/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.waiternow = (function() {

    /**
     * Namespace waiternow.
     * @exports waiternow
     * @namespace
     */
    var waiternow = {};

    waiternow.common = (function() {

        /**
         * Namespace common.
         * @memberof waiternow
         * @namespace
         */
        var common = {};

        common.GetSystemConfigurationActionProto = (function() {

            /**
             * Properties of a GetSystemConfigurationActionProto.
             * @memberof waiternow.common
             * @interface IGetSystemConfigurationActionProto
             */

            /**
             * Constructs a new GetSystemConfigurationActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a GetSystemConfigurationActionProto.
             * @implements IGetSystemConfigurationActionProto
             * @constructor
             * @param {waiternow.common.IGetSystemConfigurationActionProto=} [properties] Properties to set
             */
            function GetSystemConfigurationActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new GetSystemConfigurationActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.GetSystemConfigurationActionProto
             * @static
             * @param {waiternow.common.IGetSystemConfigurationActionProto=} [properties] Properties to set
             * @returns {waiternow.common.GetSystemConfigurationActionProto} GetSystemConfigurationActionProto instance
             */
            GetSystemConfigurationActionProto.create = function create(properties) {
                return new GetSystemConfigurationActionProto(properties);
            };

            /**
             * Encodes the specified GetSystemConfigurationActionProto message. Does not implicitly {@link waiternow.common.GetSystemConfigurationActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.GetSystemConfigurationActionProto
             * @static
             * @param {waiternow.common.IGetSystemConfigurationActionProto} message GetSystemConfigurationActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetSystemConfigurationActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified GetSystemConfigurationActionProto message, length delimited. Does not implicitly {@link waiternow.common.GetSystemConfigurationActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.GetSystemConfigurationActionProto
             * @static
             * @param {waiternow.common.IGetSystemConfigurationActionProto} message GetSystemConfigurationActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetSystemConfigurationActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetSystemConfigurationActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.GetSystemConfigurationActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.GetSystemConfigurationActionProto} GetSystemConfigurationActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetSystemConfigurationActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetSystemConfigurationActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetSystemConfigurationActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.GetSystemConfigurationActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.GetSystemConfigurationActionProto} GetSystemConfigurationActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetSystemConfigurationActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetSystemConfigurationActionProto message.
             * @function verify
             * @memberof waiternow.common.GetSystemConfigurationActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetSystemConfigurationActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a GetSystemConfigurationActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.GetSystemConfigurationActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.GetSystemConfigurationActionProto} GetSystemConfigurationActionProto
             */
            GetSystemConfigurationActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.GetSystemConfigurationActionProto)
                    return object;
                return new $root.waiternow.common.GetSystemConfigurationActionProto();
            };

            /**
             * Creates a plain object from a GetSystemConfigurationActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.GetSystemConfigurationActionProto
             * @static
             * @param {waiternow.common.GetSystemConfigurationActionProto} message GetSystemConfigurationActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetSystemConfigurationActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this GetSystemConfigurationActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.GetSystemConfigurationActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetSystemConfigurationActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for GetSystemConfigurationActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.GetSystemConfigurationActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            GetSystemConfigurationActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.GetSystemConfigurationActionProto";
            };

            GetSystemConfigurationActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.GetSystemConfigurationActionProto
                 * @interface IRequest
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.GetSystemConfigurationActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.GetSystemConfigurationActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetSystemConfigurationActionProto.Request
                 * @static
                 * @param {waiternow.common.GetSystemConfigurationActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.GetSystemConfigurationActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.GetSystemConfigurationActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetSystemConfigurationActionProto.Request
                 * @static
                 * @param {waiternow.common.GetSystemConfigurationActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.GetSystemConfigurationActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetSystemConfigurationActionProto.Request
                 * @static
                 * @param {waiternow.common.GetSystemConfigurationActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetSystemConfigurationActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetSystemConfigurationActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetSystemConfigurationActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetSystemConfigurationActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetSystemConfigurationActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.GetSystemConfigurationActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetSystemConfigurationActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetSystemConfigurationActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetSystemConfigurationActionProto.Request)
                        return object;
                    return new $root.waiternow.common.GetSystemConfigurationActionProto.Request();
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetSystemConfigurationActionProto.Request
                 * @static
                 * @param {waiternow.common.GetSystemConfigurationActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject() {
                    return {};
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetSystemConfigurationActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetSystemConfigurationActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetSystemConfigurationActionProto.Request";
                };

                return Request;
            })();

            GetSystemConfigurationActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.GetSystemConfigurationActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.ISystemConfigProto|null} [systemConfiguration] Response systemConfiguration
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.GetSystemConfigurationActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.GetSystemConfigurationActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.GetSystemConfigurationActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response systemConfiguration.
                 * @member {waiternow.common.ISystemConfigProto|null|undefined} systemConfiguration
                 * @memberof waiternow.common.GetSystemConfigurationActionProto.Response
                 * @instance
                 */
                Response.prototype.systemConfiguration = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetSystemConfigurationActionProto.Response
                 * @static
                 * @param {waiternow.common.GetSystemConfigurationActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.GetSystemConfigurationActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.GetSystemConfigurationActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetSystemConfigurationActionProto.Response
                 * @static
                 * @param {waiternow.common.GetSystemConfigurationActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.systemConfiguration != null && Object.hasOwnProperty.call(message, "systemConfiguration"))
                        $root.waiternow.common.SystemConfigProto.encode(message.systemConfiguration, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.GetSystemConfigurationActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetSystemConfigurationActionProto.Response
                 * @static
                 * @param {waiternow.common.GetSystemConfigurationActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetSystemConfigurationActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetSystemConfigurationActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetSystemConfigurationActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.systemConfiguration = $root.waiternow.common.SystemConfigProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetSystemConfigurationActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetSystemConfigurationActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.GetSystemConfigurationActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.systemConfiguration != null && message.hasOwnProperty("systemConfiguration")) {
                        var error = $root.waiternow.common.SystemConfigProto.verify(message.systemConfiguration);
                        if (error)
                            return "systemConfiguration." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetSystemConfigurationActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetSystemConfigurationActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetSystemConfigurationActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.GetSystemConfigurationActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.GetSystemConfigurationActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.systemConfiguration != null) {
                        if (typeof object.systemConfiguration !== "object")
                            throw TypeError(".waiternow.common.GetSystemConfigurationActionProto.Response.systemConfiguration: object expected");
                        message.systemConfiguration = $root.waiternow.common.SystemConfigProto.fromObject(object.systemConfiguration);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetSystemConfigurationActionProto.Response
                 * @static
                 * @param {waiternow.common.GetSystemConfigurationActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.systemConfiguration = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.systemConfiguration != null && message.hasOwnProperty("systemConfiguration"))
                        object.systemConfiguration = $root.waiternow.common.SystemConfigProto.toObject(message.systemConfiguration, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetSystemConfigurationActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetSystemConfigurationActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetSystemConfigurationActionProto.Response";
                };

                return Response;
            })();

            return GetSystemConfigurationActionProto;
        })();

        common.BackfillActionProto = (function() {

            /**
             * Properties of a BackfillActionProto.
             * @memberof waiternow.common
             * @interface IBackfillActionProto
             */

            /**
             * Constructs a new BackfillActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a BackfillActionProto.
             * @implements IBackfillActionProto
             * @constructor
             * @param {waiternow.common.IBackfillActionProto=} [properties] Properties to set
             */
            function BackfillActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new BackfillActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.BackfillActionProto
             * @static
             * @param {waiternow.common.IBackfillActionProto=} [properties] Properties to set
             * @returns {waiternow.common.BackfillActionProto} BackfillActionProto instance
             */
            BackfillActionProto.create = function create(properties) {
                return new BackfillActionProto(properties);
            };

            /**
             * Encodes the specified BackfillActionProto message. Does not implicitly {@link waiternow.common.BackfillActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.BackfillActionProto
             * @static
             * @param {waiternow.common.IBackfillActionProto} message BackfillActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BackfillActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified BackfillActionProto message, length delimited. Does not implicitly {@link waiternow.common.BackfillActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.BackfillActionProto
             * @static
             * @param {waiternow.common.IBackfillActionProto} message BackfillActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BackfillActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a BackfillActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.BackfillActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.BackfillActionProto} BackfillActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BackfillActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.BackfillActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a BackfillActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.BackfillActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.BackfillActionProto} BackfillActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BackfillActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a BackfillActionProto message.
             * @function verify
             * @memberof waiternow.common.BackfillActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            BackfillActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a BackfillActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.BackfillActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.BackfillActionProto} BackfillActionProto
             */
            BackfillActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.BackfillActionProto)
                    return object;
                return new $root.waiternow.common.BackfillActionProto();
            };

            /**
             * Creates a plain object from a BackfillActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.BackfillActionProto
             * @static
             * @param {waiternow.common.BackfillActionProto} message BackfillActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            BackfillActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this BackfillActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.BackfillActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            BackfillActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for BackfillActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.BackfillActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            BackfillActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.BackfillActionProto";
            };

            BackfillActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.BackfillActionProto
                 * @interface IRequest
                 * @property {boolean|null} [backfillBusinesses] Request backfillBusinesses
                 * @property {boolean|null} [backfillCache] Request backfillCache
                 * @property {boolean|null} [backfillCampaigns] Request backfillCampaigns
                 * @property {boolean|null} [backfillCheckIns] Request backfillCheckIns
                 * @property {boolean|null} [backfillDeliveries] Request backfillDeliveries
                 * @property {boolean|null} [backfillDevices] Request backfillDevices
                 * @property {boolean|null} [backfillClientFeedback] Request backfillClientFeedback
                 * @property {boolean|null} [backfillLocations] Request backfillLocations
                 * @property {boolean|null} [backfillLocationBusinessHours] Request backfillLocationBusinessHours
                 * @property {boolean|null} [backfillLocationMetrics] Request backfillLocationMetrics
                 * @property {boolean|null} [backfillMetrics] Request backfillMetrics
                 * @property {boolean|null} [backfillOrders] Request backfillOrders
                 * @property {boolean|null} [backfillPointsOfService] Request backfillPointsOfService
                 * @property {boolean|null} [backfillResources] Request backfillResources
                 * @property {boolean|null} [backfillReviews] Request backfillReviews
                 * @property {boolean|null} [backfillUserRoles] Request backfillUserRoles
                 * @property {boolean|null} [backfillUsers] Request backfillUsers
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.BackfillActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.BackfillActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request backfillBusinesses.
                 * @member {boolean} backfillBusinesses
                 * @memberof waiternow.common.BackfillActionProto.Request
                 * @instance
                 */
                Request.prototype.backfillBusinesses = false;

                /**
                 * Request backfillCache.
                 * @member {boolean} backfillCache
                 * @memberof waiternow.common.BackfillActionProto.Request
                 * @instance
                 */
                Request.prototype.backfillCache = false;

                /**
                 * Request backfillCampaigns.
                 * @member {boolean} backfillCampaigns
                 * @memberof waiternow.common.BackfillActionProto.Request
                 * @instance
                 */
                Request.prototype.backfillCampaigns = false;

                /**
                 * Request backfillCheckIns.
                 * @member {boolean} backfillCheckIns
                 * @memberof waiternow.common.BackfillActionProto.Request
                 * @instance
                 */
                Request.prototype.backfillCheckIns = false;

                /**
                 * Request backfillDeliveries.
                 * @member {boolean} backfillDeliveries
                 * @memberof waiternow.common.BackfillActionProto.Request
                 * @instance
                 */
                Request.prototype.backfillDeliveries = false;

                /**
                 * Request backfillDevices.
                 * @member {boolean} backfillDevices
                 * @memberof waiternow.common.BackfillActionProto.Request
                 * @instance
                 */
                Request.prototype.backfillDevices = false;

                /**
                 * Request backfillClientFeedback.
                 * @member {boolean} backfillClientFeedback
                 * @memberof waiternow.common.BackfillActionProto.Request
                 * @instance
                 */
                Request.prototype.backfillClientFeedback = false;

                /**
                 * Request backfillLocations.
                 * @member {boolean} backfillLocations
                 * @memberof waiternow.common.BackfillActionProto.Request
                 * @instance
                 */
                Request.prototype.backfillLocations = false;

                /**
                 * Request backfillLocationBusinessHours.
                 * @member {boolean} backfillLocationBusinessHours
                 * @memberof waiternow.common.BackfillActionProto.Request
                 * @instance
                 */
                Request.prototype.backfillLocationBusinessHours = false;

                /**
                 * Request backfillLocationMetrics.
                 * @member {boolean} backfillLocationMetrics
                 * @memberof waiternow.common.BackfillActionProto.Request
                 * @instance
                 */
                Request.prototype.backfillLocationMetrics = false;

                /**
                 * Request backfillMetrics.
                 * @member {boolean} backfillMetrics
                 * @memberof waiternow.common.BackfillActionProto.Request
                 * @instance
                 */
                Request.prototype.backfillMetrics = false;

                /**
                 * Request backfillOrders.
                 * @member {boolean} backfillOrders
                 * @memberof waiternow.common.BackfillActionProto.Request
                 * @instance
                 */
                Request.prototype.backfillOrders = false;

                /**
                 * Request backfillPointsOfService.
                 * @member {boolean} backfillPointsOfService
                 * @memberof waiternow.common.BackfillActionProto.Request
                 * @instance
                 */
                Request.prototype.backfillPointsOfService = false;

                /**
                 * Request backfillResources.
                 * @member {boolean} backfillResources
                 * @memberof waiternow.common.BackfillActionProto.Request
                 * @instance
                 */
                Request.prototype.backfillResources = false;

                /**
                 * Request backfillReviews.
                 * @member {boolean} backfillReviews
                 * @memberof waiternow.common.BackfillActionProto.Request
                 * @instance
                 */
                Request.prototype.backfillReviews = false;

                /**
                 * Request backfillUserRoles.
                 * @member {boolean} backfillUserRoles
                 * @memberof waiternow.common.BackfillActionProto.Request
                 * @instance
                 */
                Request.prototype.backfillUserRoles = false;

                /**
                 * Request backfillUsers.
                 * @member {boolean} backfillUsers
                 * @memberof waiternow.common.BackfillActionProto.Request
                 * @instance
                 */
                Request.prototype.backfillUsers = false;

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.BackfillActionProto.Request
                 * @static
                 * @param {waiternow.common.BackfillActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.BackfillActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.BackfillActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.BackfillActionProto.Request
                 * @static
                 * @param {waiternow.common.BackfillActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.backfillBusinesses != null && Object.hasOwnProperty.call(message, "backfillBusinesses"))
                        writer.uint32(/* id 1, wireType 0 =*/8).bool(message.backfillBusinesses);
                    if (message.backfillCache != null && Object.hasOwnProperty.call(message, "backfillCache"))
                        writer.uint32(/* id 2, wireType 0 =*/16).bool(message.backfillCache);
                    if (message.backfillCampaigns != null && Object.hasOwnProperty.call(message, "backfillCampaigns"))
                        writer.uint32(/* id 3, wireType 0 =*/24).bool(message.backfillCampaigns);
                    if (message.backfillCheckIns != null && Object.hasOwnProperty.call(message, "backfillCheckIns"))
                        writer.uint32(/* id 4, wireType 0 =*/32).bool(message.backfillCheckIns);
                    if (message.backfillDeliveries != null && Object.hasOwnProperty.call(message, "backfillDeliveries"))
                        writer.uint32(/* id 5, wireType 0 =*/40).bool(message.backfillDeliveries);
                    if (message.backfillDevices != null && Object.hasOwnProperty.call(message, "backfillDevices"))
                        writer.uint32(/* id 6, wireType 0 =*/48).bool(message.backfillDevices);
                    if (message.backfillClientFeedback != null && Object.hasOwnProperty.call(message, "backfillClientFeedback"))
                        writer.uint32(/* id 7, wireType 0 =*/56).bool(message.backfillClientFeedback);
                    if (message.backfillLocations != null && Object.hasOwnProperty.call(message, "backfillLocations"))
                        writer.uint32(/* id 8, wireType 0 =*/64).bool(message.backfillLocations);
                    if (message.backfillLocationBusinessHours != null && Object.hasOwnProperty.call(message, "backfillLocationBusinessHours"))
                        writer.uint32(/* id 9, wireType 0 =*/72).bool(message.backfillLocationBusinessHours);
                    if (message.backfillLocationMetrics != null && Object.hasOwnProperty.call(message, "backfillLocationMetrics"))
                        writer.uint32(/* id 10, wireType 0 =*/80).bool(message.backfillLocationMetrics);
                    if (message.backfillMetrics != null && Object.hasOwnProperty.call(message, "backfillMetrics"))
                        writer.uint32(/* id 11, wireType 0 =*/88).bool(message.backfillMetrics);
                    if (message.backfillOrders != null && Object.hasOwnProperty.call(message, "backfillOrders"))
                        writer.uint32(/* id 12, wireType 0 =*/96).bool(message.backfillOrders);
                    if (message.backfillPointsOfService != null && Object.hasOwnProperty.call(message, "backfillPointsOfService"))
                        writer.uint32(/* id 13, wireType 0 =*/104).bool(message.backfillPointsOfService);
                    if (message.backfillResources != null && Object.hasOwnProperty.call(message, "backfillResources"))
                        writer.uint32(/* id 14, wireType 0 =*/112).bool(message.backfillResources);
                    if (message.backfillReviews != null && Object.hasOwnProperty.call(message, "backfillReviews"))
                        writer.uint32(/* id 15, wireType 0 =*/120).bool(message.backfillReviews);
                    if (message.backfillUserRoles != null && Object.hasOwnProperty.call(message, "backfillUserRoles"))
                        writer.uint32(/* id 16, wireType 0 =*/128).bool(message.backfillUserRoles);
                    if (message.backfillUsers != null && Object.hasOwnProperty.call(message, "backfillUsers"))
                        writer.uint32(/* id 17, wireType 0 =*/136).bool(message.backfillUsers);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.BackfillActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.BackfillActionProto.Request
                 * @static
                 * @param {waiternow.common.BackfillActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.BackfillActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.BackfillActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.BackfillActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.backfillBusinesses = reader.bool();
                                break;
                            }
                        case 2: {
                                message.backfillCache = reader.bool();
                                break;
                            }
                        case 3: {
                                message.backfillCampaigns = reader.bool();
                                break;
                            }
                        case 4: {
                                message.backfillCheckIns = reader.bool();
                                break;
                            }
                        case 5: {
                                message.backfillDeliveries = reader.bool();
                                break;
                            }
                        case 6: {
                                message.backfillDevices = reader.bool();
                                break;
                            }
                        case 7: {
                                message.backfillClientFeedback = reader.bool();
                                break;
                            }
                        case 8: {
                                message.backfillLocations = reader.bool();
                                break;
                            }
                        case 9: {
                                message.backfillLocationBusinessHours = reader.bool();
                                break;
                            }
                        case 10: {
                                message.backfillLocationMetrics = reader.bool();
                                break;
                            }
                        case 11: {
                                message.backfillMetrics = reader.bool();
                                break;
                            }
                        case 12: {
                                message.backfillOrders = reader.bool();
                                break;
                            }
                        case 13: {
                                message.backfillPointsOfService = reader.bool();
                                break;
                            }
                        case 14: {
                                message.backfillResources = reader.bool();
                                break;
                            }
                        case 15: {
                                message.backfillReviews = reader.bool();
                                break;
                            }
                        case 16: {
                                message.backfillUserRoles = reader.bool();
                                break;
                            }
                        case 17: {
                                message.backfillUsers = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.BackfillActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.BackfillActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.BackfillActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.backfillBusinesses != null && message.hasOwnProperty("backfillBusinesses"))
                        if (typeof message.backfillBusinesses !== "boolean")
                            return "backfillBusinesses: boolean expected";
                    if (message.backfillCache != null && message.hasOwnProperty("backfillCache"))
                        if (typeof message.backfillCache !== "boolean")
                            return "backfillCache: boolean expected";
                    if (message.backfillCampaigns != null && message.hasOwnProperty("backfillCampaigns"))
                        if (typeof message.backfillCampaigns !== "boolean")
                            return "backfillCampaigns: boolean expected";
                    if (message.backfillCheckIns != null && message.hasOwnProperty("backfillCheckIns"))
                        if (typeof message.backfillCheckIns !== "boolean")
                            return "backfillCheckIns: boolean expected";
                    if (message.backfillDeliveries != null && message.hasOwnProperty("backfillDeliveries"))
                        if (typeof message.backfillDeliveries !== "boolean")
                            return "backfillDeliveries: boolean expected";
                    if (message.backfillDevices != null && message.hasOwnProperty("backfillDevices"))
                        if (typeof message.backfillDevices !== "boolean")
                            return "backfillDevices: boolean expected";
                    if (message.backfillClientFeedback != null && message.hasOwnProperty("backfillClientFeedback"))
                        if (typeof message.backfillClientFeedback !== "boolean")
                            return "backfillClientFeedback: boolean expected";
                    if (message.backfillLocations != null && message.hasOwnProperty("backfillLocations"))
                        if (typeof message.backfillLocations !== "boolean")
                            return "backfillLocations: boolean expected";
                    if (message.backfillLocationBusinessHours != null && message.hasOwnProperty("backfillLocationBusinessHours"))
                        if (typeof message.backfillLocationBusinessHours !== "boolean")
                            return "backfillLocationBusinessHours: boolean expected";
                    if (message.backfillLocationMetrics != null && message.hasOwnProperty("backfillLocationMetrics"))
                        if (typeof message.backfillLocationMetrics !== "boolean")
                            return "backfillLocationMetrics: boolean expected";
                    if (message.backfillMetrics != null && message.hasOwnProperty("backfillMetrics"))
                        if (typeof message.backfillMetrics !== "boolean")
                            return "backfillMetrics: boolean expected";
                    if (message.backfillOrders != null && message.hasOwnProperty("backfillOrders"))
                        if (typeof message.backfillOrders !== "boolean")
                            return "backfillOrders: boolean expected";
                    if (message.backfillPointsOfService != null && message.hasOwnProperty("backfillPointsOfService"))
                        if (typeof message.backfillPointsOfService !== "boolean")
                            return "backfillPointsOfService: boolean expected";
                    if (message.backfillResources != null && message.hasOwnProperty("backfillResources"))
                        if (typeof message.backfillResources !== "boolean")
                            return "backfillResources: boolean expected";
                    if (message.backfillReviews != null && message.hasOwnProperty("backfillReviews"))
                        if (typeof message.backfillReviews !== "boolean")
                            return "backfillReviews: boolean expected";
                    if (message.backfillUserRoles != null && message.hasOwnProperty("backfillUserRoles"))
                        if (typeof message.backfillUserRoles !== "boolean")
                            return "backfillUserRoles: boolean expected";
                    if (message.backfillUsers != null && message.hasOwnProperty("backfillUsers"))
                        if (typeof message.backfillUsers !== "boolean")
                            return "backfillUsers: boolean expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.BackfillActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.BackfillActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.BackfillActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.BackfillActionProto.Request();
                    if (object.backfillBusinesses != null)
                        message.backfillBusinesses = Boolean(object.backfillBusinesses);
                    if (object.backfillCache != null)
                        message.backfillCache = Boolean(object.backfillCache);
                    if (object.backfillCampaigns != null)
                        message.backfillCampaigns = Boolean(object.backfillCampaigns);
                    if (object.backfillCheckIns != null)
                        message.backfillCheckIns = Boolean(object.backfillCheckIns);
                    if (object.backfillDeliveries != null)
                        message.backfillDeliveries = Boolean(object.backfillDeliveries);
                    if (object.backfillDevices != null)
                        message.backfillDevices = Boolean(object.backfillDevices);
                    if (object.backfillClientFeedback != null)
                        message.backfillClientFeedback = Boolean(object.backfillClientFeedback);
                    if (object.backfillLocations != null)
                        message.backfillLocations = Boolean(object.backfillLocations);
                    if (object.backfillLocationBusinessHours != null)
                        message.backfillLocationBusinessHours = Boolean(object.backfillLocationBusinessHours);
                    if (object.backfillLocationMetrics != null)
                        message.backfillLocationMetrics = Boolean(object.backfillLocationMetrics);
                    if (object.backfillMetrics != null)
                        message.backfillMetrics = Boolean(object.backfillMetrics);
                    if (object.backfillOrders != null)
                        message.backfillOrders = Boolean(object.backfillOrders);
                    if (object.backfillPointsOfService != null)
                        message.backfillPointsOfService = Boolean(object.backfillPointsOfService);
                    if (object.backfillResources != null)
                        message.backfillResources = Boolean(object.backfillResources);
                    if (object.backfillReviews != null)
                        message.backfillReviews = Boolean(object.backfillReviews);
                    if (object.backfillUserRoles != null)
                        message.backfillUserRoles = Boolean(object.backfillUserRoles);
                    if (object.backfillUsers != null)
                        message.backfillUsers = Boolean(object.backfillUsers);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.BackfillActionProto.Request
                 * @static
                 * @param {waiternow.common.BackfillActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.backfillBusinesses = false;
                        object.backfillCache = false;
                        object.backfillCampaigns = false;
                        object.backfillCheckIns = false;
                        object.backfillDeliveries = false;
                        object.backfillDevices = false;
                        object.backfillClientFeedback = false;
                        object.backfillLocations = false;
                        object.backfillLocationBusinessHours = false;
                        object.backfillLocationMetrics = false;
                        object.backfillMetrics = false;
                        object.backfillOrders = false;
                        object.backfillPointsOfService = false;
                        object.backfillResources = false;
                        object.backfillReviews = false;
                        object.backfillUserRoles = false;
                        object.backfillUsers = false;
                    }
                    if (message.backfillBusinesses != null && message.hasOwnProperty("backfillBusinesses"))
                        object.backfillBusinesses = message.backfillBusinesses;
                    if (message.backfillCache != null && message.hasOwnProperty("backfillCache"))
                        object.backfillCache = message.backfillCache;
                    if (message.backfillCampaigns != null && message.hasOwnProperty("backfillCampaigns"))
                        object.backfillCampaigns = message.backfillCampaigns;
                    if (message.backfillCheckIns != null && message.hasOwnProperty("backfillCheckIns"))
                        object.backfillCheckIns = message.backfillCheckIns;
                    if (message.backfillDeliveries != null && message.hasOwnProperty("backfillDeliveries"))
                        object.backfillDeliveries = message.backfillDeliveries;
                    if (message.backfillDevices != null && message.hasOwnProperty("backfillDevices"))
                        object.backfillDevices = message.backfillDevices;
                    if (message.backfillClientFeedback != null && message.hasOwnProperty("backfillClientFeedback"))
                        object.backfillClientFeedback = message.backfillClientFeedback;
                    if (message.backfillLocations != null && message.hasOwnProperty("backfillLocations"))
                        object.backfillLocations = message.backfillLocations;
                    if (message.backfillLocationBusinessHours != null && message.hasOwnProperty("backfillLocationBusinessHours"))
                        object.backfillLocationBusinessHours = message.backfillLocationBusinessHours;
                    if (message.backfillLocationMetrics != null && message.hasOwnProperty("backfillLocationMetrics"))
                        object.backfillLocationMetrics = message.backfillLocationMetrics;
                    if (message.backfillMetrics != null && message.hasOwnProperty("backfillMetrics"))
                        object.backfillMetrics = message.backfillMetrics;
                    if (message.backfillOrders != null && message.hasOwnProperty("backfillOrders"))
                        object.backfillOrders = message.backfillOrders;
                    if (message.backfillPointsOfService != null && message.hasOwnProperty("backfillPointsOfService"))
                        object.backfillPointsOfService = message.backfillPointsOfService;
                    if (message.backfillResources != null && message.hasOwnProperty("backfillResources"))
                        object.backfillResources = message.backfillResources;
                    if (message.backfillReviews != null && message.hasOwnProperty("backfillReviews"))
                        object.backfillReviews = message.backfillReviews;
                    if (message.backfillUserRoles != null && message.hasOwnProperty("backfillUserRoles"))
                        object.backfillUserRoles = message.backfillUserRoles;
                    if (message.backfillUsers != null && message.hasOwnProperty("backfillUsers"))
                        object.backfillUsers = message.backfillUsers;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.BackfillActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.BackfillActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.BackfillActionProto.Request";
                };

                return Request;
            })();

            BackfillActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.BackfillActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.BackfillActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.BackfillActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.BackfillActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.BackfillActionProto.Response
                 * @static
                 * @param {waiternow.common.BackfillActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.BackfillActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.BackfillActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.BackfillActionProto.Response
                 * @static
                 * @param {waiternow.common.BackfillActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.BackfillActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.BackfillActionProto.Response
                 * @static
                 * @param {waiternow.common.BackfillActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.BackfillActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.BackfillActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.BackfillActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.BackfillActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.BackfillActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.BackfillActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.BackfillActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.BackfillActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.BackfillActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.BackfillActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.BackfillActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.BackfillActionProto.Response
                 * @static
                 * @param {waiternow.common.BackfillActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.BackfillActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.BackfillActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.BackfillActionProto.Response";
                };

                return Response;
            })();

            return BackfillActionProto;
        })();

        common.CustomBackfillActionProto = (function() {

            /**
             * Properties of a CustomBackfillActionProto.
             * @memberof waiternow.common
             * @interface ICustomBackfillActionProto
             */

            /**
             * Constructs a new CustomBackfillActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a CustomBackfillActionProto.
             * @implements ICustomBackfillActionProto
             * @constructor
             * @param {waiternow.common.ICustomBackfillActionProto=} [properties] Properties to set
             */
            function CustomBackfillActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new CustomBackfillActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.CustomBackfillActionProto
             * @static
             * @param {waiternow.common.ICustomBackfillActionProto=} [properties] Properties to set
             * @returns {waiternow.common.CustomBackfillActionProto} CustomBackfillActionProto instance
             */
            CustomBackfillActionProto.create = function create(properties) {
                return new CustomBackfillActionProto(properties);
            };

            /**
             * Encodes the specified CustomBackfillActionProto message. Does not implicitly {@link waiternow.common.CustomBackfillActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.CustomBackfillActionProto
             * @static
             * @param {waiternow.common.ICustomBackfillActionProto} message CustomBackfillActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CustomBackfillActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified CustomBackfillActionProto message, length delimited. Does not implicitly {@link waiternow.common.CustomBackfillActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.CustomBackfillActionProto
             * @static
             * @param {waiternow.common.ICustomBackfillActionProto} message CustomBackfillActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CustomBackfillActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CustomBackfillActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.CustomBackfillActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.CustomBackfillActionProto} CustomBackfillActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CustomBackfillActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CustomBackfillActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CustomBackfillActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.CustomBackfillActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.CustomBackfillActionProto} CustomBackfillActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CustomBackfillActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CustomBackfillActionProto message.
             * @function verify
             * @memberof waiternow.common.CustomBackfillActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CustomBackfillActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a CustomBackfillActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.CustomBackfillActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.CustomBackfillActionProto} CustomBackfillActionProto
             */
            CustomBackfillActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.CustomBackfillActionProto)
                    return object;
                return new $root.waiternow.common.CustomBackfillActionProto();
            };

            /**
             * Creates a plain object from a CustomBackfillActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.CustomBackfillActionProto
             * @static
             * @param {waiternow.common.CustomBackfillActionProto} message CustomBackfillActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CustomBackfillActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this CustomBackfillActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.CustomBackfillActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CustomBackfillActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for CustomBackfillActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.CustomBackfillActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            CustomBackfillActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.CustomBackfillActionProto";
            };

            CustomBackfillActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.CustomBackfillActionProto
                 * @interface IRequest
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.CustomBackfillActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.CustomBackfillActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.CustomBackfillActionProto.Request
                 * @static
                 * @param {waiternow.common.CustomBackfillActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.CustomBackfillActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.CustomBackfillActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.CustomBackfillActionProto.Request
                 * @static
                 * @param {waiternow.common.CustomBackfillActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.CustomBackfillActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.CustomBackfillActionProto.Request
                 * @static
                 * @param {waiternow.common.CustomBackfillActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.CustomBackfillActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.CustomBackfillActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CustomBackfillActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.CustomBackfillActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.CustomBackfillActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.CustomBackfillActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.CustomBackfillActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.CustomBackfillActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.CustomBackfillActionProto.Request)
                        return object;
                    return new $root.waiternow.common.CustomBackfillActionProto.Request();
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.CustomBackfillActionProto.Request
                 * @static
                 * @param {waiternow.common.CustomBackfillActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject() {
                    return {};
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.CustomBackfillActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.CustomBackfillActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.CustomBackfillActionProto.Request";
                };

                return Request;
            })();

            CustomBackfillActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.CustomBackfillActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.CustomBackfillActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.CustomBackfillActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.CustomBackfillActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.CustomBackfillActionProto.Response
                 * @static
                 * @param {waiternow.common.CustomBackfillActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.CustomBackfillActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.CustomBackfillActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.CustomBackfillActionProto.Response
                 * @static
                 * @param {waiternow.common.CustomBackfillActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.CustomBackfillActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.CustomBackfillActionProto.Response
                 * @static
                 * @param {waiternow.common.CustomBackfillActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.CustomBackfillActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.CustomBackfillActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CustomBackfillActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.CustomBackfillActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.CustomBackfillActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.CustomBackfillActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.CustomBackfillActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.CustomBackfillActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.CustomBackfillActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.CustomBackfillActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.CustomBackfillActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.CustomBackfillActionProto.Response
                 * @static
                 * @param {waiternow.common.CustomBackfillActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.CustomBackfillActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.CustomBackfillActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.CustomBackfillActionProto.Response";
                };

                return Response;
            })();

            return CustomBackfillActionProto;
        })();

        common.EncryptActionProto = (function() {

            /**
             * Properties of an EncryptActionProto.
             * @memberof waiternow.common
             * @interface IEncryptActionProto
             */

            /**
             * Constructs a new EncryptActionProto.
             * @memberof waiternow.common
             * @classdesc Represents an EncryptActionProto.
             * @implements IEncryptActionProto
             * @constructor
             * @param {waiternow.common.IEncryptActionProto=} [properties] Properties to set
             */
            function EncryptActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new EncryptActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.EncryptActionProto
             * @static
             * @param {waiternow.common.IEncryptActionProto=} [properties] Properties to set
             * @returns {waiternow.common.EncryptActionProto} EncryptActionProto instance
             */
            EncryptActionProto.create = function create(properties) {
                return new EncryptActionProto(properties);
            };

            /**
             * Encodes the specified EncryptActionProto message. Does not implicitly {@link waiternow.common.EncryptActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.EncryptActionProto
             * @static
             * @param {waiternow.common.IEncryptActionProto} message EncryptActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EncryptActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified EncryptActionProto message, length delimited. Does not implicitly {@link waiternow.common.EncryptActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.EncryptActionProto
             * @static
             * @param {waiternow.common.IEncryptActionProto} message EncryptActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EncryptActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an EncryptActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.EncryptActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.EncryptActionProto} EncryptActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EncryptActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.EncryptActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an EncryptActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.EncryptActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.EncryptActionProto} EncryptActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EncryptActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an EncryptActionProto message.
             * @function verify
             * @memberof waiternow.common.EncryptActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            EncryptActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates an EncryptActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.EncryptActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.EncryptActionProto} EncryptActionProto
             */
            EncryptActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.EncryptActionProto)
                    return object;
                return new $root.waiternow.common.EncryptActionProto();
            };

            /**
             * Creates a plain object from an EncryptActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.EncryptActionProto
             * @static
             * @param {waiternow.common.EncryptActionProto} message EncryptActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            EncryptActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this EncryptActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.EncryptActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            EncryptActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for EncryptActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.EncryptActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            EncryptActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.EncryptActionProto";
            };

            EncryptActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.EncryptActionProto
                 * @interface IRequest
                 * @property {string|null} [data] Request data
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.EncryptActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.EncryptActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request data.
                 * @member {string} data
                 * @memberof waiternow.common.EncryptActionProto.Request
                 * @instance
                 */
                Request.prototype.data = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.EncryptActionProto.Request
                 * @static
                 * @param {waiternow.common.EncryptActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.EncryptActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.EncryptActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.EncryptActionProto.Request
                 * @static
                 * @param {waiternow.common.EncryptActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.data);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.EncryptActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.EncryptActionProto.Request
                 * @static
                 * @param {waiternow.common.EncryptActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.EncryptActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.EncryptActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.EncryptActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.data = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.EncryptActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.EncryptActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.EncryptActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.data != null && message.hasOwnProperty("data"))
                        if (!$util.isString(message.data))
                            return "data: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.EncryptActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.EncryptActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.EncryptActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.EncryptActionProto.Request();
                    if (object.data != null)
                        message.data = String(object.data);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.EncryptActionProto.Request
                 * @static
                 * @param {waiternow.common.EncryptActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.data = "";
                    if (message.data != null && message.hasOwnProperty("data"))
                        object.data = message.data;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.EncryptActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.EncryptActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.EncryptActionProto.Request";
                };

                return Request;
            })();

            EncryptActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.EncryptActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {string|null} [encryptedData] Response encryptedData
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.EncryptActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.EncryptActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.EncryptActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response encryptedData.
                 * @member {string} encryptedData
                 * @memberof waiternow.common.EncryptActionProto.Response
                 * @instance
                 */
                Response.prototype.encryptedData = "";

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.EncryptActionProto.Response
                 * @static
                 * @param {waiternow.common.EncryptActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.EncryptActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.EncryptActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.EncryptActionProto.Response
                 * @static
                 * @param {waiternow.common.EncryptActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.encryptedData != null && Object.hasOwnProperty.call(message, "encryptedData"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.encryptedData);
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.EncryptActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.EncryptActionProto.Response
                 * @static
                 * @param {waiternow.common.EncryptActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.EncryptActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.EncryptActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.EncryptActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.encryptedData = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.EncryptActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.EncryptActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.EncryptActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.encryptedData != null && message.hasOwnProperty("encryptedData"))
                        if (!$util.isString(message.encryptedData))
                            return "encryptedData: string expected";
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.EncryptActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.EncryptActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.EncryptActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.EncryptActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.EncryptActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.encryptedData != null)
                        message.encryptedData = String(object.encryptedData);
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.EncryptActionProto.Response
                 * @static
                 * @param {waiternow.common.EncryptActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.encryptedData = "";
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.encryptedData != null && message.hasOwnProperty("encryptedData"))
                        object.encryptedData = message.encryptedData;
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.EncryptActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.EncryptActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.EncryptActionProto.Response";
                };

                return Response;
            })();

            return EncryptActionProto;
        })();

        common.DecryptActionProto = (function() {

            /**
             * Properties of a DecryptActionProto.
             * @memberof waiternow.common
             * @interface IDecryptActionProto
             */

            /**
             * Constructs a new DecryptActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a DecryptActionProto.
             * @implements IDecryptActionProto
             * @constructor
             * @param {waiternow.common.IDecryptActionProto=} [properties] Properties to set
             */
            function DecryptActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new DecryptActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.DecryptActionProto
             * @static
             * @param {waiternow.common.IDecryptActionProto=} [properties] Properties to set
             * @returns {waiternow.common.DecryptActionProto} DecryptActionProto instance
             */
            DecryptActionProto.create = function create(properties) {
                return new DecryptActionProto(properties);
            };

            /**
             * Encodes the specified DecryptActionProto message. Does not implicitly {@link waiternow.common.DecryptActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.DecryptActionProto
             * @static
             * @param {waiternow.common.IDecryptActionProto} message DecryptActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DecryptActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified DecryptActionProto message, length delimited. Does not implicitly {@link waiternow.common.DecryptActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.DecryptActionProto
             * @static
             * @param {waiternow.common.IDecryptActionProto} message DecryptActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DecryptActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a DecryptActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.DecryptActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.DecryptActionProto} DecryptActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DecryptActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.DecryptActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a DecryptActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.DecryptActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.DecryptActionProto} DecryptActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DecryptActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a DecryptActionProto message.
             * @function verify
             * @memberof waiternow.common.DecryptActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            DecryptActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a DecryptActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.DecryptActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.DecryptActionProto} DecryptActionProto
             */
            DecryptActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.DecryptActionProto)
                    return object;
                return new $root.waiternow.common.DecryptActionProto();
            };

            /**
             * Creates a plain object from a DecryptActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.DecryptActionProto
             * @static
             * @param {waiternow.common.DecryptActionProto} message DecryptActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            DecryptActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this DecryptActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.DecryptActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            DecryptActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for DecryptActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.DecryptActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            DecryptActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.DecryptActionProto";
            };

            DecryptActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.DecryptActionProto
                 * @interface IRequest
                 * @property {string|null} [encryptedData] Request encryptedData
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.DecryptActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.DecryptActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request encryptedData.
                 * @member {string} encryptedData
                 * @memberof waiternow.common.DecryptActionProto.Request
                 * @instance
                 */
                Request.prototype.encryptedData = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.DecryptActionProto.Request
                 * @static
                 * @param {waiternow.common.DecryptActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.DecryptActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.DecryptActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.DecryptActionProto.Request
                 * @static
                 * @param {waiternow.common.DecryptActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.encryptedData != null && Object.hasOwnProperty.call(message, "encryptedData"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.encryptedData);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.DecryptActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.DecryptActionProto.Request
                 * @static
                 * @param {waiternow.common.DecryptActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.DecryptActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.DecryptActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.DecryptActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.encryptedData = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.DecryptActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.DecryptActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.DecryptActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.encryptedData != null && message.hasOwnProperty("encryptedData"))
                        if (!$util.isString(message.encryptedData))
                            return "encryptedData: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.DecryptActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.DecryptActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.DecryptActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.DecryptActionProto.Request();
                    if (object.encryptedData != null)
                        message.encryptedData = String(object.encryptedData);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.DecryptActionProto.Request
                 * @static
                 * @param {waiternow.common.DecryptActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.encryptedData = "";
                    if (message.encryptedData != null && message.hasOwnProperty("encryptedData"))
                        object.encryptedData = message.encryptedData;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.DecryptActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.DecryptActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.DecryptActionProto.Request";
                };

                return Request;
            })();

            DecryptActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.DecryptActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {string|null} [data] Response data
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.DecryptActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.DecryptActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.DecryptActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response data.
                 * @member {string} data
                 * @memberof waiternow.common.DecryptActionProto.Response
                 * @instance
                 */
                Response.prototype.data = "";

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.DecryptActionProto.Response
                 * @static
                 * @param {waiternow.common.DecryptActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.DecryptActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.DecryptActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.DecryptActionProto.Response
                 * @static
                 * @param {waiternow.common.DecryptActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.data);
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.DecryptActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.DecryptActionProto.Response
                 * @static
                 * @param {waiternow.common.DecryptActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.DecryptActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.DecryptActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.DecryptActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.data = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.DecryptActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.DecryptActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.DecryptActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.data != null && message.hasOwnProperty("data"))
                        if (!$util.isString(message.data))
                            return "data: string expected";
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.DecryptActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.DecryptActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.DecryptActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.DecryptActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.DecryptActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.data != null)
                        message.data = String(object.data);
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.DecryptActionProto.Response
                 * @static
                 * @param {waiternow.common.DecryptActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.data = "";
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.data != null && message.hasOwnProperty("data"))
                        object.data = message.data;
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.DecryptActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.DecryptActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.DecryptActionProto.Response";
                };

                return Response;
            })();

            return DecryptActionProto;
        })();

        common.SuperuserUpdateActionProto = (function() {

            /**
             * Properties of a SuperuserUpdateActionProto.
             * @memberof waiternow.common
             * @interface ISuperuserUpdateActionProto
             */

            /**
             * Constructs a new SuperuserUpdateActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a SuperuserUpdateActionProto.
             * @implements ISuperuserUpdateActionProto
             * @constructor
             * @param {waiternow.common.ISuperuserUpdateActionProto=} [properties] Properties to set
             */
            function SuperuserUpdateActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new SuperuserUpdateActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.SuperuserUpdateActionProto
             * @static
             * @param {waiternow.common.ISuperuserUpdateActionProto=} [properties] Properties to set
             * @returns {waiternow.common.SuperuserUpdateActionProto} SuperuserUpdateActionProto instance
             */
            SuperuserUpdateActionProto.create = function create(properties) {
                return new SuperuserUpdateActionProto(properties);
            };

            /**
             * Encodes the specified SuperuserUpdateActionProto message. Does not implicitly {@link waiternow.common.SuperuserUpdateActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.SuperuserUpdateActionProto
             * @static
             * @param {waiternow.common.ISuperuserUpdateActionProto} message SuperuserUpdateActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SuperuserUpdateActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified SuperuserUpdateActionProto message, length delimited. Does not implicitly {@link waiternow.common.SuperuserUpdateActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.SuperuserUpdateActionProto
             * @static
             * @param {waiternow.common.ISuperuserUpdateActionProto} message SuperuserUpdateActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SuperuserUpdateActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SuperuserUpdateActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.SuperuserUpdateActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.SuperuserUpdateActionProto} SuperuserUpdateActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SuperuserUpdateActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.SuperuserUpdateActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SuperuserUpdateActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.SuperuserUpdateActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.SuperuserUpdateActionProto} SuperuserUpdateActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SuperuserUpdateActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SuperuserUpdateActionProto message.
             * @function verify
             * @memberof waiternow.common.SuperuserUpdateActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SuperuserUpdateActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a SuperuserUpdateActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.SuperuserUpdateActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.SuperuserUpdateActionProto} SuperuserUpdateActionProto
             */
            SuperuserUpdateActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.SuperuserUpdateActionProto)
                    return object;
                return new $root.waiternow.common.SuperuserUpdateActionProto();
            };

            /**
             * Creates a plain object from a SuperuserUpdateActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.SuperuserUpdateActionProto
             * @static
             * @param {waiternow.common.SuperuserUpdateActionProto} message SuperuserUpdateActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SuperuserUpdateActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this SuperuserUpdateActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.SuperuserUpdateActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SuperuserUpdateActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for SuperuserUpdateActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.SuperuserUpdateActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            SuperuserUpdateActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.SuperuserUpdateActionProto";
            };

            SuperuserUpdateActionProto.UserUpdateProto = (function() {

                /**
                 * Properties of a UserUpdateProto.
                 * @memberof waiternow.common.SuperuserUpdateActionProto
                 * @interface IUserUpdateProto
                 * @property {string|null} [userId] UserUpdateProto userId
                 * @property {string|null} [newEmail] UserUpdateProto newEmail
                 * @property {string|null} [newPassword] UserUpdateProto newPassword
                 */

                /**
                 * Constructs a new UserUpdateProto.
                 * @memberof waiternow.common.SuperuserUpdateActionProto
                 * @classdesc Represents a UserUpdateProto.
                 * @implements IUserUpdateProto
                 * @constructor
                 * @param {waiternow.common.SuperuserUpdateActionProto.IUserUpdateProto=} [properties] Properties to set
                 */
                function UserUpdateProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * UserUpdateProto userId.
                 * @member {string} userId
                 * @memberof waiternow.common.SuperuserUpdateActionProto.UserUpdateProto
                 * @instance
                 */
                UserUpdateProto.prototype.userId = "";

                /**
                 * UserUpdateProto newEmail.
                 * @member {string} newEmail
                 * @memberof waiternow.common.SuperuserUpdateActionProto.UserUpdateProto
                 * @instance
                 */
                UserUpdateProto.prototype.newEmail = "";

                /**
                 * UserUpdateProto newPassword.
                 * @member {string} newPassword
                 * @memberof waiternow.common.SuperuserUpdateActionProto.UserUpdateProto
                 * @instance
                 */
                UserUpdateProto.prototype.newPassword = "";

                /**
                 * Creates a new UserUpdateProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.SuperuserUpdateActionProto.UserUpdateProto
                 * @static
                 * @param {waiternow.common.SuperuserUpdateActionProto.IUserUpdateProto=} [properties] Properties to set
                 * @returns {waiternow.common.SuperuserUpdateActionProto.UserUpdateProto} UserUpdateProto instance
                 */
                UserUpdateProto.create = function create(properties) {
                    return new UserUpdateProto(properties);
                };

                /**
                 * Encodes the specified UserUpdateProto message. Does not implicitly {@link waiternow.common.SuperuserUpdateActionProto.UserUpdateProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.SuperuserUpdateActionProto.UserUpdateProto
                 * @static
                 * @param {waiternow.common.SuperuserUpdateActionProto.IUserUpdateProto} message UserUpdateProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UserUpdateProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.userId);
                    if (message.newEmail != null && Object.hasOwnProperty.call(message, "newEmail"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.newEmail);
                    if (message.newPassword != null && Object.hasOwnProperty.call(message, "newPassword"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.newPassword);
                    return writer;
                };

                /**
                 * Encodes the specified UserUpdateProto message, length delimited. Does not implicitly {@link waiternow.common.SuperuserUpdateActionProto.UserUpdateProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.SuperuserUpdateActionProto.UserUpdateProto
                 * @static
                 * @param {waiternow.common.SuperuserUpdateActionProto.IUserUpdateProto} message UserUpdateProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UserUpdateProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a UserUpdateProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.SuperuserUpdateActionProto.UserUpdateProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.SuperuserUpdateActionProto.UserUpdateProto} UserUpdateProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UserUpdateProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.SuperuserUpdateActionProto.UserUpdateProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.userId = reader.string();
                                break;
                            }
                        case 2: {
                                message.newEmail = reader.string();
                                break;
                            }
                        case 3: {
                                message.newPassword = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a UserUpdateProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.SuperuserUpdateActionProto.UserUpdateProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.SuperuserUpdateActionProto.UserUpdateProto} UserUpdateProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UserUpdateProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a UserUpdateProto message.
                 * @function verify
                 * @memberof waiternow.common.SuperuserUpdateActionProto.UserUpdateProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                UserUpdateProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.userId != null && message.hasOwnProperty("userId"))
                        if (!$util.isString(message.userId))
                            return "userId: string expected";
                    if (message.newEmail != null && message.hasOwnProperty("newEmail"))
                        if (!$util.isString(message.newEmail))
                            return "newEmail: string expected";
                    if (message.newPassword != null && message.hasOwnProperty("newPassword"))
                        if (!$util.isString(message.newPassword))
                            return "newPassword: string expected";
                    return null;
                };

                /**
                 * Creates a UserUpdateProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.SuperuserUpdateActionProto.UserUpdateProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.SuperuserUpdateActionProto.UserUpdateProto} UserUpdateProto
                 */
                UserUpdateProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.SuperuserUpdateActionProto.UserUpdateProto)
                        return object;
                    var message = new $root.waiternow.common.SuperuserUpdateActionProto.UserUpdateProto();
                    if (object.userId != null)
                        message.userId = String(object.userId);
                    if (object.newEmail != null)
                        message.newEmail = String(object.newEmail);
                    if (object.newPassword != null)
                        message.newPassword = String(object.newPassword);
                    return message;
                };

                /**
                 * Creates a plain object from a UserUpdateProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.SuperuserUpdateActionProto.UserUpdateProto
                 * @static
                 * @param {waiternow.common.SuperuserUpdateActionProto.UserUpdateProto} message UserUpdateProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                UserUpdateProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.userId = "";
                        object.newEmail = "";
                        object.newPassword = "";
                    }
                    if (message.userId != null && message.hasOwnProperty("userId"))
                        object.userId = message.userId;
                    if (message.newEmail != null && message.hasOwnProperty("newEmail"))
                        object.newEmail = message.newEmail;
                    if (message.newPassword != null && message.hasOwnProperty("newPassword"))
                        object.newPassword = message.newPassword;
                    return object;
                };

                /**
                 * Converts this UserUpdateProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.SuperuserUpdateActionProto.UserUpdateProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                UserUpdateProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for UserUpdateProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.SuperuserUpdateActionProto.UserUpdateProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                UserUpdateProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.SuperuserUpdateActionProto.UserUpdateProto";
                };

                return UserUpdateProto;
            })();

            SuperuserUpdateActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.SuperuserUpdateActionProto
                 * @interface IRequest
                 * @property {waiternow.common.SuperuserUpdateActionProto.IUserUpdateProto|null} [userUpdate] Request userUpdate
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.SuperuserUpdateActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.SuperuserUpdateActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request userUpdate.
                 * @member {waiternow.common.SuperuserUpdateActionProto.IUserUpdateProto|null|undefined} userUpdate
                 * @memberof waiternow.common.SuperuserUpdateActionProto.Request
                 * @instance
                 */
                Request.prototype.userUpdate = null;

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.SuperuserUpdateActionProto.Request
                 * @static
                 * @param {waiternow.common.SuperuserUpdateActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.SuperuserUpdateActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.SuperuserUpdateActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.SuperuserUpdateActionProto.Request
                 * @static
                 * @param {waiternow.common.SuperuserUpdateActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.userUpdate != null && Object.hasOwnProperty.call(message, "userUpdate"))
                        $root.waiternow.common.SuperuserUpdateActionProto.UserUpdateProto.encode(message.userUpdate, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.SuperuserUpdateActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.SuperuserUpdateActionProto.Request
                 * @static
                 * @param {waiternow.common.SuperuserUpdateActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.SuperuserUpdateActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.SuperuserUpdateActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.SuperuserUpdateActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.userUpdate = $root.waiternow.common.SuperuserUpdateActionProto.UserUpdateProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.SuperuserUpdateActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.SuperuserUpdateActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.SuperuserUpdateActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.userUpdate != null && message.hasOwnProperty("userUpdate")) {
                        var error = $root.waiternow.common.SuperuserUpdateActionProto.UserUpdateProto.verify(message.userUpdate);
                        if (error)
                            return "userUpdate." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.SuperuserUpdateActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.SuperuserUpdateActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.SuperuserUpdateActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.SuperuserUpdateActionProto.Request();
                    if (object.userUpdate != null) {
                        if (typeof object.userUpdate !== "object")
                            throw TypeError(".waiternow.common.SuperuserUpdateActionProto.Request.userUpdate: object expected");
                        message.userUpdate = $root.waiternow.common.SuperuserUpdateActionProto.UserUpdateProto.fromObject(object.userUpdate);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.SuperuserUpdateActionProto.Request
                 * @static
                 * @param {waiternow.common.SuperuserUpdateActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.userUpdate = null;
                    if (message.userUpdate != null && message.hasOwnProperty("userUpdate"))
                        object.userUpdate = $root.waiternow.common.SuperuserUpdateActionProto.UserUpdateProto.toObject(message.userUpdate, options);
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.SuperuserUpdateActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.SuperuserUpdateActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.SuperuserUpdateActionProto.Request";
                };

                return Request;
            })();

            SuperuserUpdateActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.SuperuserUpdateActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.SuperuserUpdateActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.SuperuserUpdateActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.SuperuserUpdateActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.SuperuserUpdateActionProto.Response
                 * @static
                 * @param {waiternow.common.SuperuserUpdateActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.SuperuserUpdateActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.SuperuserUpdateActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.SuperuserUpdateActionProto.Response
                 * @static
                 * @param {waiternow.common.SuperuserUpdateActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.SuperuserUpdateActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.SuperuserUpdateActionProto.Response
                 * @static
                 * @param {waiternow.common.SuperuserUpdateActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.SuperuserUpdateActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.SuperuserUpdateActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.SuperuserUpdateActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.SuperuserUpdateActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.SuperuserUpdateActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.SuperuserUpdateActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.SuperuserUpdateActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.SuperuserUpdateActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.SuperuserUpdateActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.SuperuserUpdateActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.SuperuserUpdateActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.SuperuserUpdateActionProto.Response
                 * @static
                 * @param {waiternow.common.SuperuserUpdateActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.SuperuserUpdateActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.SuperuserUpdateActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.SuperuserUpdateActionProto.Response";
                };

                return Response;
            })();

            return SuperuserUpdateActionProto;
        })();

        common.SendSmsActionProto = (function() {

            /**
             * Properties of a SendSmsActionProto.
             * @memberof waiternow.common
             * @interface ISendSmsActionProto
             */

            /**
             * Constructs a new SendSmsActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a SendSmsActionProto.
             * @implements ISendSmsActionProto
             * @constructor
             * @param {waiternow.common.ISendSmsActionProto=} [properties] Properties to set
             */
            function SendSmsActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new SendSmsActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.SendSmsActionProto
             * @static
             * @param {waiternow.common.ISendSmsActionProto=} [properties] Properties to set
             * @returns {waiternow.common.SendSmsActionProto} SendSmsActionProto instance
             */
            SendSmsActionProto.create = function create(properties) {
                return new SendSmsActionProto(properties);
            };

            /**
             * Encodes the specified SendSmsActionProto message. Does not implicitly {@link waiternow.common.SendSmsActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.SendSmsActionProto
             * @static
             * @param {waiternow.common.ISendSmsActionProto} message SendSmsActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SendSmsActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified SendSmsActionProto message, length delimited. Does not implicitly {@link waiternow.common.SendSmsActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.SendSmsActionProto
             * @static
             * @param {waiternow.common.ISendSmsActionProto} message SendSmsActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SendSmsActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SendSmsActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.SendSmsActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.SendSmsActionProto} SendSmsActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SendSmsActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.SendSmsActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SendSmsActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.SendSmsActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.SendSmsActionProto} SendSmsActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SendSmsActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SendSmsActionProto message.
             * @function verify
             * @memberof waiternow.common.SendSmsActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SendSmsActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a SendSmsActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.SendSmsActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.SendSmsActionProto} SendSmsActionProto
             */
            SendSmsActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.SendSmsActionProto)
                    return object;
                return new $root.waiternow.common.SendSmsActionProto();
            };

            /**
             * Creates a plain object from a SendSmsActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.SendSmsActionProto
             * @static
             * @param {waiternow.common.SendSmsActionProto} message SendSmsActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SendSmsActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this SendSmsActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.SendSmsActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SendSmsActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for SendSmsActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.SendSmsActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            SendSmsActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.SendSmsActionProto";
            };

            SendSmsActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.SendSmsActionProto
                 * @interface IRequest
                 * @property {waiternow.common.IPhoneNumberProto|null} [to] Request to
                 * @property {string|null} [message] Request message
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.SendSmsActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.SendSmsActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request to.
                 * @member {waiternow.common.IPhoneNumberProto|null|undefined} to
                 * @memberof waiternow.common.SendSmsActionProto.Request
                 * @instance
                 */
                Request.prototype.to = null;

                /**
                 * Request message.
                 * @member {string} message
                 * @memberof waiternow.common.SendSmsActionProto.Request
                 * @instance
                 */
                Request.prototype.message = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.SendSmsActionProto.Request
                 * @static
                 * @param {waiternow.common.SendSmsActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.SendSmsActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.SendSmsActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.SendSmsActionProto.Request
                 * @static
                 * @param {waiternow.common.SendSmsActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.to != null && Object.hasOwnProperty.call(message, "to"))
                        $root.waiternow.common.PhoneNumberProto.encode(message.to, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.SendSmsActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.SendSmsActionProto.Request
                 * @static
                 * @param {waiternow.common.SendSmsActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.SendSmsActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.SendSmsActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.SendSmsActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.to = $root.waiternow.common.PhoneNumberProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.message = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.SendSmsActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.SendSmsActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.SendSmsActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.to != null && message.hasOwnProperty("to")) {
                        var error = $root.waiternow.common.PhoneNumberProto.verify(message.to);
                        if (error)
                            return "to." + error;
                    }
                    if (message.message != null && message.hasOwnProperty("message"))
                        if (!$util.isString(message.message))
                            return "message: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.SendSmsActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.SendSmsActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.SendSmsActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.SendSmsActionProto.Request();
                    if (object.to != null) {
                        if (typeof object.to !== "object")
                            throw TypeError(".waiternow.common.SendSmsActionProto.Request.to: object expected");
                        message.to = $root.waiternow.common.PhoneNumberProto.fromObject(object.to);
                    }
                    if (object.message != null)
                        message.message = String(object.message);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.SendSmsActionProto.Request
                 * @static
                 * @param {waiternow.common.SendSmsActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.to = null;
                        object.message = "";
                    }
                    if (message.to != null && message.hasOwnProperty("to"))
                        object.to = $root.waiternow.common.PhoneNumberProto.toObject(message.to, options);
                    if (message.message != null && message.hasOwnProperty("message"))
                        object.message = message.message;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.SendSmsActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.SendSmsActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.SendSmsActionProto.Request";
                };

                return Request;
            })();

            SendSmsActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.SendSmsActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.SendSmsActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.SendSmsActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.SendSmsActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.SendSmsActionProto.Response
                 * @static
                 * @param {waiternow.common.SendSmsActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.SendSmsActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.SendSmsActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.SendSmsActionProto.Response
                 * @static
                 * @param {waiternow.common.SendSmsActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.SendSmsActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.SendSmsActionProto.Response
                 * @static
                 * @param {waiternow.common.SendSmsActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.SendSmsActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.SendSmsActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.SendSmsActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.SendSmsActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.SendSmsActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.SendSmsActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.SendSmsActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.SendSmsActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.SendSmsActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.SendSmsActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.SendSmsActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.SendSmsActionProto.Response
                 * @static
                 * @param {waiternow.common.SendSmsActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.SendSmsActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.SendSmsActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.SendSmsActionProto.Response";
                };

                return Response;
            })();

            return SendSmsActionProto;
        })();

        common.ValidateAddressActionProto = (function() {

            /**
             * Properties of a ValidateAddressActionProto.
             * @memberof waiternow.common
             * @interface IValidateAddressActionProto
             */

            /**
             * Constructs a new ValidateAddressActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a ValidateAddressActionProto.
             * @implements IValidateAddressActionProto
             * @constructor
             * @param {waiternow.common.IValidateAddressActionProto=} [properties] Properties to set
             */
            function ValidateAddressActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new ValidateAddressActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.ValidateAddressActionProto
             * @static
             * @param {waiternow.common.IValidateAddressActionProto=} [properties] Properties to set
             * @returns {waiternow.common.ValidateAddressActionProto} ValidateAddressActionProto instance
             */
            ValidateAddressActionProto.create = function create(properties) {
                return new ValidateAddressActionProto(properties);
            };

            /**
             * Encodes the specified ValidateAddressActionProto message. Does not implicitly {@link waiternow.common.ValidateAddressActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.ValidateAddressActionProto
             * @static
             * @param {waiternow.common.IValidateAddressActionProto} message ValidateAddressActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ValidateAddressActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified ValidateAddressActionProto message, length delimited. Does not implicitly {@link waiternow.common.ValidateAddressActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.ValidateAddressActionProto
             * @static
             * @param {waiternow.common.IValidateAddressActionProto} message ValidateAddressActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ValidateAddressActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ValidateAddressActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.ValidateAddressActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.ValidateAddressActionProto} ValidateAddressActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ValidateAddressActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.ValidateAddressActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ValidateAddressActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.ValidateAddressActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.ValidateAddressActionProto} ValidateAddressActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ValidateAddressActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ValidateAddressActionProto message.
             * @function verify
             * @memberof waiternow.common.ValidateAddressActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ValidateAddressActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a ValidateAddressActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.ValidateAddressActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.ValidateAddressActionProto} ValidateAddressActionProto
             */
            ValidateAddressActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.ValidateAddressActionProto)
                    return object;
                return new $root.waiternow.common.ValidateAddressActionProto();
            };

            /**
             * Creates a plain object from a ValidateAddressActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.ValidateAddressActionProto
             * @static
             * @param {waiternow.common.ValidateAddressActionProto} message ValidateAddressActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ValidateAddressActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this ValidateAddressActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.ValidateAddressActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ValidateAddressActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for ValidateAddressActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.ValidateAddressActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            ValidateAddressActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.ValidateAddressActionProto";
            };

            ValidateAddressActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.ValidateAddressActionProto
                 * @interface IRequest
                 * @property {waiternow.common.IAddressProto|null} [address] Request address
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.ValidateAddressActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.ValidateAddressActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request address.
                 * @member {waiternow.common.IAddressProto|null|undefined} address
                 * @memberof waiternow.common.ValidateAddressActionProto.Request
                 * @instance
                 */
                Request.prototype.address = null;

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.ValidateAddressActionProto.Request
                 * @static
                 * @param {waiternow.common.ValidateAddressActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.ValidateAddressActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.ValidateAddressActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.ValidateAddressActionProto.Request
                 * @static
                 * @param {waiternow.common.ValidateAddressActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.address != null && Object.hasOwnProperty.call(message, "address"))
                        $root.waiternow.common.AddressProto.encode(message.address, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.ValidateAddressActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.ValidateAddressActionProto.Request
                 * @static
                 * @param {waiternow.common.ValidateAddressActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.ValidateAddressActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.ValidateAddressActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.ValidateAddressActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.address = $root.waiternow.common.AddressProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.ValidateAddressActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.ValidateAddressActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.ValidateAddressActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.address != null && message.hasOwnProperty("address")) {
                        var error = $root.waiternow.common.AddressProto.verify(message.address);
                        if (error)
                            return "address." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.ValidateAddressActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.ValidateAddressActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.ValidateAddressActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.ValidateAddressActionProto.Request();
                    if (object.address != null) {
                        if (typeof object.address !== "object")
                            throw TypeError(".waiternow.common.ValidateAddressActionProto.Request.address: object expected");
                        message.address = $root.waiternow.common.AddressProto.fromObject(object.address);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.ValidateAddressActionProto.Request
                 * @static
                 * @param {waiternow.common.ValidateAddressActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.address = null;
                    if (message.address != null && message.hasOwnProperty("address"))
                        object.address = $root.waiternow.common.AddressProto.toObject(message.address, options);
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.ValidateAddressActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.ValidateAddressActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.ValidateAddressActionProto.Request";
                };

                return Request;
            })();

            ValidateAddressActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.ValidateAddressActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {boolean|null} [isAddressValid] Response isAddressValid
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.ValidateAddressActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.ValidateAddressActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.ValidateAddressActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response isAddressValid.
                 * @member {boolean} isAddressValid
                 * @memberof waiternow.common.ValidateAddressActionProto.Response
                 * @instance
                 */
                Response.prototype.isAddressValid = false;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.ValidateAddressActionProto.Response
                 * @static
                 * @param {waiternow.common.ValidateAddressActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.ValidateAddressActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.ValidateAddressActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.ValidateAddressActionProto.Response
                 * @static
                 * @param {waiternow.common.ValidateAddressActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.isAddressValid != null && Object.hasOwnProperty.call(message, "isAddressValid"))
                        writer.uint32(/* id 2, wireType 0 =*/16).bool(message.isAddressValid);
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.ValidateAddressActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.ValidateAddressActionProto.Response
                 * @static
                 * @param {waiternow.common.ValidateAddressActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.ValidateAddressActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.ValidateAddressActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.ValidateAddressActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.isAddressValid = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.ValidateAddressActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.ValidateAddressActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.ValidateAddressActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.isAddressValid != null && message.hasOwnProperty("isAddressValid"))
                        if (typeof message.isAddressValid !== "boolean")
                            return "isAddressValid: boolean expected";
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.ValidateAddressActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.ValidateAddressActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.ValidateAddressActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.ValidateAddressActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.ValidateAddressActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.isAddressValid != null)
                        message.isAddressValid = Boolean(object.isAddressValid);
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.ValidateAddressActionProto.Response
                 * @static
                 * @param {waiternow.common.ValidateAddressActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.isAddressValid = false;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.isAddressValid != null && message.hasOwnProperty("isAddressValid"))
                        object.isAddressValid = message.isAddressValid;
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.ValidateAddressActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.ValidateAddressActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.ValidateAddressActionProto.Response";
                };

                return Response;
            })();

            return ValidateAddressActionProto;
        })();

        common.GeocodeAddressActionProto = (function() {

            /**
             * Properties of a GeocodeAddressActionProto.
             * @memberof waiternow.common
             * @interface IGeocodeAddressActionProto
             */

            /**
             * Constructs a new GeocodeAddressActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a GeocodeAddressActionProto.
             * @implements IGeocodeAddressActionProto
             * @constructor
             * @param {waiternow.common.IGeocodeAddressActionProto=} [properties] Properties to set
             */
            function GeocodeAddressActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new GeocodeAddressActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.GeocodeAddressActionProto
             * @static
             * @param {waiternow.common.IGeocodeAddressActionProto=} [properties] Properties to set
             * @returns {waiternow.common.GeocodeAddressActionProto} GeocodeAddressActionProto instance
             */
            GeocodeAddressActionProto.create = function create(properties) {
                return new GeocodeAddressActionProto(properties);
            };

            /**
             * Encodes the specified GeocodeAddressActionProto message. Does not implicitly {@link waiternow.common.GeocodeAddressActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.GeocodeAddressActionProto
             * @static
             * @param {waiternow.common.IGeocodeAddressActionProto} message GeocodeAddressActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GeocodeAddressActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified GeocodeAddressActionProto message, length delimited. Does not implicitly {@link waiternow.common.GeocodeAddressActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.GeocodeAddressActionProto
             * @static
             * @param {waiternow.common.IGeocodeAddressActionProto} message GeocodeAddressActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GeocodeAddressActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GeocodeAddressActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.GeocodeAddressActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.GeocodeAddressActionProto} GeocodeAddressActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GeocodeAddressActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GeocodeAddressActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GeocodeAddressActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.GeocodeAddressActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.GeocodeAddressActionProto} GeocodeAddressActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GeocodeAddressActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GeocodeAddressActionProto message.
             * @function verify
             * @memberof waiternow.common.GeocodeAddressActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GeocodeAddressActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a GeocodeAddressActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.GeocodeAddressActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.GeocodeAddressActionProto} GeocodeAddressActionProto
             */
            GeocodeAddressActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.GeocodeAddressActionProto)
                    return object;
                return new $root.waiternow.common.GeocodeAddressActionProto();
            };

            /**
             * Creates a plain object from a GeocodeAddressActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.GeocodeAddressActionProto
             * @static
             * @param {waiternow.common.GeocodeAddressActionProto} message GeocodeAddressActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GeocodeAddressActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this GeocodeAddressActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.GeocodeAddressActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GeocodeAddressActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for GeocodeAddressActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.GeocodeAddressActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            GeocodeAddressActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.GeocodeAddressActionProto";
            };

            GeocodeAddressActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.GeocodeAddressActionProto
                 * @interface IRequest
                 * @property {waiternow.common.IAddressProto|null} [address] Request address
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.GeocodeAddressActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.GeocodeAddressActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request address.
                 * @member {waiternow.common.IAddressProto|null|undefined} address
                 * @memberof waiternow.common.GeocodeAddressActionProto.Request
                 * @instance
                 */
                Request.prototype.address = null;

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GeocodeAddressActionProto.Request
                 * @static
                 * @param {waiternow.common.GeocodeAddressActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.GeocodeAddressActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.GeocodeAddressActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GeocodeAddressActionProto.Request
                 * @static
                 * @param {waiternow.common.GeocodeAddressActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.address != null && Object.hasOwnProperty.call(message, "address"))
                        $root.waiternow.common.AddressProto.encode(message.address, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.GeocodeAddressActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GeocodeAddressActionProto.Request
                 * @static
                 * @param {waiternow.common.GeocodeAddressActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GeocodeAddressActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GeocodeAddressActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GeocodeAddressActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.address = $root.waiternow.common.AddressProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GeocodeAddressActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GeocodeAddressActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.GeocodeAddressActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.address != null && message.hasOwnProperty("address")) {
                        var error = $root.waiternow.common.AddressProto.verify(message.address);
                        if (error)
                            return "address." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GeocodeAddressActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GeocodeAddressActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GeocodeAddressActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.GeocodeAddressActionProto.Request();
                    if (object.address != null) {
                        if (typeof object.address !== "object")
                            throw TypeError(".waiternow.common.GeocodeAddressActionProto.Request.address: object expected");
                        message.address = $root.waiternow.common.AddressProto.fromObject(object.address);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GeocodeAddressActionProto.Request
                 * @static
                 * @param {waiternow.common.GeocodeAddressActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.address = null;
                    if (message.address != null && message.hasOwnProperty("address"))
                        object.address = $root.waiternow.common.AddressProto.toObject(message.address, options);
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GeocodeAddressActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.GeocodeAddressActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GeocodeAddressActionProto.Request";
                };

                return Request;
            })();

            GeocodeAddressActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.GeocodeAddressActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IAddressProto|null} [address] Response address
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.GeocodeAddressActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.GeocodeAddressActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.GeocodeAddressActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response address.
                 * @member {waiternow.common.IAddressProto|null|undefined} address
                 * @memberof waiternow.common.GeocodeAddressActionProto.Response
                 * @instance
                 */
                Response.prototype.address = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GeocodeAddressActionProto.Response
                 * @static
                 * @param {waiternow.common.GeocodeAddressActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.GeocodeAddressActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.GeocodeAddressActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GeocodeAddressActionProto.Response
                 * @static
                 * @param {waiternow.common.GeocodeAddressActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.address != null && Object.hasOwnProperty.call(message, "address"))
                        $root.waiternow.common.AddressProto.encode(message.address, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.GeocodeAddressActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GeocodeAddressActionProto.Response
                 * @static
                 * @param {waiternow.common.GeocodeAddressActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GeocodeAddressActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GeocodeAddressActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GeocodeAddressActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.address = $root.waiternow.common.AddressProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GeocodeAddressActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GeocodeAddressActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.GeocodeAddressActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.address != null && message.hasOwnProperty("address")) {
                        var error = $root.waiternow.common.AddressProto.verify(message.address);
                        if (error)
                            return "address." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GeocodeAddressActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GeocodeAddressActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GeocodeAddressActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.GeocodeAddressActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.GeocodeAddressActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.address != null) {
                        if (typeof object.address !== "object")
                            throw TypeError(".waiternow.common.GeocodeAddressActionProto.Response.address: object expected");
                        message.address = $root.waiternow.common.AddressProto.fromObject(object.address);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GeocodeAddressActionProto.Response
                 * @static
                 * @param {waiternow.common.GeocodeAddressActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.address = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.address != null && message.hasOwnProperty("address"))
                        object.address = $root.waiternow.common.AddressProto.toObject(message.address, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GeocodeAddressActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.GeocodeAddressActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GeocodeAddressActionProto.Response";
                };

                return Response;
            })();

            return GeocodeAddressActionProto;
        })();

        common.CalculateGeoDistanceActionProto = (function() {

            /**
             * Properties of a CalculateGeoDistanceActionProto.
             * @memberof waiternow.common
             * @interface ICalculateGeoDistanceActionProto
             */

            /**
             * Constructs a new CalculateGeoDistanceActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a CalculateGeoDistanceActionProto.
             * @implements ICalculateGeoDistanceActionProto
             * @constructor
             * @param {waiternow.common.ICalculateGeoDistanceActionProto=} [properties] Properties to set
             */
            function CalculateGeoDistanceActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new CalculateGeoDistanceActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.CalculateGeoDistanceActionProto
             * @static
             * @param {waiternow.common.ICalculateGeoDistanceActionProto=} [properties] Properties to set
             * @returns {waiternow.common.CalculateGeoDistanceActionProto} CalculateGeoDistanceActionProto instance
             */
            CalculateGeoDistanceActionProto.create = function create(properties) {
                return new CalculateGeoDistanceActionProto(properties);
            };

            /**
             * Encodes the specified CalculateGeoDistanceActionProto message. Does not implicitly {@link waiternow.common.CalculateGeoDistanceActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.CalculateGeoDistanceActionProto
             * @static
             * @param {waiternow.common.ICalculateGeoDistanceActionProto} message CalculateGeoDistanceActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CalculateGeoDistanceActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified CalculateGeoDistanceActionProto message, length delimited. Does not implicitly {@link waiternow.common.CalculateGeoDistanceActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.CalculateGeoDistanceActionProto
             * @static
             * @param {waiternow.common.ICalculateGeoDistanceActionProto} message CalculateGeoDistanceActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CalculateGeoDistanceActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CalculateGeoDistanceActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.CalculateGeoDistanceActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.CalculateGeoDistanceActionProto} CalculateGeoDistanceActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CalculateGeoDistanceActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CalculateGeoDistanceActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CalculateGeoDistanceActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.CalculateGeoDistanceActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.CalculateGeoDistanceActionProto} CalculateGeoDistanceActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CalculateGeoDistanceActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CalculateGeoDistanceActionProto message.
             * @function verify
             * @memberof waiternow.common.CalculateGeoDistanceActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CalculateGeoDistanceActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a CalculateGeoDistanceActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.CalculateGeoDistanceActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.CalculateGeoDistanceActionProto} CalculateGeoDistanceActionProto
             */
            CalculateGeoDistanceActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.CalculateGeoDistanceActionProto)
                    return object;
                return new $root.waiternow.common.CalculateGeoDistanceActionProto();
            };

            /**
             * Creates a plain object from a CalculateGeoDistanceActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.CalculateGeoDistanceActionProto
             * @static
             * @param {waiternow.common.CalculateGeoDistanceActionProto} message CalculateGeoDistanceActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CalculateGeoDistanceActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this CalculateGeoDistanceActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.CalculateGeoDistanceActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CalculateGeoDistanceActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for CalculateGeoDistanceActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.CalculateGeoDistanceActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            CalculateGeoDistanceActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.CalculateGeoDistanceActionProto";
            };

            CalculateGeoDistanceActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.CalculateGeoDistanceActionProto
                 * @interface IRequest
                 * @property {waiternow.common.IAddressProto|null} [from] Request from
                 * @property {waiternow.common.IAddressProto|null} [to] Request to
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.CalculateGeoDistanceActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.CalculateGeoDistanceActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request from.
                 * @member {waiternow.common.IAddressProto|null|undefined} from
                 * @memberof waiternow.common.CalculateGeoDistanceActionProto.Request
                 * @instance
                 */
                Request.prototype.from = null;

                /**
                 * Request to.
                 * @member {waiternow.common.IAddressProto|null|undefined} to
                 * @memberof waiternow.common.CalculateGeoDistanceActionProto.Request
                 * @instance
                 */
                Request.prototype.to = null;

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.CalculateGeoDistanceActionProto.Request
                 * @static
                 * @param {waiternow.common.CalculateGeoDistanceActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.CalculateGeoDistanceActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.CalculateGeoDistanceActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.CalculateGeoDistanceActionProto.Request
                 * @static
                 * @param {waiternow.common.CalculateGeoDistanceActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.from != null && Object.hasOwnProperty.call(message, "from"))
                        $root.waiternow.common.AddressProto.encode(message.from, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.to != null && Object.hasOwnProperty.call(message, "to"))
                        $root.waiternow.common.AddressProto.encode(message.to, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.CalculateGeoDistanceActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.CalculateGeoDistanceActionProto.Request
                 * @static
                 * @param {waiternow.common.CalculateGeoDistanceActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.CalculateGeoDistanceActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.CalculateGeoDistanceActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CalculateGeoDistanceActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.from = $root.waiternow.common.AddressProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.to = $root.waiternow.common.AddressProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.CalculateGeoDistanceActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.CalculateGeoDistanceActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.CalculateGeoDistanceActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.from != null && message.hasOwnProperty("from")) {
                        var error = $root.waiternow.common.AddressProto.verify(message.from);
                        if (error)
                            return "from." + error;
                    }
                    if (message.to != null && message.hasOwnProperty("to")) {
                        var error = $root.waiternow.common.AddressProto.verify(message.to);
                        if (error)
                            return "to." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.CalculateGeoDistanceActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.CalculateGeoDistanceActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.CalculateGeoDistanceActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.CalculateGeoDistanceActionProto.Request();
                    if (object.from != null) {
                        if (typeof object.from !== "object")
                            throw TypeError(".waiternow.common.CalculateGeoDistanceActionProto.Request.from: object expected");
                        message.from = $root.waiternow.common.AddressProto.fromObject(object.from);
                    }
                    if (object.to != null) {
                        if (typeof object.to !== "object")
                            throw TypeError(".waiternow.common.CalculateGeoDistanceActionProto.Request.to: object expected");
                        message.to = $root.waiternow.common.AddressProto.fromObject(object.to);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.CalculateGeoDistanceActionProto.Request
                 * @static
                 * @param {waiternow.common.CalculateGeoDistanceActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.from = null;
                        object.to = null;
                    }
                    if (message.from != null && message.hasOwnProperty("from"))
                        object.from = $root.waiternow.common.AddressProto.toObject(message.from, options);
                    if (message.to != null && message.hasOwnProperty("to"))
                        object.to = $root.waiternow.common.AddressProto.toObject(message.to, options);
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.CalculateGeoDistanceActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.CalculateGeoDistanceActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.CalculateGeoDistanceActionProto.Request";
                };

                return Request;
            })();

            CalculateGeoDistanceActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.CalculateGeoDistanceActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IGeoDistanceProto|null} [geoDistance] Response geoDistance
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.CalculateGeoDistanceActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.CalculateGeoDistanceActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.CalculateGeoDistanceActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response geoDistance.
                 * @member {waiternow.common.IGeoDistanceProto|null|undefined} geoDistance
                 * @memberof waiternow.common.CalculateGeoDistanceActionProto.Response
                 * @instance
                 */
                Response.prototype.geoDistance = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.CalculateGeoDistanceActionProto.Response
                 * @static
                 * @param {waiternow.common.CalculateGeoDistanceActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.CalculateGeoDistanceActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.CalculateGeoDistanceActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.CalculateGeoDistanceActionProto.Response
                 * @static
                 * @param {waiternow.common.CalculateGeoDistanceActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.geoDistance != null && Object.hasOwnProperty.call(message, "geoDistance"))
                        $root.waiternow.common.GeoDistanceProto.encode(message.geoDistance, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.CalculateGeoDistanceActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.CalculateGeoDistanceActionProto.Response
                 * @static
                 * @param {waiternow.common.CalculateGeoDistanceActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.CalculateGeoDistanceActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.CalculateGeoDistanceActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CalculateGeoDistanceActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.geoDistance = $root.waiternow.common.GeoDistanceProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.CalculateGeoDistanceActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.CalculateGeoDistanceActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.CalculateGeoDistanceActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.geoDistance != null && message.hasOwnProperty("geoDistance")) {
                        var error = $root.waiternow.common.GeoDistanceProto.verify(message.geoDistance);
                        if (error)
                            return "geoDistance." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.CalculateGeoDistanceActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.CalculateGeoDistanceActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.CalculateGeoDistanceActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.CalculateGeoDistanceActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.CalculateGeoDistanceActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.geoDistance != null) {
                        if (typeof object.geoDistance !== "object")
                            throw TypeError(".waiternow.common.CalculateGeoDistanceActionProto.Response.geoDistance: object expected");
                        message.geoDistance = $root.waiternow.common.GeoDistanceProto.fromObject(object.geoDistance);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.CalculateGeoDistanceActionProto.Response
                 * @static
                 * @param {waiternow.common.CalculateGeoDistanceActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.geoDistance = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.geoDistance != null && message.hasOwnProperty("geoDistance"))
                        object.geoDistance = $root.waiternow.common.GeoDistanceProto.toObject(message.geoDistance, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.CalculateGeoDistanceActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.CalculateGeoDistanceActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.CalculateGeoDistanceActionProto.Response";
                };

                return Response;
            })();

            return CalculateGeoDistanceActionProto;
        })();

        common.TerminateDeviceSessionRequestActionProto = (function() {

            /**
             * Properties of a TerminateDeviceSessionRequestActionProto.
             * @memberof waiternow.common
             * @interface ITerminateDeviceSessionRequestActionProto
             */

            /**
             * Constructs a new TerminateDeviceSessionRequestActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a TerminateDeviceSessionRequestActionProto.
             * @implements ITerminateDeviceSessionRequestActionProto
             * @constructor
             * @param {waiternow.common.ITerminateDeviceSessionRequestActionProto=} [properties] Properties to set
             */
            function TerminateDeviceSessionRequestActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new TerminateDeviceSessionRequestActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.TerminateDeviceSessionRequestActionProto
             * @static
             * @param {waiternow.common.ITerminateDeviceSessionRequestActionProto=} [properties] Properties to set
             * @returns {waiternow.common.TerminateDeviceSessionRequestActionProto} TerminateDeviceSessionRequestActionProto instance
             */
            TerminateDeviceSessionRequestActionProto.create = function create(properties) {
                return new TerminateDeviceSessionRequestActionProto(properties);
            };

            /**
             * Encodes the specified TerminateDeviceSessionRequestActionProto message. Does not implicitly {@link waiternow.common.TerminateDeviceSessionRequestActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.TerminateDeviceSessionRequestActionProto
             * @static
             * @param {waiternow.common.ITerminateDeviceSessionRequestActionProto} message TerminateDeviceSessionRequestActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            TerminateDeviceSessionRequestActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified TerminateDeviceSessionRequestActionProto message, length delimited. Does not implicitly {@link waiternow.common.TerminateDeviceSessionRequestActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.TerminateDeviceSessionRequestActionProto
             * @static
             * @param {waiternow.common.ITerminateDeviceSessionRequestActionProto} message TerminateDeviceSessionRequestActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            TerminateDeviceSessionRequestActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a TerminateDeviceSessionRequestActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.TerminateDeviceSessionRequestActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.TerminateDeviceSessionRequestActionProto} TerminateDeviceSessionRequestActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            TerminateDeviceSessionRequestActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.TerminateDeviceSessionRequestActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a TerminateDeviceSessionRequestActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.TerminateDeviceSessionRequestActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.TerminateDeviceSessionRequestActionProto} TerminateDeviceSessionRequestActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            TerminateDeviceSessionRequestActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a TerminateDeviceSessionRequestActionProto message.
             * @function verify
             * @memberof waiternow.common.TerminateDeviceSessionRequestActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            TerminateDeviceSessionRequestActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a TerminateDeviceSessionRequestActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.TerminateDeviceSessionRequestActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.TerminateDeviceSessionRequestActionProto} TerminateDeviceSessionRequestActionProto
             */
            TerminateDeviceSessionRequestActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.TerminateDeviceSessionRequestActionProto)
                    return object;
                return new $root.waiternow.common.TerminateDeviceSessionRequestActionProto();
            };

            /**
             * Creates a plain object from a TerminateDeviceSessionRequestActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.TerminateDeviceSessionRequestActionProto
             * @static
             * @param {waiternow.common.TerminateDeviceSessionRequestActionProto} message TerminateDeviceSessionRequestActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            TerminateDeviceSessionRequestActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this TerminateDeviceSessionRequestActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.TerminateDeviceSessionRequestActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            TerminateDeviceSessionRequestActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for TerminateDeviceSessionRequestActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.TerminateDeviceSessionRequestActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            TerminateDeviceSessionRequestActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.TerminateDeviceSessionRequestActionProto";
            };

            TerminateDeviceSessionRequestActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.TerminateDeviceSessionRequestActionProto
                 * @interface IRequest
                 * @property {string|null} [deviceId] Request deviceId
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.TerminateDeviceSessionRequestActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.TerminateDeviceSessionRequestActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request deviceId.
                 * @member {string} deviceId
                 * @memberof waiternow.common.TerminateDeviceSessionRequestActionProto.Request
                 * @instance
                 */
                Request.prototype.deviceId = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.TerminateDeviceSessionRequestActionProto.Request
                 * @static
                 * @param {waiternow.common.TerminateDeviceSessionRequestActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.TerminateDeviceSessionRequestActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.TerminateDeviceSessionRequestActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.TerminateDeviceSessionRequestActionProto.Request
                 * @static
                 * @param {waiternow.common.TerminateDeviceSessionRequestActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceId != null && Object.hasOwnProperty.call(message, "deviceId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.deviceId);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.TerminateDeviceSessionRequestActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.TerminateDeviceSessionRequestActionProto.Request
                 * @static
                 * @param {waiternow.common.TerminateDeviceSessionRequestActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.TerminateDeviceSessionRequestActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.TerminateDeviceSessionRequestActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.TerminateDeviceSessionRequestActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.TerminateDeviceSessionRequestActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.TerminateDeviceSessionRequestActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.TerminateDeviceSessionRequestActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                        if (!$util.isString(message.deviceId))
                            return "deviceId: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.TerminateDeviceSessionRequestActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.TerminateDeviceSessionRequestActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.TerminateDeviceSessionRequestActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.TerminateDeviceSessionRequestActionProto.Request();
                    if (object.deviceId != null)
                        message.deviceId = String(object.deviceId);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.TerminateDeviceSessionRequestActionProto.Request
                 * @static
                 * @param {waiternow.common.TerminateDeviceSessionRequestActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.deviceId = "";
                    if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                        object.deviceId = message.deviceId;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.TerminateDeviceSessionRequestActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.TerminateDeviceSessionRequestActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.TerminateDeviceSessionRequestActionProto.Request";
                };

                return Request;
            })();

            TerminateDeviceSessionRequestActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.TerminateDeviceSessionRequestActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.TerminateDeviceSessionRequestActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.TerminateDeviceSessionRequestActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.TerminateDeviceSessionRequestActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.TerminateDeviceSessionRequestActionProto.Response
                 * @static
                 * @param {waiternow.common.TerminateDeviceSessionRequestActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.TerminateDeviceSessionRequestActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.TerminateDeviceSessionRequestActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.TerminateDeviceSessionRequestActionProto.Response
                 * @static
                 * @param {waiternow.common.TerminateDeviceSessionRequestActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.TerminateDeviceSessionRequestActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.TerminateDeviceSessionRequestActionProto.Response
                 * @static
                 * @param {waiternow.common.TerminateDeviceSessionRequestActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.TerminateDeviceSessionRequestActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.TerminateDeviceSessionRequestActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.TerminateDeviceSessionRequestActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.TerminateDeviceSessionRequestActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.TerminateDeviceSessionRequestActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.TerminateDeviceSessionRequestActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.TerminateDeviceSessionRequestActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.TerminateDeviceSessionRequestActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.TerminateDeviceSessionRequestActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.TerminateDeviceSessionRequestActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.TerminateDeviceSessionRequestActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.TerminateDeviceSessionRequestActionProto.Response
                 * @static
                 * @param {waiternow.common.TerminateDeviceSessionRequestActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.TerminateDeviceSessionRequestActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.TerminateDeviceSessionRequestActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.TerminateDeviceSessionRequestActionProto.Response";
                };

                return Response;
            })();

            return TerminateDeviceSessionRequestActionProto;
        })();

        common.StartRemoteLogsSessionActionProto = (function() {

            /**
             * Properties of a StartRemoteLogsSessionActionProto.
             * @memberof waiternow.common
             * @interface IStartRemoteLogsSessionActionProto
             */

            /**
             * Constructs a new StartRemoteLogsSessionActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a StartRemoteLogsSessionActionProto.
             * @implements IStartRemoteLogsSessionActionProto
             * @constructor
             * @param {waiternow.common.IStartRemoteLogsSessionActionProto=} [properties] Properties to set
             */
            function StartRemoteLogsSessionActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new StartRemoteLogsSessionActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.StartRemoteLogsSessionActionProto
             * @static
             * @param {waiternow.common.IStartRemoteLogsSessionActionProto=} [properties] Properties to set
             * @returns {waiternow.common.StartRemoteLogsSessionActionProto} StartRemoteLogsSessionActionProto instance
             */
            StartRemoteLogsSessionActionProto.create = function create(properties) {
                return new StartRemoteLogsSessionActionProto(properties);
            };

            /**
             * Encodes the specified StartRemoteLogsSessionActionProto message. Does not implicitly {@link waiternow.common.StartRemoteLogsSessionActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.StartRemoteLogsSessionActionProto
             * @static
             * @param {waiternow.common.IStartRemoteLogsSessionActionProto} message StartRemoteLogsSessionActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StartRemoteLogsSessionActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified StartRemoteLogsSessionActionProto message, length delimited. Does not implicitly {@link waiternow.common.StartRemoteLogsSessionActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.StartRemoteLogsSessionActionProto
             * @static
             * @param {waiternow.common.IStartRemoteLogsSessionActionProto} message StartRemoteLogsSessionActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StartRemoteLogsSessionActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a StartRemoteLogsSessionActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.StartRemoteLogsSessionActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.StartRemoteLogsSessionActionProto} StartRemoteLogsSessionActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StartRemoteLogsSessionActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.StartRemoteLogsSessionActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a StartRemoteLogsSessionActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.StartRemoteLogsSessionActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.StartRemoteLogsSessionActionProto} StartRemoteLogsSessionActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StartRemoteLogsSessionActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a StartRemoteLogsSessionActionProto message.
             * @function verify
             * @memberof waiternow.common.StartRemoteLogsSessionActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            StartRemoteLogsSessionActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a StartRemoteLogsSessionActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.StartRemoteLogsSessionActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.StartRemoteLogsSessionActionProto} StartRemoteLogsSessionActionProto
             */
            StartRemoteLogsSessionActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.StartRemoteLogsSessionActionProto)
                    return object;
                return new $root.waiternow.common.StartRemoteLogsSessionActionProto();
            };

            /**
             * Creates a plain object from a StartRemoteLogsSessionActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.StartRemoteLogsSessionActionProto
             * @static
             * @param {waiternow.common.StartRemoteLogsSessionActionProto} message StartRemoteLogsSessionActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            StartRemoteLogsSessionActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this StartRemoteLogsSessionActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.StartRemoteLogsSessionActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            StartRemoteLogsSessionActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for StartRemoteLogsSessionActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.StartRemoteLogsSessionActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            StartRemoteLogsSessionActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.StartRemoteLogsSessionActionProto";
            };

            StartRemoteLogsSessionActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.StartRemoteLogsSessionActionProto
                 * @interface IRequest
                 * @property {string|null} [deviceId] Request deviceId
                 * @property {google.protobuf.IDuration|null} [duration] Request duration
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.StartRemoteLogsSessionActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.StartRemoteLogsSessionActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request deviceId.
                 * @member {string} deviceId
                 * @memberof waiternow.common.StartRemoteLogsSessionActionProto.Request
                 * @instance
                 */
                Request.prototype.deviceId = "";

                /**
                 * Request duration.
                 * @member {google.protobuf.IDuration|null|undefined} duration
                 * @memberof waiternow.common.StartRemoteLogsSessionActionProto.Request
                 * @instance
                 */
                Request.prototype.duration = null;

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.StartRemoteLogsSessionActionProto.Request
                 * @static
                 * @param {waiternow.common.StartRemoteLogsSessionActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.StartRemoteLogsSessionActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.StartRemoteLogsSessionActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.StartRemoteLogsSessionActionProto.Request
                 * @static
                 * @param {waiternow.common.StartRemoteLogsSessionActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceId != null && Object.hasOwnProperty.call(message, "deviceId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.deviceId);
                    if (message.duration != null && Object.hasOwnProperty.call(message, "duration"))
                        $root.google.protobuf.Duration.encode(message.duration, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.StartRemoteLogsSessionActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.StartRemoteLogsSessionActionProto.Request
                 * @static
                 * @param {waiternow.common.StartRemoteLogsSessionActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.StartRemoteLogsSessionActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.StartRemoteLogsSessionActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.StartRemoteLogsSessionActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceId = reader.string();
                                break;
                            }
                        case 2: {
                                message.duration = $root.google.protobuf.Duration.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.StartRemoteLogsSessionActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.StartRemoteLogsSessionActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.StartRemoteLogsSessionActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                        if (!$util.isString(message.deviceId))
                            return "deviceId: string expected";
                    if (message.duration != null && message.hasOwnProperty("duration")) {
                        var error = $root.google.protobuf.Duration.verify(message.duration);
                        if (error)
                            return "duration." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.StartRemoteLogsSessionActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.StartRemoteLogsSessionActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.StartRemoteLogsSessionActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.StartRemoteLogsSessionActionProto.Request();
                    if (object.deviceId != null)
                        message.deviceId = String(object.deviceId);
                    if (object.duration != null) {
                        if (typeof object.duration !== "object")
                            throw TypeError(".waiternow.common.StartRemoteLogsSessionActionProto.Request.duration: object expected");
                        message.duration = $root.google.protobuf.Duration.fromObject(object.duration);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.StartRemoteLogsSessionActionProto.Request
                 * @static
                 * @param {waiternow.common.StartRemoteLogsSessionActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.deviceId = "";
                        object.duration = null;
                    }
                    if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                        object.deviceId = message.deviceId;
                    if (message.duration != null && message.hasOwnProperty("duration"))
                        object.duration = $root.google.protobuf.Duration.toObject(message.duration, options);
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.StartRemoteLogsSessionActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.StartRemoteLogsSessionActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.StartRemoteLogsSessionActionProto.Request";
                };

                return Request;
            })();

            StartRemoteLogsSessionActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.StartRemoteLogsSessionActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.StartRemoteLogsSessionActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.StartRemoteLogsSessionActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.StartRemoteLogsSessionActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.StartRemoteLogsSessionActionProto.Response
                 * @static
                 * @param {waiternow.common.StartRemoteLogsSessionActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.StartRemoteLogsSessionActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.StartRemoteLogsSessionActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.StartRemoteLogsSessionActionProto.Response
                 * @static
                 * @param {waiternow.common.StartRemoteLogsSessionActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.StartRemoteLogsSessionActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.StartRemoteLogsSessionActionProto.Response
                 * @static
                 * @param {waiternow.common.StartRemoteLogsSessionActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.StartRemoteLogsSessionActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.StartRemoteLogsSessionActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.StartRemoteLogsSessionActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.StartRemoteLogsSessionActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.StartRemoteLogsSessionActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.StartRemoteLogsSessionActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.StartRemoteLogsSessionActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.StartRemoteLogsSessionActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.StartRemoteLogsSessionActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.StartRemoteLogsSessionActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.StartRemoteLogsSessionActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.StartRemoteLogsSessionActionProto.Response
                 * @static
                 * @param {waiternow.common.StartRemoteLogsSessionActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.StartRemoteLogsSessionActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.StartRemoteLogsSessionActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.StartRemoteLogsSessionActionProto.Response";
                };

                return Response;
            })();

            return StartRemoteLogsSessionActionProto;
        })();

        common.GetEmailVerificationCodeActionProto = (function() {

            /**
             * Properties of a GetEmailVerificationCodeActionProto.
             * @memberof waiternow.common
             * @interface IGetEmailVerificationCodeActionProto
             */

            /**
             * Constructs a new GetEmailVerificationCodeActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a GetEmailVerificationCodeActionProto.
             * @implements IGetEmailVerificationCodeActionProto
             * @constructor
             * @param {waiternow.common.IGetEmailVerificationCodeActionProto=} [properties] Properties to set
             */
            function GetEmailVerificationCodeActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new GetEmailVerificationCodeActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.GetEmailVerificationCodeActionProto
             * @static
             * @param {waiternow.common.IGetEmailVerificationCodeActionProto=} [properties] Properties to set
             * @returns {waiternow.common.GetEmailVerificationCodeActionProto} GetEmailVerificationCodeActionProto instance
             */
            GetEmailVerificationCodeActionProto.create = function create(properties) {
                return new GetEmailVerificationCodeActionProto(properties);
            };

            /**
             * Encodes the specified GetEmailVerificationCodeActionProto message. Does not implicitly {@link waiternow.common.GetEmailVerificationCodeActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.GetEmailVerificationCodeActionProto
             * @static
             * @param {waiternow.common.IGetEmailVerificationCodeActionProto} message GetEmailVerificationCodeActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetEmailVerificationCodeActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified GetEmailVerificationCodeActionProto message, length delimited. Does not implicitly {@link waiternow.common.GetEmailVerificationCodeActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.GetEmailVerificationCodeActionProto
             * @static
             * @param {waiternow.common.IGetEmailVerificationCodeActionProto} message GetEmailVerificationCodeActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetEmailVerificationCodeActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetEmailVerificationCodeActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.GetEmailVerificationCodeActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.GetEmailVerificationCodeActionProto} GetEmailVerificationCodeActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetEmailVerificationCodeActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetEmailVerificationCodeActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetEmailVerificationCodeActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.GetEmailVerificationCodeActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.GetEmailVerificationCodeActionProto} GetEmailVerificationCodeActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetEmailVerificationCodeActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetEmailVerificationCodeActionProto message.
             * @function verify
             * @memberof waiternow.common.GetEmailVerificationCodeActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetEmailVerificationCodeActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a GetEmailVerificationCodeActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.GetEmailVerificationCodeActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.GetEmailVerificationCodeActionProto} GetEmailVerificationCodeActionProto
             */
            GetEmailVerificationCodeActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.GetEmailVerificationCodeActionProto)
                    return object;
                return new $root.waiternow.common.GetEmailVerificationCodeActionProto();
            };

            /**
             * Creates a plain object from a GetEmailVerificationCodeActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.GetEmailVerificationCodeActionProto
             * @static
             * @param {waiternow.common.GetEmailVerificationCodeActionProto} message GetEmailVerificationCodeActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetEmailVerificationCodeActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this GetEmailVerificationCodeActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.GetEmailVerificationCodeActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetEmailVerificationCodeActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for GetEmailVerificationCodeActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.GetEmailVerificationCodeActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            GetEmailVerificationCodeActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.GetEmailVerificationCodeActionProto";
            };

            GetEmailVerificationCodeActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.GetEmailVerificationCodeActionProto
                 * @interface IRequest
                 * @property {string|null} [email] Request email
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.GetEmailVerificationCodeActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.GetEmailVerificationCodeActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request email.
                 * @member {string} email
                 * @memberof waiternow.common.GetEmailVerificationCodeActionProto.Request
                 * @instance
                 */
                Request.prototype.email = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetEmailVerificationCodeActionProto.Request
                 * @static
                 * @param {waiternow.common.GetEmailVerificationCodeActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.GetEmailVerificationCodeActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.GetEmailVerificationCodeActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetEmailVerificationCodeActionProto.Request
                 * @static
                 * @param {waiternow.common.GetEmailVerificationCodeActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.GetEmailVerificationCodeActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetEmailVerificationCodeActionProto.Request
                 * @static
                 * @param {waiternow.common.GetEmailVerificationCodeActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetEmailVerificationCodeActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetEmailVerificationCodeActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetEmailVerificationCodeActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.email = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetEmailVerificationCodeActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetEmailVerificationCodeActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.GetEmailVerificationCodeActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.email != null && message.hasOwnProperty("email"))
                        if (!$util.isString(message.email))
                            return "email: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetEmailVerificationCodeActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetEmailVerificationCodeActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetEmailVerificationCodeActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.GetEmailVerificationCodeActionProto.Request();
                    if (object.email != null)
                        message.email = String(object.email);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetEmailVerificationCodeActionProto.Request
                 * @static
                 * @param {waiternow.common.GetEmailVerificationCodeActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.email = "";
                    if (message.email != null && message.hasOwnProperty("email"))
                        object.email = message.email;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetEmailVerificationCodeActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetEmailVerificationCodeActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetEmailVerificationCodeActionProto.Request";
                };

                return Request;
            })();

            GetEmailVerificationCodeActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.GetEmailVerificationCodeActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {string|null} [verificationCode] Response verificationCode
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.GetEmailVerificationCodeActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.GetEmailVerificationCodeActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.GetEmailVerificationCodeActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response verificationCode.
                 * @member {string} verificationCode
                 * @memberof waiternow.common.GetEmailVerificationCodeActionProto.Response
                 * @instance
                 */
                Response.prototype.verificationCode = "";

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetEmailVerificationCodeActionProto.Response
                 * @static
                 * @param {waiternow.common.GetEmailVerificationCodeActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.GetEmailVerificationCodeActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.GetEmailVerificationCodeActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetEmailVerificationCodeActionProto.Response
                 * @static
                 * @param {waiternow.common.GetEmailVerificationCodeActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.verificationCode != null && Object.hasOwnProperty.call(message, "verificationCode"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.verificationCode);
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.GetEmailVerificationCodeActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetEmailVerificationCodeActionProto.Response
                 * @static
                 * @param {waiternow.common.GetEmailVerificationCodeActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetEmailVerificationCodeActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetEmailVerificationCodeActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetEmailVerificationCodeActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.verificationCode = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetEmailVerificationCodeActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetEmailVerificationCodeActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.GetEmailVerificationCodeActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.verificationCode != null && message.hasOwnProperty("verificationCode"))
                        if (!$util.isString(message.verificationCode))
                            return "verificationCode: string expected";
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetEmailVerificationCodeActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetEmailVerificationCodeActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetEmailVerificationCodeActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.GetEmailVerificationCodeActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.GetEmailVerificationCodeActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.verificationCode != null)
                        message.verificationCode = String(object.verificationCode);
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetEmailVerificationCodeActionProto.Response
                 * @static
                 * @param {waiternow.common.GetEmailVerificationCodeActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.verificationCode = "";
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.verificationCode != null && message.hasOwnProperty("verificationCode"))
                        object.verificationCode = message.verificationCode;
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetEmailVerificationCodeActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetEmailVerificationCodeActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetEmailVerificationCodeActionProto.Response";
                };

                return Response;
            })();

            return GetEmailVerificationCodeActionProto;
        })();

        common.GetPhoneNumberVerificationCodeActionProto = (function() {

            /**
             * Properties of a GetPhoneNumberVerificationCodeActionProto.
             * @memberof waiternow.common
             * @interface IGetPhoneNumberVerificationCodeActionProto
             */

            /**
             * Constructs a new GetPhoneNumberVerificationCodeActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a GetPhoneNumberVerificationCodeActionProto.
             * @implements IGetPhoneNumberVerificationCodeActionProto
             * @constructor
             * @param {waiternow.common.IGetPhoneNumberVerificationCodeActionProto=} [properties] Properties to set
             */
            function GetPhoneNumberVerificationCodeActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new GetPhoneNumberVerificationCodeActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.GetPhoneNumberVerificationCodeActionProto
             * @static
             * @param {waiternow.common.IGetPhoneNumberVerificationCodeActionProto=} [properties] Properties to set
             * @returns {waiternow.common.GetPhoneNumberVerificationCodeActionProto} GetPhoneNumberVerificationCodeActionProto instance
             */
            GetPhoneNumberVerificationCodeActionProto.create = function create(properties) {
                return new GetPhoneNumberVerificationCodeActionProto(properties);
            };

            /**
             * Encodes the specified GetPhoneNumberVerificationCodeActionProto message. Does not implicitly {@link waiternow.common.GetPhoneNumberVerificationCodeActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.GetPhoneNumberVerificationCodeActionProto
             * @static
             * @param {waiternow.common.IGetPhoneNumberVerificationCodeActionProto} message GetPhoneNumberVerificationCodeActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetPhoneNumberVerificationCodeActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified GetPhoneNumberVerificationCodeActionProto message, length delimited. Does not implicitly {@link waiternow.common.GetPhoneNumberVerificationCodeActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.GetPhoneNumberVerificationCodeActionProto
             * @static
             * @param {waiternow.common.IGetPhoneNumberVerificationCodeActionProto} message GetPhoneNumberVerificationCodeActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetPhoneNumberVerificationCodeActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetPhoneNumberVerificationCodeActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.GetPhoneNumberVerificationCodeActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.GetPhoneNumberVerificationCodeActionProto} GetPhoneNumberVerificationCodeActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetPhoneNumberVerificationCodeActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetPhoneNumberVerificationCodeActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetPhoneNumberVerificationCodeActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.GetPhoneNumberVerificationCodeActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.GetPhoneNumberVerificationCodeActionProto} GetPhoneNumberVerificationCodeActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetPhoneNumberVerificationCodeActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetPhoneNumberVerificationCodeActionProto message.
             * @function verify
             * @memberof waiternow.common.GetPhoneNumberVerificationCodeActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetPhoneNumberVerificationCodeActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a GetPhoneNumberVerificationCodeActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.GetPhoneNumberVerificationCodeActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.GetPhoneNumberVerificationCodeActionProto} GetPhoneNumberVerificationCodeActionProto
             */
            GetPhoneNumberVerificationCodeActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.GetPhoneNumberVerificationCodeActionProto)
                    return object;
                return new $root.waiternow.common.GetPhoneNumberVerificationCodeActionProto();
            };

            /**
             * Creates a plain object from a GetPhoneNumberVerificationCodeActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.GetPhoneNumberVerificationCodeActionProto
             * @static
             * @param {waiternow.common.GetPhoneNumberVerificationCodeActionProto} message GetPhoneNumberVerificationCodeActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetPhoneNumberVerificationCodeActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this GetPhoneNumberVerificationCodeActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.GetPhoneNumberVerificationCodeActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetPhoneNumberVerificationCodeActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for GetPhoneNumberVerificationCodeActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.GetPhoneNumberVerificationCodeActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            GetPhoneNumberVerificationCodeActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.GetPhoneNumberVerificationCodeActionProto";
            };

            GetPhoneNumberVerificationCodeActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.GetPhoneNumberVerificationCodeActionProto
                 * @interface IRequest
                 * @property {waiternow.common.IPhoneNumberProto|null} [phoneNumber] Request phoneNumber
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.GetPhoneNumberVerificationCodeActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.GetPhoneNumberVerificationCodeActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request phoneNumber.
                 * @member {waiternow.common.IPhoneNumberProto|null|undefined} phoneNumber
                 * @memberof waiternow.common.GetPhoneNumberVerificationCodeActionProto.Request
                 * @instance
                 */
                Request.prototype.phoneNumber = null;

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetPhoneNumberVerificationCodeActionProto.Request
                 * @static
                 * @param {waiternow.common.GetPhoneNumberVerificationCodeActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.GetPhoneNumberVerificationCodeActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.GetPhoneNumberVerificationCodeActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetPhoneNumberVerificationCodeActionProto.Request
                 * @static
                 * @param {waiternow.common.GetPhoneNumberVerificationCodeActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.phoneNumber != null && Object.hasOwnProperty.call(message, "phoneNumber"))
                        $root.waiternow.common.PhoneNumberProto.encode(message.phoneNumber, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.GetPhoneNumberVerificationCodeActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetPhoneNumberVerificationCodeActionProto.Request
                 * @static
                 * @param {waiternow.common.GetPhoneNumberVerificationCodeActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetPhoneNumberVerificationCodeActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetPhoneNumberVerificationCodeActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetPhoneNumberVerificationCodeActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.phoneNumber = $root.waiternow.common.PhoneNumberProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetPhoneNumberVerificationCodeActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetPhoneNumberVerificationCodeActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.GetPhoneNumberVerificationCodeActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber")) {
                        var error = $root.waiternow.common.PhoneNumberProto.verify(message.phoneNumber);
                        if (error)
                            return "phoneNumber." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetPhoneNumberVerificationCodeActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetPhoneNumberVerificationCodeActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetPhoneNumberVerificationCodeActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.GetPhoneNumberVerificationCodeActionProto.Request();
                    if (object.phoneNumber != null) {
                        if (typeof object.phoneNumber !== "object")
                            throw TypeError(".waiternow.common.GetPhoneNumberVerificationCodeActionProto.Request.phoneNumber: object expected");
                        message.phoneNumber = $root.waiternow.common.PhoneNumberProto.fromObject(object.phoneNumber);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetPhoneNumberVerificationCodeActionProto.Request
                 * @static
                 * @param {waiternow.common.GetPhoneNumberVerificationCodeActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.phoneNumber = null;
                    if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
                        object.phoneNumber = $root.waiternow.common.PhoneNumberProto.toObject(message.phoneNumber, options);
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetPhoneNumberVerificationCodeActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetPhoneNumberVerificationCodeActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetPhoneNumberVerificationCodeActionProto.Request";
                };

                return Request;
            })();

            GetPhoneNumberVerificationCodeActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.GetPhoneNumberVerificationCodeActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {string|null} [verificationCode] Response verificationCode
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.GetPhoneNumberVerificationCodeActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.GetPhoneNumberVerificationCodeActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.GetPhoneNumberVerificationCodeActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response verificationCode.
                 * @member {string} verificationCode
                 * @memberof waiternow.common.GetPhoneNumberVerificationCodeActionProto.Response
                 * @instance
                 */
                Response.prototype.verificationCode = "";

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetPhoneNumberVerificationCodeActionProto.Response
                 * @static
                 * @param {waiternow.common.GetPhoneNumberVerificationCodeActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.GetPhoneNumberVerificationCodeActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.GetPhoneNumberVerificationCodeActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetPhoneNumberVerificationCodeActionProto.Response
                 * @static
                 * @param {waiternow.common.GetPhoneNumberVerificationCodeActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.verificationCode != null && Object.hasOwnProperty.call(message, "verificationCode"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.verificationCode);
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.GetPhoneNumberVerificationCodeActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetPhoneNumberVerificationCodeActionProto.Response
                 * @static
                 * @param {waiternow.common.GetPhoneNumberVerificationCodeActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetPhoneNumberVerificationCodeActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetPhoneNumberVerificationCodeActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetPhoneNumberVerificationCodeActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.verificationCode = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetPhoneNumberVerificationCodeActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetPhoneNumberVerificationCodeActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.GetPhoneNumberVerificationCodeActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.verificationCode != null && message.hasOwnProperty("verificationCode"))
                        if (!$util.isString(message.verificationCode))
                            return "verificationCode: string expected";
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetPhoneNumberVerificationCodeActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetPhoneNumberVerificationCodeActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetPhoneNumberVerificationCodeActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.GetPhoneNumberVerificationCodeActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.GetPhoneNumberVerificationCodeActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.verificationCode != null)
                        message.verificationCode = String(object.verificationCode);
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetPhoneNumberVerificationCodeActionProto.Response
                 * @static
                 * @param {waiternow.common.GetPhoneNumberVerificationCodeActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.verificationCode = "";
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.verificationCode != null && message.hasOwnProperty("verificationCode"))
                        object.verificationCode = message.verificationCode;
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetPhoneNumberVerificationCodeActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetPhoneNumberVerificationCodeActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetPhoneNumberVerificationCodeActionProto.Response";
                };

                return Response;
            })();

            return GetPhoneNumberVerificationCodeActionProto;
        })();

        common.FindMetricsActionProto = (function() {

            /**
             * Properties of a FindMetricsActionProto.
             * @memberof waiternow.common
             * @interface IFindMetricsActionProto
             */

            /**
             * Constructs a new FindMetricsActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a FindMetricsActionProto.
             * @implements IFindMetricsActionProto
             * @constructor
             * @param {waiternow.common.IFindMetricsActionProto=} [properties] Properties to set
             */
            function FindMetricsActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new FindMetricsActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FindMetricsActionProto
             * @static
             * @param {waiternow.common.IFindMetricsActionProto=} [properties] Properties to set
             * @returns {waiternow.common.FindMetricsActionProto} FindMetricsActionProto instance
             */
            FindMetricsActionProto.create = function create(properties) {
                return new FindMetricsActionProto(properties);
            };

            /**
             * Encodes the specified FindMetricsActionProto message. Does not implicitly {@link waiternow.common.FindMetricsActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FindMetricsActionProto
             * @static
             * @param {waiternow.common.IFindMetricsActionProto} message FindMetricsActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindMetricsActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified FindMetricsActionProto message, length delimited. Does not implicitly {@link waiternow.common.FindMetricsActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FindMetricsActionProto
             * @static
             * @param {waiternow.common.IFindMetricsActionProto} message FindMetricsActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindMetricsActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FindMetricsActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FindMetricsActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FindMetricsActionProto} FindMetricsActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindMetricsActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindMetricsActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FindMetricsActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FindMetricsActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FindMetricsActionProto} FindMetricsActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindMetricsActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FindMetricsActionProto message.
             * @function verify
             * @memberof waiternow.common.FindMetricsActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FindMetricsActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a FindMetricsActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FindMetricsActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FindMetricsActionProto} FindMetricsActionProto
             */
            FindMetricsActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FindMetricsActionProto)
                    return object;
                return new $root.waiternow.common.FindMetricsActionProto();
            };

            /**
             * Creates a plain object from a FindMetricsActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FindMetricsActionProto
             * @static
             * @param {waiternow.common.FindMetricsActionProto} message FindMetricsActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FindMetricsActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this FindMetricsActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FindMetricsActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FindMetricsActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FindMetricsActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.FindMetricsActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FindMetricsActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FindMetricsActionProto";
            };

            FindMetricsActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.FindMetricsActionProto
                 * @interface IRequest
                 * @property {waiternow.common.PeriodType|null} [periodType] Request periodType
                 * @property {waiternow.common.IDateProto|null} [afterDate] Request afterDate
                 * @property {waiternow.common.IDateProto|null} [beforeDate] Request beforeDate
                 * @property {waiternow.common.SortOrder|null} [sortOrder] Request sortOrder
                 * @property {string|null} [continuationToken] Request continuationToken
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.FindMetricsActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.FindMetricsActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request periodType.
                 * @member {waiternow.common.PeriodType} periodType
                 * @memberof waiternow.common.FindMetricsActionProto.Request
                 * @instance
                 */
                Request.prototype.periodType = 0;

                /**
                 * Request afterDate.
                 * @member {waiternow.common.IDateProto|null|undefined} afterDate
                 * @memberof waiternow.common.FindMetricsActionProto.Request
                 * @instance
                 */
                Request.prototype.afterDate = null;

                /**
                 * Request beforeDate.
                 * @member {waiternow.common.IDateProto|null|undefined} beforeDate
                 * @memberof waiternow.common.FindMetricsActionProto.Request
                 * @instance
                 */
                Request.prototype.beforeDate = null;

                /**
                 * Request sortOrder.
                 * @member {waiternow.common.SortOrder} sortOrder
                 * @memberof waiternow.common.FindMetricsActionProto.Request
                 * @instance
                 */
                Request.prototype.sortOrder = 0;

                /**
                 * Request continuationToken.
                 * @member {string} continuationToken
                 * @memberof waiternow.common.FindMetricsActionProto.Request
                 * @instance
                 */
                Request.prototype.continuationToken = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindMetricsActionProto.Request
                 * @static
                 * @param {waiternow.common.FindMetricsActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.FindMetricsActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.FindMetricsActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindMetricsActionProto.Request
                 * @static
                 * @param {waiternow.common.FindMetricsActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.periodType != null && Object.hasOwnProperty.call(message, "periodType"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.periodType);
                    if (message.afterDate != null && Object.hasOwnProperty.call(message, "afterDate"))
                        $root.waiternow.common.DateProto.encode(message.afterDate, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.beforeDate != null && Object.hasOwnProperty.call(message, "beforeDate"))
                        $root.waiternow.common.DateProto.encode(message.beforeDate, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.sortOrder != null && Object.hasOwnProperty.call(message, "sortOrder"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.sortOrder);
                    if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.continuationToken);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.FindMetricsActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindMetricsActionProto.Request
                 * @static
                 * @param {waiternow.common.FindMetricsActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindMetricsActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindMetricsActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindMetricsActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.periodType = reader.int32();
                                break;
                            }
                        case 2: {
                                message.afterDate = $root.waiternow.common.DateProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.beforeDate = $root.waiternow.common.DateProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 4: {
                                message.sortOrder = reader.int32();
                                break;
                            }
                        case 5: {
                                message.continuationToken = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindMetricsActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindMetricsActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.FindMetricsActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.periodType != null && message.hasOwnProperty("periodType"))
                        switch (message.periodType) {
                        default:
                            return "periodType: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                            break;
                        }
                    if (message.afterDate != null && message.hasOwnProperty("afterDate")) {
                        var error = $root.waiternow.common.DateProto.verify(message.afterDate);
                        if (error)
                            return "afterDate." + error;
                    }
                    if (message.beforeDate != null && message.hasOwnProperty("beforeDate")) {
                        var error = $root.waiternow.common.DateProto.verify(message.beforeDate);
                        if (error)
                            return "beforeDate." + error;
                    }
                    if (message.sortOrder != null && message.hasOwnProperty("sortOrder"))
                        switch (message.sortOrder) {
                        default:
                            return "sortOrder: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        if (!$util.isString(message.continuationToken))
                            return "continuationToken: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindMetricsActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindMetricsActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindMetricsActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.FindMetricsActionProto.Request();
                    switch (object.periodType) {
                    default:
                        if (typeof object.periodType === "number") {
                            message.periodType = object.periodType;
                            break;
                        }
                        break;
                    case "PERIOD_TYPE_UNSPECIFIED":
                    case 0:
                        message.periodType = 0;
                        break;
                    case "DAILY":
                    case 1:
                        message.periodType = 1;
                        break;
                    case "MONTHLY":
                    case 2:
                        message.periodType = 2;
                        break;
                    case "YEARLY":
                    case 3:
                        message.periodType = 3;
                        break;
                    }
                    if (object.afterDate != null) {
                        if (typeof object.afterDate !== "object")
                            throw TypeError(".waiternow.common.FindMetricsActionProto.Request.afterDate: object expected");
                        message.afterDate = $root.waiternow.common.DateProto.fromObject(object.afterDate);
                    }
                    if (object.beforeDate != null) {
                        if (typeof object.beforeDate !== "object")
                            throw TypeError(".waiternow.common.FindMetricsActionProto.Request.beforeDate: object expected");
                        message.beforeDate = $root.waiternow.common.DateProto.fromObject(object.beforeDate);
                    }
                    switch (object.sortOrder) {
                    default:
                        if (typeof object.sortOrder === "number") {
                            message.sortOrder = object.sortOrder;
                            break;
                        }
                        break;
                    case "SORT_ORDER_UNSPECIFIED":
                    case 0:
                        message.sortOrder = 0;
                        break;
                    case "ASCENDING":
                    case 1:
                        message.sortOrder = 1;
                        break;
                    case "DESCENDING":
                    case 2:
                        message.sortOrder = 2;
                        break;
                    }
                    if (object.continuationToken != null)
                        message.continuationToken = String(object.continuationToken);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindMetricsActionProto.Request
                 * @static
                 * @param {waiternow.common.FindMetricsActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.periodType = options.enums === String ? "PERIOD_TYPE_UNSPECIFIED" : 0;
                        object.afterDate = null;
                        object.beforeDate = null;
                        object.sortOrder = options.enums === String ? "SORT_ORDER_UNSPECIFIED" : 0;
                        object.continuationToken = "";
                    }
                    if (message.periodType != null && message.hasOwnProperty("periodType"))
                        object.periodType = options.enums === String ? $root.waiternow.common.PeriodType[message.periodType] === undefined ? message.periodType : $root.waiternow.common.PeriodType[message.periodType] : message.periodType;
                    if (message.afterDate != null && message.hasOwnProperty("afterDate"))
                        object.afterDate = $root.waiternow.common.DateProto.toObject(message.afterDate, options);
                    if (message.beforeDate != null && message.hasOwnProperty("beforeDate"))
                        object.beforeDate = $root.waiternow.common.DateProto.toObject(message.beforeDate, options);
                    if (message.sortOrder != null && message.hasOwnProperty("sortOrder"))
                        object.sortOrder = options.enums === String ? $root.waiternow.common.SortOrder[message.sortOrder] === undefined ? message.sortOrder : $root.waiternow.common.SortOrder[message.sortOrder] : message.sortOrder;
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        object.continuationToken = message.continuationToken;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindMetricsActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindMetricsActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindMetricsActionProto.Request";
                };

                return Request;
            })();

            FindMetricsActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.FindMetricsActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IMetricsProto|null} [metrics] Response metrics
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.FindMetricsActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.FindMetricsActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.FindMetricsActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response metrics.
                 * @member {waiternow.common.IMetricsProto|null|undefined} metrics
                 * @memberof waiternow.common.FindMetricsActionProto.Response
                 * @instance
                 */
                Response.prototype.metrics = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindMetricsActionProto.Response
                 * @static
                 * @param {waiternow.common.FindMetricsActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.FindMetricsActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.FindMetricsActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindMetricsActionProto.Response
                 * @static
                 * @param {waiternow.common.FindMetricsActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.metrics != null && Object.hasOwnProperty.call(message, "metrics"))
                        $root.waiternow.common.MetricsProto.encode(message.metrics, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.FindMetricsActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindMetricsActionProto.Response
                 * @static
                 * @param {waiternow.common.FindMetricsActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindMetricsActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindMetricsActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindMetricsActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.metrics = $root.waiternow.common.MetricsProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindMetricsActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindMetricsActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.FindMetricsActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.metrics != null && message.hasOwnProperty("metrics")) {
                        var error = $root.waiternow.common.MetricsProto.verify(message.metrics);
                        if (error)
                            return "metrics." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindMetricsActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindMetricsActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindMetricsActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.FindMetricsActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.FindMetricsActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.metrics != null) {
                        if (typeof object.metrics !== "object")
                            throw TypeError(".waiternow.common.FindMetricsActionProto.Response.metrics: object expected");
                        message.metrics = $root.waiternow.common.MetricsProto.fromObject(object.metrics);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindMetricsActionProto.Response
                 * @static
                 * @param {waiternow.common.FindMetricsActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.metrics = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.metrics != null && message.hasOwnProperty("metrics"))
                        object.metrics = $root.waiternow.common.MetricsProto.toObject(message.metrics, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindMetricsActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindMetricsActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindMetricsActionProto.Response";
                };

                return Response;
            })();

            return FindMetricsActionProto;
        })();

        common.FindPaidOrdersTopLocationsActionProto = (function() {

            /**
             * Properties of a FindPaidOrdersTopLocationsActionProto.
             * @memberof waiternow.common
             * @interface IFindPaidOrdersTopLocationsActionProto
             */

            /**
             * Constructs a new FindPaidOrdersTopLocationsActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a FindPaidOrdersTopLocationsActionProto.
             * @implements IFindPaidOrdersTopLocationsActionProto
             * @constructor
             * @param {waiternow.common.IFindPaidOrdersTopLocationsActionProto=} [properties] Properties to set
             */
            function FindPaidOrdersTopLocationsActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new FindPaidOrdersTopLocationsActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FindPaidOrdersTopLocationsActionProto
             * @static
             * @param {waiternow.common.IFindPaidOrdersTopLocationsActionProto=} [properties] Properties to set
             * @returns {waiternow.common.FindPaidOrdersTopLocationsActionProto} FindPaidOrdersTopLocationsActionProto instance
             */
            FindPaidOrdersTopLocationsActionProto.create = function create(properties) {
                return new FindPaidOrdersTopLocationsActionProto(properties);
            };

            /**
             * Encodes the specified FindPaidOrdersTopLocationsActionProto message. Does not implicitly {@link waiternow.common.FindPaidOrdersTopLocationsActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FindPaidOrdersTopLocationsActionProto
             * @static
             * @param {waiternow.common.IFindPaidOrdersTopLocationsActionProto} message FindPaidOrdersTopLocationsActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindPaidOrdersTopLocationsActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified FindPaidOrdersTopLocationsActionProto message, length delimited. Does not implicitly {@link waiternow.common.FindPaidOrdersTopLocationsActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FindPaidOrdersTopLocationsActionProto
             * @static
             * @param {waiternow.common.IFindPaidOrdersTopLocationsActionProto} message FindPaidOrdersTopLocationsActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindPaidOrdersTopLocationsActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FindPaidOrdersTopLocationsActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FindPaidOrdersTopLocationsActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FindPaidOrdersTopLocationsActionProto} FindPaidOrdersTopLocationsActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindPaidOrdersTopLocationsActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindPaidOrdersTopLocationsActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FindPaidOrdersTopLocationsActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FindPaidOrdersTopLocationsActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FindPaidOrdersTopLocationsActionProto} FindPaidOrdersTopLocationsActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindPaidOrdersTopLocationsActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FindPaidOrdersTopLocationsActionProto message.
             * @function verify
             * @memberof waiternow.common.FindPaidOrdersTopLocationsActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FindPaidOrdersTopLocationsActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a FindPaidOrdersTopLocationsActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FindPaidOrdersTopLocationsActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FindPaidOrdersTopLocationsActionProto} FindPaidOrdersTopLocationsActionProto
             */
            FindPaidOrdersTopLocationsActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FindPaidOrdersTopLocationsActionProto)
                    return object;
                return new $root.waiternow.common.FindPaidOrdersTopLocationsActionProto();
            };

            /**
             * Creates a plain object from a FindPaidOrdersTopLocationsActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FindPaidOrdersTopLocationsActionProto
             * @static
             * @param {waiternow.common.FindPaidOrdersTopLocationsActionProto} message FindPaidOrdersTopLocationsActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FindPaidOrdersTopLocationsActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this FindPaidOrdersTopLocationsActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FindPaidOrdersTopLocationsActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FindPaidOrdersTopLocationsActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FindPaidOrdersTopLocationsActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.FindPaidOrdersTopLocationsActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FindPaidOrdersTopLocationsActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FindPaidOrdersTopLocationsActionProto";
            };

            FindPaidOrdersTopLocationsActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.FindPaidOrdersTopLocationsActionProto
                 * @interface IRequest
                 * @property {number|null} [year] Request year
                 * @property {waiternow.common.Month|null} [month] Request month
                 * @property {number|null} [day] Request day
                 * @property {string|null} [continuationToken] Request continuationToken
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.FindPaidOrdersTopLocationsActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.FindPaidOrdersTopLocationsActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request year.
                 * @member {number} year
                 * @memberof waiternow.common.FindPaidOrdersTopLocationsActionProto.Request
                 * @instance
                 */
                Request.prototype.year = 0;

                /**
                 * Request month.
                 * @member {waiternow.common.Month} month
                 * @memberof waiternow.common.FindPaidOrdersTopLocationsActionProto.Request
                 * @instance
                 */
                Request.prototype.month = 0;

                /**
                 * Request day.
                 * @member {number} day
                 * @memberof waiternow.common.FindPaidOrdersTopLocationsActionProto.Request
                 * @instance
                 */
                Request.prototype.day = 0;

                /**
                 * Request continuationToken.
                 * @member {string} continuationToken
                 * @memberof waiternow.common.FindPaidOrdersTopLocationsActionProto.Request
                 * @instance
                 */
                Request.prototype.continuationToken = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindPaidOrdersTopLocationsActionProto.Request
                 * @static
                 * @param {waiternow.common.FindPaidOrdersTopLocationsActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.FindPaidOrdersTopLocationsActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.FindPaidOrdersTopLocationsActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindPaidOrdersTopLocationsActionProto.Request
                 * @static
                 * @param {waiternow.common.FindPaidOrdersTopLocationsActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.year != null && Object.hasOwnProperty.call(message, "year"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.year);
                    if (message.month != null && Object.hasOwnProperty.call(message, "month"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.month);
                    if (message.day != null && Object.hasOwnProperty.call(message, "day"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.day);
                    if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.continuationToken);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.FindPaidOrdersTopLocationsActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindPaidOrdersTopLocationsActionProto.Request
                 * @static
                 * @param {waiternow.common.FindPaidOrdersTopLocationsActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindPaidOrdersTopLocationsActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindPaidOrdersTopLocationsActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindPaidOrdersTopLocationsActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.year = reader.int32();
                                break;
                            }
                        case 2: {
                                message.month = reader.int32();
                                break;
                            }
                        case 3: {
                                message.day = reader.int32();
                                break;
                            }
                        case 4: {
                                message.continuationToken = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindPaidOrdersTopLocationsActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindPaidOrdersTopLocationsActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.FindPaidOrdersTopLocationsActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.year != null && message.hasOwnProperty("year"))
                        if (!$util.isInteger(message.year))
                            return "year: integer expected";
                    if (message.month != null && message.hasOwnProperty("month"))
                        switch (message.month) {
                        default:
                            return "month: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                        case 6:
                        case 7:
                        case 8:
                        case 9:
                        case 10:
                        case 11:
                        case 12:
                            break;
                        }
                    if (message.day != null && message.hasOwnProperty("day"))
                        if (!$util.isInteger(message.day))
                            return "day: integer expected";
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        if (!$util.isString(message.continuationToken))
                            return "continuationToken: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindPaidOrdersTopLocationsActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindPaidOrdersTopLocationsActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindPaidOrdersTopLocationsActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.FindPaidOrdersTopLocationsActionProto.Request();
                    if (object.year != null)
                        message.year = object.year | 0;
                    switch (object.month) {
                    default:
                        if (typeof object.month === "number") {
                            message.month = object.month;
                            break;
                        }
                        break;
                    case "MONTH_UNSPECIFIED":
                    case 0:
                        message.month = 0;
                        break;
                    case "JANUARY":
                    case 1:
                        message.month = 1;
                        break;
                    case "FEBRUARY":
                    case 2:
                        message.month = 2;
                        break;
                    case "MARCH":
                    case 3:
                        message.month = 3;
                        break;
                    case "APRIL":
                    case 4:
                        message.month = 4;
                        break;
                    case "MAY":
                    case 5:
                        message.month = 5;
                        break;
                    case "JUNE":
                    case 6:
                        message.month = 6;
                        break;
                    case "JULY":
                    case 7:
                        message.month = 7;
                        break;
                    case "AUGUST":
                    case 8:
                        message.month = 8;
                        break;
                    case "SEPTEMBER":
                    case 9:
                        message.month = 9;
                        break;
                    case "OCTOBER":
                    case 10:
                        message.month = 10;
                        break;
                    case "NOVEMBER":
                    case 11:
                        message.month = 11;
                        break;
                    case "DECEMBER":
                    case 12:
                        message.month = 12;
                        break;
                    }
                    if (object.day != null)
                        message.day = object.day | 0;
                    if (object.continuationToken != null)
                        message.continuationToken = String(object.continuationToken);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindPaidOrdersTopLocationsActionProto.Request
                 * @static
                 * @param {waiternow.common.FindPaidOrdersTopLocationsActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.year = 0;
                        object.month = options.enums === String ? "MONTH_UNSPECIFIED" : 0;
                        object.day = 0;
                        object.continuationToken = "";
                    }
                    if (message.year != null && message.hasOwnProperty("year"))
                        object.year = message.year;
                    if (message.month != null && message.hasOwnProperty("month"))
                        object.month = options.enums === String ? $root.waiternow.common.Month[message.month] === undefined ? message.month : $root.waiternow.common.Month[message.month] : message.month;
                    if (message.day != null && message.hasOwnProperty("day"))
                        object.day = message.day;
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        object.continuationToken = message.continuationToken;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindPaidOrdersTopLocationsActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindPaidOrdersTopLocationsActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindPaidOrdersTopLocationsActionProto.Request";
                };

                return Request;
            })();

            FindPaidOrdersTopLocationsActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.FindPaidOrdersTopLocationsActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.ILocationMetricsProto|null} [metrics] Response metrics
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.FindPaidOrdersTopLocationsActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.FindPaidOrdersTopLocationsActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.FindPaidOrdersTopLocationsActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response metrics.
                 * @member {waiternow.common.ILocationMetricsProto|null|undefined} metrics
                 * @memberof waiternow.common.FindPaidOrdersTopLocationsActionProto.Response
                 * @instance
                 */
                Response.prototype.metrics = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindPaidOrdersTopLocationsActionProto.Response
                 * @static
                 * @param {waiternow.common.FindPaidOrdersTopLocationsActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.FindPaidOrdersTopLocationsActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.FindPaidOrdersTopLocationsActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindPaidOrdersTopLocationsActionProto.Response
                 * @static
                 * @param {waiternow.common.FindPaidOrdersTopLocationsActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.metrics != null && Object.hasOwnProperty.call(message, "metrics"))
                        $root.waiternow.common.LocationMetricsProto.encode(message.metrics, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.FindPaidOrdersTopLocationsActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindPaidOrdersTopLocationsActionProto.Response
                 * @static
                 * @param {waiternow.common.FindPaidOrdersTopLocationsActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindPaidOrdersTopLocationsActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindPaidOrdersTopLocationsActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindPaidOrdersTopLocationsActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.metrics = $root.waiternow.common.LocationMetricsProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindPaidOrdersTopLocationsActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindPaidOrdersTopLocationsActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.FindPaidOrdersTopLocationsActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.metrics != null && message.hasOwnProperty("metrics")) {
                        var error = $root.waiternow.common.LocationMetricsProto.verify(message.metrics);
                        if (error)
                            return "metrics." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindPaidOrdersTopLocationsActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindPaidOrdersTopLocationsActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindPaidOrdersTopLocationsActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.FindPaidOrdersTopLocationsActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.FindPaidOrdersTopLocationsActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.metrics != null) {
                        if (typeof object.metrics !== "object")
                            throw TypeError(".waiternow.common.FindPaidOrdersTopLocationsActionProto.Response.metrics: object expected");
                        message.metrics = $root.waiternow.common.LocationMetricsProto.fromObject(object.metrics);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindPaidOrdersTopLocationsActionProto.Response
                 * @static
                 * @param {waiternow.common.FindPaidOrdersTopLocationsActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.metrics = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.metrics != null && message.hasOwnProperty("metrics"))
                        object.metrics = $root.waiternow.common.LocationMetricsProto.toObject(message.metrics, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindPaidOrdersTopLocationsActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindPaidOrdersTopLocationsActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindPaidOrdersTopLocationsActionProto.Response";
                };

                return Response;
            })();

            return FindPaidOrdersTopLocationsActionProto;
        })();

        common.FindPaidOrdersTopBusinessesActionProto = (function() {

            /**
             * Properties of a FindPaidOrdersTopBusinessesActionProto.
             * @memberof waiternow.common
             * @interface IFindPaidOrdersTopBusinessesActionProto
             */

            /**
             * Constructs a new FindPaidOrdersTopBusinessesActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a FindPaidOrdersTopBusinessesActionProto.
             * @implements IFindPaidOrdersTopBusinessesActionProto
             * @constructor
             * @param {waiternow.common.IFindPaidOrdersTopBusinessesActionProto=} [properties] Properties to set
             */
            function FindPaidOrdersTopBusinessesActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new FindPaidOrdersTopBusinessesActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FindPaidOrdersTopBusinessesActionProto
             * @static
             * @param {waiternow.common.IFindPaidOrdersTopBusinessesActionProto=} [properties] Properties to set
             * @returns {waiternow.common.FindPaidOrdersTopBusinessesActionProto} FindPaidOrdersTopBusinessesActionProto instance
             */
            FindPaidOrdersTopBusinessesActionProto.create = function create(properties) {
                return new FindPaidOrdersTopBusinessesActionProto(properties);
            };

            /**
             * Encodes the specified FindPaidOrdersTopBusinessesActionProto message. Does not implicitly {@link waiternow.common.FindPaidOrdersTopBusinessesActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FindPaidOrdersTopBusinessesActionProto
             * @static
             * @param {waiternow.common.IFindPaidOrdersTopBusinessesActionProto} message FindPaidOrdersTopBusinessesActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindPaidOrdersTopBusinessesActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified FindPaidOrdersTopBusinessesActionProto message, length delimited. Does not implicitly {@link waiternow.common.FindPaidOrdersTopBusinessesActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FindPaidOrdersTopBusinessesActionProto
             * @static
             * @param {waiternow.common.IFindPaidOrdersTopBusinessesActionProto} message FindPaidOrdersTopBusinessesActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindPaidOrdersTopBusinessesActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FindPaidOrdersTopBusinessesActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FindPaidOrdersTopBusinessesActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FindPaidOrdersTopBusinessesActionProto} FindPaidOrdersTopBusinessesActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindPaidOrdersTopBusinessesActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindPaidOrdersTopBusinessesActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FindPaidOrdersTopBusinessesActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FindPaidOrdersTopBusinessesActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FindPaidOrdersTopBusinessesActionProto} FindPaidOrdersTopBusinessesActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindPaidOrdersTopBusinessesActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FindPaidOrdersTopBusinessesActionProto message.
             * @function verify
             * @memberof waiternow.common.FindPaidOrdersTopBusinessesActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FindPaidOrdersTopBusinessesActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a FindPaidOrdersTopBusinessesActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FindPaidOrdersTopBusinessesActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FindPaidOrdersTopBusinessesActionProto} FindPaidOrdersTopBusinessesActionProto
             */
            FindPaidOrdersTopBusinessesActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FindPaidOrdersTopBusinessesActionProto)
                    return object;
                return new $root.waiternow.common.FindPaidOrdersTopBusinessesActionProto();
            };

            /**
             * Creates a plain object from a FindPaidOrdersTopBusinessesActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FindPaidOrdersTopBusinessesActionProto
             * @static
             * @param {waiternow.common.FindPaidOrdersTopBusinessesActionProto} message FindPaidOrdersTopBusinessesActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FindPaidOrdersTopBusinessesActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this FindPaidOrdersTopBusinessesActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FindPaidOrdersTopBusinessesActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FindPaidOrdersTopBusinessesActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FindPaidOrdersTopBusinessesActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.FindPaidOrdersTopBusinessesActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FindPaidOrdersTopBusinessesActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FindPaidOrdersTopBusinessesActionProto";
            };

            FindPaidOrdersTopBusinessesActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.FindPaidOrdersTopBusinessesActionProto
                 * @interface IRequest
                 * @property {number|null} [year] Request year
                 * @property {waiternow.common.Month|null} [month] Request month
                 * @property {number|null} [day] Request day
                 * @property {string|null} [continuationToken] Request continuationToken
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.FindPaidOrdersTopBusinessesActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.FindPaidOrdersTopBusinessesActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request year.
                 * @member {number} year
                 * @memberof waiternow.common.FindPaidOrdersTopBusinessesActionProto.Request
                 * @instance
                 */
                Request.prototype.year = 0;

                /**
                 * Request month.
                 * @member {waiternow.common.Month} month
                 * @memberof waiternow.common.FindPaidOrdersTopBusinessesActionProto.Request
                 * @instance
                 */
                Request.prototype.month = 0;

                /**
                 * Request day.
                 * @member {number} day
                 * @memberof waiternow.common.FindPaidOrdersTopBusinessesActionProto.Request
                 * @instance
                 */
                Request.prototype.day = 0;

                /**
                 * Request continuationToken.
                 * @member {string} continuationToken
                 * @memberof waiternow.common.FindPaidOrdersTopBusinessesActionProto.Request
                 * @instance
                 */
                Request.prototype.continuationToken = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindPaidOrdersTopBusinessesActionProto.Request
                 * @static
                 * @param {waiternow.common.FindPaidOrdersTopBusinessesActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.FindPaidOrdersTopBusinessesActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.FindPaidOrdersTopBusinessesActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindPaidOrdersTopBusinessesActionProto.Request
                 * @static
                 * @param {waiternow.common.FindPaidOrdersTopBusinessesActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.year != null && Object.hasOwnProperty.call(message, "year"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.year);
                    if (message.month != null && Object.hasOwnProperty.call(message, "month"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.month);
                    if (message.day != null && Object.hasOwnProperty.call(message, "day"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.day);
                    if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.continuationToken);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.FindPaidOrdersTopBusinessesActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindPaidOrdersTopBusinessesActionProto.Request
                 * @static
                 * @param {waiternow.common.FindPaidOrdersTopBusinessesActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindPaidOrdersTopBusinessesActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindPaidOrdersTopBusinessesActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindPaidOrdersTopBusinessesActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.year = reader.int32();
                                break;
                            }
                        case 2: {
                                message.month = reader.int32();
                                break;
                            }
                        case 3: {
                                message.day = reader.int32();
                                break;
                            }
                        case 4: {
                                message.continuationToken = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindPaidOrdersTopBusinessesActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindPaidOrdersTopBusinessesActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.FindPaidOrdersTopBusinessesActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.year != null && message.hasOwnProperty("year"))
                        if (!$util.isInteger(message.year))
                            return "year: integer expected";
                    if (message.month != null && message.hasOwnProperty("month"))
                        switch (message.month) {
                        default:
                            return "month: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                        case 6:
                        case 7:
                        case 8:
                        case 9:
                        case 10:
                        case 11:
                        case 12:
                            break;
                        }
                    if (message.day != null && message.hasOwnProperty("day"))
                        if (!$util.isInteger(message.day))
                            return "day: integer expected";
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        if (!$util.isString(message.continuationToken))
                            return "continuationToken: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindPaidOrdersTopBusinessesActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindPaidOrdersTopBusinessesActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindPaidOrdersTopBusinessesActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.FindPaidOrdersTopBusinessesActionProto.Request();
                    if (object.year != null)
                        message.year = object.year | 0;
                    switch (object.month) {
                    default:
                        if (typeof object.month === "number") {
                            message.month = object.month;
                            break;
                        }
                        break;
                    case "MONTH_UNSPECIFIED":
                    case 0:
                        message.month = 0;
                        break;
                    case "JANUARY":
                    case 1:
                        message.month = 1;
                        break;
                    case "FEBRUARY":
                    case 2:
                        message.month = 2;
                        break;
                    case "MARCH":
                    case 3:
                        message.month = 3;
                        break;
                    case "APRIL":
                    case 4:
                        message.month = 4;
                        break;
                    case "MAY":
                    case 5:
                        message.month = 5;
                        break;
                    case "JUNE":
                    case 6:
                        message.month = 6;
                        break;
                    case "JULY":
                    case 7:
                        message.month = 7;
                        break;
                    case "AUGUST":
                    case 8:
                        message.month = 8;
                        break;
                    case "SEPTEMBER":
                    case 9:
                        message.month = 9;
                        break;
                    case "OCTOBER":
                    case 10:
                        message.month = 10;
                        break;
                    case "NOVEMBER":
                    case 11:
                        message.month = 11;
                        break;
                    case "DECEMBER":
                    case 12:
                        message.month = 12;
                        break;
                    }
                    if (object.day != null)
                        message.day = object.day | 0;
                    if (object.continuationToken != null)
                        message.continuationToken = String(object.continuationToken);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindPaidOrdersTopBusinessesActionProto.Request
                 * @static
                 * @param {waiternow.common.FindPaidOrdersTopBusinessesActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.year = 0;
                        object.month = options.enums === String ? "MONTH_UNSPECIFIED" : 0;
                        object.day = 0;
                        object.continuationToken = "";
                    }
                    if (message.year != null && message.hasOwnProperty("year"))
                        object.year = message.year;
                    if (message.month != null && message.hasOwnProperty("month"))
                        object.month = options.enums === String ? $root.waiternow.common.Month[message.month] === undefined ? message.month : $root.waiternow.common.Month[message.month] : message.month;
                    if (message.day != null && message.hasOwnProperty("day"))
                        object.day = message.day;
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        object.continuationToken = message.continuationToken;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindPaidOrdersTopBusinessesActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindPaidOrdersTopBusinessesActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindPaidOrdersTopBusinessesActionProto.Request";
                };

                return Request;
            })();

            FindPaidOrdersTopBusinessesActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.FindPaidOrdersTopBusinessesActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IBusinessMetricsProto|null} [metrics] Response metrics
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.FindPaidOrdersTopBusinessesActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.FindPaidOrdersTopBusinessesActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.FindPaidOrdersTopBusinessesActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response metrics.
                 * @member {waiternow.common.IBusinessMetricsProto|null|undefined} metrics
                 * @memberof waiternow.common.FindPaidOrdersTopBusinessesActionProto.Response
                 * @instance
                 */
                Response.prototype.metrics = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindPaidOrdersTopBusinessesActionProto.Response
                 * @static
                 * @param {waiternow.common.FindPaidOrdersTopBusinessesActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.FindPaidOrdersTopBusinessesActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.FindPaidOrdersTopBusinessesActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindPaidOrdersTopBusinessesActionProto.Response
                 * @static
                 * @param {waiternow.common.FindPaidOrdersTopBusinessesActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.metrics != null && Object.hasOwnProperty.call(message, "metrics"))
                        $root.waiternow.common.BusinessMetricsProto.encode(message.metrics, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.FindPaidOrdersTopBusinessesActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindPaidOrdersTopBusinessesActionProto.Response
                 * @static
                 * @param {waiternow.common.FindPaidOrdersTopBusinessesActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindPaidOrdersTopBusinessesActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindPaidOrdersTopBusinessesActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindPaidOrdersTopBusinessesActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.metrics = $root.waiternow.common.BusinessMetricsProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindPaidOrdersTopBusinessesActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindPaidOrdersTopBusinessesActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.FindPaidOrdersTopBusinessesActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.metrics != null && message.hasOwnProperty("metrics")) {
                        var error = $root.waiternow.common.BusinessMetricsProto.verify(message.metrics);
                        if (error)
                            return "metrics." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindPaidOrdersTopBusinessesActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindPaidOrdersTopBusinessesActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindPaidOrdersTopBusinessesActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.FindPaidOrdersTopBusinessesActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.FindPaidOrdersTopBusinessesActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.metrics != null) {
                        if (typeof object.metrics !== "object")
                            throw TypeError(".waiternow.common.FindPaidOrdersTopBusinessesActionProto.Response.metrics: object expected");
                        message.metrics = $root.waiternow.common.BusinessMetricsProto.fromObject(object.metrics);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindPaidOrdersTopBusinessesActionProto.Response
                 * @static
                 * @param {waiternow.common.FindPaidOrdersTopBusinessesActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.metrics = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.metrics != null && message.hasOwnProperty("metrics"))
                        object.metrics = $root.waiternow.common.BusinessMetricsProto.toObject(message.metrics, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindPaidOrdersTopBusinessesActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindPaidOrdersTopBusinessesActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindPaidOrdersTopBusinessesActionProto.Response";
                };

                return Response;
            })();

            return FindPaidOrdersTopBusinessesActionProto;
        })();

        common.FindPaidOrdersByEmailActionProto = (function() {

            /**
             * Properties of a FindPaidOrdersByEmailActionProto.
             * @memberof waiternow.common
             * @interface IFindPaidOrdersByEmailActionProto
             */

            /**
             * Constructs a new FindPaidOrdersByEmailActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a FindPaidOrdersByEmailActionProto.
             * @implements IFindPaidOrdersByEmailActionProto
             * @constructor
             * @param {waiternow.common.IFindPaidOrdersByEmailActionProto=} [properties] Properties to set
             */
            function FindPaidOrdersByEmailActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new FindPaidOrdersByEmailActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FindPaidOrdersByEmailActionProto
             * @static
             * @param {waiternow.common.IFindPaidOrdersByEmailActionProto=} [properties] Properties to set
             * @returns {waiternow.common.FindPaidOrdersByEmailActionProto} FindPaidOrdersByEmailActionProto instance
             */
            FindPaidOrdersByEmailActionProto.create = function create(properties) {
                return new FindPaidOrdersByEmailActionProto(properties);
            };

            /**
             * Encodes the specified FindPaidOrdersByEmailActionProto message. Does not implicitly {@link waiternow.common.FindPaidOrdersByEmailActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FindPaidOrdersByEmailActionProto
             * @static
             * @param {waiternow.common.IFindPaidOrdersByEmailActionProto} message FindPaidOrdersByEmailActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindPaidOrdersByEmailActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified FindPaidOrdersByEmailActionProto message, length delimited. Does not implicitly {@link waiternow.common.FindPaidOrdersByEmailActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FindPaidOrdersByEmailActionProto
             * @static
             * @param {waiternow.common.IFindPaidOrdersByEmailActionProto} message FindPaidOrdersByEmailActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindPaidOrdersByEmailActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FindPaidOrdersByEmailActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FindPaidOrdersByEmailActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FindPaidOrdersByEmailActionProto} FindPaidOrdersByEmailActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindPaidOrdersByEmailActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindPaidOrdersByEmailActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FindPaidOrdersByEmailActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FindPaidOrdersByEmailActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FindPaidOrdersByEmailActionProto} FindPaidOrdersByEmailActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindPaidOrdersByEmailActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FindPaidOrdersByEmailActionProto message.
             * @function verify
             * @memberof waiternow.common.FindPaidOrdersByEmailActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FindPaidOrdersByEmailActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a FindPaidOrdersByEmailActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FindPaidOrdersByEmailActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FindPaidOrdersByEmailActionProto} FindPaidOrdersByEmailActionProto
             */
            FindPaidOrdersByEmailActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FindPaidOrdersByEmailActionProto)
                    return object;
                return new $root.waiternow.common.FindPaidOrdersByEmailActionProto();
            };

            /**
             * Creates a plain object from a FindPaidOrdersByEmailActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FindPaidOrdersByEmailActionProto
             * @static
             * @param {waiternow.common.FindPaidOrdersByEmailActionProto} message FindPaidOrdersByEmailActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FindPaidOrdersByEmailActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this FindPaidOrdersByEmailActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FindPaidOrdersByEmailActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FindPaidOrdersByEmailActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FindPaidOrdersByEmailActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.FindPaidOrdersByEmailActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FindPaidOrdersByEmailActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FindPaidOrdersByEmailActionProto";
            };

            FindPaidOrdersByEmailActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.FindPaidOrdersByEmailActionProto
                 * @interface IRequest
                 * @property {string|null} [email] Request email
                 * @property {string|null} [continuationToken] Request continuationToken
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.FindPaidOrdersByEmailActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.FindPaidOrdersByEmailActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request email.
                 * @member {string} email
                 * @memberof waiternow.common.FindPaidOrdersByEmailActionProto.Request
                 * @instance
                 */
                Request.prototype.email = "";

                /**
                 * Request continuationToken.
                 * @member {string} continuationToken
                 * @memberof waiternow.common.FindPaidOrdersByEmailActionProto.Request
                 * @instance
                 */
                Request.prototype.continuationToken = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindPaidOrdersByEmailActionProto.Request
                 * @static
                 * @param {waiternow.common.FindPaidOrdersByEmailActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.FindPaidOrdersByEmailActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.FindPaidOrdersByEmailActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindPaidOrdersByEmailActionProto.Request
                 * @static
                 * @param {waiternow.common.FindPaidOrdersByEmailActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
                    if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.continuationToken);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.FindPaidOrdersByEmailActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindPaidOrdersByEmailActionProto.Request
                 * @static
                 * @param {waiternow.common.FindPaidOrdersByEmailActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindPaidOrdersByEmailActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindPaidOrdersByEmailActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindPaidOrdersByEmailActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.email = reader.string();
                                break;
                            }
                        case 2: {
                                message.continuationToken = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindPaidOrdersByEmailActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindPaidOrdersByEmailActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.FindPaidOrdersByEmailActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.email != null && message.hasOwnProperty("email"))
                        if (!$util.isString(message.email))
                            return "email: string expected";
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        if (!$util.isString(message.continuationToken))
                            return "continuationToken: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindPaidOrdersByEmailActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindPaidOrdersByEmailActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindPaidOrdersByEmailActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.FindPaidOrdersByEmailActionProto.Request();
                    if (object.email != null)
                        message.email = String(object.email);
                    if (object.continuationToken != null)
                        message.continuationToken = String(object.continuationToken);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindPaidOrdersByEmailActionProto.Request
                 * @static
                 * @param {waiternow.common.FindPaidOrdersByEmailActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.email = "";
                        object.continuationToken = "";
                    }
                    if (message.email != null && message.hasOwnProperty("email"))
                        object.email = message.email;
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        object.continuationToken = message.continuationToken;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindPaidOrdersByEmailActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindPaidOrdersByEmailActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindPaidOrdersByEmailActionProto.Request";
                };

                return Request;
            })();

            FindPaidOrdersByEmailActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.FindPaidOrdersByEmailActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IOrdersProto|null} [orders] Response orders
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.FindPaidOrdersByEmailActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.FindPaidOrdersByEmailActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.FindPaidOrdersByEmailActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response orders.
                 * @member {waiternow.common.IOrdersProto|null|undefined} orders
                 * @memberof waiternow.common.FindPaidOrdersByEmailActionProto.Response
                 * @instance
                 */
                Response.prototype.orders = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindPaidOrdersByEmailActionProto.Response
                 * @static
                 * @param {waiternow.common.FindPaidOrdersByEmailActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.FindPaidOrdersByEmailActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.FindPaidOrdersByEmailActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindPaidOrdersByEmailActionProto.Response
                 * @static
                 * @param {waiternow.common.FindPaidOrdersByEmailActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.orders != null && Object.hasOwnProperty.call(message, "orders"))
                        $root.waiternow.common.OrdersProto.encode(message.orders, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.FindPaidOrdersByEmailActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindPaidOrdersByEmailActionProto.Response
                 * @static
                 * @param {waiternow.common.FindPaidOrdersByEmailActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindPaidOrdersByEmailActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindPaidOrdersByEmailActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindPaidOrdersByEmailActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.orders = $root.waiternow.common.OrdersProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindPaidOrdersByEmailActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindPaidOrdersByEmailActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.FindPaidOrdersByEmailActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.orders != null && message.hasOwnProperty("orders")) {
                        var error = $root.waiternow.common.OrdersProto.verify(message.orders);
                        if (error)
                            return "orders." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindPaidOrdersByEmailActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindPaidOrdersByEmailActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindPaidOrdersByEmailActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.FindPaidOrdersByEmailActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.FindPaidOrdersByEmailActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.orders != null) {
                        if (typeof object.orders !== "object")
                            throw TypeError(".waiternow.common.FindPaidOrdersByEmailActionProto.Response.orders: object expected");
                        message.orders = $root.waiternow.common.OrdersProto.fromObject(object.orders);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindPaidOrdersByEmailActionProto.Response
                 * @static
                 * @param {waiternow.common.FindPaidOrdersByEmailActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.orders = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.orders != null && message.hasOwnProperty("orders"))
                        object.orders = $root.waiternow.common.OrdersProto.toObject(message.orders, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindPaidOrdersByEmailActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindPaidOrdersByEmailActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindPaidOrdersByEmailActionProto.Response";
                };

                return Response;
            })();

            return FindPaidOrdersByEmailActionProto;
        })();

        common.FindPaidOrdersByPhoneActionProto = (function() {

            /**
             * Properties of a FindPaidOrdersByPhoneActionProto.
             * @memberof waiternow.common
             * @interface IFindPaidOrdersByPhoneActionProto
             */

            /**
             * Constructs a new FindPaidOrdersByPhoneActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a FindPaidOrdersByPhoneActionProto.
             * @implements IFindPaidOrdersByPhoneActionProto
             * @constructor
             * @param {waiternow.common.IFindPaidOrdersByPhoneActionProto=} [properties] Properties to set
             */
            function FindPaidOrdersByPhoneActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new FindPaidOrdersByPhoneActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FindPaidOrdersByPhoneActionProto
             * @static
             * @param {waiternow.common.IFindPaidOrdersByPhoneActionProto=} [properties] Properties to set
             * @returns {waiternow.common.FindPaidOrdersByPhoneActionProto} FindPaidOrdersByPhoneActionProto instance
             */
            FindPaidOrdersByPhoneActionProto.create = function create(properties) {
                return new FindPaidOrdersByPhoneActionProto(properties);
            };

            /**
             * Encodes the specified FindPaidOrdersByPhoneActionProto message. Does not implicitly {@link waiternow.common.FindPaidOrdersByPhoneActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FindPaidOrdersByPhoneActionProto
             * @static
             * @param {waiternow.common.IFindPaidOrdersByPhoneActionProto} message FindPaidOrdersByPhoneActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindPaidOrdersByPhoneActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified FindPaidOrdersByPhoneActionProto message, length delimited. Does not implicitly {@link waiternow.common.FindPaidOrdersByPhoneActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FindPaidOrdersByPhoneActionProto
             * @static
             * @param {waiternow.common.IFindPaidOrdersByPhoneActionProto} message FindPaidOrdersByPhoneActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindPaidOrdersByPhoneActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FindPaidOrdersByPhoneActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FindPaidOrdersByPhoneActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FindPaidOrdersByPhoneActionProto} FindPaidOrdersByPhoneActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindPaidOrdersByPhoneActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindPaidOrdersByPhoneActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FindPaidOrdersByPhoneActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FindPaidOrdersByPhoneActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FindPaidOrdersByPhoneActionProto} FindPaidOrdersByPhoneActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindPaidOrdersByPhoneActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FindPaidOrdersByPhoneActionProto message.
             * @function verify
             * @memberof waiternow.common.FindPaidOrdersByPhoneActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FindPaidOrdersByPhoneActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a FindPaidOrdersByPhoneActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FindPaidOrdersByPhoneActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FindPaidOrdersByPhoneActionProto} FindPaidOrdersByPhoneActionProto
             */
            FindPaidOrdersByPhoneActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FindPaidOrdersByPhoneActionProto)
                    return object;
                return new $root.waiternow.common.FindPaidOrdersByPhoneActionProto();
            };

            /**
             * Creates a plain object from a FindPaidOrdersByPhoneActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FindPaidOrdersByPhoneActionProto
             * @static
             * @param {waiternow.common.FindPaidOrdersByPhoneActionProto} message FindPaidOrdersByPhoneActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FindPaidOrdersByPhoneActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this FindPaidOrdersByPhoneActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FindPaidOrdersByPhoneActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FindPaidOrdersByPhoneActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FindPaidOrdersByPhoneActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.FindPaidOrdersByPhoneActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FindPaidOrdersByPhoneActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FindPaidOrdersByPhoneActionProto";
            };

            FindPaidOrdersByPhoneActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.FindPaidOrdersByPhoneActionProto
                 * @interface IRequest
                 * @property {string|null} [phoneNumber] Request phoneNumber
                 * @property {string|null} [continuationToken] Request continuationToken
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.FindPaidOrdersByPhoneActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.FindPaidOrdersByPhoneActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request phoneNumber.
                 * @member {string} phoneNumber
                 * @memberof waiternow.common.FindPaidOrdersByPhoneActionProto.Request
                 * @instance
                 */
                Request.prototype.phoneNumber = "";

                /**
                 * Request continuationToken.
                 * @member {string} continuationToken
                 * @memberof waiternow.common.FindPaidOrdersByPhoneActionProto.Request
                 * @instance
                 */
                Request.prototype.continuationToken = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindPaidOrdersByPhoneActionProto.Request
                 * @static
                 * @param {waiternow.common.FindPaidOrdersByPhoneActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.FindPaidOrdersByPhoneActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.FindPaidOrdersByPhoneActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindPaidOrdersByPhoneActionProto.Request
                 * @static
                 * @param {waiternow.common.FindPaidOrdersByPhoneActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.phoneNumber != null && Object.hasOwnProperty.call(message, "phoneNumber"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.phoneNumber);
                    if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.continuationToken);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.FindPaidOrdersByPhoneActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindPaidOrdersByPhoneActionProto.Request
                 * @static
                 * @param {waiternow.common.FindPaidOrdersByPhoneActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindPaidOrdersByPhoneActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindPaidOrdersByPhoneActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindPaidOrdersByPhoneActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.phoneNumber = reader.string();
                                break;
                            }
                        case 2: {
                                message.continuationToken = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindPaidOrdersByPhoneActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindPaidOrdersByPhoneActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.FindPaidOrdersByPhoneActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
                        if (!$util.isString(message.phoneNumber))
                            return "phoneNumber: string expected";
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        if (!$util.isString(message.continuationToken))
                            return "continuationToken: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindPaidOrdersByPhoneActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindPaidOrdersByPhoneActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindPaidOrdersByPhoneActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.FindPaidOrdersByPhoneActionProto.Request();
                    if (object.phoneNumber != null)
                        message.phoneNumber = String(object.phoneNumber);
                    if (object.continuationToken != null)
                        message.continuationToken = String(object.continuationToken);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindPaidOrdersByPhoneActionProto.Request
                 * @static
                 * @param {waiternow.common.FindPaidOrdersByPhoneActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.phoneNumber = "";
                        object.continuationToken = "";
                    }
                    if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
                        object.phoneNumber = message.phoneNumber;
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        object.continuationToken = message.continuationToken;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindPaidOrdersByPhoneActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindPaidOrdersByPhoneActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindPaidOrdersByPhoneActionProto.Request";
                };

                return Request;
            })();

            FindPaidOrdersByPhoneActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.FindPaidOrdersByPhoneActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IOrdersProto|null} [orders] Response orders
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.FindPaidOrdersByPhoneActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.FindPaidOrdersByPhoneActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.FindPaidOrdersByPhoneActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response orders.
                 * @member {waiternow.common.IOrdersProto|null|undefined} orders
                 * @memberof waiternow.common.FindPaidOrdersByPhoneActionProto.Response
                 * @instance
                 */
                Response.prototype.orders = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindPaidOrdersByPhoneActionProto.Response
                 * @static
                 * @param {waiternow.common.FindPaidOrdersByPhoneActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.FindPaidOrdersByPhoneActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.FindPaidOrdersByPhoneActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindPaidOrdersByPhoneActionProto.Response
                 * @static
                 * @param {waiternow.common.FindPaidOrdersByPhoneActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.orders != null && Object.hasOwnProperty.call(message, "orders"))
                        $root.waiternow.common.OrdersProto.encode(message.orders, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.FindPaidOrdersByPhoneActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindPaidOrdersByPhoneActionProto.Response
                 * @static
                 * @param {waiternow.common.FindPaidOrdersByPhoneActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindPaidOrdersByPhoneActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindPaidOrdersByPhoneActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindPaidOrdersByPhoneActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.orders = $root.waiternow.common.OrdersProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindPaidOrdersByPhoneActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindPaidOrdersByPhoneActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.FindPaidOrdersByPhoneActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.orders != null && message.hasOwnProperty("orders")) {
                        var error = $root.waiternow.common.OrdersProto.verify(message.orders);
                        if (error)
                            return "orders." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindPaidOrdersByPhoneActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindPaidOrdersByPhoneActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindPaidOrdersByPhoneActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.FindPaidOrdersByPhoneActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.FindPaidOrdersByPhoneActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.orders != null) {
                        if (typeof object.orders !== "object")
                            throw TypeError(".waiternow.common.FindPaidOrdersByPhoneActionProto.Response.orders: object expected");
                        message.orders = $root.waiternow.common.OrdersProto.fromObject(object.orders);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindPaidOrdersByPhoneActionProto.Response
                 * @static
                 * @param {waiternow.common.FindPaidOrdersByPhoneActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.orders = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.orders != null && message.hasOwnProperty("orders"))
                        object.orders = $root.waiternow.common.OrdersProto.toObject(message.orders, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindPaidOrdersByPhoneActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindPaidOrdersByPhoneActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindPaidOrdersByPhoneActionProto.Response";
                };

                return Response;
            })();

            return FindPaidOrdersByPhoneActionProto;
        })();

        common.GetLocationTaxesActionProto = (function() {

            /**
             * Properties of a GetLocationTaxesActionProto.
             * @memberof waiternow.common
             * @interface IGetLocationTaxesActionProto
             */

            /**
             * Constructs a new GetLocationTaxesActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a GetLocationTaxesActionProto.
             * @implements IGetLocationTaxesActionProto
             * @constructor
             * @param {waiternow.common.IGetLocationTaxesActionProto=} [properties] Properties to set
             */
            function GetLocationTaxesActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new GetLocationTaxesActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.GetLocationTaxesActionProto
             * @static
             * @param {waiternow.common.IGetLocationTaxesActionProto=} [properties] Properties to set
             * @returns {waiternow.common.GetLocationTaxesActionProto} GetLocationTaxesActionProto instance
             */
            GetLocationTaxesActionProto.create = function create(properties) {
                return new GetLocationTaxesActionProto(properties);
            };

            /**
             * Encodes the specified GetLocationTaxesActionProto message. Does not implicitly {@link waiternow.common.GetLocationTaxesActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.GetLocationTaxesActionProto
             * @static
             * @param {waiternow.common.IGetLocationTaxesActionProto} message GetLocationTaxesActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetLocationTaxesActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified GetLocationTaxesActionProto message, length delimited. Does not implicitly {@link waiternow.common.GetLocationTaxesActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.GetLocationTaxesActionProto
             * @static
             * @param {waiternow.common.IGetLocationTaxesActionProto} message GetLocationTaxesActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetLocationTaxesActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetLocationTaxesActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.GetLocationTaxesActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.GetLocationTaxesActionProto} GetLocationTaxesActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetLocationTaxesActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetLocationTaxesActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetLocationTaxesActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.GetLocationTaxesActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.GetLocationTaxesActionProto} GetLocationTaxesActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetLocationTaxesActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetLocationTaxesActionProto message.
             * @function verify
             * @memberof waiternow.common.GetLocationTaxesActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetLocationTaxesActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a GetLocationTaxesActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.GetLocationTaxesActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.GetLocationTaxesActionProto} GetLocationTaxesActionProto
             */
            GetLocationTaxesActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.GetLocationTaxesActionProto)
                    return object;
                return new $root.waiternow.common.GetLocationTaxesActionProto();
            };

            /**
             * Creates a plain object from a GetLocationTaxesActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.GetLocationTaxesActionProto
             * @static
             * @param {waiternow.common.GetLocationTaxesActionProto} message GetLocationTaxesActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetLocationTaxesActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this GetLocationTaxesActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.GetLocationTaxesActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetLocationTaxesActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for GetLocationTaxesActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.GetLocationTaxesActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            GetLocationTaxesActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.GetLocationTaxesActionProto";
            };

            GetLocationTaxesActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.GetLocationTaxesActionProto
                 * @interface IRequest
                 * @property {string|null} [locationId] Request locationId
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.GetLocationTaxesActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.GetLocationTaxesActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.GetLocationTaxesActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetLocationTaxesActionProto.Request
                 * @static
                 * @param {waiternow.common.GetLocationTaxesActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.GetLocationTaxesActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.GetLocationTaxesActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetLocationTaxesActionProto.Request
                 * @static
                 * @param {waiternow.common.GetLocationTaxesActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.GetLocationTaxesActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetLocationTaxesActionProto.Request
                 * @static
                 * @param {waiternow.common.GetLocationTaxesActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetLocationTaxesActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetLocationTaxesActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetLocationTaxesActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetLocationTaxesActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetLocationTaxesActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.GetLocationTaxesActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetLocationTaxesActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetLocationTaxesActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetLocationTaxesActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.GetLocationTaxesActionProto.Request();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetLocationTaxesActionProto.Request
                 * @static
                 * @param {waiternow.common.GetLocationTaxesActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.locationId = "";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetLocationTaxesActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetLocationTaxesActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetLocationTaxesActionProto.Request";
                };

                return Request;
            })();

            GetLocationTaxesActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.GetLocationTaxesActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.ITaxesProto|null} [taxes] Response taxes
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.GetLocationTaxesActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.GetLocationTaxesActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.GetLocationTaxesActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response taxes.
                 * @member {waiternow.common.ITaxesProto|null|undefined} taxes
                 * @memberof waiternow.common.GetLocationTaxesActionProto.Response
                 * @instance
                 */
                Response.prototype.taxes = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetLocationTaxesActionProto.Response
                 * @static
                 * @param {waiternow.common.GetLocationTaxesActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.GetLocationTaxesActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.GetLocationTaxesActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetLocationTaxesActionProto.Response
                 * @static
                 * @param {waiternow.common.GetLocationTaxesActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.taxes != null && Object.hasOwnProperty.call(message, "taxes"))
                        $root.waiternow.common.TaxesProto.encode(message.taxes, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.GetLocationTaxesActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetLocationTaxesActionProto.Response
                 * @static
                 * @param {waiternow.common.GetLocationTaxesActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetLocationTaxesActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetLocationTaxesActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetLocationTaxesActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.taxes = $root.waiternow.common.TaxesProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetLocationTaxesActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetLocationTaxesActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.GetLocationTaxesActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.taxes != null && message.hasOwnProperty("taxes")) {
                        var error = $root.waiternow.common.TaxesProto.verify(message.taxes);
                        if (error)
                            return "taxes." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetLocationTaxesActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetLocationTaxesActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetLocationTaxesActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.GetLocationTaxesActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.GetLocationTaxesActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.taxes != null) {
                        if (typeof object.taxes !== "object")
                            throw TypeError(".waiternow.common.GetLocationTaxesActionProto.Response.taxes: object expected");
                        message.taxes = $root.waiternow.common.TaxesProto.fromObject(object.taxes);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetLocationTaxesActionProto.Response
                 * @static
                 * @param {waiternow.common.GetLocationTaxesActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.taxes = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.taxes != null && message.hasOwnProperty("taxes"))
                        object.taxes = $root.waiternow.common.TaxesProto.toObject(message.taxes, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetLocationTaxesActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetLocationTaxesActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetLocationTaxesActionProto.Response";
                };

                return Response;
            })();

            return GetLocationTaxesActionProto;
        })();

        common.GetSalesTaxByAddressActionProto = (function() {

            /**
             * Properties of a GetSalesTaxByAddressActionProto.
             * @memberof waiternow.common
             * @interface IGetSalesTaxByAddressActionProto
             */

            /**
             * Constructs a new GetSalesTaxByAddressActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a GetSalesTaxByAddressActionProto.
             * @implements IGetSalesTaxByAddressActionProto
             * @constructor
             * @param {waiternow.common.IGetSalesTaxByAddressActionProto=} [properties] Properties to set
             */
            function GetSalesTaxByAddressActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new GetSalesTaxByAddressActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.GetSalesTaxByAddressActionProto
             * @static
             * @param {waiternow.common.IGetSalesTaxByAddressActionProto=} [properties] Properties to set
             * @returns {waiternow.common.GetSalesTaxByAddressActionProto} GetSalesTaxByAddressActionProto instance
             */
            GetSalesTaxByAddressActionProto.create = function create(properties) {
                return new GetSalesTaxByAddressActionProto(properties);
            };

            /**
             * Encodes the specified GetSalesTaxByAddressActionProto message. Does not implicitly {@link waiternow.common.GetSalesTaxByAddressActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.GetSalesTaxByAddressActionProto
             * @static
             * @param {waiternow.common.IGetSalesTaxByAddressActionProto} message GetSalesTaxByAddressActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetSalesTaxByAddressActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified GetSalesTaxByAddressActionProto message, length delimited. Does not implicitly {@link waiternow.common.GetSalesTaxByAddressActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.GetSalesTaxByAddressActionProto
             * @static
             * @param {waiternow.common.IGetSalesTaxByAddressActionProto} message GetSalesTaxByAddressActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetSalesTaxByAddressActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetSalesTaxByAddressActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.GetSalesTaxByAddressActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.GetSalesTaxByAddressActionProto} GetSalesTaxByAddressActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetSalesTaxByAddressActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetSalesTaxByAddressActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetSalesTaxByAddressActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.GetSalesTaxByAddressActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.GetSalesTaxByAddressActionProto} GetSalesTaxByAddressActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetSalesTaxByAddressActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetSalesTaxByAddressActionProto message.
             * @function verify
             * @memberof waiternow.common.GetSalesTaxByAddressActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetSalesTaxByAddressActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a GetSalesTaxByAddressActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.GetSalesTaxByAddressActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.GetSalesTaxByAddressActionProto} GetSalesTaxByAddressActionProto
             */
            GetSalesTaxByAddressActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.GetSalesTaxByAddressActionProto)
                    return object;
                return new $root.waiternow.common.GetSalesTaxByAddressActionProto();
            };

            /**
             * Creates a plain object from a GetSalesTaxByAddressActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.GetSalesTaxByAddressActionProto
             * @static
             * @param {waiternow.common.GetSalesTaxByAddressActionProto} message GetSalesTaxByAddressActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetSalesTaxByAddressActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this GetSalesTaxByAddressActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.GetSalesTaxByAddressActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetSalesTaxByAddressActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for GetSalesTaxByAddressActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.GetSalesTaxByAddressActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            GetSalesTaxByAddressActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.GetSalesTaxByAddressActionProto";
            };

            GetSalesTaxByAddressActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.GetSalesTaxByAddressActionProto
                 * @interface IRequest
                 * @property {waiternow.common.IAddressProto|null} [address] Request address
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.GetSalesTaxByAddressActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.GetSalesTaxByAddressActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request address.
                 * @member {waiternow.common.IAddressProto|null|undefined} address
                 * @memberof waiternow.common.GetSalesTaxByAddressActionProto.Request
                 * @instance
                 */
                Request.prototype.address = null;

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetSalesTaxByAddressActionProto.Request
                 * @static
                 * @param {waiternow.common.GetSalesTaxByAddressActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.GetSalesTaxByAddressActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.GetSalesTaxByAddressActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetSalesTaxByAddressActionProto.Request
                 * @static
                 * @param {waiternow.common.GetSalesTaxByAddressActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.address != null && Object.hasOwnProperty.call(message, "address"))
                        $root.waiternow.common.AddressProto.encode(message.address, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.GetSalesTaxByAddressActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetSalesTaxByAddressActionProto.Request
                 * @static
                 * @param {waiternow.common.GetSalesTaxByAddressActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetSalesTaxByAddressActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetSalesTaxByAddressActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetSalesTaxByAddressActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.address = $root.waiternow.common.AddressProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetSalesTaxByAddressActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetSalesTaxByAddressActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.GetSalesTaxByAddressActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.address != null && message.hasOwnProperty("address")) {
                        var error = $root.waiternow.common.AddressProto.verify(message.address);
                        if (error)
                            return "address." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetSalesTaxByAddressActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetSalesTaxByAddressActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetSalesTaxByAddressActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.GetSalesTaxByAddressActionProto.Request();
                    if (object.address != null) {
                        if (typeof object.address !== "object")
                            throw TypeError(".waiternow.common.GetSalesTaxByAddressActionProto.Request.address: object expected");
                        message.address = $root.waiternow.common.AddressProto.fromObject(object.address);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetSalesTaxByAddressActionProto.Request
                 * @static
                 * @param {waiternow.common.GetSalesTaxByAddressActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.address = null;
                    if (message.address != null && message.hasOwnProperty("address"))
                        object.address = $root.waiternow.common.AddressProto.toObject(message.address, options);
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetSalesTaxByAddressActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetSalesTaxByAddressActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetSalesTaxByAddressActionProto.Request";
                };

                return Request;
            })();

            GetSalesTaxByAddressActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.GetSalesTaxByAddressActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.ITaxesProto|null} [taxes] Response taxes
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.GetSalesTaxByAddressActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.GetSalesTaxByAddressActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.GetSalesTaxByAddressActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response taxes.
                 * @member {waiternow.common.ITaxesProto|null|undefined} taxes
                 * @memberof waiternow.common.GetSalesTaxByAddressActionProto.Response
                 * @instance
                 */
                Response.prototype.taxes = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetSalesTaxByAddressActionProto.Response
                 * @static
                 * @param {waiternow.common.GetSalesTaxByAddressActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.GetSalesTaxByAddressActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.GetSalesTaxByAddressActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetSalesTaxByAddressActionProto.Response
                 * @static
                 * @param {waiternow.common.GetSalesTaxByAddressActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.taxes != null && Object.hasOwnProperty.call(message, "taxes"))
                        $root.waiternow.common.TaxesProto.encode(message.taxes, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.GetSalesTaxByAddressActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetSalesTaxByAddressActionProto.Response
                 * @static
                 * @param {waiternow.common.GetSalesTaxByAddressActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetSalesTaxByAddressActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetSalesTaxByAddressActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetSalesTaxByAddressActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.taxes = $root.waiternow.common.TaxesProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetSalesTaxByAddressActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetSalesTaxByAddressActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.GetSalesTaxByAddressActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.taxes != null && message.hasOwnProperty("taxes")) {
                        var error = $root.waiternow.common.TaxesProto.verify(message.taxes);
                        if (error)
                            return "taxes." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetSalesTaxByAddressActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetSalesTaxByAddressActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetSalesTaxByAddressActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.GetSalesTaxByAddressActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.GetSalesTaxByAddressActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.taxes != null) {
                        if (typeof object.taxes !== "object")
                            throw TypeError(".waiternow.common.GetSalesTaxByAddressActionProto.Response.taxes: object expected");
                        message.taxes = $root.waiternow.common.TaxesProto.fromObject(object.taxes);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetSalesTaxByAddressActionProto.Response
                 * @static
                 * @param {waiternow.common.GetSalesTaxByAddressActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.taxes = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.taxes != null && message.hasOwnProperty("taxes"))
                        object.taxes = $root.waiternow.common.TaxesProto.toObject(message.taxes, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetSalesTaxByAddressActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetSalesTaxByAddressActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetSalesTaxByAddressActionProto.Response";
                };

                return Response;
            })();

            return GetSalesTaxByAddressActionProto;
        })();

        common.ReprocessOrderPaymentActionProto = (function() {

            /**
             * Properties of a ReprocessOrderPaymentActionProto.
             * @memberof waiternow.common
             * @interface IReprocessOrderPaymentActionProto
             */

            /**
             * Constructs a new ReprocessOrderPaymentActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a ReprocessOrderPaymentActionProto.
             * @implements IReprocessOrderPaymentActionProto
             * @constructor
             * @param {waiternow.common.IReprocessOrderPaymentActionProto=} [properties] Properties to set
             */
            function ReprocessOrderPaymentActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new ReprocessOrderPaymentActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.ReprocessOrderPaymentActionProto
             * @static
             * @param {waiternow.common.IReprocessOrderPaymentActionProto=} [properties] Properties to set
             * @returns {waiternow.common.ReprocessOrderPaymentActionProto} ReprocessOrderPaymentActionProto instance
             */
            ReprocessOrderPaymentActionProto.create = function create(properties) {
                return new ReprocessOrderPaymentActionProto(properties);
            };

            /**
             * Encodes the specified ReprocessOrderPaymentActionProto message. Does not implicitly {@link waiternow.common.ReprocessOrderPaymentActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.ReprocessOrderPaymentActionProto
             * @static
             * @param {waiternow.common.IReprocessOrderPaymentActionProto} message ReprocessOrderPaymentActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReprocessOrderPaymentActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified ReprocessOrderPaymentActionProto message, length delimited. Does not implicitly {@link waiternow.common.ReprocessOrderPaymentActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.ReprocessOrderPaymentActionProto
             * @static
             * @param {waiternow.common.IReprocessOrderPaymentActionProto} message ReprocessOrderPaymentActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReprocessOrderPaymentActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ReprocessOrderPaymentActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.ReprocessOrderPaymentActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.ReprocessOrderPaymentActionProto} ReprocessOrderPaymentActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReprocessOrderPaymentActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.ReprocessOrderPaymentActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ReprocessOrderPaymentActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.ReprocessOrderPaymentActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.ReprocessOrderPaymentActionProto} ReprocessOrderPaymentActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReprocessOrderPaymentActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ReprocessOrderPaymentActionProto message.
             * @function verify
             * @memberof waiternow.common.ReprocessOrderPaymentActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ReprocessOrderPaymentActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a ReprocessOrderPaymentActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.ReprocessOrderPaymentActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.ReprocessOrderPaymentActionProto} ReprocessOrderPaymentActionProto
             */
            ReprocessOrderPaymentActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.ReprocessOrderPaymentActionProto)
                    return object;
                return new $root.waiternow.common.ReprocessOrderPaymentActionProto();
            };

            /**
             * Creates a plain object from a ReprocessOrderPaymentActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.ReprocessOrderPaymentActionProto
             * @static
             * @param {waiternow.common.ReprocessOrderPaymentActionProto} message ReprocessOrderPaymentActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ReprocessOrderPaymentActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this ReprocessOrderPaymentActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.ReprocessOrderPaymentActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ReprocessOrderPaymentActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for ReprocessOrderPaymentActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.ReprocessOrderPaymentActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            ReprocessOrderPaymentActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.ReprocessOrderPaymentActionProto";
            };

            ReprocessOrderPaymentActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.ReprocessOrderPaymentActionProto
                 * @interface IRequest
                 * @property {string|null} [orderId] Request orderId
                 * @property {boolean|null} [sendToBusinessForPreparation] Request sendToBusinessForPreparation
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.ReprocessOrderPaymentActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.ReprocessOrderPaymentActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request orderId.
                 * @member {string} orderId
                 * @memberof waiternow.common.ReprocessOrderPaymentActionProto.Request
                 * @instance
                 */
                Request.prototype.orderId = "";

                /**
                 * Request sendToBusinessForPreparation.
                 * @member {boolean} sendToBusinessForPreparation
                 * @memberof waiternow.common.ReprocessOrderPaymentActionProto.Request
                 * @instance
                 */
                Request.prototype.sendToBusinessForPreparation = false;

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.ReprocessOrderPaymentActionProto.Request
                 * @static
                 * @param {waiternow.common.ReprocessOrderPaymentActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.ReprocessOrderPaymentActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.ReprocessOrderPaymentActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.ReprocessOrderPaymentActionProto.Request
                 * @static
                 * @param {waiternow.common.ReprocessOrderPaymentActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.orderId != null && Object.hasOwnProperty.call(message, "orderId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.orderId);
                    if (message.sendToBusinessForPreparation != null && Object.hasOwnProperty.call(message, "sendToBusinessForPreparation"))
                        writer.uint32(/* id 2, wireType 0 =*/16).bool(message.sendToBusinessForPreparation);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.ReprocessOrderPaymentActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.ReprocessOrderPaymentActionProto.Request
                 * @static
                 * @param {waiternow.common.ReprocessOrderPaymentActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.ReprocessOrderPaymentActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.ReprocessOrderPaymentActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.ReprocessOrderPaymentActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.orderId = reader.string();
                                break;
                            }
                        case 2: {
                                message.sendToBusinessForPreparation = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.ReprocessOrderPaymentActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.ReprocessOrderPaymentActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.ReprocessOrderPaymentActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.orderId != null && message.hasOwnProperty("orderId"))
                        if (!$util.isString(message.orderId))
                            return "orderId: string expected";
                    if (message.sendToBusinessForPreparation != null && message.hasOwnProperty("sendToBusinessForPreparation"))
                        if (typeof message.sendToBusinessForPreparation !== "boolean")
                            return "sendToBusinessForPreparation: boolean expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.ReprocessOrderPaymentActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.ReprocessOrderPaymentActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.ReprocessOrderPaymentActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.ReprocessOrderPaymentActionProto.Request();
                    if (object.orderId != null)
                        message.orderId = String(object.orderId);
                    if (object.sendToBusinessForPreparation != null)
                        message.sendToBusinessForPreparation = Boolean(object.sendToBusinessForPreparation);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.ReprocessOrderPaymentActionProto.Request
                 * @static
                 * @param {waiternow.common.ReprocessOrderPaymentActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.orderId = "";
                        object.sendToBusinessForPreparation = false;
                    }
                    if (message.orderId != null && message.hasOwnProperty("orderId"))
                        object.orderId = message.orderId;
                    if (message.sendToBusinessForPreparation != null && message.hasOwnProperty("sendToBusinessForPreparation"))
                        object.sendToBusinessForPreparation = message.sendToBusinessForPreparation;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.ReprocessOrderPaymentActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.ReprocessOrderPaymentActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.ReprocessOrderPaymentActionProto.Request";
                };

                return Request;
            })();

            ReprocessOrderPaymentActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.ReprocessOrderPaymentActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.ReprocessOrderPaymentActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.ReprocessOrderPaymentActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.ReprocessOrderPaymentActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.ReprocessOrderPaymentActionProto.Response
                 * @static
                 * @param {waiternow.common.ReprocessOrderPaymentActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.ReprocessOrderPaymentActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.ReprocessOrderPaymentActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.ReprocessOrderPaymentActionProto.Response
                 * @static
                 * @param {waiternow.common.ReprocessOrderPaymentActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.ReprocessOrderPaymentActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.ReprocessOrderPaymentActionProto.Response
                 * @static
                 * @param {waiternow.common.ReprocessOrderPaymentActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.ReprocessOrderPaymentActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.ReprocessOrderPaymentActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.ReprocessOrderPaymentActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.ReprocessOrderPaymentActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.ReprocessOrderPaymentActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.ReprocessOrderPaymentActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.ReprocessOrderPaymentActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.ReprocessOrderPaymentActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.ReprocessOrderPaymentActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.ReprocessOrderPaymentActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.ReprocessOrderPaymentActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.ReprocessOrderPaymentActionProto.Response
                 * @static
                 * @param {waiternow.common.ReprocessOrderPaymentActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.ReprocessOrderPaymentActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.ReprocessOrderPaymentActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.ReprocessOrderPaymentActionProto.Response";
                };

                return Response;
            })();

            return ReprocessOrderPaymentActionProto;
        })();

        common.FindLocationsByStripeAccountActionProto = (function() {

            /**
             * Properties of a FindLocationsByStripeAccountActionProto.
             * @memberof waiternow.common
             * @interface IFindLocationsByStripeAccountActionProto
             */

            /**
             * Constructs a new FindLocationsByStripeAccountActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a FindLocationsByStripeAccountActionProto.
             * @implements IFindLocationsByStripeAccountActionProto
             * @constructor
             * @param {waiternow.common.IFindLocationsByStripeAccountActionProto=} [properties] Properties to set
             */
            function FindLocationsByStripeAccountActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new FindLocationsByStripeAccountActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FindLocationsByStripeAccountActionProto
             * @static
             * @param {waiternow.common.IFindLocationsByStripeAccountActionProto=} [properties] Properties to set
             * @returns {waiternow.common.FindLocationsByStripeAccountActionProto} FindLocationsByStripeAccountActionProto instance
             */
            FindLocationsByStripeAccountActionProto.create = function create(properties) {
                return new FindLocationsByStripeAccountActionProto(properties);
            };

            /**
             * Encodes the specified FindLocationsByStripeAccountActionProto message. Does not implicitly {@link waiternow.common.FindLocationsByStripeAccountActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FindLocationsByStripeAccountActionProto
             * @static
             * @param {waiternow.common.IFindLocationsByStripeAccountActionProto} message FindLocationsByStripeAccountActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindLocationsByStripeAccountActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified FindLocationsByStripeAccountActionProto message, length delimited. Does not implicitly {@link waiternow.common.FindLocationsByStripeAccountActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FindLocationsByStripeAccountActionProto
             * @static
             * @param {waiternow.common.IFindLocationsByStripeAccountActionProto} message FindLocationsByStripeAccountActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindLocationsByStripeAccountActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FindLocationsByStripeAccountActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FindLocationsByStripeAccountActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FindLocationsByStripeAccountActionProto} FindLocationsByStripeAccountActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindLocationsByStripeAccountActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindLocationsByStripeAccountActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FindLocationsByStripeAccountActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FindLocationsByStripeAccountActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FindLocationsByStripeAccountActionProto} FindLocationsByStripeAccountActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindLocationsByStripeAccountActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FindLocationsByStripeAccountActionProto message.
             * @function verify
             * @memberof waiternow.common.FindLocationsByStripeAccountActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FindLocationsByStripeAccountActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a FindLocationsByStripeAccountActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FindLocationsByStripeAccountActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FindLocationsByStripeAccountActionProto} FindLocationsByStripeAccountActionProto
             */
            FindLocationsByStripeAccountActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FindLocationsByStripeAccountActionProto)
                    return object;
                return new $root.waiternow.common.FindLocationsByStripeAccountActionProto();
            };

            /**
             * Creates a plain object from a FindLocationsByStripeAccountActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FindLocationsByStripeAccountActionProto
             * @static
             * @param {waiternow.common.FindLocationsByStripeAccountActionProto} message FindLocationsByStripeAccountActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FindLocationsByStripeAccountActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this FindLocationsByStripeAccountActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FindLocationsByStripeAccountActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FindLocationsByStripeAccountActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FindLocationsByStripeAccountActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.FindLocationsByStripeAccountActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FindLocationsByStripeAccountActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FindLocationsByStripeAccountActionProto";
            };

            FindLocationsByStripeAccountActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.FindLocationsByStripeAccountActionProto
                 * @interface IRequest
                 * @property {string|null} [stripeAccountId] Request stripeAccountId
                 * @property {string|null} [continuationToken] Request continuationToken
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.FindLocationsByStripeAccountActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.FindLocationsByStripeAccountActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request stripeAccountId.
                 * @member {string} stripeAccountId
                 * @memberof waiternow.common.FindLocationsByStripeAccountActionProto.Request
                 * @instance
                 */
                Request.prototype.stripeAccountId = "";

                /**
                 * Request continuationToken.
                 * @member {string} continuationToken
                 * @memberof waiternow.common.FindLocationsByStripeAccountActionProto.Request
                 * @instance
                 */
                Request.prototype.continuationToken = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindLocationsByStripeAccountActionProto.Request
                 * @static
                 * @param {waiternow.common.FindLocationsByStripeAccountActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.FindLocationsByStripeAccountActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.FindLocationsByStripeAccountActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindLocationsByStripeAccountActionProto.Request
                 * @static
                 * @param {waiternow.common.FindLocationsByStripeAccountActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.stripeAccountId != null && Object.hasOwnProperty.call(message, "stripeAccountId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.stripeAccountId);
                    if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.continuationToken);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.FindLocationsByStripeAccountActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindLocationsByStripeAccountActionProto.Request
                 * @static
                 * @param {waiternow.common.FindLocationsByStripeAccountActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindLocationsByStripeAccountActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindLocationsByStripeAccountActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindLocationsByStripeAccountActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.stripeAccountId = reader.string();
                                break;
                            }
                        case 2: {
                                message.continuationToken = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindLocationsByStripeAccountActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindLocationsByStripeAccountActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.FindLocationsByStripeAccountActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.stripeAccountId != null && message.hasOwnProperty("stripeAccountId"))
                        if (!$util.isString(message.stripeAccountId))
                            return "stripeAccountId: string expected";
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        if (!$util.isString(message.continuationToken))
                            return "continuationToken: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindLocationsByStripeAccountActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindLocationsByStripeAccountActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindLocationsByStripeAccountActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.FindLocationsByStripeAccountActionProto.Request();
                    if (object.stripeAccountId != null)
                        message.stripeAccountId = String(object.stripeAccountId);
                    if (object.continuationToken != null)
                        message.continuationToken = String(object.continuationToken);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindLocationsByStripeAccountActionProto.Request
                 * @static
                 * @param {waiternow.common.FindLocationsByStripeAccountActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.stripeAccountId = "";
                        object.continuationToken = "";
                    }
                    if (message.stripeAccountId != null && message.hasOwnProperty("stripeAccountId"))
                        object.stripeAccountId = message.stripeAccountId;
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        object.continuationToken = message.continuationToken;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindLocationsByStripeAccountActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindLocationsByStripeAccountActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindLocationsByStripeAccountActionProto.Request";
                };

                return Request;
            })();

            FindLocationsByStripeAccountActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.FindLocationsByStripeAccountActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.ILocationsProto|null} [locations] Response locations
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.FindLocationsByStripeAccountActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.FindLocationsByStripeAccountActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.FindLocationsByStripeAccountActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response locations.
                 * @member {waiternow.common.ILocationsProto|null|undefined} locations
                 * @memberof waiternow.common.FindLocationsByStripeAccountActionProto.Response
                 * @instance
                 */
                Response.prototype.locations = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindLocationsByStripeAccountActionProto.Response
                 * @static
                 * @param {waiternow.common.FindLocationsByStripeAccountActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.FindLocationsByStripeAccountActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.FindLocationsByStripeAccountActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindLocationsByStripeAccountActionProto.Response
                 * @static
                 * @param {waiternow.common.FindLocationsByStripeAccountActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.locations != null && Object.hasOwnProperty.call(message, "locations"))
                        $root.waiternow.common.LocationsProto.encode(message.locations, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.FindLocationsByStripeAccountActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindLocationsByStripeAccountActionProto.Response
                 * @static
                 * @param {waiternow.common.FindLocationsByStripeAccountActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindLocationsByStripeAccountActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindLocationsByStripeAccountActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindLocationsByStripeAccountActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.locations = $root.waiternow.common.LocationsProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindLocationsByStripeAccountActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindLocationsByStripeAccountActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.FindLocationsByStripeAccountActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.locations != null && message.hasOwnProperty("locations")) {
                        var error = $root.waiternow.common.LocationsProto.verify(message.locations);
                        if (error)
                            return "locations." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindLocationsByStripeAccountActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindLocationsByStripeAccountActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindLocationsByStripeAccountActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.FindLocationsByStripeAccountActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.FindLocationsByStripeAccountActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.locations != null) {
                        if (typeof object.locations !== "object")
                            throw TypeError(".waiternow.common.FindLocationsByStripeAccountActionProto.Response.locations: object expected");
                        message.locations = $root.waiternow.common.LocationsProto.fromObject(object.locations);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindLocationsByStripeAccountActionProto.Response
                 * @static
                 * @param {waiternow.common.FindLocationsByStripeAccountActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.locations = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.locations != null && message.hasOwnProperty("locations"))
                        object.locations = $root.waiternow.common.LocationsProto.toObject(message.locations, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindLocationsByStripeAccountActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindLocationsByStripeAccountActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindLocationsByStripeAccountActionProto.Response";
                };

                return Response;
            })();

            return FindLocationsByStripeAccountActionProto;
        })();

        common.FindInactiveLocationsActionProto = (function() {

            /**
             * Properties of a FindInactiveLocationsActionProto.
             * @memberof waiternow.common
             * @interface IFindInactiveLocationsActionProto
             */

            /**
             * Constructs a new FindInactiveLocationsActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a FindInactiveLocationsActionProto.
             * @implements IFindInactiveLocationsActionProto
             * @constructor
             * @param {waiternow.common.IFindInactiveLocationsActionProto=} [properties] Properties to set
             */
            function FindInactiveLocationsActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new FindInactiveLocationsActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FindInactiveLocationsActionProto
             * @static
             * @param {waiternow.common.IFindInactiveLocationsActionProto=} [properties] Properties to set
             * @returns {waiternow.common.FindInactiveLocationsActionProto} FindInactiveLocationsActionProto instance
             */
            FindInactiveLocationsActionProto.create = function create(properties) {
                return new FindInactiveLocationsActionProto(properties);
            };

            /**
             * Encodes the specified FindInactiveLocationsActionProto message. Does not implicitly {@link waiternow.common.FindInactiveLocationsActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FindInactiveLocationsActionProto
             * @static
             * @param {waiternow.common.IFindInactiveLocationsActionProto} message FindInactiveLocationsActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindInactiveLocationsActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified FindInactiveLocationsActionProto message, length delimited. Does not implicitly {@link waiternow.common.FindInactiveLocationsActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FindInactiveLocationsActionProto
             * @static
             * @param {waiternow.common.IFindInactiveLocationsActionProto} message FindInactiveLocationsActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindInactiveLocationsActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FindInactiveLocationsActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FindInactiveLocationsActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FindInactiveLocationsActionProto} FindInactiveLocationsActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindInactiveLocationsActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindInactiveLocationsActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FindInactiveLocationsActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FindInactiveLocationsActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FindInactiveLocationsActionProto} FindInactiveLocationsActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindInactiveLocationsActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FindInactiveLocationsActionProto message.
             * @function verify
             * @memberof waiternow.common.FindInactiveLocationsActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FindInactiveLocationsActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a FindInactiveLocationsActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FindInactiveLocationsActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FindInactiveLocationsActionProto} FindInactiveLocationsActionProto
             */
            FindInactiveLocationsActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FindInactiveLocationsActionProto)
                    return object;
                return new $root.waiternow.common.FindInactiveLocationsActionProto();
            };

            /**
             * Creates a plain object from a FindInactiveLocationsActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FindInactiveLocationsActionProto
             * @static
             * @param {waiternow.common.FindInactiveLocationsActionProto} message FindInactiveLocationsActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FindInactiveLocationsActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this FindInactiveLocationsActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FindInactiveLocationsActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FindInactiveLocationsActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FindInactiveLocationsActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.FindInactiveLocationsActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FindInactiveLocationsActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FindInactiveLocationsActionProto";
            };

            FindInactiveLocationsActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.FindInactiveLocationsActionProto
                 * @interface IRequest
                 * @property {string|null} [continuationToken] Request continuationToken
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.FindInactiveLocationsActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.FindInactiveLocationsActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request continuationToken.
                 * @member {string} continuationToken
                 * @memberof waiternow.common.FindInactiveLocationsActionProto.Request
                 * @instance
                 */
                Request.prototype.continuationToken = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindInactiveLocationsActionProto.Request
                 * @static
                 * @param {waiternow.common.FindInactiveLocationsActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.FindInactiveLocationsActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.FindInactiveLocationsActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindInactiveLocationsActionProto.Request
                 * @static
                 * @param {waiternow.common.FindInactiveLocationsActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.continuationToken);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.FindInactiveLocationsActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindInactiveLocationsActionProto.Request
                 * @static
                 * @param {waiternow.common.FindInactiveLocationsActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindInactiveLocationsActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindInactiveLocationsActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindInactiveLocationsActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.continuationToken = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindInactiveLocationsActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindInactiveLocationsActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.FindInactiveLocationsActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        if (!$util.isString(message.continuationToken))
                            return "continuationToken: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindInactiveLocationsActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindInactiveLocationsActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindInactiveLocationsActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.FindInactiveLocationsActionProto.Request();
                    if (object.continuationToken != null)
                        message.continuationToken = String(object.continuationToken);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindInactiveLocationsActionProto.Request
                 * @static
                 * @param {waiternow.common.FindInactiveLocationsActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.continuationToken = "";
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        object.continuationToken = message.continuationToken;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindInactiveLocationsActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindInactiveLocationsActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindInactiveLocationsActionProto.Request";
                };

                return Request;
            })();

            FindInactiveLocationsActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.FindInactiveLocationsActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.ILocationsProto|null} [locations] Response locations
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.FindInactiveLocationsActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.FindInactiveLocationsActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.FindInactiveLocationsActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response locations.
                 * @member {waiternow.common.ILocationsProto|null|undefined} locations
                 * @memberof waiternow.common.FindInactiveLocationsActionProto.Response
                 * @instance
                 */
                Response.prototype.locations = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindInactiveLocationsActionProto.Response
                 * @static
                 * @param {waiternow.common.FindInactiveLocationsActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.FindInactiveLocationsActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.FindInactiveLocationsActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindInactiveLocationsActionProto.Response
                 * @static
                 * @param {waiternow.common.FindInactiveLocationsActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.locations != null && Object.hasOwnProperty.call(message, "locations"))
                        $root.waiternow.common.LocationsProto.encode(message.locations, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.FindInactiveLocationsActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindInactiveLocationsActionProto.Response
                 * @static
                 * @param {waiternow.common.FindInactiveLocationsActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindInactiveLocationsActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindInactiveLocationsActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindInactiveLocationsActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.locations = $root.waiternow.common.LocationsProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindInactiveLocationsActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindInactiveLocationsActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.FindInactiveLocationsActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.locations != null && message.hasOwnProperty("locations")) {
                        var error = $root.waiternow.common.LocationsProto.verify(message.locations);
                        if (error)
                            return "locations." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindInactiveLocationsActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindInactiveLocationsActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindInactiveLocationsActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.FindInactiveLocationsActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.FindInactiveLocationsActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.locations != null) {
                        if (typeof object.locations !== "object")
                            throw TypeError(".waiternow.common.FindInactiveLocationsActionProto.Response.locations: object expected");
                        message.locations = $root.waiternow.common.LocationsProto.fromObject(object.locations);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindInactiveLocationsActionProto.Response
                 * @static
                 * @param {waiternow.common.FindInactiveLocationsActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.locations = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.locations != null && message.hasOwnProperty("locations"))
                        object.locations = $root.waiternow.common.LocationsProto.toObject(message.locations, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindInactiveLocationsActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindInactiveLocationsActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindInactiveLocationsActionProto.Response";
                };

                return Response;
            })();

            return FindInactiveLocationsActionProto;
        })();

        common.FindRemoteLogsByDeviceActionProto = (function() {

            /**
             * Properties of a FindRemoteLogsByDeviceActionProto.
             * @memberof waiternow.common
             * @interface IFindRemoteLogsByDeviceActionProto
             */

            /**
             * Constructs a new FindRemoteLogsByDeviceActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a FindRemoteLogsByDeviceActionProto.
             * @implements IFindRemoteLogsByDeviceActionProto
             * @constructor
             * @param {waiternow.common.IFindRemoteLogsByDeviceActionProto=} [properties] Properties to set
             */
            function FindRemoteLogsByDeviceActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new FindRemoteLogsByDeviceActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FindRemoteLogsByDeviceActionProto
             * @static
             * @param {waiternow.common.IFindRemoteLogsByDeviceActionProto=} [properties] Properties to set
             * @returns {waiternow.common.FindRemoteLogsByDeviceActionProto} FindRemoteLogsByDeviceActionProto instance
             */
            FindRemoteLogsByDeviceActionProto.create = function create(properties) {
                return new FindRemoteLogsByDeviceActionProto(properties);
            };

            /**
             * Encodes the specified FindRemoteLogsByDeviceActionProto message. Does not implicitly {@link waiternow.common.FindRemoteLogsByDeviceActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FindRemoteLogsByDeviceActionProto
             * @static
             * @param {waiternow.common.IFindRemoteLogsByDeviceActionProto} message FindRemoteLogsByDeviceActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindRemoteLogsByDeviceActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified FindRemoteLogsByDeviceActionProto message, length delimited. Does not implicitly {@link waiternow.common.FindRemoteLogsByDeviceActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FindRemoteLogsByDeviceActionProto
             * @static
             * @param {waiternow.common.IFindRemoteLogsByDeviceActionProto} message FindRemoteLogsByDeviceActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindRemoteLogsByDeviceActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FindRemoteLogsByDeviceActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FindRemoteLogsByDeviceActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FindRemoteLogsByDeviceActionProto} FindRemoteLogsByDeviceActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindRemoteLogsByDeviceActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindRemoteLogsByDeviceActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FindRemoteLogsByDeviceActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FindRemoteLogsByDeviceActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FindRemoteLogsByDeviceActionProto} FindRemoteLogsByDeviceActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindRemoteLogsByDeviceActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FindRemoteLogsByDeviceActionProto message.
             * @function verify
             * @memberof waiternow.common.FindRemoteLogsByDeviceActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FindRemoteLogsByDeviceActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a FindRemoteLogsByDeviceActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FindRemoteLogsByDeviceActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FindRemoteLogsByDeviceActionProto} FindRemoteLogsByDeviceActionProto
             */
            FindRemoteLogsByDeviceActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FindRemoteLogsByDeviceActionProto)
                    return object;
                return new $root.waiternow.common.FindRemoteLogsByDeviceActionProto();
            };

            /**
             * Creates a plain object from a FindRemoteLogsByDeviceActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FindRemoteLogsByDeviceActionProto
             * @static
             * @param {waiternow.common.FindRemoteLogsByDeviceActionProto} message FindRemoteLogsByDeviceActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FindRemoteLogsByDeviceActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this FindRemoteLogsByDeviceActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FindRemoteLogsByDeviceActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FindRemoteLogsByDeviceActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FindRemoteLogsByDeviceActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.FindRemoteLogsByDeviceActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FindRemoteLogsByDeviceActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FindRemoteLogsByDeviceActionProto";
            };

            FindRemoteLogsByDeviceActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.FindRemoteLogsByDeviceActionProto
                 * @interface IRequest
                 * @property {string|null} [deviceId] Request deviceId
                 * @property {google.protobuf.ITimestamp|null} [afterTime] Request afterTime
                 * @property {google.protobuf.ITimestamp|null} [beforeTime] Request beforeTime
                 * @property {waiternow.common.SortOrder|null} [sortOrder] Request sortOrder
                 * @property {string|null} [continuationToken] Request continuationToken
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.FindRemoteLogsByDeviceActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.FindRemoteLogsByDeviceActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request deviceId.
                 * @member {string} deviceId
                 * @memberof waiternow.common.FindRemoteLogsByDeviceActionProto.Request
                 * @instance
                 */
                Request.prototype.deviceId = "";

                /**
                 * Request afterTime.
                 * @member {google.protobuf.ITimestamp|null|undefined} afterTime
                 * @memberof waiternow.common.FindRemoteLogsByDeviceActionProto.Request
                 * @instance
                 */
                Request.prototype.afterTime = null;

                /**
                 * Request beforeTime.
                 * @member {google.protobuf.ITimestamp|null|undefined} beforeTime
                 * @memberof waiternow.common.FindRemoteLogsByDeviceActionProto.Request
                 * @instance
                 */
                Request.prototype.beforeTime = null;

                /**
                 * Request sortOrder.
                 * @member {waiternow.common.SortOrder} sortOrder
                 * @memberof waiternow.common.FindRemoteLogsByDeviceActionProto.Request
                 * @instance
                 */
                Request.prototype.sortOrder = 0;

                /**
                 * Request continuationToken.
                 * @member {string} continuationToken
                 * @memberof waiternow.common.FindRemoteLogsByDeviceActionProto.Request
                 * @instance
                 */
                Request.prototype.continuationToken = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindRemoteLogsByDeviceActionProto.Request
                 * @static
                 * @param {waiternow.common.FindRemoteLogsByDeviceActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.FindRemoteLogsByDeviceActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.FindRemoteLogsByDeviceActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindRemoteLogsByDeviceActionProto.Request
                 * @static
                 * @param {waiternow.common.FindRemoteLogsByDeviceActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceId != null && Object.hasOwnProperty.call(message, "deviceId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.deviceId);
                    if (message.afterTime != null && Object.hasOwnProperty.call(message, "afterTime"))
                        $root.google.protobuf.Timestamp.encode(message.afterTime, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.beforeTime != null && Object.hasOwnProperty.call(message, "beforeTime"))
                        $root.google.protobuf.Timestamp.encode(message.beforeTime, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.sortOrder != null && Object.hasOwnProperty.call(message, "sortOrder"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.sortOrder);
                    if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.continuationToken);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.FindRemoteLogsByDeviceActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindRemoteLogsByDeviceActionProto.Request
                 * @static
                 * @param {waiternow.common.FindRemoteLogsByDeviceActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindRemoteLogsByDeviceActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindRemoteLogsByDeviceActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindRemoteLogsByDeviceActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceId = reader.string();
                                break;
                            }
                        case 2: {
                                message.afterTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.beforeTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            }
                        case 4: {
                                message.sortOrder = reader.int32();
                                break;
                            }
                        case 5: {
                                message.continuationToken = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindRemoteLogsByDeviceActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindRemoteLogsByDeviceActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.FindRemoteLogsByDeviceActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                        if (!$util.isString(message.deviceId))
                            return "deviceId: string expected";
                    if (message.afterTime != null && message.hasOwnProperty("afterTime")) {
                        var error = $root.google.protobuf.Timestamp.verify(message.afterTime);
                        if (error)
                            return "afterTime." + error;
                    }
                    if (message.beforeTime != null && message.hasOwnProperty("beforeTime")) {
                        var error = $root.google.protobuf.Timestamp.verify(message.beforeTime);
                        if (error)
                            return "beforeTime." + error;
                    }
                    if (message.sortOrder != null && message.hasOwnProperty("sortOrder"))
                        switch (message.sortOrder) {
                        default:
                            return "sortOrder: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        if (!$util.isString(message.continuationToken))
                            return "continuationToken: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindRemoteLogsByDeviceActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindRemoteLogsByDeviceActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindRemoteLogsByDeviceActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.FindRemoteLogsByDeviceActionProto.Request();
                    if (object.deviceId != null)
                        message.deviceId = String(object.deviceId);
                    if (object.afterTime != null) {
                        if (typeof object.afterTime !== "object")
                            throw TypeError(".waiternow.common.FindRemoteLogsByDeviceActionProto.Request.afterTime: object expected");
                        message.afterTime = $root.google.protobuf.Timestamp.fromObject(object.afterTime);
                    }
                    if (object.beforeTime != null) {
                        if (typeof object.beforeTime !== "object")
                            throw TypeError(".waiternow.common.FindRemoteLogsByDeviceActionProto.Request.beforeTime: object expected");
                        message.beforeTime = $root.google.protobuf.Timestamp.fromObject(object.beforeTime);
                    }
                    switch (object.sortOrder) {
                    default:
                        if (typeof object.sortOrder === "number") {
                            message.sortOrder = object.sortOrder;
                            break;
                        }
                        break;
                    case "SORT_ORDER_UNSPECIFIED":
                    case 0:
                        message.sortOrder = 0;
                        break;
                    case "ASCENDING":
                    case 1:
                        message.sortOrder = 1;
                        break;
                    case "DESCENDING":
                    case 2:
                        message.sortOrder = 2;
                        break;
                    }
                    if (object.continuationToken != null)
                        message.continuationToken = String(object.continuationToken);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindRemoteLogsByDeviceActionProto.Request
                 * @static
                 * @param {waiternow.common.FindRemoteLogsByDeviceActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.deviceId = "";
                        object.afterTime = null;
                        object.beforeTime = null;
                        object.sortOrder = options.enums === String ? "SORT_ORDER_UNSPECIFIED" : 0;
                        object.continuationToken = "";
                    }
                    if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                        object.deviceId = message.deviceId;
                    if (message.afterTime != null && message.hasOwnProperty("afterTime"))
                        object.afterTime = $root.google.protobuf.Timestamp.toObject(message.afterTime, options);
                    if (message.beforeTime != null && message.hasOwnProperty("beforeTime"))
                        object.beforeTime = $root.google.protobuf.Timestamp.toObject(message.beforeTime, options);
                    if (message.sortOrder != null && message.hasOwnProperty("sortOrder"))
                        object.sortOrder = options.enums === String ? $root.waiternow.common.SortOrder[message.sortOrder] === undefined ? message.sortOrder : $root.waiternow.common.SortOrder[message.sortOrder] : message.sortOrder;
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        object.continuationToken = message.continuationToken;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindRemoteLogsByDeviceActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindRemoteLogsByDeviceActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindRemoteLogsByDeviceActionProto.Request";
                };

                return Request;
            })();

            FindRemoteLogsByDeviceActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.FindRemoteLogsByDeviceActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IRemoteLogsProto|null} [logs] Response logs
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.FindRemoteLogsByDeviceActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.FindRemoteLogsByDeviceActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.FindRemoteLogsByDeviceActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response logs.
                 * @member {waiternow.common.IRemoteLogsProto|null|undefined} logs
                 * @memberof waiternow.common.FindRemoteLogsByDeviceActionProto.Response
                 * @instance
                 */
                Response.prototype.logs = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindRemoteLogsByDeviceActionProto.Response
                 * @static
                 * @param {waiternow.common.FindRemoteLogsByDeviceActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.FindRemoteLogsByDeviceActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.FindRemoteLogsByDeviceActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindRemoteLogsByDeviceActionProto.Response
                 * @static
                 * @param {waiternow.common.FindRemoteLogsByDeviceActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.logs != null && Object.hasOwnProperty.call(message, "logs"))
                        $root.waiternow.common.RemoteLogsProto.encode(message.logs, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.FindRemoteLogsByDeviceActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindRemoteLogsByDeviceActionProto.Response
                 * @static
                 * @param {waiternow.common.FindRemoteLogsByDeviceActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindRemoteLogsByDeviceActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindRemoteLogsByDeviceActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindRemoteLogsByDeviceActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.logs = $root.waiternow.common.RemoteLogsProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindRemoteLogsByDeviceActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindRemoteLogsByDeviceActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.FindRemoteLogsByDeviceActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.logs != null && message.hasOwnProperty("logs")) {
                        var error = $root.waiternow.common.RemoteLogsProto.verify(message.logs);
                        if (error)
                            return "logs." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindRemoteLogsByDeviceActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindRemoteLogsByDeviceActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindRemoteLogsByDeviceActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.FindRemoteLogsByDeviceActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.FindRemoteLogsByDeviceActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.logs != null) {
                        if (typeof object.logs !== "object")
                            throw TypeError(".waiternow.common.FindRemoteLogsByDeviceActionProto.Response.logs: object expected");
                        message.logs = $root.waiternow.common.RemoteLogsProto.fromObject(object.logs);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindRemoteLogsByDeviceActionProto.Response
                 * @static
                 * @param {waiternow.common.FindRemoteLogsByDeviceActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.logs = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.logs != null && message.hasOwnProperty("logs"))
                        object.logs = $root.waiternow.common.RemoteLogsProto.toObject(message.logs, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindRemoteLogsByDeviceActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindRemoteLogsByDeviceActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindRemoteLogsByDeviceActionProto.Response";
                };

                return Response;
            })();

            return FindRemoteLogsByDeviceActionProto;
        })();

        /**
         * ErrorCode enum.
         * @name waiternow.common.ErrorCode
         * @enum {number}
         * @property {number} ERROR_CODE_UNSPECIFIED=0 ERROR_CODE_UNSPECIFIED value
         * @property {number} CHANGE_OF_ADDRESS_NOT_ALLOWED_OUTSIDE_COUNTRY=30 CHANGE_OF_ADDRESS_NOT_ALLOWED_OUTSIDE_COUNTRY value
         * @property {number} DELIVERY_FAILED_ORDER_REFUNDED=19 DELIVERY_FAILED_ORDER_REFUNDED value
         * @property {number} DELIVERY_NOT_ALLOWED=16 DELIVERY_NOT_ALLOWED value
         * @property {number} DELIVERY_NOT_ALLOWED_DELIVERY_ADDRESS_NOT_IN_COVERAGE=22 DELIVERY_NOT_ALLOWED_DELIVERY_ADDRESS_NOT_IN_COVERAGE value
         * @property {number} DELIVERY_NOT_ALLOWED_DISTANCE_TOO_LONG=17 DELIVERY_NOT_ALLOWED_DISTANCE_TOO_LONG value
         * @property {number} DELIVERY_NOT_ALLOWED_OUTSIDE_OF_DELIVERY_TIME=23 DELIVERY_NOT_ALLOWED_OUTSIDE_OF_DELIVERY_TIME value
         * @property {number} DELIVERY_NOT_ALLOWED_PICKUP_ADDRESS_NOT_IN_COVERAGE=21 DELIVERY_NOT_ALLOWED_PICKUP_ADDRESS_NOT_IN_COVERAGE value
         * @property {number} DELIVERY_NOT_ALLOWED_REQUESTED_DROP_OFF_TIME_TOO_SOON=27 DELIVERY_NOT_ALLOWED_REQUESTED_DROP_OFF_TIME_TOO_SOON value
         * @property {number} DELIVERY_NOT_CONFIGURED_AT_LOCATION=28 DELIVERY_NOT_CONFIGURED_AT_LOCATION value
         * @property {number} DELIVERY_NOT_ENABLED_AT_LOCATION=15 DELIVERY_NOT_ENABLED_AT_LOCATION value
         * @property {number} EMAIL_ALREADY_IN_USE=2 EMAIL_ALREADY_IN_USE value
         * @property {number} INTERNAL_ERROR=1 INTERNAL_ERROR value
         * @property {number} INVALID_ADDRESS=9 INVALID_ADDRESS value
         * @property {number} INVALID_BUSINESS_DESCRIPTION=24 INVALID_BUSINESS_DESCRIPTION value
         * @property {number} INVALID_DELIVERY_CONFIGURATION=25 INVALID_DELIVERY_CONFIGURATION value
         * @property {number} INVALID_EMAIL=18 INVALID_EMAIL value
         * @property {number} INVALID_EMAIL_VERIFICATION_CODE=7 INVALID_EMAIL_VERIFICATION_CODE value
         * @property {number} INVALID_INPUT=3 INVALID_INPUT value
         * @property {number} INVALID_ORDER_ALCOHOL_NOT_ALLOWED=29 INVALID_ORDER_ALCOHOL_NOT_ALLOWED value
         * @property {number} INVALID_ORDER_TIME=11 INVALID_ORDER_TIME value
         * @property {number} INVALID_ORDER_TIME_IN_THE_PAST=12 INVALID_ORDER_TIME_IN_THE_PAST value
         * @property {number} INVALID_ORDER_TIME_TOO_FAR_IN_THE_FUTURE=13 INVALID_ORDER_TIME_TOO_FAR_IN_THE_FUTURE value
         * @property {number} INVALID_PHONE_NUMBER=10 INVALID_PHONE_NUMBER value
         * @property {number} INVALID_PHONE_NUMBER_VERIFICATION_CODE=8 INVALID_PHONE_NUMBER_VERIFICATION_CODE value
         * @property {number} INVALID_PICKUP_PHONE_NUMBER=26 INVALID_PICKUP_PHONE_NUMBER value
         * @property {number} INVALID_MENU=33 INVALID_MENU value
         * @property {number} INVALID_MENU_CURRENCY_FOR_LOCATION=31 INVALID_MENU_CURRENCY_FOR_LOCATION value
         * @property {number} INVALID_MENU_CURRENCY_FOR_BUSINESS=32 INVALID_MENU_CURRENCY_FOR_BUSINESS value
         * @property {number} LOCATION_ALREADY_ENROLLED_WITH_PAYMENTS=34 LOCATION_ALREADY_ENROLLED_WITH_PAYMENTS value
         * @property {number} LOCATION_OFFLINE=6 LOCATION_OFFLINE value
         * @property {number} LOCATION_WITHOUT_TAX_INFORMATION=20 LOCATION_WITHOUT_TAX_INFORMATION value
         * @property {number} LOCATION_WITHOUT_TIMEZONE=14 LOCATION_WITHOUT_TIMEZONE value
         * @property {number} LOCATIONS_IN_DIFFERENT_COUNTRIES_NOT_ALLOWED_FOR_BUSINESS=39 LOCATIONS_IN_DIFFERENT_COUNTRIES_NOT_ALLOWED_FOR_BUSINESS value
         * @property {number} NOT_FOUND=5 NOT_FOUND value
         * @property {number} PAYMENT_INVALID_AMOUNT_TOO_SMALL=35 PAYMENT_INVALID_AMOUNT_TOO_SMALL value
         * @property {number} SERVICE_SUSPENDED=4 SERVICE_SUSPENDED value
         * @property {number} USER_SUSPENDED=36 USER_SUSPENDED value
         * @property {number} USER_SUSPENDED_WAITING_FOR_EMAIL_VERIFICATION=37 USER_SUSPENDED_WAITING_FOR_EMAIL_VERIFICATION value
         * @property {number} VANITY_URL_ALREADY_IN_USE=38 VANITY_URL_ALREADY_IN_USE value
         */
        common.ErrorCode = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "ERROR_CODE_UNSPECIFIED"] = 0;
            values[valuesById[30] = "CHANGE_OF_ADDRESS_NOT_ALLOWED_OUTSIDE_COUNTRY"] = 30;
            values[valuesById[19] = "DELIVERY_FAILED_ORDER_REFUNDED"] = 19;
            values[valuesById[16] = "DELIVERY_NOT_ALLOWED"] = 16;
            values[valuesById[22] = "DELIVERY_NOT_ALLOWED_DELIVERY_ADDRESS_NOT_IN_COVERAGE"] = 22;
            values[valuesById[17] = "DELIVERY_NOT_ALLOWED_DISTANCE_TOO_LONG"] = 17;
            values[valuesById[23] = "DELIVERY_NOT_ALLOWED_OUTSIDE_OF_DELIVERY_TIME"] = 23;
            values[valuesById[21] = "DELIVERY_NOT_ALLOWED_PICKUP_ADDRESS_NOT_IN_COVERAGE"] = 21;
            values[valuesById[27] = "DELIVERY_NOT_ALLOWED_REQUESTED_DROP_OFF_TIME_TOO_SOON"] = 27;
            values[valuesById[28] = "DELIVERY_NOT_CONFIGURED_AT_LOCATION"] = 28;
            values[valuesById[15] = "DELIVERY_NOT_ENABLED_AT_LOCATION"] = 15;
            values[valuesById[2] = "EMAIL_ALREADY_IN_USE"] = 2;
            values[valuesById[1] = "INTERNAL_ERROR"] = 1;
            values[valuesById[9] = "INVALID_ADDRESS"] = 9;
            values[valuesById[24] = "INVALID_BUSINESS_DESCRIPTION"] = 24;
            values[valuesById[25] = "INVALID_DELIVERY_CONFIGURATION"] = 25;
            values[valuesById[18] = "INVALID_EMAIL"] = 18;
            values[valuesById[7] = "INVALID_EMAIL_VERIFICATION_CODE"] = 7;
            values[valuesById[3] = "INVALID_INPUT"] = 3;
            values[valuesById[29] = "INVALID_ORDER_ALCOHOL_NOT_ALLOWED"] = 29;
            values[valuesById[11] = "INVALID_ORDER_TIME"] = 11;
            values[valuesById[12] = "INVALID_ORDER_TIME_IN_THE_PAST"] = 12;
            values[valuesById[13] = "INVALID_ORDER_TIME_TOO_FAR_IN_THE_FUTURE"] = 13;
            values[valuesById[10] = "INVALID_PHONE_NUMBER"] = 10;
            values[valuesById[8] = "INVALID_PHONE_NUMBER_VERIFICATION_CODE"] = 8;
            values[valuesById[26] = "INVALID_PICKUP_PHONE_NUMBER"] = 26;
            values[valuesById[33] = "INVALID_MENU"] = 33;
            values[valuesById[31] = "INVALID_MENU_CURRENCY_FOR_LOCATION"] = 31;
            values[valuesById[32] = "INVALID_MENU_CURRENCY_FOR_BUSINESS"] = 32;
            values[valuesById[34] = "LOCATION_ALREADY_ENROLLED_WITH_PAYMENTS"] = 34;
            values[valuesById[6] = "LOCATION_OFFLINE"] = 6;
            values[valuesById[20] = "LOCATION_WITHOUT_TAX_INFORMATION"] = 20;
            values[valuesById[14] = "LOCATION_WITHOUT_TIMEZONE"] = 14;
            values[valuesById[39] = "LOCATIONS_IN_DIFFERENT_COUNTRIES_NOT_ALLOWED_FOR_BUSINESS"] = 39;
            values[valuesById[5] = "NOT_FOUND"] = 5;
            values[valuesById[35] = "PAYMENT_INVALID_AMOUNT_TOO_SMALL"] = 35;
            values[valuesById[4] = "SERVICE_SUSPENDED"] = 4;
            values[valuesById[36] = "USER_SUSPENDED"] = 36;
            values[valuesById[37] = "USER_SUSPENDED_WAITING_FOR_EMAIL_VERIFICATION"] = 37;
            values[valuesById[38] = "VANITY_URL_ALREADY_IN_USE"] = 38;
            return values;
        })();

        /**
         * Language enum.
         * @name waiternow.common.Language
         * @enum {number}
         * @property {number} LANGUAGE_UNSPECIFIED=0 LANGUAGE_UNSPECIFIED value
         * @property {number} ENGLISH=1 ENGLISH value
         * @property {number} SPANISH=2 SPANISH value
         */
        common.Language = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "LANGUAGE_UNSPECIFIED"] = 0;
            values[valuesById[1] = "ENGLISH"] = 1;
            values[valuesById[2] = "SPANISH"] = 2;
            return values;
        })();

        /**
         * QrCodeSize enum.
         * @name waiternow.common.QrCodeSize
         * @enum {number}
         * @property {number} QR_CODE_SIZE_UNSPECIFIED=0 QR_CODE_SIZE_UNSPECIFIED value
         * @property {number} SMALL=1 SMALL value
         * @property {number} SMALL_RAW=2 SMALL_RAW value
         * @property {number} SIZE_4_BY_3_INCH=3 SIZE_4_BY_3_INCH value
         * @property {number} SIZE_4_BY_4_INCH=4 SIZE_4_BY_4_INCH value
         * @property {number} SIZE_4_BY_6_INCH=5 SIZE_4_BY_6_INCH value
         */
        common.QrCodeSize = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "QR_CODE_SIZE_UNSPECIFIED"] = 0;
            values[valuesById[1] = "SMALL"] = 1;
            values[valuesById[2] = "SMALL_RAW"] = 2;
            values[valuesById[3] = "SIZE_4_BY_3_INCH"] = 3;
            values[valuesById[4] = "SIZE_4_BY_4_INCH"] = 4;
            values[valuesById[5] = "SIZE_4_BY_6_INCH"] = 5;
            return values;
        })();

        /**
         * Theme enum.
         * @name waiternow.common.Theme
         * @enum {number}
         * @property {number} THEME_UNSPECIFIED=0 THEME_UNSPECIFIED value
         * @property {number} DARK=1 DARK value
         * @property {number} LIGHT=2 LIGHT value
         */
        common.Theme = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "THEME_UNSPECIFIED"] = 0;
            values[valuesById[1] = "DARK"] = 1;
            values[valuesById[2] = "LIGHT"] = 2;
            return values;
        })();

        common.QrCodeDataProto = (function() {

            /**
             * Properties of a QrCodeDataProto.
             * @memberof waiternow.common
             * @interface IQrCodeDataProto
             * @property {string|null} [dataToEncode] QrCodeDataProto dataToEncode
             * @property {string|null} [encodedDataReference] QrCodeDataProto encodedDataReference
             * @property {string|null} [title] QrCodeDataProto title
             * @property {string|null} [subtitle] QrCodeDataProto subtitle
             */

            /**
             * Constructs a new QrCodeDataProto.
             * @memberof waiternow.common
             * @classdesc Represents a QrCodeDataProto.
             * @implements IQrCodeDataProto
             * @constructor
             * @param {waiternow.common.IQrCodeDataProto=} [properties] Properties to set
             */
            function QrCodeDataProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * QrCodeDataProto dataToEncode.
             * @member {string} dataToEncode
             * @memberof waiternow.common.QrCodeDataProto
             * @instance
             */
            QrCodeDataProto.prototype.dataToEncode = "";

            /**
             * QrCodeDataProto encodedDataReference.
             * @member {string} encodedDataReference
             * @memberof waiternow.common.QrCodeDataProto
             * @instance
             */
            QrCodeDataProto.prototype.encodedDataReference = "";

            /**
             * QrCodeDataProto title.
             * @member {string} title
             * @memberof waiternow.common.QrCodeDataProto
             * @instance
             */
            QrCodeDataProto.prototype.title = "";

            /**
             * QrCodeDataProto subtitle.
             * @member {string} subtitle
             * @memberof waiternow.common.QrCodeDataProto
             * @instance
             */
            QrCodeDataProto.prototype.subtitle = "";

            /**
             * Creates a new QrCodeDataProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.QrCodeDataProto
             * @static
             * @param {waiternow.common.IQrCodeDataProto=} [properties] Properties to set
             * @returns {waiternow.common.QrCodeDataProto} QrCodeDataProto instance
             */
            QrCodeDataProto.create = function create(properties) {
                return new QrCodeDataProto(properties);
            };

            /**
             * Encodes the specified QrCodeDataProto message. Does not implicitly {@link waiternow.common.QrCodeDataProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.QrCodeDataProto
             * @static
             * @param {waiternow.common.IQrCodeDataProto} message QrCodeDataProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            QrCodeDataProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.dataToEncode != null && Object.hasOwnProperty.call(message, "dataToEncode"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.dataToEncode);
                if (message.encodedDataReference != null && Object.hasOwnProperty.call(message, "encodedDataReference"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.encodedDataReference);
                if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.title);
                if (message.subtitle != null && Object.hasOwnProperty.call(message, "subtitle"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.subtitle);
                return writer;
            };

            /**
             * Encodes the specified QrCodeDataProto message, length delimited. Does not implicitly {@link waiternow.common.QrCodeDataProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.QrCodeDataProto
             * @static
             * @param {waiternow.common.IQrCodeDataProto} message QrCodeDataProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            QrCodeDataProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a QrCodeDataProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.QrCodeDataProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.QrCodeDataProto} QrCodeDataProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            QrCodeDataProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.QrCodeDataProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.dataToEncode = reader.string();
                            break;
                        }
                    case 2: {
                            message.encodedDataReference = reader.string();
                            break;
                        }
                    case 3: {
                            message.title = reader.string();
                            break;
                        }
                    case 5: {
                            message.subtitle = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a QrCodeDataProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.QrCodeDataProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.QrCodeDataProto} QrCodeDataProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            QrCodeDataProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a QrCodeDataProto message.
             * @function verify
             * @memberof waiternow.common.QrCodeDataProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            QrCodeDataProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.dataToEncode != null && message.hasOwnProperty("dataToEncode"))
                    if (!$util.isString(message.dataToEncode))
                        return "dataToEncode: string expected";
                if (message.encodedDataReference != null && message.hasOwnProperty("encodedDataReference"))
                    if (!$util.isString(message.encodedDataReference))
                        return "encodedDataReference: string expected";
                if (message.title != null && message.hasOwnProperty("title"))
                    if (!$util.isString(message.title))
                        return "title: string expected";
                if (message.subtitle != null && message.hasOwnProperty("subtitle"))
                    if (!$util.isString(message.subtitle))
                        return "subtitle: string expected";
                return null;
            };

            /**
             * Creates a QrCodeDataProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.QrCodeDataProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.QrCodeDataProto} QrCodeDataProto
             */
            QrCodeDataProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.QrCodeDataProto)
                    return object;
                var message = new $root.waiternow.common.QrCodeDataProto();
                if (object.dataToEncode != null)
                    message.dataToEncode = String(object.dataToEncode);
                if (object.encodedDataReference != null)
                    message.encodedDataReference = String(object.encodedDataReference);
                if (object.title != null)
                    message.title = String(object.title);
                if (object.subtitle != null)
                    message.subtitle = String(object.subtitle);
                return message;
            };

            /**
             * Creates a plain object from a QrCodeDataProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.QrCodeDataProto
             * @static
             * @param {waiternow.common.QrCodeDataProto} message QrCodeDataProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            QrCodeDataProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.dataToEncode = "";
                    object.encodedDataReference = "";
                    object.title = "";
                    object.subtitle = "";
                }
                if (message.dataToEncode != null && message.hasOwnProperty("dataToEncode"))
                    object.dataToEncode = message.dataToEncode;
                if (message.encodedDataReference != null && message.hasOwnProperty("encodedDataReference"))
                    object.encodedDataReference = message.encodedDataReference;
                if (message.title != null && message.hasOwnProperty("title"))
                    object.title = message.title;
                if (message.subtitle != null && message.hasOwnProperty("subtitle"))
                    object.subtitle = message.subtitle;
                return object;
            };

            /**
             * Converts this QrCodeDataProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.QrCodeDataProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            QrCodeDataProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for QrCodeDataProto
             * @function getTypeUrl
             * @memberof waiternow.common.QrCodeDataProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            QrCodeDataProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.QrCodeDataProto";
            };

            return QrCodeDataProto;
        })();

        /**
         * Rating enum.
         * @name waiternow.common.Rating
         * @enum {number}
         * @property {number} RATING_UNSPECIFIED=0 RATING_UNSPECIFIED value
         * @property {number} ONE_STAR=1 ONE_STAR value
         * @property {number} TWO_STARS=2 TWO_STARS value
         * @property {number} THREE_STARS=3 THREE_STARS value
         * @property {number} FOUR_STARS=4 FOUR_STARS value
         * @property {number} FIVE_STARS=5 FIVE_STARS value
         */
        common.Rating = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "RATING_UNSPECIFIED"] = 0;
            values[valuesById[1] = "ONE_STAR"] = 1;
            values[valuesById[2] = "TWO_STARS"] = 2;
            values[valuesById[3] = "THREE_STARS"] = 3;
            values[valuesById[4] = "FOUR_STARS"] = 4;
            values[valuesById[5] = "FIVE_STARS"] = 5;
            return values;
        })();

        /**
         * ThumbSignal enum.
         * @name waiternow.common.ThumbSignal
         * @enum {number}
         * @property {number} THUMB_SIGNAL_UNSPECIFIED=0 THUMB_SIGNAL_UNSPECIFIED value
         * @property {number} THUMB_UP=1 THUMB_UP value
         * @property {number} THUMB_DOWN=2 THUMB_DOWN value
         */
        common.ThumbSignal = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "THUMB_SIGNAL_UNSPECIFIED"] = 0;
            values[valuesById[1] = "THUMB_UP"] = 1;
            values[valuesById[2] = "THUMB_DOWN"] = 2;
            return values;
        })();

        /**
         * ContactMedium enum.
         * @name waiternow.common.ContactMedium
         * @enum {number}
         * @property {number} CONTACT_MEDIUM_UNSPECIFIED=0 CONTACT_MEDIUM_UNSPECIFIED value
         * @property {number} EMAIL=1 EMAIL value
         * @property {number} PHONE_CALL=2 PHONE_CALL value
         * @property {number} TEXT_MESSAGE=3 TEXT_MESSAGE value
         * @property {number} WHATS_APP=4 WHATS_APP value
         */
        common.ContactMedium = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "CONTACT_MEDIUM_UNSPECIFIED"] = 0;
            values[valuesById[1] = "EMAIL"] = 1;
            values[valuesById[2] = "PHONE_CALL"] = 2;
            values[valuesById[3] = "TEXT_MESSAGE"] = 3;
            values[valuesById[4] = "WHATS_APP"] = 4;
            return values;
        })();

        /**
         * RecordType enum.
         * @name waiternow.common.RecordType
         * @enum {number}
         * @property {number} RECORD_TYPE_UNSPECIFIED=0 RECORD_TYPE_UNSPECIFIED value
         * @property {number} REGULAR=1 REGULAR value
         * @property {number} PRE_CREATED=3 PRE_CREATED value
         * @property {number} TEST=4 TEST value
         * @property {number} DEMO=5 DEMO value
         */
        common.RecordType = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "RECORD_TYPE_UNSPECIFIED"] = 0;
            values[valuesById[1] = "REGULAR"] = 1;
            values[valuesById[3] = "PRE_CREATED"] = 3;
            values[valuesById[4] = "TEST"] = 4;
            values[valuesById[5] = "DEMO"] = 5;
            return values;
        })();

        common.TextProto = (function() {

            /**
             * Properties of a TextProto.
             * @memberof waiternow.common
             * @interface ITextProto
             * @property {string|null} [text] TextProto text
             * @property {waiternow.common.Language|null} [language] TextProto language
             * @property {Array.<waiternow.common.TextProto.ILocalizedTextProto>|null} [localizedTexts] TextProto localizedTexts
             */

            /**
             * Constructs a new TextProto.
             * @memberof waiternow.common
             * @classdesc Represents a TextProto.
             * @implements ITextProto
             * @constructor
             * @param {waiternow.common.ITextProto=} [properties] Properties to set
             */
            function TextProto(properties) {
                this.localizedTexts = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * TextProto text.
             * @member {string} text
             * @memberof waiternow.common.TextProto
             * @instance
             */
            TextProto.prototype.text = "";

            /**
             * TextProto language.
             * @member {waiternow.common.Language} language
             * @memberof waiternow.common.TextProto
             * @instance
             */
            TextProto.prototype.language = 0;

            /**
             * TextProto localizedTexts.
             * @member {Array.<waiternow.common.TextProto.ILocalizedTextProto>} localizedTexts
             * @memberof waiternow.common.TextProto
             * @instance
             */
            TextProto.prototype.localizedTexts = $util.emptyArray;

            /**
             * Creates a new TextProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.TextProto
             * @static
             * @param {waiternow.common.ITextProto=} [properties] Properties to set
             * @returns {waiternow.common.TextProto} TextProto instance
             */
            TextProto.create = function create(properties) {
                return new TextProto(properties);
            };

            /**
             * Encodes the specified TextProto message. Does not implicitly {@link waiternow.common.TextProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.TextProto
             * @static
             * @param {waiternow.common.ITextProto} message TextProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            TextProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.text != null && Object.hasOwnProperty.call(message, "text"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.text);
                if (message.localizedTexts != null && message.localizedTexts.length)
                    for (var i = 0; i < message.localizedTexts.length; ++i)
                        $root.waiternow.common.TextProto.LocalizedTextProto.encode(message.localizedTexts[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.language != null && Object.hasOwnProperty.call(message, "language"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.language);
                return writer;
            };

            /**
             * Encodes the specified TextProto message, length delimited. Does not implicitly {@link waiternow.common.TextProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.TextProto
             * @static
             * @param {waiternow.common.ITextProto} message TextProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            TextProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a TextProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.TextProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.TextProto} TextProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            TextProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.TextProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.text = reader.string();
                            break;
                        }
                    case 3: {
                            message.language = reader.int32();
                            break;
                        }
                    case 2: {
                            if (!(message.localizedTexts && message.localizedTexts.length))
                                message.localizedTexts = [];
                            message.localizedTexts.push($root.waiternow.common.TextProto.LocalizedTextProto.decode(reader, reader.uint32()));
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a TextProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.TextProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.TextProto} TextProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            TextProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a TextProto message.
             * @function verify
             * @memberof waiternow.common.TextProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            TextProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.text != null && message.hasOwnProperty("text"))
                    if (!$util.isString(message.text))
                        return "text: string expected";
                if (message.language != null && message.hasOwnProperty("language"))
                    switch (message.language) {
                    default:
                        return "language: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                        break;
                    }
                if (message.localizedTexts != null && message.hasOwnProperty("localizedTexts")) {
                    if (!Array.isArray(message.localizedTexts))
                        return "localizedTexts: array expected";
                    for (var i = 0; i < message.localizedTexts.length; ++i) {
                        var error = $root.waiternow.common.TextProto.LocalizedTextProto.verify(message.localizedTexts[i]);
                        if (error)
                            return "localizedTexts." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a TextProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.TextProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.TextProto} TextProto
             */
            TextProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.TextProto)
                    return object;
                var message = new $root.waiternow.common.TextProto();
                if (object.text != null)
                    message.text = String(object.text);
                switch (object.language) {
                default:
                    if (typeof object.language === "number") {
                        message.language = object.language;
                        break;
                    }
                    break;
                case "LANGUAGE_UNSPECIFIED":
                case 0:
                    message.language = 0;
                    break;
                case "ENGLISH":
                case 1:
                    message.language = 1;
                    break;
                case "SPANISH":
                case 2:
                    message.language = 2;
                    break;
                }
                if (object.localizedTexts) {
                    if (!Array.isArray(object.localizedTexts))
                        throw TypeError(".waiternow.common.TextProto.localizedTexts: array expected");
                    message.localizedTexts = [];
                    for (var i = 0; i < object.localizedTexts.length; ++i) {
                        if (typeof object.localizedTexts[i] !== "object")
                            throw TypeError(".waiternow.common.TextProto.localizedTexts: object expected");
                        message.localizedTexts[i] = $root.waiternow.common.TextProto.LocalizedTextProto.fromObject(object.localizedTexts[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a TextProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.TextProto
             * @static
             * @param {waiternow.common.TextProto} message TextProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            TextProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.localizedTexts = [];
                if (options.defaults) {
                    object.text = "";
                    object.language = options.enums === String ? "LANGUAGE_UNSPECIFIED" : 0;
                }
                if (message.text != null && message.hasOwnProperty("text"))
                    object.text = message.text;
                if (message.localizedTexts && message.localizedTexts.length) {
                    object.localizedTexts = [];
                    for (var j = 0; j < message.localizedTexts.length; ++j)
                        object.localizedTexts[j] = $root.waiternow.common.TextProto.LocalizedTextProto.toObject(message.localizedTexts[j], options);
                }
                if (message.language != null && message.hasOwnProperty("language"))
                    object.language = options.enums === String ? $root.waiternow.common.Language[message.language] === undefined ? message.language : $root.waiternow.common.Language[message.language] : message.language;
                return object;
            };

            /**
             * Converts this TextProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.TextProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            TextProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for TextProto
             * @function getTypeUrl
             * @memberof waiternow.common.TextProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            TextProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.TextProto";
            };

            TextProto.LocalizedTextProto = (function() {

                /**
                 * Properties of a LocalizedTextProto.
                 * @memberof waiternow.common.TextProto
                 * @interface ILocalizedTextProto
                 * @property {string|null} [text] LocalizedTextProto text
                 * @property {waiternow.common.Language|null} [language] LocalizedTextProto language
                 */

                /**
                 * Constructs a new LocalizedTextProto.
                 * @memberof waiternow.common.TextProto
                 * @classdesc Represents a LocalizedTextProto.
                 * @implements ILocalizedTextProto
                 * @constructor
                 * @param {waiternow.common.TextProto.ILocalizedTextProto=} [properties] Properties to set
                 */
                function LocalizedTextProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * LocalizedTextProto text.
                 * @member {string} text
                 * @memberof waiternow.common.TextProto.LocalizedTextProto
                 * @instance
                 */
                LocalizedTextProto.prototype.text = "";

                /**
                 * LocalizedTextProto language.
                 * @member {waiternow.common.Language} language
                 * @memberof waiternow.common.TextProto.LocalizedTextProto
                 * @instance
                 */
                LocalizedTextProto.prototype.language = 0;

                /**
                 * Creates a new LocalizedTextProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.TextProto.LocalizedTextProto
                 * @static
                 * @param {waiternow.common.TextProto.ILocalizedTextProto=} [properties] Properties to set
                 * @returns {waiternow.common.TextProto.LocalizedTextProto} LocalizedTextProto instance
                 */
                LocalizedTextProto.create = function create(properties) {
                    return new LocalizedTextProto(properties);
                };

                /**
                 * Encodes the specified LocalizedTextProto message. Does not implicitly {@link waiternow.common.TextProto.LocalizedTextProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.TextProto.LocalizedTextProto
                 * @static
                 * @param {waiternow.common.TextProto.ILocalizedTextProto} message LocalizedTextProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LocalizedTextProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.text != null && Object.hasOwnProperty.call(message, "text"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.text);
                    if (message.language != null && Object.hasOwnProperty.call(message, "language"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.language);
                    return writer;
                };

                /**
                 * Encodes the specified LocalizedTextProto message, length delimited. Does not implicitly {@link waiternow.common.TextProto.LocalizedTextProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.TextProto.LocalizedTextProto
                 * @static
                 * @param {waiternow.common.TextProto.ILocalizedTextProto} message LocalizedTextProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LocalizedTextProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a LocalizedTextProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.TextProto.LocalizedTextProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.TextProto.LocalizedTextProto} LocalizedTextProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LocalizedTextProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.TextProto.LocalizedTextProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.text = reader.string();
                                break;
                            }
                        case 2: {
                                message.language = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a LocalizedTextProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.TextProto.LocalizedTextProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.TextProto.LocalizedTextProto} LocalizedTextProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LocalizedTextProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a LocalizedTextProto message.
                 * @function verify
                 * @memberof waiternow.common.TextProto.LocalizedTextProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                LocalizedTextProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.text != null && message.hasOwnProperty("text"))
                        if (!$util.isString(message.text))
                            return "text: string expected";
                    if (message.language != null && message.hasOwnProperty("language"))
                        switch (message.language) {
                        default:
                            return "language: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    return null;
                };

                /**
                 * Creates a LocalizedTextProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.TextProto.LocalizedTextProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.TextProto.LocalizedTextProto} LocalizedTextProto
                 */
                LocalizedTextProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.TextProto.LocalizedTextProto)
                        return object;
                    var message = new $root.waiternow.common.TextProto.LocalizedTextProto();
                    if (object.text != null)
                        message.text = String(object.text);
                    switch (object.language) {
                    default:
                        if (typeof object.language === "number") {
                            message.language = object.language;
                            break;
                        }
                        break;
                    case "LANGUAGE_UNSPECIFIED":
                    case 0:
                        message.language = 0;
                        break;
                    case "ENGLISH":
                    case 1:
                        message.language = 1;
                        break;
                    case "SPANISH":
                    case 2:
                        message.language = 2;
                        break;
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a LocalizedTextProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.TextProto.LocalizedTextProto
                 * @static
                 * @param {waiternow.common.TextProto.LocalizedTextProto} message LocalizedTextProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                LocalizedTextProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.text = "";
                        object.language = options.enums === String ? "LANGUAGE_UNSPECIFIED" : 0;
                    }
                    if (message.text != null && message.hasOwnProperty("text"))
                        object.text = message.text;
                    if (message.language != null && message.hasOwnProperty("language"))
                        object.language = options.enums === String ? $root.waiternow.common.Language[message.language] === undefined ? message.language : $root.waiternow.common.Language[message.language] : message.language;
                    return object;
                };

                /**
                 * Converts this LocalizedTextProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.TextProto.LocalizedTextProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                LocalizedTextProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for LocalizedTextProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.TextProto.LocalizedTextProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                LocalizedTextProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.TextProto.LocalizedTextProto";
                };

                return LocalizedTextProto;
            })();

            return TextProto;
        })();

        common.ImageProto = (function() {

            /**
             * Properties of an ImageProto.
             * @memberof waiternow.common
             * @interface IImageProto
             * @property {string|null} [imageId] ImageProto imageId
             * @property {string|null} [imageUrl] ImageProto imageUrl
             */

            /**
             * Constructs a new ImageProto.
             * @memberof waiternow.common
             * @classdesc Represents an ImageProto.
             * @implements IImageProto
             * @constructor
             * @param {waiternow.common.IImageProto=} [properties] Properties to set
             */
            function ImageProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ImageProto imageId.
             * @member {string} imageId
             * @memberof waiternow.common.ImageProto
             * @instance
             */
            ImageProto.prototype.imageId = "";

            /**
             * ImageProto imageUrl.
             * @member {string} imageUrl
             * @memberof waiternow.common.ImageProto
             * @instance
             */
            ImageProto.prototype.imageUrl = "";

            /**
             * Creates a new ImageProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.ImageProto
             * @static
             * @param {waiternow.common.IImageProto=} [properties] Properties to set
             * @returns {waiternow.common.ImageProto} ImageProto instance
             */
            ImageProto.create = function create(properties) {
                return new ImageProto(properties);
            };

            /**
             * Encodes the specified ImageProto message. Does not implicitly {@link waiternow.common.ImageProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.ImageProto
             * @static
             * @param {waiternow.common.IImageProto} message ImageProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ImageProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.imageId != null && Object.hasOwnProperty.call(message, "imageId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.imageId);
                if (message.imageUrl != null && Object.hasOwnProperty.call(message, "imageUrl"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.imageUrl);
                return writer;
            };

            /**
             * Encodes the specified ImageProto message, length delimited. Does not implicitly {@link waiternow.common.ImageProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.ImageProto
             * @static
             * @param {waiternow.common.IImageProto} message ImageProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ImageProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an ImageProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.ImageProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.ImageProto} ImageProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ImageProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.ImageProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.imageId = reader.string();
                            break;
                        }
                    case 2: {
                            message.imageUrl = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an ImageProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.ImageProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.ImageProto} ImageProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ImageProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an ImageProto message.
             * @function verify
             * @memberof waiternow.common.ImageProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ImageProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.imageId != null && message.hasOwnProperty("imageId"))
                    if (!$util.isString(message.imageId))
                        return "imageId: string expected";
                if (message.imageUrl != null && message.hasOwnProperty("imageUrl"))
                    if (!$util.isString(message.imageUrl))
                        return "imageUrl: string expected";
                return null;
            };

            /**
             * Creates an ImageProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.ImageProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.ImageProto} ImageProto
             */
            ImageProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.ImageProto)
                    return object;
                var message = new $root.waiternow.common.ImageProto();
                if (object.imageId != null)
                    message.imageId = String(object.imageId);
                if (object.imageUrl != null)
                    message.imageUrl = String(object.imageUrl);
                return message;
            };

            /**
             * Creates a plain object from an ImageProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.ImageProto
             * @static
             * @param {waiternow.common.ImageProto} message ImageProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ImageProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.imageId = "";
                    object.imageUrl = "";
                }
                if (message.imageId != null && message.hasOwnProperty("imageId"))
                    object.imageId = message.imageId;
                if (message.imageUrl != null && message.hasOwnProperty("imageUrl"))
                    object.imageUrl = message.imageUrl;
                return object;
            };

            /**
             * Converts this ImageProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.ImageProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ImageProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for ImageProto
             * @function getTypeUrl
             * @memberof waiternow.common.ImageProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            ImageProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.ImageProto";
            };

            return ImageProto;
        })();

        /**
         * SelectionType enum.
         * @name waiternow.common.SelectionType
         * @enum {number}
         * @property {number} SELECTION_TYPE_UNSPECIFIED=0 SELECTION_TYPE_UNSPECIFIED value
         * @property {number} SINGLE=1 SINGLE value
         * @property {number} MULTIPLE=2 MULTIPLE value
         */
        common.SelectionType = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "SELECTION_TYPE_UNSPECIFIED"] = 0;
            values[valuesById[1] = "SINGLE"] = 1;
            values[valuesById[2] = "MULTIPLE"] = 2;
            return values;
        })();

        /**
         * ReachMedium enum.
         * @name waiternow.common.ReachMedium
         * @enum {number}
         * @property {number} REACH_MEDIUM_UNDEFINED=0 REACH_MEDIUM_UNDEFINED value
         * @property {number} GOOGLE=1 GOOGLE value
         * @property {number} FACEBOOK=2 FACEBOOK value
         * @property {number} INSTRAGRAM=3 INSTRAGRAM value
         * @property {number} LINKED_IN=4 LINKED_IN value
         * @property {number} RECOMMENDATION=5 RECOMMENDATION value
         * @property {number} SALESPERSON=6 SALESPERSON value
         * @property {number} OTHER=7 OTHER value
         */
        common.ReachMedium = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "REACH_MEDIUM_UNDEFINED"] = 0;
            values[valuesById[1] = "GOOGLE"] = 1;
            values[valuesById[2] = "FACEBOOK"] = 2;
            values[valuesById[3] = "INSTRAGRAM"] = 3;
            values[valuesById[4] = "LINKED_IN"] = 4;
            values[valuesById[5] = "RECOMMENDATION"] = 5;
            values[valuesById[6] = "SALESPERSON"] = 6;
            values[valuesById[7] = "OTHER"] = 7;
            return values;
        })();

        common.PeriodProto = (function() {

            /**
             * Properties of a PeriodProto.
             * @memberof waiternow.common
             * @interface IPeriodProto
             * @property {number|null} [year] PeriodProto year
             * @property {waiternow.common.Month|null} [month] PeriodProto month
             * @property {waiternow.common.ITimestampRangeProto|null} [range] PeriodProto range
             */

            /**
             * Constructs a new PeriodProto.
             * @memberof waiternow.common
             * @classdesc Represents a PeriodProto.
             * @implements IPeriodProto
             * @constructor
             * @param {waiternow.common.IPeriodProto=} [properties] Properties to set
             */
            function PeriodProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * PeriodProto year.
             * @member {number} year
             * @memberof waiternow.common.PeriodProto
             * @instance
             */
            PeriodProto.prototype.year = 0;

            /**
             * PeriodProto month.
             * @member {waiternow.common.Month} month
             * @memberof waiternow.common.PeriodProto
             * @instance
             */
            PeriodProto.prototype.month = 0;

            /**
             * PeriodProto range.
             * @member {waiternow.common.ITimestampRangeProto|null|undefined} range
             * @memberof waiternow.common.PeriodProto
             * @instance
             */
            PeriodProto.prototype.range = null;

            /**
             * Creates a new PeriodProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.PeriodProto
             * @static
             * @param {waiternow.common.IPeriodProto=} [properties] Properties to set
             * @returns {waiternow.common.PeriodProto} PeriodProto instance
             */
            PeriodProto.create = function create(properties) {
                return new PeriodProto(properties);
            };

            /**
             * Encodes the specified PeriodProto message. Does not implicitly {@link waiternow.common.PeriodProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.PeriodProto
             * @static
             * @param {waiternow.common.IPeriodProto} message PeriodProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PeriodProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.year != null && Object.hasOwnProperty.call(message, "year"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.year);
                if (message.month != null && Object.hasOwnProperty.call(message, "month"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.month);
                if (message.range != null && Object.hasOwnProperty.call(message, "range"))
                    $root.waiternow.common.TimestampRangeProto.encode(message.range, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified PeriodProto message, length delimited. Does not implicitly {@link waiternow.common.PeriodProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.PeriodProto
             * @static
             * @param {waiternow.common.IPeriodProto} message PeriodProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PeriodProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a PeriodProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.PeriodProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.PeriodProto} PeriodProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PeriodProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PeriodProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.year = reader.int32();
                            break;
                        }
                    case 2: {
                            message.month = reader.int32();
                            break;
                        }
                    case 3: {
                            message.range = $root.waiternow.common.TimestampRangeProto.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a PeriodProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.PeriodProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.PeriodProto} PeriodProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PeriodProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a PeriodProto message.
             * @function verify
             * @memberof waiternow.common.PeriodProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            PeriodProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.year != null && message.hasOwnProperty("year"))
                    if (!$util.isInteger(message.year))
                        return "year: integer expected";
                if (message.month != null && message.hasOwnProperty("month"))
                    switch (message.month) {
                    default:
                        return "month: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                    case 9:
                    case 10:
                    case 11:
                    case 12:
                        break;
                    }
                if (message.range != null && message.hasOwnProperty("range")) {
                    var error = $root.waiternow.common.TimestampRangeProto.verify(message.range);
                    if (error)
                        return "range." + error;
                }
                return null;
            };

            /**
             * Creates a PeriodProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.PeriodProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.PeriodProto} PeriodProto
             */
            PeriodProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.PeriodProto)
                    return object;
                var message = new $root.waiternow.common.PeriodProto();
                if (object.year != null)
                    message.year = object.year | 0;
                switch (object.month) {
                default:
                    if (typeof object.month === "number") {
                        message.month = object.month;
                        break;
                    }
                    break;
                case "MONTH_UNSPECIFIED":
                case 0:
                    message.month = 0;
                    break;
                case "JANUARY":
                case 1:
                    message.month = 1;
                    break;
                case "FEBRUARY":
                case 2:
                    message.month = 2;
                    break;
                case "MARCH":
                case 3:
                    message.month = 3;
                    break;
                case "APRIL":
                case 4:
                    message.month = 4;
                    break;
                case "MAY":
                case 5:
                    message.month = 5;
                    break;
                case "JUNE":
                case 6:
                    message.month = 6;
                    break;
                case "JULY":
                case 7:
                    message.month = 7;
                    break;
                case "AUGUST":
                case 8:
                    message.month = 8;
                    break;
                case "SEPTEMBER":
                case 9:
                    message.month = 9;
                    break;
                case "OCTOBER":
                case 10:
                    message.month = 10;
                    break;
                case "NOVEMBER":
                case 11:
                    message.month = 11;
                    break;
                case "DECEMBER":
                case 12:
                    message.month = 12;
                    break;
                }
                if (object.range != null) {
                    if (typeof object.range !== "object")
                        throw TypeError(".waiternow.common.PeriodProto.range: object expected");
                    message.range = $root.waiternow.common.TimestampRangeProto.fromObject(object.range);
                }
                return message;
            };

            /**
             * Creates a plain object from a PeriodProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.PeriodProto
             * @static
             * @param {waiternow.common.PeriodProto} message PeriodProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            PeriodProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.year = 0;
                    object.month = options.enums === String ? "MONTH_UNSPECIFIED" : 0;
                    object.range = null;
                }
                if (message.year != null && message.hasOwnProperty("year"))
                    object.year = message.year;
                if (message.month != null && message.hasOwnProperty("month"))
                    object.month = options.enums === String ? $root.waiternow.common.Month[message.month] === undefined ? message.month : $root.waiternow.common.Month[message.month] : message.month;
                if (message.range != null && message.hasOwnProperty("range"))
                    object.range = $root.waiternow.common.TimestampRangeProto.toObject(message.range, options);
                return object;
            };

            /**
             * Converts this PeriodProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.PeriodProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            PeriodProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for PeriodProto
             * @function getTypeUrl
             * @memberof waiternow.common.PeriodProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            PeriodProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.PeriodProto";
            };

            return PeriodProto;
        })();

        /**
         * EmailRecipient enum.
         * @name waiternow.common.EmailRecipient
         * @enum {number}
         * @property {number} EMAIL_RECIPIENT_UNSPECIFIED=0 EMAIL_RECIPIENT_UNSPECIFIED value
         * @property {number} INFO=1 INFO value
         * @property {number} SYSTEM=2 SYSTEM value
         * @property {number} SUPPORT=3 SUPPORT value
         * @property {number} CONTACT=4 CONTACT value
         * @property {number} FEEDBACK=5 FEEDBACK value
         * @property {number} SALES=6 SALES value
         * @property {number} BILLING=7 BILLING value
         * @property {number} QR_CODE_SALES=8 QR_CODE_SALES value
         */
        common.EmailRecipient = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "EMAIL_RECIPIENT_UNSPECIFIED"] = 0;
            values[valuesById[1] = "INFO"] = 1;
            values[valuesById[2] = "SYSTEM"] = 2;
            values[valuesById[3] = "SUPPORT"] = 3;
            values[valuesById[4] = "CONTACT"] = 4;
            values[valuesById[5] = "FEEDBACK"] = 5;
            values[valuesById[6] = "SALES"] = 6;
            values[valuesById[7] = "BILLING"] = 7;
            values[valuesById[8] = "QR_CODE_SALES"] = 8;
            return values;
        })();

        common.ContinuationTokenProto = (function() {

            /**
             * Properties of a ContinuationTokenProto.
             * @memberof waiternow.common
             * @interface IContinuationTokenProto
             * @property {string|null} [lastFetchedId] ContinuationTokenProto lastFetchedId
             * @property {google.protobuf.ITimestamp|null} [lastFetchedTimestamp] ContinuationTokenProto lastFetchedTimestamp
             */

            /**
             * Constructs a new ContinuationTokenProto.
             * @memberof waiternow.common
             * @classdesc Represents a ContinuationTokenProto.
             * @implements IContinuationTokenProto
             * @constructor
             * @param {waiternow.common.IContinuationTokenProto=} [properties] Properties to set
             */
            function ContinuationTokenProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ContinuationTokenProto lastFetchedId.
             * @member {string} lastFetchedId
             * @memberof waiternow.common.ContinuationTokenProto
             * @instance
             */
            ContinuationTokenProto.prototype.lastFetchedId = "";

            /**
             * ContinuationTokenProto lastFetchedTimestamp.
             * @member {google.protobuf.ITimestamp|null|undefined} lastFetchedTimestamp
             * @memberof waiternow.common.ContinuationTokenProto
             * @instance
             */
            ContinuationTokenProto.prototype.lastFetchedTimestamp = null;

            /**
             * Creates a new ContinuationTokenProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.ContinuationTokenProto
             * @static
             * @param {waiternow.common.IContinuationTokenProto=} [properties] Properties to set
             * @returns {waiternow.common.ContinuationTokenProto} ContinuationTokenProto instance
             */
            ContinuationTokenProto.create = function create(properties) {
                return new ContinuationTokenProto(properties);
            };

            /**
             * Encodes the specified ContinuationTokenProto message. Does not implicitly {@link waiternow.common.ContinuationTokenProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.ContinuationTokenProto
             * @static
             * @param {waiternow.common.IContinuationTokenProto} message ContinuationTokenProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ContinuationTokenProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.lastFetchedId != null && Object.hasOwnProperty.call(message, "lastFetchedId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.lastFetchedId);
                if (message.lastFetchedTimestamp != null && Object.hasOwnProperty.call(message, "lastFetchedTimestamp"))
                    $root.google.protobuf.Timestamp.encode(message.lastFetchedTimestamp, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified ContinuationTokenProto message, length delimited. Does not implicitly {@link waiternow.common.ContinuationTokenProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.ContinuationTokenProto
             * @static
             * @param {waiternow.common.IContinuationTokenProto} message ContinuationTokenProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ContinuationTokenProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ContinuationTokenProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.ContinuationTokenProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.ContinuationTokenProto} ContinuationTokenProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ContinuationTokenProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.ContinuationTokenProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.lastFetchedId = reader.string();
                            break;
                        }
                    case 2: {
                            message.lastFetchedTimestamp = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ContinuationTokenProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.ContinuationTokenProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.ContinuationTokenProto} ContinuationTokenProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ContinuationTokenProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ContinuationTokenProto message.
             * @function verify
             * @memberof waiternow.common.ContinuationTokenProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ContinuationTokenProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.lastFetchedId != null && message.hasOwnProperty("lastFetchedId"))
                    if (!$util.isString(message.lastFetchedId))
                        return "lastFetchedId: string expected";
                if (message.lastFetchedTimestamp != null && message.hasOwnProperty("lastFetchedTimestamp")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.lastFetchedTimestamp);
                    if (error)
                        return "lastFetchedTimestamp." + error;
                }
                return null;
            };

            /**
             * Creates a ContinuationTokenProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.ContinuationTokenProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.ContinuationTokenProto} ContinuationTokenProto
             */
            ContinuationTokenProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.ContinuationTokenProto)
                    return object;
                var message = new $root.waiternow.common.ContinuationTokenProto();
                if (object.lastFetchedId != null)
                    message.lastFetchedId = String(object.lastFetchedId);
                if (object.lastFetchedTimestamp != null) {
                    if (typeof object.lastFetchedTimestamp !== "object")
                        throw TypeError(".waiternow.common.ContinuationTokenProto.lastFetchedTimestamp: object expected");
                    message.lastFetchedTimestamp = $root.google.protobuf.Timestamp.fromObject(object.lastFetchedTimestamp);
                }
                return message;
            };

            /**
             * Creates a plain object from a ContinuationTokenProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.ContinuationTokenProto
             * @static
             * @param {waiternow.common.ContinuationTokenProto} message ContinuationTokenProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ContinuationTokenProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.lastFetchedId = "";
                    object.lastFetchedTimestamp = null;
                }
                if (message.lastFetchedId != null && message.hasOwnProperty("lastFetchedId"))
                    object.lastFetchedId = message.lastFetchedId;
                if (message.lastFetchedTimestamp != null && message.hasOwnProperty("lastFetchedTimestamp"))
                    object.lastFetchedTimestamp = $root.google.protobuf.Timestamp.toObject(message.lastFetchedTimestamp, options);
                return object;
            };

            /**
             * Converts this ContinuationTokenProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.ContinuationTokenProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ContinuationTokenProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for ContinuationTokenProto
             * @function getTypeUrl
             * @memberof waiternow.common.ContinuationTokenProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            ContinuationTokenProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.ContinuationTokenProto";
            };

            return ContinuationTokenProto;
        })();

        common.TaxesProto = (function() {

            /**
             * Properties of a TaxesProto.
             * @memberof waiternow.common
             * @interface ITaxesProto
             * @property {waiternow.common.IDecimalProto|null} [salesTax] TaxesProto salesTax
             * @property {waiternow.common.TaxesProto.Type|null} [salesTaxType] TaxesProto salesTaxType
             * @property {Array.<waiternow.common.TaxesProto.ITaxProto>|null} [additionalTaxes] TaxesProto additionalTaxes
             */

            /**
             * Constructs a new TaxesProto.
             * @memberof waiternow.common
             * @classdesc Represents a TaxesProto.
             * @implements ITaxesProto
             * @constructor
             * @param {waiternow.common.ITaxesProto=} [properties] Properties to set
             */
            function TaxesProto(properties) {
                this.additionalTaxes = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * TaxesProto salesTax.
             * @member {waiternow.common.IDecimalProto|null|undefined} salesTax
             * @memberof waiternow.common.TaxesProto
             * @instance
             */
            TaxesProto.prototype.salesTax = null;

            /**
             * TaxesProto salesTaxType.
             * @member {waiternow.common.TaxesProto.Type} salesTaxType
             * @memberof waiternow.common.TaxesProto
             * @instance
             */
            TaxesProto.prototype.salesTaxType = 0;

            /**
             * TaxesProto additionalTaxes.
             * @member {Array.<waiternow.common.TaxesProto.ITaxProto>} additionalTaxes
             * @memberof waiternow.common.TaxesProto
             * @instance
             */
            TaxesProto.prototype.additionalTaxes = $util.emptyArray;

            /**
             * Creates a new TaxesProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.TaxesProto
             * @static
             * @param {waiternow.common.ITaxesProto=} [properties] Properties to set
             * @returns {waiternow.common.TaxesProto} TaxesProto instance
             */
            TaxesProto.create = function create(properties) {
                return new TaxesProto(properties);
            };

            /**
             * Encodes the specified TaxesProto message. Does not implicitly {@link waiternow.common.TaxesProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.TaxesProto
             * @static
             * @param {waiternow.common.ITaxesProto} message TaxesProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            TaxesProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.salesTax != null && Object.hasOwnProperty.call(message, "salesTax"))
                    $root.waiternow.common.DecimalProto.encode(message.salesTax, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.salesTaxType != null && Object.hasOwnProperty.call(message, "salesTaxType"))
                    writer.uint32(/* id 4, wireType 0 =*/32).int32(message.salesTaxType);
                if (message.additionalTaxes != null && message.additionalTaxes.length)
                    for (var i = 0; i < message.additionalTaxes.length; ++i)
                        $root.waiternow.common.TaxesProto.TaxProto.encode(message.additionalTaxes[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified TaxesProto message, length delimited. Does not implicitly {@link waiternow.common.TaxesProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.TaxesProto
             * @static
             * @param {waiternow.common.ITaxesProto} message TaxesProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            TaxesProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a TaxesProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.TaxesProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.TaxesProto} TaxesProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            TaxesProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.TaxesProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 3: {
                            message.salesTax = $root.waiternow.common.DecimalProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 4: {
                            message.salesTaxType = reader.int32();
                            break;
                        }
                    case 5: {
                            if (!(message.additionalTaxes && message.additionalTaxes.length))
                                message.additionalTaxes = [];
                            message.additionalTaxes.push($root.waiternow.common.TaxesProto.TaxProto.decode(reader, reader.uint32()));
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a TaxesProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.TaxesProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.TaxesProto} TaxesProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            TaxesProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a TaxesProto message.
             * @function verify
             * @memberof waiternow.common.TaxesProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            TaxesProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.salesTax != null && message.hasOwnProperty("salesTax")) {
                    var error = $root.waiternow.common.DecimalProto.verify(message.salesTax);
                    if (error)
                        return "salesTax." + error;
                }
                if (message.salesTaxType != null && message.hasOwnProperty("salesTaxType"))
                    switch (message.salesTaxType) {
                    default:
                        return "salesTaxType: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                        break;
                    }
                if (message.additionalTaxes != null && message.hasOwnProperty("additionalTaxes")) {
                    if (!Array.isArray(message.additionalTaxes))
                        return "additionalTaxes: array expected";
                    for (var i = 0; i < message.additionalTaxes.length; ++i) {
                        var error = $root.waiternow.common.TaxesProto.TaxProto.verify(message.additionalTaxes[i]);
                        if (error)
                            return "additionalTaxes." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a TaxesProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.TaxesProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.TaxesProto} TaxesProto
             */
            TaxesProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.TaxesProto)
                    return object;
                var message = new $root.waiternow.common.TaxesProto();
                if (object.salesTax != null) {
                    if (typeof object.salesTax !== "object")
                        throw TypeError(".waiternow.common.TaxesProto.salesTax: object expected");
                    message.salesTax = $root.waiternow.common.DecimalProto.fromObject(object.salesTax);
                }
                switch (object.salesTaxType) {
                default:
                    if (typeof object.salesTaxType === "number") {
                        message.salesTaxType = object.salesTaxType;
                        break;
                    }
                    break;
                case "TYPE_UNSPECIFIED":
                case 0:
                    message.salesTaxType = 0;
                    break;
                case "UNALTERABLE":
                case 1:
                    message.salesTaxType = 1;
                    break;
                case "FALLBACK":
                case 2:
                    message.salesTaxType = 2;
                    break;
                }
                if (object.additionalTaxes) {
                    if (!Array.isArray(object.additionalTaxes))
                        throw TypeError(".waiternow.common.TaxesProto.additionalTaxes: array expected");
                    message.additionalTaxes = [];
                    for (var i = 0; i < object.additionalTaxes.length; ++i) {
                        if (typeof object.additionalTaxes[i] !== "object")
                            throw TypeError(".waiternow.common.TaxesProto.additionalTaxes: object expected");
                        message.additionalTaxes[i] = $root.waiternow.common.TaxesProto.TaxProto.fromObject(object.additionalTaxes[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a TaxesProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.TaxesProto
             * @static
             * @param {waiternow.common.TaxesProto} message TaxesProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            TaxesProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.additionalTaxes = [];
                if (options.defaults) {
                    object.salesTax = null;
                    object.salesTaxType = options.enums === String ? "TYPE_UNSPECIFIED" : 0;
                }
                if (message.salesTax != null && message.hasOwnProperty("salesTax"))
                    object.salesTax = $root.waiternow.common.DecimalProto.toObject(message.salesTax, options);
                if (message.salesTaxType != null && message.hasOwnProperty("salesTaxType"))
                    object.salesTaxType = options.enums === String ? $root.waiternow.common.TaxesProto.Type[message.salesTaxType] === undefined ? message.salesTaxType : $root.waiternow.common.TaxesProto.Type[message.salesTaxType] : message.salesTaxType;
                if (message.additionalTaxes && message.additionalTaxes.length) {
                    object.additionalTaxes = [];
                    for (var j = 0; j < message.additionalTaxes.length; ++j)
                        object.additionalTaxes[j] = $root.waiternow.common.TaxesProto.TaxProto.toObject(message.additionalTaxes[j], options);
                }
                return object;
            };

            /**
             * Converts this TaxesProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.TaxesProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            TaxesProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for TaxesProto
             * @function getTypeUrl
             * @memberof waiternow.common.TaxesProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            TaxesProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.TaxesProto";
            };

            /**
             * Type enum.
             * @name waiternow.common.TaxesProto.Type
             * @enum {number}
             * @property {number} TYPE_UNSPECIFIED=0 TYPE_UNSPECIFIED value
             * @property {number} UNALTERABLE=1 UNALTERABLE value
             * @property {number} FALLBACK=2 FALLBACK value
             */
            TaxesProto.Type = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "TYPE_UNSPECIFIED"] = 0;
                values[valuesById[1] = "UNALTERABLE"] = 1;
                values[valuesById[2] = "FALLBACK"] = 2;
                return values;
            })();

            TaxesProto.TaxProto = (function() {

                /**
                 * Properties of a TaxProto.
                 * @memberof waiternow.common.TaxesProto
                 * @interface ITaxProto
                 * @property {waiternow.common.ITextProto|null} [name] TaxProto name
                 * @property {waiternow.common.IDecimalProto|null} [rate] TaxProto rate
                 */

                /**
                 * Constructs a new TaxProto.
                 * @memberof waiternow.common.TaxesProto
                 * @classdesc Represents a TaxProto.
                 * @implements ITaxProto
                 * @constructor
                 * @param {waiternow.common.TaxesProto.ITaxProto=} [properties] Properties to set
                 */
                function TaxProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * TaxProto name.
                 * @member {waiternow.common.ITextProto|null|undefined} name
                 * @memberof waiternow.common.TaxesProto.TaxProto
                 * @instance
                 */
                TaxProto.prototype.name = null;

                /**
                 * TaxProto rate.
                 * @member {waiternow.common.IDecimalProto|null|undefined} rate
                 * @memberof waiternow.common.TaxesProto.TaxProto
                 * @instance
                 */
                TaxProto.prototype.rate = null;

                /**
                 * Creates a new TaxProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.TaxesProto.TaxProto
                 * @static
                 * @param {waiternow.common.TaxesProto.ITaxProto=} [properties] Properties to set
                 * @returns {waiternow.common.TaxesProto.TaxProto} TaxProto instance
                 */
                TaxProto.create = function create(properties) {
                    return new TaxProto(properties);
                };

                /**
                 * Encodes the specified TaxProto message. Does not implicitly {@link waiternow.common.TaxesProto.TaxProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.TaxesProto.TaxProto
                 * @static
                 * @param {waiternow.common.TaxesProto.ITaxProto} message TaxProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                TaxProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        $root.waiternow.common.TextProto.encode(message.name, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.rate != null && Object.hasOwnProperty.call(message, "rate"))
                        $root.waiternow.common.DecimalProto.encode(message.rate, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified TaxProto message, length delimited. Does not implicitly {@link waiternow.common.TaxesProto.TaxProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.TaxesProto.TaxProto
                 * @static
                 * @param {waiternow.common.TaxesProto.ITaxProto} message TaxProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                TaxProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a TaxProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.TaxesProto.TaxProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.TaxesProto.TaxProto} TaxProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                TaxProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.TaxesProto.TaxProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.name = $root.waiternow.common.TextProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.rate = $root.waiternow.common.DecimalProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a TaxProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.TaxesProto.TaxProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.TaxesProto.TaxProto} TaxProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                TaxProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a TaxProto message.
                 * @function verify
                 * @memberof waiternow.common.TaxesProto.TaxProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                TaxProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.name != null && message.hasOwnProperty("name")) {
                        var error = $root.waiternow.common.TextProto.verify(message.name);
                        if (error)
                            return "name." + error;
                    }
                    if (message.rate != null && message.hasOwnProperty("rate")) {
                        var error = $root.waiternow.common.DecimalProto.verify(message.rate);
                        if (error)
                            return "rate." + error;
                    }
                    return null;
                };

                /**
                 * Creates a TaxProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.TaxesProto.TaxProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.TaxesProto.TaxProto} TaxProto
                 */
                TaxProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.TaxesProto.TaxProto)
                        return object;
                    var message = new $root.waiternow.common.TaxesProto.TaxProto();
                    if (object.name != null) {
                        if (typeof object.name !== "object")
                            throw TypeError(".waiternow.common.TaxesProto.TaxProto.name: object expected");
                        message.name = $root.waiternow.common.TextProto.fromObject(object.name);
                    }
                    if (object.rate != null) {
                        if (typeof object.rate !== "object")
                            throw TypeError(".waiternow.common.TaxesProto.TaxProto.rate: object expected");
                        message.rate = $root.waiternow.common.DecimalProto.fromObject(object.rate);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a TaxProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.TaxesProto.TaxProto
                 * @static
                 * @param {waiternow.common.TaxesProto.TaxProto} message TaxProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                TaxProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.name = null;
                        object.rate = null;
                    }
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = $root.waiternow.common.TextProto.toObject(message.name, options);
                    if (message.rate != null && message.hasOwnProperty("rate"))
                        object.rate = $root.waiternow.common.DecimalProto.toObject(message.rate, options);
                    return object;
                };

                /**
                 * Converts this TaxProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.TaxesProto.TaxProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                TaxProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for TaxProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.TaxesProto.TaxProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                TaxProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.TaxesProto.TaxProto";
                };

                return TaxProto;
            })();

            return TaxesProto;
        })();

        /**
         * SortOrder enum.
         * @name waiternow.common.SortOrder
         * @enum {number}
         * @property {number} SORT_ORDER_UNSPECIFIED=0 SORT_ORDER_UNSPECIFIED value
         * @property {number} ASCENDING=1 ASCENDING value
         * @property {number} DESCENDING=2 DESCENDING value
         */
        common.SortOrder = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "SORT_ORDER_UNSPECIFIED"] = 0;
            values[valuesById[1] = "ASCENDING"] = 1;
            values[valuesById[2] = "DESCENDING"] = 2;
            return values;
        })();

        common.DerivedQuantityConfigProto = (function() {

            /**
             * Properties of a DerivedQuantityConfigProto.
             * @memberof waiternow.common
             * @interface IDerivedQuantityConfigProto
             * @property {waiternow.common.IMoneyProto|null} [fixedAmount] DerivedQuantityConfigProto fixedAmount
             * @property {waiternow.common.IDecimalProto|null} [rate] DerivedQuantityConfigProto rate
             */

            /**
             * Constructs a new DerivedQuantityConfigProto.
             * @memberof waiternow.common
             * @classdesc Represents a DerivedQuantityConfigProto.
             * @implements IDerivedQuantityConfigProto
             * @constructor
             * @param {waiternow.common.IDerivedQuantityConfigProto=} [properties] Properties to set
             */
            function DerivedQuantityConfigProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * DerivedQuantityConfigProto fixedAmount.
             * @member {waiternow.common.IMoneyProto|null|undefined} fixedAmount
             * @memberof waiternow.common.DerivedQuantityConfigProto
             * @instance
             */
            DerivedQuantityConfigProto.prototype.fixedAmount = null;

            /**
             * DerivedQuantityConfigProto rate.
             * @member {waiternow.common.IDecimalProto|null|undefined} rate
             * @memberof waiternow.common.DerivedQuantityConfigProto
             * @instance
             */
            DerivedQuantityConfigProto.prototype.rate = null;

            /**
             * Creates a new DerivedQuantityConfigProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.DerivedQuantityConfigProto
             * @static
             * @param {waiternow.common.IDerivedQuantityConfigProto=} [properties] Properties to set
             * @returns {waiternow.common.DerivedQuantityConfigProto} DerivedQuantityConfigProto instance
             */
            DerivedQuantityConfigProto.create = function create(properties) {
                return new DerivedQuantityConfigProto(properties);
            };

            /**
             * Encodes the specified DerivedQuantityConfigProto message. Does not implicitly {@link waiternow.common.DerivedQuantityConfigProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.DerivedQuantityConfigProto
             * @static
             * @param {waiternow.common.IDerivedQuantityConfigProto} message DerivedQuantityConfigProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DerivedQuantityConfigProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.fixedAmount != null && Object.hasOwnProperty.call(message, "fixedAmount"))
                    $root.waiternow.common.MoneyProto.encode(message.fixedAmount, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.rate != null && Object.hasOwnProperty.call(message, "rate"))
                    $root.waiternow.common.DecimalProto.encode(message.rate, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified DerivedQuantityConfigProto message, length delimited. Does not implicitly {@link waiternow.common.DerivedQuantityConfigProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.DerivedQuantityConfigProto
             * @static
             * @param {waiternow.common.IDerivedQuantityConfigProto} message DerivedQuantityConfigProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DerivedQuantityConfigProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a DerivedQuantityConfigProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.DerivedQuantityConfigProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.DerivedQuantityConfigProto} DerivedQuantityConfigProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DerivedQuantityConfigProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.DerivedQuantityConfigProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 2: {
                            message.fixedAmount = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 3: {
                            message.rate = $root.waiternow.common.DecimalProto.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a DerivedQuantityConfigProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.DerivedQuantityConfigProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.DerivedQuantityConfigProto} DerivedQuantityConfigProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DerivedQuantityConfigProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a DerivedQuantityConfigProto message.
             * @function verify
             * @memberof waiternow.common.DerivedQuantityConfigProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            DerivedQuantityConfigProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.fixedAmount != null && message.hasOwnProperty("fixedAmount")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.fixedAmount);
                    if (error)
                        return "fixedAmount." + error;
                }
                if (message.rate != null && message.hasOwnProperty("rate")) {
                    var error = $root.waiternow.common.DecimalProto.verify(message.rate);
                    if (error)
                        return "rate." + error;
                }
                return null;
            };

            /**
             * Creates a DerivedQuantityConfigProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.DerivedQuantityConfigProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.DerivedQuantityConfigProto} DerivedQuantityConfigProto
             */
            DerivedQuantityConfigProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.DerivedQuantityConfigProto)
                    return object;
                var message = new $root.waiternow.common.DerivedQuantityConfigProto();
                if (object.fixedAmount != null) {
                    if (typeof object.fixedAmount !== "object")
                        throw TypeError(".waiternow.common.DerivedQuantityConfigProto.fixedAmount: object expected");
                    message.fixedAmount = $root.waiternow.common.MoneyProto.fromObject(object.fixedAmount);
                }
                if (object.rate != null) {
                    if (typeof object.rate !== "object")
                        throw TypeError(".waiternow.common.DerivedQuantityConfigProto.rate: object expected");
                    message.rate = $root.waiternow.common.DecimalProto.fromObject(object.rate);
                }
                return message;
            };

            /**
             * Creates a plain object from a DerivedQuantityConfigProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.DerivedQuantityConfigProto
             * @static
             * @param {waiternow.common.DerivedQuantityConfigProto} message DerivedQuantityConfigProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            DerivedQuantityConfigProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.fixedAmount = null;
                    object.rate = null;
                }
                if (message.fixedAmount != null && message.hasOwnProperty("fixedAmount"))
                    object.fixedAmount = $root.waiternow.common.MoneyProto.toObject(message.fixedAmount, options);
                if (message.rate != null && message.hasOwnProperty("rate"))
                    object.rate = $root.waiternow.common.DecimalProto.toObject(message.rate, options);
                return object;
            };

            /**
             * Converts this DerivedQuantityConfigProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.DerivedQuantityConfigProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            DerivedQuantityConfigProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for DerivedQuantityConfigProto
             * @function getTypeUrl
             * @memberof waiternow.common.DerivedQuantityConfigProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            DerivedQuantityConfigProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.DerivedQuantityConfigProto";
            };

            return DerivedQuantityConfigProto;
        })();

        /**
         * DeliveryCarrier enum.
         * @name waiternow.common.DeliveryCarrier
         * @enum {number}
         * @property {number} DELIVERY_CARRIER_UNSPECIFIED=0 DELIVERY_CARRIER_UNSPECIFIED value
         * @property {number} SELF=1 SELF value
         * @property {number} DOORDASH=2 DOORDASH value
         */
        common.DeliveryCarrier = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "DELIVERY_CARRIER_UNSPECIFIED"] = 0;
            values[valuesById[1] = "SELF"] = 1;
            values[valuesById[2] = "DOORDASH"] = 2;
            return values;
        })();

        common.GeoDistanceProto = (function() {

            /**
             * Properties of a GeoDistanceProto.
             * @memberof waiternow.common
             * @interface IGeoDistanceProto
             * @property {waiternow.common.IDistanceQuantityProto|null} [distance] GeoDistanceProto distance
             * @property {google.protobuf.IDuration|null} [drivingDuration] GeoDistanceProto drivingDuration
             * @property {google.protobuf.IDuration|null} [drivingDurationInTraffic] GeoDistanceProto drivingDurationInTraffic
             */

            /**
             * Constructs a new GeoDistanceProto.
             * @memberof waiternow.common
             * @classdesc Represents a GeoDistanceProto.
             * @implements IGeoDistanceProto
             * @constructor
             * @param {waiternow.common.IGeoDistanceProto=} [properties] Properties to set
             */
            function GeoDistanceProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GeoDistanceProto distance.
             * @member {waiternow.common.IDistanceQuantityProto|null|undefined} distance
             * @memberof waiternow.common.GeoDistanceProto
             * @instance
             */
            GeoDistanceProto.prototype.distance = null;

            /**
             * GeoDistanceProto drivingDuration.
             * @member {google.protobuf.IDuration|null|undefined} drivingDuration
             * @memberof waiternow.common.GeoDistanceProto
             * @instance
             */
            GeoDistanceProto.prototype.drivingDuration = null;

            /**
             * GeoDistanceProto drivingDurationInTraffic.
             * @member {google.protobuf.IDuration|null|undefined} drivingDurationInTraffic
             * @memberof waiternow.common.GeoDistanceProto
             * @instance
             */
            GeoDistanceProto.prototype.drivingDurationInTraffic = null;

            /**
             * Creates a new GeoDistanceProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.GeoDistanceProto
             * @static
             * @param {waiternow.common.IGeoDistanceProto=} [properties] Properties to set
             * @returns {waiternow.common.GeoDistanceProto} GeoDistanceProto instance
             */
            GeoDistanceProto.create = function create(properties) {
                return new GeoDistanceProto(properties);
            };

            /**
             * Encodes the specified GeoDistanceProto message. Does not implicitly {@link waiternow.common.GeoDistanceProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.GeoDistanceProto
             * @static
             * @param {waiternow.common.IGeoDistanceProto} message GeoDistanceProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GeoDistanceProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.distance != null && Object.hasOwnProperty.call(message, "distance"))
                    $root.waiternow.common.DistanceQuantityProto.encode(message.distance, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.drivingDuration != null && Object.hasOwnProperty.call(message, "drivingDuration"))
                    $root.google.protobuf.Duration.encode(message.drivingDuration, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.drivingDurationInTraffic != null && Object.hasOwnProperty.call(message, "drivingDurationInTraffic"))
                    $root.google.protobuf.Duration.encode(message.drivingDurationInTraffic, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified GeoDistanceProto message, length delimited. Does not implicitly {@link waiternow.common.GeoDistanceProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.GeoDistanceProto
             * @static
             * @param {waiternow.common.IGeoDistanceProto} message GeoDistanceProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GeoDistanceProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GeoDistanceProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.GeoDistanceProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.GeoDistanceProto} GeoDistanceProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GeoDistanceProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GeoDistanceProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.distance = $root.waiternow.common.DistanceQuantityProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 2: {
                            message.drivingDuration = $root.google.protobuf.Duration.decode(reader, reader.uint32());
                            break;
                        }
                    case 3: {
                            message.drivingDurationInTraffic = $root.google.protobuf.Duration.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GeoDistanceProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.GeoDistanceProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.GeoDistanceProto} GeoDistanceProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GeoDistanceProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GeoDistanceProto message.
             * @function verify
             * @memberof waiternow.common.GeoDistanceProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GeoDistanceProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.distance != null && message.hasOwnProperty("distance")) {
                    var error = $root.waiternow.common.DistanceQuantityProto.verify(message.distance);
                    if (error)
                        return "distance." + error;
                }
                if (message.drivingDuration != null && message.hasOwnProperty("drivingDuration")) {
                    var error = $root.google.protobuf.Duration.verify(message.drivingDuration);
                    if (error)
                        return "drivingDuration." + error;
                }
                if (message.drivingDurationInTraffic != null && message.hasOwnProperty("drivingDurationInTraffic")) {
                    var error = $root.google.protobuf.Duration.verify(message.drivingDurationInTraffic);
                    if (error)
                        return "drivingDurationInTraffic." + error;
                }
                return null;
            };

            /**
             * Creates a GeoDistanceProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.GeoDistanceProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.GeoDistanceProto} GeoDistanceProto
             */
            GeoDistanceProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.GeoDistanceProto)
                    return object;
                var message = new $root.waiternow.common.GeoDistanceProto();
                if (object.distance != null) {
                    if (typeof object.distance !== "object")
                        throw TypeError(".waiternow.common.GeoDistanceProto.distance: object expected");
                    message.distance = $root.waiternow.common.DistanceQuantityProto.fromObject(object.distance);
                }
                if (object.drivingDuration != null) {
                    if (typeof object.drivingDuration !== "object")
                        throw TypeError(".waiternow.common.GeoDistanceProto.drivingDuration: object expected");
                    message.drivingDuration = $root.google.protobuf.Duration.fromObject(object.drivingDuration);
                }
                if (object.drivingDurationInTraffic != null) {
                    if (typeof object.drivingDurationInTraffic !== "object")
                        throw TypeError(".waiternow.common.GeoDistanceProto.drivingDurationInTraffic: object expected");
                    message.drivingDurationInTraffic = $root.google.protobuf.Duration.fromObject(object.drivingDurationInTraffic);
                }
                return message;
            };

            /**
             * Creates a plain object from a GeoDistanceProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.GeoDistanceProto
             * @static
             * @param {waiternow.common.GeoDistanceProto} message GeoDistanceProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GeoDistanceProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.distance = null;
                    object.drivingDuration = null;
                    object.drivingDurationInTraffic = null;
                }
                if (message.distance != null && message.hasOwnProperty("distance"))
                    object.distance = $root.waiternow.common.DistanceQuantityProto.toObject(message.distance, options);
                if (message.drivingDuration != null && message.hasOwnProperty("drivingDuration"))
                    object.drivingDuration = $root.google.protobuf.Duration.toObject(message.drivingDuration, options);
                if (message.drivingDurationInTraffic != null && message.hasOwnProperty("drivingDurationInTraffic"))
                    object.drivingDurationInTraffic = $root.google.protobuf.Duration.toObject(message.drivingDurationInTraffic, options);
                return object;
            };

            /**
             * Converts this GeoDistanceProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.GeoDistanceProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GeoDistanceProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for GeoDistanceProto
             * @function getTypeUrl
             * @memberof waiternow.common.GeoDistanceProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            GeoDistanceProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.GeoDistanceProto";
            };

            return GeoDistanceProto;
        })();

        common.PropertyProto = (function() {

            /**
             * Properties of a PropertyProto.
             * @memberof waiternow.common
             * @interface IPropertyProto
             * @property {string|null} [name] PropertyProto name
             * @property {waiternow.common.PropertyProto.IValueProto|null} [value] PropertyProto value
             */

            /**
             * Constructs a new PropertyProto.
             * @memberof waiternow.common
             * @classdesc Represents a PropertyProto.
             * @implements IPropertyProto
             * @constructor
             * @param {waiternow.common.IPropertyProto=} [properties] Properties to set
             */
            function PropertyProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * PropertyProto name.
             * @member {string} name
             * @memberof waiternow.common.PropertyProto
             * @instance
             */
            PropertyProto.prototype.name = "";

            /**
             * PropertyProto value.
             * @member {waiternow.common.PropertyProto.IValueProto|null|undefined} value
             * @memberof waiternow.common.PropertyProto
             * @instance
             */
            PropertyProto.prototype.value = null;

            /**
             * Creates a new PropertyProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.PropertyProto
             * @static
             * @param {waiternow.common.IPropertyProto=} [properties] Properties to set
             * @returns {waiternow.common.PropertyProto} PropertyProto instance
             */
            PropertyProto.create = function create(properties) {
                return new PropertyProto(properties);
            };

            /**
             * Encodes the specified PropertyProto message. Does not implicitly {@link waiternow.common.PropertyProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.PropertyProto
             * @static
             * @param {waiternow.common.IPropertyProto} message PropertyProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PropertyProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                    $root.waiternow.common.PropertyProto.ValueProto.encode(message.value, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified PropertyProto message, length delimited. Does not implicitly {@link waiternow.common.PropertyProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.PropertyProto
             * @static
             * @param {waiternow.common.IPropertyProto} message PropertyProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PropertyProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a PropertyProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.PropertyProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.PropertyProto} PropertyProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PropertyProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PropertyProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.name = reader.string();
                            break;
                        }
                    case 2: {
                            message.value = $root.waiternow.common.PropertyProto.ValueProto.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a PropertyProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.PropertyProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.PropertyProto} PropertyProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PropertyProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a PropertyProto message.
             * @function verify
             * @memberof waiternow.common.PropertyProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            PropertyProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.value != null && message.hasOwnProperty("value")) {
                    var error = $root.waiternow.common.PropertyProto.ValueProto.verify(message.value);
                    if (error)
                        return "value." + error;
                }
                return null;
            };

            /**
             * Creates a PropertyProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.PropertyProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.PropertyProto} PropertyProto
             */
            PropertyProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.PropertyProto)
                    return object;
                var message = new $root.waiternow.common.PropertyProto();
                if (object.name != null)
                    message.name = String(object.name);
                if (object.value != null) {
                    if (typeof object.value !== "object")
                        throw TypeError(".waiternow.common.PropertyProto.value: object expected");
                    message.value = $root.waiternow.common.PropertyProto.ValueProto.fromObject(object.value);
                }
                return message;
            };

            /**
             * Creates a plain object from a PropertyProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.PropertyProto
             * @static
             * @param {waiternow.common.PropertyProto} message PropertyProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            PropertyProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.name = "";
                    object.value = null;
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.value != null && message.hasOwnProperty("value"))
                    object.value = $root.waiternow.common.PropertyProto.ValueProto.toObject(message.value, options);
                return object;
            };

            /**
             * Converts this PropertyProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.PropertyProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            PropertyProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for PropertyProto
             * @function getTypeUrl
             * @memberof waiternow.common.PropertyProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            PropertyProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.PropertyProto";
            };

            PropertyProto.ValueProto = (function() {

                /**
                 * Properties of a ValueProto.
                 * @memberof waiternow.common.PropertyProto
                 * @interface IValueProto
                 * @property {string|null} [asString] ValueProto asString
                 * @property {boolean|null} [asBool] ValueProto asBool
                 * @property {number|null} [asInt] ValueProto asInt
                 * @property {number|null} [asLong] ValueProto asLong
                 * @property {number|null} [asUnsignedInt] ValueProto asUnsignedInt
                 * @property {number|null} [asUnsignedLong] ValueProto asUnsignedLong
                 * @property {number|null} [asFloat] ValueProto asFloat
                 * @property {number|null} [asDouble] ValueProto asDouble
                 * @property {Uint8Array|null} [asBytes] ValueProto asBytes
                 * @property {google.protobuf.IAny|null} [asAny] ValueProto asAny
                 */

                /**
                 * Constructs a new ValueProto.
                 * @memberof waiternow.common.PropertyProto
                 * @classdesc Represents a ValueProto.
                 * @implements IValueProto
                 * @constructor
                 * @param {waiternow.common.PropertyProto.IValueProto=} [properties] Properties to set
                 */
                function ValueProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ValueProto asString.
                 * @member {string|null|undefined} asString
                 * @memberof waiternow.common.PropertyProto.ValueProto
                 * @instance
                 */
                ValueProto.prototype.asString = null;

                /**
                 * ValueProto asBool.
                 * @member {boolean|null|undefined} asBool
                 * @memberof waiternow.common.PropertyProto.ValueProto
                 * @instance
                 */
                ValueProto.prototype.asBool = null;

                /**
                 * ValueProto asInt.
                 * @member {number|null|undefined} asInt
                 * @memberof waiternow.common.PropertyProto.ValueProto
                 * @instance
                 */
                ValueProto.prototype.asInt = null;

                /**
                 * ValueProto asLong.
                 * @member {number|null|undefined} asLong
                 * @memberof waiternow.common.PropertyProto.ValueProto
                 * @instance
                 */
                ValueProto.prototype.asLong = null;

                /**
                 * ValueProto asUnsignedInt.
                 * @member {number|null|undefined} asUnsignedInt
                 * @memberof waiternow.common.PropertyProto.ValueProto
                 * @instance
                 */
                ValueProto.prototype.asUnsignedInt = null;

                /**
                 * ValueProto asUnsignedLong.
                 * @member {number|null|undefined} asUnsignedLong
                 * @memberof waiternow.common.PropertyProto.ValueProto
                 * @instance
                 */
                ValueProto.prototype.asUnsignedLong = null;

                /**
                 * ValueProto asFloat.
                 * @member {number|null|undefined} asFloat
                 * @memberof waiternow.common.PropertyProto.ValueProto
                 * @instance
                 */
                ValueProto.prototype.asFloat = null;

                /**
                 * ValueProto asDouble.
                 * @member {number|null|undefined} asDouble
                 * @memberof waiternow.common.PropertyProto.ValueProto
                 * @instance
                 */
                ValueProto.prototype.asDouble = null;

                /**
                 * ValueProto asBytes.
                 * @member {Uint8Array|null|undefined} asBytes
                 * @memberof waiternow.common.PropertyProto.ValueProto
                 * @instance
                 */
                ValueProto.prototype.asBytes = null;

                /**
                 * ValueProto asAny.
                 * @member {google.protobuf.IAny|null|undefined} asAny
                 * @memberof waiternow.common.PropertyProto.ValueProto
                 * @instance
                 */
                ValueProto.prototype.asAny = null;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * ValueProto valueType.
                 * @member {"asString"|"asBool"|"asInt"|"asLong"|"asUnsignedInt"|"asUnsignedLong"|"asFloat"|"asDouble"|"asBytes"|"asAny"|undefined} valueType
                 * @memberof waiternow.common.PropertyProto.ValueProto
                 * @instance
                 */
                Object.defineProperty(ValueProto.prototype, "valueType", {
                    get: $util.oneOfGetter($oneOfFields = ["asString", "asBool", "asInt", "asLong", "asUnsignedInt", "asUnsignedLong", "asFloat", "asDouble", "asBytes", "asAny"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new ValueProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.PropertyProto.ValueProto
                 * @static
                 * @param {waiternow.common.PropertyProto.IValueProto=} [properties] Properties to set
                 * @returns {waiternow.common.PropertyProto.ValueProto} ValueProto instance
                 */
                ValueProto.create = function create(properties) {
                    return new ValueProto(properties);
                };

                /**
                 * Encodes the specified ValueProto message. Does not implicitly {@link waiternow.common.PropertyProto.ValueProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.PropertyProto.ValueProto
                 * @static
                 * @param {waiternow.common.PropertyProto.IValueProto} message ValueProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ValueProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.asString != null && Object.hasOwnProperty.call(message, "asString"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.asString);
                    if (message.asBool != null && Object.hasOwnProperty.call(message, "asBool"))
                        writer.uint32(/* id 2, wireType 0 =*/16).bool(message.asBool);
                    if (message.asInt != null && Object.hasOwnProperty.call(message, "asInt"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.asInt);
                    if (message.asLong != null && Object.hasOwnProperty.call(message, "asLong"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int64(message.asLong);
                    if (message.asUnsignedInt != null && Object.hasOwnProperty.call(message, "asUnsignedInt"))
                        writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.asUnsignedInt);
                    if (message.asUnsignedLong != null && Object.hasOwnProperty.call(message, "asUnsignedLong"))
                        writer.uint32(/* id 6, wireType 0 =*/48).uint64(message.asUnsignedLong);
                    if (message.asFloat != null && Object.hasOwnProperty.call(message, "asFloat"))
                        writer.uint32(/* id 7, wireType 5 =*/61).float(message.asFloat);
                    if (message.asDouble != null && Object.hasOwnProperty.call(message, "asDouble"))
                        writer.uint32(/* id 8, wireType 1 =*/65).double(message.asDouble);
                    if (message.asBytes != null && Object.hasOwnProperty.call(message, "asBytes"))
                        writer.uint32(/* id 9, wireType 2 =*/74).bytes(message.asBytes);
                    if (message.asAny != null && Object.hasOwnProperty.call(message, "asAny"))
                        $root.google.protobuf.Any.encode(message.asAny, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified ValueProto message, length delimited. Does not implicitly {@link waiternow.common.PropertyProto.ValueProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.PropertyProto.ValueProto
                 * @static
                 * @param {waiternow.common.PropertyProto.IValueProto} message ValueProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ValueProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ValueProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.PropertyProto.ValueProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.PropertyProto.ValueProto} ValueProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ValueProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PropertyProto.ValueProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.asString = reader.string();
                                break;
                            }
                        case 2: {
                                message.asBool = reader.bool();
                                break;
                            }
                        case 3: {
                                message.asInt = reader.int32();
                                break;
                            }
                        case 4: {
                                message.asLong = reader.int64();
                                break;
                            }
                        case 5: {
                                message.asUnsignedInt = reader.uint32();
                                break;
                            }
                        case 6: {
                                message.asUnsignedLong = reader.uint64();
                                break;
                            }
                        case 7: {
                                message.asFloat = reader.float();
                                break;
                            }
                        case 8: {
                                message.asDouble = reader.double();
                                break;
                            }
                        case 9: {
                                message.asBytes = reader.bytes();
                                break;
                            }
                        case 10: {
                                message.asAny = $root.google.protobuf.Any.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ValueProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.PropertyProto.ValueProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.PropertyProto.ValueProto} ValueProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ValueProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ValueProto message.
                 * @function verify
                 * @memberof waiternow.common.PropertyProto.ValueProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ValueProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.asString != null && message.hasOwnProperty("asString")) {
                        properties.valueType = 1;
                        if (!$util.isString(message.asString))
                            return "asString: string expected";
                    }
                    if (message.asBool != null && message.hasOwnProperty("asBool")) {
                        if (properties.valueType === 1)
                            return "valueType: multiple values";
                        properties.valueType = 1;
                        if (typeof message.asBool !== "boolean")
                            return "asBool: boolean expected";
                    }
                    if (message.asInt != null && message.hasOwnProperty("asInt")) {
                        if (properties.valueType === 1)
                            return "valueType: multiple values";
                        properties.valueType = 1;
                        if (!$util.isInteger(message.asInt))
                            return "asInt: integer expected";
                    }
                    if (message.asLong != null && message.hasOwnProperty("asLong")) {
                        if (properties.valueType === 1)
                            return "valueType: multiple values";
                        properties.valueType = 1;
                        if (!$util.isInteger(message.asLong) && !(message.asLong && $util.isInteger(message.asLong.low) && $util.isInteger(message.asLong.high)))
                            return "asLong: integer|Long expected";
                    }
                    if (message.asUnsignedInt != null && message.hasOwnProperty("asUnsignedInt")) {
                        if (properties.valueType === 1)
                            return "valueType: multiple values";
                        properties.valueType = 1;
                        if (!$util.isInteger(message.asUnsignedInt))
                            return "asUnsignedInt: integer expected";
                    }
                    if (message.asUnsignedLong != null && message.hasOwnProperty("asUnsignedLong")) {
                        if (properties.valueType === 1)
                            return "valueType: multiple values";
                        properties.valueType = 1;
                        if (!$util.isInteger(message.asUnsignedLong) && !(message.asUnsignedLong && $util.isInteger(message.asUnsignedLong.low) && $util.isInteger(message.asUnsignedLong.high)))
                            return "asUnsignedLong: integer|Long expected";
                    }
                    if (message.asFloat != null && message.hasOwnProperty("asFloat")) {
                        if (properties.valueType === 1)
                            return "valueType: multiple values";
                        properties.valueType = 1;
                        if (typeof message.asFloat !== "number")
                            return "asFloat: number expected";
                    }
                    if (message.asDouble != null && message.hasOwnProperty("asDouble")) {
                        if (properties.valueType === 1)
                            return "valueType: multiple values";
                        properties.valueType = 1;
                        if (typeof message.asDouble !== "number")
                            return "asDouble: number expected";
                    }
                    if (message.asBytes != null && message.hasOwnProperty("asBytes")) {
                        if (properties.valueType === 1)
                            return "valueType: multiple values";
                        properties.valueType = 1;
                        if (!(message.asBytes && typeof message.asBytes.length === "number" || $util.isString(message.asBytes)))
                            return "asBytes: buffer expected";
                    }
                    if (message.asAny != null && message.hasOwnProperty("asAny")) {
                        if (properties.valueType === 1)
                            return "valueType: multiple values";
                        properties.valueType = 1;
                        {
                            var error = $root.google.protobuf.Any.verify(message.asAny);
                            if (error)
                                return "asAny." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a ValueProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.PropertyProto.ValueProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.PropertyProto.ValueProto} ValueProto
                 */
                ValueProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.PropertyProto.ValueProto)
                        return object;
                    var message = new $root.waiternow.common.PropertyProto.ValueProto();
                    if (object.asString != null)
                        message.asString = String(object.asString);
                    if (object.asBool != null)
                        message.asBool = Boolean(object.asBool);
                    if (object.asInt != null)
                        message.asInt = object.asInt | 0;
                    if (object.asLong != null)
                        if ($util.Long)
                            (message.asLong = $util.Long.fromValue(object.asLong)).unsigned = false;
                        else if (typeof object.asLong === "string")
                            message.asLong = parseInt(object.asLong, 10);
                        else if (typeof object.asLong === "number")
                            message.asLong = object.asLong;
                        else if (typeof object.asLong === "object")
                            message.asLong = new $util.LongBits(object.asLong.low >>> 0, object.asLong.high >>> 0).toNumber();
                    if (object.asUnsignedInt != null)
                        message.asUnsignedInt = object.asUnsignedInt >>> 0;
                    if (object.asUnsignedLong != null)
                        if ($util.Long)
                            (message.asUnsignedLong = $util.Long.fromValue(object.asUnsignedLong)).unsigned = true;
                        else if (typeof object.asUnsignedLong === "string")
                            message.asUnsignedLong = parseInt(object.asUnsignedLong, 10);
                        else if (typeof object.asUnsignedLong === "number")
                            message.asUnsignedLong = object.asUnsignedLong;
                        else if (typeof object.asUnsignedLong === "object")
                            message.asUnsignedLong = new $util.LongBits(object.asUnsignedLong.low >>> 0, object.asUnsignedLong.high >>> 0).toNumber(true);
                    if (object.asFloat != null)
                        message.asFloat = Number(object.asFloat);
                    if (object.asDouble != null)
                        message.asDouble = Number(object.asDouble);
                    if (object.asBytes != null)
                        if (typeof object.asBytes === "string")
                            $util.base64.decode(object.asBytes, message.asBytes = $util.newBuffer($util.base64.length(object.asBytes)), 0);
                        else if (object.asBytes.length >= 0)
                            message.asBytes = object.asBytes;
                    if (object.asAny != null) {
                        if (typeof object.asAny !== "object")
                            throw TypeError(".waiternow.common.PropertyProto.ValueProto.asAny: object expected");
                        message.asAny = $root.google.protobuf.Any.fromObject(object.asAny);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a ValueProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.PropertyProto.ValueProto
                 * @static
                 * @param {waiternow.common.PropertyProto.ValueProto} message ValueProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ValueProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (message.asString != null && message.hasOwnProperty("asString")) {
                        object.asString = message.asString;
                        if (options.oneofs)
                            object.valueType = "asString";
                    }
                    if (message.asBool != null && message.hasOwnProperty("asBool")) {
                        object.asBool = message.asBool;
                        if (options.oneofs)
                            object.valueType = "asBool";
                    }
                    if (message.asInt != null && message.hasOwnProperty("asInt")) {
                        object.asInt = message.asInt;
                        if (options.oneofs)
                            object.valueType = "asInt";
                    }
                    if (message.asLong != null && message.hasOwnProperty("asLong")) {
                        if (typeof message.asLong === "number")
                            object.asLong = options.longs === String ? String(message.asLong) : message.asLong;
                        else
                            object.asLong = options.longs === String ? $util.Long.prototype.toString.call(message.asLong) : options.longs === Number ? new $util.LongBits(message.asLong.low >>> 0, message.asLong.high >>> 0).toNumber() : message.asLong;
                        if (options.oneofs)
                            object.valueType = "asLong";
                    }
                    if (message.asUnsignedInt != null && message.hasOwnProperty("asUnsignedInt")) {
                        object.asUnsignedInt = message.asUnsignedInt;
                        if (options.oneofs)
                            object.valueType = "asUnsignedInt";
                    }
                    if (message.asUnsignedLong != null && message.hasOwnProperty("asUnsignedLong")) {
                        if (typeof message.asUnsignedLong === "number")
                            object.asUnsignedLong = options.longs === String ? String(message.asUnsignedLong) : message.asUnsignedLong;
                        else
                            object.asUnsignedLong = options.longs === String ? $util.Long.prototype.toString.call(message.asUnsignedLong) : options.longs === Number ? new $util.LongBits(message.asUnsignedLong.low >>> 0, message.asUnsignedLong.high >>> 0).toNumber(true) : message.asUnsignedLong;
                        if (options.oneofs)
                            object.valueType = "asUnsignedLong";
                    }
                    if (message.asFloat != null && message.hasOwnProperty("asFloat")) {
                        object.asFloat = options.json && !isFinite(message.asFloat) ? String(message.asFloat) : message.asFloat;
                        if (options.oneofs)
                            object.valueType = "asFloat";
                    }
                    if (message.asDouble != null && message.hasOwnProperty("asDouble")) {
                        object.asDouble = options.json && !isFinite(message.asDouble) ? String(message.asDouble) : message.asDouble;
                        if (options.oneofs)
                            object.valueType = "asDouble";
                    }
                    if (message.asBytes != null && message.hasOwnProperty("asBytes")) {
                        object.asBytes = options.bytes === String ? $util.base64.encode(message.asBytes, 0, message.asBytes.length) : options.bytes === Array ? Array.prototype.slice.call(message.asBytes) : message.asBytes;
                        if (options.oneofs)
                            object.valueType = "asBytes";
                    }
                    if (message.asAny != null && message.hasOwnProperty("asAny")) {
                        object.asAny = $root.google.protobuf.Any.toObject(message.asAny, options);
                        if (options.oneofs)
                            object.valueType = "asAny";
                    }
                    return object;
                };

                /**
                 * Converts this ValueProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.PropertyProto.ValueProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ValueProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ValueProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.PropertyProto.ValueProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ValueProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.PropertyProto.ValueProto";
                };

                return ValueProto;
            })();

            return PropertyProto;
        })();

        /**
         * OptionalYesNo enum.
         * @name waiternow.common.OptionalYesNo
         * @enum {number}
         * @property {number} OPTIONAL_YES_NO_UNSPECIFIED=0 OPTIONAL_YES_NO_UNSPECIFIED value
         * @property {number} YES=1 YES value
         * @property {number} NO=2 NO value
         */
        common.OptionalYesNo = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "OPTIONAL_YES_NO_UNSPECIFIED"] = 0;
            values[valuesById[1] = "YES"] = 1;
            values[valuesById[2] = "NO"] = 2;
            return values;
        })();

        common.MoneyProto = (function() {

            /**
             * Properties of a MoneyProto.
             * @memberof waiternow.common
             * @interface IMoneyProto
             * @property {string|null} [currencyCode] MoneyProto currencyCode
             * @property {number|null} [units] MoneyProto units
             * @property {number|null} [cents] MoneyProto cents
             */

            /**
             * Constructs a new MoneyProto.
             * @memberof waiternow.common
             * @classdesc Represents a MoneyProto.
             * @implements IMoneyProto
             * @constructor
             * @param {waiternow.common.IMoneyProto=} [properties] Properties to set
             */
            function MoneyProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * MoneyProto currencyCode.
             * @member {string} currencyCode
             * @memberof waiternow.common.MoneyProto
             * @instance
             */
            MoneyProto.prototype.currencyCode = "";

            /**
             * MoneyProto units.
             * @member {number} units
             * @memberof waiternow.common.MoneyProto
             * @instance
             */
            MoneyProto.prototype.units = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * MoneyProto cents.
             * @member {number} cents
             * @memberof waiternow.common.MoneyProto
             * @instance
             */
            MoneyProto.prototype.cents = 0;

            /**
             * Creates a new MoneyProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.MoneyProto
             * @static
             * @param {waiternow.common.IMoneyProto=} [properties] Properties to set
             * @returns {waiternow.common.MoneyProto} MoneyProto instance
             */
            MoneyProto.create = function create(properties) {
                return new MoneyProto(properties);
            };

            /**
             * Encodes the specified MoneyProto message. Does not implicitly {@link waiternow.common.MoneyProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.MoneyProto
             * @static
             * @param {waiternow.common.IMoneyProto} message MoneyProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MoneyProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.currencyCode != null && Object.hasOwnProperty.call(message, "currencyCode"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.currencyCode);
                if (message.units != null && Object.hasOwnProperty.call(message, "units"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int64(message.units);
                if (message.cents != null && Object.hasOwnProperty.call(message, "cents"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.cents);
                return writer;
            };

            /**
             * Encodes the specified MoneyProto message, length delimited. Does not implicitly {@link waiternow.common.MoneyProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.MoneyProto
             * @static
             * @param {waiternow.common.IMoneyProto} message MoneyProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MoneyProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a MoneyProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.MoneyProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.MoneyProto} MoneyProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MoneyProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.MoneyProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.currencyCode = reader.string();
                            break;
                        }
                    case 2: {
                            message.units = reader.int64();
                            break;
                        }
                    case 3: {
                            message.cents = reader.int32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a MoneyProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.MoneyProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.MoneyProto} MoneyProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MoneyProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a MoneyProto message.
             * @function verify
             * @memberof waiternow.common.MoneyProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            MoneyProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.currencyCode != null && message.hasOwnProperty("currencyCode"))
                    if (!$util.isString(message.currencyCode))
                        return "currencyCode: string expected";
                if (message.units != null && message.hasOwnProperty("units"))
                    if (!$util.isInteger(message.units) && !(message.units && $util.isInteger(message.units.low) && $util.isInteger(message.units.high)))
                        return "units: integer|Long expected";
                if (message.cents != null && message.hasOwnProperty("cents"))
                    if (!$util.isInteger(message.cents))
                        return "cents: integer expected";
                return null;
            };

            /**
             * Creates a MoneyProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.MoneyProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.MoneyProto} MoneyProto
             */
            MoneyProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.MoneyProto)
                    return object;
                var message = new $root.waiternow.common.MoneyProto();
                if (object.currencyCode != null)
                    message.currencyCode = String(object.currencyCode);
                if (object.units != null)
                    if ($util.Long)
                        (message.units = $util.Long.fromValue(object.units)).unsigned = false;
                    else if (typeof object.units === "string")
                        message.units = parseInt(object.units, 10);
                    else if (typeof object.units === "number")
                        message.units = object.units;
                    else if (typeof object.units === "object")
                        message.units = new $util.LongBits(object.units.low >>> 0, object.units.high >>> 0).toNumber();
                if (object.cents != null)
                    message.cents = object.cents | 0;
                return message;
            };

            /**
             * Creates a plain object from a MoneyProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.MoneyProto
             * @static
             * @param {waiternow.common.MoneyProto} message MoneyProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            MoneyProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.currencyCode = "";
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.units = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.units = options.longs === String ? "0" : 0;
                    object.cents = 0;
                }
                if (message.currencyCode != null && message.hasOwnProperty("currencyCode"))
                    object.currencyCode = message.currencyCode;
                if (message.units != null && message.hasOwnProperty("units"))
                    if (typeof message.units === "number")
                        object.units = options.longs === String ? String(message.units) : message.units;
                    else
                        object.units = options.longs === String ? $util.Long.prototype.toString.call(message.units) : options.longs === Number ? new $util.LongBits(message.units.low >>> 0, message.units.high >>> 0).toNumber() : message.units;
                if (message.cents != null && message.hasOwnProperty("cents"))
                    object.cents = message.cents;
                return object;
            };

            /**
             * Converts this MoneyProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.MoneyProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            MoneyProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for MoneyProto
             * @function getTypeUrl
             * @memberof waiternow.common.MoneyProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            MoneyProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.MoneyProto";
            };

            return MoneyProto;
        })();

        common.DecimalProto = (function() {

            /**
             * Properties of a DecimalProto.
             * @memberof waiternow.common
             * @interface IDecimalProto
             * @property {string|null} [value] DecimalProto value
             */

            /**
             * Constructs a new DecimalProto.
             * @memberof waiternow.common
             * @classdesc Represents a DecimalProto.
             * @implements IDecimalProto
             * @constructor
             * @param {waiternow.common.IDecimalProto=} [properties] Properties to set
             */
            function DecimalProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * DecimalProto value.
             * @member {string} value
             * @memberof waiternow.common.DecimalProto
             * @instance
             */
            DecimalProto.prototype.value = "";

            /**
             * Creates a new DecimalProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.DecimalProto
             * @static
             * @param {waiternow.common.IDecimalProto=} [properties] Properties to set
             * @returns {waiternow.common.DecimalProto} DecimalProto instance
             */
            DecimalProto.create = function create(properties) {
                return new DecimalProto(properties);
            };

            /**
             * Encodes the specified DecimalProto message. Does not implicitly {@link waiternow.common.DecimalProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.DecimalProto
             * @static
             * @param {waiternow.common.IDecimalProto} message DecimalProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DecimalProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.value);
                return writer;
            };

            /**
             * Encodes the specified DecimalProto message, length delimited. Does not implicitly {@link waiternow.common.DecimalProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.DecimalProto
             * @static
             * @param {waiternow.common.IDecimalProto} message DecimalProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DecimalProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a DecimalProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.DecimalProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.DecimalProto} DecimalProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DecimalProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.DecimalProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.value = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a DecimalProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.DecimalProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.DecimalProto} DecimalProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DecimalProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a DecimalProto message.
             * @function verify
             * @memberof waiternow.common.DecimalProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            DecimalProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.value != null && message.hasOwnProperty("value"))
                    if (!$util.isString(message.value))
                        return "value: string expected";
                return null;
            };

            /**
             * Creates a DecimalProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.DecimalProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.DecimalProto} DecimalProto
             */
            DecimalProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.DecimalProto)
                    return object;
                var message = new $root.waiternow.common.DecimalProto();
                if (object.value != null)
                    message.value = String(object.value);
                return message;
            };

            /**
             * Creates a plain object from a DecimalProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.DecimalProto
             * @static
             * @param {waiternow.common.DecimalProto} message DecimalProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            DecimalProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.value = "";
                if (message.value != null && message.hasOwnProperty("value"))
                    object.value = message.value;
                return object;
            };

            /**
             * Converts this DecimalProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.DecimalProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            DecimalProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for DecimalProto
             * @function getTypeUrl
             * @memberof waiternow.common.DecimalProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            DecimalProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.DecimalProto";
            };

            return DecimalProto;
        })();

        common.DistanceQuantityProto = (function() {

            /**
             * Properties of a DistanceQuantityProto.
             * @memberof waiternow.common
             * @interface IDistanceQuantityProto
             * @property {waiternow.common.IDecimalProto|null} [value] DistanceQuantityProto value
             * @property {waiternow.common.DistanceQuantityProto.Unit|null} [unit] DistanceQuantityProto unit
             */

            /**
             * Constructs a new DistanceQuantityProto.
             * @memberof waiternow.common
             * @classdesc Represents a DistanceQuantityProto.
             * @implements IDistanceQuantityProto
             * @constructor
             * @param {waiternow.common.IDistanceQuantityProto=} [properties] Properties to set
             */
            function DistanceQuantityProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * DistanceQuantityProto value.
             * @member {waiternow.common.IDecimalProto|null|undefined} value
             * @memberof waiternow.common.DistanceQuantityProto
             * @instance
             */
            DistanceQuantityProto.prototype.value = null;

            /**
             * DistanceQuantityProto unit.
             * @member {waiternow.common.DistanceQuantityProto.Unit} unit
             * @memberof waiternow.common.DistanceQuantityProto
             * @instance
             */
            DistanceQuantityProto.prototype.unit = 0;

            /**
             * Creates a new DistanceQuantityProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.DistanceQuantityProto
             * @static
             * @param {waiternow.common.IDistanceQuantityProto=} [properties] Properties to set
             * @returns {waiternow.common.DistanceQuantityProto} DistanceQuantityProto instance
             */
            DistanceQuantityProto.create = function create(properties) {
                return new DistanceQuantityProto(properties);
            };

            /**
             * Encodes the specified DistanceQuantityProto message. Does not implicitly {@link waiternow.common.DistanceQuantityProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.DistanceQuantityProto
             * @static
             * @param {waiternow.common.IDistanceQuantityProto} message DistanceQuantityProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DistanceQuantityProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                    $root.waiternow.common.DecimalProto.encode(message.value, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.unit != null && Object.hasOwnProperty.call(message, "unit"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.unit);
                return writer;
            };

            /**
             * Encodes the specified DistanceQuantityProto message, length delimited. Does not implicitly {@link waiternow.common.DistanceQuantityProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.DistanceQuantityProto
             * @static
             * @param {waiternow.common.IDistanceQuantityProto} message DistanceQuantityProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DistanceQuantityProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a DistanceQuantityProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.DistanceQuantityProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.DistanceQuantityProto} DistanceQuantityProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DistanceQuantityProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.DistanceQuantityProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.value = $root.waiternow.common.DecimalProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 2: {
                            message.unit = reader.int32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a DistanceQuantityProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.DistanceQuantityProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.DistanceQuantityProto} DistanceQuantityProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DistanceQuantityProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a DistanceQuantityProto message.
             * @function verify
             * @memberof waiternow.common.DistanceQuantityProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            DistanceQuantityProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.value != null && message.hasOwnProperty("value")) {
                    var error = $root.waiternow.common.DecimalProto.verify(message.value);
                    if (error)
                        return "value." + error;
                }
                if (message.unit != null && message.hasOwnProperty("unit"))
                    switch (message.unit) {
                    default:
                        return "unit: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                        break;
                    }
                return null;
            };

            /**
             * Creates a DistanceQuantityProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.DistanceQuantityProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.DistanceQuantityProto} DistanceQuantityProto
             */
            DistanceQuantityProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.DistanceQuantityProto)
                    return object;
                var message = new $root.waiternow.common.DistanceQuantityProto();
                if (object.value != null) {
                    if (typeof object.value !== "object")
                        throw TypeError(".waiternow.common.DistanceQuantityProto.value: object expected");
                    message.value = $root.waiternow.common.DecimalProto.fromObject(object.value);
                }
                switch (object.unit) {
                default:
                    if (typeof object.unit === "number") {
                        message.unit = object.unit;
                        break;
                    }
                    break;
                case "UNIT_UNSPECIFIED":
                case 0:
                    message.unit = 0;
                    break;
                case "METER":
                case 1:
                    message.unit = 1;
                    break;
                case "KILOMETER":
                case 2:
                    message.unit = 2;
                    break;
                case "MILE":
                case 3:
                    message.unit = 3;
                    break;
                }
                return message;
            };

            /**
             * Creates a plain object from a DistanceQuantityProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.DistanceQuantityProto
             * @static
             * @param {waiternow.common.DistanceQuantityProto} message DistanceQuantityProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            DistanceQuantityProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.value = null;
                    object.unit = options.enums === String ? "UNIT_UNSPECIFIED" : 0;
                }
                if (message.value != null && message.hasOwnProperty("value"))
                    object.value = $root.waiternow.common.DecimalProto.toObject(message.value, options);
                if (message.unit != null && message.hasOwnProperty("unit"))
                    object.unit = options.enums === String ? $root.waiternow.common.DistanceQuantityProto.Unit[message.unit] === undefined ? message.unit : $root.waiternow.common.DistanceQuantityProto.Unit[message.unit] : message.unit;
                return object;
            };

            /**
             * Converts this DistanceQuantityProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.DistanceQuantityProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            DistanceQuantityProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for DistanceQuantityProto
             * @function getTypeUrl
             * @memberof waiternow.common.DistanceQuantityProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            DistanceQuantityProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.DistanceQuantityProto";
            };

            /**
             * Unit enum.
             * @name waiternow.common.DistanceQuantityProto.Unit
             * @enum {number}
             * @property {number} UNIT_UNSPECIFIED=0 UNIT_UNSPECIFIED value
             * @property {number} METER=1 METER value
             * @property {number} KILOMETER=2 KILOMETER value
             * @property {number} MILE=3 MILE value
             */
            DistanceQuantityProto.Unit = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "UNIT_UNSPECIFIED"] = 0;
                values[valuesById[1] = "METER"] = 1;
                values[valuesById[2] = "KILOMETER"] = 2;
                values[valuesById[3] = "MILE"] = 3;
                return values;
            })();

            return DistanceQuantityProto;
        })();

        /**
         * Month enum.
         * @name waiternow.common.Month
         * @enum {number}
         * @property {number} MONTH_UNSPECIFIED=0 MONTH_UNSPECIFIED value
         * @property {number} JANUARY=1 JANUARY value
         * @property {number} FEBRUARY=2 FEBRUARY value
         * @property {number} MARCH=3 MARCH value
         * @property {number} APRIL=4 APRIL value
         * @property {number} MAY=5 MAY value
         * @property {number} JUNE=6 JUNE value
         * @property {number} JULY=7 JULY value
         * @property {number} AUGUST=8 AUGUST value
         * @property {number} SEPTEMBER=9 SEPTEMBER value
         * @property {number} OCTOBER=10 OCTOBER value
         * @property {number} NOVEMBER=11 NOVEMBER value
         * @property {number} DECEMBER=12 DECEMBER value
         */
        common.Month = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "MONTH_UNSPECIFIED"] = 0;
            values[valuesById[1] = "JANUARY"] = 1;
            values[valuesById[2] = "FEBRUARY"] = 2;
            values[valuesById[3] = "MARCH"] = 3;
            values[valuesById[4] = "APRIL"] = 4;
            values[valuesById[5] = "MAY"] = 5;
            values[valuesById[6] = "JUNE"] = 6;
            values[valuesById[7] = "JULY"] = 7;
            values[valuesById[8] = "AUGUST"] = 8;
            values[valuesById[9] = "SEPTEMBER"] = 9;
            values[valuesById[10] = "OCTOBER"] = 10;
            values[valuesById[11] = "NOVEMBER"] = 11;
            values[valuesById[12] = "DECEMBER"] = 12;
            return values;
        })();

        /**
         * DayOfWeek enum.
         * @name waiternow.common.DayOfWeek
         * @enum {number}
         * @property {number} DAY_OF_WEEK_UNSPECIFIED=0 DAY_OF_WEEK_UNSPECIFIED value
         * @property {number} SUNDAY=1 SUNDAY value
         * @property {number} MONDAY=2 MONDAY value
         * @property {number} TUESDAY=3 TUESDAY value
         * @property {number} WEDNESDAY=4 WEDNESDAY value
         * @property {number} THURSDAY=5 THURSDAY value
         * @property {number} FRIDAY=6 FRIDAY value
         * @property {number} SATURDAY=7 SATURDAY value
         */
        common.DayOfWeek = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "DAY_OF_WEEK_UNSPECIFIED"] = 0;
            values[valuesById[1] = "SUNDAY"] = 1;
            values[valuesById[2] = "MONDAY"] = 2;
            values[valuesById[3] = "TUESDAY"] = 3;
            values[valuesById[4] = "WEDNESDAY"] = 4;
            values[valuesById[5] = "THURSDAY"] = 5;
            values[valuesById[6] = "FRIDAY"] = 6;
            values[valuesById[7] = "SATURDAY"] = 7;
            return values;
        })();

        common.DateProto = (function() {

            /**
             * Properties of a DateProto.
             * @memberof waiternow.common
             * @interface IDateProto
             * @property {number|null} [year] DateProto year
             * @property {waiternow.common.Month|null} [month] DateProto month
             * @property {number|null} [day] DateProto day
             */

            /**
             * Constructs a new DateProto.
             * @memberof waiternow.common
             * @classdesc Represents a DateProto.
             * @implements IDateProto
             * @constructor
             * @param {waiternow.common.IDateProto=} [properties] Properties to set
             */
            function DateProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * DateProto year.
             * @member {number} year
             * @memberof waiternow.common.DateProto
             * @instance
             */
            DateProto.prototype.year = 0;

            /**
             * DateProto month.
             * @member {waiternow.common.Month} month
             * @memberof waiternow.common.DateProto
             * @instance
             */
            DateProto.prototype.month = 0;

            /**
             * DateProto day.
             * @member {number} day
             * @memberof waiternow.common.DateProto
             * @instance
             */
            DateProto.prototype.day = 0;

            /**
             * Creates a new DateProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.DateProto
             * @static
             * @param {waiternow.common.IDateProto=} [properties] Properties to set
             * @returns {waiternow.common.DateProto} DateProto instance
             */
            DateProto.create = function create(properties) {
                return new DateProto(properties);
            };

            /**
             * Encodes the specified DateProto message. Does not implicitly {@link waiternow.common.DateProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.DateProto
             * @static
             * @param {waiternow.common.IDateProto} message DateProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DateProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.year != null && Object.hasOwnProperty.call(message, "year"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.year);
                if (message.month != null && Object.hasOwnProperty.call(message, "month"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.month);
                if (message.day != null && Object.hasOwnProperty.call(message, "day"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.day);
                return writer;
            };

            /**
             * Encodes the specified DateProto message, length delimited. Does not implicitly {@link waiternow.common.DateProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.DateProto
             * @static
             * @param {waiternow.common.IDateProto} message DateProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DateProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a DateProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.DateProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.DateProto} DateProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DateProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.DateProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.year = reader.int32();
                            break;
                        }
                    case 2: {
                            message.month = reader.int32();
                            break;
                        }
                    case 3: {
                            message.day = reader.int32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a DateProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.DateProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.DateProto} DateProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DateProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a DateProto message.
             * @function verify
             * @memberof waiternow.common.DateProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            DateProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.year != null && message.hasOwnProperty("year"))
                    if (!$util.isInteger(message.year))
                        return "year: integer expected";
                if (message.month != null && message.hasOwnProperty("month"))
                    switch (message.month) {
                    default:
                        return "month: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                    case 9:
                    case 10:
                    case 11:
                    case 12:
                        break;
                    }
                if (message.day != null && message.hasOwnProperty("day"))
                    if (!$util.isInteger(message.day))
                        return "day: integer expected";
                return null;
            };

            /**
             * Creates a DateProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.DateProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.DateProto} DateProto
             */
            DateProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.DateProto)
                    return object;
                var message = new $root.waiternow.common.DateProto();
                if (object.year != null)
                    message.year = object.year | 0;
                switch (object.month) {
                default:
                    if (typeof object.month === "number") {
                        message.month = object.month;
                        break;
                    }
                    break;
                case "MONTH_UNSPECIFIED":
                case 0:
                    message.month = 0;
                    break;
                case "JANUARY":
                case 1:
                    message.month = 1;
                    break;
                case "FEBRUARY":
                case 2:
                    message.month = 2;
                    break;
                case "MARCH":
                case 3:
                    message.month = 3;
                    break;
                case "APRIL":
                case 4:
                    message.month = 4;
                    break;
                case "MAY":
                case 5:
                    message.month = 5;
                    break;
                case "JUNE":
                case 6:
                    message.month = 6;
                    break;
                case "JULY":
                case 7:
                    message.month = 7;
                    break;
                case "AUGUST":
                case 8:
                    message.month = 8;
                    break;
                case "SEPTEMBER":
                case 9:
                    message.month = 9;
                    break;
                case "OCTOBER":
                case 10:
                    message.month = 10;
                    break;
                case "NOVEMBER":
                case 11:
                    message.month = 11;
                    break;
                case "DECEMBER":
                case 12:
                    message.month = 12;
                    break;
                }
                if (object.day != null)
                    message.day = object.day | 0;
                return message;
            };

            /**
             * Creates a plain object from a DateProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.DateProto
             * @static
             * @param {waiternow.common.DateProto} message DateProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            DateProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.year = 0;
                    object.month = options.enums === String ? "MONTH_UNSPECIFIED" : 0;
                    object.day = 0;
                }
                if (message.year != null && message.hasOwnProperty("year"))
                    object.year = message.year;
                if (message.month != null && message.hasOwnProperty("month"))
                    object.month = options.enums === String ? $root.waiternow.common.Month[message.month] === undefined ? message.month : $root.waiternow.common.Month[message.month] : message.month;
                if (message.day != null && message.hasOwnProperty("day"))
                    object.day = message.day;
                return object;
            };

            /**
             * Converts this DateProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.DateProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            DateProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for DateProto
             * @function getTypeUrl
             * @memberof waiternow.common.DateProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            DateProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.DateProto";
            };

            return DateProto;
        })();

        common.TimeProto = (function() {

            /**
             * Properties of a TimeProto.
             * @memberof waiternow.common
             * @interface ITimeProto
             * @property {number|null} [hour] TimeProto hour
             * @property {number|null} [minute] TimeProto minute
             * @property {number|null} [second] TimeProto second
             * @property {number|null} [nano] TimeProto nano
             */

            /**
             * Constructs a new TimeProto.
             * @memberof waiternow.common
             * @classdesc Represents a TimeProto.
             * @implements ITimeProto
             * @constructor
             * @param {waiternow.common.ITimeProto=} [properties] Properties to set
             */
            function TimeProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * TimeProto hour.
             * @member {number} hour
             * @memberof waiternow.common.TimeProto
             * @instance
             */
            TimeProto.prototype.hour = 0;

            /**
             * TimeProto minute.
             * @member {number} minute
             * @memberof waiternow.common.TimeProto
             * @instance
             */
            TimeProto.prototype.minute = 0;

            /**
             * TimeProto second.
             * @member {number} second
             * @memberof waiternow.common.TimeProto
             * @instance
             */
            TimeProto.prototype.second = 0;

            /**
             * TimeProto nano.
             * @member {number} nano
             * @memberof waiternow.common.TimeProto
             * @instance
             */
            TimeProto.prototype.nano = 0;

            /**
             * Creates a new TimeProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.TimeProto
             * @static
             * @param {waiternow.common.ITimeProto=} [properties] Properties to set
             * @returns {waiternow.common.TimeProto} TimeProto instance
             */
            TimeProto.create = function create(properties) {
                return new TimeProto(properties);
            };

            /**
             * Encodes the specified TimeProto message. Does not implicitly {@link waiternow.common.TimeProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.TimeProto
             * @static
             * @param {waiternow.common.ITimeProto} message TimeProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            TimeProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.hour != null && Object.hasOwnProperty.call(message, "hour"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.hour);
                if (message.minute != null && Object.hasOwnProperty.call(message, "minute"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.minute);
                if (message.second != null && Object.hasOwnProperty.call(message, "second"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.second);
                if (message.nano != null && Object.hasOwnProperty.call(message, "nano"))
                    writer.uint32(/* id 4, wireType 0 =*/32).int32(message.nano);
                return writer;
            };

            /**
             * Encodes the specified TimeProto message, length delimited. Does not implicitly {@link waiternow.common.TimeProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.TimeProto
             * @static
             * @param {waiternow.common.ITimeProto} message TimeProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            TimeProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a TimeProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.TimeProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.TimeProto} TimeProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            TimeProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.TimeProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.hour = reader.int32();
                            break;
                        }
                    case 2: {
                            message.minute = reader.int32();
                            break;
                        }
                    case 3: {
                            message.second = reader.int32();
                            break;
                        }
                    case 4: {
                            message.nano = reader.int32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a TimeProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.TimeProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.TimeProto} TimeProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            TimeProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a TimeProto message.
             * @function verify
             * @memberof waiternow.common.TimeProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            TimeProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.hour != null && message.hasOwnProperty("hour"))
                    if (!$util.isInteger(message.hour))
                        return "hour: integer expected";
                if (message.minute != null && message.hasOwnProperty("minute"))
                    if (!$util.isInteger(message.minute))
                        return "minute: integer expected";
                if (message.second != null && message.hasOwnProperty("second"))
                    if (!$util.isInteger(message.second))
                        return "second: integer expected";
                if (message.nano != null && message.hasOwnProperty("nano"))
                    if (!$util.isInteger(message.nano))
                        return "nano: integer expected";
                return null;
            };

            /**
             * Creates a TimeProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.TimeProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.TimeProto} TimeProto
             */
            TimeProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.TimeProto)
                    return object;
                var message = new $root.waiternow.common.TimeProto();
                if (object.hour != null)
                    message.hour = object.hour | 0;
                if (object.minute != null)
                    message.minute = object.minute | 0;
                if (object.second != null)
                    message.second = object.second | 0;
                if (object.nano != null)
                    message.nano = object.nano | 0;
                return message;
            };

            /**
             * Creates a plain object from a TimeProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.TimeProto
             * @static
             * @param {waiternow.common.TimeProto} message TimeProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            TimeProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.hour = 0;
                    object.minute = 0;
                    object.second = 0;
                    object.nano = 0;
                }
                if (message.hour != null && message.hasOwnProperty("hour"))
                    object.hour = message.hour;
                if (message.minute != null && message.hasOwnProperty("minute"))
                    object.minute = message.minute;
                if (message.second != null && message.hasOwnProperty("second"))
                    object.second = message.second;
                if (message.nano != null && message.hasOwnProperty("nano"))
                    object.nano = message.nano;
                return object;
            };

            /**
             * Converts this TimeProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.TimeProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            TimeProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for TimeProto
             * @function getTypeUrl
             * @memberof waiternow.common.TimeProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            TimeProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.TimeProto";
            };

            return TimeProto;
        })();

        common.DateTimeProto = (function() {

            /**
             * Properties of a DateTimeProto.
             * @memberof waiternow.common
             * @interface IDateTimeProto
             * @property {waiternow.common.IDateProto|null} [date] DateTimeProto date
             * @property {waiternow.common.ITimeProto|null} [time] DateTimeProto time
             */

            /**
             * Constructs a new DateTimeProto.
             * @memberof waiternow.common
             * @classdesc Represents a DateTimeProto.
             * @implements IDateTimeProto
             * @constructor
             * @param {waiternow.common.IDateTimeProto=} [properties] Properties to set
             */
            function DateTimeProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * DateTimeProto date.
             * @member {waiternow.common.IDateProto|null|undefined} date
             * @memberof waiternow.common.DateTimeProto
             * @instance
             */
            DateTimeProto.prototype.date = null;

            /**
             * DateTimeProto time.
             * @member {waiternow.common.ITimeProto|null|undefined} time
             * @memberof waiternow.common.DateTimeProto
             * @instance
             */
            DateTimeProto.prototype.time = null;

            /**
             * Creates a new DateTimeProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.DateTimeProto
             * @static
             * @param {waiternow.common.IDateTimeProto=} [properties] Properties to set
             * @returns {waiternow.common.DateTimeProto} DateTimeProto instance
             */
            DateTimeProto.create = function create(properties) {
                return new DateTimeProto(properties);
            };

            /**
             * Encodes the specified DateTimeProto message. Does not implicitly {@link waiternow.common.DateTimeProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.DateTimeProto
             * @static
             * @param {waiternow.common.IDateTimeProto} message DateTimeProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DateTimeProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.date != null && Object.hasOwnProperty.call(message, "date"))
                    $root.waiternow.common.DateProto.encode(message.date, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.time != null && Object.hasOwnProperty.call(message, "time"))
                    $root.waiternow.common.TimeProto.encode(message.time, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified DateTimeProto message, length delimited. Does not implicitly {@link waiternow.common.DateTimeProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.DateTimeProto
             * @static
             * @param {waiternow.common.IDateTimeProto} message DateTimeProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DateTimeProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a DateTimeProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.DateTimeProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.DateTimeProto} DateTimeProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DateTimeProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.DateTimeProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.date = $root.waiternow.common.DateProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 2: {
                            message.time = $root.waiternow.common.TimeProto.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a DateTimeProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.DateTimeProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.DateTimeProto} DateTimeProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DateTimeProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a DateTimeProto message.
             * @function verify
             * @memberof waiternow.common.DateTimeProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            DateTimeProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.date != null && message.hasOwnProperty("date")) {
                    var error = $root.waiternow.common.DateProto.verify(message.date);
                    if (error)
                        return "date." + error;
                }
                if (message.time != null && message.hasOwnProperty("time")) {
                    var error = $root.waiternow.common.TimeProto.verify(message.time);
                    if (error)
                        return "time." + error;
                }
                return null;
            };

            /**
             * Creates a DateTimeProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.DateTimeProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.DateTimeProto} DateTimeProto
             */
            DateTimeProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.DateTimeProto)
                    return object;
                var message = new $root.waiternow.common.DateTimeProto();
                if (object.date != null) {
                    if (typeof object.date !== "object")
                        throw TypeError(".waiternow.common.DateTimeProto.date: object expected");
                    message.date = $root.waiternow.common.DateProto.fromObject(object.date);
                }
                if (object.time != null) {
                    if (typeof object.time !== "object")
                        throw TypeError(".waiternow.common.DateTimeProto.time: object expected");
                    message.time = $root.waiternow.common.TimeProto.fromObject(object.time);
                }
                return message;
            };

            /**
             * Creates a plain object from a DateTimeProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.DateTimeProto
             * @static
             * @param {waiternow.common.DateTimeProto} message DateTimeProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            DateTimeProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.date = null;
                    object.time = null;
                }
                if (message.date != null && message.hasOwnProperty("date"))
                    object.date = $root.waiternow.common.DateProto.toObject(message.date, options);
                if (message.time != null && message.hasOwnProperty("time"))
                    object.time = $root.waiternow.common.TimeProto.toObject(message.time, options);
                return object;
            };

            /**
             * Converts this DateTimeProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.DateTimeProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            DateTimeProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for DateTimeProto
             * @function getTypeUrl
             * @memberof waiternow.common.DateTimeProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            DateTimeProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.DateTimeProto";
            };

            return DateTimeProto;
        })();

        common.MonthRangeProto = (function() {

            /**
             * Properties of a MonthRangeProto.
             * @memberof waiternow.common
             * @interface IMonthRangeProto
             * @property {waiternow.common.Month|null} [from] MonthRangeProto from
             * @property {waiternow.common.Month|null} [to] MonthRangeProto to
             */

            /**
             * Constructs a new MonthRangeProto.
             * @memberof waiternow.common
             * @classdesc Represents a MonthRangeProto.
             * @implements IMonthRangeProto
             * @constructor
             * @param {waiternow.common.IMonthRangeProto=} [properties] Properties to set
             */
            function MonthRangeProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * MonthRangeProto from.
             * @member {waiternow.common.Month} from
             * @memberof waiternow.common.MonthRangeProto
             * @instance
             */
            MonthRangeProto.prototype.from = 0;

            /**
             * MonthRangeProto to.
             * @member {waiternow.common.Month} to
             * @memberof waiternow.common.MonthRangeProto
             * @instance
             */
            MonthRangeProto.prototype.to = 0;

            /**
             * Creates a new MonthRangeProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.MonthRangeProto
             * @static
             * @param {waiternow.common.IMonthRangeProto=} [properties] Properties to set
             * @returns {waiternow.common.MonthRangeProto} MonthRangeProto instance
             */
            MonthRangeProto.create = function create(properties) {
                return new MonthRangeProto(properties);
            };

            /**
             * Encodes the specified MonthRangeProto message. Does not implicitly {@link waiternow.common.MonthRangeProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.MonthRangeProto
             * @static
             * @param {waiternow.common.IMonthRangeProto} message MonthRangeProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MonthRangeProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.from != null && Object.hasOwnProperty.call(message, "from"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.from);
                if (message.to != null && Object.hasOwnProperty.call(message, "to"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.to);
                return writer;
            };

            /**
             * Encodes the specified MonthRangeProto message, length delimited. Does not implicitly {@link waiternow.common.MonthRangeProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.MonthRangeProto
             * @static
             * @param {waiternow.common.IMonthRangeProto} message MonthRangeProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MonthRangeProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a MonthRangeProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.MonthRangeProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.MonthRangeProto} MonthRangeProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MonthRangeProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.MonthRangeProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.from = reader.int32();
                            break;
                        }
                    case 2: {
                            message.to = reader.int32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a MonthRangeProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.MonthRangeProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.MonthRangeProto} MonthRangeProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MonthRangeProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a MonthRangeProto message.
             * @function verify
             * @memberof waiternow.common.MonthRangeProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            MonthRangeProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.from != null && message.hasOwnProperty("from"))
                    switch (message.from) {
                    default:
                        return "from: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                    case 9:
                    case 10:
                    case 11:
                    case 12:
                        break;
                    }
                if (message.to != null && message.hasOwnProperty("to"))
                    switch (message.to) {
                    default:
                        return "to: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                    case 9:
                    case 10:
                    case 11:
                    case 12:
                        break;
                    }
                return null;
            };

            /**
             * Creates a MonthRangeProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.MonthRangeProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.MonthRangeProto} MonthRangeProto
             */
            MonthRangeProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.MonthRangeProto)
                    return object;
                var message = new $root.waiternow.common.MonthRangeProto();
                switch (object.from) {
                default:
                    if (typeof object.from === "number") {
                        message.from = object.from;
                        break;
                    }
                    break;
                case "MONTH_UNSPECIFIED":
                case 0:
                    message.from = 0;
                    break;
                case "JANUARY":
                case 1:
                    message.from = 1;
                    break;
                case "FEBRUARY":
                case 2:
                    message.from = 2;
                    break;
                case "MARCH":
                case 3:
                    message.from = 3;
                    break;
                case "APRIL":
                case 4:
                    message.from = 4;
                    break;
                case "MAY":
                case 5:
                    message.from = 5;
                    break;
                case "JUNE":
                case 6:
                    message.from = 6;
                    break;
                case "JULY":
                case 7:
                    message.from = 7;
                    break;
                case "AUGUST":
                case 8:
                    message.from = 8;
                    break;
                case "SEPTEMBER":
                case 9:
                    message.from = 9;
                    break;
                case "OCTOBER":
                case 10:
                    message.from = 10;
                    break;
                case "NOVEMBER":
                case 11:
                    message.from = 11;
                    break;
                case "DECEMBER":
                case 12:
                    message.from = 12;
                    break;
                }
                switch (object.to) {
                default:
                    if (typeof object.to === "number") {
                        message.to = object.to;
                        break;
                    }
                    break;
                case "MONTH_UNSPECIFIED":
                case 0:
                    message.to = 0;
                    break;
                case "JANUARY":
                case 1:
                    message.to = 1;
                    break;
                case "FEBRUARY":
                case 2:
                    message.to = 2;
                    break;
                case "MARCH":
                case 3:
                    message.to = 3;
                    break;
                case "APRIL":
                case 4:
                    message.to = 4;
                    break;
                case "MAY":
                case 5:
                    message.to = 5;
                    break;
                case "JUNE":
                case 6:
                    message.to = 6;
                    break;
                case "JULY":
                case 7:
                    message.to = 7;
                    break;
                case "AUGUST":
                case 8:
                    message.to = 8;
                    break;
                case "SEPTEMBER":
                case 9:
                    message.to = 9;
                    break;
                case "OCTOBER":
                case 10:
                    message.to = 10;
                    break;
                case "NOVEMBER":
                case 11:
                    message.to = 11;
                    break;
                case "DECEMBER":
                case 12:
                    message.to = 12;
                    break;
                }
                return message;
            };

            /**
             * Creates a plain object from a MonthRangeProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.MonthRangeProto
             * @static
             * @param {waiternow.common.MonthRangeProto} message MonthRangeProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            MonthRangeProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.from = options.enums === String ? "MONTH_UNSPECIFIED" : 0;
                    object.to = options.enums === String ? "MONTH_UNSPECIFIED" : 0;
                }
                if (message.from != null && message.hasOwnProperty("from"))
                    object.from = options.enums === String ? $root.waiternow.common.Month[message.from] === undefined ? message.from : $root.waiternow.common.Month[message.from] : message.from;
                if (message.to != null && message.hasOwnProperty("to"))
                    object.to = options.enums === String ? $root.waiternow.common.Month[message.to] === undefined ? message.to : $root.waiternow.common.Month[message.to] : message.to;
                return object;
            };

            /**
             * Converts this MonthRangeProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.MonthRangeProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            MonthRangeProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for MonthRangeProto
             * @function getTypeUrl
             * @memberof waiternow.common.MonthRangeProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            MonthRangeProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.MonthRangeProto";
            };

            return MonthRangeProto;
        })();

        common.DateRangeProto = (function() {

            /**
             * Properties of a DateRangeProto.
             * @memberof waiternow.common
             * @interface IDateRangeProto
             * @property {waiternow.common.IDateProto|null} [from] DateRangeProto from
             * @property {waiternow.common.IDateProto|null} [to] DateRangeProto to
             */

            /**
             * Constructs a new DateRangeProto.
             * @memberof waiternow.common
             * @classdesc Represents a DateRangeProto.
             * @implements IDateRangeProto
             * @constructor
             * @param {waiternow.common.IDateRangeProto=} [properties] Properties to set
             */
            function DateRangeProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * DateRangeProto from.
             * @member {waiternow.common.IDateProto|null|undefined} from
             * @memberof waiternow.common.DateRangeProto
             * @instance
             */
            DateRangeProto.prototype.from = null;

            /**
             * DateRangeProto to.
             * @member {waiternow.common.IDateProto|null|undefined} to
             * @memberof waiternow.common.DateRangeProto
             * @instance
             */
            DateRangeProto.prototype.to = null;

            /**
             * Creates a new DateRangeProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.DateRangeProto
             * @static
             * @param {waiternow.common.IDateRangeProto=} [properties] Properties to set
             * @returns {waiternow.common.DateRangeProto} DateRangeProto instance
             */
            DateRangeProto.create = function create(properties) {
                return new DateRangeProto(properties);
            };

            /**
             * Encodes the specified DateRangeProto message. Does not implicitly {@link waiternow.common.DateRangeProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.DateRangeProto
             * @static
             * @param {waiternow.common.IDateRangeProto} message DateRangeProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DateRangeProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.from != null && Object.hasOwnProperty.call(message, "from"))
                    $root.waiternow.common.DateProto.encode(message.from, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.to != null && Object.hasOwnProperty.call(message, "to"))
                    $root.waiternow.common.DateProto.encode(message.to, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified DateRangeProto message, length delimited. Does not implicitly {@link waiternow.common.DateRangeProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.DateRangeProto
             * @static
             * @param {waiternow.common.IDateRangeProto} message DateRangeProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DateRangeProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a DateRangeProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.DateRangeProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.DateRangeProto} DateRangeProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DateRangeProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.DateRangeProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.from = $root.waiternow.common.DateProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 2: {
                            message.to = $root.waiternow.common.DateProto.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a DateRangeProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.DateRangeProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.DateRangeProto} DateRangeProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DateRangeProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a DateRangeProto message.
             * @function verify
             * @memberof waiternow.common.DateRangeProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            DateRangeProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.from != null && message.hasOwnProperty("from")) {
                    var error = $root.waiternow.common.DateProto.verify(message.from);
                    if (error)
                        return "from." + error;
                }
                if (message.to != null && message.hasOwnProperty("to")) {
                    var error = $root.waiternow.common.DateProto.verify(message.to);
                    if (error)
                        return "to." + error;
                }
                return null;
            };

            /**
             * Creates a DateRangeProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.DateRangeProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.DateRangeProto} DateRangeProto
             */
            DateRangeProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.DateRangeProto)
                    return object;
                var message = new $root.waiternow.common.DateRangeProto();
                if (object.from != null) {
                    if (typeof object.from !== "object")
                        throw TypeError(".waiternow.common.DateRangeProto.from: object expected");
                    message.from = $root.waiternow.common.DateProto.fromObject(object.from);
                }
                if (object.to != null) {
                    if (typeof object.to !== "object")
                        throw TypeError(".waiternow.common.DateRangeProto.to: object expected");
                    message.to = $root.waiternow.common.DateProto.fromObject(object.to);
                }
                return message;
            };

            /**
             * Creates a plain object from a DateRangeProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.DateRangeProto
             * @static
             * @param {waiternow.common.DateRangeProto} message DateRangeProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            DateRangeProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.from = null;
                    object.to = null;
                }
                if (message.from != null && message.hasOwnProperty("from"))
                    object.from = $root.waiternow.common.DateProto.toObject(message.from, options);
                if (message.to != null && message.hasOwnProperty("to"))
                    object.to = $root.waiternow.common.DateProto.toObject(message.to, options);
                return object;
            };

            /**
             * Converts this DateRangeProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.DateRangeProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            DateRangeProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for DateRangeProto
             * @function getTypeUrl
             * @memberof waiternow.common.DateRangeProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            DateRangeProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.DateRangeProto";
            };

            return DateRangeProto;
        })();

        common.TimeRangeProto = (function() {

            /**
             * Properties of a TimeRangeProto.
             * @memberof waiternow.common
             * @interface ITimeRangeProto
             * @property {waiternow.common.ITimeProto|null} [from] TimeRangeProto from
             * @property {waiternow.common.ITimeProto|null} [to] TimeRangeProto to
             */

            /**
             * Constructs a new TimeRangeProto.
             * @memberof waiternow.common
             * @classdesc Represents a TimeRangeProto.
             * @implements ITimeRangeProto
             * @constructor
             * @param {waiternow.common.ITimeRangeProto=} [properties] Properties to set
             */
            function TimeRangeProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * TimeRangeProto from.
             * @member {waiternow.common.ITimeProto|null|undefined} from
             * @memberof waiternow.common.TimeRangeProto
             * @instance
             */
            TimeRangeProto.prototype.from = null;

            /**
             * TimeRangeProto to.
             * @member {waiternow.common.ITimeProto|null|undefined} to
             * @memberof waiternow.common.TimeRangeProto
             * @instance
             */
            TimeRangeProto.prototype.to = null;

            /**
             * Creates a new TimeRangeProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.TimeRangeProto
             * @static
             * @param {waiternow.common.ITimeRangeProto=} [properties] Properties to set
             * @returns {waiternow.common.TimeRangeProto} TimeRangeProto instance
             */
            TimeRangeProto.create = function create(properties) {
                return new TimeRangeProto(properties);
            };

            /**
             * Encodes the specified TimeRangeProto message. Does not implicitly {@link waiternow.common.TimeRangeProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.TimeRangeProto
             * @static
             * @param {waiternow.common.ITimeRangeProto} message TimeRangeProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            TimeRangeProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.from != null && Object.hasOwnProperty.call(message, "from"))
                    $root.waiternow.common.TimeProto.encode(message.from, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.to != null && Object.hasOwnProperty.call(message, "to"))
                    $root.waiternow.common.TimeProto.encode(message.to, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified TimeRangeProto message, length delimited. Does not implicitly {@link waiternow.common.TimeRangeProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.TimeRangeProto
             * @static
             * @param {waiternow.common.ITimeRangeProto} message TimeRangeProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            TimeRangeProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a TimeRangeProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.TimeRangeProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.TimeRangeProto} TimeRangeProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            TimeRangeProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.TimeRangeProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.from = $root.waiternow.common.TimeProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 2: {
                            message.to = $root.waiternow.common.TimeProto.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a TimeRangeProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.TimeRangeProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.TimeRangeProto} TimeRangeProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            TimeRangeProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a TimeRangeProto message.
             * @function verify
             * @memberof waiternow.common.TimeRangeProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            TimeRangeProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.from != null && message.hasOwnProperty("from")) {
                    var error = $root.waiternow.common.TimeProto.verify(message.from);
                    if (error)
                        return "from." + error;
                }
                if (message.to != null && message.hasOwnProperty("to")) {
                    var error = $root.waiternow.common.TimeProto.verify(message.to);
                    if (error)
                        return "to." + error;
                }
                return null;
            };

            /**
             * Creates a TimeRangeProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.TimeRangeProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.TimeRangeProto} TimeRangeProto
             */
            TimeRangeProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.TimeRangeProto)
                    return object;
                var message = new $root.waiternow.common.TimeRangeProto();
                if (object.from != null) {
                    if (typeof object.from !== "object")
                        throw TypeError(".waiternow.common.TimeRangeProto.from: object expected");
                    message.from = $root.waiternow.common.TimeProto.fromObject(object.from);
                }
                if (object.to != null) {
                    if (typeof object.to !== "object")
                        throw TypeError(".waiternow.common.TimeRangeProto.to: object expected");
                    message.to = $root.waiternow.common.TimeProto.fromObject(object.to);
                }
                return message;
            };

            /**
             * Creates a plain object from a TimeRangeProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.TimeRangeProto
             * @static
             * @param {waiternow.common.TimeRangeProto} message TimeRangeProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            TimeRangeProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.from = null;
                    object.to = null;
                }
                if (message.from != null && message.hasOwnProperty("from"))
                    object.from = $root.waiternow.common.TimeProto.toObject(message.from, options);
                if (message.to != null && message.hasOwnProperty("to"))
                    object.to = $root.waiternow.common.TimeProto.toObject(message.to, options);
                return object;
            };

            /**
             * Converts this TimeRangeProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.TimeRangeProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            TimeRangeProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for TimeRangeProto
             * @function getTypeUrl
             * @memberof waiternow.common.TimeRangeProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            TimeRangeProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.TimeRangeProto";
            };

            return TimeRangeProto;
        })();

        common.DateTimeRangeProto = (function() {

            /**
             * Properties of a DateTimeRangeProto.
             * @memberof waiternow.common
             * @interface IDateTimeRangeProto
             * @property {waiternow.common.IDateTimeProto|null} [from] DateTimeRangeProto from
             * @property {waiternow.common.IDateTimeProto|null} [to] DateTimeRangeProto to
             */

            /**
             * Constructs a new DateTimeRangeProto.
             * @memberof waiternow.common
             * @classdesc Represents a DateTimeRangeProto.
             * @implements IDateTimeRangeProto
             * @constructor
             * @param {waiternow.common.IDateTimeRangeProto=} [properties] Properties to set
             */
            function DateTimeRangeProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * DateTimeRangeProto from.
             * @member {waiternow.common.IDateTimeProto|null|undefined} from
             * @memberof waiternow.common.DateTimeRangeProto
             * @instance
             */
            DateTimeRangeProto.prototype.from = null;

            /**
             * DateTimeRangeProto to.
             * @member {waiternow.common.IDateTimeProto|null|undefined} to
             * @memberof waiternow.common.DateTimeRangeProto
             * @instance
             */
            DateTimeRangeProto.prototype.to = null;

            /**
             * Creates a new DateTimeRangeProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.DateTimeRangeProto
             * @static
             * @param {waiternow.common.IDateTimeRangeProto=} [properties] Properties to set
             * @returns {waiternow.common.DateTimeRangeProto} DateTimeRangeProto instance
             */
            DateTimeRangeProto.create = function create(properties) {
                return new DateTimeRangeProto(properties);
            };

            /**
             * Encodes the specified DateTimeRangeProto message. Does not implicitly {@link waiternow.common.DateTimeRangeProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.DateTimeRangeProto
             * @static
             * @param {waiternow.common.IDateTimeRangeProto} message DateTimeRangeProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DateTimeRangeProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.from != null && Object.hasOwnProperty.call(message, "from"))
                    $root.waiternow.common.DateTimeProto.encode(message.from, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.to != null && Object.hasOwnProperty.call(message, "to"))
                    $root.waiternow.common.DateTimeProto.encode(message.to, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified DateTimeRangeProto message, length delimited. Does not implicitly {@link waiternow.common.DateTimeRangeProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.DateTimeRangeProto
             * @static
             * @param {waiternow.common.IDateTimeRangeProto} message DateTimeRangeProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DateTimeRangeProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a DateTimeRangeProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.DateTimeRangeProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.DateTimeRangeProto} DateTimeRangeProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DateTimeRangeProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.DateTimeRangeProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.from = $root.waiternow.common.DateTimeProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 2: {
                            message.to = $root.waiternow.common.DateTimeProto.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a DateTimeRangeProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.DateTimeRangeProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.DateTimeRangeProto} DateTimeRangeProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DateTimeRangeProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a DateTimeRangeProto message.
             * @function verify
             * @memberof waiternow.common.DateTimeRangeProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            DateTimeRangeProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.from != null && message.hasOwnProperty("from")) {
                    var error = $root.waiternow.common.DateTimeProto.verify(message.from);
                    if (error)
                        return "from." + error;
                }
                if (message.to != null && message.hasOwnProperty("to")) {
                    var error = $root.waiternow.common.DateTimeProto.verify(message.to);
                    if (error)
                        return "to." + error;
                }
                return null;
            };

            /**
             * Creates a DateTimeRangeProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.DateTimeRangeProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.DateTimeRangeProto} DateTimeRangeProto
             */
            DateTimeRangeProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.DateTimeRangeProto)
                    return object;
                var message = new $root.waiternow.common.DateTimeRangeProto();
                if (object.from != null) {
                    if (typeof object.from !== "object")
                        throw TypeError(".waiternow.common.DateTimeRangeProto.from: object expected");
                    message.from = $root.waiternow.common.DateTimeProto.fromObject(object.from);
                }
                if (object.to != null) {
                    if (typeof object.to !== "object")
                        throw TypeError(".waiternow.common.DateTimeRangeProto.to: object expected");
                    message.to = $root.waiternow.common.DateTimeProto.fromObject(object.to);
                }
                return message;
            };

            /**
             * Creates a plain object from a DateTimeRangeProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.DateTimeRangeProto
             * @static
             * @param {waiternow.common.DateTimeRangeProto} message DateTimeRangeProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            DateTimeRangeProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.from = null;
                    object.to = null;
                }
                if (message.from != null && message.hasOwnProperty("from"))
                    object.from = $root.waiternow.common.DateTimeProto.toObject(message.from, options);
                if (message.to != null && message.hasOwnProperty("to"))
                    object.to = $root.waiternow.common.DateTimeProto.toObject(message.to, options);
                return object;
            };

            /**
             * Converts this DateTimeRangeProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.DateTimeRangeProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            DateTimeRangeProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for DateTimeRangeProto
             * @function getTypeUrl
             * @memberof waiternow.common.DateTimeRangeProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            DateTimeRangeProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.DateTimeRangeProto";
            };

            return DateTimeRangeProto;
        })();

        common.TimestampRangeProto = (function() {

            /**
             * Properties of a TimestampRangeProto.
             * @memberof waiternow.common
             * @interface ITimestampRangeProto
             * @property {google.protobuf.ITimestamp|null} [from] TimestampRangeProto from
             * @property {google.protobuf.ITimestamp|null} [to] TimestampRangeProto to
             */

            /**
             * Constructs a new TimestampRangeProto.
             * @memberof waiternow.common
             * @classdesc Represents a TimestampRangeProto.
             * @implements ITimestampRangeProto
             * @constructor
             * @param {waiternow.common.ITimestampRangeProto=} [properties] Properties to set
             */
            function TimestampRangeProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * TimestampRangeProto from.
             * @member {google.protobuf.ITimestamp|null|undefined} from
             * @memberof waiternow.common.TimestampRangeProto
             * @instance
             */
            TimestampRangeProto.prototype.from = null;

            /**
             * TimestampRangeProto to.
             * @member {google.protobuf.ITimestamp|null|undefined} to
             * @memberof waiternow.common.TimestampRangeProto
             * @instance
             */
            TimestampRangeProto.prototype.to = null;

            /**
             * Creates a new TimestampRangeProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.TimestampRangeProto
             * @static
             * @param {waiternow.common.ITimestampRangeProto=} [properties] Properties to set
             * @returns {waiternow.common.TimestampRangeProto} TimestampRangeProto instance
             */
            TimestampRangeProto.create = function create(properties) {
                return new TimestampRangeProto(properties);
            };

            /**
             * Encodes the specified TimestampRangeProto message. Does not implicitly {@link waiternow.common.TimestampRangeProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.TimestampRangeProto
             * @static
             * @param {waiternow.common.ITimestampRangeProto} message TimestampRangeProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            TimestampRangeProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.from != null && Object.hasOwnProperty.call(message, "from"))
                    $root.google.protobuf.Timestamp.encode(message.from, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.to != null && Object.hasOwnProperty.call(message, "to"))
                    $root.google.protobuf.Timestamp.encode(message.to, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified TimestampRangeProto message, length delimited. Does not implicitly {@link waiternow.common.TimestampRangeProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.TimestampRangeProto
             * @static
             * @param {waiternow.common.ITimestampRangeProto} message TimestampRangeProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            TimestampRangeProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a TimestampRangeProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.TimestampRangeProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.TimestampRangeProto} TimestampRangeProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            TimestampRangeProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.TimestampRangeProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.from = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 2: {
                            message.to = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a TimestampRangeProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.TimestampRangeProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.TimestampRangeProto} TimestampRangeProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            TimestampRangeProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a TimestampRangeProto message.
             * @function verify
             * @memberof waiternow.common.TimestampRangeProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            TimestampRangeProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.from != null && message.hasOwnProperty("from")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.from);
                    if (error)
                        return "from." + error;
                }
                if (message.to != null && message.hasOwnProperty("to")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.to);
                    if (error)
                        return "to." + error;
                }
                return null;
            };

            /**
             * Creates a TimestampRangeProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.TimestampRangeProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.TimestampRangeProto} TimestampRangeProto
             */
            TimestampRangeProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.TimestampRangeProto)
                    return object;
                var message = new $root.waiternow.common.TimestampRangeProto();
                if (object.from != null) {
                    if (typeof object.from !== "object")
                        throw TypeError(".waiternow.common.TimestampRangeProto.from: object expected");
                    message.from = $root.google.protobuf.Timestamp.fromObject(object.from);
                }
                if (object.to != null) {
                    if (typeof object.to !== "object")
                        throw TypeError(".waiternow.common.TimestampRangeProto.to: object expected");
                    message.to = $root.google.protobuf.Timestamp.fromObject(object.to);
                }
                return message;
            };

            /**
             * Creates a plain object from a TimestampRangeProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.TimestampRangeProto
             * @static
             * @param {waiternow.common.TimestampRangeProto} message TimestampRangeProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            TimestampRangeProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.from = null;
                    object.to = null;
                }
                if (message.from != null && message.hasOwnProperty("from"))
                    object.from = $root.google.protobuf.Timestamp.toObject(message.from, options);
                if (message.to != null && message.hasOwnProperty("to"))
                    object.to = $root.google.protobuf.Timestamp.toObject(message.to, options);
                return object;
            };

            /**
             * Converts this TimestampRangeProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.TimestampRangeProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            TimestampRangeProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for TimestampRangeProto
             * @function getTypeUrl
             * @memberof waiternow.common.TimestampRangeProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            TimestampRangeProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.TimestampRangeProto";
            };

            return TimestampRangeProto;
        })();

        common.BusinessHoursProto = (function() {

            /**
             * Properties of a BusinessHoursProto.
             * @memberof waiternow.common
             * @interface IBusinessHoursProto
             * @property {waiternow.common.ITimeRangeProto|null} [sundayHours] BusinessHoursProto sundayHours
             * @property {waiternow.common.ITimeRangeProto|null} [mondayHours] BusinessHoursProto mondayHours
             * @property {waiternow.common.ITimeRangeProto|null} [tuesdayHours] BusinessHoursProto tuesdayHours
             * @property {waiternow.common.ITimeRangeProto|null} [wednesdayHours] BusinessHoursProto wednesdayHours
             * @property {waiternow.common.ITimeRangeProto|null} [thursdayHours] BusinessHoursProto thursdayHours
             * @property {waiternow.common.ITimeRangeProto|null} [fridayHours] BusinessHoursProto fridayHours
             * @property {waiternow.common.ITimeRangeProto|null} [saturdayHours] BusinessHoursProto saturdayHours
             * @property {boolean|null} [isSundayClosed] BusinessHoursProto isSundayClosed
             * @property {boolean|null} [isMondayClosed] BusinessHoursProto isMondayClosed
             * @property {boolean|null} [isTuesdayClosed] BusinessHoursProto isTuesdayClosed
             * @property {boolean|null} [isWednesdayClosed] BusinessHoursProto isWednesdayClosed
             * @property {boolean|null} [isThursdayClosed] BusinessHoursProto isThursdayClosed
             * @property {boolean|null} [isFridayClosed] BusinessHoursProto isFridayClosed
             * @property {boolean|null} [isSaturdayClosed] BusinessHoursProto isSaturdayClosed
             * @property {waiternow.common.ITimeRangeProto|null} [sundaySecondHours] BusinessHoursProto sundaySecondHours
             * @property {waiternow.common.ITimeRangeProto|null} [mondaySecondHours] BusinessHoursProto mondaySecondHours
             * @property {waiternow.common.ITimeRangeProto|null} [tuesdaySecondHours] BusinessHoursProto tuesdaySecondHours
             * @property {waiternow.common.ITimeRangeProto|null} [wednesdaySecondHours] BusinessHoursProto wednesdaySecondHours
             * @property {waiternow.common.ITimeRangeProto|null} [thursdaySecondHours] BusinessHoursProto thursdaySecondHours
             * @property {waiternow.common.ITimeRangeProto|null} [fridaySecondHours] BusinessHoursProto fridaySecondHours
             * @property {waiternow.common.ITimeRangeProto|null} [saturdaySecondHours] BusinessHoursProto saturdaySecondHours
             * @property {Array.<waiternow.common.BusinessHoursProto.ISpecialHoursProto>|null} [specialHours] BusinessHoursProto specialHours
             */

            /**
             * Constructs a new BusinessHoursProto.
             * @memberof waiternow.common
             * @classdesc Represents a BusinessHoursProto.
             * @implements IBusinessHoursProto
             * @constructor
             * @param {waiternow.common.IBusinessHoursProto=} [properties] Properties to set
             */
            function BusinessHoursProto(properties) {
                this.specialHours = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * BusinessHoursProto sundayHours.
             * @member {waiternow.common.ITimeRangeProto|null|undefined} sundayHours
             * @memberof waiternow.common.BusinessHoursProto
             * @instance
             */
            BusinessHoursProto.prototype.sundayHours = null;

            /**
             * BusinessHoursProto mondayHours.
             * @member {waiternow.common.ITimeRangeProto|null|undefined} mondayHours
             * @memberof waiternow.common.BusinessHoursProto
             * @instance
             */
            BusinessHoursProto.prototype.mondayHours = null;

            /**
             * BusinessHoursProto tuesdayHours.
             * @member {waiternow.common.ITimeRangeProto|null|undefined} tuesdayHours
             * @memberof waiternow.common.BusinessHoursProto
             * @instance
             */
            BusinessHoursProto.prototype.tuesdayHours = null;

            /**
             * BusinessHoursProto wednesdayHours.
             * @member {waiternow.common.ITimeRangeProto|null|undefined} wednesdayHours
             * @memberof waiternow.common.BusinessHoursProto
             * @instance
             */
            BusinessHoursProto.prototype.wednesdayHours = null;

            /**
             * BusinessHoursProto thursdayHours.
             * @member {waiternow.common.ITimeRangeProto|null|undefined} thursdayHours
             * @memberof waiternow.common.BusinessHoursProto
             * @instance
             */
            BusinessHoursProto.prototype.thursdayHours = null;

            /**
             * BusinessHoursProto fridayHours.
             * @member {waiternow.common.ITimeRangeProto|null|undefined} fridayHours
             * @memberof waiternow.common.BusinessHoursProto
             * @instance
             */
            BusinessHoursProto.prototype.fridayHours = null;

            /**
             * BusinessHoursProto saturdayHours.
             * @member {waiternow.common.ITimeRangeProto|null|undefined} saturdayHours
             * @memberof waiternow.common.BusinessHoursProto
             * @instance
             */
            BusinessHoursProto.prototype.saturdayHours = null;

            /**
             * BusinessHoursProto isSundayClosed.
             * @member {boolean} isSundayClosed
             * @memberof waiternow.common.BusinessHoursProto
             * @instance
             */
            BusinessHoursProto.prototype.isSundayClosed = false;

            /**
             * BusinessHoursProto isMondayClosed.
             * @member {boolean} isMondayClosed
             * @memberof waiternow.common.BusinessHoursProto
             * @instance
             */
            BusinessHoursProto.prototype.isMondayClosed = false;

            /**
             * BusinessHoursProto isTuesdayClosed.
             * @member {boolean} isTuesdayClosed
             * @memberof waiternow.common.BusinessHoursProto
             * @instance
             */
            BusinessHoursProto.prototype.isTuesdayClosed = false;

            /**
             * BusinessHoursProto isWednesdayClosed.
             * @member {boolean} isWednesdayClosed
             * @memberof waiternow.common.BusinessHoursProto
             * @instance
             */
            BusinessHoursProto.prototype.isWednesdayClosed = false;

            /**
             * BusinessHoursProto isThursdayClosed.
             * @member {boolean} isThursdayClosed
             * @memberof waiternow.common.BusinessHoursProto
             * @instance
             */
            BusinessHoursProto.prototype.isThursdayClosed = false;

            /**
             * BusinessHoursProto isFridayClosed.
             * @member {boolean} isFridayClosed
             * @memberof waiternow.common.BusinessHoursProto
             * @instance
             */
            BusinessHoursProto.prototype.isFridayClosed = false;

            /**
             * BusinessHoursProto isSaturdayClosed.
             * @member {boolean} isSaturdayClosed
             * @memberof waiternow.common.BusinessHoursProto
             * @instance
             */
            BusinessHoursProto.prototype.isSaturdayClosed = false;

            /**
             * BusinessHoursProto sundaySecondHours.
             * @member {waiternow.common.ITimeRangeProto|null|undefined} sundaySecondHours
             * @memberof waiternow.common.BusinessHoursProto
             * @instance
             */
            BusinessHoursProto.prototype.sundaySecondHours = null;

            /**
             * BusinessHoursProto mondaySecondHours.
             * @member {waiternow.common.ITimeRangeProto|null|undefined} mondaySecondHours
             * @memberof waiternow.common.BusinessHoursProto
             * @instance
             */
            BusinessHoursProto.prototype.mondaySecondHours = null;

            /**
             * BusinessHoursProto tuesdaySecondHours.
             * @member {waiternow.common.ITimeRangeProto|null|undefined} tuesdaySecondHours
             * @memberof waiternow.common.BusinessHoursProto
             * @instance
             */
            BusinessHoursProto.prototype.tuesdaySecondHours = null;

            /**
             * BusinessHoursProto wednesdaySecondHours.
             * @member {waiternow.common.ITimeRangeProto|null|undefined} wednesdaySecondHours
             * @memberof waiternow.common.BusinessHoursProto
             * @instance
             */
            BusinessHoursProto.prototype.wednesdaySecondHours = null;

            /**
             * BusinessHoursProto thursdaySecondHours.
             * @member {waiternow.common.ITimeRangeProto|null|undefined} thursdaySecondHours
             * @memberof waiternow.common.BusinessHoursProto
             * @instance
             */
            BusinessHoursProto.prototype.thursdaySecondHours = null;

            /**
             * BusinessHoursProto fridaySecondHours.
             * @member {waiternow.common.ITimeRangeProto|null|undefined} fridaySecondHours
             * @memberof waiternow.common.BusinessHoursProto
             * @instance
             */
            BusinessHoursProto.prototype.fridaySecondHours = null;

            /**
             * BusinessHoursProto saturdaySecondHours.
             * @member {waiternow.common.ITimeRangeProto|null|undefined} saturdaySecondHours
             * @memberof waiternow.common.BusinessHoursProto
             * @instance
             */
            BusinessHoursProto.prototype.saturdaySecondHours = null;

            /**
             * BusinessHoursProto specialHours.
             * @member {Array.<waiternow.common.BusinessHoursProto.ISpecialHoursProto>} specialHours
             * @memberof waiternow.common.BusinessHoursProto
             * @instance
             */
            BusinessHoursProto.prototype.specialHours = $util.emptyArray;

            /**
             * Creates a new BusinessHoursProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.BusinessHoursProto
             * @static
             * @param {waiternow.common.IBusinessHoursProto=} [properties] Properties to set
             * @returns {waiternow.common.BusinessHoursProto} BusinessHoursProto instance
             */
            BusinessHoursProto.create = function create(properties) {
                return new BusinessHoursProto(properties);
            };

            /**
             * Encodes the specified BusinessHoursProto message. Does not implicitly {@link waiternow.common.BusinessHoursProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.BusinessHoursProto
             * @static
             * @param {waiternow.common.IBusinessHoursProto} message BusinessHoursProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BusinessHoursProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.sundayHours != null && Object.hasOwnProperty.call(message, "sundayHours"))
                    $root.waiternow.common.TimeRangeProto.encode(message.sundayHours, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.mondayHours != null && Object.hasOwnProperty.call(message, "mondayHours"))
                    $root.waiternow.common.TimeRangeProto.encode(message.mondayHours, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.tuesdayHours != null && Object.hasOwnProperty.call(message, "tuesdayHours"))
                    $root.waiternow.common.TimeRangeProto.encode(message.tuesdayHours, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.wednesdayHours != null && Object.hasOwnProperty.call(message, "wednesdayHours"))
                    $root.waiternow.common.TimeRangeProto.encode(message.wednesdayHours, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                if (message.thursdayHours != null && Object.hasOwnProperty.call(message, "thursdayHours"))
                    $root.waiternow.common.TimeRangeProto.encode(message.thursdayHours, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                if (message.fridayHours != null && Object.hasOwnProperty.call(message, "fridayHours"))
                    $root.waiternow.common.TimeRangeProto.encode(message.fridayHours, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                if (message.saturdayHours != null && Object.hasOwnProperty.call(message, "saturdayHours"))
                    $root.waiternow.common.TimeRangeProto.encode(message.saturdayHours, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                if (message.isSundayClosed != null && Object.hasOwnProperty.call(message, "isSundayClosed"))
                    writer.uint32(/* id 8, wireType 0 =*/64).bool(message.isSundayClosed);
                if (message.isMondayClosed != null && Object.hasOwnProperty.call(message, "isMondayClosed"))
                    writer.uint32(/* id 9, wireType 0 =*/72).bool(message.isMondayClosed);
                if (message.isTuesdayClosed != null && Object.hasOwnProperty.call(message, "isTuesdayClosed"))
                    writer.uint32(/* id 10, wireType 0 =*/80).bool(message.isTuesdayClosed);
                if (message.isWednesdayClosed != null && Object.hasOwnProperty.call(message, "isWednesdayClosed"))
                    writer.uint32(/* id 11, wireType 0 =*/88).bool(message.isWednesdayClosed);
                if (message.isThursdayClosed != null && Object.hasOwnProperty.call(message, "isThursdayClosed"))
                    writer.uint32(/* id 12, wireType 0 =*/96).bool(message.isThursdayClosed);
                if (message.isFridayClosed != null && Object.hasOwnProperty.call(message, "isFridayClosed"))
                    writer.uint32(/* id 13, wireType 0 =*/104).bool(message.isFridayClosed);
                if (message.isSaturdayClosed != null && Object.hasOwnProperty.call(message, "isSaturdayClosed"))
                    writer.uint32(/* id 14, wireType 0 =*/112).bool(message.isSaturdayClosed);
                if (message.sundaySecondHours != null && Object.hasOwnProperty.call(message, "sundaySecondHours"))
                    $root.waiternow.common.TimeRangeProto.encode(message.sundaySecondHours, writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
                if (message.mondaySecondHours != null && Object.hasOwnProperty.call(message, "mondaySecondHours"))
                    $root.waiternow.common.TimeRangeProto.encode(message.mondaySecondHours, writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
                if (message.tuesdaySecondHours != null && Object.hasOwnProperty.call(message, "tuesdaySecondHours"))
                    $root.waiternow.common.TimeRangeProto.encode(message.tuesdaySecondHours, writer.uint32(/* id 17, wireType 2 =*/138).fork()).ldelim();
                if (message.wednesdaySecondHours != null && Object.hasOwnProperty.call(message, "wednesdaySecondHours"))
                    $root.waiternow.common.TimeRangeProto.encode(message.wednesdaySecondHours, writer.uint32(/* id 18, wireType 2 =*/146).fork()).ldelim();
                if (message.thursdaySecondHours != null && Object.hasOwnProperty.call(message, "thursdaySecondHours"))
                    $root.waiternow.common.TimeRangeProto.encode(message.thursdaySecondHours, writer.uint32(/* id 19, wireType 2 =*/154).fork()).ldelim();
                if (message.fridaySecondHours != null && Object.hasOwnProperty.call(message, "fridaySecondHours"))
                    $root.waiternow.common.TimeRangeProto.encode(message.fridaySecondHours, writer.uint32(/* id 20, wireType 2 =*/162).fork()).ldelim();
                if (message.saturdaySecondHours != null && Object.hasOwnProperty.call(message, "saturdaySecondHours"))
                    $root.waiternow.common.TimeRangeProto.encode(message.saturdaySecondHours, writer.uint32(/* id 21, wireType 2 =*/170).fork()).ldelim();
                if (message.specialHours != null && message.specialHours.length)
                    for (var i = 0; i < message.specialHours.length; ++i)
                        $root.waiternow.common.BusinessHoursProto.SpecialHoursProto.encode(message.specialHours[i], writer.uint32(/* id 22, wireType 2 =*/178).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified BusinessHoursProto message, length delimited. Does not implicitly {@link waiternow.common.BusinessHoursProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.BusinessHoursProto
             * @static
             * @param {waiternow.common.IBusinessHoursProto} message BusinessHoursProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BusinessHoursProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a BusinessHoursProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.BusinessHoursProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.BusinessHoursProto} BusinessHoursProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BusinessHoursProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.BusinessHoursProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.sundayHours = $root.waiternow.common.TimeRangeProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 2: {
                            message.mondayHours = $root.waiternow.common.TimeRangeProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 3: {
                            message.tuesdayHours = $root.waiternow.common.TimeRangeProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 4: {
                            message.wednesdayHours = $root.waiternow.common.TimeRangeProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 5: {
                            message.thursdayHours = $root.waiternow.common.TimeRangeProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 6: {
                            message.fridayHours = $root.waiternow.common.TimeRangeProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 7: {
                            message.saturdayHours = $root.waiternow.common.TimeRangeProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 8: {
                            message.isSundayClosed = reader.bool();
                            break;
                        }
                    case 9: {
                            message.isMondayClosed = reader.bool();
                            break;
                        }
                    case 10: {
                            message.isTuesdayClosed = reader.bool();
                            break;
                        }
                    case 11: {
                            message.isWednesdayClosed = reader.bool();
                            break;
                        }
                    case 12: {
                            message.isThursdayClosed = reader.bool();
                            break;
                        }
                    case 13: {
                            message.isFridayClosed = reader.bool();
                            break;
                        }
                    case 14: {
                            message.isSaturdayClosed = reader.bool();
                            break;
                        }
                    case 15: {
                            message.sundaySecondHours = $root.waiternow.common.TimeRangeProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 16: {
                            message.mondaySecondHours = $root.waiternow.common.TimeRangeProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 17: {
                            message.tuesdaySecondHours = $root.waiternow.common.TimeRangeProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 18: {
                            message.wednesdaySecondHours = $root.waiternow.common.TimeRangeProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 19: {
                            message.thursdaySecondHours = $root.waiternow.common.TimeRangeProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 20: {
                            message.fridaySecondHours = $root.waiternow.common.TimeRangeProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 21: {
                            message.saturdaySecondHours = $root.waiternow.common.TimeRangeProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 22: {
                            if (!(message.specialHours && message.specialHours.length))
                                message.specialHours = [];
                            message.specialHours.push($root.waiternow.common.BusinessHoursProto.SpecialHoursProto.decode(reader, reader.uint32()));
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a BusinessHoursProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.BusinessHoursProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.BusinessHoursProto} BusinessHoursProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BusinessHoursProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a BusinessHoursProto message.
             * @function verify
             * @memberof waiternow.common.BusinessHoursProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            BusinessHoursProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.sundayHours != null && message.hasOwnProperty("sundayHours")) {
                    var error = $root.waiternow.common.TimeRangeProto.verify(message.sundayHours);
                    if (error)
                        return "sundayHours." + error;
                }
                if (message.mondayHours != null && message.hasOwnProperty("mondayHours")) {
                    var error = $root.waiternow.common.TimeRangeProto.verify(message.mondayHours);
                    if (error)
                        return "mondayHours." + error;
                }
                if (message.tuesdayHours != null && message.hasOwnProperty("tuesdayHours")) {
                    var error = $root.waiternow.common.TimeRangeProto.verify(message.tuesdayHours);
                    if (error)
                        return "tuesdayHours." + error;
                }
                if (message.wednesdayHours != null && message.hasOwnProperty("wednesdayHours")) {
                    var error = $root.waiternow.common.TimeRangeProto.verify(message.wednesdayHours);
                    if (error)
                        return "wednesdayHours." + error;
                }
                if (message.thursdayHours != null && message.hasOwnProperty("thursdayHours")) {
                    var error = $root.waiternow.common.TimeRangeProto.verify(message.thursdayHours);
                    if (error)
                        return "thursdayHours." + error;
                }
                if (message.fridayHours != null && message.hasOwnProperty("fridayHours")) {
                    var error = $root.waiternow.common.TimeRangeProto.verify(message.fridayHours);
                    if (error)
                        return "fridayHours." + error;
                }
                if (message.saturdayHours != null && message.hasOwnProperty("saturdayHours")) {
                    var error = $root.waiternow.common.TimeRangeProto.verify(message.saturdayHours);
                    if (error)
                        return "saturdayHours." + error;
                }
                if (message.isSundayClosed != null && message.hasOwnProperty("isSundayClosed"))
                    if (typeof message.isSundayClosed !== "boolean")
                        return "isSundayClosed: boolean expected";
                if (message.isMondayClosed != null && message.hasOwnProperty("isMondayClosed"))
                    if (typeof message.isMondayClosed !== "boolean")
                        return "isMondayClosed: boolean expected";
                if (message.isTuesdayClosed != null && message.hasOwnProperty("isTuesdayClosed"))
                    if (typeof message.isTuesdayClosed !== "boolean")
                        return "isTuesdayClosed: boolean expected";
                if (message.isWednesdayClosed != null && message.hasOwnProperty("isWednesdayClosed"))
                    if (typeof message.isWednesdayClosed !== "boolean")
                        return "isWednesdayClosed: boolean expected";
                if (message.isThursdayClosed != null && message.hasOwnProperty("isThursdayClosed"))
                    if (typeof message.isThursdayClosed !== "boolean")
                        return "isThursdayClosed: boolean expected";
                if (message.isFridayClosed != null && message.hasOwnProperty("isFridayClosed"))
                    if (typeof message.isFridayClosed !== "boolean")
                        return "isFridayClosed: boolean expected";
                if (message.isSaturdayClosed != null && message.hasOwnProperty("isSaturdayClosed"))
                    if (typeof message.isSaturdayClosed !== "boolean")
                        return "isSaturdayClosed: boolean expected";
                if (message.sundaySecondHours != null && message.hasOwnProperty("sundaySecondHours")) {
                    var error = $root.waiternow.common.TimeRangeProto.verify(message.sundaySecondHours);
                    if (error)
                        return "sundaySecondHours." + error;
                }
                if (message.mondaySecondHours != null && message.hasOwnProperty("mondaySecondHours")) {
                    var error = $root.waiternow.common.TimeRangeProto.verify(message.mondaySecondHours);
                    if (error)
                        return "mondaySecondHours." + error;
                }
                if (message.tuesdaySecondHours != null && message.hasOwnProperty("tuesdaySecondHours")) {
                    var error = $root.waiternow.common.TimeRangeProto.verify(message.tuesdaySecondHours);
                    if (error)
                        return "tuesdaySecondHours." + error;
                }
                if (message.wednesdaySecondHours != null && message.hasOwnProperty("wednesdaySecondHours")) {
                    var error = $root.waiternow.common.TimeRangeProto.verify(message.wednesdaySecondHours);
                    if (error)
                        return "wednesdaySecondHours." + error;
                }
                if (message.thursdaySecondHours != null && message.hasOwnProperty("thursdaySecondHours")) {
                    var error = $root.waiternow.common.TimeRangeProto.verify(message.thursdaySecondHours);
                    if (error)
                        return "thursdaySecondHours." + error;
                }
                if (message.fridaySecondHours != null && message.hasOwnProperty("fridaySecondHours")) {
                    var error = $root.waiternow.common.TimeRangeProto.verify(message.fridaySecondHours);
                    if (error)
                        return "fridaySecondHours." + error;
                }
                if (message.saturdaySecondHours != null && message.hasOwnProperty("saturdaySecondHours")) {
                    var error = $root.waiternow.common.TimeRangeProto.verify(message.saturdaySecondHours);
                    if (error)
                        return "saturdaySecondHours." + error;
                }
                if (message.specialHours != null && message.hasOwnProperty("specialHours")) {
                    if (!Array.isArray(message.specialHours))
                        return "specialHours: array expected";
                    for (var i = 0; i < message.specialHours.length; ++i) {
                        var error = $root.waiternow.common.BusinessHoursProto.SpecialHoursProto.verify(message.specialHours[i]);
                        if (error)
                            return "specialHours." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a BusinessHoursProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.BusinessHoursProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.BusinessHoursProto} BusinessHoursProto
             */
            BusinessHoursProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.BusinessHoursProto)
                    return object;
                var message = new $root.waiternow.common.BusinessHoursProto();
                if (object.sundayHours != null) {
                    if (typeof object.sundayHours !== "object")
                        throw TypeError(".waiternow.common.BusinessHoursProto.sundayHours: object expected");
                    message.sundayHours = $root.waiternow.common.TimeRangeProto.fromObject(object.sundayHours);
                }
                if (object.mondayHours != null) {
                    if (typeof object.mondayHours !== "object")
                        throw TypeError(".waiternow.common.BusinessHoursProto.mondayHours: object expected");
                    message.mondayHours = $root.waiternow.common.TimeRangeProto.fromObject(object.mondayHours);
                }
                if (object.tuesdayHours != null) {
                    if (typeof object.tuesdayHours !== "object")
                        throw TypeError(".waiternow.common.BusinessHoursProto.tuesdayHours: object expected");
                    message.tuesdayHours = $root.waiternow.common.TimeRangeProto.fromObject(object.tuesdayHours);
                }
                if (object.wednesdayHours != null) {
                    if (typeof object.wednesdayHours !== "object")
                        throw TypeError(".waiternow.common.BusinessHoursProto.wednesdayHours: object expected");
                    message.wednesdayHours = $root.waiternow.common.TimeRangeProto.fromObject(object.wednesdayHours);
                }
                if (object.thursdayHours != null) {
                    if (typeof object.thursdayHours !== "object")
                        throw TypeError(".waiternow.common.BusinessHoursProto.thursdayHours: object expected");
                    message.thursdayHours = $root.waiternow.common.TimeRangeProto.fromObject(object.thursdayHours);
                }
                if (object.fridayHours != null) {
                    if (typeof object.fridayHours !== "object")
                        throw TypeError(".waiternow.common.BusinessHoursProto.fridayHours: object expected");
                    message.fridayHours = $root.waiternow.common.TimeRangeProto.fromObject(object.fridayHours);
                }
                if (object.saturdayHours != null) {
                    if (typeof object.saturdayHours !== "object")
                        throw TypeError(".waiternow.common.BusinessHoursProto.saturdayHours: object expected");
                    message.saturdayHours = $root.waiternow.common.TimeRangeProto.fromObject(object.saturdayHours);
                }
                if (object.isSundayClosed != null)
                    message.isSundayClosed = Boolean(object.isSundayClosed);
                if (object.isMondayClosed != null)
                    message.isMondayClosed = Boolean(object.isMondayClosed);
                if (object.isTuesdayClosed != null)
                    message.isTuesdayClosed = Boolean(object.isTuesdayClosed);
                if (object.isWednesdayClosed != null)
                    message.isWednesdayClosed = Boolean(object.isWednesdayClosed);
                if (object.isThursdayClosed != null)
                    message.isThursdayClosed = Boolean(object.isThursdayClosed);
                if (object.isFridayClosed != null)
                    message.isFridayClosed = Boolean(object.isFridayClosed);
                if (object.isSaturdayClosed != null)
                    message.isSaturdayClosed = Boolean(object.isSaturdayClosed);
                if (object.sundaySecondHours != null) {
                    if (typeof object.sundaySecondHours !== "object")
                        throw TypeError(".waiternow.common.BusinessHoursProto.sundaySecondHours: object expected");
                    message.sundaySecondHours = $root.waiternow.common.TimeRangeProto.fromObject(object.sundaySecondHours);
                }
                if (object.mondaySecondHours != null) {
                    if (typeof object.mondaySecondHours !== "object")
                        throw TypeError(".waiternow.common.BusinessHoursProto.mondaySecondHours: object expected");
                    message.mondaySecondHours = $root.waiternow.common.TimeRangeProto.fromObject(object.mondaySecondHours);
                }
                if (object.tuesdaySecondHours != null) {
                    if (typeof object.tuesdaySecondHours !== "object")
                        throw TypeError(".waiternow.common.BusinessHoursProto.tuesdaySecondHours: object expected");
                    message.tuesdaySecondHours = $root.waiternow.common.TimeRangeProto.fromObject(object.tuesdaySecondHours);
                }
                if (object.wednesdaySecondHours != null) {
                    if (typeof object.wednesdaySecondHours !== "object")
                        throw TypeError(".waiternow.common.BusinessHoursProto.wednesdaySecondHours: object expected");
                    message.wednesdaySecondHours = $root.waiternow.common.TimeRangeProto.fromObject(object.wednesdaySecondHours);
                }
                if (object.thursdaySecondHours != null) {
                    if (typeof object.thursdaySecondHours !== "object")
                        throw TypeError(".waiternow.common.BusinessHoursProto.thursdaySecondHours: object expected");
                    message.thursdaySecondHours = $root.waiternow.common.TimeRangeProto.fromObject(object.thursdaySecondHours);
                }
                if (object.fridaySecondHours != null) {
                    if (typeof object.fridaySecondHours !== "object")
                        throw TypeError(".waiternow.common.BusinessHoursProto.fridaySecondHours: object expected");
                    message.fridaySecondHours = $root.waiternow.common.TimeRangeProto.fromObject(object.fridaySecondHours);
                }
                if (object.saturdaySecondHours != null) {
                    if (typeof object.saturdaySecondHours !== "object")
                        throw TypeError(".waiternow.common.BusinessHoursProto.saturdaySecondHours: object expected");
                    message.saturdaySecondHours = $root.waiternow.common.TimeRangeProto.fromObject(object.saturdaySecondHours);
                }
                if (object.specialHours) {
                    if (!Array.isArray(object.specialHours))
                        throw TypeError(".waiternow.common.BusinessHoursProto.specialHours: array expected");
                    message.specialHours = [];
                    for (var i = 0; i < object.specialHours.length; ++i) {
                        if (typeof object.specialHours[i] !== "object")
                            throw TypeError(".waiternow.common.BusinessHoursProto.specialHours: object expected");
                        message.specialHours[i] = $root.waiternow.common.BusinessHoursProto.SpecialHoursProto.fromObject(object.specialHours[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a BusinessHoursProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.BusinessHoursProto
             * @static
             * @param {waiternow.common.BusinessHoursProto} message BusinessHoursProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            BusinessHoursProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.specialHours = [];
                if (options.defaults) {
                    object.sundayHours = null;
                    object.mondayHours = null;
                    object.tuesdayHours = null;
                    object.wednesdayHours = null;
                    object.thursdayHours = null;
                    object.fridayHours = null;
                    object.saturdayHours = null;
                    object.isSundayClosed = false;
                    object.isMondayClosed = false;
                    object.isTuesdayClosed = false;
                    object.isWednesdayClosed = false;
                    object.isThursdayClosed = false;
                    object.isFridayClosed = false;
                    object.isSaturdayClosed = false;
                    object.sundaySecondHours = null;
                    object.mondaySecondHours = null;
                    object.tuesdaySecondHours = null;
                    object.wednesdaySecondHours = null;
                    object.thursdaySecondHours = null;
                    object.fridaySecondHours = null;
                    object.saturdaySecondHours = null;
                }
                if (message.sundayHours != null && message.hasOwnProperty("sundayHours"))
                    object.sundayHours = $root.waiternow.common.TimeRangeProto.toObject(message.sundayHours, options);
                if (message.mondayHours != null && message.hasOwnProperty("mondayHours"))
                    object.mondayHours = $root.waiternow.common.TimeRangeProto.toObject(message.mondayHours, options);
                if (message.tuesdayHours != null && message.hasOwnProperty("tuesdayHours"))
                    object.tuesdayHours = $root.waiternow.common.TimeRangeProto.toObject(message.tuesdayHours, options);
                if (message.wednesdayHours != null && message.hasOwnProperty("wednesdayHours"))
                    object.wednesdayHours = $root.waiternow.common.TimeRangeProto.toObject(message.wednesdayHours, options);
                if (message.thursdayHours != null && message.hasOwnProperty("thursdayHours"))
                    object.thursdayHours = $root.waiternow.common.TimeRangeProto.toObject(message.thursdayHours, options);
                if (message.fridayHours != null && message.hasOwnProperty("fridayHours"))
                    object.fridayHours = $root.waiternow.common.TimeRangeProto.toObject(message.fridayHours, options);
                if (message.saturdayHours != null && message.hasOwnProperty("saturdayHours"))
                    object.saturdayHours = $root.waiternow.common.TimeRangeProto.toObject(message.saturdayHours, options);
                if (message.isSundayClosed != null && message.hasOwnProperty("isSundayClosed"))
                    object.isSundayClosed = message.isSundayClosed;
                if (message.isMondayClosed != null && message.hasOwnProperty("isMondayClosed"))
                    object.isMondayClosed = message.isMondayClosed;
                if (message.isTuesdayClosed != null && message.hasOwnProperty("isTuesdayClosed"))
                    object.isTuesdayClosed = message.isTuesdayClosed;
                if (message.isWednesdayClosed != null && message.hasOwnProperty("isWednesdayClosed"))
                    object.isWednesdayClosed = message.isWednesdayClosed;
                if (message.isThursdayClosed != null && message.hasOwnProperty("isThursdayClosed"))
                    object.isThursdayClosed = message.isThursdayClosed;
                if (message.isFridayClosed != null && message.hasOwnProperty("isFridayClosed"))
                    object.isFridayClosed = message.isFridayClosed;
                if (message.isSaturdayClosed != null && message.hasOwnProperty("isSaturdayClosed"))
                    object.isSaturdayClosed = message.isSaturdayClosed;
                if (message.sundaySecondHours != null && message.hasOwnProperty("sundaySecondHours"))
                    object.sundaySecondHours = $root.waiternow.common.TimeRangeProto.toObject(message.sundaySecondHours, options);
                if (message.mondaySecondHours != null && message.hasOwnProperty("mondaySecondHours"))
                    object.mondaySecondHours = $root.waiternow.common.TimeRangeProto.toObject(message.mondaySecondHours, options);
                if (message.tuesdaySecondHours != null && message.hasOwnProperty("tuesdaySecondHours"))
                    object.tuesdaySecondHours = $root.waiternow.common.TimeRangeProto.toObject(message.tuesdaySecondHours, options);
                if (message.wednesdaySecondHours != null && message.hasOwnProperty("wednesdaySecondHours"))
                    object.wednesdaySecondHours = $root.waiternow.common.TimeRangeProto.toObject(message.wednesdaySecondHours, options);
                if (message.thursdaySecondHours != null && message.hasOwnProperty("thursdaySecondHours"))
                    object.thursdaySecondHours = $root.waiternow.common.TimeRangeProto.toObject(message.thursdaySecondHours, options);
                if (message.fridaySecondHours != null && message.hasOwnProperty("fridaySecondHours"))
                    object.fridaySecondHours = $root.waiternow.common.TimeRangeProto.toObject(message.fridaySecondHours, options);
                if (message.saturdaySecondHours != null && message.hasOwnProperty("saturdaySecondHours"))
                    object.saturdaySecondHours = $root.waiternow.common.TimeRangeProto.toObject(message.saturdaySecondHours, options);
                if (message.specialHours && message.specialHours.length) {
                    object.specialHours = [];
                    for (var j = 0; j < message.specialHours.length; ++j)
                        object.specialHours[j] = $root.waiternow.common.BusinessHoursProto.SpecialHoursProto.toObject(message.specialHours[j], options);
                }
                return object;
            };

            /**
             * Converts this BusinessHoursProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.BusinessHoursProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            BusinessHoursProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for BusinessHoursProto
             * @function getTypeUrl
             * @memberof waiternow.common.BusinessHoursProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            BusinessHoursProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.BusinessHoursProto";
            };

            BusinessHoursProto.SpecialHoursProto = (function() {

                /**
                 * Properties of a SpecialHoursProto.
                 * @memberof waiternow.common.BusinessHoursProto
                 * @interface ISpecialHoursProto
                 * @property {waiternow.common.IDateProto|null} [date] SpecialHoursProto date
                 * @property {boolean|null} [isClosed] SpecialHoursProto isClosed
                 */

                /**
                 * Constructs a new SpecialHoursProto.
                 * @memberof waiternow.common.BusinessHoursProto
                 * @classdesc Represents a SpecialHoursProto.
                 * @implements ISpecialHoursProto
                 * @constructor
                 * @param {waiternow.common.BusinessHoursProto.ISpecialHoursProto=} [properties] Properties to set
                 */
                function SpecialHoursProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SpecialHoursProto date.
                 * @member {waiternow.common.IDateProto|null|undefined} date
                 * @memberof waiternow.common.BusinessHoursProto.SpecialHoursProto
                 * @instance
                 */
                SpecialHoursProto.prototype.date = null;

                /**
                 * SpecialHoursProto isClosed.
                 * @member {boolean} isClosed
                 * @memberof waiternow.common.BusinessHoursProto.SpecialHoursProto
                 * @instance
                 */
                SpecialHoursProto.prototype.isClosed = false;

                /**
                 * Creates a new SpecialHoursProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.BusinessHoursProto.SpecialHoursProto
                 * @static
                 * @param {waiternow.common.BusinessHoursProto.ISpecialHoursProto=} [properties] Properties to set
                 * @returns {waiternow.common.BusinessHoursProto.SpecialHoursProto} SpecialHoursProto instance
                 */
                SpecialHoursProto.create = function create(properties) {
                    return new SpecialHoursProto(properties);
                };

                /**
                 * Encodes the specified SpecialHoursProto message. Does not implicitly {@link waiternow.common.BusinessHoursProto.SpecialHoursProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.BusinessHoursProto.SpecialHoursProto
                 * @static
                 * @param {waiternow.common.BusinessHoursProto.ISpecialHoursProto} message SpecialHoursProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SpecialHoursProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.date != null && Object.hasOwnProperty.call(message, "date"))
                        $root.waiternow.common.DateProto.encode(message.date, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.isClosed != null && Object.hasOwnProperty.call(message, "isClosed"))
                        writer.uint32(/* id 2, wireType 0 =*/16).bool(message.isClosed);
                    return writer;
                };

                /**
                 * Encodes the specified SpecialHoursProto message, length delimited. Does not implicitly {@link waiternow.common.BusinessHoursProto.SpecialHoursProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.BusinessHoursProto.SpecialHoursProto
                 * @static
                 * @param {waiternow.common.BusinessHoursProto.ISpecialHoursProto} message SpecialHoursProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SpecialHoursProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SpecialHoursProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.BusinessHoursProto.SpecialHoursProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.BusinessHoursProto.SpecialHoursProto} SpecialHoursProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SpecialHoursProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.BusinessHoursProto.SpecialHoursProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.date = $root.waiternow.common.DateProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.isClosed = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SpecialHoursProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.BusinessHoursProto.SpecialHoursProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.BusinessHoursProto.SpecialHoursProto} SpecialHoursProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SpecialHoursProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SpecialHoursProto message.
                 * @function verify
                 * @memberof waiternow.common.BusinessHoursProto.SpecialHoursProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SpecialHoursProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.date != null && message.hasOwnProperty("date")) {
                        var error = $root.waiternow.common.DateProto.verify(message.date);
                        if (error)
                            return "date." + error;
                    }
                    if (message.isClosed != null && message.hasOwnProperty("isClosed"))
                        if (typeof message.isClosed !== "boolean")
                            return "isClosed: boolean expected";
                    return null;
                };

                /**
                 * Creates a SpecialHoursProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.BusinessHoursProto.SpecialHoursProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.BusinessHoursProto.SpecialHoursProto} SpecialHoursProto
                 */
                SpecialHoursProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.BusinessHoursProto.SpecialHoursProto)
                        return object;
                    var message = new $root.waiternow.common.BusinessHoursProto.SpecialHoursProto();
                    if (object.date != null) {
                        if (typeof object.date !== "object")
                            throw TypeError(".waiternow.common.BusinessHoursProto.SpecialHoursProto.date: object expected");
                        message.date = $root.waiternow.common.DateProto.fromObject(object.date);
                    }
                    if (object.isClosed != null)
                        message.isClosed = Boolean(object.isClosed);
                    return message;
                };

                /**
                 * Creates a plain object from a SpecialHoursProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.BusinessHoursProto.SpecialHoursProto
                 * @static
                 * @param {waiternow.common.BusinessHoursProto.SpecialHoursProto} message SpecialHoursProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SpecialHoursProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.date = null;
                        object.isClosed = false;
                    }
                    if (message.date != null && message.hasOwnProperty("date"))
                        object.date = $root.waiternow.common.DateProto.toObject(message.date, options);
                    if (message.isClosed != null && message.hasOwnProperty("isClosed"))
                        object.isClosed = message.isClosed;
                    return object;
                };

                /**
                 * Converts this SpecialHoursProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.BusinessHoursProto.SpecialHoursProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SpecialHoursProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for SpecialHoursProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.BusinessHoursProto.SpecialHoursProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                SpecialHoursProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.BusinessHoursProto.SpecialHoursProto";
                };

                return SpecialHoursProto;
            })();

            return BusinessHoursProto;
        })();

        common.HolidayProto = (function() {

            /**
             * Properties of a HolidayProto.
             * @memberof waiternow.common
             * @interface IHolidayProto
             * @property {waiternow.common.IDateProto|null} [date] HolidayProto date
             * @property {waiternow.common.HolidayProto.Name|null} [name] HolidayProto name
             */

            /**
             * Constructs a new HolidayProto.
             * @memberof waiternow.common
             * @classdesc Represents a HolidayProto.
             * @implements IHolidayProto
             * @constructor
             * @param {waiternow.common.IHolidayProto=} [properties] Properties to set
             */
            function HolidayProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * HolidayProto date.
             * @member {waiternow.common.IDateProto|null|undefined} date
             * @memberof waiternow.common.HolidayProto
             * @instance
             */
            HolidayProto.prototype.date = null;

            /**
             * HolidayProto name.
             * @member {waiternow.common.HolidayProto.Name} name
             * @memberof waiternow.common.HolidayProto
             * @instance
             */
            HolidayProto.prototype.name = 0;

            /**
             * Creates a new HolidayProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.HolidayProto
             * @static
             * @param {waiternow.common.IHolidayProto=} [properties] Properties to set
             * @returns {waiternow.common.HolidayProto} HolidayProto instance
             */
            HolidayProto.create = function create(properties) {
                return new HolidayProto(properties);
            };

            /**
             * Encodes the specified HolidayProto message. Does not implicitly {@link waiternow.common.HolidayProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.HolidayProto
             * @static
             * @param {waiternow.common.IHolidayProto} message HolidayProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            HolidayProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.date != null && Object.hasOwnProperty.call(message, "date"))
                    $root.waiternow.common.DateProto.encode(message.date, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.name);
                return writer;
            };

            /**
             * Encodes the specified HolidayProto message, length delimited. Does not implicitly {@link waiternow.common.HolidayProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.HolidayProto
             * @static
             * @param {waiternow.common.IHolidayProto} message HolidayProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            HolidayProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a HolidayProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.HolidayProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.HolidayProto} HolidayProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            HolidayProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.HolidayProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.date = $root.waiternow.common.DateProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 2: {
                            message.name = reader.int32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a HolidayProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.HolidayProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.HolidayProto} HolidayProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            HolidayProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a HolidayProto message.
             * @function verify
             * @memberof waiternow.common.HolidayProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            HolidayProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.date != null && message.hasOwnProperty("date")) {
                    var error = $root.waiternow.common.DateProto.verify(message.date);
                    if (error)
                        return "date." + error;
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    switch (message.name) {
                    default:
                        return "name: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                    case 9:
                    case 10:
                    case 11:
                    case 12:
                        break;
                    }
                return null;
            };

            /**
             * Creates a HolidayProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.HolidayProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.HolidayProto} HolidayProto
             */
            HolidayProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.HolidayProto)
                    return object;
                var message = new $root.waiternow.common.HolidayProto();
                if (object.date != null) {
                    if (typeof object.date !== "object")
                        throw TypeError(".waiternow.common.HolidayProto.date: object expected");
                    message.date = $root.waiternow.common.DateProto.fromObject(object.date);
                }
                switch (object.name) {
                default:
                    if (typeof object.name === "number") {
                        message.name = object.name;
                        break;
                    }
                    break;
                case "HOLIDAY_UNSPECIFIED":
                case 0:
                    message.name = 0;
                    break;
                case "NEW_YEAR":
                case 1:
                    message.name = 1;
                    break;
                case "MEMORIAL_DAY":
                case 2:
                    message.name = 2;
                    break;
                case "INDEPENDENCE_DAY":
                case 3:
                    message.name = 3;
                    break;
                case "LABOR_DAY":
                case 4:
                    message.name = 4;
                    break;
                case "THANKSGIVING":
                case 5:
                    message.name = 5;
                    break;
                case "BLACK_FRIDAY":
                case 6:
                    message.name = 6;
                    break;
                case "CHRISTMAS_EVE":
                case 7:
                    message.name = 7;
                    break;
                case "CHRISTMAS":
                case 8:
                    message.name = 8;
                    break;
                case "NEW_YEAR_EVE":
                case 9:
                    message.name = 9;
                    break;
                case "CONSTITUTION_DAY":
                case 10:
                    message.name = 10;
                    break;
                case "BENITO_JUAREZ_BIRHTDAY":
                case 11:
                    message.name = 11;
                    break;
                case "REVOLUTION_DAY":
                case 12:
                    message.name = 12;
                    break;
                }
                return message;
            };

            /**
             * Creates a plain object from a HolidayProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.HolidayProto
             * @static
             * @param {waiternow.common.HolidayProto} message HolidayProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            HolidayProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.date = null;
                    object.name = options.enums === String ? "HOLIDAY_UNSPECIFIED" : 0;
                }
                if (message.date != null && message.hasOwnProperty("date"))
                    object.date = $root.waiternow.common.DateProto.toObject(message.date, options);
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = options.enums === String ? $root.waiternow.common.HolidayProto.Name[message.name] === undefined ? message.name : $root.waiternow.common.HolidayProto.Name[message.name] : message.name;
                return object;
            };

            /**
             * Converts this HolidayProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.HolidayProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            HolidayProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for HolidayProto
             * @function getTypeUrl
             * @memberof waiternow.common.HolidayProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            HolidayProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.HolidayProto";
            };

            /**
             * Name enum.
             * @name waiternow.common.HolidayProto.Name
             * @enum {number}
             * @property {number} HOLIDAY_UNSPECIFIED=0 HOLIDAY_UNSPECIFIED value
             * @property {number} NEW_YEAR=1 NEW_YEAR value
             * @property {number} MEMORIAL_DAY=2 MEMORIAL_DAY value
             * @property {number} INDEPENDENCE_DAY=3 INDEPENDENCE_DAY value
             * @property {number} LABOR_DAY=4 LABOR_DAY value
             * @property {number} THANKSGIVING=5 THANKSGIVING value
             * @property {number} BLACK_FRIDAY=6 BLACK_FRIDAY value
             * @property {number} CHRISTMAS_EVE=7 CHRISTMAS_EVE value
             * @property {number} CHRISTMAS=8 CHRISTMAS value
             * @property {number} NEW_YEAR_EVE=9 NEW_YEAR_EVE value
             * @property {number} CONSTITUTION_DAY=10 CONSTITUTION_DAY value
             * @property {number} BENITO_JUAREZ_BIRHTDAY=11 BENITO_JUAREZ_BIRHTDAY value
             * @property {number} REVOLUTION_DAY=12 REVOLUTION_DAY value
             */
            HolidayProto.Name = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "HOLIDAY_UNSPECIFIED"] = 0;
                values[valuesById[1] = "NEW_YEAR"] = 1;
                values[valuesById[2] = "MEMORIAL_DAY"] = 2;
                values[valuesById[3] = "INDEPENDENCE_DAY"] = 3;
                values[valuesById[4] = "LABOR_DAY"] = 4;
                values[valuesById[5] = "THANKSGIVING"] = 5;
                values[valuesById[6] = "BLACK_FRIDAY"] = 6;
                values[valuesById[7] = "CHRISTMAS_EVE"] = 7;
                values[valuesById[8] = "CHRISTMAS"] = 8;
                values[valuesById[9] = "NEW_YEAR_EVE"] = 9;
                values[valuesById[10] = "CONSTITUTION_DAY"] = 10;
                values[valuesById[11] = "BENITO_JUAREZ_BIRHTDAY"] = 11;
                values[valuesById[12] = "REVOLUTION_DAY"] = 12;
                return values;
            })();

            return HolidayProto;
        })();

        common.ActiveSystemConfigProto = (function() {

            /**
             * Properties of an ActiveSystemConfigProto.
             * @memberof waiternow.common
             * @interface IActiveSystemConfigProto
             * @property {string|null} [systemConfigurationPath] ActiveSystemConfigProto systemConfigurationPath
             */

            /**
             * Constructs a new ActiveSystemConfigProto.
             * @memberof waiternow.common
             * @classdesc Represents an ActiveSystemConfigProto.
             * @implements IActiveSystemConfigProto
             * @constructor
             * @param {waiternow.common.IActiveSystemConfigProto=} [properties] Properties to set
             */
            function ActiveSystemConfigProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ActiveSystemConfigProto systemConfigurationPath.
             * @member {string} systemConfigurationPath
             * @memberof waiternow.common.ActiveSystemConfigProto
             * @instance
             */
            ActiveSystemConfigProto.prototype.systemConfigurationPath = "";

            /**
             * Creates a new ActiveSystemConfigProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.ActiveSystemConfigProto
             * @static
             * @param {waiternow.common.IActiveSystemConfigProto=} [properties] Properties to set
             * @returns {waiternow.common.ActiveSystemConfigProto} ActiveSystemConfigProto instance
             */
            ActiveSystemConfigProto.create = function create(properties) {
                return new ActiveSystemConfigProto(properties);
            };

            /**
             * Encodes the specified ActiveSystemConfigProto message. Does not implicitly {@link waiternow.common.ActiveSystemConfigProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.ActiveSystemConfigProto
             * @static
             * @param {waiternow.common.IActiveSystemConfigProto} message ActiveSystemConfigProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ActiveSystemConfigProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.systemConfigurationPath != null && Object.hasOwnProperty.call(message, "systemConfigurationPath"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.systemConfigurationPath);
                return writer;
            };

            /**
             * Encodes the specified ActiveSystemConfigProto message, length delimited. Does not implicitly {@link waiternow.common.ActiveSystemConfigProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.ActiveSystemConfigProto
             * @static
             * @param {waiternow.common.IActiveSystemConfigProto} message ActiveSystemConfigProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ActiveSystemConfigProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an ActiveSystemConfigProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.ActiveSystemConfigProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.ActiveSystemConfigProto} ActiveSystemConfigProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ActiveSystemConfigProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.ActiveSystemConfigProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 2: {
                            message.systemConfigurationPath = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an ActiveSystemConfigProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.ActiveSystemConfigProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.ActiveSystemConfigProto} ActiveSystemConfigProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ActiveSystemConfigProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an ActiveSystemConfigProto message.
             * @function verify
             * @memberof waiternow.common.ActiveSystemConfigProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ActiveSystemConfigProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.systemConfigurationPath != null && message.hasOwnProperty("systemConfigurationPath"))
                    if (!$util.isString(message.systemConfigurationPath))
                        return "systemConfigurationPath: string expected";
                return null;
            };

            /**
             * Creates an ActiveSystemConfigProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.ActiveSystemConfigProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.ActiveSystemConfigProto} ActiveSystemConfigProto
             */
            ActiveSystemConfigProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.ActiveSystemConfigProto)
                    return object;
                var message = new $root.waiternow.common.ActiveSystemConfigProto();
                if (object.systemConfigurationPath != null)
                    message.systemConfigurationPath = String(object.systemConfigurationPath);
                return message;
            };

            /**
             * Creates a plain object from an ActiveSystemConfigProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.ActiveSystemConfigProto
             * @static
             * @param {waiternow.common.ActiveSystemConfigProto} message ActiveSystemConfigProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ActiveSystemConfigProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.systemConfigurationPath = "";
                if (message.systemConfigurationPath != null && message.hasOwnProperty("systemConfigurationPath"))
                    object.systemConfigurationPath = message.systemConfigurationPath;
                return object;
            };

            /**
             * Converts this ActiveSystemConfigProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.ActiveSystemConfigProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ActiveSystemConfigProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for ActiveSystemConfigProto
             * @function getTypeUrl
             * @memberof waiternow.common.ActiveSystemConfigProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            ActiveSystemConfigProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.ActiveSystemConfigProto";
            };

            return ActiveSystemConfigProto;
        })();

        common.SystemConfigProto = (function() {

            /**
             * Properties of a SystemConfigProto.
             * @memberof waiternow.common
             * @interface ISystemConfigProto
             * @property {string|null} [configurationName] SystemConfigProto configurationName
             * @property {waiternow.common.ISystemInfoProto|null} [systemInfo] SystemConfigProto systemInfo
             * @property {waiternow.common.IAdministrationConfigProto|null} [administrationConfig] SystemConfigProto administrationConfig
             * @property {waiternow.common.IPersistenceLayerConfigProto|null} [persistenceLayerConfig] SystemConfigProto persistenceLayerConfig
             * @property {waiternow.common.IStorageLayerConfigProto|null} [storageLayerConfig] SystemConfigProto storageLayerConfig
             * @property {waiternow.common.IWebLayerConfigProto|null} [webLayerConfig] SystemConfigProto webLayerConfig
             * @property {waiternow.common.IFirebaseConfigProto|null} [firebaseConfig] SystemConfigProto firebaseConfig
             * @property {waiternow.common.IThresholdsConfigProto|null} [thresholdsConfig] SystemConfigProto thresholdsConfig
             * @property {waiternow.common.IEmailServiceConfigProto|null} [emailServiceConfig] SystemConfigProto emailServiceConfig
             * @property {waiternow.common.IBillingConfigProto|null} [billingConfig] SystemConfigProto billingConfig
             * @property {waiternow.common.IPaymentConfigProto|null} [paymentConfig] SystemConfigProto paymentConfig
             * @property {waiternow.common.ISmsMessagingServiceConfigProto|null} [smsMessagingServiceConfig] SystemConfigProto smsMessagingServiceConfig
             * @property {waiternow.common.IOncallConfigProto|null} [oncallConfig] SystemConfigProto oncallConfig
             * @property {waiternow.common.IGoogleApiKeysProto|null} [googleApiKeys] SystemConfigProto googleApiKeys
             * @property {waiternow.common.IDoordashApiKeysProto|null} [doordashApiKeys] SystemConfigProto doordashApiKeys
             * @property {waiternow.common.IUsGeocoderApiKeysProto|null} [usGeocoderApiKeys] SystemConfigProto usGeocoderApiKeys
             * @property {waiternow.common.IUberApiKeysProto|null} [uberApiKeys] SystemConfigProto uberApiKeys
             */

            /**
             * Constructs a new SystemConfigProto.
             * @memberof waiternow.common
             * @classdesc Represents a SystemConfigProto.
             * @implements ISystemConfigProto
             * @constructor
             * @param {waiternow.common.ISystemConfigProto=} [properties] Properties to set
             */
            function SystemConfigProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * SystemConfigProto configurationName.
             * @member {string} configurationName
             * @memberof waiternow.common.SystemConfigProto
             * @instance
             */
            SystemConfigProto.prototype.configurationName = "";

            /**
             * SystemConfigProto systemInfo.
             * @member {waiternow.common.ISystemInfoProto|null|undefined} systemInfo
             * @memberof waiternow.common.SystemConfigProto
             * @instance
             */
            SystemConfigProto.prototype.systemInfo = null;

            /**
             * SystemConfigProto administrationConfig.
             * @member {waiternow.common.IAdministrationConfigProto|null|undefined} administrationConfig
             * @memberof waiternow.common.SystemConfigProto
             * @instance
             */
            SystemConfigProto.prototype.administrationConfig = null;

            /**
             * SystemConfigProto persistenceLayerConfig.
             * @member {waiternow.common.IPersistenceLayerConfigProto|null|undefined} persistenceLayerConfig
             * @memberof waiternow.common.SystemConfigProto
             * @instance
             */
            SystemConfigProto.prototype.persistenceLayerConfig = null;

            /**
             * SystemConfigProto storageLayerConfig.
             * @member {waiternow.common.IStorageLayerConfigProto|null|undefined} storageLayerConfig
             * @memberof waiternow.common.SystemConfigProto
             * @instance
             */
            SystemConfigProto.prototype.storageLayerConfig = null;

            /**
             * SystemConfigProto webLayerConfig.
             * @member {waiternow.common.IWebLayerConfigProto|null|undefined} webLayerConfig
             * @memberof waiternow.common.SystemConfigProto
             * @instance
             */
            SystemConfigProto.prototype.webLayerConfig = null;

            /**
             * SystemConfigProto firebaseConfig.
             * @member {waiternow.common.IFirebaseConfigProto|null|undefined} firebaseConfig
             * @memberof waiternow.common.SystemConfigProto
             * @instance
             */
            SystemConfigProto.prototype.firebaseConfig = null;

            /**
             * SystemConfigProto thresholdsConfig.
             * @member {waiternow.common.IThresholdsConfigProto|null|undefined} thresholdsConfig
             * @memberof waiternow.common.SystemConfigProto
             * @instance
             */
            SystemConfigProto.prototype.thresholdsConfig = null;

            /**
             * SystemConfigProto emailServiceConfig.
             * @member {waiternow.common.IEmailServiceConfigProto|null|undefined} emailServiceConfig
             * @memberof waiternow.common.SystemConfigProto
             * @instance
             */
            SystemConfigProto.prototype.emailServiceConfig = null;

            /**
             * SystemConfigProto billingConfig.
             * @member {waiternow.common.IBillingConfigProto|null|undefined} billingConfig
             * @memberof waiternow.common.SystemConfigProto
             * @instance
             */
            SystemConfigProto.prototype.billingConfig = null;

            /**
             * SystemConfigProto paymentConfig.
             * @member {waiternow.common.IPaymentConfigProto|null|undefined} paymentConfig
             * @memberof waiternow.common.SystemConfigProto
             * @instance
             */
            SystemConfigProto.prototype.paymentConfig = null;

            /**
             * SystemConfigProto smsMessagingServiceConfig.
             * @member {waiternow.common.ISmsMessagingServiceConfigProto|null|undefined} smsMessagingServiceConfig
             * @memberof waiternow.common.SystemConfigProto
             * @instance
             */
            SystemConfigProto.prototype.smsMessagingServiceConfig = null;

            /**
             * SystemConfigProto oncallConfig.
             * @member {waiternow.common.IOncallConfigProto|null|undefined} oncallConfig
             * @memberof waiternow.common.SystemConfigProto
             * @instance
             */
            SystemConfigProto.prototype.oncallConfig = null;

            /**
             * SystemConfigProto googleApiKeys.
             * @member {waiternow.common.IGoogleApiKeysProto|null|undefined} googleApiKeys
             * @memberof waiternow.common.SystemConfigProto
             * @instance
             */
            SystemConfigProto.prototype.googleApiKeys = null;

            /**
             * SystemConfigProto doordashApiKeys.
             * @member {waiternow.common.IDoordashApiKeysProto|null|undefined} doordashApiKeys
             * @memberof waiternow.common.SystemConfigProto
             * @instance
             */
            SystemConfigProto.prototype.doordashApiKeys = null;

            /**
             * SystemConfigProto usGeocoderApiKeys.
             * @member {waiternow.common.IUsGeocoderApiKeysProto|null|undefined} usGeocoderApiKeys
             * @memberof waiternow.common.SystemConfigProto
             * @instance
             */
            SystemConfigProto.prototype.usGeocoderApiKeys = null;

            /**
             * SystemConfigProto uberApiKeys.
             * @member {waiternow.common.IUberApiKeysProto|null|undefined} uberApiKeys
             * @memberof waiternow.common.SystemConfigProto
             * @instance
             */
            SystemConfigProto.prototype.uberApiKeys = null;

            /**
             * Creates a new SystemConfigProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.SystemConfigProto
             * @static
             * @param {waiternow.common.ISystemConfigProto=} [properties] Properties to set
             * @returns {waiternow.common.SystemConfigProto} SystemConfigProto instance
             */
            SystemConfigProto.create = function create(properties) {
                return new SystemConfigProto(properties);
            };

            /**
             * Encodes the specified SystemConfigProto message. Does not implicitly {@link waiternow.common.SystemConfigProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.SystemConfigProto
             * @static
             * @param {waiternow.common.ISystemConfigProto} message SystemConfigProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SystemConfigProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.configurationName != null && Object.hasOwnProperty.call(message, "configurationName"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.configurationName);
                if (message.systemInfo != null && Object.hasOwnProperty.call(message, "systemInfo"))
                    $root.waiternow.common.SystemInfoProto.encode(message.systemInfo, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.administrationConfig != null && Object.hasOwnProperty.call(message, "administrationConfig"))
                    $root.waiternow.common.AdministrationConfigProto.encode(message.administrationConfig, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.persistenceLayerConfig != null && Object.hasOwnProperty.call(message, "persistenceLayerConfig"))
                    $root.waiternow.common.PersistenceLayerConfigProto.encode(message.persistenceLayerConfig, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                if (message.storageLayerConfig != null && Object.hasOwnProperty.call(message, "storageLayerConfig"))
                    $root.waiternow.common.StorageLayerConfigProto.encode(message.storageLayerConfig, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                if (message.webLayerConfig != null && Object.hasOwnProperty.call(message, "webLayerConfig"))
                    $root.waiternow.common.WebLayerConfigProto.encode(message.webLayerConfig, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                if (message.firebaseConfig != null && Object.hasOwnProperty.call(message, "firebaseConfig"))
                    $root.waiternow.common.FirebaseConfigProto.encode(message.firebaseConfig, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                if (message.thresholdsConfig != null && Object.hasOwnProperty.call(message, "thresholdsConfig"))
                    $root.waiternow.common.ThresholdsConfigProto.encode(message.thresholdsConfig, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                if (message.emailServiceConfig != null && Object.hasOwnProperty.call(message, "emailServiceConfig"))
                    $root.waiternow.common.EmailServiceConfigProto.encode(message.emailServiceConfig, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                if (message.billingConfig != null && Object.hasOwnProperty.call(message, "billingConfig"))
                    $root.waiternow.common.BillingConfigProto.encode(message.billingConfig, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                if (message.paymentConfig != null && Object.hasOwnProperty.call(message, "paymentConfig"))
                    $root.waiternow.common.PaymentConfigProto.encode(message.paymentConfig, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                if (message.smsMessagingServiceConfig != null && Object.hasOwnProperty.call(message, "smsMessagingServiceConfig"))
                    $root.waiternow.common.SmsMessagingServiceConfigProto.encode(message.smsMessagingServiceConfig, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                if (message.oncallConfig != null && Object.hasOwnProperty.call(message, "oncallConfig"))
                    $root.waiternow.common.OncallConfigProto.encode(message.oncallConfig, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
                if (message.googleApiKeys != null && Object.hasOwnProperty.call(message, "googleApiKeys"))
                    $root.waiternow.common.GoogleApiKeysProto.encode(message.googleApiKeys, writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
                if (message.doordashApiKeys != null && Object.hasOwnProperty.call(message, "doordashApiKeys"))
                    $root.waiternow.common.DoordashApiKeysProto.encode(message.doordashApiKeys, writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
                if (message.usGeocoderApiKeys != null && Object.hasOwnProperty.call(message, "usGeocoderApiKeys"))
                    $root.waiternow.common.UsGeocoderApiKeysProto.encode(message.usGeocoderApiKeys, writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
                if (message.uberApiKeys != null && Object.hasOwnProperty.call(message, "uberApiKeys"))
                    $root.waiternow.common.UberApiKeysProto.encode(message.uberApiKeys, writer.uint32(/* id 17, wireType 2 =*/138).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified SystemConfigProto message, length delimited. Does not implicitly {@link waiternow.common.SystemConfigProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.SystemConfigProto
             * @static
             * @param {waiternow.common.ISystemConfigProto} message SystemConfigProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SystemConfigProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SystemConfigProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.SystemConfigProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.SystemConfigProto} SystemConfigProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SystemConfigProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.SystemConfigProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.configurationName = reader.string();
                            break;
                        }
                    case 2: {
                            message.systemInfo = $root.waiternow.common.SystemInfoProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 3: {
                            message.administrationConfig = $root.waiternow.common.AdministrationConfigProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 4: {
                            message.persistenceLayerConfig = $root.waiternow.common.PersistenceLayerConfigProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 5: {
                            message.storageLayerConfig = $root.waiternow.common.StorageLayerConfigProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 6: {
                            message.webLayerConfig = $root.waiternow.common.WebLayerConfigProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 7: {
                            message.firebaseConfig = $root.waiternow.common.FirebaseConfigProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 8: {
                            message.thresholdsConfig = $root.waiternow.common.ThresholdsConfigProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 9: {
                            message.emailServiceConfig = $root.waiternow.common.EmailServiceConfigProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 10: {
                            message.billingConfig = $root.waiternow.common.BillingConfigProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 11: {
                            message.paymentConfig = $root.waiternow.common.PaymentConfigProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 12: {
                            message.smsMessagingServiceConfig = $root.waiternow.common.SmsMessagingServiceConfigProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 13: {
                            message.oncallConfig = $root.waiternow.common.OncallConfigProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 14: {
                            message.googleApiKeys = $root.waiternow.common.GoogleApiKeysProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 15: {
                            message.doordashApiKeys = $root.waiternow.common.DoordashApiKeysProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 16: {
                            message.usGeocoderApiKeys = $root.waiternow.common.UsGeocoderApiKeysProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 17: {
                            message.uberApiKeys = $root.waiternow.common.UberApiKeysProto.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SystemConfigProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.SystemConfigProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.SystemConfigProto} SystemConfigProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SystemConfigProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SystemConfigProto message.
             * @function verify
             * @memberof waiternow.common.SystemConfigProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SystemConfigProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.configurationName != null && message.hasOwnProperty("configurationName"))
                    if (!$util.isString(message.configurationName))
                        return "configurationName: string expected";
                if (message.systemInfo != null && message.hasOwnProperty("systemInfo")) {
                    var error = $root.waiternow.common.SystemInfoProto.verify(message.systemInfo);
                    if (error)
                        return "systemInfo." + error;
                }
                if (message.administrationConfig != null && message.hasOwnProperty("administrationConfig")) {
                    var error = $root.waiternow.common.AdministrationConfigProto.verify(message.administrationConfig);
                    if (error)
                        return "administrationConfig." + error;
                }
                if (message.persistenceLayerConfig != null && message.hasOwnProperty("persistenceLayerConfig")) {
                    var error = $root.waiternow.common.PersistenceLayerConfigProto.verify(message.persistenceLayerConfig);
                    if (error)
                        return "persistenceLayerConfig." + error;
                }
                if (message.storageLayerConfig != null && message.hasOwnProperty("storageLayerConfig")) {
                    var error = $root.waiternow.common.StorageLayerConfigProto.verify(message.storageLayerConfig);
                    if (error)
                        return "storageLayerConfig." + error;
                }
                if (message.webLayerConfig != null && message.hasOwnProperty("webLayerConfig")) {
                    var error = $root.waiternow.common.WebLayerConfigProto.verify(message.webLayerConfig);
                    if (error)
                        return "webLayerConfig." + error;
                }
                if (message.firebaseConfig != null && message.hasOwnProperty("firebaseConfig")) {
                    var error = $root.waiternow.common.FirebaseConfigProto.verify(message.firebaseConfig);
                    if (error)
                        return "firebaseConfig." + error;
                }
                if (message.thresholdsConfig != null && message.hasOwnProperty("thresholdsConfig")) {
                    var error = $root.waiternow.common.ThresholdsConfigProto.verify(message.thresholdsConfig);
                    if (error)
                        return "thresholdsConfig." + error;
                }
                if (message.emailServiceConfig != null && message.hasOwnProperty("emailServiceConfig")) {
                    var error = $root.waiternow.common.EmailServiceConfigProto.verify(message.emailServiceConfig);
                    if (error)
                        return "emailServiceConfig." + error;
                }
                if (message.billingConfig != null && message.hasOwnProperty("billingConfig")) {
                    var error = $root.waiternow.common.BillingConfigProto.verify(message.billingConfig);
                    if (error)
                        return "billingConfig." + error;
                }
                if (message.paymentConfig != null && message.hasOwnProperty("paymentConfig")) {
                    var error = $root.waiternow.common.PaymentConfigProto.verify(message.paymentConfig);
                    if (error)
                        return "paymentConfig." + error;
                }
                if (message.smsMessagingServiceConfig != null && message.hasOwnProperty("smsMessagingServiceConfig")) {
                    var error = $root.waiternow.common.SmsMessagingServiceConfigProto.verify(message.smsMessagingServiceConfig);
                    if (error)
                        return "smsMessagingServiceConfig." + error;
                }
                if (message.oncallConfig != null && message.hasOwnProperty("oncallConfig")) {
                    var error = $root.waiternow.common.OncallConfigProto.verify(message.oncallConfig);
                    if (error)
                        return "oncallConfig." + error;
                }
                if (message.googleApiKeys != null && message.hasOwnProperty("googleApiKeys")) {
                    var error = $root.waiternow.common.GoogleApiKeysProto.verify(message.googleApiKeys);
                    if (error)
                        return "googleApiKeys." + error;
                }
                if (message.doordashApiKeys != null && message.hasOwnProperty("doordashApiKeys")) {
                    var error = $root.waiternow.common.DoordashApiKeysProto.verify(message.doordashApiKeys);
                    if (error)
                        return "doordashApiKeys." + error;
                }
                if (message.usGeocoderApiKeys != null && message.hasOwnProperty("usGeocoderApiKeys")) {
                    var error = $root.waiternow.common.UsGeocoderApiKeysProto.verify(message.usGeocoderApiKeys);
                    if (error)
                        return "usGeocoderApiKeys." + error;
                }
                if (message.uberApiKeys != null && message.hasOwnProperty("uberApiKeys")) {
                    var error = $root.waiternow.common.UberApiKeysProto.verify(message.uberApiKeys);
                    if (error)
                        return "uberApiKeys." + error;
                }
                return null;
            };

            /**
             * Creates a SystemConfigProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.SystemConfigProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.SystemConfigProto} SystemConfigProto
             */
            SystemConfigProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.SystemConfigProto)
                    return object;
                var message = new $root.waiternow.common.SystemConfigProto();
                if (object.configurationName != null)
                    message.configurationName = String(object.configurationName);
                if (object.systemInfo != null) {
                    if (typeof object.systemInfo !== "object")
                        throw TypeError(".waiternow.common.SystemConfigProto.systemInfo: object expected");
                    message.systemInfo = $root.waiternow.common.SystemInfoProto.fromObject(object.systemInfo);
                }
                if (object.administrationConfig != null) {
                    if (typeof object.administrationConfig !== "object")
                        throw TypeError(".waiternow.common.SystemConfigProto.administrationConfig: object expected");
                    message.administrationConfig = $root.waiternow.common.AdministrationConfigProto.fromObject(object.administrationConfig);
                }
                if (object.persistenceLayerConfig != null) {
                    if (typeof object.persistenceLayerConfig !== "object")
                        throw TypeError(".waiternow.common.SystemConfigProto.persistenceLayerConfig: object expected");
                    message.persistenceLayerConfig = $root.waiternow.common.PersistenceLayerConfigProto.fromObject(object.persistenceLayerConfig);
                }
                if (object.storageLayerConfig != null) {
                    if (typeof object.storageLayerConfig !== "object")
                        throw TypeError(".waiternow.common.SystemConfigProto.storageLayerConfig: object expected");
                    message.storageLayerConfig = $root.waiternow.common.StorageLayerConfigProto.fromObject(object.storageLayerConfig);
                }
                if (object.webLayerConfig != null) {
                    if (typeof object.webLayerConfig !== "object")
                        throw TypeError(".waiternow.common.SystemConfigProto.webLayerConfig: object expected");
                    message.webLayerConfig = $root.waiternow.common.WebLayerConfigProto.fromObject(object.webLayerConfig);
                }
                if (object.firebaseConfig != null) {
                    if (typeof object.firebaseConfig !== "object")
                        throw TypeError(".waiternow.common.SystemConfigProto.firebaseConfig: object expected");
                    message.firebaseConfig = $root.waiternow.common.FirebaseConfigProto.fromObject(object.firebaseConfig);
                }
                if (object.thresholdsConfig != null) {
                    if (typeof object.thresholdsConfig !== "object")
                        throw TypeError(".waiternow.common.SystemConfigProto.thresholdsConfig: object expected");
                    message.thresholdsConfig = $root.waiternow.common.ThresholdsConfigProto.fromObject(object.thresholdsConfig);
                }
                if (object.emailServiceConfig != null) {
                    if (typeof object.emailServiceConfig !== "object")
                        throw TypeError(".waiternow.common.SystemConfigProto.emailServiceConfig: object expected");
                    message.emailServiceConfig = $root.waiternow.common.EmailServiceConfigProto.fromObject(object.emailServiceConfig);
                }
                if (object.billingConfig != null) {
                    if (typeof object.billingConfig !== "object")
                        throw TypeError(".waiternow.common.SystemConfigProto.billingConfig: object expected");
                    message.billingConfig = $root.waiternow.common.BillingConfigProto.fromObject(object.billingConfig);
                }
                if (object.paymentConfig != null) {
                    if (typeof object.paymentConfig !== "object")
                        throw TypeError(".waiternow.common.SystemConfigProto.paymentConfig: object expected");
                    message.paymentConfig = $root.waiternow.common.PaymentConfigProto.fromObject(object.paymentConfig);
                }
                if (object.smsMessagingServiceConfig != null) {
                    if (typeof object.smsMessagingServiceConfig !== "object")
                        throw TypeError(".waiternow.common.SystemConfigProto.smsMessagingServiceConfig: object expected");
                    message.smsMessagingServiceConfig = $root.waiternow.common.SmsMessagingServiceConfigProto.fromObject(object.smsMessagingServiceConfig);
                }
                if (object.oncallConfig != null) {
                    if (typeof object.oncallConfig !== "object")
                        throw TypeError(".waiternow.common.SystemConfigProto.oncallConfig: object expected");
                    message.oncallConfig = $root.waiternow.common.OncallConfigProto.fromObject(object.oncallConfig);
                }
                if (object.googleApiKeys != null) {
                    if (typeof object.googleApiKeys !== "object")
                        throw TypeError(".waiternow.common.SystemConfigProto.googleApiKeys: object expected");
                    message.googleApiKeys = $root.waiternow.common.GoogleApiKeysProto.fromObject(object.googleApiKeys);
                }
                if (object.doordashApiKeys != null) {
                    if (typeof object.doordashApiKeys !== "object")
                        throw TypeError(".waiternow.common.SystemConfigProto.doordashApiKeys: object expected");
                    message.doordashApiKeys = $root.waiternow.common.DoordashApiKeysProto.fromObject(object.doordashApiKeys);
                }
                if (object.usGeocoderApiKeys != null) {
                    if (typeof object.usGeocoderApiKeys !== "object")
                        throw TypeError(".waiternow.common.SystemConfigProto.usGeocoderApiKeys: object expected");
                    message.usGeocoderApiKeys = $root.waiternow.common.UsGeocoderApiKeysProto.fromObject(object.usGeocoderApiKeys);
                }
                if (object.uberApiKeys != null) {
                    if (typeof object.uberApiKeys !== "object")
                        throw TypeError(".waiternow.common.SystemConfigProto.uberApiKeys: object expected");
                    message.uberApiKeys = $root.waiternow.common.UberApiKeysProto.fromObject(object.uberApiKeys);
                }
                return message;
            };

            /**
             * Creates a plain object from a SystemConfigProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.SystemConfigProto
             * @static
             * @param {waiternow.common.SystemConfigProto} message SystemConfigProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SystemConfigProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.configurationName = "";
                    object.systemInfo = null;
                    object.administrationConfig = null;
                    object.persistenceLayerConfig = null;
                    object.storageLayerConfig = null;
                    object.webLayerConfig = null;
                    object.firebaseConfig = null;
                    object.thresholdsConfig = null;
                    object.emailServiceConfig = null;
                    object.billingConfig = null;
                    object.paymentConfig = null;
                    object.smsMessagingServiceConfig = null;
                    object.oncallConfig = null;
                    object.googleApiKeys = null;
                    object.doordashApiKeys = null;
                    object.usGeocoderApiKeys = null;
                    object.uberApiKeys = null;
                }
                if (message.configurationName != null && message.hasOwnProperty("configurationName"))
                    object.configurationName = message.configurationName;
                if (message.systemInfo != null && message.hasOwnProperty("systemInfo"))
                    object.systemInfo = $root.waiternow.common.SystemInfoProto.toObject(message.systemInfo, options);
                if (message.administrationConfig != null && message.hasOwnProperty("administrationConfig"))
                    object.administrationConfig = $root.waiternow.common.AdministrationConfigProto.toObject(message.administrationConfig, options);
                if (message.persistenceLayerConfig != null && message.hasOwnProperty("persistenceLayerConfig"))
                    object.persistenceLayerConfig = $root.waiternow.common.PersistenceLayerConfigProto.toObject(message.persistenceLayerConfig, options);
                if (message.storageLayerConfig != null && message.hasOwnProperty("storageLayerConfig"))
                    object.storageLayerConfig = $root.waiternow.common.StorageLayerConfigProto.toObject(message.storageLayerConfig, options);
                if (message.webLayerConfig != null && message.hasOwnProperty("webLayerConfig"))
                    object.webLayerConfig = $root.waiternow.common.WebLayerConfigProto.toObject(message.webLayerConfig, options);
                if (message.firebaseConfig != null && message.hasOwnProperty("firebaseConfig"))
                    object.firebaseConfig = $root.waiternow.common.FirebaseConfigProto.toObject(message.firebaseConfig, options);
                if (message.thresholdsConfig != null && message.hasOwnProperty("thresholdsConfig"))
                    object.thresholdsConfig = $root.waiternow.common.ThresholdsConfigProto.toObject(message.thresholdsConfig, options);
                if (message.emailServiceConfig != null && message.hasOwnProperty("emailServiceConfig"))
                    object.emailServiceConfig = $root.waiternow.common.EmailServiceConfigProto.toObject(message.emailServiceConfig, options);
                if (message.billingConfig != null && message.hasOwnProperty("billingConfig"))
                    object.billingConfig = $root.waiternow.common.BillingConfigProto.toObject(message.billingConfig, options);
                if (message.paymentConfig != null && message.hasOwnProperty("paymentConfig"))
                    object.paymentConfig = $root.waiternow.common.PaymentConfigProto.toObject(message.paymentConfig, options);
                if (message.smsMessagingServiceConfig != null && message.hasOwnProperty("smsMessagingServiceConfig"))
                    object.smsMessagingServiceConfig = $root.waiternow.common.SmsMessagingServiceConfigProto.toObject(message.smsMessagingServiceConfig, options);
                if (message.oncallConfig != null && message.hasOwnProperty("oncallConfig"))
                    object.oncallConfig = $root.waiternow.common.OncallConfigProto.toObject(message.oncallConfig, options);
                if (message.googleApiKeys != null && message.hasOwnProperty("googleApiKeys"))
                    object.googleApiKeys = $root.waiternow.common.GoogleApiKeysProto.toObject(message.googleApiKeys, options);
                if (message.doordashApiKeys != null && message.hasOwnProperty("doordashApiKeys"))
                    object.doordashApiKeys = $root.waiternow.common.DoordashApiKeysProto.toObject(message.doordashApiKeys, options);
                if (message.usGeocoderApiKeys != null && message.hasOwnProperty("usGeocoderApiKeys"))
                    object.usGeocoderApiKeys = $root.waiternow.common.UsGeocoderApiKeysProto.toObject(message.usGeocoderApiKeys, options);
                if (message.uberApiKeys != null && message.hasOwnProperty("uberApiKeys"))
                    object.uberApiKeys = $root.waiternow.common.UberApiKeysProto.toObject(message.uberApiKeys, options);
                return object;
            };

            /**
             * Converts this SystemConfigProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.SystemConfigProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SystemConfigProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for SystemConfigProto
             * @function getTypeUrl
             * @memberof waiternow.common.SystemConfigProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            SystemConfigProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.SystemConfigProto";
            };

            return SystemConfigProto;
        })();

        common.SystemInfoProto = (function() {

            /**
             * Properties of a SystemInfoProto.
             * @memberof waiternow.common
             * @interface ISystemInfoProto
             * @property {string|null} [version] SystemInfoProto version
             * @property {string|null} [buildTime] SystemInfoProto buildTime
             * @property {waiternow.common.SystemInfoProto.Environment|null} [environment] SystemInfoProto environment
             * @property {string|null} [consumerReleaseTime] SystemInfoProto consumerReleaseTime
             * @property {string|null} [businessWebReleaseTime] SystemInfoProto businessWebReleaseTime
             * @property {string|null} [adminReleaseTime] SystemInfoProto adminReleaseTime
             * @property {string|null} [supportReleaseTime] SystemInfoProto supportReleaseTime
             * @property {string|null} [landingPageReleaseTime] SystemInfoProto landingPageReleaseTime
             */

            /**
             * Constructs a new SystemInfoProto.
             * @memberof waiternow.common
             * @classdesc Represents a SystemInfoProto.
             * @implements ISystemInfoProto
             * @constructor
             * @param {waiternow.common.ISystemInfoProto=} [properties] Properties to set
             */
            function SystemInfoProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * SystemInfoProto version.
             * @member {string} version
             * @memberof waiternow.common.SystemInfoProto
             * @instance
             */
            SystemInfoProto.prototype.version = "";

            /**
             * SystemInfoProto buildTime.
             * @member {string} buildTime
             * @memberof waiternow.common.SystemInfoProto
             * @instance
             */
            SystemInfoProto.prototype.buildTime = "";

            /**
             * SystemInfoProto environment.
             * @member {waiternow.common.SystemInfoProto.Environment} environment
             * @memberof waiternow.common.SystemInfoProto
             * @instance
             */
            SystemInfoProto.prototype.environment = 0;

            /**
             * SystemInfoProto consumerReleaseTime.
             * @member {string} consumerReleaseTime
             * @memberof waiternow.common.SystemInfoProto
             * @instance
             */
            SystemInfoProto.prototype.consumerReleaseTime = "";

            /**
             * SystemInfoProto businessWebReleaseTime.
             * @member {string} businessWebReleaseTime
             * @memberof waiternow.common.SystemInfoProto
             * @instance
             */
            SystemInfoProto.prototype.businessWebReleaseTime = "";

            /**
             * SystemInfoProto adminReleaseTime.
             * @member {string} adminReleaseTime
             * @memberof waiternow.common.SystemInfoProto
             * @instance
             */
            SystemInfoProto.prototype.adminReleaseTime = "";

            /**
             * SystemInfoProto supportReleaseTime.
             * @member {string} supportReleaseTime
             * @memberof waiternow.common.SystemInfoProto
             * @instance
             */
            SystemInfoProto.prototype.supportReleaseTime = "";

            /**
             * SystemInfoProto landingPageReleaseTime.
             * @member {string} landingPageReleaseTime
             * @memberof waiternow.common.SystemInfoProto
             * @instance
             */
            SystemInfoProto.prototype.landingPageReleaseTime = "";

            /**
             * Creates a new SystemInfoProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.SystemInfoProto
             * @static
             * @param {waiternow.common.ISystemInfoProto=} [properties] Properties to set
             * @returns {waiternow.common.SystemInfoProto} SystemInfoProto instance
             */
            SystemInfoProto.create = function create(properties) {
                return new SystemInfoProto(properties);
            };

            /**
             * Encodes the specified SystemInfoProto message. Does not implicitly {@link waiternow.common.SystemInfoProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.SystemInfoProto
             * @static
             * @param {waiternow.common.ISystemInfoProto} message SystemInfoProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SystemInfoProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.version != null && Object.hasOwnProperty.call(message, "version"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.version);
                if (message.buildTime != null && Object.hasOwnProperty.call(message, "buildTime"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.buildTime);
                if (message.environment != null && Object.hasOwnProperty.call(message, "environment"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.environment);
                if (message.consumerReleaseTime != null && Object.hasOwnProperty.call(message, "consumerReleaseTime"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.consumerReleaseTime);
                if (message.businessWebReleaseTime != null && Object.hasOwnProperty.call(message, "businessWebReleaseTime"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.businessWebReleaseTime);
                if (message.adminReleaseTime != null && Object.hasOwnProperty.call(message, "adminReleaseTime"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.adminReleaseTime);
                if (message.supportReleaseTime != null && Object.hasOwnProperty.call(message, "supportReleaseTime"))
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.supportReleaseTime);
                if (message.landingPageReleaseTime != null && Object.hasOwnProperty.call(message, "landingPageReleaseTime"))
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.landingPageReleaseTime);
                return writer;
            };

            /**
             * Encodes the specified SystemInfoProto message, length delimited. Does not implicitly {@link waiternow.common.SystemInfoProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.SystemInfoProto
             * @static
             * @param {waiternow.common.ISystemInfoProto} message SystemInfoProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SystemInfoProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SystemInfoProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.SystemInfoProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.SystemInfoProto} SystemInfoProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SystemInfoProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.SystemInfoProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.version = reader.string();
                            break;
                        }
                    case 2: {
                            message.buildTime = reader.string();
                            break;
                        }
                    case 3: {
                            message.environment = reader.int32();
                            break;
                        }
                    case 4: {
                            message.consumerReleaseTime = reader.string();
                            break;
                        }
                    case 5: {
                            message.businessWebReleaseTime = reader.string();
                            break;
                        }
                    case 6: {
                            message.adminReleaseTime = reader.string();
                            break;
                        }
                    case 7: {
                            message.supportReleaseTime = reader.string();
                            break;
                        }
                    case 8: {
                            message.landingPageReleaseTime = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SystemInfoProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.SystemInfoProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.SystemInfoProto} SystemInfoProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SystemInfoProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SystemInfoProto message.
             * @function verify
             * @memberof waiternow.common.SystemInfoProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SystemInfoProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.version != null && message.hasOwnProperty("version"))
                    if (!$util.isString(message.version))
                        return "version: string expected";
                if (message.buildTime != null && message.hasOwnProperty("buildTime"))
                    if (!$util.isString(message.buildTime))
                        return "buildTime: string expected";
                if (message.environment != null && message.hasOwnProperty("environment"))
                    switch (message.environment) {
                    default:
                        return "environment: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                        break;
                    }
                if (message.consumerReleaseTime != null && message.hasOwnProperty("consumerReleaseTime"))
                    if (!$util.isString(message.consumerReleaseTime))
                        return "consumerReleaseTime: string expected";
                if (message.businessWebReleaseTime != null && message.hasOwnProperty("businessWebReleaseTime"))
                    if (!$util.isString(message.businessWebReleaseTime))
                        return "businessWebReleaseTime: string expected";
                if (message.adminReleaseTime != null && message.hasOwnProperty("adminReleaseTime"))
                    if (!$util.isString(message.adminReleaseTime))
                        return "adminReleaseTime: string expected";
                if (message.supportReleaseTime != null && message.hasOwnProperty("supportReleaseTime"))
                    if (!$util.isString(message.supportReleaseTime))
                        return "supportReleaseTime: string expected";
                if (message.landingPageReleaseTime != null && message.hasOwnProperty("landingPageReleaseTime"))
                    if (!$util.isString(message.landingPageReleaseTime))
                        return "landingPageReleaseTime: string expected";
                return null;
            };

            /**
             * Creates a SystemInfoProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.SystemInfoProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.SystemInfoProto} SystemInfoProto
             */
            SystemInfoProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.SystemInfoProto)
                    return object;
                var message = new $root.waiternow.common.SystemInfoProto();
                if (object.version != null)
                    message.version = String(object.version);
                if (object.buildTime != null)
                    message.buildTime = String(object.buildTime);
                switch (object.environment) {
                default:
                    if (typeof object.environment === "number") {
                        message.environment = object.environment;
                        break;
                    }
                    break;
                case "ENVIRONMENT_UNSPECIFIED":
                case 0:
                    message.environment = 0;
                    break;
                case "PROD":
                case 1:
                    message.environment = 1;
                    break;
                case "DEV":
                case 2:
                    message.environment = 2;
                    break;
                case "LOCAL":
                case 3:
                    message.environment = 3;
                    break;
                }
                if (object.consumerReleaseTime != null)
                    message.consumerReleaseTime = String(object.consumerReleaseTime);
                if (object.businessWebReleaseTime != null)
                    message.businessWebReleaseTime = String(object.businessWebReleaseTime);
                if (object.adminReleaseTime != null)
                    message.adminReleaseTime = String(object.adminReleaseTime);
                if (object.supportReleaseTime != null)
                    message.supportReleaseTime = String(object.supportReleaseTime);
                if (object.landingPageReleaseTime != null)
                    message.landingPageReleaseTime = String(object.landingPageReleaseTime);
                return message;
            };

            /**
             * Creates a plain object from a SystemInfoProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.SystemInfoProto
             * @static
             * @param {waiternow.common.SystemInfoProto} message SystemInfoProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SystemInfoProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.version = "";
                    object.buildTime = "";
                    object.environment = options.enums === String ? "ENVIRONMENT_UNSPECIFIED" : 0;
                    object.consumerReleaseTime = "";
                    object.businessWebReleaseTime = "";
                    object.adminReleaseTime = "";
                    object.supportReleaseTime = "";
                    object.landingPageReleaseTime = "";
                }
                if (message.version != null && message.hasOwnProperty("version"))
                    object.version = message.version;
                if (message.buildTime != null && message.hasOwnProperty("buildTime"))
                    object.buildTime = message.buildTime;
                if (message.environment != null && message.hasOwnProperty("environment"))
                    object.environment = options.enums === String ? $root.waiternow.common.SystemInfoProto.Environment[message.environment] === undefined ? message.environment : $root.waiternow.common.SystemInfoProto.Environment[message.environment] : message.environment;
                if (message.consumerReleaseTime != null && message.hasOwnProperty("consumerReleaseTime"))
                    object.consumerReleaseTime = message.consumerReleaseTime;
                if (message.businessWebReleaseTime != null && message.hasOwnProperty("businessWebReleaseTime"))
                    object.businessWebReleaseTime = message.businessWebReleaseTime;
                if (message.adminReleaseTime != null && message.hasOwnProperty("adminReleaseTime"))
                    object.adminReleaseTime = message.adminReleaseTime;
                if (message.supportReleaseTime != null && message.hasOwnProperty("supportReleaseTime"))
                    object.supportReleaseTime = message.supportReleaseTime;
                if (message.landingPageReleaseTime != null && message.hasOwnProperty("landingPageReleaseTime"))
                    object.landingPageReleaseTime = message.landingPageReleaseTime;
                return object;
            };

            /**
             * Converts this SystemInfoProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.SystemInfoProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SystemInfoProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for SystemInfoProto
             * @function getTypeUrl
             * @memberof waiternow.common.SystemInfoProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            SystemInfoProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.SystemInfoProto";
            };

            /**
             * Environment enum.
             * @name waiternow.common.SystemInfoProto.Environment
             * @enum {number}
             * @property {number} ENVIRONMENT_UNSPECIFIED=0 ENVIRONMENT_UNSPECIFIED value
             * @property {number} PROD=1 PROD value
             * @property {number} DEV=2 DEV value
             * @property {number} LOCAL=3 LOCAL value
             */
            SystemInfoProto.Environment = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "ENVIRONMENT_UNSPECIFIED"] = 0;
                values[valuesById[1] = "PROD"] = 1;
                values[valuesById[2] = "DEV"] = 2;
                values[valuesById[3] = "LOCAL"] = 3;
                return values;
            })();

            return SystemInfoProto;
        })();

        common.AdministrationConfigProto = (function() {

            /**
             * Properties of an AdministrationConfigProto.
             * @memberof waiternow.common
             * @interface IAdministrationConfigProto
             * @property {Array.<string>|null} [superusers] AdministrationConfigProto superusers
             * @property {Array.<string>|null} [privilegedUsers] AdministrationConfigProto privilegedUsers
             * @property {Array.<string>|null} [adminUsers] AdministrationConfigProto adminUsers
             * @property {Array.<string>|null} [impersonatorUsers] AdministrationConfigProto impersonatorUsers
             */

            /**
             * Constructs a new AdministrationConfigProto.
             * @memberof waiternow.common
             * @classdesc Represents an AdministrationConfigProto.
             * @implements IAdministrationConfigProto
             * @constructor
             * @param {waiternow.common.IAdministrationConfigProto=} [properties] Properties to set
             */
            function AdministrationConfigProto(properties) {
                this.superusers = [];
                this.privilegedUsers = [];
                this.adminUsers = [];
                this.impersonatorUsers = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AdministrationConfigProto superusers.
             * @member {Array.<string>} superusers
             * @memberof waiternow.common.AdministrationConfigProto
             * @instance
             */
            AdministrationConfigProto.prototype.superusers = $util.emptyArray;

            /**
             * AdministrationConfigProto privilegedUsers.
             * @member {Array.<string>} privilegedUsers
             * @memberof waiternow.common.AdministrationConfigProto
             * @instance
             */
            AdministrationConfigProto.prototype.privilegedUsers = $util.emptyArray;

            /**
             * AdministrationConfigProto adminUsers.
             * @member {Array.<string>} adminUsers
             * @memberof waiternow.common.AdministrationConfigProto
             * @instance
             */
            AdministrationConfigProto.prototype.adminUsers = $util.emptyArray;

            /**
             * AdministrationConfigProto impersonatorUsers.
             * @member {Array.<string>} impersonatorUsers
             * @memberof waiternow.common.AdministrationConfigProto
             * @instance
             */
            AdministrationConfigProto.prototype.impersonatorUsers = $util.emptyArray;

            /**
             * Creates a new AdministrationConfigProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.AdministrationConfigProto
             * @static
             * @param {waiternow.common.IAdministrationConfigProto=} [properties] Properties to set
             * @returns {waiternow.common.AdministrationConfigProto} AdministrationConfigProto instance
             */
            AdministrationConfigProto.create = function create(properties) {
                return new AdministrationConfigProto(properties);
            };

            /**
             * Encodes the specified AdministrationConfigProto message. Does not implicitly {@link waiternow.common.AdministrationConfigProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.AdministrationConfigProto
             * @static
             * @param {waiternow.common.IAdministrationConfigProto} message AdministrationConfigProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AdministrationConfigProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.superusers != null && message.superusers.length)
                    for (var i = 0; i < message.superusers.length; ++i)
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.superusers[i]);
                if (message.privilegedUsers != null && message.privilegedUsers.length)
                    for (var i = 0; i < message.privilegedUsers.length; ++i)
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.privilegedUsers[i]);
                if (message.adminUsers != null && message.adminUsers.length)
                    for (var i = 0; i < message.adminUsers.length; ++i)
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.adminUsers[i]);
                if (message.impersonatorUsers != null && message.impersonatorUsers.length)
                    for (var i = 0; i < message.impersonatorUsers.length; ++i)
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.impersonatorUsers[i]);
                return writer;
            };

            /**
             * Encodes the specified AdministrationConfigProto message, length delimited. Does not implicitly {@link waiternow.common.AdministrationConfigProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.AdministrationConfigProto
             * @static
             * @param {waiternow.common.IAdministrationConfigProto} message AdministrationConfigProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AdministrationConfigProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AdministrationConfigProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.AdministrationConfigProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.AdministrationConfigProto} AdministrationConfigProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AdministrationConfigProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.AdministrationConfigProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            if (!(message.superusers && message.superusers.length))
                                message.superusers = [];
                            message.superusers.push(reader.string());
                            break;
                        }
                    case 2: {
                            if (!(message.privilegedUsers && message.privilegedUsers.length))
                                message.privilegedUsers = [];
                            message.privilegedUsers.push(reader.string());
                            break;
                        }
                    case 3: {
                            if (!(message.adminUsers && message.adminUsers.length))
                                message.adminUsers = [];
                            message.adminUsers.push(reader.string());
                            break;
                        }
                    case 4: {
                            if (!(message.impersonatorUsers && message.impersonatorUsers.length))
                                message.impersonatorUsers = [];
                            message.impersonatorUsers.push(reader.string());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AdministrationConfigProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.AdministrationConfigProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.AdministrationConfigProto} AdministrationConfigProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AdministrationConfigProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AdministrationConfigProto message.
             * @function verify
             * @memberof waiternow.common.AdministrationConfigProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AdministrationConfigProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.superusers != null && message.hasOwnProperty("superusers")) {
                    if (!Array.isArray(message.superusers))
                        return "superusers: array expected";
                    for (var i = 0; i < message.superusers.length; ++i)
                        if (!$util.isString(message.superusers[i]))
                            return "superusers: string[] expected";
                }
                if (message.privilegedUsers != null && message.hasOwnProperty("privilegedUsers")) {
                    if (!Array.isArray(message.privilegedUsers))
                        return "privilegedUsers: array expected";
                    for (var i = 0; i < message.privilegedUsers.length; ++i)
                        if (!$util.isString(message.privilegedUsers[i]))
                            return "privilegedUsers: string[] expected";
                }
                if (message.adminUsers != null && message.hasOwnProperty("adminUsers")) {
                    if (!Array.isArray(message.adminUsers))
                        return "adminUsers: array expected";
                    for (var i = 0; i < message.adminUsers.length; ++i)
                        if (!$util.isString(message.adminUsers[i]))
                            return "adminUsers: string[] expected";
                }
                if (message.impersonatorUsers != null && message.hasOwnProperty("impersonatorUsers")) {
                    if (!Array.isArray(message.impersonatorUsers))
                        return "impersonatorUsers: array expected";
                    for (var i = 0; i < message.impersonatorUsers.length; ++i)
                        if (!$util.isString(message.impersonatorUsers[i]))
                            return "impersonatorUsers: string[] expected";
                }
                return null;
            };

            /**
             * Creates an AdministrationConfigProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.AdministrationConfigProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.AdministrationConfigProto} AdministrationConfigProto
             */
            AdministrationConfigProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.AdministrationConfigProto)
                    return object;
                var message = new $root.waiternow.common.AdministrationConfigProto();
                if (object.superusers) {
                    if (!Array.isArray(object.superusers))
                        throw TypeError(".waiternow.common.AdministrationConfigProto.superusers: array expected");
                    message.superusers = [];
                    for (var i = 0; i < object.superusers.length; ++i)
                        message.superusers[i] = String(object.superusers[i]);
                }
                if (object.privilegedUsers) {
                    if (!Array.isArray(object.privilegedUsers))
                        throw TypeError(".waiternow.common.AdministrationConfigProto.privilegedUsers: array expected");
                    message.privilegedUsers = [];
                    for (var i = 0; i < object.privilegedUsers.length; ++i)
                        message.privilegedUsers[i] = String(object.privilegedUsers[i]);
                }
                if (object.adminUsers) {
                    if (!Array.isArray(object.adminUsers))
                        throw TypeError(".waiternow.common.AdministrationConfigProto.adminUsers: array expected");
                    message.adminUsers = [];
                    for (var i = 0; i < object.adminUsers.length; ++i)
                        message.adminUsers[i] = String(object.adminUsers[i]);
                }
                if (object.impersonatorUsers) {
                    if (!Array.isArray(object.impersonatorUsers))
                        throw TypeError(".waiternow.common.AdministrationConfigProto.impersonatorUsers: array expected");
                    message.impersonatorUsers = [];
                    for (var i = 0; i < object.impersonatorUsers.length; ++i)
                        message.impersonatorUsers[i] = String(object.impersonatorUsers[i]);
                }
                return message;
            };

            /**
             * Creates a plain object from an AdministrationConfigProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.AdministrationConfigProto
             * @static
             * @param {waiternow.common.AdministrationConfigProto} message AdministrationConfigProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AdministrationConfigProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults) {
                    object.superusers = [];
                    object.privilegedUsers = [];
                    object.adminUsers = [];
                    object.impersonatorUsers = [];
                }
                if (message.superusers && message.superusers.length) {
                    object.superusers = [];
                    for (var j = 0; j < message.superusers.length; ++j)
                        object.superusers[j] = message.superusers[j];
                }
                if (message.privilegedUsers && message.privilegedUsers.length) {
                    object.privilegedUsers = [];
                    for (var j = 0; j < message.privilegedUsers.length; ++j)
                        object.privilegedUsers[j] = message.privilegedUsers[j];
                }
                if (message.adminUsers && message.adminUsers.length) {
                    object.adminUsers = [];
                    for (var j = 0; j < message.adminUsers.length; ++j)
                        object.adminUsers[j] = message.adminUsers[j];
                }
                if (message.impersonatorUsers && message.impersonatorUsers.length) {
                    object.impersonatorUsers = [];
                    for (var j = 0; j < message.impersonatorUsers.length; ++j)
                        object.impersonatorUsers[j] = message.impersonatorUsers[j];
                }
                return object;
            };

            /**
             * Converts this AdministrationConfigProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.AdministrationConfigProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AdministrationConfigProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for AdministrationConfigProto
             * @function getTypeUrl
             * @memberof waiternow.common.AdministrationConfigProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            AdministrationConfigProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.AdministrationConfigProto";
            };

            return AdministrationConfigProto;
        })();

        common.OncallConfigProto = (function() {

            /**
             * Properties of an OncallConfigProto.
             * @memberof waiternow.common
             * @interface IOncallConfigProto
             * @property {Array.<waiternow.common.OncallConfigProto.IOncallRotationMemberProto>|null} [oncallRationMembers] OncallConfigProto oncallRationMembers
             */

            /**
             * Constructs a new OncallConfigProto.
             * @memberof waiternow.common
             * @classdesc Represents an OncallConfigProto.
             * @implements IOncallConfigProto
             * @constructor
             * @param {waiternow.common.IOncallConfigProto=} [properties] Properties to set
             */
            function OncallConfigProto(properties) {
                this.oncallRationMembers = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * OncallConfigProto oncallRationMembers.
             * @member {Array.<waiternow.common.OncallConfigProto.IOncallRotationMemberProto>} oncallRationMembers
             * @memberof waiternow.common.OncallConfigProto
             * @instance
             */
            OncallConfigProto.prototype.oncallRationMembers = $util.emptyArray;

            /**
             * Creates a new OncallConfigProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.OncallConfigProto
             * @static
             * @param {waiternow.common.IOncallConfigProto=} [properties] Properties to set
             * @returns {waiternow.common.OncallConfigProto} OncallConfigProto instance
             */
            OncallConfigProto.create = function create(properties) {
                return new OncallConfigProto(properties);
            };

            /**
             * Encodes the specified OncallConfigProto message. Does not implicitly {@link waiternow.common.OncallConfigProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.OncallConfigProto
             * @static
             * @param {waiternow.common.IOncallConfigProto} message OncallConfigProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OncallConfigProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.oncallRationMembers != null && message.oncallRationMembers.length)
                    for (var i = 0; i < message.oncallRationMembers.length; ++i)
                        $root.waiternow.common.OncallConfigProto.OncallRotationMemberProto.encode(message.oncallRationMembers[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified OncallConfigProto message, length delimited. Does not implicitly {@link waiternow.common.OncallConfigProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.OncallConfigProto
             * @static
             * @param {waiternow.common.IOncallConfigProto} message OncallConfigProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OncallConfigProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an OncallConfigProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.OncallConfigProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.OncallConfigProto} OncallConfigProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OncallConfigProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.OncallConfigProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            if (!(message.oncallRationMembers && message.oncallRationMembers.length))
                                message.oncallRationMembers = [];
                            message.oncallRationMembers.push($root.waiternow.common.OncallConfigProto.OncallRotationMemberProto.decode(reader, reader.uint32()));
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an OncallConfigProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.OncallConfigProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.OncallConfigProto} OncallConfigProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OncallConfigProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an OncallConfigProto message.
             * @function verify
             * @memberof waiternow.common.OncallConfigProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            OncallConfigProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.oncallRationMembers != null && message.hasOwnProperty("oncallRationMembers")) {
                    if (!Array.isArray(message.oncallRationMembers))
                        return "oncallRationMembers: array expected";
                    for (var i = 0; i < message.oncallRationMembers.length; ++i) {
                        var error = $root.waiternow.common.OncallConfigProto.OncallRotationMemberProto.verify(message.oncallRationMembers[i]);
                        if (error)
                            return "oncallRationMembers." + error;
                    }
                }
                return null;
            };

            /**
             * Creates an OncallConfigProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.OncallConfigProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.OncallConfigProto} OncallConfigProto
             */
            OncallConfigProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.OncallConfigProto)
                    return object;
                var message = new $root.waiternow.common.OncallConfigProto();
                if (object.oncallRationMembers) {
                    if (!Array.isArray(object.oncallRationMembers))
                        throw TypeError(".waiternow.common.OncallConfigProto.oncallRationMembers: array expected");
                    message.oncallRationMembers = [];
                    for (var i = 0; i < object.oncallRationMembers.length; ++i) {
                        if (typeof object.oncallRationMembers[i] !== "object")
                            throw TypeError(".waiternow.common.OncallConfigProto.oncallRationMembers: object expected");
                        message.oncallRationMembers[i] = $root.waiternow.common.OncallConfigProto.OncallRotationMemberProto.fromObject(object.oncallRationMembers[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from an OncallConfigProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.OncallConfigProto
             * @static
             * @param {waiternow.common.OncallConfigProto} message OncallConfigProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            OncallConfigProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.oncallRationMembers = [];
                if (message.oncallRationMembers && message.oncallRationMembers.length) {
                    object.oncallRationMembers = [];
                    for (var j = 0; j < message.oncallRationMembers.length; ++j)
                        object.oncallRationMembers[j] = $root.waiternow.common.OncallConfigProto.OncallRotationMemberProto.toObject(message.oncallRationMembers[j], options);
                }
                return object;
            };

            /**
             * Converts this OncallConfigProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.OncallConfigProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            OncallConfigProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for OncallConfigProto
             * @function getTypeUrl
             * @memberof waiternow.common.OncallConfigProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            OncallConfigProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.OncallConfigProto";
            };

            OncallConfigProto.OncallRotationMemberProto = (function() {

                /**
                 * Properties of an OncallRotationMemberProto.
                 * @memberof waiternow.common.OncallConfigProto
                 * @interface IOncallRotationMemberProto
                 * @property {waiternow.common.IEmailAddressProto|null} [emailAddress] OncallRotationMemberProto emailAddress
                 * @property {waiternow.common.IPhoneNumberProto|null} [phoneNumber] OncallRotationMemberProto phoneNumber
                 * @property {boolean|null} [isActive] OncallRotationMemberProto isActive
                 * @property {boolean|null} [isPrimary] OncallRotationMemberProto isPrimary
                 */

                /**
                 * Constructs a new OncallRotationMemberProto.
                 * @memberof waiternow.common.OncallConfigProto
                 * @classdesc Represents an OncallRotationMemberProto.
                 * @implements IOncallRotationMemberProto
                 * @constructor
                 * @param {waiternow.common.OncallConfigProto.IOncallRotationMemberProto=} [properties] Properties to set
                 */
                function OncallRotationMemberProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * OncallRotationMemberProto emailAddress.
                 * @member {waiternow.common.IEmailAddressProto|null|undefined} emailAddress
                 * @memberof waiternow.common.OncallConfigProto.OncallRotationMemberProto
                 * @instance
                 */
                OncallRotationMemberProto.prototype.emailAddress = null;

                /**
                 * OncallRotationMemberProto phoneNumber.
                 * @member {waiternow.common.IPhoneNumberProto|null|undefined} phoneNumber
                 * @memberof waiternow.common.OncallConfigProto.OncallRotationMemberProto
                 * @instance
                 */
                OncallRotationMemberProto.prototype.phoneNumber = null;

                /**
                 * OncallRotationMemberProto isActive.
                 * @member {boolean} isActive
                 * @memberof waiternow.common.OncallConfigProto.OncallRotationMemberProto
                 * @instance
                 */
                OncallRotationMemberProto.prototype.isActive = false;

                /**
                 * OncallRotationMemberProto isPrimary.
                 * @member {boolean} isPrimary
                 * @memberof waiternow.common.OncallConfigProto.OncallRotationMemberProto
                 * @instance
                 */
                OncallRotationMemberProto.prototype.isPrimary = false;

                /**
                 * Creates a new OncallRotationMemberProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.OncallConfigProto.OncallRotationMemberProto
                 * @static
                 * @param {waiternow.common.OncallConfigProto.IOncallRotationMemberProto=} [properties] Properties to set
                 * @returns {waiternow.common.OncallConfigProto.OncallRotationMemberProto} OncallRotationMemberProto instance
                 */
                OncallRotationMemberProto.create = function create(properties) {
                    return new OncallRotationMemberProto(properties);
                };

                /**
                 * Encodes the specified OncallRotationMemberProto message. Does not implicitly {@link waiternow.common.OncallConfigProto.OncallRotationMemberProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.OncallConfigProto.OncallRotationMemberProto
                 * @static
                 * @param {waiternow.common.OncallConfigProto.IOncallRotationMemberProto} message OncallRotationMemberProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                OncallRotationMemberProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.emailAddress != null && Object.hasOwnProperty.call(message, "emailAddress"))
                        $root.waiternow.common.EmailAddressProto.encode(message.emailAddress, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.phoneNumber != null && Object.hasOwnProperty.call(message, "phoneNumber"))
                        $root.waiternow.common.PhoneNumberProto.encode(message.phoneNumber, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.isActive != null && Object.hasOwnProperty.call(message, "isActive"))
                        writer.uint32(/* id 3, wireType 0 =*/24).bool(message.isActive);
                    if (message.isPrimary != null && Object.hasOwnProperty.call(message, "isPrimary"))
                        writer.uint32(/* id 4, wireType 0 =*/32).bool(message.isPrimary);
                    return writer;
                };

                /**
                 * Encodes the specified OncallRotationMemberProto message, length delimited. Does not implicitly {@link waiternow.common.OncallConfigProto.OncallRotationMemberProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.OncallConfigProto.OncallRotationMemberProto
                 * @static
                 * @param {waiternow.common.OncallConfigProto.IOncallRotationMemberProto} message OncallRotationMemberProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                OncallRotationMemberProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an OncallRotationMemberProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.OncallConfigProto.OncallRotationMemberProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.OncallConfigProto.OncallRotationMemberProto} OncallRotationMemberProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                OncallRotationMemberProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.OncallConfigProto.OncallRotationMemberProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.emailAddress = $root.waiternow.common.EmailAddressProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.phoneNumber = $root.waiternow.common.PhoneNumberProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.isActive = reader.bool();
                                break;
                            }
                        case 4: {
                                message.isPrimary = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an OncallRotationMemberProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.OncallConfigProto.OncallRotationMemberProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.OncallConfigProto.OncallRotationMemberProto} OncallRotationMemberProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                OncallRotationMemberProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an OncallRotationMemberProto message.
                 * @function verify
                 * @memberof waiternow.common.OncallConfigProto.OncallRotationMemberProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                OncallRotationMemberProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.emailAddress != null && message.hasOwnProperty("emailAddress")) {
                        var error = $root.waiternow.common.EmailAddressProto.verify(message.emailAddress);
                        if (error)
                            return "emailAddress." + error;
                    }
                    if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber")) {
                        var error = $root.waiternow.common.PhoneNumberProto.verify(message.phoneNumber);
                        if (error)
                            return "phoneNumber." + error;
                    }
                    if (message.isActive != null && message.hasOwnProperty("isActive"))
                        if (typeof message.isActive !== "boolean")
                            return "isActive: boolean expected";
                    if (message.isPrimary != null && message.hasOwnProperty("isPrimary"))
                        if (typeof message.isPrimary !== "boolean")
                            return "isPrimary: boolean expected";
                    return null;
                };

                /**
                 * Creates an OncallRotationMemberProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.OncallConfigProto.OncallRotationMemberProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.OncallConfigProto.OncallRotationMemberProto} OncallRotationMemberProto
                 */
                OncallRotationMemberProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.OncallConfigProto.OncallRotationMemberProto)
                        return object;
                    var message = new $root.waiternow.common.OncallConfigProto.OncallRotationMemberProto();
                    if (object.emailAddress != null) {
                        if (typeof object.emailAddress !== "object")
                            throw TypeError(".waiternow.common.OncallConfigProto.OncallRotationMemberProto.emailAddress: object expected");
                        message.emailAddress = $root.waiternow.common.EmailAddressProto.fromObject(object.emailAddress);
                    }
                    if (object.phoneNumber != null) {
                        if (typeof object.phoneNumber !== "object")
                            throw TypeError(".waiternow.common.OncallConfigProto.OncallRotationMemberProto.phoneNumber: object expected");
                        message.phoneNumber = $root.waiternow.common.PhoneNumberProto.fromObject(object.phoneNumber);
                    }
                    if (object.isActive != null)
                        message.isActive = Boolean(object.isActive);
                    if (object.isPrimary != null)
                        message.isPrimary = Boolean(object.isPrimary);
                    return message;
                };

                /**
                 * Creates a plain object from an OncallRotationMemberProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.OncallConfigProto.OncallRotationMemberProto
                 * @static
                 * @param {waiternow.common.OncallConfigProto.OncallRotationMemberProto} message OncallRotationMemberProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                OncallRotationMemberProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.emailAddress = null;
                        object.phoneNumber = null;
                        object.isActive = false;
                        object.isPrimary = false;
                    }
                    if (message.emailAddress != null && message.hasOwnProperty("emailAddress"))
                        object.emailAddress = $root.waiternow.common.EmailAddressProto.toObject(message.emailAddress, options);
                    if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
                        object.phoneNumber = $root.waiternow.common.PhoneNumberProto.toObject(message.phoneNumber, options);
                    if (message.isActive != null && message.hasOwnProperty("isActive"))
                        object.isActive = message.isActive;
                    if (message.isPrimary != null && message.hasOwnProperty("isPrimary"))
                        object.isPrimary = message.isPrimary;
                    return object;
                };

                /**
                 * Converts this OncallRotationMemberProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.OncallConfigProto.OncallRotationMemberProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                OncallRotationMemberProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for OncallRotationMemberProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.OncallConfigProto.OncallRotationMemberProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                OncallRotationMemberProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.OncallConfigProto.OncallRotationMemberProto";
                };

                return OncallRotationMemberProto;
            })();

            return OncallConfigProto;
        })();

        common.PersistenceLayerConfigProto = (function() {

            /**
             * Properties of a PersistenceLayerConfigProto.
             * @memberof waiternow.common
             * @interface IPersistenceLayerConfigProto
             * @property {waiternow.common.PersistenceLayerConfigProto.IDatabaseConfigProto|null} [databaseConfig] PersistenceLayerConfigProto databaseConfig
             */

            /**
             * Constructs a new PersistenceLayerConfigProto.
             * @memberof waiternow.common
             * @classdesc Represents a PersistenceLayerConfigProto.
             * @implements IPersistenceLayerConfigProto
             * @constructor
             * @param {waiternow.common.IPersistenceLayerConfigProto=} [properties] Properties to set
             */
            function PersistenceLayerConfigProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * PersistenceLayerConfigProto databaseConfig.
             * @member {waiternow.common.PersistenceLayerConfigProto.IDatabaseConfigProto|null|undefined} databaseConfig
             * @memberof waiternow.common.PersistenceLayerConfigProto
             * @instance
             */
            PersistenceLayerConfigProto.prototype.databaseConfig = null;

            /**
             * Creates a new PersistenceLayerConfigProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.PersistenceLayerConfigProto
             * @static
             * @param {waiternow.common.IPersistenceLayerConfigProto=} [properties] Properties to set
             * @returns {waiternow.common.PersistenceLayerConfigProto} PersistenceLayerConfigProto instance
             */
            PersistenceLayerConfigProto.create = function create(properties) {
                return new PersistenceLayerConfigProto(properties);
            };

            /**
             * Encodes the specified PersistenceLayerConfigProto message. Does not implicitly {@link waiternow.common.PersistenceLayerConfigProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.PersistenceLayerConfigProto
             * @static
             * @param {waiternow.common.IPersistenceLayerConfigProto} message PersistenceLayerConfigProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PersistenceLayerConfigProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.databaseConfig != null && Object.hasOwnProperty.call(message, "databaseConfig"))
                    $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.encode(message.databaseConfig, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified PersistenceLayerConfigProto message, length delimited. Does not implicitly {@link waiternow.common.PersistenceLayerConfigProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.PersistenceLayerConfigProto
             * @static
             * @param {waiternow.common.IPersistenceLayerConfigProto} message PersistenceLayerConfigProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PersistenceLayerConfigProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a PersistenceLayerConfigProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.PersistenceLayerConfigProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.PersistenceLayerConfigProto} PersistenceLayerConfigProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PersistenceLayerConfigProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PersistenceLayerConfigProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.databaseConfig = $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a PersistenceLayerConfigProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.PersistenceLayerConfigProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.PersistenceLayerConfigProto} PersistenceLayerConfigProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PersistenceLayerConfigProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a PersistenceLayerConfigProto message.
             * @function verify
             * @memberof waiternow.common.PersistenceLayerConfigProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            PersistenceLayerConfigProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.databaseConfig != null && message.hasOwnProperty("databaseConfig")) {
                    var error = $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.verify(message.databaseConfig);
                    if (error)
                        return "databaseConfig." + error;
                }
                return null;
            };

            /**
             * Creates a PersistenceLayerConfigProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.PersistenceLayerConfigProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.PersistenceLayerConfigProto} PersistenceLayerConfigProto
             */
            PersistenceLayerConfigProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.PersistenceLayerConfigProto)
                    return object;
                var message = new $root.waiternow.common.PersistenceLayerConfigProto();
                if (object.databaseConfig != null) {
                    if (typeof object.databaseConfig !== "object")
                        throw TypeError(".waiternow.common.PersistenceLayerConfigProto.databaseConfig: object expected");
                    message.databaseConfig = $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.fromObject(object.databaseConfig);
                }
                return message;
            };

            /**
             * Creates a plain object from a PersistenceLayerConfigProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.PersistenceLayerConfigProto
             * @static
             * @param {waiternow.common.PersistenceLayerConfigProto} message PersistenceLayerConfigProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            PersistenceLayerConfigProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.databaseConfig = null;
                if (message.databaseConfig != null && message.hasOwnProperty("databaseConfig"))
                    object.databaseConfig = $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.toObject(message.databaseConfig, options);
                return object;
            };

            /**
             * Converts this PersistenceLayerConfigProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.PersistenceLayerConfigProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            PersistenceLayerConfigProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for PersistenceLayerConfigProto
             * @function getTypeUrl
             * @memberof waiternow.common.PersistenceLayerConfigProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            PersistenceLayerConfigProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.PersistenceLayerConfigProto";
            };

            PersistenceLayerConfigProto.DatabaseConfigProto = (function() {

                /**
                 * Properties of a DatabaseConfigProto.
                 * @memberof waiternow.common.PersistenceLayerConfigProto
                 * @interface IDatabaseConfigProto
                 * @property {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.IHsqlConfigProto|null} [hsqlConfig] DatabaseConfigProto hsqlConfig
                 * @property {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.IPostgresqlConfigProto|null} [postgresqlConfig] DatabaseConfigProto postgresqlConfig
                 * @property {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.IGoogleCloudSqlPostgresqlConfigProto|null} [googleCloudSqlPostgresqlConfig] DatabaseConfigProto googleCloudSqlPostgresqlConfig
                 * @property {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.IFirestoreConfigProto|null} [firestoreConfig] DatabaseConfigProto firestoreConfig
                 * @property {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.IFirestoreEmulatorConfigProto|null} [firestoreEmulatorConfig] DatabaseConfigProto firestoreEmulatorConfig
                 * @property {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.ISpannerConfigProto|null} [spannerConfig] DatabaseConfigProto spannerConfig
                 */

                /**
                 * Constructs a new DatabaseConfigProto.
                 * @memberof waiternow.common.PersistenceLayerConfigProto
                 * @classdesc Represents a DatabaseConfigProto.
                 * @implements IDatabaseConfigProto
                 * @constructor
                 * @param {waiternow.common.PersistenceLayerConfigProto.IDatabaseConfigProto=} [properties] Properties to set
                 */
                function DatabaseConfigProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * DatabaseConfigProto hsqlConfig.
                 * @member {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.IHsqlConfigProto|null|undefined} hsqlConfig
                 * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto
                 * @instance
                 */
                DatabaseConfigProto.prototype.hsqlConfig = null;

                /**
                 * DatabaseConfigProto postgresqlConfig.
                 * @member {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.IPostgresqlConfigProto|null|undefined} postgresqlConfig
                 * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto
                 * @instance
                 */
                DatabaseConfigProto.prototype.postgresqlConfig = null;

                /**
                 * DatabaseConfigProto googleCloudSqlPostgresqlConfig.
                 * @member {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.IGoogleCloudSqlPostgresqlConfigProto|null|undefined} googleCloudSqlPostgresqlConfig
                 * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto
                 * @instance
                 */
                DatabaseConfigProto.prototype.googleCloudSqlPostgresqlConfig = null;

                /**
                 * DatabaseConfigProto firestoreConfig.
                 * @member {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.IFirestoreConfigProto|null|undefined} firestoreConfig
                 * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto
                 * @instance
                 */
                DatabaseConfigProto.prototype.firestoreConfig = null;

                /**
                 * DatabaseConfigProto firestoreEmulatorConfig.
                 * @member {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.IFirestoreEmulatorConfigProto|null|undefined} firestoreEmulatorConfig
                 * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto
                 * @instance
                 */
                DatabaseConfigProto.prototype.firestoreEmulatorConfig = null;

                /**
                 * DatabaseConfigProto spannerConfig.
                 * @member {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.ISpannerConfigProto|null|undefined} spannerConfig
                 * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto
                 * @instance
                 */
                DatabaseConfigProto.prototype.spannerConfig = null;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * DatabaseConfigProto database.
                 * @member {"hsqlConfig"|"postgresqlConfig"|"googleCloudSqlPostgresqlConfig"|"firestoreConfig"|"firestoreEmulatorConfig"|"spannerConfig"|undefined} database
                 * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto
                 * @instance
                 */
                Object.defineProperty(DatabaseConfigProto.prototype, "database", {
                    get: $util.oneOfGetter($oneOfFields = ["hsqlConfig", "postgresqlConfig", "googleCloudSqlPostgresqlConfig", "firestoreConfig", "firestoreEmulatorConfig", "spannerConfig"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new DatabaseConfigProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto
                 * @static
                 * @param {waiternow.common.PersistenceLayerConfigProto.IDatabaseConfigProto=} [properties] Properties to set
                 * @returns {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto} DatabaseConfigProto instance
                 */
                DatabaseConfigProto.create = function create(properties) {
                    return new DatabaseConfigProto(properties);
                };

                /**
                 * Encodes the specified DatabaseConfigProto message. Does not implicitly {@link waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto
                 * @static
                 * @param {waiternow.common.PersistenceLayerConfigProto.IDatabaseConfigProto} message DatabaseConfigProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DatabaseConfigProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.hsqlConfig != null && Object.hasOwnProperty.call(message, "hsqlConfig"))
                        $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.HsqlConfigProto.encode(message.hsqlConfig, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.postgresqlConfig != null && Object.hasOwnProperty.call(message, "postgresqlConfig"))
                        $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.PostgresqlConfigProto.encode(message.postgresqlConfig, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.googleCloudSqlPostgresqlConfig != null && Object.hasOwnProperty.call(message, "googleCloudSqlPostgresqlConfig"))
                        $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.GoogleCloudSqlPostgresqlConfigProto.encode(message.googleCloudSqlPostgresqlConfig, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.firestoreConfig != null && Object.hasOwnProperty.call(message, "firestoreConfig"))
                        $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreConfigProto.encode(message.firestoreConfig, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.firestoreEmulatorConfig != null && Object.hasOwnProperty.call(message, "firestoreEmulatorConfig"))
                        $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreEmulatorConfigProto.encode(message.firestoreEmulatorConfig, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.spannerConfig != null && Object.hasOwnProperty.call(message, "spannerConfig"))
                        $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.SpannerConfigProto.encode(message.spannerConfig, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified DatabaseConfigProto message, length delimited. Does not implicitly {@link waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto
                 * @static
                 * @param {waiternow.common.PersistenceLayerConfigProto.IDatabaseConfigProto} message DatabaseConfigProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DatabaseConfigProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a DatabaseConfigProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto} DatabaseConfigProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DatabaseConfigProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.hsqlConfig = $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.HsqlConfigProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.postgresqlConfig = $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.PostgresqlConfigProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.googleCloudSqlPostgresqlConfig = $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.GoogleCloudSqlPostgresqlConfigProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 4: {
                                message.firestoreConfig = $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreConfigProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 5: {
                                message.firestoreEmulatorConfig = $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreEmulatorConfigProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 6: {
                                message.spannerConfig = $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.SpannerConfigProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a DatabaseConfigProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto} DatabaseConfigProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DatabaseConfigProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a DatabaseConfigProto message.
                 * @function verify
                 * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                DatabaseConfigProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.hsqlConfig != null && message.hasOwnProperty("hsqlConfig")) {
                        properties.database = 1;
                        {
                            var error = $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.HsqlConfigProto.verify(message.hsqlConfig);
                            if (error)
                                return "hsqlConfig." + error;
                        }
                    }
                    if (message.postgresqlConfig != null && message.hasOwnProperty("postgresqlConfig")) {
                        if (properties.database === 1)
                            return "database: multiple values";
                        properties.database = 1;
                        {
                            var error = $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.PostgresqlConfigProto.verify(message.postgresqlConfig);
                            if (error)
                                return "postgresqlConfig." + error;
                        }
                    }
                    if (message.googleCloudSqlPostgresqlConfig != null && message.hasOwnProperty("googleCloudSqlPostgresqlConfig")) {
                        if (properties.database === 1)
                            return "database: multiple values";
                        properties.database = 1;
                        {
                            var error = $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.GoogleCloudSqlPostgresqlConfigProto.verify(message.googleCloudSqlPostgresqlConfig);
                            if (error)
                                return "googleCloudSqlPostgresqlConfig." + error;
                        }
                    }
                    if (message.firestoreConfig != null && message.hasOwnProperty("firestoreConfig")) {
                        if (properties.database === 1)
                            return "database: multiple values";
                        properties.database = 1;
                        {
                            var error = $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreConfigProto.verify(message.firestoreConfig);
                            if (error)
                                return "firestoreConfig." + error;
                        }
                    }
                    if (message.firestoreEmulatorConfig != null && message.hasOwnProperty("firestoreEmulatorConfig")) {
                        if (properties.database === 1)
                            return "database: multiple values";
                        properties.database = 1;
                        {
                            var error = $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreEmulatorConfigProto.verify(message.firestoreEmulatorConfig);
                            if (error)
                                return "firestoreEmulatorConfig." + error;
                        }
                    }
                    if (message.spannerConfig != null && message.hasOwnProperty("spannerConfig")) {
                        if (properties.database === 1)
                            return "database: multiple values";
                        properties.database = 1;
                        {
                            var error = $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.SpannerConfigProto.verify(message.spannerConfig);
                            if (error)
                                return "spannerConfig." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a DatabaseConfigProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto} DatabaseConfigProto
                 */
                DatabaseConfigProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto)
                        return object;
                    var message = new $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto();
                    if (object.hsqlConfig != null) {
                        if (typeof object.hsqlConfig !== "object")
                            throw TypeError(".waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.hsqlConfig: object expected");
                        message.hsqlConfig = $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.HsqlConfigProto.fromObject(object.hsqlConfig);
                    }
                    if (object.postgresqlConfig != null) {
                        if (typeof object.postgresqlConfig !== "object")
                            throw TypeError(".waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.postgresqlConfig: object expected");
                        message.postgresqlConfig = $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.PostgresqlConfigProto.fromObject(object.postgresqlConfig);
                    }
                    if (object.googleCloudSqlPostgresqlConfig != null) {
                        if (typeof object.googleCloudSqlPostgresqlConfig !== "object")
                            throw TypeError(".waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.googleCloudSqlPostgresqlConfig: object expected");
                        message.googleCloudSqlPostgresqlConfig = $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.GoogleCloudSqlPostgresqlConfigProto.fromObject(object.googleCloudSqlPostgresqlConfig);
                    }
                    if (object.firestoreConfig != null) {
                        if (typeof object.firestoreConfig !== "object")
                            throw TypeError(".waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.firestoreConfig: object expected");
                        message.firestoreConfig = $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreConfigProto.fromObject(object.firestoreConfig);
                    }
                    if (object.firestoreEmulatorConfig != null) {
                        if (typeof object.firestoreEmulatorConfig !== "object")
                            throw TypeError(".waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.firestoreEmulatorConfig: object expected");
                        message.firestoreEmulatorConfig = $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreEmulatorConfigProto.fromObject(object.firestoreEmulatorConfig);
                    }
                    if (object.spannerConfig != null) {
                        if (typeof object.spannerConfig !== "object")
                            throw TypeError(".waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.spannerConfig: object expected");
                        message.spannerConfig = $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.SpannerConfigProto.fromObject(object.spannerConfig);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a DatabaseConfigProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto
                 * @static
                 * @param {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto} message DatabaseConfigProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                DatabaseConfigProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (message.hsqlConfig != null && message.hasOwnProperty("hsqlConfig")) {
                        object.hsqlConfig = $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.HsqlConfigProto.toObject(message.hsqlConfig, options);
                        if (options.oneofs)
                            object.database = "hsqlConfig";
                    }
                    if (message.postgresqlConfig != null && message.hasOwnProperty("postgresqlConfig")) {
                        object.postgresqlConfig = $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.PostgresqlConfigProto.toObject(message.postgresqlConfig, options);
                        if (options.oneofs)
                            object.database = "postgresqlConfig";
                    }
                    if (message.googleCloudSqlPostgresqlConfig != null && message.hasOwnProperty("googleCloudSqlPostgresqlConfig")) {
                        object.googleCloudSqlPostgresqlConfig = $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.GoogleCloudSqlPostgresqlConfigProto.toObject(message.googleCloudSqlPostgresqlConfig, options);
                        if (options.oneofs)
                            object.database = "googleCloudSqlPostgresqlConfig";
                    }
                    if (message.firestoreConfig != null && message.hasOwnProperty("firestoreConfig")) {
                        object.firestoreConfig = $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreConfigProto.toObject(message.firestoreConfig, options);
                        if (options.oneofs)
                            object.database = "firestoreConfig";
                    }
                    if (message.firestoreEmulatorConfig != null && message.hasOwnProperty("firestoreEmulatorConfig")) {
                        object.firestoreEmulatorConfig = $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreEmulatorConfigProto.toObject(message.firestoreEmulatorConfig, options);
                        if (options.oneofs)
                            object.database = "firestoreEmulatorConfig";
                    }
                    if (message.spannerConfig != null && message.hasOwnProperty("spannerConfig")) {
                        object.spannerConfig = $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.SpannerConfigProto.toObject(message.spannerConfig, options);
                        if (options.oneofs)
                            object.database = "spannerConfig";
                    }
                    return object;
                };

                /**
                 * Converts this DatabaseConfigProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                DatabaseConfigProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for DatabaseConfigProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                DatabaseConfigProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto";
                };

                DatabaseConfigProto.HsqlConfigProto = (function() {

                    /**
                     * Properties of a HsqlConfigProto.
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto
                     * @interface IHsqlConfigProto
                     * @property {boolean|null} [dropDatabaseOnStart] HsqlConfigProto dropDatabaseOnStart
                     */

                    /**
                     * Constructs a new HsqlConfigProto.
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto
                     * @classdesc Represents a HsqlConfigProto.
                     * @implements IHsqlConfigProto
                     * @constructor
                     * @param {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.IHsqlConfigProto=} [properties] Properties to set
                     */
                    function HsqlConfigProto(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * HsqlConfigProto dropDatabaseOnStart.
                     * @member {boolean} dropDatabaseOnStart
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.HsqlConfigProto
                     * @instance
                     */
                    HsqlConfigProto.prototype.dropDatabaseOnStart = false;

                    /**
                     * Creates a new HsqlConfigProto instance using the specified properties.
                     * @function create
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.HsqlConfigProto
                     * @static
                     * @param {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.IHsqlConfigProto=} [properties] Properties to set
                     * @returns {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.HsqlConfigProto} HsqlConfigProto instance
                     */
                    HsqlConfigProto.create = function create(properties) {
                        return new HsqlConfigProto(properties);
                    };

                    /**
                     * Encodes the specified HsqlConfigProto message. Does not implicitly {@link waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.HsqlConfigProto.verify|verify} messages.
                     * @function encode
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.HsqlConfigProto
                     * @static
                     * @param {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.IHsqlConfigProto} message HsqlConfigProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    HsqlConfigProto.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.dropDatabaseOnStart != null && Object.hasOwnProperty.call(message, "dropDatabaseOnStart"))
                            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.dropDatabaseOnStart);
                        return writer;
                    };

                    /**
                     * Encodes the specified HsqlConfigProto message, length delimited. Does not implicitly {@link waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.HsqlConfigProto.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.HsqlConfigProto
                     * @static
                     * @param {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.IHsqlConfigProto} message HsqlConfigProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    HsqlConfigProto.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a HsqlConfigProto message from the specified reader or buffer.
                     * @function decode
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.HsqlConfigProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.HsqlConfigProto} HsqlConfigProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    HsqlConfigProto.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.HsqlConfigProto();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.dropDatabaseOnStart = reader.bool();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a HsqlConfigProto message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.HsqlConfigProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.HsqlConfigProto} HsqlConfigProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    HsqlConfigProto.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a HsqlConfigProto message.
                     * @function verify
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.HsqlConfigProto
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    HsqlConfigProto.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.dropDatabaseOnStart != null && message.hasOwnProperty("dropDatabaseOnStart"))
                            if (typeof message.dropDatabaseOnStart !== "boolean")
                                return "dropDatabaseOnStart: boolean expected";
                        return null;
                    };

                    /**
                     * Creates a HsqlConfigProto message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.HsqlConfigProto
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.HsqlConfigProto} HsqlConfigProto
                     */
                    HsqlConfigProto.fromObject = function fromObject(object) {
                        if (object instanceof $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.HsqlConfigProto)
                            return object;
                        var message = new $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.HsqlConfigProto();
                        if (object.dropDatabaseOnStart != null)
                            message.dropDatabaseOnStart = Boolean(object.dropDatabaseOnStart);
                        return message;
                    };

                    /**
                     * Creates a plain object from a HsqlConfigProto message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.HsqlConfigProto
                     * @static
                     * @param {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.HsqlConfigProto} message HsqlConfigProto
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    HsqlConfigProto.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.dropDatabaseOnStart = false;
                        if (message.dropDatabaseOnStart != null && message.hasOwnProperty("dropDatabaseOnStart"))
                            object.dropDatabaseOnStart = message.dropDatabaseOnStart;
                        return object;
                    };

                    /**
                     * Converts this HsqlConfigProto to JSON.
                     * @function toJSON
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.HsqlConfigProto
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    HsqlConfigProto.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for HsqlConfigProto
                     * @function getTypeUrl
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.HsqlConfigProto
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    HsqlConfigProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.HsqlConfigProto";
                    };

                    return HsqlConfigProto;
                })();

                DatabaseConfigProto.PostgresqlConfigProto = (function() {

                    /**
                     * Properties of a PostgresqlConfigProto.
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto
                     * @interface IPostgresqlConfigProto
                     * @property {string|null} [databaseUrl] PostgresqlConfigProto databaseUrl
                     * @property {string|null} [user] PostgresqlConfigProto user
                     * @property {string|null} [encryptedPassword] PostgresqlConfigProto encryptedPassword
                     */

                    /**
                     * Constructs a new PostgresqlConfigProto.
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto
                     * @classdesc Represents a PostgresqlConfigProto.
                     * @implements IPostgresqlConfigProto
                     * @constructor
                     * @param {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.IPostgresqlConfigProto=} [properties] Properties to set
                     */
                    function PostgresqlConfigProto(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * PostgresqlConfigProto databaseUrl.
                     * @member {string} databaseUrl
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.PostgresqlConfigProto
                     * @instance
                     */
                    PostgresqlConfigProto.prototype.databaseUrl = "";

                    /**
                     * PostgresqlConfigProto user.
                     * @member {string} user
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.PostgresqlConfigProto
                     * @instance
                     */
                    PostgresqlConfigProto.prototype.user = "";

                    /**
                     * PostgresqlConfigProto encryptedPassword.
                     * @member {string} encryptedPassword
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.PostgresqlConfigProto
                     * @instance
                     */
                    PostgresqlConfigProto.prototype.encryptedPassword = "";

                    /**
                     * Creates a new PostgresqlConfigProto instance using the specified properties.
                     * @function create
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.PostgresqlConfigProto
                     * @static
                     * @param {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.IPostgresqlConfigProto=} [properties] Properties to set
                     * @returns {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.PostgresqlConfigProto} PostgresqlConfigProto instance
                     */
                    PostgresqlConfigProto.create = function create(properties) {
                        return new PostgresqlConfigProto(properties);
                    };

                    /**
                     * Encodes the specified PostgresqlConfigProto message. Does not implicitly {@link waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.PostgresqlConfigProto.verify|verify} messages.
                     * @function encode
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.PostgresqlConfigProto
                     * @static
                     * @param {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.IPostgresqlConfigProto} message PostgresqlConfigProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PostgresqlConfigProto.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.databaseUrl != null && Object.hasOwnProperty.call(message, "databaseUrl"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.databaseUrl);
                        if (message.user != null && Object.hasOwnProperty.call(message, "user"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.user);
                        if (message.encryptedPassword != null && Object.hasOwnProperty.call(message, "encryptedPassword"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.encryptedPassword);
                        return writer;
                    };

                    /**
                     * Encodes the specified PostgresqlConfigProto message, length delimited. Does not implicitly {@link waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.PostgresqlConfigProto.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.PostgresqlConfigProto
                     * @static
                     * @param {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.IPostgresqlConfigProto} message PostgresqlConfigProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PostgresqlConfigProto.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a PostgresqlConfigProto message from the specified reader or buffer.
                     * @function decode
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.PostgresqlConfigProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.PostgresqlConfigProto} PostgresqlConfigProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PostgresqlConfigProto.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.PostgresqlConfigProto();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.databaseUrl = reader.string();
                                    break;
                                }
                            case 2: {
                                    message.user = reader.string();
                                    break;
                                }
                            case 3: {
                                    message.encryptedPassword = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a PostgresqlConfigProto message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.PostgresqlConfigProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.PostgresqlConfigProto} PostgresqlConfigProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PostgresqlConfigProto.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a PostgresqlConfigProto message.
                     * @function verify
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.PostgresqlConfigProto
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PostgresqlConfigProto.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.databaseUrl != null && message.hasOwnProperty("databaseUrl"))
                            if (!$util.isString(message.databaseUrl))
                                return "databaseUrl: string expected";
                        if (message.user != null && message.hasOwnProperty("user"))
                            if (!$util.isString(message.user))
                                return "user: string expected";
                        if (message.encryptedPassword != null && message.hasOwnProperty("encryptedPassword"))
                            if (!$util.isString(message.encryptedPassword))
                                return "encryptedPassword: string expected";
                        return null;
                    };

                    /**
                     * Creates a PostgresqlConfigProto message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.PostgresqlConfigProto
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.PostgresqlConfigProto} PostgresqlConfigProto
                     */
                    PostgresqlConfigProto.fromObject = function fromObject(object) {
                        if (object instanceof $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.PostgresqlConfigProto)
                            return object;
                        var message = new $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.PostgresqlConfigProto();
                        if (object.databaseUrl != null)
                            message.databaseUrl = String(object.databaseUrl);
                        if (object.user != null)
                            message.user = String(object.user);
                        if (object.encryptedPassword != null)
                            message.encryptedPassword = String(object.encryptedPassword);
                        return message;
                    };

                    /**
                     * Creates a plain object from a PostgresqlConfigProto message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.PostgresqlConfigProto
                     * @static
                     * @param {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.PostgresqlConfigProto} message PostgresqlConfigProto
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PostgresqlConfigProto.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.databaseUrl = "";
                            object.user = "";
                            object.encryptedPassword = "";
                        }
                        if (message.databaseUrl != null && message.hasOwnProperty("databaseUrl"))
                            object.databaseUrl = message.databaseUrl;
                        if (message.user != null && message.hasOwnProperty("user"))
                            object.user = message.user;
                        if (message.encryptedPassword != null && message.hasOwnProperty("encryptedPassword"))
                            object.encryptedPassword = message.encryptedPassword;
                        return object;
                    };

                    /**
                     * Converts this PostgresqlConfigProto to JSON.
                     * @function toJSON
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.PostgresqlConfigProto
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PostgresqlConfigProto.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for PostgresqlConfigProto
                     * @function getTypeUrl
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.PostgresqlConfigProto
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    PostgresqlConfigProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.PostgresqlConfigProto";
                    };

                    return PostgresqlConfigProto;
                })();

                DatabaseConfigProto.GoogleCloudSqlPostgresqlConfigProto = (function() {

                    /**
                     * Properties of a GoogleCloudSqlPostgresqlConfigProto.
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto
                     * @interface IGoogleCloudSqlPostgresqlConfigProto
                     * @property {string|null} [cloudSqlConnectionName] GoogleCloudSqlPostgresqlConfigProto cloudSqlConnectionName
                     * @property {string|null} [databaseName] GoogleCloudSqlPostgresqlConfigProto databaseName
                     * @property {string|null} [user] GoogleCloudSqlPostgresqlConfigProto user
                     * @property {string|null} [encryptedPassword] GoogleCloudSqlPostgresqlConfigProto encryptedPassword
                     */

                    /**
                     * Constructs a new GoogleCloudSqlPostgresqlConfigProto.
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto
                     * @classdesc Represents a GoogleCloudSqlPostgresqlConfigProto.
                     * @implements IGoogleCloudSqlPostgresqlConfigProto
                     * @constructor
                     * @param {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.IGoogleCloudSqlPostgresqlConfigProto=} [properties] Properties to set
                     */
                    function GoogleCloudSqlPostgresqlConfigProto(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * GoogleCloudSqlPostgresqlConfigProto cloudSqlConnectionName.
                     * @member {string} cloudSqlConnectionName
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.GoogleCloudSqlPostgresqlConfigProto
                     * @instance
                     */
                    GoogleCloudSqlPostgresqlConfigProto.prototype.cloudSqlConnectionName = "";

                    /**
                     * GoogleCloudSqlPostgresqlConfigProto databaseName.
                     * @member {string} databaseName
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.GoogleCloudSqlPostgresqlConfigProto
                     * @instance
                     */
                    GoogleCloudSqlPostgresqlConfigProto.prototype.databaseName = "";

                    /**
                     * GoogleCloudSqlPostgresqlConfigProto user.
                     * @member {string} user
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.GoogleCloudSqlPostgresqlConfigProto
                     * @instance
                     */
                    GoogleCloudSqlPostgresqlConfigProto.prototype.user = "";

                    /**
                     * GoogleCloudSqlPostgresqlConfigProto encryptedPassword.
                     * @member {string} encryptedPassword
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.GoogleCloudSqlPostgresqlConfigProto
                     * @instance
                     */
                    GoogleCloudSqlPostgresqlConfigProto.prototype.encryptedPassword = "";

                    /**
                     * Creates a new GoogleCloudSqlPostgresqlConfigProto instance using the specified properties.
                     * @function create
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.GoogleCloudSqlPostgresqlConfigProto
                     * @static
                     * @param {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.IGoogleCloudSqlPostgresqlConfigProto=} [properties] Properties to set
                     * @returns {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.GoogleCloudSqlPostgresqlConfigProto} GoogleCloudSqlPostgresqlConfigProto instance
                     */
                    GoogleCloudSqlPostgresqlConfigProto.create = function create(properties) {
                        return new GoogleCloudSqlPostgresqlConfigProto(properties);
                    };

                    /**
                     * Encodes the specified GoogleCloudSqlPostgresqlConfigProto message. Does not implicitly {@link waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.GoogleCloudSqlPostgresqlConfigProto.verify|verify} messages.
                     * @function encode
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.GoogleCloudSqlPostgresqlConfigProto
                     * @static
                     * @param {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.IGoogleCloudSqlPostgresqlConfigProto} message GoogleCloudSqlPostgresqlConfigProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GoogleCloudSqlPostgresqlConfigProto.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.cloudSqlConnectionName != null && Object.hasOwnProperty.call(message, "cloudSqlConnectionName"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.cloudSqlConnectionName);
                        if (message.databaseName != null && Object.hasOwnProperty.call(message, "databaseName"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.databaseName);
                        if (message.user != null && Object.hasOwnProperty.call(message, "user"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.user);
                        if (message.encryptedPassword != null && Object.hasOwnProperty.call(message, "encryptedPassword"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.encryptedPassword);
                        return writer;
                    };

                    /**
                     * Encodes the specified GoogleCloudSqlPostgresqlConfigProto message, length delimited. Does not implicitly {@link waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.GoogleCloudSqlPostgresqlConfigProto.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.GoogleCloudSqlPostgresqlConfigProto
                     * @static
                     * @param {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.IGoogleCloudSqlPostgresqlConfigProto} message GoogleCloudSqlPostgresqlConfigProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GoogleCloudSqlPostgresqlConfigProto.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a GoogleCloudSqlPostgresqlConfigProto message from the specified reader or buffer.
                     * @function decode
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.GoogleCloudSqlPostgresqlConfigProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.GoogleCloudSqlPostgresqlConfigProto} GoogleCloudSqlPostgresqlConfigProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GoogleCloudSqlPostgresqlConfigProto.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.GoogleCloudSqlPostgresqlConfigProto();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.cloudSqlConnectionName = reader.string();
                                    break;
                                }
                            case 2: {
                                    message.databaseName = reader.string();
                                    break;
                                }
                            case 3: {
                                    message.user = reader.string();
                                    break;
                                }
                            case 4: {
                                    message.encryptedPassword = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a GoogleCloudSqlPostgresqlConfigProto message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.GoogleCloudSqlPostgresqlConfigProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.GoogleCloudSqlPostgresqlConfigProto} GoogleCloudSqlPostgresqlConfigProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GoogleCloudSqlPostgresqlConfigProto.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a GoogleCloudSqlPostgresqlConfigProto message.
                     * @function verify
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.GoogleCloudSqlPostgresqlConfigProto
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GoogleCloudSqlPostgresqlConfigProto.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.cloudSqlConnectionName != null && message.hasOwnProperty("cloudSqlConnectionName"))
                            if (!$util.isString(message.cloudSqlConnectionName))
                                return "cloudSqlConnectionName: string expected";
                        if (message.databaseName != null && message.hasOwnProperty("databaseName"))
                            if (!$util.isString(message.databaseName))
                                return "databaseName: string expected";
                        if (message.user != null && message.hasOwnProperty("user"))
                            if (!$util.isString(message.user))
                                return "user: string expected";
                        if (message.encryptedPassword != null && message.hasOwnProperty("encryptedPassword"))
                            if (!$util.isString(message.encryptedPassword))
                                return "encryptedPassword: string expected";
                        return null;
                    };

                    /**
                     * Creates a GoogleCloudSqlPostgresqlConfigProto message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.GoogleCloudSqlPostgresqlConfigProto
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.GoogleCloudSqlPostgresqlConfigProto} GoogleCloudSqlPostgresqlConfigProto
                     */
                    GoogleCloudSqlPostgresqlConfigProto.fromObject = function fromObject(object) {
                        if (object instanceof $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.GoogleCloudSqlPostgresqlConfigProto)
                            return object;
                        var message = new $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.GoogleCloudSqlPostgresqlConfigProto();
                        if (object.cloudSqlConnectionName != null)
                            message.cloudSqlConnectionName = String(object.cloudSqlConnectionName);
                        if (object.databaseName != null)
                            message.databaseName = String(object.databaseName);
                        if (object.user != null)
                            message.user = String(object.user);
                        if (object.encryptedPassword != null)
                            message.encryptedPassword = String(object.encryptedPassword);
                        return message;
                    };

                    /**
                     * Creates a plain object from a GoogleCloudSqlPostgresqlConfigProto message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.GoogleCloudSqlPostgresqlConfigProto
                     * @static
                     * @param {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.GoogleCloudSqlPostgresqlConfigProto} message GoogleCloudSqlPostgresqlConfigProto
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GoogleCloudSqlPostgresqlConfigProto.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.cloudSqlConnectionName = "";
                            object.databaseName = "";
                            object.user = "";
                            object.encryptedPassword = "";
                        }
                        if (message.cloudSqlConnectionName != null && message.hasOwnProperty("cloudSqlConnectionName"))
                            object.cloudSqlConnectionName = message.cloudSqlConnectionName;
                        if (message.databaseName != null && message.hasOwnProperty("databaseName"))
                            object.databaseName = message.databaseName;
                        if (message.user != null && message.hasOwnProperty("user"))
                            object.user = message.user;
                        if (message.encryptedPassword != null && message.hasOwnProperty("encryptedPassword"))
                            object.encryptedPassword = message.encryptedPassword;
                        return object;
                    };

                    /**
                     * Converts this GoogleCloudSqlPostgresqlConfigProto to JSON.
                     * @function toJSON
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.GoogleCloudSqlPostgresqlConfigProto
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GoogleCloudSqlPostgresqlConfigProto.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for GoogleCloudSqlPostgresqlConfigProto
                     * @function getTypeUrl
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.GoogleCloudSqlPostgresqlConfigProto
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    GoogleCloudSqlPostgresqlConfigProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.GoogleCloudSqlPostgresqlConfigProto";
                    };

                    return GoogleCloudSqlPostgresqlConfigProto;
                })();

                DatabaseConfigProto.FirestoreEmulatorConfigProto = (function() {

                    /**
                     * Properties of a FirestoreEmulatorConfigProto.
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto
                     * @interface IFirestoreEmulatorConfigProto
                     */

                    /**
                     * Constructs a new FirestoreEmulatorConfigProto.
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto
                     * @classdesc Represents a FirestoreEmulatorConfigProto.
                     * @implements IFirestoreEmulatorConfigProto
                     * @constructor
                     * @param {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.IFirestoreEmulatorConfigProto=} [properties] Properties to set
                     */
                    function FirestoreEmulatorConfigProto(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Creates a new FirestoreEmulatorConfigProto instance using the specified properties.
                     * @function create
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreEmulatorConfigProto
                     * @static
                     * @param {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.IFirestoreEmulatorConfigProto=} [properties] Properties to set
                     * @returns {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreEmulatorConfigProto} FirestoreEmulatorConfigProto instance
                     */
                    FirestoreEmulatorConfigProto.create = function create(properties) {
                        return new FirestoreEmulatorConfigProto(properties);
                    };

                    /**
                     * Encodes the specified FirestoreEmulatorConfigProto message. Does not implicitly {@link waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreEmulatorConfigProto.verify|verify} messages.
                     * @function encode
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreEmulatorConfigProto
                     * @static
                     * @param {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.IFirestoreEmulatorConfigProto} message FirestoreEmulatorConfigProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FirestoreEmulatorConfigProto.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };

                    /**
                     * Encodes the specified FirestoreEmulatorConfigProto message, length delimited. Does not implicitly {@link waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreEmulatorConfigProto.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreEmulatorConfigProto
                     * @static
                     * @param {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.IFirestoreEmulatorConfigProto} message FirestoreEmulatorConfigProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FirestoreEmulatorConfigProto.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a FirestoreEmulatorConfigProto message from the specified reader or buffer.
                     * @function decode
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreEmulatorConfigProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreEmulatorConfigProto} FirestoreEmulatorConfigProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FirestoreEmulatorConfigProto.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreEmulatorConfigProto();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a FirestoreEmulatorConfigProto message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreEmulatorConfigProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreEmulatorConfigProto} FirestoreEmulatorConfigProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FirestoreEmulatorConfigProto.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a FirestoreEmulatorConfigProto message.
                     * @function verify
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreEmulatorConfigProto
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FirestoreEmulatorConfigProto.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };

                    /**
                     * Creates a FirestoreEmulatorConfigProto message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreEmulatorConfigProto
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreEmulatorConfigProto} FirestoreEmulatorConfigProto
                     */
                    FirestoreEmulatorConfigProto.fromObject = function fromObject(object) {
                        if (object instanceof $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreEmulatorConfigProto)
                            return object;
                        return new $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreEmulatorConfigProto();
                    };

                    /**
                     * Creates a plain object from a FirestoreEmulatorConfigProto message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreEmulatorConfigProto
                     * @static
                     * @param {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreEmulatorConfigProto} message FirestoreEmulatorConfigProto
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FirestoreEmulatorConfigProto.toObject = function toObject() {
                        return {};
                    };

                    /**
                     * Converts this FirestoreEmulatorConfigProto to JSON.
                     * @function toJSON
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreEmulatorConfigProto
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FirestoreEmulatorConfigProto.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for FirestoreEmulatorConfigProto
                     * @function getTypeUrl
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreEmulatorConfigProto
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    FirestoreEmulatorConfigProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreEmulatorConfigProto";
                    };

                    return FirestoreEmulatorConfigProto;
                })();

                DatabaseConfigProto.FirestoreConfigProto = (function() {

                    /**
                     * Properties of a FirestoreConfigProto.
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto
                     * @interface IFirestoreConfigProto
                     * @property {string|null} [projectId] FirestoreConfigProto projectId
                     */

                    /**
                     * Constructs a new FirestoreConfigProto.
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto
                     * @classdesc Represents a FirestoreConfigProto.
                     * @implements IFirestoreConfigProto
                     * @constructor
                     * @param {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.IFirestoreConfigProto=} [properties] Properties to set
                     */
                    function FirestoreConfigProto(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * FirestoreConfigProto projectId.
                     * @member {string} projectId
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreConfigProto
                     * @instance
                     */
                    FirestoreConfigProto.prototype.projectId = "";

                    /**
                     * Creates a new FirestoreConfigProto instance using the specified properties.
                     * @function create
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreConfigProto
                     * @static
                     * @param {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.IFirestoreConfigProto=} [properties] Properties to set
                     * @returns {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreConfigProto} FirestoreConfigProto instance
                     */
                    FirestoreConfigProto.create = function create(properties) {
                        return new FirestoreConfigProto(properties);
                    };

                    /**
                     * Encodes the specified FirestoreConfigProto message. Does not implicitly {@link waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreConfigProto.verify|verify} messages.
                     * @function encode
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreConfigProto
                     * @static
                     * @param {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.IFirestoreConfigProto} message FirestoreConfigProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FirestoreConfigProto.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.projectId != null && Object.hasOwnProperty.call(message, "projectId"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.projectId);
                        return writer;
                    };

                    /**
                     * Encodes the specified FirestoreConfigProto message, length delimited. Does not implicitly {@link waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreConfigProto.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreConfigProto
                     * @static
                     * @param {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.IFirestoreConfigProto} message FirestoreConfigProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FirestoreConfigProto.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a FirestoreConfigProto message from the specified reader or buffer.
                     * @function decode
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreConfigProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreConfigProto} FirestoreConfigProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FirestoreConfigProto.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreConfigProto();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.projectId = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a FirestoreConfigProto message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreConfigProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreConfigProto} FirestoreConfigProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FirestoreConfigProto.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a FirestoreConfigProto message.
                     * @function verify
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreConfigProto
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FirestoreConfigProto.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (!$util.isString(message.projectId))
                                return "projectId: string expected";
                        return null;
                    };

                    /**
                     * Creates a FirestoreConfigProto message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreConfigProto
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreConfigProto} FirestoreConfigProto
                     */
                    FirestoreConfigProto.fromObject = function fromObject(object) {
                        if (object instanceof $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreConfigProto)
                            return object;
                        var message = new $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreConfigProto();
                        if (object.projectId != null)
                            message.projectId = String(object.projectId);
                        return message;
                    };

                    /**
                     * Creates a plain object from a FirestoreConfigProto message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreConfigProto
                     * @static
                     * @param {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreConfigProto} message FirestoreConfigProto
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FirestoreConfigProto.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.projectId = "";
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            object.projectId = message.projectId;
                        return object;
                    };

                    /**
                     * Converts this FirestoreConfigProto to JSON.
                     * @function toJSON
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreConfigProto
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FirestoreConfigProto.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for FirestoreConfigProto
                     * @function getTypeUrl
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreConfigProto
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    FirestoreConfigProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.FirestoreConfigProto";
                    };

                    return FirestoreConfigProto;
                })();

                DatabaseConfigProto.SpannerConfigProto = (function() {

                    /**
                     * Properties of a SpannerConfigProto.
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto
                     * @interface ISpannerConfigProto
                     * @property {string|null} [databaseUrl] SpannerConfigProto databaseUrl
                     * @property {string|null} [user] SpannerConfigProto user
                     * @property {string|null} [encryptedPassword] SpannerConfigProto encryptedPassword
                     */

                    /**
                     * Constructs a new SpannerConfigProto.
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto
                     * @classdesc Represents a SpannerConfigProto.
                     * @implements ISpannerConfigProto
                     * @constructor
                     * @param {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.ISpannerConfigProto=} [properties] Properties to set
                     */
                    function SpannerConfigProto(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * SpannerConfigProto databaseUrl.
                     * @member {string} databaseUrl
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.SpannerConfigProto
                     * @instance
                     */
                    SpannerConfigProto.prototype.databaseUrl = "";

                    /**
                     * SpannerConfigProto user.
                     * @member {string} user
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.SpannerConfigProto
                     * @instance
                     */
                    SpannerConfigProto.prototype.user = "";

                    /**
                     * SpannerConfigProto encryptedPassword.
                     * @member {string} encryptedPassword
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.SpannerConfigProto
                     * @instance
                     */
                    SpannerConfigProto.prototype.encryptedPassword = "";

                    /**
                     * Creates a new SpannerConfigProto instance using the specified properties.
                     * @function create
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.SpannerConfigProto
                     * @static
                     * @param {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.ISpannerConfigProto=} [properties] Properties to set
                     * @returns {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.SpannerConfigProto} SpannerConfigProto instance
                     */
                    SpannerConfigProto.create = function create(properties) {
                        return new SpannerConfigProto(properties);
                    };

                    /**
                     * Encodes the specified SpannerConfigProto message. Does not implicitly {@link waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.SpannerConfigProto.verify|verify} messages.
                     * @function encode
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.SpannerConfigProto
                     * @static
                     * @param {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.ISpannerConfigProto} message SpannerConfigProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SpannerConfigProto.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.databaseUrl != null && Object.hasOwnProperty.call(message, "databaseUrl"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.databaseUrl);
                        if (message.user != null && Object.hasOwnProperty.call(message, "user"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.user);
                        if (message.encryptedPassword != null && Object.hasOwnProperty.call(message, "encryptedPassword"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.encryptedPassword);
                        return writer;
                    };

                    /**
                     * Encodes the specified SpannerConfigProto message, length delimited. Does not implicitly {@link waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.SpannerConfigProto.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.SpannerConfigProto
                     * @static
                     * @param {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.ISpannerConfigProto} message SpannerConfigProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SpannerConfigProto.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a SpannerConfigProto message from the specified reader or buffer.
                     * @function decode
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.SpannerConfigProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.SpannerConfigProto} SpannerConfigProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SpannerConfigProto.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.SpannerConfigProto();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.databaseUrl = reader.string();
                                    break;
                                }
                            case 2: {
                                    message.user = reader.string();
                                    break;
                                }
                            case 3: {
                                    message.encryptedPassword = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a SpannerConfigProto message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.SpannerConfigProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.SpannerConfigProto} SpannerConfigProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SpannerConfigProto.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a SpannerConfigProto message.
                     * @function verify
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.SpannerConfigProto
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SpannerConfigProto.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.databaseUrl != null && message.hasOwnProperty("databaseUrl"))
                            if (!$util.isString(message.databaseUrl))
                                return "databaseUrl: string expected";
                        if (message.user != null && message.hasOwnProperty("user"))
                            if (!$util.isString(message.user))
                                return "user: string expected";
                        if (message.encryptedPassword != null && message.hasOwnProperty("encryptedPassword"))
                            if (!$util.isString(message.encryptedPassword))
                                return "encryptedPassword: string expected";
                        return null;
                    };

                    /**
                     * Creates a SpannerConfigProto message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.SpannerConfigProto
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.SpannerConfigProto} SpannerConfigProto
                     */
                    SpannerConfigProto.fromObject = function fromObject(object) {
                        if (object instanceof $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.SpannerConfigProto)
                            return object;
                        var message = new $root.waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.SpannerConfigProto();
                        if (object.databaseUrl != null)
                            message.databaseUrl = String(object.databaseUrl);
                        if (object.user != null)
                            message.user = String(object.user);
                        if (object.encryptedPassword != null)
                            message.encryptedPassword = String(object.encryptedPassword);
                        return message;
                    };

                    /**
                     * Creates a plain object from a SpannerConfigProto message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.SpannerConfigProto
                     * @static
                     * @param {waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.SpannerConfigProto} message SpannerConfigProto
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SpannerConfigProto.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.databaseUrl = "";
                            object.user = "";
                            object.encryptedPassword = "";
                        }
                        if (message.databaseUrl != null && message.hasOwnProperty("databaseUrl"))
                            object.databaseUrl = message.databaseUrl;
                        if (message.user != null && message.hasOwnProperty("user"))
                            object.user = message.user;
                        if (message.encryptedPassword != null && message.hasOwnProperty("encryptedPassword"))
                            object.encryptedPassword = message.encryptedPassword;
                        return object;
                    };

                    /**
                     * Converts this SpannerConfigProto to JSON.
                     * @function toJSON
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.SpannerConfigProto
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SpannerConfigProto.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for SpannerConfigProto
                     * @function getTypeUrl
                     * @memberof waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.SpannerConfigProto
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    SpannerConfigProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/waiternow.common.PersistenceLayerConfigProto.DatabaseConfigProto.SpannerConfigProto";
                    };

                    return SpannerConfigProto;
                })();

                return DatabaseConfigProto;
            })();

            return PersistenceLayerConfigProto;
        })();

        common.StorageLayerConfigProto = (function() {

            /**
             * Properties of a StorageLayerConfigProto.
             * @memberof waiternow.common
             * @interface IStorageLayerConfigProto
             * @property {waiternow.common.StorageLayerConfigProto.IStorageConfigProto|null} [storageConfig] StorageLayerConfigProto storageConfig
             */

            /**
             * Constructs a new StorageLayerConfigProto.
             * @memberof waiternow.common
             * @classdesc Represents a StorageLayerConfigProto.
             * @implements IStorageLayerConfigProto
             * @constructor
             * @param {waiternow.common.IStorageLayerConfigProto=} [properties] Properties to set
             */
            function StorageLayerConfigProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * StorageLayerConfigProto storageConfig.
             * @member {waiternow.common.StorageLayerConfigProto.IStorageConfigProto|null|undefined} storageConfig
             * @memberof waiternow.common.StorageLayerConfigProto
             * @instance
             */
            StorageLayerConfigProto.prototype.storageConfig = null;

            /**
             * Creates a new StorageLayerConfigProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.StorageLayerConfigProto
             * @static
             * @param {waiternow.common.IStorageLayerConfigProto=} [properties] Properties to set
             * @returns {waiternow.common.StorageLayerConfigProto} StorageLayerConfigProto instance
             */
            StorageLayerConfigProto.create = function create(properties) {
                return new StorageLayerConfigProto(properties);
            };

            /**
             * Encodes the specified StorageLayerConfigProto message. Does not implicitly {@link waiternow.common.StorageLayerConfigProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.StorageLayerConfigProto
             * @static
             * @param {waiternow.common.IStorageLayerConfigProto} message StorageLayerConfigProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StorageLayerConfigProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.storageConfig != null && Object.hasOwnProperty.call(message, "storageConfig"))
                    $root.waiternow.common.StorageLayerConfigProto.StorageConfigProto.encode(message.storageConfig, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified StorageLayerConfigProto message, length delimited. Does not implicitly {@link waiternow.common.StorageLayerConfigProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.StorageLayerConfigProto
             * @static
             * @param {waiternow.common.IStorageLayerConfigProto} message StorageLayerConfigProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StorageLayerConfigProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a StorageLayerConfigProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.StorageLayerConfigProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.StorageLayerConfigProto} StorageLayerConfigProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StorageLayerConfigProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.StorageLayerConfigProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.storageConfig = $root.waiternow.common.StorageLayerConfigProto.StorageConfigProto.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a StorageLayerConfigProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.StorageLayerConfigProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.StorageLayerConfigProto} StorageLayerConfigProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StorageLayerConfigProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a StorageLayerConfigProto message.
             * @function verify
             * @memberof waiternow.common.StorageLayerConfigProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            StorageLayerConfigProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.storageConfig != null && message.hasOwnProperty("storageConfig")) {
                    var error = $root.waiternow.common.StorageLayerConfigProto.StorageConfigProto.verify(message.storageConfig);
                    if (error)
                        return "storageConfig." + error;
                }
                return null;
            };

            /**
             * Creates a StorageLayerConfigProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.StorageLayerConfigProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.StorageLayerConfigProto} StorageLayerConfigProto
             */
            StorageLayerConfigProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.StorageLayerConfigProto)
                    return object;
                var message = new $root.waiternow.common.StorageLayerConfigProto();
                if (object.storageConfig != null) {
                    if (typeof object.storageConfig !== "object")
                        throw TypeError(".waiternow.common.StorageLayerConfigProto.storageConfig: object expected");
                    message.storageConfig = $root.waiternow.common.StorageLayerConfigProto.StorageConfigProto.fromObject(object.storageConfig);
                }
                return message;
            };

            /**
             * Creates a plain object from a StorageLayerConfigProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.StorageLayerConfigProto
             * @static
             * @param {waiternow.common.StorageLayerConfigProto} message StorageLayerConfigProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            StorageLayerConfigProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.storageConfig = null;
                if (message.storageConfig != null && message.hasOwnProperty("storageConfig"))
                    object.storageConfig = $root.waiternow.common.StorageLayerConfigProto.StorageConfigProto.toObject(message.storageConfig, options);
                return object;
            };

            /**
             * Converts this StorageLayerConfigProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.StorageLayerConfigProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            StorageLayerConfigProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for StorageLayerConfigProto
             * @function getTypeUrl
             * @memberof waiternow.common.StorageLayerConfigProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            StorageLayerConfigProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.StorageLayerConfigProto";
            };

            StorageLayerConfigProto.StorageConfigProto = (function() {

                /**
                 * Properties of a StorageConfigProto.
                 * @memberof waiternow.common.StorageLayerConfigProto
                 * @interface IStorageConfigProto
                 * @property {waiternow.common.StorageLayerConfigProto.StorageConfigProto.ITmpFileSystemConfigProto|null} [tmpFileSystemConfig] StorageConfigProto tmpFileSystemConfig
                 * @property {waiternow.common.StorageLayerConfigProto.StorageConfigProto.IGoogleCloudStorageConfigProto|null} [googleCloudStorageConfig] StorageConfigProto googleCloudStorageConfig
                 */

                /**
                 * Constructs a new StorageConfigProto.
                 * @memberof waiternow.common.StorageLayerConfigProto
                 * @classdesc Represents a StorageConfigProto.
                 * @implements IStorageConfigProto
                 * @constructor
                 * @param {waiternow.common.StorageLayerConfigProto.IStorageConfigProto=} [properties] Properties to set
                 */
                function StorageConfigProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StorageConfigProto tmpFileSystemConfig.
                 * @member {waiternow.common.StorageLayerConfigProto.StorageConfigProto.ITmpFileSystemConfigProto|null|undefined} tmpFileSystemConfig
                 * @memberof waiternow.common.StorageLayerConfigProto.StorageConfigProto
                 * @instance
                 */
                StorageConfigProto.prototype.tmpFileSystemConfig = null;

                /**
                 * StorageConfigProto googleCloudStorageConfig.
                 * @member {waiternow.common.StorageLayerConfigProto.StorageConfigProto.IGoogleCloudStorageConfigProto|null|undefined} googleCloudStorageConfig
                 * @memberof waiternow.common.StorageLayerConfigProto.StorageConfigProto
                 * @instance
                 */
                StorageConfigProto.prototype.googleCloudStorageConfig = null;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * StorageConfigProto storage.
                 * @member {"tmpFileSystemConfig"|"googleCloudStorageConfig"|undefined} storage
                 * @memberof waiternow.common.StorageLayerConfigProto.StorageConfigProto
                 * @instance
                 */
                Object.defineProperty(StorageConfigProto.prototype, "storage", {
                    get: $util.oneOfGetter($oneOfFields = ["tmpFileSystemConfig", "googleCloudStorageConfig"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new StorageConfigProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.StorageLayerConfigProto.StorageConfigProto
                 * @static
                 * @param {waiternow.common.StorageLayerConfigProto.IStorageConfigProto=} [properties] Properties to set
                 * @returns {waiternow.common.StorageLayerConfigProto.StorageConfigProto} StorageConfigProto instance
                 */
                StorageConfigProto.create = function create(properties) {
                    return new StorageConfigProto(properties);
                };

                /**
                 * Encodes the specified StorageConfigProto message. Does not implicitly {@link waiternow.common.StorageLayerConfigProto.StorageConfigProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.StorageLayerConfigProto.StorageConfigProto
                 * @static
                 * @param {waiternow.common.StorageLayerConfigProto.IStorageConfigProto} message StorageConfigProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StorageConfigProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.tmpFileSystemConfig != null && Object.hasOwnProperty.call(message, "tmpFileSystemConfig"))
                        $root.waiternow.common.StorageLayerConfigProto.StorageConfigProto.TmpFileSystemConfigProto.encode(message.tmpFileSystemConfig, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.googleCloudStorageConfig != null && Object.hasOwnProperty.call(message, "googleCloudStorageConfig"))
                        $root.waiternow.common.StorageLayerConfigProto.StorageConfigProto.GoogleCloudStorageConfigProto.encode(message.googleCloudStorageConfig, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified StorageConfigProto message, length delimited. Does not implicitly {@link waiternow.common.StorageLayerConfigProto.StorageConfigProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.StorageLayerConfigProto.StorageConfigProto
                 * @static
                 * @param {waiternow.common.StorageLayerConfigProto.IStorageConfigProto} message StorageConfigProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StorageConfigProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a StorageConfigProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.StorageLayerConfigProto.StorageConfigProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.StorageLayerConfigProto.StorageConfigProto} StorageConfigProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StorageConfigProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.StorageLayerConfigProto.StorageConfigProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.tmpFileSystemConfig = $root.waiternow.common.StorageLayerConfigProto.StorageConfigProto.TmpFileSystemConfigProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.googleCloudStorageConfig = $root.waiternow.common.StorageLayerConfigProto.StorageConfigProto.GoogleCloudStorageConfigProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a StorageConfigProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.StorageLayerConfigProto.StorageConfigProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.StorageLayerConfigProto.StorageConfigProto} StorageConfigProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StorageConfigProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StorageConfigProto message.
                 * @function verify
                 * @memberof waiternow.common.StorageLayerConfigProto.StorageConfigProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StorageConfigProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.tmpFileSystemConfig != null && message.hasOwnProperty("tmpFileSystemConfig")) {
                        properties.storage = 1;
                        {
                            var error = $root.waiternow.common.StorageLayerConfigProto.StorageConfigProto.TmpFileSystemConfigProto.verify(message.tmpFileSystemConfig);
                            if (error)
                                return "tmpFileSystemConfig." + error;
                        }
                    }
                    if (message.googleCloudStorageConfig != null && message.hasOwnProperty("googleCloudStorageConfig")) {
                        if (properties.storage === 1)
                            return "storage: multiple values";
                        properties.storage = 1;
                        {
                            var error = $root.waiternow.common.StorageLayerConfigProto.StorageConfigProto.GoogleCloudStorageConfigProto.verify(message.googleCloudStorageConfig);
                            if (error)
                                return "googleCloudStorageConfig." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a StorageConfigProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.StorageLayerConfigProto.StorageConfigProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.StorageLayerConfigProto.StorageConfigProto} StorageConfigProto
                 */
                StorageConfigProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.StorageLayerConfigProto.StorageConfigProto)
                        return object;
                    var message = new $root.waiternow.common.StorageLayerConfigProto.StorageConfigProto();
                    if (object.tmpFileSystemConfig != null) {
                        if (typeof object.tmpFileSystemConfig !== "object")
                            throw TypeError(".waiternow.common.StorageLayerConfigProto.StorageConfigProto.tmpFileSystemConfig: object expected");
                        message.tmpFileSystemConfig = $root.waiternow.common.StorageLayerConfigProto.StorageConfigProto.TmpFileSystemConfigProto.fromObject(object.tmpFileSystemConfig);
                    }
                    if (object.googleCloudStorageConfig != null) {
                        if (typeof object.googleCloudStorageConfig !== "object")
                            throw TypeError(".waiternow.common.StorageLayerConfigProto.StorageConfigProto.googleCloudStorageConfig: object expected");
                        message.googleCloudStorageConfig = $root.waiternow.common.StorageLayerConfigProto.StorageConfigProto.GoogleCloudStorageConfigProto.fromObject(object.googleCloudStorageConfig);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a StorageConfigProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.StorageLayerConfigProto.StorageConfigProto
                 * @static
                 * @param {waiternow.common.StorageLayerConfigProto.StorageConfigProto} message StorageConfigProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StorageConfigProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (message.tmpFileSystemConfig != null && message.hasOwnProperty("tmpFileSystemConfig")) {
                        object.tmpFileSystemConfig = $root.waiternow.common.StorageLayerConfigProto.StorageConfigProto.TmpFileSystemConfigProto.toObject(message.tmpFileSystemConfig, options);
                        if (options.oneofs)
                            object.storage = "tmpFileSystemConfig";
                    }
                    if (message.googleCloudStorageConfig != null && message.hasOwnProperty("googleCloudStorageConfig")) {
                        object.googleCloudStorageConfig = $root.waiternow.common.StorageLayerConfigProto.StorageConfigProto.GoogleCloudStorageConfigProto.toObject(message.googleCloudStorageConfig, options);
                        if (options.oneofs)
                            object.storage = "googleCloudStorageConfig";
                    }
                    return object;
                };

                /**
                 * Converts this StorageConfigProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.StorageLayerConfigProto.StorageConfigProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StorageConfigProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for StorageConfigProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.StorageLayerConfigProto.StorageConfigProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                StorageConfigProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.StorageLayerConfigProto.StorageConfigProto";
                };

                StorageConfigProto.TmpFileSystemConfigProto = (function() {

                    /**
                     * Properties of a TmpFileSystemConfigProto.
                     * @memberof waiternow.common.StorageLayerConfigProto.StorageConfigProto
                     * @interface ITmpFileSystemConfigProto
                     * @property {boolean|null} [dropStorageOnStart] TmpFileSystemConfigProto dropStorageOnStart
                     */

                    /**
                     * Constructs a new TmpFileSystemConfigProto.
                     * @memberof waiternow.common.StorageLayerConfigProto.StorageConfigProto
                     * @classdesc Represents a TmpFileSystemConfigProto.
                     * @implements ITmpFileSystemConfigProto
                     * @constructor
                     * @param {waiternow.common.StorageLayerConfigProto.StorageConfigProto.ITmpFileSystemConfigProto=} [properties] Properties to set
                     */
                    function TmpFileSystemConfigProto(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * TmpFileSystemConfigProto dropStorageOnStart.
                     * @member {boolean} dropStorageOnStart
                     * @memberof waiternow.common.StorageLayerConfigProto.StorageConfigProto.TmpFileSystemConfigProto
                     * @instance
                     */
                    TmpFileSystemConfigProto.prototype.dropStorageOnStart = false;

                    /**
                     * Creates a new TmpFileSystemConfigProto instance using the specified properties.
                     * @function create
                     * @memberof waiternow.common.StorageLayerConfigProto.StorageConfigProto.TmpFileSystemConfigProto
                     * @static
                     * @param {waiternow.common.StorageLayerConfigProto.StorageConfigProto.ITmpFileSystemConfigProto=} [properties] Properties to set
                     * @returns {waiternow.common.StorageLayerConfigProto.StorageConfigProto.TmpFileSystemConfigProto} TmpFileSystemConfigProto instance
                     */
                    TmpFileSystemConfigProto.create = function create(properties) {
                        return new TmpFileSystemConfigProto(properties);
                    };

                    /**
                     * Encodes the specified TmpFileSystemConfigProto message. Does not implicitly {@link waiternow.common.StorageLayerConfigProto.StorageConfigProto.TmpFileSystemConfigProto.verify|verify} messages.
                     * @function encode
                     * @memberof waiternow.common.StorageLayerConfigProto.StorageConfigProto.TmpFileSystemConfigProto
                     * @static
                     * @param {waiternow.common.StorageLayerConfigProto.StorageConfigProto.ITmpFileSystemConfigProto} message TmpFileSystemConfigProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TmpFileSystemConfigProto.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.dropStorageOnStart != null && Object.hasOwnProperty.call(message, "dropStorageOnStart"))
                            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.dropStorageOnStart);
                        return writer;
                    };

                    /**
                     * Encodes the specified TmpFileSystemConfigProto message, length delimited. Does not implicitly {@link waiternow.common.StorageLayerConfigProto.StorageConfigProto.TmpFileSystemConfigProto.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof waiternow.common.StorageLayerConfigProto.StorageConfigProto.TmpFileSystemConfigProto
                     * @static
                     * @param {waiternow.common.StorageLayerConfigProto.StorageConfigProto.ITmpFileSystemConfigProto} message TmpFileSystemConfigProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TmpFileSystemConfigProto.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a TmpFileSystemConfigProto message from the specified reader or buffer.
                     * @function decode
                     * @memberof waiternow.common.StorageLayerConfigProto.StorageConfigProto.TmpFileSystemConfigProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {waiternow.common.StorageLayerConfigProto.StorageConfigProto.TmpFileSystemConfigProto} TmpFileSystemConfigProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TmpFileSystemConfigProto.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.StorageLayerConfigProto.StorageConfigProto.TmpFileSystemConfigProto();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.dropStorageOnStart = reader.bool();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a TmpFileSystemConfigProto message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof waiternow.common.StorageLayerConfigProto.StorageConfigProto.TmpFileSystemConfigProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {waiternow.common.StorageLayerConfigProto.StorageConfigProto.TmpFileSystemConfigProto} TmpFileSystemConfigProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TmpFileSystemConfigProto.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a TmpFileSystemConfigProto message.
                     * @function verify
                     * @memberof waiternow.common.StorageLayerConfigProto.StorageConfigProto.TmpFileSystemConfigProto
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TmpFileSystemConfigProto.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.dropStorageOnStart != null && message.hasOwnProperty("dropStorageOnStart"))
                            if (typeof message.dropStorageOnStart !== "boolean")
                                return "dropStorageOnStart: boolean expected";
                        return null;
                    };

                    /**
                     * Creates a TmpFileSystemConfigProto message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof waiternow.common.StorageLayerConfigProto.StorageConfigProto.TmpFileSystemConfigProto
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {waiternow.common.StorageLayerConfigProto.StorageConfigProto.TmpFileSystemConfigProto} TmpFileSystemConfigProto
                     */
                    TmpFileSystemConfigProto.fromObject = function fromObject(object) {
                        if (object instanceof $root.waiternow.common.StorageLayerConfigProto.StorageConfigProto.TmpFileSystemConfigProto)
                            return object;
                        var message = new $root.waiternow.common.StorageLayerConfigProto.StorageConfigProto.TmpFileSystemConfigProto();
                        if (object.dropStorageOnStart != null)
                            message.dropStorageOnStart = Boolean(object.dropStorageOnStart);
                        return message;
                    };

                    /**
                     * Creates a plain object from a TmpFileSystemConfigProto message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof waiternow.common.StorageLayerConfigProto.StorageConfigProto.TmpFileSystemConfigProto
                     * @static
                     * @param {waiternow.common.StorageLayerConfigProto.StorageConfigProto.TmpFileSystemConfigProto} message TmpFileSystemConfigProto
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TmpFileSystemConfigProto.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.dropStorageOnStart = false;
                        if (message.dropStorageOnStart != null && message.hasOwnProperty("dropStorageOnStart"))
                            object.dropStorageOnStart = message.dropStorageOnStart;
                        return object;
                    };

                    /**
                     * Converts this TmpFileSystemConfigProto to JSON.
                     * @function toJSON
                     * @memberof waiternow.common.StorageLayerConfigProto.StorageConfigProto.TmpFileSystemConfigProto
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TmpFileSystemConfigProto.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for TmpFileSystemConfigProto
                     * @function getTypeUrl
                     * @memberof waiternow.common.StorageLayerConfigProto.StorageConfigProto.TmpFileSystemConfigProto
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    TmpFileSystemConfigProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/waiternow.common.StorageLayerConfigProto.StorageConfigProto.TmpFileSystemConfigProto";
                    };

                    return TmpFileSystemConfigProto;
                })();

                StorageConfigProto.GoogleCloudStorageConfigProto = (function() {

                    /**
                     * Properties of a GoogleCloudStorageConfigProto.
                     * @memberof waiternow.common.StorageLayerConfigProto.StorageConfigProto
                     * @interface IGoogleCloudStorageConfigProto
                     * @property {string|null} [bucket] GoogleCloudStorageConfigProto bucket
                     */

                    /**
                     * Constructs a new GoogleCloudStorageConfigProto.
                     * @memberof waiternow.common.StorageLayerConfigProto.StorageConfigProto
                     * @classdesc Represents a GoogleCloudStorageConfigProto.
                     * @implements IGoogleCloudStorageConfigProto
                     * @constructor
                     * @param {waiternow.common.StorageLayerConfigProto.StorageConfigProto.IGoogleCloudStorageConfigProto=} [properties] Properties to set
                     */
                    function GoogleCloudStorageConfigProto(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * GoogleCloudStorageConfigProto bucket.
                     * @member {string} bucket
                     * @memberof waiternow.common.StorageLayerConfigProto.StorageConfigProto.GoogleCloudStorageConfigProto
                     * @instance
                     */
                    GoogleCloudStorageConfigProto.prototype.bucket = "";

                    /**
                     * Creates a new GoogleCloudStorageConfigProto instance using the specified properties.
                     * @function create
                     * @memberof waiternow.common.StorageLayerConfigProto.StorageConfigProto.GoogleCloudStorageConfigProto
                     * @static
                     * @param {waiternow.common.StorageLayerConfigProto.StorageConfigProto.IGoogleCloudStorageConfigProto=} [properties] Properties to set
                     * @returns {waiternow.common.StorageLayerConfigProto.StorageConfigProto.GoogleCloudStorageConfigProto} GoogleCloudStorageConfigProto instance
                     */
                    GoogleCloudStorageConfigProto.create = function create(properties) {
                        return new GoogleCloudStorageConfigProto(properties);
                    };

                    /**
                     * Encodes the specified GoogleCloudStorageConfigProto message. Does not implicitly {@link waiternow.common.StorageLayerConfigProto.StorageConfigProto.GoogleCloudStorageConfigProto.verify|verify} messages.
                     * @function encode
                     * @memberof waiternow.common.StorageLayerConfigProto.StorageConfigProto.GoogleCloudStorageConfigProto
                     * @static
                     * @param {waiternow.common.StorageLayerConfigProto.StorageConfigProto.IGoogleCloudStorageConfigProto} message GoogleCloudStorageConfigProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GoogleCloudStorageConfigProto.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.bucket != null && Object.hasOwnProperty.call(message, "bucket"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.bucket);
                        return writer;
                    };

                    /**
                     * Encodes the specified GoogleCloudStorageConfigProto message, length delimited. Does not implicitly {@link waiternow.common.StorageLayerConfigProto.StorageConfigProto.GoogleCloudStorageConfigProto.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof waiternow.common.StorageLayerConfigProto.StorageConfigProto.GoogleCloudStorageConfigProto
                     * @static
                     * @param {waiternow.common.StorageLayerConfigProto.StorageConfigProto.IGoogleCloudStorageConfigProto} message GoogleCloudStorageConfigProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GoogleCloudStorageConfigProto.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a GoogleCloudStorageConfigProto message from the specified reader or buffer.
                     * @function decode
                     * @memberof waiternow.common.StorageLayerConfigProto.StorageConfigProto.GoogleCloudStorageConfigProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {waiternow.common.StorageLayerConfigProto.StorageConfigProto.GoogleCloudStorageConfigProto} GoogleCloudStorageConfigProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GoogleCloudStorageConfigProto.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.StorageLayerConfigProto.StorageConfigProto.GoogleCloudStorageConfigProto();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.bucket = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a GoogleCloudStorageConfigProto message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof waiternow.common.StorageLayerConfigProto.StorageConfigProto.GoogleCloudStorageConfigProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {waiternow.common.StorageLayerConfigProto.StorageConfigProto.GoogleCloudStorageConfigProto} GoogleCloudStorageConfigProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GoogleCloudStorageConfigProto.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a GoogleCloudStorageConfigProto message.
                     * @function verify
                     * @memberof waiternow.common.StorageLayerConfigProto.StorageConfigProto.GoogleCloudStorageConfigProto
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GoogleCloudStorageConfigProto.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.bucket != null && message.hasOwnProperty("bucket"))
                            if (!$util.isString(message.bucket))
                                return "bucket: string expected";
                        return null;
                    };

                    /**
                     * Creates a GoogleCloudStorageConfigProto message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof waiternow.common.StorageLayerConfigProto.StorageConfigProto.GoogleCloudStorageConfigProto
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {waiternow.common.StorageLayerConfigProto.StorageConfigProto.GoogleCloudStorageConfigProto} GoogleCloudStorageConfigProto
                     */
                    GoogleCloudStorageConfigProto.fromObject = function fromObject(object) {
                        if (object instanceof $root.waiternow.common.StorageLayerConfigProto.StorageConfigProto.GoogleCloudStorageConfigProto)
                            return object;
                        var message = new $root.waiternow.common.StorageLayerConfigProto.StorageConfigProto.GoogleCloudStorageConfigProto();
                        if (object.bucket != null)
                            message.bucket = String(object.bucket);
                        return message;
                    };

                    /**
                     * Creates a plain object from a GoogleCloudStorageConfigProto message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof waiternow.common.StorageLayerConfigProto.StorageConfigProto.GoogleCloudStorageConfigProto
                     * @static
                     * @param {waiternow.common.StorageLayerConfigProto.StorageConfigProto.GoogleCloudStorageConfigProto} message GoogleCloudStorageConfigProto
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GoogleCloudStorageConfigProto.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.bucket = "";
                        if (message.bucket != null && message.hasOwnProperty("bucket"))
                            object.bucket = message.bucket;
                        return object;
                    };

                    /**
                     * Converts this GoogleCloudStorageConfigProto to JSON.
                     * @function toJSON
                     * @memberof waiternow.common.StorageLayerConfigProto.StorageConfigProto.GoogleCloudStorageConfigProto
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GoogleCloudStorageConfigProto.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for GoogleCloudStorageConfigProto
                     * @function getTypeUrl
                     * @memberof waiternow.common.StorageLayerConfigProto.StorageConfigProto.GoogleCloudStorageConfigProto
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    GoogleCloudStorageConfigProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/waiternow.common.StorageLayerConfigProto.StorageConfigProto.GoogleCloudStorageConfigProto";
                    };

                    return GoogleCloudStorageConfigProto;
                })();

                return StorageConfigProto;
            })();

            return StorageLayerConfigProto;
        })();

        common.EmailServiceConfigProto = (function() {

            /**
             * Properties of an EmailServiceConfigProto.
             * @memberof waiternow.common
             * @interface IEmailServiceConfigProto
             * @property {waiternow.common.IEmailAddressProto|null} [systemEmailSender] EmailServiceConfigProto systemEmailSender
             * @property {waiternow.common.IEmailAddressProto|null} [infoRecipient] EmailServiceConfigProto infoRecipient
             * @property {waiternow.common.IEmailAddressProto|null} [systemRecipient] EmailServiceConfigProto systemRecipient
             * @property {waiternow.common.IEmailAddressProto|null} [supportRecipient] EmailServiceConfigProto supportRecipient
             * @property {waiternow.common.IEmailAddressProto|null} [contactRecipient] EmailServiceConfigProto contactRecipient
             * @property {waiternow.common.IEmailAddressProto|null} [feedbackRecipient] EmailServiceConfigProto feedbackRecipient
             * @property {waiternow.common.IEmailAddressProto|null} [salesRecipient] EmailServiceConfigProto salesRecipient
             * @property {waiternow.common.IEmailAddressProto|null} [billingRecipient] EmailServiceConfigProto billingRecipient
             * @property {waiternow.common.IEmailAddressProto|null} [qrCodeSalesRecipient] EmailServiceConfigProto qrCodeSalesRecipient
             * @property {waiternow.common.EmailServiceConfigProto.IMailGunConfigProto|null} [mailGunConfig] EmailServiceConfigProto mailGunConfig
             */

            /**
             * Constructs a new EmailServiceConfigProto.
             * @memberof waiternow.common
             * @classdesc Represents an EmailServiceConfigProto.
             * @implements IEmailServiceConfigProto
             * @constructor
             * @param {waiternow.common.IEmailServiceConfigProto=} [properties] Properties to set
             */
            function EmailServiceConfigProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * EmailServiceConfigProto systemEmailSender.
             * @member {waiternow.common.IEmailAddressProto|null|undefined} systemEmailSender
             * @memberof waiternow.common.EmailServiceConfigProto
             * @instance
             */
            EmailServiceConfigProto.prototype.systemEmailSender = null;

            /**
             * EmailServiceConfigProto infoRecipient.
             * @member {waiternow.common.IEmailAddressProto|null|undefined} infoRecipient
             * @memberof waiternow.common.EmailServiceConfigProto
             * @instance
             */
            EmailServiceConfigProto.prototype.infoRecipient = null;

            /**
             * EmailServiceConfigProto systemRecipient.
             * @member {waiternow.common.IEmailAddressProto|null|undefined} systemRecipient
             * @memberof waiternow.common.EmailServiceConfigProto
             * @instance
             */
            EmailServiceConfigProto.prototype.systemRecipient = null;

            /**
             * EmailServiceConfigProto supportRecipient.
             * @member {waiternow.common.IEmailAddressProto|null|undefined} supportRecipient
             * @memberof waiternow.common.EmailServiceConfigProto
             * @instance
             */
            EmailServiceConfigProto.prototype.supportRecipient = null;

            /**
             * EmailServiceConfigProto contactRecipient.
             * @member {waiternow.common.IEmailAddressProto|null|undefined} contactRecipient
             * @memberof waiternow.common.EmailServiceConfigProto
             * @instance
             */
            EmailServiceConfigProto.prototype.contactRecipient = null;

            /**
             * EmailServiceConfigProto feedbackRecipient.
             * @member {waiternow.common.IEmailAddressProto|null|undefined} feedbackRecipient
             * @memberof waiternow.common.EmailServiceConfigProto
             * @instance
             */
            EmailServiceConfigProto.prototype.feedbackRecipient = null;

            /**
             * EmailServiceConfigProto salesRecipient.
             * @member {waiternow.common.IEmailAddressProto|null|undefined} salesRecipient
             * @memberof waiternow.common.EmailServiceConfigProto
             * @instance
             */
            EmailServiceConfigProto.prototype.salesRecipient = null;

            /**
             * EmailServiceConfigProto billingRecipient.
             * @member {waiternow.common.IEmailAddressProto|null|undefined} billingRecipient
             * @memberof waiternow.common.EmailServiceConfigProto
             * @instance
             */
            EmailServiceConfigProto.prototype.billingRecipient = null;

            /**
             * EmailServiceConfigProto qrCodeSalesRecipient.
             * @member {waiternow.common.IEmailAddressProto|null|undefined} qrCodeSalesRecipient
             * @memberof waiternow.common.EmailServiceConfigProto
             * @instance
             */
            EmailServiceConfigProto.prototype.qrCodeSalesRecipient = null;

            /**
             * EmailServiceConfigProto mailGunConfig.
             * @member {waiternow.common.EmailServiceConfigProto.IMailGunConfigProto|null|undefined} mailGunConfig
             * @memberof waiternow.common.EmailServiceConfigProto
             * @instance
             */
            EmailServiceConfigProto.prototype.mailGunConfig = null;

            /**
             * Creates a new EmailServiceConfigProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.EmailServiceConfigProto
             * @static
             * @param {waiternow.common.IEmailServiceConfigProto=} [properties] Properties to set
             * @returns {waiternow.common.EmailServiceConfigProto} EmailServiceConfigProto instance
             */
            EmailServiceConfigProto.create = function create(properties) {
                return new EmailServiceConfigProto(properties);
            };

            /**
             * Encodes the specified EmailServiceConfigProto message. Does not implicitly {@link waiternow.common.EmailServiceConfigProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.EmailServiceConfigProto
             * @static
             * @param {waiternow.common.IEmailServiceConfigProto} message EmailServiceConfigProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EmailServiceConfigProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.systemEmailSender != null && Object.hasOwnProperty.call(message, "systemEmailSender"))
                    $root.waiternow.common.EmailAddressProto.encode(message.systemEmailSender, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.infoRecipient != null && Object.hasOwnProperty.call(message, "infoRecipient"))
                    $root.waiternow.common.EmailAddressProto.encode(message.infoRecipient, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.systemRecipient != null && Object.hasOwnProperty.call(message, "systemRecipient"))
                    $root.waiternow.common.EmailAddressProto.encode(message.systemRecipient, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.supportRecipient != null && Object.hasOwnProperty.call(message, "supportRecipient"))
                    $root.waiternow.common.EmailAddressProto.encode(message.supportRecipient, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                if (message.contactRecipient != null && Object.hasOwnProperty.call(message, "contactRecipient"))
                    $root.waiternow.common.EmailAddressProto.encode(message.contactRecipient, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                if (message.feedbackRecipient != null && Object.hasOwnProperty.call(message, "feedbackRecipient"))
                    $root.waiternow.common.EmailAddressProto.encode(message.feedbackRecipient, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                if (message.salesRecipient != null && Object.hasOwnProperty.call(message, "salesRecipient"))
                    $root.waiternow.common.EmailAddressProto.encode(message.salesRecipient, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                if (message.billingRecipient != null && Object.hasOwnProperty.call(message, "billingRecipient"))
                    $root.waiternow.common.EmailAddressProto.encode(message.billingRecipient, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                if (message.mailGunConfig != null && Object.hasOwnProperty.call(message, "mailGunConfig"))
                    $root.waiternow.common.EmailServiceConfigProto.MailGunConfigProto.encode(message.mailGunConfig, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                if (message.qrCodeSalesRecipient != null && Object.hasOwnProperty.call(message, "qrCodeSalesRecipient"))
                    $root.waiternow.common.EmailAddressProto.encode(message.qrCodeSalesRecipient, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified EmailServiceConfigProto message, length delimited. Does not implicitly {@link waiternow.common.EmailServiceConfigProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.EmailServiceConfigProto
             * @static
             * @param {waiternow.common.IEmailServiceConfigProto} message EmailServiceConfigProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EmailServiceConfigProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an EmailServiceConfigProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.EmailServiceConfigProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.EmailServiceConfigProto} EmailServiceConfigProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EmailServiceConfigProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.EmailServiceConfigProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.systemEmailSender = $root.waiternow.common.EmailAddressProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 2: {
                            message.infoRecipient = $root.waiternow.common.EmailAddressProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 3: {
                            message.systemRecipient = $root.waiternow.common.EmailAddressProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 4: {
                            message.supportRecipient = $root.waiternow.common.EmailAddressProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 5: {
                            message.contactRecipient = $root.waiternow.common.EmailAddressProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 6: {
                            message.feedbackRecipient = $root.waiternow.common.EmailAddressProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 7: {
                            message.salesRecipient = $root.waiternow.common.EmailAddressProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 8: {
                            message.billingRecipient = $root.waiternow.common.EmailAddressProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 10: {
                            message.qrCodeSalesRecipient = $root.waiternow.common.EmailAddressProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 9: {
                            message.mailGunConfig = $root.waiternow.common.EmailServiceConfigProto.MailGunConfigProto.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an EmailServiceConfigProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.EmailServiceConfigProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.EmailServiceConfigProto} EmailServiceConfigProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EmailServiceConfigProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an EmailServiceConfigProto message.
             * @function verify
             * @memberof waiternow.common.EmailServiceConfigProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            EmailServiceConfigProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.systemEmailSender != null && message.hasOwnProperty("systemEmailSender")) {
                    var error = $root.waiternow.common.EmailAddressProto.verify(message.systemEmailSender);
                    if (error)
                        return "systemEmailSender." + error;
                }
                if (message.infoRecipient != null && message.hasOwnProperty("infoRecipient")) {
                    var error = $root.waiternow.common.EmailAddressProto.verify(message.infoRecipient);
                    if (error)
                        return "infoRecipient." + error;
                }
                if (message.systemRecipient != null && message.hasOwnProperty("systemRecipient")) {
                    var error = $root.waiternow.common.EmailAddressProto.verify(message.systemRecipient);
                    if (error)
                        return "systemRecipient." + error;
                }
                if (message.supportRecipient != null && message.hasOwnProperty("supportRecipient")) {
                    var error = $root.waiternow.common.EmailAddressProto.verify(message.supportRecipient);
                    if (error)
                        return "supportRecipient." + error;
                }
                if (message.contactRecipient != null && message.hasOwnProperty("contactRecipient")) {
                    var error = $root.waiternow.common.EmailAddressProto.verify(message.contactRecipient);
                    if (error)
                        return "contactRecipient." + error;
                }
                if (message.feedbackRecipient != null && message.hasOwnProperty("feedbackRecipient")) {
                    var error = $root.waiternow.common.EmailAddressProto.verify(message.feedbackRecipient);
                    if (error)
                        return "feedbackRecipient." + error;
                }
                if (message.salesRecipient != null && message.hasOwnProperty("salesRecipient")) {
                    var error = $root.waiternow.common.EmailAddressProto.verify(message.salesRecipient);
                    if (error)
                        return "salesRecipient." + error;
                }
                if (message.billingRecipient != null && message.hasOwnProperty("billingRecipient")) {
                    var error = $root.waiternow.common.EmailAddressProto.verify(message.billingRecipient);
                    if (error)
                        return "billingRecipient." + error;
                }
                if (message.qrCodeSalesRecipient != null && message.hasOwnProperty("qrCodeSalesRecipient")) {
                    var error = $root.waiternow.common.EmailAddressProto.verify(message.qrCodeSalesRecipient);
                    if (error)
                        return "qrCodeSalesRecipient." + error;
                }
                if (message.mailGunConfig != null && message.hasOwnProperty("mailGunConfig")) {
                    var error = $root.waiternow.common.EmailServiceConfigProto.MailGunConfigProto.verify(message.mailGunConfig);
                    if (error)
                        return "mailGunConfig." + error;
                }
                return null;
            };

            /**
             * Creates an EmailServiceConfigProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.EmailServiceConfigProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.EmailServiceConfigProto} EmailServiceConfigProto
             */
            EmailServiceConfigProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.EmailServiceConfigProto)
                    return object;
                var message = new $root.waiternow.common.EmailServiceConfigProto();
                if (object.systemEmailSender != null) {
                    if (typeof object.systemEmailSender !== "object")
                        throw TypeError(".waiternow.common.EmailServiceConfigProto.systemEmailSender: object expected");
                    message.systemEmailSender = $root.waiternow.common.EmailAddressProto.fromObject(object.systemEmailSender);
                }
                if (object.infoRecipient != null) {
                    if (typeof object.infoRecipient !== "object")
                        throw TypeError(".waiternow.common.EmailServiceConfigProto.infoRecipient: object expected");
                    message.infoRecipient = $root.waiternow.common.EmailAddressProto.fromObject(object.infoRecipient);
                }
                if (object.systemRecipient != null) {
                    if (typeof object.systemRecipient !== "object")
                        throw TypeError(".waiternow.common.EmailServiceConfigProto.systemRecipient: object expected");
                    message.systemRecipient = $root.waiternow.common.EmailAddressProto.fromObject(object.systemRecipient);
                }
                if (object.supportRecipient != null) {
                    if (typeof object.supportRecipient !== "object")
                        throw TypeError(".waiternow.common.EmailServiceConfigProto.supportRecipient: object expected");
                    message.supportRecipient = $root.waiternow.common.EmailAddressProto.fromObject(object.supportRecipient);
                }
                if (object.contactRecipient != null) {
                    if (typeof object.contactRecipient !== "object")
                        throw TypeError(".waiternow.common.EmailServiceConfigProto.contactRecipient: object expected");
                    message.contactRecipient = $root.waiternow.common.EmailAddressProto.fromObject(object.contactRecipient);
                }
                if (object.feedbackRecipient != null) {
                    if (typeof object.feedbackRecipient !== "object")
                        throw TypeError(".waiternow.common.EmailServiceConfigProto.feedbackRecipient: object expected");
                    message.feedbackRecipient = $root.waiternow.common.EmailAddressProto.fromObject(object.feedbackRecipient);
                }
                if (object.salesRecipient != null) {
                    if (typeof object.salesRecipient !== "object")
                        throw TypeError(".waiternow.common.EmailServiceConfigProto.salesRecipient: object expected");
                    message.salesRecipient = $root.waiternow.common.EmailAddressProto.fromObject(object.salesRecipient);
                }
                if (object.billingRecipient != null) {
                    if (typeof object.billingRecipient !== "object")
                        throw TypeError(".waiternow.common.EmailServiceConfigProto.billingRecipient: object expected");
                    message.billingRecipient = $root.waiternow.common.EmailAddressProto.fromObject(object.billingRecipient);
                }
                if (object.qrCodeSalesRecipient != null) {
                    if (typeof object.qrCodeSalesRecipient !== "object")
                        throw TypeError(".waiternow.common.EmailServiceConfigProto.qrCodeSalesRecipient: object expected");
                    message.qrCodeSalesRecipient = $root.waiternow.common.EmailAddressProto.fromObject(object.qrCodeSalesRecipient);
                }
                if (object.mailGunConfig != null) {
                    if (typeof object.mailGunConfig !== "object")
                        throw TypeError(".waiternow.common.EmailServiceConfigProto.mailGunConfig: object expected");
                    message.mailGunConfig = $root.waiternow.common.EmailServiceConfigProto.MailGunConfigProto.fromObject(object.mailGunConfig);
                }
                return message;
            };

            /**
             * Creates a plain object from an EmailServiceConfigProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.EmailServiceConfigProto
             * @static
             * @param {waiternow.common.EmailServiceConfigProto} message EmailServiceConfigProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            EmailServiceConfigProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.systemEmailSender = null;
                    object.infoRecipient = null;
                    object.systemRecipient = null;
                    object.supportRecipient = null;
                    object.contactRecipient = null;
                    object.feedbackRecipient = null;
                    object.salesRecipient = null;
                    object.billingRecipient = null;
                    object.mailGunConfig = null;
                    object.qrCodeSalesRecipient = null;
                }
                if (message.systemEmailSender != null && message.hasOwnProperty("systemEmailSender"))
                    object.systemEmailSender = $root.waiternow.common.EmailAddressProto.toObject(message.systemEmailSender, options);
                if (message.infoRecipient != null && message.hasOwnProperty("infoRecipient"))
                    object.infoRecipient = $root.waiternow.common.EmailAddressProto.toObject(message.infoRecipient, options);
                if (message.systemRecipient != null && message.hasOwnProperty("systemRecipient"))
                    object.systemRecipient = $root.waiternow.common.EmailAddressProto.toObject(message.systemRecipient, options);
                if (message.supportRecipient != null && message.hasOwnProperty("supportRecipient"))
                    object.supportRecipient = $root.waiternow.common.EmailAddressProto.toObject(message.supportRecipient, options);
                if (message.contactRecipient != null && message.hasOwnProperty("contactRecipient"))
                    object.contactRecipient = $root.waiternow.common.EmailAddressProto.toObject(message.contactRecipient, options);
                if (message.feedbackRecipient != null && message.hasOwnProperty("feedbackRecipient"))
                    object.feedbackRecipient = $root.waiternow.common.EmailAddressProto.toObject(message.feedbackRecipient, options);
                if (message.salesRecipient != null && message.hasOwnProperty("salesRecipient"))
                    object.salesRecipient = $root.waiternow.common.EmailAddressProto.toObject(message.salesRecipient, options);
                if (message.billingRecipient != null && message.hasOwnProperty("billingRecipient"))
                    object.billingRecipient = $root.waiternow.common.EmailAddressProto.toObject(message.billingRecipient, options);
                if (message.mailGunConfig != null && message.hasOwnProperty("mailGunConfig"))
                    object.mailGunConfig = $root.waiternow.common.EmailServiceConfigProto.MailGunConfigProto.toObject(message.mailGunConfig, options);
                if (message.qrCodeSalesRecipient != null && message.hasOwnProperty("qrCodeSalesRecipient"))
                    object.qrCodeSalesRecipient = $root.waiternow.common.EmailAddressProto.toObject(message.qrCodeSalesRecipient, options);
                return object;
            };

            /**
             * Converts this EmailServiceConfigProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.EmailServiceConfigProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            EmailServiceConfigProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for EmailServiceConfigProto
             * @function getTypeUrl
             * @memberof waiternow.common.EmailServiceConfigProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            EmailServiceConfigProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.EmailServiceConfigProto";
            };

            EmailServiceConfigProto.MailGunConfigProto = (function() {

                /**
                 * Properties of a MailGunConfigProto.
                 * @memberof waiternow.common.EmailServiceConfigProto
                 * @interface IMailGunConfigProto
                 * @property {string|null} [encryptedPrivateApiKey] MailGunConfigProto encryptedPrivateApiKey
                 * @property {string|null} [domain] MailGunConfigProto domain
                 */

                /**
                 * Constructs a new MailGunConfigProto.
                 * @memberof waiternow.common.EmailServiceConfigProto
                 * @classdesc Represents a MailGunConfigProto.
                 * @implements IMailGunConfigProto
                 * @constructor
                 * @param {waiternow.common.EmailServiceConfigProto.IMailGunConfigProto=} [properties] Properties to set
                 */
                function MailGunConfigProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * MailGunConfigProto encryptedPrivateApiKey.
                 * @member {string} encryptedPrivateApiKey
                 * @memberof waiternow.common.EmailServiceConfigProto.MailGunConfigProto
                 * @instance
                 */
                MailGunConfigProto.prototype.encryptedPrivateApiKey = "";

                /**
                 * MailGunConfigProto domain.
                 * @member {string} domain
                 * @memberof waiternow.common.EmailServiceConfigProto.MailGunConfigProto
                 * @instance
                 */
                MailGunConfigProto.prototype.domain = "";

                /**
                 * Creates a new MailGunConfigProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.EmailServiceConfigProto.MailGunConfigProto
                 * @static
                 * @param {waiternow.common.EmailServiceConfigProto.IMailGunConfigProto=} [properties] Properties to set
                 * @returns {waiternow.common.EmailServiceConfigProto.MailGunConfigProto} MailGunConfigProto instance
                 */
                MailGunConfigProto.create = function create(properties) {
                    return new MailGunConfigProto(properties);
                };

                /**
                 * Encodes the specified MailGunConfigProto message. Does not implicitly {@link waiternow.common.EmailServiceConfigProto.MailGunConfigProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.EmailServiceConfigProto.MailGunConfigProto
                 * @static
                 * @param {waiternow.common.EmailServiceConfigProto.IMailGunConfigProto} message MailGunConfigProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MailGunConfigProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.encryptedPrivateApiKey != null && Object.hasOwnProperty.call(message, "encryptedPrivateApiKey"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.encryptedPrivateApiKey);
                    if (message.domain != null && Object.hasOwnProperty.call(message, "domain"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.domain);
                    return writer;
                };

                /**
                 * Encodes the specified MailGunConfigProto message, length delimited. Does not implicitly {@link waiternow.common.EmailServiceConfigProto.MailGunConfigProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.EmailServiceConfigProto.MailGunConfigProto
                 * @static
                 * @param {waiternow.common.EmailServiceConfigProto.IMailGunConfigProto} message MailGunConfigProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MailGunConfigProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a MailGunConfigProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.EmailServiceConfigProto.MailGunConfigProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.EmailServiceConfigProto.MailGunConfigProto} MailGunConfigProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MailGunConfigProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.EmailServiceConfigProto.MailGunConfigProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.encryptedPrivateApiKey = reader.string();
                                break;
                            }
                        case 2: {
                                message.domain = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a MailGunConfigProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.EmailServiceConfigProto.MailGunConfigProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.EmailServiceConfigProto.MailGunConfigProto} MailGunConfigProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MailGunConfigProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a MailGunConfigProto message.
                 * @function verify
                 * @memberof waiternow.common.EmailServiceConfigProto.MailGunConfigProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                MailGunConfigProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.encryptedPrivateApiKey != null && message.hasOwnProperty("encryptedPrivateApiKey"))
                        if (!$util.isString(message.encryptedPrivateApiKey))
                            return "encryptedPrivateApiKey: string expected";
                    if (message.domain != null && message.hasOwnProperty("domain"))
                        if (!$util.isString(message.domain))
                            return "domain: string expected";
                    return null;
                };

                /**
                 * Creates a MailGunConfigProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.EmailServiceConfigProto.MailGunConfigProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.EmailServiceConfigProto.MailGunConfigProto} MailGunConfigProto
                 */
                MailGunConfigProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.EmailServiceConfigProto.MailGunConfigProto)
                        return object;
                    var message = new $root.waiternow.common.EmailServiceConfigProto.MailGunConfigProto();
                    if (object.encryptedPrivateApiKey != null)
                        message.encryptedPrivateApiKey = String(object.encryptedPrivateApiKey);
                    if (object.domain != null)
                        message.domain = String(object.domain);
                    return message;
                };

                /**
                 * Creates a plain object from a MailGunConfigProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.EmailServiceConfigProto.MailGunConfigProto
                 * @static
                 * @param {waiternow.common.EmailServiceConfigProto.MailGunConfigProto} message MailGunConfigProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                MailGunConfigProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.encryptedPrivateApiKey = "";
                        object.domain = "";
                    }
                    if (message.encryptedPrivateApiKey != null && message.hasOwnProperty("encryptedPrivateApiKey"))
                        object.encryptedPrivateApiKey = message.encryptedPrivateApiKey;
                    if (message.domain != null && message.hasOwnProperty("domain"))
                        object.domain = message.domain;
                    return object;
                };

                /**
                 * Converts this MailGunConfigProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.EmailServiceConfigProto.MailGunConfigProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                MailGunConfigProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for MailGunConfigProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.EmailServiceConfigProto.MailGunConfigProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                MailGunConfigProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.EmailServiceConfigProto.MailGunConfigProto";
                };

                return MailGunConfigProto;
            })();

            return EmailServiceConfigProto;
        })();

        common.SmsMessagingServiceConfigProto = (function() {

            /**
             * Properties of a SmsMessagingServiceConfigProto.
             * @memberof waiternow.common
             * @interface ISmsMessagingServiceConfigProto
             * @property {waiternow.common.SmsMessagingServiceConfigProto.ITwilioConfigProto|null} [twilioConfig] SmsMessagingServiceConfigProto twilioConfig
             */

            /**
             * Constructs a new SmsMessagingServiceConfigProto.
             * @memberof waiternow.common
             * @classdesc Represents a SmsMessagingServiceConfigProto.
             * @implements ISmsMessagingServiceConfigProto
             * @constructor
             * @param {waiternow.common.ISmsMessagingServiceConfigProto=} [properties] Properties to set
             */
            function SmsMessagingServiceConfigProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * SmsMessagingServiceConfigProto twilioConfig.
             * @member {waiternow.common.SmsMessagingServiceConfigProto.ITwilioConfigProto|null|undefined} twilioConfig
             * @memberof waiternow.common.SmsMessagingServiceConfigProto
             * @instance
             */
            SmsMessagingServiceConfigProto.prototype.twilioConfig = null;

            /**
             * Creates a new SmsMessagingServiceConfigProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.SmsMessagingServiceConfigProto
             * @static
             * @param {waiternow.common.ISmsMessagingServiceConfigProto=} [properties] Properties to set
             * @returns {waiternow.common.SmsMessagingServiceConfigProto} SmsMessagingServiceConfigProto instance
             */
            SmsMessagingServiceConfigProto.create = function create(properties) {
                return new SmsMessagingServiceConfigProto(properties);
            };

            /**
             * Encodes the specified SmsMessagingServiceConfigProto message. Does not implicitly {@link waiternow.common.SmsMessagingServiceConfigProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.SmsMessagingServiceConfigProto
             * @static
             * @param {waiternow.common.ISmsMessagingServiceConfigProto} message SmsMessagingServiceConfigProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SmsMessagingServiceConfigProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.twilioConfig != null && Object.hasOwnProperty.call(message, "twilioConfig"))
                    $root.waiternow.common.SmsMessagingServiceConfigProto.TwilioConfigProto.encode(message.twilioConfig, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified SmsMessagingServiceConfigProto message, length delimited. Does not implicitly {@link waiternow.common.SmsMessagingServiceConfigProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.SmsMessagingServiceConfigProto
             * @static
             * @param {waiternow.common.ISmsMessagingServiceConfigProto} message SmsMessagingServiceConfigProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SmsMessagingServiceConfigProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SmsMessagingServiceConfigProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.SmsMessagingServiceConfigProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.SmsMessagingServiceConfigProto} SmsMessagingServiceConfigProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SmsMessagingServiceConfigProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.SmsMessagingServiceConfigProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.twilioConfig = $root.waiternow.common.SmsMessagingServiceConfigProto.TwilioConfigProto.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SmsMessagingServiceConfigProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.SmsMessagingServiceConfigProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.SmsMessagingServiceConfigProto} SmsMessagingServiceConfigProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SmsMessagingServiceConfigProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SmsMessagingServiceConfigProto message.
             * @function verify
             * @memberof waiternow.common.SmsMessagingServiceConfigProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SmsMessagingServiceConfigProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.twilioConfig != null && message.hasOwnProperty("twilioConfig")) {
                    var error = $root.waiternow.common.SmsMessagingServiceConfigProto.TwilioConfigProto.verify(message.twilioConfig);
                    if (error)
                        return "twilioConfig." + error;
                }
                return null;
            };

            /**
             * Creates a SmsMessagingServiceConfigProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.SmsMessagingServiceConfigProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.SmsMessagingServiceConfigProto} SmsMessagingServiceConfigProto
             */
            SmsMessagingServiceConfigProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.SmsMessagingServiceConfigProto)
                    return object;
                var message = new $root.waiternow.common.SmsMessagingServiceConfigProto();
                if (object.twilioConfig != null) {
                    if (typeof object.twilioConfig !== "object")
                        throw TypeError(".waiternow.common.SmsMessagingServiceConfigProto.twilioConfig: object expected");
                    message.twilioConfig = $root.waiternow.common.SmsMessagingServiceConfigProto.TwilioConfigProto.fromObject(object.twilioConfig);
                }
                return message;
            };

            /**
             * Creates a plain object from a SmsMessagingServiceConfigProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.SmsMessagingServiceConfigProto
             * @static
             * @param {waiternow.common.SmsMessagingServiceConfigProto} message SmsMessagingServiceConfigProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SmsMessagingServiceConfigProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.twilioConfig = null;
                if (message.twilioConfig != null && message.hasOwnProperty("twilioConfig"))
                    object.twilioConfig = $root.waiternow.common.SmsMessagingServiceConfigProto.TwilioConfigProto.toObject(message.twilioConfig, options);
                return object;
            };

            /**
             * Converts this SmsMessagingServiceConfigProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.SmsMessagingServiceConfigProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SmsMessagingServiceConfigProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for SmsMessagingServiceConfigProto
             * @function getTypeUrl
             * @memberof waiternow.common.SmsMessagingServiceConfigProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            SmsMessagingServiceConfigProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.SmsMessagingServiceConfigProto";
            };

            SmsMessagingServiceConfigProto.TwilioConfigProto = (function() {

                /**
                 * Properties of a TwilioConfigProto.
                 * @memberof waiternow.common.SmsMessagingServiceConfigProto
                 * @interface ITwilioConfigProto
                 * @property {string|null} [encryptedAccountSid] TwilioConfigProto encryptedAccountSid
                 * @property {string|null} [encryptedAuthToken] TwilioConfigProto encryptedAuthToken
                 * @property {waiternow.common.IPhoneNumberProto|null} [virtualPhoneNumber] TwilioConfigProto virtualPhoneNumber
                 */

                /**
                 * Constructs a new TwilioConfigProto.
                 * @memberof waiternow.common.SmsMessagingServiceConfigProto
                 * @classdesc Represents a TwilioConfigProto.
                 * @implements ITwilioConfigProto
                 * @constructor
                 * @param {waiternow.common.SmsMessagingServiceConfigProto.ITwilioConfigProto=} [properties] Properties to set
                 */
                function TwilioConfigProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * TwilioConfigProto encryptedAccountSid.
                 * @member {string} encryptedAccountSid
                 * @memberof waiternow.common.SmsMessagingServiceConfigProto.TwilioConfigProto
                 * @instance
                 */
                TwilioConfigProto.prototype.encryptedAccountSid = "";

                /**
                 * TwilioConfigProto encryptedAuthToken.
                 * @member {string} encryptedAuthToken
                 * @memberof waiternow.common.SmsMessagingServiceConfigProto.TwilioConfigProto
                 * @instance
                 */
                TwilioConfigProto.prototype.encryptedAuthToken = "";

                /**
                 * TwilioConfigProto virtualPhoneNumber.
                 * @member {waiternow.common.IPhoneNumberProto|null|undefined} virtualPhoneNumber
                 * @memberof waiternow.common.SmsMessagingServiceConfigProto.TwilioConfigProto
                 * @instance
                 */
                TwilioConfigProto.prototype.virtualPhoneNumber = null;

                /**
                 * Creates a new TwilioConfigProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.SmsMessagingServiceConfigProto.TwilioConfigProto
                 * @static
                 * @param {waiternow.common.SmsMessagingServiceConfigProto.ITwilioConfigProto=} [properties] Properties to set
                 * @returns {waiternow.common.SmsMessagingServiceConfigProto.TwilioConfigProto} TwilioConfigProto instance
                 */
                TwilioConfigProto.create = function create(properties) {
                    return new TwilioConfigProto(properties);
                };

                /**
                 * Encodes the specified TwilioConfigProto message. Does not implicitly {@link waiternow.common.SmsMessagingServiceConfigProto.TwilioConfigProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.SmsMessagingServiceConfigProto.TwilioConfigProto
                 * @static
                 * @param {waiternow.common.SmsMessagingServiceConfigProto.ITwilioConfigProto} message TwilioConfigProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                TwilioConfigProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.encryptedAccountSid != null && Object.hasOwnProperty.call(message, "encryptedAccountSid"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.encryptedAccountSid);
                    if (message.encryptedAuthToken != null && Object.hasOwnProperty.call(message, "encryptedAuthToken"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.encryptedAuthToken);
                    if (message.virtualPhoneNumber != null && Object.hasOwnProperty.call(message, "virtualPhoneNumber"))
                        $root.waiternow.common.PhoneNumberProto.encode(message.virtualPhoneNumber, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified TwilioConfigProto message, length delimited. Does not implicitly {@link waiternow.common.SmsMessagingServiceConfigProto.TwilioConfigProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.SmsMessagingServiceConfigProto.TwilioConfigProto
                 * @static
                 * @param {waiternow.common.SmsMessagingServiceConfigProto.ITwilioConfigProto} message TwilioConfigProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                TwilioConfigProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a TwilioConfigProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.SmsMessagingServiceConfigProto.TwilioConfigProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.SmsMessagingServiceConfigProto.TwilioConfigProto} TwilioConfigProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                TwilioConfigProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.SmsMessagingServiceConfigProto.TwilioConfigProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.encryptedAccountSid = reader.string();
                                break;
                            }
                        case 2: {
                                message.encryptedAuthToken = reader.string();
                                break;
                            }
                        case 3: {
                                message.virtualPhoneNumber = $root.waiternow.common.PhoneNumberProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a TwilioConfigProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.SmsMessagingServiceConfigProto.TwilioConfigProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.SmsMessagingServiceConfigProto.TwilioConfigProto} TwilioConfigProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                TwilioConfigProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a TwilioConfigProto message.
                 * @function verify
                 * @memberof waiternow.common.SmsMessagingServiceConfigProto.TwilioConfigProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                TwilioConfigProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.encryptedAccountSid != null && message.hasOwnProperty("encryptedAccountSid"))
                        if (!$util.isString(message.encryptedAccountSid))
                            return "encryptedAccountSid: string expected";
                    if (message.encryptedAuthToken != null && message.hasOwnProperty("encryptedAuthToken"))
                        if (!$util.isString(message.encryptedAuthToken))
                            return "encryptedAuthToken: string expected";
                    if (message.virtualPhoneNumber != null && message.hasOwnProperty("virtualPhoneNumber")) {
                        var error = $root.waiternow.common.PhoneNumberProto.verify(message.virtualPhoneNumber);
                        if (error)
                            return "virtualPhoneNumber." + error;
                    }
                    return null;
                };

                /**
                 * Creates a TwilioConfigProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.SmsMessagingServiceConfigProto.TwilioConfigProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.SmsMessagingServiceConfigProto.TwilioConfigProto} TwilioConfigProto
                 */
                TwilioConfigProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.SmsMessagingServiceConfigProto.TwilioConfigProto)
                        return object;
                    var message = new $root.waiternow.common.SmsMessagingServiceConfigProto.TwilioConfigProto();
                    if (object.encryptedAccountSid != null)
                        message.encryptedAccountSid = String(object.encryptedAccountSid);
                    if (object.encryptedAuthToken != null)
                        message.encryptedAuthToken = String(object.encryptedAuthToken);
                    if (object.virtualPhoneNumber != null) {
                        if (typeof object.virtualPhoneNumber !== "object")
                            throw TypeError(".waiternow.common.SmsMessagingServiceConfigProto.TwilioConfigProto.virtualPhoneNumber: object expected");
                        message.virtualPhoneNumber = $root.waiternow.common.PhoneNumberProto.fromObject(object.virtualPhoneNumber);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a TwilioConfigProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.SmsMessagingServiceConfigProto.TwilioConfigProto
                 * @static
                 * @param {waiternow.common.SmsMessagingServiceConfigProto.TwilioConfigProto} message TwilioConfigProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                TwilioConfigProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.encryptedAccountSid = "";
                        object.encryptedAuthToken = "";
                        object.virtualPhoneNumber = null;
                    }
                    if (message.encryptedAccountSid != null && message.hasOwnProperty("encryptedAccountSid"))
                        object.encryptedAccountSid = message.encryptedAccountSid;
                    if (message.encryptedAuthToken != null && message.hasOwnProperty("encryptedAuthToken"))
                        object.encryptedAuthToken = message.encryptedAuthToken;
                    if (message.virtualPhoneNumber != null && message.hasOwnProperty("virtualPhoneNumber"))
                        object.virtualPhoneNumber = $root.waiternow.common.PhoneNumberProto.toObject(message.virtualPhoneNumber, options);
                    return object;
                };

                /**
                 * Converts this TwilioConfigProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.SmsMessagingServiceConfigProto.TwilioConfigProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                TwilioConfigProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for TwilioConfigProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.SmsMessagingServiceConfigProto.TwilioConfigProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                TwilioConfigProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.SmsMessagingServiceConfigProto.TwilioConfigProto";
                };

                return TwilioConfigProto;
            })();

            return SmsMessagingServiceConfigProto;
        })();

        common.WebLayerConfigProto = (function() {

            /**
             * Properties of a WebLayerConfigProto.
             * @memberof waiternow.common
             * @interface IWebLayerConfigProto
             * @property {waiternow.common.WebLayerConfigProto.ActionProtoEncoding|null} [actionProtoEncoding] WebLayerConfigProto actionProtoEncoding
             */

            /**
             * Constructs a new WebLayerConfigProto.
             * @memberof waiternow.common
             * @classdesc Represents a WebLayerConfigProto.
             * @implements IWebLayerConfigProto
             * @constructor
             * @param {waiternow.common.IWebLayerConfigProto=} [properties] Properties to set
             */
            function WebLayerConfigProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * WebLayerConfigProto actionProtoEncoding.
             * @member {waiternow.common.WebLayerConfigProto.ActionProtoEncoding} actionProtoEncoding
             * @memberof waiternow.common.WebLayerConfigProto
             * @instance
             */
            WebLayerConfigProto.prototype.actionProtoEncoding = 0;

            /**
             * Creates a new WebLayerConfigProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.WebLayerConfigProto
             * @static
             * @param {waiternow.common.IWebLayerConfigProto=} [properties] Properties to set
             * @returns {waiternow.common.WebLayerConfigProto} WebLayerConfigProto instance
             */
            WebLayerConfigProto.create = function create(properties) {
                return new WebLayerConfigProto(properties);
            };

            /**
             * Encodes the specified WebLayerConfigProto message. Does not implicitly {@link waiternow.common.WebLayerConfigProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.WebLayerConfigProto
             * @static
             * @param {waiternow.common.IWebLayerConfigProto} message WebLayerConfigProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            WebLayerConfigProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.actionProtoEncoding != null && Object.hasOwnProperty.call(message, "actionProtoEncoding"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.actionProtoEncoding);
                return writer;
            };

            /**
             * Encodes the specified WebLayerConfigProto message, length delimited. Does not implicitly {@link waiternow.common.WebLayerConfigProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.WebLayerConfigProto
             * @static
             * @param {waiternow.common.IWebLayerConfigProto} message WebLayerConfigProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            WebLayerConfigProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a WebLayerConfigProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.WebLayerConfigProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.WebLayerConfigProto} WebLayerConfigProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            WebLayerConfigProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.WebLayerConfigProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.actionProtoEncoding = reader.int32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a WebLayerConfigProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.WebLayerConfigProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.WebLayerConfigProto} WebLayerConfigProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            WebLayerConfigProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a WebLayerConfigProto message.
             * @function verify
             * @memberof waiternow.common.WebLayerConfigProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            WebLayerConfigProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.actionProtoEncoding != null && message.hasOwnProperty("actionProtoEncoding"))
                    switch (message.actionProtoEncoding) {
                    default:
                        return "actionProtoEncoding: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                        break;
                    }
                return null;
            };

            /**
             * Creates a WebLayerConfigProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.WebLayerConfigProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.WebLayerConfigProto} WebLayerConfigProto
             */
            WebLayerConfigProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.WebLayerConfigProto)
                    return object;
                var message = new $root.waiternow.common.WebLayerConfigProto();
                switch (object.actionProtoEncoding) {
                default:
                    if (typeof object.actionProtoEncoding === "number") {
                        message.actionProtoEncoding = object.actionProtoEncoding;
                        break;
                    }
                    break;
                case "ACTION_PROTO_ENCODING_UNSPECIFIED":
                case 0:
                    message.actionProtoEncoding = 0;
                    break;
                case "BINARY":
                case 1:
                    message.actionProtoEncoding = 1;
                    break;
                case "TEXT":
                case 2:
                    message.actionProtoEncoding = 2;
                    break;
                case "AS_REQUESTED":
                case 3:
                    message.actionProtoEncoding = 3;
                    break;
                }
                return message;
            };

            /**
             * Creates a plain object from a WebLayerConfigProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.WebLayerConfigProto
             * @static
             * @param {waiternow.common.WebLayerConfigProto} message WebLayerConfigProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            WebLayerConfigProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.actionProtoEncoding = options.enums === String ? "ACTION_PROTO_ENCODING_UNSPECIFIED" : 0;
                if (message.actionProtoEncoding != null && message.hasOwnProperty("actionProtoEncoding"))
                    object.actionProtoEncoding = options.enums === String ? $root.waiternow.common.WebLayerConfigProto.ActionProtoEncoding[message.actionProtoEncoding] === undefined ? message.actionProtoEncoding : $root.waiternow.common.WebLayerConfigProto.ActionProtoEncoding[message.actionProtoEncoding] : message.actionProtoEncoding;
                return object;
            };

            /**
             * Converts this WebLayerConfigProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.WebLayerConfigProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            WebLayerConfigProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for WebLayerConfigProto
             * @function getTypeUrl
             * @memberof waiternow.common.WebLayerConfigProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            WebLayerConfigProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.WebLayerConfigProto";
            };

            /**
             * ActionProtoEncoding enum.
             * @name waiternow.common.WebLayerConfigProto.ActionProtoEncoding
             * @enum {number}
             * @property {number} ACTION_PROTO_ENCODING_UNSPECIFIED=0 ACTION_PROTO_ENCODING_UNSPECIFIED value
             * @property {number} BINARY=1 BINARY value
             * @property {number} TEXT=2 TEXT value
             * @property {number} AS_REQUESTED=3 AS_REQUESTED value
             */
            WebLayerConfigProto.ActionProtoEncoding = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "ACTION_PROTO_ENCODING_UNSPECIFIED"] = 0;
                values[valuesById[1] = "BINARY"] = 1;
                values[valuesById[2] = "TEXT"] = 2;
                values[valuesById[3] = "AS_REQUESTED"] = 3;
                return values;
            })();

            return WebLayerConfigProto;
        })();

        common.FirebaseConfigProto = (function() {

            /**
             * Properties of a FirebaseConfigProto.
             * @memberof waiternow.common
             * @interface IFirebaseConfigProto
             * @property {string|null} [projectId] FirebaseConfigProto projectId
             * @property {string|null} [encryptedMessagingServerKey] FirebaseConfigProto encryptedMessagingServerKey
             * @property {string|null} [databaseUrl] FirebaseConfigProto databaseUrl
             * @property {waiternow.common.FirebaseConfigProto.INotificationAlertConfigProto|null} [notificationAlertConfig] FirebaseConfigProto notificationAlertConfig
             */

            /**
             * Constructs a new FirebaseConfigProto.
             * @memberof waiternow.common
             * @classdesc Represents a FirebaseConfigProto.
             * @implements IFirebaseConfigProto
             * @constructor
             * @param {waiternow.common.IFirebaseConfigProto=} [properties] Properties to set
             */
            function FirebaseConfigProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * FirebaseConfigProto projectId.
             * @member {string} projectId
             * @memberof waiternow.common.FirebaseConfigProto
             * @instance
             */
            FirebaseConfigProto.prototype.projectId = "";

            /**
             * FirebaseConfigProto encryptedMessagingServerKey.
             * @member {string} encryptedMessagingServerKey
             * @memberof waiternow.common.FirebaseConfigProto
             * @instance
             */
            FirebaseConfigProto.prototype.encryptedMessagingServerKey = "";

            /**
             * FirebaseConfigProto databaseUrl.
             * @member {string} databaseUrl
             * @memberof waiternow.common.FirebaseConfigProto
             * @instance
             */
            FirebaseConfigProto.prototype.databaseUrl = "";

            /**
             * FirebaseConfigProto notificationAlertConfig.
             * @member {waiternow.common.FirebaseConfigProto.INotificationAlertConfigProto|null|undefined} notificationAlertConfig
             * @memberof waiternow.common.FirebaseConfigProto
             * @instance
             */
            FirebaseConfigProto.prototype.notificationAlertConfig = null;

            /**
             * Creates a new FirebaseConfigProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FirebaseConfigProto
             * @static
             * @param {waiternow.common.IFirebaseConfigProto=} [properties] Properties to set
             * @returns {waiternow.common.FirebaseConfigProto} FirebaseConfigProto instance
             */
            FirebaseConfigProto.create = function create(properties) {
                return new FirebaseConfigProto(properties);
            };

            /**
             * Encodes the specified FirebaseConfigProto message. Does not implicitly {@link waiternow.common.FirebaseConfigProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FirebaseConfigProto
             * @static
             * @param {waiternow.common.IFirebaseConfigProto} message FirebaseConfigProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FirebaseConfigProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.projectId != null && Object.hasOwnProperty.call(message, "projectId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.projectId);
                if (message.encryptedMessagingServerKey != null && Object.hasOwnProperty.call(message, "encryptedMessagingServerKey"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.encryptedMessagingServerKey);
                if (message.databaseUrl != null && Object.hasOwnProperty.call(message, "databaseUrl"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.databaseUrl);
                if (message.notificationAlertConfig != null && Object.hasOwnProperty.call(message, "notificationAlertConfig"))
                    $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.encode(message.notificationAlertConfig, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified FirebaseConfigProto message, length delimited. Does not implicitly {@link waiternow.common.FirebaseConfigProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FirebaseConfigProto
             * @static
             * @param {waiternow.common.IFirebaseConfigProto} message FirebaseConfigProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FirebaseConfigProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FirebaseConfigProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FirebaseConfigProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FirebaseConfigProto} FirebaseConfigProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FirebaseConfigProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FirebaseConfigProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.projectId = reader.string();
                            break;
                        }
                    case 2: {
                            message.encryptedMessagingServerKey = reader.string();
                            break;
                        }
                    case 3: {
                            message.databaseUrl = reader.string();
                            break;
                        }
                    case 4: {
                            message.notificationAlertConfig = $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FirebaseConfigProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FirebaseConfigProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FirebaseConfigProto} FirebaseConfigProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FirebaseConfigProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FirebaseConfigProto message.
             * @function verify
             * @memberof waiternow.common.FirebaseConfigProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FirebaseConfigProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.projectId != null && message.hasOwnProperty("projectId"))
                    if (!$util.isString(message.projectId))
                        return "projectId: string expected";
                if (message.encryptedMessagingServerKey != null && message.hasOwnProperty("encryptedMessagingServerKey"))
                    if (!$util.isString(message.encryptedMessagingServerKey))
                        return "encryptedMessagingServerKey: string expected";
                if (message.databaseUrl != null && message.hasOwnProperty("databaseUrl"))
                    if (!$util.isString(message.databaseUrl))
                        return "databaseUrl: string expected";
                if (message.notificationAlertConfig != null && message.hasOwnProperty("notificationAlertConfig")) {
                    var error = $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.verify(message.notificationAlertConfig);
                    if (error)
                        return "notificationAlertConfig." + error;
                }
                return null;
            };

            /**
             * Creates a FirebaseConfigProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FirebaseConfigProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FirebaseConfigProto} FirebaseConfigProto
             */
            FirebaseConfigProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FirebaseConfigProto)
                    return object;
                var message = new $root.waiternow.common.FirebaseConfigProto();
                if (object.projectId != null)
                    message.projectId = String(object.projectId);
                if (object.encryptedMessagingServerKey != null)
                    message.encryptedMessagingServerKey = String(object.encryptedMessagingServerKey);
                if (object.databaseUrl != null)
                    message.databaseUrl = String(object.databaseUrl);
                if (object.notificationAlertConfig != null) {
                    if (typeof object.notificationAlertConfig !== "object")
                        throw TypeError(".waiternow.common.FirebaseConfigProto.notificationAlertConfig: object expected");
                    message.notificationAlertConfig = $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.fromObject(object.notificationAlertConfig);
                }
                return message;
            };

            /**
             * Creates a plain object from a FirebaseConfigProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FirebaseConfigProto
             * @static
             * @param {waiternow.common.FirebaseConfigProto} message FirebaseConfigProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FirebaseConfigProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.projectId = "";
                    object.encryptedMessagingServerKey = "";
                    object.databaseUrl = "";
                    object.notificationAlertConfig = null;
                }
                if (message.projectId != null && message.hasOwnProperty("projectId"))
                    object.projectId = message.projectId;
                if (message.encryptedMessagingServerKey != null && message.hasOwnProperty("encryptedMessagingServerKey"))
                    object.encryptedMessagingServerKey = message.encryptedMessagingServerKey;
                if (message.databaseUrl != null && message.hasOwnProperty("databaseUrl"))
                    object.databaseUrl = message.databaseUrl;
                if (message.notificationAlertConfig != null && message.hasOwnProperty("notificationAlertConfig"))
                    object.notificationAlertConfig = $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.toObject(message.notificationAlertConfig, options);
                return object;
            };

            /**
             * Converts this FirebaseConfigProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FirebaseConfigProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FirebaseConfigProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FirebaseConfigProto
             * @function getTypeUrl
             * @memberof waiternow.common.FirebaseConfigProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FirebaseConfigProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FirebaseConfigProto";
            };

            FirebaseConfigProto.NotificationAlertConfigProto = (function() {

                /**
                 * Properties of a NotificationAlertConfigProto.
                 * @memberof waiternow.common.FirebaseConfigProto
                 * @interface INotificationAlertConfigProto
                 * @property {string|null} [imageUrl] NotificationAlertConfigProto imageUrl
                 * @property {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.IUserAlertsConfigProto|null} [userAlertsConfig] NotificationAlertConfigProto userAlertsConfig
                 * @property {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.IConsumerAlertsConfigProto|null} [consumerAlertsConfig] NotificationAlertConfigProto consumerAlertsConfig
                 */

                /**
                 * Constructs a new NotificationAlertConfigProto.
                 * @memberof waiternow.common.FirebaseConfigProto
                 * @classdesc Represents a NotificationAlertConfigProto.
                 * @implements INotificationAlertConfigProto
                 * @constructor
                 * @param {waiternow.common.FirebaseConfigProto.INotificationAlertConfigProto=} [properties] Properties to set
                 */
                function NotificationAlertConfigProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * NotificationAlertConfigProto imageUrl.
                 * @member {string} imageUrl
                 * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto
                 * @instance
                 */
                NotificationAlertConfigProto.prototype.imageUrl = "";

                /**
                 * NotificationAlertConfigProto userAlertsConfig.
                 * @member {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.IUserAlertsConfigProto|null|undefined} userAlertsConfig
                 * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto
                 * @instance
                 */
                NotificationAlertConfigProto.prototype.userAlertsConfig = null;

                /**
                 * NotificationAlertConfigProto consumerAlertsConfig.
                 * @member {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.IConsumerAlertsConfigProto|null|undefined} consumerAlertsConfig
                 * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto
                 * @instance
                 */
                NotificationAlertConfigProto.prototype.consumerAlertsConfig = null;

                /**
                 * Creates a new NotificationAlertConfigProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto
                 * @static
                 * @param {waiternow.common.FirebaseConfigProto.INotificationAlertConfigProto=} [properties] Properties to set
                 * @returns {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto} NotificationAlertConfigProto instance
                 */
                NotificationAlertConfigProto.create = function create(properties) {
                    return new NotificationAlertConfigProto(properties);
                };

                /**
                 * Encodes the specified NotificationAlertConfigProto message. Does not implicitly {@link waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto
                 * @static
                 * @param {waiternow.common.FirebaseConfigProto.INotificationAlertConfigProto} message NotificationAlertConfigProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                NotificationAlertConfigProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.imageUrl != null && Object.hasOwnProperty.call(message, "imageUrl"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.imageUrl);
                    if (message.userAlertsConfig != null && Object.hasOwnProperty.call(message, "userAlertsConfig"))
                        $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.encode(message.userAlertsConfig, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.consumerAlertsConfig != null && Object.hasOwnProperty.call(message, "consumerAlertsConfig"))
                        $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto.encode(message.consumerAlertsConfig, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified NotificationAlertConfigProto message, length delimited. Does not implicitly {@link waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto
                 * @static
                 * @param {waiternow.common.FirebaseConfigProto.INotificationAlertConfigProto} message NotificationAlertConfigProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                NotificationAlertConfigProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a NotificationAlertConfigProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto} NotificationAlertConfigProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                NotificationAlertConfigProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.imageUrl = reader.string();
                                break;
                            }
                        case 2: {
                                message.userAlertsConfig = $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.consumerAlertsConfig = $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a NotificationAlertConfigProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto} NotificationAlertConfigProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                NotificationAlertConfigProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a NotificationAlertConfigProto message.
                 * @function verify
                 * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                NotificationAlertConfigProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.imageUrl != null && message.hasOwnProperty("imageUrl"))
                        if (!$util.isString(message.imageUrl))
                            return "imageUrl: string expected";
                    if (message.userAlertsConfig != null && message.hasOwnProperty("userAlertsConfig")) {
                        var error = $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.verify(message.userAlertsConfig);
                        if (error)
                            return "userAlertsConfig." + error;
                    }
                    if (message.consumerAlertsConfig != null && message.hasOwnProperty("consumerAlertsConfig")) {
                        var error = $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto.verify(message.consumerAlertsConfig);
                        if (error)
                            return "consumerAlertsConfig." + error;
                    }
                    return null;
                };

                /**
                 * Creates a NotificationAlertConfigProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto} NotificationAlertConfigProto
                 */
                NotificationAlertConfigProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto)
                        return object;
                    var message = new $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto();
                    if (object.imageUrl != null)
                        message.imageUrl = String(object.imageUrl);
                    if (object.userAlertsConfig != null) {
                        if (typeof object.userAlertsConfig !== "object")
                            throw TypeError(".waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.userAlertsConfig: object expected");
                        message.userAlertsConfig = $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.fromObject(object.userAlertsConfig);
                    }
                    if (object.consumerAlertsConfig != null) {
                        if (typeof object.consumerAlertsConfig !== "object")
                            throw TypeError(".waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.consumerAlertsConfig: object expected");
                        message.consumerAlertsConfig = $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto.fromObject(object.consumerAlertsConfig);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a NotificationAlertConfigProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto
                 * @static
                 * @param {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto} message NotificationAlertConfigProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                NotificationAlertConfigProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.imageUrl = "";
                        object.userAlertsConfig = null;
                        object.consumerAlertsConfig = null;
                    }
                    if (message.imageUrl != null && message.hasOwnProperty("imageUrl"))
                        object.imageUrl = message.imageUrl;
                    if (message.userAlertsConfig != null && message.hasOwnProperty("userAlertsConfig"))
                        object.userAlertsConfig = $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.toObject(message.userAlertsConfig, options);
                    if (message.consumerAlertsConfig != null && message.hasOwnProperty("consumerAlertsConfig"))
                        object.consumerAlertsConfig = $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto.toObject(message.consumerAlertsConfig, options);
                    return object;
                };

                /**
                 * Converts this NotificationAlertConfigProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                NotificationAlertConfigProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for NotificationAlertConfigProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                NotificationAlertConfigProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto";
                };

                NotificationAlertConfigProto.LocalizedConfigProto = (function() {

                    /**
                     * Properties of a LocalizedConfigProto.
                     * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto
                     * @interface ILocalizedConfigProto
                     * @property {waiternow.common.Language|null} [language] LocalizedConfigProto language
                     * @property {string|null} [title] LocalizedConfigProto title
                     * @property {string|null} [body] LocalizedConfigProto body
                     */

                    /**
                     * Constructs a new LocalizedConfigProto.
                     * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto
                     * @classdesc Represents a LocalizedConfigProto.
                     * @implements ILocalizedConfigProto
                     * @constructor
                     * @param {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ILocalizedConfigProto=} [properties] Properties to set
                     */
                    function LocalizedConfigProto(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * LocalizedConfigProto language.
                     * @member {waiternow.common.Language} language
                     * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.LocalizedConfigProto
                     * @instance
                     */
                    LocalizedConfigProto.prototype.language = 0;

                    /**
                     * LocalizedConfigProto title.
                     * @member {string} title
                     * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.LocalizedConfigProto
                     * @instance
                     */
                    LocalizedConfigProto.prototype.title = "";

                    /**
                     * LocalizedConfigProto body.
                     * @member {string} body
                     * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.LocalizedConfigProto
                     * @instance
                     */
                    LocalizedConfigProto.prototype.body = "";

                    /**
                     * Creates a new LocalizedConfigProto instance using the specified properties.
                     * @function create
                     * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.LocalizedConfigProto
                     * @static
                     * @param {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ILocalizedConfigProto=} [properties] Properties to set
                     * @returns {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.LocalizedConfigProto} LocalizedConfigProto instance
                     */
                    LocalizedConfigProto.create = function create(properties) {
                        return new LocalizedConfigProto(properties);
                    };

                    /**
                     * Encodes the specified LocalizedConfigProto message. Does not implicitly {@link waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.LocalizedConfigProto.verify|verify} messages.
                     * @function encode
                     * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.LocalizedConfigProto
                     * @static
                     * @param {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ILocalizedConfigProto} message LocalizedConfigProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    LocalizedConfigProto.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.language != null && Object.hasOwnProperty.call(message, "language"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.language);
                        if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.title);
                        if (message.body != null && Object.hasOwnProperty.call(message, "body"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.body);
                        return writer;
                    };

                    /**
                     * Encodes the specified LocalizedConfigProto message, length delimited. Does not implicitly {@link waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.LocalizedConfigProto.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.LocalizedConfigProto
                     * @static
                     * @param {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ILocalizedConfigProto} message LocalizedConfigProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    LocalizedConfigProto.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a LocalizedConfigProto message from the specified reader or buffer.
                     * @function decode
                     * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.LocalizedConfigProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.LocalizedConfigProto} LocalizedConfigProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    LocalizedConfigProto.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.LocalizedConfigProto();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.language = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.title = reader.string();
                                    break;
                                }
                            case 3: {
                                    message.body = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a LocalizedConfigProto message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.LocalizedConfigProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.LocalizedConfigProto} LocalizedConfigProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    LocalizedConfigProto.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a LocalizedConfigProto message.
                     * @function verify
                     * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.LocalizedConfigProto
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    LocalizedConfigProto.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.language != null && message.hasOwnProperty("language"))
                            switch (message.language) {
                            default:
                                return "language: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.title != null && message.hasOwnProperty("title"))
                            if (!$util.isString(message.title))
                                return "title: string expected";
                        if (message.body != null && message.hasOwnProperty("body"))
                            if (!$util.isString(message.body))
                                return "body: string expected";
                        return null;
                    };

                    /**
                     * Creates a LocalizedConfigProto message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.LocalizedConfigProto
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.LocalizedConfigProto} LocalizedConfigProto
                     */
                    LocalizedConfigProto.fromObject = function fromObject(object) {
                        if (object instanceof $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.LocalizedConfigProto)
                            return object;
                        var message = new $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.LocalizedConfigProto();
                        switch (object.language) {
                        default:
                            if (typeof object.language === "number") {
                                message.language = object.language;
                                break;
                            }
                            break;
                        case "LANGUAGE_UNSPECIFIED":
                        case 0:
                            message.language = 0;
                            break;
                        case "ENGLISH":
                        case 1:
                            message.language = 1;
                            break;
                        case "SPANISH":
                        case 2:
                            message.language = 2;
                            break;
                        }
                        if (object.title != null)
                            message.title = String(object.title);
                        if (object.body != null)
                            message.body = String(object.body);
                        return message;
                    };

                    /**
                     * Creates a plain object from a LocalizedConfigProto message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.LocalizedConfigProto
                     * @static
                     * @param {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.LocalizedConfigProto} message LocalizedConfigProto
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    LocalizedConfigProto.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.language = options.enums === String ? "LANGUAGE_UNSPECIFIED" : 0;
                            object.title = "";
                            object.body = "";
                        }
                        if (message.language != null && message.hasOwnProperty("language"))
                            object.language = options.enums === String ? $root.waiternow.common.Language[message.language] === undefined ? message.language : $root.waiternow.common.Language[message.language] : message.language;
                        if (message.title != null && message.hasOwnProperty("title"))
                            object.title = message.title;
                        if (message.body != null && message.hasOwnProperty("body"))
                            object.body = message.body;
                        return object;
                    };

                    /**
                     * Converts this LocalizedConfigProto to JSON.
                     * @function toJSON
                     * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.LocalizedConfigProto
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    LocalizedConfigProto.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for LocalizedConfigProto
                     * @function getTypeUrl
                     * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.LocalizedConfigProto
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    LocalizedConfigProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.LocalizedConfigProto";
                    };

                    return LocalizedConfigProto;
                })();

                NotificationAlertConfigProto.UserAlertsConfigProto = (function() {

                    /**
                     * Properties of a UserAlertsConfigProto.
                     * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto
                     * @interface IUserAlertsConfigProto
                     * @property {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.INewOrderAlertConfigProto|null} [newOrderAlertConfig] UserAlertsConfigProto newOrderAlertConfig
                     * @property {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.IOrderStatusUpdatedAlertConfigProto|null} [orderStatusUpdatedAlertConfig] UserAlertsConfigProto orderStatusUpdatedAlertConfig
                     */

                    /**
                     * Constructs a new UserAlertsConfigProto.
                     * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto
                     * @classdesc Represents a UserAlertsConfigProto.
                     * @implements IUserAlertsConfigProto
                     * @constructor
                     * @param {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.IUserAlertsConfigProto=} [properties] Properties to set
                     */
                    function UserAlertsConfigProto(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * UserAlertsConfigProto newOrderAlertConfig.
                     * @member {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.INewOrderAlertConfigProto|null|undefined} newOrderAlertConfig
                     * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto
                     * @instance
                     */
                    UserAlertsConfigProto.prototype.newOrderAlertConfig = null;

                    /**
                     * UserAlertsConfigProto orderStatusUpdatedAlertConfig.
                     * @member {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.IOrderStatusUpdatedAlertConfigProto|null|undefined} orderStatusUpdatedAlertConfig
                     * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto
                     * @instance
                     */
                    UserAlertsConfigProto.prototype.orderStatusUpdatedAlertConfig = null;

                    /**
                     * Creates a new UserAlertsConfigProto instance using the specified properties.
                     * @function create
                     * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto
                     * @static
                     * @param {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.IUserAlertsConfigProto=} [properties] Properties to set
                     * @returns {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto} UserAlertsConfigProto instance
                     */
                    UserAlertsConfigProto.create = function create(properties) {
                        return new UserAlertsConfigProto(properties);
                    };

                    /**
                     * Encodes the specified UserAlertsConfigProto message. Does not implicitly {@link waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.verify|verify} messages.
                     * @function encode
                     * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto
                     * @static
                     * @param {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.IUserAlertsConfigProto} message UserAlertsConfigProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UserAlertsConfigProto.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.newOrderAlertConfig != null && Object.hasOwnProperty.call(message, "newOrderAlertConfig"))
                            $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.NewOrderAlertConfigProto.encode(message.newOrderAlertConfig, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.orderStatusUpdatedAlertConfig != null && Object.hasOwnProperty.call(message, "orderStatusUpdatedAlertConfig"))
                            $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.OrderStatusUpdatedAlertConfigProto.encode(message.orderStatusUpdatedAlertConfig, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };

                    /**
                     * Encodes the specified UserAlertsConfigProto message, length delimited. Does not implicitly {@link waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto
                     * @static
                     * @param {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.IUserAlertsConfigProto} message UserAlertsConfigProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UserAlertsConfigProto.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a UserAlertsConfigProto message from the specified reader or buffer.
                     * @function decode
                     * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto} UserAlertsConfigProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UserAlertsConfigProto.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.newOrderAlertConfig = $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.NewOrderAlertConfigProto.decode(reader, reader.uint32());
                                    break;
                                }
                            case 2: {
                                    message.orderStatusUpdatedAlertConfig = $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.OrderStatusUpdatedAlertConfigProto.decode(reader, reader.uint32());
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a UserAlertsConfigProto message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto} UserAlertsConfigProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UserAlertsConfigProto.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a UserAlertsConfigProto message.
                     * @function verify
                     * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UserAlertsConfigProto.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.newOrderAlertConfig != null && message.hasOwnProperty("newOrderAlertConfig")) {
                            var error = $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.NewOrderAlertConfigProto.verify(message.newOrderAlertConfig);
                            if (error)
                                return "newOrderAlertConfig." + error;
                        }
                        if (message.orderStatusUpdatedAlertConfig != null && message.hasOwnProperty("orderStatusUpdatedAlertConfig")) {
                            var error = $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.OrderStatusUpdatedAlertConfigProto.verify(message.orderStatusUpdatedAlertConfig);
                            if (error)
                                return "orderStatusUpdatedAlertConfig." + error;
                        }
                        return null;
                    };

                    /**
                     * Creates a UserAlertsConfigProto message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto} UserAlertsConfigProto
                     */
                    UserAlertsConfigProto.fromObject = function fromObject(object) {
                        if (object instanceof $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto)
                            return object;
                        var message = new $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto();
                        if (object.newOrderAlertConfig != null) {
                            if (typeof object.newOrderAlertConfig !== "object")
                                throw TypeError(".waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.newOrderAlertConfig: object expected");
                            message.newOrderAlertConfig = $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.NewOrderAlertConfigProto.fromObject(object.newOrderAlertConfig);
                        }
                        if (object.orderStatusUpdatedAlertConfig != null) {
                            if (typeof object.orderStatusUpdatedAlertConfig !== "object")
                                throw TypeError(".waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.orderStatusUpdatedAlertConfig: object expected");
                            message.orderStatusUpdatedAlertConfig = $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.OrderStatusUpdatedAlertConfigProto.fromObject(object.orderStatusUpdatedAlertConfig);
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a UserAlertsConfigProto message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto
                     * @static
                     * @param {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto} message UserAlertsConfigProto
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UserAlertsConfigProto.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.newOrderAlertConfig = null;
                            object.orderStatusUpdatedAlertConfig = null;
                        }
                        if (message.newOrderAlertConfig != null && message.hasOwnProperty("newOrderAlertConfig"))
                            object.newOrderAlertConfig = $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.NewOrderAlertConfigProto.toObject(message.newOrderAlertConfig, options);
                        if (message.orderStatusUpdatedAlertConfig != null && message.hasOwnProperty("orderStatusUpdatedAlertConfig"))
                            object.orderStatusUpdatedAlertConfig = $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.OrderStatusUpdatedAlertConfigProto.toObject(message.orderStatusUpdatedAlertConfig, options);
                        return object;
                    };

                    /**
                     * Converts this UserAlertsConfigProto to JSON.
                     * @function toJSON
                     * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UserAlertsConfigProto.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for UserAlertsConfigProto
                     * @function getTypeUrl
                     * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    UserAlertsConfigProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto";
                    };

                    UserAlertsConfigProto.NewOrderAlertConfigProto = (function() {

                        /**
                         * Properties of a NewOrderAlertConfigProto.
                         * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto
                         * @interface INewOrderAlertConfigProto
                         * @property {string|null} [redirectLink] NewOrderAlertConfigProto redirectLink
                         * @property {Array.<waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ILocalizedConfigProto>|null} [localizedConfigurations] NewOrderAlertConfigProto localizedConfigurations
                         */

                        /**
                         * Constructs a new NewOrderAlertConfigProto.
                         * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto
                         * @classdesc Represents a NewOrderAlertConfigProto.
                         * @implements INewOrderAlertConfigProto
                         * @constructor
                         * @param {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.INewOrderAlertConfigProto=} [properties] Properties to set
                         */
                        function NewOrderAlertConfigProto(properties) {
                            this.localizedConfigurations = [];
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * NewOrderAlertConfigProto redirectLink.
                         * @member {string} redirectLink
                         * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.NewOrderAlertConfigProto
                         * @instance
                         */
                        NewOrderAlertConfigProto.prototype.redirectLink = "";

                        /**
                         * NewOrderAlertConfigProto localizedConfigurations.
                         * @member {Array.<waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ILocalizedConfigProto>} localizedConfigurations
                         * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.NewOrderAlertConfigProto
                         * @instance
                         */
                        NewOrderAlertConfigProto.prototype.localizedConfigurations = $util.emptyArray;

                        /**
                         * Creates a new NewOrderAlertConfigProto instance using the specified properties.
                         * @function create
                         * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.NewOrderAlertConfigProto
                         * @static
                         * @param {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.INewOrderAlertConfigProto=} [properties] Properties to set
                         * @returns {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.NewOrderAlertConfigProto} NewOrderAlertConfigProto instance
                         */
                        NewOrderAlertConfigProto.create = function create(properties) {
                            return new NewOrderAlertConfigProto(properties);
                        };

                        /**
                         * Encodes the specified NewOrderAlertConfigProto message. Does not implicitly {@link waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.NewOrderAlertConfigProto.verify|verify} messages.
                         * @function encode
                         * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.NewOrderAlertConfigProto
                         * @static
                         * @param {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.INewOrderAlertConfigProto} message NewOrderAlertConfigProto message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        NewOrderAlertConfigProto.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.redirectLink != null && Object.hasOwnProperty.call(message, "redirectLink"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.redirectLink);
                            if (message.localizedConfigurations != null && message.localizedConfigurations.length)
                                for (var i = 0; i < message.localizedConfigurations.length; ++i)
                                    $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.LocalizedConfigProto.encode(message.localizedConfigurations[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                            return writer;
                        };

                        /**
                         * Encodes the specified NewOrderAlertConfigProto message, length delimited. Does not implicitly {@link waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.NewOrderAlertConfigProto.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.NewOrderAlertConfigProto
                         * @static
                         * @param {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.INewOrderAlertConfigProto} message NewOrderAlertConfigProto message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        NewOrderAlertConfigProto.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a NewOrderAlertConfigProto message from the specified reader or buffer.
                         * @function decode
                         * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.NewOrderAlertConfigProto
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.NewOrderAlertConfigProto} NewOrderAlertConfigProto
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        NewOrderAlertConfigProto.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.NewOrderAlertConfigProto();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1: {
                                        message.redirectLink = reader.string();
                                        break;
                                    }
                                case 2: {
                                        if (!(message.localizedConfigurations && message.localizedConfigurations.length))
                                            message.localizedConfigurations = [];
                                        message.localizedConfigurations.push($root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.LocalizedConfigProto.decode(reader, reader.uint32()));
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a NewOrderAlertConfigProto message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.NewOrderAlertConfigProto
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.NewOrderAlertConfigProto} NewOrderAlertConfigProto
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        NewOrderAlertConfigProto.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a NewOrderAlertConfigProto message.
                         * @function verify
                         * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.NewOrderAlertConfigProto
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        NewOrderAlertConfigProto.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.redirectLink != null && message.hasOwnProperty("redirectLink"))
                                if (!$util.isString(message.redirectLink))
                                    return "redirectLink: string expected";
                            if (message.localizedConfigurations != null && message.hasOwnProperty("localizedConfigurations")) {
                                if (!Array.isArray(message.localizedConfigurations))
                                    return "localizedConfigurations: array expected";
                                for (var i = 0; i < message.localizedConfigurations.length; ++i) {
                                    var error = $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.LocalizedConfigProto.verify(message.localizedConfigurations[i]);
                                    if (error)
                                        return "localizedConfigurations." + error;
                                }
                            }
                            return null;
                        };

                        /**
                         * Creates a NewOrderAlertConfigProto message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.NewOrderAlertConfigProto
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.NewOrderAlertConfigProto} NewOrderAlertConfigProto
                         */
                        NewOrderAlertConfigProto.fromObject = function fromObject(object) {
                            if (object instanceof $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.NewOrderAlertConfigProto)
                                return object;
                            var message = new $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.NewOrderAlertConfigProto();
                            if (object.redirectLink != null)
                                message.redirectLink = String(object.redirectLink);
                            if (object.localizedConfigurations) {
                                if (!Array.isArray(object.localizedConfigurations))
                                    throw TypeError(".waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.NewOrderAlertConfigProto.localizedConfigurations: array expected");
                                message.localizedConfigurations = [];
                                for (var i = 0; i < object.localizedConfigurations.length; ++i) {
                                    if (typeof object.localizedConfigurations[i] !== "object")
                                        throw TypeError(".waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.NewOrderAlertConfigProto.localizedConfigurations: object expected");
                                    message.localizedConfigurations[i] = $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.LocalizedConfigProto.fromObject(object.localizedConfigurations[i]);
                                }
                            }
                            return message;
                        };

                        /**
                         * Creates a plain object from a NewOrderAlertConfigProto message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.NewOrderAlertConfigProto
                         * @static
                         * @param {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.NewOrderAlertConfigProto} message NewOrderAlertConfigProto
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        NewOrderAlertConfigProto.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.arrays || options.defaults)
                                object.localizedConfigurations = [];
                            if (options.defaults)
                                object.redirectLink = "";
                            if (message.redirectLink != null && message.hasOwnProperty("redirectLink"))
                                object.redirectLink = message.redirectLink;
                            if (message.localizedConfigurations && message.localizedConfigurations.length) {
                                object.localizedConfigurations = [];
                                for (var j = 0; j < message.localizedConfigurations.length; ++j)
                                    object.localizedConfigurations[j] = $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.LocalizedConfigProto.toObject(message.localizedConfigurations[j], options);
                            }
                            return object;
                        };

                        /**
                         * Converts this NewOrderAlertConfigProto to JSON.
                         * @function toJSON
                         * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.NewOrderAlertConfigProto
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        NewOrderAlertConfigProto.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for NewOrderAlertConfigProto
                         * @function getTypeUrl
                         * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.NewOrderAlertConfigProto
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        NewOrderAlertConfigProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.NewOrderAlertConfigProto";
                        };

                        return NewOrderAlertConfigProto;
                    })();

                    UserAlertsConfigProto.OrderStatusUpdatedAlertConfigProto = (function() {

                        /**
                         * Properties of an OrderStatusUpdatedAlertConfigProto.
                         * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto
                         * @interface IOrderStatusUpdatedAlertConfigProto
                         * @property {string|null} [redirectLink] OrderStatusUpdatedAlertConfigProto redirectLink
                         * @property {Array.<waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ILocalizedConfigProto>|null} [localizedConfigurations] OrderStatusUpdatedAlertConfigProto localizedConfigurations
                         */

                        /**
                         * Constructs a new OrderStatusUpdatedAlertConfigProto.
                         * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto
                         * @classdesc Represents an OrderStatusUpdatedAlertConfigProto.
                         * @implements IOrderStatusUpdatedAlertConfigProto
                         * @constructor
                         * @param {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.IOrderStatusUpdatedAlertConfigProto=} [properties] Properties to set
                         */
                        function OrderStatusUpdatedAlertConfigProto(properties) {
                            this.localizedConfigurations = [];
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * OrderStatusUpdatedAlertConfigProto redirectLink.
                         * @member {string} redirectLink
                         * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.OrderStatusUpdatedAlertConfigProto
                         * @instance
                         */
                        OrderStatusUpdatedAlertConfigProto.prototype.redirectLink = "";

                        /**
                         * OrderStatusUpdatedAlertConfigProto localizedConfigurations.
                         * @member {Array.<waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ILocalizedConfigProto>} localizedConfigurations
                         * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.OrderStatusUpdatedAlertConfigProto
                         * @instance
                         */
                        OrderStatusUpdatedAlertConfigProto.prototype.localizedConfigurations = $util.emptyArray;

                        /**
                         * Creates a new OrderStatusUpdatedAlertConfigProto instance using the specified properties.
                         * @function create
                         * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.OrderStatusUpdatedAlertConfigProto
                         * @static
                         * @param {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.IOrderStatusUpdatedAlertConfigProto=} [properties] Properties to set
                         * @returns {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.OrderStatusUpdatedAlertConfigProto} OrderStatusUpdatedAlertConfigProto instance
                         */
                        OrderStatusUpdatedAlertConfigProto.create = function create(properties) {
                            return new OrderStatusUpdatedAlertConfigProto(properties);
                        };

                        /**
                         * Encodes the specified OrderStatusUpdatedAlertConfigProto message. Does not implicitly {@link waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.OrderStatusUpdatedAlertConfigProto.verify|verify} messages.
                         * @function encode
                         * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.OrderStatusUpdatedAlertConfigProto
                         * @static
                         * @param {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.IOrderStatusUpdatedAlertConfigProto} message OrderStatusUpdatedAlertConfigProto message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        OrderStatusUpdatedAlertConfigProto.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.redirectLink != null && Object.hasOwnProperty.call(message, "redirectLink"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.redirectLink);
                            if (message.localizedConfigurations != null && message.localizedConfigurations.length)
                                for (var i = 0; i < message.localizedConfigurations.length; ++i)
                                    $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.LocalizedConfigProto.encode(message.localizedConfigurations[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                            return writer;
                        };

                        /**
                         * Encodes the specified OrderStatusUpdatedAlertConfigProto message, length delimited. Does not implicitly {@link waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.OrderStatusUpdatedAlertConfigProto.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.OrderStatusUpdatedAlertConfigProto
                         * @static
                         * @param {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.IOrderStatusUpdatedAlertConfigProto} message OrderStatusUpdatedAlertConfigProto message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        OrderStatusUpdatedAlertConfigProto.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes an OrderStatusUpdatedAlertConfigProto message from the specified reader or buffer.
                         * @function decode
                         * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.OrderStatusUpdatedAlertConfigProto
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.OrderStatusUpdatedAlertConfigProto} OrderStatusUpdatedAlertConfigProto
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        OrderStatusUpdatedAlertConfigProto.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.OrderStatusUpdatedAlertConfigProto();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1: {
                                        message.redirectLink = reader.string();
                                        break;
                                    }
                                case 2: {
                                        if (!(message.localizedConfigurations && message.localizedConfigurations.length))
                                            message.localizedConfigurations = [];
                                        message.localizedConfigurations.push($root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.LocalizedConfigProto.decode(reader, reader.uint32()));
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes an OrderStatusUpdatedAlertConfigProto message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.OrderStatusUpdatedAlertConfigProto
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.OrderStatusUpdatedAlertConfigProto} OrderStatusUpdatedAlertConfigProto
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        OrderStatusUpdatedAlertConfigProto.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies an OrderStatusUpdatedAlertConfigProto message.
                         * @function verify
                         * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.OrderStatusUpdatedAlertConfigProto
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        OrderStatusUpdatedAlertConfigProto.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.redirectLink != null && message.hasOwnProperty("redirectLink"))
                                if (!$util.isString(message.redirectLink))
                                    return "redirectLink: string expected";
                            if (message.localizedConfigurations != null && message.hasOwnProperty("localizedConfigurations")) {
                                if (!Array.isArray(message.localizedConfigurations))
                                    return "localizedConfigurations: array expected";
                                for (var i = 0; i < message.localizedConfigurations.length; ++i) {
                                    var error = $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.LocalizedConfigProto.verify(message.localizedConfigurations[i]);
                                    if (error)
                                        return "localizedConfigurations." + error;
                                }
                            }
                            return null;
                        };

                        /**
                         * Creates an OrderStatusUpdatedAlertConfigProto message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.OrderStatusUpdatedAlertConfigProto
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.OrderStatusUpdatedAlertConfigProto} OrderStatusUpdatedAlertConfigProto
                         */
                        OrderStatusUpdatedAlertConfigProto.fromObject = function fromObject(object) {
                            if (object instanceof $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.OrderStatusUpdatedAlertConfigProto)
                                return object;
                            var message = new $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.OrderStatusUpdatedAlertConfigProto();
                            if (object.redirectLink != null)
                                message.redirectLink = String(object.redirectLink);
                            if (object.localizedConfigurations) {
                                if (!Array.isArray(object.localizedConfigurations))
                                    throw TypeError(".waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.OrderStatusUpdatedAlertConfigProto.localizedConfigurations: array expected");
                                message.localizedConfigurations = [];
                                for (var i = 0; i < object.localizedConfigurations.length; ++i) {
                                    if (typeof object.localizedConfigurations[i] !== "object")
                                        throw TypeError(".waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.OrderStatusUpdatedAlertConfigProto.localizedConfigurations: object expected");
                                    message.localizedConfigurations[i] = $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.LocalizedConfigProto.fromObject(object.localizedConfigurations[i]);
                                }
                            }
                            return message;
                        };

                        /**
                         * Creates a plain object from an OrderStatusUpdatedAlertConfigProto message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.OrderStatusUpdatedAlertConfigProto
                         * @static
                         * @param {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.OrderStatusUpdatedAlertConfigProto} message OrderStatusUpdatedAlertConfigProto
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        OrderStatusUpdatedAlertConfigProto.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.arrays || options.defaults)
                                object.localizedConfigurations = [];
                            if (options.defaults)
                                object.redirectLink = "";
                            if (message.redirectLink != null && message.hasOwnProperty("redirectLink"))
                                object.redirectLink = message.redirectLink;
                            if (message.localizedConfigurations && message.localizedConfigurations.length) {
                                object.localizedConfigurations = [];
                                for (var j = 0; j < message.localizedConfigurations.length; ++j)
                                    object.localizedConfigurations[j] = $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.LocalizedConfigProto.toObject(message.localizedConfigurations[j], options);
                            }
                            return object;
                        };

                        /**
                         * Converts this OrderStatusUpdatedAlertConfigProto to JSON.
                         * @function toJSON
                         * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.OrderStatusUpdatedAlertConfigProto
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        OrderStatusUpdatedAlertConfigProto.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for OrderStatusUpdatedAlertConfigProto
                         * @function getTypeUrl
                         * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.OrderStatusUpdatedAlertConfigProto
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        OrderStatusUpdatedAlertConfigProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.UserAlertsConfigProto.OrderStatusUpdatedAlertConfigProto";
                        };

                        return OrderStatusUpdatedAlertConfigProto;
                    })();

                    return UserAlertsConfigProto;
                })();

                NotificationAlertConfigProto.ConsumerAlertsConfigProto = (function() {

                    /**
                     * Properties of a ConsumerAlertsConfigProto.
                     * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto
                     * @interface IConsumerAlertsConfigProto
                     * @property {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto.IOrderStatusUpdatedAlertConfigProto|null} [orderStatusUpdatedAlertConfig] ConsumerAlertsConfigProto orderStatusUpdatedAlertConfig
                     */

                    /**
                     * Constructs a new ConsumerAlertsConfigProto.
                     * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto
                     * @classdesc Represents a ConsumerAlertsConfigProto.
                     * @implements IConsumerAlertsConfigProto
                     * @constructor
                     * @param {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.IConsumerAlertsConfigProto=} [properties] Properties to set
                     */
                    function ConsumerAlertsConfigProto(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * ConsumerAlertsConfigProto orderStatusUpdatedAlertConfig.
                     * @member {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto.IOrderStatusUpdatedAlertConfigProto|null|undefined} orderStatusUpdatedAlertConfig
                     * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto
                     * @instance
                     */
                    ConsumerAlertsConfigProto.prototype.orderStatusUpdatedAlertConfig = null;

                    /**
                     * Creates a new ConsumerAlertsConfigProto instance using the specified properties.
                     * @function create
                     * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto
                     * @static
                     * @param {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.IConsumerAlertsConfigProto=} [properties] Properties to set
                     * @returns {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto} ConsumerAlertsConfigProto instance
                     */
                    ConsumerAlertsConfigProto.create = function create(properties) {
                        return new ConsumerAlertsConfigProto(properties);
                    };

                    /**
                     * Encodes the specified ConsumerAlertsConfigProto message. Does not implicitly {@link waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto.verify|verify} messages.
                     * @function encode
                     * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto
                     * @static
                     * @param {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.IConsumerAlertsConfigProto} message ConsumerAlertsConfigProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ConsumerAlertsConfigProto.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.orderStatusUpdatedAlertConfig != null && Object.hasOwnProperty.call(message, "orderStatusUpdatedAlertConfig"))
                            $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto.OrderStatusUpdatedAlertConfigProto.encode(message.orderStatusUpdatedAlertConfig, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };

                    /**
                     * Encodes the specified ConsumerAlertsConfigProto message, length delimited. Does not implicitly {@link waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto
                     * @static
                     * @param {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.IConsumerAlertsConfigProto} message ConsumerAlertsConfigProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ConsumerAlertsConfigProto.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a ConsumerAlertsConfigProto message from the specified reader or buffer.
                     * @function decode
                     * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto} ConsumerAlertsConfigProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ConsumerAlertsConfigProto.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.orderStatusUpdatedAlertConfig = $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto.OrderStatusUpdatedAlertConfigProto.decode(reader, reader.uint32());
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a ConsumerAlertsConfigProto message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto} ConsumerAlertsConfigProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ConsumerAlertsConfigProto.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a ConsumerAlertsConfigProto message.
                     * @function verify
                     * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ConsumerAlertsConfigProto.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.orderStatusUpdatedAlertConfig != null && message.hasOwnProperty("orderStatusUpdatedAlertConfig")) {
                            var error = $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto.OrderStatusUpdatedAlertConfigProto.verify(message.orderStatusUpdatedAlertConfig);
                            if (error)
                                return "orderStatusUpdatedAlertConfig." + error;
                        }
                        return null;
                    };

                    /**
                     * Creates a ConsumerAlertsConfigProto message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto} ConsumerAlertsConfigProto
                     */
                    ConsumerAlertsConfigProto.fromObject = function fromObject(object) {
                        if (object instanceof $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto)
                            return object;
                        var message = new $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto();
                        if (object.orderStatusUpdatedAlertConfig != null) {
                            if (typeof object.orderStatusUpdatedAlertConfig !== "object")
                                throw TypeError(".waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto.orderStatusUpdatedAlertConfig: object expected");
                            message.orderStatusUpdatedAlertConfig = $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto.OrderStatusUpdatedAlertConfigProto.fromObject(object.orderStatusUpdatedAlertConfig);
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a ConsumerAlertsConfigProto message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto
                     * @static
                     * @param {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto} message ConsumerAlertsConfigProto
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ConsumerAlertsConfigProto.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.orderStatusUpdatedAlertConfig = null;
                        if (message.orderStatusUpdatedAlertConfig != null && message.hasOwnProperty("orderStatusUpdatedAlertConfig"))
                            object.orderStatusUpdatedAlertConfig = $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto.OrderStatusUpdatedAlertConfigProto.toObject(message.orderStatusUpdatedAlertConfig, options);
                        return object;
                    };

                    /**
                     * Converts this ConsumerAlertsConfigProto to JSON.
                     * @function toJSON
                     * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ConsumerAlertsConfigProto.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for ConsumerAlertsConfigProto
                     * @function getTypeUrl
                     * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    ConsumerAlertsConfigProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto";
                    };

                    ConsumerAlertsConfigProto.OrderStatusUpdatedAlertConfigProto = (function() {

                        /**
                         * Properties of an OrderStatusUpdatedAlertConfigProto.
                         * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto
                         * @interface IOrderStatusUpdatedAlertConfigProto
                         * @property {string|null} [redirectLink] OrderStatusUpdatedAlertConfigProto redirectLink
                         * @property {Array.<waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ILocalizedConfigProto>|null} [localizedConfigurations] OrderStatusUpdatedAlertConfigProto localizedConfigurations
                         */

                        /**
                         * Constructs a new OrderStatusUpdatedAlertConfigProto.
                         * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto
                         * @classdesc Represents an OrderStatusUpdatedAlertConfigProto.
                         * @implements IOrderStatusUpdatedAlertConfigProto
                         * @constructor
                         * @param {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto.IOrderStatusUpdatedAlertConfigProto=} [properties] Properties to set
                         */
                        function OrderStatusUpdatedAlertConfigProto(properties) {
                            this.localizedConfigurations = [];
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * OrderStatusUpdatedAlertConfigProto redirectLink.
                         * @member {string} redirectLink
                         * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto.OrderStatusUpdatedAlertConfigProto
                         * @instance
                         */
                        OrderStatusUpdatedAlertConfigProto.prototype.redirectLink = "";

                        /**
                         * OrderStatusUpdatedAlertConfigProto localizedConfigurations.
                         * @member {Array.<waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ILocalizedConfigProto>} localizedConfigurations
                         * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto.OrderStatusUpdatedAlertConfigProto
                         * @instance
                         */
                        OrderStatusUpdatedAlertConfigProto.prototype.localizedConfigurations = $util.emptyArray;

                        /**
                         * Creates a new OrderStatusUpdatedAlertConfigProto instance using the specified properties.
                         * @function create
                         * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto.OrderStatusUpdatedAlertConfigProto
                         * @static
                         * @param {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto.IOrderStatusUpdatedAlertConfigProto=} [properties] Properties to set
                         * @returns {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto.OrderStatusUpdatedAlertConfigProto} OrderStatusUpdatedAlertConfigProto instance
                         */
                        OrderStatusUpdatedAlertConfigProto.create = function create(properties) {
                            return new OrderStatusUpdatedAlertConfigProto(properties);
                        };

                        /**
                         * Encodes the specified OrderStatusUpdatedAlertConfigProto message. Does not implicitly {@link waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto.OrderStatusUpdatedAlertConfigProto.verify|verify} messages.
                         * @function encode
                         * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto.OrderStatusUpdatedAlertConfigProto
                         * @static
                         * @param {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto.IOrderStatusUpdatedAlertConfigProto} message OrderStatusUpdatedAlertConfigProto message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        OrderStatusUpdatedAlertConfigProto.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.redirectLink != null && Object.hasOwnProperty.call(message, "redirectLink"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.redirectLink);
                            if (message.localizedConfigurations != null && message.localizedConfigurations.length)
                                for (var i = 0; i < message.localizedConfigurations.length; ++i)
                                    $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.LocalizedConfigProto.encode(message.localizedConfigurations[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                            return writer;
                        };

                        /**
                         * Encodes the specified OrderStatusUpdatedAlertConfigProto message, length delimited. Does not implicitly {@link waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto.OrderStatusUpdatedAlertConfigProto.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto.OrderStatusUpdatedAlertConfigProto
                         * @static
                         * @param {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto.IOrderStatusUpdatedAlertConfigProto} message OrderStatusUpdatedAlertConfigProto message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        OrderStatusUpdatedAlertConfigProto.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes an OrderStatusUpdatedAlertConfigProto message from the specified reader or buffer.
                         * @function decode
                         * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto.OrderStatusUpdatedAlertConfigProto
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto.OrderStatusUpdatedAlertConfigProto} OrderStatusUpdatedAlertConfigProto
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        OrderStatusUpdatedAlertConfigProto.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto.OrderStatusUpdatedAlertConfigProto();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1: {
                                        message.redirectLink = reader.string();
                                        break;
                                    }
                                case 2: {
                                        if (!(message.localizedConfigurations && message.localizedConfigurations.length))
                                            message.localizedConfigurations = [];
                                        message.localizedConfigurations.push($root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.LocalizedConfigProto.decode(reader, reader.uint32()));
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes an OrderStatusUpdatedAlertConfigProto message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto.OrderStatusUpdatedAlertConfigProto
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto.OrderStatusUpdatedAlertConfigProto} OrderStatusUpdatedAlertConfigProto
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        OrderStatusUpdatedAlertConfigProto.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies an OrderStatusUpdatedAlertConfigProto message.
                         * @function verify
                         * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto.OrderStatusUpdatedAlertConfigProto
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        OrderStatusUpdatedAlertConfigProto.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.redirectLink != null && message.hasOwnProperty("redirectLink"))
                                if (!$util.isString(message.redirectLink))
                                    return "redirectLink: string expected";
                            if (message.localizedConfigurations != null && message.hasOwnProperty("localizedConfigurations")) {
                                if (!Array.isArray(message.localizedConfigurations))
                                    return "localizedConfigurations: array expected";
                                for (var i = 0; i < message.localizedConfigurations.length; ++i) {
                                    var error = $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.LocalizedConfigProto.verify(message.localizedConfigurations[i]);
                                    if (error)
                                        return "localizedConfigurations." + error;
                                }
                            }
                            return null;
                        };

                        /**
                         * Creates an OrderStatusUpdatedAlertConfigProto message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto.OrderStatusUpdatedAlertConfigProto
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto.OrderStatusUpdatedAlertConfigProto} OrderStatusUpdatedAlertConfigProto
                         */
                        OrderStatusUpdatedAlertConfigProto.fromObject = function fromObject(object) {
                            if (object instanceof $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto.OrderStatusUpdatedAlertConfigProto)
                                return object;
                            var message = new $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto.OrderStatusUpdatedAlertConfigProto();
                            if (object.redirectLink != null)
                                message.redirectLink = String(object.redirectLink);
                            if (object.localizedConfigurations) {
                                if (!Array.isArray(object.localizedConfigurations))
                                    throw TypeError(".waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto.OrderStatusUpdatedAlertConfigProto.localizedConfigurations: array expected");
                                message.localizedConfigurations = [];
                                for (var i = 0; i < object.localizedConfigurations.length; ++i) {
                                    if (typeof object.localizedConfigurations[i] !== "object")
                                        throw TypeError(".waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto.OrderStatusUpdatedAlertConfigProto.localizedConfigurations: object expected");
                                    message.localizedConfigurations[i] = $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.LocalizedConfigProto.fromObject(object.localizedConfigurations[i]);
                                }
                            }
                            return message;
                        };

                        /**
                         * Creates a plain object from an OrderStatusUpdatedAlertConfigProto message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto.OrderStatusUpdatedAlertConfigProto
                         * @static
                         * @param {waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto.OrderStatusUpdatedAlertConfigProto} message OrderStatusUpdatedAlertConfigProto
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        OrderStatusUpdatedAlertConfigProto.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.arrays || options.defaults)
                                object.localizedConfigurations = [];
                            if (options.defaults)
                                object.redirectLink = "";
                            if (message.redirectLink != null && message.hasOwnProperty("redirectLink"))
                                object.redirectLink = message.redirectLink;
                            if (message.localizedConfigurations && message.localizedConfigurations.length) {
                                object.localizedConfigurations = [];
                                for (var j = 0; j < message.localizedConfigurations.length; ++j)
                                    object.localizedConfigurations[j] = $root.waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.LocalizedConfigProto.toObject(message.localizedConfigurations[j], options);
                            }
                            return object;
                        };

                        /**
                         * Converts this OrderStatusUpdatedAlertConfigProto to JSON.
                         * @function toJSON
                         * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto.OrderStatusUpdatedAlertConfigProto
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        OrderStatusUpdatedAlertConfigProto.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for OrderStatusUpdatedAlertConfigProto
                         * @function getTypeUrl
                         * @memberof waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto.OrderStatusUpdatedAlertConfigProto
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        OrderStatusUpdatedAlertConfigProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/waiternow.common.FirebaseConfigProto.NotificationAlertConfigProto.ConsumerAlertsConfigProto.OrderStatusUpdatedAlertConfigProto";
                        };

                        return OrderStatusUpdatedAlertConfigProto;
                    })();

                    return ConsumerAlertsConfigProto;
                })();

                return NotificationAlertConfigProto;
            })();

            return FirebaseConfigProto;
        })();

        common.ThresholdsConfigProto = (function() {

            /**
             * Properties of a ThresholdsConfigProto.
             * @memberof waiternow.common
             * @interface IThresholdsConfigProto
             * @property {number|null} [authTokenExpirationMinutes] ThresholdsConfigProto authTokenExpirationMinutes
             * @property {number|null} [consumerCheckinSessionExpirationMinutes] ThresholdsConfigProto consumerCheckinSessionExpirationMinutes
             * @property {number|null} [consumerDeviceSessionExpirationMinutes] ThresholdsConfigProto consumerDeviceSessionExpirationMinutes
             * @property {number|null} [consumerOrderStatusPollRateSeconds] ThresholdsConfigProto consumerOrderStatusPollRateSeconds
             * @property {number|null} [consumerLocationOnlineStatusPollRateMinutes] ThresholdsConfigProto consumerLocationOnlineStatusPollRateMinutes
             * @property {number|null} [businessDeviceSessionExpirationMinutes] ThresholdsConfigProto businessDeviceSessionExpirationMinutes
             * @property {number|null} [businessDeviceHeartbeatRateMinutes] ThresholdsConfigProto businessDeviceHeartbeatRateMinutes
             * @property {number|null} [businessCheckOrdersPollRateSeconds] ThresholdsConfigProto businessCheckOrdersPollRateSeconds
             * @property {number|null} [businessSafetyCheckOrdersPollRateMinutes] ThresholdsConfigProto businessSafetyCheckOrdersPollRateMinutes
             * @property {number|null} [orderUnackedAndPaidElapsedTimeWarningThresholdMinutes] ThresholdsConfigProto orderUnackedAndPaidElapsedTimeWarningThresholdMinutes
             * @property {number|null} [lateLocationsOpeningGracePeriodMinutes] ThresholdsConfigProto lateLocationsOpeningGracePeriodMinutes
             * @property {number|null} [lateLocationsClosingGracePeriodMinutes] ThresholdsConfigProto lateLocationsClosingGracePeriodMinutes
             * @property {number|null} [lateLocationsAlertRateMinutes] ThresholdsConfigProto lateLocationsAlertRateMinutes
             * @property {number|null} [defaultOrderPreparationDurationMinutes] ThresholdsConfigProto defaultOrderPreparationDurationMinutes
             * @property {number|null} [ordersTtlDays] ThresholdsConfigProto ordersTtlDays
             * @property {number|null} [dailyMetricsTtlDays] ThresholdsConfigProto dailyMetricsTtlDays
             * @property {number|null} [checkInsTtlDays] ThresholdsConfigProto checkInsTtlDays
             * @property {number|null} [deliveriesTtlDays] ThresholdsConfigProto deliveriesTtlDays
             * @property {number|null} [cacheTtlDays] ThresholdsConfigProto cacheTtlDays
             * @property {number|null} [cachedSalesTaxExpirationDays] ThresholdsConfigProto cachedSalesTaxExpirationDays
             * @property {number|null} [maxAttemptsToMarkOrderAsPaid] ThresholdsConfigProto maxAttemptsToMarkOrderAsPaid
             * @property {number|null} [timeBetweenAttemptsToMarkOrderAsPaidSeconds] ThresholdsConfigProto timeBetweenAttemptsToMarkOrderAsPaidSeconds
             * @property {number|null} [devicesTtlDays] ThresholdsConfigProto devicesTtlDays
             * @property {number|null} [eventsTtlDays] ThresholdsConfigProto eventsTtlDays
             * @property {number|null} [remoteLogsTtlDays] ThresholdsConfigProto remoteLogsTtlDays
             */

            /**
             * Constructs a new ThresholdsConfigProto.
             * @memberof waiternow.common
             * @classdesc Represents a ThresholdsConfigProto.
             * @implements IThresholdsConfigProto
             * @constructor
             * @param {waiternow.common.IThresholdsConfigProto=} [properties] Properties to set
             */
            function ThresholdsConfigProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ThresholdsConfigProto authTokenExpirationMinutes.
             * @member {number} authTokenExpirationMinutes
             * @memberof waiternow.common.ThresholdsConfigProto
             * @instance
             */
            ThresholdsConfigProto.prototype.authTokenExpirationMinutes = 0;

            /**
             * ThresholdsConfigProto consumerCheckinSessionExpirationMinutes.
             * @member {number} consumerCheckinSessionExpirationMinutes
             * @memberof waiternow.common.ThresholdsConfigProto
             * @instance
             */
            ThresholdsConfigProto.prototype.consumerCheckinSessionExpirationMinutes = 0;

            /**
             * ThresholdsConfigProto consumerDeviceSessionExpirationMinutes.
             * @member {number} consumerDeviceSessionExpirationMinutes
             * @memberof waiternow.common.ThresholdsConfigProto
             * @instance
             */
            ThresholdsConfigProto.prototype.consumerDeviceSessionExpirationMinutes = 0;

            /**
             * ThresholdsConfigProto consumerOrderStatusPollRateSeconds.
             * @member {number} consumerOrderStatusPollRateSeconds
             * @memberof waiternow.common.ThresholdsConfigProto
             * @instance
             */
            ThresholdsConfigProto.prototype.consumerOrderStatusPollRateSeconds = 0;

            /**
             * ThresholdsConfigProto consumerLocationOnlineStatusPollRateMinutes.
             * @member {number} consumerLocationOnlineStatusPollRateMinutes
             * @memberof waiternow.common.ThresholdsConfigProto
             * @instance
             */
            ThresholdsConfigProto.prototype.consumerLocationOnlineStatusPollRateMinutes = 0;

            /**
             * ThresholdsConfigProto businessDeviceSessionExpirationMinutes.
             * @member {number} businessDeviceSessionExpirationMinutes
             * @memberof waiternow.common.ThresholdsConfigProto
             * @instance
             */
            ThresholdsConfigProto.prototype.businessDeviceSessionExpirationMinutes = 0;

            /**
             * ThresholdsConfigProto businessDeviceHeartbeatRateMinutes.
             * @member {number} businessDeviceHeartbeatRateMinutes
             * @memberof waiternow.common.ThresholdsConfigProto
             * @instance
             */
            ThresholdsConfigProto.prototype.businessDeviceHeartbeatRateMinutes = 0;

            /**
             * ThresholdsConfigProto businessCheckOrdersPollRateSeconds.
             * @member {number} businessCheckOrdersPollRateSeconds
             * @memberof waiternow.common.ThresholdsConfigProto
             * @instance
             */
            ThresholdsConfigProto.prototype.businessCheckOrdersPollRateSeconds = 0;

            /**
             * ThresholdsConfigProto businessSafetyCheckOrdersPollRateMinutes.
             * @member {number} businessSafetyCheckOrdersPollRateMinutes
             * @memberof waiternow.common.ThresholdsConfigProto
             * @instance
             */
            ThresholdsConfigProto.prototype.businessSafetyCheckOrdersPollRateMinutes = 0;

            /**
             * ThresholdsConfigProto orderUnackedAndPaidElapsedTimeWarningThresholdMinutes.
             * @member {number} orderUnackedAndPaidElapsedTimeWarningThresholdMinutes
             * @memberof waiternow.common.ThresholdsConfigProto
             * @instance
             */
            ThresholdsConfigProto.prototype.orderUnackedAndPaidElapsedTimeWarningThresholdMinutes = 0;

            /**
             * ThresholdsConfigProto lateLocationsOpeningGracePeriodMinutes.
             * @member {number} lateLocationsOpeningGracePeriodMinutes
             * @memberof waiternow.common.ThresholdsConfigProto
             * @instance
             */
            ThresholdsConfigProto.prototype.lateLocationsOpeningGracePeriodMinutes = 0;

            /**
             * ThresholdsConfigProto lateLocationsClosingGracePeriodMinutes.
             * @member {number} lateLocationsClosingGracePeriodMinutes
             * @memberof waiternow.common.ThresholdsConfigProto
             * @instance
             */
            ThresholdsConfigProto.prototype.lateLocationsClosingGracePeriodMinutes = 0;

            /**
             * ThresholdsConfigProto lateLocationsAlertRateMinutes.
             * @member {number} lateLocationsAlertRateMinutes
             * @memberof waiternow.common.ThresholdsConfigProto
             * @instance
             */
            ThresholdsConfigProto.prototype.lateLocationsAlertRateMinutes = 0;

            /**
             * ThresholdsConfigProto defaultOrderPreparationDurationMinutes.
             * @member {number} defaultOrderPreparationDurationMinutes
             * @memberof waiternow.common.ThresholdsConfigProto
             * @instance
             */
            ThresholdsConfigProto.prototype.defaultOrderPreparationDurationMinutes = 0;

            /**
             * ThresholdsConfigProto ordersTtlDays.
             * @member {number} ordersTtlDays
             * @memberof waiternow.common.ThresholdsConfigProto
             * @instance
             */
            ThresholdsConfigProto.prototype.ordersTtlDays = 0;

            /**
             * ThresholdsConfigProto dailyMetricsTtlDays.
             * @member {number} dailyMetricsTtlDays
             * @memberof waiternow.common.ThresholdsConfigProto
             * @instance
             */
            ThresholdsConfigProto.prototype.dailyMetricsTtlDays = 0;

            /**
             * ThresholdsConfigProto checkInsTtlDays.
             * @member {number} checkInsTtlDays
             * @memberof waiternow.common.ThresholdsConfigProto
             * @instance
             */
            ThresholdsConfigProto.prototype.checkInsTtlDays = 0;

            /**
             * ThresholdsConfigProto deliveriesTtlDays.
             * @member {number} deliveriesTtlDays
             * @memberof waiternow.common.ThresholdsConfigProto
             * @instance
             */
            ThresholdsConfigProto.prototype.deliveriesTtlDays = 0;

            /**
             * ThresholdsConfigProto cacheTtlDays.
             * @member {number} cacheTtlDays
             * @memberof waiternow.common.ThresholdsConfigProto
             * @instance
             */
            ThresholdsConfigProto.prototype.cacheTtlDays = 0;

            /**
             * ThresholdsConfigProto cachedSalesTaxExpirationDays.
             * @member {number} cachedSalesTaxExpirationDays
             * @memberof waiternow.common.ThresholdsConfigProto
             * @instance
             */
            ThresholdsConfigProto.prototype.cachedSalesTaxExpirationDays = 0;

            /**
             * ThresholdsConfigProto maxAttemptsToMarkOrderAsPaid.
             * @member {number} maxAttemptsToMarkOrderAsPaid
             * @memberof waiternow.common.ThresholdsConfigProto
             * @instance
             */
            ThresholdsConfigProto.prototype.maxAttemptsToMarkOrderAsPaid = 0;

            /**
             * ThresholdsConfigProto timeBetweenAttemptsToMarkOrderAsPaidSeconds.
             * @member {number} timeBetweenAttemptsToMarkOrderAsPaidSeconds
             * @memberof waiternow.common.ThresholdsConfigProto
             * @instance
             */
            ThresholdsConfigProto.prototype.timeBetweenAttemptsToMarkOrderAsPaidSeconds = 0;

            /**
             * ThresholdsConfigProto devicesTtlDays.
             * @member {number} devicesTtlDays
             * @memberof waiternow.common.ThresholdsConfigProto
             * @instance
             */
            ThresholdsConfigProto.prototype.devicesTtlDays = 0;

            /**
             * ThresholdsConfigProto eventsTtlDays.
             * @member {number} eventsTtlDays
             * @memberof waiternow.common.ThresholdsConfigProto
             * @instance
             */
            ThresholdsConfigProto.prototype.eventsTtlDays = 0;

            /**
             * ThresholdsConfigProto remoteLogsTtlDays.
             * @member {number} remoteLogsTtlDays
             * @memberof waiternow.common.ThresholdsConfigProto
             * @instance
             */
            ThresholdsConfigProto.prototype.remoteLogsTtlDays = 0;

            /**
             * Creates a new ThresholdsConfigProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.ThresholdsConfigProto
             * @static
             * @param {waiternow.common.IThresholdsConfigProto=} [properties] Properties to set
             * @returns {waiternow.common.ThresholdsConfigProto} ThresholdsConfigProto instance
             */
            ThresholdsConfigProto.create = function create(properties) {
                return new ThresholdsConfigProto(properties);
            };

            /**
             * Encodes the specified ThresholdsConfigProto message. Does not implicitly {@link waiternow.common.ThresholdsConfigProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.ThresholdsConfigProto
             * @static
             * @param {waiternow.common.IThresholdsConfigProto} message ThresholdsConfigProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ThresholdsConfigProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.authTokenExpirationMinutes != null && Object.hasOwnProperty.call(message, "authTokenExpirationMinutes"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.authTokenExpirationMinutes);
                if (message.consumerCheckinSessionExpirationMinutes != null && Object.hasOwnProperty.call(message, "consumerCheckinSessionExpirationMinutes"))
                    writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.consumerCheckinSessionExpirationMinutes);
                if (message.consumerDeviceSessionExpirationMinutes != null && Object.hasOwnProperty.call(message, "consumerDeviceSessionExpirationMinutes"))
                    writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.consumerDeviceSessionExpirationMinutes);
                if (message.consumerOrderStatusPollRateSeconds != null && Object.hasOwnProperty.call(message, "consumerOrderStatusPollRateSeconds"))
                    writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.consumerOrderStatusPollRateSeconds);
                if (message.consumerLocationOnlineStatusPollRateMinutes != null && Object.hasOwnProperty.call(message, "consumerLocationOnlineStatusPollRateMinutes"))
                    writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.consumerLocationOnlineStatusPollRateMinutes);
                if (message.businessDeviceSessionExpirationMinutes != null && Object.hasOwnProperty.call(message, "businessDeviceSessionExpirationMinutes"))
                    writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.businessDeviceSessionExpirationMinutes);
                if (message.businessDeviceHeartbeatRateMinutes != null && Object.hasOwnProperty.call(message, "businessDeviceHeartbeatRateMinutes"))
                    writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.businessDeviceHeartbeatRateMinutes);
                if (message.businessCheckOrdersPollRateSeconds != null && Object.hasOwnProperty.call(message, "businessCheckOrdersPollRateSeconds"))
                    writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.businessCheckOrdersPollRateSeconds);
                if (message.orderUnackedAndPaidElapsedTimeWarningThresholdMinutes != null && Object.hasOwnProperty.call(message, "orderUnackedAndPaidElapsedTimeWarningThresholdMinutes"))
                    writer.uint32(/* id 9, wireType 0 =*/72).uint32(message.orderUnackedAndPaidElapsedTimeWarningThresholdMinutes);
                if (message.lateLocationsOpeningGracePeriodMinutes != null && Object.hasOwnProperty.call(message, "lateLocationsOpeningGracePeriodMinutes"))
                    writer.uint32(/* id 10, wireType 0 =*/80).uint32(message.lateLocationsOpeningGracePeriodMinutes);
                if (message.lateLocationsClosingGracePeriodMinutes != null && Object.hasOwnProperty.call(message, "lateLocationsClosingGracePeriodMinutes"))
                    writer.uint32(/* id 11, wireType 0 =*/88).uint32(message.lateLocationsClosingGracePeriodMinutes);
                if (message.lateLocationsAlertRateMinutes != null && Object.hasOwnProperty.call(message, "lateLocationsAlertRateMinutes"))
                    writer.uint32(/* id 12, wireType 0 =*/96).uint32(message.lateLocationsAlertRateMinutes);
                if (message.defaultOrderPreparationDurationMinutes != null && Object.hasOwnProperty.call(message, "defaultOrderPreparationDurationMinutes"))
                    writer.uint32(/* id 13, wireType 0 =*/104).uint32(message.defaultOrderPreparationDurationMinutes);
                if (message.ordersTtlDays != null && Object.hasOwnProperty.call(message, "ordersTtlDays"))
                    writer.uint32(/* id 14, wireType 0 =*/112).uint32(message.ordersTtlDays);
                if (message.dailyMetricsTtlDays != null && Object.hasOwnProperty.call(message, "dailyMetricsTtlDays"))
                    writer.uint32(/* id 15, wireType 0 =*/120).uint32(message.dailyMetricsTtlDays);
                if (message.checkInsTtlDays != null && Object.hasOwnProperty.call(message, "checkInsTtlDays"))
                    writer.uint32(/* id 16, wireType 0 =*/128).uint32(message.checkInsTtlDays);
                if (message.deliveriesTtlDays != null && Object.hasOwnProperty.call(message, "deliveriesTtlDays"))
                    writer.uint32(/* id 17, wireType 0 =*/136).uint32(message.deliveriesTtlDays);
                if (message.cacheTtlDays != null && Object.hasOwnProperty.call(message, "cacheTtlDays"))
                    writer.uint32(/* id 18, wireType 0 =*/144).uint32(message.cacheTtlDays);
                if (message.cachedSalesTaxExpirationDays != null && Object.hasOwnProperty.call(message, "cachedSalesTaxExpirationDays"))
                    writer.uint32(/* id 19, wireType 0 =*/152).uint32(message.cachedSalesTaxExpirationDays);
                if (message.maxAttemptsToMarkOrderAsPaid != null && Object.hasOwnProperty.call(message, "maxAttemptsToMarkOrderAsPaid"))
                    writer.uint32(/* id 20, wireType 0 =*/160).uint32(message.maxAttemptsToMarkOrderAsPaid);
                if (message.timeBetweenAttemptsToMarkOrderAsPaidSeconds != null && Object.hasOwnProperty.call(message, "timeBetweenAttemptsToMarkOrderAsPaidSeconds"))
                    writer.uint32(/* id 21, wireType 0 =*/168).uint32(message.timeBetweenAttemptsToMarkOrderAsPaidSeconds);
                if (message.devicesTtlDays != null && Object.hasOwnProperty.call(message, "devicesTtlDays"))
                    writer.uint32(/* id 22, wireType 0 =*/176).uint32(message.devicesTtlDays);
                if (message.businessSafetyCheckOrdersPollRateMinutes != null && Object.hasOwnProperty.call(message, "businessSafetyCheckOrdersPollRateMinutes"))
                    writer.uint32(/* id 23, wireType 0 =*/184).uint32(message.businessSafetyCheckOrdersPollRateMinutes);
                if (message.eventsTtlDays != null && Object.hasOwnProperty.call(message, "eventsTtlDays"))
                    writer.uint32(/* id 25, wireType 0 =*/200).uint32(message.eventsTtlDays);
                if (message.remoteLogsTtlDays != null && Object.hasOwnProperty.call(message, "remoteLogsTtlDays"))
                    writer.uint32(/* id 26, wireType 0 =*/208).uint32(message.remoteLogsTtlDays);
                return writer;
            };

            /**
             * Encodes the specified ThresholdsConfigProto message, length delimited. Does not implicitly {@link waiternow.common.ThresholdsConfigProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.ThresholdsConfigProto
             * @static
             * @param {waiternow.common.IThresholdsConfigProto} message ThresholdsConfigProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ThresholdsConfigProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ThresholdsConfigProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.ThresholdsConfigProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.ThresholdsConfigProto} ThresholdsConfigProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ThresholdsConfigProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.ThresholdsConfigProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.authTokenExpirationMinutes = reader.uint32();
                            break;
                        }
                    case 2: {
                            message.consumerCheckinSessionExpirationMinutes = reader.uint32();
                            break;
                        }
                    case 3: {
                            message.consumerDeviceSessionExpirationMinutes = reader.uint32();
                            break;
                        }
                    case 4: {
                            message.consumerOrderStatusPollRateSeconds = reader.uint32();
                            break;
                        }
                    case 5: {
                            message.consumerLocationOnlineStatusPollRateMinutes = reader.uint32();
                            break;
                        }
                    case 6: {
                            message.businessDeviceSessionExpirationMinutes = reader.uint32();
                            break;
                        }
                    case 7: {
                            message.businessDeviceHeartbeatRateMinutes = reader.uint32();
                            break;
                        }
                    case 8: {
                            message.businessCheckOrdersPollRateSeconds = reader.uint32();
                            break;
                        }
                    case 23: {
                            message.businessSafetyCheckOrdersPollRateMinutes = reader.uint32();
                            break;
                        }
                    case 9: {
                            message.orderUnackedAndPaidElapsedTimeWarningThresholdMinutes = reader.uint32();
                            break;
                        }
                    case 10: {
                            message.lateLocationsOpeningGracePeriodMinutes = reader.uint32();
                            break;
                        }
                    case 11: {
                            message.lateLocationsClosingGracePeriodMinutes = reader.uint32();
                            break;
                        }
                    case 12: {
                            message.lateLocationsAlertRateMinutes = reader.uint32();
                            break;
                        }
                    case 13: {
                            message.defaultOrderPreparationDurationMinutes = reader.uint32();
                            break;
                        }
                    case 14: {
                            message.ordersTtlDays = reader.uint32();
                            break;
                        }
                    case 15: {
                            message.dailyMetricsTtlDays = reader.uint32();
                            break;
                        }
                    case 16: {
                            message.checkInsTtlDays = reader.uint32();
                            break;
                        }
                    case 17: {
                            message.deliveriesTtlDays = reader.uint32();
                            break;
                        }
                    case 18: {
                            message.cacheTtlDays = reader.uint32();
                            break;
                        }
                    case 19: {
                            message.cachedSalesTaxExpirationDays = reader.uint32();
                            break;
                        }
                    case 20: {
                            message.maxAttemptsToMarkOrderAsPaid = reader.uint32();
                            break;
                        }
                    case 21: {
                            message.timeBetweenAttemptsToMarkOrderAsPaidSeconds = reader.uint32();
                            break;
                        }
                    case 22: {
                            message.devicesTtlDays = reader.uint32();
                            break;
                        }
                    case 25: {
                            message.eventsTtlDays = reader.uint32();
                            break;
                        }
                    case 26: {
                            message.remoteLogsTtlDays = reader.uint32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ThresholdsConfigProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.ThresholdsConfigProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.ThresholdsConfigProto} ThresholdsConfigProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ThresholdsConfigProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ThresholdsConfigProto message.
             * @function verify
             * @memberof waiternow.common.ThresholdsConfigProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ThresholdsConfigProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.authTokenExpirationMinutes != null && message.hasOwnProperty("authTokenExpirationMinutes"))
                    if (!$util.isInteger(message.authTokenExpirationMinutes))
                        return "authTokenExpirationMinutes: integer expected";
                if (message.consumerCheckinSessionExpirationMinutes != null && message.hasOwnProperty("consumerCheckinSessionExpirationMinutes"))
                    if (!$util.isInteger(message.consumerCheckinSessionExpirationMinutes))
                        return "consumerCheckinSessionExpirationMinutes: integer expected";
                if (message.consumerDeviceSessionExpirationMinutes != null && message.hasOwnProperty("consumerDeviceSessionExpirationMinutes"))
                    if (!$util.isInteger(message.consumerDeviceSessionExpirationMinutes))
                        return "consumerDeviceSessionExpirationMinutes: integer expected";
                if (message.consumerOrderStatusPollRateSeconds != null && message.hasOwnProperty("consumerOrderStatusPollRateSeconds"))
                    if (!$util.isInteger(message.consumerOrderStatusPollRateSeconds))
                        return "consumerOrderStatusPollRateSeconds: integer expected";
                if (message.consumerLocationOnlineStatusPollRateMinutes != null && message.hasOwnProperty("consumerLocationOnlineStatusPollRateMinutes"))
                    if (!$util.isInteger(message.consumerLocationOnlineStatusPollRateMinutes))
                        return "consumerLocationOnlineStatusPollRateMinutes: integer expected";
                if (message.businessDeviceSessionExpirationMinutes != null && message.hasOwnProperty("businessDeviceSessionExpirationMinutes"))
                    if (!$util.isInteger(message.businessDeviceSessionExpirationMinutes))
                        return "businessDeviceSessionExpirationMinutes: integer expected";
                if (message.businessDeviceHeartbeatRateMinutes != null && message.hasOwnProperty("businessDeviceHeartbeatRateMinutes"))
                    if (!$util.isInteger(message.businessDeviceHeartbeatRateMinutes))
                        return "businessDeviceHeartbeatRateMinutes: integer expected";
                if (message.businessCheckOrdersPollRateSeconds != null && message.hasOwnProperty("businessCheckOrdersPollRateSeconds"))
                    if (!$util.isInteger(message.businessCheckOrdersPollRateSeconds))
                        return "businessCheckOrdersPollRateSeconds: integer expected";
                if (message.businessSafetyCheckOrdersPollRateMinutes != null && message.hasOwnProperty("businessSafetyCheckOrdersPollRateMinutes"))
                    if (!$util.isInteger(message.businessSafetyCheckOrdersPollRateMinutes))
                        return "businessSafetyCheckOrdersPollRateMinutes: integer expected";
                if (message.orderUnackedAndPaidElapsedTimeWarningThresholdMinutes != null && message.hasOwnProperty("orderUnackedAndPaidElapsedTimeWarningThresholdMinutes"))
                    if (!$util.isInteger(message.orderUnackedAndPaidElapsedTimeWarningThresholdMinutes))
                        return "orderUnackedAndPaidElapsedTimeWarningThresholdMinutes: integer expected";
                if (message.lateLocationsOpeningGracePeriodMinutes != null && message.hasOwnProperty("lateLocationsOpeningGracePeriodMinutes"))
                    if (!$util.isInteger(message.lateLocationsOpeningGracePeriodMinutes))
                        return "lateLocationsOpeningGracePeriodMinutes: integer expected";
                if (message.lateLocationsClosingGracePeriodMinutes != null && message.hasOwnProperty("lateLocationsClosingGracePeriodMinutes"))
                    if (!$util.isInteger(message.lateLocationsClosingGracePeriodMinutes))
                        return "lateLocationsClosingGracePeriodMinutes: integer expected";
                if (message.lateLocationsAlertRateMinutes != null && message.hasOwnProperty("lateLocationsAlertRateMinutes"))
                    if (!$util.isInteger(message.lateLocationsAlertRateMinutes))
                        return "lateLocationsAlertRateMinutes: integer expected";
                if (message.defaultOrderPreparationDurationMinutes != null && message.hasOwnProperty("defaultOrderPreparationDurationMinutes"))
                    if (!$util.isInteger(message.defaultOrderPreparationDurationMinutes))
                        return "defaultOrderPreparationDurationMinutes: integer expected";
                if (message.ordersTtlDays != null && message.hasOwnProperty("ordersTtlDays"))
                    if (!$util.isInteger(message.ordersTtlDays))
                        return "ordersTtlDays: integer expected";
                if (message.dailyMetricsTtlDays != null && message.hasOwnProperty("dailyMetricsTtlDays"))
                    if (!$util.isInteger(message.dailyMetricsTtlDays))
                        return "dailyMetricsTtlDays: integer expected";
                if (message.checkInsTtlDays != null && message.hasOwnProperty("checkInsTtlDays"))
                    if (!$util.isInteger(message.checkInsTtlDays))
                        return "checkInsTtlDays: integer expected";
                if (message.deliveriesTtlDays != null && message.hasOwnProperty("deliveriesTtlDays"))
                    if (!$util.isInteger(message.deliveriesTtlDays))
                        return "deliveriesTtlDays: integer expected";
                if (message.cacheTtlDays != null && message.hasOwnProperty("cacheTtlDays"))
                    if (!$util.isInteger(message.cacheTtlDays))
                        return "cacheTtlDays: integer expected";
                if (message.cachedSalesTaxExpirationDays != null && message.hasOwnProperty("cachedSalesTaxExpirationDays"))
                    if (!$util.isInteger(message.cachedSalesTaxExpirationDays))
                        return "cachedSalesTaxExpirationDays: integer expected";
                if (message.maxAttemptsToMarkOrderAsPaid != null && message.hasOwnProperty("maxAttemptsToMarkOrderAsPaid"))
                    if (!$util.isInteger(message.maxAttemptsToMarkOrderAsPaid))
                        return "maxAttemptsToMarkOrderAsPaid: integer expected";
                if (message.timeBetweenAttemptsToMarkOrderAsPaidSeconds != null && message.hasOwnProperty("timeBetweenAttemptsToMarkOrderAsPaidSeconds"))
                    if (!$util.isInteger(message.timeBetweenAttemptsToMarkOrderAsPaidSeconds))
                        return "timeBetweenAttemptsToMarkOrderAsPaidSeconds: integer expected";
                if (message.devicesTtlDays != null && message.hasOwnProperty("devicesTtlDays"))
                    if (!$util.isInteger(message.devicesTtlDays))
                        return "devicesTtlDays: integer expected";
                if (message.eventsTtlDays != null && message.hasOwnProperty("eventsTtlDays"))
                    if (!$util.isInteger(message.eventsTtlDays))
                        return "eventsTtlDays: integer expected";
                if (message.remoteLogsTtlDays != null && message.hasOwnProperty("remoteLogsTtlDays"))
                    if (!$util.isInteger(message.remoteLogsTtlDays))
                        return "remoteLogsTtlDays: integer expected";
                return null;
            };

            /**
             * Creates a ThresholdsConfigProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.ThresholdsConfigProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.ThresholdsConfigProto} ThresholdsConfigProto
             */
            ThresholdsConfigProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.ThresholdsConfigProto)
                    return object;
                var message = new $root.waiternow.common.ThresholdsConfigProto();
                if (object.authTokenExpirationMinutes != null)
                    message.authTokenExpirationMinutes = object.authTokenExpirationMinutes >>> 0;
                if (object.consumerCheckinSessionExpirationMinutes != null)
                    message.consumerCheckinSessionExpirationMinutes = object.consumerCheckinSessionExpirationMinutes >>> 0;
                if (object.consumerDeviceSessionExpirationMinutes != null)
                    message.consumerDeviceSessionExpirationMinutes = object.consumerDeviceSessionExpirationMinutes >>> 0;
                if (object.consumerOrderStatusPollRateSeconds != null)
                    message.consumerOrderStatusPollRateSeconds = object.consumerOrderStatusPollRateSeconds >>> 0;
                if (object.consumerLocationOnlineStatusPollRateMinutes != null)
                    message.consumerLocationOnlineStatusPollRateMinutes = object.consumerLocationOnlineStatusPollRateMinutes >>> 0;
                if (object.businessDeviceSessionExpirationMinutes != null)
                    message.businessDeviceSessionExpirationMinutes = object.businessDeviceSessionExpirationMinutes >>> 0;
                if (object.businessDeviceHeartbeatRateMinutes != null)
                    message.businessDeviceHeartbeatRateMinutes = object.businessDeviceHeartbeatRateMinutes >>> 0;
                if (object.businessCheckOrdersPollRateSeconds != null)
                    message.businessCheckOrdersPollRateSeconds = object.businessCheckOrdersPollRateSeconds >>> 0;
                if (object.businessSafetyCheckOrdersPollRateMinutes != null)
                    message.businessSafetyCheckOrdersPollRateMinutes = object.businessSafetyCheckOrdersPollRateMinutes >>> 0;
                if (object.orderUnackedAndPaidElapsedTimeWarningThresholdMinutes != null)
                    message.orderUnackedAndPaidElapsedTimeWarningThresholdMinutes = object.orderUnackedAndPaidElapsedTimeWarningThresholdMinutes >>> 0;
                if (object.lateLocationsOpeningGracePeriodMinutes != null)
                    message.lateLocationsOpeningGracePeriodMinutes = object.lateLocationsOpeningGracePeriodMinutes >>> 0;
                if (object.lateLocationsClosingGracePeriodMinutes != null)
                    message.lateLocationsClosingGracePeriodMinutes = object.lateLocationsClosingGracePeriodMinutes >>> 0;
                if (object.lateLocationsAlertRateMinutes != null)
                    message.lateLocationsAlertRateMinutes = object.lateLocationsAlertRateMinutes >>> 0;
                if (object.defaultOrderPreparationDurationMinutes != null)
                    message.defaultOrderPreparationDurationMinutes = object.defaultOrderPreparationDurationMinutes >>> 0;
                if (object.ordersTtlDays != null)
                    message.ordersTtlDays = object.ordersTtlDays >>> 0;
                if (object.dailyMetricsTtlDays != null)
                    message.dailyMetricsTtlDays = object.dailyMetricsTtlDays >>> 0;
                if (object.checkInsTtlDays != null)
                    message.checkInsTtlDays = object.checkInsTtlDays >>> 0;
                if (object.deliveriesTtlDays != null)
                    message.deliveriesTtlDays = object.deliveriesTtlDays >>> 0;
                if (object.cacheTtlDays != null)
                    message.cacheTtlDays = object.cacheTtlDays >>> 0;
                if (object.cachedSalesTaxExpirationDays != null)
                    message.cachedSalesTaxExpirationDays = object.cachedSalesTaxExpirationDays >>> 0;
                if (object.maxAttemptsToMarkOrderAsPaid != null)
                    message.maxAttemptsToMarkOrderAsPaid = object.maxAttemptsToMarkOrderAsPaid >>> 0;
                if (object.timeBetweenAttemptsToMarkOrderAsPaidSeconds != null)
                    message.timeBetweenAttemptsToMarkOrderAsPaidSeconds = object.timeBetweenAttemptsToMarkOrderAsPaidSeconds >>> 0;
                if (object.devicesTtlDays != null)
                    message.devicesTtlDays = object.devicesTtlDays >>> 0;
                if (object.eventsTtlDays != null)
                    message.eventsTtlDays = object.eventsTtlDays >>> 0;
                if (object.remoteLogsTtlDays != null)
                    message.remoteLogsTtlDays = object.remoteLogsTtlDays >>> 0;
                return message;
            };

            /**
             * Creates a plain object from a ThresholdsConfigProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.ThresholdsConfigProto
             * @static
             * @param {waiternow.common.ThresholdsConfigProto} message ThresholdsConfigProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ThresholdsConfigProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.authTokenExpirationMinutes = 0;
                    object.consumerCheckinSessionExpirationMinutes = 0;
                    object.consumerDeviceSessionExpirationMinutes = 0;
                    object.consumerOrderStatusPollRateSeconds = 0;
                    object.consumerLocationOnlineStatusPollRateMinutes = 0;
                    object.businessDeviceSessionExpirationMinutes = 0;
                    object.businessDeviceHeartbeatRateMinutes = 0;
                    object.businessCheckOrdersPollRateSeconds = 0;
                    object.orderUnackedAndPaidElapsedTimeWarningThresholdMinutes = 0;
                    object.lateLocationsOpeningGracePeriodMinutes = 0;
                    object.lateLocationsClosingGracePeriodMinutes = 0;
                    object.lateLocationsAlertRateMinutes = 0;
                    object.defaultOrderPreparationDurationMinutes = 0;
                    object.ordersTtlDays = 0;
                    object.dailyMetricsTtlDays = 0;
                    object.checkInsTtlDays = 0;
                    object.deliveriesTtlDays = 0;
                    object.cacheTtlDays = 0;
                    object.cachedSalesTaxExpirationDays = 0;
                    object.maxAttemptsToMarkOrderAsPaid = 0;
                    object.timeBetweenAttemptsToMarkOrderAsPaidSeconds = 0;
                    object.devicesTtlDays = 0;
                    object.businessSafetyCheckOrdersPollRateMinutes = 0;
                    object.eventsTtlDays = 0;
                    object.remoteLogsTtlDays = 0;
                }
                if (message.authTokenExpirationMinutes != null && message.hasOwnProperty("authTokenExpirationMinutes"))
                    object.authTokenExpirationMinutes = message.authTokenExpirationMinutes;
                if (message.consumerCheckinSessionExpirationMinutes != null && message.hasOwnProperty("consumerCheckinSessionExpirationMinutes"))
                    object.consumerCheckinSessionExpirationMinutes = message.consumerCheckinSessionExpirationMinutes;
                if (message.consumerDeviceSessionExpirationMinutes != null && message.hasOwnProperty("consumerDeviceSessionExpirationMinutes"))
                    object.consumerDeviceSessionExpirationMinutes = message.consumerDeviceSessionExpirationMinutes;
                if (message.consumerOrderStatusPollRateSeconds != null && message.hasOwnProperty("consumerOrderStatusPollRateSeconds"))
                    object.consumerOrderStatusPollRateSeconds = message.consumerOrderStatusPollRateSeconds;
                if (message.consumerLocationOnlineStatusPollRateMinutes != null && message.hasOwnProperty("consumerLocationOnlineStatusPollRateMinutes"))
                    object.consumerLocationOnlineStatusPollRateMinutes = message.consumerLocationOnlineStatusPollRateMinutes;
                if (message.businessDeviceSessionExpirationMinutes != null && message.hasOwnProperty("businessDeviceSessionExpirationMinutes"))
                    object.businessDeviceSessionExpirationMinutes = message.businessDeviceSessionExpirationMinutes;
                if (message.businessDeviceHeartbeatRateMinutes != null && message.hasOwnProperty("businessDeviceHeartbeatRateMinutes"))
                    object.businessDeviceHeartbeatRateMinutes = message.businessDeviceHeartbeatRateMinutes;
                if (message.businessCheckOrdersPollRateSeconds != null && message.hasOwnProperty("businessCheckOrdersPollRateSeconds"))
                    object.businessCheckOrdersPollRateSeconds = message.businessCheckOrdersPollRateSeconds;
                if (message.orderUnackedAndPaidElapsedTimeWarningThresholdMinutes != null && message.hasOwnProperty("orderUnackedAndPaidElapsedTimeWarningThresholdMinutes"))
                    object.orderUnackedAndPaidElapsedTimeWarningThresholdMinutes = message.orderUnackedAndPaidElapsedTimeWarningThresholdMinutes;
                if (message.lateLocationsOpeningGracePeriodMinutes != null && message.hasOwnProperty("lateLocationsOpeningGracePeriodMinutes"))
                    object.lateLocationsOpeningGracePeriodMinutes = message.lateLocationsOpeningGracePeriodMinutes;
                if (message.lateLocationsClosingGracePeriodMinutes != null && message.hasOwnProperty("lateLocationsClosingGracePeriodMinutes"))
                    object.lateLocationsClosingGracePeriodMinutes = message.lateLocationsClosingGracePeriodMinutes;
                if (message.lateLocationsAlertRateMinutes != null && message.hasOwnProperty("lateLocationsAlertRateMinutes"))
                    object.lateLocationsAlertRateMinutes = message.lateLocationsAlertRateMinutes;
                if (message.defaultOrderPreparationDurationMinutes != null && message.hasOwnProperty("defaultOrderPreparationDurationMinutes"))
                    object.defaultOrderPreparationDurationMinutes = message.defaultOrderPreparationDurationMinutes;
                if (message.ordersTtlDays != null && message.hasOwnProperty("ordersTtlDays"))
                    object.ordersTtlDays = message.ordersTtlDays;
                if (message.dailyMetricsTtlDays != null && message.hasOwnProperty("dailyMetricsTtlDays"))
                    object.dailyMetricsTtlDays = message.dailyMetricsTtlDays;
                if (message.checkInsTtlDays != null && message.hasOwnProperty("checkInsTtlDays"))
                    object.checkInsTtlDays = message.checkInsTtlDays;
                if (message.deliveriesTtlDays != null && message.hasOwnProperty("deliveriesTtlDays"))
                    object.deliveriesTtlDays = message.deliveriesTtlDays;
                if (message.cacheTtlDays != null && message.hasOwnProperty("cacheTtlDays"))
                    object.cacheTtlDays = message.cacheTtlDays;
                if (message.cachedSalesTaxExpirationDays != null && message.hasOwnProperty("cachedSalesTaxExpirationDays"))
                    object.cachedSalesTaxExpirationDays = message.cachedSalesTaxExpirationDays;
                if (message.maxAttemptsToMarkOrderAsPaid != null && message.hasOwnProperty("maxAttemptsToMarkOrderAsPaid"))
                    object.maxAttemptsToMarkOrderAsPaid = message.maxAttemptsToMarkOrderAsPaid;
                if (message.timeBetweenAttemptsToMarkOrderAsPaidSeconds != null && message.hasOwnProperty("timeBetweenAttemptsToMarkOrderAsPaidSeconds"))
                    object.timeBetweenAttemptsToMarkOrderAsPaidSeconds = message.timeBetweenAttemptsToMarkOrderAsPaidSeconds;
                if (message.devicesTtlDays != null && message.hasOwnProperty("devicesTtlDays"))
                    object.devicesTtlDays = message.devicesTtlDays;
                if (message.businessSafetyCheckOrdersPollRateMinutes != null && message.hasOwnProperty("businessSafetyCheckOrdersPollRateMinutes"))
                    object.businessSafetyCheckOrdersPollRateMinutes = message.businessSafetyCheckOrdersPollRateMinutes;
                if (message.eventsTtlDays != null && message.hasOwnProperty("eventsTtlDays"))
                    object.eventsTtlDays = message.eventsTtlDays;
                if (message.remoteLogsTtlDays != null && message.hasOwnProperty("remoteLogsTtlDays"))
                    object.remoteLogsTtlDays = message.remoteLogsTtlDays;
                return object;
            };

            /**
             * Converts this ThresholdsConfigProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.ThresholdsConfigProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ThresholdsConfigProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for ThresholdsConfigProto
             * @function getTypeUrl
             * @memberof waiternow.common.ThresholdsConfigProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            ThresholdsConfigProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.ThresholdsConfigProto";
            };

            return ThresholdsConfigProto;
        })();

        common.BillingConfigProto = (function() {

            /**
             * Properties of a BillingConfigProto.
             * @memberof waiternow.common
             * @interface IBillingConfigProto
             * @property {Array.<waiternow.common.BillingConfigProto.ILocalizedConfigProto>|null} [localizedConfigurations] BillingConfigProto localizedConfigurations
             * @property {Array.<waiternow.common.BillingConfigProto.IPlanProto>|null} [plans] BillingConfigProto plans
             */

            /**
             * Constructs a new BillingConfigProto.
             * @memberof waiternow.common
             * @classdesc Represents a BillingConfigProto.
             * @implements IBillingConfigProto
             * @constructor
             * @param {waiternow.common.IBillingConfigProto=} [properties] Properties to set
             */
            function BillingConfigProto(properties) {
                this.localizedConfigurations = [];
                this.plans = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * BillingConfigProto localizedConfigurations.
             * @member {Array.<waiternow.common.BillingConfigProto.ILocalizedConfigProto>} localizedConfigurations
             * @memberof waiternow.common.BillingConfigProto
             * @instance
             */
            BillingConfigProto.prototype.localizedConfigurations = $util.emptyArray;

            /**
             * BillingConfigProto plans.
             * @member {Array.<waiternow.common.BillingConfigProto.IPlanProto>} plans
             * @memberof waiternow.common.BillingConfigProto
             * @instance
             */
            BillingConfigProto.prototype.plans = $util.emptyArray;

            /**
             * Creates a new BillingConfigProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.BillingConfigProto
             * @static
             * @param {waiternow.common.IBillingConfigProto=} [properties] Properties to set
             * @returns {waiternow.common.BillingConfigProto} BillingConfigProto instance
             */
            BillingConfigProto.create = function create(properties) {
                return new BillingConfigProto(properties);
            };

            /**
             * Encodes the specified BillingConfigProto message. Does not implicitly {@link waiternow.common.BillingConfigProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.BillingConfigProto
             * @static
             * @param {waiternow.common.IBillingConfigProto} message BillingConfigProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BillingConfigProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.localizedConfigurations != null && message.localizedConfigurations.length)
                    for (var i = 0; i < message.localizedConfigurations.length; ++i)
                        $root.waiternow.common.BillingConfigProto.LocalizedConfigProto.encode(message.localizedConfigurations[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.plans != null && message.plans.length)
                    for (var i = 0; i < message.plans.length; ++i)
                        $root.waiternow.common.BillingConfigProto.PlanProto.encode(message.plans[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified BillingConfigProto message, length delimited. Does not implicitly {@link waiternow.common.BillingConfigProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.BillingConfigProto
             * @static
             * @param {waiternow.common.IBillingConfigProto} message BillingConfigProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BillingConfigProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a BillingConfigProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.BillingConfigProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.BillingConfigProto} BillingConfigProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BillingConfigProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.BillingConfigProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            if (!(message.localizedConfigurations && message.localizedConfigurations.length))
                                message.localizedConfigurations = [];
                            message.localizedConfigurations.push($root.waiternow.common.BillingConfigProto.LocalizedConfigProto.decode(reader, reader.uint32()));
                            break;
                        }
                    case 2: {
                            if (!(message.plans && message.plans.length))
                                message.plans = [];
                            message.plans.push($root.waiternow.common.BillingConfigProto.PlanProto.decode(reader, reader.uint32()));
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a BillingConfigProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.BillingConfigProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.BillingConfigProto} BillingConfigProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BillingConfigProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a BillingConfigProto message.
             * @function verify
             * @memberof waiternow.common.BillingConfigProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            BillingConfigProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.localizedConfigurations != null && message.hasOwnProperty("localizedConfigurations")) {
                    if (!Array.isArray(message.localizedConfigurations))
                        return "localizedConfigurations: array expected";
                    for (var i = 0; i < message.localizedConfigurations.length; ++i) {
                        var error = $root.waiternow.common.BillingConfigProto.LocalizedConfigProto.verify(message.localizedConfigurations[i]);
                        if (error)
                            return "localizedConfigurations." + error;
                    }
                }
                if (message.plans != null && message.hasOwnProperty("plans")) {
                    if (!Array.isArray(message.plans))
                        return "plans: array expected";
                    for (var i = 0; i < message.plans.length; ++i) {
                        var error = $root.waiternow.common.BillingConfigProto.PlanProto.verify(message.plans[i]);
                        if (error)
                            return "plans." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a BillingConfigProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.BillingConfigProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.BillingConfigProto} BillingConfigProto
             */
            BillingConfigProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.BillingConfigProto)
                    return object;
                var message = new $root.waiternow.common.BillingConfigProto();
                if (object.localizedConfigurations) {
                    if (!Array.isArray(object.localizedConfigurations))
                        throw TypeError(".waiternow.common.BillingConfigProto.localizedConfigurations: array expected");
                    message.localizedConfigurations = [];
                    for (var i = 0; i < object.localizedConfigurations.length; ++i) {
                        if (typeof object.localizedConfigurations[i] !== "object")
                            throw TypeError(".waiternow.common.BillingConfigProto.localizedConfigurations: object expected");
                        message.localizedConfigurations[i] = $root.waiternow.common.BillingConfigProto.LocalizedConfigProto.fromObject(object.localizedConfigurations[i]);
                    }
                }
                if (object.plans) {
                    if (!Array.isArray(object.plans))
                        throw TypeError(".waiternow.common.BillingConfigProto.plans: array expected");
                    message.plans = [];
                    for (var i = 0; i < object.plans.length; ++i) {
                        if (typeof object.plans[i] !== "object")
                            throw TypeError(".waiternow.common.BillingConfigProto.plans: object expected");
                        message.plans[i] = $root.waiternow.common.BillingConfigProto.PlanProto.fromObject(object.plans[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a BillingConfigProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.BillingConfigProto
             * @static
             * @param {waiternow.common.BillingConfigProto} message BillingConfigProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            BillingConfigProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults) {
                    object.localizedConfigurations = [];
                    object.plans = [];
                }
                if (message.localizedConfigurations && message.localizedConfigurations.length) {
                    object.localizedConfigurations = [];
                    for (var j = 0; j < message.localizedConfigurations.length; ++j)
                        object.localizedConfigurations[j] = $root.waiternow.common.BillingConfigProto.LocalizedConfigProto.toObject(message.localizedConfigurations[j], options);
                }
                if (message.plans && message.plans.length) {
                    object.plans = [];
                    for (var j = 0; j < message.plans.length; ++j)
                        object.plans[j] = $root.waiternow.common.BillingConfigProto.PlanProto.toObject(message.plans[j], options);
                }
                return object;
            };

            /**
             * Converts this BillingConfigProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.BillingConfigProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            BillingConfigProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for BillingConfigProto
             * @function getTypeUrl
             * @memberof waiternow.common.BillingConfigProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            BillingConfigProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.BillingConfigProto";
            };

            BillingConfigProto.LocalizedConfigProto = (function() {

                /**
                 * Properties of a LocalizedConfigProto.
                 * @memberof waiternow.common.BillingConfigProto
                 * @interface ILocalizedConfigProto
                 * @property {waiternow.common.Country|null} [country] LocalizedConfigProto country
                 * @property {string|null} [state] LocalizedConfigProto state
                 * @property {string|null} [currencyCode] LocalizedConfigProto currencyCode
                 * @property {waiternow.common.IDecimalProto|null} [tax] LocalizedConfigProto tax
                 */

                /**
                 * Constructs a new LocalizedConfigProto.
                 * @memberof waiternow.common.BillingConfigProto
                 * @classdesc Represents a LocalizedConfigProto.
                 * @implements ILocalizedConfigProto
                 * @constructor
                 * @param {waiternow.common.BillingConfigProto.ILocalizedConfigProto=} [properties] Properties to set
                 */
                function LocalizedConfigProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * LocalizedConfigProto country.
                 * @member {waiternow.common.Country} country
                 * @memberof waiternow.common.BillingConfigProto.LocalizedConfigProto
                 * @instance
                 */
                LocalizedConfigProto.prototype.country = 0;

                /**
                 * LocalizedConfigProto state.
                 * @member {string} state
                 * @memberof waiternow.common.BillingConfigProto.LocalizedConfigProto
                 * @instance
                 */
                LocalizedConfigProto.prototype.state = "";

                /**
                 * LocalizedConfigProto currencyCode.
                 * @member {string} currencyCode
                 * @memberof waiternow.common.BillingConfigProto.LocalizedConfigProto
                 * @instance
                 */
                LocalizedConfigProto.prototype.currencyCode = "";

                /**
                 * LocalizedConfigProto tax.
                 * @member {waiternow.common.IDecimalProto|null|undefined} tax
                 * @memberof waiternow.common.BillingConfigProto.LocalizedConfigProto
                 * @instance
                 */
                LocalizedConfigProto.prototype.tax = null;

                /**
                 * Creates a new LocalizedConfigProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.BillingConfigProto.LocalizedConfigProto
                 * @static
                 * @param {waiternow.common.BillingConfigProto.ILocalizedConfigProto=} [properties] Properties to set
                 * @returns {waiternow.common.BillingConfigProto.LocalizedConfigProto} LocalizedConfigProto instance
                 */
                LocalizedConfigProto.create = function create(properties) {
                    return new LocalizedConfigProto(properties);
                };

                /**
                 * Encodes the specified LocalizedConfigProto message. Does not implicitly {@link waiternow.common.BillingConfigProto.LocalizedConfigProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.BillingConfigProto.LocalizedConfigProto
                 * @static
                 * @param {waiternow.common.BillingConfigProto.ILocalizedConfigProto} message LocalizedConfigProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LocalizedConfigProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.country != null && Object.hasOwnProperty.call(message, "country"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.country);
                    if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.state);
                    if (message.currencyCode != null && Object.hasOwnProperty.call(message, "currencyCode"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.currencyCode);
                    if (message.tax != null && Object.hasOwnProperty.call(message, "tax"))
                        $root.waiternow.common.DecimalProto.encode(message.tax, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified LocalizedConfigProto message, length delimited. Does not implicitly {@link waiternow.common.BillingConfigProto.LocalizedConfigProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.BillingConfigProto.LocalizedConfigProto
                 * @static
                 * @param {waiternow.common.BillingConfigProto.ILocalizedConfigProto} message LocalizedConfigProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LocalizedConfigProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a LocalizedConfigProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.BillingConfigProto.LocalizedConfigProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.BillingConfigProto.LocalizedConfigProto} LocalizedConfigProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LocalizedConfigProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.BillingConfigProto.LocalizedConfigProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.country = reader.int32();
                                break;
                            }
                        case 2: {
                                message.state = reader.string();
                                break;
                            }
                        case 3: {
                                message.currencyCode = reader.string();
                                break;
                            }
                        case 4: {
                                message.tax = $root.waiternow.common.DecimalProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a LocalizedConfigProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.BillingConfigProto.LocalizedConfigProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.BillingConfigProto.LocalizedConfigProto} LocalizedConfigProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LocalizedConfigProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a LocalizedConfigProto message.
                 * @function verify
                 * @memberof waiternow.common.BillingConfigProto.LocalizedConfigProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                LocalizedConfigProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.country != null && message.hasOwnProperty("country"))
                        switch (message.country) {
                        default:
                            return "country: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.state != null && message.hasOwnProperty("state"))
                        if (!$util.isString(message.state))
                            return "state: string expected";
                    if (message.currencyCode != null && message.hasOwnProperty("currencyCode"))
                        if (!$util.isString(message.currencyCode))
                            return "currencyCode: string expected";
                    if (message.tax != null && message.hasOwnProperty("tax")) {
                        var error = $root.waiternow.common.DecimalProto.verify(message.tax);
                        if (error)
                            return "tax." + error;
                    }
                    return null;
                };

                /**
                 * Creates a LocalizedConfigProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.BillingConfigProto.LocalizedConfigProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.BillingConfigProto.LocalizedConfigProto} LocalizedConfigProto
                 */
                LocalizedConfigProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.BillingConfigProto.LocalizedConfigProto)
                        return object;
                    var message = new $root.waiternow.common.BillingConfigProto.LocalizedConfigProto();
                    switch (object.country) {
                    default:
                        if (typeof object.country === "number") {
                            message.country = object.country;
                            break;
                        }
                        break;
                    case "COUNTRY_UNSPECIFIED":
                    case 0:
                        message.country = 0;
                        break;
                    case "UNITED_STATES":
                    case 1:
                        message.country = 1;
                        break;
                    case "MEXICO":
                    case 2:
                        message.country = 2;
                        break;
                    }
                    if (object.state != null)
                        message.state = String(object.state);
                    if (object.currencyCode != null)
                        message.currencyCode = String(object.currencyCode);
                    if (object.tax != null) {
                        if (typeof object.tax !== "object")
                            throw TypeError(".waiternow.common.BillingConfigProto.LocalizedConfigProto.tax: object expected");
                        message.tax = $root.waiternow.common.DecimalProto.fromObject(object.tax);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a LocalizedConfigProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.BillingConfigProto.LocalizedConfigProto
                 * @static
                 * @param {waiternow.common.BillingConfigProto.LocalizedConfigProto} message LocalizedConfigProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                LocalizedConfigProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.country = options.enums === String ? "COUNTRY_UNSPECIFIED" : 0;
                        object.state = "";
                        object.currencyCode = "";
                        object.tax = null;
                    }
                    if (message.country != null && message.hasOwnProperty("country"))
                        object.country = options.enums === String ? $root.waiternow.common.Country[message.country] === undefined ? message.country : $root.waiternow.common.Country[message.country] : message.country;
                    if (message.state != null && message.hasOwnProperty("state"))
                        object.state = message.state;
                    if (message.currencyCode != null && message.hasOwnProperty("currencyCode"))
                        object.currencyCode = message.currencyCode;
                    if (message.tax != null && message.hasOwnProperty("tax"))
                        object.tax = $root.waiternow.common.DecimalProto.toObject(message.tax, options);
                    return object;
                };

                /**
                 * Converts this LocalizedConfigProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.BillingConfigProto.LocalizedConfigProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                LocalizedConfigProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for LocalizedConfigProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.BillingConfigProto.LocalizedConfigProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                LocalizedConfigProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.BillingConfigProto.LocalizedConfigProto";
                };

                return LocalizedConfigProto;
            })();

            BillingConfigProto.PlanProto = (function() {

                /**
                 * Properties of a PlanProto.
                 * @memberof waiternow.common.BillingConfigProto
                 * @interface IPlanProto
                 * @property {waiternow.common.Country|null} [country] PlanProto country
                 * @property {waiternow.common.IIntRangeProto|null} [pointsOfServiceRange] PlanProto pointsOfServiceRange
                 * @property {number|null} [freeNumberOfRequests] PlanProto freeNumberOfRequests
                 * @property {waiternow.common.IMoneyProto|null} [cost] PlanProto cost
                 */

                /**
                 * Constructs a new PlanProto.
                 * @memberof waiternow.common.BillingConfigProto
                 * @classdesc Represents a PlanProto.
                 * @implements IPlanProto
                 * @constructor
                 * @param {waiternow.common.BillingConfigProto.IPlanProto=} [properties] Properties to set
                 */
                function PlanProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PlanProto country.
                 * @member {waiternow.common.Country} country
                 * @memberof waiternow.common.BillingConfigProto.PlanProto
                 * @instance
                 */
                PlanProto.prototype.country = 0;

                /**
                 * PlanProto pointsOfServiceRange.
                 * @member {waiternow.common.IIntRangeProto|null|undefined} pointsOfServiceRange
                 * @memberof waiternow.common.BillingConfigProto.PlanProto
                 * @instance
                 */
                PlanProto.prototype.pointsOfServiceRange = null;

                /**
                 * PlanProto freeNumberOfRequests.
                 * @member {number} freeNumberOfRequests
                 * @memberof waiternow.common.BillingConfigProto.PlanProto
                 * @instance
                 */
                PlanProto.prototype.freeNumberOfRequests = 0;

                /**
                 * PlanProto cost.
                 * @member {waiternow.common.IMoneyProto|null|undefined} cost
                 * @memberof waiternow.common.BillingConfigProto.PlanProto
                 * @instance
                 */
                PlanProto.prototype.cost = null;

                /**
                 * Creates a new PlanProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.BillingConfigProto.PlanProto
                 * @static
                 * @param {waiternow.common.BillingConfigProto.IPlanProto=} [properties] Properties to set
                 * @returns {waiternow.common.BillingConfigProto.PlanProto} PlanProto instance
                 */
                PlanProto.create = function create(properties) {
                    return new PlanProto(properties);
                };

                /**
                 * Encodes the specified PlanProto message. Does not implicitly {@link waiternow.common.BillingConfigProto.PlanProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.BillingConfigProto.PlanProto
                 * @static
                 * @param {waiternow.common.BillingConfigProto.IPlanProto} message PlanProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PlanProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.country != null && Object.hasOwnProperty.call(message, "country"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.country);
                    if (message.pointsOfServiceRange != null && Object.hasOwnProperty.call(message, "pointsOfServiceRange"))
                        $root.waiternow.common.IntRangeProto.encode(message.pointsOfServiceRange, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.freeNumberOfRequests != null && Object.hasOwnProperty.call(message, "freeNumberOfRequests"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.freeNumberOfRequests);
                    if (message.cost != null && Object.hasOwnProperty.call(message, "cost"))
                        $root.waiternow.common.MoneyProto.encode(message.cost, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified PlanProto message, length delimited. Does not implicitly {@link waiternow.common.BillingConfigProto.PlanProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.BillingConfigProto.PlanProto
                 * @static
                 * @param {waiternow.common.BillingConfigProto.IPlanProto} message PlanProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PlanProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PlanProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.BillingConfigProto.PlanProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.BillingConfigProto.PlanProto} PlanProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PlanProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.BillingConfigProto.PlanProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.country = reader.int32();
                                break;
                            }
                        case 2: {
                                message.pointsOfServiceRange = $root.waiternow.common.IntRangeProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.freeNumberOfRequests = reader.int32();
                                break;
                            }
                        case 4: {
                                message.cost = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PlanProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.BillingConfigProto.PlanProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.BillingConfigProto.PlanProto} PlanProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PlanProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PlanProto message.
                 * @function verify
                 * @memberof waiternow.common.BillingConfigProto.PlanProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PlanProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.country != null && message.hasOwnProperty("country"))
                        switch (message.country) {
                        default:
                            return "country: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.pointsOfServiceRange != null && message.hasOwnProperty("pointsOfServiceRange")) {
                        var error = $root.waiternow.common.IntRangeProto.verify(message.pointsOfServiceRange);
                        if (error)
                            return "pointsOfServiceRange." + error;
                    }
                    if (message.freeNumberOfRequests != null && message.hasOwnProperty("freeNumberOfRequests"))
                        if (!$util.isInteger(message.freeNumberOfRequests))
                            return "freeNumberOfRequests: integer expected";
                    if (message.cost != null && message.hasOwnProperty("cost")) {
                        var error = $root.waiternow.common.MoneyProto.verify(message.cost);
                        if (error)
                            return "cost." + error;
                    }
                    return null;
                };

                /**
                 * Creates a PlanProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.BillingConfigProto.PlanProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.BillingConfigProto.PlanProto} PlanProto
                 */
                PlanProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.BillingConfigProto.PlanProto)
                        return object;
                    var message = new $root.waiternow.common.BillingConfigProto.PlanProto();
                    switch (object.country) {
                    default:
                        if (typeof object.country === "number") {
                            message.country = object.country;
                            break;
                        }
                        break;
                    case "COUNTRY_UNSPECIFIED":
                    case 0:
                        message.country = 0;
                        break;
                    case "UNITED_STATES":
                    case 1:
                        message.country = 1;
                        break;
                    case "MEXICO":
                    case 2:
                        message.country = 2;
                        break;
                    }
                    if (object.pointsOfServiceRange != null) {
                        if (typeof object.pointsOfServiceRange !== "object")
                            throw TypeError(".waiternow.common.BillingConfigProto.PlanProto.pointsOfServiceRange: object expected");
                        message.pointsOfServiceRange = $root.waiternow.common.IntRangeProto.fromObject(object.pointsOfServiceRange);
                    }
                    if (object.freeNumberOfRequests != null)
                        message.freeNumberOfRequests = object.freeNumberOfRequests | 0;
                    if (object.cost != null) {
                        if (typeof object.cost !== "object")
                            throw TypeError(".waiternow.common.BillingConfigProto.PlanProto.cost: object expected");
                        message.cost = $root.waiternow.common.MoneyProto.fromObject(object.cost);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a PlanProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.BillingConfigProto.PlanProto
                 * @static
                 * @param {waiternow.common.BillingConfigProto.PlanProto} message PlanProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PlanProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.country = options.enums === String ? "COUNTRY_UNSPECIFIED" : 0;
                        object.pointsOfServiceRange = null;
                        object.freeNumberOfRequests = 0;
                        object.cost = null;
                    }
                    if (message.country != null && message.hasOwnProperty("country"))
                        object.country = options.enums === String ? $root.waiternow.common.Country[message.country] === undefined ? message.country : $root.waiternow.common.Country[message.country] : message.country;
                    if (message.pointsOfServiceRange != null && message.hasOwnProperty("pointsOfServiceRange"))
                        object.pointsOfServiceRange = $root.waiternow.common.IntRangeProto.toObject(message.pointsOfServiceRange, options);
                    if (message.freeNumberOfRequests != null && message.hasOwnProperty("freeNumberOfRequests"))
                        object.freeNumberOfRequests = message.freeNumberOfRequests;
                    if (message.cost != null && message.hasOwnProperty("cost"))
                        object.cost = $root.waiternow.common.MoneyProto.toObject(message.cost, options);
                    return object;
                };

                /**
                 * Converts this PlanProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.BillingConfigProto.PlanProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PlanProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for PlanProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.BillingConfigProto.PlanProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                PlanProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.BillingConfigProto.PlanProto";
                };

                return PlanProto;
            })();

            return BillingConfigProto;
        })();

        common.PaymentConfigProto = (function() {

            /**
             * Properties of a PaymentConfigProto.
             * @memberof waiternow.common
             * @interface IPaymentConfigProto
             * @property {waiternow.common.PaymentConfigProto.IPayPalConfigProto|null} [paypalUsaConfig] PaymentConfigProto paypalUsaConfig
             * @property {waiternow.common.PaymentConfigProto.IStripeConfigProto|null} [stripeUsaConfig] PaymentConfigProto stripeUsaConfig
             * @property {waiternow.common.IDerivedQuantityConfigProto|null} [orderPaymentStripeFeeUsa] PaymentConfigProto orderPaymentStripeFeeUsa
             * @property {waiternow.common.PaymentConfigProto.IVariableFeeProto|null} [orderPaymentWaiterNowFeeUsa] PaymentConfigProto orderPaymentWaiterNowFeeUsa
             */

            /**
             * Constructs a new PaymentConfigProto.
             * @memberof waiternow.common
             * @classdesc Represents a PaymentConfigProto.
             * @implements IPaymentConfigProto
             * @constructor
             * @param {waiternow.common.IPaymentConfigProto=} [properties] Properties to set
             */
            function PaymentConfigProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * PaymentConfigProto paypalUsaConfig.
             * @member {waiternow.common.PaymentConfigProto.IPayPalConfigProto|null|undefined} paypalUsaConfig
             * @memberof waiternow.common.PaymentConfigProto
             * @instance
             */
            PaymentConfigProto.prototype.paypalUsaConfig = null;

            /**
             * PaymentConfigProto stripeUsaConfig.
             * @member {waiternow.common.PaymentConfigProto.IStripeConfigProto|null|undefined} stripeUsaConfig
             * @memberof waiternow.common.PaymentConfigProto
             * @instance
             */
            PaymentConfigProto.prototype.stripeUsaConfig = null;

            /**
             * PaymentConfigProto orderPaymentStripeFeeUsa.
             * @member {waiternow.common.IDerivedQuantityConfigProto|null|undefined} orderPaymentStripeFeeUsa
             * @memberof waiternow.common.PaymentConfigProto
             * @instance
             */
            PaymentConfigProto.prototype.orderPaymentStripeFeeUsa = null;

            /**
             * PaymentConfigProto orderPaymentWaiterNowFeeUsa.
             * @member {waiternow.common.PaymentConfigProto.IVariableFeeProto|null|undefined} orderPaymentWaiterNowFeeUsa
             * @memberof waiternow.common.PaymentConfigProto
             * @instance
             */
            PaymentConfigProto.prototype.orderPaymentWaiterNowFeeUsa = null;

            /**
             * Creates a new PaymentConfigProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.PaymentConfigProto
             * @static
             * @param {waiternow.common.IPaymentConfigProto=} [properties] Properties to set
             * @returns {waiternow.common.PaymentConfigProto} PaymentConfigProto instance
             */
            PaymentConfigProto.create = function create(properties) {
                return new PaymentConfigProto(properties);
            };

            /**
             * Encodes the specified PaymentConfigProto message. Does not implicitly {@link waiternow.common.PaymentConfigProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.PaymentConfigProto
             * @static
             * @param {waiternow.common.IPaymentConfigProto} message PaymentConfigProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PaymentConfigProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.paypalUsaConfig != null && Object.hasOwnProperty.call(message, "paypalUsaConfig"))
                    $root.waiternow.common.PaymentConfigProto.PayPalConfigProto.encode(message.paypalUsaConfig, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.stripeUsaConfig != null && Object.hasOwnProperty.call(message, "stripeUsaConfig"))
                    $root.waiternow.common.PaymentConfigProto.StripeConfigProto.encode(message.stripeUsaConfig, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.orderPaymentStripeFeeUsa != null && Object.hasOwnProperty.call(message, "orderPaymentStripeFeeUsa"))
                    $root.waiternow.common.DerivedQuantityConfigProto.encode(message.orderPaymentStripeFeeUsa, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.orderPaymentWaiterNowFeeUsa != null && Object.hasOwnProperty.call(message, "orderPaymentWaiterNowFeeUsa"))
                    $root.waiternow.common.PaymentConfigProto.VariableFeeProto.encode(message.orderPaymentWaiterNowFeeUsa, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified PaymentConfigProto message, length delimited. Does not implicitly {@link waiternow.common.PaymentConfigProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.PaymentConfigProto
             * @static
             * @param {waiternow.common.IPaymentConfigProto} message PaymentConfigProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PaymentConfigProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a PaymentConfigProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.PaymentConfigProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.PaymentConfigProto} PaymentConfigProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PaymentConfigProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PaymentConfigProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.paypalUsaConfig = $root.waiternow.common.PaymentConfigProto.PayPalConfigProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 2: {
                            message.stripeUsaConfig = $root.waiternow.common.PaymentConfigProto.StripeConfigProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 3: {
                            message.orderPaymentStripeFeeUsa = $root.waiternow.common.DerivedQuantityConfigProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 4: {
                            message.orderPaymentWaiterNowFeeUsa = $root.waiternow.common.PaymentConfigProto.VariableFeeProto.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a PaymentConfigProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.PaymentConfigProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.PaymentConfigProto} PaymentConfigProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PaymentConfigProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a PaymentConfigProto message.
             * @function verify
             * @memberof waiternow.common.PaymentConfigProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            PaymentConfigProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.paypalUsaConfig != null && message.hasOwnProperty("paypalUsaConfig")) {
                    var error = $root.waiternow.common.PaymentConfigProto.PayPalConfigProto.verify(message.paypalUsaConfig);
                    if (error)
                        return "paypalUsaConfig." + error;
                }
                if (message.stripeUsaConfig != null && message.hasOwnProperty("stripeUsaConfig")) {
                    var error = $root.waiternow.common.PaymentConfigProto.StripeConfigProto.verify(message.stripeUsaConfig);
                    if (error)
                        return "stripeUsaConfig." + error;
                }
                if (message.orderPaymentStripeFeeUsa != null && message.hasOwnProperty("orderPaymentStripeFeeUsa")) {
                    var error = $root.waiternow.common.DerivedQuantityConfigProto.verify(message.orderPaymentStripeFeeUsa);
                    if (error)
                        return "orderPaymentStripeFeeUsa." + error;
                }
                if (message.orderPaymentWaiterNowFeeUsa != null && message.hasOwnProperty("orderPaymentWaiterNowFeeUsa")) {
                    var error = $root.waiternow.common.PaymentConfigProto.VariableFeeProto.verify(message.orderPaymentWaiterNowFeeUsa);
                    if (error)
                        return "orderPaymentWaiterNowFeeUsa." + error;
                }
                return null;
            };

            /**
             * Creates a PaymentConfigProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.PaymentConfigProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.PaymentConfigProto} PaymentConfigProto
             */
            PaymentConfigProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.PaymentConfigProto)
                    return object;
                var message = new $root.waiternow.common.PaymentConfigProto();
                if (object.paypalUsaConfig != null) {
                    if (typeof object.paypalUsaConfig !== "object")
                        throw TypeError(".waiternow.common.PaymentConfigProto.paypalUsaConfig: object expected");
                    message.paypalUsaConfig = $root.waiternow.common.PaymentConfigProto.PayPalConfigProto.fromObject(object.paypalUsaConfig);
                }
                if (object.stripeUsaConfig != null) {
                    if (typeof object.stripeUsaConfig !== "object")
                        throw TypeError(".waiternow.common.PaymentConfigProto.stripeUsaConfig: object expected");
                    message.stripeUsaConfig = $root.waiternow.common.PaymentConfigProto.StripeConfigProto.fromObject(object.stripeUsaConfig);
                }
                if (object.orderPaymentStripeFeeUsa != null) {
                    if (typeof object.orderPaymentStripeFeeUsa !== "object")
                        throw TypeError(".waiternow.common.PaymentConfigProto.orderPaymentStripeFeeUsa: object expected");
                    message.orderPaymentStripeFeeUsa = $root.waiternow.common.DerivedQuantityConfigProto.fromObject(object.orderPaymentStripeFeeUsa);
                }
                if (object.orderPaymentWaiterNowFeeUsa != null) {
                    if (typeof object.orderPaymentWaiterNowFeeUsa !== "object")
                        throw TypeError(".waiternow.common.PaymentConfigProto.orderPaymentWaiterNowFeeUsa: object expected");
                    message.orderPaymentWaiterNowFeeUsa = $root.waiternow.common.PaymentConfigProto.VariableFeeProto.fromObject(object.orderPaymentWaiterNowFeeUsa);
                }
                return message;
            };

            /**
             * Creates a plain object from a PaymentConfigProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.PaymentConfigProto
             * @static
             * @param {waiternow.common.PaymentConfigProto} message PaymentConfigProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            PaymentConfigProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.paypalUsaConfig = null;
                    object.stripeUsaConfig = null;
                    object.orderPaymentStripeFeeUsa = null;
                    object.orderPaymentWaiterNowFeeUsa = null;
                }
                if (message.paypalUsaConfig != null && message.hasOwnProperty("paypalUsaConfig"))
                    object.paypalUsaConfig = $root.waiternow.common.PaymentConfigProto.PayPalConfigProto.toObject(message.paypalUsaConfig, options);
                if (message.stripeUsaConfig != null && message.hasOwnProperty("stripeUsaConfig"))
                    object.stripeUsaConfig = $root.waiternow.common.PaymentConfigProto.StripeConfigProto.toObject(message.stripeUsaConfig, options);
                if (message.orderPaymentStripeFeeUsa != null && message.hasOwnProperty("orderPaymentStripeFeeUsa"))
                    object.orderPaymentStripeFeeUsa = $root.waiternow.common.DerivedQuantityConfigProto.toObject(message.orderPaymentStripeFeeUsa, options);
                if (message.orderPaymentWaiterNowFeeUsa != null && message.hasOwnProperty("orderPaymentWaiterNowFeeUsa"))
                    object.orderPaymentWaiterNowFeeUsa = $root.waiternow.common.PaymentConfigProto.VariableFeeProto.toObject(message.orderPaymentWaiterNowFeeUsa, options);
                return object;
            };

            /**
             * Converts this PaymentConfigProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.PaymentConfigProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            PaymentConfigProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for PaymentConfigProto
             * @function getTypeUrl
             * @memberof waiternow.common.PaymentConfigProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            PaymentConfigProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.PaymentConfigProto";
            };

            PaymentConfigProto.PayPalConfigProto = (function() {

                /**
                 * Properties of a PayPalConfigProto.
                 * @memberof waiternow.common.PaymentConfigProto
                 * @interface IPayPalConfigProto
                 * @property {string|null} [clientId] PayPalConfigProto clientId
                 * @property {string|null} [encryptedSecret] PayPalConfigProto encryptedSecret
                 */

                /**
                 * Constructs a new PayPalConfigProto.
                 * @memberof waiternow.common.PaymentConfigProto
                 * @classdesc Represents a PayPalConfigProto.
                 * @implements IPayPalConfigProto
                 * @constructor
                 * @param {waiternow.common.PaymentConfigProto.IPayPalConfigProto=} [properties] Properties to set
                 */
                function PayPalConfigProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PayPalConfigProto clientId.
                 * @member {string} clientId
                 * @memberof waiternow.common.PaymentConfigProto.PayPalConfigProto
                 * @instance
                 */
                PayPalConfigProto.prototype.clientId = "";

                /**
                 * PayPalConfigProto encryptedSecret.
                 * @member {string} encryptedSecret
                 * @memberof waiternow.common.PaymentConfigProto.PayPalConfigProto
                 * @instance
                 */
                PayPalConfigProto.prototype.encryptedSecret = "";

                /**
                 * Creates a new PayPalConfigProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.PaymentConfigProto.PayPalConfigProto
                 * @static
                 * @param {waiternow.common.PaymentConfigProto.IPayPalConfigProto=} [properties] Properties to set
                 * @returns {waiternow.common.PaymentConfigProto.PayPalConfigProto} PayPalConfigProto instance
                 */
                PayPalConfigProto.create = function create(properties) {
                    return new PayPalConfigProto(properties);
                };

                /**
                 * Encodes the specified PayPalConfigProto message. Does not implicitly {@link waiternow.common.PaymentConfigProto.PayPalConfigProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.PaymentConfigProto.PayPalConfigProto
                 * @static
                 * @param {waiternow.common.PaymentConfigProto.IPayPalConfigProto} message PayPalConfigProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PayPalConfigProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.clientId != null && Object.hasOwnProperty.call(message, "clientId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.clientId);
                    if (message.encryptedSecret != null && Object.hasOwnProperty.call(message, "encryptedSecret"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.encryptedSecret);
                    return writer;
                };

                /**
                 * Encodes the specified PayPalConfigProto message, length delimited. Does not implicitly {@link waiternow.common.PaymentConfigProto.PayPalConfigProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.PaymentConfigProto.PayPalConfigProto
                 * @static
                 * @param {waiternow.common.PaymentConfigProto.IPayPalConfigProto} message PayPalConfigProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PayPalConfigProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PayPalConfigProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.PaymentConfigProto.PayPalConfigProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.PaymentConfigProto.PayPalConfigProto} PayPalConfigProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PayPalConfigProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PaymentConfigProto.PayPalConfigProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.clientId = reader.string();
                                break;
                            }
                        case 2: {
                                message.encryptedSecret = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PayPalConfigProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.PaymentConfigProto.PayPalConfigProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.PaymentConfigProto.PayPalConfigProto} PayPalConfigProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PayPalConfigProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PayPalConfigProto message.
                 * @function verify
                 * @memberof waiternow.common.PaymentConfigProto.PayPalConfigProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PayPalConfigProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.clientId != null && message.hasOwnProperty("clientId"))
                        if (!$util.isString(message.clientId))
                            return "clientId: string expected";
                    if (message.encryptedSecret != null && message.hasOwnProperty("encryptedSecret"))
                        if (!$util.isString(message.encryptedSecret))
                            return "encryptedSecret: string expected";
                    return null;
                };

                /**
                 * Creates a PayPalConfigProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.PaymentConfigProto.PayPalConfigProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.PaymentConfigProto.PayPalConfigProto} PayPalConfigProto
                 */
                PayPalConfigProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.PaymentConfigProto.PayPalConfigProto)
                        return object;
                    var message = new $root.waiternow.common.PaymentConfigProto.PayPalConfigProto();
                    if (object.clientId != null)
                        message.clientId = String(object.clientId);
                    if (object.encryptedSecret != null)
                        message.encryptedSecret = String(object.encryptedSecret);
                    return message;
                };

                /**
                 * Creates a plain object from a PayPalConfigProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.PaymentConfigProto.PayPalConfigProto
                 * @static
                 * @param {waiternow.common.PaymentConfigProto.PayPalConfigProto} message PayPalConfigProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PayPalConfigProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.clientId = "";
                        object.encryptedSecret = "";
                    }
                    if (message.clientId != null && message.hasOwnProperty("clientId"))
                        object.clientId = message.clientId;
                    if (message.encryptedSecret != null && message.hasOwnProperty("encryptedSecret"))
                        object.encryptedSecret = message.encryptedSecret;
                    return object;
                };

                /**
                 * Converts this PayPalConfigProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.PaymentConfigProto.PayPalConfigProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PayPalConfigProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for PayPalConfigProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.PaymentConfigProto.PayPalConfigProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                PayPalConfigProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.PaymentConfigProto.PayPalConfigProto";
                };

                return PayPalConfigProto;
            })();

            PaymentConfigProto.StripeConfigProto = (function() {

                /**
                 * Properties of a StripeConfigProto.
                 * @memberof waiternow.common.PaymentConfigProto
                 * @interface IStripeConfigProto
                 * @property {string|null} [encryptedSecretKey] StripeConfigProto encryptedSecretKey
                 * @property {string|null} [publishableKey] StripeConfigProto publishableKey
                 */

                /**
                 * Constructs a new StripeConfigProto.
                 * @memberof waiternow.common.PaymentConfigProto
                 * @classdesc Represents a StripeConfigProto.
                 * @implements IStripeConfigProto
                 * @constructor
                 * @param {waiternow.common.PaymentConfigProto.IStripeConfigProto=} [properties] Properties to set
                 */
                function StripeConfigProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StripeConfigProto encryptedSecretKey.
                 * @member {string} encryptedSecretKey
                 * @memberof waiternow.common.PaymentConfigProto.StripeConfigProto
                 * @instance
                 */
                StripeConfigProto.prototype.encryptedSecretKey = "";

                /**
                 * StripeConfigProto publishableKey.
                 * @member {string} publishableKey
                 * @memberof waiternow.common.PaymentConfigProto.StripeConfigProto
                 * @instance
                 */
                StripeConfigProto.prototype.publishableKey = "";

                /**
                 * Creates a new StripeConfigProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.PaymentConfigProto.StripeConfigProto
                 * @static
                 * @param {waiternow.common.PaymentConfigProto.IStripeConfigProto=} [properties] Properties to set
                 * @returns {waiternow.common.PaymentConfigProto.StripeConfigProto} StripeConfigProto instance
                 */
                StripeConfigProto.create = function create(properties) {
                    return new StripeConfigProto(properties);
                };

                /**
                 * Encodes the specified StripeConfigProto message. Does not implicitly {@link waiternow.common.PaymentConfigProto.StripeConfigProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.PaymentConfigProto.StripeConfigProto
                 * @static
                 * @param {waiternow.common.PaymentConfigProto.IStripeConfigProto} message StripeConfigProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StripeConfigProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.encryptedSecretKey != null && Object.hasOwnProperty.call(message, "encryptedSecretKey"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.encryptedSecretKey);
                    if (message.publishableKey != null && Object.hasOwnProperty.call(message, "publishableKey"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.publishableKey);
                    return writer;
                };

                /**
                 * Encodes the specified StripeConfigProto message, length delimited. Does not implicitly {@link waiternow.common.PaymentConfigProto.StripeConfigProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.PaymentConfigProto.StripeConfigProto
                 * @static
                 * @param {waiternow.common.PaymentConfigProto.IStripeConfigProto} message StripeConfigProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StripeConfigProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a StripeConfigProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.PaymentConfigProto.StripeConfigProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.PaymentConfigProto.StripeConfigProto} StripeConfigProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StripeConfigProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PaymentConfigProto.StripeConfigProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.encryptedSecretKey = reader.string();
                                break;
                            }
                        case 2: {
                                message.publishableKey = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a StripeConfigProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.PaymentConfigProto.StripeConfigProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.PaymentConfigProto.StripeConfigProto} StripeConfigProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StripeConfigProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StripeConfigProto message.
                 * @function verify
                 * @memberof waiternow.common.PaymentConfigProto.StripeConfigProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StripeConfigProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.encryptedSecretKey != null && message.hasOwnProperty("encryptedSecretKey"))
                        if (!$util.isString(message.encryptedSecretKey))
                            return "encryptedSecretKey: string expected";
                    if (message.publishableKey != null && message.hasOwnProperty("publishableKey"))
                        if (!$util.isString(message.publishableKey))
                            return "publishableKey: string expected";
                    return null;
                };

                /**
                 * Creates a StripeConfigProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.PaymentConfigProto.StripeConfigProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.PaymentConfigProto.StripeConfigProto} StripeConfigProto
                 */
                StripeConfigProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.PaymentConfigProto.StripeConfigProto)
                        return object;
                    var message = new $root.waiternow.common.PaymentConfigProto.StripeConfigProto();
                    if (object.encryptedSecretKey != null)
                        message.encryptedSecretKey = String(object.encryptedSecretKey);
                    if (object.publishableKey != null)
                        message.publishableKey = String(object.publishableKey);
                    return message;
                };

                /**
                 * Creates a plain object from a StripeConfigProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.PaymentConfigProto.StripeConfigProto
                 * @static
                 * @param {waiternow.common.PaymentConfigProto.StripeConfigProto} message StripeConfigProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StripeConfigProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.encryptedSecretKey = "";
                        object.publishableKey = "";
                    }
                    if (message.encryptedSecretKey != null && message.hasOwnProperty("encryptedSecretKey"))
                        object.encryptedSecretKey = message.encryptedSecretKey;
                    if (message.publishableKey != null && message.hasOwnProperty("publishableKey"))
                        object.publishableKey = message.publishableKey;
                    return object;
                };

                /**
                 * Converts this StripeConfigProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.PaymentConfigProto.StripeConfigProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StripeConfigProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for StripeConfigProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.PaymentConfigProto.StripeConfigProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                StripeConfigProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.PaymentConfigProto.StripeConfigProto";
                };

                return StripeConfigProto;
            })();

            PaymentConfigProto.VariableFeeProto = (function() {

                /**
                 * Properties of a VariableFeeProto.
                 * @memberof waiternow.common.PaymentConfigProto
                 * @interface IVariableFeeProto
                 * @property {Array.<waiternow.common.PaymentConfigProto.VariableFeeProto.IBracketProto>|null} [brackets] VariableFeeProto brackets
                 */

                /**
                 * Constructs a new VariableFeeProto.
                 * @memberof waiternow.common.PaymentConfigProto
                 * @classdesc Represents a VariableFeeProto.
                 * @implements IVariableFeeProto
                 * @constructor
                 * @param {waiternow.common.PaymentConfigProto.IVariableFeeProto=} [properties] Properties to set
                 */
                function VariableFeeProto(properties) {
                    this.brackets = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * VariableFeeProto brackets.
                 * @member {Array.<waiternow.common.PaymentConfigProto.VariableFeeProto.IBracketProto>} brackets
                 * @memberof waiternow.common.PaymentConfigProto.VariableFeeProto
                 * @instance
                 */
                VariableFeeProto.prototype.brackets = $util.emptyArray;

                /**
                 * Creates a new VariableFeeProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.PaymentConfigProto.VariableFeeProto
                 * @static
                 * @param {waiternow.common.PaymentConfigProto.IVariableFeeProto=} [properties] Properties to set
                 * @returns {waiternow.common.PaymentConfigProto.VariableFeeProto} VariableFeeProto instance
                 */
                VariableFeeProto.create = function create(properties) {
                    return new VariableFeeProto(properties);
                };

                /**
                 * Encodes the specified VariableFeeProto message. Does not implicitly {@link waiternow.common.PaymentConfigProto.VariableFeeProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.PaymentConfigProto.VariableFeeProto
                 * @static
                 * @param {waiternow.common.PaymentConfigProto.IVariableFeeProto} message VariableFeeProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                VariableFeeProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.brackets != null && message.brackets.length)
                        for (var i = 0; i < message.brackets.length; ++i)
                            $root.waiternow.common.PaymentConfigProto.VariableFeeProto.BracketProto.encode(message.brackets[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified VariableFeeProto message, length delimited. Does not implicitly {@link waiternow.common.PaymentConfigProto.VariableFeeProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.PaymentConfigProto.VariableFeeProto
                 * @static
                 * @param {waiternow.common.PaymentConfigProto.IVariableFeeProto} message VariableFeeProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                VariableFeeProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a VariableFeeProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.PaymentConfigProto.VariableFeeProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.PaymentConfigProto.VariableFeeProto} VariableFeeProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                VariableFeeProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PaymentConfigProto.VariableFeeProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                if (!(message.brackets && message.brackets.length))
                                    message.brackets = [];
                                message.brackets.push($root.waiternow.common.PaymentConfigProto.VariableFeeProto.BracketProto.decode(reader, reader.uint32()));
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a VariableFeeProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.PaymentConfigProto.VariableFeeProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.PaymentConfigProto.VariableFeeProto} VariableFeeProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                VariableFeeProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a VariableFeeProto message.
                 * @function verify
                 * @memberof waiternow.common.PaymentConfigProto.VariableFeeProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                VariableFeeProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.brackets != null && message.hasOwnProperty("brackets")) {
                        if (!Array.isArray(message.brackets))
                            return "brackets: array expected";
                        for (var i = 0; i < message.brackets.length; ++i) {
                            var error = $root.waiternow.common.PaymentConfigProto.VariableFeeProto.BracketProto.verify(message.brackets[i]);
                            if (error)
                                return "brackets." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a VariableFeeProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.PaymentConfigProto.VariableFeeProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.PaymentConfigProto.VariableFeeProto} VariableFeeProto
                 */
                VariableFeeProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.PaymentConfigProto.VariableFeeProto)
                        return object;
                    var message = new $root.waiternow.common.PaymentConfigProto.VariableFeeProto();
                    if (object.brackets) {
                        if (!Array.isArray(object.brackets))
                            throw TypeError(".waiternow.common.PaymentConfigProto.VariableFeeProto.brackets: array expected");
                        message.brackets = [];
                        for (var i = 0; i < object.brackets.length; ++i) {
                            if (typeof object.brackets[i] !== "object")
                                throw TypeError(".waiternow.common.PaymentConfigProto.VariableFeeProto.brackets: object expected");
                            message.brackets[i] = $root.waiternow.common.PaymentConfigProto.VariableFeeProto.BracketProto.fromObject(object.brackets[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a VariableFeeProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.PaymentConfigProto.VariableFeeProto
                 * @static
                 * @param {waiternow.common.PaymentConfigProto.VariableFeeProto} message VariableFeeProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                VariableFeeProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.brackets = [];
                    if (message.brackets && message.brackets.length) {
                        object.brackets = [];
                        for (var j = 0; j < message.brackets.length; ++j)
                            object.brackets[j] = $root.waiternow.common.PaymentConfigProto.VariableFeeProto.BracketProto.toObject(message.brackets[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this VariableFeeProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.PaymentConfigProto.VariableFeeProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                VariableFeeProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for VariableFeeProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.PaymentConfigProto.VariableFeeProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                VariableFeeProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.PaymentConfigProto.VariableFeeProto";
                };

                VariableFeeProto.BracketProto = (function() {

                    /**
                     * Properties of a BracketProto.
                     * @memberof waiternow.common.PaymentConfigProto.VariableFeeProto
                     * @interface IBracketProto
                     * @property {waiternow.common.IDerivedQuantityConfigProto|null} [fee] BracketProto fee
                     * @property {waiternow.common.IMoneyProto|null} [upperLimitExclusive] BracketProto upperLimitExclusive
                     */

                    /**
                     * Constructs a new BracketProto.
                     * @memberof waiternow.common.PaymentConfigProto.VariableFeeProto
                     * @classdesc Represents a BracketProto.
                     * @implements IBracketProto
                     * @constructor
                     * @param {waiternow.common.PaymentConfigProto.VariableFeeProto.IBracketProto=} [properties] Properties to set
                     */
                    function BracketProto(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * BracketProto fee.
                     * @member {waiternow.common.IDerivedQuantityConfigProto|null|undefined} fee
                     * @memberof waiternow.common.PaymentConfigProto.VariableFeeProto.BracketProto
                     * @instance
                     */
                    BracketProto.prototype.fee = null;

                    /**
                     * BracketProto upperLimitExclusive.
                     * @member {waiternow.common.IMoneyProto|null|undefined} upperLimitExclusive
                     * @memberof waiternow.common.PaymentConfigProto.VariableFeeProto.BracketProto
                     * @instance
                     */
                    BracketProto.prototype.upperLimitExclusive = null;

                    /**
                     * Creates a new BracketProto instance using the specified properties.
                     * @function create
                     * @memberof waiternow.common.PaymentConfigProto.VariableFeeProto.BracketProto
                     * @static
                     * @param {waiternow.common.PaymentConfigProto.VariableFeeProto.IBracketProto=} [properties] Properties to set
                     * @returns {waiternow.common.PaymentConfigProto.VariableFeeProto.BracketProto} BracketProto instance
                     */
                    BracketProto.create = function create(properties) {
                        return new BracketProto(properties);
                    };

                    /**
                     * Encodes the specified BracketProto message. Does not implicitly {@link waiternow.common.PaymentConfigProto.VariableFeeProto.BracketProto.verify|verify} messages.
                     * @function encode
                     * @memberof waiternow.common.PaymentConfigProto.VariableFeeProto.BracketProto
                     * @static
                     * @param {waiternow.common.PaymentConfigProto.VariableFeeProto.IBracketProto} message BracketProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BracketProto.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.fee != null && Object.hasOwnProperty.call(message, "fee"))
                            $root.waiternow.common.DerivedQuantityConfigProto.encode(message.fee, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.upperLimitExclusive != null && Object.hasOwnProperty.call(message, "upperLimitExclusive"))
                            $root.waiternow.common.MoneyProto.encode(message.upperLimitExclusive, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };

                    /**
                     * Encodes the specified BracketProto message, length delimited. Does not implicitly {@link waiternow.common.PaymentConfigProto.VariableFeeProto.BracketProto.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof waiternow.common.PaymentConfigProto.VariableFeeProto.BracketProto
                     * @static
                     * @param {waiternow.common.PaymentConfigProto.VariableFeeProto.IBracketProto} message BracketProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BracketProto.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a BracketProto message from the specified reader or buffer.
                     * @function decode
                     * @memberof waiternow.common.PaymentConfigProto.VariableFeeProto.BracketProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {waiternow.common.PaymentConfigProto.VariableFeeProto.BracketProto} BracketProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BracketProto.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PaymentConfigProto.VariableFeeProto.BracketProto();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.fee = $root.waiternow.common.DerivedQuantityConfigProto.decode(reader, reader.uint32());
                                    break;
                                }
                            case 2: {
                                    message.upperLimitExclusive = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a BracketProto message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof waiternow.common.PaymentConfigProto.VariableFeeProto.BracketProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {waiternow.common.PaymentConfigProto.VariableFeeProto.BracketProto} BracketProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BracketProto.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a BracketProto message.
                     * @function verify
                     * @memberof waiternow.common.PaymentConfigProto.VariableFeeProto.BracketProto
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BracketProto.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.fee != null && message.hasOwnProperty("fee")) {
                            var error = $root.waiternow.common.DerivedQuantityConfigProto.verify(message.fee);
                            if (error)
                                return "fee." + error;
                        }
                        if (message.upperLimitExclusive != null && message.hasOwnProperty("upperLimitExclusive")) {
                            var error = $root.waiternow.common.MoneyProto.verify(message.upperLimitExclusive);
                            if (error)
                                return "upperLimitExclusive." + error;
                        }
                        return null;
                    };

                    /**
                     * Creates a BracketProto message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof waiternow.common.PaymentConfigProto.VariableFeeProto.BracketProto
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {waiternow.common.PaymentConfigProto.VariableFeeProto.BracketProto} BracketProto
                     */
                    BracketProto.fromObject = function fromObject(object) {
                        if (object instanceof $root.waiternow.common.PaymentConfigProto.VariableFeeProto.BracketProto)
                            return object;
                        var message = new $root.waiternow.common.PaymentConfigProto.VariableFeeProto.BracketProto();
                        if (object.fee != null) {
                            if (typeof object.fee !== "object")
                                throw TypeError(".waiternow.common.PaymentConfigProto.VariableFeeProto.BracketProto.fee: object expected");
                            message.fee = $root.waiternow.common.DerivedQuantityConfigProto.fromObject(object.fee);
                        }
                        if (object.upperLimitExclusive != null) {
                            if (typeof object.upperLimitExclusive !== "object")
                                throw TypeError(".waiternow.common.PaymentConfigProto.VariableFeeProto.BracketProto.upperLimitExclusive: object expected");
                            message.upperLimitExclusive = $root.waiternow.common.MoneyProto.fromObject(object.upperLimitExclusive);
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a BracketProto message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof waiternow.common.PaymentConfigProto.VariableFeeProto.BracketProto
                     * @static
                     * @param {waiternow.common.PaymentConfigProto.VariableFeeProto.BracketProto} message BracketProto
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BracketProto.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.fee = null;
                            object.upperLimitExclusive = null;
                        }
                        if (message.fee != null && message.hasOwnProperty("fee"))
                            object.fee = $root.waiternow.common.DerivedQuantityConfigProto.toObject(message.fee, options);
                        if (message.upperLimitExclusive != null && message.hasOwnProperty("upperLimitExclusive"))
                            object.upperLimitExclusive = $root.waiternow.common.MoneyProto.toObject(message.upperLimitExclusive, options);
                        return object;
                    };

                    /**
                     * Converts this BracketProto to JSON.
                     * @function toJSON
                     * @memberof waiternow.common.PaymentConfigProto.VariableFeeProto.BracketProto
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BracketProto.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for BracketProto
                     * @function getTypeUrl
                     * @memberof waiternow.common.PaymentConfigProto.VariableFeeProto.BracketProto
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    BracketProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/waiternow.common.PaymentConfigProto.VariableFeeProto.BracketProto";
                    };

                    return BracketProto;
                })();

                return VariableFeeProto;
            })();

            return PaymentConfigProto;
        })();

        common.GoogleApiKeysProto = (function() {

            /**
             * Properties of a GoogleApiKeysProto.
             * @memberof waiternow.common
             * @interface IGoogleApiKeysProto
             * @property {string|null} [encryptedGoogleMapsServicesApiKey] GoogleApiKeysProto encryptedGoogleMapsServicesApiKey
             * @property {string|null} [encryptedGoogleMapsServicesApiKeyForConsumer] GoogleApiKeysProto encryptedGoogleMapsServicesApiKeyForConsumer
             * @property {string|null} [encryptedGoogleAiServicesApiKeyForAdmin] GoogleApiKeysProto encryptedGoogleAiServicesApiKeyForAdmin
             */

            /**
             * Constructs a new GoogleApiKeysProto.
             * @memberof waiternow.common
             * @classdesc Represents a GoogleApiKeysProto.
             * @implements IGoogleApiKeysProto
             * @constructor
             * @param {waiternow.common.IGoogleApiKeysProto=} [properties] Properties to set
             */
            function GoogleApiKeysProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GoogleApiKeysProto encryptedGoogleMapsServicesApiKey.
             * @member {string} encryptedGoogleMapsServicesApiKey
             * @memberof waiternow.common.GoogleApiKeysProto
             * @instance
             */
            GoogleApiKeysProto.prototype.encryptedGoogleMapsServicesApiKey = "";

            /**
             * GoogleApiKeysProto encryptedGoogleMapsServicesApiKeyForConsumer.
             * @member {string} encryptedGoogleMapsServicesApiKeyForConsumer
             * @memberof waiternow.common.GoogleApiKeysProto
             * @instance
             */
            GoogleApiKeysProto.prototype.encryptedGoogleMapsServicesApiKeyForConsumer = "";

            /**
             * GoogleApiKeysProto encryptedGoogleAiServicesApiKeyForAdmin.
             * @member {string} encryptedGoogleAiServicesApiKeyForAdmin
             * @memberof waiternow.common.GoogleApiKeysProto
             * @instance
             */
            GoogleApiKeysProto.prototype.encryptedGoogleAiServicesApiKeyForAdmin = "";

            /**
             * Creates a new GoogleApiKeysProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.GoogleApiKeysProto
             * @static
             * @param {waiternow.common.IGoogleApiKeysProto=} [properties] Properties to set
             * @returns {waiternow.common.GoogleApiKeysProto} GoogleApiKeysProto instance
             */
            GoogleApiKeysProto.create = function create(properties) {
                return new GoogleApiKeysProto(properties);
            };

            /**
             * Encodes the specified GoogleApiKeysProto message. Does not implicitly {@link waiternow.common.GoogleApiKeysProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.GoogleApiKeysProto
             * @static
             * @param {waiternow.common.IGoogleApiKeysProto} message GoogleApiKeysProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GoogleApiKeysProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.encryptedGoogleMapsServicesApiKey != null && Object.hasOwnProperty.call(message, "encryptedGoogleMapsServicesApiKey"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.encryptedGoogleMapsServicesApiKey);
                if (message.encryptedGoogleMapsServicesApiKeyForConsumer != null && Object.hasOwnProperty.call(message, "encryptedGoogleMapsServicesApiKeyForConsumer"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.encryptedGoogleMapsServicesApiKeyForConsumer);
                if (message.encryptedGoogleAiServicesApiKeyForAdmin != null && Object.hasOwnProperty.call(message, "encryptedGoogleAiServicesApiKeyForAdmin"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.encryptedGoogleAiServicesApiKeyForAdmin);
                return writer;
            };

            /**
             * Encodes the specified GoogleApiKeysProto message, length delimited. Does not implicitly {@link waiternow.common.GoogleApiKeysProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.GoogleApiKeysProto
             * @static
             * @param {waiternow.common.IGoogleApiKeysProto} message GoogleApiKeysProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GoogleApiKeysProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GoogleApiKeysProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.GoogleApiKeysProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.GoogleApiKeysProto} GoogleApiKeysProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GoogleApiKeysProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GoogleApiKeysProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.encryptedGoogleMapsServicesApiKey = reader.string();
                            break;
                        }
                    case 2: {
                            message.encryptedGoogleMapsServicesApiKeyForConsumer = reader.string();
                            break;
                        }
                    case 3: {
                            message.encryptedGoogleAiServicesApiKeyForAdmin = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GoogleApiKeysProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.GoogleApiKeysProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.GoogleApiKeysProto} GoogleApiKeysProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GoogleApiKeysProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GoogleApiKeysProto message.
             * @function verify
             * @memberof waiternow.common.GoogleApiKeysProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GoogleApiKeysProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.encryptedGoogleMapsServicesApiKey != null && message.hasOwnProperty("encryptedGoogleMapsServicesApiKey"))
                    if (!$util.isString(message.encryptedGoogleMapsServicesApiKey))
                        return "encryptedGoogleMapsServicesApiKey: string expected";
                if (message.encryptedGoogleMapsServicesApiKeyForConsumer != null && message.hasOwnProperty("encryptedGoogleMapsServicesApiKeyForConsumer"))
                    if (!$util.isString(message.encryptedGoogleMapsServicesApiKeyForConsumer))
                        return "encryptedGoogleMapsServicesApiKeyForConsumer: string expected";
                if (message.encryptedGoogleAiServicesApiKeyForAdmin != null && message.hasOwnProperty("encryptedGoogleAiServicesApiKeyForAdmin"))
                    if (!$util.isString(message.encryptedGoogleAiServicesApiKeyForAdmin))
                        return "encryptedGoogleAiServicesApiKeyForAdmin: string expected";
                return null;
            };

            /**
             * Creates a GoogleApiKeysProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.GoogleApiKeysProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.GoogleApiKeysProto} GoogleApiKeysProto
             */
            GoogleApiKeysProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.GoogleApiKeysProto)
                    return object;
                var message = new $root.waiternow.common.GoogleApiKeysProto();
                if (object.encryptedGoogleMapsServicesApiKey != null)
                    message.encryptedGoogleMapsServicesApiKey = String(object.encryptedGoogleMapsServicesApiKey);
                if (object.encryptedGoogleMapsServicesApiKeyForConsumer != null)
                    message.encryptedGoogleMapsServicesApiKeyForConsumer = String(object.encryptedGoogleMapsServicesApiKeyForConsumer);
                if (object.encryptedGoogleAiServicesApiKeyForAdmin != null)
                    message.encryptedGoogleAiServicesApiKeyForAdmin = String(object.encryptedGoogleAiServicesApiKeyForAdmin);
                return message;
            };

            /**
             * Creates a plain object from a GoogleApiKeysProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.GoogleApiKeysProto
             * @static
             * @param {waiternow.common.GoogleApiKeysProto} message GoogleApiKeysProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GoogleApiKeysProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.encryptedGoogleMapsServicesApiKey = "";
                    object.encryptedGoogleMapsServicesApiKeyForConsumer = "";
                    object.encryptedGoogleAiServicesApiKeyForAdmin = "";
                }
                if (message.encryptedGoogleMapsServicesApiKey != null && message.hasOwnProperty("encryptedGoogleMapsServicesApiKey"))
                    object.encryptedGoogleMapsServicesApiKey = message.encryptedGoogleMapsServicesApiKey;
                if (message.encryptedGoogleMapsServicesApiKeyForConsumer != null && message.hasOwnProperty("encryptedGoogleMapsServicesApiKeyForConsumer"))
                    object.encryptedGoogleMapsServicesApiKeyForConsumer = message.encryptedGoogleMapsServicesApiKeyForConsumer;
                if (message.encryptedGoogleAiServicesApiKeyForAdmin != null && message.hasOwnProperty("encryptedGoogleAiServicesApiKeyForAdmin"))
                    object.encryptedGoogleAiServicesApiKeyForAdmin = message.encryptedGoogleAiServicesApiKeyForAdmin;
                return object;
            };

            /**
             * Converts this GoogleApiKeysProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.GoogleApiKeysProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GoogleApiKeysProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for GoogleApiKeysProto
             * @function getTypeUrl
             * @memberof waiternow.common.GoogleApiKeysProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            GoogleApiKeysProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.GoogleApiKeysProto";
            };

            return GoogleApiKeysProto;
        })();

        common.DoordashApiKeysProto = (function() {

            /**
             * Properties of a DoordashApiKeysProto.
             * @memberof waiternow.common
             * @interface IDoordashApiKeysProto
             * @property {string|null} [encryptedSigningSecret] DoordashApiKeysProto encryptedSigningSecret
             * @property {string|null} [encryptedDeveloperId] DoordashApiKeysProto encryptedDeveloperId
             * @property {string|null} [encryptedKeyId] DoordashApiKeysProto encryptedKeyId
             */

            /**
             * Constructs a new DoordashApiKeysProto.
             * @memberof waiternow.common
             * @classdesc Represents a DoordashApiKeysProto.
             * @implements IDoordashApiKeysProto
             * @constructor
             * @param {waiternow.common.IDoordashApiKeysProto=} [properties] Properties to set
             */
            function DoordashApiKeysProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * DoordashApiKeysProto encryptedSigningSecret.
             * @member {string} encryptedSigningSecret
             * @memberof waiternow.common.DoordashApiKeysProto
             * @instance
             */
            DoordashApiKeysProto.prototype.encryptedSigningSecret = "";

            /**
             * DoordashApiKeysProto encryptedDeveloperId.
             * @member {string} encryptedDeveloperId
             * @memberof waiternow.common.DoordashApiKeysProto
             * @instance
             */
            DoordashApiKeysProto.prototype.encryptedDeveloperId = "";

            /**
             * DoordashApiKeysProto encryptedKeyId.
             * @member {string} encryptedKeyId
             * @memberof waiternow.common.DoordashApiKeysProto
             * @instance
             */
            DoordashApiKeysProto.prototype.encryptedKeyId = "";

            /**
             * Creates a new DoordashApiKeysProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.DoordashApiKeysProto
             * @static
             * @param {waiternow.common.IDoordashApiKeysProto=} [properties] Properties to set
             * @returns {waiternow.common.DoordashApiKeysProto} DoordashApiKeysProto instance
             */
            DoordashApiKeysProto.create = function create(properties) {
                return new DoordashApiKeysProto(properties);
            };

            /**
             * Encodes the specified DoordashApiKeysProto message. Does not implicitly {@link waiternow.common.DoordashApiKeysProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.DoordashApiKeysProto
             * @static
             * @param {waiternow.common.IDoordashApiKeysProto} message DoordashApiKeysProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DoordashApiKeysProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.encryptedSigningSecret != null && Object.hasOwnProperty.call(message, "encryptedSigningSecret"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.encryptedSigningSecret);
                if (message.encryptedDeveloperId != null && Object.hasOwnProperty.call(message, "encryptedDeveloperId"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.encryptedDeveloperId);
                if (message.encryptedKeyId != null && Object.hasOwnProperty.call(message, "encryptedKeyId"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.encryptedKeyId);
                return writer;
            };

            /**
             * Encodes the specified DoordashApiKeysProto message, length delimited. Does not implicitly {@link waiternow.common.DoordashApiKeysProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.DoordashApiKeysProto
             * @static
             * @param {waiternow.common.IDoordashApiKeysProto} message DoordashApiKeysProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DoordashApiKeysProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a DoordashApiKeysProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.DoordashApiKeysProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.DoordashApiKeysProto} DoordashApiKeysProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DoordashApiKeysProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.DoordashApiKeysProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.encryptedSigningSecret = reader.string();
                            break;
                        }
                    case 2: {
                            message.encryptedDeveloperId = reader.string();
                            break;
                        }
                    case 3: {
                            message.encryptedKeyId = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a DoordashApiKeysProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.DoordashApiKeysProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.DoordashApiKeysProto} DoordashApiKeysProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DoordashApiKeysProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a DoordashApiKeysProto message.
             * @function verify
             * @memberof waiternow.common.DoordashApiKeysProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            DoordashApiKeysProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.encryptedSigningSecret != null && message.hasOwnProperty("encryptedSigningSecret"))
                    if (!$util.isString(message.encryptedSigningSecret))
                        return "encryptedSigningSecret: string expected";
                if (message.encryptedDeveloperId != null && message.hasOwnProperty("encryptedDeveloperId"))
                    if (!$util.isString(message.encryptedDeveloperId))
                        return "encryptedDeveloperId: string expected";
                if (message.encryptedKeyId != null && message.hasOwnProperty("encryptedKeyId"))
                    if (!$util.isString(message.encryptedKeyId))
                        return "encryptedKeyId: string expected";
                return null;
            };

            /**
             * Creates a DoordashApiKeysProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.DoordashApiKeysProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.DoordashApiKeysProto} DoordashApiKeysProto
             */
            DoordashApiKeysProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.DoordashApiKeysProto)
                    return object;
                var message = new $root.waiternow.common.DoordashApiKeysProto();
                if (object.encryptedSigningSecret != null)
                    message.encryptedSigningSecret = String(object.encryptedSigningSecret);
                if (object.encryptedDeveloperId != null)
                    message.encryptedDeveloperId = String(object.encryptedDeveloperId);
                if (object.encryptedKeyId != null)
                    message.encryptedKeyId = String(object.encryptedKeyId);
                return message;
            };

            /**
             * Creates a plain object from a DoordashApiKeysProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.DoordashApiKeysProto
             * @static
             * @param {waiternow.common.DoordashApiKeysProto} message DoordashApiKeysProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            DoordashApiKeysProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.encryptedSigningSecret = "";
                    object.encryptedDeveloperId = "";
                    object.encryptedKeyId = "";
                }
                if (message.encryptedSigningSecret != null && message.hasOwnProperty("encryptedSigningSecret"))
                    object.encryptedSigningSecret = message.encryptedSigningSecret;
                if (message.encryptedDeveloperId != null && message.hasOwnProperty("encryptedDeveloperId"))
                    object.encryptedDeveloperId = message.encryptedDeveloperId;
                if (message.encryptedKeyId != null && message.hasOwnProperty("encryptedKeyId"))
                    object.encryptedKeyId = message.encryptedKeyId;
                return object;
            };

            /**
             * Converts this DoordashApiKeysProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.DoordashApiKeysProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            DoordashApiKeysProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for DoordashApiKeysProto
             * @function getTypeUrl
             * @memberof waiternow.common.DoordashApiKeysProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            DoordashApiKeysProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.DoordashApiKeysProto";
            };

            return DoordashApiKeysProto;
        })();

        common.UsGeocoderApiKeysProto = (function() {

            /**
             * Properties of a UsGeocoderApiKeysProto.
             * @memberof waiternow.common
             * @interface IUsGeocoderApiKeysProto
             * @property {string|null} [encryptedAuthKey] UsGeocoderApiKeysProto encryptedAuthKey
             */

            /**
             * Constructs a new UsGeocoderApiKeysProto.
             * @memberof waiternow.common
             * @classdesc Represents a UsGeocoderApiKeysProto.
             * @implements IUsGeocoderApiKeysProto
             * @constructor
             * @param {waiternow.common.IUsGeocoderApiKeysProto=} [properties] Properties to set
             */
            function UsGeocoderApiKeysProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * UsGeocoderApiKeysProto encryptedAuthKey.
             * @member {string} encryptedAuthKey
             * @memberof waiternow.common.UsGeocoderApiKeysProto
             * @instance
             */
            UsGeocoderApiKeysProto.prototype.encryptedAuthKey = "";

            /**
             * Creates a new UsGeocoderApiKeysProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.UsGeocoderApiKeysProto
             * @static
             * @param {waiternow.common.IUsGeocoderApiKeysProto=} [properties] Properties to set
             * @returns {waiternow.common.UsGeocoderApiKeysProto} UsGeocoderApiKeysProto instance
             */
            UsGeocoderApiKeysProto.create = function create(properties) {
                return new UsGeocoderApiKeysProto(properties);
            };

            /**
             * Encodes the specified UsGeocoderApiKeysProto message. Does not implicitly {@link waiternow.common.UsGeocoderApiKeysProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.UsGeocoderApiKeysProto
             * @static
             * @param {waiternow.common.IUsGeocoderApiKeysProto} message UsGeocoderApiKeysProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UsGeocoderApiKeysProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.encryptedAuthKey != null && Object.hasOwnProperty.call(message, "encryptedAuthKey"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.encryptedAuthKey);
                return writer;
            };

            /**
             * Encodes the specified UsGeocoderApiKeysProto message, length delimited. Does not implicitly {@link waiternow.common.UsGeocoderApiKeysProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.UsGeocoderApiKeysProto
             * @static
             * @param {waiternow.common.IUsGeocoderApiKeysProto} message UsGeocoderApiKeysProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UsGeocoderApiKeysProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a UsGeocoderApiKeysProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.UsGeocoderApiKeysProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.UsGeocoderApiKeysProto} UsGeocoderApiKeysProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UsGeocoderApiKeysProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.UsGeocoderApiKeysProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.encryptedAuthKey = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a UsGeocoderApiKeysProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.UsGeocoderApiKeysProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.UsGeocoderApiKeysProto} UsGeocoderApiKeysProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UsGeocoderApiKeysProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a UsGeocoderApiKeysProto message.
             * @function verify
             * @memberof waiternow.common.UsGeocoderApiKeysProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            UsGeocoderApiKeysProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.encryptedAuthKey != null && message.hasOwnProperty("encryptedAuthKey"))
                    if (!$util.isString(message.encryptedAuthKey))
                        return "encryptedAuthKey: string expected";
                return null;
            };

            /**
             * Creates a UsGeocoderApiKeysProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.UsGeocoderApiKeysProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.UsGeocoderApiKeysProto} UsGeocoderApiKeysProto
             */
            UsGeocoderApiKeysProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.UsGeocoderApiKeysProto)
                    return object;
                var message = new $root.waiternow.common.UsGeocoderApiKeysProto();
                if (object.encryptedAuthKey != null)
                    message.encryptedAuthKey = String(object.encryptedAuthKey);
                return message;
            };

            /**
             * Creates a plain object from a UsGeocoderApiKeysProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.UsGeocoderApiKeysProto
             * @static
             * @param {waiternow.common.UsGeocoderApiKeysProto} message UsGeocoderApiKeysProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            UsGeocoderApiKeysProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.encryptedAuthKey = "";
                if (message.encryptedAuthKey != null && message.hasOwnProperty("encryptedAuthKey"))
                    object.encryptedAuthKey = message.encryptedAuthKey;
                return object;
            };

            /**
             * Converts this UsGeocoderApiKeysProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.UsGeocoderApiKeysProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            UsGeocoderApiKeysProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for UsGeocoderApiKeysProto
             * @function getTypeUrl
             * @memberof waiternow.common.UsGeocoderApiKeysProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            UsGeocoderApiKeysProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.UsGeocoderApiKeysProto";
            };

            return UsGeocoderApiKeysProto;
        })();

        common.UberApiKeysProto = (function() {

            /**
             * Properties of an UberApiKeysProto.
             * @memberof waiternow.common
             * @interface IUberApiKeysProto
             * @property {string|null} [encryptedCustomerId] UberApiKeysProto encryptedCustomerId
             * @property {string|null} [encryptedClientId] UberApiKeysProto encryptedClientId
             * @property {string|null} [encryptedClientSecret] UberApiKeysProto encryptedClientSecret
             */

            /**
             * Constructs a new UberApiKeysProto.
             * @memberof waiternow.common
             * @classdesc Represents an UberApiKeysProto.
             * @implements IUberApiKeysProto
             * @constructor
             * @param {waiternow.common.IUberApiKeysProto=} [properties] Properties to set
             */
            function UberApiKeysProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * UberApiKeysProto encryptedCustomerId.
             * @member {string} encryptedCustomerId
             * @memberof waiternow.common.UberApiKeysProto
             * @instance
             */
            UberApiKeysProto.prototype.encryptedCustomerId = "";

            /**
             * UberApiKeysProto encryptedClientId.
             * @member {string} encryptedClientId
             * @memberof waiternow.common.UberApiKeysProto
             * @instance
             */
            UberApiKeysProto.prototype.encryptedClientId = "";

            /**
             * UberApiKeysProto encryptedClientSecret.
             * @member {string} encryptedClientSecret
             * @memberof waiternow.common.UberApiKeysProto
             * @instance
             */
            UberApiKeysProto.prototype.encryptedClientSecret = "";

            /**
             * Creates a new UberApiKeysProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.UberApiKeysProto
             * @static
             * @param {waiternow.common.IUberApiKeysProto=} [properties] Properties to set
             * @returns {waiternow.common.UberApiKeysProto} UberApiKeysProto instance
             */
            UberApiKeysProto.create = function create(properties) {
                return new UberApiKeysProto(properties);
            };

            /**
             * Encodes the specified UberApiKeysProto message. Does not implicitly {@link waiternow.common.UberApiKeysProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.UberApiKeysProto
             * @static
             * @param {waiternow.common.IUberApiKeysProto} message UberApiKeysProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UberApiKeysProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.encryptedCustomerId != null && Object.hasOwnProperty.call(message, "encryptedCustomerId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.encryptedCustomerId);
                if (message.encryptedClientId != null && Object.hasOwnProperty.call(message, "encryptedClientId"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.encryptedClientId);
                if (message.encryptedClientSecret != null && Object.hasOwnProperty.call(message, "encryptedClientSecret"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.encryptedClientSecret);
                return writer;
            };

            /**
             * Encodes the specified UberApiKeysProto message, length delimited. Does not implicitly {@link waiternow.common.UberApiKeysProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.UberApiKeysProto
             * @static
             * @param {waiternow.common.IUberApiKeysProto} message UberApiKeysProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UberApiKeysProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an UberApiKeysProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.UberApiKeysProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.UberApiKeysProto} UberApiKeysProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UberApiKeysProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.UberApiKeysProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.encryptedCustomerId = reader.string();
                            break;
                        }
                    case 2: {
                            message.encryptedClientId = reader.string();
                            break;
                        }
                    case 3: {
                            message.encryptedClientSecret = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an UberApiKeysProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.UberApiKeysProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.UberApiKeysProto} UberApiKeysProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UberApiKeysProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an UberApiKeysProto message.
             * @function verify
             * @memberof waiternow.common.UberApiKeysProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            UberApiKeysProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.encryptedCustomerId != null && message.hasOwnProperty("encryptedCustomerId"))
                    if (!$util.isString(message.encryptedCustomerId))
                        return "encryptedCustomerId: string expected";
                if (message.encryptedClientId != null && message.hasOwnProperty("encryptedClientId"))
                    if (!$util.isString(message.encryptedClientId))
                        return "encryptedClientId: string expected";
                if (message.encryptedClientSecret != null && message.hasOwnProperty("encryptedClientSecret"))
                    if (!$util.isString(message.encryptedClientSecret))
                        return "encryptedClientSecret: string expected";
                return null;
            };

            /**
             * Creates an UberApiKeysProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.UberApiKeysProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.UberApiKeysProto} UberApiKeysProto
             */
            UberApiKeysProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.UberApiKeysProto)
                    return object;
                var message = new $root.waiternow.common.UberApiKeysProto();
                if (object.encryptedCustomerId != null)
                    message.encryptedCustomerId = String(object.encryptedCustomerId);
                if (object.encryptedClientId != null)
                    message.encryptedClientId = String(object.encryptedClientId);
                if (object.encryptedClientSecret != null)
                    message.encryptedClientSecret = String(object.encryptedClientSecret);
                return message;
            };

            /**
             * Creates a plain object from an UberApiKeysProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.UberApiKeysProto
             * @static
             * @param {waiternow.common.UberApiKeysProto} message UberApiKeysProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            UberApiKeysProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.encryptedCustomerId = "";
                    object.encryptedClientId = "";
                    object.encryptedClientSecret = "";
                }
                if (message.encryptedCustomerId != null && message.hasOwnProperty("encryptedCustomerId"))
                    object.encryptedCustomerId = message.encryptedCustomerId;
                if (message.encryptedClientId != null && message.hasOwnProperty("encryptedClientId"))
                    object.encryptedClientId = message.encryptedClientId;
                if (message.encryptedClientSecret != null && message.hasOwnProperty("encryptedClientSecret"))
                    object.encryptedClientSecret = message.encryptedClientSecret;
                return object;
            };

            /**
             * Converts this UberApiKeysProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.UberApiKeysProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            UberApiKeysProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for UberApiKeysProto
             * @function getTypeUrl
             * @memberof waiternow.common.UberApiKeysProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            UberApiKeysProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.UberApiKeysProto";
            };

            return UberApiKeysProto;
        })();

        common.SimplePhoneNumberProto = (function() {

            /**
             * Properties of a SimplePhoneNumberProto.
             * @memberof waiternow.common
             * @interface ISimplePhoneNumberProto
             * @property {string|null} [phoneNumber] SimplePhoneNumberProto phoneNumber
             */

            /**
             * Constructs a new SimplePhoneNumberProto.
             * @memberof waiternow.common
             * @classdesc Represents a SimplePhoneNumberProto.
             * @implements ISimplePhoneNumberProto
             * @constructor
             * @param {waiternow.common.ISimplePhoneNumberProto=} [properties] Properties to set
             */
            function SimplePhoneNumberProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * SimplePhoneNumberProto phoneNumber.
             * @member {string} phoneNumber
             * @memberof waiternow.common.SimplePhoneNumberProto
             * @instance
             */
            SimplePhoneNumberProto.prototype.phoneNumber = "";

            /**
             * Creates a new SimplePhoneNumberProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.SimplePhoneNumberProto
             * @static
             * @param {waiternow.common.ISimplePhoneNumberProto=} [properties] Properties to set
             * @returns {waiternow.common.SimplePhoneNumberProto} SimplePhoneNumberProto instance
             */
            SimplePhoneNumberProto.create = function create(properties) {
                return new SimplePhoneNumberProto(properties);
            };

            /**
             * Encodes the specified SimplePhoneNumberProto message. Does not implicitly {@link waiternow.common.SimplePhoneNumberProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.SimplePhoneNumberProto
             * @static
             * @param {waiternow.common.ISimplePhoneNumberProto} message SimplePhoneNumberProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SimplePhoneNumberProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.phoneNumber != null && Object.hasOwnProperty.call(message, "phoneNumber"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.phoneNumber);
                return writer;
            };

            /**
             * Encodes the specified SimplePhoneNumberProto message, length delimited. Does not implicitly {@link waiternow.common.SimplePhoneNumberProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.SimplePhoneNumberProto
             * @static
             * @param {waiternow.common.ISimplePhoneNumberProto} message SimplePhoneNumberProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SimplePhoneNumberProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SimplePhoneNumberProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.SimplePhoneNumberProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.SimplePhoneNumberProto} SimplePhoneNumberProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SimplePhoneNumberProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.SimplePhoneNumberProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.phoneNumber = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SimplePhoneNumberProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.SimplePhoneNumberProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.SimplePhoneNumberProto} SimplePhoneNumberProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SimplePhoneNumberProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SimplePhoneNumberProto message.
             * @function verify
             * @memberof waiternow.common.SimplePhoneNumberProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SimplePhoneNumberProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
                    if (!$util.isString(message.phoneNumber))
                        return "phoneNumber: string expected";
                return null;
            };

            /**
             * Creates a SimplePhoneNumberProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.SimplePhoneNumberProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.SimplePhoneNumberProto} SimplePhoneNumberProto
             */
            SimplePhoneNumberProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.SimplePhoneNumberProto)
                    return object;
                var message = new $root.waiternow.common.SimplePhoneNumberProto();
                if (object.phoneNumber != null)
                    message.phoneNumber = String(object.phoneNumber);
                return message;
            };

            /**
             * Creates a plain object from a SimplePhoneNumberProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.SimplePhoneNumberProto
             * @static
             * @param {waiternow.common.SimplePhoneNumberProto} message SimplePhoneNumberProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SimplePhoneNumberProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.phoneNumber = "";
                if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
                    object.phoneNumber = message.phoneNumber;
                return object;
            };

            /**
             * Converts this SimplePhoneNumberProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.SimplePhoneNumberProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SimplePhoneNumberProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for SimplePhoneNumberProto
             * @function getTypeUrl
             * @memberof waiternow.common.SimplePhoneNumberProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            SimplePhoneNumberProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.SimplePhoneNumberProto";
            };

            return SimplePhoneNumberProto;
        })();

        common.StructuredPhoneNumberProto = (function() {

            /**
             * Properties of a StructuredPhoneNumberProto.
             * @memberof waiternow.common
             * @interface IStructuredPhoneNumberProto
             * @property {number|null} [countryCode] StructuredPhoneNumberProto countryCode
             * @property {number|null} [number] StructuredPhoneNumberProto number
             */

            /**
             * Constructs a new StructuredPhoneNumberProto.
             * @memberof waiternow.common
             * @classdesc Represents a StructuredPhoneNumberProto.
             * @implements IStructuredPhoneNumberProto
             * @constructor
             * @param {waiternow.common.IStructuredPhoneNumberProto=} [properties] Properties to set
             */
            function StructuredPhoneNumberProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * StructuredPhoneNumberProto countryCode.
             * @member {number} countryCode
             * @memberof waiternow.common.StructuredPhoneNumberProto
             * @instance
             */
            StructuredPhoneNumberProto.prototype.countryCode = 0;

            /**
             * StructuredPhoneNumberProto number.
             * @member {number} number
             * @memberof waiternow.common.StructuredPhoneNumberProto
             * @instance
             */
            StructuredPhoneNumberProto.prototype.number = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new StructuredPhoneNumberProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.StructuredPhoneNumberProto
             * @static
             * @param {waiternow.common.IStructuredPhoneNumberProto=} [properties] Properties to set
             * @returns {waiternow.common.StructuredPhoneNumberProto} StructuredPhoneNumberProto instance
             */
            StructuredPhoneNumberProto.create = function create(properties) {
                return new StructuredPhoneNumberProto(properties);
            };

            /**
             * Encodes the specified StructuredPhoneNumberProto message. Does not implicitly {@link waiternow.common.StructuredPhoneNumberProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.StructuredPhoneNumberProto
             * @static
             * @param {waiternow.common.IStructuredPhoneNumberProto} message StructuredPhoneNumberProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StructuredPhoneNumberProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.countryCode != null && Object.hasOwnProperty.call(message, "countryCode"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.countryCode);
                if (message.number != null && Object.hasOwnProperty.call(message, "number"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int64(message.number);
                return writer;
            };

            /**
             * Encodes the specified StructuredPhoneNumberProto message, length delimited. Does not implicitly {@link waiternow.common.StructuredPhoneNumberProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.StructuredPhoneNumberProto
             * @static
             * @param {waiternow.common.IStructuredPhoneNumberProto} message StructuredPhoneNumberProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StructuredPhoneNumberProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a StructuredPhoneNumberProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.StructuredPhoneNumberProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.StructuredPhoneNumberProto} StructuredPhoneNumberProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StructuredPhoneNumberProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.StructuredPhoneNumberProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.countryCode = reader.int32();
                            break;
                        }
                    case 2: {
                            message.number = reader.int64();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a StructuredPhoneNumberProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.StructuredPhoneNumberProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.StructuredPhoneNumberProto} StructuredPhoneNumberProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StructuredPhoneNumberProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a StructuredPhoneNumberProto message.
             * @function verify
             * @memberof waiternow.common.StructuredPhoneNumberProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            StructuredPhoneNumberProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.countryCode != null && message.hasOwnProperty("countryCode"))
                    if (!$util.isInteger(message.countryCode))
                        return "countryCode: integer expected";
                if (message.number != null && message.hasOwnProperty("number"))
                    if (!$util.isInteger(message.number) && !(message.number && $util.isInteger(message.number.low) && $util.isInteger(message.number.high)))
                        return "number: integer|Long expected";
                return null;
            };

            /**
             * Creates a StructuredPhoneNumberProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.StructuredPhoneNumberProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.StructuredPhoneNumberProto} StructuredPhoneNumberProto
             */
            StructuredPhoneNumberProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.StructuredPhoneNumberProto)
                    return object;
                var message = new $root.waiternow.common.StructuredPhoneNumberProto();
                if (object.countryCode != null)
                    message.countryCode = object.countryCode | 0;
                if (object.number != null)
                    if ($util.Long)
                        (message.number = $util.Long.fromValue(object.number)).unsigned = false;
                    else if (typeof object.number === "string")
                        message.number = parseInt(object.number, 10);
                    else if (typeof object.number === "number")
                        message.number = object.number;
                    else if (typeof object.number === "object")
                        message.number = new $util.LongBits(object.number.low >>> 0, object.number.high >>> 0).toNumber();
                return message;
            };

            /**
             * Creates a plain object from a StructuredPhoneNumberProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.StructuredPhoneNumberProto
             * @static
             * @param {waiternow.common.StructuredPhoneNumberProto} message StructuredPhoneNumberProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            StructuredPhoneNumberProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.countryCode = 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.number = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.number = options.longs === String ? "0" : 0;
                }
                if (message.countryCode != null && message.hasOwnProperty("countryCode"))
                    object.countryCode = message.countryCode;
                if (message.number != null && message.hasOwnProperty("number"))
                    if (typeof message.number === "number")
                        object.number = options.longs === String ? String(message.number) : message.number;
                    else
                        object.number = options.longs === String ? $util.Long.prototype.toString.call(message.number) : options.longs === Number ? new $util.LongBits(message.number.low >>> 0, message.number.high >>> 0).toNumber() : message.number;
                return object;
            };

            /**
             * Converts this StructuredPhoneNumberProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.StructuredPhoneNumberProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            StructuredPhoneNumberProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for StructuredPhoneNumberProto
             * @function getTypeUrl
             * @memberof waiternow.common.StructuredPhoneNumberProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            StructuredPhoneNumberProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.StructuredPhoneNumberProto";
            };

            return StructuredPhoneNumberProto;
        })();

        common.PhoneNumberProto = (function() {

            /**
             * Properties of a PhoneNumberProto.
             * @memberof waiternow.common
             * @interface IPhoneNumberProto
             * @property {waiternow.common.ISimplePhoneNumberProto|null} [simplePhoneNumber] PhoneNumberProto simplePhoneNumber
             * @property {waiternow.common.IStructuredPhoneNumberProto|null} [structuredPhoneNumber] PhoneNumberProto structuredPhoneNumber
             * @property {waiternow.common.PhoneNumberProto.PhoneType|null} [phoneType] PhoneNumberProto phoneType
             */

            /**
             * Constructs a new PhoneNumberProto.
             * @memberof waiternow.common
             * @classdesc Represents a PhoneNumberProto.
             * @implements IPhoneNumberProto
             * @constructor
             * @param {waiternow.common.IPhoneNumberProto=} [properties] Properties to set
             */
            function PhoneNumberProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * PhoneNumberProto simplePhoneNumber.
             * @member {waiternow.common.ISimplePhoneNumberProto|null|undefined} simplePhoneNumber
             * @memberof waiternow.common.PhoneNumberProto
             * @instance
             */
            PhoneNumberProto.prototype.simplePhoneNumber = null;

            /**
             * PhoneNumberProto structuredPhoneNumber.
             * @member {waiternow.common.IStructuredPhoneNumberProto|null|undefined} structuredPhoneNumber
             * @memberof waiternow.common.PhoneNumberProto
             * @instance
             */
            PhoneNumberProto.prototype.structuredPhoneNumber = null;

            /**
             * PhoneNumberProto phoneType.
             * @member {waiternow.common.PhoneNumberProto.PhoneType} phoneType
             * @memberof waiternow.common.PhoneNumberProto
             * @instance
             */
            PhoneNumberProto.prototype.phoneType = 0;

            // OneOf field names bound to virtual getters and setters
            var $oneOfFields;

            /**
             * PhoneNumberProto phoneNumber.
             * @member {"simplePhoneNumber"|"structuredPhoneNumber"|undefined} phoneNumber
             * @memberof waiternow.common.PhoneNumberProto
             * @instance
             */
            Object.defineProperty(PhoneNumberProto.prototype, "phoneNumber", {
                get: $util.oneOfGetter($oneOfFields = ["simplePhoneNumber", "structuredPhoneNumber"]),
                set: $util.oneOfSetter($oneOfFields)
            });

            /**
             * Creates a new PhoneNumberProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.PhoneNumberProto
             * @static
             * @param {waiternow.common.IPhoneNumberProto=} [properties] Properties to set
             * @returns {waiternow.common.PhoneNumberProto} PhoneNumberProto instance
             */
            PhoneNumberProto.create = function create(properties) {
                return new PhoneNumberProto(properties);
            };

            /**
             * Encodes the specified PhoneNumberProto message. Does not implicitly {@link waiternow.common.PhoneNumberProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.PhoneNumberProto
             * @static
             * @param {waiternow.common.IPhoneNumberProto} message PhoneNumberProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PhoneNumberProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.simplePhoneNumber != null && Object.hasOwnProperty.call(message, "simplePhoneNumber"))
                    $root.waiternow.common.SimplePhoneNumberProto.encode(message.simplePhoneNumber, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.structuredPhoneNumber != null && Object.hasOwnProperty.call(message, "structuredPhoneNumber"))
                    $root.waiternow.common.StructuredPhoneNumberProto.encode(message.structuredPhoneNumber, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.phoneType != null && Object.hasOwnProperty.call(message, "phoneType"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.phoneType);
                return writer;
            };

            /**
             * Encodes the specified PhoneNumberProto message, length delimited. Does not implicitly {@link waiternow.common.PhoneNumberProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.PhoneNumberProto
             * @static
             * @param {waiternow.common.IPhoneNumberProto} message PhoneNumberProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PhoneNumberProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a PhoneNumberProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.PhoneNumberProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.PhoneNumberProto} PhoneNumberProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PhoneNumberProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PhoneNumberProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.simplePhoneNumber = $root.waiternow.common.SimplePhoneNumberProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 2: {
                            message.structuredPhoneNumber = $root.waiternow.common.StructuredPhoneNumberProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 3: {
                            message.phoneType = reader.int32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a PhoneNumberProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.PhoneNumberProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.PhoneNumberProto} PhoneNumberProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PhoneNumberProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a PhoneNumberProto message.
             * @function verify
             * @memberof waiternow.common.PhoneNumberProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            PhoneNumberProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                var properties = {};
                if (message.simplePhoneNumber != null && message.hasOwnProperty("simplePhoneNumber")) {
                    properties.phoneNumber = 1;
                    {
                        var error = $root.waiternow.common.SimplePhoneNumberProto.verify(message.simplePhoneNumber);
                        if (error)
                            return "simplePhoneNumber." + error;
                    }
                }
                if (message.structuredPhoneNumber != null && message.hasOwnProperty("structuredPhoneNumber")) {
                    if (properties.phoneNumber === 1)
                        return "phoneNumber: multiple values";
                    properties.phoneNumber = 1;
                    {
                        var error = $root.waiternow.common.StructuredPhoneNumberProto.verify(message.structuredPhoneNumber);
                        if (error)
                            return "structuredPhoneNumber." + error;
                    }
                }
                if (message.phoneType != null && message.hasOwnProperty("phoneType"))
                    switch (message.phoneType) {
                    default:
                        return "phoneType: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                        break;
                    }
                return null;
            };

            /**
             * Creates a PhoneNumberProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.PhoneNumberProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.PhoneNumberProto} PhoneNumberProto
             */
            PhoneNumberProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.PhoneNumberProto)
                    return object;
                var message = new $root.waiternow.common.PhoneNumberProto();
                if (object.simplePhoneNumber != null) {
                    if (typeof object.simplePhoneNumber !== "object")
                        throw TypeError(".waiternow.common.PhoneNumberProto.simplePhoneNumber: object expected");
                    message.simplePhoneNumber = $root.waiternow.common.SimplePhoneNumberProto.fromObject(object.simplePhoneNumber);
                }
                if (object.structuredPhoneNumber != null) {
                    if (typeof object.structuredPhoneNumber !== "object")
                        throw TypeError(".waiternow.common.PhoneNumberProto.structuredPhoneNumber: object expected");
                    message.structuredPhoneNumber = $root.waiternow.common.StructuredPhoneNumberProto.fromObject(object.structuredPhoneNumber);
                }
                switch (object.phoneType) {
                default:
                    if (typeof object.phoneType === "number") {
                        message.phoneType = object.phoneType;
                        break;
                    }
                    break;
                case "PHONE_TYPE_UNSPECIFIED":
                case 0:
                    message.phoneType = 0;
                    break;
                case "MOBILE":
                case 1:
                    message.phoneType = 1;
                    break;
                case "HOME":
                case 2:
                    message.phoneType = 2;
                    break;
                case "WORK":
                case 3:
                    message.phoneType = 3;
                    break;
                }
                return message;
            };

            /**
             * Creates a plain object from a PhoneNumberProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.PhoneNumberProto
             * @static
             * @param {waiternow.common.PhoneNumberProto} message PhoneNumberProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            PhoneNumberProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.phoneType = options.enums === String ? "PHONE_TYPE_UNSPECIFIED" : 0;
                if (message.simplePhoneNumber != null && message.hasOwnProperty("simplePhoneNumber")) {
                    object.simplePhoneNumber = $root.waiternow.common.SimplePhoneNumberProto.toObject(message.simplePhoneNumber, options);
                    if (options.oneofs)
                        object.phoneNumber = "simplePhoneNumber";
                }
                if (message.structuredPhoneNumber != null && message.hasOwnProperty("structuredPhoneNumber")) {
                    object.structuredPhoneNumber = $root.waiternow.common.StructuredPhoneNumberProto.toObject(message.structuredPhoneNumber, options);
                    if (options.oneofs)
                        object.phoneNumber = "structuredPhoneNumber";
                }
                if (message.phoneType != null && message.hasOwnProperty("phoneType"))
                    object.phoneType = options.enums === String ? $root.waiternow.common.PhoneNumberProto.PhoneType[message.phoneType] === undefined ? message.phoneType : $root.waiternow.common.PhoneNumberProto.PhoneType[message.phoneType] : message.phoneType;
                return object;
            };

            /**
             * Converts this PhoneNumberProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.PhoneNumberProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            PhoneNumberProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for PhoneNumberProto
             * @function getTypeUrl
             * @memberof waiternow.common.PhoneNumberProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            PhoneNumberProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.PhoneNumberProto";
            };

            /**
             * PhoneType enum.
             * @name waiternow.common.PhoneNumberProto.PhoneType
             * @enum {number}
             * @property {number} PHONE_TYPE_UNSPECIFIED=0 PHONE_TYPE_UNSPECIFIED value
             * @property {number} MOBILE=1 MOBILE value
             * @property {number} HOME=2 HOME value
             * @property {number} WORK=3 WORK value
             */
            PhoneNumberProto.PhoneType = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "PHONE_TYPE_UNSPECIFIED"] = 0;
                values[valuesById[1] = "MOBILE"] = 1;
                values[valuesById[2] = "HOME"] = 2;
                values[valuesById[3] = "WORK"] = 3;
                return values;
            })();

            return PhoneNumberProto;
        })();

        /**
         * Country enum.
         * @name waiternow.common.Country
         * @enum {number}
         * @property {number} COUNTRY_UNSPECIFIED=0 COUNTRY_UNSPECIFIED value
         * @property {number} UNITED_STATES=1 UNITED_STATES value
         * @property {number} MEXICO=2 MEXICO value
         */
        common.Country = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "COUNTRY_UNSPECIFIED"] = 0;
            values[valuesById[1] = "UNITED_STATES"] = 1;
            values[valuesById[2] = "MEXICO"] = 2;
            return values;
        })();

        common.SimpleAddressProto = (function() {

            /**
             * Properties of a SimpleAddressProto.
             * @memberof waiternow.common
             * @interface ISimpleAddressProto
             * @property {string|null} [address] SimpleAddressProto address
             */

            /**
             * Constructs a new SimpleAddressProto.
             * @memberof waiternow.common
             * @classdesc Represents a SimpleAddressProto.
             * @implements ISimpleAddressProto
             * @constructor
             * @param {waiternow.common.ISimpleAddressProto=} [properties] Properties to set
             */
            function SimpleAddressProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * SimpleAddressProto address.
             * @member {string} address
             * @memberof waiternow.common.SimpleAddressProto
             * @instance
             */
            SimpleAddressProto.prototype.address = "";

            /**
             * Creates a new SimpleAddressProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.SimpleAddressProto
             * @static
             * @param {waiternow.common.ISimpleAddressProto=} [properties] Properties to set
             * @returns {waiternow.common.SimpleAddressProto} SimpleAddressProto instance
             */
            SimpleAddressProto.create = function create(properties) {
                return new SimpleAddressProto(properties);
            };

            /**
             * Encodes the specified SimpleAddressProto message. Does not implicitly {@link waiternow.common.SimpleAddressProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.SimpleAddressProto
             * @static
             * @param {waiternow.common.ISimpleAddressProto} message SimpleAddressProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SimpleAddressProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.address != null && Object.hasOwnProperty.call(message, "address"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.address);
                return writer;
            };

            /**
             * Encodes the specified SimpleAddressProto message, length delimited. Does not implicitly {@link waiternow.common.SimpleAddressProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.SimpleAddressProto
             * @static
             * @param {waiternow.common.ISimpleAddressProto} message SimpleAddressProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SimpleAddressProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SimpleAddressProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.SimpleAddressProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.SimpleAddressProto} SimpleAddressProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SimpleAddressProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.SimpleAddressProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.address = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SimpleAddressProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.SimpleAddressProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.SimpleAddressProto} SimpleAddressProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SimpleAddressProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SimpleAddressProto message.
             * @function verify
             * @memberof waiternow.common.SimpleAddressProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SimpleAddressProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.address != null && message.hasOwnProperty("address"))
                    if (!$util.isString(message.address))
                        return "address: string expected";
                return null;
            };

            /**
             * Creates a SimpleAddressProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.SimpleAddressProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.SimpleAddressProto} SimpleAddressProto
             */
            SimpleAddressProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.SimpleAddressProto)
                    return object;
                var message = new $root.waiternow.common.SimpleAddressProto();
                if (object.address != null)
                    message.address = String(object.address);
                return message;
            };

            /**
             * Creates a plain object from a SimpleAddressProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.SimpleAddressProto
             * @static
             * @param {waiternow.common.SimpleAddressProto} message SimpleAddressProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SimpleAddressProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.address = "";
                if (message.address != null && message.hasOwnProperty("address"))
                    object.address = message.address;
                return object;
            };

            /**
             * Converts this SimpleAddressProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.SimpleAddressProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SimpleAddressProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for SimpleAddressProto
             * @function getTypeUrl
             * @memberof waiternow.common.SimpleAddressProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            SimpleAddressProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.SimpleAddressProto";
            };

            return SimpleAddressProto;
        })();

        common.StructuredAddressProto = (function() {

            /**
             * Properties of a StructuredAddressProto.
             * @memberof waiternow.common
             * @interface IStructuredAddressProto
             * @property {string|null} [street] StructuredAddressProto street
             * @property {string|null} [city] StructuredAddressProto city
             * @property {string|null} [state] StructuredAddressProto state
             * @property {string|null} [postalCode] StructuredAddressProto postalCode
             * @property {waiternow.common.Country|null} [country] StructuredAddressProto country
             * @property {string|null} [otherCountry] StructuredAddressProto otherCountry
             */

            /**
             * Constructs a new StructuredAddressProto.
             * @memberof waiternow.common
             * @classdesc Represents a StructuredAddressProto.
             * @implements IStructuredAddressProto
             * @constructor
             * @param {waiternow.common.IStructuredAddressProto=} [properties] Properties to set
             */
            function StructuredAddressProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * StructuredAddressProto street.
             * @member {string} street
             * @memberof waiternow.common.StructuredAddressProto
             * @instance
             */
            StructuredAddressProto.prototype.street = "";

            /**
             * StructuredAddressProto city.
             * @member {string} city
             * @memberof waiternow.common.StructuredAddressProto
             * @instance
             */
            StructuredAddressProto.prototype.city = "";

            /**
             * StructuredAddressProto state.
             * @member {string} state
             * @memberof waiternow.common.StructuredAddressProto
             * @instance
             */
            StructuredAddressProto.prototype.state = "";

            /**
             * StructuredAddressProto postalCode.
             * @member {string} postalCode
             * @memberof waiternow.common.StructuredAddressProto
             * @instance
             */
            StructuredAddressProto.prototype.postalCode = "";

            /**
             * StructuredAddressProto country.
             * @member {waiternow.common.Country} country
             * @memberof waiternow.common.StructuredAddressProto
             * @instance
             */
            StructuredAddressProto.prototype.country = 0;

            /**
             * StructuredAddressProto otherCountry.
             * @member {string} otherCountry
             * @memberof waiternow.common.StructuredAddressProto
             * @instance
             */
            StructuredAddressProto.prototype.otherCountry = "";

            /**
             * Creates a new StructuredAddressProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.StructuredAddressProto
             * @static
             * @param {waiternow.common.IStructuredAddressProto=} [properties] Properties to set
             * @returns {waiternow.common.StructuredAddressProto} StructuredAddressProto instance
             */
            StructuredAddressProto.create = function create(properties) {
                return new StructuredAddressProto(properties);
            };

            /**
             * Encodes the specified StructuredAddressProto message. Does not implicitly {@link waiternow.common.StructuredAddressProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.StructuredAddressProto
             * @static
             * @param {waiternow.common.IStructuredAddressProto} message StructuredAddressProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StructuredAddressProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.street != null && Object.hasOwnProperty.call(message, "street"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.street);
                if (message.city != null && Object.hasOwnProperty.call(message, "city"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.city);
                if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.state);
                if (message.postalCode != null && Object.hasOwnProperty.call(message, "postalCode"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.postalCode);
                if (message.otherCountry != null && Object.hasOwnProperty.call(message, "otherCountry"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.otherCountry);
                if (message.country != null && Object.hasOwnProperty.call(message, "country"))
                    writer.uint32(/* id 6, wireType 0 =*/48).int32(message.country);
                return writer;
            };

            /**
             * Encodes the specified StructuredAddressProto message, length delimited. Does not implicitly {@link waiternow.common.StructuredAddressProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.StructuredAddressProto
             * @static
             * @param {waiternow.common.IStructuredAddressProto} message StructuredAddressProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StructuredAddressProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a StructuredAddressProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.StructuredAddressProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.StructuredAddressProto} StructuredAddressProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StructuredAddressProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.StructuredAddressProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.street = reader.string();
                            break;
                        }
                    case 2: {
                            message.city = reader.string();
                            break;
                        }
                    case 3: {
                            message.state = reader.string();
                            break;
                        }
                    case 4: {
                            message.postalCode = reader.string();
                            break;
                        }
                    case 6: {
                            message.country = reader.int32();
                            break;
                        }
                    case 5: {
                            message.otherCountry = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a StructuredAddressProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.StructuredAddressProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.StructuredAddressProto} StructuredAddressProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StructuredAddressProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a StructuredAddressProto message.
             * @function verify
             * @memberof waiternow.common.StructuredAddressProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            StructuredAddressProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.street != null && message.hasOwnProperty("street"))
                    if (!$util.isString(message.street))
                        return "street: string expected";
                if (message.city != null && message.hasOwnProperty("city"))
                    if (!$util.isString(message.city))
                        return "city: string expected";
                if (message.state != null && message.hasOwnProperty("state"))
                    if (!$util.isString(message.state))
                        return "state: string expected";
                if (message.postalCode != null && message.hasOwnProperty("postalCode"))
                    if (!$util.isString(message.postalCode))
                        return "postalCode: string expected";
                if (message.country != null && message.hasOwnProperty("country"))
                    switch (message.country) {
                    default:
                        return "country: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                        break;
                    }
                if (message.otherCountry != null && message.hasOwnProperty("otherCountry"))
                    if (!$util.isString(message.otherCountry))
                        return "otherCountry: string expected";
                return null;
            };

            /**
             * Creates a StructuredAddressProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.StructuredAddressProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.StructuredAddressProto} StructuredAddressProto
             */
            StructuredAddressProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.StructuredAddressProto)
                    return object;
                var message = new $root.waiternow.common.StructuredAddressProto();
                if (object.street != null)
                    message.street = String(object.street);
                if (object.city != null)
                    message.city = String(object.city);
                if (object.state != null)
                    message.state = String(object.state);
                if (object.postalCode != null)
                    message.postalCode = String(object.postalCode);
                switch (object.country) {
                default:
                    if (typeof object.country === "number") {
                        message.country = object.country;
                        break;
                    }
                    break;
                case "COUNTRY_UNSPECIFIED":
                case 0:
                    message.country = 0;
                    break;
                case "UNITED_STATES":
                case 1:
                    message.country = 1;
                    break;
                case "MEXICO":
                case 2:
                    message.country = 2;
                    break;
                }
                if (object.otherCountry != null)
                    message.otherCountry = String(object.otherCountry);
                return message;
            };

            /**
             * Creates a plain object from a StructuredAddressProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.StructuredAddressProto
             * @static
             * @param {waiternow.common.StructuredAddressProto} message StructuredAddressProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            StructuredAddressProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.street = "";
                    object.city = "";
                    object.state = "";
                    object.postalCode = "";
                    object.otherCountry = "";
                    object.country = options.enums === String ? "COUNTRY_UNSPECIFIED" : 0;
                }
                if (message.street != null && message.hasOwnProperty("street"))
                    object.street = message.street;
                if (message.city != null && message.hasOwnProperty("city"))
                    object.city = message.city;
                if (message.state != null && message.hasOwnProperty("state"))
                    object.state = message.state;
                if (message.postalCode != null && message.hasOwnProperty("postalCode"))
                    object.postalCode = message.postalCode;
                if (message.otherCountry != null && message.hasOwnProperty("otherCountry"))
                    object.otherCountry = message.otherCountry;
                if (message.country != null && message.hasOwnProperty("country"))
                    object.country = options.enums === String ? $root.waiternow.common.Country[message.country] === undefined ? message.country : $root.waiternow.common.Country[message.country] : message.country;
                return object;
            };

            /**
             * Converts this StructuredAddressProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.StructuredAddressProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            StructuredAddressProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for StructuredAddressProto
             * @function getTypeUrl
             * @memberof waiternow.common.StructuredAddressProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            StructuredAddressProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.StructuredAddressProto";
            };

            return StructuredAddressProto;
        })();

        common.GeocodeProto = (function() {

            /**
             * Properties of a GeocodeProto.
             * @memberof waiternow.common
             * @interface IGeocodeProto
             * @property {waiternow.common.GeocodeProto.ILocationProto|null} [location] GeocodeProto location
             * @property {string|null} [timeZone] GeocodeProto timeZone
             * @property {string|null} [formattedAddress] GeocodeProto formattedAddress
             * @property {waiternow.common.GeocodeProto.IAddressComponentsProto|null} [addressComponents] GeocodeProto addressComponents
             */

            /**
             * Constructs a new GeocodeProto.
             * @memberof waiternow.common
             * @classdesc Represents a GeocodeProto.
             * @implements IGeocodeProto
             * @constructor
             * @param {waiternow.common.IGeocodeProto=} [properties] Properties to set
             */
            function GeocodeProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GeocodeProto location.
             * @member {waiternow.common.GeocodeProto.ILocationProto|null|undefined} location
             * @memberof waiternow.common.GeocodeProto
             * @instance
             */
            GeocodeProto.prototype.location = null;

            /**
             * GeocodeProto timeZone.
             * @member {string} timeZone
             * @memberof waiternow.common.GeocodeProto
             * @instance
             */
            GeocodeProto.prototype.timeZone = "";

            /**
             * GeocodeProto formattedAddress.
             * @member {string} formattedAddress
             * @memberof waiternow.common.GeocodeProto
             * @instance
             */
            GeocodeProto.prototype.formattedAddress = "";

            /**
             * GeocodeProto addressComponents.
             * @member {waiternow.common.GeocodeProto.IAddressComponentsProto|null|undefined} addressComponents
             * @memberof waiternow.common.GeocodeProto
             * @instance
             */
            GeocodeProto.prototype.addressComponents = null;

            /**
             * Creates a new GeocodeProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.GeocodeProto
             * @static
             * @param {waiternow.common.IGeocodeProto=} [properties] Properties to set
             * @returns {waiternow.common.GeocodeProto} GeocodeProto instance
             */
            GeocodeProto.create = function create(properties) {
                return new GeocodeProto(properties);
            };

            /**
             * Encodes the specified GeocodeProto message. Does not implicitly {@link waiternow.common.GeocodeProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.GeocodeProto
             * @static
             * @param {waiternow.common.IGeocodeProto} message GeocodeProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GeocodeProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.location != null && Object.hasOwnProperty.call(message, "location"))
                    $root.waiternow.common.GeocodeProto.LocationProto.encode(message.location, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.timeZone != null && Object.hasOwnProperty.call(message, "timeZone"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.timeZone);
                if (message.formattedAddress != null && Object.hasOwnProperty.call(message, "formattedAddress"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.formattedAddress);
                if (message.addressComponents != null && Object.hasOwnProperty.call(message, "addressComponents"))
                    $root.waiternow.common.GeocodeProto.AddressComponentsProto.encode(message.addressComponents, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified GeocodeProto message, length delimited. Does not implicitly {@link waiternow.common.GeocodeProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.GeocodeProto
             * @static
             * @param {waiternow.common.IGeocodeProto} message GeocodeProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GeocodeProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GeocodeProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.GeocodeProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.GeocodeProto} GeocodeProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GeocodeProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GeocodeProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.location = $root.waiternow.common.GeocodeProto.LocationProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 2: {
                            message.timeZone = reader.string();
                            break;
                        }
                    case 3: {
                            message.formattedAddress = reader.string();
                            break;
                        }
                    case 4: {
                            message.addressComponents = $root.waiternow.common.GeocodeProto.AddressComponentsProto.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GeocodeProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.GeocodeProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.GeocodeProto} GeocodeProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GeocodeProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GeocodeProto message.
             * @function verify
             * @memberof waiternow.common.GeocodeProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GeocodeProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.location != null && message.hasOwnProperty("location")) {
                    var error = $root.waiternow.common.GeocodeProto.LocationProto.verify(message.location);
                    if (error)
                        return "location." + error;
                }
                if (message.timeZone != null && message.hasOwnProperty("timeZone"))
                    if (!$util.isString(message.timeZone))
                        return "timeZone: string expected";
                if (message.formattedAddress != null && message.hasOwnProperty("formattedAddress"))
                    if (!$util.isString(message.formattedAddress))
                        return "formattedAddress: string expected";
                if (message.addressComponents != null && message.hasOwnProperty("addressComponents")) {
                    var error = $root.waiternow.common.GeocodeProto.AddressComponentsProto.verify(message.addressComponents);
                    if (error)
                        return "addressComponents." + error;
                }
                return null;
            };

            /**
             * Creates a GeocodeProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.GeocodeProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.GeocodeProto} GeocodeProto
             */
            GeocodeProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.GeocodeProto)
                    return object;
                var message = new $root.waiternow.common.GeocodeProto();
                if (object.location != null) {
                    if (typeof object.location !== "object")
                        throw TypeError(".waiternow.common.GeocodeProto.location: object expected");
                    message.location = $root.waiternow.common.GeocodeProto.LocationProto.fromObject(object.location);
                }
                if (object.timeZone != null)
                    message.timeZone = String(object.timeZone);
                if (object.formattedAddress != null)
                    message.formattedAddress = String(object.formattedAddress);
                if (object.addressComponents != null) {
                    if (typeof object.addressComponents !== "object")
                        throw TypeError(".waiternow.common.GeocodeProto.addressComponents: object expected");
                    message.addressComponents = $root.waiternow.common.GeocodeProto.AddressComponentsProto.fromObject(object.addressComponents);
                }
                return message;
            };

            /**
             * Creates a plain object from a GeocodeProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.GeocodeProto
             * @static
             * @param {waiternow.common.GeocodeProto} message GeocodeProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GeocodeProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.location = null;
                    object.timeZone = "";
                    object.formattedAddress = "";
                    object.addressComponents = null;
                }
                if (message.location != null && message.hasOwnProperty("location"))
                    object.location = $root.waiternow.common.GeocodeProto.LocationProto.toObject(message.location, options);
                if (message.timeZone != null && message.hasOwnProperty("timeZone"))
                    object.timeZone = message.timeZone;
                if (message.formattedAddress != null && message.hasOwnProperty("formattedAddress"))
                    object.formattedAddress = message.formattedAddress;
                if (message.addressComponents != null && message.hasOwnProperty("addressComponents"))
                    object.addressComponents = $root.waiternow.common.GeocodeProto.AddressComponentsProto.toObject(message.addressComponents, options);
                return object;
            };

            /**
             * Converts this GeocodeProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.GeocodeProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GeocodeProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for GeocodeProto
             * @function getTypeUrl
             * @memberof waiternow.common.GeocodeProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            GeocodeProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.GeocodeProto";
            };

            GeocodeProto.LocationProto = (function() {

                /**
                 * Properties of a LocationProto.
                 * @memberof waiternow.common.GeocodeProto
                 * @interface ILocationProto
                 * @property {number|null} [latitud] LocationProto latitud
                 * @property {number|null} [longitude] LocationProto longitude
                 */

                /**
                 * Constructs a new LocationProto.
                 * @memberof waiternow.common.GeocodeProto
                 * @classdesc Represents a LocationProto.
                 * @implements ILocationProto
                 * @constructor
                 * @param {waiternow.common.GeocodeProto.ILocationProto=} [properties] Properties to set
                 */
                function LocationProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * LocationProto latitud.
                 * @member {number} latitud
                 * @memberof waiternow.common.GeocodeProto.LocationProto
                 * @instance
                 */
                LocationProto.prototype.latitud = 0;

                /**
                 * LocationProto longitude.
                 * @member {number} longitude
                 * @memberof waiternow.common.GeocodeProto.LocationProto
                 * @instance
                 */
                LocationProto.prototype.longitude = 0;

                /**
                 * Creates a new LocationProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GeocodeProto.LocationProto
                 * @static
                 * @param {waiternow.common.GeocodeProto.ILocationProto=} [properties] Properties to set
                 * @returns {waiternow.common.GeocodeProto.LocationProto} LocationProto instance
                 */
                LocationProto.create = function create(properties) {
                    return new LocationProto(properties);
                };

                /**
                 * Encodes the specified LocationProto message. Does not implicitly {@link waiternow.common.GeocodeProto.LocationProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GeocodeProto.LocationProto
                 * @static
                 * @param {waiternow.common.GeocodeProto.ILocationProto} message LocationProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LocationProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.latitud != null && Object.hasOwnProperty.call(message, "latitud"))
                        writer.uint32(/* id 1, wireType 1 =*/9).double(message.latitud);
                    if (message.longitude != null && Object.hasOwnProperty.call(message, "longitude"))
                        writer.uint32(/* id 2, wireType 1 =*/17).double(message.longitude);
                    return writer;
                };

                /**
                 * Encodes the specified LocationProto message, length delimited. Does not implicitly {@link waiternow.common.GeocodeProto.LocationProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GeocodeProto.LocationProto
                 * @static
                 * @param {waiternow.common.GeocodeProto.ILocationProto} message LocationProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LocationProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a LocationProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GeocodeProto.LocationProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GeocodeProto.LocationProto} LocationProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LocationProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GeocodeProto.LocationProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.latitud = reader.double();
                                break;
                            }
                        case 2: {
                                message.longitude = reader.double();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a LocationProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GeocodeProto.LocationProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GeocodeProto.LocationProto} LocationProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LocationProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a LocationProto message.
                 * @function verify
                 * @memberof waiternow.common.GeocodeProto.LocationProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                LocationProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.latitud != null && message.hasOwnProperty("latitud"))
                        if (typeof message.latitud !== "number")
                            return "latitud: number expected";
                    if (message.longitude != null && message.hasOwnProperty("longitude"))
                        if (typeof message.longitude !== "number")
                            return "longitude: number expected";
                    return null;
                };

                /**
                 * Creates a LocationProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GeocodeProto.LocationProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GeocodeProto.LocationProto} LocationProto
                 */
                LocationProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GeocodeProto.LocationProto)
                        return object;
                    var message = new $root.waiternow.common.GeocodeProto.LocationProto();
                    if (object.latitud != null)
                        message.latitud = Number(object.latitud);
                    if (object.longitude != null)
                        message.longitude = Number(object.longitude);
                    return message;
                };

                /**
                 * Creates a plain object from a LocationProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GeocodeProto.LocationProto
                 * @static
                 * @param {waiternow.common.GeocodeProto.LocationProto} message LocationProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                LocationProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.latitud = 0;
                        object.longitude = 0;
                    }
                    if (message.latitud != null && message.hasOwnProperty("latitud"))
                        object.latitud = options.json && !isFinite(message.latitud) ? String(message.latitud) : message.latitud;
                    if (message.longitude != null && message.hasOwnProperty("longitude"))
                        object.longitude = options.json && !isFinite(message.longitude) ? String(message.longitude) : message.longitude;
                    return object;
                };

                /**
                 * Converts this LocationProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GeocodeProto.LocationProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                LocationProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for LocationProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.GeocodeProto.LocationProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                LocationProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GeocodeProto.LocationProto";
                };

                return LocationProto;
            })();

            GeocodeProto.AddressComponentsProto = (function() {

                /**
                 * Properties of an AddressComponentsProto.
                 * @memberof waiternow.common.GeocodeProto
                 * @interface IAddressComponentsProto
                 * @property {string|null} [number] AddressComponentsProto number
                 * @property {string|null} [street] AddressComponentsProto street
                 * @property {string|null} [streetShortName] AddressComponentsProto streetShortName
                 * @property {string|null} [city] AddressComponentsProto city
                 * @property {string|null} [cityShortName] AddressComponentsProto cityShortName
                 * @property {string|null} [state] AddressComponentsProto state
                 * @property {string|null} [stateShortName] AddressComponentsProto stateShortName
                 * @property {string|null} [postalCode] AddressComponentsProto postalCode
                 * @property {string|null} [country] AddressComponentsProto country
                 * @property {string|null} [countryShortName] AddressComponentsProto countryShortName
                 */

                /**
                 * Constructs a new AddressComponentsProto.
                 * @memberof waiternow.common.GeocodeProto
                 * @classdesc Represents an AddressComponentsProto.
                 * @implements IAddressComponentsProto
                 * @constructor
                 * @param {waiternow.common.GeocodeProto.IAddressComponentsProto=} [properties] Properties to set
                 */
                function AddressComponentsProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * AddressComponentsProto number.
                 * @member {string} number
                 * @memberof waiternow.common.GeocodeProto.AddressComponentsProto
                 * @instance
                 */
                AddressComponentsProto.prototype.number = "";

                /**
                 * AddressComponentsProto street.
                 * @member {string} street
                 * @memberof waiternow.common.GeocodeProto.AddressComponentsProto
                 * @instance
                 */
                AddressComponentsProto.prototype.street = "";

                /**
                 * AddressComponentsProto streetShortName.
                 * @member {string} streetShortName
                 * @memberof waiternow.common.GeocodeProto.AddressComponentsProto
                 * @instance
                 */
                AddressComponentsProto.prototype.streetShortName = "";

                /**
                 * AddressComponentsProto city.
                 * @member {string} city
                 * @memberof waiternow.common.GeocodeProto.AddressComponentsProto
                 * @instance
                 */
                AddressComponentsProto.prototype.city = "";

                /**
                 * AddressComponentsProto cityShortName.
                 * @member {string} cityShortName
                 * @memberof waiternow.common.GeocodeProto.AddressComponentsProto
                 * @instance
                 */
                AddressComponentsProto.prototype.cityShortName = "";

                /**
                 * AddressComponentsProto state.
                 * @member {string} state
                 * @memberof waiternow.common.GeocodeProto.AddressComponentsProto
                 * @instance
                 */
                AddressComponentsProto.prototype.state = "";

                /**
                 * AddressComponentsProto stateShortName.
                 * @member {string} stateShortName
                 * @memberof waiternow.common.GeocodeProto.AddressComponentsProto
                 * @instance
                 */
                AddressComponentsProto.prototype.stateShortName = "";

                /**
                 * AddressComponentsProto postalCode.
                 * @member {string} postalCode
                 * @memberof waiternow.common.GeocodeProto.AddressComponentsProto
                 * @instance
                 */
                AddressComponentsProto.prototype.postalCode = "";

                /**
                 * AddressComponentsProto country.
                 * @member {string} country
                 * @memberof waiternow.common.GeocodeProto.AddressComponentsProto
                 * @instance
                 */
                AddressComponentsProto.prototype.country = "";

                /**
                 * AddressComponentsProto countryShortName.
                 * @member {string} countryShortName
                 * @memberof waiternow.common.GeocodeProto.AddressComponentsProto
                 * @instance
                 */
                AddressComponentsProto.prototype.countryShortName = "";

                /**
                 * Creates a new AddressComponentsProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GeocodeProto.AddressComponentsProto
                 * @static
                 * @param {waiternow.common.GeocodeProto.IAddressComponentsProto=} [properties] Properties to set
                 * @returns {waiternow.common.GeocodeProto.AddressComponentsProto} AddressComponentsProto instance
                 */
                AddressComponentsProto.create = function create(properties) {
                    return new AddressComponentsProto(properties);
                };

                /**
                 * Encodes the specified AddressComponentsProto message. Does not implicitly {@link waiternow.common.GeocodeProto.AddressComponentsProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GeocodeProto.AddressComponentsProto
                 * @static
                 * @param {waiternow.common.GeocodeProto.IAddressComponentsProto} message AddressComponentsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AddressComponentsProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.number != null && Object.hasOwnProperty.call(message, "number"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.number);
                    if (message.street != null && Object.hasOwnProperty.call(message, "street"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.street);
                    if (message.streetShortName != null && Object.hasOwnProperty.call(message, "streetShortName"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.streetShortName);
                    if (message.city != null && Object.hasOwnProperty.call(message, "city"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.city);
                    if (message.cityShortName != null && Object.hasOwnProperty.call(message, "cityShortName"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.cityShortName);
                    if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                        writer.uint32(/* id 6, wireType 2 =*/50).string(message.state);
                    if (message.stateShortName != null && Object.hasOwnProperty.call(message, "stateShortName"))
                        writer.uint32(/* id 7, wireType 2 =*/58).string(message.stateShortName);
                    if (message.postalCode != null && Object.hasOwnProperty.call(message, "postalCode"))
                        writer.uint32(/* id 8, wireType 2 =*/66).string(message.postalCode);
                    if (message.country != null && Object.hasOwnProperty.call(message, "country"))
                        writer.uint32(/* id 9, wireType 2 =*/74).string(message.country);
                    if (message.countryShortName != null && Object.hasOwnProperty.call(message, "countryShortName"))
                        writer.uint32(/* id 10, wireType 2 =*/82).string(message.countryShortName);
                    return writer;
                };

                /**
                 * Encodes the specified AddressComponentsProto message, length delimited. Does not implicitly {@link waiternow.common.GeocodeProto.AddressComponentsProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GeocodeProto.AddressComponentsProto
                 * @static
                 * @param {waiternow.common.GeocodeProto.IAddressComponentsProto} message AddressComponentsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AddressComponentsProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an AddressComponentsProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GeocodeProto.AddressComponentsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GeocodeProto.AddressComponentsProto} AddressComponentsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AddressComponentsProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GeocodeProto.AddressComponentsProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.number = reader.string();
                                break;
                            }
                        case 2: {
                                message.street = reader.string();
                                break;
                            }
                        case 3: {
                                message.streetShortName = reader.string();
                                break;
                            }
                        case 4: {
                                message.city = reader.string();
                                break;
                            }
                        case 5: {
                                message.cityShortName = reader.string();
                                break;
                            }
                        case 6: {
                                message.state = reader.string();
                                break;
                            }
                        case 7: {
                                message.stateShortName = reader.string();
                                break;
                            }
                        case 8: {
                                message.postalCode = reader.string();
                                break;
                            }
                        case 9: {
                                message.country = reader.string();
                                break;
                            }
                        case 10: {
                                message.countryShortName = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an AddressComponentsProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GeocodeProto.AddressComponentsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GeocodeProto.AddressComponentsProto} AddressComponentsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AddressComponentsProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an AddressComponentsProto message.
                 * @function verify
                 * @memberof waiternow.common.GeocodeProto.AddressComponentsProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                AddressComponentsProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.number != null && message.hasOwnProperty("number"))
                        if (!$util.isString(message.number))
                            return "number: string expected";
                    if (message.street != null && message.hasOwnProperty("street"))
                        if (!$util.isString(message.street))
                            return "street: string expected";
                    if (message.streetShortName != null && message.hasOwnProperty("streetShortName"))
                        if (!$util.isString(message.streetShortName))
                            return "streetShortName: string expected";
                    if (message.city != null && message.hasOwnProperty("city"))
                        if (!$util.isString(message.city))
                            return "city: string expected";
                    if (message.cityShortName != null && message.hasOwnProperty("cityShortName"))
                        if (!$util.isString(message.cityShortName))
                            return "cityShortName: string expected";
                    if (message.state != null && message.hasOwnProperty("state"))
                        if (!$util.isString(message.state))
                            return "state: string expected";
                    if (message.stateShortName != null && message.hasOwnProperty("stateShortName"))
                        if (!$util.isString(message.stateShortName))
                            return "stateShortName: string expected";
                    if (message.postalCode != null && message.hasOwnProperty("postalCode"))
                        if (!$util.isString(message.postalCode))
                            return "postalCode: string expected";
                    if (message.country != null && message.hasOwnProperty("country"))
                        if (!$util.isString(message.country))
                            return "country: string expected";
                    if (message.countryShortName != null && message.hasOwnProperty("countryShortName"))
                        if (!$util.isString(message.countryShortName))
                            return "countryShortName: string expected";
                    return null;
                };

                /**
                 * Creates an AddressComponentsProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GeocodeProto.AddressComponentsProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GeocodeProto.AddressComponentsProto} AddressComponentsProto
                 */
                AddressComponentsProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GeocodeProto.AddressComponentsProto)
                        return object;
                    var message = new $root.waiternow.common.GeocodeProto.AddressComponentsProto();
                    if (object.number != null)
                        message.number = String(object.number);
                    if (object.street != null)
                        message.street = String(object.street);
                    if (object.streetShortName != null)
                        message.streetShortName = String(object.streetShortName);
                    if (object.city != null)
                        message.city = String(object.city);
                    if (object.cityShortName != null)
                        message.cityShortName = String(object.cityShortName);
                    if (object.state != null)
                        message.state = String(object.state);
                    if (object.stateShortName != null)
                        message.stateShortName = String(object.stateShortName);
                    if (object.postalCode != null)
                        message.postalCode = String(object.postalCode);
                    if (object.country != null)
                        message.country = String(object.country);
                    if (object.countryShortName != null)
                        message.countryShortName = String(object.countryShortName);
                    return message;
                };

                /**
                 * Creates a plain object from an AddressComponentsProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GeocodeProto.AddressComponentsProto
                 * @static
                 * @param {waiternow.common.GeocodeProto.AddressComponentsProto} message AddressComponentsProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                AddressComponentsProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.number = "";
                        object.street = "";
                        object.streetShortName = "";
                        object.city = "";
                        object.cityShortName = "";
                        object.state = "";
                        object.stateShortName = "";
                        object.postalCode = "";
                        object.country = "";
                        object.countryShortName = "";
                    }
                    if (message.number != null && message.hasOwnProperty("number"))
                        object.number = message.number;
                    if (message.street != null && message.hasOwnProperty("street"))
                        object.street = message.street;
                    if (message.streetShortName != null && message.hasOwnProperty("streetShortName"))
                        object.streetShortName = message.streetShortName;
                    if (message.city != null && message.hasOwnProperty("city"))
                        object.city = message.city;
                    if (message.cityShortName != null && message.hasOwnProperty("cityShortName"))
                        object.cityShortName = message.cityShortName;
                    if (message.state != null && message.hasOwnProperty("state"))
                        object.state = message.state;
                    if (message.stateShortName != null && message.hasOwnProperty("stateShortName"))
                        object.stateShortName = message.stateShortName;
                    if (message.postalCode != null && message.hasOwnProperty("postalCode"))
                        object.postalCode = message.postalCode;
                    if (message.country != null && message.hasOwnProperty("country"))
                        object.country = message.country;
                    if (message.countryShortName != null && message.hasOwnProperty("countryShortName"))
                        object.countryShortName = message.countryShortName;
                    return object;
                };

                /**
                 * Converts this AddressComponentsProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GeocodeProto.AddressComponentsProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                AddressComponentsProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for AddressComponentsProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.GeocodeProto.AddressComponentsProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                AddressComponentsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GeocodeProto.AddressComponentsProto";
                };

                return AddressComponentsProto;
            })();

            return GeocodeProto;
        })();

        common.AddressProto = (function() {

            /**
             * Properties of an AddressProto.
             * @memberof waiternow.common
             * @interface IAddressProto
             * @property {waiternow.common.ISimpleAddressProto|null} [simpleAddress] AddressProto simpleAddress
             * @property {waiternow.common.IStructuredAddressProto|null} [structuredAddress] AddressProto structuredAddress
             * @property {waiternow.common.IGeocodeProto|null} [geocode] AddressProto geocode
             */

            /**
             * Constructs a new AddressProto.
             * @memberof waiternow.common
             * @classdesc Represents an AddressProto.
             * @implements IAddressProto
             * @constructor
             * @param {waiternow.common.IAddressProto=} [properties] Properties to set
             */
            function AddressProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AddressProto simpleAddress.
             * @member {waiternow.common.ISimpleAddressProto|null|undefined} simpleAddress
             * @memberof waiternow.common.AddressProto
             * @instance
             */
            AddressProto.prototype.simpleAddress = null;

            /**
             * AddressProto structuredAddress.
             * @member {waiternow.common.IStructuredAddressProto|null|undefined} structuredAddress
             * @memberof waiternow.common.AddressProto
             * @instance
             */
            AddressProto.prototype.structuredAddress = null;

            /**
             * AddressProto geocode.
             * @member {waiternow.common.IGeocodeProto|null|undefined} geocode
             * @memberof waiternow.common.AddressProto
             * @instance
             */
            AddressProto.prototype.geocode = null;

            // OneOf field names bound to virtual getters and setters
            var $oneOfFields;

            /**
             * AddressProto address.
             * @member {"simpleAddress"|"structuredAddress"|undefined} address
             * @memberof waiternow.common.AddressProto
             * @instance
             */
            Object.defineProperty(AddressProto.prototype, "address", {
                get: $util.oneOfGetter($oneOfFields = ["simpleAddress", "structuredAddress"]),
                set: $util.oneOfSetter($oneOfFields)
            });

            /**
             * Creates a new AddressProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.AddressProto
             * @static
             * @param {waiternow.common.IAddressProto=} [properties] Properties to set
             * @returns {waiternow.common.AddressProto} AddressProto instance
             */
            AddressProto.create = function create(properties) {
                return new AddressProto(properties);
            };

            /**
             * Encodes the specified AddressProto message. Does not implicitly {@link waiternow.common.AddressProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.AddressProto
             * @static
             * @param {waiternow.common.IAddressProto} message AddressProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AddressProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.simpleAddress != null && Object.hasOwnProperty.call(message, "simpleAddress"))
                    $root.waiternow.common.SimpleAddressProto.encode(message.simpleAddress, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.structuredAddress != null && Object.hasOwnProperty.call(message, "structuredAddress"))
                    $root.waiternow.common.StructuredAddressProto.encode(message.structuredAddress, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.geocode != null && Object.hasOwnProperty.call(message, "geocode"))
                    $root.waiternow.common.GeocodeProto.encode(message.geocode, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified AddressProto message, length delimited. Does not implicitly {@link waiternow.common.AddressProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.AddressProto
             * @static
             * @param {waiternow.common.IAddressProto} message AddressProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AddressProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AddressProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.AddressProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.AddressProto} AddressProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AddressProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.AddressProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.simpleAddress = $root.waiternow.common.SimpleAddressProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 2: {
                            message.structuredAddress = $root.waiternow.common.StructuredAddressProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 3: {
                            message.geocode = $root.waiternow.common.GeocodeProto.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AddressProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.AddressProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.AddressProto} AddressProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AddressProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AddressProto message.
             * @function verify
             * @memberof waiternow.common.AddressProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AddressProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                var properties = {};
                if (message.simpleAddress != null && message.hasOwnProperty("simpleAddress")) {
                    properties.address = 1;
                    {
                        var error = $root.waiternow.common.SimpleAddressProto.verify(message.simpleAddress);
                        if (error)
                            return "simpleAddress." + error;
                    }
                }
                if (message.structuredAddress != null && message.hasOwnProperty("structuredAddress")) {
                    if (properties.address === 1)
                        return "address: multiple values";
                    properties.address = 1;
                    {
                        var error = $root.waiternow.common.StructuredAddressProto.verify(message.structuredAddress);
                        if (error)
                            return "structuredAddress." + error;
                    }
                }
                if (message.geocode != null && message.hasOwnProperty("geocode")) {
                    var error = $root.waiternow.common.GeocodeProto.verify(message.geocode);
                    if (error)
                        return "geocode." + error;
                }
                return null;
            };

            /**
             * Creates an AddressProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.AddressProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.AddressProto} AddressProto
             */
            AddressProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.AddressProto)
                    return object;
                var message = new $root.waiternow.common.AddressProto();
                if (object.simpleAddress != null) {
                    if (typeof object.simpleAddress !== "object")
                        throw TypeError(".waiternow.common.AddressProto.simpleAddress: object expected");
                    message.simpleAddress = $root.waiternow.common.SimpleAddressProto.fromObject(object.simpleAddress);
                }
                if (object.structuredAddress != null) {
                    if (typeof object.structuredAddress !== "object")
                        throw TypeError(".waiternow.common.AddressProto.structuredAddress: object expected");
                    message.structuredAddress = $root.waiternow.common.StructuredAddressProto.fromObject(object.structuredAddress);
                }
                if (object.geocode != null) {
                    if (typeof object.geocode !== "object")
                        throw TypeError(".waiternow.common.AddressProto.geocode: object expected");
                    message.geocode = $root.waiternow.common.GeocodeProto.fromObject(object.geocode);
                }
                return message;
            };

            /**
             * Creates a plain object from an AddressProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.AddressProto
             * @static
             * @param {waiternow.common.AddressProto} message AddressProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AddressProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.geocode = null;
                if (message.simpleAddress != null && message.hasOwnProperty("simpleAddress")) {
                    object.simpleAddress = $root.waiternow.common.SimpleAddressProto.toObject(message.simpleAddress, options);
                    if (options.oneofs)
                        object.address = "simpleAddress";
                }
                if (message.structuredAddress != null && message.hasOwnProperty("structuredAddress")) {
                    object.structuredAddress = $root.waiternow.common.StructuredAddressProto.toObject(message.structuredAddress, options);
                    if (options.oneofs)
                        object.address = "structuredAddress";
                }
                if (message.geocode != null && message.hasOwnProperty("geocode"))
                    object.geocode = $root.waiternow.common.GeocodeProto.toObject(message.geocode, options);
                return object;
            };

            /**
             * Converts this AddressProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.AddressProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AddressProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for AddressProto
             * @function getTypeUrl
             * @memberof waiternow.common.AddressProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            AddressProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.AddressProto";
            };

            return AddressProto;
        })();

        common.EmailAddressProto = (function() {

            /**
             * Properties of an EmailAddressProto.
             * @memberof waiternow.common
             * @interface IEmailAddressProto
             * @property {string|null} [email] EmailAddressProto email
             * @property {string|null} [name] EmailAddressProto name
             */

            /**
             * Constructs a new EmailAddressProto.
             * @memberof waiternow.common
             * @classdesc Represents an EmailAddressProto.
             * @implements IEmailAddressProto
             * @constructor
             * @param {waiternow.common.IEmailAddressProto=} [properties] Properties to set
             */
            function EmailAddressProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * EmailAddressProto email.
             * @member {string} email
             * @memberof waiternow.common.EmailAddressProto
             * @instance
             */
            EmailAddressProto.prototype.email = "";

            /**
             * EmailAddressProto name.
             * @member {string} name
             * @memberof waiternow.common.EmailAddressProto
             * @instance
             */
            EmailAddressProto.prototype.name = "";

            /**
             * Creates a new EmailAddressProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.EmailAddressProto
             * @static
             * @param {waiternow.common.IEmailAddressProto=} [properties] Properties to set
             * @returns {waiternow.common.EmailAddressProto} EmailAddressProto instance
             */
            EmailAddressProto.create = function create(properties) {
                return new EmailAddressProto(properties);
            };

            /**
             * Encodes the specified EmailAddressProto message. Does not implicitly {@link waiternow.common.EmailAddressProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.EmailAddressProto
             * @static
             * @param {waiternow.common.IEmailAddressProto} message EmailAddressProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EmailAddressProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                return writer;
            };

            /**
             * Encodes the specified EmailAddressProto message, length delimited. Does not implicitly {@link waiternow.common.EmailAddressProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.EmailAddressProto
             * @static
             * @param {waiternow.common.IEmailAddressProto} message EmailAddressProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EmailAddressProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an EmailAddressProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.EmailAddressProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.EmailAddressProto} EmailAddressProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EmailAddressProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.EmailAddressProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.email = reader.string();
                            break;
                        }
                    case 2: {
                            message.name = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an EmailAddressProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.EmailAddressProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.EmailAddressProto} EmailAddressProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EmailAddressProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an EmailAddressProto message.
             * @function verify
             * @memberof waiternow.common.EmailAddressProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            EmailAddressProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.email != null && message.hasOwnProperty("email"))
                    if (!$util.isString(message.email))
                        return "email: string expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                return null;
            };

            /**
             * Creates an EmailAddressProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.EmailAddressProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.EmailAddressProto} EmailAddressProto
             */
            EmailAddressProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.EmailAddressProto)
                    return object;
                var message = new $root.waiternow.common.EmailAddressProto();
                if (object.email != null)
                    message.email = String(object.email);
                if (object.name != null)
                    message.name = String(object.name);
                return message;
            };

            /**
             * Creates a plain object from an EmailAddressProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.EmailAddressProto
             * @static
             * @param {waiternow.common.EmailAddressProto} message EmailAddressProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            EmailAddressProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.email = "";
                    object.name = "";
                }
                if (message.email != null && message.hasOwnProperty("email"))
                    object.email = message.email;
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                return object;
            };

            /**
             * Converts this EmailAddressProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.EmailAddressProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            EmailAddressProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for EmailAddressProto
             * @function getTypeUrl
             * @memberof waiternow.common.EmailAddressProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            EmailAddressProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.EmailAddressProto";
            };

            return EmailAddressProto;
        })();

        common.IntRangeProto = (function() {

            /**
             * Properties of an IntRangeProto.
             * @memberof waiternow.common
             * @interface IIntRangeProto
             * @property {number|null} [from] IntRangeProto from
             * @property {number|null} [to] IntRangeProto to
             */

            /**
             * Constructs a new IntRangeProto.
             * @memberof waiternow.common
             * @classdesc Represents an IntRangeProto.
             * @implements IIntRangeProto
             * @constructor
             * @param {waiternow.common.IIntRangeProto=} [properties] Properties to set
             */
            function IntRangeProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * IntRangeProto from.
             * @member {number} from
             * @memberof waiternow.common.IntRangeProto
             * @instance
             */
            IntRangeProto.prototype.from = 0;

            /**
             * IntRangeProto to.
             * @member {number} to
             * @memberof waiternow.common.IntRangeProto
             * @instance
             */
            IntRangeProto.prototype.to = 0;

            /**
             * Creates a new IntRangeProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.IntRangeProto
             * @static
             * @param {waiternow.common.IIntRangeProto=} [properties] Properties to set
             * @returns {waiternow.common.IntRangeProto} IntRangeProto instance
             */
            IntRangeProto.create = function create(properties) {
                return new IntRangeProto(properties);
            };

            /**
             * Encodes the specified IntRangeProto message. Does not implicitly {@link waiternow.common.IntRangeProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.IntRangeProto
             * @static
             * @param {waiternow.common.IIntRangeProto} message IntRangeProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            IntRangeProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.from != null && Object.hasOwnProperty.call(message, "from"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.from);
                if (message.to != null && Object.hasOwnProperty.call(message, "to"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.to);
                return writer;
            };

            /**
             * Encodes the specified IntRangeProto message, length delimited. Does not implicitly {@link waiternow.common.IntRangeProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.IntRangeProto
             * @static
             * @param {waiternow.common.IIntRangeProto} message IntRangeProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            IntRangeProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an IntRangeProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.IntRangeProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.IntRangeProto} IntRangeProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            IntRangeProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.IntRangeProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.from = reader.int32();
                            break;
                        }
                    case 2: {
                            message.to = reader.int32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an IntRangeProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.IntRangeProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.IntRangeProto} IntRangeProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            IntRangeProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an IntRangeProto message.
             * @function verify
             * @memberof waiternow.common.IntRangeProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            IntRangeProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.from != null && message.hasOwnProperty("from"))
                    if (!$util.isInteger(message.from))
                        return "from: integer expected";
                if (message.to != null && message.hasOwnProperty("to"))
                    if (!$util.isInteger(message.to))
                        return "to: integer expected";
                return null;
            };

            /**
             * Creates an IntRangeProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.IntRangeProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.IntRangeProto} IntRangeProto
             */
            IntRangeProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.IntRangeProto)
                    return object;
                var message = new $root.waiternow.common.IntRangeProto();
                if (object.from != null)
                    message.from = object.from | 0;
                if (object.to != null)
                    message.to = object.to | 0;
                return message;
            };

            /**
             * Creates a plain object from an IntRangeProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.IntRangeProto
             * @static
             * @param {waiternow.common.IntRangeProto} message IntRangeProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            IntRangeProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.from = 0;
                    object.to = 0;
                }
                if (message.from != null && message.hasOwnProperty("from"))
                    object.from = message.from;
                if (message.to != null && message.hasOwnProperty("to"))
                    object.to = message.to;
                return object;
            };

            /**
             * Converts this IntRangeProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.IntRangeProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            IntRangeProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for IntRangeProto
             * @function getTypeUrl
             * @memberof waiternow.common.IntRangeProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            IntRangeProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.IntRangeProto";
            };

            return IntRangeProto;
        })();

        common.LocationProto = (function() {

            /**
             * Properties of a LocationProto.
             * @memberof waiternow.common
             * @interface ILocationProto
             * @property {string|null} [id] LocationProto id
             * @property {google.protobuf.ITimestamp|null} [creationTime] LocationProto creationTime
             * @property {google.protobuf.ITimestamp|null} [lastUpdateTime] LocationProto lastUpdateTime
             * @property {string|null} [businessId] LocationProto businessId
             * @property {string|null} [name] LocationProto name
             * @property {waiternow.common.IAddressProto|null} [address] LocationProto address
             * @property {waiternow.common.LocationProto.ISettingsProto|null} [settings] LocationProto settings
             * @property {waiternow.common.LocationProto.IRedundantDataProto|null} [redundantData] LocationProto redundantData
             * @property {waiternow.common.IPhoneNumberProto|null} [phoneNumber] LocationProto phoneNumber
             * @property {waiternow.common.LocationProto.IMetadataProto|null} [metadata] LocationProto metadata
             * @property {waiternow.common.ITextProto|null} [announcement] LocationProto announcement
             */

            /**
             * Constructs a new LocationProto.
             * @memberof waiternow.common
             * @classdesc Represents a LocationProto.
             * @implements ILocationProto
             * @constructor
             * @param {waiternow.common.ILocationProto=} [properties] Properties to set
             */
            function LocationProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * LocationProto id.
             * @member {string} id
             * @memberof waiternow.common.LocationProto
             * @instance
             */
            LocationProto.prototype.id = "";

            /**
             * LocationProto creationTime.
             * @member {google.protobuf.ITimestamp|null|undefined} creationTime
             * @memberof waiternow.common.LocationProto
             * @instance
             */
            LocationProto.prototype.creationTime = null;

            /**
             * LocationProto lastUpdateTime.
             * @member {google.protobuf.ITimestamp|null|undefined} lastUpdateTime
             * @memberof waiternow.common.LocationProto
             * @instance
             */
            LocationProto.prototype.lastUpdateTime = null;

            /**
             * LocationProto businessId.
             * @member {string} businessId
             * @memberof waiternow.common.LocationProto
             * @instance
             */
            LocationProto.prototype.businessId = "";

            /**
             * LocationProto name.
             * @member {string} name
             * @memberof waiternow.common.LocationProto
             * @instance
             */
            LocationProto.prototype.name = "";

            /**
             * LocationProto address.
             * @member {waiternow.common.IAddressProto|null|undefined} address
             * @memberof waiternow.common.LocationProto
             * @instance
             */
            LocationProto.prototype.address = null;

            /**
             * LocationProto settings.
             * @member {waiternow.common.LocationProto.ISettingsProto|null|undefined} settings
             * @memberof waiternow.common.LocationProto
             * @instance
             */
            LocationProto.prototype.settings = null;

            /**
             * LocationProto redundantData.
             * @member {waiternow.common.LocationProto.IRedundantDataProto|null|undefined} redundantData
             * @memberof waiternow.common.LocationProto
             * @instance
             */
            LocationProto.prototype.redundantData = null;

            /**
             * LocationProto phoneNumber.
             * @member {waiternow.common.IPhoneNumberProto|null|undefined} phoneNumber
             * @memberof waiternow.common.LocationProto
             * @instance
             */
            LocationProto.prototype.phoneNumber = null;

            /**
             * LocationProto metadata.
             * @member {waiternow.common.LocationProto.IMetadataProto|null|undefined} metadata
             * @memberof waiternow.common.LocationProto
             * @instance
             */
            LocationProto.prototype.metadata = null;

            /**
             * LocationProto announcement.
             * @member {waiternow.common.ITextProto|null|undefined} announcement
             * @memberof waiternow.common.LocationProto
             * @instance
             */
            LocationProto.prototype.announcement = null;

            /**
             * Creates a new LocationProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.LocationProto
             * @static
             * @param {waiternow.common.ILocationProto=} [properties] Properties to set
             * @returns {waiternow.common.LocationProto} LocationProto instance
             */
            LocationProto.create = function create(properties) {
                return new LocationProto(properties);
            };

            /**
             * Encodes the specified LocationProto message. Does not implicitly {@link waiternow.common.LocationProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.LocationProto
             * @static
             * @param {waiternow.common.ILocationProto} message LocationProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            LocationProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.businessId);
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.name);
                if (message.address != null && Object.hasOwnProperty.call(message, "address"))
                    $root.waiternow.common.AddressProto.encode(message.address, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                if (message.creationTime != null && Object.hasOwnProperty.call(message, "creationTime"))
                    $root.google.protobuf.Timestamp.encode(message.creationTime, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                    $root.google.protobuf.Timestamp.encode(message.lastUpdateTime, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                if (message.settings != null && Object.hasOwnProperty.call(message, "settings"))
                    $root.waiternow.common.LocationProto.SettingsProto.encode(message.settings, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                if (message.redundantData != null && Object.hasOwnProperty.call(message, "redundantData"))
                    $root.waiternow.common.LocationProto.RedundantDataProto.encode(message.redundantData, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                if (message.phoneNumber != null && Object.hasOwnProperty.call(message, "phoneNumber"))
                    $root.waiternow.common.PhoneNumberProto.encode(message.phoneNumber, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                if (message.metadata != null && Object.hasOwnProperty.call(message, "metadata"))
                    $root.waiternow.common.LocationProto.MetadataProto.encode(message.metadata, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                if (message.announcement != null && Object.hasOwnProperty.call(message, "announcement"))
                    $root.waiternow.common.TextProto.encode(message.announcement, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified LocationProto message, length delimited. Does not implicitly {@link waiternow.common.LocationProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.LocationProto
             * @static
             * @param {waiternow.common.ILocationProto} message LocationProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            LocationProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a LocationProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.LocationProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.LocationProto} LocationProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            LocationProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.LocationProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.id = reader.string();
                            break;
                        }
                    case 5: {
                            message.creationTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 6: {
                            message.lastUpdateTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 2: {
                            message.businessId = reader.string();
                            break;
                        }
                    case 3: {
                            message.name = reader.string();
                            break;
                        }
                    case 4: {
                            message.address = $root.waiternow.common.AddressProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 7: {
                            message.settings = $root.waiternow.common.LocationProto.SettingsProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 8: {
                            message.redundantData = $root.waiternow.common.LocationProto.RedundantDataProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 9: {
                            message.phoneNumber = $root.waiternow.common.PhoneNumberProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 10: {
                            message.metadata = $root.waiternow.common.LocationProto.MetadataProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 11: {
                            message.announcement = $root.waiternow.common.TextProto.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a LocationProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.LocationProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.LocationProto} LocationProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            LocationProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a LocationProto message.
             * @function verify
             * @memberof waiternow.common.LocationProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            LocationProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.id != null && message.hasOwnProperty("id"))
                    if (!$util.isString(message.id))
                        return "id: string expected";
                if (message.creationTime != null && message.hasOwnProperty("creationTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.creationTime);
                    if (error)
                        return "creationTime." + error;
                }
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.lastUpdateTime);
                    if (error)
                        return "lastUpdateTime." + error;
                }
                if (message.businessId != null && message.hasOwnProperty("businessId"))
                    if (!$util.isString(message.businessId))
                        return "businessId: string expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.address != null && message.hasOwnProperty("address")) {
                    var error = $root.waiternow.common.AddressProto.verify(message.address);
                    if (error)
                        return "address." + error;
                }
                if (message.settings != null && message.hasOwnProperty("settings")) {
                    var error = $root.waiternow.common.LocationProto.SettingsProto.verify(message.settings);
                    if (error)
                        return "settings." + error;
                }
                if (message.redundantData != null && message.hasOwnProperty("redundantData")) {
                    var error = $root.waiternow.common.LocationProto.RedundantDataProto.verify(message.redundantData);
                    if (error)
                        return "redundantData." + error;
                }
                if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber")) {
                    var error = $root.waiternow.common.PhoneNumberProto.verify(message.phoneNumber);
                    if (error)
                        return "phoneNumber." + error;
                }
                if (message.metadata != null && message.hasOwnProperty("metadata")) {
                    var error = $root.waiternow.common.LocationProto.MetadataProto.verify(message.metadata);
                    if (error)
                        return "metadata." + error;
                }
                if (message.announcement != null && message.hasOwnProperty("announcement")) {
                    var error = $root.waiternow.common.TextProto.verify(message.announcement);
                    if (error)
                        return "announcement." + error;
                }
                return null;
            };

            /**
             * Creates a LocationProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.LocationProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.LocationProto} LocationProto
             */
            LocationProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.LocationProto)
                    return object;
                var message = new $root.waiternow.common.LocationProto();
                if (object.id != null)
                    message.id = String(object.id);
                if (object.creationTime != null) {
                    if (typeof object.creationTime !== "object")
                        throw TypeError(".waiternow.common.LocationProto.creationTime: object expected");
                    message.creationTime = $root.google.protobuf.Timestamp.fromObject(object.creationTime);
                }
                if (object.lastUpdateTime != null) {
                    if (typeof object.lastUpdateTime !== "object")
                        throw TypeError(".waiternow.common.LocationProto.lastUpdateTime: object expected");
                    message.lastUpdateTime = $root.google.protobuf.Timestamp.fromObject(object.lastUpdateTime);
                }
                if (object.businessId != null)
                    message.businessId = String(object.businessId);
                if (object.name != null)
                    message.name = String(object.name);
                if (object.address != null) {
                    if (typeof object.address !== "object")
                        throw TypeError(".waiternow.common.LocationProto.address: object expected");
                    message.address = $root.waiternow.common.AddressProto.fromObject(object.address);
                }
                if (object.settings != null) {
                    if (typeof object.settings !== "object")
                        throw TypeError(".waiternow.common.LocationProto.settings: object expected");
                    message.settings = $root.waiternow.common.LocationProto.SettingsProto.fromObject(object.settings);
                }
                if (object.redundantData != null) {
                    if (typeof object.redundantData !== "object")
                        throw TypeError(".waiternow.common.LocationProto.redundantData: object expected");
                    message.redundantData = $root.waiternow.common.LocationProto.RedundantDataProto.fromObject(object.redundantData);
                }
                if (object.phoneNumber != null) {
                    if (typeof object.phoneNumber !== "object")
                        throw TypeError(".waiternow.common.LocationProto.phoneNumber: object expected");
                    message.phoneNumber = $root.waiternow.common.PhoneNumberProto.fromObject(object.phoneNumber);
                }
                if (object.metadata != null) {
                    if (typeof object.metadata !== "object")
                        throw TypeError(".waiternow.common.LocationProto.metadata: object expected");
                    message.metadata = $root.waiternow.common.LocationProto.MetadataProto.fromObject(object.metadata);
                }
                if (object.announcement != null) {
                    if (typeof object.announcement !== "object")
                        throw TypeError(".waiternow.common.LocationProto.announcement: object expected");
                    message.announcement = $root.waiternow.common.TextProto.fromObject(object.announcement);
                }
                return message;
            };

            /**
             * Creates a plain object from a LocationProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.LocationProto
             * @static
             * @param {waiternow.common.LocationProto} message LocationProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            LocationProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.id = "";
                    object.businessId = "";
                    object.name = "";
                    object.address = null;
                    object.creationTime = null;
                    object.lastUpdateTime = null;
                    object.settings = null;
                    object.redundantData = null;
                    object.phoneNumber = null;
                    object.metadata = null;
                    object.announcement = null;
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                if (message.businessId != null && message.hasOwnProperty("businessId"))
                    object.businessId = message.businessId;
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.address != null && message.hasOwnProperty("address"))
                    object.address = $root.waiternow.common.AddressProto.toObject(message.address, options);
                if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                    object.creationTime = $root.google.protobuf.Timestamp.toObject(message.creationTime, options);
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                    object.lastUpdateTime = $root.google.protobuf.Timestamp.toObject(message.lastUpdateTime, options);
                if (message.settings != null && message.hasOwnProperty("settings"))
                    object.settings = $root.waiternow.common.LocationProto.SettingsProto.toObject(message.settings, options);
                if (message.redundantData != null && message.hasOwnProperty("redundantData"))
                    object.redundantData = $root.waiternow.common.LocationProto.RedundantDataProto.toObject(message.redundantData, options);
                if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
                    object.phoneNumber = $root.waiternow.common.PhoneNumberProto.toObject(message.phoneNumber, options);
                if (message.metadata != null && message.hasOwnProperty("metadata"))
                    object.metadata = $root.waiternow.common.LocationProto.MetadataProto.toObject(message.metadata, options);
                if (message.announcement != null && message.hasOwnProperty("announcement"))
                    object.announcement = $root.waiternow.common.TextProto.toObject(message.announcement, options);
                return object;
            };

            /**
             * Converts this LocationProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.LocationProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            LocationProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for LocationProto
             * @function getTypeUrl
             * @memberof waiternow.common.LocationProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            LocationProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.LocationProto";
            };

            LocationProto.SettingsProto = (function() {

                /**
                 * Properties of a SettingsProto.
                 * @memberof waiternow.common.LocationProto
                 * @interface ISettingsProto
                 * @property {waiternow.common.IImageMenuProto|null} [imageMenu] SettingsProto imageMenu
                 * @property {waiternow.common.LocationProto.SettingsProto.ILocaleSettingsProto|null} [localeSettings] SettingsProto localeSettings
                 * @property {waiternow.common.LocationProto.SettingsProto.IQuotaProto|null} [quota] SettingsProto quota
                 * @property {waiternow.common.LocationProto.SettingsProto.IViewSettingsProto|null} [viewSettings] SettingsProto viewSettings
                 * @property {waiternow.common.LocationProto.SettingsProto.IExternalLinksProto|null} [externalLinks] SettingsProto externalLinks
                 * @property {waiternow.common.LocationProto.SettingsProto.IOperationSettingsProto|null} [operationSettings] SettingsProto operationSettings
                 */

                /**
                 * Constructs a new SettingsProto.
                 * @memberof waiternow.common.LocationProto
                 * @classdesc Represents a SettingsProto.
                 * @implements ISettingsProto
                 * @constructor
                 * @param {waiternow.common.LocationProto.ISettingsProto=} [properties] Properties to set
                 */
                function SettingsProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SettingsProto imageMenu.
                 * @member {waiternow.common.IImageMenuProto|null|undefined} imageMenu
                 * @memberof waiternow.common.LocationProto.SettingsProto
                 * @instance
                 */
                SettingsProto.prototype.imageMenu = null;

                /**
                 * SettingsProto localeSettings.
                 * @member {waiternow.common.LocationProto.SettingsProto.ILocaleSettingsProto|null|undefined} localeSettings
                 * @memberof waiternow.common.LocationProto.SettingsProto
                 * @instance
                 */
                SettingsProto.prototype.localeSettings = null;

                /**
                 * SettingsProto quota.
                 * @member {waiternow.common.LocationProto.SettingsProto.IQuotaProto|null|undefined} quota
                 * @memberof waiternow.common.LocationProto.SettingsProto
                 * @instance
                 */
                SettingsProto.prototype.quota = null;

                /**
                 * SettingsProto viewSettings.
                 * @member {waiternow.common.LocationProto.SettingsProto.IViewSettingsProto|null|undefined} viewSettings
                 * @memberof waiternow.common.LocationProto.SettingsProto
                 * @instance
                 */
                SettingsProto.prototype.viewSettings = null;

                /**
                 * SettingsProto externalLinks.
                 * @member {waiternow.common.LocationProto.SettingsProto.IExternalLinksProto|null|undefined} externalLinks
                 * @memberof waiternow.common.LocationProto.SettingsProto
                 * @instance
                 */
                SettingsProto.prototype.externalLinks = null;

                /**
                 * SettingsProto operationSettings.
                 * @member {waiternow.common.LocationProto.SettingsProto.IOperationSettingsProto|null|undefined} operationSettings
                 * @memberof waiternow.common.LocationProto.SettingsProto
                 * @instance
                 */
                SettingsProto.prototype.operationSettings = null;

                /**
                 * Creates a new SettingsProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.LocationProto.SettingsProto
                 * @static
                 * @param {waiternow.common.LocationProto.ISettingsProto=} [properties] Properties to set
                 * @returns {waiternow.common.LocationProto.SettingsProto} SettingsProto instance
                 */
                SettingsProto.create = function create(properties) {
                    return new SettingsProto(properties);
                };

                /**
                 * Encodes the specified SettingsProto message. Does not implicitly {@link waiternow.common.LocationProto.SettingsProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.LocationProto.SettingsProto
                 * @static
                 * @param {waiternow.common.LocationProto.ISettingsProto} message SettingsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SettingsProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.imageMenu != null && Object.hasOwnProperty.call(message, "imageMenu"))
                        $root.waiternow.common.ImageMenuProto.encode(message.imageMenu, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.localeSettings != null && Object.hasOwnProperty.call(message, "localeSettings"))
                        $root.waiternow.common.LocationProto.SettingsProto.LocaleSettingsProto.encode(message.localeSettings, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.quota != null && Object.hasOwnProperty.call(message, "quota"))
                        $root.waiternow.common.LocationProto.SettingsProto.QuotaProto.encode(message.quota, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.viewSettings != null && Object.hasOwnProperty.call(message, "viewSettings"))
                        $root.waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.encode(message.viewSettings, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.externalLinks != null && Object.hasOwnProperty.call(message, "externalLinks"))
                        $root.waiternow.common.LocationProto.SettingsProto.ExternalLinksProto.encode(message.externalLinks, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.operationSettings != null && Object.hasOwnProperty.call(message, "operationSettings"))
                        $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.encode(message.operationSettings, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified SettingsProto message, length delimited. Does not implicitly {@link waiternow.common.LocationProto.SettingsProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.LocationProto.SettingsProto
                 * @static
                 * @param {waiternow.common.LocationProto.ISettingsProto} message SettingsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SettingsProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SettingsProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.LocationProto.SettingsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.LocationProto.SettingsProto} SettingsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SettingsProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.LocationProto.SettingsProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.imageMenu = $root.waiternow.common.ImageMenuProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.localeSettings = $root.waiternow.common.LocationProto.SettingsProto.LocaleSettingsProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.quota = $root.waiternow.common.LocationProto.SettingsProto.QuotaProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 4: {
                                message.viewSettings = $root.waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 5: {
                                message.externalLinks = $root.waiternow.common.LocationProto.SettingsProto.ExternalLinksProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 6: {
                                message.operationSettings = $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SettingsProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.LocationProto.SettingsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.LocationProto.SettingsProto} SettingsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SettingsProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SettingsProto message.
                 * @function verify
                 * @memberof waiternow.common.LocationProto.SettingsProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SettingsProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.imageMenu != null && message.hasOwnProperty("imageMenu")) {
                        var error = $root.waiternow.common.ImageMenuProto.verify(message.imageMenu);
                        if (error)
                            return "imageMenu." + error;
                    }
                    if (message.localeSettings != null && message.hasOwnProperty("localeSettings")) {
                        var error = $root.waiternow.common.LocationProto.SettingsProto.LocaleSettingsProto.verify(message.localeSettings);
                        if (error)
                            return "localeSettings." + error;
                    }
                    if (message.quota != null && message.hasOwnProperty("quota")) {
                        var error = $root.waiternow.common.LocationProto.SettingsProto.QuotaProto.verify(message.quota);
                        if (error)
                            return "quota." + error;
                    }
                    if (message.viewSettings != null && message.hasOwnProperty("viewSettings")) {
                        var error = $root.waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.verify(message.viewSettings);
                        if (error)
                            return "viewSettings." + error;
                    }
                    if (message.externalLinks != null && message.hasOwnProperty("externalLinks")) {
                        var error = $root.waiternow.common.LocationProto.SettingsProto.ExternalLinksProto.verify(message.externalLinks);
                        if (error)
                            return "externalLinks." + error;
                    }
                    if (message.operationSettings != null && message.hasOwnProperty("operationSettings")) {
                        var error = $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.verify(message.operationSettings);
                        if (error)
                            return "operationSettings." + error;
                    }
                    return null;
                };

                /**
                 * Creates a SettingsProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.LocationProto.SettingsProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.LocationProto.SettingsProto} SettingsProto
                 */
                SettingsProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.LocationProto.SettingsProto)
                        return object;
                    var message = new $root.waiternow.common.LocationProto.SettingsProto();
                    if (object.imageMenu != null) {
                        if (typeof object.imageMenu !== "object")
                            throw TypeError(".waiternow.common.LocationProto.SettingsProto.imageMenu: object expected");
                        message.imageMenu = $root.waiternow.common.ImageMenuProto.fromObject(object.imageMenu);
                    }
                    if (object.localeSettings != null) {
                        if (typeof object.localeSettings !== "object")
                            throw TypeError(".waiternow.common.LocationProto.SettingsProto.localeSettings: object expected");
                        message.localeSettings = $root.waiternow.common.LocationProto.SettingsProto.LocaleSettingsProto.fromObject(object.localeSettings);
                    }
                    if (object.quota != null) {
                        if (typeof object.quota !== "object")
                            throw TypeError(".waiternow.common.LocationProto.SettingsProto.quota: object expected");
                        message.quota = $root.waiternow.common.LocationProto.SettingsProto.QuotaProto.fromObject(object.quota);
                    }
                    if (object.viewSettings != null) {
                        if (typeof object.viewSettings !== "object")
                            throw TypeError(".waiternow.common.LocationProto.SettingsProto.viewSettings: object expected");
                        message.viewSettings = $root.waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.fromObject(object.viewSettings);
                    }
                    if (object.externalLinks != null) {
                        if (typeof object.externalLinks !== "object")
                            throw TypeError(".waiternow.common.LocationProto.SettingsProto.externalLinks: object expected");
                        message.externalLinks = $root.waiternow.common.LocationProto.SettingsProto.ExternalLinksProto.fromObject(object.externalLinks);
                    }
                    if (object.operationSettings != null) {
                        if (typeof object.operationSettings !== "object")
                            throw TypeError(".waiternow.common.LocationProto.SettingsProto.operationSettings: object expected");
                        message.operationSettings = $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.fromObject(object.operationSettings);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SettingsProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.LocationProto.SettingsProto
                 * @static
                 * @param {waiternow.common.LocationProto.SettingsProto} message SettingsProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SettingsProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.imageMenu = null;
                        object.localeSettings = null;
                        object.quota = null;
                        object.viewSettings = null;
                        object.externalLinks = null;
                        object.operationSettings = null;
                    }
                    if (message.imageMenu != null && message.hasOwnProperty("imageMenu"))
                        object.imageMenu = $root.waiternow.common.ImageMenuProto.toObject(message.imageMenu, options);
                    if (message.localeSettings != null && message.hasOwnProperty("localeSettings"))
                        object.localeSettings = $root.waiternow.common.LocationProto.SettingsProto.LocaleSettingsProto.toObject(message.localeSettings, options);
                    if (message.quota != null && message.hasOwnProperty("quota"))
                        object.quota = $root.waiternow.common.LocationProto.SettingsProto.QuotaProto.toObject(message.quota, options);
                    if (message.viewSettings != null && message.hasOwnProperty("viewSettings"))
                        object.viewSettings = $root.waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.toObject(message.viewSettings, options);
                    if (message.externalLinks != null && message.hasOwnProperty("externalLinks"))
                        object.externalLinks = $root.waiternow.common.LocationProto.SettingsProto.ExternalLinksProto.toObject(message.externalLinks, options);
                    if (message.operationSettings != null && message.hasOwnProperty("operationSettings"))
                        object.operationSettings = $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.toObject(message.operationSettings, options);
                    return object;
                };

                /**
                 * Converts this SettingsProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.LocationProto.SettingsProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SettingsProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for SettingsProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.LocationProto.SettingsProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                SettingsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.LocationProto.SettingsProto";
                };

                SettingsProto.LocaleSettingsProto = (function() {

                    /**
                     * Properties of a LocaleSettingsProto.
                     * @memberof waiternow.common.LocationProto.SettingsProto
                     * @interface ILocaleSettingsProto
                     * @property {waiternow.common.Language|null} [language] LocaleSettingsProto language
                     * @property {string|null} [currencyCode] LocaleSettingsProto currencyCode
                     * @property {string|null} [timeZone] LocaleSettingsProto timeZone
                     */

                    /**
                     * Constructs a new LocaleSettingsProto.
                     * @memberof waiternow.common.LocationProto.SettingsProto
                     * @classdesc Represents a LocaleSettingsProto.
                     * @implements ILocaleSettingsProto
                     * @constructor
                     * @param {waiternow.common.LocationProto.SettingsProto.ILocaleSettingsProto=} [properties] Properties to set
                     */
                    function LocaleSettingsProto(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * LocaleSettingsProto language.
                     * @member {waiternow.common.Language} language
                     * @memberof waiternow.common.LocationProto.SettingsProto.LocaleSettingsProto
                     * @instance
                     */
                    LocaleSettingsProto.prototype.language = 0;

                    /**
                     * LocaleSettingsProto currencyCode.
                     * @member {string} currencyCode
                     * @memberof waiternow.common.LocationProto.SettingsProto.LocaleSettingsProto
                     * @instance
                     */
                    LocaleSettingsProto.prototype.currencyCode = "";

                    /**
                     * LocaleSettingsProto timeZone.
                     * @member {string} timeZone
                     * @memberof waiternow.common.LocationProto.SettingsProto.LocaleSettingsProto
                     * @instance
                     */
                    LocaleSettingsProto.prototype.timeZone = "";

                    /**
                     * Creates a new LocaleSettingsProto instance using the specified properties.
                     * @function create
                     * @memberof waiternow.common.LocationProto.SettingsProto.LocaleSettingsProto
                     * @static
                     * @param {waiternow.common.LocationProto.SettingsProto.ILocaleSettingsProto=} [properties] Properties to set
                     * @returns {waiternow.common.LocationProto.SettingsProto.LocaleSettingsProto} LocaleSettingsProto instance
                     */
                    LocaleSettingsProto.create = function create(properties) {
                        return new LocaleSettingsProto(properties);
                    };

                    /**
                     * Encodes the specified LocaleSettingsProto message. Does not implicitly {@link waiternow.common.LocationProto.SettingsProto.LocaleSettingsProto.verify|verify} messages.
                     * @function encode
                     * @memberof waiternow.common.LocationProto.SettingsProto.LocaleSettingsProto
                     * @static
                     * @param {waiternow.common.LocationProto.SettingsProto.ILocaleSettingsProto} message LocaleSettingsProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    LocaleSettingsProto.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.language != null && Object.hasOwnProperty.call(message, "language"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.language);
                        if (message.currencyCode != null && Object.hasOwnProperty.call(message, "currencyCode"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.currencyCode);
                        if (message.timeZone != null && Object.hasOwnProperty.call(message, "timeZone"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.timeZone);
                        return writer;
                    };

                    /**
                     * Encodes the specified LocaleSettingsProto message, length delimited. Does not implicitly {@link waiternow.common.LocationProto.SettingsProto.LocaleSettingsProto.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof waiternow.common.LocationProto.SettingsProto.LocaleSettingsProto
                     * @static
                     * @param {waiternow.common.LocationProto.SettingsProto.ILocaleSettingsProto} message LocaleSettingsProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    LocaleSettingsProto.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a LocaleSettingsProto message from the specified reader or buffer.
                     * @function decode
                     * @memberof waiternow.common.LocationProto.SettingsProto.LocaleSettingsProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {waiternow.common.LocationProto.SettingsProto.LocaleSettingsProto} LocaleSettingsProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    LocaleSettingsProto.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.LocationProto.SettingsProto.LocaleSettingsProto();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.language = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.currencyCode = reader.string();
                                    break;
                                }
                            case 3: {
                                    message.timeZone = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a LocaleSettingsProto message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof waiternow.common.LocationProto.SettingsProto.LocaleSettingsProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {waiternow.common.LocationProto.SettingsProto.LocaleSettingsProto} LocaleSettingsProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    LocaleSettingsProto.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a LocaleSettingsProto message.
                     * @function verify
                     * @memberof waiternow.common.LocationProto.SettingsProto.LocaleSettingsProto
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    LocaleSettingsProto.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.language != null && message.hasOwnProperty("language"))
                            switch (message.language) {
                            default:
                                return "language: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.currencyCode != null && message.hasOwnProperty("currencyCode"))
                            if (!$util.isString(message.currencyCode))
                                return "currencyCode: string expected";
                        if (message.timeZone != null && message.hasOwnProperty("timeZone"))
                            if (!$util.isString(message.timeZone))
                                return "timeZone: string expected";
                        return null;
                    };

                    /**
                     * Creates a LocaleSettingsProto message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof waiternow.common.LocationProto.SettingsProto.LocaleSettingsProto
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {waiternow.common.LocationProto.SettingsProto.LocaleSettingsProto} LocaleSettingsProto
                     */
                    LocaleSettingsProto.fromObject = function fromObject(object) {
                        if (object instanceof $root.waiternow.common.LocationProto.SettingsProto.LocaleSettingsProto)
                            return object;
                        var message = new $root.waiternow.common.LocationProto.SettingsProto.LocaleSettingsProto();
                        switch (object.language) {
                        default:
                            if (typeof object.language === "number") {
                                message.language = object.language;
                                break;
                            }
                            break;
                        case "LANGUAGE_UNSPECIFIED":
                        case 0:
                            message.language = 0;
                            break;
                        case "ENGLISH":
                        case 1:
                            message.language = 1;
                            break;
                        case "SPANISH":
                        case 2:
                            message.language = 2;
                            break;
                        }
                        if (object.currencyCode != null)
                            message.currencyCode = String(object.currencyCode);
                        if (object.timeZone != null)
                            message.timeZone = String(object.timeZone);
                        return message;
                    };

                    /**
                     * Creates a plain object from a LocaleSettingsProto message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof waiternow.common.LocationProto.SettingsProto.LocaleSettingsProto
                     * @static
                     * @param {waiternow.common.LocationProto.SettingsProto.LocaleSettingsProto} message LocaleSettingsProto
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    LocaleSettingsProto.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.language = options.enums === String ? "LANGUAGE_UNSPECIFIED" : 0;
                            object.currencyCode = "";
                            object.timeZone = "";
                        }
                        if (message.language != null && message.hasOwnProperty("language"))
                            object.language = options.enums === String ? $root.waiternow.common.Language[message.language] === undefined ? message.language : $root.waiternow.common.Language[message.language] : message.language;
                        if (message.currencyCode != null && message.hasOwnProperty("currencyCode"))
                            object.currencyCode = message.currencyCode;
                        if (message.timeZone != null && message.hasOwnProperty("timeZone"))
                            object.timeZone = message.timeZone;
                        return object;
                    };

                    /**
                     * Converts this LocaleSettingsProto to JSON.
                     * @function toJSON
                     * @memberof waiternow.common.LocationProto.SettingsProto.LocaleSettingsProto
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    LocaleSettingsProto.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for LocaleSettingsProto
                     * @function getTypeUrl
                     * @memberof waiternow.common.LocationProto.SettingsProto.LocaleSettingsProto
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    LocaleSettingsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/waiternow.common.LocationProto.SettingsProto.LocaleSettingsProto";
                    };

                    return LocaleSettingsProto;
                })();

                SettingsProto.QuotaProto = (function() {

                    /**
                     * Properties of a QuotaProto.
                     * @memberof waiternow.common.LocationProto.SettingsProto
                     * @interface IQuotaProto
                     * @property {waiternow.common.IMoneyProto|null} [monthlyBudget] QuotaProto monthlyBudget
                     */

                    /**
                     * Constructs a new QuotaProto.
                     * @memberof waiternow.common.LocationProto.SettingsProto
                     * @classdesc Represents a QuotaProto.
                     * @implements IQuotaProto
                     * @constructor
                     * @param {waiternow.common.LocationProto.SettingsProto.IQuotaProto=} [properties] Properties to set
                     */
                    function QuotaProto(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * QuotaProto monthlyBudget.
                     * @member {waiternow.common.IMoneyProto|null|undefined} monthlyBudget
                     * @memberof waiternow.common.LocationProto.SettingsProto.QuotaProto
                     * @instance
                     */
                    QuotaProto.prototype.monthlyBudget = null;

                    /**
                     * Creates a new QuotaProto instance using the specified properties.
                     * @function create
                     * @memberof waiternow.common.LocationProto.SettingsProto.QuotaProto
                     * @static
                     * @param {waiternow.common.LocationProto.SettingsProto.IQuotaProto=} [properties] Properties to set
                     * @returns {waiternow.common.LocationProto.SettingsProto.QuotaProto} QuotaProto instance
                     */
                    QuotaProto.create = function create(properties) {
                        return new QuotaProto(properties);
                    };

                    /**
                     * Encodes the specified QuotaProto message. Does not implicitly {@link waiternow.common.LocationProto.SettingsProto.QuotaProto.verify|verify} messages.
                     * @function encode
                     * @memberof waiternow.common.LocationProto.SettingsProto.QuotaProto
                     * @static
                     * @param {waiternow.common.LocationProto.SettingsProto.IQuotaProto} message QuotaProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    QuotaProto.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.monthlyBudget != null && Object.hasOwnProperty.call(message, "monthlyBudget"))
                            $root.waiternow.common.MoneyProto.encode(message.monthlyBudget, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };

                    /**
                     * Encodes the specified QuotaProto message, length delimited. Does not implicitly {@link waiternow.common.LocationProto.SettingsProto.QuotaProto.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof waiternow.common.LocationProto.SettingsProto.QuotaProto
                     * @static
                     * @param {waiternow.common.LocationProto.SettingsProto.IQuotaProto} message QuotaProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    QuotaProto.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a QuotaProto message from the specified reader or buffer.
                     * @function decode
                     * @memberof waiternow.common.LocationProto.SettingsProto.QuotaProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {waiternow.common.LocationProto.SettingsProto.QuotaProto} QuotaProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    QuotaProto.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.LocationProto.SettingsProto.QuotaProto();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.monthlyBudget = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a QuotaProto message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof waiternow.common.LocationProto.SettingsProto.QuotaProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {waiternow.common.LocationProto.SettingsProto.QuotaProto} QuotaProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    QuotaProto.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a QuotaProto message.
                     * @function verify
                     * @memberof waiternow.common.LocationProto.SettingsProto.QuotaProto
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    QuotaProto.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.monthlyBudget != null && message.hasOwnProperty("monthlyBudget")) {
                            var error = $root.waiternow.common.MoneyProto.verify(message.monthlyBudget);
                            if (error)
                                return "monthlyBudget." + error;
                        }
                        return null;
                    };

                    /**
                     * Creates a QuotaProto message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof waiternow.common.LocationProto.SettingsProto.QuotaProto
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {waiternow.common.LocationProto.SettingsProto.QuotaProto} QuotaProto
                     */
                    QuotaProto.fromObject = function fromObject(object) {
                        if (object instanceof $root.waiternow.common.LocationProto.SettingsProto.QuotaProto)
                            return object;
                        var message = new $root.waiternow.common.LocationProto.SettingsProto.QuotaProto();
                        if (object.monthlyBudget != null) {
                            if (typeof object.monthlyBudget !== "object")
                                throw TypeError(".waiternow.common.LocationProto.SettingsProto.QuotaProto.monthlyBudget: object expected");
                            message.monthlyBudget = $root.waiternow.common.MoneyProto.fromObject(object.monthlyBudget);
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a QuotaProto message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof waiternow.common.LocationProto.SettingsProto.QuotaProto
                     * @static
                     * @param {waiternow.common.LocationProto.SettingsProto.QuotaProto} message QuotaProto
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    QuotaProto.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.monthlyBudget = null;
                        if (message.monthlyBudget != null && message.hasOwnProperty("monthlyBudget"))
                            object.monthlyBudget = $root.waiternow.common.MoneyProto.toObject(message.monthlyBudget, options);
                        return object;
                    };

                    /**
                     * Converts this QuotaProto to JSON.
                     * @function toJSON
                     * @memberof waiternow.common.LocationProto.SettingsProto.QuotaProto
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    QuotaProto.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for QuotaProto
                     * @function getTypeUrl
                     * @memberof waiternow.common.LocationProto.SettingsProto.QuotaProto
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    QuotaProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/waiternow.common.LocationProto.SettingsProto.QuotaProto";
                    };

                    return QuotaProto;
                })();

                SettingsProto.ViewSettingsProto = (function() {

                    /**
                     * Properties of a ViewSettingsProto.
                     * @memberof waiternow.common.LocationProto.SettingsProto
                     * @interface IViewSettingsProto
                     * @property {waiternow.common.Theme|null} [theme] ViewSettingsProto theme
                     * @property {waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.AppMode|null} [appMode] ViewSettingsProto appMode
                     * @property {waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.IColorPaletteProto|null} [colorPalette] ViewSettingsProto colorPalette
                     */

                    /**
                     * Constructs a new ViewSettingsProto.
                     * @memberof waiternow.common.LocationProto.SettingsProto
                     * @classdesc Represents a ViewSettingsProto.
                     * @implements IViewSettingsProto
                     * @constructor
                     * @param {waiternow.common.LocationProto.SettingsProto.IViewSettingsProto=} [properties] Properties to set
                     */
                    function ViewSettingsProto(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * ViewSettingsProto theme.
                     * @member {waiternow.common.Theme} theme
                     * @memberof waiternow.common.LocationProto.SettingsProto.ViewSettingsProto
                     * @instance
                     */
                    ViewSettingsProto.prototype.theme = 0;

                    /**
                     * ViewSettingsProto appMode.
                     * @member {waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.AppMode} appMode
                     * @memberof waiternow.common.LocationProto.SettingsProto.ViewSettingsProto
                     * @instance
                     */
                    ViewSettingsProto.prototype.appMode = 0;

                    /**
                     * ViewSettingsProto colorPalette.
                     * @member {waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.IColorPaletteProto|null|undefined} colorPalette
                     * @memberof waiternow.common.LocationProto.SettingsProto.ViewSettingsProto
                     * @instance
                     */
                    ViewSettingsProto.prototype.colorPalette = null;

                    /**
                     * Creates a new ViewSettingsProto instance using the specified properties.
                     * @function create
                     * @memberof waiternow.common.LocationProto.SettingsProto.ViewSettingsProto
                     * @static
                     * @param {waiternow.common.LocationProto.SettingsProto.IViewSettingsProto=} [properties] Properties to set
                     * @returns {waiternow.common.LocationProto.SettingsProto.ViewSettingsProto} ViewSettingsProto instance
                     */
                    ViewSettingsProto.create = function create(properties) {
                        return new ViewSettingsProto(properties);
                    };

                    /**
                     * Encodes the specified ViewSettingsProto message. Does not implicitly {@link waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.verify|verify} messages.
                     * @function encode
                     * @memberof waiternow.common.LocationProto.SettingsProto.ViewSettingsProto
                     * @static
                     * @param {waiternow.common.LocationProto.SettingsProto.IViewSettingsProto} message ViewSettingsProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ViewSettingsProto.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.theme != null && Object.hasOwnProperty.call(message, "theme"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.theme);
                        if (message.appMode != null && Object.hasOwnProperty.call(message, "appMode"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.appMode);
                        if (message.colorPalette != null && Object.hasOwnProperty.call(message, "colorPalette"))
                            $root.waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.ColorPaletteProto.encode(message.colorPalette, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        return writer;
                    };

                    /**
                     * Encodes the specified ViewSettingsProto message, length delimited. Does not implicitly {@link waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof waiternow.common.LocationProto.SettingsProto.ViewSettingsProto
                     * @static
                     * @param {waiternow.common.LocationProto.SettingsProto.IViewSettingsProto} message ViewSettingsProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ViewSettingsProto.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a ViewSettingsProto message from the specified reader or buffer.
                     * @function decode
                     * @memberof waiternow.common.LocationProto.SettingsProto.ViewSettingsProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {waiternow.common.LocationProto.SettingsProto.ViewSettingsProto} ViewSettingsProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ViewSettingsProto.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.LocationProto.SettingsProto.ViewSettingsProto();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.theme = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.appMode = reader.int32();
                                    break;
                                }
                            case 3: {
                                    message.colorPalette = $root.waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.ColorPaletteProto.decode(reader, reader.uint32());
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a ViewSettingsProto message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof waiternow.common.LocationProto.SettingsProto.ViewSettingsProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {waiternow.common.LocationProto.SettingsProto.ViewSettingsProto} ViewSettingsProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ViewSettingsProto.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a ViewSettingsProto message.
                     * @function verify
                     * @memberof waiternow.common.LocationProto.SettingsProto.ViewSettingsProto
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ViewSettingsProto.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.theme != null && message.hasOwnProperty("theme"))
                            switch (message.theme) {
                            default:
                                return "theme: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.appMode != null && message.hasOwnProperty("appMode"))
                            switch (message.appMode) {
                            default:
                                return "appMode: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.colorPalette != null && message.hasOwnProperty("colorPalette")) {
                            var error = $root.waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.ColorPaletteProto.verify(message.colorPalette);
                            if (error)
                                return "colorPalette." + error;
                        }
                        return null;
                    };

                    /**
                     * Creates a ViewSettingsProto message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof waiternow.common.LocationProto.SettingsProto.ViewSettingsProto
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {waiternow.common.LocationProto.SettingsProto.ViewSettingsProto} ViewSettingsProto
                     */
                    ViewSettingsProto.fromObject = function fromObject(object) {
                        if (object instanceof $root.waiternow.common.LocationProto.SettingsProto.ViewSettingsProto)
                            return object;
                        var message = new $root.waiternow.common.LocationProto.SettingsProto.ViewSettingsProto();
                        switch (object.theme) {
                        default:
                            if (typeof object.theme === "number") {
                                message.theme = object.theme;
                                break;
                            }
                            break;
                        case "THEME_UNSPECIFIED":
                        case 0:
                            message.theme = 0;
                            break;
                        case "DARK":
                        case 1:
                            message.theme = 1;
                            break;
                        case "LIGHT":
                        case 2:
                            message.theme = 2;
                            break;
                        }
                        switch (object.appMode) {
                        default:
                            if (typeof object.appMode === "number") {
                                message.appMode = object.appMode;
                                break;
                            }
                            break;
                        case "APP_MODE_UNSPECIFIED":
                        case 0:
                            message.appMode = 0;
                            break;
                        case "FULL":
                        case 1:
                            message.appMode = 1;
                            break;
                        case "REQUEST_WAITER_ONLY":
                        case 2:
                            message.appMode = 2;
                            break;
                        }
                        if (object.colorPalette != null) {
                            if (typeof object.colorPalette !== "object")
                                throw TypeError(".waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.colorPalette: object expected");
                            message.colorPalette = $root.waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.ColorPaletteProto.fromObject(object.colorPalette);
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a ViewSettingsProto message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof waiternow.common.LocationProto.SettingsProto.ViewSettingsProto
                     * @static
                     * @param {waiternow.common.LocationProto.SettingsProto.ViewSettingsProto} message ViewSettingsProto
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ViewSettingsProto.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.theme = options.enums === String ? "THEME_UNSPECIFIED" : 0;
                            object.appMode = options.enums === String ? "APP_MODE_UNSPECIFIED" : 0;
                            object.colorPalette = null;
                        }
                        if (message.theme != null && message.hasOwnProperty("theme"))
                            object.theme = options.enums === String ? $root.waiternow.common.Theme[message.theme] === undefined ? message.theme : $root.waiternow.common.Theme[message.theme] : message.theme;
                        if (message.appMode != null && message.hasOwnProperty("appMode"))
                            object.appMode = options.enums === String ? $root.waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.AppMode[message.appMode] === undefined ? message.appMode : $root.waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.AppMode[message.appMode] : message.appMode;
                        if (message.colorPalette != null && message.hasOwnProperty("colorPalette"))
                            object.colorPalette = $root.waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.ColorPaletteProto.toObject(message.colorPalette, options);
                        return object;
                    };

                    /**
                     * Converts this ViewSettingsProto to JSON.
                     * @function toJSON
                     * @memberof waiternow.common.LocationProto.SettingsProto.ViewSettingsProto
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ViewSettingsProto.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for ViewSettingsProto
                     * @function getTypeUrl
                     * @memberof waiternow.common.LocationProto.SettingsProto.ViewSettingsProto
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    ViewSettingsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/waiternow.common.LocationProto.SettingsProto.ViewSettingsProto";
                    };

                    /**
                     * AppMode enum.
                     * @name waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.AppMode
                     * @enum {number}
                     * @property {number} APP_MODE_UNSPECIFIED=0 APP_MODE_UNSPECIFIED value
                     * @property {number} FULL=1 FULL value
                     * @property {number} REQUEST_WAITER_ONLY=2 REQUEST_WAITER_ONLY value
                     */
                    ViewSettingsProto.AppMode = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "APP_MODE_UNSPECIFIED"] = 0;
                        values[valuesById[1] = "FULL"] = 1;
                        values[valuesById[2] = "REQUEST_WAITER_ONLY"] = 2;
                        return values;
                    })();

                    ViewSettingsProto.ColorPaletteProto = (function() {

                        /**
                         * Properties of a ColorPaletteProto.
                         * @memberof waiternow.common.LocationProto.SettingsProto.ViewSettingsProto
                         * @interface IColorPaletteProto
                         * @property {string|null} [background] ColorPaletteProto background
                         * @property {string|null} [contrast] ColorPaletteProto contrast
                         * @property {string|null} [buttonBackground] ColorPaletteProto buttonBackground
                         * @property {string|null} [iconLine] ColorPaletteProto iconLine
                         * @property {string|null} [disabledIconLine] ColorPaletteProto disabledIconLine
                         * @property {string|null} [buttonStatusLine] ColorPaletteProto buttonStatusLine
                         * @property {string|null} [warningMessage] ColorPaletteProto warningMessage
                         */

                        /**
                         * Constructs a new ColorPaletteProto.
                         * @memberof waiternow.common.LocationProto.SettingsProto.ViewSettingsProto
                         * @classdesc Represents a ColorPaletteProto.
                         * @implements IColorPaletteProto
                         * @constructor
                         * @param {waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.IColorPaletteProto=} [properties] Properties to set
                         */
                        function ColorPaletteProto(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * ColorPaletteProto background.
                         * @member {string} background
                         * @memberof waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.ColorPaletteProto
                         * @instance
                         */
                        ColorPaletteProto.prototype.background = "";

                        /**
                         * ColorPaletteProto contrast.
                         * @member {string} contrast
                         * @memberof waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.ColorPaletteProto
                         * @instance
                         */
                        ColorPaletteProto.prototype.contrast = "";

                        /**
                         * ColorPaletteProto buttonBackground.
                         * @member {string} buttonBackground
                         * @memberof waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.ColorPaletteProto
                         * @instance
                         */
                        ColorPaletteProto.prototype.buttonBackground = "";

                        /**
                         * ColorPaletteProto iconLine.
                         * @member {string} iconLine
                         * @memberof waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.ColorPaletteProto
                         * @instance
                         */
                        ColorPaletteProto.prototype.iconLine = "";

                        /**
                         * ColorPaletteProto disabledIconLine.
                         * @member {string} disabledIconLine
                         * @memberof waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.ColorPaletteProto
                         * @instance
                         */
                        ColorPaletteProto.prototype.disabledIconLine = "";

                        /**
                         * ColorPaletteProto buttonStatusLine.
                         * @member {string} buttonStatusLine
                         * @memberof waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.ColorPaletteProto
                         * @instance
                         */
                        ColorPaletteProto.prototype.buttonStatusLine = "";

                        /**
                         * ColorPaletteProto warningMessage.
                         * @member {string} warningMessage
                         * @memberof waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.ColorPaletteProto
                         * @instance
                         */
                        ColorPaletteProto.prototype.warningMessage = "";

                        /**
                         * Creates a new ColorPaletteProto instance using the specified properties.
                         * @function create
                         * @memberof waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.ColorPaletteProto
                         * @static
                         * @param {waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.IColorPaletteProto=} [properties] Properties to set
                         * @returns {waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.ColorPaletteProto} ColorPaletteProto instance
                         */
                        ColorPaletteProto.create = function create(properties) {
                            return new ColorPaletteProto(properties);
                        };

                        /**
                         * Encodes the specified ColorPaletteProto message. Does not implicitly {@link waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.ColorPaletteProto.verify|verify} messages.
                         * @function encode
                         * @memberof waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.ColorPaletteProto
                         * @static
                         * @param {waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.IColorPaletteProto} message ColorPaletteProto message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ColorPaletteProto.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.background != null && Object.hasOwnProperty.call(message, "background"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.background);
                            if (message.contrast != null && Object.hasOwnProperty.call(message, "contrast"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.contrast);
                            if (message.buttonBackground != null && Object.hasOwnProperty.call(message, "buttonBackground"))
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.buttonBackground);
                            if (message.iconLine != null && Object.hasOwnProperty.call(message, "iconLine"))
                                writer.uint32(/* id 4, wireType 2 =*/34).string(message.iconLine);
                            if (message.disabledIconLine != null && Object.hasOwnProperty.call(message, "disabledIconLine"))
                                writer.uint32(/* id 5, wireType 2 =*/42).string(message.disabledIconLine);
                            if (message.buttonStatusLine != null && Object.hasOwnProperty.call(message, "buttonStatusLine"))
                                writer.uint32(/* id 6, wireType 2 =*/50).string(message.buttonStatusLine);
                            if (message.warningMessage != null && Object.hasOwnProperty.call(message, "warningMessage"))
                                writer.uint32(/* id 7, wireType 2 =*/58).string(message.warningMessage);
                            return writer;
                        };

                        /**
                         * Encodes the specified ColorPaletteProto message, length delimited. Does not implicitly {@link waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.ColorPaletteProto.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.ColorPaletteProto
                         * @static
                         * @param {waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.IColorPaletteProto} message ColorPaletteProto message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ColorPaletteProto.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a ColorPaletteProto message from the specified reader or buffer.
                         * @function decode
                         * @memberof waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.ColorPaletteProto
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.ColorPaletteProto} ColorPaletteProto
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ColorPaletteProto.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.ColorPaletteProto();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1: {
                                        message.background = reader.string();
                                        break;
                                    }
                                case 2: {
                                        message.contrast = reader.string();
                                        break;
                                    }
                                case 3: {
                                        message.buttonBackground = reader.string();
                                        break;
                                    }
                                case 4: {
                                        message.iconLine = reader.string();
                                        break;
                                    }
                                case 5: {
                                        message.disabledIconLine = reader.string();
                                        break;
                                    }
                                case 6: {
                                        message.buttonStatusLine = reader.string();
                                        break;
                                    }
                                case 7: {
                                        message.warningMessage = reader.string();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a ColorPaletteProto message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.ColorPaletteProto
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.ColorPaletteProto} ColorPaletteProto
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ColorPaletteProto.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a ColorPaletteProto message.
                         * @function verify
                         * @memberof waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.ColorPaletteProto
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        ColorPaletteProto.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.background != null && message.hasOwnProperty("background"))
                                if (!$util.isString(message.background))
                                    return "background: string expected";
                            if (message.contrast != null && message.hasOwnProperty("contrast"))
                                if (!$util.isString(message.contrast))
                                    return "contrast: string expected";
                            if (message.buttonBackground != null && message.hasOwnProperty("buttonBackground"))
                                if (!$util.isString(message.buttonBackground))
                                    return "buttonBackground: string expected";
                            if (message.iconLine != null && message.hasOwnProperty("iconLine"))
                                if (!$util.isString(message.iconLine))
                                    return "iconLine: string expected";
                            if (message.disabledIconLine != null && message.hasOwnProperty("disabledIconLine"))
                                if (!$util.isString(message.disabledIconLine))
                                    return "disabledIconLine: string expected";
                            if (message.buttonStatusLine != null && message.hasOwnProperty("buttonStatusLine"))
                                if (!$util.isString(message.buttonStatusLine))
                                    return "buttonStatusLine: string expected";
                            if (message.warningMessage != null && message.hasOwnProperty("warningMessage"))
                                if (!$util.isString(message.warningMessage))
                                    return "warningMessage: string expected";
                            return null;
                        };

                        /**
                         * Creates a ColorPaletteProto message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.ColorPaletteProto
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.ColorPaletteProto} ColorPaletteProto
                         */
                        ColorPaletteProto.fromObject = function fromObject(object) {
                            if (object instanceof $root.waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.ColorPaletteProto)
                                return object;
                            var message = new $root.waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.ColorPaletteProto();
                            if (object.background != null)
                                message.background = String(object.background);
                            if (object.contrast != null)
                                message.contrast = String(object.contrast);
                            if (object.buttonBackground != null)
                                message.buttonBackground = String(object.buttonBackground);
                            if (object.iconLine != null)
                                message.iconLine = String(object.iconLine);
                            if (object.disabledIconLine != null)
                                message.disabledIconLine = String(object.disabledIconLine);
                            if (object.buttonStatusLine != null)
                                message.buttonStatusLine = String(object.buttonStatusLine);
                            if (object.warningMessage != null)
                                message.warningMessage = String(object.warningMessage);
                            return message;
                        };

                        /**
                         * Creates a plain object from a ColorPaletteProto message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.ColorPaletteProto
                         * @static
                         * @param {waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.ColorPaletteProto} message ColorPaletteProto
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        ColorPaletteProto.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.background = "";
                                object.contrast = "";
                                object.buttonBackground = "";
                                object.iconLine = "";
                                object.disabledIconLine = "";
                                object.buttonStatusLine = "";
                                object.warningMessage = "";
                            }
                            if (message.background != null && message.hasOwnProperty("background"))
                                object.background = message.background;
                            if (message.contrast != null && message.hasOwnProperty("contrast"))
                                object.contrast = message.contrast;
                            if (message.buttonBackground != null && message.hasOwnProperty("buttonBackground"))
                                object.buttonBackground = message.buttonBackground;
                            if (message.iconLine != null && message.hasOwnProperty("iconLine"))
                                object.iconLine = message.iconLine;
                            if (message.disabledIconLine != null && message.hasOwnProperty("disabledIconLine"))
                                object.disabledIconLine = message.disabledIconLine;
                            if (message.buttonStatusLine != null && message.hasOwnProperty("buttonStatusLine"))
                                object.buttonStatusLine = message.buttonStatusLine;
                            if (message.warningMessage != null && message.hasOwnProperty("warningMessage"))
                                object.warningMessage = message.warningMessage;
                            return object;
                        };

                        /**
                         * Converts this ColorPaletteProto to JSON.
                         * @function toJSON
                         * @memberof waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.ColorPaletteProto
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        ColorPaletteProto.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for ColorPaletteProto
                         * @function getTypeUrl
                         * @memberof waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.ColorPaletteProto
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        ColorPaletteProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.ColorPaletteProto";
                        };

                        return ColorPaletteProto;
                    })();

                    return ViewSettingsProto;
                })();

                SettingsProto.ExternalLinksProto = (function() {

                    /**
                     * Properties of an ExternalLinksProto.
                     * @memberof waiternow.common.LocationProto.SettingsProto
                     * @interface IExternalLinksProto
                     * @property {string|null} [website] ExternalLinksProto website
                     * @property {string|null} [youtube] ExternalLinksProto youtube
                     * @property {string|null} [facebook] ExternalLinksProto facebook
                     * @property {string|null} [instagram] ExternalLinksProto instagram
                     * @property {string|null} [twitter] ExternalLinksProto twitter
                     * @property {string|null} [linkedIn] ExternalLinksProto linkedIn
                     * @property {string|null} [tiktok] ExternalLinksProto tiktok
                     */

                    /**
                     * Constructs a new ExternalLinksProto.
                     * @memberof waiternow.common.LocationProto.SettingsProto
                     * @classdesc Represents an ExternalLinksProto.
                     * @implements IExternalLinksProto
                     * @constructor
                     * @param {waiternow.common.LocationProto.SettingsProto.IExternalLinksProto=} [properties] Properties to set
                     */
                    function ExternalLinksProto(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * ExternalLinksProto website.
                     * @member {string} website
                     * @memberof waiternow.common.LocationProto.SettingsProto.ExternalLinksProto
                     * @instance
                     */
                    ExternalLinksProto.prototype.website = "";

                    /**
                     * ExternalLinksProto youtube.
                     * @member {string} youtube
                     * @memberof waiternow.common.LocationProto.SettingsProto.ExternalLinksProto
                     * @instance
                     */
                    ExternalLinksProto.prototype.youtube = "";

                    /**
                     * ExternalLinksProto facebook.
                     * @member {string} facebook
                     * @memberof waiternow.common.LocationProto.SettingsProto.ExternalLinksProto
                     * @instance
                     */
                    ExternalLinksProto.prototype.facebook = "";

                    /**
                     * ExternalLinksProto instagram.
                     * @member {string} instagram
                     * @memberof waiternow.common.LocationProto.SettingsProto.ExternalLinksProto
                     * @instance
                     */
                    ExternalLinksProto.prototype.instagram = "";

                    /**
                     * ExternalLinksProto twitter.
                     * @member {string} twitter
                     * @memberof waiternow.common.LocationProto.SettingsProto.ExternalLinksProto
                     * @instance
                     */
                    ExternalLinksProto.prototype.twitter = "";

                    /**
                     * ExternalLinksProto linkedIn.
                     * @member {string} linkedIn
                     * @memberof waiternow.common.LocationProto.SettingsProto.ExternalLinksProto
                     * @instance
                     */
                    ExternalLinksProto.prototype.linkedIn = "";

                    /**
                     * ExternalLinksProto tiktok.
                     * @member {string} tiktok
                     * @memberof waiternow.common.LocationProto.SettingsProto.ExternalLinksProto
                     * @instance
                     */
                    ExternalLinksProto.prototype.tiktok = "";

                    /**
                     * Creates a new ExternalLinksProto instance using the specified properties.
                     * @function create
                     * @memberof waiternow.common.LocationProto.SettingsProto.ExternalLinksProto
                     * @static
                     * @param {waiternow.common.LocationProto.SettingsProto.IExternalLinksProto=} [properties] Properties to set
                     * @returns {waiternow.common.LocationProto.SettingsProto.ExternalLinksProto} ExternalLinksProto instance
                     */
                    ExternalLinksProto.create = function create(properties) {
                        return new ExternalLinksProto(properties);
                    };

                    /**
                     * Encodes the specified ExternalLinksProto message. Does not implicitly {@link waiternow.common.LocationProto.SettingsProto.ExternalLinksProto.verify|verify} messages.
                     * @function encode
                     * @memberof waiternow.common.LocationProto.SettingsProto.ExternalLinksProto
                     * @static
                     * @param {waiternow.common.LocationProto.SettingsProto.IExternalLinksProto} message ExternalLinksProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExternalLinksProto.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.website != null && Object.hasOwnProperty.call(message, "website"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.website);
                        if (message.youtube != null && Object.hasOwnProperty.call(message, "youtube"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.youtube);
                        if (message.facebook != null && Object.hasOwnProperty.call(message, "facebook"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.facebook);
                        if (message.instagram != null && Object.hasOwnProperty.call(message, "instagram"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.instagram);
                        if (message.twitter != null && Object.hasOwnProperty.call(message, "twitter"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.twitter);
                        if (message.linkedIn != null && Object.hasOwnProperty.call(message, "linkedIn"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.linkedIn);
                        if (message.tiktok != null && Object.hasOwnProperty.call(message, "tiktok"))
                            writer.uint32(/* id 7, wireType 2 =*/58).string(message.tiktok);
                        return writer;
                    };

                    /**
                     * Encodes the specified ExternalLinksProto message, length delimited. Does not implicitly {@link waiternow.common.LocationProto.SettingsProto.ExternalLinksProto.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof waiternow.common.LocationProto.SettingsProto.ExternalLinksProto
                     * @static
                     * @param {waiternow.common.LocationProto.SettingsProto.IExternalLinksProto} message ExternalLinksProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExternalLinksProto.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an ExternalLinksProto message from the specified reader or buffer.
                     * @function decode
                     * @memberof waiternow.common.LocationProto.SettingsProto.ExternalLinksProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {waiternow.common.LocationProto.SettingsProto.ExternalLinksProto} ExternalLinksProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExternalLinksProto.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.LocationProto.SettingsProto.ExternalLinksProto();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.website = reader.string();
                                    break;
                                }
                            case 2: {
                                    message.youtube = reader.string();
                                    break;
                                }
                            case 3: {
                                    message.facebook = reader.string();
                                    break;
                                }
                            case 4: {
                                    message.instagram = reader.string();
                                    break;
                                }
                            case 5: {
                                    message.twitter = reader.string();
                                    break;
                                }
                            case 6: {
                                    message.linkedIn = reader.string();
                                    break;
                                }
                            case 7: {
                                    message.tiktok = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an ExternalLinksProto message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof waiternow.common.LocationProto.SettingsProto.ExternalLinksProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {waiternow.common.LocationProto.SettingsProto.ExternalLinksProto} ExternalLinksProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExternalLinksProto.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an ExternalLinksProto message.
                     * @function verify
                     * @memberof waiternow.common.LocationProto.SettingsProto.ExternalLinksProto
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ExternalLinksProto.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.website != null && message.hasOwnProperty("website"))
                            if (!$util.isString(message.website))
                                return "website: string expected";
                        if (message.youtube != null && message.hasOwnProperty("youtube"))
                            if (!$util.isString(message.youtube))
                                return "youtube: string expected";
                        if (message.facebook != null && message.hasOwnProperty("facebook"))
                            if (!$util.isString(message.facebook))
                                return "facebook: string expected";
                        if (message.instagram != null && message.hasOwnProperty("instagram"))
                            if (!$util.isString(message.instagram))
                                return "instagram: string expected";
                        if (message.twitter != null && message.hasOwnProperty("twitter"))
                            if (!$util.isString(message.twitter))
                                return "twitter: string expected";
                        if (message.linkedIn != null && message.hasOwnProperty("linkedIn"))
                            if (!$util.isString(message.linkedIn))
                                return "linkedIn: string expected";
                        if (message.tiktok != null && message.hasOwnProperty("tiktok"))
                            if (!$util.isString(message.tiktok))
                                return "tiktok: string expected";
                        return null;
                    };

                    /**
                     * Creates an ExternalLinksProto message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof waiternow.common.LocationProto.SettingsProto.ExternalLinksProto
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {waiternow.common.LocationProto.SettingsProto.ExternalLinksProto} ExternalLinksProto
                     */
                    ExternalLinksProto.fromObject = function fromObject(object) {
                        if (object instanceof $root.waiternow.common.LocationProto.SettingsProto.ExternalLinksProto)
                            return object;
                        var message = new $root.waiternow.common.LocationProto.SettingsProto.ExternalLinksProto();
                        if (object.website != null)
                            message.website = String(object.website);
                        if (object.youtube != null)
                            message.youtube = String(object.youtube);
                        if (object.facebook != null)
                            message.facebook = String(object.facebook);
                        if (object.instagram != null)
                            message.instagram = String(object.instagram);
                        if (object.twitter != null)
                            message.twitter = String(object.twitter);
                        if (object.linkedIn != null)
                            message.linkedIn = String(object.linkedIn);
                        if (object.tiktok != null)
                            message.tiktok = String(object.tiktok);
                        return message;
                    };

                    /**
                     * Creates a plain object from an ExternalLinksProto message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof waiternow.common.LocationProto.SettingsProto.ExternalLinksProto
                     * @static
                     * @param {waiternow.common.LocationProto.SettingsProto.ExternalLinksProto} message ExternalLinksProto
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ExternalLinksProto.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.website = "";
                            object.youtube = "";
                            object.facebook = "";
                            object.instagram = "";
                            object.twitter = "";
                            object.linkedIn = "";
                            object.tiktok = "";
                        }
                        if (message.website != null && message.hasOwnProperty("website"))
                            object.website = message.website;
                        if (message.youtube != null && message.hasOwnProperty("youtube"))
                            object.youtube = message.youtube;
                        if (message.facebook != null && message.hasOwnProperty("facebook"))
                            object.facebook = message.facebook;
                        if (message.instagram != null && message.hasOwnProperty("instagram"))
                            object.instagram = message.instagram;
                        if (message.twitter != null && message.hasOwnProperty("twitter"))
                            object.twitter = message.twitter;
                        if (message.linkedIn != null && message.hasOwnProperty("linkedIn"))
                            object.linkedIn = message.linkedIn;
                        if (message.tiktok != null && message.hasOwnProperty("tiktok"))
                            object.tiktok = message.tiktok;
                        return object;
                    };

                    /**
                     * Converts this ExternalLinksProto to JSON.
                     * @function toJSON
                     * @memberof waiternow.common.LocationProto.SettingsProto.ExternalLinksProto
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ExternalLinksProto.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for ExternalLinksProto
                     * @function getTypeUrl
                     * @memberof waiternow.common.LocationProto.SettingsProto.ExternalLinksProto
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    ExternalLinksProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/waiternow.common.LocationProto.SettingsProto.ExternalLinksProto";
                    };

                    return ExternalLinksProto;
                })();

                SettingsProto.OperationSettingsProto = (function() {

                    /**
                     * Properties of an OperationSettingsProto.
                     * @memberof waiternow.common.LocationProto.SettingsProto
                     * @interface IOperationSettingsProto
                     * @property {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.IEnabledFeaturesProto|null} [enabledFeatures] OperationSettingsProto enabledFeatures
                     * @property {waiternow.common.ITaxesProto|null} [taxes] OperationSettingsProto taxes
                     * @property {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.IStripeAccountProto|null} [stripeAccount] OperationSettingsProto stripeAccount
                     * @property {Array.<waiternow.common.IPrinterProto>|null} [printers] OperationSettingsProto printers
                     * @property {waiternow.common.IDerivedQuantityConfigProto|null} [orderPaymentWaiterNowFee] OperationSettingsProto orderPaymentWaiterNowFee
                     * @property {waiternow.common.IBusinessHoursProto|null} [businessHours] OperationSettingsProto businessHours
                     * @property {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.IAlertConfigProto|null} [alertConfig] OperationSettingsProto alertConfig
                     * @property {google.protobuf.IDuration|null} [orderPreparationDuration] OperationSettingsProto orderPreparationDuration
                     * @property {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.IDeliveryConfigProto|null} [deliveryConfig] OperationSettingsProto deliveryConfig
                     */

                    /**
                     * Constructs a new OperationSettingsProto.
                     * @memberof waiternow.common.LocationProto.SettingsProto
                     * @classdesc Represents an OperationSettingsProto.
                     * @implements IOperationSettingsProto
                     * @constructor
                     * @param {waiternow.common.LocationProto.SettingsProto.IOperationSettingsProto=} [properties] Properties to set
                     */
                    function OperationSettingsProto(properties) {
                        this.printers = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * OperationSettingsProto enabledFeatures.
                     * @member {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.IEnabledFeaturesProto|null|undefined} enabledFeatures
                     * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto
                     * @instance
                     */
                    OperationSettingsProto.prototype.enabledFeatures = null;

                    /**
                     * OperationSettingsProto taxes.
                     * @member {waiternow.common.ITaxesProto|null|undefined} taxes
                     * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto
                     * @instance
                     */
                    OperationSettingsProto.prototype.taxes = null;

                    /**
                     * OperationSettingsProto stripeAccount.
                     * @member {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.IStripeAccountProto|null|undefined} stripeAccount
                     * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto
                     * @instance
                     */
                    OperationSettingsProto.prototype.stripeAccount = null;

                    /**
                     * OperationSettingsProto printers.
                     * @member {Array.<waiternow.common.IPrinterProto>} printers
                     * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto
                     * @instance
                     */
                    OperationSettingsProto.prototype.printers = $util.emptyArray;

                    /**
                     * OperationSettingsProto orderPaymentWaiterNowFee.
                     * @member {waiternow.common.IDerivedQuantityConfigProto|null|undefined} orderPaymentWaiterNowFee
                     * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto
                     * @instance
                     */
                    OperationSettingsProto.prototype.orderPaymentWaiterNowFee = null;

                    /**
                     * OperationSettingsProto businessHours.
                     * @member {waiternow.common.IBusinessHoursProto|null|undefined} businessHours
                     * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto
                     * @instance
                     */
                    OperationSettingsProto.prototype.businessHours = null;

                    /**
                     * OperationSettingsProto alertConfig.
                     * @member {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.IAlertConfigProto|null|undefined} alertConfig
                     * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto
                     * @instance
                     */
                    OperationSettingsProto.prototype.alertConfig = null;

                    /**
                     * OperationSettingsProto orderPreparationDuration.
                     * @member {google.protobuf.IDuration|null|undefined} orderPreparationDuration
                     * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto
                     * @instance
                     */
                    OperationSettingsProto.prototype.orderPreparationDuration = null;

                    /**
                     * OperationSettingsProto deliveryConfig.
                     * @member {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.IDeliveryConfigProto|null|undefined} deliveryConfig
                     * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto
                     * @instance
                     */
                    OperationSettingsProto.prototype.deliveryConfig = null;

                    /**
                     * Creates a new OperationSettingsProto instance using the specified properties.
                     * @function create
                     * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto
                     * @static
                     * @param {waiternow.common.LocationProto.SettingsProto.IOperationSettingsProto=} [properties] Properties to set
                     * @returns {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto} OperationSettingsProto instance
                     */
                    OperationSettingsProto.create = function create(properties) {
                        return new OperationSettingsProto(properties);
                    };

                    /**
                     * Encodes the specified OperationSettingsProto message. Does not implicitly {@link waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.verify|verify} messages.
                     * @function encode
                     * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto
                     * @static
                     * @param {waiternow.common.LocationProto.SettingsProto.IOperationSettingsProto} message OperationSettingsProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    OperationSettingsProto.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.enabledFeatures != null && Object.hasOwnProperty.call(message, "enabledFeatures"))
                            $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.EnabledFeaturesProto.encode(message.enabledFeatures, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.taxes != null && Object.hasOwnProperty.call(message, "taxes"))
                            $root.waiternow.common.TaxesProto.encode(message.taxes, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.stripeAccount != null && Object.hasOwnProperty.call(message, "stripeAccount"))
                            $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.StripeAccountProto.encode(message.stripeAccount, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.printers != null && message.printers.length)
                            for (var i = 0; i < message.printers.length; ++i)
                                $root.waiternow.common.PrinterProto.encode(message.printers[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        if (message.orderPaymentWaiterNowFee != null && Object.hasOwnProperty.call(message, "orderPaymentWaiterNowFee"))
                            $root.waiternow.common.DerivedQuantityConfigProto.encode(message.orderPaymentWaiterNowFee, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        if (message.businessHours != null && Object.hasOwnProperty.call(message, "businessHours"))
                            $root.waiternow.common.BusinessHoursProto.encode(message.businessHours, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                        if (message.alertConfig != null && Object.hasOwnProperty.call(message, "alertConfig"))
                            $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.AlertConfigProto.encode(message.alertConfig, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                        if (message.orderPreparationDuration != null && Object.hasOwnProperty.call(message, "orderPreparationDuration"))
                            $root.google.protobuf.Duration.encode(message.orderPreparationDuration, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                        if (message.deliveryConfig != null && Object.hasOwnProperty.call(message, "deliveryConfig"))
                            $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto.encode(message.deliveryConfig, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                        return writer;
                    };

                    /**
                     * Encodes the specified OperationSettingsProto message, length delimited. Does not implicitly {@link waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto
                     * @static
                     * @param {waiternow.common.LocationProto.SettingsProto.IOperationSettingsProto} message OperationSettingsProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    OperationSettingsProto.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an OperationSettingsProto message from the specified reader or buffer.
                     * @function decode
                     * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto} OperationSettingsProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    OperationSettingsProto.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.enabledFeatures = $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.EnabledFeaturesProto.decode(reader, reader.uint32());
                                    break;
                                }
                            case 2: {
                                    message.taxes = $root.waiternow.common.TaxesProto.decode(reader, reader.uint32());
                                    break;
                                }
                            case 3: {
                                    message.stripeAccount = $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.StripeAccountProto.decode(reader, reader.uint32());
                                    break;
                                }
                            case 4: {
                                    if (!(message.printers && message.printers.length))
                                        message.printers = [];
                                    message.printers.push($root.waiternow.common.PrinterProto.decode(reader, reader.uint32()));
                                    break;
                                }
                            case 5: {
                                    message.orderPaymentWaiterNowFee = $root.waiternow.common.DerivedQuantityConfigProto.decode(reader, reader.uint32());
                                    break;
                                }
                            case 6: {
                                    message.businessHours = $root.waiternow.common.BusinessHoursProto.decode(reader, reader.uint32());
                                    break;
                                }
                            case 7: {
                                    message.alertConfig = $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.AlertConfigProto.decode(reader, reader.uint32());
                                    break;
                                }
                            case 8: {
                                    message.orderPreparationDuration = $root.google.protobuf.Duration.decode(reader, reader.uint32());
                                    break;
                                }
                            case 9: {
                                    message.deliveryConfig = $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto.decode(reader, reader.uint32());
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an OperationSettingsProto message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto} OperationSettingsProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    OperationSettingsProto.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an OperationSettingsProto message.
                     * @function verify
                     * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    OperationSettingsProto.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.enabledFeatures != null && message.hasOwnProperty("enabledFeatures")) {
                            var error = $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.EnabledFeaturesProto.verify(message.enabledFeatures);
                            if (error)
                                return "enabledFeatures." + error;
                        }
                        if (message.taxes != null && message.hasOwnProperty("taxes")) {
                            var error = $root.waiternow.common.TaxesProto.verify(message.taxes);
                            if (error)
                                return "taxes." + error;
                        }
                        if (message.stripeAccount != null && message.hasOwnProperty("stripeAccount")) {
                            var error = $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.StripeAccountProto.verify(message.stripeAccount);
                            if (error)
                                return "stripeAccount." + error;
                        }
                        if (message.printers != null && message.hasOwnProperty("printers")) {
                            if (!Array.isArray(message.printers))
                                return "printers: array expected";
                            for (var i = 0; i < message.printers.length; ++i) {
                                var error = $root.waiternow.common.PrinterProto.verify(message.printers[i]);
                                if (error)
                                    return "printers." + error;
                            }
                        }
                        if (message.orderPaymentWaiterNowFee != null && message.hasOwnProperty("orderPaymentWaiterNowFee")) {
                            var error = $root.waiternow.common.DerivedQuantityConfigProto.verify(message.orderPaymentWaiterNowFee);
                            if (error)
                                return "orderPaymentWaiterNowFee." + error;
                        }
                        if (message.businessHours != null && message.hasOwnProperty("businessHours")) {
                            var error = $root.waiternow.common.BusinessHoursProto.verify(message.businessHours);
                            if (error)
                                return "businessHours." + error;
                        }
                        if (message.alertConfig != null && message.hasOwnProperty("alertConfig")) {
                            var error = $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.AlertConfigProto.verify(message.alertConfig);
                            if (error)
                                return "alertConfig." + error;
                        }
                        if (message.orderPreparationDuration != null && message.hasOwnProperty("orderPreparationDuration")) {
                            var error = $root.google.protobuf.Duration.verify(message.orderPreparationDuration);
                            if (error)
                                return "orderPreparationDuration." + error;
                        }
                        if (message.deliveryConfig != null && message.hasOwnProperty("deliveryConfig")) {
                            var error = $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto.verify(message.deliveryConfig);
                            if (error)
                                return "deliveryConfig." + error;
                        }
                        return null;
                    };

                    /**
                     * Creates an OperationSettingsProto message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto} OperationSettingsProto
                     */
                    OperationSettingsProto.fromObject = function fromObject(object) {
                        if (object instanceof $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto)
                            return object;
                        var message = new $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto();
                        if (object.enabledFeatures != null) {
                            if (typeof object.enabledFeatures !== "object")
                                throw TypeError(".waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.enabledFeatures: object expected");
                            message.enabledFeatures = $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.EnabledFeaturesProto.fromObject(object.enabledFeatures);
                        }
                        if (object.taxes != null) {
                            if (typeof object.taxes !== "object")
                                throw TypeError(".waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.taxes: object expected");
                            message.taxes = $root.waiternow.common.TaxesProto.fromObject(object.taxes);
                        }
                        if (object.stripeAccount != null) {
                            if (typeof object.stripeAccount !== "object")
                                throw TypeError(".waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.stripeAccount: object expected");
                            message.stripeAccount = $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.StripeAccountProto.fromObject(object.stripeAccount);
                        }
                        if (object.printers) {
                            if (!Array.isArray(object.printers))
                                throw TypeError(".waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.printers: array expected");
                            message.printers = [];
                            for (var i = 0; i < object.printers.length; ++i) {
                                if (typeof object.printers[i] !== "object")
                                    throw TypeError(".waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.printers: object expected");
                                message.printers[i] = $root.waiternow.common.PrinterProto.fromObject(object.printers[i]);
                            }
                        }
                        if (object.orderPaymentWaiterNowFee != null) {
                            if (typeof object.orderPaymentWaiterNowFee !== "object")
                                throw TypeError(".waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.orderPaymentWaiterNowFee: object expected");
                            message.orderPaymentWaiterNowFee = $root.waiternow.common.DerivedQuantityConfigProto.fromObject(object.orderPaymentWaiterNowFee);
                        }
                        if (object.businessHours != null) {
                            if (typeof object.businessHours !== "object")
                                throw TypeError(".waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.businessHours: object expected");
                            message.businessHours = $root.waiternow.common.BusinessHoursProto.fromObject(object.businessHours);
                        }
                        if (object.alertConfig != null) {
                            if (typeof object.alertConfig !== "object")
                                throw TypeError(".waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.alertConfig: object expected");
                            message.alertConfig = $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.AlertConfigProto.fromObject(object.alertConfig);
                        }
                        if (object.orderPreparationDuration != null) {
                            if (typeof object.orderPreparationDuration !== "object")
                                throw TypeError(".waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.orderPreparationDuration: object expected");
                            message.orderPreparationDuration = $root.google.protobuf.Duration.fromObject(object.orderPreparationDuration);
                        }
                        if (object.deliveryConfig != null) {
                            if (typeof object.deliveryConfig !== "object")
                                throw TypeError(".waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.deliveryConfig: object expected");
                            message.deliveryConfig = $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto.fromObject(object.deliveryConfig);
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from an OperationSettingsProto message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto
                     * @static
                     * @param {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto} message OperationSettingsProto
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    OperationSettingsProto.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.printers = [];
                        if (options.defaults) {
                            object.enabledFeatures = null;
                            object.taxes = null;
                            object.stripeAccount = null;
                            object.orderPaymentWaiterNowFee = null;
                            object.businessHours = null;
                            object.alertConfig = null;
                            object.orderPreparationDuration = null;
                            object.deliveryConfig = null;
                        }
                        if (message.enabledFeatures != null && message.hasOwnProperty("enabledFeatures"))
                            object.enabledFeatures = $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.EnabledFeaturesProto.toObject(message.enabledFeatures, options);
                        if (message.taxes != null && message.hasOwnProperty("taxes"))
                            object.taxes = $root.waiternow.common.TaxesProto.toObject(message.taxes, options);
                        if (message.stripeAccount != null && message.hasOwnProperty("stripeAccount"))
                            object.stripeAccount = $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.StripeAccountProto.toObject(message.stripeAccount, options);
                        if (message.printers && message.printers.length) {
                            object.printers = [];
                            for (var j = 0; j < message.printers.length; ++j)
                                object.printers[j] = $root.waiternow.common.PrinterProto.toObject(message.printers[j], options);
                        }
                        if (message.orderPaymentWaiterNowFee != null && message.hasOwnProperty("orderPaymentWaiterNowFee"))
                            object.orderPaymentWaiterNowFee = $root.waiternow.common.DerivedQuantityConfigProto.toObject(message.orderPaymentWaiterNowFee, options);
                        if (message.businessHours != null && message.hasOwnProperty("businessHours"))
                            object.businessHours = $root.waiternow.common.BusinessHoursProto.toObject(message.businessHours, options);
                        if (message.alertConfig != null && message.hasOwnProperty("alertConfig"))
                            object.alertConfig = $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.AlertConfigProto.toObject(message.alertConfig, options);
                        if (message.orderPreparationDuration != null && message.hasOwnProperty("orderPreparationDuration"))
                            object.orderPreparationDuration = $root.google.protobuf.Duration.toObject(message.orderPreparationDuration, options);
                        if (message.deliveryConfig != null && message.hasOwnProperty("deliveryConfig"))
                            object.deliveryConfig = $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto.toObject(message.deliveryConfig, options);
                        return object;
                    };

                    /**
                     * Converts this OperationSettingsProto to JSON.
                     * @function toJSON
                     * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    OperationSettingsProto.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for OperationSettingsProto
                     * @function getTypeUrl
                     * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    OperationSettingsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/waiternow.common.LocationProto.SettingsProto.OperationSettingsProto";
                    };

                    OperationSettingsProto.EnabledFeaturesProto = (function() {

                        /**
                         * Properties of an EnabledFeaturesProto.
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto
                         * @interface IEnabledFeaturesProto
                         * @property {boolean|null} [isPaymentRequiredForOrders] EnabledFeaturesProto isPaymentRequiredForOrders
                         * @property {boolean|null} [isPokeWaiterDisabled] EnabledFeaturesProto isPokeWaiterDisabled
                         * @property {boolean|null} [isMenuDisabled] EnabledFeaturesProto isMenuDisabled
                         * @property {boolean|null} [isImageMenuDisabled] EnabledFeaturesProto isImageMenuDisabled
                         * @property {boolean|null} [isMessageWaiterDisabled] EnabledFeaturesProto isMessageWaiterDisabled
                         * @property {boolean|null} [isAskForCheckDisabled] EnabledFeaturesProto isAskForCheckDisabled
                         * @property {boolean|null} [isSpecialInstructionsDisabled] EnabledFeaturesProto isSpecialInstructionsDisabled
                         * @property {boolean|null} [isCompletedStatusSupportedForPaidOrders] EnabledFeaturesProto isCompletedStatusSupportedForPaidOrders
                         * @property {boolean|null} [isOnsiteTipsDisabled] EnabledFeaturesProto isOnsiteTipsDisabled
                         * @property {boolean|null} [isOnlineTipsDisabled] EnabledFeaturesProto isOnlineTipsDisabled
                         * @property {boolean|null} [isOnlinePickupTipsEnabled] EnabledFeaturesProto isOnlinePickupTipsEnabled
                         * @property {boolean|null} [isDeliveryDisabled] EnabledFeaturesProto isDeliveryDisabled
                         * @property {boolean|null} [chargeCreditCardFeeToConsumer] EnabledFeaturesProto chargeCreditCardFeeToConsumer
                         * @property {boolean|null} [isAlcoholForOnlinePickupAllowed] EnabledFeaturesProto isAlcoholForOnlinePickupAllowed
                         * @property {boolean|null} [isAlcoholForDeliveryAllowed] EnabledFeaturesProto isAlcoholForDeliveryAllowed
                         * @property {boolean|null} [printOrderAndReceipt] EnabledFeaturesProto printOrderAndReceipt
                         * @property {boolean|null} [isOrderForLaterDisabled] EnabledFeaturesProto isOrderForLaterDisabled
                         * @property {boolean|null} [isOrderForLaterDayDisabled] EnabledFeaturesProto isOrderForLaterDayDisabled
                         * @property {boolean|null} [isSmsOnNewOrdersForBusinessWebEnabled] EnabledFeaturesProto isSmsOnNewOrdersForBusinessWebEnabled
                         * @property {boolean|null} [expandQuantityForPrintedOrders] EnabledFeaturesProto expandQuantityForPrintedOrders
                         * @property {boolean|null} [isBusinessAutoStartSessionEnabled] EnabledFeaturesProto isBusinessAutoStartSessionEnabled
                         */

                        /**
                         * Constructs a new EnabledFeaturesProto.
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto
                         * @classdesc Represents an EnabledFeaturesProto.
                         * @implements IEnabledFeaturesProto
                         * @constructor
                         * @param {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.IEnabledFeaturesProto=} [properties] Properties to set
                         */
                        function EnabledFeaturesProto(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * EnabledFeaturesProto isPaymentRequiredForOrders.
                         * @member {boolean} isPaymentRequiredForOrders
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.EnabledFeaturesProto
                         * @instance
                         */
                        EnabledFeaturesProto.prototype.isPaymentRequiredForOrders = false;

                        /**
                         * EnabledFeaturesProto isPokeWaiterDisabled.
                         * @member {boolean} isPokeWaiterDisabled
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.EnabledFeaturesProto
                         * @instance
                         */
                        EnabledFeaturesProto.prototype.isPokeWaiterDisabled = false;

                        /**
                         * EnabledFeaturesProto isMenuDisabled.
                         * @member {boolean} isMenuDisabled
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.EnabledFeaturesProto
                         * @instance
                         */
                        EnabledFeaturesProto.prototype.isMenuDisabled = false;

                        /**
                         * EnabledFeaturesProto isImageMenuDisabled.
                         * @member {boolean} isImageMenuDisabled
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.EnabledFeaturesProto
                         * @instance
                         */
                        EnabledFeaturesProto.prototype.isImageMenuDisabled = false;

                        /**
                         * EnabledFeaturesProto isMessageWaiterDisabled.
                         * @member {boolean} isMessageWaiterDisabled
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.EnabledFeaturesProto
                         * @instance
                         */
                        EnabledFeaturesProto.prototype.isMessageWaiterDisabled = false;

                        /**
                         * EnabledFeaturesProto isAskForCheckDisabled.
                         * @member {boolean} isAskForCheckDisabled
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.EnabledFeaturesProto
                         * @instance
                         */
                        EnabledFeaturesProto.prototype.isAskForCheckDisabled = false;

                        /**
                         * EnabledFeaturesProto isSpecialInstructionsDisabled.
                         * @member {boolean} isSpecialInstructionsDisabled
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.EnabledFeaturesProto
                         * @instance
                         */
                        EnabledFeaturesProto.prototype.isSpecialInstructionsDisabled = false;

                        /**
                         * EnabledFeaturesProto isCompletedStatusSupportedForPaidOrders.
                         * @member {boolean} isCompletedStatusSupportedForPaidOrders
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.EnabledFeaturesProto
                         * @instance
                         */
                        EnabledFeaturesProto.prototype.isCompletedStatusSupportedForPaidOrders = false;

                        /**
                         * EnabledFeaturesProto isOnsiteTipsDisabled.
                         * @member {boolean} isOnsiteTipsDisabled
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.EnabledFeaturesProto
                         * @instance
                         */
                        EnabledFeaturesProto.prototype.isOnsiteTipsDisabled = false;

                        /**
                         * EnabledFeaturesProto isOnlineTipsDisabled.
                         * @member {boolean} isOnlineTipsDisabled
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.EnabledFeaturesProto
                         * @instance
                         */
                        EnabledFeaturesProto.prototype.isOnlineTipsDisabled = false;

                        /**
                         * EnabledFeaturesProto isOnlinePickupTipsEnabled.
                         * @member {boolean} isOnlinePickupTipsEnabled
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.EnabledFeaturesProto
                         * @instance
                         */
                        EnabledFeaturesProto.prototype.isOnlinePickupTipsEnabled = false;

                        /**
                         * EnabledFeaturesProto isDeliveryDisabled.
                         * @member {boolean} isDeliveryDisabled
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.EnabledFeaturesProto
                         * @instance
                         */
                        EnabledFeaturesProto.prototype.isDeliveryDisabled = false;

                        /**
                         * EnabledFeaturesProto chargeCreditCardFeeToConsumer.
                         * @member {boolean} chargeCreditCardFeeToConsumer
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.EnabledFeaturesProto
                         * @instance
                         */
                        EnabledFeaturesProto.prototype.chargeCreditCardFeeToConsumer = false;

                        /**
                         * EnabledFeaturesProto isAlcoholForOnlinePickupAllowed.
                         * @member {boolean} isAlcoholForOnlinePickupAllowed
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.EnabledFeaturesProto
                         * @instance
                         */
                        EnabledFeaturesProto.prototype.isAlcoholForOnlinePickupAllowed = false;

                        /**
                         * EnabledFeaturesProto isAlcoholForDeliveryAllowed.
                         * @member {boolean} isAlcoholForDeliveryAllowed
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.EnabledFeaturesProto
                         * @instance
                         */
                        EnabledFeaturesProto.prototype.isAlcoholForDeliveryAllowed = false;

                        /**
                         * EnabledFeaturesProto printOrderAndReceipt.
                         * @member {boolean} printOrderAndReceipt
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.EnabledFeaturesProto
                         * @instance
                         */
                        EnabledFeaturesProto.prototype.printOrderAndReceipt = false;

                        /**
                         * EnabledFeaturesProto isOrderForLaterDisabled.
                         * @member {boolean} isOrderForLaterDisabled
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.EnabledFeaturesProto
                         * @instance
                         */
                        EnabledFeaturesProto.prototype.isOrderForLaterDisabled = false;

                        /**
                         * EnabledFeaturesProto isOrderForLaterDayDisabled.
                         * @member {boolean} isOrderForLaterDayDisabled
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.EnabledFeaturesProto
                         * @instance
                         */
                        EnabledFeaturesProto.prototype.isOrderForLaterDayDisabled = false;

                        /**
                         * EnabledFeaturesProto isSmsOnNewOrdersForBusinessWebEnabled.
                         * @member {boolean} isSmsOnNewOrdersForBusinessWebEnabled
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.EnabledFeaturesProto
                         * @instance
                         */
                        EnabledFeaturesProto.prototype.isSmsOnNewOrdersForBusinessWebEnabled = false;

                        /**
                         * EnabledFeaturesProto expandQuantityForPrintedOrders.
                         * @member {boolean} expandQuantityForPrintedOrders
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.EnabledFeaturesProto
                         * @instance
                         */
                        EnabledFeaturesProto.prototype.expandQuantityForPrintedOrders = false;

                        /**
                         * EnabledFeaturesProto isBusinessAutoStartSessionEnabled.
                         * @member {boolean} isBusinessAutoStartSessionEnabled
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.EnabledFeaturesProto
                         * @instance
                         */
                        EnabledFeaturesProto.prototype.isBusinessAutoStartSessionEnabled = false;

                        /**
                         * Creates a new EnabledFeaturesProto instance using the specified properties.
                         * @function create
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.EnabledFeaturesProto
                         * @static
                         * @param {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.IEnabledFeaturesProto=} [properties] Properties to set
                         * @returns {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.EnabledFeaturesProto} EnabledFeaturesProto instance
                         */
                        EnabledFeaturesProto.create = function create(properties) {
                            return new EnabledFeaturesProto(properties);
                        };

                        /**
                         * Encodes the specified EnabledFeaturesProto message. Does not implicitly {@link waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.EnabledFeaturesProto.verify|verify} messages.
                         * @function encode
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.EnabledFeaturesProto
                         * @static
                         * @param {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.IEnabledFeaturesProto} message EnabledFeaturesProto message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        EnabledFeaturesProto.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.isPaymentRequiredForOrders != null && Object.hasOwnProperty.call(message, "isPaymentRequiredForOrders"))
                                writer.uint32(/* id 1, wireType 0 =*/8).bool(message.isPaymentRequiredForOrders);
                            if (message.isPokeWaiterDisabled != null && Object.hasOwnProperty.call(message, "isPokeWaiterDisabled"))
                                writer.uint32(/* id 2, wireType 0 =*/16).bool(message.isPokeWaiterDisabled);
                            if (message.isMenuDisabled != null && Object.hasOwnProperty.call(message, "isMenuDisabled"))
                                writer.uint32(/* id 3, wireType 0 =*/24).bool(message.isMenuDisabled);
                            if (message.isImageMenuDisabled != null && Object.hasOwnProperty.call(message, "isImageMenuDisabled"))
                                writer.uint32(/* id 4, wireType 0 =*/32).bool(message.isImageMenuDisabled);
                            if (message.isMessageWaiterDisabled != null && Object.hasOwnProperty.call(message, "isMessageWaiterDisabled"))
                                writer.uint32(/* id 5, wireType 0 =*/40).bool(message.isMessageWaiterDisabled);
                            if (message.isAskForCheckDisabled != null && Object.hasOwnProperty.call(message, "isAskForCheckDisabled"))
                                writer.uint32(/* id 6, wireType 0 =*/48).bool(message.isAskForCheckDisabled);
                            if (message.isSpecialInstructionsDisabled != null && Object.hasOwnProperty.call(message, "isSpecialInstructionsDisabled"))
                                writer.uint32(/* id 7, wireType 0 =*/56).bool(message.isSpecialInstructionsDisabled);
                            if (message.isCompletedStatusSupportedForPaidOrders != null && Object.hasOwnProperty.call(message, "isCompletedStatusSupportedForPaidOrders"))
                                writer.uint32(/* id 8, wireType 0 =*/64).bool(message.isCompletedStatusSupportedForPaidOrders);
                            if (message.isOnsiteTipsDisabled != null && Object.hasOwnProperty.call(message, "isOnsiteTipsDisabled"))
                                writer.uint32(/* id 9, wireType 0 =*/72).bool(message.isOnsiteTipsDisabled);
                            if (message.isOnlineTipsDisabled != null && Object.hasOwnProperty.call(message, "isOnlineTipsDisabled"))
                                writer.uint32(/* id 10, wireType 0 =*/80).bool(message.isOnlineTipsDisabled);
                            if (message.isDeliveryDisabled != null && Object.hasOwnProperty.call(message, "isDeliveryDisabled"))
                                writer.uint32(/* id 11, wireType 0 =*/88).bool(message.isDeliveryDisabled);
                            if (message.chargeCreditCardFeeToConsumer != null && Object.hasOwnProperty.call(message, "chargeCreditCardFeeToConsumer"))
                                writer.uint32(/* id 12, wireType 0 =*/96).bool(message.chargeCreditCardFeeToConsumer);
                            if (message.isAlcoholForOnlinePickupAllowed != null && Object.hasOwnProperty.call(message, "isAlcoholForOnlinePickupAllowed"))
                                writer.uint32(/* id 13, wireType 0 =*/104).bool(message.isAlcoholForOnlinePickupAllowed);
                            if (message.isAlcoholForDeliveryAllowed != null && Object.hasOwnProperty.call(message, "isAlcoholForDeliveryAllowed"))
                                writer.uint32(/* id 14, wireType 0 =*/112).bool(message.isAlcoholForDeliveryAllowed);
                            if (message.printOrderAndReceipt != null && Object.hasOwnProperty.call(message, "printOrderAndReceipt"))
                                writer.uint32(/* id 15, wireType 0 =*/120).bool(message.printOrderAndReceipt);
                            if (message.isOrderForLaterDisabled != null && Object.hasOwnProperty.call(message, "isOrderForLaterDisabled"))
                                writer.uint32(/* id 16, wireType 0 =*/128).bool(message.isOrderForLaterDisabled);
                            if (message.isOrderForLaterDayDisabled != null && Object.hasOwnProperty.call(message, "isOrderForLaterDayDisabled"))
                                writer.uint32(/* id 17, wireType 0 =*/136).bool(message.isOrderForLaterDayDisabled);
                            if (message.isSmsOnNewOrdersForBusinessWebEnabled != null && Object.hasOwnProperty.call(message, "isSmsOnNewOrdersForBusinessWebEnabled"))
                                writer.uint32(/* id 18, wireType 0 =*/144).bool(message.isSmsOnNewOrdersForBusinessWebEnabled);
                            if (message.expandQuantityForPrintedOrders != null && Object.hasOwnProperty.call(message, "expandQuantityForPrintedOrders"))
                                writer.uint32(/* id 19, wireType 0 =*/152).bool(message.expandQuantityForPrintedOrders);
                            if (message.isOnlinePickupTipsEnabled != null && Object.hasOwnProperty.call(message, "isOnlinePickupTipsEnabled"))
                                writer.uint32(/* id 20, wireType 0 =*/160).bool(message.isOnlinePickupTipsEnabled);
                            if (message.isBusinessAutoStartSessionEnabled != null && Object.hasOwnProperty.call(message, "isBusinessAutoStartSessionEnabled"))
                                writer.uint32(/* id 21, wireType 0 =*/168).bool(message.isBusinessAutoStartSessionEnabled);
                            return writer;
                        };

                        /**
                         * Encodes the specified EnabledFeaturesProto message, length delimited. Does not implicitly {@link waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.EnabledFeaturesProto.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.EnabledFeaturesProto
                         * @static
                         * @param {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.IEnabledFeaturesProto} message EnabledFeaturesProto message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        EnabledFeaturesProto.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes an EnabledFeaturesProto message from the specified reader or buffer.
                         * @function decode
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.EnabledFeaturesProto
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.EnabledFeaturesProto} EnabledFeaturesProto
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        EnabledFeaturesProto.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.EnabledFeaturesProto();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1: {
                                        message.isPaymentRequiredForOrders = reader.bool();
                                        break;
                                    }
                                case 2: {
                                        message.isPokeWaiterDisabled = reader.bool();
                                        break;
                                    }
                                case 3: {
                                        message.isMenuDisabled = reader.bool();
                                        break;
                                    }
                                case 4: {
                                        message.isImageMenuDisabled = reader.bool();
                                        break;
                                    }
                                case 5: {
                                        message.isMessageWaiterDisabled = reader.bool();
                                        break;
                                    }
                                case 6: {
                                        message.isAskForCheckDisabled = reader.bool();
                                        break;
                                    }
                                case 7: {
                                        message.isSpecialInstructionsDisabled = reader.bool();
                                        break;
                                    }
                                case 8: {
                                        message.isCompletedStatusSupportedForPaidOrders = reader.bool();
                                        break;
                                    }
                                case 9: {
                                        message.isOnsiteTipsDisabled = reader.bool();
                                        break;
                                    }
                                case 10: {
                                        message.isOnlineTipsDisabled = reader.bool();
                                        break;
                                    }
                                case 20: {
                                        message.isOnlinePickupTipsEnabled = reader.bool();
                                        break;
                                    }
                                case 11: {
                                        message.isDeliveryDisabled = reader.bool();
                                        break;
                                    }
                                case 12: {
                                        message.chargeCreditCardFeeToConsumer = reader.bool();
                                        break;
                                    }
                                case 13: {
                                        message.isAlcoholForOnlinePickupAllowed = reader.bool();
                                        break;
                                    }
                                case 14: {
                                        message.isAlcoholForDeliveryAllowed = reader.bool();
                                        break;
                                    }
                                case 15: {
                                        message.printOrderAndReceipt = reader.bool();
                                        break;
                                    }
                                case 16: {
                                        message.isOrderForLaterDisabled = reader.bool();
                                        break;
                                    }
                                case 17: {
                                        message.isOrderForLaterDayDisabled = reader.bool();
                                        break;
                                    }
                                case 18: {
                                        message.isSmsOnNewOrdersForBusinessWebEnabled = reader.bool();
                                        break;
                                    }
                                case 19: {
                                        message.expandQuantityForPrintedOrders = reader.bool();
                                        break;
                                    }
                                case 21: {
                                        message.isBusinessAutoStartSessionEnabled = reader.bool();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes an EnabledFeaturesProto message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.EnabledFeaturesProto
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.EnabledFeaturesProto} EnabledFeaturesProto
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        EnabledFeaturesProto.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies an EnabledFeaturesProto message.
                         * @function verify
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.EnabledFeaturesProto
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        EnabledFeaturesProto.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.isPaymentRequiredForOrders != null && message.hasOwnProperty("isPaymentRequiredForOrders"))
                                if (typeof message.isPaymentRequiredForOrders !== "boolean")
                                    return "isPaymentRequiredForOrders: boolean expected";
                            if (message.isPokeWaiterDisabled != null && message.hasOwnProperty("isPokeWaiterDisabled"))
                                if (typeof message.isPokeWaiterDisabled !== "boolean")
                                    return "isPokeWaiterDisabled: boolean expected";
                            if (message.isMenuDisabled != null && message.hasOwnProperty("isMenuDisabled"))
                                if (typeof message.isMenuDisabled !== "boolean")
                                    return "isMenuDisabled: boolean expected";
                            if (message.isImageMenuDisabled != null && message.hasOwnProperty("isImageMenuDisabled"))
                                if (typeof message.isImageMenuDisabled !== "boolean")
                                    return "isImageMenuDisabled: boolean expected";
                            if (message.isMessageWaiterDisabled != null && message.hasOwnProperty("isMessageWaiterDisabled"))
                                if (typeof message.isMessageWaiterDisabled !== "boolean")
                                    return "isMessageWaiterDisabled: boolean expected";
                            if (message.isAskForCheckDisabled != null && message.hasOwnProperty("isAskForCheckDisabled"))
                                if (typeof message.isAskForCheckDisabled !== "boolean")
                                    return "isAskForCheckDisabled: boolean expected";
                            if (message.isSpecialInstructionsDisabled != null && message.hasOwnProperty("isSpecialInstructionsDisabled"))
                                if (typeof message.isSpecialInstructionsDisabled !== "boolean")
                                    return "isSpecialInstructionsDisabled: boolean expected";
                            if (message.isCompletedStatusSupportedForPaidOrders != null && message.hasOwnProperty("isCompletedStatusSupportedForPaidOrders"))
                                if (typeof message.isCompletedStatusSupportedForPaidOrders !== "boolean")
                                    return "isCompletedStatusSupportedForPaidOrders: boolean expected";
                            if (message.isOnsiteTipsDisabled != null && message.hasOwnProperty("isOnsiteTipsDisabled"))
                                if (typeof message.isOnsiteTipsDisabled !== "boolean")
                                    return "isOnsiteTipsDisabled: boolean expected";
                            if (message.isOnlineTipsDisabled != null && message.hasOwnProperty("isOnlineTipsDisabled"))
                                if (typeof message.isOnlineTipsDisabled !== "boolean")
                                    return "isOnlineTipsDisabled: boolean expected";
                            if (message.isOnlinePickupTipsEnabled != null && message.hasOwnProperty("isOnlinePickupTipsEnabled"))
                                if (typeof message.isOnlinePickupTipsEnabled !== "boolean")
                                    return "isOnlinePickupTipsEnabled: boolean expected";
                            if (message.isDeliveryDisabled != null && message.hasOwnProperty("isDeliveryDisabled"))
                                if (typeof message.isDeliveryDisabled !== "boolean")
                                    return "isDeliveryDisabled: boolean expected";
                            if (message.chargeCreditCardFeeToConsumer != null && message.hasOwnProperty("chargeCreditCardFeeToConsumer"))
                                if (typeof message.chargeCreditCardFeeToConsumer !== "boolean")
                                    return "chargeCreditCardFeeToConsumer: boolean expected";
                            if (message.isAlcoholForOnlinePickupAllowed != null && message.hasOwnProperty("isAlcoholForOnlinePickupAllowed"))
                                if (typeof message.isAlcoholForOnlinePickupAllowed !== "boolean")
                                    return "isAlcoholForOnlinePickupAllowed: boolean expected";
                            if (message.isAlcoholForDeliveryAllowed != null && message.hasOwnProperty("isAlcoholForDeliveryAllowed"))
                                if (typeof message.isAlcoholForDeliveryAllowed !== "boolean")
                                    return "isAlcoholForDeliveryAllowed: boolean expected";
                            if (message.printOrderAndReceipt != null && message.hasOwnProperty("printOrderAndReceipt"))
                                if (typeof message.printOrderAndReceipt !== "boolean")
                                    return "printOrderAndReceipt: boolean expected";
                            if (message.isOrderForLaterDisabled != null && message.hasOwnProperty("isOrderForLaterDisabled"))
                                if (typeof message.isOrderForLaterDisabled !== "boolean")
                                    return "isOrderForLaterDisabled: boolean expected";
                            if (message.isOrderForLaterDayDisabled != null && message.hasOwnProperty("isOrderForLaterDayDisabled"))
                                if (typeof message.isOrderForLaterDayDisabled !== "boolean")
                                    return "isOrderForLaterDayDisabled: boolean expected";
                            if (message.isSmsOnNewOrdersForBusinessWebEnabled != null && message.hasOwnProperty("isSmsOnNewOrdersForBusinessWebEnabled"))
                                if (typeof message.isSmsOnNewOrdersForBusinessWebEnabled !== "boolean")
                                    return "isSmsOnNewOrdersForBusinessWebEnabled: boolean expected";
                            if (message.expandQuantityForPrintedOrders != null && message.hasOwnProperty("expandQuantityForPrintedOrders"))
                                if (typeof message.expandQuantityForPrintedOrders !== "boolean")
                                    return "expandQuantityForPrintedOrders: boolean expected";
                            if (message.isBusinessAutoStartSessionEnabled != null && message.hasOwnProperty("isBusinessAutoStartSessionEnabled"))
                                if (typeof message.isBusinessAutoStartSessionEnabled !== "boolean")
                                    return "isBusinessAutoStartSessionEnabled: boolean expected";
                            return null;
                        };

                        /**
                         * Creates an EnabledFeaturesProto message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.EnabledFeaturesProto
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.EnabledFeaturesProto} EnabledFeaturesProto
                         */
                        EnabledFeaturesProto.fromObject = function fromObject(object) {
                            if (object instanceof $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.EnabledFeaturesProto)
                                return object;
                            var message = new $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.EnabledFeaturesProto();
                            if (object.isPaymentRequiredForOrders != null)
                                message.isPaymentRequiredForOrders = Boolean(object.isPaymentRequiredForOrders);
                            if (object.isPokeWaiterDisabled != null)
                                message.isPokeWaiterDisabled = Boolean(object.isPokeWaiterDisabled);
                            if (object.isMenuDisabled != null)
                                message.isMenuDisabled = Boolean(object.isMenuDisabled);
                            if (object.isImageMenuDisabled != null)
                                message.isImageMenuDisabled = Boolean(object.isImageMenuDisabled);
                            if (object.isMessageWaiterDisabled != null)
                                message.isMessageWaiterDisabled = Boolean(object.isMessageWaiterDisabled);
                            if (object.isAskForCheckDisabled != null)
                                message.isAskForCheckDisabled = Boolean(object.isAskForCheckDisabled);
                            if (object.isSpecialInstructionsDisabled != null)
                                message.isSpecialInstructionsDisabled = Boolean(object.isSpecialInstructionsDisabled);
                            if (object.isCompletedStatusSupportedForPaidOrders != null)
                                message.isCompletedStatusSupportedForPaidOrders = Boolean(object.isCompletedStatusSupportedForPaidOrders);
                            if (object.isOnsiteTipsDisabled != null)
                                message.isOnsiteTipsDisabled = Boolean(object.isOnsiteTipsDisabled);
                            if (object.isOnlineTipsDisabled != null)
                                message.isOnlineTipsDisabled = Boolean(object.isOnlineTipsDisabled);
                            if (object.isOnlinePickupTipsEnabled != null)
                                message.isOnlinePickupTipsEnabled = Boolean(object.isOnlinePickupTipsEnabled);
                            if (object.isDeliveryDisabled != null)
                                message.isDeliveryDisabled = Boolean(object.isDeliveryDisabled);
                            if (object.chargeCreditCardFeeToConsumer != null)
                                message.chargeCreditCardFeeToConsumer = Boolean(object.chargeCreditCardFeeToConsumer);
                            if (object.isAlcoholForOnlinePickupAllowed != null)
                                message.isAlcoholForOnlinePickupAllowed = Boolean(object.isAlcoholForOnlinePickupAllowed);
                            if (object.isAlcoholForDeliveryAllowed != null)
                                message.isAlcoholForDeliveryAllowed = Boolean(object.isAlcoholForDeliveryAllowed);
                            if (object.printOrderAndReceipt != null)
                                message.printOrderAndReceipt = Boolean(object.printOrderAndReceipt);
                            if (object.isOrderForLaterDisabled != null)
                                message.isOrderForLaterDisabled = Boolean(object.isOrderForLaterDisabled);
                            if (object.isOrderForLaterDayDisabled != null)
                                message.isOrderForLaterDayDisabled = Boolean(object.isOrderForLaterDayDisabled);
                            if (object.isSmsOnNewOrdersForBusinessWebEnabled != null)
                                message.isSmsOnNewOrdersForBusinessWebEnabled = Boolean(object.isSmsOnNewOrdersForBusinessWebEnabled);
                            if (object.expandQuantityForPrintedOrders != null)
                                message.expandQuantityForPrintedOrders = Boolean(object.expandQuantityForPrintedOrders);
                            if (object.isBusinessAutoStartSessionEnabled != null)
                                message.isBusinessAutoStartSessionEnabled = Boolean(object.isBusinessAutoStartSessionEnabled);
                            return message;
                        };

                        /**
                         * Creates a plain object from an EnabledFeaturesProto message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.EnabledFeaturesProto
                         * @static
                         * @param {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.EnabledFeaturesProto} message EnabledFeaturesProto
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        EnabledFeaturesProto.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.isPaymentRequiredForOrders = false;
                                object.isPokeWaiterDisabled = false;
                                object.isMenuDisabled = false;
                                object.isImageMenuDisabled = false;
                                object.isMessageWaiterDisabled = false;
                                object.isAskForCheckDisabled = false;
                                object.isSpecialInstructionsDisabled = false;
                                object.isCompletedStatusSupportedForPaidOrders = false;
                                object.isOnsiteTipsDisabled = false;
                                object.isOnlineTipsDisabled = false;
                                object.isDeliveryDisabled = false;
                                object.chargeCreditCardFeeToConsumer = false;
                                object.isAlcoholForOnlinePickupAllowed = false;
                                object.isAlcoholForDeliveryAllowed = false;
                                object.printOrderAndReceipt = false;
                                object.isOrderForLaterDisabled = false;
                                object.isOrderForLaterDayDisabled = false;
                                object.isSmsOnNewOrdersForBusinessWebEnabled = false;
                                object.expandQuantityForPrintedOrders = false;
                                object.isOnlinePickupTipsEnabled = false;
                                object.isBusinessAutoStartSessionEnabled = false;
                            }
                            if (message.isPaymentRequiredForOrders != null && message.hasOwnProperty("isPaymentRequiredForOrders"))
                                object.isPaymentRequiredForOrders = message.isPaymentRequiredForOrders;
                            if (message.isPokeWaiterDisabled != null && message.hasOwnProperty("isPokeWaiterDisabled"))
                                object.isPokeWaiterDisabled = message.isPokeWaiterDisabled;
                            if (message.isMenuDisabled != null && message.hasOwnProperty("isMenuDisabled"))
                                object.isMenuDisabled = message.isMenuDisabled;
                            if (message.isImageMenuDisabled != null && message.hasOwnProperty("isImageMenuDisabled"))
                                object.isImageMenuDisabled = message.isImageMenuDisabled;
                            if (message.isMessageWaiterDisabled != null && message.hasOwnProperty("isMessageWaiterDisabled"))
                                object.isMessageWaiterDisabled = message.isMessageWaiterDisabled;
                            if (message.isAskForCheckDisabled != null && message.hasOwnProperty("isAskForCheckDisabled"))
                                object.isAskForCheckDisabled = message.isAskForCheckDisabled;
                            if (message.isSpecialInstructionsDisabled != null && message.hasOwnProperty("isSpecialInstructionsDisabled"))
                                object.isSpecialInstructionsDisabled = message.isSpecialInstructionsDisabled;
                            if (message.isCompletedStatusSupportedForPaidOrders != null && message.hasOwnProperty("isCompletedStatusSupportedForPaidOrders"))
                                object.isCompletedStatusSupportedForPaidOrders = message.isCompletedStatusSupportedForPaidOrders;
                            if (message.isOnsiteTipsDisabled != null && message.hasOwnProperty("isOnsiteTipsDisabled"))
                                object.isOnsiteTipsDisabled = message.isOnsiteTipsDisabled;
                            if (message.isOnlineTipsDisabled != null && message.hasOwnProperty("isOnlineTipsDisabled"))
                                object.isOnlineTipsDisabled = message.isOnlineTipsDisabled;
                            if (message.isDeliveryDisabled != null && message.hasOwnProperty("isDeliveryDisabled"))
                                object.isDeliveryDisabled = message.isDeliveryDisabled;
                            if (message.chargeCreditCardFeeToConsumer != null && message.hasOwnProperty("chargeCreditCardFeeToConsumer"))
                                object.chargeCreditCardFeeToConsumer = message.chargeCreditCardFeeToConsumer;
                            if (message.isAlcoholForOnlinePickupAllowed != null && message.hasOwnProperty("isAlcoholForOnlinePickupAllowed"))
                                object.isAlcoholForOnlinePickupAllowed = message.isAlcoholForOnlinePickupAllowed;
                            if (message.isAlcoholForDeliveryAllowed != null && message.hasOwnProperty("isAlcoholForDeliveryAllowed"))
                                object.isAlcoholForDeliveryAllowed = message.isAlcoholForDeliveryAllowed;
                            if (message.printOrderAndReceipt != null && message.hasOwnProperty("printOrderAndReceipt"))
                                object.printOrderAndReceipt = message.printOrderAndReceipt;
                            if (message.isOrderForLaterDisabled != null && message.hasOwnProperty("isOrderForLaterDisabled"))
                                object.isOrderForLaterDisabled = message.isOrderForLaterDisabled;
                            if (message.isOrderForLaterDayDisabled != null && message.hasOwnProperty("isOrderForLaterDayDisabled"))
                                object.isOrderForLaterDayDisabled = message.isOrderForLaterDayDisabled;
                            if (message.isSmsOnNewOrdersForBusinessWebEnabled != null && message.hasOwnProperty("isSmsOnNewOrdersForBusinessWebEnabled"))
                                object.isSmsOnNewOrdersForBusinessWebEnabled = message.isSmsOnNewOrdersForBusinessWebEnabled;
                            if (message.expandQuantityForPrintedOrders != null && message.hasOwnProperty("expandQuantityForPrintedOrders"))
                                object.expandQuantityForPrintedOrders = message.expandQuantityForPrintedOrders;
                            if (message.isOnlinePickupTipsEnabled != null && message.hasOwnProperty("isOnlinePickupTipsEnabled"))
                                object.isOnlinePickupTipsEnabled = message.isOnlinePickupTipsEnabled;
                            if (message.isBusinessAutoStartSessionEnabled != null && message.hasOwnProperty("isBusinessAutoStartSessionEnabled"))
                                object.isBusinessAutoStartSessionEnabled = message.isBusinessAutoStartSessionEnabled;
                            return object;
                        };

                        /**
                         * Converts this EnabledFeaturesProto to JSON.
                         * @function toJSON
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.EnabledFeaturesProto
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        EnabledFeaturesProto.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for EnabledFeaturesProto
                         * @function getTypeUrl
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.EnabledFeaturesProto
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        EnabledFeaturesProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.EnabledFeaturesProto";
                        };

                        return EnabledFeaturesProto;
                    })();

                    OperationSettingsProto.StripeAccountProto = (function() {

                        /**
                         * Properties of a StripeAccountProto.
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto
                         * @interface IStripeAccountProto
                         * @property {string|null} [id] StripeAccountProto id
                         * @property {boolean|null} [isEnrolled] StripeAccountProto isEnrolled
                         * @property {google.protobuf.ITimestamp|null} [enrolledOn] StripeAccountProto enrolledOn
                         */

                        /**
                         * Constructs a new StripeAccountProto.
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto
                         * @classdesc Represents a StripeAccountProto.
                         * @implements IStripeAccountProto
                         * @constructor
                         * @param {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.IStripeAccountProto=} [properties] Properties to set
                         */
                        function StripeAccountProto(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * StripeAccountProto id.
                         * @member {string} id
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.StripeAccountProto
                         * @instance
                         */
                        StripeAccountProto.prototype.id = "";

                        /**
                         * StripeAccountProto isEnrolled.
                         * @member {boolean} isEnrolled
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.StripeAccountProto
                         * @instance
                         */
                        StripeAccountProto.prototype.isEnrolled = false;

                        /**
                         * StripeAccountProto enrolledOn.
                         * @member {google.protobuf.ITimestamp|null|undefined} enrolledOn
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.StripeAccountProto
                         * @instance
                         */
                        StripeAccountProto.prototype.enrolledOn = null;

                        /**
                         * Creates a new StripeAccountProto instance using the specified properties.
                         * @function create
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.StripeAccountProto
                         * @static
                         * @param {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.IStripeAccountProto=} [properties] Properties to set
                         * @returns {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.StripeAccountProto} StripeAccountProto instance
                         */
                        StripeAccountProto.create = function create(properties) {
                            return new StripeAccountProto(properties);
                        };

                        /**
                         * Encodes the specified StripeAccountProto message. Does not implicitly {@link waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.StripeAccountProto.verify|verify} messages.
                         * @function encode
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.StripeAccountProto
                         * @static
                         * @param {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.IStripeAccountProto} message StripeAccountProto message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        StripeAccountProto.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                            if (message.isEnrolled != null && Object.hasOwnProperty.call(message, "isEnrolled"))
                                writer.uint32(/* id 2, wireType 0 =*/16).bool(message.isEnrolled);
                            if (message.enrolledOn != null && Object.hasOwnProperty.call(message, "enrolledOn"))
                                $root.google.protobuf.Timestamp.encode(message.enrolledOn, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                            return writer;
                        };

                        /**
                         * Encodes the specified StripeAccountProto message, length delimited. Does not implicitly {@link waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.StripeAccountProto.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.StripeAccountProto
                         * @static
                         * @param {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.IStripeAccountProto} message StripeAccountProto message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        StripeAccountProto.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a StripeAccountProto message from the specified reader or buffer.
                         * @function decode
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.StripeAccountProto
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.StripeAccountProto} StripeAccountProto
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        StripeAccountProto.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.StripeAccountProto();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1: {
                                        message.id = reader.string();
                                        break;
                                    }
                                case 2: {
                                        message.isEnrolled = reader.bool();
                                        break;
                                    }
                                case 3: {
                                        message.enrolledOn = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a StripeAccountProto message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.StripeAccountProto
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.StripeAccountProto} StripeAccountProto
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        StripeAccountProto.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a StripeAccountProto message.
                         * @function verify
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.StripeAccountProto
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        StripeAccountProto.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.id != null && message.hasOwnProperty("id"))
                                if (!$util.isString(message.id))
                                    return "id: string expected";
                            if (message.isEnrolled != null && message.hasOwnProperty("isEnrolled"))
                                if (typeof message.isEnrolled !== "boolean")
                                    return "isEnrolled: boolean expected";
                            if (message.enrolledOn != null && message.hasOwnProperty("enrolledOn")) {
                                var error = $root.google.protobuf.Timestamp.verify(message.enrolledOn);
                                if (error)
                                    return "enrolledOn." + error;
                            }
                            return null;
                        };

                        /**
                         * Creates a StripeAccountProto message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.StripeAccountProto
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.StripeAccountProto} StripeAccountProto
                         */
                        StripeAccountProto.fromObject = function fromObject(object) {
                            if (object instanceof $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.StripeAccountProto)
                                return object;
                            var message = new $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.StripeAccountProto();
                            if (object.id != null)
                                message.id = String(object.id);
                            if (object.isEnrolled != null)
                                message.isEnrolled = Boolean(object.isEnrolled);
                            if (object.enrolledOn != null) {
                                if (typeof object.enrolledOn !== "object")
                                    throw TypeError(".waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.StripeAccountProto.enrolledOn: object expected");
                                message.enrolledOn = $root.google.protobuf.Timestamp.fromObject(object.enrolledOn);
                            }
                            return message;
                        };

                        /**
                         * Creates a plain object from a StripeAccountProto message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.StripeAccountProto
                         * @static
                         * @param {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.StripeAccountProto} message StripeAccountProto
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        StripeAccountProto.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.id = "";
                                object.isEnrolled = false;
                                object.enrolledOn = null;
                            }
                            if (message.id != null && message.hasOwnProperty("id"))
                                object.id = message.id;
                            if (message.isEnrolled != null && message.hasOwnProperty("isEnrolled"))
                                object.isEnrolled = message.isEnrolled;
                            if (message.enrolledOn != null && message.hasOwnProperty("enrolledOn"))
                                object.enrolledOn = $root.google.protobuf.Timestamp.toObject(message.enrolledOn, options);
                            return object;
                        };

                        /**
                         * Converts this StripeAccountProto to JSON.
                         * @function toJSON
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.StripeAccountProto
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        StripeAccountProto.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for StripeAccountProto
                         * @function getTypeUrl
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.StripeAccountProto
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        StripeAccountProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.StripeAccountProto";
                        };

                        return StripeAccountProto;
                    })();

                    OperationSettingsProto.AlertConfigProto = (function() {

                        /**
                         * Properties of an AlertConfigProto.
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto
                         * @interface IAlertConfigProto
                         * @property {string|null} [email] AlertConfigProto email
                         * @property {waiternow.common.IPhoneNumberProto|null} [phoneNumber] AlertConfigProto phoneNumber
                         */

                        /**
                         * Constructs a new AlertConfigProto.
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto
                         * @classdesc Represents an AlertConfigProto.
                         * @implements IAlertConfigProto
                         * @constructor
                         * @param {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.IAlertConfigProto=} [properties] Properties to set
                         */
                        function AlertConfigProto(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * AlertConfigProto email.
                         * @member {string} email
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.AlertConfigProto
                         * @instance
                         */
                        AlertConfigProto.prototype.email = "";

                        /**
                         * AlertConfigProto phoneNumber.
                         * @member {waiternow.common.IPhoneNumberProto|null|undefined} phoneNumber
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.AlertConfigProto
                         * @instance
                         */
                        AlertConfigProto.prototype.phoneNumber = null;

                        /**
                         * Creates a new AlertConfigProto instance using the specified properties.
                         * @function create
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.AlertConfigProto
                         * @static
                         * @param {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.IAlertConfigProto=} [properties] Properties to set
                         * @returns {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.AlertConfigProto} AlertConfigProto instance
                         */
                        AlertConfigProto.create = function create(properties) {
                            return new AlertConfigProto(properties);
                        };

                        /**
                         * Encodes the specified AlertConfigProto message. Does not implicitly {@link waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.AlertConfigProto.verify|verify} messages.
                         * @function encode
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.AlertConfigProto
                         * @static
                         * @param {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.IAlertConfigProto} message AlertConfigProto message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        AlertConfigProto.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
                            if (message.phoneNumber != null && Object.hasOwnProperty.call(message, "phoneNumber"))
                                $root.waiternow.common.PhoneNumberProto.encode(message.phoneNumber, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                            return writer;
                        };

                        /**
                         * Encodes the specified AlertConfigProto message, length delimited. Does not implicitly {@link waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.AlertConfigProto.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.AlertConfigProto
                         * @static
                         * @param {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.IAlertConfigProto} message AlertConfigProto message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        AlertConfigProto.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes an AlertConfigProto message from the specified reader or buffer.
                         * @function decode
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.AlertConfigProto
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.AlertConfigProto} AlertConfigProto
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        AlertConfigProto.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.AlertConfigProto();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1: {
                                        message.email = reader.string();
                                        break;
                                    }
                                case 2: {
                                        message.phoneNumber = $root.waiternow.common.PhoneNumberProto.decode(reader, reader.uint32());
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes an AlertConfigProto message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.AlertConfigProto
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.AlertConfigProto} AlertConfigProto
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        AlertConfigProto.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies an AlertConfigProto message.
                         * @function verify
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.AlertConfigProto
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        AlertConfigProto.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.email != null && message.hasOwnProperty("email"))
                                if (!$util.isString(message.email))
                                    return "email: string expected";
                            if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber")) {
                                var error = $root.waiternow.common.PhoneNumberProto.verify(message.phoneNumber);
                                if (error)
                                    return "phoneNumber." + error;
                            }
                            return null;
                        };

                        /**
                         * Creates an AlertConfigProto message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.AlertConfigProto
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.AlertConfigProto} AlertConfigProto
                         */
                        AlertConfigProto.fromObject = function fromObject(object) {
                            if (object instanceof $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.AlertConfigProto)
                                return object;
                            var message = new $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.AlertConfigProto();
                            if (object.email != null)
                                message.email = String(object.email);
                            if (object.phoneNumber != null) {
                                if (typeof object.phoneNumber !== "object")
                                    throw TypeError(".waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.AlertConfigProto.phoneNumber: object expected");
                                message.phoneNumber = $root.waiternow.common.PhoneNumberProto.fromObject(object.phoneNumber);
                            }
                            return message;
                        };

                        /**
                         * Creates a plain object from an AlertConfigProto message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.AlertConfigProto
                         * @static
                         * @param {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.AlertConfigProto} message AlertConfigProto
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        AlertConfigProto.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.email = "";
                                object.phoneNumber = null;
                            }
                            if (message.email != null && message.hasOwnProperty("email"))
                                object.email = message.email;
                            if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
                                object.phoneNumber = $root.waiternow.common.PhoneNumberProto.toObject(message.phoneNumber, options);
                            return object;
                        };

                        /**
                         * Converts this AlertConfigProto to JSON.
                         * @function toJSON
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.AlertConfigProto
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        AlertConfigProto.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for AlertConfigProto
                         * @function getTypeUrl
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.AlertConfigProto
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        AlertConfigProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.AlertConfigProto";
                        };

                        return AlertConfigProto;
                    })();

                    OperationSettingsProto.DeliveryConfigProto = (function() {

                        /**
                         * Properties of a DeliveryConfigProto.
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto
                         * @interface IDeliveryConfigProto
                         * @property {waiternow.common.DeliveryCarrier|null} [deliveryCarrier] DeliveryConfigProto deliveryCarrier
                         * @property {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto.ISelfDeliveryConfigProto|null} [selfDeliveryConfig] DeliveryConfigProto selfDeliveryConfig
                         */

                        /**
                         * Constructs a new DeliveryConfigProto.
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto
                         * @classdesc Represents a DeliveryConfigProto.
                         * @implements IDeliveryConfigProto
                         * @constructor
                         * @param {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.IDeliveryConfigProto=} [properties] Properties to set
                         */
                        function DeliveryConfigProto(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * DeliveryConfigProto deliveryCarrier.
                         * @member {waiternow.common.DeliveryCarrier} deliveryCarrier
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto
                         * @instance
                         */
                        DeliveryConfigProto.prototype.deliveryCarrier = 0;

                        /**
                         * DeliveryConfigProto selfDeliveryConfig.
                         * @member {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto.ISelfDeliveryConfigProto|null|undefined} selfDeliveryConfig
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto
                         * @instance
                         */
                        DeliveryConfigProto.prototype.selfDeliveryConfig = null;

                        /**
                         * Creates a new DeliveryConfigProto instance using the specified properties.
                         * @function create
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto
                         * @static
                         * @param {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.IDeliveryConfigProto=} [properties] Properties to set
                         * @returns {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto} DeliveryConfigProto instance
                         */
                        DeliveryConfigProto.create = function create(properties) {
                            return new DeliveryConfigProto(properties);
                        };

                        /**
                         * Encodes the specified DeliveryConfigProto message. Does not implicitly {@link waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto.verify|verify} messages.
                         * @function encode
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto
                         * @static
                         * @param {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.IDeliveryConfigProto} message DeliveryConfigProto message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DeliveryConfigProto.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.deliveryCarrier != null && Object.hasOwnProperty.call(message, "deliveryCarrier"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.deliveryCarrier);
                            if (message.selfDeliveryConfig != null && Object.hasOwnProperty.call(message, "selfDeliveryConfig"))
                                $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto.SelfDeliveryConfigProto.encode(message.selfDeliveryConfig, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                            return writer;
                        };

                        /**
                         * Encodes the specified DeliveryConfigProto message, length delimited. Does not implicitly {@link waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto
                         * @static
                         * @param {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.IDeliveryConfigProto} message DeliveryConfigProto message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DeliveryConfigProto.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a DeliveryConfigProto message from the specified reader or buffer.
                         * @function decode
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto} DeliveryConfigProto
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DeliveryConfigProto.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1: {
                                        message.deliveryCarrier = reader.int32();
                                        break;
                                    }
                                case 2: {
                                        message.selfDeliveryConfig = $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto.SelfDeliveryConfigProto.decode(reader, reader.uint32());
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a DeliveryConfigProto message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto} DeliveryConfigProto
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DeliveryConfigProto.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a DeliveryConfigProto message.
                         * @function verify
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        DeliveryConfigProto.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.deliveryCarrier != null && message.hasOwnProperty("deliveryCarrier"))
                                switch (message.deliveryCarrier) {
                                default:
                                    return "deliveryCarrier: enum value expected";
                                case 0:
                                case 1:
                                case 2:
                                    break;
                                }
                            if (message.selfDeliveryConfig != null && message.hasOwnProperty("selfDeliveryConfig")) {
                                var error = $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto.SelfDeliveryConfigProto.verify(message.selfDeliveryConfig);
                                if (error)
                                    return "selfDeliveryConfig." + error;
                            }
                            return null;
                        };

                        /**
                         * Creates a DeliveryConfigProto message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto} DeliveryConfigProto
                         */
                        DeliveryConfigProto.fromObject = function fromObject(object) {
                            if (object instanceof $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto)
                                return object;
                            var message = new $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto();
                            switch (object.deliveryCarrier) {
                            default:
                                if (typeof object.deliveryCarrier === "number") {
                                    message.deliveryCarrier = object.deliveryCarrier;
                                    break;
                                }
                                break;
                            case "DELIVERY_CARRIER_UNSPECIFIED":
                            case 0:
                                message.deliveryCarrier = 0;
                                break;
                            case "SELF":
                            case 1:
                                message.deliveryCarrier = 1;
                                break;
                            case "DOORDASH":
                            case 2:
                                message.deliveryCarrier = 2;
                                break;
                            }
                            if (object.selfDeliveryConfig != null) {
                                if (typeof object.selfDeliveryConfig !== "object")
                                    throw TypeError(".waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto.selfDeliveryConfig: object expected");
                                message.selfDeliveryConfig = $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto.SelfDeliveryConfigProto.fromObject(object.selfDeliveryConfig);
                            }
                            return message;
                        };

                        /**
                         * Creates a plain object from a DeliveryConfigProto message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto
                         * @static
                         * @param {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto} message DeliveryConfigProto
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        DeliveryConfigProto.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.deliveryCarrier = options.enums === String ? "DELIVERY_CARRIER_UNSPECIFIED" : 0;
                                object.selfDeliveryConfig = null;
                            }
                            if (message.deliveryCarrier != null && message.hasOwnProperty("deliveryCarrier"))
                                object.deliveryCarrier = options.enums === String ? $root.waiternow.common.DeliveryCarrier[message.deliveryCarrier] === undefined ? message.deliveryCarrier : $root.waiternow.common.DeliveryCarrier[message.deliveryCarrier] : message.deliveryCarrier;
                            if (message.selfDeliveryConfig != null && message.hasOwnProperty("selfDeliveryConfig"))
                                object.selfDeliveryConfig = $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto.SelfDeliveryConfigProto.toObject(message.selfDeliveryConfig, options);
                            return object;
                        };

                        /**
                         * Converts this DeliveryConfigProto to JSON.
                         * @function toJSON
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        DeliveryConfigProto.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for DeliveryConfigProto
                         * @function getTypeUrl
                         * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        DeliveryConfigProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto";
                        };

                        DeliveryConfigProto.SelfDeliveryConfigProto = (function() {

                            /**
                             * Properties of a SelfDeliveryConfigProto.
                             * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto
                             * @interface ISelfDeliveryConfigProto
                             * @property {waiternow.common.IMoneyProto|null} [baseFee] SelfDeliveryConfigProto baseFee
                             * @property {waiternow.common.IDistanceQuantityProto|null} [baseDistance] SelfDeliveryConfigProto baseDistance
                             * @property {waiternow.common.IMoneyProto|null} [feePerDistanceUnit] SelfDeliveryConfigProto feePerDistanceUnit
                             * @property {waiternow.common.IDistanceQuantityProto|null} [maxDistance] SelfDeliveryConfigProto maxDistance
                             */

                            /**
                             * Constructs a new SelfDeliveryConfigProto.
                             * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto
                             * @classdesc Represents a SelfDeliveryConfigProto.
                             * @implements ISelfDeliveryConfigProto
                             * @constructor
                             * @param {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto.ISelfDeliveryConfigProto=} [properties] Properties to set
                             */
                            function SelfDeliveryConfigProto(properties) {
                                if (properties)
                                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                        if (properties[keys[i]] != null)
                                            this[keys[i]] = properties[keys[i]];
                            }

                            /**
                             * SelfDeliveryConfigProto baseFee.
                             * @member {waiternow.common.IMoneyProto|null|undefined} baseFee
                             * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto.SelfDeliveryConfigProto
                             * @instance
                             */
                            SelfDeliveryConfigProto.prototype.baseFee = null;

                            /**
                             * SelfDeliveryConfigProto baseDistance.
                             * @member {waiternow.common.IDistanceQuantityProto|null|undefined} baseDistance
                             * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto.SelfDeliveryConfigProto
                             * @instance
                             */
                            SelfDeliveryConfigProto.prototype.baseDistance = null;

                            /**
                             * SelfDeliveryConfigProto feePerDistanceUnit.
                             * @member {waiternow.common.IMoneyProto|null|undefined} feePerDistanceUnit
                             * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto.SelfDeliveryConfigProto
                             * @instance
                             */
                            SelfDeliveryConfigProto.prototype.feePerDistanceUnit = null;

                            /**
                             * SelfDeliveryConfigProto maxDistance.
                             * @member {waiternow.common.IDistanceQuantityProto|null|undefined} maxDistance
                             * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto.SelfDeliveryConfigProto
                             * @instance
                             */
                            SelfDeliveryConfigProto.prototype.maxDistance = null;

                            /**
                             * Creates a new SelfDeliveryConfigProto instance using the specified properties.
                             * @function create
                             * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto.SelfDeliveryConfigProto
                             * @static
                             * @param {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto.ISelfDeliveryConfigProto=} [properties] Properties to set
                             * @returns {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto.SelfDeliveryConfigProto} SelfDeliveryConfigProto instance
                             */
                            SelfDeliveryConfigProto.create = function create(properties) {
                                return new SelfDeliveryConfigProto(properties);
                            };

                            /**
                             * Encodes the specified SelfDeliveryConfigProto message. Does not implicitly {@link waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto.SelfDeliveryConfigProto.verify|verify} messages.
                             * @function encode
                             * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto.SelfDeliveryConfigProto
                             * @static
                             * @param {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto.ISelfDeliveryConfigProto} message SelfDeliveryConfigProto message or plain object to encode
                             * @param {$protobuf.Writer} [writer] Writer to encode to
                             * @returns {$protobuf.Writer} Writer
                             */
                            SelfDeliveryConfigProto.encode = function encode(message, writer) {
                                if (!writer)
                                    writer = $Writer.create();
                                if (message.baseFee != null && Object.hasOwnProperty.call(message, "baseFee"))
                                    $root.waiternow.common.MoneyProto.encode(message.baseFee, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                                if (message.baseDistance != null && Object.hasOwnProperty.call(message, "baseDistance"))
                                    $root.waiternow.common.DistanceQuantityProto.encode(message.baseDistance, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                                if (message.feePerDistanceUnit != null && Object.hasOwnProperty.call(message, "feePerDistanceUnit"))
                                    $root.waiternow.common.MoneyProto.encode(message.feePerDistanceUnit, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                                if (message.maxDistance != null && Object.hasOwnProperty.call(message, "maxDistance"))
                                    $root.waiternow.common.DistanceQuantityProto.encode(message.maxDistance, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                                return writer;
                            };

                            /**
                             * Encodes the specified SelfDeliveryConfigProto message, length delimited. Does not implicitly {@link waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto.SelfDeliveryConfigProto.verify|verify} messages.
                             * @function encodeDelimited
                             * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto.SelfDeliveryConfigProto
                             * @static
                             * @param {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto.ISelfDeliveryConfigProto} message SelfDeliveryConfigProto message or plain object to encode
                             * @param {$protobuf.Writer} [writer] Writer to encode to
                             * @returns {$protobuf.Writer} Writer
                             */
                            SelfDeliveryConfigProto.encodeDelimited = function encodeDelimited(message, writer) {
                                return this.encode(message, writer).ldelim();
                            };

                            /**
                             * Decodes a SelfDeliveryConfigProto message from the specified reader or buffer.
                             * @function decode
                             * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto.SelfDeliveryConfigProto
                             * @static
                             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                             * @param {number} [length] Message length if known beforehand
                             * @returns {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto.SelfDeliveryConfigProto} SelfDeliveryConfigProto
                             * @throws {Error} If the payload is not a reader or valid buffer
                             * @throws {$protobuf.util.ProtocolError} If required fields are missing
                             */
                            SelfDeliveryConfigProto.decode = function decode(reader, length) {
                                if (!(reader instanceof $Reader))
                                    reader = $Reader.create(reader);
                                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto.SelfDeliveryConfigProto();
                                while (reader.pos < end) {
                                    var tag = reader.uint32();
                                    switch (tag >>> 3) {
                                    case 1: {
                                            message.baseFee = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                                            break;
                                        }
                                    case 2: {
                                            message.baseDistance = $root.waiternow.common.DistanceQuantityProto.decode(reader, reader.uint32());
                                            break;
                                        }
                                    case 3: {
                                            message.feePerDistanceUnit = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                                            break;
                                        }
                                    case 4: {
                                            message.maxDistance = $root.waiternow.common.DistanceQuantityProto.decode(reader, reader.uint32());
                                            break;
                                        }
                                    default:
                                        reader.skipType(tag & 7);
                                        break;
                                    }
                                }
                                return message;
                            };

                            /**
                             * Decodes a SelfDeliveryConfigProto message from the specified reader or buffer, length delimited.
                             * @function decodeDelimited
                             * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto.SelfDeliveryConfigProto
                             * @static
                             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                             * @returns {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto.SelfDeliveryConfigProto} SelfDeliveryConfigProto
                             * @throws {Error} If the payload is not a reader or valid buffer
                             * @throws {$protobuf.util.ProtocolError} If required fields are missing
                             */
                            SelfDeliveryConfigProto.decodeDelimited = function decodeDelimited(reader) {
                                if (!(reader instanceof $Reader))
                                    reader = new $Reader(reader);
                                return this.decode(reader, reader.uint32());
                            };

                            /**
                             * Verifies a SelfDeliveryConfigProto message.
                             * @function verify
                             * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto.SelfDeliveryConfigProto
                             * @static
                             * @param {Object.<string,*>} message Plain object to verify
                             * @returns {string|null} `null` if valid, otherwise the reason why it is not
                             */
                            SelfDeliveryConfigProto.verify = function verify(message) {
                                if (typeof message !== "object" || message === null)
                                    return "object expected";
                                if (message.baseFee != null && message.hasOwnProperty("baseFee")) {
                                    var error = $root.waiternow.common.MoneyProto.verify(message.baseFee);
                                    if (error)
                                        return "baseFee." + error;
                                }
                                if (message.baseDistance != null && message.hasOwnProperty("baseDistance")) {
                                    var error = $root.waiternow.common.DistanceQuantityProto.verify(message.baseDistance);
                                    if (error)
                                        return "baseDistance." + error;
                                }
                                if (message.feePerDistanceUnit != null && message.hasOwnProperty("feePerDistanceUnit")) {
                                    var error = $root.waiternow.common.MoneyProto.verify(message.feePerDistanceUnit);
                                    if (error)
                                        return "feePerDistanceUnit." + error;
                                }
                                if (message.maxDistance != null && message.hasOwnProperty("maxDistance")) {
                                    var error = $root.waiternow.common.DistanceQuantityProto.verify(message.maxDistance);
                                    if (error)
                                        return "maxDistance." + error;
                                }
                                return null;
                            };

                            /**
                             * Creates a SelfDeliveryConfigProto message from a plain object. Also converts values to their respective internal types.
                             * @function fromObject
                             * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto.SelfDeliveryConfigProto
                             * @static
                             * @param {Object.<string,*>} object Plain object
                             * @returns {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto.SelfDeliveryConfigProto} SelfDeliveryConfigProto
                             */
                            SelfDeliveryConfigProto.fromObject = function fromObject(object) {
                                if (object instanceof $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto.SelfDeliveryConfigProto)
                                    return object;
                                var message = new $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto.SelfDeliveryConfigProto();
                                if (object.baseFee != null) {
                                    if (typeof object.baseFee !== "object")
                                        throw TypeError(".waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto.SelfDeliveryConfigProto.baseFee: object expected");
                                    message.baseFee = $root.waiternow.common.MoneyProto.fromObject(object.baseFee);
                                }
                                if (object.baseDistance != null) {
                                    if (typeof object.baseDistance !== "object")
                                        throw TypeError(".waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto.SelfDeliveryConfigProto.baseDistance: object expected");
                                    message.baseDistance = $root.waiternow.common.DistanceQuantityProto.fromObject(object.baseDistance);
                                }
                                if (object.feePerDistanceUnit != null) {
                                    if (typeof object.feePerDistanceUnit !== "object")
                                        throw TypeError(".waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto.SelfDeliveryConfigProto.feePerDistanceUnit: object expected");
                                    message.feePerDistanceUnit = $root.waiternow.common.MoneyProto.fromObject(object.feePerDistanceUnit);
                                }
                                if (object.maxDistance != null) {
                                    if (typeof object.maxDistance !== "object")
                                        throw TypeError(".waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto.SelfDeliveryConfigProto.maxDistance: object expected");
                                    message.maxDistance = $root.waiternow.common.DistanceQuantityProto.fromObject(object.maxDistance);
                                }
                                return message;
                            };

                            /**
                             * Creates a plain object from a SelfDeliveryConfigProto message. Also converts values to other types if specified.
                             * @function toObject
                             * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto.SelfDeliveryConfigProto
                             * @static
                             * @param {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto.SelfDeliveryConfigProto} message SelfDeliveryConfigProto
                             * @param {$protobuf.IConversionOptions} [options] Conversion options
                             * @returns {Object.<string,*>} Plain object
                             */
                            SelfDeliveryConfigProto.toObject = function toObject(message, options) {
                                if (!options)
                                    options = {};
                                var object = {};
                                if (options.defaults) {
                                    object.baseFee = null;
                                    object.baseDistance = null;
                                    object.feePerDistanceUnit = null;
                                    object.maxDistance = null;
                                }
                                if (message.baseFee != null && message.hasOwnProperty("baseFee"))
                                    object.baseFee = $root.waiternow.common.MoneyProto.toObject(message.baseFee, options);
                                if (message.baseDistance != null && message.hasOwnProperty("baseDistance"))
                                    object.baseDistance = $root.waiternow.common.DistanceQuantityProto.toObject(message.baseDistance, options);
                                if (message.feePerDistanceUnit != null && message.hasOwnProperty("feePerDistanceUnit"))
                                    object.feePerDistanceUnit = $root.waiternow.common.MoneyProto.toObject(message.feePerDistanceUnit, options);
                                if (message.maxDistance != null && message.hasOwnProperty("maxDistance"))
                                    object.maxDistance = $root.waiternow.common.DistanceQuantityProto.toObject(message.maxDistance, options);
                                return object;
                            };

                            /**
                             * Converts this SelfDeliveryConfigProto to JSON.
                             * @function toJSON
                             * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto.SelfDeliveryConfigProto
                             * @instance
                             * @returns {Object.<string,*>} JSON object
                             */
                            SelfDeliveryConfigProto.prototype.toJSON = function toJSON() {
                                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                            };

                            /**
                             * Gets the default type url for SelfDeliveryConfigProto
                             * @function getTypeUrl
                             * @memberof waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto.SelfDeliveryConfigProto
                             * @static
                             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                             * @returns {string} The default type url
                             */
                            SelfDeliveryConfigProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                                if (typeUrlPrefix === undefined) {
                                    typeUrlPrefix = "type.googleapis.com";
                                }
                                return typeUrlPrefix + "/waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.DeliveryConfigProto.SelfDeliveryConfigProto";
                            };

                            return SelfDeliveryConfigProto;
                        })();

                        return DeliveryConfigProto;
                    })();

                    return OperationSettingsProto;
                })();

                return SettingsProto;
            })();

            LocationProto.RedundantDataProto = (function() {

                /**
                 * Properties of a RedundantDataProto.
                 * @memberof waiternow.common.LocationProto
                 * @interface IRedundantDataProto
                 * @property {string|null} [businessName] RedundantDataProto businessName
                 * @property {boolean|null} [isBusinessSuspended] RedundantDataProto isBusinessSuspended
                 * @property {waiternow.common.LocationProto.ISettingsProto|null} [businessLocationSettings] RedundantDataProto businessLocationSettings
                 * @property {waiternow.common.IImageProto|null} [businessLogo] RedundantDataProto businessLogo
                 * @property {waiternow.common.IImageProto|null} [businessMenuHeaderForLandscapeScreen] RedundantDataProto businessMenuHeaderForLandscapeScreen
                 * @property {waiternow.common.IImageProto|null} [businessMenuHeaderForPortraitScreen] RedundantDataProto businessMenuHeaderForPortraitScreen
                 * @property {waiternow.common.IImageProto|null} [businessHomeHeaderForLandscapeScreen] RedundantDataProto businessHomeHeaderForLandscapeScreen
                 * @property {waiternow.common.IImageProto|null} [businessHomeHeaderForPortraitScreen] RedundantDataProto businessHomeHeaderForPortraitScreen
                 * @property {string|null} [legacyBusinessDescription] RedundantDataProto legacyBusinessDescription
                 * @property {waiternow.common.ITextProto|null} [businessDescription] RedundantDataProto businessDescription
                 * @property {google.protobuf.ITimestamp|null} [lastPaidOrderOn] RedundantDataProto lastPaidOrderOn
                 */

                /**
                 * Constructs a new RedundantDataProto.
                 * @memberof waiternow.common.LocationProto
                 * @classdesc Represents a RedundantDataProto.
                 * @implements IRedundantDataProto
                 * @constructor
                 * @param {waiternow.common.LocationProto.IRedundantDataProto=} [properties] Properties to set
                 */
                function RedundantDataProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * RedundantDataProto businessName.
                 * @member {string} businessName
                 * @memberof waiternow.common.LocationProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.businessName = "";

                /**
                 * RedundantDataProto isBusinessSuspended.
                 * @member {boolean} isBusinessSuspended
                 * @memberof waiternow.common.LocationProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.isBusinessSuspended = false;

                /**
                 * RedundantDataProto businessLocationSettings.
                 * @member {waiternow.common.LocationProto.ISettingsProto|null|undefined} businessLocationSettings
                 * @memberof waiternow.common.LocationProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.businessLocationSettings = null;

                /**
                 * RedundantDataProto businessLogo.
                 * @member {waiternow.common.IImageProto|null|undefined} businessLogo
                 * @memberof waiternow.common.LocationProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.businessLogo = null;

                /**
                 * RedundantDataProto businessMenuHeaderForLandscapeScreen.
                 * @member {waiternow.common.IImageProto|null|undefined} businessMenuHeaderForLandscapeScreen
                 * @memberof waiternow.common.LocationProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.businessMenuHeaderForLandscapeScreen = null;

                /**
                 * RedundantDataProto businessMenuHeaderForPortraitScreen.
                 * @member {waiternow.common.IImageProto|null|undefined} businessMenuHeaderForPortraitScreen
                 * @memberof waiternow.common.LocationProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.businessMenuHeaderForPortraitScreen = null;

                /**
                 * RedundantDataProto businessHomeHeaderForLandscapeScreen.
                 * @member {waiternow.common.IImageProto|null|undefined} businessHomeHeaderForLandscapeScreen
                 * @memberof waiternow.common.LocationProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.businessHomeHeaderForLandscapeScreen = null;

                /**
                 * RedundantDataProto businessHomeHeaderForPortraitScreen.
                 * @member {waiternow.common.IImageProto|null|undefined} businessHomeHeaderForPortraitScreen
                 * @memberof waiternow.common.LocationProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.businessHomeHeaderForPortraitScreen = null;

                /**
                 * RedundantDataProto legacyBusinessDescription.
                 * @member {string} legacyBusinessDescription
                 * @memberof waiternow.common.LocationProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.legacyBusinessDescription = "";

                /**
                 * RedundantDataProto businessDescription.
                 * @member {waiternow.common.ITextProto|null|undefined} businessDescription
                 * @memberof waiternow.common.LocationProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.businessDescription = null;

                /**
                 * RedundantDataProto lastPaidOrderOn.
                 * @member {google.protobuf.ITimestamp|null|undefined} lastPaidOrderOn
                 * @memberof waiternow.common.LocationProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.lastPaidOrderOn = null;

                /**
                 * Creates a new RedundantDataProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.LocationProto.RedundantDataProto
                 * @static
                 * @param {waiternow.common.LocationProto.IRedundantDataProto=} [properties] Properties to set
                 * @returns {waiternow.common.LocationProto.RedundantDataProto} RedundantDataProto instance
                 */
                RedundantDataProto.create = function create(properties) {
                    return new RedundantDataProto(properties);
                };

                /**
                 * Encodes the specified RedundantDataProto message. Does not implicitly {@link waiternow.common.LocationProto.RedundantDataProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.LocationProto.RedundantDataProto
                 * @static
                 * @param {waiternow.common.LocationProto.IRedundantDataProto} message RedundantDataProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RedundantDataProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.businessName != null && Object.hasOwnProperty.call(message, "businessName"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessName);
                    if (message.isBusinessSuspended != null && Object.hasOwnProperty.call(message, "isBusinessSuspended"))
                        writer.uint32(/* id 3, wireType 0 =*/24).bool(message.isBusinessSuspended);
                    if (message.businessLocationSettings != null && Object.hasOwnProperty.call(message, "businessLocationSettings"))
                        $root.waiternow.common.LocationProto.SettingsProto.encode(message.businessLocationSettings, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.businessLogo != null && Object.hasOwnProperty.call(message, "businessLogo"))
                        $root.waiternow.common.ImageProto.encode(message.businessLogo, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.businessMenuHeaderForLandscapeScreen != null && Object.hasOwnProperty.call(message, "businessMenuHeaderForLandscapeScreen"))
                        $root.waiternow.common.ImageProto.encode(message.businessMenuHeaderForLandscapeScreen, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.businessMenuHeaderForPortraitScreen != null && Object.hasOwnProperty.call(message, "businessMenuHeaderForPortraitScreen"))
                        $root.waiternow.common.ImageProto.encode(message.businessMenuHeaderForPortraitScreen, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    if (message.legacyBusinessDescription != null && Object.hasOwnProperty.call(message, "legacyBusinessDescription"))
                        writer.uint32(/* id 8, wireType 2 =*/66).string(message.legacyBusinessDescription);
                    if (message.businessDescription != null && Object.hasOwnProperty.call(message, "businessDescription"))
                        $root.waiternow.common.TextProto.encode(message.businessDescription, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                    if (message.lastPaidOrderOn != null && Object.hasOwnProperty.call(message, "lastPaidOrderOn"))
                        $root.google.protobuf.Timestamp.encode(message.lastPaidOrderOn, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                    if (message.businessHomeHeaderForLandscapeScreen != null && Object.hasOwnProperty.call(message, "businessHomeHeaderForLandscapeScreen"))
                        $root.waiternow.common.ImageProto.encode(message.businessHomeHeaderForLandscapeScreen, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                    if (message.businessHomeHeaderForPortraitScreen != null && Object.hasOwnProperty.call(message, "businessHomeHeaderForPortraitScreen"))
                        $root.waiternow.common.ImageProto.encode(message.businessHomeHeaderForPortraitScreen, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified RedundantDataProto message, length delimited. Does not implicitly {@link waiternow.common.LocationProto.RedundantDataProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.LocationProto.RedundantDataProto
                 * @static
                 * @param {waiternow.common.LocationProto.IRedundantDataProto} message RedundantDataProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RedundantDataProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a RedundantDataProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.LocationProto.RedundantDataProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.LocationProto.RedundantDataProto} RedundantDataProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RedundantDataProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.LocationProto.RedundantDataProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.businessName = reader.string();
                                break;
                            }
                        case 3: {
                                message.isBusinessSuspended = reader.bool();
                                break;
                            }
                        case 4: {
                                message.businessLocationSettings = $root.waiternow.common.LocationProto.SettingsProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 5: {
                                message.businessLogo = $root.waiternow.common.ImageProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 6: {
                                message.businessMenuHeaderForLandscapeScreen = $root.waiternow.common.ImageProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 7: {
                                message.businessMenuHeaderForPortraitScreen = $root.waiternow.common.ImageProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 11: {
                                message.businessHomeHeaderForLandscapeScreen = $root.waiternow.common.ImageProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 12: {
                                message.businessHomeHeaderForPortraitScreen = $root.waiternow.common.ImageProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 8: {
                                message.legacyBusinessDescription = reader.string();
                                break;
                            }
                        case 9: {
                                message.businessDescription = $root.waiternow.common.TextProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 10: {
                                message.lastPaidOrderOn = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a RedundantDataProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.LocationProto.RedundantDataProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.LocationProto.RedundantDataProto} RedundantDataProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RedundantDataProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a RedundantDataProto message.
                 * @function verify
                 * @memberof waiternow.common.LocationProto.RedundantDataProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                RedundantDataProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.businessName != null && message.hasOwnProperty("businessName"))
                        if (!$util.isString(message.businessName))
                            return "businessName: string expected";
                    if (message.isBusinessSuspended != null && message.hasOwnProperty("isBusinessSuspended"))
                        if (typeof message.isBusinessSuspended !== "boolean")
                            return "isBusinessSuspended: boolean expected";
                    if (message.businessLocationSettings != null && message.hasOwnProperty("businessLocationSettings")) {
                        var error = $root.waiternow.common.LocationProto.SettingsProto.verify(message.businessLocationSettings);
                        if (error)
                            return "businessLocationSettings." + error;
                    }
                    if (message.businessLogo != null && message.hasOwnProperty("businessLogo")) {
                        var error = $root.waiternow.common.ImageProto.verify(message.businessLogo);
                        if (error)
                            return "businessLogo." + error;
                    }
                    if (message.businessMenuHeaderForLandscapeScreen != null && message.hasOwnProperty("businessMenuHeaderForLandscapeScreen")) {
                        var error = $root.waiternow.common.ImageProto.verify(message.businessMenuHeaderForLandscapeScreen);
                        if (error)
                            return "businessMenuHeaderForLandscapeScreen." + error;
                    }
                    if (message.businessMenuHeaderForPortraitScreen != null && message.hasOwnProperty("businessMenuHeaderForPortraitScreen")) {
                        var error = $root.waiternow.common.ImageProto.verify(message.businessMenuHeaderForPortraitScreen);
                        if (error)
                            return "businessMenuHeaderForPortraitScreen." + error;
                    }
                    if (message.businessHomeHeaderForLandscapeScreen != null && message.hasOwnProperty("businessHomeHeaderForLandscapeScreen")) {
                        var error = $root.waiternow.common.ImageProto.verify(message.businessHomeHeaderForLandscapeScreen);
                        if (error)
                            return "businessHomeHeaderForLandscapeScreen." + error;
                    }
                    if (message.businessHomeHeaderForPortraitScreen != null && message.hasOwnProperty("businessHomeHeaderForPortraitScreen")) {
                        var error = $root.waiternow.common.ImageProto.verify(message.businessHomeHeaderForPortraitScreen);
                        if (error)
                            return "businessHomeHeaderForPortraitScreen." + error;
                    }
                    if (message.legacyBusinessDescription != null && message.hasOwnProperty("legacyBusinessDescription"))
                        if (!$util.isString(message.legacyBusinessDescription))
                            return "legacyBusinessDescription: string expected";
                    if (message.businessDescription != null && message.hasOwnProperty("businessDescription")) {
                        var error = $root.waiternow.common.TextProto.verify(message.businessDescription);
                        if (error)
                            return "businessDescription." + error;
                    }
                    if (message.lastPaidOrderOn != null && message.hasOwnProperty("lastPaidOrderOn")) {
                        var error = $root.google.protobuf.Timestamp.verify(message.lastPaidOrderOn);
                        if (error)
                            return "lastPaidOrderOn." + error;
                    }
                    return null;
                };

                /**
                 * Creates a RedundantDataProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.LocationProto.RedundantDataProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.LocationProto.RedundantDataProto} RedundantDataProto
                 */
                RedundantDataProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.LocationProto.RedundantDataProto)
                        return object;
                    var message = new $root.waiternow.common.LocationProto.RedundantDataProto();
                    if (object.businessName != null)
                        message.businessName = String(object.businessName);
                    if (object.isBusinessSuspended != null)
                        message.isBusinessSuspended = Boolean(object.isBusinessSuspended);
                    if (object.businessLocationSettings != null) {
                        if (typeof object.businessLocationSettings !== "object")
                            throw TypeError(".waiternow.common.LocationProto.RedundantDataProto.businessLocationSettings: object expected");
                        message.businessLocationSettings = $root.waiternow.common.LocationProto.SettingsProto.fromObject(object.businessLocationSettings);
                    }
                    if (object.businessLogo != null) {
                        if (typeof object.businessLogo !== "object")
                            throw TypeError(".waiternow.common.LocationProto.RedundantDataProto.businessLogo: object expected");
                        message.businessLogo = $root.waiternow.common.ImageProto.fromObject(object.businessLogo);
                    }
                    if (object.businessMenuHeaderForLandscapeScreen != null) {
                        if (typeof object.businessMenuHeaderForLandscapeScreen !== "object")
                            throw TypeError(".waiternow.common.LocationProto.RedundantDataProto.businessMenuHeaderForLandscapeScreen: object expected");
                        message.businessMenuHeaderForLandscapeScreen = $root.waiternow.common.ImageProto.fromObject(object.businessMenuHeaderForLandscapeScreen);
                    }
                    if (object.businessMenuHeaderForPortraitScreen != null) {
                        if (typeof object.businessMenuHeaderForPortraitScreen !== "object")
                            throw TypeError(".waiternow.common.LocationProto.RedundantDataProto.businessMenuHeaderForPortraitScreen: object expected");
                        message.businessMenuHeaderForPortraitScreen = $root.waiternow.common.ImageProto.fromObject(object.businessMenuHeaderForPortraitScreen);
                    }
                    if (object.businessHomeHeaderForLandscapeScreen != null) {
                        if (typeof object.businessHomeHeaderForLandscapeScreen !== "object")
                            throw TypeError(".waiternow.common.LocationProto.RedundantDataProto.businessHomeHeaderForLandscapeScreen: object expected");
                        message.businessHomeHeaderForLandscapeScreen = $root.waiternow.common.ImageProto.fromObject(object.businessHomeHeaderForLandscapeScreen);
                    }
                    if (object.businessHomeHeaderForPortraitScreen != null) {
                        if (typeof object.businessHomeHeaderForPortraitScreen !== "object")
                            throw TypeError(".waiternow.common.LocationProto.RedundantDataProto.businessHomeHeaderForPortraitScreen: object expected");
                        message.businessHomeHeaderForPortraitScreen = $root.waiternow.common.ImageProto.fromObject(object.businessHomeHeaderForPortraitScreen);
                    }
                    if (object.legacyBusinessDescription != null)
                        message.legacyBusinessDescription = String(object.legacyBusinessDescription);
                    if (object.businessDescription != null) {
                        if (typeof object.businessDescription !== "object")
                            throw TypeError(".waiternow.common.LocationProto.RedundantDataProto.businessDescription: object expected");
                        message.businessDescription = $root.waiternow.common.TextProto.fromObject(object.businessDescription);
                    }
                    if (object.lastPaidOrderOn != null) {
                        if (typeof object.lastPaidOrderOn !== "object")
                            throw TypeError(".waiternow.common.LocationProto.RedundantDataProto.lastPaidOrderOn: object expected");
                        message.lastPaidOrderOn = $root.google.protobuf.Timestamp.fromObject(object.lastPaidOrderOn);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a RedundantDataProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.LocationProto.RedundantDataProto
                 * @static
                 * @param {waiternow.common.LocationProto.RedundantDataProto} message RedundantDataProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                RedundantDataProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.businessName = "";
                        object.isBusinessSuspended = false;
                        object.businessLocationSettings = null;
                        object.businessLogo = null;
                        object.businessMenuHeaderForLandscapeScreen = null;
                        object.businessMenuHeaderForPortraitScreen = null;
                        object.legacyBusinessDescription = "";
                        object.businessDescription = null;
                        object.lastPaidOrderOn = null;
                        object.businessHomeHeaderForLandscapeScreen = null;
                        object.businessHomeHeaderForPortraitScreen = null;
                    }
                    if (message.businessName != null && message.hasOwnProperty("businessName"))
                        object.businessName = message.businessName;
                    if (message.isBusinessSuspended != null && message.hasOwnProperty("isBusinessSuspended"))
                        object.isBusinessSuspended = message.isBusinessSuspended;
                    if (message.businessLocationSettings != null && message.hasOwnProperty("businessLocationSettings"))
                        object.businessLocationSettings = $root.waiternow.common.LocationProto.SettingsProto.toObject(message.businessLocationSettings, options);
                    if (message.businessLogo != null && message.hasOwnProperty("businessLogo"))
                        object.businessLogo = $root.waiternow.common.ImageProto.toObject(message.businessLogo, options);
                    if (message.businessMenuHeaderForLandscapeScreen != null && message.hasOwnProperty("businessMenuHeaderForLandscapeScreen"))
                        object.businessMenuHeaderForLandscapeScreen = $root.waiternow.common.ImageProto.toObject(message.businessMenuHeaderForLandscapeScreen, options);
                    if (message.businessMenuHeaderForPortraitScreen != null && message.hasOwnProperty("businessMenuHeaderForPortraitScreen"))
                        object.businessMenuHeaderForPortraitScreen = $root.waiternow.common.ImageProto.toObject(message.businessMenuHeaderForPortraitScreen, options);
                    if (message.legacyBusinessDescription != null && message.hasOwnProperty("legacyBusinessDescription"))
                        object.legacyBusinessDescription = message.legacyBusinessDescription;
                    if (message.businessDescription != null && message.hasOwnProperty("businessDescription"))
                        object.businessDescription = $root.waiternow.common.TextProto.toObject(message.businessDescription, options);
                    if (message.lastPaidOrderOn != null && message.hasOwnProperty("lastPaidOrderOn"))
                        object.lastPaidOrderOn = $root.google.protobuf.Timestamp.toObject(message.lastPaidOrderOn, options);
                    if (message.businessHomeHeaderForLandscapeScreen != null && message.hasOwnProperty("businessHomeHeaderForLandscapeScreen"))
                        object.businessHomeHeaderForLandscapeScreen = $root.waiternow.common.ImageProto.toObject(message.businessHomeHeaderForLandscapeScreen, options);
                    if (message.businessHomeHeaderForPortraitScreen != null && message.hasOwnProperty("businessHomeHeaderForPortraitScreen"))
                        object.businessHomeHeaderForPortraitScreen = $root.waiternow.common.ImageProto.toObject(message.businessHomeHeaderForPortraitScreen, options);
                    return object;
                };

                /**
                 * Converts this RedundantDataProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.LocationProto.RedundantDataProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                RedundantDataProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for RedundantDataProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.LocationProto.RedundantDataProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                RedundantDataProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.LocationProto.RedundantDataProto";
                };

                return RedundantDataProto;
            })();

            LocationProto.MetadataProto = (function() {

                /**
                 * Properties of a MetadataProto.
                 * @memberof waiternow.common.LocationProto
                 * @interface IMetadataProto
                 * @property {string|null} [salesPartnerId] MetadataProto salesPartnerId
                 */

                /**
                 * Constructs a new MetadataProto.
                 * @memberof waiternow.common.LocationProto
                 * @classdesc Represents a MetadataProto.
                 * @implements IMetadataProto
                 * @constructor
                 * @param {waiternow.common.LocationProto.IMetadataProto=} [properties] Properties to set
                 */
                function MetadataProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * MetadataProto salesPartnerId.
                 * @member {string} salesPartnerId
                 * @memberof waiternow.common.LocationProto.MetadataProto
                 * @instance
                 */
                MetadataProto.prototype.salesPartnerId = "";

                /**
                 * Creates a new MetadataProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.LocationProto.MetadataProto
                 * @static
                 * @param {waiternow.common.LocationProto.IMetadataProto=} [properties] Properties to set
                 * @returns {waiternow.common.LocationProto.MetadataProto} MetadataProto instance
                 */
                MetadataProto.create = function create(properties) {
                    return new MetadataProto(properties);
                };

                /**
                 * Encodes the specified MetadataProto message. Does not implicitly {@link waiternow.common.LocationProto.MetadataProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.LocationProto.MetadataProto
                 * @static
                 * @param {waiternow.common.LocationProto.IMetadataProto} message MetadataProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MetadataProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.salesPartnerId != null && Object.hasOwnProperty.call(message, "salesPartnerId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.salesPartnerId);
                    return writer;
                };

                /**
                 * Encodes the specified MetadataProto message, length delimited. Does not implicitly {@link waiternow.common.LocationProto.MetadataProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.LocationProto.MetadataProto
                 * @static
                 * @param {waiternow.common.LocationProto.IMetadataProto} message MetadataProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MetadataProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a MetadataProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.LocationProto.MetadataProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.LocationProto.MetadataProto} MetadataProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MetadataProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.LocationProto.MetadataProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.salesPartnerId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a MetadataProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.LocationProto.MetadataProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.LocationProto.MetadataProto} MetadataProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MetadataProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a MetadataProto message.
                 * @function verify
                 * @memberof waiternow.common.LocationProto.MetadataProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                MetadataProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.salesPartnerId != null && message.hasOwnProperty("salesPartnerId"))
                        if (!$util.isString(message.salesPartnerId))
                            return "salesPartnerId: string expected";
                    return null;
                };

                /**
                 * Creates a MetadataProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.LocationProto.MetadataProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.LocationProto.MetadataProto} MetadataProto
                 */
                MetadataProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.LocationProto.MetadataProto)
                        return object;
                    var message = new $root.waiternow.common.LocationProto.MetadataProto();
                    if (object.salesPartnerId != null)
                        message.salesPartnerId = String(object.salesPartnerId);
                    return message;
                };

                /**
                 * Creates a plain object from a MetadataProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.LocationProto.MetadataProto
                 * @static
                 * @param {waiternow.common.LocationProto.MetadataProto} message MetadataProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                MetadataProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.salesPartnerId = "";
                    if (message.salesPartnerId != null && message.hasOwnProperty("salesPartnerId"))
                        object.salesPartnerId = message.salesPartnerId;
                    return object;
                };

                /**
                 * Converts this MetadataProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.LocationProto.MetadataProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                MetadataProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for MetadataProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.LocationProto.MetadataProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                MetadataProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.LocationProto.MetadataProto";
                };

                return MetadataProto;
            })();

            return LocationProto;
        })();

        common.LocationsProto = (function() {

            /**
             * Properties of a LocationsProto.
             * @memberof waiternow.common
             * @interface ILocationsProto
             * @property {Array.<waiternow.common.ILocationProto>|null} [locations] LocationsProto locations
             * @property {string|null} [continuationToken] LocationsProto continuationToken
             */

            /**
             * Constructs a new LocationsProto.
             * @memberof waiternow.common
             * @classdesc Represents a LocationsProto.
             * @implements ILocationsProto
             * @constructor
             * @param {waiternow.common.ILocationsProto=} [properties] Properties to set
             */
            function LocationsProto(properties) {
                this.locations = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * LocationsProto locations.
             * @member {Array.<waiternow.common.ILocationProto>} locations
             * @memberof waiternow.common.LocationsProto
             * @instance
             */
            LocationsProto.prototype.locations = $util.emptyArray;

            /**
             * LocationsProto continuationToken.
             * @member {string} continuationToken
             * @memberof waiternow.common.LocationsProto
             * @instance
             */
            LocationsProto.prototype.continuationToken = "";

            /**
             * Creates a new LocationsProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.LocationsProto
             * @static
             * @param {waiternow.common.ILocationsProto=} [properties] Properties to set
             * @returns {waiternow.common.LocationsProto} LocationsProto instance
             */
            LocationsProto.create = function create(properties) {
                return new LocationsProto(properties);
            };

            /**
             * Encodes the specified LocationsProto message. Does not implicitly {@link waiternow.common.LocationsProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.LocationsProto
             * @static
             * @param {waiternow.common.ILocationsProto} message LocationsProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            LocationsProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.locations != null && message.locations.length)
                    for (var i = 0; i < message.locations.length; ++i)
                        $root.waiternow.common.LocationProto.encode(message.locations[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.continuationToken);
                return writer;
            };

            /**
             * Encodes the specified LocationsProto message, length delimited. Does not implicitly {@link waiternow.common.LocationsProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.LocationsProto
             * @static
             * @param {waiternow.common.ILocationsProto} message LocationsProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            LocationsProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a LocationsProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.LocationsProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.LocationsProto} LocationsProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            LocationsProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.LocationsProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            if (!(message.locations && message.locations.length))
                                message.locations = [];
                            message.locations.push($root.waiternow.common.LocationProto.decode(reader, reader.uint32()));
                            break;
                        }
                    case 2: {
                            message.continuationToken = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a LocationsProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.LocationsProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.LocationsProto} LocationsProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            LocationsProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a LocationsProto message.
             * @function verify
             * @memberof waiternow.common.LocationsProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            LocationsProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.locations != null && message.hasOwnProperty("locations")) {
                    if (!Array.isArray(message.locations))
                        return "locations: array expected";
                    for (var i = 0; i < message.locations.length; ++i) {
                        var error = $root.waiternow.common.LocationProto.verify(message.locations[i]);
                        if (error)
                            return "locations." + error;
                    }
                }
                if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                    if (!$util.isString(message.continuationToken))
                        return "continuationToken: string expected";
                return null;
            };

            /**
             * Creates a LocationsProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.LocationsProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.LocationsProto} LocationsProto
             */
            LocationsProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.LocationsProto)
                    return object;
                var message = new $root.waiternow.common.LocationsProto();
                if (object.locations) {
                    if (!Array.isArray(object.locations))
                        throw TypeError(".waiternow.common.LocationsProto.locations: array expected");
                    message.locations = [];
                    for (var i = 0; i < object.locations.length; ++i) {
                        if (typeof object.locations[i] !== "object")
                            throw TypeError(".waiternow.common.LocationsProto.locations: object expected");
                        message.locations[i] = $root.waiternow.common.LocationProto.fromObject(object.locations[i]);
                    }
                }
                if (object.continuationToken != null)
                    message.continuationToken = String(object.continuationToken);
                return message;
            };

            /**
             * Creates a plain object from a LocationsProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.LocationsProto
             * @static
             * @param {waiternow.common.LocationsProto} message LocationsProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            LocationsProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.locations = [];
                if (options.defaults)
                    object.continuationToken = "";
                if (message.locations && message.locations.length) {
                    object.locations = [];
                    for (var j = 0; j < message.locations.length; ++j)
                        object.locations[j] = $root.waiternow.common.LocationProto.toObject(message.locations[j], options);
                }
                if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                    object.continuationToken = message.continuationToken;
                return object;
            };

            /**
             * Converts this LocationsProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.LocationsProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            LocationsProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for LocationsProto
             * @function getTypeUrl
             * @memberof waiternow.common.LocationsProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            LocationsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.LocationsProto";
            };

            return LocationsProto;
        })();

        common.BusinessLocationsProto = (function() {

            /**
             * Properties of a BusinessLocationsProto.
             * @memberof waiternow.common
             * @interface IBusinessLocationsProto
             * @property {Array.<waiternow.common.ILocationProto>|null} [locations] BusinessLocationsProto locations
             */

            /**
             * Constructs a new BusinessLocationsProto.
             * @memberof waiternow.common
             * @classdesc Represents a BusinessLocationsProto.
             * @implements IBusinessLocationsProto
             * @constructor
             * @param {waiternow.common.IBusinessLocationsProto=} [properties] Properties to set
             */
            function BusinessLocationsProto(properties) {
                this.locations = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * BusinessLocationsProto locations.
             * @member {Array.<waiternow.common.ILocationProto>} locations
             * @memberof waiternow.common.BusinessLocationsProto
             * @instance
             */
            BusinessLocationsProto.prototype.locations = $util.emptyArray;

            /**
             * Creates a new BusinessLocationsProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.BusinessLocationsProto
             * @static
             * @param {waiternow.common.IBusinessLocationsProto=} [properties] Properties to set
             * @returns {waiternow.common.BusinessLocationsProto} BusinessLocationsProto instance
             */
            BusinessLocationsProto.create = function create(properties) {
                return new BusinessLocationsProto(properties);
            };

            /**
             * Encodes the specified BusinessLocationsProto message. Does not implicitly {@link waiternow.common.BusinessLocationsProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.BusinessLocationsProto
             * @static
             * @param {waiternow.common.IBusinessLocationsProto} message BusinessLocationsProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BusinessLocationsProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.locations != null && message.locations.length)
                    for (var i = 0; i < message.locations.length; ++i)
                        $root.waiternow.common.LocationProto.encode(message.locations[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified BusinessLocationsProto message, length delimited. Does not implicitly {@link waiternow.common.BusinessLocationsProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.BusinessLocationsProto
             * @static
             * @param {waiternow.common.IBusinessLocationsProto} message BusinessLocationsProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BusinessLocationsProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a BusinessLocationsProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.BusinessLocationsProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.BusinessLocationsProto} BusinessLocationsProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BusinessLocationsProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.BusinessLocationsProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            if (!(message.locations && message.locations.length))
                                message.locations = [];
                            message.locations.push($root.waiternow.common.LocationProto.decode(reader, reader.uint32()));
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a BusinessLocationsProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.BusinessLocationsProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.BusinessLocationsProto} BusinessLocationsProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BusinessLocationsProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a BusinessLocationsProto message.
             * @function verify
             * @memberof waiternow.common.BusinessLocationsProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            BusinessLocationsProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.locations != null && message.hasOwnProperty("locations")) {
                    if (!Array.isArray(message.locations))
                        return "locations: array expected";
                    for (var i = 0; i < message.locations.length; ++i) {
                        var error = $root.waiternow.common.LocationProto.verify(message.locations[i]);
                        if (error)
                            return "locations." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a BusinessLocationsProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.BusinessLocationsProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.BusinessLocationsProto} BusinessLocationsProto
             */
            BusinessLocationsProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.BusinessLocationsProto)
                    return object;
                var message = new $root.waiternow.common.BusinessLocationsProto();
                if (object.locations) {
                    if (!Array.isArray(object.locations))
                        throw TypeError(".waiternow.common.BusinessLocationsProto.locations: array expected");
                    message.locations = [];
                    for (var i = 0; i < object.locations.length; ++i) {
                        if (typeof object.locations[i] !== "object")
                            throw TypeError(".waiternow.common.BusinessLocationsProto.locations: object expected");
                        message.locations[i] = $root.waiternow.common.LocationProto.fromObject(object.locations[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a BusinessLocationsProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.BusinessLocationsProto
             * @static
             * @param {waiternow.common.BusinessLocationsProto} message BusinessLocationsProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            BusinessLocationsProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.locations = [];
                if (message.locations && message.locations.length) {
                    object.locations = [];
                    for (var j = 0; j < message.locations.length; ++j)
                        object.locations[j] = $root.waiternow.common.LocationProto.toObject(message.locations[j], options);
                }
                return object;
            };

            /**
             * Converts this BusinessLocationsProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.BusinessLocationsProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            BusinessLocationsProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for BusinessLocationsProto
             * @function getTypeUrl
             * @memberof waiternow.common.BusinessLocationsProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            BusinessLocationsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.BusinessLocationsProto";
            };

            return BusinessLocationsProto;
        })();

        common.UserLocationsProto = (function() {

            /**
             * Properties of a UserLocationsProto.
             * @memberof waiternow.common
             * @interface IUserLocationsProto
             * @property {string|null} [userId] UserLocationsProto userId
             * @property {Array.<waiternow.common.UserLocationsProto.IManagedLocationProto>|null} [locations] UserLocationsProto locations
             */

            /**
             * Constructs a new UserLocationsProto.
             * @memberof waiternow.common
             * @classdesc Represents a UserLocationsProto.
             * @implements IUserLocationsProto
             * @constructor
             * @param {waiternow.common.IUserLocationsProto=} [properties] Properties to set
             */
            function UserLocationsProto(properties) {
                this.locations = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * UserLocationsProto userId.
             * @member {string} userId
             * @memberof waiternow.common.UserLocationsProto
             * @instance
             */
            UserLocationsProto.prototype.userId = "";

            /**
             * UserLocationsProto locations.
             * @member {Array.<waiternow.common.UserLocationsProto.IManagedLocationProto>} locations
             * @memberof waiternow.common.UserLocationsProto
             * @instance
             */
            UserLocationsProto.prototype.locations = $util.emptyArray;

            /**
             * Creates a new UserLocationsProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.UserLocationsProto
             * @static
             * @param {waiternow.common.IUserLocationsProto=} [properties] Properties to set
             * @returns {waiternow.common.UserLocationsProto} UserLocationsProto instance
             */
            UserLocationsProto.create = function create(properties) {
                return new UserLocationsProto(properties);
            };

            /**
             * Encodes the specified UserLocationsProto message. Does not implicitly {@link waiternow.common.UserLocationsProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.UserLocationsProto
             * @static
             * @param {waiternow.common.IUserLocationsProto} message UserLocationsProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UserLocationsProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.userId);
                if (message.locations != null && message.locations.length)
                    for (var i = 0; i < message.locations.length; ++i)
                        $root.waiternow.common.UserLocationsProto.ManagedLocationProto.encode(message.locations[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified UserLocationsProto message, length delimited. Does not implicitly {@link waiternow.common.UserLocationsProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.UserLocationsProto
             * @static
             * @param {waiternow.common.IUserLocationsProto} message UserLocationsProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UserLocationsProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a UserLocationsProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.UserLocationsProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.UserLocationsProto} UserLocationsProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UserLocationsProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.UserLocationsProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.userId = reader.string();
                            break;
                        }
                    case 2: {
                            if (!(message.locations && message.locations.length))
                                message.locations = [];
                            message.locations.push($root.waiternow.common.UserLocationsProto.ManagedLocationProto.decode(reader, reader.uint32()));
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a UserLocationsProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.UserLocationsProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.UserLocationsProto} UserLocationsProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UserLocationsProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a UserLocationsProto message.
             * @function verify
             * @memberof waiternow.common.UserLocationsProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            UserLocationsProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.userId != null && message.hasOwnProperty("userId"))
                    if (!$util.isString(message.userId))
                        return "userId: string expected";
                if (message.locations != null && message.hasOwnProperty("locations")) {
                    if (!Array.isArray(message.locations))
                        return "locations: array expected";
                    for (var i = 0; i < message.locations.length; ++i) {
                        var error = $root.waiternow.common.UserLocationsProto.ManagedLocationProto.verify(message.locations[i]);
                        if (error)
                            return "locations." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a UserLocationsProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.UserLocationsProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.UserLocationsProto} UserLocationsProto
             */
            UserLocationsProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.UserLocationsProto)
                    return object;
                var message = new $root.waiternow.common.UserLocationsProto();
                if (object.userId != null)
                    message.userId = String(object.userId);
                if (object.locations) {
                    if (!Array.isArray(object.locations))
                        throw TypeError(".waiternow.common.UserLocationsProto.locations: array expected");
                    message.locations = [];
                    for (var i = 0; i < object.locations.length; ++i) {
                        if (typeof object.locations[i] !== "object")
                            throw TypeError(".waiternow.common.UserLocationsProto.locations: object expected");
                        message.locations[i] = $root.waiternow.common.UserLocationsProto.ManagedLocationProto.fromObject(object.locations[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a UserLocationsProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.UserLocationsProto
             * @static
             * @param {waiternow.common.UserLocationsProto} message UserLocationsProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            UserLocationsProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.locations = [];
                if (options.defaults)
                    object.userId = "";
                if (message.userId != null && message.hasOwnProperty("userId"))
                    object.userId = message.userId;
                if (message.locations && message.locations.length) {
                    object.locations = [];
                    for (var j = 0; j < message.locations.length; ++j)
                        object.locations[j] = $root.waiternow.common.UserLocationsProto.ManagedLocationProto.toObject(message.locations[j], options);
                }
                return object;
            };

            /**
             * Converts this UserLocationsProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.UserLocationsProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            UserLocationsProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for UserLocationsProto
             * @function getTypeUrl
             * @memberof waiternow.common.UserLocationsProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            UserLocationsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.UserLocationsProto";
            };

            UserLocationsProto.ManagedLocationProto = (function() {

                /**
                 * Properties of a ManagedLocationProto.
                 * @memberof waiternow.common.UserLocationsProto
                 * @interface IManagedLocationProto
                 * @property {waiternow.common.ILocationProto|null} [location] ManagedLocationProto location
                 * @property {waiternow.common.Role|null} [userRole] ManagedLocationProto userRole
                 * @property {boolean|null} [hasOnsitePickup] ManagedLocationProto hasOnsitePickup
                 */

                /**
                 * Constructs a new ManagedLocationProto.
                 * @memberof waiternow.common.UserLocationsProto
                 * @classdesc Represents a ManagedLocationProto.
                 * @implements IManagedLocationProto
                 * @constructor
                 * @param {waiternow.common.UserLocationsProto.IManagedLocationProto=} [properties] Properties to set
                 */
                function ManagedLocationProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ManagedLocationProto location.
                 * @member {waiternow.common.ILocationProto|null|undefined} location
                 * @memberof waiternow.common.UserLocationsProto.ManagedLocationProto
                 * @instance
                 */
                ManagedLocationProto.prototype.location = null;

                /**
                 * ManagedLocationProto userRole.
                 * @member {waiternow.common.Role} userRole
                 * @memberof waiternow.common.UserLocationsProto.ManagedLocationProto
                 * @instance
                 */
                ManagedLocationProto.prototype.userRole = 0;

                /**
                 * ManagedLocationProto hasOnsitePickup.
                 * @member {boolean} hasOnsitePickup
                 * @memberof waiternow.common.UserLocationsProto.ManagedLocationProto
                 * @instance
                 */
                ManagedLocationProto.prototype.hasOnsitePickup = false;

                /**
                 * Creates a new ManagedLocationProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.UserLocationsProto.ManagedLocationProto
                 * @static
                 * @param {waiternow.common.UserLocationsProto.IManagedLocationProto=} [properties] Properties to set
                 * @returns {waiternow.common.UserLocationsProto.ManagedLocationProto} ManagedLocationProto instance
                 */
                ManagedLocationProto.create = function create(properties) {
                    return new ManagedLocationProto(properties);
                };

                /**
                 * Encodes the specified ManagedLocationProto message. Does not implicitly {@link waiternow.common.UserLocationsProto.ManagedLocationProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.UserLocationsProto.ManagedLocationProto
                 * @static
                 * @param {waiternow.common.UserLocationsProto.IManagedLocationProto} message ManagedLocationProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ManagedLocationProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.location != null && Object.hasOwnProperty.call(message, "location"))
                        $root.waiternow.common.LocationProto.encode(message.location, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.userRole != null && Object.hasOwnProperty.call(message, "userRole"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.userRole);
                    if (message.hasOnsitePickup != null && Object.hasOwnProperty.call(message, "hasOnsitePickup"))
                        writer.uint32(/* id 3, wireType 0 =*/24).bool(message.hasOnsitePickup);
                    return writer;
                };

                /**
                 * Encodes the specified ManagedLocationProto message, length delimited. Does not implicitly {@link waiternow.common.UserLocationsProto.ManagedLocationProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.UserLocationsProto.ManagedLocationProto
                 * @static
                 * @param {waiternow.common.UserLocationsProto.IManagedLocationProto} message ManagedLocationProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ManagedLocationProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ManagedLocationProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.UserLocationsProto.ManagedLocationProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.UserLocationsProto.ManagedLocationProto} ManagedLocationProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ManagedLocationProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.UserLocationsProto.ManagedLocationProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.location = $root.waiternow.common.LocationProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.userRole = reader.int32();
                                break;
                            }
                        case 3: {
                                message.hasOnsitePickup = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ManagedLocationProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.UserLocationsProto.ManagedLocationProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.UserLocationsProto.ManagedLocationProto} ManagedLocationProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ManagedLocationProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ManagedLocationProto message.
                 * @function verify
                 * @memberof waiternow.common.UserLocationsProto.ManagedLocationProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ManagedLocationProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.location != null && message.hasOwnProperty("location")) {
                        var error = $root.waiternow.common.LocationProto.verify(message.location);
                        if (error)
                            return "location." + error;
                    }
                    if (message.userRole != null && message.hasOwnProperty("userRole"))
                        switch (message.userRole) {
                        default:
                            return "userRole: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                            break;
                        }
                    if (message.hasOnsitePickup != null && message.hasOwnProperty("hasOnsitePickup"))
                        if (typeof message.hasOnsitePickup !== "boolean")
                            return "hasOnsitePickup: boolean expected";
                    return null;
                };

                /**
                 * Creates a ManagedLocationProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.UserLocationsProto.ManagedLocationProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.UserLocationsProto.ManagedLocationProto} ManagedLocationProto
                 */
                ManagedLocationProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.UserLocationsProto.ManagedLocationProto)
                        return object;
                    var message = new $root.waiternow.common.UserLocationsProto.ManagedLocationProto();
                    if (object.location != null) {
                        if (typeof object.location !== "object")
                            throw TypeError(".waiternow.common.UserLocationsProto.ManagedLocationProto.location: object expected");
                        message.location = $root.waiternow.common.LocationProto.fromObject(object.location);
                    }
                    switch (object.userRole) {
                    default:
                        if (typeof object.userRole === "number") {
                            message.userRole = object.userRole;
                            break;
                        }
                        break;
                    case "ROLE_UNSPECIFIED":
                    case 0:
                        message.userRole = 0;
                        break;
                    case "OWNER":
                    case 1:
                        message.userRole = 1;
                        break;
                    case "ADMIN":
                    case 2:
                        message.userRole = 2;
                        break;
                    case "VIEWER":
                    case 3:
                        message.userRole = 3;
                        break;
                    }
                    if (object.hasOnsitePickup != null)
                        message.hasOnsitePickup = Boolean(object.hasOnsitePickup);
                    return message;
                };

                /**
                 * Creates a plain object from a ManagedLocationProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.UserLocationsProto.ManagedLocationProto
                 * @static
                 * @param {waiternow.common.UserLocationsProto.ManagedLocationProto} message ManagedLocationProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ManagedLocationProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.location = null;
                        object.userRole = options.enums === String ? "ROLE_UNSPECIFIED" : 0;
                        object.hasOnsitePickup = false;
                    }
                    if (message.location != null && message.hasOwnProperty("location"))
                        object.location = $root.waiternow.common.LocationProto.toObject(message.location, options);
                    if (message.userRole != null && message.hasOwnProperty("userRole"))
                        object.userRole = options.enums === String ? $root.waiternow.common.Role[message.userRole] === undefined ? message.userRole : $root.waiternow.common.Role[message.userRole] : message.userRole;
                    if (message.hasOnsitePickup != null && message.hasOwnProperty("hasOnsitePickup"))
                        object.hasOnsitePickup = message.hasOnsitePickup;
                    return object;
                };

                /**
                 * Converts this ManagedLocationProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.UserLocationsProto.ManagedLocationProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ManagedLocationProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ManagedLocationProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.UserLocationsProto.ManagedLocationProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ManagedLocationProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.UserLocationsProto.ManagedLocationProto";
                };

                return ManagedLocationProto;
            })();

            return UserLocationsProto;
        })();

        common.LocationUsersProto = (function() {

            /**
             * Properties of a LocationUsersProto.
             * @memberof waiternow.common
             * @interface ILocationUsersProto
             * @property {string|null} [locationId] LocationUsersProto locationId
             * @property {Array.<waiternow.common.LocationUsersProto.IManagerUserProto>|null} [users] LocationUsersProto users
             */

            /**
             * Constructs a new LocationUsersProto.
             * @memberof waiternow.common
             * @classdesc Represents a LocationUsersProto.
             * @implements ILocationUsersProto
             * @constructor
             * @param {waiternow.common.ILocationUsersProto=} [properties] Properties to set
             */
            function LocationUsersProto(properties) {
                this.users = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * LocationUsersProto locationId.
             * @member {string} locationId
             * @memberof waiternow.common.LocationUsersProto
             * @instance
             */
            LocationUsersProto.prototype.locationId = "";

            /**
             * LocationUsersProto users.
             * @member {Array.<waiternow.common.LocationUsersProto.IManagerUserProto>} users
             * @memberof waiternow.common.LocationUsersProto
             * @instance
             */
            LocationUsersProto.prototype.users = $util.emptyArray;

            /**
             * Creates a new LocationUsersProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.LocationUsersProto
             * @static
             * @param {waiternow.common.ILocationUsersProto=} [properties] Properties to set
             * @returns {waiternow.common.LocationUsersProto} LocationUsersProto instance
             */
            LocationUsersProto.create = function create(properties) {
                return new LocationUsersProto(properties);
            };

            /**
             * Encodes the specified LocationUsersProto message. Does not implicitly {@link waiternow.common.LocationUsersProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.LocationUsersProto
             * @static
             * @param {waiternow.common.ILocationUsersProto} message LocationUsersProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            LocationUsersProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                if (message.users != null && message.users.length)
                    for (var i = 0; i < message.users.length; ++i)
                        $root.waiternow.common.LocationUsersProto.ManagerUserProto.encode(message.users[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified LocationUsersProto message, length delimited. Does not implicitly {@link waiternow.common.LocationUsersProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.LocationUsersProto
             * @static
             * @param {waiternow.common.ILocationUsersProto} message LocationUsersProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            LocationUsersProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a LocationUsersProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.LocationUsersProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.LocationUsersProto} LocationUsersProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            LocationUsersProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.LocationUsersProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.locationId = reader.string();
                            break;
                        }
                    case 2: {
                            if (!(message.users && message.users.length))
                                message.users = [];
                            message.users.push($root.waiternow.common.LocationUsersProto.ManagerUserProto.decode(reader, reader.uint32()));
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a LocationUsersProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.LocationUsersProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.LocationUsersProto} LocationUsersProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            LocationUsersProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a LocationUsersProto message.
             * @function verify
             * @memberof waiternow.common.LocationUsersProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            LocationUsersProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.locationId != null && message.hasOwnProperty("locationId"))
                    if (!$util.isString(message.locationId))
                        return "locationId: string expected";
                if (message.users != null && message.hasOwnProperty("users")) {
                    if (!Array.isArray(message.users))
                        return "users: array expected";
                    for (var i = 0; i < message.users.length; ++i) {
                        var error = $root.waiternow.common.LocationUsersProto.ManagerUserProto.verify(message.users[i]);
                        if (error)
                            return "users." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a LocationUsersProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.LocationUsersProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.LocationUsersProto} LocationUsersProto
             */
            LocationUsersProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.LocationUsersProto)
                    return object;
                var message = new $root.waiternow.common.LocationUsersProto();
                if (object.locationId != null)
                    message.locationId = String(object.locationId);
                if (object.users) {
                    if (!Array.isArray(object.users))
                        throw TypeError(".waiternow.common.LocationUsersProto.users: array expected");
                    message.users = [];
                    for (var i = 0; i < object.users.length; ++i) {
                        if (typeof object.users[i] !== "object")
                            throw TypeError(".waiternow.common.LocationUsersProto.users: object expected");
                        message.users[i] = $root.waiternow.common.LocationUsersProto.ManagerUserProto.fromObject(object.users[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a LocationUsersProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.LocationUsersProto
             * @static
             * @param {waiternow.common.LocationUsersProto} message LocationUsersProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            LocationUsersProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.users = [];
                if (options.defaults)
                    object.locationId = "";
                if (message.locationId != null && message.hasOwnProperty("locationId"))
                    object.locationId = message.locationId;
                if (message.users && message.users.length) {
                    object.users = [];
                    for (var j = 0; j < message.users.length; ++j)
                        object.users[j] = $root.waiternow.common.LocationUsersProto.ManagerUserProto.toObject(message.users[j], options);
                }
                return object;
            };

            /**
             * Converts this LocationUsersProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.LocationUsersProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            LocationUsersProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for LocationUsersProto
             * @function getTypeUrl
             * @memberof waiternow.common.LocationUsersProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            LocationUsersProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.LocationUsersProto";
            };

            LocationUsersProto.ManagerUserProto = (function() {

                /**
                 * Properties of a ManagerUserProto.
                 * @memberof waiternow.common.LocationUsersProto
                 * @interface IManagerUserProto
                 * @property {string|null} [userEmail] ManagerUserProto userEmail
                 * @property {waiternow.common.Role|null} [userRole] ManagerUserProto userRole
                 */

                /**
                 * Constructs a new ManagerUserProto.
                 * @memberof waiternow.common.LocationUsersProto
                 * @classdesc Represents a ManagerUserProto.
                 * @implements IManagerUserProto
                 * @constructor
                 * @param {waiternow.common.LocationUsersProto.IManagerUserProto=} [properties] Properties to set
                 */
                function ManagerUserProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ManagerUserProto userEmail.
                 * @member {string} userEmail
                 * @memberof waiternow.common.LocationUsersProto.ManagerUserProto
                 * @instance
                 */
                ManagerUserProto.prototype.userEmail = "";

                /**
                 * ManagerUserProto userRole.
                 * @member {waiternow.common.Role} userRole
                 * @memberof waiternow.common.LocationUsersProto.ManagerUserProto
                 * @instance
                 */
                ManagerUserProto.prototype.userRole = 0;

                /**
                 * Creates a new ManagerUserProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.LocationUsersProto.ManagerUserProto
                 * @static
                 * @param {waiternow.common.LocationUsersProto.IManagerUserProto=} [properties] Properties to set
                 * @returns {waiternow.common.LocationUsersProto.ManagerUserProto} ManagerUserProto instance
                 */
                ManagerUserProto.create = function create(properties) {
                    return new ManagerUserProto(properties);
                };

                /**
                 * Encodes the specified ManagerUserProto message. Does not implicitly {@link waiternow.common.LocationUsersProto.ManagerUserProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.LocationUsersProto.ManagerUserProto
                 * @static
                 * @param {waiternow.common.LocationUsersProto.IManagerUserProto} message ManagerUserProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ManagerUserProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.userEmail != null && Object.hasOwnProperty.call(message, "userEmail"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.userEmail);
                    if (message.userRole != null && Object.hasOwnProperty.call(message, "userRole"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.userRole);
                    return writer;
                };

                /**
                 * Encodes the specified ManagerUserProto message, length delimited. Does not implicitly {@link waiternow.common.LocationUsersProto.ManagerUserProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.LocationUsersProto.ManagerUserProto
                 * @static
                 * @param {waiternow.common.LocationUsersProto.IManagerUserProto} message ManagerUserProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ManagerUserProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ManagerUserProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.LocationUsersProto.ManagerUserProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.LocationUsersProto.ManagerUserProto} ManagerUserProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ManagerUserProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.LocationUsersProto.ManagerUserProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.userEmail = reader.string();
                                break;
                            }
                        case 2: {
                                message.userRole = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ManagerUserProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.LocationUsersProto.ManagerUserProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.LocationUsersProto.ManagerUserProto} ManagerUserProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ManagerUserProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ManagerUserProto message.
                 * @function verify
                 * @memberof waiternow.common.LocationUsersProto.ManagerUserProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ManagerUserProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.userEmail != null && message.hasOwnProperty("userEmail"))
                        if (!$util.isString(message.userEmail))
                            return "userEmail: string expected";
                    if (message.userRole != null && message.hasOwnProperty("userRole"))
                        switch (message.userRole) {
                        default:
                            return "userRole: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                            break;
                        }
                    return null;
                };

                /**
                 * Creates a ManagerUserProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.LocationUsersProto.ManagerUserProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.LocationUsersProto.ManagerUserProto} ManagerUserProto
                 */
                ManagerUserProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.LocationUsersProto.ManagerUserProto)
                        return object;
                    var message = new $root.waiternow.common.LocationUsersProto.ManagerUserProto();
                    if (object.userEmail != null)
                        message.userEmail = String(object.userEmail);
                    switch (object.userRole) {
                    default:
                        if (typeof object.userRole === "number") {
                            message.userRole = object.userRole;
                            break;
                        }
                        break;
                    case "ROLE_UNSPECIFIED":
                    case 0:
                        message.userRole = 0;
                        break;
                    case "OWNER":
                    case 1:
                        message.userRole = 1;
                        break;
                    case "ADMIN":
                    case 2:
                        message.userRole = 2;
                        break;
                    case "VIEWER":
                    case 3:
                        message.userRole = 3;
                        break;
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a ManagerUserProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.LocationUsersProto.ManagerUserProto
                 * @static
                 * @param {waiternow.common.LocationUsersProto.ManagerUserProto} message ManagerUserProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ManagerUserProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.userEmail = "";
                        object.userRole = options.enums === String ? "ROLE_UNSPECIFIED" : 0;
                    }
                    if (message.userEmail != null && message.hasOwnProperty("userEmail"))
                        object.userEmail = message.userEmail;
                    if (message.userRole != null && message.hasOwnProperty("userRole"))
                        object.userRole = options.enums === String ? $root.waiternow.common.Role[message.userRole] === undefined ? message.userRole : $root.waiternow.common.Role[message.userRole] : message.userRole;
                    return object;
                };

                /**
                 * Converts this ManagerUserProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.LocationUsersProto.ManagerUserProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ManagerUserProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ManagerUserProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.LocationUsersProto.ManagerUserProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ManagerUserProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.LocationUsersProto.ManagerUserProto";
                };

                return ManagerUserProto;
            })();

            return LocationUsersProto;
        })();

        common.LocationBusinessHoursProto = (function() {

            /**
             * Properties of a LocationBusinessHoursProto.
             * @memberof waiternow.common
             * @interface ILocationBusinessHoursProto
             * @property {string|null} [locationId] LocationBusinessHoursProto locationId
             * @property {waiternow.common.IBusinessHoursProto|null} [businessHours] LocationBusinessHoursProto businessHours
             * @property {string|null} [timeZone] LocationBusinessHoursProto timeZone
             * @property {boolean|null} [isLocationOnline] LocationBusinessHoursProto isLocationOnline
             * @property {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.IAlertConfigProto|null} [alertConfig] LocationBusinessHoursProto alertConfig
             * @property {google.protobuf.ITimestamp|null} [lastAlert] LocationBusinessHoursProto lastAlert
             * @property {waiternow.common.LocationBusinessHoursProto.IRedundantDataProto|null} [redundantData] LocationBusinessHoursProto redundantData
             */

            /**
             * Constructs a new LocationBusinessHoursProto.
             * @memberof waiternow.common
             * @classdesc Represents a LocationBusinessHoursProto.
             * @implements ILocationBusinessHoursProto
             * @constructor
             * @param {waiternow.common.ILocationBusinessHoursProto=} [properties] Properties to set
             */
            function LocationBusinessHoursProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * LocationBusinessHoursProto locationId.
             * @member {string} locationId
             * @memberof waiternow.common.LocationBusinessHoursProto
             * @instance
             */
            LocationBusinessHoursProto.prototype.locationId = "";

            /**
             * LocationBusinessHoursProto businessHours.
             * @member {waiternow.common.IBusinessHoursProto|null|undefined} businessHours
             * @memberof waiternow.common.LocationBusinessHoursProto
             * @instance
             */
            LocationBusinessHoursProto.prototype.businessHours = null;

            /**
             * LocationBusinessHoursProto timeZone.
             * @member {string} timeZone
             * @memberof waiternow.common.LocationBusinessHoursProto
             * @instance
             */
            LocationBusinessHoursProto.prototype.timeZone = "";

            /**
             * LocationBusinessHoursProto isLocationOnline.
             * @member {boolean} isLocationOnline
             * @memberof waiternow.common.LocationBusinessHoursProto
             * @instance
             */
            LocationBusinessHoursProto.prototype.isLocationOnline = false;

            /**
             * LocationBusinessHoursProto alertConfig.
             * @member {waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.IAlertConfigProto|null|undefined} alertConfig
             * @memberof waiternow.common.LocationBusinessHoursProto
             * @instance
             */
            LocationBusinessHoursProto.prototype.alertConfig = null;

            /**
             * LocationBusinessHoursProto lastAlert.
             * @member {google.protobuf.ITimestamp|null|undefined} lastAlert
             * @memberof waiternow.common.LocationBusinessHoursProto
             * @instance
             */
            LocationBusinessHoursProto.prototype.lastAlert = null;

            /**
             * LocationBusinessHoursProto redundantData.
             * @member {waiternow.common.LocationBusinessHoursProto.IRedundantDataProto|null|undefined} redundantData
             * @memberof waiternow.common.LocationBusinessHoursProto
             * @instance
             */
            LocationBusinessHoursProto.prototype.redundantData = null;

            /**
             * Creates a new LocationBusinessHoursProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.LocationBusinessHoursProto
             * @static
             * @param {waiternow.common.ILocationBusinessHoursProto=} [properties] Properties to set
             * @returns {waiternow.common.LocationBusinessHoursProto} LocationBusinessHoursProto instance
             */
            LocationBusinessHoursProto.create = function create(properties) {
                return new LocationBusinessHoursProto(properties);
            };

            /**
             * Encodes the specified LocationBusinessHoursProto message. Does not implicitly {@link waiternow.common.LocationBusinessHoursProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.LocationBusinessHoursProto
             * @static
             * @param {waiternow.common.ILocationBusinessHoursProto} message LocationBusinessHoursProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            LocationBusinessHoursProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                if (message.businessHours != null && Object.hasOwnProperty.call(message, "businessHours"))
                    $root.waiternow.common.BusinessHoursProto.encode(message.businessHours, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.timeZone != null && Object.hasOwnProperty.call(message, "timeZone"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.timeZone);
                if (message.isLocationOnline != null && Object.hasOwnProperty.call(message, "isLocationOnline"))
                    writer.uint32(/* id 4, wireType 0 =*/32).bool(message.isLocationOnline);
                if (message.alertConfig != null && Object.hasOwnProperty.call(message, "alertConfig"))
                    $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.AlertConfigProto.encode(message.alertConfig, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                if (message.lastAlert != null && Object.hasOwnProperty.call(message, "lastAlert"))
                    $root.google.protobuf.Timestamp.encode(message.lastAlert, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                if (message.redundantData != null && Object.hasOwnProperty.call(message, "redundantData"))
                    $root.waiternow.common.LocationBusinessHoursProto.RedundantDataProto.encode(message.redundantData, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified LocationBusinessHoursProto message, length delimited. Does not implicitly {@link waiternow.common.LocationBusinessHoursProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.LocationBusinessHoursProto
             * @static
             * @param {waiternow.common.ILocationBusinessHoursProto} message LocationBusinessHoursProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            LocationBusinessHoursProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a LocationBusinessHoursProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.LocationBusinessHoursProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.LocationBusinessHoursProto} LocationBusinessHoursProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            LocationBusinessHoursProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.LocationBusinessHoursProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.locationId = reader.string();
                            break;
                        }
                    case 2: {
                            message.businessHours = $root.waiternow.common.BusinessHoursProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 3: {
                            message.timeZone = reader.string();
                            break;
                        }
                    case 4: {
                            message.isLocationOnline = reader.bool();
                            break;
                        }
                    case 5: {
                            message.alertConfig = $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.AlertConfigProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 6: {
                            message.lastAlert = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 7: {
                            message.redundantData = $root.waiternow.common.LocationBusinessHoursProto.RedundantDataProto.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a LocationBusinessHoursProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.LocationBusinessHoursProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.LocationBusinessHoursProto} LocationBusinessHoursProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            LocationBusinessHoursProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a LocationBusinessHoursProto message.
             * @function verify
             * @memberof waiternow.common.LocationBusinessHoursProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            LocationBusinessHoursProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.locationId != null && message.hasOwnProperty("locationId"))
                    if (!$util.isString(message.locationId))
                        return "locationId: string expected";
                if (message.businessHours != null && message.hasOwnProperty("businessHours")) {
                    var error = $root.waiternow.common.BusinessHoursProto.verify(message.businessHours);
                    if (error)
                        return "businessHours." + error;
                }
                if (message.timeZone != null && message.hasOwnProperty("timeZone"))
                    if (!$util.isString(message.timeZone))
                        return "timeZone: string expected";
                if (message.isLocationOnline != null && message.hasOwnProperty("isLocationOnline"))
                    if (typeof message.isLocationOnline !== "boolean")
                        return "isLocationOnline: boolean expected";
                if (message.alertConfig != null && message.hasOwnProperty("alertConfig")) {
                    var error = $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.AlertConfigProto.verify(message.alertConfig);
                    if (error)
                        return "alertConfig." + error;
                }
                if (message.lastAlert != null && message.hasOwnProperty("lastAlert")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.lastAlert);
                    if (error)
                        return "lastAlert." + error;
                }
                if (message.redundantData != null && message.hasOwnProperty("redundantData")) {
                    var error = $root.waiternow.common.LocationBusinessHoursProto.RedundantDataProto.verify(message.redundantData);
                    if (error)
                        return "redundantData." + error;
                }
                return null;
            };

            /**
             * Creates a LocationBusinessHoursProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.LocationBusinessHoursProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.LocationBusinessHoursProto} LocationBusinessHoursProto
             */
            LocationBusinessHoursProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.LocationBusinessHoursProto)
                    return object;
                var message = new $root.waiternow.common.LocationBusinessHoursProto();
                if (object.locationId != null)
                    message.locationId = String(object.locationId);
                if (object.businessHours != null) {
                    if (typeof object.businessHours !== "object")
                        throw TypeError(".waiternow.common.LocationBusinessHoursProto.businessHours: object expected");
                    message.businessHours = $root.waiternow.common.BusinessHoursProto.fromObject(object.businessHours);
                }
                if (object.timeZone != null)
                    message.timeZone = String(object.timeZone);
                if (object.isLocationOnline != null)
                    message.isLocationOnline = Boolean(object.isLocationOnline);
                if (object.alertConfig != null) {
                    if (typeof object.alertConfig !== "object")
                        throw TypeError(".waiternow.common.LocationBusinessHoursProto.alertConfig: object expected");
                    message.alertConfig = $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.AlertConfigProto.fromObject(object.alertConfig);
                }
                if (object.lastAlert != null) {
                    if (typeof object.lastAlert !== "object")
                        throw TypeError(".waiternow.common.LocationBusinessHoursProto.lastAlert: object expected");
                    message.lastAlert = $root.google.protobuf.Timestamp.fromObject(object.lastAlert);
                }
                if (object.redundantData != null) {
                    if (typeof object.redundantData !== "object")
                        throw TypeError(".waiternow.common.LocationBusinessHoursProto.redundantData: object expected");
                    message.redundantData = $root.waiternow.common.LocationBusinessHoursProto.RedundantDataProto.fromObject(object.redundantData);
                }
                return message;
            };

            /**
             * Creates a plain object from a LocationBusinessHoursProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.LocationBusinessHoursProto
             * @static
             * @param {waiternow.common.LocationBusinessHoursProto} message LocationBusinessHoursProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            LocationBusinessHoursProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.locationId = "";
                    object.businessHours = null;
                    object.timeZone = "";
                    object.isLocationOnline = false;
                    object.alertConfig = null;
                    object.lastAlert = null;
                    object.redundantData = null;
                }
                if (message.locationId != null && message.hasOwnProperty("locationId"))
                    object.locationId = message.locationId;
                if (message.businessHours != null && message.hasOwnProperty("businessHours"))
                    object.businessHours = $root.waiternow.common.BusinessHoursProto.toObject(message.businessHours, options);
                if (message.timeZone != null && message.hasOwnProperty("timeZone"))
                    object.timeZone = message.timeZone;
                if (message.isLocationOnline != null && message.hasOwnProperty("isLocationOnline"))
                    object.isLocationOnline = message.isLocationOnline;
                if (message.alertConfig != null && message.hasOwnProperty("alertConfig"))
                    object.alertConfig = $root.waiternow.common.LocationProto.SettingsProto.OperationSettingsProto.AlertConfigProto.toObject(message.alertConfig, options);
                if (message.lastAlert != null && message.hasOwnProperty("lastAlert"))
                    object.lastAlert = $root.google.protobuf.Timestamp.toObject(message.lastAlert, options);
                if (message.redundantData != null && message.hasOwnProperty("redundantData"))
                    object.redundantData = $root.waiternow.common.LocationBusinessHoursProto.RedundantDataProto.toObject(message.redundantData, options);
                return object;
            };

            /**
             * Converts this LocationBusinessHoursProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.LocationBusinessHoursProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            LocationBusinessHoursProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for LocationBusinessHoursProto
             * @function getTypeUrl
             * @memberof waiternow.common.LocationBusinessHoursProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            LocationBusinessHoursProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.LocationBusinessHoursProto";
            };

            LocationBusinessHoursProto.RedundantDataProto = (function() {

                /**
                 * Properties of a RedundantDataProto.
                 * @memberof waiternow.common.LocationBusinessHoursProto
                 * @interface IRedundantDataProto
                 * @property {string|null} [businessName] RedundantDataProto businessName
                 * @property {string|null} [locationName] RedundantDataProto locationName
                 * @property {waiternow.common.IAddressProto|null} [locationAddress] RedundantDataProto locationAddress
                 * @property {waiternow.common.IPhoneNumberProto|null} [locationPhoneNumber] RedundantDataProto locationPhoneNumber
                 */

                /**
                 * Constructs a new RedundantDataProto.
                 * @memberof waiternow.common.LocationBusinessHoursProto
                 * @classdesc Represents a RedundantDataProto.
                 * @implements IRedundantDataProto
                 * @constructor
                 * @param {waiternow.common.LocationBusinessHoursProto.IRedundantDataProto=} [properties] Properties to set
                 */
                function RedundantDataProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * RedundantDataProto businessName.
                 * @member {string} businessName
                 * @memberof waiternow.common.LocationBusinessHoursProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.businessName = "";

                /**
                 * RedundantDataProto locationName.
                 * @member {string} locationName
                 * @memberof waiternow.common.LocationBusinessHoursProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.locationName = "";

                /**
                 * RedundantDataProto locationAddress.
                 * @member {waiternow.common.IAddressProto|null|undefined} locationAddress
                 * @memberof waiternow.common.LocationBusinessHoursProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.locationAddress = null;

                /**
                 * RedundantDataProto locationPhoneNumber.
                 * @member {waiternow.common.IPhoneNumberProto|null|undefined} locationPhoneNumber
                 * @memberof waiternow.common.LocationBusinessHoursProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.locationPhoneNumber = null;

                /**
                 * Creates a new RedundantDataProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.LocationBusinessHoursProto.RedundantDataProto
                 * @static
                 * @param {waiternow.common.LocationBusinessHoursProto.IRedundantDataProto=} [properties] Properties to set
                 * @returns {waiternow.common.LocationBusinessHoursProto.RedundantDataProto} RedundantDataProto instance
                 */
                RedundantDataProto.create = function create(properties) {
                    return new RedundantDataProto(properties);
                };

                /**
                 * Encodes the specified RedundantDataProto message. Does not implicitly {@link waiternow.common.LocationBusinessHoursProto.RedundantDataProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.LocationBusinessHoursProto.RedundantDataProto
                 * @static
                 * @param {waiternow.common.LocationBusinessHoursProto.IRedundantDataProto} message RedundantDataProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RedundantDataProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.businessName != null && Object.hasOwnProperty.call(message, "businessName"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessName);
                    if (message.locationAddress != null && Object.hasOwnProperty.call(message, "locationAddress"))
                        $root.waiternow.common.AddressProto.encode(message.locationAddress, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.locationName != null && Object.hasOwnProperty.call(message, "locationName"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.locationName);
                    if (message.locationPhoneNumber != null && Object.hasOwnProperty.call(message, "locationPhoneNumber"))
                        $root.waiternow.common.PhoneNumberProto.encode(message.locationPhoneNumber, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified RedundantDataProto message, length delimited. Does not implicitly {@link waiternow.common.LocationBusinessHoursProto.RedundantDataProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.LocationBusinessHoursProto.RedundantDataProto
                 * @static
                 * @param {waiternow.common.LocationBusinessHoursProto.IRedundantDataProto} message RedundantDataProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RedundantDataProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a RedundantDataProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.LocationBusinessHoursProto.RedundantDataProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.LocationBusinessHoursProto.RedundantDataProto} RedundantDataProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RedundantDataProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.LocationBusinessHoursProto.RedundantDataProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.businessName = reader.string();
                                break;
                            }
                        case 3: {
                                message.locationName = reader.string();
                                break;
                            }
                        case 2: {
                                message.locationAddress = $root.waiternow.common.AddressProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 4: {
                                message.locationPhoneNumber = $root.waiternow.common.PhoneNumberProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a RedundantDataProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.LocationBusinessHoursProto.RedundantDataProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.LocationBusinessHoursProto.RedundantDataProto} RedundantDataProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RedundantDataProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a RedundantDataProto message.
                 * @function verify
                 * @memberof waiternow.common.LocationBusinessHoursProto.RedundantDataProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                RedundantDataProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.businessName != null && message.hasOwnProperty("businessName"))
                        if (!$util.isString(message.businessName))
                            return "businessName: string expected";
                    if (message.locationName != null && message.hasOwnProperty("locationName"))
                        if (!$util.isString(message.locationName))
                            return "locationName: string expected";
                    if (message.locationAddress != null && message.hasOwnProperty("locationAddress")) {
                        var error = $root.waiternow.common.AddressProto.verify(message.locationAddress);
                        if (error)
                            return "locationAddress." + error;
                    }
                    if (message.locationPhoneNumber != null && message.hasOwnProperty("locationPhoneNumber")) {
                        var error = $root.waiternow.common.PhoneNumberProto.verify(message.locationPhoneNumber);
                        if (error)
                            return "locationPhoneNumber." + error;
                    }
                    return null;
                };

                /**
                 * Creates a RedundantDataProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.LocationBusinessHoursProto.RedundantDataProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.LocationBusinessHoursProto.RedundantDataProto} RedundantDataProto
                 */
                RedundantDataProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.LocationBusinessHoursProto.RedundantDataProto)
                        return object;
                    var message = new $root.waiternow.common.LocationBusinessHoursProto.RedundantDataProto();
                    if (object.businessName != null)
                        message.businessName = String(object.businessName);
                    if (object.locationName != null)
                        message.locationName = String(object.locationName);
                    if (object.locationAddress != null) {
                        if (typeof object.locationAddress !== "object")
                            throw TypeError(".waiternow.common.LocationBusinessHoursProto.RedundantDataProto.locationAddress: object expected");
                        message.locationAddress = $root.waiternow.common.AddressProto.fromObject(object.locationAddress);
                    }
                    if (object.locationPhoneNumber != null) {
                        if (typeof object.locationPhoneNumber !== "object")
                            throw TypeError(".waiternow.common.LocationBusinessHoursProto.RedundantDataProto.locationPhoneNumber: object expected");
                        message.locationPhoneNumber = $root.waiternow.common.PhoneNumberProto.fromObject(object.locationPhoneNumber);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a RedundantDataProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.LocationBusinessHoursProto.RedundantDataProto
                 * @static
                 * @param {waiternow.common.LocationBusinessHoursProto.RedundantDataProto} message RedundantDataProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                RedundantDataProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.businessName = "";
                        object.locationAddress = null;
                        object.locationName = "";
                        object.locationPhoneNumber = null;
                    }
                    if (message.businessName != null && message.hasOwnProperty("businessName"))
                        object.businessName = message.businessName;
                    if (message.locationAddress != null && message.hasOwnProperty("locationAddress"))
                        object.locationAddress = $root.waiternow.common.AddressProto.toObject(message.locationAddress, options);
                    if (message.locationName != null && message.hasOwnProperty("locationName"))
                        object.locationName = message.locationName;
                    if (message.locationPhoneNumber != null && message.hasOwnProperty("locationPhoneNumber"))
                        object.locationPhoneNumber = $root.waiternow.common.PhoneNumberProto.toObject(message.locationPhoneNumber, options);
                    return object;
                };

                /**
                 * Converts this RedundantDataProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.LocationBusinessHoursProto.RedundantDataProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                RedundantDataProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for RedundantDataProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.LocationBusinessHoursProto.RedundantDataProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                RedundantDataProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.LocationBusinessHoursProto.RedundantDataProto";
                };

                return RedundantDataProto;
            })();

            return LocationBusinessHoursProto;
        })();

        common.ImageMenuProto = (function() {

            /**
             * Properties of an ImageMenuProto.
             * @memberof waiternow.common
             * @interface IImageMenuProto
             * @property {Array.<waiternow.common.ImageMenuProto.ICategoryProto>|null} [categories] ImageMenuProto categories
             */

            /**
             * Constructs a new ImageMenuProto.
             * @memberof waiternow.common
             * @classdesc Represents an ImageMenuProto.
             * @implements IImageMenuProto
             * @constructor
             * @param {waiternow.common.IImageMenuProto=} [properties] Properties to set
             */
            function ImageMenuProto(properties) {
                this.categories = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ImageMenuProto categories.
             * @member {Array.<waiternow.common.ImageMenuProto.ICategoryProto>} categories
             * @memberof waiternow.common.ImageMenuProto
             * @instance
             */
            ImageMenuProto.prototype.categories = $util.emptyArray;

            /**
             * Creates a new ImageMenuProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.ImageMenuProto
             * @static
             * @param {waiternow.common.IImageMenuProto=} [properties] Properties to set
             * @returns {waiternow.common.ImageMenuProto} ImageMenuProto instance
             */
            ImageMenuProto.create = function create(properties) {
                return new ImageMenuProto(properties);
            };

            /**
             * Encodes the specified ImageMenuProto message. Does not implicitly {@link waiternow.common.ImageMenuProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.ImageMenuProto
             * @static
             * @param {waiternow.common.IImageMenuProto} message ImageMenuProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ImageMenuProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.categories != null && message.categories.length)
                    for (var i = 0; i < message.categories.length; ++i)
                        $root.waiternow.common.ImageMenuProto.CategoryProto.encode(message.categories[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified ImageMenuProto message, length delimited. Does not implicitly {@link waiternow.common.ImageMenuProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.ImageMenuProto
             * @static
             * @param {waiternow.common.IImageMenuProto} message ImageMenuProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ImageMenuProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an ImageMenuProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.ImageMenuProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.ImageMenuProto} ImageMenuProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ImageMenuProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.ImageMenuProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            if (!(message.categories && message.categories.length))
                                message.categories = [];
                            message.categories.push($root.waiternow.common.ImageMenuProto.CategoryProto.decode(reader, reader.uint32()));
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an ImageMenuProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.ImageMenuProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.ImageMenuProto} ImageMenuProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ImageMenuProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an ImageMenuProto message.
             * @function verify
             * @memberof waiternow.common.ImageMenuProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ImageMenuProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.categories != null && message.hasOwnProperty("categories")) {
                    if (!Array.isArray(message.categories))
                        return "categories: array expected";
                    for (var i = 0; i < message.categories.length; ++i) {
                        var error = $root.waiternow.common.ImageMenuProto.CategoryProto.verify(message.categories[i]);
                        if (error)
                            return "categories." + error;
                    }
                }
                return null;
            };

            /**
             * Creates an ImageMenuProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.ImageMenuProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.ImageMenuProto} ImageMenuProto
             */
            ImageMenuProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.ImageMenuProto)
                    return object;
                var message = new $root.waiternow.common.ImageMenuProto();
                if (object.categories) {
                    if (!Array.isArray(object.categories))
                        throw TypeError(".waiternow.common.ImageMenuProto.categories: array expected");
                    message.categories = [];
                    for (var i = 0; i < object.categories.length; ++i) {
                        if (typeof object.categories[i] !== "object")
                            throw TypeError(".waiternow.common.ImageMenuProto.categories: object expected");
                        message.categories[i] = $root.waiternow.common.ImageMenuProto.CategoryProto.fromObject(object.categories[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from an ImageMenuProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.ImageMenuProto
             * @static
             * @param {waiternow.common.ImageMenuProto} message ImageMenuProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ImageMenuProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.categories = [];
                if (message.categories && message.categories.length) {
                    object.categories = [];
                    for (var j = 0; j < message.categories.length; ++j)
                        object.categories[j] = $root.waiternow.common.ImageMenuProto.CategoryProto.toObject(message.categories[j], options);
                }
                return object;
            };

            /**
             * Converts this ImageMenuProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.ImageMenuProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ImageMenuProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for ImageMenuProto
             * @function getTypeUrl
             * @memberof waiternow.common.ImageMenuProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            ImageMenuProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.ImageMenuProto";
            };

            ImageMenuProto.CategoryProto = (function() {

                /**
                 * Properties of a CategoryProto.
                 * @memberof waiternow.common.ImageMenuProto
                 * @interface ICategoryProto
                 * @property {string|null} [name] CategoryProto name
                 * @property {Array.<waiternow.common.IImageProto>|null} [images] CategoryProto images
                 */

                /**
                 * Constructs a new CategoryProto.
                 * @memberof waiternow.common.ImageMenuProto
                 * @classdesc Represents a CategoryProto.
                 * @implements ICategoryProto
                 * @constructor
                 * @param {waiternow.common.ImageMenuProto.ICategoryProto=} [properties] Properties to set
                 */
                function CategoryProto(properties) {
                    this.images = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * CategoryProto name.
                 * @member {string} name
                 * @memberof waiternow.common.ImageMenuProto.CategoryProto
                 * @instance
                 */
                CategoryProto.prototype.name = "";

                /**
                 * CategoryProto images.
                 * @member {Array.<waiternow.common.IImageProto>} images
                 * @memberof waiternow.common.ImageMenuProto.CategoryProto
                 * @instance
                 */
                CategoryProto.prototype.images = $util.emptyArray;

                /**
                 * Creates a new CategoryProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.ImageMenuProto.CategoryProto
                 * @static
                 * @param {waiternow.common.ImageMenuProto.ICategoryProto=} [properties] Properties to set
                 * @returns {waiternow.common.ImageMenuProto.CategoryProto} CategoryProto instance
                 */
                CategoryProto.create = function create(properties) {
                    return new CategoryProto(properties);
                };

                /**
                 * Encodes the specified CategoryProto message. Does not implicitly {@link waiternow.common.ImageMenuProto.CategoryProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.ImageMenuProto.CategoryProto
                 * @static
                 * @param {waiternow.common.ImageMenuProto.ICategoryProto} message CategoryProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CategoryProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                    if (message.images != null && message.images.length)
                        for (var i = 0; i < message.images.length; ++i)
                            $root.waiternow.common.ImageProto.encode(message.images[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified CategoryProto message, length delimited. Does not implicitly {@link waiternow.common.ImageMenuProto.CategoryProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.ImageMenuProto.CategoryProto
                 * @static
                 * @param {waiternow.common.ImageMenuProto.ICategoryProto} message CategoryProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CategoryProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a CategoryProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.ImageMenuProto.CategoryProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.ImageMenuProto.CategoryProto} CategoryProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CategoryProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.ImageMenuProto.CategoryProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.name = reader.string();
                                break;
                            }
                        case 2: {
                                if (!(message.images && message.images.length))
                                    message.images = [];
                                message.images.push($root.waiternow.common.ImageProto.decode(reader, reader.uint32()));
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a CategoryProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.ImageMenuProto.CategoryProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.ImageMenuProto.CategoryProto} CategoryProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CategoryProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a CategoryProto message.
                 * @function verify
                 * @memberof waiternow.common.ImageMenuProto.CategoryProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                CategoryProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.name != null && message.hasOwnProperty("name"))
                        if (!$util.isString(message.name))
                            return "name: string expected";
                    if (message.images != null && message.hasOwnProperty("images")) {
                        if (!Array.isArray(message.images))
                            return "images: array expected";
                        for (var i = 0; i < message.images.length; ++i) {
                            var error = $root.waiternow.common.ImageProto.verify(message.images[i]);
                            if (error)
                                return "images." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a CategoryProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.ImageMenuProto.CategoryProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.ImageMenuProto.CategoryProto} CategoryProto
                 */
                CategoryProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.ImageMenuProto.CategoryProto)
                        return object;
                    var message = new $root.waiternow.common.ImageMenuProto.CategoryProto();
                    if (object.name != null)
                        message.name = String(object.name);
                    if (object.images) {
                        if (!Array.isArray(object.images))
                            throw TypeError(".waiternow.common.ImageMenuProto.CategoryProto.images: array expected");
                        message.images = [];
                        for (var i = 0; i < object.images.length; ++i) {
                            if (typeof object.images[i] !== "object")
                                throw TypeError(".waiternow.common.ImageMenuProto.CategoryProto.images: object expected");
                            message.images[i] = $root.waiternow.common.ImageProto.fromObject(object.images[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a CategoryProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.ImageMenuProto.CategoryProto
                 * @static
                 * @param {waiternow.common.ImageMenuProto.CategoryProto} message CategoryProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                CategoryProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.images = [];
                    if (options.defaults)
                        object.name = "";
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = message.name;
                    if (message.images && message.images.length) {
                        object.images = [];
                        for (var j = 0; j < message.images.length; ++j)
                            object.images[j] = $root.waiternow.common.ImageProto.toObject(message.images[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this CategoryProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.ImageMenuProto.CategoryProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                CategoryProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for CategoryProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.ImageMenuProto.CategoryProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                CategoryProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.ImageMenuProto.CategoryProto";
                };

                return CategoryProto;
            })();

            return ImageMenuProto;
        })();

        common.AvailabilityScheduleProto = (function() {

            /**
             * Properties of an AvailabilityScheduleProto.
             * @memberof waiternow.common
             * @interface IAvailabilityScheduleProto
             * @property {string|null} [id] AvailabilityScheduleProto id
             * @property {waiternow.common.IScheduleProto|null} [schedule] AvailabilityScheduleProto schedule
             */

            /**
             * Constructs a new AvailabilityScheduleProto.
             * @memberof waiternow.common
             * @classdesc Represents an AvailabilityScheduleProto.
             * @implements IAvailabilityScheduleProto
             * @constructor
             * @param {waiternow.common.IAvailabilityScheduleProto=} [properties] Properties to set
             */
            function AvailabilityScheduleProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AvailabilityScheduleProto id.
             * @member {string} id
             * @memberof waiternow.common.AvailabilityScheduleProto
             * @instance
             */
            AvailabilityScheduleProto.prototype.id = "";

            /**
             * AvailabilityScheduleProto schedule.
             * @member {waiternow.common.IScheduleProto|null|undefined} schedule
             * @memberof waiternow.common.AvailabilityScheduleProto
             * @instance
             */
            AvailabilityScheduleProto.prototype.schedule = null;

            /**
             * Creates a new AvailabilityScheduleProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.AvailabilityScheduleProto
             * @static
             * @param {waiternow.common.IAvailabilityScheduleProto=} [properties] Properties to set
             * @returns {waiternow.common.AvailabilityScheduleProto} AvailabilityScheduleProto instance
             */
            AvailabilityScheduleProto.create = function create(properties) {
                return new AvailabilityScheduleProto(properties);
            };

            /**
             * Encodes the specified AvailabilityScheduleProto message. Does not implicitly {@link waiternow.common.AvailabilityScheduleProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.AvailabilityScheduleProto
             * @static
             * @param {waiternow.common.IAvailabilityScheduleProto} message AvailabilityScheduleProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AvailabilityScheduleProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                if (message.schedule != null && Object.hasOwnProperty.call(message, "schedule"))
                    $root.waiternow.common.ScheduleProto.encode(message.schedule, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified AvailabilityScheduleProto message, length delimited. Does not implicitly {@link waiternow.common.AvailabilityScheduleProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.AvailabilityScheduleProto
             * @static
             * @param {waiternow.common.IAvailabilityScheduleProto} message AvailabilityScheduleProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AvailabilityScheduleProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AvailabilityScheduleProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.AvailabilityScheduleProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.AvailabilityScheduleProto} AvailabilityScheduleProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AvailabilityScheduleProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.AvailabilityScheduleProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.id = reader.string();
                            break;
                        }
                    case 2: {
                            message.schedule = $root.waiternow.common.ScheduleProto.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AvailabilityScheduleProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.AvailabilityScheduleProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.AvailabilityScheduleProto} AvailabilityScheduleProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AvailabilityScheduleProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AvailabilityScheduleProto message.
             * @function verify
             * @memberof waiternow.common.AvailabilityScheduleProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AvailabilityScheduleProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.id != null && message.hasOwnProperty("id"))
                    if (!$util.isString(message.id))
                        return "id: string expected";
                if (message.schedule != null && message.hasOwnProperty("schedule")) {
                    var error = $root.waiternow.common.ScheduleProto.verify(message.schedule);
                    if (error)
                        return "schedule." + error;
                }
                return null;
            };

            /**
             * Creates an AvailabilityScheduleProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.AvailabilityScheduleProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.AvailabilityScheduleProto} AvailabilityScheduleProto
             */
            AvailabilityScheduleProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.AvailabilityScheduleProto)
                    return object;
                var message = new $root.waiternow.common.AvailabilityScheduleProto();
                if (object.id != null)
                    message.id = String(object.id);
                if (object.schedule != null) {
                    if (typeof object.schedule !== "object")
                        throw TypeError(".waiternow.common.AvailabilityScheduleProto.schedule: object expected");
                    message.schedule = $root.waiternow.common.ScheduleProto.fromObject(object.schedule);
                }
                return message;
            };

            /**
             * Creates a plain object from an AvailabilityScheduleProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.AvailabilityScheduleProto
             * @static
             * @param {waiternow.common.AvailabilityScheduleProto} message AvailabilityScheduleProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AvailabilityScheduleProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.id = "";
                    object.schedule = null;
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                if (message.schedule != null && message.hasOwnProperty("schedule"))
                    object.schedule = $root.waiternow.common.ScheduleProto.toObject(message.schedule, options);
                return object;
            };

            /**
             * Converts this AvailabilityScheduleProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.AvailabilityScheduleProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AvailabilityScheduleProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for AvailabilityScheduleProto
             * @function getTypeUrl
             * @memberof waiternow.common.AvailabilityScheduleProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            AvailabilityScheduleProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.AvailabilityScheduleProto";
            };

            return AvailabilityScheduleProto;
        })();

        common.MenuSpecProto = (function() {

            /**
             * Properties of a MenuSpecProto.
             * @memberof waiternow.common
             * @interface IMenuSpecProto
             * @property {waiternow.common.IImageProto|null} [headerImage] MenuSpecProto headerImage
             * @property {Array.<waiternow.common.MenuSpecProto.ICategoryProto>|null} [categories] MenuSpecProto categories
             * @property {Array.<waiternow.common.MenuSpecProto.IItemProto>|null} [items] MenuSpecProto items
             * @property {Array.<waiternow.common.MenuSpecProto.IItemSelectionProto>|null} [itemSelections] MenuSpecProto itemSelections
             * @property {Array.<waiternow.common.MenuSpecProto.IMenuItemProto>|null} [menuItems] MenuSpecProto menuItems
             * @property {Array.<waiternow.common.MenuSpecProto.IMenuItemSelectionProto>|null} [menuItemSelections] MenuSpecProto menuItemSelections
             * @property {Array.<waiternow.common.MenuSpecProto.IComboProto>|null} [combos] MenuSpecProto combos
             * @property {Array.<waiternow.common.IAvailabilityScheduleProto>|null} [schedules] MenuSpecProto schedules
             */

            /**
             * Constructs a new MenuSpecProto.
             * @memberof waiternow.common
             * @classdesc Represents a MenuSpecProto.
             * @implements IMenuSpecProto
             * @constructor
             * @param {waiternow.common.IMenuSpecProto=} [properties] Properties to set
             */
            function MenuSpecProto(properties) {
                this.categories = [];
                this.items = [];
                this.itemSelections = [];
                this.menuItems = [];
                this.menuItemSelections = [];
                this.combos = [];
                this.schedules = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * MenuSpecProto headerImage.
             * @member {waiternow.common.IImageProto|null|undefined} headerImage
             * @memberof waiternow.common.MenuSpecProto
             * @instance
             */
            MenuSpecProto.prototype.headerImage = null;

            /**
             * MenuSpecProto categories.
             * @member {Array.<waiternow.common.MenuSpecProto.ICategoryProto>} categories
             * @memberof waiternow.common.MenuSpecProto
             * @instance
             */
            MenuSpecProto.prototype.categories = $util.emptyArray;

            /**
             * MenuSpecProto items.
             * @member {Array.<waiternow.common.MenuSpecProto.IItemProto>} items
             * @memberof waiternow.common.MenuSpecProto
             * @instance
             */
            MenuSpecProto.prototype.items = $util.emptyArray;

            /**
             * MenuSpecProto itemSelections.
             * @member {Array.<waiternow.common.MenuSpecProto.IItemSelectionProto>} itemSelections
             * @memberof waiternow.common.MenuSpecProto
             * @instance
             */
            MenuSpecProto.prototype.itemSelections = $util.emptyArray;

            /**
             * MenuSpecProto menuItems.
             * @member {Array.<waiternow.common.MenuSpecProto.IMenuItemProto>} menuItems
             * @memberof waiternow.common.MenuSpecProto
             * @instance
             */
            MenuSpecProto.prototype.menuItems = $util.emptyArray;

            /**
             * MenuSpecProto menuItemSelections.
             * @member {Array.<waiternow.common.MenuSpecProto.IMenuItemSelectionProto>} menuItemSelections
             * @memberof waiternow.common.MenuSpecProto
             * @instance
             */
            MenuSpecProto.prototype.menuItemSelections = $util.emptyArray;

            /**
             * MenuSpecProto combos.
             * @member {Array.<waiternow.common.MenuSpecProto.IComboProto>} combos
             * @memberof waiternow.common.MenuSpecProto
             * @instance
             */
            MenuSpecProto.prototype.combos = $util.emptyArray;

            /**
             * MenuSpecProto schedules.
             * @member {Array.<waiternow.common.IAvailabilityScheduleProto>} schedules
             * @memberof waiternow.common.MenuSpecProto
             * @instance
             */
            MenuSpecProto.prototype.schedules = $util.emptyArray;

            /**
             * Creates a new MenuSpecProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.MenuSpecProto
             * @static
             * @param {waiternow.common.IMenuSpecProto=} [properties] Properties to set
             * @returns {waiternow.common.MenuSpecProto} MenuSpecProto instance
             */
            MenuSpecProto.create = function create(properties) {
                return new MenuSpecProto(properties);
            };

            /**
             * Encodes the specified MenuSpecProto message. Does not implicitly {@link waiternow.common.MenuSpecProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.MenuSpecProto
             * @static
             * @param {waiternow.common.IMenuSpecProto} message MenuSpecProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MenuSpecProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.headerImage != null && Object.hasOwnProperty.call(message, "headerImage"))
                    $root.waiternow.common.ImageProto.encode(message.headerImage, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.categories != null && message.categories.length)
                    for (var i = 0; i < message.categories.length; ++i)
                        $root.waiternow.common.MenuSpecProto.CategoryProto.encode(message.categories[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.items != null && message.items.length)
                    for (var i = 0; i < message.items.length; ++i)
                        $root.waiternow.common.MenuSpecProto.ItemProto.encode(message.items[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.itemSelections != null && message.itemSelections.length)
                    for (var i = 0; i < message.itemSelections.length; ++i)
                        $root.waiternow.common.MenuSpecProto.ItemSelectionProto.encode(message.itemSelections[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                if (message.menuItems != null && message.menuItems.length)
                    for (var i = 0; i < message.menuItems.length; ++i)
                        $root.waiternow.common.MenuSpecProto.MenuItemProto.encode(message.menuItems[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                if (message.menuItemSelections != null && message.menuItemSelections.length)
                    for (var i = 0; i < message.menuItemSelections.length; ++i)
                        $root.waiternow.common.MenuSpecProto.MenuItemSelectionProto.encode(message.menuItemSelections[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                if (message.combos != null && message.combos.length)
                    for (var i = 0; i < message.combos.length; ++i)
                        $root.waiternow.common.MenuSpecProto.ComboProto.encode(message.combos[i], writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                if (message.schedules != null && message.schedules.length)
                    for (var i = 0; i < message.schedules.length; ++i)
                        $root.waiternow.common.AvailabilityScheduleProto.encode(message.schedules[i], writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified MenuSpecProto message, length delimited. Does not implicitly {@link waiternow.common.MenuSpecProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.MenuSpecProto
             * @static
             * @param {waiternow.common.IMenuSpecProto} message MenuSpecProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MenuSpecProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a MenuSpecProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.MenuSpecProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.MenuSpecProto} MenuSpecProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MenuSpecProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.MenuSpecProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.headerImage = $root.waiternow.common.ImageProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 2: {
                            if (!(message.categories && message.categories.length))
                                message.categories = [];
                            message.categories.push($root.waiternow.common.MenuSpecProto.CategoryProto.decode(reader, reader.uint32()));
                            break;
                        }
                    case 3: {
                            if (!(message.items && message.items.length))
                                message.items = [];
                            message.items.push($root.waiternow.common.MenuSpecProto.ItemProto.decode(reader, reader.uint32()));
                            break;
                        }
                    case 4: {
                            if (!(message.itemSelections && message.itemSelections.length))
                                message.itemSelections = [];
                            message.itemSelections.push($root.waiternow.common.MenuSpecProto.ItemSelectionProto.decode(reader, reader.uint32()));
                            break;
                        }
                    case 5: {
                            if (!(message.menuItems && message.menuItems.length))
                                message.menuItems = [];
                            message.menuItems.push($root.waiternow.common.MenuSpecProto.MenuItemProto.decode(reader, reader.uint32()));
                            break;
                        }
                    case 6: {
                            if (!(message.menuItemSelections && message.menuItemSelections.length))
                                message.menuItemSelections = [];
                            message.menuItemSelections.push($root.waiternow.common.MenuSpecProto.MenuItemSelectionProto.decode(reader, reader.uint32()));
                            break;
                        }
                    case 7: {
                            if (!(message.combos && message.combos.length))
                                message.combos = [];
                            message.combos.push($root.waiternow.common.MenuSpecProto.ComboProto.decode(reader, reader.uint32()));
                            break;
                        }
                    case 8: {
                            if (!(message.schedules && message.schedules.length))
                                message.schedules = [];
                            message.schedules.push($root.waiternow.common.AvailabilityScheduleProto.decode(reader, reader.uint32()));
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a MenuSpecProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.MenuSpecProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.MenuSpecProto} MenuSpecProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MenuSpecProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a MenuSpecProto message.
             * @function verify
             * @memberof waiternow.common.MenuSpecProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            MenuSpecProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.headerImage != null && message.hasOwnProperty("headerImage")) {
                    var error = $root.waiternow.common.ImageProto.verify(message.headerImage);
                    if (error)
                        return "headerImage." + error;
                }
                if (message.categories != null && message.hasOwnProperty("categories")) {
                    if (!Array.isArray(message.categories))
                        return "categories: array expected";
                    for (var i = 0; i < message.categories.length; ++i) {
                        var error = $root.waiternow.common.MenuSpecProto.CategoryProto.verify(message.categories[i]);
                        if (error)
                            return "categories." + error;
                    }
                }
                if (message.items != null && message.hasOwnProperty("items")) {
                    if (!Array.isArray(message.items))
                        return "items: array expected";
                    for (var i = 0; i < message.items.length; ++i) {
                        var error = $root.waiternow.common.MenuSpecProto.ItemProto.verify(message.items[i]);
                        if (error)
                            return "items." + error;
                    }
                }
                if (message.itemSelections != null && message.hasOwnProperty("itemSelections")) {
                    if (!Array.isArray(message.itemSelections))
                        return "itemSelections: array expected";
                    for (var i = 0; i < message.itemSelections.length; ++i) {
                        var error = $root.waiternow.common.MenuSpecProto.ItemSelectionProto.verify(message.itemSelections[i]);
                        if (error)
                            return "itemSelections." + error;
                    }
                }
                if (message.menuItems != null && message.hasOwnProperty("menuItems")) {
                    if (!Array.isArray(message.menuItems))
                        return "menuItems: array expected";
                    for (var i = 0; i < message.menuItems.length; ++i) {
                        var error = $root.waiternow.common.MenuSpecProto.MenuItemProto.verify(message.menuItems[i]);
                        if (error)
                            return "menuItems." + error;
                    }
                }
                if (message.menuItemSelections != null && message.hasOwnProperty("menuItemSelections")) {
                    if (!Array.isArray(message.menuItemSelections))
                        return "menuItemSelections: array expected";
                    for (var i = 0; i < message.menuItemSelections.length; ++i) {
                        var error = $root.waiternow.common.MenuSpecProto.MenuItemSelectionProto.verify(message.menuItemSelections[i]);
                        if (error)
                            return "menuItemSelections." + error;
                    }
                }
                if (message.combos != null && message.hasOwnProperty("combos")) {
                    if (!Array.isArray(message.combos))
                        return "combos: array expected";
                    for (var i = 0; i < message.combos.length; ++i) {
                        var error = $root.waiternow.common.MenuSpecProto.ComboProto.verify(message.combos[i]);
                        if (error)
                            return "combos." + error;
                    }
                }
                if (message.schedules != null && message.hasOwnProperty("schedules")) {
                    if (!Array.isArray(message.schedules))
                        return "schedules: array expected";
                    for (var i = 0; i < message.schedules.length; ++i) {
                        var error = $root.waiternow.common.AvailabilityScheduleProto.verify(message.schedules[i]);
                        if (error)
                            return "schedules." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a MenuSpecProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.MenuSpecProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.MenuSpecProto} MenuSpecProto
             */
            MenuSpecProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.MenuSpecProto)
                    return object;
                var message = new $root.waiternow.common.MenuSpecProto();
                if (object.headerImage != null) {
                    if (typeof object.headerImage !== "object")
                        throw TypeError(".waiternow.common.MenuSpecProto.headerImage: object expected");
                    message.headerImage = $root.waiternow.common.ImageProto.fromObject(object.headerImage);
                }
                if (object.categories) {
                    if (!Array.isArray(object.categories))
                        throw TypeError(".waiternow.common.MenuSpecProto.categories: array expected");
                    message.categories = [];
                    for (var i = 0; i < object.categories.length; ++i) {
                        if (typeof object.categories[i] !== "object")
                            throw TypeError(".waiternow.common.MenuSpecProto.categories: object expected");
                        message.categories[i] = $root.waiternow.common.MenuSpecProto.CategoryProto.fromObject(object.categories[i]);
                    }
                }
                if (object.items) {
                    if (!Array.isArray(object.items))
                        throw TypeError(".waiternow.common.MenuSpecProto.items: array expected");
                    message.items = [];
                    for (var i = 0; i < object.items.length; ++i) {
                        if (typeof object.items[i] !== "object")
                            throw TypeError(".waiternow.common.MenuSpecProto.items: object expected");
                        message.items[i] = $root.waiternow.common.MenuSpecProto.ItemProto.fromObject(object.items[i]);
                    }
                }
                if (object.itemSelections) {
                    if (!Array.isArray(object.itemSelections))
                        throw TypeError(".waiternow.common.MenuSpecProto.itemSelections: array expected");
                    message.itemSelections = [];
                    for (var i = 0; i < object.itemSelections.length; ++i) {
                        if (typeof object.itemSelections[i] !== "object")
                            throw TypeError(".waiternow.common.MenuSpecProto.itemSelections: object expected");
                        message.itemSelections[i] = $root.waiternow.common.MenuSpecProto.ItemSelectionProto.fromObject(object.itemSelections[i]);
                    }
                }
                if (object.menuItems) {
                    if (!Array.isArray(object.menuItems))
                        throw TypeError(".waiternow.common.MenuSpecProto.menuItems: array expected");
                    message.menuItems = [];
                    for (var i = 0; i < object.menuItems.length; ++i) {
                        if (typeof object.menuItems[i] !== "object")
                            throw TypeError(".waiternow.common.MenuSpecProto.menuItems: object expected");
                        message.menuItems[i] = $root.waiternow.common.MenuSpecProto.MenuItemProto.fromObject(object.menuItems[i]);
                    }
                }
                if (object.menuItemSelections) {
                    if (!Array.isArray(object.menuItemSelections))
                        throw TypeError(".waiternow.common.MenuSpecProto.menuItemSelections: array expected");
                    message.menuItemSelections = [];
                    for (var i = 0; i < object.menuItemSelections.length; ++i) {
                        if (typeof object.menuItemSelections[i] !== "object")
                            throw TypeError(".waiternow.common.MenuSpecProto.menuItemSelections: object expected");
                        message.menuItemSelections[i] = $root.waiternow.common.MenuSpecProto.MenuItemSelectionProto.fromObject(object.menuItemSelections[i]);
                    }
                }
                if (object.combos) {
                    if (!Array.isArray(object.combos))
                        throw TypeError(".waiternow.common.MenuSpecProto.combos: array expected");
                    message.combos = [];
                    for (var i = 0; i < object.combos.length; ++i) {
                        if (typeof object.combos[i] !== "object")
                            throw TypeError(".waiternow.common.MenuSpecProto.combos: object expected");
                        message.combos[i] = $root.waiternow.common.MenuSpecProto.ComboProto.fromObject(object.combos[i]);
                    }
                }
                if (object.schedules) {
                    if (!Array.isArray(object.schedules))
                        throw TypeError(".waiternow.common.MenuSpecProto.schedules: array expected");
                    message.schedules = [];
                    for (var i = 0; i < object.schedules.length; ++i) {
                        if (typeof object.schedules[i] !== "object")
                            throw TypeError(".waiternow.common.MenuSpecProto.schedules: object expected");
                        message.schedules[i] = $root.waiternow.common.AvailabilityScheduleProto.fromObject(object.schedules[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a MenuSpecProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.MenuSpecProto
             * @static
             * @param {waiternow.common.MenuSpecProto} message MenuSpecProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            MenuSpecProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults) {
                    object.categories = [];
                    object.items = [];
                    object.itemSelections = [];
                    object.menuItems = [];
                    object.menuItemSelections = [];
                    object.combos = [];
                    object.schedules = [];
                }
                if (options.defaults)
                    object.headerImage = null;
                if (message.headerImage != null && message.hasOwnProperty("headerImage"))
                    object.headerImage = $root.waiternow.common.ImageProto.toObject(message.headerImage, options);
                if (message.categories && message.categories.length) {
                    object.categories = [];
                    for (var j = 0; j < message.categories.length; ++j)
                        object.categories[j] = $root.waiternow.common.MenuSpecProto.CategoryProto.toObject(message.categories[j], options);
                }
                if (message.items && message.items.length) {
                    object.items = [];
                    for (var j = 0; j < message.items.length; ++j)
                        object.items[j] = $root.waiternow.common.MenuSpecProto.ItemProto.toObject(message.items[j], options);
                }
                if (message.itemSelections && message.itemSelections.length) {
                    object.itemSelections = [];
                    for (var j = 0; j < message.itemSelections.length; ++j)
                        object.itemSelections[j] = $root.waiternow.common.MenuSpecProto.ItemSelectionProto.toObject(message.itemSelections[j], options);
                }
                if (message.menuItems && message.menuItems.length) {
                    object.menuItems = [];
                    for (var j = 0; j < message.menuItems.length; ++j)
                        object.menuItems[j] = $root.waiternow.common.MenuSpecProto.MenuItemProto.toObject(message.menuItems[j], options);
                }
                if (message.menuItemSelections && message.menuItemSelections.length) {
                    object.menuItemSelections = [];
                    for (var j = 0; j < message.menuItemSelections.length; ++j)
                        object.menuItemSelections[j] = $root.waiternow.common.MenuSpecProto.MenuItemSelectionProto.toObject(message.menuItemSelections[j], options);
                }
                if (message.combos && message.combos.length) {
                    object.combos = [];
                    for (var j = 0; j < message.combos.length; ++j)
                        object.combos[j] = $root.waiternow.common.MenuSpecProto.ComboProto.toObject(message.combos[j], options);
                }
                if (message.schedules && message.schedules.length) {
                    object.schedules = [];
                    for (var j = 0; j < message.schedules.length; ++j)
                        object.schedules[j] = $root.waiternow.common.AvailabilityScheduleProto.toObject(message.schedules[j], options);
                }
                return object;
            };

            /**
             * Converts this MenuSpecProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.MenuSpecProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            MenuSpecProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for MenuSpecProto
             * @function getTypeUrl
             * @memberof waiternow.common.MenuSpecProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            MenuSpecProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.MenuSpecProto";
            };

            MenuSpecProto.ItemProto = (function() {

                /**
                 * Properties of an ItemProto.
                 * @memberof waiternow.common.MenuSpecProto
                 * @interface IItemProto
                 * @property {string|null} [id] ItemProto id
                 * @property {waiternow.common.ITextProto|null} [name] ItemProto name
                 * @property {waiternow.common.ITextProto|null} [description] ItemProto description
                 * @property {waiternow.common.IImageProto|null} [image] ItemProto image
                 * @property {waiternow.common.IMoneyProto|null} [price] ItemProto price
                 * @property {boolean|null} [isUnavailable] ItemProto isUnavailable
                 */

                /**
                 * Constructs a new ItemProto.
                 * @memberof waiternow.common.MenuSpecProto
                 * @classdesc Represents an ItemProto.
                 * @implements IItemProto
                 * @constructor
                 * @param {waiternow.common.MenuSpecProto.IItemProto=} [properties] Properties to set
                 */
                function ItemProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ItemProto id.
                 * @member {string} id
                 * @memberof waiternow.common.MenuSpecProto.ItemProto
                 * @instance
                 */
                ItemProto.prototype.id = "";

                /**
                 * ItemProto name.
                 * @member {waiternow.common.ITextProto|null|undefined} name
                 * @memberof waiternow.common.MenuSpecProto.ItemProto
                 * @instance
                 */
                ItemProto.prototype.name = null;

                /**
                 * ItemProto description.
                 * @member {waiternow.common.ITextProto|null|undefined} description
                 * @memberof waiternow.common.MenuSpecProto.ItemProto
                 * @instance
                 */
                ItemProto.prototype.description = null;

                /**
                 * ItemProto image.
                 * @member {waiternow.common.IImageProto|null|undefined} image
                 * @memberof waiternow.common.MenuSpecProto.ItemProto
                 * @instance
                 */
                ItemProto.prototype.image = null;

                /**
                 * ItemProto price.
                 * @member {waiternow.common.IMoneyProto|null|undefined} price
                 * @memberof waiternow.common.MenuSpecProto.ItemProto
                 * @instance
                 */
                ItemProto.prototype.price = null;

                /**
                 * ItemProto isUnavailable.
                 * @member {boolean} isUnavailable
                 * @memberof waiternow.common.MenuSpecProto.ItemProto
                 * @instance
                 */
                ItemProto.prototype.isUnavailable = false;

                /**
                 * Creates a new ItemProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.MenuSpecProto.ItemProto
                 * @static
                 * @param {waiternow.common.MenuSpecProto.IItemProto=} [properties] Properties to set
                 * @returns {waiternow.common.MenuSpecProto.ItemProto} ItemProto instance
                 */
                ItemProto.create = function create(properties) {
                    return new ItemProto(properties);
                };

                /**
                 * Encodes the specified ItemProto message. Does not implicitly {@link waiternow.common.MenuSpecProto.ItemProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.MenuSpecProto.ItemProto
                 * @static
                 * @param {waiternow.common.MenuSpecProto.IItemProto} message ItemProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ItemProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        $root.waiternow.common.TextProto.encode(message.name, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                        $root.waiternow.common.TextProto.encode(message.description, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.image != null && Object.hasOwnProperty.call(message, "image"))
                        $root.waiternow.common.ImageProto.encode(message.image, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.price != null && Object.hasOwnProperty.call(message, "price"))
                        $root.waiternow.common.MoneyProto.encode(message.price, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.isUnavailable != null && Object.hasOwnProperty.call(message, "isUnavailable"))
                        writer.uint32(/* id 6, wireType 0 =*/48).bool(message.isUnavailable);
                    return writer;
                };

                /**
                 * Encodes the specified ItemProto message, length delimited. Does not implicitly {@link waiternow.common.MenuSpecProto.ItemProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.MenuSpecProto.ItemProto
                 * @static
                 * @param {waiternow.common.MenuSpecProto.IItemProto} message ItemProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ItemProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an ItemProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.MenuSpecProto.ItemProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.MenuSpecProto.ItemProto} ItemProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ItemProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.MenuSpecProto.ItemProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.id = reader.string();
                                break;
                            }
                        case 2: {
                                message.name = $root.waiternow.common.TextProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.description = $root.waiternow.common.TextProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 4: {
                                message.image = $root.waiternow.common.ImageProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 5: {
                                message.price = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 6: {
                                message.isUnavailable = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an ItemProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.MenuSpecProto.ItemProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.MenuSpecProto.ItemProto} ItemProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ItemProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an ItemProto message.
                 * @function verify
                 * @memberof waiternow.common.MenuSpecProto.ItemProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ItemProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (!$util.isString(message.id))
                            return "id: string expected";
                    if (message.name != null && message.hasOwnProperty("name")) {
                        var error = $root.waiternow.common.TextProto.verify(message.name);
                        if (error)
                            return "name." + error;
                    }
                    if (message.description != null && message.hasOwnProperty("description")) {
                        var error = $root.waiternow.common.TextProto.verify(message.description);
                        if (error)
                            return "description." + error;
                    }
                    if (message.image != null && message.hasOwnProperty("image")) {
                        var error = $root.waiternow.common.ImageProto.verify(message.image);
                        if (error)
                            return "image." + error;
                    }
                    if (message.price != null && message.hasOwnProperty("price")) {
                        var error = $root.waiternow.common.MoneyProto.verify(message.price);
                        if (error)
                            return "price." + error;
                    }
                    if (message.isUnavailable != null && message.hasOwnProperty("isUnavailable"))
                        if (typeof message.isUnavailable !== "boolean")
                            return "isUnavailable: boolean expected";
                    return null;
                };

                /**
                 * Creates an ItemProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.MenuSpecProto.ItemProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.MenuSpecProto.ItemProto} ItemProto
                 */
                ItemProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.MenuSpecProto.ItemProto)
                        return object;
                    var message = new $root.waiternow.common.MenuSpecProto.ItemProto();
                    if (object.id != null)
                        message.id = String(object.id);
                    if (object.name != null) {
                        if (typeof object.name !== "object")
                            throw TypeError(".waiternow.common.MenuSpecProto.ItemProto.name: object expected");
                        message.name = $root.waiternow.common.TextProto.fromObject(object.name);
                    }
                    if (object.description != null) {
                        if (typeof object.description !== "object")
                            throw TypeError(".waiternow.common.MenuSpecProto.ItemProto.description: object expected");
                        message.description = $root.waiternow.common.TextProto.fromObject(object.description);
                    }
                    if (object.image != null) {
                        if (typeof object.image !== "object")
                            throw TypeError(".waiternow.common.MenuSpecProto.ItemProto.image: object expected");
                        message.image = $root.waiternow.common.ImageProto.fromObject(object.image);
                    }
                    if (object.price != null) {
                        if (typeof object.price !== "object")
                            throw TypeError(".waiternow.common.MenuSpecProto.ItemProto.price: object expected");
                        message.price = $root.waiternow.common.MoneyProto.fromObject(object.price);
                    }
                    if (object.isUnavailable != null)
                        message.isUnavailable = Boolean(object.isUnavailable);
                    return message;
                };

                /**
                 * Creates a plain object from an ItemProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.MenuSpecProto.ItemProto
                 * @static
                 * @param {waiternow.common.MenuSpecProto.ItemProto} message ItemProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ItemProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.id = "";
                        object.name = null;
                        object.description = null;
                        object.image = null;
                        object.price = null;
                        object.isUnavailable = false;
                    }
                    if (message.id != null && message.hasOwnProperty("id"))
                        object.id = message.id;
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = $root.waiternow.common.TextProto.toObject(message.name, options);
                    if (message.description != null && message.hasOwnProperty("description"))
                        object.description = $root.waiternow.common.TextProto.toObject(message.description, options);
                    if (message.image != null && message.hasOwnProperty("image"))
                        object.image = $root.waiternow.common.ImageProto.toObject(message.image, options);
                    if (message.price != null && message.hasOwnProperty("price"))
                        object.price = $root.waiternow.common.MoneyProto.toObject(message.price, options);
                    if (message.isUnavailable != null && message.hasOwnProperty("isUnavailable"))
                        object.isUnavailable = message.isUnavailable;
                    return object;
                };

                /**
                 * Converts this ItemProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.MenuSpecProto.ItemProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ItemProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ItemProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.MenuSpecProto.ItemProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ItemProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.MenuSpecProto.ItemProto";
                };

                return ItemProto;
            })();

            MenuSpecProto.ItemSelectionProto = (function() {

                /**
                 * Properties of an ItemSelectionProto.
                 * @memberof waiternow.common.MenuSpecProto
                 * @interface IItemSelectionProto
                 * @property {string|null} [id] ItemSelectionProto id
                 * @property {waiternow.common.ITextProto|null} [title] ItemSelectionProto title
                 * @property {Array.<string>|null} [itemIds] ItemSelectionProto itemIds
                 * @property {waiternow.common.SelectionType|null} [selectionType] ItemSelectionProto selectionType
                 * @property {boolean|null} [isRequired] ItemSelectionProto isRequired
                 * @property {number|null} [maxSelections] ItemSelectionProto maxSelections
                 */

                /**
                 * Constructs a new ItemSelectionProto.
                 * @memberof waiternow.common.MenuSpecProto
                 * @classdesc Represents an ItemSelectionProto.
                 * @implements IItemSelectionProto
                 * @constructor
                 * @param {waiternow.common.MenuSpecProto.IItemSelectionProto=} [properties] Properties to set
                 */
                function ItemSelectionProto(properties) {
                    this.itemIds = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ItemSelectionProto id.
                 * @member {string} id
                 * @memberof waiternow.common.MenuSpecProto.ItemSelectionProto
                 * @instance
                 */
                ItemSelectionProto.prototype.id = "";

                /**
                 * ItemSelectionProto title.
                 * @member {waiternow.common.ITextProto|null|undefined} title
                 * @memberof waiternow.common.MenuSpecProto.ItemSelectionProto
                 * @instance
                 */
                ItemSelectionProto.prototype.title = null;

                /**
                 * ItemSelectionProto itemIds.
                 * @member {Array.<string>} itemIds
                 * @memberof waiternow.common.MenuSpecProto.ItemSelectionProto
                 * @instance
                 */
                ItemSelectionProto.prototype.itemIds = $util.emptyArray;

                /**
                 * ItemSelectionProto selectionType.
                 * @member {waiternow.common.SelectionType} selectionType
                 * @memberof waiternow.common.MenuSpecProto.ItemSelectionProto
                 * @instance
                 */
                ItemSelectionProto.prototype.selectionType = 0;

                /**
                 * ItemSelectionProto isRequired.
                 * @member {boolean} isRequired
                 * @memberof waiternow.common.MenuSpecProto.ItemSelectionProto
                 * @instance
                 */
                ItemSelectionProto.prototype.isRequired = false;

                /**
                 * ItemSelectionProto maxSelections.
                 * @member {number} maxSelections
                 * @memberof waiternow.common.MenuSpecProto.ItemSelectionProto
                 * @instance
                 */
                ItemSelectionProto.prototype.maxSelections = 0;

                /**
                 * Creates a new ItemSelectionProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.MenuSpecProto.ItemSelectionProto
                 * @static
                 * @param {waiternow.common.MenuSpecProto.IItemSelectionProto=} [properties] Properties to set
                 * @returns {waiternow.common.MenuSpecProto.ItemSelectionProto} ItemSelectionProto instance
                 */
                ItemSelectionProto.create = function create(properties) {
                    return new ItemSelectionProto(properties);
                };

                /**
                 * Encodes the specified ItemSelectionProto message. Does not implicitly {@link waiternow.common.MenuSpecProto.ItemSelectionProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.MenuSpecProto.ItemSelectionProto
                 * @static
                 * @param {waiternow.common.MenuSpecProto.IItemSelectionProto} message ItemSelectionProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ItemSelectionProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                    if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                        $root.waiternow.common.TextProto.encode(message.title, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.itemIds != null && message.itemIds.length)
                        for (var i = 0; i < message.itemIds.length; ++i)
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.itemIds[i]);
                    if (message.selectionType != null && Object.hasOwnProperty.call(message, "selectionType"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.selectionType);
                    if (message.isRequired != null && Object.hasOwnProperty.call(message, "isRequired"))
                        writer.uint32(/* id 5, wireType 0 =*/40).bool(message.isRequired);
                    if (message.maxSelections != null && Object.hasOwnProperty.call(message, "maxSelections"))
                        writer.uint32(/* id 6, wireType 0 =*/48).int32(message.maxSelections);
                    return writer;
                };

                /**
                 * Encodes the specified ItemSelectionProto message, length delimited. Does not implicitly {@link waiternow.common.MenuSpecProto.ItemSelectionProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.MenuSpecProto.ItemSelectionProto
                 * @static
                 * @param {waiternow.common.MenuSpecProto.IItemSelectionProto} message ItemSelectionProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ItemSelectionProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an ItemSelectionProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.MenuSpecProto.ItemSelectionProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.MenuSpecProto.ItemSelectionProto} ItemSelectionProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ItemSelectionProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.MenuSpecProto.ItemSelectionProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.id = reader.string();
                                break;
                            }
                        case 2: {
                                message.title = $root.waiternow.common.TextProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                if (!(message.itemIds && message.itemIds.length))
                                    message.itemIds = [];
                                message.itemIds.push(reader.string());
                                break;
                            }
                        case 4: {
                                message.selectionType = reader.int32();
                                break;
                            }
                        case 5: {
                                message.isRequired = reader.bool();
                                break;
                            }
                        case 6: {
                                message.maxSelections = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an ItemSelectionProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.MenuSpecProto.ItemSelectionProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.MenuSpecProto.ItemSelectionProto} ItemSelectionProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ItemSelectionProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an ItemSelectionProto message.
                 * @function verify
                 * @memberof waiternow.common.MenuSpecProto.ItemSelectionProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ItemSelectionProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (!$util.isString(message.id))
                            return "id: string expected";
                    if (message.title != null && message.hasOwnProperty("title")) {
                        var error = $root.waiternow.common.TextProto.verify(message.title);
                        if (error)
                            return "title." + error;
                    }
                    if (message.itemIds != null && message.hasOwnProperty("itemIds")) {
                        if (!Array.isArray(message.itemIds))
                            return "itemIds: array expected";
                        for (var i = 0; i < message.itemIds.length; ++i)
                            if (!$util.isString(message.itemIds[i]))
                                return "itemIds: string[] expected";
                    }
                    if (message.selectionType != null && message.hasOwnProperty("selectionType"))
                        switch (message.selectionType) {
                        default:
                            return "selectionType: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.isRequired != null && message.hasOwnProperty("isRequired"))
                        if (typeof message.isRequired !== "boolean")
                            return "isRequired: boolean expected";
                    if (message.maxSelections != null && message.hasOwnProperty("maxSelections"))
                        if (!$util.isInteger(message.maxSelections))
                            return "maxSelections: integer expected";
                    return null;
                };

                /**
                 * Creates an ItemSelectionProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.MenuSpecProto.ItemSelectionProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.MenuSpecProto.ItemSelectionProto} ItemSelectionProto
                 */
                ItemSelectionProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.MenuSpecProto.ItemSelectionProto)
                        return object;
                    var message = new $root.waiternow.common.MenuSpecProto.ItemSelectionProto();
                    if (object.id != null)
                        message.id = String(object.id);
                    if (object.title != null) {
                        if (typeof object.title !== "object")
                            throw TypeError(".waiternow.common.MenuSpecProto.ItemSelectionProto.title: object expected");
                        message.title = $root.waiternow.common.TextProto.fromObject(object.title);
                    }
                    if (object.itemIds) {
                        if (!Array.isArray(object.itemIds))
                            throw TypeError(".waiternow.common.MenuSpecProto.ItemSelectionProto.itemIds: array expected");
                        message.itemIds = [];
                        for (var i = 0; i < object.itemIds.length; ++i)
                            message.itemIds[i] = String(object.itemIds[i]);
                    }
                    switch (object.selectionType) {
                    default:
                        if (typeof object.selectionType === "number") {
                            message.selectionType = object.selectionType;
                            break;
                        }
                        break;
                    case "SELECTION_TYPE_UNSPECIFIED":
                    case 0:
                        message.selectionType = 0;
                        break;
                    case "SINGLE":
                    case 1:
                        message.selectionType = 1;
                        break;
                    case "MULTIPLE":
                    case 2:
                        message.selectionType = 2;
                        break;
                    }
                    if (object.isRequired != null)
                        message.isRequired = Boolean(object.isRequired);
                    if (object.maxSelections != null)
                        message.maxSelections = object.maxSelections | 0;
                    return message;
                };

                /**
                 * Creates a plain object from an ItemSelectionProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.MenuSpecProto.ItemSelectionProto
                 * @static
                 * @param {waiternow.common.MenuSpecProto.ItemSelectionProto} message ItemSelectionProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ItemSelectionProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.itemIds = [];
                    if (options.defaults) {
                        object.id = "";
                        object.title = null;
                        object.selectionType = options.enums === String ? "SELECTION_TYPE_UNSPECIFIED" : 0;
                        object.isRequired = false;
                        object.maxSelections = 0;
                    }
                    if (message.id != null && message.hasOwnProperty("id"))
                        object.id = message.id;
                    if (message.title != null && message.hasOwnProperty("title"))
                        object.title = $root.waiternow.common.TextProto.toObject(message.title, options);
                    if (message.itemIds && message.itemIds.length) {
                        object.itemIds = [];
                        for (var j = 0; j < message.itemIds.length; ++j)
                            object.itemIds[j] = message.itemIds[j];
                    }
                    if (message.selectionType != null && message.hasOwnProperty("selectionType"))
                        object.selectionType = options.enums === String ? $root.waiternow.common.SelectionType[message.selectionType] === undefined ? message.selectionType : $root.waiternow.common.SelectionType[message.selectionType] : message.selectionType;
                    if (message.isRequired != null && message.hasOwnProperty("isRequired"))
                        object.isRequired = message.isRequired;
                    if (message.maxSelections != null && message.hasOwnProperty("maxSelections"))
                        object.maxSelections = message.maxSelections;
                    return object;
                };

                /**
                 * Converts this ItemSelectionProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.MenuSpecProto.ItemSelectionProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ItemSelectionProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ItemSelectionProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.MenuSpecProto.ItemSelectionProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ItemSelectionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.MenuSpecProto.ItemSelectionProto";
                };

                return ItemSelectionProto;
            })();

            MenuSpecProto.MenuItemProto = (function() {

                /**
                 * Properties of a MenuItemProto.
                 * @memberof waiternow.common.MenuSpecProto
                 * @interface IMenuItemProto
                 * @property {string|null} [id] MenuItemProto id
                 * @property {waiternow.common.ITextProto|null} [name] MenuItemProto name
                 * @property {waiternow.common.ITextProto|null} [description] MenuItemProto description
                 * @property {waiternow.common.IImageProto|null} [image] MenuItemProto image
                 * @property {Array.<string>|null} [removableIngredientItemIds] MenuItemProto removableIngredientItemIds
                 * @property {Array.<string>|null} [itemSelectionIds] MenuItemProto itemSelectionIds
                 * @property {number|null} [calories] MenuItemProto calories
                 * @property {boolean|null} [containsAlcohol] MenuItemProto containsAlcohol
                 * @property {boolean|null} [isUnavailable] MenuItemProto isUnavailable
                 * @property {waiternow.common.IMoneyProto|null} [price] MenuItemProto price
                 * @property {waiternow.common.IMoneyProto|null} [priceInCombo] MenuItemProto priceInCombo
                 * @property {Array.<string>|null} [categoryIds] MenuItemProto categoryIds
                 * @property {string|null} [station] MenuItemProto station
                 * @property {string|null} [availabilityScheduleId] MenuItemProto availabilityScheduleId
                 */

                /**
                 * Constructs a new MenuItemProto.
                 * @memberof waiternow.common.MenuSpecProto
                 * @classdesc Represents a MenuItemProto.
                 * @implements IMenuItemProto
                 * @constructor
                 * @param {waiternow.common.MenuSpecProto.IMenuItemProto=} [properties] Properties to set
                 */
                function MenuItemProto(properties) {
                    this.removableIngredientItemIds = [];
                    this.itemSelectionIds = [];
                    this.categoryIds = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * MenuItemProto id.
                 * @member {string} id
                 * @memberof waiternow.common.MenuSpecProto.MenuItemProto
                 * @instance
                 */
                MenuItemProto.prototype.id = "";

                /**
                 * MenuItemProto name.
                 * @member {waiternow.common.ITextProto|null|undefined} name
                 * @memberof waiternow.common.MenuSpecProto.MenuItemProto
                 * @instance
                 */
                MenuItemProto.prototype.name = null;

                /**
                 * MenuItemProto description.
                 * @member {waiternow.common.ITextProto|null|undefined} description
                 * @memberof waiternow.common.MenuSpecProto.MenuItemProto
                 * @instance
                 */
                MenuItemProto.prototype.description = null;

                /**
                 * MenuItemProto image.
                 * @member {waiternow.common.IImageProto|null|undefined} image
                 * @memberof waiternow.common.MenuSpecProto.MenuItemProto
                 * @instance
                 */
                MenuItemProto.prototype.image = null;

                /**
                 * MenuItemProto removableIngredientItemIds.
                 * @member {Array.<string>} removableIngredientItemIds
                 * @memberof waiternow.common.MenuSpecProto.MenuItemProto
                 * @instance
                 */
                MenuItemProto.prototype.removableIngredientItemIds = $util.emptyArray;

                /**
                 * MenuItemProto itemSelectionIds.
                 * @member {Array.<string>} itemSelectionIds
                 * @memberof waiternow.common.MenuSpecProto.MenuItemProto
                 * @instance
                 */
                MenuItemProto.prototype.itemSelectionIds = $util.emptyArray;

                /**
                 * MenuItemProto calories.
                 * @member {number} calories
                 * @memberof waiternow.common.MenuSpecProto.MenuItemProto
                 * @instance
                 */
                MenuItemProto.prototype.calories = 0;

                /**
                 * MenuItemProto containsAlcohol.
                 * @member {boolean} containsAlcohol
                 * @memberof waiternow.common.MenuSpecProto.MenuItemProto
                 * @instance
                 */
                MenuItemProto.prototype.containsAlcohol = false;

                /**
                 * MenuItemProto isUnavailable.
                 * @member {boolean} isUnavailable
                 * @memberof waiternow.common.MenuSpecProto.MenuItemProto
                 * @instance
                 */
                MenuItemProto.prototype.isUnavailable = false;

                /**
                 * MenuItemProto price.
                 * @member {waiternow.common.IMoneyProto|null|undefined} price
                 * @memberof waiternow.common.MenuSpecProto.MenuItemProto
                 * @instance
                 */
                MenuItemProto.prototype.price = null;

                /**
                 * MenuItemProto priceInCombo.
                 * @member {waiternow.common.IMoneyProto|null|undefined} priceInCombo
                 * @memberof waiternow.common.MenuSpecProto.MenuItemProto
                 * @instance
                 */
                MenuItemProto.prototype.priceInCombo = null;

                /**
                 * MenuItemProto categoryIds.
                 * @member {Array.<string>} categoryIds
                 * @memberof waiternow.common.MenuSpecProto.MenuItemProto
                 * @instance
                 */
                MenuItemProto.prototype.categoryIds = $util.emptyArray;

                /**
                 * MenuItemProto station.
                 * @member {string} station
                 * @memberof waiternow.common.MenuSpecProto.MenuItemProto
                 * @instance
                 */
                MenuItemProto.prototype.station = "";

                /**
                 * MenuItemProto availabilityScheduleId.
                 * @member {string} availabilityScheduleId
                 * @memberof waiternow.common.MenuSpecProto.MenuItemProto
                 * @instance
                 */
                MenuItemProto.prototype.availabilityScheduleId = "";

                /**
                 * Creates a new MenuItemProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.MenuSpecProto.MenuItemProto
                 * @static
                 * @param {waiternow.common.MenuSpecProto.IMenuItemProto=} [properties] Properties to set
                 * @returns {waiternow.common.MenuSpecProto.MenuItemProto} MenuItemProto instance
                 */
                MenuItemProto.create = function create(properties) {
                    return new MenuItemProto(properties);
                };

                /**
                 * Encodes the specified MenuItemProto message. Does not implicitly {@link waiternow.common.MenuSpecProto.MenuItemProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.MenuSpecProto.MenuItemProto
                 * @static
                 * @param {waiternow.common.MenuSpecProto.IMenuItemProto} message MenuItemProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MenuItemProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        $root.waiternow.common.TextProto.encode(message.name, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                        $root.waiternow.common.TextProto.encode(message.description, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.image != null && Object.hasOwnProperty.call(message, "image"))
                        $root.waiternow.common.ImageProto.encode(message.image, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.removableIngredientItemIds != null && message.removableIngredientItemIds.length)
                        for (var i = 0; i < message.removableIngredientItemIds.length; ++i)
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.removableIngredientItemIds[i]);
                    if (message.itemSelectionIds != null && message.itemSelectionIds.length)
                        for (var i = 0; i < message.itemSelectionIds.length; ++i)
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.itemSelectionIds[i]);
                    if (message.calories != null && Object.hasOwnProperty.call(message, "calories"))
                        writer.uint32(/* id 7, wireType 0 =*/56).int32(message.calories);
                    if (message.containsAlcohol != null && Object.hasOwnProperty.call(message, "containsAlcohol"))
                        writer.uint32(/* id 8, wireType 0 =*/64).bool(message.containsAlcohol);
                    if (message.isUnavailable != null && Object.hasOwnProperty.call(message, "isUnavailable"))
                        writer.uint32(/* id 9, wireType 0 =*/72).bool(message.isUnavailable);
                    if (message.price != null && Object.hasOwnProperty.call(message, "price"))
                        $root.waiternow.common.MoneyProto.encode(message.price, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                    if (message.priceInCombo != null && Object.hasOwnProperty.call(message, "priceInCombo"))
                        $root.waiternow.common.MoneyProto.encode(message.priceInCombo, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                    if (message.categoryIds != null && message.categoryIds.length)
                        for (var i = 0; i < message.categoryIds.length; ++i)
                            writer.uint32(/* id 12, wireType 2 =*/98).string(message.categoryIds[i]);
                    if (message.station != null && Object.hasOwnProperty.call(message, "station"))
                        writer.uint32(/* id 13, wireType 2 =*/106).string(message.station);
                    if (message.availabilityScheduleId != null && Object.hasOwnProperty.call(message, "availabilityScheduleId"))
                        writer.uint32(/* id 14, wireType 2 =*/114).string(message.availabilityScheduleId);
                    return writer;
                };

                /**
                 * Encodes the specified MenuItemProto message, length delimited. Does not implicitly {@link waiternow.common.MenuSpecProto.MenuItemProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.MenuSpecProto.MenuItemProto
                 * @static
                 * @param {waiternow.common.MenuSpecProto.IMenuItemProto} message MenuItemProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MenuItemProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a MenuItemProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.MenuSpecProto.MenuItemProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.MenuSpecProto.MenuItemProto} MenuItemProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MenuItemProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.MenuSpecProto.MenuItemProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.id = reader.string();
                                break;
                            }
                        case 2: {
                                message.name = $root.waiternow.common.TextProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.description = $root.waiternow.common.TextProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 4: {
                                message.image = $root.waiternow.common.ImageProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 5: {
                                if (!(message.removableIngredientItemIds && message.removableIngredientItemIds.length))
                                    message.removableIngredientItemIds = [];
                                message.removableIngredientItemIds.push(reader.string());
                                break;
                            }
                        case 6: {
                                if (!(message.itemSelectionIds && message.itemSelectionIds.length))
                                    message.itemSelectionIds = [];
                                message.itemSelectionIds.push(reader.string());
                                break;
                            }
                        case 7: {
                                message.calories = reader.int32();
                                break;
                            }
                        case 8: {
                                message.containsAlcohol = reader.bool();
                                break;
                            }
                        case 9: {
                                message.isUnavailable = reader.bool();
                                break;
                            }
                        case 10: {
                                message.price = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 11: {
                                message.priceInCombo = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 12: {
                                if (!(message.categoryIds && message.categoryIds.length))
                                    message.categoryIds = [];
                                message.categoryIds.push(reader.string());
                                break;
                            }
                        case 13: {
                                message.station = reader.string();
                                break;
                            }
                        case 14: {
                                message.availabilityScheduleId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a MenuItemProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.MenuSpecProto.MenuItemProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.MenuSpecProto.MenuItemProto} MenuItemProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MenuItemProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a MenuItemProto message.
                 * @function verify
                 * @memberof waiternow.common.MenuSpecProto.MenuItemProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                MenuItemProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (!$util.isString(message.id))
                            return "id: string expected";
                    if (message.name != null && message.hasOwnProperty("name")) {
                        var error = $root.waiternow.common.TextProto.verify(message.name);
                        if (error)
                            return "name." + error;
                    }
                    if (message.description != null && message.hasOwnProperty("description")) {
                        var error = $root.waiternow.common.TextProto.verify(message.description);
                        if (error)
                            return "description." + error;
                    }
                    if (message.image != null && message.hasOwnProperty("image")) {
                        var error = $root.waiternow.common.ImageProto.verify(message.image);
                        if (error)
                            return "image." + error;
                    }
                    if (message.removableIngredientItemIds != null && message.hasOwnProperty("removableIngredientItemIds")) {
                        if (!Array.isArray(message.removableIngredientItemIds))
                            return "removableIngredientItemIds: array expected";
                        for (var i = 0; i < message.removableIngredientItemIds.length; ++i)
                            if (!$util.isString(message.removableIngredientItemIds[i]))
                                return "removableIngredientItemIds: string[] expected";
                    }
                    if (message.itemSelectionIds != null && message.hasOwnProperty("itemSelectionIds")) {
                        if (!Array.isArray(message.itemSelectionIds))
                            return "itemSelectionIds: array expected";
                        for (var i = 0; i < message.itemSelectionIds.length; ++i)
                            if (!$util.isString(message.itemSelectionIds[i]))
                                return "itemSelectionIds: string[] expected";
                    }
                    if (message.calories != null && message.hasOwnProperty("calories"))
                        if (!$util.isInteger(message.calories))
                            return "calories: integer expected";
                    if (message.containsAlcohol != null && message.hasOwnProperty("containsAlcohol"))
                        if (typeof message.containsAlcohol !== "boolean")
                            return "containsAlcohol: boolean expected";
                    if (message.isUnavailable != null && message.hasOwnProperty("isUnavailable"))
                        if (typeof message.isUnavailable !== "boolean")
                            return "isUnavailable: boolean expected";
                    if (message.price != null && message.hasOwnProperty("price")) {
                        var error = $root.waiternow.common.MoneyProto.verify(message.price);
                        if (error)
                            return "price." + error;
                    }
                    if (message.priceInCombo != null && message.hasOwnProperty("priceInCombo")) {
                        var error = $root.waiternow.common.MoneyProto.verify(message.priceInCombo);
                        if (error)
                            return "priceInCombo." + error;
                    }
                    if (message.categoryIds != null && message.hasOwnProperty("categoryIds")) {
                        if (!Array.isArray(message.categoryIds))
                            return "categoryIds: array expected";
                        for (var i = 0; i < message.categoryIds.length; ++i)
                            if (!$util.isString(message.categoryIds[i]))
                                return "categoryIds: string[] expected";
                    }
                    if (message.station != null && message.hasOwnProperty("station"))
                        if (!$util.isString(message.station))
                            return "station: string expected";
                    if (message.availabilityScheduleId != null && message.hasOwnProperty("availabilityScheduleId"))
                        if (!$util.isString(message.availabilityScheduleId))
                            return "availabilityScheduleId: string expected";
                    return null;
                };

                /**
                 * Creates a MenuItemProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.MenuSpecProto.MenuItemProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.MenuSpecProto.MenuItemProto} MenuItemProto
                 */
                MenuItemProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.MenuSpecProto.MenuItemProto)
                        return object;
                    var message = new $root.waiternow.common.MenuSpecProto.MenuItemProto();
                    if (object.id != null)
                        message.id = String(object.id);
                    if (object.name != null) {
                        if (typeof object.name !== "object")
                            throw TypeError(".waiternow.common.MenuSpecProto.MenuItemProto.name: object expected");
                        message.name = $root.waiternow.common.TextProto.fromObject(object.name);
                    }
                    if (object.description != null) {
                        if (typeof object.description !== "object")
                            throw TypeError(".waiternow.common.MenuSpecProto.MenuItemProto.description: object expected");
                        message.description = $root.waiternow.common.TextProto.fromObject(object.description);
                    }
                    if (object.image != null) {
                        if (typeof object.image !== "object")
                            throw TypeError(".waiternow.common.MenuSpecProto.MenuItemProto.image: object expected");
                        message.image = $root.waiternow.common.ImageProto.fromObject(object.image);
                    }
                    if (object.removableIngredientItemIds) {
                        if (!Array.isArray(object.removableIngredientItemIds))
                            throw TypeError(".waiternow.common.MenuSpecProto.MenuItemProto.removableIngredientItemIds: array expected");
                        message.removableIngredientItemIds = [];
                        for (var i = 0; i < object.removableIngredientItemIds.length; ++i)
                            message.removableIngredientItemIds[i] = String(object.removableIngredientItemIds[i]);
                    }
                    if (object.itemSelectionIds) {
                        if (!Array.isArray(object.itemSelectionIds))
                            throw TypeError(".waiternow.common.MenuSpecProto.MenuItemProto.itemSelectionIds: array expected");
                        message.itemSelectionIds = [];
                        for (var i = 0; i < object.itemSelectionIds.length; ++i)
                            message.itemSelectionIds[i] = String(object.itemSelectionIds[i]);
                    }
                    if (object.calories != null)
                        message.calories = object.calories | 0;
                    if (object.containsAlcohol != null)
                        message.containsAlcohol = Boolean(object.containsAlcohol);
                    if (object.isUnavailable != null)
                        message.isUnavailable = Boolean(object.isUnavailable);
                    if (object.price != null) {
                        if (typeof object.price !== "object")
                            throw TypeError(".waiternow.common.MenuSpecProto.MenuItemProto.price: object expected");
                        message.price = $root.waiternow.common.MoneyProto.fromObject(object.price);
                    }
                    if (object.priceInCombo != null) {
                        if (typeof object.priceInCombo !== "object")
                            throw TypeError(".waiternow.common.MenuSpecProto.MenuItemProto.priceInCombo: object expected");
                        message.priceInCombo = $root.waiternow.common.MoneyProto.fromObject(object.priceInCombo);
                    }
                    if (object.categoryIds) {
                        if (!Array.isArray(object.categoryIds))
                            throw TypeError(".waiternow.common.MenuSpecProto.MenuItemProto.categoryIds: array expected");
                        message.categoryIds = [];
                        for (var i = 0; i < object.categoryIds.length; ++i)
                            message.categoryIds[i] = String(object.categoryIds[i]);
                    }
                    if (object.station != null)
                        message.station = String(object.station);
                    if (object.availabilityScheduleId != null)
                        message.availabilityScheduleId = String(object.availabilityScheduleId);
                    return message;
                };

                /**
                 * Creates a plain object from a MenuItemProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.MenuSpecProto.MenuItemProto
                 * @static
                 * @param {waiternow.common.MenuSpecProto.MenuItemProto} message MenuItemProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                MenuItemProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.removableIngredientItemIds = [];
                        object.itemSelectionIds = [];
                        object.categoryIds = [];
                    }
                    if (options.defaults) {
                        object.id = "";
                        object.name = null;
                        object.description = null;
                        object.image = null;
                        object.calories = 0;
                        object.containsAlcohol = false;
                        object.isUnavailable = false;
                        object.price = null;
                        object.priceInCombo = null;
                        object.station = "";
                        object.availabilityScheduleId = "";
                    }
                    if (message.id != null && message.hasOwnProperty("id"))
                        object.id = message.id;
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = $root.waiternow.common.TextProto.toObject(message.name, options);
                    if (message.description != null && message.hasOwnProperty("description"))
                        object.description = $root.waiternow.common.TextProto.toObject(message.description, options);
                    if (message.image != null && message.hasOwnProperty("image"))
                        object.image = $root.waiternow.common.ImageProto.toObject(message.image, options);
                    if (message.removableIngredientItemIds && message.removableIngredientItemIds.length) {
                        object.removableIngredientItemIds = [];
                        for (var j = 0; j < message.removableIngredientItemIds.length; ++j)
                            object.removableIngredientItemIds[j] = message.removableIngredientItemIds[j];
                    }
                    if (message.itemSelectionIds && message.itemSelectionIds.length) {
                        object.itemSelectionIds = [];
                        for (var j = 0; j < message.itemSelectionIds.length; ++j)
                            object.itemSelectionIds[j] = message.itemSelectionIds[j];
                    }
                    if (message.calories != null && message.hasOwnProperty("calories"))
                        object.calories = message.calories;
                    if (message.containsAlcohol != null && message.hasOwnProperty("containsAlcohol"))
                        object.containsAlcohol = message.containsAlcohol;
                    if (message.isUnavailable != null && message.hasOwnProperty("isUnavailable"))
                        object.isUnavailable = message.isUnavailable;
                    if (message.price != null && message.hasOwnProperty("price"))
                        object.price = $root.waiternow.common.MoneyProto.toObject(message.price, options);
                    if (message.priceInCombo != null && message.hasOwnProperty("priceInCombo"))
                        object.priceInCombo = $root.waiternow.common.MoneyProto.toObject(message.priceInCombo, options);
                    if (message.categoryIds && message.categoryIds.length) {
                        object.categoryIds = [];
                        for (var j = 0; j < message.categoryIds.length; ++j)
                            object.categoryIds[j] = message.categoryIds[j];
                    }
                    if (message.station != null && message.hasOwnProperty("station"))
                        object.station = message.station;
                    if (message.availabilityScheduleId != null && message.hasOwnProperty("availabilityScheduleId"))
                        object.availabilityScheduleId = message.availabilityScheduleId;
                    return object;
                };

                /**
                 * Converts this MenuItemProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.MenuSpecProto.MenuItemProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                MenuItemProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for MenuItemProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.MenuSpecProto.MenuItemProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                MenuItemProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.MenuSpecProto.MenuItemProto";
                };

                return MenuItemProto;
            })();

            MenuSpecProto.MenuItemSelectionProto = (function() {

                /**
                 * Properties of a MenuItemSelectionProto.
                 * @memberof waiternow.common.MenuSpecProto
                 * @interface IMenuItemSelectionProto
                 * @property {string|null} [id] MenuItemSelectionProto id
                 * @property {waiternow.common.ITextProto|null} [title] MenuItemSelectionProto title
                 * @property {Array.<string>|null} [menuItemIds] MenuItemSelectionProto menuItemIds
                 * @property {waiternow.common.SelectionType|null} [selectionType] MenuItemSelectionProto selectionType
                 * @property {boolean|null} [isRequired] MenuItemSelectionProto isRequired
                 * @property {number|null} [maxSelections] MenuItemSelectionProto maxSelections
                 */

                /**
                 * Constructs a new MenuItemSelectionProto.
                 * @memberof waiternow.common.MenuSpecProto
                 * @classdesc Represents a MenuItemSelectionProto.
                 * @implements IMenuItemSelectionProto
                 * @constructor
                 * @param {waiternow.common.MenuSpecProto.IMenuItemSelectionProto=} [properties] Properties to set
                 */
                function MenuItemSelectionProto(properties) {
                    this.menuItemIds = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * MenuItemSelectionProto id.
                 * @member {string} id
                 * @memberof waiternow.common.MenuSpecProto.MenuItemSelectionProto
                 * @instance
                 */
                MenuItemSelectionProto.prototype.id = "";

                /**
                 * MenuItemSelectionProto title.
                 * @member {waiternow.common.ITextProto|null|undefined} title
                 * @memberof waiternow.common.MenuSpecProto.MenuItemSelectionProto
                 * @instance
                 */
                MenuItemSelectionProto.prototype.title = null;

                /**
                 * MenuItemSelectionProto menuItemIds.
                 * @member {Array.<string>} menuItemIds
                 * @memberof waiternow.common.MenuSpecProto.MenuItemSelectionProto
                 * @instance
                 */
                MenuItemSelectionProto.prototype.menuItemIds = $util.emptyArray;

                /**
                 * MenuItemSelectionProto selectionType.
                 * @member {waiternow.common.SelectionType} selectionType
                 * @memberof waiternow.common.MenuSpecProto.MenuItemSelectionProto
                 * @instance
                 */
                MenuItemSelectionProto.prototype.selectionType = 0;

                /**
                 * MenuItemSelectionProto isRequired.
                 * @member {boolean} isRequired
                 * @memberof waiternow.common.MenuSpecProto.MenuItemSelectionProto
                 * @instance
                 */
                MenuItemSelectionProto.prototype.isRequired = false;

                /**
                 * MenuItemSelectionProto maxSelections.
                 * @member {number} maxSelections
                 * @memberof waiternow.common.MenuSpecProto.MenuItemSelectionProto
                 * @instance
                 */
                MenuItemSelectionProto.prototype.maxSelections = 0;

                /**
                 * Creates a new MenuItemSelectionProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.MenuSpecProto.MenuItemSelectionProto
                 * @static
                 * @param {waiternow.common.MenuSpecProto.IMenuItemSelectionProto=} [properties] Properties to set
                 * @returns {waiternow.common.MenuSpecProto.MenuItemSelectionProto} MenuItemSelectionProto instance
                 */
                MenuItemSelectionProto.create = function create(properties) {
                    return new MenuItemSelectionProto(properties);
                };

                /**
                 * Encodes the specified MenuItemSelectionProto message. Does not implicitly {@link waiternow.common.MenuSpecProto.MenuItemSelectionProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.MenuSpecProto.MenuItemSelectionProto
                 * @static
                 * @param {waiternow.common.MenuSpecProto.IMenuItemSelectionProto} message MenuItemSelectionProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MenuItemSelectionProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                    if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                        $root.waiternow.common.TextProto.encode(message.title, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.menuItemIds != null && message.menuItemIds.length)
                        for (var i = 0; i < message.menuItemIds.length; ++i)
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.menuItemIds[i]);
                    if (message.selectionType != null && Object.hasOwnProperty.call(message, "selectionType"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.selectionType);
                    if (message.isRequired != null && Object.hasOwnProperty.call(message, "isRequired"))
                        writer.uint32(/* id 5, wireType 0 =*/40).bool(message.isRequired);
                    if (message.maxSelections != null && Object.hasOwnProperty.call(message, "maxSelections"))
                        writer.uint32(/* id 6, wireType 0 =*/48).int32(message.maxSelections);
                    return writer;
                };

                /**
                 * Encodes the specified MenuItemSelectionProto message, length delimited. Does not implicitly {@link waiternow.common.MenuSpecProto.MenuItemSelectionProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.MenuSpecProto.MenuItemSelectionProto
                 * @static
                 * @param {waiternow.common.MenuSpecProto.IMenuItemSelectionProto} message MenuItemSelectionProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MenuItemSelectionProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a MenuItemSelectionProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.MenuSpecProto.MenuItemSelectionProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.MenuSpecProto.MenuItemSelectionProto} MenuItemSelectionProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MenuItemSelectionProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.MenuSpecProto.MenuItemSelectionProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.id = reader.string();
                                break;
                            }
                        case 2: {
                                message.title = $root.waiternow.common.TextProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                if (!(message.menuItemIds && message.menuItemIds.length))
                                    message.menuItemIds = [];
                                message.menuItemIds.push(reader.string());
                                break;
                            }
                        case 4: {
                                message.selectionType = reader.int32();
                                break;
                            }
                        case 5: {
                                message.isRequired = reader.bool();
                                break;
                            }
                        case 6: {
                                message.maxSelections = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a MenuItemSelectionProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.MenuSpecProto.MenuItemSelectionProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.MenuSpecProto.MenuItemSelectionProto} MenuItemSelectionProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MenuItemSelectionProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a MenuItemSelectionProto message.
                 * @function verify
                 * @memberof waiternow.common.MenuSpecProto.MenuItemSelectionProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                MenuItemSelectionProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (!$util.isString(message.id))
                            return "id: string expected";
                    if (message.title != null && message.hasOwnProperty("title")) {
                        var error = $root.waiternow.common.TextProto.verify(message.title);
                        if (error)
                            return "title." + error;
                    }
                    if (message.menuItemIds != null && message.hasOwnProperty("menuItemIds")) {
                        if (!Array.isArray(message.menuItemIds))
                            return "menuItemIds: array expected";
                        for (var i = 0; i < message.menuItemIds.length; ++i)
                            if (!$util.isString(message.menuItemIds[i]))
                                return "menuItemIds: string[] expected";
                    }
                    if (message.selectionType != null && message.hasOwnProperty("selectionType"))
                        switch (message.selectionType) {
                        default:
                            return "selectionType: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.isRequired != null && message.hasOwnProperty("isRequired"))
                        if (typeof message.isRequired !== "boolean")
                            return "isRequired: boolean expected";
                    if (message.maxSelections != null && message.hasOwnProperty("maxSelections"))
                        if (!$util.isInteger(message.maxSelections))
                            return "maxSelections: integer expected";
                    return null;
                };

                /**
                 * Creates a MenuItemSelectionProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.MenuSpecProto.MenuItemSelectionProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.MenuSpecProto.MenuItemSelectionProto} MenuItemSelectionProto
                 */
                MenuItemSelectionProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.MenuSpecProto.MenuItemSelectionProto)
                        return object;
                    var message = new $root.waiternow.common.MenuSpecProto.MenuItemSelectionProto();
                    if (object.id != null)
                        message.id = String(object.id);
                    if (object.title != null) {
                        if (typeof object.title !== "object")
                            throw TypeError(".waiternow.common.MenuSpecProto.MenuItemSelectionProto.title: object expected");
                        message.title = $root.waiternow.common.TextProto.fromObject(object.title);
                    }
                    if (object.menuItemIds) {
                        if (!Array.isArray(object.menuItemIds))
                            throw TypeError(".waiternow.common.MenuSpecProto.MenuItemSelectionProto.menuItemIds: array expected");
                        message.menuItemIds = [];
                        for (var i = 0; i < object.menuItemIds.length; ++i)
                            message.menuItemIds[i] = String(object.menuItemIds[i]);
                    }
                    switch (object.selectionType) {
                    default:
                        if (typeof object.selectionType === "number") {
                            message.selectionType = object.selectionType;
                            break;
                        }
                        break;
                    case "SELECTION_TYPE_UNSPECIFIED":
                    case 0:
                        message.selectionType = 0;
                        break;
                    case "SINGLE":
                    case 1:
                        message.selectionType = 1;
                        break;
                    case "MULTIPLE":
                    case 2:
                        message.selectionType = 2;
                        break;
                    }
                    if (object.isRequired != null)
                        message.isRequired = Boolean(object.isRequired);
                    if (object.maxSelections != null)
                        message.maxSelections = object.maxSelections | 0;
                    return message;
                };

                /**
                 * Creates a plain object from a MenuItemSelectionProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.MenuSpecProto.MenuItemSelectionProto
                 * @static
                 * @param {waiternow.common.MenuSpecProto.MenuItemSelectionProto} message MenuItemSelectionProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                MenuItemSelectionProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.menuItemIds = [];
                    if (options.defaults) {
                        object.id = "";
                        object.title = null;
                        object.selectionType = options.enums === String ? "SELECTION_TYPE_UNSPECIFIED" : 0;
                        object.isRequired = false;
                        object.maxSelections = 0;
                    }
                    if (message.id != null && message.hasOwnProperty("id"))
                        object.id = message.id;
                    if (message.title != null && message.hasOwnProperty("title"))
                        object.title = $root.waiternow.common.TextProto.toObject(message.title, options);
                    if (message.menuItemIds && message.menuItemIds.length) {
                        object.menuItemIds = [];
                        for (var j = 0; j < message.menuItemIds.length; ++j)
                            object.menuItemIds[j] = message.menuItemIds[j];
                    }
                    if (message.selectionType != null && message.hasOwnProperty("selectionType"))
                        object.selectionType = options.enums === String ? $root.waiternow.common.SelectionType[message.selectionType] === undefined ? message.selectionType : $root.waiternow.common.SelectionType[message.selectionType] : message.selectionType;
                    if (message.isRequired != null && message.hasOwnProperty("isRequired"))
                        object.isRequired = message.isRequired;
                    if (message.maxSelections != null && message.hasOwnProperty("maxSelections"))
                        object.maxSelections = message.maxSelections;
                    return object;
                };

                /**
                 * Converts this MenuItemSelectionProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.MenuSpecProto.MenuItemSelectionProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                MenuItemSelectionProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for MenuItemSelectionProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.MenuSpecProto.MenuItemSelectionProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                MenuItemSelectionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.MenuSpecProto.MenuItemSelectionProto";
                };

                return MenuItemSelectionProto;
            })();

            MenuSpecProto.ComboProto = (function() {

                /**
                 * Properties of a ComboProto.
                 * @memberof waiternow.common.MenuSpecProto
                 * @interface IComboProto
                 * @property {string|null} [id] ComboProto id
                 * @property {waiternow.common.ITextProto|null} [name] ComboProto name
                 * @property {waiternow.common.ITextProto|null} [description] ComboProto description
                 * @property {waiternow.common.IImageProto|null} [image] ComboProto image
                 * @property {Array.<string>|null} [menuItemIds] ComboProto menuItemIds
                 * @property {Array.<string>|null} [menuItemSelectionIds] ComboProto menuItemSelectionIds
                 * @property {Array.<string>|null} [itemSelectionIds] ComboProto itemSelectionIds
                 * @property {boolean|null} [isUnavailable] ComboProto isUnavailable
                 * @property {waiternow.common.IMoneyProto|null} [price] ComboProto price
                 * @property {Array.<string>|null} [categoryIds] ComboProto categoryIds
                 * @property {string|null} [availabilityScheduleId] ComboProto availabilityScheduleId
                 */

                /**
                 * Constructs a new ComboProto.
                 * @memberof waiternow.common.MenuSpecProto
                 * @classdesc Represents a ComboProto.
                 * @implements IComboProto
                 * @constructor
                 * @param {waiternow.common.MenuSpecProto.IComboProto=} [properties] Properties to set
                 */
                function ComboProto(properties) {
                    this.menuItemIds = [];
                    this.menuItemSelectionIds = [];
                    this.itemSelectionIds = [];
                    this.categoryIds = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ComboProto id.
                 * @member {string} id
                 * @memberof waiternow.common.MenuSpecProto.ComboProto
                 * @instance
                 */
                ComboProto.prototype.id = "";

                /**
                 * ComboProto name.
                 * @member {waiternow.common.ITextProto|null|undefined} name
                 * @memberof waiternow.common.MenuSpecProto.ComboProto
                 * @instance
                 */
                ComboProto.prototype.name = null;

                /**
                 * ComboProto description.
                 * @member {waiternow.common.ITextProto|null|undefined} description
                 * @memberof waiternow.common.MenuSpecProto.ComboProto
                 * @instance
                 */
                ComboProto.prototype.description = null;

                /**
                 * ComboProto image.
                 * @member {waiternow.common.IImageProto|null|undefined} image
                 * @memberof waiternow.common.MenuSpecProto.ComboProto
                 * @instance
                 */
                ComboProto.prototype.image = null;

                /**
                 * ComboProto menuItemIds.
                 * @member {Array.<string>} menuItemIds
                 * @memberof waiternow.common.MenuSpecProto.ComboProto
                 * @instance
                 */
                ComboProto.prototype.menuItemIds = $util.emptyArray;

                /**
                 * ComboProto menuItemSelectionIds.
                 * @member {Array.<string>} menuItemSelectionIds
                 * @memberof waiternow.common.MenuSpecProto.ComboProto
                 * @instance
                 */
                ComboProto.prototype.menuItemSelectionIds = $util.emptyArray;

                /**
                 * ComboProto itemSelectionIds.
                 * @member {Array.<string>} itemSelectionIds
                 * @memberof waiternow.common.MenuSpecProto.ComboProto
                 * @instance
                 */
                ComboProto.prototype.itemSelectionIds = $util.emptyArray;

                /**
                 * ComboProto isUnavailable.
                 * @member {boolean} isUnavailable
                 * @memberof waiternow.common.MenuSpecProto.ComboProto
                 * @instance
                 */
                ComboProto.prototype.isUnavailable = false;

                /**
                 * ComboProto price.
                 * @member {waiternow.common.IMoneyProto|null|undefined} price
                 * @memberof waiternow.common.MenuSpecProto.ComboProto
                 * @instance
                 */
                ComboProto.prototype.price = null;

                /**
                 * ComboProto categoryIds.
                 * @member {Array.<string>} categoryIds
                 * @memberof waiternow.common.MenuSpecProto.ComboProto
                 * @instance
                 */
                ComboProto.prototype.categoryIds = $util.emptyArray;

                /**
                 * ComboProto availabilityScheduleId.
                 * @member {string} availabilityScheduleId
                 * @memberof waiternow.common.MenuSpecProto.ComboProto
                 * @instance
                 */
                ComboProto.prototype.availabilityScheduleId = "";

                /**
                 * Creates a new ComboProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.MenuSpecProto.ComboProto
                 * @static
                 * @param {waiternow.common.MenuSpecProto.IComboProto=} [properties] Properties to set
                 * @returns {waiternow.common.MenuSpecProto.ComboProto} ComboProto instance
                 */
                ComboProto.create = function create(properties) {
                    return new ComboProto(properties);
                };

                /**
                 * Encodes the specified ComboProto message. Does not implicitly {@link waiternow.common.MenuSpecProto.ComboProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.MenuSpecProto.ComboProto
                 * @static
                 * @param {waiternow.common.MenuSpecProto.IComboProto} message ComboProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ComboProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        $root.waiternow.common.TextProto.encode(message.name, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.menuItemIds != null && message.menuItemIds.length)
                        for (var i = 0; i < message.menuItemIds.length; ++i)
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.menuItemIds[i]);
                    if (message.menuItemSelectionIds != null && message.menuItemSelectionIds.length)
                        for (var i = 0; i < message.menuItemSelectionIds.length; ++i)
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.menuItemSelectionIds[i]);
                    if (message.itemSelectionIds != null && message.itemSelectionIds.length)
                        for (var i = 0; i < message.itemSelectionIds.length; ++i)
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.itemSelectionIds[i]);
                    if (message.isUnavailable != null && Object.hasOwnProperty.call(message, "isUnavailable"))
                        writer.uint32(/* id 6, wireType 0 =*/48).bool(message.isUnavailable);
                    if (message.price != null && Object.hasOwnProperty.call(message, "price"))
                        $root.waiternow.common.MoneyProto.encode(message.price, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    if (message.categoryIds != null && message.categoryIds.length)
                        for (var i = 0; i < message.categoryIds.length; ++i)
                            writer.uint32(/* id 8, wireType 2 =*/66).string(message.categoryIds[i]);
                    if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                        $root.waiternow.common.TextProto.encode(message.description, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                    if (message.availabilityScheduleId != null && Object.hasOwnProperty.call(message, "availabilityScheduleId"))
                        writer.uint32(/* id 10, wireType 2 =*/82).string(message.availabilityScheduleId);
                    if (message.image != null && Object.hasOwnProperty.call(message, "image"))
                        $root.waiternow.common.ImageProto.encode(message.image, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified ComboProto message, length delimited. Does not implicitly {@link waiternow.common.MenuSpecProto.ComboProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.MenuSpecProto.ComboProto
                 * @static
                 * @param {waiternow.common.MenuSpecProto.IComboProto} message ComboProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ComboProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ComboProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.MenuSpecProto.ComboProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.MenuSpecProto.ComboProto} ComboProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ComboProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.MenuSpecProto.ComboProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.id = reader.string();
                                break;
                            }
                        case 2: {
                                message.name = $root.waiternow.common.TextProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 9: {
                                message.description = $root.waiternow.common.TextProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 11: {
                                message.image = $root.waiternow.common.ImageProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                if (!(message.menuItemIds && message.menuItemIds.length))
                                    message.menuItemIds = [];
                                message.menuItemIds.push(reader.string());
                                break;
                            }
                        case 4: {
                                if (!(message.menuItemSelectionIds && message.menuItemSelectionIds.length))
                                    message.menuItemSelectionIds = [];
                                message.menuItemSelectionIds.push(reader.string());
                                break;
                            }
                        case 5: {
                                if (!(message.itemSelectionIds && message.itemSelectionIds.length))
                                    message.itemSelectionIds = [];
                                message.itemSelectionIds.push(reader.string());
                                break;
                            }
                        case 6: {
                                message.isUnavailable = reader.bool();
                                break;
                            }
                        case 7: {
                                message.price = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 8: {
                                if (!(message.categoryIds && message.categoryIds.length))
                                    message.categoryIds = [];
                                message.categoryIds.push(reader.string());
                                break;
                            }
                        case 10: {
                                message.availabilityScheduleId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ComboProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.MenuSpecProto.ComboProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.MenuSpecProto.ComboProto} ComboProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ComboProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ComboProto message.
                 * @function verify
                 * @memberof waiternow.common.MenuSpecProto.ComboProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ComboProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (!$util.isString(message.id))
                            return "id: string expected";
                    if (message.name != null && message.hasOwnProperty("name")) {
                        var error = $root.waiternow.common.TextProto.verify(message.name);
                        if (error)
                            return "name." + error;
                    }
                    if (message.description != null && message.hasOwnProperty("description")) {
                        var error = $root.waiternow.common.TextProto.verify(message.description);
                        if (error)
                            return "description." + error;
                    }
                    if (message.image != null && message.hasOwnProperty("image")) {
                        var error = $root.waiternow.common.ImageProto.verify(message.image);
                        if (error)
                            return "image." + error;
                    }
                    if (message.menuItemIds != null && message.hasOwnProperty("menuItemIds")) {
                        if (!Array.isArray(message.menuItemIds))
                            return "menuItemIds: array expected";
                        for (var i = 0; i < message.menuItemIds.length; ++i)
                            if (!$util.isString(message.menuItemIds[i]))
                                return "menuItemIds: string[] expected";
                    }
                    if (message.menuItemSelectionIds != null && message.hasOwnProperty("menuItemSelectionIds")) {
                        if (!Array.isArray(message.menuItemSelectionIds))
                            return "menuItemSelectionIds: array expected";
                        for (var i = 0; i < message.menuItemSelectionIds.length; ++i)
                            if (!$util.isString(message.menuItemSelectionIds[i]))
                                return "menuItemSelectionIds: string[] expected";
                    }
                    if (message.itemSelectionIds != null && message.hasOwnProperty("itemSelectionIds")) {
                        if (!Array.isArray(message.itemSelectionIds))
                            return "itemSelectionIds: array expected";
                        for (var i = 0; i < message.itemSelectionIds.length; ++i)
                            if (!$util.isString(message.itemSelectionIds[i]))
                                return "itemSelectionIds: string[] expected";
                    }
                    if (message.isUnavailable != null && message.hasOwnProperty("isUnavailable"))
                        if (typeof message.isUnavailable !== "boolean")
                            return "isUnavailable: boolean expected";
                    if (message.price != null && message.hasOwnProperty("price")) {
                        var error = $root.waiternow.common.MoneyProto.verify(message.price);
                        if (error)
                            return "price." + error;
                    }
                    if (message.categoryIds != null && message.hasOwnProperty("categoryIds")) {
                        if (!Array.isArray(message.categoryIds))
                            return "categoryIds: array expected";
                        for (var i = 0; i < message.categoryIds.length; ++i)
                            if (!$util.isString(message.categoryIds[i]))
                                return "categoryIds: string[] expected";
                    }
                    if (message.availabilityScheduleId != null && message.hasOwnProperty("availabilityScheduleId"))
                        if (!$util.isString(message.availabilityScheduleId))
                            return "availabilityScheduleId: string expected";
                    return null;
                };

                /**
                 * Creates a ComboProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.MenuSpecProto.ComboProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.MenuSpecProto.ComboProto} ComboProto
                 */
                ComboProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.MenuSpecProto.ComboProto)
                        return object;
                    var message = new $root.waiternow.common.MenuSpecProto.ComboProto();
                    if (object.id != null)
                        message.id = String(object.id);
                    if (object.name != null) {
                        if (typeof object.name !== "object")
                            throw TypeError(".waiternow.common.MenuSpecProto.ComboProto.name: object expected");
                        message.name = $root.waiternow.common.TextProto.fromObject(object.name);
                    }
                    if (object.description != null) {
                        if (typeof object.description !== "object")
                            throw TypeError(".waiternow.common.MenuSpecProto.ComboProto.description: object expected");
                        message.description = $root.waiternow.common.TextProto.fromObject(object.description);
                    }
                    if (object.image != null) {
                        if (typeof object.image !== "object")
                            throw TypeError(".waiternow.common.MenuSpecProto.ComboProto.image: object expected");
                        message.image = $root.waiternow.common.ImageProto.fromObject(object.image);
                    }
                    if (object.menuItemIds) {
                        if (!Array.isArray(object.menuItemIds))
                            throw TypeError(".waiternow.common.MenuSpecProto.ComboProto.menuItemIds: array expected");
                        message.menuItemIds = [];
                        for (var i = 0; i < object.menuItemIds.length; ++i)
                            message.menuItemIds[i] = String(object.menuItemIds[i]);
                    }
                    if (object.menuItemSelectionIds) {
                        if (!Array.isArray(object.menuItemSelectionIds))
                            throw TypeError(".waiternow.common.MenuSpecProto.ComboProto.menuItemSelectionIds: array expected");
                        message.menuItemSelectionIds = [];
                        for (var i = 0; i < object.menuItemSelectionIds.length; ++i)
                            message.menuItemSelectionIds[i] = String(object.menuItemSelectionIds[i]);
                    }
                    if (object.itemSelectionIds) {
                        if (!Array.isArray(object.itemSelectionIds))
                            throw TypeError(".waiternow.common.MenuSpecProto.ComboProto.itemSelectionIds: array expected");
                        message.itemSelectionIds = [];
                        for (var i = 0; i < object.itemSelectionIds.length; ++i)
                            message.itemSelectionIds[i] = String(object.itemSelectionIds[i]);
                    }
                    if (object.isUnavailable != null)
                        message.isUnavailable = Boolean(object.isUnavailable);
                    if (object.price != null) {
                        if (typeof object.price !== "object")
                            throw TypeError(".waiternow.common.MenuSpecProto.ComboProto.price: object expected");
                        message.price = $root.waiternow.common.MoneyProto.fromObject(object.price);
                    }
                    if (object.categoryIds) {
                        if (!Array.isArray(object.categoryIds))
                            throw TypeError(".waiternow.common.MenuSpecProto.ComboProto.categoryIds: array expected");
                        message.categoryIds = [];
                        for (var i = 0; i < object.categoryIds.length; ++i)
                            message.categoryIds[i] = String(object.categoryIds[i]);
                    }
                    if (object.availabilityScheduleId != null)
                        message.availabilityScheduleId = String(object.availabilityScheduleId);
                    return message;
                };

                /**
                 * Creates a plain object from a ComboProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.MenuSpecProto.ComboProto
                 * @static
                 * @param {waiternow.common.MenuSpecProto.ComboProto} message ComboProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ComboProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.menuItemIds = [];
                        object.menuItemSelectionIds = [];
                        object.itemSelectionIds = [];
                        object.categoryIds = [];
                    }
                    if (options.defaults) {
                        object.id = "";
                        object.name = null;
                        object.isUnavailable = false;
                        object.price = null;
                        object.description = null;
                        object.availabilityScheduleId = "";
                        object.image = null;
                    }
                    if (message.id != null && message.hasOwnProperty("id"))
                        object.id = message.id;
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = $root.waiternow.common.TextProto.toObject(message.name, options);
                    if (message.menuItemIds && message.menuItemIds.length) {
                        object.menuItemIds = [];
                        for (var j = 0; j < message.menuItemIds.length; ++j)
                            object.menuItemIds[j] = message.menuItemIds[j];
                    }
                    if (message.menuItemSelectionIds && message.menuItemSelectionIds.length) {
                        object.menuItemSelectionIds = [];
                        for (var j = 0; j < message.menuItemSelectionIds.length; ++j)
                            object.menuItemSelectionIds[j] = message.menuItemSelectionIds[j];
                    }
                    if (message.itemSelectionIds && message.itemSelectionIds.length) {
                        object.itemSelectionIds = [];
                        for (var j = 0; j < message.itemSelectionIds.length; ++j)
                            object.itemSelectionIds[j] = message.itemSelectionIds[j];
                    }
                    if (message.isUnavailable != null && message.hasOwnProperty("isUnavailable"))
                        object.isUnavailable = message.isUnavailable;
                    if (message.price != null && message.hasOwnProperty("price"))
                        object.price = $root.waiternow.common.MoneyProto.toObject(message.price, options);
                    if (message.categoryIds && message.categoryIds.length) {
                        object.categoryIds = [];
                        for (var j = 0; j < message.categoryIds.length; ++j)
                            object.categoryIds[j] = message.categoryIds[j];
                    }
                    if (message.description != null && message.hasOwnProperty("description"))
                        object.description = $root.waiternow.common.TextProto.toObject(message.description, options);
                    if (message.availabilityScheduleId != null && message.hasOwnProperty("availabilityScheduleId"))
                        object.availabilityScheduleId = message.availabilityScheduleId;
                    if (message.image != null && message.hasOwnProperty("image"))
                        object.image = $root.waiternow.common.ImageProto.toObject(message.image, options);
                    return object;
                };

                /**
                 * Converts this ComboProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.MenuSpecProto.ComboProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ComboProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ComboProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.MenuSpecProto.ComboProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ComboProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.MenuSpecProto.ComboProto";
                };

                return ComboProto;
            })();

            MenuSpecProto.CategoryProto = (function() {

                /**
                 * Properties of a CategoryProto.
                 * @memberof waiternow.common.MenuSpecProto
                 * @interface ICategoryProto
                 * @property {string|null} [id] CategoryProto id
                 * @property {string|null} [parentCategoryId] CategoryProto parentCategoryId
                 * @property {waiternow.common.ITextProto|null} [name] CategoryProto name
                 * @property {waiternow.common.IImageProto|null} [image] CategoryProto image
                 */

                /**
                 * Constructs a new CategoryProto.
                 * @memberof waiternow.common.MenuSpecProto
                 * @classdesc Represents a CategoryProto.
                 * @implements ICategoryProto
                 * @constructor
                 * @param {waiternow.common.MenuSpecProto.ICategoryProto=} [properties] Properties to set
                 */
                function CategoryProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * CategoryProto id.
                 * @member {string} id
                 * @memberof waiternow.common.MenuSpecProto.CategoryProto
                 * @instance
                 */
                CategoryProto.prototype.id = "";

                /**
                 * CategoryProto parentCategoryId.
                 * @member {string} parentCategoryId
                 * @memberof waiternow.common.MenuSpecProto.CategoryProto
                 * @instance
                 */
                CategoryProto.prototype.parentCategoryId = "";

                /**
                 * CategoryProto name.
                 * @member {waiternow.common.ITextProto|null|undefined} name
                 * @memberof waiternow.common.MenuSpecProto.CategoryProto
                 * @instance
                 */
                CategoryProto.prototype.name = null;

                /**
                 * CategoryProto image.
                 * @member {waiternow.common.IImageProto|null|undefined} image
                 * @memberof waiternow.common.MenuSpecProto.CategoryProto
                 * @instance
                 */
                CategoryProto.prototype.image = null;

                /**
                 * Creates a new CategoryProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.MenuSpecProto.CategoryProto
                 * @static
                 * @param {waiternow.common.MenuSpecProto.ICategoryProto=} [properties] Properties to set
                 * @returns {waiternow.common.MenuSpecProto.CategoryProto} CategoryProto instance
                 */
                CategoryProto.create = function create(properties) {
                    return new CategoryProto(properties);
                };

                /**
                 * Encodes the specified CategoryProto message. Does not implicitly {@link waiternow.common.MenuSpecProto.CategoryProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.MenuSpecProto.CategoryProto
                 * @static
                 * @param {waiternow.common.MenuSpecProto.ICategoryProto} message CategoryProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CategoryProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                    if (message.parentCategoryId != null && Object.hasOwnProperty.call(message, "parentCategoryId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.parentCategoryId);
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        $root.waiternow.common.TextProto.encode(message.name, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.image != null && Object.hasOwnProperty.call(message, "image"))
                        $root.waiternow.common.ImageProto.encode(message.image, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified CategoryProto message, length delimited. Does not implicitly {@link waiternow.common.MenuSpecProto.CategoryProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.MenuSpecProto.CategoryProto
                 * @static
                 * @param {waiternow.common.MenuSpecProto.ICategoryProto} message CategoryProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CategoryProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a CategoryProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.MenuSpecProto.CategoryProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.MenuSpecProto.CategoryProto} CategoryProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CategoryProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.MenuSpecProto.CategoryProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.id = reader.string();
                                break;
                            }
                        case 2: {
                                message.parentCategoryId = reader.string();
                                break;
                            }
                        case 3: {
                                message.name = $root.waiternow.common.TextProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 4: {
                                message.image = $root.waiternow.common.ImageProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a CategoryProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.MenuSpecProto.CategoryProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.MenuSpecProto.CategoryProto} CategoryProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CategoryProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a CategoryProto message.
                 * @function verify
                 * @memberof waiternow.common.MenuSpecProto.CategoryProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                CategoryProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (!$util.isString(message.id))
                            return "id: string expected";
                    if (message.parentCategoryId != null && message.hasOwnProperty("parentCategoryId"))
                        if (!$util.isString(message.parentCategoryId))
                            return "parentCategoryId: string expected";
                    if (message.name != null && message.hasOwnProperty("name")) {
                        var error = $root.waiternow.common.TextProto.verify(message.name);
                        if (error)
                            return "name." + error;
                    }
                    if (message.image != null && message.hasOwnProperty("image")) {
                        var error = $root.waiternow.common.ImageProto.verify(message.image);
                        if (error)
                            return "image." + error;
                    }
                    return null;
                };

                /**
                 * Creates a CategoryProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.MenuSpecProto.CategoryProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.MenuSpecProto.CategoryProto} CategoryProto
                 */
                CategoryProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.MenuSpecProto.CategoryProto)
                        return object;
                    var message = new $root.waiternow.common.MenuSpecProto.CategoryProto();
                    if (object.id != null)
                        message.id = String(object.id);
                    if (object.parentCategoryId != null)
                        message.parentCategoryId = String(object.parentCategoryId);
                    if (object.name != null) {
                        if (typeof object.name !== "object")
                            throw TypeError(".waiternow.common.MenuSpecProto.CategoryProto.name: object expected");
                        message.name = $root.waiternow.common.TextProto.fromObject(object.name);
                    }
                    if (object.image != null) {
                        if (typeof object.image !== "object")
                            throw TypeError(".waiternow.common.MenuSpecProto.CategoryProto.image: object expected");
                        message.image = $root.waiternow.common.ImageProto.fromObject(object.image);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a CategoryProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.MenuSpecProto.CategoryProto
                 * @static
                 * @param {waiternow.common.MenuSpecProto.CategoryProto} message CategoryProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                CategoryProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.id = "";
                        object.parentCategoryId = "";
                        object.name = null;
                        object.image = null;
                    }
                    if (message.id != null && message.hasOwnProperty("id"))
                        object.id = message.id;
                    if (message.parentCategoryId != null && message.hasOwnProperty("parentCategoryId"))
                        object.parentCategoryId = message.parentCategoryId;
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = $root.waiternow.common.TextProto.toObject(message.name, options);
                    if (message.image != null && message.hasOwnProperty("image"))
                        object.image = $root.waiternow.common.ImageProto.toObject(message.image, options);
                    return object;
                };

                /**
                 * Converts this CategoryProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.MenuSpecProto.CategoryProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                CategoryProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for CategoryProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.MenuSpecProto.CategoryProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                CategoryProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.MenuSpecProto.CategoryProto";
                };

                return CategoryProto;
            })();

            return MenuSpecProto;
        })();

        common.MenuProto = (function() {

            /**
             * Properties of a MenuProto.
             * @memberof waiternow.common
             * @interface IMenuProto
             * @property {waiternow.common.IImageProto|null} [headerImage] MenuProto headerImage
             * @property {Array.<waiternow.common.MenuProto.ICategoryLevel1Proto>|null} [categories] MenuProto categories
             * @property {Array.<waiternow.common.MenuProto.IMenuEntryProto>|null} [uncategorizedMenuEntries] MenuProto uncategorizedMenuEntries
             * @property {google.protobuf.ITimestamp|null} [expiration] MenuProto expiration
             */

            /**
             * Constructs a new MenuProto.
             * @memberof waiternow.common
             * @classdesc Represents a MenuProto.
             * @implements IMenuProto
             * @constructor
             * @param {waiternow.common.IMenuProto=} [properties] Properties to set
             */
            function MenuProto(properties) {
                this.categories = [];
                this.uncategorizedMenuEntries = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * MenuProto headerImage.
             * @member {waiternow.common.IImageProto|null|undefined} headerImage
             * @memberof waiternow.common.MenuProto
             * @instance
             */
            MenuProto.prototype.headerImage = null;

            /**
             * MenuProto categories.
             * @member {Array.<waiternow.common.MenuProto.ICategoryLevel1Proto>} categories
             * @memberof waiternow.common.MenuProto
             * @instance
             */
            MenuProto.prototype.categories = $util.emptyArray;

            /**
             * MenuProto uncategorizedMenuEntries.
             * @member {Array.<waiternow.common.MenuProto.IMenuEntryProto>} uncategorizedMenuEntries
             * @memberof waiternow.common.MenuProto
             * @instance
             */
            MenuProto.prototype.uncategorizedMenuEntries = $util.emptyArray;

            /**
             * MenuProto expiration.
             * @member {google.protobuf.ITimestamp|null|undefined} expiration
             * @memberof waiternow.common.MenuProto
             * @instance
             */
            MenuProto.prototype.expiration = null;

            /**
             * Creates a new MenuProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.MenuProto
             * @static
             * @param {waiternow.common.IMenuProto=} [properties] Properties to set
             * @returns {waiternow.common.MenuProto} MenuProto instance
             */
            MenuProto.create = function create(properties) {
                return new MenuProto(properties);
            };

            /**
             * Encodes the specified MenuProto message. Does not implicitly {@link waiternow.common.MenuProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.MenuProto
             * @static
             * @param {waiternow.common.IMenuProto} message MenuProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MenuProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.headerImage != null && Object.hasOwnProperty.call(message, "headerImage"))
                    $root.waiternow.common.ImageProto.encode(message.headerImage, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.categories != null && message.categories.length)
                    for (var i = 0; i < message.categories.length; ++i)
                        $root.waiternow.common.MenuProto.CategoryLevel1Proto.encode(message.categories[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.uncategorizedMenuEntries != null && message.uncategorizedMenuEntries.length)
                    for (var i = 0; i < message.uncategorizedMenuEntries.length; ++i)
                        $root.waiternow.common.MenuProto.MenuEntryProto.encode(message.uncategorizedMenuEntries[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.expiration != null && Object.hasOwnProperty.call(message, "expiration"))
                    $root.google.protobuf.Timestamp.encode(message.expiration, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified MenuProto message, length delimited. Does not implicitly {@link waiternow.common.MenuProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.MenuProto
             * @static
             * @param {waiternow.common.IMenuProto} message MenuProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MenuProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a MenuProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.MenuProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.MenuProto} MenuProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MenuProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.MenuProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.headerImage = $root.waiternow.common.ImageProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 2: {
                            if (!(message.categories && message.categories.length))
                                message.categories = [];
                            message.categories.push($root.waiternow.common.MenuProto.CategoryLevel1Proto.decode(reader, reader.uint32()));
                            break;
                        }
                    case 3: {
                            if (!(message.uncategorizedMenuEntries && message.uncategorizedMenuEntries.length))
                                message.uncategorizedMenuEntries = [];
                            message.uncategorizedMenuEntries.push($root.waiternow.common.MenuProto.MenuEntryProto.decode(reader, reader.uint32()));
                            break;
                        }
                    case 4: {
                            message.expiration = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a MenuProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.MenuProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.MenuProto} MenuProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MenuProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a MenuProto message.
             * @function verify
             * @memberof waiternow.common.MenuProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            MenuProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.headerImage != null && message.hasOwnProperty("headerImage")) {
                    var error = $root.waiternow.common.ImageProto.verify(message.headerImage);
                    if (error)
                        return "headerImage." + error;
                }
                if (message.categories != null && message.hasOwnProperty("categories")) {
                    if (!Array.isArray(message.categories))
                        return "categories: array expected";
                    for (var i = 0; i < message.categories.length; ++i) {
                        var error = $root.waiternow.common.MenuProto.CategoryLevel1Proto.verify(message.categories[i]);
                        if (error)
                            return "categories." + error;
                    }
                }
                if (message.uncategorizedMenuEntries != null && message.hasOwnProperty("uncategorizedMenuEntries")) {
                    if (!Array.isArray(message.uncategorizedMenuEntries))
                        return "uncategorizedMenuEntries: array expected";
                    for (var i = 0; i < message.uncategorizedMenuEntries.length; ++i) {
                        var error = $root.waiternow.common.MenuProto.MenuEntryProto.verify(message.uncategorizedMenuEntries[i]);
                        if (error)
                            return "uncategorizedMenuEntries." + error;
                    }
                }
                if (message.expiration != null && message.hasOwnProperty("expiration")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.expiration);
                    if (error)
                        return "expiration." + error;
                }
                return null;
            };

            /**
             * Creates a MenuProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.MenuProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.MenuProto} MenuProto
             */
            MenuProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.MenuProto)
                    return object;
                var message = new $root.waiternow.common.MenuProto();
                if (object.headerImage != null) {
                    if (typeof object.headerImage !== "object")
                        throw TypeError(".waiternow.common.MenuProto.headerImage: object expected");
                    message.headerImage = $root.waiternow.common.ImageProto.fromObject(object.headerImage);
                }
                if (object.categories) {
                    if (!Array.isArray(object.categories))
                        throw TypeError(".waiternow.common.MenuProto.categories: array expected");
                    message.categories = [];
                    for (var i = 0; i < object.categories.length; ++i) {
                        if (typeof object.categories[i] !== "object")
                            throw TypeError(".waiternow.common.MenuProto.categories: object expected");
                        message.categories[i] = $root.waiternow.common.MenuProto.CategoryLevel1Proto.fromObject(object.categories[i]);
                    }
                }
                if (object.uncategorizedMenuEntries) {
                    if (!Array.isArray(object.uncategorizedMenuEntries))
                        throw TypeError(".waiternow.common.MenuProto.uncategorizedMenuEntries: array expected");
                    message.uncategorizedMenuEntries = [];
                    for (var i = 0; i < object.uncategorizedMenuEntries.length; ++i) {
                        if (typeof object.uncategorizedMenuEntries[i] !== "object")
                            throw TypeError(".waiternow.common.MenuProto.uncategorizedMenuEntries: object expected");
                        message.uncategorizedMenuEntries[i] = $root.waiternow.common.MenuProto.MenuEntryProto.fromObject(object.uncategorizedMenuEntries[i]);
                    }
                }
                if (object.expiration != null) {
                    if (typeof object.expiration !== "object")
                        throw TypeError(".waiternow.common.MenuProto.expiration: object expected");
                    message.expiration = $root.google.protobuf.Timestamp.fromObject(object.expiration);
                }
                return message;
            };

            /**
             * Creates a plain object from a MenuProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.MenuProto
             * @static
             * @param {waiternow.common.MenuProto} message MenuProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            MenuProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults) {
                    object.categories = [];
                    object.uncategorizedMenuEntries = [];
                }
                if (options.defaults) {
                    object.headerImage = null;
                    object.expiration = null;
                }
                if (message.headerImage != null && message.hasOwnProperty("headerImage"))
                    object.headerImage = $root.waiternow.common.ImageProto.toObject(message.headerImage, options);
                if (message.categories && message.categories.length) {
                    object.categories = [];
                    for (var j = 0; j < message.categories.length; ++j)
                        object.categories[j] = $root.waiternow.common.MenuProto.CategoryLevel1Proto.toObject(message.categories[j], options);
                }
                if (message.uncategorizedMenuEntries && message.uncategorizedMenuEntries.length) {
                    object.uncategorizedMenuEntries = [];
                    for (var j = 0; j < message.uncategorizedMenuEntries.length; ++j)
                        object.uncategorizedMenuEntries[j] = $root.waiternow.common.MenuProto.MenuEntryProto.toObject(message.uncategorizedMenuEntries[j], options);
                }
                if (message.expiration != null && message.hasOwnProperty("expiration"))
                    object.expiration = $root.google.protobuf.Timestamp.toObject(message.expiration, options);
                return object;
            };

            /**
             * Converts this MenuProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.MenuProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            MenuProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for MenuProto
             * @function getTypeUrl
             * @memberof waiternow.common.MenuProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            MenuProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.MenuProto";
            };

            MenuProto.ItemProto = (function() {

                /**
                 * Properties of an ItemProto.
                 * @memberof waiternow.common.MenuProto
                 * @interface IItemProto
                 * @property {string|null} [id] ItemProto id
                 * @property {waiternow.common.ITextProto|null} [name] ItemProto name
                 * @property {waiternow.common.ITextProto|null} [description] ItemProto description
                 * @property {waiternow.common.IImageProto|null} [image] ItemProto image
                 * @property {waiternow.common.IMoneyProto|null} [price] ItemProto price
                 * @property {boolean|null} [isUnavailable] ItemProto isUnavailable
                 */

                /**
                 * Constructs a new ItemProto.
                 * @memberof waiternow.common.MenuProto
                 * @classdesc Represents an ItemProto.
                 * @implements IItemProto
                 * @constructor
                 * @param {waiternow.common.MenuProto.IItemProto=} [properties] Properties to set
                 */
                function ItemProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ItemProto id.
                 * @member {string} id
                 * @memberof waiternow.common.MenuProto.ItemProto
                 * @instance
                 */
                ItemProto.prototype.id = "";

                /**
                 * ItemProto name.
                 * @member {waiternow.common.ITextProto|null|undefined} name
                 * @memberof waiternow.common.MenuProto.ItemProto
                 * @instance
                 */
                ItemProto.prototype.name = null;

                /**
                 * ItemProto description.
                 * @member {waiternow.common.ITextProto|null|undefined} description
                 * @memberof waiternow.common.MenuProto.ItemProto
                 * @instance
                 */
                ItemProto.prototype.description = null;

                /**
                 * ItemProto image.
                 * @member {waiternow.common.IImageProto|null|undefined} image
                 * @memberof waiternow.common.MenuProto.ItemProto
                 * @instance
                 */
                ItemProto.prototype.image = null;

                /**
                 * ItemProto price.
                 * @member {waiternow.common.IMoneyProto|null|undefined} price
                 * @memberof waiternow.common.MenuProto.ItemProto
                 * @instance
                 */
                ItemProto.prototype.price = null;

                /**
                 * ItemProto isUnavailable.
                 * @member {boolean} isUnavailable
                 * @memberof waiternow.common.MenuProto.ItemProto
                 * @instance
                 */
                ItemProto.prototype.isUnavailable = false;

                /**
                 * Creates a new ItemProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.MenuProto.ItemProto
                 * @static
                 * @param {waiternow.common.MenuProto.IItemProto=} [properties] Properties to set
                 * @returns {waiternow.common.MenuProto.ItemProto} ItemProto instance
                 */
                ItemProto.create = function create(properties) {
                    return new ItemProto(properties);
                };

                /**
                 * Encodes the specified ItemProto message. Does not implicitly {@link waiternow.common.MenuProto.ItemProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.MenuProto.ItemProto
                 * @static
                 * @param {waiternow.common.MenuProto.IItemProto} message ItemProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ItemProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        $root.waiternow.common.TextProto.encode(message.name, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                        $root.waiternow.common.TextProto.encode(message.description, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.image != null && Object.hasOwnProperty.call(message, "image"))
                        $root.waiternow.common.ImageProto.encode(message.image, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.price != null && Object.hasOwnProperty.call(message, "price"))
                        $root.waiternow.common.MoneyProto.encode(message.price, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.id);
                    if (message.isUnavailable != null && Object.hasOwnProperty.call(message, "isUnavailable"))
                        writer.uint32(/* id 6, wireType 0 =*/48).bool(message.isUnavailable);
                    return writer;
                };

                /**
                 * Encodes the specified ItemProto message, length delimited. Does not implicitly {@link waiternow.common.MenuProto.ItemProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.MenuProto.ItemProto
                 * @static
                 * @param {waiternow.common.MenuProto.IItemProto} message ItemProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ItemProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an ItemProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.MenuProto.ItemProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.MenuProto.ItemProto} ItemProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ItemProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.MenuProto.ItemProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 5: {
                                message.id = reader.string();
                                break;
                            }
                        case 1: {
                                message.name = $root.waiternow.common.TextProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.description = $root.waiternow.common.TextProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.image = $root.waiternow.common.ImageProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 4: {
                                message.price = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 6: {
                                message.isUnavailable = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an ItemProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.MenuProto.ItemProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.MenuProto.ItemProto} ItemProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ItemProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an ItemProto message.
                 * @function verify
                 * @memberof waiternow.common.MenuProto.ItemProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ItemProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (!$util.isString(message.id))
                            return "id: string expected";
                    if (message.name != null && message.hasOwnProperty("name")) {
                        var error = $root.waiternow.common.TextProto.verify(message.name);
                        if (error)
                            return "name." + error;
                    }
                    if (message.description != null && message.hasOwnProperty("description")) {
                        var error = $root.waiternow.common.TextProto.verify(message.description);
                        if (error)
                            return "description." + error;
                    }
                    if (message.image != null && message.hasOwnProperty("image")) {
                        var error = $root.waiternow.common.ImageProto.verify(message.image);
                        if (error)
                            return "image." + error;
                    }
                    if (message.price != null && message.hasOwnProperty("price")) {
                        var error = $root.waiternow.common.MoneyProto.verify(message.price);
                        if (error)
                            return "price." + error;
                    }
                    if (message.isUnavailable != null && message.hasOwnProperty("isUnavailable"))
                        if (typeof message.isUnavailable !== "boolean")
                            return "isUnavailable: boolean expected";
                    return null;
                };

                /**
                 * Creates an ItemProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.MenuProto.ItemProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.MenuProto.ItemProto} ItemProto
                 */
                ItemProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.MenuProto.ItemProto)
                        return object;
                    var message = new $root.waiternow.common.MenuProto.ItemProto();
                    if (object.id != null)
                        message.id = String(object.id);
                    if (object.name != null) {
                        if (typeof object.name !== "object")
                            throw TypeError(".waiternow.common.MenuProto.ItemProto.name: object expected");
                        message.name = $root.waiternow.common.TextProto.fromObject(object.name);
                    }
                    if (object.description != null) {
                        if (typeof object.description !== "object")
                            throw TypeError(".waiternow.common.MenuProto.ItemProto.description: object expected");
                        message.description = $root.waiternow.common.TextProto.fromObject(object.description);
                    }
                    if (object.image != null) {
                        if (typeof object.image !== "object")
                            throw TypeError(".waiternow.common.MenuProto.ItemProto.image: object expected");
                        message.image = $root.waiternow.common.ImageProto.fromObject(object.image);
                    }
                    if (object.price != null) {
                        if (typeof object.price !== "object")
                            throw TypeError(".waiternow.common.MenuProto.ItemProto.price: object expected");
                        message.price = $root.waiternow.common.MoneyProto.fromObject(object.price);
                    }
                    if (object.isUnavailable != null)
                        message.isUnavailable = Boolean(object.isUnavailable);
                    return message;
                };

                /**
                 * Creates a plain object from an ItemProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.MenuProto.ItemProto
                 * @static
                 * @param {waiternow.common.MenuProto.ItemProto} message ItemProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ItemProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.name = null;
                        object.description = null;
                        object.image = null;
                        object.price = null;
                        object.id = "";
                        object.isUnavailable = false;
                    }
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = $root.waiternow.common.TextProto.toObject(message.name, options);
                    if (message.description != null && message.hasOwnProperty("description"))
                        object.description = $root.waiternow.common.TextProto.toObject(message.description, options);
                    if (message.image != null && message.hasOwnProperty("image"))
                        object.image = $root.waiternow.common.ImageProto.toObject(message.image, options);
                    if (message.price != null && message.hasOwnProperty("price"))
                        object.price = $root.waiternow.common.MoneyProto.toObject(message.price, options);
                    if (message.id != null && message.hasOwnProperty("id"))
                        object.id = message.id;
                    if (message.isUnavailable != null && message.hasOwnProperty("isUnavailable"))
                        object.isUnavailable = message.isUnavailable;
                    return object;
                };

                /**
                 * Converts this ItemProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.MenuProto.ItemProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ItemProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ItemProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.MenuProto.ItemProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ItemProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.MenuProto.ItemProto";
                };

                return ItemProto;
            })();

            MenuProto.ItemSelectionProto = (function() {

                /**
                 * Properties of an ItemSelectionProto.
                 * @memberof waiternow.common.MenuProto
                 * @interface IItemSelectionProto
                 * @property {string|null} [id] ItemSelectionProto id
                 * @property {waiternow.common.ITextProto|null} [title] ItemSelectionProto title
                 * @property {Array.<waiternow.common.MenuProto.IItemProto>|null} [items] ItemSelectionProto items
                 * @property {waiternow.common.SelectionType|null} [selectionType] ItemSelectionProto selectionType
                 * @property {boolean|null} [isRequired] ItemSelectionProto isRequired
                 * @property {number|null} [maxSelections] ItemSelectionProto maxSelections
                 */

                /**
                 * Constructs a new ItemSelectionProto.
                 * @memberof waiternow.common.MenuProto
                 * @classdesc Represents an ItemSelectionProto.
                 * @implements IItemSelectionProto
                 * @constructor
                 * @param {waiternow.common.MenuProto.IItemSelectionProto=} [properties] Properties to set
                 */
                function ItemSelectionProto(properties) {
                    this.items = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ItemSelectionProto id.
                 * @member {string} id
                 * @memberof waiternow.common.MenuProto.ItemSelectionProto
                 * @instance
                 */
                ItemSelectionProto.prototype.id = "";

                /**
                 * ItemSelectionProto title.
                 * @member {waiternow.common.ITextProto|null|undefined} title
                 * @memberof waiternow.common.MenuProto.ItemSelectionProto
                 * @instance
                 */
                ItemSelectionProto.prototype.title = null;

                /**
                 * ItemSelectionProto items.
                 * @member {Array.<waiternow.common.MenuProto.IItemProto>} items
                 * @memberof waiternow.common.MenuProto.ItemSelectionProto
                 * @instance
                 */
                ItemSelectionProto.prototype.items = $util.emptyArray;

                /**
                 * ItemSelectionProto selectionType.
                 * @member {waiternow.common.SelectionType} selectionType
                 * @memberof waiternow.common.MenuProto.ItemSelectionProto
                 * @instance
                 */
                ItemSelectionProto.prototype.selectionType = 0;

                /**
                 * ItemSelectionProto isRequired.
                 * @member {boolean} isRequired
                 * @memberof waiternow.common.MenuProto.ItemSelectionProto
                 * @instance
                 */
                ItemSelectionProto.prototype.isRequired = false;

                /**
                 * ItemSelectionProto maxSelections.
                 * @member {number} maxSelections
                 * @memberof waiternow.common.MenuProto.ItemSelectionProto
                 * @instance
                 */
                ItemSelectionProto.prototype.maxSelections = 0;

                /**
                 * Creates a new ItemSelectionProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.MenuProto.ItemSelectionProto
                 * @static
                 * @param {waiternow.common.MenuProto.IItemSelectionProto=} [properties] Properties to set
                 * @returns {waiternow.common.MenuProto.ItemSelectionProto} ItemSelectionProto instance
                 */
                ItemSelectionProto.create = function create(properties) {
                    return new ItemSelectionProto(properties);
                };

                /**
                 * Encodes the specified ItemSelectionProto message. Does not implicitly {@link waiternow.common.MenuProto.ItemSelectionProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.MenuProto.ItemSelectionProto
                 * @static
                 * @param {waiternow.common.MenuProto.IItemSelectionProto} message ItemSelectionProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ItemSelectionProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                        $root.waiternow.common.TextProto.encode(message.title, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.items != null && message.items.length)
                        for (var i = 0; i < message.items.length; ++i)
                            $root.waiternow.common.MenuProto.ItemProto.encode(message.items[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.selectionType != null && Object.hasOwnProperty.call(message, "selectionType"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.selectionType);
                    if (message.isRequired != null && Object.hasOwnProperty.call(message, "isRequired"))
                        writer.uint32(/* id 4, wireType 0 =*/32).bool(message.isRequired);
                    if (message.maxSelections != null && Object.hasOwnProperty.call(message, "maxSelections"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int32(message.maxSelections);
                    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                        writer.uint32(/* id 6, wireType 2 =*/50).string(message.id);
                    return writer;
                };

                /**
                 * Encodes the specified ItemSelectionProto message, length delimited. Does not implicitly {@link waiternow.common.MenuProto.ItemSelectionProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.MenuProto.ItemSelectionProto
                 * @static
                 * @param {waiternow.common.MenuProto.IItemSelectionProto} message ItemSelectionProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ItemSelectionProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an ItemSelectionProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.MenuProto.ItemSelectionProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.MenuProto.ItemSelectionProto} ItemSelectionProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ItemSelectionProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.MenuProto.ItemSelectionProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 6: {
                                message.id = reader.string();
                                break;
                            }
                        case 1: {
                                message.title = $root.waiternow.common.TextProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                if (!(message.items && message.items.length))
                                    message.items = [];
                                message.items.push($root.waiternow.common.MenuProto.ItemProto.decode(reader, reader.uint32()));
                                break;
                            }
                        case 3: {
                                message.selectionType = reader.int32();
                                break;
                            }
                        case 4: {
                                message.isRequired = reader.bool();
                                break;
                            }
                        case 5: {
                                message.maxSelections = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an ItemSelectionProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.MenuProto.ItemSelectionProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.MenuProto.ItemSelectionProto} ItemSelectionProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ItemSelectionProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an ItemSelectionProto message.
                 * @function verify
                 * @memberof waiternow.common.MenuProto.ItemSelectionProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ItemSelectionProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (!$util.isString(message.id))
                            return "id: string expected";
                    if (message.title != null && message.hasOwnProperty("title")) {
                        var error = $root.waiternow.common.TextProto.verify(message.title);
                        if (error)
                            return "title." + error;
                    }
                    if (message.items != null && message.hasOwnProperty("items")) {
                        if (!Array.isArray(message.items))
                            return "items: array expected";
                        for (var i = 0; i < message.items.length; ++i) {
                            var error = $root.waiternow.common.MenuProto.ItemProto.verify(message.items[i]);
                            if (error)
                                return "items." + error;
                        }
                    }
                    if (message.selectionType != null && message.hasOwnProperty("selectionType"))
                        switch (message.selectionType) {
                        default:
                            return "selectionType: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.isRequired != null && message.hasOwnProperty("isRequired"))
                        if (typeof message.isRequired !== "boolean")
                            return "isRequired: boolean expected";
                    if (message.maxSelections != null && message.hasOwnProperty("maxSelections"))
                        if (!$util.isInteger(message.maxSelections))
                            return "maxSelections: integer expected";
                    return null;
                };

                /**
                 * Creates an ItemSelectionProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.MenuProto.ItemSelectionProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.MenuProto.ItemSelectionProto} ItemSelectionProto
                 */
                ItemSelectionProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.MenuProto.ItemSelectionProto)
                        return object;
                    var message = new $root.waiternow.common.MenuProto.ItemSelectionProto();
                    if (object.id != null)
                        message.id = String(object.id);
                    if (object.title != null) {
                        if (typeof object.title !== "object")
                            throw TypeError(".waiternow.common.MenuProto.ItemSelectionProto.title: object expected");
                        message.title = $root.waiternow.common.TextProto.fromObject(object.title);
                    }
                    if (object.items) {
                        if (!Array.isArray(object.items))
                            throw TypeError(".waiternow.common.MenuProto.ItemSelectionProto.items: array expected");
                        message.items = [];
                        for (var i = 0; i < object.items.length; ++i) {
                            if (typeof object.items[i] !== "object")
                                throw TypeError(".waiternow.common.MenuProto.ItemSelectionProto.items: object expected");
                            message.items[i] = $root.waiternow.common.MenuProto.ItemProto.fromObject(object.items[i]);
                        }
                    }
                    switch (object.selectionType) {
                    default:
                        if (typeof object.selectionType === "number") {
                            message.selectionType = object.selectionType;
                            break;
                        }
                        break;
                    case "SELECTION_TYPE_UNSPECIFIED":
                    case 0:
                        message.selectionType = 0;
                        break;
                    case "SINGLE":
                    case 1:
                        message.selectionType = 1;
                        break;
                    case "MULTIPLE":
                    case 2:
                        message.selectionType = 2;
                        break;
                    }
                    if (object.isRequired != null)
                        message.isRequired = Boolean(object.isRequired);
                    if (object.maxSelections != null)
                        message.maxSelections = object.maxSelections | 0;
                    return message;
                };

                /**
                 * Creates a plain object from an ItemSelectionProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.MenuProto.ItemSelectionProto
                 * @static
                 * @param {waiternow.common.MenuProto.ItemSelectionProto} message ItemSelectionProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ItemSelectionProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.items = [];
                    if (options.defaults) {
                        object.title = null;
                        object.selectionType = options.enums === String ? "SELECTION_TYPE_UNSPECIFIED" : 0;
                        object.isRequired = false;
                        object.maxSelections = 0;
                        object.id = "";
                    }
                    if (message.title != null && message.hasOwnProperty("title"))
                        object.title = $root.waiternow.common.TextProto.toObject(message.title, options);
                    if (message.items && message.items.length) {
                        object.items = [];
                        for (var j = 0; j < message.items.length; ++j)
                            object.items[j] = $root.waiternow.common.MenuProto.ItemProto.toObject(message.items[j], options);
                    }
                    if (message.selectionType != null && message.hasOwnProperty("selectionType"))
                        object.selectionType = options.enums === String ? $root.waiternow.common.SelectionType[message.selectionType] === undefined ? message.selectionType : $root.waiternow.common.SelectionType[message.selectionType] : message.selectionType;
                    if (message.isRequired != null && message.hasOwnProperty("isRequired"))
                        object.isRequired = message.isRequired;
                    if (message.maxSelections != null && message.hasOwnProperty("maxSelections"))
                        object.maxSelections = message.maxSelections;
                    if (message.id != null && message.hasOwnProperty("id"))
                        object.id = message.id;
                    return object;
                };

                /**
                 * Converts this ItemSelectionProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.MenuProto.ItemSelectionProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ItemSelectionProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ItemSelectionProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.MenuProto.ItemSelectionProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ItemSelectionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.MenuProto.ItemSelectionProto";
                };

                return ItemSelectionProto;
            })();

            MenuProto.MenuItemProto = (function() {

                /**
                 * Properties of a MenuItemProto.
                 * @memberof waiternow.common.MenuProto
                 * @interface IMenuItemProto
                 * @property {string|null} [id] MenuItemProto id
                 * @property {waiternow.common.ITextProto|null} [name] MenuItemProto name
                 * @property {waiternow.common.ITextProto|null} [description] MenuItemProto description
                 * @property {waiternow.common.IImageProto|null} [image] MenuItemProto image
                 * @property {Array.<waiternow.common.MenuProto.IItemProto>|null} [removableIngredients] MenuItemProto removableIngredients
                 * @property {Array.<waiternow.common.MenuProto.IItemSelectionProto>|null} [itemSelections] MenuItemProto itemSelections
                 * @property {number|null} [calories] MenuItemProto calories
                 * @property {boolean|null} [containsAlcohol] MenuItemProto containsAlcohol
                 * @property {boolean|null} [isUnavailable] MenuItemProto isUnavailable
                 * @property {waiternow.common.IMoneyProto|null} [price] MenuItemProto price
                 * @property {waiternow.common.IMoneyProto|null} [priceInCombo] MenuItemProto priceInCombo
                 * @property {string|null} [station] MenuItemProto station
                 * @property {waiternow.common.IAvailabilityScheduleProto|null} [availabilitySchedule] MenuItemProto availabilitySchedule
                 */

                /**
                 * Constructs a new MenuItemProto.
                 * @memberof waiternow.common.MenuProto
                 * @classdesc Represents a MenuItemProto.
                 * @implements IMenuItemProto
                 * @constructor
                 * @param {waiternow.common.MenuProto.IMenuItemProto=} [properties] Properties to set
                 */
                function MenuItemProto(properties) {
                    this.removableIngredients = [];
                    this.itemSelections = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * MenuItemProto id.
                 * @member {string} id
                 * @memberof waiternow.common.MenuProto.MenuItemProto
                 * @instance
                 */
                MenuItemProto.prototype.id = "";

                /**
                 * MenuItemProto name.
                 * @member {waiternow.common.ITextProto|null|undefined} name
                 * @memberof waiternow.common.MenuProto.MenuItemProto
                 * @instance
                 */
                MenuItemProto.prototype.name = null;

                /**
                 * MenuItemProto description.
                 * @member {waiternow.common.ITextProto|null|undefined} description
                 * @memberof waiternow.common.MenuProto.MenuItemProto
                 * @instance
                 */
                MenuItemProto.prototype.description = null;

                /**
                 * MenuItemProto image.
                 * @member {waiternow.common.IImageProto|null|undefined} image
                 * @memberof waiternow.common.MenuProto.MenuItemProto
                 * @instance
                 */
                MenuItemProto.prototype.image = null;

                /**
                 * MenuItemProto removableIngredients.
                 * @member {Array.<waiternow.common.MenuProto.IItemProto>} removableIngredients
                 * @memberof waiternow.common.MenuProto.MenuItemProto
                 * @instance
                 */
                MenuItemProto.prototype.removableIngredients = $util.emptyArray;

                /**
                 * MenuItemProto itemSelections.
                 * @member {Array.<waiternow.common.MenuProto.IItemSelectionProto>} itemSelections
                 * @memberof waiternow.common.MenuProto.MenuItemProto
                 * @instance
                 */
                MenuItemProto.prototype.itemSelections = $util.emptyArray;

                /**
                 * MenuItemProto calories.
                 * @member {number} calories
                 * @memberof waiternow.common.MenuProto.MenuItemProto
                 * @instance
                 */
                MenuItemProto.prototype.calories = 0;

                /**
                 * MenuItemProto containsAlcohol.
                 * @member {boolean} containsAlcohol
                 * @memberof waiternow.common.MenuProto.MenuItemProto
                 * @instance
                 */
                MenuItemProto.prototype.containsAlcohol = false;

                /**
                 * MenuItemProto isUnavailable.
                 * @member {boolean} isUnavailable
                 * @memberof waiternow.common.MenuProto.MenuItemProto
                 * @instance
                 */
                MenuItemProto.prototype.isUnavailable = false;

                /**
                 * MenuItemProto price.
                 * @member {waiternow.common.IMoneyProto|null|undefined} price
                 * @memberof waiternow.common.MenuProto.MenuItemProto
                 * @instance
                 */
                MenuItemProto.prototype.price = null;

                /**
                 * MenuItemProto priceInCombo.
                 * @member {waiternow.common.IMoneyProto|null|undefined} priceInCombo
                 * @memberof waiternow.common.MenuProto.MenuItemProto
                 * @instance
                 */
                MenuItemProto.prototype.priceInCombo = null;

                /**
                 * MenuItemProto station.
                 * @member {string} station
                 * @memberof waiternow.common.MenuProto.MenuItemProto
                 * @instance
                 */
                MenuItemProto.prototype.station = "";

                /**
                 * MenuItemProto availabilitySchedule.
                 * @member {waiternow.common.IAvailabilityScheduleProto|null|undefined} availabilitySchedule
                 * @memberof waiternow.common.MenuProto.MenuItemProto
                 * @instance
                 */
                MenuItemProto.prototype.availabilitySchedule = null;

                /**
                 * Creates a new MenuItemProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.MenuProto.MenuItemProto
                 * @static
                 * @param {waiternow.common.MenuProto.IMenuItemProto=} [properties] Properties to set
                 * @returns {waiternow.common.MenuProto.MenuItemProto} MenuItemProto instance
                 */
                MenuItemProto.create = function create(properties) {
                    return new MenuItemProto(properties);
                };

                /**
                 * Encodes the specified MenuItemProto message. Does not implicitly {@link waiternow.common.MenuProto.MenuItemProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.MenuProto.MenuItemProto
                 * @static
                 * @param {waiternow.common.MenuProto.IMenuItemProto} message MenuItemProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MenuItemProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        $root.waiternow.common.TextProto.encode(message.name, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                        $root.waiternow.common.TextProto.encode(message.description, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.image != null && Object.hasOwnProperty.call(message, "image"))
                        $root.waiternow.common.ImageProto.encode(message.image, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.removableIngredients != null && message.removableIngredients.length)
                        for (var i = 0; i < message.removableIngredients.length; ++i)
                            $root.waiternow.common.MenuProto.ItemProto.encode(message.removableIngredients[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.itemSelections != null && message.itemSelections.length)
                        for (var i = 0; i < message.itemSelections.length; ++i)
                            $root.waiternow.common.MenuProto.ItemSelectionProto.encode(message.itemSelections[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.calories != null && Object.hasOwnProperty.call(message, "calories"))
                        writer.uint32(/* id 6, wireType 0 =*/48).int32(message.calories);
                    if (message.containsAlcohol != null && Object.hasOwnProperty.call(message, "containsAlcohol"))
                        writer.uint32(/* id 7, wireType 0 =*/56).bool(message.containsAlcohol);
                    if (message.isUnavailable != null && Object.hasOwnProperty.call(message, "isUnavailable"))
                        writer.uint32(/* id 8, wireType 0 =*/64).bool(message.isUnavailable);
                    if (message.price != null && Object.hasOwnProperty.call(message, "price"))
                        $root.waiternow.common.MoneyProto.encode(message.price, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                    if (message.priceInCombo != null && Object.hasOwnProperty.call(message, "priceInCombo"))
                        $root.waiternow.common.MoneyProto.encode(message.priceInCombo, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                    if (message.station != null && Object.hasOwnProperty.call(message, "station"))
                        writer.uint32(/* id 11, wireType 2 =*/90).string(message.station);
                    if (message.availabilitySchedule != null && Object.hasOwnProperty.call(message, "availabilitySchedule"))
                        $root.waiternow.common.AvailabilityScheduleProto.encode(message.availabilitySchedule, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                        writer.uint32(/* id 13, wireType 2 =*/106).string(message.id);
                    return writer;
                };

                /**
                 * Encodes the specified MenuItemProto message, length delimited. Does not implicitly {@link waiternow.common.MenuProto.MenuItemProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.MenuProto.MenuItemProto
                 * @static
                 * @param {waiternow.common.MenuProto.IMenuItemProto} message MenuItemProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MenuItemProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a MenuItemProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.MenuProto.MenuItemProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.MenuProto.MenuItemProto} MenuItemProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MenuItemProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.MenuProto.MenuItemProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 13: {
                                message.id = reader.string();
                                break;
                            }
                        case 1: {
                                message.name = $root.waiternow.common.TextProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.description = $root.waiternow.common.TextProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.image = $root.waiternow.common.ImageProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 4: {
                                if (!(message.removableIngredients && message.removableIngredients.length))
                                    message.removableIngredients = [];
                                message.removableIngredients.push($root.waiternow.common.MenuProto.ItemProto.decode(reader, reader.uint32()));
                                break;
                            }
                        case 5: {
                                if (!(message.itemSelections && message.itemSelections.length))
                                    message.itemSelections = [];
                                message.itemSelections.push($root.waiternow.common.MenuProto.ItemSelectionProto.decode(reader, reader.uint32()));
                                break;
                            }
                        case 6: {
                                message.calories = reader.int32();
                                break;
                            }
                        case 7: {
                                message.containsAlcohol = reader.bool();
                                break;
                            }
                        case 8: {
                                message.isUnavailable = reader.bool();
                                break;
                            }
                        case 9: {
                                message.price = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 10: {
                                message.priceInCombo = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 11: {
                                message.station = reader.string();
                                break;
                            }
                        case 12: {
                                message.availabilitySchedule = $root.waiternow.common.AvailabilityScheduleProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a MenuItemProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.MenuProto.MenuItemProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.MenuProto.MenuItemProto} MenuItemProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MenuItemProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a MenuItemProto message.
                 * @function verify
                 * @memberof waiternow.common.MenuProto.MenuItemProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                MenuItemProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (!$util.isString(message.id))
                            return "id: string expected";
                    if (message.name != null && message.hasOwnProperty("name")) {
                        var error = $root.waiternow.common.TextProto.verify(message.name);
                        if (error)
                            return "name." + error;
                    }
                    if (message.description != null && message.hasOwnProperty("description")) {
                        var error = $root.waiternow.common.TextProto.verify(message.description);
                        if (error)
                            return "description." + error;
                    }
                    if (message.image != null && message.hasOwnProperty("image")) {
                        var error = $root.waiternow.common.ImageProto.verify(message.image);
                        if (error)
                            return "image." + error;
                    }
                    if (message.removableIngredients != null && message.hasOwnProperty("removableIngredients")) {
                        if (!Array.isArray(message.removableIngredients))
                            return "removableIngredients: array expected";
                        for (var i = 0; i < message.removableIngredients.length; ++i) {
                            var error = $root.waiternow.common.MenuProto.ItemProto.verify(message.removableIngredients[i]);
                            if (error)
                                return "removableIngredients." + error;
                        }
                    }
                    if (message.itemSelections != null && message.hasOwnProperty("itemSelections")) {
                        if (!Array.isArray(message.itemSelections))
                            return "itemSelections: array expected";
                        for (var i = 0; i < message.itemSelections.length; ++i) {
                            var error = $root.waiternow.common.MenuProto.ItemSelectionProto.verify(message.itemSelections[i]);
                            if (error)
                                return "itemSelections." + error;
                        }
                    }
                    if (message.calories != null && message.hasOwnProperty("calories"))
                        if (!$util.isInteger(message.calories))
                            return "calories: integer expected";
                    if (message.containsAlcohol != null && message.hasOwnProperty("containsAlcohol"))
                        if (typeof message.containsAlcohol !== "boolean")
                            return "containsAlcohol: boolean expected";
                    if (message.isUnavailable != null && message.hasOwnProperty("isUnavailable"))
                        if (typeof message.isUnavailable !== "boolean")
                            return "isUnavailable: boolean expected";
                    if (message.price != null && message.hasOwnProperty("price")) {
                        var error = $root.waiternow.common.MoneyProto.verify(message.price);
                        if (error)
                            return "price." + error;
                    }
                    if (message.priceInCombo != null && message.hasOwnProperty("priceInCombo")) {
                        var error = $root.waiternow.common.MoneyProto.verify(message.priceInCombo);
                        if (error)
                            return "priceInCombo." + error;
                    }
                    if (message.station != null && message.hasOwnProperty("station"))
                        if (!$util.isString(message.station))
                            return "station: string expected";
                    if (message.availabilitySchedule != null && message.hasOwnProperty("availabilitySchedule")) {
                        var error = $root.waiternow.common.AvailabilityScheduleProto.verify(message.availabilitySchedule);
                        if (error)
                            return "availabilitySchedule." + error;
                    }
                    return null;
                };

                /**
                 * Creates a MenuItemProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.MenuProto.MenuItemProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.MenuProto.MenuItemProto} MenuItemProto
                 */
                MenuItemProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.MenuProto.MenuItemProto)
                        return object;
                    var message = new $root.waiternow.common.MenuProto.MenuItemProto();
                    if (object.id != null)
                        message.id = String(object.id);
                    if (object.name != null) {
                        if (typeof object.name !== "object")
                            throw TypeError(".waiternow.common.MenuProto.MenuItemProto.name: object expected");
                        message.name = $root.waiternow.common.TextProto.fromObject(object.name);
                    }
                    if (object.description != null) {
                        if (typeof object.description !== "object")
                            throw TypeError(".waiternow.common.MenuProto.MenuItemProto.description: object expected");
                        message.description = $root.waiternow.common.TextProto.fromObject(object.description);
                    }
                    if (object.image != null) {
                        if (typeof object.image !== "object")
                            throw TypeError(".waiternow.common.MenuProto.MenuItemProto.image: object expected");
                        message.image = $root.waiternow.common.ImageProto.fromObject(object.image);
                    }
                    if (object.removableIngredients) {
                        if (!Array.isArray(object.removableIngredients))
                            throw TypeError(".waiternow.common.MenuProto.MenuItemProto.removableIngredients: array expected");
                        message.removableIngredients = [];
                        for (var i = 0; i < object.removableIngredients.length; ++i) {
                            if (typeof object.removableIngredients[i] !== "object")
                                throw TypeError(".waiternow.common.MenuProto.MenuItemProto.removableIngredients: object expected");
                            message.removableIngredients[i] = $root.waiternow.common.MenuProto.ItemProto.fromObject(object.removableIngredients[i]);
                        }
                    }
                    if (object.itemSelections) {
                        if (!Array.isArray(object.itemSelections))
                            throw TypeError(".waiternow.common.MenuProto.MenuItemProto.itemSelections: array expected");
                        message.itemSelections = [];
                        for (var i = 0; i < object.itemSelections.length; ++i) {
                            if (typeof object.itemSelections[i] !== "object")
                                throw TypeError(".waiternow.common.MenuProto.MenuItemProto.itemSelections: object expected");
                            message.itemSelections[i] = $root.waiternow.common.MenuProto.ItemSelectionProto.fromObject(object.itemSelections[i]);
                        }
                    }
                    if (object.calories != null)
                        message.calories = object.calories | 0;
                    if (object.containsAlcohol != null)
                        message.containsAlcohol = Boolean(object.containsAlcohol);
                    if (object.isUnavailable != null)
                        message.isUnavailable = Boolean(object.isUnavailable);
                    if (object.price != null) {
                        if (typeof object.price !== "object")
                            throw TypeError(".waiternow.common.MenuProto.MenuItemProto.price: object expected");
                        message.price = $root.waiternow.common.MoneyProto.fromObject(object.price);
                    }
                    if (object.priceInCombo != null) {
                        if (typeof object.priceInCombo !== "object")
                            throw TypeError(".waiternow.common.MenuProto.MenuItemProto.priceInCombo: object expected");
                        message.priceInCombo = $root.waiternow.common.MoneyProto.fromObject(object.priceInCombo);
                    }
                    if (object.station != null)
                        message.station = String(object.station);
                    if (object.availabilitySchedule != null) {
                        if (typeof object.availabilitySchedule !== "object")
                            throw TypeError(".waiternow.common.MenuProto.MenuItemProto.availabilitySchedule: object expected");
                        message.availabilitySchedule = $root.waiternow.common.AvailabilityScheduleProto.fromObject(object.availabilitySchedule);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a MenuItemProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.MenuProto.MenuItemProto
                 * @static
                 * @param {waiternow.common.MenuProto.MenuItemProto} message MenuItemProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                MenuItemProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.removableIngredients = [];
                        object.itemSelections = [];
                    }
                    if (options.defaults) {
                        object.name = null;
                        object.description = null;
                        object.image = null;
                        object.calories = 0;
                        object.containsAlcohol = false;
                        object.isUnavailable = false;
                        object.price = null;
                        object.priceInCombo = null;
                        object.station = "";
                        object.availabilitySchedule = null;
                        object.id = "";
                    }
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = $root.waiternow.common.TextProto.toObject(message.name, options);
                    if (message.description != null && message.hasOwnProperty("description"))
                        object.description = $root.waiternow.common.TextProto.toObject(message.description, options);
                    if (message.image != null && message.hasOwnProperty("image"))
                        object.image = $root.waiternow.common.ImageProto.toObject(message.image, options);
                    if (message.removableIngredients && message.removableIngredients.length) {
                        object.removableIngredients = [];
                        for (var j = 0; j < message.removableIngredients.length; ++j)
                            object.removableIngredients[j] = $root.waiternow.common.MenuProto.ItemProto.toObject(message.removableIngredients[j], options);
                    }
                    if (message.itemSelections && message.itemSelections.length) {
                        object.itemSelections = [];
                        for (var j = 0; j < message.itemSelections.length; ++j)
                            object.itemSelections[j] = $root.waiternow.common.MenuProto.ItemSelectionProto.toObject(message.itemSelections[j], options);
                    }
                    if (message.calories != null && message.hasOwnProperty("calories"))
                        object.calories = message.calories;
                    if (message.containsAlcohol != null && message.hasOwnProperty("containsAlcohol"))
                        object.containsAlcohol = message.containsAlcohol;
                    if (message.isUnavailable != null && message.hasOwnProperty("isUnavailable"))
                        object.isUnavailable = message.isUnavailable;
                    if (message.price != null && message.hasOwnProperty("price"))
                        object.price = $root.waiternow.common.MoneyProto.toObject(message.price, options);
                    if (message.priceInCombo != null && message.hasOwnProperty("priceInCombo"))
                        object.priceInCombo = $root.waiternow.common.MoneyProto.toObject(message.priceInCombo, options);
                    if (message.station != null && message.hasOwnProperty("station"))
                        object.station = message.station;
                    if (message.availabilitySchedule != null && message.hasOwnProperty("availabilitySchedule"))
                        object.availabilitySchedule = $root.waiternow.common.AvailabilityScheduleProto.toObject(message.availabilitySchedule, options);
                    if (message.id != null && message.hasOwnProperty("id"))
                        object.id = message.id;
                    return object;
                };

                /**
                 * Converts this MenuItemProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.MenuProto.MenuItemProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                MenuItemProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for MenuItemProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.MenuProto.MenuItemProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                MenuItemProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.MenuProto.MenuItemProto";
                };

                return MenuItemProto;
            })();

            MenuProto.MenuItemSelectionProto = (function() {

                /**
                 * Properties of a MenuItemSelectionProto.
                 * @memberof waiternow.common.MenuProto
                 * @interface IMenuItemSelectionProto
                 * @property {string|null} [id] MenuItemSelectionProto id
                 * @property {waiternow.common.ITextProto|null} [title] MenuItemSelectionProto title
                 * @property {Array.<waiternow.common.MenuProto.IMenuItemProto>|null} [menuItems] MenuItemSelectionProto menuItems
                 * @property {waiternow.common.SelectionType|null} [selectionType] MenuItemSelectionProto selectionType
                 * @property {boolean|null} [isRequired] MenuItemSelectionProto isRequired
                 * @property {number|null} [maxSelections] MenuItemSelectionProto maxSelections
                 */

                /**
                 * Constructs a new MenuItemSelectionProto.
                 * @memberof waiternow.common.MenuProto
                 * @classdesc Represents a MenuItemSelectionProto.
                 * @implements IMenuItemSelectionProto
                 * @constructor
                 * @param {waiternow.common.MenuProto.IMenuItemSelectionProto=} [properties] Properties to set
                 */
                function MenuItemSelectionProto(properties) {
                    this.menuItems = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * MenuItemSelectionProto id.
                 * @member {string} id
                 * @memberof waiternow.common.MenuProto.MenuItemSelectionProto
                 * @instance
                 */
                MenuItemSelectionProto.prototype.id = "";

                /**
                 * MenuItemSelectionProto title.
                 * @member {waiternow.common.ITextProto|null|undefined} title
                 * @memberof waiternow.common.MenuProto.MenuItemSelectionProto
                 * @instance
                 */
                MenuItemSelectionProto.prototype.title = null;

                /**
                 * MenuItemSelectionProto menuItems.
                 * @member {Array.<waiternow.common.MenuProto.IMenuItemProto>} menuItems
                 * @memberof waiternow.common.MenuProto.MenuItemSelectionProto
                 * @instance
                 */
                MenuItemSelectionProto.prototype.menuItems = $util.emptyArray;

                /**
                 * MenuItemSelectionProto selectionType.
                 * @member {waiternow.common.SelectionType} selectionType
                 * @memberof waiternow.common.MenuProto.MenuItemSelectionProto
                 * @instance
                 */
                MenuItemSelectionProto.prototype.selectionType = 0;

                /**
                 * MenuItemSelectionProto isRequired.
                 * @member {boolean} isRequired
                 * @memberof waiternow.common.MenuProto.MenuItemSelectionProto
                 * @instance
                 */
                MenuItemSelectionProto.prototype.isRequired = false;

                /**
                 * MenuItemSelectionProto maxSelections.
                 * @member {number} maxSelections
                 * @memberof waiternow.common.MenuProto.MenuItemSelectionProto
                 * @instance
                 */
                MenuItemSelectionProto.prototype.maxSelections = 0;

                /**
                 * Creates a new MenuItemSelectionProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.MenuProto.MenuItemSelectionProto
                 * @static
                 * @param {waiternow.common.MenuProto.IMenuItemSelectionProto=} [properties] Properties to set
                 * @returns {waiternow.common.MenuProto.MenuItemSelectionProto} MenuItemSelectionProto instance
                 */
                MenuItemSelectionProto.create = function create(properties) {
                    return new MenuItemSelectionProto(properties);
                };

                /**
                 * Encodes the specified MenuItemSelectionProto message. Does not implicitly {@link waiternow.common.MenuProto.MenuItemSelectionProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.MenuProto.MenuItemSelectionProto
                 * @static
                 * @param {waiternow.common.MenuProto.IMenuItemSelectionProto} message MenuItemSelectionProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MenuItemSelectionProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                        $root.waiternow.common.TextProto.encode(message.title, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.menuItems != null && message.menuItems.length)
                        for (var i = 0; i < message.menuItems.length; ++i)
                            $root.waiternow.common.MenuProto.MenuItemProto.encode(message.menuItems[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.selectionType != null && Object.hasOwnProperty.call(message, "selectionType"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.selectionType);
                    if (message.isRequired != null && Object.hasOwnProperty.call(message, "isRequired"))
                        writer.uint32(/* id 4, wireType 0 =*/32).bool(message.isRequired);
                    if (message.maxSelections != null && Object.hasOwnProperty.call(message, "maxSelections"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int32(message.maxSelections);
                    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                        writer.uint32(/* id 6, wireType 2 =*/50).string(message.id);
                    return writer;
                };

                /**
                 * Encodes the specified MenuItemSelectionProto message, length delimited. Does not implicitly {@link waiternow.common.MenuProto.MenuItemSelectionProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.MenuProto.MenuItemSelectionProto
                 * @static
                 * @param {waiternow.common.MenuProto.IMenuItemSelectionProto} message MenuItemSelectionProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MenuItemSelectionProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a MenuItemSelectionProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.MenuProto.MenuItemSelectionProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.MenuProto.MenuItemSelectionProto} MenuItemSelectionProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MenuItemSelectionProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.MenuProto.MenuItemSelectionProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 6: {
                                message.id = reader.string();
                                break;
                            }
                        case 1: {
                                message.title = $root.waiternow.common.TextProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                if (!(message.menuItems && message.menuItems.length))
                                    message.menuItems = [];
                                message.menuItems.push($root.waiternow.common.MenuProto.MenuItemProto.decode(reader, reader.uint32()));
                                break;
                            }
                        case 3: {
                                message.selectionType = reader.int32();
                                break;
                            }
                        case 4: {
                                message.isRequired = reader.bool();
                                break;
                            }
                        case 5: {
                                message.maxSelections = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a MenuItemSelectionProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.MenuProto.MenuItemSelectionProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.MenuProto.MenuItemSelectionProto} MenuItemSelectionProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MenuItemSelectionProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a MenuItemSelectionProto message.
                 * @function verify
                 * @memberof waiternow.common.MenuProto.MenuItemSelectionProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                MenuItemSelectionProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (!$util.isString(message.id))
                            return "id: string expected";
                    if (message.title != null && message.hasOwnProperty("title")) {
                        var error = $root.waiternow.common.TextProto.verify(message.title);
                        if (error)
                            return "title." + error;
                    }
                    if (message.menuItems != null && message.hasOwnProperty("menuItems")) {
                        if (!Array.isArray(message.menuItems))
                            return "menuItems: array expected";
                        for (var i = 0; i < message.menuItems.length; ++i) {
                            var error = $root.waiternow.common.MenuProto.MenuItemProto.verify(message.menuItems[i]);
                            if (error)
                                return "menuItems." + error;
                        }
                    }
                    if (message.selectionType != null && message.hasOwnProperty("selectionType"))
                        switch (message.selectionType) {
                        default:
                            return "selectionType: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.isRequired != null && message.hasOwnProperty("isRequired"))
                        if (typeof message.isRequired !== "boolean")
                            return "isRequired: boolean expected";
                    if (message.maxSelections != null && message.hasOwnProperty("maxSelections"))
                        if (!$util.isInteger(message.maxSelections))
                            return "maxSelections: integer expected";
                    return null;
                };

                /**
                 * Creates a MenuItemSelectionProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.MenuProto.MenuItemSelectionProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.MenuProto.MenuItemSelectionProto} MenuItemSelectionProto
                 */
                MenuItemSelectionProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.MenuProto.MenuItemSelectionProto)
                        return object;
                    var message = new $root.waiternow.common.MenuProto.MenuItemSelectionProto();
                    if (object.id != null)
                        message.id = String(object.id);
                    if (object.title != null) {
                        if (typeof object.title !== "object")
                            throw TypeError(".waiternow.common.MenuProto.MenuItemSelectionProto.title: object expected");
                        message.title = $root.waiternow.common.TextProto.fromObject(object.title);
                    }
                    if (object.menuItems) {
                        if (!Array.isArray(object.menuItems))
                            throw TypeError(".waiternow.common.MenuProto.MenuItemSelectionProto.menuItems: array expected");
                        message.menuItems = [];
                        for (var i = 0; i < object.menuItems.length; ++i) {
                            if (typeof object.menuItems[i] !== "object")
                                throw TypeError(".waiternow.common.MenuProto.MenuItemSelectionProto.menuItems: object expected");
                            message.menuItems[i] = $root.waiternow.common.MenuProto.MenuItemProto.fromObject(object.menuItems[i]);
                        }
                    }
                    switch (object.selectionType) {
                    default:
                        if (typeof object.selectionType === "number") {
                            message.selectionType = object.selectionType;
                            break;
                        }
                        break;
                    case "SELECTION_TYPE_UNSPECIFIED":
                    case 0:
                        message.selectionType = 0;
                        break;
                    case "SINGLE":
                    case 1:
                        message.selectionType = 1;
                        break;
                    case "MULTIPLE":
                    case 2:
                        message.selectionType = 2;
                        break;
                    }
                    if (object.isRequired != null)
                        message.isRequired = Boolean(object.isRequired);
                    if (object.maxSelections != null)
                        message.maxSelections = object.maxSelections | 0;
                    return message;
                };

                /**
                 * Creates a plain object from a MenuItemSelectionProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.MenuProto.MenuItemSelectionProto
                 * @static
                 * @param {waiternow.common.MenuProto.MenuItemSelectionProto} message MenuItemSelectionProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                MenuItemSelectionProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.menuItems = [];
                    if (options.defaults) {
                        object.title = null;
                        object.selectionType = options.enums === String ? "SELECTION_TYPE_UNSPECIFIED" : 0;
                        object.isRequired = false;
                        object.maxSelections = 0;
                        object.id = "";
                    }
                    if (message.title != null && message.hasOwnProperty("title"))
                        object.title = $root.waiternow.common.TextProto.toObject(message.title, options);
                    if (message.menuItems && message.menuItems.length) {
                        object.menuItems = [];
                        for (var j = 0; j < message.menuItems.length; ++j)
                            object.menuItems[j] = $root.waiternow.common.MenuProto.MenuItemProto.toObject(message.menuItems[j], options);
                    }
                    if (message.selectionType != null && message.hasOwnProperty("selectionType"))
                        object.selectionType = options.enums === String ? $root.waiternow.common.SelectionType[message.selectionType] === undefined ? message.selectionType : $root.waiternow.common.SelectionType[message.selectionType] : message.selectionType;
                    if (message.isRequired != null && message.hasOwnProperty("isRequired"))
                        object.isRequired = message.isRequired;
                    if (message.maxSelections != null && message.hasOwnProperty("maxSelections"))
                        object.maxSelections = message.maxSelections;
                    if (message.id != null && message.hasOwnProperty("id"))
                        object.id = message.id;
                    return object;
                };

                /**
                 * Converts this MenuItemSelectionProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.MenuProto.MenuItemSelectionProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                MenuItemSelectionProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for MenuItemSelectionProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.MenuProto.MenuItemSelectionProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                MenuItemSelectionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.MenuProto.MenuItemSelectionProto";
                };

                return MenuItemSelectionProto;
            })();

            MenuProto.ComboProto = (function() {

                /**
                 * Properties of a ComboProto.
                 * @memberof waiternow.common.MenuProto
                 * @interface IComboProto
                 * @property {string|null} [id] ComboProto id
                 * @property {waiternow.common.ITextProto|null} [name] ComboProto name
                 * @property {waiternow.common.ITextProto|null} [description] ComboProto description
                 * @property {waiternow.common.IImageProto|null} [image] ComboProto image
                 * @property {Array.<waiternow.common.MenuProto.IMenuItemProto>|null} [menuItems] ComboProto menuItems
                 * @property {Array.<waiternow.common.MenuProto.IMenuItemSelectionProto>|null} [menuItemSelections] ComboProto menuItemSelections
                 * @property {Array.<waiternow.common.MenuProto.IItemSelectionProto>|null} [itemSelections] ComboProto itemSelections
                 * @property {boolean|null} [isUnavailable] ComboProto isUnavailable
                 * @property {waiternow.common.IMoneyProto|null} [price] ComboProto price
                 * @property {waiternow.common.IAvailabilityScheduleProto|null} [availabilitySchedule] ComboProto availabilitySchedule
                 */

                /**
                 * Constructs a new ComboProto.
                 * @memberof waiternow.common.MenuProto
                 * @classdesc Represents a ComboProto.
                 * @implements IComboProto
                 * @constructor
                 * @param {waiternow.common.MenuProto.IComboProto=} [properties] Properties to set
                 */
                function ComboProto(properties) {
                    this.menuItems = [];
                    this.menuItemSelections = [];
                    this.itemSelections = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ComboProto id.
                 * @member {string} id
                 * @memberof waiternow.common.MenuProto.ComboProto
                 * @instance
                 */
                ComboProto.prototype.id = "";

                /**
                 * ComboProto name.
                 * @member {waiternow.common.ITextProto|null|undefined} name
                 * @memberof waiternow.common.MenuProto.ComboProto
                 * @instance
                 */
                ComboProto.prototype.name = null;

                /**
                 * ComboProto description.
                 * @member {waiternow.common.ITextProto|null|undefined} description
                 * @memberof waiternow.common.MenuProto.ComboProto
                 * @instance
                 */
                ComboProto.prototype.description = null;

                /**
                 * ComboProto image.
                 * @member {waiternow.common.IImageProto|null|undefined} image
                 * @memberof waiternow.common.MenuProto.ComboProto
                 * @instance
                 */
                ComboProto.prototype.image = null;

                /**
                 * ComboProto menuItems.
                 * @member {Array.<waiternow.common.MenuProto.IMenuItemProto>} menuItems
                 * @memberof waiternow.common.MenuProto.ComboProto
                 * @instance
                 */
                ComboProto.prototype.menuItems = $util.emptyArray;

                /**
                 * ComboProto menuItemSelections.
                 * @member {Array.<waiternow.common.MenuProto.IMenuItemSelectionProto>} menuItemSelections
                 * @memberof waiternow.common.MenuProto.ComboProto
                 * @instance
                 */
                ComboProto.prototype.menuItemSelections = $util.emptyArray;

                /**
                 * ComboProto itemSelections.
                 * @member {Array.<waiternow.common.MenuProto.IItemSelectionProto>} itemSelections
                 * @memberof waiternow.common.MenuProto.ComboProto
                 * @instance
                 */
                ComboProto.prototype.itemSelections = $util.emptyArray;

                /**
                 * ComboProto isUnavailable.
                 * @member {boolean} isUnavailable
                 * @memberof waiternow.common.MenuProto.ComboProto
                 * @instance
                 */
                ComboProto.prototype.isUnavailable = false;

                /**
                 * ComboProto price.
                 * @member {waiternow.common.IMoneyProto|null|undefined} price
                 * @memberof waiternow.common.MenuProto.ComboProto
                 * @instance
                 */
                ComboProto.prototype.price = null;

                /**
                 * ComboProto availabilitySchedule.
                 * @member {waiternow.common.IAvailabilityScheduleProto|null|undefined} availabilitySchedule
                 * @memberof waiternow.common.MenuProto.ComboProto
                 * @instance
                 */
                ComboProto.prototype.availabilitySchedule = null;

                /**
                 * Creates a new ComboProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.MenuProto.ComboProto
                 * @static
                 * @param {waiternow.common.MenuProto.IComboProto=} [properties] Properties to set
                 * @returns {waiternow.common.MenuProto.ComboProto} ComboProto instance
                 */
                ComboProto.create = function create(properties) {
                    return new ComboProto(properties);
                };

                /**
                 * Encodes the specified ComboProto message. Does not implicitly {@link waiternow.common.MenuProto.ComboProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.MenuProto.ComboProto
                 * @static
                 * @param {waiternow.common.MenuProto.IComboProto} message ComboProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ComboProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        $root.waiternow.common.TextProto.encode(message.name, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.menuItems != null && message.menuItems.length)
                        for (var i = 0; i < message.menuItems.length; ++i)
                            $root.waiternow.common.MenuProto.MenuItemProto.encode(message.menuItems[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.menuItemSelections != null && message.menuItemSelections.length)
                        for (var i = 0; i < message.menuItemSelections.length; ++i)
                            $root.waiternow.common.MenuProto.MenuItemSelectionProto.encode(message.menuItemSelections[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.itemSelections != null && message.itemSelections.length)
                        for (var i = 0; i < message.itemSelections.length; ++i)
                            $root.waiternow.common.MenuProto.ItemSelectionProto.encode(message.itemSelections[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.isUnavailable != null && Object.hasOwnProperty.call(message, "isUnavailable"))
                        writer.uint32(/* id 5, wireType 0 =*/40).bool(message.isUnavailable);
                    if (message.price != null && Object.hasOwnProperty.call(message, "price"))
                        $root.waiternow.common.MoneyProto.encode(message.price, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                        $root.waiternow.common.TextProto.encode(message.description, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    if (message.availabilitySchedule != null && Object.hasOwnProperty.call(message, "availabilitySchedule"))
                        $root.waiternow.common.AvailabilityScheduleProto.encode(message.availabilitySchedule, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                        writer.uint32(/* id 9, wireType 2 =*/74).string(message.id);
                    if (message.image != null && Object.hasOwnProperty.call(message, "image"))
                        $root.waiternow.common.ImageProto.encode(message.image, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified ComboProto message, length delimited. Does not implicitly {@link waiternow.common.MenuProto.ComboProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.MenuProto.ComboProto
                 * @static
                 * @param {waiternow.common.MenuProto.IComboProto} message ComboProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ComboProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ComboProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.MenuProto.ComboProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.MenuProto.ComboProto} ComboProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ComboProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.MenuProto.ComboProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 9: {
                                message.id = reader.string();
                                break;
                            }
                        case 1: {
                                message.name = $root.waiternow.common.TextProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 7: {
                                message.description = $root.waiternow.common.TextProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 10: {
                                message.image = $root.waiternow.common.ImageProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                if (!(message.menuItems && message.menuItems.length))
                                    message.menuItems = [];
                                message.menuItems.push($root.waiternow.common.MenuProto.MenuItemProto.decode(reader, reader.uint32()));
                                break;
                            }
                        case 3: {
                                if (!(message.menuItemSelections && message.menuItemSelections.length))
                                    message.menuItemSelections = [];
                                message.menuItemSelections.push($root.waiternow.common.MenuProto.MenuItemSelectionProto.decode(reader, reader.uint32()));
                                break;
                            }
                        case 4: {
                                if (!(message.itemSelections && message.itemSelections.length))
                                    message.itemSelections = [];
                                message.itemSelections.push($root.waiternow.common.MenuProto.ItemSelectionProto.decode(reader, reader.uint32()));
                                break;
                            }
                        case 5: {
                                message.isUnavailable = reader.bool();
                                break;
                            }
                        case 6: {
                                message.price = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 8: {
                                message.availabilitySchedule = $root.waiternow.common.AvailabilityScheduleProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ComboProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.MenuProto.ComboProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.MenuProto.ComboProto} ComboProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ComboProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ComboProto message.
                 * @function verify
                 * @memberof waiternow.common.MenuProto.ComboProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ComboProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (!$util.isString(message.id))
                            return "id: string expected";
                    if (message.name != null && message.hasOwnProperty("name")) {
                        var error = $root.waiternow.common.TextProto.verify(message.name);
                        if (error)
                            return "name." + error;
                    }
                    if (message.description != null && message.hasOwnProperty("description")) {
                        var error = $root.waiternow.common.TextProto.verify(message.description);
                        if (error)
                            return "description." + error;
                    }
                    if (message.image != null && message.hasOwnProperty("image")) {
                        var error = $root.waiternow.common.ImageProto.verify(message.image);
                        if (error)
                            return "image." + error;
                    }
                    if (message.menuItems != null && message.hasOwnProperty("menuItems")) {
                        if (!Array.isArray(message.menuItems))
                            return "menuItems: array expected";
                        for (var i = 0; i < message.menuItems.length; ++i) {
                            var error = $root.waiternow.common.MenuProto.MenuItemProto.verify(message.menuItems[i]);
                            if (error)
                                return "menuItems." + error;
                        }
                    }
                    if (message.menuItemSelections != null && message.hasOwnProperty("menuItemSelections")) {
                        if (!Array.isArray(message.menuItemSelections))
                            return "menuItemSelections: array expected";
                        for (var i = 0; i < message.menuItemSelections.length; ++i) {
                            var error = $root.waiternow.common.MenuProto.MenuItemSelectionProto.verify(message.menuItemSelections[i]);
                            if (error)
                                return "menuItemSelections." + error;
                        }
                    }
                    if (message.itemSelections != null && message.hasOwnProperty("itemSelections")) {
                        if (!Array.isArray(message.itemSelections))
                            return "itemSelections: array expected";
                        for (var i = 0; i < message.itemSelections.length; ++i) {
                            var error = $root.waiternow.common.MenuProto.ItemSelectionProto.verify(message.itemSelections[i]);
                            if (error)
                                return "itemSelections." + error;
                        }
                    }
                    if (message.isUnavailable != null && message.hasOwnProperty("isUnavailable"))
                        if (typeof message.isUnavailable !== "boolean")
                            return "isUnavailable: boolean expected";
                    if (message.price != null && message.hasOwnProperty("price")) {
                        var error = $root.waiternow.common.MoneyProto.verify(message.price);
                        if (error)
                            return "price." + error;
                    }
                    if (message.availabilitySchedule != null && message.hasOwnProperty("availabilitySchedule")) {
                        var error = $root.waiternow.common.AvailabilityScheduleProto.verify(message.availabilitySchedule);
                        if (error)
                            return "availabilitySchedule." + error;
                    }
                    return null;
                };

                /**
                 * Creates a ComboProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.MenuProto.ComboProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.MenuProto.ComboProto} ComboProto
                 */
                ComboProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.MenuProto.ComboProto)
                        return object;
                    var message = new $root.waiternow.common.MenuProto.ComboProto();
                    if (object.id != null)
                        message.id = String(object.id);
                    if (object.name != null) {
                        if (typeof object.name !== "object")
                            throw TypeError(".waiternow.common.MenuProto.ComboProto.name: object expected");
                        message.name = $root.waiternow.common.TextProto.fromObject(object.name);
                    }
                    if (object.description != null) {
                        if (typeof object.description !== "object")
                            throw TypeError(".waiternow.common.MenuProto.ComboProto.description: object expected");
                        message.description = $root.waiternow.common.TextProto.fromObject(object.description);
                    }
                    if (object.image != null) {
                        if (typeof object.image !== "object")
                            throw TypeError(".waiternow.common.MenuProto.ComboProto.image: object expected");
                        message.image = $root.waiternow.common.ImageProto.fromObject(object.image);
                    }
                    if (object.menuItems) {
                        if (!Array.isArray(object.menuItems))
                            throw TypeError(".waiternow.common.MenuProto.ComboProto.menuItems: array expected");
                        message.menuItems = [];
                        for (var i = 0; i < object.menuItems.length; ++i) {
                            if (typeof object.menuItems[i] !== "object")
                                throw TypeError(".waiternow.common.MenuProto.ComboProto.menuItems: object expected");
                            message.menuItems[i] = $root.waiternow.common.MenuProto.MenuItemProto.fromObject(object.menuItems[i]);
                        }
                    }
                    if (object.menuItemSelections) {
                        if (!Array.isArray(object.menuItemSelections))
                            throw TypeError(".waiternow.common.MenuProto.ComboProto.menuItemSelections: array expected");
                        message.menuItemSelections = [];
                        for (var i = 0; i < object.menuItemSelections.length; ++i) {
                            if (typeof object.menuItemSelections[i] !== "object")
                                throw TypeError(".waiternow.common.MenuProto.ComboProto.menuItemSelections: object expected");
                            message.menuItemSelections[i] = $root.waiternow.common.MenuProto.MenuItemSelectionProto.fromObject(object.menuItemSelections[i]);
                        }
                    }
                    if (object.itemSelections) {
                        if (!Array.isArray(object.itemSelections))
                            throw TypeError(".waiternow.common.MenuProto.ComboProto.itemSelections: array expected");
                        message.itemSelections = [];
                        for (var i = 0; i < object.itemSelections.length; ++i) {
                            if (typeof object.itemSelections[i] !== "object")
                                throw TypeError(".waiternow.common.MenuProto.ComboProto.itemSelections: object expected");
                            message.itemSelections[i] = $root.waiternow.common.MenuProto.ItemSelectionProto.fromObject(object.itemSelections[i]);
                        }
                    }
                    if (object.isUnavailable != null)
                        message.isUnavailable = Boolean(object.isUnavailable);
                    if (object.price != null) {
                        if (typeof object.price !== "object")
                            throw TypeError(".waiternow.common.MenuProto.ComboProto.price: object expected");
                        message.price = $root.waiternow.common.MoneyProto.fromObject(object.price);
                    }
                    if (object.availabilitySchedule != null) {
                        if (typeof object.availabilitySchedule !== "object")
                            throw TypeError(".waiternow.common.MenuProto.ComboProto.availabilitySchedule: object expected");
                        message.availabilitySchedule = $root.waiternow.common.AvailabilityScheduleProto.fromObject(object.availabilitySchedule);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a ComboProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.MenuProto.ComboProto
                 * @static
                 * @param {waiternow.common.MenuProto.ComboProto} message ComboProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ComboProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.menuItems = [];
                        object.menuItemSelections = [];
                        object.itemSelections = [];
                    }
                    if (options.defaults) {
                        object.name = null;
                        object.isUnavailable = false;
                        object.price = null;
                        object.description = null;
                        object.availabilitySchedule = null;
                        object.id = "";
                        object.image = null;
                    }
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = $root.waiternow.common.TextProto.toObject(message.name, options);
                    if (message.menuItems && message.menuItems.length) {
                        object.menuItems = [];
                        for (var j = 0; j < message.menuItems.length; ++j)
                            object.menuItems[j] = $root.waiternow.common.MenuProto.MenuItemProto.toObject(message.menuItems[j], options);
                    }
                    if (message.menuItemSelections && message.menuItemSelections.length) {
                        object.menuItemSelections = [];
                        for (var j = 0; j < message.menuItemSelections.length; ++j)
                            object.menuItemSelections[j] = $root.waiternow.common.MenuProto.MenuItemSelectionProto.toObject(message.menuItemSelections[j], options);
                    }
                    if (message.itemSelections && message.itemSelections.length) {
                        object.itemSelections = [];
                        for (var j = 0; j < message.itemSelections.length; ++j)
                            object.itemSelections[j] = $root.waiternow.common.MenuProto.ItemSelectionProto.toObject(message.itemSelections[j], options);
                    }
                    if (message.isUnavailable != null && message.hasOwnProperty("isUnavailable"))
                        object.isUnavailable = message.isUnavailable;
                    if (message.price != null && message.hasOwnProperty("price"))
                        object.price = $root.waiternow.common.MoneyProto.toObject(message.price, options);
                    if (message.description != null && message.hasOwnProperty("description"))
                        object.description = $root.waiternow.common.TextProto.toObject(message.description, options);
                    if (message.availabilitySchedule != null && message.hasOwnProperty("availabilitySchedule"))
                        object.availabilitySchedule = $root.waiternow.common.AvailabilityScheduleProto.toObject(message.availabilitySchedule, options);
                    if (message.id != null && message.hasOwnProperty("id"))
                        object.id = message.id;
                    if (message.image != null && message.hasOwnProperty("image"))
                        object.image = $root.waiternow.common.ImageProto.toObject(message.image, options);
                    return object;
                };

                /**
                 * Converts this ComboProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.MenuProto.ComboProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ComboProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ComboProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.MenuProto.ComboProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ComboProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.MenuProto.ComboProto";
                };

                return ComboProto;
            })();

            MenuProto.MenuEntryProto = (function() {

                /**
                 * Properties of a MenuEntryProto.
                 * @memberof waiternow.common.MenuProto
                 * @interface IMenuEntryProto
                 * @property {waiternow.common.MenuProto.IMenuItemProto|null} [menuItem] MenuEntryProto menuItem
                 * @property {waiternow.common.MenuProto.IComboProto|null} [combo] MenuEntryProto combo
                 */

                /**
                 * Constructs a new MenuEntryProto.
                 * @memberof waiternow.common.MenuProto
                 * @classdesc Represents a MenuEntryProto.
                 * @implements IMenuEntryProto
                 * @constructor
                 * @param {waiternow.common.MenuProto.IMenuEntryProto=} [properties] Properties to set
                 */
                function MenuEntryProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * MenuEntryProto menuItem.
                 * @member {waiternow.common.MenuProto.IMenuItemProto|null|undefined} menuItem
                 * @memberof waiternow.common.MenuProto.MenuEntryProto
                 * @instance
                 */
                MenuEntryProto.prototype.menuItem = null;

                /**
                 * MenuEntryProto combo.
                 * @member {waiternow.common.MenuProto.IComboProto|null|undefined} combo
                 * @memberof waiternow.common.MenuProto.MenuEntryProto
                 * @instance
                 */
                MenuEntryProto.prototype.combo = null;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * MenuEntryProto entryType.
                 * @member {"menuItem"|"combo"|undefined} entryType
                 * @memberof waiternow.common.MenuProto.MenuEntryProto
                 * @instance
                 */
                Object.defineProperty(MenuEntryProto.prototype, "entryType", {
                    get: $util.oneOfGetter($oneOfFields = ["menuItem", "combo"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new MenuEntryProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.MenuProto.MenuEntryProto
                 * @static
                 * @param {waiternow.common.MenuProto.IMenuEntryProto=} [properties] Properties to set
                 * @returns {waiternow.common.MenuProto.MenuEntryProto} MenuEntryProto instance
                 */
                MenuEntryProto.create = function create(properties) {
                    return new MenuEntryProto(properties);
                };

                /**
                 * Encodes the specified MenuEntryProto message. Does not implicitly {@link waiternow.common.MenuProto.MenuEntryProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.MenuProto.MenuEntryProto
                 * @static
                 * @param {waiternow.common.MenuProto.IMenuEntryProto} message MenuEntryProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MenuEntryProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.menuItem != null && Object.hasOwnProperty.call(message, "menuItem"))
                        $root.waiternow.common.MenuProto.MenuItemProto.encode(message.menuItem, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.combo != null && Object.hasOwnProperty.call(message, "combo"))
                        $root.waiternow.common.MenuProto.ComboProto.encode(message.combo, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified MenuEntryProto message, length delimited. Does not implicitly {@link waiternow.common.MenuProto.MenuEntryProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.MenuProto.MenuEntryProto
                 * @static
                 * @param {waiternow.common.MenuProto.IMenuEntryProto} message MenuEntryProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MenuEntryProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a MenuEntryProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.MenuProto.MenuEntryProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.MenuProto.MenuEntryProto} MenuEntryProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MenuEntryProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.MenuProto.MenuEntryProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.menuItem = $root.waiternow.common.MenuProto.MenuItemProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.combo = $root.waiternow.common.MenuProto.ComboProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a MenuEntryProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.MenuProto.MenuEntryProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.MenuProto.MenuEntryProto} MenuEntryProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MenuEntryProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a MenuEntryProto message.
                 * @function verify
                 * @memberof waiternow.common.MenuProto.MenuEntryProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                MenuEntryProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.menuItem != null && message.hasOwnProperty("menuItem")) {
                        properties.entryType = 1;
                        {
                            var error = $root.waiternow.common.MenuProto.MenuItemProto.verify(message.menuItem);
                            if (error)
                                return "menuItem." + error;
                        }
                    }
                    if (message.combo != null && message.hasOwnProperty("combo")) {
                        if (properties.entryType === 1)
                            return "entryType: multiple values";
                        properties.entryType = 1;
                        {
                            var error = $root.waiternow.common.MenuProto.ComboProto.verify(message.combo);
                            if (error)
                                return "combo." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a MenuEntryProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.MenuProto.MenuEntryProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.MenuProto.MenuEntryProto} MenuEntryProto
                 */
                MenuEntryProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.MenuProto.MenuEntryProto)
                        return object;
                    var message = new $root.waiternow.common.MenuProto.MenuEntryProto();
                    if (object.menuItem != null) {
                        if (typeof object.menuItem !== "object")
                            throw TypeError(".waiternow.common.MenuProto.MenuEntryProto.menuItem: object expected");
                        message.menuItem = $root.waiternow.common.MenuProto.MenuItemProto.fromObject(object.menuItem);
                    }
                    if (object.combo != null) {
                        if (typeof object.combo !== "object")
                            throw TypeError(".waiternow.common.MenuProto.MenuEntryProto.combo: object expected");
                        message.combo = $root.waiternow.common.MenuProto.ComboProto.fromObject(object.combo);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a MenuEntryProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.MenuProto.MenuEntryProto
                 * @static
                 * @param {waiternow.common.MenuProto.MenuEntryProto} message MenuEntryProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                MenuEntryProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (message.menuItem != null && message.hasOwnProperty("menuItem")) {
                        object.menuItem = $root.waiternow.common.MenuProto.MenuItemProto.toObject(message.menuItem, options);
                        if (options.oneofs)
                            object.entryType = "menuItem";
                    }
                    if (message.combo != null && message.hasOwnProperty("combo")) {
                        object.combo = $root.waiternow.common.MenuProto.ComboProto.toObject(message.combo, options);
                        if (options.oneofs)
                            object.entryType = "combo";
                    }
                    return object;
                };

                /**
                 * Converts this MenuEntryProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.MenuProto.MenuEntryProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                MenuEntryProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for MenuEntryProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.MenuProto.MenuEntryProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                MenuEntryProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.MenuProto.MenuEntryProto";
                };

                return MenuEntryProto;
            })();

            MenuProto.CategoryLevel3Proto = (function() {

                /**
                 * Properties of a CategoryLevel3Proto.
                 * @memberof waiternow.common.MenuProto
                 * @interface ICategoryLevel3Proto
                 * @property {string|null} [id] CategoryLevel3Proto id
                 * @property {waiternow.common.ITextProto|null} [name] CategoryLevel3Proto name
                 * @property {waiternow.common.IImageProto|null} [image] CategoryLevel3Proto image
                 * @property {Array.<waiternow.common.MenuProto.IMenuEntryProto>|null} [menuEntries] CategoryLevel3Proto menuEntries
                 */

                /**
                 * Constructs a new CategoryLevel3Proto.
                 * @memberof waiternow.common.MenuProto
                 * @classdesc Represents a CategoryLevel3Proto.
                 * @implements ICategoryLevel3Proto
                 * @constructor
                 * @param {waiternow.common.MenuProto.ICategoryLevel3Proto=} [properties] Properties to set
                 */
                function CategoryLevel3Proto(properties) {
                    this.menuEntries = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * CategoryLevel3Proto id.
                 * @member {string} id
                 * @memberof waiternow.common.MenuProto.CategoryLevel3Proto
                 * @instance
                 */
                CategoryLevel3Proto.prototype.id = "";

                /**
                 * CategoryLevel3Proto name.
                 * @member {waiternow.common.ITextProto|null|undefined} name
                 * @memberof waiternow.common.MenuProto.CategoryLevel3Proto
                 * @instance
                 */
                CategoryLevel3Proto.prototype.name = null;

                /**
                 * CategoryLevel3Proto image.
                 * @member {waiternow.common.IImageProto|null|undefined} image
                 * @memberof waiternow.common.MenuProto.CategoryLevel3Proto
                 * @instance
                 */
                CategoryLevel3Proto.prototype.image = null;

                /**
                 * CategoryLevel3Proto menuEntries.
                 * @member {Array.<waiternow.common.MenuProto.IMenuEntryProto>} menuEntries
                 * @memberof waiternow.common.MenuProto.CategoryLevel3Proto
                 * @instance
                 */
                CategoryLevel3Proto.prototype.menuEntries = $util.emptyArray;

                /**
                 * Creates a new CategoryLevel3Proto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.MenuProto.CategoryLevel3Proto
                 * @static
                 * @param {waiternow.common.MenuProto.ICategoryLevel3Proto=} [properties] Properties to set
                 * @returns {waiternow.common.MenuProto.CategoryLevel3Proto} CategoryLevel3Proto instance
                 */
                CategoryLevel3Proto.create = function create(properties) {
                    return new CategoryLevel3Proto(properties);
                };

                /**
                 * Encodes the specified CategoryLevel3Proto message. Does not implicitly {@link waiternow.common.MenuProto.CategoryLevel3Proto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.MenuProto.CategoryLevel3Proto
                 * @static
                 * @param {waiternow.common.MenuProto.ICategoryLevel3Proto} message CategoryLevel3Proto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CategoryLevel3Proto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        $root.waiternow.common.TextProto.encode(message.name, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.image != null && Object.hasOwnProperty.call(message, "image"))
                        $root.waiternow.common.ImageProto.encode(message.image, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.menuEntries != null && message.menuEntries.length)
                        for (var i = 0; i < message.menuEntries.length; ++i)
                            $root.waiternow.common.MenuProto.MenuEntryProto.encode(message.menuEntries[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.id);
                    return writer;
                };

                /**
                 * Encodes the specified CategoryLevel3Proto message, length delimited. Does not implicitly {@link waiternow.common.MenuProto.CategoryLevel3Proto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.MenuProto.CategoryLevel3Proto
                 * @static
                 * @param {waiternow.common.MenuProto.ICategoryLevel3Proto} message CategoryLevel3Proto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CategoryLevel3Proto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a CategoryLevel3Proto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.MenuProto.CategoryLevel3Proto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.MenuProto.CategoryLevel3Proto} CategoryLevel3Proto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CategoryLevel3Proto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.MenuProto.CategoryLevel3Proto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 4: {
                                message.id = reader.string();
                                break;
                            }
                        case 1: {
                                message.name = $root.waiternow.common.TextProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.image = $root.waiternow.common.ImageProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                if (!(message.menuEntries && message.menuEntries.length))
                                    message.menuEntries = [];
                                message.menuEntries.push($root.waiternow.common.MenuProto.MenuEntryProto.decode(reader, reader.uint32()));
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a CategoryLevel3Proto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.MenuProto.CategoryLevel3Proto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.MenuProto.CategoryLevel3Proto} CategoryLevel3Proto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CategoryLevel3Proto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a CategoryLevel3Proto message.
                 * @function verify
                 * @memberof waiternow.common.MenuProto.CategoryLevel3Proto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                CategoryLevel3Proto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (!$util.isString(message.id))
                            return "id: string expected";
                    if (message.name != null && message.hasOwnProperty("name")) {
                        var error = $root.waiternow.common.TextProto.verify(message.name);
                        if (error)
                            return "name." + error;
                    }
                    if (message.image != null && message.hasOwnProperty("image")) {
                        var error = $root.waiternow.common.ImageProto.verify(message.image);
                        if (error)
                            return "image." + error;
                    }
                    if (message.menuEntries != null && message.hasOwnProperty("menuEntries")) {
                        if (!Array.isArray(message.menuEntries))
                            return "menuEntries: array expected";
                        for (var i = 0; i < message.menuEntries.length; ++i) {
                            var error = $root.waiternow.common.MenuProto.MenuEntryProto.verify(message.menuEntries[i]);
                            if (error)
                                return "menuEntries." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a CategoryLevel3Proto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.MenuProto.CategoryLevel3Proto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.MenuProto.CategoryLevel3Proto} CategoryLevel3Proto
                 */
                CategoryLevel3Proto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.MenuProto.CategoryLevel3Proto)
                        return object;
                    var message = new $root.waiternow.common.MenuProto.CategoryLevel3Proto();
                    if (object.id != null)
                        message.id = String(object.id);
                    if (object.name != null) {
                        if (typeof object.name !== "object")
                            throw TypeError(".waiternow.common.MenuProto.CategoryLevel3Proto.name: object expected");
                        message.name = $root.waiternow.common.TextProto.fromObject(object.name);
                    }
                    if (object.image != null) {
                        if (typeof object.image !== "object")
                            throw TypeError(".waiternow.common.MenuProto.CategoryLevel3Proto.image: object expected");
                        message.image = $root.waiternow.common.ImageProto.fromObject(object.image);
                    }
                    if (object.menuEntries) {
                        if (!Array.isArray(object.menuEntries))
                            throw TypeError(".waiternow.common.MenuProto.CategoryLevel3Proto.menuEntries: array expected");
                        message.menuEntries = [];
                        for (var i = 0; i < object.menuEntries.length; ++i) {
                            if (typeof object.menuEntries[i] !== "object")
                                throw TypeError(".waiternow.common.MenuProto.CategoryLevel3Proto.menuEntries: object expected");
                            message.menuEntries[i] = $root.waiternow.common.MenuProto.MenuEntryProto.fromObject(object.menuEntries[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a CategoryLevel3Proto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.MenuProto.CategoryLevel3Proto
                 * @static
                 * @param {waiternow.common.MenuProto.CategoryLevel3Proto} message CategoryLevel3Proto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                CategoryLevel3Proto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.menuEntries = [];
                    if (options.defaults) {
                        object.name = null;
                        object.image = null;
                        object.id = "";
                    }
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = $root.waiternow.common.TextProto.toObject(message.name, options);
                    if (message.image != null && message.hasOwnProperty("image"))
                        object.image = $root.waiternow.common.ImageProto.toObject(message.image, options);
                    if (message.menuEntries && message.menuEntries.length) {
                        object.menuEntries = [];
                        for (var j = 0; j < message.menuEntries.length; ++j)
                            object.menuEntries[j] = $root.waiternow.common.MenuProto.MenuEntryProto.toObject(message.menuEntries[j], options);
                    }
                    if (message.id != null && message.hasOwnProperty("id"))
                        object.id = message.id;
                    return object;
                };

                /**
                 * Converts this CategoryLevel3Proto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.MenuProto.CategoryLevel3Proto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                CategoryLevel3Proto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for CategoryLevel3Proto
                 * @function getTypeUrl
                 * @memberof waiternow.common.MenuProto.CategoryLevel3Proto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                CategoryLevel3Proto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.MenuProto.CategoryLevel3Proto";
                };

                return CategoryLevel3Proto;
            })();

            MenuProto.CategoryLevel2Proto = (function() {

                /**
                 * Properties of a CategoryLevel2Proto.
                 * @memberof waiternow.common.MenuProto
                 * @interface ICategoryLevel2Proto
                 * @property {string|null} [id] CategoryLevel2Proto id
                 * @property {waiternow.common.ITextProto|null} [name] CategoryLevel2Proto name
                 * @property {waiternow.common.IImageProto|null} [image] CategoryLevel2Proto image
                 * @property {Array.<waiternow.common.MenuProto.IMenuEntryProto>|null} [menuEntries] CategoryLevel2Proto menuEntries
                 * @property {Array.<waiternow.common.MenuProto.ICategoryLevel3Proto>|null} [categories] CategoryLevel2Proto categories
                 */

                /**
                 * Constructs a new CategoryLevel2Proto.
                 * @memberof waiternow.common.MenuProto
                 * @classdesc Represents a CategoryLevel2Proto.
                 * @implements ICategoryLevel2Proto
                 * @constructor
                 * @param {waiternow.common.MenuProto.ICategoryLevel2Proto=} [properties] Properties to set
                 */
                function CategoryLevel2Proto(properties) {
                    this.menuEntries = [];
                    this.categories = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * CategoryLevel2Proto id.
                 * @member {string} id
                 * @memberof waiternow.common.MenuProto.CategoryLevel2Proto
                 * @instance
                 */
                CategoryLevel2Proto.prototype.id = "";

                /**
                 * CategoryLevel2Proto name.
                 * @member {waiternow.common.ITextProto|null|undefined} name
                 * @memberof waiternow.common.MenuProto.CategoryLevel2Proto
                 * @instance
                 */
                CategoryLevel2Proto.prototype.name = null;

                /**
                 * CategoryLevel2Proto image.
                 * @member {waiternow.common.IImageProto|null|undefined} image
                 * @memberof waiternow.common.MenuProto.CategoryLevel2Proto
                 * @instance
                 */
                CategoryLevel2Proto.prototype.image = null;

                /**
                 * CategoryLevel2Proto menuEntries.
                 * @member {Array.<waiternow.common.MenuProto.IMenuEntryProto>} menuEntries
                 * @memberof waiternow.common.MenuProto.CategoryLevel2Proto
                 * @instance
                 */
                CategoryLevel2Proto.prototype.menuEntries = $util.emptyArray;

                /**
                 * CategoryLevel2Proto categories.
                 * @member {Array.<waiternow.common.MenuProto.ICategoryLevel3Proto>} categories
                 * @memberof waiternow.common.MenuProto.CategoryLevel2Proto
                 * @instance
                 */
                CategoryLevel2Proto.prototype.categories = $util.emptyArray;

                /**
                 * Creates a new CategoryLevel2Proto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.MenuProto.CategoryLevel2Proto
                 * @static
                 * @param {waiternow.common.MenuProto.ICategoryLevel2Proto=} [properties] Properties to set
                 * @returns {waiternow.common.MenuProto.CategoryLevel2Proto} CategoryLevel2Proto instance
                 */
                CategoryLevel2Proto.create = function create(properties) {
                    return new CategoryLevel2Proto(properties);
                };

                /**
                 * Encodes the specified CategoryLevel2Proto message. Does not implicitly {@link waiternow.common.MenuProto.CategoryLevel2Proto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.MenuProto.CategoryLevel2Proto
                 * @static
                 * @param {waiternow.common.MenuProto.ICategoryLevel2Proto} message CategoryLevel2Proto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CategoryLevel2Proto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        $root.waiternow.common.TextProto.encode(message.name, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.image != null && Object.hasOwnProperty.call(message, "image"))
                        $root.waiternow.common.ImageProto.encode(message.image, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.menuEntries != null && message.menuEntries.length)
                        for (var i = 0; i < message.menuEntries.length; ++i)
                            $root.waiternow.common.MenuProto.MenuEntryProto.encode(message.menuEntries[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.categories != null && message.categories.length)
                        for (var i = 0; i < message.categories.length; ++i)
                            $root.waiternow.common.MenuProto.CategoryLevel3Proto.encode(message.categories[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.id);
                    return writer;
                };

                /**
                 * Encodes the specified CategoryLevel2Proto message, length delimited. Does not implicitly {@link waiternow.common.MenuProto.CategoryLevel2Proto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.MenuProto.CategoryLevel2Proto
                 * @static
                 * @param {waiternow.common.MenuProto.ICategoryLevel2Proto} message CategoryLevel2Proto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CategoryLevel2Proto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a CategoryLevel2Proto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.MenuProto.CategoryLevel2Proto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.MenuProto.CategoryLevel2Proto} CategoryLevel2Proto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CategoryLevel2Proto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.MenuProto.CategoryLevel2Proto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 5: {
                                message.id = reader.string();
                                break;
                            }
                        case 1: {
                                message.name = $root.waiternow.common.TextProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.image = $root.waiternow.common.ImageProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                if (!(message.menuEntries && message.menuEntries.length))
                                    message.menuEntries = [];
                                message.menuEntries.push($root.waiternow.common.MenuProto.MenuEntryProto.decode(reader, reader.uint32()));
                                break;
                            }
                        case 4: {
                                if (!(message.categories && message.categories.length))
                                    message.categories = [];
                                message.categories.push($root.waiternow.common.MenuProto.CategoryLevel3Proto.decode(reader, reader.uint32()));
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a CategoryLevel2Proto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.MenuProto.CategoryLevel2Proto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.MenuProto.CategoryLevel2Proto} CategoryLevel2Proto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CategoryLevel2Proto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a CategoryLevel2Proto message.
                 * @function verify
                 * @memberof waiternow.common.MenuProto.CategoryLevel2Proto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                CategoryLevel2Proto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (!$util.isString(message.id))
                            return "id: string expected";
                    if (message.name != null && message.hasOwnProperty("name")) {
                        var error = $root.waiternow.common.TextProto.verify(message.name);
                        if (error)
                            return "name." + error;
                    }
                    if (message.image != null && message.hasOwnProperty("image")) {
                        var error = $root.waiternow.common.ImageProto.verify(message.image);
                        if (error)
                            return "image." + error;
                    }
                    if (message.menuEntries != null && message.hasOwnProperty("menuEntries")) {
                        if (!Array.isArray(message.menuEntries))
                            return "menuEntries: array expected";
                        for (var i = 0; i < message.menuEntries.length; ++i) {
                            var error = $root.waiternow.common.MenuProto.MenuEntryProto.verify(message.menuEntries[i]);
                            if (error)
                                return "menuEntries." + error;
                        }
                    }
                    if (message.categories != null && message.hasOwnProperty("categories")) {
                        if (!Array.isArray(message.categories))
                            return "categories: array expected";
                        for (var i = 0; i < message.categories.length; ++i) {
                            var error = $root.waiternow.common.MenuProto.CategoryLevel3Proto.verify(message.categories[i]);
                            if (error)
                                return "categories." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a CategoryLevel2Proto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.MenuProto.CategoryLevel2Proto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.MenuProto.CategoryLevel2Proto} CategoryLevel2Proto
                 */
                CategoryLevel2Proto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.MenuProto.CategoryLevel2Proto)
                        return object;
                    var message = new $root.waiternow.common.MenuProto.CategoryLevel2Proto();
                    if (object.id != null)
                        message.id = String(object.id);
                    if (object.name != null) {
                        if (typeof object.name !== "object")
                            throw TypeError(".waiternow.common.MenuProto.CategoryLevel2Proto.name: object expected");
                        message.name = $root.waiternow.common.TextProto.fromObject(object.name);
                    }
                    if (object.image != null) {
                        if (typeof object.image !== "object")
                            throw TypeError(".waiternow.common.MenuProto.CategoryLevel2Proto.image: object expected");
                        message.image = $root.waiternow.common.ImageProto.fromObject(object.image);
                    }
                    if (object.menuEntries) {
                        if (!Array.isArray(object.menuEntries))
                            throw TypeError(".waiternow.common.MenuProto.CategoryLevel2Proto.menuEntries: array expected");
                        message.menuEntries = [];
                        for (var i = 0; i < object.menuEntries.length; ++i) {
                            if (typeof object.menuEntries[i] !== "object")
                                throw TypeError(".waiternow.common.MenuProto.CategoryLevel2Proto.menuEntries: object expected");
                            message.menuEntries[i] = $root.waiternow.common.MenuProto.MenuEntryProto.fromObject(object.menuEntries[i]);
                        }
                    }
                    if (object.categories) {
                        if (!Array.isArray(object.categories))
                            throw TypeError(".waiternow.common.MenuProto.CategoryLevel2Proto.categories: array expected");
                        message.categories = [];
                        for (var i = 0; i < object.categories.length; ++i) {
                            if (typeof object.categories[i] !== "object")
                                throw TypeError(".waiternow.common.MenuProto.CategoryLevel2Proto.categories: object expected");
                            message.categories[i] = $root.waiternow.common.MenuProto.CategoryLevel3Proto.fromObject(object.categories[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a CategoryLevel2Proto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.MenuProto.CategoryLevel2Proto
                 * @static
                 * @param {waiternow.common.MenuProto.CategoryLevel2Proto} message CategoryLevel2Proto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                CategoryLevel2Proto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.menuEntries = [];
                        object.categories = [];
                    }
                    if (options.defaults) {
                        object.name = null;
                        object.image = null;
                        object.id = "";
                    }
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = $root.waiternow.common.TextProto.toObject(message.name, options);
                    if (message.image != null && message.hasOwnProperty("image"))
                        object.image = $root.waiternow.common.ImageProto.toObject(message.image, options);
                    if (message.menuEntries && message.menuEntries.length) {
                        object.menuEntries = [];
                        for (var j = 0; j < message.menuEntries.length; ++j)
                            object.menuEntries[j] = $root.waiternow.common.MenuProto.MenuEntryProto.toObject(message.menuEntries[j], options);
                    }
                    if (message.categories && message.categories.length) {
                        object.categories = [];
                        for (var j = 0; j < message.categories.length; ++j)
                            object.categories[j] = $root.waiternow.common.MenuProto.CategoryLevel3Proto.toObject(message.categories[j], options);
                    }
                    if (message.id != null && message.hasOwnProperty("id"))
                        object.id = message.id;
                    return object;
                };

                /**
                 * Converts this CategoryLevel2Proto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.MenuProto.CategoryLevel2Proto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                CategoryLevel2Proto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for CategoryLevel2Proto
                 * @function getTypeUrl
                 * @memberof waiternow.common.MenuProto.CategoryLevel2Proto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                CategoryLevel2Proto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.MenuProto.CategoryLevel2Proto";
                };

                return CategoryLevel2Proto;
            })();

            MenuProto.CategoryLevel1Proto = (function() {

                /**
                 * Properties of a CategoryLevel1Proto.
                 * @memberof waiternow.common.MenuProto
                 * @interface ICategoryLevel1Proto
                 * @property {string|null} [id] CategoryLevel1Proto id
                 * @property {waiternow.common.ITextProto|null} [name] CategoryLevel1Proto name
                 * @property {waiternow.common.IImageProto|null} [image] CategoryLevel1Proto image
                 * @property {Array.<waiternow.common.MenuProto.IMenuEntryProto>|null} [menuEntries] CategoryLevel1Proto menuEntries
                 * @property {Array.<waiternow.common.MenuProto.ICategoryLevel2Proto>|null} [categories] CategoryLevel1Proto categories
                 */

                /**
                 * Constructs a new CategoryLevel1Proto.
                 * @memberof waiternow.common.MenuProto
                 * @classdesc Represents a CategoryLevel1Proto.
                 * @implements ICategoryLevel1Proto
                 * @constructor
                 * @param {waiternow.common.MenuProto.ICategoryLevel1Proto=} [properties] Properties to set
                 */
                function CategoryLevel1Proto(properties) {
                    this.menuEntries = [];
                    this.categories = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * CategoryLevel1Proto id.
                 * @member {string} id
                 * @memberof waiternow.common.MenuProto.CategoryLevel1Proto
                 * @instance
                 */
                CategoryLevel1Proto.prototype.id = "";

                /**
                 * CategoryLevel1Proto name.
                 * @member {waiternow.common.ITextProto|null|undefined} name
                 * @memberof waiternow.common.MenuProto.CategoryLevel1Proto
                 * @instance
                 */
                CategoryLevel1Proto.prototype.name = null;

                /**
                 * CategoryLevel1Proto image.
                 * @member {waiternow.common.IImageProto|null|undefined} image
                 * @memberof waiternow.common.MenuProto.CategoryLevel1Proto
                 * @instance
                 */
                CategoryLevel1Proto.prototype.image = null;

                /**
                 * CategoryLevel1Proto menuEntries.
                 * @member {Array.<waiternow.common.MenuProto.IMenuEntryProto>} menuEntries
                 * @memberof waiternow.common.MenuProto.CategoryLevel1Proto
                 * @instance
                 */
                CategoryLevel1Proto.prototype.menuEntries = $util.emptyArray;

                /**
                 * CategoryLevel1Proto categories.
                 * @member {Array.<waiternow.common.MenuProto.ICategoryLevel2Proto>} categories
                 * @memberof waiternow.common.MenuProto.CategoryLevel1Proto
                 * @instance
                 */
                CategoryLevel1Proto.prototype.categories = $util.emptyArray;

                /**
                 * Creates a new CategoryLevel1Proto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.MenuProto.CategoryLevel1Proto
                 * @static
                 * @param {waiternow.common.MenuProto.ICategoryLevel1Proto=} [properties] Properties to set
                 * @returns {waiternow.common.MenuProto.CategoryLevel1Proto} CategoryLevel1Proto instance
                 */
                CategoryLevel1Proto.create = function create(properties) {
                    return new CategoryLevel1Proto(properties);
                };

                /**
                 * Encodes the specified CategoryLevel1Proto message. Does not implicitly {@link waiternow.common.MenuProto.CategoryLevel1Proto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.MenuProto.CategoryLevel1Proto
                 * @static
                 * @param {waiternow.common.MenuProto.ICategoryLevel1Proto} message CategoryLevel1Proto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CategoryLevel1Proto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        $root.waiternow.common.TextProto.encode(message.name, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.image != null && Object.hasOwnProperty.call(message, "image"))
                        $root.waiternow.common.ImageProto.encode(message.image, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.menuEntries != null && message.menuEntries.length)
                        for (var i = 0; i < message.menuEntries.length; ++i)
                            $root.waiternow.common.MenuProto.MenuEntryProto.encode(message.menuEntries[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.categories != null && message.categories.length)
                        for (var i = 0; i < message.categories.length; ++i)
                            $root.waiternow.common.MenuProto.CategoryLevel2Proto.encode(message.categories[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.id);
                    return writer;
                };

                /**
                 * Encodes the specified CategoryLevel1Proto message, length delimited. Does not implicitly {@link waiternow.common.MenuProto.CategoryLevel1Proto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.MenuProto.CategoryLevel1Proto
                 * @static
                 * @param {waiternow.common.MenuProto.ICategoryLevel1Proto} message CategoryLevel1Proto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CategoryLevel1Proto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a CategoryLevel1Proto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.MenuProto.CategoryLevel1Proto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.MenuProto.CategoryLevel1Proto} CategoryLevel1Proto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CategoryLevel1Proto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.MenuProto.CategoryLevel1Proto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 5: {
                                message.id = reader.string();
                                break;
                            }
                        case 1: {
                                message.name = $root.waiternow.common.TextProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.image = $root.waiternow.common.ImageProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                if (!(message.menuEntries && message.menuEntries.length))
                                    message.menuEntries = [];
                                message.menuEntries.push($root.waiternow.common.MenuProto.MenuEntryProto.decode(reader, reader.uint32()));
                                break;
                            }
                        case 4: {
                                if (!(message.categories && message.categories.length))
                                    message.categories = [];
                                message.categories.push($root.waiternow.common.MenuProto.CategoryLevel2Proto.decode(reader, reader.uint32()));
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a CategoryLevel1Proto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.MenuProto.CategoryLevel1Proto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.MenuProto.CategoryLevel1Proto} CategoryLevel1Proto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CategoryLevel1Proto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a CategoryLevel1Proto message.
                 * @function verify
                 * @memberof waiternow.common.MenuProto.CategoryLevel1Proto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                CategoryLevel1Proto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (!$util.isString(message.id))
                            return "id: string expected";
                    if (message.name != null && message.hasOwnProperty("name")) {
                        var error = $root.waiternow.common.TextProto.verify(message.name);
                        if (error)
                            return "name." + error;
                    }
                    if (message.image != null && message.hasOwnProperty("image")) {
                        var error = $root.waiternow.common.ImageProto.verify(message.image);
                        if (error)
                            return "image." + error;
                    }
                    if (message.menuEntries != null && message.hasOwnProperty("menuEntries")) {
                        if (!Array.isArray(message.menuEntries))
                            return "menuEntries: array expected";
                        for (var i = 0; i < message.menuEntries.length; ++i) {
                            var error = $root.waiternow.common.MenuProto.MenuEntryProto.verify(message.menuEntries[i]);
                            if (error)
                                return "menuEntries." + error;
                        }
                    }
                    if (message.categories != null && message.hasOwnProperty("categories")) {
                        if (!Array.isArray(message.categories))
                            return "categories: array expected";
                        for (var i = 0; i < message.categories.length; ++i) {
                            var error = $root.waiternow.common.MenuProto.CategoryLevel2Proto.verify(message.categories[i]);
                            if (error)
                                return "categories." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a CategoryLevel1Proto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.MenuProto.CategoryLevel1Proto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.MenuProto.CategoryLevel1Proto} CategoryLevel1Proto
                 */
                CategoryLevel1Proto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.MenuProto.CategoryLevel1Proto)
                        return object;
                    var message = new $root.waiternow.common.MenuProto.CategoryLevel1Proto();
                    if (object.id != null)
                        message.id = String(object.id);
                    if (object.name != null) {
                        if (typeof object.name !== "object")
                            throw TypeError(".waiternow.common.MenuProto.CategoryLevel1Proto.name: object expected");
                        message.name = $root.waiternow.common.TextProto.fromObject(object.name);
                    }
                    if (object.image != null) {
                        if (typeof object.image !== "object")
                            throw TypeError(".waiternow.common.MenuProto.CategoryLevel1Proto.image: object expected");
                        message.image = $root.waiternow.common.ImageProto.fromObject(object.image);
                    }
                    if (object.menuEntries) {
                        if (!Array.isArray(object.menuEntries))
                            throw TypeError(".waiternow.common.MenuProto.CategoryLevel1Proto.menuEntries: array expected");
                        message.menuEntries = [];
                        for (var i = 0; i < object.menuEntries.length; ++i) {
                            if (typeof object.menuEntries[i] !== "object")
                                throw TypeError(".waiternow.common.MenuProto.CategoryLevel1Proto.menuEntries: object expected");
                            message.menuEntries[i] = $root.waiternow.common.MenuProto.MenuEntryProto.fromObject(object.menuEntries[i]);
                        }
                    }
                    if (object.categories) {
                        if (!Array.isArray(object.categories))
                            throw TypeError(".waiternow.common.MenuProto.CategoryLevel1Proto.categories: array expected");
                        message.categories = [];
                        for (var i = 0; i < object.categories.length; ++i) {
                            if (typeof object.categories[i] !== "object")
                                throw TypeError(".waiternow.common.MenuProto.CategoryLevel1Proto.categories: object expected");
                            message.categories[i] = $root.waiternow.common.MenuProto.CategoryLevel2Proto.fromObject(object.categories[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a CategoryLevel1Proto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.MenuProto.CategoryLevel1Proto
                 * @static
                 * @param {waiternow.common.MenuProto.CategoryLevel1Proto} message CategoryLevel1Proto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                CategoryLevel1Proto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.menuEntries = [];
                        object.categories = [];
                    }
                    if (options.defaults) {
                        object.name = null;
                        object.image = null;
                        object.id = "";
                    }
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = $root.waiternow.common.TextProto.toObject(message.name, options);
                    if (message.image != null && message.hasOwnProperty("image"))
                        object.image = $root.waiternow.common.ImageProto.toObject(message.image, options);
                    if (message.menuEntries && message.menuEntries.length) {
                        object.menuEntries = [];
                        for (var j = 0; j < message.menuEntries.length; ++j)
                            object.menuEntries[j] = $root.waiternow.common.MenuProto.MenuEntryProto.toObject(message.menuEntries[j], options);
                    }
                    if (message.categories && message.categories.length) {
                        object.categories = [];
                        for (var j = 0; j < message.categories.length; ++j)
                            object.categories[j] = $root.waiternow.common.MenuProto.CategoryLevel2Proto.toObject(message.categories[j], options);
                    }
                    if (message.id != null && message.hasOwnProperty("id"))
                        object.id = message.id;
                    return object;
                };

                /**
                 * Converts this CategoryLevel1Proto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.MenuProto.CategoryLevel1Proto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                CategoryLevel1Proto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for CategoryLevel1Proto
                 * @function getTypeUrl
                 * @memberof waiternow.common.MenuProto.CategoryLevel1Proto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                CategoryLevel1Proto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.MenuProto.CategoryLevel1Proto";
                };

                return CategoryLevel1Proto;
            })();

            return MenuProto;
        })();

        common.MenuOrderProto = (function() {

            /**
             * Properties of a MenuOrderProto.
             * @memberof waiternow.common
             * @interface IMenuOrderProto
             * @property {Array.<waiternow.common.MenuOrderProto.IMenuEntryProto>|null} [menuEntries] MenuOrderProto menuEntries
             * @property {boolean|null} [toGo] MenuOrderProto toGo
             * @property {boolean|null} [includeCutlery] MenuOrderProto includeCutlery
             */

            /**
             * Constructs a new MenuOrderProto.
             * @memberof waiternow.common
             * @classdesc Represents a MenuOrderProto.
             * @implements IMenuOrderProto
             * @constructor
             * @param {waiternow.common.IMenuOrderProto=} [properties] Properties to set
             */
            function MenuOrderProto(properties) {
                this.menuEntries = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * MenuOrderProto menuEntries.
             * @member {Array.<waiternow.common.MenuOrderProto.IMenuEntryProto>} menuEntries
             * @memberof waiternow.common.MenuOrderProto
             * @instance
             */
            MenuOrderProto.prototype.menuEntries = $util.emptyArray;

            /**
             * MenuOrderProto toGo.
             * @member {boolean} toGo
             * @memberof waiternow.common.MenuOrderProto
             * @instance
             */
            MenuOrderProto.prototype.toGo = false;

            /**
             * MenuOrderProto includeCutlery.
             * @member {boolean} includeCutlery
             * @memberof waiternow.common.MenuOrderProto
             * @instance
             */
            MenuOrderProto.prototype.includeCutlery = false;

            /**
             * Creates a new MenuOrderProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.MenuOrderProto
             * @static
             * @param {waiternow.common.IMenuOrderProto=} [properties] Properties to set
             * @returns {waiternow.common.MenuOrderProto} MenuOrderProto instance
             */
            MenuOrderProto.create = function create(properties) {
                return new MenuOrderProto(properties);
            };

            /**
             * Encodes the specified MenuOrderProto message. Does not implicitly {@link waiternow.common.MenuOrderProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.MenuOrderProto
             * @static
             * @param {waiternow.common.IMenuOrderProto} message MenuOrderProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MenuOrderProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.menuEntries != null && message.menuEntries.length)
                    for (var i = 0; i < message.menuEntries.length; ++i)
                        $root.waiternow.common.MenuOrderProto.MenuEntryProto.encode(message.menuEntries[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.toGo != null && Object.hasOwnProperty.call(message, "toGo"))
                    writer.uint32(/* id 2, wireType 0 =*/16).bool(message.toGo);
                if (message.includeCutlery != null && Object.hasOwnProperty.call(message, "includeCutlery"))
                    writer.uint32(/* id 3, wireType 0 =*/24).bool(message.includeCutlery);
                return writer;
            };

            /**
             * Encodes the specified MenuOrderProto message, length delimited. Does not implicitly {@link waiternow.common.MenuOrderProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.MenuOrderProto
             * @static
             * @param {waiternow.common.IMenuOrderProto} message MenuOrderProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MenuOrderProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a MenuOrderProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.MenuOrderProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.MenuOrderProto} MenuOrderProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MenuOrderProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.MenuOrderProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            if (!(message.menuEntries && message.menuEntries.length))
                                message.menuEntries = [];
                            message.menuEntries.push($root.waiternow.common.MenuOrderProto.MenuEntryProto.decode(reader, reader.uint32()));
                            break;
                        }
                    case 2: {
                            message.toGo = reader.bool();
                            break;
                        }
                    case 3: {
                            message.includeCutlery = reader.bool();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a MenuOrderProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.MenuOrderProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.MenuOrderProto} MenuOrderProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MenuOrderProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a MenuOrderProto message.
             * @function verify
             * @memberof waiternow.common.MenuOrderProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            MenuOrderProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.menuEntries != null && message.hasOwnProperty("menuEntries")) {
                    if (!Array.isArray(message.menuEntries))
                        return "menuEntries: array expected";
                    for (var i = 0; i < message.menuEntries.length; ++i) {
                        var error = $root.waiternow.common.MenuOrderProto.MenuEntryProto.verify(message.menuEntries[i]);
                        if (error)
                            return "menuEntries." + error;
                    }
                }
                if (message.toGo != null && message.hasOwnProperty("toGo"))
                    if (typeof message.toGo !== "boolean")
                        return "toGo: boolean expected";
                if (message.includeCutlery != null && message.hasOwnProperty("includeCutlery"))
                    if (typeof message.includeCutlery !== "boolean")
                        return "includeCutlery: boolean expected";
                return null;
            };

            /**
             * Creates a MenuOrderProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.MenuOrderProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.MenuOrderProto} MenuOrderProto
             */
            MenuOrderProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.MenuOrderProto)
                    return object;
                var message = new $root.waiternow.common.MenuOrderProto();
                if (object.menuEntries) {
                    if (!Array.isArray(object.menuEntries))
                        throw TypeError(".waiternow.common.MenuOrderProto.menuEntries: array expected");
                    message.menuEntries = [];
                    for (var i = 0; i < object.menuEntries.length; ++i) {
                        if (typeof object.menuEntries[i] !== "object")
                            throw TypeError(".waiternow.common.MenuOrderProto.menuEntries: object expected");
                        message.menuEntries[i] = $root.waiternow.common.MenuOrderProto.MenuEntryProto.fromObject(object.menuEntries[i]);
                    }
                }
                if (object.toGo != null)
                    message.toGo = Boolean(object.toGo);
                if (object.includeCutlery != null)
                    message.includeCutlery = Boolean(object.includeCutlery);
                return message;
            };

            /**
             * Creates a plain object from a MenuOrderProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.MenuOrderProto
             * @static
             * @param {waiternow.common.MenuOrderProto} message MenuOrderProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            MenuOrderProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.menuEntries = [];
                if (options.defaults) {
                    object.toGo = false;
                    object.includeCutlery = false;
                }
                if (message.menuEntries && message.menuEntries.length) {
                    object.menuEntries = [];
                    for (var j = 0; j < message.menuEntries.length; ++j)
                        object.menuEntries[j] = $root.waiternow.common.MenuOrderProto.MenuEntryProto.toObject(message.menuEntries[j], options);
                }
                if (message.toGo != null && message.hasOwnProperty("toGo"))
                    object.toGo = message.toGo;
                if (message.includeCutlery != null && message.hasOwnProperty("includeCutlery"))
                    object.includeCutlery = message.includeCutlery;
                return object;
            };

            /**
             * Converts this MenuOrderProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.MenuOrderProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            MenuOrderProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for MenuOrderProto
             * @function getTypeUrl
             * @memberof waiternow.common.MenuOrderProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            MenuOrderProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.MenuOrderProto";
            };

            MenuOrderProto.ItemProto = (function() {

                /**
                 * Properties of an ItemProto.
                 * @memberof waiternow.common.MenuOrderProto
                 * @interface IItemProto
                 * @property {string|null} [id] ItemProto id
                 * @property {waiternow.common.ITextProto|null} [name] ItemProto name
                 * @property {waiternow.common.IMoneyProto|null} [price] ItemProto price
                 */

                /**
                 * Constructs a new ItemProto.
                 * @memberof waiternow.common.MenuOrderProto
                 * @classdesc Represents an ItemProto.
                 * @implements IItemProto
                 * @constructor
                 * @param {waiternow.common.MenuOrderProto.IItemProto=} [properties] Properties to set
                 */
                function ItemProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ItemProto id.
                 * @member {string} id
                 * @memberof waiternow.common.MenuOrderProto.ItemProto
                 * @instance
                 */
                ItemProto.prototype.id = "";

                /**
                 * ItemProto name.
                 * @member {waiternow.common.ITextProto|null|undefined} name
                 * @memberof waiternow.common.MenuOrderProto.ItemProto
                 * @instance
                 */
                ItemProto.prototype.name = null;

                /**
                 * ItemProto price.
                 * @member {waiternow.common.IMoneyProto|null|undefined} price
                 * @memberof waiternow.common.MenuOrderProto.ItemProto
                 * @instance
                 */
                ItemProto.prototype.price = null;

                /**
                 * Creates a new ItemProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.MenuOrderProto.ItemProto
                 * @static
                 * @param {waiternow.common.MenuOrderProto.IItemProto=} [properties] Properties to set
                 * @returns {waiternow.common.MenuOrderProto.ItemProto} ItemProto instance
                 */
                ItemProto.create = function create(properties) {
                    return new ItemProto(properties);
                };

                /**
                 * Encodes the specified ItemProto message. Does not implicitly {@link waiternow.common.MenuOrderProto.ItemProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.MenuOrderProto.ItemProto
                 * @static
                 * @param {waiternow.common.MenuOrderProto.IItemProto} message ItemProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ItemProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        $root.waiternow.common.TextProto.encode(message.name, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.price != null && Object.hasOwnProperty.call(message, "price"))
                        $root.waiternow.common.MoneyProto.encode(message.price, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.id);
                    return writer;
                };

                /**
                 * Encodes the specified ItemProto message, length delimited. Does not implicitly {@link waiternow.common.MenuOrderProto.ItemProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.MenuOrderProto.ItemProto
                 * @static
                 * @param {waiternow.common.MenuOrderProto.IItemProto} message ItemProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ItemProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an ItemProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.MenuOrderProto.ItemProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.MenuOrderProto.ItemProto} ItemProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ItemProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.MenuOrderProto.ItemProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 3: {
                                message.id = reader.string();
                                break;
                            }
                        case 1: {
                                message.name = $root.waiternow.common.TextProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.price = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an ItemProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.MenuOrderProto.ItemProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.MenuOrderProto.ItemProto} ItemProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ItemProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an ItemProto message.
                 * @function verify
                 * @memberof waiternow.common.MenuOrderProto.ItemProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ItemProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (!$util.isString(message.id))
                            return "id: string expected";
                    if (message.name != null && message.hasOwnProperty("name")) {
                        var error = $root.waiternow.common.TextProto.verify(message.name);
                        if (error)
                            return "name." + error;
                    }
                    if (message.price != null && message.hasOwnProperty("price")) {
                        var error = $root.waiternow.common.MoneyProto.verify(message.price);
                        if (error)
                            return "price." + error;
                    }
                    return null;
                };

                /**
                 * Creates an ItemProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.MenuOrderProto.ItemProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.MenuOrderProto.ItemProto} ItemProto
                 */
                ItemProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.MenuOrderProto.ItemProto)
                        return object;
                    var message = new $root.waiternow.common.MenuOrderProto.ItemProto();
                    if (object.id != null)
                        message.id = String(object.id);
                    if (object.name != null) {
                        if (typeof object.name !== "object")
                            throw TypeError(".waiternow.common.MenuOrderProto.ItemProto.name: object expected");
                        message.name = $root.waiternow.common.TextProto.fromObject(object.name);
                    }
                    if (object.price != null) {
                        if (typeof object.price !== "object")
                            throw TypeError(".waiternow.common.MenuOrderProto.ItemProto.price: object expected");
                        message.price = $root.waiternow.common.MoneyProto.fromObject(object.price);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an ItemProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.MenuOrderProto.ItemProto
                 * @static
                 * @param {waiternow.common.MenuOrderProto.ItemProto} message ItemProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ItemProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.name = null;
                        object.price = null;
                        object.id = "";
                    }
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = $root.waiternow.common.TextProto.toObject(message.name, options);
                    if (message.price != null && message.hasOwnProperty("price"))
                        object.price = $root.waiternow.common.MoneyProto.toObject(message.price, options);
                    if (message.id != null && message.hasOwnProperty("id"))
                        object.id = message.id;
                    return object;
                };

                /**
                 * Converts this ItemProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.MenuOrderProto.ItemProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ItemProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ItemProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.MenuOrderProto.ItemProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ItemProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.MenuOrderProto.ItemProto";
                };

                return ItemProto;
            })();

            MenuOrderProto.ItemSelectionProto = (function() {

                /**
                 * Properties of an ItemSelectionProto.
                 * @memberof waiternow.common.MenuOrderProto
                 * @interface IItemSelectionProto
                 * @property {string|null} [id] ItemSelectionProto id
                 * @property {waiternow.common.ITextProto|null} [title] ItemSelectionProto title
                 * @property {Array.<waiternow.common.MenuOrderProto.IItemProto>|null} [selectedItems] ItemSelectionProto selectedItems
                 */

                /**
                 * Constructs a new ItemSelectionProto.
                 * @memberof waiternow.common.MenuOrderProto
                 * @classdesc Represents an ItemSelectionProto.
                 * @implements IItemSelectionProto
                 * @constructor
                 * @param {waiternow.common.MenuOrderProto.IItemSelectionProto=} [properties] Properties to set
                 */
                function ItemSelectionProto(properties) {
                    this.selectedItems = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ItemSelectionProto id.
                 * @member {string} id
                 * @memberof waiternow.common.MenuOrderProto.ItemSelectionProto
                 * @instance
                 */
                ItemSelectionProto.prototype.id = "";

                /**
                 * ItemSelectionProto title.
                 * @member {waiternow.common.ITextProto|null|undefined} title
                 * @memberof waiternow.common.MenuOrderProto.ItemSelectionProto
                 * @instance
                 */
                ItemSelectionProto.prototype.title = null;

                /**
                 * ItemSelectionProto selectedItems.
                 * @member {Array.<waiternow.common.MenuOrderProto.IItemProto>} selectedItems
                 * @memberof waiternow.common.MenuOrderProto.ItemSelectionProto
                 * @instance
                 */
                ItemSelectionProto.prototype.selectedItems = $util.emptyArray;

                /**
                 * Creates a new ItemSelectionProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.MenuOrderProto.ItemSelectionProto
                 * @static
                 * @param {waiternow.common.MenuOrderProto.IItemSelectionProto=} [properties] Properties to set
                 * @returns {waiternow.common.MenuOrderProto.ItemSelectionProto} ItemSelectionProto instance
                 */
                ItemSelectionProto.create = function create(properties) {
                    return new ItemSelectionProto(properties);
                };

                /**
                 * Encodes the specified ItemSelectionProto message. Does not implicitly {@link waiternow.common.MenuOrderProto.ItemSelectionProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.MenuOrderProto.ItemSelectionProto
                 * @static
                 * @param {waiternow.common.MenuOrderProto.IItemSelectionProto} message ItemSelectionProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ItemSelectionProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                        $root.waiternow.common.TextProto.encode(message.title, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.selectedItems != null && message.selectedItems.length)
                        for (var i = 0; i < message.selectedItems.length; ++i)
                            $root.waiternow.common.MenuOrderProto.ItemProto.encode(message.selectedItems[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.id);
                    return writer;
                };

                /**
                 * Encodes the specified ItemSelectionProto message, length delimited. Does not implicitly {@link waiternow.common.MenuOrderProto.ItemSelectionProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.MenuOrderProto.ItemSelectionProto
                 * @static
                 * @param {waiternow.common.MenuOrderProto.IItemSelectionProto} message ItemSelectionProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ItemSelectionProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an ItemSelectionProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.MenuOrderProto.ItemSelectionProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.MenuOrderProto.ItemSelectionProto} ItemSelectionProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ItemSelectionProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.MenuOrderProto.ItemSelectionProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 3: {
                                message.id = reader.string();
                                break;
                            }
                        case 1: {
                                message.title = $root.waiternow.common.TextProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                if (!(message.selectedItems && message.selectedItems.length))
                                    message.selectedItems = [];
                                message.selectedItems.push($root.waiternow.common.MenuOrderProto.ItemProto.decode(reader, reader.uint32()));
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an ItemSelectionProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.MenuOrderProto.ItemSelectionProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.MenuOrderProto.ItemSelectionProto} ItemSelectionProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ItemSelectionProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an ItemSelectionProto message.
                 * @function verify
                 * @memberof waiternow.common.MenuOrderProto.ItemSelectionProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ItemSelectionProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (!$util.isString(message.id))
                            return "id: string expected";
                    if (message.title != null && message.hasOwnProperty("title")) {
                        var error = $root.waiternow.common.TextProto.verify(message.title);
                        if (error)
                            return "title." + error;
                    }
                    if (message.selectedItems != null && message.hasOwnProperty("selectedItems")) {
                        if (!Array.isArray(message.selectedItems))
                            return "selectedItems: array expected";
                        for (var i = 0; i < message.selectedItems.length; ++i) {
                            var error = $root.waiternow.common.MenuOrderProto.ItemProto.verify(message.selectedItems[i]);
                            if (error)
                                return "selectedItems." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates an ItemSelectionProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.MenuOrderProto.ItemSelectionProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.MenuOrderProto.ItemSelectionProto} ItemSelectionProto
                 */
                ItemSelectionProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.MenuOrderProto.ItemSelectionProto)
                        return object;
                    var message = new $root.waiternow.common.MenuOrderProto.ItemSelectionProto();
                    if (object.id != null)
                        message.id = String(object.id);
                    if (object.title != null) {
                        if (typeof object.title !== "object")
                            throw TypeError(".waiternow.common.MenuOrderProto.ItemSelectionProto.title: object expected");
                        message.title = $root.waiternow.common.TextProto.fromObject(object.title);
                    }
                    if (object.selectedItems) {
                        if (!Array.isArray(object.selectedItems))
                            throw TypeError(".waiternow.common.MenuOrderProto.ItemSelectionProto.selectedItems: array expected");
                        message.selectedItems = [];
                        for (var i = 0; i < object.selectedItems.length; ++i) {
                            if (typeof object.selectedItems[i] !== "object")
                                throw TypeError(".waiternow.common.MenuOrderProto.ItemSelectionProto.selectedItems: object expected");
                            message.selectedItems[i] = $root.waiternow.common.MenuOrderProto.ItemProto.fromObject(object.selectedItems[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an ItemSelectionProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.MenuOrderProto.ItemSelectionProto
                 * @static
                 * @param {waiternow.common.MenuOrderProto.ItemSelectionProto} message ItemSelectionProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ItemSelectionProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.selectedItems = [];
                    if (options.defaults) {
                        object.title = null;
                        object.id = "";
                    }
                    if (message.title != null && message.hasOwnProperty("title"))
                        object.title = $root.waiternow.common.TextProto.toObject(message.title, options);
                    if (message.selectedItems && message.selectedItems.length) {
                        object.selectedItems = [];
                        for (var j = 0; j < message.selectedItems.length; ++j)
                            object.selectedItems[j] = $root.waiternow.common.MenuOrderProto.ItemProto.toObject(message.selectedItems[j], options);
                    }
                    if (message.id != null && message.hasOwnProperty("id"))
                        object.id = message.id;
                    return object;
                };

                /**
                 * Converts this ItemSelectionProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.MenuOrderProto.ItemSelectionProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ItemSelectionProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ItemSelectionProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.MenuOrderProto.ItemSelectionProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ItemSelectionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.MenuOrderProto.ItemSelectionProto";
                };

                return ItemSelectionProto;
            })();

            MenuOrderProto.MenuItemProto = (function() {

                /**
                 * Properties of a MenuItemProto.
                 * @memberof waiternow.common.MenuOrderProto
                 * @interface IMenuItemProto
                 * @property {string|null} [id] MenuItemProto id
                 * @property {waiternow.common.ITextProto|null} [name] MenuItemProto name
                 * @property {Array.<waiternow.common.MenuOrderProto.IItemProto>|null} [withoutIngredients] MenuItemProto withoutIngredients
                 * @property {Array.<waiternow.common.MenuOrderProto.IItemSelectionProto>|null} [itemSelections] MenuItemProto itemSelections
                 * @property {boolean|null} [containsAlcohol] MenuItemProto containsAlcohol
                 * @property {waiternow.common.IMoneyProto|null} [price] MenuItemProto price
                 * @property {waiternow.common.IMoneyProto|null} [priceInCombo] MenuItemProto priceInCombo
                 * @property {string|null} [station] MenuItemProto station
                 * @property {number|null} [quantity] MenuItemProto quantity
                 * @property {string|null} [specialInstructions] MenuItemProto specialInstructions
                 */

                /**
                 * Constructs a new MenuItemProto.
                 * @memberof waiternow.common.MenuOrderProto
                 * @classdesc Represents a MenuItemProto.
                 * @implements IMenuItemProto
                 * @constructor
                 * @param {waiternow.common.MenuOrderProto.IMenuItemProto=} [properties] Properties to set
                 */
                function MenuItemProto(properties) {
                    this.withoutIngredients = [];
                    this.itemSelections = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * MenuItemProto id.
                 * @member {string} id
                 * @memberof waiternow.common.MenuOrderProto.MenuItemProto
                 * @instance
                 */
                MenuItemProto.prototype.id = "";

                /**
                 * MenuItemProto name.
                 * @member {waiternow.common.ITextProto|null|undefined} name
                 * @memberof waiternow.common.MenuOrderProto.MenuItemProto
                 * @instance
                 */
                MenuItemProto.prototype.name = null;

                /**
                 * MenuItemProto withoutIngredients.
                 * @member {Array.<waiternow.common.MenuOrderProto.IItemProto>} withoutIngredients
                 * @memberof waiternow.common.MenuOrderProto.MenuItemProto
                 * @instance
                 */
                MenuItemProto.prototype.withoutIngredients = $util.emptyArray;

                /**
                 * MenuItemProto itemSelections.
                 * @member {Array.<waiternow.common.MenuOrderProto.IItemSelectionProto>} itemSelections
                 * @memberof waiternow.common.MenuOrderProto.MenuItemProto
                 * @instance
                 */
                MenuItemProto.prototype.itemSelections = $util.emptyArray;

                /**
                 * MenuItemProto containsAlcohol.
                 * @member {boolean} containsAlcohol
                 * @memberof waiternow.common.MenuOrderProto.MenuItemProto
                 * @instance
                 */
                MenuItemProto.prototype.containsAlcohol = false;

                /**
                 * MenuItemProto price.
                 * @member {waiternow.common.IMoneyProto|null|undefined} price
                 * @memberof waiternow.common.MenuOrderProto.MenuItemProto
                 * @instance
                 */
                MenuItemProto.prototype.price = null;

                /**
                 * MenuItemProto priceInCombo.
                 * @member {waiternow.common.IMoneyProto|null|undefined} priceInCombo
                 * @memberof waiternow.common.MenuOrderProto.MenuItemProto
                 * @instance
                 */
                MenuItemProto.prototype.priceInCombo = null;

                /**
                 * MenuItemProto station.
                 * @member {string} station
                 * @memberof waiternow.common.MenuOrderProto.MenuItemProto
                 * @instance
                 */
                MenuItemProto.prototype.station = "";

                /**
                 * MenuItemProto quantity.
                 * @member {number} quantity
                 * @memberof waiternow.common.MenuOrderProto.MenuItemProto
                 * @instance
                 */
                MenuItemProto.prototype.quantity = 0;

                /**
                 * MenuItemProto specialInstructions.
                 * @member {string} specialInstructions
                 * @memberof waiternow.common.MenuOrderProto.MenuItemProto
                 * @instance
                 */
                MenuItemProto.prototype.specialInstructions = "";

                /**
                 * Creates a new MenuItemProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.MenuOrderProto.MenuItemProto
                 * @static
                 * @param {waiternow.common.MenuOrderProto.IMenuItemProto=} [properties] Properties to set
                 * @returns {waiternow.common.MenuOrderProto.MenuItemProto} MenuItemProto instance
                 */
                MenuItemProto.create = function create(properties) {
                    return new MenuItemProto(properties);
                };

                /**
                 * Encodes the specified MenuItemProto message. Does not implicitly {@link waiternow.common.MenuOrderProto.MenuItemProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.MenuOrderProto.MenuItemProto
                 * @static
                 * @param {waiternow.common.MenuOrderProto.IMenuItemProto} message MenuItemProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MenuItemProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        $root.waiternow.common.TextProto.encode(message.name, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.withoutIngredients != null && message.withoutIngredients.length)
                        for (var i = 0; i < message.withoutIngredients.length; ++i)
                            $root.waiternow.common.MenuOrderProto.ItemProto.encode(message.withoutIngredients[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.itemSelections != null && message.itemSelections.length)
                        for (var i = 0; i < message.itemSelections.length; ++i)
                            $root.waiternow.common.MenuOrderProto.ItemSelectionProto.encode(message.itemSelections[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.containsAlcohol != null && Object.hasOwnProperty.call(message, "containsAlcohol"))
                        writer.uint32(/* id 4, wireType 0 =*/32).bool(message.containsAlcohol);
                    if (message.price != null && Object.hasOwnProperty.call(message, "price"))
                        $root.waiternow.common.MoneyProto.encode(message.price, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.priceInCombo != null && Object.hasOwnProperty.call(message, "priceInCombo"))
                        $root.waiternow.common.MoneyProto.encode(message.priceInCombo, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.station != null && Object.hasOwnProperty.call(message, "station"))
                        writer.uint32(/* id 7, wireType 2 =*/58).string(message.station);
                    if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
                        writer.uint32(/* id 8, wireType 0 =*/64).int32(message.quantity);
                    if (message.specialInstructions != null && Object.hasOwnProperty.call(message, "specialInstructions"))
                        writer.uint32(/* id 9, wireType 2 =*/74).string(message.specialInstructions);
                    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                        writer.uint32(/* id 10, wireType 2 =*/82).string(message.id);
                    return writer;
                };

                /**
                 * Encodes the specified MenuItemProto message, length delimited. Does not implicitly {@link waiternow.common.MenuOrderProto.MenuItemProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.MenuOrderProto.MenuItemProto
                 * @static
                 * @param {waiternow.common.MenuOrderProto.IMenuItemProto} message MenuItemProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MenuItemProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a MenuItemProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.MenuOrderProto.MenuItemProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.MenuOrderProto.MenuItemProto} MenuItemProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MenuItemProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.MenuOrderProto.MenuItemProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 10: {
                                message.id = reader.string();
                                break;
                            }
                        case 1: {
                                message.name = $root.waiternow.common.TextProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                if (!(message.withoutIngredients && message.withoutIngredients.length))
                                    message.withoutIngredients = [];
                                message.withoutIngredients.push($root.waiternow.common.MenuOrderProto.ItemProto.decode(reader, reader.uint32()));
                                break;
                            }
                        case 3: {
                                if (!(message.itemSelections && message.itemSelections.length))
                                    message.itemSelections = [];
                                message.itemSelections.push($root.waiternow.common.MenuOrderProto.ItemSelectionProto.decode(reader, reader.uint32()));
                                break;
                            }
                        case 4: {
                                message.containsAlcohol = reader.bool();
                                break;
                            }
                        case 5: {
                                message.price = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 6: {
                                message.priceInCombo = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 7: {
                                message.station = reader.string();
                                break;
                            }
                        case 8: {
                                message.quantity = reader.int32();
                                break;
                            }
                        case 9: {
                                message.specialInstructions = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a MenuItemProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.MenuOrderProto.MenuItemProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.MenuOrderProto.MenuItemProto} MenuItemProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MenuItemProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a MenuItemProto message.
                 * @function verify
                 * @memberof waiternow.common.MenuOrderProto.MenuItemProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                MenuItemProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (!$util.isString(message.id))
                            return "id: string expected";
                    if (message.name != null && message.hasOwnProperty("name")) {
                        var error = $root.waiternow.common.TextProto.verify(message.name);
                        if (error)
                            return "name." + error;
                    }
                    if (message.withoutIngredients != null && message.hasOwnProperty("withoutIngredients")) {
                        if (!Array.isArray(message.withoutIngredients))
                            return "withoutIngredients: array expected";
                        for (var i = 0; i < message.withoutIngredients.length; ++i) {
                            var error = $root.waiternow.common.MenuOrderProto.ItemProto.verify(message.withoutIngredients[i]);
                            if (error)
                                return "withoutIngredients." + error;
                        }
                    }
                    if (message.itemSelections != null && message.hasOwnProperty("itemSelections")) {
                        if (!Array.isArray(message.itemSelections))
                            return "itemSelections: array expected";
                        for (var i = 0; i < message.itemSelections.length; ++i) {
                            var error = $root.waiternow.common.MenuOrderProto.ItemSelectionProto.verify(message.itemSelections[i]);
                            if (error)
                                return "itemSelections." + error;
                        }
                    }
                    if (message.containsAlcohol != null && message.hasOwnProperty("containsAlcohol"))
                        if (typeof message.containsAlcohol !== "boolean")
                            return "containsAlcohol: boolean expected";
                    if (message.price != null && message.hasOwnProperty("price")) {
                        var error = $root.waiternow.common.MoneyProto.verify(message.price);
                        if (error)
                            return "price." + error;
                    }
                    if (message.priceInCombo != null && message.hasOwnProperty("priceInCombo")) {
                        var error = $root.waiternow.common.MoneyProto.verify(message.priceInCombo);
                        if (error)
                            return "priceInCombo." + error;
                    }
                    if (message.station != null && message.hasOwnProperty("station"))
                        if (!$util.isString(message.station))
                            return "station: string expected";
                    if (message.quantity != null && message.hasOwnProperty("quantity"))
                        if (!$util.isInteger(message.quantity))
                            return "quantity: integer expected";
                    if (message.specialInstructions != null && message.hasOwnProperty("specialInstructions"))
                        if (!$util.isString(message.specialInstructions))
                            return "specialInstructions: string expected";
                    return null;
                };

                /**
                 * Creates a MenuItemProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.MenuOrderProto.MenuItemProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.MenuOrderProto.MenuItemProto} MenuItemProto
                 */
                MenuItemProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.MenuOrderProto.MenuItemProto)
                        return object;
                    var message = new $root.waiternow.common.MenuOrderProto.MenuItemProto();
                    if (object.id != null)
                        message.id = String(object.id);
                    if (object.name != null) {
                        if (typeof object.name !== "object")
                            throw TypeError(".waiternow.common.MenuOrderProto.MenuItemProto.name: object expected");
                        message.name = $root.waiternow.common.TextProto.fromObject(object.name);
                    }
                    if (object.withoutIngredients) {
                        if (!Array.isArray(object.withoutIngredients))
                            throw TypeError(".waiternow.common.MenuOrderProto.MenuItemProto.withoutIngredients: array expected");
                        message.withoutIngredients = [];
                        for (var i = 0; i < object.withoutIngredients.length; ++i) {
                            if (typeof object.withoutIngredients[i] !== "object")
                                throw TypeError(".waiternow.common.MenuOrderProto.MenuItemProto.withoutIngredients: object expected");
                            message.withoutIngredients[i] = $root.waiternow.common.MenuOrderProto.ItemProto.fromObject(object.withoutIngredients[i]);
                        }
                    }
                    if (object.itemSelections) {
                        if (!Array.isArray(object.itemSelections))
                            throw TypeError(".waiternow.common.MenuOrderProto.MenuItemProto.itemSelections: array expected");
                        message.itemSelections = [];
                        for (var i = 0; i < object.itemSelections.length; ++i) {
                            if (typeof object.itemSelections[i] !== "object")
                                throw TypeError(".waiternow.common.MenuOrderProto.MenuItemProto.itemSelections: object expected");
                            message.itemSelections[i] = $root.waiternow.common.MenuOrderProto.ItemSelectionProto.fromObject(object.itemSelections[i]);
                        }
                    }
                    if (object.containsAlcohol != null)
                        message.containsAlcohol = Boolean(object.containsAlcohol);
                    if (object.price != null) {
                        if (typeof object.price !== "object")
                            throw TypeError(".waiternow.common.MenuOrderProto.MenuItemProto.price: object expected");
                        message.price = $root.waiternow.common.MoneyProto.fromObject(object.price);
                    }
                    if (object.priceInCombo != null) {
                        if (typeof object.priceInCombo !== "object")
                            throw TypeError(".waiternow.common.MenuOrderProto.MenuItemProto.priceInCombo: object expected");
                        message.priceInCombo = $root.waiternow.common.MoneyProto.fromObject(object.priceInCombo);
                    }
                    if (object.station != null)
                        message.station = String(object.station);
                    if (object.quantity != null)
                        message.quantity = object.quantity | 0;
                    if (object.specialInstructions != null)
                        message.specialInstructions = String(object.specialInstructions);
                    return message;
                };

                /**
                 * Creates a plain object from a MenuItemProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.MenuOrderProto.MenuItemProto
                 * @static
                 * @param {waiternow.common.MenuOrderProto.MenuItemProto} message MenuItemProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                MenuItemProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.withoutIngredients = [];
                        object.itemSelections = [];
                    }
                    if (options.defaults) {
                        object.name = null;
                        object.containsAlcohol = false;
                        object.price = null;
                        object.priceInCombo = null;
                        object.station = "";
                        object.quantity = 0;
                        object.specialInstructions = "";
                        object.id = "";
                    }
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = $root.waiternow.common.TextProto.toObject(message.name, options);
                    if (message.withoutIngredients && message.withoutIngredients.length) {
                        object.withoutIngredients = [];
                        for (var j = 0; j < message.withoutIngredients.length; ++j)
                            object.withoutIngredients[j] = $root.waiternow.common.MenuOrderProto.ItemProto.toObject(message.withoutIngredients[j], options);
                    }
                    if (message.itemSelections && message.itemSelections.length) {
                        object.itemSelections = [];
                        for (var j = 0; j < message.itemSelections.length; ++j)
                            object.itemSelections[j] = $root.waiternow.common.MenuOrderProto.ItemSelectionProto.toObject(message.itemSelections[j], options);
                    }
                    if (message.containsAlcohol != null && message.hasOwnProperty("containsAlcohol"))
                        object.containsAlcohol = message.containsAlcohol;
                    if (message.price != null && message.hasOwnProperty("price"))
                        object.price = $root.waiternow.common.MoneyProto.toObject(message.price, options);
                    if (message.priceInCombo != null && message.hasOwnProperty("priceInCombo"))
                        object.priceInCombo = $root.waiternow.common.MoneyProto.toObject(message.priceInCombo, options);
                    if (message.station != null && message.hasOwnProperty("station"))
                        object.station = message.station;
                    if (message.quantity != null && message.hasOwnProperty("quantity"))
                        object.quantity = message.quantity;
                    if (message.specialInstructions != null && message.hasOwnProperty("specialInstructions"))
                        object.specialInstructions = message.specialInstructions;
                    if (message.id != null && message.hasOwnProperty("id"))
                        object.id = message.id;
                    return object;
                };

                /**
                 * Converts this MenuItemProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.MenuOrderProto.MenuItemProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                MenuItemProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for MenuItemProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.MenuOrderProto.MenuItemProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                MenuItemProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.MenuOrderProto.MenuItemProto";
                };

                return MenuItemProto;
            })();

            MenuOrderProto.MenuItemSelectionProto = (function() {

                /**
                 * Properties of a MenuItemSelectionProto.
                 * @memberof waiternow.common.MenuOrderProto
                 * @interface IMenuItemSelectionProto
                 * @property {string|null} [id] MenuItemSelectionProto id
                 * @property {waiternow.common.ITextProto|null} [title] MenuItemSelectionProto title
                 * @property {Array.<waiternow.common.MenuOrderProto.IMenuItemProto>|null} [selectedMenuItems] MenuItemSelectionProto selectedMenuItems
                 */

                /**
                 * Constructs a new MenuItemSelectionProto.
                 * @memberof waiternow.common.MenuOrderProto
                 * @classdesc Represents a MenuItemSelectionProto.
                 * @implements IMenuItemSelectionProto
                 * @constructor
                 * @param {waiternow.common.MenuOrderProto.IMenuItemSelectionProto=} [properties] Properties to set
                 */
                function MenuItemSelectionProto(properties) {
                    this.selectedMenuItems = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * MenuItemSelectionProto id.
                 * @member {string} id
                 * @memberof waiternow.common.MenuOrderProto.MenuItemSelectionProto
                 * @instance
                 */
                MenuItemSelectionProto.prototype.id = "";

                /**
                 * MenuItemSelectionProto title.
                 * @member {waiternow.common.ITextProto|null|undefined} title
                 * @memberof waiternow.common.MenuOrderProto.MenuItemSelectionProto
                 * @instance
                 */
                MenuItemSelectionProto.prototype.title = null;

                /**
                 * MenuItemSelectionProto selectedMenuItems.
                 * @member {Array.<waiternow.common.MenuOrderProto.IMenuItemProto>} selectedMenuItems
                 * @memberof waiternow.common.MenuOrderProto.MenuItemSelectionProto
                 * @instance
                 */
                MenuItemSelectionProto.prototype.selectedMenuItems = $util.emptyArray;

                /**
                 * Creates a new MenuItemSelectionProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.MenuOrderProto.MenuItemSelectionProto
                 * @static
                 * @param {waiternow.common.MenuOrderProto.IMenuItemSelectionProto=} [properties] Properties to set
                 * @returns {waiternow.common.MenuOrderProto.MenuItemSelectionProto} MenuItemSelectionProto instance
                 */
                MenuItemSelectionProto.create = function create(properties) {
                    return new MenuItemSelectionProto(properties);
                };

                /**
                 * Encodes the specified MenuItemSelectionProto message. Does not implicitly {@link waiternow.common.MenuOrderProto.MenuItemSelectionProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.MenuOrderProto.MenuItemSelectionProto
                 * @static
                 * @param {waiternow.common.MenuOrderProto.IMenuItemSelectionProto} message MenuItemSelectionProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MenuItemSelectionProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                        $root.waiternow.common.TextProto.encode(message.title, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.selectedMenuItems != null && message.selectedMenuItems.length)
                        for (var i = 0; i < message.selectedMenuItems.length; ++i)
                            $root.waiternow.common.MenuOrderProto.MenuItemProto.encode(message.selectedMenuItems[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.id);
                    return writer;
                };

                /**
                 * Encodes the specified MenuItemSelectionProto message, length delimited. Does not implicitly {@link waiternow.common.MenuOrderProto.MenuItemSelectionProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.MenuOrderProto.MenuItemSelectionProto
                 * @static
                 * @param {waiternow.common.MenuOrderProto.IMenuItemSelectionProto} message MenuItemSelectionProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MenuItemSelectionProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a MenuItemSelectionProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.MenuOrderProto.MenuItemSelectionProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.MenuOrderProto.MenuItemSelectionProto} MenuItemSelectionProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MenuItemSelectionProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.MenuOrderProto.MenuItemSelectionProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 3: {
                                message.id = reader.string();
                                break;
                            }
                        case 1: {
                                message.title = $root.waiternow.common.TextProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                if (!(message.selectedMenuItems && message.selectedMenuItems.length))
                                    message.selectedMenuItems = [];
                                message.selectedMenuItems.push($root.waiternow.common.MenuOrderProto.MenuItemProto.decode(reader, reader.uint32()));
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a MenuItemSelectionProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.MenuOrderProto.MenuItemSelectionProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.MenuOrderProto.MenuItemSelectionProto} MenuItemSelectionProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MenuItemSelectionProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a MenuItemSelectionProto message.
                 * @function verify
                 * @memberof waiternow.common.MenuOrderProto.MenuItemSelectionProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                MenuItemSelectionProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (!$util.isString(message.id))
                            return "id: string expected";
                    if (message.title != null && message.hasOwnProperty("title")) {
                        var error = $root.waiternow.common.TextProto.verify(message.title);
                        if (error)
                            return "title." + error;
                    }
                    if (message.selectedMenuItems != null && message.hasOwnProperty("selectedMenuItems")) {
                        if (!Array.isArray(message.selectedMenuItems))
                            return "selectedMenuItems: array expected";
                        for (var i = 0; i < message.selectedMenuItems.length; ++i) {
                            var error = $root.waiternow.common.MenuOrderProto.MenuItemProto.verify(message.selectedMenuItems[i]);
                            if (error)
                                return "selectedMenuItems." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a MenuItemSelectionProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.MenuOrderProto.MenuItemSelectionProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.MenuOrderProto.MenuItemSelectionProto} MenuItemSelectionProto
                 */
                MenuItemSelectionProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.MenuOrderProto.MenuItemSelectionProto)
                        return object;
                    var message = new $root.waiternow.common.MenuOrderProto.MenuItemSelectionProto();
                    if (object.id != null)
                        message.id = String(object.id);
                    if (object.title != null) {
                        if (typeof object.title !== "object")
                            throw TypeError(".waiternow.common.MenuOrderProto.MenuItemSelectionProto.title: object expected");
                        message.title = $root.waiternow.common.TextProto.fromObject(object.title);
                    }
                    if (object.selectedMenuItems) {
                        if (!Array.isArray(object.selectedMenuItems))
                            throw TypeError(".waiternow.common.MenuOrderProto.MenuItemSelectionProto.selectedMenuItems: array expected");
                        message.selectedMenuItems = [];
                        for (var i = 0; i < object.selectedMenuItems.length; ++i) {
                            if (typeof object.selectedMenuItems[i] !== "object")
                                throw TypeError(".waiternow.common.MenuOrderProto.MenuItemSelectionProto.selectedMenuItems: object expected");
                            message.selectedMenuItems[i] = $root.waiternow.common.MenuOrderProto.MenuItemProto.fromObject(object.selectedMenuItems[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a MenuItemSelectionProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.MenuOrderProto.MenuItemSelectionProto
                 * @static
                 * @param {waiternow.common.MenuOrderProto.MenuItemSelectionProto} message MenuItemSelectionProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                MenuItemSelectionProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.selectedMenuItems = [];
                    if (options.defaults) {
                        object.title = null;
                        object.id = "";
                    }
                    if (message.title != null && message.hasOwnProperty("title"))
                        object.title = $root.waiternow.common.TextProto.toObject(message.title, options);
                    if (message.selectedMenuItems && message.selectedMenuItems.length) {
                        object.selectedMenuItems = [];
                        for (var j = 0; j < message.selectedMenuItems.length; ++j)
                            object.selectedMenuItems[j] = $root.waiternow.common.MenuOrderProto.MenuItemProto.toObject(message.selectedMenuItems[j], options);
                    }
                    if (message.id != null && message.hasOwnProperty("id"))
                        object.id = message.id;
                    return object;
                };

                /**
                 * Converts this MenuItemSelectionProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.MenuOrderProto.MenuItemSelectionProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                MenuItemSelectionProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for MenuItemSelectionProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.MenuOrderProto.MenuItemSelectionProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                MenuItemSelectionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.MenuOrderProto.MenuItemSelectionProto";
                };

                return MenuItemSelectionProto;
            })();

            MenuOrderProto.ComboProto = (function() {

                /**
                 * Properties of a ComboProto.
                 * @memberof waiternow.common.MenuOrderProto
                 * @interface IComboProto
                 * @property {string|null} [id] ComboProto id
                 * @property {waiternow.common.ITextProto|null} [name] ComboProto name
                 * @property {Array.<waiternow.common.MenuOrderProto.IMenuItemProto>|null} [menuItems] ComboProto menuItems
                 * @property {Array.<waiternow.common.MenuOrderProto.IMenuItemSelectionProto>|null} [menuItemSelections] ComboProto menuItemSelections
                 * @property {Array.<waiternow.common.MenuOrderProto.IItemSelectionProto>|null} [itemSelections] ComboProto itemSelections
                 * @property {waiternow.common.IMoneyProto|null} [price] ComboProto price
                 * @property {number|null} [quantity] ComboProto quantity
                 * @property {string|null} [specialInstructions] ComboProto specialInstructions
                 */

                /**
                 * Constructs a new ComboProto.
                 * @memberof waiternow.common.MenuOrderProto
                 * @classdesc Represents a ComboProto.
                 * @implements IComboProto
                 * @constructor
                 * @param {waiternow.common.MenuOrderProto.IComboProto=} [properties] Properties to set
                 */
                function ComboProto(properties) {
                    this.menuItems = [];
                    this.menuItemSelections = [];
                    this.itemSelections = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ComboProto id.
                 * @member {string} id
                 * @memberof waiternow.common.MenuOrderProto.ComboProto
                 * @instance
                 */
                ComboProto.prototype.id = "";

                /**
                 * ComboProto name.
                 * @member {waiternow.common.ITextProto|null|undefined} name
                 * @memberof waiternow.common.MenuOrderProto.ComboProto
                 * @instance
                 */
                ComboProto.prototype.name = null;

                /**
                 * ComboProto menuItems.
                 * @member {Array.<waiternow.common.MenuOrderProto.IMenuItemProto>} menuItems
                 * @memberof waiternow.common.MenuOrderProto.ComboProto
                 * @instance
                 */
                ComboProto.prototype.menuItems = $util.emptyArray;

                /**
                 * ComboProto menuItemSelections.
                 * @member {Array.<waiternow.common.MenuOrderProto.IMenuItemSelectionProto>} menuItemSelections
                 * @memberof waiternow.common.MenuOrderProto.ComboProto
                 * @instance
                 */
                ComboProto.prototype.menuItemSelections = $util.emptyArray;

                /**
                 * ComboProto itemSelections.
                 * @member {Array.<waiternow.common.MenuOrderProto.IItemSelectionProto>} itemSelections
                 * @memberof waiternow.common.MenuOrderProto.ComboProto
                 * @instance
                 */
                ComboProto.prototype.itemSelections = $util.emptyArray;

                /**
                 * ComboProto price.
                 * @member {waiternow.common.IMoneyProto|null|undefined} price
                 * @memberof waiternow.common.MenuOrderProto.ComboProto
                 * @instance
                 */
                ComboProto.prototype.price = null;

                /**
                 * ComboProto quantity.
                 * @member {number} quantity
                 * @memberof waiternow.common.MenuOrderProto.ComboProto
                 * @instance
                 */
                ComboProto.prototype.quantity = 0;

                /**
                 * ComboProto specialInstructions.
                 * @member {string} specialInstructions
                 * @memberof waiternow.common.MenuOrderProto.ComboProto
                 * @instance
                 */
                ComboProto.prototype.specialInstructions = "";

                /**
                 * Creates a new ComboProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.MenuOrderProto.ComboProto
                 * @static
                 * @param {waiternow.common.MenuOrderProto.IComboProto=} [properties] Properties to set
                 * @returns {waiternow.common.MenuOrderProto.ComboProto} ComboProto instance
                 */
                ComboProto.create = function create(properties) {
                    return new ComboProto(properties);
                };

                /**
                 * Encodes the specified ComboProto message. Does not implicitly {@link waiternow.common.MenuOrderProto.ComboProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.MenuOrderProto.ComboProto
                 * @static
                 * @param {waiternow.common.MenuOrderProto.IComboProto} message ComboProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ComboProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        $root.waiternow.common.TextProto.encode(message.name, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.menuItems != null && message.menuItems.length)
                        for (var i = 0; i < message.menuItems.length; ++i)
                            $root.waiternow.common.MenuOrderProto.MenuItemProto.encode(message.menuItems[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.itemSelections != null && message.itemSelections.length)
                        for (var i = 0; i < message.itemSelections.length; ++i)
                            $root.waiternow.common.MenuOrderProto.ItemSelectionProto.encode(message.itemSelections[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.menuItemSelections != null && message.menuItemSelections.length)
                        for (var i = 0; i < message.menuItemSelections.length; ++i)
                            $root.waiternow.common.MenuOrderProto.MenuItemSelectionProto.encode(message.menuItemSelections[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.price != null && Object.hasOwnProperty.call(message, "price"))
                        $root.waiternow.common.MoneyProto.encode(message.price, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
                        writer.uint32(/* id 6, wireType 0 =*/48).int32(message.quantity);
                    if (message.specialInstructions != null && Object.hasOwnProperty.call(message, "specialInstructions"))
                        writer.uint32(/* id 7, wireType 2 =*/58).string(message.specialInstructions);
                    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                        writer.uint32(/* id 8, wireType 2 =*/66).string(message.id);
                    return writer;
                };

                /**
                 * Encodes the specified ComboProto message, length delimited. Does not implicitly {@link waiternow.common.MenuOrderProto.ComboProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.MenuOrderProto.ComboProto
                 * @static
                 * @param {waiternow.common.MenuOrderProto.IComboProto} message ComboProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ComboProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ComboProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.MenuOrderProto.ComboProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.MenuOrderProto.ComboProto} ComboProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ComboProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.MenuOrderProto.ComboProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 8: {
                                message.id = reader.string();
                                break;
                            }
                        case 1: {
                                message.name = $root.waiternow.common.TextProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                if (!(message.menuItems && message.menuItems.length))
                                    message.menuItems = [];
                                message.menuItems.push($root.waiternow.common.MenuOrderProto.MenuItemProto.decode(reader, reader.uint32()));
                                break;
                            }
                        case 4: {
                                if (!(message.menuItemSelections && message.menuItemSelections.length))
                                    message.menuItemSelections = [];
                                message.menuItemSelections.push($root.waiternow.common.MenuOrderProto.MenuItemSelectionProto.decode(reader, reader.uint32()));
                                break;
                            }
                        case 3: {
                                if (!(message.itemSelections && message.itemSelections.length))
                                    message.itemSelections = [];
                                message.itemSelections.push($root.waiternow.common.MenuOrderProto.ItemSelectionProto.decode(reader, reader.uint32()));
                                break;
                            }
                        case 5: {
                                message.price = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 6: {
                                message.quantity = reader.int32();
                                break;
                            }
                        case 7: {
                                message.specialInstructions = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ComboProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.MenuOrderProto.ComboProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.MenuOrderProto.ComboProto} ComboProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ComboProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ComboProto message.
                 * @function verify
                 * @memberof waiternow.common.MenuOrderProto.ComboProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ComboProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (!$util.isString(message.id))
                            return "id: string expected";
                    if (message.name != null && message.hasOwnProperty("name")) {
                        var error = $root.waiternow.common.TextProto.verify(message.name);
                        if (error)
                            return "name." + error;
                    }
                    if (message.menuItems != null && message.hasOwnProperty("menuItems")) {
                        if (!Array.isArray(message.menuItems))
                            return "menuItems: array expected";
                        for (var i = 0; i < message.menuItems.length; ++i) {
                            var error = $root.waiternow.common.MenuOrderProto.MenuItemProto.verify(message.menuItems[i]);
                            if (error)
                                return "menuItems." + error;
                        }
                    }
                    if (message.menuItemSelections != null && message.hasOwnProperty("menuItemSelections")) {
                        if (!Array.isArray(message.menuItemSelections))
                            return "menuItemSelections: array expected";
                        for (var i = 0; i < message.menuItemSelections.length; ++i) {
                            var error = $root.waiternow.common.MenuOrderProto.MenuItemSelectionProto.verify(message.menuItemSelections[i]);
                            if (error)
                                return "menuItemSelections." + error;
                        }
                    }
                    if (message.itemSelections != null && message.hasOwnProperty("itemSelections")) {
                        if (!Array.isArray(message.itemSelections))
                            return "itemSelections: array expected";
                        for (var i = 0; i < message.itemSelections.length; ++i) {
                            var error = $root.waiternow.common.MenuOrderProto.ItemSelectionProto.verify(message.itemSelections[i]);
                            if (error)
                                return "itemSelections." + error;
                        }
                    }
                    if (message.price != null && message.hasOwnProperty("price")) {
                        var error = $root.waiternow.common.MoneyProto.verify(message.price);
                        if (error)
                            return "price." + error;
                    }
                    if (message.quantity != null && message.hasOwnProperty("quantity"))
                        if (!$util.isInteger(message.quantity))
                            return "quantity: integer expected";
                    if (message.specialInstructions != null && message.hasOwnProperty("specialInstructions"))
                        if (!$util.isString(message.specialInstructions))
                            return "specialInstructions: string expected";
                    return null;
                };

                /**
                 * Creates a ComboProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.MenuOrderProto.ComboProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.MenuOrderProto.ComboProto} ComboProto
                 */
                ComboProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.MenuOrderProto.ComboProto)
                        return object;
                    var message = new $root.waiternow.common.MenuOrderProto.ComboProto();
                    if (object.id != null)
                        message.id = String(object.id);
                    if (object.name != null) {
                        if (typeof object.name !== "object")
                            throw TypeError(".waiternow.common.MenuOrderProto.ComboProto.name: object expected");
                        message.name = $root.waiternow.common.TextProto.fromObject(object.name);
                    }
                    if (object.menuItems) {
                        if (!Array.isArray(object.menuItems))
                            throw TypeError(".waiternow.common.MenuOrderProto.ComboProto.menuItems: array expected");
                        message.menuItems = [];
                        for (var i = 0; i < object.menuItems.length; ++i) {
                            if (typeof object.menuItems[i] !== "object")
                                throw TypeError(".waiternow.common.MenuOrderProto.ComboProto.menuItems: object expected");
                            message.menuItems[i] = $root.waiternow.common.MenuOrderProto.MenuItemProto.fromObject(object.menuItems[i]);
                        }
                    }
                    if (object.menuItemSelections) {
                        if (!Array.isArray(object.menuItemSelections))
                            throw TypeError(".waiternow.common.MenuOrderProto.ComboProto.menuItemSelections: array expected");
                        message.menuItemSelections = [];
                        for (var i = 0; i < object.menuItemSelections.length; ++i) {
                            if (typeof object.menuItemSelections[i] !== "object")
                                throw TypeError(".waiternow.common.MenuOrderProto.ComboProto.menuItemSelections: object expected");
                            message.menuItemSelections[i] = $root.waiternow.common.MenuOrderProto.MenuItemSelectionProto.fromObject(object.menuItemSelections[i]);
                        }
                    }
                    if (object.itemSelections) {
                        if (!Array.isArray(object.itemSelections))
                            throw TypeError(".waiternow.common.MenuOrderProto.ComboProto.itemSelections: array expected");
                        message.itemSelections = [];
                        for (var i = 0; i < object.itemSelections.length; ++i) {
                            if (typeof object.itemSelections[i] !== "object")
                                throw TypeError(".waiternow.common.MenuOrderProto.ComboProto.itemSelections: object expected");
                            message.itemSelections[i] = $root.waiternow.common.MenuOrderProto.ItemSelectionProto.fromObject(object.itemSelections[i]);
                        }
                    }
                    if (object.price != null) {
                        if (typeof object.price !== "object")
                            throw TypeError(".waiternow.common.MenuOrderProto.ComboProto.price: object expected");
                        message.price = $root.waiternow.common.MoneyProto.fromObject(object.price);
                    }
                    if (object.quantity != null)
                        message.quantity = object.quantity | 0;
                    if (object.specialInstructions != null)
                        message.specialInstructions = String(object.specialInstructions);
                    return message;
                };

                /**
                 * Creates a plain object from a ComboProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.MenuOrderProto.ComboProto
                 * @static
                 * @param {waiternow.common.MenuOrderProto.ComboProto} message ComboProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ComboProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.menuItems = [];
                        object.itemSelections = [];
                        object.menuItemSelections = [];
                    }
                    if (options.defaults) {
                        object.name = null;
                        object.price = null;
                        object.quantity = 0;
                        object.specialInstructions = "";
                        object.id = "";
                    }
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = $root.waiternow.common.TextProto.toObject(message.name, options);
                    if (message.menuItems && message.menuItems.length) {
                        object.menuItems = [];
                        for (var j = 0; j < message.menuItems.length; ++j)
                            object.menuItems[j] = $root.waiternow.common.MenuOrderProto.MenuItemProto.toObject(message.menuItems[j], options);
                    }
                    if (message.itemSelections && message.itemSelections.length) {
                        object.itemSelections = [];
                        for (var j = 0; j < message.itemSelections.length; ++j)
                            object.itemSelections[j] = $root.waiternow.common.MenuOrderProto.ItemSelectionProto.toObject(message.itemSelections[j], options);
                    }
                    if (message.menuItemSelections && message.menuItemSelections.length) {
                        object.menuItemSelections = [];
                        for (var j = 0; j < message.menuItemSelections.length; ++j)
                            object.menuItemSelections[j] = $root.waiternow.common.MenuOrderProto.MenuItemSelectionProto.toObject(message.menuItemSelections[j], options);
                    }
                    if (message.price != null && message.hasOwnProperty("price"))
                        object.price = $root.waiternow.common.MoneyProto.toObject(message.price, options);
                    if (message.quantity != null && message.hasOwnProperty("quantity"))
                        object.quantity = message.quantity;
                    if (message.specialInstructions != null && message.hasOwnProperty("specialInstructions"))
                        object.specialInstructions = message.specialInstructions;
                    if (message.id != null && message.hasOwnProperty("id"))
                        object.id = message.id;
                    return object;
                };

                /**
                 * Converts this ComboProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.MenuOrderProto.ComboProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ComboProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ComboProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.MenuOrderProto.ComboProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ComboProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.MenuOrderProto.ComboProto";
                };

                return ComboProto;
            })();

            MenuOrderProto.MenuEntryProto = (function() {

                /**
                 * Properties of a MenuEntryProto.
                 * @memberof waiternow.common.MenuOrderProto
                 * @interface IMenuEntryProto
                 * @property {waiternow.common.MenuOrderProto.IMenuItemProto|null} [menuItem] MenuEntryProto menuItem
                 * @property {waiternow.common.MenuOrderProto.IComboProto|null} [combo] MenuEntryProto combo
                 */

                /**
                 * Constructs a new MenuEntryProto.
                 * @memberof waiternow.common.MenuOrderProto
                 * @classdesc Represents a MenuEntryProto.
                 * @implements IMenuEntryProto
                 * @constructor
                 * @param {waiternow.common.MenuOrderProto.IMenuEntryProto=} [properties] Properties to set
                 */
                function MenuEntryProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * MenuEntryProto menuItem.
                 * @member {waiternow.common.MenuOrderProto.IMenuItemProto|null|undefined} menuItem
                 * @memberof waiternow.common.MenuOrderProto.MenuEntryProto
                 * @instance
                 */
                MenuEntryProto.prototype.menuItem = null;

                /**
                 * MenuEntryProto combo.
                 * @member {waiternow.common.MenuOrderProto.IComboProto|null|undefined} combo
                 * @memberof waiternow.common.MenuOrderProto.MenuEntryProto
                 * @instance
                 */
                MenuEntryProto.prototype.combo = null;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * MenuEntryProto entryType.
                 * @member {"menuItem"|"combo"|undefined} entryType
                 * @memberof waiternow.common.MenuOrderProto.MenuEntryProto
                 * @instance
                 */
                Object.defineProperty(MenuEntryProto.prototype, "entryType", {
                    get: $util.oneOfGetter($oneOfFields = ["menuItem", "combo"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new MenuEntryProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.MenuOrderProto.MenuEntryProto
                 * @static
                 * @param {waiternow.common.MenuOrderProto.IMenuEntryProto=} [properties] Properties to set
                 * @returns {waiternow.common.MenuOrderProto.MenuEntryProto} MenuEntryProto instance
                 */
                MenuEntryProto.create = function create(properties) {
                    return new MenuEntryProto(properties);
                };

                /**
                 * Encodes the specified MenuEntryProto message. Does not implicitly {@link waiternow.common.MenuOrderProto.MenuEntryProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.MenuOrderProto.MenuEntryProto
                 * @static
                 * @param {waiternow.common.MenuOrderProto.IMenuEntryProto} message MenuEntryProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MenuEntryProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.menuItem != null && Object.hasOwnProperty.call(message, "menuItem"))
                        $root.waiternow.common.MenuOrderProto.MenuItemProto.encode(message.menuItem, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.combo != null && Object.hasOwnProperty.call(message, "combo"))
                        $root.waiternow.common.MenuOrderProto.ComboProto.encode(message.combo, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified MenuEntryProto message, length delimited. Does not implicitly {@link waiternow.common.MenuOrderProto.MenuEntryProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.MenuOrderProto.MenuEntryProto
                 * @static
                 * @param {waiternow.common.MenuOrderProto.IMenuEntryProto} message MenuEntryProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MenuEntryProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a MenuEntryProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.MenuOrderProto.MenuEntryProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.MenuOrderProto.MenuEntryProto} MenuEntryProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MenuEntryProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.MenuOrderProto.MenuEntryProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.menuItem = $root.waiternow.common.MenuOrderProto.MenuItemProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.combo = $root.waiternow.common.MenuOrderProto.ComboProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a MenuEntryProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.MenuOrderProto.MenuEntryProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.MenuOrderProto.MenuEntryProto} MenuEntryProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MenuEntryProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a MenuEntryProto message.
                 * @function verify
                 * @memberof waiternow.common.MenuOrderProto.MenuEntryProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                MenuEntryProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.menuItem != null && message.hasOwnProperty("menuItem")) {
                        properties.entryType = 1;
                        {
                            var error = $root.waiternow.common.MenuOrderProto.MenuItemProto.verify(message.menuItem);
                            if (error)
                                return "menuItem." + error;
                        }
                    }
                    if (message.combo != null && message.hasOwnProperty("combo")) {
                        if (properties.entryType === 1)
                            return "entryType: multiple values";
                        properties.entryType = 1;
                        {
                            var error = $root.waiternow.common.MenuOrderProto.ComboProto.verify(message.combo);
                            if (error)
                                return "combo." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a MenuEntryProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.MenuOrderProto.MenuEntryProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.MenuOrderProto.MenuEntryProto} MenuEntryProto
                 */
                MenuEntryProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.MenuOrderProto.MenuEntryProto)
                        return object;
                    var message = new $root.waiternow.common.MenuOrderProto.MenuEntryProto();
                    if (object.menuItem != null) {
                        if (typeof object.menuItem !== "object")
                            throw TypeError(".waiternow.common.MenuOrderProto.MenuEntryProto.menuItem: object expected");
                        message.menuItem = $root.waiternow.common.MenuOrderProto.MenuItemProto.fromObject(object.menuItem);
                    }
                    if (object.combo != null) {
                        if (typeof object.combo !== "object")
                            throw TypeError(".waiternow.common.MenuOrderProto.MenuEntryProto.combo: object expected");
                        message.combo = $root.waiternow.common.MenuOrderProto.ComboProto.fromObject(object.combo);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a MenuEntryProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.MenuOrderProto.MenuEntryProto
                 * @static
                 * @param {waiternow.common.MenuOrderProto.MenuEntryProto} message MenuEntryProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                MenuEntryProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (message.menuItem != null && message.hasOwnProperty("menuItem")) {
                        object.menuItem = $root.waiternow.common.MenuOrderProto.MenuItemProto.toObject(message.menuItem, options);
                        if (options.oneofs)
                            object.entryType = "menuItem";
                    }
                    if (message.combo != null && message.hasOwnProperty("combo")) {
                        object.combo = $root.waiternow.common.MenuOrderProto.ComboProto.toObject(message.combo, options);
                        if (options.oneofs)
                            object.entryType = "combo";
                    }
                    return object;
                };

                /**
                 * Converts this MenuEntryProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.MenuOrderProto.MenuEntryProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                MenuEntryProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for MenuEntryProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.MenuOrderProto.MenuEntryProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                MenuEntryProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.MenuOrderProto.MenuEntryProto";
                };

                return MenuEntryProto;
            })();

            return MenuOrderProto;
        })();

        common.MenuEntryAvailabilityProto = (function() {

            /**
             * Properties of a MenuEntryAvailabilityProto.
             * @memberof waiternow.common
             * @interface IMenuEntryAvailabilityProto
             * @property {string|null} [id] MenuEntryAvailabilityProto id
             * @property {waiternow.common.ITextProto|null} [name] MenuEntryAvailabilityProto name
             * @property {waiternow.common.MenuEntryAvailabilityProto.MenuEntryType|null} [menuEntryType] MenuEntryAvailabilityProto menuEntryType
             * @property {boolean|null} [isUnavailable] MenuEntryAvailabilityProto isUnavailable
             */

            /**
             * Constructs a new MenuEntryAvailabilityProto.
             * @memberof waiternow.common
             * @classdesc Represents a MenuEntryAvailabilityProto.
             * @implements IMenuEntryAvailabilityProto
             * @constructor
             * @param {waiternow.common.IMenuEntryAvailabilityProto=} [properties] Properties to set
             */
            function MenuEntryAvailabilityProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * MenuEntryAvailabilityProto id.
             * @member {string} id
             * @memberof waiternow.common.MenuEntryAvailabilityProto
             * @instance
             */
            MenuEntryAvailabilityProto.prototype.id = "";

            /**
             * MenuEntryAvailabilityProto name.
             * @member {waiternow.common.ITextProto|null|undefined} name
             * @memberof waiternow.common.MenuEntryAvailabilityProto
             * @instance
             */
            MenuEntryAvailabilityProto.prototype.name = null;

            /**
             * MenuEntryAvailabilityProto menuEntryType.
             * @member {waiternow.common.MenuEntryAvailabilityProto.MenuEntryType} menuEntryType
             * @memberof waiternow.common.MenuEntryAvailabilityProto
             * @instance
             */
            MenuEntryAvailabilityProto.prototype.menuEntryType = 0;

            /**
             * MenuEntryAvailabilityProto isUnavailable.
             * @member {boolean} isUnavailable
             * @memberof waiternow.common.MenuEntryAvailabilityProto
             * @instance
             */
            MenuEntryAvailabilityProto.prototype.isUnavailable = false;

            /**
             * Creates a new MenuEntryAvailabilityProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.MenuEntryAvailabilityProto
             * @static
             * @param {waiternow.common.IMenuEntryAvailabilityProto=} [properties] Properties to set
             * @returns {waiternow.common.MenuEntryAvailabilityProto} MenuEntryAvailabilityProto instance
             */
            MenuEntryAvailabilityProto.create = function create(properties) {
                return new MenuEntryAvailabilityProto(properties);
            };

            /**
             * Encodes the specified MenuEntryAvailabilityProto message. Does not implicitly {@link waiternow.common.MenuEntryAvailabilityProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.MenuEntryAvailabilityProto
             * @static
             * @param {waiternow.common.IMenuEntryAvailabilityProto} message MenuEntryAvailabilityProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MenuEntryAvailabilityProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    $root.waiternow.common.TextProto.encode(message.name, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.menuEntryType != null && Object.hasOwnProperty.call(message, "menuEntryType"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.menuEntryType);
                if (message.isUnavailable != null && Object.hasOwnProperty.call(message, "isUnavailable"))
                    writer.uint32(/* id 4, wireType 0 =*/32).bool(message.isUnavailable);
                return writer;
            };

            /**
             * Encodes the specified MenuEntryAvailabilityProto message, length delimited. Does not implicitly {@link waiternow.common.MenuEntryAvailabilityProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.MenuEntryAvailabilityProto
             * @static
             * @param {waiternow.common.IMenuEntryAvailabilityProto} message MenuEntryAvailabilityProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MenuEntryAvailabilityProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a MenuEntryAvailabilityProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.MenuEntryAvailabilityProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.MenuEntryAvailabilityProto} MenuEntryAvailabilityProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MenuEntryAvailabilityProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.MenuEntryAvailabilityProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.id = reader.string();
                            break;
                        }
                    case 2: {
                            message.name = $root.waiternow.common.TextProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 3: {
                            message.menuEntryType = reader.int32();
                            break;
                        }
                    case 4: {
                            message.isUnavailable = reader.bool();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a MenuEntryAvailabilityProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.MenuEntryAvailabilityProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.MenuEntryAvailabilityProto} MenuEntryAvailabilityProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MenuEntryAvailabilityProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a MenuEntryAvailabilityProto message.
             * @function verify
             * @memberof waiternow.common.MenuEntryAvailabilityProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            MenuEntryAvailabilityProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.id != null && message.hasOwnProperty("id"))
                    if (!$util.isString(message.id))
                        return "id: string expected";
                if (message.name != null && message.hasOwnProperty("name")) {
                    var error = $root.waiternow.common.TextProto.verify(message.name);
                    if (error)
                        return "name." + error;
                }
                if (message.menuEntryType != null && message.hasOwnProperty("menuEntryType"))
                    switch (message.menuEntryType) {
                    default:
                        return "menuEntryType: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                        break;
                    }
                if (message.isUnavailable != null && message.hasOwnProperty("isUnavailable"))
                    if (typeof message.isUnavailable !== "boolean")
                        return "isUnavailable: boolean expected";
                return null;
            };

            /**
             * Creates a MenuEntryAvailabilityProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.MenuEntryAvailabilityProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.MenuEntryAvailabilityProto} MenuEntryAvailabilityProto
             */
            MenuEntryAvailabilityProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.MenuEntryAvailabilityProto)
                    return object;
                var message = new $root.waiternow.common.MenuEntryAvailabilityProto();
                if (object.id != null)
                    message.id = String(object.id);
                if (object.name != null) {
                    if (typeof object.name !== "object")
                        throw TypeError(".waiternow.common.MenuEntryAvailabilityProto.name: object expected");
                    message.name = $root.waiternow.common.TextProto.fromObject(object.name);
                }
                switch (object.menuEntryType) {
                default:
                    if (typeof object.menuEntryType === "number") {
                        message.menuEntryType = object.menuEntryType;
                        break;
                    }
                    break;
                case "MENU_ENTRY_TYPE_UNSPECIFIED":
                case 0:
                    message.menuEntryType = 0;
                    break;
                case "MENU_ITEM":
                case 1:
                    message.menuEntryType = 1;
                    break;
                case "COMBO":
                case 2:
                    message.menuEntryType = 2;
                    break;
                }
                if (object.isUnavailable != null)
                    message.isUnavailable = Boolean(object.isUnavailable);
                return message;
            };

            /**
             * Creates a plain object from a MenuEntryAvailabilityProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.MenuEntryAvailabilityProto
             * @static
             * @param {waiternow.common.MenuEntryAvailabilityProto} message MenuEntryAvailabilityProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            MenuEntryAvailabilityProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.id = "";
                    object.name = null;
                    object.menuEntryType = options.enums === String ? "MENU_ENTRY_TYPE_UNSPECIFIED" : 0;
                    object.isUnavailable = false;
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = $root.waiternow.common.TextProto.toObject(message.name, options);
                if (message.menuEntryType != null && message.hasOwnProperty("menuEntryType"))
                    object.menuEntryType = options.enums === String ? $root.waiternow.common.MenuEntryAvailabilityProto.MenuEntryType[message.menuEntryType] === undefined ? message.menuEntryType : $root.waiternow.common.MenuEntryAvailabilityProto.MenuEntryType[message.menuEntryType] : message.menuEntryType;
                if (message.isUnavailable != null && message.hasOwnProperty("isUnavailable"))
                    object.isUnavailable = message.isUnavailable;
                return object;
            };

            /**
             * Converts this MenuEntryAvailabilityProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.MenuEntryAvailabilityProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            MenuEntryAvailabilityProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for MenuEntryAvailabilityProto
             * @function getTypeUrl
             * @memberof waiternow.common.MenuEntryAvailabilityProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            MenuEntryAvailabilityProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.MenuEntryAvailabilityProto";
            };

            /**
             * MenuEntryType enum.
             * @name waiternow.common.MenuEntryAvailabilityProto.MenuEntryType
             * @enum {number}
             * @property {number} MENU_ENTRY_TYPE_UNSPECIFIED=0 MENU_ENTRY_TYPE_UNSPECIFIED value
             * @property {number} MENU_ITEM=1 MENU_ITEM value
             * @property {number} COMBO=2 COMBO value
             */
            MenuEntryAvailabilityProto.MenuEntryType = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "MENU_ENTRY_TYPE_UNSPECIFIED"] = 0;
                values[valuesById[1] = "MENU_ITEM"] = 1;
                values[valuesById[2] = "COMBO"] = 2;
                return values;
            })();

            return MenuEntryAvailabilityProto;
        })();

        common.ItemAvailabilityProto = (function() {

            /**
             * Properties of an ItemAvailabilityProto.
             * @memberof waiternow.common
             * @interface IItemAvailabilityProto
             * @property {string|null} [id] ItemAvailabilityProto id
             * @property {waiternow.common.ITextProto|null} [name] ItemAvailabilityProto name
             * @property {waiternow.common.IMoneyProto|null} [price] ItemAvailabilityProto price
             * @property {boolean|null} [isUnavailable] ItemAvailabilityProto isUnavailable
             */

            /**
             * Constructs a new ItemAvailabilityProto.
             * @memberof waiternow.common
             * @classdesc Represents an ItemAvailabilityProto.
             * @implements IItemAvailabilityProto
             * @constructor
             * @param {waiternow.common.IItemAvailabilityProto=} [properties] Properties to set
             */
            function ItemAvailabilityProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ItemAvailabilityProto id.
             * @member {string} id
             * @memberof waiternow.common.ItemAvailabilityProto
             * @instance
             */
            ItemAvailabilityProto.prototype.id = "";

            /**
             * ItemAvailabilityProto name.
             * @member {waiternow.common.ITextProto|null|undefined} name
             * @memberof waiternow.common.ItemAvailabilityProto
             * @instance
             */
            ItemAvailabilityProto.prototype.name = null;

            /**
             * ItemAvailabilityProto price.
             * @member {waiternow.common.IMoneyProto|null|undefined} price
             * @memberof waiternow.common.ItemAvailabilityProto
             * @instance
             */
            ItemAvailabilityProto.prototype.price = null;

            /**
             * ItemAvailabilityProto isUnavailable.
             * @member {boolean} isUnavailable
             * @memberof waiternow.common.ItemAvailabilityProto
             * @instance
             */
            ItemAvailabilityProto.prototype.isUnavailable = false;

            /**
             * Creates a new ItemAvailabilityProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.ItemAvailabilityProto
             * @static
             * @param {waiternow.common.IItemAvailabilityProto=} [properties] Properties to set
             * @returns {waiternow.common.ItemAvailabilityProto} ItemAvailabilityProto instance
             */
            ItemAvailabilityProto.create = function create(properties) {
                return new ItemAvailabilityProto(properties);
            };

            /**
             * Encodes the specified ItemAvailabilityProto message. Does not implicitly {@link waiternow.common.ItemAvailabilityProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.ItemAvailabilityProto
             * @static
             * @param {waiternow.common.IItemAvailabilityProto} message ItemAvailabilityProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ItemAvailabilityProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    $root.waiternow.common.TextProto.encode(message.name, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.price != null && Object.hasOwnProperty.call(message, "price"))
                    $root.waiternow.common.MoneyProto.encode(message.price, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.isUnavailable != null && Object.hasOwnProperty.call(message, "isUnavailable"))
                    writer.uint32(/* id 4, wireType 0 =*/32).bool(message.isUnavailable);
                return writer;
            };

            /**
             * Encodes the specified ItemAvailabilityProto message, length delimited. Does not implicitly {@link waiternow.common.ItemAvailabilityProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.ItemAvailabilityProto
             * @static
             * @param {waiternow.common.IItemAvailabilityProto} message ItemAvailabilityProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ItemAvailabilityProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an ItemAvailabilityProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.ItemAvailabilityProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.ItemAvailabilityProto} ItemAvailabilityProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ItemAvailabilityProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.ItemAvailabilityProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.id = reader.string();
                            break;
                        }
                    case 2: {
                            message.name = $root.waiternow.common.TextProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 3: {
                            message.price = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 4: {
                            message.isUnavailable = reader.bool();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an ItemAvailabilityProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.ItemAvailabilityProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.ItemAvailabilityProto} ItemAvailabilityProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ItemAvailabilityProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an ItemAvailabilityProto message.
             * @function verify
             * @memberof waiternow.common.ItemAvailabilityProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ItemAvailabilityProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.id != null && message.hasOwnProperty("id"))
                    if (!$util.isString(message.id))
                        return "id: string expected";
                if (message.name != null && message.hasOwnProperty("name")) {
                    var error = $root.waiternow.common.TextProto.verify(message.name);
                    if (error)
                        return "name." + error;
                }
                if (message.price != null && message.hasOwnProperty("price")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.price);
                    if (error)
                        return "price." + error;
                }
                if (message.isUnavailable != null && message.hasOwnProperty("isUnavailable"))
                    if (typeof message.isUnavailable !== "boolean")
                        return "isUnavailable: boolean expected";
                return null;
            };

            /**
             * Creates an ItemAvailabilityProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.ItemAvailabilityProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.ItemAvailabilityProto} ItemAvailabilityProto
             */
            ItemAvailabilityProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.ItemAvailabilityProto)
                    return object;
                var message = new $root.waiternow.common.ItemAvailabilityProto();
                if (object.id != null)
                    message.id = String(object.id);
                if (object.name != null) {
                    if (typeof object.name !== "object")
                        throw TypeError(".waiternow.common.ItemAvailabilityProto.name: object expected");
                    message.name = $root.waiternow.common.TextProto.fromObject(object.name);
                }
                if (object.price != null) {
                    if (typeof object.price !== "object")
                        throw TypeError(".waiternow.common.ItemAvailabilityProto.price: object expected");
                    message.price = $root.waiternow.common.MoneyProto.fromObject(object.price);
                }
                if (object.isUnavailable != null)
                    message.isUnavailable = Boolean(object.isUnavailable);
                return message;
            };

            /**
             * Creates a plain object from an ItemAvailabilityProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.ItemAvailabilityProto
             * @static
             * @param {waiternow.common.ItemAvailabilityProto} message ItemAvailabilityProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ItemAvailabilityProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.id = "";
                    object.name = null;
                    object.price = null;
                    object.isUnavailable = false;
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = $root.waiternow.common.TextProto.toObject(message.name, options);
                if (message.price != null && message.hasOwnProperty("price"))
                    object.price = $root.waiternow.common.MoneyProto.toObject(message.price, options);
                if (message.isUnavailable != null && message.hasOwnProperty("isUnavailable"))
                    object.isUnavailable = message.isUnavailable;
                return object;
            };

            /**
             * Converts this ItemAvailabilityProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.ItemAvailabilityProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ItemAvailabilityProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for ItemAvailabilityProto
             * @function getTypeUrl
             * @memberof waiternow.common.ItemAvailabilityProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            ItemAvailabilityProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.ItemAvailabilityProto";
            };

            return ItemAvailabilityProto;
        })();

        common.MenuAvailabilityProto = (function() {

            /**
             * Properties of a MenuAvailabilityProto.
             * @memberof waiternow.common
             * @interface IMenuAvailabilityProto
             * @property {string|null} [locationId] MenuAvailabilityProto locationId
             * @property {Array.<string>|null} [unavailableItemsIds] MenuAvailabilityProto unavailableItemsIds
             * @property {Array.<string>|null} [unavailableMenuItemsIds] MenuAvailabilityProto unavailableMenuItemsIds
             * @property {Array.<string>|null} [unavailableCombosIds] MenuAvailabilityProto unavailableCombosIds
             */

            /**
             * Constructs a new MenuAvailabilityProto.
             * @memberof waiternow.common
             * @classdesc Represents a MenuAvailabilityProto.
             * @implements IMenuAvailabilityProto
             * @constructor
             * @param {waiternow.common.IMenuAvailabilityProto=} [properties] Properties to set
             */
            function MenuAvailabilityProto(properties) {
                this.unavailableItemsIds = [];
                this.unavailableMenuItemsIds = [];
                this.unavailableCombosIds = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * MenuAvailabilityProto locationId.
             * @member {string} locationId
             * @memberof waiternow.common.MenuAvailabilityProto
             * @instance
             */
            MenuAvailabilityProto.prototype.locationId = "";

            /**
             * MenuAvailabilityProto unavailableItemsIds.
             * @member {Array.<string>} unavailableItemsIds
             * @memberof waiternow.common.MenuAvailabilityProto
             * @instance
             */
            MenuAvailabilityProto.prototype.unavailableItemsIds = $util.emptyArray;

            /**
             * MenuAvailabilityProto unavailableMenuItemsIds.
             * @member {Array.<string>} unavailableMenuItemsIds
             * @memberof waiternow.common.MenuAvailabilityProto
             * @instance
             */
            MenuAvailabilityProto.prototype.unavailableMenuItemsIds = $util.emptyArray;

            /**
             * MenuAvailabilityProto unavailableCombosIds.
             * @member {Array.<string>} unavailableCombosIds
             * @memberof waiternow.common.MenuAvailabilityProto
             * @instance
             */
            MenuAvailabilityProto.prototype.unavailableCombosIds = $util.emptyArray;

            /**
             * Creates a new MenuAvailabilityProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.MenuAvailabilityProto
             * @static
             * @param {waiternow.common.IMenuAvailabilityProto=} [properties] Properties to set
             * @returns {waiternow.common.MenuAvailabilityProto} MenuAvailabilityProto instance
             */
            MenuAvailabilityProto.create = function create(properties) {
                return new MenuAvailabilityProto(properties);
            };

            /**
             * Encodes the specified MenuAvailabilityProto message. Does not implicitly {@link waiternow.common.MenuAvailabilityProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.MenuAvailabilityProto
             * @static
             * @param {waiternow.common.IMenuAvailabilityProto} message MenuAvailabilityProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MenuAvailabilityProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                if (message.unavailableItemsIds != null && message.unavailableItemsIds.length)
                    for (var i = 0; i < message.unavailableItemsIds.length; ++i)
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.unavailableItemsIds[i]);
                if (message.unavailableMenuItemsIds != null && message.unavailableMenuItemsIds.length)
                    for (var i = 0; i < message.unavailableMenuItemsIds.length; ++i)
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.unavailableMenuItemsIds[i]);
                if (message.unavailableCombosIds != null && message.unavailableCombosIds.length)
                    for (var i = 0; i < message.unavailableCombosIds.length; ++i)
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.unavailableCombosIds[i]);
                return writer;
            };

            /**
             * Encodes the specified MenuAvailabilityProto message, length delimited. Does not implicitly {@link waiternow.common.MenuAvailabilityProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.MenuAvailabilityProto
             * @static
             * @param {waiternow.common.IMenuAvailabilityProto} message MenuAvailabilityProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MenuAvailabilityProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a MenuAvailabilityProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.MenuAvailabilityProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.MenuAvailabilityProto} MenuAvailabilityProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MenuAvailabilityProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.MenuAvailabilityProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.locationId = reader.string();
                            break;
                        }
                    case 2: {
                            if (!(message.unavailableItemsIds && message.unavailableItemsIds.length))
                                message.unavailableItemsIds = [];
                            message.unavailableItemsIds.push(reader.string());
                            break;
                        }
                    case 3: {
                            if (!(message.unavailableMenuItemsIds && message.unavailableMenuItemsIds.length))
                                message.unavailableMenuItemsIds = [];
                            message.unavailableMenuItemsIds.push(reader.string());
                            break;
                        }
                    case 4: {
                            if (!(message.unavailableCombosIds && message.unavailableCombosIds.length))
                                message.unavailableCombosIds = [];
                            message.unavailableCombosIds.push(reader.string());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a MenuAvailabilityProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.MenuAvailabilityProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.MenuAvailabilityProto} MenuAvailabilityProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MenuAvailabilityProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a MenuAvailabilityProto message.
             * @function verify
             * @memberof waiternow.common.MenuAvailabilityProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            MenuAvailabilityProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.locationId != null && message.hasOwnProperty("locationId"))
                    if (!$util.isString(message.locationId))
                        return "locationId: string expected";
                if (message.unavailableItemsIds != null && message.hasOwnProperty("unavailableItemsIds")) {
                    if (!Array.isArray(message.unavailableItemsIds))
                        return "unavailableItemsIds: array expected";
                    for (var i = 0; i < message.unavailableItemsIds.length; ++i)
                        if (!$util.isString(message.unavailableItemsIds[i]))
                            return "unavailableItemsIds: string[] expected";
                }
                if (message.unavailableMenuItemsIds != null && message.hasOwnProperty("unavailableMenuItemsIds")) {
                    if (!Array.isArray(message.unavailableMenuItemsIds))
                        return "unavailableMenuItemsIds: array expected";
                    for (var i = 0; i < message.unavailableMenuItemsIds.length; ++i)
                        if (!$util.isString(message.unavailableMenuItemsIds[i]))
                            return "unavailableMenuItemsIds: string[] expected";
                }
                if (message.unavailableCombosIds != null && message.hasOwnProperty("unavailableCombosIds")) {
                    if (!Array.isArray(message.unavailableCombosIds))
                        return "unavailableCombosIds: array expected";
                    for (var i = 0; i < message.unavailableCombosIds.length; ++i)
                        if (!$util.isString(message.unavailableCombosIds[i]))
                            return "unavailableCombosIds: string[] expected";
                }
                return null;
            };

            /**
             * Creates a MenuAvailabilityProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.MenuAvailabilityProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.MenuAvailabilityProto} MenuAvailabilityProto
             */
            MenuAvailabilityProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.MenuAvailabilityProto)
                    return object;
                var message = new $root.waiternow.common.MenuAvailabilityProto();
                if (object.locationId != null)
                    message.locationId = String(object.locationId);
                if (object.unavailableItemsIds) {
                    if (!Array.isArray(object.unavailableItemsIds))
                        throw TypeError(".waiternow.common.MenuAvailabilityProto.unavailableItemsIds: array expected");
                    message.unavailableItemsIds = [];
                    for (var i = 0; i < object.unavailableItemsIds.length; ++i)
                        message.unavailableItemsIds[i] = String(object.unavailableItemsIds[i]);
                }
                if (object.unavailableMenuItemsIds) {
                    if (!Array.isArray(object.unavailableMenuItemsIds))
                        throw TypeError(".waiternow.common.MenuAvailabilityProto.unavailableMenuItemsIds: array expected");
                    message.unavailableMenuItemsIds = [];
                    for (var i = 0; i < object.unavailableMenuItemsIds.length; ++i)
                        message.unavailableMenuItemsIds[i] = String(object.unavailableMenuItemsIds[i]);
                }
                if (object.unavailableCombosIds) {
                    if (!Array.isArray(object.unavailableCombosIds))
                        throw TypeError(".waiternow.common.MenuAvailabilityProto.unavailableCombosIds: array expected");
                    message.unavailableCombosIds = [];
                    for (var i = 0; i < object.unavailableCombosIds.length; ++i)
                        message.unavailableCombosIds[i] = String(object.unavailableCombosIds[i]);
                }
                return message;
            };

            /**
             * Creates a plain object from a MenuAvailabilityProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.MenuAvailabilityProto
             * @static
             * @param {waiternow.common.MenuAvailabilityProto} message MenuAvailabilityProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            MenuAvailabilityProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults) {
                    object.unavailableItemsIds = [];
                    object.unavailableMenuItemsIds = [];
                    object.unavailableCombosIds = [];
                }
                if (options.defaults)
                    object.locationId = "";
                if (message.locationId != null && message.hasOwnProperty("locationId"))
                    object.locationId = message.locationId;
                if (message.unavailableItemsIds && message.unavailableItemsIds.length) {
                    object.unavailableItemsIds = [];
                    for (var j = 0; j < message.unavailableItemsIds.length; ++j)
                        object.unavailableItemsIds[j] = message.unavailableItemsIds[j];
                }
                if (message.unavailableMenuItemsIds && message.unavailableMenuItemsIds.length) {
                    object.unavailableMenuItemsIds = [];
                    for (var j = 0; j < message.unavailableMenuItemsIds.length; ++j)
                        object.unavailableMenuItemsIds[j] = message.unavailableMenuItemsIds[j];
                }
                if (message.unavailableCombosIds && message.unavailableCombosIds.length) {
                    object.unavailableCombosIds = [];
                    for (var j = 0; j < message.unavailableCombosIds.length; ++j)
                        object.unavailableCombosIds[j] = message.unavailableCombosIds[j];
                }
                return object;
            };

            /**
             * Converts this MenuAvailabilityProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.MenuAvailabilityProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            MenuAvailabilityProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for MenuAvailabilityProto
             * @function getTypeUrl
             * @memberof waiternow.common.MenuAvailabilityProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            MenuAvailabilityProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.MenuAvailabilityProto";
            };

            return MenuAvailabilityProto;
        })();

        common.DailyRecurrenceProto = (function() {

            /**
             * Properties of a DailyRecurrenceProto.
             * @memberof waiternow.common
             * @interface IDailyRecurrenceProto
             * @property {waiternow.common.DailyRecurrenceProto.RecurrenceType|null} [recurrenceType] DailyRecurrenceProto recurrenceType
             * @property {waiternow.common.ITimeRangeProto|null} [timeRange] DailyRecurrenceProto timeRange
             */

            /**
             * Constructs a new DailyRecurrenceProto.
             * @memberof waiternow.common
             * @classdesc Represents a DailyRecurrenceProto.
             * @implements IDailyRecurrenceProto
             * @constructor
             * @param {waiternow.common.IDailyRecurrenceProto=} [properties] Properties to set
             */
            function DailyRecurrenceProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * DailyRecurrenceProto recurrenceType.
             * @member {waiternow.common.DailyRecurrenceProto.RecurrenceType} recurrenceType
             * @memberof waiternow.common.DailyRecurrenceProto
             * @instance
             */
            DailyRecurrenceProto.prototype.recurrenceType = 0;

            /**
             * DailyRecurrenceProto timeRange.
             * @member {waiternow.common.ITimeRangeProto|null|undefined} timeRange
             * @memberof waiternow.common.DailyRecurrenceProto
             * @instance
             */
            DailyRecurrenceProto.prototype.timeRange = null;

            /**
             * Creates a new DailyRecurrenceProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.DailyRecurrenceProto
             * @static
             * @param {waiternow.common.IDailyRecurrenceProto=} [properties] Properties to set
             * @returns {waiternow.common.DailyRecurrenceProto} DailyRecurrenceProto instance
             */
            DailyRecurrenceProto.create = function create(properties) {
                return new DailyRecurrenceProto(properties);
            };

            /**
             * Encodes the specified DailyRecurrenceProto message. Does not implicitly {@link waiternow.common.DailyRecurrenceProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.DailyRecurrenceProto
             * @static
             * @param {waiternow.common.IDailyRecurrenceProto} message DailyRecurrenceProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DailyRecurrenceProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.recurrenceType != null && Object.hasOwnProperty.call(message, "recurrenceType"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.recurrenceType);
                if (message.timeRange != null && Object.hasOwnProperty.call(message, "timeRange"))
                    $root.waiternow.common.TimeRangeProto.encode(message.timeRange, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified DailyRecurrenceProto message, length delimited. Does not implicitly {@link waiternow.common.DailyRecurrenceProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.DailyRecurrenceProto
             * @static
             * @param {waiternow.common.IDailyRecurrenceProto} message DailyRecurrenceProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DailyRecurrenceProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a DailyRecurrenceProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.DailyRecurrenceProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.DailyRecurrenceProto} DailyRecurrenceProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DailyRecurrenceProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.DailyRecurrenceProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.recurrenceType = reader.int32();
                            break;
                        }
                    case 2: {
                            message.timeRange = $root.waiternow.common.TimeRangeProto.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a DailyRecurrenceProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.DailyRecurrenceProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.DailyRecurrenceProto} DailyRecurrenceProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DailyRecurrenceProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a DailyRecurrenceProto message.
             * @function verify
             * @memberof waiternow.common.DailyRecurrenceProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            DailyRecurrenceProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.recurrenceType != null && message.hasOwnProperty("recurrenceType"))
                    switch (message.recurrenceType) {
                    default:
                        return "recurrenceType: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                    case 9:
                    case 10:
                    case 11:
                    case 12:
                    case 13:
                    case 14:
                    case 15:
                    case 16:
                    case 17:
                    case 18:
                    case 19:
                    case 20:
                    case 21:
                    case 22:
                    case 23:
                    case 24:
                    case 25:
                    case 26:
                    case 27:
                    case 28:
                    case 29:
                    case 30:
                    case 31:
                    case 32:
                    case 33:
                    case 34:
                    case 35:
                    case 36:
                    case 37:
                    case 38:
                        break;
                    }
                if (message.timeRange != null && message.hasOwnProperty("timeRange")) {
                    var error = $root.waiternow.common.TimeRangeProto.verify(message.timeRange);
                    if (error)
                        return "timeRange." + error;
                }
                return null;
            };

            /**
             * Creates a DailyRecurrenceProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.DailyRecurrenceProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.DailyRecurrenceProto} DailyRecurrenceProto
             */
            DailyRecurrenceProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.DailyRecurrenceProto)
                    return object;
                var message = new $root.waiternow.common.DailyRecurrenceProto();
                switch (object.recurrenceType) {
                default:
                    if (typeof object.recurrenceType === "number") {
                        message.recurrenceType = object.recurrenceType;
                        break;
                    }
                    break;
                case "RECURRENCE_TYPE_UNSPECIFIED":
                case 0:
                    message.recurrenceType = 0;
                    break;
                case "DAILY":
                case 1:
                    message.recurrenceType = 1;
                    break;
                case "WEEKDAYS":
                case 2:
                    message.recurrenceType = 2;
                    break;
                case "WEEKENDS":
                case 3:
                    message.recurrenceType = 3;
                    break;
                case "WEEKLY_ON_SUNDAY":
                case 4:
                    message.recurrenceType = 4;
                    break;
                case "WEEKLY_ON_MONDAY":
                case 5:
                    message.recurrenceType = 5;
                    break;
                case "WEEKLY_ON_TUESDAY":
                case 6:
                    message.recurrenceType = 6;
                    break;
                case "WEEKLY_ON_WEDNESDAY":
                case 7:
                    message.recurrenceType = 7;
                    break;
                case "WEEKLY_ON_THURSDAY":
                case 8:
                    message.recurrenceType = 8;
                    break;
                case "WEEKLY_ON_FRIDAY":
                case 9:
                    message.recurrenceType = 9;
                    break;
                case "WEEKLY_ON_SATURDAY":
                case 10:
                    message.recurrenceType = 10;
                    break;
                case "MONTHLY_ON_FIRST_SUNDAY":
                case 11:
                    message.recurrenceType = 11;
                    break;
                case "MONTHLY_ON_FIRST_MONDAY":
                case 12:
                    message.recurrenceType = 12;
                    break;
                case "MONTHLY_ON_FIRST_TUESDAY":
                case 13:
                    message.recurrenceType = 13;
                    break;
                case "MONTHLY_ON_FIRST_WEDNESDAY":
                case 14:
                    message.recurrenceType = 14;
                    break;
                case "MONTHLY_ON_FIRST_THURSDAY":
                case 15:
                    message.recurrenceType = 15;
                    break;
                case "MONTHLY_ON_FIRST_FRIDAY":
                case 16:
                    message.recurrenceType = 16;
                    break;
                case "MONTHLY_ON_FIRST_SATURDAY":
                case 17:
                    message.recurrenceType = 17;
                    break;
                case "MONTHLY_ON_SECOND_SUNDAY":
                case 18:
                    message.recurrenceType = 18;
                    break;
                case "MONTHLY_ON_SECOND_MONDAY":
                case 19:
                    message.recurrenceType = 19;
                    break;
                case "MONTHLY_ON_SECOND_TUESDAY":
                case 20:
                    message.recurrenceType = 20;
                    break;
                case "MONTHLY_ON_SECOND_WEDNESDAY":
                case 21:
                    message.recurrenceType = 21;
                    break;
                case "MONTHLY_ON_SECOND_THURSDAY":
                case 22:
                    message.recurrenceType = 22;
                    break;
                case "MONTHLY_ON_SECOND_FRIDAY":
                case 23:
                    message.recurrenceType = 23;
                    break;
                case "MONTHLY_ON_SECOND_SATURDAY":
                case 24:
                    message.recurrenceType = 24;
                    break;
                case "MONTHLY_ON_THIRD_SUNDAY":
                case 25:
                    message.recurrenceType = 25;
                    break;
                case "MONTHLY_ON_THIRD_MONDAY":
                case 26:
                    message.recurrenceType = 26;
                    break;
                case "MONTHLY_ON_THIRD_TUESDAY":
                case 27:
                    message.recurrenceType = 27;
                    break;
                case "MONTHLY_ON_THIRD_WEDNESDAY":
                case 28:
                    message.recurrenceType = 28;
                    break;
                case "MONTHLY_ON_THIRD_THURSDAY":
                case 29:
                    message.recurrenceType = 29;
                    break;
                case "MONTHLY_ON_THIRD_FRIDAY":
                case 30:
                    message.recurrenceType = 30;
                    break;
                case "MONTHLY_ON_THIRD_SATURDAY":
                case 31:
                    message.recurrenceType = 31;
                    break;
                case "MONTHLY_ON_LAST_SUNDAY":
                case 32:
                    message.recurrenceType = 32;
                    break;
                case "MONTHLY_ON_LAST_MONDAY":
                case 33:
                    message.recurrenceType = 33;
                    break;
                case "MONTHLY_ON_LAST_TUESDAY":
                case 34:
                    message.recurrenceType = 34;
                    break;
                case "MONTHLY_ON_LAST_WEDNESDAY":
                case 35:
                    message.recurrenceType = 35;
                    break;
                case "MONTHLY_ON_LAST_THURSDAY":
                case 36:
                    message.recurrenceType = 36;
                    break;
                case "MONTHLY_ON_LAST_FRIDAY":
                case 37:
                    message.recurrenceType = 37;
                    break;
                case "MONTHLY_ON_LAST_SATURDAY":
                case 38:
                    message.recurrenceType = 38;
                    break;
                }
                if (object.timeRange != null) {
                    if (typeof object.timeRange !== "object")
                        throw TypeError(".waiternow.common.DailyRecurrenceProto.timeRange: object expected");
                    message.timeRange = $root.waiternow.common.TimeRangeProto.fromObject(object.timeRange);
                }
                return message;
            };

            /**
             * Creates a plain object from a DailyRecurrenceProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.DailyRecurrenceProto
             * @static
             * @param {waiternow.common.DailyRecurrenceProto} message DailyRecurrenceProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            DailyRecurrenceProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.recurrenceType = options.enums === String ? "RECURRENCE_TYPE_UNSPECIFIED" : 0;
                    object.timeRange = null;
                }
                if (message.recurrenceType != null && message.hasOwnProperty("recurrenceType"))
                    object.recurrenceType = options.enums === String ? $root.waiternow.common.DailyRecurrenceProto.RecurrenceType[message.recurrenceType] === undefined ? message.recurrenceType : $root.waiternow.common.DailyRecurrenceProto.RecurrenceType[message.recurrenceType] : message.recurrenceType;
                if (message.timeRange != null && message.hasOwnProperty("timeRange"))
                    object.timeRange = $root.waiternow.common.TimeRangeProto.toObject(message.timeRange, options);
                return object;
            };

            /**
             * Converts this DailyRecurrenceProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.DailyRecurrenceProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            DailyRecurrenceProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for DailyRecurrenceProto
             * @function getTypeUrl
             * @memberof waiternow.common.DailyRecurrenceProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            DailyRecurrenceProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.DailyRecurrenceProto";
            };

            /**
             * RecurrenceType enum.
             * @name waiternow.common.DailyRecurrenceProto.RecurrenceType
             * @enum {number}
             * @property {number} RECURRENCE_TYPE_UNSPECIFIED=0 RECURRENCE_TYPE_UNSPECIFIED value
             * @property {number} DAILY=1 DAILY value
             * @property {number} WEEKDAYS=2 WEEKDAYS value
             * @property {number} WEEKENDS=3 WEEKENDS value
             * @property {number} WEEKLY_ON_SUNDAY=4 WEEKLY_ON_SUNDAY value
             * @property {number} WEEKLY_ON_MONDAY=5 WEEKLY_ON_MONDAY value
             * @property {number} WEEKLY_ON_TUESDAY=6 WEEKLY_ON_TUESDAY value
             * @property {number} WEEKLY_ON_WEDNESDAY=7 WEEKLY_ON_WEDNESDAY value
             * @property {number} WEEKLY_ON_THURSDAY=8 WEEKLY_ON_THURSDAY value
             * @property {number} WEEKLY_ON_FRIDAY=9 WEEKLY_ON_FRIDAY value
             * @property {number} WEEKLY_ON_SATURDAY=10 WEEKLY_ON_SATURDAY value
             * @property {number} MONTHLY_ON_FIRST_SUNDAY=11 MONTHLY_ON_FIRST_SUNDAY value
             * @property {number} MONTHLY_ON_FIRST_MONDAY=12 MONTHLY_ON_FIRST_MONDAY value
             * @property {number} MONTHLY_ON_FIRST_TUESDAY=13 MONTHLY_ON_FIRST_TUESDAY value
             * @property {number} MONTHLY_ON_FIRST_WEDNESDAY=14 MONTHLY_ON_FIRST_WEDNESDAY value
             * @property {number} MONTHLY_ON_FIRST_THURSDAY=15 MONTHLY_ON_FIRST_THURSDAY value
             * @property {number} MONTHLY_ON_FIRST_FRIDAY=16 MONTHLY_ON_FIRST_FRIDAY value
             * @property {number} MONTHLY_ON_FIRST_SATURDAY=17 MONTHLY_ON_FIRST_SATURDAY value
             * @property {number} MONTHLY_ON_SECOND_SUNDAY=18 MONTHLY_ON_SECOND_SUNDAY value
             * @property {number} MONTHLY_ON_SECOND_MONDAY=19 MONTHLY_ON_SECOND_MONDAY value
             * @property {number} MONTHLY_ON_SECOND_TUESDAY=20 MONTHLY_ON_SECOND_TUESDAY value
             * @property {number} MONTHLY_ON_SECOND_WEDNESDAY=21 MONTHLY_ON_SECOND_WEDNESDAY value
             * @property {number} MONTHLY_ON_SECOND_THURSDAY=22 MONTHLY_ON_SECOND_THURSDAY value
             * @property {number} MONTHLY_ON_SECOND_FRIDAY=23 MONTHLY_ON_SECOND_FRIDAY value
             * @property {number} MONTHLY_ON_SECOND_SATURDAY=24 MONTHLY_ON_SECOND_SATURDAY value
             * @property {number} MONTHLY_ON_THIRD_SUNDAY=25 MONTHLY_ON_THIRD_SUNDAY value
             * @property {number} MONTHLY_ON_THIRD_MONDAY=26 MONTHLY_ON_THIRD_MONDAY value
             * @property {number} MONTHLY_ON_THIRD_TUESDAY=27 MONTHLY_ON_THIRD_TUESDAY value
             * @property {number} MONTHLY_ON_THIRD_WEDNESDAY=28 MONTHLY_ON_THIRD_WEDNESDAY value
             * @property {number} MONTHLY_ON_THIRD_THURSDAY=29 MONTHLY_ON_THIRD_THURSDAY value
             * @property {number} MONTHLY_ON_THIRD_FRIDAY=30 MONTHLY_ON_THIRD_FRIDAY value
             * @property {number} MONTHLY_ON_THIRD_SATURDAY=31 MONTHLY_ON_THIRD_SATURDAY value
             * @property {number} MONTHLY_ON_LAST_SUNDAY=32 MONTHLY_ON_LAST_SUNDAY value
             * @property {number} MONTHLY_ON_LAST_MONDAY=33 MONTHLY_ON_LAST_MONDAY value
             * @property {number} MONTHLY_ON_LAST_TUESDAY=34 MONTHLY_ON_LAST_TUESDAY value
             * @property {number} MONTHLY_ON_LAST_WEDNESDAY=35 MONTHLY_ON_LAST_WEDNESDAY value
             * @property {number} MONTHLY_ON_LAST_THURSDAY=36 MONTHLY_ON_LAST_THURSDAY value
             * @property {number} MONTHLY_ON_LAST_FRIDAY=37 MONTHLY_ON_LAST_FRIDAY value
             * @property {number} MONTHLY_ON_LAST_SATURDAY=38 MONTHLY_ON_LAST_SATURDAY value
             */
            DailyRecurrenceProto.RecurrenceType = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "RECURRENCE_TYPE_UNSPECIFIED"] = 0;
                values[valuesById[1] = "DAILY"] = 1;
                values[valuesById[2] = "WEEKDAYS"] = 2;
                values[valuesById[3] = "WEEKENDS"] = 3;
                values[valuesById[4] = "WEEKLY_ON_SUNDAY"] = 4;
                values[valuesById[5] = "WEEKLY_ON_MONDAY"] = 5;
                values[valuesById[6] = "WEEKLY_ON_TUESDAY"] = 6;
                values[valuesById[7] = "WEEKLY_ON_WEDNESDAY"] = 7;
                values[valuesById[8] = "WEEKLY_ON_THURSDAY"] = 8;
                values[valuesById[9] = "WEEKLY_ON_FRIDAY"] = 9;
                values[valuesById[10] = "WEEKLY_ON_SATURDAY"] = 10;
                values[valuesById[11] = "MONTHLY_ON_FIRST_SUNDAY"] = 11;
                values[valuesById[12] = "MONTHLY_ON_FIRST_MONDAY"] = 12;
                values[valuesById[13] = "MONTHLY_ON_FIRST_TUESDAY"] = 13;
                values[valuesById[14] = "MONTHLY_ON_FIRST_WEDNESDAY"] = 14;
                values[valuesById[15] = "MONTHLY_ON_FIRST_THURSDAY"] = 15;
                values[valuesById[16] = "MONTHLY_ON_FIRST_FRIDAY"] = 16;
                values[valuesById[17] = "MONTHLY_ON_FIRST_SATURDAY"] = 17;
                values[valuesById[18] = "MONTHLY_ON_SECOND_SUNDAY"] = 18;
                values[valuesById[19] = "MONTHLY_ON_SECOND_MONDAY"] = 19;
                values[valuesById[20] = "MONTHLY_ON_SECOND_TUESDAY"] = 20;
                values[valuesById[21] = "MONTHLY_ON_SECOND_WEDNESDAY"] = 21;
                values[valuesById[22] = "MONTHLY_ON_SECOND_THURSDAY"] = 22;
                values[valuesById[23] = "MONTHLY_ON_SECOND_FRIDAY"] = 23;
                values[valuesById[24] = "MONTHLY_ON_SECOND_SATURDAY"] = 24;
                values[valuesById[25] = "MONTHLY_ON_THIRD_SUNDAY"] = 25;
                values[valuesById[26] = "MONTHLY_ON_THIRD_MONDAY"] = 26;
                values[valuesById[27] = "MONTHLY_ON_THIRD_TUESDAY"] = 27;
                values[valuesById[28] = "MONTHLY_ON_THIRD_WEDNESDAY"] = 28;
                values[valuesById[29] = "MONTHLY_ON_THIRD_THURSDAY"] = 29;
                values[valuesById[30] = "MONTHLY_ON_THIRD_FRIDAY"] = 30;
                values[valuesById[31] = "MONTHLY_ON_THIRD_SATURDAY"] = 31;
                values[valuesById[32] = "MONTHLY_ON_LAST_SUNDAY"] = 32;
                values[valuesById[33] = "MONTHLY_ON_LAST_MONDAY"] = 33;
                values[valuesById[34] = "MONTHLY_ON_LAST_TUESDAY"] = 34;
                values[valuesById[35] = "MONTHLY_ON_LAST_WEDNESDAY"] = 35;
                values[valuesById[36] = "MONTHLY_ON_LAST_THURSDAY"] = 36;
                values[valuesById[37] = "MONTHLY_ON_LAST_FRIDAY"] = 37;
                values[valuesById[38] = "MONTHLY_ON_LAST_SATURDAY"] = 38;
                return values;
            })();

            return DailyRecurrenceProto;
        })();

        common.MonthlyRecurrenceProto = (function() {

            /**
             * Properties of a MonthlyRecurrenceProto.
             * @memberof waiternow.common
             * @interface IMonthlyRecurrenceProto
             * @property {number|null} [montlyOnDay] MonthlyRecurrenceProto montlyOnDay
             * @property {waiternow.common.ITimeRangeProto|null} [timeRange] MonthlyRecurrenceProto timeRange
             */

            /**
             * Constructs a new MonthlyRecurrenceProto.
             * @memberof waiternow.common
             * @classdesc Represents a MonthlyRecurrenceProto.
             * @implements IMonthlyRecurrenceProto
             * @constructor
             * @param {waiternow.common.IMonthlyRecurrenceProto=} [properties] Properties to set
             */
            function MonthlyRecurrenceProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * MonthlyRecurrenceProto montlyOnDay.
             * @member {number} montlyOnDay
             * @memberof waiternow.common.MonthlyRecurrenceProto
             * @instance
             */
            MonthlyRecurrenceProto.prototype.montlyOnDay = 0;

            /**
             * MonthlyRecurrenceProto timeRange.
             * @member {waiternow.common.ITimeRangeProto|null|undefined} timeRange
             * @memberof waiternow.common.MonthlyRecurrenceProto
             * @instance
             */
            MonthlyRecurrenceProto.prototype.timeRange = null;

            /**
             * Creates a new MonthlyRecurrenceProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.MonthlyRecurrenceProto
             * @static
             * @param {waiternow.common.IMonthlyRecurrenceProto=} [properties] Properties to set
             * @returns {waiternow.common.MonthlyRecurrenceProto} MonthlyRecurrenceProto instance
             */
            MonthlyRecurrenceProto.create = function create(properties) {
                return new MonthlyRecurrenceProto(properties);
            };

            /**
             * Encodes the specified MonthlyRecurrenceProto message. Does not implicitly {@link waiternow.common.MonthlyRecurrenceProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.MonthlyRecurrenceProto
             * @static
             * @param {waiternow.common.IMonthlyRecurrenceProto} message MonthlyRecurrenceProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MonthlyRecurrenceProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.montlyOnDay != null && Object.hasOwnProperty.call(message, "montlyOnDay"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.montlyOnDay);
                if (message.timeRange != null && Object.hasOwnProperty.call(message, "timeRange"))
                    $root.waiternow.common.TimeRangeProto.encode(message.timeRange, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified MonthlyRecurrenceProto message, length delimited. Does not implicitly {@link waiternow.common.MonthlyRecurrenceProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.MonthlyRecurrenceProto
             * @static
             * @param {waiternow.common.IMonthlyRecurrenceProto} message MonthlyRecurrenceProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MonthlyRecurrenceProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a MonthlyRecurrenceProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.MonthlyRecurrenceProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.MonthlyRecurrenceProto} MonthlyRecurrenceProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MonthlyRecurrenceProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.MonthlyRecurrenceProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.montlyOnDay = reader.int32();
                            break;
                        }
                    case 2: {
                            message.timeRange = $root.waiternow.common.TimeRangeProto.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a MonthlyRecurrenceProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.MonthlyRecurrenceProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.MonthlyRecurrenceProto} MonthlyRecurrenceProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MonthlyRecurrenceProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a MonthlyRecurrenceProto message.
             * @function verify
             * @memberof waiternow.common.MonthlyRecurrenceProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            MonthlyRecurrenceProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.montlyOnDay != null && message.hasOwnProperty("montlyOnDay"))
                    if (!$util.isInteger(message.montlyOnDay))
                        return "montlyOnDay: integer expected";
                if (message.timeRange != null && message.hasOwnProperty("timeRange")) {
                    var error = $root.waiternow.common.TimeRangeProto.verify(message.timeRange);
                    if (error)
                        return "timeRange." + error;
                }
                return null;
            };

            /**
             * Creates a MonthlyRecurrenceProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.MonthlyRecurrenceProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.MonthlyRecurrenceProto} MonthlyRecurrenceProto
             */
            MonthlyRecurrenceProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.MonthlyRecurrenceProto)
                    return object;
                var message = new $root.waiternow.common.MonthlyRecurrenceProto();
                if (object.montlyOnDay != null)
                    message.montlyOnDay = object.montlyOnDay | 0;
                if (object.timeRange != null) {
                    if (typeof object.timeRange !== "object")
                        throw TypeError(".waiternow.common.MonthlyRecurrenceProto.timeRange: object expected");
                    message.timeRange = $root.waiternow.common.TimeRangeProto.fromObject(object.timeRange);
                }
                return message;
            };

            /**
             * Creates a plain object from a MonthlyRecurrenceProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.MonthlyRecurrenceProto
             * @static
             * @param {waiternow.common.MonthlyRecurrenceProto} message MonthlyRecurrenceProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            MonthlyRecurrenceProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.montlyOnDay = 0;
                    object.timeRange = null;
                }
                if (message.montlyOnDay != null && message.hasOwnProperty("montlyOnDay"))
                    object.montlyOnDay = message.montlyOnDay;
                if (message.timeRange != null && message.hasOwnProperty("timeRange"))
                    object.timeRange = $root.waiternow.common.TimeRangeProto.toObject(message.timeRange, options);
                return object;
            };

            /**
             * Converts this MonthlyRecurrenceProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.MonthlyRecurrenceProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            MonthlyRecurrenceProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for MonthlyRecurrenceProto
             * @function getTypeUrl
             * @memberof waiternow.common.MonthlyRecurrenceProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            MonthlyRecurrenceProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.MonthlyRecurrenceProto";
            };

            return MonthlyRecurrenceProto;
        })();

        common.YearlyRecurrenceProto = (function() {

            /**
             * Properties of a YearlyRecurrenceProto.
             * @memberof waiternow.common
             * @interface IYearlyRecurrenceProto
             * @property {waiternow.common.Month|null} [month] YearlyRecurrenceProto month
             * @property {number|null} [day] YearlyRecurrenceProto day
             * @property {waiternow.common.ITimeRangeProto|null} [timeRange] YearlyRecurrenceProto timeRange
             */

            /**
             * Constructs a new YearlyRecurrenceProto.
             * @memberof waiternow.common
             * @classdesc Represents a YearlyRecurrenceProto.
             * @implements IYearlyRecurrenceProto
             * @constructor
             * @param {waiternow.common.IYearlyRecurrenceProto=} [properties] Properties to set
             */
            function YearlyRecurrenceProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * YearlyRecurrenceProto month.
             * @member {waiternow.common.Month} month
             * @memberof waiternow.common.YearlyRecurrenceProto
             * @instance
             */
            YearlyRecurrenceProto.prototype.month = 0;

            /**
             * YearlyRecurrenceProto day.
             * @member {number} day
             * @memberof waiternow.common.YearlyRecurrenceProto
             * @instance
             */
            YearlyRecurrenceProto.prototype.day = 0;

            /**
             * YearlyRecurrenceProto timeRange.
             * @member {waiternow.common.ITimeRangeProto|null|undefined} timeRange
             * @memberof waiternow.common.YearlyRecurrenceProto
             * @instance
             */
            YearlyRecurrenceProto.prototype.timeRange = null;

            /**
             * Creates a new YearlyRecurrenceProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.YearlyRecurrenceProto
             * @static
             * @param {waiternow.common.IYearlyRecurrenceProto=} [properties] Properties to set
             * @returns {waiternow.common.YearlyRecurrenceProto} YearlyRecurrenceProto instance
             */
            YearlyRecurrenceProto.create = function create(properties) {
                return new YearlyRecurrenceProto(properties);
            };

            /**
             * Encodes the specified YearlyRecurrenceProto message. Does not implicitly {@link waiternow.common.YearlyRecurrenceProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.YearlyRecurrenceProto
             * @static
             * @param {waiternow.common.IYearlyRecurrenceProto} message YearlyRecurrenceProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            YearlyRecurrenceProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.month != null && Object.hasOwnProperty.call(message, "month"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.month);
                if (message.day != null && Object.hasOwnProperty.call(message, "day"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.day);
                if (message.timeRange != null && Object.hasOwnProperty.call(message, "timeRange"))
                    $root.waiternow.common.TimeRangeProto.encode(message.timeRange, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified YearlyRecurrenceProto message, length delimited. Does not implicitly {@link waiternow.common.YearlyRecurrenceProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.YearlyRecurrenceProto
             * @static
             * @param {waiternow.common.IYearlyRecurrenceProto} message YearlyRecurrenceProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            YearlyRecurrenceProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a YearlyRecurrenceProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.YearlyRecurrenceProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.YearlyRecurrenceProto} YearlyRecurrenceProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            YearlyRecurrenceProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.YearlyRecurrenceProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.month = reader.int32();
                            break;
                        }
                    case 2: {
                            message.day = reader.int32();
                            break;
                        }
                    case 3: {
                            message.timeRange = $root.waiternow.common.TimeRangeProto.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a YearlyRecurrenceProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.YearlyRecurrenceProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.YearlyRecurrenceProto} YearlyRecurrenceProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            YearlyRecurrenceProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a YearlyRecurrenceProto message.
             * @function verify
             * @memberof waiternow.common.YearlyRecurrenceProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            YearlyRecurrenceProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.month != null && message.hasOwnProperty("month"))
                    switch (message.month) {
                    default:
                        return "month: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                    case 9:
                    case 10:
                    case 11:
                    case 12:
                        break;
                    }
                if (message.day != null && message.hasOwnProperty("day"))
                    if (!$util.isInteger(message.day))
                        return "day: integer expected";
                if (message.timeRange != null && message.hasOwnProperty("timeRange")) {
                    var error = $root.waiternow.common.TimeRangeProto.verify(message.timeRange);
                    if (error)
                        return "timeRange." + error;
                }
                return null;
            };

            /**
             * Creates a YearlyRecurrenceProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.YearlyRecurrenceProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.YearlyRecurrenceProto} YearlyRecurrenceProto
             */
            YearlyRecurrenceProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.YearlyRecurrenceProto)
                    return object;
                var message = new $root.waiternow.common.YearlyRecurrenceProto();
                switch (object.month) {
                default:
                    if (typeof object.month === "number") {
                        message.month = object.month;
                        break;
                    }
                    break;
                case "MONTH_UNSPECIFIED":
                case 0:
                    message.month = 0;
                    break;
                case "JANUARY":
                case 1:
                    message.month = 1;
                    break;
                case "FEBRUARY":
                case 2:
                    message.month = 2;
                    break;
                case "MARCH":
                case 3:
                    message.month = 3;
                    break;
                case "APRIL":
                case 4:
                    message.month = 4;
                    break;
                case "MAY":
                case 5:
                    message.month = 5;
                    break;
                case "JUNE":
                case 6:
                    message.month = 6;
                    break;
                case "JULY":
                case 7:
                    message.month = 7;
                    break;
                case "AUGUST":
                case 8:
                    message.month = 8;
                    break;
                case "SEPTEMBER":
                case 9:
                    message.month = 9;
                    break;
                case "OCTOBER":
                case 10:
                    message.month = 10;
                    break;
                case "NOVEMBER":
                case 11:
                    message.month = 11;
                    break;
                case "DECEMBER":
                case 12:
                    message.month = 12;
                    break;
                }
                if (object.day != null)
                    message.day = object.day | 0;
                if (object.timeRange != null) {
                    if (typeof object.timeRange !== "object")
                        throw TypeError(".waiternow.common.YearlyRecurrenceProto.timeRange: object expected");
                    message.timeRange = $root.waiternow.common.TimeRangeProto.fromObject(object.timeRange);
                }
                return message;
            };

            /**
             * Creates a plain object from a YearlyRecurrenceProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.YearlyRecurrenceProto
             * @static
             * @param {waiternow.common.YearlyRecurrenceProto} message YearlyRecurrenceProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            YearlyRecurrenceProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.month = options.enums === String ? "MONTH_UNSPECIFIED" : 0;
                    object.day = 0;
                    object.timeRange = null;
                }
                if (message.month != null && message.hasOwnProperty("month"))
                    object.month = options.enums === String ? $root.waiternow.common.Month[message.month] === undefined ? message.month : $root.waiternow.common.Month[message.month] : message.month;
                if (message.day != null && message.hasOwnProperty("day"))
                    object.day = message.day;
                if (message.timeRange != null && message.hasOwnProperty("timeRange"))
                    object.timeRange = $root.waiternow.common.TimeRangeProto.toObject(message.timeRange, options);
                return object;
            };

            /**
             * Converts this YearlyRecurrenceProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.YearlyRecurrenceProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            YearlyRecurrenceProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for YearlyRecurrenceProto
             * @function getTypeUrl
             * @memberof waiternow.common.YearlyRecurrenceProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            YearlyRecurrenceProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.YearlyRecurrenceProto";
            };

            return YearlyRecurrenceProto;
        })();

        common.ScheduleProto = (function() {

            /**
             * Properties of a ScheduleProto.
             * @memberof waiternow.common
             * @interface IScheduleProto
             * @property {Array.<waiternow.common.IDateTimeRangeProto>|null} [dateTimeRanges] ScheduleProto dateTimeRanges
             * @property {Array.<waiternow.common.IDailyRecurrenceProto>|null} [dailyRecurrences] ScheduleProto dailyRecurrences
             * @property {Array.<waiternow.common.IMonthlyRecurrenceProto>|null} [monthlyRecurrences] ScheduleProto monthlyRecurrences
             * @property {Array.<waiternow.common.IYearlyRecurrenceProto>|null} [yearlyRecurrences] ScheduleProto yearlyRecurrences
             * @property {boolean|null} [isInverted] ScheduleProto isInverted
             */

            /**
             * Constructs a new ScheduleProto.
             * @memberof waiternow.common
             * @classdesc Represents a ScheduleProto.
             * @implements IScheduleProto
             * @constructor
             * @param {waiternow.common.IScheduleProto=} [properties] Properties to set
             */
            function ScheduleProto(properties) {
                this.dateTimeRanges = [];
                this.dailyRecurrences = [];
                this.monthlyRecurrences = [];
                this.yearlyRecurrences = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ScheduleProto dateTimeRanges.
             * @member {Array.<waiternow.common.IDateTimeRangeProto>} dateTimeRanges
             * @memberof waiternow.common.ScheduleProto
             * @instance
             */
            ScheduleProto.prototype.dateTimeRanges = $util.emptyArray;

            /**
             * ScheduleProto dailyRecurrences.
             * @member {Array.<waiternow.common.IDailyRecurrenceProto>} dailyRecurrences
             * @memberof waiternow.common.ScheduleProto
             * @instance
             */
            ScheduleProto.prototype.dailyRecurrences = $util.emptyArray;

            /**
             * ScheduleProto monthlyRecurrences.
             * @member {Array.<waiternow.common.IMonthlyRecurrenceProto>} monthlyRecurrences
             * @memberof waiternow.common.ScheduleProto
             * @instance
             */
            ScheduleProto.prototype.monthlyRecurrences = $util.emptyArray;

            /**
             * ScheduleProto yearlyRecurrences.
             * @member {Array.<waiternow.common.IYearlyRecurrenceProto>} yearlyRecurrences
             * @memberof waiternow.common.ScheduleProto
             * @instance
             */
            ScheduleProto.prototype.yearlyRecurrences = $util.emptyArray;

            /**
             * ScheduleProto isInverted.
             * @member {boolean} isInverted
             * @memberof waiternow.common.ScheduleProto
             * @instance
             */
            ScheduleProto.prototype.isInverted = false;

            /**
             * Creates a new ScheduleProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.ScheduleProto
             * @static
             * @param {waiternow.common.IScheduleProto=} [properties] Properties to set
             * @returns {waiternow.common.ScheduleProto} ScheduleProto instance
             */
            ScheduleProto.create = function create(properties) {
                return new ScheduleProto(properties);
            };

            /**
             * Encodes the specified ScheduleProto message. Does not implicitly {@link waiternow.common.ScheduleProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.ScheduleProto
             * @static
             * @param {waiternow.common.IScheduleProto} message ScheduleProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ScheduleProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.dateTimeRanges != null && message.dateTimeRanges.length)
                    for (var i = 0; i < message.dateTimeRanges.length; ++i)
                        $root.waiternow.common.DateTimeRangeProto.encode(message.dateTimeRanges[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.dailyRecurrences != null && message.dailyRecurrences.length)
                    for (var i = 0; i < message.dailyRecurrences.length; ++i)
                        $root.waiternow.common.DailyRecurrenceProto.encode(message.dailyRecurrences[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.monthlyRecurrences != null && message.monthlyRecurrences.length)
                    for (var i = 0; i < message.monthlyRecurrences.length; ++i)
                        $root.waiternow.common.MonthlyRecurrenceProto.encode(message.monthlyRecurrences[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.yearlyRecurrences != null && message.yearlyRecurrences.length)
                    for (var i = 0; i < message.yearlyRecurrences.length; ++i)
                        $root.waiternow.common.YearlyRecurrenceProto.encode(message.yearlyRecurrences[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                if (message.isInverted != null && Object.hasOwnProperty.call(message, "isInverted"))
                    writer.uint32(/* id 5, wireType 0 =*/40).bool(message.isInverted);
                return writer;
            };

            /**
             * Encodes the specified ScheduleProto message, length delimited. Does not implicitly {@link waiternow.common.ScheduleProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.ScheduleProto
             * @static
             * @param {waiternow.common.IScheduleProto} message ScheduleProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ScheduleProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ScheduleProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.ScheduleProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.ScheduleProto} ScheduleProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ScheduleProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.ScheduleProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            if (!(message.dateTimeRanges && message.dateTimeRanges.length))
                                message.dateTimeRanges = [];
                            message.dateTimeRanges.push($root.waiternow.common.DateTimeRangeProto.decode(reader, reader.uint32()));
                            break;
                        }
                    case 2: {
                            if (!(message.dailyRecurrences && message.dailyRecurrences.length))
                                message.dailyRecurrences = [];
                            message.dailyRecurrences.push($root.waiternow.common.DailyRecurrenceProto.decode(reader, reader.uint32()));
                            break;
                        }
                    case 3: {
                            if (!(message.monthlyRecurrences && message.monthlyRecurrences.length))
                                message.monthlyRecurrences = [];
                            message.monthlyRecurrences.push($root.waiternow.common.MonthlyRecurrenceProto.decode(reader, reader.uint32()));
                            break;
                        }
                    case 4: {
                            if (!(message.yearlyRecurrences && message.yearlyRecurrences.length))
                                message.yearlyRecurrences = [];
                            message.yearlyRecurrences.push($root.waiternow.common.YearlyRecurrenceProto.decode(reader, reader.uint32()));
                            break;
                        }
                    case 5: {
                            message.isInverted = reader.bool();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ScheduleProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.ScheduleProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.ScheduleProto} ScheduleProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ScheduleProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ScheduleProto message.
             * @function verify
             * @memberof waiternow.common.ScheduleProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ScheduleProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.dateTimeRanges != null && message.hasOwnProperty("dateTimeRanges")) {
                    if (!Array.isArray(message.dateTimeRanges))
                        return "dateTimeRanges: array expected";
                    for (var i = 0; i < message.dateTimeRanges.length; ++i) {
                        var error = $root.waiternow.common.DateTimeRangeProto.verify(message.dateTimeRanges[i]);
                        if (error)
                            return "dateTimeRanges." + error;
                    }
                }
                if (message.dailyRecurrences != null && message.hasOwnProperty("dailyRecurrences")) {
                    if (!Array.isArray(message.dailyRecurrences))
                        return "dailyRecurrences: array expected";
                    for (var i = 0; i < message.dailyRecurrences.length; ++i) {
                        var error = $root.waiternow.common.DailyRecurrenceProto.verify(message.dailyRecurrences[i]);
                        if (error)
                            return "dailyRecurrences." + error;
                    }
                }
                if (message.monthlyRecurrences != null && message.hasOwnProperty("monthlyRecurrences")) {
                    if (!Array.isArray(message.monthlyRecurrences))
                        return "monthlyRecurrences: array expected";
                    for (var i = 0; i < message.monthlyRecurrences.length; ++i) {
                        var error = $root.waiternow.common.MonthlyRecurrenceProto.verify(message.monthlyRecurrences[i]);
                        if (error)
                            return "monthlyRecurrences." + error;
                    }
                }
                if (message.yearlyRecurrences != null && message.hasOwnProperty("yearlyRecurrences")) {
                    if (!Array.isArray(message.yearlyRecurrences))
                        return "yearlyRecurrences: array expected";
                    for (var i = 0; i < message.yearlyRecurrences.length; ++i) {
                        var error = $root.waiternow.common.YearlyRecurrenceProto.verify(message.yearlyRecurrences[i]);
                        if (error)
                            return "yearlyRecurrences." + error;
                    }
                }
                if (message.isInverted != null && message.hasOwnProperty("isInverted"))
                    if (typeof message.isInverted !== "boolean")
                        return "isInverted: boolean expected";
                return null;
            };

            /**
             * Creates a ScheduleProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.ScheduleProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.ScheduleProto} ScheduleProto
             */
            ScheduleProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.ScheduleProto)
                    return object;
                var message = new $root.waiternow.common.ScheduleProto();
                if (object.dateTimeRanges) {
                    if (!Array.isArray(object.dateTimeRanges))
                        throw TypeError(".waiternow.common.ScheduleProto.dateTimeRanges: array expected");
                    message.dateTimeRanges = [];
                    for (var i = 0; i < object.dateTimeRanges.length; ++i) {
                        if (typeof object.dateTimeRanges[i] !== "object")
                            throw TypeError(".waiternow.common.ScheduleProto.dateTimeRanges: object expected");
                        message.dateTimeRanges[i] = $root.waiternow.common.DateTimeRangeProto.fromObject(object.dateTimeRanges[i]);
                    }
                }
                if (object.dailyRecurrences) {
                    if (!Array.isArray(object.dailyRecurrences))
                        throw TypeError(".waiternow.common.ScheduleProto.dailyRecurrences: array expected");
                    message.dailyRecurrences = [];
                    for (var i = 0; i < object.dailyRecurrences.length; ++i) {
                        if (typeof object.dailyRecurrences[i] !== "object")
                            throw TypeError(".waiternow.common.ScheduleProto.dailyRecurrences: object expected");
                        message.dailyRecurrences[i] = $root.waiternow.common.DailyRecurrenceProto.fromObject(object.dailyRecurrences[i]);
                    }
                }
                if (object.monthlyRecurrences) {
                    if (!Array.isArray(object.monthlyRecurrences))
                        throw TypeError(".waiternow.common.ScheduleProto.monthlyRecurrences: array expected");
                    message.monthlyRecurrences = [];
                    for (var i = 0; i < object.monthlyRecurrences.length; ++i) {
                        if (typeof object.monthlyRecurrences[i] !== "object")
                            throw TypeError(".waiternow.common.ScheduleProto.monthlyRecurrences: object expected");
                        message.monthlyRecurrences[i] = $root.waiternow.common.MonthlyRecurrenceProto.fromObject(object.monthlyRecurrences[i]);
                    }
                }
                if (object.yearlyRecurrences) {
                    if (!Array.isArray(object.yearlyRecurrences))
                        throw TypeError(".waiternow.common.ScheduleProto.yearlyRecurrences: array expected");
                    message.yearlyRecurrences = [];
                    for (var i = 0; i < object.yearlyRecurrences.length; ++i) {
                        if (typeof object.yearlyRecurrences[i] !== "object")
                            throw TypeError(".waiternow.common.ScheduleProto.yearlyRecurrences: object expected");
                        message.yearlyRecurrences[i] = $root.waiternow.common.YearlyRecurrenceProto.fromObject(object.yearlyRecurrences[i]);
                    }
                }
                if (object.isInverted != null)
                    message.isInverted = Boolean(object.isInverted);
                return message;
            };

            /**
             * Creates a plain object from a ScheduleProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.ScheduleProto
             * @static
             * @param {waiternow.common.ScheduleProto} message ScheduleProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ScheduleProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults) {
                    object.dateTimeRanges = [];
                    object.dailyRecurrences = [];
                    object.monthlyRecurrences = [];
                    object.yearlyRecurrences = [];
                }
                if (options.defaults)
                    object.isInverted = false;
                if (message.dateTimeRanges && message.dateTimeRanges.length) {
                    object.dateTimeRanges = [];
                    for (var j = 0; j < message.dateTimeRanges.length; ++j)
                        object.dateTimeRanges[j] = $root.waiternow.common.DateTimeRangeProto.toObject(message.dateTimeRanges[j], options);
                }
                if (message.dailyRecurrences && message.dailyRecurrences.length) {
                    object.dailyRecurrences = [];
                    for (var j = 0; j < message.dailyRecurrences.length; ++j)
                        object.dailyRecurrences[j] = $root.waiternow.common.DailyRecurrenceProto.toObject(message.dailyRecurrences[j], options);
                }
                if (message.monthlyRecurrences && message.monthlyRecurrences.length) {
                    object.monthlyRecurrences = [];
                    for (var j = 0; j < message.monthlyRecurrences.length; ++j)
                        object.monthlyRecurrences[j] = $root.waiternow.common.MonthlyRecurrenceProto.toObject(message.monthlyRecurrences[j], options);
                }
                if (message.yearlyRecurrences && message.yearlyRecurrences.length) {
                    object.yearlyRecurrences = [];
                    for (var j = 0; j < message.yearlyRecurrences.length; ++j)
                        object.yearlyRecurrences[j] = $root.waiternow.common.YearlyRecurrenceProto.toObject(message.yearlyRecurrences[j], options);
                }
                if (message.isInverted != null && message.hasOwnProperty("isInverted"))
                    object.isInverted = message.isInverted;
                return object;
            };

            /**
             * Converts this ScheduleProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.ScheduleProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ScheduleProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for ScheduleProto
             * @function getTypeUrl
             * @memberof waiternow.common.ScheduleProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            ScheduleProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.ScheduleProto";
            };

            return ScheduleProto;
        })();

        common.PrinterProto = (function() {

            /**
             * Properties of a PrinterProto.
             * @memberof waiternow.common
             * @interface IPrinterProto
             * @property {waiternow.common.PrinterProto.Brand|null} [brand] PrinterProto brand
             * @property {string|null} [model] PrinterProto model
             * @property {string|null} [station] PrinterProto station
             * @property {waiternow.common.PrinterProto.ILanSettingsProto|null} [lanSettings] PrinterProto lanSettings
             * @property {waiternow.common.PrinterProto.ICalibrationProto|null} [orderCalibration] PrinterProto orderCalibration
             * @property {waiternow.common.PrinterProto.ICalibrationProto|null} [orderReceiptCalibration] PrinterProto orderReceiptCalibration
             * @property {boolean|null} [isDisabled] PrinterProto isDisabled
             */

            /**
             * Constructs a new PrinterProto.
             * @memberof waiternow.common
             * @classdesc Represents a PrinterProto.
             * @implements IPrinterProto
             * @constructor
             * @param {waiternow.common.IPrinterProto=} [properties] Properties to set
             */
            function PrinterProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * PrinterProto brand.
             * @member {waiternow.common.PrinterProto.Brand} brand
             * @memberof waiternow.common.PrinterProto
             * @instance
             */
            PrinterProto.prototype.brand = 0;

            /**
             * PrinterProto model.
             * @member {string} model
             * @memberof waiternow.common.PrinterProto
             * @instance
             */
            PrinterProto.prototype.model = "";

            /**
             * PrinterProto station.
             * @member {string} station
             * @memberof waiternow.common.PrinterProto
             * @instance
             */
            PrinterProto.prototype.station = "";

            /**
             * PrinterProto lanSettings.
             * @member {waiternow.common.PrinterProto.ILanSettingsProto|null|undefined} lanSettings
             * @memberof waiternow.common.PrinterProto
             * @instance
             */
            PrinterProto.prototype.lanSettings = null;

            /**
             * PrinterProto orderCalibration.
             * @member {waiternow.common.PrinterProto.ICalibrationProto|null|undefined} orderCalibration
             * @memberof waiternow.common.PrinterProto
             * @instance
             */
            PrinterProto.prototype.orderCalibration = null;

            /**
             * PrinterProto orderReceiptCalibration.
             * @member {waiternow.common.PrinterProto.ICalibrationProto|null|undefined} orderReceiptCalibration
             * @memberof waiternow.common.PrinterProto
             * @instance
             */
            PrinterProto.prototype.orderReceiptCalibration = null;

            /**
             * PrinterProto isDisabled.
             * @member {boolean} isDisabled
             * @memberof waiternow.common.PrinterProto
             * @instance
             */
            PrinterProto.prototype.isDisabled = false;

            /**
             * Creates a new PrinterProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.PrinterProto
             * @static
             * @param {waiternow.common.IPrinterProto=} [properties] Properties to set
             * @returns {waiternow.common.PrinterProto} PrinterProto instance
             */
            PrinterProto.create = function create(properties) {
                return new PrinterProto(properties);
            };

            /**
             * Encodes the specified PrinterProto message. Does not implicitly {@link waiternow.common.PrinterProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.PrinterProto
             * @static
             * @param {waiternow.common.IPrinterProto} message PrinterProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PrinterProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.brand != null && Object.hasOwnProperty.call(message, "brand"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.brand);
                if (message.station != null && Object.hasOwnProperty.call(message, "station"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.station);
                if (message.lanSettings != null && Object.hasOwnProperty.call(message, "lanSettings"))
                    $root.waiternow.common.PrinterProto.LanSettingsProto.encode(message.lanSettings, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.orderCalibration != null && Object.hasOwnProperty.call(message, "orderCalibration"))
                    $root.waiternow.common.PrinterProto.CalibrationProto.encode(message.orderCalibration, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                if (message.orderReceiptCalibration != null && Object.hasOwnProperty.call(message, "orderReceiptCalibration"))
                    $root.waiternow.common.PrinterProto.CalibrationProto.encode(message.orderReceiptCalibration, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                if (message.isDisabled != null && Object.hasOwnProperty.call(message, "isDisabled"))
                    writer.uint32(/* id 6, wireType 0 =*/48).bool(message.isDisabled);
                if (message.model != null && Object.hasOwnProperty.call(message, "model"))
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.model);
                return writer;
            };

            /**
             * Encodes the specified PrinterProto message, length delimited. Does not implicitly {@link waiternow.common.PrinterProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.PrinterProto
             * @static
             * @param {waiternow.common.IPrinterProto} message PrinterProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PrinterProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a PrinterProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.PrinterProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.PrinterProto} PrinterProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PrinterProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PrinterProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.brand = reader.int32();
                            break;
                        }
                    case 7: {
                            message.model = reader.string();
                            break;
                        }
                    case 2: {
                            message.station = reader.string();
                            break;
                        }
                    case 3: {
                            message.lanSettings = $root.waiternow.common.PrinterProto.LanSettingsProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 4: {
                            message.orderCalibration = $root.waiternow.common.PrinterProto.CalibrationProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 5: {
                            message.orderReceiptCalibration = $root.waiternow.common.PrinterProto.CalibrationProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 6: {
                            message.isDisabled = reader.bool();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a PrinterProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.PrinterProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.PrinterProto} PrinterProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PrinterProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a PrinterProto message.
             * @function verify
             * @memberof waiternow.common.PrinterProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            PrinterProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.brand != null && message.hasOwnProperty("brand"))
                    switch (message.brand) {
                    default:
                        return "brand: enum value expected";
                    case 0:
                    case 1:
                        break;
                    }
                if (message.model != null && message.hasOwnProperty("model"))
                    if (!$util.isString(message.model))
                        return "model: string expected";
                if (message.station != null && message.hasOwnProperty("station"))
                    if (!$util.isString(message.station))
                        return "station: string expected";
                if (message.lanSettings != null && message.hasOwnProperty("lanSettings")) {
                    var error = $root.waiternow.common.PrinterProto.LanSettingsProto.verify(message.lanSettings);
                    if (error)
                        return "lanSettings." + error;
                }
                if (message.orderCalibration != null && message.hasOwnProperty("orderCalibration")) {
                    var error = $root.waiternow.common.PrinterProto.CalibrationProto.verify(message.orderCalibration);
                    if (error)
                        return "orderCalibration." + error;
                }
                if (message.orderReceiptCalibration != null && message.hasOwnProperty("orderReceiptCalibration")) {
                    var error = $root.waiternow.common.PrinterProto.CalibrationProto.verify(message.orderReceiptCalibration);
                    if (error)
                        return "orderReceiptCalibration." + error;
                }
                if (message.isDisabled != null && message.hasOwnProperty("isDisabled"))
                    if (typeof message.isDisabled !== "boolean")
                        return "isDisabled: boolean expected";
                return null;
            };

            /**
             * Creates a PrinterProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.PrinterProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.PrinterProto} PrinterProto
             */
            PrinterProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.PrinterProto)
                    return object;
                var message = new $root.waiternow.common.PrinterProto();
                switch (object.brand) {
                default:
                    if (typeof object.brand === "number") {
                        message.brand = object.brand;
                        break;
                    }
                    break;
                case "BRAND_UNSPECIFIED":
                case 0:
                    message.brand = 0;
                    break;
                case "STAR_MICRONICS":
                case 1:
                    message.brand = 1;
                    break;
                }
                if (object.model != null)
                    message.model = String(object.model);
                if (object.station != null)
                    message.station = String(object.station);
                if (object.lanSettings != null) {
                    if (typeof object.lanSettings !== "object")
                        throw TypeError(".waiternow.common.PrinterProto.lanSettings: object expected");
                    message.lanSettings = $root.waiternow.common.PrinterProto.LanSettingsProto.fromObject(object.lanSettings);
                }
                if (object.orderCalibration != null) {
                    if (typeof object.orderCalibration !== "object")
                        throw TypeError(".waiternow.common.PrinterProto.orderCalibration: object expected");
                    message.orderCalibration = $root.waiternow.common.PrinterProto.CalibrationProto.fromObject(object.orderCalibration);
                }
                if (object.orderReceiptCalibration != null) {
                    if (typeof object.orderReceiptCalibration !== "object")
                        throw TypeError(".waiternow.common.PrinterProto.orderReceiptCalibration: object expected");
                    message.orderReceiptCalibration = $root.waiternow.common.PrinterProto.CalibrationProto.fromObject(object.orderReceiptCalibration);
                }
                if (object.isDisabled != null)
                    message.isDisabled = Boolean(object.isDisabled);
                return message;
            };

            /**
             * Creates a plain object from a PrinterProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.PrinterProto
             * @static
             * @param {waiternow.common.PrinterProto} message PrinterProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            PrinterProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.brand = options.enums === String ? "BRAND_UNSPECIFIED" : 0;
                    object.station = "";
                    object.lanSettings = null;
                    object.orderCalibration = null;
                    object.orderReceiptCalibration = null;
                    object.isDisabled = false;
                    object.model = "";
                }
                if (message.brand != null && message.hasOwnProperty("brand"))
                    object.brand = options.enums === String ? $root.waiternow.common.PrinterProto.Brand[message.brand] === undefined ? message.brand : $root.waiternow.common.PrinterProto.Brand[message.brand] : message.brand;
                if (message.station != null && message.hasOwnProperty("station"))
                    object.station = message.station;
                if (message.lanSettings != null && message.hasOwnProperty("lanSettings"))
                    object.lanSettings = $root.waiternow.common.PrinterProto.LanSettingsProto.toObject(message.lanSettings, options);
                if (message.orderCalibration != null && message.hasOwnProperty("orderCalibration"))
                    object.orderCalibration = $root.waiternow.common.PrinterProto.CalibrationProto.toObject(message.orderCalibration, options);
                if (message.orderReceiptCalibration != null && message.hasOwnProperty("orderReceiptCalibration"))
                    object.orderReceiptCalibration = $root.waiternow.common.PrinterProto.CalibrationProto.toObject(message.orderReceiptCalibration, options);
                if (message.isDisabled != null && message.hasOwnProperty("isDisabled"))
                    object.isDisabled = message.isDisabled;
                if (message.model != null && message.hasOwnProperty("model"))
                    object.model = message.model;
                return object;
            };

            /**
             * Converts this PrinterProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.PrinterProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            PrinterProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for PrinterProto
             * @function getTypeUrl
             * @memberof waiternow.common.PrinterProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            PrinterProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.PrinterProto";
            };

            /**
             * Brand enum.
             * @name waiternow.common.PrinterProto.Brand
             * @enum {number}
             * @property {number} BRAND_UNSPECIFIED=0 BRAND_UNSPECIFIED value
             * @property {number} STAR_MICRONICS=1 STAR_MICRONICS value
             */
            PrinterProto.Brand = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "BRAND_UNSPECIFIED"] = 0;
                values[valuesById[1] = "STAR_MICRONICS"] = 1;
                return values;
            })();

            PrinterProto.LanSettingsProto = (function() {

                /**
                 * Properties of a LanSettingsProto.
                 * @memberof waiternow.common.PrinterProto
                 * @interface ILanSettingsProto
                 * @property {string|null} [ipAddress] LanSettingsProto ipAddress
                 */

                /**
                 * Constructs a new LanSettingsProto.
                 * @memberof waiternow.common.PrinterProto
                 * @classdesc Represents a LanSettingsProto.
                 * @implements ILanSettingsProto
                 * @constructor
                 * @param {waiternow.common.PrinterProto.ILanSettingsProto=} [properties] Properties to set
                 */
                function LanSettingsProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * LanSettingsProto ipAddress.
                 * @member {string} ipAddress
                 * @memberof waiternow.common.PrinterProto.LanSettingsProto
                 * @instance
                 */
                LanSettingsProto.prototype.ipAddress = "";

                /**
                 * Creates a new LanSettingsProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.PrinterProto.LanSettingsProto
                 * @static
                 * @param {waiternow.common.PrinterProto.ILanSettingsProto=} [properties] Properties to set
                 * @returns {waiternow.common.PrinterProto.LanSettingsProto} LanSettingsProto instance
                 */
                LanSettingsProto.create = function create(properties) {
                    return new LanSettingsProto(properties);
                };

                /**
                 * Encodes the specified LanSettingsProto message. Does not implicitly {@link waiternow.common.PrinterProto.LanSettingsProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.PrinterProto.LanSettingsProto
                 * @static
                 * @param {waiternow.common.PrinterProto.ILanSettingsProto} message LanSettingsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LanSettingsProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.ipAddress != null && Object.hasOwnProperty.call(message, "ipAddress"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.ipAddress);
                    return writer;
                };

                /**
                 * Encodes the specified LanSettingsProto message, length delimited. Does not implicitly {@link waiternow.common.PrinterProto.LanSettingsProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.PrinterProto.LanSettingsProto
                 * @static
                 * @param {waiternow.common.PrinterProto.ILanSettingsProto} message LanSettingsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LanSettingsProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a LanSettingsProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.PrinterProto.LanSettingsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.PrinterProto.LanSettingsProto} LanSettingsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LanSettingsProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PrinterProto.LanSettingsProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.ipAddress = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a LanSettingsProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.PrinterProto.LanSettingsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.PrinterProto.LanSettingsProto} LanSettingsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LanSettingsProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a LanSettingsProto message.
                 * @function verify
                 * @memberof waiternow.common.PrinterProto.LanSettingsProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                LanSettingsProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.ipAddress != null && message.hasOwnProperty("ipAddress"))
                        if (!$util.isString(message.ipAddress))
                            return "ipAddress: string expected";
                    return null;
                };

                /**
                 * Creates a LanSettingsProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.PrinterProto.LanSettingsProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.PrinterProto.LanSettingsProto} LanSettingsProto
                 */
                LanSettingsProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.PrinterProto.LanSettingsProto)
                        return object;
                    var message = new $root.waiternow.common.PrinterProto.LanSettingsProto();
                    if (object.ipAddress != null)
                        message.ipAddress = String(object.ipAddress);
                    return message;
                };

                /**
                 * Creates a plain object from a LanSettingsProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.PrinterProto.LanSettingsProto
                 * @static
                 * @param {waiternow.common.PrinterProto.LanSettingsProto} message LanSettingsProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                LanSettingsProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.ipAddress = "";
                    if (message.ipAddress != null && message.hasOwnProperty("ipAddress"))
                        object.ipAddress = message.ipAddress;
                    return object;
                };

                /**
                 * Converts this LanSettingsProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.PrinterProto.LanSettingsProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                LanSettingsProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for LanSettingsProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.PrinterProto.LanSettingsProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                LanSettingsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.PrinterProto.LanSettingsProto";
                };

                return LanSettingsProto;
            })();

            PrinterProto.CalibrationProto = (function() {

                /**
                 * Properties of a CalibrationProto.
                 * @memberof waiternow.common.PrinterProto
                 * @interface ICalibrationProto
                 * @property {number|null} [titleFontSize] CalibrationProto titleFontSize
                 * @property {number|null} [subtitleFontSize] CalibrationProto subtitleFontSize
                 * @property {number|null} [normalFontSize] CalibrationProto normalFontSize
                 * @property {number|null} [lineMaxCharsInNormalFontSize] CalibrationProto lineMaxCharsInNormalFontSize
                 */

                /**
                 * Constructs a new CalibrationProto.
                 * @memberof waiternow.common.PrinterProto
                 * @classdesc Represents a CalibrationProto.
                 * @implements ICalibrationProto
                 * @constructor
                 * @param {waiternow.common.PrinterProto.ICalibrationProto=} [properties] Properties to set
                 */
                function CalibrationProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * CalibrationProto titleFontSize.
                 * @member {number} titleFontSize
                 * @memberof waiternow.common.PrinterProto.CalibrationProto
                 * @instance
                 */
                CalibrationProto.prototype.titleFontSize = 0;

                /**
                 * CalibrationProto subtitleFontSize.
                 * @member {number} subtitleFontSize
                 * @memberof waiternow.common.PrinterProto.CalibrationProto
                 * @instance
                 */
                CalibrationProto.prototype.subtitleFontSize = 0;

                /**
                 * CalibrationProto normalFontSize.
                 * @member {number} normalFontSize
                 * @memberof waiternow.common.PrinterProto.CalibrationProto
                 * @instance
                 */
                CalibrationProto.prototype.normalFontSize = 0;

                /**
                 * CalibrationProto lineMaxCharsInNormalFontSize.
                 * @member {number} lineMaxCharsInNormalFontSize
                 * @memberof waiternow.common.PrinterProto.CalibrationProto
                 * @instance
                 */
                CalibrationProto.prototype.lineMaxCharsInNormalFontSize = 0;

                /**
                 * Creates a new CalibrationProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.PrinterProto.CalibrationProto
                 * @static
                 * @param {waiternow.common.PrinterProto.ICalibrationProto=} [properties] Properties to set
                 * @returns {waiternow.common.PrinterProto.CalibrationProto} CalibrationProto instance
                 */
                CalibrationProto.create = function create(properties) {
                    return new CalibrationProto(properties);
                };

                /**
                 * Encodes the specified CalibrationProto message. Does not implicitly {@link waiternow.common.PrinterProto.CalibrationProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.PrinterProto.CalibrationProto
                 * @static
                 * @param {waiternow.common.PrinterProto.ICalibrationProto} message CalibrationProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CalibrationProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.titleFontSize != null && Object.hasOwnProperty.call(message, "titleFontSize"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.titleFontSize);
                    if (message.subtitleFontSize != null && Object.hasOwnProperty.call(message, "subtitleFontSize"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.subtitleFontSize);
                    if (message.normalFontSize != null && Object.hasOwnProperty.call(message, "normalFontSize"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.normalFontSize);
                    if (message.lineMaxCharsInNormalFontSize != null && Object.hasOwnProperty.call(message, "lineMaxCharsInNormalFontSize"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.lineMaxCharsInNormalFontSize);
                    return writer;
                };

                /**
                 * Encodes the specified CalibrationProto message, length delimited. Does not implicitly {@link waiternow.common.PrinterProto.CalibrationProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.PrinterProto.CalibrationProto
                 * @static
                 * @param {waiternow.common.PrinterProto.ICalibrationProto} message CalibrationProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CalibrationProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a CalibrationProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.PrinterProto.CalibrationProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.PrinterProto.CalibrationProto} CalibrationProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CalibrationProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PrinterProto.CalibrationProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.titleFontSize = reader.int32();
                                break;
                            }
                        case 2: {
                                message.subtitleFontSize = reader.int32();
                                break;
                            }
                        case 3: {
                                message.normalFontSize = reader.int32();
                                break;
                            }
                        case 4: {
                                message.lineMaxCharsInNormalFontSize = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a CalibrationProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.PrinterProto.CalibrationProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.PrinterProto.CalibrationProto} CalibrationProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CalibrationProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a CalibrationProto message.
                 * @function verify
                 * @memberof waiternow.common.PrinterProto.CalibrationProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                CalibrationProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.titleFontSize != null && message.hasOwnProperty("titleFontSize"))
                        if (!$util.isInteger(message.titleFontSize))
                            return "titleFontSize: integer expected";
                    if (message.subtitleFontSize != null && message.hasOwnProperty("subtitleFontSize"))
                        if (!$util.isInteger(message.subtitleFontSize))
                            return "subtitleFontSize: integer expected";
                    if (message.normalFontSize != null && message.hasOwnProperty("normalFontSize"))
                        if (!$util.isInteger(message.normalFontSize))
                            return "normalFontSize: integer expected";
                    if (message.lineMaxCharsInNormalFontSize != null && message.hasOwnProperty("lineMaxCharsInNormalFontSize"))
                        if (!$util.isInteger(message.lineMaxCharsInNormalFontSize))
                            return "lineMaxCharsInNormalFontSize: integer expected";
                    return null;
                };

                /**
                 * Creates a CalibrationProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.PrinterProto.CalibrationProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.PrinterProto.CalibrationProto} CalibrationProto
                 */
                CalibrationProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.PrinterProto.CalibrationProto)
                        return object;
                    var message = new $root.waiternow.common.PrinterProto.CalibrationProto();
                    if (object.titleFontSize != null)
                        message.titleFontSize = object.titleFontSize | 0;
                    if (object.subtitleFontSize != null)
                        message.subtitleFontSize = object.subtitleFontSize | 0;
                    if (object.normalFontSize != null)
                        message.normalFontSize = object.normalFontSize | 0;
                    if (object.lineMaxCharsInNormalFontSize != null)
                        message.lineMaxCharsInNormalFontSize = object.lineMaxCharsInNormalFontSize | 0;
                    return message;
                };

                /**
                 * Creates a plain object from a CalibrationProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.PrinterProto.CalibrationProto
                 * @static
                 * @param {waiternow.common.PrinterProto.CalibrationProto} message CalibrationProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                CalibrationProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.titleFontSize = 0;
                        object.subtitleFontSize = 0;
                        object.normalFontSize = 0;
                        object.lineMaxCharsInNormalFontSize = 0;
                    }
                    if (message.titleFontSize != null && message.hasOwnProperty("titleFontSize"))
                        object.titleFontSize = message.titleFontSize;
                    if (message.subtitleFontSize != null && message.hasOwnProperty("subtitleFontSize"))
                        object.subtitleFontSize = message.subtitleFontSize;
                    if (message.normalFontSize != null && message.hasOwnProperty("normalFontSize"))
                        object.normalFontSize = message.normalFontSize;
                    if (message.lineMaxCharsInNormalFontSize != null && message.hasOwnProperty("lineMaxCharsInNormalFontSize"))
                        object.lineMaxCharsInNormalFontSize = message.lineMaxCharsInNormalFontSize;
                    return object;
                };

                /**
                 * Converts this CalibrationProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.PrinterProto.CalibrationProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                CalibrationProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for CalibrationProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.PrinterProto.CalibrationProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                CalibrationProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.PrinterProto.CalibrationProto";
                };

                return CalibrationProto;
            })();

            return PrinterProto;
        })();

        common.UserProto = (function() {

            /**
             * Properties of a UserProto.
             * @memberof waiternow.common
             * @interface IUserProto
             * @property {string|null} [id] UserProto id
             * @property {google.protobuf.ITimestamp|null} [creationTime] UserProto creationTime
             * @property {google.protobuf.ITimestamp|null} [lastUpdateTime] UserProto lastUpdateTime
             * @property {string|null} [email] UserProto email
             * @property {string|null} [password] UserProto password
             * @property {string|null} [passwordHash] UserProto passwordHash
             * @property {Uint8Array|null} [salt] UserProto salt
             * @property {string|null} [name] UserProto name
             * @property {string|null} [lastName] UserProto lastName
             * @property {waiternow.common.IPhoneNumberProto|null} [phoneNumber] UserProto phoneNumber
             * @property {boolean|null} [isSuspended] UserProto isSuspended
             * @property {waiternow.common.UserProto.SuspensionCause|null} [suspensionCause] UserProto suspensionCause
             * @property {waiternow.common.UserProto.ISettingsProto|null} [settings] UserProto settings
             * @property {waiternow.common.UserProto.IMetadataProto|null} [metadata] UserProto metadata
             */

            /**
             * Constructs a new UserProto.
             * @memberof waiternow.common
             * @classdesc Represents a UserProto.
             * @implements IUserProto
             * @constructor
             * @param {waiternow.common.IUserProto=} [properties] Properties to set
             */
            function UserProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * UserProto id.
             * @member {string} id
             * @memberof waiternow.common.UserProto
             * @instance
             */
            UserProto.prototype.id = "";

            /**
             * UserProto creationTime.
             * @member {google.protobuf.ITimestamp|null|undefined} creationTime
             * @memberof waiternow.common.UserProto
             * @instance
             */
            UserProto.prototype.creationTime = null;

            /**
             * UserProto lastUpdateTime.
             * @member {google.protobuf.ITimestamp|null|undefined} lastUpdateTime
             * @memberof waiternow.common.UserProto
             * @instance
             */
            UserProto.prototype.lastUpdateTime = null;

            /**
             * UserProto email.
             * @member {string} email
             * @memberof waiternow.common.UserProto
             * @instance
             */
            UserProto.prototype.email = "";

            /**
             * UserProto password.
             * @member {string} password
             * @memberof waiternow.common.UserProto
             * @instance
             */
            UserProto.prototype.password = "";

            /**
             * UserProto passwordHash.
             * @member {string} passwordHash
             * @memberof waiternow.common.UserProto
             * @instance
             */
            UserProto.prototype.passwordHash = "";

            /**
             * UserProto salt.
             * @member {Uint8Array} salt
             * @memberof waiternow.common.UserProto
             * @instance
             */
            UserProto.prototype.salt = $util.newBuffer([]);

            /**
             * UserProto name.
             * @member {string} name
             * @memberof waiternow.common.UserProto
             * @instance
             */
            UserProto.prototype.name = "";

            /**
             * UserProto lastName.
             * @member {string} lastName
             * @memberof waiternow.common.UserProto
             * @instance
             */
            UserProto.prototype.lastName = "";

            /**
             * UserProto phoneNumber.
             * @member {waiternow.common.IPhoneNumberProto|null|undefined} phoneNumber
             * @memberof waiternow.common.UserProto
             * @instance
             */
            UserProto.prototype.phoneNumber = null;

            /**
             * UserProto isSuspended.
             * @member {boolean} isSuspended
             * @memberof waiternow.common.UserProto
             * @instance
             */
            UserProto.prototype.isSuspended = false;

            /**
             * UserProto suspensionCause.
             * @member {waiternow.common.UserProto.SuspensionCause} suspensionCause
             * @memberof waiternow.common.UserProto
             * @instance
             */
            UserProto.prototype.suspensionCause = 0;

            /**
             * UserProto settings.
             * @member {waiternow.common.UserProto.ISettingsProto|null|undefined} settings
             * @memberof waiternow.common.UserProto
             * @instance
             */
            UserProto.prototype.settings = null;

            /**
             * UserProto metadata.
             * @member {waiternow.common.UserProto.IMetadataProto|null|undefined} metadata
             * @memberof waiternow.common.UserProto
             * @instance
             */
            UserProto.prototype.metadata = null;

            /**
             * Creates a new UserProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.UserProto
             * @static
             * @param {waiternow.common.IUserProto=} [properties] Properties to set
             * @returns {waiternow.common.UserProto} UserProto instance
             */
            UserProto.create = function create(properties) {
                return new UserProto(properties);
            };

            /**
             * Encodes the specified UserProto message. Does not implicitly {@link waiternow.common.UserProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.UserProto
             * @static
             * @param {waiternow.common.IUserProto} message UserProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UserProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.email);
                if (message.password != null && Object.hasOwnProperty.call(message, "password"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.password);
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.name);
                if (message.lastName != null && Object.hasOwnProperty.call(message, "lastName"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.lastName);
                if (message.phoneNumber != null && Object.hasOwnProperty.call(message, "phoneNumber"))
                    $root.waiternow.common.PhoneNumberProto.encode(message.phoneNumber, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                if (message.isSuspended != null && Object.hasOwnProperty.call(message, "isSuspended"))
                    writer.uint32(/* id 7, wireType 0 =*/56).bool(message.isSuspended);
                if (message.suspensionCause != null && Object.hasOwnProperty.call(message, "suspensionCause"))
                    writer.uint32(/* id 8, wireType 0 =*/64).int32(message.suspensionCause);
                if (message.settings != null && Object.hasOwnProperty.call(message, "settings"))
                    $root.waiternow.common.UserProto.SettingsProto.encode(message.settings, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                if (message.creationTime != null && Object.hasOwnProperty.call(message, "creationTime"))
                    $root.google.protobuf.Timestamp.encode(message.creationTime, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                    $root.google.protobuf.Timestamp.encode(message.lastUpdateTime, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                if (message.metadata != null && Object.hasOwnProperty.call(message, "metadata"))
                    $root.waiternow.common.UserProto.MetadataProto.encode(message.metadata, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                if (message.passwordHash != null && Object.hasOwnProperty.call(message, "passwordHash"))
                    writer.uint32(/* id 13, wireType 2 =*/106).string(message.passwordHash);
                if (message.salt != null && Object.hasOwnProperty.call(message, "salt"))
                    writer.uint32(/* id 14, wireType 2 =*/114).bytes(message.salt);
                return writer;
            };

            /**
             * Encodes the specified UserProto message, length delimited. Does not implicitly {@link waiternow.common.UserProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.UserProto
             * @static
             * @param {waiternow.common.IUserProto} message UserProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UserProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a UserProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.UserProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.UserProto} UserProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UserProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.UserProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.id = reader.string();
                            break;
                        }
                    case 10: {
                            message.creationTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 11: {
                            message.lastUpdateTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 2: {
                            message.email = reader.string();
                            break;
                        }
                    case 3: {
                            message.password = reader.string();
                            break;
                        }
                    case 13: {
                            message.passwordHash = reader.string();
                            break;
                        }
                    case 14: {
                            message.salt = reader.bytes();
                            break;
                        }
                    case 4: {
                            message.name = reader.string();
                            break;
                        }
                    case 5: {
                            message.lastName = reader.string();
                            break;
                        }
                    case 6: {
                            message.phoneNumber = $root.waiternow.common.PhoneNumberProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 7: {
                            message.isSuspended = reader.bool();
                            break;
                        }
                    case 8: {
                            message.suspensionCause = reader.int32();
                            break;
                        }
                    case 9: {
                            message.settings = $root.waiternow.common.UserProto.SettingsProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 12: {
                            message.metadata = $root.waiternow.common.UserProto.MetadataProto.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a UserProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.UserProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.UserProto} UserProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UserProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a UserProto message.
             * @function verify
             * @memberof waiternow.common.UserProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            UserProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.id != null && message.hasOwnProperty("id"))
                    if (!$util.isString(message.id))
                        return "id: string expected";
                if (message.creationTime != null && message.hasOwnProperty("creationTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.creationTime);
                    if (error)
                        return "creationTime." + error;
                }
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.lastUpdateTime);
                    if (error)
                        return "lastUpdateTime." + error;
                }
                if (message.email != null && message.hasOwnProperty("email"))
                    if (!$util.isString(message.email))
                        return "email: string expected";
                if (message.password != null && message.hasOwnProperty("password"))
                    if (!$util.isString(message.password))
                        return "password: string expected";
                if (message.passwordHash != null && message.hasOwnProperty("passwordHash"))
                    if (!$util.isString(message.passwordHash))
                        return "passwordHash: string expected";
                if (message.salt != null && message.hasOwnProperty("salt"))
                    if (!(message.salt && typeof message.salt.length === "number" || $util.isString(message.salt)))
                        return "salt: buffer expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.lastName != null && message.hasOwnProperty("lastName"))
                    if (!$util.isString(message.lastName))
                        return "lastName: string expected";
                if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber")) {
                    var error = $root.waiternow.common.PhoneNumberProto.verify(message.phoneNumber);
                    if (error)
                        return "phoneNumber." + error;
                }
                if (message.isSuspended != null && message.hasOwnProperty("isSuspended"))
                    if (typeof message.isSuspended !== "boolean")
                        return "isSuspended: boolean expected";
                if (message.suspensionCause != null && message.hasOwnProperty("suspensionCause"))
                    switch (message.suspensionCause) {
                    default:
                        return "suspensionCause: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                        break;
                    }
                if (message.settings != null && message.hasOwnProperty("settings")) {
                    var error = $root.waiternow.common.UserProto.SettingsProto.verify(message.settings);
                    if (error)
                        return "settings." + error;
                }
                if (message.metadata != null && message.hasOwnProperty("metadata")) {
                    var error = $root.waiternow.common.UserProto.MetadataProto.verify(message.metadata);
                    if (error)
                        return "metadata." + error;
                }
                return null;
            };

            /**
             * Creates a UserProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.UserProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.UserProto} UserProto
             */
            UserProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.UserProto)
                    return object;
                var message = new $root.waiternow.common.UserProto();
                if (object.id != null)
                    message.id = String(object.id);
                if (object.creationTime != null) {
                    if (typeof object.creationTime !== "object")
                        throw TypeError(".waiternow.common.UserProto.creationTime: object expected");
                    message.creationTime = $root.google.protobuf.Timestamp.fromObject(object.creationTime);
                }
                if (object.lastUpdateTime != null) {
                    if (typeof object.lastUpdateTime !== "object")
                        throw TypeError(".waiternow.common.UserProto.lastUpdateTime: object expected");
                    message.lastUpdateTime = $root.google.protobuf.Timestamp.fromObject(object.lastUpdateTime);
                }
                if (object.email != null)
                    message.email = String(object.email);
                if (object.password != null)
                    message.password = String(object.password);
                if (object.passwordHash != null)
                    message.passwordHash = String(object.passwordHash);
                if (object.salt != null)
                    if (typeof object.salt === "string")
                        $util.base64.decode(object.salt, message.salt = $util.newBuffer($util.base64.length(object.salt)), 0);
                    else if (object.salt.length >= 0)
                        message.salt = object.salt;
                if (object.name != null)
                    message.name = String(object.name);
                if (object.lastName != null)
                    message.lastName = String(object.lastName);
                if (object.phoneNumber != null) {
                    if (typeof object.phoneNumber !== "object")
                        throw TypeError(".waiternow.common.UserProto.phoneNumber: object expected");
                    message.phoneNumber = $root.waiternow.common.PhoneNumberProto.fromObject(object.phoneNumber);
                }
                if (object.isSuspended != null)
                    message.isSuspended = Boolean(object.isSuspended);
                switch (object.suspensionCause) {
                default:
                    if (typeof object.suspensionCause === "number") {
                        message.suspensionCause = object.suspensionCause;
                        break;
                    }
                    break;
                case "SUSPENSION_CAUSE_UNSPECIFIED":
                case 0:
                    message.suspensionCause = 0;
                    break;
                case "SPAM_USER":
                case 1:
                    message.suspensionCause = 1;
                    break;
                case "WAITING_EMAIL_VERIFICATION":
                case 2:
                    message.suspensionCause = 2;
                    break;
                }
                if (object.settings != null) {
                    if (typeof object.settings !== "object")
                        throw TypeError(".waiternow.common.UserProto.settings: object expected");
                    message.settings = $root.waiternow.common.UserProto.SettingsProto.fromObject(object.settings);
                }
                if (object.metadata != null) {
                    if (typeof object.metadata !== "object")
                        throw TypeError(".waiternow.common.UserProto.metadata: object expected");
                    message.metadata = $root.waiternow.common.UserProto.MetadataProto.fromObject(object.metadata);
                }
                return message;
            };

            /**
             * Creates a plain object from a UserProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.UserProto
             * @static
             * @param {waiternow.common.UserProto} message UserProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            UserProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.id = "";
                    object.email = "";
                    object.password = "";
                    object.name = "";
                    object.lastName = "";
                    object.phoneNumber = null;
                    object.isSuspended = false;
                    object.suspensionCause = options.enums === String ? "SUSPENSION_CAUSE_UNSPECIFIED" : 0;
                    object.settings = null;
                    object.creationTime = null;
                    object.lastUpdateTime = null;
                    object.metadata = null;
                    object.passwordHash = "";
                    if (options.bytes === String)
                        object.salt = "";
                    else {
                        object.salt = [];
                        if (options.bytes !== Array)
                            object.salt = $util.newBuffer(object.salt);
                    }
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                if (message.email != null && message.hasOwnProperty("email"))
                    object.email = message.email;
                if (message.password != null && message.hasOwnProperty("password"))
                    object.password = message.password;
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.lastName != null && message.hasOwnProperty("lastName"))
                    object.lastName = message.lastName;
                if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
                    object.phoneNumber = $root.waiternow.common.PhoneNumberProto.toObject(message.phoneNumber, options);
                if (message.isSuspended != null && message.hasOwnProperty("isSuspended"))
                    object.isSuspended = message.isSuspended;
                if (message.suspensionCause != null && message.hasOwnProperty("suspensionCause"))
                    object.suspensionCause = options.enums === String ? $root.waiternow.common.UserProto.SuspensionCause[message.suspensionCause] === undefined ? message.suspensionCause : $root.waiternow.common.UserProto.SuspensionCause[message.suspensionCause] : message.suspensionCause;
                if (message.settings != null && message.hasOwnProperty("settings"))
                    object.settings = $root.waiternow.common.UserProto.SettingsProto.toObject(message.settings, options);
                if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                    object.creationTime = $root.google.protobuf.Timestamp.toObject(message.creationTime, options);
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                    object.lastUpdateTime = $root.google.protobuf.Timestamp.toObject(message.lastUpdateTime, options);
                if (message.metadata != null && message.hasOwnProperty("metadata"))
                    object.metadata = $root.waiternow.common.UserProto.MetadataProto.toObject(message.metadata, options);
                if (message.passwordHash != null && message.hasOwnProperty("passwordHash"))
                    object.passwordHash = message.passwordHash;
                if (message.salt != null && message.hasOwnProperty("salt"))
                    object.salt = options.bytes === String ? $util.base64.encode(message.salt, 0, message.salt.length) : options.bytes === Array ? Array.prototype.slice.call(message.salt) : message.salt;
                return object;
            };

            /**
             * Converts this UserProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.UserProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            UserProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for UserProto
             * @function getTypeUrl
             * @memberof waiternow.common.UserProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            UserProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.UserProto";
            };

            /**
             * SuspensionCause enum.
             * @name waiternow.common.UserProto.SuspensionCause
             * @enum {number}
             * @property {number} SUSPENSION_CAUSE_UNSPECIFIED=0 SUSPENSION_CAUSE_UNSPECIFIED value
             * @property {number} SPAM_USER=1 SPAM_USER value
             * @property {number} WAITING_EMAIL_VERIFICATION=2 WAITING_EMAIL_VERIFICATION value
             */
            UserProto.SuspensionCause = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "SUSPENSION_CAUSE_UNSPECIFIED"] = 0;
                values[valuesById[1] = "SPAM_USER"] = 1;
                values[valuesById[2] = "WAITING_EMAIL_VERIFICATION"] = 2;
                return values;
            })();

            UserProto.SettingsProto = (function() {

                /**
                 * Properties of a SettingsProto.
                 * @memberof waiternow.common.UserProto
                 * @interface ISettingsProto
                 * @property {waiternow.common.ContactMedium|null} [preferredContactMedium] SettingsProto preferredContactMedium
                 * @property {waiternow.common.Language|null} [language] SettingsProto language
                 */

                /**
                 * Constructs a new SettingsProto.
                 * @memberof waiternow.common.UserProto
                 * @classdesc Represents a SettingsProto.
                 * @implements ISettingsProto
                 * @constructor
                 * @param {waiternow.common.UserProto.ISettingsProto=} [properties] Properties to set
                 */
                function SettingsProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SettingsProto preferredContactMedium.
                 * @member {waiternow.common.ContactMedium} preferredContactMedium
                 * @memberof waiternow.common.UserProto.SettingsProto
                 * @instance
                 */
                SettingsProto.prototype.preferredContactMedium = 0;

                /**
                 * SettingsProto language.
                 * @member {waiternow.common.Language} language
                 * @memberof waiternow.common.UserProto.SettingsProto
                 * @instance
                 */
                SettingsProto.prototype.language = 0;

                /**
                 * Creates a new SettingsProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.UserProto.SettingsProto
                 * @static
                 * @param {waiternow.common.UserProto.ISettingsProto=} [properties] Properties to set
                 * @returns {waiternow.common.UserProto.SettingsProto} SettingsProto instance
                 */
                SettingsProto.create = function create(properties) {
                    return new SettingsProto(properties);
                };

                /**
                 * Encodes the specified SettingsProto message. Does not implicitly {@link waiternow.common.UserProto.SettingsProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.UserProto.SettingsProto
                 * @static
                 * @param {waiternow.common.UserProto.ISettingsProto} message SettingsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SettingsProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.preferredContactMedium != null && Object.hasOwnProperty.call(message, "preferredContactMedium"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.preferredContactMedium);
                    if (message.language != null && Object.hasOwnProperty.call(message, "language"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.language);
                    return writer;
                };

                /**
                 * Encodes the specified SettingsProto message, length delimited. Does not implicitly {@link waiternow.common.UserProto.SettingsProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.UserProto.SettingsProto
                 * @static
                 * @param {waiternow.common.UserProto.ISettingsProto} message SettingsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SettingsProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SettingsProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.UserProto.SettingsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.UserProto.SettingsProto} SettingsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SettingsProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.UserProto.SettingsProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.preferredContactMedium = reader.int32();
                                break;
                            }
                        case 2: {
                                message.language = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SettingsProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.UserProto.SettingsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.UserProto.SettingsProto} SettingsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SettingsProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SettingsProto message.
                 * @function verify
                 * @memberof waiternow.common.UserProto.SettingsProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SettingsProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.preferredContactMedium != null && message.hasOwnProperty("preferredContactMedium"))
                        switch (message.preferredContactMedium) {
                        default:
                            return "preferredContactMedium: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                            break;
                        }
                    if (message.language != null && message.hasOwnProperty("language"))
                        switch (message.language) {
                        default:
                            return "language: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    return null;
                };

                /**
                 * Creates a SettingsProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.UserProto.SettingsProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.UserProto.SettingsProto} SettingsProto
                 */
                SettingsProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.UserProto.SettingsProto)
                        return object;
                    var message = new $root.waiternow.common.UserProto.SettingsProto();
                    switch (object.preferredContactMedium) {
                    default:
                        if (typeof object.preferredContactMedium === "number") {
                            message.preferredContactMedium = object.preferredContactMedium;
                            break;
                        }
                        break;
                    case "CONTACT_MEDIUM_UNSPECIFIED":
                    case 0:
                        message.preferredContactMedium = 0;
                        break;
                    case "EMAIL":
                    case 1:
                        message.preferredContactMedium = 1;
                        break;
                    case "PHONE_CALL":
                    case 2:
                        message.preferredContactMedium = 2;
                        break;
                    case "TEXT_MESSAGE":
                    case 3:
                        message.preferredContactMedium = 3;
                        break;
                    case "WHATS_APP":
                    case 4:
                        message.preferredContactMedium = 4;
                        break;
                    }
                    switch (object.language) {
                    default:
                        if (typeof object.language === "number") {
                            message.language = object.language;
                            break;
                        }
                        break;
                    case "LANGUAGE_UNSPECIFIED":
                    case 0:
                        message.language = 0;
                        break;
                    case "ENGLISH":
                    case 1:
                        message.language = 1;
                        break;
                    case "SPANISH":
                    case 2:
                        message.language = 2;
                        break;
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SettingsProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.UserProto.SettingsProto
                 * @static
                 * @param {waiternow.common.UserProto.SettingsProto} message SettingsProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SettingsProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.preferredContactMedium = options.enums === String ? "CONTACT_MEDIUM_UNSPECIFIED" : 0;
                        object.language = options.enums === String ? "LANGUAGE_UNSPECIFIED" : 0;
                    }
                    if (message.preferredContactMedium != null && message.hasOwnProperty("preferredContactMedium"))
                        object.preferredContactMedium = options.enums === String ? $root.waiternow.common.ContactMedium[message.preferredContactMedium] === undefined ? message.preferredContactMedium : $root.waiternow.common.ContactMedium[message.preferredContactMedium] : message.preferredContactMedium;
                    if (message.language != null && message.hasOwnProperty("language"))
                        object.language = options.enums === String ? $root.waiternow.common.Language[message.language] === undefined ? message.language : $root.waiternow.common.Language[message.language] : message.language;
                    return object;
                };

                /**
                 * Converts this SettingsProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.UserProto.SettingsProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SettingsProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for SettingsProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.UserProto.SettingsProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                SettingsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.UserProto.SettingsProto";
                };

                return SettingsProto;
            })();

            UserProto.MetadataProto = (function() {

                /**
                 * Properties of a MetadataProto.
                 * @memberof waiternow.common.UserProto
                 * @interface IMetadataProto
                 * @property {waiternow.common.RecordType|null} [recordType] MetadataProto recordType
                 * @property {waiternow.common.ReachMedium|null} [reachMedium] MetadataProto reachMedium
                 */

                /**
                 * Constructs a new MetadataProto.
                 * @memberof waiternow.common.UserProto
                 * @classdesc Represents a MetadataProto.
                 * @implements IMetadataProto
                 * @constructor
                 * @param {waiternow.common.UserProto.IMetadataProto=} [properties] Properties to set
                 */
                function MetadataProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * MetadataProto recordType.
                 * @member {waiternow.common.RecordType} recordType
                 * @memberof waiternow.common.UserProto.MetadataProto
                 * @instance
                 */
                MetadataProto.prototype.recordType = 0;

                /**
                 * MetadataProto reachMedium.
                 * @member {waiternow.common.ReachMedium} reachMedium
                 * @memberof waiternow.common.UserProto.MetadataProto
                 * @instance
                 */
                MetadataProto.prototype.reachMedium = 0;

                /**
                 * Creates a new MetadataProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.UserProto.MetadataProto
                 * @static
                 * @param {waiternow.common.UserProto.IMetadataProto=} [properties] Properties to set
                 * @returns {waiternow.common.UserProto.MetadataProto} MetadataProto instance
                 */
                MetadataProto.create = function create(properties) {
                    return new MetadataProto(properties);
                };

                /**
                 * Encodes the specified MetadataProto message. Does not implicitly {@link waiternow.common.UserProto.MetadataProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.UserProto.MetadataProto
                 * @static
                 * @param {waiternow.common.UserProto.IMetadataProto} message MetadataProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MetadataProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.recordType != null && Object.hasOwnProperty.call(message, "recordType"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.recordType);
                    if (message.reachMedium != null && Object.hasOwnProperty.call(message, "reachMedium"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.reachMedium);
                    return writer;
                };

                /**
                 * Encodes the specified MetadataProto message, length delimited. Does not implicitly {@link waiternow.common.UserProto.MetadataProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.UserProto.MetadataProto
                 * @static
                 * @param {waiternow.common.UserProto.IMetadataProto} message MetadataProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MetadataProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a MetadataProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.UserProto.MetadataProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.UserProto.MetadataProto} MetadataProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MetadataProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.UserProto.MetadataProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.recordType = reader.int32();
                                break;
                            }
                        case 3: {
                                message.reachMedium = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a MetadataProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.UserProto.MetadataProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.UserProto.MetadataProto} MetadataProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MetadataProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a MetadataProto message.
                 * @function verify
                 * @memberof waiternow.common.UserProto.MetadataProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                MetadataProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.recordType != null && message.hasOwnProperty("recordType"))
                        switch (message.recordType) {
                        default:
                            return "recordType: enum value expected";
                        case 0:
                        case 1:
                        case 3:
                        case 4:
                        case 5:
                            break;
                        }
                    if (message.reachMedium != null && message.hasOwnProperty("reachMedium"))
                        switch (message.reachMedium) {
                        default:
                            return "reachMedium: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                        case 6:
                        case 7:
                            break;
                        }
                    return null;
                };

                /**
                 * Creates a MetadataProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.UserProto.MetadataProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.UserProto.MetadataProto} MetadataProto
                 */
                MetadataProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.UserProto.MetadataProto)
                        return object;
                    var message = new $root.waiternow.common.UserProto.MetadataProto();
                    switch (object.recordType) {
                    default:
                        if (typeof object.recordType === "number") {
                            message.recordType = object.recordType;
                            break;
                        }
                        break;
                    case "RECORD_TYPE_UNSPECIFIED":
                    case 0:
                        message.recordType = 0;
                        break;
                    case "REGULAR":
                    case 1:
                        message.recordType = 1;
                        break;
                    case "PRE_CREATED":
                    case 3:
                        message.recordType = 3;
                        break;
                    case "TEST":
                    case 4:
                        message.recordType = 4;
                        break;
                    case "DEMO":
                    case 5:
                        message.recordType = 5;
                        break;
                    }
                    switch (object.reachMedium) {
                    default:
                        if (typeof object.reachMedium === "number") {
                            message.reachMedium = object.reachMedium;
                            break;
                        }
                        break;
                    case "REACH_MEDIUM_UNDEFINED":
                    case 0:
                        message.reachMedium = 0;
                        break;
                    case "GOOGLE":
                    case 1:
                        message.reachMedium = 1;
                        break;
                    case "FACEBOOK":
                    case 2:
                        message.reachMedium = 2;
                        break;
                    case "INSTRAGRAM":
                    case 3:
                        message.reachMedium = 3;
                        break;
                    case "LINKED_IN":
                    case 4:
                        message.reachMedium = 4;
                        break;
                    case "RECOMMENDATION":
                    case 5:
                        message.reachMedium = 5;
                        break;
                    case "SALESPERSON":
                    case 6:
                        message.reachMedium = 6;
                        break;
                    case "OTHER":
                    case 7:
                        message.reachMedium = 7;
                        break;
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a MetadataProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.UserProto.MetadataProto
                 * @static
                 * @param {waiternow.common.UserProto.MetadataProto} message MetadataProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                MetadataProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.recordType = options.enums === String ? "RECORD_TYPE_UNSPECIFIED" : 0;
                        object.reachMedium = options.enums === String ? "REACH_MEDIUM_UNDEFINED" : 0;
                    }
                    if (message.recordType != null && message.hasOwnProperty("recordType"))
                        object.recordType = options.enums === String ? $root.waiternow.common.RecordType[message.recordType] === undefined ? message.recordType : $root.waiternow.common.RecordType[message.recordType] : message.recordType;
                    if (message.reachMedium != null && message.hasOwnProperty("reachMedium"))
                        object.reachMedium = options.enums === String ? $root.waiternow.common.ReachMedium[message.reachMedium] === undefined ? message.reachMedium : $root.waiternow.common.ReachMedium[message.reachMedium] : message.reachMedium;
                    return object;
                };

                /**
                 * Converts this MetadataProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.UserProto.MetadataProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                MetadataProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for MetadataProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.UserProto.MetadataProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                MetadataProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.UserProto.MetadataProto";
                };

                return MetadataProto;
            })();

            return UserProto;
        })();

        common.UserRoleProto = (function() {

            /**
             * Properties of a UserRoleProto.
             * @memberof waiternow.common
             * @interface IUserRoleProto
             * @property {string|null} [userId] UserRoleProto userId
             * @property {waiternow.common.UserRoleProto.IResourceProto|null} [resource] UserRoleProto resource
             * @property {waiternow.common.Role|null} [role] UserRoleProto role
             * @property {google.protobuf.ITimestamp|null} [creationTime] UserRoleProto creationTime
             */

            /**
             * Constructs a new UserRoleProto.
             * @memberof waiternow.common
             * @classdesc Represents a UserRoleProto.
             * @implements IUserRoleProto
             * @constructor
             * @param {waiternow.common.IUserRoleProto=} [properties] Properties to set
             */
            function UserRoleProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * UserRoleProto userId.
             * @member {string} userId
             * @memberof waiternow.common.UserRoleProto
             * @instance
             */
            UserRoleProto.prototype.userId = "";

            /**
             * UserRoleProto resource.
             * @member {waiternow.common.UserRoleProto.IResourceProto|null|undefined} resource
             * @memberof waiternow.common.UserRoleProto
             * @instance
             */
            UserRoleProto.prototype.resource = null;

            /**
             * UserRoleProto role.
             * @member {waiternow.common.Role} role
             * @memberof waiternow.common.UserRoleProto
             * @instance
             */
            UserRoleProto.prototype.role = 0;

            /**
             * UserRoleProto creationTime.
             * @member {google.protobuf.ITimestamp|null|undefined} creationTime
             * @memberof waiternow.common.UserRoleProto
             * @instance
             */
            UserRoleProto.prototype.creationTime = null;

            /**
             * Creates a new UserRoleProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.UserRoleProto
             * @static
             * @param {waiternow.common.IUserRoleProto=} [properties] Properties to set
             * @returns {waiternow.common.UserRoleProto} UserRoleProto instance
             */
            UserRoleProto.create = function create(properties) {
                return new UserRoleProto(properties);
            };

            /**
             * Encodes the specified UserRoleProto message. Does not implicitly {@link waiternow.common.UserRoleProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.UserRoleProto
             * @static
             * @param {waiternow.common.IUserRoleProto} message UserRoleProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UserRoleProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.userId);
                if (message.resource != null && Object.hasOwnProperty.call(message, "resource"))
                    $root.waiternow.common.UserRoleProto.ResourceProto.encode(message.resource, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.role != null && Object.hasOwnProperty.call(message, "role"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.role);
                if (message.creationTime != null && Object.hasOwnProperty.call(message, "creationTime"))
                    $root.google.protobuf.Timestamp.encode(message.creationTime, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified UserRoleProto message, length delimited. Does not implicitly {@link waiternow.common.UserRoleProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.UserRoleProto
             * @static
             * @param {waiternow.common.IUserRoleProto} message UserRoleProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UserRoleProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a UserRoleProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.UserRoleProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.UserRoleProto} UserRoleProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UserRoleProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.UserRoleProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.userId = reader.string();
                            break;
                        }
                    case 2: {
                            message.resource = $root.waiternow.common.UserRoleProto.ResourceProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 3: {
                            message.role = reader.int32();
                            break;
                        }
                    case 4: {
                            message.creationTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a UserRoleProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.UserRoleProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.UserRoleProto} UserRoleProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UserRoleProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a UserRoleProto message.
             * @function verify
             * @memberof waiternow.common.UserRoleProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            UserRoleProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.userId != null && message.hasOwnProperty("userId"))
                    if (!$util.isString(message.userId))
                        return "userId: string expected";
                if (message.resource != null && message.hasOwnProperty("resource")) {
                    var error = $root.waiternow.common.UserRoleProto.ResourceProto.verify(message.resource);
                    if (error)
                        return "resource." + error;
                }
                if (message.role != null && message.hasOwnProperty("role"))
                    switch (message.role) {
                    default:
                        return "role: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                        break;
                    }
                if (message.creationTime != null && message.hasOwnProperty("creationTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.creationTime);
                    if (error)
                        return "creationTime." + error;
                }
                return null;
            };

            /**
             * Creates a UserRoleProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.UserRoleProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.UserRoleProto} UserRoleProto
             */
            UserRoleProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.UserRoleProto)
                    return object;
                var message = new $root.waiternow.common.UserRoleProto();
                if (object.userId != null)
                    message.userId = String(object.userId);
                if (object.resource != null) {
                    if (typeof object.resource !== "object")
                        throw TypeError(".waiternow.common.UserRoleProto.resource: object expected");
                    message.resource = $root.waiternow.common.UserRoleProto.ResourceProto.fromObject(object.resource);
                }
                switch (object.role) {
                default:
                    if (typeof object.role === "number") {
                        message.role = object.role;
                        break;
                    }
                    break;
                case "ROLE_UNSPECIFIED":
                case 0:
                    message.role = 0;
                    break;
                case "OWNER":
                case 1:
                    message.role = 1;
                    break;
                case "ADMIN":
                case 2:
                    message.role = 2;
                    break;
                case "VIEWER":
                case 3:
                    message.role = 3;
                    break;
                }
                if (object.creationTime != null) {
                    if (typeof object.creationTime !== "object")
                        throw TypeError(".waiternow.common.UserRoleProto.creationTime: object expected");
                    message.creationTime = $root.google.protobuf.Timestamp.fromObject(object.creationTime);
                }
                return message;
            };

            /**
             * Creates a plain object from a UserRoleProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.UserRoleProto
             * @static
             * @param {waiternow.common.UserRoleProto} message UserRoleProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            UserRoleProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.userId = "";
                    object.resource = null;
                    object.role = options.enums === String ? "ROLE_UNSPECIFIED" : 0;
                    object.creationTime = null;
                }
                if (message.userId != null && message.hasOwnProperty("userId"))
                    object.userId = message.userId;
                if (message.resource != null && message.hasOwnProperty("resource"))
                    object.resource = $root.waiternow.common.UserRoleProto.ResourceProto.toObject(message.resource, options);
                if (message.role != null && message.hasOwnProperty("role"))
                    object.role = options.enums === String ? $root.waiternow.common.Role[message.role] === undefined ? message.role : $root.waiternow.common.Role[message.role] : message.role;
                if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                    object.creationTime = $root.google.protobuf.Timestamp.toObject(message.creationTime, options);
                return object;
            };

            /**
             * Converts this UserRoleProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.UserRoleProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            UserRoleProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for UserRoleProto
             * @function getTypeUrl
             * @memberof waiternow.common.UserRoleProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            UserRoleProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.UserRoleProto";
            };

            UserRoleProto.ResourceProto = (function() {

                /**
                 * Properties of a ResourceProto.
                 * @memberof waiternow.common.UserRoleProto
                 * @interface IResourceProto
                 * @property {string|null} [businessId] ResourceProto businessId
                 * @property {string|null} [locationId] ResourceProto locationId
                 */

                /**
                 * Constructs a new ResourceProto.
                 * @memberof waiternow.common.UserRoleProto
                 * @classdesc Represents a ResourceProto.
                 * @implements IResourceProto
                 * @constructor
                 * @param {waiternow.common.UserRoleProto.IResourceProto=} [properties] Properties to set
                 */
                function ResourceProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ResourceProto businessId.
                 * @member {string|null|undefined} businessId
                 * @memberof waiternow.common.UserRoleProto.ResourceProto
                 * @instance
                 */
                ResourceProto.prototype.businessId = null;

                /**
                 * ResourceProto locationId.
                 * @member {string|null|undefined} locationId
                 * @memberof waiternow.common.UserRoleProto.ResourceProto
                 * @instance
                 */
                ResourceProto.prototype.locationId = null;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * ResourceProto resource.
                 * @member {"businessId"|"locationId"|undefined} resource
                 * @memberof waiternow.common.UserRoleProto.ResourceProto
                 * @instance
                 */
                Object.defineProperty(ResourceProto.prototype, "resource", {
                    get: $util.oneOfGetter($oneOfFields = ["businessId", "locationId"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new ResourceProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.UserRoleProto.ResourceProto
                 * @static
                 * @param {waiternow.common.UserRoleProto.IResourceProto=} [properties] Properties to set
                 * @returns {waiternow.common.UserRoleProto.ResourceProto} ResourceProto instance
                 */
                ResourceProto.create = function create(properties) {
                    return new ResourceProto(properties);
                };

                /**
                 * Encodes the specified ResourceProto message. Does not implicitly {@link waiternow.common.UserRoleProto.ResourceProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.UserRoleProto.ResourceProto
                 * @static
                 * @param {waiternow.common.UserRoleProto.IResourceProto} message ResourceProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ResourceProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.businessId);
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.locationId);
                    return writer;
                };

                /**
                 * Encodes the specified ResourceProto message, length delimited. Does not implicitly {@link waiternow.common.UserRoleProto.ResourceProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.UserRoleProto.ResourceProto
                 * @static
                 * @param {waiternow.common.UserRoleProto.IResourceProto} message ResourceProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ResourceProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ResourceProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.UserRoleProto.ResourceProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.UserRoleProto.ResourceProto} ResourceProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ResourceProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.UserRoleProto.ResourceProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 2: {
                                message.businessId = reader.string();
                                break;
                            }
                        case 3: {
                                message.locationId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ResourceProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.UserRoleProto.ResourceProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.UserRoleProto.ResourceProto} ResourceProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ResourceProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ResourceProto message.
                 * @function verify
                 * @memberof waiternow.common.UserRoleProto.ResourceProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ResourceProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.businessId != null && message.hasOwnProperty("businessId")) {
                        properties.resource = 1;
                        if (!$util.isString(message.businessId))
                            return "businessId: string expected";
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId")) {
                        if (properties.resource === 1)
                            return "resource: multiple values";
                        properties.resource = 1;
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    }
                    return null;
                };

                /**
                 * Creates a ResourceProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.UserRoleProto.ResourceProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.UserRoleProto.ResourceProto} ResourceProto
                 */
                ResourceProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.UserRoleProto.ResourceProto)
                        return object;
                    var message = new $root.waiternow.common.UserRoleProto.ResourceProto();
                    if (object.businessId != null)
                        message.businessId = String(object.businessId);
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    return message;
                };

                /**
                 * Creates a plain object from a ResourceProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.UserRoleProto.ResourceProto
                 * @static
                 * @param {waiternow.common.UserRoleProto.ResourceProto} message ResourceProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ResourceProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (message.businessId != null && message.hasOwnProperty("businessId")) {
                        object.businessId = message.businessId;
                        if (options.oneofs)
                            object.resource = "businessId";
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId")) {
                        object.locationId = message.locationId;
                        if (options.oneofs)
                            object.resource = "locationId";
                    }
                    return object;
                };

                /**
                 * Converts this ResourceProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.UserRoleProto.ResourceProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ResourceProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ResourceProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.UserRoleProto.ResourceProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ResourceProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.UserRoleProto.ResourceProto";
                };

                return ResourceProto;
            })();

            return UserRoleProto;
        })();

        /**
         * Role enum.
         * @name waiternow.common.Role
         * @enum {number}
         * @property {number} ROLE_UNSPECIFIED=0 ROLE_UNSPECIFIED value
         * @property {number} OWNER=1 OWNER value
         * @property {number} ADMIN=2 ADMIN value
         * @property {number} VIEWER=3 VIEWER value
         */
        common.Role = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "ROLE_UNSPECIFIED"] = 0;
            values[valuesById[1] = "OWNER"] = 1;
            values[valuesById[2] = "ADMIN"] = 2;
            values[valuesById[3] = "VIEWER"] = 3;
            return values;
        })();

        common.EmailVerificationProto = (function() {

            /**
             * Properties of an EmailVerificationProto.
             * @memberof waiternow.common
             * @interface IEmailVerificationProto
             * @property {string|null} [userId] EmailVerificationProto userId
             * @property {google.protobuf.ITimestamp|null} [creationTime] EmailVerificationProto creationTime
             */

            /**
             * Constructs a new EmailVerificationProto.
             * @memberof waiternow.common
             * @classdesc Represents an EmailVerificationProto.
             * @implements IEmailVerificationProto
             * @constructor
             * @param {waiternow.common.IEmailVerificationProto=} [properties] Properties to set
             */
            function EmailVerificationProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * EmailVerificationProto userId.
             * @member {string} userId
             * @memberof waiternow.common.EmailVerificationProto
             * @instance
             */
            EmailVerificationProto.prototype.userId = "";

            /**
             * EmailVerificationProto creationTime.
             * @member {google.protobuf.ITimestamp|null|undefined} creationTime
             * @memberof waiternow.common.EmailVerificationProto
             * @instance
             */
            EmailVerificationProto.prototype.creationTime = null;

            /**
             * Creates a new EmailVerificationProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.EmailVerificationProto
             * @static
             * @param {waiternow.common.IEmailVerificationProto=} [properties] Properties to set
             * @returns {waiternow.common.EmailVerificationProto} EmailVerificationProto instance
             */
            EmailVerificationProto.create = function create(properties) {
                return new EmailVerificationProto(properties);
            };

            /**
             * Encodes the specified EmailVerificationProto message. Does not implicitly {@link waiternow.common.EmailVerificationProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.EmailVerificationProto
             * @static
             * @param {waiternow.common.IEmailVerificationProto} message EmailVerificationProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EmailVerificationProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.userId);
                if (message.creationTime != null && Object.hasOwnProperty.call(message, "creationTime"))
                    $root.google.protobuf.Timestamp.encode(message.creationTime, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified EmailVerificationProto message, length delimited. Does not implicitly {@link waiternow.common.EmailVerificationProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.EmailVerificationProto
             * @static
             * @param {waiternow.common.IEmailVerificationProto} message EmailVerificationProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EmailVerificationProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an EmailVerificationProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.EmailVerificationProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.EmailVerificationProto} EmailVerificationProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EmailVerificationProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.EmailVerificationProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.userId = reader.string();
                            break;
                        }
                    case 2: {
                            message.creationTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an EmailVerificationProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.EmailVerificationProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.EmailVerificationProto} EmailVerificationProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EmailVerificationProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an EmailVerificationProto message.
             * @function verify
             * @memberof waiternow.common.EmailVerificationProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            EmailVerificationProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.userId != null && message.hasOwnProperty("userId"))
                    if (!$util.isString(message.userId))
                        return "userId: string expected";
                if (message.creationTime != null && message.hasOwnProperty("creationTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.creationTime);
                    if (error)
                        return "creationTime." + error;
                }
                return null;
            };

            /**
             * Creates an EmailVerificationProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.EmailVerificationProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.EmailVerificationProto} EmailVerificationProto
             */
            EmailVerificationProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.EmailVerificationProto)
                    return object;
                var message = new $root.waiternow.common.EmailVerificationProto();
                if (object.userId != null)
                    message.userId = String(object.userId);
                if (object.creationTime != null) {
                    if (typeof object.creationTime !== "object")
                        throw TypeError(".waiternow.common.EmailVerificationProto.creationTime: object expected");
                    message.creationTime = $root.google.protobuf.Timestamp.fromObject(object.creationTime);
                }
                return message;
            };

            /**
             * Creates a plain object from an EmailVerificationProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.EmailVerificationProto
             * @static
             * @param {waiternow.common.EmailVerificationProto} message EmailVerificationProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            EmailVerificationProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.userId = "";
                    object.creationTime = null;
                }
                if (message.userId != null && message.hasOwnProperty("userId"))
                    object.userId = message.userId;
                if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                    object.creationTime = $root.google.protobuf.Timestamp.toObject(message.creationTime, options);
                return object;
            };

            /**
             * Converts this EmailVerificationProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.EmailVerificationProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            EmailVerificationProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for EmailVerificationProto
             * @function getTypeUrl
             * @memberof waiternow.common.EmailVerificationProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            EmailVerificationProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.EmailVerificationProto";
            };

            return EmailVerificationProto;
        })();

        common.EmailUpdateVerificationProto = (function() {

            /**
             * Properties of an EmailUpdateVerificationProto.
             * @memberof waiternow.common
             * @interface IEmailUpdateVerificationProto
             * @property {string|null} [userId] EmailUpdateVerificationProto userId
             * @property {string|null} [newEmail] EmailUpdateVerificationProto newEmail
             * @property {google.protobuf.ITimestamp|null} [creationTime] EmailUpdateVerificationProto creationTime
             */

            /**
             * Constructs a new EmailUpdateVerificationProto.
             * @memberof waiternow.common
             * @classdesc Represents an EmailUpdateVerificationProto.
             * @implements IEmailUpdateVerificationProto
             * @constructor
             * @param {waiternow.common.IEmailUpdateVerificationProto=} [properties] Properties to set
             */
            function EmailUpdateVerificationProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * EmailUpdateVerificationProto userId.
             * @member {string} userId
             * @memberof waiternow.common.EmailUpdateVerificationProto
             * @instance
             */
            EmailUpdateVerificationProto.prototype.userId = "";

            /**
             * EmailUpdateVerificationProto newEmail.
             * @member {string} newEmail
             * @memberof waiternow.common.EmailUpdateVerificationProto
             * @instance
             */
            EmailUpdateVerificationProto.prototype.newEmail = "";

            /**
             * EmailUpdateVerificationProto creationTime.
             * @member {google.protobuf.ITimestamp|null|undefined} creationTime
             * @memberof waiternow.common.EmailUpdateVerificationProto
             * @instance
             */
            EmailUpdateVerificationProto.prototype.creationTime = null;

            /**
             * Creates a new EmailUpdateVerificationProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.EmailUpdateVerificationProto
             * @static
             * @param {waiternow.common.IEmailUpdateVerificationProto=} [properties] Properties to set
             * @returns {waiternow.common.EmailUpdateVerificationProto} EmailUpdateVerificationProto instance
             */
            EmailUpdateVerificationProto.create = function create(properties) {
                return new EmailUpdateVerificationProto(properties);
            };

            /**
             * Encodes the specified EmailUpdateVerificationProto message. Does not implicitly {@link waiternow.common.EmailUpdateVerificationProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.EmailUpdateVerificationProto
             * @static
             * @param {waiternow.common.IEmailUpdateVerificationProto} message EmailUpdateVerificationProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EmailUpdateVerificationProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.userId);
                if (message.newEmail != null && Object.hasOwnProperty.call(message, "newEmail"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.newEmail);
                if (message.creationTime != null && Object.hasOwnProperty.call(message, "creationTime"))
                    $root.google.protobuf.Timestamp.encode(message.creationTime, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified EmailUpdateVerificationProto message, length delimited. Does not implicitly {@link waiternow.common.EmailUpdateVerificationProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.EmailUpdateVerificationProto
             * @static
             * @param {waiternow.common.IEmailUpdateVerificationProto} message EmailUpdateVerificationProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EmailUpdateVerificationProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an EmailUpdateVerificationProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.EmailUpdateVerificationProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.EmailUpdateVerificationProto} EmailUpdateVerificationProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EmailUpdateVerificationProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.EmailUpdateVerificationProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.userId = reader.string();
                            break;
                        }
                    case 2: {
                            message.newEmail = reader.string();
                            break;
                        }
                    case 3: {
                            message.creationTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an EmailUpdateVerificationProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.EmailUpdateVerificationProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.EmailUpdateVerificationProto} EmailUpdateVerificationProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EmailUpdateVerificationProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an EmailUpdateVerificationProto message.
             * @function verify
             * @memberof waiternow.common.EmailUpdateVerificationProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            EmailUpdateVerificationProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.userId != null && message.hasOwnProperty("userId"))
                    if (!$util.isString(message.userId))
                        return "userId: string expected";
                if (message.newEmail != null && message.hasOwnProperty("newEmail"))
                    if (!$util.isString(message.newEmail))
                        return "newEmail: string expected";
                if (message.creationTime != null && message.hasOwnProperty("creationTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.creationTime);
                    if (error)
                        return "creationTime." + error;
                }
                return null;
            };

            /**
             * Creates an EmailUpdateVerificationProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.EmailUpdateVerificationProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.EmailUpdateVerificationProto} EmailUpdateVerificationProto
             */
            EmailUpdateVerificationProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.EmailUpdateVerificationProto)
                    return object;
                var message = new $root.waiternow.common.EmailUpdateVerificationProto();
                if (object.userId != null)
                    message.userId = String(object.userId);
                if (object.newEmail != null)
                    message.newEmail = String(object.newEmail);
                if (object.creationTime != null) {
                    if (typeof object.creationTime !== "object")
                        throw TypeError(".waiternow.common.EmailUpdateVerificationProto.creationTime: object expected");
                    message.creationTime = $root.google.protobuf.Timestamp.fromObject(object.creationTime);
                }
                return message;
            };

            /**
             * Creates a plain object from an EmailUpdateVerificationProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.EmailUpdateVerificationProto
             * @static
             * @param {waiternow.common.EmailUpdateVerificationProto} message EmailUpdateVerificationProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            EmailUpdateVerificationProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.userId = "";
                    object.newEmail = "";
                    object.creationTime = null;
                }
                if (message.userId != null && message.hasOwnProperty("userId"))
                    object.userId = message.userId;
                if (message.newEmail != null && message.hasOwnProperty("newEmail"))
                    object.newEmail = message.newEmail;
                if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                    object.creationTime = $root.google.protobuf.Timestamp.toObject(message.creationTime, options);
                return object;
            };

            /**
             * Converts this EmailUpdateVerificationProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.EmailUpdateVerificationProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            EmailUpdateVerificationProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for EmailUpdateVerificationProto
             * @function getTypeUrl
             * @memberof waiternow.common.EmailUpdateVerificationProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            EmailUpdateVerificationProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.EmailUpdateVerificationProto";
            };

            return EmailUpdateVerificationProto;
        })();

        common.ResetPasswordAuthenticityProto = (function() {

            /**
             * Properties of a ResetPasswordAuthenticityProto.
             * @memberof waiternow.common
             * @interface IResetPasswordAuthenticityProto
             * @property {string|null} [userId] ResetPasswordAuthenticityProto userId
             * @property {google.protobuf.ITimestamp|null} [creationTime] ResetPasswordAuthenticityProto creationTime
             */

            /**
             * Constructs a new ResetPasswordAuthenticityProto.
             * @memberof waiternow.common
             * @classdesc Represents a ResetPasswordAuthenticityProto.
             * @implements IResetPasswordAuthenticityProto
             * @constructor
             * @param {waiternow.common.IResetPasswordAuthenticityProto=} [properties] Properties to set
             */
            function ResetPasswordAuthenticityProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ResetPasswordAuthenticityProto userId.
             * @member {string} userId
             * @memberof waiternow.common.ResetPasswordAuthenticityProto
             * @instance
             */
            ResetPasswordAuthenticityProto.prototype.userId = "";

            /**
             * ResetPasswordAuthenticityProto creationTime.
             * @member {google.protobuf.ITimestamp|null|undefined} creationTime
             * @memberof waiternow.common.ResetPasswordAuthenticityProto
             * @instance
             */
            ResetPasswordAuthenticityProto.prototype.creationTime = null;

            /**
             * Creates a new ResetPasswordAuthenticityProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.ResetPasswordAuthenticityProto
             * @static
             * @param {waiternow.common.IResetPasswordAuthenticityProto=} [properties] Properties to set
             * @returns {waiternow.common.ResetPasswordAuthenticityProto} ResetPasswordAuthenticityProto instance
             */
            ResetPasswordAuthenticityProto.create = function create(properties) {
                return new ResetPasswordAuthenticityProto(properties);
            };

            /**
             * Encodes the specified ResetPasswordAuthenticityProto message. Does not implicitly {@link waiternow.common.ResetPasswordAuthenticityProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.ResetPasswordAuthenticityProto
             * @static
             * @param {waiternow.common.IResetPasswordAuthenticityProto} message ResetPasswordAuthenticityProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ResetPasswordAuthenticityProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.userId);
                if (message.creationTime != null && Object.hasOwnProperty.call(message, "creationTime"))
                    $root.google.protobuf.Timestamp.encode(message.creationTime, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified ResetPasswordAuthenticityProto message, length delimited. Does not implicitly {@link waiternow.common.ResetPasswordAuthenticityProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.ResetPasswordAuthenticityProto
             * @static
             * @param {waiternow.common.IResetPasswordAuthenticityProto} message ResetPasswordAuthenticityProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ResetPasswordAuthenticityProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ResetPasswordAuthenticityProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.ResetPasswordAuthenticityProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.ResetPasswordAuthenticityProto} ResetPasswordAuthenticityProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ResetPasswordAuthenticityProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.ResetPasswordAuthenticityProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.userId = reader.string();
                            break;
                        }
                    case 2: {
                            message.creationTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ResetPasswordAuthenticityProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.ResetPasswordAuthenticityProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.ResetPasswordAuthenticityProto} ResetPasswordAuthenticityProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ResetPasswordAuthenticityProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ResetPasswordAuthenticityProto message.
             * @function verify
             * @memberof waiternow.common.ResetPasswordAuthenticityProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ResetPasswordAuthenticityProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.userId != null && message.hasOwnProperty("userId"))
                    if (!$util.isString(message.userId))
                        return "userId: string expected";
                if (message.creationTime != null && message.hasOwnProperty("creationTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.creationTime);
                    if (error)
                        return "creationTime." + error;
                }
                return null;
            };

            /**
             * Creates a ResetPasswordAuthenticityProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.ResetPasswordAuthenticityProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.ResetPasswordAuthenticityProto} ResetPasswordAuthenticityProto
             */
            ResetPasswordAuthenticityProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.ResetPasswordAuthenticityProto)
                    return object;
                var message = new $root.waiternow.common.ResetPasswordAuthenticityProto();
                if (object.userId != null)
                    message.userId = String(object.userId);
                if (object.creationTime != null) {
                    if (typeof object.creationTime !== "object")
                        throw TypeError(".waiternow.common.ResetPasswordAuthenticityProto.creationTime: object expected");
                    message.creationTime = $root.google.protobuf.Timestamp.fromObject(object.creationTime);
                }
                return message;
            };

            /**
             * Creates a plain object from a ResetPasswordAuthenticityProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.ResetPasswordAuthenticityProto
             * @static
             * @param {waiternow.common.ResetPasswordAuthenticityProto} message ResetPasswordAuthenticityProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ResetPasswordAuthenticityProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.userId = "";
                    object.creationTime = null;
                }
                if (message.userId != null && message.hasOwnProperty("userId"))
                    object.userId = message.userId;
                if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                    object.creationTime = $root.google.protobuf.Timestamp.toObject(message.creationTime, options);
                return object;
            };

            /**
             * Converts this ResetPasswordAuthenticityProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.ResetPasswordAuthenticityProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ResetPasswordAuthenticityProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for ResetPasswordAuthenticityProto
             * @function getTypeUrl
             * @memberof waiternow.common.ResetPasswordAuthenticityProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            ResetPasswordAuthenticityProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.ResetPasswordAuthenticityProto";
            };

            return ResetPasswordAuthenticityProto;
        })();

        common.CredentialsProto = (function() {

            /**
             * Properties of a CredentialsProto.
             * @memberof waiternow.common
             * @interface ICredentialsProto
             * @property {string|null} [email] CredentialsProto email
             * @property {string|null} [passwordHash] CredentialsProto passwordHash
             * @property {google.protobuf.ITimestamp|null} [creationTime] CredentialsProto creationTime
             * @property {google.protobuf.IDuration|null} [expiration] CredentialsProto expiration
             */

            /**
             * Constructs a new CredentialsProto.
             * @memberof waiternow.common
             * @classdesc Represents a CredentialsProto.
             * @implements ICredentialsProto
             * @constructor
             * @param {waiternow.common.ICredentialsProto=} [properties] Properties to set
             */
            function CredentialsProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * CredentialsProto email.
             * @member {string} email
             * @memberof waiternow.common.CredentialsProto
             * @instance
             */
            CredentialsProto.prototype.email = "";

            /**
             * CredentialsProto passwordHash.
             * @member {string} passwordHash
             * @memberof waiternow.common.CredentialsProto
             * @instance
             */
            CredentialsProto.prototype.passwordHash = "";

            /**
             * CredentialsProto creationTime.
             * @member {google.protobuf.ITimestamp|null|undefined} creationTime
             * @memberof waiternow.common.CredentialsProto
             * @instance
             */
            CredentialsProto.prototype.creationTime = null;

            /**
             * CredentialsProto expiration.
             * @member {google.protobuf.IDuration|null|undefined} expiration
             * @memberof waiternow.common.CredentialsProto
             * @instance
             */
            CredentialsProto.prototype.expiration = null;

            /**
             * Creates a new CredentialsProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.CredentialsProto
             * @static
             * @param {waiternow.common.ICredentialsProto=} [properties] Properties to set
             * @returns {waiternow.common.CredentialsProto} CredentialsProto instance
             */
            CredentialsProto.create = function create(properties) {
                return new CredentialsProto(properties);
            };

            /**
             * Encodes the specified CredentialsProto message. Does not implicitly {@link waiternow.common.CredentialsProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.CredentialsProto
             * @static
             * @param {waiternow.common.ICredentialsProto} message CredentialsProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CredentialsProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
                if (message.passwordHash != null && Object.hasOwnProperty.call(message, "passwordHash"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.passwordHash);
                if (message.creationTime != null && Object.hasOwnProperty.call(message, "creationTime"))
                    $root.google.protobuf.Timestamp.encode(message.creationTime, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.expiration != null && Object.hasOwnProperty.call(message, "expiration"))
                    $root.google.protobuf.Duration.encode(message.expiration, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified CredentialsProto message, length delimited. Does not implicitly {@link waiternow.common.CredentialsProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.CredentialsProto
             * @static
             * @param {waiternow.common.ICredentialsProto} message CredentialsProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CredentialsProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CredentialsProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.CredentialsProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.CredentialsProto} CredentialsProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CredentialsProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CredentialsProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.email = reader.string();
                            break;
                        }
                    case 2: {
                            message.passwordHash = reader.string();
                            break;
                        }
                    case 3: {
                            message.creationTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 4: {
                            message.expiration = $root.google.protobuf.Duration.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CredentialsProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.CredentialsProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.CredentialsProto} CredentialsProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CredentialsProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CredentialsProto message.
             * @function verify
             * @memberof waiternow.common.CredentialsProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CredentialsProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.email != null && message.hasOwnProperty("email"))
                    if (!$util.isString(message.email))
                        return "email: string expected";
                if (message.passwordHash != null && message.hasOwnProperty("passwordHash"))
                    if (!$util.isString(message.passwordHash))
                        return "passwordHash: string expected";
                if (message.creationTime != null && message.hasOwnProperty("creationTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.creationTime);
                    if (error)
                        return "creationTime." + error;
                }
                if (message.expiration != null && message.hasOwnProperty("expiration")) {
                    var error = $root.google.protobuf.Duration.verify(message.expiration);
                    if (error)
                        return "expiration." + error;
                }
                return null;
            };

            /**
             * Creates a CredentialsProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.CredentialsProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.CredentialsProto} CredentialsProto
             */
            CredentialsProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.CredentialsProto)
                    return object;
                var message = new $root.waiternow.common.CredentialsProto();
                if (object.email != null)
                    message.email = String(object.email);
                if (object.passwordHash != null)
                    message.passwordHash = String(object.passwordHash);
                if (object.creationTime != null) {
                    if (typeof object.creationTime !== "object")
                        throw TypeError(".waiternow.common.CredentialsProto.creationTime: object expected");
                    message.creationTime = $root.google.protobuf.Timestamp.fromObject(object.creationTime);
                }
                if (object.expiration != null) {
                    if (typeof object.expiration !== "object")
                        throw TypeError(".waiternow.common.CredentialsProto.expiration: object expected");
                    message.expiration = $root.google.protobuf.Duration.fromObject(object.expiration);
                }
                return message;
            };

            /**
             * Creates a plain object from a CredentialsProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.CredentialsProto
             * @static
             * @param {waiternow.common.CredentialsProto} message CredentialsProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CredentialsProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.email = "";
                    object.passwordHash = "";
                    object.creationTime = null;
                    object.expiration = null;
                }
                if (message.email != null && message.hasOwnProperty("email"))
                    object.email = message.email;
                if (message.passwordHash != null && message.hasOwnProperty("passwordHash"))
                    object.passwordHash = message.passwordHash;
                if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                    object.creationTime = $root.google.protobuf.Timestamp.toObject(message.creationTime, options);
                if (message.expiration != null && message.hasOwnProperty("expiration"))
                    object.expiration = $root.google.protobuf.Duration.toObject(message.expiration, options);
                return object;
            };

            /**
             * Converts this CredentialsProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.CredentialsProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CredentialsProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for CredentialsProto
             * @function getTypeUrl
             * @memberof waiternow.common.CredentialsProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            CredentialsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.CredentialsProto";
            };

            return CredentialsProto;
        })();

        common.EventProto = (function() {

            /**
             * Properties of an EventProto.
             * @memberof waiternow.common
             * @interface IEventProto
             * @property {string|null} [id] EventProto id
             * @property {google.protobuf.ITimestamp|null} [creationTime] EventProto creationTime
             * @property {google.protobuf.ITimestamp|null} [lastUpdateTime] EventProto lastUpdateTime
             * @property {waiternow.common.EventProto.ISourceProto|null} [source] EventProto source
             * @property {string|null} [name] EventProto name
             * @property {string|null} [summary] EventProto summary
             * @property {google.protobuf.IAny|null} [data] EventProto data
             * @property {waiternow.common.EventProto.CriticalityLevel|null} [level] EventProto level
             * @property {waiternow.common.EventProto.IRedundantDataProto|null} [redundantData] EventProto redundantData
             */

            /**
             * Constructs a new EventProto.
             * @memberof waiternow.common
             * @classdesc Represents an EventProto.
             * @implements IEventProto
             * @constructor
             * @param {waiternow.common.IEventProto=} [properties] Properties to set
             */
            function EventProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * EventProto id.
             * @member {string} id
             * @memberof waiternow.common.EventProto
             * @instance
             */
            EventProto.prototype.id = "";

            /**
             * EventProto creationTime.
             * @member {google.protobuf.ITimestamp|null|undefined} creationTime
             * @memberof waiternow.common.EventProto
             * @instance
             */
            EventProto.prototype.creationTime = null;

            /**
             * EventProto lastUpdateTime.
             * @member {google.protobuf.ITimestamp|null|undefined} lastUpdateTime
             * @memberof waiternow.common.EventProto
             * @instance
             */
            EventProto.prototype.lastUpdateTime = null;

            /**
             * EventProto source.
             * @member {waiternow.common.EventProto.ISourceProto|null|undefined} source
             * @memberof waiternow.common.EventProto
             * @instance
             */
            EventProto.prototype.source = null;

            /**
             * EventProto name.
             * @member {string} name
             * @memberof waiternow.common.EventProto
             * @instance
             */
            EventProto.prototype.name = "";

            /**
             * EventProto summary.
             * @member {string} summary
             * @memberof waiternow.common.EventProto
             * @instance
             */
            EventProto.prototype.summary = "";

            /**
             * EventProto data.
             * @member {google.protobuf.IAny|null|undefined} data
             * @memberof waiternow.common.EventProto
             * @instance
             */
            EventProto.prototype.data = null;

            /**
             * EventProto level.
             * @member {waiternow.common.EventProto.CriticalityLevel} level
             * @memberof waiternow.common.EventProto
             * @instance
             */
            EventProto.prototype.level = 0;

            /**
             * EventProto redundantData.
             * @member {waiternow.common.EventProto.IRedundantDataProto|null|undefined} redundantData
             * @memberof waiternow.common.EventProto
             * @instance
             */
            EventProto.prototype.redundantData = null;

            /**
             * Creates a new EventProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.EventProto
             * @static
             * @param {waiternow.common.IEventProto=} [properties] Properties to set
             * @returns {waiternow.common.EventProto} EventProto instance
             */
            EventProto.create = function create(properties) {
                return new EventProto(properties);
            };

            /**
             * Encodes the specified EventProto message. Does not implicitly {@link waiternow.common.EventProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.EventProto
             * @static
             * @param {waiternow.common.IEventProto} message EventProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EventProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                if (message.creationTime != null && Object.hasOwnProperty.call(message, "creationTime"))
                    $root.google.protobuf.Timestamp.encode(message.creationTime, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                    $root.google.protobuf.Timestamp.encode(message.lastUpdateTime, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.source != null && Object.hasOwnProperty.call(message, "source"))
                    $root.waiternow.common.EventProto.SourceProto.encode(message.source, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.name);
                if (message.summary != null && Object.hasOwnProperty.call(message, "summary"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.summary);
                if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                    $root.google.protobuf.Any.encode(message.data, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                if (message.level != null && Object.hasOwnProperty.call(message, "level"))
                    writer.uint32(/* id 8, wireType 0 =*/64).int32(message.level);
                if (message.redundantData != null && Object.hasOwnProperty.call(message, "redundantData"))
                    $root.waiternow.common.EventProto.RedundantDataProto.encode(message.redundantData, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified EventProto message, length delimited. Does not implicitly {@link waiternow.common.EventProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.EventProto
             * @static
             * @param {waiternow.common.IEventProto} message EventProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EventProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an EventProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.EventProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.EventProto} EventProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EventProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.EventProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.id = reader.string();
                            break;
                        }
                    case 2: {
                            message.creationTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 3: {
                            message.lastUpdateTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 4: {
                            message.source = $root.waiternow.common.EventProto.SourceProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 5: {
                            message.name = reader.string();
                            break;
                        }
                    case 6: {
                            message.summary = reader.string();
                            break;
                        }
                    case 7: {
                            message.data = $root.google.protobuf.Any.decode(reader, reader.uint32());
                            break;
                        }
                    case 8: {
                            message.level = reader.int32();
                            break;
                        }
                    case 9: {
                            message.redundantData = $root.waiternow.common.EventProto.RedundantDataProto.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an EventProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.EventProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.EventProto} EventProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EventProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an EventProto message.
             * @function verify
             * @memberof waiternow.common.EventProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            EventProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.id != null && message.hasOwnProperty("id"))
                    if (!$util.isString(message.id))
                        return "id: string expected";
                if (message.creationTime != null && message.hasOwnProperty("creationTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.creationTime);
                    if (error)
                        return "creationTime." + error;
                }
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.lastUpdateTime);
                    if (error)
                        return "lastUpdateTime." + error;
                }
                if (message.source != null && message.hasOwnProperty("source")) {
                    var error = $root.waiternow.common.EventProto.SourceProto.verify(message.source);
                    if (error)
                        return "source." + error;
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.summary != null && message.hasOwnProperty("summary"))
                    if (!$util.isString(message.summary))
                        return "summary: string expected";
                if (message.data != null && message.hasOwnProperty("data")) {
                    var error = $root.google.protobuf.Any.verify(message.data);
                    if (error)
                        return "data." + error;
                }
                if (message.level != null && message.hasOwnProperty("level"))
                    switch (message.level) {
                    default:
                        return "level: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                        break;
                    }
                if (message.redundantData != null && message.hasOwnProperty("redundantData")) {
                    var error = $root.waiternow.common.EventProto.RedundantDataProto.verify(message.redundantData);
                    if (error)
                        return "redundantData." + error;
                }
                return null;
            };

            /**
             * Creates an EventProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.EventProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.EventProto} EventProto
             */
            EventProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.EventProto)
                    return object;
                var message = new $root.waiternow.common.EventProto();
                if (object.id != null)
                    message.id = String(object.id);
                if (object.creationTime != null) {
                    if (typeof object.creationTime !== "object")
                        throw TypeError(".waiternow.common.EventProto.creationTime: object expected");
                    message.creationTime = $root.google.protobuf.Timestamp.fromObject(object.creationTime);
                }
                if (object.lastUpdateTime != null) {
                    if (typeof object.lastUpdateTime !== "object")
                        throw TypeError(".waiternow.common.EventProto.lastUpdateTime: object expected");
                    message.lastUpdateTime = $root.google.protobuf.Timestamp.fromObject(object.lastUpdateTime);
                }
                if (object.source != null) {
                    if (typeof object.source !== "object")
                        throw TypeError(".waiternow.common.EventProto.source: object expected");
                    message.source = $root.waiternow.common.EventProto.SourceProto.fromObject(object.source);
                }
                if (object.name != null)
                    message.name = String(object.name);
                if (object.summary != null)
                    message.summary = String(object.summary);
                if (object.data != null) {
                    if (typeof object.data !== "object")
                        throw TypeError(".waiternow.common.EventProto.data: object expected");
                    message.data = $root.google.protobuf.Any.fromObject(object.data);
                }
                switch (object.level) {
                default:
                    if (typeof object.level === "number") {
                        message.level = object.level;
                        break;
                    }
                    break;
                case "LEVEL_UNSPECIFIED":
                case 0:
                    message.level = 0;
                    break;
                case "CRITICAL":
                case 1:
                    message.level = 1;
                    break;
                case "WARNING":
                case 2:
                    message.level = 2;
                    break;
                case "INFO":
                case 3:
                    message.level = 3;
                    break;
                case "DEBUG":
                case 4:
                    message.level = 4;
                    break;
                }
                if (object.redundantData != null) {
                    if (typeof object.redundantData !== "object")
                        throw TypeError(".waiternow.common.EventProto.redundantData: object expected");
                    message.redundantData = $root.waiternow.common.EventProto.RedundantDataProto.fromObject(object.redundantData);
                }
                return message;
            };

            /**
             * Creates a plain object from an EventProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.EventProto
             * @static
             * @param {waiternow.common.EventProto} message EventProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            EventProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.id = "";
                    object.creationTime = null;
                    object.lastUpdateTime = null;
                    object.source = null;
                    object.name = "";
                    object.summary = "";
                    object.data = null;
                    object.level = options.enums === String ? "LEVEL_UNSPECIFIED" : 0;
                    object.redundantData = null;
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                    object.creationTime = $root.google.protobuf.Timestamp.toObject(message.creationTime, options);
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                    object.lastUpdateTime = $root.google.protobuf.Timestamp.toObject(message.lastUpdateTime, options);
                if (message.source != null && message.hasOwnProperty("source"))
                    object.source = $root.waiternow.common.EventProto.SourceProto.toObject(message.source, options);
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.summary != null && message.hasOwnProperty("summary"))
                    object.summary = message.summary;
                if (message.data != null && message.hasOwnProperty("data"))
                    object.data = $root.google.protobuf.Any.toObject(message.data, options);
                if (message.level != null && message.hasOwnProperty("level"))
                    object.level = options.enums === String ? $root.waiternow.common.EventProto.CriticalityLevel[message.level] === undefined ? message.level : $root.waiternow.common.EventProto.CriticalityLevel[message.level] : message.level;
                if (message.redundantData != null && message.hasOwnProperty("redundantData"))
                    object.redundantData = $root.waiternow.common.EventProto.RedundantDataProto.toObject(message.redundantData, options);
                return object;
            };

            /**
             * Converts this EventProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.EventProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            EventProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for EventProto
             * @function getTypeUrl
             * @memberof waiternow.common.EventProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            EventProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.EventProto";
            };

            EventProto.SourceProto = (function() {

                /**
                 * Properties of a SourceProto.
                 * @memberof waiternow.common.EventProto
                 * @interface ISourceProto
                 * @property {string|null} [deviceId] SourceProto deviceId
                 * @property {string|null} [userId] SourceProto userId
                 * @property {string|null} [businessId] SourceProto businessId
                 * @property {string|null} [locationId] SourceProto locationId
                 */

                /**
                 * Constructs a new SourceProto.
                 * @memberof waiternow.common.EventProto
                 * @classdesc Represents a SourceProto.
                 * @implements ISourceProto
                 * @constructor
                 * @param {waiternow.common.EventProto.ISourceProto=} [properties] Properties to set
                 */
                function SourceProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SourceProto deviceId.
                 * @member {string} deviceId
                 * @memberof waiternow.common.EventProto.SourceProto
                 * @instance
                 */
                SourceProto.prototype.deviceId = "";

                /**
                 * SourceProto userId.
                 * @member {string} userId
                 * @memberof waiternow.common.EventProto.SourceProto
                 * @instance
                 */
                SourceProto.prototype.userId = "";

                /**
                 * SourceProto businessId.
                 * @member {string} businessId
                 * @memberof waiternow.common.EventProto.SourceProto
                 * @instance
                 */
                SourceProto.prototype.businessId = "";

                /**
                 * SourceProto locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.EventProto.SourceProto
                 * @instance
                 */
                SourceProto.prototype.locationId = "";

                /**
                 * Creates a new SourceProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.EventProto.SourceProto
                 * @static
                 * @param {waiternow.common.EventProto.ISourceProto=} [properties] Properties to set
                 * @returns {waiternow.common.EventProto.SourceProto} SourceProto instance
                 */
                SourceProto.create = function create(properties) {
                    return new SourceProto(properties);
                };

                /**
                 * Encodes the specified SourceProto message. Does not implicitly {@link waiternow.common.EventProto.SourceProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.EventProto.SourceProto
                 * @static
                 * @param {waiternow.common.EventProto.ISourceProto} message SourceProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SourceProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceId != null && Object.hasOwnProperty.call(message, "deviceId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.deviceId);
                    if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.userId);
                    if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.businessId);
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.locationId);
                    return writer;
                };

                /**
                 * Encodes the specified SourceProto message, length delimited. Does not implicitly {@link waiternow.common.EventProto.SourceProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.EventProto.SourceProto
                 * @static
                 * @param {waiternow.common.EventProto.ISourceProto} message SourceProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SourceProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SourceProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.EventProto.SourceProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.EventProto.SourceProto} SourceProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SourceProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.EventProto.SourceProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceId = reader.string();
                                break;
                            }
                        case 2: {
                                message.userId = reader.string();
                                break;
                            }
                        case 3: {
                                message.businessId = reader.string();
                                break;
                            }
                        case 4: {
                                message.locationId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SourceProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.EventProto.SourceProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.EventProto.SourceProto} SourceProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SourceProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SourceProto message.
                 * @function verify
                 * @memberof waiternow.common.EventProto.SourceProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SourceProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                        if (!$util.isString(message.deviceId))
                            return "deviceId: string expected";
                    if (message.userId != null && message.hasOwnProperty("userId"))
                        if (!$util.isString(message.userId))
                            return "userId: string expected";
                    if (message.businessId != null && message.hasOwnProperty("businessId"))
                        if (!$util.isString(message.businessId))
                            return "businessId: string expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    return null;
                };

                /**
                 * Creates a SourceProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.EventProto.SourceProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.EventProto.SourceProto} SourceProto
                 */
                SourceProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.EventProto.SourceProto)
                        return object;
                    var message = new $root.waiternow.common.EventProto.SourceProto();
                    if (object.deviceId != null)
                        message.deviceId = String(object.deviceId);
                    if (object.userId != null)
                        message.userId = String(object.userId);
                    if (object.businessId != null)
                        message.businessId = String(object.businessId);
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    return message;
                };

                /**
                 * Creates a plain object from a SourceProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.EventProto.SourceProto
                 * @static
                 * @param {waiternow.common.EventProto.SourceProto} message SourceProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SourceProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.deviceId = "";
                        object.userId = "";
                        object.businessId = "";
                        object.locationId = "";
                    }
                    if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                        object.deviceId = message.deviceId;
                    if (message.userId != null && message.hasOwnProperty("userId"))
                        object.userId = message.userId;
                    if (message.businessId != null && message.hasOwnProperty("businessId"))
                        object.businessId = message.businessId;
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    return object;
                };

                /**
                 * Converts this SourceProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.EventProto.SourceProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SourceProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for SourceProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.EventProto.SourceProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                SourceProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.EventProto.SourceProto";
                };

                return SourceProto;
            })();

            /**
             * CriticalityLevel enum.
             * @name waiternow.common.EventProto.CriticalityLevel
             * @enum {number}
             * @property {number} LEVEL_UNSPECIFIED=0 LEVEL_UNSPECIFIED value
             * @property {number} CRITICAL=1 CRITICAL value
             * @property {number} WARNING=2 WARNING value
             * @property {number} INFO=3 INFO value
             * @property {number} DEBUG=4 DEBUG value
             */
            EventProto.CriticalityLevel = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "LEVEL_UNSPECIFIED"] = 0;
                values[valuesById[1] = "CRITICAL"] = 1;
                values[valuesById[2] = "WARNING"] = 2;
                values[valuesById[3] = "INFO"] = 3;
                values[valuesById[4] = "DEBUG"] = 4;
                return values;
            })();

            EventProto.RedundantDataProto = (function() {

                /**
                 * Properties of a RedundantDataProto.
                 * @memberof waiternow.common.EventProto
                 * @interface IRedundantDataProto
                 * @property {waiternow.common.DeviceProto.ClientType|null} [clientType] RedundantDataProto clientType
                 * @property {waiternow.common.DeviceProto.DeviceType|null} [deviceType] RedundantDataProto deviceType
                 */

                /**
                 * Constructs a new RedundantDataProto.
                 * @memberof waiternow.common.EventProto
                 * @classdesc Represents a RedundantDataProto.
                 * @implements IRedundantDataProto
                 * @constructor
                 * @param {waiternow.common.EventProto.IRedundantDataProto=} [properties] Properties to set
                 */
                function RedundantDataProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * RedundantDataProto clientType.
                 * @member {waiternow.common.DeviceProto.ClientType} clientType
                 * @memberof waiternow.common.EventProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.clientType = 0;

                /**
                 * RedundantDataProto deviceType.
                 * @member {waiternow.common.DeviceProto.DeviceType} deviceType
                 * @memberof waiternow.common.EventProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.deviceType = 0;

                /**
                 * Creates a new RedundantDataProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.EventProto.RedundantDataProto
                 * @static
                 * @param {waiternow.common.EventProto.IRedundantDataProto=} [properties] Properties to set
                 * @returns {waiternow.common.EventProto.RedundantDataProto} RedundantDataProto instance
                 */
                RedundantDataProto.create = function create(properties) {
                    return new RedundantDataProto(properties);
                };

                /**
                 * Encodes the specified RedundantDataProto message. Does not implicitly {@link waiternow.common.EventProto.RedundantDataProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.EventProto.RedundantDataProto
                 * @static
                 * @param {waiternow.common.EventProto.IRedundantDataProto} message RedundantDataProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RedundantDataProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.clientType != null && Object.hasOwnProperty.call(message, "clientType"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.clientType);
                    if (message.deviceType != null && Object.hasOwnProperty.call(message, "deviceType"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.deviceType);
                    return writer;
                };

                /**
                 * Encodes the specified RedundantDataProto message, length delimited. Does not implicitly {@link waiternow.common.EventProto.RedundantDataProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.EventProto.RedundantDataProto
                 * @static
                 * @param {waiternow.common.EventProto.IRedundantDataProto} message RedundantDataProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RedundantDataProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a RedundantDataProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.EventProto.RedundantDataProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.EventProto.RedundantDataProto} RedundantDataProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RedundantDataProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.EventProto.RedundantDataProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.clientType = reader.int32();
                                break;
                            }
                        case 2: {
                                message.deviceType = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a RedundantDataProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.EventProto.RedundantDataProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.EventProto.RedundantDataProto} RedundantDataProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RedundantDataProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a RedundantDataProto message.
                 * @function verify
                 * @memberof waiternow.common.EventProto.RedundantDataProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                RedundantDataProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.clientType != null && message.hasOwnProperty("clientType"))
                        switch (message.clientType) {
                        default:
                            return "clientType: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.deviceType != null && message.hasOwnProperty("deviceType"))
                        switch (message.deviceType) {
                        default:
                            return "deviceType: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                            break;
                        }
                    return null;
                };

                /**
                 * Creates a RedundantDataProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.EventProto.RedundantDataProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.EventProto.RedundantDataProto} RedundantDataProto
                 */
                RedundantDataProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.EventProto.RedundantDataProto)
                        return object;
                    var message = new $root.waiternow.common.EventProto.RedundantDataProto();
                    switch (object.clientType) {
                    default:
                        if (typeof object.clientType === "number") {
                            message.clientType = object.clientType;
                            break;
                        }
                        break;
                    case "CLIENT_TYPE_UNSPECIFIED":
                    case 0:
                        message.clientType = 0;
                        break;
                    case "BUSINESS":
                    case 1:
                        message.clientType = 1;
                        break;
                    case "CONSUMER":
                    case 2:
                        message.clientType = 2;
                        break;
                    }
                    switch (object.deviceType) {
                    default:
                        if (typeof object.deviceType === "number") {
                            message.deviceType = object.deviceType;
                            break;
                        }
                        break;
                    case "DEVICE_TYPE_UNSPECIFIED":
                    case 0:
                        message.deviceType = 0;
                        break;
                    case "WEB":
                    case 1:
                        message.deviceType = 1;
                        break;
                    case "ANDROID":
                    case 2:
                        message.deviceType = 2;
                        break;
                    case "APPLE":
                    case 3:
                        message.deviceType = 3;
                        break;
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a RedundantDataProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.EventProto.RedundantDataProto
                 * @static
                 * @param {waiternow.common.EventProto.RedundantDataProto} message RedundantDataProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                RedundantDataProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.clientType = options.enums === String ? "CLIENT_TYPE_UNSPECIFIED" : 0;
                        object.deviceType = options.enums === String ? "DEVICE_TYPE_UNSPECIFIED" : 0;
                    }
                    if (message.clientType != null && message.hasOwnProperty("clientType"))
                        object.clientType = options.enums === String ? $root.waiternow.common.DeviceProto.ClientType[message.clientType] === undefined ? message.clientType : $root.waiternow.common.DeviceProto.ClientType[message.clientType] : message.clientType;
                    if (message.deviceType != null && message.hasOwnProperty("deviceType"))
                        object.deviceType = options.enums === String ? $root.waiternow.common.DeviceProto.DeviceType[message.deviceType] === undefined ? message.deviceType : $root.waiternow.common.DeviceProto.DeviceType[message.deviceType] : message.deviceType;
                    return object;
                };

                /**
                 * Converts this RedundantDataProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.EventProto.RedundantDataProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                RedundantDataProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for RedundantDataProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.EventProto.RedundantDataProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                RedundantDataProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.EventProto.RedundantDataProto";
                };

                return RedundantDataProto;
            })();

            return EventProto;
        })();

        common.EventsProto = (function() {

            /**
             * Properties of an EventsProto.
             * @memberof waiternow.common
             * @interface IEventsProto
             * @property {Array.<waiternow.common.IEventProto>|null} [events] EventsProto events
             * @property {string|null} [continuationToken] EventsProto continuationToken
             */

            /**
             * Constructs a new EventsProto.
             * @memberof waiternow.common
             * @classdesc Represents an EventsProto.
             * @implements IEventsProto
             * @constructor
             * @param {waiternow.common.IEventsProto=} [properties] Properties to set
             */
            function EventsProto(properties) {
                this.events = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * EventsProto events.
             * @member {Array.<waiternow.common.IEventProto>} events
             * @memberof waiternow.common.EventsProto
             * @instance
             */
            EventsProto.prototype.events = $util.emptyArray;

            /**
             * EventsProto continuationToken.
             * @member {string} continuationToken
             * @memberof waiternow.common.EventsProto
             * @instance
             */
            EventsProto.prototype.continuationToken = "";

            /**
             * Creates a new EventsProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.EventsProto
             * @static
             * @param {waiternow.common.IEventsProto=} [properties] Properties to set
             * @returns {waiternow.common.EventsProto} EventsProto instance
             */
            EventsProto.create = function create(properties) {
                return new EventsProto(properties);
            };

            /**
             * Encodes the specified EventsProto message. Does not implicitly {@link waiternow.common.EventsProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.EventsProto
             * @static
             * @param {waiternow.common.IEventsProto} message EventsProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EventsProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.events != null && message.events.length)
                    for (var i = 0; i < message.events.length; ++i)
                        $root.waiternow.common.EventProto.encode(message.events[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.continuationToken);
                return writer;
            };

            /**
             * Encodes the specified EventsProto message, length delimited. Does not implicitly {@link waiternow.common.EventsProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.EventsProto
             * @static
             * @param {waiternow.common.IEventsProto} message EventsProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EventsProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an EventsProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.EventsProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.EventsProto} EventsProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EventsProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.EventsProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            if (!(message.events && message.events.length))
                                message.events = [];
                            message.events.push($root.waiternow.common.EventProto.decode(reader, reader.uint32()));
                            break;
                        }
                    case 2: {
                            message.continuationToken = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an EventsProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.EventsProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.EventsProto} EventsProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EventsProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an EventsProto message.
             * @function verify
             * @memberof waiternow.common.EventsProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            EventsProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.events != null && message.hasOwnProperty("events")) {
                    if (!Array.isArray(message.events))
                        return "events: array expected";
                    for (var i = 0; i < message.events.length; ++i) {
                        var error = $root.waiternow.common.EventProto.verify(message.events[i]);
                        if (error)
                            return "events." + error;
                    }
                }
                if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                    if (!$util.isString(message.continuationToken))
                        return "continuationToken: string expected";
                return null;
            };

            /**
             * Creates an EventsProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.EventsProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.EventsProto} EventsProto
             */
            EventsProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.EventsProto)
                    return object;
                var message = new $root.waiternow.common.EventsProto();
                if (object.events) {
                    if (!Array.isArray(object.events))
                        throw TypeError(".waiternow.common.EventsProto.events: array expected");
                    message.events = [];
                    for (var i = 0; i < object.events.length; ++i) {
                        if (typeof object.events[i] !== "object")
                            throw TypeError(".waiternow.common.EventsProto.events: object expected");
                        message.events[i] = $root.waiternow.common.EventProto.fromObject(object.events[i]);
                    }
                }
                if (object.continuationToken != null)
                    message.continuationToken = String(object.continuationToken);
                return message;
            };

            /**
             * Creates a plain object from an EventsProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.EventsProto
             * @static
             * @param {waiternow.common.EventsProto} message EventsProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            EventsProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.events = [];
                if (options.defaults)
                    object.continuationToken = "";
                if (message.events && message.events.length) {
                    object.events = [];
                    for (var j = 0; j < message.events.length; ++j)
                        object.events[j] = $root.waiternow.common.EventProto.toObject(message.events[j], options);
                }
                if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                    object.continuationToken = message.continuationToken;
                return object;
            };

            /**
             * Converts this EventsProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.EventsProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            EventsProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for EventsProto
             * @function getTypeUrl
             * @memberof waiternow.common.EventsProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            EventsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.EventsProto";
            };

            return EventsProto;
        })();

        common.RemoteLogProto = (function() {

            /**
             * Properties of a RemoteLogProto.
             * @memberof waiternow.common
             * @interface IRemoteLogProto
             * @property {string|null} [id] RemoteLogProto id
             * @property {google.protobuf.ITimestamp|null} [creationTime] RemoteLogProto creationTime
             * @property {google.protobuf.ITimestamp|null} [lastUpdateTime] RemoteLogProto lastUpdateTime
             * @property {google.protobuf.ITimestamp|null} [remoteLogTime] RemoteLogProto remoteLogTime
             * @property {waiternow.common.RemoteLogProto.ISourceProto|null} [source] RemoteLogProto source
             * @property {waiternow.common.RemoteLogProto.ISubjectProto|null} [subject] RemoteLogProto subject
             * @property {waiternow.common.RemoteLogProto.Level|null} [level] RemoteLogProto level
             * @property {string|null} [message] RemoteLogProto message
             * @property {string|null} [stackTrace] RemoteLogProto stackTrace
             */

            /**
             * Constructs a new RemoteLogProto.
             * @memberof waiternow.common
             * @classdesc Represents a RemoteLogProto.
             * @implements IRemoteLogProto
             * @constructor
             * @param {waiternow.common.IRemoteLogProto=} [properties] Properties to set
             */
            function RemoteLogProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * RemoteLogProto id.
             * @member {string} id
             * @memberof waiternow.common.RemoteLogProto
             * @instance
             */
            RemoteLogProto.prototype.id = "";

            /**
             * RemoteLogProto creationTime.
             * @member {google.protobuf.ITimestamp|null|undefined} creationTime
             * @memberof waiternow.common.RemoteLogProto
             * @instance
             */
            RemoteLogProto.prototype.creationTime = null;

            /**
             * RemoteLogProto lastUpdateTime.
             * @member {google.protobuf.ITimestamp|null|undefined} lastUpdateTime
             * @memberof waiternow.common.RemoteLogProto
             * @instance
             */
            RemoteLogProto.prototype.lastUpdateTime = null;

            /**
             * RemoteLogProto remoteLogTime.
             * @member {google.protobuf.ITimestamp|null|undefined} remoteLogTime
             * @memberof waiternow.common.RemoteLogProto
             * @instance
             */
            RemoteLogProto.prototype.remoteLogTime = null;

            /**
             * RemoteLogProto source.
             * @member {waiternow.common.RemoteLogProto.ISourceProto|null|undefined} source
             * @memberof waiternow.common.RemoteLogProto
             * @instance
             */
            RemoteLogProto.prototype.source = null;

            /**
             * RemoteLogProto subject.
             * @member {waiternow.common.RemoteLogProto.ISubjectProto|null|undefined} subject
             * @memberof waiternow.common.RemoteLogProto
             * @instance
             */
            RemoteLogProto.prototype.subject = null;

            /**
             * RemoteLogProto level.
             * @member {waiternow.common.RemoteLogProto.Level} level
             * @memberof waiternow.common.RemoteLogProto
             * @instance
             */
            RemoteLogProto.prototype.level = 0;

            /**
             * RemoteLogProto message.
             * @member {string} message
             * @memberof waiternow.common.RemoteLogProto
             * @instance
             */
            RemoteLogProto.prototype.message = "";

            /**
             * RemoteLogProto stackTrace.
             * @member {string} stackTrace
             * @memberof waiternow.common.RemoteLogProto
             * @instance
             */
            RemoteLogProto.prototype.stackTrace = "";

            /**
             * Creates a new RemoteLogProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.RemoteLogProto
             * @static
             * @param {waiternow.common.IRemoteLogProto=} [properties] Properties to set
             * @returns {waiternow.common.RemoteLogProto} RemoteLogProto instance
             */
            RemoteLogProto.create = function create(properties) {
                return new RemoteLogProto(properties);
            };

            /**
             * Encodes the specified RemoteLogProto message. Does not implicitly {@link waiternow.common.RemoteLogProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.RemoteLogProto
             * @static
             * @param {waiternow.common.IRemoteLogProto} message RemoteLogProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RemoteLogProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                if (message.creationTime != null && Object.hasOwnProperty.call(message, "creationTime"))
                    $root.google.protobuf.Timestamp.encode(message.creationTime, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                    $root.google.protobuf.Timestamp.encode(message.lastUpdateTime, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.remoteLogTime != null && Object.hasOwnProperty.call(message, "remoteLogTime"))
                    $root.google.protobuf.Timestamp.encode(message.remoteLogTime, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                if (message.source != null && Object.hasOwnProperty.call(message, "source"))
                    $root.waiternow.common.RemoteLogProto.SourceProto.encode(message.source, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                if (message.subject != null && Object.hasOwnProperty.call(message, "subject"))
                    $root.waiternow.common.RemoteLogProto.SubjectProto.encode(message.subject, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                if (message.level != null && Object.hasOwnProperty.call(message, "level"))
                    writer.uint32(/* id 7, wireType 0 =*/56).int32(message.level);
                if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.message);
                if (message.stackTrace != null && Object.hasOwnProperty.call(message, "stackTrace"))
                    writer.uint32(/* id 9, wireType 2 =*/74).string(message.stackTrace);
                return writer;
            };

            /**
             * Encodes the specified RemoteLogProto message, length delimited. Does not implicitly {@link waiternow.common.RemoteLogProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.RemoteLogProto
             * @static
             * @param {waiternow.common.IRemoteLogProto} message RemoteLogProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RemoteLogProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a RemoteLogProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.RemoteLogProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.RemoteLogProto} RemoteLogProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RemoteLogProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.RemoteLogProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.id = reader.string();
                            break;
                        }
                    case 2: {
                            message.creationTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 3: {
                            message.lastUpdateTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 4: {
                            message.remoteLogTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 5: {
                            message.source = $root.waiternow.common.RemoteLogProto.SourceProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 6: {
                            message.subject = $root.waiternow.common.RemoteLogProto.SubjectProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 7: {
                            message.level = reader.int32();
                            break;
                        }
                    case 8: {
                            message.message = reader.string();
                            break;
                        }
                    case 9: {
                            message.stackTrace = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a RemoteLogProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.RemoteLogProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.RemoteLogProto} RemoteLogProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RemoteLogProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a RemoteLogProto message.
             * @function verify
             * @memberof waiternow.common.RemoteLogProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            RemoteLogProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.id != null && message.hasOwnProperty("id"))
                    if (!$util.isString(message.id))
                        return "id: string expected";
                if (message.creationTime != null && message.hasOwnProperty("creationTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.creationTime);
                    if (error)
                        return "creationTime." + error;
                }
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.lastUpdateTime);
                    if (error)
                        return "lastUpdateTime." + error;
                }
                if (message.remoteLogTime != null && message.hasOwnProperty("remoteLogTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.remoteLogTime);
                    if (error)
                        return "remoteLogTime." + error;
                }
                if (message.source != null && message.hasOwnProperty("source")) {
                    var error = $root.waiternow.common.RemoteLogProto.SourceProto.verify(message.source);
                    if (error)
                        return "source." + error;
                }
                if (message.subject != null && message.hasOwnProperty("subject")) {
                    var error = $root.waiternow.common.RemoteLogProto.SubjectProto.verify(message.subject);
                    if (error)
                        return "subject." + error;
                }
                if (message.level != null && message.hasOwnProperty("level"))
                    switch (message.level) {
                    default:
                        return "level: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                        break;
                    }
                if (message.message != null && message.hasOwnProperty("message"))
                    if (!$util.isString(message.message))
                        return "message: string expected";
                if (message.stackTrace != null && message.hasOwnProperty("stackTrace"))
                    if (!$util.isString(message.stackTrace))
                        return "stackTrace: string expected";
                return null;
            };

            /**
             * Creates a RemoteLogProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.RemoteLogProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.RemoteLogProto} RemoteLogProto
             */
            RemoteLogProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.RemoteLogProto)
                    return object;
                var message = new $root.waiternow.common.RemoteLogProto();
                if (object.id != null)
                    message.id = String(object.id);
                if (object.creationTime != null) {
                    if (typeof object.creationTime !== "object")
                        throw TypeError(".waiternow.common.RemoteLogProto.creationTime: object expected");
                    message.creationTime = $root.google.protobuf.Timestamp.fromObject(object.creationTime);
                }
                if (object.lastUpdateTime != null) {
                    if (typeof object.lastUpdateTime !== "object")
                        throw TypeError(".waiternow.common.RemoteLogProto.lastUpdateTime: object expected");
                    message.lastUpdateTime = $root.google.protobuf.Timestamp.fromObject(object.lastUpdateTime);
                }
                if (object.remoteLogTime != null) {
                    if (typeof object.remoteLogTime !== "object")
                        throw TypeError(".waiternow.common.RemoteLogProto.remoteLogTime: object expected");
                    message.remoteLogTime = $root.google.protobuf.Timestamp.fromObject(object.remoteLogTime);
                }
                if (object.source != null) {
                    if (typeof object.source !== "object")
                        throw TypeError(".waiternow.common.RemoteLogProto.source: object expected");
                    message.source = $root.waiternow.common.RemoteLogProto.SourceProto.fromObject(object.source);
                }
                if (object.subject != null) {
                    if (typeof object.subject !== "object")
                        throw TypeError(".waiternow.common.RemoteLogProto.subject: object expected");
                    message.subject = $root.waiternow.common.RemoteLogProto.SubjectProto.fromObject(object.subject);
                }
                switch (object.level) {
                default:
                    if (typeof object.level === "number") {
                        message.level = object.level;
                        break;
                    }
                    break;
                case "LEVEL_UNSPECIFIED":
                case 0:
                    message.level = 0;
                    break;
                case "ERROR":
                case 1:
                    message.level = 1;
                    break;
                case "WARNING":
                case 2:
                    message.level = 2;
                    break;
                case "INFO":
                case 3:
                    message.level = 3;
                    break;
                case "DEBUG":
                case 4:
                    message.level = 4;
                    break;
                }
                if (object.message != null)
                    message.message = String(object.message);
                if (object.stackTrace != null)
                    message.stackTrace = String(object.stackTrace);
                return message;
            };

            /**
             * Creates a plain object from a RemoteLogProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.RemoteLogProto
             * @static
             * @param {waiternow.common.RemoteLogProto} message RemoteLogProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            RemoteLogProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.id = "";
                    object.creationTime = null;
                    object.lastUpdateTime = null;
                    object.remoteLogTime = null;
                    object.source = null;
                    object.subject = null;
                    object.level = options.enums === String ? "LEVEL_UNSPECIFIED" : 0;
                    object.message = "";
                    object.stackTrace = "";
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                    object.creationTime = $root.google.protobuf.Timestamp.toObject(message.creationTime, options);
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                    object.lastUpdateTime = $root.google.protobuf.Timestamp.toObject(message.lastUpdateTime, options);
                if (message.remoteLogTime != null && message.hasOwnProperty("remoteLogTime"))
                    object.remoteLogTime = $root.google.protobuf.Timestamp.toObject(message.remoteLogTime, options);
                if (message.source != null && message.hasOwnProperty("source"))
                    object.source = $root.waiternow.common.RemoteLogProto.SourceProto.toObject(message.source, options);
                if (message.subject != null && message.hasOwnProperty("subject"))
                    object.subject = $root.waiternow.common.RemoteLogProto.SubjectProto.toObject(message.subject, options);
                if (message.level != null && message.hasOwnProperty("level"))
                    object.level = options.enums === String ? $root.waiternow.common.RemoteLogProto.Level[message.level] === undefined ? message.level : $root.waiternow.common.RemoteLogProto.Level[message.level] : message.level;
                if (message.message != null && message.hasOwnProperty("message"))
                    object.message = message.message;
                if (message.stackTrace != null && message.hasOwnProperty("stackTrace"))
                    object.stackTrace = message.stackTrace;
                return object;
            };

            /**
             * Converts this RemoteLogProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.RemoteLogProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            RemoteLogProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for RemoteLogProto
             * @function getTypeUrl
             * @memberof waiternow.common.RemoteLogProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            RemoteLogProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.RemoteLogProto";
            };

            RemoteLogProto.SourceProto = (function() {

                /**
                 * Properties of a SourceProto.
                 * @memberof waiternow.common.RemoteLogProto
                 * @interface ISourceProto
                 * @property {string|null} [deviceId] SourceProto deviceId
                 * @property {waiternow.common.DeviceProto.ClientType|null} [clientType] SourceProto clientType
                 * @property {waiternow.common.DeviceProto.DeviceType|null} [deviceType] SourceProto deviceType
                 * @property {boolean|null} [isFirebaseNotificationsSupported] SourceProto isFirebaseNotificationsSupported
                 */

                /**
                 * Constructs a new SourceProto.
                 * @memberof waiternow.common.RemoteLogProto
                 * @classdesc Represents a SourceProto.
                 * @implements ISourceProto
                 * @constructor
                 * @param {waiternow.common.RemoteLogProto.ISourceProto=} [properties] Properties to set
                 */
                function SourceProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SourceProto deviceId.
                 * @member {string} deviceId
                 * @memberof waiternow.common.RemoteLogProto.SourceProto
                 * @instance
                 */
                SourceProto.prototype.deviceId = "";

                /**
                 * SourceProto clientType.
                 * @member {waiternow.common.DeviceProto.ClientType} clientType
                 * @memberof waiternow.common.RemoteLogProto.SourceProto
                 * @instance
                 */
                SourceProto.prototype.clientType = 0;

                /**
                 * SourceProto deviceType.
                 * @member {waiternow.common.DeviceProto.DeviceType} deviceType
                 * @memberof waiternow.common.RemoteLogProto.SourceProto
                 * @instance
                 */
                SourceProto.prototype.deviceType = 0;

                /**
                 * SourceProto isFirebaseNotificationsSupported.
                 * @member {boolean} isFirebaseNotificationsSupported
                 * @memberof waiternow.common.RemoteLogProto.SourceProto
                 * @instance
                 */
                SourceProto.prototype.isFirebaseNotificationsSupported = false;

                /**
                 * Creates a new SourceProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.RemoteLogProto.SourceProto
                 * @static
                 * @param {waiternow.common.RemoteLogProto.ISourceProto=} [properties] Properties to set
                 * @returns {waiternow.common.RemoteLogProto.SourceProto} SourceProto instance
                 */
                SourceProto.create = function create(properties) {
                    return new SourceProto(properties);
                };

                /**
                 * Encodes the specified SourceProto message. Does not implicitly {@link waiternow.common.RemoteLogProto.SourceProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.RemoteLogProto.SourceProto
                 * @static
                 * @param {waiternow.common.RemoteLogProto.ISourceProto} message SourceProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SourceProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceId != null && Object.hasOwnProperty.call(message, "deviceId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.deviceId);
                    if (message.clientType != null && Object.hasOwnProperty.call(message, "clientType"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.clientType);
                    if (message.deviceType != null && Object.hasOwnProperty.call(message, "deviceType"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.deviceType);
                    if (message.isFirebaseNotificationsSupported != null && Object.hasOwnProperty.call(message, "isFirebaseNotificationsSupported"))
                        writer.uint32(/* id 4, wireType 0 =*/32).bool(message.isFirebaseNotificationsSupported);
                    return writer;
                };

                /**
                 * Encodes the specified SourceProto message, length delimited. Does not implicitly {@link waiternow.common.RemoteLogProto.SourceProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.RemoteLogProto.SourceProto
                 * @static
                 * @param {waiternow.common.RemoteLogProto.ISourceProto} message SourceProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SourceProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SourceProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.RemoteLogProto.SourceProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.RemoteLogProto.SourceProto} SourceProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SourceProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.RemoteLogProto.SourceProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceId = reader.string();
                                break;
                            }
                        case 2: {
                                message.clientType = reader.int32();
                                break;
                            }
                        case 3: {
                                message.deviceType = reader.int32();
                                break;
                            }
                        case 4: {
                                message.isFirebaseNotificationsSupported = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SourceProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.RemoteLogProto.SourceProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.RemoteLogProto.SourceProto} SourceProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SourceProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SourceProto message.
                 * @function verify
                 * @memberof waiternow.common.RemoteLogProto.SourceProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SourceProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                        if (!$util.isString(message.deviceId))
                            return "deviceId: string expected";
                    if (message.clientType != null && message.hasOwnProperty("clientType"))
                        switch (message.clientType) {
                        default:
                            return "clientType: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.deviceType != null && message.hasOwnProperty("deviceType"))
                        switch (message.deviceType) {
                        default:
                            return "deviceType: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                            break;
                        }
                    if (message.isFirebaseNotificationsSupported != null && message.hasOwnProperty("isFirebaseNotificationsSupported"))
                        if (typeof message.isFirebaseNotificationsSupported !== "boolean")
                            return "isFirebaseNotificationsSupported: boolean expected";
                    return null;
                };

                /**
                 * Creates a SourceProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.RemoteLogProto.SourceProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.RemoteLogProto.SourceProto} SourceProto
                 */
                SourceProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.RemoteLogProto.SourceProto)
                        return object;
                    var message = new $root.waiternow.common.RemoteLogProto.SourceProto();
                    if (object.deviceId != null)
                        message.deviceId = String(object.deviceId);
                    switch (object.clientType) {
                    default:
                        if (typeof object.clientType === "number") {
                            message.clientType = object.clientType;
                            break;
                        }
                        break;
                    case "CLIENT_TYPE_UNSPECIFIED":
                    case 0:
                        message.clientType = 0;
                        break;
                    case "BUSINESS":
                    case 1:
                        message.clientType = 1;
                        break;
                    case "CONSUMER":
                    case 2:
                        message.clientType = 2;
                        break;
                    }
                    switch (object.deviceType) {
                    default:
                        if (typeof object.deviceType === "number") {
                            message.deviceType = object.deviceType;
                            break;
                        }
                        break;
                    case "DEVICE_TYPE_UNSPECIFIED":
                    case 0:
                        message.deviceType = 0;
                        break;
                    case "WEB":
                    case 1:
                        message.deviceType = 1;
                        break;
                    case "ANDROID":
                    case 2:
                        message.deviceType = 2;
                        break;
                    case "APPLE":
                    case 3:
                        message.deviceType = 3;
                        break;
                    }
                    if (object.isFirebaseNotificationsSupported != null)
                        message.isFirebaseNotificationsSupported = Boolean(object.isFirebaseNotificationsSupported);
                    return message;
                };

                /**
                 * Creates a plain object from a SourceProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.RemoteLogProto.SourceProto
                 * @static
                 * @param {waiternow.common.RemoteLogProto.SourceProto} message SourceProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SourceProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.deviceId = "";
                        object.clientType = options.enums === String ? "CLIENT_TYPE_UNSPECIFIED" : 0;
                        object.deviceType = options.enums === String ? "DEVICE_TYPE_UNSPECIFIED" : 0;
                        object.isFirebaseNotificationsSupported = false;
                    }
                    if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                        object.deviceId = message.deviceId;
                    if (message.clientType != null && message.hasOwnProperty("clientType"))
                        object.clientType = options.enums === String ? $root.waiternow.common.DeviceProto.ClientType[message.clientType] === undefined ? message.clientType : $root.waiternow.common.DeviceProto.ClientType[message.clientType] : message.clientType;
                    if (message.deviceType != null && message.hasOwnProperty("deviceType"))
                        object.deviceType = options.enums === String ? $root.waiternow.common.DeviceProto.DeviceType[message.deviceType] === undefined ? message.deviceType : $root.waiternow.common.DeviceProto.DeviceType[message.deviceType] : message.deviceType;
                    if (message.isFirebaseNotificationsSupported != null && message.hasOwnProperty("isFirebaseNotificationsSupported"))
                        object.isFirebaseNotificationsSupported = message.isFirebaseNotificationsSupported;
                    return object;
                };

                /**
                 * Converts this SourceProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.RemoteLogProto.SourceProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SourceProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for SourceProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.RemoteLogProto.SourceProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                SourceProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.RemoteLogProto.SourceProto";
                };

                return SourceProto;
            })();

            RemoteLogProto.SubjectProto = (function() {

                /**
                 * Properties of a SubjectProto.
                 * @memberof waiternow.common.RemoteLogProto
                 * @interface ISubjectProto
                 * @property {string|null} [userId] SubjectProto userId
                 * @property {string|null} [businessId] SubjectProto businessId
                 * @property {string|null} [locationId] SubjectProto locationId
                 */

                /**
                 * Constructs a new SubjectProto.
                 * @memberof waiternow.common.RemoteLogProto
                 * @classdesc Represents a SubjectProto.
                 * @implements ISubjectProto
                 * @constructor
                 * @param {waiternow.common.RemoteLogProto.ISubjectProto=} [properties] Properties to set
                 */
                function SubjectProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SubjectProto userId.
                 * @member {string} userId
                 * @memberof waiternow.common.RemoteLogProto.SubjectProto
                 * @instance
                 */
                SubjectProto.prototype.userId = "";

                /**
                 * SubjectProto businessId.
                 * @member {string} businessId
                 * @memberof waiternow.common.RemoteLogProto.SubjectProto
                 * @instance
                 */
                SubjectProto.prototype.businessId = "";

                /**
                 * SubjectProto locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.RemoteLogProto.SubjectProto
                 * @instance
                 */
                SubjectProto.prototype.locationId = "";

                /**
                 * Creates a new SubjectProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.RemoteLogProto.SubjectProto
                 * @static
                 * @param {waiternow.common.RemoteLogProto.ISubjectProto=} [properties] Properties to set
                 * @returns {waiternow.common.RemoteLogProto.SubjectProto} SubjectProto instance
                 */
                SubjectProto.create = function create(properties) {
                    return new SubjectProto(properties);
                };

                /**
                 * Encodes the specified SubjectProto message. Does not implicitly {@link waiternow.common.RemoteLogProto.SubjectProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.RemoteLogProto.SubjectProto
                 * @static
                 * @param {waiternow.common.RemoteLogProto.ISubjectProto} message SubjectProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SubjectProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.userId);
                    if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.businessId);
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.locationId);
                    return writer;
                };

                /**
                 * Encodes the specified SubjectProto message, length delimited. Does not implicitly {@link waiternow.common.RemoteLogProto.SubjectProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.RemoteLogProto.SubjectProto
                 * @static
                 * @param {waiternow.common.RemoteLogProto.ISubjectProto} message SubjectProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SubjectProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SubjectProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.RemoteLogProto.SubjectProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.RemoteLogProto.SubjectProto} SubjectProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SubjectProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.RemoteLogProto.SubjectProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.userId = reader.string();
                                break;
                            }
                        case 2: {
                                message.businessId = reader.string();
                                break;
                            }
                        case 3: {
                                message.locationId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SubjectProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.RemoteLogProto.SubjectProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.RemoteLogProto.SubjectProto} SubjectProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SubjectProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SubjectProto message.
                 * @function verify
                 * @memberof waiternow.common.RemoteLogProto.SubjectProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SubjectProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.userId != null && message.hasOwnProperty("userId"))
                        if (!$util.isString(message.userId))
                            return "userId: string expected";
                    if (message.businessId != null && message.hasOwnProperty("businessId"))
                        if (!$util.isString(message.businessId))
                            return "businessId: string expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    return null;
                };

                /**
                 * Creates a SubjectProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.RemoteLogProto.SubjectProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.RemoteLogProto.SubjectProto} SubjectProto
                 */
                SubjectProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.RemoteLogProto.SubjectProto)
                        return object;
                    var message = new $root.waiternow.common.RemoteLogProto.SubjectProto();
                    if (object.userId != null)
                        message.userId = String(object.userId);
                    if (object.businessId != null)
                        message.businessId = String(object.businessId);
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    return message;
                };

                /**
                 * Creates a plain object from a SubjectProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.RemoteLogProto.SubjectProto
                 * @static
                 * @param {waiternow.common.RemoteLogProto.SubjectProto} message SubjectProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SubjectProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.userId = "";
                        object.businessId = "";
                        object.locationId = "";
                    }
                    if (message.userId != null && message.hasOwnProperty("userId"))
                        object.userId = message.userId;
                    if (message.businessId != null && message.hasOwnProperty("businessId"))
                        object.businessId = message.businessId;
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    return object;
                };

                /**
                 * Converts this SubjectProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.RemoteLogProto.SubjectProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SubjectProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for SubjectProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.RemoteLogProto.SubjectProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                SubjectProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.RemoteLogProto.SubjectProto";
                };

                return SubjectProto;
            })();

            /**
             * Level enum.
             * @name waiternow.common.RemoteLogProto.Level
             * @enum {number}
             * @property {number} LEVEL_UNSPECIFIED=0 LEVEL_UNSPECIFIED value
             * @property {number} ERROR=1 ERROR value
             * @property {number} WARNING=2 WARNING value
             * @property {number} INFO=3 INFO value
             * @property {number} DEBUG=4 DEBUG value
             */
            RemoteLogProto.Level = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "LEVEL_UNSPECIFIED"] = 0;
                values[valuesById[1] = "ERROR"] = 1;
                values[valuesById[2] = "WARNING"] = 2;
                values[valuesById[3] = "INFO"] = 3;
                values[valuesById[4] = "DEBUG"] = 4;
                return values;
            })();

            return RemoteLogProto;
        })();

        common.RemoteLogsProto = (function() {

            /**
             * Properties of a RemoteLogsProto.
             * @memberof waiternow.common
             * @interface IRemoteLogsProto
             * @property {Array.<waiternow.common.IRemoteLogProto>|null} [logs] RemoteLogsProto logs
             * @property {string|null} [continuationToken] RemoteLogsProto continuationToken
             */

            /**
             * Constructs a new RemoteLogsProto.
             * @memberof waiternow.common
             * @classdesc Represents a RemoteLogsProto.
             * @implements IRemoteLogsProto
             * @constructor
             * @param {waiternow.common.IRemoteLogsProto=} [properties] Properties to set
             */
            function RemoteLogsProto(properties) {
                this.logs = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * RemoteLogsProto logs.
             * @member {Array.<waiternow.common.IRemoteLogProto>} logs
             * @memberof waiternow.common.RemoteLogsProto
             * @instance
             */
            RemoteLogsProto.prototype.logs = $util.emptyArray;

            /**
             * RemoteLogsProto continuationToken.
             * @member {string} continuationToken
             * @memberof waiternow.common.RemoteLogsProto
             * @instance
             */
            RemoteLogsProto.prototype.continuationToken = "";

            /**
             * Creates a new RemoteLogsProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.RemoteLogsProto
             * @static
             * @param {waiternow.common.IRemoteLogsProto=} [properties] Properties to set
             * @returns {waiternow.common.RemoteLogsProto} RemoteLogsProto instance
             */
            RemoteLogsProto.create = function create(properties) {
                return new RemoteLogsProto(properties);
            };

            /**
             * Encodes the specified RemoteLogsProto message. Does not implicitly {@link waiternow.common.RemoteLogsProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.RemoteLogsProto
             * @static
             * @param {waiternow.common.IRemoteLogsProto} message RemoteLogsProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RemoteLogsProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.logs != null && message.logs.length)
                    for (var i = 0; i < message.logs.length; ++i)
                        $root.waiternow.common.RemoteLogProto.encode(message.logs[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.continuationToken);
                return writer;
            };

            /**
             * Encodes the specified RemoteLogsProto message, length delimited. Does not implicitly {@link waiternow.common.RemoteLogsProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.RemoteLogsProto
             * @static
             * @param {waiternow.common.IRemoteLogsProto} message RemoteLogsProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RemoteLogsProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a RemoteLogsProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.RemoteLogsProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.RemoteLogsProto} RemoteLogsProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RemoteLogsProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.RemoteLogsProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            if (!(message.logs && message.logs.length))
                                message.logs = [];
                            message.logs.push($root.waiternow.common.RemoteLogProto.decode(reader, reader.uint32()));
                            break;
                        }
                    case 2: {
                            message.continuationToken = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a RemoteLogsProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.RemoteLogsProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.RemoteLogsProto} RemoteLogsProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RemoteLogsProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a RemoteLogsProto message.
             * @function verify
             * @memberof waiternow.common.RemoteLogsProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            RemoteLogsProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.logs != null && message.hasOwnProperty("logs")) {
                    if (!Array.isArray(message.logs))
                        return "logs: array expected";
                    for (var i = 0; i < message.logs.length; ++i) {
                        var error = $root.waiternow.common.RemoteLogProto.verify(message.logs[i]);
                        if (error)
                            return "logs." + error;
                    }
                }
                if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                    if (!$util.isString(message.continuationToken))
                        return "continuationToken: string expected";
                return null;
            };

            /**
             * Creates a RemoteLogsProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.RemoteLogsProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.RemoteLogsProto} RemoteLogsProto
             */
            RemoteLogsProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.RemoteLogsProto)
                    return object;
                var message = new $root.waiternow.common.RemoteLogsProto();
                if (object.logs) {
                    if (!Array.isArray(object.logs))
                        throw TypeError(".waiternow.common.RemoteLogsProto.logs: array expected");
                    message.logs = [];
                    for (var i = 0; i < object.logs.length; ++i) {
                        if (typeof object.logs[i] !== "object")
                            throw TypeError(".waiternow.common.RemoteLogsProto.logs: object expected");
                        message.logs[i] = $root.waiternow.common.RemoteLogProto.fromObject(object.logs[i]);
                    }
                }
                if (object.continuationToken != null)
                    message.continuationToken = String(object.continuationToken);
                return message;
            };

            /**
             * Creates a plain object from a RemoteLogsProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.RemoteLogsProto
             * @static
             * @param {waiternow.common.RemoteLogsProto} message RemoteLogsProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            RemoteLogsProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.logs = [];
                if (options.defaults)
                    object.continuationToken = "";
                if (message.logs && message.logs.length) {
                    object.logs = [];
                    for (var j = 0; j < message.logs.length; ++j)
                        object.logs[j] = $root.waiternow.common.RemoteLogProto.toObject(message.logs[j], options);
                }
                if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                    object.continuationToken = message.continuationToken;
                return object;
            };

            /**
             * Converts this RemoteLogsProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.RemoteLogsProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            RemoteLogsProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for RemoteLogsProto
             * @function getTypeUrl
             * @memberof waiternow.common.RemoteLogsProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            RemoteLogsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.RemoteLogsProto";
            };

            return RemoteLogsProto;
        })();

        common.DeviceProto = (function() {

            /**
             * Properties of a DeviceProto.
             * @memberof waiternow.common
             * @interface IDeviceProto
             * @property {string|null} [id] DeviceProto id
             * @property {google.protobuf.ITimestamp|null} [creationTime] DeviceProto creationTime
             * @property {google.protobuf.ITimestamp|null} [lastUpdateTime] DeviceProto lastUpdateTime
             * @property {string|null} [firebaseMessagingToken] DeviceProto firebaseMessagingToken
             * @property {string|null} [userId] DeviceProto userId
             * @property {string|null} [consumerId] DeviceProto consumerId
             * @property {waiternow.common.DeviceProto.ClientType|null} [clientType] DeviceProto clientType
             * @property {waiternow.common.DeviceProto.DeviceType|null} [deviceType] DeviceProto deviceType
             * @property {waiternow.common.DeviceProto.IInterestsProto|null} [interests] DeviceProto interests
             * @property {waiternow.common.DeviceProto.IStatusProto|null} [status] DeviceProto status
             * @property {string|null} [version] DeviceProto version
             */

            /**
             * Constructs a new DeviceProto.
             * @memberof waiternow.common
             * @classdesc Represents a DeviceProto.
             * @implements IDeviceProto
             * @constructor
             * @param {waiternow.common.IDeviceProto=} [properties] Properties to set
             */
            function DeviceProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * DeviceProto id.
             * @member {string} id
             * @memberof waiternow.common.DeviceProto
             * @instance
             */
            DeviceProto.prototype.id = "";

            /**
             * DeviceProto creationTime.
             * @member {google.protobuf.ITimestamp|null|undefined} creationTime
             * @memberof waiternow.common.DeviceProto
             * @instance
             */
            DeviceProto.prototype.creationTime = null;

            /**
             * DeviceProto lastUpdateTime.
             * @member {google.protobuf.ITimestamp|null|undefined} lastUpdateTime
             * @memberof waiternow.common.DeviceProto
             * @instance
             */
            DeviceProto.prototype.lastUpdateTime = null;

            /**
             * DeviceProto firebaseMessagingToken.
             * @member {string} firebaseMessagingToken
             * @memberof waiternow.common.DeviceProto
             * @instance
             */
            DeviceProto.prototype.firebaseMessagingToken = "";

            /**
             * DeviceProto userId.
             * @member {string} userId
             * @memberof waiternow.common.DeviceProto
             * @instance
             */
            DeviceProto.prototype.userId = "";

            /**
             * DeviceProto consumerId.
             * @member {string} consumerId
             * @memberof waiternow.common.DeviceProto
             * @instance
             */
            DeviceProto.prototype.consumerId = "";

            /**
             * DeviceProto clientType.
             * @member {waiternow.common.DeviceProto.ClientType} clientType
             * @memberof waiternow.common.DeviceProto
             * @instance
             */
            DeviceProto.prototype.clientType = 0;

            /**
             * DeviceProto deviceType.
             * @member {waiternow.common.DeviceProto.DeviceType} deviceType
             * @memberof waiternow.common.DeviceProto
             * @instance
             */
            DeviceProto.prototype.deviceType = 0;

            /**
             * DeviceProto interests.
             * @member {waiternow.common.DeviceProto.IInterestsProto|null|undefined} interests
             * @memberof waiternow.common.DeviceProto
             * @instance
             */
            DeviceProto.prototype.interests = null;

            /**
             * DeviceProto status.
             * @member {waiternow.common.DeviceProto.IStatusProto|null|undefined} status
             * @memberof waiternow.common.DeviceProto
             * @instance
             */
            DeviceProto.prototype.status = null;

            /**
             * DeviceProto version.
             * @member {string} version
             * @memberof waiternow.common.DeviceProto
             * @instance
             */
            DeviceProto.prototype.version = "";

            /**
             * Creates a new DeviceProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.DeviceProto
             * @static
             * @param {waiternow.common.IDeviceProto=} [properties] Properties to set
             * @returns {waiternow.common.DeviceProto} DeviceProto instance
             */
            DeviceProto.create = function create(properties) {
                return new DeviceProto(properties);
            };

            /**
             * Encodes the specified DeviceProto message. Does not implicitly {@link waiternow.common.DeviceProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.DeviceProto
             * @static
             * @param {waiternow.common.IDeviceProto} message DeviceProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DeviceProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                if (message.firebaseMessagingToken != null && Object.hasOwnProperty.call(message, "firebaseMessagingToken"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.firebaseMessagingToken);
                if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.userId);
                if (message.consumerId != null && Object.hasOwnProperty.call(message, "consumerId"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.consumerId);
                if (message.clientType != null && Object.hasOwnProperty.call(message, "clientType"))
                    writer.uint32(/* id 5, wireType 0 =*/40).int32(message.clientType);
                if (message.deviceType != null && Object.hasOwnProperty.call(message, "deviceType"))
                    writer.uint32(/* id 6, wireType 0 =*/48).int32(message.deviceType);
                if (message.interests != null && Object.hasOwnProperty.call(message, "interests"))
                    $root.waiternow.common.DeviceProto.InterestsProto.encode(message.interests, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                    $root.waiternow.common.DeviceProto.StatusProto.encode(message.status, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                if (message.creationTime != null && Object.hasOwnProperty.call(message, "creationTime"))
                    $root.google.protobuf.Timestamp.encode(message.creationTime, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                    $root.google.protobuf.Timestamp.encode(message.lastUpdateTime, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                if (message.version != null && Object.hasOwnProperty.call(message, "version"))
                    writer.uint32(/* id 11, wireType 2 =*/90).string(message.version);
                return writer;
            };

            /**
             * Encodes the specified DeviceProto message, length delimited. Does not implicitly {@link waiternow.common.DeviceProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.DeviceProto
             * @static
             * @param {waiternow.common.IDeviceProto} message DeviceProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DeviceProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a DeviceProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.DeviceProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.DeviceProto} DeviceProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DeviceProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.DeviceProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.id = reader.string();
                            break;
                        }
                    case 9: {
                            message.creationTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 10: {
                            message.lastUpdateTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 2: {
                            message.firebaseMessagingToken = reader.string();
                            break;
                        }
                    case 3: {
                            message.userId = reader.string();
                            break;
                        }
                    case 4: {
                            message.consumerId = reader.string();
                            break;
                        }
                    case 5: {
                            message.clientType = reader.int32();
                            break;
                        }
                    case 6: {
                            message.deviceType = reader.int32();
                            break;
                        }
                    case 7: {
                            message.interests = $root.waiternow.common.DeviceProto.InterestsProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 8: {
                            message.status = $root.waiternow.common.DeviceProto.StatusProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 11: {
                            message.version = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a DeviceProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.DeviceProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.DeviceProto} DeviceProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DeviceProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a DeviceProto message.
             * @function verify
             * @memberof waiternow.common.DeviceProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            DeviceProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.id != null && message.hasOwnProperty("id"))
                    if (!$util.isString(message.id))
                        return "id: string expected";
                if (message.creationTime != null && message.hasOwnProperty("creationTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.creationTime);
                    if (error)
                        return "creationTime." + error;
                }
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.lastUpdateTime);
                    if (error)
                        return "lastUpdateTime." + error;
                }
                if (message.firebaseMessagingToken != null && message.hasOwnProperty("firebaseMessagingToken"))
                    if (!$util.isString(message.firebaseMessagingToken))
                        return "firebaseMessagingToken: string expected";
                if (message.userId != null && message.hasOwnProperty("userId"))
                    if (!$util.isString(message.userId))
                        return "userId: string expected";
                if (message.consumerId != null && message.hasOwnProperty("consumerId"))
                    if (!$util.isString(message.consumerId))
                        return "consumerId: string expected";
                if (message.clientType != null && message.hasOwnProperty("clientType"))
                    switch (message.clientType) {
                    default:
                        return "clientType: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                        break;
                    }
                if (message.deviceType != null && message.hasOwnProperty("deviceType"))
                    switch (message.deviceType) {
                    default:
                        return "deviceType: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                        break;
                    }
                if (message.interests != null && message.hasOwnProperty("interests")) {
                    var error = $root.waiternow.common.DeviceProto.InterestsProto.verify(message.interests);
                    if (error)
                        return "interests." + error;
                }
                if (message.status != null && message.hasOwnProperty("status")) {
                    var error = $root.waiternow.common.DeviceProto.StatusProto.verify(message.status);
                    if (error)
                        return "status." + error;
                }
                if (message.version != null && message.hasOwnProperty("version"))
                    if (!$util.isString(message.version))
                        return "version: string expected";
                return null;
            };

            /**
             * Creates a DeviceProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.DeviceProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.DeviceProto} DeviceProto
             */
            DeviceProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.DeviceProto)
                    return object;
                var message = new $root.waiternow.common.DeviceProto();
                if (object.id != null)
                    message.id = String(object.id);
                if (object.creationTime != null) {
                    if (typeof object.creationTime !== "object")
                        throw TypeError(".waiternow.common.DeviceProto.creationTime: object expected");
                    message.creationTime = $root.google.protobuf.Timestamp.fromObject(object.creationTime);
                }
                if (object.lastUpdateTime != null) {
                    if (typeof object.lastUpdateTime !== "object")
                        throw TypeError(".waiternow.common.DeviceProto.lastUpdateTime: object expected");
                    message.lastUpdateTime = $root.google.protobuf.Timestamp.fromObject(object.lastUpdateTime);
                }
                if (object.firebaseMessagingToken != null)
                    message.firebaseMessagingToken = String(object.firebaseMessagingToken);
                if (object.userId != null)
                    message.userId = String(object.userId);
                if (object.consumerId != null)
                    message.consumerId = String(object.consumerId);
                switch (object.clientType) {
                default:
                    if (typeof object.clientType === "number") {
                        message.clientType = object.clientType;
                        break;
                    }
                    break;
                case "CLIENT_TYPE_UNSPECIFIED":
                case 0:
                    message.clientType = 0;
                    break;
                case "BUSINESS":
                case 1:
                    message.clientType = 1;
                    break;
                case "CONSUMER":
                case 2:
                    message.clientType = 2;
                    break;
                }
                switch (object.deviceType) {
                default:
                    if (typeof object.deviceType === "number") {
                        message.deviceType = object.deviceType;
                        break;
                    }
                    break;
                case "DEVICE_TYPE_UNSPECIFIED":
                case 0:
                    message.deviceType = 0;
                    break;
                case "WEB":
                case 1:
                    message.deviceType = 1;
                    break;
                case "ANDROID":
                case 2:
                    message.deviceType = 2;
                    break;
                case "APPLE":
                case 3:
                    message.deviceType = 3;
                    break;
                }
                if (object.interests != null) {
                    if (typeof object.interests !== "object")
                        throw TypeError(".waiternow.common.DeviceProto.interests: object expected");
                    message.interests = $root.waiternow.common.DeviceProto.InterestsProto.fromObject(object.interests);
                }
                if (object.status != null) {
                    if (typeof object.status !== "object")
                        throw TypeError(".waiternow.common.DeviceProto.status: object expected");
                    message.status = $root.waiternow.common.DeviceProto.StatusProto.fromObject(object.status);
                }
                if (object.version != null)
                    message.version = String(object.version);
                return message;
            };

            /**
             * Creates a plain object from a DeviceProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.DeviceProto
             * @static
             * @param {waiternow.common.DeviceProto} message DeviceProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            DeviceProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.id = "";
                    object.firebaseMessagingToken = "";
                    object.userId = "";
                    object.consumerId = "";
                    object.clientType = options.enums === String ? "CLIENT_TYPE_UNSPECIFIED" : 0;
                    object.deviceType = options.enums === String ? "DEVICE_TYPE_UNSPECIFIED" : 0;
                    object.interests = null;
                    object.status = null;
                    object.creationTime = null;
                    object.lastUpdateTime = null;
                    object.version = "";
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                if (message.firebaseMessagingToken != null && message.hasOwnProperty("firebaseMessagingToken"))
                    object.firebaseMessagingToken = message.firebaseMessagingToken;
                if (message.userId != null && message.hasOwnProperty("userId"))
                    object.userId = message.userId;
                if (message.consumerId != null && message.hasOwnProperty("consumerId"))
                    object.consumerId = message.consumerId;
                if (message.clientType != null && message.hasOwnProperty("clientType"))
                    object.clientType = options.enums === String ? $root.waiternow.common.DeviceProto.ClientType[message.clientType] === undefined ? message.clientType : $root.waiternow.common.DeviceProto.ClientType[message.clientType] : message.clientType;
                if (message.deviceType != null && message.hasOwnProperty("deviceType"))
                    object.deviceType = options.enums === String ? $root.waiternow.common.DeviceProto.DeviceType[message.deviceType] === undefined ? message.deviceType : $root.waiternow.common.DeviceProto.DeviceType[message.deviceType] : message.deviceType;
                if (message.interests != null && message.hasOwnProperty("interests"))
                    object.interests = $root.waiternow.common.DeviceProto.InterestsProto.toObject(message.interests, options);
                if (message.status != null && message.hasOwnProperty("status"))
                    object.status = $root.waiternow.common.DeviceProto.StatusProto.toObject(message.status, options);
                if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                    object.creationTime = $root.google.protobuf.Timestamp.toObject(message.creationTime, options);
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                    object.lastUpdateTime = $root.google.protobuf.Timestamp.toObject(message.lastUpdateTime, options);
                if (message.version != null && message.hasOwnProperty("version"))
                    object.version = message.version;
                return object;
            };

            /**
             * Converts this DeviceProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.DeviceProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            DeviceProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for DeviceProto
             * @function getTypeUrl
             * @memberof waiternow.common.DeviceProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            DeviceProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.DeviceProto";
            };

            /**
             * ClientType enum.
             * @name waiternow.common.DeviceProto.ClientType
             * @enum {number}
             * @property {number} CLIENT_TYPE_UNSPECIFIED=0 CLIENT_TYPE_UNSPECIFIED value
             * @property {number} BUSINESS=1 BUSINESS value
             * @property {number} CONSUMER=2 CONSUMER value
             */
            DeviceProto.ClientType = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "CLIENT_TYPE_UNSPECIFIED"] = 0;
                values[valuesById[1] = "BUSINESS"] = 1;
                values[valuesById[2] = "CONSUMER"] = 2;
                return values;
            })();

            /**
             * DeviceType enum.
             * @name waiternow.common.DeviceProto.DeviceType
             * @enum {number}
             * @property {number} DEVICE_TYPE_UNSPECIFIED=0 DEVICE_TYPE_UNSPECIFIED value
             * @property {number} WEB=1 WEB value
             * @property {number} ANDROID=2 ANDROID value
             * @property {number} APPLE=3 APPLE value
             */
            DeviceProto.DeviceType = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "DEVICE_TYPE_UNSPECIFIED"] = 0;
                values[valuesById[1] = "WEB"] = 1;
                values[valuesById[2] = "ANDROID"] = 2;
                values[valuesById[3] = "APPLE"] = 3;
                return values;
            })();

            DeviceProto.InterestsProto = (function() {

                /**
                 * Properties of an InterestsProto.
                 * @memberof waiternow.common.DeviceProto
                 * @interface IInterestsProto
                 * @property {string|null} [locationId] InterestsProto locationId
                 * @property {string|null} [pointOfServiceId] InterestsProto pointOfServiceId
                 */

                /**
                 * Constructs a new InterestsProto.
                 * @memberof waiternow.common.DeviceProto
                 * @classdesc Represents an InterestsProto.
                 * @implements IInterestsProto
                 * @constructor
                 * @param {waiternow.common.DeviceProto.IInterestsProto=} [properties] Properties to set
                 */
                function InterestsProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * InterestsProto locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.DeviceProto.InterestsProto
                 * @instance
                 */
                InterestsProto.prototype.locationId = "";

                /**
                 * InterestsProto pointOfServiceId.
                 * @member {string} pointOfServiceId
                 * @memberof waiternow.common.DeviceProto.InterestsProto
                 * @instance
                 */
                InterestsProto.prototype.pointOfServiceId = "";

                /**
                 * Creates a new InterestsProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.DeviceProto.InterestsProto
                 * @static
                 * @param {waiternow.common.DeviceProto.IInterestsProto=} [properties] Properties to set
                 * @returns {waiternow.common.DeviceProto.InterestsProto} InterestsProto instance
                 */
                InterestsProto.create = function create(properties) {
                    return new InterestsProto(properties);
                };

                /**
                 * Encodes the specified InterestsProto message. Does not implicitly {@link waiternow.common.DeviceProto.InterestsProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.DeviceProto.InterestsProto
                 * @static
                 * @param {waiternow.common.DeviceProto.IInterestsProto} message InterestsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                InterestsProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    if (message.pointOfServiceId != null && Object.hasOwnProperty.call(message, "pointOfServiceId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.pointOfServiceId);
                    return writer;
                };

                /**
                 * Encodes the specified InterestsProto message, length delimited. Does not implicitly {@link waiternow.common.DeviceProto.InterestsProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.DeviceProto.InterestsProto
                 * @static
                 * @param {waiternow.common.DeviceProto.IInterestsProto} message InterestsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                InterestsProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an InterestsProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.DeviceProto.InterestsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.DeviceProto.InterestsProto} InterestsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                InterestsProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.DeviceProto.InterestsProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 2: {
                                message.pointOfServiceId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an InterestsProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.DeviceProto.InterestsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.DeviceProto.InterestsProto} InterestsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                InterestsProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an InterestsProto message.
                 * @function verify
                 * @memberof waiternow.common.DeviceProto.InterestsProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                InterestsProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    if (message.pointOfServiceId != null && message.hasOwnProperty("pointOfServiceId"))
                        if (!$util.isString(message.pointOfServiceId))
                            return "pointOfServiceId: string expected";
                    return null;
                };

                /**
                 * Creates an InterestsProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.DeviceProto.InterestsProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.DeviceProto.InterestsProto} InterestsProto
                 */
                InterestsProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.DeviceProto.InterestsProto)
                        return object;
                    var message = new $root.waiternow.common.DeviceProto.InterestsProto();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    if (object.pointOfServiceId != null)
                        message.pointOfServiceId = String(object.pointOfServiceId);
                    return message;
                };

                /**
                 * Creates a plain object from an InterestsProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.DeviceProto.InterestsProto
                 * @static
                 * @param {waiternow.common.DeviceProto.InterestsProto} message InterestsProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                InterestsProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.locationId = "";
                        object.pointOfServiceId = "";
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    if (message.pointOfServiceId != null && message.hasOwnProperty("pointOfServiceId"))
                        object.pointOfServiceId = message.pointOfServiceId;
                    return object;
                };

                /**
                 * Converts this InterestsProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.DeviceProto.InterestsProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                InterestsProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for InterestsProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.DeviceProto.InterestsProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                InterestsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.DeviceProto.InterestsProto";
                };

                return InterestsProto;
            })();

            DeviceProto.StatusProto = (function() {

                /**
                 * Properties of a StatusProto.
                 * @memberof waiternow.common.DeviceProto
                 * @interface IStatusProto
                 * @property {waiternow.common.DeviceProto.StatusProto.State|null} [state] StatusProto state
                 * @property {google.protobuf.ITimestamp|null} [lastUpdateTime] StatusProto lastUpdateTime
                 */

                /**
                 * Constructs a new StatusProto.
                 * @memberof waiternow.common.DeviceProto
                 * @classdesc Represents a StatusProto.
                 * @implements IStatusProto
                 * @constructor
                 * @param {waiternow.common.DeviceProto.IStatusProto=} [properties] Properties to set
                 */
                function StatusProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StatusProto state.
                 * @member {waiternow.common.DeviceProto.StatusProto.State} state
                 * @memberof waiternow.common.DeviceProto.StatusProto
                 * @instance
                 */
                StatusProto.prototype.state = 0;

                /**
                 * StatusProto lastUpdateTime.
                 * @member {google.protobuf.ITimestamp|null|undefined} lastUpdateTime
                 * @memberof waiternow.common.DeviceProto.StatusProto
                 * @instance
                 */
                StatusProto.prototype.lastUpdateTime = null;

                /**
                 * Creates a new StatusProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.DeviceProto.StatusProto
                 * @static
                 * @param {waiternow.common.DeviceProto.IStatusProto=} [properties] Properties to set
                 * @returns {waiternow.common.DeviceProto.StatusProto} StatusProto instance
                 */
                StatusProto.create = function create(properties) {
                    return new StatusProto(properties);
                };

                /**
                 * Encodes the specified StatusProto message. Does not implicitly {@link waiternow.common.DeviceProto.StatusProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.DeviceProto.StatusProto
                 * @static
                 * @param {waiternow.common.DeviceProto.IStatusProto} message StatusProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StatusProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.state);
                    if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                        $root.google.protobuf.Timestamp.encode(message.lastUpdateTime, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified StatusProto message, length delimited. Does not implicitly {@link waiternow.common.DeviceProto.StatusProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.DeviceProto.StatusProto
                 * @static
                 * @param {waiternow.common.DeviceProto.IStatusProto} message StatusProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StatusProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a StatusProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.DeviceProto.StatusProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.DeviceProto.StatusProto} StatusProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StatusProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.DeviceProto.StatusProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.state = reader.int32();
                                break;
                            }
                        case 2: {
                                message.lastUpdateTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a StatusProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.DeviceProto.StatusProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.DeviceProto.StatusProto} StatusProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StatusProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StatusProto message.
                 * @function verify
                 * @memberof waiternow.common.DeviceProto.StatusProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StatusProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.state != null && message.hasOwnProperty("state"))
                        switch (message.state) {
                        default:
                            return "state: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                            break;
                        }
                    if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime")) {
                        var error = $root.google.protobuf.Timestamp.verify(message.lastUpdateTime);
                        if (error)
                            return "lastUpdateTime." + error;
                    }
                    return null;
                };

                /**
                 * Creates a StatusProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.DeviceProto.StatusProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.DeviceProto.StatusProto} StatusProto
                 */
                StatusProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.DeviceProto.StatusProto)
                        return object;
                    var message = new $root.waiternow.common.DeviceProto.StatusProto();
                    switch (object.state) {
                    default:
                        if (typeof object.state === "number") {
                            message.state = object.state;
                            break;
                        }
                        break;
                    case "STATE_UNSPECIFIED":
                    case 0:
                        message.state = 0;
                        break;
                    case "ACTIVE":
                    case 1:
                        message.state = 1;
                        break;
                    case "INACTIVE":
                    case 2:
                        message.state = 2;
                        break;
                    case "GRACE_PERIOD_TO_INACTIVE":
                    case 3:
                        message.state = 3;
                        break;
                    }
                    if (object.lastUpdateTime != null) {
                        if (typeof object.lastUpdateTime !== "object")
                            throw TypeError(".waiternow.common.DeviceProto.StatusProto.lastUpdateTime: object expected");
                        message.lastUpdateTime = $root.google.protobuf.Timestamp.fromObject(object.lastUpdateTime);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a StatusProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.DeviceProto.StatusProto
                 * @static
                 * @param {waiternow.common.DeviceProto.StatusProto} message StatusProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StatusProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.state = options.enums === String ? "STATE_UNSPECIFIED" : 0;
                        object.lastUpdateTime = null;
                    }
                    if (message.state != null && message.hasOwnProperty("state"))
                        object.state = options.enums === String ? $root.waiternow.common.DeviceProto.StatusProto.State[message.state] === undefined ? message.state : $root.waiternow.common.DeviceProto.StatusProto.State[message.state] : message.state;
                    if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                        object.lastUpdateTime = $root.google.protobuf.Timestamp.toObject(message.lastUpdateTime, options);
                    return object;
                };

                /**
                 * Converts this StatusProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.DeviceProto.StatusProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StatusProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for StatusProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.DeviceProto.StatusProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                StatusProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.DeviceProto.StatusProto";
                };

                /**
                 * State enum.
                 * @name waiternow.common.DeviceProto.StatusProto.State
                 * @enum {number}
                 * @property {number} STATE_UNSPECIFIED=0 STATE_UNSPECIFIED value
                 * @property {number} ACTIVE=1 ACTIVE value
                 * @property {number} INACTIVE=2 INACTIVE value
                 * @property {number} GRACE_PERIOD_TO_INACTIVE=3 GRACE_PERIOD_TO_INACTIVE value
                 */
                StatusProto.State = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "STATE_UNSPECIFIED"] = 0;
                    values[valuesById[1] = "ACTIVE"] = 1;
                    values[valuesById[2] = "INACTIVE"] = 2;
                    values[valuesById[3] = "GRACE_PERIOD_TO_INACTIVE"] = 3;
                    return values;
                })();

                return StatusProto;
            })();

            return DeviceProto;
        })();

        common.DeviceSessionInfoProto = (function() {

            /**
             * Properties of a DeviceSessionInfoProto.
             * @memberof waiternow.common
             * @interface IDeviceSessionInfoProto
             * @property {google.protobuf.IDuration|null} [expiration] DeviceSessionInfoProto expiration
             */

            /**
             * Constructs a new DeviceSessionInfoProto.
             * @memberof waiternow.common
             * @classdesc Represents a DeviceSessionInfoProto.
             * @implements IDeviceSessionInfoProto
             * @constructor
             * @param {waiternow.common.IDeviceSessionInfoProto=} [properties] Properties to set
             */
            function DeviceSessionInfoProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * DeviceSessionInfoProto expiration.
             * @member {google.protobuf.IDuration|null|undefined} expiration
             * @memberof waiternow.common.DeviceSessionInfoProto
             * @instance
             */
            DeviceSessionInfoProto.prototype.expiration = null;

            /**
             * Creates a new DeviceSessionInfoProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.DeviceSessionInfoProto
             * @static
             * @param {waiternow.common.IDeviceSessionInfoProto=} [properties] Properties to set
             * @returns {waiternow.common.DeviceSessionInfoProto} DeviceSessionInfoProto instance
             */
            DeviceSessionInfoProto.create = function create(properties) {
                return new DeviceSessionInfoProto(properties);
            };

            /**
             * Encodes the specified DeviceSessionInfoProto message. Does not implicitly {@link waiternow.common.DeviceSessionInfoProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.DeviceSessionInfoProto
             * @static
             * @param {waiternow.common.IDeviceSessionInfoProto} message DeviceSessionInfoProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DeviceSessionInfoProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.expiration != null && Object.hasOwnProperty.call(message, "expiration"))
                    $root.google.protobuf.Duration.encode(message.expiration, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified DeviceSessionInfoProto message, length delimited. Does not implicitly {@link waiternow.common.DeviceSessionInfoProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.DeviceSessionInfoProto
             * @static
             * @param {waiternow.common.IDeviceSessionInfoProto} message DeviceSessionInfoProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DeviceSessionInfoProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a DeviceSessionInfoProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.DeviceSessionInfoProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.DeviceSessionInfoProto} DeviceSessionInfoProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DeviceSessionInfoProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.DeviceSessionInfoProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.expiration = $root.google.protobuf.Duration.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a DeviceSessionInfoProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.DeviceSessionInfoProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.DeviceSessionInfoProto} DeviceSessionInfoProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DeviceSessionInfoProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a DeviceSessionInfoProto message.
             * @function verify
             * @memberof waiternow.common.DeviceSessionInfoProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            DeviceSessionInfoProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.expiration != null && message.hasOwnProperty("expiration")) {
                    var error = $root.google.protobuf.Duration.verify(message.expiration);
                    if (error)
                        return "expiration." + error;
                }
                return null;
            };

            /**
             * Creates a DeviceSessionInfoProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.DeviceSessionInfoProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.DeviceSessionInfoProto} DeviceSessionInfoProto
             */
            DeviceSessionInfoProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.DeviceSessionInfoProto)
                    return object;
                var message = new $root.waiternow.common.DeviceSessionInfoProto();
                if (object.expiration != null) {
                    if (typeof object.expiration !== "object")
                        throw TypeError(".waiternow.common.DeviceSessionInfoProto.expiration: object expected");
                    message.expiration = $root.google.protobuf.Duration.fromObject(object.expiration);
                }
                return message;
            };

            /**
             * Creates a plain object from a DeviceSessionInfoProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.DeviceSessionInfoProto
             * @static
             * @param {waiternow.common.DeviceSessionInfoProto} message DeviceSessionInfoProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            DeviceSessionInfoProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.expiration = null;
                if (message.expiration != null && message.hasOwnProperty("expiration"))
                    object.expiration = $root.google.protobuf.Duration.toObject(message.expiration, options);
                return object;
            };

            /**
             * Converts this DeviceSessionInfoProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.DeviceSessionInfoProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            DeviceSessionInfoProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for DeviceSessionInfoProto
             * @function getTypeUrl
             * @memberof waiternow.common.DeviceSessionInfoProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            DeviceSessionInfoProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.DeviceSessionInfoProto";
            };

            return DeviceSessionInfoProto;
        })();

        common.LocationDevicesProto = (function() {

            /**
             * Properties of a LocationDevicesProto.
             * @memberof waiternow.common
             * @interface ILocationDevicesProto
             * @property {string|null} [locationId] LocationDevicesProto locationId
             * @property {Array.<waiternow.common.IDeviceProto>|null} [devices] LocationDevicesProto devices
             */

            /**
             * Constructs a new LocationDevicesProto.
             * @memberof waiternow.common
             * @classdesc Represents a LocationDevicesProto.
             * @implements ILocationDevicesProto
             * @constructor
             * @param {waiternow.common.ILocationDevicesProto=} [properties] Properties to set
             */
            function LocationDevicesProto(properties) {
                this.devices = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * LocationDevicesProto locationId.
             * @member {string} locationId
             * @memberof waiternow.common.LocationDevicesProto
             * @instance
             */
            LocationDevicesProto.prototype.locationId = "";

            /**
             * LocationDevicesProto devices.
             * @member {Array.<waiternow.common.IDeviceProto>} devices
             * @memberof waiternow.common.LocationDevicesProto
             * @instance
             */
            LocationDevicesProto.prototype.devices = $util.emptyArray;

            /**
             * Creates a new LocationDevicesProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.LocationDevicesProto
             * @static
             * @param {waiternow.common.ILocationDevicesProto=} [properties] Properties to set
             * @returns {waiternow.common.LocationDevicesProto} LocationDevicesProto instance
             */
            LocationDevicesProto.create = function create(properties) {
                return new LocationDevicesProto(properties);
            };

            /**
             * Encodes the specified LocationDevicesProto message. Does not implicitly {@link waiternow.common.LocationDevicesProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.LocationDevicesProto
             * @static
             * @param {waiternow.common.ILocationDevicesProto} message LocationDevicesProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            LocationDevicesProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                if (message.devices != null && message.devices.length)
                    for (var i = 0; i < message.devices.length; ++i)
                        $root.waiternow.common.DeviceProto.encode(message.devices[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified LocationDevicesProto message, length delimited. Does not implicitly {@link waiternow.common.LocationDevicesProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.LocationDevicesProto
             * @static
             * @param {waiternow.common.ILocationDevicesProto} message LocationDevicesProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            LocationDevicesProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a LocationDevicesProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.LocationDevicesProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.LocationDevicesProto} LocationDevicesProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            LocationDevicesProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.LocationDevicesProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.locationId = reader.string();
                            break;
                        }
                    case 2: {
                            if (!(message.devices && message.devices.length))
                                message.devices = [];
                            message.devices.push($root.waiternow.common.DeviceProto.decode(reader, reader.uint32()));
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a LocationDevicesProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.LocationDevicesProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.LocationDevicesProto} LocationDevicesProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            LocationDevicesProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a LocationDevicesProto message.
             * @function verify
             * @memberof waiternow.common.LocationDevicesProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            LocationDevicesProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.locationId != null && message.hasOwnProperty("locationId"))
                    if (!$util.isString(message.locationId))
                        return "locationId: string expected";
                if (message.devices != null && message.hasOwnProperty("devices")) {
                    if (!Array.isArray(message.devices))
                        return "devices: array expected";
                    for (var i = 0; i < message.devices.length; ++i) {
                        var error = $root.waiternow.common.DeviceProto.verify(message.devices[i]);
                        if (error)
                            return "devices." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a LocationDevicesProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.LocationDevicesProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.LocationDevicesProto} LocationDevicesProto
             */
            LocationDevicesProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.LocationDevicesProto)
                    return object;
                var message = new $root.waiternow.common.LocationDevicesProto();
                if (object.locationId != null)
                    message.locationId = String(object.locationId);
                if (object.devices) {
                    if (!Array.isArray(object.devices))
                        throw TypeError(".waiternow.common.LocationDevicesProto.devices: array expected");
                    message.devices = [];
                    for (var i = 0; i < object.devices.length; ++i) {
                        if (typeof object.devices[i] !== "object")
                            throw TypeError(".waiternow.common.LocationDevicesProto.devices: object expected");
                        message.devices[i] = $root.waiternow.common.DeviceProto.fromObject(object.devices[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a LocationDevicesProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.LocationDevicesProto
             * @static
             * @param {waiternow.common.LocationDevicesProto} message LocationDevicesProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            LocationDevicesProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.devices = [];
                if (options.defaults)
                    object.locationId = "";
                if (message.locationId != null && message.hasOwnProperty("locationId"))
                    object.locationId = message.locationId;
                if (message.devices && message.devices.length) {
                    object.devices = [];
                    for (var j = 0; j < message.devices.length; ++j)
                        object.devices[j] = $root.waiternow.common.DeviceProto.toObject(message.devices[j], options);
                }
                return object;
            };

            /**
             * Converts this LocationDevicesProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.LocationDevicesProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            LocationDevicesProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for LocationDevicesProto
             * @function getTypeUrl
             * @memberof waiternow.common.LocationDevicesProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            LocationDevicesProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.LocationDevicesProto";
            };

            return LocationDevicesProto;
        })();

        common.PointOfServiceDevicesProto = (function() {

            /**
             * Properties of a PointOfServiceDevicesProto.
             * @memberof waiternow.common
             * @interface IPointOfServiceDevicesProto
             * @property {string|null} [pointOfServiceId] PointOfServiceDevicesProto pointOfServiceId
             * @property {Array.<waiternow.common.IDeviceProto>|null} [devices] PointOfServiceDevicesProto devices
             */

            /**
             * Constructs a new PointOfServiceDevicesProto.
             * @memberof waiternow.common
             * @classdesc Represents a PointOfServiceDevicesProto.
             * @implements IPointOfServiceDevicesProto
             * @constructor
             * @param {waiternow.common.IPointOfServiceDevicesProto=} [properties] Properties to set
             */
            function PointOfServiceDevicesProto(properties) {
                this.devices = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * PointOfServiceDevicesProto pointOfServiceId.
             * @member {string} pointOfServiceId
             * @memberof waiternow.common.PointOfServiceDevicesProto
             * @instance
             */
            PointOfServiceDevicesProto.prototype.pointOfServiceId = "";

            /**
             * PointOfServiceDevicesProto devices.
             * @member {Array.<waiternow.common.IDeviceProto>} devices
             * @memberof waiternow.common.PointOfServiceDevicesProto
             * @instance
             */
            PointOfServiceDevicesProto.prototype.devices = $util.emptyArray;

            /**
             * Creates a new PointOfServiceDevicesProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.PointOfServiceDevicesProto
             * @static
             * @param {waiternow.common.IPointOfServiceDevicesProto=} [properties] Properties to set
             * @returns {waiternow.common.PointOfServiceDevicesProto} PointOfServiceDevicesProto instance
             */
            PointOfServiceDevicesProto.create = function create(properties) {
                return new PointOfServiceDevicesProto(properties);
            };

            /**
             * Encodes the specified PointOfServiceDevicesProto message. Does not implicitly {@link waiternow.common.PointOfServiceDevicesProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.PointOfServiceDevicesProto
             * @static
             * @param {waiternow.common.IPointOfServiceDevicesProto} message PointOfServiceDevicesProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PointOfServiceDevicesProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.pointOfServiceId != null && Object.hasOwnProperty.call(message, "pointOfServiceId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.pointOfServiceId);
                if (message.devices != null && message.devices.length)
                    for (var i = 0; i < message.devices.length; ++i)
                        $root.waiternow.common.DeviceProto.encode(message.devices[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified PointOfServiceDevicesProto message, length delimited. Does not implicitly {@link waiternow.common.PointOfServiceDevicesProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.PointOfServiceDevicesProto
             * @static
             * @param {waiternow.common.IPointOfServiceDevicesProto} message PointOfServiceDevicesProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PointOfServiceDevicesProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a PointOfServiceDevicesProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.PointOfServiceDevicesProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.PointOfServiceDevicesProto} PointOfServiceDevicesProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PointOfServiceDevicesProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PointOfServiceDevicesProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.pointOfServiceId = reader.string();
                            break;
                        }
                    case 2: {
                            if (!(message.devices && message.devices.length))
                                message.devices = [];
                            message.devices.push($root.waiternow.common.DeviceProto.decode(reader, reader.uint32()));
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a PointOfServiceDevicesProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.PointOfServiceDevicesProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.PointOfServiceDevicesProto} PointOfServiceDevicesProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PointOfServiceDevicesProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a PointOfServiceDevicesProto message.
             * @function verify
             * @memberof waiternow.common.PointOfServiceDevicesProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            PointOfServiceDevicesProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.pointOfServiceId != null && message.hasOwnProperty("pointOfServiceId"))
                    if (!$util.isString(message.pointOfServiceId))
                        return "pointOfServiceId: string expected";
                if (message.devices != null && message.hasOwnProperty("devices")) {
                    if (!Array.isArray(message.devices))
                        return "devices: array expected";
                    for (var i = 0; i < message.devices.length; ++i) {
                        var error = $root.waiternow.common.DeviceProto.verify(message.devices[i]);
                        if (error)
                            return "devices." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a PointOfServiceDevicesProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.PointOfServiceDevicesProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.PointOfServiceDevicesProto} PointOfServiceDevicesProto
             */
            PointOfServiceDevicesProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.PointOfServiceDevicesProto)
                    return object;
                var message = new $root.waiternow.common.PointOfServiceDevicesProto();
                if (object.pointOfServiceId != null)
                    message.pointOfServiceId = String(object.pointOfServiceId);
                if (object.devices) {
                    if (!Array.isArray(object.devices))
                        throw TypeError(".waiternow.common.PointOfServiceDevicesProto.devices: array expected");
                    message.devices = [];
                    for (var i = 0; i < object.devices.length; ++i) {
                        if (typeof object.devices[i] !== "object")
                            throw TypeError(".waiternow.common.PointOfServiceDevicesProto.devices: object expected");
                        message.devices[i] = $root.waiternow.common.DeviceProto.fromObject(object.devices[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a PointOfServiceDevicesProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.PointOfServiceDevicesProto
             * @static
             * @param {waiternow.common.PointOfServiceDevicesProto} message PointOfServiceDevicesProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            PointOfServiceDevicesProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.devices = [];
                if (options.defaults)
                    object.pointOfServiceId = "";
                if (message.pointOfServiceId != null && message.hasOwnProperty("pointOfServiceId"))
                    object.pointOfServiceId = message.pointOfServiceId;
                if (message.devices && message.devices.length) {
                    object.devices = [];
                    for (var j = 0; j < message.devices.length; ++j)
                        object.devices[j] = $root.waiternow.common.DeviceProto.toObject(message.devices[j], options);
                }
                return object;
            };

            /**
             * Converts this PointOfServiceDevicesProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.PointOfServiceDevicesProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            PointOfServiceDevicesProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for PointOfServiceDevicesProto
             * @function getTypeUrl
             * @memberof waiternow.common.PointOfServiceDevicesProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            PointOfServiceDevicesProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.PointOfServiceDevicesProto";
            };

            return PointOfServiceDevicesProto;
        })();

        /**
         * PeriodType enum.
         * @name waiternow.common.PeriodType
         * @enum {number}
         * @property {number} PERIOD_TYPE_UNSPECIFIED=0 PERIOD_TYPE_UNSPECIFIED value
         * @property {number} DAILY=1 DAILY value
         * @property {number} MONTHLY=2 MONTHLY value
         * @property {number} YEARLY=3 YEARLY value
         */
        common.PeriodType = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "PERIOD_TYPE_UNSPECIFIED"] = 0;
            values[valuesById[1] = "DAILY"] = 1;
            values[valuesById[2] = "MONTHLY"] = 2;
            values[valuesById[3] = "YEARLY"] = 3;
            return values;
        })();

        common.MetricProto = (function() {

            /**
             * Properties of a MetricProto.
             * @memberof waiternow.common
             * @interface IMetricProto
             * @property {string|null} [id] MetricProto id
             * @property {waiternow.common.IDateRangeProto|null} [period] MetricProto period
             * @property {waiternow.common.PeriodType|null} [periodType] MetricProto periodType
             * @property {google.protobuf.ITimestamp|null} [creationTime] MetricProto creationTime
             * @property {google.protobuf.ITimestamp|null} [lastUpdateTime] MetricProto lastUpdateTime
             * @property {number|null} [newLocations] MetricProto newLocations
             * @property {number|null} [locationsEnrolledOnPayments] MetricProto locationsEnrolledOnPayments
             * @property {number|null} [paidOrders] MetricProto paidOrders
             * @property {number|null} [refundedOrders] MetricProto refundedOrders
             * @property {waiternow.common.IMoneyProto|null} [orderPaymentsVolume] MetricProto orderPaymentsVolume
             * @property {waiternow.common.IMoneyProto|null} [waiternowOrderPaymentsRevenue] MetricProto waiternowOrderPaymentsRevenue
             * @property {waiternow.common.IMoneyProto|null} [refundedOrdersVolume] MetricProto refundedOrdersVolume
             * @property {number|null} [checkIns] MetricProto checkIns
             * @property {number|null} [orders] MetricProto orders
             * @property {number|null} [reviews] MetricProto reviews
             * @property {number|null} [reviewsWithComments] MetricProto reviewsWithComments
             * @property {number|null} [incompleteOrders] MetricProto incompleteOrders
             * @property {number|null} [onlinePickupOrders] MetricProto onlinePickupOrders
             * @property {number|null} [deliveryOrders] MetricProto deliveryOrders
             * @property {waiternow.common.MetricProto.IMetricValuesProto|null} [metricValuesUs] MetricProto metricValuesUs
             * @property {waiternow.common.MetricProto.IMetricValuesProto|null} [metricValuesMx] MetricProto metricValuesMx
             */

            /**
             * Constructs a new MetricProto.
             * @memberof waiternow.common
             * @classdesc Represents a MetricProto.
             * @implements IMetricProto
             * @constructor
             * @param {waiternow.common.IMetricProto=} [properties] Properties to set
             */
            function MetricProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * MetricProto id.
             * @member {string} id
             * @memberof waiternow.common.MetricProto
             * @instance
             */
            MetricProto.prototype.id = "";

            /**
             * MetricProto period.
             * @member {waiternow.common.IDateRangeProto|null|undefined} period
             * @memberof waiternow.common.MetricProto
             * @instance
             */
            MetricProto.prototype.period = null;

            /**
             * MetricProto periodType.
             * @member {waiternow.common.PeriodType} periodType
             * @memberof waiternow.common.MetricProto
             * @instance
             */
            MetricProto.prototype.periodType = 0;

            /**
             * MetricProto creationTime.
             * @member {google.protobuf.ITimestamp|null|undefined} creationTime
             * @memberof waiternow.common.MetricProto
             * @instance
             */
            MetricProto.prototype.creationTime = null;

            /**
             * MetricProto lastUpdateTime.
             * @member {google.protobuf.ITimestamp|null|undefined} lastUpdateTime
             * @memberof waiternow.common.MetricProto
             * @instance
             */
            MetricProto.prototype.lastUpdateTime = null;

            /**
             * MetricProto newLocations.
             * @member {number} newLocations
             * @memberof waiternow.common.MetricProto
             * @instance
             */
            MetricProto.prototype.newLocations = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * MetricProto locationsEnrolledOnPayments.
             * @member {number} locationsEnrolledOnPayments
             * @memberof waiternow.common.MetricProto
             * @instance
             */
            MetricProto.prototype.locationsEnrolledOnPayments = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * MetricProto paidOrders.
             * @member {number} paidOrders
             * @memberof waiternow.common.MetricProto
             * @instance
             */
            MetricProto.prototype.paidOrders = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * MetricProto refundedOrders.
             * @member {number} refundedOrders
             * @memberof waiternow.common.MetricProto
             * @instance
             */
            MetricProto.prototype.refundedOrders = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * MetricProto orderPaymentsVolume.
             * @member {waiternow.common.IMoneyProto|null|undefined} orderPaymentsVolume
             * @memberof waiternow.common.MetricProto
             * @instance
             */
            MetricProto.prototype.orderPaymentsVolume = null;

            /**
             * MetricProto waiternowOrderPaymentsRevenue.
             * @member {waiternow.common.IMoneyProto|null|undefined} waiternowOrderPaymentsRevenue
             * @memberof waiternow.common.MetricProto
             * @instance
             */
            MetricProto.prototype.waiternowOrderPaymentsRevenue = null;

            /**
             * MetricProto refundedOrdersVolume.
             * @member {waiternow.common.IMoneyProto|null|undefined} refundedOrdersVolume
             * @memberof waiternow.common.MetricProto
             * @instance
             */
            MetricProto.prototype.refundedOrdersVolume = null;

            /**
             * MetricProto checkIns.
             * @member {number} checkIns
             * @memberof waiternow.common.MetricProto
             * @instance
             */
            MetricProto.prototype.checkIns = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * MetricProto orders.
             * @member {number} orders
             * @memberof waiternow.common.MetricProto
             * @instance
             */
            MetricProto.prototype.orders = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * MetricProto reviews.
             * @member {number} reviews
             * @memberof waiternow.common.MetricProto
             * @instance
             */
            MetricProto.prototype.reviews = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * MetricProto reviewsWithComments.
             * @member {number} reviewsWithComments
             * @memberof waiternow.common.MetricProto
             * @instance
             */
            MetricProto.prototype.reviewsWithComments = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * MetricProto incompleteOrders.
             * @member {number} incompleteOrders
             * @memberof waiternow.common.MetricProto
             * @instance
             */
            MetricProto.prototype.incompleteOrders = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * MetricProto onlinePickupOrders.
             * @member {number} onlinePickupOrders
             * @memberof waiternow.common.MetricProto
             * @instance
             */
            MetricProto.prototype.onlinePickupOrders = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * MetricProto deliveryOrders.
             * @member {number} deliveryOrders
             * @memberof waiternow.common.MetricProto
             * @instance
             */
            MetricProto.prototype.deliveryOrders = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * MetricProto metricValuesUs.
             * @member {waiternow.common.MetricProto.IMetricValuesProto|null|undefined} metricValuesUs
             * @memberof waiternow.common.MetricProto
             * @instance
             */
            MetricProto.prototype.metricValuesUs = null;

            /**
             * MetricProto metricValuesMx.
             * @member {waiternow.common.MetricProto.IMetricValuesProto|null|undefined} metricValuesMx
             * @memberof waiternow.common.MetricProto
             * @instance
             */
            MetricProto.prototype.metricValuesMx = null;

            /**
             * Creates a new MetricProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.MetricProto
             * @static
             * @param {waiternow.common.IMetricProto=} [properties] Properties to set
             * @returns {waiternow.common.MetricProto} MetricProto instance
             */
            MetricProto.create = function create(properties) {
                return new MetricProto(properties);
            };

            /**
             * Encodes the specified MetricProto message. Does not implicitly {@link waiternow.common.MetricProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.MetricProto
             * @static
             * @param {waiternow.common.IMetricProto} message MetricProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MetricProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                if (message.period != null && Object.hasOwnProperty.call(message, "period"))
                    $root.waiternow.common.DateRangeProto.encode(message.period, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.periodType != null && Object.hasOwnProperty.call(message, "periodType"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.periodType);
                if (message.creationTime != null && Object.hasOwnProperty.call(message, "creationTime"))
                    $root.google.protobuf.Timestamp.encode(message.creationTime, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                    $root.google.protobuf.Timestamp.encode(message.lastUpdateTime, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                if (message.newLocations != null && Object.hasOwnProperty.call(message, "newLocations"))
                    writer.uint32(/* id 6, wireType 0 =*/48).int64(message.newLocations);
                if (message.locationsEnrolledOnPayments != null && Object.hasOwnProperty.call(message, "locationsEnrolledOnPayments"))
                    writer.uint32(/* id 7, wireType 0 =*/56).int64(message.locationsEnrolledOnPayments);
                if (message.paidOrders != null && Object.hasOwnProperty.call(message, "paidOrders"))
                    writer.uint32(/* id 8, wireType 0 =*/64).int64(message.paidOrders);
                if (message.refundedOrders != null && Object.hasOwnProperty.call(message, "refundedOrders"))
                    writer.uint32(/* id 9, wireType 0 =*/72).int64(message.refundedOrders);
                if (message.orderPaymentsVolume != null && Object.hasOwnProperty.call(message, "orderPaymentsVolume"))
                    $root.waiternow.common.MoneyProto.encode(message.orderPaymentsVolume, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                if (message.waiternowOrderPaymentsRevenue != null && Object.hasOwnProperty.call(message, "waiternowOrderPaymentsRevenue"))
                    $root.waiternow.common.MoneyProto.encode(message.waiternowOrderPaymentsRevenue, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                if (message.refundedOrdersVolume != null && Object.hasOwnProperty.call(message, "refundedOrdersVolume"))
                    $root.waiternow.common.MoneyProto.encode(message.refundedOrdersVolume, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                if (message.checkIns != null && Object.hasOwnProperty.call(message, "checkIns"))
                    writer.uint32(/* id 13, wireType 0 =*/104).int64(message.checkIns);
                if (message.orders != null && Object.hasOwnProperty.call(message, "orders"))
                    writer.uint32(/* id 14, wireType 0 =*/112).int64(message.orders);
                if (message.reviews != null && Object.hasOwnProperty.call(message, "reviews"))
                    writer.uint32(/* id 15, wireType 0 =*/120).int64(message.reviews);
                if (message.reviewsWithComments != null && Object.hasOwnProperty.call(message, "reviewsWithComments"))
                    writer.uint32(/* id 16, wireType 0 =*/128).int64(message.reviewsWithComments);
                if (message.incompleteOrders != null && Object.hasOwnProperty.call(message, "incompleteOrders"))
                    writer.uint32(/* id 17, wireType 0 =*/136).int64(message.incompleteOrders);
                if (message.onlinePickupOrders != null && Object.hasOwnProperty.call(message, "onlinePickupOrders"))
                    writer.uint32(/* id 18, wireType 0 =*/144).int64(message.onlinePickupOrders);
                if (message.deliveryOrders != null && Object.hasOwnProperty.call(message, "deliveryOrders"))
                    writer.uint32(/* id 19, wireType 0 =*/152).int64(message.deliveryOrders);
                if (message.metricValuesUs != null && Object.hasOwnProperty.call(message, "metricValuesUs"))
                    $root.waiternow.common.MetricProto.MetricValuesProto.encode(message.metricValuesUs, writer.uint32(/* id 20, wireType 2 =*/162).fork()).ldelim();
                if (message.metricValuesMx != null && Object.hasOwnProperty.call(message, "metricValuesMx"))
                    $root.waiternow.common.MetricProto.MetricValuesProto.encode(message.metricValuesMx, writer.uint32(/* id 21, wireType 2 =*/170).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified MetricProto message, length delimited. Does not implicitly {@link waiternow.common.MetricProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.MetricProto
             * @static
             * @param {waiternow.common.IMetricProto} message MetricProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MetricProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a MetricProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.MetricProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.MetricProto} MetricProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MetricProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.MetricProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.id = reader.string();
                            break;
                        }
                    case 2: {
                            message.period = $root.waiternow.common.DateRangeProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 3: {
                            message.periodType = reader.int32();
                            break;
                        }
                    case 4: {
                            message.creationTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 5: {
                            message.lastUpdateTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 6: {
                            message.newLocations = reader.int64();
                            break;
                        }
                    case 7: {
                            message.locationsEnrolledOnPayments = reader.int64();
                            break;
                        }
                    case 8: {
                            message.paidOrders = reader.int64();
                            break;
                        }
                    case 9: {
                            message.refundedOrders = reader.int64();
                            break;
                        }
                    case 10: {
                            message.orderPaymentsVolume = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 11: {
                            message.waiternowOrderPaymentsRevenue = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 12: {
                            message.refundedOrdersVolume = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 13: {
                            message.checkIns = reader.int64();
                            break;
                        }
                    case 14: {
                            message.orders = reader.int64();
                            break;
                        }
                    case 15: {
                            message.reviews = reader.int64();
                            break;
                        }
                    case 16: {
                            message.reviewsWithComments = reader.int64();
                            break;
                        }
                    case 17: {
                            message.incompleteOrders = reader.int64();
                            break;
                        }
                    case 18: {
                            message.onlinePickupOrders = reader.int64();
                            break;
                        }
                    case 19: {
                            message.deliveryOrders = reader.int64();
                            break;
                        }
                    case 20: {
                            message.metricValuesUs = $root.waiternow.common.MetricProto.MetricValuesProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 21: {
                            message.metricValuesMx = $root.waiternow.common.MetricProto.MetricValuesProto.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a MetricProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.MetricProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.MetricProto} MetricProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MetricProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a MetricProto message.
             * @function verify
             * @memberof waiternow.common.MetricProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            MetricProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.id != null && message.hasOwnProperty("id"))
                    if (!$util.isString(message.id))
                        return "id: string expected";
                if (message.period != null && message.hasOwnProperty("period")) {
                    var error = $root.waiternow.common.DateRangeProto.verify(message.period);
                    if (error)
                        return "period." + error;
                }
                if (message.periodType != null && message.hasOwnProperty("periodType"))
                    switch (message.periodType) {
                    default:
                        return "periodType: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                        break;
                    }
                if (message.creationTime != null && message.hasOwnProperty("creationTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.creationTime);
                    if (error)
                        return "creationTime." + error;
                }
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.lastUpdateTime);
                    if (error)
                        return "lastUpdateTime." + error;
                }
                if (message.newLocations != null && message.hasOwnProperty("newLocations"))
                    if (!$util.isInteger(message.newLocations) && !(message.newLocations && $util.isInteger(message.newLocations.low) && $util.isInteger(message.newLocations.high)))
                        return "newLocations: integer|Long expected";
                if (message.locationsEnrolledOnPayments != null && message.hasOwnProperty("locationsEnrolledOnPayments"))
                    if (!$util.isInteger(message.locationsEnrolledOnPayments) && !(message.locationsEnrolledOnPayments && $util.isInteger(message.locationsEnrolledOnPayments.low) && $util.isInteger(message.locationsEnrolledOnPayments.high)))
                        return "locationsEnrolledOnPayments: integer|Long expected";
                if (message.paidOrders != null && message.hasOwnProperty("paidOrders"))
                    if (!$util.isInteger(message.paidOrders) && !(message.paidOrders && $util.isInteger(message.paidOrders.low) && $util.isInteger(message.paidOrders.high)))
                        return "paidOrders: integer|Long expected";
                if (message.refundedOrders != null && message.hasOwnProperty("refundedOrders"))
                    if (!$util.isInteger(message.refundedOrders) && !(message.refundedOrders && $util.isInteger(message.refundedOrders.low) && $util.isInteger(message.refundedOrders.high)))
                        return "refundedOrders: integer|Long expected";
                if (message.orderPaymentsVolume != null && message.hasOwnProperty("orderPaymentsVolume")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.orderPaymentsVolume);
                    if (error)
                        return "orderPaymentsVolume." + error;
                }
                if (message.waiternowOrderPaymentsRevenue != null && message.hasOwnProperty("waiternowOrderPaymentsRevenue")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.waiternowOrderPaymentsRevenue);
                    if (error)
                        return "waiternowOrderPaymentsRevenue." + error;
                }
                if (message.refundedOrdersVolume != null && message.hasOwnProperty("refundedOrdersVolume")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.refundedOrdersVolume);
                    if (error)
                        return "refundedOrdersVolume." + error;
                }
                if (message.checkIns != null && message.hasOwnProperty("checkIns"))
                    if (!$util.isInteger(message.checkIns) && !(message.checkIns && $util.isInteger(message.checkIns.low) && $util.isInteger(message.checkIns.high)))
                        return "checkIns: integer|Long expected";
                if (message.orders != null && message.hasOwnProperty("orders"))
                    if (!$util.isInteger(message.orders) && !(message.orders && $util.isInteger(message.orders.low) && $util.isInteger(message.orders.high)))
                        return "orders: integer|Long expected";
                if (message.reviews != null && message.hasOwnProperty("reviews"))
                    if (!$util.isInteger(message.reviews) && !(message.reviews && $util.isInteger(message.reviews.low) && $util.isInteger(message.reviews.high)))
                        return "reviews: integer|Long expected";
                if (message.reviewsWithComments != null && message.hasOwnProperty("reviewsWithComments"))
                    if (!$util.isInteger(message.reviewsWithComments) && !(message.reviewsWithComments && $util.isInteger(message.reviewsWithComments.low) && $util.isInteger(message.reviewsWithComments.high)))
                        return "reviewsWithComments: integer|Long expected";
                if (message.incompleteOrders != null && message.hasOwnProperty("incompleteOrders"))
                    if (!$util.isInteger(message.incompleteOrders) && !(message.incompleteOrders && $util.isInteger(message.incompleteOrders.low) && $util.isInteger(message.incompleteOrders.high)))
                        return "incompleteOrders: integer|Long expected";
                if (message.onlinePickupOrders != null && message.hasOwnProperty("onlinePickupOrders"))
                    if (!$util.isInteger(message.onlinePickupOrders) && !(message.onlinePickupOrders && $util.isInteger(message.onlinePickupOrders.low) && $util.isInteger(message.onlinePickupOrders.high)))
                        return "onlinePickupOrders: integer|Long expected";
                if (message.deliveryOrders != null && message.hasOwnProperty("deliveryOrders"))
                    if (!$util.isInteger(message.deliveryOrders) && !(message.deliveryOrders && $util.isInteger(message.deliveryOrders.low) && $util.isInteger(message.deliveryOrders.high)))
                        return "deliveryOrders: integer|Long expected";
                if (message.metricValuesUs != null && message.hasOwnProperty("metricValuesUs")) {
                    var error = $root.waiternow.common.MetricProto.MetricValuesProto.verify(message.metricValuesUs);
                    if (error)
                        return "metricValuesUs." + error;
                }
                if (message.metricValuesMx != null && message.hasOwnProperty("metricValuesMx")) {
                    var error = $root.waiternow.common.MetricProto.MetricValuesProto.verify(message.metricValuesMx);
                    if (error)
                        return "metricValuesMx." + error;
                }
                return null;
            };

            /**
             * Creates a MetricProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.MetricProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.MetricProto} MetricProto
             */
            MetricProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.MetricProto)
                    return object;
                var message = new $root.waiternow.common.MetricProto();
                if (object.id != null)
                    message.id = String(object.id);
                if (object.period != null) {
                    if (typeof object.period !== "object")
                        throw TypeError(".waiternow.common.MetricProto.period: object expected");
                    message.period = $root.waiternow.common.DateRangeProto.fromObject(object.period);
                }
                switch (object.periodType) {
                default:
                    if (typeof object.periodType === "number") {
                        message.periodType = object.periodType;
                        break;
                    }
                    break;
                case "PERIOD_TYPE_UNSPECIFIED":
                case 0:
                    message.periodType = 0;
                    break;
                case "DAILY":
                case 1:
                    message.periodType = 1;
                    break;
                case "MONTHLY":
                case 2:
                    message.periodType = 2;
                    break;
                case "YEARLY":
                case 3:
                    message.periodType = 3;
                    break;
                }
                if (object.creationTime != null) {
                    if (typeof object.creationTime !== "object")
                        throw TypeError(".waiternow.common.MetricProto.creationTime: object expected");
                    message.creationTime = $root.google.protobuf.Timestamp.fromObject(object.creationTime);
                }
                if (object.lastUpdateTime != null) {
                    if (typeof object.lastUpdateTime !== "object")
                        throw TypeError(".waiternow.common.MetricProto.lastUpdateTime: object expected");
                    message.lastUpdateTime = $root.google.protobuf.Timestamp.fromObject(object.lastUpdateTime);
                }
                if (object.newLocations != null)
                    if ($util.Long)
                        (message.newLocations = $util.Long.fromValue(object.newLocations)).unsigned = false;
                    else if (typeof object.newLocations === "string")
                        message.newLocations = parseInt(object.newLocations, 10);
                    else if (typeof object.newLocations === "number")
                        message.newLocations = object.newLocations;
                    else if (typeof object.newLocations === "object")
                        message.newLocations = new $util.LongBits(object.newLocations.low >>> 0, object.newLocations.high >>> 0).toNumber();
                if (object.locationsEnrolledOnPayments != null)
                    if ($util.Long)
                        (message.locationsEnrolledOnPayments = $util.Long.fromValue(object.locationsEnrolledOnPayments)).unsigned = false;
                    else if (typeof object.locationsEnrolledOnPayments === "string")
                        message.locationsEnrolledOnPayments = parseInt(object.locationsEnrolledOnPayments, 10);
                    else if (typeof object.locationsEnrolledOnPayments === "number")
                        message.locationsEnrolledOnPayments = object.locationsEnrolledOnPayments;
                    else if (typeof object.locationsEnrolledOnPayments === "object")
                        message.locationsEnrolledOnPayments = new $util.LongBits(object.locationsEnrolledOnPayments.low >>> 0, object.locationsEnrolledOnPayments.high >>> 0).toNumber();
                if (object.paidOrders != null)
                    if ($util.Long)
                        (message.paidOrders = $util.Long.fromValue(object.paidOrders)).unsigned = false;
                    else if (typeof object.paidOrders === "string")
                        message.paidOrders = parseInt(object.paidOrders, 10);
                    else if (typeof object.paidOrders === "number")
                        message.paidOrders = object.paidOrders;
                    else if (typeof object.paidOrders === "object")
                        message.paidOrders = new $util.LongBits(object.paidOrders.low >>> 0, object.paidOrders.high >>> 0).toNumber();
                if (object.refundedOrders != null)
                    if ($util.Long)
                        (message.refundedOrders = $util.Long.fromValue(object.refundedOrders)).unsigned = false;
                    else if (typeof object.refundedOrders === "string")
                        message.refundedOrders = parseInt(object.refundedOrders, 10);
                    else if (typeof object.refundedOrders === "number")
                        message.refundedOrders = object.refundedOrders;
                    else if (typeof object.refundedOrders === "object")
                        message.refundedOrders = new $util.LongBits(object.refundedOrders.low >>> 0, object.refundedOrders.high >>> 0).toNumber();
                if (object.orderPaymentsVolume != null) {
                    if (typeof object.orderPaymentsVolume !== "object")
                        throw TypeError(".waiternow.common.MetricProto.orderPaymentsVolume: object expected");
                    message.orderPaymentsVolume = $root.waiternow.common.MoneyProto.fromObject(object.orderPaymentsVolume);
                }
                if (object.waiternowOrderPaymentsRevenue != null) {
                    if (typeof object.waiternowOrderPaymentsRevenue !== "object")
                        throw TypeError(".waiternow.common.MetricProto.waiternowOrderPaymentsRevenue: object expected");
                    message.waiternowOrderPaymentsRevenue = $root.waiternow.common.MoneyProto.fromObject(object.waiternowOrderPaymentsRevenue);
                }
                if (object.refundedOrdersVolume != null) {
                    if (typeof object.refundedOrdersVolume !== "object")
                        throw TypeError(".waiternow.common.MetricProto.refundedOrdersVolume: object expected");
                    message.refundedOrdersVolume = $root.waiternow.common.MoneyProto.fromObject(object.refundedOrdersVolume);
                }
                if (object.checkIns != null)
                    if ($util.Long)
                        (message.checkIns = $util.Long.fromValue(object.checkIns)).unsigned = false;
                    else if (typeof object.checkIns === "string")
                        message.checkIns = parseInt(object.checkIns, 10);
                    else if (typeof object.checkIns === "number")
                        message.checkIns = object.checkIns;
                    else if (typeof object.checkIns === "object")
                        message.checkIns = new $util.LongBits(object.checkIns.low >>> 0, object.checkIns.high >>> 0).toNumber();
                if (object.orders != null)
                    if ($util.Long)
                        (message.orders = $util.Long.fromValue(object.orders)).unsigned = false;
                    else if (typeof object.orders === "string")
                        message.orders = parseInt(object.orders, 10);
                    else if (typeof object.orders === "number")
                        message.orders = object.orders;
                    else if (typeof object.orders === "object")
                        message.orders = new $util.LongBits(object.orders.low >>> 0, object.orders.high >>> 0).toNumber();
                if (object.reviews != null)
                    if ($util.Long)
                        (message.reviews = $util.Long.fromValue(object.reviews)).unsigned = false;
                    else if (typeof object.reviews === "string")
                        message.reviews = parseInt(object.reviews, 10);
                    else if (typeof object.reviews === "number")
                        message.reviews = object.reviews;
                    else if (typeof object.reviews === "object")
                        message.reviews = new $util.LongBits(object.reviews.low >>> 0, object.reviews.high >>> 0).toNumber();
                if (object.reviewsWithComments != null)
                    if ($util.Long)
                        (message.reviewsWithComments = $util.Long.fromValue(object.reviewsWithComments)).unsigned = false;
                    else if (typeof object.reviewsWithComments === "string")
                        message.reviewsWithComments = parseInt(object.reviewsWithComments, 10);
                    else if (typeof object.reviewsWithComments === "number")
                        message.reviewsWithComments = object.reviewsWithComments;
                    else if (typeof object.reviewsWithComments === "object")
                        message.reviewsWithComments = new $util.LongBits(object.reviewsWithComments.low >>> 0, object.reviewsWithComments.high >>> 0).toNumber();
                if (object.incompleteOrders != null)
                    if ($util.Long)
                        (message.incompleteOrders = $util.Long.fromValue(object.incompleteOrders)).unsigned = false;
                    else if (typeof object.incompleteOrders === "string")
                        message.incompleteOrders = parseInt(object.incompleteOrders, 10);
                    else if (typeof object.incompleteOrders === "number")
                        message.incompleteOrders = object.incompleteOrders;
                    else if (typeof object.incompleteOrders === "object")
                        message.incompleteOrders = new $util.LongBits(object.incompleteOrders.low >>> 0, object.incompleteOrders.high >>> 0).toNumber();
                if (object.onlinePickupOrders != null)
                    if ($util.Long)
                        (message.onlinePickupOrders = $util.Long.fromValue(object.onlinePickupOrders)).unsigned = false;
                    else if (typeof object.onlinePickupOrders === "string")
                        message.onlinePickupOrders = parseInt(object.onlinePickupOrders, 10);
                    else if (typeof object.onlinePickupOrders === "number")
                        message.onlinePickupOrders = object.onlinePickupOrders;
                    else if (typeof object.onlinePickupOrders === "object")
                        message.onlinePickupOrders = new $util.LongBits(object.onlinePickupOrders.low >>> 0, object.onlinePickupOrders.high >>> 0).toNumber();
                if (object.deliveryOrders != null)
                    if ($util.Long)
                        (message.deliveryOrders = $util.Long.fromValue(object.deliveryOrders)).unsigned = false;
                    else if (typeof object.deliveryOrders === "string")
                        message.deliveryOrders = parseInt(object.deliveryOrders, 10);
                    else if (typeof object.deliveryOrders === "number")
                        message.deliveryOrders = object.deliveryOrders;
                    else if (typeof object.deliveryOrders === "object")
                        message.deliveryOrders = new $util.LongBits(object.deliveryOrders.low >>> 0, object.deliveryOrders.high >>> 0).toNumber();
                if (object.metricValuesUs != null) {
                    if (typeof object.metricValuesUs !== "object")
                        throw TypeError(".waiternow.common.MetricProto.metricValuesUs: object expected");
                    message.metricValuesUs = $root.waiternow.common.MetricProto.MetricValuesProto.fromObject(object.metricValuesUs);
                }
                if (object.metricValuesMx != null) {
                    if (typeof object.metricValuesMx !== "object")
                        throw TypeError(".waiternow.common.MetricProto.metricValuesMx: object expected");
                    message.metricValuesMx = $root.waiternow.common.MetricProto.MetricValuesProto.fromObject(object.metricValuesMx);
                }
                return message;
            };

            /**
             * Creates a plain object from a MetricProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.MetricProto
             * @static
             * @param {waiternow.common.MetricProto} message MetricProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            MetricProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.id = "";
                    object.period = null;
                    object.periodType = options.enums === String ? "PERIOD_TYPE_UNSPECIFIED" : 0;
                    object.creationTime = null;
                    object.lastUpdateTime = null;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.newLocations = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.newLocations = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.locationsEnrolledOnPayments = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.locationsEnrolledOnPayments = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.paidOrders = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.paidOrders = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.refundedOrders = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.refundedOrders = options.longs === String ? "0" : 0;
                    object.orderPaymentsVolume = null;
                    object.waiternowOrderPaymentsRevenue = null;
                    object.refundedOrdersVolume = null;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.checkIns = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.checkIns = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.orders = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.orders = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.reviews = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.reviews = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.reviewsWithComments = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.reviewsWithComments = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.incompleteOrders = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.incompleteOrders = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.onlinePickupOrders = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.onlinePickupOrders = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.deliveryOrders = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.deliveryOrders = options.longs === String ? "0" : 0;
                    object.metricValuesUs = null;
                    object.metricValuesMx = null;
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                if (message.period != null && message.hasOwnProperty("period"))
                    object.period = $root.waiternow.common.DateRangeProto.toObject(message.period, options);
                if (message.periodType != null && message.hasOwnProperty("periodType"))
                    object.periodType = options.enums === String ? $root.waiternow.common.PeriodType[message.periodType] === undefined ? message.periodType : $root.waiternow.common.PeriodType[message.periodType] : message.periodType;
                if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                    object.creationTime = $root.google.protobuf.Timestamp.toObject(message.creationTime, options);
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                    object.lastUpdateTime = $root.google.protobuf.Timestamp.toObject(message.lastUpdateTime, options);
                if (message.newLocations != null && message.hasOwnProperty("newLocations"))
                    if (typeof message.newLocations === "number")
                        object.newLocations = options.longs === String ? String(message.newLocations) : message.newLocations;
                    else
                        object.newLocations = options.longs === String ? $util.Long.prototype.toString.call(message.newLocations) : options.longs === Number ? new $util.LongBits(message.newLocations.low >>> 0, message.newLocations.high >>> 0).toNumber() : message.newLocations;
                if (message.locationsEnrolledOnPayments != null && message.hasOwnProperty("locationsEnrolledOnPayments"))
                    if (typeof message.locationsEnrolledOnPayments === "number")
                        object.locationsEnrolledOnPayments = options.longs === String ? String(message.locationsEnrolledOnPayments) : message.locationsEnrolledOnPayments;
                    else
                        object.locationsEnrolledOnPayments = options.longs === String ? $util.Long.prototype.toString.call(message.locationsEnrolledOnPayments) : options.longs === Number ? new $util.LongBits(message.locationsEnrolledOnPayments.low >>> 0, message.locationsEnrolledOnPayments.high >>> 0).toNumber() : message.locationsEnrolledOnPayments;
                if (message.paidOrders != null && message.hasOwnProperty("paidOrders"))
                    if (typeof message.paidOrders === "number")
                        object.paidOrders = options.longs === String ? String(message.paidOrders) : message.paidOrders;
                    else
                        object.paidOrders = options.longs === String ? $util.Long.prototype.toString.call(message.paidOrders) : options.longs === Number ? new $util.LongBits(message.paidOrders.low >>> 0, message.paidOrders.high >>> 0).toNumber() : message.paidOrders;
                if (message.refundedOrders != null && message.hasOwnProperty("refundedOrders"))
                    if (typeof message.refundedOrders === "number")
                        object.refundedOrders = options.longs === String ? String(message.refundedOrders) : message.refundedOrders;
                    else
                        object.refundedOrders = options.longs === String ? $util.Long.prototype.toString.call(message.refundedOrders) : options.longs === Number ? new $util.LongBits(message.refundedOrders.low >>> 0, message.refundedOrders.high >>> 0).toNumber() : message.refundedOrders;
                if (message.orderPaymentsVolume != null && message.hasOwnProperty("orderPaymentsVolume"))
                    object.orderPaymentsVolume = $root.waiternow.common.MoneyProto.toObject(message.orderPaymentsVolume, options);
                if (message.waiternowOrderPaymentsRevenue != null && message.hasOwnProperty("waiternowOrderPaymentsRevenue"))
                    object.waiternowOrderPaymentsRevenue = $root.waiternow.common.MoneyProto.toObject(message.waiternowOrderPaymentsRevenue, options);
                if (message.refundedOrdersVolume != null && message.hasOwnProperty("refundedOrdersVolume"))
                    object.refundedOrdersVolume = $root.waiternow.common.MoneyProto.toObject(message.refundedOrdersVolume, options);
                if (message.checkIns != null && message.hasOwnProperty("checkIns"))
                    if (typeof message.checkIns === "number")
                        object.checkIns = options.longs === String ? String(message.checkIns) : message.checkIns;
                    else
                        object.checkIns = options.longs === String ? $util.Long.prototype.toString.call(message.checkIns) : options.longs === Number ? new $util.LongBits(message.checkIns.low >>> 0, message.checkIns.high >>> 0).toNumber() : message.checkIns;
                if (message.orders != null && message.hasOwnProperty("orders"))
                    if (typeof message.orders === "number")
                        object.orders = options.longs === String ? String(message.orders) : message.orders;
                    else
                        object.orders = options.longs === String ? $util.Long.prototype.toString.call(message.orders) : options.longs === Number ? new $util.LongBits(message.orders.low >>> 0, message.orders.high >>> 0).toNumber() : message.orders;
                if (message.reviews != null && message.hasOwnProperty("reviews"))
                    if (typeof message.reviews === "number")
                        object.reviews = options.longs === String ? String(message.reviews) : message.reviews;
                    else
                        object.reviews = options.longs === String ? $util.Long.prototype.toString.call(message.reviews) : options.longs === Number ? new $util.LongBits(message.reviews.low >>> 0, message.reviews.high >>> 0).toNumber() : message.reviews;
                if (message.reviewsWithComments != null && message.hasOwnProperty("reviewsWithComments"))
                    if (typeof message.reviewsWithComments === "number")
                        object.reviewsWithComments = options.longs === String ? String(message.reviewsWithComments) : message.reviewsWithComments;
                    else
                        object.reviewsWithComments = options.longs === String ? $util.Long.prototype.toString.call(message.reviewsWithComments) : options.longs === Number ? new $util.LongBits(message.reviewsWithComments.low >>> 0, message.reviewsWithComments.high >>> 0).toNumber() : message.reviewsWithComments;
                if (message.incompleteOrders != null && message.hasOwnProperty("incompleteOrders"))
                    if (typeof message.incompleteOrders === "number")
                        object.incompleteOrders = options.longs === String ? String(message.incompleteOrders) : message.incompleteOrders;
                    else
                        object.incompleteOrders = options.longs === String ? $util.Long.prototype.toString.call(message.incompleteOrders) : options.longs === Number ? new $util.LongBits(message.incompleteOrders.low >>> 0, message.incompleteOrders.high >>> 0).toNumber() : message.incompleteOrders;
                if (message.onlinePickupOrders != null && message.hasOwnProperty("onlinePickupOrders"))
                    if (typeof message.onlinePickupOrders === "number")
                        object.onlinePickupOrders = options.longs === String ? String(message.onlinePickupOrders) : message.onlinePickupOrders;
                    else
                        object.onlinePickupOrders = options.longs === String ? $util.Long.prototype.toString.call(message.onlinePickupOrders) : options.longs === Number ? new $util.LongBits(message.onlinePickupOrders.low >>> 0, message.onlinePickupOrders.high >>> 0).toNumber() : message.onlinePickupOrders;
                if (message.deliveryOrders != null && message.hasOwnProperty("deliveryOrders"))
                    if (typeof message.deliveryOrders === "number")
                        object.deliveryOrders = options.longs === String ? String(message.deliveryOrders) : message.deliveryOrders;
                    else
                        object.deliveryOrders = options.longs === String ? $util.Long.prototype.toString.call(message.deliveryOrders) : options.longs === Number ? new $util.LongBits(message.deliveryOrders.low >>> 0, message.deliveryOrders.high >>> 0).toNumber() : message.deliveryOrders;
                if (message.metricValuesUs != null && message.hasOwnProperty("metricValuesUs"))
                    object.metricValuesUs = $root.waiternow.common.MetricProto.MetricValuesProto.toObject(message.metricValuesUs, options);
                if (message.metricValuesMx != null && message.hasOwnProperty("metricValuesMx"))
                    object.metricValuesMx = $root.waiternow.common.MetricProto.MetricValuesProto.toObject(message.metricValuesMx, options);
                return object;
            };

            /**
             * Converts this MetricProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.MetricProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            MetricProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for MetricProto
             * @function getTypeUrl
             * @memberof waiternow.common.MetricProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            MetricProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.MetricProto";
            };

            MetricProto.MetricValuesProto = (function() {

                /**
                 * Properties of a MetricValuesProto.
                 * @memberof waiternow.common.MetricProto
                 * @interface IMetricValuesProto
                 * @property {number|null} [newLocations] MetricValuesProto newLocations
                 * @property {number|null} [locationsEnrolledOnPayments] MetricValuesProto locationsEnrolledOnPayments
                 * @property {number|null} [paidOrders] MetricValuesProto paidOrders
                 * @property {number|null} [refundedOrders] MetricValuesProto refundedOrders
                 * @property {waiternow.common.IMoneyProto|null} [orderPaymentsVolume] MetricValuesProto orderPaymentsVolume
                 * @property {waiternow.common.IMoneyProto|null} [waiternowOrderPaymentsRevenue] MetricValuesProto waiternowOrderPaymentsRevenue
                 * @property {waiternow.common.IMoneyProto|null} [refundedOrdersVolume] MetricValuesProto refundedOrdersVolume
                 * @property {number|null} [checkIns] MetricValuesProto checkIns
                 * @property {number|null} [orders] MetricValuesProto orders
                 * @property {number|null} [reviews] MetricValuesProto reviews
                 * @property {number|null} [reviewsWithComments] MetricValuesProto reviewsWithComments
                 * @property {number|null} [incompleteOrders] MetricValuesProto incompleteOrders
                 * @property {number|null} [onlinePickupOrders] MetricValuesProto onlinePickupOrders
                 * @property {number|null} [deliveryOrders] MetricValuesProto deliveryOrders
                 * @property {number|null} [disputedOrders] MetricValuesProto disputedOrders
                 * @property {waiternow.common.IMoneyProto|null} [disputedOrdersVolume] MetricValuesProto disputedOrdersVolume
                 * @property {number|null} [onsitePickupOrders] MetricValuesProto onsitePickupOrders
                 * @property {number|null} [onsiteOrders] MetricValuesProto onsiteOrders
                 */

                /**
                 * Constructs a new MetricValuesProto.
                 * @memberof waiternow.common.MetricProto
                 * @classdesc Represents a MetricValuesProto.
                 * @implements IMetricValuesProto
                 * @constructor
                 * @param {waiternow.common.MetricProto.IMetricValuesProto=} [properties] Properties to set
                 */
                function MetricValuesProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * MetricValuesProto newLocations.
                 * @member {number} newLocations
                 * @memberof waiternow.common.MetricProto.MetricValuesProto
                 * @instance
                 */
                MetricValuesProto.prototype.newLocations = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * MetricValuesProto locationsEnrolledOnPayments.
                 * @member {number} locationsEnrolledOnPayments
                 * @memberof waiternow.common.MetricProto.MetricValuesProto
                 * @instance
                 */
                MetricValuesProto.prototype.locationsEnrolledOnPayments = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * MetricValuesProto paidOrders.
                 * @member {number} paidOrders
                 * @memberof waiternow.common.MetricProto.MetricValuesProto
                 * @instance
                 */
                MetricValuesProto.prototype.paidOrders = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * MetricValuesProto refundedOrders.
                 * @member {number} refundedOrders
                 * @memberof waiternow.common.MetricProto.MetricValuesProto
                 * @instance
                 */
                MetricValuesProto.prototype.refundedOrders = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * MetricValuesProto orderPaymentsVolume.
                 * @member {waiternow.common.IMoneyProto|null|undefined} orderPaymentsVolume
                 * @memberof waiternow.common.MetricProto.MetricValuesProto
                 * @instance
                 */
                MetricValuesProto.prototype.orderPaymentsVolume = null;

                /**
                 * MetricValuesProto waiternowOrderPaymentsRevenue.
                 * @member {waiternow.common.IMoneyProto|null|undefined} waiternowOrderPaymentsRevenue
                 * @memberof waiternow.common.MetricProto.MetricValuesProto
                 * @instance
                 */
                MetricValuesProto.prototype.waiternowOrderPaymentsRevenue = null;

                /**
                 * MetricValuesProto refundedOrdersVolume.
                 * @member {waiternow.common.IMoneyProto|null|undefined} refundedOrdersVolume
                 * @memberof waiternow.common.MetricProto.MetricValuesProto
                 * @instance
                 */
                MetricValuesProto.prototype.refundedOrdersVolume = null;

                /**
                 * MetricValuesProto checkIns.
                 * @member {number} checkIns
                 * @memberof waiternow.common.MetricProto.MetricValuesProto
                 * @instance
                 */
                MetricValuesProto.prototype.checkIns = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * MetricValuesProto orders.
                 * @member {number} orders
                 * @memberof waiternow.common.MetricProto.MetricValuesProto
                 * @instance
                 */
                MetricValuesProto.prototype.orders = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * MetricValuesProto reviews.
                 * @member {number} reviews
                 * @memberof waiternow.common.MetricProto.MetricValuesProto
                 * @instance
                 */
                MetricValuesProto.prototype.reviews = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * MetricValuesProto reviewsWithComments.
                 * @member {number} reviewsWithComments
                 * @memberof waiternow.common.MetricProto.MetricValuesProto
                 * @instance
                 */
                MetricValuesProto.prototype.reviewsWithComments = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * MetricValuesProto incompleteOrders.
                 * @member {number} incompleteOrders
                 * @memberof waiternow.common.MetricProto.MetricValuesProto
                 * @instance
                 */
                MetricValuesProto.prototype.incompleteOrders = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * MetricValuesProto onlinePickupOrders.
                 * @member {number} onlinePickupOrders
                 * @memberof waiternow.common.MetricProto.MetricValuesProto
                 * @instance
                 */
                MetricValuesProto.prototype.onlinePickupOrders = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * MetricValuesProto deliveryOrders.
                 * @member {number} deliveryOrders
                 * @memberof waiternow.common.MetricProto.MetricValuesProto
                 * @instance
                 */
                MetricValuesProto.prototype.deliveryOrders = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * MetricValuesProto disputedOrders.
                 * @member {number} disputedOrders
                 * @memberof waiternow.common.MetricProto.MetricValuesProto
                 * @instance
                 */
                MetricValuesProto.prototype.disputedOrders = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * MetricValuesProto disputedOrdersVolume.
                 * @member {waiternow.common.IMoneyProto|null|undefined} disputedOrdersVolume
                 * @memberof waiternow.common.MetricProto.MetricValuesProto
                 * @instance
                 */
                MetricValuesProto.prototype.disputedOrdersVolume = null;

                /**
                 * MetricValuesProto onsitePickupOrders.
                 * @member {number} onsitePickupOrders
                 * @memberof waiternow.common.MetricProto.MetricValuesProto
                 * @instance
                 */
                MetricValuesProto.prototype.onsitePickupOrders = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * MetricValuesProto onsiteOrders.
                 * @member {number} onsiteOrders
                 * @memberof waiternow.common.MetricProto.MetricValuesProto
                 * @instance
                 */
                MetricValuesProto.prototype.onsiteOrders = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Creates a new MetricValuesProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.MetricProto.MetricValuesProto
                 * @static
                 * @param {waiternow.common.MetricProto.IMetricValuesProto=} [properties] Properties to set
                 * @returns {waiternow.common.MetricProto.MetricValuesProto} MetricValuesProto instance
                 */
                MetricValuesProto.create = function create(properties) {
                    return new MetricValuesProto(properties);
                };

                /**
                 * Encodes the specified MetricValuesProto message. Does not implicitly {@link waiternow.common.MetricProto.MetricValuesProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.MetricProto.MetricValuesProto
                 * @static
                 * @param {waiternow.common.MetricProto.IMetricValuesProto} message MetricValuesProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MetricValuesProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.newLocations != null && Object.hasOwnProperty.call(message, "newLocations"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.newLocations);
                    if (message.locationsEnrolledOnPayments != null && Object.hasOwnProperty.call(message, "locationsEnrolledOnPayments"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int64(message.locationsEnrolledOnPayments);
                    if (message.paidOrders != null && Object.hasOwnProperty.call(message, "paidOrders"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int64(message.paidOrders);
                    if (message.refundedOrders != null && Object.hasOwnProperty.call(message, "refundedOrders"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int64(message.refundedOrders);
                    if (message.orderPaymentsVolume != null && Object.hasOwnProperty.call(message, "orderPaymentsVolume"))
                        $root.waiternow.common.MoneyProto.encode(message.orderPaymentsVolume, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.waiternowOrderPaymentsRevenue != null && Object.hasOwnProperty.call(message, "waiternowOrderPaymentsRevenue"))
                        $root.waiternow.common.MoneyProto.encode(message.waiternowOrderPaymentsRevenue, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.refundedOrdersVolume != null && Object.hasOwnProperty.call(message, "refundedOrdersVolume"))
                        $root.waiternow.common.MoneyProto.encode(message.refundedOrdersVolume, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    if (message.checkIns != null && Object.hasOwnProperty.call(message, "checkIns"))
                        writer.uint32(/* id 8, wireType 0 =*/64).int64(message.checkIns);
                    if (message.orders != null && Object.hasOwnProperty.call(message, "orders"))
                        writer.uint32(/* id 9, wireType 0 =*/72).int64(message.orders);
                    if (message.reviews != null && Object.hasOwnProperty.call(message, "reviews"))
                        writer.uint32(/* id 10, wireType 0 =*/80).int64(message.reviews);
                    if (message.reviewsWithComments != null && Object.hasOwnProperty.call(message, "reviewsWithComments"))
                        writer.uint32(/* id 11, wireType 0 =*/88).int64(message.reviewsWithComments);
                    if (message.incompleteOrders != null && Object.hasOwnProperty.call(message, "incompleteOrders"))
                        writer.uint32(/* id 12, wireType 0 =*/96).int64(message.incompleteOrders);
                    if (message.onlinePickupOrders != null && Object.hasOwnProperty.call(message, "onlinePickupOrders"))
                        writer.uint32(/* id 13, wireType 0 =*/104).int64(message.onlinePickupOrders);
                    if (message.deliveryOrders != null && Object.hasOwnProperty.call(message, "deliveryOrders"))
                        writer.uint32(/* id 14, wireType 0 =*/112).int64(message.deliveryOrders);
                    if (message.disputedOrders != null && Object.hasOwnProperty.call(message, "disputedOrders"))
                        writer.uint32(/* id 15, wireType 0 =*/120).int64(message.disputedOrders);
                    if (message.disputedOrdersVolume != null && Object.hasOwnProperty.call(message, "disputedOrdersVolume"))
                        $root.waiternow.common.MoneyProto.encode(message.disputedOrdersVolume, writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
                    if (message.onsitePickupOrders != null && Object.hasOwnProperty.call(message, "onsitePickupOrders"))
                        writer.uint32(/* id 17, wireType 0 =*/136).int64(message.onsitePickupOrders);
                    if (message.onsiteOrders != null && Object.hasOwnProperty.call(message, "onsiteOrders"))
                        writer.uint32(/* id 18, wireType 0 =*/144).int64(message.onsiteOrders);
                    return writer;
                };

                /**
                 * Encodes the specified MetricValuesProto message, length delimited. Does not implicitly {@link waiternow.common.MetricProto.MetricValuesProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.MetricProto.MetricValuesProto
                 * @static
                 * @param {waiternow.common.MetricProto.IMetricValuesProto} message MetricValuesProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MetricValuesProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a MetricValuesProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.MetricProto.MetricValuesProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.MetricProto.MetricValuesProto} MetricValuesProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MetricValuesProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.MetricProto.MetricValuesProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.newLocations = reader.int64();
                                break;
                            }
                        case 2: {
                                message.locationsEnrolledOnPayments = reader.int64();
                                break;
                            }
                        case 3: {
                                message.paidOrders = reader.int64();
                                break;
                            }
                        case 4: {
                                message.refundedOrders = reader.int64();
                                break;
                            }
                        case 5: {
                                message.orderPaymentsVolume = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 6: {
                                message.waiternowOrderPaymentsRevenue = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 7: {
                                message.refundedOrdersVolume = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 8: {
                                message.checkIns = reader.int64();
                                break;
                            }
                        case 9: {
                                message.orders = reader.int64();
                                break;
                            }
                        case 10: {
                                message.reviews = reader.int64();
                                break;
                            }
                        case 11: {
                                message.reviewsWithComments = reader.int64();
                                break;
                            }
                        case 12: {
                                message.incompleteOrders = reader.int64();
                                break;
                            }
                        case 13: {
                                message.onlinePickupOrders = reader.int64();
                                break;
                            }
                        case 14: {
                                message.deliveryOrders = reader.int64();
                                break;
                            }
                        case 15: {
                                message.disputedOrders = reader.int64();
                                break;
                            }
                        case 16: {
                                message.disputedOrdersVolume = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 17: {
                                message.onsitePickupOrders = reader.int64();
                                break;
                            }
                        case 18: {
                                message.onsiteOrders = reader.int64();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a MetricValuesProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.MetricProto.MetricValuesProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.MetricProto.MetricValuesProto} MetricValuesProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MetricValuesProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a MetricValuesProto message.
                 * @function verify
                 * @memberof waiternow.common.MetricProto.MetricValuesProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                MetricValuesProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.newLocations != null && message.hasOwnProperty("newLocations"))
                        if (!$util.isInteger(message.newLocations) && !(message.newLocations && $util.isInteger(message.newLocations.low) && $util.isInteger(message.newLocations.high)))
                            return "newLocations: integer|Long expected";
                    if (message.locationsEnrolledOnPayments != null && message.hasOwnProperty("locationsEnrolledOnPayments"))
                        if (!$util.isInteger(message.locationsEnrolledOnPayments) && !(message.locationsEnrolledOnPayments && $util.isInteger(message.locationsEnrolledOnPayments.low) && $util.isInteger(message.locationsEnrolledOnPayments.high)))
                            return "locationsEnrolledOnPayments: integer|Long expected";
                    if (message.paidOrders != null && message.hasOwnProperty("paidOrders"))
                        if (!$util.isInteger(message.paidOrders) && !(message.paidOrders && $util.isInteger(message.paidOrders.low) && $util.isInteger(message.paidOrders.high)))
                            return "paidOrders: integer|Long expected";
                    if (message.refundedOrders != null && message.hasOwnProperty("refundedOrders"))
                        if (!$util.isInteger(message.refundedOrders) && !(message.refundedOrders && $util.isInteger(message.refundedOrders.low) && $util.isInteger(message.refundedOrders.high)))
                            return "refundedOrders: integer|Long expected";
                    if (message.orderPaymentsVolume != null && message.hasOwnProperty("orderPaymentsVolume")) {
                        var error = $root.waiternow.common.MoneyProto.verify(message.orderPaymentsVolume);
                        if (error)
                            return "orderPaymentsVolume." + error;
                    }
                    if (message.waiternowOrderPaymentsRevenue != null && message.hasOwnProperty("waiternowOrderPaymentsRevenue")) {
                        var error = $root.waiternow.common.MoneyProto.verify(message.waiternowOrderPaymentsRevenue);
                        if (error)
                            return "waiternowOrderPaymentsRevenue." + error;
                    }
                    if (message.refundedOrdersVolume != null && message.hasOwnProperty("refundedOrdersVolume")) {
                        var error = $root.waiternow.common.MoneyProto.verify(message.refundedOrdersVolume);
                        if (error)
                            return "refundedOrdersVolume." + error;
                    }
                    if (message.checkIns != null && message.hasOwnProperty("checkIns"))
                        if (!$util.isInteger(message.checkIns) && !(message.checkIns && $util.isInteger(message.checkIns.low) && $util.isInteger(message.checkIns.high)))
                            return "checkIns: integer|Long expected";
                    if (message.orders != null && message.hasOwnProperty("orders"))
                        if (!$util.isInteger(message.orders) && !(message.orders && $util.isInteger(message.orders.low) && $util.isInteger(message.orders.high)))
                            return "orders: integer|Long expected";
                    if (message.reviews != null && message.hasOwnProperty("reviews"))
                        if (!$util.isInteger(message.reviews) && !(message.reviews && $util.isInteger(message.reviews.low) && $util.isInteger(message.reviews.high)))
                            return "reviews: integer|Long expected";
                    if (message.reviewsWithComments != null && message.hasOwnProperty("reviewsWithComments"))
                        if (!$util.isInteger(message.reviewsWithComments) && !(message.reviewsWithComments && $util.isInteger(message.reviewsWithComments.low) && $util.isInteger(message.reviewsWithComments.high)))
                            return "reviewsWithComments: integer|Long expected";
                    if (message.incompleteOrders != null && message.hasOwnProperty("incompleteOrders"))
                        if (!$util.isInteger(message.incompleteOrders) && !(message.incompleteOrders && $util.isInteger(message.incompleteOrders.low) && $util.isInteger(message.incompleteOrders.high)))
                            return "incompleteOrders: integer|Long expected";
                    if (message.onlinePickupOrders != null && message.hasOwnProperty("onlinePickupOrders"))
                        if (!$util.isInteger(message.onlinePickupOrders) && !(message.onlinePickupOrders && $util.isInteger(message.onlinePickupOrders.low) && $util.isInteger(message.onlinePickupOrders.high)))
                            return "onlinePickupOrders: integer|Long expected";
                    if (message.deliveryOrders != null && message.hasOwnProperty("deliveryOrders"))
                        if (!$util.isInteger(message.deliveryOrders) && !(message.deliveryOrders && $util.isInteger(message.deliveryOrders.low) && $util.isInteger(message.deliveryOrders.high)))
                            return "deliveryOrders: integer|Long expected";
                    if (message.disputedOrders != null && message.hasOwnProperty("disputedOrders"))
                        if (!$util.isInteger(message.disputedOrders) && !(message.disputedOrders && $util.isInteger(message.disputedOrders.low) && $util.isInteger(message.disputedOrders.high)))
                            return "disputedOrders: integer|Long expected";
                    if (message.disputedOrdersVolume != null && message.hasOwnProperty("disputedOrdersVolume")) {
                        var error = $root.waiternow.common.MoneyProto.verify(message.disputedOrdersVolume);
                        if (error)
                            return "disputedOrdersVolume." + error;
                    }
                    if (message.onsitePickupOrders != null && message.hasOwnProperty("onsitePickupOrders"))
                        if (!$util.isInteger(message.onsitePickupOrders) && !(message.onsitePickupOrders && $util.isInteger(message.onsitePickupOrders.low) && $util.isInteger(message.onsitePickupOrders.high)))
                            return "onsitePickupOrders: integer|Long expected";
                    if (message.onsiteOrders != null && message.hasOwnProperty("onsiteOrders"))
                        if (!$util.isInteger(message.onsiteOrders) && !(message.onsiteOrders && $util.isInteger(message.onsiteOrders.low) && $util.isInteger(message.onsiteOrders.high)))
                            return "onsiteOrders: integer|Long expected";
                    return null;
                };

                /**
                 * Creates a MetricValuesProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.MetricProto.MetricValuesProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.MetricProto.MetricValuesProto} MetricValuesProto
                 */
                MetricValuesProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.MetricProto.MetricValuesProto)
                        return object;
                    var message = new $root.waiternow.common.MetricProto.MetricValuesProto();
                    if (object.newLocations != null)
                        if ($util.Long)
                            (message.newLocations = $util.Long.fromValue(object.newLocations)).unsigned = false;
                        else if (typeof object.newLocations === "string")
                            message.newLocations = parseInt(object.newLocations, 10);
                        else if (typeof object.newLocations === "number")
                            message.newLocations = object.newLocations;
                        else if (typeof object.newLocations === "object")
                            message.newLocations = new $util.LongBits(object.newLocations.low >>> 0, object.newLocations.high >>> 0).toNumber();
                    if (object.locationsEnrolledOnPayments != null)
                        if ($util.Long)
                            (message.locationsEnrolledOnPayments = $util.Long.fromValue(object.locationsEnrolledOnPayments)).unsigned = false;
                        else if (typeof object.locationsEnrolledOnPayments === "string")
                            message.locationsEnrolledOnPayments = parseInt(object.locationsEnrolledOnPayments, 10);
                        else if (typeof object.locationsEnrolledOnPayments === "number")
                            message.locationsEnrolledOnPayments = object.locationsEnrolledOnPayments;
                        else if (typeof object.locationsEnrolledOnPayments === "object")
                            message.locationsEnrolledOnPayments = new $util.LongBits(object.locationsEnrolledOnPayments.low >>> 0, object.locationsEnrolledOnPayments.high >>> 0).toNumber();
                    if (object.paidOrders != null)
                        if ($util.Long)
                            (message.paidOrders = $util.Long.fromValue(object.paidOrders)).unsigned = false;
                        else if (typeof object.paidOrders === "string")
                            message.paidOrders = parseInt(object.paidOrders, 10);
                        else if (typeof object.paidOrders === "number")
                            message.paidOrders = object.paidOrders;
                        else if (typeof object.paidOrders === "object")
                            message.paidOrders = new $util.LongBits(object.paidOrders.low >>> 0, object.paidOrders.high >>> 0).toNumber();
                    if (object.refundedOrders != null)
                        if ($util.Long)
                            (message.refundedOrders = $util.Long.fromValue(object.refundedOrders)).unsigned = false;
                        else if (typeof object.refundedOrders === "string")
                            message.refundedOrders = parseInt(object.refundedOrders, 10);
                        else if (typeof object.refundedOrders === "number")
                            message.refundedOrders = object.refundedOrders;
                        else if (typeof object.refundedOrders === "object")
                            message.refundedOrders = new $util.LongBits(object.refundedOrders.low >>> 0, object.refundedOrders.high >>> 0).toNumber();
                    if (object.orderPaymentsVolume != null) {
                        if (typeof object.orderPaymentsVolume !== "object")
                            throw TypeError(".waiternow.common.MetricProto.MetricValuesProto.orderPaymentsVolume: object expected");
                        message.orderPaymentsVolume = $root.waiternow.common.MoneyProto.fromObject(object.orderPaymentsVolume);
                    }
                    if (object.waiternowOrderPaymentsRevenue != null) {
                        if (typeof object.waiternowOrderPaymentsRevenue !== "object")
                            throw TypeError(".waiternow.common.MetricProto.MetricValuesProto.waiternowOrderPaymentsRevenue: object expected");
                        message.waiternowOrderPaymentsRevenue = $root.waiternow.common.MoneyProto.fromObject(object.waiternowOrderPaymentsRevenue);
                    }
                    if (object.refundedOrdersVolume != null) {
                        if (typeof object.refundedOrdersVolume !== "object")
                            throw TypeError(".waiternow.common.MetricProto.MetricValuesProto.refundedOrdersVolume: object expected");
                        message.refundedOrdersVolume = $root.waiternow.common.MoneyProto.fromObject(object.refundedOrdersVolume);
                    }
                    if (object.checkIns != null)
                        if ($util.Long)
                            (message.checkIns = $util.Long.fromValue(object.checkIns)).unsigned = false;
                        else if (typeof object.checkIns === "string")
                            message.checkIns = parseInt(object.checkIns, 10);
                        else if (typeof object.checkIns === "number")
                            message.checkIns = object.checkIns;
                        else if (typeof object.checkIns === "object")
                            message.checkIns = new $util.LongBits(object.checkIns.low >>> 0, object.checkIns.high >>> 0).toNumber();
                    if (object.orders != null)
                        if ($util.Long)
                            (message.orders = $util.Long.fromValue(object.orders)).unsigned = false;
                        else if (typeof object.orders === "string")
                            message.orders = parseInt(object.orders, 10);
                        else if (typeof object.orders === "number")
                            message.orders = object.orders;
                        else if (typeof object.orders === "object")
                            message.orders = new $util.LongBits(object.orders.low >>> 0, object.orders.high >>> 0).toNumber();
                    if (object.reviews != null)
                        if ($util.Long)
                            (message.reviews = $util.Long.fromValue(object.reviews)).unsigned = false;
                        else if (typeof object.reviews === "string")
                            message.reviews = parseInt(object.reviews, 10);
                        else if (typeof object.reviews === "number")
                            message.reviews = object.reviews;
                        else if (typeof object.reviews === "object")
                            message.reviews = new $util.LongBits(object.reviews.low >>> 0, object.reviews.high >>> 0).toNumber();
                    if (object.reviewsWithComments != null)
                        if ($util.Long)
                            (message.reviewsWithComments = $util.Long.fromValue(object.reviewsWithComments)).unsigned = false;
                        else if (typeof object.reviewsWithComments === "string")
                            message.reviewsWithComments = parseInt(object.reviewsWithComments, 10);
                        else if (typeof object.reviewsWithComments === "number")
                            message.reviewsWithComments = object.reviewsWithComments;
                        else if (typeof object.reviewsWithComments === "object")
                            message.reviewsWithComments = new $util.LongBits(object.reviewsWithComments.low >>> 0, object.reviewsWithComments.high >>> 0).toNumber();
                    if (object.incompleteOrders != null)
                        if ($util.Long)
                            (message.incompleteOrders = $util.Long.fromValue(object.incompleteOrders)).unsigned = false;
                        else if (typeof object.incompleteOrders === "string")
                            message.incompleteOrders = parseInt(object.incompleteOrders, 10);
                        else if (typeof object.incompleteOrders === "number")
                            message.incompleteOrders = object.incompleteOrders;
                        else if (typeof object.incompleteOrders === "object")
                            message.incompleteOrders = new $util.LongBits(object.incompleteOrders.low >>> 0, object.incompleteOrders.high >>> 0).toNumber();
                    if (object.onlinePickupOrders != null)
                        if ($util.Long)
                            (message.onlinePickupOrders = $util.Long.fromValue(object.onlinePickupOrders)).unsigned = false;
                        else if (typeof object.onlinePickupOrders === "string")
                            message.onlinePickupOrders = parseInt(object.onlinePickupOrders, 10);
                        else if (typeof object.onlinePickupOrders === "number")
                            message.onlinePickupOrders = object.onlinePickupOrders;
                        else if (typeof object.onlinePickupOrders === "object")
                            message.onlinePickupOrders = new $util.LongBits(object.onlinePickupOrders.low >>> 0, object.onlinePickupOrders.high >>> 0).toNumber();
                    if (object.deliveryOrders != null)
                        if ($util.Long)
                            (message.deliveryOrders = $util.Long.fromValue(object.deliveryOrders)).unsigned = false;
                        else if (typeof object.deliveryOrders === "string")
                            message.deliveryOrders = parseInt(object.deliveryOrders, 10);
                        else if (typeof object.deliveryOrders === "number")
                            message.deliveryOrders = object.deliveryOrders;
                        else if (typeof object.deliveryOrders === "object")
                            message.deliveryOrders = new $util.LongBits(object.deliveryOrders.low >>> 0, object.deliveryOrders.high >>> 0).toNumber();
                    if (object.disputedOrders != null)
                        if ($util.Long)
                            (message.disputedOrders = $util.Long.fromValue(object.disputedOrders)).unsigned = false;
                        else if (typeof object.disputedOrders === "string")
                            message.disputedOrders = parseInt(object.disputedOrders, 10);
                        else if (typeof object.disputedOrders === "number")
                            message.disputedOrders = object.disputedOrders;
                        else if (typeof object.disputedOrders === "object")
                            message.disputedOrders = new $util.LongBits(object.disputedOrders.low >>> 0, object.disputedOrders.high >>> 0).toNumber();
                    if (object.disputedOrdersVolume != null) {
                        if (typeof object.disputedOrdersVolume !== "object")
                            throw TypeError(".waiternow.common.MetricProto.MetricValuesProto.disputedOrdersVolume: object expected");
                        message.disputedOrdersVolume = $root.waiternow.common.MoneyProto.fromObject(object.disputedOrdersVolume);
                    }
                    if (object.onsitePickupOrders != null)
                        if ($util.Long)
                            (message.onsitePickupOrders = $util.Long.fromValue(object.onsitePickupOrders)).unsigned = false;
                        else if (typeof object.onsitePickupOrders === "string")
                            message.onsitePickupOrders = parseInt(object.onsitePickupOrders, 10);
                        else if (typeof object.onsitePickupOrders === "number")
                            message.onsitePickupOrders = object.onsitePickupOrders;
                        else if (typeof object.onsitePickupOrders === "object")
                            message.onsitePickupOrders = new $util.LongBits(object.onsitePickupOrders.low >>> 0, object.onsitePickupOrders.high >>> 0).toNumber();
                    if (object.onsiteOrders != null)
                        if ($util.Long)
                            (message.onsiteOrders = $util.Long.fromValue(object.onsiteOrders)).unsigned = false;
                        else if (typeof object.onsiteOrders === "string")
                            message.onsiteOrders = parseInt(object.onsiteOrders, 10);
                        else if (typeof object.onsiteOrders === "number")
                            message.onsiteOrders = object.onsiteOrders;
                        else if (typeof object.onsiteOrders === "object")
                            message.onsiteOrders = new $util.LongBits(object.onsiteOrders.low >>> 0, object.onsiteOrders.high >>> 0).toNumber();
                    return message;
                };

                /**
                 * Creates a plain object from a MetricValuesProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.MetricProto.MetricValuesProto
                 * @static
                 * @param {waiternow.common.MetricProto.MetricValuesProto} message MetricValuesProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                MetricValuesProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.newLocations = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.newLocations = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.locationsEnrolledOnPayments = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.locationsEnrolledOnPayments = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.paidOrders = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.paidOrders = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.refundedOrders = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.refundedOrders = options.longs === String ? "0" : 0;
                        object.orderPaymentsVolume = null;
                        object.waiternowOrderPaymentsRevenue = null;
                        object.refundedOrdersVolume = null;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.checkIns = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.checkIns = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.orders = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.orders = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.reviews = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.reviews = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.reviewsWithComments = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.reviewsWithComments = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.incompleteOrders = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.incompleteOrders = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.onlinePickupOrders = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.onlinePickupOrders = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.deliveryOrders = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.deliveryOrders = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.disputedOrders = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.disputedOrders = options.longs === String ? "0" : 0;
                        object.disputedOrdersVolume = null;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.onsitePickupOrders = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.onsitePickupOrders = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.onsiteOrders = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.onsiteOrders = options.longs === String ? "0" : 0;
                    }
                    if (message.newLocations != null && message.hasOwnProperty("newLocations"))
                        if (typeof message.newLocations === "number")
                            object.newLocations = options.longs === String ? String(message.newLocations) : message.newLocations;
                        else
                            object.newLocations = options.longs === String ? $util.Long.prototype.toString.call(message.newLocations) : options.longs === Number ? new $util.LongBits(message.newLocations.low >>> 0, message.newLocations.high >>> 0).toNumber() : message.newLocations;
                    if (message.locationsEnrolledOnPayments != null && message.hasOwnProperty("locationsEnrolledOnPayments"))
                        if (typeof message.locationsEnrolledOnPayments === "number")
                            object.locationsEnrolledOnPayments = options.longs === String ? String(message.locationsEnrolledOnPayments) : message.locationsEnrolledOnPayments;
                        else
                            object.locationsEnrolledOnPayments = options.longs === String ? $util.Long.prototype.toString.call(message.locationsEnrolledOnPayments) : options.longs === Number ? new $util.LongBits(message.locationsEnrolledOnPayments.low >>> 0, message.locationsEnrolledOnPayments.high >>> 0).toNumber() : message.locationsEnrolledOnPayments;
                    if (message.paidOrders != null && message.hasOwnProperty("paidOrders"))
                        if (typeof message.paidOrders === "number")
                            object.paidOrders = options.longs === String ? String(message.paidOrders) : message.paidOrders;
                        else
                            object.paidOrders = options.longs === String ? $util.Long.prototype.toString.call(message.paidOrders) : options.longs === Number ? new $util.LongBits(message.paidOrders.low >>> 0, message.paidOrders.high >>> 0).toNumber() : message.paidOrders;
                    if (message.refundedOrders != null && message.hasOwnProperty("refundedOrders"))
                        if (typeof message.refundedOrders === "number")
                            object.refundedOrders = options.longs === String ? String(message.refundedOrders) : message.refundedOrders;
                        else
                            object.refundedOrders = options.longs === String ? $util.Long.prototype.toString.call(message.refundedOrders) : options.longs === Number ? new $util.LongBits(message.refundedOrders.low >>> 0, message.refundedOrders.high >>> 0).toNumber() : message.refundedOrders;
                    if (message.orderPaymentsVolume != null && message.hasOwnProperty("orderPaymentsVolume"))
                        object.orderPaymentsVolume = $root.waiternow.common.MoneyProto.toObject(message.orderPaymentsVolume, options);
                    if (message.waiternowOrderPaymentsRevenue != null && message.hasOwnProperty("waiternowOrderPaymentsRevenue"))
                        object.waiternowOrderPaymentsRevenue = $root.waiternow.common.MoneyProto.toObject(message.waiternowOrderPaymentsRevenue, options);
                    if (message.refundedOrdersVolume != null && message.hasOwnProperty("refundedOrdersVolume"))
                        object.refundedOrdersVolume = $root.waiternow.common.MoneyProto.toObject(message.refundedOrdersVolume, options);
                    if (message.checkIns != null && message.hasOwnProperty("checkIns"))
                        if (typeof message.checkIns === "number")
                            object.checkIns = options.longs === String ? String(message.checkIns) : message.checkIns;
                        else
                            object.checkIns = options.longs === String ? $util.Long.prototype.toString.call(message.checkIns) : options.longs === Number ? new $util.LongBits(message.checkIns.low >>> 0, message.checkIns.high >>> 0).toNumber() : message.checkIns;
                    if (message.orders != null && message.hasOwnProperty("orders"))
                        if (typeof message.orders === "number")
                            object.orders = options.longs === String ? String(message.orders) : message.orders;
                        else
                            object.orders = options.longs === String ? $util.Long.prototype.toString.call(message.orders) : options.longs === Number ? new $util.LongBits(message.orders.low >>> 0, message.orders.high >>> 0).toNumber() : message.orders;
                    if (message.reviews != null && message.hasOwnProperty("reviews"))
                        if (typeof message.reviews === "number")
                            object.reviews = options.longs === String ? String(message.reviews) : message.reviews;
                        else
                            object.reviews = options.longs === String ? $util.Long.prototype.toString.call(message.reviews) : options.longs === Number ? new $util.LongBits(message.reviews.low >>> 0, message.reviews.high >>> 0).toNumber() : message.reviews;
                    if (message.reviewsWithComments != null && message.hasOwnProperty("reviewsWithComments"))
                        if (typeof message.reviewsWithComments === "number")
                            object.reviewsWithComments = options.longs === String ? String(message.reviewsWithComments) : message.reviewsWithComments;
                        else
                            object.reviewsWithComments = options.longs === String ? $util.Long.prototype.toString.call(message.reviewsWithComments) : options.longs === Number ? new $util.LongBits(message.reviewsWithComments.low >>> 0, message.reviewsWithComments.high >>> 0).toNumber() : message.reviewsWithComments;
                    if (message.incompleteOrders != null && message.hasOwnProperty("incompleteOrders"))
                        if (typeof message.incompleteOrders === "number")
                            object.incompleteOrders = options.longs === String ? String(message.incompleteOrders) : message.incompleteOrders;
                        else
                            object.incompleteOrders = options.longs === String ? $util.Long.prototype.toString.call(message.incompleteOrders) : options.longs === Number ? new $util.LongBits(message.incompleteOrders.low >>> 0, message.incompleteOrders.high >>> 0).toNumber() : message.incompleteOrders;
                    if (message.onlinePickupOrders != null && message.hasOwnProperty("onlinePickupOrders"))
                        if (typeof message.onlinePickupOrders === "number")
                            object.onlinePickupOrders = options.longs === String ? String(message.onlinePickupOrders) : message.onlinePickupOrders;
                        else
                            object.onlinePickupOrders = options.longs === String ? $util.Long.prototype.toString.call(message.onlinePickupOrders) : options.longs === Number ? new $util.LongBits(message.onlinePickupOrders.low >>> 0, message.onlinePickupOrders.high >>> 0).toNumber() : message.onlinePickupOrders;
                    if (message.deliveryOrders != null && message.hasOwnProperty("deliveryOrders"))
                        if (typeof message.deliveryOrders === "number")
                            object.deliveryOrders = options.longs === String ? String(message.deliveryOrders) : message.deliveryOrders;
                        else
                            object.deliveryOrders = options.longs === String ? $util.Long.prototype.toString.call(message.deliveryOrders) : options.longs === Number ? new $util.LongBits(message.deliveryOrders.low >>> 0, message.deliveryOrders.high >>> 0).toNumber() : message.deliveryOrders;
                    if (message.disputedOrders != null && message.hasOwnProperty("disputedOrders"))
                        if (typeof message.disputedOrders === "number")
                            object.disputedOrders = options.longs === String ? String(message.disputedOrders) : message.disputedOrders;
                        else
                            object.disputedOrders = options.longs === String ? $util.Long.prototype.toString.call(message.disputedOrders) : options.longs === Number ? new $util.LongBits(message.disputedOrders.low >>> 0, message.disputedOrders.high >>> 0).toNumber() : message.disputedOrders;
                    if (message.disputedOrdersVolume != null && message.hasOwnProperty("disputedOrdersVolume"))
                        object.disputedOrdersVolume = $root.waiternow.common.MoneyProto.toObject(message.disputedOrdersVolume, options);
                    if (message.onsitePickupOrders != null && message.hasOwnProperty("onsitePickupOrders"))
                        if (typeof message.onsitePickupOrders === "number")
                            object.onsitePickupOrders = options.longs === String ? String(message.onsitePickupOrders) : message.onsitePickupOrders;
                        else
                            object.onsitePickupOrders = options.longs === String ? $util.Long.prototype.toString.call(message.onsitePickupOrders) : options.longs === Number ? new $util.LongBits(message.onsitePickupOrders.low >>> 0, message.onsitePickupOrders.high >>> 0).toNumber() : message.onsitePickupOrders;
                    if (message.onsiteOrders != null && message.hasOwnProperty("onsiteOrders"))
                        if (typeof message.onsiteOrders === "number")
                            object.onsiteOrders = options.longs === String ? String(message.onsiteOrders) : message.onsiteOrders;
                        else
                            object.onsiteOrders = options.longs === String ? $util.Long.prototype.toString.call(message.onsiteOrders) : options.longs === Number ? new $util.LongBits(message.onsiteOrders.low >>> 0, message.onsiteOrders.high >>> 0).toNumber() : message.onsiteOrders;
                    return object;
                };

                /**
                 * Converts this MetricValuesProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.MetricProto.MetricValuesProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                MetricValuesProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for MetricValuesProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.MetricProto.MetricValuesProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                MetricValuesProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.MetricProto.MetricValuesProto";
                };

                return MetricValuesProto;
            })();

            return MetricProto;
        })();

        common.MetricsProto = (function() {

            /**
             * Properties of a MetricsProto.
             * @memberof waiternow.common
             * @interface IMetricsProto
             * @property {Array.<waiternow.common.IMetricProto>|null} [metrics] MetricsProto metrics
             * @property {string|null} [continuationToken] MetricsProto continuationToken
             */

            /**
             * Constructs a new MetricsProto.
             * @memberof waiternow.common
             * @classdesc Represents a MetricsProto.
             * @implements IMetricsProto
             * @constructor
             * @param {waiternow.common.IMetricsProto=} [properties] Properties to set
             */
            function MetricsProto(properties) {
                this.metrics = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * MetricsProto metrics.
             * @member {Array.<waiternow.common.IMetricProto>} metrics
             * @memberof waiternow.common.MetricsProto
             * @instance
             */
            MetricsProto.prototype.metrics = $util.emptyArray;

            /**
             * MetricsProto continuationToken.
             * @member {string} continuationToken
             * @memberof waiternow.common.MetricsProto
             * @instance
             */
            MetricsProto.prototype.continuationToken = "";

            /**
             * Creates a new MetricsProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.MetricsProto
             * @static
             * @param {waiternow.common.IMetricsProto=} [properties] Properties to set
             * @returns {waiternow.common.MetricsProto} MetricsProto instance
             */
            MetricsProto.create = function create(properties) {
                return new MetricsProto(properties);
            };

            /**
             * Encodes the specified MetricsProto message. Does not implicitly {@link waiternow.common.MetricsProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.MetricsProto
             * @static
             * @param {waiternow.common.IMetricsProto} message MetricsProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MetricsProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.metrics != null && message.metrics.length)
                    for (var i = 0; i < message.metrics.length; ++i)
                        $root.waiternow.common.MetricProto.encode(message.metrics[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.continuationToken);
                return writer;
            };

            /**
             * Encodes the specified MetricsProto message, length delimited. Does not implicitly {@link waiternow.common.MetricsProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.MetricsProto
             * @static
             * @param {waiternow.common.IMetricsProto} message MetricsProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MetricsProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a MetricsProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.MetricsProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.MetricsProto} MetricsProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MetricsProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.MetricsProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            if (!(message.metrics && message.metrics.length))
                                message.metrics = [];
                            message.metrics.push($root.waiternow.common.MetricProto.decode(reader, reader.uint32()));
                            break;
                        }
                    case 2: {
                            message.continuationToken = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a MetricsProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.MetricsProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.MetricsProto} MetricsProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MetricsProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a MetricsProto message.
             * @function verify
             * @memberof waiternow.common.MetricsProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            MetricsProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.metrics != null && message.hasOwnProperty("metrics")) {
                    if (!Array.isArray(message.metrics))
                        return "metrics: array expected";
                    for (var i = 0; i < message.metrics.length; ++i) {
                        var error = $root.waiternow.common.MetricProto.verify(message.metrics[i]);
                        if (error)
                            return "metrics." + error;
                    }
                }
                if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                    if (!$util.isString(message.continuationToken))
                        return "continuationToken: string expected";
                return null;
            };

            /**
             * Creates a MetricsProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.MetricsProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.MetricsProto} MetricsProto
             */
            MetricsProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.MetricsProto)
                    return object;
                var message = new $root.waiternow.common.MetricsProto();
                if (object.metrics) {
                    if (!Array.isArray(object.metrics))
                        throw TypeError(".waiternow.common.MetricsProto.metrics: array expected");
                    message.metrics = [];
                    for (var i = 0; i < object.metrics.length; ++i) {
                        if (typeof object.metrics[i] !== "object")
                            throw TypeError(".waiternow.common.MetricsProto.metrics: object expected");
                        message.metrics[i] = $root.waiternow.common.MetricProto.fromObject(object.metrics[i]);
                    }
                }
                if (object.continuationToken != null)
                    message.continuationToken = String(object.continuationToken);
                return message;
            };

            /**
             * Creates a plain object from a MetricsProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.MetricsProto
             * @static
             * @param {waiternow.common.MetricsProto} message MetricsProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            MetricsProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.metrics = [];
                if (options.defaults)
                    object.continuationToken = "";
                if (message.metrics && message.metrics.length) {
                    object.metrics = [];
                    for (var j = 0; j < message.metrics.length; ++j)
                        object.metrics[j] = $root.waiternow.common.MetricProto.toObject(message.metrics[j], options);
                }
                if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                    object.continuationToken = message.continuationToken;
                return object;
            };

            /**
             * Converts this MetricsProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.MetricsProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            MetricsProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for MetricsProto
             * @function getTypeUrl
             * @memberof waiternow.common.MetricsProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            MetricsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.MetricsProto";
            };

            return MetricsProto;
        })();

        common.LocationMetricProto = (function() {

            /**
             * Properties of a LocationMetricProto.
             * @memberof waiternow.common
             * @interface ILocationMetricProto
             * @property {string|null} [id] LocationMetricProto id
             * @property {waiternow.common.IDateRangeProto|null} [period] LocationMetricProto period
             * @property {waiternow.common.PeriodType|null} [periodType] LocationMetricProto periodType
             * @property {google.protobuf.ITimestamp|null} [creationTime] LocationMetricProto creationTime
             * @property {google.protobuf.ITimestamp|null} [lastUpdateTime] LocationMetricProto lastUpdateTime
             * @property {string|null} [locationId] LocationMetricProto locationId
             * @property {number|null} [checkIns] LocationMetricProto checkIns
             * @property {number|null} [orders] LocationMetricProto orders
             * @property {number|null} [paidOrders] LocationMetricProto paidOrders
             * @property {number|null} [refundedOrders] LocationMetricProto refundedOrders
             * @property {waiternow.common.IMoneyProto|null} [orderPaymentsVolume] LocationMetricProto orderPaymentsVolume
             * @property {waiternow.common.IMoneyProto|null} [waiternowOrderPaymentsRevenue] LocationMetricProto waiternowOrderPaymentsRevenue
             * @property {waiternow.common.IMoneyProto|null} [tips] LocationMetricProto tips
             * @property {waiternow.common.IMoneyProto|null} [refundedOrdersVolume] LocationMetricProto refundedOrdersVolume
             * @property {number|null} [thumbsUp] LocationMetricProto thumbsUp
             * @property {number|null} [thumbsDown] LocationMetricProto thumbsDown
             * @property {number|null} [reviewsWithComments] LocationMetricProto reviewsWithComments
             * @property {number|null} [incompleteOrders] LocationMetricProto incompleteOrders
             * @property {number|null} [onlinePickupOrders] LocationMetricProto onlinePickupOrders
             * @property {number|null} [deliveryOrders] LocationMetricProto deliveryOrders
             * @property {number|null} [oneStarRatings] LocationMetricProto oneStarRatings
             * @property {number|null} [twoStarsRatings] LocationMetricProto twoStarsRatings
             * @property {number|null} [threeStarsRatings] LocationMetricProto threeStarsRatings
             * @property {number|null} [fourStarsRatings] LocationMetricProto fourStarsRatings
             * @property {number|null} [fiveStarsRatings] LocationMetricProto fiveStarsRatings
             * @property {number|null} [disputedOrders] LocationMetricProto disputedOrders
             * @property {waiternow.common.IMoneyProto|null} [disputedOrdersVolume] LocationMetricProto disputedOrdersVolume
             * @property {number|null} [onsitePickupOrders] LocationMetricProto onsitePickupOrders
             * @property {number|null} [onsiteOrders] LocationMetricProto onsiteOrders
             * @property {waiternow.common.LocationMetricProto.IRedundantDataProto|null} [redundantData] LocationMetricProto redundantData
             */

            /**
             * Constructs a new LocationMetricProto.
             * @memberof waiternow.common
             * @classdesc Represents a LocationMetricProto.
             * @implements ILocationMetricProto
             * @constructor
             * @param {waiternow.common.ILocationMetricProto=} [properties] Properties to set
             */
            function LocationMetricProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * LocationMetricProto id.
             * @member {string} id
             * @memberof waiternow.common.LocationMetricProto
             * @instance
             */
            LocationMetricProto.prototype.id = "";

            /**
             * LocationMetricProto period.
             * @member {waiternow.common.IDateRangeProto|null|undefined} period
             * @memberof waiternow.common.LocationMetricProto
             * @instance
             */
            LocationMetricProto.prototype.period = null;

            /**
             * LocationMetricProto periodType.
             * @member {waiternow.common.PeriodType} periodType
             * @memberof waiternow.common.LocationMetricProto
             * @instance
             */
            LocationMetricProto.prototype.periodType = 0;

            /**
             * LocationMetricProto creationTime.
             * @member {google.protobuf.ITimestamp|null|undefined} creationTime
             * @memberof waiternow.common.LocationMetricProto
             * @instance
             */
            LocationMetricProto.prototype.creationTime = null;

            /**
             * LocationMetricProto lastUpdateTime.
             * @member {google.protobuf.ITimestamp|null|undefined} lastUpdateTime
             * @memberof waiternow.common.LocationMetricProto
             * @instance
             */
            LocationMetricProto.prototype.lastUpdateTime = null;

            /**
             * LocationMetricProto locationId.
             * @member {string} locationId
             * @memberof waiternow.common.LocationMetricProto
             * @instance
             */
            LocationMetricProto.prototype.locationId = "";

            /**
             * LocationMetricProto checkIns.
             * @member {number} checkIns
             * @memberof waiternow.common.LocationMetricProto
             * @instance
             */
            LocationMetricProto.prototype.checkIns = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * LocationMetricProto orders.
             * @member {number} orders
             * @memberof waiternow.common.LocationMetricProto
             * @instance
             */
            LocationMetricProto.prototype.orders = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * LocationMetricProto paidOrders.
             * @member {number} paidOrders
             * @memberof waiternow.common.LocationMetricProto
             * @instance
             */
            LocationMetricProto.prototype.paidOrders = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * LocationMetricProto refundedOrders.
             * @member {number} refundedOrders
             * @memberof waiternow.common.LocationMetricProto
             * @instance
             */
            LocationMetricProto.prototype.refundedOrders = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * LocationMetricProto orderPaymentsVolume.
             * @member {waiternow.common.IMoneyProto|null|undefined} orderPaymentsVolume
             * @memberof waiternow.common.LocationMetricProto
             * @instance
             */
            LocationMetricProto.prototype.orderPaymentsVolume = null;

            /**
             * LocationMetricProto waiternowOrderPaymentsRevenue.
             * @member {waiternow.common.IMoneyProto|null|undefined} waiternowOrderPaymentsRevenue
             * @memberof waiternow.common.LocationMetricProto
             * @instance
             */
            LocationMetricProto.prototype.waiternowOrderPaymentsRevenue = null;

            /**
             * LocationMetricProto tips.
             * @member {waiternow.common.IMoneyProto|null|undefined} tips
             * @memberof waiternow.common.LocationMetricProto
             * @instance
             */
            LocationMetricProto.prototype.tips = null;

            /**
             * LocationMetricProto refundedOrdersVolume.
             * @member {waiternow.common.IMoneyProto|null|undefined} refundedOrdersVolume
             * @memberof waiternow.common.LocationMetricProto
             * @instance
             */
            LocationMetricProto.prototype.refundedOrdersVolume = null;

            /**
             * LocationMetricProto thumbsUp.
             * @member {number} thumbsUp
             * @memberof waiternow.common.LocationMetricProto
             * @instance
             */
            LocationMetricProto.prototype.thumbsUp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * LocationMetricProto thumbsDown.
             * @member {number} thumbsDown
             * @memberof waiternow.common.LocationMetricProto
             * @instance
             */
            LocationMetricProto.prototype.thumbsDown = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * LocationMetricProto reviewsWithComments.
             * @member {number} reviewsWithComments
             * @memberof waiternow.common.LocationMetricProto
             * @instance
             */
            LocationMetricProto.prototype.reviewsWithComments = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * LocationMetricProto incompleteOrders.
             * @member {number} incompleteOrders
             * @memberof waiternow.common.LocationMetricProto
             * @instance
             */
            LocationMetricProto.prototype.incompleteOrders = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * LocationMetricProto onlinePickupOrders.
             * @member {number} onlinePickupOrders
             * @memberof waiternow.common.LocationMetricProto
             * @instance
             */
            LocationMetricProto.prototype.onlinePickupOrders = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * LocationMetricProto deliveryOrders.
             * @member {number} deliveryOrders
             * @memberof waiternow.common.LocationMetricProto
             * @instance
             */
            LocationMetricProto.prototype.deliveryOrders = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * LocationMetricProto oneStarRatings.
             * @member {number} oneStarRatings
             * @memberof waiternow.common.LocationMetricProto
             * @instance
             */
            LocationMetricProto.prototype.oneStarRatings = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * LocationMetricProto twoStarsRatings.
             * @member {number} twoStarsRatings
             * @memberof waiternow.common.LocationMetricProto
             * @instance
             */
            LocationMetricProto.prototype.twoStarsRatings = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * LocationMetricProto threeStarsRatings.
             * @member {number} threeStarsRatings
             * @memberof waiternow.common.LocationMetricProto
             * @instance
             */
            LocationMetricProto.prototype.threeStarsRatings = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * LocationMetricProto fourStarsRatings.
             * @member {number} fourStarsRatings
             * @memberof waiternow.common.LocationMetricProto
             * @instance
             */
            LocationMetricProto.prototype.fourStarsRatings = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * LocationMetricProto fiveStarsRatings.
             * @member {number} fiveStarsRatings
             * @memberof waiternow.common.LocationMetricProto
             * @instance
             */
            LocationMetricProto.prototype.fiveStarsRatings = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * LocationMetricProto disputedOrders.
             * @member {number} disputedOrders
             * @memberof waiternow.common.LocationMetricProto
             * @instance
             */
            LocationMetricProto.prototype.disputedOrders = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * LocationMetricProto disputedOrdersVolume.
             * @member {waiternow.common.IMoneyProto|null|undefined} disputedOrdersVolume
             * @memberof waiternow.common.LocationMetricProto
             * @instance
             */
            LocationMetricProto.prototype.disputedOrdersVolume = null;

            /**
             * LocationMetricProto onsitePickupOrders.
             * @member {number} onsitePickupOrders
             * @memberof waiternow.common.LocationMetricProto
             * @instance
             */
            LocationMetricProto.prototype.onsitePickupOrders = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * LocationMetricProto onsiteOrders.
             * @member {number} onsiteOrders
             * @memberof waiternow.common.LocationMetricProto
             * @instance
             */
            LocationMetricProto.prototype.onsiteOrders = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * LocationMetricProto redundantData.
             * @member {waiternow.common.LocationMetricProto.IRedundantDataProto|null|undefined} redundantData
             * @memberof waiternow.common.LocationMetricProto
             * @instance
             */
            LocationMetricProto.prototype.redundantData = null;

            /**
             * Creates a new LocationMetricProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.LocationMetricProto
             * @static
             * @param {waiternow.common.ILocationMetricProto=} [properties] Properties to set
             * @returns {waiternow.common.LocationMetricProto} LocationMetricProto instance
             */
            LocationMetricProto.create = function create(properties) {
                return new LocationMetricProto(properties);
            };

            /**
             * Encodes the specified LocationMetricProto message. Does not implicitly {@link waiternow.common.LocationMetricProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.LocationMetricProto
             * @static
             * @param {waiternow.common.ILocationMetricProto} message LocationMetricProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            LocationMetricProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                if (message.period != null && Object.hasOwnProperty.call(message, "period"))
                    $root.waiternow.common.DateRangeProto.encode(message.period, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.periodType != null && Object.hasOwnProperty.call(message, "periodType"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.periodType);
                if (message.creationTime != null && Object.hasOwnProperty.call(message, "creationTime"))
                    $root.google.protobuf.Timestamp.encode(message.creationTime, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                    $root.google.protobuf.Timestamp.encode(message.lastUpdateTime, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.locationId);
                if (message.checkIns != null && Object.hasOwnProperty.call(message, "checkIns"))
                    writer.uint32(/* id 7, wireType 0 =*/56).int64(message.checkIns);
                if (message.orders != null && Object.hasOwnProperty.call(message, "orders"))
                    writer.uint32(/* id 8, wireType 0 =*/64).int64(message.orders);
                if (message.paidOrders != null && Object.hasOwnProperty.call(message, "paidOrders"))
                    writer.uint32(/* id 9, wireType 0 =*/72).int64(message.paidOrders);
                if (message.refundedOrders != null && Object.hasOwnProperty.call(message, "refundedOrders"))
                    writer.uint32(/* id 10, wireType 0 =*/80).int64(message.refundedOrders);
                if (message.orderPaymentsVolume != null && Object.hasOwnProperty.call(message, "orderPaymentsVolume"))
                    $root.waiternow.common.MoneyProto.encode(message.orderPaymentsVolume, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                if (message.waiternowOrderPaymentsRevenue != null && Object.hasOwnProperty.call(message, "waiternowOrderPaymentsRevenue"))
                    $root.waiternow.common.MoneyProto.encode(message.waiternowOrderPaymentsRevenue, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                if (message.tips != null && Object.hasOwnProperty.call(message, "tips"))
                    $root.waiternow.common.MoneyProto.encode(message.tips, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
                if (message.refundedOrdersVolume != null && Object.hasOwnProperty.call(message, "refundedOrdersVolume"))
                    $root.waiternow.common.MoneyProto.encode(message.refundedOrdersVolume, writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
                if (message.thumbsUp != null && Object.hasOwnProperty.call(message, "thumbsUp"))
                    writer.uint32(/* id 15, wireType 0 =*/120).int64(message.thumbsUp);
                if (message.thumbsDown != null && Object.hasOwnProperty.call(message, "thumbsDown"))
                    writer.uint32(/* id 16, wireType 0 =*/128).int64(message.thumbsDown);
                if (message.reviewsWithComments != null && Object.hasOwnProperty.call(message, "reviewsWithComments"))
                    writer.uint32(/* id 17, wireType 0 =*/136).int64(message.reviewsWithComments);
                if (message.incompleteOrders != null && Object.hasOwnProperty.call(message, "incompleteOrders"))
                    writer.uint32(/* id 18, wireType 0 =*/144).int64(message.incompleteOrders);
                if (message.onlinePickupOrders != null && Object.hasOwnProperty.call(message, "onlinePickupOrders"))
                    writer.uint32(/* id 19, wireType 0 =*/152).int64(message.onlinePickupOrders);
                if (message.deliveryOrders != null && Object.hasOwnProperty.call(message, "deliveryOrders"))
                    writer.uint32(/* id 20, wireType 0 =*/160).int64(message.deliveryOrders);
                if (message.oneStarRatings != null && Object.hasOwnProperty.call(message, "oneStarRatings"))
                    writer.uint32(/* id 21, wireType 0 =*/168).int64(message.oneStarRatings);
                if (message.twoStarsRatings != null && Object.hasOwnProperty.call(message, "twoStarsRatings"))
                    writer.uint32(/* id 22, wireType 0 =*/176).int64(message.twoStarsRatings);
                if (message.threeStarsRatings != null && Object.hasOwnProperty.call(message, "threeStarsRatings"))
                    writer.uint32(/* id 23, wireType 0 =*/184).int64(message.threeStarsRatings);
                if (message.fourStarsRatings != null && Object.hasOwnProperty.call(message, "fourStarsRatings"))
                    writer.uint32(/* id 24, wireType 0 =*/192).int64(message.fourStarsRatings);
                if (message.fiveStarsRatings != null && Object.hasOwnProperty.call(message, "fiveStarsRatings"))
                    writer.uint32(/* id 25, wireType 0 =*/200).int64(message.fiveStarsRatings);
                if (message.redundantData != null && Object.hasOwnProperty.call(message, "redundantData"))
                    $root.waiternow.common.LocationMetricProto.RedundantDataProto.encode(message.redundantData, writer.uint32(/* id 26, wireType 2 =*/210).fork()).ldelim();
                if (message.disputedOrders != null && Object.hasOwnProperty.call(message, "disputedOrders"))
                    writer.uint32(/* id 27, wireType 0 =*/216).int64(message.disputedOrders);
                if (message.disputedOrdersVolume != null && Object.hasOwnProperty.call(message, "disputedOrdersVolume"))
                    $root.waiternow.common.MoneyProto.encode(message.disputedOrdersVolume, writer.uint32(/* id 28, wireType 2 =*/226).fork()).ldelim();
                if (message.onsitePickupOrders != null && Object.hasOwnProperty.call(message, "onsitePickupOrders"))
                    writer.uint32(/* id 29, wireType 0 =*/232).int64(message.onsitePickupOrders);
                if (message.onsiteOrders != null && Object.hasOwnProperty.call(message, "onsiteOrders"))
                    writer.uint32(/* id 30, wireType 0 =*/240).int64(message.onsiteOrders);
                return writer;
            };

            /**
             * Encodes the specified LocationMetricProto message, length delimited. Does not implicitly {@link waiternow.common.LocationMetricProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.LocationMetricProto
             * @static
             * @param {waiternow.common.ILocationMetricProto} message LocationMetricProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            LocationMetricProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a LocationMetricProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.LocationMetricProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.LocationMetricProto} LocationMetricProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            LocationMetricProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.LocationMetricProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.id = reader.string();
                            break;
                        }
                    case 2: {
                            message.period = $root.waiternow.common.DateRangeProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 3: {
                            message.periodType = reader.int32();
                            break;
                        }
                    case 4: {
                            message.creationTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 5: {
                            message.lastUpdateTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 6: {
                            message.locationId = reader.string();
                            break;
                        }
                    case 7: {
                            message.checkIns = reader.int64();
                            break;
                        }
                    case 8: {
                            message.orders = reader.int64();
                            break;
                        }
                    case 9: {
                            message.paidOrders = reader.int64();
                            break;
                        }
                    case 10: {
                            message.refundedOrders = reader.int64();
                            break;
                        }
                    case 11: {
                            message.orderPaymentsVolume = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 12: {
                            message.waiternowOrderPaymentsRevenue = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 13: {
                            message.tips = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 14: {
                            message.refundedOrdersVolume = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 15: {
                            message.thumbsUp = reader.int64();
                            break;
                        }
                    case 16: {
                            message.thumbsDown = reader.int64();
                            break;
                        }
                    case 17: {
                            message.reviewsWithComments = reader.int64();
                            break;
                        }
                    case 18: {
                            message.incompleteOrders = reader.int64();
                            break;
                        }
                    case 19: {
                            message.onlinePickupOrders = reader.int64();
                            break;
                        }
                    case 20: {
                            message.deliveryOrders = reader.int64();
                            break;
                        }
                    case 21: {
                            message.oneStarRatings = reader.int64();
                            break;
                        }
                    case 22: {
                            message.twoStarsRatings = reader.int64();
                            break;
                        }
                    case 23: {
                            message.threeStarsRatings = reader.int64();
                            break;
                        }
                    case 24: {
                            message.fourStarsRatings = reader.int64();
                            break;
                        }
                    case 25: {
                            message.fiveStarsRatings = reader.int64();
                            break;
                        }
                    case 27: {
                            message.disputedOrders = reader.int64();
                            break;
                        }
                    case 28: {
                            message.disputedOrdersVolume = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 29: {
                            message.onsitePickupOrders = reader.int64();
                            break;
                        }
                    case 30: {
                            message.onsiteOrders = reader.int64();
                            break;
                        }
                    case 26: {
                            message.redundantData = $root.waiternow.common.LocationMetricProto.RedundantDataProto.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a LocationMetricProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.LocationMetricProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.LocationMetricProto} LocationMetricProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            LocationMetricProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a LocationMetricProto message.
             * @function verify
             * @memberof waiternow.common.LocationMetricProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            LocationMetricProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.id != null && message.hasOwnProperty("id"))
                    if (!$util.isString(message.id))
                        return "id: string expected";
                if (message.period != null && message.hasOwnProperty("period")) {
                    var error = $root.waiternow.common.DateRangeProto.verify(message.period);
                    if (error)
                        return "period." + error;
                }
                if (message.periodType != null && message.hasOwnProperty("periodType"))
                    switch (message.periodType) {
                    default:
                        return "periodType: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                        break;
                    }
                if (message.creationTime != null && message.hasOwnProperty("creationTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.creationTime);
                    if (error)
                        return "creationTime." + error;
                }
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.lastUpdateTime);
                    if (error)
                        return "lastUpdateTime." + error;
                }
                if (message.locationId != null && message.hasOwnProperty("locationId"))
                    if (!$util.isString(message.locationId))
                        return "locationId: string expected";
                if (message.checkIns != null && message.hasOwnProperty("checkIns"))
                    if (!$util.isInteger(message.checkIns) && !(message.checkIns && $util.isInteger(message.checkIns.low) && $util.isInteger(message.checkIns.high)))
                        return "checkIns: integer|Long expected";
                if (message.orders != null && message.hasOwnProperty("orders"))
                    if (!$util.isInteger(message.orders) && !(message.orders && $util.isInteger(message.orders.low) && $util.isInteger(message.orders.high)))
                        return "orders: integer|Long expected";
                if (message.paidOrders != null && message.hasOwnProperty("paidOrders"))
                    if (!$util.isInteger(message.paidOrders) && !(message.paidOrders && $util.isInteger(message.paidOrders.low) && $util.isInteger(message.paidOrders.high)))
                        return "paidOrders: integer|Long expected";
                if (message.refundedOrders != null && message.hasOwnProperty("refundedOrders"))
                    if (!$util.isInteger(message.refundedOrders) && !(message.refundedOrders && $util.isInteger(message.refundedOrders.low) && $util.isInteger(message.refundedOrders.high)))
                        return "refundedOrders: integer|Long expected";
                if (message.orderPaymentsVolume != null && message.hasOwnProperty("orderPaymentsVolume")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.orderPaymentsVolume);
                    if (error)
                        return "orderPaymentsVolume." + error;
                }
                if (message.waiternowOrderPaymentsRevenue != null && message.hasOwnProperty("waiternowOrderPaymentsRevenue")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.waiternowOrderPaymentsRevenue);
                    if (error)
                        return "waiternowOrderPaymentsRevenue." + error;
                }
                if (message.tips != null && message.hasOwnProperty("tips")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.tips);
                    if (error)
                        return "tips." + error;
                }
                if (message.refundedOrdersVolume != null && message.hasOwnProperty("refundedOrdersVolume")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.refundedOrdersVolume);
                    if (error)
                        return "refundedOrdersVolume." + error;
                }
                if (message.thumbsUp != null && message.hasOwnProperty("thumbsUp"))
                    if (!$util.isInteger(message.thumbsUp) && !(message.thumbsUp && $util.isInteger(message.thumbsUp.low) && $util.isInteger(message.thumbsUp.high)))
                        return "thumbsUp: integer|Long expected";
                if (message.thumbsDown != null && message.hasOwnProperty("thumbsDown"))
                    if (!$util.isInteger(message.thumbsDown) && !(message.thumbsDown && $util.isInteger(message.thumbsDown.low) && $util.isInteger(message.thumbsDown.high)))
                        return "thumbsDown: integer|Long expected";
                if (message.reviewsWithComments != null && message.hasOwnProperty("reviewsWithComments"))
                    if (!$util.isInteger(message.reviewsWithComments) && !(message.reviewsWithComments && $util.isInteger(message.reviewsWithComments.low) && $util.isInteger(message.reviewsWithComments.high)))
                        return "reviewsWithComments: integer|Long expected";
                if (message.incompleteOrders != null && message.hasOwnProperty("incompleteOrders"))
                    if (!$util.isInteger(message.incompleteOrders) && !(message.incompleteOrders && $util.isInteger(message.incompleteOrders.low) && $util.isInteger(message.incompleteOrders.high)))
                        return "incompleteOrders: integer|Long expected";
                if (message.onlinePickupOrders != null && message.hasOwnProperty("onlinePickupOrders"))
                    if (!$util.isInteger(message.onlinePickupOrders) && !(message.onlinePickupOrders && $util.isInteger(message.onlinePickupOrders.low) && $util.isInteger(message.onlinePickupOrders.high)))
                        return "onlinePickupOrders: integer|Long expected";
                if (message.deliveryOrders != null && message.hasOwnProperty("deliveryOrders"))
                    if (!$util.isInteger(message.deliveryOrders) && !(message.deliveryOrders && $util.isInteger(message.deliveryOrders.low) && $util.isInteger(message.deliveryOrders.high)))
                        return "deliveryOrders: integer|Long expected";
                if (message.oneStarRatings != null && message.hasOwnProperty("oneStarRatings"))
                    if (!$util.isInteger(message.oneStarRatings) && !(message.oneStarRatings && $util.isInteger(message.oneStarRatings.low) && $util.isInteger(message.oneStarRatings.high)))
                        return "oneStarRatings: integer|Long expected";
                if (message.twoStarsRatings != null && message.hasOwnProperty("twoStarsRatings"))
                    if (!$util.isInteger(message.twoStarsRatings) && !(message.twoStarsRatings && $util.isInteger(message.twoStarsRatings.low) && $util.isInteger(message.twoStarsRatings.high)))
                        return "twoStarsRatings: integer|Long expected";
                if (message.threeStarsRatings != null && message.hasOwnProperty("threeStarsRatings"))
                    if (!$util.isInteger(message.threeStarsRatings) && !(message.threeStarsRatings && $util.isInteger(message.threeStarsRatings.low) && $util.isInteger(message.threeStarsRatings.high)))
                        return "threeStarsRatings: integer|Long expected";
                if (message.fourStarsRatings != null && message.hasOwnProperty("fourStarsRatings"))
                    if (!$util.isInteger(message.fourStarsRatings) && !(message.fourStarsRatings && $util.isInteger(message.fourStarsRatings.low) && $util.isInteger(message.fourStarsRatings.high)))
                        return "fourStarsRatings: integer|Long expected";
                if (message.fiveStarsRatings != null && message.hasOwnProperty("fiveStarsRatings"))
                    if (!$util.isInteger(message.fiveStarsRatings) && !(message.fiveStarsRatings && $util.isInteger(message.fiveStarsRatings.low) && $util.isInteger(message.fiveStarsRatings.high)))
                        return "fiveStarsRatings: integer|Long expected";
                if (message.disputedOrders != null && message.hasOwnProperty("disputedOrders"))
                    if (!$util.isInteger(message.disputedOrders) && !(message.disputedOrders && $util.isInteger(message.disputedOrders.low) && $util.isInteger(message.disputedOrders.high)))
                        return "disputedOrders: integer|Long expected";
                if (message.disputedOrdersVolume != null && message.hasOwnProperty("disputedOrdersVolume")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.disputedOrdersVolume);
                    if (error)
                        return "disputedOrdersVolume." + error;
                }
                if (message.onsitePickupOrders != null && message.hasOwnProperty("onsitePickupOrders"))
                    if (!$util.isInteger(message.onsitePickupOrders) && !(message.onsitePickupOrders && $util.isInteger(message.onsitePickupOrders.low) && $util.isInteger(message.onsitePickupOrders.high)))
                        return "onsitePickupOrders: integer|Long expected";
                if (message.onsiteOrders != null && message.hasOwnProperty("onsiteOrders"))
                    if (!$util.isInteger(message.onsiteOrders) && !(message.onsiteOrders && $util.isInteger(message.onsiteOrders.low) && $util.isInteger(message.onsiteOrders.high)))
                        return "onsiteOrders: integer|Long expected";
                if (message.redundantData != null && message.hasOwnProperty("redundantData")) {
                    var error = $root.waiternow.common.LocationMetricProto.RedundantDataProto.verify(message.redundantData);
                    if (error)
                        return "redundantData." + error;
                }
                return null;
            };

            /**
             * Creates a LocationMetricProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.LocationMetricProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.LocationMetricProto} LocationMetricProto
             */
            LocationMetricProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.LocationMetricProto)
                    return object;
                var message = new $root.waiternow.common.LocationMetricProto();
                if (object.id != null)
                    message.id = String(object.id);
                if (object.period != null) {
                    if (typeof object.period !== "object")
                        throw TypeError(".waiternow.common.LocationMetricProto.period: object expected");
                    message.period = $root.waiternow.common.DateRangeProto.fromObject(object.period);
                }
                switch (object.periodType) {
                default:
                    if (typeof object.periodType === "number") {
                        message.periodType = object.periodType;
                        break;
                    }
                    break;
                case "PERIOD_TYPE_UNSPECIFIED":
                case 0:
                    message.periodType = 0;
                    break;
                case "DAILY":
                case 1:
                    message.periodType = 1;
                    break;
                case "MONTHLY":
                case 2:
                    message.periodType = 2;
                    break;
                case "YEARLY":
                case 3:
                    message.periodType = 3;
                    break;
                }
                if (object.creationTime != null) {
                    if (typeof object.creationTime !== "object")
                        throw TypeError(".waiternow.common.LocationMetricProto.creationTime: object expected");
                    message.creationTime = $root.google.protobuf.Timestamp.fromObject(object.creationTime);
                }
                if (object.lastUpdateTime != null) {
                    if (typeof object.lastUpdateTime !== "object")
                        throw TypeError(".waiternow.common.LocationMetricProto.lastUpdateTime: object expected");
                    message.lastUpdateTime = $root.google.protobuf.Timestamp.fromObject(object.lastUpdateTime);
                }
                if (object.locationId != null)
                    message.locationId = String(object.locationId);
                if (object.checkIns != null)
                    if ($util.Long)
                        (message.checkIns = $util.Long.fromValue(object.checkIns)).unsigned = false;
                    else if (typeof object.checkIns === "string")
                        message.checkIns = parseInt(object.checkIns, 10);
                    else if (typeof object.checkIns === "number")
                        message.checkIns = object.checkIns;
                    else if (typeof object.checkIns === "object")
                        message.checkIns = new $util.LongBits(object.checkIns.low >>> 0, object.checkIns.high >>> 0).toNumber();
                if (object.orders != null)
                    if ($util.Long)
                        (message.orders = $util.Long.fromValue(object.orders)).unsigned = false;
                    else if (typeof object.orders === "string")
                        message.orders = parseInt(object.orders, 10);
                    else if (typeof object.orders === "number")
                        message.orders = object.orders;
                    else if (typeof object.orders === "object")
                        message.orders = new $util.LongBits(object.orders.low >>> 0, object.orders.high >>> 0).toNumber();
                if (object.paidOrders != null)
                    if ($util.Long)
                        (message.paidOrders = $util.Long.fromValue(object.paidOrders)).unsigned = false;
                    else if (typeof object.paidOrders === "string")
                        message.paidOrders = parseInt(object.paidOrders, 10);
                    else if (typeof object.paidOrders === "number")
                        message.paidOrders = object.paidOrders;
                    else if (typeof object.paidOrders === "object")
                        message.paidOrders = new $util.LongBits(object.paidOrders.low >>> 0, object.paidOrders.high >>> 0).toNumber();
                if (object.refundedOrders != null)
                    if ($util.Long)
                        (message.refundedOrders = $util.Long.fromValue(object.refundedOrders)).unsigned = false;
                    else if (typeof object.refundedOrders === "string")
                        message.refundedOrders = parseInt(object.refundedOrders, 10);
                    else if (typeof object.refundedOrders === "number")
                        message.refundedOrders = object.refundedOrders;
                    else if (typeof object.refundedOrders === "object")
                        message.refundedOrders = new $util.LongBits(object.refundedOrders.low >>> 0, object.refundedOrders.high >>> 0).toNumber();
                if (object.orderPaymentsVolume != null) {
                    if (typeof object.orderPaymentsVolume !== "object")
                        throw TypeError(".waiternow.common.LocationMetricProto.orderPaymentsVolume: object expected");
                    message.orderPaymentsVolume = $root.waiternow.common.MoneyProto.fromObject(object.orderPaymentsVolume);
                }
                if (object.waiternowOrderPaymentsRevenue != null) {
                    if (typeof object.waiternowOrderPaymentsRevenue !== "object")
                        throw TypeError(".waiternow.common.LocationMetricProto.waiternowOrderPaymentsRevenue: object expected");
                    message.waiternowOrderPaymentsRevenue = $root.waiternow.common.MoneyProto.fromObject(object.waiternowOrderPaymentsRevenue);
                }
                if (object.tips != null) {
                    if (typeof object.tips !== "object")
                        throw TypeError(".waiternow.common.LocationMetricProto.tips: object expected");
                    message.tips = $root.waiternow.common.MoneyProto.fromObject(object.tips);
                }
                if (object.refundedOrdersVolume != null) {
                    if (typeof object.refundedOrdersVolume !== "object")
                        throw TypeError(".waiternow.common.LocationMetricProto.refundedOrdersVolume: object expected");
                    message.refundedOrdersVolume = $root.waiternow.common.MoneyProto.fromObject(object.refundedOrdersVolume);
                }
                if (object.thumbsUp != null)
                    if ($util.Long)
                        (message.thumbsUp = $util.Long.fromValue(object.thumbsUp)).unsigned = false;
                    else if (typeof object.thumbsUp === "string")
                        message.thumbsUp = parseInt(object.thumbsUp, 10);
                    else if (typeof object.thumbsUp === "number")
                        message.thumbsUp = object.thumbsUp;
                    else if (typeof object.thumbsUp === "object")
                        message.thumbsUp = new $util.LongBits(object.thumbsUp.low >>> 0, object.thumbsUp.high >>> 0).toNumber();
                if (object.thumbsDown != null)
                    if ($util.Long)
                        (message.thumbsDown = $util.Long.fromValue(object.thumbsDown)).unsigned = false;
                    else if (typeof object.thumbsDown === "string")
                        message.thumbsDown = parseInt(object.thumbsDown, 10);
                    else if (typeof object.thumbsDown === "number")
                        message.thumbsDown = object.thumbsDown;
                    else if (typeof object.thumbsDown === "object")
                        message.thumbsDown = new $util.LongBits(object.thumbsDown.low >>> 0, object.thumbsDown.high >>> 0).toNumber();
                if (object.reviewsWithComments != null)
                    if ($util.Long)
                        (message.reviewsWithComments = $util.Long.fromValue(object.reviewsWithComments)).unsigned = false;
                    else if (typeof object.reviewsWithComments === "string")
                        message.reviewsWithComments = parseInt(object.reviewsWithComments, 10);
                    else if (typeof object.reviewsWithComments === "number")
                        message.reviewsWithComments = object.reviewsWithComments;
                    else if (typeof object.reviewsWithComments === "object")
                        message.reviewsWithComments = new $util.LongBits(object.reviewsWithComments.low >>> 0, object.reviewsWithComments.high >>> 0).toNumber();
                if (object.incompleteOrders != null)
                    if ($util.Long)
                        (message.incompleteOrders = $util.Long.fromValue(object.incompleteOrders)).unsigned = false;
                    else if (typeof object.incompleteOrders === "string")
                        message.incompleteOrders = parseInt(object.incompleteOrders, 10);
                    else if (typeof object.incompleteOrders === "number")
                        message.incompleteOrders = object.incompleteOrders;
                    else if (typeof object.incompleteOrders === "object")
                        message.incompleteOrders = new $util.LongBits(object.incompleteOrders.low >>> 0, object.incompleteOrders.high >>> 0).toNumber();
                if (object.onlinePickupOrders != null)
                    if ($util.Long)
                        (message.onlinePickupOrders = $util.Long.fromValue(object.onlinePickupOrders)).unsigned = false;
                    else if (typeof object.onlinePickupOrders === "string")
                        message.onlinePickupOrders = parseInt(object.onlinePickupOrders, 10);
                    else if (typeof object.onlinePickupOrders === "number")
                        message.onlinePickupOrders = object.onlinePickupOrders;
                    else if (typeof object.onlinePickupOrders === "object")
                        message.onlinePickupOrders = new $util.LongBits(object.onlinePickupOrders.low >>> 0, object.onlinePickupOrders.high >>> 0).toNumber();
                if (object.deliveryOrders != null)
                    if ($util.Long)
                        (message.deliveryOrders = $util.Long.fromValue(object.deliveryOrders)).unsigned = false;
                    else if (typeof object.deliveryOrders === "string")
                        message.deliveryOrders = parseInt(object.deliveryOrders, 10);
                    else if (typeof object.deliveryOrders === "number")
                        message.deliveryOrders = object.deliveryOrders;
                    else if (typeof object.deliveryOrders === "object")
                        message.deliveryOrders = new $util.LongBits(object.deliveryOrders.low >>> 0, object.deliveryOrders.high >>> 0).toNumber();
                if (object.oneStarRatings != null)
                    if ($util.Long)
                        (message.oneStarRatings = $util.Long.fromValue(object.oneStarRatings)).unsigned = false;
                    else if (typeof object.oneStarRatings === "string")
                        message.oneStarRatings = parseInt(object.oneStarRatings, 10);
                    else if (typeof object.oneStarRatings === "number")
                        message.oneStarRatings = object.oneStarRatings;
                    else if (typeof object.oneStarRatings === "object")
                        message.oneStarRatings = new $util.LongBits(object.oneStarRatings.low >>> 0, object.oneStarRatings.high >>> 0).toNumber();
                if (object.twoStarsRatings != null)
                    if ($util.Long)
                        (message.twoStarsRatings = $util.Long.fromValue(object.twoStarsRatings)).unsigned = false;
                    else if (typeof object.twoStarsRatings === "string")
                        message.twoStarsRatings = parseInt(object.twoStarsRatings, 10);
                    else if (typeof object.twoStarsRatings === "number")
                        message.twoStarsRatings = object.twoStarsRatings;
                    else if (typeof object.twoStarsRatings === "object")
                        message.twoStarsRatings = new $util.LongBits(object.twoStarsRatings.low >>> 0, object.twoStarsRatings.high >>> 0).toNumber();
                if (object.threeStarsRatings != null)
                    if ($util.Long)
                        (message.threeStarsRatings = $util.Long.fromValue(object.threeStarsRatings)).unsigned = false;
                    else if (typeof object.threeStarsRatings === "string")
                        message.threeStarsRatings = parseInt(object.threeStarsRatings, 10);
                    else if (typeof object.threeStarsRatings === "number")
                        message.threeStarsRatings = object.threeStarsRatings;
                    else if (typeof object.threeStarsRatings === "object")
                        message.threeStarsRatings = new $util.LongBits(object.threeStarsRatings.low >>> 0, object.threeStarsRatings.high >>> 0).toNumber();
                if (object.fourStarsRatings != null)
                    if ($util.Long)
                        (message.fourStarsRatings = $util.Long.fromValue(object.fourStarsRatings)).unsigned = false;
                    else if (typeof object.fourStarsRatings === "string")
                        message.fourStarsRatings = parseInt(object.fourStarsRatings, 10);
                    else if (typeof object.fourStarsRatings === "number")
                        message.fourStarsRatings = object.fourStarsRatings;
                    else if (typeof object.fourStarsRatings === "object")
                        message.fourStarsRatings = new $util.LongBits(object.fourStarsRatings.low >>> 0, object.fourStarsRatings.high >>> 0).toNumber();
                if (object.fiveStarsRatings != null)
                    if ($util.Long)
                        (message.fiveStarsRatings = $util.Long.fromValue(object.fiveStarsRatings)).unsigned = false;
                    else if (typeof object.fiveStarsRatings === "string")
                        message.fiveStarsRatings = parseInt(object.fiveStarsRatings, 10);
                    else if (typeof object.fiveStarsRatings === "number")
                        message.fiveStarsRatings = object.fiveStarsRatings;
                    else if (typeof object.fiveStarsRatings === "object")
                        message.fiveStarsRatings = new $util.LongBits(object.fiveStarsRatings.low >>> 0, object.fiveStarsRatings.high >>> 0).toNumber();
                if (object.disputedOrders != null)
                    if ($util.Long)
                        (message.disputedOrders = $util.Long.fromValue(object.disputedOrders)).unsigned = false;
                    else if (typeof object.disputedOrders === "string")
                        message.disputedOrders = parseInt(object.disputedOrders, 10);
                    else if (typeof object.disputedOrders === "number")
                        message.disputedOrders = object.disputedOrders;
                    else if (typeof object.disputedOrders === "object")
                        message.disputedOrders = new $util.LongBits(object.disputedOrders.low >>> 0, object.disputedOrders.high >>> 0).toNumber();
                if (object.disputedOrdersVolume != null) {
                    if (typeof object.disputedOrdersVolume !== "object")
                        throw TypeError(".waiternow.common.LocationMetricProto.disputedOrdersVolume: object expected");
                    message.disputedOrdersVolume = $root.waiternow.common.MoneyProto.fromObject(object.disputedOrdersVolume);
                }
                if (object.onsitePickupOrders != null)
                    if ($util.Long)
                        (message.onsitePickupOrders = $util.Long.fromValue(object.onsitePickupOrders)).unsigned = false;
                    else if (typeof object.onsitePickupOrders === "string")
                        message.onsitePickupOrders = parseInt(object.onsitePickupOrders, 10);
                    else if (typeof object.onsitePickupOrders === "number")
                        message.onsitePickupOrders = object.onsitePickupOrders;
                    else if (typeof object.onsitePickupOrders === "object")
                        message.onsitePickupOrders = new $util.LongBits(object.onsitePickupOrders.low >>> 0, object.onsitePickupOrders.high >>> 0).toNumber();
                if (object.onsiteOrders != null)
                    if ($util.Long)
                        (message.onsiteOrders = $util.Long.fromValue(object.onsiteOrders)).unsigned = false;
                    else if (typeof object.onsiteOrders === "string")
                        message.onsiteOrders = parseInt(object.onsiteOrders, 10);
                    else if (typeof object.onsiteOrders === "number")
                        message.onsiteOrders = object.onsiteOrders;
                    else if (typeof object.onsiteOrders === "object")
                        message.onsiteOrders = new $util.LongBits(object.onsiteOrders.low >>> 0, object.onsiteOrders.high >>> 0).toNumber();
                if (object.redundantData != null) {
                    if (typeof object.redundantData !== "object")
                        throw TypeError(".waiternow.common.LocationMetricProto.redundantData: object expected");
                    message.redundantData = $root.waiternow.common.LocationMetricProto.RedundantDataProto.fromObject(object.redundantData);
                }
                return message;
            };

            /**
             * Creates a plain object from a LocationMetricProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.LocationMetricProto
             * @static
             * @param {waiternow.common.LocationMetricProto} message LocationMetricProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            LocationMetricProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.id = "";
                    object.period = null;
                    object.periodType = options.enums === String ? "PERIOD_TYPE_UNSPECIFIED" : 0;
                    object.creationTime = null;
                    object.lastUpdateTime = null;
                    object.locationId = "";
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.checkIns = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.checkIns = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.orders = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.orders = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.paidOrders = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.paidOrders = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.refundedOrders = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.refundedOrders = options.longs === String ? "0" : 0;
                    object.orderPaymentsVolume = null;
                    object.waiternowOrderPaymentsRevenue = null;
                    object.tips = null;
                    object.refundedOrdersVolume = null;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.thumbsUp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.thumbsUp = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.thumbsDown = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.thumbsDown = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.reviewsWithComments = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.reviewsWithComments = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.incompleteOrders = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.incompleteOrders = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.onlinePickupOrders = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.onlinePickupOrders = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.deliveryOrders = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.deliveryOrders = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.oneStarRatings = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.oneStarRatings = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.twoStarsRatings = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.twoStarsRatings = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.threeStarsRatings = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.threeStarsRatings = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.fourStarsRatings = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.fourStarsRatings = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.fiveStarsRatings = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.fiveStarsRatings = options.longs === String ? "0" : 0;
                    object.redundantData = null;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.disputedOrders = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.disputedOrders = options.longs === String ? "0" : 0;
                    object.disputedOrdersVolume = null;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.onsitePickupOrders = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.onsitePickupOrders = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.onsiteOrders = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.onsiteOrders = options.longs === String ? "0" : 0;
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                if (message.period != null && message.hasOwnProperty("period"))
                    object.period = $root.waiternow.common.DateRangeProto.toObject(message.period, options);
                if (message.periodType != null && message.hasOwnProperty("periodType"))
                    object.periodType = options.enums === String ? $root.waiternow.common.PeriodType[message.periodType] === undefined ? message.periodType : $root.waiternow.common.PeriodType[message.periodType] : message.periodType;
                if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                    object.creationTime = $root.google.protobuf.Timestamp.toObject(message.creationTime, options);
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                    object.lastUpdateTime = $root.google.protobuf.Timestamp.toObject(message.lastUpdateTime, options);
                if (message.locationId != null && message.hasOwnProperty("locationId"))
                    object.locationId = message.locationId;
                if (message.checkIns != null && message.hasOwnProperty("checkIns"))
                    if (typeof message.checkIns === "number")
                        object.checkIns = options.longs === String ? String(message.checkIns) : message.checkIns;
                    else
                        object.checkIns = options.longs === String ? $util.Long.prototype.toString.call(message.checkIns) : options.longs === Number ? new $util.LongBits(message.checkIns.low >>> 0, message.checkIns.high >>> 0).toNumber() : message.checkIns;
                if (message.orders != null && message.hasOwnProperty("orders"))
                    if (typeof message.orders === "number")
                        object.orders = options.longs === String ? String(message.orders) : message.orders;
                    else
                        object.orders = options.longs === String ? $util.Long.prototype.toString.call(message.orders) : options.longs === Number ? new $util.LongBits(message.orders.low >>> 0, message.orders.high >>> 0).toNumber() : message.orders;
                if (message.paidOrders != null && message.hasOwnProperty("paidOrders"))
                    if (typeof message.paidOrders === "number")
                        object.paidOrders = options.longs === String ? String(message.paidOrders) : message.paidOrders;
                    else
                        object.paidOrders = options.longs === String ? $util.Long.prototype.toString.call(message.paidOrders) : options.longs === Number ? new $util.LongBits(message.paidOrders.low >>> 0, message.paidOrders.high >>> 0).toNumber() : message.paidOrders;
                if (message.refundedOrders != null && message.hasOwnProperty("refundedOrders"))
                    if (typeof message.refundedOrders === "number")
                        object.refundedOrders = options.longs === String ? String(message.refundedOrders) : message.refundedOrders;
                    else
                        object.refundedOrders = options.longs === String ? $util.Long.prototype.toString.call(message.refundedOrders) : options.longs === Number ? new $util.LongBits(message.refundedOrders.low >>> 0, message.refundedOrders.high >>> 0).toNumber() : message.refundedOrders;
                if (message.orderPaymentsVolume != null && message.hasOwnProperty("orderPaymentsVolume"))
                    object.orderPaymentsVolume = $root.waiternow.common.MoneyProto.toObject(message.orderPaymentsVolume, options);
                if (message.waiternowOrderPaymentsRevenue != null && message.hasOwnProperty("waiternowOrderPaymentsRevenue"))
                    object.waiternowOrderPaymentsRevenue = $root.waiternow.common.MoneyProto.toObject(message.waiternowOrderPaymentsRevenue, options);
                if (message.tips != null && message.hasOwnProperty("tips"))
                    object.tips = $root.waiternow.common.MoneyProto.toObject(message.tips, options);
                if (message.refundedOrdersVolume != null && message.hasOwnProperty("refundedOrdersVolume"))
                    object.refundedOrdersVolume = $root.waiternow.common.MoneyProto.toObject(message.refundedOrdersVolume, options);
                if (message.thumbsUp != null && message.hasOwnProperty("thumbsUp"))
                    if (typeof message.thumbsUp === "number")
                        object.thumbsUp = options.longs === String ? String(message.thumbsUp) : message.thumbsUp;
                    else
                        object.thumbsUp = options.longs === String ? $util.Long.prototype.toString.call(message.thumbsUp) : options.longs === Number ? new $util.LongBits(message.thumbsUp.low >>> 0, message.thumbsUp.high >>> 0).toNumber() : message.thumbsUp;
                if (message.thumbsDown != null && message.hasOwnProperty("thumbsDown"))
                    if (typeof message.thumbsDown === "number")
                        object.thumbsDown = options.longs === String ? String(message.thumbsDown) : message.thumbsDown;
                    else
                        object.thumbsDown = options.longs === String ? $util.Long.prototype.toString.call(message.thumbsDown) : options.longs === Number ? new $util.LongBits(message.thumbsDown.low >>> 0, message.thumbsDown.high >>> 0).toNumber() : message.thumbsDown;
                if (message.reviewsWithComments != null && message.hasOwnProperty("reviewsWithComments"))
                    if (typeof message.reviewsWithComments === "number")
                        object.reviewsWithComments = options.longs === String ? String(message.reviewsWithComments) : message.reviewsWithComments;
                    else
                        object.reviewsWithComments = options.longs === String ? $util.Long.prototype.toString.call(message.reviewsWithComments) : options.longs === Number ? new $util.LongBits(message.reviewsWithComments.low >>> 0, message.reviewsWithComments.high >>> 0).toNumber() : message.reviewsWithComments;
                if (message.incompleteOrders != null && message.hasOwnProperty("incompleteOrders"))
                    if (typeof message.incompleteOrders === "number")
                        object.incompleteOrders = options.longs === String ? String(message.incompleteOrders) : message.incompleteOrders;
                    else
                        object.incompleteOrders = options.longs === String ? $util.Long.prototype.toString.call(message.incompleteOrders) : options.longs === Number ? new $util.LongBits(message.incompleteOrders.low >>> 0, message.incompleteOrders.high >>> 0).toNumber() : message.incompleteOrders;
                if (message.onlinePickupOrders != null && message.hasOwnProperty("onlinePickupOrders"))
                    if (typeof message.onlinePickupOrders === "number")
                        object.onlinePickupOrders = options.longs === String ? String(message.onlinePickupOrders) : message.onlinePickupOrders;
                    else
                        object.onlinePickupOrders = options.longs === String ? $util.Long.prototype.toString.call(message.onlinePickupOrders) : options.longs === Number ? new $util.LongBits(message.onlinePickupOrders.low >>> 0, message.onlinePickupOrders.high >>> 0).toNumber() : message.onlinePickupOrders;
                if (message.deliveryOrders != null && message.hasOwnProperty("deliveryOrders"))
                    if (typeof message.deliveryOrders === "number")
                        object.deliveryOrders = options.longs === String ? String(message.deliveryOrders) : message.deliveryOrders;
                    else
                        object.deliveryOrders = options.longs === String ? $util.Long.prototype.toString.call(message.deliveryOrders) : options.longs === Number ? new $util.LongBits(message.deliveryOrders.low >>> 0, message.deliveryOrders.high >>> 0).toNumber() : message.deliveryOrders;
                if (message.oneStarRatings != null && message.hasOwnProperty("oneStarRatings"))
                    if (typeof message.oneStarRatings === "number")
                        object.oneStarRatings = options.longs === String ? String(message.oneStarRatings) : message.oneStarRatings;
                    else
                        object.oneStarRatings = options.longs === String ? $util.Long.prototype.toString.call(message.oneStarRatings) : options.longs === Number ? new $util.LongBits(message.oneStarRatings.low >>> 0, message.oneStarRatings.high >>> 0).toNumber() : message.oneStarRatings;
                if (message.twoStarsRatings != null && message.hasOwnProperty("twoStarsRatings"))
                    if (typeof message.twoStarsRatings === "number")
                        object.twoStarsRatings = options.longs === String ? String(message.twoStarsRatings) : message.twoStarsRatings;
                    else
                        object.twoStarsRatings = options.longs === String ? $util.Long.prototype.toString.call(message.twoStarsRatings) : options.longs === Number ? new $util.LongBits(message.twoStarsRatings.low >>> 0, message.twoStarsRatings.high >>> 0).toNumber() : message.twoStarsRatings;
                if (message.threeStarsRatings != null && message.hasOwnProperty("threeStarsRatings"))
                    if (typeof message.threeStarsRatings === "number")
                        object.threeStarsRatings = options.longs === String ? String(message.threeStarsRatings) : message.threeStarsRatings;
                    else
                        object.threeStarsRatings = options.longs === String ? $util.Long.prototype.toString.call(message.threeStarsRatings) : options.longs === Number ? new $util.LongBits(message.threeStarsRatings.low >>> 0, message.threeStarsRatings.high >>> 0).toNumber() : message.threeStarsRatings;
                if (message.fourStarsRatings != null && message.hasOwnProperty("fourStarsRatings"))
                    if (typeof message.fourStarsRatings === "number")
                        object.fourStarsRatings = options.longs === String ? String(message.fourStarsRatings) : message.fourStarsRatings;
                    else
                        object.fourStarsRatings = options.longs === String ? $util.Long.prototype.toString.call(message.fourStarsRatings) : options.longs === Number ? new $util.LongBits(message.fourStarsRatings.low >>> 0, message.fourStarsRatings.high >>> 0).toNumber() : message.fourStarsRatings;
                if (message.fiveStarsRatings != null && message.hasOwnProperty("fiveStarsRatings"))
                    if (typeof message.fiveStarsRatings === "number")
                        object.fiveStarsRatings = options.longs === String ? String(message.fiveStarsRatings) : message.fiveStarsRatings;
                    else
                        object.fiveStarsRatings = options.longs === String ? $util.Long.prototype.toString.call(message.fiveStarsRatings) : options.longs === Number ? new $util.LongBits(message.fiveStarsRatings.low >>> 0, message.fiveStarsRatings.high >>> 0).toNumber() : message.fiveStarsRatings;
                if (message.redundantData != null && message.hasOwnProperty("redundantData"))
                    object.redundantData = $root.waiternow.common.LocationMetricProto.RedundantDataProto.toObject(message.redundantData, options);
                if (message.disputedOrders != null && message.hasOwnProperty("disputedOrders"))
                    if (typeof message.disputedOrders === "number")
                        object.disputedOrders = options.longs === String ? String(message.disputedOrders) : message.disputedOrders;
                    else
                        object.disputedOrders = options.longs === String ? $util.Long.prototype.toString.call(message.disputedOrders) : options.longs === Number ? new $util.LongBits(message.disputedOrders.low >>> 0, message.disputedOrders.high >>> 0).toNumber() : message.disputedOrders;
                if (message.disputedOrdersVolume != null && message.hasOwnProperty("disputedOrdersVolume"))
                    object.disputedOrdersVolume = $root.waiternow.common.MoneyProto.toObject(message.disputedOrdersVolume, options);
                if (message.onsitePickupOrders != null && message.hasOwnProperty("onsitePickupOrders"))
                    if (typeof message.onsitePickupOrders === "number")
                        object.onsitePickupOrders = options.longs === String ? String(message.onsitePickupOrders) : message.onsitePickupOrders;
                    else
                        object.onsitePickupOrders = options.longs === String ? $util.Long.prototype.toString.call(message.onsitePickupOrders) : options.longs === Number ? new $util.LongBits(message.onsitePickupOrders.low >>> 0, message.onsitePickupOrders.high >>> 0).toNumber() : message.onsitePickupOrders;
                if (message.onsiteOrders != null && message.hasOwnProperty("onsiteOrders"))
                    if (typeof message.onsiteOrders === "number")
                        object.onsiteOrders = options.longs === String ? String(message.onsiteOrders) : message.onsiteOrders;
                    else
                        object.onsiteOrders = options.longs === String ? $util.Long.prototype.toString.call(message.onsiteOrders) : options.longs === Number ? new $util.LongBits(message.onsiteOrders.low >>> 0, message.onsiteOrders.high >>> 0).toNumber() : message.onsiteOrders;
                return object;
            };

            /**
             * Converts this LocationMetricProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.LocationMetricProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            LocationMetricProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for LocationMetricProto
             * @function getTypeUrl
             * @memberof waiternow.common.LocationMetricProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            LocationMetricProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.LocationMetricProto";
            };

            LocationMetricProto.RedundantDataProto = (function() {

                /**
                 * Properties of a RedundantDataProto.
                 * @memberof waiternow.common.LocationMetricProto
                 * @interface IRedundantDataProto
                 * @property {string|null} [businessId] RedundantDataProto businessId
                 * @property {string|null} [businessName] RedundantDataProto businessName
                 * @property {string|null} [locationName] RedundantDataProto locationName
                 */

                /**
                 * Constructs a new RedundantDataProto.
                 * @memberof waiternow.common.LocationMetricProto
                 * @classdesc Represents a RedundantDataProto.
                 * @implements IRedundantDataProto
                 * @constructor
                 * @param {waiternow.common.LocationMetricProto.IRedundantDataProto=} [properties] Properties to set
                 */
                function RedundantDataProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * RedundantDataProto businessId.
                 * @member {string} businessId
                 * @memberof waiternow.common.LocationMetricProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.businessId = "";

                /**
                 * RedundantDataProto businessName.
                 * @member {string} businessName
                 * @memberof waiternow.common.LocationMetricProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.businessName = "";

                /**
                 * RedundantDataProto locationName.
                 * @member {string} locationName
                 * @memberof waiternow.common.LocationMetricProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.locationName = "";

                /**
                 * Creates a new RedundantDataProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.LocationMetricProto.RedundantDataProto
                 * @static
                 * @param {waiternow.common.LocationMetricProto.IRedundantDataProto=} [properties] Properties to set
                 * @returns {waiternow.common.LocationMetricProto.RedundantDataProto} RedundantDataProto instance
                 */
                RedundantDataProto.create = function create(properties) {
                    return new RedundantDataProto(properties);
                };

                /**
                 * Encodes the specified RedundantDataProto message. Does not implicitly {@link waiternow.common.LocationMetricProto.RedundantDataProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.LocationMetricProto.RedundantDataProto
                 * @static
                 * @param {waiternow.common.LocationMetricProto.IRedundantDataProto} message RedundantDataProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RedundantDataProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessId);
                    if (message.businessName != null && Object.hasOwnProperty.call(message, "businessName"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.businessName);
                    if (message.locationName != null && Object.hasOwnProperty.call(message, "locationName"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.locationName);
                    return writer;
                };

                /**
                 * Encodes the specified RedundantDataProto message, length delimited. Does not implicitly {@link waiternow.common.LocationMetricProto.RedundantDataProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.LocationMetricProto.RedundantDataProto
                 * @static
                 * @param {waiternow.common.LocationMetricProto.IRedundantDataProto} message RedundantDataProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RedundantDataProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a RedundantDataProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.LocationMetricProto.RedundantDataProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.LocationMetricProto.RedundantDataProto} RedundantDataProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RedundantDataProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.LocationMetricProto.RedundantDataProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.businessId = reader.string();
                                break;
                            }
                        case 2: {
                                message.businessName = reader.string();
                                break;
                            }
                        case 3: {
                                message.locationName = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a RedundantDataProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.LocationMetricProto.RedundantDataProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.LocationMetricProto.RedundantDataProto} RedundantDataProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RedundantDataProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a RedundantDataProto message.
                 * @function verify
                 * @memberof waiternow.common.LocationMetricProto.RedundantDataProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                RedundantDataProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.businessId != null && message.hasOwnProperty("businessId"))
                        if (!$util.isString(message.businessId))
                            return "businessId: string expected";
                    if (message.businessName != null && message.hasOwnProperty("businessName"))
                        if (!$util.isString(message.businessName))
                            return "businessName: string expected";
                    if (message.locationName != null && message.hasOwnProperty("locationName"))
                        if (!$util.isString(message.locationName))
                            return "locationName: string expected";
                    return null;
                };

                /**
                 * Creates a RedundantDataProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.LocationMetricProto.RedundantDataProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.LocationMetricProto.RedundantDataProto} RedundantDataProto
                 */
                RedundantDataProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.LocationMetricProto.RedundantDataProto)
                        return object;
                    var message = new $root.waiternow.common.LocationMetricProto.RedundantDataProto();
                    if (object.businessId != null)
                        message.businessId = String(object.businessId);
                    if (object.businessName != null)
                        message.businessName = String(object.businessName);
                    if (object.locationName != null)
                        message.locationName = String(object.locationName);
                    return message;
                };

                /**
                 * Creates a plain object from a RedundantDataProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.LocationMetricProto.RedundantDataProto
                 * @static
                 * @param {waiternow.common.LocationMetricProto.RedundantDataProto} message RedundantDataProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                RedundantDataProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.businessId = "";
                        object.businessName = "";
                        object.locationName = "";
                    }
                    if (message.businessId != null && message.hasOwnProperty("businessId"))
                        object.businessId = message.businessId;
                    if (message.businessName != null && message.hasOwnProperty("businessName"))
                        object.businessName = message.businessName;
                    if (message.locationName != null && message.hasOwnProperty("locationName"))
                        object.locationName = message.locationName;
                    return object;
                };

                /**
                 * Converts this RedundantDataProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.LocationMetricProto.RedundantDataProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                RedundantDataProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for RedundantDataProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.LocationMetricProto.RedundantDataProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                RedundantDataProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.LocationMetricProto.RedundantDataProto";
                };

                return RedundantDataProto;
            })();

            return LocationMetricProto;
        })();

        common.LocationMetricsProto = (function() {

            /**
             * Properties of a LocationMetricsProto.
             * @memberof waiternow.common
             * @interface ILocationMetricsProto
             * @property {Array.<waiternow.common.ILocationMetricProto>|null} [metrics] LocationMetricsProto metrics
             * @property {string|null} [continuationToken] LocationMetricsProto continuationToken
             */

            /**
             * Constructs a new LocationMetricsProto.
             * @memberof waiternow.common
             * @classdesc Represents a LocationMetricsProto.
             * @implements ILocationMetricsProto
             * @constructor
             * @param {waiternow.common.ILocationMetricsProto=} [properties] Properties to set
             */
            function LocationMetricsProto(properties) {
                this.metrics = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * LocationMetricsProto metrics.
             * @member {Array.<waiternow.common.ILocationMetricProto>} metrics
             * @memberof waiternow.common.LocationMetricsProto
             * @instance
             */
            LocationMetricsProto.prototype.metrics = $util.emptyArray;

            /**
             * LocationMetricsProto continuationToken.
             * @member {string} continuationToken
             * @memberof waiternow.common.LocationMetricsProto
             * @instance
             */
            LocationMetricsProto.prototype.continuationToken = "";

            /**
             * Creates a new LocationMetricsProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.LocationMetricsProto
             * @static
             * @param {waiternow.common.ILocationMetricsProto=} [properties] Properties to set
             * @returns {waiternow.common.LocationMetricsProto} LocationMetricsProto instance
             */
            LocationMetricsProto.create = function create(properties) {
                return new LocationMetricsProto(properties);
            };

            /**
             * Encodes the specified LocationMetricsProto message. Does not implicitly {@link waiternow.common.LocationMetricsProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.LocationMetricsProto
             * @static
             * @param {waiternow.common.ILocationMetricsProto} message LocationMetricsProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            LocationMetricsProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.metrics != null && message.metrics.length)
                    for (var i = 0; i < message.metrics.length; ++i)
                        $root.waiternow.common.LocationMetricProto.encode(message.metrics[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.continuationToken);
                return writer;
            };

            /**
             * Encodes the specified LocationMetricsProto message, length delimited. Does not implicitly {@link waiternow.common.LocationMetricsProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.LocationMetricsProto
             * @static
             * @param {waiternow.common.ILocationMetricsProto} message LocationMetricsProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            LocationMetricsProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a LocationMetricsProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.LocationMetricsProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.LocationMetricsProto} LocationMetricsProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            LocationMetricsProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.LocationMetricsProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            if (!(message.metrics && message.metrics.length))
                                message.metrics = [];
                            message.metrics.push($root.waiternow.common.LocationMetricProto.decode(reader, reader.uint32()));
                            break;
                        }
                    case 2: {
                            message.continuationToken = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a LocationMetricsProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.LocationMetricsProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.LocationMetricsProto} LocationMetricsProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            LocationMetricsProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a LocationMetricsProto message.
             * @function verify
             * @memberof waiternow.common.LocationMetricsProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            LocationMetricsProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.metrics != null && message.hasOwnProperty("metrics")) {
                    if (!Array.isArray(message.metrics))
                        return "metrics: array expected";
                    for (var i = 0; i < message.metrics.length; ++i) {
                        var error = $root.waiternow.common.LocationMetricProto.verify(message.metrics[i]);
                        if (error)
                            return "metrics." + error;
                    }
                }
                if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                    if (!$util.isString(message.continuationToken))
                        return "continuationToken: string expected";
                return null;
            };

            /**
             * Creates a LocationMetricsProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.LocationMetricsProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.LocationMetricsProto} LocationMetricsProto
             */
            LocationMetricsProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.LocationMetricsProto)
                    return object;
                var message = new $root.waiternow.common.LocationMetricsProto();
                if (object.metrics) {
                    if (!Array.isArray(object.metrics))
                        throw TypeError(".waiternow.common.LocationMetricsProto.metrics: array expected");
                    message.metrics = [];
                    for (var i = 0; i < object.metrics.length; ++i) {
                        if (typeof object.metrics[i] !== "object")
                            throw TypeError(".waiternow.common.LocationMetricsProto.metrics: object expected");
                        message.metrics[i] = $root.waiternow.common.LocationMetricProto.fromObject(object.metrics[i]);
                    }
                }
                if (object.continuationToken != null)
                    message.continuationToken = String(object.continuationToken);
                return message;
            };

            /**
             * Creates a plain object from a LocationMetricsProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.LocationMetricsProto
             * @static
             * @param {waiternow.common.LocationMetricsProto} message LocationMetricsProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            LocationMetricsProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.metrics = [];
                if (options.defaults)
                    object.continuationToken = "";
                if (message.metrics && message.metrics.length) {
                    object.metrics = [];
                    for (var j = 0; j < message.metrics.length; ++j)
                        object.metrics[j] = $root.waiternow.common.LocationMetricProto.toObject(message.metrics[j], options);
                }
                if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                    object.continuationToken = message.continuationToken;
                return object;
            };

            /**
             * Converts this LocationMetricsProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.LocationMetricsProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            LocationMetricsProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for LocationMetricsProto
             * @function getTypeUrl
             * @memberof waiternow.common.LocationMetricsProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            LocationMetricsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.LocationMetricsProto";
            };

            return LocationMetricsProto;
        })();

        common.BusinessMetricProto = (function() {

            /**
             * Properties of a BusinessMetricProto.
             * @memberof waiternow.common
             * @interface IBusinessMetricProto
             * @property {string|null} [id] BusinessMetricProto id
             * @property {waiternow.common.IDateRangeProto|null} [period] BusinessMetricProto period
             * @property {waiternow.common.PeriodType|null} [periodType] BusinessMetricProto periodType
             * @property {google.protobuf.ITimestamp|null} [creationTime] BusinessMetricProto creationTime
             * @property {google.protobuf.ITimestamp|null} [lastUpdateTime] BusinessMetricProto lastUpdateTime
             * @property {string|null} [businessId] BusinessMetricProto businessId
             * @property {number|null} [checkIns] BusinessMetricProto checkIns
             * @property {number|null} [orders] BusinessMetricProto orders
             * @property {number|null} [paidOrders] BusinessMetricProto paidOrders
             * @property {number|null} [refundedOrders] BusinessMetricProto refundedOrders
             * @property {waiternow.common.IMoneyProto|null} [orderPaymentsVolume] BusinessMetricProto orderPaymentsVolume
             * @property {waiternow.common.IMoneyProto|null} [waiternowOrderPaymentsRevenue] BusinessMetricProto waiternowOrderPaymentsRevenue
             * @property {waiternow.common.IMoneyProto|null} [tips] BusinessMetricProto tips
             * @property {waiternow.common.IMoneyProto|null} [refundedOrdersVolume] BusinessMetricProto refundedOrdersVolume
             * @property {number|null} [thumbsUp] BusinessMetricProto thumbsUp
             * @property {number|null} [thumbsDown] BusinessMetricProto thumbsDown
             * @property {number|null} [reviewsWithComments] BusinessMetricProto reviewsWithComments
             * @property {number|null} [incompleteOrders] BusinessMetricProto incompleteOrders
             * @property {number|null} [onlinePickupOrders] BusinessMetricProto onlinePickupOrders
             * @property {number|null} [deliveryOrders] BusinessMetricProto deliveryOrders
             * @property {number|null} [oneStarRatings] BusinessMetricProto oneStarRatings
             * @property {number|null} [twoStarsRatings] BusinessMetricProto twoStarsRatings
             * @property {number|null} [threeStarsRatings] BusinessMetricProto threeStarsRatings
             * @property {number|null} [fourStarsRatings] BusinessMetricProto fourStarsRatings
             * @property {number|null} [fiveStarsRatings] BusinessMetricProto fiveStarsRatings
             * @property {number|null} [disputedOrders] BusinessMetricProto disputedOrders
             * @property {waiternow.common.IMoneyProto|null} [disputedOrdersVolume] BusinessMetricProto disputedOrdersVolume
             * @property {waiternow.common.BusinessMetricProto.IRedundantDataProto|null} [redundantData] BusinessMetricProto redundantData
             */

            /**
             * Constructs a new BusinessMetricProto.
             * @memberof waiternow.common
             * @classdesc Represents a BusinessMetricProto.
             * @implements IBusinessMetricProto
             * @constructor
             * @param {waiternow.common.IBusinessMetricProto=} [properties] Properties to set
             */
            function BusinessMetricProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * BusinessMetricProto id.
             * @member {string} id
             * @memberof waiternow.common.BusinessMetricProto
             * @instance
             */
            BusinessMetricProto.prototype.id = "";

            /**
             * BusinessMetricProto period.
             * @member {waiternow.common.IDateRangeProto|null|undefined} period
             * @memberof waiternow.common.BusinessMetricProto
             * @instance
             */
            BusinessMetricProto.prototype.period = null;

            /**
             * BusinessMetricProto periodType.
             * @member {waiternow.common.PeriodType} periodType
             * @memberof waiternow.common.BusinessMetricProto
             * @instance
             */
            BusinessMetricProto.prototype.periodType = 0;

            /**
             * BusinessMetricProto creationTime.
             * @member {google.protobuf.ITimestamp|null|undefined} creationTime
             * @memberof waiternow.common.BusinessMetricProto
             * @instance
             */
            BusinessMetricProto.prototype.creationTime = null;

            /**
             * BusinessMetricProto lastUpdateTime.
             * @member {google.protobuf.ITimestamp|null|undefined} lastUpdateTime
             * @memberof waiternow.common.BusinessMetricProto
             * @instance
             */
            BusinessMetricProto.prototype.lastUpdateTime = null;

            /**
             * BusinessMetricProto businessId.
             * @member {string} businessId
             * @memberof waiternow.common.BusinessMetricProto
             * @instance
             */
            BusinessMetricProto.prototype.businessId = "";

            /**
             * BusinessMetricProto checkIns.
             * @member {number} checkIns
             * @memberof waiternow.common.BusinessMetricProto
             * @instance
             */
            BusinessMetricProto.prototype.checkIns = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * BusinessMetricProto orders.
             * @member {number} orders
             * @memberof waiternow.common.BusinessMetricProto
             * @instance
             */
            BusinessMetricProto.prototype.orders = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * BusinessMetricProto paidOrders.
             * @member {number} paidOrders
             * @memberof waiternow.common.BusinessMetricProto
             * @instance
             */
            BusinessMetricProto.prototype.paidOrders = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * BusinessMetricProto refundedOrders.
             * @member {number} refundedOrders
             * @memberof waiternow.common.BusinessMetricProto
             * @instance
             */
            BusinessMetricProto.prototype.refundedOrders = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * BusinessMetricProto orderPaymentsVolume.
             * @member {waiternow.common.IMoneyProto|null|undefined} orderPaymentsVolume
             * @memberof waiternow.common.BusinessMetricProto
             * @instance
             */
            BusinessMetricProto.prototype.orderPaymentsVolume = null;

            /**
             * BusinessMetricProto waiternowOrderPaymentsRevenue.
             * @member {waiternow.common.IMoneyProto|null|undefined} waiternowOrderPaymentsRevenue
             * @memberof waiternow.common.BusinessMetricProto
             * @instance
             */
            BusinessMetricProto.prototype.waiternowOrderPaymentsRevenue = null;

            /**
             * BusinessMetricProto tips.
             * @member {waiternow.common.IMoneyProto|null|undefined} tips
             * @memberof waiternow.common.BusinessMetricProto
             * @instance
             */
            BusinessMetricProto.prototype.tips = null;

            /**
             * BusinessMetricProto refundedOrdersVolume.
             * @member {waiternow.common.IMoneyProto|null|undefined} refundedOrdersVolume
             * @memberof waiternow.common.BusinessMetricProto
             * @instance
             */
            BusinessMetricProto.prototype.refundedOrdersVolume = null;

            /**
             * BusinessMetricProto thumbsUp.
             * @member {number} thumbsUp
             * @memberof waiternow.common.BusinessMetricProto
             * @instance
             */
            BusinessMetricProto.prototype.thumbsUp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * BusinessMetricProto thumbsDown.
             * @member {number} thumbsDown
             * @memberof waiternow.common.BusinessMetricProto
             * @instance
             */
            BusinessMetricProto.prototype.thumbsDown = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * BusinessMetricProto reviewsWithComments.
             * @member {number} reviewsWithComments
             * @memberof waiternow.common.BusinessMetricProto
             * @instance
             */
            BusinessMetricProto.prototype.reviewsWithComments = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * BusinessMetricProto incompleteOrders.
             * @member {number} incompleteOrders
             * @memberof waiternow.common.BusinessMetricProto
             * @instance
             */
            BusinessMetricProto.prototype.incompleteOrders = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * BusinessMetricProto onlinePickupOrders.
             * @member {number} onlinePickupOrders
             * @memberof waiternow.common.BusinessMetricProto
             * @instance
             */
            BusinessMetricProto.prototype.onlinePickupOrders = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * BusinessMetricProto deliveryOrders.
             * @member {number} deliveryOrders
             * @memberof waiternow.common.BusinessMetricProto
             * @instance
             */
            BusinessMetricProto.prototype.deliveryOrders = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * BusinessMetricProto oneStarRatings.
             * @member {number} oneStarRatings
             * @memberof waiternow.common.BusinessMetricProto
             * @instance
             */
            BusinessMetricProto.prototype.oneStarRatings = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * BusinessMetricProto twoStarsRatings.
             * @member {number} twoStarsRatings
             * @memberof waiternow.common.BusinessMetricProto
             * @instance
             */
            BusinessMetricProto.prototype.twoStarsRatings = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * BusinessMetricProto threeStarsRatings.
             * @member {number} threeStarsRatings
             * @memberof waiternow.common.BusinessMetricProto
             * @instance
             */
            BusinessMetricProto.prototype.threeStarsRatings = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * BusinessMetricProto fourStarsRatings.
             * @member {number} fourStarsRatings
             * @memberof waiternow.common.BusinessMetricProto
             * @instance
             */
            BusinessMetricProto.prototype.fourStarsRatings = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * BusinessMetricProto fiveStarsRatings.
             * @member {number} fiveStarsRatings
             * @memberof waiternow.common.BusinessMetricProto
             * @instance
             */
            BusinessMetricProto.prototype.fiveStarsRatings = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * BusinessMetricProto disputedOrders.
             * @member {number} disputedOrders
             * @memberof waiternow.common.BusinessMetricProto
             * @instance
             */
            BusinessMetricProto.prototype.disputedOrders = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * BusinessMetricProto disputedOrdersVolume.
             * @member {waiternow.common.IMoneyProto|null|undefined} disputedOrdersVolume
             * @memberof waiternow.common.BusinessMetricProto
             * @instance
             */
            BusinessMetricProto.prototype.disputedOrdersVolume = null;

            /**
             * BusinessMetricProto redundantData.
             * @member {waiternow.common.BusinessMetricProto.IRedundantDataProto|null|undefined} redundantData
             * @memberof waiternow.common.BusinessMetricProto
             * @instance
             */
            BusinessMetricProto.prototype.redundantData = null;

            /**
             * Creates a new BusinessMetricProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.BusinessMetricProto
             * @static
             * @param {waiternow.common.IBusinessMetricProto=} [properties] Properties to set
             * @returns {waiternow.common.BusinessMetricProto} BusinessMetricProto instance
             */
            BusinessMetricProto.create = function create(properties) {
                return new BusinessMetricProto(properties);
            };

            /**
             * Encodes the specified BusinessMetricProto message. Does not implicitly {@link waiternow.common.BusinessMetricProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.BusinessMetricProto
             * @static
             * @param {waiternow.common.IBusinessMetricProto} message BusinessMetricProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BusinessMetricProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                if (message.period != null && Object.hasOwnProperty.call(message, "period"))
                    $root.waiternow.common.DateRangeProto.encode(message.period, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.periodType != null && Object.hasOwnProperty.call(message, "periodType"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.periodType);
                if (message.creationTime != null && Object.hasOwnProperty.call(message, "creationTime"))
                    $root.google.protobuf.Timestamp.encode(message.creationTime, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                    $root.google.protobuf.Timestamp.encode(message.lastUpdateTime, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.businessId);
                if (message.checkIns != null && Object.hasOwnProperty.call(message, "checkIns"))
                    writer.uint32(/* id 7, wireType 0 =*/56).int64(message.checkIns);
                if (message.orders != null && Object.hasOwnProperty.call(message, "orders"))
                    writer.uint32(/* id 8, wireType 0 =*/64).int64(message.orders);
                if (message.paidOrders != null && Object.hasOwnProperty.call(message, "paidOrders"))
                    writer.uint32(/* id 9, wireType 0 =*/72).int64(message.paidOrders);
                if (message.refundedOrders != null && Object.hasOwnProperty.call(message, "refundedOrders"))
                    writer.uint32(/* id 10, wireType 0 =*/80).int64(message.refundedOrders);
                if (message.orderPaymentsVolume != null && Object.hasOwnProperty.call(message, "orderPaymentsVolume"))
                    $root.waiternow.common.MoneyProto.encode(message.orderPaymentsVolume, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                if (message.waiternowOrderPaymentsRevenue != null && Object.hasOwnProperty.call(message, "waiternowOrderPaymentsRevenue"))
                    $root.waiternow.common.MoneyProto.encode(message.waiternowOrderPaymentsRevenue, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                if (message.tips != null && Object.hasOwnProperty.call(message, "tips"))
                    $root.waiternow.common.MoneyProto.encode(message.tips, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
                if (message.refundedOrdersVolume != null && Object.hasOwnProperty.call(message, "refundedOrdersVolume"))
                    $root.waiternow.common.MoneyProto.encode(message.refundedOrdersVolume, writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
                if (message.thumbsUp != null && Object.hasOwnProperty.call(message, "thumbsUp"))
                    writer.uint32(/* id 15, wireType 0 =*/120).int64(message.thumbsUp);
                if (message.thumbsDown != null && Object.hasOwnProperty.call(message, "thumbsDown"))
                    writer.uint32(/* id 16, wireType 0 =*/128).int64(message.thumbsDown);
                if (message.reviewsWithComments != null && Object.hasOwnProperty.call(message, "reviewsWithComments"))
                    writer.uint32(/* id 17, wireType 0 =*/136).int64(message.reviewsWithComments);
                if (message.incompleteOrders != null && Object.hasOwnProperty.call(message, "incompleteOrders"))
                    writer.uint32(/* id 18, wireType 0 =*/144).int64(message.incompleteOrders);
                if (message.onlinePickupOrders != null && Object.hasOwnProperty.call(message, "onlinePickupOrders"))
                    writer.uint32(/* id 19, wireType 0 =*/152).int64(message.onlinePickupOrders);
                if (message.deliveryOrders != null && Object.hasOwnProperty.call(message, "deliveryOrders"))
                    writer.uint32(/* id 20, wireType 0 =*/160).int64(message.deliveryOrders);
                if (message.oneStarRatings != null && Object.hasOwnProperty.call(message, "oneStarRatings"))
                    writer.uint32(/* id 21, wireType 0 =*/168).int64(message.oneStarRatings);
                if (message.twoStarsRatings != null && Object.hasOwnProperty.call(message, "twoStarsRatings"))
                    writer.uint32(/* id 22, wireType 0 =*/176).int64(message.twoStarsRatings);
                if (message.threeStarsRatings != null && Object.hasOwnProperty.call(message, "threeStarsRatings"))
                    writer.uint32(/* id 23, wireType 0 =*/184).int64(message.threeStarsRatings);
                if (message.fourStarsRatings != null && Object.hasOwnProperty.call(message, "fourStarsRatings"))
                    writer.uint32(/* id 24, wireType 0 =*/192).int64(message.fourStarsRatings);
                if (message.fiveStarsRatings != null && Object.hasOwnProperty.call(message, "fiveStarsRatings"))
                    writer.uint32(/* id 25, wireType 0 =*/200).int64(message.fiveStarsRatings);
                if (message.redundantData != null && Object.hasOwnProperty.call(message, "redundantData"))
                    $root.waiternow.common.BusinessMetricProto.RedundantDataProto.encode(message.redundantData, writer.uint32(/* id 26, wireType 2 =*/210).fork()).ldelim();
                if (message.disputedOrders != null && Object.hasOwnProperty.call(message, "disputedOrders"))
                    writer.uint32(/* id 27, wireType 0 =*/216).int64(message.disputedOrders);
                if (message.disputedOrdersVolume != null && Object.hasOwnProperty.call(message, "disputedOrdersVolume"))
                    $root.waiternow.common.MoneyProto.encode(message.disputedOrdersVolume, writer.uint32(/* id 28, wireType 2 =*/226).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified BusinessMetricProto message, length delimited. Does not implicitly {@link waiternow.common.BusinessMetricProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.BusinessMetricProto
             * @static
             * @param {waiternow.common.IBusinessMetricProto} message BusinessMetricProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BusinessMetricProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a BusinessMetricProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.BusinessMetricProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.BusinessMetricProto} BusinessMetricProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BusinessMetricProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.BusinessMetricProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.id = reader.string();
                            break;
                        }
                    case 2: {
                            message.period = $root.waiternow.common.DateRangeProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 3: {
                            message.periodType = reader.int32();
                            break;
                        }
                    case 4: {
                            message.creationTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 5: {
                            message.lastUpdateTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 6: {
                            message.businessId = reader.string();
                            break;
                        }
                    case 7: {
                            message.checkIns = reader.int64();
                            break;
                        }
                    case 8: {
                            message.orders = reader.int64();
                            break;
                        }
                    case 9: {
                            message.paidOrders = reader.int64();
                            break;
                        }
                    case 10: {
                            message.refundedOrders = reader.int64();
                            break;
                        }
                    case 11: {
                            message.orderPaymentsVolume = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 12: {
                            message.waiternowOrderPaymentsRevenue = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 13: {
                            message.tips = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 14: {
                            message.refundedOrdersVolume = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 15: {
                            message.thumbsUp = reader.int64();
                            break;
                        }
                    case 16: {
                            message.thumbsDown = reader.int64();
                            break;
                        }
                    case 17: {
                            message.reviewsWithComments = reader.int64();
                            break;
                        }
                    case 18: {
                            message.incompleteOrders = reader.int64();
                            break;
                        }
                    case 19: {
                            message.onlinePickupOrders = reader.int64();
                            break;
                        }
                    case 20: {
                            message.deliveryOrders = reader.int64();
                            break;
                        }
                    case 21: {
                            message.oneStarRatings = reader.int64();
                            break;
                        }
                    case 22: {
                            message.twoStarsRatings = reader.int64();
                            break;
                        }
                    case 23: {
                            message.threeStarsRatings = reader.int64();
                            break;
                        }
                    case 24: {
                            message.fourStarsRatings = reader.int64();
                            break;
                        }
                    case 25: {
                            message.fiveStarsRatings = reader.int64();
                            break;
                        }
                    case 27: {
                            message.disputedOrders = reader.int64();
                            break;
                        }
                    case 28: {
                            message.disputedOrdersVolume = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 26: {
                            message.redundantData = $root.waiternow.common.BusinessMetricProto.RedundantDataProto.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a BusinessMetricProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.BusinessMetricProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.BusinessMetricProto} BusinessMetricProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BusinessMetricProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a BusinessMetricProto message.
             * @function verify
             * @memberof waiternow.common.BusinessMetricProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            BusinessMetricProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.id != null && message.hasOwnProperty("id"))
                    if (!$util.isString(message.id))
                        return "id: string expected";
                if (message.period != null && message.hasOwnProperty("period")) {
                    var error = $root.waiternow.common.DateRangeProto.verify(message.period);
                    if (error)
                        return "period." + error;
                }
                if (message.periodType != null && message.hasOwnProperty("periodType"))
                    switch (message.periodType) {
                    default:
                        return "periodType: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                        break;
                    }
                if (message.creationTime != null && message.hasOwnProperty("creationTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.creationTime);
                    if (error)
                        return "creationTime." + error;
                }
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.lastUpdateTime);
                    if (error)
                        return "lastUpdateTime." + error;
                }
                if (message.businessId != null && message.hasOwnProperty("businessId"))
                    if (!$util.isString(message.businessId))
                        return "businessId: string expected";
                if (message.checkIns != null && message.hasOwnProperty("checkIns"))
                    if (!$util.isInteger(message.checkIns) && !(message.checkIns && $util.isInteger(message.checkIns.low) && $util.isInteger(message.checkIns.high)))
                        return "checkIns: integer|Long expected";
                if (message.orders != null && message.hasOwnProperty("orders"))
                    if (!$util.isInteger(message.orders) && !(message.orders && $util.isInteger(message.orders.low) && $util.isInteger(message.orders.high)))
                        return "orders: integer|Long expected";
                if (message.paidOrders != null && message.hasOwnProperty("paidOrders"))
                    if (!$util.isInteger(message.paidOrders) && !(message.paidOrders && $util.isInteger(message.paidOrders.low) && $util.isInteger(message.paidOrders.high)))
                        return "paidOrders: integer|Long expected";
                if (message.refundedOrders != null && message.hasOwnProperty("refundedOrders"))
                    if (!$util.isInteger(message.refundedOrders) && !(message.refundedOrders && $util.isInteger(message.refundedOrders.low) && $util.isInteger(message.refundedOrders.high)))
                        return "refundedOrders: integer|Long expected";
                if (message.orderPaymentsVolume != null && message.hasOwnProperty("orderPaymentsVolume")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.orderPaymentsVolume);
                    if (error)
                        return "orderPaymentsVolume." + error;
                }
                if (message.waiternowOrderPaymentsRevenue != null && message.hasOwnProperty("waiternowOrderPaymentsRevenue")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.waiternowOrderPaymentsRevenue);
                    if (error)
                        return "waiternowOrderPaymentsRevenue." + error;
                }
                if (message.tips != null && message.hasOwnProperty("tips")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.tips);
                    if (error)
                        return "tips." + error;
                }
                if (message.refundedOrdersVolume != null && message.hasOwnProperty("refundedOrdersVolume")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.refundedOrdersVolume);
                    if (error)
                        return "refundedOrdersVolume." + error;
                }
                if (message.thumbsUp != null && message.hasOwnProperty("thumbsUp"))
                    if (!$util.isInteger(message.thumbsUp) && !(message.thumbsUp && $util.isInteger(message.thumbsUp.low) && $util.isInteger(message.thumbsUp.high)))
                        return "thumbsUp: integer|Long expected";
                if (message.thumbsDown != null && message.hasOwnProperty("thumbsDown"))
                    if (!$util.isInteger(message.thumbsDown) && !(message.thumbsDown && $util.isInteger(message.thumbsDown.low) && $util.isInteger(message.thumbsDown.high)))
                        return "thumbsDown: integer|Long expected";
                if (message.reviewsWithComments != null && message.hasOwnProperty("reviewsWithComments"))
                    if (!$util.isInteger(message.reviewsWithComments) && !(message.reviewsWithComments && $util.isInteger(message.reviewsWithComments.low) && $util.isInteger(message.reviewsWithComments.high)))
                        return "reviewsWithComments: integer|Long expected";
                if (message.incompleteOrders != null && message.hasOwnProperty("incompleteOrders"))
                    if (!$util.isInteger(message.incompleteOrders) && !(message.incompleteOrders && $util.isInteger(message.incompleteOrders.low) && $util.isInteger(message.incompleteOrders.high)))
                        return "incompleteOrders: integer|Long expected";
                if (message.onlinePickupOrders != null && message.hasOwnProperty("onlinePickupOrders"))
                    if (!$util.isInteger(message.onlinePickupOrders) && !(message.onlinePickupOrders && $util.isInteger(message.onlinePickupOrders.low) && $util.isInteger(message.onlinePickupOrders.high)))
                        return "onlinePickupOrders: integer|Long expected";
                if (message.deliveryOrders != null && message.hasOwnProperty("deliveryOrders"))
                    if (!$util.isInteger(message.deliveryOrders) && !(message.deliveryOrders && $util.isInteger(message.deliveryOrders.low) && $util.isInteger(message.deliveryOrders.high)))
                        return "deliveryOrders: integer|Long expected";
                if (message.oneStarRatings != null && message.hasOwnProperty("oneStarRatings"))
                    if (!$util.isInteger(message.oneStarRatings) && !(message.oneStarRatings && $util.isInteger(message.oneStarRatings.low) && $util.isInteger(message.oneStarRatings.high)))
                        return "oneStarRatings: integer|Long expected";
                if (message.twoStarsRatings != null && message.hasOwnProperty("twoStarsRatings"))
                    if (!$util.isInteger(message.twoStarsRatings) && !(message.twoStarsRatings && $util.isInteger(message.twoStarsRatings.low) && $util.isInteger(message.twoStarsRatings.high)))
                        return "twoStarsRatings: integer|Long expected";
                if (message.threeStarsRatings != null && message.hasOwnProperty("threeStarsRatings"))
                    if (!$util.isInteger(message.threeStarsRatings) && !(message.threeStarsRatings && $util.isInteger(message.threeStarsRatings.low) && $util.isInteger(message.threeStarsRatings.high)))
                        return "threeStarsRatings: integer|Long expected";
                if (message.fourStarsRatings != null && message.hasOwnProperty("fourStarsRatings"))
                    if (!$util.isInteger(message.fourStarsRatings) && !(message.fourStarsRatings && $util.isInteger(message.fourStarsRatings.low) && $util.isInteger(message.fourStarsRatings.high)))
                        return "fourStarsRatings: integer|Long expected";
                if (message.fiveStarsRatings != null && message.hasOwnProperty("fiveStarsRatings"))
                    if (!$util.isInteger(message.fiveStarsRatings) && !(message.fiveStarsRatings && $util.isInteger(message.fiveStarsRatings.low) && $util.isInteger(message.fiveStarsRatings.high)))
                        return "fiveStarsRatings: integer|Long expected";
                if (message.disputedOrders != null && message.hasOwnProperty("disputedOrders"))
                    if (!$util.isInteger(message.disputedOrders) && !(message.disputedOrders && $util.isInteger(message.disputedOrders.low) && $util.isInteger(message.disputedOrders.high)))
                        return "disputedOrders: integer|Long expected";
                if (message.disputedOrdersVolume != null && message.hasOwnProperty("disputedOrdersVolume")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.disputedOrdersVolume);
                    if (error)
                        return "disputedOrdersVolume." + error;
                }
                if (message.redundantData != null && message.hasOwnProperty("redundantData")) {
                    var error = $root.waiternow.common.BusinessMetricProto.RedundantDataProto.verify(message.redundantData);
                    if (error)
                        return "redundantData." + error;
                }
                return null;
            };

            /**
             * Creates a BusinessMetricProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.BusinessMetricProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.BusinessMetricProto} BusinessMetricProto
             */
            BusinessMetricProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.BusinessMetricProto)
                    return object;
                var message = new $root.waiternow.common.BusinessMetricProto();
                if (object.id != null)
                    message.id = String(object.id);
                if (object.period != null) {
                    if (typeof object.period !== "object")
                        throw TypeError(".waiternow.common.BusinessMetricProto.period: object expected");
                    message.period = $root.waiternow.common.DateRangeProto.fromObject(object.period);
                }
                switch (object.periodType) {
                default:
                    if (typeof object.periodType === "number") {
                        message.periodType = object.periodType;
                        break;
                    }
                    break;
                case "PERIOD_TYPE_UNSPECIFIED":
                case 0:
                    message.periodType = 0;
                    break;
                case "DAILY":
                case 1:
                    message.periodType = 1;
                    break;
                case "MONTHLY":
                case 2:
                    message.periodType = 2;
                    break;
                case "YEARLY":
                case 3:
                    message.periodType = 3;
                    break;
                }
                if (object.creationTime != null) {
                    if (typeof object.creationTime !== "object")
                        throw TypeError(".waiternow.common.BusinessMetricProto.creationTime: object expected");
                    message.creationTime = $root.google.protobuf.Timestamp.fromObject(object.creationTime);
                }
                if (object.lastUpdateTime != null) {
                    if (typeof object.lastUpdateTime !== "object")
                        throw TypeError(".waiternow.common.BusinessMetricProto.lastUpdateTime: object expected");
                    message.lastUpdateTime = $root.google.protobuf.Timestamp.fromObject(object.lastUpdateTime);
                }
                if (object.businessId != null)
                    message.businessId = String(object.businessId);
                if (object.checkIns != null)
                    if ($util.Long)
                        (message.checkIns = $util.Long.fromValue(object.checkIns)).unsigned = false;
                    else if (typeof object.checkIns === "string")
                        message.checkIns = parseInt(object.checkIns, 10);
                    else if (typeof object.checkIns === "number")
                        message.checkIns = object.checkIns;
                    else if (typeof object.checkIns === "object")
                        message.checkIns = new $util.LongBits(object.checkIns.low >>> 0, object.checkIns.high >>> 0).toNumber();
                if (object.orders != null)
                    if ($util.Long)
                        (message.orders = $util.Long.fromValue(object.orders)).unsigned = false;
                    else if (typeof object.orders === "string")
                        message.orders = parseInt(object.orders, 10);
                    else if (typeof object.orders === "number")
                        message.orders = object.orders;
                    else if (typeof object.orders === "object")
                        message.orders = new $util.LongBits(object.orders.low >>> 0, object.orders.high >>> 0).toNumber();
                if (object.paidOrders != null)
                    if ($util.Long)
                        (message.paidOrders = $util.Long.fromValue(object.paidOrders)).unsigned = false;
                    else if (typeof object.paidOrders === "string")
                        message.paidOrders = parseInt(object.paidOrders, 10);
                    else if (typeof object.paidOrders === "number")
                        message.paidOrders = object.paidOrders;
                    else if (typeof object.paidOrders === "object")
                        message.paidOrders = new $util.LongBits(object.paidOrders.low >>> 0, object.paidOrders.high >>> 0).toNumber();
                if (object.refundedOrders != null)
                    if ($util.Long)
                        (message.refundedOrders = $util.Long.fromValue(object.refundedOrders)).unsigned = false;
                    else if (typeof object.refundedOrders === "string")
                        message.refundedOrders = parseInt(object.refundedOrders, 10);
                    else if (typeof object.refundedOrders === "number")
                        message.refundedOrders = object.refundedOrders;
                    else if (typeof object.refundedOrders === "object")
                        message.refundedOrders = new $util.LongBits(object.refundedOrders.low >>> 0, object.refundedOrders.high >>> 0).toNumber();
                if (object.orderPaymentsVolume != null) {
                    if (typeof object.orderPaymentsVolume !== "object")
                        throw TypeError(".waiternow.common.BusinessMetricProto.orderPaymentsVolume: object expected");
                    message.orderPaymentsVolume = $root.waiternow.common.MoneyProto.fromObject(object.orderPaymentsVolume);
                }
                if (object.waiternowOrderPaymentsRevenue != null) {
                    if (typeof object.waiternowOrderPaymentsRevenue !== "object")
                        throw TypeError(".waiternow.common.BusinessMetricProto.waiternowOrderPaymentsRevenue: object expected");
                    message.waiternowOrderPaymentsRevenue = $root.waiternow.common.MoneyProto.fromObject(object.waiternowOrderPaymentsRevenue);
                }
                if (object.tips != null) {
                    if (typeof object.tips !== "object")
                        throw TypeError(".waiternow.common.BusinessMetricProto.tips: object expected");
                    message.tips = $root.waiternow.common.MoneyProto.fromObject(object.tips);
                }
                if (object.refundedOrdersVolume != null) {
                    if (typeof object.refundedOrdersVolume !== "object")
                        throw TypeError(".waiternow.common.BusinessMetricProto.refundedOrdersVolume: object expected");
                    message.refundedOrdersVolume = $root.waiternow.common.MoneyProto.fromObject(object.refundedOrdersVolume);
                }
                if (object.thumbsUp != null)
                    if ($util.Long)
                        (message.thumbsUp = $util.Long.fromValue(object.thumbsUp)).unsigned = false;
                    else if (typeof object.thumbsUp === "string")
                        message.thumbsUp = parseInt(object.thumbsUp, 10);
                    else if (typeof object.thumbsUp === "number")
                        message.thumbsUp = object.thumbsUp;
                    else if (typeof object.thumbsUp === "object")
                        message.thumbsUp = new $util.LongBits(object.thumbsUp.low >>> 0, object.thumbsUp.high >>> 0).toNumber();
                if (object.thumbsDown != null)
                    if ($util.Long)
                        (message.thumbsDown = $util.Long.fromValue(object.thumbsDown)).unsigned = false;
                    else if (typeof object.thumbsDown === "string")
                        message.thumbsDown = parseInt(object.thumbsDown, 10);
                    else if (typeof object.thumbsDown === "number")
                        message.thumbsDown = object.thumbsDown;
                    else if (typeof object.thumbsDown === "object")
                        message.thumbsDown = new $util.LongBits(object.thumbsDown.low >>> 0, object.thumbsDown.high >>> 0).toNumber();
                if (object.reviewsWithComments != null)
                    if ($util.Long)
                        (message.reviewsWithComments = $util.Long.fromValue(object.reviewsWithComments)).unsigned = false;
                    else if (typeof object.reviewsWithComments === "string")
                        message.reviewsWithComments = parseInt(object.reviewsWithComments, 10);
                    else if (typeof object.reviewsWithComments === "number")
                        message.reviewsWithComments = object.reviewsWithComments;
                    else if (typeof object.reviewsWithComments === "object")
                        message.reviewsWithComments = new $util.LongBits(object.reviewsWithComments.low >>> 0, object.reviewsWithComments.high >>> 0).toNumber();
                if (object.incompleteOrders != null)
                    if ($util.Long)
                        (message.incompleteOrders = $util.Long.fromValue(object.incompleteOrders)).unsigned = false;
                    else if (typeof object.incompleteOrders === "string")
                        message.incompleteOrders = parseInt(object.incompleteOrders, 10);
                    else if (typeof object.incompleteOrders === "number")
                        message.incompleteOrders = object.incompleteOrders;
                    else if (typeof object.incompleteOrders === "object")
                        message.incompleteOrders = new $util.LongBits(object.incompleteOrders.low >>> 0, object.incompleteOrders.high >>> 0).toNumber();
                if (object.onlinePickupOrders != null)
                    if ($util.Long)
                        (message.onlinePickupOrders = $util.Long.fromValue(object.onlinePickupOrders)).unsigned = false;
                    else if (typeof object.onlinePickupOrders === "string")
                        message.onlinePickupOrders = parseInt(object.onlinePickupOrders, 10);
                    else if (typeof object.onlinePickupOrders === "number")
                        message.onlinePickupOrders = object.onlinePickupOrders;
                    else if (typeof object.onlinePickupOrders === "object")
                        message.onlinePickupOrders = new $util.LongBits(object.onlinePickupOrders.low >>> 0, object.onlinePickupOrders.high >>> 0).toNumber();
                if (object.deliveryOrders != null)
                    if ($util.Long)
                        (message.deliveryOrders = $util.Long.fromValue(object.deliveryOrders)).unsigned = false;
                    else if (typeof object.deliveryOrders === "string")
                        message.deliveryOrders = parseInt(object.deliveryOrders, 10);
                    else if (typeof object.deliveryOrders === "number")
                        message.deliveryOrders = object.deliveryOrders;
                    else if (typeof object.deliveryOrders === "object")
                        message.deliveryOrders = new $util.LongBits(object.deliveryOrders.low >>> 0, object.deliveryOrders.high >>> 0).toNumber();
                if (object.oneStarRatings != null)
                    if ($util.Long)
                        (message.oneStarRatings = $util.Long.fromValue(object.oneStarRatings)).unsigned = false;
                    else if (typeof object.oneStarRatings === "string")
                        message.oneStarRatings = parseInt(object.oneStarRatings, 10);
                    else if (typeof object.oneStarRatings === "number")
                        message.oneStarRatings = object.oneStarRatings;
                    else if (typeof object.oneStarRatings === "object")
                        message.oneStarRatings = new $util.LongBits(object.oneStarRatings.low >>> 0, object.oneStarRatings.high >>> 0).toNumber();
                if (object.twoStarsRatings != null)
                    if ($util.Long)
                        (message.twoStarsRatings = $util.Long.fromValue(object.twoStarsRatings)).unsigned = false;
                    else if (typeof object.twoStarsRatings === "string")
                        message.twoStarsRatings = parseInt(object.twoStarsRatings, 10);
                    else if (typeof object.twoStarsRatings === "number")
                        message.twoStarsRatings = object.twoStarsRatings;
                    else if (typeof object.twoStarsRatings === "object")
                        message.twoStarsRatings = new $util.LongBits(object.twoStarsRatings.low >>> 0, object.twoStarsRatings.high >>> 0).toNumber();
                if (object.threeStarsRatings != null)
                    if ($util.Long)
                        (message.threeStarsRatings = $util.Long.fromValue(object.threeStarsRatings)).unsigned = false;
                    else if (typeof object.threeStarsRatings === "string")
                        message.threeStarsRatings = parseInt(object.threeStarsRatings, 10);
                    else if (typeof object.threeStarsRatings === "number")
                        message.threeStarsRatings = object.threeStarsRatings;
                    else if (typeof object.threeStarsRatings === "object")
                        message.threeStarsRatings = new $util.LongBits(object.threeStarsRatings.low >>> 0, object.threeStarsRatings.high >>> 0).toNumber();
                if (object.fourStarsRatings != null)
                    if ($util.Long)
                        (message.fourStarsRatings = $util.Long.fromValue(object.fourStarsRatings)).unsigned = false;
                    else if (typeof object.fourStarsRatings === "string")
                        message.fourStarsRatings = parseInt(object.fourStarsRatings, 10);
                    else if (typeof object.fourStarsRatings === "number")
                        message.fourStarsRatings = object.fourStarsRatings;
                    else if (typeof object.fourStarsRatings === "object")
                        message.fourStarsRatings = new $util.LongBits(object.fourStarsRatings.low >>> 0, object.fourStarsRatings.high >>> 0).toNumber();
                if (object.fiveStarsRatings != null)
                    if ($util.Long)
                        (message.fiveStarsRatings = $util.Long.fromValue(object.fiveStarsRatings)).unsigned = false;
                    else if (typeof object.fiveStarsRatings === "string")
                        message.fiveStarsRatings = parseInt(object.fiveStarsRatings, 10);
                    else if (typeof object.fiveStarsRatings === "number")
                        message.fiveStarsRatings = object.fiveStarsRatings;
                    else if (typeof object.fiveStarsRatings === "object")
                        message.fiveStarsRatings = new $util.LongBits(object.fiveStarsRatings.low >>> 0, object.fiveStarsRatings.high >>> 0).toNumber();
                if (object.disputedOrders != null)
                    if ($util.Long)
                        (message.disputedOrders = $util.Long.fromValue(object.disputedOrders)).unsigned = false;
                    else if (typeof object.disputedOrders === "string")
                        message.disputedOrders = parseInt(object.disputedOrders, 10);
                    else if (typeof object.disputedOrders === "number")
                        message.disputedOrders = object.disputedOrders;
                    else if (typeof object.disputedOrders === "object")
                        message.disputedOrders = new $util.LongBits(object.disputedOrders.low >>> 0, object.disputedOrders.high >>> 0).toNumber();
                if (object.disputedOrdersVolume != null) {
                    if (typeof object.disputedOrdersVolume !== "object")
                        throw TypeError(".waiternow.common.BusinessMetricProto.disputedOrdersVolume: object expected");
                    message.disputedOrdersVolume = $root.waiternow.common.MoneyProto.fromObject(object.disputedOrdersVolume);
                }
                if (object.redundantData != null) {
                    if (typeof object.redundantData !== "object")
                        throw TypeError(".waiternow.common.BusinessMetricProto.redundantData: object expected");
                    message.redundantData = $root.waiternow.common.BusinessMetricProto.RedundantDataProto.fromObject(object.redundantData);
                }
                return message;
            };

            /**
             * Creates a plain object from a BusinessMetricProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.BusinessMetricProto
             * @static
             * @param {waiternow.common.BusinessMetricProto} message BusinessMetricProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            BusinessMetricProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.id = "";
                    object.period = null;
                    object.periodType = options.enums === String ? "PERIOD_TYPE_UNSPECIFIED" : 0;
                    object.creationTime = null;
                    object.lastUpdateTime = null;
                    object.businessId = "";
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.checkIns = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.checkIns = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.orders = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.orders = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.paidOrders = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.paidOrders = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.refundedOrders = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.refundedOrders = options.longs === String ? "0" : 0;
                    object.orderPaymentsVolume = null;
                    object.waiternowOrderPaymentsRevenue = null;
                    object.tips = null;
                    object.refundedOrdersVolume = null;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.thumbsUp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.thumbsUp = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.thumbsDown = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.thumbsDown = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.reviewsWithComments = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.reviewsWithComments = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.incompleteOrders = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.incompleteOrders = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.onlinePickupOrders = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.onlinePickupOrders = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.deliveryOrders = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.deliveryOrders = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.oneStarRatings = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.oneStarRatings = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.twoStarsRatings = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.twoStarsRatings = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.threeStarsRatings = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.threeStarsRatings = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.fourStarsRatings = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.fourStarsRatings = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.fiveStarsRatings = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.fiveStarsRatings = options.longs === String ? "0" : 0;
                    object.redundantData = null;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.disputedOrders = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.disputedOrders = options.longs === String ? "0" : 0;
                    object.disputedOrdersVolume = null;
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                if (message.period != null && message.hasOwnProperty("period"))
                    object.period = $root.waiternow.common.DateRangeProto.toObject(message.period, options);
                if (message.periodType != null && message.hasOwnProperty("periodType"))
                    object.periodType = options.enums === String ? $root.waiternow.common.PeriodType[message.periodType] === undefined ? message.periodType : $root.waiternow.common.PeriodType[message.periodType] : message.periodType;
                if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                    object.creationTime = $root.google.protobuf.Timestamp.toObject(message.creationTime, options);
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                    object.lastUpdateTime = $root.google.protobuf.Timestamp.toObject(message.lastUpdateTime, options);
                if (message.businessId != null && message.hasOwnProperty("businessId"))
                    object.businessId = message.businessId;
                if (message.checkIns != null && message.hasOwnProperty("checkIns"))
                    if (typeof message.checkIns === "number")
                        object.checkIns = options.longs === String ? String(message.checkIns) : message.checkIns;
                    else
                        object.checkIns = options.longs === String ? $util.Long.prototype.toString.call(message.checkIns) : options.longs === Number ? new $util.LongBits(message.checkIns.low >>> 0, message.checkIns.high >>> 0).toNumber() : message.checkIns;
                if (message.orders != null && message.hasOwnProperty("orders"))
                    if (typeof message.orders === "number")
                        object.orders = options.longs === String ? String(message.orders) : message.orders;
                    else
                        object.orders = options.longs === String ? $util.Long.prototype.toString.call(message.orders) : options.longs === Number ? new $util.LongBits(message.orders.low >>> 0, message.orders.high >>> 0).toNumber() : message.orders;
                if (message.paidOrders != null && message.hasOwnProperty("paidOrders"))
                    if (typeof message.paidOrders === "number")
                        object.paidOrders = options.longs === String ? String(message.paidOrders) : message.paidOrders;
                    else
                        object.paidOrders = options.longs === String ? $util.Long.prototype.toString.call(message.paidOrders) : options.longs === Number ? new $util.LongBits(message.paidOrders.low >>> 0, message.paidOrders.high >>> 0).toNumber() : message.paidOrders;
                if (message.refundedOrders != null && message.hasOwnProperty("refundedOrders"))
                    if (typeof message.refundedOrders === "number")
                        object.refundedOrders = options.longs === String ? String(message.refundedOrders) : message.refundedOrders;
                    else
                        object.refundedOrders = options.longs === String ? $util.Long.prototype.toString.call(message.refundedOrders) : options.longs === Number ? new $util.LongBits(message.refundedOrders.low >>> 0, message.refundedOrders.high >>> 0).toNumber() : message.refundedOrders;
                if (message.orderPaymentsVolume != null && message.hasOwnProperty("orderPaymentsVolume"))
                    object.orderPaymentsVolume = $root.waiternow.common.MoneyProto.toObject(message.orderPaymentsVolume, options);
                if (message.waiternowOrderPaymentsRevenue != null && message.hasOwnProperty("waiternowOrderPaymentsRevenue"))
                    object.waiternowOrderPaymentsRevenue = $root.waiternow.common.MoneyProto.toObject(message.waiternowOrderPaymentsRevenue, options);
                if (message.tips != null && message.hasOwnProperty("tips"))
                    object.tips = $root.waiternow.common.MoneyProto.toObject(message.tips, options);
                if (message.refundedOrdersVolume != null && message.hasOwnProperty("refundedOrdersVolume"))
                    object.refundedOrdersVolume = $root.waiternow.common.MoneyProto.toObject(message.refundedOrdersVolume, options);
                if (message.thumbsUp != null && message.hasOwnProperty("thumbsUp"))
                    if (typeof message.thumbsUp === "number")
                        object.thumbsUp = options.longs === String ? String(message.thumbsUp) : message.thumbsUp;
                    else
                        object.thumbsUp = options.longs === String ? $util.Long.prototype.toString.call(message.thumbsUp) : options.longs === Number ? new $util.LongBits(message.thumbsUp.low >>> 0, message.thumbsUp.high >>> 0).toNumber() : message.thumbsUp;
                if (message.thumbsDown != null && message.hasOwnProperty("thumbsDown"))
                    if (typeof message.thumbsDown === "number")
                        object.thumbsDown = options.longs === String ? String(message.thumbsDown) : message.thumbsDown;
                    else
                        object.thumbsDown = options.longs === String ? $util.Long.prototype.toString.call(message.thumbsDown) : options.longs === Number ? new $util.LongBits(message.thumbsDown.low >>> 0, message.thumbsDown.high >>> 0).toNumber() : message.thumbsDown;
                if (message.reviewsWithComments != null && message.hasOwnProperty("reviewsWithComments"))
                    if (typeof message.reviewsWithComments === "number")
                        object.reviewsWithComments = options.longs === String ? String(message.reviewsWithComments) : message.reviewsWithComments;
                    else
                        object.reviewsWithComments = options.longs === String ? $util.Long.prototype.toString.call(message.reviewsWithComments) : options.longs === Number ? new $util.LongBits(message.reviewsWithComments.low >>> 0, message.reviewsWithComments.high >>> 0).toNumber() : message.reviewsWithComments;
                if (message.incompleteOrders != null && message.hasOwnProperty("incompleteOrders"))
                    if (typeof message.incompleteOrders === "number")
                        object.incompleteOrders = options.longs === String ? String(message.incompleteOrders) : message.incompleteOrders;
                    else
                        object.incompleteOrders = options.longs === String ? $util.Long.prototype.toString.call(message.incompleteOrders) : options.longs === Number ? new $util.LongBits(message.incompleteOrders.low >>> 0, message.incompleteOrders.high >>> 0).toNumber() : message.incompleteOrders;
                if (message.onlinePickupOrders != null && message.hasOwnProperty("onlinePickupOrders"))
                    if (typeof message.onlinePickupOrders === "number")
                        object.onlinePickupOrders = options.longs === String ? String(message.onlinePickupOrders) : message.onlinePickupOrders;
                    else
                        object.onlinePickupOrders = options.longs === String ? $util.Long.prototype.toString.call(message.onlinePickupOrders) : options.longs === Number ? new $util.LongBits(message.onlinePickupOrders.low >>> 0, message.onlinePickupOrders.high >>> 0).toNumber() : message.onlinePickupOrders;
                if (message.deliveryOrders != null && message.hasOwnProperty("deliveryOrders"))
                    if (typeof message.deliveryOrders === "number")
                        object.deliveryOrders = options.longs === String ? String(message.deliveryOrders) : message.deliveryOrders;
                    else
                        object.deliveryOrders = options.longs === String ? $util.Long.prototype.toString.call(message.deliveryOrders) : options.longs === Number ? new $util.LongBits(message.deliveryOrders.low >>> 0, message.deliveryOrders.high >>> 0).toNumber() : message.deliveryOrders;
                if (message.oneStarRatings != null && message.hasOwnProperty("oneStarRatings"))
                    if (typeof message.oneStarRatings === "number")
                        object.oneStarRatings = options.longs === String ? String(message.oneStarRatings) : message.oneStarRatings;
                    else
                        object.oneStarRatings = options.longs === String ? $util.Long.prototype.toString.call(message.oneStarRatings) : options.longs === Number ? new $util.LongBits(message.oneStarRatings.low >>> 0, message.oneStarRatings.high >>> 0).toNumber() : message.oneStarRatings;
                if (message.twoStarsRatings != null && message.hasOwnProperty("twoStarsRatings"))
                    if (typeof message.twoStarsRatings === "number")
                        object.twoStarsRatings = options.longs === String ? String(message.twoStarsRatings) : message.twoStarsRatings;
                    else
                        object.twoStarsRatings = options.longs === String ? $util.Long.prototype.toString.call(message.twoStarsRatings) : options.longs === Number ? new $util.LongBits(message.twoStarsRatings.low >>> 0, message.twoStarsRatings.high >>> 0).toNumber() : message.twoStarsRatings;
                if (message.threeStarsRatings != null && message.hasOwnProperty("threeStarsRatings"))
                    if (typeof message.threeStarsRatings === "number")
                        object.threeStarsRatings = options.longs === String ? String(message.threeStarsRatings) : message.threeStarsRatings;
                    else
                        object.threeStarsRatings = options.longs === String ? $util.Long.prototype.toString.call(message.threeStarsRatings) : options.longs === Number ? new $util.LongBits(message.threeStarsRatings.low >>> 0, message.threeStarsRatings.high >>> 0).toNumber() : message.threeStarsRatings;
                if (message.fourStarsRatings != null && message.hasOwnProperty("fourStarsRatings"))
                    if (typeof message.fourStarsRatings === "number")
                        object.fourStarsRatings = options.longs === String ? String(message.fourStarsRatings) : message.fourStarsRatings;
                    else
                        object.fourStarsRatings = options.longs === String ? $util.Long.prototype.toString.call(message.fourStarsRatings) : options.longs === Number ? new $util.LongBits(message.fourStarsRatings.low >>> 0, message.fourStarsRatings.high >>> 0).toNumber() : message.fourStarsRatings;
                if (message.fiveStarsRatings != null && message.hasOwnProperty("fiveStarsRatings"))
                    if (typeof message.fiveStarsRatings === "number")
                        object.fiveStarsRatings = options.longs === String ? String(message.fiveStarsRatings) : message.fiveStarsRatings;
                    else
                        object.fiveStarsRatings = options.longs === String ? $util.Long.prototype.toString.call(message.fiveStarsRatings) : options.longs === Number ? new $util.LongBits(message.fiveStarsRatings.low >>> 0, message.fiveStarsRatings.high >>> 0).toNumber() : message.fiveStarsRatings;
                if (message.redundantData != null && message.hasOwnProperty("redundantData"))
                    object.redundantData = $root.waiternow.common.BusinessMetricProto.RedundantDataProto.toObject(message.redundantData, options);
                if (message.disputedOrders != null && message.hasOwnProperty("disputedOrders"))
                    if (typeof message.disputedOrders === "number")
                        object.disputedOrders = options.longs === String ? String(message.disputedOrders) : message.disputedOrders;
                    else
                        object.disputedOrders = options.longs === String ? $util.Long.prototype.toString.call(message.disputedOrders) : options.longs === Number ? new $util.LongBits(message.disputedOrders.low >>> 0, message.disputedOrders.high >>> 0).toNumber() : message.disputedOrders;
                if (message.disputedOrdersVolume != null && message.hasOwnProperty("disputedOrdersVolume"))
                    object.disputedOrdersVolume = $root.waiternow.common.MoneyProto.toObject(message.disputedOrdersVolume, options);
                return object;
            };

            /**
             * Converts this BusinessMetricProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.BusinessMetricProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            BusinessMetricProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for BusinessMetricProto
             * @function getTypeUrl
             * @memberof waiternow.common.BusinessMetricProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            BusinessMetricProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.BusinessMetricProto";
            };

            BusinessMetricProto.RedundantDataProto = (function() {

                /**
                 * Properties of a RedundantDataProto.
                 * @memberof waiternow.common.BusinessMetricProto
                 * @interface IRedundantDataProto
                 * @property {string|null} [businessName] RedundantDataProto businessName
                 */

                /**
                 * Constructs a new RedundantDataProto.
                 * @memberof waiternow.common.BusinessMetricProto
                 * @classdesc Represents a RedundantDataProto.
                 * @implements IRedundantDataProto
                 * @constructor
                 * @param {waiternow.common.BusinessMetricProto.IRedundantDataProto=} [properties] Properties to set
                 */
                function RedundantDataProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * RedundantDataProto businessName.
                 * @member {string} businessName
                 * @memberof waiternow.common.BusinessMetricProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.businessName = "";

                /**
                 * Creates a new RedundantDataProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.BusinessMetricProto.RedundantDataProto
                 * @static
                 * @param {waiternow.common.BusinessMetricProto.IRedundantDataProto=} [properties] Properties to set
                 * @returns {waiternow.common.BusinessMetricProto.RedundantDataProto} RedundantDataProto instance
                 */
                RedundantDataProto.create = function create(properties) {
                    return new RedundantDataProto(properties);
                };

                /**
                 * Encodes the specified RedundantDataProto message. Does not implicitly {@link waiternow.common.BusinessMetricProto.RedundantDataProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.BusinessMetricProto.RedundantDataProto
                 * @static
                 * @param {waiternow.common.BusinessMetricProto.IRedundantDataProto} message RedundantDataProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RedundantDataProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.businessName != null && Object.hasOwnProperty.call(message, "businessName"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessName);
                    return writer;
                };

                /**
                 * Encodes the specified RedundantDataProto message, length delimited. Does not implicitly {@link waiternow.common.BusinessMetricProto.RedundantDataProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.BusinessMetricProto.RedundantDataProto
                 * @static
                 * @param {waiternow.common.BusinessMetricProto.IRedundantDataProto} message RedundantDataProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RedundantDataProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a RedundantDataProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.BusinessMetricProto.RedundantDataProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.BusinessMetricProto.RedundantDataProto} RedundantDataProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RedundantDataProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.BusinessMetricProto.RedundantDataProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.businessName = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a RedundantDataProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.BusinessMetricProto.RedundantDataProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.BusinessMetricProto.RedundantDataProto} RedundantDataProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RedundantDataProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a RedundantDataProto message.
                 * @function verify
                 * @memberof waiternow.common.BusinessMetricProto.RedundantDataProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                RedundantDataProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.businessName != null && message.hasOwnProperty("businessName"))
                        if (!$util.isString(message.businessName))
                            return "businessName: string expected";
                    return null;
                };

                /**
                 * Creates a RedundantDataProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.BusinessMetricProto.RedundantDataProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.BusinessMetricProto.RedundantDataProto} RedundantDataProto
                 */
                RedundantDataProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.BusinessMetricProto.RedundantDataProto)
                        return object;
                    var message = new $root.waiternow.common.BusinessMetricProto.RedundantDataProto();
                    if (object.businessName != null)
                        message.businessName = String(object.businessName);
                    return message;
                };

                /**
                 * Creates a plain object from a RedundantDataProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.BusinessMetricProto.RedundantDataProto
                 * @static
                 * @param {waiternow.common.BusinessMetricProto.RedundantDataProto} message RedundantDataProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                RedundantDataProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.businessName = "";
                    if (message.businessName != null && message.hasOwnProperty("businessName"))
                        object.businessName = message.businessName;
                    return object;
                };

                /**
                 * Converts this RedundantDataProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.BusinessMetricProto.RedundantDataProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                RedundantDataProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for RedundantDataProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.BusinessMetricProto.RedundantDataProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                RedundantDataProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.BusinessMetricProto.RedundantDataProto";
                };

                return RedundantDataProto;
            })();

            return BusinessMetricProto;
        })();

        common.BusinessMetricsProto = (function() {

            /**
             * Properties of a BusinessMetricsProto.
             * @memberof waiternow.common
             * @interface IBusinessMetricsProto
             * @property {Array.<waiternow.common.IBusinessMetricProto>|null} [metrics] BusinessMetricsProto metrics
             * @property {string|null} [continuationToken] BusinessMetricsProto continuationToken
             */

            /**
             * Constructs a new BusinessMetricsProto.
             * @memberof waiternow.common
             * @classdesc Represents a BusinessMetricsProto.
             * @implements IBusinessMetricsProto
             * @constructor
             * @param {waiternow.common.IBusinessMetricsProto=} [properties] Properties to set
             */
            function BusinessMetricsProto(properties) {
                this.metrics = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * BusinessMetricsProto metrics.
             * @member {Array.<waiternow.common.IBusinessMetricProto>} metrics
             * @memberof waiternow.common.BusinessMetricsProto
             * @instance
             */
            BusinessMetricsProto.prototype.metrics = $util.emptyArray;

            /**
             * BusinessMetricsProto continuationToken.
             * @member {string} continuationToken
             * @memberof waiternow.common.BusinessMetricsProto
             * @instance
             */
            BusinessMetricsProto.prototype.continuationToken = "";

            /**
             * Creates a new BusinessMetricsProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.BusinessMetricsProto
             * @static
             * @param {waiternow.common.IBusinessMetricsProto=} [properties] Properties to set
             * @returns {waiternow.common.BusinessMetricsProto} BusinessMetricsProto instance
             */
            BusinessMetricsProto.create = function create(properties) {
                return new BusinessMetricsProto(properties);
            };

            /**
             * Encodes the specified BusinessMetricsProto message. Does not implicitly {@link waiternow.common.BusinessMetricsProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.BusinessMetricsProto
             * @static
             * @param {waiternow.common.IBusinessMetricsProto} message BusinessMetricsProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BusinessMetricsProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.metrics != null && message.metrics.length)
                    for (var i = 0; i < message.metrics.length; ++i)
                        $root.waiternow.common.BusinessMetricProto.encode(message.metrics[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.continuationToken);
                return writer;
            };

            /**
             * Encodes the specified BusinessMetricsProto message, length delimited. Does not implicitly {@link waiternow.common.BusinessMetricsProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.BusinessMetricsProto
             * @static
             * @param {waiternow.common.IBusinessMetricsProto} message BusinessMetricsProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BusinessMetricsProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a BusinessMetricsProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.BusinessMetricsProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.BusinessMetricsProto} BusinessMetricsProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BusinessMetricsProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.BusinessMetricsProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            if (!(message.metrics && message.metrics.length))
                                message.metrics = [];
                            message.metrics.push($root.waiternow.common.BusinessMetricProto.decode(reader, reader.uint32()));
                            break;
                        }
                    case 2: {
                            message.continuationToken = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a BusinessMetricsProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.BusinessMetricsProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.BusinessMetricsProto} BusinessMetricsProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BusinessMetricsProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a BusinessMetricsProto message.
             * @function verify
             * @memberof waiternow.common.BusinessMetricsProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            BusinessMetricsProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.metrics != null && message.hasOwnProperty("metrics")) {
                    if (!Array.isArray(message.metrics))
                        return "metrics: array expected";
                    for (var i = 0; i < message.metrics.length; ++i) {
                        var error = $root.waiternow.common.BusinessMetricProto.verify(message.metrics[i]);
                        if (error)
                            return "metrics." + error;
                    }
                }
                if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                    if (!$util.isString(message.continuationToken))
                        return "continuationToken: string expected";
                return null;
            };

            /**
             * Creates a BusinessMetricsProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.BusinessMetricsProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.BusinessMetricsProto} BusinessMetricsProto
             */
            BusinessMetricsProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.BusinessMetricsProto)
                    return object;
                var message = new $root.waiternow.common.BusinessMetricsProto();
                if (object.metrics) {
                    if (!Array.isArray(object.metrics))
                        throw TypeError(".waiternow.common.BusinessMetricsProto.metrics: array expected");
                    message.metrics = [];
                    for (var i = 0; i < object.metrics.length; ++i) {
                        if (typeof object.metrics[i] !== "object")
                            throw TypeError(".waiternow.common.BusinessMetricsProto.metrics: object expected");
                        message.metrics[i] = $root.waiternow.common.BusinessMetricProto.fromObject(object.metrics[i]);
                    }
                }
                if (object.continuationToken != null)
                    message.continuationToken = String(object.continuationToken);
                return message;
            };

            /**
             * Creates a plain object from a BusinessMetricsProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.BusinessMetricsProto
             * @static
             * @param {waiternow.common.BusinessMetricsProto} message BusinessMetricsProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            BusinessMetricsProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.metrics = [];
                if (options.defaults)
                    object.continuationToken = "";
                if (message.metrics && message.metrics.length) {
                    object.metrics = [];
                    for (var j = 0; j < message.metrics.length; ++j)
                        object.metrics[j] = $root.waiternow.common.BusinessMetricProto.toObject(message.metrics[j], options);
                }
                if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                    object.continuationToken = message.continuationToken;
                return object;
            };

            /**
             * Converts this BusinessMetricsProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.BusinessMetricsProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            BusinessMetricsProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for BusinessMetricsProto
             * @function getTypeUrl
             * @memberof waiternow.common.BusinessMetricsProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            BusinessMetricsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.BusinessMetricsProto";
            };

            return BusinessMetricsProto;
        })();

        common.OrderProto = (function() {

            /**
             * Properties of an OrderProto.
             * @memberof waiternow.common
             * @interface IOrderProto
             * @property {string|null} [id] OrderProto id
             * @property {google.protobuf.ITimestamp|null} [creationTime] OrderProto creationTime
             * @property {google.protobuf.ITimestamp|null} [lastUpdateTime] OrderProto lastUpdateTime
             * @property {string|null} [pointOfServiceId] OrderProto pointOfServiceId
             * @property {string|null} [consumerId] OrderProto consumerId
             * @property {string|null} [deviceId] OrderProto deviceId
             * @property {waiternow.common.OrderProto.IWaiterRequestProto|null} [waiterRequest] OrderProto waiterRequest
             * @property {waiternow.common.IMenuOrderProto|null} [menuOrder] OrderProto menuOrder
             * @property {waiternow.common.OrderProto.IStatusProto|null} [status] OrderProto status
             * @property {waiternow.common.OrderProto.IRedundantDataProto|null} [redundantData] OrderProto redundantData
             * @property {number|null} [orderNumber] OrderProto orderNumber
             * @property {waiternow.common.OrderProto.IMetadataProto|null} [metadata] OrderProto metadata
             * @property {waiternow.common.IDateTimeProto|null} [orderTime] OrderProto orderTime
             * @property {google.protobuf.ITimestamp|null} [timeToPrepare] OrderProto timeToPrepare
             * @property {waiternow.common.IDeliveryProto|null} [delivery] OrderProto delivery
             * @property {waiternow.common.IDeliveryProto|null} [retriedDelivery] OrderProto retriedDelivery
             */

            /**
             * Constructs a new OrderProto.
             * @memberof waiternow.common
             * @classdesc Represents an OrderProto.
             * @implements IOrderProto
             * @constructor
             * @param {waiternow.common.IOrderProto=} [properties] Properties to set
             */
            function OrderProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * OrderProto id.
             * @member {string} id
             * @memberof waiternow.common.OrderProto
             * @instance
             */
            OrderProto.prototype.id = "";

            /**
             * OrderProto creationTime.
             * @member {google.protobuf.ITimestamp|null|undefined} creationTime
             * @memberof waiternow.common.OrderProto
             * @instance
             */
            OrderProto.prototype.creationTime = null;

            /**
             * OrderProto lastUpdateTime.
             * @member {google.protobuf.ITimestamp|null|undefined} lastUpdateTime
             * @memberof waiternow.common.OrderProto
             * @instance
             */
            OrderProto.prototype.lastUpdateTime = null;

            /**
             * OrderProto pointOfServiceId.
             * @member {string} pointOfServiceId
             * @memberof waiternow.common.OrderProto
             * @instance
             */
            OrderProto.prototype.pointOfServiceId = "";

            /**
             * OrderProto consumerId.
             * @member {string} consumerId
             * @memberof waiternow.common.OrderProto
             * @instance
             */
            OrderProto.prototype.consumerId = "";

            /**
             * OrderProto deviceId.
             * @member {string} deviceId
             * @memberof waiternow.common.OrderProto
             * @instance
             */
            OrderProto.prototype.deviceId = "";

            /**
             * OrderProto waiterRequest.
             * @member {waiternow.common.OrderProto.IWaiterRequestProto|null|undefined} waiterRequest
             * @memberof waiternow.common.OrderProto
             * @instance
             */
            OrderProto.prototype.waiterRequest = null;

            /**
             * OrderProto menuOrder.
             * @member {waiternow.common.IMenuOrderProto|null|undefined} menuOrder
             * @memberof waiternow.common.OrderProto
             * @instance
             */
            OrderProto.prototype.menuOrder = null;

            /**
             * OrderProto status.
             * @member {waiternow.common.OrderProto.IStatusProto|null|undefined} status
             * @memberof waiternow.common.OrderProto
             * @instance
             */
            OrderProto.prototype.status = null;

            /**
             * OrderProto redundantData.
             * @member {waiternow.common.OrderProto.IRedundantDataProto|null|undefined} redundantData
             * @memberof waiternow.common.OrderProto
             * @instance
             */
            OrderProto.prototype.redundantData = null;

            /**
             * OrderProto orderNumber.
             * @member {number} orderNumber
             * @memberof waiternow.common.OrderProto
             * @instance
             */
            OrderProto.prototype.orderNumber = 0;

            /**
             * OrderProto metadata.
             * @member {waiternow.common.OrderProto.IMetadataProto|null|undefined} metadata
             * @memberof waiternow.common.OrderProto
             * @instance
             */
            OrderProto.prototype.metadata = null;

            /**
             * OrderProto orderTime.
             * @member {waiternow.common.IDateTimeProto|null|undefined} orderTime
             * @memberof waiternow.common.OrderProto
             * @instance
             */
            OrderProto.prototype.orderTime = null;

            /**
             * OrderProto timeToPrepare.
             * @member {google.protobuf.ITimestamp|null|undefined} timeToPrepare
             * @memberof waiternow.common.OrderProto
             * @instance
             */
            OrderProto.prototype.timeToPrepare = null;

            /**
             * OrderProto delivery.
             * @member {waiternow.common.IDeliveryProto|null|undefined} delivery
             * @memberof waiternow.common.OrderProto
             * @instance
             */
            OrderProto.prototype.delivery = null;

            /**
             * OrderProto retriedDelivery.
             * @member {waiternow.common.IDeliveryProto|null|undefined} retriedDelivery
             * @memberof waiternow.common.OrderProto
             * @instance
             */
            OrderProto.prototype.retriedDelivery = null;

            // OneOf field names bound to virtual getters and setters
            var $oneOfFields;

            /**
             * OrderProto orderType.
             * @member {"waiterRequest"|"menuOrder"|undefined} orderType
             * @memberof waiternow.common.OrderProto
             * @instance
             */
            Object.defineProperty(OrderProto.prototype, "orderType", {
                get: $util.oneOfGetter($oneOfFields = ["waiterRequest", "menuOrder"]),
                set: $util.oneOfSetter($oneOfFields)
            });

            /**
             * Creates a new OrderProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.OrderProto
             * @static
             * @param {waiternow.common.IOrderProto=} [properties] Properties to set
             * @returns {waiternow.common.OrderProto} OrderProto instance
             */
            OrderProto.create = function create(properties) {
                return new OrderProto(properties);
            };

            /**
             * Encodes the specified OrderProto message. Does not implicitly {@link waiternow.common.OrderProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.OrderProto
             * @static
             * @param {waiternow.common.IOrderProto} message OrderProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OrderProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                if (message.pointOfServiceId != null && Object.hasOwnProperty.call(message, "pointOfServiceId"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.pointOfServiceId);
                if (message.consumerId != null && Object.hasOwnProperty.call(message, "consumerId"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.consumerId);
                if (message.waiterRequest != null && Object.hasOwnProperty.call(message, "waiterRequest"))
                    $root.waiternow.common.OrderProto.WaiterRequestProto.encode(message.waiterRequest, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                if (message.menuOrder != null && Object.hasOwnProperty.call(message, "menuOrder"))
                    $root.waiternow.common.MenuOrderProto.encode(message.menuOrder, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                    $root.waiternow.common.OrderProto.StatusProto.encode(message.status, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                if (message.creationTime != null && Object.hasOwnProperty.call(message, "creationTime"))
                    $root.google.protobuf.Timestamp.encode(message.creationTime, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                if (message.redundantData != null && Object.hasOwnProperty.call(message, "redundantData"))
                    $root.waiternow.common.OrderProto.RedundantDataProto.encode(message.redundantData, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                if (message.deviceId != null && Object.hasOwnProperty.call(message, "deviceId"))
                    writer.uint32(/* id 9, wireType 2 =*/74).string(message.deviceId);
                if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                    $root.google.protobuf.Timestamp.encode(message.lastUpdateTime, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                if (message.orderNumber != null && Object.hasOwnProperty.call(message, "orderNumber"))
                    writer.uint32(/* id 11, wireType 0 =*/88).int32(message.orderNumber);
                if (message.metadata != null && Object.hasOwnProperty.call(message, "metadata"))
                    $root.waiternow.common.OrderProto.MetadataProto.encode(message.metadata, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                if (message.orderTime != null && Object.hasOwnProperty.call(message, "orderTime"))
                    $root.waiternow.common.DateTimeProto.encode(message.orderTime, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
                if (message.delivery != null && Object.hasOwnProperty.call(message, "delivery"))
                    $root.waiternow.common.DeliveryProto.encode(message.delivery, writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
                if (message.retriedDelivery != null && Object.hasOwnProperty.call(message, "retriedDelivery"))
                    $root.waiternow.common.DeliveryProto.encode(message.retriedDelivery, writer.uint32(/* id 17, wireType 2 =*/138).fork()).ldelim();
                if (message.timeToPrepare != null && Object.hasOwnProperty.call(message, "timeToPrepare"))
                    $root.google.protobuf.Timestamp.encode(message.timeToPrepare, writer.uint32(/* id 18, wireType 2 =*/146).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified OrderProto message, length delimited. Does not implicitly {@link waiternow.common.OrderProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.OrderProto
             * @static
             * @param {waiternow.common.IOrderProto} message OrderProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OrderProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an OrderProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.OrderProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.OrderProto} OrderProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OrderProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.OrderProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.id = reader.string();
                            break;
                        }
                    case 7: {
                            message.creationTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 10: {
                            message.lastUpdateTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 2: {
                            message.pointOfServiceId = reader.string();
                            break;
                        }
                    case 3: {
                            message.consumerId = reader.string();
                            break;
                        }
                    case 9: {
                            message.deviceId = reader.string();
                            break;
                        }
                    case 4: {
                            message.waiterRequest = $root.waiternow.common.OrderProto.WaiterRequestProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 5: {
                            message.menuOrder = $root.waiternow.common.MenuOrderProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 6: {
                            message.status = $root.waiternow.common.OrderProto.StatusProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 8: {
                            message.redundantData = $root.waiternow.common.OrderProto.RedundantDataProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 11: {
                            message.orderNumber = reader.int32();
                            break;
                        }
                    case 12: {
                            message.metadata = $root.waiternow.common.OrderProto.MetadataProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 13: {
                            message.orderTime = $root.waiternow.common.DateTimeProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 18: {
                            message.timeToPrepare = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 16: {
                            message.delivery = $root.waiternow.common.DeliveryProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 17: {
                            message.retriedDelivery = $root.waiternow.common.DeliveryProto.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an OrderProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.OrderProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.OrderProto} OrderProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OrderProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an OrderProto message.
             * @function verify
             * @memberof waiternow.common.OrderProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            OrderProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                var properties = {};
                if (message.id != null && message.hasOwnProperty("id"))
                    if (!$util.isString(message.id))
                        return "id: string expected";
                if (message.creationTime != null && message.hasOwnProperty("creationTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.creationTime);
                    if (error)
                        return "creationTime." + error;
                }
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.lastUpdateTime);
                    if (error)
                        return "lastUpdateTime." + error;
                }
                if (message.pointOfServiceId != null && message.hasOwnProperty("pointOfServiceId"))
                    if (!$util.isString(message.pointOfServiceId))
                        return "pointOfServiceId: string expected";
                if (message.consumerId != null && message.hasOwnProperty("consumerId"))
                    if (!$util.isString(message.consumerId))
                        return "consumerId: string expected";
                if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                    if (!$util.isString(message.deviceId))
                        return "deviceId: string expected";
                if (message.waiterRequest != null && message.hasOwnProperty("waiterRequest")) {
                    properties.orderType = 1;
                    {
                        var error = $root.waiternow.common.OrderProto.WaiterRequestProto.verify(message.waiterRequest);
                        if (error)
                            return "waiterRequest." + error;
                    }
                }
                if (message.menuOrder != null && message.hasOwnProperty("menuOrder")) {
                    if (properties.orderType === 1)
                        return "orderType: multiple values";
                    properties.orderType = 1;
                    {
                        var error = $root.waiternow.common.MenuOrderProto.verify(message.menuOrder);
                        if (error)
                            return "menuOrder." + error;
                    }
                }
                if (message.status != null && message.hasOwnProperty("status")) {
                    var error = $root.waiternow.common.OrderProto.StatusProto.verify(message.status);
                    if (error)
                        return "status." + error;
                }
                if (message.redundantData != null && message.hasOwnProperty("redundantData")) {
                    var error = $root.waiternow.common.OrderProto.RedundantDataProto.verify(message.redundantData);
                    if (error)
                        return "redundantData." + error;
                }
                if (message.orderNumber != null && message.hasOwnProperty("orderNumber"))
                    if (!$util.isInteger(message.orderNumber))
                        return "orderNumber: integer expected";
                if (message.metadata != null && message.hasOwnProperty("metadata")) {
                    var error = $root.waiternow.common.OrderProto.MetadataProto.verify(message.metadata);
                    if (error)
                        return "metadata." + error;
                }
                if (message.orderTime != null && message.hasOwnProperty("orderTime")) {
                    var error = $root.waiternow.common.DateTimeProto.verify(message.orderTime);
                    if (error)
                        return "orderTime." + error;
                }
                if (message.timeToPrepare != null && message.hasOwnProperty("timeToPrepare")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.timeToPrepare);
                    if (error)
                        return "timeToPrepare." + error;
                }
                if (message.delivery != null && message.hasOwnProperty("delivery")) {
                    var error = $root.waiternow.common.DeliveryProto.verify(message.delivery);
                    if (error)
                        return "delivery." + error;
                }
                if (message.retriedDelivery != null && message.hasOwnProperty("retriedDelivery")) {
                    var error = $root.waiternow.common.DeliveryProto.verify(message.retriedDelivery);
                    if (error)
                        return "retriedDelivery." + error;
                }
                return null;
            };

            /**
             * Creates an OrderProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.OrderProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.OrderProto} OrderProto
             */
            OrderProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.OrderProto)
                    return object;
                var message = new $root.waiternow.common.OrderProto();
                if (object.id != null)
                    message.id = String(object.id);
                if (object.creationTime != null) {
                    if (typeof object.creationTime !== "object")
                        throw TypeError(".waiternow.common.OrderProto.creationTime: object expected");
                    message.creationTime = $root.google.protobuf.Timestamp.fromObject(object.creationTime);
                }
                if (object.lastUpdateTime != null) {
                    if (typeof object.lastUpdateTime !== "object")
                        throw TypeError(".waiternow.common.OrderProto.lastUpdateTime: object expected");
                    message.lastUpdateTime = $root.google.protobuf.Timestamp.fromObject(object.lastUpdateTime);
                }
                if (object.pointOfServiceId != null)
                    message.pointOfServiceId = String(object.pointOfServiceId);
                if (object.consumerId != null)
                    message.consumerId = String(object.consumerId);
                if (object.deviceId != null)
                    message.deviceId = String(object.deviceId);
                if (object.waiterRequest != null) {
                    if (typeof object.waiterRequest !== "object")
                        throw TypeError(".waiternow.common.OrderProto.waiterRequest: object expected");
                    message.waiterRequest = $root.waiternow.common.OrderProto.WaiterRequestProto.fromObject(object.waiterRequest);
                }
                if (object.menuOrder != null) {
                    if (typeof object.menuOrder !== "object")
                        throw TypeError(".waiternow.common.OrderProto.menuOrder: object expected");
                    message.menuOrder = $root.waiternow.common.MenuOrderProto.fromObject(object.menuOrder);
                }
                if (object.status != null) {
                    if (typeof object.status !== "object")
                        throw TypeError(".waiternow.common.OrderProto.status: object expected");
                    message.status = $root.waiternow.common.OrderProto.StatusProto.fromObject(object.status);
                }
                if (object.redundantData != null) {
                    if (typeof object.redundantData !== "object")
                        throw TypeError(".waiternow.common.OrderProto.redundantData: object expected");
                    message.redundantData = $root.waiternow.common.OrderProto.RedundantDataProto.fromObject(object.redundantData);
                }
                if (object.orderNumber != null)
                    message.orderNumber = object.orderNumber | 0;
                if (object.metadata != null) {
                    if (typeof object.metadata !== "object")
                        throw TypeError(".waiternow.common.OrderProto.metadata: object expected");
                    message.metadata = $root.waiternow.common.OrderProto.MetadataProto.fromObject(object.metadata);
                }
                if (object.orderTime != null) {
                    if (typeof object.orderTime !== "object")
                        throw TypeError(".waiternow.common.OrderProto.orderTime: object expected");
                    message.orderTime = $root.waiternow.common.DateTimeProto.fromObject(object.orderTime);
                }
                if (object.timeToPrepare != null) {
                    if (typeof object.timeToPrepare !== "object")
                        throw TypeError(".waiternow.common.OrderProto.timeToPrepare: object expected");
                    message.timeToPrepare = $root.google.protobuf.Timestamp.fromObject(object.timeToPrepare);
                }
                if (object.delivery != null) {
                    if (typeof object.delivery !== "object")
                        throw TypeError(".waiternow.common.OrderProto.delivery: object expected");
                    message.delivery = $root.waiternow.common.DeliveryProto.fromObject(object.delivery);
                }
                if (object.retriedDelivery != null) {
                    if (typeof object.retriedDelivery !== "object")
                        throw TypeError(".waiternow.common.OrderProto.retriedDelivery: object expected");
                    message.retriedDelivery = $root.waiternow.common.DeliveryProto.fromObject(object.retriedDelivery);
                }
                return message;
            };

            /**
             * Creates a plain object from an OrderProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.OrderProto
             * @static
             * @param {waiternow.common.OrderProto} message OrderProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            OrderProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.id = "";
                    object.pointOfServiceId = "";
                    object.consumerId = "";
                    object.status = null;
                    object.creationTime = null;
                    object.redundantData = null;
                    object.deviceId = "";
                    object.lastUpdateTime = null;
                    object.orderNumber = 0;
                    object.metadata = null;
                    object.orderTime = null;
                    object.delivery = null;
                    object.retriedDelivery = null;
                    object.timeToPrepare = null;
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                if (message.pointOfServiceId != null && message.hasOwnProperty("pointOfServiceId"))
                    object.pointOfServiceId = message.pointOfServiceId;
                if (message.consumerId != null && message.hasOwnProperty("consumerId"))
                    object.consumerId = message.consumerId;
                if (message.waiterRequest != null && message.hasOwnProperty("waiterRequest")) {
                    object.waiterRequest = $root.waiternow.common.OrderProto.WaiterRequestProto.toObject(message.waiterRequest, options);
                    if (options.oneofs)
                        object.orderType = "waiterRequest";
                }
                if (message.menuOrder != null && message.hasOwnProperty("menuOrder")) {
                    object.menuOrder = $root.waiternow.common.MenuOrderProto.toObject(message.menuOrder, options);
                    if (options.oneofs)
                        object.orderType = "menuOrder";
                }
                if (message.status != null && message.hasOwnProperty("status"))
                    object.status = $root.waiternow.common.OrderProto.StatusProto.toObject(message.status, options);
                if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                    object.creationTime = $root.google.protobuf.Timestamp.toObject(message.creationTime, options);
                if (message.redundantData != null && message.hasOwnProperty("redundantData"))
                    object.redundantData = $root.waiternow.common.OrderProto.RedundantDataProto.toObject(message.redundantData, options);
                if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                    object.deviceId = message.deviceId;
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                    object.lastUpdateTime = $root.google.protobuf.Timestamp.toObject(message.lastUpdateTime, options);
                if (message.orderNumber != null && message.hasOwnProperty("orderNumber"))
                    object.orderNumber = message.orderNumber;
                if (message.metadata != null && message.hasOwnProperty("metadata"))
                    object.metadata = $root.waiternow.common.OrderProto.MetadataProto.toObject(message.metadata, options);
                if (message.orderTime != null && message.hasOwnProperty("orderTime"))
                    object.orderTime = $root.waiternow.common.DateTimeProto.toObject(message.orderTime, options);
                if (message.delivery != null && message.hasOwnProperty("delivery"))
                    object.delivery = $root.waiternow.common.DeliveryProto.toObject(message.delivery, options);
                if (message.retriedDelivery != null && message.hasOwnProperty("retriedDelivery"))
                    object.retriedDelivery = $root.waiternow.common.DeliveryProto.toObject(message.retriedDelivery, options);
                if (message.timeToPrepare != null && message.hasOwnProperty("timeToPrepare"))
                    object.timeToPrepare = $root.google.protobuf.Timestamp.toObject(message.timeToPrepare, options);
                return object;
            };

            /**
             * Converts this OrderProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.OrderProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            OrderProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for OrderProto
             * @function getTypeUrl
             * @memberof waiternow.common.OrderProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            OrderProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.OrderProto";
            };

            OrderProto.WaiterRequestProto = (function() {

                /**
                 * Properties of a WaiterRequestProto.
                 * @memberof waiternow.common.OrderProto
                 * @interface IWaiterRequestProto
                 * @property {waiternow.common.OrderProto.WaiterRequestProto.PredefinedAction|null} [predefinedAction] WaiterRequestProto predefinedAction
                 * @property {string|null} [customMessage] WaiterRequestProto customMessage
                 * @property {waiternow.common.OrderProto.WaiterRequestProto.CheckOption|null} [checkOption] WaiterRequestProto checkOption
                 */

                /**
                 * Constructs a new WaiterRequestProto.
                 * @memberof waiternow.common.OrderProto
                 * @classdesc Represents a WaiterRequestProto.
                 * @implements IWaiterRequestProto
                 * @constructor
                 * @param {waiternow.common.OrderProto.IWaiterRequestProto=} [properties] Properties to set
                 */
                function WaiterRequestProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * WaiterRequestProto predefinedAction.
                 * @member {waiternow.common.OrderProto.WaiterRequestProto.PredefinedAction} predefinedAction
                 * @memberof waiternow.common.OrderProto.WaiterRequestProto
                 * @instance
                 */
                WaiterRequestProto.prototype.predefinedAction = 0;

                /**
                 * WaiterRequestProto customMessage.
                 * @member {string} customMessage
                 * @memberof waiternow.common.OrderProto.WaiterRequestProto
                 * @instance
                 */
                WaiterRequestProto.prototype.customMessage = "";

                /**
                 * WaiterRequestProto checkOption.
                 * @member {waiternow.common.OrderProto.WaiterRequestProto.CheckOption} checkOption
                 * @memberof waiternow.common.OrderProto.WaiterRequestProto
                 * @instance
                 */
                WaiterRequestProto.prototype.checkOption = 0;

                /**
                 * Creates a new WaiterRequestProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.OrderProto.WaiterRequestProto
                 * @static
                 * @param {waiternow.common.OrderProto.IWaiterRequestProto=} [properties] Properties to set
                 * @returns {waiternow.common.OrderProto.WaiterRequestProto} WaiterRequestProto instance
                 */
                WaiterRequestProto.create = function create(properties) {
                    return new WaiterRequestProto(properties);
                };

                /**
                 * Encodes the specified WaiterRequestProto message. Does not implicitly {@link waiternow.common.OrderProto.WaiterRequestProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.OrderProto.WaiterRequestProto
                 * @static
                 * @param {waiternow.common.OrderProto.IWaiterRequestProto} message WaiterRequestProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                WaiterRequestProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.predefinedAction != null && Object.hasOwnProperty.call(message, "predefinedAction"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.predefinedAction);
                    if (message.customMessage != null && Object.hasOwnProperty.call(message, "customMessage"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.customMessage);
                    if (message.checkOption != null && Object.hasOwnProperty.call(message, "checkOption"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.checkOption);
                    return writer;
                };

                /**
                 * Encodes the specified WaiterRequestProto message, length delimited. Does not implicitly {@link waiternow.common.OrderProto.WaiterRequestProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.OrderProto.WaiterRequestProto
                 * @static
                 * @param {waiternow.common.OrderProto.IWaiterRequestProto} message WaiterRequestProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                WaiterRequestProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a WaiterRequestProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.OrderProto.WaiterRequestProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.OrderProto.WaiterRequestProto} WaiterRequestProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                WaiterRequestProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.OrderProto.WaiterRequestProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.predefinedAction = reader.int32();
                                break;
                            }
                        case 2: {
                                message.customMessage = reader.string();
                                break;
                            }
                        case 3: {
                                message.checkOption = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a WaiterRequestProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.OrderProto.WaiterRequestProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.OrderProto.WaiterRequestProto} WaiterRequestProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                WaiterRequestProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a WaiterRequestProto message.
                 * @function verify
                 * @memberof waiternow.common.OrderProto.WaiterRequestProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                WaiterRequestProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.predefinedAction != null && message.hasOwnProperty("predefinedAction"))
                        switch (message.predefinedAction) {
                        default:
                            return "predefinedAction: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                            break;
                        }
                    if (message.customMessage != null && message.hasOwnProperty("customMessage"))
                        if (!$util.isString(message.customMessage))
                            return "customMessage: string expected";
                    if (message.checkOption != null && message.hasOwnProperty("checkOption"))
                        switch (message.checkOption) {
                        default:
                            return "checkOption: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    return null;
                };

                /**
                 * Creates a WaiterRequestProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.OrderProto.WaiterRequestProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.OrderProto.WaiterRequestProto} WaiterRequestProto
                 */
                WaiterRequestProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.OrderProto.WaiterRequestProto)
                        return object;
                    var message = new $root.waiternow.common.OrderProto.WaiterRequestProto();
                    switch (object.predefinedAction) {
                    default:
                        if (typeof object.predefinedAction === "number") {
                            message.predefinedAction = object.predefinedAction;
                            break;
                        }
                        break;
                    case "PREDEFINED_ACTION_UNSPECIFIED":
                    case 0:
                        message.predefinedAction = 0;
                        break;
                    case "CALL_WAITER":
                    case 1:
                        message.predefinedAction = 1;
                        break;
                    case "CHECK":
                    case 2:
                        message.predefinedAction = 2;
                        break;
                    case "CLEAN_TABLE":
                    case 3:
                        message.predefinedAction = 3;
                        break;
                    case "NAPKINGS":
                    case 4:
                        message.predefinedAction = 4;
                        break;
                    case "UTENSILS":
                    case 5:
                        message.predefinedAction = 5;
                        break;
                    }
                    if (object.customMessage != null)
                        message.customMessage = String(object.customMessage);
                    switch (object.checkOption) {
                    default:
                        if (typeof object.checkOption === "number") {
                            message.checkOption = object.checkOption;
                            break;
                        }
                        break;
                    case "CHECK_OPTION_UNSPECIFIED":
                    case 0:
                        message.checkOption = 0;
                        break;
                    case "CREDIT_CARD_PAYMENT":
                    case 1:
                        message.checkOption = 1;
                        break;
                    case "CASH_PAYMENT":
                    case 2:
                        message.checkOption = 2;
                        break;
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a WaiterRequestProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.OrderProto.WaiterRequestProto
                 * @static
                 * @param {waiternow.common.OrderProto.WaiterRequestProto} message WaiterRequestProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                WaiterRequestProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.predefinedAction = options.enums === String ? "PREDEFINED_ACTION_UNSPECIFIED" : 0;
                        object.customMessage = "";
                        object.checkOption = options.enums === String ? "CHECK_OPTION_UNSPECIFIED" : 0;
                    }
                    if (message.predefinedAction != null && message.hasOwnProperty("predefinedAction"))
                        object.predefinedAction = options.enums === String ? $root.waiternow.common.OrderProto.WaiterRequestProto.PredefinedAction[message.predefinedAction] === undefined ? message.predefinedAction : $root.waiternow.common.OrderProto.WaiterRequestProto.PredefinedAction[message.predefinedAction] : message.predefinedAction;
                    if (message.customMessage != null && message.hasOwnProperty("customMessage"))
                        object.customMessage = message.customMessage;
                    if (message.checkOption != null && message.hasOwnProperty("checkOption"))
                        object.checkOption = options.enums === String ? $root.waiternow.common.OrderProto.WaiterRequestProto.CheckOption[message.checkOption] === undefined ? message.checkOption : $root.waiternow.common.OrderProto.WaiterRequestProto.CheckOption[message.checkOption] : message.checkOption;
                    return object;
                };

                /**
                 * Converts this WaiterRequestProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.OrderProto.WaiterRequestProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                WaiterRequestProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for WaiterRequestProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.OrderProto.WaiterRequestProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                WaiterRequestProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.OrderProto.WaiterRequestProto";
                };

                /**
                 * PredefinedAction enum.
                 * @name waiternow.common.OrderProto.WaiterRequestProto.PredefinedAction
                 * @enum {number}
                 * @property {number} PREDEFINED_ACTION_UNSPECIFIED=0 PREDEFINED_ACTION_UNSPECIFIED value
                 * @property {number} CALL_WAITER=1 CALL_WAITER value
                 * @property {number} CHECK=2 CHECK value
                 * @property {number} CLEAN_TABLE=3 CLEAN_TABLE value
                 * @property {number} NAPKINGS=4 NAPKINGS value
                 * @property {number} UTENSILS=5 UTENSILS value
                 */
                WaiterRequestProto.PredefinedAction = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "PREDEFINED_ACTION_UNSPECIFIED"] = 0;
                    values[valuesById[1] = "CALL_WAITER"] = 1;
                    values[valuesById[2] = "CHECK"] = 2;
                    values[valuesById[3] = "CLEAN_TABLE"] = 3;
                    values[valuesById[4] = "NAPKINGS"] = 4;
                    values[valuesById[5] = "UTENSILS"] = 5;
                    return values;
                })();

                /**
                 * CheckOption enum.
                 * @name waiternow.common.OrderProto.WaiterRequestProto.CheckOption
                 * @enum {number}
                 * @property {number} CHECK_OPTION_UNSPECIFIED=0 CHECK_OPTION_UNSPECIFIED value
                 * @property {number} CREDIT_CARD_PAYMENT=1 CREDIT_CARD_PAYMENT value
                 * @property {number} CASH_PAYMENT=2 CASH_PAYMENT value
                 */
                WaiterRequestProto.CheckOption = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "CHECK_OPTION_UNSPECIFIED"] = 0;
                    values[valuesById[1] = "CREDIT_CARD_PAYMENT"] = 1;
                    values[valuesById[2] = "CASH_PAYMENT"] = 2;
                    return values;
                })();

                return WaiterRequestProto;
            })();

            OrderProto.StatusProto = (function() {

                /**
                 * Properties of a StatusProto.
                 * @memberof waiternow.common.OrderProto
                 * @interface IStatusProto
                 * @property {google.protobuf.ITimestamp|null} [received] StatusProto received
                 * @property {google.protobuf.ITimestamp|null} [acked] StatusProto acked
                 * @property {string|null} [ackedByUserId] StatusProto ackedByUserId
                 * @property {google.protobuf.ITimestamp|null} [printed] StatusProto printed
                 * @property {string|null} [printedByUserId] StatusProto printedByUserId
                 * @property {waiternow.common.IPaymentProto|null} [payment] StatusProto payment
                 * @property {google.protobuf.ITimestamp|null} [completed] StatusProto completed
                 * @property {string|null} [completedByUserId] StatusProto completedByUserId
                 */

                /**
                 * Constructs a new StatusProto.
                 * @memberof waiternow.common.OrderProto
                 * @classdesc Represents a StatusProto.
                 * @implements IStatusProto
                 * @constructor
                 * @param {waiternow.common.OrderProto.IStatusProto=} [properties] Properties to set
                 */
                function StatusProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StatusProto received.
                 * @member {google.protobuf.ITimestamp|null|undefined} received
                 * @memberof waiternow.common.OrderProto.StatusProto
                 * @instance
                 */
                StatusProto.prototype.received = null;

                /**
                 * StatusProto acked.
                 * @member {google.protobuf.ITimestamp|null|undefined} acked
                 * @memberof waiternow.common.OrderProto.StatusProto
                 * @instance
                 */
                StatusProto.prototype.acked = null;

                /**
                 * StatusProto ackedByUserId.
                 * @member {string} ackedByUserId
                 * @memberof waiternow.common.OrderProto.StatusProto
                 * @instance
                 */
                StatusProto.prototype.ackedByUserId = "";

                /**
                 * StatusProto printed.
                 * @member {google.protobuf.ITimestamp|null|undefined} printed
                 * @memberof waiternow.common.OrderProto.StatusProto
                 * @instance
                 */
                StatusProto.prototype.printed = null;

                /**
                 * StatusProto printedByUserId.
                 * @member {string} printedByUserId
                 * @memberof waiternow.common.OrderProto.StatusProto
                 * @instance
                 */
                StatusProto.prototype.printedByUserId = "";

                /**
                 * StatusProto payment.
                 * @member {waiternow.common.IPaymentProto|null|undefined} payment
                 * @memberof waiternow.common.OrderProto.StatusProto
                 * @instance
                 */
                StatusProto.prototype.payment = null;

                /**
                 * StatusProto completed.
                 * @member {google.protobuf.ITimestamp|null|undefined} completed
                 * @memberof waiternow.common.OrderProto.StatusProto
                 * @instance
                 */
                StatusProto.prototype.completed = null;

                /**
                 * StatusProto completedByUserId.
                 * @member {string} completedByUserId
                 * @memberof waiternow.common.OrderProto.StatusProto
                 * @instance
                 */
                StatusProto.prototype.completedByUserId = "";

                /**
                 * Creates a new StatusProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.OrderProto.StatusProto
                 * @static
                 * @param {waiternow.common.OrderProto.IStatusProto=} [properties] Properties to set
                 * @returns {waiternow.common.OrderProto.StatusProto} StatusProto instance
                 */
                StatusProto.create = function create(properties) {
                    return new StatusProto(properties);
                };

                /**
                 * Encodes the specified StatusProto message. Does not implicitly {@link waiternow.common.OrderProto.StatusProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.OrderProto.StatusProto
                 * @static
                 * @param {waiternow.common.OrderProto.IStatusProto} message StatusProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StatusProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.received != null && Object.hasOwnProperty.call(message, "received"))
                        $root.google.protobuf.Timestamp.encode(message.received, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.acked != null && Object.hasOwnProperty.call(message, "acked"))
                        $root.google.protobuf.Timestamp.encode(message.acked, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.ackedByUserId != null && Object.hasOwnProperty.call(message, "ackedByUserId"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.ackedByUserId);
                    if (message.printed != null && Object.hasOwnProperty.call(message, "printed"))
                        $root.google.protobuf.Timestamp.encode(message.printed, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.printedByUserId != null && Object.hasOwnProperty.call(message, "printedByUserId"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.printedByUserId);
                    if (message.payment != null && Object.hasOwnProperty.call(message, "payment"))
                        $root.waiternow.common.PaymentProto.encode(message.payment, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.completed != null && Object.hasOwnProperty.call(message, "completed"))
                        $root.google.protobuf.Timestamp.encode(message.completed, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    if (message.completedByUserId != null && Object.hasOwnProperty.call(message, "completedByUserId"))
                        writer.uint32(/* id 8, wireType 2 =*/66).string(message.completedByUserId);
                    return writer;
                };

                /**
                 * Encodes the specified StatusProto message, length delimited. Does not implicitly {@link waiternow.common.OrderProto.StatusProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.OrderProto.StatusProto
                 * @static
                 * @param {waiternow.common.OrderProto.IStatusProto} message StatusProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StatusProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a StatusProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.OrderProto.StatusProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.OrderProto.StatusProto} StatusProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StatusProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.OrderProto.StatusProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.received = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.acked = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.ackedByUserId = reader.string();
                                break;
                            }
                        case 4: {
                                message.printed = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            }
                        case 5: {
                                message.printedByUserId = reader.string();
                                break;
                            }
                        case 6: {
                                message.payment = $root.waiternow.common.PaymentProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 7: {
                                message.completed = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            }
                        case 8: {
                                message.completedByUserId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a StatusProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.OrderProto.StatusProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.OrderProto.StatusProto} StatusProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StatusProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StatusProto message.
                 * @function verify
                 * @memberof waiternow.common.OrderProto.StatusProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StatusProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.received != null && message.hasOwnProperty("received")) {
                        var error = $root.google.protobuf.Timestamp.verify(message.received);
                        if (error)
                            return "received." + error;
                    }
                    if (message.acked != null && message.hasOwnProperty("acked")) {
                        var error = $root.google.protobuf.Timestamp.verify(message.acked);
                        if (error)
                            return "acked." + error;
                    }
                    if (message.ackedByUserId != null && message.hasOwnProperty("ackedByUserId"))
                        if (!$util.isString(message.ackedByUserId))
                            return "ackedByUserId: string expected";
                    if (message.printed != null && message.hasOwnProperty("printed")) {
                        var error = $root.google.protobuf.Timestamp.verify(message.printed);
                        if (error)
                            return "printed." + error;
                    }
                    if (message.printedByUserId != null && message.hasOwnProperty("printedByUserId"))
                        if (!$util.isString(message.printedByUserId))
                            return "printedByUserId: string expected";
                    if (message.payment != null && message.hasOwnProperty("payment")) {
                        var error = $root.waiternow.common.PaymentProto.verify(message.payment);
                        if (error)
                            return "payment." + error;
                    }
                    if (message.completed != null && message.hasOwnProperty("completed")) {
                        var error = $root.google.protobuf.Timestamp.verify(message.completed);
                        if (error)
                            return "completed." + error;
                    }
                    if (message.completedByUserId != null && message.hasOwnProperty("completedByUserId"))
                        if (!$util.isString(message.completedByUserId))
                            return "completedByUserId: string expected";
                    return null;
                };

                /**
                 * Creates a StatusProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.OrderProto.StatusProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.OrderProto.StatusProto} StatusProto
                 */
                StatusProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.OrderProto.StatusProto)
                        return object;
                    var message = new $root.waiternow.common.OrderProto.StatusProto();
                    if (object.received != null) {
                        if (typeof object.received !== "object")
                            throw TypeError(".waiternow.common.OrderProto.StatusProto.received: object expected");
                        message.received = $root.google.protobuf.Timestamp.fromObject(object.received);
                    }
                    if (object.acked != null) {
                        if (typeof object.acked !== "object")
                            throw TypeError(".waiternow.common.OrderProto.StatusProto.acked: object expected");
                        message.acked = $root.google.protobuf.Timestamp.fromObject(object.acked);
                    }
                    if (object.ackedByUserId != null)
                        message.ackedByUserId = String(object.ackedByUserId);
                    if (object.printed != null) {
                        if (typeof object.printed !== "object")
                            throw TypeError(".waiternow.common.OrderProto.StatusProto.printed: object expected");
                        message.printed = $root.google.protobuf.Timestamp.fromObject(object.printed);
                    }
                    if (object.printedByUserId != null)
                        message.printedByUserId = String(object.printedByUserId);
                    if (object.payment != null) {
                        if (typeof object.payment !== "object")
                            throw TypeError(".waiternow.common.OrderProto.StatusProto.payment: object expected");
                        message.payment = $root.waiternow.common.PaymentProto.fromObject(object.payment);
                    }
                    if (object.completed != null) {
                        if (typeof object.completed !== "object")
                            throw TypeError(".waiternow.common.OrderProto.StatusProto.completed: object expected");
                        message.completed = $root.google.protobuf.Timestamp.fromObject(object.completed);
                    }
                    if (object.completedByUserId != null)
                        message.completedByUserId = String(object.completedByUserId);
                    return message;
                };

                /**
                 * Creates a plain object from a StatusProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.OrderProto.StatusProto
                 * @static
                 * @param {waiternow.common.OrderProto.StatusProto} message StatusProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StatusProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.received = null;
                        object.acked = null;
                        object.ackedByUserId = "";
                        object.printed = null;
                        object.printedByUserId = "";
                        object.payment = null;
                        object.completed = null;
                        object.completedByUserId = "";
                    }
                    if (message.received != null && message.hasOwnProperty("received"))
                        object.received = $root.google.protobuf.Timestamp.toObject(message.received, options);
                    if (message.acked != null && message.hasOwnProperty("acked"))
                        object.acked = $root.google.protobuf.Timestamp.toObject(message.acked, options);
                    if (message.ackedByUserId != null && message.hasOwnProperty("ackedByUserId"))
                        object.ackedByUserId = message.ackedByUserId;
                    if (message.printed != null && message.hasOwnProperty("printed"))
                        object.printed = $root.google.protobuf.Timestamp.toObject(message.printed, options);
                    if (message.printedByUserId != null && message.hasOwnProperty("printedByUserId"))
                        object.printedByUserId = message.printedByUserId;
                    if (message.payment != null && message.hasOwnProperty("payment"))
                        object.payment = $root.waiternow.common.PaymentProto.toObject(message.payment, options);
                    if (message.completed != null && message.hasOwnProperty("completed"))
                        object.completed = $root.google.protobuf.Timestamp.toObject(message.completed, options);
                    if (message.completedByUserId != null && message.hasOwnProperty("completedByUserId"))
                        object.completedByUserId = message.completedByUserId;
                    return object;
                };

                /**
                 * Converts this StatusProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.OrderProto.StatusProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StatusProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for StatusProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.OrderProto.StatusProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                StatusProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.OrderProto.StatusProto";
                };

                return StatusProto;
            })();

            OrderProto.RedundantDataProto = (function() {

                /**
                 * Properties of a RedundantDataProto.
                 * @memberof waiternow.common.OrderProto
                 * @interface IRedundantDataProto
                 * @property {string|null} [locationId] RedundantDataProto locationId
                 * @property {string|null} [businessId] RedundantDataProto businessId
                 * @property {string|null} [pointOfServiceFriendlyName] RedundantDataProto pointOfServiceFriendlyName
                 * @property {string|null} [consumerName] RedundantDataProto consumerName
                 * @property {waiternow.common.Language|null} [language] RedundantDataProto language
                 * @property {string|null} [businessName] RedundantDataProto businessName
                 * @property {waiternow.common.IAddressProto|null} [locationAddress] RedundantDataProto locationAddress
                 * @property {boolean|null} [isOnlinePickup] RedundantDataProto isOnlinePickup
                 * @property {boolean|null} [isOnsitePickup] RedundantDataProto isOnsitePickup
                 * @property {boolean|null} [isDelivery] RedundantDataProto isDelivery
                 * @property {string|null} [locationName] RedundantDataProto locationName
                 * @property {waiternow.common.IPhoneNumberProto|null} [locationPhoneNumber] RedundantDataProto locationPhoneNumber
                 * @property {boolean|null} [isCompletedStatusExpected] RedundantDataProto isCompletedStatusExpected
                 * @property {string|null} [locationTimeZone] RedundantDataProto locationTimeZone
                 */

                /**
                 * Constructs a new RedundantDataProto.
                 * @memberof waiternow.common.OrderProto
                 * @classdesc Represents a RedundantDataProto.
                 * @implements IRedundantDataProto
                 * @constructor
                 * @param {waiternow.common.OrderProto.IRedundantDataProto=} [properties] Properties to set
                 */
                function RedundantDataProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * RedundantDataProto locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.OrderProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.locationId = "";

                /**
                 * RedundantDataProto businessId.
                 * @member {string} businessId
                 * @memberof waiternow.common.OrderProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.businessId = "";

                /**
                 * RedundantDataProto pointOfServiceFriendlyName.
                 * @member {string} pointOfServiceFriendlyName
                 * @memberof waiternow.common.OrderProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.pointOfServiceFriendlyName = "";

                /**
                 * RedundantDataProto consumerName.
                 * @member {string} consumerName
                 * @memberof waiternow.common.OrderProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.consumerName = "";

                /**
                 * RedundantDataProto language.
                 * @member {waiternow.common.Language} language
                 * @memberof waiternow.common.OrderProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.language = 0;

                /**
                 * RedundantDataProto businessName.
                 * @member {string} businessName
                 * @memberof waiternow.common.OrderProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.businessName = "";

                /**
                 * RedundantDataProto locationAddress.
                 * @member {waiternow.common.IAddressProto|null|undefined} locationAddress
                 * @memberof waiternow.common.OrderProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.locationAddress = null;

                /**
                 * RedundantDataProto isOnlinePickup.
                 * @member {boolean} isOnlinePickup
                 * @memberof waiternow.common.OrderProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.isOnlinePickup = false;

                /**
                 * RedundantDataProto isOnsitePickup.
                 * @member {boolean} isOnsitePickup
                 * @memberof waiternow.common.OrderProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.isOnsitePickup = false;

                /**
                 * RedundantDataProto isDelivery.
                 * @member {boolean} isDelivery
                 * @memberof waiternow.common.OrderProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.isDelivery = false;

                /**
                 * RedundantDataProto locationName.
                 * @member {string} locationName
                 * @memberof waiternow.common.OrderProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.locationName = "";

                /**
                 * RedundantDataProto locationPhoneNumber.
                 * @member {waiternow.common.IPhoneNumberProto|null|undefined} locationPhoneNumber
                 * @memberof waiternow.common.OrderProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.locationPhoneNumber = null;

                /**
                 * RedundantDataProto isCompletedStatusExpected.
                 * @member {boolean} isCompletedStatusExpected
                 * @memberof waiternow.common.OrderProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.isCompletedStatusExpected = false;

                /**
                 * RedundantDataProto locationTimeZone.
                 * @member {string} locationTimeZone
                 * @memberof waiternow.common.OrderProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.locationTimeZone = "";

                /**
                 * Creates a new RedundantDataProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.OrderProto.RedundantDataProto
                 * @static
                 * @param {waiternow.common.OrderProto.IRedundantDataProto=} [properties] Properties to set
                 * @returns {waiternow.common.OrderProto.RedundantDataProto} RedundantDataProto instance
                 */
                RedundantDataProto.create = function create(properties) {
                    return new RedundantDataProto(properties);
                };

                /**
                 * Encodes the specified RedundantDataProto message. Does not implicitly {@link waiternow.common.OrderProto.RedundantDataProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.OrderProto.RedundantDataProto
                 * @static
                 * @param {waiternow.common.OrderProto.IRedundantDataProto} message RedundantDataProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RedundantDataProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.businessId);
                    if (message.pointOfServiceFriendlyName != null && Object.hasOwnProperty.call(message, "pointOfServiceFriendlyName"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.pointOfServiceFriendlyName);
                    if (message.consumerName != null && Object.hasOwnProperty.call(message, "consumerName"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.consumerName);
                    if (message.language != null && Object.hasOwnProperty.call(message, "language"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int32(message.language);
                    if (message.businessName != null && Object.hasOwnProperty.call(message, "businessName"))
                        writer.uint32(/* id 6, wireType 2 =*/50).string(message.businessName);
                    if (message.locationAddress != null && Object.hasOwnProperty.call(message, "locationAddress"))
                        $root.waiternow.common.AddressProto.encode(message.locationAddress, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    if (message.isOnlinePickup != null && Object.hasOwnProperty.call(message, "isOnlinePickup"))
                        writer.uint32(/* id 8, wireType 0 =*/64).bool(message.isOnlinePickup);
                    if (message.isOnsitePickup != null && Object.hasOwnProperty.call(message, "isOnsitePickup"))
                        writer.uint32(/* id 9, wireType 0 =*/72).bool(message.isOnsitePickup);
                    if (message.isDelivery != null && Object.hasOwnProperty.call(message, "isDelivery"))
                        writer.uint32(/* id 10, wireType 0 =*/80).bool(message.isDelivery);
                    if (message.locationName != null && Object.hasOwnProperty.call(message, "locationName"))
                        writer.uint32(/* id 11, wireType 2 =*/90).string(message.locationName);
                    if (message.locationPhoneNumber != null && Object.hasOwnProperty.call(message, "locationPhoneNumber"))
                        $root.waiternow.common.PhoneNumberProto.encode(message.locationPhoneNumber, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                    if (message.isCompletedStatusExpected != null && Object.hasOwnProperty.call(message, "isCompletedStatusExpected"))
                        writer.uint32(/* id 13, wireType 0 =*/104).bool(message.isCompletedStatusExpected);
                    if (message.locationTimeZone != null && Object.hasOwnProperty.call(message, "locationTimeZone"))
                        writer.uint32(/* id 14, wireType 2 =*/114).string(message.locationTimeZone);
                    return writer;
                };

                /**
                 * Encodes the specified RedundantDataProto message, length delimited. Does not implicitly {@link waiternow.common.OrderProto.RedundantDataProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.OrderProto.RedundantDataProto
                 * @static
                 * @param {waiternow.common.OrderProto.IRedundantDataProto} message RedundantDataProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RedundantDataProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a RedundantDataProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.OrderProto.RedundantDataProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.OrderProto.RedundantDataProto} RedundantDataProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RedundantDataProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.OrderProto.RedundantDataProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 2: {
                                message.businessId = reader.string();
                                break;
                            }
                        case 3: {
                                message.pointOfServiceFriendlyName = reader.string();
                                break;
                            }
                        case 4: {
                                message.consumerName = reader.string();
                                break;
                            }
                        case 5: {
                                message.language = reader.int32();
                                break;
                            }
                        case 6: {
                                message.businessName = reader.string();
                                break;
                            }
                        case 7: {
                                message.locationAddress = $root.waiternow.common.AddressProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 8: {
                                message.isOnlinePickup = reader.bool();
                                break;
                            }
                        case 9: {
                                message.isOnsitePickup = reader.bool();
                                break;
                            }
                        case 10: {
                                message.isDelivery = reader.bool();
                                break;
                            }
                        case 11: {
                                message.locationName = reader.string();
                                break;
                            }
                        case 12: {
                                message.locationPhoneNumber = $root.waiternow.common.PhoneNumberProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 13: {
                                message.isCompletedStatusExpected = reader.bool();
                                break;
                            }
                        case 14: {
                                message.locationTimeZone = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a RedundantDataProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.OrderProto.RedundantDataProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.OrderProto.RedundantDataProto} RedundantDataProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RedundantDataProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a RedundantDataProto message.
                 * @function verify
                 * @memberof waiternow.common.OrderProto.RedundantDataProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                RedundantDataProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    if (message.businessId != null && message.hasOwnProperty("businessId"))
                        if (!$util.isString(message.businessId))
                            return "businessId: string expected";
                    if (message.pointOfServiceFriendlyName != null && message.hasOwnProperty("pointOfServiceFriendlyName"))
                        if (!$util.isString(message.pointOfServiceFriendlyName))
                            return "pointOfServiceFriendlyName: string expected";
                    if (message.consumerName != null && message.hasOwnProperty("consumerName"))
                        if (!$util.isString(message.consumerName))
                            return "consumerName: string expected";
                    if (message.language != null && message.hasOwnProperty("language"))
                        switch (message.language) {
                        default:
                            return "language: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.businessName != null && message.hasOwnProperty("businessName"))
                        if (!$util.isString(message.businessName))
                            return "businessName: string expected";
                    if (message.locationAddress != null && message.hasOwnProperty("locationAddress")) {
                        var error = $root.waiternow.common.AddressProto.verify(message.locationAddress);
                        if (error)
                            return "locationAddress." + error;
                    }
                    if (message.isOnlinePickup != null && message.hasOwnProperty("isOnlinePickup"))
                        if (typeof message.isOnlinePickup !== "boolean")
                            return "isOnlinePickup: boolean expected";
                    if (message.isOnsitePickup != null && message.hasOwnProperty("isOnsitePickup"))
                        if (typeof message.isOnsitePickup !== "boolean")
                            return "isOnsitePickup: boolean expected";
                    if (message.isDelivery != null && message.hasOwnProperty("isDelivery"))
                        if (typeof message.isDelivery !== "boolean")
                            return "isDelivery: boolean expected";
                    if (message.locationName != null && message.hasOwnProperty("locationName"))
                        if (!$util.isString(message.locationName))
                            return "locationName: string expected";
                    if (message.locationPhoneNumber != null && message.hasOwnProperty("locationPhoneNumber")) {
                        var error = $root.waiternow.common.PhoneNumberProto.verify(message.locationPhoneNumber);
                        if (error)
                            return "locationPhoneNumber." + error;
                    }
                    if (message.isCompletedStatusExpected != null && message.hasOwnProperty("isCompletedStatusExpected"))
                        if (typeof message.isCompletedStatusExpected !== "boolean")
                            return "isCompletedStatusExpected: boolean expected";
                    if (message.locationTimeZone != null && message.hasOwnProperty("locationTimeZone"))
                        if (!$util.isString(message.locationTimeZone))
                            return "locationTimeZone: string expected";
                    return null;
                };

                /**
                 * Creates a RedundantDataProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.OrderProto.RedundantDataProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.OrderProto.RedundantDataProto} RedundantDataProto
                 */
                RedundantDataProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.OrderProto.RedundantDataProto)
                        return object;
                    var message = new $root.waiternow.common.OrderProto.RedundantDataProto();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    if (object.businessId != null)
                        message.businessId = String(object.businessId);
                    if (object.pointOfServiceFriendlyName != null)
                        message.pointOfServiceFriendlyName = String(object.pointOfServiceFriendlyName);
                    if (object.consumerName != null)
                        message.consumerName = String(object.consumerName);
                    switch (object.language) {
                    default:
                        if (typeof object.language === "number") {
                            message.language = object.language;
                            break;
                        }
                        break;
                    case "LANGUAGE_UNSPECIFIED":
                    case 0:
                        message.language = 0;
                        break;
                    case "ENGLISH":
                    case 1:
                        message.language = 1;
                        break;
                    case "SPANISH":
                    case 2:
                        message.language = 2;
                        break;
                    }
                    if (object.businessName != null)
                        message.businessName = String(object.businessName);
                    if (object.locationAddress != null) {
                        if (typeof object.locationAddress !== "object")
                            throw TypeError(".waiternow.common.OrderProto.RedundantDataProto.locationAddress: object expected");
                        message.locationAddress = $root.waiternow.common.AddressProto.fromObject(object.locationAddress);
                    }
                    if (object.isOnlinePickup != null)
                        message.isOnlinePickup = Boolean(object.isOnlinePickup);
                    if (object.isOnsitePickup != null)
                        message.isOnsitePickup = Boolean(object.isOnsitePickup);
                    if (object.isDelivery != null)
                        message.isDelivery = Boolean(object.isDelivery);
                    if (object.locationName != null)
                        message.locationName = String(object.locationName);
                    if (object.locationPhoneNumber != null) {
                        if (typeof object.locationPhoneNumber !== "object")
                            throw TypeError(".waiternow.common.OrderProto.RedundantDataProto.locationPhoneNumber: object expected");
                        message.locationPhoneNumber = $root.waiternow.common.PhoneNumberProto.fromObject(object.locationPhoneNumber);
                    }
                    if (object.isCompletedStatusExpected != null)
                        message.isCompletedStatusExpected = Boolean(object.isCompletedStatusExpected);
                    if (object.locationTimeZone != null)
                        message.locationTimeZone = String(object.locationTimeZone);
                    return message;
                };

                /**
                 * Creates a plain object from a RedundantDataProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.OrderProto.RedundantDataProto
                 * @static
                 * @param {waiternow.common.OrderProto.RedundantDataProto} message RedundantDataProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                RedundantDataProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.locationId = "";
                        object.businessId = "";
                        object.pointOfServiceFriendlyName = "";
                        object.consumerName = "";
                        object.language = options.enums === String ? "LANGUAGE_UNSPECIFIED" : 0;
                        object.businessName = "";
                        object.locationAddress = null;
                        object.isOnlinePickup = false;
                        object.isOnsitePickup = false;
                        object.isDelivery = false;
                        object.locationName = "";
                        object.locationPhoneNumber = null;
                        object.isCompletedStatusExpected = false;
                        object.locationTimeZone = "";
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    if (message.businessId != null && message.hasOwnProperty("businessId"))
                        object.businessId = message.businessId;
                    if (message.pointOfServiceFriendlyName != null && message.hasOwnProperty("pointOfServiceFriendlyName"))
                        object.pointOfServiceFriendlyName = message.pointOfServiceFriendlyName;
                    if (message.consumerName != null && message.hasOwnProperty("consumerName"))
                        object.consumerName = message.consumerName;
                    if (message.language != null && message.hasOwnProperty("language"))
                        object.language = options.enums === String ? $root.waiternow.common.Language[message.language] === undefined ? message.language : $root.waiternow.common.Language[message.language] : message.language;
                    if (message.businessName != null && message.hasOwnProperty("businessName"))
                        object.businessName = message.businessName;
                    if (message.locationAddress != null && message.hasOwnProperty("locationAddress"))
                        object.locationAddress = $root.waiternow.common.AddressProto.toObject(message.locationAddress, options);
                    if (message.isOnlinePickup != null && message.hasOwnProperty("isOnlinePickup"))
                        object.isOnlinePickup = message.isOnlinePickup;
                    if (message.isOnsitePickup != null && message.hasOwnProperty("isOnsitePickup"))
                        object.isOnsitePickup = message.isOnsitePickup;
                    if (message.isDelivery != null && message.hasOwnProperty("isDelivery"))
                        object.isDelivery = message.isDelivery;
                    if (message.locationName != null && message.hasOwnProperty("locationName"))
                        object.locationName = message.locationName;
                    if (message.locationPhoneNumber != null && message.hasOwnProperty("locationPhoneNumber"))
                        object.locationPhoneNumber = $root.waiternow.common.PhoneNumberProto.toObject(message.locationPhoneNumber, options);
                    if (message.isCompletedStatusExpected != null && message.hasOwnProperty("isCompletedStatusExpected"))
                        object.isCompletedStatusExpected = message.isCompletedStatusExpected;
                    if (message.locationTimeZone != null && message.hasOwnProperty("locationTimeZone"))
                        object.locationTimeZone = message.locationTimeZone;
                    return object;
                };

                /**
                 * Converts this RedundantDataProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.OrderProto.RedundantDataProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                RedundantDataProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for RedundantDataProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.OrderProto.RedundantDataProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                RedundantDataProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.OrderProto.RedundantDataProto";
                };

                return RedundantDataProto;
            })();

            OrderProto.MetadataProto = (function() {

                /**
                 * Properties of a MetadataProto.
                 * @memberof waiternow.common.OrderProto
                 * @interface IMetadataProto
                 * @property {boolean|null} [isStressTest] MetadataProto isStressTest
                 * @property {boolean|null} [emulatePrinter] MetadataProto emulatePrinter
                 */

                /**
                 * Constructs a new MetadataProto.
                 * @memberof waiternow.common.OrderProto
                 * @classdesc Represents a MetadataProto.
                 * @implements IMetadataProto
                 * @constructor
                 * @param {waiternow.common.OrderProto.IMetadataProto=} [properties] Properties to set
                 */
                function MetadataProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * MetadataProto isStressTest.
                 * @member {boolean} isStressTest
                 * @memberof waiternow.common.OrderProto.MetadataProto
                 * @instance
                 */
                MetadataProto.prototype.isStressTest = false;

                /**
                 * MetadataProto emulatePrinter.
                 * @member {boolean} emulatePrinter
                 * @memberof waiternow.common.OrderProto.MetadataProto
                 * @instance
                 */
                MetadataProto.prototype.emulatePrinter = false;

                /**
                 * Creates a new MetadataProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.OrderProto.MetadataProto
                 * @static
                 * @param {waiternow.common.OrderProto.IMetadataProto=} [properties] Properties to set
                 * @returns {waiternow.common.OrderProto.MetadataProto} MetadataProto instance
                 */
                MetadataProto.create = function create(properties) {
                    return new MetadataProto(properties);
                };

                /**
                 * Encodes the specified MetadataProto message. Does not implicitly {@link waiternow.common.OrderProto.MetadataProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.OrderProto.MetadataProto
                 * @static
                 * @param {waiternow.common.OrderProto.IMetadataProto} message MetadataProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MetadataProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.isStressTest != null && Object.hasOwnProperty.call(message, "isStressTest"))
                        writer.uint32(/* id 1, wireType 0 =*/8).bool(message.isStressTest);
                    if (message.emulatePrinter != null && Object.hasOwnProperty.call(message, "emulatePrinter"))
                        writer.uint32(/* id 2, wireType 0 =*/16).bool(message.emulatePrinter);
                    return writer;
                };

                /**
                 * Encodes the specified MetadataProto message, length delimited. Does not implicitly {@link waiternow.common.OrderProto.MetadataProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.OrderProto.MetadataProto
                 * @static
                 * @param {waiternow.common.OrderProto.IMetadataProto} message MetadataProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MetadataProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a MetadataProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.OrderProto.MetadataProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.OrderProto.MetadataProto} MetadataProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MetadataProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.OrderProto.MetadataProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.isStressTest = reader.bool();
                                break;
                            }
                        case 2: {
                                message.emulatePrinter = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a MetadataProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.OrderProto.MetadataProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.OrderProto.MetadataProto} MetadataProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MetadataProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a MetadataProto message.
                 * @function verify
                 * @memberof waiternow.common.OrderProto.MetadataProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                MetadataProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.isStressTest != null && message.hasOwnProperty("isStressTest"))
                        if (typeof message.isStressTest !== "boolean")
                            return "isStressTest: boolean expected";
                    if (message.emulatePrinter != null && message.hasOwnProperty("emulatePrinter"))
                        if (typeof message.emulatePrinter !== "boolean")
                            return "emulatePrinter: boolean expected";
                    return null;
                };

                /**
                 * Creates a MetadataProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.OrderProto.MetadataProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.OrderProto.MetadataProto} MetadataProto
                 */
                MetadataProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.OrderProto.MetadataProto)
                        return object;
                    var message = new $root.waiternow.common.OrderProto.MetadataProto();
                    if (object.isStressTest != null)
                        message.isStressTest = Boolean(object.isStressTest);
                    if (object.emulatePrinter != null)
                        message.emulatePrinter = Boolean(object.emulatePrinter);
                    return message;
                };

                /**
                 * Creates a plain object from a MetadataProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.OrderProto.MetadataProto
                 * @static
                 * @param {waiternow.common.OrderProto.MetadataProto} message MetadataProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                MetadataProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.isStressTest = false;
                        object.emulatePrinter = false;
                    }
                    if (message.isStressTest != null && message.hasOwnProperty("isStressTest"))
                        object.isStressTest = message.isStressTest;
                    if (message.emulatePrinter != null && message.hasOwnProperty("emulatePrinter"))
                        object.emulatePrinter = message.emulatePrinter;
                    return object;
                };

                /**
                 * Converts this MetadataProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.OrderProto.MetadataProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                MetadataProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for MetadataProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.OrderProto.MetadataProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                MetadataProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.OrderProto.MetadataProto";
                };

                return MetadataProto;
            })();

            return OrderProto;
        })();

        common.OrdersProto = (function() {

            /**
             * Properties of an OrdersProto.
             * @memberof waiternow.common
             * @interface IOrdersProto
             * @property {Array.<waiternow.common.IOrderProto>|null} [orders] OrdersProto orders
             * @property {string|null} [continuationToken] OrdersProto continuationToken
             */

            /**
             * Constructs a new OrdersProto.
             * @memberof waiternow.common
             * @classdesc Represents an OrdersProto.
             * @implements IOrdersProto
             * @constructor
             * @param {waiternow.common.IOrdersProto=} [properties] Properties to set
             */
            function OrdersProto(properties) {
                this.orders = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * OrdersProto orders.
             * @member {Array.<waiternow.common.IOrderProto>} orders
             * @memberof waiternow.common.OrdersProto
             * @instance
             */
            OrdersProto.prototype.orders = $util.emptyArray;

            /**
             * OrdersProto continuationToken.
             * @member {string} continuationToken
             * @memberof waiternow.common.OrdersProto
             * @instance
             */
            OrdersProto.prototype.continuationToken = "";

            /**
             * Creates a new OrdersProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.OrdersProto
             * @static
             * @param {waiternow.common.IOrdersProto=} [properties] Properties to set
             * @returns {waiternow.common.OrdersProto} OrdersProto instance
             */
            OrdersProto.create = function create(properties) {
                return new OrdersProto(properties);
            };

            /**
             * Encodes the specified OrdersProto message. Does not implicitly {@link waiternow.common.OrdersProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.OrdersProto
             * @static
             * @param {waiternow.common.IOrdersProto} message OrdersProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OrdersProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.orders != null && message.orders.length)
                    for (var i = 0; i < message.orders.length; ++i)
                        $root.waiternow.common.OrderProto.encode(message.orders[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.continuationToken);
                return writer;
            };

            /**
             * Encodes the specified OrdersProto message, length delimited. Does not implicitly {@link waiternow.common.OrdersProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.OrdersProto
             * @static
             * @param {waiternow.common.IOrdersProto} message OrdersProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OrdersProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an OrdersProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.OrdersProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.OrdersProto} OrdersProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OrdersProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.OrdersProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            if (!(message.orders && message.orders.length))
                                message.orders = [];
                            message.orders.push($root.waiternow.common.OrderProto.decode(reader, reader.uint32()));
                            break;
                        }
                    case 2: {
                            message.continuationToken = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an OrdersProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.OrdersProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.OrdersProto} OrdersProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OrdersProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an OrdersProto message.
             * @function verify
             * @memberof waiternow.common.OrdersProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            OrdersProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.orders != null && message.hasOwnProperty("orders")) {
                    if (!Array.isArray(message.orders))
                        return "orders: array expected";
                    for (var i = 0; i < message.orders.length; ++i) {
                        var error = $root.waiternow.common.OrderProto.verify(message.orders[i]);
                        if (error)
                            return "orders." + error;
                    }
                }
                if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                    if (!$util.isString(message.continuationToken))
                        return "continuationToken: string expected";
                return null;
            };

            /**
             * Creates an OrdersProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.OrdersProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.OrdersProto} OrdersProto
             */
            OrdersProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.OrdersProto)
                    return object;
                var message = new $root.waiternow.common.OrdersProto();
                if (object.orders) {
                    if (!Array.isArray(object.orders))
                        throw TypeError(".waiternow.common.OrdersProto.orders: array expected");
                    message.orders = [];
                    for (var i = 0; i < object.orders.length; ++i) {
                        if (typeof object.orders[i] !== "object")
                            throw TypeError(".waiternow.common.OrdersProto.orders: object expected");
                        message.orders[i] = $root.waiternow.common.OrderProto.fromObject(object.orders[i]);
                    }
                }
                if (object.continuationToken != null)
                    message.continuationToken = String(object.continuationToken);
                return message;
            };

            /**
             * Creates a plain object from an OrdersProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.OrdersProto
             * @static
             * @param {waiternow.common.OrdersProto} message OrdersProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            OrdersProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.orders = [];
                if (options.defaults)
                    object.continuationToken = "";
                if (message.orders && message.orders.length) {
                    object.orders = [];
                    for (var j = 0; j < message.orders.length; ++j)
                        object.orders[j] = $root.waiternow.common.OrderProto.toObject(message.orders[j], options);
                }
                if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                    object.continuationToken = message.continuationToken;
                return object;
            };

            /**
             * Converts this OrdersProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.OrdersProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            OrdersProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for OrdersProto
             * @function getTypeUrl
             * @memberof waiternow.common.OrdersProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            OrdersProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.OrdersProto";
            };

            return OrdersProto;
        })();

        common.OrderSplitByStationProto = (function() {

            /**
             * Properties of an OrderSplitByStationProto.
             * @memberof waiternow.common
             * @interface IOrderSplitByStationProto
             * @property {Array.<waiternow.common.OrderSplitByStationProto.IOrderPartProto>|null} [orderParts] OrderSplitByStationProto orderParts
             */

            /**
             * Constructs a new OrderSplitByStationProto.
             * @memberof waiternow.common
             * @classdesc Represents an OrderSplitByStationProto.
             * @implements IOrderSplitByStationProto
             * @constructor
             * @param {waiternow.common.IOrderSplitByStationProto=} [properties] Properties to set
             */
            function OrderSplitByStationProto(properties) {
                this.orderParts = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * OrderSplitByStationProto orderParts.
             * @member {Array.<waiternow.common.OrderSplitByStationProto.IOrderPartProto>} orderParts
             * @memberof waiternow.common.OrderSplitByStationProto
             * @instance
             */
            OrderSplitByStationProto.prototype.orderParts = $util.emptyArray;

            /**
             * Creates a new OrderSplitByStationProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.OrderSplitByStationProto
             * @static
             * @param {waiternow.common.IOrderSplitByStationProto=} [properties] Properties to set
             * @returns {waiternow.common.OrderSplitByStationProto} OrderSplitByStationProto instance
             */
            OrderSplitByStationProto.create = function create(properties) {
                return new OrderSplitByStationProto(properties);
            };

            /**
             * Encodes the specified OrderSplitByStationProto message. Does not implicitly {@link waiternow.common.OrderSplitByStationProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.OrderSplitByStationProto
             * @static
             * @param {waiternow.common.IOrderSplitByStationProto} message OrderSplitByStationProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OrderSplitByStationProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.orderParts != null && message.orderParts.length)
                    for (var i = 0; i < message.orderParts.length; ++i)
                        $root.waiternow.common.OrderSplitByStationProto.OrderPartProto.encode(message.orderParts[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified OrderSplitByStationProto message, length delimited. Does not implicitly {@link waiternow.common.OrderSplitByStationProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.OrderSplitByStationProto
             * @static
             * @param {waiternow.common.IOrderSplitByStationProto} message OrderSplitByStationProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OrderSplitByStationProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an OrderSplitByStationProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.OrderSplitByStationProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.OrderSplitByStationProto} OrderSplitByStationProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OrderSplitByStationProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.OrderSplitByStationProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            if (!(message.orderParts && message.orderParts.length))
                                message.orderParts = [];
                            message.orderParts.push($root.waiternow.common.OrderSplitByStationProto.OrderPartProto.decode(reader, reader.uint32()));
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an OrderSplitByStationProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.OrderSplitByStationProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.OrderSplitByStationProto} OrderSplitByStationProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OrderSplitByStationProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an OrderSplitByStationProto message.
             * @function verify
             * @memberof waiternow.common.OrderSplitByStationProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            OrderSplitByStationProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.orderParts != null && message.hasOwnProperty("orderParts")) {
                    if (!Array.isArray(message.orderParts))
                        return "orderParts: array expected";
                    for (var i = 0; i < message.orderParts.length; ++i) {
                        var error = $root.waiternow.common.OrderSplitByStationProto.OrderPartProto.verify(message.orderParts[i]);
                        if (error)
                            return "orderParts." + error;
                    }
                }
                return null;
            };

            /**
             * Creates an OrderSplitByStationProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.OrderSplitByStationProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.OrderSplitByStationProto} OrderSplitByStationProto
             */
            OrderSplitByStationProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.OrderSplitByStationProto)
                    return object;
                var message = new $root.waiternow.common.OrderSplitByStationProto();
                if (object.orderParts) {
                    if (!Array.isArray(object.orderParts))
                        throw TypeError(".waiternow.common.OrderSplitByStationProto.orderParts: array expected");
                    message.orderParts = [];
                    for (var i = 0; i < object.orderParts.length; ++i) {
                        if (typeof object.orderParts[i] !== "object")
                            throw TypeError(".waiternow.common.OrderSplitByStationProto.orderParts: object expected");
                        message.orderParts[i] = $root.waiternow.common.OrderSplitByStationProto.OrderPartProto.fromObject(object.orderParts[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from an OrderSplitByStationProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.OrderSplitByStationProto
             * @static
             * @param {waiternow.common.OrderSplitByStationProto} message OrderSplitByStationProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            OrderSplitByStationProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.orderParts = [];
                if (message.orderParts && message.orderParts.length) {
                    object.orderParts = [];
                    for (var j = 0; j < message.orderParts.length; ++j)
                        object.orderParts[j] = $root.waiternow.common.OrderSplitByStationProto.OrderPartProto.toObject(message.orderParts[j], options);
                }
                return object;
            };

            /**
             * Converts this OrderSplitByStationProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.OrderSplitByStationProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            OrderSplitByStationProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for OrderSplitByStationProto
             * @function getTypeUrl
             * @memberof waiternow.common.OrderSplitByStationProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            OrderSplitByStationProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.OrderSplitByStationProto";
            };

            OrderSplitByStationProto.OrderPartProto = (function() {

                /**
                 * Properties of an OrderPartProto.
                 * @memberof waiternow.common.OrderSplitByStationProto
                 * @interface IOrderPartProto
                 * @property {waiternow.common.IOrderProto|null} [order] OrderPartProto order
                 * @property {string|null} [station] OrderPartProto station
                 */

                /**
                 * Constructs a new OrderPartProto.
                 * @memberof waiternow.common.OrderSplitByStationProto
                 * @classdesc Represents an OrderPartProto.
                 * @implements IOrderPartProto
                 * @constructor
                 * @param {waiternow.common.OrderSplitByStationProto.IOrderPartProto=} [properties] Properties to set
                 */
                function OrderPartProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * OrderPartProto order.
                 * @member {waiternow.common.IOrderProto|null|undefined} order
                 * @memberof waiternow.common.OrderSplitByStationProto.OrderPartProto
                 * @instance
                 */
                OrderPartProto.prototype.order = null;

                /**
                 * OrderPartProto station.
                 * @member {string} station
                 * @memberof waiternow.common.OrderSplitByStationProto.OrderPartProto
                 * @instance
                 */
                OrderPartProto.prototype.station = "";

                /**
                 * Creates a new OrderPartProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.OrderSplitByStationProto.OrderPartProto
                 * @static
                 * @param {waiternow.common.OrderSplitByStationProto.IOrderPartProto=} [properties] Properties to set
                 * @returns {waiternow.common.OrderSplitByStationProto.OrderPartProto} OrderPartProto instance
                 */
                OrderPartProto.create = function create(properties) {
                    return new OrderPartProto(properties);
                };

                /**
                 * Encodes the specified OrderPartProto message. Does not implicitly {@link waiternow.common.OrderSplitByStationProto.OrderPartProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.OrderSplitByStationProto.OrderPartProto
                 * @static
                 * @param {waiternow.common.OrderSplitByStationProto.IOrderPartProto} message OrderPartProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                OrderPartProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.order != null && Object.hasOwnProperty.call(message, "order"))
                        $root.waiternow.common.OrderProto.encode(message.order, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.station != null && Object.hasOwnProperty.call(message, "station"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.station);
                    return writer;
                };

                /**
                 * Encodes the specified OrderPartProto message, length delimited. Does not implicitly {@link waiternow.common.OrderSplitByStationProto.OrderPartProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.OrderSplitByStationProto.OrderPartProto
                 * @static
                 * @param {waiternow.common.OrderSplitByStationProto.IOrderPartProto} message OrderPartProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                OrderPartProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an OrderPartProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.OrderSplitByStationProto.OrderPartProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.OrderSplitByStationProto.OrderPartProto} OrderPartProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                OrderPartProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.OrderSplitByStationProto.OrderPartProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.order = $root.waiternow.common.OrderProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.station = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an OrderPartProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.OrderSplitByStationProto.OrderPartProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.OrderSplitByStationProto.OrderPartProto} OrderPartProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                OrderPartProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an OrderPartProto message.
                 * @function verify
                 * @memberof waiternow.common.OrderSplitByStationProto.OrderPartProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                OrderPartProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.order != null && message.hasOwnProperty("order")) {
                        var error = $root.waiternow.common.OrderProto.verify(message.order);
                        if (error)
                            return "order." + error;
                    }
                    if (message.station != null && message.hasOwnProperty("station"))
                        if (!$util.isString(message.station))
                            return "station: string expected";
                    return null;
                };

                /**
                 * Creates an OrderPartProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.OrderSplitByStationProto.OrderPartProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.OrderSplitByStationProto.OrderPartProto} OrderPartProto
                 */
                OrderPartProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.OrderSplitByStationProto.OrderPartProto)
                        return object;
                    var message = new $root.waiternow.common.OrderSplitByStationProto.OrderPartProto();
                    if (object.order != null) {
                        if (typeof object.order !== "object")
                            throw TypeError(".waiternow.common.OrderSplitByStationProto.OrderPartProto.order: object expected");
                        message.order = $root.waiternow.common.OrderProto.fromObject(object.order);
                    }
                    if (object.station != null)
                        message.station = String(object.station);
                    return message;
                };

                /**
                 * Creates a plain object from an OrderPartProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.OrderSplitByStationProto.OrderPartProto
                 * @static
                 * @param {waiternow.common.OrderSplitByStationProto.OrderPartProto} message OrderPartProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                OrderPartProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.order = null;
                        object.station = "";
                    }
                    if (message.order != null && message.hasOwnProperty("order"))
                        object.order = $root.waiternow.common.OrderProto.toObject(message.order, options);
                    if (message.station != null && message.hasOwnProperty("station"))
                        object.station = message.station;
                    return object;
                };

                /**
                 * Converts this OrderPartProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.OrderSplitByStationProto.OrderPartProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                OrderPartProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for OrderPartProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.OrderSplitByStationProto.OrderPartProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                OrderPartProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.OrderSplitByStationProto.OrderPartProto";
                };

                return OrderPartProto;
            })();

            return OrderSplitByStationProto;
        })();

        common.OrderMaybeSplitByStationProto = (function() {

            /**
             * Properties of an OrderMaybeSplitByStationProto.
             * @memberof waiternow.common
             * @interface IOrderMaybeSplitByStationProto
             * @property {waiternow.common.IOrderProto|null} [order] OrderMaybeSplitByStationProto order
             * @property {waiternow.common.IOrderSplitByStationProto|null} [orderSplitByStation] OrderMaybeSplitByStationProto orderSplitByStation
             */

            /**
             * Constructs a new OrderMaybeSplitByStationProto.
             * @memberof waiternow.common
             * @classdesc Represents an OrderMaybeSplitByStationProto.
             * @implements IOrderMaybeSplitByStationProto
             * @constructor
             * @param {waiternow.common.IOrderMaybeSplitByStationProto=} [properties] Properties to set
             */
            function OrderMaybeSplitByStationProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * OrderMaybeSplitByStationProto order.
             * @member {waiternow.common.IOrderProto|null|undefined} order
             * @memberof waiternow.common.OrderMaybeSplitByStationProto
             * @instance
             */
            OrderMaybeSplitByStationProto.prototype.order = null;

            /**
             * OrderMaybeSplitByStationProto orderSplitByStation.
             * @member {waiternow.common.IOrderSplitByStationProto|null|undefined} orderSplitByStation
             * @memberof waiternow.common.OrderMaybeSplitByStationProto
             * @instance
             */
            OrderMaybeSplitByStationProto.prototype.orderSplitByStation = null;

            /**
             * Creates a new OrderMaybeSplitByStationProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.OrderMaybeSplitByStationProto
             * @static
             * @param {waiternow.common.IOrderMaybeSplitByStationProto=} [properties] Properties to set
             * @returns {waiternow.common.OrderMaybeSplitByStationProto} OrderMaybeSplitByStationProto instance
             */
            OrderMaybeSplitByStationProto.create = function create(properties) {
                return new OrderMaybeSplitByStationProto(properties);
            };

            /**
             * Encodes the specified OrderMaybeSplitByStationProto message. Does not implicitly {@link waiternow.common.OrderMaybeSplitByStationProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.OrderMaybeSplitByStationProto
             * @static
             * @param {waiternow.common.IOrderMaybeSplitByStationProto} message OrderMaybeSplitByStationProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OrderMaybeSplitByStationProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.order != null && Object.hasOwnProperty.call(message, "order"))
                    $root.waiternow.common.OrderProto.encode(message.order, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.orderSplitByStation != null && Object.hasOwnProperty.call(message, "orderSplitByStation"))
                    $root.waiternow.common.OrderSplitByStationProto.encode(message.orderSplitByStation, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified OrderMaybeSplitByStationProto message, length delimited. Does not implicitly {@link waiternow.common.OrderMaybeSplitByStationProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.OrderMaybeSplitByStationProto
             * @static
             * @param {waiternow.common.IOrderMaybeSplitByStationProto} message OrderMaybeSplitByStationProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OrderMaybeSplitByStationProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an OrderMaybeSplitByStationProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.OrderMaybeSplitByStationProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.OrderMaybeSplitByStationProto} OrderMaybeSplitByStationProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OrderMaybeSplitByStationProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.OrderMaybeSplitByStationProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.order = $root.waiternow.common.OrderProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 2: {
                            message.orderSplitByStation = $root.waiternow.common.OrderSplitByStationProto.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an OrderMaybeSplitByStationProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.OrderMaybeSplitByStationProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.OrderMaybeSplitByStationProto} OrderMaybeSplitByStationProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OrderMaybeSplitByStationProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an OrderMaybeSplitByStationProto message.
             * @function verify
             * @memberof waiternow.common.OrderMaybeSplitByStationProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            OrderMaybeSplitByStationProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.order != null && message.hasOwnProperty("order")) {
                    var error = $root.waiternow.common.OrderProto.verify(message.order);
                    if (error)
                        return "order." + error;
                }
                if (message.orderSplitByStation != null && message.hasOwnProperty("orderSplitByStation")) {
                    var error = $root.waiternow.common.OrderSplitByStationProto.verify(message.orderSplitByStation);
                    if (error)
                        return "orderSplitByStation." + error;
                }
                return null;
            };

            /**
             * Creates an OrderMaybeSplitByStationProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.OrderMaybeSplitByStationProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.OrderMaybeSplitByStationProto} OrderMaybeSplitByStationProto
             */
            OrderMaybeSplitByStationProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.OrderMaybeSplitByStationProto)
                    return object;
                var message = new $root.waiternow.common.OrderMaybeSplitByStationProto();
                if (object.order != null) {
                    if (typeof object.order !== "object")
                        throw TypeError(".waiternow.common.OrderMaybeSplitByStationProto.order: object expected");
                    message.order = $root.waiternow.common.OrderProto.fromObject(object.order);
                }
                if (object.orderSplitByStation != null) {
                    if (typeof object.orderSplitByStation !== "object")
                        throw TypeError(".waiternow.common.OrderMaybeSplitByStationProto.orderSplitByStation: object expected");
                    message.orderSplitByStation = $root.waiternow.common.OrderSplitByStationProto.fromObject(object.orderSplitByStation);
                }
                return message;
            };

            /**
             * Creates a plain object from an OrderMaybeSplitByStationProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.OrderMaybeSplitByStationProto
             * @static
             * @param {waiternow.common.OrderMaybeSplitByStationProto} message OrderMaybeSplitByStationProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            OrderMaybeSplitByStationProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.order = null;
                    object.orderSplitByStation = null;
                }
                if (message.order != null && message.hasOwnProperty("order"))
                    object.order = $root.waiternow.common.OrderProto.toObject(message.order, options);
                if (message.orderSplitByStation != null && message.hasOwnProperty("orderSplitByStation"))
                    object.orderSplitByStation = $root.waiternow.common.OrderSplitByStationProto.toObject(message.orderSplitByStation, options);
                return object;
            };

            /**
             * Converts this OrderMaybeSplitByStationProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.OrderMaybeSplitByStationProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            OrderMaybeSplitByStationProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for OrderMaybeSplitByStationProto
             * @function getTypeUrl
             * @memberof waiternow.common.OrderMaybeSplitByStationProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            OrderMaybeSplitByStationProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.OrderMaybeSplitByStationProto";
            };

            return OrderMaybeSplitByStationProto;
        })();

        common.LocationOrdersProto = (function() {

            /**
             * Properties of a LocationOrdersProto.
             * @memberof waiternow.common
             * @interface ILocationOrdersProto
             * @property {string|null} [locationId] LocationOrdersProto locationId
             * @property {Array.<waiternow.common.IOrderProto>|null} [orders] LocationOrdersProto orders
             * @property {string|null} [continuationToken] LocationOrdersProto continuationToken
             * @property {Array.<waiternow.common.IOrderSplitByStationProto>|null} [ordersSplitByStation] LocationOrdersProto ordersSplitByStation
             */

            /**
             * Constructs a new LocationOrdersProto.
             * @memberof waiternow.common
             * @classdesc Represents a LocationOrdersProto.
             * @implements ILocationOrdersProto
             * @constructor
             * @param {waiternow.common.ILocationOrdersProto=} [properties] Properties to set
             */
            function LocationOrdersProto(properties) {
                this.orders = [];
                this.ordersSplitByStation = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * LocationOrdersProto locationId.
             * @member {string} locationId
             * @memberof waiternow.common.LocationOrdersProto
             * @instance
             */
            LocationOrdersProto.prototype.locationId = "";

            /**
             * LocationOrdersProto orders.
             * @member {Array.<waiternow.common.IOrderProto>} orders
             * @memberof waiternow.common.LocationOrdersProto
             * @instance
             */
            LocationOrdersProto.prototype.orders = $util.emptyArray;

            /**
             * LocationOrdersProto continuationToken.
             * @member {string} continuationToken
             * @memberof waiternow.common.LocationOrdersProto
             * @instance
             */
            LocationOrdersProto.prototype.continuationToken = "";

            /**
             * LocationOrdersProto ordersSplitByStation.
             * @member {Array.<waiternow.common.IOrderSplitByStationProto>} ordersSplitByStation
             * @memberof waiternow.common.LocationOrdersProto
             * @instance
             */
            LocationOrdersProto.prototype.ordersSplitByStation = $util.emptyArray;

            /**
             * Creates a new LocationOrdersProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.LocationOrdersProto
             * @static
             * @param {waiternow.common.ILocationOrdersProto=} [properties] Properties to set
             * @returns {waiternow.common.LocationOrdersProto} LocationOrdersProto instance
             */
            LocationOrdersProto.create = function create(properties) {
                return new LocationOrdersProto(properties);
            };

            /**
             * Encodes the specified LocationOrdersProto message. Does not implicitly {@link waiternow.common.LocationOrdersProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.LocationOrdersProto
             * @static
             * @param {waiternow.common.ILocationOrdersProto} message LocationOrdersProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            LocationOrdersProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                if (message.orders != null && message.orders.length)
                    for (var i = 0; i < message.orders.length; ++i)
                        $root.waiternow.common.OrderProto.encode(message.orders[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.continuationToken);
                if (message.ordersSplitByStation != null && message.ordersSplitByStation.length)
                    for (var i = 0; i < message.ordersSplitByStation.length; ++i)
                        $root.waiternow.common.OrderSplitByStationProto.encode(message.ordersSplitByStation[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified LocationOrdersProto message, length delimited. Does not implicitly {@link waiternow.common.LocationOrdersProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.LocationOrdersProto
             * @static
             * @param {waiternow.common.ILocationOrdersProto} message LocationOrdersProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            LocationOrdersProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a LocationOrdersProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.LocationOrdersProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.LocationOrdersProto} LocationOrdersProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            LocationOrdersProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.LocationOrdersProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.locationId = reader.string();
                            break;
                        }
                    case 2: {
                            if (!(message.orders && message.orders.length))
                                message.orders = [];
                            message.orders.push($root.waiternow.common.OrderProto.decode(reader, reader.uint32()));
                            break;
                        }
                    case 3: {
                            message.continuationToken = reader.string();
                            break;
                        }
                    case 4: {
                            if (!(message.ordersSplitByStation && message.ordersSplitByStation.length))
                                message.ordersSplitByStation = [];
                            message.ordersSplitByStation.push($root.waiternow.common.OrderSplitByStationProto.decode(reader, reader.uint32()));
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a LocationOrdersProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.LocationOrdersProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.LocationOrdersProto} LocationOrdersProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            LocationOrdersProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a LocationOrdersProto message.
             * @function verify
             * @memberof waiternow.common.LocationOrdersProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            LocationOrdersProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.locationId != null && message.hasOwnProperty("locationId"))
                    if (!$util.isString(message.locationId))
                        return "locationId: string expected";
                if (message.orders != null && message.hasOwnProperty("orders")) {
                    if (!Array.isArray(message.orders))
                        return "orders: array expected";
                    for (var i = 0; i < message.orders.length; ++i) {
                        var error = $root.waiternow.common.OrderProto.verify(message.orders[i]);
                        if (error)
                            return "orders." + error;
                    }
                }
                if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                    if (!$util.isString(message.continuationToken))
                        return "continuationToken: string expected";
                if (message.ordersSplitByStation != null && message.hasOwnProperty("ordersSplitByStation")) {
                    if (!Array.isArray(message.ordersSplitByStation))
                        return "ordersSplitByStation: array expected";
                    for (var i = 0; i < message.ordersSplitByStation.length; ++i) {
                        var error = $root.waiternow.common.OrderSplitByStationProto.verify(message.ordersSplitByStation[i]);
                        if (error)
                            return "ordersSplitByStation." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a LocationOrdersProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.LocationOrdersProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.LocationOrdersProto} LocationOrdersProto
             */
            LocationOrdersProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.LocationOrdersProto)
                    return object;
                var message = new $root.waiternow.common.LocationOrdersProto();
                if (object.locationId != null)
                    message.locationId = String(object.locationId);
                if (object.orders) {
                    if (!Array.isArray(object.orders))
                        throw TypeError(".waiternow.common.LocationOrdersProto.orders: array expected");
                    message.orders = [];
                    for (var i = 0; i < object.orders.length; ++i) {
                        if (typeof object.orders[i] !== "object")
                            throw TypeError(".waiternow.common.LocationOrdersProto.orders: object expected");
                        message.orders[i] = $root.waiternow.common.OrderProto.fromObject(object.orders[i]);
                    }
                }
                if (object.continuationToken != null)
                    message.continuationToken = String(object.continuationToken);
                if (object.ordersSplitByStation) {
                    if (!Array.isArray(object.ordersSplitByStation))
                        throw TypeError(".waiternow.common.LocationOrdersProto.ordersSplitByStation: array expected");
                    message.ordersSplitByStation = [];
                    for (var i = 0; i < object.ordersSplitByStation.length; ++i) {
                        if (typeof object.ordersSplitByStation[i] !== "object")
                            throw TypeError(".waiternow.common.LocationOrdersProto.ordersSplitByStation: object expected");
                        message.ordersSplitByStation[i] = $root.waiternow.common.OrderSplitByStationProto.fromObject(object.ordersSplitByStation[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a LocationOrdersProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.LocationOrdersProto
             * @static
             * @param {waiternow.common.LocationOrdersProto} message LocationOrdersProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            LocationOrdersProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults) {
                    object.orders = [];
                    object.ordersSplitByStation = [];
                }
                if (options.defaults) {
                    object.locationId = "";
                    object.continuationToken = "";
                }
                if (message.locationId != null && message.hasOwnProperty("locationId"))
                    object.locationId = message.locationId;
                if (message.orders && message.orders.length) {
                    object.orders = [];
                    for (var j = 0; j < message.orders.length; ++j)
                        object.orders[j] = $root.waiternow.common.OrderProto.toObject(message.orders[j], options);
                }
                if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                    object.continuationToken = message.continuationToken;
                if (message.ordersSplitByStation && message.ordersSplitByStation.length) {
                    object.ordersSplitByStation = [];
                    for (var j = 0; j < message.ordersSplitByStation.length; ++j)
                        object.ordersSplitByStation[j] = $root.waiternow.common.OrderSplitByStationProto.toObject(message.ordersSplitByStation[j], options);
                }
                return object;
            };

            /**
             * Converts this LocationOrdersProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.LocationOrdersProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            LocationOrdersProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for LocationOrdersProto
             * @function getTypeUrl
             * @memberof waiternow.common.LocationOrdersProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            LocationOrdersProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.LocationOrdersProto";
            };

            return LocationOrdersProto;
        })();

        common.OrdersMaybeSplitByStationProto = (function() {

            /**
             * Properties of an OrdersMaybeSplitByStationProto.
             * @memberof waiternow.common
             * @interface IOrdersMaybeSplitByStationProto
             * @property {Array.<waiternow.common.IOrderMaybeSplitByStationProto>|null} [orders] OrdersMaybeSplitByStationProto orders
             * @property {string|null} [continuationToken] OrdersMaybeSplitByStationProto continuationToken
             */

            /**
             * Constructs a new OrdersMaybeSplitByStationProto.
             * @memberof waiternow.common
             * @classdesc Represents an OrdersMaybeSplitByStationProto.
             * @implements IOrdersMaybeSplitByStationProto
             * @constructor
             * @param {waiternow.common.IOrdersMaybeSplitByStationProto=} [properties] Properties to set
             */
            function OrdersMaybeSplitByStationProto(properties) {
                this.orders = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * OrdersMaybeSplitByStationProto orders.
             * @member {Array.<waiternow.common.IOrderMaybeSplitByStationProto>} orders
             * @memberof waiternow.common.OrdersMaybeSplitByStationProto
             * @instance
             */
            OrdersMaybeSplitByStationProto.prototype.orders = $util.emptyArray;

            /**
             * OrdersMaybeSplitByStationProto continuationToken.
             * @member {string} continuationToken
             * @memberof waiternow.common.OrdersMaybeSplitByStationProto
             * @instance
             */
            OrdersMaybeSplitByStationProto.prototype.continuationToken = "";

            /**
             * Creates a new OrdersMaybeSplitByStationProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.OrdersMaybeSplitByStationProto
             * @static
             * @param {waiternow.common.IOrdersMaybeSplitByStationProto=} [properties] Properties to set
             * @returns {waiternow.common.OrdersMaybeSplitByStationProto} OrdersMaybeSplitByStationProto instance
             */
            OrdersMaybeSplitByStationProto.create = function create(properties) {
                return new OrdersMaybeSplitByStationProto(properties);
            };

            /**
             * Encodes the specified OrdersMaybeSplitByStationProto message. Does not implicitly {@link waiternow.common.OrdersMaybeSplitByStationProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.OrdersMaybeSplitByStationProto
             * @static
             * @param {waiternow.common.IOrdersMaybeSplitByStationProto} message OrdersMaybeSplitByStationProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OrdersMaybeSplitByStationProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.orders != null && message.orders.length)
                    for (var i = 0; i < message.orders.length; ++i)
                        $root.waiternow.common.OrderMaybeSplitByStationProto.encode(message.orders[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.continuationToken);
                return writer;
            };

            /**
             * Encodes the specified OrdersMaybeSplitByStationProto message, length delimited. Does not implicitly {@link waiternow.common.OrdersMaybeSplitByStationProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.OrdersMaybeSplitByStationProto
             * @static
             * @param {waiternow.common.IOrdersMaybeSplitByStationProto} message OrdersMaybeSplitByStationProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OrdersMaybeSplitByStationProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an OrdersMaybeSplitByStationProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.OrdersMaybeSplitByStationProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.OrdersMaybeSplitByStationProto} OrdersMaybeSplitByStationProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OrdersMaybeSplitByStationProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.OrdersMaybeSplitByStationProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            if (!(message.orders && message.orders.length))
                                message.orders = [];
                            message.orders.push($root.waiternow.common.OrderMaybeSplitByStationProto.decode(reader, reader.uint32()));
                            break;
                        }
                    case 2: {
                            message.continuationToken = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an OrdersMaybeSplitByStationProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.OrdersMaybeSplitByStationProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.OrdersMaybeSplitByStationProto} OrdersMaybeSplitByStationProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OrdersMaybeSplitByStationProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an OrdersMaybeSplitByStationProto message.
             * @function verify
             * @memberof waiternow.common.OrdersMaybeSplitByStationProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            OrdersMaybeSplitByStationProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.orders != null && message.hasOwnProperty("orders")) {
                    if (!Array.isArray(message.orders))
                        return "orders: array expected";
                    for (var i = 0; i < message.orders.length; ++i) {
                        var error = $root.waiternow.common.OrderMaybeSplitByStationProto.verify(message.orders[i]);
                        if (error)
                            return "orders." + error;
                    }
                }
                if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                    if (!$util.isString(message.continuationToken))
                        return "continuationToken: string expected";
                return null;
            };

            /**
             * Creates an OrdersMaybeSplitByStationProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.OrdersMaybeSplitByStationProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.OrdersMaybeSplitByStationProto} OrdersMaybeSplitByStationProto
             */
            OrdersMaybeSplitByStationProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.OrdersMaybeSplitByStationProto)
                    return object;
                var message = new $root.waiternow.common.OrdersMaybeSplitByStationProto();
                if (object.orders) {
                    if (!Array.isArray(object.orders))
                        throw TypeError(".waiternow.common.OrdersMaybeSplitByStationProto.orders: array expected");
                    message.orders = [];
                    for (var i = 0; i < object.orders.length; ++i) {
                        if (typeof object.orders[i] !== "object")
                            throw TypeError(".waiternow.common.OrdersMaybeSplitByStationProto.orders: object expected");
                        message.orders[i] = $root.waiternow.common.OrderMaybeSplitByStationProto.fromObject(object.orders[i]);
                    }
                }
                if (object.continuationToken != null)
                    message.continuationToken = String(object.continuationToken);
                return message;
            };

            /**
             * Creates a plain object from an OrdersMaybeSplitByStationProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.OrdersMaybeSplitByStationProto
             * @static
             * @param {waiternow.common.OrdersMaybeSplitByStationProto} message OrdersMaybeSplitByStationProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            OrdersMaybeSplitByStationProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.orders = [];
                if (options.defaults)
                    object.continuationToken = "";
                if (message.orders && message.orders.length) {
                    object.orders = [];
                    for (var j = 0; j < message.orders.length; ++j)
                        object.orders[j] = $root.waiternow.common.OrderMaybeSplitByStationProto.toObject(message.orders[j], options);
                }
                if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                    object.continuationToken = message.continuationToken;
                return object;
            };

            /**
             * Converts this OrdersMaybeSplitByStationProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.OrdersMaybeSplitByStationProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            OrdersMaybeSplitByStationProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for OrdersMaybeSplitByStationProto
             * @function getTypeUrl
             * @memberof waiternow.common.OrdersMaybeSplitByStationProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            OrdersMaybeSplitByStationProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.OrdersMaybeSplitByStationProto";
            };

            return OrdersMaybeSplitByStationProto;
        })();

        common.DeviceOrdersProto = (function() {

            /**
             * Properties of a DeviceOrdersProto.
             * @memberof waiternow.common
             * @interface IDeviceOrdersProto
             * @property {string|null} [deviceId] DeviceOrdersProto deviceId
             * @property {Array.<waiternow.common.IOrderProto>|null} [orders] DeviceOrdersProto orders
             * @property {string|null} [continuationToken] DeviceOrdersProto continuationToken
             */

            /**
             * Constructs a new DeviceOrdersProto.
             * @memberof waiternow.common
             * @classdesc Represents a DeviceOrdersProto.
             * @implements IDeviceOrdersProto
             * @constructor
             * @param {waiternow.common.IDeviceOrdersProto=} [properties] Properties to set
             */
            function DeviceOrdersProto(properties) {
                this.orders = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * DeviceOrdersProto deviceId.
             * @member {string} deviceId
             * @memberof waiternow.common.DeviceOrdersProto
             * @instance
             */
            DeviceOrdersProto.prototype.deviceId = "";

            /**
             * DeviceOrdersProto orders.
             * @member {Array.<waiternow.common.IOrderProto>} orders
             * @memberof waiternow.common.DeviceOrdersProto
             * @instance
             */
            DeviceOrdersProto.prototype.orders = $util.emptyArray;

            /**
             * DeviceOrdersProto continuationToken.
             * @member {string} continuationToken
             * @memberof waiternow.common.DeviceOrdersProto
             * @instance
             */
            DeviceOrdersProto.prototype.continuationToken = "";

            /**
             * Creates a new DeviceOrdersProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.DeviceOrdersProto
             * @static
             * @param {waiternow.common.IDeviceOrdersProto=} [properties] Properties to set
             * @returns {waiternow.common.DeviceOrdersProto} DeviceOrdersProto instance
             */
            DeviceOrdersProto.create = function create(properties) {
                return new DeviceOrdersProto(properties);
            };

            /**
             * Encodes the specified DeviceOrdersProto message. Does not implicitly {@link waiternow.common.DeviceOrdersProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.DeviceOrdersProto
             * @static
             * @param {waiternow.common.IDeviceOrdersProto} message DeviceOrdersProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DeviceOrdersProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.deviceId != null && Object.hasOwnProperty.call(message, "deviceId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.deviceId);
                if (message.orders != null && message.orders.length)
                    for (var i = 0; i < message.orders.length; ++i)
                        $root.waiternow.common.OrderProto.encode(message.orders[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.continuationToken);
                return writer;
            };

            /**
             * Encodes the specified DeviceOrdersProto message, length delimited. Does not implicitly {@link waiternow.common.DeviceOrdersProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.DeviceOrdersProto
             * @static
             * @param {waiternow.common.IDeviceOrdersProto} message DeviceOrdersProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DeviceOrdersProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a DeviceOrdersProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.DeviceOrdersProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.DeviceOrdersProto} DeviceOrdersProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DeviceOrdersProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.DeviceOrdersProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.deviceId = reader.string();
                            break;
                        }
                    case 2: {
                            if (!(message.orders && message.orders.length))
                                message.orders = [];
                            message.orders.push($root.waiternow.common.OrderProto.decode(reader, reader.uint32()));
                            break;
                        }
                    case 3: {
                            message.continuationToken = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a DeviceOrdersProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.DeviceOrdersProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.DeviceOrdersProto} DeviceOrdersProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DeviceOrdersProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a DeviceOrdersProto message.
             * @function verify
             * @memberof waiternow.common.DeviceOrdersProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            DeviceOrdersProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                    if (!$util.isString(message.deviceId))
                        return "deviceId: string expected";
                if (message.orders != null && message.hasOwnProperty("orders")) {
                    if (!Array.isArray(message.orders))
                        return "orders: array expected";
                    for (var i = 0; i < message.orders.length; ++i) {
                        var error = $root.waiternow.common.OrderProto.verify(message.orders[i]);
                        if (error)
                            return "orders." + error;
                    }
                }
                if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                    if (!$util.isString(message.continuationToken))
                        return "continuationToken: string expected";
                return null;
            };

            /**
             * Creates a DeviceOrdersProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.DeviceOrdersProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.DeviceOrdersProto} DeviceOrdersProto
             */
            DeviceOrdersProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.DeviceOrdersProto)
                    return object;
                var message = new $root.waiternow.common.DeviceOrdersProto();
                if (object.deviceId != null)
                    message.deviceId = String(object.deviceId);
                if (object.orders) {
                    if (!Array.isArray(object.orders))
                        throw TypeError(".waiternow.common.DeviceOrdersProto.orders: array expected");
                    message.orders = [];
                    for (var i = 0; i < object.orders.length; ++i) {
                        if (typeof object.orders[i] !== "object")
                            throw TypeError(".waiternow.common.DeviceOrdersProto.orders: object expected");
                        message.orders[i] = $root.waiternow.common.OrderProto.fromObject(object.orders[i]);
                    }
                }
                if (object.continuationToken != null)
                    message.continuationToken = String(object.continuationToken);
                return message;
            };

            /**
             * Creates a plain object from a DeviceOrdersProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.DeviceOrdersProto
             * @static
             * @param {waiternow.common.DeviceOrdersProto} message DeviceOrdersProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            DeviceOrdersProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.orders = [];
                if (options.defaults) {
                    object.deviceId = "";
                    object.continuationToken = "";
                }
                if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                    object.deviceId = message.deviceId;
                if (message.orders && message.orders.length) {
                    object.orders = [];
                    for (var j = 0; j < message.orders.length; ++j)
                        object.orders[j] = $root.waiternow.common.OrderProto.toObject(message.orders[j], options);
                }
                if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                    object.continuationToken = message.continuationToken;
                return object;
            };

            /**
             * Converts this DeviceOrdersProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.DeviceOrdersProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            DeviceOrdersProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for DeviceOrdersProto
             * @function getTypeUrl
             * @memberof waiternow.common.DeviceOrdersProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            DeviceOrdersProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.DeviceOrdersProto";
            };

            return DeviceOrdersProto;
        })();

        common.OrderCountProto = (function() {

            /**
             * Properties of an OrderCountProto.
             * @memberof waiternow.common
             * @interface IOrderCountProto
             * @property {string|null} [locationId] OrderCountProto locationId
             * @property {number|null} [orderCount] OrderCountProto orderCount
             * @property {string|null} [concurrencyToken] OrderCountProto concurrencyToken
             * @property {waiternow.common.IDateProto|null} [date] OrderCountProto date
             */

            /**
             * Constructs a new OrderCountProto.
             * @memberof waiternow.common
             * @classdesc Represents an OrderCountProto.
             * @implements IOrderCountProto
             * @constructor
             * @param {waiternow.common.IOrderCountProto=} [properties] Properties to set
             */
            function OrderCountProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * OrderCountProto locationId.
             * @member {string} locationId
             * @memberof waiternow.common.OrderCountProto
             * @instance
             */
            OrderCountProto.prototype.locationId = "";

            /**
             * OrderCountProto orderCount.
             * @member {number} orderCount
             * @memberof waiternow.common.OrderCountProto
             * @instance
             */
            OrderCountProto.prototype.orderCount = 0;

            /**
             * OrderCountProto concurrencyToken.
             * @member {string} concurrencyToken
             * @memberof waiternow.common.OrderCountProto
             * @instance
             */
            OrderCountProto.prototype.concurrencyToken = "";

            /**
             * OrderCountProto date.
             * @member {waiternow.common.IDateProto|null|undefined} date
             * @memberof waiternow.common.OrderCountProto
             * @instance
             */
            OrderCountProto.prototype.date = null;

            /**
             * Creates a new OrderCountProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.OrderCountProto
             * @static
             * @param {waiternow.common.IOrderCountProto=} [properties] Properties to set
             * @returns {waiternow.common.OrderCountProto} OrderCountProto instance
             */
            OrderCountProto.create = function create(properties) {
                return new OrderCountProto(properties);
            };

            /**
             * Encodes the specified OrderCountProto message. Does not implicitly {@link waiternow.common.OrderCountProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.OrderCountProto
             * @static
             * @param {waiternow.common.IOrderCountProto} message OrderCountProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OrderCountProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                if (message.orderCount != null && Object.hasOwnProperty.call(message, "orderCount"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.orderCount);
                if (message.concurrencyToken != null && Object.hasOwnProperty.call(message, "concurrencyToken"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.concurrencyToken);
                if (message.date != null && Object.hasOwnProperty.call(message, "date"))
                    $root.waiternow.common.DateProto.encode(message.date, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified OrderCountProto message, length delimited. Does not implicitly {@link waiternow.common.OrderCountProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.OrderCountProto
             * @static
             * @param {waiternow.common.IOrderCountProto} message OrderCountProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OrderCountProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an OrderCountProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.OrderCountProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.OrderCountProto} OrderCountProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OrderCountProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.OrderCountProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.locationId = reader.string();
                            break;
                        }
                    case 2: {
                            message.orderCount = reader.int32();
                            break;
                        }
                    case 3: {
                            message.concurrencyToken = reader.string();
                            break;
                        }
                    case 4: {
                            message.date = $root.waiternow.common.DateProto.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an OrderCountProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.OrderCountProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.OrderCountProto} OrderCountProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OrderCountProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an OrderCountProto message.
             * @function verify
             * @memberof waiternow.common.OrderCountProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            OrderCountProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.locationId != null && message.hasOwnProperty("locationId"))
                    if (!$util.isString(message.locationId))
                        return "locationId: string expected";
                if (message.orderCount != null && message.hasOwnProperty("orderCount"))
                    if (!$util.isInteger(message.orderCount))
                        return "orderCount: integer expected";
                if (message.concurrencyToken != null && message.hasOwnProperty("concurrencyToken"))
                    if (!$util.isString(message.concurrencyToken))
                        return "concurrencyToken: string expected";
                if (message.date != null && message.hasOwnProperty("date")) {
                    var error = $root.waiternow.common.DateProto.verify(message.date);
                    if (error)
                        return "date." + error;
                }
                return null;
            };

            /**
             * Creates an OrderCountProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.OrderCountProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.OrderCountProto} OrderCountProto
             */
            OrderCountProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.OrderCountProto)
                    return object;
                var message = new $root.waiternow.common.OrderCountProto();
                if (object.locationId != null)
                    message.locationId = String(object.locationId);
                if (object.orderCount != null)
                    message.orderCount = object.orderCount | 0;
                if (object.concurrencyToken != null)
                    message.concurrencyToken = String(object.concurrencyToken);
                if (object.date != null) {
                    if (typeof object.date !== "object")
                        throw TypeError(".waiternow.common.OrderCountProto.date: object expected");
                    message.date = $root.waiternow.common.DateProto.fromObject(object.date);
                }
                return message;
            };

            /**
             * Creates a plain object from an OrderCountProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.OrderCountProto
             * @static
             * @param {waiternow.common.OrderCountProto} message OrderCountProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            OrderCountProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.locationId = "";
                    object.orderCount = 0;
                    object.concurrencyToken = "";
                    object.date = null;
                }
                if (message.locationId != null && message.hasOwnProperty("locationId"))
                    object.locationId = message.locationId;
                if (message.orderCount != null && message.hasOwnProperty("orderCount"))
                    object.orderCount = message.orderCount;
                if (message.concurrencyToken != null && message.hasOwnProperty("concurrencyToken"))
                    object.concurrencyToken = message.concurrencyToken;
                if (message.date != null && message.hasOwnProperty("date"))
                    object.date = $root.waiternow.common.DateProto.toObject(message.date, options);
                return object;
            };

            /**
             * Converts this OrderCountProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.OrderCountProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            OrderCountProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for OrderCountProto
             * @function getTypeUrl
             * @memberof waiternow.common.OrderCountProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            OrderCountProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.OrderCountProto";
            };

            return OrderCountProto;
        })();

        common.SalesSummaryReportProto = (function() {

            /**
             * Properties of a SalesSummaryReportProto.
             * @memberof waiternow.common
             * @interface ISalesSummaryReportProto
             * @property {string|null} [locationId] SalesSummaryReportProto locationId
             * @property {waiternow.common.IDateRangeProto|null} [period] SalesSummaryReportProto period
             * @property {number|null} [orders] SalesSummaryReportProto orders
             * @property {number|null} [partiallyRefundedOrders] SalesSummaryReportProto partiallyRefundedOrders
             * @property {number|null} [refundedOrders] SalesSummaryReportProto refundedOrders
             * @property {waiternow.common.IMoneyProto|null} [subtotal] SalesSummaryReportProto subtotal
             * @property {waiternow.common.IMoneyProto|null} [discounts] SalesSummaryReportProto discounts
             * @property {waiternow.common.IMoneyProto|null} [tax] SalesSummaryReportProto tax
             * @property {waiternow.common.IMoneyProto|null} [tips] SalesSummaryReportProto tips
             * @property {waiternow.common.IMoneyProto|null} [deliveryFeesSelf] SalesSummaryReportProto deliveryFeesSelf
             * @property {waiternow.common.IMoneyProto|null} [deliveryTipsSelf] SalesSummaryReportProto deliveryTipsSelf
             * @property {waiternow.common.IMoneyProto|null} [deliveryFeesDoorDash] SalesSummaryReportProto deliveryFeesDoorDash
             * @property {waiternow.common.IMoneyProto|null} [deliveryTipsDoorDash] SalesSummaryReportProto deliveryTipsDoorDash
             * @property {waiternow.common.IMoneyProto|null} [creditCardFeeAdjustment] SalesSummaryReportProto creditCardFeeAdjustment
             * @property {waiternow.common.IMoneyProto|null} [stripeFee] SalesSummaryReportProto stripeFee
             * @property {waiternow.common.IMoneyProto|null} [waiterNowFee] SalesSummaryReportProto waiterNowFee
             * @property {waiternow.common.IMoneyProto|null} [total] SalesSummaryReportProto total
             * @property {waiternow.common.IMoneyProto|null} [netPaidToBusiness] SalesSummaryReportProto netPaidToBusiness
             * @property {waiternow.common.IMoneyProto|null} [refunds] SalesSummaryReportProto refunds
             * @property {waiternow.common.IMoneyProto|null} [creditCardFeeAdjustmentForThirdPartyDelivery] SalesSummaryReportProto creditCardFeeAdjustmentForThirdPartyDelivery
             * @property {number|null} [disputedOrders] SalesSummaryReportProto disputedOrders
             * @property {waiternow.common.IMoneyProto|null} [disputes] SalesSummaryReportProto disputes
             */

            /**
             * Constructs a new SalesSummaryReportProto.
             * @memberof waiternow.common
             * @classdesc Represents a SalesSummaryReportProto.
             * @implements ISalesSummaryReportProto
             * @constructor
             * @param {waiternow.common.ISalesSummaryReportProto=} [properties] Properties to set
             */
            function SalesSummaryReportProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * SalesSummaryReportProto locationId.
             * @member {string} locationId
             * @memberof waiternow.common.SalesSummaryReportProto
             * @instance
             */
            SalesSummaryReportProto.prototype.locationId = "";

            /**
             * SalesSummaryReportProto period.
             * @member {waiternow.common.IDateRangeProto|null|undefined} period
             * @memberof waiternow.common.SalesSummaryReportProto
             * @instance
             */
            SalesSummaryReportProto.prototype.period = null;

            /**
             * SalesSummaryReportProto orders.
             * @member {number} orders
             * @memberof waiternow.common.SalesSummaryReportProto
             * @instance
             */
            SalesSummaryReportProto.prototype.orders = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * SalesSummaryReportProto partiallyRefundedOrders.
             * @member {number} partiallyRefundedOrders
             * @memberof waiternow.common.SalesSummaryReportProto
             * @instance
             */
            SalesSummaryReportProto.prototype.partiallyRefundedOrders = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * SalesSummaryReportProto refundedOrders.
             * @member {number} refundedOrders
             * @memberof waiternow.common.SalesSummaryReportProto
             * @instance
             */
            SalesSummaryReportProto.prototype.refundedOrders = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * SalesSummaryReportProto subtotal.
             * @member {waiternow.common.IMoneyProto|null|undefined} subtotal
             * @memberof waiternow.common.SalesSummaryReportProto
             * @instance
             */
            SalesSummaryReportProto.prototype.subtotal = null;

            /**
             * SalesSummaryReportProto discounts.
             * @member {waiternow.common.IMoneyProto|null|undefined} discounts
             * @memberof waiternow.common.SalesSummaryReportProto
             * @instance
             */
            SalesSummaryReportProto.prototype.discounts = null;

            /**
             * SalesSummaryReportProto tax.
             * @member {waiternow.common.IMoneyProto|null|undefined} tax
             * @memberof waiternow.common.SalesSummaryReportProto
             * @instance
             */
            SalesSummaryReportProto.prototype.tax = null;

            /**
             * SalesSummaryReportProto tips.
             * @member {waiternow.common.IMoneyProto|null|undefined} tips
             * @memberof waiternow.common.SalesSummaryReportProto
             * @instance
             */
            SalesSummaryReportProto.prototype.tips = null;

            /**
             * SalesSummaryReportProto deliveryFeesSelf.
             * @member {waiternow.common.IMoneyProto|null|undefined} deliveryFeesSelf
             * @memberof waiternow.common.SalesSummaryReportProto
             * @instance
             */
            SalesSummaryReportProto.prototype.deliveryFeesSelf = null;

            /**
             * SalesSummaryReportProto deliveryTipsSelf.
             * @member {waiternow.common.IMoneyProto|null|undefined} deliveryTipsSelf
             * @memberof waiternow.common.SalesSummaryReportProto
             * @instance
             */
            SalesSummaryReportProto.prototype.deliveryTipsSelf = null;

            /**
             * SalesSummaryReportProto deliveryFeesDoorDash.
             * @member {waiternow.common.IMoneyProto|null|undefined} deliveryFeesDoorDash
             * @memberof waiternow.common.SalesSummaryReportProto
             * @instance
             */
            SalesSummaryReportProto.prototype.deliveryFeesDoorDash = null;

            /**
             * SalesSummaryReportProto deliveryTipsDoorDash.
             * @member {waiternow.common.IMoneyProto|null|undefined} deliveryTipsDoorDash
             * @memberof waiternow.common.SalesSummaryReportProto
             * @instance
             */
            SalesSummaryReportProto.prototype.deliveryTipsDoorDash = null;

            /**
             * SalesSummaryReportProto creditCardFeeAdjustment.
             * @member {waiternow.common.IMoneyProto|null|undefined} creditCardFeeAdjustment
             * @memberof waiternow.common.SalesSummaryReportProto
             * @instance
             */
            SalesSummaryReportProto.prototype.creditCardFeeAdjustment = null;

            /**
             * SalesSummaryReportProto stripeFee.
             * @member {waiternow.common.IMoneyProto|null|undefined} stripeFee
             * @memberof waiternow.common.SalesSummaryReportProto
             * @instance
             */
            SalesSummaryReportProto.prototype.stripeFee = null;

            /**
             * SalesSummaryReportProto waiterNowFee.
             * @member {waiternow.common.IMoneyProto|null|undefined} waiterNowFee
             * @memberof waiternow.common.SalesSummaryReportProto
             * @instance
             */
            SalesSummaryReportProto.prototype.waiterNowFee = null;

            /**
             * SalesSummaryReportProto total.
             * @member {waiternow.common.IMoneyProto|null|undefined} total
             * @memberof waiternow.common.SalesSummaryReportProto
             * @instance
             */
            SalesSummaryReportProto.prototype.total = null;

            /**
             * SalesSummaryReportProto netPaidToBusiness.
             * @member {waiternow.common.IMoneyProto|null|undefined} netPaidToBusiness
             * @memberof waiternow.common.SalesSummaryReportProto
             * @instance
             */
            SalesSummaryReportProto.prototype.netPaidToBusiness = null;

            /**
             * SalesSummaryReportProto refunds.
             * @member {waiternow.common.IMoneyProto|null|undefined} refunds
             * @memberof waiternow.common.SalesSummaryReportProto
             * @instance
             */
            SalesSummaryReportProto.prototype.refunds = null;

            /**
             * SalesSummaryReportProto creditCardFeeAdjustmentForThirdPartyDelivery.
             * @member {waiternow.common.IMoneyProto|null|undefined} creditCardFeeAdjustmentForThirdPartyDelivery
             * @memberof waiternow.common.SalesSummaryReportProto
             * @instance
             */
            SalesSummaryReportProto.prototype.creditCardFeeAdjustmentForThirdPartyDelivery = null;

            /**
             * SalesSummaryReportProto disputedOrders.
             * @member {number} disputedOrders
             * @memberof waiternow.common.SalesSummaryReportProto
             * @instance
             */
            SalesSummaryReportProto.prototype.disputedOrders = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * SalesSummaryReportProto disputes.
             * @member {waiternow.common.IMoneyProto|null|undefined} disputes
             * @memberof waiternow.common.SalesSummaryReportProto
             * @instance
             */
            SalesSummaryReportProto.prototype.disputes = null;

            /**
             * Creates a new SalesSummaryReportProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.SalesSummaryReportProto
             * @static
             * @param {waiternow.common.ISalesSummaryReportProto=} [properties] Properties to set
             * @returns {waiternow.common.SalesSummaryReportProto} SalesSummaryReportProto instance
             */
            SalesSummaryReportProto.create = function create(properties) {
                return new SalesSummaryReportProto(properties);
            };

            /**
             * Encodes the specified SalesSummaryReportProto message. Does not implicitly {@link waiternow.common.SalesSummaryReportProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.SalesSummaryReportProto
             * @static
             * @param {waiternow.common.ISalesSummaryReportProto} message SalesSummaryReportProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SalesSummaryReportProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                if (message.period != null && Object.hasOwnProperty.call(message, "period"))
                    $root.waiternow.common.DateRangeProto.encode(message.period, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.orders != null && Object.hasOwnProperty.call(message, "orders"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int64(message.orders);
                if (message.partiallyRefundedOrders != null && Object.hasOwnProperty.call(message, "partiallyRefundedOrders"))
                    writer.uint32(/* id 4, wireType 0 =*/32).int64(message.partiallyRefundedOrders);
                if (message.refundedOrders != null && Object.hasOwnProperty.call(message, "refundedOrders"))
                    writer.uint32(/* id 5, wireType 0 =*/40).int64(message.refundedOrders);
                if (message.subtotal != null && Object.hasOwnProperty.call(message, "subtotal"))
                    $root.waiternow.common.MoneyProto.encode(message.subtotal, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                if (message.discounts != null && Object.hasOwnProperty.call(message, "discounts"))
                    $root.waiternow.common.MoneyProto.encode(message.discounts, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                if (message.tax != null && Object.hasOwnProperty.call(message, "tax"))
                    $root.waiternow.common.MoneyProto.encode(message.tax, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                if (message.tips != null && Object.hasOwnProperty.call(message, "tips"))
                    $root.waiternow.common.MoneyProto.encode(message.tips, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                if (message.deliveryFeesSelf != null && Object.hasOwnProperty.call(message, "deliveryFeesSelf"))
                    $root.waiternow.common.MoneyProto.encode(message.deliveryFeesSelf, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                if (message.deliveryTipsSelf != null && Object.hasOwnProperty.call(message, "deliveryTipsSelf"))
                    $root.waiternow.common.MoneyProto.encode(message.deliveryTipsSelf, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                if (message.deliveryFeesDoorDash != null && Object.hasOwnProperty.call(message, "deliveryFeesDoorDash"))
                    $root.waiternow.common.MoneyProto.encode(message.deliveryFeesDoorDash, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                if (message.deliveryTipsDoorDash != null && Object.hasOwnProperty.call(message, "deliveryTipsDoorDash"))
                    $root.waiternow.common.MoneyProto.encode(message.deliveryTipsDoorDash, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
                if (message.creditCardFeeAdjustment != null && Object.hasOwnProperty.call(message, "creditCardFeeAdjustment"))
                    $root.waiternow.common.MoneyProto.encode(message.creditCardFeeAdjustment, writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
                if (message.stripeFee != null && Object.hasOwnProperty.call(message, "stripeFee"))
                    $root.waiternow.common.MoneyProto.encode(message.stripeFee, writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
                if (message.waiterNowFee != null && Object.hasOwnProperty.call(message, "waiterNowFee"))
                    $root.waiternow.common.MoneyProto.encode(message.waiterNowFee, writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
                if (message.total != null && Object.hasOwnProperty.call(message, "total"))
                    $root.waiternow.common.MoneyProto.encode(message.total, writer.uint32(/* id 17, wireType 2 =*/138).fork()).ldelim();
                if (message.netPaidToBusiness != null && Object.hasOwnProperty.call(message, "netPaidToBusiness"))
                    $root.waiternow.common.MoneyProto.encode(message.netPaidToBusiness, writer.uint32(/* id 18, wireType 2 =*/146).fork()).ldelim();
                if (message.refunds != null && Object.hasOwnProperty.call(message, "refunds"))
                    $root.waiternow.common.MoneyProto.encode(message.refunds, writer.uint32(/* id 19, wireType 2 =*/154).fork()).ldelim();
                if (message.creditCardFeeAdjustmentForThirdPartyDelivery != null && Object.hasOwnProperty.call(message, "creditCardFeeAdjustmentForThirdPartyDelivery"))
                    $root.waiternow.common.MoneyProto.encode(message.creditCardFeeAdjustmentForThirdPartyDelivery, writer.uint32(/* id 20, wireType 2 =*/162).fork()).ldelim();
                if (message.disputedOrders != null && Object.hasOwnProperty.call(message, "disputedOrders"))
                    writer.uint32(/* id 21, wireType 0 =*/168).int64(message.disputedOrders);
                if (message.disputes != null && Object.hasOwnProperty.call(message, "disputes"))
                    $root.waiternow.common.MoneyProto.encode(message.disputes, writer.uint32(/* id 22, wireType 2 =*/178).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified SalesSummaryReportProto message, length delimited. Does not implicitly {@link waiternow.common.SalesSummaryReportProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.SalesSummaryReportProto
             * @static
             * @param {waiternow.common.ISalesSummaryReportProto} message SalesSummaryReportProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SalesSummaryReportProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SalesSummaryReportProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.SalesSummaryReportProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.SalesSummaryReportProto} SalesSummaryReportProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SalesSummaryReportProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.SalesSummaryReportProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.locationId = reader.string();
                            break;
                        }
                    case 2: {
                            message.period = $root.waiternow.common.DateRangeProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 3: {
                            message.orders = reader.int64();
                            break;
                        }
                    case 4: {
                            message.partiallyRefundedOrders = reader.int64();
                            break;
                        }
                    case 5: {
                            message.refundedOrders = reader.int64();
                            break;
                        }
                    case 6: {
                            message.subtotal = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 7: {
                            message.discounts = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 8: {
                            message.tax = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 9: {
                            message.tips = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 10: {
                            message.deliveryFeesSelf = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 11: {
                            message.deliveryTipsSelf = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 12: {
                            message.deliveryFeesDoorDash = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 13: {
                            message.deliveryTipsDoorDash = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 14: {
                            message.creditCardFeeAdjustment = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 15: {
                            message.stripeFee = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 16: {
                            message.waiterNowFee = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 17: {
                            message.total = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 18: {
                            message.netPaidToBusiness = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 19: {
                            message.refunds = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 20: {
                            message.creditCardFeeAdjustmentForThirdPartyDelivery = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 21: {
                            message.disputedOrders = reader.int64();
                            break;
                        }
                    case 22: {
                            message.disputes = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SalesSummaryReportProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.SalesSummaryReportProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.SalesSummaryReportProto} SalesSummaryReportProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SalesSummaryReportProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SalesSummaryReportProto message.
             * @function verify
             * @memberof waiternow.common.SalesSummaryReportProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SalesSummaryReportProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.locationId != null && message.hasOwnProperty("locationId"))
                    if (!$util.isString(message.locationId))
                        return "locationId: string expected";
                if (message.period != null && message.hasOwnProperty("period")) {
                    var error = $root.waiternow.common.DateRangeProto.verify(message.period);
                    if (error)
                        return "period." + error;
                }
                if (message.orders != null && message.hasOwnProperty("orders"))
                    if (!$util.isInteger(message.orders) && !(message.orders && $util.isInteger(message.orders.low) && $util.isInteger(message.orders.high)))
                        return "orders: integer|Long expected";
                if (message.partiallyRefundedOrders != null && message.hasOwnProperty("partiallyRefundedOrders"))
                    if (!$util.isInteger(message.partiallyRefundedOrders) && !(message.partiallyRefundedOrders && $util.isInteger(message.partiallyRefundedOrders.low) && $util.isInteger(message.partiallyRefundedOrders.high)))
                        return "partiallyRefundedOrders: integer|Long expected";
                if (message.refundedOrders != null && message.hasOwnProperty("refundedOrders"))
                    if (!$util.isInteger(message.refundedOrders) && !(message.refundedOrders && $util.isInteger(message.refundedOrders.low) && $util.isInteger(message.refundedOrders.high)))
                        return "refundedOrders: integer|Long expected";
                if (message.subtotal != null && message.hasOwnProperty("subtotal")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.subtotal);
                    if (error)
                        return "subtotal." + error;
                }
                if (message.discounts != null && message.hasOwnProperty("discounts")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.discounts);
                    if (error)
                        return "discounts." + error;
                }
                if (message.tax != null && message.hasOwnProperty("tax")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.tax);
                    if (error)
                        return "tax." + error;
                }
                if (message.tips != null && message.hasOwnProperty("tips")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.tips);
                    if (error)
                        return "tips." + error;
                }
                if (message.deliveryFeesSelf != null && message.hasOwnProperty("deliveryFeesSelf")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.deliveryFeesSelf);
                    if (error)
                        return "deliveryFeesSelf." + error;
                }
                if (message.deliveryTipsSelf != null && message.hasOwnProperty("deliveryTipsSelf")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.deliveryTipsSelf);
                    if (error)
                        return "deliveryTipsSelf." + error;
                }
                if (message.deliveryFeesDoorDash != null && message.hasOwnProperty("deliveryFeesDoorDash")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.deliveryFeesDoorDash);
                    if (error)
                        return "deliveryFeesDoorDash." + error;
                }
                if (message.deliveryTipsDoorDash != null && message.hasOwnProperty("deliveryTipsDoorDash")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.deliveryTipsDoorDash);
                    if (error)
                        return "deliveryTipsDoorDash." + error;
                }
                if (message.creditCardFeeAdjustment != null && message.hasOwnProperty("creditCardFeeAdjustment")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.creditCardFeeAdjustment);
                    if (error)
                        return "creditCardFeeAdjustment." + error;
                }
                if (message.stripeFee != null && message.hasOwnProperty("stripeFee")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.stripeFee);
                    if (error)
                        return "stripeFee." + error;
                }
                if (message.waiterNowFee != null && message.hasOwnProperty("waiterNowFee")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.waiterNowFee);
                    if (error)
                        return "waiterNowFee." + error;
                }
                if (message.total != null && message.hasOwnProperty("total")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.total);
                    if (error)
                        return "total." + error;
                }
                if (message.netPaidToBusiness != null && message.hasOwnProperty("netPaidToBusiness")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.netPaidToBusiness);
                    if (error)
                        return "netPaidToBusiness." + error;
                }
                if (message.refunds != null && message.hasOwnProperty("refunds")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.refunds);
                    if (error)
                        return "refunds." + error;
                }
                if (message.creditCardFeeAdjustmentForThirdPartyDelivery != null && message.hasOwnProperty("creditCardFeeAdjustmentForThirdPartyDelivery")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.creditCardFeeAdjustmentForThirdPartyDelivery);
                    if (error)
                        return "creditCardFeeAdjustmentForThirdPartyDelivery." + error;
                }
                if (message.disputedOrders != null && message.hasOwnProperty("disputedOrders"))
                    if (!$util.isInteger(message.disputedOrders) && !(message.disputedOrders && $util.isInteger(message.disputedOrders.low) && $util.isInteger(message.disputedOrders.high)))
                        return "disputedOrders: integer|Long expected";
                if (message.disputes != null && message.hasOwnProperty("disputes")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.disputes);
                    if (error)
                        return "disputes." + error;
                }
                return null;
            };

            /**
             * Creates a SalesSummaryReportProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.SalesSummaryReportProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.SalesSummaryReportProto} SalesSummaryReportProto
             */
            SalesSummaryReportProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.SalesSummaryReportProto)
                    return object;
                var message = new $root.waiternow.common.SalesSummaryReportProto();
                if (object.locationId != null)
                    message.locationId = String(object.locationId);
                if (object.period != null) {
                    if (typeof object.period !== "object")
                        throw TypeError(".waiternow.common.SalesSummaryReportProto.period: object expected");
                    message.period = $root.waiternow.common.DateRangeProto.fromObject(object.period);
                }
                if (object.orders != null)
                    if ($util.Long)
                        (message.orders = $util.Long.fromValue(object.orders)).unsigned = false;
                    else if (typeof object.orders === "string")
                        message.orders = parseInt(object.orders, 10);
                    else if (typeof object.orders === "number")
                        message.orders = object.orders;
                    else if (typeof object.orders === "object")
                        message.orders = new $util.LongBits(object.orders.low >>> 0, object.orders.high >>> 0).toNumber();
                if (object.partiallyRefundedOrders != null)
                    if ($util.Long)
                        (message.partiallyRefundedOrders = $util.Long.fromValue(object.partiallyRefundedOrders)).unsigned = false;
                    else if (typeof object.partiallyRefundedOrders === "string")
                        message.partiallyRefundedOrders = parseInt(object.partiallyRefundedOrders, 10);
                    else if (typeof object.partiallyRefundedOrders === "number")
                        message.partiallyRefundedOrders = object.partiallyRefundedOrders;
                    else if (typeof object.partiallyRefundedOrders === "object")
                        message.partiallyRefundedOrders = new $util.LongBits(object.partiallyRefundedOrders.low >>> 0, object.partiallyRefundedOrders.high >>> 0).toNumber();
                if (object.refundedOrders != null)
                    if ($util.Long)
                        (message.refundedOrders = $util.Long.fromValue(object.refundedOrders)).unsigned = false;
                    else if (typeof object.refundedOrders === "string")
                        message.refundedOrders = parseInt(object.refundedOrders, 10);
                    else if (typeof object.refundedOrders === "number")
                        message.refundedOrders = object.refundedOrders;
                    else if (typeof object.refundedOrders === "object")
                        message.refundedOrders = new $util.LongBits(object.refundedOrders.low >>> 0, object.refundedOrders.high >>> 0).toNumber();
                if (object.subtotal != null) {
                    if (typeof object.subtotal !== "object")
                        throw TypeError(".waiternow.common.SalesSummaryReportProto.subtotal: object expected");
                    message.subtotal = $root.waiternow.common.MoneyProto.fromObject(object.subtotal);
                }
                if (object.discounts != null) {
                    if (typeof object.discounts !== "object")
                        throw TypeError(".waiternow.common.SalesSummaryReportProto.discounts: object expected");
                    message.discounts = $root.waiternow.common.MoneyProto.fromObject(object.discounts);
                }
                if (object.tax != null) {
                    if (typeof object.tax !== "object")
                        throw TypeError(".waiternow.common.SalesSummaryReportProto.tax: object expected");
                    message.tax = $root.waiternow.common.MoneyProto.fromObject(object.tax);
                }
                if (object.tips != null) {
                    if (typeof object.tips !== "object")
                        throw TypeError(".waiternow.common.SalesSummaryReportProto.tips: object expected");
                    message.tips = $root.waiternow.common.MoneyProto.fromObject(object.tips);
                }
                if (object.deliveryFeesSelf != null) {
                    if (typeof object.deliveryFeesSelf !== "object")
                        throw TypeError(".waiternow.common.SalesSummaryReportProto.deliveryFeesSelf: object expected");
                    message.deliveryFeesSelf = $root.waiternow.common.MoneyProto.fromObject(object.deliveryFeesSelf);
                }
                if (object.deliveryTipsSelf != null) {
                    if (typeof object.deliveryTipsSelf !== "object")
                        throw TypeError(".waiternow.common.SalesSummaryReportProto.deliveryTipsSelf: object expected");
                    message.deliveryTipsSelf = $root.waiternow.common.MoneyProto.fromObject(object.deliveryTipsSelf);
                }
                if (object.deliveryFeesDoorDash != null) {
                    if (typeof object.deliveryFeesDoorDash !== "object")
                        throw TypeError(".waiternow.common.SalesSummaryReportProto.deliveryFeesDoorDash: object expected");
                    message.deliveryFeesDoorDash = $root.waiternow.common.MoneyProto.fromObject(object.deliveryFeesDoorDash);
                }
                if (object.deliveryTipsDoorDash != null) {
                    if (typeof object.deliveryTipsDoorDash !== "object")
                        throw TypeError(".waiternow.common.SalesSummaryReportProto.deliveryTipsDoorDash: object expected");
                    message.deliveryTipsDoorDash = $root.waiternow.common.MoneyProto.fromObject(object.deliveryTipsDoorDash);
                }
                if (object.creditCardFeeAdjustment != null) {
                    if (typeof object.creditCardFeeAdjustment !== "object")
                        throw TypeError(".waiternow.common.SalesSummaryReportProto.creditCardFeeAdjustment: object expected");
                    message.creditCardFeeAdjustment = $root.waiternow.common.MoneyProto.fromObject(object.creditCardFeeAdjustment);
                }
                if (object.stripeFee != null) {
                    if (typeof object.stripeFee !== "object")
                        throw TypeError(".waiternow.common.SalesSummaryReportProto.stripeFee: object expected");
                    message.stripeFee = $root.waiternow.common.MoneyProto.fromObject(object.stripeFee);
                }
                if (object.waiterNowFee != null) {
                    if (typeof object.waiterNowFee !== "object")
                        throw TypeError(".waiternow.common.SalesSummaryReportProto.waiterNowFee: object expected");
                    message.waiterNowFee = $root.waiternow.common.MoneyProto.fromObject(object.waiterNowFee);
                }
                if (object.total != null) {
                    if (typeof object.total !== "object")
                        throw TypeError(".waiternow.common.SalesSummaryReportProto.total: object expected");
                    message.total = $root.waiternow.common.MoneyProto.fromObject(object.total);
                }
                if (object.netPaidToBusiness != null) {
                    if (typeof object.netPaidToBusiness !== "object")
                        throw TypeError(".waiternow.common.SalesSummaryReportProto.netPaidToBusiness: object expected");
                    message.netPaidToBusiness = $root.waiternow.common.MoneyProto.fromObject(object.netPaidToBusiness);
                }
                if (object.refunds != null) {
                    if (typeof object.refunds !== "object")
                        throw TypeError(".waiternow.common.SalesSummaryReportProto.refunds: object expected");
                    message.refunds = $root.waiternow.common.MoneyProto.fromObject(object.refunds);
                }
                if (object.creditCardFeeAdjustmentForThirdPartyDelivery != null) {
                    if (typeof object.creditCardFeeAdjustmentForThirdPartyDelivery !== "object")
                        throw TypeError(".waiternow.common.SalesSummaryReportProto.creditCardFeeAdjustmentForThirdPartyDelivery: object expected");
                    message.creditCardFeeAdjustmentForThirdPartyDelivery = $root.waiternow.common.MoneyProto.fromObject(object.creditCardFeeAdjustmentForThirdPartyDelivery);
                }
                if (object.disputedOrders != null)
                    if ($util.Long)
                        (message.disputedOrders = $util.Long.fromValue(object.disputedOrders)).unsigned = false;
                    else if (typeof object.disputedOrders === "string")
                        message.disputedOrders = parseInt(object.disputedOrders, 10);
                    else if (typeof object.disputedOrders === "number")
                        message.disputedOrders = object.disputedOrders;
                    else if (typeof object.disputedOrders === "object")
                        message.disputedOrders = new $util.LongBits(object.disputedOrders.low >>> 0, object.disputedOrders.high >>> 0).toNumber();
                if (object.disputes != null) {
                    if (typeof object.disputes !== "object")
                        throw TypeError(".waiternow.common.SalesSummaryReportProto.disputes: object expected");
                    message.disputes = $root.waiternow.common.MoneyProto.fromObject(object.disputes);
                }
                return message;
            };

            /**
             * Creates a plain object from a SalesSummaryReportProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.SalesSummaryReportProto
             * @static
             * @param {waiternow.common.SalesSummaryReportProto} message SalesSummaryReportProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SalesSummaryReportProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.locationId = "";
                    object.period = null;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.orders = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.orders = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.partiallyRefundedOrders = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.partiallyRefundedOrders = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.refundedOrders = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.refundedOrders = options.longs === String ? "0" : 0;
                    object.subtotal = null;
                    object.discounts = null;
                    object.tax = null;
                    object.tips = null;
                    object.deliveryFeesSelf = null;
                    object.deliveryTipsSelf = null;
                    object.deliveryFeesDoorDash = null;
                    object.deliveryTipsDoorDash = null;
                    object.creditCardFeeAdjustment = null;
                    object.stripeFee = null;
                    object.waiterNowFee = null;
                    object.total = null;
                    object.netPaidToBusiness = null;
                    object.refunds = null;
                    object.creditCardFeeAdjustmentForThirdPartyDelivery = null;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.disputedOrders = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.disputedOrders = options.longs === String ? "0" : 0;
                    object.disputes = null;
                }
                if (message.locationId != null && message.hasOwnProperty("locationId"))
                    object.locationId = message.locationId;
                if (message.period != null && message.hasOwnProperty("period"))
                    object.period = $root.waiternow.common.DateRangeProto.toObject(message.period, options);
                if (message.orders != null && message.hasOwnProperty("orders"))
                    if (typeof message.orders === "number")
                        object.orders = options.longs === String ? String(message.orders) : message.orders;
                    else
                        object.orders = options.longs === String ? $util.Long.prototype.toString.call(message.orders) : options.longs === Number ? new $util.LongBits(message.orders.low >>> 0, message.orders.high >>> 0).toNumber() : message.orders;
                if (message.partiallyRefundedOrders != null && message.hasOwnProperty("partiallyRefundedOrders"))
                    if (typeof message.partiallyRefundedOrders === "number")
                        object.partiallyRefundedOrders = options.longs === String ? String(message.partiallyRefundedOrders) : message.partiallyRefundedOrders;
                    else
                        object.partiallyRefundedOrders = options.longs === String ? $util.Long.prototype.toString.call(message.partiallyRefundedOrders) : options.longs === Number ? new $util.LongBits(message.partiallyRefundedOrders.low >>> 0, message.partiallyRefundedOrders.high >>> 0).toNumber() : message.partiallyRefundedOrders;
                if (message.refundedOrders != null && message.hasOwnProperty("refundedOrders"))
                    if (typeof message.refundedOrders === "number")
                        object.refundedOrders = options.longs === String ? String(message.refundedOrders) : message.refundedOrders;
                    else
                        object.refundedOrders = options.longs === String ? $util.Long.prototype.toString.call(message.refundedOrders) : options.longs === Number ? new $util.LongBits(message.refundedOrders.low >>> 0, message.refundedOrders.high >>> 0).toNumber() : message.refundedOrders;
                if (message.subtotal != null && message.hasOwnProperty("subtotal"))
                    object.subtotal = $root.waiternow.common.MoneyProto.toObject(message.subtotal, options);
                if (message.discounts != null && message.hasOwnProperty("discounts"))
                    object.discounts = $root.waiternow.common.MoneyProto.toObject(message.discounts, options);
                if (message.tax != null && message.hasOwnProperty("tax"))
                    object.tax = $root.waiternow.common.MoneyProto.toObject(message.tax, options);
                if (message.tips != null && message.hasOwnProperty("tips"))
                    object.tips = $root.waiternow.common.MoneyProto.toObject(message.tips, options);
                if (message.deliveryFeesSelf != null && message.hasOwnProperty("deliveryFeesSelf"))
                    object.deliveryFeesSelf = $root.waiternow.common.MoneyProto.toObject(message.deliveryFeesSelf, options);
                if (message.deliveryTipsSelf != null && message.hasOwnProperty("deliveryTipsSelf"))
                    object.deliveryTipsSelf = $root.waiternow.common.MoneyProto.toObject(message.deliveryTipsSelf, options);
                if (message.deliveryFeesDoorDash != null && message.hasOwnProperty("deliveryFeesDoorDash"))
                    object.deliveryFeesDoorDash = $root.waiternow.common.MoneyProto.toObject(message.deliveryFeesDoorDash, options);
                if (message.deliveryTipsDoorDash != null && message.hasOwnProperty("deliveryTipsDoorDash"))
                    object.deliveryTipsDoorDash = $root.waiternow.common.MoneyProto.toObject(message.deliveryTipsDoorDash, options);
                if (message.creditCardFeeAdjustment != null && message.hasOwnProperty("creditCardFeeAdjustment"))
                    object.creditCardFeeAdjustment = $root.waiternow.common.MoneyProto.toObject(message.creditCardFeeAdjustment, options);
                if (message.stripeFee != null && message.hasOwnProperty("stripeFee"))
                    object.stripeFee = $root.waiternow.common.MoneyProto.toObject(message.stripeFee, options);
                if (message.waiterNowFee != null && message.hasOwnProperty("waiterNowFee"))
                    object.waiterNowFee = $root.waiternow.common.MoneyProto.toObject(message.waiterNowFee, options);
                if (message.total != null && message.hasOwnProperty("total"))
                    object.total = $root.waiternow.common.MoneyProto.toObject(message.total, options);
                if (message.netPaidToBusiness != null && message.hasOwnProperty("netPaidToBusiness"))
                    object.netPaidToBusiness = $root.waiternow.common.MoneyProto.toObject(message.netPaidToBusiness, options);
                if (message.refunds != null && message.hasOwnProperty("refunds"))
                    object.refunds = $root.waiternow.common.MoneyProto.toObject(message.refunds, options);
                if (message.creditCardFeeAdjustmentForThirdPartyDelivery != null && message.hasOwnProperty("creditCardFeeAdjustmentForThirdPartyDelivery"))
                    object.creditCardFeeAdjustmentForThirdPartyDelivery = $root.waiternow.common.MoneyProto.toObject(message.creditCardFeeAdjustmentForThirdPartyDelivery, options);
                if (message.disputedOrders != null && message.hasOwnProperty("disputedOrders"))
                    if (typeof message.disputedOrders === "number")
                        object.disputedOrders = options.longs === String ? String(message.disputedOrders) : message.disputedOrders;
                    else
                        object.disputedOrders = options.longs === String ? $util.Long.prototype.toString.call(message.disputedOrders) : options.longs === Number ? new $util.LongBits(message.disputedOrders.low >>> 0, message.disputedOrders.high >>> 0).toNumber() : message.disputedOrders;
                if (message.disputes != null && message.hasOwnProperty("disputes"))
                    object.disputes = $root.waiternow.common.MoneyProto.toObject(message.disputes, options);
                return object;
            };

            /**
             * Converts this SalesSummaryReportProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.SalesSummaryReportProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SalesSummaryReportProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for SalesSummaryReportProto
             * @function getTypeUrl
             * @memberof waiternow.common.SalesSummaryReportProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            SalesSummaryReportProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.SalesSummaryReportProto";
            };

            return SalesSummaryReportProto;
        })();

        common.PartInfoProto = (function() {

            /**
             * Properties of a PartInfoProto.
             * @memberof waiternow.common
             * @interface IPartInfoProto
             * @property {number|null} [index] PartInfoProto index
             * @property {number|null} [size] PartInfoProto size
             * @property {string|null} [station] PartInfoProto station
             */

            /**
             * Constructs a new PartInfoProto.
             * @memberof waiternow.common
             * @classdesc Represents a PartInfoProto.
             * @implements IPartInfoProto
             * @constructor
             * @param {waiternow.common.IPartInfoProto=} [properties] Properties to set
             */
            function PartInfoProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * PartInfoProto index.
             * @member {number} index
             * @memberof waiternow.common.PartInfoProto
             * @instance
             */
            PartInfoProto.prototype.index = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * PartInfoProto size.
             * @member {number} size
             * @memberof waiternow.common.PartInfoProto
             * @instance
             */
            PartInfoProto.prototype.size = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * PartInfoProto station.
             * @member {string} station
             * @memberof waiternow.common.PartInfoProto
             * @instance
             */
            PartInfoProto.prototype.station = "";

            /**
             * Creates a new PartInfoProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.PartInfoProto
             * @static
             * @param {waiternow.common.IPartInfoProto=} [properties] Properties to set
             * @returns {waiternow.common.PartInfoProto} PartInfoProto instance
             */
            PartInfoProto.create = function create(properties) {
                return new PartInfoProto(properties);
            };

            /**
             * Encodes the specified PartInfoProto message. Does not implicitly {@link waiternow.common.PartInfoProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.PartInfoProto
             * @static
             * @param {waiternow.common.IPartInfoProto} message PartInfoProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PartInfoProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.index != null && Object.hasOwnProperty.call(message, "index"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int64(message.index);
                if (message.size != null && Object.hasOwnProperty.call(message, "size"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int64(message.size);
                if (message.station != null && Object.hasOwnProperty.call(message, "station"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.station);
                return writer;
            };

            /**
             * Encodes the specified PartInfoProto message, length delimited. Does not implicitly {@link waiternow.common.PartInfoProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.PartInfoProto
             * @static
             * @param {waiternow.common.IPartInfoProto} message PartInfoProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PartInfoProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a PartInfoProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.PartInfoProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.PartInfoProto} PartInfoProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PartInfoProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PartInfoProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.index = reader.int64();
                            break;
                        }
                    case 2: {
                            message.size = reader.int64();
                            break;
                        }
                    case 3: {
                            message.station = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a PartInfoProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.PartInfoProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.PartInfoProto} PartInfoProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PartInfoProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a PartInfoProto message.
             * @function verify
             * @memberof waiternow.common.PartInfoProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            PartInfoProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.index != null && message.hasOwnProperty("index"))
                    if (!$util.isInteger(message.index) && !(message.index && $util.isInteger(message.index.low) && $util.isInteger(message.index.high)))
                        return "index: integer|Long expected";
                if (message.size != null && message.hasOwnProperty("size"))
                    if (!$util.isInteger(message.size) && !(message.size && $util.isInteger(message.size.low) && $util.isInteger(message.size.high)))
                        return "size: integer|Long expected";
                if (message.station != null && message.hasOwnProperty("station"))
                    if (!$util.isString(message.station))
                        return "station: string expected";
                return null;
            };

            /**
             * Creates a PartInfoProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.PartInfoProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.PartInfoProto} PartInfoProto
             */
            PartInfoProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.PartInfoProto)
                    return object;
                var message = new $root.waiternow.common.PartInfoProto();
                if (object.index != null)
                    if ($util.Long)
                        (message.index = $util.Long.fromValue(object.index)).unsigned = false;
                    else if (typeof object.index === "string")
                        message.index = parseInt(object.index, 10);
                    else if (typeof object.index === "number")
                        message.index = object.index;
                    else if (typeof object.index === "object")
                        message.index = new $util.LongBits(object.index.low >>> 0, object.index.high >>> 0).toNumber();
                if (object.size != null)
                    if ($util.Long)
                        (message.size = $util.Long.fromValue(object.size)).unsigned = false;
                    else if (typeof object.size === "string")
                        message.size = parseInt(object.size, 10);
                    else if (typeof object.size === "number")
                        message.size = object.size;
                    else if (typeof object.size === "object")
                        message.size = new $util.LongBits(object.size.low >>> 0, object.size.high >>> 0).toNumber();
                if (object.station != null)
                    message.station = String(object.station);
                return message;
            };

            /**
             * Creates a plain object from a PartInfoProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.PartInfoProto
             * @static
             * @param {waiternow.common.PartInfoProto} message PartInfoProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            PartInfoProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.index = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.index = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.size = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.size = options.longs === String ? "0" : 0;
                    object.station = "";
                }
                if (message.index != null && message.hasOwnProperty("index"))
                    if (typeof message.index === "number")
                        object.index = options.longs === String ? String(message.index) : message.index;
                    else
                        object.index = options.longs === String ? $util.Long.prototype.toString.call(message.index) : options.longs === Number ? new $util.LongBits(message.index.low >>> 0, message.index.high >>> 0).toNumber() : message.index;
                if (message.size != null && message.hasOwnProperty("size"))
                    if (typeof message.size === "number")
                        object.size = options.longs === String ? String(message.size) : message.size;
                    else
                        object.size = options.longs === String ? $util.Long.prototype.toString.call(message.size) : options.longs === Number ? new $util.LongBits(message.size.low >>> 0, message.size.high >>> 0).toNumber() : message.size;
                if (message.station != null && message.hasOwnProperty("station"))
                    object.station = message.station;
                return object;
            };

            /**
             * Converts this PartInfoProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.PartInfoProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            PartInfoProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for PartInfoProto
             * @function getTypeUrl
             * @memberof waiternow.common.PartInfoProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            PartInfoProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.PartInfoProto";
            };

            return PartInfoProto;
        })();

        common.DeliveryProto = (function() {

            /**
             * Properties of a DeliveryProto.
             * @memberof waiternow.common
             * @interface IDeliveryProto
             * @property {string|null} [id] DeliveryProto id
             * @property {google.protobuf.ITimestamp|null} [creationTime] DeliveryProto creationTime
             * @property {google.protobuf.ITimestamp|null} [lastUpdateTime] DeliveryProto lastUpdateTime
             * @property {string|null} [locationId] DeliveryProto locationId
             * @property {string|null} [businessName] DeliveryProto businessName
             * @property {waiternow.common.IAddressProto|null} [locationAddress] DeliveryProto locationAddress
             * @property {waiternow.common.IPhoneNumberProto|null} [locationPhoneNumber] DeliveryProto locationPhoneNumber
             * @property {waiternow.common.IAddressProto|null} [deliveryAddress] DeliveryProto deliveryAddress
             * @property {waiternow.common.IPhoneNumberProto|null} [consumerPhoneNumber] DeliveryProto consumerPhoneNumber
             * @property {string|null} [consumerEmail] DeliveryProto consumerEmail
             * @property {google.protobuf.ITimestamp|null} [requestedPickupTime] DeliveryProto requestedPickupTime
             * @property {google.protobuf.ITimestamp|null} [requestedDropoffTime] DeliveryProto requestedDropoffTime
             * @property {string|null} [deliveryIdFromCarrier] DeliveryProto deliveryIdFromCarrier
             * @property {waiternow.common.DeliveryCarrier|null} [deliveryCarrier] DeliveryProto deliveryCarrier
             * @property {waiternow.common.IDistanceQuantityProto|null} [distance] DeliveryProto distance
             * @property {waiternow.common.IMoneyProto|null} [fee] DeliveryProto fee
             * @property {google.protobuf.IDuration|null} [quoteExpiration] DeliveryProto quoteExpiration
             * @property {waiternow.common.DeliveryProto.Status|null} [status] DeliveryProto status
             * @property {string|null} [trackingUrl] DeliveryProto trackingUrl
             * @property {boolean|null} [containsAlcohol] DeliveryProto containsAlcohol
             * @property {google.protobuf.ITimestamp|null} [estimatedPickupTime] DeliveryProto estimatedPickupTime
             * @property {google.protobuf.ITimestamp|null} [estimatedDropoffTime] DeliveryProto estimatedDropoffTime
             * @property {waiternow.common.IMoneyProto|null} [deliveryTip] DeliveryProto deliveryTip
             * @property {string|null} [consumerName] DeliveryProto consumerName
             * @property {string|null} [dropoffInstructions] DeliveryProto dropoffInstructions
             * @property {boolean|null} [contactlessDropoff] DeliveryProto contactlessDropoff
             */

            /**
             * Constructs a new DeliveryProto.
             * @memberof waiternow.common
             * @classdesc Represents a DeliveryProto.
             * @implements IDeliveryProto
             * @constructor
             * @param {waiternow.common.IDeliveryProto=} [properties] Properties to set
             */
            function DeliveryProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * DeliveryProto id.
             * @member {string} id
             * @memberof waiternow.common.DeliveryProto
             * @instance
             */
            DeliveryProto.prototype.id = "";

            /**
             * DeliveryProto creationTime.
             * @member {google.protobuf.ITimestamp|null|undefined} creationTime
             * @memberof waiternow.common.DeliveryProto
             * @instance
             */
            DeliveryProto.prototype.creationTime = null;

            /**
             * DeliveryProto lastUpdateTime.
             * @member {google.protobuf.ITimestamp|null|undefined} lastUpdateTime
             * @memberof waiternow.common.DeliveryProto
             * @instance
             */
            DeliveryProto.prototype.lastUpdateTime = null;

            /**
             * DeliveryProto locationId.
             * @member {string} locationId
             * @memberof waiternow.common.DeliveryProto
             * @instance
             */
            DeliveryProto.prototype.locationId = "";

            /**
             * DeliveryProto businessName.
             * @member {string} businessName
             * @memberof waiternow.common.DeliveryProto
             * @instance
             */
            DeliveryProto.prototype.businessName = "";

            /**
             * DeliveryProto locationAddress.
             * @member {waiternow.common.IAddressProto|null|undefined} locationAddress
             * @memberof waiternow.common.DeliveryProto
             * @instance
             */
            DeliveryProto.prototype.locationAddress = null;

            /**
             * DeliveryProto locationPhoneNumber.
             * @member {waiternow.common.IPhoneNumberProto|null|undefined} locationPhoneNumber
             * @memberof waiternow.common.DeliveryProto
             * @instance
             */
            DeliveryProto.prototype.locationPhoneNumber = null;

            /**
             * DeliveryProto deliveryAddress.
             * @member {waiternow.common.IAddressProto|null|undefined} deliveryAddress
             * @memberof waiternow.common.DeliveryProto
             * @instance
             */
            DeliveryProto.prototype.deliveryAddress = null;

            /**
             * DeliveryProto consumerPhoneNumber.
             * @member {waiternow.common.IPhoneNumberProto|null|undefined} consumerPhoneNumber
             * @memberof waiternow.common.DeliveryProto
             * @instance
             */
            DeliveryProto.prototype.consumerPhoneNumber = null;

            /**
             * DeliveryProto consumerEmail.
             * @member {string} consumerEmail
             * @memberof waiternow.common.DeliveryProto
             * @instance
             */
            DeliveryProto.prototype.consumerEmail = "";

            /**
             * DeliveryProto requestedPickupTime.
             * @member {google.protobuf.ITimestamp|null|undefined} requestedPickupTime
             * @memberof waiternow.common.DeliveryProto
             * @instance
             */
            DeliveryProto.prototype.requestedPickupTime = null;

            /**
             * DeliveryProto requestedDropoffTime.
             * @member {google.protobuf.ITimestamp|null|undefined} requestedDropoffTime
             * @memberof waiternow.common.DeliveryProto
             * @instance
             */
            DeliveryProto.prototype.requestedDropoffTime = null;

            /**
             * DeliveryProto deliveryIdFromCarrier.
             * @member {string} deliveryIdFromCarrier
             * @memberof waiternow.common.DeliveryProto
             * @instance
             */
            DeliveryProto.prototype.deliveryIdFromCarrier = "";

            /**
             * DeliveryProto deliveryCarrier.
             * @member {waiternow.common.DeliveryCarrier} deliveryCarrier
             * @memberof waiternow.common.DeliveryProto
             * @instance
             */
            DeliveryProto.prototype.deliveryCarrier = 0;

            /**
             * DeliveryProto distance.
             * @member {waiternow.common.IDistanceQuantityProto|null|undefined} distance
             * @memberof waiternow.common.DeliveryProto
             * @instance
             */
            DeliveryProto.prototype.distance = null;

            /**
             * DeliveryProto fee.
             * @member {waiternow.common.IMoneyProto|null|undefined} fee
             * @memberof waiternow.common.DeliveryProto
             * @instance
             */
            DeliveryProto.prototype.fee = null;

            /**
             * DeliveryProto quoteExpiration.
             * @member {google.protobuf.IDuration|null|undefined} quoteExpiration
             * @memberof waiternow.common.DeliveryProto
             * @instance
             */
            DeliveryProto.prototype.quoteExpiration = null;

            /**
             * DeliveryProto status.
             * @member {waiternow.common.DeliveryProto.Status} status
             * @memberof waiternow.common.DeliveryProto
             * @instance
             */
            DeliveryProto.prototype.status = 0;

            /**
             * DeliveryProto trackingUrl.
             * @member {string} trackingUrl
             * @memberof waiternow.common.DeliveryProto
             * @instance
             */
            DeliveryProto.prototype.trackingUrl = "";

            /**
             * DeliveryProto containsAlcohol.
             * @member {boolean} containsAlcohol
             * @memberof waiternow.common.DeliveryProto
             * @instance
             */
            DeliveryProto.prototype.containsAlcohol = false;

            /**
             * DeliveryProto estimatedPickupTime.
             * @member {google.protobuf.ITimestamp|null|undefined} estimatedPickupTime
             * @memberof waiternow.common.DeliveryProto
             * @instance
             */
            DeliveryProto.prototype.estimatedPickupTime = null;

            /**
             * DeliveryProto estimatedDropoffTime.
             * @member {google.protobuf.ITimestamp|null|undefined} estimatedDropoffTime
             * @memberof waiternow.common.DeliveryProto
             * @instance
             */
            DeliveryProto.prototype.estimatedDropoffTime = null;

            /**
             * DeliveryProto deliveryTip.
             * @member {waiternow.common.IMoneyProto|null|undefined} deliveryTip
             * @memberof waiternow.common.DeliveryProto
             * @instance
             */
            DeliveryProto.prototype.deliveryTip = null;

            /**
             * DeliveryProto consumerName.
             * @member {string} consumerName
             * @memberof waiternow.common.DeliveryProto
             * @instance
             */
            DeliveryProto.prototype.consumerName = "";

            /**
             * DeliveryProto dropoffInstructions.
             * @member {string} dropoffInstructions
             * @memberof waiternow.common.DeliveryProto
             * @instance
             */
            DeliveryProto.prototype.dropoffInstructions = "";

            /**
             * DeliveryProto contactlessDropoff.
             * @member {boolean} contactlessDropoff
             * @memberof waiternow.common.DeliveryProto
             * @instance
             */
            DeliveryProto.prototype.contactlessDropoff = false;

            // OneOf field names bound to virtual getters and setters
            var $oneOfFields;

            /**
             * DeliveryProto pickupOrDropoffTimeRequest.
             * @member {"requestedPickupTime"|"requestedDropoffTime"|undefined} pickupOrDropoffTimeRequest
             * @memberof waiternow.common.DeliveryProto
             * @instance
             */
            Object.defineProperty(DeliveryProto.prototype, "pickupOrDropoffTimeRequest", {
                get: $util.oneOfGetter($oneOfFields = ["requestedPickupTime", "requestedDropoffTime"]),
                set: $util.oneOfSetter($oneOfFields)
            });

            /**
             * Creates a new DeliveryProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.DeliveryProto
             * @static
             * @param {waiternow.common.IDeliveryProto=} [properties] Properties to set
             * @returns {waiternow.common.DeliveryProto} DeliveryProto instance
             */
            DeliveryProto.create = function create(properties) {
                return new DeliveryProto(properties);
            };

            /**
             * Encodes the specified DeliveryProto message. Does not implicitly {@link waiternow.common.DeliveryProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.DeliveryProto
             * @static
             * @param {waiternow.common.IDeliveryProto} message DeliveryProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DeliveryProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                if (message.creationTime != null && Object.hasOwnProperty.call(message, "creationTime"))
                    $root.google.protobuf.Timestamp.encode(message.creationTime, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                    $root.google.protobuf.Timestamp.encode(message.lastUpdateTime, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.locationId);
                if (message.businessName != null && Object.hasOwnProperty.call(message, "businessName"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.businessName);
                if (message.locationAddress != null && Object.hasOwnProperty.call(message, "locationAddress"))
                    $root.waiternow.common.AddressProto.encode(message.locationAddress, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                if (message.locationPhoneNumber != null && Object.hasOwnProperty.call(message, "locationPhoneNumber"))
                    $root.waiternow.common.PhoneNumberProto.encode(message.locationPhoneNumber, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                if (message.deliveryAddress != null && Object.hasOwnProperty.call(message, "deliveryAddress"))
                    $root.waiternow.common.AddressProto.encode(message.deliveryAddress, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                if (message.consumerPhoneNumber != null && Object.hasOwnProperty.call(message, "consumerPhoneNumber"))
                    $root.waiternow.common.PhoneNumberProto.encode(message.consumerPhoneNumber, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                if (message.consumerEmail != null && Object.hasOwnProperty.call(message, "consumerEmail"))
                    writer.uint32(/* id 10, wireType 2 =*/82).string(message.consumerEmail);
                if (message.requestedPickupTime != null && Object.hasOwnProperty.call(message, "requestedPickupTime"))
                    $root.google.protobuf.Timestamp.encode(message.requestedPickupTime, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                if (message.requestedDropoffTime != null && Object.hasOwnProperty.call(message, "requestedDropoffTime"))
                    $root.google.protobuf.Timestamp.encode(message.requestedDropoffTime, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                if (message.deliveryIdFromCarrier != null && Object.hasOwnProperty.call(message, "deliveryIdFromCarrier"))
                    writer.uint32(/* id 13, wireType 2 =*/106).string(message.deliveryIdFromCarrier);
                if (message.deliveryCarrier != null && Object.hasOwnProperty.call(message, "deliveryCarrier"))
                    writer.uint32(/* id 14, wireType 0 =*/112).int32(message.deliveryCarrier);
                if (message.distance != null && Object.hasOwnProperty.call(message, "distance"))
                    $root.waiternow.common.DistanceQuantityProto.encode(message.distance, writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
                if (message.fee != null && Object.hasOwnProperty.call(message, "fee"))
                    $root.waiternow.common.MoneyProto.encode(message.fee, writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
                if (message.quoteExpiration != null && Object.hasOwnProperty.call(message, "quoteExpiration"))
                    $root.google.protobuf.Duration.encode(message.quoteExpiration, writer.uint32(/* id 17, wireType 2 =*/138).fork()).ldelim();
                if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                    writer.uint32(/* id 18, wireType 0 =*/144).int32(message.status);
                if (message.trackingUrl != null && Object.hasOwnProperty.call(message, "trackingUrl"))
                    writer.uint32(/* id 19, wireType 2 =*/154).string(message.trackingUrl);
                if (message.containsAlcohol != null && Object.hasOwnProperty.call(message, "containsAlcohol"))
                    writer.uint32(/* id 20, wireType 0 =*/160).bool(message.containsAlcohol);
                if (message.estimatedPickupTime != null && Object.hasOwnProperty.call(message, "estimatedPickupTime"))
                    $root.google.protobuf.Timestamp.encode(message.estimatedPickupTime, writer.uint32(/* id 21, wireType 2 =*/170).fork()).ldelim();
                if (message.estimatedDropoffTime != null && Object.hasOwnProperty.call(message, "estimatedDropoffTime"))
                    $root.google.protobuf.Timestamp.encode(message.estimatedDropoffTime, writer.uint32(/* id 22, wireType 2 =*/178).fork()).ldelim();
                if (message.deliveryTip != null && Object.hasOwnProperty.call(message, "deliveryTip"))
                    $root.waiternow.common.MoneyProto.encode(message.deliveryTip, writer.uint32(/* id 23, wireType 2 =*/186).fork()).ldelim();
                if (message.consumerName != null && Object.hasOwnProperty.call(message, "consumerName"))
                    writer.uint32(/* id 25, wireType 2 =*/202).string(message.consumerName);
                if (message.dropoffInstructions != null && Object.hasOwnProperty.call(message, "dropoffInstructions"))
                    writer.uint32(/* id 26, wireType 2 =*/210).string(message.dropoffInstructions);
                if (message.contactlessDropoff != null && Object.hasOwnProperty.call(message, "contactlessDropoff"))
                    writer.uint32(/* id 27, wireType 0 =*/216).bool(message.contactlessDropoff);
                return writer;
            };

            /**
             * Encodes the specified DeliveryProto message, length delimited. Does not implicitly {@link waiternow.common.DeliveryProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.DeliveryProto
             * @static
             * @param {waiternow.common.IDeliveryProto} message DeliveryProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DeliveryProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a DeliveryProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.DeliveryProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.DeliveryProto} DeliveryProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DeliveryProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.DeliveryProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.id = reader.string();
                            break;
                        }
                    case 2: {
                            message.creationTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 3: {
                            message.lastUpdateTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 4: {
                            message.locationId = reader.string();
                            break;
                        }
                    case 5: {
                            message.businessName = reader.string();
                            break;
                        }
                    case 6: {
                            message.locationAddress = $root.waiternow.common.AddressProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 7: {
                            message.locationPhoneNumber = $root.waiternow.common.PhoneNumberProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 8: {
                            message.deliveryAddress = $root.waiternow.common.AddressProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 9: {
                            message.consumerPhoneNumber = $root.waiternow.common.PhoneNumberProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 10: {
                            message.consumerEmail = reader.string();
                            break;
                        }
                    case 11: {
                            message.requestedPickupTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 12: {
                            message.requestedDropoffTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 13: {
                            message.deliveryIdFromCarrier = reader.string();
                            break;
                        }
                    case 14: {
                            message.deliveryCarrier = reader.int32();
                            break;
                        }
                    case 15: {
                            message.distance = $root.waiternow.common.DistanceQuantityProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 16: {
                            message.fee = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 17: {
                            message.quoteExpiration = $root.google.protobuf.Duration.decode(reader, reader.uint32());
                            break;
                        }
                    case 18: {
                            message.status = reader.int32();
                            break;
                        }
                    case 19: {
                            message.trackingUrl = reader.string();
                            break;
                        }
                    case 20: {
                            message.containsAlcohol = reader.bool();
                            break;
                        }
                    case 21: {
                            message.estimatedPickupTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 22: {
                            message.estimatedDropoffTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 23: {
                            message.deliveryTip = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 25: {
                            message.consumerName = reader.string();
                            break;
                        }
                    case 26: {
                            message.dropoffInstructions = reader.string();
                            break;
                        }
                    case 27: {
                            message.contactlessDropoff = reader.bool();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a DeliveryProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.DeliveryProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.DeliveryProto} DeliveryProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DeliveryProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a DeliveryProto message.
             * @function verify
             * @memberof waiternow.common.DeliveryProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            DeliveryProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                var properties = {};
                if (message.id != null && message.hasOwnProperty("id"))
                    if (!$util.isString(message.id))
                        return "id: string expected";
                if (message.creationTime != null && message.hasOwnProperty("creationTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.creationTime);
                    if (error)
                        return "creationTime." + error;
                }
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.lastUpdateTime);
                    if (error)
                        return "lastUpdateTime." + error;
                }
                if (message.locationId != null && message.hasOwnProperty("locationId"))
                    if (!$util.isString(message.locationId))
                        return "locationId: string expected";
                if (message.businessName != null && message.hasOwnProperty("businessName"))
                    if (!$util.isString(message.businessName))
                        return "businessName: string expected";
                if (message.locationAddress != null && message.hasOwnProperty("locationAddress")) {
                    var error = $root.waiternow.common.AddressProto.verify(message.locationAddress);
                    if (error)
                        return "locationAddress." + error;
                }
                if (message.locationPhoneNumber != null && message.hasOwnProperty("locationPhoneNumber")) {
                    var error = $root.waiternow.common.PhoneNumberProto.verify(message.locationPhoneNumber);
                    if (error)
                        return "locationPhoneNumber." + error;
                }
                if (message.deliveryAddress != null && message.hasOwnProperty("deliveryAddress")) {
                    var error = $root.waiternow.common.AddressProto.verify(message.deliveryAddress);
                    if (error)
                        return "deliveryAddress." + error;
                }
                if (message.consumerPhoneNumber != null && message.hasOwnProperty("consumerPhoneNumber")) {
                    var error = $root.waiternow.common.PhoneNumberProto.verify(message.consumerPhoneNumber);
                    if (error)
                        return "consumerPhoneNumber." + error;
                }
                if (message.consumerEmail != null && message.hasOwnProperty("consumerEmail"))
                    if (!$util.isString(message.consumerEmail))
                        return "consumerEmail: string expected";
                if (message.requestedPickupTime != null && message.hasOwnProperty("requestedPickupTime")) {
                    properties.pickupOrDropoffTimeRequest = 1;
                    {
                        var error = $root.google.protobuf.Timestamp.verify(message.requestedPickupTime);
                        if (error)
                            return "requestedPickupTime." + error;
                    }
                }
                if (message.requestedDropoffTime != null && message.hasOwnProperty("requestedDropoffTime")) {
                    if (properties.pickupOrDropoffTimeRequest === 1)
                        return "pickupOrDropoffTimeRequest: multiple values";
                    properties.pickupOrDropoffTimeRequest = 1;
                    {
                        var error = $root.google.protobuf.Timestamp.verify(message.requestedDropoffTime);
                        if (error)
                            return "requestedDropoffTime." + error;
                    }
                }
                if (message.deliveryIdFromCarrier != null && message.hasOwnProperty("deliveryIdFromCarrier"))
                    if (!$util.isString(message.deliveryIdFromCarrier))
                        return "deliveryIdFromCarrier: string expected";
                if (message.deliveryCarrier != null && message.hasOwnProperty("deliveryCarrier"))
                    switch (message.deliveryCarrier) {
                    default:
                        return "deliveryCarrier: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                        break;
                    }
                if (message.distance != null && message.hasOwnProperty("distance")) {
                    var error = $root.waiternow.common.DistanceQuantityProto.verify(message.distance);
                    if (error)
                        return "distance." + error;
                }
                if (message.fee != null && message.hasOwnProperty("fee")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.fee);
                    if (error)
                        return "fee." + error;
                }
                if (message.quoteExpiration != null && message.hasOwnProperty("quoteExpiration")) {
                    var error = $root.google.protobuf.Duration.verify(message.quoteExpiration);
                    if (error)
                        return "quoteExpiration." + error;
                }
                if (message.status != null && message.hasOwnProperty("status"))
                    switch (message.status) {
                    default:
                        return "status: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                        break;
                    }
                if (message.trackingUrl != null && message.hasOwnProperty("trackingUrl"))
                    if (!$util.isString(message.trackingUrl))
                        return "trackingUrl: string expected";
                if (message.containsAlcohol != null && message.hasOwnProperty("containsAlcohol"))
                    if (typeof message.containsAlcohol !== "boolean")
                        return "containsAlcohol: boolean expected";
                if (message.estimatedPickupTime != null && message.hasOwnProperty("estimatedPickupTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.estimatedPickupTime);
                    if (error)
                        return "estimatedPickupTime." + error;
                }
                if (message.estimatedDropoffTime != null && message.hasOwnProperty("estimatedDropoffTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.estimatedDropoffTime);
                    if (error)
                        return "estimatedDropoffTime." + error;
                }
                if (message.deliveryTip != null && message.hasOwnProperty("deliveryTip")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.deliveryTip);
                    if (error)
                        return "deliveryTip." + error;
                }
                if (message.consumerName != null && message.hasOwnProperty("consumerName"))
                    if (!$util.isString(message.consumerName))
                        return "consumerName: string expected";
                if (message.dropoffInstructions != null && message.hasOwnProperty("dropoffInstructions"))
                    if (!$util.isString(message.dropoffInstructions))
                        return "dropoffInstructions: string expected";
                if (message.contactlessDropoff != null && message.hasOwnProperty("contactlessDropoff"))
                    if (typeof message.contactlessDropoff !== "boolean")
                        return "contactlessDropoff: boolean expected";
                return null;
            };

            /**
             * Creates a DeliveryProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.DeliveryProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.DeliveryProto} DeliveryProto
             */
            DeliveryProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.DeliveryProto)
                    return object;
                var message = new $root.waiternow.common.DeliveryProto();
                if (object.id != null)
                    message.id = String(object.id);
                if (object.creationTime != null) {
                    if (typeof object.creationTime !== "object")
                        throw TypeError(".waiternow.common.DeliveryProto.creationTime: object expected");
                    message.creationTime = $root.google.protobuf.Timestamp.fromObject(object.creationTime);
                }
                if (object.lastUpdateTime != null) {
                    if (typeof object.lastUpdateTime !== "object")
                        throw TypeError(".waiternow.common.DeliveryProto.lastUpdateTime: object expected");
                    message.lastUpdateTime = $root.google.protobuf.Timestamp.fromObject(object.lastUpdateTime);
                }
                if (object.locationId != null)
                    message.locationId = String(object.locationId);
                if (object.businessName != null)
                    message.businessName = String(object.businessName);
                if (object.locationAddress != null) {
                    if (typeof object.locationAddress !== "object")
                        throw TypeError(".waiternow.common.DeliveryProto.locationAddress: object expected");
                    message.locationAddress = $root.waiternow.common.AddressProto.fromObject(object.locationAddress);
                }
                if (object.locationPhoneNumber != null) {
                    if (typeof object.locationPhoneNumber !== "object")
                        throw TypeError(".waiternow.common.DeliveryProto.locationPhoneNumber: object expected");
                    message.locationPhoneNumber = $root.waiternow.common.PhoneNumberProto.fromObject(object.locationPhoneNumber);
                }
                if (object.deliveryAddress != null) {
                    if (typeof object.deliveryAddress !== "object")
                        throw TypeError(".waiternow.common.DeliveryProto.deliveryAddress: object expected");
                    message.deliveryAddress = $root.waiternow.common.AddressProto.fromObject(object.deliveryAddress);
                }
                if (object.consumerPhoneNumber != null) {
                    if (typeof object.consumerPhoneNumber !== "object")
                        throw TypeError(".waiternow.common.DeliveryProto.consumerPhoneNumber: object expected");
                    message.consumerPhoneNumber = $root.waiternow.common.PhoneNumberProto.fromObject(object.consumerPhoneNumber);
                }
                if (object.consumerEmail != null)
                    message.consumerEmail = String(object.consumerEmail);
                if (object.requestedPickupTime != null) {
                    if (typeof object.requestedPickupTime !== "object")
                        throw TypeError(".waiternow.common.DeliveryProto.requestedPickupTime: object expected");
                    message.requestedPickupTime = $root.google.protobuf.Timestamp.fromObject(object.requestedPickupTime);
                }
                if (object.requestedDropoffTime != null) {
                    if (typeof object.requestedDropoffTime !== "object")
                        throw TypeError(".waiternow.common.DeliveryProto.requestedDropoffTime: object expected");
                    message.requestedDropoffTime = $root.google.protobuf.Timestamp.fromObject(object.requestedDropoffTime);
                }
                if (object.deliveryIdFromCarrier != null)
                    message.deliveryIdFromCarrier = String(object.deliveryIdFromCarrier);
                switch (object.deliveryCarrier) {
                default:
                    if (typeof object.deliveryCarrier === "number") {
                        message.deliveryCarrier = object.deliveryCarrier;
                        break;
                    }
                    break;
                case "DELIVERY_CARRIER_UNSPECIFIED":
                case 0:
                    message.deliveryCarrier = 0;
                    break;
                case "SELF":
                case 1:
                    message.deliveryCarrier = 1;
                    break;
                case "DOORDASH":
                case 2:
                    message.deliveryCarrier = 2;
                    break;
                }
                if (object.distance != null) {
                    if (typeof object.distance !== "object")
                        throw TypeError(".waiternow.common.DeliveryProto.distance: object expected");
                    message.distance = $root.waiternow.common.DistanceQuantityProto.fromObject(object.distance);
                }
                if (object.fee != null) {
                    if (typeof object.fee !== "object")
                        throw TypeError(".waiternow.common.DeliveryProto.fee: object expected");
                    message.fee = $root.waiternow.common.MoneyProto.fromObject(object.fee);
                }
                if (object.quoteExpiration != null) {
                    if (typeof object.quoteExpiration !== "object")
                        throw TypeError(".waiternow.common.DeliveryProto.quoteExpiration: object expected");
                    message.quoteExpiration = $root.google.protobuf.Duration.fromObject(object.quoteExpiration);
                }
                switch (object.status) {
                default:
                    if (typeof object.status === "number") {
                        message.status = object.status;
                        break;
                    }
                    break;
                case "STATE_UNSPECIFIED":
                case 0:
                    message.status = 0;
                    break;
                case "QUOTE":
                case 1:
                    message.status = 1;
                    break;
                case "ACCEPTED":
                case 2:
                    message.status = 2;
                    break;
                case "FAILED":
                case 3:
                    message.status = 3;
                    break;
                case "CANCELED":
                case 4:
                    message.status = 4;
                    break;
                }
                if (object.trackingUrl != null)
                    message.trackingUrl = String(object.trackingUrl);
                if (object.containsAlcohol != null)
                    message.containsAlcohol = Boolean(object.containsAlcohol);
                if (object.estimatedPickupTime != null) {
                    if (typeof object.estimatedPickupTime !== "object")
                        throw TypeError(".waiternow.common.DeliveryProto.estimatedPickupTime: object expected");
                    message.estimatedPickupTime = $root.google.protobuf.Timestamp.fromObject(object.estimatedPickupTime);
                }
                if (object.estimatedDropoffTime != null) {
                    if (typeof object.estimatedDropoffTime !== "object")
                        throw TypeError(".waiternow.common.DeliveryProto.estimatedDropoffTime: object expected");
                    message.estimatedDropoffTime = $root.google.protobuf.Timestamp.fromObject(object.estimatedDropoffTime);
                }
                if (object.deliveryTip != null) {
                    if (typeof object.deliveryTip !== "object")
                        throw TypeError(".waiternow.common.DeliveryProto.deliveryTip: object expected");
                    message.deliveryTip = $root.waiternow.common.MoneyProto.fromObject(object.deliveryTip);
                }
                if (object.consumerName != null)
                    message.consumerName = String(object.consumerName);
                if (object.dropoffInstructions != null)
                    message.dropoffInstructions = String(object.dropoffInstructions);
                if (object.contactlessDropoff != null)
                    message.contactlessDropoff = Boolean(object.contactlessDropoff);
                return message;
            };

            /**
             * Creates a plain object from a DeliveryProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.DeliveryProto
             * @static
             * @param {waiternow.common.DeliveryProto} message DeliveryProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            DeliveryProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.id = "";
                    object.creationTime = null;
                    object.lastUpdateTime = null;
                    object.locationId = "";
                    object.businessName = "";
                    object.locationAddress = null;
                    object.locationPhoneNumber = null;
                    object.deliveryAddress = null;
                    object.consumerPhoneNumber = null;
                    object.consumerEmail = "";
                    object.deliveryIdFromCarrier = "";
                    object.deliveryCarrier = options.enums === String ? "DELIVERY_CARRIER_UNSPECIFIED" : 0;
                    object.distance = null;
                    object.fee = null;
                    object.quoteExpiration = null;
                    object.status = options.enums === String ? "STATE_UNSPECIFIED" : 0;
                    object.trackingUrl = "";
                    object.containsAlcohol = false;
                    object.estimatedPickupTime = null;
                    object.estimatedDropoffTime = null;
                    object.deliveryTip = null;
                    object.consumerName = "";
                    object.dropoffInstructions = "";
                    object.contactlessDropoff = false;
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                    object.creationTime = $root.google.protobuf.Timestamp.toObject(message.creationTime, options);
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                    object.lastUpdateTime = $root.google.protobuf.Timestamp.toObject(message.lastUpdateTime, options);
                if (message.locationId != null && message.hasOwnProperty("locationId"))
                    object.locationId = message.locationId;
                if (message.businessName != null && message.hasOwnProperty("businessName"))
                    object.businessName = message.businessName;
                if (message.locationAddress != null && message.hasOwnProperty("locationAddress"))
                    object.locationAddress = $root.waiternow.common.AddressProto.toObject(message.locationAddress, options);
                if (message.locationPhoneNumber != null && message.hasOwnProperty("locationPhoneNumber"))
                    object.locationPhoneNumber = $root.waiternow.common.PhoneNumberProto.toObject(message.locationPhoneNumber, options);
                if (message.deliveryAddress != null && message.hasOwnProperty("deliveryAddress"))
                    object.deliveryAddress = $root.waiternow.common.AddressProto.toObject(message.deliveryAddress, options);
                if (message.consumerPhoneNumber != null && message.hasOwnProperty("consumerPhoneNumber"))
                    object.consumerPhoneNumber = $root.waiternow.common.PhoneNumberProto.toObject(message.consumerPhoneNumber, options);
                if (message.consumerEmail != null && message.hasOwnProperty("consumerEmail"))
                    object.consumerEmail = message.consumerEmail;
                if (message.requestedPickupTime != null && message.hasOwnProperty("requestedPickupTime")) {
                    object.requestedPickupTime = $root.google.protobuf.Timestamp.toObject(message.requestedPickupTime, options);
                    if (options.oneofs)
                        object.pickupOrDropoffTimeRequest = "requestedPickupTime";
                }
                if (message.requestedDropoffTime != null && message.hasOwnProperty("requestedDropoffTime")) {
                    object.requestedDropoffTime = $root.google.protobuf.Timestamp.toObject(message.requestedDropoffTime, options);
                    if (options.oneofs)
                        object.pickupOrDropoffTimeRequest = "requestedDropoffTime";
                }
                if (message.deliveryIdFromCarrier != null && message.hasOwnProperty("deliveryIdFromCarrier"))
                    object.deliveryIdFromCarrier = message.deliveryIdFromCarrier;
                if (message.deliveryCarrier != null && message.hasOwnProperty("deliveryCarrier"))
                    object.deliveryCarrier = options.enums === String ? $root.waiternow.common.DeliveryCarrier[message.deliveryCarrier] === undefined ? message.deliveryCarrier : $root.waiternow.common.DeliveryCarrier[message.deliveryCarrier] : message.deliveryCarrier;
                if (message.distance != null && message.hasOwnProperty("distance"))
                    object.distance = $root.waiternow.common.DistanceQuantityProto.toObject(message.distance, options);
                if (message.fee != null && message.hasOwnProperty("fee"))
                    object.fee = $root.waiternow.common.MoneyProto.toObject(message.fee, options);
                if (message.quoteExpiration != null && message.hasOwnProperty("quoteExpiration"))
                    object.quoteExpiration = $root.google.protobuf.Duration.toObject(message.quoteExpiration, options);
                if (message.status != null && message.hasOwnProperty("status"))
                    object.status = options.enums === String ? $root.waiternow.common.DeliveryProto.Status[message.status] === undefined ? message.status : $root.waiternow.common.DeliveryProto.Status[message.status] : message.status;
                if (message.trackingUrl != null && message.hasOwnProperty("trackingUrl"))
                    object.trackingUrl = message.trackingUrl;
                if (message.containsAlcohol != null && message.hasOwnProperty("containsAlcohol"))
                    object.containsAlcohol = message.containsAlcohol;
                if (message.estimatedPickupTime != null && message.hasOwnProperty("estimatedPickupTime"))
                    object.estimatedPickupTime = $root.google.protobuf.Timestamp.toObject(message.estimatedPickupTime, options);
                if (message.estimatedDropoffTime != null && message.hasOwnProperty("estimatedDropoffTime"))
                    object.estimatedDropoffTime = $root.google.protobuf.Timestamp.toObject(message.estimatedDropoffTime, options);
                if (message.deliveryTip != null && message.hasOwnProperty("deliveryTip"))
                    object.deliveryTip = $root.waiternow.common.MoneyProto.toObject(message.deliveryTip, options);
                if (message.consumerName != null && message.hasOwnProperty("consumerName"))
                    object.consumerName = message.consumerName;
                if (message.dropoffInstructions != null && message.hasOwnProperty("dropoffInstructions"))
                    object.dropoffInstructions = message.dropoffInstructions;
                if (message.contactlessDropoff != null && message.hasOwnProperty("contactlessDropoff"))
                    object.contactlessDropoff = message.contactlessDropoff;
                return object;
            };

            /**
             * Converts this DeliveryProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.DeliveryProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            DeliveryProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for DeliveryProto
             * @function getTypeUrl
             * @memberof waiternow.common.DeliveryProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            DeliveryProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.DeliveryProto";
            };

            /**
             * Status enum.
             * @name waiternow.common.DeliveryProto.Status
             * @enum {number}
             * @property {number} STATE_UNSPECIFIED=0 STATE_UNSPECIFIED value
             * @property {number} QUOTE=1 QUOTE value
             * @property {number} ACCEPTED=2 ACCEPTED value
             * @property {number} FAILED=3 FAILED value
             * @property {number} CANCELED=4 CANCELED value
             */
            DeliveryProto.Status = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "STATE_UNSPECIFIED"] = 0;
                values[valuesById[1] = "QUOTE"] = 1;
                values[valuesById[2] = "ACCEPTED"] = 2;
                values[valuesById[3] = "FAILED"] = 3;
                values[valuesById[4] = "CANCELED"] = 4;
                return values;
            })();

            return DeliveryProto;
        })();

        common.PaymentProto = (function() {

            /**
             * Properties of a PaymentProto.
             * @memberof waiternow.common
             * @interface IPaymentProto
             * @property {string|null} [id] PaymentProto id
             * @property {google.protobuf.ITimestamp|null} [creationTime] PaymentProto creationTime
             * @property {google.protobuf.ITimestamp|null} [lastUpdateTime] PaymentProto lastUpdateTime
             * @property {waiternow.common.PaymentProto.PaymentCollector|null} [collector] PaymentProto collector
             * @property {waiternow.common.IMoneyProto|null} [subtotal] PaymentProto subtotal
             * @property {Array.<waiternow.common.IDiscountProto>|null} [discounts] PaymentProto discounts
             * @property {waiternow.common.ITaxesProto|null} [appliedTaxes] PaymentProto appliedTaxes
             * @property {waiternow.common.IMoneyProto|null} [tax] PaymentProto tax
             * @property {waiternow.common.IMoneyProto|null} [tip] PaymentProto tip
             * @property {waiternow.common.IMoneyProto|null} [deliveryFee] PaymentProto deliveryFee
             * @property {boolean|null} [isDeliveryFeePaidToBusiness] PaymentProto isDeliveryFeePaidToBusiness
             * @property {boolean|null} [isDeliveryFeeChargedToWaiterNow] PaymentProto isDeliveryFeeChargedToWaiterNow
             * @property {waiternow.common.IMoneyProto|null} [deliveryTip] PaymentProto deliveryTip
             * @property {waiternow.common.IMoneyProto|null} [creditCardFeeAdjustment] PaymentProto creditCardFeeAdjustment
             * @property {boolean|null} [isCreditCardFeeChargedToConsumer] PaymentProto isCreditCardFeeChargedToConsumer
             * @property {waiternow.common.IMoneyProto|null} [creditCardFeeAdjustmentForThirdPartyDelivery] PaymentProto creditCardFeeAdjustmentForThirdPartyDelivery
             * @property {waiternow.common.IMoneyProto|null} [waiterNowFee] PaymentProto waiterNowFee
             * @property {waiternow.common.IMoneyProto|null} [serviceFee] PaymentProto serviceFee
             * @property {waiternow.common.IMoneyProto|null} [stripeFee] PaymentProto stripeFee
             * @property {waiternow.common.IMoneyProto|null} [applicationFee] PaymentProto applicationFee
             * @property {waiternow.common.IMoneyProto|null} [netPaidToBusiness] PaymentProto netPaidToBusiness
             * @property {waiternow.common.IMoneyProto|null} [total] PaymentProto total
             * @property {google.protobuf.ITimestamp|null} [paymentTime] PaymentProto paymentTime
             * @property {boolean|null} [isTaxIncludedInPrice] PaymentProto isTaxIncludedInPrice
             * @property {boolean|null} [stripeFeeIncludesTaxesAppliedToOriginalStripeFee] PaymentProto stripeFeeIncludesTaxesAppliedToOriginalStripeFee
             * @property {waiternow.common.PaymentProto.Status|null} [status] PaymentProto status
             * @property {string|null} [error] PaymentProto error
             * @property {string|null} [expectedReference] PaymentProto expectedReference
             * @property {string|null} [referenceFromPaymentCollector] PaymentProto referenceFromPaymentCollector
             * @property {waiternow.common.PaymentProto.ICancelationStatusProto|null} [cancelationStatus] PaymentProto cancelationStatus
             * @property {waiternow.common.PaymentProto.IRefundStatusProto|null} [refundStatus] PaymentProto refundStatus
             * @property {Array.<waiternow.common.PaymentProto.IPartialRefundProto>|null} [partialRefunds] PaymentProto partialRefunds
             * @property {waiternow.common.PaymentProto.IDisputeProto|null} [dispute] PaymentProto dispute
             * @property {string|null} [stripeClientSecret] PaymentProto stripeClientSecret
             * @property {string|null} [payerEmail] PaymentProto payerEmail
             * @property {waiternow.common.IPhoneNumberProto|null} [payerPhoneNumber] PaymentProto payerPhoneNumber
             * @property {waiternow.common.PaymentProto.IPaymentAttemptProto|null} [paymentAttempt] PaymentProto paymentAttempt
             */

            /**
             * Constructs a new PaymentProto.
             * @memberof waiternow.common
             * @classdesc Represents a PaymentProto.
             * @implements IPaymentProto
             * @constructor
             * @param {waiternow.common.IPaymentProto=} [properties] Properties to set
             */
            function PaymentProto(properties) {
                this.discounts = [];
                this.partialRefunds = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * PaymentProto id.
             * @member {string} id
             * @memberof waiternow.common.PaymentProto
             * @instance
             */
            PaymentProto.prototype.id = "";

            /**
             * PaymentProto creationTime.
             * @member {google.protobuf.ITimestamp|null|undefined} creationTime
             * @memberof waiternow.common.PaymentProto
             * @instance
             */
            PaymentProto.prototype.creationTime = null;

            /**
             * PaymentProto lastUpdateTime.
             * @member {google.protobuf.ITimestamp|null|undefined} lastUpdateTime
             * @memberof waiternow.common.PaymentProto
             * @instance
             */
            PaymentProto.prototype.lastUpdateTime = null;

            /**
             * PaymentProto collector.
             * @member {waiternow.common.PaymentProto.PaymentCollector} collector
             * @memberof waiternow.common.PaymentProto
             * @instance
             */
            PaymentProto.prototype.collector = 0;

            /**
             * PaymentProto subtotal.
             * @member {waiternow.common.IMoneyProto|null|undefined} subtotal
             * @memberof waiternow.common.PaymentProto
             * @instance
             */
            PaymentProto.prototype.subtotal = null;

            /**
             * PaymentProto discounts.
             * @member {Array.<waiternow.common.IDiscountProto>} discounts
             * @memberof waiternow.common.PaymentProto
             * @instance
             */
            PaymentProto.prototype.discounts = $util.emptyArray;

            /**
             * PaymentProto appliedTaxes.
             * @member {waiternow.common.ITaxesProto|null|undefined} appliedTaxes
             * @memberof waiternow.common.PaymentProto
             * @instance
             */
            PaymentProto.prototype.appliedTaxes = null;

            /**
             * PaymentProto tax.
             * @member {waiternow.common.IMoneyProto|null|undefined} tax
             * @memberof waiternow.common.PaymentProto
             * @instance
             */
            PaymentProto.prototype.tax = null;

            /**
             * PaymentProto tip.
             * @member {waiternow.common.IMoneyProto|null|undefined} tip
             * @memberof waiternow.common.PaymentProto
             * @instance
             */
            PaymentProto.prototype.tip = null;

            /**
             * PaymentProto deliveryFee.
             * @member {waiternow.common.IMoneyProto|null|undefined} deliveryFee
             * @memberof waiternow.common.PaymentProto
             * @instance
             */
            PaymentProto.prototype.deliveryFee = null;

            /**
             * PaymentProto isDeliveryFeePaidToBusiness.
             * @member {boolean} isDeliveryFeePaidToBusiness
             * @memberof waiternow.common.PaymentProto
             * @instance
             */
            PaymentProto.prototype.isDeliveryFeePaidToBusiness = false;

            /**
             * PaymentProto isDeliveryFeeChargedToWaiterNow.
             * @member {boolean} isDeliveryFeeChargedToWaiterNow
             * @memberof waiternow.common.PaymentProto
             * @instance
             */
            PaymentProto.prototype.isDeliveryFeeChargedToWaiterNow = false;

            /**
             * PaymentProto deliveryTip.
             * @member {waiternow.common.IMoneyProto|null|undefined} deliveryTip
             * @memberof waiternow.common.PaymentProto
             * @instance
             */
            PaymentProto.prototype.deliveryTip = null;

            /**
             * PaymentProto creditCardFeeAdjustment.
             * @member {waiternow.common.IMoneyProto|null|undefined} creditCardFeeAdjustment
             * @memberof waiternow.common.PaymentProto
             * @instance
             */
            PaymentProto.prototype.creditCardFeeAdjustment = null;

            /**
             * PaymentProto isCreditCardFeeChargedToConsumer.
             * @member {boolean} isCreditCardFeeChargedToConsumer
             * @memberof waiternow.common.PaymentProto
             * @instance
             */
            PaymentProto.prototype.isCreditCardFeeChargedToConsumer = false;

            /**
             * PaymentProto creditCardFeeAdjustmentForThirdPartyDelivery.
             * @member {waiternow.common.IMoneyProto|null|undefined} creditCardFeeAdjustmentForThirdPartyDelivery
             * @memberof waiternow.common.PaymentProto
             * @instance
             */
            PaymentProto.prototype.creditCardFeeAdjustmentForThirdPartyDelivery = null;

            /**
             * PaymentProto waiterNowFee.
             * @member {waiternow.common.IMoneyProto|null|undefined} waiterNowFee
             * @memberof waiternow.common.PaymentProto
             * @instance
             */
            PaymentProto.prototype.waiterNowFee = null;

            /**
             * PaymentProto serviceFee.
             * @member {waiternow.common.IMoneyProto|null|undefined} serviceFee
             * @memberof waiternow.common.PaymentProto
             * @instance
             */
            PaymentProto.prototype.serviceFee = null;

            /**
             * PaymentProto stripeFee.
             * @member {waiternow.common.IMoneyProto|null|undefined} stripeFee
             * @memberof waiternow.common.PaymentProto
             * @instance
             */
            PaymentProto.prototype.stripeFee = null;

            /**
             * PaymentProto applicationFee.
             * @member {waiternow.common.IMoneyProto|null|undefined} applicationFee
             * @memberof waiternow.common.PaymentProto
             * @instance
             */
            PaymentProto.prototype.applicationFee = null;

            /**
             * PaymentProto netPaidToBusiness.
             * @member {waiternow.common.IMoneyProto|null|undefined} netPaidToBusiness
             * @memberof waiternow.common.PaymentProto
             * @instance
             */
            PaymentProto.prototype.netPaidToBusiness = null;

            /**
             * PaymentProto total.
             * @member {waiternow.common.IMoneyProto|null|undefined} total
             * @memberof waiternow.common.PaymentProto
             * @instance
             */
            PaymentProto.prototype.total = null;

            /**
             * PaymentProto paymentTime.
             * @member {google.protobuf.ITimestamp|null|undefined} paymentTime
             * @memberof waiternow.common.PaymentProto
             * @instance
             */
            PaymentProto.prototype.paymentTime = null;

            /**
             * PaymentProto isTaxIncludedInPrice.
             * @member {boolean} isTaxIncludedInPrice
             * @memberof waiternow.common.PaymentProto
             * @instance
             */
            PaymentProto.prototype.isTaxIncludedInPrice = false;

            /**
             * PaymentProto stripeFeeIncludesTaxesAppliedToOriginalStripeFee.
             * @member {boolean} stripeFeeIncludesTaxesAppliedToOriginalStripeFee
             * @memberof waiternow.common.PaymentProto
             * @instance
             */
            PaymentProto.prototype.stripeFeeIncludesTaxesAppliedToOriginalStripeFee = false;

            /**
             * PaymentProto status.
             * @member {waiternow.common.PaymentProto.Status} status
             * @memberof waiternow.common.PaymentProto
             * @instance
             */
            PaymentProto.prototype.status = 0;

            /**
             * PaymentProto error.
             * @member {string} error
             * @memberof waiternow.common.PaymentProto
             * @instance
             */
            PaymentProto.prototype.error = "";

            /**
             * PaymentProto expectedReference.
             * @member {string} expectedReference
             * @memberof waiternow.common.PaymentProto
             * @instance
             */
            PaymentProto.prototype.expectedReference = "";

            /**
             * PaymentProto referenceFromPaymentCollector.
             * @member {string} referenceFromPaymentCollector
             * @memberof waiternow.common.PaymentProto
             * @instance
             */
            PaymentProto.prototype.referenceFromPaymentCollector = "";

            /**
             * PaymentProto cancelationStatus.
             * @member {waiternow.common.PaymentProto.ICancelationStatusProto|null|undefined} cancelationStatus
             * @memberof waiternow.common.PaymentProto
             * @instance
             */
            PaymentProto.prototype.cancelationStatus = null;

            /**
             * PaymentProto refundStatus.
             * @member {waiternow.common.PaymentProto.IRefundStatusProto|null|undefined} refundStatus
             * @memberof waiternow.common.PaymentProto
             * @instance
             */
            PaymentProto.prototype.refundStatus = null;

            /**
             * PaymentProto partialRefunds.
             * @member {Array.<waiternow.common.PaymentProto.IPartialRefundProto>} partialRefunds
             * @memberof waiternow.common.PaymentProto
             * @instance
             */
            PaymentProto.prototype.partialRefunds = $util.emptyArray;

            /**
             * PaymentProto dispute.
             * @member {waiternow.common.PaymentProto.IDisputeProto|null|undefined} dispute
             * @memberof waiternow.common.PaymentProto
             * @instance
             */
            PaymentProto.prototype.dispute = null;

            /**
             * PaymentProto stripeClientSecret.
             * @member {string} stripeClientSecret
             * @memberof waiternow.common.PaymentProto
             * @instance
             */
            PaymentProto.prototype.stripeClientSecret = "";

            /**
             * PaymentProto payerEmail.
             * @member {string} payerEmail
             * @memberof waiternow.common.PaymentProto
             * @instance
             */
            PaymentProto.prototype.payerEmail = "";

            /**
             * PaymentProto payerPhoneNumber.
             * @member {waiternow.common.IPhoneNumberProto|null|undefined} payerPhoneNumber
             * @memberof waiternow.common.PaymentProto
             * @instance
             */
            PaymentProto.prototype.payerPhoneNumber = null;

            /**
             * PaymentProto paymentAttempt.
             * @member {waiternow.common.PaymentProto.IPaymentAttemptProto|null|undefined} paymentAttempt
             * @memberof waiternow.common.PaymentProto
             * @instance
             */
            PaymentProto.prototype.paymentAttempt = null;

            /**
             * Creates a new PaymentProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.PaymentProto
             * @static
             * @param {waiternow.common.IPaymentProto=} [properties] Properties to set
             * @returns {waiternow.common.PaymentProto} PaymentProto instance
             */
            PaymentProto.create = function create(properties) {
                return new PaymentProto(properties);
            };

            /**
             * Encodes the specified PaymentProto message. Does not implicitly {@link waiternow.common.PaymentProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.PaymentProto
             * @static
             * @param {waiternow.common.IPaymentProto} message PaymentProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PaymentProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                if (message.collector != null && Object.hasOwnProperty.call(message, "collector"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.collector);
                if (message.creationTime != null && Object.hasOwnProperty.call(message, "creationTime"))
                    $root.google.protobuf.Timestamp.encode(message.creationTime, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.subtotal != null && Object.hasOwnProperty.call(message, "subtotal"))
                    $root.waiternow.common.MoneyProto.encode(message.subtotal, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                if (message.appliedTaxes != null && Object.hasOwnProperty.call(message, "appliedTaxes"))
                    $root.waiternow.common.TaxesProto.encode(message.appliedTaxes, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                if (message.tax != null && Object.hasOwnProperty.call(message, "tax"))
                    $root.waiternow.common.MoneyProto.encode(message.tax, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                if (message.waiterNowFee != null && Object.hasOwnProperty.call(message, "waiterNowFee"))
                    $root.waiternow.common.MoneyProto.encode(message.waiterNowFee, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                if (message.tip != null && Object.hasOwnProperty.call(message, "tip"))
                    $root.waiternow.common.MoneyProto.encode(message.tip, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                if (message.total != null && Object.hasOwnProperty.call(message, "total"))
                    $root.waiternow.common.MoneyProto.encode(message.total, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                if (message.paymentTime != null && Object.hasOwnProperty.call(message, "paymentTime"))
                    $root.google.protobuf.Timestamp.encode(message.paymentTime, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                    writer.uint32(/* id 11, wireType 0 =*/88).int32(message.status);
                if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                    writer.uint32(/* id 12, wireType 2 =*/98).string(message.error);
                if (message.expectedReference != null && Object.hasOwnProperty.call(message, "expectedReference"))
                    writer.uint32(/* id 13, wireType 2 =*/106).string(message.expectedReference);
                if (message.referenceFromPaymentCollector != null && Object.hasOwnProperty.call(message, "referenceFromPaymentCollector"))
                    writer.uint32(/* id 14, wireType 2 =*/114).string(message.referenceFromPaymentCollector);
                if (message.cancelationStatus != null && Object.hasOwnProperty.call(message, "cancelationStatus"))
                    $root.waiternow.common.PaymentProto.CancelationStatusProto.encode(message.cancelationStatus, writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
                if (message.refundStatus != null && Object.hasOwnProperty.call(message, "refundStatus"))
                    $root.waiternow.common.PaymentProto.RefundStatusProto.encode(message.refundStatus, writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
                if (message.stripeClientSecret != null && Object.hasOwnProperty.call(message, "stripeClientSecret"))
                    writer.uint32(/* id 17, wireType 2 =*/138).string(message.stripeClientSecret);
                if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                    $root.google.protobuf.Timestamp.encode(message.lastUpdateTime, writer.uint32(/* id 18, wireType 2 =*/146).fork()).ldelim();
                if (message.partialRefunds != null && message.partialRefunds.length)
                    for (var i = 0; i < message.partialRefunds.length; ++i)
                        $root.waiternow.common.PaymentProto.PartialRefundProto.encode(message.partialRefunds[i], writer.uint32(/* id 19, wireType 2 =*/154).fork()).ldelim();
                if (message.discounts != null && message.discounts.length)
                    for (var i = 0; i < message.discounts.length; ++i)
                        $root.waiternow.common.DiscountProto.encode(message.discounts[i], writer.uint32(/* id 20, wireType 2 =*/162).fork()).ldelim();
                if (message.payerEmail != null && Object.hasOwnProperty.call(message, "payerEmail"))
                    writer.uint32(/* id 21, wireType 2 =*/170).string(message.payerEmail);
                if (message.payerPhoneNumber != null && Object.hasOwnProperty.call(message, "payerPhoneNumber"))
                    $root.waiternow.common.PhoneNumberProto.encode(message.payerPhoneNumber, writer.uint32(/* id 22, wireType 2 =*/178).fork()).ldelim();
                if (message.deliveryFee != null && Object.hasOwnProperty.call(message, "deliveryFee"))
                    $root.waiternow.common.MoneyProto.encode(message.deliveryFee, writer.uint32(/* id 24, wireType 2 =*/194).fork()).ldelim();
                if (message.isDeliveryFeePaidToBusiness != null && Object.hasOwnProperty.call(message, "isDeliveryFeePaidToBusiness"))
                    writer.uint32(/* id 25, wireType 0 =*/200).bool(message.isDeliveryFeePaidToBusiness);
                if (message.isDeliveryFeeChargedToWaiterNow != null && Object.hasOwnProperty.call(message, "isDeliveryFeeChargedToWaiterNow"))
                    writer.uint32(/* id 26, wireType 0 =*/208).bool(message.isDeliveryFeeChargedToWaiterNow);
                if (message.deliveryTip != null && Object.hasOwnProperty.call(message, "deliveryTip"))
                    $root.waiternow.common.MoneyProto.encode(message.deliveryTip, writer.uint32(/* id 27, wireType 2 =*/218).fork()).ldelim();
                if (message.creditCardFeeAdjustment != null && Object.hasOwnProperty.call(message, "creditCardFeeAdjustment"))
                    $root.waiternow.common.MoneyProto.encode(message.creditCardFeeAdjustment, writer.uint32(/* id 28, wireType 2 =*/226).fork()).ldelim();
                if (message.serviceFee != null && Object.hasOwnProperty.call(message, "serviceFee"))
                    $root.waiternow.common.MoneyProto.encode(message.serviceFee, writer.uint32(/* id 29, wireType 2 =*/234).fork()).ldelim();
                if (message.stripeFee != null && Object.hasOwnProperty.call(message, "stripeFee"))
                    $root.waiternow.common.MoneyProto.encode(message.stripeFee, writer.uint32(/* id 30, wireType 2 =*/242).fork()).ldelim();
                if (message.applicationFee != null && Object.hasOwnProperty.call(message, "applicationFee"))
                    $root.waiternow.common.MoneyProto.encode(message.applicationFee, writer.uint32(/* id 31, wireType 2 =*/250).fork()).ldelim();
                if (message.netPaidToBusiness != null && Object.hasOwnProperty.call(message, "netPaidToBusiness"))
                    $root.waiternow.common.MoneyProto.encode(message.netPaidToBusiness, writer.uint32(/* id 32, wireType 2 =*/258).fork()).ldelim();
                if (message.isCreditCardFeeChargedToConsumer != null && Object.hasOwnProperty.call(message, "isCreditCardFeeChargedToConsumer"))
                    writer.uint32(/* id 33, wireType 0 =*/264).bool(message.isCreditCardFeeChargedToConsumer);
                if (message.dispute != null && Object.hasOwnProperty.call(message, "dispute"))
                    $root.waiternow.common.PaymentProto.DisputeProto.encode(message.dispute, writer.uint32(/* id 34, wireType 2 =*/274).fork()).ldelim();
                if (message.isTaxIncludedInPrice != null && Object.hasOwnProperty.call(message, "isTaxIncludedInPrice"))
                    writer.uint32(/* id 35, wireType 0 =*/280).bool(message.isTaxIncludedInPrice);
                if (message.creditCardFeeAdjustmentForThirdPartyDelivery != null && Object.hasOwnProperty.call(message, "creditCardFeeAdjustmentForThirdPartyDelivery"))
                    $root.waiternow.common.MoneyProto.encode(message.creditCardFeeAdjustmentForThirdPartyDelivery, writer.uint32(/* id 36, wireType 2 =*/290).fork()).ldelim();
                if (message.paymentAttempt != null && Object.hasOwnProperty.call(message, "paymentAttempt"))
                    $root.waiternow.common.PaymentProto.PaymentAttemptProto.encode(message.paymentAttempt, writer.uint32(/* id 37, wireType 2 =*/298).fork()).ldelim();
                if (message.stripeFeeIncludesTaxesAppliedToOriginalStripeFee != null && Object.hasOwnProperty.call(message, "stripeFeeIncludesTaxesAppliedToOriginalStripeFee"))
                    writer.uint32(/* id 38, wireType 0 =*/304).bool(message.stripeFeeIncludesTaxesAppliedToOriginalStripeFee);
                return writer;
            };

            /**
             * Encodes the specified PaymentProto message, length delimited. Does not implicitly {@link waiternow.common.PaymentProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.PaymentProto
             * @static
             * @param {waiternow.common.IPaymentProto} message PaymentProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PaymentProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a PaymentProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.PaymentProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.PaymentProto} PaymentProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PaymentProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PaymentProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.id = reader.string();
                            break;
                        }
                    case 3: {
                            message.creationTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 18: {
                            message.lastUpdateTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 2: {
                            message.collector = reader.int32();
                            break;
                        }
                    case 4: {
                            message.subtotal = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 20: {
                            if (!(message.discounts && message.discounts.length))
                                message.discounts = [];
                            message.discounts.push($root.waiternow.common.DiscountProto.decode(reader, reader.uint32()));
                            break;
                        }
                    case 5: {
                            message.appliedTaxes = $root.waiternow.common.TaxesProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 6: {
                            message.tax = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 8: {
                            message.tip = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 24: {
                            message.deliveryFee = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 25: {
                            message.isDeliveryFeePaidToBusiness = reader.bool();
                            break;
                        }
                    case 26: {
                            message.isDeliveryFeeChargedToWaiterNow = reader.bool();
                            break;
                        }
                    case 27: {
                            message.deliveryTip = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 28: {
                            message.creditCardFeeAdjustment = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 33: {
                            message.isCreditCardFeeChargedToConsumer = reader.bool();
                            break;
                        }
                    case 36: {
                            message.creditCardFeeAdjustmentForThirdPartyDelivery = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 7: {
                            message.waiterNowFee = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 29: {
                            message.serviceFee = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 30: {
                            message.stripeFee = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 31: {
                            message.applicationFee = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 32: {
                            message.netPaidToBusiness = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 9: {
                            message.total = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 10: {
                            message.paymentTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 35: {
                            message.isTaxIncludedInPrice = reader.bool();
                            break;
                        }
                    case 38: {
                            message.stripeFeeIncludesTaxesAppliedToOriginalStripeFee = reader.bool();
                            break;
                        }
                    case 11: {
                            message.status = reader.int32();
                            break;
                        }
                    case 12: {
                            message.error = reader.string();
                            break;
                        }
                    case 13: {
                            message.expectedReference = reader.string();
                            break;
                        }
                    case 14: {
                            message.referenceFromPaymentCollector = reader.string();
                            break;
                        }
                    case 15: {
                            message.cancelationStatus = $root.waiternow.common.PaymentProto.CancelationStatusProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 16: {
                            message.refundStatus = $root.waiternow.common.PaymentProto.RefundStatusProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 19: {
                            if (!(message.partialRefunds && message.partialRefunds.length))
                                message.partialRefunds = [];
                            message.partialRefunds.push($root.waiternow.common.PaymentProto.PartialRefundProto.decode(reader, reader.uint32()));
                            break;
                        }
                    case 34: {
                            message.dispute = $root.waiternow.common.PaymentProto.DisputeProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 17: {
                            message.stripeClientSecret = reader.string();
                            break;
                        }
                    case 21: {
                            message.payerEmail = reader.string();
                            break;
                        }
                    case 22: {
                            message.payerPhoneNumber = $root.waiternow.common.PhoneNumberProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 37: {
                            message.paymentAttempt = $root.waiternow.common.PaymentProto.PaymentAttemptProto.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a PaymentProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.PaymentProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.PaymentProto} PaymentProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PaymentProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a PaymentProto message.
             * @function verify
             * @memberof waiternow.common.PaymentProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            PaymentProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.id != null && message.hasOwnProperty("id"))
                    if (!$util.isString(message.id))
                        return "id: string expected";
                if (message.creationTime != null && message.hasOwnProperty("creationTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.creationTime);
                    if (error)
                        return "creationTime." + error;
                }
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.lastUpdateTime);
                    if (error)
                        return "lastUpdateTime." + error;
                }
                if (message.collector != null && message.hasOwnProperty("collector"))
                    switch (message.collector) {
                    default:
                        return "collector: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                        break;
                    }
                if (message.subtotal != null && message.hasOwnProperty("subtotal")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.subtotal);
                    if (error)
                        return "subtotal." + error;
                }
                if (message.discounts != null && message.hasOwnProperty("discounts")) {
                    if (!Array.isArray(message.discounts))
                        return "discounts: array expected";
                    for (var i = 0; i < message.discounts.length; ++i) {
                        var error = $root.waiternow.common.DiscountProto.verify(message.discounts[i]);
                        if (error)
                            return "discounts." + error;
                    }
                }
                if (message.appliedTaxes != null && message.hasOwnProperty("appliedTaxes")) {
                    var error = $root.waiternow.common.TaxesProto.verify(message.appliedTaxes);
                    if (error)
                        return "appliedTaxes." + error;
                }
                if (message.tax != null && message.hasOwnProperty("tax")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.tax);
                    if (error)
                        return "tax." + error;
                }
                if (message.tip != null && message.hasOwnProperty("tip")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.tip);
                    if (error)
                        return "tip." + error;
                }
                if (message.deliveryFee != null && message.hasOwnProperty("deliveryFee")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.deliveryFee);
                    if (error)
                        return "deliveryFee." + error;
                }
                if (message.isDeliveryFeePaidToBusiness != null && message.hasOwnProperty("isDeliveryFeePaidToBusiness"))
                    if (typeof message.isDeliveryFeePaidToBusiness !== "boolean")
                        return "isDeliveryFeePaidToBusiness: boolean expected";
                if (message.isDeliveryFeeChargedToWaiterNow != null && message.hasOwnProperty("isDeliveryFeeChargedToWaiterNow"))
                    if (typeof message.isDeliveryFeeChargedToWaiterNow !== "boolean")
                        return "isDeliveryFeeChargedToWaiterNow: boolean expected";
                if (message.deliveryTip != null && message.hasOwnProperty("deliveryTip")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.deliveryTip);
                    if (error)
                        return "deliveryTip." + error;
                }
                if (message.creditCardFeeAdjustment != null && message.hasOwnProperty("creditCardFeeAdjustment")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.creditCardFeeAdjustment);
                    if (error)
                        return "creditCardFeeAdjustment." + error;
                }
                if (message.isCreditCardFeeChargedToConsumer != null && message.hasOwnProperty("isCreditCardFeeChargedToConsumer"))
                    if (typeof message.isCreditCardFeeChargedToConsumer !== "boolean")
                        return "isCreditCardFeeChargedToConsumer: boolean expected";
                if (message.creditCardFeeAdjustmentForThirdPartyDelivery != null && message.hasOwnProperty("creditCardFeeAdjustmentForThirdPartyDelivery")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.creditCardFeeAdjustmentForThirdPartyDelivery);
                    if (error)
                        return "creditCardFeeAdjustmentForThirdPartyDelivery." + error;
                }
                if (message.waiterNowFee != null && message.hasOwnProperty("waiterNowFee")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.waiterNowFee);
                    if (error)
                        return "waiterNowFee." + error;
                }
                if (message.serviceFee != null && message.hasOwnProperty("serviceFee")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.serviceFee);
                    if (error)
                        return "serviceFee." + error;
                }
                if (message.stripeFee != null && message.hasOwnProperty("stripeFee")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.stripeFee);
                    if (error)
                        return "stripeFee." + error;
                }
                if (message.applicationFee != null && message.hasOwnProperty("applicationFee")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.applicationFee);
                    if (error)
                        return "applicationFee." + error;
                }
                if (message.netPaidToBusiness != null && message.hasOwnProperty("netPaidToBusiness")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.netPaidToBusiness);
                    if (error)
                        return "netPaidToBusiness." + error;
                }
                if (message.total != null && message.hasOwnProperty("total")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.total);
                    if (error)
                        return "total." + error;
                }
                if (message.paymentTime != null && message.hasOwnProperty("paymentTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.paymentTime);
                    if (error)
                        return "paymentTime." + error;
                }
                if (message.isTaxIncludedInPrice != null && message.hasOwnProperty("isTaxIncludedInPrice"))
                    if (typeof message.isTaxIncludedInPrice !== "boolean")
                        return "isTaxIncludedInPrice: boolean expected";
                if (message.stripeFeeIncludesTaxesAppliedToOriginalStripeFee != null && message.hasOwnProperty("stripeFeeIncludesTaxesAppliedToOriginalStripeFee"))
                    if (typeof message.stripeFeeIncludesTaxesAppliedToOriginalStripeFee !== "boolean")
                        return "stripeFeeIncludesTaxesAppliedToOriginalStripeFee: boolean expected";
                if (message.status != null && message.hasOwnProperty("status"))
                    switch (message.status) {
                    default:
                        return "status: enum value expected";
                    case 0:
                    case 1:
                    case 9:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                        break;
                    }
                if (message.error != null && message.hasOwnProperty("error"))
                    if (!$util.isString(message.error))
                        return "error: string expected";
                if (message.expectedReference != null && message.hasOwnProperty("expectedReference"))
                    if (!$util.isString(message.expectedReference))
                        return "expectedReference: string expected";
                if (message.referenceFromPaymentCollector != null && message.hasOwnProperty("referenceFromPaymentCollector"))
                    if (!$util.isString(message.referenceFromPaymentCollector))
                        return "referenceFromPaymentCollector: string expected";
                if (message.cancelationStatus != null && message.hasOwnProperty("cancelationStatus")) {
                    var error = $root.waiternow.common.PaymentProto.CancelationStatusProto.verify(message.cancelationStatus);
                    if (error)
                        return "cancelationStatus." + error;
                }
                if (message.refundStatus != null && message.hasOwnProperty("refundStatus")) {
                    var error = $root.waiternow.common.PaymentProto.RefundStatusProto.verify(message.refundStatus);
                    if (error)
                        return "refundStatus." + error;
                }
                if (message.partialRefunds != null && message.hasOwnProperty("partialRefunds")) {
                    if (!Array.isArray(message.partialRefunds))
                        return "partialRefunds: array expected";
                    for (var i = 0; i < message.partialRefunds.length; ++i) {
                        var error = $root.waiternow.common.PaymentProto.PartialRefundProto.verify(message.partialRefunds[i]);
                        if (error)
                            return "partialRefunds." + error;
                    }
                }
                if (message.dispute != null && message.hasOwnProperty("dispute")) {
                    var error = $root.waiternow.common.PaymentProto.DisputeProto.verify(message.dispute);
                    if (error)
                        return "dispute." + error;
                }
                if (message.stripeClientSecret != null && message.hasOwnProperty("stripeClientSecret"))
                    if (!$util.isString(message.stripeClientSecret))
                        return "stripeClientSecret: string expected";
                if (message.payerEmail != null && message.hasOwnProperty("payerEmail"))
                    if (!$util.isString(message.payerEmail))
                        return "payerEmail: string expected";
                if (message.payerPhoneNumber != null && message.hasOwnProperty("payerPhoneNumber")) {
                    var error = $root.waiternow.common.PhoneNumberProto.verify(message.payerPhoneNumber);
                    if (error)
                        return "payerPhoneNumber." + error;
                }
                if (message.paymentAttempt != null && message.hasOwnProperty("paymentAttempt")) {
                    var error = $root.waiternow.common.PaymentProto.PaymentAttemptProto.verify(message.paymentAttempt);
                    if (error)
                        return "paymentAttempt." + error;
                }
                return null;
            };

            /**
             * Creates a PaymentProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.PaymentProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.PaymentProto} PaymentProto
             */
            PaymentProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.PaymentProto)
                    return object;
                var message = new $root.waiternow.common.PaymentProto();
                if (object.id != null)
                    message.id = String(object.id);
                if (object.creationTime != null) {
                    if (typeof object.creationTime !== "object")
                        throw TypeError(".waiternow.common.PaymentProto.creationTime: object expected");
                    message.creationTime = $root.google.protobuf.Timestamp.fromObject(object.creationTime);
                }
                if (object.lastUpdateTime != null) {
                    if (typeof object.lastUpdateTime !== "object")
                        throw TypeError(".waiternow.common.PaymentProto.lastUpdateTime: object expected");
                    message.lastUpdateTime = $root.google.protobuf.Timestamp.fromObject(object.lastUpdateTime);
                }
                switch (object.collector) {
                default:
                    if (typeof object.collector === "number") {
                        message.collector = object.collector;
                        break;
                    }
                    break;
                case "PAYMENT_COLLECTOR_UNSPECIFIED":
                case 0:
                    message.collector = 0;
                    break;
                case "PAYPAL_USA":
                case 1:
                    message.collector = 1;
                    break;
                case "STRIPE_USA":
                case 2:
                    message.collector = 2;
                    break;
                case "STRIPE_MEXICO":
                case 3:
                    message.collector = 3;
                    break;
                }
                if (object.subtotal != null) {
                    if (typeof object.subtotal !== "object")
                        throw TypeError(".waiternow.common.PaymentProto.subtotal: object expected");
                    message.subtotal = $root.waiternow.common.MoneyProto.fromObject(object.subtotal);
                }
                if (object.discounts) {
                    if (!Array.isArray(object.discounts))
                        throw TypeError(".waiternow.common.PaymentProto.discounts: array expected");
                    message.discounts = [];
                    for (var i = 0; i < object.discounts.length; ++i) {
                        if (typeof object.discounts[i] !== "object")
                            throw TypeError(".waiternow.common.PaymentProto.discounts: object expected");
                        message.discounts[i] = $root.waiternow.common.DiscountProto.fromObject(object.discounts[i]);
                    }
                }
                if (object.appliedTaxes != null) {
                    if (typeof object.appliedTaxes !== "object")
                        throw TypeError(".waiternow.common.PaymentProto.appliedTaxes: object expected");
                    message.appliedTaxes = $root.waiternow.common.TaxesProto.fromObject(object.appliedTaxes);
                }
                if (object.tax != null) {
                    if (typeof object.tax !== "object")
                        throw TypeError(".waiternow.common.PaymentProto.tax: object expected");
                    message.tax = $root.waiternow.common.MoneyProto.fromObject(object.tax);
                }
                if (object.tip != null) {
                    if (typeof object.tip !== "object")
                        throw TypeError(".waiternow.common.PaymentProto.tip: object expected");
                    message.tip = $root.waiternow.common.MoneyProto.fromObject(object.tip);
                }
                if (object.deliveryFee != null) {
                    if (typeof object.deliveryFee !== "object")
                        throw TypeError(".waiternow.common.PaymentProto.deliveryFee: object expected");
                    message.deliveryFee = $root.waiternow.common.MoneyProto.fromObject(object.deliveryFee);
                }
                if (object.isDeliveryFeePaidToBusiness != null)
                    message.isDeliveryFeePaidToBusiness = Boolean(object.isDeliveryFeePaidToBusiness);
                if (object.isDeliveryFeeChargedToWaiterNow != null)
                    message.isDeliveryFeeChargedToWaiterNow = Boolean(object.isDeliveryFeeChargedToWaiterNow);
                if (object.deliveryTip != null) {
                    if (typeof object.deliveryTip !== "object")
                        throw TypeError(".waiternow.common.PaymentProto.deliveryTip: object expected");
                    message.deliveryTip = $root.waiternow.common.MoneyProto.fromObject(object.deliveryTip);
                }
                if (object.creditCardFeeAdjustment != null) {
                    if (typeof object.creditCardFeeAdjustment !== "object")
                        throw TypeError(".waiternow.common.PaymentProto.creditCardFeeAdjustment: object expected");
                    message.creditCardFeeAdjustment = $root.waiternow.common.MoneyProto.fromObject(object.creditCardFeeAdjustment);
                }
                if (object.isCreditCardFeeChargedToConsumer != null)
                    message.isCreditCardFeeChargedToConsumer = Boolean(object.isCreditCardFeeChargedToConsumer);
                if (object.creditCardFeeAdjustmentForThirdPartyDelivery != null) {
                    if (typeof object.creditCardFeeAdjustmentForThirdPartyDelivery !== "object")
                        throw TypeError(".waiternow.common.PaymentProto.creditCardFeeAdjustmentForThirdPartyDelivery: object expected");
                    message.creditCardFeeAdjustmentForThirdPartyDelivery = $root.waiternow.common.MoneyProto.fromObject(object.creditCardFeeAdjustmentForThirdPartyDelivery);
                }
                if (object.waiterNowFee != null) {
                    if (typeof object.waiterNowFee !== "object")
                        throw TypeError(".waiternow.common.PaymentProto.waiterNowFee: object expected");
                    message.waiterNowFee = $root.waiternow.common.MoneyProto.fromObject(object.waiterNowFee);
                }
                if (object.serviceFee != null) {
                    if (typeof object.serviceFee !== "object")
                        throw TypeError(".waiternow.common.PaymentProto.serviceFee: object expected");
                    message.serviceFee = $root.waiternow.common.MoneyProto.fromObject(object.serviceFee);
                }
                if (object.stripeFee != null) {
                    if (typeof object.stripeFee !== "object")
                        throw TypeError(".waiternow.common.PaymentProto.stripeFee: object expected");
                    message.stripeFee = $root.waiternow.common.MoneyProto.fromObject(object.stripeFee);
                }
                if (object.applicationFee != null) {
                    if (typeof object.applicationFee !== "object")
                        throw TypeError(".waiternow.common.PaymentProto.applicationFee: object expected");
                    message.applicationFee = $root.waiternow.common.MoneyProto.fromObject(object.applicationFee);
                }
                if (object.netPaidToBusiness != null) {
                    if (typeof object.netPaidToBusiness !== "object")
                        throw TypeError(".waiternow.common.PaymentProto.netPaidToBusiness: object expected");
                    message.netPaidToBusiness = $root.waiternow.common.MoneyProto.fromObject(object.netPaidToBusiness);
                }
                if (object.total != null) {
                    if (typeof object.total !== "object")
                        throw TypeError(".waiternow.common.PaymentProto.total: object expected");
                    message.total = $root.waiternow.common.MoneyProto.fromObject(object.total);
                }
                if (object.paymentTime != null) {
                    if (typeof object.paymentTime !== "object")
                        throw TypeError(".waiternow.common.PaymentProto.paymentTime: object expected");
                    message.paymentTime = $root.google.protobuf.Timestamp.fromObject(object.paymentTime);
                }
                if (object.isTaxIncludedInPrice != null)
                    message.isTaxIncludedInPrice = Boolean(object.isTaxIncludedInPrice);
                if (object.stripeFeeIncludesTaxesAppliedToOriginalStripeFee != null)
                    message.stripeFeeIncludesTaxesAppliedToOriginalStripeFee = Boolean(object.stripeFeeIncludesTaxesAppliedToOriginalStripeFee);
                switch (object.status) {
                default:
                    if (typeof object.status === "number") {
                        message.status = object.status;
                        break;
                    }
                    break;
                case "STATUS_UNSPECIFIED":
                case 0:
                    message.status = 0;
                    break;
                case "SUCCESSFUL":
                case 1:
                    message.status = 1;
                    break;
                case "SUCCESSFUL_FOR_LATER":
                case 9:
                    message.status = 9;
                    break;
                case "REQUIRES_PAYMENT_METHOD":
                case 2:
                    message.status = 2;
                    break;
                case "REQUIRES_ACTION":
                case 3:
                    message.status = 3;
                    break;
                case "PROCESSING":
                case 4:
                    message.status = 4;
                    break;
                case "DECLINED":
                case 5:
                    message.status = 5;
                    break;
                case "CANCELED":
                case 6:
                    message.status = 6;
                    break;
                case "REFUNDED":
                case 7:
                    message.status = 7;
                    break;
                case "DISPUTED":
                case 8:
                    message.status = 8;
                    break;
                }
                if (object.error != null)
                    message.error = String(object.error);
                if (object.expectedReference != null)
                    message.expectedReference = String(object.expectedReference);
                if (object.referenceFromPaymentCollector != null)
                    message.referenceFromPaymentCollector = String(object.referenceFromPaymentCollector);
                if (object.cancelationStatus != null) {
                    if (typeof object.cancelationStatus !== "object")
                        throw TypeError(".waiternow.common.PaymentProto.cancelationStatus: object expected");
                    message.cancelationStatus = $root.waiternow.common.PaymentProto.CancelationStatusProto.fromObject(object.cancelationStatus);
                }
                if (object.refundStatus != null) {
                    if (typeof object.refundStatus !== "object")
                        throw TypeError(".waiternow.common.PaymentProto.refundStatus: object expected");
                    message.refundStatus = $root.waiternow.common.PaymentProto.RefundStatusProto.fromObject(object.refundStatus);
                }
                if (object.partialRefunds) {
                    if (!Array.isArray(object.partialRefunds))
                        throw TypeError(".waiternow.common.PaymentProto.partialRefunds: array expected");
                    message.partialRefunds = [];
                    for (var i = 0; i < object.partialRefunds.length; ++i) {
                        if (typeof object.partialRefunds[i] !== "object")
                            throw TypeError(".waiternow.common.PaymentProto.partialRefunds: object expected");
                        message.partialRefunds[i] = $root.waiternow.common.PaymentProto.PartialRefundProto.fromObject(object.partialRefunds[i]);
                    }
                }
                if (object.dispute != null) {
                    if (typeof object.dispute !== "object")
                        throw TypeError(".waiternow.common.PaymentProto.dispute: object expected");
                    message.dispute = $root.waiternow.common.PaymentProto.DisputeProto.fromObject(object.dispute);
                }
                if (object.stripeClientSecret != null)
                    message.stripeClientSecret = String(object.stripeClientSecret);
                if (object.payerEmail != null)
                    message.payerEmail = String(object.payerEmail);
                if (object.payerPhoneNumber != null) {
                    if (typeof object.payerPhoneNumber !== "object")
                        throw TypeError(".waiternow.common.PaymentProto.payerPhoneNumber: object expected");
                    message.payerPhoneNumber = $root.waiternow.common.PhoneNumberProto.fromObject(object.payerPhoneNumber);
                }
                if (object.paymentAttempt != null) {
                    if (typeof object.paymentAttempt !== "object")
                        throw TypeError(".waiternow.common.PaymentProto.paymentAttempt: object expected");
                    message.paymentAttempt = $root.waiternow.common.PaymentProto.PaymentAttemptProto.fromObject(object.paymentAttempt);
                }
                return message;
            };

            /**
             * Creates a plain object from a PaymentProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.PaymentProto
             * @static
             * @param {waiternow.common.PaymentProto} message PaymentProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            PaymentProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults) {
                    object.partialRefunds = [];
                    object.discounts = [];
                }
                if (options.defaults) {
                    object.id = "";
                    object.collector = options.enums === String ? "PAYMENT_COLLECTOR_UNSPECIFIED" : 0;
                    object.creationTime = null;
                    object.subtotal = null;
                    object.appliedTaxes = null;
                    object.tax = null;
                    object.waiterNowFee = null;
                    object.tip = null;
                    object.total = null;
                    object.paymentTime = null;
                    object.status = options.enums === String ? "STATUS_UNSPECIFIED" : 0;
                    object.error = "";
                    object.expectedReference = "";
                    object.referenceFromPaymentCollector = "";
                    object.cancelationStatus = null;
                    object.refundStatus = null;
                    object.stripeClientSecret = "";
                    object.lastUpdateTime = null;
                    object.payerEmail = "";
                    object.payerPhoneNumber = null;
                    object.deliveryFee = null;
                    object.isDeliveryFeePaidToBusiness = false;
                    object.isDeliveryFeeChargedToWaiterNow = false;
                    object.deliveryTip = null;
                    object.creditCardFeeAdjustment = null;
                    object.serviceFee = null;
                    object.stripeFee = null;
                    object.applicationFee = null;
                    object.netPaidToBusiness = null;
                    object.isCreditCardFeeChargedToConsumer = false;
                    object.dispute = null;
                    object.isTaxIncludedInPrice = false;
                    object.creditCardFeeAdjustmentForThirdPartyDelivery = null;
                    object.paymentAttempt = null;
                    object.stripeFeeIncludesTaxesAppliedToOriginalStripeFee = false;
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                if (message.collector != null && message.hasOwnProperty("collector"))
                    object.collector = options.enums === String ? $root.waiternow.common.PaymentProto.PaymentCollector[message.collector] === undefined ? message.collector : $root.waiternow.common.PaymentProto.PaymentCollector[message.collector] : message.collector;
                if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                    object.creationTime = $root.google.protobuf.Timestamp.toObject(message.creationTime, options);
                if (message.subtotal != null && message.hasOwnProperty("subtotal"))
                    object.subtotal = $root.waiternow.common.MoneyProto.toObject(message.subtotal, options);
                if (message.appliedTaxes != null && message.hasOwnProperty("appliedTaxes"))
                    object.appliedTaxes = $root.waiternow.common.TaxesProto.toObject(message.appliedTaxes, options);
                if (message.tax != null && message.hasOwnProperty("tax"))
                    object.tax = $root.waiternow.common.MoneyProto.toObject(message.tax, options);
                if (message.waiterNowFee != null && message.hasOwnProperty("waiterNowFee"))
                    object.waiterNowFee = $root.waiternow.common.MoneyProto.toObject(message.waiterNowFee, options);
                if (message.tip != null && message.hasOwnProperty("tip"))
                    object.tip = $root.waiternow.common.MoneyProto.toObject(message.tip, options);
                if (message.total != null && message.hasOwnProperty("total"))
                    object.total = $root.waiternow.common.MoneyProto.toObject(message.total, options);
                if (message.paymentTime != null && message.hasOwnProperty("paymentTime"))
                    object.paymentTime = $root.google.protobuf.Timestamp.toObject(message.paymentTime, options);
                if (message.status != null && message.hasOwnProperty("status"))
                    object.status = options.enums === String ? $root.waiternow.common.PaymentProto.Status[message.status] === undefined ? message.status : $root.waiternow.common.PaymentProto.Status[message.status] : message.status;
                if (message.error != null && message.hasOwnProperty("error"))
                    object.error = message.error;
                if (message.expectedReference != null && message.hasOwnProperty("expectedReference"))
                    object.expectedReference = message.expectedReference;
                if (message.referenceFromPaymentCollector != null && message.hasOwnProperty("referenceFromPaymentCollector"))
                    object.referenceFromPaymentCollector = message.referenceFromPaymentCollector;
                if (message.cancelationStatus != null && message.hasOwnProperty("cancelationStatus"))
                    object.cancelationStatus = $root.waiternow.common.PaymentProto.CancelationStatusProto.toObject(message.cancelationStatus, options);
                if (message.refundStatus != null && message.hasOwnProperty("refundStatus"))
                    object.refundStatus = $root.waiternow.common.PaymentProto.RefundStatusProto.toObject(message.refundStatus, options);
                if (message.stripeClientSecret != null && message.hasOwnProperty("stripeClientSecret"))
                    object.stripeClientSecret = message.stripeClientSecret;
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                    object.lastUpdateTime = $root.google.protobuf.Timestamp.toObject(message.lastUpdateTime, options);
                if (message.partialRefunds && message.partialRefunds.length) {
                    object.partialRefunds = [];
                    for (var j = 0; j < message.partialRefunds.length; ++j)
                        object.partialRefunds[j] = $root.waiternow.common.PaymentProto.PartialRefundProto.toObject(message.partialRefunds[j], options);
                }
                if (message.discounts && message.discounts.length) {
                    object.discounts = [];
                    for (var j = 0; j < message.discounts.length; ++j)
                        object.discounts[j] = $root.waiternow.common.DiscountProto.toObject(message.discounts[j], options);
                }
                if (message.payerEmail != null && message.hasOwnProperty("payerEmail"))
                    object.payerEmail = message.payerEmail;
                if (message.payerPhoneNumber != null && message.hasOwnProperty("payerPhoneNumber"))
                    object.payerPhoneNumber = $root.waiternow.common.PhoneNumberProto.toObject(message.payerPhoneNumber, options);
                if (message.deliveryFee != null && message.hasOwnProperty("deliveryFee"))
                    object.deliveryFee = $root.waiternow.common.MoneyProto.toObject(message.deliveryFee, options);
                if (message.isDeliveryFeePaidToBusiness != null && message.hasOwnProperty("isDeliveryFeePaidToBusiness"))
                    object.isDeliveryFeePaidToBusiness = message.isDeliveryFeePaidToBusiness;
                if (message.isDeliveryFeeChargedToWaiterNow != null && message.hasOwnProperty("isDeliveryFeeChargedToWaiterNow"))
                    object.isDeliveryFeeChargedToWaiterNow = message.isDeliveryFeeChargedToWaiterNow;
                if (message.deliveryTip != null && message.hasOwnProperty("deliveryTip"))
                    object.deliveryTip = $root.waiternow.common.MoneyProto.toObject(message.deliveryTip, options);
                if (message.creditCardFeeAdjustment != null && message.hasOwnProperty("creditCardFeeAdjustment"))
                    object.creditCardFeeAdjustment = $root.waiternow.common.MoneyProto.toObject(message.creditCardFeeAdjustment, options);
                if (message.serviceFee != null && message.hasOwnProperty("serviceFee"))
                    object.serviceFee = $root.waiternow.common.MoneyProto.toObject(message.serviceFee, options);
                if (message.stripeFee != null && message.hasOwnProperty("stripeFee"))
                    object.stripeFee = $root.waiternow.common.MoneyProto.toObject(message.stripeFee, options);
                if (message.applicationFee != null && message.hasOwnProperty("applicationFee"))
                    object.applicationFee = $root.waiternow.common.MoneyProto.toObject(message.applicationFee, options);
                if (message.netPaidToBusiness != null && message.hasOwnProperty("netPaidToBusiness"))
                    object.netPaidToBusiness = $root.waiternow.common.MoneyProto.toObject(message.netPaidToBusiness, options);
                if (message.isCreditCardFeeChargedToConsumer != null && message.hasOwnProperty("isCreditCardFeeChargedToConsumer"))
                    object.isCreditCardFeeChargedToConsumer = message.isCreditCardFeeChargedToConsumer;
                if (message.dispute != null && message.hasOwnProperty("dispute"))
                    object.dispute = $root.waiternow.common.PaymentProto.DisputeProto.toObject(message.dispute, options);
                if (message.isTaxIncludedInPrice != null && message.hasOwnProperty("isTaxIncludedInPrice"))
                    object.isTaxIncludedInPrice = message.isTaxIncludedInPrice;
                if (message.creditCardFeeAdjustmentForThirdPartyDelivery != null && message.hasOwnProperty("creditCardFeeAdjustmentForThirdPartyDelivery"))
                    object.creditCardFeeAdjustmentForThirdPartyDelivery = $root.waiternow.common.MoneyProto.toObject(message.creditCardFeeAdjustmentForThirdPartyDelivery, options);
                if (message.paymentAttempt != null && message.hasOwnProperty("paymentAttempt"))
                    object.paymentAttempt = $root.waiternow.common.PaymentProto.PaymentAttemptProto.toObject(message.paymentAttempt, options);
                if (message.stripeFeeIncludesTaxesAppliedToOriginalStripeFee != null && message.hasOwnProperty("stripeFeeIncludesTaxesAppliedToOriginalStripeFee"))
                    object.stripeFeeIncludesTaxesAppliedToOriginalStripeFee = message.stripeFeeIncludesTaxesAppliedToOriginalStripeFee;
                return object;
            };

            /**
             * Converts this PaymentProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.PaymentProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            PaymentProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for PaymentProto
             * @function getTypeUrl
             * @memberof waiternow.common.PaymentProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            PaymentProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.PaymentProto";
            };

            /**
             * PaymentCollector enum.
             * @name waiternow.common.PaymentProto.PaymentCollector
             * @enum {number}
             * @property {number} PAYMENT_COLLECTOR_UNSPECIFIED=0 PAYMENT_COLLECTOR_UNSPECIFIED value
             * @property {number} PAYPAL_USA=1 PAYPAL_USA value
             * @property {number} STRIPE_USA=2 STRIPE_USA value
             * @property {number} STRIPE_MEXICO=3 STRIPE_MEXICO value
             */
            PaymentProto.PaymentCollector = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "PAYMENT_COLLECTOR_UNSPECIFIED"] = 0;
                values[valuesById[1] = "PAYPAL_USA"] = 1;
                values[valuesById[2] = "STRIPE_USA"] = 2;
                values[valuesById[3] = "STRIPE_MEXICO"] = 3;
                return values;
            })();

            /**
             * Status enum.
             * @name waiternow.common.PaymentProto.Status
             * @enum {number}
             * @property {number} STATUS_UNSPECIFIED=0 STATUS_UNSPECIFIED value
             * @property {number} SUCCESSFUL=1 SUCCESSFUL value
             * @property {number} SUCCESSFUL_FOR_LATER=9 SUCCESSFUL_FOR_LATER value
             * @property {number} REQUIRES_PAYMENT_METHOD=2 REQUIRES_PAYMENT_METHOD value
             * @property {number} REQUIRES_ACTION=3 REQUIRES_ACTION value
             * @property {number} PROCESSING=4 PROCESSING value
             * @property {number} DECLINED=5 DECLINED value
             * @property {number} CANCELED=6 CANCELED value
             * @property {number} REFUNDED=7 REFUNDED value
             * @property {number} DISPUTED=8 DISPUTED value
             */
            PaymentProto.Status = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "STATUS_UNSPECIFIED"] = 0;
                values[valuesById[1] = "SUCCESSFUL"] = 1;
                values[valuesById[9] = "SUCCESSFUL_FOR_LATER"] = 9;
                values[valuesById[2] = "REQUIRES_PAYMENT_METHOD"] = 2;
                values[valuesById[3] = "REQUIRES_ACTION"] = 3;
                values[valuesById[4] = "PROCESSING"] = 4;
                values[valuesById[5] = "DECLINED"] = 5;
                values[valuesById[6] = "CANCELED"] = 6;
                values[valuesById[7] = "REFUNDED"] = 7;
                values[valuesById[8] = "DISPUTED"] = 8;
                return values;
            })();

            PaymentProto.CancelationStatusProto = (function() {

                /**
                 * Properties of a CancelationStatusProto.
                 * @memberof waiternow.common.PaymentProto
                 * @interface ICancelationStatusProto
                 * @property {string|null} [cancelationId] CancelationStatusProto cancelationId
                 * @property {google.protobuf.ITimestamp|null} [cancelationTime] CancelationStatusProto cancelationTime
                 * @property {waiternow.common.PaymentProto.CancelationStatusProto.State|null} [state] CancelationStatusProto state
                 * @property {string|null} [error] CancelationStatusProto error
                 */

                /**
                 * Constructs a new CancelationStatusProto.
                 * @memberof waiternow.common.PaymentProto
                 * @classdesc Represents a CancelationStatusProto.
                 * @implements ICancelationStatusProto
                 * @constructor
                 * @param {waiternow.common.PaymentProto.ICancelationStatusProto=} [properties] Properties to set
                 */
                function CancelationStatusProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * CancelationStatusProto cancelationId.
                 * @member {string} cancelationId
                 * @memberof waiternow.common.PaymentProto.CancelationStatusProto
                 * @instance
                 */
                CancelationStatusProto.prototype.cancelationId = "";

                /**
                 * CancelationStatusProto cancelationTime.
                 * @member {google.protobuf.ITimestamp|null|undefined} cancelationTime
                 * @memberof waiternow.common.PaymentProto.CancelationStatusProto
                 * @instance
                 */
                CancelationStatusProto.prototype.cancelationTime = null;

                /**
                 * CancelationStatusProto state.
                 * @member {waiternow.common.PaymentProto.CancelationStatusProto.State} state
                 * @memberof waiternow.common.PaymentProto.CancelationStatusProto
                 * @instance
                 */
                CancelationStatusProto.prototype.state = 0;

                /**
                 * CancelationStatusProto error.
                 * @member {string} error
                 * @memberof waiternow.common.PaymentProto.CancelationStatusProto
                 * @instance
                 */
                CancelationStatusProto.prototype.error = "";

                /**
                 * Creates a new CancelationStatusProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.PaymentProto.CancelationStatusProto
                 * @static
                 * @param {waiternow.common.PaymentProto.ICancelationStatusProto=} [properties] Properties to set
                 * @returns {waiternow.common.PaymentProto.CancelationStatusProto} CancelationStatusProto instance
                 */
                CancelationStatusProto.create = function create(properties) {
                    return new CancelationStatusProto(properties);
                };

                /**
                 * Encodes the specified CancelationStatusProto message. Does not implicitly {@link waiternow.common.PaymentProto.CancelationStatusProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.PaymentProto.CancelationStatusProto
                 * @static
                 * @param {waiternow.common.PaymentProto.ICancelationStatusProto} message CancelationStatusProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CancelationStatusProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.cancelationId != null && Object.hasOwnProperty.call(message, "cancelationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.cancelationId);
                    if (message.cancelationTime != null && Object.hasOwnProperty.call(message, "cancelationTime"))
                        $root.google.protobuf.Timestamp.encode(message.cancelationTime, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.state);
                    if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.error);
                    return writer;
                };

                /**
                 * Encodes the specified CancelationStatusProto message, length delimited. Does not implicitly {@link waiternow.common.PaymentProto.CancelationStatusProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.PaymentProto.CancelationStatusProto
                 * @static
                 * @param {waiternow.common.PaymentProto.ICancelationStatusProto} message CancelationStatusProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CancelationStatusProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a CancelationStatusProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.PaymentProto.CancelationStatusProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.PaymentProto.CancelationStatusProto} CancelationStatusProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CancelationStatusProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PaymentProto.CancelationStatusProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.cancelationId = reader.string();
                                break;
                            }
                        case 2: {
                                message.cancelationTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.state = reader.int32();
                                break;
                            }
                        case 4: {
                                message.error = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a CancelationStatusProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.PaymentProto.CancelationStatusProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.PaymentProto.CancelationStatusProto} CancelationStatusProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CancelationStatusProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a CancelationStatusProto message.
                 * @function verify
                 * @memberof waiternow.common.PaymentProto.CancelationStatusProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                CancelationStatusProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.cancelationId != null && message.hasOwnProperty("cancelationId"))
                        if (!$util.isString(message.cancelationId))
                            return "cancelationId: string expected";
                    if (message.cancelationTime != null && message.hasOwnProperty("cancelationTime")) {
                        var error = $root.google.protobuf.Timestamp.verify(message.cancelationTime);
                        if (error)
                            return "cancelationTime." + error;
                    }
                    if (message.state != null && message.hasOwnProperty("state"))
                        switch (message.state) {
                        default:
                            return "state: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                            break;
                        }
                    if (message.error != null && message.hasOwnProperty("error"))
                        if (!$util.isString(message.error))
                            return "error: string expected";
                    return null;
                };

                /**
                 * Creates a CancelationStatusProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.PaymentProto.CancelationStatusProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.PaymentProto.CancelationStatusProto} CancelationStatusProto
                 */
                CancelationStatusProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.PaymentProto.CancelationStatusProto)
                        return object;
                    var message = new $root.waiternow.common.PaymentProto.CancelationStatusProto();
                    if (object.cancelationId != null)
                        message.cancelationId = String(object.cancelationId);
                    if (object.cancelationTime != null) {
                        if (typeof object.cancelationTime !== "object")
                            throw TypeError(".waiternow.common.PaymentProto.CancelationStatusProto.cancelationTime: object expected");
                        message.cancelationTime = $root.google.protobuf.Timestamp.fromObject(object.cancelationTime);
                    }
                    switch (object.state) {
                    default:
                        if (typeof object.state === "number") {
                            message.state = object.state;
                            break;
                        }
                        break;
                    case "STATUS_UNSPECIFIED":
                    case 0:
                        message.state = 0;
                        break;
                    case "SUCCESSFUL":
                    case 1:
                        message.state = 1;
                        break;
                    case "PENDING":
                    case 2:
                        message.state = 2;
                        break;
                    case "FAILED":
                    case 3:
                        message.state = 3;
                        break;
                    }
                    if (object.error != null)
                        message.error = String(object.error);
                    return message;
                };

                /**
                 * Creates a plain object from a CancelationStatusProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.PaymentProto.CancelationStatusProto
                 * @static
                 * @param {waiternow.common.PaymentProto.CancelationStatusProto} message CancelationStatusProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                CancelationStatusProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.cancelationId = "";
                        object.cancelationTime = null;
                        object.state = options.enums === String ? "STATUS_UNSPECIFIED" : 0;
                        object.error = "";
                    }
                    if (message.cancelationId != null && message.hasOwnProperty("cancelationId"))
                        object.cancelationId = message.cancelationId;
                    if (message.cancelationTime != null && message.hasOwnProperty("cancelationTime"))
                        object.cancelationTime = $root.google.protobuf.Timestamp.toObject(message.cancelationTime, options);
                    if (message.state != null && message.hasOwnProperty("state"))
                        object.state = options.enums === String ? $root.waiternow.common.PaymentProto.CancelationStatusProto.State[message.state] === undefined ? message.state : $root.waiternow.common.PaymentProto.CancelationStatusProto.State[message.state] : message.state;
                    if (message.error != null && message.hasOwnProperty("error"))
                        object.error = message.error;
                    return object;
                };

                /**
                 * Converts this CancelationStatusProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.PaymentProto.CancelationStatusProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                CancelationStatusProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for CancelationStatusProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.PaymentProto.CancelationStatusProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                CancelationStatusProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.PaymentProto.CancelationStatusProto";
                };

                /**
                 * State enum.
                 * @name waiternow.common.PaymentProto.CancelationStatusProto.State
                 * @enum {number}
                 * @property {number} STATUS_UNSPECIFIED=0 STATUS_UNSPECIFIED value
                 * @property {number} SUCCESSFUL=1 SUCCESSFUL value
                 * @property {number} PENDING=2 PENDING value
                 * @property {number} FAILED=3 FAILED value
                 */
                CancelationStatusProto.State = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "STATUS_UNSPECIFIED"] = 0;
                    values[valuesById[1] = "SUCCESSFUL"] = 1;
                    values[valuesById[2] = "PENDING"] = 2;
                    values[valuesById[3] = "FAILED"] = 3;
                    return values;
                })();

                return CancelationStatusProto;
            })();

            PaymentProto.RefundStatusProto = (function() {

                /**
                 * Properties of a RefundStatusProto.
                 * @memberof waiternow.common.PaymentProto
                 * @interface IRefundStatusProto
                 * @property {string|null} [refundId] RefundStatusProto refundId
                 * @property {google.protobuf.ITimestamp|null} [refundTime] RefundStatusProto refundTime
                 * @property {waiternow.common.PaymentProto.RefundStatusProto.State|null} [state] RefundStatusProto state
                 * @property {string|null} [error] RefundStatusProto error
                 */

                /**
                 * Constructs a new RefundStatusProto.
                 * @memberof waiternow.common.PaymentProto
                 * @classdesc Represents a RefundStatusProto.
                 * @implements IRefundStatusProto
                 * @constructor
                 * @param {waiternow.common.PaymentProto.IRefundStatusProto=} [properties] Properties to set
                 */
                function RefundStatusProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * RefundStatusProto refundId.
                 * @member {string} refundId
                 * @memberof waiternow.common.PaymentProto.RefundStatusProto
                 * @instance
                 */
                RefundStatusProto.prototype.refundId = "";

                /**
                 * RefundStatusProto refundTime.
                 * @member {google.protobuf.ITimestamp|null|undefined} refundTime
                 * @memberof waiternow.common.PaymentProto.RefundStatusProto
                 * @instance
                 */
                RefundStatusProto.prototype.refundTime = null;

                /**
                 * RefundStatusProto state.
                 * @member {waiternow.common.PaymentProto.RefundStatusProto.State} state
                 * @memberof waiternow.common.PaymentProto.RefundStatusProto
                 * @instance
                 */
                RefundStatusProto.prototype.state = 0;

                /**
                 * RefundStatusProto error.
                 * @member {string} error
                 * @memberof waiternow.common.PaymentProto.RefundStatusProto
                 * @instance
                 */
                RefundStatusProto.prototype.error = "";

                /**
                 * Creates a new RefundStatusProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.PaymentProto.RefundStatusProto
                 * @static
                 * @param {waiternow.common.PaymentProto.IRefundStatusProto=} [properties] Properties to set
                 * @returns {waiternow.common.PaymentProto.RefundStatusProto} RefundStatusProto instance
                 */
                RefundStatusProto.create = function create(properties) {
                    return new RefundStatusProto(properties);
                };

                /**
                 * Encodes the specified RefundStatusProto message. Does not implicitly {@link waiternow.common.PaymentProto.RefundStatusProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.PaymentProto.RefundStatusProto
                 * @static
                 * @param {waiternow.common.PaymentProto.IRefundStatusProto} message RefundStatusProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RefundStatusProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.refundId != null && Object.hasOwnProperty.call(message, "refundId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.refundId);
                    if (message.refundTime != null && Object.hasOwnProperty.call(message, "refundTime"))
                        $root.google.protobuf.Timestamp.encode(message.refundTime, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.state);
                    if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.error);
                    return writer;
                };

                /**
                 * Encodes the specified RefundStatusProto message, length delimited. Does not implicitly {@link waiternow.common.PaymentProto.RefundStatusProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.PaymentProto.RefundStatusProto
                 * @static
                 * @param {waiternow.common.PaymentProto.IRefundStatusProto} message RefundStatusProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RefundStatusProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a RefundStatusProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.PaymentProto.RefundStatusProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.PaymentProto.RefundStatusProto} RefundStatusProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RefundStatusProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PaymentProto.RefundStatusProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.refundId = reader.string();
                                break;
                            }
                        case 2: {
                                message.refundTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.state = reader.int32();
                                break;
                            }
                        case 4: {
                                message.error = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a RefundStatusProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.PaymentProto.RefundStatusProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.PaymentProto.RefundStatusProto} RefundStatusProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RefundStatusProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a RefundStatusProto message.
                 * @function verify
                 * @memberof waiternow.common.PaymentProto.RefundStatusProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                RefundStatusProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.refundId != null && message.hasOwnProperty("refundId"))
                        if (!$util.isString(message.refundId))
                            return "refundId: string expected";
                    if (message.refundTime != null && message.hasOwnProperty("refundTime")) {
                        var error = $root.google.protobuf.Timestamp.verify(message.refundTime);
                        if (error)
                            return "refundTime." + error;
                    }
                    if (message.state != null && message.hasOwnProperty("state"))
                        switch (message.state) {
                        default:
                            return "state: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                            break;
                        }
                    if (message.error != null && message.hasOwnProperty("error"))
                        if (!$util.isString(message.error))
                            return "error: string expected";
                    return null;
                };

                /**
                 * Creates a RefundStatusProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.PaymentProto.RefundStatusProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.PaymentProto.RefundStatusProto} RefundStatusProto
                 */
                RefundStatusProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.PaymentProto.RefundStatusProto)
                        return object;
                    var message = new $root.waiternow.common.PaymentProto.RefundStatusProto();
                    if (object.refundId != null)
                        message.refundId = String(object.refundId);
                    if (object.refundTime != null) {
                        if (typeof object.refundTime !== "object")
                            throw TypeError(".waiternow.common.PaymentProto.RefundStatusProto.refundTime: object expected");
                        message.refundTime = $root.google.protobuf.Timestamp.fromObject(object.refundTime);
                    }
                    switch (object.state) {
                    default:
                        if (typeof object.state === "number") {
                            message.state = object.state;
                            break;
                        }
                        break;
                    case "STATUS_UNSPECIFIED":
                    case 0:
                        message.state = 0;
                        break;
                    case "SUCCESSFUL":
                    case 1:
                        message.state = 1;
                        break;
                    case "PENDING":
                    case 2:
                        message.state = 2;
                        break;
                    case "FAILED":
                    case 3:
                        message.state = 3;
                        break;
                    }
                    if (object.error != null)
                        message.error = String(object.error);
                    return message;
                };

                /**
                 * Creates a plain object from a RefundStatusProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.PaymentProto.RefundStatusProto
                 * @static
                 * @param {waiternow.common.PaymentProto.RefundStatusProto} message RefundStatusProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                RefundStatusProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.refundId = "";
                        object.refundTime = null;
                        object.state = options.enums === String ? "STATUS_UNSPECIFIED" : 0;
                        object.error = "";
                    }
                    if (message.refundId != null && message.hasOwnProperty("refundId"))
                        object.refundId = message.refundId;
                    if (message.refundTime != null && message.hasOwnProperty("refundTime"))
                        object.refundTime = $root.google.protobuf.Timestamp.toObject(message.refundTime, options);
                    if (message.state != null && message.hasOwnProperty("state"))
                        object.state = options.enums === String ? $root.waiternow.common.PaymentProto.RefundStatusProto.State[message.state] === undefined ? message.state : $root.waiternow.common.PaymentProto.RefundStatusProto.State[message.state] : message.state;
                    if (message.error != null && message.hasOwnProperty("error"))
                        object.error = message.error;
                    return object;
                };

                /**
                 * Converts this RefundStatusProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.PaymentProto.RefundStatusProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                RefundStatusProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for RefundStatusProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.PaymentProto.RefundStatusProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                RefundStatusProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.PaymentProto.RefundStatusProto";
                };

                /**
                 * State enum.
                 * @name waiternow.common.PaymentProto.RefundStatusProto.State
                 * @enum {number}
                 * @property {number} STATUS_UNSPECIFIED=0 STATUS_UNSPECIFIED value
                 * @property {number} SUCCESSFUL=1 SUCCESSFUL value
                 * @property {number} PENDING=2 PENDING value
                 * @property {number} FAILED=3 FAILED value
                 */
                RefundStatusProto.State = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "STATUS_UNSPECIFIED"] = 0;
                    values[valuesById[1] = "SUCCESSFUL"] = 1;
                    values[valuesById[2] = "PENDING"] = 2;
                    values[valuesById[3] = "FAILED"] = 3;
                    return values;
                })();

                return RefundStatusProto;
            })();

            PaymentProto.PartialRefundProto = (function() {

                /**
                 * Properties of a PartialRefundProto.
                 * @memberof waiternow.common.PaymentProto
                 * @interface IPartialRefundProto
                 * @property {string|null} [refundId] PartialRefundProto refundId
                 * @property {google.protobuf.ITimestamp|null} [refundTime] PartialRefundProto refundTime
                 * @property {waiternow.common.PaymentProto.PartialRefundProto.State|null} [state] PartialRefundProto state
                 * @property {string|null} [error] PartialRefundProto error
                 * @property {waiternow.common.IMoneyProto|null} [amount] PartialRefundProto amount
                 */

                /**
                 * Constructs a new PartialRefundProto.
                 * @memberof waiternow.common.PaymentProto
                 * @classdesc Represents a PartialRefundProto.
                 * @implements IPartialRefundProto
                 * @constructor
                 * @param {waiternow.common.PaymentProto.IPartialRefundProto=} [properties] Properties to set
                 */
                function PartialRefundProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PartialRefundProto refundId.
                 * @member {string} refundId
                 * @memberof waiternow.common.PaymentProto.PartialRefundProto
                 * @instance
                 */
                PartialRefundProto.prototype.refundId = "";

                /**
                 * PartialRefundProto refundTime.
                 * @member {google.protobuf.ITimestamp|null|undefined} refundTime
                 * @memberof waiternow.common.PaymentProto.PartialRefundProto
                 * @instance
                 */
                PartialRefundProto.prototype.refundTime = null;

                /**
                 * PartialRefundProto state.
                 * @member {waiternow.common.PaymentProto.PartialRefundProto.State} state
                 * @memberof waiternow.common.PaymentProto.PartialRefundProto
                 * @instance
                 */
                PartialRefundProto.prototype.state = 0;

                /**
                 * PartialRefundProto error.
                 * @member {string} error
                 * @memberof waiternow.common.PaymentProto.PartialRefundProto
                 * @instance
                 */
                PartialRefundProto.prototype.error = "";

                /**
                 * PartialRefundProto amount.
                 * @member {waiternow.common.IMoneyProto|null|undefined} amount
                 * @memberof waiternow.common.PaymentProto.PartialRefundProto
                 * @instance
                 */
                PartialRefundProto.prototype.amount = null;

                /**
                 * Creates a new PartialRefundProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.PaymentProto.PartialRefundProto
                 * @static
                 * @param {waiternow.common.PaymentProto.IPartialRefundProto=} [properties] Properties to set
                 * @returns {waiternow.common.PaymentProto.PartialRefundProto} PartialRefundProto instance
                 */
                PartialRefundProto.create = function create(properties) {
                    return new PartialRefundProto(properties);
                };

                /**
                 * Encodes the specified PartialRefundProto message. Does not implicitly {@link waiternow.common.PaymentProto.PartialRefundProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.PaymentProto.PartialRefundProto
                 * @static
                 * @param {waiternow.common.PaymentProto.IPartialRefundProto} message PartialRefundProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PartialRefundProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.refundId != null && Object.hasOwnProperty.call(message, "refundId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.refundId);
                    if (message.refundTime != null && Object.hasOwnProperty.call(message, "refundTime"))
                        $root.google.protobuf.Timestamp.encode(message.refundTime, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.state);
                    if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.error);
                    if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                        $root.waiternow.common.MoneyProto.encode(message.amount, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified PartialRefundProto message, length delimited. Does not implicitly {@link waiternow.common.PaymentProto.PartialRefundProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.PaymentProto.PartialRefundProto
                 * @static
                 * @param {waiternow.common.PaymentProto.IPartialRefundProto} message PartialRefundProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PartialRefundProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PartialRefundProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.PaymentProto.PartialRefundProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.PaymentProto.PartialRefundProto} PartialRefundProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PartialRefundProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PaymentProto.PartialRefundProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.refundId = reader.string();
                                break;
                            }
                        case 2: {
                                message.refundTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.state = reader.int32();
                                break;
                            }
                        case 4: {
                                message.error = reader.string();
                                break;
                            }
                        case 5: {
                                message.amount = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PartialRefundProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.PaymentProto.PartialRefundProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.PaymentProto.PartialRefundProto} PartialRefundProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PartialRefundProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PartialRefundProto message.
                 * @function verify
                 * @memberof waiternow.common.PaymentProto.PartialRefundProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PartialRefundProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.refundId != null && message.hasOwnProperty("refundId"))
                        if (!$util.isString(message.refundId))
                            return "refundId: string expected";
                    if (message.refundTime != null && message.hasOwnProperty("refundTime")) {
                        var error = $root.google.protobuf.Timestamp.verify(message.refundTime);
                        if (error)
                            return "refundTime." + error;
                    }
                    if (message.state != null && message.hasOwnProperty("state"))
                        switch (message.state) {
                        default:
                            return "state: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                            break;
                        }
                    if (message.error != null && message.hasOwnProperty("error"))
                        if (!$util.isString(message.error))
                            return "error: string expected";
                    if (message.amount != null && message.hasOwnProperty("amount")) {
                        var error = $root.waiternow.common.MoneyProto.verify(message.amount);
                        if (error)
                            return "amount." + error;
                    }
                    return null;
                };

                /**
                 * Creates a PartialRefundProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.PaymentProto.PartialRefundProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.PaymentProto.PartialRefundProto} PartialRefundProto
                 */
                PartialRefundProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.PaymentProto.PartialRefundProto)
                        return object;
                    var message = new $root.waiternow.common.PaymentProto.PartialRefundProto();
                    if (object.refundId != null)
                        message.refundId = String(object.refundId);
                    if (object.refundTime != null) {
                        if (typeof object.refundTime !== "object")
                            throw TypeError(".waiternow.common.PaymentProto.PartialRefundProto.refundTime: object expected");
                        message.refundTime = $root.google.protobuf.Timestamp.fromObject(object.refundTime);
                    }
                    switch (object.state) {
                    default:
                        if (typeof object.state === "number") {
                            message.state = object.state;
                            break;
                        }
                        break;
                    case "STATUS_UNSPECIFIED":
                    case 0:
                        message.state = 0;
                        break;
                    case "SUCCESSFUL":
                    case 1:
                        message.state = 1;
                        break;
                    case "PENDING":
                    case 2:
                        message.state = 2;
                        break;
                    case "FAILED":
                    case 3:
                        message.state = 3;
                        break;
                    }
                    if (object.error != null)
                        message.error = String(object.error);
                    if (object.amount != null) {
                        if (typeof object.amount !== "object")
                            throw TypeError(".waiternow.common.PaymentProto.PartialRefundProto.amount: object expected");
                        message.amount = $root.waiternow.common.MoneyProto.fromObject(object.amount);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a PartialRefundProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.PaymentProto.PartialRefundProto
                 * @static
                 * @param {waiternow.common.PaymentProto.PartialRefundProto} message PartialRefundProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PartialRefundProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.refundId = "";
                        object.refundTime = null;
                        object.state = options.enums === String ? "STATUS_UNSPECIFIED" : 0;
                        object.error = "";
                        object.amount = null;
                    }
                    if (message.refundId != null && message.hasOwnProperty("refundId"))
                        object.refundId = message.refundId;
                    if (message.refundTime != null && message.hasOwnProperty("refundTime"))
                        object.refundTime = $root.google.protobuf.Timestamp.toObject(message.refundTime, options);
                    if (message.state != null && message.hasOwnProperty("state"))
                        object.state = options.enums === String ? $root.waiternow.common.PaymentProto.PartialRefundProto.State[message.state] === undefined ? message.state : $root.waiternow.common.PaymentProto.PartialRefundProto.State[message.state] : message.state;
                    if (message.error != null && message.hasOwnProperty("error"))
                        object.error = message.error;
                    if (message.amount != null && message.hasOwnProperty("amount"))
                        object.amount = $root.waiternow.common.MoneyProto.toObject(message.amount, options);
                    return object;
                };

                /**
                 * Converts this PartialRefundProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.PaymentProto.PartialRefundProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PartialRefundProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for PartialRefundProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.PaymentProto.PartialRefundProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                PartialRefundProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.PaymentProto.PartialRefundProto";
                };

                /**
                 * State enum.
                 * @name waiternow.common.PaymentProto.PartialRefundProto.State
                 * @enum {number}
                 * @property {number} STATUS_UNSPECIFIED=0 STATUS_UNSPECIFIED value
                 * @property {number} SUCCESSFUL=1 SUCCESSFUL value
                 * @property {number} PENDING=2 PENDING value
                 * @property {number} FAILED=3 FAILED value
                 */
                PartialRefundProto.State = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "STATUS_UNSPECIFIED"] = 0;
                    values[valuesById[1] = "SUCCESSFUL"] = 1;
                    values[valuesById[2] = "PENDING"] = 2;
                    values[valuesById[3] = "FAILED"] = 3;
                    return values;
                })();

                return PartialRefundProto;
            })();

            PaymentProto.DisputeProto = (function() {

                /**
                 * Properties of a DisputeProto.
                 * @memberof waiternow.common.PaymentProto
                 * @interface IDisputeProto
                 * @property {google.protobuf.ITimestamp|null} [disputeTime] DisputeProto disputeTime
                 * @property {waiternow.common.IDateProto|null} [disputeDate] DisputeProto disputeDate
                 * @property {string|null} [reason] DisputeProto reason
                 * @property {boolean|null} [businessNotNotified] DisputeProto businessNotNotified
                 */

                /**
                 * Constructs a new DisputeProto.
                 * @memberof waiternow.common.PaymentProto
                 * @classdesc Represents a DisputeProto.
                 * @implements IDisputeProto
                 * @constructor
                 * @param {waiternow.common.PaymentProto.IDisputeProto=} [properties] Properties to set
                 */
                function DisputeProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * DisputeProto disputeTime.
                 * @member {google.protobuf.ITimestamp|null|undefined} disputeTime
                 * @memberof waiternow.common.PaymentProto.DisputeProto
                 * @instance
                 */
                DisputeProto.prototype.disputeTime = null;

                /**
                 * DisputeProto disputeDate.
                 * @member {waiternow.common.IDateProto|null|undefined} disputeDate
                 * @memberof waiternow.common.PaymentProto.DisputeProto
                 * @instance
                 */
                DisputeProto.prototype.disputeDate = null;

                /**
                 * DisputeProto reason.
                 * @member {string} reason
                 * @memberof waiternow.common.PaymentProto.DisputeProto
                 * @instance
                 */
                DisputeProto.prototype.reason = "";

                /**
                 * DisputeProto businessNotNotified.
                 * @member {boolean} businessNotNotified
                 * @memberof waiternow.common.PaymentProto.DisputeProto
                 * @instance
                 */
                DisputeProto.prototype.businessNotNotified = false;

                /**
                 * Creates a new DisputeProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.PaymentProto.DisputeProto
                 * @static
                 * @param {waiternow.common.PaymentProto.IDisputeProto=} [properties] Properties to set
                 * @returns {waiternow.common.PaymentProto.DisputeProto} DisputeProto instance
                 */
                DisputeProto.create = function create(properties) {
                    return new DisputeProto(properties);
                };

                /**
                 * Encodes the specified DisputeProto message. Does not implicitly {@link waiternow.common.PaymentProto.DisputeProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.PaymentProto.DisputeProto
                 * @static
                 * @param {waiternow.common.PaymentProto.IDisputeProto} message DisputeProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DisputeProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.disputeDate != null && Object.hasOwnProperty.call(message, "disputeDate"))
                        $root.waiternow.common.DateProto.encode(message.disputeDate, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.reason != null && Object.hasOwnProperty.call(message, "reason"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.reason);
                    if (message.businessNotNotified != null && Object.hasOwnProperty.call(message, "businessNotNotified"))
                        writer.uint32(/* id 3, wireType 0 =*/24).bool(message.businessNotNotified);
                    if (message.disputeTime != null && Object.hasOwnProperty.call(message, "disputeTime"))
                        $root.google.protobuf.Timestamp.encode(message.disputeTime, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified DisputeProto message, length delimited. Does not implicitly {@link waiternow.common.PaymentProto.DisputeProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.PaymentProto.DisputeProto
                 * @static
                 * @param {waiternow.common.PaymentProto.IDisputeProto} message DisputeProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DisputeProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a DisputeProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.PaymentProto.DisputeProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.PaymentProto.DisputeProto} DisputeProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DisputeProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PaymentProto.DisputeProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 4: {
                                message.disputeTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            }
                        case 1: {
                                message.disputeDate = $root.waiternow.common.DateProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.reason = reader.string();
                                break;
                            }
                        case 3: {
                                message.businessNotNotified = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a DisputeProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.PaymentProto.DisputeProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.PaymentProto.DisputeProto} DisputeProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DisputeProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a DisputeProto message.
                 * @function verify
                 * @memberof waiternow.common.PaymentProto.DisputeProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                DisputeProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.disputeTime != null && message.hasOwnProperty("disputeTime")) {
                        var error = $root.google.protobuf.Timestamp.verify(message.disputeTime);
                        if (error)
                            return "disputeTime." + error;
                    }
                    if (message.disputeDate != null && message.hasOwnProperty("disputeDate")) {
                        var error = $root.waiternow.common.DateProto.verify(message.disputeDate);
                        if (error)
                            return "disputeDate." + error;
                    }
                    if (message.reason != null && message.hasOwnProperty("reason"))
                        if (!$util.isString(message.reason))
                            return "reason: string expected";
                    if (message.businessNotNotified != null && message.hasOwnProperty("businessNotNotified"))
                        if (typeof message.businessNotNotified !== "boolean")
                            return "businessNotNotified: boolean expected";
                    return null;
                };

                /**
                 * Creates a DisputeProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.PaymentProto.DisputeProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.PaymentProto.DisputeProto} DisputeProto
                 */
                DisputeProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.PaymentProto.DisputeProto)
                        return object;
                    var message = new $root.waiternow.common.PaymentProto.DisputeProto();
                    if (object.disputeTime != null) {
                        if (typeof object.disputeTime !== "object")
                            throw TypeError(".waiternow.common.PaymentProto.DisputeProto.disputeTime: object expected");
                        message.disputeTime = $root.google.protobuf.Timestamp.fromObject(object.disputeTime);
                    }
                    if (object.disputeDate != null) {
                        if (typeof object.disputeDate !== "object")
                            throw TypeError(".waiternow.common.PaymentProto.DisputeProto.disputeDate: object expected");
                        message.disputeDate = $root.waiternow.common.DateProto.fromObject(object.disputeDate);
                    }
                    if (object.reason != null)
                        message.reason = String(object.reason);
                    if (object.businessNotNotified != null)
                        message.businessNotNotified = Boolean(object.businessNotNotified);
                    return message;
                };

                /**
                 * Creates a plain object from a DisputeProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.PaymentProto.DisputeProto
                 * @static
                 * @param {waiternow.common.PaymentProto.DisputeProto} message DisputeProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                DisputeProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.disputeDate = null;
                        object.reason = "";
                        object.businessNotNotified = false;
                        object.disputeTime = null;
                    }
                    if (message.disputeDate != null && message.hasOwnProperty("disputeDate"))
                        object.disputeDate = $root.waiternow.common.DateProto.toObject(message.disputeDate, options);
                    if (message.reason != null && message.hasOwnProperty("reason"))
                        object.reason = message.reason;
                    if (message.businessNotNotified != null && message.hasOwnProperty("businessNotNotified"))
                        object.businessNotNotified = message.businessNotNotified;
                    if (message.disputeTime != null && message.hasOwnProperty("disputeTime"))
                        object.disputeTime = $root.google.protobuf.Timestamp.toObject(message.disputeTime, options);
                    return object;
                };

                /**
                 * Converts this DisputeProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.PaymentProto.DisputeProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                DisputeProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for DisputeProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.PaymentProto.DisputeProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                DisputeProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.PaymentProto.DisputeProto";
                };

                return DisputeProto;
            })();

            PaymentProto.PaymentAttemptProto = (function() {

                /**
                 * Properties of a PaymentAttemptProto.
                 * @memberof waiternow.common.PaymentProto
                 * @interface IPaymentAttemptProto
                 * @property {boolean|null} [paymentAttempted] PaymentAttemptProto paymentAttempted
                 * @property {google.protobuf.ITimestamp|null} [paymentAttemptTime] PaymentAttemptProto paymentAttemptTime
                 */

                /**
                 * Constructs a new PaymentAttemptProto.
                 * @memberof waiternow.common.PaymentProto
                 * @classdesc Represents a PaymentAttemptProto.
                 * @implements IPaymentAttemptProto
                 * @constructor
                 * @param {waiternow.common.PaymentProto.IPaymentAttemptProto=} [properties] Properties to set
                 */
                function PaymentAttemptProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PaymentAttemptProto paymentAttempted.
                 * @member {boolean} paymentAttempted
                 * @memberof waiternow.common.PaymentProto.PaymentAttemptProto
                 * @instance
                 */
                PaymentAttemptProto.prototype.paymentAttempted = false;

                /**
                 * PaymentAttemptProto paymentAttemptTime.
                 * @member {google.protobuf.ITimestamp|null|undefined} paymentAttemptTime
                 * @memberof waiternow.common.PaymentProto.PaymentAttemptProto
                 * @instance
                 */
                PaymentAttemptProto.prototype.paymentAttemptTime = null;

                /**
                 * Creates a new PaymentAttemptProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.PaymentProto.PaymentAttemptProto
                 * @static
                 * @param {waiternow.common.PaymentProto.IPaymentAttemptProto=} [properties] Properties to set
                 * @returns {waiternow.common.PaymentProto.PaymentAttemptProto} PaymentAttemptProto instance
                 */
                PaymentAttemptProto.create = function create(properties) {
                    return new PaymentAttemptProto(properties);
                };

                /**
                 * Encodes the specified PaymentAttemptProto message. Does not implicitly {@link waiternow.common.PaymentProto.PaymentAttemptProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.PaymentProto.PaymentAttemptProto
                 * @static
                 * @param {waiternow.common.PaymentProto.IPaymentAttemptProto} message PaymentAttemptProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PaymentAttemptProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.paymentAttempted != null && Object.hasOwnProperty.call(message, "paymentAttempted"))
                        writer.uint32(/* id 1, wireType 0 =*/8).bool(message.paymentAttempted);
                    if (message.paymentAttemptTime != null && Object.hasOwnProperty.call(message, "paymentAttemptTime"))
                        $root.google.protobuf.Timestamp.encode(message.paymentAttemptTime, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified PaymentAttemptProto message, length delimited. Does not implicitly {@link waiternow.common.PaymentProto.PaymentAttemptProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.PaymentProto.PaymentAttemptProto
                 * @static
                 * @param {waiternow.common.PaymentProto.IPaymentAttemptProto} message PaymentAttemptProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PaymentAttemptProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PaymentAttemptProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.PaymentProto.PaymentAttemptProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.PaymentProto.PaymentAttemptProto} PaymentAttemptProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PaymentAttemptProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PaymentProto.PaymentAttemptProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.paymentAttempted = reader.bool();
                                break;
                            }
                        case 2: {
                                message.paymentAttemptTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PaymentAttemptProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.PaymentProto.PaymentAttemptProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.PaymentProto.PaymentAttemptProto} PaymentAttemptProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PaymentAttemptProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PaymentAttemptProto message.
                 * @function verify
                 * @memberof waiternow.common.PaymentProto.PaymentAttemptProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PaymentAttemptProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.paymentAttempted != null && message.hasOwnProperty("paymentAttempted"))
                        if (typeof message.paymentAttempted !== "boolean")
                            return "paymentAttempted: boolean expected";
                    if (message.paymentAttemptTime != null && message.hasOwnProperty("paymentAttemptTime")) {
                        var error = $root.google.protobuf.Timestamp.verify(message.paymentAttemptTime);
                        if (error)
                            return "paymentAttemptTime." + error;
                    }
                    return null;
                };

                /**
                 * Creates a PaymentAttemptProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.PaymentProto.PaymentAttemptProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.PaymentProto.PaymentAttemptProto} PaymentAttemptProto
                 */
                PaymentAttemptProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.PaymentProto.PaymentAttemptProto)
                        return object;
                    var message = new $root.waiternow.common.PaymentProto.PaymentAttemptProto();
                    if (object.paymentAttempted != null)
                        message.paymentAttempted = Boolean(object.paymentAttempted);
                    if (object.paymentAttemptTime != null) {
                        if (typeof object.paymentAttemptTime !== "object")
                            throw TypeError(".waiternow.common.PaymentProto.PaymentAttemptProto.paymentAttemptTime: object expected");
                        message.paymentAttemptTime = $root.google.protobuf.Timestamp.fromObject(object.paymentAttemptTime);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a PaymentAttemptProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.PaymentProto.PaymentAttemptProto
                 * @static
                 * @param {waiternow.common.PaymentProto.PaymentAttemptProto} message PaymentAttemptProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PaymentAttemptProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.paymentAttempted = false;
                        object.paymentAttemptTime = null;
                    }
                    if (message.paymentAttempted != null && message.hasOwnProperty("paymentAttempted"))
                        object.paymentAttempted = message.paymentAttempted;
                    if (message.paymentAttemptTime != null && message.hasOwnProperty("paymentAttemptTime"))
                        object.paymentAttemptTime = $root.google.protobuf.Timestamp.toObject(message.paymentAttemptTime, options);
                    return object;
                };

                /**
                 * Converts this PaymentAttemptProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.PaymentProto.PaymentAttemptProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PaymentAttemptProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for PaymentAttemptProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.PaymentProto.PaymentAttemptProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                PaymentAttemptProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.PaymentProto.PaymentAttemptProto";
                };

                return PaymentAttemptProto;
            })();

            return PaymentProto;
        })();

        common.OrderTotalCalculationProto = (function() {

            /**
             * Properties of an OrderTotalCalculationProto.
             * @memberof waiternow.common
             * @interface IOrderTotalCalculationProto
             * @property {waiternow.common.IMoneyProto|null} [subtotal] OrderTotalCalculationProto subtotal
             * @property {Array.<waiternow.common.IDiscountProto>|null} [discounts] OrderTotalCalculationProto discounts
             * @property {waiternow.common.ITaxesProto|null} [appliedTaxes] OrderTotalCalculationProto appliedTaxes
             * @property {waiternow.common.IMoneyProto|null} [tax] OrderTotalCalculationProto tax
             * @property {waiternow.common.IMoneyProto|null} [tip] OrderTotalCalculationProto tip
             * @property {waiternow.common.IMoneyProto|null} [deliveryFee] OrderTotalCalculationProto deliveryFee
             * @property {boolean|null} [isDeliveryFeePaidToBusiness] OrderTotalCalculationProto isDeliveryFeePaidToBusiness
             * @property {boolean|null} [isDeliveryFeeChargedToWaiterNow] OrderTotalCalculationProto isDeliveryFeeChargedToWaiterNow
             * @property {waiternow.common.IMoneyProto|null} [deliveryTip] OrderTotalCalculationProto deliveryTip
             * @property {waiternow.common.IMoneyProto|null} [creditCardFeeAdjustment] OrderTotalCalculationProto creditCardFeeAdjustment
             * @property {boolean|null} [isCreditCardFeeChargedToConsumer] OrderTotalCalculationProto isCreditCardFeeChargedToConsumer
             * @property {waiternow.common.IMoneyProto|null} [creditCardFeeAdjustmentForThirdPartyDelivery] OrderTotalCalculationProto creditCardFeeAdjustmentForThirdPartyDelivery
             * @property {waiternow.common.IMoneyProto|null} [waiterNowFee] OrderTotalCalculationProto waiterNowFee
             * @property {waiternow.common.IMoneyProto|null} [serviceFee] OrderTotalCalculationProto serviceFee
             * @property {waiternow.common.IMoneyProto|null} [total] OrderTotalCalculationProto total
             * @property {waiternow.common.IMoneyProto|null} [stripeFee] OrderTotalCalculationProto stripeFee
             * @property {waiternow.common.IMoneyProto|null} [applicationFee] OrderTotalCalculationProto applicationFee
             * @property {waiternow.common.IMoneyProto|null} [netPaidToBusiness] OrderTotalCalculationProto netPaidToBusiness
             * @property {boolean|null} [isTaxIncludedInPrice] OrderTotalCalculationProto isTaxIncludedInPrice
             * @property {boolean|null} [stripeFeeIncludesTaxesAppliedToOriginalStripeFee] OrderTotalCalculationProto stripeFeeIncludesTaxesAppliedToOriginalStripeFee
             */

            /**
             * Constructs a new OrderTotalCalculationProto.
             * @memberof waiternow.common
             * @classdesc Represents an OrderTotalCalculationProto.
             * @implements IOrderTotalCalculationProto
             * @constructor
             * @param {waiternow.common.IOrderTotalCalculationProto=} [properties] Properties to set
             */
            function OrderTotalCalculationProto(properties) {
                this.discounts = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * OrderTotalCalculationProto subtotal.
             * @member {waiternow.common.IMoneyProto|null|undefined} subtotal
             * @memberof waiternow.common.OrderTotalCalculationProto
             * @instance
             */
            OrderTotalCalculationProto.prototype.subtotal = null;

            /**
             * OrderTotalCalculationProto discounts.
             * @member {Array.<waiternow.common.IDiscountProto>} discounts
             * @memberof waiternow.common.OrderTotalCalculationProto
             * @instance
             */
            OrderTotalCalculationProto.prototype.discounts = $util.emptyArray;

            /**
             * OrderTotalCalculationProto appliedTaxes.
             * @member {waiternow.common.ITaxesProto|null|undefined} appliedTaxes
             * @memberof waiternow.common.OrderTotalCalculationProto
             * @instance
             */
            OrderTotalCalculationProto.prototype.appliedTaxes = null;

            /**
             * OrderTotalCalculationProto tax.
             * @member {waiternow.common.IMoneyProto|null|undefined} tax
             * @memberof waiternow.common.OrderTotalCalculationProto
             * @instance
             */
            OrderTotalCalculationProto.prototype.tax = null;

            /**
             * OrderTotalCalculationProto tip.
             * @member {waiternow.common.IMoneyProto|null|undefined} tip
             * @memberof waiternow.common.OrderTotalCalculationProto
             * @instance
             */
            OrderTotalCalculationProto.prototype.tip = null;

            /**
             * OrderTotalCalculationProto deliveryFee.
             * @member {waiternow.common.IMoneyProto|null|undefined} deliveryFee
             * @memberof waiternow.common.OrderTotalCalculationProto
             * @instance
             */
            OrderTotalCalculationProto.prototype.deliveryFee = null;

            /**
             * OrderTotalCalculationProto isDeliveryFeePaidToBusiness.
             * @member {boolean} isDeliveryFeePaidToBusiness
             * @memberof waiternow.common.OrderTotalCalculationProto
             * @instance
             */
            OrderTotalCalculationProto.prototype.isDeliveryFeePaidToBusiness = false;

            /**
             * OrderTotalCalculationProto isDeliveryFeeChargedToWaiterNow.
             * @member {boolean} isDeliveryFeeChargedToWaiterNow
             * @memberof waiternow.common.OrderTotalCalculationProto
             * @instance
             */
            OrderTotalCalculationProto.prototype.isDeliveryFeeChargedToWaiterNow = false;

            /**
             * OrderTotalCalculationProto deliveryTip.
             * @member {waiternow.common.IMoneyProto|null|undefined} deliveryTip
             * @memberof waiternow.common.OrderTotalCalculationProto
             * @instance
             */
            OrderTotalCalculationProto.prototype.deliveryTip = null;

            /**
             * OrderTotalCalculationProto creditCardFeeAdjustment.
             * @member {waiternow.common.IMoneyProto|null|undefined} creditCardFeeAdjustment
             * @memberof waiternow.common.OrderTotalCalculationProto
             * @instance
             */
            OrderTotalCalculationProto.prototype.creditCardFeeAdjustment = null;

            /**
             * OrderTotalCalculationProto isCreditCardFeeChargedToConsumer.
             * @member {boolean} isCreditCardFeeChargedToConsumer
             * @memberof waiternow.common.OrderTotalCalculationProto
             * @instance
             */
            OrderTotalCalculationProto.prototype.isCreditCardFeeChargedToConsumer = false;

            /**
             * OrderTotalCalculationProto creditCardFeeAdjustmentForThirdPartyDelivery.
             * @member {waiternow.common.IMoneyProto|null|undefined} creditCardFeeAdjustmentForThirdPartyDelivery
             * @memberof waiternow.common.OrderTotalCalculationProto
             * @instance
             */
            OrderTotalCalculationProto.prototype.creditCardFeeAdjustmentForThirdPartyDelivery = null;

            /**
             * OrderTotalCalculationProto waiterNowFee.
             * @member {waiternow.common.IMoneyProto|null|undefined} waiterNowFee
             * @memberof waiternow.common.OrderTotalCalculationProto
             * @instance
             */
            OrderTotalCalculationProto.prototype.waiterNowFee = null;

            /**
             * OrderTotalCalculationProto serviceFee.
             * @member {waiternow.common.IMoneyProto|null|undefined} serviceFee
             * @memberof waiternow.common.OrderTotalCalculationProto
             * @instance
             */
            OrderTotalCalculationProto.prototype.serviceFee = null;

            /**
             * OrderTotalCalculationProto total.
             * @member {waiternow.common.IMoneyProto|null|undefined} total
             * @memberof waiternow.common.OrderTotalCalculationProto
             * @instance
             */
            OrderTotalCalculationProto.prototype.total = null;

            /**
             * OrderTotalCalculationProto stripeFee.
             * @member {waiternow.common.IMoneyProto|null|undefined} stripeFee
             * @memberof waiternow.common.OrderTotalCalculationProto
             * @instance
             */
            OrderTotalCalculationProto.prototype.stripeFee = null;

            /**
             * OrderTotalCalculationProto applicationFee.
             * @member {waiternow.common.IMoneyProto|null|undefined} applicationFee
             * @memberof waiternow.common.OrderTotalCalculationProto
             * @instance
             */
            OrderTotalCalculationProto.prototype.applicationFee = null;

            /**
             * OrderTotalCalculationProto netPaidToBusiness.
             * @member {waiternow.common.IMoneyProto|null|undefined} netPaidToBusiness
             * @memberof waiternow.common.OrderTotalCalculationProto
             * @instance
             */
            OrderTotalCalculationProto.prototype.netPaidToBusiness = null;

            /**
             * OrderTotalCalculationProto isTaxIncludedInPrice.
             * @member {boolean} isTaxIncludedInPrice
             * @memberof waiternow.common.OrderTotalCalculationProto
             * @instance
             */
            OrderTotalCalculationProto.prototype.isTaxIncludedInPrice = false;

            /**
             * OrderTotalCalculationProto stripeFeeIncludesTaxesAppliedToOriginalStripeFee.
             * @member {boolean} stripeFeeIncludesTaxesAppliedToOriginalStripeFee
             * @memberof waiternow.common.OrderTotalCalculationProto
             * @instance
             */
            OrderTotalCalculationProto.prototype.stripeFeeIncludesTaxesAppliedToOriginalStripeFee = false;

            /**
             * Creates a new OrderTotalCalculationProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.OrderTotalCalculationProto
             * @static
             * @param {waiternow.common.IOrderTotalCalculationProto=} [properties] Properties to set
             * @returns {waiternow.common.OrderTotalCalculationProto} OrderTotalCalculationProto instance
             */
            OrderTotalCalculationProto.create = function create(properties) {
                return new OrderTotalCalculationProto(properties);
            };

            /**
             * Encodes the specified OrderTotalCalculationProto message. Does not implicitly {@link waiternow.common.OrderTotalCalculationProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.OrderTotalCalculationProto
             * @static
             * @param {waiternow.common.IOrderTotalCalculationProto} message OrderTotalCalculationProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OrderTotalCalculationProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.subtotal != null && Object.hasOwnProperty.call(message, "subtotal"))
                    $root.waiternow.common.MoneyProto.encode(message.subtotal, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.discounts != null && message.discounts.length)
                    for (var i = 0; i < message.discounts.length; ++i)
                        $root.waiternow.common.DiscountProto.encode(message.discounts[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.appliedTaxes != null && Object.hasOwnProperty.call(message, "appliedTaxes"))
                    $root.waiternow.common.TaxesProto.encode(message.appliedTaxes, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.tax != null && Object.hasOwnProperty.call(message, "tax"))
                    $root.waiternow.common.MoneyProto.encode(message.tax, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                if (message.tip != null && Object.hasOwnProperty.call(message, "tip"))
                    $root.waiternow.common.MoneyProto.encode(message.tip, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                if (message.deliveryFee != null && Object.hasOwnProperty.call(message, "deliveryFee"))
                    $root.waiternow.common.MoneyProto.encode(message.deliveryFee, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                if (message.isDeliveryFeePaidToBusiness != null && Object.hasOwnProperty.call(message, "isDeliveryFeePaidToBusiness"))
                    writer.uint32(/* id 7, wireType 0 =*/56).bool(message.isDeliveryFeePaidToBusiness);
                if (message.isDeliveryFeeChargedToWaiterNow != null && Object.hasOwnProperty.call(message, "isDeliveryFeeChargedToWaiterNow"))
                    writer.uint32(/* id 8, wireType 0 =*/64).bool(message.isDeliveryFeeChargedToWaiterNow);
                if (message.deliveryTip != null && Object.hasOwnProperty.call(message, "deliveryTip"))
                    $root.waiternow.common.MoneyProto.encode(message.deliveryTip, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                if (message.creditCardFeeAdjustment != null && Object.hasOwnProperty.call(message, "creditCardFeeAdjustment"))
                    $root.waiternow.common.MoneyProto.encode(message.creditCardFeeAdjustment, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                if (message.isCreditCardFeeChargedToConsumer != null && Object.hasOwnProperty.call(message, "isCreditCardFeeChargedToConsumer"))
                    writer.uint32(/* id 11, wireType 0 =*/88).bool(message.isCreditCardFeeChargedToConsumer);
                if (message.waiterNowFee != null && Object.hasOwnProperty.call(message, "waiterNowFee"))
                    $root.waiternow.common.MoneyProto.encode(message.waiterNowFee, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                if (message.serviceFee != null && Object.hasOwnProperty.call(message, "serviceFee"))
                    $root.waiternow.common.MoneyProto.encode(message.serviceFee, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
                if (message.total != null && Object.hasOwnProperty.call(message, "total"))
                    $root.waiternow.common.MoneyProto.encode(message.total, writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
                if (message.stripeFee != null && Object.hasOwnProperty.call(message, "stripeFee"))
                    $root.waiternow.common.MoneyProto.encode(message.stripeFee, writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
                if (message.applicationFee != null && Object.hasOwnProperty.call(message, "applicationFee"))
                    $root.waiternow.common.MoneyProto.encode(message.applicationFee, writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
                if (message.netPaidToBusiness != null && Object.hasOwnProperty.call(message, "netPaidToBusiness"))
                    $root.waiternow.common.MoneyProto.encode(message.netPaidToBusiness, writer.uint32(/* id 17, wireType 2 =*/138).fork()).ldelim();
                if (message.isTaxIncludedInPrice != null && Object.hasOwnProperty.call(message, "isTaxIncludedInPrice"))
                    writer.uint32(/* id 18, wireType 0 =*/144).bool(message.isTaxIncludedInPrice);
                if (message.creditCardFeeAdjustmentForThirdPartyDelivery != null && Object.hasOwnProperty.call(message, "creditCardFeeAdjustmentForThirdPartyDelivery"))
                    $root.waiternow.common.MoneyProto.encode(message.creditCardFeeAdjustmentForThirdPartyDelivery, writer.uint32(/* id 19, wireType 2 =*/154).fork()).ldelim();
                if (message.stripeFeeIncludesTaxesAppliedToOriginalStripeFee != null && Object.hasOwnProperty.call(message, "stripeFeeIncludesTaxesAppliedToOriginalStripeFee"))
                    writer.uint32(/* id 20, wireType 0 =*/160).bool(message.stripeFeeIncludesTaxesAppliedToOriginalStripeFee);
                return writer;
            };

            /**
             * Encodes the specified OrderTotalCalculationProto message, length delimited. Does not implicitly {@link waiternow.common.OrderTotalCalculationProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.OrderTotalCalculationProto
             * @static
             * @param {waiternow.common.IOrderTotalCalculationProto} message OrderTotalCalculationProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OrderTotalCalculationProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an OrderTotalCalculationProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.OrderTotalCalculationProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.OrderTotalCalculationProto} OrderTotalCalculationProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OrderTotalCalculationProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.OrderTotalCalculationProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.subtotal = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 2: {
                            if (!(message.discounts && message.discounts.length))
                                message.discounts = [];
                            message.discounts.push($root.waiternow.common.DiscountProto.decode(reader, reader.uint32()));
                            break;
                        }
                    case 3: {
                            message.appliedTaxes = $root.waiternow.common.TaxesProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 4: {
                            message.tax = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 5: {
                            message.tip = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 6: {
                            message.deliveryFee = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 7: {
                            message.isDeliveryFeePaidToBusiness = reader.bool();
                            break;
                        }
                    case 8: {
                            message.isDeliveryFeeChargedToWaiterNow = reader.bool();
                            break;
                        }
                    case 9: {
                            message.deliveryTip = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 10: {
                            message.creditCardFeeAdjustment = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 11: {
                            message.isCreditCardFeeChargedToConsumer = reader.bool();
                            break;
                        }
                    case 19: {
                            message.creditCardFeeAdjustmentForThirdPartyDelivery = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 12: {
                            message.waiterNowFee = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 13: {
                            message.serviceFee = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 14: {
                            message.total = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 15: {
                            message.stripeFee = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 16: {
                            message.applicationFee = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 17: {
                            message.netPaidToBusiness = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 18: {
                            message.isTaxIncludedInPrice = reader.bool();
                            break;
                        }
                    case 20: {
                            message.stripeFeeIncludesTaxesAppliedToOriginalStripeFee = reader.bool();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an OrderTotalCalculationProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.OrderTotalCalculationProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.OrderTotalCalculationProto} OrderTotalCalculationProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OrderTotalCalculationProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an OrderTotalCalculationProto message.
             * @function verify
             * @memberof waiternow.common.OrderTotalCalculationProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            OrderTotalCalculationProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.subtotal != null && message.hasOwnProperty("subtotal")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.subtotal);
                    if (error)
                        return "subtotal." + error;
                }
                if (message.discounts != null && message.hasOwnProperty("discounts")) {
                    if (!Array.isArray(message.discounts))
                        return "discounts: array expected";
                    for (var i = 0; i < message.discounts.length; ++i) {
                        var error = $root.waiternow.common.DiscountProto.verify(message.discounts[i]);
                        if (error)
                            return "discounts." + error;
                    }
                }
                if (message.appliedTaxes != null && message.hasOwnProperty("appliedTaxes")) {
                    var error = $root.waiternow.common.TaxesProto.verify(message.appliedTaxes);
                    if (error)
                        return "appliedTaxes." + error;
                }
                if (message.tax != null && message.hasOwnProperty("tax")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.tax);
                    if (error)
                        return "tax." + error;
                }
                if (message.tip != null && message.hasOwnProperty("tip")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.tip);
                    if (error)
                        return "tip." + error;
                }
                if (message.deliveryFee != null && message.hasOwnProperty("deliveryFee")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.deliveryFee);
                    if (error)
                        return "deliveryFee." + error;
                }
                if (message.isDeliveryFeePaidToBusiness != null && message.hasOwnProperty("isDeliveryFeePaidToBusiness"))
                    if (typeof message.isDeliveryFeePaidToBusiness !== "boolean")
                        return "isDeliveryFeePaidToBusiness: boolean expected";
                if (message.isDeliveryFeeChargedToWaiterNow != null && message.hasOwnProperty("isDeliveryFeeChargedToWaiterNow"))
                    if (typeof message.isDeliveryFeeChargedToWaiterNow !== "boolean")
                        return "isDeliveryFeeChargedToWaiterNow: boolean expected";
                if (message.deliveryTip != null && message.hasOwnProperty("deliveryTip")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.deliveryTip);
                    if (error)
                        return "deliveryTip." + error;
                }
                if (message.creditCardFeeAdjustment != null && message.hasOwnProperty("creditCardFeeAdjustment")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.creditCardFeeAdjustment);
                    if (error)
                        return "creditCardFeeAdjustment." + error;
                }
                if (message.isCreditCardFeeChargedToConsumer != null && message.hasOwnProperty("isCreditCardFeeChargedToConsumer"))
                    if (typeof message.isCreditCardFeeChargedToConsumer !== "boolean")
                        return "isCreditCardFeeChargedToConsumer: boolean expected";
                if (message.creditCardFeeAdjustmentForThirdPartyDelivery != null && message.hasOwnProperty("creditCardFeeAdjustmentForThirdPartyDelivery")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.creditCardFeeAdjustmentForThirdPartyDelivery);
                    if (error)
                        return "creditCardFeeAdjustmentForThirdPartyDelivery." + error;
                }
                if (message.waiterNowFee != null && message.hasOwnProperty("waiterNowFee")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.waiterNowFee);
                    if (error)
                        return "waiterNowFee." + error;
                }
                if (message.serviceFee != null && message.hasOwnProperty("serviceFee")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.serviceFee);
                    if (error)
                        return "serviceFee." + error;
                }
                if (message.total != null && message.hasOwnProperty("total")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.total);
                    if (error)
                        return "total." + error;
                }
                if (message.stripeFee != null && message.hasOwnProperty("stripeFee")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.stripeFee);
                    if (error)
                        return "stripeFee." + error;
                }
                if (message.applicationFee != null && message.hasOwnProperty("applicationFee")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.applicationFee);
                    if (error)
                        return "applicationFee." + error;
                }
                if (message.netPaidToBusiness != null && message.hasOwnProperty("netPaidToBusiness")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.netPaidToBusiness);
                    if (error)
                        return "netPaidToBusiness." + error;
                }
                if (message.isTaxIncludedInPrice != null && message.hasOwnProperty("isTaxIncludedInPrice"))
                    if (typeof message.isTaxIncludedInPrice !== "boolean")
                        return "isTaxIncludedInPrice: boolean expected";
                if (message.stripeFeeIncludesTaxesAppliedToOriginalStripeFee != null && message.hasOwnProperty("stripeFeeIncludesTaxesAppliedToOriginalStripeFee"))
                    if (typeof message.stripeFeeIncludesTaxesAppliedToOriginalStripeFee !== "boolean")
                        return "stripeFeeIncludesTaxesAppliedToOriginalStripeFee: boolean expected";
                return null;
            };

            /**
             * Creates an OrderTotalCalculationProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.OrderTotalCalculationProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.OrderTotalCalculationProto} OrderTotalCalculationProto
             */
            OrderTotalCalculationProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.OrderTotalCalculationProto)
                    return object;
                var message = new $root.waiternow.common.OrderTotalCalculationProto();
                if (object.subtotal != null) {
                    if (typeof object.subtotal !== "object")
                        throw TypeError(".waiternow.common.OrderTotalCalculationProto.subtotal: object expected");
                    message.subtotal = $root.waiternow.common.MoneyProto.fromObject(object.subtotal);
                }
                if (object.discounts) {
                    if (!Array.isArray(object.discounts))
                        throw TypeError(".waiternow.common.OrderTotalCalculationProto.discounts: array expected");
                    message.discounts = [];
                    for (var i = 0; i < object.discounts.length; ++i) {
                        if (typeof object.discounts[i] !== "object")
                            throw TypeError(".waiternow.common.OrderTotalCalculationProto.discounts: object expected");
                        message.discounts[i] = $root.waiternow.common.DiscountProto.fromObject(object.discounts[i]);
                    }
                }
                if (object.appliedTaxes != null) {
                    if (typeof object.appliedTaxes !== "object")
                        throw TypeError(".waiternow.common.OrderTotalCalculationProto.appliedTaxes: object expected");
                    message.appliedTaxes = $root.waiternow.common.TaxesProto.fromObject(object.appliedTaxes);
                }
                if (object.tax != null) {
                    if (typeof object.tax !== "object")
                        throw TypeError(".waiternow.common.OrderTotalCalculationProto.tax: object expected");
                    message.tax = $root.waiternow.common.MoneyProto.fromObject(object.tax);
                }
                if (object.tip != null) {
                    if (typeof object.tip !== "object")
                        throw TypeError(".waiternow.common.OrderTotalCalculationProto.tip: object expected");
                    message.tip = $root.waiternow.common.MoneyProto.fromObject(object.tip);
                }
                if (object.deliveryFee != null) {
                    if (typeof object.deliveryFee !== "object")
                        throw TypeError(".waiternow.common.OrderTotalCalculationProto.deliveryFee: object expected");
                    message.deliveryFee = $root.waiternow.common.MoneyProto.fromObject(object.deliveryFee);
                }
                if (object.isDeliveryFeePaidToBusiness != null)
                    message.isDeliveryFeePaidToBusiness = Boolean(object.isDeliveryFeePaidToBusiness);
                if (object.isDeliveryFeeChargedToWaiterNow != null)
                    message.isDeliveryFeeChargedToWaiterNow = Boolean(object.isDeliveryFeeChargedToWaiterNow);
                if (object.deliveryTip != null) {
                    if (typeof object.deliveryTip !== "object")
                        throw TypeError(".waiternow.common.OrderTotalCalculationProto.deliveryTip: object expected");
                    message.deliveryTip = $root.waiternow.common.MoneyProto.fromObject(object.deliveryTip);
                }
                if (object.creditCardFeeAdjustment != null) {
                    if (typeof object.creditCardFeeAdjustment !== "object")
                        throw TypeError(".waiternow.common.OrderTotalCalculationProto.creditCardFeeAdjustment: object expected");
                    message.creditCardFeeAdjustment = $root.waiternow.common.MoneyProto.fromObject(object.creditCardFeeAdjustment);
                }
                if (object.isCreditCardFeeChargedToConsumer != null)
                    message.isCreditCardFeeChargedToConsumer = Boolean(object.isCreditCardFeeChargedToConsumer);
                if (object.creditCardFeeAdjustmentForThirdPartyDelivery != null) {
                    if (typeof object.creditCardFeeAdjustmentForThirdPartyDelivery !== "object")
                        throw TypeError(".waiternow.common.OrderTotalCalculationProto.creditCardFeeAdjustmentForThirdPartyDelivery: object expected");
                    message.creditCardFeeAdjustmentForThirdPartyDelivery = $root.waiternow.common.MoneyProto.fromObject(object.creditCardFeeAdjustmentForThirdPartyDelivery);
                }
                if (object.waiterNowFee != null) {
                    if (typeof object.waiterNowFee !== "object")
                        throw TypeError(".waiternow.common.OrderTotalCalculationProto.waiterNowFee: object expected");
                    message.waiterNowFee = $root.waiternow.common.MoneyProto.fromObject(object.waiterNowFee);
                }
                if (object.serviceFee != null) {
                    if (typeof object.serviceFee !== "object")
                        throw TypeError(".waiternow.common.OrderTotalCalculationProto.serviceFee: object expected");
                    message.serviceFee = $root.waiternow.common.MoneyProto.fromObject(object.serviceFee);
                }
                if (object.total != null) {
                    if (typeof object.total !== "object")
                        throw TypeError(".waiternow.common.OrderTotalCalculationProto.total: object expected");
                    message.total = $root.waiternow.common.MoneyProto.fromObject(object.total);
                }
                if (object.stripeFee != null) {
                    if (typeof object.stripeFee !== "object")
                        throw TypeError(".waiternow.common.OrderTotalCalculationProto.stripeFee: object expected");
                    message.stripeFee = $root.waiternow.common.MoneyProto.fromObject(object.stripeFee);
                }
                if (object.applicationFee != null) {
                    if (typeof object.applicationFee !== "object")
                        throw TypeError(".waiternow.common.OrderTotalCalculationProto.applicationFee: object expected");
                    message.applicationFee = $root.waiternow.common.MoneyProto.fromObject(object.applicationFee);
                }
                if (object.netPaidToBusiness != null) {
                    if (typeof object.netPaidToBusiness !== "object")
                        throw TypeError(".waiternow.common.OrderTotalCalculationProto.netPaidToBusiness: object expected");
                    message.netPaidToBusiness = $root.waiternow.common.MoneyProto.fromObject(object.netPaidToBusiness);
                }
                if (object.isTaxIncludedInPrice != null)
                    message.isTaxIncludedInPrice = Boolean(object.isTaxIncludedInPrice);
                if (object.stripeFeeIncludesTaxesAppliedToOriginalStripeFee != null)
                    message.stripeFeeIncludesTaxesAppliedToOriginalStripeFee = Boolean(object.stripeFeeIncludesTaxesAppliedToOriginalStripeFee);
                return message;
            };

            /**
             * Creates a plain object from an OrderTotalCalculationProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.OrderTotalCalculationProto
             * @static
             * @param {waiternow.common.OrderTotalCalculationProto} message OrderTotalCalculationProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            OrderTotalCalculationProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.discounts = [];
                if (options.defaults) {
                    object.subtotal = null;
                    object.appliedTaxes = null;
                    object.tax = null;
                    object.tip = null;
                    object.deliveryFee = null;
                    object.isDeliveryFeePaidToBusiness = false;
                    object.isDeliveryFeeChargedToWaiterNow = false;
                    object.deliveryTip = null;
                    object.creditCardFeeAdjustment = null;
                    object.isCreditCardFeeChargedToConsumer = false;
                    object.waiterNowFee = null;
                    object.serviceFee = null;
                    object.total = null;
                    object.stripeFee = null;
                    object.applicationFee = null;
                    object.netPaidToBusiness = null;
                    object.isTaxIncludedInPrice = false;
                    object.creditCardFeeAdjustmentForThirdPartyDelivery = null;
                    object.stripeFeeIncludesTaxesAppliedToOriginalStripeFee = false;
                }
                if (message.subtotal != null && message.hasOwnProperty("subtotal"))
                    object.subtotal = $root.waiternow.common.MoneyProto.toObject(message.subtotal, options);
                if (message.discounts && message.discounts.length) {
                    object.discounts = [];
                    for (var j = 0; j < message.discounts.length; ++j)
                        object.discounts[j] = $root.waiternow.common.DiscountProto.toObject(message.discounts[j], options);
                }
                if (message.appliedTaxes != null && message.hasOwnProperty("appliedTaxes"))
                    object.appliedTaxes = $root.waiternow.common.TaxesProto.toObject(message.appliedTaxes, options);
                if (message.tax != null && message.hasOwnProperty("tax"))
                    object.tax = $root.waiternow.common.MoneyProto.toObject(message.tax, options);
                if (message.tip != null && message.hasOwnProperty("tip"))
                    object.tip = $root.waiternow.common.MoneyProto.toObject(message.tip, options);
                if (message.deliveryFee != null && message.hasOwnProperty("deliveryFee"))
                    object.deliveryFee = $root.waiternow.common.MoneyProto.toObject(message.deliveryFee, options);
                if (message.isDeliveryFeePaidToBusiness != null && message.hasOwnProperty("isDeliveryFeePaidToBusiness"))
                    object.isDeliveryFeePaidToBusiness = message.isDeliveryFeePaidToBusiness;
                if (message.isDeliveryFeeChargedToWaiterNow != null && message.hasOwnProperty("isDeliveryFeeChargedToWaiterNow"))
                    object.isDeliveryFeeChargedToWaiterNow = message.isDeliveryFeeChargedToWaiterNow;
                if (message.deliveryTip != null && message.hasOwnProperty("deliveryTip"))
                    object.deliveryTip = $root.waiternow.common.MoneyProto.toObject(message.deliveryTip, options);
                if (message.creditCardFeeAdjustment != null && message.hasOwnProperty("creditCardFeeAdjustment"))
                    object.creditCardFeeAdjustment = $root.waiternow.common.MoneyProto.toObject(message.creditCardFeeAdjustment, options);
                if (message.isCreditCardFeeChargedToConsumer != null && message.hasOwnProperty("isCreditCardFeeChargedToConsumer"))
                    object.isCreditCardFeeChargedToConsumer = message.isCreditCardFeeChargedToConsumer;
                if (message.waiterNowFee != null && message.hasOwnProperty("waiterNowFee"))
                    object.waiterNowFee = $root.waiternow.common.MoneyProto.toObject(message.waiterNowFee, options);
                if (message.serviceFee != null && message.hasOwnProperty("serviceFee"))
                    object.serviceFee = $root.waiternow.common.MoneyProto.toObject(message.serviceFee, options);
                if (message.total != null && message.hasOwnProperty("total"))
                    object.total = $root.waiternow.common.MoneyProto.toObject(message.total, options);
                if (message.stripeFee != null && message.hasOwnProperty("stripeFee"))
                    object.stripeFee = $root.waiternow.common.MoneyProto.toObject(message.stripeFee, options);
                if (message.applicationFee != null && message.hasOwnProperty("applicationFee"))
                    object.applicationFee = $root.waiternow.common.MoneyProto.toObject(message.applicationFee, options);
                if (message.netPaidToBusiness != null && message.hasOwnProperty("netPaidToBusiness"))
                    object.netPaidToBusiness = $root.waiternow.common.MoneyProto.toObject(message.netPaidToBusiness, options);
                if (message.isTaxIncludedInPrice != null && message.hasOwnProperty("isTaxIncludedInPrice"))
                    object.isTaxIncludedInPrice = message.isTaxIncludedInPrice;
                if (message.creditCardFeeAdjustmentForThirdPartyDelivery != null && message.hasOwnProperty("creditCardFeeAdjustmentForThirdPartyDelivery"))
                    object.creditCardFeeAdjustmentForThirdPartyDelivery = $root.waiternow.common.MoneyProto.toObject(message.creditCardFeeAdjustmentForThirdPartyDelivery, options);
                if (message.stripeFeeIncludesTaxesAppliedToOriginalStripeFee != null && message.hasOwnProperty("stripeFeeIncludesTaxesAppliedToOriginalStripeFee"))
                    object.stripeFeeIncludesTaxesAppliedToOriginalStripeFee = message.stripeFeeIncludesTaxesAppliedToOriginalStripeFee;
                return object;
            };

            /**
             * Converts this OrderTotalCalculationProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.OrderTotalCalculationProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            OrderTotalCalculationProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for OrderTotalCalculationProto
             * @function getTypeUrl
             * @memberof waiternow.common.OrderTotalCalculationProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            OrderTotalCalculationProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.OrderTotalCalculationProto";
            };

            return OrderTotalCalculationProto;
        })();

        common.MarketplacePaymentsLocationEnrollmentProto = (function() {

            /**
             * Properties of a MarketplacePaymentsLocationEnrollmentProto.
             * @memberof waiternow.common
             * @interface IMarketplacePaymentsLocationEnrollmentProto
             * @property {string|null} [redirectUrl] MarketplacePaymentsLocationEnrollmentProto redirectUrl
             */

            /**
             * Constructs a new MarketplacePaymentsLocationEnrollmentProto.
             * @memberof waiternow.common
             * @classdesc Represents a MarketplacePaymentsLocationEnrollmentProto.
             * @implements IMarketplacePaymentsLocationEnrollmentProto
             * @constructor
             * @param {waiternow.common.IMarketplacePaymentsLocationEnrollmentProto=} [properties] Properties to set
             */
            function MarketplacePaymentsLocationEnrollmentProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * MarketplacePaymentsLocationEnrollmentProto redirectUrl.
             * @member {string} redirectUrl
             * @memberof waiternow.common.MarketplacePaymentsLocationEnrollmentProto
             * @instance
             */
            MarketplacePaymentsLocationEnrollmentProto.prototype.redirectUrl = "";

            /**
             * Creates a new MarketplacePaymentsLocationEnrollmentProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.MarketplacePaymentsLocationEnrollmentProto
             * @static
             * @param {waiternow.common.IMarketplacePaymentsLocationEnrollmentProto=} [properties] Properties to set
             * @returns {waiternow.common.MarketplacePaymentsLocationEnrollmentProto} MarketplacePaymentsLocationEnrollmentProto instance
             */
            MarketplacePaymentsLocationEnrollmentProto.create = function create(properties) {
                return new MarketplacePaymentsLocationEnrollmentProto(properties);
            };

            /**
             * Encodes the specified MarketplacePaymentsLocationEnrollmentProto message. Does not implicitly {@link waiternow.common.MarketplacePaymentsLocationEnrollmentProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.MarketplacePaymentsLocationEnrollmentProto
             * @static
             * @param {waiternow.common.IMarketplacePaymentsLocationEnrollmentProto} message MarketplacePaymentsLocationEnrollmentProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MarketplacePaymentsLocationEnrollmentProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.redirectUrl != null && Object.hasOwnProperty.call(message, "redirectUrl"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.redirectUrl);
                return writer;
            };

            /**
             * Encodes the specified MarketplacePaymentsLocationEnrollmentProto message, length delimited. Does not implicitly {@link waiternow.common.MarketplacePaymentsLocationEnrollmentProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.MarketplacePaymentsLocationEnrollmentProto
             * @static
             * @param {waiternow.common.IMarketplacePaymentsLocationEnrollmentProto} message MarketplacePaymentsLocationEnrollmentProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MarketplacePaymentsLocationEnrollmentProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a MarketplacePaymentsLocationEnrollmentProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.MarketplacePaymentsLocationEnrollmentProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.MarketplacePaymentsLocationEnrollmentProto} MarketplacePaymentsLocationEnrollmentProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MarketplacePaymentsLocationEnrollmentProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.MarketplacePaymentsLocationEnrollmentProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.redirectUrl = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a MarketplacePaymentsLocationEnrollmentProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.MarketplacePaymentsLocationEnrollmentProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.MarketplacePaymentsLocationEnrollmentProto} MarketplacePaymentsLocationEnrollmentProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MarketplacePaymentsLocationEnrollmentProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a MarketplacePaymentsLocationEnrollmentProto message.
             * @function verify
             * @memberof waiternow.common.MarketplacePaymentsLocationEnrollmentProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            MarketplacePaymentsLocationEnrollmentProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.redirectUrl != null && message.hasOwnProperty("redirectUrl"))
                    if (!$util.isString(message.redirectUrl))
                        return "redirectUrl: string expected";
                return null;
            };

            /**
             * Creates a MarketplacePaymentsLocationEnrollmentProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.MarketplacePaymentsLocationEnrollmentProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.MarketplacePaymentsLocationEnrollmentProto} MarketplacePaymentsLocationEnrollmentProto
             */
            MarketplacePaymentsLocationEnrollmentProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.MarketplacePaymentsLocationEnrollmentProto)
                    return object;
                var message = new $root.waiternow.common.MarketplacePaymentsLocationEnrollmentProto();
                if (object.redirectUrl != null)
                    message.redirectUrl = String(object.redirectUrl);
                return message;
            };

            /**
             * Creates a plain object from a MarketplacePaymentsLocationEnrollmentProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.MarketplacePaymentsLocationEnrollmentProto
             * @static
             * @param {waiternow.common.MarketplacePaymentsLocationEnrollmentProto} message MarketplacePaymentsLocationEnrollmentProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            MarketplacePaymentsLocationEnrollmentProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.redirectUrl = "";
                if (message.redirectUrl != null && message.hasOwnProperty("redirectUrl"))
                    object.redirectUrl = message.redirectUrl;
                return object;
            };

            /**
             * Converts this MarketplacePaymentsLocationEnrollmentProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.MarketplacePaymentsLocationEnrollmentProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            MarketplacePaymentsLocationEnrollmentProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for MarketplacePaymentsLocationEnrollmentProto
             * @function getTypeUrl
             * @memberof waiternow.common.MarketplacePaymentsLocationEnrollmentProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            MarketplacePaymentsLocationEnrollmentProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.MarketplacePaymentsLocationEnrollmentProto";
            };

            return MarketplacePaymentsLocationEnrollmentProto;
        })();

        common.DiscountProto = (function() {

            /**
             * Properties of a DiscountProto.
             * @memberof waiternow.common
             * @interface IDiscountProto
             * @property {waiternow.common.IMoneyProto|null} [amount] DiscountProto amount
             * @property {string|null} [description] DiscountProto description
             */

            /**
             * Constructs a new DiscountProto.
             * @memberof waiternow.common
             * @classdesc Represents a DiscountProto.
             * @implements IDiscountProto
             * @constructor
             * @param {waiternow.common.IDiscountProto=} [properties] Properties to set
             */
            function DiscountProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * DiscountProto amount.
             * @member {waiternow.common.IMoneyProto|null|undefined} amount
             * @memberof waiternow.common.DiscountProto
             * @instance
             */
            DiscountProto.prototype.amount = null;

            /**
             * DiscountProto description.
             * @member {string} description
             * @memberof waiternow.common.DiscountProto
             * @instance
             */
            DiscountProto.prototype.description = "";

            /**
             * Creates a new DiscountProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.DiscountProto
             * @static
             * @param {waiternow.common.IDiscountProto=} [properties] Properties to set
             * @returns {waiternow.common.DiscountProto} DiscountProto instance
             */
            DiscountProto.create = function create(properties) {
                return new DiscountProto(properties);
            };

            /**
             * Encodes the specified DiscountProto message. Does not implicitly {@link waiternow.common.DiscountProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.DiscountProto
             * @static
             * @param {waiternow.common.IDiscountProto} message DiscountProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DiscountProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                    $root.waiternow.common.MoneyProto.encode(message.amount, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.description);
                return writer;
            };

            /**
             * Encodes the specified DiscountProto message, length delimited. Does not implicitly {@link waiternow.common.DiscountProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.DiscountProto
             * @static
             * @param {waiternow.common.IDiscountProto} message DiscountProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DiscountProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a DiscountProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.DiscountProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.DiscountProto} DiscountProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DiscountProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.DiscountProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.amount = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 2: {
                            message.description = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a DiscountProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.DiscountProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.DiscountProto} DiscountProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DiscountProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a DiscountProto message.
             * @function verify
             * @memberof waiternow.common.DiscountProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            DiscountProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.amount != null && message.hasOwnProperty("amount")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.amount);
                    if (error)
                        return "amount." + error;
                }
                if (message.description != null && message.hasOwnProperty("description"))
                    if (!$util.isString(message.description))
                        return "description: string expected";
                return null;
            };

            /**
             * Creates a DiscountProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.DiscountProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.DiscountProto} DiscountProto
             */
            DiscountProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.DiscountProto)
                    return object;
                var message = new $root.waiternow.common.DiscountProto();
                if (object.amount != null) {
                    if (typeof object.amount !== "object")
                        throw TypeError(".waiternow.common.DiscountProto.amount: object expected");
                    message.amount = $root.waiternow.common.MoneyProto.fromObject(object.amount);
                }
                if (object.description != null)
                    message.description = String(object.description);
                return message;
            };

            /**
             * Creates a plain object from a DiscountProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.DiscountProto
             * @static
             * @param {waiternow.common.DiscountProto} message DiscountProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            DiscountProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.amount = null;
                    object.description = "";
                }
                if (message.amount != null && message.hasOwnProperty("amount"))
                    object.amount = $root.waiternow.common.MoneyProto.toObject(message.amount, options);
                if (message.description != null && message.hasOwnProperty("description"))
                    object.description = message.description;
                return object;
            };

            /**
             * Converts this DiscountProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.DiscountProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            DiscountProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for DiscountProto
             * @function getTypeUrl
             * @memberof waiternow.common.DiscountProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            DiscountProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.DiscountProto";
            };

            return DiscountProto;
        })();

        common.RefundProto = (function() {

            /**
             * Properties of a RefundProto.
             * @memberof waiternow.common
             * @interface IRefundProto
             * @property {string|null} [id] RefundProto id
             * @property {google.protobuf.ITimestamp|null} [creationTime] RefundProto creationTime
             * @property {google.protobuf.ITimestamp|null} [lastUpdateTime] RefundProto lastUpdateTime
             * @property {string|null} [orderId] RefundProto orderId
             * @property {string|null} [refundId] RefundProto refundId
             * @property {google.protobuf.ITimestamp|null} [refundTime] RefundProto refundTime
             * @property {waiternow.common.IMoneyProto|null} [amount] RefundProto amount
             * @property {waiternow.common.RefundProto.IRedundantDataProto|null} [redundantData] RefundProto redundantData
             */

            /**
             * Constructs a new RefundProto.
             * @memberof waiternow.common
             * @classdesc Represents a RefundProto.
             * @implements IRefundProto
             * @constructor
             * @param {waiternow.common.IRefundProto=} [properties] Properties to set
             */
            function RefundProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * RefundProto id.
             * @member {string} id
             * @memberof waiternow.common.RefundProto
             * @instance
             */
            RefundProto.prototype.id = "";

            /**
             * RefundProto creationTime.
             * @member {google.protobuf.ITimestamp|null|undefined} creationTime
             * @memberof waiternow.common.RefundProto
             * @instance
             */
            RefundProto.prototype.creationTime = null;

            /**
             * RefundProto lastUpdateTime.
             * @member {google.protobuf.ITimestamp|null|undefined} lastUpdateTime
             * @memberof waiternow.common.RefundProto
             * @instance
             */
            RefundProto.prototype.lastUpdateTime = null;

            /**
             * RefundProto orderId.
             * @member {string} orderId
             * @memberof waiternow.common.RefundProto
             * @instance
             */
            RefundProto.prototype.orderId = "";

            /**
             * RefundProto refundId.
             * @member {string} refundId
             * @memberof waiternow.common.RefundProto
             * @instance
             */
            RefundProto.prototype.refundId = "";

            /**
             * RefundProto refundTime.
             * @member {google.protobuf.ITimestamp|null|undefined} refundTime
             * @memberof waiternow.common.RefundProto
             * @instance
             */
            RefundProto.prototype.refundTime = null;

            /**
             * RefundProto amount.
             * @member {waiternow.common.IMoneyProto|null|undefined} amount
             * @memberof waiternow.common.RefundProto
             * @instance
             */
            RefundProto.prototype.amount = null;

            /**
             * RefundProto redundantData.
             * @member {waiternow.common.RefundProto.IRedundantDataProto|null|undefined} redundantData
             * @memberof waiternow.common.RefundProto
             * @instance
             */
            RefundProto.prototype.redundantData = null;

            /**
             * Creates a new RefundProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.RefundProto
             * @static
             * @param {waiternow.common.IRefundProto=} [properties] Properties to set
             * @returns {waiternow.common.RefundProto} RefundProto instance
             */
            RefundProto.create = function create(properties) {
                return new RefundProto(properties);
            };

            /**
             * Encodes the specified RefundProto message. Does not implicitly {@link waiternow.common.RefundProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.RefundProto
             * @static
             * @param {waiternow.common.IRefundProto} message RefundProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RefundProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                if (message.creationTime != null && Object.hasOwnProperty.call(message, "creationTime"))
                    $root.google.protobuf.Timestamp.encode(message.creationTime, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                    $root.google.protobuf.Timestamp.encode(message.lastUpdateTime, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.orderId != null && Object.hasOwnProperty.call(message, "orderId"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.orderId);
                if (message.refundId != null && Object.hasOwnProperty.call(message, "refundId"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.refundId);
                if (message.refundTime != null && Object.hasOwnProperty.call(message, "refundTime"))
                    $root.google.protobuf.Timestamp.encode(message.refundTime, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                    $root.waiternow.common.MoneyProto.encode(message.amount, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                if (message.redundantData != null && Object.hasOwnProperty.call(message, "redundantData"))
                    $root.waiternow.common.RefundProto.RedundantDataProto.encode(message.redundantData, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified RefundProto message, length delimited. Does not implicitly {@link waiternow.common.RefundProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.RefundProto
             * @static
             * @param {waiternow.common.IRefundProto} message RefundProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RefundProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a RefundProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.RefundProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.RefundProto} RefundProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RefundProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.RefundProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.id = reader.string();
                            break;
                        }
                    case 2: {
                            message.creationTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 3: {
                            message.lastUpdateTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 4: {
                            message.orderId = reader.string();
                            break;
                        }
                    case 5: {
                            message.refundId = reader.string();
                            break;
                        }
                    case 6: {
                            message.refundTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 7: {
                            message.amount = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 8: {
                            message.redundantData = $root.waiternow.common.RefundProto.RedundantDataProto.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a RefundProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.RefundProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.RefundProto} RefundProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RefundProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a RefundProto message.
             * @function verify
             * @memberof waiternow.common.RefundProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            RefundProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.id != null && message.hasOwnProperty("id"))
                    if (!$util.isString(message.id))
                        return "id: string expected";
                if (message.creationTime != null && message.hasOwnProperty("creationTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.creationTime);
                    if (error)
                        return "creationTime." + error;
                }
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.lastUpdateTime);
                    if (error)
                        return "lastUpdateTime." + error;
                }
                if (message.orderId != null && message.hasOwnProperty("orderId"))
                    if (!$util.isString(message.orderId))
                        return "orderId: string expected";
                if (message.refundId != null && message.hasOwnProperty("refundId"))
                    if (!$util.isString(message.refundId))
                        return "refundId: string expected";
                if (message.refundTime != null && message.hasOwnProperty("refundTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.refundTime);
                    if (error)
                        return "refundTime." + error;
                }
                if (message.amount != null && message.hasOwnProperty("amount")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.amount);
                    if (error)
                        return "amount." + error;
                }
                if (message.redundantData != null && message.hasOwnProperty("redundantData")) {
                    var error = $root.waiternow.common.RefundProto.RedundantDataProto.verify(message.redundantData);
                    if (error)
                        return "redundantData." + error;
                }
                return null;
            };

            /**
             * Creates a RefundProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.RefundProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.RefundProto} RefundProto
             */
            RefundProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.RefundProto)
                    return object;
                var message = new $root.waiternow.common.RefundProto();
                if (object.id != null)
                    message.id = String(object.id);
                if (object.creationTime != null) {
                    if (typeof object.creationTime !== "object")
                        throw TypeError(".waiternow.common.RefundProto.creationTime: object expected");
                    message.creationTime = $root.google.protobuf.Timestamp.fromObject(object.creationTime);
                }
                if (object.lastUpdateTime != null) {
                    if (typeof object.lastUpdateTime !== "object")
                        throw TypeError(".waiternow.common.RefundProto.lastUpdateTime: object expected");
                    message.lastUpdateTime = $root.google.protobuf.Timestamp.fromObject(object.lastUpdateTime);
                }
                if (object.orderId != null)
                    message.orderId = String(object.orderId);
                if (object.refundId != null)
                    message.refundId = String(object.refundId);
                if (object.refundTime != null) {
                    if (typeof object.refundTime !== "object")
                        throw TypeError(".waiternow.common.RefundProto.refundTime: object expected");
                    message.refundTime = $root.google.protobuf.Timestamp.fromObject(object.refundTime);
                }
                if (object.amount != null) {
                    if (typeof object.amount !== "object")
                        throw TypeError(".waiternow.common.RefundProto.amount: object expected");
                    message.amount = $root.waiternow.common.MoneyProto.fromObject(object.amount);
                }
                if (object.redundantData != null) {
                    if (typeof object.redundantData !== "object")
                        throw TypeError(".waiternow.common.RefundProto.redundantData: object expected");
                    message.redundantData = $root.waiternow.common.RefundProto.RedundantDataProto.fromObject(object.redundantData);
                }
                return message;
            };

            /**
             * Creates a plain object from a RefundProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.RefundProto
             * @static
             * @param {waiternow.common.RefundProto} message RefundProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            RefundProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.id = "";
                    object.creationTime = null;
                    object.lastUpdateTime = null;
                    object.orderId = "";
                    object.refundId = "";
                    object.refundTime = null;
                    object.amount = null;
                    object.redundantData = null;
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                    object.creationTime = $root.google.protobuf.Timestamp.toObject(message.creationTime, options);
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                    object.lastUpdateTime = $root.google.protobuf.Timestamp.toObject(message.lastUpdateTime, options);
                if (message.orderId != null && message.hasOwnProperty("orderId"))
                    object.orderId = message.orderId;
                if (message.refundId != null && message.hasOwnProperty("refundId"))
                    object.refundId = message.refundId;
                if (message.refundTime != null && message.hasOwnProperty("refundTime"))
                    object.refundTime = $root.google.protobuf.Timestamp.toObject(message.refundTime, options);
                if (message.amount != null && message.hasOwnProperty("amount"))
                    object.amount = $root.waiternow.common.MoneyProto.toObject(message.amount, options);
                if (message.redundantData != null && message.hasOwnProperty("redundantData"))
                    object.redundantData = $root.waiternow.common.RefundProto.RedundantDataProto.toObject(message.redundantData, options);
                return object;
            };

            /**
             * Converts this RefundProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.RefundProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            RefundProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for RefundProto
             * @function getTypeUrl
             * @memberof waiternow.common.RefundProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            RefundProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.RefundProto";
            };

            RefundProto.RedundantDataProto = (function() {

                /**
                 * Properties of a RedundantDataProto.
                 * @memberof waiternow.common.RefundProto
                 * @interface IRedundantDataProto
                 * @property {string|null} [locationId] RedundantDataProto locationId
                 * @property {waiternow.common.Country|null} [locationCountry] RedundantDataProto locationCountry
                 * @property {boolean|null} [isOrderFullyRefunded] RedundantDataProto isOrderFullyRefunded
                 * @property {waiternow.common.IMoneyProto|null} [applicationFee] RedundantDataProto applicationFee
                 */

                /**
                 * Constructs a new RedundantDataProto.
                 * @memberof waiternow.common.RefundProto
                 * @classdesc Represents a RedundantDataProto.
                 * @implements IRedundantDataProto
                 * @constructor
                 * @param {waiternow.common.RefundProto.IRedundantDataProto=} [properties] Properties to set
                 */
                function RedundantDataProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * RedundantDataProto locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.RefundProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.locationId = "";

                /**
                 * RedundantDataProto locationCountry.
                 * @member {waiternow.common.Country} locationCountry
                 * @memberof waiternow.common.RefundProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.locationCountry = 0;

                /**
                 * RedundantDataProto isOrderFullyRefunded.
                 * @member {boolean} isOrderFullyRefunded
                 * @memberof waiternow.common.RefundProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.isOrderFullyRefunded = false;

                /**
                 * RedundantDataProto applicationFee.
                 * @member {waiternow.common.IMoneyProto|null|undefined} applicationFee
                 * @memberof waiternow.common.RefundProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.applicationFee = null;

                /**
                 * Creates a new RedundantDataProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.RefundProto.RedundantDataProto
                 * @static
                 * @param {waiternow.common.RefundProto.IRedundantDataProto=} [properties] Properties to set
                 * @returns {waiternow.common.RefundProto.RedundantDataProto} RedundantDataProto instance
                 */
                RedundantDataProto.create = function create(properties) {
                    return new RedundantDataProto(properties);
                };

                /**
                 * Encodes the specified RedundantDataProto message. Does not implicitly {@link waiternow.common.RefundProto.RedundantDataProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.RefundProto.RedundantDataProto
                 * @static
                 * @param {waiternow.common.RefundProto.IRedundantDataProto} message RedundantDataProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RedundantDataProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    if (message.locationCountry != null && Object.hasOwnProperty.call(message, "locationCountry"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.locationCountry);
                    if (message.isOrderFullyRefunded != null && Object.hasOwnProperty.call(message, "isOrderFullyRefunded"))
                        writer.uint32(/* id 3, wireType 0 =*/24).bool(message.isOrderFullyRefunded);
                    if (message.applicationFee != null && Object.hasOwnProperty.call(message, "applicationFee"))
                        $root.waiternow.common.MoneyProto.encode(message.applicationFee, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified RedundantDataProto message, length delimited. Does not implicitly {@link waiternow.common.RefundProto.RedundantDataProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.RefundProto.RedundantDataProto
                 * @static
                 * @param {waiternow.common.RefundProto.IRedundantDataProto} message RedundantDataProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RedundantDataProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a RedundantDataProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.RefundProto.RedundantDataProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.RefundProto.RedundantDataProto} RedundantDataProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RedundantDataProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.RefundProto.RedundantDataProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 2: {
                                message.locationCountry = reader.int32();
                                break;
                            }
                        case 3: {
                                message.isOrderFullyRefunded = reader.bool();
                                break;
                            }
                        case 4: {
                                message.applicationFee = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a RedundantDataProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.RefundProto.RedundantDataProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.RefundProto.RedundantDataProto} RedundantDataProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RedundantDataProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a RedundantDataProto message.
                 * @function verify
                 * @memberof waiternow.common.RefundProto.RedundantDataProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                RedundantDataProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    if (message.locationCountry != null && message.hasOwnProperty("locationCountry"))
                        switch (message.locationCountry) {
                        default:
                            return "locationCountry: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.isOrderFullyRefunded != null && message.hasOwnProperty("isOrderFullyRefunded"))
                        if (typeof message.isOrderFullyRefunded !== "boolean")
                            return "isOrderFullyRefunded: boolean expected";
                    if (message.applicationFee != null && message.hasOwnProperty("applicationFee")) {
                        var error = $root.waiternow.common.MoneyProto.verify(message.applicationFee);
                        if (error)
                            return "applicationFee." + error;
                    }
                    return null;
                };

                /**
                 * Creates a RedundantDataProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.RefundProto.RedundantDataProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.RefundProto.RedundantDataProto} RedundantDataProto
                 */
                RedundantDataProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.RefundProto.RedundantDataProto)
                        return object;
                    var message = new $root.waiternow.common.RefundProto.RedundantDataProto();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    switch (object.locationCountry) {
                    default:
                        if (typeof object.locationCountry === "number") {
                            message.locationCountry = object.locationCountry;
                            break;
                        }
                        break;
                    case "COUNTRY_UNSPECIFIED":
                    case 0:
                        message.locationCountry = 0;
                        break;
                    case "UNITED_STATES":
                    case 1:
                        message.locationCountry = 1;
                        break;
                    case "MEXICO":
                    case 2:
                        message.locationCountry = 2;
                        break;
                    }
                    if (object.isOrderFullyRefunded != null)
                        message.isOrderFullyRefunded = Boolean(object.isOrderFullyRefunded);
                    if (object.applicationFee != null) {
                        if (typeof object.applicationFee !== "object")
                            throw TypeError(".waiternow.common.RefundProto.RedundantDataProto.applicationFee: object expected");
                        message.applicationFee = $root.waiternow.common.MoneyProto.fromObject(object.applicationFee);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a RedundantDataProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.RefundProto.RedundantDataProto
                 * @static
                 * @param {waiternow.common.RefundProto.RedundantDataProto} message RedundantDataProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                RedundantDataProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.locationId = "";
                        object.locationCountry = options.enums === String ? "COUNTRY_UNSPECIFIED" : 0;
                        object.isOrderFullyRefunded = false;
                        object.applicationFee = null;
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    if (message.locationCountry != null && message.hasOwnProperty("locationCountry"))
                        object.locationCountry = options.enums === String ? $root.waiternow.common.Country[message.locationCountry] === undefined ? message.locationCountry : $root.waiternow.common.Country[message.locationCountry] : message.locationCountry;
                    if (message.isOrderFullyRefunded != null && message.hasOwnProperty("isOrderFullyRefunded"))
                        object.isOrderFullyRefunded = message.isOrderFullyRefunded;
                    if (message.applicationFee != null && message.hasOwnProperty("applicationFee"))
                        object.applicationFee = $root.waiternow.common.MoneyProto.toObject(message.applicationFee, options);
                    return object;
                };

                /**
                 * Converts this RedundantDataProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.RefundProto.RedundantDataProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                RedundantDataProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for RedundantDataProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.RefundProto.RedundantDataProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                RedundantDataProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.RefundProto.RedundantDataProto";
                };

                return RedundantDataProto;
            })();

            return RefundProto;
        })();

        common.RefundsProto = (function() {

            /**
             * Properties of a RefundsProto.
             * @memberof waiternow.common
             * @interface IRefundsProto
             * @property {Array.<waiternow.common.IRefundProto>|null} [refunds] RefundsProto refunds
             * @property {string|null} [continuationToken] RefundsProto continuationToken
             */

            /**
             * Constructs a new RefundsProto.
             * @memberof waiternow.common
             * @classdesc Represents a RefundsProto.
             * @implements IRefundsProto
             * @constructor
             * @param {waiternow.common.IRefundsProto=} [properties] Properties to set
             */
            function RefundsProto(properties) {
                this.refunds = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * RefundsProto refunds.
             * @member {Array.<waiternow.common.IRefundProto>} refunds
             * @memberof waiternow.common.RefundsProto
             * @instance
             */
            RefundsProto.prototype.refunds = $util.emptyArray;

            /**
             * RefundsProto continuationToken.
             * @member {string} continuationToken
             * @memberof waiternow.common.RefundsProto
             * @instance
             */
            RefundsProto.prototype.continuationToken = "";

            /**
             * Creates a new RefundsProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.RefundsProto
             * @static
             * @param {waiternow.common.IRefundsProto=} [properties] Properties to set
             * @returns {waiternow.common.RefundsProto} RefundsProto instance
             */
            RefundsProto.create = function create(properties) {
                return new RefundsProto(properties);
            };

            /**
             * Encodes the specified RefundsProto message. Does not implicitly {@link waiternow.common.RefundsProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.RefundsProto
             * @static
             * @param {waiternow.common.IRefundsProto} message RefundsProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RefundsProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.refunds != null && message.refunds.length)
                    for (var i = 0; i < message.refunds.length; ++i)
                        $root.waiternow.common.RefundProto.encode(message.refunds[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.continuationToken);
                return writer;
            };

            /**
             * Encodes the specified RefundsProto message, length delimited. Does not implicitly {@link waiternow.common.RefundsProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.RefundsProto
             * @static
             * @param {waiternow.common.IRefundsProto} message RefundsProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RefundsProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a RefundsProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.RefundsProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.RefundsProto} RefundsProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RefundsProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.RefundsProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            if (!(message.refunds && message.refunds.length))
                                message.refunds = [];
                            message.refunds.push($root.waiternow.common.RefundProto.decode(reader, reader.uint32()));
                            break;
                        }
                    case 2: {
                            message.continuationToken = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a RefundsProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.RefundsProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.RefundsProto} RefundsProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RefundsProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a RefundsProto message.
             * @function verify
             * @memberof waiternow.common.RefundsProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            RefundsProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.refunds != null && message.hasOwnProperty("refunds")) {
                    if (!Array.isArray(message.refunds))
                        return "refunds: array expected";
                    for (var i = 0; i < message.refunds.length; ++i) {
                        var error = $root.waiternow.common.RefundProto.verify(message.refunds[i]);
                        if (error)
                            return "refunds." + error;
                    }
                }
                if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                    if (!$util.isString(message.continuationToken))
                        return "continuationToken: string expected";
                return null;
            };

            /**
             * Creates a RefundsProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.RefundsProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.RefundsProto} RefundsProto
             */
            RefundsProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.RefundsProto)
                    return object;
                var message = new $root.waiternow.common.RefundsProto();
                if (object.refunds) {
                    if (!Array.isArray(object.refunds))
                        throw TypeError(".waiternow.common.RefundsProto.refunds: array expected");
                    message.refunds = [];
                    for (var i = 0; i < object.refunds.length; ++i) {
                        if (typeof object.refunds[i] !== "object")
                            throw TypeError(".waiternow.common.RefundsProto.refunds: object expected");
                        message.refunds[i] = $root.waiternow.common.RefundProto.fromObject(object.refunds[i]);
                    }
                }
                if (object.continuationToken != null)
                    message.continuationToken = String(object.continuationToken);
                return message;
            };

            /**
             * Creates a plain object from a RefundsProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.RefundsProto
             * @static
             * @param {waiternow.common.RefundsProto} message RefundsProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            RefundsProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.refunds = [];
                if (options.defaults)
                    object.continuationToken = "";
                if (message.refunds && message.refunds.length) {
                    object.refunds = [];
                    for (var j = 0; j < message.refunds.length; ++j)
                        object.refunds[j] = $root.waiternow.common.RefundProto.toObject(message.refunds[j], options);
                }
                if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                    object.continuationToken = message.continuationToken;
                return object;
            };

            /**
             * Converts this RefundsProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.RefundsProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            RefundsProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for RefundsProto
             * @function getTypeUrl
             * @memberof waiternow.common.RefundsProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            RefundsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.RefundsProto";
            };

            return RefundsProto;
        })();

        common.OperationStatusProto = (function() {

            /**
             * Properties of an OperationStatusProto.
             * @memberof waiternow.common
             * @interface IOperationStatusProto
             * @property {boolean|null} [isSuccess] OperationStatusProto isSuccess
             * @property {boolean|null} [isFailure] OperationStatusProto isFailure
             * @property {string|null} [errorCode] OperationStatusProto errorCode
             * @property {string|null} [errorMessage] OperationStatusProto errorMessage
             */

            /**
             * Constructs a new OperationStatusProto.
             * @memberof waiternow.common
             * @classdesc Represents an OperationStatusProto.
             * @implements IOperationStatusProto
             * @constructor
             * @param {waiternow.common.IOperationStatusProto=} [properties] Properties to set
             */
            function OperationStatusProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * OperationStatusProto isSuccess.
             * @member {boolean} isSuccess
             * @memberof waiternow.common.OperationStatusProto
             * @instance
             */
            OperationStatusProto.prototype.isSuccess = false;

            /**
             * OperationStatusProto isFailure.
             * @member {boolean} isFailure
             * @memberof waiternow.common.OperationStatusProto
             * @instance
             */
            OperationStatusProto.prototype.isFailure = false;

            /**
             * OperationStatusProto errorCode.
             * @member {string} errorCode
             * @memberof waiternow.common.OperationStatusProto
             * @instance
             */
            OperationStatusProto.prototype.errorCode = "";

            /**
             * OperationStatusProto errorMessage.
             * @member {string} errorMessage
             * @memberof waiternow.common.OperationStatusProto
             * @instance
             */
            OperationStatusProto.prototype.errorMessage = "";

            /**
             * Creates a new OperationStatusProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.OperationStatusProto
             * @static
             * @param {waiternow.common.IOperationStatusProto=} [properties] Properties to set
             * @returns {waiternow.common.OperationStatusProto} OperationStatusProto instance
             */
            OperationStatusProto.create = function create(properties) {
                return new OperationStatusProto(properties);
            };

            /**
             * Encodes the specified OperationStatusProto message. Does not implicitly {@link waiternow.common.OperationStatusProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.OperationStatusProto
             * @static
             * @param {waiternow.common.IOperationStatusProto} message OperationStatusProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OperationStatusProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.isSuccess != null && Object.hasOwnProperty.call(message, "isSuccess"))
                    writer.uint32(/* id 1, wireType 0 =*/8).bool(message.isSuccess);
                if (message.isFailure != null && Object.hasOwnProperty.call(message, "isFailure"))
                    writer.uint32(/* id 2, wireType 0 =*/16).bool(message.isFailure);
                if (message.errorCode != null && Object.hasOwnProperty.call(message, "errorCode"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.errorCode);
                if (message.errorMessage != null && Object.hasOwnProperty.call(message, "errorMessage"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.errorMessage);
                return writer;
            };

            /**
             * Encodes the specified OperationStatusProto message, length delimited. Does not implicitly {@link waiternow.common.OperationStatusProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.OperationStatusProto
             * @static
             * @param {waiternow.common.IOperationStatusProto} message OperationStatusProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OperationStatusProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an OperationStatusProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.OperationStatusProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.OperationStatusProto} OperationStatusProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OperationStatusProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.OperationStatusProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.isSuccess = reader.bool();
                            break;
                        }
                    case 2: {
                            message.isFailure = reader.bool();
                            break;
                        }
                    case 3: {
                            message.errorCode = reader.string();
                            break;
                        }
                    case 4: {
                            message.errorMessage = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an OperationStatusProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.OperationStatusProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.OperationStatusProto} OperationStatusProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OperationStatusProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an OperationStatusProto message.
             * @function verify
             * @memberof waiternow.common.OperationStatusProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            OperationStatusProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.isSuccess != null && message.hasOwnProperty("isSuccess"))
                    if (typeof message.isSuccess !== "boolean")
                        return "isSuccess: boolean expected";
                if (message.isFailure != null && message.hasOwnProperty("isFailure"))
                    if (typeof message.isFailure !== "boolean")
                        return "isFailure: boolean expected";
                if (message.errorCode != null && message.hasOwnProperty("errorCode"))
                    if (!$util.isString(message.errorCode))
                        return "errorCode: string expected";
                if (message.errorMessage != null && message.hasOwnProperty("errorMessage"))
                    if (!$util.isString(message.errorMessage))
                        return "errorMessage: string expected";
                return null;
            };

            /**
             * Creates an OperationStatusProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.OperationStatusProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.OperationStatusProto} OperationStatusProto
             */
            OperationStatusProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.OperationStatusProto)
                    return object;
                var message = new $root.waiternow.common.OperationStatusProto();
                if (object.isSuccess != null)
                    message.isSuccess = Boolean(object.isSuccess);
                if (object.isFailure != null)
                    message.isFailure = Boolean(object.isFailure);
                if (object.errorCode != null)
                    message.errorCode = String(object.errorCode);
                if (object.errorMessage != null)
                    message.errorMessage = String(object.errorMessage);
                return message;
            };

            /**
             * Creates a plain object from an OperationStatusProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.OperationStatusProto
             * @static
             * @param {waiternow.common.OperationStatusProto} message OperationStatusProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            OperationStatusProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.isSuccess = false;
                    object.isFailure = false;
                    object.errorCode = "";
                    object.errorMessage = "";
                }
                if (message.isSuccess != null && message.hasOwnProperty("isSuccess"))
                    object.isSuccess = message.isSuccess;
                if (message.isFailure != null && message.hasOwnProperty("isFailure"))
                    object.isFailure = message.isFailure;
                if (message.errorCode != null && message.hasOwnProperty("errorCode"))
                    object.errorCode = message.errorCode;
                if (message.errorMessage != null && message.hasOwnProperty("errorMessage"))
                    object.errorMessage = message.errorMessage;
                return object;
            };

            /**
             * Converts this OperationStatusProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.OperationStatusProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            OperationStatusProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for OperationStatusProto
             * @function getTypeUrl
             * @memberof waiternow.common.OperationStatusProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            OperationStatusProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.OperationStatusProto";
            };

            return OperationStatusProto;
        })();

        common.AnalyticsProto = (function() {

            /**
             * Properties of an AnalyticsProto.
             * @memberof waiternow.common
             * @interface IAnalyticsProto
             * @property {string|null} [locationId] AnalyticsProto locationId
             * @property {google.protobuf.ITimestamp|null} [creationTime] AnalyticsProto creationTime
             * @property {google.protobuf.ITimestamp|null} [lastUpdateTime] AnalyticsProto lastUpdateTime
             * @property {string|null} [concurrencyToken] AnalyticsProto concurrencyToken
             * @property {Array.<waiternow.common.AnalyticsProto.IYearStatisticsProto>|null} [yearStatistics] AnalyticsProto yearStatistics
             * @property {waiternow.common.AnalyticsProto.IRedundantDataProto|null} [redundantData] AnalyticsProto redundantData
             */

            /**
             * Constructs a new AnalyticsProto.
             * @memberof waiternow.common
             * @classdesc Represents an AnalyticsProto.
             * @implements IAnalyticsProto
             * @constructor
             * @param {waiternow.common.IAnalyticsProto=} [properties] Properties to set
             */
            function AnalyticsProto(properties) {
                this.yearStatistics = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AnalyticsProto locationId.
             * @member {string} locationId
             * @memberof waiternow.common.AnalyticsProto
             * @instance
             */
            AnalyticsProto.prototype.locationId = "";

            /**
             * AnalyticsProto creationTime.
             * @member {google.protobuf.ITimestamp|null|undefined} creationTime
             * @memberof waiternow.common.AnalyticsProto
             * @instance
             */
            AnalyticsProto.prototype.creationTime = null;

            /**
             * AnalyticsProto lastUpdateTime.
             * @member {google.protobuf.ITimestamp|null|undefined} lastUpdateTime
             * @memberof waiternow.common.AnalyticsProto
             * @instance
             */
            AnalyticsProto.prototype.lastUpdateTime = null;

            /**
             * AnalyticsProto concurrencyToken.
             * @member {string} concurrencyToken
             * @memberof waiternow.common.AnalyticsProto
             * @instance
             */
            AnalyticsProto.prototype.concurrencyToken = "";

            /**
             * AnalyticsProto yearStatistics.
             * @member {Array.<waiternow.common.AnalyticsProto.IYearStatisticsProto>} yearStatistics
             * @memberof waiternow.common.AnalyticsProto
             * @instance
             */
            AnalyticsProto.prototype.yearStatistics = $util.emptyArray;

            /**
             * AnalyticsProto redundantData.
             * @member {waiternow.common.AnalyticsProto.IRedundantDataProto|null|undefined} redundantData
             * @memberof waiternow.common.AnalyticsProto
             * @instance
             */
            AnalyticsProto.prototype.redundantData = null;

            /**
             * Creates a new AnalyticsProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.AnalyticsProto
             * @static
             * @param {waiternow.common.IAnalyticsProto=} [properties] Properties to set
             * @returns {waiternow.common.AnalyticsProto} AnalyticsProto instance
             */
            AnalyticsProto.create = function create(properties) {
                return new AnalyticsProto(properties);
            };

            /**
             * Encodes the specified AnalyticsProto message. Does not implicitly {@link waiternow.common.AnalyticsProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.AnalyticsProto
             * @static
             * @param {waiternow.common.IAnalyticsProto} message AnalyticsProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AnalyticsProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                if (message.creationTime != null && Object.hasOwnProperty.call(message, "creationTime"))
                    $root.google.protobuf.Timestamp.encode(message.creationTime, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                    $root.google.protobuf.Timestamp.encode(message.lastUpdateTime, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.concurrencyToken != null && Object.hasOwnProperty.call(message, "concurrencyToken"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.concurrencyToken);
                if (message.yearStatistics != null && message.yearStatistics.length)
                    for (var i = 0; i < message.yearStatistics.length; ++i)
                        $root.waiternow.common.AnalyticsProto.YearStatisticsProto.encode(message.yearStatistics[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                if (message.redundantData != null && Object.hasOwnProperty.call(message, "redundantData"))
                    $root.waiternow.common.AnalyticsProto.RedundantDataProto.encode(message.redundantData, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified AnalyticsProto message, length delimited. Does not implicitly {@link waiternow.common.AnalyticsProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.AnalyticsProto
             * @static
             * @param {waiternow.common.IAnalyticsProto} message AnalyticsProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AnalyticsProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AnalyticsProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.AnalyticsProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.AnalyticsProto} AnalyticsProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AnalyticsProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.AnalyticsProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.locationId = reader.string();
                            break;
                        }
                    case 2: {
                            message.creationTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 3: {
                            message.lastUpdateTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 4: {
                            message.concurrencyToken = reader.string();
                            break;
                        }
                    case 5: {
                            if (!(message.yearStatistics && message.yearStatistics.length))
                                message.yearStatistics = [];
                            message.yearStatistics.push($root.waiternow.common.AnalyticsProto.YearStatisticsProto.decode(reader, reader.uint32()));
                            break;
                        }
                    case 6: {
                            message.redundantData = $root.waiternow.common.AnalyticsProto.RedundantDataProto.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AnalyticsProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.AnalyticsProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.AnalyticsProto} AnalyticsProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AnalyticsProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AnalyticsProto message.
             * @function verify
             * @memberof waiternow.common.AnalyticsProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AnalyticsProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.locationId != null && message.hasOwnProperty("locationId"))
                    if (!$util.isString(message.locationId))
                        return "locationId: string expected";
                if (message.creationTime != null && message.hasOwnProperty("creationTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.creationTime);
                    if (error)
                        return "creationTime." + error;
                }
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.lastUpdateTime);
                    if (error)
                        return "lastUpdateTime." + error;
                }
                if (message.concurrencyToken != null && message.hasOwnProperty("concurrencyToken"))
                    if (!$util.isString(message.concurrencyToken))
                        return "concurrencyToken: string expected";
                if (message.yearStatistics != null && message.hasOwnProperty("yearStatistics")) {
                    if (!Array.isArray(message.yearStatistics))
                        return "yearStatistics: array expected";
                    for (var i = 0; i < message.yearStatistics.length; ++i) {
                        var error = $root.waiternow.common.AnalyticsProto.YearStatisticsProto.verify(message.yearStatistics[i]);
                        if (error)
                            return "yearStatistics." + error;
                    }
                }
                if (message.redundantData != null && message.hasOwnProperty("redundantData")) {
                    var error = $root.waiternow.common.AnalyticsProto.RedundantDataProto.verify(message.redundantData);
                    if (error)
                        return "redundantData." + error;
                }
                return null;
            };

            /**
             * Creates an AnalyticsProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.AnalyticsProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.AnalyticsProto} AnalyticsProto
             */
            AnalyticsProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.AnalyticsProto)
                    return object;
                var message = new $root.waiternow.common.AnalyticsProto();
                if (object.locationId != null)
                    message.locationId = String(object.locationId);
                if (object.creationTime != null) {
                    if (typeof object.creationTime !== "object")
                        throw TypeError(".waiternow.common.AnalyticsProto.creationTime: object expected");
                    message.creationTime = $root.google.protobuf.Timestamp.fromObject(object.creationTime);
                }
                if (object.lastUpdateTime != null) {
                    if (typeof object.lastUpdateTime !== "object")
                        throw TypeError(".waiternow.common.AnalyticsProto.lastUpdateTime: object expected");
                    message.lastUpdateTime = $root.google.protobuf.Timestamp.fromObject(object.lastUpdateTime);
                }
                if (object.concurrencyToken != null)
                    message.concurrencyToken = String(object.concurrencyToken);
                if (object.yearStatistics) {
                    if (!Array.isArray(object.yearStatistics))
                        throw TypeError(".waiternow.common.AnalyticsProto.yearStatistics: array expected");
                    message.yearStatistics = [];
                    for (var i = 0; i < object.yearStatistics.length; ++i) {
                        if (typeof object.yearStatistics[i] !== "object")
                            throw TypeError(".waiternow.common.AnalyticsProto.yearStatistics: object expected");
                        message.yearStatistics[i] = $root.waiternow.common.AnalyticsProto.YearStatisticsProto.fromObject(object.yearStatistics[i]);
                    }
                }
                if (object.redundantData != null) {
                    if (typeof object.redundantData !== "object")
                        throw TypeError(".waiternow.common.AnalyticsProto.redundantData: object expected");
                    message.redundantData = $root.waiternow.common.AnalyticsProto.RedundantDataProto.fromObject(object.redundantData);
                }
                return message;
            };

            /**
             * Creates a plain object from an AnalyticsProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.AnalyticsProto
             * @static
             * @param {waiternow.common.AnalyticsProto} message AnalyticsProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AnalyticsProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.yearStatistics = [];
                if (options.defaults) {
                    object.locationId = "";
                    object.creationTime = null;
                    object.lastUpdateTime = null;
                    object.concurrencyToken = "";
                    object.redundantData = null;
                }
                if (message.locationId != null && message.hasOwnProperty("locationId"))
                    object.locationId = message.locationId;
                if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                    object.creationTime = $root.google.protobuf.Timestamp.toObject(message.creationTime, options);
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                    object.lastUpdateTime = $root.google.protobuf.Timestamp.toObject(message.lastUpdateTime, options);
                if (message.concurrencyToken != null && message.hasOwnProperty("concurrencyToken"))
                    object.concurrencyToken = message.concurrencyToken;
                if (message.yearStatistics && message.yearStatistics.length) {
                    object.yearStatistics = [];
                    for (var j = 0; j < message.yearStatistics.length; ++j)
                        object.yearStatistics[j] = $root.waiternow.common.AnalyticsProto.YearStatisticsProto.toObject(message.yearStatistics[j], options);
                }
                if (message.redundantData != null && message.hasOwnProperty("redundantData"))
                    object.redundantData = $root.waiternow.common.AnalyticsProto.RedundantDataProto.toObject(message.redundantData, options);
                return object;
            };

            /**
             * Converts this AnalyticsProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.AnalyticsProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AnalyticsProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for AnalyticsProto
             * @function getTypeUrl
             * @memberof waiternow.common.AnalyticsProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            AnalyticsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.AnalyticsProto";
            };

            AnalyticsProto.StatisticsProto = (function() {

                /**
                 * Properties of a StatisticsProto.
                 * @memberof waiternow.common.AnalyticsProto
                 * @interface IStatisticsProto
                 * @property {number|null} [numberOfRequests] StatisticsProto numberOfRequests
                 * @property {number|null} [numberOfCheckIns] StatisticsProto numberOfCheckIns
                 * @property {number|null} [numberOfPaidOrders] StatisticsProto numberOfPaidOrders
                 * @property {number|null} [numberOfThumbsUp] StatisticsProto numberOfThumbsUp
                 * @property {number|null} [numberOfThumbsDown] StatisticsProto numberOfThumbsDown
                 * @property {number|null} [numberOfFiveStarsRatings] StatisticsProto numberOfFiveStarsRatings
                 * @property {number|null} [numberOfFourStarsRatings] StatisticsProto numberOfFourStarsRatings
                 * @property {number|null} [numberOfThreeStarsRatings] StatisticsProto numberOfThreeStarsRatings
                 * @property {number|null} [numberOfTwoStarsRatings] StatisticsProto numberOfTwoStarsRatings
                 * @property {number|null} [numberOfOneStarRatings] StatisticsProto numberOfOneStarRatings
                 */

                /**
                 * Constructs a new StatisticsProto.
                 * @memberof waiternow.common.AnalyticsProto
                 * @classdesc Represents a StatisticsProto.
                 * @implements IStatisticsProto
                 * @constructor
                 * @param {waiternow.common.AnalyticsProto.IStatisticsProto=} [properties] Properties to set
                 */
                function StatisticsProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StatisticsProto numberOfRequests.
                 * @member {number} numberOfRequests
                 * @memberof waiternow.common.AnalyticsProto.StatisticsProto
                 * @instance
                 */
                StatisticsProto.prototype.numberOfRequests = 0;

                /**
                 * StatisticsProto numberOfCheckIns.
                 * @member {number} numberOfCheckIns
                 * @memberof waiternow.common.AnalyticsProto.StatisticsProto
                 * @instance
                 */
                StatisticsProto.prototype.numberOfCheckIns = 0;

                /**
                 * StatisticsProto numberOfPaidOrders.
                 * @member {number} numberOfPaidOrders
                 * @memberof waiternow.common.AnalyticsProto.StatisticsProto
                 * @instance
                 */
                StatisticsProto.prototype.numberOfPaidOrders = 0;

                /**
                 * StatisticsProto numberOfThumbsUp.
                 * @member {number} numberOfThumbsUp
                 * @memberof waiternow.common.AnalyticsProto.StatisticsProto
                 * @instance
                 */
                StatisticsProto.prototype.numberOfThumbsUp = 0;

                /**
                 * StatisticsProto numberOfThumbsDown.
                 * @member {number} numberOfThumbsDown
                 * @memberof waiternow.common.AnalyticsProto.StatisticsProto
                 * @instance
                 */
                StatisticsProto.prototype.numberOfThumbsDown = 0;

                /**
                 * StatisticsProto numberOfFiveStarsRatings.
                 * @member {number} numberOfFiveStarsRatings
                 * @memberof waiternow.common.AnalyticsProto.StatisticsProto
                 * @instance
                 */
                StatisticsProto.prototype.numberOfFiveStarsRatings = 0;

                /**
                 * StatisticsProto numberOfFourStarsRatings.
                 * @member {number} numberOfFourStarsRatings
                 * @memberof waiternow.common.AnalyticsProto.StatisticsProto
                 * @instance
                 */
                StatisticsProto.prototype.numberOfFourStarsRatings = 0;

                /**
                 * StatisticsProto numberOfThreeStarsRatings.
                 * @member {number} numberOfThreeStarsRatings
                 * @memberof waiternow.common.AnalyticsProto.StatisticsProto
                 * @instance
                 */
                StatisticsProto.prototype.numberOfThreeStarsRatings = 0;

                /**
                 * StatisticsProto numberOfTwoStarsRatings.
                 * @member {number} numberOfTwoStarsRatings
                 * @memberof waiternow.common.AnalyticsProto.StatisticsProto
                 * @instance
                 */
                StatisticsProto.prototype.numberOfTwoStarsRatings = 0;

                /**
                 * StatisticsProto numberOfOneStarRatings.
                 * @member {number} numberOfOneStarRatings
                 * @memberof waiternow.common.AnalyticsProto.StatisticsProto
                 * @instance
                 */
                StatisticsProto.prototype.numberOfOneStarRatings = 0;

                /**
                 * Creates a new StatisticsProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.AnalyticsProto.StatisticsProto
                 * @static
                 * @param {waiternow.common.AnalyticsProto.IStatisticsProto=} [properties] Properties to set
                 * @returns {waiternow.common.AnalyticsProto.StatisticsProto} StatisticsProto instance
                 */
                StatisticsProto.create = function create(properties) {
                    return new StatisticsProto(properties);
                };

                /**
                 * Encodes the specified StatisticsProto message. Does not implicitly {@link waiternow.common.AnalyticsProto.StatisticsProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.AnalyticsProto.StatisticsProto
                 * @static
                 * @param {waiternow.common.AnalyticsProto.IStatisticsProto} message StatisticsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StatisticsProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.numberOfRequests != null && Object.hasOwnProperty.call(message, "numberOfRequests"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.numberOfRequests);
                    if (message.numberOfCheckIns != null && Object.hasOwnProperty.call(message, "numberOfCheckIns"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.numberOfCheckIns);
                    if (message.numberOfPaidOrders != null && Object.hasOwnProperty.call(message, "numberOfPaidOrders"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.numberOfPaidOrders);
                    if (message.numberOfThumbsUp != null && Object.hasOwnProperty.call(message, "numberOfThumbsUp"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.numberOfThumbsUp);
                    if (message.numberOfThumbsDown != null && Object.hasOwnProperty.call(message, "numberOfThumbsDown"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int32(message.numberOfThumbsDown);
                    if (message.numberOfFiveStarsRatings != null && Object.hasOwnProperty.call(message, "numberOfFiveStarsRatings"))
                        writer.uint32(/* id 6, wireType 0 =*/48).int32(message.numberOfFiveStarsRatings);
                    if (message.numberOfFourStarsRatings != null && Object.hasOwnProperty.call(message, "numberOfFourStarsRatings"))
                        writer.uint32(/* id 7, wireType 0 =*/56).int32(message.numberOfFourStarsRatings);
                    if (message.numberOfThreeStarsRatings != null && Object.hasOwnProperty.call(message, "numberOfThreeStarsRatings"))
                        writer.uint32(/* id 8, wireType 0 =*/64).int32(message.numberOfThreeStarsRatings);
                    if (message.numberOfTwoStarsRatings != null && Object.hasOwnProperty.call(message, "numberOfTwoStarsRatings"))
                        writer.uint32(/* id 9, wireType 0 =*/72).int32(message.numberOfTwoStarsRatings);
                    if (message.numberOfOneStarRatings != null && Object.hasOwnProperty.call(message, "numberOfOneStarRatings"))
                        writer.uint32(/* id 10, wireType 0 =*/80).int32(message.numberOfOneStarRatings);
                    return writer;
                };

                /**
                 * Encodes the specified StatisticsProto message, length delimited. Does not implicitly {@link waiternow.common.AnalyticsProto.StatisticsProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.AnalyticsProto.StatisticsProto
                 * @static
                 * @param {waiternow.common.AnalyticsProto.IStatisticsProto} message StatisticsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StatisticsProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a StatisticsProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.AnalyticsProto.StatisticsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.AnalyticsProto.StatisticsProto} StatisticsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StatisticsProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.AnalyticsProto.StatisticsProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.numberOfRequests = reader.int32();
                                break;
                            }
                        case 2: {
                                message.numberOfCheckIns = reader.int32();
                                break;
                            }
                        case 3: {
                                message.numberOfPaidOrders = reader.int32();
                                break;
                            }
                        case 4: {
                                message.numberOfThumbsUp = reader.int32();
                                break;
                            }
                        case 5: {
                                message.numberOfThumbsDown = reader.int32();
                                break;
                            }
                        case 6: {
                                message.numberOfFiveStarsRatings = reader.int32();
                                break;
                            }
                        case 7: {
                                message.numberOfFourStarsRatings = reader.int32();
                                break;
                            }
                        case 8: {
                                message.numberOfThreeStarsRatings = reader.int32();
                                break;
                            }
                        case 9: {
                                message.numberOfTwoStarsRatings = reader.int32();
                                break;
                            }
                        case 10: {
                                message.numberOfOneStarRatings = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a StatisticsProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.AnalyticsProto.StatisticsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.AnalyticsProto.StatisticsProto} StatisticsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StatisticsProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StatisticsProto message.
                 * @function verify
                 * @memberof waiternow.common.AnalyticsProto.StatisticsProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StatisticsProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.numberOfRequests != null && message.hasOwnProperty("numberOfRequests"))
                        if (!$util.isInteger(message.numberOfRequests))
                            return "numberOfRequests: integer expected";
                    if (message.numberOfCheckIns != null && message.hasOwnProperty("numberOfCheckIns"))
                        if (!$util.isInteger(message.numberOfCheckIns))
                            return "numberOfCheckIns: integer expected";
                    if (message.numberOfPaidOrders != null && message.hasOwnProperty("numberOfPaidOrders"))
                        if (!$util.isInteger(message.numberOfPaidOrders))
                            return "numberOfPaidOrders: integer expected";
                    if (message.numberOfThumbsUp != null && message.hasOwnProperty("numberOfThumbsUp"))
                        if (!$util.isInteger(message.numberOfThumbsUp))
                            return "numberOfThumbsUp: integer expected";
                    if (message.numberOfThumbsDown != null && message.hasOwnProperty("numberOfThumbsDown"))
                        if (!$util.isInteger(message.numberOfThumbsDown))
                            return "numberOfThumbsDown: integer expected";
                    if (message.numberOfFiveStarsRatings != null && message.hasOwnProperty("numberOfFiveStarsRatings"))
                        if (!$util.isInteger(message.numberOfFiveStarsRatings))
                            return "numberOfFiveStarsRatings: integer expected";
                    if (message.numberOfFourStarsRatings != null && message.hasOwnProperty("numberOfFourStarsRatings"))
                        if (!$util.isInteger(message.numberOfFourStarsRatings))
                            return "numberOfFourStarsRatings: integer expected";
                    if (message.numberOfThreeStarsRatings != null && message.hasOwnProperty("numberOfThreeStarsRatings"))
                        if (!$util.isInteger(message.numberOfThreeStarsRatings))
                            return "numberOfThreeStarsRatings: integer expected";
                    if (message.numberOfTwoStarsRatings != null && message.hasOwnProperty("numberOfTwoStarsRatings"))
                        if (!$util.isInteger(message.numberOfTwoStarsRatings))
                            return "numberOfTwoStarsRatings: integer expected";
                    if (message.numberOfOneStarRatings != null && message.hasOwnProperty("numberOfOneStarRatings"))
                        if (!$util.isInteger(message.numberOfOneStarRatings))
                            return "numberOfOneStarRatings: integer expected";
                    return null;
                };

                /**
                 * Creates a StatisticsProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.AnalyticsProto.StatisticsProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.AnalyticsProto.StatisticsProto} StatisticsProto
                 */
                StatisticsProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.AnalyticsProto.StatisticsProto)
                        return object;
                    var message = new $root.waiternow.common.AnalyticsProto.StatisticsProto();
                    if (object.numberOfRequests != null)
                        message.numberOfRequests = object.numberOfRequests | 0;
                    if (object.numberOfCheckIns != null)
                        message.numberOfCheckIns = object.numberOfCheckIns | 0;
                    if (object.numberOfPaidOrders != null)
                        message.numberOfPaidOrders = object.numberOfPaidOrders | 0;
                    if (object.numberOfThumbsUp != null)
                        message.numberOfThumbsUp = object.numberOfThumbsUp | 0;
                    if (object.numberOfThumbsDown != null)
                        message.numberOfThumbsDown = object.numberOfThumbsDown | 0;
                    if (object.numberOfFiveStarsRatings != null)
                        message.numberOfFiveStarsRatings = object.numberOfFiveStarsRatings | 0;
                    if (object.numberOfFourStarsRatings != null)
                        message.numberOfFourStarsRatings = object.numberOfFourStarsRatings | 0;
                    if (object.numberOfThreeStarsRatings != null)
                        message.numberOfThreeStarsRatings = object.numberOfThreeStarsRatings | 0;
                    if (object.numberOfTwoStarsRatings != null)
                        message.numberOfTwoStarsRatings = object.numberOfTwoStarsRatings | 0;
                    if (object.numberOfOneStarRatings != null)
                        message.numberOfOneStarRatings = object.numberOfOneStarRatings | 0;
                    return message;
                };

                /**
                 * Creates a plain object from a StatisticsProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.AnalyticsProto.StatisticsProto
                 * @static
                 * @param {waiternow.common.AnalyticsProto.StatisticsProto} message StatisticsProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StatisticsProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.numberOfRequests = 0;
                        object.numberOfCheckIns = 0;
                        object.numberOfPaidOrders = 0;
                        object.numberOfThumbsUp = 0;
                        object.numberOfThumbsDown = 0;
                        object.numberOfFiveStarsRatings = 0;
                        object.numberOfFourStarsRatings = 0;
                        object.numberOfThreeStarsRatings = 0;
                        object.numberOfTwoStarsRatings = 0;
                        object.numberOfOneStarRatings = 0;
                    }
                    if (message.numberOfRequests != null && message.hasOwnProperty("numberOfRequests"))
                        object.numberOfRequests = message.numberOfRequests;
                    if (message.numberOfCheckIns != null && message.hasOwnProperty("numberOfCheckIns"))
                        object.numberOfCheckIns = message.numberOfCheckIns;
                    if (message.numberOfPaidOrders != null && message.hasOwnProperty("numberOfPaidOrders"))
                        object.numberOfPaidOrders = message.numberOfPaidOrders;
                    if (message.numberOfThumbsUp != null && message.hasOwnProperty("numberOfThumbsUp"))
                        object.numberOfThumbsUp = message.numberOfThumbsUp;
                    if (message.numberOfThumbsDown != null && message.hasOwnProperty("numberOfThumbsDown"))
                        object.numberOfThumbsDown = message.numberOfThumbsDown;
                    if (message.numberOfFiveStarsRatings != null && message.hasOwnProperty("numberOfFiveStarsRatings"))
                        object.numberOfFiveStarsRatings = message.numberOfFiveStarsRatings;
                    if (message.numberOfFourStarsRatings != null && message.hasOwnProperty("numberOfFourStarsRatings"))
                        object.numberOfFourStarsRatings = message.numberOfFourStarsRatings;
                    if (message.numberOfThreeStarsRatings != null && message.hasOwnProperty("numberOfThreeStarsRatings"))
                        object.numberOfThreeStarsRatings = message.numberOfThreeStarsRatings;
                    if (message.numberOfTwoStarsRatings != null && message.hasOwnProperty("numberOfTwoStarsRatings"))
                        object.numberOfTwoStarsRatings = message.numberOfTwoStarsRatings;
                    if (message.numberOfOneStarRatings != null && message.hasOwnProperty("numberOfOneStarRatings"))
                        object.numberOfOneStarRatings = message.numberOfOneStarRatings;
                    return object;
                };

                /**
                 * Converts this StatisticsProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.AnalyticsProto.StatisticsProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StatisticsProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for StatisticsProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.AnalyticsProto.StatisticsProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                StatisticsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.AnalyticsProto.StatisticsProto";
                };

                return StatisticsProto;
            })();

            AnalyticsProto.MonthStatisticsProto = (function() {

                /**
                 * Properties of a MonthStatisticsProto.
                 * @memberof waiternow.common.AnalyticsProto
                 * @interface IMonthStatisticsProto
                 * @property {waiternow.common.Month|null} [month] MonthStatisticsProto month
                 * @property {waiternow.common.AnalyticsProto.IStatisticsProto|null} [statistics] MonthStatisticsProto statistics
                 */

                /**
                 * Constructs a new MonthStatisticsProto.
                 * @memberof waiternow.common.AnalyticsProto
                 * @classdesc Represents a MonthStatisticsProto.
                 * @implements IMonthStatisticsProto
                 * @constructor
                 * @param {waiternow.common.AnalyticsProto.IMonthStatisticsProto=} [properties] Properties to set
                 */
                function MonthStatisticsProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * MonthStatisticsProto month.
                 * @member {waiternow.common.Month} month
                 * @memberof waiternow.common.AnalyticsProto.MonthStatisticsProto
                 * @instance
                 */
                MonthStatisticsProto.prototype.month = 0;

                /**
                 * MonthStatisticsProto statistics.
                 * @member {waiternow.common.AnalyticsProto.IStatisticsProto|null|undefined} statistics
                 * @memberof waiternow.common.AnalyticsProto.MonthStatisticsProto
                 * @instance
                 */
                MonthStatisticsProto.prototype.statistics = null;

                /**
                 * Creates a new MonthStatisticsProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.AnalyticsProto.MonthStatisticsProto
                 * @static
                 * @param {waiternow.common.AnalyticsProto.IMonthStatisticsProto=} [properties] Properties to set
                 * @returns {waiternow.common.AnalyticsProto.MonthStatisticsProto} MonthStatisticsProto instance
                 */
                MonthStatisticsProto.create = function create(properties) {
                    return new MonthStatisticsProto(properties);
                };

                /**
                 * Encodes the specified MonthStatisticsProto message. Does not implicitly {@link waiternow.common.AnalyticsProto.MonthStatisticsProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.AnalyticsProto.MonthStatisticsProto
                 * @static
                 * @param {waiternow.common.AnalyticsProto.IMonthStatisticsProto} message MonthStatisticsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MonthStatisticsProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.month != null && Object.hasOwnProperty.call(message, "month"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.month);
                    if (message.statistics != null && Object.hasOwnProperty.call(message, "statistics"))
                        $root.waiternow.common.AnalyticsProto.StatisticsProto.encode(message.statistics, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified MonthStatisticsProto message, length delimited. Does not implicitly {@link waiternow.common.AnalyticsProto.MonthStatisticsProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.AnalyticsProto.MonthStatisticsProto
                 * @static
                 * @param {waiternow.common.AnalyticsProto.IMonthStatisticsProto} message MonthStatisticsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MonthStatisticsProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a MonthStatisticsProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.AnalyticsProto.MonthStatisticsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.AnalyticsProto.MonthStatisticsProto} MonthStatisticsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MonthStatisticsProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.AnalyticsProto.MonthStatisticsProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.month = reader.int32();
                                break;
                            }
                        case 2: {
                                message.statistics = $root.waiternow.common.AnalyticsProto.StatisticsProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a MonthStatisticsProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.AnalyticsProto.MonthStatisticsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.AnalyticsProto.MonthStatisticsProto} MonthStatisticsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MonthStatisticsProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a MonthStatisticsProto message.
                 * @function verify
                 * @memberof waiternow.common.AnalyticsProto.MonthStatisticsProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                MonthStatisticsProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.month != null && message.hasOwnProperty("month"))
                        switch (message.month) {
                        default:
                            return "month: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                        case 6:
                        case 7:
                        case 8:
                        case 9:
                        case 10:
                        case 11:
                        case 12:
                            break;
                        }
                    if (message.statistics != null && message.hasOwnProperty("statistics")) {
                        var error = $root.waiternow.common.AnalyticsProto.StatisticsProto.verify(message.statistics);
                        if (error)
                            return "statistics." + error;
                    }
                    return null;
                };

                /**
                 * Creates a MonthStatisticsProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.AnalyticsProto.MonthStatisticsProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.AnalyticsProto.MonthStatisticsProto} MonthStatisticsProto
                 */
                MonthStatisticsProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.AnalyticsProto.MonthStatisticsProto)
                        return object;
                    var message = new $root.waiternow.common.AnalyticsProto.MonthStatisticsProto();
                    switch (object.month) {
                    default:
                        if (typeof object.month === "number") {
                            message.month = object.month;
                            break;
                        }
                        break;
                    case "MONTH_UNSPECIFIED":
                    case 0:
                        message.month = 0;
                        break;
                    case "JANUARY":
                    case 1:
                        message.month = 1;
                        break;
                    case "FEBRUARY":
                    case 2:
                        message.month = 2;
                        break;
                    case "MARCH":
                    case 3:
                        message.month = 3;
                        break;
                    case "APRIL":
                    case 4:
                        message.month = 4;
                        break;
                    case "MAY":
                    case 5:
                        message.month = 5;
                        break;
                    case "JUNE":
                    case 6:
                        message.month = 6;
                        break;
                    case "JULY":
                    case 7:
                        message.month = 7;
                        break;
                    case "AUGUST":
                    case 8:
                        message.month = 8;
                        break;
                    case "SEPTEMBER":
                    case 9:
                        message.month = 9;
                        break;
                    case "OCTOBER":
                    case 10:
                        message.month = 10;
                        break;
                    case "NOVEMBER":
                    case 11:
                        message.month = 11;
                        break;
                    case "DECEMBER":
                    case 12:
                        message.month = 12;
                        break;
                    }
                    if (object.statistics != null) {
                        if (typeof object.statistics !== "object")
                            throw TypeError(".waiternow.common.AnalyticsProto.MonthStatisticsProto.statistics: object expected");
                        message.statistics = $root.waiternow.common.AnalyticsProto.StatisticsProto.fromObject(object.statistics);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a MonthStatisticsProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.AnalyticsProto.MonthStatisticsProto
                 * @static
                 * @param {waiternow.common.AnalyticsProto.MonthStatisticsProto} message MonthStatisticsProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                MonthStatisticsProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.month = options.enums === String ? "MONTH_UNSPECIFIED" : 0;
                        object.statistics = null;
                    }
                    if (message.month != null && message.hasOwnProperty("month"))
                        object.month = options.enums === String ? $root.waiternow.common.Month[message.month] === undefined ? message.month : $root.waiternow.common.Month[message.month] : message.month;
                    if (message.statistics != null && message.hasOwnProperty("statistics"))
                        object.statistics = $root.waiternow.common.AnalyticsProto.StatisticsProto.toObject(message.statistics, options);
                    return object;
                };

                /**
                 * Converts this MonthStatisticsProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.AnalyticsProto.MonthStatisticsProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                MonthStatisticsProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for MonthStatisticsProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.AnalyticsProto.MonthStatisticsProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                MonthStatisticsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.AnalyticsProto.MonthStatisticsProto";
                };

                return MonthStatisticsProto;
            })();

            AnalyticsProto.YearStatisticsProto = (function() {

                /**
                 * Properties of a YearStatisticsProto.
                 * @memberof waiternow.common.AnalyticsProto
                 * @interface IYearStatisticsProto
                 * @property {number|null} [year] YearStatisticsProto year
                 * @property {Array.<waiternow.common.AnalyticsProto.IMonthStatisticsProto>|null} [monthStatistics] YearStatisticsProto monthStatistics
                 */

                /**
                 * Constructs a new YearStatisticsProto.
                 * @memberof waiternow.common.AnalyticsProto
                 * @classdesc Represents a YearStatisticsProto.
                 * @implements IYearStatisticsProto
                 * @constructor
                 * @param {waiternow.common.AnalyticsProto.IYearStatisticsProto=} [properties] Properties to set
                 */
                function YearStatisticsProto(properties) {
                    this.monthStatistics = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * YearStatisticsProto year.
                 * @member {number} year
                 * @memberof waiternow.common.AnalyticsProto.YearStatisticsProto
                 * @instance
                 */
                YearStatisticsProto.prototype.year = 0;

                /**
                 * YearStatisticsProto monthStatistics.
                 * @member {Array.<waiternow.common.AnalyticsProto.IMonthStatisticsProto>} monthStatistics
                 * @memberof waiternow.common.AnalyticsProto.YearStatisticsProto
                 * @instance
                 */
                YearStatisticsProto.prototype.monthStatistics = $util.emptyArray;

                /**
                 * Creates a new YearStatisticsProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.AnalyticsProto.YearStatisticsProto
                 * @static
                 * @param {waiternow.common.AnalyticsProto.IYearStatisticsProto=} [properties] Properties to set
                 * @returns {waiternow.common.AnalyticsProto.YearStatisticsProto} YearStatisticsProto instance
                 */
                YearStatisticsProto.create = function create(properties) {
                    return new YearStatisticsProto(properties);
                };

                /**
                 * Encodes the specified YearStatisticsProto message. Does not implicitly {@link waiternow.common.AnalyticsProto.YearStatisticsProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.AnalyticsProto.YearStatisticsProto
                 * @static
                 * @param {waiternow.common.AnalyticsProto.IYearStatisticsProto} message YearStatisticsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                YearStatisticsProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.year != null && Object.hasOwnProperty.call(message, "year"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.year);
                    if (message.monthStatistics != null && message.monthStatistics.length)
                        for (var i = 0; i < message.monthStatistics.length; ++i)
                            $root.waiternow.common.AnalyticsProto.MonthStatisticsProto.encode(message.monthStatistics[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified YearStatisticsProto message, length delimited. Does not implicitly {@link waiternow.common.AnalyticsProto.YearStatisticsProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.AnalyticsProto.YearStatisticsProto
                 * @static
                 * @param {waiternow.common.AnalyticsProto.IYearStatisticsProto} message YearStatisticsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                YearStatisticsProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a YearStatisticsProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.AnalyticsProto.YearStatisticsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.AnalyticsProto.YearStatisticsProto} YearStatisticsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                YearStatisticsProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.AnalyticsProto.YearStatisticsProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.year = reader.int32();
                                break;
                            }
                        case 2: {
                                if (!(message.monthStatistics && message.monthStatistics.length))
                                    message.monthStatistics = [];
                                message.monthStatistics.push($root.waiternow.common.AnalyticsProto.MonthStatisticsProto.decode(reader, reader.uint32()));
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a YearStatisticsProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.AnalyticsProto.YearStatisticsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.AnalyticsProto.YearStatisticsProto} YearStatisticsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                YearStatisticsProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a YearStatisticsProto message.
                 * @function verify
                 * @memberof waiternow.common.AnalyticsProto.YearStatisticsProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                YearStatisticsProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.year != null && message.hasOwnProperty("year"))
                        if (!$util.isInteger(message.year))
                            return "year: integer expected";
                    if (message.monthStatistics != null && message.hasOwnProperty("monthStatistics")) {
                        if (!Array.isArray(message.monthStatistics))
                            return "monthStatistics: array expected";
                        for (var i = 0; i < message.monthStatistics.length; ++i) {
                            var error = $root.waiternow.common.AnalyticsProto.MonthStatisticsProto.verify(message.monthStatistics[i]);
                            if (error)
                                return "monthStatistics." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a YearStatisticsProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.AnalyticsProto.YearStatisticsProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.AnalyticsProto.YearStatisticsProto} YearStatisticsProto
                 */
                YearStatisticsProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.AnalyticsProto.YearStatisticsProto)
                        return object;
                    var message = new $root.waiternow.common.AnalyticsProto.YearStatisticsProto();
                    if (object.year != null)
                        message.year = object.year | 0;
                    if (object.monthStatistics) {
                        if (!Array.isArray(object.monthStatistics))
                            throw TypeError(".waiternow.common.AnalyticsProto.YearStatisticsProto.monthStatistics: array expected");
                        message.monthStatistics = [];
                        for (var i = 0; i < object.monthStatistics.length; ++i) {
                            if (typeof object.monthStatistics[i] !== "object")
                                throw TypeError(".waiternow.common.AnalyticsProto.YearStatisticsProto.monthStatistics: object expected");
                            message.monthStatistics[i] = $root.waiternow.common.AnalyticsProto.MonthStatisticsProto.fromObject(object.monthStatistics[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a YearStatisticsProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.AnalyticsProto.YearStatisticsProto
                 * @static
                 * @param {waiternow.common.AnalyticsProto.YearStatisticsProto} message YearStatisticsProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                YearStatisticsProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.monthStatistics = [];
                    if (options.defaults)
                        object.year = 0;
                    if (message.year != null && message.hasOwnProperty("year"))
                        object.year = message.year;
                    if (message.monthStatistics && message.monthStatistics.length) {
                        object.monthStatistics = [];
                        for (var j = 0; j < message.monthStatistics.length; ++j)
                            object.monthStatistics[j] = $root.waiternow.common.AnalyticsProto.MonthStatisticsProto.toObject(message.monthStatistics[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this YearStatisticsProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.AnalyticsProto.YearStatisticsProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                YearStatisticsProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for YearStatisticsProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.AnalyticsProto.YearStatisticsProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                YearStatisticsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.AnalyticsProto.YearStatisticsProto";
                };

                return YearStatisticsProto;
            })();

            AnalyticsProto.RedundantDataProto = (function() {

                /**
                 * Properties of a RedundantDataProto.
                 * @memberof waiternow.common.AnalyticsProto
                 * @interface IRedundantDataProto
                 * @property {number|null} [totalNumberOfRequests] RedundantDataProto totalNumberOfRequests
                 * @property {number|null} [totalNumberOfCheckIns] RedundantDataProto totalNumberOfCheckIns
                 * @property {number|null} [totalNumberOfPaidOrders] RedundantDataProto totalNumberOfPaidOrders
                 * @property {number|null} [totalNumberOfThumbsUp] RedundantDataProto totalNumberOfThumbsUp
                 * @property {number|null} [totalNumberOfThumbsDown] RedundantDataProto totalNumberOfThumbsDown
                 * @property {number|null} [totalNumberOfFiveStarsRatings] RedundantDataProto totalNumberOfFiveStarsRatings
                 * @property {number|null} [totalNumberOfFourStarsRatings] RedundantDataProto totalNumberOfFourStarsRatings
                 * @property {number|null} [totalNumberOfThreeStarsRatings] RedundantDataProto totalNumberOfThreeStarsRatings
                 * @property {number|null} [totalNumberOfTwoStarsRatings] RedundantDataProto totalNumberOfTwoStarsRatings
                 * @property {number|null} [totalNumberOfOneStarRatings] RedundantDataProto totalNumberOfOneStarRatings
                 */

                /**
                 * Constructs a new RedundantDataProto.
                 * @memberof waiternow.common.AnalyticsProto
                 * @classdesc Represents a RedundantDataProto.
                 * @implements IRedundantDataProto
                 * @constructor
                 * @param {waiternow.common.AnalyticsProto.IRedundantDataProto=} [properties] Properties to set
                 */
                function RedundantDataProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * RedundantDataProto totalNumberOfRequests.
                 * @member {number} totalNumberOfRequests
                 * @memberof waiternow.common.AnalyticsProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.totalNumberOfRequests = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * RedundantDataProto totalNumberOfCheckIns.
                 * @member {number} totalNumberOfCheckIns
                 * @memberof waiternow.common.AnalyticsProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.totalNumberOfCheckIns = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * RedundantDataProto totalNumberOfPaidOrders.
                 * @member {number} totalNumberOfPaidOrders
                 * @memberof waiternow.common.AnalyticsProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.totalNumberOfPaidOrders = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * RedundantDataProto totalNumberOfThumbsUp.
                 * @member {number} totalNumberOfThumbsUp
                 * @memberof waiternow.common.AnalyticsProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.totalNumberOfThumbsUp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * RedundantDataProto totalNumberOfThumbsDown.
                 * @member {number} totalNumberOfThumbsDown
                 * @memberof waiternow.common.AnalyticsProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.totalNumberOfThumbsDown = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * RedundantDataProto totalNumberOfFiveStarsRatings.
                 * @member {number} totalNumberOfFiveStarsRatings
                 * @memberof waiternow.common.AnalyticsProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.totalNumberOfFiveStarsRatings = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * RedundantDataProto totalNumberOfFourStarsRatings.
                 * @member {number} totalNumberOfFourStarsRatings
                 * @memberof waiternow.common.AnalyticsProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.totalNumberOfFourStarsRatings = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * RedundantDataProto totalNumberOfThreeStarsRatings.
                 * @member {number} totalNumberOfThreeStarsRatings
                 * @memberof waiternow.common.AnalyticsProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.totalNumberOfThreeStarsRatings = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * RedundantDataProto totalNumberOfTwoStarsRatings.
                 * @member {number} totalNumberOfTwoStarsRatings
                 * @memberof waiternow.common.AnalyticsProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.totalNumberOfTwoStarsRatings = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * RedundantDataProto totalNumberOfOneStarRatings.
                 * @member {number} totalNumberOfOneStarRatings
                 * @memberof waiternow.common.AnalyticsProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.totalNumberOfOneStarRatings = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Creates a new RedundantDataProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.AnalyticsProto.RedundantDataProto
                 * @static
                 * @param {waiternow.common.AnalyticsProto.IRedundantDataProto=} [properties] Properties to set
                 * @returns {waiternow.common.AnalyticsProto.RedundantDataProto} RedundantDataProto instance
                 */
                RedundantDataProto.create = function create(properties) {
                    return new RedundantDataProto(properties);
                };

                /**
                 * Encodes the specified RedundantDataProto message. Does not implicitly {@link waiternow.common.AnalyticsProto.RedundantDataProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.AnalyticsProto.RedundantDataProto
                 * @static
                 * @param {waiternow.common.AnalyticsProto.IRedundantDataProto} message RedundantDataProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RedundantDataProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.totalNumberOfRequests != null && Object.hasOwnProperty.call(message, "totalNumberOfRequests"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.totalNumberOfRequests);
                    if (message.totalNumberOfCheckIns != null && Object.hasOwnProperty.call(message, "totalNumberOfCheckIns"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int64(message.totalNumberOfCheckIns);
                    if (message.totalNumberOfPaidOrders != null && Object.hasOwnProperty.call(message, "totalNumberOfPaidOrders"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int64(message.totalNumberOfPaidOrders);
                    if (message.totalNumberOfThumbsUp != null && Object.hasOwnProperty.call(message, "totalNumberOfThumbsUp"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int64(message.totalNumberOfThumbsUp);
                    if (message.totalNumberOfThumbsDown != null && Object.hasOwnProperty.call(message, "totalNumberOfThumbsDown"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int64(message.totalNumberOfThumbsDown);
                    if (message.totalNumberOfFiveStarsRatings != null && Object.hasOwnProperty.call(message, "totalNumberOfFiveStarsRatings"))
                        writer.uint32(/* id 6, wireType 0 =*/48).int64(message.totalNumberOfFiveStarsRatings);
                    if (message.totalNumberOfFourStarsRatings != null && Object.hasOwnProperty.call(message, "totalNumberOfFourStarsRatings"))
                        writer.uint32(/* id 7, wireType 0 =*/56).int64(message.totalNumberOfFourStarsRatings);
                    if (message.totalNumberOfThreeStarsRatings != null && Object.hasOwnProperty.call(message, "totalNumberOfThreeStarsRatings"))
                        writer.uint32(/* id 8, wireType 0 =*/64).int64(message.totalNumberOfThreeStarsRatings);
                    if (message.totalNumberOfTwoStarsRatings != null && Object.hasOwnProperty.call(message, "totalNumberOfTwoStarsRatings"))
                        writer.uint32(/* id 9, wireType 0 =*/72).int64(message.totalNumberOfTwoStarsRatings);
                    if (message.totalNumberOfOneStarRatings != null && Object.hasOwnProperty.call(message, "totalNumberOfOneStarRatings"))
                        writer.uint32(/* id 10, wireType 0 =*/80).int64(message.totalNumberOfOneStarRatings);
                    return writer;
                };

                /**
                 * Encodes the specified RedundantDataProto message, length delimited. Does not implicitly {@link waiternow.common.AnalyticsProto.RedundantDataProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.AnalyticsProto.RedundantDataProto
                 * @static
                 * @param {waiternow.common.AnalyticsProto.IRedundantDataProto} message RedundantDataProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RedundantDataProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a RedundantDataProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.AnalyticsProto.RedundantDataProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.AnalyticsProto.RedundantDataProto} RedundantDataProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RedundantDataProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.AnalyticsProto.RedundantDataProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.totalNumberOfRequests = reader.int64();
                                break;
                            }
                        case 2: {
                                message.totalNumberOfCheckIns = reader.int64();
                                break;
                            }
                        case 3: {
                                message.totalNumberOfPaidOrders = reader.int64();
                                break;
                            }
                        case 4: {
                                message.totalNumberOfThumbsUp = reader.int64();
                                break;
                            }
                        case 5: {
                                message.totalNumberOfThumbsDown = reader.int64();
                                break;
                            }
                        case 6: {
                                message.totalNumberOfFiveStarsRatings = reader.int64();
                                break;
                            }
                        case 7: {
                                message.totalNumberOfFourStarsRatings = reader.int64();
                                break;
                            }
                        case 8: {
                                message.totalNumberOfThreeStarsRatings = reader.int64();
                                break;
                            }
                        case 9: {
                                message.totalNumberOfTwoStarsRatings = reader.int64();
                                break;
                            }
                        case 10: {
                                message.totalNumberOfOneStarRatings = reader.int64();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a RedundantDataProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.AnalyticsProto.RedundantDataProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.AnalyticsProto.RedundantDataProto} RedundantDataProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RedundantDataProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a RedundantDataProto message.
                 * @function verify
                 * @memberof waiternow.common.AnalyticsProto.RedundantDataProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                RedundantDataProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.totalNumberOfRequests != null && message.hasOwnProperty("totalNumberOfRequests"))
                        if (!$util.isInteger(message.totalNumberOfRequests) && !(message.totalNumberOfRequests && $util.isInteger(message.totalNumberOfRequests.low) && $util.isInteger(message.totalNumberOfRequests.high)))
                            return "totalNumberOfRequests: integer|Long expected";
                    if (message.totalNumberOfCheckIns != null && message.hasOwnProperty("totalNumberOfCheckIns"))
                        if (!$util.isInteger(message.totalNumberOfCheckIns) && !(message.totalNumberOfCheckIns && $util.isInteger(message.totalNumberOfCheckIns.low) && $util.isInteger(message.totalNumberOfCheckIns.high)))
                            return "totalNumberOfCheckIns: integer|Long expected";
                    if (message.totalNumberOfPaidOrders != null && message.hasOwnProperty("totalNumberOfPaidOrders"))
                        if (!$util.isInteger(message.totalNumberOfPaidOrders) && !(message.totalNumberOfPaidOrders && $util.isInteger(message.totalNumberOfPaidOrders.low) && $util.isInteger(message.totalNumberOfPaidOrders.high)))
                            return "totalNumberOfPaidOrders: integer|Long expected";
                    if (message.totalNumberOfThumbsUp != null && message.hasOwnProperty("totalNumberOfThumbsUp"))
                        if (!$util.isInteger(message.totalNumberOfThumbsUp) && !(message.totalNumberOfThumbsUp && $util.isInteger(message.totalNumberOfThumbsUp.low) && $util.isInteger(message.totalNumberOfThumbsUp.high)))
                            return "totalNumberOfThumbsUp: integer|Long expected";
                    if (message.totalNumberOfThumbsDown != null && message.hasOwnProperty("totalNumberOfThumbsDown"))
                        if (!$util.isInteger(message.totalNumberOfThumbsDown) && !(message.totalNumberOfThumbsDown && $util.isInteger(message.totalNumberOfThumbsDown.low) && $util.isInteger(message.totalNumberOfThumbsDown.high)))
                            return "totalNumberOfThumbsDown: integer|Long expected";
                    if (message.totalNumberOfFiveStarsRatings != null && message.hasOwnProperty("totalNumberOfFiveStarsRatings"))
                        if (!$util.isInteger(message.totalNumberOfFiveStarsRatings) && !(message.totalNumberOfFiveStarsRatings && $util.isInteger(message.totalNumberOfFiveStarsRatings.low) && $util.isInteger(message.totalNumberOfFiveStarsRatings.high)))
                            return "totalNumberOfFiveStarsRatings: integer|Long expected";
                    if (message.totalNumberOfFourStarsRatings != null && message.hasOwnProperty("totalNumberOfFourStarsRatings"))
                        if (!$util.isInteger(message.totalNumberOfFourStarsRatings) && !(message.totalNumberOfFourStarsRatings && $util.isInteger(message.totalNumberOfFourStarsRatings.low) && $util.isInteger(message.totalNumberOfFourStarsRatings.high)))
                            return "totalNumberOfFourStarsRatings: integer|Long expected";
                    if (message.totalNumberOfThreeStarsRatings != null && message.hasOwnProperty("totalNumberOfThreeStarsRatings"))
                        if (!$util.isInteger(message.totalNumberOfThreeStarsRatings) && !(message.totalNumberOfThreeStarsRatings && $util.isInteger(message.totalNumberOfThreeStarsRatings.low) && $util.isInteger(message.totalNumberOfThreeStarsRatings.high)))
                            return "totalNumberOfThreeStarsRatings: integer|Long expected";
                    if (message.totalNumberOfTwoStarsRatings != null && message.hasOwnProperty("totalNumberOfTwoStarsRatings"))
                        if (!$util.isInteger(message.totalNumberOfTwoStarsRatings) && !(message.totalNumberOfTwoStarsRatings && $util.isInteger(message.totalNumberOfTwoStarsRatings.low) && $util.isInteger(message.totalNumberOfTwoStarsRatings.high)))
                            return "totalNumberOfTwoStarsRatings: integer|Long expected";
                    if (message.totalNumberOfOneStarRatings != null && message.hasOwnProperty("totalNumberOfOneStarRatings"))
                        if (!$util.isInteger(message.totalNumberOfOneStarRatings) && !(message.totalNumberOfOneStarRatings && $util.isInteger(message.totalNumberOfOneStarRatings.low) && $util.isInteger(message.totalNumberOfOneStarRatings.high)))
                            return "totalNumberOfOneStarRatings: integer|Long expected";
                    return null;
                };

                /**
                 * Creates a RedundantDataProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.AnalyticsProto.RedundantDataProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.AnalyticsProto.RedundantDataProto} RedundantDataProto
                 */
                RedundantDataProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.AnalyticsProto.RedundantDataProto)
                        return object;
                    var message = new $root.waiternow.common.AnalyticsProto.RedundantDataProto();
                    if (object.totalNumberOfRequests != null)
                        if ($util.Long)
                            (message.totalNumberOfRequests = $util.Long.fromValue(object.totalNumberOfRequests)).unsigned = false;
                        else if (typeof object.totalNumberOfRequests === "string")
                            message.totalNumberOfRequests = parseInt(object.totalNumberOfRequests, 10);
                        else if (typeof object.totalNumberOfRequests === "number")
                            message.totalNumberOfRequests = object.totalNumberOfRequests;
                        else if (typeof object.totalNumberOfRequests === "object")
                            message.totalNumberOfRequests = new $util.LongBits(object.totalNumberOfRequests.low >>> 0, object.totalNumberOfRequests.high >>> 0).toNumber();
                    if (object.totalNumberOfCheckIns != null)
                        if ($util.Long)
                            (message.totalNumberOfCheckIns = $util.Long.fromValue(object.totalNumberOfCheckIns)).unsigned = false;
                        else if (typeof object.totalNumberOfCheckIns === "string")
                            message.totalNumberOfCheckIns = parseInt(object.totalNumberOfCheckIns, 10);
                        else if (typeof object.totalNumberOfCheckIns === "number")
                            message.totalNumberOfCheckIns = object.totalNumberOfCheckIns;
                        else if (typeof object.totalNumberOfCheckIns === "object")
                            message.totalNumberOfCheckIns = new $util.LongBits(object.totalNumberOfCheckIns.low >>> 0, object.totalNumberOfCheckIns.high >>> 0).toNumber();
                    if (object.totalNumberOfPaidOrders != null)
                        if ($util.Long)
                            (message.totalNumberOfPaidOrders = $util.Long.fromValue(object.totalNumberOfPaidOrders)).unsigned = false;
                        else if (typeof object.totalNumberOfPaidOrders === "string")
                            message.totalNumberOfPaidOrders = parseInt(object.totalNumberOfPaidOrders, 10);
                        else if (typeof object.totalNumberOfPaidOrders === "number")
                            message.totalNumberOfPaidOrders = object.totalNumberOfPaidOrders;
                        else if (typeof object.totalNumberOfPaidOrders === "object")
                            message.totalNumberOfPaidOrders = new $util.LongBits(object.totalNumberOfPaidOrders.low >>> 0, object.totalNumberOfPaidOrders.high >>> 0).toNumber();
                    if (object.totalNumberOfThumbsUp != null)
                        if ($util.Long)
                            (message.totalNumberOfThumbsUp = $util.Long.fromValue(object.totalNumberOfThumbsUp)).unsigned = false;
                        else if (typeof object.totalNumberOfThumbsUp === "string")
                            message.totalNumberOfThumbsUp = parseInt(object.totalNumberOfThumbsUp, 10);
                        else if (typeof object.totalNumberOfThumbsUp === "number")
                            message.totalNumberOfThumbsUp = object.totalNumberOfThumbsUp;
                        else if (typeof object.totalNumberOfThumbsUp === "object")
                            message.totalNumberOfThumbsUp = new $util.LongBits(object.totalNumberOfThumbsUp.low >>> 0, object.totalNumberOfThumbsUp.high >>> 0).toNumber();
                    if (object.totalNumberOfThumbsDown != null)
                        if ($util.Long)
                            (message.totalNumberOfThumbsDown = $util.Long.fromValue(object.totalNumberOfThumbsDown)).unsigned = false;
                        else if (typeof object.totalNumberOfThumbsDown === "string")
                            message.totalNumberOfThumbsDown = parseInt(object.totalNumberOfThumbsDown, 10);
                        else if (typeof object.totalNumberOfThumbsDown === "number")
                            message.totalNumberOfThumbsDown = object.totalNumberOfThumbsDown;
                        else if (typeof object.totalNumberOfThumbsDown === "object")
                            message.totalNumberOfThumbsDown = new $util.LongBits(object.totalNumberOfThumbsDown.low >>> 0, object.totalNumberOfThumbsDown.high >>> 0).toNumber();
                    if (object.totalNumberOfFiveStarsRatings != null)
                        if ($util.Long)
                            (message.totalNumberOfFiveStarsRatings = $util.Long.fromValue(object.totalNumberOfFiveStarsRatings)).unsigned = false;
                        else if (typeof object.totalNumberOfFiveStarsRatings === "string")
                            message.totalNumberOfFiveStarsRatings = parseInt(object.totalNumberOfFiveStarsRatings, 10);
                        else if (typeof object.totalNumberOfFiveStarsRatings === "number")
                            message.totalNumberOfFiveStarsRatings = object.totalNumberOfFiveStarsRatings;
                        else if (typeof object.totalNumberOfFiveStarsRatings === "object")
                            message.totalNumberOfFiveStarsRatings = new $util.LongBits(object.totalNumberOfFiveStarsRatings.low >>> 0, object.totalNumberOfFiveStarsRatings.high >>> 0).toNumber();
                    if (object.totalNumberOfFourStarsRatings != null)
                        if ($util.Long)
                            (message.totalNumberOfFourStarsRatings = $util.Long.fromValue(object.totalNumberOfFourStarsRatings)).unsigned = false;
                        else if (typeof object.totalNumberOfFourStarsRatings === "string")
                            message.totalNumberOfFourStarsRatings = parseInt(object.totalNumberOfFourStarsRatings, 10);
                        else if (typeof object.totalNumberOfFourStarsRatings === "number")
                            message.totalNumberOfFourStarsRatings = object.totalNumberOfFourStarsRatings;
                        else if (typeof object.totalNumberOfFourStarsRatings === "object")
                            message.totalNumberOfFourStarsRatings = new $util.LongBits(object.totalNumberOfFourStarsRatings.low >>> 0, object.totalNumberOfFourStarsRatings.high >>> 0).toNumber();
                    if (object.totalNumberOfThreeStarsRatings != null)
                        if ($util.Long)
                            (message.totalNumberOfThreeStarsRatings = $util.Long.fromValue(object.totalNumberOfThreeStarsRatings)).unsigned = false;
                        else if (typeof object.totalNumberOfThreeStarsRatings === "string")
                            message.totalNumberOfThreeStarsRatings = parseInt(object.totalNumberOfThreeStarsRatings, 10);
                        else if (typeof object.totalNumberOfThreeStarsRatings === "number")
                            message.totalNumberOfThreeStarsRatings = object.totalNumberOfThreeStarsRatings;
                        else if (typeof object.totalNumberOfThreeStarsRatings === "object")
                            message.totalNumberOfThreeStarsRatings = new $util.LongBits(object.totalNumberOfThreeStarsRatings.low >>> 0, object.totalNumberOfThreeStarsRatings.high >>> 0).toNumber();
                    if (object.totalNumberOfTwoStarsRatings != null)
                        if ($util.Long)
                            (message.totalNumberOfTwoStarsRatings = $util.Long.fromValue(object.totalNumberOfTwoStarsRatings)).unsigned = false;
                        else if (typeof object.totalNumberOfTwoStarsRatings === "string")
                            message.totalNumberOfTwoStarsRatings = parseInt(object.totalNumberOfTwoStarsRatings, 10);
                        else if (typeof object.totalNumberOfTwoStarsRatings === "number")
                            message.totalNumberOfTwoStarsRatings = object.totalNumberOfTwoStarsRatings;
                        else if (typeof object.totalNumberOfTwoStarsRatings === "object")
                            message.totalNumberOfTwoStarsRatings = new $util.LongBits(object.totalNumberOfTwoStarsRatings.low >>> 0, object.totalNumberOfTwoStarsRatings.high >>> 0).toNumber();
                    if (object.totalNumberOfOneStarRatings != null)
                        if ($util.Long)
                            (message.totalNumberOfOneStarRatings = $util.Long.fromValue(object.totalNumberOfOneStarRatings)).unsigned = false;
                        else if (typeof object.totalNumberOfOneStarRatings === "string")
                            message.totalNumberOfOneStarRatings = parseInt(object.totalNumberOfOneStarRatings, 10);
                        else if (typeof object.totalNumberOfOneStarRatings === "number")
                            message.totalNumberOfOneStarRatings = object.totalNumberOfOneStarRatings;
                        else if (typeof object.totalNumberOfOneStarRatings === "object")
                            message.totalNumberOfOneStarRatings = new $util.LongBits(object.totalNumberOfOneStarRatings.low >>> 0, object.totalNumberOfOneStarRatings.high >>> 0).toNumber();
                    return message;
                };

                /**
                 * Creates a plain object from a RedundantDataProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.AnalyticsProto.RedundantDataProto
                 * @static
                 * @param {waiternow.common.AnalyticsProto.RedundantDataProto} message RedundantDataProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                RedundantDataProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.totalNumberOfRequests = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.totalNumberOfRequests = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.totalNumberOfCheckIns = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.totalNumberOfCheckIns = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.totalNumberOfPaidOrders = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.totalNumberOfPaidOrders = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.totalNumberOfThumbsUp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.totalNumberOfThumbsUp = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.totalNumberOfThumbsDown = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.totalNumberOfThumbsDown = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.totalNumberOfFiveStarsRatings = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.totalNumberOfFiveStarsRatings = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.totalNumberOfFourStarsRatings = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.totalNumberOfFourStarsRatings = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.totalNumberOfThreeStarsRatings = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.totalNumberOfThreeStarsRatings = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.totalNumberOfTwoStarsRatings = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.totalNumberOfTwoStarsRatings = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.totalNumberOfOneStarRatings = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.totalNumberOfOneStarRatings = options.longs === String ? "0" : 0;
                    }
                    if (message.totalNumberOfRequests != null && message.hasOwnProperty("totalNumberOfRequests"))
                        if (typeof message.totalNumberOfRequests === "number")
                            object.totalNumberOfRequests = options.longs === String ? String(message.totalNumberOfRequests) : message.totalNumberOfRequests;
                        else
                            object.totalNumberOfRequests = options.longs === String ? $util.Long.prototype.toString.call(message.totalNumberOfRequests) : options.longs === Number ? new $util.LongBits(message.totalNumberOfRequests.low >>> 0, message.totalNumberOfRequests.high >>> 0).toNumber() : message.totalNumberOfRequests;
                    if (message.totalNumberOfCheckIns != null && message.hasOwnProperty("totalNumberOfCheckIns"))
                        if (typeof message.totalNumberOfCheckIns === "number")
                            object.totalNumberOfCheckIns = options.longs === String ? String(message.totalNumberOfCheckIns) : message.totalNumberOfCheckIns;
                        else
                            object.totalNumberOfCheckIns = options.longs === String ? $util.Long.prototype.toString.call(message.totalNumberOfCheckIns) : options.longs === Number ? new $util.LongBits(message.totalNumberOfCheckIns.low >>> 0, message.totalNumberOfCheckIns.high >>> 0).toNumber() : message.totalNumberOfCheckIns;
                    if (message.totalNumberOfPaidOrders != null && message.hasOwnProperty("totalNumberOfPaidOrders"))
                        if (typeof message.totalNumberOfPaidOrders === "number")
                            object.totalNumberOfPaidOrders = options.longs === String ? String(message.totalNumberOfPaidOrders) : message.totalNumberOfPaidOrders;
                        else
                            object.totalNumberOfPaidOrders = options.longs === String ? $util.Long.prototype.toString.call(message.totalNumberOfPaidOrders) : options.longs === Number ? new $util.LongBits(message.totalNumberOfPaidOrders.low >>> 0, message.totalNumberOfPaidOrders.high >>> 0).toNumber() : message.totalNumberOfPaidOrders;
                    if (message.totalNumberOfThumbsUp != null && message.hasOwnProperty("totalNumberOfThumbsUp"))
                        if (typeof message.totalNumberOfThumbsUp === "number")
                            object.totalNumberOfThumbsUp = options.longs === String ? String(message.totalNumberOfThumbsUp) : message.totalNumberOfThumbsUp;
                        else
                            object.totalNumberOfThumbsUp = options.longs === String ? $util.Long.prototype.toString.call(message.totalNumberOfThumbsUp) : options.longs === Number ? new $util.LongBits(message.totalNumberOfThumbsUp.low >>> 0, message.totalNumberOfThumbsUp.high >>> 0).toNumber() : message.totalNumberOfThumbsUp;
                    if (message.totalNumberOfThumbsDown != null && message.hasOwnProperty("totalNumberOfThumbsDown"))
                        if (typeof message.totalNumberOfThumbsDown === "number")
                            object.totalNumberOfThumbsDown = options.longs === String ? String(message.totalNumberOfThumbsDown) : message.totalNumberOfThumbsDown;
                        else
                            object.totalNumberOfThumbsDown = options.longs === String ? $util.Long.prototype.toString.call(message.totalNumberOfThumbsDown) : options.longs === Number ? new $util.LongBits(message.totalNumberOfThumbsDown.low >>> 0, message.totalNumberOfThumbsDown.high >>> 0).toNumber() : message.totalNumberOfThumbsDown;
                    if (message.totalNumberOfFiveStarsRatings != null && message.hasOwnProperty("totalNumberOfFiveStarsRatings"))
                        if (typeof message.totalNumberOfFiveStarsRatings === "number")
                            object.totalNumberOfFiveStarsRatings = options.longs === String ? String(message.totalNumberOfFiveStarsRatings) : message.totalNumberOfFiveStarsRatings;
                        else
                            object.totalNumberOfFiveStarsRatings = options.longs === String ? $util.Long.prototype.toString.call(message.totalNumberOfFiveStarsRatings) : options.longs === Number ? new $util.LongBits(message.totalNumberOfFiveStarsRatings.low >>> 0, message.totalNumberOfFiveStarsRatings.high >>> 0).toNumber() : message.totalNumberOfFiveStarsRatings;
                    if (message.totalNumberOfFourStarsRatings != null && message.hasOwnProperty("totalNumberOfFourStarsRatings"))
                        if (typeof message.totalNumberOfFourStarsRatings === "number")
                            object.totalNumberOfFourStarsRatings = options.longs === String ? String(message.totalNumberOfFourStarsRatings) : message.totalNumberOfFourStarsRatings;
                        else
                            object.totalNumberOfFourStarsRatings = options.longs === String ? $util.Long.prototype.toString.call(message.totalNumberOfFourStarsRatings) : options.longs === Number ? new $util.LongBits(message.totalNumberOfFourStarsRatings.low >>> 0, message.totalNumberOfFourStarsRatings.high >>> 0).toNumber() : message.totalNumberOfFourStarsRatings;
                    if (message.totalNumberOfThreeStarsRatings != null && message.hasOwnProperty("totalNumberOfThreeStarsRatings"))
                        if (typeof message.totalNumberOfThreeStarsRatings === "number")
                            object.totalNumberOfThreeStarsRatings = options.longs === String ? String(message.totalNumberOfThreeStarsRatings) : message.totalNumberOfThreeStarsRatings;
                        else
                            object.totalNumberOfThreeStarsRatings = options.longs === String ? $util.Long.prototype.toString.call(message.totalNumberOfThreeStarsRatings) : options.longs === Number ? new $util.LongBits(message.totalNumberOfThreeStarsRatings.low >>> 0, message.totalNumberOfThreeStarsRatings.high >>> 0).toNumber() : message.totalNumberOfThreeStarsRatings;
                    if (message.totalNumberOfTwoStarsRatings != null && message.hasOwnProperty("totalNumberOfTwoStarsRatings"))
                        if (typeof message.totalNumberOfTwoStarsRatings === "number")
                            object.totalNumberOfTwoStarsRatings = options.longs === String ? String(message.totalNumberOfTwoStarsRatings) : message.totalNumberOfTwoStarsRatings;
                        else
                            object.totalNumberOfTwoStarsRatings = options.longs === String ? $util.Long.prototype.toString.call(message.totalNumberOfTwoStarsRatings) : options.longs === Number ? new $util.LongBits(message.totalNumberOfTwoStarsRatings.low >>> 0, message.totalNumberOfTwoStarsRatings.high >>> 0).toNumber() : message.totalNumberOfTwoStarsRatings;
                    if (message.totalNumberOfOneStarRatings != null && message.hasOwnProperty("totalNumberOfOneStarRatings"))
                        if (typeof message.totalNumberOfOneStarRatings === "number")
                            object.totalNumberOfOneStarRatings = options.longs === String ? String(message.totalNumberOfOneStarRatings) : message.totalNumberOfOneStarRatings;
                        else
                            object.totalNumberOfOneStarRatings = options.longs === String ? $util.Long.prototype.toString.call(message.totalNumberOfOneStarRatings) : options.longs === Number ? new $util.LongBits(message.totalNumberOfOneStarRatings.low >>> 0, message.totalNumberOfOneStarRatings.high >>> 0).toNumber() : message.totalNumberOfOneStarRatings;
                    return object;
                };

                /**
                 * Converts this RedundantDataProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.AnalyticsProto.RedundantDataProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                RedundantDataProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for RedundantDataProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.AnalyticsProto.RedundantDataProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                RedundantDataProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.AnalyticsProto.RedundantDataProto";
                };

                return RedundantDataProto;
            })();

            return AnalyticsProto;
        })();

        common.AuthTokenProto = (function() {

            /**
             * Properties of an AuthTokenProto.
             * @memberof waiternow.common
             * @interface IAuthTokenProto
             * @property {string|null} [value] AuthTokenProto value
             * @property {google.protobuf.ITimestamp|null} [creationTime] AuthTokenProto creationTime
             * @property {google.protobuf.IDuration|null} [expiration] AuthTokenProto expiration
             */

            /**
             * Constructs a new AuthTokenProto.
             * @memberof waiternow.common
             * @classdesc Represents an AuthTokenProto.
             * @implements IAuthTokenProto
             * @constructor
             * @param {waiternow.common.IAuthTokenProto=} [properties] Properties to set
             */
            function AuthTokenProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AuthTokenProto value.
             * @member {string} value
             * @memberof waiternow.common.AuthTokenProto
             * @instance
             */
            AuthTokenProto.prototype.value = "";

            /**
             * AuthTokenProto creationTime.
             * @member {google.protobuf.ITimestamp|null|undefined} creationTime
             * @memberof waiternow.common.AuthTokenProto
             * @instance
             */
            AuthTokenProto.prototype.creationTime = null;

            /**
             * AuthTokenProto expiration.
             * @member {google.protobuf.IDuration|null|undefined} expiration
             * @memberof waiternow.common.AuthTokenProto
             * @instance
             */
            AuthTokenProto.prototype.expiration = null;

            /**
             * Creates a new AuthTokenProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.AuthTokenProto
             * @static
             * @param {waiternow.common.IAuthTokenProto=} [properties] Properties to set
             * @returns {waiternow.common.AuthTokenProto} AuthTokenProto instance
             */
            AuthTokenProto.create = function create(properties) {
                return new AuthTokenProto(properties);
            };

            /**
             * Encodes the specified AuthTokenProto message. Does not implicitly {@link waiternow.common.AuthTokenProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.AuthTokenProto
             * @static
             * @param {waiternow.common.IAuthTokenProto} message AuthTokenProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AuthTokenProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.value);
                if (message.creationTime != null && Object.hasOwnProperty.call(message, "creationTime"))
                    $root.google.protobuf.Timestamp.encode(message.creationTime, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.expiration != null && Object.hasOwnProperty.call(message, "expiration"))
                    $root.google.protobuf.Duration.encode(message.expiration, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified AuthTokenProto message, length delimited. Does not implicitly {@link waiternow.common.AuthTokenProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.AuthTokenProto
             * @static
             * @param {waiternow.common.IAuthTokenProto} message AuthTokenProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AuthTokenProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AuthTokenProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.AuthTokenProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.AuthTokenProto} AuthTokenProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AuthTokenProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.AuthTokenProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.value = reader.string();
                            break;
                        }
                    case 2: {
                            message.creationTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 3: {
                            message.expiration = $root.google.protobuf.Duration.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AuthTokenProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.AuthTokenProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.AuthTokenProto} AuthTokenProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AuthTokenProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AuthTokenProto message.
             * @function verify
             * @memberof waiternow.common.AuthTokenProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AuthTokenProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.value != null && message.hasOwnProperty("value"))
                    if (!$util.isString(message.value))
                        return "value: string expected";
                if (message.creationTime != null && message.hasOwnProperty("creationTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.creationTime);
                    if (error)
                        return "creationTime." + error;
                }
                if (message.expiration != null && message.hasOwnProperty("expiration")) {
                    var error = $root.google.protobuf.Duration.verify(message.expiration);
                    if (error)
                        return "expiration." + error;
                }
                return null;
            };

            /**
             * Creates an AuthTokenProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.AuthTokenProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.AuthTokenProto} AuthTokenProto
             */
            AuthTokenProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.AuthTokenProto)
                    return object;
                var message = new $root.waiternow.common.AuthTokenProto();
                if (object.value != null)
                    message.value = String(object.value);
                if (object.creationTime != null) {
                    if (typeof object.creationTime !== "object")
                        throw TypeError(".waiternow.common.AuthTokenProto.creationTime: object expected");
                    message.creationTime = $root.google.protobuf.Timestamp.fromObject(object.creationTime);
                }
                if (object.expiration != null) {
                    if (typeof object.expiration !== "object")
                        throw TypeError(".waiternow.common.AuthTokenProto.expiration: object expected");
                    message.expiration = $root.google.protobuf.Duration.fromObject(object.expiration);
                }
                return message;
            };

            /**
             * Creates a plain object from an AuthTokenProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.AuthTokenProto
             * @static
             * @param {waiternow.common.AuthTokenProto} message AuthTokenProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AuthTokenProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.value = "";
                    object.creationTime = null;
                    object.expiration = null;
                }
                if (message.value != null && message.hasOwnProperty("value"))
                    object.value = message.value;
                if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                    object.creationTime = $root.google.protobuf.Timestamp.toObject(message.creationTime, options);
                if (message.expiration != null && message.hasOwnProperty("expiration"))
                    object.expiration = $root.google.protobuf.Duration.toObject(message.expiration, options);
                return object;
            };

            /**
             * Converts this AuthTokenProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.AuthTokenProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AuthTokenProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for AuthTokenProto
             * @function getTypeUrl
             * @memberof waiternow.common.AuthTokenProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            AuthTokenProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.AuthTokenProto";
            };

            return AuthTokenProto;
        })();

        common.AuthUserProto = (function() {

            /**
             * Properties of an AuthUserProto.
             * @memberof waiternow.common
             * @interface IAuthUserProto
             * @property {string|null} [userId] AuthUserProto userId
             */

            /**
             * Constructs a new AuthUserProto.
             * @memberof waiternow.common
             * @classdesc Represents an AuthUserProto.
             * @implements IAuthUserProto
             * @constructor
             * @param {waiternow.common.IAuthUserProto=} [properties] Properties to set
             */
            function AuthUserProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AuthUserProto userId.
             * @member {string} userId
             * @memberof waiternow.common.AuthUserProto
             * @instance
             */
            AuthUserProto.prototype.userId = "";

            /**
             * Creates a new AuthUserProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.AuthUserProto
             * @static
             * @param {waiternow.common.IAuthUserProto=} [properties] Properties to set
             * @returns {waiternow.common.AuthUserProto} AuthUserProto instance
             */
            AuthUserProto.create = function create(properties) {
                return new AuthUserProto(properties);
            };

            /**
             * Encodes the specified AuthUserProto message. Does not implicitly {@link waiternow.common.AuthUserProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.AuthUserProto
             * @static
             * @param {waiternow.common.IAuthUserProto} message AuthUserProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AuthUserProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.userId);
                return writer;
            };

            /**
             * Encodes the specified AuthUserProto message, length delimited. Does not implicitly {@link waiternow.common.AuthUserProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.AuthUserProto
             * @static
             * @param {waiternow.common.IAuthUserProto} message AuthUserProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AuthUserProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AuthUserProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.AuthUserProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.AuthUserProto} AuthUserProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AuthUserProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.AuthUserProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.userId = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AuthUserProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.AuthUserProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.AuthUserProto} AuthUserProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AuthUserProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AuthUserProto message.
             * @function verify
             * @memberof waiternow.common.AuthUserProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AuthUserProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.userId != null && message.hasOwnProperty("userId"))
                    if (!$util.isString(message.userId))
                        return "userId: string expected";
                return null;
            };

            /**
             * Creates an AuthUserProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.AuthUserProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.AuthUserProto} AuthUserProto
             */
            AuthUserProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.AuthUserProto)
                    return object;
                var message = new $root.waiternow.common.AuthUserProto();
                if (object.userId != null)
                    message.userId = String(object.userId);
                return message;
            };

            /**
             * Creates a plain object from an AuthUserProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.AuthUserProto
             * @static
             * @param {waiternow.common.AuthUserProto} message AuthUserProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AuthUserProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.userId = "";
                if (message.userId != null && message.hasOwnProperty("userId"))
                    object.userId = message.userId;
                return object;
            };

            /**
             * Converts this AuthUserProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.AuthUserProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AuthUserProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for AuthUserProto
             * @function getTypeUrl
             * @memberof waiternow.common.AuthUserProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            AuthUserProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.AuthUserProto";
            };

            return AuthUserProto;
        })();

        common.BillProto = (function() {

            /**
             * Properties of a BillProto.
             * @memberof waiternow.common
             * @interface IBillProto
             * @property {string|null} [id] BillProto id
             * @property {google.protobuf.ITimestamp|null} [creationTime] BillProto creationTime
             * @property {google.protobuf.ITimestamp|null} [lastUpdateTime] BillProto lastUpdateTime
             * @property {number|null} [billNumber] BillProto billNumber
             * @property {string|null} [businessId] BillProto businessId
             * @property {string|null} [businessName] BillProto businessName
             * @property {string|null} [businessOfficialId] BillProto businessOfficialId
             * @property {waiternow.common.IAddressProto|null} [billingAddress] BillProto billingAddress
             * @property {waiternow.common.IPeriodProto|null} [period] BillProto period
             * @property {Array.<waiternow.common.BillProto.ILocationBillProto>|null} [locationBills] BillProto locationBills
             * @property {waiternow.common.IMoneyProto|null} [subtotal] BillProto subtotal
             * @property {waiternow.common.BillProto.IDiscountProto|null} [discountTotal] BillProto discountTotal
             * @property {waiternow.common.ITaxesProto|null} [taxes] BillProto taxes
             * @property {waiternow.common.IMoneyProto|null} [total] BillProto total
             * @property {waiternow.common.BillProto.IStatusProto|null} [status] BillProto status
             */

            /**
             * Constructs a new BillProto.
             * @memberof waiternow.common
             * @classdesc Represents a BillProto.
             * @implements IBillProto
             * @constructor
             * @param {waiternow.common.IBillProto=} [properties] Properties to set
             */
            function BillProto(properties) {
                this.locationBills = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * BillProto id.
             * @member {string} id
             * @memberof waiternow.common.BillProto
             * @instance
             */
            BillProto.prototype.id = "";

            /**
             * BillProto creationTime.
             * @member {google.protobuf.ITimestamp|null|undefined} creationTime
             * @memberof waiternow.common.BillProto
             * @instance
             */
            BillProto.prototype.creationTime = null;

            /**
             * BillProto lastUpdateTime.
             * @member {google.protobuf.ITimestamp|null|undefined} lastUpdateTime
             * @memberof waiternow.common.BillProto
             * @instance
             */
            BillProto.prototype.lastUpdateTime = null;

            /**
             * BillProto billNumber.
             * @member {number} billNumber
             * @memberof waiternow.common.BillProto
             * @instance
             */
            BillProto.prototype.billNumber = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * BillProto businessId.
             * @member {string} businessId
             * @memberof waiternow.common.BillProto
             * @instance
             */
            BillProto.prototype.businessId = "";

            /**
             * BillProto businessName.
             * @member {string} businessName
             * @memberof waiternow.common.BillProto
             * @instance
             */
            BillProto.prototype.businessName = "";

            /**
             * BillProto businessOfficialId.
             * @member {string} businessOfficialId
             * @memberof waiternow.common.BillProto
             * @instance
             */
            BillProto.prototype.businessOfficialId = "";

            /**
             * BillProto billingAddress.
             * @member {waiternow.common.IAddressProto|null|undefined} billingAddress
             * @memberof waiternow.common.BillProto
             * @instance
             */
            BillProto.prototype.billingAddress = null;

            /**
             * BillProto period.
             * @member {waiternow.common.IPeriodProto|null|undefined} period
             * @memberof waiternow.common.BillProto
             * @instance
             */
            BillProto.prototype.period = null;

            /**
             * BillProto locationBills.
             * @member {Array.<waiternow.common.BillProto.ILocationBillProto>} locationBills
             * @memberof waiternow.common.BillProto
             * @instance
             */
            BillProto.prototype.locationBills = $util.emptyArray;

            /**
             * BillProto subtotal.
             * @member {waiternow.common.IMoneyProto|null|undefined} subtotal
             * @memberof waiternow.common.BillProto
             * @instance
             */
            BillProto.prototype.subtotal = null;

            /**
             * BillProto discountTotal.
             * @member {waiternow.common.BillProto.IDiscountProto|null|undefined} discountTotal
             * @memberof waiternow.common.BillProto
             * @instance
             */
            BillProto.prototype.discountTotal = null;

            /**
             * BillProto taxes.
             * @member {waiternow.common.ITaxesProto|null|undefined} taxes
             * @memberof waiternow.common.BillProto
             * @instance
             */
            BillProto.prototype.taxes = null;

            /**
             * BillProto total.
             * @member {waiternow.common.IMoneyProto|null|undefined} total
             * @memberof waiternow.common.BillProto
             * @instance
             */
            BillProto.prototype.total = null;

            /**
             * BillProto status.
             * @member {waiternow.common.BillProto.IStatusProto|null|undefined} status
             * @memberof waiternow.common.BillProto
             * @instance
             */
            BillProto.prototype.status = null;

            /**
             * Creates a new BillProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.BillProto
             * @static
             * @param {waiternow.common.IBillProto=} [properties] Properties to set
             * @returns {waiternow.common.BillProto} BillProto instance
             */
            BillProto.create = function create(properties) {
                return new BillProto(properties);
            };

            /**
             * Encodes the specified BillProto message. Does not implicitly {@link waiternow.common.BillProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.BillProto
             * @static
             * @param {waiternow.common.IBillProto} message BillProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BillProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                if (message.billNumber != null && Object.hasOwnProperty.call(message, "billNumber"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int64(message.billNumber);
                if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.businessId);
                if (message.businessName != null && Object.hasOwnProperty.call(message, "businessName"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.businessName);
                if (message.businessOfficialId != null && Object.hasOwnProperty.call(message, "businessOfficialId"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.businessOfficialId);
                if (message.billingAddress != null && Object.hasOwnProperty.call(message, "billingAddress"))
                    $root.waiternow.common.AddressProto.encode(message.billingAddress, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                if (message.period != null && Object.hasOwnProperty.call(message, "period"))
                    $root.waiternow.common.PeriodProto.encode(message.period, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                if (message.locationBills != null && message.locationBills.length)
                    for (var i = 0; i < message.locationBills.length; ++i)
                        $root.waiternow.common.BillProto.LocationBillProto.encode(message.locationBills[i], writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                if (message.subtotal != null && Object.hasOwnProperty.call(message, "subtotal"))
                    $root.waiternow.common.MoneyProto.encode(message.subtotal, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                if (message.discountTotal != null && Object.hasOwnProperty.call(message, "discountTotal"))
                    $root.waiternow.common.BillProto.DiscountProto.encode(message.discountTotal, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                if (message.taxes != null && Object.hasOwnProperty.call(message, "taxes"))
                    $root.waiternow.common.TaxesProto.encode(message.taxes, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                if (message.total != null && Object.hasOwnProperty.call(message, "total"))
                    $root.waiternow.common.MoneyProto.encode(message.total, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                    $root.waiternow.common.BillProto.StatusProto.encode(message.status, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
                if (message.creationTime != null && Object.hasOwnProperty.call(message, "creationTime"))
                    $root.google.protobuf.Timestamp.encode(message.creationTime, writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
                if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                    $root.google.protobuf.Timestamp.encode(message.lastUpdateTime, writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified BillProto message, length delimited. Does not implicitly {@link waiternow.common.BillProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.BillProto
             * @static
             * @param {waiternow.common.IBillProto} message BillProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BillProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a BillProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.BillProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.BillProto} BillProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BillProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.BillProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.id = reader.string();
                            break;
                        }
                    case 14: {
                            message.creationTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 15: {
                            message.lastUpdateTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 2: {
                            message.billNumber = reader.int64();
                            break;
                        }
                    case 3: {
                            message.businessId = reader.string();
                            break;
                        }
                    case 4: {
                            message.businessName = reader.string();
                            break;
                        }
                    case 5: {
                            message.businessOfficialId = reader.string();
                            break;
                        }
                    case 6: {
                            message.billingAddress = $root.waiternow.common.AddressProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 7: {
                            message.period = $root.waiternow.common.PeriodProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 8: {
                            if (!(message.locationBills && message.locationBills.length))
                                message.locationBills = [];
                            message.locationBills.push($root.waiternow.common.BillProto.LocationBillProto.decode(reader, reader.uint32()));
                            break;
                        }
                    case 9: {
                            message.subtotal = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 10: {
                            message.discountTotal = $root.waiternow.common.BillProto.DiscountProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 11: {
                            message.taxes = $root.waiternow.common.TaxesProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 12: {
                            message.total = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 13: {
                            message.status = $root.waiternow.common.BillProto.StatusProto.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a BillProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.BillProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.BillProto} BillProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BillProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a BillProto message.
             * @function verify
             * @memberof waiternow.common.BillProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            BillProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.id != null && message.hasOwnProperty("id"))
                    if (!$util.isString(message.id))
                        return "id: string expected";
                if (message.creationTime != null && message.hasOwnProperty("creationTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.creationTime);
                    if (error)
                        return "creationTime." + error;
                }
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.lastUpdateTime);
                    if (error)
                        return "lastUpdateTime." + error;
                }
                if (message.billNumber != null && message.hasOwnProperty("billNumber"))
                    if (!$util.isInteger(message.billNumber) && !(message.billNumber && $util.isInteger(message.billNumber.low) && $util.isInteger(message.billNumber.high)))
                        return "billNumber: integer|Long expected";
                if (message.businessId != null && message.hasOwnProperty("businessId"))
                    if (!$util.isString(message.businessId))
                        return "businessId: string expected";
                if (message.businessName != null && message.hasOwnProperty("businessName"))
                    if (!$util.isString(message.businessName))
                        return "businessName: string expected";
                if (message.businessOfficialId != null && message.hasOwnProperty("businessOfficialId"))
                    if (!$util.isString(message.businessOfficialId))
                        return "businessOfficialId: string expected";
                if (message.billingAddress != null && message.hasOwnProperty("billingAddress")) {
                    var error = $root.waiternow.common.AddressProto.verify(message.billingAddress);
                    if (error)
                        return "billingAddress." + error;
                }
                if (message.period != null && message.hasOwnProperty("period")) {
                    var error = $root.waiternow.common.PeriodProto.verify(message.period);
                    if (error)
                        return "period." + error;
                }
                if (message.locationBills != null && message.hasOwnProperty("locationBills")) {
                    if (!Array.isArray(message.locationBills))
                        return "locationBills: array expected";
                    for (var i = 0; i < message.locationBills.length; ++i) {
                        var error = $root.waiternow.common.BillProto.LocationBillProto.verify(message.locationBills[i]);
                        if (error)
                            return "locationBills." + error;
                    }
                }
                if (message.subtotal != null && message.hasOwnProperty("subtotal")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.subtotal);
                    if (error)
                        return "subtotal." + error;
                }
                if (message.discountTotal != null && message.hasOwnProperty("discountTotal")) {
                    var error = $root.waiternow.common.BillProto.DiscountProto.verify(message.discountTotal);
                    if (error)
                        return "discountTotal." + error;
                }
                if (message.taxes != null && message.hasOwnProperty("taxes")) {
                    var error = $root.waiternow.common.TaxesProto.verify(message.taxes);
                    if (error)
                        return "taxes." + error;
                }
                if (message.total != null && message.hasOwnProperty("total")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.total);
                    if (error)
                        return "total." + error;
                }
                if (message.status != null && message.hasOwnProperty("status")) {
                    var error = $root.waiternow.common.BillProto.StatusProto.verify(message.status);
                    if (error)
                        return "status." + error;
                }
                return null;
            };

            /**
             * Creates a BillProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.BillProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.BillProto} BillProto
             */
            BillProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.BillProto)
                    return object;
                var message = new $root.waiternow.common.BillProto();
                if (object.id != null)
                    message.id = String(object.id);
                if (object.creationTime != null) {
                    if (typeof object.creationTime !== "object")
                        throw TypeError(".waiternow.common.BillProto.creationTime: object expected");
                    message.creationTime = $root.google.protobuf.Timestamp.fromObject(object.creationTime);
                }
                if (object.lastUpdateTime != null) {
                    if (typeof object.lastUpdateTime !== "object")
                        throw TypeError(".waiternow.common.BillProto.lastUpdateTime: object expected");
                    message.lastUpdateTime = $root.google.protobuf.Timestamp.fromObject(object.lastUpdateTime);
                }
                if (object.billNumber != null)
                    if ($util.Long)
                        (message.billNumber = $util.Long.fromValue(object.billNumber)).unsigned = false;
                    else if (typeof object.billNumber === "string")
                        message.billNumber = parseInt(object.billNumber, 10);
                    else if (typeof object.billNumber === "number")
                        message.billNumber = object.billNumber;
                    else if (typeof object.billNumber === "object")
                        message.billNumber = new $util.LongBits(object.billNumber.low >>> 0, object.billNumber.high >>> 0).toNumber();
                if (object.businessId != null)
                    message.businessId = String(object.businessId);
                if (object.businessName != null)
                    message.businessName = String(object.businessName);
                if (object.businessOfficialId != null)
                    message.businessOfficialId = String(object.businessOfficialId);
                if (object.billingAddress != null) {
                    if (typeof object.billingAddress !== "object")
                        throw TypeError(".waiternow.common.BillProto.billingAddress: object expected");
                    message.billingAddress = $root.waiternow.common.AddressProto.fromObject(object.billingAddress);
                }
                if (object.period != null) {
                    if (typeof object.period !== "object")
                        throw TypeError(".waiternow.common.BillProto.period: object expected");
                    message.period = $root.waiternow.common.PeriodProto.fromObject(object.period);
                }
                if (object.locationBills) {
                    if (!Array.isArray(object.locationBills))
                        throw TypeError(".waiternow.common.BillProto.locationBills: array expected");
                    message.locationBills = [];
                    for (var i = 0; i < object.locationBills.length; ++i) {
                        if (typeof object.locationBills[i] !== "object")
                            throw TypeError(".waiternow.common.BillProto.locationBills: object expected");
                        message.locationBills[i] = $root.waiternow.common.BillProto.LocationBillProto.fromObject(object.locationBills[i]);
                    }
                }
                if (object.subtotal != null) {
                    if (typeof object.subtotal !== "object")
                        throw TypeError(".waiternow.common.BillProto.subtotal: object expected");
                    message.subtotal = $root.waiternow.common.MoneyProto.fromObject(object.subtotal);
                }
                if (object.discountTotal != null) {
                    if (typeof object.discountTotal !== "object")
                        throw TypeError(".waiternow.common.BillProto.discountTotal: object expected");
                    message.discountTotal = $root.waiternow.common.BillProto.DiscountProto.fromObject(object.discountTotal);
                }
                if (object.taxes != null) {
                    if (typeof object.taxes !== "object")
                        throw TypeError(".waiternow.common.BillProto.taxes: object expected");
                    message.taxes = $root.waiternow.common.TaxesProto.fromObject(object.taxes);
                }
                if (object.total != null) {
                    if (typeof object.total !== "object")
                        throw TypeError(".waiternow.common.BillProto.total: object expected");
                    message.total = $root.waiternow.common.MoneyProto.fromObject(object.total);
                }
                if (object.status != null) {
                    if (typeof object.status !== "object")
                        throw TypeError(".waiternow.common.BillProto.status: object expected");
                    message.status = $root.waiternow.common.BillProto.StatusProto.fromObject(object.status);
                }
                return message;
            };

            /**
             * Creates a plain object from a BillProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.BillProto
             * @static
             * @param {waiternow.common.BillProto} message BillProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            BillProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.locationBills = [];
                if (options.defaults) {
                    object.id = "";
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.billNumber = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.billNumber = options.longs === String ? "0" : 0;
                    object.businessId = "";
                    object.businessName = "";
                    object.businessOfficialId = "";
                    object.billingAddress = null;
                    object.period = null;
                    object.subtotal = null;
                    object.discountTotal = null;
                    object.taxes = null;
                    object.total = null;
                    object.status = null;
                    object.creationTime = null;
                    object.lastUpdateTime = null;
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                if (message.billNumber != null && message.hasOwnProperty("billNumber"))
                    if (typeof message.billNumber === "number")
                        object.billNumber = options.longs === String ? String(message.billNumber) : message.billNumber;
                    else
                        object.billNumber = options.longs === String ? $util.Long.prototype.toString.call(message.billNumber) : options.longs === Number ? new $util.LongBits(message.billNumber.low >>> 0, message.billNumber.high >>> 0).toNumber() : message.billNumber;
                if (message.businessId != null && message.hasOwnProperty("businessId"))
                    object.businessId = message.businessId;
                if (message.businessName != null && message.hasOwnProperty("businessName"))
                    object.businessName = message.businessName;
                if (message.businessOfficialId != null && message.hasOwnProperty("businessOfficialId"))
                    object.businessOfficialId = message.businessOfficialId;
                if (message.billingAddress != null && message.hasOwnProperty("billingAddress"))
                    object.billingAddress = $root.waiternow.common.AddressProto.toObject(message.billingAddress, options);
                if (message.period != null && message.hasOwnProperty("period"))
                    object.period = $root.waiternow.common.PeriodProto.toObject(message.period, options);
                if (message.locationBills && message.locationBills.length) {
                    object.locationBills = [];
                    for (var j = 0; j < message.locationBills.length; ++j)
                        object.locationBills[j] = $root.waiternow.common.BillProto.LocationBillProto.toObject(message.locationBills[j], options);
                }
                if (message.subtotal != null && message.hasOwnProperty("subtotal"))
                    object.subtotal = $root.waiternow.common.MoneyProto.toObject(message.subtotal, options);
                if (message.discountTotal != null && message.hasOwnProperty("discountTotal"))
                    object.discountTotal = $root.waiternow.common.BillProto.DiscountProto.toObject(message.discountTotal, options);
                if (message.taxes != null && message.hasOwnProperty("taxes"))
                    object.taxes = $root.waiternow.common.TaxesProto.toObject(message.taxes, options);
                if (message.total != null && message.hasOwnProperty("total"))
                    object.total = $root.waiternow.common.MoneyProto.toObject(message.total, options);
                if (message.status != null && message.hasOwnProperty("status"))
                    object.status = $root.waiternow.common.BillProto.StatusProto.toObject(message.status, options);
                if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                    object.creationTime = $root.google.protobuf.Timestamp.toObject(message.creationTime, options);
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                    object.lastUpdateTime = $root.google.protobuf.Timestamp.toObject(message.lastUpdateTime, options);
                return object;
            };

            /**
             * Converts this BillProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.BillProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            BillProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for BillProto
             * @function getTypeUrl
             * @memberof waiternow.common.BillProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            BillProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.BillProto";
            };

            BillProto.DiscountProto = (function() {

                /**
                 * Properties of a DiscountProto.
                 * @memberof waiternow.common.BillProto
                 * @interface IDiscountProto
                 * @property {waiternow.common.IMoneyProto|null} [amount] DiscountProto amount
                 * @property {string|null} [description] DiscountProto description
                 */

                /**
                 * Constructs a new DiscountProto.
                 * @memberof waiternow.common.BillProto
                 * @classdesc Represents a DiscountProto.
                 * @implements IDiscountProto
                 * @constructor
                 * @param {waiternow.common.BillProto.IDiscountProto=} [properties] Properties to set
                 */
                function DiscountProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * DiscountProto amount.
                 * @member {waiternow.common.IMoneyProto|null|undefined} amount
                 * @memberof waiternow.common.BillProto.DiscountProto
                 * @instance
                 */
                DiscountProto.prototype.amount = null;

                /**
                 * DiscountProto description.
                 * @member {string} description
                 * @memberof waiternow.common.BillProto.DiscountProto
                 * @instance
                 */
                DiscountProto.prototype.description = "";

                /**
                 * Creates a new DiscountProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.BillProto.DiscountProto
                 * @static
                 * @param {waiternow.common.BillProto.IDiscountProto=} [properties] Properties to set
                 * @returns {waiternow.common.BillProto.DiscountProto} DiscountProto instance
                 */
                DiscountProto.create = function create(properties) {
                    return new DiscountProto(properties);
                };

                /**
                 * Encodes the specified DiscountProto message. Does not implicitly {@link waiternow.common.BillProto.DiscountProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.BillProto.DiscountProto
                 * @static
                 * @param {waiternow.common.BillProto.IDiscountProto} message DiscountProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DiscountProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                        $root.waiternow.common.MoneyProto.encode(message.amount, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.description);
                    return writer;
                };

                /**
                 * Encodes the specified DiscountProto message, length delimited. Does not implicitly {@link waiternow.common.BillProto.DiscountProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.BillProto.DiscountProto
                 * @static
                 * @param {waiternow.common.BillProto.IDiscountProto} message DiscountProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DiscountProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a DiscountProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.BillProto.DiscountProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.BillProto.DiscountProto} DiscountProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DiscountProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.BillProto.DiscountProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.amount = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.description = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a DiscountProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.BillProto.DiscountProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.BillProto.DiscountProto} DiscountProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DiscountProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a DiscountProto message.
                 * @function verify
                 * @memberof waiternow.common.BillProto.DiscountProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                DiscountProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.amount != null && message.hasOwnProperty("amount")) {
                        var error = $root.waiternow.common.MoneyProto.verify(message.amount);
                        if (error)
                            return "amount." + error;
                    }
                    if (message.description != null && message.hasOwnProperty("description"))
                        if (!$util.isString(message.description))
                            return "description: string expected";
                    return null;
                };

                /**
                 * Creates a DiscountProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.BillProto.DiscountProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.BillProto.DiscountProto} DiscountProto
                 */
                DiscountProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.BillProto.DiscountProto)
                        return object;
                    var message = new $root.waiternow.common.BillProto.DiscountProto();
                    if (object.amount != null) {
                        if (typeof object.amount !== "object")
                            throw TypeError(".waiternow.common.BillProto.DiscountProto.amount: object expected");
                        message.amount = $root.waiternow.common.MoneyProto.fromObject(object.amount);
                    }
                    if (object.description != null)
                        message.description = String(object.description);
                    return message;
                };

                /**
                 * Creates a plain object from a DiscountProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.BillProto.DiscountProto
                 * @static
                 * @param {waiternow.common.BillProto.DiscountProto} message DiscountProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                DiscountProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.amount = null;
                        object.description = "";
                    }
                    if (message.amount != null && message.hasOwnProperty("amount"))
                        object.amount = $root.waiternow.common.MoneyProto.toObject(message.amount, options);
                    if (message.description != null && message.hasOwnProperty("description"))
                        object.description = message.description;
                    return object;
                };

                /**
                 * Converts this DiscountProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.BillProto.DiscountProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                DiscountProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for DiscountProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.BillProto.DiscountProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                DiscountProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.BillProto.DiscountProto";
                };

                return DiscountProto;
            })();

            BillProto.LocationBillProto = (function() {

                /**
                 * Properties of a LocationBillProto.
                 * @memberof waiternow.common.BillProto
                 * @interface ILocationBillProto
                 * @property {string|null} [locationId] LocationBillProto locationId
                 * @property {string|null} [locationName] LocationBillProto locationName
                 * @property {waiternow.common.IAddressProto|null} [locationAddress] LocationBillProto locationAddress
                 * @property {waiternow.common.ITimestampRangeProto|null} [period] LocationBillProto period
                 * @property {number|null} [numberOfPointsOfService] LocationBillProto numberOfPointsOfService
                 * @property {number|null} [numberOfRequests] LocationBillProto numberOfRequests
                 * @property {waiternow.common.IMoneyProto|null} [charges] LocationBillProto charges
                 * @property {Array.<waiternow.common.BillProto.IDiscountProto>|null} [discounts] LocationBillProto discounts
                 */

                /**
                 * Constructs a new LocationBillProto.
                 * @memberof waiternow.common.BillProto
                 * @classdesc Represents a LocationBillProto.
                 * @implements ILocationBillProto
                 * @constructor
                 * @param {waiternow.common.BillProto.ILocationBillProto=} [properties] Properties to set
                 */
                function LocationBillProto(properties) {
                    this.discounts = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * LocationBillProto locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.BillProto.LocationBillProto
                 * @instance
                 */
                LocationBillProto.prototype.locationId = "";

                /**
                 * LocationBillProto locationName.
                 * @member {string} locationName
                 * @memberof waiternow.common.BillProto.LocationBillProto
                 * @instance
                 */
                LocationBillProto.prototype.locationName = "";

                /**
                 * LocationBillProto locationAddress.
                 * @member {waiternow.common.IAddressProto|null|undefined} locationAddress
                 * @memberof waiternow.common.BillProto.LocationBillProto
                 * @instance
                 */
                LocationBillProto.prototype.locationAddress = null;

                /**
                 * LocationBillProto period.
                 * @member {waiternow.common.ITimestampRangeProto|null|undefined} period
                 * @memberof waiternow.common.BillProto.LocationBillProto
                 * @instance
                 */
                LocationBillProto.prototype.period = null;

                /**
                 * LocationBillProto numberOfPointsOfService.
                 * @member {number} numberOfPointsOfService
                 * @memberof waiternow.common.BillProto.LocationBillProto
                 * @instance
                 */
                LocationBillProto.prototype.numberOfPointsOfService = 0;

                /**
                 * LocationBillProto numberOfRequests.
                 * @member {number} numberOfRequests
                 * @memberof waiternow.common.BillProto.LocationBillProto
                 * @instance
                 */
                LocationBillProto.prototype.numberOfRequests = 0;

                /**
                 * LocationBillProto charges.
                 * @member {waiternow.common.IMoneyProto|null|undefined} charges
                 * @memberof waiternow.common.BillProto.LocationBillProto
                 * @instance
                 */
                LocationBillProto.prototype.charges = null;

                /**
                 * LocationBillProto discounts.
                 * @member {Array.<waiternow.common.BillProto.IDiscountProto>} discounts
                 * @memberof waiternow.common.BillProto.LocationBillProto
                 * @instance
                 */
                LocationBillProto.prototype.discounts = $util.emptyArray;

                /**
                 * Creates a new LocationBillProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.BillProto.LocationBillProto
                 * @static
                 * @param {waiternow.common.BillProto.ILocationBillProto=} [properties] Properties to set
                 * @returns {waiternow.common.BillProto.LocationBillProto} LocationBillProto instance
                 */
                LocationBillProto.create = function create(properties) {
                    return new LocationBillProto(properties);
                };

                /**
                 * Encodes the specified LocationBillProto message. Does not implicitly {@link waiternow.common.BillProto.LocationBillProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.BillProto.LocationBillProto
                 * @static
                 * @param {waiternow.common.BillProto.ILocationBillProto} message LocationBillProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LocationBillProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    if (message.locationName != null && Object.hasOwnProperty.call(message, "locationName"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.locationName);
                    if (message.locationAddress != null && Object.hasOwnProperty.call(message, "locationAddress"))
                        $root.waiternow.common.AddressProto.encode(message.locationAddress, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.period != null && Object.hasOwnProperty.call(message, "period"))
                        $root.waiternow.common.TimestampRangeProto.encode(message.period, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.numberOfPointsOfService != null && Object.hasOwnProperty.call(message, "numberOfPointsOfService"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int32(message.numberOfPointsOfService);
                    if (message.numberOfRequests != null && Object.hasOwnProperty.call(message, "numberOfRequests"))
                        writer.uint32(/* id 6, wireType 0 =*/48).int32(message.numberOfRequests);
                    if (message.charges != null && Object.hasOwnProperty.call(message, "charges"))
                        $root.waiternow.common.MoneyProto.encode(message.charges, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    if (message.discounts != null && message.discounts.length)
                        for (var i = 0; i < message.discounts.length; ++i)
                            $root.waiternow.common.BillProto.DiscountProto.encode(message.discounts[i], writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified LocationBillProto message, length delimited. Does not implicitly {@link waiternow.common.BillProto.LocationBillProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.BillProto.LocationBillProto
                 * @static
                 * @param {waiternow.common.BillProto.ILocationBillProto} message LocationBillProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LocationBillProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a LocationBillProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.BillProto.LocationBillProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.BillProto.LocationBillProto} LocationBillProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LocationBillProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.BillProto.LocationBillProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 2: {
                                message.locationName = reader.string();
                                break;
                            }
                        case 3: {
                                message.locationAddress = $root.waiternow.common.AddressProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 4: {
                                message.period = $root.waiternow.common.TimestampRangeProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 5: {
                                message.numberOfPointsOfService = reader.int32();
                                break;
                            }
                        case 6: {
                                message.numberOfRequests = reader.int32();
                                break;
                            }
                        case 7: {
                                message.charges = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 8: {
                                if (!(message.discounts && message.discounts.length))
                                    message.discounts = [];
                                message.discounts.push($root.waiternow.common.BillProto.DiscountProto.decode(reader, reader.uint32()));
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a LocationBillProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.BillProto.LocationBillProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.BillProto.LocationBillProto} LocationBillProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LocationBillProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a LocationBillProto message.
                 * @function verify
                 * @memberof waiternow.common.BillProto.LocationBillProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                LocationBillProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    if (message.locationName != null && message.hasOwnProperty("locationName"))
                        if (!$util.isString(message.locationName))
                            return "locationName: string expected";
                    if (message.locationAddress != null && message.hasOwnProperty("locationAddress")) {
                        var error = $root.waiternow.common.AddressProto.verify(message.locationAddress);
                        if (error)
                            return "locationAddress." + error;
                    }
                    if (message.period != null && message.hasOwnProperty("period")) {
                        var error = $root.waiternow.common.TimestampRangeProto.verify(message.period);
                        if (error)
                            return "period." + error;
                    }
                    if (message.numberOfPointsOfService != null && message.hasOwnProperty("numberOfPointsOfService"))
                        if (!$util.isInteger(message.numberOfPointsOfService))
                            return "numberOfPointsOfService: integer expected";
                    if (message.numberOfRequests != null && message.hasOwnProperty("numberOfRequests"))
                        if (!$util.isInteger(message.numberOfRequests))
                            return "numberOfRequests: integer expected";
                    if (message.charges != null && message.hasOwnProperty("charges")) {
                        var error = $root.waiternow.common.MoneyProto.verify(message.charges);
                        if (error)
                            return "charges." + error;
                    }
                    if (message.discounts != null && message.hasOwnProperty("discounts")) {
                        if (!Array.isArray(message.discounts))
                            return "discounts: array expected";
                        for (var i = 0; i < message.discounts.length; ++i) {
                            var error = $root.waiternow.common.BillProto.DiscountProto.verify(message.discounts[i]);
                            if (error)
                                return "discounts." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a LocationBillProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.BillProto.LocationBillProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.BillProto.LocationBillProto} LocationBillProto
                 */
                LocationBillProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.BillProto.LocationBillProto)
                        return object;
                    var message = new $root.waiternow.common.BillProto.LocationBillProto();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    if (object.locationName != null)
                        message.locationName = String(object.locationName);
                    if (object.locationAddress != null) {
                        if (typeof object.locationAddress !== "object")
                            throw TypeError(".waiternow.common.BillProto.LocationBillProto.locationAddress: object expected");
                        message.locationAddress = $root.waiternow.common.AddressProto.fromObject(object.locationAddress);
                    }
                    if (object.period != null) {
                        if (typeof object.period !== "object")
                            throw TypeError(".waiternow.common.BillProto.LocationBillProto.period: object expected");
                        message.period = $root.waiternow.common.TimestampRangeProto.fromObject(object.period);
                    }
                    if (object.numberOfPointsOfService != null)
                        message.numberOfPointsOfService = object.numberOfPointsOfService | 0;
                    if (object.numberOfRequests != null)
                        message.numberOfRequests = object.numberOfRequests | 0;
                    if (object.charges != null) {
                        if (typeof object.charges !== "object")
                            throw TypeError(".waiternow.common.BillProto.LocationBillProto.charges: object expected");
                        message.charges = $root.waiternow.common.MoneyProto.fromObject(object.charges);
                    }
                    if (object.discounts) {
                        if (!Array.isArray(object.discounts))
                            throw TypeError(".waiternow.common.BillProto.LocationBillProto.discounts: array expected");
                        message.discounts = [];
                        for (var i = 0; i < object.discounts.length; ++i) {
                            if (typeof object.discounts[i] !== "object")
                                throw TypeError(".waiternow.common.BillProto.LocationBillProto.discounts: object expected");
                            message.discounts[i] = $root.waiternow.common.BillProto.DiscountProto.fromObject(object.discounts[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a LocationBillProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.BillProto.LocationBillProto
                 * @static
                 * @param {waiternow.common.BillProto.LocationBillProto} message LocationBillProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                LocationBillProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.discounts = [];
                    if (options.defaults) {
                        object.locationId = "";
                        object.locationName = "";
                        object.locationAddress = null;
                        object.period = null;
                        object.numberOfPointsOfService = 0;
                        object.numberOfRequests = 0;
                        object.charges = null;
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    if (message.locationName != null && message.hasOwnProperty("locationName"))
                        object.locationName = message.locationName;
                    if (message.locationAddress != null && message.hasOwnProperty("locationAddress"))
                        object.locationAddress = $root.waiternow.common.AddressProto.toObject(message.locationAddress, options);
                    if (message.period != null && message.hasOwnProperty("period"))
                        object.period = $root.waiternow.common.TimestampRangeProto.toObject(message.period, options);
                    if (message.numberOfPointsOfService != null && message.hasOwnProperty("numberOfPointsOfService"))
                        object.numberOfPointsOfService = message.numberOfPointsOfService;
                    if (message.numberOfRequests != null && message.hasOwnProperty("numberOfRequests"))
                        object.numberOfRequests = message.numberOfRequests;
                    if (message.charges != null && message.hasOwnProperty("charges"))
                        object.charges = $root.waiternow.common.MoneyProto.toObject(message.charges, options);
                    if (message.discounts && message.discounts.length) {
                        object.discounts = [];
                        for (var j = 0; j < message.discounts.length; ++j)
                            object.discounts[j] = $root.waiternow.common.BillProto.DiscountProto.toObject(message.discounts[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this LocationBillProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.BillProto.LocationBillProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                LocationBillProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for LocationBillProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.BillProto.LocationBillProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                LocationBillProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.BillProto.LocationBillProto";
                };

                return LocationBillProto;
            })();

            BillProto.StatusProto = (function() {

                /**
                 * Properties of a StatusProto.
                 * @memberof waiternow.common.BillProto
                 * @interface IStatusProto
                 * @property {waiternow.common.BillProto.StatusProto.State|null} [state] StatusProto state
                 * @property {string|null} [justification] StatusProto justification
                 * @property {waiternow.common.IPaymentProto|null} [payment] StatusProto payment
                 */

                /**
                 * Constructs a new StatusProto.
                 * @memberof waiternow.common.BillProto
                 * @classdesc Represents a StatusProto.
                 * @implements IStatusProto
                 * @constructor
                 * @param {waiternow.common.BillProto.IStatusProto=} [properties] Properties to set
                 */
                function StatusProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StatusProto state.
                 * @member {waiternow.common.BillProto.StatusProto.State} state
                 * @memberof waiternow.common.BillProto.StatusProto
                 * @instance
                 */
                StatusProto.prototype.state = 0;

                /**
                 * StatusProto justification.
                 * @member {string} justification
                 * @memberof waiternow.common.BillProto.StatusProto
                 * @instance
                 */
                StatusProto.prototype.justification = "";

                /**
                 * StatusProto payment.
                 * @member {waiternow.common.IPaymentProto|null|undefined} payment
                 * @memberof waiternow.common.BillProto.StatusProto
                 * @instance
                 */
                StatusProto.prototype.payment = null;

                /**
                 * Creates a new StatusProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.BillProto.StatusProto
                 * @static
                 * @param {waiternow.common.BillProto.IStatusProto=} [properties] Properties to set
                 * @returns {waiternow.common.BillProto.StatusProto} StatusProto instance
                 */
                StatusProto.create = function create(properties) {
                    return new StatusProto(properties);
                };

                /**
                 * Encodes the specified StatusProto message. Does not implicitly {@link waiternow.common.BillProto.StatusProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.BillProto.StatusProto
                 * @static
                 * @param {waiternow.common.BillProto.IStatusProto} message StatusProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StatusProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.state);
                    if (message.payment != null && Object.hasOwnProperty.call(message, "payment"))
                        $root.waiternow.common.PaymentProto.encode(message.payment, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.justification != null && Object.hasOwnProperty.call(message, "justification"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.justification);
                    return writer;
                };

                /**
                 * Encodes the specified StatusProto message, length delimited. Does not implicitly {@link waiternow.common.BillProto.StatusProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.BillProto.StatusProto
                 * @static
                 * @param {waiternow.common.BillProto.IStatusProto} message StatusProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StatusProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a StatusProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.BillProto.StatusProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.BillProto.StatusProto} StatusProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StatusProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.BillProto.StatusProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.state = reader.int32();
                                break;
                            }
                        case 3: {
                                message.justification = reader.string();
                                break;
                            }
                        case 2: {
                                message.payment = $root.waiternow.common.PaymentProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a StatusProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.BillProto.StatusProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.BillProto.StatusProto} StatusProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StatusProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StatusProto message.
                 * @function verify
                 * @memberof waiternow.common.BillProto.StatusProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StatusProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.state != null && message.hasOwnProperty("state"))
                        switch (message.state) {
                        default:
                            return "state: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                            break;
                        }
                    if (message.justification != null && message.hasOwnProperty("justification"))
                        if (!$util.isString(message.justification))
                            return "justification: string expected";
                    if (message.payment != null && message.hasOwnProperty("payment")) {
                        var error = $root.waiternow.common.PaymentProto.verify(message.payment);
                        if (error)
                            return "payment." + error;
                    }
                    return null;
                };

                /**
                 * Creates a StatusProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.BillProto.StatusProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.BillProto.StatusProto} StatusProto
                 */
                StatusProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.BillProto.StatusProto)
                        return object;
                    var message = new $root.waiternow.common.BillProto.StatusProto();
                    switch (object.state) {
                    default:
                        if (typeof object.state === "number") {
                            message.state = object.state;
                            break;
                        }
                        break;
                    case "STATE_UNSPECIFIED":
                    case 0:
                        message.state = 0;
                        break;
                    case "PENDING":
                    case 1:
                        message.state = 1;
                        break;
                    case "PAID":
                    case 2:
                        message.state = 2;
                        break;
                    case "REFUNDED":
                    case 3:
                        message.state = 3;
                        break;
                    case "NULL":
                    case 4:
                        message.state = 4;
                        break;
                    case "CANCELED":
                    case 5:
                        message.state = 5;
                        break;
                    }
                    if (object.justification != null)
                        message.justification = String(object.justification);
                    if (object.payment != null) {
                        if (typeof object.payment !== "object")
                            throw TypeError(".waiternow.common.BillProto.StatusProto.payment: object expected");
                        message.payment = $root.waiternow.common.PaymentProto.fromObject(object.payment);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a StatusProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.BillProto.StatusProto
                 * @static
                 * @param {waiternow.common.BillProto.StatusProto} message StatusProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StatusProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.state = options.enums === String ? "STATE_UNSPECIFIED" : 0;
                        object.payment = null;
                        object.justification = "";
                    }
                    if (message.state != null && message.hasOwnProperty("state"))
                        object.state = options.enums === String ? $root.waiternow.common.BillProto.StatusProto.State[message.state] === undefined ? message.state : $root.waiternow.common.BillProto.StatusProto.State[message.state] : message.state;
                    if (message.payment != null && message.hasOwnProperty("payment"))
                        object.payment = $root.waiternow.common.PaymentProto.toObject(message.payment, options);
                    if (message.justification != null && message.hasOwnProperty("justification"))
                        object.justification = message.justification;
                    return object;
                };

                /**
                 * Converts this StatusProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.BillProto.StatusProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StatusProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for StatusProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.BillProto.StatusProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                StatusProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.BillProto.StatusProto";
                };

                /**
                 * State enum.
                 * @name waiternow.common.BillProto.StatusProto.State
                 * @enum {number}
                 * @property {number} STATE_UNSPECIFIED=0 STATE_UNSPECIFIED value
                 * @property {number} PENDING=1 PENDING value
                 * @property {number} PAID=2 PAID value
                 * @property {number} REFUNDED=3 REFUNDED value
                 * @property {number} NULL=4 NULL value
                 * @property {number} CANCELED=5 CANCELED value
                 */
                StatusProto.State = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "STATE_UNSPECIFIED"] = 0;
                    values[valuesById[1] = "PENDING"] = 1;
                    values[valuesById[2] = "PAID"] = 2;
                    values[valuesById[3] = "REFUNDED"] = 3;
                    values[valuesById[4] = "NULL"] = 4;
                    values[valuesById[5] = "CANCELED"] = 5;
                    return values;
                })();

                return StatusProto;
            })();

            return BillProto;
        })();

        common.BusinessBillsProto = (function() {

            /**
             * Properties of a BusinessBillsProto.
             * @memberof waiternow.common
             * @interface IBusinessBillsProto
             * @property {string|null} [businessId] BusinessBillsProto businessId
             * @property {Array.<waiternow.common.IBillProto>|null} [bills] BusinessBillsProto bills
             */

            /**
             * Constructs a new BusinessBillsProto.
             * @memberof waiternow.common
             * @classdesc Represents a BusinessBillsProto.
             * @implements IBusinessBillsProto
             * @constructor
             * @param {waiternow.common.IBusinessBillsProto=} [properties] Properties to set
             */
            function BusinessBillsProto(properties) {
                this.bills = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * BusinessBillsProto businessId.
             * @member {string} businessId
             * @memberof waiternow.common.BusinessBillsProto
             * @instance
             */
            BusinessBillsProto.prototype.businessId = "";

            /**
             * BusinessBillsProto bills.
             * @member {Array.<waiternow.common.IBillProto>} bills
             * @memberof waiternow.common.BusinessBillsProto
             * @instance
             */
            BusinessBillsProto.prototype.bills = $util.emptyArray;

            /**
             * Creates a new BusinessBillsProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.BusinessBillsProto
             * @static
             * @param {waiternow.common.IBusinessBillsProto=} [properties] Properties to set
             * @returns {waiternow.common.BusinessBillsProto} BusinessBillsProto instance
             */
            BusinessBillsProto.create = function create(properties) {
                return new BusinessBillsProto(properties);
            };

            /**
             * Encodes the specified BusinessBillsProto message. Does not implicitly {@link waiternow.common.BusinessBillsProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.BusinessBillsProto
             * @static
             * @param {waiternow.common.IBusinessBillsProto} message BusinessBillsProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BusinessBillsProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessId);
                if (message.bills != null && message.bills.length)
                    for (var i = 0; i < message.bills.length; ++i)
                        $root.waiternow.common.BillProto.encode(message.bills[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified BusinessBillsProto message, length delimited. Does not implicitly {@link waiternow.common.BusinessBillsProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.BusinessBillsProto
             * @static
             * @param {waiternow.common.IBusinessBillsProto} message BusinessBillsProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BusinessBillsProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a BusinessBillsProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.BusinessBillsProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.BusinessBillsProto} BusinessBillsProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BusinessBillsProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.BusinessBillsProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.businessId = reader.string();
                            break;
                        }
                    case 2: {
                            if (!(message.bills && message.bills.length))
                                message.bills = [];
                            message.bills.push($root.waiternow.common.BillProto.decode(reader, reader.uint32()));
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a BusinessBillsProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.BusinessBillsProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.BusinessBillsProto} BusinessBillsProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BusinessBillsProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a BusinessBillsProto message.
             * @function verify
             * @memberof waiternow.common.BusinessBillsProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            BusinessBillsProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.businessId != null && message.hasOwnProperty("businessId"))
                    if (!$util.isString(message.businessId))
                        return "businessId: string expected";
                if (message.bills != null && message.hasOwnProperty("bills")) {
                    if (!Array.isArray(message.bills))
                        return "bills: array expected";
                    for (var i = 0; i < message.bills.length; ++i) {
                        var error = $root.waiternow.common.BillProto.verify(message.bills[i]);
                        if (error)
                            return "bills." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a BusinessBillsProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.BusinessBillsProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.BusinessBillsProto} BusinessBillsProto
             */
            BusinessBillsProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.BusinessBillsProto)
                    return object;
                var message = new $root.waiternow.common.BusinessBillsProto();
                if (object.businessId != null)
                    message.businessId = String(object.businessId);
                if (object.bills) {
                    if (!Array.isArray(object.bills))
                        throw TypeError(".waiternow.common.BusinessBillsProto.bills: array expected");
                    message.bills = [];
                    for (var i = 0; i < object.bills.length; ++i) {
                        if (typeof object.bills[i] !== "object")
                            throw TypeError(".waiternow.common.BusinessBillsProto.bills: object expected");
                        message.bills[i] = $root.waiternow.common.BillProto.fromObject(object.bills[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a BusinessBillsProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.BusinessBillsProto
             * @static
             * @param {waiternow.common.BusinessBillsProto} message BusinessBillsProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            BusinessBillsProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.bills = [];
                if (options.defaults)
                    object.businessId = "";
                if (message.businessId != null && message.hasOwnProperty("businessId"))
                    object.businessId = message.businessId;
                if (message.bills && message.bills.length) {
                    object.bills = [];
                    for (var j = 0; j < message.bills.length; ++j)
                        object.bills[j] = $root.waiternow.common.BillProto.toObject(message.bills[j], options);
                }
                return object;
            };

            /**
             * Converts this BusinessBillsProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.BusinessBillsProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            BusinessBillsProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for BusinessBillsProto
             * @function getTypeUrl
             * @memberof waiternow.common.BusinessBillsProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            BusinessBillsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.BusinessBillsProto";
            };

            return BusinessBillsProto;
        })();

        common.BusinessPendingBillsProto = (function() {

            /**
             * Properties of a BusinessPendingBillsProto.
             * @memberof waiternow.common
             * @interface IBusinessPendingBillsProto
             * @property {string|null} [businessId] BusinessPendingBillsProto businessId
             * @property {waiternow.common.IMoneyProto|null} [balance] BusinessPendingBillsProto balance
             * @property {Array.<waiternow.common.IBillProto>|null} [bills] BusinessPendingBillsProto bills
             */

            /**
             * Constructs a new BusinessPendingBillsProto.
             * @memberof waiternow.common
             * @classdesc Represents a BusinessPendingBillsProto.
             * @implements IBusinessPendingBillsProto
             * @constructor
             * @param {waiternow.common.IBusinessPendingBillsProto=} [properties] Properties to set
             */
            function BusinessPendingBillsProto(properties) {
                this.bills = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * BusinessPendingBillsProto businessId.
             * @member {string} businessId
             * @memberof waiternow.common.BusinessPendingBillsProto
             * @instance
             */
            BusinessPendingBillsProto.prototype.businessId = "";

            /**
             * BusinessPendingBillsProto balance.
             * @member {waiternow.common.IMoneyProto|null|undefined} balance
             * @memberof waiternow.common.BusinessPendingBillsProto
             * @instance
             */
            BusinessPendingBillsProto.prototype.balance = null;

            /**
             * BusinessPendingBillsProto bills.
             * @member {Array.<waiternow.common.IBillProto>} bills
             * @memberof waiternow.common.BusinessPendingBillsProto
             * @instance
             */
            BusinessPendingBillsProto.prototype.bills = $util.emptyArray;

            /**
             * Creates a new BusinessPendingBillsProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.BusinessPendingBillsProto
             * @static
             * @param {waiternow.common.IBusinessPendingBillsProto=} [properties] Properties to set
             * @returns {waiternow.common.BusinessPendingBillsProto} BusinessPendingBillsProto instance
             */
            BusinessPendingBillsProto.create = function create(properties) {
                return new BusinessPendingBillsProto(properties);
            };

            /**
             * Encodes the specified BusinessPendingBillsProto message. Does not implicitly {@link waiternow.common.BusinessPendingBillsProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.BusinessPendingBillsProto
             * @static
             * @param {waiternow.common.IBusinessPendingBillsProto} message BusinessPendingBillsProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BusinessPendingBillsProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessId);
                if (message.balance != null && Object.hasOwnProperty.call(message, "balance"))
                    $root.waiternow.common.MoneyProto.encode(message.balance, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.bills != null && message.bills.length)
                    for (var i = 0; i < message.bills.length; ++i)
                        $root.waiternow.common.BillProto.encode(message.bills[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified BusinessPendingBillsProto message, length delimited. Does not implicitly {@link waiternow.common.BusinessPendingBillsProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.BusinessPendingBillsProto
             * @static
             * @param {waiternow.common.IBusinessPendingBillsProto} message BusinessPendingBillsProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BusinessPendingBillsProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a BusinessPendingBillsProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.BusinessPendingBillsProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.BusinessPendingBillsProto} BusinessPendingBillsProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BusinessPendingBillsProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.BusinessPendingBillsProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.businessId = reader.string();
                            break;
                        }
                    case 2: {
                            message.balance = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 3: {
                            if (!(message.bills && message.bills.length))
                                message.bills = [];
                            message.bills.push($root.waiternow.common.BillProto.decode(reader, reader.uint32()));
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a BusinessPendingBillsProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.BusinessPendingBillsProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.BusinessPendingBillsProto} BusinessPendingBillsProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BusinessPendingBillsProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a BusinessPendingBillsProto message.
             * @function verify
             * @memberof waiternow.common.BusinessPendingBillsProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            BusinessPendingBillsProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.businessId != null && message.hasOwnProperty("businessId"))
                    if (!$util.isString(message.businessId))
                        return "businessId: string expected";
                if (message.balance != null && message.hasOwnProperty("balance")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.balance);
                    if (error)
                        return "balance." + error;
                }
                if (message.bills != null && message.hasOwnProperty("bills")) {
                    if (!Array.isArray(message.bills))
                        return "bills: array expected";
                    for (var i = 0; i < message.bills.length; ++i) {
                        var error = $root.waiternow.common.BillProto.verify(message.bills[i]);
                        if (error)
                            return "bills." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a BusinessPendingBillsProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.BusinessPendingBillsProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.BusinessPendingBillsProto} BusinessPendingBillsProto
             */
            BusinessPendingBillsProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.BusinessPendingBillsProto)
                    return object;
                var message = new $root.waiternow.common.BusinessPendingBillsProto();
                if (object.businessId != null)
                    message.businessId = String(object.businessId);
                if (object.balance != null) {
                    if (typeof object.balance !== "object")
                        throw TypeError(".waiternow.common.BusinessPendingBillsProto.balance: object expected");
                    message.balance = $root.waiternow.common.MoneyProto.fromObject(object.balance);
                }
                if (object.bills) {
                    if (!Array.isArray(object.bills))
                        throw TypeError(".waiternow.common.BusinessPendingBillsProto.bills: array expected");
                    message.bills = [];
                    for (var i = 0; i < object.bills.length; ++i) {
                        if (typeof object.bills[i] !== "object")
                            throw TypeError(".waiternow.common.BusinessPendingBillsProto.bills: object expected");
                        message.bills[i] = $root.waiternow.common.BillProto.fromObject(object.bills[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a BusinessPendingBillsProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.BusinessPendingBillsProto
             * @static
             * @param {waiternow.common.BusinessPendingBillsProto} message BusinessPendingBillsProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            BusinessPendingBillsProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.bills = [];
                if (options.defaults) {
                    object.businessId = "";
                    object.balance = null;
                }
                if (message.businessId != null && message.hasOwnProperty("businessId"))
                    object.businessId = message.businessId;
                if (message.balance != null && message.hasOwnProperty("balance"))
                    object.balance = $root.waiternow.common.MoneyProto.toObject(message.balance, options);
                if (message.bills && message.bills.length) {
                    object.bills = [];
                    for (var j = 0; j < message.bills.length; ++j)
                        object.bills[j] = $root.waiternow.common.BillProto.toObject(message.bills[j], options);
                }
                return object;
            };

            /**
             * Converts this BusinessPendingBillsProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.BusinessPendingBillsProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            BusinessPendingBillsProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for BusinessPendingBillsProto
             * @function getTypeUrl
             * @memberof waiternow.common.BusinessPendingBillsProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            BusinessPendingBillsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.BusinessPendingBillsProto";
            };

            return BusinessPendingBillsProto;
        })();

        common.BusinessProto = (function() {

            /**
             * Properties of a BusinessProto.
             * @memberof waiternow.common
             * @interface IBusinessProto
             * @property {string|null} [id] BusinessProto id
             * @property {google.protobuf.ITimestamp|null} [creationTime] BusinessProto creationTime
             * @property {google.protobuf.ITimestamp|null} [lastUpdateTime] BusinessProto lastUpdateTime
             * @property {string|null} [businessName] BusinessProto businessName
             * @property {boolean|null} [isSuspended] BusinessProto isSuspended
             * @property {waiternow.common.BusinessProto.SuspensionCause|null} [suspensionCause] BusinessProto suspensionCause
             * @property {waiternow.common.LocationProto.ISettingsProto|null} [locationSettings] BusinessProto locationSettings
             * @property {waiternow.common.BusinessProto.IMetadataProto|null} [metadata] BusinessProto metadata
             * @property {boolean|null} [isBillable] BusinessProto isBillable
             * @property {waiternow.common.IImageProto|null} [logo] BusinessProto logo
             * @property {waiternow.common.BusinessProto.ISettingsProto|null} [settings] BusinessProto settings
             * @property {waiternow.common.IImageProto|null} [menuHeaderForLandscapeScreen] BusinessProto menuHeaderForLandscapeScreen
             * @property {waiternow.common.IImageProto|null} [menuHeaderForPortraitScreen] BusinessProto menuHeaderForPortraitScreen
             * @property {waiternow.common.IImageProto|null} [homeHeaderForLandscapeScreen] BusinessProto homeHeaderForLandscapeScreen
             * @property {waiternow.common.IImageProto|null} [homeHeaderForPortraitScreen] BusinessProto homeHeaderForPortraitScreen
             * @property {string|null} [legacyDescription] BusinessProto legacyDescription
             * @property {waiternow.common.ITextProto|null} [description] BusinessProto description
             * @property {string|null} [vanityUrl] BusinessProto vanityUrl
             */

            /**
             * Constructs a new BusinessProto.
             * @memberof waiternow.common
             * @classdesc Represents a BusinessProto.
             * @implements IBusinessProto
             * @constructor
             * @param {waiternow.common.IBusinessProto=} [properties] Properties to set
             */
            function BusinessProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * BusinessProto id.
             * @member {string} id
             * @memberof waiternow.common.BusinessProto
             * @instance
             */
            BusinessProto.prototype.id = "";

            /**
             * BusinessProto creationTime.
             * @member {google.protobuf.ITimestamp|null|undefined} creationTime
             * @memberof waiternow.common.BusinessProto
             * @instance
             */
            BusinessProto.prototype.creationTime = null;

            /**
             * BusinessProto lastUpdateTime.
             * @member {google.protobuf.ITimestamp|null|undefined} lastUpdateTime
             * @memberof waiternow.common.BusinessProto
             * @instance
             */
            BusinessProto.prototype.lastUpdateTime = null;

            /**
             * BusinessProto businessName.
             * @member {string} businessName
             * @memberof waiternow.common.BusinessProto
             * @instance
             */
            BusinessProto.prototype.businessName = "";

            /**
             * BusinessProto isSuspended.
             * @member {boolean} isSuspended
             * @memberof waiternow.common.BusinessProto
             * @instance
             */
            BusinessProto.prototype.isSuspended = false;

            /**
             * BusinessProto suspensionCause.
             * @member {waiternow.common.BusinessProto.SuspensionCause} suspensionCause
             * @memberof waiternow.common.BusinessProto
             * @instance
             */
            BusinessProto.prototype.suspensionCause = 0;

            /**
             * BusinessProto locationSettings.
             * @member {waiternow.common.LocationProto.ISettingsProto|null|undefined} locationSettings
             * @memberof waiternow.common.BusinessProto
             * @instance
             */
            BusinessProto.prototype.locationSettings = null;

            /**
             * BusinessProto metadata.
             * @member {waiternow.common.BusinessProto.IMetadataProto|null|undefined} metadata
             * @memberof waiternow.common.BusinessProto
             * @instance
             */
            BusinessProto.prototype.metadata = null;

            /**
             * BusinessProto isBillable.
             * @member {boolean} isBillable
             * @memberof waiternow.common.BusinessProto
             * @instance
             */
            BusinessProto.prototype.isBillable = false;

            /**
             * BusinessProto logo.
             * @member {waiternow.common.IImageProto|null|undefined} logo
             * @memberof waiternow.common.BusinessProto
             * @instance
             */
            BusinessProto.prototype.logo = null;

            /**
             * BusinessProto settings.
             * @member {waiternow.common.BusinessProto.ISettingsProto|null|undefined} settings
             * @memberof waiternow.common.BusinessProto
             * @instance
             */
            BusinessProto.prototype.settings = null;

            /**
             * BusinessProto menuHeaderForLandscapeScreen.
             * @member {waiternow.common.IImageProto|null|undefined} menuHeaderForLandscapeScreen
             * @memberof waiternow.common.BusinessProto
             * @instance
             */
            BusinessProto.prototype.menuHeaderForLandscapeScreen = null;

            /**
             * BusinessProto menuHeaderForPortraitScreen.
             * @member {waiternow.common.IImageProto|null|undefined} menuHeaderForPortraitScreen
             * @memberof waiternow.common.BusinessProto
             * @instance
             */
            BusinessProto.prototype.menuHeaderForPortraitScreen = null;

            /**
             * BusinessProto homeHeaderForLandscapeScreen.
             * @member {waiternow.common.IImageProto|null|undefined} homeHeaderForLandscapeScreen
             * @memberof waiternow.common.BusinessProto
             * @instance
             */
            BusinessProto.prototype.homeHeaderForLandscapeScreen = null;

            /**
             * BusinessProto homeHeaderForPortraitScreen.
             * @member {waiternow.common.IImageProto|null|undefined} homeHeaderForPortraitScreen
             * @memberof waiternow.common.BusinessProto
             * @instance
             */
            BusinessProto.prototype.homeHeaderForPortraitScreen = null;

            /**
             * BusinessProto legacyDescription.
             * @member {string} legacyDescription
             * @memberof waiternow.common.BusinessProto
             * @instance
             */
            BusinessProto.prototype.legacyDescription = "";

            /**
             * BusinessProto description.
             * @member {waiternow.common.ITextProto|null|undefined} description
             * @memberof waiternow.common.BusinessProto
             * @instance
             */
            BusinessProto.prototype.description = null;

            /**
             * BusinessProto vanityUrl.
             * @member {string} vanityUrl
             * @memberof waiternow.common.BusinessProto
             * @instance
             */
            BusinessProto.prototype.vanityUrl = "";

            /**
             * Creates a new BusinessProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.BusinessProto
             * @static
             * @param {waiternow.common.IBusinessProto=} [properties] Properties to set
             * @returns {waiternow.common.BusinessProto} BusinessProto instance
             */
            BusinessProto.create = function create(properties) {
                return new BusinessProto(properties);
            };

            /**
             * Encodes the specified BusinessProto message. Does not implicitly {@link waiternow.common.BusinessProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.BusinessProto
             * @static
             * @param {waiternow.common.IBusinessProto} message BusinessProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BusinessProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                if (message.businessName != null && Object.hasOwnProperty.call(message, "businessName"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.businessName);
                if (message.creationTime != null && Object.hasOwnProperty.call(message, "creationTime"))
                    $root.google.protobuf.Timestamp.encode(message.creationTime, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                    $root.google.protobuf.Timestamp.encode(message.lastUpdateTime, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                if (message.isSuspended != null && Object.hasOwnProperty.call(message, "isSuspended"))
                    writer.uint32(/* id 6, wireType 0 =*/48).bool(message.isSuspended);
                if (message.suspensionCause != null && Object.hasOwnProperty.call(message, "suspensionCause"))
                    writer.uint32(/* id 7, wireType 0 =*/56).int32(message.suspensionCause);
                if (message.locationSettings != null && Object.hasOwnProperty.call(message, "locationSettings"))
                    $root.waiternow.common.LocationProto.SettingsProto.encode(message.locationSettings, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                if (message.metadata != null && Object.hasOwnProperty.call(message, "metadata"))
                    $root.waiternow.common.BusinessProto.MetadataProto.encode(message.metadata, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                if (message.isBillable != null && Object.hasOwnProperty.call(message, "isBillable"))
                    writer.uint32(/* id 10, wireType 0 =*/80).bool(message.isBillable);
                if (message.logo != null && Object.hasOwnProperty.call(message, "logo"))
                    $root.waiternow.common.ImageProto.encode(message.logo, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                if (message.settings != null && Object.hasOwnProperty.call(message, "settings"))
                    $root.waiternow.common.BusinessProto.SettingsProto.encode(message.settings, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                if (message.menuHeaderForLandscapeScreen != null && Object.hasOwnProperty.call(message, "menuHeaderForLandscapeScreen"))
                    $root.waiternow.common.ImageProto.encode(message.menuHeaderForLandscapeScreen, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
                if (message.menuHeaderForPortraitScreen != null && Object.hasOwnProperty.call(message, "menuHeaderForPortraitScreen"))
                    $root.waiternow.common.ImageProto.encode(message.menuHeaderForPortraitScreen, writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
                if (message.legacyDescription != null && Object.hasOwnProperty.call(message, "legacyDescription"))
                    writer.uint32(/* id 15, wireType 2 =*/122).string(message.legacyDescription);
                if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                    $root.waiternow.common.TextProto.encode(message.description, writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
                if (message.vanityUrl != null && Object.hasOwnProperty.call(message, "vanityUrl"))
                    writer.uint32(/* id 17, wireType 2 =*/138).string(message.vanityUrl);
                if (message.homeHeaderForLandscapeScreen != null && Object.hasOwnProperty.call(message, "homeHeaderForLandscapeScreen"))
                    $root.waiternow.common.ImageProto.encode(message.homeHeaderForLandscapeScreen, writer.uint32(/* id 18, wireType 2 =*/146).fork()).ldelim();
                if (message.homeHeaderForPortraitScreen != null && Object.hasOwnProperty.call(message, "homeHeaderForPortraitScreen"))
                    $root.waiternow.common.ImageProto.encode(message.homeHeaderForPortraitScreen, writer.uint32(/* id 19, wireType 2 =*/154).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified BusinessProto message, length delimited. Does not implicitly {@link waiternow.common.BusinessProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.BusinessProto
             * @static
             * @param {waiternow.common.IBusinessProto} message BusinessProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BusinessProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a BusinessProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.BusinessProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.BusinessProto} BusinessProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BusinessProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.BusinessProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.id = reader.string();
                            break;
                        }
                    case 4: {
                            message.creationTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 5: {
                            message.lastUpdateTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 2: {
                            message.businessName = reader.string();
                            break;
                        }
                    case 6: {
                            message.isSuspended = reader.bool();
                            break;
                        }
                    case 7: {
                            message.suspensionCause = reader.int32();
                            break;
                        }
                    case 8: {
                            message.locationSettings = $root.waiternow.common.LocationProto.SettingsProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 9: {
                            message.metadata = $root.waiternow.common.BusinessProto.MetadataProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 10: {
                            message.isBillable = reader.bool();
                            break;
                        }
                    case 11: {
                            message.logo = $root.waiternow.common.ImageProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 12: {
                            message.settings = $root.waiternow.common.BusinessProto.SettingsProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 13: {
                            message.menuHeaderForLandscapeScreen = $root.waiternow.common.ImageProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 14: {
                            message.menuHeaderForPortraitScreen = $root.waiternow.common.ImageProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 18: {
                            message.homeHeaderForLandscapeScreen = $root.waiternow.common.ImageProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 19: {
                            message.homeHeaderForPortraitScreen = $root.waiternow.common.ImageProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 15: {
                            message.legacyDescription = reader.string();
                            break;
                        }
                    case 16: {
                            message.description = $root.waiternow.common.TextProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 17: {
                            message.vanityUrl = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a BusinessProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.BusinessProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.BusinessProto} BusinessProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BusinessProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a BusinessProto message.
             * @function verify
             * @memberof waiternow.common.BusinessProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            BusinessProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.id != null && message.hasOwnProperty("id"))
                    if (!$util.isString(message.id))
                        return "id: string expected";
                if (message.creationTime != null && message.hasOwnProperty("creationTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.creationTime);
                    if (error)
                        return "creationTime." + error;
                }
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.lastUpdateTime);
                    if (error)
                        return "lastUpdateTime." + error;
                }
                if (message.businessName != null && message.hasOwnProperty("businessName"))
                    if (!$util.isString(message.businessName))
                        return "businessName: string expected";
                if (message.isSuspended != null && message.hasOwnProperty("isSuspended"))
                    if (typeof message.isSuspended !== "boolean")
                        return "isSuspended: boolean expected";
                if (message.suspensionCause != null && message.hasOwnProperty("suspensionCause"))
                    switch (message.suspensionCause) {
                    default:
                        return "suspensionCause: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                        break;
                    }
                if (message.locationSettings != null && message.hasOwnProperty("locationSettings")) {
                    var error = $root.waiternow.common.LocationProto.SettingsProto.verify(message.locationSettings);
                    if (error)
                        return "locationSettings." + error;
                }
                if (message.metadata != null && message.hasOwnProperty("metadata")) {
                    var error = $root.waiternow.common.BusinessProto.MetadataProto.verify(message.metadata);
                    if (error)
                        return "metadata." + error;
                }
                if (message.isBillable != null && message.hasOwnProperty("isBillable"))
                    if (typeof message.isBillable !== "boolean")
                        return "isBillable: boolean expected";
                if (message.logo != null && message.hasOwnProperty("logo")) {
                    var error = $root.waiternow.common.ImageProto.verify(message.logo);
                    if (error)
                        return "logo." + error;
                }
                if (message.settings != null && message.hasOwnProperty("settings")) {
                    var error = $root.waiternow.common.BusinessProto.SettingsProto.verify(message.settings);
                    if (error)
                        return "settings." + error;
                }
                if (message.menuHeaderForLandscapeScreen != null && message.hasOwnProperty("menuHeaderForLandscapeScreen")) {
                    var error = $root.waiternow.common.ImageProto.verify(message.menuHeaderForLandscapeScreen);
                    if (error)
                        return "menuHeaderForLandscapeScreen." + error;
                }
                if (message.menuHeaderForPortraitScreen != null && message.hasOwnProperty("menuHeaderForPortraitScreen")) {
                    var error = $root.waiternow.common.ImageProto.verify(message.menuHeaderForPortraitScreen);
                    if (error)
                        return "menuHeaderForPortraitScreen." + error;
                }
                if (message.homeHeaderForLandscapeScreen != null && message.hasOwnProperty("homeHeaderForLandscapeScreen")) {
                    var error = $root.waiternow.common.ImageProto.verify(message.homeHeaderForLandscapeScreen);
                    if (error)
                        return "homeHeaderForLandscapeScreen." + error;
                }
                if (message.homeHeaderForPortraitScreen != null && message.hasOwnProperty("homeHeaderForPortraitScreen")) {
                    var error = $root.waiternow.common.ImageProto.verify(message.homeHeaderForPortraitScreen);
                    if (error)
                        return "homeHeaderForPortraitScreen." + error;
                }
                if (message.legacyDescription != null && message.hasOwnProperty("legacyDescription"))
                    if (!$util.isString(message.legacyDescription))
                        return "legacyDescription: string expected";
                if (message.description != null && message.hasOwnProperty("description")) {
                    var error = $root.waiternow.common.TextProto.verify(message.description);
                    if (error)
                        return "description." + error;
                }
                if (message.vanityUrl != null && message.hasOwnProperty("vanityUrl"))
                    if (!$util.isString(message.vanityUrl))
                        return "vanityUrl: string expected";
                return null;
            };

            /**
             * Creates a BusinessProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.BusinessProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.BusinessProto} BusinessProto
             */
            BusinessProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.BusinessProto)
                    return object;
                var message = new $root.waiternow.common.BusinessProto();
                if (object.id != null)
                    message.id = String(object.id);
                if (object.creationTime != null) {
                    if (typeof object.creationTime !== "object")
                        throw TypeError(".waiternow.common.BusinessProto.creationTime: object expected");
                    message.creationTime = $root.google.protobuf.Timestamp.fromObject(object.creationTime);
                }
                if (object.lastUpdateTime != null) {
                    if (typeof object.lastUpdateTime !== "object")
                        throw TypeError(".waiternow.common.BusinessProto.lastUpdateTime: object expected");
                    message.lastUpdateTime = $root.google.protobuf.Timestamp.fromObject(object.lastUpdateTime);
                }
                if (object.businessName != null)
                    message.businessName = String(object.businessName);
                if (object.isSuspended != null)
                    message.isSuspended = Boolean(object.isSuspended);
                switch (object.suspensionCause) {
                default:
                    if (typeof object.suspensionCause === "number") {
                        message.suspensionCause = object.suspensionCause;
                        break;
                    }
                    break;
                case "SUSPENSION_CAUSE_UNSPECIFIED":
                case 0:
                    message.suspensionCause = 0;
                    break;
                case "UNPAID_BILL":
                case 1:
                    message.suspensionCause = 1;
                    break;
                case "QUOTA_LIMIT_REACHED":
                case 2:
                    message.suspensionCause = 2;
                    break;
                case "SUSPENDED_BY_OWNER":
                case 3:
                    message.suspensionCause = 3;
                    break;
                case "BLOCKED_OWNER":
                case 4:
                    message.suspensionCause = 4;
                    break;
                }
                if (object.locationSettings != null) {
                    if (typeof object.locationSettings !== "object")
                        throw TypeError(".waiternow.common.BusinessProto.locationSettings: object expected");
                    message.locationSettings = $root.waiternow.common.LocationProto.SettingsProto.fromObject(object.locationSettings);
                }
                if (object.metadata != null) {
                    if (typeof object.metadata !== "object")
                        throw TypeError(".waiternow.common.BusinessProto.metadata: object expected");
                    message.metadata = $root.waiternow.common.BusinessProto.MetadataProto.fromObject(object.metadata);
                }
                if (object.isBillable != null)
                    message.isBillable = Boolean(object.isBillable);
                if (object.logo != null) {
                    if (typeof object.logo !== "object")
                        throw TypeError(".waiternow.common.BusinessProto.logo: object expected");
                    message.logo = $root.waiternow.common.ImageProto.fromObject(object.logo);
                }
                if (object.settings != null) {
                    if (typeof object.settings !== "object")
                        throw TypeError(".waiternow.common.BusinessProto.settings: object expected");
                    message.settings = $root.waiternow.common.BusinessProto.SettingsProto.fromObject(object.settings);
                }
                if (object.menuHeaderForLandscapeScreen != null) {
                    if (typeof object.menuHeaderForLandscapeScreen !== "object")
                        throw TypeError(".waiternow.common.BusinessProto.menuHeaderForLandscapeScreen: object expected");
                    message.menuHeaderForLandscapeScreen = $root.waiternow.common.ImageProto.fromObject(object.menuHeaderForLandscapeScreen);
                }
                if (object.menuHeaderForPortraitScreen != null) {
                    if (typeof object.menuHeaderForPortraitScreen !== "object")
                        throw TypeError(".waiternow.common.BusinessProto.menuHeaderForPortraitScreen: object expected");
                    message.menuHeaderForPortraitScreen = $root.waiternow.common.ImageProto.fromObject(object.menuHeaderForPortraitScreen);
                }
                if (object.homeHeaderForLandscapeScreen != null) {
                    if (typeof object.homeHeaderForLandscapeScreen !== "object")
                        throw TypeError(".waiternow.common.BusinessProto.homeHeaderForLandscapeScreen: object expected");
                    message.homeHeaderForLandscapeScreen = $root.waiternow.common.ImageProto.fromObject(object.homeHeaderForLandscapeScreen);
                }
                if (object.homeHeaderForPortraitScreen != null) {
                    if (typeof object.homeHeaderForPortraitScreen !== "object")
                        throw TypeError(".waiternow.common.BusinessProto.homeHeaderForPortraitScreen: object expected");
                    message.homeHeaderForPortraitScreen = $root.waiternow.common.ImageProto.fromObject(object.homeHeaderForPortraitScreen);
                }
                if (object.legacyDescription != null)
                    message.legacyDescription = String(object.legacyDescription);
                if (object.description != null) {
                    if (typeof object.description !== "object")
                        throw TypeError(".waiternow.common.BusinessProto.description: object expected");
                    message.description = $root.waiternow.common.TextProto.fromObject(object.description);
                }
                if (object.vanityUrl != null)
                    message.vanityUrl = String(object.vanityUrl);
                return message;
            };

            /**
             * Creates a plain object from a BusinessProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.BusinessProto
             * @static
             * @param {waiternow.common.BusinessProto} message BusinessProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            BusinessProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.id = "";
                    object.businessName = "";
                    object.creationTime = null;
                    object.lastUpdateTime = null;
                    object.isSuspended = false;
                    object.suspensionCause = options.enums === String ? "SUSPENSION_CAUSE_UNSPECIFIED" : 0;
                    object.locationSettings = null;
                    object.metadata = null;
                    object.isBillable = false;
                    object.logo = null;
                    object.settings = null;
                    object.menuHeaderForLandscapeScreen = null;
                    object.menuHeaderForPortraitScreen = null;
                    object.legacyDescription = "";
                    object.description = null;
                    object.vanityUrl = "";
                    object.homeHeaderForLandscapeScreen = null;
                    object.homeHeaderForPortraitScreen = null;
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                if (message.businessName != null && message.hasOwnProperty("businessName"))
                    object.businessName = message.businessName;
                if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                    object.creationTime = $root.google.protobuf.Timestamp.toObject(message.creationTime, options);
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                    object.lastUpdateTime = $root.google.protobuf.Timestamp.toObject(message.lastUpdateTime, options);
                if (message.isSuspended != null && message.hasOwnProperty("isSuspended"))
                    object.isSuspended = message.isSuspended;
                if (message.suspensionCause != null && message.hasOwnProperty("suspensionCause"))
                    object.suspensionCause = options.enums === String ? $root.waiternow.common.BusinessProto.SuspensionCause[message.suspensionCause] === undefined ? message.suspensionCause : $root.waiternow.common.BusinessProto.SuspensionCause[message.suspensionCause] : message.suspensionCause;
                if (message.locationSettings != null && message.hasOwnProperty("locationSettings"))
                    object.locationSettings = $root.waiternow.common.LocationProto.SettingsProto.toObject(message.locationSettings, options);
                if (message.metadata != null && message.hasOwnProperty("metadata"))
                    object.metadata = $root.waiternow.common.BusinessProto.MetadataProto.toObject(message.metadata, options);
                if (message.isBillable != null && message.hasOwnProperty("isBillable"))
                    object.isBillable = message.isBillable;
                if (message.logo != null && message.hasOwnProperty("logo"))
                    object.logo = $root.waiternow.common.ImageProto.toObject(message.logo, options);
                if (message.settings != null && message.hasOwnProperty("settings"))
                    object.settings = $root.waiternow.common.BusinessProto.SettingsProto.toObject(message.settings, options);
                if (message.menuHeaderForLandscapeScreen != null && message.hasOwnProperty("menuHeaderForLandscapeScreen"))
                    object.menuHeaderForLandscapeScreen = $root.waiternow.common.ImageProto.toObject(message.menuHeaderForLandscapeScreen, options);
                if (message.menuHeaderForPortraitScreen != null && message.hasOwnProperty("menuHeaderForPortraitScreen"))
                    object.menuHeaderForPortraitScreen = $root.waiternow.common.ImageProto.toObject(message.menuHeaderForPortraitScreen, options);
                if (message.legacyDescription != null && message.hasOwnProperty("legacyDescription"))
                    object.legacyDescription = message.legacyDescription;
                if (message.description != null && message.hasOwnProperty("description"))
                    object.description = $root.waiternow.common.TextProto.toObject(message.description, options);
                if (message.vanityUrl != null && message.hasOwnProperty("vanityUrl"))
                    object.vanityUrl = message.vanityUrl;
                if (message.homeHeaderForLandscapeScreen != null && message.hasOwnProperty("homeHeaderForLandscapeScreen"))
                    object.homeHeaderForLandscapeScreen = $root.waiternow.common.ImageProto.toObject(message.homeHeaderForLandscapeScreen, options);
                if (message.homeHeaderForPortraitScreen != null && message.hasOwnProperty("homeHeaderForPortraitScreen"))
                    object.homeHeaderForPortraitScreen = $root.waiternow.common.ImageProto.toObject(message.homeHeaderForPortraitScreen, options);
                return object;
            };

            /**
             * Converts this BusinessProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.BusinessProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            BusinessProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for BusinessProto
             * @function getTypeUrl
             * @memberof waiternow.common.BusinessProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            BusinessProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.BusinessProto";
            };

            /**
             * SuspensionCause enum.
             * @name waiternow.common.BusinessProto.SuspensionCause
             * @enum {number}
             * @property {number} SUSPENSION_CAUSE_UNSPECIFIED=0 SUSPENSION_CAUSE_UNSPECIFIED value
             * @property {number} UNPAID_BILL=1 UNPAID_BILL value
             * @property {number} QUOTA_LIMIT_REACHED=2 QUOTA_LIMIT_REACHED value
             * @property {number} SUSPENDED_BY_OWNER=3 SUSPENDED_BY_OWNER value
             * @property {number} BLOCKED_OWNER=4 BLOCKED_OWNER value
             */
            BusinessProto.SuspensionCause = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "SUSPENSION_CAUSE_UNSPECIFIED"] = 0;
                values[valuesById[1] = "UNPAID_BILL"] = 1;
                values[valuesById[2] = "QUOTA_LIMIT_REACHED"] = 2;
                values[valuesById[3] = "SUSPENDED_BY_OWNER"] = 3;
                values[valuesById[4] = "BLOCKED_OWNER"] = 4;
                return values;
            })();

            BusinessProto.MetadataProto = (function() {

                /**
                 * Properties of a MetadataProto.
                 * @memberof waiternow.common.BusinessProto
                 * @interface IMetadataProto
                 * @property {waiternow.common.RecordType|null} [recordType] MetadataProto recordType
                 * @property {string|null} [salesReference] MetadataProto salesReference
                 * @property {string|null} [salesPartnerId] MetadataProto salesPartnerId
                 * @property {string|null} [salespersonCode] MetadataProto salespersonCode
                 * @property {number|null} [trialPeriodDays] MetadataProto trialPeriodDays
                 */

                /**
                 * Constructs a new MetadataProto.
                 * @memberof waiternow.common.BusinessProto
                 * @classdesc Represents a MetadataProto.
                 * @implements IMetadataProto
                 * @constructor
                 * @param {waiternow.common.BusinessProto.IMetadataProto=} [properties] Properties to set
                 */
                function MetadataProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * MetadataProto recordType.
                 * @member {waiternow.common.RecordType} recordType
                 * @memberof waiternow.common.BusinessProto.MetadataProto
                 * @instance
                 */
                MetadataProto.prototype.recordType = 0;

                /**
                 * MetadataProto salesReference.
                 * @member {string} salesReference
                 * @memberof waiternow.common.BusinessProto.MetadataProto
                 * @instance
                 */
                MetadataProto.prototype.salesReference = "";

                /**
                 * MetadataProto salesPartnerId.
                 * @member {string} salesPartnerId
                 * @memberof waiternow.common.BusinessProto.MetadataProto
                 * @instance
                 */
                MetadataProto.prototype.salesPartnerId = "";

                /**
                 * MetadataProto salespersonCode.
                 * @member {string} salespersonCode
                 * @memberof waiternow.common.BusinessProto.MetadataProto
                 * @instance
                 */
                MetadataProto.prototype.salespersonCode = "";

                /**
                 * MetadataProto trialPeriodDays.
                 * @member {number} trialPeriodDays
                 * @memberof waiternow.common.BusinessProto.MetadataProto
                 * @instance
                 */
                MetadataProto.prototype.trialPeriodDays = 0;

                /**
                 * Creates a new MetadataProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.BusinessProto.MetadataProto
                 * @static
                 * @param {waiternow.common.BusinessProto.IMetadataProto=} [properties] Properties to set
                 * @returns {waiternow.common.BusinessProto.MetadataProto} MetadataProto instance
                 */
                MetadataProto.create = function create(properties) {
                    return new MetadataProto(properties);
                };

                /**
                 * Encodes the specified MetadataProto message. Does not implicitly {@link waiternow.common.BusinessProto.MetadataProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.BusinessProto.MetadataProto
                 * @static
                 * @param {waiternow.common.BusinessProto.IMetadataProto} message MetadataProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MetadataProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.recordType != null && Object.hasOwnProperty.call(message, "recordType"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.recordType);
                    if (message.salesReference != null && Object.hasOwnProperty.call(message, "salesReference"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.salesReference);
                    if (message.salesPartnerId != null && Object.hasOwnProperty.call(message, "salesPartnerId"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.salesPartnerId);
                    if (message.trialPeriodDays != null && Object.hasOwnProperty.call(message, "trialPeriodDays"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.trialPeriodDays);
                    if (message.salespersonCode != null && Object.hasOwnProperty.call(message, "salespersonCode"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.salespersonCode);
                    return writer;
                };

                /**
                 * Encodes the specified MetadataProto message, length delimited. Does not implicitly {@link waiternow.common.BusinessProto.MetadataProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.BusinessProto.MetadataProto
                 * @static
                 * @param {waiternow.common.BusinessProto.IMetadataProto} message MetadataProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MetadataProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a MetadataProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.BusinessProto.MetadataProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.BusinessProto.MetadataProto} MetadataProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MetadataProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.BusinessProto.MetadataProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.recordType = reader.int32();
                                break;
                            }
                        case 2: {
                                message.salesReference = reader.string();
                                break;
                            }
                        case 3: {
                                message.salesPartnerId = reader.string();
                                break;
                            }
                        case 5: {
                                message.salespersonCode = reader.string();
                                break;
                            }
                        case 4: {
                                message.trialPeriodDays = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a MetadataProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.BusinessProto.MetadataProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.BusinessProto.MetadataProto} MetadataProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MetadataProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a MetadataProto message.
                 * @function verify
                 * @memberof waiternow.common.BusinessProto.MetadataProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                MetadataProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.recordType != null && message.hasOwnProperty("recordType"))
                        switch (message.recordType) {
                        default:
                            return "recordType: enum value expected";
                        case 0:
                        case 1:
                        case 3:
                        case 4:
                        case 5:
                            break;
                        }
                    if (message.salesReference != null && message.hasOwnProperty("salesReference"))
                        if (!$util.isString(message.salesReference))
                            return "salesReference: string expected";
                    if (message.salesPartnerId != null && message.hasOwnProperty("salesPartnerId"))
                        if (!$util.isString(message.salesPartnerId))
                            return "salesPartnerId: string expected";
                    if (message.salespersonCode != null && message.hasOwnProperty("salespersonCode"))
                        if (!$util.isString(message.salespersonCode))
                            return "salespersonCode: string expected";
                    if (message.trialPeriodDays != null && message.hasOwnProperty("trialPeriodDays"))
                        if (!$util.isInteger(message.trialPeriodDays))
                            return "trialPeriodDays: integer expected";
                    return null;
                };

                /**
                 * Creates a MetadataProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.BusinessProto.MetadataProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.BusinessProto.MetadataProto} MetadataProto
                 */
                MetadataProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.BusinessProto.MetadataProto)
                        return object;
                    var message = new $root.waiternow.common.BusinessProto.MetadataProto();
                    switch (object.recordType) {
                    default:
                        if (typeof object.recordType === "number") {
                            message.recordType = object.recordType;
                            break;
                        }
                        break;
                    case "RECORD_TYPE_UNSPECIFIED":
                    case 0:
                        message.recordType = 0;
                        break;
                    case "REGULAR":
                    case 1:
                        message.recordType = 1;
                        break;
                    case "PRE_CREATED":
                    case 3:
                        message.recordType = 3;
                        break;
                    case "TEST":
                    case 4:
                        message.recordType = 4;
                        break;
                    case "DEMO":
                    case 5:
                        message.recordType = 5;
                        break;
                    }
                    if (object.salesReference != null)
                        message.salesReference = String(object.salesReference);
                    if (object.salesPartnerId != null)
                        message.salesPartnerId = String(object.salesPartnerId);
                    if (object.salespersonCode != null)
                        message.salespersonCode = String(object.salespersonCode);
                    if (object.trialPeriodDays != null)
                        message.trialPeriodDays = object.trialPeriodDays | 0;
                    return message;
                };

                /**
                 * Creates a plain object from a MetadataProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.BusinessProto.MetadataProto
                 * @static
                 * @param {waiternow.common.BusinessProto.MetadataProto} message MetadataProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                MetadataProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.recordType = options.enums === String ? "RECORD_TYPE_UNSPECIFIED" : 0;
                        object.salesReference = "";
                        object.salesPartnerId = "";
                        object.trialPeriodDays = 0;
                        object.salespersonCode = "";
                    }
                    if (message.recordType != null && message.hasOwnProperty("recordType"))
                        object.recordType = options.enums === String ? $root.waiternow.common.RecordType[message.recordType] === undefined ? message.recordType : $root.waiternow.common.RecordType[message.recordType] : message.recordType;
                    if (message.salesReference != null && message.hasOwnProperty("salesReference"))
                        object.salesReference = message.salesReference;
                    if (message.salesPartnerId != null && message.hasOwnProperty("salesPartnerId"))
                        object.salesPartnerId = message.salesPartnerId;
                    if (message.trialPeriodDays != null && message.hasOwnProperty("trialPeriodDays"))
                        object.trialPeriodDays = message.trialPeriodDays;
                    if (message.salespersonCode != null && message.hasOwnProperty("salespersonCode"))
                        object.salespersonCode = message.salespersonCode;
                    return object;
                };

                /**
                 * Converts this MetadataProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.BusinessProto.MetadataProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                MetadataProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for MetadataProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.BusinessProto.MetadataProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                MetadataProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.BusinessProto.MetadataProto";
                };

                return MetadataProto;
            })();

            BusinessProto.SettingsProto = (function() {

                /**
                 * Properties of a SettingsProto.
                 * @memberof waiternow.common.BusinessProto
                 * @interface ISettingsProto
                 * @property {waiternow.common.BusinessProto.SettingsProto.IBillingInfoProto|null} [billingInfo] SettingsProto billingInfo
                 * @property {waiternow.common.BusinessProto.SettingsProto.ICustomPlanProto|null} [customPlan] SettingsProto customPlan
                 */

                /**
                 * Constructs a new SettingsProto.
                 * @memberof waiternow.common.BusinessProto
                 * @classdesc Represents a SettingsProto.
                 * @implements ISettingsProto
                 * @constructor
                 * @param {waiternow.common.BusinessProto.ISettingsProto=} [properties] Properties to set
                 */
                function SettingsProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SettingsProto billingInfo.
                 * @member {waiternow.common.BusinessProto.SettingsProto.IBillingInfoProto|null|undefined} billingInfo
                 * @memberof waiternow.common.BusinessProto.SettingsProto
                 * @instance
                 */
                SettingsProto.prototype.billingInfo = null;

                /**
                 * SettingsProto customPlan.
                 * @member {waiternow.common.BusinessProto.SettingsProto.ICustomPlanProto|null|undefined} customPlan
                 * @memberof waiternow.common.BusinessProto.SettingsProto
                 * @instance
                 */
                SettingsProto.prototype.customPlan = null;

                /**
                 * Creates a new SettingsProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.BusinessProto.SettingsProto
                 * @static
                 * @param {waiternow.common.BusinessProto.ISettingsProto=} [properties] Properties to set
                 * @returns {waiternow.common.BusinessProto.SettingsProto} SettingsProto instance
                 */
                SettingsProto.create = function create(properties) {
                    return new SettingsProto(properties);
                };

                /**
                 * Encodes the specified SettingsProto message. Does not implicitly {@link waiternow.common.BusinessProto.SettingsProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.BusinessProto.SettingsProto
                 * @static
                 * @param {waiternow.common.BusinessProto.ISettingsProto} message SettingsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SettingsProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.billingInfo != null && Object.hasOwnProperty.call(message, "billingInfo"))
                        $root.waiternow.common.BusinessProto.SettingsProto.BillingInfoProto.encode(message.billingInfo, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.customPlan != null && Object.hasOwnProperty.call(message, "customPlan"))
                        $root.waiternow.common.BusinessProto.SettingsProto.CustomPlanProto.encode(message.customPlan, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified SettingsProto message, length delimited. Does not implicitly {@link waiternow.common.BusinessProto.SettingsProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.BusinessProto.SettingsProto
                 * @static
                 * @param {waiternow.common.BusinessProto.ISettingsProto} message SettingsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SettingsProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SettingsProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.BusinessProto.SettingsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.BusinessProto.SettingsProto} SettingsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SettingsProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.BusinessProto.SettingsProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.billingInfo = $root.waiternow.common.BusinessProto.SettingsProto.BillingInfoProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.customPlan = $root.waiternow.common.BusinessProto.SettingsProto.CustomPlanProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SettingsProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.BusinessProto.SettingsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.BusinessProto.SettingsProto} SettingsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SettingsProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SettingsProto message.
                 * @function verify
                 * @memberof waiternow.common.BusinessProto.SettingsProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SettingsProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.billingInfo != null && message.hasOwnProperty("billingInfo")) {
                        var error = $root.waiternow.common.BusinessProto.SettingsProto.BillingInfoProto.verify(message.billingInfo);
                        if (error)
                            return "billingInfo." + error;
                    }
                    if (message.customPlan != null && message.hasOwnProperty("customPlan")) {
                        var error = $root.waiternow.common.BusinessProto.SettingsProto.CustomPlanProto.verify(message.customPlan);
                        if (error)
                            return "customPlan." + error;
                    }
                    return null;
                };

                /**
                 * Creates a SettingsProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.BusinessProto.SettingsProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.BusinessProto.SettingsProto} SettingsProto
                 */
                SettingsProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.BusinessProto.SettingsProto)
                        return object;
                    var message = new $root.waiternow.common.BusinessProto.SettingsProto();
                    if (object.billingInfo != null) {
                        if (typeof object.billingInfo !== "object")
                            throw TypeError(".waiternow.common.BusinessProto.SettingsProto.billingInfo: object expected");
                        message.billingInfo = $root.waiternow.common.BusinessProto.SettingsProto.BillingInfoProto.fromObject(object.billingInfo);
                    }
                    if (object.customPlan != null) {
                        if (typeof object.customPlan !== "object")
                            throw TypeError(".waiternow.common.BusinessProto.SettingsProto.customPlan: object expected");
                        message.customPlan = $root.waiternow.common.BusinessProto.SettingsProto.CustomPlanProto.fromObject(object.customPlan);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SettingsProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.BusinessProto.SettingsProto
                 * @static
                 * @param {waiternow.common.BusinessProto.SettingsProto} message SettingsProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SettingsProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.billingInfo = null;
                        object.customPlan = null;
                    }
                    if (message.billingInfo != null && message.hasOwnProperty("billingInfo"))
                        object.billingInfo = $root.waiternow.common.BusinessProto.SettingsProto.BillingInfoProto.toObject(message.billingInfo, options);
                    if (message.customPlan != null && message.hasOwnProperty("customPlan"))
                        object.customPlan = $root.waiternow.common.BusinessProto.SettingsProto.CustomPlanProto.toObject(message.customPlan, options);
                    return object;
                };

                /**
                 * Converts this SettingsProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.BusinessProto.SettingsProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SettingsProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for SettingsProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.BusinessProto.SettingsProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                SettingsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.BusinessProto.SettingsProto";
                };

                SettingsProto.BillingInfoProto = (function() {

                    /**
                     * Properties of a BillingInfoProto.
                     * @memberof waiternow.common.BusinessProto.SettingsProto
                     * @interface IBillingInfoProto
                     * @property {string|null} [businessOfficialId] BillingInfoProto businessOfficialId
                     * @property {waiternow.common.IAddressProto|null} [billingAddress] BillingInfoProto billingAddress
                     * @property {string|null} [businessOfficialName] BillingInfoProto businessOfficialName
                     */

                    /**
                     * Constructs a new BillingInfoProto.
                     * @memberof waiternow.common.BusinessProto.SettingsProto
                     * @classdesc Represents a BillingInfoProto.
                     * @implements IBillingInfoProto
                     * @constructor
                     * @param {waiternow.common.BusinessProto.SettingsProto.IBillingInfoProto=} [properties] Properties to set
                     */
                    function BillingInfoProto(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * BillingInfoProto businessOfficialId.
                     * @member {string} businessOfficialId
                     * @memberof waiternow.common.BusinessProto.SettingsProto.BillingInfoProto
                     * @instance
                     */
                    BillingInfoProto.prototype.businessOfficialId = "";

                    /**
                     * BillingInfoProto billingAddress.
                     * @member {waiternow.common.IAddressProto|null|undefined} billingAddress
                     * @memberof waiternow.common.BusinessProto.SettingsProto.BillingInfoProto
                     * @instance
                     */
                    BillingInfoProto.prototype.billingAddress = null;

                    /**
                     * BillingInfoProto businessOfficialName.
                     * @member {string} businessOfficialName
                     * @memberof waiternow.common.BusinessProto.SettingsProto.BillingInfoProto
                     * @instance
                     */
                    BillingInfoProto.prototype.businessOfficialName = "";

                    /**
                     * Creates a new BillingInfoProto instance using the specified properties.
                     * @function create
                     * @memberof waiternow.common.BusinessProto.SettingsProto.BillingInfoProto
                     * @static
                     * @param {waiternow.common.BusinessProto.SettingsProto.IBillingInfoProto=} [properties] Properties to set
                     * @returns {waiternow.common.BusinessProto.SettingsProto.BillingInfoProto} BillingInfoProto instance
                     */
                    BillingInfoProto.create = function create(properties) {
                        return new BillingInfoProto(properties);
                    };

                    /**
                     * Encodes the specified BillingInfoProto message. Does not implicitly {@link waiternow.common.BusinessProto.SettingsProto.BillingInfoProto.verify|verify} messages.
                     * @function encode
                     * @memberof waiternow.common.BusinessProto.SettingsProto.BillingInfoProto
                     * @static
                     * @param {waiternow.common.BusinessProto.SettingsProto.IBillingInfoProto} message BillingInfoProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BillingInfoProto.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.businessOfficialId != null && Object.hasOwnProperty.call(message, "businessOfficialId"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessOfficialId);
                        if (message.billingAddress != null && Object.hasOwnProperty.call(message, "billingAddress"))
                            $root.waiternow.common.AddressProto.encode(message.billingAddress, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.businessOfficialName != null && Object.hasOwnProperty.call(message, "businessOfficialName"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.businessOfficialName);
                        return writer;
                    };

                    /**
                     * Encodes the specified BillingInfoProto message, length delimited. Does not implicitly {@link waiternow.common.BusinessProto.SettingsProto.BillingInfoProto.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof waiternow.common.BusinessProto.SettingsProto.BillingInfoProto
                     * @static
                     * @param {waiternow.common.BusinessProto.SettingsProto.IBillingInfoProto} message BillingInfoProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BillingInfoProto.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a BillingInfoProto message from the specified reader or buffer.
                     * @function decode
                     * @memberof waiternow.common.BusinessProto.SettingsProto.BillingInfoProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {waiternow.common.BusinessProto.SettingsProto.BillingInfoProto} BillingInfoProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BillingInfoProto.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.BusinessProto.SettingsProto.BillingInfoProto();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.businessOfficialId = reader.string();
                                    break;
                                }
                            case 2: {
                                    message.billingAddress = $root.waiternow.common.AddressProto.decode(reader, reader.uint32());
                                    break;
                                }
                            case 3: {
                                    message.businessOfficialName = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a BillingInfoProto message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof waiternow.common.BusinessProto.SettingsProto.BillingInfoProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {waiternow.common.BusinessProto.SettingsProto.BillingInfoProto} BillingInfoProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BillingInfoProto.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a BillingInfoProto message.
                     * @function verify
                     * @memberof waiternow.common.BusinessProto.SettingsProto.BillingInfoProto
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BillingInfoProto.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.businessOfficialId != null && message.hasOwnProperty("businessOfficialId"))
                            if (!$util.isString(message.businessOfficialId))
                                return "businessOfficialId: string expected";
                        if (message.billingAddress != null && message.hasOwnProperty("billingAddress")) {
                            var error = $root.waiternow.common.AddressProto.verify(message.billingAddress);
                            if (error)
                                return "billingAddress." + error;
                        }
                        if (message.businessOfficialName != null && message.hasOwnProperty("businessOfficialName"))
                            if (!$util.isString(message.businessOfficialName))
                                return "businessOfficialName: string expected";
                        return null;
                    };

                    /**
                     * Creates a BillingInfoProto message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof waiternow.common.BusinessProto.SettingsProto.BillingInfoProto
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {waiternow.common.BusinessProto.SettingsProto.BillingInfoProto} BillingInfoProto
                     */
                    BillingInfoProto.fromObject = function fromObject(object) {
                        if (object instanceof $root.waiternow.common.BusinessProto.SettingsProto.BillingInfoProto)
                            return object;
                        var message = new $root.waiternow.common.BusinessProto.SettingsProto.BillingInfoProto();
                        if (object.businessOfficialId != null)
                            message.businessOfficialId = String(object.businessOfficialId);
                        if (object.billingAddress != null) {
                            if (typeof object.billingAddress !== "object")
                                throw TypeError(".waiternow.common.BusinessProto.SettingsProto.BillingInfoProto.billingAddress: object expected");
                            message.billingAddress = $root.waiternow.common.AddressProto.fromObject(object.billingAddress);
                        }
                        if (object.businessOfficialName != null)
                            message.businessOfficialName = String(object.businessOfficialName);
                        return message;
                    };

                    /**
                     * Creates a plain object from a BillingInfoProto message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof waiternow.common.BusinessProto.SettingsProto.BillingInfoProto
                     * @static
                     * @param {waiternow.common.BusinessProto.SettingsProto.BillingInfoProto} message BillingInfoProto
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BillingInfoProto.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.businessOfficialId = "";
                            object.billingAddress = null;
                            object.businessOfficialName = "";
                        }
                        if (message.businessOfficialId != null && message.hasOwnProperty("businessOfficialId"))
                            object.businessOfficialId = message.businessOfficialId;
                        if (message.billingAddress != null && message.hasOwnProperty("billingAddress"))
                            object.billingAddress = $root.waiternow.common.AddressProto.toObject(message.billingAddress, options);
                        if (message.businessOfficialName != null && message.hasOwnProperty("businessOfficialName"))
                            object.businessOfficialName = message.businessOfficialName;
                        return object;
                    };

                    /**
                     * Converts this BillingInfoProto to JSON.
                     * @function toJSON
                     * @memberof waiternow.common.BusinessProto.SettingsProto.BillingInfoProto
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BillingInfoProto.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for BillingInfoProto
                     * @function getTypeUrl
                     * @memberof waiternow.common.BusinessProto.SettingsProto.BillingInfoProto
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    BillingInfoProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/waiternow.common.BusinessProto.SettingsProto.BillingInfoProto";
                    };

                    return BillingInfoProto;
                })();

                SettingsProto.CustomPlanProto = (function() {

                    /**
                     * Properties of a CustomPlanProto.
                     * @memberof waiternow.common.BusinessProto.SettingsProto
                     * @interface ICustomPlanProto
                     * @property {number|null} [maxNumberOfLocations] CustomPlanProto maxNumberOfLocations
                     * @property {number|null} [maxNumberOfPointsOfServiceByLocation] CustomPlanProto maxNumberOfPointsOfServiceByLocation
                     * @property {waiternow.common.IMoneyProto|null} [cost] CustomPlanProto cost
                     */

                    /**
                     * Constructs a new CustomPlanProto.
                     * @memberof waiternow.common.BusinessProto.SettingsProto
                     * @classdesc Represents a CustomPlanProto.
                     * @implements ICustomPlanProto
                     * @constructor
                     * @param {waiternow.common.BusinessProto.SettingsProto.ICustomPlanProto=} [properties] Properties to set
                     */
                    function CustomPlanProto(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * CustomPlanProto maxNumberOfLocations.
                     * @member {number} maxNumberOfLocations
                     * @memberof waiternow.common.BusinessProto.SettingsProto.CustomPlanProto
                     * @instance
                     */
                    CustomPlanProto.prototype.maxNumberOfLocations = 0;

                    /**
                     * CustomPlanProto maxNumberOfPointsOfServiceByLocation.
                     * @member {number} maxNumberOfPointsOfServiceByLocation
                     * @memberof waiternow.common.BusinessProto.SettingsProto.CustomPlanProto
                     * @instance
                     */
                    CustomPlanProto.prototype.maxNumberOfPointsOfServiceByLocation = 0;

                    /**
                     * CustomPlanProto cost.
                     * @member {waiternow.common.IMoneyProto|null|undefined} cost
                     * @memberof waiternow.common.BusinessProto.SettingsProto.CustomPlanProto
                     * @instance
                     */
                    CustomPlanProto.prototype.cost = null;

                    /**
                     * Creates a new CustomPlanProto instance using the specified properties.
                     * @function create
                     * @memberof waiternow.common.BusinessProto.SettingsProto.CustomPlanProto
                     * @static
                     * @param {waiternow.common.BusinessProto.SettingsProto.ICustomPlanProto=} [properties] Properties to set
                     * @returns {waiternow.common.BusinessProto.SettingsProto.CustomPlanProto} CustomPlanProto instance
                     */
                    CustomPlanProto.create = function create(properties) {
                        return new CustomPlanProto(properties);
                    };

                    /**
                     * Encodes the specified CustomPlanProto message. Does not implicitly {@link waiternow.common.BusinessProto.SettingsProto.CustomPlanProto.verify|verify} messages.
                     * @function encode
                     * @memberof waiternow.common.BusinessProto.SettingsProto.CustomPlanProto
                     * @static
                     * @param {waiternow.common.BusinessProto.SettingsProto.ICustomPlanProto} message CustomPlanProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CustomPlanProto.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.maxNumberOfLocations != null && Object.hasOwnProperty.call(message, "maxNumberOfLocations"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.maxNumberOfLocations);
                        if (message.maxNumberOfPointsOfServiceByLocation != null && Object.hasOwnProperty.call(message, "maxNumberOfPointsOfServiceByLocation"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.maxNumberOfPointsOfServiceByLocation);
                        if (message.cost != null && Object.hasOwnProperty.call(message, "cost"))
                            $root.waiternow.common.MoneyProto.encode(message.cost, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        return writer;
                    };

                    /**
                     * Encodes the specified CustomPlanProto message, length delimited. Does not implicitly {@link waiternow.common.BusinessProto.SettingsProto.CustomPlanProto.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof waiternow.common.BusinessProto.SettingsProto.CustomPlanProto
                     * @static
                     * @param {waiternow.common.BusinessProto.SettingsProto.ICustomPlanProto} message CustomPlanProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CustomPlanProto.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a CustomPlanProto message from the specified reader or buffer.
                     * @function decode
                     * @memberof waiternow.common.BusinessProto.SettingsProto.CustomPlanProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {waiternow.common.BusinessProto.SettingsProto.CustomPlanProto} CustomPlanProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CustomPlanProto.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.BusinessProto.SettingsProto.CustomPlanProto();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.maxNumberOfLocations = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.maxNumberOfPointsOfServiceByLocation = reader.int32();
                                    break;
                                }
                            case 3: {
                                    message.cost = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a CustomPlanProto message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof waiternow.common.BusinessProto.SettingsProto.CustomPlanProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {waiternow.common.BusinessProto.SettingsProto.CustomPlanProto} CustomPlanProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CustomPlanProto.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a CustomPlanProto message.
                     * @function verify
                     * @memberof waiternow.common.BusinessProto.SettingsProto.CustomPlanProto
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CustomPlanProto.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.maxNumberOfLocations != null && message.hasOwnProperty("maxNumberOfLocations"))
                            if (!$util.isInteger(message.maxNumberOfLocations))
                                return "maxNumberOfLocations: integer expected";
                        if (message.maxNumberOfPointsOfServiceByLocation != null && message.hasOwnProperty("maxNumberOfPointsOfServiceByLocation"))
                            if (!$util.isInteger(message.maxNumberOfPointsOfServiceByLocation))
                                return "maxNumberOfPointsOfServiceByLocation: integer expected";
                        if (message.cost != null && message.hasOwnProperty("cost")) {
                            var error = $root.waiternow.common.MoneyProto.verify(message.cost);
                            if (error)
                                return "cost." + error;
                        }
                        return null;
                    };

                    /**
                     * Creates a CustomPlanProto message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof waiternow.common.BusinessProto.SettingsProto.CustomPlanProto
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {waiternow.common.BusinessProto.SettingsProto.CustomPlanProto} CustomPlanProto
                     */
                    CustomPlanProto.fromObject = function fromObject(object) {
                        if (object instanceof $root.waiternow.common.BusinessProto.SettingsProto.CustomPlanProto)
                            return object;
                        var message = new $root.waiternow.common.BusinessProto.SettingsProto.CustomPlanProto();
                        if (object.maxNumberOfLocations != null)
                            message.maxNumberOfLocations = object.maxNumberOfLocations | 0;
                        if (object.maxNumberOfPointsOfServiceByLocation != null)
                            message.maxNumberOfPointsOfServiceByLocation = object.maxNumberOfPointsOfServiceByLocation | 0;
                        if (object.cost != null) {
                            if (typeof object.cost !== "object")
                                throw TypeError(".waiternow.common.BusinessProto.SettingsProto.CustomPlanProto.cost: object expected");
                            message.cost = $root.waiternow.common.MoneyProto.fromObject(object.cost);
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a CustomPlanProto message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof waiternow.common.BusinessProto.SettingsProto.CustomPlanProto
                     * @static
                     * @param {waiternow.common.BusinessProto.SettingsProto.CustomPlanProto} message CustomPlanProto
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CustomPlanProto.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.maxNumberOfLocations = 0;
                            object.maxNumberOfPointsOfServiceByLocation = 0;
                            object.cost = null;
                        }
                        if (message.maxNumberOfLocations != null && message.hasOwnProperty("maxNumberOfLocations"))
                            object.maxNumberOfLocations = message.maxNumberOfLocations;
                        if (message.maxNumberOfPointsOfServiceByLocation != null && message.hasOwnProperty("maxNumberOfPointsOfServiceByLocation"))
                            object.maxNumberOfPointsOfServiceByLocation = message.maxNumberOfPointsOfServiceByLocation;
                        if (message.cost != null && message.hasOwnProperty("cost"))
                            object.cost = $root.waiternow.common.MoneyProto.toObject(message.cost, options);
                        return object;
                    };

                    /**
                     * Converts this CustomPlanProto to JSON.
                     * @function toJSON
                     * @memberof waiternow.common.BusinessProto.SettingsProto.CustomPlanProto
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CustomPlanProto.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for CustomPlanProto
                     * @function getTypeUrl
                     * @memberof waiternow.common.BusinessProto.SettingsProto.CustomPlanProto
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    CustomPlanProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/waiternow.common.BusinessProto.SettingsProto.CustomPlanProto";
                    };

                    return CustomPlanProto;
                })();

                return SettingsProto;
            })();

            return BusinessProto;
        })();

        common.BusinessesProto = (function() {

            /**
             * Properties of a BusinessesProto.
             * @memberof waiternow.common
             * @interface IBusinessesProto
             * @property {Array.<waiternow.common.IBusinessProto>|null} [businesses] BusinessesProto businesses
             * @property {string|null} [continuationToken] BusinessesProto continuationToken
             */

            /**
             * Constructs a new BusinessesProto.
             * @memberof waiternow.common
             * @classdesc Represents a BusinessesProto.
             * @implements IBusinessesProto
             * @constructor
             * @param {waiternow.common.IBusinessesProto=} [properties] Properties to set
             */
            function BusinessesProto(properties) {
                this.businesses = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * BusinessesProto businesses.
             * @member {Array.<waiternow.common.IBusinessProto>} businesses
             * @memberof waiternow.common.BusinessesProto
             * @instance
             */
            BusinessesProto.prototype.businesses = $util.emptyArray;

            /**
             * BusinessesProto continuationToken.
             * @member {string} continuationToken
             * @memberof waiternow.common.BusinessesProto
             * @instance
             */
            BusinessesProto.prototype.continuationToken = "";

            /**
             * Creates a new BusinessesProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.BusinessesProto
             * @static
             * @param {waiternow.common.IBusinessesProto=} [properties] Properties to set
             * @returns {waiternow.common.BusinessesProto} BusinessesProto instance
             */
            BusinessesProto.create = function create(properties) {
                return new BusinessesProto(properties);
            };

            /**
             * Encodes the specified BusinessesProto message. Does not implicitly {@link waiternow.common.BusinessesProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.BusinessesProto
             * @static
             * @param {waiternow.common.IBusinessesProto} message BusinessesProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BusinessesProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.businesses != null && message.businesses.length)
                    for (var i = 0; i < message.businesses.length; ++i)
                        $root.waiternow.common.BusinessProto.encode(message.businesses[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.continuationToken);
                return writer;
            };

            /**
             * Encodes the specified BusinessesProto message, length delimited. Does not implicitly {@link waiternow.common.BusinessesProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.BusinessesProto
             * @static
             * @param {waiternow.common.IBusinessesProto} message BusinessesProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BusinessesProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a BusinessesProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.BusinessesProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.BusinessesProto} BusinessesProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BusinessesProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.BusinessesProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            if (!(message.businesses && message.businesses.length))
                                message.businesses = [];
                            message.businesses.push($root.waiternow.common.BusinessProto.decode(reader, reader.uint32()));
                            break;
                        }
                    case 2: {
                            message.continuationToken = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a BusinessesProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.BusinessesProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.BusinessesProto} BusinessesProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BusinessesProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a BusinessesProto message.
             * @function verify
             * @memberof waiternow.common.BusinessesProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            BusinessesProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.businesses != null && message.hasOwnProperty("businesses")) {
                    if (!Array.isArray(message.businesses))
                        return "businesses: array expected";
                    for (var i = 0; i < message.businesses.length; ++i) {
                        var error = $root.waiternow.common.BusinessProto.verify(message.businesses[i]);
                        if (error)
                            return "businesses." + error;
                    }
                }
                if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                    if (!$util.isString(message.continuationToken))
                        return "continuationToken: string expected";
                return null;
            };

            /**
             * Creates a BusinessesProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.BusinessesProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.BusinessesProto} BusinessesProto
             */
            BusinessesProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.BusinessesProto)
                    return object;
                var message = new $root.waiternow.common.BusinessesProto();
                if (object.businesses) {
                    if (!Array.isArray(object.businesses))
                        throw TypeError(".waiternow.common.BusinessesProto.businesses: array expected");
                    message.businesses = [];
                    for (var i = 0; i < object.businesses.length; ++i) {
                        if (typeof object.businesses[i] !== "object")
                            throw TypeError(".waiternow.common.BusinessesProto.businesses: object expected");
                        message.businesses[i] = $root.waiternow.common.BusinessProto.fromObject(object.businesses[i]);
                    }
                }
                if (object.continuationToken != null)
                    message.continuationToken = String(object.continuationToken);
                return message;
            };

            /**
             * Creates a plain object from a BusinessesProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.BusinessesProto
             * @static
             * @param {waiternow.common.BusinessesProto} message BusinessesProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            BusinessesProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.businesses = [];
                if (options.defaults)
                    object.continuationToken = "";
                if (message.businesses && message.businesses.length) {
                    object.businesses = [];
                    for (var j = 0; j < message.businesses.length; ++j)
                        object.businesses[j] = $root.waiternow.common.BusinessProto.toObject(message.businesses[j], options);
                }
                if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                    object.continuationToken = message.continuationToken;
                return object;
            };

            /**
             * Converts this BusinessesProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.BusinessesProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            BusinessesProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for BusinessesProto
             * @function getTypeUrl
             * @memberof waiternow.common.BusinessesProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            BusinessesProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.BusinessesProto";
            };

            return BusinessesProto;
        })();

        common.UserBusinessesProto = (function() {

            /**
             * Properties of a UserBusinessesProto.
             * @memberof waiternow.common
             * @interface IUserBusinessesProto
             * @property {string|null} [userId] UserBusinessesProto userId
             * @property {Array.<waiternow.common.UserBusinessesProto.IManagedBusinessProto>|null} [businesses] UserBusinessesProto businesses
             */

            /**
             * Constructs a new UserBusinessesProto.
             * @memberof waiternow.common
             * @classdesc Represents a UserBusinessesProto.
             * @implements IUserBusinessesProto
             * @constructor
             * @param {waiternow.common.IUserBusinessesProto=} [properties] Properties to set
             */
            function UserBusinessesProto(properties) {
                this.businesses = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * UserBusinessesProto userId.
             * @member {string} userId
             * @memberof waiternow.common.UserBusinessesProto
             * @instance
             */
            UserBusinessesProto.prototype.userId = "";

            /**
             * UserBusinessesProto businesses.
             * @member {Array.<waiternow.common.UserBusinessesProto.IManagedBusinessProto>} businesses
             * @memberof waiternow.common.UserBusinessesProto
             * @instance
             */
            UserBusinessesProto.prototype.businesses = $util.emptyArray;

            /**
             * Creates a new UserBusinessesProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.UserBusinessesProto
             * @static
             * @param {waiternow.common.IUserBusinessesProto=} [properties] Properties to set
             * @returns {waiternow.common.UserBusinessesProto} UserBusinessesProto instance
             */
            UserBusinessesProto.create = function create(properties) {
                return new UserBusinessesProto(properties);
            };

            /**
             * Encodes the specified UserBusinessesProto message. Does not implicitly {@link waiternow.common.UserBusinessesProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.UserBusinessesProto
             * @static
             * @param {waiternow.common.IUserBusinessesProto} message UserBusinessesProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UserBusinessesProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.userId);
                if (message.businesses != null && message.businesses.length)
                    for (var i = 0; i < message.businesses.length; ++i)
                        $root.waiternow.common.UserBusinessesProto.ManagedBusinessProto.encode(message.businesses[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified UserBusinessesProto message, length delimited. Does not implicitly {@link waiternow.common.UserBusinessesProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.UserBusinessesProto
             * @static
             * @param {waiternow.common.IUserBusinessesProto} message UserBusinessesProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UserBusinessesProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a UserBusinessesProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.UserBusinessesProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.UserBusinessesProto} UserBusinessesProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UserBusinessesProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.UserBusinessesProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.userId = reader.string();
                            break;
                        }
                    case 2: {
                            if (!(message.businesses && message.businesses.length))
                                message.businesses = [];
                            message.businesses.push($root.waiternow.common.UserBusinessesProto.ManagedBusinessProto.decode(reader, reader.uint32()));
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a UserBusinessesProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.UserBusinessesProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.UserBusinessesProto} UserBusinessesProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UserBusinessesProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a UserBusinessesProto message.
             * @function verify
             * @memberof waiternow.common.UserBusinessesProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            UserBusinessesProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.userId != null && message.hasOwnProperty("userId"))
                    if (!$util.isString(message.userId))
                        return "userId: string expected";
                if (message.businesses != null && message.hasOwnProperty("businesses")) {
                    if (!Array.isArray(message.businesses))
                        return "businesses: array expected";
                    for (var i = 0; i < message.businesses.length; ++i) {
                        var error = $root.waiternow.common.UserBusinessesProto.ManagedBusinessProto.verify(message.businesses[i]);
                        if (error)
                            return "businesses." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a UserBusinessesProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.UserBusinessesProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.UserBusinessesProto} UserBusinessesProto
             */
            UserBusinessesProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.UserBusinessesProto)
                    return object;
                var message = new $root.waiternow.common.UserBusinessesProto();
                if (object.userId != null)
                    message.userId = String(object.userId);
                if (object.businesses) {
                    if (!Array.isArray(object.businesses))
                        throw TypeError(".waiternow.common.UserBusinessesProto.businesses: array expected");
                    message.businesses = [];
                    for (var i = 0; i < object.businesses.length; ++i) {
                        if (typeof object.businesses[i] !== "object")
                            throw TypeError(".waiternow.common.UserBusinessesProto.businesses: object expected");
                        message.businesses[i] = $root.waiternow.common.UserBusinessesProto.ManagedBusinessProto.fromObject(object.businesses[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a UserBusinessesProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.UserBusinessesProto
             * @static
             * @param {waiternow.common.UserBusinessesProto} message UserBusinessesProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            UserBusinessesProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.businesses = [];
                if (options.defaults)
                    object.userId = "";
                if (message.userId != null && message.hasOwnProperty("userId"))
                    object.userId = message.userId;
                if (message.businesses && message.businesses.length) {
                    object.businesses = [];
                    for (var j = 0; j < message.businesses.length; ++j)
                        object.businesses[j] = $root.waiternow.common.UserBusinessesProto.ManagedBusinessProto.toObject(message.businesses[j], options);
                }
                return object;
            };

            /**
             * Converts this UserBusinessesProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.UserBusinessesProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            UserBusinessesProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for UserBusinessesProto
             * @function getTypeUrl
             * @memberof waiternow.common.UserBusinessesProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            UserBusinessesProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.UserBusinessesProto";
            };

            UserBusinessesProto.ManagedBusinessProto = (function() {

                /**
                 * Properties of a ManagedBusinessProto.
                 * @memberof waiternow.common.UserBusinessesProto
                 * @interface IManagedBusinessProto
                 * @property {waiternow.common.IBusinessProto|null} [business] ManagedBusinessProto business
                 * @property {waiternow.common.Role|null} [userRole] ManagedBusinessProto userRole
                 */

                /**
                 * Constructs a new ManagedBusinessProto.
                 * @memberof waiternow.common.UserBusinessesProto
                 * @classdesc Represents a ManagedBusinessProto.
                 * @implements IManagedBusinessProto
                 * @constructor
                 * @param {waiternow.common.UserBusinessesProto.IManagedBusinessProto=} [properties] Properties to set
                 */
                function ManagedBusinessProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ManagedBusinessProto business.
                 * @member {waiternow.common.IBusinessProto|null|undefined} business
                 * @memberof waiternow.common.UserBusinessesProto.ManagedBusinessProto
                 * @instance
                 */
                ManagedBusinessProto.prototype.business = null;

                /**
                 * ManagedBusinessProto userRole.
                 * @member {waiternow.common.Role} userRole
                 * @memberof waiternow.common.UserBusinessesProto.ManagedBusinessProto
                 * @instance
                 */
                ManagedBusinessProto.prototype.userRole = 0;

                /**
                 * Creates a new ManagedBusinessProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.UserBusinessesProto.ManagedBusinessProto
                 * @static
                 * @param {waiternow.common.UserBusinessesProto.IManagedBusinessProto=} [properties] Properties to set
                 * @returns {waiternow.common.UserBusinessesProto.ManagedBusinessProto} ManagedBusinessProto instance
                 */
                ManagedBusinessProto.create = function create(properties) {
                    return new ManagedBusinessProto(properties);
                };

                /**
                 * Encodes the specified ManagedBusinessProto message. Does not implicitly {@link waiternow.common.UserBusinessesProto.ManagedBusinessProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.UserBusinessesProto.ManagedBusinessProto
                 * @static
                 * @param {waiternow.common.UserBusinessesProto.IManagedBusinessProto} message ManagedBusinessProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ManagedBusinessProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.business != null && Object.hasOwnProperty.call(message, "business"))
                        $root.waiternow.common.BusinessProto.encode(message.business, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.userRole != null && Object.hasOwnProperty.call(message, "userRole"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.userRole);
                    return writer;
                };

                /**
                 * Encodes the specified ManagedBusinessProto message, length delimited. Does not implicitly {@link waiternow.common.UserBusinessesProto.ManagedBusinessProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.UserBusinessesProto.ManagedBusinessProto
                 * @static
                 * @param {waiternow.common.UserBusinessesProto.IManagedBusinessProto} message ManagedBusinessProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ManagedBusinessProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ManagedBusinessProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.UserBusinessesProto.ManagedBusinessProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.UserBusinessesProto.ManagedBusinessProto} ManagedBusinessProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ManagedBusinessProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.UserBusinessesProto.ManagedBusinessProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.business = $root.waiternow.common.BusinessProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.userRole = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ManagedBusinessProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.UserBusinessesProto.ManagedBusinessProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.UserBusinessesProto.ManagedBusinessProto} ManagedBusinessProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ManagedBusinessProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ManagedBusinessProto message.
                 * @function verify
                 * @memberof waiternow.common.UserBusinessesProto.ManagedBusinessProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ManagedBusinessProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.business != null && message.hasOwnProperty("business")) {
                        var error = $root.waiternow.common.BusinessProto.verify(message.business);
                        if (error)
                            return "business." + error;
                    }
                    if (message.userRole != null && message.hasOwnProperty("userRole"))
                        switch (message.userRole) {
                        default:
                            return "userRole: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                            break;
                        }
                    return null;
                };

                /**
                 * Creates a ManagedBusinessProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.UserBusinessesProto.ManagedBusinessProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.UserBusinessesProto.ManagedBusinessProto} ManagedBusinessProto
                 */
                ManagedBusinessProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.UserBusinessesProto.ManagedBusinessProto)
                        return object;
                    var message = new $root.waiternow.common.UserBusinessesProto.ManagedBusinessProto();
                    if (object.business != null) {
                        if (typeof object.business !== "object")
                            throw TypeError(".waiternow.common.UserBusinessesProto.ManagedBusinessProto.business: object expected");
                        message.business = $root.waiternow.common.BusinessProto.fromObject(object.business);
                    }
                    switch (object.userRole) {
                    default:
                        if (typeof object.userRole === "number") {
                            message.userRole = object.userRole;
                            break;
                        }
                        break;
                    case "ROLE_UNSPECIFIED":
                    case 0:
                        message.userRole = 0;
                        break;
                    case "OWNER":
                    case 1:
                        message.userRole = 1;
                        break;
                    case "ADMIN":
                    case 2:
                        message.userRole = 2;
                        break;
                    case "VIEWER":
                    case 3:
                        message.userRole = 3;
                        break;
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a ManagedBusinessProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.UserBusinessesProto.ManagedBusinessProto
                 * @static
                 * @param {waiternow.common.UserBusinessesProto.ManagedBusinessProto} message ManagedBusinessProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ManagedBusinessProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.business = null;
                        object.userRole = options.enums === String ? "ROLE_UNSPECIFIED" : 0;
                    }
                    if (message.business != null && message.hasOwnProperty("business"))
                        object.business = $root.waiternow.common.BusinessProto.toObject(message.business, options);
                    if (message.userRole != null && message.hasOwnProperty("userRole"))
                        object.userRole = options.enums === String ? $root.waiternow.common.Role[message.userRole] === undefined ? message.userRole : $root.waiternow.common.Role[message.userRole] : message.userRole;
                    return object;
                };

                /**
                 * Converts this ManagedBusinessProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.UserBusinessesProto.ManagedBusinessProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ManagedBusinessProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ManagedBusinessProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.UserBusinessesProto.ManagedBusinessProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ManagedBusinessProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.UserBusinessesProto.ManagedBusinessProto";
                };

                return ManagedBusinessProto;
            })();

            return UserBusinessesProto;
        })();

        common.BusinessUsersProto = (function() {

            /**
             * Properties of a BusinessUsersProto.
             * @memberof waiternow.common
             * @interface IBusinessUsersProto
             * @property {string|null} [businessId] BusinessUsersProto businessId
             * @property {Array.<waiternow.common.BusinessUsersProto.IManagerUserProto>|null} [users] BusinessUsersProto users
             */

            /**
             * Constructs a new BusinessUsersProto.
             * @memberof waiternow.common
             * @classdesc Represents a BusinessUsersProto.
             * @implements IBusinessUsersProto
             * @constructor
             * @param {waiternow.common.IBusinessUsersProto=} [properties] Properties to set
             */
            function BusinessUsersProto(properties) {
                this.users = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * BusinessUsersProto businessId.
             * @member {string} businessId
             * @memberof waiternow.common.BusinessUsersProto
             * @instance
             */
            BusinessUsersProto.prototype.businessId = "";

            /**
             * BusinessUsersProto users.
             * @member {Array.<waiternow.common.BusinessUsersProto.IManagerUserProto>} users
             * @memberof waiternow.common.BusinessUsersProto
             * @instance
             */
            BusinessUsersProto.prototype.users = $util.emptyArray;

            /**
             * Creates a new BusinessUsersProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.BusinessUsersProto
             * @static
             * @param {waiternow.common.IBusinessUsersProto=} [properties] Properties to set
             * @returns {waiternow.common.BusinessUsersProto} BusinessUsersProto instance
             */
            BusinessUsersProto.create = function create(properties) {
                return new BusinessUsersProto(properties);
            };

            /**
             * Encodes the specified BusinessUsersProto message. Does not implicitly {@link waiternow.common.BusinessUsersProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.BusinessUsersProto
             * @static
             * @param {waiternow.common.IBusinessUsersProto} message BusinessUsersProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BusinessUsersProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessId);
                if (message.users != null && message.users.length)
                    for (var i = 0; i < message.users.length; ++i)
                        $root.waiternow.common.BusinessUsersProto.ManagerUserProto.encode(message.users[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified BusinessUsersProto message, length delimited. Does not implicitly {@link waiternow.common.BusinessUsersProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.BusinessUsersProto
             * @static
             * @param {waiternow.common.IBusinessUsersProto} message BusinessUsersProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BusinessUsersProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a BusinessUsersProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.BusinessUsersProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.BusinessUsersProto} BusinessUsersProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BusinessUsersProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.BusinessUsersProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.businessId = reader.string();
                            break;
                        }
                    case 2: {
                            if (!(message.users && message.users.length))
                                message.users = [];
                            message.users.push($root.waiternow.common.BusinessUsersProto.ManagerUserProto.decode(reader, reader.uint32()));
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a BusinessUsersProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.BusinessUsersProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.BusinessUsersProto} BusinessUsersProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BusinessUsersProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a BusinessUsersProto message.
             * @function verify
             * @memberof waiternow.common.BusinessUsersProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            BusinessUsersProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.businessId != null && message.hasOwnProperty("businessId"))
                    if (!$util.isString(message.businessId))
                        return "businessId: string expected";
                if (message.users != null && message.hasOwnProperty("users")) {
                    if (!Array.isArray(message.users))
                        return "users: array expected";
                    for (var i = 0; i < message.users.length; ++i) {
                        var error = $root.waiternow.common.BusinessUsersProto.ManagerUserProto.verify(message.users[i]);
                        if (error)
                            return "users." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a BusinessUsersProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.BusinessUsersProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.BusinessUsersProto} BusinessUsersProto
             */
            BusinessUsersProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.BusinessUsersProto)
                    return object;
                var message = new $root.waiternow.common.BusinessUsersProto();
                if (object.businessId != null)
                    message.businessId = String(object.businessId);
                if (object.users) {
                    if (!Array.isArray(object.users))
                        throw TypeError(".waiternow.common.BusinessUsersProto.users: array expected");
                    message.users = [];
                    for (var i = 0; i < object.users.length; ++i) {
                        if (typeof object.users[i] !== "object")
                            throw TypeError(".waiternow.common.BusinessUsersProto.users: object expected");
                        message.users[i] = $root.waiternow.common.BusinessUsersProto.ManagerUserProto.fromObject(object.users[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a BusinessUsersProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.BusinessUsersProto
             * @static
             * @param {waiternow.common.BusinessUsersProto} message BusinessUsersProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            BusinessUsersProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.users = [];
                if (options.defaults)
                    object.businessId = "";
                if (message.businessId != null && message.hasOwnProperty("businessId"))
                    object.businessId = message.businessId;
                if (message.users && message.users.length) {
                    object.users = [];
                    for (var j = 0; j < message.users.length; ++j)
                        object.users[j] = $root.waiternow.common.BusinessUsersProto.ManagerUserProto.toObject(message.users[j], options);
                }
                return object;
            };

            /**
             * Converts this BusinessUsersProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.BusinessUsersProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            BusinessUsersProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for BusinessUsersProto
             * @function getTypeUrl
             * @memberof waiternow.common.BusinessUsersProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            BusinessUsersProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.BusinessUsersProto";
            };

            BusinessUsersProto.ManagerUserProto = (function() {

                /**
                 * Properties of a ManagerUserProto.
                 * @memberof waiternow.common.BusinessUsersProto
                 * @interface IManagerUserProto
                 * @property {string|null} [email] ManagerUserProto email
                 * @property {waiternow.common.Role|null} [role] ManagerUserProto role
                 * @property {string|null} [id] ManagerUserProto id
                 * @property {string|null} [name] ManagerUserProto name
                 * @property {string|null} [lastName] ManagerUserProto lastName
                 * @property {waiternow.common.IPhoneNumberProto|null} [phoneNumber] ManagerUserProto phoneNumber
                 */

                /**
                 * Constructs a new ManagerUserProto.
                 * @memberof waiternow.common.BusinessUsersProto
                 * @classdesc Represents a ManagerUserProto.
                 * @implements IManagerUserProto
                 * @constructor
                 * @param {waiternow.common.BusinessUsersProto.IManagerUserProto=} [properties] Properties to set
                 */
                function ManagerUserProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ManagerUserProto email.
                 * @member {string} email
                 * @memberof waiternow.common.BusinessUsersProto.ManagerUserProto
                 * @instance
                 */
                ManagerUserProto.prototype.email = "";

                /**
                 * ManagerUserProto role.
                 * @member {waiternow.common.Role} role
                 * @memberof waiternow.common.BusinessUsersProto.ManagerUserProto
                 * @instance
                 */
                ManagerUserProto.prototype.role = 0;

                /**
                 * ManagerUserProto id.
                 * @member {string} id
                 * @memberof waiternow.common.BusinessUsersProto.ManagerUserProto
                 * @instance
                 */
                ManagerUserProto.prototype.id = "";

                /**
                 * ManagerUserProto name.
                 * @member {string} name
                 * @memberof waiternow.common.BusinessUsersProto.ManagerUserProto
                 * @instance
                 */
                ManagerUserProto.prototype.name = "";

                /**
                 * ManagerUserProto lastName.
                 * @member {string} lastName
                 * @memberof waiternow.common.BusinessUsersProto.ManagerUserProto
                 * @instance
                 */
                ManagerUserProto.prototype.lastName = "";

                /**
                 * ManagerUserProto phoneNumber.
                 * @member {waiternow.common.IPhoneNumberProto|null|undefined} phoneNumber
                 * @memberof waiternow.common.BusinessUsersProto.ManagerUserProto
                 * @instance
                 */
                ManagerUserProto.prototype.phoneNumber = null;

                /**
                 * Creates a new ManagerUserProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.BusinessUsersProto.ManagerUserProto
                 * @static
                 * @param {waiternow.common.BusinessUsersProto.IManagerUserProto=} [properties] Properties to set
                 * @returns {waiternow.common.BusinessUsersProto.ManagerUserProto} ManagerUserProto instance
                 */
                ManagerUserProto.create = function create(properties) {
                    return new ManagerUserProto(properties);
                };

                /**
                 * Encodes the specified ManagerUserProto message. Does not implicitly {@link waiternow.common.BusinessUsersProto.ManagerUserProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.BusinessUsersProto.ManagerUserProto
                 * @static
                 * @param {waiternow.common.BusinessUsersProto.IManagerUserProto} message ManagerUserProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ManagerUserProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
                    if (message.role != null && Object.hasOwnProperty.call(message, "role"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.role);
                    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.id);
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.name);
                    if (message.lastName != null && Object.hasOwnProperty.call(message, "lastName"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.lastName);
                    if (message.phoneNumber != null && Object.hasOwnProperty.call(message, "phoneNumber"))
                        $root.waiternow.common.PhoneNumberProto.encode(message.phoneNumber, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified ManagerUserProto message, length delimited. Does not implicitly {@link waiternow.common.BusinessUsersProto.ManagerUserProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.BusinessUsersProto.ManagerUserProto
                 * @static
                 * @param {waiternow.common.BusinessUsersProto.IManagerUserProto} message ManagerUserProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ManagerUserProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ManagerUserProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.BusinessUsersProto.ManagerUserProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.BusinessUsersProto.ManagerUserProto} ManagerUserProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ManagerUserProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.BusinessUsersProto.ManagerUserProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.email = reader.string();
                                break;
                            }
                        case 2: {
                                message.role = reader.int32();
                                break;
                            }
                        case 3: {
                                message.id = reader.string();
                                break;
                            }
                        case 4: {
                                message.name = reader.string();
                                break;
                            }
                        case 5: {
                                message.lastName = reader.string();
                                break;
                            }
                        case 6: {
                                message.phoneNumber = $root.waiternow.common.PhoneNumberProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ManagerUserProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.BusinessUsersProto.ManagerUserProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.BusinessUsersProto.ManagerUserProto} ManagerUserProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ManagerUserProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ManagerUserProto message.
                 * @function verify
                 * @memberof waiternow.common.BusinessUsersProto.ManagerUserProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ManagerUserProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.email != null && message.hasOwnProperty("email"))
                        if (!$util.isString(message.email))
                            return "email: string expected";
                    if (message.role != null && message.hasOwnProperty("role"))
                        switch (message.role) {
                        default:
                            return "role: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                            break;
                        }
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (!$util.isString(message.id))
                            return "id: string expected";
                    if (message.name != null && message.hasOwnProperty("name"))
                        if (!$util.isString(message.name))
                            return "name: string expected";
                    if (message.lastName != null && message.hasOwnProperty("lastName"))
                        if (!$util.isString(message.lastName))
                            return "lastName: string expected";
                    if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber")) {
                        var error = $root.waiternow.common.PhoneNumberProto.verify(message.phoneNumber);
                        if (error)
                            return "phoneNumber." + error;
                    }
                    return null;
                };

                /**
                 * Creates a ManagerUserProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.BusinessUsersProto.ManagerUserProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.BusinessUsersProto.ManagerUserProto} ManagerUserProto
                 */
                ManagerUserProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.BusinessUsersProto.ManagerUserProto)
                        return object;
                    var message = new $root.waiternow.common.BusinessUsersProto.ManagerUserProto();
                    if (object.email != null)
                        message.email = String(object.email);
                    switch (object.role) {
                    default:
                        if (typeof object.role === "number") {
                            message.role = object.role;
                            break;
                        }
                        break;
                    case "ROLE_UNSPECIFIED":
                    case 0:
                        message.role = 0;
                        break;
                    case "OWNER":
                    case 1:
                        message.role = 1;
                        break;
                    case "ADMIN":
                    case 2:
                        message.role = 2;
                        break;
                    case "VIEWER":
                    case 3:
                        message.role = 3;
                        break;
                    }
                    if (object.id != null)
                        message.id = String(object.id);
                    if (object.name != null)
                        message.name = String(object.name);
                    if (object.lastName != null)
                        message.lastName = String(object.lastName);
                    if (object.phoneNumber != null) {
                        if (typeof object.phoneNumber !== "object")
                            throw TypeError(".waiternow.common.BusinessUsersProto.ManagerUserProto.phoneNumber: object expected");
                        message.phoneNumber = $root.waiternow.common.PhoneNumberProto.fromObject(object.phoneNumber);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a ManagerUserProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.BusinessUsersProto.ManagerUserProto
                 * @static
                 * @param {waiternow.common.BusinessUsersProto.ManagerUserProto} message ManagerUserProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ManagerUserProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.email = "";
                        object.role = options.enums === String ? "ROLE_UNSPECIFIED" : 0;
                        object.id = "";
                        object.name = "";
                        object.lastName = "";
                        object.phoneNumber = null;
                    }
                    if (message.email != null && message.hasOwnProperty("email"))
                        object.email = message.email;
                    if (message.role != null && message.hasOwnProperty("role"))
                        object.role = options.enums === String ? $root.waiternow.common.Role[message.role] === undefined ? message.role : $root.waiternow.common.Role[message.role] : message.role;
                    if (message.id != null && message.hasOwnProperty("id"))
                        object.id = message.id;
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = message.name;
                    if (message.lastName != null && message.hasOwnProperty("lastName"))
                        object.lastName = message.lastName;
                    if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
                        object.phoneNumber = $root.waiternow.common.PhoneNumberProto.toObject(message.phoneNumber, options);
                    return object;
                };

                /**
                 * Converts this ManagerUserProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.BusinessUsersProto.ManagerUserProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ManagerUserProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ManagerUserProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.BusinessUsersProto.ManagerUserProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ManagerUserProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.BusinessUsersProto.ManagerUserProto";
                };

                return ManagerUserProto;
            })();

            return BusinessUsersProto;
        })();

        common.CampaignProto = (function() {

            /**
             * Properties of a CampaignProto.
             * @memberof waiternow.common
             * @interface ICampaignProto
             * @property {string|null} [id] CampaignProto id
             * @property {google.protobuf.ITimestamp|null} [creationTime] CampaignProto creationTime
             * @property {google.protobuf.ITimestamp|null} [lastUpdateTime] CampaignProto lastUpdateTime
             * @property {string|null} [businessId] CampaignProto businessId
             * @property {string|null} [locationId] CampaignProto locationId
             * @property {string|null} [code] CampaignProto code
             * @property {waiternow.common.ITextProto|null} [description] CampaignProto description
             * @property {waiternow.common.IDerivedQuantityConfigProto|null} [discount] CampaignProto discount
             * @property {Array.<waiternow.common.CampaignProto.IConditionProto>|null} [conditions] CampaignProto conditions
             * @property {boolean|null} [isActive] CampaignProto isActive
             */

            /**
             * Constructs a new CampaignProto.
             * @memberof waiternow.common
             * @classdesc Represents a CampaignProto.
             * @implements ICampaignProto
             * @constructor
             * @param {waiternow.common.ICampaignProto=} [properties] Properties to set
             */
            function CampaignProto(properties) {
                this.conditions = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * CampaignProto id.
             * @member {string} id
             * @memberof waiternow.common.CampaignProto
             * @instance
             */
            CampaignProto.prototype.id = "";

            /**
             * CampaignProto creationTime.
             * @member {google.protobuf.ITimestamp|null|undefined} creationTime
             * @memberof waiternow.common.CampaignProto
             * @instance
             */
            CampaignProto.prototype.creationTime = null;

            /**
             * CampaignProto lastUpdateTime.
             * @member {google.protobuf.ITimestamp|null|undefined} lastUpdateTime
             * @memberof waiternow.common.CampaignProto
             * @instance
             */
            CampaignProto.prototype.lastUpdateTime = null;

            /**
             * CampaignProto businessId.
             * @member {string|null|undefined} businessId
             * @memberof waiternow.common.CampaignProto
             * @instance
             */
            CampaignProto.prototype.businessId = null;

            /**
             * CampaignProto locationId.
             * @member {string|null|undefined} locationId
             * @memberof waiternow.common.CampaignProto
             * @instance
             */
            CampaignProto.prototype.locationId = null;

            /**
             * CampaignProto code.
             * @member {string} code
             * @memberof waiternow.common.CampaignProto
             * @instance
             */
            CampaignProto.prototype.code = "";

            /**
             * CampaignProto description.
             * @member {waiternow.common.ITextProto|null|undefined} description
             * @memberof waiternow.common.CampaignProto
             * @instance
             */
            CampaignProto.prototype.description = null;

            /**
             * CampaignProto discount.
             * @member {waiternow.common.IDerivedQuantityConfigProto|null|undefined} discount
             * @memberof waiternow.common.CampaignProto
             * @instance
             */
            CampaignProto.prototype.discount = null;

            /**
             * CampaignProto conditions.
             * @member {Array.<waiternow.common.CampaignProto.IConditionProto>} conditions
             * @memberof waiternow.common.CampaignProto
             * @instance
             */
            CampaignProto.prototype.conditions = $util.emptyArray;

            /**
             * CampaignProto isActive.
             * @member {boolean} isActive
             * @memberof waiternow.common.CampaignProto
             * @instance
             */
            CampaignProto.prototype.isActive = false;

            // OneOf field names bound to virtual getters and setters
            var $oneOfFields;

            /**
             * CampaignProto campaignScope.
             * @member {"businessId"|"locationId"|undefined} campaignScope
             * @memberof waiternow.common.CampaignProto
             * @instance
             */
            Object.defineProperty(CampaignProto.prototype, "campaignScope", {
                get: $util.oneOfGetter($oneOfFields = ["businessId", "locationId"]),
                set: $util.oneOfSetter($oneOfFields)
            });

            /**
             * Creates a new CampaignProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.CampaignProto
             * @static
             * @param {waiternow.common.ICampaignProto=} [properties] Properties to set
             * @returns {waiternow.common.CampaignProto} CampaignProto instance
             */
            CampaignProto.create = function create(properties) {
                return new CampaignProto(properties);
            };

            /**
             * Encodes the specified CampaignProto message. Does not implicitly {@link waiternow.common.CampaignProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.CampaignProto
             * @static
             * @param {waiternow.common.ICampaignProto} message CampaignProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CampaignProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                if (message.creationTime != null && Object.hasOwnProperty.call(message, "creationTime"))
                    $root.google.protobuf.Timestamp.encode(message.creationTime, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                    $root.google.protobuf.Timestamp.encode(message.lastUpdateTime, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.businessId);
                if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.locationId);
                if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.code);
                if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                    $root.waiternow.common.TextProto.encode(message.description, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                if (message.discount != null && Object.hasOwnProperty.call(message, "discount"))
                    $root.waiternow.common.DerivedQuantityConfigProto.encode(message.discount, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                if (message.conditions != null && message.conditions.length)
                    for (var i = 0; i < message.conditions.length; ++i)
                        $root.waiternow.common.CampaignProto.ConditionProto.encode(message.conditions[i], writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                if (message.isActive != null && Object.hasOwnProperty.call(message, "isActive"))
                    writer.uint32(/* id 10, wireType 0 =*/80).bool(message.isActive);
                return writer;
            };

            /**
             * Encodes the specified CampaignProto message, length delimited. Does not implicitly {@link waiternow.common.CampaignProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.CampaignProto
             * @static
             * @param {waiternow.common.ICampaignProto} message CampaignProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CampaignProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CampaignProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.CampaignProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.CampaignProto} CampaignProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CampaignProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CampaignProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.id = reader.string();
                            break;
                        }
                    case 2: {
                            message.creationTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 3: {
                            message.lastUpdateTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 4: {
                            message.businessId = reader.string();
                            break;
                        }
                    case 5: {
                            message.locationId = reader.string();
                            break;
                        }
                    case 6: {
                            message.code = reader.string();
                            break;
                        }
                    case 7: {
                            message.description = $root.waiternow.common.TextProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 8: {
                            message.discount = $root.waiternow.common.DerivedQuantityConfigProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 9: {
                            if (!(message.conditions && message.conditions.length))
                                message.conditions = [];
                            message.conditions.push($root.waiternow.common.CampaignProto.ConditionProto.decode(reader, reader.uint32()));
                            break;
                        }
                    case 10: {
                            message.isActive = reader.bool();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CampaignProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.CampaignProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.CampaignProto} CampaignProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CampaignProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CampaignProto message.
             * @function verify
             * @memberof waiternow.common.CampaignProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CampaignProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                var properties = {};
                if (message.id != null && message.hasOwnProperty("id"))
                    if (!$util.isString(message.id))
                        return "id: string expected";
                if (message.creationTime != null && message.hasOwnProperty("creationTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.creationTime);
                    if (error)
                        return "creationTime." + error;
                }
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.lastUpdateTime);
                    if (error)
                        return "lastUpdateTime." + error;
                }
                if (message.businessId != null && message.hasOwnProperty("businessId")) {
                    properties.campaignScope = 1;
                    if (!$util.isString(message.businessId))
                        return "businessId: string expected";
                }
                if (message.locationId != null && message.hasOwnProperty("locationId")) {
                    if (properties.campaignScope === 1)
                        return "campaignScope: multiple values";
                    properties.campaignScope = 1;
                    if (!$util.isString(message.locationId))
                        return "locationId: string expected";
                }
                if (message.code != null && message.hasOwnProperty("code"))
                    if (!$util.isString(message.code))
                        return "code: string expected";
                if (message.description != null && message.hasOwnProperty("description")) {
                    var error = $root.waiternow.common.TextProto.verify(message.description);
                    if (error)
                        return "description." + error;
                }
                if (message.discount != null && message.hasOwnProperty("discount")) {
                    var error = $root.waiternow.common.DerivedQuantityConfigProto.verify(message.discount);
                    if (error)
                        return "discount." + error;
                }
                if (message.conditions != null && message.hasOwnProperty("conditions")) {
                    if (!Array.isArray(message.conditions))
                        return "conditions: array expected";
                    for (var i = 0; i < message.conditions.length; ++i) {
                        var error = $root.waiternow.common.CampaignProto.ConditionProto.verify(message.conditions[i]);
                        if (error)
                            return "conditions." + error;
                    }
                }
                if (message.isActive != null && message.hasOwnProperty("isActive"))
                    if (typeof message.isActive !== "boolean")
                        return "isActive: boolean expected";
                return null;
            };

            /**
             * Creates a CampaignProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.CampaignProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.CampaignProto} CampaignProto
             */
            CampaignProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.CampaignProto)
                    return object;
                var message = new $root.waiternow.common.CampaignProto();
                if (object.id != null)
                    message.id = String(object.id);
                if (object.creationTime != null) {
                    if (typeof object.creationTime !== "object")
                        throw TypeError(".waiternow.common.CampaignProto.creationTime: object expected");
                    message.creationTime = $root.google.protobuf.Timestamp.fromObject(object.creationTime);
                }
                if (object.lastUpdateTime != null) {
                    if (typeof object.lastUpdateTime !== "object")
                        throw TypeError(".waiternow.common.CampaignProto.lastUpdateTime: object expected");
                    message.lastUpdateTime = $root.google.protobuf.Timestamp.fromObject(object.lastUpdateTime);
                }
                if (object.businessId != null)
                    message.businessId = String(object.businessId);
                if (object.locationId != null)
                    message.locationId = String(object.locationId);
                if (object.code != null)
                    message.code = String(object.code);
                if (object.description != null) {
                    if (typeof object.description !== "object")
                        throw TypeError(".waiternow.common.CampaignProto.description: object expected");
                    message.description = $root.waiternow.common.TextProto.fromObject(object.description);
                }
                if (object.discount != null) {
                    if (typeof object.discount !== "object")
                        throw TypeError(".waiternow.common.CampaignProto.discount: object expected");
                    message.discount = $root.waiternow.common.DerivedQuantityConfigProto.fromObject(object.discount);
                }
                if (object.conditions) {
                    if (!Array.isArray(object.conditions))
                        throw TypeError(".waiternow.common.CampaignProto.conditions: array expected");
                    message.conditions = [];
                    for (var i = 0; i < object.conditions.length; ++i) {
                        if (typeof object.conditions[i] !== "object")
                            throw TypeError(".waiternow.common.CampaignProto.conditions: object expected");
                        message.conditions[i] = $root.waiternow.common.CampaignProto.ConditionProto.fromObject(object.conditions[i]);
                    }
                }
                if (object.isActive != null)
                    message.isActive = Boolean(object.isActive);
                return message;
            };

            /**
             * Creates a plain object from a CampaignProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.CampaignProto
             * @static
             * @param {waiternow.common.CampaignProto} message CampaignProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CampaignProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.conditions = [];
                if (options.defaults) {
                    object.id = "";
                    object.creationTime = null;
                    object.lastUpdateTime = null;
                    object.code = "";
                    object.description = null;
                    object.discount = null;
                    object.isActive = false;
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                    object.creationTime = $root.google.protobuf.Timestamp.toObject(message.creationTime, options);
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                    object.lastUpdateTime = $root.google.protobuf.Timestamp.toObject(message.lastUpdateTime, options);
                if (message.businessId != null && message.hasOwnProperty("businessId")) {
                    object.businessId = message.businessId;
                    if (options.oneofs)
                        object.campaignScope = "businessId";
                }
                if (message.locationId != null && message.hasOwnProperty("locationId")) {
                    object.locationId = message.locationId;
                    if (options.oneofs)
                        object.campaignScope = "locationId";
                }
                if (message.code != null && message.hasOwnProperty("code"))
                    object.code = message.code;
                if (message.description != null && message.hasOwnProperty("description"))
                    object.description = $root.waiternow.common.TextProto.toObject(message.description, options);
                if (message.discount != null && message.hasOwnProperty("discount"))
                    object.discount = $root.waiternow.common.DerivedQuantityConfigProto.toObject(message.discount, options);
                if (message.conditions && message.conditions.length) {
                    object.conditions = [];
                    for (var j = 0; j < message.conditions.length; ++j)
                        object.conditions[j] = $root.waiternow.common.CampaignProto.ConditionProto.toObject(message.conditions[j], options);
                }
                if (message.isActive != null && message.hasOwnProperty("isActive"))
                    object.isActive = message.isActive;
                return object;
            };

            /**
             * Converts this CampaignProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.CampaignProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CampaignProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for CampaignProto
             * @function getTypeUrl
             * @memberof waiternow.common.CampaignProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            CampaignProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.CampaignProto";
            };

            CampaignProto.ConditionProto = (function() {

                /**
                 * Properties of a ConditionProto.
                 * @memberof waiternow.common.CampaignProto
                 * @interface IConditionProto
                 * @property {waiternow.common.CampaignProto.ConditionProto.Rule|null} [rule] ConditionProto rule
                 * @property {waiternow.common.IScheduleProto|null} [schedule] ConditionProto schedule
                 */

                /**
                 * Constructs a new ConditionProto.
                 * @memberof waiternow.common.CampaignProto
                 * @classdesc Represents a ConditionProto.
                 * @implements IConditionProto
                 * @constructor
                 * @param {waiternow.common.CampaignProto.IConditionProto=} [properties] Properties to set
                 */
                function ConditionProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ConditionProto rule.
                 * @member {waiternow.common.CampaignProto.ConditionProto.Rule} rule
                 * @memberof waiternow.common.CampaignProto.ConditionProto
                 * @instance
                 */
                ConditionProto.prototype.rule = 0;

                /**
                 * ConditionProto schedule.
                 * @member {waiternow.common.IScheduleProto|null|undefined} schedule
                 * @memberof waiternow.common.CampaignProto.ConditionProto
                 * @instance
                 */
                ConditionProto.prototype.schedule = null;

                /**
                 * Creates a new ConditionProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.CampaignProto.ConditionProto
                 * @static
                 * @param {waiternow.common.CampaignProto.IConditionProto=} [properties] Properties to set
                 * @returns {waiternow.common.CampaignProto.ConditionProto} ConditionProto instance
                 */
                ConditionProto.create = function create(properties) {
                    return new ConditionProto(properties);
                };

                /**
                 * Encodes the specified ConditionProto message. Does not implicitly {@link waiternow.common.CampaignProto.ConditionProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.CampaignProto.ConditionProto
                 * @static
                 * @param {waiternow.common.CampaignProto.IConditionProto} message ConditionProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ConditionProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.rule != null && Object.hasOwnProperty.call(message, "rule"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.rule);
                    if (message.schedule != null && Object.hasOwnProperty.call(message, "schedule"))
                        $root.waiternow.common.ScheduleProto.encode(message.schedule, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified ConditionProto message, length delimited. Does not implicitly {@link waiternow.common.CampaignProto.ConditionProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.CampaignProto.ConditionProto
                 * @static
                 * @param {waiternow.common.CampaignProto.IConditionProto} message ConditionProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ConditionProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ConditionProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.CampaignProto.ConditionProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.CampaignProto.ConditionProto} ConditionProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ConditionProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CampaignProto.ConditionProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.rule = reader.int32();
                                break;
                            }
                        case 2: {
                                message.schedule = $root.waiternow.common.ScheduleProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ConditionProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.CampaignProto.ConditionProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.CampaignProto.ConditionProto} ConditionProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ConditionProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ConditionProto message.
                 * @function verify
                 * @memberof waiternow.common.CampaignProto.ConditionProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ConditionProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.rule != null && message.hasOwnProperty("rule"))
                        switch (message.rule) {
                        default:
                            return "rule: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.schedule != null && message.hasOwnProperty("schedule")) {
                        var error = $root.waiternow.common.ScheduleProto.verify(message.schedule);
                        if (error)
                            return "schedule." + error;
                    }
                    return null;
                };

                /**
                 * Creates a ConditionProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.CampaignProto.ConditionProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.CampaignProto.ConditionProto} ConditionProto
                 */
                ConditionProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.CampaignProto.ConditionProto)
                        return object;
                    var message = new $root.waiternow.common.CampaignProto.ConditionProto();
                    switch (object.rule) {
                    default:
                        if (typeof object.rule === "number") {
                            message.rule = object.rule;
                            break;
                        }
                        break;
                    case "RULE_UNSPECIFIED":
                    case 0:
                        message.rule = 0;
                        break;
                    case "FIRST_PURCHASE":
                    case 1:
                        message.rule = 1;
                        break;
                    case "EXCLUDE_ONLINE_ORDERS":
                    case 2:
                        message.rule = 2;
                        break;
                    }
                    if (object.schedule != null) {
                        if (typeof object.schedule !== "object")
                            throw TypeError(".waiternow.common.CampaignProto.ConditionProto.schedule: object expected");
                        message.schedule = $root.waiternow.common.ScheduleProto.fromObject(object.schedule);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a ConditionProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.CampaignProto.ConditionProto
                 * @static
                 * @param {waiternow.common.CampaignProto.ConditionProto} message ConditionProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ConditionProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.rule = options.enums === String ? "RULE_UNSPECIFIED" : 0;
                        object.schedule = null;
                    }
                    if (message.rule != null && message.hasOwnProperty("rule"))
                        object.rule = options.enums === String ? $root.waiternow.common.CampaignProto.ConditionProto.Rule[message.rule] === undefined ? message.rule : $root.waiternow.common.CampaignProto.ConditionProto.Rule[message.rule] : message.rule;
                    if (message.schedule != null && message.hasOwnProperty("schedule"))
                        object.schedule = $root.waiternow.common.ScheduleProto.toObject(message.schedule, options);
                    return object;
                };

                /**
                 * Converts this ConditionProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.CampaignProto.ConditionProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ConditionProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ConditionProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.CampaignProto.ConditionProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ConditionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.CampaignProto.ConditionProto";
                };

                /**
                 * Rule enum.
                 * @name waiternow.common.CampaignProto.ConditionProto.Rule
                 * @enum {number}
                 * @property {number} RULE_UNSPECIFIED=0 RULE_UNSPECIFIED value
                 * @property {number} FIRST_PURCHASE=1 FIRST_PURCHASE value
                 * @property {number} EXCLUDE_ONLINE_ORDERS=2 EXCLUDE_ONLINE_ORDERS value
                 */
                ConditionProto.Rule = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "RULE_UNSPECIFIED"] = 0;
                    values[valuesById[1] = "FIRST_PURCHASE"] = 1;
                    values[valuesById[2] = "EXCLUDE_ONLINE_ORDERS"] = 2;
                    return values;
                })();

                return ConditionProto;
            })();

            return CampaignProto;
        })();

        common.CampaignsProto = (function() {

            /**
             * Properties of a CampaignsProto.
             * @memberof waiternow.common
             * @interface ICampaignsProto
             * @property {Array.<waiternow.common.ICampaignProto>|null} [campaigns] CampaignsProto campaigns
             * @property {string|null} [continuationToken] CampaignsProto continuationToken
             */

            /**
             * Constructs a new CampaignsProto.
             * @memberof waiternow.common
             * @classdesc Represents a CampaignsProto.
             * @implements ICampaignsProto
             * @constructor
             * @param {waiternow.common.ICampaignsProto=} [properties] Properties to set
             */
            function CampaignsProto(properties) {
                this.campaigns = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * CampaignsProto campaigns.
             * @member {Array.<waiternow.common.ICampaignProto>} campaigns
             * @memberof waiternow.common.CampaignsProto
             * @instance
             */
            CampaignsProto.prototype.campaigns = $util.emptyArray;

            /**
             * CampaignsProto continuationToken.
             * @member {string} continuationToken
             * @memberof waiternow.common.CampaignsProto
             * @instance
             */
            CampaignsProto.prototype.continuationToken = "";

            /**
             * Creates a new CampaignsProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.CampaignsProto
             * @static
             * @param {waiternow.common.ICampaignsProto=} [properties] Properties to set
             * @returns {waiternow.common.CampaignsProto} CampaignsProto instance
             */
            CampaignsProto.create = function create(properties) {
                return new CampaignsProto(properties);
            };

            /**
             * Encodes the specified CampaignsProto message. Does not implicitly {@link waiternow.common.CampaignsProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.CampaignsProto
             * @static
             * @param {waiternow.common.ICampaignsProto} message CampaignsProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CampaignsProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.campaigns != null && message.campaigns.length)
                    for (var i = 0; i < message.campaigns.length; ++i)
                        $root.waiternow.common.CampaignProto.encode(message.campaigns[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.continuationToken);
                return writer;
            };

            /**
             * Encodes the specified CampaignsProto message, length delimited. Does not implicitly {@link waiternow.common.CampaignsProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.CampaignsProto
             * @static
             * @param {waiternow.common.ICampaignsProto} message CampaignsProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CampaignsProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CampaignsProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.CampaignsProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.CampaignsProto} CampaignsProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CampaignsProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CampaignsProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            if (!(message.campaigns && message.campaigns.length))
                                message.campaigns = [];
                            message.campaigns.push($root.waiternow.common.CampaignProto.decode(reader, reader.uint32()));
                            break;
                        }
                    case 2: {
                            message.continuationToken = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CampaignsProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.CampaignsProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.CampaignsProto} CampaignsProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CampaignsProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CampaignsProto message.
             * @function verify
             * @memberof waiternow.common.CampaignsProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CampaignsProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.campaigns != null && message.hasOwnProperty("campaigns")) {
                    if (!Array.isArray(message.campaigns))
                        return "campaigns: array expected";
                    for (var i = 0; i < message.campaigns.length; ++i) {
                        var error = $root.waiternow.common.CampaignProto.verify(message.campaigns[i]);
                        if (error)
                            return "campaigns." + error;
                    }
                }
                if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                    if (!$util.isString(message.continuationToken))
                        return "continuationToken: string expected";
                return null;
            };

            /**
             * Creates a CampaignsProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.CampaignsProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.CampaignsProto} CampaignsProto
             */
            CampaignsProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.CampaignsProto)
                    return object;
                var message = new $root.waiternow.common.CampaignsProto();
                if (object.campaigns) {
                    if (!Array.isArray(object.campaigns))
                        throw TypeError(".waiternow.common.CampaignsProto.campaigns: array expected");
                    message.campaigns = [];
                    for (var i = 0; i < object.campaigns.length; ++i) {
                        if (typeof object.campaigns[i] !== "object")
                            throw TypeError(".waiternow.common.CampaignsProto.campaigns: object expected");
                        message.campaigns[i] = $root.waiternow.common.CampaignProto.fromObject(object.campaigns[i]);
                    }
                }
                if (object.continuationToken != null)
                    message.continuationToken = String(object.continuationToken);
                return message;
            };

            /**
             * Creates a plain object from a CampaignsProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.CampaignsProto
             * @static
             * @param {waiternow.common.CampaignsProto} message CampaignsProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CampaignsProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.campaigns = [];
                if (options.defaults)
                    object.continuationToken = "";
                if (message.campaigns && message.campaigns.length) {
                    object.campaigns = [];
                    for (var j = 0; j < message.campaigns.length; ++j)
                        object.campaigns[j] = $root.waiternow.common.CampaignProto.toObject(message.campaigns[j], options);
                }
                if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                    object.continuationToken = message.continuationToken;
                return object;
            };

            /**
             * Converts this CampaignsProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.CampaignsProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CampaignsProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for CampaignsProto
             * @function getTypeUrl
             * @memberof waiternow.common.CampaignsProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            CampaignsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.CampaignsProto";
            };

            return CampaignsProto;
        })();

        common.CachedDataProto = (function() {

            /**
             * Properties of a CachedDataProto.
             * @memberof waiternow.common
             * @interface ICachedDataProto
             * @property {waiternow.common.CachedDataProto.IIdProto|null} [id] CachedDataProto id
             * @property {google.protobuf.ITimestamp|null} [creationTime] CachedDataProto creationTime
             * @property {google.protobuf.ITimestamp|null} [lastUpdateTime] CachedDataProto lastUpdateTime
             * @property {string|null} [dataString] CachedDataProto dataString
             * @property {boolean|null} [dataBool] CachedDataProto dataBool
             * @property {number|null} [dataInt] CachedDataProto dataInt
             * @property {number|null} [dataLong] CachedDataProto dataLong
             * @property {number|null} [dataUnsignedInt] CachedDataProto dataUnsignedInt
             * @property {number|null} [dataUnsignedLong] CachedDataProto dataUnsignedLong
             * @property {number|null} [dataFloat] CachedDataProto dataFloat
             * @property {number|null} [dataDouble] CachedDataProto dataDouble
             * @property {Uint8Array|null} [dataBytes] CachedDataProto dataBytes
             * @property {google.protobuf.IAny|null} [dataAny] CachedDataProto dataAny
             */

            /**
             * Constructs a new CachedDataProto.
             * @memberof waiternow.common
             * @classdesc Represents a CachedDataProto.
             * @implements ICachedDataProto
             * @constructor
             * @param {waiternow.common.ICachedDataProto=} [properties] Properties to set
             */
            function CachedDataProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * CachedDataProto id.
             * @member {waiternow.common.CachedDataProto.IIdProto|null|undefined} id
             * @memberof waiternow.common.CachedDataProto
             * @instance
             */
            CachedDataProto.prototype.id = null;

            /**
             * CachedDataProto creationTime.
             * @member {google.protobuf.ITimestamp|null|undefined} creationTime
             * @memberof waiternow.common.CachedDataProto
             * @instance
             */
            CachedDataProto.prototype.creationTime = null;

            /**
             * CachedDataProto lastUpdateTime.
             * @member {google.protobuf.ITimestamp|null|undefined} lastUpdateTime
             * @memberof waiternow.common.CachedDataProto
             * @instance
             */
            CachedDataProto.prototype.lastUpdateTime = null;

            /**
             * CachedDataProto dataString.
             * @member {string|null|undefined} dataString
             * @memberof waiternow.common.CachedDataProto
             * @instance
             */
            CachedDataProto.prototype.dataString = null;

            /**
             * CachedDataProto dataBool.
             * @member {boolean|null|undefined} dataBool
             * @memberof waiternow.common.CachedDataProto
             * @instance
             */
            CachedDataProto.prototype.dataBool = null;

            /**
             * CachedDataProto dataInt.
             * @member {number|null|undefined} dataInt
             * @memberof waiternow.common.CachedDataProto
             * @instance
             */
            CachedDataProto.prototype.dataInt = null;

            /**
             * CachedDataProto dataLong.
             * @member {number|null|undefined} dataLong
             * @memberof waiternow.common.CachedDataProto
             * @instance
             */
            CachedDataProto.prototype.dataLong = null;

            /**
             * CachedDataProto dataUnsignedInt.
             * @member {number|null|undefined} dataUnsignedInt
             * @memberof waiternow.common.CachedDataProto
             * @instance
             */
            CachedDataProto.prototype.dataUnsignedInt = null;

            /**
             * CachedDataProto dataUnsignedLong.
             * @member {number|null|undefined} dataUnsignedLong
             * @memberof waiternow.common.CachedDataProto
             * @instance
             */
            CachedDataProto.prototype.dataUnsignedLong = null;

            /**
             * CachedDataProto dataFloat.
             * @member {number|null|undefined} dataFloat
             * @memberof waiternow.common.CachedDataProto
             * @instance
             */
            CachedDataProto.prototype.dataFloat = null;

            /**
             * CachedDataProto dataDouble.
             * @member {number|null|undefined} dataDouble
             * @memberof waiternow.common.CachedDataProto
             * @instance
             */
            CachedDataProto.prototype.dataDouble = null;

            /**
             * CachedDataProto dataBytes.
             * @member {Uint8Array|null|undefined} dataBytes
             * @memberof waiternow.common.CachedDataProto
             * @instance
             */
            CachedDataProto.prototype.dataBytes = null;

            /**
             * CachedDataProto dataAny.
             * @member {google.protobuf.IAny|null|undefined} dataAny
             * @memberof waiternow.common.CachedDataProto
             * @instance
             */
            CachedDataProto.prototype.dataAny = null;

            // OneOf field names bound to virtual getters and setters
            var $oneOfFields;

            /**
             * CachedDataProto valueType.
             * @member {"dataString"|"dataBool"|"dataInt"|"dataLong"|"dataUnsignedInt"|"dataUnsignedLong"|"dataFloat"|"dataDouble"|"dataBytes"|"dataAny"|undefined} valueType
             * @memberof waiternow.common.CachedDataProto
             * @instance
             */
            Object.defineProperty(CachedDataProto.prototype, "valueType", {
                get: $util.oneOfGetter($oneOfFields = ["dataString", "dataBool", "dataInt", "dataLong", "dataUnsignedInt", "dataUnsignedLong", "dataFloat", "dataDouble", "dataBytes", "dataAny"]),
                set: $util.oneOfSetter($oneOfFields)
            });

            /**
             * Creates a new CachedDataProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.CachedDataProto
             * @static
             * @param {waiternow.common.ICachedDataProto=} [properties] Properties to set
             * @returns {waiternow.common.CachedDataProto} CachedDataProto instance
             */
            CachedDataProto.create = function create(properties) {
                return new CachedDataProto(properties);
            };

            /**
             * Encodes the specified CachedDataProto message. Does not implicitly {@link waiternow.common.CachedDataProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.CachedDataProto
             * @static
             * @param {waiternow.common.ICachedDataProto} message CachedDataProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CachedDataProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                    $root.waiternow.common.CachedDataProto.IdProto.encode(message.id, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.creationTime != null && Object.hasOwnProperty.call(message, "creationTime"))
                    $root.google.protobuf.Timestamp.encode(message.creationTime, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                    $root.google.protobuf.Timestamp.encode(message.lastUpdateTime, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.dataString != null && Object.hasOwnProperty.call(message, "dataString"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.dataString);
                if (message.dataBool != null && Object.hasOwnProperty.call(message, "dataBool"))
                    writer.uint32(/* id 5, wireType 0 =*/40).bool(message.dataBool);
                if (message.dataInt != null && Object.hasOwnProperty.call(message, "dataInt"))
                    writer.uint32(/* id 6, wireType 0 =*/48).int32(message.dataInt);
                if (message.dataLong != null && Object.hasOwnProperty.call(message, "dataLong"))
                    writer.uint32(/* id 7, wireType 0 =*/56).int64(message.dataLong);
                if (message.dataUnsignedInt != null && Object.hasOwnProperty.call(message, "dataUnsignedInt"))
                    writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.dataUnsignedInt);
                if (message.dataUnsignedLong != null && Object.hasOwnProperty.call(message, "dataUnsignedLong"))
                    writer.uint32(/* id 9, wireType 0 =*/72).uint64(message.dataUnsignedLong);
                if (message.dataFloat != null && Object.hasOwnProperty.call(message, "dataFloat"))
                    writer.uint32(/* id 10, wireType 5 =*/85).float(message.dataFloat);
                if (message.dataDouble != null && Object.hasOwnProperty.call(message, "dataDouble"))
                    writer.uint32(/* id 11, wireType 1 =*/89).double(message.dataDouble);
                if (message.dataBytes != null && Object.hasOwnProperty.call(message, "dataBytes"))
                    writer.uint32(/* id 12, wireType 2 =*/98).bytes(message.dataBytes);
                if (message.dataAny != null && Object.hasOwnProperty.call(message, "dataAny"))
                    $root.google.protobuf.Any.encode(message.dataAny, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified CachedDataProto message, length delimited. Does not implicitly {@link waiternow.common.CachedDataProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.CachedDataProto
             * @static
             * @param {waiternow.common.ICachedDataProto} message CachedDataProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CachedDataProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CachedDataProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.CachedDataProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.CachedDataProto} CachedDataProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CachedDataProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CachedDataProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.id = $root.waiternow.common.CachedDataProto.IdProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 2: {
                            message.creationTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 3: {
                            message.lastUpdateTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 4: {
                            message.dataString = reader.string();
                            break;
                        }
                    case 5: {
                            message.dataBool = reader.bool();
                            break;
                        }
                    case 6: {
                            message.dataInt = reader.int32();
                            break;
                        }
                    case 7: {
                            message.dataLong = reader.int64();
                            break;
                        }
                    case 8: {
                            message.dataUnsignedInt = reader.uint32();
                            break;
                        }
                    case 9: {
                            message.dataUnsignedLong = reader.uint64();
                            break;
                        }
                    case 10: {
                            message.dataFloat = reader.float();
                            break;
                        }
                    case 11: {
                            message.dataDouble = reader.double();
                            break;
                        }
                    case 12: {
                            message.dataBytes = reader.bytes();
                            break;
                        }
                    case 13: {
                            message.dataAny = $root.google.protobuf.Any.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CachedDataProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.CachedDataProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.CachedDataProto} CachedDataProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CachedDataProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CachedDataProto message.
             * @function verify
             * @memberof waiternow.common.CachedDataProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CachedDataProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                var properties = {};
                if (message.id != null && message.hasOwnProperty("id")) {
                    var error = $root.waiternow.common.CachedDataProto.IdProto.verify(message.id);
                    if (error)
                        return "id." + error;
                }
                if (message.creationTime != null && message.hasOwnProperty("creationTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.creationTime);
                    if (error)
                        return "creationTime." + error;
                }
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.lastUpdateTime);
                    if (error)
                        return "lastUpdateTime." + error;
                }
                if (message.dataString != null && message.hasOwnProperty("dataString")) {
                    properties.valueType = 1;
                    if (!$util.isString(message.dataString))
                        return "dataString: string expected";
                }
                if (message.dataBool != null && message.hasOwnProperty("dataBool")) {
                    if (properties.valueType === 1)
                        return "valueType: multiple values";
                    properties.valueType = 1;
                    if (typeof message.dataBool !== "boolean")
                        return "dataBool: boolean expected";
                }
                if (message.dataInt != null && message.hasOwnProperty("dataInt")) {
                    if (properties.valueType === 1)
                        return "valueType: multiple values";
                    properties.valueType = 1;
                    if (!$util.isInteger(message.dataInt))
                        return "dataInt: integer expected";
                }
                if (message.dataLong != null && message.hasOwnProperty("dataLong")) {
                    if (properties.valueType === 1)
                        return "valueType: multiple values";
                    properties.valueType = 1;
                    if (!$util.isInteger(message.dataLong) && !(message.dataLong && $util.isInteger(message.dataLong.low) && $util.isInteger(message.dataLong.high)))
                        return "dataLong: integer|Long expected";
                }
                if (message.dataUnsignedInt != null && message.hasOwnProperty("dataUnsignedInt")) {
                    if (properties.valueType === 1)
                        return "valueType: multiple values";
                    properties.valueType = 1;
                    if (!$util.isInteger(message.dataUnsignedInt))
                        return "dataUnsignedInt: integer expected";
                }
                if (message.dataUnsignedLong != null && message.hasOwnProperty("dataUnsignedLong")) {
                    if (properties.valueType === 1)
                        return "valueType: multiple values";
                    properties.valueType = 1;
                    if (!$util.isInteger(message.dataUnsignedLong) && !(message.dataUnsignedLong && $util.isInteger(message.dataUnsignedLong.low) && $util.isInteger(message.dataUnsignedLong.high)))
                        return "dataUnsignedLong: integer|Long expected";
                }
                if (message.dataFloat != null && message.hasOwnProperty("dataFloat")) {
                    if (properties.valueType === 1)
                        return "valueType: multiple values";
                    properties.valueType = 1;
                    if (typeof message.dataFloat !== "number")
                        return "dataFloat: number expected";
                }
                if (message.dataDouble != null && message.hasOwnProperty("dataDouble")) {
                    if (properties.valueType === 1)
                        return "valueType: multiple values";
                    properties.valueType = 1;
                    if (typeof message.dataDouble !== "number")
                        return "dataDouble: number expected";
                }
                if (message.dataBytes != null && message.hasOwnProperty("dataBytes")) {
                    if (properties.valueType === 1)
                        return "valueType: multiple values";
                    properties.valueType = 1;
                    if (!(message.dataBytes && typeof message.dataBytes.length === "number" || $util.isString(message.dataBytes)))
                        return "dataBytes: buffer expected";
                }
                if (message.dataAny != null && message.hasOwnProperty("dataAny")) {
                    if (properties.valueType === 1)
                        return "valueType: multiple values";
                    properties.valueType = 1;
                    {
                        var error = $root.google.protobuf.Any.verify(message.dataAny);
                        if (error)
                            return "dataAny." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a CachedDataProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.CachedDataProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.CachedDataProto} CachedDataProto
             */
            CachedDataProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.CachedDataProto)
                    return object;
                var message = new $root.waiternow.common.CachedDataProto();
                if (object.id != null) {
                    if (typeof object.id !== "object")
                        throw TypeError(".waiternow.common.CachedDataProto.id: object expected");
                    message.id = $root.waiternow.common.CachedDataProto.IdProto.fromObject(object.id);
                }
                if (object.creationTime != null) {
                    if (typeof object.creationTime !== "object")
                        throw TypeError(".waiternow.common.CachedDataProto.creationTime: object expected");
                    message.creationTime = $root.google.protobuf.Timestamp.fromObject(object.creationTime);
                }
                if (object.lastUpdateTime != null) {
                    if (typeof object.lastUpdateTime !== "object")
                        throw TypeError(".waiternow.common.CachedDataProto.lastUpdateTime: object expected");
                    message.lastUpdateTime = $root.google.protobuf.Timestamp.fromObject(object.lastUpdateTime);
                }
                if (object.dataString != null)
                    message.dataString = String(object.dataString);
                if (object.dataBool != null)
                    message.dataBool = Boolean(object.dataBool);
                if (object.dataInt != null)
                    message.dataInt = object.dataInt | 0;
                if (object.dataLong != null)
                    if ($util.Long)
                        (message.dataLong = $util.Long.fromValue(object.dataLong)).unsigned = false;
                    else if (typeof object.dataLong === "string")
                        message.dataLong = parseInt(object.dataLong, 10);
                    else if (typeof object.dataLong === "number")
                        message.dataLong = object.dataLong;
                    else if (typeof object.dataLong === "object")
                        message.dataLong = new $util.LongBits(object.dataLong.low >>> 0, object.dataLong.high >>> 0).toNumber();
                if (object.dataUnsignedInt != null)
                    message.dataUnsignedInt = object.dataUnsignedInt >>> 0;
                if (object.dataUnsignedLong != null)
                    if ($util.Long)
                        (message.dataUnsignedLong = $util.Long.fromValue(object.dataUnsignedLong)).unsigned = true;
                    else if (typeof object.dataUnsignedLong === "string")
                        message.dataUnsignedLong = parseInt(object.dataUnsignedLong, 10);
                    else if (typeof object.dataUnsignedLong === "number")
                        message.dataUnsignedLong = object.dataUnsignedLong;
                    else if (typeof object.dataUnsignedLong === "object")
                        message.dataUnsignedLong = new $util.LongBits(object.dataUnsignedLong.low >>> 0, object.dataUnsignedLong.high >>> 0).toNumber(true);
                if (object.dataFloat != null)
                    message.dataFloat = Number(object.dataFloat);
                if (object.dataDouble != null)
                    message.dataDouble = Number(object.dataDouble);
                if (object.dataBytes != null)
                    if (typeof object.dataBytes === "string")
                        $util.base64.decode(object.dataBytes, message.dataBytes = $util.newBuffer($util.base64.length(object.dataBytes)), 0);
                    else if (object.dataBytes.length >= 0)
                        message.dataBytes = object.dataBytes;
                if (object.dataAny != null) {
                    if (typeof object.dataAny !== "object")
                        throw TypeError(".waiternow.common.CachedDataProto.dataAny: object expected");
                    message.dataAny = $root.google.protobuf.Any.fromObject(object.dataAny);
                }
                return message;
            };

            /**
             * Creates a plain object from a CachedDataProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.CachedDataProto
             * @static
             * @param {waiternow.common.CachedDataProto} message CachedDataProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CachedDataProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.id = null;
                    object.creationTime = null;
                    object.lastUpdateTime = null;
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = $root.waiternow.common.CachedDataProto.IdProto.toObject(message.id, options);
                if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                    object.creationTime = $root.google.protobuf.Timestamp.toObject(message.creationTime, options);
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                    object.lastUpdateTime = $root.google.protobuf.Timestamp.toObject(message.lastUpdateTime, options);
                if (message.dataString != null && message.hasOwnProperty("dataString")) {
                    object.dataString = message.dataString;
                    if (options.oneofs)
                        object.valueType = "dataString";
                }
                if (message.dataBool != null && message.hasOwnProperty("dataBool")) {
                    object.dataBool = message.dataBool;
                    if (options.oneofs)
                        object.valueType = "dataBool";
                }
                if (message.dataInt != null && message.hasOwnProperty("dataInt")) {
                    object.dataInt = message.dataInt;
                    if (options.oneofs)
                        object.valueType = "dataInt";
                }
                if (message.dataLong != null && message.hasOwnProperty("dataLong")) {
                    if (typeof message.dataLong === "number")
                        object.dataLong = options.longs === String ? String(message.dataLong) : message.dataLong;
                    else
                        object.dataLong = options.longs === String ? $util.Long.prototype.toString.call(message.dataLong) : options.longs === Number ? new $util.LongBits(message.dataLong.low >>> 0, message.dataLong.high >>> 0).toNumber() : message.dataLong;
                    if (options.oneofs)
                        object.valueType = "dataLong";
                }
                if (message.dataUnsignedInt != null && message.hasOwnProperty("dataUnsignedInt")) {
                    object.dataUnsignedInt = message.dataUnsignedInt;
                    if (options.oneofs)
                        object.valueType = "dataUnsignedInt";
                }
                if (message.dataUnsignedLong != null && message.hasOwnProperty("dataUnsignedLong")) {
                    if (typeof message.dataUnsignedLong === "number")
                        object.dataUnsignedLong = options.longs === String ? String(message.dataUnsignedLong) : message.dataUnsignedLong;
                    else
                        object.dataUnsignedLong = options.longs === String ? $util.Long.prototype.toString.call(message.dataUnsignedLong) : options.longs === Number ? new $util.LongBits(message.dataUnsignedLong.low >>> 0, message.dataUnsignedLong.high >>> 0).toNumber(true) : message.dataUnsignedLong;
                    if (options.oneofs)
                        object.valueType = "dataUnsignedLong";
                }
                if (message.dataFloat != null && message.hasOwnProperty("dataFloat")) {
                    object.dataFloat = options.json && !isFinite(message.dataFloat) ? String(message.dataFloat) : message.dataFloat;
                    if (options.oneofs)
                        object.valueType = "dataFloat";
                }
                if (message.dataDouble != null && message.hasOwnProperty("dataDouble")) {
                    object.dataDouble = options.json && !isFinite(message.dataDouble) ? String(message.dataDouble) : message.dataDouble;
                    if (options.oneofs)
                        object.valueType = "dataDouble";
                }
                if (message.dataBytes != null && message.hasOwnProperty("dataBytes")) {
                    object.dataBytes = options.bytes === String ? $util.base64.encode(message.dataBytes, 0, message.dataBytes.length) : options.bytes === Array ? Array.prototype.slice.call(message.dataBytes) : message.dataBytes;
                    if (options.oneofs)
                        object.valueType = "dataBytes";
                }
                if (message.dataAny != null && message.hasOwnProperty("dataAny")) {
                    object.dataAny = $root.google.protobuf.Any.toObject(message.dataAny, options);
                    if (options.oneofs)
                        object.valueType = "dataAny";
                }
                return object;
            };

            /**
             * Converts this CachedDataProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.CachedDataProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CachedDataProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for CachedDataProto
             * @function getTypeUrl
             * @memberof waiternow.common.CachedDataProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            CachedDataProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.CachedDataProto";
            };

            CachedDataProto.IdProto = (function() {

                /**
                 * Properties of an IdProto.
                 * @memberof waiternow.common.CachedDataProto
                 * @interface IIdProto
                 * @property {string|null} [namespace] IdProto namespace
                 * @property {string|null} [key] IdProto key
                 */

                /**
                 * Constructs a new IdProto.
                 * @memberof waiternow.common.CachedDataProto
                 * @classdesc Represents an IdProto.
                 * @implements IIdProto
                 * @constructor
                 * @param {waiternow.common.CachedDataProto.IIdProto=} [properties] Properties to set
                 */
                function IdProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * IdProto namespace.
                 * @member {string} namespace
                 * @memberof waiternow.common.CachedDataProto.IdProto
                 * @instance
                 */
                IdProto.prototype.namespace = "";

                /**
                 * IdProto key.
                 * @member {string} key
                 * @memberof waiternow.common.CachedDataProto.IdProto
                 * @instance
                 */
                IdProto.prototype.key = "";

                /**
                 * Creates a new IdProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.CachedDataProto.IdProto
                 * @static
                 * @param {waiternow.common.CachedDataProto.IIdProto=} [properties] Properties to set
                 * @returns {waiternow.common.CachedDataProto.IdProto} IdProto instance
                 */
                IdProto.create = function create(properties) {
                    return new IdProto(properties);
                };

                /**
                 * Encodes the specified IdProto message. Does not implicitly {@link waiternow.common.CachedDataProto.IdProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.CachedDataProto.IdProto
                 * @static
                 * @param {waiternow.common.CachedDataProto.IIdProto} message IdProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                IdProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.namespace != null && Object.hasOwnProperty.call(message, "namespace"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.namespace);
                    if (message.key != null && Object.hasOwnProperty.call(message, "key"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.key);
                    return writer;
                };

                /**
                 * Encodes the specified IdProto message, length delimited. Does not implicitly {@link waiternow.common.CachedDataProto.IdProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.CachedDataProto.IdProto
                 * @static
                 * @param {waiternow.common.CachedDataProto.IIdProto} message IdProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                IdProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an IdProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.CachedDataProto.IdProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.CachedDataProto.IdProto} IdProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                IdProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CachedDataProto.IdProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.namespace = reader.string();
                                break;
                            }
                        case 2: {
                                message.key = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an IdProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.CachedDataProto.IdProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.CachedDataProto.IdProto} IdProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                IdProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an IdProto message.
                 * @function verify
                 * @memberof waiternow.common.CachedDataProto.IdProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                IdProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.namespace != null && message.hasOwnProperty("namespace"))
                        if (!$util.isString(message.namespace))
                            return "namespace: string expected";
                    if (message.key != null && message.hasOwnProperty("key"))
                        if (!$util.isString(message.key))
                            return "key: string expected";
                    return null;
                };

                /**
                 * Creates an IdProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.CachedDataProto.IdProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.CachedDataProto.IdProto} IdProto
                 */
                IdProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.CachedDataProto.IdProto)
                        return object;
                    var message = new $root.waiternow.common.CachedDataProto.IdProto();
                    if (object.namespace != null)
                        message.namespace = String(object.namespace);
                    if (object.key != null)
                        message.key = String(object.key);
                    return message;
                };

                /**
                 * Creates a plain object from an IdProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.CachedDataProto.IdProto
                 * @static
                 * @param {waiternow.common.CachedDataProto.IdProto} message IdProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                IdProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.namespace = "";
                        object.key = "";
                    }
                    if (message.namespace != null && message.hasOwnProperty("namespace"))
                        object.namespace = message.namespace;
                    if (message.key != null && message.hasOwnProperty("key"))
                        object.key = message.key;
                    return object;
                };

                /**
                 * Converts this IdProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.CachedDataProto.IdProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                IdProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for IdProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.CachedDataProto.IdProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                IdProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.CachedDataProto.IdProto";
                };

                return IdProto;
            })();

            return CachedDataProto;
        })();

        common.CheckInProto = (function() {

            /**
             * Properties of a CheckInProto.
             * @memberof waiternow.common
             * @interface ICheckInProto
             * @property {string|null} [id] CheckInProto id
             * @property {google.protobuf.ITimestamp|null} [creationTime] CheckInProto creationTime
             * @property {google.protobuf.ITimestamp|null} [lastUpdateTime] CheckInProto lastUpdateTime
             * @property {string|null} [deviceId] CheckInProto deviceId
             * @property {string|null} [pointOfServiceId] CheckInProto pointOfServiceId
             * @property {waiternow.common.CheckInProto.IRedundantDataProto|null} [redundantData] CheckInProto redundantData
             */

            /**
             * Constructs a new CheckInProto.
             * @memberof waiternow.common
             * @classdesc Represents a CheckInProto.
             * @implements ICheckInProto
             * @constructor
             * @param {waiternow.common.ICheckInProto=} [properties] Properties to set
             */
            function CheckInProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * CheckInProto id.
             * @member {string} id
             * @memberof waiternow.common.CheckInProto
             * @instance
             */
            CheckInProto.prototype.id = "";

            /**
             * CheckInProto creationTime.
             * @member {google.protobuf.ITimestamp|null|undefined} creationTime
             * @memberof waiternow.common.CheckInProto
             * @instance
             */
            CheckInProto.prototype.creationTime = null;

            /**
             * CheckInProto lastUpdateTime.
             * @member {google.protobuf.ITimestamp|null|undefined} lastUpdateTime
             * @memberof waiternow.common.CheckInProto
             * @instance
             */
            CheckInProto.prototype.lastUpdateTime = null;

            /**
             * CheckInProto deviceId.
             * @member {string} deviceId
             * @memberof waiternow.common.CheckInProto
             * @instance
             */
            CheckInProto.prototype.deviceId = "";

            /**
             * CheckInProto pointOfServiceId.
             * @member {string} pointOfServiceId
             * @memberof waiternow.common.CheckInProto
             * @instance
             */
            CheckInProto.prototype.pointOfServiceId = "";

            /**
             * CheckInProto redundantData.
             * @member {waiternow.common.CheckInProto.IRedundantDataProto|null|undefined} redundantData
             * @memberof waiternow.common.CheckInProto
             * @instance
             */
            CheckInProto.prototype.redundantData = null;

            /**
             * Creates a new CheckInProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.CheckInProto
             * @static
             * @param {waiternow.common.ICheckInProto=} [properties] Properties to set
             * @returns {waiternow.common.CheckInProto} CheckInProto instance
             */
            CheckInProto.create = function create(properties) {
                return new CheckInProto(properties);
            };

            /**
             * Encodes the specified CheckInProto message. Does not implicitly {@link waiternow.common.CheckInProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.CheckInProto
             * @static
             * @param {waiternow.common.ICheckInProto} message CheckInProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CheckInProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                if (message.creationTime != null && Object.hasOwnProperty.call(message, "creationTime"))
                    $root.google.protobuf.Timestamp.encode(message.creationTime, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                    $root.google.protobuf.Timestamp.encode(message.lastUpdateTime, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.deviceId != null && Object.hasOwnProperty.call(message, "deviceId"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.deviceId);
                if (message.pointOfServiceId != null && Object.hasOwnProperty.call(message, "pointOfServiceId"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.pointOfServiceId);
                if (message.redundantData != null && Object.hasOwnProperty.call(message, "redundantData"))
                    $root.waiternow.common.CheckInProto.RedundantDataProto.encode(message.redundantData, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified CheckInProto message, length delimited. Does not implicitly {@link waiternow.common.CheckInProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.CheckInProto
             * @static
             * @param {waiternow.common.ICheckInProto} message CheckInProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CheckInProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CheckInProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.CheckInProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.CheckInProto} CheckInProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CheckInProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CheckInProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.id = reader.string();
                            break;
                        }
                    case 2: {
                            message.creationTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 3: {
                            message.lastUpdateTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 4: {
                            message.deviceId = reader.string();
                            break;
                        }
                    case 5: {
                            message.pointOfServiceId = reader.string();
                            break;
                        }
                    case 6: {
                            message.redundantData = $root.waiternow.common.CheckInProto.RedundantDataProto.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CheckInProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.CheckInProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.CheckInProto} CheckInProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CheckInProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CheckInProto message.
             * @function verify
             * @memberof waiternow.common.CheckInProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CheckInProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.id != null && message.hasOwnProperty("id"))
                    if (!$util.isString(message.id))
                        return "id: string expected";
                if (message.creationTime != null && message.hasOwnProperty("creationTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.creationTime);
                    if (error)
                        return "creationTime." + error;
                }
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.lastUpdateTime);
                    if (error)
                        return "lastUpdateTime." + error;
                }
                if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                    if (!$util.isString(message.deviceId))
                        return "deviceId: string expected";
                if (message.pointOfServiceId != null && message.hasOwnProperty("pointOfServiceId"))
                    if (!$util.isString(message.pointOfServiceId))
                        return "pointOfServiceId: string expected";
                if (message.redundantData != null && message.hasOwnProperty("redundantData")) {
                    var error = $root.waiternow.common.CheckInProto.RedundantDataProto.verify(message.redundantData);
                    if (error)
                        return "redundantData." + error;
                }
                return null;
            };

            /**
             * Creates a CheckInProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.CheckInProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.CheckInProto} CheckInProto
             */
            CheckInProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.CheckInProto)
                    return object;
                var message = new $root.waiternow.common.CheckInProto();
                if (object.id != null)
                    message.id = String(object.id);
                if (object.creationTime != null) {
                    if (typeof object.creationTime !== "object")
                        throw TypeError(".waiternow.common.CheckInProto.creationTime: object expected");
                    message.creationTime = $root.google.protobuf.Timestamp.fromObject(object.creationTime);
                }
                if (object.lastUpdateTime != null) {
                    if (typeof object.lastUpdateTime !== "object")
                        throw TypeError(".waiternow.common.CheckInProto.lastUpdateTime: object expected");
                    message.lastUpdateTime = $root.google.protobuf.Timestamp.fromObject(object.lastUpdateTime);
                }
                if (object.deviceId != null)
                    message.deviceId = String(object.deviceId);
                if (object.pointOfServiceId != null)
                    message.pointOfServiceId = String(object.pointOfServiceId);
                if (object.redundantData != null) {
                    if (typeof object.redundantData !== "object")
                        throw TypeError(".waiternow.common.CheckInProto.redundantData: object expected");
                    message.redundantData = $root.waiternow.common.CheckInProto.RedundantDataProto.fromObject(object.redundantData);
                }
                return message;
            };

            /**
             * Creates a plain object from a CheckInProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.CheckInProto
             * @static
             * @param {waiternow.common.CheckInProto} message CheckInProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CheckInProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.id = "";
                    object.creationTime = null;
                    object.lastUpdateTime = null;
                    object.deviceId = "";
                    object.pointOfServiceId = "";
                    object.redundantData = null;
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                    object.creationTime = $root.google.protobuf.Timestamp.toObject(message.creationTime, options);
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                    object.lastUpdateTime = $root.google.protobuf.Timestamp.toObject(message.lastUpdateTime, options);
                if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                    object.deviceId = message.deviceId;
                if (message.pointOfServiceId != null && message.hasOwnProperty("pointOfServiceId"))
                    object.pointOfServiceId = message.pointOfServiceId;
                if (message.redundantData != null && message.hasOwnProperty("redundantData"))
                    object.redundantData = $root.waiternow.common.CheckInProto.RedundantDataProto.toObject(message.redundantData, options);
                return object;
            };

            /**
             * Converts this CheckInProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.CheckInProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CheckInProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for CheckInProto
             * @function getTypeUrl
             * @memberof waiternow.common.CheckInProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            CheckInProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.CheckInProto";
            };

            CheckInProto.RedundantDataProto = (function() {

                /**
                 * Properties of a RedundantDataProto.
                 * @memberof waiternow.common.CheckInProto
                 * @interface IRedundantDataProto
                 * @property {string|null} [consumerId] RedundantDataProto consumerId
                 * @property {string|null} [locationId] RedundantDataProto locationId
                 * @property {string|null} [businessId] RedundantDataProto businessId
                 * @property {waiternow.common.Country|null} [locationCountry] RedundantDataProto locationCountry
                 */

                /**
                 * Constructs a new RedundantDataProto.
                 * @memberof waiternow.common.CheckInProto
                 * @classdesc Represents a RedundantDataProto.
                 * @implements IRedundantDataProto
                 * @constructor
                 * @param {waiternow.common.CheckInProto.IRedundantDataProto=} [properties] Properties to set
                 */
                function RedundantDataProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * RedundantDataProto consumerId.
                 * @member {string} consumerId
                 * @memberof waiternow.common.CheckInProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.consumerId = "";

                /**
                 * RedundantDataProto locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.CheckInProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.locationId = "";

                /**
                 * RedundantDataProto businessId.
                 * @member {string} businessId
                 * @memberof waiternow.common.CheckInProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.businessId = "";

                /**
                 * RedundantDataProto locationCountry.
                 * @member {waiternow.common.Country} locationCountry
                 * @memberof waiternow.common.CheckInProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.locationCountry = 0;

                /**
                 * Creates a new RedundantDataProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.CheckInProto.RedundantDataProto
                 * @static
                 * @param {waiternow.common.CheckInProto.IRedundantDataProto=} [properties] Properties to set
                 * @returns {waiternow.common.CheckInProto.RedundantDataProto} RedundantDataProto instance
                 */
                RedundantDataProto.create = function create(properties) {
                    return new RedundantDataProto(properties);
                };

                /**
                 * Encodes the specified RedundantDataProto message. Does not implicitly {@link waiternow.common.CheckInProto.RedundantDataProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.CheckInProto.RedundantDataProto
                 * @static
                 * @param {waiternow.common.CheckInProto.IRedundantDataProto} message RedundantDataProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RedundantDataProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.consumerId != null && Object.hasOwnProperty.call(message, "consumerId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.consumerId);
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.locationId);
                    if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.businessId);
                    if (message.locationCountry != null && Object.hasOwnProperty.call(message, "locationCountry"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.locationCountry);
                    return writer;
                };

                /**
                 * Encodes the specified RedundantDataProto message, length delimited. Does not implicitly {@link waiternow.common.CheckInProto.RedundantDataProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.CheckInProto.RedundantDataProto
                 * @static
                 * @param {waiternow.common.CheckInProto.IRedundantDataProto} message RedundantDataProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RedundantDataProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a RedundantDataProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.CheckInProto.RedundantDataProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.CheckInProto.RedundantDataProto} RedundantDataProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RedundantDataProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CheckInProto.RedundantDataProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.consumerId = reader.string();
                                break;
                            }
                        case 2: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 3: {
                                message.businessId = reader.string();
                                break;
                            }
                        case 4: {
                                message.locationCountry = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a RedundantDataProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.CheckInProto.RedundantDataProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.CheckInProto.RedundantDataProto} RedundantDataProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RedundantDataProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a RedundantDataProto message.
                 * @function verify
                 * @memberof waiternow.common.CheckInProto.RedundantDataProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                RedundantDataProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.consumerId != null && message.hasOwnProperty("consumerId"))
                        if (!$util.isString(message.consumerId))
                            return "consumerId: string expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    if (message.businessId != null && message.hasOwnProperty("businessId"))
                        if (!$util.isString(message.businessId))
                            return "businessId: string expected";
                    if (message.locationCountry != null && message.hasOwnProperty("locationCountry"))
                        switch (message.locationCountry) {
                        default:
                            return "locationCountry: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    return null;
                };

                /**
                 * Creates a RedundantDataProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.CheckInProto.RedundantDataProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.CheckInProto.RedundantDataProto} RedundantDataProto
                 */
                RedundantDataProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.CheckInProto.RedundantDataProto)
                        return object;
                    var message = new $root.waiternow.common.CheckInProto.RedundantDataProto();
                    if (object.consumerId != null)
                        message.consumerId = String(object.consumerId);
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    if (object.businessId != null)
                        message.businessId = String(object.businessId);
                    switch (object.locationCountry) {
                    default:
                        if (typeof object.locationCountry === "number") {
                            message.locationCountry = object.locationCountry;
                            break;
                        }
                        break;
                    case "COUNTRY_UNSPECIFIED":
                    case 0:
                        message.locationCountry = 0;
                        break;
                    case "UNITED_STATES":
                    case 1:
                        message.locationCountry = 1;
                        break;
                    case "MEXICO":
                    case 2:
                        message.locationCountry = 2;
                        break;
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a RedundantDataProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.CheckInProto.RedundantDataProto
                 * @static
                 * @param {waiternow.common.CheckInProto.RedundantDataProto} message RedundantDataProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                RedundantDataProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.consumerId = "";
                        object.locationId = "";
                        object.businessId = "";
                        object.locationCountry = options.enums === String ? "COUNTRY_UNSPECIFIED" : 0;
                    }
                    if (message.consumerId != null && message.hasOwnProperty("consumerId"))
                        object.consumerId = message.consumerId;
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    if (message.businessId != null && message.hasOwnProperty("businessId"))
                        object.businessId = message.businessId;
                    if (message.locationCountry != null && message.hasOwnProperty("locationCountry"))
                        object.locationCountry = options.enums === String ? $root.waiternow.common.Country[message.locationCountry] === undefined ? message.locationCountry : $root.waiternow.common.Country[message.locationCountry] : message.locationCountry;
                    return object;
                };

                /**
                 * Converts this RedundantDataProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.CheckInProto.RedundantDataProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                RedundantDataProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for RedundantDataProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.CheckInProto.RedundantDataProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                RedundantDataProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.CheckInProto.RedundantDataProto";
                };

                return RedundantDataProto;
            })();

            return CheckInProto;
        })();

        common.CheckInsProto = (function() {

            /**
             * Properties of a CheckInsProto.
             * @memberof waiternow.common
             * @interface ICheckInsProto
             * @property {Array.<waiternow.common.ICheckInProto>|null} [checkIns] CheckInsProto checkIns
             * @property {string|null} [continuationToken] CheckInsProto continuationToken
             */

            /**
             * Constructs a new CheckInsProto.
             * @memberof waiternow.common
             * @classdesc Represents a CheckInsProto.
             * @implements ICheckInsProto
             * @constructor
             * @param {waiternow.common.ICheckInsProto=} [properties] Properties to set
             */
            function CheckInsProto(properties) {
                this.checkIns = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * CheckInsProto checkIns.
             * @member {Array.<waiternow.common.ICheckInProto>} checkIns
             * @memberof waiternow.common.CheckInsProto
             * @instance
             */
            CheckInsProto.prototype.checkIns = $util.emptyArray;

            /**
             * CheckInsProto continuationToken.
             * @member {string} continuationToken
             * @memberof waiternow.common.CheckInsProto
             * @instance
             */
            CheckInsProto.prototype.continuationToken = "";

            /**
             * Creates a new CheckInsProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.CheckInsProto
             * @static
             * @param {waiternow.common.ICheckInsProto=} [properties] Properties to set
             * @returns {waiternow.common.CheckInsProto} CheckInsProto instance
             */
            CheckInsProto.create = function create(properties) {
                return new CheckInsProto(properties);
            };

            /**
             * Encodes the specified CheckInsProto message. Does not implicitly {@link waiternow.common.CheckInsProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.CheckInsProto
             * @static
             * @param {waiternow.common.ICheckInsProto} message CheckInsProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CheckInsProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.checkIns != null && message.checkIns.length)
                    for (var i = 0; i < message.checkIns.length; ++i)
                        $root.waiternow.common.CheckInProto.encode(message.checkIns[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.continuationToken);
                return writer;
            };

            /**
             * Encodes the specified CheckInsProto message, length delimited. Does not implicitly {@link waiternow.common.CheckInsProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.CheckInsProto
             * @static
             * @param {waiternow.common.ICheckInsProto} message CheckInsProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CheckInsProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CheckInsProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.CheckInsProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.CheckInsProto} CheckInsProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CheckInsProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CheckInsProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            if (!(message.checkIns && message.checkIns.length))
                                message.checkIns = [];
                            message.checkIns.push($root.waiternow.common.CheckInProto.decode(reader, reader.uint32()));
                            break;
                        }
                    case 2: {
                            message.continuationToken = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CheckInsProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.CheckInsProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.CheckInsProto} CheckInsProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CheckInsProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CheckInsProto message.
             * @function verify
             * @memberof waiternow.common.CheckInsProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CheckInsProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.checkIns != null && message.hasOwnProperty("checkIns")) {
                    if (!Array.isArray(message.checkIns))
                        return "checkIns: array expected";
                    for (var i = 0; i < message.checkIns.length; ++i) {
                        var error = $root.waiternow.common.CheckInProto.verify(message.checkIns[i]);
                        if (error)
                            return "checkIns." + error;
                    }
                }
                if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                    if (!$util.isString(message.continuationToken))
                        return "continuationToken: string expected";
                return null;
            };

            /**
             * Creates a CheckInsProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.CheckInsProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.CheckInsProto} CheckInsProto
             */
            CheckInsProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.CheckInsProto)
                    return object;
                var message = new $root.waiternow.common.CheckInsProto();
                if (object.checkIns) {
                    if (!Array.isArray(object.checkIns))
                        throw TypeError(".waiternow.common.CheckInsProto.checkIns: array expected");
                    message.checkIns = [];
                    for (var i = 0; i < object.checkIns.length; ++i) {
                        if (typeof object.checkIns[i] !== "object")
                            throw TypeError(".waiternow.common.CheckInsProto.checkIns: object expected");
                        message.checkIns[i] = $root.waiternow.common.CheckInProto.fromObject(object.checkIns[i]);
                    }
                }
                if (object.continuationToken != null)
                    message.continuationToken = String(object.continuationToken);
                return message;
            };

            /**
             * Creates a plain object from a CheckInsProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.CheckInsProto
             * @static
             * @param {waiternow.common.CheckInsProto} message CheckInsProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CheckInsProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.checkIns = [];
                if (options.defaults)
                    object.continuationToken = "";
                if (message.checkIns && message.checkIns.length) {
                    object.checkIns = [];
                    for (var j = 0; j < message.checkIns.length; ++j)
                        object.checkIns[j] = $root.waiternow.common.CheckInProto.toObject(message.checkIns[j], options);
                }
                if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                    object.continuationToken = message.continuationToken;
                return object;
            };

            /**
             * Converts this CheckInsProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.CheckInsProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CheckInsProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for CheckInsProto
             * @function getTypeUrl
             * @memberof waiternow.common.CheckInsProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            CheckInsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.CheckInsProto";
            };

            return CheckInsProto;
        })();

        common.CheckInDataProto = (function() {

            /**
             * Properties of a CheckInDataProto.
             * @memberof waiternow.common
             * @interface ICheckInDataProto
             * @property {waiternow.common.CheckInDataProto.IBusinessDataProto|null} [businessData] CheckInDataProto businessData
             * @property {waiternow.common.CheckInDataProto.IMenuDataProto|null} [menuData] CheckInDataProto menuData
             * @property {waiternow.common.CheckInDataProto.IPaymentsDataProto|null} [paymentsData] CheckInDataProto paymentsData
             * @property {waiternow.common.CheckInDataProto.IStatusProto|null} [status] CheckInDataProto status
             * @property {waiternow.common.CheckInDataProto.IEnabledFeaturesProto|null} [enabledFeatures] CheckInDataProto enabledFeatures
             * @property {waiternow.common.CheckInDataProto.IConfigurationProto|null} [configuration] CheckInDataProto configuration
             * @property {waiternow.common.CheckInDataProto.IViewSettingsProto|null} [viewSettings] CheckInDataProto viewSettings
             */

            /**
             * Constructs a new CheckInDataProto.
             * @memberof waiternow.common
             * @classdesc Represents a CheckInDataProto.
             * @implements ICheckInDataProto
             * @constructor
             * @param {waiternow.common.ICheckInDataProto=} [properties] Properties to set
             */
            function CheckInDataProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * CheckInDataProto businessData.
             * @member {waiternow.common.CheckInDataProto.IBusinessDataProto|null|undefined} businessData
             * @memberof waiternow.common.CheckInDataProto
             * @instance
             */
            CheckInDataProto.prototype.businessData = null;

            /**
             * CheckInDataProto menuData.
             * @member {waiternow.common.CheckInDataProto.IMenuDataProto|null|undefined} menuData
             * @memberof waiternow.common.CheckInDataProto
             * @instance
             */
            CheckInDataProto.prototype.menuData = null;

            /**
             * CheckInDataProto paymentsData.
             * @member {waiternow.common.CheckInDataProto.IPaymentsDataProto|null|undefined} paymentsData
             * @memberof waiternow.common.CheckInDataProto
             * @instance
             */
            CheckInDataProto.prototype.paymentsData = null;

            /**
             * CheckInDataProto status.
             * @member {waiternow.common.CheckInDataProto.IStatusProto|null|undefined} status
             * @memberof waiternow.common.CheckInDataProto
             * @instance
             */
            CheckInDataProto.prototype.status = null;

            /**
             * CheckInDataProto enabledFeatures.
             * @member {waiternow.common.CheckInDataProto.IEnabledFeaturesProto|null|undefined} enabledFeatures
             * @memberof waiternow.common.CheckInDataProto
             * @instance
             */
            CheckInDataProto.prototype.enabledFeatures = null;

            /**
             * CheckInDataProto configuration.
             * @member {waiternow.common.CheckInDataProto.IConfigurationProto|null|undefined} configuration
             * @memberof waiternow.common.CheckInDataProto
             * @instance
             */
            CheckInDataProto.prototype.configuration = null;

            /**
             * CheckInDataProto viewSettings.
             * @member {waiternow.common.CheckInDataProto.IViewSettingsProto|null|undefined} viewSettings
             * @memberof waiternow.common.CheckInDataProto
             * @instance
             */
            CheckInDataProto.prototype.viewSettings = null;

            /**
             * Creates a new CheckInDataProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.CheckInDataProto
             * @static
             * @param {waiternow.common.ICheckInDataProto=} [properties] Properties to set
             * @returns {waiternow.common.CheckInDataProto} CheckInDataProto instance
             */
            CheckInDataProto.create = function create(properties) {
                return new CheckInDataProto(properties);
            };

            /**
             * Encodes the specified CheckInDataProto message. Does not implicitly {@link waiternow.common.CheckInDataProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.CheckInDataProto
             * @static
             * @param {waiternow.common.ICheckInDataProto} message CheckInDataProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CheckInDataProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.businessData != null && Object.hasOwnProperty.call(message, "businessData"))
                    $root.waiternow.common.CheckInDataProto.BusinessDataProto.encode(message.businessData, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.menuData != null && Object.hasOwnProperty.call(message, "menuData"))
                    $root.waiternow.common.CheckInDataProto.MenuDataProto.encode(message.menuData, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.paymentsData != null && Object.hasOwnProperty.call(message, "paymentsData"))
                    $root.waiternow.common.CheckInDataProto.PaymentsDataProto.encode(message.paymentsData, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                    $root.waiternow.common.CheckInDataProto.StatusProto.encode(message.status, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                if (message.enabledFeatures != null && Object.hasOwnProperty.call(message, "enabledFeatures"))
                    $root.waiternow.common.CheckInDataProto.EnabledFeaturesProto.encode(message.enabledFeatures, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                if (message.configuration != null && Object.hasOwnProperty.call(message, "configuration"))
                    $root.waiternow.common.CheckInDataProto.ConfigurationProto.encode(message.configuration, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                if (message.viewSettings != null && Object.hasOwnProperty.call(message, "viewSettings"))
                    $root.waiternow.common.CheckInDataProto.ViewSettingsProto.encode(message.viewSettings, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified CheckInDataProto message, length delimited. Does not implicitly {@link waiternow.common.CheckInDataProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.CheckInDataProto
             * @static
             * @param {waiternow.common.ICheckInDataProto} message CheckInDataProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CheckInDataProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CheckInDataProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.CheckInDataProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.CheckInDataProto} CheckInDataProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CheckInDataProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CheckInDataProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.businessData = $root.waiternow.common.CheckInDataProto.BusinessDataProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 2: {
                            message.menuData = $root.waiternow.common.CheckInDataProto.MenuDataProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 3: {
                            message.paymentsData = $root.waiternow.common.CheckInDataProto.PaymentsDataProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 4: {
                            message.status = $root.waiternow.common.CheckInDataProto.StatusProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 5: {
                            message.enabledFeatures = $root.waiternow.common.CheckInDataProto.EnabledFeaturesProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 6: {
                            message.configuration = $root.waiternow.common.CheckInDataProto.ConfigurationProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 7: {
                            message.viewSettings = $root.waiternow.common.CheckInDataProto.ViewSettingsProto.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CheckInDataProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.CheckInDataProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.CheckInDataProto} CheckInDataProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CheckInDataProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CheckInDataProto message.
             * @function verify
             * @memberof waiternow.common.CheckInDataProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CheckInDataProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.businessData != null && message.hasOwnProperty("businessData")) {
                    var error = $root.waiternow.common.CheckInDataProto.BusinessDataProto.verify(message.businessData);
                    if (error)
                        return "businessData." + error;
                }
                if (message.menuData != null && message.hasOwnProperty("menuData")) {
                    var error = $root.waiternow.common.CheckInDataProto.MenuDataProto.verify(message.menuData);
                    if (error)
                        return "menuData." + error;
                }
                if (message.paymentsData != null && message.hasOwnProperty("paymentsData")) {
                    var error = $root.waiternow.common.CheckInDataProto.PaymentsDataProto.verify(message.paymentsData);
                    if (error)
                        return "paymentsData." + error;
                }
                if (message.status != null && message.hasOwnProperty("status")) {
                    var error = $root.waiternow.common.CheckInDataProto.StatusProto.verify(message.status);
                    if (error)
                        return "status." + error;
                }
                if (message.enabledFeatures != null && message.hasOwnProperty("enabledFeatures")) {
                    var error = $root.waiternow.common.CheckInDataProto.EnabledFeaturesProto.verify(message.enabledFeatures);
                    if (error)
                        return "enabledFeatures." + error;
                }
                if (message.configuration != null && message.hasOwnProperty("configuration")) {
                    var error = $root.waiternow.common.CheckInDataProto.ConfigurationProto.verify(message.configuration);
                    if (error)
                        return "configuration." + error;
                }
                if (message.viewSettings != null && message.hasOwnProperty("viewSettings")) {
                    var error = $root.waiternow.common.CheckInDataProto.ViewSettingsProto.verify(message.viewSettings);
                    if (error)
                        return "viewSettings." + error;
                }
                return null;
            };

            /**
             * Creates a CheckInDataProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.CheckInDataProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.CheckInDataProto} CheckInDataProto
             */
            CheckInDataProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.CheckInDataProto)
                    return object;
                var message = new $root.waiternow.common.CheckInDataProto();
                if (object.businessData != null) {
                    if (typeof object.businessData !== "object")
                        throw TypeError(".waiternow.common.CheckInDataProto.businessData: object expected");
                    message.businessData = $root.waiternow.common.CheckInDataProto.BusinessDataProto.fromObject(object.businessData);
                }
                if (object.menuData != null) {
                    if (typeof object.menuData !== "object")
                        throw TypeError(".waiternow.common.CheckInDataProto.menuData: object expected");
                    message.menuData = $root.waiternow.common.CheckInDataProto.MenuDataProto.fromObject(object.menuData);
                }
                if (object.paymentsData != null) {
                    if (typeof object.paymentsData !== "object")
                        throw TypeError(".waiternow.common.CheckInDataProto.paymentsData: object expected");
                    message.paymentsData = $root.waiternow.common.CheckInDataProto.PaymentsDataProto.fromObject(object.paymentsData);
                }
                if (object.status != null) {
                    if (typeof object.status !== "object")
                        throw TypeError(".waiternow.common.CheckInDataProto.status: object expected");
                    message.status = $root.waiternow.common.CheckInDataProto.StatusProto.fromObject(object.status);
                }
                if (object.enabledFeatures != null) {
                    if (typeof object.enabledFeatures !== "object")
                        throw TypeError(".waiternow.common.CheckInDataProto.enabledFeatures: object expected");
                    message.enabledFeatures = $root.waiternow.common.CheckInDataProto.EnabledFeaturesProto.fromObject(object.enabledFeatures);
                }
                if (object.configuration != null) {
                    if (typeof object.configuration !== "object")
                        throw TypeError(".waiternow.common.CheckInDataProto.configuration: object expected");
                    message.configuration = $root.waiternow.common.CheckInDataProto.ConfigurationProto.fromObject(object.configuration);
                }
                if (object.viewSettings != null) {
                    if (typeof object.viewSettings !== "object")
                        throw TypeError(".waiternow.common.CheckInDataProto.viewSettings: object expected");
                    message.viewSettings = $root.waiternow.common.CheckInDataProto.ViewSettingsProto.fromObject(object.viewSettings);
                }
                return message;
            };

            /**
             * Creates a plain object from a CheckInDataProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.CheckInDataProto
             * @static
             * @param {waiternow.common.CheckInDataProto} message CheckInDataProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CheckInDataProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.businessData = null;
                    object.menuData = null;
                    object.paymentsData = null;
                    object.status = null;
                    object.enabledFeatures = null;
                    object.configuration = null;
                    object.viewSettings = null;
                }
                if (message.businessData != null && message.hasOwnProperty("businessData"))
                    object.businessData = $root.waiternow.common.CheckInDataProto.BusinessDataProto.toObject(message.businessData, options);
                if (message.menuData != null && message.hasOwnProperty("menuData"))
                    object.menuData = $root.waiternow.common.CheckInDataProto.MenuDataProto.toObject(message.menuData, options);
                if (message.paymentsData != null && message.hasOwnProperty("paymentsData"))
                    object.paymentsData = $root.waiternow.common.CheckInDataProto.PaymentsDataProto.toObject(message.paymentsData, options);
                if (message.status != null && message.hasOwnProperty("status"))
                    object.status = $root.waiternow.common.CheckInDataProto.StatusProto.toObject(message.status, options);
                if (message.enabledFeatures != null && message.hasOwnProperty("enabledFeatures"))
                    object.enabledFeatures = $root.waiternow.common.CheckInDataProto.EnabledFeaturesProto.toObject(message.enabledFeatures, options);
                if (message.configuration != null && message.hasOwnProperty("configuration"))
                    object.configuration = $root.waiternow.common.CheckInDataProto.ConfigurationProto.toObject(message.configuration, options);
                if (message.viewSettings != null && message.hasOwnProperty("viewSettings"))
                    object.viewSettings = $root.waiternow.common.CheckInDataProto.ViewSettingsProto.toObject(message.viewSettings, options);
                return object;
            };

            /**
             * Converts this CheckInDataProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.CheckInDataProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CheckInDataProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for CheckInDataProto
             * @function getTypeUrl
             * @memberof waiternow.common.CheckInDataProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            CheckInDataProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.CheckInDataProto";
            };

            CheckInDataProto.BusinessDataProto = (function() {

                /**
                 * Properties of a BusinessDataProto.
                 * @memberof waiternow.common.CheckInDataProto
                 * @interface IBusinessDataProto
                 * @property {string|null} [pointOfServiceId] BusinessDataProto pointOfServiceId
                 * @property {string|null} [locationId] BusinessDataProto locationId
                 * @property {string|null} [businessName] BusinessDataProto businessName
                 * @property {string|null} [locationName] BusinessDataProto locationName
                 * @property {string|null} [pointOfServiceFriendlyName] BusinessDataProto pointOfServiceFriendlyName
                 * @property {waiternow.common.IImageProto|null} [businessLogo] BusinessDataProto businessLogo
                 * @property {waiternow.common.IImageProto|null} [menuHeaderForLandscapeScreen] BusinessDataProto menuHeaderForLandscapeScreen
                 * @property {waiternow.common.IImageProto|null} [menuHeaderForPortraitScreen] BusinessDataProto menuHeaderForPortraitScreen
                 * @property {waiternow.common.IImageProto|null} [homeHeaderForLandscapeScreen] BusinessDataProto homeHeaderForLandscapeScreen
                 * @property {waiternow.common.IImageProto|null} [homeHeaderForPortraitScreen] BusinessDataProto homeHeaderForPortraitScreen
                 * @property {waiternow.common.IAddressProto|null} [locationAddress] BusinessDataProto locationAddress
                 * @property {waiternow.common.Language|null} [language] BusinessDataProto language
                 * @property {waiternow.common.LocationProto.SettingsProto.IExternalLinksProto|null} [externalLinks] BusinessDataProto externalLinks
                 * @property {waiternow.common.IBusinessHoursProto|null} [businessHours] BusinessDataProto businessHours
                 * @property {waiternow.common.IPhoneNumberProto|null} [locationPhoneNumber] BusinessDataProto locationPhoneNumber
                 * @property {string|null} [legacyDescription] BusinessDataProto legacyDescription
                 * @property {waiternow.common.ITextProto|null} [description] BusinessDataProto description
                 * @property {waiternow.common.ITextProto|null} [locationAnnouncement] BusinessDataProto locationAnnouncement
                 */

                /**
                 * Constructs a new BusinessDataProto.
                 * @memberof waiternow.common.CheckInDataProto
                 * @classdesc Represents a BusinessDataProto.
                 * @implements IBusinessDataProto
                 * @constructor
                 * @param {waiternow.common.CheckInDataProto.IBusinessDataProto=} [properties] Properties to set
                 */
                function BusinessDataProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * BusinessDataProto pointOfServiceId.
                 * @member {string} pointOfServiceId
                 * @memberof waiternow.common.CheckInDataProto.BusinessDataProto
                 * @instance
                 */
                BusinessDataProto.prototype.pointOfServiceId = "";

                /**
                 * BusinessDataProto locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.CheckInDataProto.BusinessDataProto
                 * @instance
                 */
                BusinessDataProto.prototype.locationId = "";

                /**
                 * BusinessDataProto businessName.
                 * @member {string} businessName
                 * @memberof waiternow.common.CheckInDataProto.BusinessDataProto
                 * @instance
                 */
                BusinessDataProto.prototype.businessName = "";

                /**
                 * BusinessDataProto locationName.
                 * @member {string} locationName
                 * @memberof waiternow.common.CheckInDataProto.BusinessDataProto
                 * @instance
                 */
                BusinessDataProto.prototype.locationName = "";

                /**
                 * BusinessDataProto pointOfServiceFriendlyName.
                 * @member {string} pointOfServiceFriendlyName
                 * @memberof waiternow.common.CheckInDataProto.BusinessDataProto
                 * @instance
                 */
                BusinessDataProto.prototype.pointOfServiceFriendlyName = "";

                /**
                 * BusinessDataProto businessLogo.
                 * @member {waiternow.common.IImageProto|null|undefined} businessLogo
                 * @memberof waiternow.common.CheckInDataProto.BusinessDataProto
                 * @instance
                 */
                BusinessDataProto.prototype.businessLogo = null;

                /**
                 * BusinessDataProto menuHeaderForLandscapeScreen.
                 * @member {waiternow.common.IImageProto|null|undefined} menuHeaderForLandscapeScreen
                 * @memberof waiternow.common.CheckInDataProto.BusinessDataProto
                 * @instance
                 */
                BusinessDataProto.prototype.menuHeaderForLandscapeScreen = null;

                /**
                 * BusinessDataProto menuHeaderForPortraitScreen.
                 * @member {waiternow.common.IImageProto|null|undefined} menuHeaderForPortraitScreen
                 * @memberof waiternow.common.CheckInDataProto.BusinessDataProto
                 * @instance
                 */
                BusinessDataProto.prototype.menuHeaderForPortraitScreen = null;

                /**
                 * BusinessDataProto homeHeaderForLandscapeScreen.
                 * @member {waiternow.common.IImageProto|null|undefined} homeHeaderForLandscapeScreen
                 * @memberof waiternow.common.CheckInDataProto.BusinessDataProto
                 * @instance
                 */
                BusinessDataProto.prototype.homeHeaderForLandscapeScreen = null;

                /**
                 * BusinessDataProto homeHeaderForPortraitScreen.
                 * @member {waiternow.common.IImageProto|null|undefined} homeHeaderForPortraitScreen
                 * @memberof waiternow.common.CheckInDataProto.BusinessDataProto
                 * @instance
                 */
                BusinessDataProto.prototype.homeHeaderForPortraitScreen = null;

                /**
                 * BusinessDataProto locationAddress.
                 * @member {waiternow.common.IAddressProto|null|undefined} locationAddress
                 * @memberof waiternow.common.CheckInDataProto.BusinessDataProto
                 * @instance
                 */
                BusinessDataProto.prototype.locationAddress = null;

                /**
                 * BusinessDataProto language.
                 * @member {waiternow.common.Language} language
                 * @memberof waiternow.common.CheckInDataProto.BusinessDataProto
                 * @instance
                 */
                BusinessDataProto.prototype.language = 0;

                /**
                 * BusinessDataProto externalLinks.
                 * @member {waiternow.common.LocationProto.SettingsProto.IExternalLinksProto|null|undefined} externalLinks
                 * @memberof waiternow.common.CheckInDataProto.BusinessDataProto
                 * @instance
                 */
                BusinessDataProto.prototype.externalLinks = null;

                /**
                 * BusinessDataProto businessHours.
                 * @member {waiternow.common.IBusinessHoursProto|null|undefined} businessHours
                 * @memberof waiternow.common.CheckInDataProto.BusinessDataProto
                 * @instance
                 */
                BusinessDataProto.prototype.businessHours = null;

                /**
                 * BusinessDataProto locationPhoneNumber.
                 * @member {waiternow.common.IPhoneNumberProto|null|undefined} locationPhoneNumber
                 * @memberof waiternow.common.CheckInDataProto.BusinessDataProto
                 * @instance
                 */
                BusinessDataProto.prototype.locationPhoneNumber = null;

                /**
                 * BusinessDataProto legacyDescription.
                 * @member {string} legacyDescription
                 * @memberof waiternow.common.CheckInDataProto.BusinessDataProto
                 * @instance
                 */
                BusinessDataProto.prototype.legacyDescription = "";

                /**
                 * BusinessDataProto description.
                 * @member {waiternow.common.ITextProto|null|undefined} description
                 * @memberof waiternow.common.CheckInDataProto.BusinessDataProto
                 * @instance
                 */
                BusinessDataProto.prototype.description = null;

                /**
                 * BusinessDataProto locationAnnouncement.
                 * @member {waiternow.common.ITextProto|null|undefined} locationAnnouncement
                 * @memberof waiternow.common.CheckInDataProto.BusinessDataProto
                 * @instance
                 */
                BusinessDataProto.prototype.locationAnnouncement = null;

                /**
                 * Creates a new BusinessDataProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.CheckInDataProto.BusinessDataProto
                 * @static
                 * @param {waiternow.common.CheckInDataProto.IBusinessDataProto=} [properties] Properties to set
                 * @returns {waiternow.common.CheckInDataProto.BusinessDataProto} BusinessDataProto instance
                 */
                BusinessDataProto.create = function create(properties) {
                    return new BusinessDataProto(properties);
                };

                /**
                 * Encodes the specified BusinessDataProto message. Does not implicitly {@link waiternow.common.CheckInDataProto.BusinessDataProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.CheckInDataProto.BusinessDataProto
                 * @static
                 * @param {waiternow.common.CheckInDataProto.IBusinessDataProto} message BusinessDataProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BusinessDataProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.pointOfServiceId != null && Object.hasOwnProperty.call(message, "pointOfServiceId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.pointOfServiceId);
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.locationId);
                    if (message.businessName != null && Object.hasOwnProperty.call(message, "businessName"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.businessName);
                    if (message.locationName != null && Object.hasOwnProperty.call(message, "locationName"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.locationName);
                    if (message.pointOfServiceFriendlyName != null && Object.hasOwnProperty.call(message, "pointOfServiceFriendlyName"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.pointOfServiceFriendlyName);
                    if (message.businessLogo != null && Object.hasOwnProperty.call(message, "businessLogo"))
                        $root.waiternow.common.ImageProto.encode(message.businessLogo, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.menuHeaderForLandscapeScreen != null && Object.hasOwnProperty.call(message, "menuHeaderForLandscapeScreen"))
                        $root.waiternow.common.ImageProto.encode(message.menuHeaderForLandscapeScreen, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    if (message.menuHeaderForPortraitScreen != null && Object.hasOwnProperty.call(message, "menuHeaderForPortraitScreen"))
                        $root.waiternow.common.ImageProto.encode(message.menuHeaderForPortraitScreen, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                    if (message.locationAddress != null && Object.hasOwnProperty.call(message, "locationAddress"))
                        $root.waiternow.common.AddressProto.encode(message.locationAddress, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                    if (message.language != null && Object.hasOwnProperty.call(message, "language"))
                        writer.uint32(/* id 10, wireType 0 =*/80).int32(message.language);
                    if (message.externalLinks != null && Object.hasOwnProperty.call(message, "externalLinks"))
                        $root.waiternow.common.LocationProto.SettingsProto.ExternalLinksProto.encode(message.externalLinks, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                    if (message.businessHours != null && Object.hasOwnProperty.call(message, "businessHours"))
                        $root.waiternow.common.BusinessHoursProto.encode(message.businessHours, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                    if (message.locationPhoneNumber != null && Object.hasOwnProperty.call(message, "locationPhoneNumber"))
                        $root.waiternow.common.PhoneNumberProto.encode(message.locationPhoneNumber, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
                    if (message.legacyDescription != null && Object.hasOwnProperty.call(message, "legacyDescription"))
                        writer.uint32(/* id 14, wireType 2 =*/114).string(message.legacyDescription);
                    if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                        $root.waiternow.common.TextProto.encode(message.description, writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
                    if (message.locationAnnouncement != null && Object.hasOwnProperty.call(message, "locationAnnouncement"))
                        $root.waiternow.common.TextProto.encode(message.locationAnnouncement, writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
                    if (message.homeHeaderForLandscapeScreen != null && Object.hasOwnProperty.call(message, "homeHeaderForLandscapeScreen"))
                        $root.waiternow.common.ImageProto.encode(message.homeHeaderForLandscapeScreen, writer.uint32(/* id 17, wireType 2 =*/138).fork()).ldelim();
                    if (message.homeHeaderForPortraitScreen != null && Object.hasOwnProperty.call(message, "homeHeaderForPortraitScreen"))
                        $root.waiternow.common.ImageProto.encode(message.homeHeaderForPortraitScreen, writer.uint32(/* id 18, wireType 2 =*/146).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified BusinessDataProto message, length delimited. Does not implicitly {@link waiternow.common.CheckInDataProto.BusinessDataProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.CheckInDataProto.BusinessDataProto
                 * @static
                 * @param {waiternow.common.CheckInDataProto.IBusinessDataProto} message BusinessDataProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BusinessDataProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a BusinessDataProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.CheckInDataProto.BusinessDataProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.CheckInDataProto.BusinessDataProto} BusinessDataProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BusinessDataProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CheckInDataProto.BusinessDataProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.pointOfServiceId = reader.string();
                                break;
                            }
                        case 2: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 3: {
                                message.businessName = reader.string();
                                break;
                            }
                        case 4: {
                                message.locationName = reader.string();
                                break;
                            }
                        case 5: {
                                message.pointOfServiceFriendlyName = reader.string();
                                break;
                            }
                        case 6: {
                                message.businessLogo = $root.waiternow.common.ImageProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 7: {
                                message.menuHeaderForLandscapeScreen = $root.waiternow.common.ImageProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 8: {
                                message.menuHeaderForPortraitScreen = $root.waiternow.common.ImageProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 17: {
                                message.homeHeaderForLandscapeScreen = $root.waiternow.common.ImageProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 18: {
                                message.homeHeaderForPortraitScreen = $root.waiternow.common.ImageProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 9: {
                                message.locationAddress = $root.waiternow.common.AddressProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 10: {
                                message.language = reader.int32();
                                break;
                            }
                        case 11: {
                                message.externalLinks = $root.waiternow.common.LocationProto.SettingsProto.ExternalLinksProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 12: {
                                message.businessHours = $root.waiternow.common.BusinessHoursProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 13: {
                                message.locationPhoneNumber = $root.waiternow.common.PhoneNumberProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 14: {
                                message.legacyDescription = reader.string();
                                break;
                            }
                        case 15: {
                                message.description = $root.waiternow.common.TextProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 16: {
                                message.locationAnnouncement = $root.waiternow.common.TextProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a BusinessDataProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.CheckInDataProto.BusinessDataProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.CheckInDataProto.BusinessDataProto} BusinessDataProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BusinessDataProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a BusinessDataProto message.
                 * @function verify
                 * @memberof waiternow.common.CheckInDataProto.BusinessDataProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                BusinessDataProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.pointOfServiceId != null && message.hasOwnProperty("pointOfServiceId"))
                        if (!$util.isString(message.pointOfServiceId))
                            return "pointOfServiceId: string expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    if (message.businessName != null && message.hasOwnProperty("businessName"))
                        if (!$util.isString(message.businessName))
                            return "businessName: string expected";
                    if (message.locationName != null && message.hasOwnProperty("locationName"))
                        if (!$util.isString(message.locationName))
                            return "locationName: string expected";
                    if (message.pointOfServiceFriendlyName != null && message.hasOwnProperty("pointOfServiceFriendlyName"))
                        if (!$util.isString(message.pointOfServiceFriendlyName))
                            return "pointOfServiceFriendlyName: string expected";
                    if (message.businessLogo != null && message.hasOwnProperty("businessLogo")) {
                        var error = $root.waiternow.common.ImageProto.verify(message.businessLogo);
                        if (error)
                            return "businessLogo." + error;
                    }
                    if (message.menuHeaderForLandscapeScreen != null && message.hasOwnProperty("menuHeaderForLandscapeScreen")) {
                        var error = $root.waiternow.common.ImageProto.verify(message.menuHeaderForLandscapeScreen);
                        if (error)
                            return "menuHeaderForLandscapeScreen." + error;
                    }
                    if (message.menuHeaderForPortraitScreen != null && message.hasOwnProperty("menuHeaderForPortraitScreen")) {
                        var error = $root.waiternow.common.ImageProto.verify(message.menuHeaderForPortraitScreen);
                        if (error)
                            return "menuHeaderForPortraitScreen." + error;
                    }
                    if (message.homeHeaderForLandscapeScreen != null && message.hasOwnProperty("homeHeaderForLandscapeScreen")) {
                        var error = $root.waiternow.common.ImageProto.verify(message.homeHeaderForLandscapeScreen);
                        if (error)
                            return "homeHeaderForLandscapeScreen." + error;
                    }
                    if (message.homeHeaderForPortraitScreen != null && message.hasOwnProperty("homeHeaderForPortraitScreen")) {
                        var error = $root.waiternow.common.ImageProto.verify(message.homeHeaderForPortraitScreen);
                        if (error)
                            return "homeHeaderForPortraitScreen." + error;
                    }
                    if (message.locationAddress != null && message.hasOwnProperty("locationAddress")) {
                        var error = $root.waiternow.common.AddressProto.verify(message.locationAddress);
                        if (error)
                            return "locationAddress." + error;
                    }
                    if (message.language != null && message.hasOwnProperty("language"))
                        switch (message.language) {
                        default:
                            return "language: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.externalLinks != null && message.hasOwnProperty("externalLinks")) {
                        var error = $root.waiternow.common.LocationProto.SettingsProto.ExternalLinksProto.verify(message.externalLinks);
                        if (error)
                            return "externalLinks." + error;
                    }
                    if (message.businessHours != null && message.hasOwnProperty("businessHours")) {
                        var error = $root.waiternow.common.BusinessHoursProto.verify(message.businessHours);
                        if (error)
                            return "businessHours." + error;
                    }
                    if (message.locationPhoneNumber != null && message.hasOwnProperty("locationPhoneNumber")) {
                        var error = $root.waiternow.common.PhoneNumberProto.verify(message.locationPhoneNumber);
                        if (error)
                            return "locationPhoneNumber." + error;
                    }
                    if (message.legacyDescription != null && message.hasOwnProperty("legacyDescription"))
                        if (!$util.isString(message.legacyDescription))
                            return "legacyDescription: string expected";
                    if (message.description != null && message.hasOwnProperty("description")) {
                        var error = $root.waiternow.common.TextProto.verify(message.description);
                        if (error)
                            return "description." + error;
                    }
                    if (message.locationAnnouncement != null && message.hasOwnProperty("locationAnnouncement")) {
                        var error = $root.waiternow.common.TextProto.verify(message.locationAnnouncement);
                        if (error)
                            return "locationAnnouncement." + error;
                    }
                    return null;
                };

                /**
                 * Creates a BusinessDataProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.CheckInDataProto.BusinessDataProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.CheckInDataProto.BusinessDataProto} BusinessDataProto
                 */
                BusinessDataProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.CheckInDataProto.BusinessDataProto)
                        return object;
                    var message = new $root.waiternow.common.CheckInDataProto.BusinessDataProto();
                    if (object.pointOfServiceId != null)
                        message.pointOfServiceId = String(object.pointOfServiceId);
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    if (object.businessName != null)
                        message.businessName = String(object.businessName);
                    if (object.locationName != null)
                        message.locationName = String(object.locationName);
                    if (object.pointOfServiceFriendlyName != null)
                        message.pointOfServiceFriendlyName = String(object.pointOfServiceFriendlyName);
                    if (object.businessLogo != null) {
                        if (typeof object.businessLogo !== "object")
                            throw TypeError(".waiternow.common.CheckInDataProto.BusinessDataProto.businessLogo: object expected");
                        message.businessLogo = $root.waiternow.common.ImageProto.fromObject(object.businessLogo);
                    }
                    if (object.menuHeaderForLandscapeScreen != null) {
                        if (typeof object.menuHeaderForLandscapeScreen !== "object")
                            throw TypeError(".waiternow.common.CheckInDataProto.BusinessDataProto.menuHeaderForLandscapeScreen: object expected");
                        message.menuHeaderForLandscapeScreen = $root.waiternow.common.ImageProto.fromObject(object.menuHeaderForLandscapeScreen);
                    }
                    if (object.menuHeaderForPortraitScreen != null) {
                        if (typeof object.menuHeaderForPortraitScreen !== "object")
                            throw TypeError(".waiternow.common.CheckInDataProto.BusinessDataProto.menuHeaderForPortraitScreen: object expected");
                        message.menuHeaderForPortraitScreen = $root.waiternow.common.ImageProto.fromObject(object.menuHeaderForPortraitScreen);
                    }
                    if (object.homeHeaderForLandscapeScreen != null) {
                        if (typeof object.homeHeaderForLandscapeScreen !== "object")
                            throw TypeError(".waiternow.common.CheckInDataProto.BusinessDataProto.homeHeaderForLandscapeScreen: object expected");
                        message.homeHeaderForLandscapeScreen = $root.waiternow.common.ImageProto.fromObject(object.homeHeaderForLandscapeScreen);
                    }
                    if (object.homeHeaderForPortraitScreen != null) {
                        if (typeof object.homeHeaderForPortraitScreen !== "object")
                            throw TypeError(".waiternow.common.CheckInDataProto.BusinessDataProto.homeHeaderForPortraitScreen: object expected");
                        message.homeHeaderForPortraitScreen = $root.waiternow.common.ImageProto.fromObject(object.homeHeaderForPortraitScreen);
                    }
                    if (object.locationAddress != null) {
                        if (typeof object.locationAddress !== "object")
                            throw TypeError(".waiternow.common.CheckInDataProto.BusinessDataProto.locationAddress: object expected");
                        message.locationAddress = $root.waiternow.common.AddressProto.fromObject(object.locationAddress);
                    }
                    switch (object.language) {
                    default:
                        if (typeof object.language === "number") {
                            message.language = object.language;
                            break;
                        }
                        break;
                    case "LANGUAGE_UNSPECIFIED":
                    case 0:
                        message.language = 0;
                        break;
                    case "ENGLISH":
                    case 1:
                        message.language = 1;
                        break;
                    case "SPANISH":
                    case 2:
                        message.language = 2;
                        break;
                    }
                    if (object.externalLinks != null) {
                        if (typeof object.externalLinks !== "object")
                            throw TypeError(".waiternow.common.CheckInDataProto.BusinessDataProto.externalLinks: object expected");
                        message.externalLinks = $root.waiternow.common.LocationProto.SettingsProto.ExternalLinksProto.fromObject(object.externalLinks);
                    }
                    if (object.businessHours != null) {
                        if (typeof object.businessHours !== "object")
                            throw TypeError(".waiternow.common.CheckInDataProto.BusinessDataProto.businessHours: object expected");
                        message.businessHours = $root.waiternow.common.BusinessHoursProto.fromObject(object.businessHours);
                    }
                    if (object.locationPhoneNumber != null) {
                        if (typeof object.locationPhoneNumber !== "object")
                            throw TypeError(".waiternow.common.CheckInDataProto.BusinessDataProto.locationPhoneNumber: object expected");
                        message.locationPhoneNumber = $root.waiternow.common.PhoneNumberProto.fromObject(object.locationPhoneNumber);
                    }
                    if (object.legacyDescription != null)
                        message.legacyDescription = String(object.legacyDescription);
                    if (object.description != null) {
                        if (typeof object.description !== "object")
                            throw TypeError(".waiternow.common.CheckInDataProto.BusinessDataProto.description: object expected");
                        message.description = $root.waiternow.common.TextProto.fromObject(object.description);
                    }
                    if (object.locationAnnouncement != null) {
                        if (typeof object.locationAnnouncement !== "object")
                            throw TypeError(".waiternow.common.CheckInDataProto.BusinessDataProto.locationAnnouncement: object expected");
                        message.locationAnnouncement = $root.waiternow.common.TextProto.fromObject(object.locationAnnouncement);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a BusinessDataProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.CheckInDataProto.BusinessDataProto
                 * @static
                 * @param {waiternow.common.CheckInDataProto.BusinessDataProto} message BusinessDataProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                BusinessDataProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.pointOfServiceId = "";
                        object.locationId = "";
                        object.businessName = "";
                        object.locationName = "";
                        object.pointOfServiceFriendlyName = "";
                        object.businessLogo = null;
                        object.menuHeaderForLandscapeScreen = null;
                        object.menuHeaderForPortraitScreen = null;
                        object.locationAddress = null;
                        object.language = options.enums === String ? "LANGUAGE_UNSPECIFIED" : 0;
                        object.externalLinks = null;
                        object.businessHours = null;
                        object.locationPhoneNumber = null;
                        object.legacyDescription = "";
                        object.description = null;
                        object.locationAnnouncement = null;
                        object.homeHeaderForLandscapeScreen = null;
                        object.homeHeaderForPortraitScreen = null;
                    }
                    if (message.pointOfServiceId != null && message.hasOwnProperty("pointOfServiceId"))
                        object.pointOfServiceId = message.pointOfServiceId;
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    if (message.businessName != null && message.hasOwnProperty("businessName"))
                        object.businessName = message.businessName;
                    if (message.locationName != null && message.hasOwnProperty("locationName"))
                        object.locationName = message.locationName;
                    if (message.pointOfServiceFriendlyName != null && message.hasOwnProperty("pointOfServiceFriendlyName"))
                        object.pointOfServiceFriendlyName = message.pointOfServiceFriendlyName;
                    if (message.businessLogo != null && message.hasOwnProperty("businessLogo"))
                        object.businessLogo = $root.waiternow.common.ImageProto.toObject(message.businessLogo, options);
                    if (message.menuHeaderForLandscapeScreen != null && message.hasOwnProperty("menuHeaderForLandscapeScreen"))
                        object.menuHeaderForLandscapeScreen = $root.waiternow.common.ImageProto.toObject(message.menuHeaderForLandscapeScreen, options);
                    if (message.menuHeaderForPortraitScreen != null && message.hasOwnProperty("menuHeaderForPortraitScreen"))
                        object.menuHeaderForPortraitScreen = $root.waiternow.common.ImageProto.toObject(message.menuHeaderForPortraitScreen, options);
                    if (message.locationAddress != null && message.hasOwnProperty("locationAddress"))
                        object.locationAddress = $root.waiternow.common.AddressProto.toObject(message.locationAddress, options);
                    if (message.language != null && message.hasOwnProperty("language"))
                        object.language = options.enums === String ? $root.waiternow.common.Language[message.language] === undefined ? message.language : $root.waiternow.common.Language[message.language] : message.language;
                    if (message.externalLinks != null && message.hasOwnProperty("externalLinks"))
                        object.externalLinks = $root.waiternow.common.LocationProto.SettingsProto.ExternalLinksProto.toObject(message.externalLinks, options);
                    if (message.businessHours != null && message.hasOwnProperty("businessHours"))
                        object.businessHours = $root.waiternow.common.BusinessHoursProto.toObject(message.businessHours, options);
                    if (message.locationPhoneNumber != null && message.hasOwnProperty("locationPhoneNumber"))
                        object.locationPhoneNumber = $root.waiternow.common.PhoneNumberProto.toObject(message.locationPhoneNumber, options);
                    if (message.legacyDescription != null && message.hasOwnProperty("legacyDescription"))
                        object.legacyDescription = message.legacyDescription;
                    if (message.description != null && message.hasOwnProperty("description"))
                        object.description = $root.waiternow.common.TextProto.toObject(message.description, options);
                    if (message.locationAnnouncement != null && message.hasOwnProperty("locationAnnouncement"))
                        object.locationAnnouncement = $root.waiternow.common.TextProto.toObject(message.locationAnnouncement, options);
                    if (message.homeHeaderForLandscapeScreen != null && message.hasOwnProperty("homeHeaderForLandscapeScreen"))
                        object.homeHeaderForLandscapeScreen = $root.waiternow.common.ImageProto.toObject(message.homeHeaderForLandscapeScreen, options);
                    if (message.homeHeaderForPortraitScreen != null && message.hasOwnProperty("homeHeaderForPortraitScreen"))
                        object.homeHeaderForPortraitScreen = $root.waiternow.common.ImageProto.toObject(message.homeHeaderForPortraitScreen, options);
                    return object;
                };

                /**
                 * Converts this BusinessDataProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.CheckInDataProto.BusinessDataProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                BusinessDataProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for BusinessDataProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.CheckInDataProto.BusinessDataProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                BusinessDataProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.CheckInDataProto.BusinessDataProto";
                };

                return BusinessDataProto;
            })();

            CheckInDataProto.MenuDataProto = (function() {

                /**
                 * Properties of a MenuDataProto.
                 * @memberof waiternow.common.CheckInDataProto
                 * @interface IMenuDataProto
                 * @property {waiternow.common.IImageMenuProto|null} [imageMenu] MenuDataProto imageMenu
                 * @property {waiternow.common.IMenuProto|null} [menu] MenuDataProto menu
                 * @property {google.protobuf.IDuration|null} [orderPreparationDuration] MenuDataProto orderPreparationDuration
                 */

                /**
                 * Constructs a new MenuDataProto.
                 * @memberof waiternow.common.CheckInDataProto
                 * @classdesc Represents a MenuDataProto.
                 * @implements IMenuDataProto
                 * @constructor
                 * @param {waiternow.common.CheckInDataProto.IMenuDataProto=} [properties] Properties to set
                 */
                function MenuDataProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * MenuDataProto imageMenu.
                 * @member {waiternow.common.IImageMenuProto|null|undefined} imageMenu
                 * @memberof waiternow.common.CheckInDataProto.MenuDataProto
                 * @instance
                 */
                MenuDataProto.prototype.imageMenu = null;

                /**
                 * MenuDataProto menu.
                 * @member {waiternow.common.IMenuProto|null|undefined} menu
                 * @memberof waiternow.common.CheckInDataProto.MenuDataProto
                 * @instance
                 */
                MenuDataProto.prototype.menu = null;

                /**
                 * MenuDataProto orderPreparationDuration.
                 * @member {google.protobuf.IDuration|null|undefined} orderPreparationDuration
                 * @memberof waiternow.common.CheckInDataProto.MenuDataProto
                 * @instance
                 */
                MenuDataProto.prototype.orderPreparationDuration = null;

                /**
                 * Creates a new MenuDataProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.CheckInDataProto.MenuDataProto
                 * @static
                 * @param {waiternow.common.CheckInDataProto.IMenuDataProto=} [properties] Properties to set
                 * @returns {waiternow.common.CheckInDataProto.MenuDataProto} MenuDataProto instance
                 */
                MenuDataProto.create = function create(properties) {
                    return new MenuDataProto(properties);
                };

                /**
                 * Encodes the specified MenuDataProto message. Does not implicitly {@link waiternow.common.CheckInDataProto.MenuDataProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.CheckInDataProto.MenuDataProto
                 * @static
                 * @param {waiternow.common.CheckInDataProto.IMenuDataProto} message MenuDataProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MenuDataProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.imageMenu != null && Object.hasOwnProperty.call(message, "imageMenu"))
                        $root.waiternow.common.ImageMenuProto.encode(message.imageMenu, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.menu != null && Object.hasOwnProperty.call(message, "menu"))
                        $root.waiternow.common.MenuProto.encode(message.menu, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.orderPreparationDuration != null && Object.hasOwnProperty.call(message, "orderPreparationDuration"))
                        $root.google.protobuf.Duration.encode(message.orderPreparationDuration, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified MenuDataProto message, length delimited. Does not implicitly {@link waiternow.common.CheckInDataProto.MenuDataProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.CheckInDataProto.MenuDataProto
                 * @static
                 * @param {waiternow.common.CheckInDataProto.IMenuDataProto} message MenuDataProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MenuDataProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a MenuDataProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.CheckInDataProto.MenuDataProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.CheckInDataProto.MenuDataProto} MenuDataProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MenuDataProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CheckInDataProto.MenuDataProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.imageMenu = $root.waiternow.common.ImageMenuProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.menu = $root.waiternow.common.MenuProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.orderPreparationDuration = $root.google.protobuf.Duration.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a MenuDataProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.CheckInDataProto.MenuDataProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.CheckInDataProto.MenuDataProto} MenuDataProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MenuDataProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a MenuDataProto message.
                 * @function verify
                 * @memberof waiternow.common.CheckInDataProto.MenuDataProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                MenuDataProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.imageMenu != null && message.hasOwnProperty("imageMenu")) {
                        var error = $root.waiternow.common.ImageMenuProto.verify(message.imageMenu);
                        if (error)
                            return "imageMenu." + error;
                    }
                    if (message.menu != null && message.hasOwnProperty("menu")) {
                        var error = $root.waiternow.common.MenuProto.verify(message.menu);
                        if (error)
                            return "menu." + error;
                    }
                    if (message.orderPreparationDuration != null && message.hasOwnProperty("orderPreparationDuration")) {
                        var error = $root.google.protobuf.Duration.verify(message.orderPreparationDuration);
                        if (error)
                            return "orderPreparationDuration." + error;
                    }
                    return null;
                };

                /**
                 * Creates a MenuDataProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.CheckInDataProto.MenuDataProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.CheckInDataProto.MenuDataProto} MenuDataProto
                 */
                MenuDataProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.CheckInDataProto.MenuDataProto)
                        return object;
                    var message = new $root.waiternow.common.CheckInDataProto.MenuDataProto();
                    if (object.imageMenu != null) {
                        if (typeof object.imageMenu !== "object")
                            throw TypeError(".waiternow.common.CheckInDataProto.MenuDataProto.imageMenu: object expected");
                        message.imageMenu = $root.waiternow.common.ImageMenuProto.fromObject(object.imageMenu);
                    }
                    if (object.menu != null) {
                        if (typeof object.menu !== "object")
                            throw TypeError(".waiternow.common.CheckInDataProto.MenuDataProto.menu: object expected");
                        message.menu = $root.waiternow.common.MenuProto.fromObject(object.menu);
                    }
                    if (object.orderPreparationDuration != null) {
                        if (typeof object.orderPreparationDuration !== "object")
                            throw TypeError(".waiternow.common.CheckInDataProto.MenuDataProto.orderPreparationDuration: object expected");
                        message.orderPreparationDuration = $root.google.protobuf.Duration.fromObject(object.orderPreparationDuration);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a MenuDataProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.CheckInDataProto.MenuDataProto
                 * @static
                 * @param {waiternow.common.CheckInDataProto.MenuDataProto} message MenuDataProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                MenuDataProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.imageMenu = null;
                        object.menu = null;
                        object.orderPreparationDuration = null;
                    }
                    if (message.imageMenu != null && message.hasOwnProperty("imageMenu"))
                        object.imageMenu = $root.waiternow.common.ImageMenuProto.toObject(message.imageMenu, options);
                    if (message.menu != null && message.hasOwnProperty("menu"))
                        object.menu = $root.waiternow.common.MenuProto.toObject(message.menu, options);
                    if (message.orderPreparationDuration != null && message.hasOwnProperty("orderPreparationDuration"))
                        object.orderPreparationDuration = $root.google.protobuf.Duration.toObject(message.orderPreparationDuration, options);
                    return object;
                };

                /**
                 * Converts this MenuDataProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.CheckInDataProto.MenuDataProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                MenuDataProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for MenuDataProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.CheckInDataProto.MenuDataProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                MenuDataProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.CheckInDataProto.MenuDataProto";
                };

                return MenuDataProto;
            })();

            CheckInDataProto.PaymentsDataProto = (function() {

                /**
                 * Properties of a PaymentsDataProto.
                 * @memberof waiternow.common.CheckInDataProto
                 * @interface IPaymentsDataProto
                 * @property {string|null} [stripePublishableKey] PaymentsDataProto stripePublishableKey
                 * @property {string|null} [currencyCode] PaymentsDataProto currencyCode
                 * @property {waiternow.common.IDecimalProto|null} [salesTax] PaymentsDataProto salesTax
                 * @property {number|null} [maxAttemptsToMarkOrderAsPaid] PaymentsDataProto maxAttemptsToMarkOrderAsPaid
                 * @property {number|null} [timeBetweenAttemptsToMarkOrderAsPaidSeconds] PaymentsDataProto timeBetweenAttemptsToMarkOrderAsPaidSeconds
                 */

                /**
                 * Constructs a new PaymentsDataProto.
                 * @memberof waiternow.common.CheckInDataProto
                 * @classdesc Represents a PaymentsDataProto.
                 * @implements IPaymentsDataProto
                 * @constructor
                 * @param {waiternow.common.CheckInDataProto.IPaymentsDataProto=} [properties] Properties to set
                 */
                function PaymentsDataProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PaymentsDataProto stripePublishableKey.
                 * @member {string} stripePublishableKey
                 * @memberof waiternow.common.CheckInDataProto.PaymentsDataProto
                 * @instance
                 */
                PaymentsDataProto.prototype.stripePublishableKey = "";

                /**
                 * PaymentsDataProto currencyCode.
                 * @member {string} currencyCode
                 * @memberof waiternow.common.CheckInDataProto.PaymentsDataProto
                 * @instance
                 */
                PaymentsDataProto.prototype.currencyCode = "";

                /**
                 * PaymentsDataProto salesTax.
                 * @member {waiternow.common.IDecimalProto|null|undefined} salesTax
                 * @memberof waiternow.common.CheckInDataProto.PaymentsDataProto
                 * @instance
                 */
                PaymentsDataProto.prototype.salesTax = null;

                /**
                 * PaymentsDataProto maxAttemptsToMarkOrderAsPaid.
                 * @member {number} maxAttemptsToMarkOrderAsPaid
                 * @memberof waiternow.common.CheckInDataProto.PaymentsDataProto
                 * @instance
                 */
                PaymentsDataProto.prototype.maxAttemptsToMarkOrderAsPaid = 0;

                /**
                 * PaymentsDataProto timeBetweenAttemptsToMarkOrderAsPaidSeconds.
                 * @member {number} timeBetweenAttemptsToMarkOrderAsPaidSeconds
                 * @memberof waiternow.common.CheckInDataProto.PaymentsDataProto
                 * @instance
                 */
                PaymentsDataProto.prototype.timeBetweenAttemptsToMarkOrderAsPaidSeconds = 0;

                /**
                 * Creates a new PaymentsDataProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.CheckInDataProto.PaymentsDataProto
                 * @static
                 * @param {waiternow.common.CheckInDataProto.IPaymentsDataProto=} [properties] Properties to set
                 * @returns {waiternow.common.CheckInDataProto.PaymentsDataProto} PaymentsDataProto instance
                 */
                PaymentsDataProto.create = function create(properties) {
                    return new PaymentsDataProto(properties);
                };

                /**
                 * Encodes the specified PaymentsDataProto message. Does not implicitly {@link waiternow.common.CheckInDataProto.PaymentsDataProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.CheckInDataProto.PaymentsDataProto
                 * @static
                 * @param {waiternow.common.CheckInDataProto.IPaymentsDataProto} message PaymentsDataProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PaymentsDataProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.stripePublishableKey != null && Object.hasOwnProperty.call(message, "stripePublishableKey"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.stripePublishableKey);
                    if (message.currencyCode != null && Object.hasOwnProperty.call(message, "currencyCode"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.currencyCode);
                    if (message.salesTax != null && Object.hasOwnProperty.call(message, "salesTax"))
                        $root.waiternow.common.DecimalProto.encode(message.salesTax, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.maxAttemptsToMarkOrderAsPaid != null && Object.hasOwnProperty.call(message, "maxAttemptsToMarkOrderAsPaid"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.maxAttemptsToMarkOrderAsPaid);
                    if (message.timeBetweenAttemptsToMarkOrderAsPaidSeconds != null && Object.hasOwnProperty.call(message, "timeBetweenAttemptsToMarkOrderAsPaidSeconds"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int32(message.timeBetweenAttemptsToMarkOrderAsPaidSeconds);
                    return writer;
                };

                /**
                 * Encodes the specified PaymentsDataProto message, length delimited. Does not implicitly {@link waiternow.common.CheckInDataProto.PaymentsDataProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.CheckInDataProto.PaymentsDataProto
                 * @static
                 * @param {waiternow.common.CheckInDataProto.IPaymentsDataProto} message PaymentsDataProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PaymentsDataProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PaymentsDataProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.CheckInDataProto.PaymentsDataProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.CheckInDataProto.PaymentsDataProto} PaymentsDataProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PaymentsDataProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CheckInDataProto.PaymentsDataProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.stripePublishableKey = reader.string();
                                break;
                            }
                        case 2: {
                                message.currencyCode = reader.string();
                                break;
                            }
                        case 3: {
                                message.salesTax = $root.waiternow.common.DecimalProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 4: {
                                message.maxAttemptsToMarkOrderAsPaid = reader.int32();
                                break;
                            }
                        case 5: {
                                message.timeBetweenAttemptsToMarkOrderAsPaidSeconds = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PaymentsDataProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.CheckInDataProto.PaymentsDataProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.CheckInDataProto.PaymentsDataProto} PaymentsDataProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PaymentsDataProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PaymentsDataProto message.
                 * @function verify
                 * @memberof waiternow.common.CheckInDataProto.PaymentsDataProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PaymentsDataProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.stripePublishableKey != null && message.hasOwnProperty("stripePublishableKey"))
                        if (!$util.isString(message.stripePublishableKey))
                            return "stripePublishableKey: string expected";
                    if (message.currencyCode != null && message.hasOwnProperty("currencyCode"))
                        if (!$util.isString(message.currencyCode))
                            return "currencyCode: string expected";
                    if (message.salesTax != null && message.hasOwnProperty("salesTax")) {
                        var error = $root.waiternow.common.DecimalProto.verify(message.salesTax);
                        if (error)
                            return "salesTax." + error;
                    }
                    if (message.maxAttemptsToMarkOrderAsPaid != null && message.hasOwnProperty("maxAttemptsToMarkOrderAsPaid"))
                        if (!$util.isInteger(message.maxAttemptsToMarkOrderAsPaid))
                            return "maxAttemptsToMarkOrderAsPaid: integer expected";
                    if (message.timeBetweenAttemptsToMarkOrderAsPaidSeconds != null && message.hasOwnProperty("timeBetweenAttemptsToMarkOrderAsPaidSeconds"))
                        if (!$util.isInteger(message.timeBetweenAttemptsToMarkOrderAsPaidSeconds))
                            return "timeBetweenAttemptsToMarkOrderAsPaidSeconds: integer expected";
                    return null;
                };

                /**
                 * Creates a PaymentsDataProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.CheckInDataProto.PaymentsDataProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.CheckInDataProto.PaymentsDataProto} PaymentsDataProto
                 */
                PaymentsDataProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.CheckInDataProto.PaymentsDataProto)
                        return object;
                    var message = new $root.waiternow.common.CheckInDataProto.PaymentsDataProto();
                    if (object.stripePublishableKey != null)
                        message.stripePublishableKey = String(object.stripePublishableKey);
                    if (object.currencyCode != null)
                        message.currencyCode = String(object.currencyCode);
                    if (object.salesTax != null) {
                        if (typeof object.salesTax !== "object")
                            throw TypeError(".waiternow.common.CheckInDataProto.PaymentsDataProto.salesTax: object expected");
                        message.salesTax = $root.waiternow.common.DecimalProto.fromObject(object.salesTax);
                    }
                    if (object.maxAttemptsToMarkOrderAsPaid != null)
                        message.maxAttemptsToMarkOrderAsPaid = object.maxAttemptsToMarkOrderAsPaid | 0;
                    if (object.timeBetweenAttemptsToMarkOrderAsPaidSeconds != null)
                        message.timeBetweenAttemptsToMarkOrderAsPaidSeconds = object.timeBetweenAttemptsToMarkOrderAsPaidSeconds | 0;
                    return message;
                };

                /**
                 * Creates a plain object from a PaymentsDataProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.CheckInDataProto.PaymentsDataProto
                 * @static
                 * @param {waiternow.common.CheckInDataProto.PaymentsDataProto} message PaymentsDataProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PaymentsDataProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.stripePublishableKey = "";
                        object.currencyCode = "";
                        object.salesTax = null;
                        object.maxAttemptsToMarkOrderAsPaid = 0;
                        object.timeBetweenAttemptsToMarkOrderAsPaidSeconds = 0;
                    }
                    if (message.stripePublishableKey != null && message.hasOwnProperty("stripePublishableKey"))
                        object.stripePublishableKey = message.stripePublishableKey;
                    if (message.currencyCode != null && message.hasOwnProperty("currencyCode"))
                        object.currencyCode = message.currencyCode;
                    if (message.salesTax != null && message.hasOwnProperty("salesTax"))
                        object.salesTax = $root.waiternow.common.DecimalProto.toObject(message.salesTax, options);
                    if (message.maxAttemptsToMarkOrderAsPaid != null && message.hasOwnProperty("maxAttemptsToMarkOrderAsPaid"))
                        object.maxAttemptsToMarkOrderAsPaid = message.maxAttemptsToMarkOrderAsPaid;
                    if (message.timeBetweenAttemptsToMarkOrderAsPaidSeconds != null && message.hasOwnProperty("timeBetweenAttemptsToMarkOrderAsPaidSeconds"))
                        object.timeBetweenAttemptsToMarkOrderAsPaidSeconds = message.timeBetweenAttemptsToMarkOrderAsPaidSeconds;
                    return object;
                };

                /**
                 * Converts this PaymentsDataProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.CheckInDataProto.PaymentsDataProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PaymentsDataProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for PaymentsDataProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.CheckInDataProto.PaymentsDataProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                PaymentsDataProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.CheckInDataProto.PaymentsDataProto";
                };

                return PaymentsDataProto;
            })();

            CheckInDataProto.StatusProto = (function() {

                /**
                 * Properties of a StatusProto.
                 * @memberof waiternow.common.CheckInDataProto
                 * @interface IStatusProto
                 * @property {boolean|null} [isLocationOnline] StatusProto isLocationOnline
                 */

                /**
                 * Constructs a new StatusProto.
                 * @memberof waiternow.common.CheckInDataProto
                 * @classdesc Represents a StatusProto.
                 * @implements IStatusProto
                 * @constructor
                 * @param {waiternow.common.CheckInDataProto.IStatusProto=} [properties] Properties to set
                 */
                function StatusProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StatusProto isLocationOnline.
                 * @member {boolean} isLocationOnline
                 * @memberof waiternow.common.CheckInDataProto.StatusProto
                 * @instance
                 */
                StatusProto.prototype.isLocationOnline = false;

                /**
                 * Creates a new StatusProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.CheckInDataProto.StatusProto
                 * @static
                 * @param {waiternow.common.CheckInDataProto.IStatusProto=} [properties] Properties to set
                 * @returns {waiternow.common.CheckInDataProto.StatusProto} StatusProto instance
                 */
                StatusProto.create = function create(properties) {
                    return new StatusProto(properties);
                };

                /**
                 * Encodes the specified StatusProto message. Does not implicitly {@link waiternow.common.CheckInDataProto.StatusProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.CheckInDataProto.StatusProto
                 * @static
                 * @param {waiternow.common.CheckInDataProto.IStatusProto} message StatusProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StatusProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.isLocationOnline != null && Object.hasOwnProperty.call(message, "isLocationOnline"))
                        writer.uint32(/* id 1, wireType 0 =*/8).bool(message.isLocationOnline);
                    return writer;
                };

                /**
                 * Encodes the specified StatusProto message, length delimited. Does not implicitly {@link waiternow.common.CheckInDataProto.StatusProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.CheckInDataProto.StatusProto
                 * @static
                 * @param {waiternow.common.CheckInDataProto.IStatusProto} message StatusProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StatusProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a StatusProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.CheckInDataProto.StatusProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.CheckInDataProto.StatusProto} StatusProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StatusProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CheckInDataProto.StatusProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.isLocationOnline = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a StatusProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.CheckInDataProto.StatusProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.CheckInDataProto.StatusProto} StatusProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StatusProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StatusProto message.
                 * @function verify
                 * @memberof waiternow.common.CheckInDataProto.StatusProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StatusProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.isLocationOnline != null && message.hasOwnProperty("isLocationOnline"))
                        if (typeof message.isLocationOnline !== "boolean")
                            return "isLocationOnline: boolean expected";
                    return null;
                };

                /**
                 * Creates a StatusProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.CheckInDataProto.StatusProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.CheckInDataProto.StatusProto} StatusProto
                 */
                StatusProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.CheckInDataProto.StatusProto)
                        return object;
                    var message = new $root.waiternow.common.CheckInDataProto.StatusProto();
                    if (object.isLocationOnline != null)
                        message.isLocationOnline = Boolean(object.isLocationOnline);
                    return message;
                };

                /**
                 * Creates a plain object from a StatusProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.CheckInDataProto.StatusProto
                 * @static
                 * @param {waiternow.common.CheckInDataProto.StatusProto} message StatusProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StatusProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.isLocationOnline = false;
                    if (message.isLocationOnline != null && message.hasOwnProperty("isLocationOnline"))
                        object.isLocationOnline = message.isLocationOnline;
                    return object;
                };

                /**
                 * Converts this StatusProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.CheckInDataProto.StatusProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StatusProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for StatusProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.CheckInDataProto.StatusProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                StatusProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.CheckInDataProto.StatusProto";
                };

                return StatusProto;
            })();

            CheckInDataProto.EnabledFeaturesProto = (function() {

                /**
                 * Properties of an EnabledFeaturesProto.
                 * @memberof waiternow.common.CheckInDataProto
                 * @interface IEnabledFeaturesProto
                 * @property {boolean|null} [isPaymentsEnabled] EnabledFeaturesProto isPaymentsEnabled
                 * @property {boolean|null} [isOnsiteTipsEnabled] EnabledFeaturesProto isOnsiteTipsEnabled
                 * @property {boolean|null} [isImageMenuEnabled] EnabledFeaturesProto isImageMenuEnabled
                 * @property {boolean|null} [isMenuEnabled] EnabledFeaturesProto isMenuEnabled
                 * @property {boolean|null} [isPokeWaiterEnabled] EnabledFeaturesProto isPokeWaiterEnabled
                 * @property {boolean|null} [isMessageWaiterEnabled] EnabledFeaturesProto isMessageWaiterEnabled
                 * @property {boolean|null} [isSpecialInstructionsEnabled] EnabledFeaturesProto isSpecialInstructionsEnabled
                 * @property {boolean|null} [isCompletedStatusForPaidOrdersEnabled] EnabledFeaturesProto isCompletedStatusForPaidOrdersEnabled
                 * @property {boolean|null} [isEmailRequiredToOrder] EnabledFeaturesProto isEmailRequiredToOrder
                 * @property {boolean|null} [isPhoneNumberRequiredToOrder] EnabledFeaturesProto isPhoneNumberRequiredToOrder
                 * @property {boolean|null} [goToMenuPageOnCheckIn] EnabledFeaturesProto goToMenuPageOnCheckIn
                 * @property {boolean|null} [isOrderToGoEnabled] EnabledFeaturesProto isOrderToGoEnabled
                 * @property {boolean|null} [isOrderForLaterEnabled] EnabledFeaturesProto isOrderForLaterEnabled
                 * @property {boolean|null} [isDeliveryEnabled] EnabledFeaturesProto isDeliveryEnabled
                 * @property {boolean|null} [isIncludeCutleryEnabled] EnabledFeaturesProto isIncludeCutleryEnabled
                 * @property {boolean|null} [isDeliveryTipsEnabled] EnabledFeaturesProto isDeliveryTipsEnabled
                 * @property {boolean|null} [isAskForCheckEnabled] EnabledFeaturesProto isAskForCheckEnabled
                 * @property {boolean|null} [isOrderForLaterDayEnabled] EnabledFeaturesProto isOrderForLaterDayEnabled
                 * @property {boolean|null} [isOnsiteClient] EnabledFeaturesProto isOnsiteClient
                 * @property {boolean|null} [isOnlineClient] EnabledFeaturesProto isOnlineClient
                 * @property {boolean|null} [isConsumerNameRequiredToOrder] EnabledFeaturesProto isConsumerNameRequiredToOrder
                 * @property {boolean|null} [isOnlinePickupTipsEnabled] EnabledFeaturesProto isOnlinePickupTipsEnabled
                 * @property {boolean|null} [isReadOnlyMode] EnabledFeaturesProto isReadOnlyMode
                 */

                /**
                 * Constructs a new EnabledFeaturesProto.
                 * @memberof waiternow.common.CheckInDataProto
                 * @classdesc Represents an EnabledFeaturesProto.
                 * @implements IEnabledFeaturesProto
                 * @constructor
                 * @param {waiternow.common.CheckInDataProto.IEnabledFeaturesProto=} [properties] Properties to set
                 */
                function EnabledFeaturesProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * EnabledFeaturesProto isPaymentsEnabled.
                 * @member {boolean} isPaymentsEnabled
                 * @memberof waiternow.common.CheckInDataProto.EnabledFeaturesProto
                 * @instance
                 */
                EnabledFeaturesProto.prototype.isPaymentsEnabled = false;

                /**
                 * EnabledFeaturesProto isOnsiteTipsEnabled.
                 * @member {boolean} isOnsiteTipsEnabled
                 * @memberof waiternow.common.CheckInDataProto.EnabledFeaturesProto
                 * @instance
                 */
                EnabledFeaturesProto.prototype.isOnsiteTipsEnabled = false;

                /**
                 * EnabledFeaturesProto isImageMenuEnabled.
                 * @member {boolean} isImageMenuEnabled
                 * @memberof waiternow.common.CheckInDataProto.EnabledFeaturesProto
                 * @instance
                 */
                EnabledFeaturesProto.prototype.isImageMenuEnabled = false;

                /**
                 * EnabledFeaturesProto isMenuEnabled.
                 * @member {boolean} isMenuEnabled
                 * @memberof waiternow.common.CheckInDataProto.EnabledFeaturesProto
                 * @instance
                 */
                EnabledFeaturesProto.prototype.isMenuEnabled = false;

                /**
                 * EnabledFeaturesProto isPokeWaiterEnabled.
                 * @member {boolean} isPokeWaiterEnabled
                 * @memberof waiternow.common.CheckInDataProto.EnabledFeaturesProto
                 * @instance
                 */
                EnabledFeaturesProto.prototype.isPokeWaiterEnabled = false;

                /**
                 * EnabledFeaturesProto isMessageWaiterEnabled.
                 * @member {boolean} isMessageWaiterEnabled
                 * @memberof waiternow.common.CheckInDataProto.EnabledFeaturesProto
                 * @instance
                 */
                EnabledFeaturesProto.prototype.isMessageWaiterEnabled = false;

                /**
                 * EnabledFeaturesProto isSpecialInstructionsEnabled.
                 * @member {boolean} isSpecialInstructionsEnabled
                 * @memberof waiternow.common.CheckInDataProto.EnabledFeaturesProto
                 * @instance
                 */
                EnabledFeaturesProto.prototype.isSpecialInstructionsEnabled = false;

                /**
                 * EnabledFeaturesProto isCompletedStatusForPaidOrdersEnabled.
                 * @member {boolean} isCompletedStatusForPaidOrdersEnabled
                 * @memberof waiternow.common.CheckInDataProto.EnabledFeaturesProto
                 * @instance
                 */
                EnabledFeaturesProto.prototype.isCompletedStatusForPaidOrdersEnabled = false;

                /**
                 * EnabledFeaturesProto isEmailRequiredToOrder.
                 * @member {boolean} isEmailRequiredToOrder
                 * @memberof waiternow.common.CheckInDataProto.EnabledFeaturesProto
                 * @instance
                 */
                EnabledFeaturesProto.prototype.isEmailRequiredToOrder = false;

                /**
                 * EnabledFeaturesProto isPhoneNumberRequiredToOrder.
                 * @member {boolean} isPhoneNumberRequiredToOrder
                 * @memberof waiternow.common.CheckInDataProto.EnabledFeaturesProto
                 * @instance
                 */
                EnabledFeaturesProto.prototype.isPhoneNumberRequiredToOrder = false;

                /**
                 * EnabledFeaturesProto goToMenuPageOnCheckIn.
                 * @member {boolean} goToMenuPageOnCheckIn
                 * @memberof waiternow.common.CheckInDataProto.EnabledFeaturesProto
                 * @instance
                 */
                EnabledFeaturesProto.prototype.goToMenuPageOnCheckIn = false;

                /**
                 * EnabledFeaturesProto isOrderToGoEnabled.
                 * @member {boolean} isOrderToGoEnabled
                 * @memberof waiternow.common.CheckInDataProto.EnabledFeaturesProto
                 * @instance
                 */
                EnabledFeaturesProto.prototype.isOrderToGoEnabled = false;

                /**
                 * EnabledFeaturesProto isOrderForLaterEnabled.
                 * @member {boolean} isOrderForLaterEnabled
                 * @memberof waiternow.common.CheckInDataProto.EnabledFeaturesProto
                 * @instance
                 */
                EnabledFeaturesProto.prototype.isOrderForLaterEnabled = false;

                /**
                 * EnabledFeaturesProto isDeliveryEnabled.
                 * @member {boolean} isDeliveryEnabled
                 * @memberof waiternow.common.CheckInDataProto.EnabledFeaturesProto
                 * @instance
                 */
                EnabledFeaturesProto.prototype.isDeliveryEnabled = false;

                /**
                 * EnabledFeaturesProto isIncludeCutleryEnabled.
                 * @member {boolean} isIncludeCutleryEnabled
                 * @memberof waiternow.common.CheckInDataProto.EnabledFeaturesProto
                 * @instance
                 */
                EnabledFeaturesProto.prototype.isIncludeCutleryEnabled = false;

                /**
                 * EnabledFeaturesProto isDeliveryTipsEnabled.
                 * @member {boolean} isDeliveryTipsEnabled
                 * @memberof waiternow.common.CheckInDataProto.EnabledFeaturesProto
                 * @instance
                 */
                EnabledFeaturesProto.prototype.isDeliveryTipsEnabled = false;

                /**
                 * EnabledFeaturesProto isAskForCheckEnabled.
                 * @member {boolean} isAskForCheckEnabled
                 * @memberof waiternow.common.CheckInDataProto.EnabledFeaturesProto
                 * @instance
                 */
                EnabledFeaturesProto.prototype.isAskForCheckEnabled = false;

                /**
                 * EnabledFeaturesProto isOrderForLaterDayEnabled.
                 * @member {boolean} isOrderForLaterDayEnabled
                 * @memberof waiternow.common.CheckInDataProto.EnabledFeaturesProto
                 * @instance
                 */
                EnabledFeaturesProto.prototype.isOrderForLaterDayEnabled = false;

                /**
                 * EnabledFeaturesProto isOnsiteClient.
                 * @member {boolean} isOnsiteClient
                 * @memberof waiternow.common.CheckInDataProto.EnabledFeaturesProto
                 * @instance
                 */
                EnabledFeaturesProto.prototype.isOnsiteClient = false;

                /**
                 * EnabledFeaturesProto isOnlineClient.
                 * @member {boolean} isOnlineClient
                 * @memberof waiternow.common.CheckInDataProto.EnabledFeaturesProto
                 * @instance
                 */
                EnabledFeaturesProto.prototype.isOnlineClient = false;

                /**
                 * EnabledFeaturesProto isConsumerNameRequiredToOrder.
                 * @member {boolean} isConsumerNameRequiredToOrder
                 * @memberof waiternow.common.CheckInDataProto.EnabledFeaturesProto
                 * @instance
                 */
                EnabledFeaturesProto.prototype.isConsumerNameRequiredToOrder = false;

                /**
                 * EnabledFeaturesProto isOnlinePickupTipsEnabled.
                 * @member {boolean} isOnlinePickupTipsEnabled
                 * @memberof waiternow.common.CheckInDataProto.EnabledFeaturesProto
                 * @instance
                 */
                EnabledFeaturesProto.prototype.isOnlinePickupTipsEnabled = false;

                /**
                 * EnabledFeaturesProto isReadOnlyMode.
                 * @member {boolean} isReadOnlyMode
                 * @memberof waiternow.common.CheckInDataProto.EnabledFeaturesProto
                 * @instance
                 */
                EnabledFeaturesProto.prototype.isReadOnlyMode = false;

                /**
                 * Creates a new EnabledFeaturesProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.CheckInDataProto.EnabledFeaturesProto
                 * @static
                 * @param {waiternow.common.CheckInDataProto.IEnabledFeaturesProto=} [properties] Properties to set
                 * @returns {waiternow.common.CheckInDataProto.EnabledFeaturesProto} EnabledFeaturesProto instance
                 */
                EnabledFeaturesProto.create = function create(properties) {
                    return new EnabledFeaturesProto(properties);
                };

                /**
                 * Encodes the specified EnabledFeaturesProto message. Does not implicitly {@link waiternow.common.CheckInDataProto.EnabledFeaturesProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.CheckInDataProto.EnabledFeaturesProto
                 * @static
                 * @param {waiternow.common.CheckInDataProto.IEnabledFeaturesProto} message EnabledFeaturesProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EnabledFeaturesProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.isPaymentsEnabled != null && Object.hasOwnProperty.call(message, "isPaymentsEnabled"))
                        writer.uint32(/* id 1, wireType 0 =*/8).bool(message.isPaymentsEnabled);
                    if (message.isOnsiteTipsEnabled != null && Object.hasOwnProperty.call(message, "isOnsiteTipsEnabled"))
                        writer.uint32(/* id 2, wireType 0 =*/16).bool(message.isOnsiteTipsEnabled);
                    if (message.isImageMenuEnabled != null && Object.hasOwnProperty.call(message, "isImageMenuEnabled"))
                        writer.uint32(/* id 3, wireType 0 =*/24).bool(message.isImageMenuEnabled);
                    if (message.isMenuEnabled != null && Object.hasOwnProperty.call(message, "isMenuEnabled"))
                        writer.uint32(/* id 4, wireType 0 =*/32).bool(message.isMenuEnabled);
                    if (message.isPokeWaiterEnabled != null && Object.hasOwnProperty.call(message, "isPokeWaiterEnabled"))
                        writer.uint32(/* id 5, wireType 0 =*/40).bool(message.isPokeWaiterEnabled);
                    if (message.isMessageWaiterEnabled != null && Object.hasOwnProperty.call(message, "isMessageWaiterEnabled"))
                        writer.uint32(/* id 6, wireType 0 =*/48).bool(message.isMessageWaiterEnabled);
                    if (message.isSpecialInstructionsEnabled != null && Object.hasOwnProperty.call(message, "isSpecialInstructionsEnabled"))
                        writer.uint32(/* id 7, wireType 0 =*/56).bool(message.isSpecialInstructionsEnabled);
                    if (message.isCompletedStatusForPaidOrdersEnabled != null && Object.hasOwnProperty.call(message, "isCompletedStatusForPaidOrdersEnabled"))
                        writer.uint32(/* id 8, wireType 0 =*/64).bool(message.isCompletedStatusForPaidOrdersEnabled);
                    if (message.isEmailRequiredToOrder != null && Object.hasOwnProperty.call(message, "isEmailRequiredToOrder"))
                        writer.uint32(/* id 9, wireType 0 =*/72).bool(message.isEmailRequiredToOrder);
                    if (message.isPhoneNumberRequiredToOrder != null && Object.hasOwnProperty.call(message, "isPhoneNumberRequiredToOrder"))
                        writer.uint32(/* id 10, wireType 0 =*/80).bool(message.isPhoneNumberRequiredToOrder);
                    if (message.goToMenuPageOnCheckIn != null && Object.hasOwnProperty.call(message, "goToMenuPageOnCheckIn"))
                        writer.uint32(/* id 11, wireType 0 =*/88).bool(message.goToMenuPageOnCheckIn);
                    if (message.isOrderToGoEnabled != null && Object.hasOwnProperty.call(message, "isOrderToGoEnabled"))
                        writer.uint32(/* id 12, wireType 0 =*/96).bool(message.isOrderToGoEnabled);
                    if (message.isOrderForLaterEnabled != null && Object.hasOwnProperty.call(message, "isOrderForLaterEnabled"))
                        writer.uint32(/* id 13, wireType 0 =*/104).bool(message.isOrderForLaterEnabled);
                    if (message.isDeliveryEnabled != null && Object.hasOwnProperty.call(message, "isDeliveryEnabled"))
                        writer.uint32(/* id 14, wireType 0 =*/112).bool(message.isDeliveryEnabled);
                    if (message.isIncludeCutleryEnabled != null && Object.hasOwnProperty.call(message, "isIncludeCutleryEnabled"))
                        writer.uint32(/* id 15, wireType 0 =*/120).bool(message.isIncludeCutleryEnabled);
                    if (message.isDeliveryTipsEnabled != null && Object.hasOwnProperty.call(message, "isDeliveryTipsEnabled"))
                        writer.uint32(/* id 16, wireType 0 =*/128).bool(message.isDeliveryTipsEnabled);
                    if (message.isAskForCheckEnabled != null && Object.hasOwnProperty.call(message, "isAskForCheckEnabled"))
                        writer.uint32(/* id 17, wireType 0 =*/136).bool(message.isAskForCheckEnabled);
                    if (message.isOrderForLaterDayEnabled != null && Object.hasOwnProperty.call(message, "isOrderForLaterDayEnabled"))
                        writer.uint32(/* id 18, wireType 0 =*/144).bool(message.isOrderForLaterDayEnabled);
                    if (message.isOnsiteClient != null && Object.hasOwnProperty.call(message, "isOnsiteClient"))
                        writer.uint32(/* id 19, wireType 0 =*/152).bool(message.isOnsiteClient);
                    if (message.isOnlineClient != null && Object.hasOwnProperty.call(message, "isOnlineClient"))
                        writer.uint32(/* id 20, wireType 0 =*/160).bool(message.isOnlineClient);
                    if (message.isConsumerNameRequiredToOrder != null && Object.hasOwnProperty.call(message, "isConsumerNameRequiredToOrder"))
                        writer.uint32(/* id 21, wireType 0 =*/168).bool(message.isConsumerNameRequiredToOrder);
                    if (message.isOnlinePickupTipsEnabled != null && Object.hasOwnProperty.call(message, "isOnlinePickupTipsEnabled"))
                        writer.uint32(/* id 22, wireType 0 =*/176).bool(message.isOnlinePickupTipsEnabled);
                    if (message.isReadOnlyMode != null && Object.hasOwnProperty.call(message, "isReadOnlyMode"))
                        writer.uint32(/* id 23, wireType 0 =*/184).bool(message.isReadOnlyMode);
                    return writer;
                };

                /**
                 * Encodes the specified EnabledFeaturesProto message, length delimited. Does not implicitly {@link waiternow.common.CheckInDataProto.EnabledFeaturesProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.CheckInDataProto.EnabledFeaturesProto
                 * @static
                 * @param {waiternow.common.CheckInDataProto.IEnabledFeaturesProto} message EnabledFeaturesProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EnabledFeaturesProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an EnabledFeaturesProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.CheckInDataProto.EnabledFeaturesProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.CheckInDataProto.EnabledFeaturesProto} EnabledFeaturesProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EnabledFeaturesProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CheckInDataProto.EnabledFeaturesProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.isPaymentsEnabled = reader.bool();
                                break;
                            }
                        case 2: {
                                message.isOnsiteTipsEnabled = reader.bool();
                                break;
                            }
                        case 3: {
                                message.isImageMenuEnabled = reader.bool();
                                break;
                            }
                        case 4: {
                                message.isMenuEnabled = reader.bool();
                                break;
                            }
                        case 5: {
                                message.isPokeWaiterEnabled = reader.bool();
                                break;
                            }
                        case 6: {
                                message.isMessageWaiterEnabled = reader.bool();
                                break;
                            }
                        case 7: {
                                message.isSpecialInstructionsEnabled = reader.bool();
                                break;
                            }
                        case 8: {
                                message.isCompletedStatusForPaidOrdersEnabled = reader.bool();
                                break;
                            }
                        case 9: {
                                message.isEmailRequiredToOrder = reader.bool();
                                break;
                            }
                        case 10: {
                                message.isPhoneNumberRequiredToOrder = reader.bool();
                                break;
                            }
                        case 11: {
                                message.goToMenuPageOnCheckIn = reader.bool();
                                break;
                            }
                        case 12: {
                                message.isOrderToGoEnabled = reader.bool();
                                break;
                            }
                        case 13: {
                                message.isOrderForLaterEnabled = reader.bool();
                                break;
                            }
                        case 14: {
                                message.isDeliveryEnabled = reader.bool();
                                break;
                            }
                        case 15: {
                                message.isIncludeCutleryEnabled = reader.bool();
                                break;
                            }
                        case 16: {
                                message.isDeliveryTipsEnabled = reader.bool();
                                break;
                            }
                        case 17: {
                                message.isAskForCheckEnabled = reader.bool();
                                break;
                            }
                        case 18: {
                                message.isOrderForLaterDayEnabled = reader.bool();
                                break;
                            }
                        case 19: {
                                message.isOnsiteClient = reader.bool();
                                break;
                            }
                        case 20: {
                                message.isOnlineClient = reader.bool();
                                break;
                            }
                        case 21: {
                                message.isConsumerNameRequiredToOrder = reader.bool();
                                break;
                            }
                        case 22: {
                                message.isOnlinePickupTipsEnabled = reader.bool();
                                break;
                            }
                        case 23: {
                                message.isReadOnlyMode = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an EnabledFeaturesProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.CheckInDataProto.EnabledFeaturesProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.CheckInDataProto.EnabledFeaturesProto} EnabledFeaturesProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EnabledFeaturesProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an EnabledFeaturesProto message.
                 * @function verify
                 * @memberof waiternow.common.CheckInDataProto.EnabledFeaturesProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                EnabledFeaturesProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.isPaymentsEnabled != null && message.hasOwnProperty("isPaymentsEnabled"))
                        if (typeof message.isPaymentsEnabled !== "boolean")
                            return "isPaymentsEnabled: boolean expected";
                    if (message.isOnsiteTipsEnabled != null && message.hasOwnProperty("isOnsiteTipsEnabled"))
                        if (typeof message.isOnsiteTipsEnabled !== "boolean")
                            return "isOnsiteTipsEnabled: boolean expected";
                    if (message.isImageMenuEnabled != null && message.hasOwnProperty("isImageMenuEnabled"))
                        if (typeof message.isImageMenuEnabled !== "boolean")
                            return "isImageMenuEnabled: boolean expected";
                    if (message.isMenuEnabled != null && message.hasOwnProperty("isMenuEnabled"))
                        if (typeof message.isMenuEnabled !== "boolean")
                            return "isMenuEnabled: boolean expected";
                    if (message.isPokeWaiterEnabled != null && message.hasOwnProperty("isPokeWaiterEnabled"))
                        if (typeof message.isPokeWaiterEnabled !== "boolean")
                            return "isPokeWaiterEnabled: boolean expected";
                    if (message.isMessageWaiterEnabled != null && message.hasOwnProperty("isMessageWaiterEnabled"))
                        if (typeof message.isMessageWaiterEnabled !== "boolean")
                            return "isMessageWaiterEnabled: boolean expected";
                    if (message.isSpecialInstructionsEnabled != null && message.hasOwnProperty("isSpecialInstructionsEnabled"))
                        if (typeof message.isSpecialInstructionsEnabled !== "boolean")
                            return "isSpecialInstructionsEnabled: boolean expected";
                    if (message.isCompletedStatusForPaidOrdersEnabled != null && message.hasOwnProperty("isCompletedStatusForPaidOrdersEnabled"))
                        if (typeof message.isCompletedStatusForPaidOrdersEnabled !== "boolean")
                            return "isCompletedStatusForPaidOrdersEnabled: boolean expected";
                    if (message.isEmailRequiredToOrder != null && message.hasOwnProperty("isEmailRequiredToOrder"))
                        if (typeof message.isEmailRequiredToOrder !== "boolean")
                            return "isEmailRequiredToOrder: boolean expected";
                    if (message.isPhoneNumberRequiredToOrder != null && message.hasOwnProperty("isPhoneNumberRequiredToOrder"))
                        if (typeof message.isPhoneNumberRequiredToOrder !== "boolean")
                            return "isPhoneNumberRequiredToOrder: boolean expected";
                    if (message.goToMenuPageOnCheckIn != null && message.hasOwnProperty("goToMenuPageOnCheckIn"))
                        if (typeof message.goToMenuPageOnCheckIn !== "boolean")
                            return "goToMenuPageOnCheckIn: boolean expected";
                    if (message.isOrderToGoEnabled != null && message.hasOwnProperty("isOrderToGoEnabled"))
                        if (typeof message.isOrderToGoEnabled !== "boolean")
                            return "isOrderToGoEnabled: boolean expected";
                    if (message.isOrderForLaterEnabled != null && message.hasOwnProperty("isOrderForLaterEnabled"))
                        if (typeof message.isOrderForLaterEnabled !== "boolean")
                            return "isOrderForLaterEnabled: boolean expected";
                    if (message.isDeliveryEnabled != null && message.hasOwnProperty("isDeliveryEnabled"))
                        if (typeof message.isDeliveryEnabled !== "boolean")
                            return "isDeliveryEnabled: boolean expected";
                    if (message.isIncludeCutleryEnabled != null && message.hasOwnProperty("isIncludeCutleryEnabled"))
                        if (typeof message.isIncludeCutleryEnabled !== "boolean")
                            return "isIncludeCutleryEnabled: boolean expected";
                    if (message.isDeliveryTipsEnabled != null && message.hasOwnProperty("isDeliveryTipsEnabled"))
                        if (typeof message.isDeliveryTipsEnabled !== "boolean")
                            return "isDeliveryTipsEnabled: boolean expected";
                    if (message.isAskForCheckEnabled != null && message.hasOwnProperty("isAskForCheckEnabled"))
                        if (typeof message.isAskForCheckEnabled !== "boolean")
                            return "isAskForCheckEnabled: boolean expected";
                    if (message.isOrderForLaterDayEnabled != null && message.hasOwnProperty("isOrderForLaterDayEnabled"))
                        if (typeof message.isOrderForLaterDayEnabled !== "boolean")
                            return "isOrderForLaterDayEnabled: boolean expected";
                    if (message.isOnsiteClient != null && message.hasOwnProperty("isOnsiteClient"))
                        if (typeof message.isOnsiteClient !== "boolean")
                            return "isOnsiteClient: boolean expected";
                    if (message.isOnlineClient != null && message.hasOwnProperty("isOnlineClient"))
                        if (typeof message.isOnlineClient !== "boolean")
                            return "isOnlineClient: boolean expected";
                    if (message.isConsumerNameRequiredToOrder != null && message.hasOwnProperty("isConsumerNameRequiredToOrder"))
                        if (typeof message.isConsumerNameRequiredToOrder !== "boolean")
                            return "isConsumerNameRequiredToOrder: boolean expected";
                    if (message.isOnlinePickupTipsEnabled != null && message.hasOwnProperty("isOnlinePickupTipsEnabled"))
                        if (typeof message.isOnlinePickupTipsEnabled !== "boolean")
                            return "isOnlinePickupTipsEnabled: boolean expected";
                    if (message.isReadOnlyMode != null && message.hasOwnProperty("isReadOnlyMode"))
                        if (typeof message.isReadOnlyMode !== "boolean")
                            return "isReadOnlyMode: boolean expected";
                    return null;
                };

                /**
                 * Creates an EnabledFeaturesProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.CheckInDataProto.EnabledFeaturesProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.CheckInDataProto.EnabledFeaturesProto} EnabledFeaturesProto
                 */
                EnabledFeaturesProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.CheckInDataProto.EnabledFeaturesProto)
                        return object;
                    var message = new $root.waiternow.common.CheckInDataProto.EnabledFeaturesProto();
                    if (object.isPaymentsEnabled != null)
                        message.isPaymentsEnabled = Boolean(object.isPaymentsEnabled);
                    if (object.isOnsiteTipsEnabled != null)
                        message.isOnsiteTipsEnabled = Boolean(object.isOnsiteTipsEnabled);
                    if (object.isImageMenuEnabled != null)
                        message.isImageMenuEnabled = Boolean(object.isImageMenuEnabled);
                    if (object.isMenuEnabled != null)
                        message.isMenuEnabled = Boolean(object.isMenuEnabled);
                    if (object.isPokeWaiterEnabled != null)
                        message.isPokeWaiterEnabled = Boolean(object.isPokeWaiterEnabled);
                    if (object.isMessageWaiterEnabled != null)
                        message.isMessageWaiterEnabled = Boolean(object.isMessageWaiterEnabled);
                    if (object.isSpecialInstructionsEnabled != null)
                        message.isSpecialInstructionsEnabled = Boolean(object.isSpecialInstructionsEnabled);
                    if (object.isCompletedStatusForPaidOrdersEnabled != null)
                        message.isCompletedStatusForPaidOrdersEnabled = Boolean(object.isCompletedStatusForPaidOrdersEnabled);
                    if (object.isEmailRequiredToOrder != null)
                        message.isEmailRequiredToOrder = Boolean(object.isEmailRequiredToOrder);
                    if (object.isPhoneNumberRequiredToOrder != null)
                        message.isPhoneNumberRequiredToOrder = Boolean(object.isPhoneNumberRequiredToOrder);
                    if (object.goToMenuPageOnCheckIn != null)
                        message.goToMenuPageOnCheckIn = Boolean(object.goToMenuPageOnCheckIn);
                    if (object.isOrderToGoEnabled != null)
                        message.isOrderToGoEnabled = Boolean(object.isOrderToGoEnabled);
                    if (object.isOrderForLaterEnabled != null)
                        message.isOrderForLaterEnabled = Boolean(object.isOrderForLaterEnabled);
                    if (object.isDeliveryEnabled != null)
                        message.isDeliveryEnabled = Boolean(object.isDeliveryEnabled);
                    if (object.isIncludeCutleryEnabled != null)
                        message.isIncludeCutleryEnabled = Boolean(object.isIncludeCutleryEnabled);
                    if (object.isDeliveryTipsEnabled != null)
                        message.isDeliveryTipsEnabled = Boolean(object.isDeliveryTipsEnabled);
                    if (object.isAskForCheckEnabled != null)
                        message.isAskForCheckEnabled = Boolean(object.isAskForCheckEnabled);
                    if (object.isOrderForLaterDayEnabled != null)
                        message.isOrderForLaterDayEnabled = Boolean(object.isOrderForLaterDayEnabled);
                    if (object.isOnsiteClient != null)
                        message.isOnsiteClient = Boolean(object.isOnsiteClient);
                    if (object.isOnlineClient != null)
                        message.isOnlineClient = Boolean(object.isOnlineClient);
                    if (object.isConsumerNameRequiredToOrder != null)
                        message.isConsumerNameRequiredToOrder = Boolean(object.isConsumerNameRequiredToOrder);
                    if (object.isOnlinePickupTipsEnabled != null)
                        message.isOnlinePickupTipsEnabled = Boolean(object.isOnlinePickupTipsEnabled);
                    if (object.isReadOnlyMode != null)
                        message.isReadOnlyMode = Boolean(object.isReadOnlyMode);
                    return message;
                };

                /**
                 * Creates a plain object from an EnabledFeaturesProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.CheckInDataProto.EnabledFeaturesProto
                 * @static
                 * @param {waiternow.common.CheckInDataProto.EnabledFeaturesProto} message EnabledFeaturesProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                EnabledFeaturesProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.isPaymentsEnabled = false;
                        object.isOnsiteTipsEnabled = false;
                        object.isImageMenuEnabled = false;
                        object.isMenuEnabled = false;
                        object.isPokeWaiterEnabled = false;
                        object.isMessageWaiterEnabled = false;
                        object.isSpecialInstructionsEnabled = false;
                        object.isCompletedStatusForPaidOrdersEnabled = false;
                        object.isEmailRequiredToOrder = false;
                        object.isPhoneNumberRequiredToOrder = false;
                        object.goToMenuPageOnCheckIn = false;
                        object.isOrderToGoEnabled = false;
                        object.isOrderForLaterEnabled = false;
                        object.isDeliveryEnabled = false;
                        object.isIncludeCutleryEnabled = false;
                        object.isDeliveryTipsEnabled = false;
                        object.isAskForCheckEnabled = false;
                        object.isOrderForLaterDayEnabled = false;
                        object.isOnsiteClient = false;
                        object.isOnlineClient = false;
                        object.isConsumerNameRequiredToOrder = false;
                        object.isOnlinePickupTipsEnabled = false;
                        object.isReadOnlyMode = false;
                    }
                    if (message.isPaymentsEnabled != null && message.hasOwnProperty("isPaymentsEnabled"))
                        object.isPaymentsEnabled = message.isPaymentsEnabled;
                    if (message.isOnsiteTipsEnabled != null && message.hasOwnProperty("isOnsiteTipsEnabled"))
                        object.isOnsiteTipsEnabled = message.isOnsiteTipsEnabled;
                    if (message.isImageMenuEnabled != null && message.hasOwnProperty("isImageMenuEnabled"))
                        object.isImageMenuEnabled = message.isImageMenuEnabled;
                    if (message.isMenuEnabled != null && message.hasOwnProperty("isMenuEnabled"))
                        object.isMenuEnabled = message.isMenuEnabled;
                    if (message.isPokeWaiterEnabled != null && message.hasOwnProperty("isPokeWaiterEnabled"))
                        object.isPokeWaiterEnabled = message.isPokeWaiterEnabled;
                    if (message.isMessageWaiterEnabled != null && message.hasOwnProperty("isMessageWaiterEnabled"))
                        object.isMessageWaiterEnabled = message.isMessageWaiterEnabled;
                    if (message.isSpecialInstructionsEnabled != null && message.hasOwnProperty("isSpecialInstructionsEnabled"))
                        object.isSpecialInstructionsEnabled = message.isSpecialInstructionsEnabled;
                    if (message.isCompletedStatusForPaidOrdersEnabled != null && message.hasOwnProperty("isCompletedStatusForPaidOrdersEnabled"))
                        object.isCompletedStatusForPaidOrdersEnabled = message.isCompletedStatusForPaidOrdersEnabled;
                    if (message.isEmailRequiredToOrder != null && message.hasOwnProperty("isEmailRequiredToOrder"))
                        object.isEmailRequiredToOrder = message.isEmailRequiredToOrder;
                    if (message.isPhoneNumberRequiredToOrder != null && message.hasOwnProperty("isPhoneNumberRequiredToOrder"))
                        object.isPhoneNumberRequiredToOrder = message.isPhoneNumberRequiredToOrder;
                    if (message.goToMenuPageOnCheckIn != null && message.hasOwnProperty("goToMenuPageOnCheckIn"))
                        object.goToMenuPageOnCheckIn = message.goToMenuPageOnCheckIn;
                    if (message.isOrderToGoEnabled != null && message.hasOwnProperty("isOrderToGoEnabled"))
                        object.isOrderToGoEnabled = message.isOrderToGoEnabled;
                    if (message.isOrderForLaterEnabled != null && message.hasOwnProperty("isOrderForLaterEnabled"))
                        object.isOrderForLaterEnabled = message.isOrderForLaterEnabled;
                    if (message.isDeliveryEnabled != null && message.hasOwnProperty("isDeliveryEnabled"))
                        object.isDeliveryEnabled = message.isDeliveryEnabled;
                    if (message.isIncludeCutleryEnabled != null && message.hasOwnProperty("isIncludeCutleryEnabled"))
                        object.isIncludeCutleryEnabled = message.isIncludeCutleryEnabled;
                    if (message.isDeliveryTipsEnabled != null && message.hasOwnProperty("isDeliveryTipsEnabled"))
                        object.isDeliveryTipsEnabled = message.isDeliveryTipsEnabled;
                    if (message.isAskForCheckEnabled != null && message.hasOwnProperty("isAskForCheckEnabled"))
                        object.isAskForCheckEnabled = message.isAskForCheckEnabled;
                    if (message.isOrderForLaterDayEnabled != null && message.hasOwnProperty("isOrderForLaterDayEnabled"))
                        object.isOrderForLaterDayEnabled = message.isOrderForLaterDayEnabled;
                    if (message.isOnsiteClient != null && message.hasOwnProperty("isOnsiteClient"))
                        object.isOnsiteClient = message.isOnsiteClient;
                    if (message.isOnlineClient != null && message.hasOwnProperty("isOnlineClient"))
                        object.isOnlineClient = message.isOnlineClient;
                    if (message.isConsumerNameRequiredToOrder != null && message.hasOwnProperty("isConsumerNameRequiredToOrder"))
                        object.isConsumerNameRequiredToOrder = message.isConsumerNameRequiredToOrder;
                    if (message.isOnlinePickupTipsEnabled != null && message.hasOwnProperty("isOnlinePickupTipsEnabled"))
                        object.isOnlinePickupTipsEnabled = message.isOnlinePickupTipsEnabled;
                    if (message.isReadOnlyMode != null && message.hasOwnProperty("isReadOnlyMode"))
                        object.isReadOnlyMode = message.isReadOnlyMode;
                    return object;
                };

                /**
                 * Converts this EnabledFeaturesProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.CheckInDataProto.EnabledFeaturesProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                EnabledFeaturesProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for EnabledFeaturesProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.CheckInDataProto.EnabledFeaturesProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                EnabledFeaturesProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.CheckInDataProto.EnabledFeaturesProto";
                };

                return EnabledFeaturesProto;
            })();

            CheckInDataProto.ConfigurationProto = (function() {

                /**
                 * Properties of a ConfigurationProto.
                 * @memberof waiternow.common.CheckInDataProto
                 * @interface IConfigurationProto
                 * @property {google.protobuf.IDuration|null} [sessionExpiration] ConfigurationProto sessionExpiration
                 * @property {google.protobuf.IDuration|null} [orderStatusPollRate] ConfigurationProto orderStatusPollRate
                 * @property {google.protobuf.IDuration|null} [locationOnlineStatusPollRate] ConfigurationProto locationOnlineStatusPollRate
                 * @property {number|null} [orderForLaterMaxDaysInTheFuture] ConfigurationProto orderForLaterMaxDaysInTheFuture
                 * @property {string|null} [googleMapsServicesApiKey] ConfigurationProto googleMapsServicesApiKey
                 */

                /**
                 * Constructs a new ConfigurationProto.
                 * @memberof waiternow.common.CheckInDataProto
                 * @classdesc Represents a ConfigurationProto.
                 * @implements IConfigurationProto
                 * @constructor
                 * @param {waiternow.common.CheckInDataProto.IConfigurationProto=} [properties] Properties to set
                 */
                function ConfigurationProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ConfigurationProto sessionExpiration.
                 * @member {google.protobuf.IDuration|null|undefined} sessionExpiration
                 * @memberof waiternow.common.CheckInDataProto.ConfigurationProto
                 * @instance
                 */
                ConfigurationProto.prototype.sessionExpiration = null;

                /**
                 * ConfigurationProto orderStatusPollRate.
                 * @member {google.protobuf.IDuration|null|undefined} orderStatusPollRate
                 * @memberof waiternow.common.CheckInDataProto.ConfigurationProto
                 * @instance
                 */
                ConfigurationProto.prototype.orderStatusPollRate = null;

                /**
                 * ConfigurationProto locationOnlineStatusPollRate.
                 * @member {google.protobuf.IDuration|null|undefined} locationOnlineStatusPollRate
                 * @memberof waiternow.common.CheckInDataProto.ConfigurationProto
                 * @instance
                 */
                ConfigurationProto.prototype.locationOnlineStatusPollRate = null;

                /**
                 * ConfigurationProto orderForLaterMaxDaysInTheFuture.
                 * @member {number} orderForLaterMaxDaysInTheFuture
                 * @memberof waiternow.common.CheckInDataProto.ConfigurationProto
                 * @instance
                 */
                ConfigurationProto.prototype.orderForLaterMaxDaysInTheFuture = 0;

                /**
                 * ConfigurationProto googleMapsServicesApiKey.
                 * @member {string} googleMapsServicesApiKey
                 * @memberof waiternow.common.CheckInDataProto.ConfigurationProto
                 * @instance
                 */
                ConfigurationProto.prototype.googleMapsServicesApiKey = "";

                /**
                 * Creates a new ConfigurationProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.CheckInDataProto.ConfigurationProto
                 * @static
                 * @param {waiternow.common.CheckInDataProto.IConfigurationProto=} [properties] Properties to set
                 * @returns {waiternow.common.CheckInDataProto.ConfigurationProto} ConfigurationProto instance
                 */
                ConfigurationProto.create = function create(properties) {
                    return new ConfigurationProto(properties);
                };

                /**
                 * Encodes the specified ConfigurationProto message. Does not implicitly {@link waiternow.common.CheckInDataProto.ConfigurationProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.CheckInDataProto.ConfigurationProto
                 * @static
                 * @param {waiternow.common.CheckInDataProto.IConfigurationProto} message ConfigurationProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ConfigurationProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.sessionExpiration != null && Object.hasOwnProperty.call(message, "sessionExpiration"))
                        $root.google.protobuf.Duration.encode(message.sessionExpiration, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.orderStatusPollRate != null && Object.hasOwnProperty.call(message, "orderStatusPollRate"))
                        $root.google.protobuf.Duration.encode(message.orderStatusPollRate, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.locationOnlineStatusPollRate != null && Object.hasOwnProperty.call(message, "locationOnlineStatusPollRate"))
                        $root.google.protobuf.Duration.encode(message.locationOnlineStatusPollRate, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.orderForLaterMaxDaysInTheFuture != null && Object.hasOwnProperty.call(message, "orderForLaterMaxDaysInTheFuture"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.orderForLaterMaxDaysInTheFuture);
                    if (message.googleMapsServicesApiKey != null && Object.hasOwnProperty.call(message, "googleMapsServicesApiKey"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.googleMapsServicesApiKey);
                    return writer;
                };

                /**
                 * Encodes the specified ConfigurationProto message, length delimited. Does not implicitly {@link waiternow.common.CheckInDataProto.ConfigurationProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.CheckInDataProto.ConfigurationProto
                 * @static
                 * @param {waiternow.common.CheckInDataProto.IConfigurationProto} message ConfigurationProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ConfigurationProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ConfigurationProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.CheckInDataProto.ConfigurationProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.CheckInDataProto.ConfigurationProto} ConfigurationProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ConfigurationProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CheckInDataProto.ConfigurationProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.sessionExpiration = $root.google.protobuf.Duration.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.orderStatusPollRate = $root.google.protobuf.Duration.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.locationOnlineStatusPollRate = $root.google.protobuf.Duration.decode(reader, reader.uint32());
                                break;
                            }
                        case 4: {
                                message.orderForLaterMaxDaysInTheFuture = reader.int32();
                                break;
                            }
                        case 5: {
                                message.googleMapsServicesApiKey = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ConfigurationProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.CheckInDataProto.ConfigurationProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.CheckInDataProto.ConfigurationProto} ConfigurationProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ConfigurationProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ConfigurationProto message.
                 * @function verify
                 * @memberof waiternow.common.CheckInDataProto.ConfigurationProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ConfigurationProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.sessionExpiration != null && message.hasOwnProperty("sessionExpiration")) {
                        var error = $root.google.protobuf.Duration.verify(message.sessionExpiration);
                        if (error)
                            return "sessionExpiration." + error;
                    }
                    if (message.orderStatusPollRate != null && message.hasOwnProperty("orderStatusPollRate")) {
                        var error = $root.google.protobuf.Duration.verify(message.orderStatusPollRate);
                        if (error)
                            return "orderStatusPollRate." + error;
                    }
                    if (message.locationOnlineStatusPollRate != null && message.hasOwnProperty("locationOnlineStatusPollRate")) {
                        var error = $root.google.protobuf.Duration.verify(message.locationOnlineStatusPollRate);
                        if (error)
                            return "locationOnlineStatusPollRate." + error;
                    }
                    if (message.orderForLaterMaxDaysInTheFuture != null && message.hasOwnProperty("orderForLaterMaxDaysInTheFuture"))
                        if (!$util.isInteger(message.orderForLaterMaxDaysInTheFuture))
                            return "orderForLaterMaxDaysInTheFuture: integer expected";
                    if (message.googleMapsServicesApiKey != null && message.hasOwnProperty("googleMapsServicesApiKey"))
                        if (!$util.isString(message.googleMapsServicesApiKey))
                            return "googleMapsServicesApiKey: string expected";
                    return null;
                };

                /**
                 * Creates a ConfigurationProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.CheckInDataProto.ConfigurationProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.CheckInDataProto.ConfigurationProto} ConfigurationProto
                 */
                ConfigurationProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.CheckInDataProto.ConfigurationProto)
                        return object;
                    var message = new $root.waiternow.common.CheckInDataProto.ConfigurationProto();
                    if (object.sessionExpiration != null) {
                        if (typeof object.sessionExpiration !== "object")
                            throw TypeError(".waiternow.common.CheckInDataProto.ConfigurationProto.sessionExpiration: object expected");
                        message.sessionExpiration = $root.google.protobuf.Duration.fromObject(object.sessionExpiration);
                    }
                    if (object.orderStatusPollRate != null) {
                        if (typeof object.orderStatusPollRate !== "object")
                            throw TypeError(".waiternow.common.CheckInDataProto.ConfigurationProto.orderStatusPollRate: object expected");
                        message.orderStatusPollRate = $root.google.protobuf.Duration.fromObject(object.orderStatusPollRate);
                    }
                    if (object.locationOnlineStatusPollRate != null) {
                        if (typeof object.locationOnlineStatusPollRate !== "object")
                            throw TypeError(".waiternow.common.CheckInDataProto.ConfigurationProto.locationOnlineStatusPollRate: object expected");
                        message.locationOnlineStatusPollRate = $root.google.protobuf.Duration.fromObject(object.locationOnlineStatusPollRate);
                    }
                    if (object.orderForLaterMaxDaysInTheFuture != null)
                        message.orderForLaterMaxDaysInTheFuture = object.orderForLaterMaxDaysInTheFuture | 0;
                    if (object.googleMapsServicesApiKey != null)
                        message.googleMapsServicesApiKey = String(object.googleMapsServicesApiKey);
                    return message;
                };

                /**
                 * Creates a plain object from a ConfigurationProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.CheckInDataProto.ConfigurationProto
                 * @static
                 * @param {waiternow.common.CheckInDataProto.ConfigurationProto} message ConfigurationProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ConfigurationProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.sessionExpiration = null;
                        object.orderStatusPollRate = null;
                        object.locationOnlineStatusPollRate = null;
                        object.orderForLaterMaxDaysInTheFuture = 0;
                        object.googleMapsServicesApiKey = "";
                    }
                    if (message.sessionExpiration != null && message.hasOwnProperty("sessionExpiration"))
                        object.sessionExpiration = $root.google.protobuf.Duration.toObject(message.sessionExpiration, options);
                    if (message.orderStatusPollRate != null && message.hasOwnProperty("orderStatusPollRate"))
                        object.orderStatusPollRate = $root.google.protobuf.Duration.toObject(message.orderStatusPollRate, options);
                    if (message.locationOnlineStatusPollRate != null && message.hasOwnProperty("locationOnlineStatusPollRate"))
                        object.locationOnlineStatusPollRate = $root.google.protobuf.Duration.toObject(message.locationOnlineStatusPollRate, options);
                    if (message.orderForLaterMaxDaysInTheFuture != null && message.hasOwnProperty("orderForLaterMaxDaysInTheFuture"))
                        object.orderForLaterMaxDaysInTheFuture = message.orderForLaterMaxDaysInTheFuture;
                    if (message.googleMapsServicesApiKey != null && message.hasOwnProperty("googleMapsServicesApiKey"))
                        object.googleMapsServicesApiKey = message.googleMapsServicesApiKey;
                    return object;
                };

                /**
                 * Converts this ConfigurationProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.CheckInDataProto.ConfigurationProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ConfigurationProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ConfigurationProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.CheckInDataProto.ConfigurationProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ConfigurationProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.CheckInDataProto.ConfigurationProto";
                };

                return ConfigurationProto;
            })();

            CheckInDataProto.ViewSettingsProto = (function() {

                /**
                 * Properties of a ViewSettingsProto.
                 * @memberof waiternow.common.CheckInDataProto
                 * @interface IViewSettingsProto
                 * @property {waiternow.common.Theme|null} [theme] ViewSettingsProto theme
                 * @property {waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.IColorPaletteProto|null} [colorPalette] ViewSettingsProto colorPalette
                 */

                /**
                 * Constructs a new ViewSettingsProto.
                 * @memberof waiternow.common.CheckInDataProto
                 * @classdesc Represents a ViewSettingsProto.
                 * @implements IViewSettingsProto
                 * @constructor
                 * @param {waiternow.common.CheckInDataProto.IViewSettingsProto=} [properties] Properties to set
                 */
                function ViewSettingsProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ViewSettingsProto theme.
                 * @member {waiternow.common.Theme} theme
                 * @memberof waiternow.common.CheckInDataProto.ViewSettingsProto
                 * @instance
                 */
                ViewSettingsProto.prototype.theme = 0;

                /**
                 * ViewSettingsProto colorPalette.
                 * @member {waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.IColorPaletteProto|null|undefined} colorPalette
                 * @memberof waiternow.common.CheckInDataProto.ViewSettingsProto
                 * @instance
                 */
                ViewSettingsProto.prototype.colorPalette = null;

                /**
                 * Creates a new ViewSettingsProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.CheckInDataProto.ViewSettingsProto
                 * @static
                 * @param {waiternow.common.CheckInDataProto.IViewSettingsProto=} [properties] Properties to set
                 * @returns {waiternow.common.CheckInDataProto.ViewSettingsProto} ViewSettingsProto instance
                 */
                ViewSettingsProto.create = function create(properties) {
                    return new ViewSettingsProto(properties);
                };

                /**
                 * Encodes the specified ViewSettingsProto message. Does not implicitly {@link waiternow.common.CheckInDataProto.ViewSettingsProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.CheckInDataProto.ViewSettingsProto
                 * @static
                 * @param {waiternow.common.CheckInDataProto.IViewSettingsProto} message ViewSettingsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ViewSettingsProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.theme != null && Object.hasOwnProperty.call(message, "theme"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.theme);
                    if (message.colorPalette != null && Object.hasOwnProperty.call(message, "colorPalette"))
                        $root.waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.ColorPaletteProto.encode(message.colorPalette, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified ViewSettingsProto message, length delimited. Does not implicitly {@link waiternow.common.CheckInDataProto.ViewSettingsProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.CheckInDataProto.ViewSettingsProto
                 * @static
                 * @param {waiternow.common.CheckInDataProto.IViewSettingsProto} message ViewSettingsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ViewSettingsProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ViewSettingsProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.CheckInDataProto.ViewSettingsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.CheckInDataProto.ViewSettingsProto} ViewSettingsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ViewSettingsProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CheckInDataProto.ViewSettingsProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.theme = reader.int32();
                                break;
                            }
                        case 2: {
                                message.colorPalette = $root.waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.ColorPaletteProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ViewSettingsProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.CheckInDataProto.ViewSettingsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.CheckInDataProto.ViewSettingsProto} ViewSettingsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ViewSettingsProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ViewSettingsProto message.
                 * @function verify
                 * @memberof waiternow.common.CheckInDataProto.ViewSettingsProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ViewSettingsProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.theme != null && message.hasOwnProperty("theme"))
                        switch (message.theme) {
                        default:
                            return "theme: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.colorPalette != null && message.hasOwnProperty("colorPalette")) {
                        var error = $root.waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.ColorPaletteProto.verify(message.colorPalette);
                        if (error)
                            return "colorPalette." + error;
                    }
                    return null;
                };

                /**
                 * Creates a ViewSettingsProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.CheckInDataProto.ViewSettingsProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.CheckInDataProto.ViewSettingsProto} ViewSettingsProto
                 */
                ViewSettingsProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.CheckInDataProto.ViewSettingsProto)
                        return object;
                    var message = new $root.waiternow.common.CheckInDataProto.ViewSettingsProto();
                    switch (object.theme) {
                    default:
                        if (typeof object.theme === "number") {
                            message.theme = object.theme;
                            break;
                        }
                        break;
                    case "THEME_UNSPECIFIED":
                    case 0:
                        message.theme = 0;
                        break;
                    case "DARK":
                    case 1:
                        message.theme = 1;
                        break;
                    case "LIGHT":
                    case 2:
                        message.theme = 2;
                        break;
                    }
                    if (object.colorPalette != null) {
                        if (typeof object.colorPalette !== "object")
                            throw TypeError(".waiternow.common.CheckInDataProto.ViewSettingsProto.colorPalette: object expected");
                        message.colorPalette = $root.waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.ColorPaletteProto.fromObject(object.colorPalette);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a ViewSettingsProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.CheckInDataProto.ViewSettingsProto
                 * @static
                 * @param {waiternow.common.CheckInDataProto.ViewSettingsProto} message ViewSettingsProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ViewSettingsProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.theme = options.enums === String ? "THEME_UNSPECIFIED" : 0;
                        object.colorPalette = null;
                    }
                    if (message.theme != null && message.hasOwnProperty("theme"))
                        object.theme = options.enums === String ? $root.waiternow.common.Theme[message.theme] === undefined ? message.theme : $root.waiternow.common.Theme[message.theme] : message.theme;
                    if (message.colorPalette != null && message.hasOwnProperty("colorPalette"))
                        object.colorPalette = $root.waiternow.common.LocationProto.SettingsProto.ViewSettingsProto.ColorPaletteProto.toObject(message.colorPalette, options);
                    return object;
                };

                /**
                 * Converts this ViewSettingsProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.CheckInDataProto.ViewSettingsProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ViewSettingsProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ViewSettingsProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.CheckInDataProto.ViewSettingsProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ViewSettingsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.CheckInDataProto.ViewSettingsProto";
                };

                return ViewSettingsProto;
            })();

            return CheckInDataProto;
        })();

        common.PostFeedbackActionProto = (function() {

            /**
             * Properties of a PostFeedbackActionProto.
             * @memberof waiternow.common
             * @interface IPostFeedbackActionProto
             */

            /**
             * Constructs a new PostFeedbackActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a PostFeedbackActionProto.
             * @implements IPostFeedbackActionProto
             * @constructor
             * @param {waiternow.common.IPostFeedbackActionProto=} [properties] Properties to set
             */
            function PostFeedbackActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new PostFeedbackActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.PostFeedbackActionProto
             * @static
             * @param {waiternow.common.IPostFeedbackActionProto=} [properties] Properties to set
             * @returns {waiternow.common.PostFeedbackActionProto} PostFeedbackActionProto instance
             */
            PostFeedbackActionProto.create = function create(properties) {
                return new PostFeedbackActionProto(properties);
            };

            /**
             * Encodes the specified PostFeedbackActionProto message. Does not implicitly {@link waiternow.common.PostFeedbackActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.PostFeedbackActionProto
             * @static
             * @param {waiternow.common.IPostFeedbackActionProto} message PostFeedbackActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PostFeedbackActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified PostFeedbackActionProto message, length delimited. Does not implicitly {@link waiternow.common.PostFeedbackActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.PostFeedbackActionProto
             * @static
             * @param {waiternow.common.IPostFeedbackActionProto} message PostFeedbackActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PostFeedbackActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a PostFeedbackActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.PostFeedbackActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.PostFeedbackActionProto} PostFeedbackActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PostFeedbackActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PostFeedbackActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a PostFeedbackActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.PostFeedbackActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.PostFeedbackActionProto} PostFeedbackActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PostFeedbackActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a PostFeedbackActionProto message.
             * @function verify
             * @memberof waiternow.common.PostFeedbackActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            PostFeedbackActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a PostFeedbackActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.PostFeedbackActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.PostFeedbackActionProto} PostFeedbackActionProto
             */
            PostFeedbackActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.PostFeedbackActionProto)
                    return object;
                return new $root.waiternow.common.PostFeedbackActionProto();
            };

            /**
             * Creates a plain object from a PostFeedbackActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.PostFeedbackActionProto
             * @static
             * @param {waiternow.common.PostFeedbackActionProto} message PostFeedbackActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            PostFeedbackActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this PostFeedbackActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.PostFeedbackActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            PostFeedbackActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for PostFeedbackActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.PostFeedbackActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            PostFeedbackActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.PostFeedbackActionProto";
            };

            PostFeedbackActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.PostFeedbackActionProto
                 * @interface IRequest
                 * @property {waiternow.common.IFeedbackProto|null} [feedback] Request feedback
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.PostFeedbackActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.PostFeedbackActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request feedback.
                 * @member {waiternow.common.IFeedbackProto|null|undefined} feedback
                 * @memberof waiternow.common.PostFeedbackActionProto.Request
                 * @instance
                 */
                Request.prototype.feedback = null;

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.PostFeedbackActionProto.Request
                 * @static
                 * @param {waiternow.common.PostFeedbackActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.PostFeedbackActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.PostFeedbackActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.PostFeedbackActionProto.Request
                 * @static
                 * @param {waiternow.common.PostFeedbackActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.feedback != null && Object.hasOwnProperty.call(message, "feedback"))
                        $root.waiternow.common.FeedbackProto.encode(message.feedback, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.PostFeedbackActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.PostFeedbackActionProto.Request
                 * @static
                 * @param {waiternow.common.PostFeedbackActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.PostFeedbackActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.PostFeedbackActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PostFeedbackActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.feedback = $root.waiternow.common.FeedbackProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.PostFeedbackActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.PostFeedbackActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.PostFeedbackActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.feedback != null && message.hasOwnProperty("feedback")) {
                        var error = $root.waiternow.common.FeedbackProto.verify(message.feedback);
                        if (error)
                            return "feedback." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.PostFeedbackActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.PostFeedbackActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.PostFeedbackActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.PostFeedbackActionProto.Request();
                    if (object.feedback != null) {
                        if (typeof object.feedback !== "object")
                            throw TypeError(".waiternow.common.PostFeedbackActionProto.Request.feedback: object expected");
                        message.feedback = $root.waiternow.common.FeedbackProto.fromObject(object.feedback);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.PostFeedbackActionProto.Request
                 * @static
                 * @param {waiternow.common.PostFeedbackActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.feedback = null;
                    if (message.feedback != null && message.hasOwnProperty("feedback"))
                        object.feedback = $root.waiternow.common.FeedbackProto.toObject(message.feedback, options);
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.PostFeedbackActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.PostFeedbackActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.PostFeedbackActionProto.Request";
                };

                return Request;
            })();

            PostFeedbackActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.PostFeedbackActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.PostFeedbackActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.PostFeedbackActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.PostFeedbackActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.PostFeedbackActionProto.Response
                 * @static
                 * @param {waiternow.common.PostFeedbackActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.PostFeedbackActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.PostFeedbackActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.PostFeedbackActionProto.Response
                 * @static
                 * @param {waiternow.common.PostFeedbackActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.PostFeedbackActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.PostFeedbackActionProto.Response
                 * @static
                 * @param {waiternow.common.PostFeedbackActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.PostFeedbackActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.PostFeedbackActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PostFeedbackActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.PostFeedbackActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.PostFeedbackActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.PostFeedbackActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.PostFeedbackActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.PostFeedbackActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.PostFeedbackActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.PostFeedbackActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.PostFeedbackActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.PostFeedbackActionProto.Response
                 * @static
                 * @param {waiternow.common.PostFeedbackActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.PostFeedbackActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.PostFeedbackActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.PostFeedbackActionProto.Response";
                };

                return Response;
            })();

            return PostFeedbackActionProto;
        })();

        common.RegisterDeviceActionProto = (function() {

            /**
             * Properties of a RegisterDeviceActionProto.
             * @memberof waiternow.common
             * @interface IRegisterDeviceActionProto
             */

            /**
             * Constructs a new RegisterDeviceActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a RegisterDeviceActionProto.
             * @implements IRegisterDeviceActionProto
             * @constructor
             * @param {waiternow.common.IRegisterDeviceActionProto=} [properties] Properties to set
             */
            function RegisterDeviceActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new RegisterDeviceActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.RegisterDeviceActionProto
             * @static
             * @param {waiternow.common.IRegisterDeviceActionProto=} [properties] Properties to set
             * @returns {waiternow.common.RegisterDeviceActionProto} RegisterDeviceActionProto instance
             */
            RegisterDeviceActionProto.create = function create(properties) {
                return new RegisterDeviceActionProto(properties);
            };

            /**
             * Encodes the specified RegisterDeviceActionProto message. Does not implicitly {@link waiternow.common.RegisterDeviceActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.RegisterDeviceActionProto
             * @static
             * @param {waiternow.common.IRegisterDeviceActionProto} message RegisterDeviceActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RegisterDeviceActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified RegisterDeviceActionProto message, length delimited. Does not implicitly {@link waiternow.common.RegisterDeviceActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.RegisterDeviceActionProto
             * @static
             * @param {waiternow.common.IRegisterDeviceActionProto} message RegisterDeviceActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RegisterDeviceActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a RegisterDeviceActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.RegisterDeviceActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.RegisterDeviceActionProto} RegisterDeviceActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RegisterDeviceActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.RegisterDeviceActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a RegisterDeviceActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.RegisterDeviceActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.RegisterDeviceActionProto} RegisterDeviceActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RegisterDeviceActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a RegisterDeviceActionProto message.
             * @function verify
             * @memberof waiternow.common.RegisterDeviceActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            RegisterDeviceActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a RegisterDeviceActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.RegisterDeviceActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.RegisterDeviceActionProto} RegisterDeviceActionProto
             */
            RegisterDeviceActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.RegisterDeviceActionProto)
                    return object;
                return new $root.waiternow.common.RegisterDeviceActionProto();
            };

            /**
             * Creates a plain object from a RegisterDeviceActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.RegisterDeviceActionProto
             * @static
             * @param {waiternow.common.RegisterDeviceActionProto} message RegisterDeviceActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            RegisterDeviceActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this RegisterDeviceActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.RegisterDeviceActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            RegisterDeviceActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for RegisterDeviceActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.RegisterDeviceActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            RegisterDeviceActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.RegisterDeviceActionProto";
            };

            RegisterDeviceActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.RegisterDeviceActionProto
                 * @interface IRequest
                 * @property {waiternow.common.DeviceProto.ClientType|null} [clientType] Request clientType
                 * @property {waiternow.common.DeviceProto.DeviceType|null} [deviceType] Request deviceType
                 * @property {string|null} [version] Request version
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.RegisterDeviceActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.RegisterDeviceActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request clientType.
                 * @member {waiternow.common.DeviceProto.ClientType} clientType
                 * @memberof waiternow.common.RegisterDeviceActionProto.Request
                 * @instance
                 */
                Request.prototype.clientType = 0;

                /**
                 * Request deviceType.
                 * @member {waiternow.common.DeviceProto.DeviceType} deviceType
                 * @memberof waiternow.common.RegisterDeviceActionProto.Request
                 * @instance
                 */
                Request.prototype.deviceType = 0;

                /**
                 * Request version.
                 * @member {string} version
                 * @memberof waiternow.common.RegisterDeviceActionProto.Request
                 * @instance
                 */
                Request.prototype.version = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.RegisterDeviceActionProto.Request
                 * @static
                 * @param {waiternow.common.RegisterDeviceActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.RegisterDeviceActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.RegisterDeviceActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.RegisterDeviceActionProto.Request
                 * @static
                 * @param {waiternow.common.RegisterDeviceActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.clientType != null && Object.hasOwnProperty.call(message, "clientType"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.clientType);
                    if (message.deviceType != null && Object.hasOwnProperty.call(message, "deviceType"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.deviceType);
                    if (message.version != null && Object.hasOwnProperty.call(message, "version"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.version);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.RegisterDeviceActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.RegisterDeviceActionProto.Request
                 * @static
                 * @param {waiternow.common.RegisterDeviceActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.RegisterDeviceActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.RegisterDeviceActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.RegisterDeviceActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.clientType = reader.int32();
                                break;
                            }
                        case 2: {
                                message.deviceType = reader.int32();
                                break;
                            }
                        case 3: {
                                message.version = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.RegisterDeviceActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.RegisterDeviceActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.RegisterDeviceActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.clientType != null && message.hasOwnProperty("clientType"))
                        switch (message.clientType) {
                        default:
                            return "clientType: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.deviceType != null && message.hasOwnProperty("deviceType"))
                        switch (message.deviceType) {
                        default:
                            return "deviceType: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                            break;
                        }
                    if (message.version != null && message.hasOwnProperty("version"))
                        if (!$util.isString(message.version))
                            return "version: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.RegisterDeviceActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.RegisterDeviceActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.RegisterDeviceActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.RegisterDeviceActionProto.Request();
                    switch (object.clientType) {
                    default:
                        if (typeof object.clientType === "number") {
                            message.clientType = object.clientType;
                            break;
                        }
                        break;
                    case "CLIENT_TYPE_UNSPECIFIED":
                    case 0:
                        message.clientType = 0;
                        break;
                    case "BUSINESS":
                    case 1:
                        message.clientType = 1;
                        break;
                    case "CONSUMER":
                    case 2:
                        message.clientType = 2;
                        break;
                    }
                    switch (object.deviceType) {
                    default:
                        if (typeof object.deviceType === "number") {
                            message.deviceType = object.deviceType;
                            break;
                        }
                        break;
                    case "DEVICE_TYPE_UNSPECIFIED":
                    case 0:
                        message.deviceType = 0;
                        break;
                    case "WEB":
                    case 1:
                        message.deviceType = 1;
                        break;
                    case "ANDROID":
                    case 2:
                        message.deviceType = 2;
                        break;
                    case "APPLE":
                    case 3:
                        message.deviceType = 3;
                        break;
                    }
                    if (object.version != null)
                        message.version = String(object.version);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.RegisterDeviceActionProto.Request
                 * @static
                 * @param {waiternow.common.RegisterDeviceActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.clientType = options.enums === String ? "CLIENT_TYPE_UNSPECIFIED" : 0;
                        object.deviceType = options.enums === String ? "DEVICE_TYPE_UNSPECIFIED" : 0;
                        object.version = "";
                    }
                    if (message.clientType != null && message.hasOwnProperty("clientType"))
                        object.clientType = options.enums === String ? $root.waiternow.common.DeviceProto.ClientType[message.clientType] === undefined ? message.clientType : $root.waiternow.common.DeviceProto.ClientType[message.clientType] : message.clientType;
                    if (message.deviceType != null && message.hasOwnProperty("deviceType"))
                        object.deviceType = options.enums === String ? $root.waiternow.common.DeviceProto.DeviceType[message.deviceType] === undefined ? message.deviceType : $root.waiternow.common.DeviceProto.DeviceType[message.deviceType] : message.deviceType;
                    if (message.version != null && message.hasOwnProperty("version"))
                        object.version = message.version;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.RegisterDeviceActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.RegisterDeviceActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.RegisterDeviceActionProto.Request";
                };

                return Request;
            })();

            RegisterDeviceActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.RegisterDeviceActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IDeviceProto|null} [device] Response device
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.RegisterDeviceActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.RegisterDeviceActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.RegisterDeviceActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response device.
                 * @member {waiternow.common.IDeviceProto|null|undefined} device
                 * @memberof waiternow.common.RegisterDeviceActionProto.Response
                 * @instance
                 */
                Response.prototype.device = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.RegisterDeviceActionProto.Response
                 * @static
                 * @param {waiternow.common.RegisterDeviceActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.RegisterDeviceActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.RegisterDeviceActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.RegisterDeviceActionProto.Response
                 * @static
                 * @param {waiternow.common.RegisterDeviceActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.device != null && Object.hasOwnProperty.call(message, "device"))
                        $root.waiternow.common.DeviceProto.encode(message.device, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.RegisterDeviceActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.RegisterDeviceActionProto.Response
                 * @static
                 * @param {waiternow.common.RegisterDeviceActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.RegisterDeviceActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.RegisterDeviceActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.RegisterDeviceActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.device = $root.waiternow.common.DeviceProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.RegisterDeviceActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.RegisterDeviceActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.RegisterDeviceActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.device != null && message.hasOwnProperty("device")) {
                        var error = $root.waiternow.common.DeviceProto.verify(message.device);
                        if (error)
                            return "device." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.RegisterDeviceActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.RegisterDeviceActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.RegisterDeviceActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.RegisterDeviceActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.RegisterDeviceActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.device != null) {
                        if (typeof object.device !== "object")
                            throw TypeError(".waiternow.common.RegisterDeviceActionProto.Response.device: object expected");
                        message.device = $root.waiternow.common.DeviceProto.fromObject(object.device);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.RegisterDeviceActionProto.Response
                 * @static
                 * @param {waiternow.common.RegisterDeviceActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.device = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.device != null && message.hasOwnProperty("device"))
                        object.device = $root.waiternow.common.DeviceProto.toObject(message.device, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.RegisterDeviceActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.RegisterDeviceActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.RegisterDeviceActionProto.Response";
                };

                return Response;
            })();

            return RegisterDeviceActionProto;
        })();

        common.StartDeviceSessionActionProto = (function() {

            /**
             * Properties of a StartDeviceSessionActionProto.
             * @memberof waiternow.common
             * @interface IStartDeviceSessionActionProto
             */

            /**
             * Constructs a new StartDeviceSessionActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a StartDeviceSessionActionProto.
             * @implements IStartDeviceSessionActionProto
             * @constructor
             * @param {waiternow.common.IStartDeviceSessionActionProto=} [properties] Properties to set
             */
            function StartDeviceSessionActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new StartDeviceSessionActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.StartDeviceSessionActionProto
             * @static
             * @param {waiternow.common.IStartDeviceSessionActionProto=} [properties] Properties to set
             * @returns {waiternow.common.StartDeviceSessionActionProto} StartDeviceSessionActionProto instance
             */
            StartDeviceSessionActionProto.create = function create(properties) {
                return new StartDeviceSessionActionProto(properties);
            };

            /**
             * Encodes the specified StartDeviceSessionActionProto message. Does not implicitly {@link waiternow.common.StartDeviceSessionActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.StartDeviceSessionActionProto
             * @static
             * @param {waiternow.common.IStartDeviceSessionActionProto} message StartDeviceSessionActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StartDeviceSessionActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified StartDeviceSessionActionProto message, length delimited. Does not implicitly {@link waiternow.common.StartDeviceSessionActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.StartDeviceSessionActionProto
             * @static
             * @param {waiternow.common.IStartDeviceSessionActionProto} message StartDeviceSessionActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StartDeviceSessionActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a StartDeviceSessionActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.StartDeviceSessionActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.StartDeviceSessionActionProto} StartDeviceSessionActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StartDeviceSessionActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.StartDeviceSessionActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a StartDeviceSessionActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.StartDeviceSessionActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.StartDeviceSessionActionProto} StartDeviceSessionActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StartDeviceSessionActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a StartDeviceSessionActionProto message.
             * @function verify
             * @memberof waiternow.common.StartDeviceSessionActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            StartDeviceSessionActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a StartDeviceSessionActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.StartDeviceSessionActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.StartDeviceSessionActionProto} StartDeviceSessionActionProto
             */
            StartDeviceSessionActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.StartDeviceSessionActionProto)
                    return object;
                return new $root.waiternow.common.StartDeviceSessionActionProto();
            };

            /**
             * Creates a plain object from a StartDeviceSessionActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.StartDeviceSessionActionProto
             * @static
             * @param {waiternow.common.StartDeviceSessionActionProto} message StartDeviceSessionActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            StartDeviceSessionActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this StartDeviceSessionActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.StartDeviceSessionActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            StartDeviceSessionActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for StartDeviceSessionActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.StartDeviceSessionActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            StartDeviceSessionActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.StartDeviceSessionActionProto";
            };

            StartDeviceSessionActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.StartDeviceSessionActionProto
                 * @interface IRequest
                 * @property {string|null} [deviceId] Request deviceId
                 * @property {string|null} [firebaseMessagingToken] Request firebaseMessagingToken
                 * @property {waiternow.common.DeviceProto.IInterestsProto|null} [interests] Request interests
                 * @property {string|null} [version] Request version
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.StartDeviceSessionActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.StartDeviceSessionActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request deviceId.
                 * @member {string} deviceId
                 * @memberof waiternow.common.StartDeviceSessionActionProto.Request
                 * @instance
                 */
                Request.prototype.deviceId = "";

                /**
                 * Request firebaseMessagingToken.
                 * @member {string} firebaseMessagingToken
                 * @memberof waiternow.common.StartDeviceSessionActionProto.Request
                 * @instance
                 */
                Request.prototype.firebaseMessagingToken = "";

                /**
                 * Request interests.
                 * @member {waiternow.common.DeviceProto.IInterestsProto|null|undefined} interests
                 * @memberof waiternow.common.StartDeviceSessionActionProto.Request
                 * @instance
                 */
                Request.prototype.interests = null;

                /**
                 * Request version.
                 * @member {string} version
                 * @memberof waiternow.common.StartDeviceSessionActionProto.Request
                 * @instance
                 */
                Request.prototype.version = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.StartDeviceSessionActionProto.Request
                 * @static
                 * @param {waiternow.common.StartDeviceSessionActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.StartDeviceSessionActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.StartDeviceSessionActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.StartDeviceSessionActionProto.Request
                 * @static
                 * @param {waiternow.common.StartDeviceSessionActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceId != null && Object.hasOwnProperty.call(message, "deviceId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.deviceId);
                    if (message.firebaseMessagingToken != null && Object.hasOwnProperty.call(message, "firebaseMessagingToken"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.firebaseMessagingToken);
                    if (message.interests != null && Object.hasOwnProperty.call(message, "interests"))
                        $root.waiternow.common.DeviceProto.InterestsProto.encode(message.interests, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.version != null && Object.hasOwnProperty.call(message, "version"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.version);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.StartDeviceSessionActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.StartDeviceSessionActionProto.Request
                 * @static
                 * @param {waiternow.common.StartDeviceSessionActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.StartDeviceSessionActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.StartDeviceSessionActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.StartDeviceSessionActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceId = reader.string();
                                break;
                            }
                        case 2: {
                                message.firebaseMessagingToken = reader.string();
                                break;
                            }
                        case 3: {
                                message.interests = $root.waiternow.common.DeviceProto.InterestsProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 4: {
                                message.version = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.StartDeviceSessionActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.StartDeviceSessionActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.StartDeviceSessionActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                        if (!$util.isString(message.deviceId))
                            return "deviceId: string expected";
                    if (message.firebaseMessagingToken != null && message.hasOwnProperty("firebaseMessagingToken"))
                        if (!$util.isString(message.firebaseMessagingToken))
                            return "firebaseMessagingToken: string expected";
                    if (message.interests != null && message.hasOwnProperty("interests")) {
                        var error = $root.waiternow.common.DeviceProto.InterestsProto.verify(message.interests);
                        if (error)
                            return "interests." + error;
                    }
                    if (message.version != null && message.hasOwnProperty("version"))
                        if (!$util.isString(message.version))
                            return "version: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.StartDeviceSessionActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.StartDeviceSessionActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.StartDeviceSessionActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.StartDeviceSessionActionProto.Request();
                    if (object.deviceId != null)
                        message.deviceId = String(object.deviceId);
                    if (object.firebaseMessagingToken != null)
                        message.firebaseMessagingToken = String(object.firebaseMessagingToken);
                    if (object.interests != null) {
                        if (typeof object.interests !== "object")
                            throw TypeError(".waiternow.common.StartDeviceSessionActionProto.Request.interests: object expected");
                        message.interests = $root.waiternow.common.DeviceProto.InterestsProto.fromObject(object.interests);
                    }
                    if (object.version != null)
                        message.version = String(object.version);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.StartDeviceSessionActionProto.Request
                 * @static
                 * @param {waiternow.common.StartDeviceSessionActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.deviceId = "";
                        object.firebaseMessagingToken = "";
                        object.interests = null;
                        object.version = "";
                    }
                    if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                        object.deviceId = message.deviceId;
                    if (message.firebaseMessagingToken != null && message.hasOwnProperty("firebaseMessagingToken"))
                        object.firebaseMessagingToken = message.firebaseMessagingToken;
                    if (message.interests != null && message.hasOwnProperty("interests"))
                        object.interests = $root.waiternow.common.DeviceProto.InterestsProto.toObject(message.interests, options);
                    if (message.version != null && message.hasOwnProperty("version"))
                        object.version = message.version;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.StartDeviceSessionActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.StartDeviceSessionActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.StartDeviceSessionActionProto.Request";
                };

                return Request;
            })();

            StartDeviceSessionActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.StartDeviceSessionActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IDeviceSessionInfoProto|null} [deviceSessionInfo] Response deviceSessionInfo
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.StartDeviceSessionActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.StartDeviceSessionActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.StartDeviceSessionActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response deviceSessionInfo.
                 * @member {waiternow.common.IDeviceSessionInfoProto|null|undefined} deviceSessionInfo
                 * @memberof waiternow.common.StartDeviceSessionActionProto.Response
                 * @instance
                 */
                Response.prototype.deviceSessionInfo = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.StartDeviceSessionActionProto.Response
                 * @static
                 * @param {waiternow.common.StartDeviceSessionActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.StartDeviceSessionActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.StartDeviceSessionActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.StartDeviceSessionActionProto.Response
                 * @static
                 * @param {waiternow.common.StartDeviceSessionActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.deviceSessionInfo != null && Object.hasOwnProperty.call(message, "deviceSessionInfo"))
                        $root.waiternow.common.DeviceSessionInfoProto.encode(message.deviceSessionInfo, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.StartDeviceSessionActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.StartDeviceSessionActionProto.Response
                 * @static
                 * @param {waiternow.common.StartDeviceSessionActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.StartDeviceSessionActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.StartDeviceSessionActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.StartDeviceSessionActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.deviceSessionInfo = $root.waiternow.common.DeviceSessionInfoProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.StartDeviceSessionActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.StartDeviceSessionActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.StartDeviceSessionActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.deviceSessionInfo != null && message.hasOwnProperty("deviceSessionInfo")) {
                        var error = $root.waiternow.common.DeviceSessionInfoProto.verify(message.deviceSessionInfo);
                        if (error)
                            return "deviceSessionInfo." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.StartDeviceSessionActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.StartDeviceSessionActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.StartDeviceSessionActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.StartDeviceSessionActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.StartDeviceSessionActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.deviceSessionInfo != null) {
                        if (typeof object.deviceSessionInfo !== "object")
                            throw TypeError(".waiternow.common.StartDeviceSessionActionProto.Response.deviceSessionInfo: object expected");
                        message.deviceSessionInfo = $root.waiternow.common.DeviceSessionInfoProto.fromObject(object.deviceSessionInfo);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.StartDeviceSessionActionProto.Response
                 * @static
                 * @param {waiternow.common.StartDeviceSessionActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.deviceSessionInfo = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.deviceSessionInfo != null && message.hasOwnProperty("deviceSessionInfo"))
                        object.deviceSessionInfo = $root.waiternow.common.DeviceSessionInfoProto.toObject(message.deviceSessionInfo, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.StartDeviceSessionActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.StartDeviceSessionActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.StartDeviceSessionActionProto.Response";
                };

                return Response;
            })();

            return StartDeviceSessionActionProto;
        })();

        common.DeviceHeartbeatActionProto = (function() {

            /**
             * Properties of a DeviceHeartbeatActionProto.
             * @memberof waiternow.common
             * @interface IDeviceHeartbeatActionProto
             */

            /**
             * Constructs a new DeviceHeartbeatActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a DeviceHeartbeatActionProto.
             * @implements IDeviceHeartbeatActionProto
             * @constructor
             * @param {waiternow.common.IDeviceHeartbeatActionProto=} [properties] Properties to set
             */
            function DeviceHeartbeatActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new DeviceHeartbeatActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.DeviceHeartbeatActionProto
             * @static
             * @param {waiternow.common.IDeviceHeartbeatActionProto=} [properties] Properties to set
             * @returns {waiternow.common.DeviceHeartbeatActionProto} DeviceHeartbeatActionProto instance
             */
            DeviceHeartbeatActionProto.create = function create(properties) {
                return new DeviceHeartbeatActionProto(properties);
            };

            /**
             * Encodes the specified DeviceHeartbeatActionProto message. Does not implicitly {@link waiternow.common.DeviceHeartbeatActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.DeviceHeartbeatActionProto
             * @static
             * @param {waiternow.common.IDeviceHeartbeatActionProto} message DeviceHeartbeatActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DeviceHeartbeatActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified DeviceHeartbeatActionProto message, length delimited. Does not implicitly {@link waiternow.common.DeviceHeartbeatActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.DeviceHeartbeatActionProto
             * @static
             * @param {waiternow.common.IDeviceHeartbeatActionProto} message DeviceHeartbeatActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DeviceHeartbeatActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a DeviceHeartbeatActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.DeviceHeartbeatActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.DeviceHeartbeatActionProto} DeviceHeartbeatActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DeviceHeartbeatActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.DeviceHeartbeatActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a DeviceHeartbeatActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.DeviceHeartbeatActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.DeviceHeartbeatActionProto} DeviceHeartbeatActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DeviceHeartbeatActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a DeviceHeartbeatActionProto message.
             * @function verify
             * @memberof waiternow.common.DeviceHeartbeatActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            DeviceHeartbeatActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a DeviceHeartbeatActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.DeviceHeartbeatActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.DeviceHeartbeatActionProto} DeviceHeartbeatActionProto
             */
            DeviceHeartbeatActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.DeviceHeartbeatActionProto)
                    return object;
                return new $root.waiternow.common.DeviceHeartbeatActionProto();
            };

            /**
             * Creates a plain object from a DeviceHeartbeatActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.DeviceHeartbeatActionProto
             * @static
             * @param {waiternow.common.DeviceHeartbeatActionProto} message DeviceHeartbeatActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            DeviceHeartbeatActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this DeviceHeartbeatActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.DeviceHeartbeatActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            DeviceHeartbeatActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for DeviceHeartbeatActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.DeviceHeartbeatActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            DeviceHeartbeatActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.DeviceHeartbeatActionProto";
            };

            DeviceHeartbeatActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.DeviceHeartbeatActionProto
                 * @interface IRequest
                 * @property {string|null} [deviceId] Request deviceId
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.DeviceHeartbeatActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.DeviceHeartbeatActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request deviceId.
                 * @member {string} deviceId
                 * @memberof waiternow.common.DeviceHeartbeatActionProto.Request
                 * @instance
                 */
                Request.prototype.deviceId = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.DeviceHeartbeatActionProto.Request
                 * @static
                 * @param {waiternow.common.DeviceHeartbeatActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.DeviceHeartbeatActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.DeviceHeartbeatActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.DeviceHeartbeatActionProto.Request
                 * @static
                 * @param {waiternow.common.DeviceHeartbeatActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceId != null && Object.hasOwnProperty.call(message, "deviceId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.deviceId);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.DeviceHeartbeatActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.DeviceHeartbeatActionProto.Request
                 * @static
                 * @param {waiternow.common.DeviceHeartbeatActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.DeviceHeartbeatActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.DeviceHeartbeatActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.DeviceHeartbeatActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.DeviceHeartbeatActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.DeviceHeartbeatActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.DeviceHeartbeatActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                        if (!$util.isString(message.deviceId))
                            return "deviceId: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.DeviceHeartbeatActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.DeviceHeartbeatActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.DeviceHeartbeatActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.DeviceHeartbeatActionProto.Request();
                    if (object.deviceId != null)
                        message.deviceId = String(object.deviceId);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.DeviceHeartbeatActionProto.Request
                 * @static
                 * @param {waiternow.common.DeviceHeartbeatActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.deviceId = "";
                    if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                        object.deviceId = message.deviceId;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.DeviceHeartbeatActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.DeviceHeartbeatActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.DeviceHeartbeatActionProto.Request";
                };

                return Request;
            })();

            DeviceHeartbeatActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.DeviceHeartbeatActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.DeviceHeartbeatActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.DeviceHeartbeatActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.DeviceHeartbeatActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.DeviceHeartbeatActionProto.Response
                 * @static
                 * @param {waiternow.common.DeviceHeartbeatActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.DeviceHeartbeatActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.DeviceHeartbeatActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.DeviceHeartbeatActionProto.Response
                 * @static
                 * @param {waiternow.common.DeviceHeartbeatActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.DeviceHeartbeatActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.DeviceHeartbeatActionProto.Response
                 * @static
                 * @param {waiternow.common.DeviceHeartbeatActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.DeviceHeartbeatActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.DeviceHeartbeatActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.DeviceHeartbeatActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.DeviceHeartbeatActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.DeviceHeartbeatActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.DeviceHeartbeatActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.DeviceHeartbeatActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.DeviceHeartbeatActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.DeviceHeartbeatActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.DeviceHeartbeatActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.DeviceHeartbeatActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.DeviceHeartbeatActionProto.Response
                 * @static
                 * @param {waiternow.common.DeviceHeartbeatActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.DeviceHeartbeatActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.DeviceHeartbeatActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.DeviceHeartbeatActionProto.Response";
                };

                return Response;
            })();

            return DeviceHeartbeatActionProto;
        })();

        common.StartGracePeriodToEndDeviceSessionActionProto = (function() {

            /**
             * Properties of a StartGracePeriodToEndDeviceSessionActionProto.
             * @memberof waiternow.common
             * @interface IStartGracePeriodToEndDeviceSessionActionProto
             */

            /**
             * Constructs a new StartGracePeriodToEndDeviceSessionActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a StartGracePeriodToEndDeviceSessionActionProto.
             * @implements IStartGracePeriodToEndDeviceSessionActionProto
             * @constructor
             * @param {waiternow.common.IStartGracePeriodToEndDeviceSessionActionProto=} [properties] Properties to set
             */
            function StartGracePeriodToEndDeviceSessionActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new StartGracePeriodToEndDeviceSessionActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.StartGracePeriodToEndDeviceSessionActionProto
             * @static
             * @param {waiternow.common.IStartGracePeriodToEndDeviceSessionActionProto=} [properties] Properties to set
             * @returns {waiternow.common.StartGracePeriodToEndDeviceSessionActionProto} StartGracePeriodToEndDeviceSessionActionProto instance
             */
            StartGracePeriodToEndDeviceSessionActionProto.create = function create(properties) {
                return new StartGracePeriodToEndDeviceSessionActionProto(properties);
            };

            /**
             * Encodes the specified StartGracePeriodToEndDeviceSessionActionProto message. Does not implicitly {@link waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.StartGracePeriodToEndDeviceSessionActionProto
             * @static
             * @param {waiternow.common.IStartGracePeriodToEndDeviceSessionActionProto} message StartGracePeriodToEndDeviceSessionActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StartGracePeriodToEndDeviceSessionActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified StartGracePeriodToEndDeviceSessionActionProto message, length delimited. Does not implicitly {@link waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.StartGracePeriodToEndDeviceSessionActionProto
             * @static
             * @param {waiternow.common.IStartGracePeriodToEndDeviceSessionActionProto} message StartGracePeriodToEndDeviceSessionActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StartGracePeriodToEndDeviceSessionActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a StartGracePeriodToEndDeviceSessionActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.StartGracePeriodToEndDeviceSessionActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.StartGracePeriodToEndDeviceSessionActionProto} StartGracePeriodToEndDeviceSessionActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StartGracePeriodToEndDeviceSessionActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.StartGracePeriodToEndDeviceSessionActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a StartGracePeriodToEndDeviceSessionActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.StartGracePeriodToEndDeviceSessionActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.StartGracePeriodToEndDeviceSessionActionProto} StartGracePeriodToEndDeviceSessionActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StartGracePeriodToEndDeviceSessionActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a StartGracePeriodToEndDeviceSessionActionProto message.
             * @function verify
             * @memberof waiternow.common.StartGracePeriodToEndDeviceSessionActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            StartGracePeriodToEndDeviceSessionActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a StartGracePeriodToEndDeviceSessionActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.StartGracePeriodToEndDeviceSessionActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.StartGracePeriodToEndDeviceSessionActionProto} StartGracePeriodToEndDeviceSessionActionProto
             */
            StartGracePeriodToEndDeviceSessionActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.StartGracePeriodToEndDeviceSessionActionProto)
                    return object;
                return new $root.waiternow.common.StartGracePeriodToEndDeviceSessionActionProto();
            };

            /**
             * Creates a plain object from a StartGracePeriodToEndDeviceSessionActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.StartGracePeriodToEndDeviceSessionActionProto
             * @static
             * @param {waiternow.common.StartGracePeriodToEndDeviceSessionActionProto} message StartGracePeriodToEndDeviceSessionActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            StartGracePeriodToEndDeviceSessionActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this StartGracePeriodToEndDeviceSessionActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.StartGracePeriodToEndDeviceSessionActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            StartGracePeriodToEndDeviceSessionActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for StartGracePeriodToEndDeviceSessionActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.StartGracePeriodToEndDeviceSessionActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            StartGracePeriodToEndDeviceSessionActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.StartGracePeriodToEndDeviceSessionActionProto";
            };

            StartGracePeriodToEndDeviceSessionActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.StartGracePeriodToEndDeviceSessionActionProto
                 * @interface IRequest
                 * @property {string|null} [deviceId] Request deviceId
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.StartGracePeriodToEndDeviceSessionActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request deviceId.
                 * @member {string} deviceId
                 * @memberof waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.Request
                 * @instance
                 */
                Request.prototype.deviceId = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.Request
                 * @static
                 * @param {waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.Request
                 * @static
                 * @param {waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceId != null && Object.hasOwnProperty.call(message, "deviceId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.deviceId);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.Request
                 * @static
                 * @param {waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                        if (!$util.isString(message.deviceId))
                            return "deviceId: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.Request();
                    if (object.deviceId != null)
                        message.deviceId = String(object.deviceId);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.Request
                 * @static
                 * @param {waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.deviceId = "";
                    if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                        object.deviceId = message.deviceId;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.Request";
                };

                return Request;
            })();

            StartGracePeriodToEndDeviceSessionActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.StartGracePeriodToEndDeviceSessionActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.StartGracePeriodToEndDeviceSessionActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.Response
                 * @static
                 * @param {waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.Response
                 * @static
                 * @param {waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.Response
                 * @static
                 * @param {waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.Response
                 * @static
                 * @param {waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.StartGracePeriodToEndDeviceSessionActionProto.Response";
                };

                return Response;
            })();

            return StartGracePeriodToEndDeviceSessionActionProto;
        })();

        common.EndDeviceSessionActionProto = (function() {

            /**
             * Properties of an EndDeviceSessionActionProto.
             * @memberof waiternow.common
             * @interface IEndDeviceSessionActionProto
             */

            /**
             * Constructs a new EndDeviceSessionActionProto.
             * @memberof waiternow.common
             * @classdesc Represents an EndDeviceSessionActionProto.
             * @implements IEndDeviceSessionActionProto
             * @constructor
             * @param {waiternow.common.IEndDeviceSessionActionProto=} [properties] Properties to set
             */
            function EndDeviceSessionActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new EndDeviceSessionActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.EndDeviceSessionActionProto
             * @static
             * @param {waiternow.common.IEndDeviceSessionActionProto=} [properties] Properties to set
             * @returns {waiternow.common.EndDeviceSessionActionProto} EndDeviceSessionActionProto instance
             */
            EndDeviceSessionActionProto.create = function create(properties) {
                return new EndDeviceSessionActionProto(properties);
            };

            /**
             * Encodes the specified EndDeviceSessionActionProto message. Does not implicitly {@link waiternow.common.EndDeviceSessionActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.EndDeviceSessionActionProto
             * @static
             * @param {waiternow.common.IEndDeviceSessionActionProto} message EndDeviceSessionActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EndDeviceSessionActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified EndDeviceSessionActionProto message, length delimited. Does not implicitly {@link waiternow.common.EndDeviceSessionActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.EndDeviceSessionActionProto
             * @static
             * @param {waiternow.common.IEndDeviceSessionActionProto} message EndDeviceSessionActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EndDeviceSessionActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an EndDeviceSessionActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.EndDeviceSessionActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.EndDeviceSessionActionProto} EndDeviceSessionActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EndDeviceSessionActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.EndDeviceSessionActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an EndDeviceSessionActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.EndDeviceSessionActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.EndDeviceSessionActionProto} EndDeviceSessionActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EndDeviceSessionActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an EndDeviceSessionActionProto message.
             * @function verify
             * @memberof waiternow.common.EndDeviceSessionActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            EndDeviceSessionActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates an EndDeviceSessionActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.EndDeviceSessionActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.EndDeviceSessionActionProto} EndDeviceSessionActionProto
             */
            EndDeviceSessionActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.EndDeviceSessionActionProto)
                    return object;
                return new $root.waiternow.common.EndDeviceSessionActionProto();
            };

            /**
             * Creates a plain object from an EndDeviceSessionActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.EndDeviceSessionActionProto
             * @static
             * @param {waiternow.common.EndDeviceSessionActionProto} message EndDeviceSessionActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            EndDeviceSessionActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this EndDeviceSessionActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.EndDeviceSessionActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            EndDeviceSessionActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for EndDeviceSessionActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.EndDeviceSessionActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            EndDeviceSessionActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.EndDeviceSessionActionProto";
            };

            EndDeviceSessionActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.EndDeviceSessionActionProto
                 * @interface IRequest
                 * @property {string|null} [deviceId] Request deviceId
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.EndDeviceSessionActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.EndDeviceSessionActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request deviceId.
                 * @member {string} deviceId
                 * @memberof waiternow.common.EndDeviceSessionActionProto.Request
                 * @instance
                 */
                Request.prototype.deviceId = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.EndDeviceSessionActionProto.Request
                 * @static
                 * @param {waiternow.common.EndDeviceSessionActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.EndDeviceSessionActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.EndDeviceSessionActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.EndDeviceSessionActionProto.Request
                 * @static
                 * @param {waiternow.common.EndDeviceSessionActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceId != null && Object.hasOwnProperty.call(message, "deviceId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.deviceId);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.EndDeviceSessionActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.EndDeviceSessionActionProto.Request
                 * @static
                 * @param {waiternow.common.EndDeviceSessionActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.EndDeviceSessionActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.EndDeviceSessionActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.EndDeviceSessionActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.EndDeviceSessionActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.EndDeviceSessionActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.EndDeviceSessionActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                        if (!$util.isString(message.deviceId))
                            return "deviceId: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.EndDeviceSessionActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.EndDeviceSessionActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.EndDeviceSessionActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.EndDeviceSessionActionProto.Request();
                    if (object.deviceId != null)
                        message.deviceId = String(object.deviceId);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.EndDeviceSessionActionProto.Request
                 * @static
                 * @param {waiternow.common.EndDeviceSessionActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.deviceId = "";
                    if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                        object.deviceId = message.deviceId;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.EndDeviceSessionActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.EndDeviceSessionActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.EndDeviceSessionActionProto.Request";
                };

                return Request;
            })();

            EndDeviceSessionActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.EndDeviceSessionActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.EndDeviceSessionActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.EndDeviceSessionActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.EndDeviceSessionActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.EndDeviceSessionActionProto.Response
                 * @static
                 * @param {waiternow.common.EndDeviceSessionActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.EndDeviceSessionActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.EndDeviceSessionActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.EndDeviceSessionActionProto.Response
                 * @static
                 * @param {waiternow.common.EndDeviceSessionActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.EndDeviceSessionActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.EndDeviceSessionActionProto.Response
                 * @static
                 * @param {waiternow.common.EndDeviceSessionActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.EndDeviceSessionActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.EndDeviceSessionActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.EndDeviceSessionActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.EndDeviceSessionActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.EndDeviceSessionActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.EndDeviceSessionActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.EndDeviceSessionActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.EndDeviceSessionActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.EndDeviceSessionActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.EndDeviceSessionActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.EndDeviceSessionActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.EndDeviceSessionActionProto.Response
                 * @static
                 * @param {waiternow.common.EndDeviceSessionActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.EndDeviceSessionActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.EndDeviceSessionActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.EndDeviceSessionActionProto.Response";
                };

                return Response;
            })();

            return EndDeviceSessionActionProto;
        })();

        common.SendEmailActionProto = (function() {

            /**
             * Properties of a SendEmailActionProto.
             * @memberof waiternow.common
             * @interface ISendEmailActionProto
             */

            /**
             * Constructs a new SendEmailActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a SendEmailActionProto.
             * @implements ISendEmailActionProto
             * @constructor
             * @param {waiternow.common.ISendEmailActionProto=} [properties] Properties to set
             */
            function SendEmailActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new SendEmailActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.SendEmailActionProto
             * @static
             * @param {waiternow.common.ISendEmailActionProto=} [properties] Properties to set
             * @returns {waiternow.common.SendEmailActionProto} SendEmailActionProto instance
             */
            SendEmailActionProto.create = function create(properties) {
                return new SendEmailActionProto(properties);
            };

            /**
             * Encodes the specified SendEmailActionProto message. Does not implicitly {@link waiternow.common.SendEmailActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.SendEmailActionProto
             * @static
             * @param {waiternow.common.ISendEmailActionProto} message SendEmailActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SendEmailActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified SendEmailActionProto message, length delimited. Does not implicitly {@link waiternow.common.SendEmailActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.SendEmailActionProto
             * @static
             * @param {waiternow.common.ISendEmailActionProto} message SendEmailActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SendEmailActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SendEmailActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.SendEmailActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.SendEmailActionProto} SendEmailActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SendEmailActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.SendEmailActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SendEmailActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.SendEmailActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.SendEmailActionProto} SendEmailActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SendEmailActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SendEmailActionProto message.
             * @function verify
             * @memberof waiternow.common.SendEmailActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SendEmailActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a SendEmailActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.SendEmailActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.SendEmailActionProto} SendEmailActionProto
             */
            SendEmailActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.SendEmailActionProto)
                    return object;
                return new $root.waiternow.common.SendEmailActionProto();
            };

            /**
             * Creates a plain object from a SendEmailActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.SendEmailActionProto
             * @static
             * @param {waiternow.common.SendEmailActionProto} message SendEmailActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SendEmailActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this SendEmailActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.SendEmailActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SendEmailActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for SendEmailActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.SendEmailActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            SendEmailActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.SendEmailActionProto";
            };

            SendEmailActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.SendEmailActionProto
                 * @interface IRequest
                 * @property {waiternow.common.IEmailAddressProto|null} [from] Request from
                 * @property {waiternow.common.EmailRecipient|null} [to] Request to
                 * @property {string|null} [subject] Request subject
                 * @property {string|null} [body] Request body
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.SendEmailActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.SendEmailActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request from.
                 * @member {waiternow.common.IEmailAddressProto|null|undefined} from
                 * @memberof waiternow.common.SendEmailActionProto.Request
                 * @instance
                 */
                Request.prototype.from = null;

                /**
                 * Request to.
                 * @member {waiternow.common.EmailRecipient} to
                 * @memberof waiternow.common.SendEmailActionProto.Request
                 * @instance
                 */
                Request.prototype.to = 0;

                /**
                 * Request subject.
                 * @member {string} subject
                 * @memberof waiternow.common.SendEmailActionProto.Request
                 * @instance
                 */
                Request.prototype.subject = "";

                /**
                 * Request body.
                 * @member {string} body
                 * @memberof waiternow.common.SendEmailActionProto.Request
                 * @instance
                 */
                Request.prototype.body = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.SendEmailActionProto.Request
                 * @static
                 * @param {waiternow.common.SendEmailActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.SendEmailActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.SendEmailActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.SendEmailActionProto.Request
                 * @static
                 * @param {waiternow.common.SendEmailActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.from != null && Object.hasOwnProperty.call(message, "from"))
                        $root.waiternow.common.EmailAddressProto.encode(message.from, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.to != null && Object.hasOwnProperty.call(message, "to"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.to);
                    if (message.subject != null && Object.hasOwnProperty.call(message, "subject"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.subject);
                    if (message.body != null && Object.hasOwnProperty.call(message, "body"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.body);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.SendEmailActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.SendEmailActionProto.Request
                 * @static
                 * @param {waiternow.common.SendEmailActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.SendEmailActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.SendEmailActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.SendEmailActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.from = $root.waiternow.common.EmailAddressProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.to = reader.int32();
                                break;
                            }
                        case 3: {
                                message.subject = reader.string();
                                break;
                            }
                        case 4: {
                                message.body = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.SendEmailActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.SendEmailActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.SendEmailActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.from != null && message.hasOwnProperty("from")) {
                        var error = $root.waiternow.common.EmailAddressProto.verify(message.from);
                        if (error)
                            return "from." + error;
                    }
                    if (message.to != null && message.hasOwnProperty("to"))
                        switch (message.to) {
                        default:
                            return "to: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                        case 6:
                        case 7:
                        case 8:
                            break;
                        }
                    if (message.subject != null && message.hasOwnProperty("subject"))
                        if (!$util.isString(message.subject))
                            return "subject: string expected";
                    if (message.body != null && message.hasOwnProperty("body"))
                        if (!$util.isString(message.body))
                            return "body: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.SendEmailActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.SendEmailActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.SendEmailActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.SendEmailActionProto.Request();
                    if (object.from != null) {
                        if (typeof object.from !== "object")
                            throw TypeError(".waiternow.common.SendEmailActionProto.Request.from: object expected");
                        message.from = $root.waiternow.common.EmailAddressProto.fromObject(object.from);
                    }
                    switch (object.to) {
                    default:
                        if (typeof object.to === "number") {
                            message.to = object.to;
                            break;
                        }
                        break;
                    case "EMAIL_RECIPIENT_UNSPECIFIED":
                    case 0:
                        message.to = 0;
                        break;
                    case "INFO":
                    case 1:
                        message.to = 1;
                        break;
                    case "SYSTEM":
                    case 2:
                        message.to = 2;
                        break;
                    case "SUPPORT":
                    case 3:
                        message.to = 3;
                        break;
                    case "CONTACT":
                    case 4:
                        message.to = 4;
                        break;
                    case "FEEDBACK":
                    case 5:
                        message.to = 5;
                        break;
                    case "SALES":
                    case 6:
                        message.to = 6;
                        break;
                    case "BILLING":
                    case 7:
                        message.to = 7;
                        break;
                    case "QR_CODE_SALES":
                    case 8:
                        message.to = 8;
                        break;
                    }
                    if (object.subject != null)
                        message.subject = String(object.subject);
                    if (object.body != null)
                        message.body = String(object.body);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.SendEmailActionProto.Request
                 * @static
                 * @param {waiternow.common.SendEmailActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.from = null;
                        object.to = options.enums === String ? "EMAIL_RECIPIENT_UNSPECIFIED" : 0;
                        object.subject = "";
                        object.body = "";
                    }
                    if (message.from != null && message.hasOwnProperty("from"))
                        object.from = $root.waiternow.common.EmailAddressProto.toObject(message.from, options);
                    if (message.to != null && message.hasOwnProperty("to"))
                        object.to = options.enums === String ? $root.waiternow.common.EmailRecipient[message.to] === undefined ? message.to : $root.waiternow.common.EmailRecipient[message.to] : message.to;
                    if (message.subject != null && message.hasOwnProperty("subject"))
                        object.subject = message.subject;
                    if (message.body != null && message.hasOwnProperty("body"))
                        object.body = message.body;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.SendEmailActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.SendEmailActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.SendEmailActionProto.Request";
                };

                return Request;
            })();

            SendEmailActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.SendEmailActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.SendEmailActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.SendEmailActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.SendEmailActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.SendEmailActionProto.Response
                 * @static
                 * @param {waiternow.common.SendEmailActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.SendEmailActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.SendEmailActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.SendEmailActionProto.Response
                 * @static
                 * @param {waiternow.common.SendEmailActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.SendEmailActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.SendEmailActionProto.Response
                 * @static
                 * @param {waiternow.common.SendEmailActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.SendEmailActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.SendEmailActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.SendEmailActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.SendEmailActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.SendEmailActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.SendEmailActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.SendEmailActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.SendEmailActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.SendEmailActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.SendEmailActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.SendEmailActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.SendEmailActionProto.Response
                 * @static
                 * @param {waiternow.common.SendEmailActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.SendEmailActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.SendEmailActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.SendEmailActionProto.Response";
                };

                return Response;
            })();

            return SendEmailActionProto;
        })();

        common.GetVersionsActionProto = (function() {

            /**
             * Properties of a GetVersionsActionProto.
             * @memberof waiternow.common
             * @interface IGetVersionsActionProto
             */

            /**
             * Constructs a new GetVersionsActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a GetVersionsActionProto.
             * @implements IGetVersionsActionProto
             * @constructor
             * @param {waiternow.common.IGetVersionsActionProto=} [properties] Properties to set
             */
            function GetVersionsActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new GetVersionsActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.GetVersionsActionProto
             * @static
             * @param {waiternow.common.IGetVersionsActionProto=} [properties] Properties to set
             * @returns {waiternow.common.GetVersionsActionProto} GetVersionsActionProto instance
             */
            GetVersionsActionProto.create = function create(properties) {
                return new GetVersionsActionProto(properties);
            };

            /**
             * Encodes the specified GetVersionsActionProto message. Does not implicitly {@link waiternow.common.GetVersionsActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.GetVersionsActionProto
             * @static
             * @param {waiternow.common.IGetVersionsActionProto} message GetVersionsActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetVersionsActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified GetVersionsActionProto message, length delimited. Does not implicitly {@link waiternow.common.GetVersionsActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.GetVersionsActionProto
             * @static
             * @param {waiternow.common.IGetVersionsActionProto} message GetVersionsActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetVersionsActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetVersionsActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.GetVersionsActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.GetVersionsActionProto} GetVersionsActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetVersionsActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetVersionsActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetVersionsActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.GetVersionsActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.GetVersionsActionProto} GetVersionsActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetVersionsActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetVersionsActionProto message.
             * @function verify
             * @memberof waiternow.common.GetVersionsActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetVersionsActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a GetVersionsActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.GetVersionsActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.GetVersionsActionProto} GetVersionsActionProto
             */
            GetVersionsActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.GetVersionsActionProto)
                    return object;
                return new $root.waiternow.common.GetVersionsActionProto();
            };

            /**
             * Creates a plain object from a GetVersionsActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.GetVersionsActionProto
             * @static
             * @param {waiternow.common.GetVersionsActionProto} message GetVersionsActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetVersionsActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this GetVersionsActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.GetVersionsActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetVersionsActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for GetVersionsActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.GetVersionsActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            GetVersionsActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.GetVersionsActionProto";
            };

            GetVersionsActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.GetVersionsActionProto
                 * @interface IRequest
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.GetVersionsActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.GetVersionsActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetVersionsActionProto.Request
                 * @static
                 * @param {waiternow.common.GetVersionsActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.GetVersionsActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.GetVersionsActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetVersionsActionProto.Request
                 * @static
                 * @param {waiternow.common.GetVersionsActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.GetVersionsActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetVersionsActionProto.Request
                 * @static
                 * @param {waiternow.common.GetVersionsActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetVersionsActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetVersionsActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetVersionsActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetVersionsActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetVersionsActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.GetVersionsActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetVersionsActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetVersionsActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetVersionsActionProto.Request)
                        return object;
                    return new $root.waiternow.common.GetVersionsActionProto.Request();
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetVersionsActionProto.Request
                 * @static
                 * @param {waiternow.common.GetVersionsActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject() {
                    return {};
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetVersionsActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetVersionsActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetVersionsActionProto.Request";
                };

                return Request;
            })();

            GetVersionsActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.GetVersionsActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IVersionProto|null} [consumerVersion] Response consumerVersion
                 * @property {waiternow.common.IVersionProto|null} [businessWebVersion] Response businessWebVersion
                 * @property {waiternow.common.IVersionProto|null} [adminVersion] Response adminVersion
                 * @property {waiternow.common.IVersionProto|null} [supportVersion] Response supportVersion
                 * @property {waiternow.common.IVersionProto|null} [landingPageVersion] Response landingPageVersion
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.GetVersionsActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.GetVersionsActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.GetVersionsActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response consumerVersion.
                 * @member {waiternow.common.IVersionProto|null|undefined} consumerVersion
                 * @memberof waiternow.common.GetVersionsActionProto.Response
                 * @instance
                 */
                Response.prototype.consumerVersion = null;

                /**
                 * Response businessWebVersion.
                 * @member {waiternow.common.IVersionProto|null|undefined} businessWebVersion
                 * @memberof waiternow.common.GetVersionsActionProto.Response
                 * @instance
                 */
                Response.prototype.businessWebVersion = null;

                /**
                 * Response adminVersion.
                 * @member {waiternow.common.IVersionProto|null|undefined} adminVersion
                 * @memberof waiternow.common.GetVersionsActionProto.Response
                 * @instance
                 */
                Response.prototype.adminVersion = null;

                /**
                 * Response supportVersion.
                 * @member {waiternow.common.IVersionProto|null|undefined} supportVersion
                 * @memberof waiternow.common.GetVersionsActionProto.Response
                 * @instance
                 */
                Response.prototype.supportVersion = null;

                /**
                 * Response landingPageVersion.
                 * @member {waiternow.common.IVersionProto|null|undefined} landingPageVersion
                 * @memberof waiternow.common.GetVersionsActionProto.Response
                 * @instance
                 */
                Response.prototype.landingPageVersion = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetVersionsActionProto.Response
                 * @static
                 * @param {waiternow.common.GetVersionsActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.GetVersionsActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.GetVersionsActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetVersionsActionProto.Response
                 * @static
                 * @param {waiternow.common.GetVersionsActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.consumerVersion != null && Object.hasOwnProperty.call(message, "consumerVersion"))
                        $root.waiternow.common.VersionProto.encode(message.consumerVersion, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.businessWebVersion != null && Object.hasOwnProperty.call(message, "businessWebVersion"))
                        $root.waiternow.common.VersionProto.encode(message.businessWebVersion, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.adminVersion != null && Object.hasOwnProperty.call(message, "adminVersion"))
                        $root.waiternow.common.VersionProto.encode(message.adminVersion, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.supportVersion != null && Object.hasOwnProperty.call(message, "supportVersion"))
                        $root.waiternow.common.VersionProto.encode(message.supportVersion, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.landingPageVersion != null && Object.hasOwnProperty.call(message, "landingPageVersion"))
                        $root.waiternow.common.VersionProto.encode(message.landingPageVersion, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.GetVersionsActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetVersionsActionProto.Response
                 * @static
                 * @param {waiternow.common.GetVersionsActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetVersionsActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetVersionsActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetVersionsActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.consumerVersion = $root.waiternow.common.VersionProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.businessWebVersion = $root.waiternow.common.VersionProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 4: {
                                message.adminVersion = $root.waiternow.common.VersionProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 5: {
                                message.supportVersion = $root.waiternow.common.VersionProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 6: {
                                message.landingPageVersion = $root.waiternow.common.VersionProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetVersionsActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetVersionsActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.GetVersionsActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.consumerVersion != null && message.hasOwnProperty("consumerVersion")) {
                        var error = $root.waiternow.common.VersionProto.verify(message.consumerVersion);
                        if (error)
                            return "consumerVersion." + error;
                    }
                    if (message.businessWebVersion != null && message.hasOwnProperty("businessWebVersion")) {
                        var error = $root.waiternow.common.VersionProto.verify(message.businessWebVersion);
                        if (error)
                            return "businessWebVersion." + error;
                    }
                    if (message.adminVersion != null && message.hasOwnProperty("adminVersion")) {
                        var error = $root.waiternow.common.VersionProto.verify(message.adminVersion);
                        if (error)
                            return "adminVersion." + error;
                    }
                    if (message.supportVersion != null && message.hasOwnProperty("supportVersion")) {
                        var error = $root.waiternow.common.VersionProto.verify(message.supportVersion);
                        if (error)
                            return "supportVersion." + error;
                    }
                    if (message.landingPageVersion != null && message.hasOwnProperty("landingPageVersion")) {
                        var error = $root.waiternow.common.VersionProto.verify(message.landingPageVersion);
                        if (error)
                            return "landingPageVersion." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetVersionsActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetVersionsActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetVersionsActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.GetVersionsActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.GetVersionsActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.consumerVersion != null) {
                        if (typeof object.consumerVersion !== "object")
                            throw TypeError(".waiternow.common.GetVersionsActionProto.Response.consumerVersion: object expected");
                        message.consumerVersion = $root.waiternow.common.VersionProto.fromObject(object.consumerVersion);
                    }
                    if (object.businessWebVersion != null) {
                        if (typeof object.businessWebVersion !== "object")
                            throw TypeError(".waiternow.common.GetVersionsActionProto.Response.businessWebVersion: object expected");
                        message.businessWebVersion = $root.waiternow.common.VersionProto.fromObject(object.businessWebVersion);
                    }
                    if (object.adminVersion != null) {
                        if (typeof object.adminVersion !== "object")
                            throw TypeError(".waiternow.common.GetVersionsActionProto.Response.adminVersion: object expected");
                        message.adminVersion = $root.waiternow.common.VersionProto.fromObject(object.adminVersion);
                    }
                    if (object.supportVersion != null) {
                        if (typeof object.supportVersion !== "object")
                            throw TypeError(".waiternow.common.GetVersionsActionProto.Response.supportVersion: object expected");
                        message.supportVersion = $root.waiternow.common.VersionProto.fromObject(object.supportVersion);
                    }
                    if (object.landingPageVersion != null) {
                        if (typeof object.landingPageVersion !== "object")
                            throw TypeError(".waiternow.common.GetVersionsActionProto.Response.landingPageVersion: object expected");
                        message.landingPageVersion = $root.waiternow.common.VersionProto.fromObject(object.landingPageVersion);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetVersionsActionProto.Response
                 * @static
                 * @param {waiternow.common.GetVersionsActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.consumerVersion = null;
                        object.businessWebVersion = null;
                        object.adminVersion = null;
                        object.supportVersion = null;
                        object.landingPageVersion = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.consumerVersion != null && message.hasOwnProperty("consumerVersion"))
                        object.consumerVersion = $root.waiternow.common.VersionProto.toObject(message.consumerVersion, options);
                    if (message.businessWebVersion != null && message.hasOwnProperty("businessWebVersion"))
                        object.businessWebVersion = $root.waiternow.common.VersionProto.toObject(message.businessWebVersion, options);
                    if (message.adminVersion != null && message.hasOwnProperty("adminVersion"))
                        object.adminVersion = $root.waiternow.common.VersionProto.toObject(message.adminVersion, options);
                    if (message.supportVersion != null && message.hasOwnProperty("supportVersion"))
                        object.supportVersion = $root.waiternow.common.VersionProto.toObject(message.supportVersion, options);
                    if (message.landingPageVersion != null && message.hasOwnProperty("landingPageVersion"))
                        object.landingPageVersion = $root.waiternow.common.VersionProto.toObject(message.landingPageVersion, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetVersionsActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetVersionsActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetVersionsActionProto.Response";
                };

                return Response;
            })();

            return GetVersionsActionProto;
        })();

        common.EmulatePaymentActionProto = (function() {

            /**
             * Properties of an EmulatePaymentActionProto.
             * @memberof waiternow.common
             * @interface IEmulatePaymentActionProto
             */

            /**
             * Constructs a new EmulatePaymentActionProto.
             * @memberof waiternow.common
             * @classdesc Represents an EmulatePaymentActionProto.
             * @implements IEmulatePaymentActionProto
             * @constructor
             * @param {waiternow.common.IEmulatePaymentActionProto=} [properties] Properties to set
             */
            function EmulatePaymentActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new EmulatePaymentActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.EmulatePaymentActionProto
             * @static
             * @param {waiternow.common.IEmulatePaymentActionProto=} [properties] Properties to set
             * @returns {waiternow.common.EmulatePaymentActionProto} EmulatePaymentActionProto instance
             */
            EmulatePaymentActionProto.create = function create(properties) {
                return new EmulatePaymentActionProto(properties);
            };

            /**
             * Encodes the specified EmulatePaymentActionProto message. Does not implicitly {@link waiternow.common.EmulatePaymentActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.EmulatePaymentActionProto
             * @static
             * @param {waiternow.common.IEmulatePaymentActionProto} message EmulatePaymentActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EmulatePaymentActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified EmulatePaymentActionProto message, length delimited. Does not implicitly {@link waiternow.common.EmulatePaymentActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.EmulatePaymentActionProto
             * @static
             * @param {waiternow.common.IEmulatePaymentActionProto} message EmulatePaymentActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EmulatePaymentActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an EmulatePaymentActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.EmulatePaymentActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.EmulatePaymentActionProto} EmulatePaymentActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EmulatePaymentActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.EmulatePaymentActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an EmulatePaymentActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.EmulatePaymentActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.EmulatePaymentActionProto} EmulatePaymentActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EmulatePaymentActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an EmulatePaymentActionProto message.
             * @function verify
             * @memberof waiternow.common.EmulatePaymentActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            EmulatePaymentActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates an EmulatePaymentActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.EmulatePaymentActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.EmulatePaymentActionProto} EmulatePaymentActionProto
             */
            EmulatePaymentActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.EmulatePaymentActionProto)
                    return object;
                return new $root.waiternow.common.EmulatePaymentActionProto();
            };

            /**
             * Creates a plain object from an EmulatePaymentActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.EmulatePaymentActionProto
             * @static
             * @param {waiternow.common.EmulatePaymentActionProto} message EmulatePaymentActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            EmulatePaymentActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this EmulatePaymentActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.EmulatePaymentActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            EmulatePaymentActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for EmulatePaymentActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.EmulatePaymentActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            EmulatePaymentActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.EmulatePaymentActionProto";
            };

            EmulatePaymentActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.EmulatePaymentActionProto
                 * @interface IRequest
                 * @property {waiternow.common.IMoneyProto|null} [subtotal] Request subtotal
                 * @property {waiternow.common.IDecimalProto|null} [tax] Request tax
                 * @property {waiternow.common.Country|null} [country] Request country
                 * @property {boolean|null} [chargeCreditCardFeeToConsumer] Request chargeCreditCardFeeToConsumer
                 * @property {waiternow.common.EmulatePaymentActionProto.Request.INonDeliveryOrder|null} [nonDeliveryOrder] Request nonDeliveryOrder
                 * @property {waiternow.common.EmulatePaymentActionProto.Request.ISelfDeliveryOrder|null} [selfDeliveryOrder] Request selfDeliveryOrder
                 * @property {waiternow.common.EmulatePaymentActionProto.Request.IThirdPartyDeliveryOrder|null} [thirdPartyDeliveryOrder] Request thirdPartyDeliveryOrder
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.EmulatePaymentActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.EmulatePaymentActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request subtotal.
                 * @member {waiternow.common.IMoneyProto|null|undefined} subtotal
                 * @memberof waiternow.common.EmulatePaymentActionProto.Request
                 * @instance
                 */
                Request.prototype.subtotal = null;

                /**
                 * Request tax.
                 * @member {waiternow.common.IDecimalProto|null|undefined} tax
                 * @memberof waiternow.common.EmulatePaymentActionProto.Request
                 * @instance
                 */
                Request.prototype.tax = null;

                /**
                 * Request country.
                 * @member {waiternow.common.Country} country
                 * @memberof waiternow.common.EmulatePaymentActionProto.Request
                 * @instance
                 */
                Request.prototype.country = 0;

                /**
                 * Request chargeCreditCardFeeToConsumer.
                 * @member {boolean} chargeCreditCardFeeToConsumer
                 * @memberof waiternow.common.EmulatePaymentActionProto.Request
                 * @instance
                 */
                Request.prototype.chargeCreditCardFeeToConsumer = false;

                /**
                 * Request nonDeliveryOrder.
                 * @member {waiternow.common.EmulatePaymentActionProto.Request.INonDeliveryOrder|null|undefined} nonDeliveryOrder
                 * @memberof waiternow.common.EmulatePaymentActionProto.Request
                 * @instance
                 */
                Request.prototype.nonDeliveryOrder = null;

                /**
                 * Request selfDeliveryOrder.
                 * @member {waiternow.common.EmulatePaymentActionProto.Request.ISelfDeliveryOrder|null|undefined} selfDeliveryOrder
                 * @memberof waiternow.common.EmulatePaymentActionProto.Request
                 * @instance
                 */
                Request.prototype.selfDeliveryOrder = null;

                /**
                 * Request thirdPartyDeliveryOrder.
                 * @member {waiternow.common.EmulatePaymentActionProto.Request.IThirdPartyDeliveryOrder|null|undefined} thirdPartyDeliveryOrder
                 * @memberof waiternow.common.EmulatePaymentActionProto.Request
                 * @instance
                 */
                Request.prototype.thirdPartyDeliveryOrder = null;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * Request orderType.
                 * @member {"nonDeliveryOrder"|"selfDeliveryOrder"|"thirdPartyDeliveryOrder"|undefined} orderType
                 * @memberof waiternow.common.EmulatePaymentActionProto.Request
                 * @instance
                 */
                Object.defineProperty(Request.prototype, "orderType", {
                    get: $util.oneOfGetter($oneOfFields = ["nonDeliveryOrder", "selfDeliveryOrder", "thirdPartyDeliveryOrder"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.EmulatePaymentActionProto.Request
                 * @static
                 * @param {waiternow.common.EmulatePaymentActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.EmulatePaymentActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.EmulatePaymentActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.EmulatePaymentActionProto.Request
                 * @static
                 * @param {waiternow.common.EmulatePaymentActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.subtotal != null && Object.hasOwnProperty.call(message, "subtotal"))
                        $root.waiternow.common.MoneyProto.encode(message.subtotal, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.tax != null && Object.hasOwnProperty.call(message, "tax"))
                        $root.waiternow.common.DecimalProto.encode(message.tax, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.country != null && Object.hasOwnProperty.call(message, "country"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.country);
                    if (message.chargeCreditCardFeeToConsumer != null && Object.hasOwnProperty.call(message, "chargeCreditCardFeeToConsumer"))
                        writer.uint32(/* id 4, wireType 0 =*/32).bool(message.chargeCreditCardFeeToConsumer);
                    if (message.nonDeliveryOrder != null && Object.hasOwnProperty.call(message, "nonDeliveryOrder"))
                        $root.waiternow.common.EmulatePaymentActionProto.Request.NonDeliveryOrder.encode(message.nonDeliveryOrder, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.selfDeliveryOrder != null && Object.hasOwnProperty.call(message, "selfDeliveryOrder"))
                        $root.waiternow.common.EmulatePaymentActionProto.Request.SelfDeliveryOrder.encode(message.selfDeliveryOrder, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.thirdPartyDeliveryOrder != null && Object.hasOwnProperty.call(message, "thirdPartyDeliveryOrder"))
                        $root.waiternow.common.EmulatePaymentActionProto.Request.ThirdPartyDeliveryOrder.encode(message.thirdPartyDeliveryOrder, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.EmulatePaymentActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.EmulatePaymentActionProto.Request
                 * @static
                 * @param {waiternow.common.EmulatePaymentActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.EmulatePaymentActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.EmulatePaymentActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.EmulatePaymentActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.subtotal = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.tax = $root.waiternow.common.DecimalProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.country = reader.int32();
                                break;
                            }
                        case 4: {
                                message.chargeCreditCardFeeToConsumer = reader.bool();
                                break;
                            }
                        case 5: {
                                message.nonDeliveryOrder = $root.waiternow.common.EmulatePaymentActionProto.Request.NonDeliveryOrder.decode(reader, reader.uint32());
                                break;
                            }
                        case 6: {
                                message.selfDeliveryOrder = $root.waiternow.common.EmulatePaymentActionProto.Request.SelfDeliveryOrder.decode(reader, reader.uint32());
                                break;
                            }
                        case 7: {
                                message.thirdPartyDeliveryOrder = $root.waiternow.common.EmulatePaymentActionProto.Request.ThirdPartyDeliveryOrder.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.EmulatePaymentActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.EmulatePaymentActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.EmulatePaymentActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.subtotal != null && message.hasOwnProperty("subtotal")) {
                        var error = $root.waiternow.common.MoneyProto.verify(message.subtotal);
                        if (error)
                            return "subtotal." + error;
                    }
                    if (message.tax != null && message.hasOwnProperty("tax")) {
                        var error = $root.waiternow.common.DecimalProto.verify(message.tax);
                        if (error)
                            return "tax." + error;
                    }
                    if (message.country != null && message.hasOwnProperty("country"))
                        switch (message.country) {
                        default:
                            return "country: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.chargeCreditCardFeeToConsumer != null && message.hasOwnProperty("chargeCreditCardFeeToConsumer"))
                        if (typeof message.chargeCreditCardFeeToConsumer !== "boolean")
                            return "chargeCreditCardFeeToConsumer: boolean expected";
                    if (message.nonDeliveryOrder != null && message.hasOwnProperty("nonDeliveryOrder")) {
                        properties.orderType = 1;
                        {
                            var error = $root.waiternow.common.EmulatePaymentActionProto.Request.NonDeliveryOrder.verify(message.nonDeliveryOrder);
                            if (error)
                                return "nonDeliveryOrder." + error;
                        }
                    }
                    if (message.selfDeliveryOrder != null && message.hasOwnProperty("selfDeliveryOrder")) {
                        if (properties.orderType === 1)
                            return "orderType: multiple values";
                        properties.orderType = 1;
                        {
                            var error = $root.waiternow.common.EmulatePaymentActionProto.Request.SelfDeliveryOrder.verify(message.selfDeliveryOrder);
                            if (error)
                                return "selfDeliveryOrder." + error;
                        }
                    }
                    if (message.thirdPartyDeliveryOrder != null && message.hasOwnProperty("thirdPartyDeliveryOrder")) {
                        if (properties.orderType === 1)
                            return "orderType: multiple values";
                        properties.orderType = 1;
                        {
                            var error = $root.waiternow.common.EmulatePaymentActionProto.Request.ThirdPartyDeliveryOrder.verify(message.thirdPartyDeliveryOrder);
                            if (error)
                                return "thirdPartyDeliveryOrder." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.EmulatePaymentActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.EmulatePaymentActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.EmulatePaymentActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.EmulatePaymentActionProto.Request();
                    if (object.subtotal != null) {
                        if (typeof object.subtotal !== "object")
                            throw TypeError(".waiternow.common.EmulatePaymentActionProto.Request.subtotal: object expected");
                        message.subtotal = $root.waiternow.common.MoneyProto.fromObject(object.subtotal);
                    }
                    if (object.tax != null) {
                        if (typeof object.tax !== "object")
                            throw TypeError(".waiternow.common.EmulatePaymentActionProto.Request.tax: object expected");
                        message.tax = $root.waiternow.common.DecimalProto.fromObject(object.tax);
                    }
                    switch (object.country) {
                    default:
                        if (typeof object.country === "number") {
                            message.country = object.country;
                            break;
                        }
                        break;
                    case "COUNTRY_UNSPECIFIED":
                    case 0:
                        message.country = 0;
                        break;
                    case "UNITED_STATES":
                    case 1:
                        message.country = 1;
                        break;
                    case "MEXICO":
                    case 2:
                        message.country = 2;
                        break;
                    }
                    if (object.chargeCreditCardFeeToConsumer != null)
                        message.chargeCreditCardFeeToConsumer = Boolean(object.chargeCreditCardFeeToConsumer);
                    if (object.nonDeliveryOrder != null) {
                        if (typeof object.nonDeliveryOrder !== "object")
                            throw TypeError(".waiternow.common.EmulatePaymentActionProto.Request.nonDeliveryOrder: object expected");
                        message.nonDeliveryOrder = $root.waiternow.common.EmulatePaymentActionProto.Request.NonDeliveryOrder.fromObject(object.nonDeliveryOrder);
                    }
                    if (object.selfDeliveryOrder != null) {
                        if (typeof object.selfDeliveryOrder !== "object")
                            throw TypeError(".waiternow.common.EmulatePaymentActionProto.Request.selfDeliveryOrder: object expected");
                        message.selfDeliveryOrder = $root.waiternow.common.EmulatePaymentActionProto.Request.SelfDeliveryOrder.fromObject(object.selfDeliveryOrder);
                    }
                    if (object.thirdPartyDeliveryOrder != null) {
                        if (typeof object.thirdPartyDeliveryOrder !== "object")
                            throw TypeError(".waiternow.common.EmulatePaymentActionProto.Request.thirdPartyDeliveryOrder: object expected");
                        message.thirdPartyDeliveryOrder = $root.waiternow.common.EmulatePaymentActionProto.Request.ThirdPartyDeliveryOrder.fromObject(object.thirdPartyDeliveryOrder);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.EmulatePaymentActionProto.Request
                 * @static
                 * @param {waiternow.common.EmulatePaymentActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.subtotal = null;
                        object.tax = null;
                        object.country = options.enums === String ? "COUNTRY_UNSPECIFIED" : 0;
                        object.chargeCreditCardFeeToConsumer = false;
                    }
                    if (message.subtotal != null && message.hasOwnProperty("subtotal"))
                        object.subtotal = $root.waiternow.common.MoneyProto.toObject(message.subtotal, options);
                    if (message.tax != null && message.hasOwnProperty("tax"))
                        object.tax = $root.waiternow.common.DecimalProto.toObject(message.tax, options);
                    if (message.country != null && message.hasOwnProperty("country"))
                        object.country = options.enums === String ? $root.waiternow.common.Country[message.country] === undefined ? message.country : $root.waiternow.common.Country[message.country] : message.country;
                    if (message.chargeCreditCardFeeToConsumer != null && message.hasOwnProperty("chargeCreditCardFeeToConsumer"))
                        object.chargeCreditCardFeeToConsumer = message.chargeCreditCardFeeToConsumer;
                    if (message.nonDeliveryOrder != null && message.hasOwnProperty("nonDeliveryOrder")) {
                        object.nonDeliveryOrder = $root.waiternow.common.EmulatePaymentActionProto.Request.NonDeliveryOrder.toObject(message.nonDeliveryOrder, options);
                        if (options.oneofs)
                            object.orderType = "nonDeliveryOrder";
                    }
                    if (message.selfDeliveryOrder != null && message.hasOwnProperty("selfDeliveryOrder")) {
                        object.selfDeliveryOrder = $root.waiternow.common.EmulatePaymentActionProto.Request.SelfDeliveryOrder.toObject(message.selfDeliveryOrder, options);
                        if (options.oneofs)
                            object.orderType = "selfDeliveryOrder";
                    }
                    if (message.thirdPartyDeliveryOrder != null && message.hasOwnProperty("thirdPartyDeliveryOrder")) {
                        object.thirdPartyDeliveryOrder = $root.waiternow.common.EmulatePaymentActionProto.Request.ThirdPartyDeliveryOrder.toObject(message.thirdPartyDeliveryOrder, options);
                        if (options.oneofs)
                            object.orderType = "thirdPartyDeliveryOrder";
                    }
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.EmulatePaymentActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.EmulatePaymentActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.EmulatePaymentActionProto.Request";
                };

                Request.NonDeliveryOrder = (function() {

                    /**
                     * Properties of a NonDeliveryOrder.
                     * @memberof waiternow.common.EmulatePaymentActionProto.Request
                     * @interface INonDeliveryOrder
                     * @property {waiternow.common.IMoneyProto|null} [tip] NonDeliveryOrder tip
                     */

                    /**
                     * Constructs a new NonDeliveryOrder.
                     * @memberof waiternow.common.EmulatePaymentActionProto.Request
                     * @classdesc Represents a NonDeliveryOrder.
                     * @implements INonDeliveryOrder
                     * @constructor
                     * @param {waiternow.common.EmulatePaymentActionProto.Request.INonDeliveryOrder=} [properties] Properties to set
                     */
                    function NonDeliveryOrder(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * NonDeliveryOrder tip.
                     * @member {waiternow.common.IMoneyProto|null|undefined} tip
                     * @memberof waiternow.common.EmulatePaymentActionProto.Request.NonDeliveryOrder
                     * @instance
                     */
                    NonDeliveryOrder.prototype.tip = null;

                    /**
                     * Creates a new NonDeliveryOrder instance using the specified properties.
                     * @function create
                     * @memberof waiternow.common.EmulatePaymentActionProto.Request.NonDeliveryOrder
                     * @static
                     * @param {waiternow.common.EmulatePaymentActionProto.Request.INonDeliveryOrder=} [properties] Properties to set
                     * @returns {waiternow.common.EmulatePaymentActionProto.Request.NonDeliveryOrder} NonDeliveryOrder instance
                     */
                    NonDeliveryOrder.create = function create(properties) {
                        return new NonDeliveryOrder(properties);
                    };

                    /**
                     * Encodes the specified NonDeliveryOrder message. Does not implicitly {@link waiternow.common.EmulatePaymentActionProto.Request.NonDeliveryOrder.verify|verify} messages.
                     * @function encode
                     * @memberof waiternow.common.EmulatePaymentActionProto.Request.NonDeliveryOrder
                     * @static
                     * @param {waiternow.common.EmulatePaymentActionProto.Request.INonDeliveryOrder} message NonDeliveryOrder message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    NonDeliveryOrder.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.tip != null && Object.hasOwnProperty.call(message, "tip"))
                            $root.waiternow.common.MoneyProto.encode(message.tip, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };

                    /**
                     * Encodes the specified NonDeliveryOrder message, length delimited. Does not implicitly {@link waiternow.common.EmulatePaymentActionProto.Request.NonDeliveryOrder.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof waiternow.common.EmulatePaymentActionProto.Request.NonDeliveryOrder
                     * @static
                     * @param {waiternow.common.EmulatePaymentActionProto.Request.INonDeliveryOrder} message NonDeliveryOrder message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    NonDeliveryOrder.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a NonDeliveryOrder message from the specified reader or buffer.
                     * @function decode
                     * @memberof waiternow.common.EmulatePaymentActionProto.Request.NonDeliveryOrder
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {waiternow.common.EmulatePaymentActionProto.Request.NonDeliveryOrder} NonDeliveryOrder
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    NonDeliveryOrder.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.EmulatePaymentActionProto.Request.NonDeliveryOrder();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.tip = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a NonDeliveryOrder message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof waiternow.common.EmulatePaymentActionProto.Request.NonDeliveryOrder
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {waiternow.common.EmulatePaymentActionProto.Request.NonDeliveryOrder} NonDeliveryOrder
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    NonDeliveryOrder.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a NonDeliveryOrder message.
                     * @function verify
                     * @memberof waiternow.common.EmulatePaymentActionProto.Request.NonDeliveryOrder
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    NonDeliveryOrder.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.tip != null && message.hasOwnProperty("tip")) {
                            var error = $root.waiternow.common.MoneyProto.verify(message.tip);
                            if (error)
                                return "tip." + error;
                        }
                        return null;
                    };

                    /**
                     * Creates a NonDeliveryOrder message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof waiternow.common.EmulatePaymentActionProto.Request.NonDeliveryOrder
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {waiternow.common.EmulatePaymentActionProto.Request.NonDeliveryOrder} NonDeliveryOrder
                     */
                    NonDeliveryOrder.fromObject = function fromObject(object) {
                        if (object instanceof $root.waiternow.common.EmulatePaymentActionProto.Request.NonDeliveryOrder)
                            return object;
                        var message = new $root.waiternow.common.EmulatePaymentActionProto.Request.NonDeliveryOrder();
                        if (object.tip != null) {
                            if (typeof object.tip !== "object")
                                throw TypeError(".waiternow.common.EmulatePaymentActionProto.Request.NonDeliveryOrder.tip: object expected");
                            message.tip = $root.waiternow.common.MoneyProto.fromObject(object.tip);
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a NonDeliveryOrder message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof waiternow.common.EmulatePaymentActionProto.Request.NonDeliveryOrder
                     * @static
                     * @param {waiternow.common.EmulatePaymentActionProto.Request.NonDeliveryOrder} message NonDeliveryOrder
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    NonDeliveryOrder.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.tip = null;
                        if (message.tip != null && message.hasOwnProperty("tip"))
                            object.tip = $root.waiternow.common.MoneyProto.toObject(message.tip, options);
                        return object;
                    };

                    /**
                     * Converts this NonDeliveryOrder to JSON.
                     * @function toJSON
                     * @memberof waiternow.common.EmulatePaymentActionProto.Request.NonDeliveryOrder
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    NonDeliveryOrder.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for NonDeliveryOrder
                     * @function getTypeUrl
                     * @memberof waiternow.common.EmulatePaymentActionProto.Request.NonDeliveryOrder
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    NonDeliveryOrder.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/waiternow.common.EmulatePaymentActionProto.Request.NonDeliveryOrder";
                    };

                    return NonDeliveryOrder;
                })();

                Request.SelfDeliveryOrder = (function() {

                    /**
                     * Properties of a SelfDeliveryOrder.
                     * @memberof waiternow.common.EmulatePaymentActionProto.Request
                     * @interface ISelfDeliveryOrder
                     * @property {waiternow.common.IMoneyProto|null} [deliveryFee] SelfDeliveryOrder deliveryFee
                     * @property {waiternow.common.IMoneyProto|null} [deliveryTip] SelfDeliveryOrder deliveryTip
                     */

                    /**
                     * Constructs a new SelfDeliveryOrder.
                     * @memberof waiternow.common.EmulatePaymentActionProto.Request
                     * @classdesc Represents a SelfDeliveryOrder.
                     * @implements ISelfDeliveryOrder
                     * @constructor
                     * @param {waiternow.common.EmulatePaymentActionProto.Request.ISelfDeliveryOrder=} [properties] Properties to set
                     */
                    function SelfDeliveryOrder(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * SelfDeliveryOrder deliveryFee.
                     * @member {waiternow.common.IMoneyProto|null|undefined} deliveryFee
                     * @memberof waiternow.common.EmulatePaymentActionProto.Request.SelfDeliveryOrder
                     * @instance
                     */
                    SelfDeliveryOrder.prototype.deliveryFee = null;

                    /**
                     * SelfDeliveryOrder deliveryTip.
                     * @member {waiternow.common.IMoneyProto|null|undefined} deliveryTip
                     * @memberof waiternow.common.EmulatePaymentActionProto.Request.SelfDeliveryOrder
                     * @instance
                     */
                    SelfDeliveryOrder.prototype.deliveryTip = null;

                    /**
                     * Creates a new SelfDeliveryOrder instance using the specified properties.
                     * @function create
                     * @memberof waiternow.common.EmulatePaymentActionProto.Request.SelfDeliveryOrder
                     * @static
                     * @param {waiternow.common.EmulatePaymentActionProto.Request.ISelfDeliveryOrder=} [properties] Properties to set
                     * @returns {waiternow.common.EmulatePaymentActionProto.Request.SelfDeliveryOrder} SelfDeliveryOrder instance
                     */
                    SelfDeliveryOrder.create = function create(properties) {
                        return new SelfDeliveryOrder(properties);
                    };

                    /**
                     * Encodes the specified SelfDeliveryOrder message. Does not implicitly {@link waiternow.common.EmulatePaymentActionProto.Request.SelfDeliveryOrder.verify|verify} messages.
                     * @function encode
                     * @memberof waiternow.common.EmulatePaymentActionProto.Request.SelfDeliveryOrder
                     * @static
                     * @param {waiternow.common.EmulatePaymentActionProto.Request.ISelfDeliveryOrder} message SelfDeliveryOrder message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SelfDeliveryOrder.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.deliveryFee != null && Object.hasOwnProperty.call(message, "deliveryFee"))
                            $root.waiternow.common.MoneyProto.encode(message.deliveryFee, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.deliveryTip != null && Object.hasOwnProperty.call(message, "deliveryTip"))
                            $root.waiternow.common.MoneyProto.encode(message.deliveryTip, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };

                    /**
                     * Encodes the specified SelfDeliveryOrder message, length delimited. Does not implicitly {@link waiternow.common.EmulatePaymentActionProto.Request.SelfDeliveryOrder.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof waiternow.common.EmulatePaymentActionProto.Request.SelfDeliveryOrder
                     * @static
                     * @param {waiternow.common.EmulatePaymentActionProto.Request.ISelfDeliveryOrder} message SelfDeliveryOrder message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SelfDeliveryOrder.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a SelfDeliveryOrder message from the specified reader or buffer.
                     * @function decode
                     * @memberof waiternow.common.EmulatePaymentActionProto.Request.SelfDeliveryOrder
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {waiternow.common.EmulatePaymentActionProto.Request.SelfDeliveryOrder} SelfDeliveryOrder
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SelfDeliveryOrder.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.EmulatePaymentActionProto.Request.SelfDeliveryOrder();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.deliveryFee = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                                    break;
                                }
                            case 2: {
                                    message.deliveryTip = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a SelfDeliveryOrder message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof waiternow.common.EmulatePaymentActionProto.Request.SelfDeliveryOrder
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {waiternow.common.EmulatePaymentActionProto.Request.SelfDeliveryOrder} SelfDeliveryOrder
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SelfDeliveryOrder.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a SelfDeliveryOrder message.
                     * @function verify
                     * @memberof waiternow.common.EmulatePaymentActionProto.Request.SelfDeliveryOrder
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SelfDeliveryOrder.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.deliveryFee != null && message.hasOwnProperty("deliveryFee")) {
                            var error = $root.waiternow.common.MoneyProto.verify(message.deliveryFee);
                            if (error)
                                return "deliveryFee." + error;
                        }
                        if (message.deliveryTip != null && message.hasOwnProperty("deliveryTip")) {
                            var error = $root.waiternow.common.MoneyProto.verify(message.deliveryTip);
                            if (error)
                                return "deliveryTip." + error;
                        }
                        return null;
                    };

                    /**
                     * Creates a SelfDeliveryOrder message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof waiternow.common.EmulatePaymentActionProto.Request.SelfDeliveryOrder
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {waiternow.common.EmulatePaymentActionProto.Request.SelfDeliveryOrder} SelfDeliveryOrder
                     */
                    SelfDeliveryOrder.fromObject = function fromObject(object) {
                        if (object instanceof $root.waiternow.common.EmulatePaymentActionProto.Request.SelfDeliveryOrder)
                            return object;
                        var message = new $root.waiternow.common.EmulatePaymentActionProto.Request.SelfDeliveryOrder();
                        if (object.deliveryFee != null) {
                            if (typeof object.deliveryFee !== "object")
                                throw TypeError(".waiternow.common.EmulatePaymentActionProto.Request.SelfDeliveryOrder.deliveryFee: object expected");
                            message.deliveryFee = $root.waiternow.common.MoneyProto.fromObject(object.deliveryFee);
                        }
                        if (object.deliveryTip != null) {
                            if (typeof object.deliveryTip !== "object")
                                throw TypeError(".waiternow.common.EmulatePaymentActionProto.Request.SelfDeliveryOrder.deliveryTip: object expected");
                            message.deliveryTip = $root.waiternow.common.MoneyProto.fromObject(object.deliveryTip);
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a SelfDeliveryOrder message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof waiternow.common.EmulatePaymentActionProto.Request.SelfDeliveryOrder
                     * @static
                     * @param {waiternow.common.EmulatePaymentActionProto.Request.SelfDeliveryOrder} message SelfDeliveryOrder
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SelfDeliveryOrder.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.deliveryFee = null;
                            object.deliveryTip = null;
                        }
                        if (message.deliveryFee != null && message.hasOwnProperty("deliveryFee"))
                            object.deliveryFee = $root.waiternow.common.MoneyProto.toObject(message.deliveryFee, options);
                        if (message.deliveryTip != null && message.hasOwnProperty("deliveryTip"))
                            object.deliveryTip = $root.waiternow.common.MoneyProto.toObject(message.deliveryTip, options);
                        return object;
                    };

                    /**
                     * Converts this SelfDeliveryOrder to JSON.
                     * @function toJSON
                     * @memberof waiternow.common.EmulatePaymentActionProto.Request.SelfDeliveryOrder
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SelfDeliveryOrder.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for SelfDeliveryOrder
                     * @function getTypeUrl
                     * @memberof waiternow.common.EmulatePaymentActionProto.Request.SelfDeliveryOrder
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    SelfDeliveryOrder.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/waiternow.common.EmulatePaymentActionProto.Request.SelfDeliveryOrder";
                    };

                    return SelfDeliveryOrder;
                })();

                Request.ThirdPartyDeliveryOrder = (function() {

                    /**
                     * Properties of a ThirdPartyDeliveryOrder.
                     * @memberof waiternow.common.EmulatePaymentActionProto.Request
                     * @interface IThirdPartyDeliveryOrder
                     * @property {waiternow.common.IMoneyProto|null} [deliveryFee] ThirdPartyDeliveryOrder deliveryFee
                     * @property {waiternow.common.IMoneyProto|null} [deliveryTip] ThirdPartyDeliveryOrder deliveryTip
                     */

                    /**
                     * Constructs a new ThirdPartyDeliveryOrder.
                     * @memberof waiternow.common.EmulatePaymentActionProto.Request
                     * @classdesc Represents a ThirdPartyDeliveryOrder.
                     * @implements IThirdPartyDeliveryOrder
                     * @constructor
                     * @param {waiternow.common.EmulatePaymentActionProto.Request.IThirdPartyDeliveryOrder=} [properties] Properties to set
                     */
                    function ThirdPartyDeliveryOrder(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * ThirdPartyDeliveryOrder deliveryFee.
                     * @member {waiternow.common.IMoneyProto|null|undefined} deliveryFee
                     * @memberof waiternow.common.EmulatePaymentActionProto.Request.ThirdPartyDeliveryOrder
                     * @instance
                     */
                    ThirdPartyDeliveryOrder.prototype.deliveryFee = null;

                    /**
                     * ThirdPartyDeliveryOrder deliveryTip.
                     * @member {waiternow.common.IMoneyProto|null|undefined} deliveryTip
                     * @memberof waiternow.common.EmulatePaymentActionProto.Request.ThirdPartyDeliveryOrder
                     * @instance
                     */
                    ThirdPartyDeliveryOrder.prototype.deliveryTip = null;

                    /**
                     * Creates a new ThirdPartyDeliveryOrder instance using the specified properties.
                     * @function create
                     * @memberof waiternow.common.EmulatePaymentActionProto.Request.ThirdPartyDeliveryOrder
                     * @static
                     * @param {waiternow.common.EmulatePaymentActionProto.Request.IThirdPartyDeliveryOrder=} [properties] Properties to set
                     * @returns {waiternow.common.EmulatePaymentActionProto.Request.ThirdPartyDeliveryOrder} ThirdPartyDeliveryOrder instance
                     */
                    ThirdPartyDeliveryOrder.create = function create(properties) {
                        return new ThirdPartyDeliveryOrder(properties);
                    };

                    /**
                     * Encodes the specified ThirdPartyDeliveryOrder message. Does not implicitly {@link waiternow.common.EmulatePaymentActionProto.Request.ThirdPartyDeliveryOrder.verify|verify} messages.
                     * @function encode
                     * @memberof waiternow.common.EmulatePaymentActionProto.Request.ThirdPartyDeliveryOrder
                     * @static
                     * @param {waiternow.common.EmulatePaymentActionProto.Request.IThirdPartyDeliveryOrder} message ThirdPartyDeliveryOrder message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ThirdPartyDeliveryOrder.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.deliveryFee != null && Object.hasOwnProperty.call(message, "deliveryFee"))
                            $root.waiternow.common.MoneyProto.encode(message.deliveryFee, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.deliveryTip != null && Object.hasOwnProperty.call(message, "deliveryTip"))
                            $root.waiternow.common.MoneyProto.encode(message.deliveryTip, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };

                    /**
                     * Encodes the specified ThirdPartyDeliveryOrder message, length delimited. Does not implicitly {@link waiternow.common.EmulatePaymentActionProto.Request.ThirdPartyDeliveryOrder.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof waiternow.common.EmulatePaymentActionProto.Request.ThirdPartyDeliveryOrder
                     * @static
                     * @param {waiternow.common.EmulatePaymentActionProto.Request.IThirdPartyDeliveryOrder} message ThirdPartyDeliveryOrder message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ThirdPartyDeliveryOrder.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a ThirdPartyDeliveryOrder message from the specified reader or buffer.
                     * @function decode
                     * @memberof waiternow.common.EmulatePaymentActionProto.Request.ThirdPartyDeliveryOrder
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {waiternow.common.EmulatePaymentActionProto.Request.ThirdPartyDeliveryOrder} ThirdPartyDeliveryOrder
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ThirdPartyDeliveryOrder.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.EmulatePaymentActionProto.Request.ThirdPartyDeliveryOrder();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.deliveryFee = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                                    break;
                                }
                            case 2: {
                                    message.deliveryTip = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a ThirdPartyDeliveryOrder message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof waiternow.common.EmulatePaymentActionProto.Request.ThirdPartyDeliveryOrder
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {waiternow.common.EmulatePaymentActionProto.Request.ThirdPartyDeliveryOrder} ThirdPartyDeliveryOrder
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ThirdPartyDeliveryOrder.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a ThirdPartyDeliveryOrder message.
                     * @function verify
                     * @memberof waiternow.common.EmulatePaymentActionProto.Request.ThirdPartyDeliveryOrder
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ThirdPartyDeliveryOrder.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.deliveryFee != null && message.hasOwnProperty("deliveryFee")) {
                            var error = $root.waiternow.common.MoneyProto.verify(message.deliveryFee);
                            if (error)
                                return "deliveryFee." + error;
                        }
                        if (message.deliveryTip != null && message.hasOwnProperty("deliveryTip")) {
                            var error = $root.waiternow.common.MoneyProto.verify(message.deliveryTip);
                            if (error)
                                return "deliveryTip." + error;
                        }
                        return null;
                    };

                    /**
                     * Creates a ThirdPartyDeliveryOrder message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof waiternow.common.EmulatePaymentActionProto.Request.ThirdPartyDeliveryOrder
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {waiternow.common.EmulatePaymentActionProto.Request.ThirdPartyDeliveryOrder} ThirdPartyDeliveryOrder
                     */
                    ThirdPartyDeliveryOrder.fromObject = function fromObject(object) {
                        if (object instanceof $root.waiternow.common.EmulatePaymentActionProto.Request.ThirdPartyDeliveryOrder)
                            return object;
                        var message = new $root.waiternow.common.EmulatePaymentActionProto.Request.ThirdPartyDeliveryOrder();
                        if (object.deliveryFee != null) {
                            if (typeof object.deliveryFee !== "object")
                                throw TypeError(".waiternow.common.EmulatePaymentActionProto.Request.ThirdPartyDeliveryOrder.deliveryFee: object expected");
                            message.deliveryFee = $root.waiternow.common.MoneyProto.fromObject(object.deliveryFee);
                        }
                        if (object.deliveryTip != null) {
                            if (typeof object.deliveryTip !== "object")
                                throw TypeError(".waiternow.common.EmulatePaymentActionProto.Request.ThirdPartyDeliveryOrder.deliveryTip: object expected");
                            message.deliveryTip = $root.waiternow.common.MoneyProto.fromObject(object.deliveryTip);
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a ThirdPartyDeliveryOrder message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof waiternow.common.EmulatePaymentActionProto.Request.ThirdPartyDeliveryOrder
                     * @static
                     * @param {waiternow.common.EmulatePaymentActionProto.Request.ThirdPartyDeliveryOrder} message ThirdPartyDeliveryOrder
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ThirdPartyDeliveryOrder.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.deliveryFee = null;
                            object.deliveryTip = null;
                        }
                        if (message.deliveryFee != null && message.hasOwnProperty("deliveryFee"))
                            object.deliveryFee = $root.waiternow.common.MoneyProto.toObject(message.deliveryFee, options);
                        if (message.deliveryTip != null && message.hasOwnProperty("deliveryTip"))
                            object.deliveryTip = $root.waiternow.common.MoneyProto.toObject(message.deliveryTip, options);
                        return object;
                    };

                    /**
                     * Converts this ThirdPartyDeliveryOrder to JSON.
                     * @function toJSON
                     * @memberof waiternow.common.EmulatePaymentActionProto.Request.ThirdPartyDeliveryOrder
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ThirdPartyDeliveryOrder.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for ThirdPartyDeliveryOrder
                     * @function getTypeUrl
                     * @memberof waiternow.common.EmulatePaymentActionProto.Request.ThirdPartyDeliveryOrder
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    ThirdPartyDeliveryOrder.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/waiternow.common.EmulatePaymentActionProto.Request.ThirdPartyDeliveryOrder";
                    };

                    return ThirdPartyDeliveryOrder;
                })();

                return Request;
            })();

            EmulatePaymentActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.EmulatePaymentActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IOrderTotalCalculationProto|null} [orderTotalCalculation] Response orderTotalCalculation
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.EmulatePaymentActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.EmulatePaymentActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.EmulatePaymentActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response orderTotalCalculation.
                 * @member {waiternow.common.IOrderTotalCalculationProto|null|undefined} orderTotalCalculation
                 * @memberof waiternow.common.EmulatePaymentActionProto.Response
                 * @instance
                 */
                Response.prototype.orderTotalCalculation = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.EmulatePaymentActionProto.Response
                 * @static
                 * @param {waiternow.common.EmulatePaymentActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.EmulatePaymentActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.EmulatePaymentActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.EmulatePaymentActionProto.Response
                 * @static
                 * @param {waiternow.common.EmulatePaymentActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.orderTotalCalculation != null && Object.hasOwnProperty.call(message, "orderTotalCalculation"))
                        $root.waiternow.common.OrderTotalCalculationProto.encode(message.orderTotalCalculation, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.EmulatePaymentActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.EmulatePaymentActionProto.Response
                 * @static
                 * @param {waiternow.common.EmulatePaymentActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.EmulatePaymentActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.EmulatePaymentActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.EmulatePaymentActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.orderTotalCalculation = $root.waiternow.common.OrderTotalCalculationProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.EmulatePaymentActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.EmulatePaymentActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.EmulatePaymentActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.orderTotalCalculation != null && message.hasOwnProperty("orderTotalCalculation")) {
                        var error = $root.waiternow.common.OrderTotalCalculationProto.verify(message.orderTotalCalculation);
                        if (error)
                            return "orderTotalCalculation." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.EmulatePaymentActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.EmulatePaymentActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.EmulatePaymentActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.EmulatePaymentActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.EmulatePaymentActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.orderTotalCalculation != null) {
                        if (typeof object.orderTotalCalculation !== "object")
                            throw TypeError(".waiternow.common.EmulatePaymentActionProto.Response.orderTotalCalculation: object expected");
                        message.orderTotalCalculation = $root.waiternow.common.OrderTotalCalculationProto.fromObject(object.orderTotalCalculation);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.EmulatePaymentActionProto.Response
                 * @static
                 * @param {waiternow.common.EmulatePaymentActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.orderTotalCalculation = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.orderTotalCalculation != null && message.hasOwnProperty("orderTotalCalculation"))
                        object.orderTotalCalculation = $root.waiternow.common.OrderTotalCalculationProto.toObject(message.orderTotalCalculation, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.EmulatePaymentActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.EmulatePaymentActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.EmulatePaymentActionProto.Response";
                };

                return Response;
            })();

            return EmulatePaymentActionProto;
        })();

        common.RegisterRemoteLogsActionProto = (function() {

            /**
             * Properties of a RegisterRemoteLogsActionProto.
             * @memberof waiternow.common
             * @interface IRegisterRemoteLogsActionProto
             */

            /**
             * Constructs a new RegisterRemoteLogsActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a RegisterRemoteLogsActionProto.
             * @implements IRegisterRemoteLogsActionProto
             * @constructor
             * @param {waiternow.common.IRegisterRemoteLogsActionProto=} [properties] Properties to set
             */
            function RegisterRemoteLogsActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new RegisterRemoteLogsActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.RegisterRemoteLogsActionProto
             * @static
             * @param {waiternow.common.IRegisterRemoteLogsActionProto=} [properties] Properties to set
             * @returns {waiternow.common.RegisterRemoteLogsActionProto} RegisterRemoteLogsActionProto instance
             */
            RegisterRemoteLogsActionProto.create = function create(properties) {
                return new RegisterRemoteLogsActionProto(properties);
            };

            /**
             * Encodes the specified RegisterRemoteLogsActionProto message. Does not implicitly {@link waiternow.common.RegisterRemoteLogsActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.RegisterRemoteLogsActionProto
             * @static
             * @param {waiternow.common.IRegisterRemoteLogsActionProto} message RegisterRemoteLogsActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RegisterRemoteLogsActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified RegisterRemoteLogsActionProto message, length delimited. Does not implicitly {@link waiternow.common.RegisterRemoteLogsActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.RegisterRemoteLogsActionProto
             * @static
             * @param {waiternow.common.IRegisterRemoteLogsActionProto} message RegisterRemoteLogsActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RegisterRemoteLogsActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a RegisterRemoteLogsActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.RegisterRemoteLogsActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.RegisterRemoteLogsActionProto} RegisterRemoteLogsActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RegisterRemoteLogsActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.RegisterRemoteLogsActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a RegisterRemoteLogsActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.RegisterRemoteLogsActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.RegisterRemoteLogsActionProto} RegisterRemoteLogsActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RegisterRemoteLogsActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a RegisterRemoteLogsActionProto message.
             * @function verify
             * @memberof waiternow.common.RegisterRemoteLogsActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            RegisterRemoteLogsActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a RegisterRemoteLogsActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.RegisterRemoteLogsActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.RegisterRemoteLogsActionProto} RegisterRemoteLogsActionProto
             */
            RegisterRemoteLogsActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.RegisterRemoteLogsActionProto)
                    return object;
                return new $root.waiternow.common.RegisterRemoteLogsActionProto();
            };

            /**
             * Creates a plain object from a RegisterRemoteLogsActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.RegisterRemoteLogsActionProto
             * @static
             * @param {waiternow.common.RegisterRemoteLogsActionProto} message RegisterRemoteLogsActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            RegisterRemoteLogsActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this RegisterRemoteLogsActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.RegisterRemoteLogsActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            RegisterRemoteLogsActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for RegisterRemoteLogsActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.RegisterRemoteLogsActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            RegisterRemoteLogsActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.RegisterRemoteLogsActionProto";
            };

            RegisterRemoteLogsActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.RegisterRemoteLogsActionProto
                 * @interface IRequest
                 * @property {Array.<waiternow.common.IRemoteLogProto>|null} [logs] Request logs
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.RegisterRemoteLogsActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.RegisterRemoteLogsActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    this.logs = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request logs.
                 * @member {Array.<waiternow.common.IRemoteLogProto>} logs
                 * @memberof waiternow.common.RegisterRemoteLogsActionProto.Request
                 * @instance
                 */
                Request.prototype.logs = $util.emptyArray;

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.RegisterRemoteLogsActionProto.Request
                 * @static
                 * @param {waiternow.common.RegisterRemoteLogsActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.RegisterRemoteLogsActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.RegisterRemoteLogsActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.RegisterRemoteLogsActionProto.Request
                 * @static
                 * @param {waiternow.common.RegisterRemoteLogsActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.logs != null && message.logs.length)
                        for (var i = 0; i < message.logs.length; ++i)
                            $root.waiternow.common.RemoteLogProto.encode(message.logs[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.RegisterRemoteLogsActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.RegisterRemoteLogsActionProto.Request
                 * @static
                 * @param {waiternow.common.RegisterRemoteLogsActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.RegisterRemoteLogsActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.RegisterRemoteLogsActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.RegisterRemoteLogsActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                if (!(message.logs && message.logs.length))
                                    message.logs = [];
                                message.logs.push($root.waiternow.common.RemoteLogProto.decode(reader, reader.uint32()));
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.RegisterRemoteLogsActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.RegisterRemoteLogsActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.RegisterRemoteLogsActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.logs != null && message.hasOwnProperty("logs")) {
                        if (!Array.isArray(message.logs))
                            return "logs: array expected";
                        for (var i = 0; i < message.logs.length; ++i) {
                            var error = $root.waiternow.common.RemoteLogProto.verify(message.logs[i]);
                            if (error)
                                return "logs." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.RegisterRemoteLogsActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.RegisterRemoteLogsActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.RegisterRemoteLogsActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.RegisterRemoteLogsActionProto.Request();
                    if (object.logs) {
                        if (!Array.isArray(object.logs))
                            throw TypeError(".waiternow.common.RegisterRemoteLogsActionProto.Request.logs: array expected");
                        message.logs = [];
                        for (var i = 0; i < object.logs.length; ++i) {
                            if (typeof object.logs[i] !== "object")
                                throw TypeError(".waiternow.common.RegisterRemoteLogsActionProto.Request.logs: object expected");
                            message.logs[i] = $root.waiternow.common.RemoteLogProto.fromObject(object.logs[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.RegisterRemoteLogsActionProto.Request
                 * @static
                 * @param {waiternow.common.RegisterRemoteLogsActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.logs = [];
                    if (message.logs && message.logs.length) {
                        object.logs = [];
                        for (var j = 0; j < message.logs.length; ++j)
                            object.logs[j] = $root.waiternow.common.RemoteLogProto.toObject(message.logs[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.RegisterRemoteLogsActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.RegisterRemoteLogsActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.RegisterRemoteLogsActionProto.Request";
                };

                return Request;
            })();

            RegisterRemoteLogsActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.RegisterRemoteLogsActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.RegisterRemoteLogsActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.RegisterRemoteLogsActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.RegisterRemoteLogsActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.RegisterRemoteLogsActionProto.Response
                 * @static
                 * @param {waiternow.common.RegisterRemoteLogsActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.RegisterRemoteLogsActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.RegisterRemoteLogsActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.RegisterRemoteLogsActionProto.Response
                 * @static
                 * @param {waiternow.common.RegisterRemoteLogsActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.RegisterRemoteLogsActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.RegisterRemoteLogsActionProto.Response
                 * @static
                 * @param {waiternow.common.RegisterRemoteLogsActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.RegisterRemoteLogsActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.RegisterRemoteLogsActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.RegisterRemoteLogsActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.RegisterRemoteLogsActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.RegisterRemoteLogsActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.RegisterRemoteLogsActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.RegisterRemoteLogsActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.RegisterRemoteLogsActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.RegisterRemoteLogsActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.RegisterRemoteLogsActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.RegisterRemoteLogsActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.RegisterRemoteLogsActionProto.Response
                 * @static
                 * @param {waiternow.common.RegisterRemoteLogsActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.RegisterRemoteLogsActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.RegisterRemoteLogsActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.RegisterRemoteLogsActionProto.Response";
                };

                return Response;
            })();

            return RegisterRemoteLogsActionProto;
        })();

        common.RegisterCriticalTempDebugInfoActionProto = (function() {

            /**
             * Properties of a RegisterCriticalTempDebugInfoActionProto.
             * @memberof waiternow.common
             * @interface IRegisterCriticalTempDebugInfoActionProto
             */

            /**
             * Constructs a new RegisterCriticalTempDebugInfoActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a RegisterCriticalTempDebugInfoActionProto.
             * @implements IRegisterCriticalTempDebugInfoActionProto
             * @constructor
             * @param {waiternow.common.IRegisterCriticalTempDebugInfoActionProto=} [properties] Properties to set
             */
            function RegisterCriticalTempDebugInfoActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new RegisterCriticalTempDebugInfoActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.RegisterCriticalTempDebugInfoActionProto
             * @static
             * @param {waiternow.common.IRegisterCriticalTempDebugInfoActionProto=} [properties] Properties to set
             * @returns {waiternow.common.RegisterCriticalTempDebugInfoActionProto} RegisterCriticalTempDebugInfoActionProto instance
             */
            RegisterCriticalTempDebugInfoActionProto.create = function create(properties) {
                return new RegisterCriticalTempDebugInfoActionProto(properties);
            };

            /**
             * Encodes the specified RegisterCriticalTempDebugInfoActionProto message. Does not implicitly {@link waiternow.common.RegisterCriticalTempDebugInfoActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.RegisterCriticalTempDebugInfoActionProto
             * @static
             * @param {waiternow.common.IRegisterCriticalTempDebugInfoActionProto} message RegisterCriticalTempDebugInfoActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RegisterCriticalTempDebugInfoActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified RegisterCriticalTempDebugInfoActionProto message, length delimited. Does not implicitly {@link waiternow.common.RegisterCriticalTempDebugInfoActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.RegisterCriticalTempDebugInfoActionProto
             * @static
             * @param {waiternow.common.IRegisterCriticalTempDebugInfoActionProto} message RegisterCriticalTempDebugInfoActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RegisterCriticalTempDebugInfoActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a RegisterCriticalTempDebugInfoActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.RegisterCriticalTempDebugInfoActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.RegisterCriticalTempDebugInfoActionProto} RegisterCriticalTempDebugInfoActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RegisterCriticalTempDebugInfoActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.RegisterCriticalTempDebugInfoActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a RegisterCriticalTempDebugInfoActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.RegisterCriticalTempDebugInfoActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.RegisterCriticalTempDebugInfoActionProto} RegisterCriticalTempDebugInfoActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RegisterCriticalTempDebugInfoActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a RegisterCriticalTempDebugInfoActionProto message.
             * @function verify
             * @memberof waiternow.common.RegisterCriticalTempDebugInfoActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            RegisterCriticalTempDebugInfoActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a RegisterCriticalTempDebugInfoActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.RegisterCriticalTempDebugInfoActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.RegisterCriticalTempDebugInfoActionProto} RegisterCriticalTempDebugInfoActionProto
             */
            RegisterCriticalTempDebugInfoActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.RegisterCriticalTempDebugInfoActionProto)
                    return object;
                return new $root.waiternow.common.RegisterCriticalTempDebugInfoActionProto();
            };

            /**
             * Creates a plain object from a RegisterCriticalTempDebugInfoActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.RegisterCriticalTempDebugInfoActionProto
             * @static
             * @param {waiternow.common.RegisterCriticalTempDebugInfoActionProto} message RegisterCriticalTempDebugInfoActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            RegisterCriticalTempDebugInfoActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this RegisterCriticalTempDebugInfoActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.RegisterCriticalTempDebugInfoActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            RegisterCriticalTempDebugInfoActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for RegisterCriticalTempDebugInfoActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.RegisterCriticalTempDebugInfoActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            RegisterCriticalTempDebugInfoActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.RegisterCriticalTempDebugInfoActionProto";
            };

            RegisterCriticalTempDebugInfoActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.RegisterCriticalTempDebugInfoActionProto
                 * @interface IRequest
                 * @property {string|null} [deviceId] Request deviceId
                 * @property {string|null} [deviceVersion] Request deviceVersion
                 * @property {string|null} [locationId] Request locationId
                 * @property {waiternow.common.DeviceProto.ClientType|null} [clientType] Request clientType
                 * @property {waiternow.common.DeviceProto.DeviceType|null} [deviceType] Request deviceType
                 * @property {string|null} [debugInfoName] Request debugInfoName
                 * @property {string|null} [debugInfoDetails] Request debugInfoDetails
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.RegisterCriticalTempDebugInfoActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.RegisterCriticalTempDebugInfoActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request deviceId.
                 * @member {string} deviceId
                 * @memberof waiternow.common.RegisterCriticalTempDebugInfoActionProto.Request
                 * @instance
                 */
                Request.prototype.deviceId = "";

                /**
                 * Request deviceVersion.
                 * @member {string} deviceVersion
                 * @memberof waiternow.common.RegisterCriticalTempDebugInfoActionProto.Request
                 * @instance
                 */
                Request.prototype.deviceVersion = "";

                /**
                 * Request locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.RegisterCriticalTempDebugInfoActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = "";

                /**
                 * Request clientType.
                 * @member {waiternow.common.DeviceProto.ClientType} clientType
                 * @memberof waiternow.common.RegisterCriticalTempDebugInfoActionProto.Request
                 * @instance
                 */
                Request.prototype.clientType = 0;

                /**
                 * Request deviceType.
                 * @member {waiternow.common.DeviceProto.DeviceType} deviceType
                 * @memberof waiternow.common.RegisterCriticalTempDebugInfoActionProto.Request
                 * @instance
                 */
                Request.prototype.deviceType = 0;

                /**
                 * Request debugInfoName.
                 * @member {string} debugInfoName
                 * @memberof waiternow.common.RegisterCriticalTempDebugInfoActionProto.Request
                 * @instance
                 */
                Request.prototype.debugInfoName = "";

                /**
                 * Request debugInfoDetails.
                 * @member {string} debugInfoDetails
                 * @memberof waiternow.common.RegisterCriticalTempDebugInfoActionProto.Request
                 * @instance
                 */
                Request.prototype.debugInfoDetails = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.RegisterCriticalTempDebugInfoActionProto.Request
                 * @static
                 * @param {waiternow.common.RegisterCriticalTempDebugInfoActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.RegisterCriticalTempDebugInfoActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.RegisterCriticalTempDebugInfoActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.RegisterCriticalTempDebugInfoActionProto.Request
                 * @static
                 * @param {waiternow.common.RegisterCriticalTempDebugInfoActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceId != null && Object.hasOwnProperty.call(message, "deviceId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.deviceId);
                    if (message.deviceVersion != null && Object.hasOwnProperty.call(message, "deviceVersion"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.deviceVersion);
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.locationId);
                    if (message.clientType != null && Object.hasOwnProperty.call(message, "clientType"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.clientType);
                    if (message.deviceType != null && Object.hasOwnProperty.call(message, "deviceType"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int32(message.deviceType);
                    if (message.debugInfoName != null && Object.hasOwnProperty.call(message, "debugInfoName"))
                        writer.uint32(/* id 6, wireType 2 =*/50).string(message.debugInfoName);
                    if (message.debugInfoDetails != null && Object.hasOwnProperty.call(message, "debugInfoDetails"))
                        writer.uint32(/* id 7, wireType 2 =*/58).string(message.debugInfoDetails);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.RegisterCriticalTempDebugInfoActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.RegisterCriticalTempDebugInfoActionProto.Request
                 * @static
                 * @param {waiternow.common.RegisterCriticalTempDebugInfoActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.RegisterCriticalTempDebugInfoActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.RegisterCriticalTempDebugInfoActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.RegisterCriticalTempDebugInfoActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceId = reader.string();
                                break;
                            }
                        case 2: {
                                message.deviceVersion = reader.string();
                                break;
                            }
                        case 3: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 4: {
                                message.clientType = reader.int32();
                                break;
                            }
                        case 5: {
                                message.deviceType = reader.int32();
                                break;
                            }
                        case 6: {
                                message.debugInfoName = reader.string();
                                break;
                            }
                        case 7: {
                                message.debugInfoDetails = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.RegisterCriticalTempDebugInfoActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.RegisterCriticalTempDebugInfoActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.RegisterCriticalTempDebugInfoActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                        if (!$util.isString(message.deviceId))
                            return "deviceId: string expected";
                    if (message.deviceVersion != null && message.hasOwnProperty("deviceVersion"))
                        if (!$util.isString(message.deviceVersion))
                            return "deviceVersion: string expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    if (message.clientType != null && message.hasOwnProperty("clientType"))
                        switch (message.clientType) {
                        default:
                            return "clientType: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.deviceType != null && message.hasOwnProperty("deviceType"))
                        switch (message.deviceType) {
                        default:
                            return "deviceType: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                            break;
                        }
                    if (message.debugInfoName != null && message.hasOwnProperty("debugInfoName"))
                        if (!$util.isString(message.debugInfoName))
                            return "debugInfoName: string expected";
                    if (message.debugInfoDetails != null && message.hasOwnProperty("debugInfoDetails"))
                        if (!$util.isString(message.debugInfoDetails))
                            return "debugInfoDetails: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.RegisterCriticalTempDebugInfoActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.RegisterCriticalTempDebugInfoActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.RegisterCriticalTempDebugInfoActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.RegisterCriticalTempDebugInfoActionProto.Request();
                    if (object.deviceId != null)
                        message.deviceId = String(object.deviceId);
                    if (object.deviceVersion != null)
                        message.deviceVersion = String(object.deviceVersion);
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    switch (object.clientType) {
                    default:
                        if (typeof object.clientType === "number") {
                            message.clientType = object.clientType;
                            break;
                        }
                        break;
                    case "CLIENT_TYPE_UNSPECIFIED":
                    case 0:
                        message.clientType = 0;
                        break;
                    case "BUSINESS":
                    case 1:
                        message.clientType = 1;
                        break;
                    case "CONSUMER":
                    case 2:
                        message.clientType = 2;
                        break;
                    }
                    switch (object.deviceType) {
                    default:
                        if (typeof object.deviceType === "number") {
                            message.deviceType = object.deviceType;
                            break;
                        }
                        break;
                    case "DEVICE_TYPE_UNSPECIFIED":
                    case 0:
                        message.deviceType = 0;
                        break;
                    case "WEB":
                    case 1:
                        message.deviceType = 1;
                        break;
                    case "ANDROID":
                    case 2:
                        message.deviceType = 2;
                        break;
                    case "APPLE":
                    case 3:
                        message.deviceType = 3;
                        break;
                    }
                    if (object.debugInfoName != null)
                        message.debugInfoName = String(object.debugInfoName);
                    if (object.debugInfoDetails != null)
                        message.debugInfoDetails = String(object.debugInfoDetails);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.RegisterCriticalTempDebugInfoActionProto.Request
                 * @static
                 * @param {waiternow.common.RegisterCriticalTempDebugInfoActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.deviceId = "";
                        object.deviceVersion = "";
                        object.locationId = "";
                        object.clientType = options.enums === String ? "CLIENT_TYPE_UNSPECIFIED" : 0;
                        object.deviceType = options.enums === String ? "DEVICE_TYPE_UNSPECIFIED" : 0;
                        object.debugInfoName = "";
                        object.debugInfoDetails = "";
                    }
                    if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                        object.deviceId = message.deviceId;
                    if (message.deviceVersion != null && message.hasOwnProperty("deviceVersion"))
                        object.deviceVersion = message.deviceVersion;
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    if (message.clientType != null && message.hasOwnProperty("clientType"))
                        object.clientType = options.enums === String ? $root.waiternow.common.DeviceProto.ClientType[message.clientType] === undefined ? message.clientType : $root.waiternow.common.DeviceProto.ClientType[message.clientType] : message.clientType;
                    if (message.deviceType != null && message.hasOwnProperty("deviceType"))
                        object.deviceType = options.enums === String ? $root.waiternow.common.DeviceProto.DeviceType[message.deviceType] === undefined ? message.deviceType : $root.waiternow.common.DeviceProto.DeviceType[message.deviceType] : message.deviceType;
                    if (message.debugInfoName != null && message.hasOwnProperty("debugInfoName"))
                        object.debugInfoName = message.debugInfoName;
                    if (message.debugInfoDetails != null && message.hasOwnProperty("debugInfoDetails"))
                        object.debugInfoDetails = message.debugInfoDetails;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.RegisterCriticalTempDebugInfoActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.RegisterCriticalTempDebugInfoActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.RegisterCriticalTempDebugInfoActionProto.Request";
                };

                return Request;
            })();

            RegisterCriticalTempDebugInfoActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.RegisterCriticalTempDebugInfoActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.RegisterCriticalTempDebugInfoActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.RegisterCriticalTempDebugInfoActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.RegisterCriticalTempDebugInfoActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.RegisterCriticalTempDebugInfoActionProto.Response
                 * @static
                 * @param {waiternow.common.RegisterCriticalTempDebugInfoActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.RegisterCriticalTempDebugInfoActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.RegisterCriticalTempDebugInfoActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.RegisterCriticalTempDebugInfoActionProto.Response
                 * @static
                 * @param {waiternow.common.RegisterCriticalTempDebugInfoActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.RegisterCriticalTempDebugInfoActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.RegisterCriticalTempDebugInfoActionProto.Response
                 * @static
                 * @param {waiternow.common.RegisterCriticalTempDebugInfoActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.RegisterCriticalTempDebugInfoActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.RegisterCriticalTempDebugInfoActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.RegisterCriticalTempDebugInfoActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.RegisterCriticalTempDebugInfoActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.RegisterCriticalTempDebugInfoActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.RegisterCriticalTempDebugInfoActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.RegisterCriticalTempDebugInfoActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.RegisterCriticalTempDebugInfoActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.RegisterCriticalTempDebugInfoActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.RegisterCriticalTempDebugInfoActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.RegisterCriticalTempDebugInfoActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.RegisterCriticalTempDebugInfoActionProto.Response
                 * @static
                 * @param {waiternow.common.RegisterCriticalTempDebugInfoActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.RegisterCriticalTempDebugInfoActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.RegisterCriticalTempDebugInfoActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.RegisterCriticalTempDebugInfoActionProto.Response";
                };

                return Response;
            })();

            return RegisterCriticalTempDebugInfoActionProto;
        })();

        common.FeedbackProto = (function() {

            /**
             * Properties of a FeedbackProto.
             * @memberof waiternow.common
             * @interface IFeedbackProto
             * @property {string|null} [id] FeedbackProto id
             * @property {google.protobuf.ITimestamp|null} [creationTime] FeedbackProto creationTime
             * @property {google.protobuf.ITimestamp|null} [lastUpdateTime] FeedbackProto lastUpdateTime
             * @property {string|null} [locationId] FeedbackProto locationId
             * @property {string|null} [userId] FeedbackProto userId
             * @property {string|null} [consumerId] FeedbackProto consumerId
             * @property {string|null} [deviceId] FeedbackProto deviceId
             * @property {string|null} [summary] FeedbackProto summary
             * @property {string|null} [description] FeedbackProto description
             * @property {waiternow.common.FeedbackProto.Target|null} [target] FeedbackProto target
             * @property {waiternow.common.FeedbackProto.Type|null} [type] FeedbackProto type
             * @property {waiternow.common.FeedbackProto.Product|null} [product] FeedbackProto product
             * @property {waiternow.common.FeedbackProto.Browser|null} [browser] FeedbackProto browser
             * @property {waiternow.common.FeedbackProto.Environment|null} [environment] FeedbackProto environment
             * @property {waiternow.common.FeedbackProto.Priority|null} [priority] FeedbackProto priority
             * @property {waiternow.common.FeedbackProto.Severity|null} [severity] FeedbackProto severity
             * @property {waiternow.common.FeedbackProto.IStatusProto|null} [status] FeedbackProto status
             * @property {Array.<waiternow.common.FeedbackProto.IReply>|null} [replies] FeedbackProto replies
             */

            /**
             * Constructs a new FeedbackProto.
             * @memberof waiternow.common
             * @classdesc Represents a FeedbackProto.
             * @implements IFeedbackProto
             * @constructor
             * @param {waiternow.common.IFeedbackProto=} [properties] Properties to set
             */
            function FeedbackProto(properties) {
                this.replies = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * FeedbackProto id.
             * @member {string} id
             * @memberof waiternow.common.FeedbackProto
             * @instance
             */
            FeedbackProto.prototype.id = "";

            /**
             * FeedbackProto creationTime.
             * @member {google.protobuf.ITimestamp|null|undefined} creationTime
             * @memberof waiternow.common.FeedbackProto
             * @instance
             */
            FeedbackProto.prototype.creationTime = null;

            /**
             * FeedbackProto lastUpdateTime.
             * @member {google.protobuf.ITimestamp|null|undefined} lastUpdateTime
             * @memberof waiternow.common.FeedbackProto
             * @instance
             */
            FeedbackProto.prototype.lastUpdateTime = null;

            /**
             * FeedbackProto locationId.
             * @member {string} locationId
             * @memberof waiternow.common.FeedbackProto
             * @instance
             */
            FeedbackProto.prototype.locationId = "";

            /**
             * FeedbackProto userId.
             * @member {string} userId
             * @memberof waiternow.common.FeedbackProto
             * @instance
             */
            FeedbackProto.prototype.userId = "";

            /**
             * FeedbackProto consumerId.
             * @member {string} consumerId
             * @memberof waiternow.common.FeedbackProto
             * @instance
             */
            FeedbackProto.prototype.consumerId = "";

            /**
             * FeedbackProto deviceId.
             * @member {string} deviceId
             * @memberof waiternow.common.FeedbackProto
             * @instance
             */
            FeedbackProto.prototype.deviceId = "";

            /**
             * FeedbackProto summary.
             * @member {string} summary
             * @memberof waiternow.common.FeedbackProto
             * @instance
             */
            FeedbackProto.prototype.summary = "";

            /**
             * FeedbackProto description.
             * @member {string} description
             * @memberof waiternow.common.FeedbackProto
             * @instance
             */
            FeedbackProto.prototype.description = "";

            /**
             * FeedbackProto target.
             * @member {waiternow.common.FeedbackProto.Target} target
             * @memberof waiternow.common.FeedbackProto
             * @instance
             */
            FeedbackProto.prototype.target = 0;

            /**
             * FeedbackProto type.
             * @member {waiternow.common.FeedbackProto.Type} type
             * @memberof waiternow.common.FeedbackProto
             * @instance
             */
            FeedbackProto.prototype.type = 0;

            /**
             * FeedbackProto product.
             * @member {waiternow.common.FeedbackProto.Product} product
             * @memberof waiternow.common.FeedbackProto
             * @instance
             */
            FeedbackProto.prototype.product = 0;

            /**
             * FeedbackProto browser.
             * @member {waiternow.common.FeedbackProto.Browser} browser
             * @memberof waiternow.common.FeedbackProto
             * @instance
             */
            FeedbackProto.prototype.browser = 0;

            /**
             * FeedbackProto environment.
             * @member {waiternow.common.FeedbackProto.Environment} environment
             * @memberof waiternow.common.FeedbackProto
             * @instance
             */
            FeedbackProto.prototype.environment = 0;

            /**
             * FeedbackProto priority.
             * @member {waiternow.common.FeedbackProto.Priority} priority
             * @memberof waiternow.common.FeedbackProto
             * @instance
             */
            FeedbackProto.prototype.priority = 0;

            /**
             * FeedbackProto severity.
             * @member {waiternow.common.FeedbackProto.Severity} severity
             * @memberof waiternow.common.FeedbackProto
             * @instance
             */
            FeedbackProto.prototype.severity = 0;

            /**
             * FeedbackProto status.
             * @member {waiternow.common.FeedbackProto.IStatusProto|null|undefined} status
             * @memberof waiternow.common.FeedbackProto
             * @instance
             */
            FeedbackProto.prototype.status = null;

            /**
             * FeedbackProto replies.
             * @member {Array.<waiternow.common.FeedbackProto.IReply>} replies
             * @memberof waiternow.common.FeedbackProto
             * @instance
             */
            FeedbackProto.prototype.replies = $util.emptyArray;

            /**
             * Creates a new FeedbackProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FeedbackProto
             * @static
             * @param {waiternow.common.IFeedbackProto=} [properties] Properties to set
             * @returns {waiternow.common.FeedbackProto} FeedbackProto instance
             */
            FeedbackProto.create = function create(properties) {
                return new FeedbackProto(properties);
            };

            /**
             * Encodes the specified FeedbackProto message. Does not implicitly {@link waiternow.common.FeedbackProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FeedbackProto
             * @static
             * @param {waiternow.common.IFeedbackProto} message FeedbackProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FeedbackProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                if (message.creationTime != null && Object.hasOwnProperty.call(message, "creationTime"))
                    $root.google.protobuf.Timestamp.encode(message.creationTime, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                    $root.google.protobuf.Timestamp.encode(message.lastUpdateTime, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.locationId);
                if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.userId);
                if (message.consumerId != null && Object.hasOwnProperty.call(message, "consumerId"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.consumerId);
                if (message.deviceId != null && Object.hasOwnProperty.call(message, "deviceId"))
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.deviceId);
                if (message.summary != null && Object.hasOwnProperty.call(message, "summary"))
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.summary);
                if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                    writer.uint32(/* id 9, wireType 2 =*/74).string(message.description);
                if (message.target != null && Object.hasOwnProperty.call(message, "target"))
                    writer.uint32(/* id 10, wireType 0 =*/80).int32(message.target);
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 11, wireType 0 =*/88).int32(message.type);
                if (message.product != null && Object.hasOwnProperty.call(message, "product"))
                    writer.uint32(/* id 12, wireType 0 =*/96).int32(message.product);
                if (message.browser != null && Object.hasOwnProperty.call(message, "browser"))
                    writer.uint32(/* id 13, wireType 0 =*/104).int32(message.browser);
                if (message.environment != null && Object.hasOwnProperty.call(message, "environment"))
                    writer.uint32(/* id 14, wireType 0 =*/112).int32(message.environment);
                if (message.priority != null && Object.hasOwnProperty.call(message, "priority"))
                    writer.uint32(/* id 15, wireType 0 =*/120).int32(message.priority);
                if (message.severity != null && Object.hasOwnProperty.call(message, "severity"))
                    writer.uint32(/* id 16, wireType 0 =*/128).int32(message.severity);
                if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                    $root.waiternow.common.FeedbackProto.StatusProto.encode(message.status, writer.uint32(/* id 17, wireType 2 =*/138).fork()).ldelim();
                if (message.replies != null && message.replies.length)
                    for (var i = 0; i < message.replies.length; ++i)
                        $root.waiternow.common.FeedbackProto.Reply.encode(message.replies[i], writer.uint32(/* id 18, wireType 2 =*/146).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified FeedbackProto message, length delimited. Does not implicitly {@link waiternow.common.FeedbackProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FeedbackProto
             * @static
             * @param {waiternow.common.IFeedbackProto} message FeedbackProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FeedbackProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FeedbackProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FeedbackProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FeedbackProto} FeedbackProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FeedbackProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FeedbackProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.id = reader.string();
                            break;
                        }
                    case 2: {
                            message.creationTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 3: {
                            message.lastUpdateTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 4: {
                            message.locationId = reader.string();
                            break;
                        }
                    case 5: {
                            message.userId = reader.string();
                            break;
                        }
                    case 6: {
                            message.consumerId = reader.string();
                            break;
                        }
                    case 7: {
                            message.deviceId = reader.string();
                            break;
                        }
                    case 8: {
                            message.summary = reader.string();
                            break;
                        }
                    case 9: {
                            message.description = reader.string();
                            break;
                        }
                    case 10: {
                            message.target = reader.int32();
                            break;
                        }
                    case 11: {
                            message.type = reader.int32();
                            break;
                        }
                    case 12: {
                            message.product = reader.int32();
                            break;
                        }
                    case 13: {
                            message.browser = reader.int32();
                            break;
                        }
                    case 14: {
                            message.environment = reader.int32();
                            break;
                        }
                    case 15: {
                            message.priority = reader.int32();
                            break;
                        }
                    case 16: {
                            message.severity = reader.int32();
                            break;
                        }
                    case 17: {
                            message.status = $root.waiternow.common.FeedbackProto.StatusProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 18: {
                            if (!(message.replies && message.replies.length))
                                message.replies = [];
                            message.replies.push($root.waiternow.common.FeedbackProto.Reply.decode(reader, reader.uint32()));
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FeedbackProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FeedbackProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FeedbackProto} FeedbackProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FeedbackProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FeedbackProto message.
             * @function verify
             * @memberof waiternow.common.FeedbackProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FeedbackProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.id != null && message.hasOwnProperty("id"))
                    if (!$util.isString(message.id))
                        return "id: string expected";
                if (message.creationTime != null && message.hasOwnProperty("creationTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.creationTime);
                    if (error)
                        return "creationTime." + error;
                }
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.lastUpdateTime);
                    if (error)
                        return "lastUpdateTime." + error;
                }
                if (message.locationId != null && message.hasOwnProperty("locationId"))
                    if (!$util.isString(message.locationId))
                        return "locationId: string expected";
                if (message.userId != null && message.hasOwnProperty("userId"))
                    if (!$util.isString(message.userId))
                        return "userId: string expected";
                if (message.consumerId != null && message.hasOwnProperty("consumerId"))
                    if (!$util.isString(message.consumerId))
                        return "consumerId: string expected";
                if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                    if (!$util.isString(message.deviceId))
                        return "deviceId: string expected";
                if (message.summary != null && message.hasOwnProperty("summary"))
                    if (!$util.isString(message.summary))
                        return "summary: string expected";
                if (message.description != null && message.hasOwnProperty("description"))
                    if (!$util.isString(message.description))
                        return "description: string expected";
                if (message.target != null && message.hasOwnProperty("target"))
                    switch (message.target) {
                    default:
                        return "target: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                        break;
                    }
                if (message.type != null && message.hasOwnProperty("type"))
                    switch (message.type) {
                    default:
                        return "type: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                        break;
                    }
                if (message.product != null && message.hasOwnProperty("product"))
                    switch (message.product) {
                    default:
                        return "product: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                        break;
                    }
                if (message.browser != null && message.hasOwnProperty("browser"))
                    switch (message.browser) {
                    default:
                        return "browser: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                        break;
                    }
                if (message.environment != null && message.hasOwnProperty("environment"))
                    switch (message.environment) {
                    default:
                        return "environment: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                        break;
                    }
                if (message.priority != null && message.hasOwnProperty("priority"))
                    switch (message.priority) {
                    default:
                        return "priority: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                        break;
                    }
                if (message.severity != null && message.hasOwnProperty("severity"))
                    switch (message.severity) {
                    default:
                        return "severity: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                        break;
                    }
                if (message.status != null && message.hasOwnProperty("status")) {
                    var error = $root.waiternow.common.FeedbackProto.StatusProto.verify(message.status);
                    if (error)
                        return "status." + error;
                }
                if (message.replies != null && message.hasOwnProperty("replies")) {
                    if (!Array.isArray(message.replies))
                        return "replies: array expected";
                    for (var i = 0; i < message.replies.length; ++i) {
                        var error = $root.waiternow.common.FeedbackProto.Reply.verify(message.replies[i]);
                        if (error)
                            return "replies." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a FeedbackProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FeedbackProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FeedbackProto} FeedbackProto
             */
            FeedbackProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FeedbackProto)
                    return object;
                var message = new $root.waiternow.common.FeedbackProto();
                if (object.id != null)
                    message.id = String(object.id);
                if (object.creationTime != null) {
                    if (typeof object.creationTime !== "object")
                        throw TypeError(".waiternow.common.FeedbackProto.creationTime: object expected");
                    message.creationTime = $root.google.protobuf.Timestamp.fromObject(object.creationTime);
                }
                if (object.lastUpdateTime != null) {
                    if (typeof object.lastUpdateTime !== "object")
                        throw TypeError(".waiternow.common.FeedbackProto.lastUpdateTime: object expected");
                    message.lastUpdateTime = $root.google.protobuf.Timestamp.fromObject(object.lastUpdateTime);
                }
                if (object.locationId != null)
                    message.locationId = String(object.locationId);
                if (object.userId != null)
                    message.userId = String(object.userId);
                if (object.consumerId != null)
                    message.consumerId = String(object.consumerId);
                if (object.deviceId != null)
                    message.deviceId = String(object.deviceId);
                if (object.summary != null)
                    message.summary = String(object.summary);
                if (object.description != null)
                    message.description = String(object.description);
                switch (object.target) {
                default:
                    if (typeof object.target === "number") {
                        message.target = object.target;
                        break;
                    }
                    break;
                case "TARGET_UNSPECIFIED":
                case 0:
                    message.target = 0;
                    break;
                case "PLATFORM":
                case 1:
                    message.target = 1;
                    break;
                case "BUSINESS":
                case 2:
                    message.target = 2;
                    break;
                }
                switch (object.type) {
                default:
                    if (typeof object.type === "number") {
                        message.type = object.type;
                        break;
                    }
                    break;
                case "TYPE_UNSPECIFIED":
                case 0:
                    message.type = 0;
                    break;
                case "FEATURE_REQUEST":
                case 1:
                    message.type = 1;
                    break;
                case "ISSUE":
                case 2:
                    message.type = 2;
                    break;
                }
                switch (object.product) {
                default:
                    if (typeof object.product === "number") {
                        message.product = object.product;
                        break;
                    }
                    break;
                case "PRODUCT_UNSPECIFIED":
                case 0:
                    message.product = 0;
                    break;
                case "CONSUMER_APP_WEB":
                case 1:
                    message.product = 1;
                    break;
                case "BUSINESS_APP_WEB":
                case 2:
                    message.product = 2;
                    break;
                case "BUSINESS_APP_ANDROID":
                case 3:
                    message.product = 3;
                    break;
                case "ADMIN_APP_WEB":
                case 4:
                    message.product = 4;
                    break;
                case "GSHEET_MENU_EDITOR_WEB":
                case 5:
                    message.product = 5;
                    break;
                }
                switch (object.browser) {
                default:
                    if (typeof object.browser === "number") {
                        message.browser = object.browser;
                        break;
                    }
                    break;
                case "BROWSER_UNSPECIFIED":
                case 0:
                    message.browser = 0;
                    break;
                case "CHROME":
                case 1:
                    message.browser = 1;
                    break;
                case "FIREFOX":
                case 2:
                    message.browser = 2;
                    break;
                case "SAFARI":
                case 3:
                    message.browser = 3;
                    break;
                }
                switch (object.environment) {
                default:
                    if (typeof object.environment === "number") {
                        message.environment = object.environment;
                        break;
                    }
                    break;
                case "ENVIRONMENT_UNSPECIFIED":
                case 0:
                    message.environment = 0;
                    break;
                case "LINUX":
                case 1:
                    message.environment = 1;
                    break;
                case "WINDOWS":
                case 2:
                    message.environment = 2;
                    break;
                case "MAC":
                case 3:
                    message.environment = 3;
                    break;
                case "ANDROID":
                case 4:
                    message.environment = 4;
                    break;
                case "IOS":
                case 5:
                    message.environment = 5;
                    break;
                }
                switch (object.priority) {
                default:
                    if (typeof object.priority === "number") {
                        message.priority = object.priority;
                        break;
                    }
                    break;
                case "PRIORITY_UNSPECIFIED":
                case 0:
                    message.priority = 0;
                    break;
                case "P0":
                case 1:
                    message.priority = 1;
                    break;
                case "P1":
                case 2:
                    message.priority = 2;
                    break;
                case "P2":
                case 3:
                    message.priority = 3;
                    break;
                case "P3":
                case 4:
                    message.priority = 4;
                    break;
                }
                switch (object.severity) {
                default:
                    if (typeof object.severity === "number") {
                        message.severity = object.severity;
                        break;
                    }
                    break;
                case "SEVERITY_UNSPECIFIED":
                case 0:
                    message.severity = 0;
                    break;
                case "LOW":
                case 1:
                    message.severity = 1;
                    break;
                case "MEDIUM":
                case 2:
                    message.severity = 2;
                    break;
                case "HIGH":
                case 3:
                    message.severity = 3;
                    break;
                case "CRITICAL":
                case 4:
                    message.severity = 4;
                    break;
                }
                if (object.status != null) {
                    if (typeof object.status !== "object")
                        throw TypeError(".waiternow.common.FeedbackProto.status: object expected");
                    message.status = $root.waiternow.common.FeedbackProto.StatusProto.fromObject(object.status);
                }
                if (object.replies) {
                    if (!Array.isArray(object.replies))
                        throw TypeError(".waiternow.common.FeedbackProto.replies: array expected");
                    message.replies = [];
                    for (var i = 0; i < object.replies.length; ++i) {
                        if (typeof object.replies[i] !== "object")
                            throw TypeError(".waiternow.common.FeedbackProto.replies: object expected");
                        message.replies[i] = $root.waiternow.common.FeedbackProto.Reply.fromObject(object.replies[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a FeedbackProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FeedbackProto
             * @static
             * @param {waiternow.common.FeedbackProto} message FeedbackProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FeedbackProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.replies = [];
                if (options.defaults) {
                    object.id = "";
                    object.creationTime = null;
                    object.lastUpdateTime = null;
                    object.locationId = "";
                    object.userId = "";
                    object.consumerId = "";
                    object.deviceId = "";
                    object.summary = "";
                    object.description = "";
                    object.target = options.enums === String ? "TARGET_UNSPECIFIED" : 0;
                    object.type = options.enums === String ? "TYPE_UNSPECIFIED" : 0;
                    object.product = options.enums === String ? "PRODUCT_UNSPECIFIED" : 0;
                    object.browser = options.enums === String ? "BROWSER_UNSPECIFIED" : 0;
                    object.environment = options.enums === String ? "ENVIRONMENT_UNSPECIFIED" : 0;
                    object.priority = options.enums === String ? "PRIORITY_UNSPECIFIED" : 0;
                    object.severity = options.enums === String ? "SEVERITY_UNSPECIFIED" : 0;
                    object.status = null;
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                    object.creationTime = $root.google.protobuf.Timestamp.toObject(message.creationTime, options);
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                    object.lastUpdateTime = $root.google.protobuf.Timestamp.toObject(message.lastUpdateTime, options);
                if (message.locationId != null && message.hasOwnProperty("locationId"))
                    object.locationId = message.locationId;
                if (message.userId != null && message.hasOwnProperty("userId"))
                    object.userId = message.userId;
                if (message.consumerId != null && message.hasOwnProperty("consumerId"))
                    object.consumerId = message.consumerId;
                if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                    object.deviceId = message.deviceId;
                if (message.summary != null && message.hasOwnProperty("summary"))
                    object.summary = message.summary;
                if (message.description != null && message.hasOwnProperty("description"))
                    object.description = message.description;
                if (message.target != null && message.hasOwnProperty("target"))
                    object.target = options.enums === String ? $root.waiternow.common.FeedbackProto.Target[message.target] === undefined ? message.target : $root.waiternow.common.FeedbackProto.Target[message.target] : message.target;
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = options.enums === String ? $root.waiternow.common.FeedbackProto.Type[message.type] === undefined ? message.type : $root.waiternow.common.FeedbackProto.Type[message.type] : message.type;
                if (message.product != null && message.hasOwnProperty("product"))
                    object.product = options.enums === String ? $root.waiternow.common.FeedbackProto.Product[message.product] === undefined ? message.product : $root.waiternow.common.FeedbackProto.Product[message.product] : message.product;
                if (message.browser != null && message.hasOwnProperty("browser"))
                    object.browser = options.enums === String ? $root.waiternow.common.FeedbackProto.Browser[message.browser] === undefined ? message.browser : $root.waiternow.common.FeedbackProto.Browser[message.browser] : message.browser;
                if (message.environment != null && message.hasOwnProperty("environment"))
                    object.environment = options.enums === String ? $root.waiternow.common.FeedbackProto.Environment[message.environment] === undefined ? message.environment : $root.waiternow.common.FeedbackProto.Environment[message.environment] : message.environment;
                if (message.priority != null && message.hasOwnProperty("priority"))
                    object.priority = options.enums === String ? $root.waiternow.common.FeedbackProto.Priority[message.priority] === undefined ? message.priority : $root.waiternow.common.FeedbackProto.Priority[message.priority] : message.priority;
                if (message.severity != null && message.hasOwnProperty("severity"))
                    object.severity = options.enums === String ? $root.waiternow.common.FeedbackProto.Severity[message.severity] === undefined ? message.severity : $root.waiternow.common.FeedbackProto.Severity[message.severity] : message.severity;
                if (message.status != null && message.hasOwnProperty("status"))
                    object.status = $root.waiternow.common.FeedbackProto.StatusProto.toObject(message.status, options);
                if (message.replies && message.replies.length) {
                    object.replies = [];
                    for (var j = 0; j < message.replies.length; ++j)
                        object.replies[j] = $root.waiternow.common.FeedbackProto.Reply.toObject(message.replies[j], options);
                }
                return object;
            };

            /**
             * Converts this FeedbackProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FeedbackProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FeedbackProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FeedbackProto
             * @function getTypeUrl
             * @memberof waiternow.common.FeedbackProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FeedbackProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FeedbackProto";
            };

            /**
             * Target enum.
             * @name waiternow.common.FeedbackProto.Target
             * @enum {number}
             * @property {number} TARGET_UNSPECIFIED=0 TARGET_UNSPECIFIED value
             * @property {number} PLATFORM=1 PLATFORM value
             * @property {number} BUSINESS=2 BUSINESS value
             */
            FeedbackProto.Target = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "TARGET_UNSPECIFIED"] = 0;
                values[valuesById[1] = "PLATFORM"] = 1;
                values[valuesById[2] = "BUSINESS"] = 2;
                return values;
            })();

            /**
             * Type enum.
             * @name waiternow.common.FeedbackProto.Type
             * @enum {number}
             * @property {number} TYPE_UNSPECIFIED=0 TYPE_UNSPECIFIED value
             * @property {number} FEATURE_REQUEST=1 FEATURE_REQUEST value
             * @property {number} ISSUE=2 ISSUE value
             */
            FeedbackProto.Type = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "TYPE_UNSPECIFIED"] = 0;
                values[valuesById[1] = "FEATURE_REQUEST"] = 1;
                values[valuesById[2] = "ISSUE"] = 2;
                return values;
            })();

            /**
             * Product enum.
             * @name waiternow.common.FeedbackProto.Product
             * @enum {number}
             * @property {number} PRODUCT_UNSPECIFIED=0 PRODUCT_UNSPECIFIED value
             * @property {number} CONSUMER_APP_WEB=1 CONSUMER_APP_WEB value
             * @property {number} BUSINESS_APP_WEB=2 BUSINESS_APP_WEB value
             * @property {number} BUSINESS_APP_ANDROID=3 BUSINESS_APP_ANDROID value
             * @property {number} ADMIN_APP_WEB=4 ADMIN_APP_WEB value
             * @property {number} GSHEET_MENU_EDITOR_WEB=5 GSHEET_MENU_EDITOR_WEB value
             */
            FeedbackProto.Product = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "PRODUCT_UNSPECIFIED"] = 0;
                values[valuesById[1] = "CONSUMER_APP_WEB"] = 1;
                values[valuesById[2] = "BUSINESS_APP_WEB"] = 2;
                values[valuesById[3] = "BUSINESS_APP_ANDROID"] = 3;
                values[valuesById[4] = "ADMIN_APP_WEB"] = 4;
                values[valuesById[5] = "GSHEET_MENU_EDITOR_WEB"] = 5;
                return values;
            })();

            /**
             * Browser enum.
             * @name waiternow.common.FeedbackProto.Browser
             * @enum {number}
             * @property {number} BROWSER_UNSPECIFIED=0 BROWSER_UNSPECIFIED value
             * @property {number} CHROME=1 CHROME value
             * @property {number} FIREFOX=2 FIREFOX value
             * @property {number} SAFARI=3 SAFARI value
             */
            FeedbackProto.Browser = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "BROWSER_UNSPECIFIED"] = 0;
                values[valuesById[1] = "CHROME"] = 1;
                values[valuesById[2] = "FIREFOX"] = 2;
                values[valuesById[3] = "SAFARI"] = 3;
                return values;
            })();

            /**
             * Environment enum.
             * @name waiternow.common.FeedbackProto.Environment
             * @enum {number}
             * @property {number} ENVIRONMENT_UNSPECIFIED=0 ENVIRONMENT_UNSPECIFIED value
             * @property {number} LINUX=1 LINUX value
             * @property {number} WINDOWS=2 WINDOWS value
             * @property {number} MAC=3 MAC value
             * @property {number} ANDROID=4 ANDROID value
             * @property {number} IOS=5 IOS value
             */
            FeedbackProto.Environment = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "ENVIRONMENT_UNSPECIFIED"] = 0;
                values[valuesById[1] = "LINUX"] = 1;
                values[valuesById[2] = "WINDOWS"] = 2;
                values[valuesById[3] = "MAC"] = 3;
                values[valuesById[4] = "ANDROID"] = 4;
                values[valuesById[5] = "IOS"] = 5;
                return values;
            })();

            /**
             * Priority enum.
             * @name waiternow.common.FeedbackProto.Priority
             * @enum {number}
             * @property {number} PRIORITY_UNSPECIFIED=0 PRIORITY_UNSPECIFIED value
             * @property {number} P0=1 P0 value
             * @property {number} P1=2 P1 value
             * @property {number} P2=3 P2 value
             * @property {number} P3=4 P3 value
             */
            FeedbackProto.Priority = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "PRIORITY_UNSPECIFIED"] = 0;
                values[valuesById[1] = "P0"] = 1;
                values[valuesById[2] = "P1"] = 2;
                values[valuesById[3] = "P2"] = 3;
                values[valuesById[4] = "P3"] = 4;
                return values;
            })();

            /**
             * Severity enum.
             * @name waiternow.common.FeedbackProto.Severity
             * @enum {number}
             * @property {number} SEVERITY_UNSPECIFIED=0 SEVERITY_UNSPECIFIED value
             * @property {number} LOW=1 LOW value
             * @property {number} MEDIUM=2 MEDIUM value
             * @property {number} HIGH=3 HIGH value
             * @property {number} CRITICAL=4 CRITICAL value
             */
            FeedbackProto.Severity = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "SEVERITY_UNSPECIFIED"] = 0;
                values[valuesById[1] = "LOW"] = 1;
                values[valuesById[2] = "MEDIUM"] = 2;
                values[valuesById[3] = "HIGH"] = 3;
                values[valuesById[4] = "CRITICAL"] = 4;
                return values;
            })();

            FeedbackProto.StatusProto = (function() {

                /**
                 * Properties of a StatusProto.
                 * @memberof waiternow.common.FeedbackProto
                 * @interface IStatusProto
                 * @property {waiternow.common.FeedbackProto.StatusProto.State|null} [state] StatusProto state
                 * @property {waiternow.common.FeedbackProto.StatusProto.Substate|null} [substate] StatusProto substate
                 * @property {string|null} [duplicateOfId] StatusProto duplicateOfId
                 */

                /**
                 * Constructs a new StatusProto.
                 * @memberof waiternow.common.FeedbackProto
                 * @classdesc Represents a StatusProto.
                 * @implements IStatusProto
                 * @constructor
                 * @param {waiternow.common.FeedbackProto.IStatusProto=} [properties] Properties to set
                 */
                function StatusProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StatusProto state.
                 * @member {waiternow.common.FeedbackProto.StatusProto.State} state
                 * @memberof waiternow.common.FeedbackProto.StatusProto
                 * @instance
                 */
                StatusProto.prototype.state = 0;

                /**
                 * StatusProto substate.
                 * @member {waiternow.common.FeedbackProto.StatusProto.Substate} substate
                 * @memberof waiternow.common.FeedbackProto.StatusProto
                 * @instance
                 */
                StatusProto.prototype.substate = 0;

                /**
                 * StatusProto duplicateOfId.
                 * @member {string} duplicateOfId
                 * @memberof waiternow.common.FeedbackProto.StatusProto
                 * @instance
                 */
                StatusProto.prototype.duplicateOfId = "";

                /**
                 * Creates a new StatusProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FeedbackProto.StatusProto
                 * @static
                 * @param {waiternow.common.FeedbackProto.IStatusProto=} [properties] Properties to set
                 * @returns {waiternow.common.FeedbackProto.StatusProto} StatusProto instance
                 */
                StatusProto.create = function create(properties) {
                    return new StatusProto(properties);
                };

                /**
                 * Encodes the specified StatusProto message. Does not implicitly {@link waiternow.common.FeedbackProto.StatusProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FeedbackProto.StatusProto
                 * @static
                 * @param {waiternow.common.FeedbackProto.IStatusProto} message StatusProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StatusProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.state);
                    if (message.substate != null && Object.hasOwnProperty.call(message, "substate"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.substate);
                    if (message.duplicateOfId != null && Object.hasOwnProperty.call(message, "duplicateOfId"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.duplicateOfId);
                    return writer;
                };

                /**
                 * Encodes the specified StatusProto message, length delimited. Does not implicitly {@link waiternow.common.FeedbackProto.StatusProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FeedbackProto.StatusProto
                 * @static
                 * @param {waiternow.common.FeedbackProto.IStatusProto} message StatusProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StatusProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a StatusProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FeedbackProto.StatusProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FeedbackProto.StatusProto} StatusProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StatusProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FeedbackProto.StatusProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.state = reader.int32();
                                break;
                            }
                        case 2: {
                                message.substate = reader.int32();
                                break;
                            }
                        case 3: {
                                message.duplicateOfId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a StatusProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FeedbackProto.StatusProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FeedbackProto.StatusProto} StatusProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StatusProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StatusProto message.
                 * @function verify
                 * @memberof waiternow.common.FeedbackProto.StatusProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StatusProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.state != null && message.hasOwnProperty("state"))
                        switch (message.state) {
                        default:
                            return "state: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                            break;
                        }
                    if (message.substate != null && message.hasOwnProperty("substate"))
                        switch (message.substate) {
                        default:
                            return "substate: enum value expected";
                        case 0:
                        case 4:
                        case 5:
                        case 6:
                        case 7:
                            break;
                        }
                    if (message.duplicateOfId != null && message.hasOwnProperty("duplicateOfId"))
                        if (!$util.isString(message.duplicateOfId))
                            return "duplicateOfId: string expected";
                    return null;
                };

                /**
                 * Creates a StatusProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FeedbackProto.StatusProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FeedbackProto.StatusProto} StatusProto
                 */
                StatusProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FeedbackProto.StatusProto)
                        return object;
                    var message = new $root.waiternow.common.FeedbackProto.StatusProto();
                    switch (object.state) {
                    default:
                        if (typeof object.state === "number") {
                            message.state = object.state;
                            break;
                        }
                        break;
                    case "STATE_UNSPECIFIED":
                    case 0:
                        message.state = 0;
                        break;
                    case "NEW":
                    case 1:
                        message.state = 1;
                        break;
                    case "IN_PROGRESS":
                    case 2:
                        message.state = 2;
                        break;
                    case "FIXED":
                    case 3:
                        message.state = 3;
                        break;
                    case "WONT_FIX":
                    case 4:
                        message.state = 4;
                        break;
                    }
                    switch (object.substate) {
                    default:
                        if (typeof object.substate === "number") {
                            message.substate = object.substate;
                            break;
                        }
                        break;
                    case "SUBSTATE_UNSPECIFIED":
                    case 0:
                        message.substate = 0;
                        break;
                    case "WONT_FIX_DUPLICATE":
                    case 4:
                        message.substate = 4;
                        break;
                    case "WONT_FIX_NOT_REPRODUCIBLE":
                    case 5:
                        message.substate = 5;
                        break;
                    case "WONT_FIX_OBSOLETE":
                    case 6:
                        message.substate = 6;
                        break;
                    case "WONT_FIX_WORKING_AS_INTENDED":
                    case 7:
                        message.substate = 7;
                        break;
                    }
                    if (object.duplicateOfId != null)
                        message.duplicateOfId = String(object.duplicateOfId);
                    return message;
                };

                /**
                 * Creates a plain object from a StatusProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FeedbackProto.StatusProto
                 * @static
                 * @param {waiternow.common.FeedbackProto.StatusProto} message StatusProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StatusProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.state = options.enums === String ? "STATE_UNSPECIFIED" : 0;
                        object.substate = options.enums === String ? "SUBSTATE_UNSPECIFIED" : 0;
                        object.duplicateOfId = "";
                    }
                    if (message.state != null && message.hasOwnProperty("state"))
                        object.state = options.enums === String ? $root.waiternow.common.FeedbackProto.StatusProto.State[message.state] === undefined ? message.state : $root.waiternow.common.FeedbackProto.StatusProto.State[message.state] : message.state;
                    if (message.substate != null && message.hasOwnProperty("substate"))
                        object.substate = options.enums === String ? $root.waiternow.common.FeedbackProto.StatusProto.Substate[message.substate] === undefined ? message.substate : $root.waiternow.common.FeedbackProto.StatusProto.Substate[message.substate] : message.substate;
                    if (message.duplicateOfId != null && message.hasOwnProperty("duplicateOfId"))
                        object.duplicateOfId = message.duplicateOfId;
                    return object;
                };

                /**
                 * Converts this StatusProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FeedbackProto.StatusProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StatusProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for StatusProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.FeedbackProto.StatusProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                StatusProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FeedbackProto.StatusProto";
                };

                /**
                 * State enum.
                 * @name waiternow.common.FeedbackProto.StatusProto.State
                 * @enum {number}
                 * @property {number} STATE_UNSPECIFIED=0 STATE_UNSPECIFIED value
                 * @property {number} NEW=1 NEW value
                 * @property {number} IN_PROGRESS=2 IN_PROGRESS value
                 * @property {number} FIXED=3 FIXED value
                 * @property {number} WONT_FIX=4 WONT_FIX value
                 */
                StatusProto.State = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "STATE_UNSPECIFIED"] = 0;
                    values[valuesById[1] = "NEW"] = 1;
                    values[valuesById[2] = "IN_PROGRESS"] = 2;
                    values[valuesById[3] = "FIXED"] = 3;
                    values[valuesById[4] = "WONT_FIX"] = 4;
                    return values;
                })();

                /**
                 * Substate enum.
                 * @name waiternow.common.FeedbackProto.StatusProto.Substate
                 * @enum {number}
                 * @property {number} SUBSTATE_UNSPECIFIED=0 SUBSTATE_UNSPECIFIED value
                 * @property {number} WONT_FIX_DUPLICATE=4 WONT_FIX_DUPLICATE value
                 * @property {number} WONT_FIX_NOT_REPRODUCIBLE=5 WONT_FIX_NOT_REPRODUCIBLE value
                 * @property {number} WONT_FIX_OBSOLETE=6 WONT_FIX_OBSOLETE value
                 * @property {number} WONT_FIX_WORKING_AS_INTENDED=7 WONT_FIX_WORKING_AS_INTENDED value
                 */
                StatusProto.Substate = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "SUBSTATE_UNSPECIFIED"] = 0;
                    values[valuesById[4] = "WONT_FIX_DUPLICATE"] = 4;
                    values[valuesById[5] = "WONT_FIX_NOT_REPRODUCIBLE"] = 5;
                    values[valuesById[6] = "WONT_FIX_OBSOLETE"] = 6;
                    values[valuesById[7] = "WONT_FIX_WORKING_AS_INTENDED"] = 7;
                    return values;
                })();

                return StatusProto;
            })();

            FeedbackProto.Reply = (function() {

                /**
                 * Properties of a Reply.
                 * @memberof waiternow.common.FeedbackProto
                 * @interface IReply
                 * @property {string|null} [repliedById] Reply repliedById
                 * @property {string|null} [repliedByEmail] Reply repliedByEmail
                 * @property {string|null} [repliedByName] Reply repliedByName
                 * @property {google.protobuf.ITimestamp|null} [timestamp] Reply timestamp
                 * @property {string|null} [message] Reply message
                 */

                /**
                 * Constructs a new Reply.
                 * @memberof waiternow.common.FeedbackProto
                 * @classdesc Represents a Reply.
                 * @implements IReply
                 * @constructor
                 * @param {waiternow.common.FeedbackProto.IReply=} [properties] Properties to set
                 */
                function Reply(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Reply repliedById.
                 * @member {string} repliedById
                 * @memberof waiternow.common.FeedbackProto.Reply
                 * @instance
                 */
                Reply.prototype.repliedById = "";

                /**
                 * Reply repliedByEmail.
                 * @member {string} repliedByEmail
                 * @memberof waiternow.common.FeedbackProto.Reply
                 * @instance
                 */
                Reply.prototype.repliedByEmail = "";

                /**
                 * Reply repliedByName.
                 * @member {string} repliedByName
                 * @memberof waiternow.common.FeedbackProto.Reply
                 * @instance
                 */
                Reply.prototype.repliedByName = "";

                /**
                 * Reply timestamp.
                 * @member {google.protobuf.ITimestamp|null|undefined} timestamp
                 * @memberof waiternow.common.FeedbackProto.Reply
                 * @instance
                 */
                Reply.prototype.timestamp = null;

                /**
                 * Reply message.
                 * @member {string} message
                 * @memberof waiternow.common.FeedbackProto.Reply
                 * @instance
                 */
                Reply.prototype.message = "";

                /**
                 * Creates a new Reply instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FeedbackProto.Reply
                 * @static
                 * @param {waiternow.common.FeedbackProto.IReply=} [properties] Properties to set
                 * @returns {waiternow.common.FeedbackProto.Reply} Reply instance
                 */
                Reply.create = function create(properties) {
                    return new Reply(properties);
                };

                /**
                 * Encodes the specified Reply message. Does not implicitly {@link waiternow.common.FeedbackProto.Reply.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FeedbackProto.Reply
                 * @static
                 * @param {waiternow.common.FeedbackProto.IReply} message Reply message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Reply.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.repliedById != null && Object.hasOwnProperty.call(message, "repliedById"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.repliedById);
                    if (message.repliedByEmail != null && Object.hasOwnProperty.call(message, "repliedByEmail"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.repliedByEmail);
                    if (message.repliedByName != null && Object.hasOwnProperty.call(message, "repliedByName"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.repliedByName);
                    if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                        $root.google.protobuf.Timestamp.encode(message.timestamp, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.message);
                    return writer;
                };

                /**
                 * Encodes the specified Reply message, length delimited. Does not implicitly {@link waiternow.common.FeedbackProto.Reply.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FeedbackProto.Reply
                 * @static
                 * @param {waiternow.common.FeedbackProto.IReply} message Reply message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Reply.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Reply message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FeedbackProto.Reply
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FeedbackProto.Reply} Reply
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Reply.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FeedbackProto.Reply();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.repliedById = reader.string();
                                break;
                            }
                        case 2: {
                                message.repliedByEmail = reader.string();
                                break;
                            }
                        case 3: {
                                message.repliedByName = reader.string();
                                break;
                            }
                        case 4: {
                                message.timestamp = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            }
                        case 5: {
                                message.message = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Reply message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FeedbackProto.Reply
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FeedbackProto.Reply} Reply
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Reply.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Reply message.
                 * @function verify
                 * @memberof waiternow.common.FeedbackProto.Reply
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Reply.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.repliedById != null && message.hasOwnProperty("repliedById"))
                        if (!$util.isString(message.repliedById))
                            return "repliedById: string expected";
                    if (message.repliedByEmail != null && message.hasOwnProperty("repliedByEmail"))
                        if (!$util.isString(message.repliedByEmail))
                            return "repliedByEmail: string expected";
                    if (message.repliedByName != null && message.hasOwnProperty("repliedByName"))
                        if (!$util.isString(message.repliedByName))
                            return "repliedByName: string expected";
                    if (message.timestamp != null && message.hasOwnProperty("timestamp")) {
                        var error = $root.google.protobuf.Timestamp.verify(message.timestamp);
                        if (error)
                            return "timestamp." + error;
                    }
                    if (message.message != null && message.hasOwnProperty("message"))
                        if (!$util.isString(message.message))
                            return "message: string expected";
                    return null;
                };

                /**
                 * Creates a Reply message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FeedbackProto.Reply
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FeedbackProto.Reply} Reply
                 */
                Reply.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FeedbackProto.Reply)
                        return object;
                    var message = new $root.waiternow.common.FeedbackProto.Reply();
                    if (object.repliedById != null)
                        message.repliedById = String(object.repliedById);
                    if (object.repliedByEmail != null)
                        message.repliedByEmail = String(object.repliedByEmail);
                    if (object.repliedByName != null)
                        message.repliedByName = String(object.repliedByName);
                    if (object.timestamp != null) {
                        if (typeof object.timestamp !== "object")
                            throw TypeError(".waiternow.common.FeedbackProto.Reply.timestamp: object expected");
                        message.timestamp = $root.google.protobuf.Timestamp.fromObject(object.timestamp);
                    }
                    if (object.message != null)
                        message.message = String(object.message);
                    return message;
                };

                /**
                 * Creates a plain object from a Reply message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FeedbackProto.Reply
                 * @static
                 * @param {waiternow.common.FeedbackProto.Reply} message Reply
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Reply.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.repliedById = "";
                        object.repliedByEmail = "";
                        object.repliedByName = "";
                        object.timestamp = null;
                        object.message = "";
                    }
                    if (message.repliedById != null && message.hasOwnProperty("repliedById"))
                        object.repliedById = message.repliedById;
                    if (message.repliedByEmail != null && message.hasOwnProperty("repliedByEmail"))
                        object.repliedByEmail = message.repliedByEmail;
                    if (message.repliedByName != null && message.hasOwnProperty("repliedByName"))
                        object.repliedByName = message.repliedByName;
                    if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                        object.timestamp = $root.google.protobuf.Timestamp.toObject(message.timestamp, options);
                    if (message.message != null && message.hasOwnProperty("message"))
                        object.message = message.message;
                    return object;
                };

                /**
                 * Converts this Reply to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FeedbackProto.Reply
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Reply.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Reply
                 * @function getTypeUrl
                 * @memberof waiternow.common.FeedbackProto.Reply
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Reply.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FeedbackProto.Reply";
                };

                return Reply;
            })();

            return FeedbackProto;
        })();

        common.VersionProto = (function() {

            /**
             * Properties of a VersionProto.
             * @memberof waiternow.common
             * @interface IVersionProto
             * @property {google.protobuf.ITimestamp|null} [buildTime] VersionProto buildTime
             * @property {google.protobuf.ITimestamp|null} [releaseTime] VersionProto releaseTime
             * @property {number|null} [major] VersionProto major
             * @property {number|null} [minor] VersionProto minor
             * @property {number|null} [patch] VersionProto patch
             */

            /**
             * Constructs a new VersionProto.
             * @memberof waiternow.common
             * @classdesc Represents a VersionProto.
             * @implements IVersionProto
             * @constructor
             * @param {waiternow.common.IVersionProto=} [properties] Properties to set
             */
            function VersionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * VersionProto buildTime.
             * @member {google.protobuf.ITimestamp|null|undefined} buildTime
             * @memberof waiternow.common.VersionProto
             * @instance
             */
            VersionProto.prototype.buildTime = null;

            /**
             * VersionProto releaseTime.
             * @member {google.protobuf.ITimestamp|null|undefined} releaseTime
             * @memberof waiternow.common.VersionProto
             * @instance
             */
            VersionProto.prototype.releaseTime = null;

            /**
             * VersionProto major.
             * @member {number} major
             * @memberof waiternow.common.VersionProto
             * @instance
             */
            VersionProto.prototype.major = 0;

            /**
             * VersionProto minor.
             * @member {number} minor
             * @memberof waiternow.common.VersionProto
             * @instance
             */
            VersionProto.prototype.minor = 0;

            /**
             * VersionProto patch.
             * @member {number} patch
             * @memberof waiternow.common.VersionProto
             * @instance
             */
            VersionProto.prototype.patch = 0;

            /**
             * Creates a new VersionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.VersionProto
             * @static
             * @param {waiternow.common.IVersionProto=} [properties] Properties to set
             * @returns {waiternow.common.VersionProto} VersionProto instance
             */
            VersionProto.create = function create(properties) {
                return new VersionProto(properties);
            };

            /**
             * Encodes the specified VersionProto message. Does not implicitly {@link waiternow.common.VersionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.VersionProto
             * @static
             * @param {waiternow.common.IVersionProto} message VersionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            VersionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.buildTime != null && Object.hasOwnProperty.call(message, "buildTime"))
                    $root.google.protobuf.Timestamp.encode(message.buildTime, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.releaseTime != null && Object.hasOwnProperty.call(message, "releaseTime"))
                    $root.google.protobuf.Timestamp.encode(message.releaseTime, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.major != null && Object.hasOwnProperty.call(message, "major"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.major);
                if (message.minor != null && Object.hasOwnProperty.call(message, "minor"))
                    writer.uint32(/* id 4, wireType 0 =*/32).int32(message.minor);
                if (message.patch != null && Object.hasOwnProperty.call(message, "patch"))
                    writer.uint32(/* id 5, wireType 0 =*/40).int32(message.patch);
                return writer;
            };

            /**
             * Encodes the specified VersionProto message, length delimited. Does not implicitly {@link waiternow.common.VersionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.VersionProto
             * @static
             * @param {waiternow.common.IVersionProto} message VersionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            VersionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a VersionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.VersionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.VersionProto} VersionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            VersionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.VersionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.buildTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 2: {
                            message.releaseTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 3: {
                            message.major = reader.int32();
                            break;
                        }
                    case 4: {
                            message.minor = reader.int32();
                            break;
                        }
                    case 5: {
                            message.patch = reader.int32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a VersionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.VersionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.VersionProto} VersionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            VersionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a VersionProto message.
             * @function verify
             * @memberof waiternow.common.VersionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            VersionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.buildTime != null && message.hasOwnProperty("buildTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.buildTime);
                    if (error)
                        return "buildTime." + error;
                }
                if (message.releaseTime != null && message.hasOwnProperty("releaseTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.releaseTime);
                    if (error)
                        return "releaseTime." + error;
                }
                if (message.major != null && message.hasOwnProperty("major"))
                    if (!$util.isInteger(message.major))
                        return "major: integer expected";
                if (message.minor != null && message.hasOwnProperty("minor"))
                    if (!$util.isInteger(message.minor))
                        return "minor: integer expected";
                if (message.patch != null && message.hasOwnProperty("patch"))
                    if (!$util.isInteger(message.patch))
                        return "patch: integer expected";
                return null;
            };

            /**
             * Creates a VersionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.VersionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.VersionProto} VersionProto
             */
            VersionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.VersionProto)
                    return object;
                var message = new $root.waiternow.common.VersionProto();
                if (object.buildTime != null) {
                    if (typeof object.buildTime !== "object")
                        throw TypeError(".waiternow.common.VersionProto.buildTime: object expected");
                    message.buildTime = $root.google.protobuf.Timestamp.fromObject(object.buildTime);
                }
                if (object.releaseTime != null) {
                    if (typeof object.releaseTime !== "object")
                        throw TypeError(".waiternow.common.VersionProto.releaseTime: object expected");
                    message.releaseTime = $root.google.protobuf.Timestamp.fromObject(object.releaseTime);
                }
                if (object.major != null)
                    message.major = object.major | 0;
                if (object.minor != null)
                    message.minor = object.minor | 0;
                if (object.patch != null)
                    message.patch = object.patch | 0;
                return message;
            };

            /**
             * Creates a plain object from a VersionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.VersionProto
             * @static
             * @param {waiternow.common.VersionProto} message VersionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            VersionProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.buildTime = null;
                    object.releaseTime = null;
                    object.major = 0;
                    object.minor = 0;
                    object.patch = 0;
                }
                if (message.buildTime != null && message.hasOwnProperty("buildTime"))
                    object.buildTime = $root.google.protobuf.Timestamp.toObject(message.buildTime, options);
                if (message.releaseTime != null && message.hasOwnProperty("releaseTime"))
                    object.releaseTime = $root.google.protobuf.Timestamp.toObject(message.releaseTime, options);
                if (message.major != null && message.hasOwnProperty("major"))
                    object.major = message.major;
                if (message.minor != null && message.hasOwnProperty("minor"))
                    object.minor = message.minor;
                if (message.patch != null && message.hasOwnProperty("patch"))
                    object.patch = message.patch;
                return object;
            };

            /**
             * Converts this VersionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.VersionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            VersionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for VersionProto
             * @function getTypeUrl
             * @memberof waiternow.common.VersionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            VersionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.VersionProto";
            };

            return VersionProto;
        })();

        common.ConsumerProto = (function() {

            /**
             * Properties of a ConsumerProto.
             * @memberof waiternow.common
             * @interface IConsumerProto
             * @property {string|null} [id] ConsumerProto id
             * @property {google.protobuf.ITimestamp|null} [creationTime] ConsumerProto creationTime
             * @property {google.protobuf.ITimestamp|null} [lastUpdateTime] ConsumerProto lastUpdateTime
             * @property {waiternow.common.IPhoneNumberProto|null} [phoneNumber] ConsumerProto phoneNumber
             * @property {string|null} [email] ConsumerProto email
             * @property {string|null} [name] ConsumerProto name
             */

            /**
             * Constructs a new ConsumerProto.
             * @memberof waiternow.common
             * @classdesc Represents a ConsumerProto.
             * @implements IConsumerProto
             * @constructor
             * @param {waiternow.common.IConsumerProto=} [properties] Properties to set
             */
            function ConsumerProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ConsumerProto id.
             * @member {string} id
             * @memberof waiternow.common.ConsumerProto
             * @instance
             */
            ConsumerProto.prototype.id = "";

            /**
             * ConsumerProto creationTime.
             * @member {google.protobuf.ITimestamp|null|undefined} creationTime
             * @memberof waiternow.common.ConsumerProto
             * @instance
             */
            ConsumerProto.prototype.creationTime = null;

            /**
             * ConsumerProto lastUpdateTime.
             * @member {google.protobuf.ITimestamp|null|undefined} lastUpdateTime
             * @memberof waiternow.common.ConsumerProto
             * @instance
             */
            ConsumerProto.prototype.lastUpdateTime = null;

            /**
             * ConsumerProto phoneNumber.
             * @member {waiternow.common.IPhoneNumberProto|null|undefined} phoneNumber
             * @memberof waiternow.common.ConsumerProto
             * @instance
             */
            ConsumerProto.prototype.phoneNumber = null;

            /**
             * ConsumerProto email.
             * @member {string} email
             * @memberof waiternow.common.ConsumerProto
             * @instance
             */
            ConsumerProto.prototype.email = "";

            /**
             * ConsumerProto name.
             * @member {string} name
             * @memberof waiternow.common.ConsumerProto
             * @instance
             */
            ConsumerProto.prototype.name = "";

            /**
             * Creates a new ConsumerProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.ConsumerProto
             * @static
             * @param {waiternow.common.IConsumerProto=} [properties] Properties to set
             * @returns {waiternow.common.ConsumerProto} ConsumerProto instance
             */
            ConsumerProto.create = function create(properties) {
                return new ConsumerProto(properties);
            };

            /**
             * Encodes the specified ConsumerProto message. Does not implicitly {@link waiternow.common.ConsumerProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.ConsumerProto
             * @static
             * @param {waiternow.common.IConsumerProto} message ConsumerProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ConsumerProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                if (message.phoneNumber != null && Object.hasOwnProperty.call(message, "phoneNumber"))
                    $root.waiternow.common.PhoneNumberProto.encode(message.phoneNumber, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.name);
                if (message.creationTime != null && Object.hasOwnProperty.call(message, "creationTime"))
                    $root.google.protobuf.Timestamp.encode(message.creationTime, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                    $root.google.protobuf.Timestamp.encode(message.lastUpdateTime, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.email);
                return writer;
            };

            /**
             * Encodes the specified ConsumerProto message, length delimited. Does not implicitly {@link waiternow.common.ConsumerProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.ConsumerProto
             * @static
             * @param {waiternow.common.IConsumerProto} message ConsumerProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ConsumerProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ConsumerProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.ConsumerProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.ConsumerProto} ConsumerProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ConsumerProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.ConsumerProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.id = reader.string();
                            break;
                        }
                    case 4: {
                            message.creationTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 5: {
                            message.lastUpdateTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 2: {
                            message.phoneNumber = $root.waiternow.common.PhoneNumberProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 7: {
                            message.email = reader.string();
                            break;
                        }
                    case 3: {
                            message.name = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ConsumerProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.ConsumerProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.ConsumerProto} ConsumerProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ConsumerProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ConsumerProto message.
             * @function verify
             * @memberof waiternow.common.ConsumerProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ConsumerProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.id != null && message.hasOwnProperty("id"))
                    if (!$util.isString(message.id))
                        return "id: string expected";
                if (message.creationTime != null && message.hasOwnProperty("creationTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.creationTime);
                    if (error)
                        return "creationTime." + error;
                }
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.lastUpdateTime);
                    if (error)
                        return "lastUpdateTime." + error;
                }
                if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber")) {
                    var error = $root.waiternow.common.PhoneNumberProto.verify(message.phoneNumber);
                    if (error)
                        return "phoneNumber." + error;
                }
                if (message.email != null && message.hasOwnProperty("email"))
                    if (!$util.isString(message.email))
                        return "email: string expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                return null;
            };

            /**
             * Creates a ConsumerProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.ConsumerProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.ConsumerProto} ConsumerProto
             */
            ConsumerProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.ConsumerProto)
                    return object;
                var message = new $root.waiternow.common.ConsumerProto();
                if (object.id != null)
                    message.id = String(object.id);
                if (object.creationTime != null) {
                    if (typeof object.creationTime !== "object")
                        throw TypeError(".waiternow.common.ConsumerProto.creationTime: object expected");
                    message.creationTime = $root.google.protobuf.Timestamp.fromObject(object.creationTime);
                }
                if (object.lastUpdateTime != null) {
                    if (typeof object.lastUpdateTime !== "object")
                        throw TypeError(".waiternow.common.ConsumerProto.lastUpdateTime: object expected");
                    message.lastUpdateTime = $root.google.protobuf.Timestamp.fromObject(object.lastUpdateTime);
                }
                if (object.phoneNumber != null) {
                    if (typeof object.phoneNumber !== "object")
                        throw TypeError(".waiternow.common.ConsumerProto.phoneNumber: object expected");
                    message.phoneNumber = $root.waiternow.common.PhoneNumberProto.fromObject(object.phoneNumber);
                }
                if (object.email != null)
                    message.email = String(object.email);
                if (object.name != null)
                    message.name = String(object.name);
                return message;
            };

            /**
             * Creates a plain object from a ConsumerProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.ConsumerProto
             * @static
             * @param {waiternow.common.ConsumerProto} message ConsumerProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ConsumerProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.id = "";
                    object.phoneNumber = null;
                    object.name = "";
                    object.creationTime = null;
                    object.lastUpdateTime = null;
                    object.email = "";
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
                    object.phoneNumber = $root.waiternow.common.PhoneNumberProto.toObject(message.phoneNumber, options);
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                    object.creationTime = $root.google.protobuf.Timestamp.toObject(message.creationTime, options);
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                    object.lastUpdateTime = $root.google.protobuf.Timestamp.toObject(message.lastUpdateTime, options);
                if (message.email != null && message.hasOwnProperty("email"))
                    object.email = message.email;
                return object;
            };

            /**
             * Converts this ConsumerProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.ConsumerProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ConsumerProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for ConsumerProto
             * @function getTypeUrl
             * @memberof waiternow.common.ConsumerProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            ConsumerProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.ConsumerProto";
            };

            return ConsumerProto;
        })();

        common.LocationCustomerProto = (function() {

            /**
             * Properties of a LocationCustomerProto.
             * @memberof waiternow.common
             * @interface ILocationCustomerProto
             * @property {waiternow.common.LocationCustomerProto.IIdProto|null} [id] LocationCustomerProto id
             * @property {google.protobuf.ITimestamp|null} [creationTime] LocationCustomerProto creationTime
             * @property {google.protobuf.ITimestamp|null} [lastUpdateTime] LocationCustomerProto lastUpdateTime
             * @property {waiternow.common.IPhoneNumberProto|null} [phoneNumber] LocationCustomerProto phoneNumber
             * @property {string|null} [name] LocationCustomerProto name
             * @property {number|null} [purchasesCount] LocationCustomerProto purchasesCount
             * @property {boolean|null} [isUnsubscribedFromCampaigns] LocationCustomerProto isUnsubscribedFromCampaigns
             */

            /**
             * Constructs a new LocationCustomerProto.
             * @memberof waiternow.common
             * @classdesc Represents a LocationCustomerProto.
             * @implements ILocationCustomerProto
             * @constructor
             * @param {waiternow.common.ILocationCustomerProto=} [properties] Properties to set
             */
            function LocationCustomerProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * LocationCustomerProto id.
             * @member {waiternow.common.LocationCustomerProto.IIdProto|null|undefined} id
             * @memberof waiternow.common.LocationCustomerProto
             * @instance
             */
            LocationCustomerProto.prototype.id = null;

            /**
             * LocationCustomerProto creationTime.
             * @member {google.protobuf.ITimestamp|null|undefined} creationTime
             * @memberof waiternow.common.LocationCustomerProto
             * @instance
             */
            LocationCustomerProto.prototype.creationTime = null;

            /**
             * LocationCustomerProto lastUpdateTime.
             * @member {google.protobuf.ITimestamp|null|undefined} lastUpdateTime
             * @memberof waiternow.common.LocationCustomerProto
             * @instance
             */
            LocationCustomerProto.prototype.lastUpdateTime = null;

            /**
             * LocationCustomerProto phoneNumber.
             * @member {waiternow.common.IPhoneNumberProto|null|undefined} phoneNumber
             * @memberof waiternow.common.LocationCustomerProto
             * @instance
             */
            LocationCustomerProto.prototype.phoneNumber = null;

            /**
             * LocationCustomerProto name.
             * @member {string} name
             * @memberof waiternow.common.LocationCustomerProto
             * @instance
             */
            LocationCustomerProto.prototype.name = "";

            /**
             * LocationCustomerProto purchasesCount.
             * @member {number} purchasesCount
             * @memberof waiternow.common.LocationCustomerProto
             * @instance
             */
            LocationCustomerProto.prototype.purchasesCount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * LocationCustomerProto isUnsubscribedFromCampaigns.
             * @member {boolean} isUnsubscribedFromCampaigns
             * @memberof waiternow.common.LocationCustomerProto
             * @instance
             */
            LocationCustomerProto.prototype.isUnsubscribedFromCampaigns = false;

            /**
             * Creates a new LocationCustomerProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.LocationCustomerProto
             * @static
             * @param {waiternow.common.ILocationCustomerProto=} [properties] Properties to set
             * @returns {waiternow.common.LocationCustomerProto} LocationCustomerProto instance
             */
            LocationCustomerProto.create = function create(properties) {
                return new LocationCustomerProto(properties);
            };

            /**
             * Encodes the specified LocationCustomerProto message. Does not implicitly {@link waiternow.common.LocationCustomerProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.LocationCustomerProto
             * @static
             * @param {waiternow.common.ILocationCustomerProto} message LocationCustomerProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            LocationCustomerProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                    $root.waiternow.common.LocationCustomerProto.IdProto.encode(message.id, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.creationTime != null && Object.hasOwnProperty.call(message, "creationTime"))
                    $root.google.protobuf.Timestamp.encode(message.creationTime, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                    $root.google.protobuf.Timestamp.encode(message.lastUpdateTime, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.phoneNumber != null && Object.hasOwnProperty.call(message, "phoneNumber"))
                    $root.waiternow.common.PhoneNumberProto.encode(message.phoneNumber, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.name);
                if (message.purchasesCount != null && Object.hasOwnProperty.call(message, "purchasesCount"))
                    writer.uint32(/* id 6, wireType 0 =*/48).int64(message.purchasesCount);
                if (message.isUnsubscribedFromCampaigns != null && Object.hasOwnProperty.call(message, "isUnsubscribedFromCampaigns"))
                    writer.uint32(/* id 7, wireType 0 =*/56).bool(message.isUnsubscribedFromCampaigns);
                return writer;
            };

            /**
             * Encodes the specified LocationCustomerProto message, length delimited. Does not implicitly {@link waiternow.common.LocationCustomerProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.LocationCustomerProto
             * @static
             * @param {waiternow.common.ILocationCustomerProto} message LocationCustomerProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            LocationCustomerProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a LocationCustomerProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.LocationCustomerProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.LocationCustomerProto} LocationCustomerProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            LocationCustomerProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.LocationCustomerProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.id = $root.waiternow.common.LocationCustomerProto.IdProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 2: {
                            message.creationTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 3: {
                            message.lastUpdateTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 4: {
                            message.phoneNumber = $root.waiternow.common.PhoneNumberProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 5: {
                            message.name = reader.string();
                            break;
                        }
                    case 6: {
                            message.purchasesCount = reader.int64();
                            break;
                        }
                    case 7: {
                            message.isUnsubscribedFromCampaigns = reader.bool();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a LocationCustomerProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.LocationCustomerProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.LocationCustomerProto} LocationCustomerProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            LocationCustomerProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a LocationCustomerProto message.
             * @function verify
             * @memberof waiternow.common.LocationCustomerProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            LocationCustomerProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.id != null && message.hasOwnProperty("id")) {
                    var error = $root.waiternow.common.LocationCustomerProto.IdProto.verify(message.id);
                    if (error)
                        return "id." + error;
                }
                if (message.creationTime != null && message.hasOwnProperty("creationTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.creationTime);
                    if (error)
                        return "creationTime." + error;
                }
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.lastUpdateTime);
                    if (error)
                        return "lastUpdateTime." + error;
                }
                if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber")) {
                    var error = $root.waiternow.common.PhoneNumberProto.verify(message.phoneNumber);
                    if (error)
                        return "phoneNumber." + error;
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.purchasesCount != null && message.hasOwnProperty("purchasesCount"))
                    if (!$util.isInteger(message.purchasesCount) && !(message.purchasesCount && $util.isInteger(message.purchasesCount.low) && $util.isInteger(message.purchasesCount.high)))
                        return "purchasesCount: integer|Long expected";
                if (message.isUnsubscribedFromCampaigns != null && message.hasOwnProperty("isUnsubscribedFromCampaigns"))
                    if (typeof message.isUnsubscribedFromCampaigns !== "boolean")
                        return "isUnsubscribedFromCampaigns: boolean expected";
                return null;
            };

            /**
             * Creates a LocationCustomerProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.LocationCustomerProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.LocationCustomerProto} LocationCustomerProto
             */
            LocationCustomerProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.LocationCustomerProto)
                    return object;
                var message = new $root.waiternow.common.LocationCustomerProto();
                if (object.id != null) {
                    if (typeof object.id !== "object")
                        throw TypeError(".waiternow.common.LocationCustomerProto.id: object expected");
                    message.id = $root.waiternow.common.LocationCustomerProto.IdProto.fromObject(object.id);
                }
                if (object.creationTime != null) {
                    if (typeof object.creationTime !== "object")
                        throw TypeError(".waiternow.common.LocationCustomerProto.creationTime: object expected");
                    message.creationTime = $root.google.protobuf.Timestamp.fromObject(object.creationTime);
                }
                if (object.lastUpdateTime != null) {
                    if (typeof object.lastUpdateTime !== "object")
                        throw TypeError(".waiternow.common.LocationCustomerProto.lastUpdateTime: object expected");
                    message.lastUpdateTime = $root.google.protobuf.Timestamp.fromObject(object.lastUpdateTime);
                }
                if (object.phoneNumber != null) {
                    if (typeof object.phoneNumber !== "object")
                        throw TypeError(".waiternow.common.LocationCustomerProto.phoneNumber: object expected");
                    message.phoneNumber = $root.waiternow.common.PhoneNumberProto.fromObject(object.phoneNumber);
                }
                if (object.name != null)
                    message.name = String(object.name);
                if (object.purchasesCount != null)
                    if ($util.Long)
                        (message.purchasesCount = $util.Long.fromValue(object.purchasesCount)).unsigned = false;
                    else if (typeof object.purchasesCount === "string")
                        message.purchasesCount = parseInt(object.purchasesCount, 10);
                    else if (typeof object.purchasesCount === "number")
                        message.purchasesCount = object.purchasesCount;
                    else if (typeof object.purchasesCount === "object")
                        message.purchasesCount = new $util.LongBits(object.purchasesCount.low >>> 0, object.purchasesCount.high >>> 0).toNumber();
                if (object.isUnsubscribedFromCampaigns != null)
                    message.isUnsubscribedFromCampaigns = Boolean(object.isUnsubscribedFromCampaigns);
                return message;
            };

            /**
             * Creates a plain object from a LocationCustomerProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.LocationCustomerProto
             * @static
             * @param {waiternow.common.LocationCustomerProto} message LocationCustomerProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            LocationCustomerProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.id = null;
                    object.creationTime = null;
                    object.lastUpdateTime = null;
                    object.phoneNumber = null;
                    object.name = "";
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.purchasesCount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.purchasesCount = options.longs === String ? "0" : 0;
                    object.isUnsubscribedFromCampaigns = false;
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = $root.waiternow.common.LocationCustomerProto.IdProto.toObject(message.id, options);
                if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                    object.creationTime = $root.google.protobuf.Timestamp.toObject(message.creationTime, options);
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                    object.lastUpdateTime = $root.google.protobuf.Timestamp.toObject(message.lastUpdateTime, options);
                if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
                    object.phoneNumber = $root.waiternow.common.PhoneNumberProto.toObject(message.phoneNumber, options);
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.purchasesCount != null && message.hasOwnProperty("purchasesCount"))
                    if (typeof message.purchasesCount === "number")
                        object.purchasesCount = options.longs === String ? String(message.purchasesCount) : message.purchasesCount;
                    else
                        object.purchasesCount = options.longs === String ? $util.Long.prototype.toString.call(message.purchasesCount) : options.longs === Number ? new $util.LongBits(message.purchasesCount.low >>> 0, message.purchasesCount.high >>> 0).toNumber() : message.purchasesCount;
                if (message.isUnsubscribedFromCampaigns != null && message.hasOwnProperty("isUnsubscribedFromCampaigns"))
                    object.isUnsubscribedFromCampaigns = message.isUnsubscribedFromCampaigns;
                return object;
            };

            /**
             * Converts this LocationCustomerProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.LocationCustomerProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            LocationCustomerProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for LocationCustomerProto
             * @function getTypeUrl
             * @memberof waiternow.common.LocationCustomerProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            LocationCustomerProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.LocationCustomerProto";
            };

            LocationCustomerProto.IdProto = (function() {

                /**
                 * Properties of an IdProto.
                 * @memberof waiternow.common.LocationCustomerProto
                 * @interface IIdProto
                 * @property {string|null} [locationId] IdProto locationId
                 * @property {string|null} [email] IdProto email
                 */

                /**
                 * Constructs a new IdProto.
                 * @memberof waiternow.common.LocationCustomerProto
                 * @classdesc Represents an IdProto.
                 * @implements IIdProto
                 * @constructor
                 * @param {waiternow.common.LocationCustomerProto.IIdProto=} [properties] Properties to set
                 */
                function IdProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * IdProto locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.LocationCustomerProto.IdProto
                 * @instance
                 */
                IdProto.prototype.locationId = "";

                /**
                 * IdProto email.
                 * @member {string} email
                 * @memberof waiternow.common.LocationCustomerProto.IdProto
                 * @instance
                 */
                IdProto.prototype.email = "";

                /**
                 * Creates a new IdProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.LocationCustomerProto.IdProto
                 * @static
                 * @param {waiternow.common.LocationCustomerProto.IIdProto=} [properties] Properties to set
                 * @returns {waiternow.common.LocationCustomerProto.IdProto} IdProto instance
                 */
                IdProto.create = function create(properties) {
                    return new IdProto(properties);
                };

                /**
                 * Encodes the specified IdProto message. Does not implicitly {@link waiternow.common.LocationCustomerProto.IdProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.LocationCustomerProto.IdProto
                 * @static
                 * @param {waiternow.common.LocationCustomerProto.IIdProto} message IdProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                IdProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.email);
                    return writer;
                };

                /**
                 * Encodes the specified IdProto message, length delimited. Does not implicitly {@link waiternow.common.LocationCustomerProto.IdProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.LocationCustomerProto.IdProto
                 * @static
                 * @param {waiternow.common.LocationCustomerProto.IIdProto} message IdProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                IdProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an IdProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.LocationCustomerProto.IdProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.LocationCustomerProto.IdProto} IdProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                IdProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.LocationCustomerProto.IdProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 2: {
                                message.email = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an IdProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.LocationCustomerProto.IdProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.LocationCustomerProto.IdProto} IdProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                IdProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an IdProto message.
                 * @function verify
                 * @memberof waiternow.common.LocationCustomerProto.IdProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                IdProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    if (message.email != null && message.hasOwnProperty("email"))
                        if (!$util.isString(message.email))
                            return "email: string expected";
                    return null;
                };

                /**
                 * Creates an IdProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.LocationCustomerProto.IdProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.LocationCustomerProto.IdProto} IdProto
                 */
                IdProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.LocationCustomerProto.IdProto)
                        return object;
                    var message = new $root.waiternow.common.LocationCustomerProto.IdProto();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    if (object.email != null)
                        message.email = String(object.email);
                    return message;
                };

                /**
                 * Creates a plain object from an IdProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.LocationCustomerProto.IdProto
                 * @static
                 * @param {waiternow.common.LocationCustomerProto.IdProto} message IdProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                IdProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.locationId = "";
                        object.email = "";
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    if (message.email != null && message.hasOwnProperty("email"))
                        object.email = message.email;
                    return object;
                };

                /**
                 * Converts this IdProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.LocationCustomerProto.IdProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                IdProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for IdProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.LocationCustomerProto.IdProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                IdProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.LocationCustomerProto.IdProto";
                };

                return IdProto;
            })();

            return LocationCustomerProto;
        })();

        common.BusinessCustomerProto = (function() {

            /**
             * Properties of a BusinessCustomerProto.
             * @memberof waiternow.common
             * @interface IBusinessCustomerProto
             * @property {waiternow.common.BusinessCustomerProto.IIdProto|null} [id] BusinessCustomerProto id
             * @property {google.protobuf.ITimestamp|null} [creationTime] BusinessCustomerProto creationTime
             * @property {google.protobuf.ITimestamp|null} [lastUpdateTime] BusinessCustomerProto lastUpdateTime
             * @property {waiternow.common.IPhoneNumberProto|null} [phoneNumber] BusinessCustomerProto phoneNumber
             * @property {string|null} [name] BusinessCustomerProto name
             * @property {number|null} [purchasesCount] BusinessCustomerProto purchasesCount
             * @property {boolean|null} [isUnsubscribedFromCampaigns] BusinessCustomerProto isUnsubscribedFromCampaigns
             */

            /**
             * Constructs a new BusinessCustomerProto.
             * @memberof waiternow.common
             * @classdesc Represents a BusinessCustomerProto.
             * @implements IBusinessCustomerProto
             * @constructor
             * @param {waiternow.common.IBusinessCustomerProto=} [properties] Properties to set
             */
            function BusinessCustomerProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * BusinessCustomerProto id.
             * @member {waiternow.common.BusinessCustomerProto.IIdProto|null|undefined} id
             * @memberof waiternow.common.BusinessCustomerProto
             * @instance
             */
            BusinessCustomerProto.prototype.id = null;

            /**
             * BusinessCustomerProto creationTime.
             * @member {google.protobuf.ITimestamp|null|undefined} creationTime
             * @memberof waiternow.common.BusinessCustomerProto
             * @instance
             */
            BusinessCustomerProto.prototype.creationTime = null;

            /**
             * BusinessCustomerProto lastUpdateTime.
             * @member {google.protobuf.ITimestamp|null|undefined} lastUpdateTime
             * @memberof waiternow.common.BusinessCustomerProto
             * @instance
             */
            BusinessCustomerProto.prototype.lastUpdateTime = null;

            /**
             * BusinessCustomerProto phoneNumber.
             * @member {waiternow.common.IPhoneNumberProto|null|undefined} phoneNumber
             * @memberof waiternow.common.BusinessCustomerProto
             * @instance
             */
            BusinessCustomerProto.prototype.phoneNumber = null;

            /**
             * BusinessCustomerProto name.
             * @member {string} name
             * @memberof waiternow.common.BusinessCustomerProto
             * @instance
             */
            BusinessCustomerProto.prototype.name = "";

            /**
             * BusinessCustomerProto purchasesCount.
             * @member {number} purchasesCount
             * @memberof waiternow.common.BusinessCustomerProto
             * @instance
             */
            BusinessCustomerProto.prototype.purchasesCount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * BusinessCustomerProto isUnsubscribedFromCampaigns.
             * @member {boolean} isUnsubscribedFromCampaigns
             * @memberof waiternow.common.BusinessCustomerProto
             * @instance
             */
            BusinessCustomerProto.prototype.isUnsubscribedFromCampaigns = false;

            /**
             * Creates a new BusinessCustomerProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.BusinessCustomerProto
             * @static
             * @param {waiternow.common.IBusinessCustomerProto=} [properties] Properties to set
             * @returns {waiternow.common.BusinessCustomerProto} BusinessCustomerProto instance
             */
            BusinessCustomerProto.create = function create(properties) {
                return new BusinessCustomerProto(properties);
            };

            /**
             * Encodes the specified BusinessCustomerProto message. Does not implicitly {@link waiternow.common.BusinessCustomerProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.BusinessCustomerProto
             * @static
             * @param {waiternow.common.IBusinessCustomerProto} message BusinessCustomerProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BusinessCustomerProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                    $root.waiternow.common.BusinessCustomerProto.IdProto.encode(message.id, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.creationTime != null && Object.hasOwnProperty.call(message, "creationTime"))
                    $root.google.protobuf.Timestamp.encode(message.creationTime, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                    $root.google.protobuf.Timestamp.encode(message.lastUpdateTime, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.phoneNumber != null && Object.hasOwnProperty.call(message, "phoneNumber"))
                    $root.waiternow.common.PhoneNumberProto.encode(message.phoneNumber, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.name);
                if (message.purchasesCount != null && Object.hasOwnProperty.call(message, "purchasesCount"))
                    writer.uint32(/* id 6, wireType 0 =*/48).int64(message.purchasesCount);
                if (message.isUnsubscribedFromCampaigns != null && Object.hasOwnProperty.call(message, "isUnsubscribedFromCampaigns"))
                    writer.uint32(/* id 7, wireType 0 =*/56).bool(message.isUnsubscribedFromCampaigns);
                return writer;
            };

            /**
             * Encodes the specified BusinessCustomerProto message, length delimited. Does not implicitly {@link waiternow.common.BusinessCustomerProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.BusinessCustomerProto
             * @static
             * @param {waiternow.common.IBusinessCustomerProto} message BusinessCustomerProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BusinessCustomerProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a BusinessCustomerProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.BusinessCustomerProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.BusinessCustomerProto} BusinessCustomerProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BusinessCustomerProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.BusinessCustomerProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.id = $root.waiternow.common.BusinessCustomerProto.IdProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 2: {
                            message.creationTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 3: {
                            message.lastUpdateTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 4: {
                            message.phoneNumber = $root.waiternow.common.PhoneNumberProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 5: {
                            message.name = reader.string();
                            break;
                        }
                    case 6: {
                            message.purchasesCount = reader.int64();
                            break;
                        }
                    case 7: {
                            message.isUnsubscribedFromCampaigns = reader.bool();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a BusinessCustomerProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.BusinessCustomerProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.BusinessCustomerProto} BusinessCustomerProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BusinessCustomerProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a BusinessCustomerProto message.
             * @function verify
             * @memberof waiternow.common.BusinessCustomerProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            BusinessCustomerProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.id != null && message.hasOwnProperty("id")) {
                    var error = $root.waiternow.common.BusinessCustomerProto.IdProto.verify(message.id);
                    if (error)
                        return "id." + error;
                }
                if (message.creationTime != null && message.hasOwnProperty("creationTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.creationTime);
                    if (error)
                        return "creationTime." + error;
                }
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.lastUpdateTime);
                    if (error)
                        return "lastUpdateTime." + error;
                }
                if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber")) {
                    var error = $root.waiternow.common.PhoneNumberProto.verify(message.phoneNumber);
                    if (error)
                        return "phoneNumber." + error;
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.purchasesCount != null && message.hasOwnProperty("purchasesCount"))
                    if (!$util.isInteger(message.purchasesCount) && !(message.purchasesCount && $util.isInteger(message.purchasesCount.low) && $util.isInteger(message.purchasesCount.high)))
                        return "purchasesCount: integer|Long expected";
                if (message.isUnsubscribedFromCampaigns != null && message.hasOwnProperty("isUnsubscribedFromCampaigns"))
                    if (typeof message.isUnsubscribedFromCampaigns !== "boolean")
                        return "isUnsubscribedFromCampaigns: boolean expected";
                return null;
            };

            /**
             * Creates a BusinessCustomerProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.BusinessCustomerProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.BusinessCustomerProto} BusinessCustomerProto
             */
            BusinessCustomerProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.BusinessCustomerProto)
                    return object;
                var message = new $root.waiternow.common.BusinessCustomerProto();
                if (object.id != null) {
                    if (typeof object.id !== "object")
                        throw TypeError(".waiternow.common.BusinessCustomerProto.id: object expected");
                    message.id = $root.waiternow.common.BusinessCustomerProto.IdProto.fromObject(object.id);
                }
                if (object.creationTime != null) {
                    if (typeof object.creationTime !== "object")
                        throw TypeError(".waiternow.common.BusinessCustomerProto.creationTime: object expected");
                    message.creationTime = $root.google.protobuf.Timestamp.fromObject(object.creationTime);
                }
                if (object.lastUpdateTime != null) {
                    if (typeof object.lastUpdateTime !== "object")
                        throw TypeError(".waiternow.common.BusinessCustomerProto.lastUpdateTime: object expected");
                    message.lastUpdateTime = $root.google.protobuf.Timestamp.fromObject(object.lastUpdateTime);
                }
                if (object.phoneNumber != null) {
                    if (typeof object.phoneNumber !== "object")
                        throw TypeError(".waiternow.common.BusinessCustomerProto.phoneNumber: object expected");
                    message.phoneNumber = $root.waiternow.common.PhoneNumberProto.fromObject(object.phoneNumber);
                }
                if (object.name != null)
                    message.name = String(object.name);
                if (object.purchasesCount != null)
                    if ($util.Long)
                        (message.purchasesCount = $util.Long.fromValue(object.purchasesCount)).unsigned = false;
                    else if (typeof object.purchasesCount === "string")
                        message.purchasesCount = parseInt(object.purchasesCount, 10);
                    else if (typeof object.purchasesCount === "number")
                        message.purchasesCount = object.purchasesCount;
                    else if (typeof object.purchasesCount === "object")
                        message.purchasesCount = new $util.LongBits(object.purchasesCount.low >>> 0, object.purchasesCount.high >>> 0).toNumber();
                if (object.isUnsubscribedFromCampaigns != null)
                    message.isUnsubscribedFromCampaigns = Boolean(object.isUnsubscribedFromCampaigns);
                return message;
            };

            /**
             * Creates a plain object from a BusinessCustomerProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.BusinessCustomerProto
             * @static
             * @param {waiternow.common.BusinessCustomerProto} message BusinessCustomerProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            BusinessCustomerProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.id = null;
                    object.creationTime = null;
                    object.lastUpdateTime = null;
                    object.phoneNumber = null;
                    object.name = "";
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.purchasesCount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.purchasesCount = options.longs === String ? "0" : 0;
                    object.isUnsubscribedFromCampaigns = false;
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = $root.waiternow.common.BusinessCustomerProto.IdProto.toObject(message.id, options);
                if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                    object.creationTime = $root.google.protobuf.Timestamp.toObject(message.creationTime, options);
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                    object.lastUpdateTime = $root.google.protobuf.Timestamp.toObject(message.lastUpdateTime, options);
                if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
                    object.phoneNumber = $root.waiternow.common.PhoneNumberProto.toObject(message.phoneNumber, options);
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.purchasesCount != null && message.hasOwnProperty("purchasesCount"))
                    if (typeof message.purchasesCount === "number")
                        object.purchasesCount = options.longs === String ? String(message.purchasesCount) : message.purchasesCount;
                    else
                        object.purchasesCount = options.longs === String ? $util.Long.prototype.toString.call(message.purchasesCount) : options.longs === Number ? new $util.LongBits(message.purchasesCount.low >>> 0, message.purchasesCount.high >>> 0).toNumber() : message.purchasesCount;
                if (message.isUnsubscribedFromCampaigns != null && message.hasOwnProperty("isUnsubscribedFromCampaigns"))
                    object.isUnsubscribedFromCampaigns = message.isUnsubscribedFromCampaigns;
                return object;
            };

            /**
             * Converts this BusinessCustomerProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.BusinessCustomerProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            BusinessCustomerProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for BusinessCustomerProto
             * @function getTypeUrl
             * @memberof waiternow.common.BusinessCustomerProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            BusinessCustomerProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.BusinessCustomerProto";
            };

            BusinessCustomerProto.IdProto = (function() {

                /**
                 * Properties of an IdProto.
                 * @memberof waiternow.common.BusinessCustomerProto
                 * @interface IIdProto
                 * @property {string|null} [businessId] IdProto businessId
                 * @property {string|null} [email] IdProto email
                 */

                /**
                 * Constructs a new IdProto.
                 * @memberof waiternow.common.BusinessCustomerProto
                 * @classdesc Represents an IdProto.
                 * @implements IIdProto
                 * @constructor
                 * @param {waiternow.common.BusinessCustomerProto.IIdProto=} [properties] Properties to set
                 */
                function IdProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * IdProto businessId.
                 * @member {string} businessId
                 * @memberof waiternow.common.BusinessCustomerProto.IdProto
                 * @instance
                 */
                IdProto.prototype.businessId = "";

                /**
                 * IdProto email.
                 * @member {string} email
                 * @memberof waiternow.common.BusinessCustomerProto.IdProto
                 * @instance
                 */
                IdProto.prototype.email = "";

                /**
                 * Creates a new IdProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.BusinessCustomerProto.IdProto
                 * @static
                 * @param {waiternow.common.BusinessCustomerProto.IIdProto=} [properties] Properties to set
                 * @returns {waiternow.common.BusinessCustomerProto.IdProto} IdProto instance
                 */
                IdProto.create = function create(properties) {
                    return new IdProto(properties);
                };

                /**
                 * Encodes the specified IdProto message. Does not implicitly {@link waiternow.common.BusinessCustomerProto.IdProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.BusinessCustomerProto.IdProto
                 * @static
                 * @param {waiternow.common.BusinessCustomerProto.IIdProto} message IdProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                IdProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessId);
                    if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.email);
                    return writer;
                };

                /**
                 * Encodes the specified IdProto message, length delimited. Does not implicitly {@link waiternow.common.BusinessCustomerProto.IdProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.BusinessCustomerProto.IdProto
                 * @static
                 * @param {waiternow.common.BusinessCustomerProto.IIdProto} message IdProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                IdProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an IdProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.BusinessCustomerProto.IdProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.BusinessCustomerProto.IdProto} IdProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                IdProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.BusinessCustomerProto.IdProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.businessId = reader.string();
                                break;
                            }
                        case 2: {
                                message.email = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an IdProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.BusinessCustomerProto.IdProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.BusinessCustomerProto.IdProto} IdProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                IdProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an IdProto message.
                 * @function verify
                 * @memberof waiternow.common.BusinessCustomerProto.IdProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                IdProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.businessId != null && message.hasOwnProperty("businessId"))
                        if (!$util.isString(message.businessId))
                            return "businessId: string expected";
                    if (message.email != null && message.hasOwnProperty("email"))
                        if (!$util.isString(message.email))
                            return "email: string expected";
                    return null;
                };

                /**
                 * Creates an IdProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.BusinessCustomerProto.IdProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.BusinessCustomerProto.IdProto} IdProto
                 */
                IdProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.BusinessCustomerProto.IdProto)
                        return object;
                    var message = new $root.waiternow.common.BusinessCustomerProto.IdProto();
                    if (object.businessId != null)
                        message.businessId = String(object.businessId);
                    if (object.email != null)
                        message.email = String(object.email);
                    return message;
                };

                /**
                 * Creates a plain object from an IdProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.BusinessCustomerProto.IdProto
                 * @static
                 * @param {waiternow.common.BusinessCustomerProto.IdProto} message IdProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                IdProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.businessId = "";
                        object.email = "";
                    }
                    if (message.businessId != null && message.hasOwnProperty("businessId"))
                        object.businessId = message.businessId;
                    if (message.email != null && message.hasOwnProperty("email"))
                        object.email = message.email;
                    return object;
                };

                /**
                 * Converts this IdProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.BusinessCustomerProto.IdProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                IdProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for IdProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.BusinessCustomerProto.IdProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                IdProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.BusinessCustomerProto.IdProto";
                };

                return IdProto;
            })();

            return BusinessCustomerProto;
        })();

        common.CheckInAtBusinessActionProto = (function() {

            /**
             * Properties of a CheckInAtBusinessActionProto.
             * @memberof waiternow.common
             * @interface ICheckInAtBusinessActionProto
             */

            /**
             * Constructs a new CheckInAtBusinessActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a CheckInAtBusinessActionProto.
             * @implements ICheckInAtBusinessActionProto
             * @constructor
             * @param {waiternow.common.ICheckInAtBusinessActionProto=} [properties] Properties to set
             */
            function CheckInAtBusinessActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new CheckInAtBusinessActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.CheckInAtBusinessActionProto
             * @static
             * @param {waiternow.common.ICheckInAtBusinessActionProto=} [properties] Properties to set
             * @returns {waiternow.common.CheckInAtBusinessActionProto} CheckInAtBusinessActionProto instance
             */
            CheckInAtBusinessActionProto.create = function create(properties) {
                return new CheckInAtBusinessActionProto(properties);
            };

            /**
             * Encodes the specified CheckInAtBusinessActionProto message. Does not implicitly {@link waiternow.common.CheckInAtBusinessActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.CheckInAtBusinessActionProto
             * @static
             * @param {waiternow.common.ICheckInAtBusinessActionProto} message CheckInAtBusinessActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CheckInAtBusinessActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified CheckInAtBusinessActionProto message, length delimited. Does not implicitly {@link waiternow.common.CheckInAtBusinessActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.CheckInAtBusinessActionProto
             * @static
             * @param {waiternow.common.ICheckInAtBusinessActionProto} message CheckInAtBusinessActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CheckInAtBusinessActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CheckInAtBusinessActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.CheckInAtBusinessActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.CheckInAtBusinessActionProto} CheckInAtBusinessActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CheckInAtBusinessActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CheckInAtBusinessActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CheckInAtBusinessActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.CheckInAtBusinessActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.CheckInAtBusinessActionProto} CheckInAtBusinessActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CheckInAtBusinessActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CheckInAtBusinessActionProto message.
             * @function verify
             * @memberof waiternow.common.CheckInAtBusinessActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CheckInAtBusinessActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a CheckInAtBusinessActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.CheckInAtBusinessActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.CheckInAtBusinessActionProto} CheckInAtBusinessActionProto
             */
            CheckInAtBusinessActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.CheckInAtBusinessActionProto)
                    return object;
                return new $root.waiternow.common.CheckInAtBusinessActionProto();
            };

            /**
             * Creates a plain object from a CheckInAtBusinessActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.CheckInAtBusinessActionProto
             * @static
             * @param {waiternow.common.CheckInAtBusinessActionProto} message CheckInAtBusinessActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CheckInAtBusinessActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this CheckInAtBusinessActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.CheckInAtBusinessActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CheckInAtBusinessActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for CheckInAtBusinessActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.CheckInAtBusinessActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            CheckInAtBusinessActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.CheckInAtBusinessActionProto";
            };

            CheckInAtBusinessActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.CheckInAtBusinessActionProto
                 * @interface IRequest
                 * @property {string|null} [businessId] Request businessId
                 * @property {waiternow.common.PointOfServiceProto.PointOfServiceType|null} [pointOfServiceType] Request pointOfServiceType
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.CheckInAtBusinessActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.CheckInAtBusinessActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request businessId.
                 * @member {string} businessId
                 * @memberof waiternow.common.CheckInAtBusinessActionProto.Request
                 * @instance
                 */
                Request.prototype.businessId = "";

                /**
                 * Request pointOfServiceType.
                 * @member {waiternow.common.PointOfServiceProto.PointOfServiceType} pointOfServiceType
                 * @memberof waiternow.common.CheckInAtBusinessActionProto.Request
                 * @instance
                 */
                Request.prototype.pointOfServiceType = 0;

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.CheckInAtBusinessActionProto.Request
                 * @static
                 * @param {waiternow.common.CheckInAtBusinessActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.CheckInAtBusinessActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.CheckInAtBusinessActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.CheckInAtBusinessActionProto.Request
                 * @static
                 * @param {waiternow.common.CheckInAtBusinessActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessId);
                    if (message.pointOfServiceType != null && Object.hasOwnProperty.call(message, "pointOfServiceType"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.pointOfServiceType);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.CheckInAtBusinessActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.CheckInAtBusinessActionProto.Request
                 * @static
                 * @param {waiternow.common.CheckInAtBusinessActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.CheckInAtBusinessActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.CheckInAtBusinessActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CheckInAtBusinessActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.businessId = reader.string();
                                break;
                            }
                        case 2: {
                                message.pointOfServiceType = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.CheckInAtBusinessActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.CheckInAtBusinessActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.CheckInAtBusinessActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.businessId != null && message.hasOwnProperty("businessId"))
                        if (!$util.isString(message.businessId))
                            return "businessId: string expected";
                    if (message.pointOfServiceType != null && message.hasOwnProperty("pointOfServiceType"))
                        switch (message.pointOfServiceType) {
                        default:
                            return "pointOfServiceType: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                        case 6:
                        case 7:
                        case 8:
                            break;
                        }
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.CheckInAtBusinessActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.CheckInAtBusinessActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.CheckInAtBusinessActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.CheckInAtBusinessActionProto.Request();
                    if (object.businessId != null)
                        message.businessId = String(object.businessId);
                    switch (object.pointOfServiceType) {
                    default:
                        if (typeof object.pointOfServiceType === "number") {
                            message.pointOfServiceType = object.pointOfServiceType;
                            break;
                        }
                        break;
                    case "POINT_OF_SERVICE_TYPE_UNSPECIFIED":
                    case 0:
                        message.pointOfServiceType = 0;
                        break;
                    case "TABLE":
                    case 1:
                        message.pointOfServiceType = 1;
                        break;
                    case "ROOM":
                    case 2:
                        message.pointOfServiceType = 2;
                        break;
                    case "TERRACE":
                    case 3:
                        message.pointOfServiceType = 3;
                        break;
                    case "POOL":
                    case 4:
                        message.pointOfServiceType = 4;
                        break;
                    case "MENU":
                    case 5:
                        message.pointOfServiceType = 5;
                        break;
                    case "ONLINE_PICKUP":
                    case 6:
                        message.pointOfServiceType = 6;
                        break;
                    case "ONSITE_PICKUP":
                    case 7:
                        message.pointOfServiceType = 7;
                        break;
                    case "ONLINE":
                    case 8:
                        message.pointOfServiceType = 8;
                        break;
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.CheckInAtBusinessActionProto.Request
                 * @static
                 * @param {waiternow.common.CheckInAtBusinessActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.businessId = "";
                        object.pointOfServiceType = options.enums === String ? "POINT_OF_SERVICE_TYPE_UNSPECIFIED" : 0;
                    }
                    if (message.businessId != null && message.hasOwnProperty("businessId"))
                        object.businessId = message.businessId;
                    if (message.pointOfServiceType != null && message.hasOwnProperty("pointOfServiceType"))
                        object.pointOfServiceType = options.enums === String ? $root.waiternow.common.PointOfServiceProto.PointOfServiceType[message.pointOfServiceType] === undefined ? message.pointOfServiceType : $root.waiternow.common.PointOfServiceProto.PointOfServiceType[message.pointOfServiceType] : message.pointOfServiceType;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.CheckInAtBusinessActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.CheckInAtBusinessActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.CheckInAtBusinessActionProto.Request";
                };

                return Request;
            })();

            CheckInAtBusinessActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.CheckInAtBusinessActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IBusinessProto|null} [business] Response business
                 * @property {Array.<waiternow.common.CheckInAtBusinessActionProto.Response.ICheckInLocationProto>|null} [locations] Response locations
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.CheckInAtBusinessActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.CheckInAtBusinessActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    this.locations = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.CheckInAtBusinessActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response business.
                 * @member {waiternow.common.IBusinessProto|null|undefined} business
                 * @memberof waiternow.common.CheckInAtBusinessActionProto.Response
                 * @instance
                 */
                Response.prototype.business = null;

                /**
                 * Response locations.
                 * @member {Array.<waiternow.common.CheckInAtBusinessActionProto.Response.ICheckInLocationProto>} locations
                 * @memberof waiternow.common.CheckInAtBusinessActionProto.Response
                 * @instance
                 */
                Response.prototype.locations = $util.emptyArray;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.CheckInAtBusinessActionProto.Response
                 * @static
                 * @param {waiternow.common.CheckInAtBusinessActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.CheckInAtBusinessActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.CheckInAtBusinessActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.CheckInAtBusinessActionProto.Response
                 * @static
                 * @param {waiternow.common.CheckInAtBusinessActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.business != null && Object.hasOwnProperty.call(message, "business"))
                        $root.waiternow.common.BusinessProto.encode(message.business, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.locations != null && message.locations.length)
                        for (var i = 0; i < message.locations.length; ++i)
                            $root.waiternow.common.CheckInAtBusinessActionProto.Response.CheckInLocationProto.encode(message.locations[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.CheckInAtBusinessActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.CheckInAtBusinessActionProto.Response
                 * @static
                 * @param {waiternow.common.CheckInAtBusinessActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.CheckInAtBusinessActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.CheckInAtBusinessActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CheckInAtBusinessActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.business = $root.waiternow.common.BusinessProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                if (!(message.locations && message.locations.length))
                                    message.locations = [];
                                message.locations.push($root.waiternow.common.CheckInAtBusinessActionProto.Response.CheckInLocationProto.decode(reader, reader.uint32()));
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.CheckInAtBusinessActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.CheckInAtBusinessActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.CheckInAtBusinessActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.business != null && message.hasOwnProperty("business")) {
                        var error = $root.waiternow.common.BusinessProto.verify(message.business);
                        if (error)
                            return "business." + error;
                    }
                    if (message.locations != null && message.hasOwnProperty("locations")) {
                        if (!Array.isArray(message.locations))
                            return "locations: array expected";
                        for (var i = 0; i < message.locations.length; ++i) {
                            var error = $root.waiternow.common.CheckInAtBusinessActionProto.Response.CheckInLocationProto.verify(message.locations[i]);
                            if (error)
                                return "locations." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.CheckInAtBusinessActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.CheckInAtBusinessActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.CheckInAtBusinessActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.CheckInAtBusinessActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.CheckInAtBusinessActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.business != null) {
                        if (typeof object.business !== "object")
                            throw TypeError(".waiternow.common.CheckInAtBusinessActionProto.Response.business: object expected");
                        message.business = $root.waiternow.common.BusinessProto.fromObject(object.business);
                    }
                    if (object.locations) {
                        if (!Array.isArray(object.locations))
                            throw TypeError(".waiternow.common.CheckInAtBusinessActionProto.Response.locations: array expected");
                        message.locations = [];
                        for (var i = 0; i < object.locations.length; ++i) {
                            if (typeof object.locations[i] !== "object")
                                throw TypeError(".waiternow.common.CheckInAtBusinessActionProto.Response.locations: object expected");
                            message.locations[i] = $root.waiternow.common.CheckInAtBusinessActionProto.Response.CheckInLocationProto.fromObject(object.locations[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.CheckInAtBusinessActionProto.Response
                 * @static
                 * @param {waiternow.common.CheckInAtBusinessActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.locations = [];
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.business = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.business != null && message.hasOwnProperty("business"))
                        object.business = $root.waiternow.common.BusinessProto.toObject(message.business, options);
                    if (message.locations && message.locations.length) {
                        object.locations = [];
                        for (var j = 0; j < message.locations.length; ++j)
                            object.locations[j] = $root.waiternow.common.CheckInAtBusinessActionProto.Response.CheckInLocationProto.toObject(message.locations[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.CheckInAtBusinessActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.CheckInAtBusinessActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.CheckInAtBusinessActionProto.Response";
                };

                Response.CheckInLocationProto = (function() {

                    /**
                     * Properties of a CheckInLocationProto.
                     * @memberof waiternow.common.CheckInAtBusinessActionProto.Response
                     * @interface ICheckInLocationProto
                     * @property {string|null} [id] CheckInLocationProto id
                     * @property {string|null} [name] CheckInLocationProto name
                     * @property {waiternow.common.IAddressProto|null} [address] CheckInLocationProto address
                     * @property {boolean|null} [isOnline] CheckInLocationProto isOnline
                     * @property {string|null} [pointOfServiceIdToCheckInAt] CheckInLocationProto pointOfServiceIdToCheckInAt
                     */

                    /**
                     * Constructs a new CheckInLocationProto.
                     * @memberof waiternow.common.CheckInAtBusinessActionProto.Response
                     * @classdesc Represents a CheckInLocationProto.
                     * @implements ICheckInLocationProto
                     * @constructor
                     * @param {waiternow.common.CheckInAtBusinessActionProto.Response.ICheckInLocationProto=} [properties] Properties to set
                     */
                    function CheckInLocationProto(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * CheckInLocationProto id.
                     * @member {string} id
                     * @memberof waiternow.common.CheckInAtBusinessActionProto.Response.CheckInLocationProto
                     * @instance
                     */
                    CheckInLocationProto.prototype.id = "";

                    /**
                     * CheckInLocationProto name.
                     * @member {string} name
                     * @memberof waiternow.common.CheckInAtBusinessActionProto.Response.CheckInLocationProto
                     * @instance
                     */
                    CheckInLocationProto.prototype.name = "";

                    /**
                     * CheckInLocationProto address.
                     * @member {waiternow.common.IAddressProto|null|undefined} address
                     * @memberof waiternow.common.CheckInAtBusinessActionProto.Response.CheckInLocationProto
                     * @instance
                     */
                    CheckInLocationProto.prototype.address = null;

                    /**
                     * CheckInLocationProto isOnline.
                     * @member {boolean} isOnline
                     * @memberof waiternow.common.CheckInAtBusinessActionProto.Response.CheckInLocationProto
                     * @instance
                     */
                    CheckInLocationProto.prototype.isOnline = false;

                    /**
                     * CheckInLocationProto pointOfServiceIdToCheckInAt.
                     * @member {string} pointOfServiceIdToCheckInAt
                     * @memberof waiternow.common.CheckInAtBusinessActionProto.Response.CheckInLocationProto
                     * @instance
                     */
                    CheckInLocationProto.prototype.pointOfServiceIdToCheckInAt = "";

                    /**
                     * Creates a new CheckInLocationProto instance using the specified properties.
                     * @function create
                     * @memberof waiternow.common.CheckInAtBusinessActionProto.Response.CheckInLocationProto
                     * @static
                     * @param {waiternow.common.CheckInAtBusinessActionProto.Response.ICheckInLocationProto=} [properties] Properties to set
                     * @returns {waiternow.common.CheckInAtBusinessActionProto.Response.CheckInLocationProto} CheckInLocationProto instance
                     */
                    CheckInLocationProto.create = function create(properties) {
                        return new CheckInLocationProto(properties);
                    };

                    /**
                     * Encodes the specified CheckInLocationProto message. Does not implicitly {@link waiternow.common.CheckInAtBusinessActionProto.Response.CheckInLocationProto.verify|verify} messages.
                     * @function encode
                     * @memberof waiternow.common.CheckInAtBusinessActionProto.Response.CheckInLocationProto
                     * @static
                     * @param {waiternow.common.CheckInAtBusinessActionProto.Response.ICheckInLocationProto} message CheckInLocationProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CheckInLocationProto.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
                            $root.waiternow.common.AddressProto.encode(message.address, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.isOnline != null && Object.hasOwnProperty.call(message, "isOnline"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.isOnline);
                        if (message.pointOfServiceIdToCheckInAt != null && Object.hasOwnProperty.call(message, "pointOfServiceIdToCheckInAt"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.pointOfServiceIdToCheckInAt);
                        return writer;
                    };

                    /**
                     * Encodes the specified CheckInLocationProto message, length delimited. Does not implicitly {@link waiternow.common.CheckInAtBusinessActionProto.Response.CheckInLocationProto.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof waiternow.common.CheckInAtBusinessActionProto.Response.CheckInLocationProto
                     * @static
                     * @param {waiternow.common.CheckInAtBusinessActionProto.Response.ICheckInLocationProto} message CheckInLocationProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CheckInLocationProto.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a CheckInLocationProto message from the specified reader or buffer.
                     * @function decode
                     * @memberof waiternow.common.CheckInAtBusinessActionProto.Response.CheckInLocationProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {waiternow.common.CheckInAtBusinessActionProto.Response.CheckInLocationProto} CheckInLocationProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CheckInLocationProto.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CheckInAtBusinessActionProto.Response.CheckInLocationProto();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.id = reader.string();
                                    break;
                                }
                            case 2: {
                                    message.name = reader.string();
                                    break;
                                }
                            case 3: {
                                    message.address = $root.waiternow.common.AddressProto.decode(reader, reader.uint32());
                                    break;
                                }
                            case 4: {
                                    message.isOnline = reader.bool();
                                    break;
                                }
                            case 5: {
                                    message.pointOfServiceIdToCheckInAt = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a CheckInLocationProto message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof waiternow.common.CheckInAtBusinessActionProto.Response.CheckInLocationProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {waiternow.common.CheckInAtBusinessActionProto.Response.CheckInLocationProto} CheckInLocationProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CheckInLocationProto.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a CheckInLocationProto message.
                     * @function verify
                     * @memberof waiternow.common.CheckInAtBusinessActionProto.Response.CheckInLocationProto
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CheckInLocationProto.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isString(message.id))
                                return "id: string expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.address != null && message.hasOwnProperty("address")) {
                            var error = $root.waiternow.common.AddressProto.verify(message.address);
                            if (error)
                                return "address." + error;
                        }
                        if (message.isOnline != null && message.hasOwnProperty("isOnline"))
                            if (typeof message.isOnline !== "boolean")
                                return "isOnline: boolean expected";
                        if (message.pointOfServiceIdToCheckInAt != null && message.hasOwnProperty("pointOfServiceIdToCheckInAt"))
                            if (!$util.isString(message.pointOfServiceIdToCheckInAt))
                                return "pointOfServiceIdToCheckInAt: string expected";
                        return null;
                    };

                    /**
                     * Creates a CheckInLocationProto message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof waiternow.common.CheckInAtBusinessActionProto.Response.CheckInLocationProto
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {waiternow.common.CheckInAtBusinessActionProto.Response.CheckInLocationProto} CheckInLocationProto
                     */
                    CheckInLocationProto.fromObject = function fromObject(object) {
                        if (object instanceof $root.waiternow.common.CheckInAtBusinessActionProto.Response.CheckInLocationProto)
                            return object;
                        var message = new $root.waiternow.common.CheckInAtBusinessActionProto.Response.CheckInLocationProto();
                        if (object.id != null)
                            message.id = String(object.id);
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.address != null) {
                            if (typeof object.address !== "object")
                                throw TypeError(".waiternow.common.CheckInAtBusinessActionProto.Response.CheckInLocationProto.address: object expected");
                            message.address = $root.waiternow.common.AddressProto.fromObject(object.address);
                        }
                        if (object.isOnline != null)
                            message.isOnline = Boolean(object.isOnline);
                        if (object.pointOfServiceIdToCheckInAt != null)
                            message.pointOfServiceIdToCheckInAt = String(object.pointOfServiceIdToCheckInAt);
                        return message;
                    };

                    /**
                     * Creates a plain object from a CheckInLocationProto message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof waiternow.common.CheckInAtBusinessActionProto.Response.CheckInLocationProto
                     * @static
                     * @param {waiternow.common.CheckInAtBusinessActionProto.Response.CheckInLocationProto} message CheckInLocationProto
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CheckInLocationProto.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.id = "";
                            object.name = "";
                            object.address = null;
                            object.isOnline = false;
                            object.pointOfServiceIdToCheckInAt = "";
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            object.id = message.id;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.address != null && message.hasOwnProperty("address"))
                            object.address = $root.waiternow.common.AddressProto.toObject(message.address, options);
                        if (message.isOnline != null && message.hasOwnProperty("isOnline"))
                            object.isOnline = message.isOnline;
                        if (message.pointOfServiceIdToCheckInAt != null && message.hasOwnProperty("pointOfServiceIdToCheckInAt"))
                            object.pointOfServiceIdToCheckInAt = message.pointOfServiceIdToCheckInAt;
                        return object;
                    };

                    /**
                     * Converts this CheckInLocationProto to JSON.
                     * @function toJSON
                     * @memberof waiternow.common.CheckInAtBusinessActionProto.Response.CheckInLocationProto
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CheckInLocationProto.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for CheckInLocationProto
                     * @function getTypeUrl
                     * @memberof waiternow.common.CheckInAtBusinessActionProto.Response.CheckInLocationProto
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    CheckInLocationProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/waiternow.common.CheckInAtBusinessActionProto.Response.CheckInLocationProto";
                    };

                    return CheckInLocationProto;
                })();

                return Response;
            })();

            return CheckInAtBusinessActionProto;
        })();

        common.CheckInActionProto = (function() {

            /**
             * Properties of a CheckInActionProto.
             * @memberof waiternow.common
             * @interface ICheckInActionProto
             */

            /**
             * Constructs a new CheckInActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a CheckInActionProto.
             * @implements ICheckInActionProto
             * @constructor
             * @param {waiternow.common.ICheckInActionProto=} [properties] Properties to set
             */
            function CheckInActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new CheckInActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.CheckInActionProto
             * @static
             * @param {waiternow.common.ICheckInActionProto=} [properties] Properties to set
             * @returns {waiternow.common.CheckInActionProto} CheckInActionProto instance
             */
            CheckInActionProto.create = function create(properties) {
                return new CheckInActionProto(properties);
            };

            /**
             * Encodes the specified CheckInActionProto message. Does not implicitly {@link waiternow.common.CheckInActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.CheckInActionProto
             * @static
             * @param {waiternow.common.ICheckInActionProto} message CheckInActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CheckInActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified CheckInActionProto message, length delimited. Does not implicitly {@link waiternow.common.CheckInActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.CheckInActionProto
             * @static
             * @param {waiternow.common.ICheckInActionProto} message CheckInActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CheckInActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CheckInActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.CheckInActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.CheckInActionProto} CheckInActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CheckInActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CheckInActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CheckInActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.CheckInActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.CheckInActionProto} CheckInActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CheckInActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CheckInActionProto message.
             * @function verify
             * @memberof waiternow.common.CheckInActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CheckInActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a CheckInActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.CheckInActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.CheckInActionProto} CheckInActionProto
             */
            CheckInActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.CheckInActionProto)
                    return object;
                return new $root.waiternow.common.CheckInActionProto();
            };

            /**
             * Creates a plain object from a CheckInActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.CheckInActionProto
             * @static
             * @param {waiternow.common.CheckInActionProto} message CheckInActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CheckInActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this CheckInActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.CheckInActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CheckInActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for CheckInActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.CheckInActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            CheckInActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.CheckInActionProto";
            };

            CheckInActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.CheckInActionProto
                 * @interface IRequest
                 * @property {string|null} [pointOfServiceId] Request pointOfServiceId
                 * @property {waiternow.common.IConsumerProto|null} [consumer] Request consumer
                 * @property {string|null} [deviceId] Request deviceId
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.CheckInActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.CheckInActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request pointOfServiceId.
                 * @member {string} pointOfServiceId
                 * @memberof waiternow.common.CheckInActionProto.Request
                 * @instance
                 */
                Request.prototype.pointOfServiceId = "";

                /**
                 * Request consumer.
                 * @member {waiternow.common.IConsumerProto|null|undefined} consumer
                 * @memberof waiternow.common.CheckInActionProto.Request
                 * @instance
                 */
                Request.prototype.consumer = null;

                /**
                 * Request deviceId.
                 * @member {string} deviceId
                 * @memberof waiternow.common.CheckInActionProto.Request
                 * @instance
                 */
                Request.prototype.deviceId = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.CheckInActionProto.Request
                 * @static
                 * @param {waiternow.common.CheckInActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.CheckInActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.CheckInActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.CheckInActionProto.Request
                 * @static
                 * @param {waiternow.common.CheckInActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.pointOfServiceId != null && Object.hasOwnProperty.call(message, "pointOfServiceId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.pointOfServiceId);
                    if (message.consumer != null && Object.hasOwnProperty.call(message, "consumer"))
                        $root.waiternow.common.ConsumerProto.encode(message.consumer, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.deviceId != null && Object.hasOwnProperty.call(message, "deviceId"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.deviceId);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.CheckInActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.CheckInActionProto.Request
                 * @static
                 * @param {waiternow.common.CheckInActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.CheckInActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.CheckInActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CheckInActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.pointOfServiceId = reader.string();
                                break;
                            }
                        case 2: {
                                message.consumer = $root.waiternow.common.ConsumerProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.deviceId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.CheckInActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.CheckInActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.CheckInActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.pointOfServiceId != null && message.hasOwnProperty("pointOfServiceId"))
                        if (!$util.isString(message.pointOfServiceId))
                            return "pointOfServiceId: string expected";
                    if (message.consumer != null && message.hasOwnProperty("consumer")) {
                        var error = $root.waiternow.common.ConsumerProto.verify(message.consumer);
                        if (error)
                            return "consumer." + error;
                    }
                    if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                        if (!$util.isString(message.deviceId))
                            return "deviceId: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.CheckInActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.CheckInActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.CheckInActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.CheckInActionProto.Request();
                    if (object.pointOfServiceId != null)
                        message.pointOfServiceId = String(object.pointOfServiceId);
                    if (object.consumer != null) {
                        if (typeof object.consumer !== "object")
                            throw TypeError(".waiternow.common.CheckInActionProto.Request.consumer: object expected");
                        message.consumer = $root.waiternow.common.ConsumerProto.fromObject(object.consumer);
                    }
                    if (object.deviceId != null)
                        message.deviceId = String(object.deviceId);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.CheckInActionProto.Request
                 * @static
                 * @param {waiternow.common.CheckInActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.pointOfServiceId = "";
                        object.consumer = null;
                        object.deviceId = "";
                    }
                    if (message.pointOfServiceId != null && message.hasOwnProperty("pointOfServiceId"))
                        object.pointOfServiceId = message.pointOfServiceId;
                    if (message.consumer != null && message.hasOwnProperty("consumer"))
                        object.consumer = $root.waiternow.common.ConsumerProto.toObject(message.consumer, options);
                    if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                        object.deviceId = message.deviceId;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.CheckInActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.CheckInActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.CheckInActionProto.Request";
                };

                return Request;
            })();

            CheckInActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.CheckInActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.ICheckInDataProto|null} [checkInData] Response checkInData
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.CheckInActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.CheckInActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.CheckInActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response checkInData.
                 * @member {waiternow.common.ICheckInDataProto|null|undefined} checkInData
                 * @memberof waiternow.common.CheckInActionProto.Response
                 * @instance
                 */
                Response.prototype.checkInData = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.CheckInActionProto.Response
                 * @static
                 * @param {waiternow.common.CheckInActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.CheckInActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.CheckInActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.CheckInActionProto.Response
                 * @static
                 * @param {waiternow.common.CheckInActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.checkInData != null && Object.hasOwnProperty.call(message, "checkInData"))
                        $root.waiternow.common.CheckInDataProto.encode(message.checkInData, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.CheckInActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.CheckInActionProto.Response
                 * @static
                 * @param {waiternow.common.CheckInActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.CheckInActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.CheckInActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CheckInActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.checkInData = $root.waiternow.common.CheckInDataProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.CheckInActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.CheckInActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.CheckInActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.checkInData != null && message.hasOwnProperty("checkInData")) {
                        var error = $root.waiternow.common.CheckInDataProto.verify(message.checkInData);
                        if (error)
                            return "checkInData." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.CheckInActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.CheckInActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.CheckInActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.CheckInActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.CheckInActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.checkInData != null) {
                        if (typeof object.checkInData !== "object")
                            throw TypeError(".waiternow.common.CheckInActionProto.Response.checkInData: object expected");
                        message.checkInData = $root.waiternow.common.CheckInDataProto.fromObject(object.checkInData);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.CheckInActionProto.Response
                 * @static
                 * @param {waiternow.common.CheckInActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.checkInData = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.checkInData != null && message.hasOwnProperty("checkInData"))
                        object.checkInData = $root.waiternow.common.CheckInDataProto.toObject(message.checkInData, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.CheckInActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.CheckInActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.CheckInActionProto.Response";
                };

                return Response;
            })();

            return CheckInActionProto;
        })();

        common.CheckLocationOnlineStatusActionProto = (function() {

            /**
             * Properties of a CheckLocationOnlineStatusActionProto.
             * @memberof waiternow.common
             * @interface ICheckLocationOnlineStatusActionProto
             */

            /**
             * Constructs a new CheckLocationOnlineStatusActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a CheckLocationOnlineStatusActionProto.
             * @implements ICheckLocationOnlineStatusActionProto
             * @constructor
             * @param {waiternow.common.ICheckLocationOnlineStatusActionProto=} [properties] Properties to set
             */
            function CheckLocationOnlineStatusActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new CheckLocationOnlineStatusActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.CheckLocationOnlineStatusActionProto
             * @static
             * @param {waiternow.common.ICheckLocationOnlineStatusActionProto=} [properties] Properties to set
             * @returns {waiternow.common.CheckLocationOnlineStatusActionProto} CheckLocationOnlineStatusActionProto instance
             */
            CheckLocationOnlineStatusActionProto.create = function create(properties) {
                return new CheckLocationOnlineStatusActionProto(properties);
            };

            /**
             * Encodes the specified CheckLocationOnlineStatusActionProto message. Does not implicitly {@link waiternow.common.CheckLocationOnlineStatusActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.CheckLocationOnlineStatusActionProto
             * @static
             * @param {waiternow.common.ICheckLocationOnlineStatusActionProto} message CheckLocationOnlineStatusActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CheckLocationOnlineStatusActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified CheckLocationOnlineStatusActionProto message, length delimited. Does not implicitly {@link waiternow.common.CheckLocationOnlineStatusActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.CheckLocationOnlineStatusActionProto
             * @static
             * @param {waiternow.common.ICheckLocationOnlineStatusActionProto} message CheckLocationOnlineStatusActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CheckLocationOnlineStatusActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CheckLocationOnlineStatusActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.CheckLocationOnlineStatusActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.CheckLocationOnlineStatusActionProto} CheckLocationOnlineStatusActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CheckLocationOnlineStatusActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CheckLocationOnlineStatusActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CheckLocationOnlineStatusActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.CheckLocationOnlineStatusActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.CheckLocationOnlineStatusActionProto} CheckLocationOnlineStatusActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CheckLocationOnlineStatusActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CheckLocationOnlineStatusActionProto message.
             * @function verify
             * @memberof waiternow.common.CheckLocationOnlineStatusActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CheckLocationOnlineStatusActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a CheckLocationOnlineStatusActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.CheckLocationOnlineStatusActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.CheckLocationOnlineStatusActionProto} CheckLocationOnlineStatusActionProto
             */
            CheckLocationOnlineStatusActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.CheckLocationOnlineStatusActionProto)
                    return object;
                return new $root.waiternow.common.CheckLocationOnlineStatusActionProto();
            };

            /**
             * Creates a plain object from a CheckLocationOnlineStatusActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.CheckLocationOnlineStatusActionProto
             * @static
             * @param {waiternow.common.CheckLocationOnlineStatusActionProto} message CheckLocationOnlineStatusActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CheckLocationOnlineStatusActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this CheckLocationOnlineStatusActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.CheckLocationOnlineStatusActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CheckLocationOnlineStatusActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for CheckLocationOnlineStatusActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.CheckLocationOnlineStatusActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            CheckLocationOnlineStatusActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.CheckLocationOnlineStatusActionProto";
            };

            CheckLocationOnlineStatusActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.CheckLocationOnlineStatusActionProto
                 * @interface IRequest
                 * @property {string|null} [locationId] Request locationId
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.CheckLocationOnlineStatusActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.CheckLocationOnlineStatusActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.CheckLocationOnlineStatusActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.CheckLocationOnlineStatusActionProto.Request
                 * @static
                 * @param {waiternow.common.CheckLocationOnlineStatusActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.CheckLocationOnlineStatusActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.CheckLocationOnlineStatusActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.CheckLocationOnlineStatusActionProto.Request
                 * @static
                 * @param {waiternow.common.CheckLocationOnlineStatusActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.CheckLocationOnlineStatusActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.CheckLocationOnlineStatusActionProto.Request
                 * @static
                 * @param {waiternow.common.CheckLocationOnlineStatusActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.CheckLocationOnlineStatusActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.CheckLocationOnlineStatusActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CheckLocationOnlineStatusActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.CheckLocationOnlineStatusActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.CheckLocationOnlineStatusActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.CheckLocationOnlineStatusActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.CheckLocationOnlineStatusActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.CheckLocationOnlineStatusActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.CheckLocationOnlineStatusActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.CheckLocationOnlineStatusActionProto.Request();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.CheckLocationOnlineStatusActionProto.Request
                 * @static
                 * @param {waiternow.common.CheckLocationOnlineStatusActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.locationId = "";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.CheckLocationOnlineStatusActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.CheckLocationOnlineStatusActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.CheckLocationOnlineStatusActionProto.Request";
                };

                return Request;
            })();

            CheckLocationOnlineStatusActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.CheckLocationOnlineStatusActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {boolean|null} [isLocationOnline] Response isLocationOnline
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.CheckLocationOnlineStatusActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.CheckLocationOnlineStatusActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.CheckLocationOnlineStatusActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response isLocationOnline.
                 * @member {boolean} isLocationOnline
                 * @memberof waiternow.common.CheckLocationOnlineStatusActionProto.Response
                 * @instance
                 */
                Response.prototype.isLocationOnline = false;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.CheckLocationOnlineStatusActionProto.Response
                 * @static
                 * @param {waiternow.common.CheckLocationOnlineStatusActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.CheckLocationOnlineStatusActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.CheckLocationOnlineStatusActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.CheckLocationOnlineStatusActionProto.Response
                 * @static
                 * @param {waiternow.common.CheckLocationOnlineStatusActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.isLocationOnline != null && Object.hasOwnProperty.call(message, "isLocationOnline"))
                        writer.uint32(/* id 2, wireType 0 =*/16).bool(message.isLocationOnline);
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.CheckLocationOnlineStatusActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.CheckLocationOnlineStatusActionProto.Response
                 * @static
                 * @param {waiternow.common.CheckLocationOnlineStatusActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.CheckLocationOnlineStatusActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.CheckLocationOnlineStatusActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CheckLocationOnlineStatusActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.isLocationOnline = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.CheckLocationOnlineStatusActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.CheckLocationOnlineStatusActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.CheckLocationOnlineStatusActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.isLocationOnline != null && message.hasOwnProperty("isLocationOnline"))
                        if (typeof message.isLocationOnline !== "boolean")
                            return "isLocationOnline: boolean expected";
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.CheckLocationOnlineStatusActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.CheckLocationOnlineStatusActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.CheckLocationOnlineStatusActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.CheckLocationOnlineStatusActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.CheckLocationOnlineStatusActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.isLocationOnline != null)
                        message.isLocationOnline = Boolean(object.isLocationOnline);
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.CheckLocationOnlineStatusActionProto.Response
                 * @static
                 * @param {waiternow.common.CheckLocationOnlineStatusActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.isLocationOnline = false;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.isLocationOnline != null && message.hasOwnProperty("isLocationOnline"))
                        object.isLocationOnline = message.isLocationOnline;
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.CheckLocationOnlineStatusActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.CheckLocationOnlineStatusActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.CheckLocationOnlineStatusActionProto.Response";
                };

                return Response;
            })();

            return CheckLocationOnlineStatusActionProto;
        })();

        common.PlaceOrderActionProto = (function() {

            /**
             * Properties of a PlaceOrderActionProto.
             * @memberof waiternow.common
             * @interface IPlaceOrderActionProto
             */

            /**
             * Constructs a new PlaceOrderActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a PlaceOrderActionProto.
             * @implements IPlaceOrderActionProto
             * @constructor
             * @param {waiternow.common.IPlaceOrderActionProto=} [properties] Properties to set
             */
            function PlaceOrderActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new PlaceOrderActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.PlaceOrderActionProto
             * @static
             * @param {waiternow.common.IPlaceOrderActionProto=} [properties] Properties to set
             * @returns {waiternow.common.PlaceOrderActionProto} PlaceOrderActionProto instance
             */
            PlaceOrderActionProto.create = function create(properties) {
                return new PlaceOrderActionProto(properties);
            };

            /**
             * Encodes the specified PlaceOrderActionProto message. Does not implicitly {@link waiternow.common.PlaceOrderActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.PlaceOrderActionProto
             * @static
             * @param {waiternow.common.IPlaceOrderActionProto} message PlaceOrderActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PlaceOrderActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified PlaceOrderActionProto message, length delimited. Does not implicitly {@link waiternow.common.PlaceOrderActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.PlaceOrderActionProto
             * @static
             * @param {waiternow.common.IPlaceOrderActionProto} message PlaceOrderActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PlaceOrderActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a PlaceOrderActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.PlaceOrderActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.PlaceOrderActionProto} PlaceOrderActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PlaceOrderActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PlaceOrderActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a PlaceOrderActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.PlaceOrderActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.PlaceOrderActionProto} PlaceOrderActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PlaceOrderActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a PlaceOrderActionProto message.
             * @function verify
             * @memberof waiternow.common.PlaceOrderActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            PlaceOrderActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a PlaceOrderActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.PlaceOrderActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.PlaceOrderActionProto} PlaceOrderActionProto
             */
            PlaceOrderActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.PlaceOrderActionProto)
                    return object;
                return new $root.waiternow.common.PlaceOrderActionProto();
            };

            /**
             * Creates a plain object from a PlaceOrderActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.PlaceOrderActionProto
             * @static
             * @param {waiternow.common.PlaceOrderActionProto} message PlaceOrderActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            PlaceOrderActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this PlaceOrderActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.PlaceOrderActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            PlaceOrderActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for PlaceOrderActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.PlaceOrderActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            PlaceOrderActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.PlaceOrderActionProto";
            };

            PlaceOrderActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.PlaceOrderActionProto
                 * @interface IRequest
                 * @property {string|null} [pointOfServiceId] Request pointOfServiceId
                 * @property {string|null} [deviceId] Request deviceId
                 * @property {waiternow.common.IConsumerProto|null} [consumer] Request consumer
                 * @property {waiternow.common.OrderProto.IWaiterRequestProto|null} [waiterRequest] Request waiterRequest
                 * @property {waiternow.common.IMenuOrderProto|null} [menuOrder] Request menuOrder
                 * @property {waiternow.common.IMoneyProto|null} [tip] Request tip
                 * @property {boolean|null} [generatePaymentIntent] Request generatePaymentIntent
                 * @property {waiternow.common.IDateTimeProto|null} [orderTime] Request orderTime
                 * @property {string|null} [deliveryId] Request deliveryId
                 * @property {waiternow.common.PlaceOrderActionProto.Request.ITestProto|null} [test] Request test
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.PlaceOrderActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.PlaceOrderActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request pointOfServiceId.
                 * @member {string} pointOfServiceId
                 * @memberof waiternow.common.PlaceOrderActionProto.Request
                 * @instance
                 */
                Request.prototype.pointOfServiceId = "";

                /**
                 * Request deviceId.
                 * @member {string} deviceId
                 * @memberof waiternow.common.PlaceOrderActionProto.Request
                 * @instance
                 */
                Request.prototype.deviceId = "";

                /**
                 * Request consumer.
                 * @member {waiternow.common.IConsumerProto|null|undefined} consumer
                 * @memberof waiternow.common.PlaceOrderActionProto.Request
                 * @instance
                 */
                Request.prototype.consumer = null;

                /**
                 * Request waiterRequest.
                 * @member {waiternow.common.OrderProto.IWaiterRequestProto|null|undefined} waiterRequest
                 * @memberof waiternow.common.PlaceOrderActionProto.Request
                 * @instance
                 */
                Request.prototype.waiterRequest = null;

                /**
                 * Request menuOrder.
                 * @member {waiternow.common.IMenuOrderProto|null|undefined} menuOrder
                 * @memberof waiternow.common.PlaceOrderActionProto.Request
                 * @instance
                 */
                Request.prototype.menuOrder = null;

                /**
                 * Request tip.
                 * @member {waiternow.common.IMoneyProto|null|undefined} tip
                 * @memberof waiternow.common.PlaceOrderActionProto.Request
                 * @instance
                 */
                Request.prototype.tip = null;

                /**
                 * Request generatePaymentIntent.
                 * @member {boolean} generatePaymentIntent
                 * @memberof waiternow.common.PlaceOrderActionProto.Request
                 * @instance
                 */
                Request.prototype.generatePaymentIntent = false;

                /**
                 * Request orderTime.
                 * @member {waiternow.common.IDateTimeProto|null|undefined} orderTime
                 * @memberof waiternow.common.PlaceOrderActionProto.Request
                 * @instance
                 */
                Request.prototype.orderTime = null;

                /**
                 * Request deliveryId.
                 * @member {string} deliveryId
                 * @memberof waiternow.common.PlaceOrderActionProto.Request
                 * @instance
                 */
                Request.prototype.deliveryId = "";

                /**
                 * Request test.
                 * @member {waiternow.common.PlaceOrderActionProto.Request.ITestProto|null|undefined} test
                 * @memberof waiternow.common.PlaceOrderActionProto.Request
                 * @instance
                 */
                Request.prototype.test = null;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * Request orderType.
                 * @member {"waiterRequest"|"menuOrder"|undefined} orderType
                 * @memberof waiternow.common.PlaceOrderActionProto.Request
                 * @instance
                 */
                Object.defineProperty(Request.prototype, "orderType", {
                    get: $util.oneOfGetter($oneOfFields = ["waiterRequest", "menuOrder"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.PlaceOrderActionProto.Request
                 * @static
                 * @param {waiternow.common.PlaceOrderActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.PlaceOrderActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.PlaceOrderActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.PlaceOrderActionProto.Request
                 * @static
                 * @param {waiternow.common.PlaceOrderActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.pointOfServiceId != null && Object.hasOwnProperty.call(message, "pointOfServiceId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.pointOfServiceId);
                    if (message.consumer != null && Object.hasOwnProperty.call(message, "consumer"))
                        $root.waiternow.common.ConsumerProto.encode(message.consumer, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.waiterRequest != null && Object.hasOwnProperty.call(message, "waiterRequest"))
                        $root.waiternow.common.OrderProto.WaiterRequestProto.encode(message.waiterRequest, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.deviceId != null && Object.hasOwnProperty.call(message, "deviceId"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.deviceId);
                    if (message.menuOrder != null && Object.hasOwnProperty.call(message, "menuOrder"))
                        $root.waiternow.common.MenuOrderProto.encode(message.menuOrder, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.tip != null && Object.hasOwnProperty.call(message, "tip"))
                        $root.waiternow.common.MoneyProto.encode(message.tip, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.generatePaymentIntent != null && Object.hasOwnProperty.call(message, "generatePaymentIntent"))
                        writer.uint32(/* id 9, wireType 0 =*/72).bool(message.generatePaymentIntent);
                    if (message.orderTime != null && Object.hasOwnProperty.call(message, "orderTime"))
                        $root.waiternow.common.DateTimeProto.encode(message.orderTime, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                    if (message.deliveryId != null && Object.hasOwnProperty.call(message, "deliveryId"))
                        writer.uint32(/* id 11, wireType 2 =*/90).string(message.deliveryId);
                    if (message.test != null && Object.hasOwnProperty.call(message, "test"))
                        $root.waiternow.common.PlaceOrderActionProto.Request.TestProto.encode(message.test, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.PlaceOrderActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.PlaceOrderActionProto.Request
                 * @static
                 * @param {waiternow.common.PlaceOrderActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.PlaceOrderActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.PlaceOrderActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PlaceOrderActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.pointOfServiceId = reader.string();
                                break;
                            }
                        case 4: {
                                message.deviceId = reader.string();
                                break;
                            }
                        case 2: {
                                message.consumer = $root.waiternow.common.ConsumerProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.waiterRequest = $root.waiternow.common.OrderProto.WaiterRequestProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 5: {
                                message.menuOrder = $root.waiternow.common.MenuOrderProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 6: {
                                message.tip = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 9: {
                                message.generatePaymentIntent = reader.bool();
                                break;
                            }
                        case 10: {
                                message.orderTime = $root.waiternow.common.DateTimeProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 11: {
                                message.deliveryId = reader.string();
                                break;
                            }
                        case 12: {
                                message.test = $root.waiternow.common.PlaceOrderActionProto.Request.TestProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.PlaceOrderActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.PlaceOrderActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.PlaceOrderActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.pointOfServiceId != null && message.hasOwnProperty("pointOfServiceId"))
                        if (!$util.isString(message.pointOfServiceId))
                            return "pointOfServiceId: string expected";
                    if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                        if (!$util.isString(message.deviceId))
                            return "deviceId: string expected";
                    if (message.consumer != null && message.hasOwnProperty("consumer")) {
                        var error = $root.waiternow.common.ConsumerProto.verify(message.consumer);
                        if (error)
                            return "consumer." + error;
                    }
                    if (message.waiterRequest != null && message.hasOwnProperty("waiterRequest")) {
                        properties.orderType = 1;
                        {
                            var error = $root.waiternow.common.OrderProto.WaiterRequestProto.verify(message.waiterRequest);
                            if (error)
                                return "waiterRequest." + error;
                        }
                    }
                    if (message.menuOrder != null && message.hasOwnProperty("menuOrder")) {
                        if (properties.orderType === 1)
                            return "orderType: multiple values";
                        properties.orderType = 1;
                        {
                            var error = $root.waiternow.common.MenuOrderProto.verify(message.menuOrder);
                            if (error)
                                return "menuOrder." + error;
                        }
                    }
                    if (message.tip != null && message.hasOwnProperty("tip")) {
                        var error = $root.waiternow.common.MoneyProto.verify(message.tip);
                        if (error)
                            return "tip." + error;
                    }
                    if (message.generatePaymentIntent != null && message.hasOwnProperty("generatePaymentIntent"))
                        if (typeof message.generatePaymentIntent !== "boolean")
                            return "generatePaymentIntent: boolean expected";
                    if (message.orderTime != null && message.hasOwnProperty("orderTime")) {
                        var error = $root.waiternow.common.DateTimeProto.verify(message.orderTime);
                        if (error)
                            return "orderTime." + error;
                    }
                    if (message.deliveryId != null && message.hasOwnProperty("deliveryId"))
                        if (!$util.isString(message.deliveryId))
                            return "deliveryId: string expected";
                    if (message.test != null && message.hasOwnProperty("test")) {
                        var error = $root.waiternow.common.PlaceOrderActionProto.Request.TestProto.verify(message.test);
                        if (error)
                            return "test." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.PlaceOrderActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.PlaceOrderActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.PlaceOrderActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.PlaceOrderActionProto.Request();
                    if (object.pointOfServiceId != null)
                        message.pointOfServiceId = String(object.pointOfServiceId);
                    if (object.deviceId != null)
                        message.deviceId = String(object.deviceId);
                    if (object.consumer != null) {
                        if (typeof object.consumer !== "object")
                            throw TypeError(".waiternow.common.PlaceOrderActionProto.Request.consumer: object expected");
                        message.consumer = $root.waiternow.common.ConsumerProto.fromObject(object.consumer);
                    }
                    if (object.waiterRequest != null) {
                        if (typeof object.waiterRequest !== "object")
                            throw TypeError(".waiternow.common.PlaceOrderActionProto.Request.waiterRequest: object expected");
                        message.waiterRequest = $root.waiternow.common.OrderProto.WaiterRequestProto.fromObject(object.waiterRequest);
                    }
                    if (object.menuOrder != null) {
                        if (typeof object.menuOrder !== "object")
                            throw TypeError(".waiternow.common.PlaceOrderActionProto.Request.menuOrder: object expected");
                        message.menuOrder = $root.waiternow.common.MenuOrderProto.fromObject(object.menuOrder);
                    }
                    if (object.tip != null) {
                        if (typeof object.tip !== "object")
                            throw TypeError(".waiternow.common.PlaceOrderActionProto.Request.tip: object expected");
                        message.tip = $root.waiternow.common.MoneyProto.fromObject(object.tip);
                    }
                    if (object.generatePaymentIntent != null)
                        message.generatePaymentIntent = Boolean(object.generatePaymentIntent);
                    if (object.orderTime != null) {
                        if (typeof object.orderTime !== "object")
                            throw TypeError(".waiternow.common.PlaceOrderActionProto.Request.orderTime: object expected");
                        message.orderTime = $root.waiternow.common.DateTimeProto.fromObject(object.orderTime);
                    }
                    if (object.deliveryId != null)
                        message.deliveryId = String(object.deliveryId);
                    if (object.test != null) {
                        if (typeof object.test !== "object")
                            throw TypeError(".waiternow.common.PlaceOrderActionProto.Request.test: object expected");
                        message.test = $root.waiternow.common.PlaceOrderActionProto.Request.TestProto.fromObject(object.test);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.PlaceOrderActionProto.Request
                 * @static
                 * @param {waiternow.common.PlaceOrderActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.pointOfServiceId = "";
                        object.consumer = null;
                        object.deviceId = "";
                        object.tip = null;
                        object.generatePaymentIntent = false;
                        object.orderTime = null;
                        object.deliveryId = "";
                        object.test = null;
                    }
                    if (message.pointOfServiceId != null && message.hasOwnProperty("pointOfServiceId"))
                        object.pointOfServiceId = message.pointOfServiceId;
                    if (message.consumer != null && message.hasOwnProperty("consumer"))
                        object.consumer = $root.waiternow.common.ConsumerProto.toObject(message.consumer, options);
                    if (message.waiterRequest != null && message.hasOwnProperty("waiterRequest")) {
                        object.waiterRequest = $root.waiternow.common.OrderProto.WaiterRequestProto.toObject(message.waiterRequest, options);
                        if (options.oneofs)
                            object.orderType = "waiterRequest";
                    }
                    if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                        object.deviceId = message.deviceId;
                    if (message.menuOrder != null && message.hasOwnProperty("menuOrder")) {
                        object.menuOrder = $root.waiternow.common.MenuOrderProto.toObject(message.menuOrder, options);
                        if (options.oneofs)
                            object.orderType = "menuOrder";
                    }
                    if (message.tip != null && message.hasOwnProperty("tip"))
                        object.tip = $root.waiternow.common.MoneyProto.toObject(message.tip, options);
                    if (message.generatePaymentIntent != null && message.hasOwnProperty("generatePaymentIntent"))
                        object.generatePaymentIntent = message.generatePaymentIntent;
                    if (message.orderTime != null && message.hasOwnProperty("orderTime"))
                        object.orderTime = $root.waiternow.common.DateTimeProto.toObject(message.orderTime, options);
                    if (message.deliveryId != null && message.hasOwnProperty("deliveryId"))
                        object.deliveryId = message.deliveryId;
                    if (message.test != null && message.hasOwnProperty("test"))
                        object.test = $root.waiternow.common.PlaceOrderActionProto.Request.TestProto.toObject(message.test, options);
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.PlaceOrderActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.PlaceOrderActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.PlaceOrderActionProto.Request";
                };

                Request.TestProto = (function() {

                    /**
                     * Properties of a TestProto.
                     * @memberof waiternow.common.PlaceOrderActionProto.Request
                     * @interface ITestProto
                     * @property {boolean|null} [isStressTest] TestProto isStressTest
                     * @property {boolean|null} [emulatePrinter] TestProto emulatePrinter
                     */

                    /**
                     * Constructs a new TestProto.
                     * @memberof waiternow.common.PlaceOrderActionProto.Request
                     * @classdesc Represents a TestProto.
                     * @implements ITestProto
                     * @constructor
                     * @param {waiternow.common.PlaceOrderActionProto.Request.ITestProto=} [properties] Properties to set
                     */
                    function TestProto(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * TestProto isStressTest.
                     * @member {boolean} isStressTest
                     * @memberof waiternow.common.PlaceOrderActionProto.Request.TestProto
                     * @instance
                     */
                    TestProto.prototype.isStressTest = false;

                    /**
                     * TestProto emulatePrinter.
                     * @member {boolean} emulatePrinter
                     * @memberof waiternow.common.PlaceOrderActionProto.Request.TestProto
                     * @instance
                     */
                    TestProto.prototype.emulatePrinter = false;

                    /**
                     * Creates a new TestProto instance using the specified properties.
                     * @function create
                     * @memberof waiternow.common.PlaceOrderActionProto.Request.TestProto
                     * @static
                     * @param {waiternow.common.PlaceOrderActionProto.Request.ITestProto=} [properties] Properties to set
                     * @returns {waiternow.common.PlaceOrderActionProto.Request.TestProto} TestProto instance
                     */
                    TestProto.create = function create(properties) {
                        return new TestProto(properties);
                    };

                    /**
                     * Encodes the specified TestProto message. Does not implicitly {@link waiternow.common.PlaceOrderActionProto.Request.TestProto.verify|verify} messages.
                     * @function encode
                     * @memberof waiternow.common.PlaceOrderActionProto.Request.TestProto
                     * @static
                     * @param {waiternow.common.PlaceOrderActionProto.Request.ITestProto} message TestProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TestProto.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.isStressTest != null && Object.hasOwnProperty.call(message, "isStressTest"))
                            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.isStressTest);
                        if (message.emulatePrinter != null && Object.hasOwnProperty.call(message, "emulatePrinter"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.emulatePrinter);
                        return writer;
                    };

                    /**
                     * Encodes the specified TestProto message, length delimited. Does not implicitly {@link waiternow.common.PlaceOrderActionProto.Request.TestProto.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof waiternow.common.PlaceOrderActionProto.Request.TestProto
                     * @static
                     * @param {waiternow.common.PlaceOrderActionProto.Request.ITestProto} message TestProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TestProto.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a TestProto message from the specified reader or buffer.
                     * @function decode
                     * @memberof waiternow.common.PlaceOrderActionProto.Request.TestProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {waiternow.common.PlaceOrderActionProto.Request.TestProto} TestProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TestProto.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PlaceOrderActionProto.Request.TestProto();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.isStressTest = reader.bool();
                                    break;
                                }
                            case 2: {
                                    message.emulatePrinter = reader.bool();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a TestProto message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof waiternow.common.PlaceOrderActionProto.Request.TestProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {waiternow.common.PlaceOrderActionProto.Request.TestProto} TestProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TestProto.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a TestProto message.
                     * @function verify
                     * @memberof waiternow.common.PlaceOrderActionProto.Request.TestProto
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TestProto.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.isStressTest != null && message.hasOwnProperty("isStressTest"))
                            if (typeof message.isStressTest !== "boolean")
                                return "isStressTest: boolean expected";
                        if (message.emulatePrinter != null && message.hasOwnProperty("emulatePrinter"))
                            if (typeof message.emulatePrinter !== "boolean")
                                return "emulatePrinter: boolean expected";
                        return null;
                    };

                    /**
                     * Creates a TestProto message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof waiternow.common.PlaceOrderActionProto.Request.TestProto
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {waiternow.common.PlaceOrderActionProto.Request.TestProto} TestProto
                     */
                    TestProto.fromObject = function fromObject(object) {
                        if (object instanceof $root.waiternow.common.PlaceOrderActionProto.Request.TestProto)
                            return object;
                        var message = new $root.waiternow.common.PlaceOrderActionProto.Request.TestProto();
                        if (object.isStressTest != null)
                            message.isStressTest = Boolean(object.isStressTest);
                        if (object.emulatePrinter != null)
                            message.emulatePrinter = Boolean(object.emulatePrinter);
                        return message;
                    };

                    /**
                     * Creates a plain object from a TestProto message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof waiternow.common.PlaceOrderActionProto.Request.TestProto
                     * @static
                     * @param {waiternow.common.PlaceOrderActionProto.Request.TestProto} message TestProto
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TestProto.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.isStressTest = false;
                            object.emulatePrinter = false;
                        }
                        if (message.isStressTest != null && message.hasOwnProperty("isStressTest"))
                            object.isStressTest = message.isStressTest;
                        if (message.emulatePrinter != null && message.hasOwnProperty("emulatePrinter"))
                            object.emulatePrinter = message.emulatePrinter;
                        return object;
                    };

                    /**
                     * Converts this TestProto to JSON.
                     * @function toJSON
                     * @memberof waiternow.common.PlaceOrderActionProto.Request.TestProto
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TestProto.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for TestProto
                     * @function getTypeUrl
                     * @memberof waiternow.common.PlaceOrderActionProto.Request.TestProto
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    TestProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/waiternow.common.PlaceOrderActionProto.Request.TestProto";
                    };

                    return TestProto;
                })();

                return Request;
            })();

            PlaceOrderActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.PlaceOrderActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IOrderProto|null} [order] Response order
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.PlaceOrderActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.PlaceOrderActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.PlaceOrderActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response order.
                 * @member {waiternow.common.IOrderProto|null|undefined} order
                 * @memberof waiternow.common.PlaceOrderActionProto.Response
                 * @instance
                 */
                Response.prototype.order = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.PlaceOrderActionProto.Response
                 * @static
                 * @param {waiternow.common.PlaceOrderActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.PlaceOrderActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.PlaceOrderActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.PlaceOrderActionProto.Response
                 * @static
                 * @param {waiternow.common.PlaceOrderActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.order != null && Object.hasOwnProperty.call(message, "order"))
                        $root.waiternow.common.OrderProto.encode(message.order, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.PlaceOrderActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.PlaceOrderActionProto.Response
                 * @static
                 * @param {waiternow.common.PlaceOrderActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.PlaceOrderActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.PlaceOrderActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PlaceOrderActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.order = $root.waiternow.common.OrderProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.PlaceOrderActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.PlaceOrderActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.PlaceOrderActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.order != null && message.hasOwnProperty("order")) {
                        var error = $root.waiternow.common.OrderProto.verify(message.order);
                        if (error)
                            return "order." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.PlaceOrderActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.PlaceOrderActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.PlaceOrderActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.PlaceOrderActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.PlaceOrderActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.order != null) {
                        if (typeof object.order !== "object")
                            throw TypeError(".waiternow.common.PlaceOrderActionProto.Response.order: object expected");
                        message.order = $root.waiternow.common.OrderProto.fromObject(object.order);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.PlaceOrderActionProto.Response
                 * @static
                 * @param {waiternow.common.PlaceOrderActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.order = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.order != null && message.hasOwnProperty("order"))
                        object.order = $root.waiternow.common.OrderProto.toObject(message.order, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.PlaceOrderActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.PlaceOrderActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.PlaceOrderActionProto.Response";
                };

                return Response;
            })();

            return PlaceOrderActionProto;
        })();

        common.CheckOrderStatusActionProto = (function() {

            /**
             * Properties of a CheckOrderStatusActionProto.
             * @memberof waiternow.common
             * @interface ICheckOrderStatusActionProto
             */

            /**
             * Constructs a new CheckOrderStatusActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a CheckOrderStatusActionProto.
             * @implements ICheckOrderStatusActionProto
             * @constructor
             * @param {waiternow.common.ICheckOrderStatusActionProto=} [properties] Properties to set
             */
            function CheckOrderStatusActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new CheckOrderStatusActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.CheckOrderStatusActionProto
             * @static
             * @param {waiternow.common.ICheckOrderStatusActionProto=} [properties] Properties to set
             * @returns {waiternow.common.CheckOrderStatusActionProto} CheckOrderStatusActionProto instance
             */
            CheckOrderStatusActionProto.create = function create(properties) {
                return new CheckOrderStatusActionProto(properties);
            };

            /**
             * Encodes the specified CheckOrderStatusActionProto message. Does not implicitly {@link waiternow.common.CheckOrderStatusActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.CheckOrderStatusActionProto
             * @static
             * @param {waiternow.common.ICheckOrderStatusActionProto} message CheckOrderStatusActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CheckOrderStatusActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified CheckOrderStatusActionProto message, length delimited. Does not implicitly {@link waiternow.common.CheckOrderStatusActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.CheckOrderStatusActionProto
             * @static
             * @param {waiternow.common.ICheckOrderStatusActionProto} message CheckOrderStatusActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CheckOrderStatusActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CheckOrderStatusActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.CheckOrderStatusActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.CheckOrderStatusActionProto} CheckOrderStatusActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CheckOrderStatusActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CheckOrderStatusActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CheckOrderStatusActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.CheckOrderStatusActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.CheckOrderStatusActionProto} CheckOrderStatusActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CheckOrderStatusActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CheckOrderStatusActionProto message.
             * @function verify
             * @memberof waiternow.common.CheckOrderStatusActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CheckOrderStatusActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a CheckOrderStatusActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.CheckOrderStatusActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.CheckOrderStatusActionProto} CheckOrderStatusActionProto
             */
            CheckOrderStatusActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.CheckOrderStatusActionProto)
                    return object;
                return new $root.waiternow.common.CheckOrderStatusActionProto();
            };

            /**
             * Creates a plain object from a CheckOrderStatusActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.CheckOrderStatusActionProto
             * @static
             * @param {waiternow.common.CheckOrderStatusActionProto} message CheckOrderStatusActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CheckOrderStatusActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this CheckOrderStatusActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.CheckOrderStatusActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CheckOrderStatusActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for CheckOrderStatusActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.CheckOrderStatusActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            CheckOrderStatusActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.CheckOrderStatusActionProto";
            };

            CheckOrderStatusActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.CheckOrderStatusActionProto
                 * @interface IRequest
                 * @property {string|null} [orderId] Request orderId
                 * @property {waiternow.common.IConsumerProto|null} [consumer] Request consumer
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.CheckOrderStatusActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.CheckOrderStatusActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request orderId.
                 * @member {string} orderId
                 * @memberof waiternow.common.CheckOrderStatusActionProto.Request
                 * @instance
                 */
                Request.prototype.orderId = "";

                /**
                 * Request consumer.
                 * @member {waiternow.common.IConsumerProto|null|undefined} consumer
                 * @memberof waiternow.common.CheckOrderStatusActionProto.Request
                 * @instance
                 */
                Request.prototype.consumer = null;

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.CheckOrderStatusActionProto.Request
                 * @static
                 * @param {waiternow.common.CheckOrderStatusActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.CheckOrderStatusActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.CheckOrderStatusActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.CheckOrderStatusActionProto.Request
                 * @static
                 * @param {waiternow.common.CheckOrderStatusActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.orderId != null && Object.hasOwnProperty.call(message, "orderId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.orderId);
                    if (message.consumer != null && Object.hasOwnProperty.call(message, "consumer"))
                        $root.waiternow.common.ConsumerProto.encode(message.consumer, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.CheckOrderStatusActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.CheckOrderStatusActionProto.Request
                 * @static
                 * @param {waiternow.common.CheckOrderStatusActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.CheckOrderStatusActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.CheckOrderStatusActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CheckOrderStatusActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.orderId = reader.string();
                                break;
                            }
                        case 2: {
                                message.consumer = $root.waiternow.common.ConsumerProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.CheckOrderStatusActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.CheckOrderStatusActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.CheckOrderStatusActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.orderId != null && message.hasOwnProperty("orderId"))
                        if (!$util.isString(message.orderId))
                            return "orderId: string expected";
                    if (message.consumer != null && message.hasOwnProperty("consumer")) {
                        var error = $root.waiternow.common.ConsumerProto.verify(message.consumer);
                        if (error)
                            return "consumer." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.CheckOrderStatusActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.CheckOrderStatusActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.CheckOrderStatusActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.CheckOrderStatusActionProto.Request();
                    if (object.orderId != null)
                        message.orderId = String(object.orderId);
                    if (object.consumer != null) {
                        if (typeof object.consumer !== "object")
                            throw TypeError(".waiternow.common.CheckOrderStatusActionProto.Request.consumer: object expected");
                        message.consumer = $root.waiternow.common.ConsumerProto.fromObject(object.consumer);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.CheckOrderStatusActionProto.Request
                 * @static
                 * @param {waiternow.common.CheckOrderStatusActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.orderId = "";
                        object.consumer = null;
                    }
                    if (message.orderId != null && message.hasOwnProperty("orderId"))
                        object.orderId = message.orderId;
                    if (message.consumer != null && message.hasOwnProperty("consumer"))
                        object.consumer = $root.waiternow.common.ConsumerProto.toObject(message.consumer, options);
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.CheckOrderStatusActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.CheckOrderStatusActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.CheckOrderStatusActionProto.Request";
                };

                return Request;
            })();

            CheckOrderStatusActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.CheckOrderStatusActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IOrderProto|null} [order] Response order
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.CheckOrderStatusActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.CheckOrderStatusActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.CheckOrderStatusActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response order.
                 * @member {waiternow.common.IOrderProto|null|undefined} order
                 * @memberof waiternow.common.CheckOrderStatusActionProto.Response
                 * @instance
                 */
                Response.prototype.order = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.CheckOrderStatusActionProto.Response
                 * @static
                 * @param {waiternow.common.CheckOrderStatusActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.CheckOrderStatusActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.CheckOrderStatusActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.CheckOrderStatusActionProto.Response
                 * @static
                 * @param {waiternow.common.CheckOrderStatusActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.order != null && Object.hasOwnProperty.call(message, "order"))
                        $root.waiternow.common.OrderProto.encode(message.order, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.CheckOrderStatusActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.CheckOrderStatusActionProto.Response
                 * @static
                 * @param {waiternow.common.CheckOrderStatusActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.CheckOrderStatusActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.CheckOrderStatusActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CheckOrderStatusActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.order = $root.waiternow.common.OrderProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.CheckOrderStatusActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.CheckOrderStatusActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.CheckOrderStatusActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.order != null && message.hasOwnProperty("order")) {
                        var error = $root.waiternow.common.OrderProto.verify(message.order);
                        if (error)
                            return "order." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.CheckOrderStatusActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.CheckOrderStatusActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.CheckOrderStatusActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.CheckOrderStatusActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.CheckOrderStatusActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.order != null) {
                        if (typeof object.order !== "object")
                            throw TypeError(".waiternow.common.CheckOrderStatusActionProto.Response.order: object expected");
                        message.order = $root.waiternow.common.OrderProto.fromObject(object.order);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.CheckOrderStatusActionProto.Response
                 * @static
                 * @param {waiternow.common.CheckOrderStatusActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.order = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.order != null && message.hasOwnProperty("order"))
                        object.order = $root.waiternow.common.OrderProto.toObject(message.order, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.CheckOrderStatusActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.CheckOrderStatusActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.CheckOrderStatusActionProto.Response";
                };

                return Response;
            })();

            return CheckOrderStatusActionProto;
        })();

        common.CheckOrdersStatusActionProto = (function() {

            /**
             * Properties of a CheckOrdersStatusActionProto.
             * @memberof waiternow.common
             * @interface ICheckOrdersStatusActionProto
             */

            /**
             * Constructs a new CheckOrdersStatusActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a CheckOrdersStatusActionProto.
             * @implements ICheckOrdersStatusActionProto
             * @constructor
             * @param {waiternow.common.ICheckOrdersStatusActionProto=} [properties] Properties to set
             */
            function CheckOrdersStatusActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new CheckOrdersStatusActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.CheckOrdersStatusActionProto
             * @static
             * @param {waiternow.common.ICheckOrdersStatusActionProto=} [properties] Properties to set
             * @returns {waiternow.common.CheckOrdersStatusActionProto} CheckOrdersStatusActionProto instance
             */
            CheckOrdersStatusActionProto.create = function create(properties) {
                return new CheckOrdersStatusActionProto(properties);
            };

            /**
             * Encodes the specified CheckOrdersStatusActionProto message. Does not implicitly {@link waiternow.common.CheckOrdersStatusActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.CheckOrdersStatusActionProto
             * @static
             * @param {waiternow.common.ICheckOrdersStatusActionProto} message CheckOrdersStatusActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CheckOrdersStatusActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified CheckOrdersStatusActionProto message, length delimited. Does not implicitly {@link waiternow.common.CheckOrdersStatusActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.CheckOrdersStatusActionProto
             * @static
             * @param {waiternow.common.ICheckOrdersStatusActionProto} message CheckOrdersStatusActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CheckOrdersStatusActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CheckOrdersStatusActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.CheckOrdersStatusActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.CheckOrdersStatusActionProto} CheckOrdersStatusActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CheckOrdersStatusActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CheckOrdersStatusActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CheckOrdersStatusActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.CheckOrdersStatusActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.CheckOrdersStatusActionProto} CheckOrdersStatusActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CheckOrdersStatusActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CheckOrdersStatusActionProto message.
             * @function verify
             * @memberof waiternow.common.CheckOrdersStatusActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CheckOrdersStatusActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a CheckOrdersStatusActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.CheckOrdersStatusActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.CheckOrdersStatusActionProto} CheckOrdersStatusActionProto
             */
            CheckOrdersStatusActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.CheckOrdersStatusActionProto)
                    return object;
                return new $root.waiternow.common.CheckOrdersStatusActionProto();
            };

            /**
             * Creates a plain object from a CheckOrdersStatusActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.CheckOrdersStatusActionProto
             * @static
             * @param {waiternow.common.CheckOrdersStatusActionProto} message CheckOrdersStatusActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CheckOrdersStatusActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this CheckOrdersStatusActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.CheckOrdersStatusActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CheckOrdersStatusActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for CheckOrdersStatusActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.CheckOrdersStatusActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            CheckOrdersStatusActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.CheckOrdersStatusActionProto";
            };

            CheckOrdersStatusActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.CheckOrdersStatusActionProto
                 * @interface IRequest
                 * @property {Array.<string>|null} [orderIds] Request orderIds
                 * @property {waiternow.common.IConsumerProto|null} [consumer] Request consumer
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.CheckOrdersStatusActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.CheckOrdersStatusActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    this.orderIds = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request orderIds.
                 * @member {Array.<string>} orderIds
                 * @memberof waiternow.common.CheckOrdersStatusActionProto.Request
                 * @instance
                 */
                Request.prototype.orderIds = $util.emptyArray;

                /**
                 * Request consumer.
                 * @member {waiternow.common.IConsumerProto|null|undefined} consumer
                 * @memberof waiternow.common.CheckOrdersStatusActionProto.Request
                 * @instance
                 */
                Request.prototype.consumer = null;

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.CheckOrdersStatusActionProto.Request
                 * @static
                 * @param {waiternow.common.CheckOrdersStatusActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.CheckOrdersStatusActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.CheckOrdersStatusActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.CheckOrdersStatusActionProto.Request
                 * @static
                 * @param {waiternow.common.CheckOrdersStatusActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.orderIds != null && message.orderIds.length)
                        for (var i = 0; i < message.orderIds.length; ++i)
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.orderIds[i]);
                    if (message.consumer != null && Object.hasOwnProperty.call(message, "consumer"))
                        $root.waiternow.common.ConsumerProto.encode(message.consumer, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.CheckOrdersStatusActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.CheckOrdersStatusActionProto.Request
                 * @static
                 * @param {waiternow.common.CheckOrdersStatusActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.CheckOrdersStatusActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.CheckOrdersStatusActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CheckOrdersStatusActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                if (!(message.orderIds && message.orderIds.length))
                                    message.orderIds = [];
                                message.orderIds.push(reader.string());
                                break;
                            }
                        case 2: {
                                message.consumer = $root.waiternow.common.ConsumerProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.CheckOrdersStatusActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.CheckOrdersStatusActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.CheckOrdersStatusActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.orderIds != null && message.hasOwnProperty("orderIds")) {
                        if (!Array.isArray(message.orderIds))
                            return "orderIds: array expected";
                        for (var i = 0; i < message.orderIds.length; ++i)
                            if (!$util.isString(message.orderIds[i]))
                                return "orderIds: string[] expected";
                    }
                    if (message.consumer != null && message.hasOwnProperty("consumer")) {
                        var error = $root.waiternow.common.ConsumerProto.verify(message.consumer);
                        if (error)
                            return "consumer." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.CheckOrdersStatusActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.CheckOrdersStatusActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.CheckOrdersStatusActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.CheckOrdersStatusActionProto.Request();
                    if (object.orderIds) {
                        if (!Array.isArray(object.orderIds))
                            throw TypeError(".waiternow.common.CheckOrdersStatusActionProto.Request.orderIds: array expected");
                        message.orderIds = [];
                        for (var i = 0; i < object.orderIds.length; ++i)
                            message.orderIds[i] = String(object.orderIds[i]);
                    }
                    if (object.consumer != null) {
                        if (typeof object.consumer !== "object")
                            throw TypeError(".waiternow.common.CheckOrdersStatusActionProto.Request.consumer: object expected");
                        message.consumer = $root.waiternow.common.ConsumerProto.fromObject(object.consumer);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.CheckOrdersStatusActionProto.Request
                 * @static
                 * @param {waiternow.common.CheckOrdersStatusActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.orderIds = [];
                    if (options.defaults)
                        object.consumer = null;
                    if (message.orderIds && message.orderIds.length) {
                        object.orderIds = [];
                        for (var j = 0; j < message.orderIds.length; ++j)
                            object.orderIds[j] = message.orderIds[j];
                    }
                    if (message.consumer != null && message.hasOwnProperty("consumer"))
                        object.consumer = $root.waiternow.common.ConsumerProto.toObject(message.consumer, options);
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.CheckOrdersStatusActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.CheckOrdersStatusActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.CheckOrdersStatusActionProto.Request";
                };

                return Request;
            })();

            CheckOrdersStatusActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.CheckOrdersStatusActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {Array.<waiternow.common.IOrderProto>|null} [orders] Response orders
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.CheckOrdersStatusActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.CheckOrdersStatusActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    this.orders = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.CheckOrdersStatusActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response orders.
                 * @member {Array.<waiternow.common.IOrderProto>} orders
                 * @memberof waiternow.common.CheckOrdersStatusActionProto.Response
                 * @instance
                 */
                Response.prototype.orders = $util.emptyArray;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.CheckOrdersStatusActionProto.Response
                 * @static
                 * @param {waiternow.common.CheckOrdersStatusActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.CheckOrdersStatusActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.CheckOrdersStatusActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.CheckOrdersStatusActionProto.Response
                 * @static
                 * @param {waiternow.common.CheckOrdersStatusActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.orders != null && message.orders.length)
                        for (var i = 0; i < message.orders.length; ++i)
                            $root.waiternow.common.OrderProto.encode(message.orders[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.CheckOrdersStatusActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.CheckOrdersStatusActionProto.Response
                 * @static
                 * @param {waiternow.common.CheckOrdersStatusActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.CheckOrdersStatusActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.CheckOrdersStatusActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CheckOrdersStatusActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                if (!(message.orders && message.orders.length))
                                    message.orders = [];
                                message.orders.push($root.waiternow.common.OrderProto.decode(reader, reader.uint32()));
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.CheckOrdersStatusActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.CheckOrdersStatusActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.CheckOrdersStatusActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.orders != null && message.hasOwnProperty("orders")) {
                        if (!Array.isArray(message.orders))
                            return "orders: array expected";
                        for (var i = 0; i < message.orders.length; ++i) {
                            var error = $root.waiternow.common.OrderProto.verify(message.orders[i]);
                            if (error)
                                return "orders." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.CheckOrdersStatusActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.CheckOrdersStatusActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.CheckOrdersStatusActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.CheckOrdersStatusActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.CheckOrdersStatusActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.orders) {
                        if (!Array.isArray(object.orders))
                            throw TypeError(".waiternow.common.CheckOrdersStatusActionProto.Response.orders: array expected");
                        message.orders = [];
                        for (var i = 0; i < object.orders.length; ++i) {
                            if (typeof object.orders[i] !== "object")
                                throw TypeError(".waiternow.common.CheckOrdersStatusActionProto.Response.orders: object expected");
                            message.orders[i] = $root.waiternow.common.OrderProto.fromObject(object.orders[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.CheckOrdersStatusActionProto.Response
                 * @static
                 * @param {waiternow.common.CheckOrdersStatusActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.orders = [];
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.orders && message.orders.length) {
                        object.orders = [];
                        for (var j = 0; j < message.orders.length; ++j)
                            object.orders[j] = $root.waiternow.common.OrderProto.toObject(message.orders[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.CheckOrdersStatusActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.CheckOrdersStatusActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.CheckOrdersStatusActionProto.Response";
                };

                return Response;
            })();

            return CheckOrdersStatusActionProto;
        })();

        common.PostReviewActionProto = (function() {

            /**
             * Properties of a PostReviewActionProto.
             * @memberof waiternow.common
             * @interface IPostReviewActionProto
             */

            /**
             * Constructs a new PostReviewActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a PostReviewActionProto.
             * @implements IPostReviewActionProto
             * @constructor
             * @param {waiternow.common.IPostReviewActionProto=} [properties] Properties to set
             */
            function PostReviewActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new PostReviewActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.PostReviewActionProto
             * @static
             * @param {waiternow.common.IPostReviewActionProto=} [properties] Properties to set
             * @returns {waiternow.common.PostReviewActionProto} PostReviewActionProto instance
             */
            PostReviewActionProto.create = function create(properties) {
                return new PostReviewActionProto(properties);
            };

            /**
             * Encodes the specified PostReviewActionProto message. Does not implicitly {@link waiternow.common.PostReviewActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.PostReviewActionProto
             * @static
             * @param {waiternow.common.IPostReviewActionProto} message PostReviewActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PostReviewActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified PostReviewActionProto message, length delimited. Does not implicitly {@link waiternow.common.PostReviewActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.PostReviewActionProto
             * @static
             * @param {waiternow.common.IPostReviewActionProto} message PostReviewActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PostReviewActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a PostReviewActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.PostReviewActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.PostReviewActionProto} PostReviewActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PostReviewActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PostReviewActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a PostReviewActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.PostReviewActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.PostReviewActionProto} PostReviewActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PostReviewActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a PostReviewActionProto message.
             * @function verify
             * @memberof waiternow.common.PostReviewActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            PostReviewActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a PostReviewActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.PostReviewActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.PostReviewActionProto} PostReviewActionProto
             */
            PostReviewActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.PostReviewActionProto)
                    return object;
                return new $root.waiternow.common.PostReviewActionProto();
            };

            /**
             * Creates a plain object from a PostReviewActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.PostReviewActionProto
             * @static
             * @param {waiternow.common.PostReviewActionProto} message PostReviewActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            PostReviewActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this PostReviewActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.PostReviewActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            PostReviewActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for PostReviewActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.PostReviewActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            PostReviewActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.PostReviewActionProto";
            };

            PostReviewActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.PostReviewActionProto
                 * @interface IRequest
                 * @property {string|null} [locationId] Request locationId
                 * @property {string|null} [pointOfServiceId] Request pointOfServiceId
                 * @property {waiternow.common.IReviewProto|null} [review] Request review
                 * @property {waiternow.common.IConsumerProto|null} [consumer] Request consumer
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.PostReviewActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.PostReviewActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request locationId.
                 * @member {string|null|undefined} locationId
                 * @memberof waiternow.common.PostReviewActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = null;

                /**
                 * Request pointOfServiceId.
                 * @member {string|null|undefined} pointOfServiceId
                 * @memberof waiternow.common.PostReviewActionProto.Request
                 * @instance
                 */
                Request.prototype.pointOfServiceId = null;

                /**
                 * Request review.
                 * @member {waiternow.common.IReviewProto|null|undefined} review
                 * @memberof waiternow.common.PostReviewActionProto.Request
                 * @instance
                 */
                Request.prototype.review = null;

                /**
                 * Request consumer.
                 * @member {waiternow.common.IConsumerProto|null|undefined} consumer
                 * @memberof waiternow.common.PostReviewActionProto.Request
                 * @instance
                 */
                Request.prototype.consumer = null;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * Request locationInfo.
                 * @member {"locationId"|"pointOfServiceId"|undefined} locationInfo
                 * @memberof waiternow.common.PostReviewActionProto.Request
                 * @instance
                 */
                Object.defineProperty(Request.prototype, "locationInfo", {
                    get: $util.oneOfGetter($oneOfFields = ["locationId", "pointOfServiceId"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.PostReviewActionProto.Request
                 * @static
                 * @param {waiternow.common.PostReviewActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.PostReviewActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.PostReviewActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.PostReviewActionProto.Request
                 * @static
                 * @param {waiternow.common.PostReviewActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    if (message.pointOfServiceId != null && Object.hasOwnProperty.call(message, "pointOfServiceId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.pointOfServiceId);
                    if (message.review != null && Object.hasOwnProperty.call(message, "review"))
                        $root.waiternow.common.ReviewProto.encode(message.review, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.consumer != null && Object.hasOwnProperty.call(message, "consumer"))
                        $root.waiternow.common.ConsumerProto.encode(message.consumer, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.PostReviewActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.PostReviewActionProto.Request
                 * @static
                 * @param {waiternow.common.PostReviewActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.PostReviewActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.PostReviewActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PostReviewActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 2: {
                                message.pointOfServiceId = reader.string();
                                break;
                            }
                        case 3: {
                                message.review = $root.waiternow.common.ReviewProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 4: {
                                message.consumer = $root.waiternow.common.ConsumerProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.PostReviewActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.PostReviewActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.PostReviewActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.locationId != null && message.hasOwnProperty("locationId")) {
                        properties.locationInfo = 1;
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    }
                    if (message.pointOfServiceId != null && message.hasOwnProperty("pointOfServiceId")) {
                        if (properties.locationInfo === 1)
                            return "locationInfo: multiple values";
                        properties.locationInfo = 1;
                        if (!$util.isString(message.pointOfServiceId))
                            return "pointOfServiceId: string expected";
                    }
                    if (message.review != null && message.hasOwnProperty("review")) {
                        var error = $root.waiternow.common.ReviewProto.verify(message.review);
                        if (error)
                            return "review." + error;
                    }
                    if (message.consumer != null && message.hasOwnProperty("consumer")) {
                        var error = $root.waiternow.common.ConsumerProto.verify(message.consumer);
                        if (error)
                            return "consumer." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.PostReviewActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.PostReviewActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.PostReviewActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.PostReviewActionProto.Request();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    if (object.pointOfServiceId != null)
                        message.pointOfServiceId = String(object.pointOfServiceId);
                    if (object.review != null) {
                        if (typeof object.review !== "object")
                            throw TypeError(".waiternow.common.PostReviewActionProto.Request.review: object expected");
                        message.review = $root.waiternow.common.ReviewProto.fromObject(object.review);
                    }
                    if (object.consumer != null) {
                        if (typeof object.consumer !== "object")
                            throw TypeError(".waiternow.common.PostReviewActionProto.Request.consumer: object expected");
                        message.consumer = $root.waiternow.common.ConsumerProto.fromObject(object.consumer);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.PostReviewActionProto.Request
                 * @static
                 * @param {waiternow.common.PostReviewActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.review = null;
                        object.consumer = null;
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId")) {
                        object.locationId = message.locationId;
                        if (options.oneofs)
                            object.locationInfo = "locationId";
                    }
                    if (message.pointOfServiceId != null && message.hasOwnProperty("pointOfServiceId")) {
                        object.pointOfServiceId = message.pointOfServiceId;
                        if (options.oneofs)
                            object.locationInfo = "pointOfServiceId";
                    }
                    if (message.review != null && message.hasOwnProperty("review"))
                        object.review = $root.waiternow.common.ReviewProto.toObject(message.review, options);
                    if (message.consumer != null && message.hasOwnProperty("consumer"))
                        object.consumer = $root.waiternow.common.ConsumerProto.toObject(message.consumer, options);
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.PostReviewActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.PostReviewActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.PostReviewActionProto.Request";
                };

                return Request;
            })();

            PostReviewActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.PostReviewActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IReviewProto|null} [review] Response review
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.PostReviewActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.PostReviewActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.PostReviewActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response review.
                 * @member {waiternow.common.IReviewProto|null|undefined} review
                 * @memberof waiternow.common.PostReviewActionProto.Response
                 * @instance
                 */
                Response.prototype.review = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.PostReviewActionProto.Response
                 * @static
                 * @param {waiternow.common.PostReviewActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.PostReviewActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.PostReviewActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.PostReviewActionProto.Response
                 * @static
                 * @param {waiternow.common.PostReviewActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.review != null && Object.hasOwnProperty.call(message, "review"))
                        $root.waiternow.common.ReviewProto.encode(message.review, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.PostReviewActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.PostReviewActionProto.Response
                 * @static
                 * @param {waiternow.common.PostReviewActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.PostReviewActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.PostReviewActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PostReviewActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.review = $root.waiternow.common.ReviewProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.PostReviewActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.PostReviewActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.PostReviewActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.review != null && message.hasOwnProperty("review")) {
                        var error = $root.waiternow.common.ReviewProto.verify(message.review);
                        if (error)
                            return "review." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.PostReviewActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.PostReviewActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.PostReviewActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.PostReviewActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.PostReviewActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.review != null) {
                        if (typeof object.review !== "object")
                            throw TypeError(".waiternow.common.PostReviewActionProto.Response.review: object expected");
                        message.review = $root.waiternow.common.ReviewProto.fromObject(object.review);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.PostReviewActionProto.Response
                 * @static
                 * @param {waiternow.common.PostReviewActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.review = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.review != null && message.hasOwnProperty("review"))
                        object.review = $root.waiternow.common.ReviewProto.toObject(message.review, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.PostReviewActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.PostReviewActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.PostReviewActionProto.Response";
                };

                return Response;
            })();

            return PostReviewActionProto;
        })();

        common.PostConsumerFeedbackActionProto = (function() {

            /**
             * Properties of a PostConsumerFeedbackActionProto.
             * @memberof waiternow.common
             * @interface IPostConsumerFeedbackActionProto
             */

            /**
             * Constructs a new PostConsumerFeedbackActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a PostConsumerFeedbackActionProto.
             * @implements IPostConsumerFeedbackActionProto
             * @constructor
             * @param {waiternow.common.IPostConsumerFeedbackActionProto=} [properties] Properties to set
             */
            function PostConsumerFeedbackActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new PostConsumerFeedbackActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.PostConsumerFeedbackActionProto
             * @static
             * @param {waiternow.common.IPostConsumerFeedbackActionProto=} [properties] Properties to set
             * @returns {waiternow.common.PostConsumerFeedbackActionProto} PostConsumerFeedbackActionProto instance
             */
            PostConsumerFeedbackActionProto.create = function create(properties) {
                return new PostConsumerFeedbackActionProto(properties);
            };

            /**
             * Encodes the specified PostConsumerFeedbackActionProto message. Does not implicitly {@link waiternow.common.PostConsumerFeedbackActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.PostConsumerFeedbackActionProto
             * @static
             * @param {waiternow.common.IPostConsumerFeedbackActionProto} message PostConsumerFeedbackActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PostConsumerFeedbackActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified PostConsumerFeedbackActionProto message, length delimited. Does not implicitly {@link waiternow.common.PostConsumerFeedbackActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.PostConsumerFeedbackActionProto
             * @static
             * @param {waiternow.common.IPostConsumerFeedbackActionProto} message PostConsumerFeedbackActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PostConsumerFeedbackActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a PostConsumerFeedbackActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.PostConsumerFeedbackActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.PostConsumerFeedbackActionProto} PostConsumerFeedbackActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PostConsumerFeedbackActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PostConsumerFeedbackActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a PostConsumerFeedbackActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.PostConsumerFeedbackActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.PostConsumerFeedbackActionProto} PostConsumerFeedbackActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PostConsumerFeedbackActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a PostConsumerFeedbackActionProto message.
             * @function verify
             * @memberof waiternow.common.PostConsumerFeedbackActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            PostConsumerFeedbackActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a PostConsumerFeedbackActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.PostConsumerFeedbackActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.PostConsumerFeedbackActionProto} PostConsumerFeedbackActionProto
             */
            PostConsumerFeedbackActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.PostConsumerFeedbackActionProto)
                    return object;
                return new $root.waiternow.common.PostConsumerFeedbackActionProto();
            };

            /**
             * Creates a plain object from a PostConsumerFeedbackActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.PostConsumerFeedbackActionProto
             * @static
             * @param {waiternow.common.PostConsumerFeedbackActionProto} message PostConsumerFeedbackActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            PostConsumerFeedbackActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this PostConsumerFeedbackActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.PostConsumerFeedbackActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            PostConsumerFeedbackActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for PostConsumerFeedbackActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.PostConsumerFeedbackActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            PostConsumerFeedbackActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.PostConsumerFeedbackActionProto";
            };

            PostConsumerFeedbackActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.PostConsumerFeedbackActionProto
                 * @interface IRequest
                 * @property {string|null} [locationId] Request locationId
                 * @property {string|null} [pointOfServiceId] Request pointOfServiceId
                 * @property {string|null} [deviceId] Request deviceId
                 * @property {waiternow.common.IConsumerProto|null} [consumer] Request consumer
                 * @property {waiternow.common.PostConsumerFeedbackActionProto.Request.IIssueOrderingProto|null} [issueOrdering] Request issueOrdering
                 * @property {waiternow.common.PostConsumerFeedbackActionProto.Request.IReviewForBusinessProto|null} [reviewForBusiness] Request reviewForBusiness
                 * @property {waiternow.common.PostConsumerFeedbackActionProto.Request.IReviewForPlatformProto|null} [reviewForPlatform] Request reviewForPlatform
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.PostConsumerFeedbackActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.PostConsumerFeedbackActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = "";

                /**
                 * Request pointOfServiceId.
                 * @member {string} pointOfServiceId
                 * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request
                 * @instance
                 */
                Request.prototype.pointOfServiceId = "";

                /**
                 * Request deviceId.
                 * @member {string} deviceId
                 * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request
                 * @instance
                 */
                Request.prototype.deviceId = "";

                /**
                 * Request consumer.
                 * @member {waiternow.common.IConsumerProto|null|undefined} consumer
                 * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request
                 * @instance
                 */
                Request.prototype.consumer = null;

                /**
                 * Request issueOrdering.
                 * @member {waiternow.common.PostConsumerFeedbackActionProto.Request.IIssueOrderingProto|null|undefined} issueOrdering
                 * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request
                 * @instance
                 */
                Request.prototype.issueOrdering = null;

                /**
                 * Request reviewForBusiness.
                 * @member {waiternow.common.PostConsumerFeedbackActionProto.Request.IReviewForBusinessProto|null|undefined} reviewForBusiness
                 * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request
                 * @instance
                 */
                Request.prototype.reviewForBusiness = null;

                /**
                 * Request reviewForPlatform.
                 * @member {waiternow.common.PostConsumerFeedbackActionProto.Request.IReviewForPlatformProto|null|undefined} reviewForPlatform
                 * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request
                 * @instance
                 */
                Request.prototype.reviewForPlatform = null;

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request
                 * @static
                 * @param {waiternow.common.PostConsumerFeedbackActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.PostConsumerFeedbackActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.PostConsumerFeedbackActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request
                 * @static
                 * @param {waiternow.common.PostConsumerFeedbackActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    if (message.pointOfServiceId != null && Object.hasOwnProperty.call(message, "pointOfServiceId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.pointOfServiceId);
                    if (message.deviceId != null && Object.hasOwnProperty.call(message, "deviceId"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.deviceId);
                    if (message.consumer != null && Object.hasOwnProperty.call(message, "consumer"))
                        $root.waiternow.common.ConsumerProto.encode(message.consumer, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.issueOrdering != null && Object.hasOwnProperty.call(message, "issueOrdering"))
                        $root.waiternow.common.PostConsumerFeedbackActionProto.Request.IssueOrderingProto.encode(message.issueOrdering, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.reviewForBusiness != null && Object.hasOwnProperty.call(message, "reviewForBusiness"))
                        $root.waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForBusinessProto.encode(message.reviewForBusiness, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.reviewForPlatform != null && Object.hasOwnProperty.call(message, "reviewForPlatform"))
                        $root.waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForPlatformProto.encode(message.reviewForPlatform, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.PostConsumerFeedbackActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request
                 * @static
                 * @param {waiternow.common.PostConsumerFeedbackActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.PostConsumerFeedbackActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PostConsumerFeedbackActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 2: {
                                message.pointOfServiceId = reader.string();
                                break;
                            }
                        case 3: {
                                message.deviceId = reader.string();
                                break;
                            }
                        case 4: {
                                message.consumer = $root.waiternow.common.ConsumerProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 5: {
                                message.issueOrdering = $root.waiternow.common.PostConsumerFeedbackActionProto.Request.IssueOrderingProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 6: {
                                message.reviewForBusiness = $root.waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForBusinessProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 7: {
                                message.reviewForPlatform = $root.waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForPlatformProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.PostConsumerFeedbackActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    if (message.pointOfServiceId != null && message.hasOwnProperty("pointOfServiceId"))
                        if (!$util.isString(message.pointOfServiceId))
                            return "pointOfServiceId: string expected";
                    if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                        if (!$util.isString(message.deviceId))
                            return "deviceId: string expected";
                    if (message.consumer != null && message.hasOwnProperty("consumer")) {
                        var error = $root.waiternow.common.ConsumerProto.verify(message.consumer);
                        if (error)
                            return "consumer." + error;
                    }
                    if (message.issueOrdering != null && message.hasOwnProperty("issueOrdering")) {
                        var error = $root.waiternow.common.PostConsumerFeedbackActionProto.Request.IssueOrderingProto.verify(message.issueOrdering);
                        if (error)
                            return "issueOrdering." + error;
                    }
                    if (message.reviewForBusiness != null && message.hasOwnProperty("reviewForBusiness")) {
                        var error = $root.waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForBusinessProto.verify(message.reviewForBusiness);
                        if (error)
                            return "reviewForBusiness." + error;
                    }
                    if (message.reviewForPlatform != null && message.hasOwnProperty("reviewForPlatform")) {
                        var error = $root.waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForPlatformProto.verify(message.reviewForPlatform);
                        if (error)
                            return "reviewForPlatform." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.PostConsumerFeedbackActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.PostConsumerFeedbackActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.PostConsumerFeedbackActionProto.Request();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    if (object.pointOfServiceId != null)
                        message.pointOfServiceId = String(object.pointOfServiceId);
                    if (object.deviceId != null)
                        message.deviceId = String(object.deviceId);
                    if (object.consumer != null) {
                        if (typeof object.consumer !== "object")
                            throw TypeError(".waiternow.common.PostConsumerFeedbackActionProto.Request.consumer: object expected");
                        message.consumer = $root.waiternow.common.ConsumerProto.fromObject(object.consumer);
                    }
                    if (object.issueOrdering != null) {
                        if (typeof object.issueOrdering !== "object")
                            throw TypeError(".waiternow.common.PostConsumerFeedbackActionProto.Request.issueOrdering: object expected");
                        message.issueOrdering = $root.waiternow.common.PostConsumerFeedbackActionProto.Request.IssueOrderingProto.fromObject(object.issueOrdering);
                    }
                    if (object.reviewForBusiness != null) {
                        if (typeof object.reviewForBusiness !== "object")
                            throw TypeError(".waiternow.common.PostConsumerFeedbackActionProto.Request.reviewForBusiness: object expected");
                        message.reviewForBusiness = $root.waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForBusinessProto.fromObject(object.reviewForBusiness);
                    }
                    if (object.reviewForPlatform != null) {
                        if (typeof object.reviewForPlatform !== "object")
                            throw TypeError(".waiternow.common.PostConsumerFeedbackActionProto.Request.reviewForPlatform: object expected");
                        message.reviewForPlatform = $root.waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForPlatformProto.fromObject(object.reviewForPlatform);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request
                 * @static
                 * @param {waiternow.common.PostConsumerFeedbackActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.locationId = "";
                        object.pointOfServiceId = "";
                        object.deviceId = "";
                        object.consumer = null;
                        object.issueOrdering = null;
                        object.reviewForBusiness = null;
                        object.reviewForPlatform = null;
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    if (message.pointOfServiceId != null && message.hasOwnProperty("pointOfServiceId"))
                        object.pointOfServiceId = message.pointOfServiceId;
                    if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                        object.deviceId = message.deviceId;
                    if (message.consumer != null && message.hasOwnProperty("consumer"))
                        object.consumer = $root.waiternow.common.ConsumerProto.toObject(message.consumer, options);
                    if (message.issueOrdering != null && message.hasOwnProperty("issueOrdering"))
                        object.issueOrdering = $root.waiternow.common.PostConsumerFeedbackActionProto.Request.IssueOrderingProto.toObject(message.issueOrdering, options);
                    if (message.reviewForBusiness != null && message.hasOwnProperty("reviewForBusiness"))
                        object.reviewForBusiness = $root.waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForBusinessProto.toObject(message.reviewForBusiness, options);
                    if (message.reviewForPlatform != null && message.hasOwnProperty("reviewForPlatform"))
                        object.reviewForPlatform = $root.waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForPlatformProto.toObject(message.reviewForPlatform, options);
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.PostConsumerFeedbackActionProto.Request";
                };

                Request.IssueOrderingProto = (function() {

                    /**
                     * Properties of an IssueOrderingProto.
                     * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request
                     * @interface IIssueOrderingProto
                     * @property {string|null} [problemWithOrder] IssueOrderingProto problemWithOrder
                     */

                    /**
                     * Constructs a new IssueOrderingProto.
                     * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request
                     * @classdesc Represents an IssueOrderingProto.
                     * @implements IIssueOrderingProto
                     * @constructor
                     * @param {waiternow.common.PostConsumerFeedbackActionProto.Request.IIssueOrderingProto=} [properties] Properties to set
                     */
                    function IssueOrderingProto(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * IssueOrderingProto problemWithOrder.
                     * @member {string} problemWithOrder
                     * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request.IssueOrderingProto
                     * @instance
                     */
                    IssueOrderingProto.prototype.problemWithOrder = "";

                    /**
                     * Creates a new IssueOrderingProto instance using the specified properties.
                     * @function create
                     * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request.IssueOrderingProto
                     * @static
                     * @param {waiternow.common.PostConsumerFeedbackActionProto.Request.IIssueOrderingProto=} [properties] Properties to set
                     * @returns {waiternow.common.PostConsumerFeedbackActionProto.Request.IssueOrderingProto} IssueOrderingProto instance
                     */
                    IssueOrderingProto.create = function create(properties) {
                        return new IssueOrderingProto(properties);
                    };

                    /**
                     * Encodes the specified IssueOrderingProto message. Does not implicitly {@link waiternow.common.PostConsumerFeedbackActionProto.Request.IssueOrderingProto.verify|verify} messages.
                     * @function encode
                     * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request.IssueOrderingProto
                     * @static
                     * @param {waiternow.common.PostConsumerFeedbackActionProto.Request.IIssueOrderingProto} message IssueOrderingProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    IssueOrderingProto.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.problemWithOrder != null && Object.hasOwnProperty.call(message, "problemWithOrder"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.problemWithOrder);
                        return writer;
                    };

                    /**
                     * Encodes the specified IssueOrderingProto message, length delimited. Does not implicitly {@link waiternow.common.PostConsumerFeedbackActionProto.Request.IssueOrderingProto.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request.IssueOrderingProto
                     * @static
                     * @param {waiternow.common.PostConsumerFeedbackActionProto.Request.IIssueOrderingProto} message IssueOrderingProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    IssueOrderingProto.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an IssueOrderingProto message from the specified reader or buffer.
                     * @function decode
                     * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request.IssueOrderingProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {waiternow.common.PostConsumerFeedbackActionProto.Request.IssueOrderingProto} IssueOrderingProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    IssueOrderingProto.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PostConsumerFeedbackActionProto.Request.IssueOrderingProto();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.problemWithOrder = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an IssueOrderingProto message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request.IssueOrderingProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {waiternow.common.PostConsumerFeedbackActionProto.Request.IssueOrderingProto} IssueOrderingProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    IssueOrderingProto.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an IssueOrderingProto message.
                     * @function verify
                     * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request.IssueOrderingProto
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    IssueOrderingProto.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.problemWithOrder != null && message.hasOwnProperty("problemWithOrder"))
                            if (!$util.isString(message.problemWithOrder))
                                return "problemWithOrder: string expected";
                        return null;
                    };

                    /**
                     * Creates an IssueOrderingProto message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request.IssueOrderingProto
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {waiternow.common.PostConsumerFeedbackActionProto.Request.IssueOrderingProto} IssueOrderingProto
                     */
                    IssueOrderingProto.fromObject = function fromObject(object) {
                        if (object instanceof $root.waiternow.common.PostConsumerFeedbackActionProto.Request.IssueOrderingProto)
                            return object;
                        var message = new $root.waiternow.common.PostConsumerFeedbackActionProto.Request.IssueOrderingProto();
                        if (object.problemWithOrder != null)
                            message.problemWithOrder = String(object.problemWithOrder);
                        return message;
                    };

                    /**
                     * Creates a plain object from an IssueOrderingProto message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request.IssueOrderingProto
                     * @static
                     * @param {waiternow.common.PostConsumerFeedbackActionProto.Request.IssueOrderingProto} message IssueOrderingProto
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    IssueOrderingProto.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.problemWithOrder = "";
                        if (message.problemWithOrder != null && message.hasOwnProperty("problemWithOrder"))
                            object.problemWithOrder = message.problemWithOrder;
                        return object;
                    };

                    /**
                     * Converts this IssueOrderingProto to JSON.
                     * @function toJSON
                     * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request.IssueOrderingProto
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    IssueOrderingProto.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for IssueOrderingProto
                     * @function getTypeUrl
                     * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request.IssueOrderingProto
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    IssueOrderingProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/waiternow.common.PostConsumerFeedbackActionProto.Request.IssueOrderingProto";
                    };

                    return IssueOrderingProto;
                })();

                Request.ReviewForBusinessProto = (function() {

                    /**
                     * Properties of a ReviewForBusinessProto.
                     * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request
                     * @interface IReviewForBusinessProto
                     * @property {waiternow.common.Rating|null} [rating] ReviewForBusinessProto rating
                     * @property {string|null} [review] ReviewForBusinessProto review
                     */

                    /**
                     * Constructs a new ReviewForBusinessProto.
                     * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request
                     * @classdesc Represents a ReviewForBusinessProto.
                     * @implements IReviewForBusinessProto
                     * @constructor
                     * @param {waiternow.common.PostConsumerFeedbackActionProto.Request.IReviewForBusinessProto=} [properties] Properties to set
                     */
                    function ReviewForBusinessProto(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * ReviewForBusinessProto rating.
                     * @member {waiternow.common.Rating} rating
                     * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForBusinessProto
                     * @instance
                     */
                    ReviewForBusinessProto.prototype.rating = 0;

                    /**
                     * ReviewForBusinessProto review.
                     * @member {string} review
                     * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForBusinessProto
                     * @instance
                     */
                    ReviewForBusinessProto.prototype.review = "";

                    /**
                     * Creates a new ReviewForBusinessProto instance using the specified properties.
                     * @function create
                     * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForBusinessProto
                     * @static
                     * @param {waiternow.common.PostConsumerFeedbackActionProto.Request.IReviewForBusinessProto=} [properties] Properties to set
                     * @returns {waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForBusinessProto} ReviewForBusinessProto instance
                     */
                    ReviewForBusinessProto.create = function create(properties) {
                        return new ReviewForBusinessProto(properties);
                    };

                    /**
                     * Encodes the specified ReviewForBusinessProto message. Does not implicitly {@link waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForBusinessProto.verify|verify} messages.
                     * @function encode
                     * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForBusinessProto
                     * @static
                     * @param {waiternow.common.PostConsumerFeedbackActionProto.Request.IReviewForBusinessProto} message ReviewForBusinessProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ReviewForBusinessProto.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.rating != null && Object.hasOwnProperty.call(message, "rating"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.rating);
                        if (message.review != null && Object.hasOwnProperty.call(message, "review"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.review);
                        return writer;
                    };

                    /**
                     * Encodes the specified ReviewForBusinessProto message, length delimited. Does not implicitly {@link waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForBusinessProto.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForBusinessProto
                     * @static
                     * @param {waiternow.common.PostConsumerFeedbackActionProto.Request.IReviewForBusinessProto} message ReviewForBusinessProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ReviewForBusinessProto.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a ReviewForBusinessProto message from the specified reader or buffer.
                     * @function decode
                     * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForBusinessProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForBusinessProto} ReviewForBusinessProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ReviewForBusinessProto.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForBusinessProto();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.rating = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.review = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a ReviewForBusinessProto message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForBusinessProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForBusinessProto} ReviewForBusinessProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ReviewForBusinessProto.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a ReviewForBusinessProto message.
                     * @function verify
                     * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForBusinessProto
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ReviewForBusinessProto.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.rating != null && message.hasOwnProperty("rating"))
                            switch (message.rating) {
                            default:
                                return "rating: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                                break;
                            }
                        if (message.review != null && message.hasOwnProperty("review"))
                            if (!$util.isString(message.review))
                                return "review: string expected";
                        return null;
                    };

                    /**
                     * Creates a ReviewForBusinessProto message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForBusinessProto
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForBusinessProto} ReviewForBusinessProto
                     */
                    ReviewForBusinessProto.fromObject = function fromObject(object) {
                        if (object instanceof $root.waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForBusinessProto)
                            return object;
                        var message = new $root.waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForBusinessProto();
                        switch (object.rating) {
                        default:
                            if (typeof object.rating === "number") {
                                message.rating = object.rating;
                                break;
                            }
                            break;
                        case "RATING_UNSPECIFIED":
                        case 0:
                            message.rating = 0;
                            break;
                        case "ONE_STAR":
                        case 1:
                            message.rating = 1;
                            break;
                        case "TWO_STARS":
                        case 2:
                            message.rating = 2;
                            break;
                        case "THREE_STARS":
                        case 3:
                            message.rating = 3;
                            break;
                        case "FOUR_STARS":
                        case 4:
                            message.rating = 4;
                            break;
                        case "FIVE_STARS":
                        case 5:
                            message.rating = 5;
                            break;
                        }
                        if (object.review != null)
                            message.review = String(object.review);
                        return message;
                    };

                    /**
                     * Creates a plain object from a ReviewForBusinessProto message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForBusinessProto
                     * @static
                     * @param {waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForBusinessProto} message ReviewForBusinessProto
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ReviewForBusinessProto.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.rating = options.enums === String ? "RATING_UNSPECIFIED" : 0;
                            object.review = "";
                        }
                        if (message.rating != null && message.hasOwnProperty("rating"))
                            object.rating = options.enums === String ? $root.waiternow.common.Rating[message.rating] === undefined ? message.rating : $root.waiternow.common.Rating[message.rating] : message.rating;
                        if (message.review != null && message.hasOwnProperty("review"))
                            object.review = message.review;
                        return object;
                    };

                    /**
                     * Converts this ReviewForBusinessProto to JSON.
                     * @function toJSON
                     * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForBusinessProto
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ReviewForBusinessProto.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for ReviewForBusinessProto
                     * @function getTypeUrl
                     * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForBusinessProto
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    ReviewForBusinessProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForBusinessProto";
                    };

                    return ReviewForBusinessProto;
                })();

                Request.ReviewForPlatformProto = (function() {

                    /**
                     * Properties of a ReviewForPlatformProto.
                     * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request
                     * @interface IReviewForPlatformProto
                     * @property {waiternow.common.OptionalYesNo|null} [wasEasyToUse] ReviewForPlatformProto wasEasyToUse
                     * @property {string|null} [comments] ReviewForPlatformProto comments
                     */

                    /**
                     * Constructs a new ReviewForPlatformProto.
                     * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request
                     * @classdesc Represents a ReviewForPlatformProto.
                     * @implements IReviewForPlatformProto
                     * @constructor
                     * @param {waiternow.common.PostConsumerFeedbackActionProto.Request.IReviewForPlatformProto=} [properties] Properties to set
                     */
                    function ReviewForPlatformProto(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * ReviewForPlatformProto wasEasyToUse.
                     * @member {waiternow.common.OptionalYesNo} wasEasyToUse
                     * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForPlatformProto
                     * @instance
                     */
                    ReviewForPlatformProto.prototype.wasEasyToUse = 0;

                    /**
                     * ReviewForPlatformProto comments.
                     * @member {string} comments
                     * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForPlatformProto
                     * @instance
                     */
                    ReviewForPlatformProto.prototype.comments = "";

                    /**
                     * Creates a new ReviewForPlatformProto instance using the specified properties.
                     * @function create
                     * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForPlatformProto
                     * @static
                     * @param {waiternow.common.PostConsumerFeedbackActionProto.Request.IReviewForPlatformProto=} [properties] Properties to set
                     * @returns {waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForPlatformProto} ReviewForPlatformProto instance
                     */
                    ReviewForPlatformProto.create = function create(properties) {
                        return new ReviewForPlatformProto(properties);
                    };

                    /**
                     * Encodes the specified ReviewForPlatformProto message. Does not implicitly {@link waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForPlatformProto.verify|verify} messages.
                     * @function encode
                     * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForPlatformProto
                     * @static
                     * @param {waiternow.common.PostConsumerFeedbackActionProto.Request.IReviewForPlatformProto} message ReviewForPlatformProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ReviewForPlatformProto.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.wasEasyToUse != null && Object.hasOwnProperty.call(message, "wasEasyToUse"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.wasEasyToUse);
                        if (message.comments != null && Object.hasOwnProperty.call(message, "comments"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.comments);
                        return writer;
                    };

                    /**
                     * Encodes the specified ReviewForPlatformProto message, length delimited. Does not implicitly {@link waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForPlatformProto.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForPlatformProto
                     * @static
                     * @param {waiternow.common.PostConsumerFeedbackActionProto.Request.IReviewForPlatformProto} message ReviewForPlatformProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ReviewForPlatformProto.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a ReviewForPlatformProto message from the specified reader or buffer.
                     * @function decode
                     * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForPlatformProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForPlatformProto} ReviewForPlatformProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ReviewForPlatformProto.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForPlatformProto();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.wasEasyToUse = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.comments = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a ReviewForPlatformProto message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForPlatformProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForPlatformProto} ReviewForPlatformProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ReviewForPlatformProto.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a ReviewForPlatformProto message.
                     * @function verify
                     * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForPlatformProto
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ReviewForPlatformProto.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.wasEasyToUse != null && message.hasOwnProperty("wasEasyToUse"))
                            switch (message.wasEasyToUse) {
                            default:
                                return "wasEasyToUse: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.comments != null && message.hasOwnProperty("comments"))
                            if (!$util.isString(message.comments))
                                return "comments: string expected";
                        return null;
                    };

                    /**
                     * Creates a ReviewForPlatformProto message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForPlatformProto
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForPlatformProto} ReviewForPlatformProto
                     */
                    ReviewForPlatformProto.fromObject = function fromObject(object) {
                        if (object instanceof $root.waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForPlatformProto)
                            return object;
                        var message = new $root.waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForPlatformProto();
                        switch (object.wasEasyToUse) {
                        default:
                            if (typeof object.wasEasyToUse === "number") {
                                message.wasEasyToUse = object.wasEasyToUse;
                                break;
                            }
                            break;
                        case "OPTIONAL_YES_NO_UNSPECIFIED":
                        case 0:
                            message.wasEasyToUse = 0;
                            break;
                        case "YES":
                        case 1:
                            message.wasEasyToUse = 1;
                            break;
                        case "NO":
                        case 2:
                            message.wasEasyToUse = 2;
                            break;
                        }
                        if (object.comments != null)
                            message.comments = String(object.comments);
                        return message;
                    };

                    /**
                     * Creates a plain object from a ReviewForPlatformProto message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForPlatformProto
                     * @static
                     * @param {waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForPlatformProto} message ReviewForPlatformProto
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ReviewForPlatformProto.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.wasEasyToUse = options.enums === String ? "OPTIONAL_YES_NO_UNSPECIFIED" : 0;
                            object.comments = "";
                        }
                        if (message.wasEasyToUse != null && message.hasOwnProperty("wasEasyToUse"))
                            object.wasEasyToUse = options.enums === String ? $root.waiternow.common.OptionalYesNo[message.wasEasyToUse] === undefined ? message.wasEasyToUse : $root.waiternow.common.OptionalYesNo[message.wasEasyToUse] : message.wasEasyToUse;
                        if (message.comments != null && message.hasOwnProperty("comments"))
                            object.comments = message.comments;
                        return object;
                    };

                    /**
                     * Converts this ReviewForPlatformProto to JSON.
                     * @function toJSON
                     * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForPlatformProto
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ReviewForPlatformProto.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for ReviewForPlatformProto
                     * @function getTypeUrl
                     * @memberof waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForPlatformProto
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    ReviewForPlatformProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/waiternow.common.PostConsumerFeedbackActionProto.Request.ReviewForPlatformProto";
                    };

                    return ReviewForPlatformProto;
                })();

                return Request;
            })();

            PostConsumerFeedbackActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.PostConsumerFeedbackActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.PostConsumerFeedbackActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.PostConsumerFeedbackActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.PostConsumerFeedbackActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.PostConsumerFeedbackActionProto.Response
                 * @static
                 * @param {waiternow.common.PostConsumerFeedbackActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.PostConsumerFeedbackActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.PostConsumerFeedbackActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.PostConsumerFeedbackActionProto.Response
                 * @static
                 * @param {waiternow.common.PostConsumerFeedbackActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.PostConsumerFeedbackActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.PostConsumerFeedbackActionProto.Response
                 * @static
                 * @param {waiternow.common.PostConsumerFeedbackActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.PostConsumerFeedbackActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.PostConsumerFeedbackActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PostConsumerFeedbackActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.PostConsumerFeedbackActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.PostConsumerFeedbackActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.PostConsumerFeedbackActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.PostConsumerFeedbackActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.PostConsumerFeedbackActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.PostConsumerFeedbackActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.PostConsumerFeedbackActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.PostConsumerFeedbackActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.PostConsumerFeedbackActionProto.Response
                 * @static
                 * @param {waiternow.common.PostConsumerFeedbackActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.PostConsumerFeedbackActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.PostConsumerFeedbackActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.PostConsumerFeedbackActionProto.Response";
                };

                return Response;
            })();

            return PostConsumerFeedbackActionProto;
        })();

        common.FindDeviceOrdersActionProto = (function() {

            /**
             * Properties of a FindDeviceOrdersActionProto.
             * @memberof waiternow.common
             * @interface IFindDeviceOrdersActionProto
             */

            /**
             * Constructs a new FindDeviceOrdersActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a FindDeviceOrdersActionProto.
             * @implements IFindDeviceOrdersActionProto
             * @constructor
             * @param {waiternow.common.IFindDeviceOrdersActionProto=} [properties] Properties to set
             */
            function FindDeviceOrdersActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new FindDeviceOrdersActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FindDeviceOrdersActionProto
             * @static
             * @param {waiternow.common.IFindDeviceOrdersActionProto=} [properties] Properties to set
             * @returns {waiternow.common.FindDeviceOrdersActionProto} FindDeviceOrdersActionProto instance
             */
            FindDeviceOrdersActionProto.create = function create(properties) {
                return new FindDeviceOrdersActionProto(properties);
            };

            /**
             * Encodes the specified FindDeviceOrdersActionProto message. Does not implicitly {@link waiternow.common.FindDeviceOrdersActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FindDeviceOrdersActionProto
             * @static
             * @param {waiternow.common.IFindDeviceOrdersActionProto} message FindDeviceOrdersActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindDeviceOrdersActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified FindDeviceOrdersActionProto message, length delimited. Does not implicitly {@link waiternow.common.FindDeviceOrdersActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FindDeviceOrdersActionProto
             * @static
             * @param {waiternow.common.IFindDeviceOrdersActionProto} message FindDeviceOrdersActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindDeviceOrdersActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FindDeviceOrdersActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FindDeviceOrdersActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FindDeviceOrdersActionProto} FindDeviceOrdersActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindDeviceOrdersActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindDeviceOrdersActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FindDeviceOrdersActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FindDeviceOrdersActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FindDeviceOrdersActionProto} FindDeviceOrdersActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindDeviceOrdersActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FindDeviceOrdersActionProto message.
             * @function verify
             * @memberof waiternow.common.FindDeviceOrdersActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FindDeviceOrdersActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a FindDeviceOrdersActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FindDeviceOrdersActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FindDeviceOrdersActionProto} FindDeviceOrdersActionProto
             */
            FindDeviceOrdersActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FindDeviceOrdersActionProto)
                    return object;
                return new $root.waiternow.common.FindDeviceOrdersActionProto();
            };

            /**
             * Creates a plain object from a FindDeviceOrdersActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FindDeviceOrdersActionProto
             * @static
             * @param {waiternow.common.FindDeviceOrdersActionProto} message FindDeviceOrdersActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FindDeviceOrdersActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this FindDeviceOrdersActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FindDeviceOrdersActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FindDeviceOrdersActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FindDeviceOrdersActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.FindDeviceOrdersActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FindDeviceOrdersActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FindDeviceOrdersActionProto";
            };

            FindDeviceOrdersActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.FindDeviceOrdersActionProto
                 * @interface IRequest
                 * @property {string|null} [deviceId] Request deviceId
                 * @property {string|null} [continuationToken] Request continuationToken
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.FindDeviceOrdersActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.FindDeviceOrdersActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request deviceId.
                 * @member {string} deviceId
                 * @memberof waiternow.common.FindDeviceOrdersActionProto.Request
                 * @instance
                 */
                Request.prototype.deviceId = "";

                /**
                 * Request continuationToken.
                 * @member {string} continuationToken
                 * @memberof waiternow.common.FindDeviceOrdersActionProto.Request
                 * @instance
                 */
                Request.prototype.continuationToken = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindDeviceOrdersActionProto.Request
                 * @static
                 * @param {waiternow.common.FindDeviceOrdersActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.FindDeviceOrdersActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.FindDeviceOrdersActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindDeviceOrdersActionProto.Request
                 * @static
                 * @param {waiternow.common.FindDeviceOrdersActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceId != null && Object.hasOwnProperty.call(message, "deviceId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.deviceId);
                    if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.continuationToken);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.FindDeviceOrdersActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindDeviceOrdersActionProto.Request
                 * @static
                 * @param {waiternow.common.FindDeviceOrdersActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindDeviceOrdersActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindDeviceOrdersActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindDeviceOrdersActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceId = reader.string();
                                break;
                            }
                        case 2: {
                                message.continuationToken = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindDeviceOrdersActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindDeviceOrdersActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.FindDeviceOrdersActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                        if (!$util.isString(message.deviceId))
                            return "deviceId: string expected";
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        if (!$util.isString(message.continuationToken))
                            return "continuationToken: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindDeviceOrdersActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindDeviceOrdersActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindDeviceOrdersActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.FindDeviceOrdersActionProto.Request();
                    if (object.deviceId != null)
                        message.deviceId = String(object.deviceId);
                    if (object.continuationToken != null)
                        message.continuationToken = String(object.continuationToken);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindDeviceOrdersActionProto.Request
                 * @static
                 * @param {waiternow.common.FindDeviceOrdersActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.deviceId = "";
                        object.continuationToken = "";
                    }
                    if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                        object.deviceId = message.deviceId;
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        object.continuationToken = message.continuationToken;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindDeviceOrdersActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindDeviceOrdersActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindDeviceOrdersActionProto.Request";
                };

                return Request;
            })();

            FindDeviceOrdersActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.FindDeviceOrdersActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IDeviceOrdersProto|null} [deviceOrders] Response deviceOrders
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.FindDeviceOrdersActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.FindDeviceOrdersActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.FindDeviceOrdersActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response deviceOrders.
                 * @member {waiternow.common.IDeviceOrdersProto|null|undefined} deviceOrders
                 * @memberof waiternow.common.FindDeviceOrdersActionProto.Response
                 * @instance
                 */
                Response.prototype.deviceOrders = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindDeviceOrdersActionProto.Response
                 * @static
                 * @param {waiternow.common.FindDeviceOrdersActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.FindDeviceOrdersActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.FindDeviceOrdersActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindDeviceOrdersActionProto.Response
                 * @static
                 * @param {waiternow.common.FindDeviceOrdersActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.deviceOrders != null && Object.hasOwnProperty.call(message, "deviceOrders"))
                        $root.waiternow.common.DeviceOrdersProto.encode(message.deviceOrders, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.FindDeviceOrdersActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindDeviceOrdersActionProto.Response
                 * @static
                 * @param {waiternow.common.FindDeviceOrdersActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindDeviceOrdersActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindDeviceOrdersActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindDeviceOrdersActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.deviceOrders = $root.waiternow.common.DeviceOrdersProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindDeviceOrdersActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindDeviceOrdersActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.FindDeviceOrdersActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.deviceOrders != null && message.hasOwnProperty("deviceOrders")) {
                        var error = $root.waiternow.common.DeviceOrdersProto.verify(message.deviceOrders);
                        if (error)
                            return "deviceOrders." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindDeviceOrdersActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindDeviceOrdersActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindDeviceOrdersActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.FindDeviceOrdersActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.FindDeviceOrdersActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.deviceOrders != null) {
                        if (typeof object.deviceOrders !== "object")
                            throw TypeError(".waiternow.common.FindDeviceOrdersActionProto.Response.deviceOrders: object expected");
                        message.deviceOrders = $root.waiternow.common.DeviceOrdersProto.fromObject(object.deviceOrders);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindDeviceOrdersActionProto.Response
                 * @static
                 * @param {waiternow.common.FindDeviceOrdersActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.deviceOrders = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.deviceOrders != null && message.hasOwnProperty("deviceOrders"))
                        object.deviceOrders = $root.waiternow.common.DeviceOrdersProto.toObject(message.deviceOrders, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindDeviceOrdersActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindDeviceOrdersActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindDeviceOrdersActionProto.Response";
                };

                return Response;
            })();

            return FindDeviceOrdersActionProto;
        })();

        common.FindDevicePaidOrdersByLocationActionProto = (function() {

            /**
             * Properties of a FindDevicePaidOrdersByLocationActionProto.
             * @memberof waiternow.common
             * @interface IFindDevicePaidOrdersByLocationActionProto
             */

            /**
             * Constructs a new FindDevicePaidOrdersByLocationActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a FindDevicePaidOrdersByLocationActionProto.
             * @implements IFindDevicePaidOrdersByLocationActionProto
             * @constructor
             * @param {waiternow.common.IFindDevicePaidOrdersByLocationActionProto=} [properties] Properties to set
             */
            function FindDevicePaidOrdersByLocationActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new FindDevicePaidOrdersByLocationActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FindDevicePaidOrdersByLocationActionProto
             * @static
             * @param {waiternow.common.IFindDevicePaidOrdersByLocationActionProto=} [properties] Properties to set
             * @returns {waiternow.common.FindDevicePaidOrdersByLocationActionProto} FindDevicePaidOrdersByLocationActionProto instance
             */
            FindDevicePaidOrdersByLocationActionProto.create = function create(properties) {
                return new FindDevicePaidOrdersByLocationActionProto(properties);
            };

            /**
             * Encodes the specified FindDevicePaidOrdersByLocationActionProto message. Does not implicitly {@link waiternow.common.FindDevicePaidOrdersByLocationActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FindDevicePaidOrdersByLocationActionProto
             * @static
             * @param {waiternow.common.IFindDevicePaidOrdersByLocationActionProto} message FindDevicePaidOrdersByLocationActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindDevicePaidOrdersByLocationActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified FindDevicePaidOrdersByLocationActionProto message, length delimited. Does not implicitly {@link waiternow.common.FindDevicePaidOrdersByLocationActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FindDevicePaidOrdersByLocationActionProto
             * @static
             * @param {waiternow.common.IFindDevicePaidOrdersByLocationActionProto} message FindDevicePaidOrdersByLocationActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindDevicePaidOrdersByLocationActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FindDevicePaidOrdersByLocationActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FindDevicePaidOrdersByLocationActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FindDevicePaidOrdersByLocationActionProto} FindDevicePaidOrdersByLocationActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindDevicePaidOrdersByLocationActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindDevicePaidOrdersByLocationActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FindDevicePaidOrdersByLocationActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FindDevicePaidOrdersByLocationActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FindDevicePaidOrdersByLocationActionProto} FindDevicePaidOrdersByLocationActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindDevicePaidOrdersByLocationActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FindDevicePaidOrdersByLocationActionProto message.
             * @function verify
             * @memberof waiternow.common.FindDevicePaidOrdersByLocationActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FindDevicePaidOrdersByLocationActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a FindDevicePaidOrdersByLocationActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FindDevicePaidOrdersByLocationActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FindDevicePaidOrdersByLocationActionProto} FindDevicePaidOrdersByLocationActionProto
             */
            FindDevicePaidOrdersByLocationActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FindDevicePaidOrdersByLocationActionProto)
                    return object;
                return new $root.waiternow.common.FindDevicePaidOrdersByLocationActionProto();
            };

            /**
             * Creates a plain object from a FindDevicePaidOrdersByLocationActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FindDevicePaidOrdersByLocationActionProto
             * @static
             * @param {waiternow.common.FindDevicePaidOrdersByLocationActionProto} message FindDevicePaidOrdersByLocationActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FindDevicePaidOrdersByLocationActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this FindDevicePaidOrdersByLocationActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FindDevicePaidOrdersByLocationActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FindDevicePaidOrdersByLocationActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FindDevicePaidOrdersByLocationActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.FindDevicePaidOrdersByLocationActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FindDevicePaidOrdersByLocationActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FindDevicePaidOrdersByLocationActionProto";
            };

            FindDevicePaidOrdersByLocationActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.FindDevicePaidOrdersByLocationActionProto
                 * @interface IRequest
                 * @property {string|null} [deviceId] Request deviceId
                 * @property {string|null} [locationId] Request locationId
                 * @property {string|null} [continuationToken] Request continuationToken
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.FindDevicePaidOrdersByLocationActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.FindDevicePaidOrdersByLocationActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request deviceId.
                 * @member {string} deviceId
                 * @memberof waiternow.common.FindDevicePaidOrdersByLocationActionProto.Request
                 * @instance
                 */
                Request.prototype.deviceId = "";

                /**
                 * Request locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.FindDevicePaidOrdersByLocationActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = "";

                /**
                 * Request continuationToken.
                 * @member {string} continuationToken
                 * @memberof waiternow.common.FindDevicePaidOrdersByLocationActionProto.Request
                 * @instance
                 */
                Request.prototype.continuationToken = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindDevicePaidOrdersByLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.FindDevicePaidOrdersByLocationActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.FindDevicePaidOrdersByLocationActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.FindDevicePaidOrdersByLocationActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindDevicePaidOrdersByLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.FindDevicePaidOrdersByLocationActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceId != null && Object.hasOwnProperty.call(message, "deviceId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.deviceId);
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.locationId);
                    if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.continuationToken);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.FindDevicePaidOrdersByLocationActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindDevicePaidOrdersByLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.FindDevicePaidOrdersByLocationActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindDevicePaidOrdersByLocationActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindDevicePaidOrdersByLocationActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindDevicePaidOrdersByLocationActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceId = reader.string();
                                break;
                            }
                        case 2: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 3: {
                                message.continuationToken = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindDevicePaidOrdersByLocationActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindDevicePaidOrdersByLocationActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.FindDevicePaidOrdersByLocationActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                        if (!$util.isString(message.deviceId))
                            return "deviceId: string expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        if (!$util.isString(message.continuationToken))
                            return "continuationToken: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindDevicePaidOrdersByLocationActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindDevicePaidOrdersByLocationActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindDevicePaidOrdersByLocationActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.FindDevicePaidOrdersByLocationActionProto.Request();
                    if (object.deviceId != null)
                        message.deviceId = String(object.deviceId);
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    if (object.continuationToken != null)
                        message.continuationToken = String(object.continuationToken);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindDevicePaidOrdersByLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.FindDevicePaidOrdersByLocationActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.deviceId = "";
                        object.locationId = "";
                        object.continuationToken = "";
                    }
                    if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                        object.deviceId = message.deviceId;
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        object.continuationToken = message.continuationToken;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindDevicePaidOrdersByLocationActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindDevicePaidOrdersByLocationActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindDevicePaidOrdersByLocationActionProto.Request";
                };

                return Request;
            })();

            FindDevicePaidOrdersByLocationActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.FindDevicePaidOrdersByLocationActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IOrdersProto|null} [orders] Response orders
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.FindDevicePaidOrdersByLocationActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.FindDevicePaidOrdersByLocationActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.FindDevicePaidOrdersByLocationActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response orders.
                 * @member {waiternow.common.IOrdersProto|null|undefined} orders
                 * @memberof waiternow.common.FindDevicePaidOrdersByLocationActionProto.Response
                 * @instance
                 */
                Response.prototype.orders = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindDevicePaidOrdersByLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.FindDevicePaidOrdersByLocationActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.FindDevicePaidOrdersByLocationActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.FindDevicePaidOrdersByLocationActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindDevicePaidOrdersByLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.FindDevicePaidOrdersByLocationActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.orders != null && Object.hasOwnProperty.call(message, "orders"))
                        $root.waiternow.common.OrdersProto.encode(message.orders, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.FindDevicePaidOrdersByLocationActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindDevicePaidOrdersByLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.FindDevicePaidOrdersByLocationActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindDevicePaidOrdersByLocationActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindDevicePaidOrdersByLocationActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindDevicePaidOrdersByLocationActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.orders = $root.waiternow.common.OrdersProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindDevicePaidOrdersByLocationActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindDevicePaidOrdersByLocationActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.FindDevicePaidOrdersByLocationActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.orders != null && message.hasOwnProperty("orders")) {
                        var error = $root.waiternow.common.OrdersProto.verify(message.orders);
                        if (error)
                            return "orders." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindDevicePaidOrdersByLocationActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindDevicePaidOrdersByLocationActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindDevicePaidOrdersByLocationActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.FindDevicePaidOrdersByLocationActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.FindDevicePaidOrdersByLocationActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.orders != null) {
                        if (typeof object.orders !== "object")
                            throw TypeError(".waiternow.common.FindDevicePaidOrdersByLocationActionProto.Response.orders: object expected");
                        message.orders = $root.waiternow.common.OrdersProto.fromObject(object.orders);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindDevicePaidOrdersByLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.FindDevicePaidOrdersByLocationActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.orders = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.orders != null && message.hasOwnProperty("orders"))
                        object.orders = $root.waiternow.common.OrdersProto.toObject(message.orders, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindDevicePaidOrdersByLocationActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindDevicePaidOrdersByLocationActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindDevicePaidOrdersByLocationActionProto.Response";
                };

                return Response;
            })();

            return FindDevicePaidOrdersByLocationActionProto;
        })();

        common.MarkOrderAsPaidActionProto = (function() {

            /**
             * Properties of a MarkOrderAsPaidActionProto.
             * @memberof waiternow.common
             * @interface IMarkOrderAsPaidActionProto
             */

            /**
             * Constructs a new MarkOrderAsPaidActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a MarkOrderAsPaidActionProto.
             * @implements IMarkOrderAsPaidActionProto
             * @constructor
             * @param {waiternow.common.IMarkOrderAsPaidActionProto=} [properties] Properties to set
             */
            function MarkOrderAsPaidActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new MarkOrderAsPaidActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.MarkOrderAsPaidActionProto
             * @static
             * @param {waiternow.common.IMarkOrderAsPaidActionProto=} [properties] Properties to set
             * @returns {waiternow.common.MarkOrderAsPaidActionProto} MarkOrderAsPaidActionProto instance
             */
            MarkOrderAsPaidActionProto.create = function create(properties) {
                return new MarkOrderAsPaidActionProto(properties);
            };

            /**
             * Encodes the specified MarkOrderAsPaidActionProto message. Does not implicitly {@link waiternow.common.MarkOrderAsPaidActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.MarkOrderAsPaidActionProto
             * @static
             * @param {waiternow.common.IMarkOrderAsPaidActionProto} message MarkOrderAsPaidActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MarkOrderAsPaidActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified MarkOrderAsPaidActionProto message, length delimited. Does not implicitly {@link waiternow.common.MarkOrderAsPaidActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.MarkOrderAsPaidActionProto
             * @static
             * @param {waiternow.common.IMarkOrderAsPaidActionProto} message MarkOrderAsPaidActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MarkOrderAsPaidActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a MarkOrderAsPaidActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.MarkOrderAsPaidActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.MarkOrderAsPaidActionProto} MarkOrderAsPaidActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MarkOrderAsPaidActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.MarkOrderAsPaidActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a MarkOrderAsPaidActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.MarkOrderAsPaidActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.MarkOrderAsPaidActionProto} MarkOrderAsPaidActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MarkOrderAsPaidActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a MarkOrderAsPaidActionProto message.
             * @function verify
             * @memberof waiternow.common.MarkOrderAsPaidActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            MarkOrderAsPaidActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a MarkOrderAsPaidActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.MarkOrderAsPaidActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.MarkOrderAsPaidActionProto} MarkOrderAsPaidActionProto
             */
            MarkOrderAsPaidActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.MarkOrderAsPaidActionProto)
                    return object;
                return new $root.waiternow.common.MarkOrderAsPaidActionProto();
            };

            /**
             * Creates a plain object from a MarkOrderAsPaidActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.MarkOrderAsPaidActionProto
             * @static
             * @param {waiternow.common.MarkOrderAsPaidActionProto} message MarkOrderAsPaidActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            MarkOrderAsPaidActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this MarkOrderAsPaidActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.MarkOrderAsPaidActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            MarkOrderAsPaidActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for MarkOrderAsPaidActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.MarkOrderAsPaidActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            MarkOrderAsPaidActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.MarkOrderAsPaidActionProto";
            };

            MarkOrderAsPaidActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.MarkOrderAsPaidActionProto
                 * @interface IRequest
                 * @property {string|null} [orderId] Request orderId
                 * @property {string|null} [emailAddress] Request emailAddress
                 * @property {waiternow.common.IPhoneNumberProto|null} [phoneNumber] Request phoneNumber
                 * @property {string|null} [name] Request name
                 * @property {number|null} [attempt] Request attempt
                 * @property {waiternow.common.MarkOrderAsPaidActionProto.Request.ITestProto|null} [test] Request test
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.MarkOrderAsPaidActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.MarkOrderAsPaidActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request orderId.
                 * @member {string} orderId
                 * @memberof waiternow.common.MarkOrderAsPaidActionProto.Request
                 * @instance
                 */
                Request.prototype.orderId = "";

                /**
                 * Request emailAddress.
                 * @member {string} emailAddress
                 * @memberof waiternow.common.MarkOrderAsPaidActionProto.Request
                 * @instance
                 */
                Request.prototype.emailAddress = "";

                /**
                 * Request phoneNumber.
                 * @member {waiternow.common.IPhoneNumberProto|null|undefined} phoneNumber
                 * @memberof waiternow.common.MarkOrderAsPaidActionProto.Request
                 * @instance
                 */
                Request.prototype.phoneNumber = null;

                /**
                 * Request name.
                 * @member {string} name
                 * @memberof waiternow.common.MarkOrderAsPaidActionProto.Request
                 * @instance
                 */
                Request.prototype.name = "";

                /**
                 * Request attempt.
                 * @member {number} attempt
                 * @memberof waiternow.common.MarkOrderAsPaidActionProto.Request
                 * @instance
                 */
                Request.prototype.attempt = 0;

                /**
                 * Request test.
                 * @member {waiternow.common.MarkOrderAsPaidActionProto.Request.ITestProto|null|undefined} test
                 * @memberof waiternow.common.MarkOrderAsPaidActionProto.Request
                 * @instance
                 */
                Request.prototype.test = null;

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.MarkOrderAsPaidActionProto.Request
                 * @static
                 * @param {waiternow.common.MarkOrderAsPaidActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.MarkOrderAsPaidActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.MarkOrderAsPaidActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.MarkOrderAsPaidActionProto.Request
                 * @static
                 * @param {waiternow.common.MarkOrderAsPaidActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.orderId != null && Object.hasOwnProperty.call(message, "orderId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.orderId);
                    if (message.emailAddress != null && Object.hasOwnProperty.call(message, "emailAddress"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.emailAddress);
                    if (message.phoneNumber != null && Object.hasOwnProperty.call(message, "phoneNumber"))
                        $root.waiternow.common.PhoneNumberProto.encode(message.phoneNumber, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.name);
                    if (message.attempt != null && Object.hasOwnProperty.call(message, "attempt"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int32(message.attempt);
                    if (message.test != null && Object.hasOwnProperty.call(message, "test"))
                        $root.waiternow.common.MarkOrderAsPaidActionProto.Request.TestProto.encode(message.test, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.MarkOrderAsPaidActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.MarkOrderAsPaidActionProto.Request
                 * @static
                 * @param {waiternow.common.MarkOrderAsPaidActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.MarkOrderAsPaidActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.MarkOrderAsPaidActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.MarkOrderAsPaidActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.orderId = reader.string();
                                break;
                            }
                        case 2: {
                                message.emailAddress = reader.string();
                                break;
                            }
                        case 3: {
                                message.phoneNumber = $root.waiternow.common.PhoneNumberProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 4: {
                                message.name = reader.string();
                                break;
                            }
                        case 5: {
                                message.attempt = reader.int32();
                                break;
                            }
                        case 6: {
                                message.test = $root.waiternow.common.MarkOrderAsPaidActionProto.Request.TestProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.MarkOrderAsPaidActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.MarkOrderAsPaidActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.MarkOrderAsPaidActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.orderId != null && message.hasOwnProperty("orderId"))
                        if (!$util.isString(message.orderId))
                            return "orderId: string expected";
                    if (message.emailAddress != null && message.hasOwnProperty("emailAddress"))
                        if (!$util.isString(message.emailAddress))
                            return "emailAddress: string expected";
                    if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber")) {
                        var error = $root.waiternow.common.PhoneNumberProto.verify(message.phoneNumber);
                        if (error)
                            return "phoneNumber." + error;
                    }
                    if (message.name != null && message.hasOwnProperty("name"))
                        if (!$util.isString(message.name))
                            return "name: string expected";
                    if (message.attempt != null && message.hasOwnProperty("attempt"))
                        if (!$util.isInteger(message.attempt))
                            return "attempt: integer expected";
                    if (message.test != null && message.hasOwnProperty("test")) {
                        var error = $root.waiternow.common.MarkOrderAsPaidActionProto.Request.TestProto.verify(message.test);
                        if (error)
                            return "test." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.MarkOrderAsPaidActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.MarkOrderAsPaidActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.MarkOrderAsPaidActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.MarkOrderAsPaidActionProto.Request();
                    if (object.orderId != null)
                        message.orderId = String(object.orderId);
                    if (object.emailAddress != null)
                        message.emailAddress = String(object.emailAddress);
                    if (object.phoneNumber != null) {
                        if (typeof object.phoneNumber !== "object")
                            throw TypeError(".waiternow.common.MarkOrderAsPaidActionProto.Request.phoneNumber: object expected");
                        message.phoneNumber = $root.waiternow.common.PhoneNumberProto.fromObject(object.phoneNumber);
                    }
                    if (object.name != null)
                        message.name = String(object.name);
                    if (object.attempt != null)
                        message.attempt = object.attempt | 0;
                    if (object.test != null) {
                        if (typeof object.test !== "object")
                            throw TypeError(".waiternow.common.MarkOrderAsPaidActionProto.Request.test: object expected");
                        message.test = $root.waiternow.common.MarkOrderAsPaidActionProto.Request.TestProto.fromObject(object.test);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.MarkOrderAsPaidActionProto.Request
                 * @static
                 * @param {waiternow.common.MarkOrderAsPaidActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.orderId = "";
                        object.emailAddress = "";
                        object.phoneNumber = null;
                        object.name = "";
                        object.attempt = 0;
                        object.test = null;
                    }
                    if (message.orderId != null && message.hasOwnProperty("orderId"))
                        object.orderId = message.orderId;
                    if (message.emailAddress != null && message.hasOwnProperty("emailAddress"))
                        object.emailAddress = message.emailAddress;
                    if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
                        object.phoneNumber = $root.waiternow.common.PhoneNumberProto.toObject(message.phoneNumber, options);
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = message.name;
                    if (message.attempt != null && message.hasOwnProperty("attempt"))
                        object.attempt = message.attempt;
                    if (message.test != null && message.hasOwnProperty("test"))
                        object.test = $root.waiternow.common.MarkOrderAsPaidActionProto.Request.TestProto.toObject(message.test, options);
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.MarkOrderAsPaidActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.MarkOrderAsPaidActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.MarkOrderAsPaidActionProto.Request";
                };

                Request.TestProto = (function() {

                    /**
                     * Properties of a TestProto.
                     * @memberof waiternow.common.MarkOrderAsPaidActionProto.Request
                     * @interface ITestProto
                     * @property {boolean|null} [isFailureTest] TestProto isFailureTest
                     * @property {number|null} [numberOfAttemptsToFail] TestProto numberOfAttemptsToFail
                     */

                    /**
                     * Constructs a new TestProto.
                     * @memberof waiternow.common.MarkOrderAsPaidActionProto.Request
                     * @classdesc Represents a TestProto.
                     * @implements ITestProto
                     * @constructor
                     * @param {waiternow.common.MarkOrderAsPaidActionProto.Request.ITestProto=} [properties] Properties to set
                     */
                    function TestProto(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * TestProto isFailureTest.
                     * @member {boolean} isFailureTest
                     * @memberof waiternow.common.MarkOrderAsPaidActionProto.Request.TestProto
                     * @instance
                     */
                    TestProto.prototype.isFailureTest = false;

                    /**
                     * TestProto numberOfAttemptsToFail.
                     * @member {number} numberOfAttemptsToFail
                     * @memberof waiternow.common.MarkOrderAsPaidActionProto.Request.TestProto
                     * @instance
                     */
                    TestProto.prototype.numberOfAttemptsToFail = 0;

                    /**
                     * Creates a new TestProto instance using the specified properties.
                     * @function create
                     * @memberof waiternow.common.MarkOrderAsPaidActionProto.Request.TestProto
                     * @static
                     * @param {waiternow.common.MarkOrderAsPaidActionProto.Request.ITestProto=} [properties] Properties to set
                     * @returns {waiternow.common.MarkOrderAsPaidActionProto.Request.TestProto} TestProto instance
                     */
                    TestProto.create = function create(properties) {
                        return new TestProto(properties);
                    };

                    /**
                     * Encodes the specified TestProto message. Does not implicitly {@link waiternow.common.MarkOrderAsPaidActionProto.Request.TestProto.verify|verify} messages.
                     * @function encode
                     * @memberof waiternow.common.MarkOrderAsPaidActionProto.Request.TestProto
                     * @static
                     * @param {waiternow.common.MarkOrderAsPaidActionProto.Request.ITestProto} message TestProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TestProto.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.isFailureTest != null && Object.hasOwnProperty.call(message, "isFailureTest"))
                            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.isFailureTest);
                        if (message.numberOfAttemptsToFail != null && Object.hasOwnProperty.call(message, "numberOfAttemptsToFail"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.numberOfAttemptsToFail);
                        return writer;
                    };

                    /**
                     * Encodes the specified TestProto message, length delimited. Does not implicitly {@link waiternow.common.MarkOrderAsPaidActionProto.Request.TestProto.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof waiternow.common.MarkOrderAsPaidActionProto.Request.TestProto
                     * @static
                     * @param {waiternow.common.MarkOrderAsPaidActionProto.Request.ITestProto} message TestProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TestProto.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a TestProto message from the specified reader or buffer.
                     * @function decode
                     * @memberof waiternow.common.MarkOrderAsPaidActionProto.Request.TestProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {waiternow.common.MarkOrderAsPaidActionProto.Request.TestProto} TestProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TestProto.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.MarkOrderAsPaidActionProto.Request.TestProto();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.isFailureTest = reader.bool();
                                    break;
                                }
                            case 2: {
                                    message.numberOfAttemptsToFail = reader.int32();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a TestProto message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof waiternow.common.MarkOrderAsPaidActionProto.Request.TestProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {waiternow.common.MarkOrderAsPaidActionProto.Request.TestProto} TestProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TestProto.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a TestProto message.
                     * @function verify
                     * @memberof waiternow.common.MarkOrderAsPaidActionProto.Request.TestProto
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TestProto.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.isFailureTest != null && message.hasOwnProperty("isFailureTest"))
                            if (typeof message.isFailureTest !== "boolean")
                                return "isFailureTest: boolean expected";
                        if (message.numberOfAttemptsToFail != null && message.hasOwnProperty("numberOfAttemptsToFail"))
                            if (!$util.isInteger(message.numberOfAttemptsToFail))
                                return "numberOfAttemptsToFail: integer expected";
                        return null;
                    };

                    /**
                     * Creates a TestProto message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof waiternow.common.MarkOrderAsPaidActionProto.Request.TestProto
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {waiternow.common.MarkOrderAsPaidActionProto.Request.TestProto} TestProto
                     */
                    TestProto.fromObject = function fromObject(object) {
                        if (object instanceof $root.waiternow.common.MarkOrderAsPaidActionProto.Request.TestProto)
                            return object;
                        var message = new $root.waiternow.common.MarkOrderAsPaidActionProto.Request.TestProto();
                        if (object.isFailureTest != null)
                            message.isFailureTest = Boolean(object.isFailureTest);
                        if (object.numberOfAttemptsToFail != null)
                            message.numberOfAttemptsToFail = object.numberOfAttemptsToFail | 0;
                        return message;
                    };

                    /**
                     * Creates a plain object from a TestProto message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof waiternow.common.MarkOrderAsPaidActionProto.Request.TestProto
                     * @static
                     * @param {waiternow.common.MarkOrderAsPaidActionProto.Request.TestProto} message TestProto
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TestProto.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.isFailureTest = false;
                            object.numberOfAttemptsToFail = 0;
                        }
                        if (message.isFailureTest != null && message.hasOwnProperty("isFailureTest"))
                            object.isFailureTest = message.isFailureTest;
                        if (message.numberOfAttemptsToFail != null && message.hasOwnProperty("numberOfAttemptsToFail"))
                            object.numberOfAttemptsToFail = message.numberOfAttemptsToFail;
                        return object;
                    };

                    /**
                     * Converts this TestProto to JSON.
                     * @function toJSON
                     * @memberof waiternow.common.MarkOrderAsPaidActionProto.Request.TestProto
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TestProto.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for TestProto
                     * @function getTypeUrl
                     * @memberof waiternow.common.MarkOrderAsPaidActionProto.Request.TestProto
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    TestProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/waiternow.common.MarkOrderAsPaidActionProto.Request.TestProto";
                    };

                    return TestProto;
                })();

                return Request;
            })();

            MarkOrderAsPaidActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.MarkOrderAsPaidActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IPaymentProto|null} [payment] Response payment
                 * @property {string|null} [deliveryTrackingUrl] Response deliveryTrackingUrl
                 * @property {waiternow.common.IOrderProto|null} [order] Response order
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.MarkOrderAsPaidActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.MarkOrderAsPaidActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.MarkOrderAsPaidActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response payment.
                 * @member {waiternow.common.IPaymentProto|null|undefined} payment
                 * @memberof waiternow.common.MarkOrderAsPaidActionProto.Response
                 * @instance
                 */
                Response.prototype.payment = null;

                /**
                 * Response deliveryTrackingUrl.
                 * @member {string} deliveryTrackingUrl
                 * @memberof waiternow.common.MarkOrderAsPaidActionProto.Response
                 * @instance
                 */
                Response.prototype.deliveryTrackingUrl = "";

                /**
                 * Response order.
                 * @member {waiternow.common.IOrderProto|null|undefined} order
                 * @memberof waiternow.common.MarkOrderAsPaidActionProto.Response
                 * @instance
                 */
                Response.prototype.order = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.MarkOrderAsPaidActionProto.Response
                 * @static
                 * @param {waiternow.common.MarkOrderAsPaidActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.MarkOrderAsPaidActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.MarkOrderAsPaidActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.MarkOrderAsPaidActionProto.Response
                 * @static
                 * @param {waiternow.common.MarkOrderAsPaidActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.payment != null && Object.hasOwnProperty.call(message, "payment"))
                        $root.waiternow.common.PaymentProto.encode(message.payment, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.deliveryTrackingUrl != null && Object.hasOwnProperty.call(message, "deliveryTrackingUrl"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.deliveryTrackingUrl);
                    if (message.order != null && Object.hasOwnProperty.call(message, "order"))
                        $root.waiternow.common.OrderProto.encode(message.order, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.MarkOrderAsPaidActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.MarkOrderAsPaidActionProto.Response
                 * @static
                 * @param {waiternow.common.MarkOrderAsPaidActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.MarkOrderAsPaidActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.MarkOrderAsPaidActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.MarkOrderAsPaidActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.payment = $root.waiternow.common.PaymentProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.deliveryTrackingUrl = reader.string();
                                break;
                            }
                        case 4: {
                                message.order = $root.waiternow.common.OrderProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.MarkOrderAsPaidActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.MarkOrderAsPaidActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.MarkOrderAsPaidActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.payment != null && message.hasOwnProperty("payment")) {
                        var error = $root.waiternow.common.PaymentProto.verify(message.payment);
                        if (error)
                            return "payment." + error;
                    }
                    if (message.deliveryTrackingUrl != null && message.hasOwnProperty("deliveryTrackingUrl"))
                        if (!$util.isString(message.deliveryTrackingUrl))
                            return "deliveryTrackingUrl: string expected";
                    if (message.order != null && message.hasOwnProperty("order")) {
                        var error = $root.waiternow.common.OrderProto.verify(message.order);
                        if (error)
                            return "order." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.MarkOrderAsPaidActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.MarkOrderAsPaidActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.MarkOrderAsPaidActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.MarkOrderAsPaidActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.MarkOrderAsPaidActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.payment != null) {
                        if (typeof object.payment !== "object")
                            throw TypeError(".waiternow.common.MarkOrderAsPaidActionProto.Response.payment: object expected");
                        message.payment = $root.waiternow.common.PaymentProto.fromObject(object.payment);
                    }
                    if (object.deliveryTrackingUrl != null)
                        message.deliveryTrackingUrl = String(object.deliveryTrackingUrl);
                    if (object.order != null) {
                        if (typeof object.order !== "object")
                            throw TypeError(".waiternow.common.MarkOrderAsPaidActionProto.Response.order: object expected");
                        message.order = $root.waiternow.common.OrderProto.fromObject(object.order);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.MarkOrderAsPaidActionProto.Response
                 * @static
                 * @param {waiternow.common.MarkOrderAsPaidActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.payment = null;
                        object.deliveryTrackingUrl = "";
                        object.order = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.payment != null && message.hasOwnProperty("payment"))
                        object.payment = $root.waiternow.common.PaymentProto.toObject(message.payment, options);
                    if (message.deliveryTrackingUrl != null && message.hasOwnProperty("deliveryTrackingUrl"))
                        object.deliveryTrackingUrl = message.deliveryTrackingUrl;
                    if (message.order != null && message.hasOwnProperty("order"))
                        object.order = $root.waiternow.common.OrderProto.toObject(message.order, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.MarkOrderAsPaidActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.MarkOrderAsPaidActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.MarkOrderAsPaidActionProto.Response";
                };

                return Response;
            })();

            return MarkOrderAsPaidActionProto;
        })();

        common.GetMenuDraftDenormalizedActionProto = (function() {

            /**
             * Properties of a GetMenuDraftDenormalizedActionProto.
             * @memberof waiternow.common
             * @interface IGetMenuDraftDenormalizedActionProto
             */

            /**
             * Constructs a new GetMenuDraftDenormalizedActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a GetMenuDraftDenormalizedActionProto.
             * @implements IGetMenuDraftDenormalizedActionProto
             * @constructor
             * @param {waiternow.common.IGetMenuDraftDenormalizedActionProto=} [properties] Properties to set
             */
            function GetMenuDraftDenormalizedActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new GetMenuDraftDenormalizedActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.GetMenuDraftDenormalizedActionProto
             * @static
             * @param {waiternow.common.IGetMenuDraftDenormalizedActionProto=} [properties] Properties to set
             * @returns {waiternow.common.GetMenuDraftDenormalizedActionProto} GetMenuDraftDenormalizedActionProto instance
             */
            GetMenuDraftDenormalizedActionProto.create = function create(properties) {
                return new GetMenuDraftDenormalizedActionProto(properties);
            };

            /**
             * Encodes the specified GetMenuDraftDenormalizedActionProto message. Does not implicitly {@link waiternow.common.GetMenuDraftDenormalizedActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.GetMenuDraftDenormalizedActionProto
             * @static
             * @param {waiternow.common.IGetMenuDraftDenormalizedActionProto} message GetMenuDraftDenormalizedActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetMenuDraftDenormalizedActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified GetMenuDraftDenormalizedActionProto message, length delimited. Does not implicitly {@link waiternow.common.GetMenuDraftDenormalizedActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.GetMenuDraftDenormalizedActionProto
             * @static
             * @param {waiternow.common.IGetMenuDraftDenormalizedActionProto} message GetMenuDraftDenormalizedActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetMenuDraftDenormalizedActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetMenuDraftDenormalizedActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.GetMenuDraftDenormalizedActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.GetMenuDraftDenormalizedActionProto} GetMenuDraftDenormalizedActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetMenuDraftDenormalizedActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetMenuDraftDenormalizedActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetMenuDraftDenormalizedActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.GetMenuDraftDenormalizedActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.GetMenuDraftDenormalizedActionProto} GetMenuDraftDenormalizedActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetMenuDraftDenormalizedActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetMenuDraftDenormalizedActionProto message.
             * @function verify
             * @memberof waiternow.common.GetMenuDraftDenormalizedActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetMenuDraftDenormalizedActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a GetMenuDraftDenormalizedActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.GetMenuDraftDenormalizedActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.GetMenuDraftDenormalizedActionProto} GetMenuDraftDenormalizedActionProto
             */
            GetMenuDraftDenormalizedActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.GetMenuDraftDenormalizedActionProto)
                    return object;
                return new $root.waiternow.common.GetMenuDraftDenormalizedActionProto();
            };

            /**
             * Creates a plain object from a GetMenuDraftDenormalizedActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.GetMenuDraftDenormalizedActionProto
             * @static
             * @param {waiternow.common.GetMenuDraftDenormalizedActionProto} message GetMenuDraftDenormalizedActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetMenuDraftDenormalizedActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this GetMenuDraftDenormalizedActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.GetMenuDraftDenormalizedActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetMenuDraftDenormalizedActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for GetMenuDraftDenormalizedActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.GetMenuDraftDenormalizedActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            GetMenuDraftDenormalizedActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.GetMenuDraftDenormalizedActionProto";
            };

            GetMenuDraftDenormalizedActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.GetMenuDraftDenormalizedActionProto
                 * @interface IRequest
                 * @property {string|null} [businessId] Request businessId
                 * @property {string|null} [locationId] Request locationId
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.GetMenuDraftDenormalizedActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.GetMenuDraftDenormalizedActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request businessId.
                 * @member {string|null|undefined} businessId
                 * @memberof waiternow.common.GetMenuDraftDenormalizedActionProto.Request
                 * @instance
                 */
                Request.prototype.businessId = null;

                /**
                 * Request locationId.
                 * @member {string|null|undefined} locationId
                 * @memberof waiternow.common.GetMenuDraftDenormalizedActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = null;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * Request subject.
                 * @member {"businessId"|"locationId"|undefined} subject
                 * @memberof waiternow.common.GetMenuDraftDenormalizedActionProto.Request
                 * @instance
                 */
                Object.defineProperty(Request.prototype, "subject", {
                    get: $util.oneOfGetter($oneOfFields = ["businessId", "locationId"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetMenuDraftDenormalizedActionProto.Request
                 * @static
                 * @param {waiternow.common.GetMenuDraftDenormalizedActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.GetMenuDraftDenormalizedActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.GetMenuDraftDenormalizedActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetMenuDraftDenormalizedActionProto.Request
                 * @static
                 * @param {waiternow.common.GetMenuDraftDenormalizedActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessId);
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.locationId);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.GetMenuDraftDenormalizedActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetMenuDraftDenormalizedActionProto.Request
                 * @static
                 * @param {waiternow.common.GetMenuDraftDenormalizedActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetMenuDraftDenormalizedActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetMenuDraftDenormalizedActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetMenuDraftDenormalizedActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.businessId = reader.string();
                                break;
                            }
                        case 2: {
                                message.locationId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetMenuDraftDenormalizedActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetMenuDraftDenormalizedActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.GetMenuDraftDenormalizedActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.businessId != null && message.hasOwnProperty("businessId")) {
                        properties.subject = 1;
                        if (!$util.isString(message.businessId))
                            return "businessId: string expected";
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId")) {
                        if (properties.subject === 1)
                            return "subject: multiple values";
                        properties.subject = 1;
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    }
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetMenuDraftDenormalizedActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetMenuDraftDenormalizedActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetMenuDraftDenormalizedActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.GetMenuDraftDenormalizedActionProto.Request();
                    if (object.businessId != null)
                        message.businessId = String(object.businessId);
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetMenuDraftDenormalizedActionProto.Request
                 * @static
                 * @param {waiternow.common.GetMenuDraftDenormalizedActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (message.businessId != null && message.hasOwnProperty("businessId")) {
                        object.businessId = message.businessId;
                        if (options.oneofs)
                            object.subject = "businessId";
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId")) {
                        object.locationId = message.locationId;
                        if (options.oneofs)
                            object.subject = "locationId";
                    }
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetMenuDraftDenormalizedActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetMenuDraftDenormalizedActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetMenuDraftDenormalizedActionProto.Request";
                };

                return Request;
            })();

            GetMenuDraftDenormalizedActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.GetMenuDraftDenormalizedActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IMenuProto|null} [menu] Response menu
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.GetMenuDraftDenormalizedActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.GetMenuDraftDenormalizedActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.GetMenuDraftDenormalizedActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response menu.
                 * @member {waiternow.common.IMenuProto|null|undefined} menu
                 * @memberof waiternow.common.GetMenuDraftDenormalizedActionProto.Response
                 * @instance
                 */
                Response.prototype.menu = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetMenuDraftDenormalizedActionProto.Response
                 * @static
                 * @param {waiternow.common.GetMenuDraftDenormalizedActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.GetMenuDraftDenormalizedActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.GetMenuDraftDenormalizedActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetMenuDraftDenormalizedActionProto.Response
                 * @static
                 * @param {waiternow.common.GetMenuDraftDenormalizedActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.menu != null && Object.hasOwnProperty.call(message, "menu"))
                        $root.waiternow.common.MenuProto.encode(message.menu, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.GetMenuDraftDenormalizedActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetMenuDraftDenormalizedActionProto.Response
                 * @static
                 * @param {waiternow.common.GetMenuDraftDenormalizedActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetMenuDraftDenormalizedActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetMenuDraftDenormalizedActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetMenuDraftDenormalizedActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.menu = $root.waiternow.common.MenuProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetMenuDraftDenormalizedActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetMenuDraftDenormalizedActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.GetMenuDraftDenormalizedActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.menu != null && message.hasOwnProperty("menu")) {
                        var error = $root.waiternow.common.MenuProto.verify(message.menu);
                        if (error)
                            return "menu." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetMenuDraftDenormalizedActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetMenuDraftDenormalizedActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetMenuDraftDenormalizedActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.GetMenuDraftDenormalizedActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.GetMenuDraftDenormalizedActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.menu != null) {
                        if (typeof object.menu !== "object")
                            throw TypeError(".waiternow.common.GetMenuDraftDenormalizedActionProto.Response.menu: object expected");
                        message.menu = $root.waiternow.common.MenuProto.fromObject(object.menu);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetMenuDraftDenormalizedActionProto.Response
                 * @static
                 * @param {waiternow.common.GetMenuDraftDenormalizedActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.menu = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.menu != null && message.hasOwnProperty("menu"))
                        object.menu = $root.waiternow.common.MenuProto.toObject(message.menu, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetMenuDraftDenormalizedActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetMenuDraftDenormalizedActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetMenuDraftDenormalizedActionProto.Response";
                };

                return Response;
            })();

            return GetMenuDraftDenormalizedActionProto;
        })();

        common.GetUpdatedMenuDenormalizedActionProto = (function() {

            /**
             * Properties of a GetUpdatedMenuDenormalizedActionProto.
             * @memberof waiternow.common
             * @interface IGetUpdatedMenuDenormalizedActionProto
             */

            /**
             * Constructs a new GetUpdatedMenuDenormalizedActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a GetUpdatedMenuDenormalizedActionProto.
             * @implements IGetUpdatedMenuDenormalizedActionProto
             * @constructor
             * @param {waiternow.common.IGetUpdatedMenuDenormalizedActionProto=} [properties] Properties to set
             */
            function GetUpdatedMenuDenormalizedActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new GetUpdatedMenuDenormalizedActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.GetUpdatedMenuDenormalizedActionProto
             * @static
             * @param {waiternow.common.IGetUpdatedMenuDenormalizedActionProto=} [properties] Properties to set
             * @returns {waiternow.common.GetUpdatedMenuDenormalizedActionProto} GetUpdatedMenuDenormalizedActionProto instance
             */
            GetUpdatedMenuDenormalizedActionProto.create = function create(properties) {
                return new GetUpdatedMenuDenormalizedActionProto(properties);
            };

            /**
             * Encodes the specified GetUpdatedMenuDenormalizedActionProto message. Does not implicitly {@link waiternow.common.GetUpdatedMenuDenormalizedActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.GetUpdatedMenuDenormalizedActionProto
             * @static
             * @param {waiternow.common.IGetUpdatedMenuDenormalizedActionProto} message GetUpdatedMenuDenormalizedActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetUpdatedMenuDenormalizedActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified GetUpdatedMenuDenormalizedActionProto message, length delimited. Does not implicitly {@link waiternow.common.GetUpdatedMenuDenormalizedActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.GetUpdatedMenuDenormalizedActionProto
             * @static
             * @param {waiternow.common.IGetUpdatedMenuDenormalizedActionProto} message GetUpdatedMenuDenormalizedActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetUpdatedMenuDenormalizedActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetUpdatedMenuDenormalizedActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.GetUpdatedMenuDenormalizedActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.GetUpdatedMenuDenormalizedActionProto} GetUpdatedMenuDenormalizedActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetUpdatedMenuDenormalizedActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetUpdatedMenuDenormalizedActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetUpdatedMenuDenormalizedActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.GetUpdatedMenuDenormalizedActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.GetUpdatedMenuDenormalizedActionProto} GetUpdatedMenuDenormalizedActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetUpdatedMenuDenormalizedActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetUpdatedMenuDenormalizedActionProto message.
             * @function verify
             * @memberof waiternow.common.GetUpdatedMenuDenormalizedActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetUpdatedMenuDenormalizedActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a GetUpdatedMenuDenormalizedActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.GetUpdatedMenuDenormalizedActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.GetUpdatedMenuDenormalizedActionProto} GetUpdatedMenuDenormalizedActionProto
             */
            GetUpdatedMenuDenormalizedActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.GetUpdatedMenuDenormalizedActionProto)
                    return object;
                return new $root.waiternow.common.GetUpdatedMenuDenormalizedActionProto();
            };

            /**
             * Creates a plain object from a GetUpdatedMenuDenormalizedActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.GetUpdatedMenuDenormalizedActionProto
             * @static
             * @param {waiternow.common.GetUpdatedMenuDenormalizedActionProto} message GetUpdatedMenuDenormalizedActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetUpdatedMenuDenormalizedActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this GetUpdatedMenuDenormalizedActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.GetUpdatedMenuDenormalizedActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetUpdatedMenuDenormalizedActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for GetUpdatedMenuDenormalizedActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.GetUpdatedMenuDenormalizedActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            GetUpdatedMenuDenormalizedActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.GetUpdatedMenuDenormalizedActionProto";
            };

            GetUpdatedMenuDenormalizedActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.GetUpdatedMenuDenormalizedActionProto
                 * @interface IRequest
                 * @property {string|null} [pointOfServiceId] Request pointOfServiceId
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.GetUpdatedMenuDenormalizedActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.GetUpdatedMenuDenormalizedActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request pointOfServiceId.
                 * @member {string} pointOfServiceId
                 * @memberof waiternow.common.GetUpdatedMenuDenormalizedActionProto.Request
                 * @instance
                 */
                Request.prototype.pointOfServiceId = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetUpdatedMenuDenormalizedActionProto.Request
                 * @static
                 * @param {waiternow.common.GetUpdatedMenuDenormalizedActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.GetUpdatedMenuDenormalizedActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.GetUpdatedMenuDenormalizedActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetUpdatedMenuDenormalizedActionProto.Request
                 * @static
                 * @param {waiternow.common.GetUpdatedMenuDenormalizedActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.pointOfServiceId != null && Object.hasOwnProperty.call(message, "pointOfServiceId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.pointOfServiceId);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.GetUpdatedMenuDenormalizedActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetUpdatedMenuDenormalizedActionProto.Request
                 * @static
                 * @param {waiternow.common.GetUpdatedMenuDenormalizedActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetUpdatedMenuDenormalizedActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetUpdatedMenuDenormalizedActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetUpdatedMenuDenormalizedActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.pointOfServiceId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetUpdatedMenuDenormalizedActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetUpdatedMenuDenormalizedActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.GetUpdatedMenuDenormalizedActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.pointOfServiceId != null && message.hasOwnProperty("pointOfServiceId"))
                        if (!$util.isString(message.pointOfServiceId))
                            return "pointOfServiceId: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetUpdatedMenuDenormalizedActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetUpdatedMenuDenormalizedActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetUpdatedMenuDenormalizedActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.GetUpdatedMenuDenormalizedActionProto.Request();
                    if (object.pointOfServiceId != null)
                        message.pointOfServiceId = String(object.pointOfServiceId);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetUpdatedMenuDenormalizedActionProto.Request
                 * @static
                 * @param {waiternow.common.GetUpdatedMenuDenormalizedActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.pointOfServiceId = "";
                    if (message.pointOfServiceId != null && message.hasOwnProperty("pointOfServiceId"))
                        object.pointOfServiceId = message.pointOfServiceId;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetUpdatedMenuDenormalizedActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetUpdatedMenuDenormalizedActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetUpdatedMenuDenormalizedActionProto.Request";
                };

                return Request;
            })();

            GetUpdatedMenuDenormalizedActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.GetUpdatedMenuDenormalizedActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IMenuProto|null} [menu] Response menu
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.GetUpdatedMenuDenormalizedActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.GetUpdatedMenuDenormalizedActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.GetUpdatedMenuDenormalizedActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response menu.
                 * @member {waiternow.common.IMenuProto|null|undefined} menu
                 * @memberof waiternow.common.GetUpdatedMenuDenormalizedActionProto.Response
                 * @instance
                 */
                Response.prototype.menu = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetUpdatedMenuDenormalizedActionProto.Response
                 * @static
                 * @param {waiternow.common.GetUpdatedMenuDenormalizedActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.GetUpdatedMenuDenormalizedActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.GetUpdatedMenuDenormalizedActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetUpdatedMenuDenormalizedActionProto.Response
                 * @static
                 * @param {waiternow.common.GetUpdatedMenuDenormalizedActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.menu != null && Object.hasOwnProperty.call(message, "menu"))
                        $root.waiternow.common.MenuProto.encode(message.menu, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.GetUpdatedMenuDenormalizedActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetUpdatedMenuDenormalizedActionProto.Response
                 * @static
                 * @param {waiternow.common.GetUpdatedMenuDenormalizedActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetUpdatedMenuDenormalizedActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetUpdatedMenuDenormalizedActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetUpdatedMenuDenormalizedActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.menu = $root.waiternow.common.MenuProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetUpdatedMenuDenormalizedActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetUpdatedMenuDenormalizedActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.GetUpdatedMenuDenormalizedActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.menu != null && message.hasOwnProperty("menu")) {
                        var error = $root.waiternow.common.MenuProto.verify(message.menu);
                        if (error)
                            return "menu." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetUpdatedMenuDenormalizedActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetUpdatedMenuDenormalizedActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetUpdatedMenuDenormalizedActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.GetUpdatedMenuDenormalizedActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.GetUpdatedMenuDenormalizedActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.menu != null) {
                        if (typeof object.menu !== "object")
                            throw TypeError(".waiternow.common.GetUpdatedMenuDenormalizedActionProto.Response.menu: object expected");
                        message.menu = $root.waiternow.common.MenuProto.fromObject(object.menu);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetUpdatedMenuDenormalizedActionProto.Response
                 * @static
                 * @param {waiternow.common.GetUpdatedMenuDenormalizedActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.menu = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.menu != null && message.hasOwnProperty("menu"))
                        object.menu = $root.waiternow.common.MenuProto.toObject(message.menu, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetUpdatedMenuDenormalizedActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetUpdatedMenuDenormalizedActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetUpdatedMenuDenormalizedActionProto.Response";
                };

                return Response;
            })();

            return GetUpdatedMenuDenormalizedActionProto;
        })();

        common.GetDeliveryQuoteActionProto = (function() {

            /**
             * Properties of a GetDeliveryQuoteActionProto.
             * @memberof waiternow.common
             * @interface IGetDeliveryQuoteActionProto
             */

            /**
             * Constructs a new GetDeliveryQuoteActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a GetDeliveryQuoteActionProto.
             * @implements IGetDeliveryQuoteActionProto
             * @constructor
             * @param {waiternow.common.IGetDeliveryQuoteActionProto=} [properties] Properties to set
             */
            function GetDeliveryQuoteActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new GetDeliveryQuoteActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.GetDeliveryQuoteActionProto
             * @static
             * @param {waiternow.common.IGetDeliveryQuoteActionProto=} [properties] Properties to set
             * @returns {waiternow.common.GetDeliveryQuoteActionProto} GetDeliveryQuoteActionProto instance
             */
            GetDeliveryQuoteActionProto.create = function create(properties) {
                return new GetDeliveryQuoteActionProto(properties);
            };

            /**
             * Encodes the specified GetDeliveryQuoteActionProto message. Does not implicitly {@link waiternow.common.GetDeliveryQuoteActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.GetDeliveryQuoteActionProto
             * @static
             * @param {waiternow.common.IGetDeliveryQuoteActionProto} message GetDeliveryQuoteActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetDeliveryQuoteActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified GetDeliveryQuoteActionProto message, length delimited. Does not implicitly {@link waiternow.common.GetDeliveryQuoteActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.GetDeliveryQuoteActionProto
             * @static
             * @param {waiternow.common.IGetDeliveryQuoteActionProto} message GetDeliveryQuoteActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetDeliveryQuoteActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetDeliveryQuoteActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.GetDeliveryQuoteActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.GetDeliveryQuoteActionProto} GetDeliveryQuoteActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetDeliveryQuoteActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetDeliveryQuoteActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetDeliveryQuoteActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.GetDeliveryQuoteActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.GetDeliveryQuoteActionProto} GetDeliveryQuoteActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetDeliveryQuoteActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetDeliveryQuoteActionProto message.
             * @function verify
             * @memberof waiternow.common.GetDeliveryQuoteActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetDeliveryQuoteActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a GetDeliveryQuoteActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.GetDeliveryQuoteActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.GetDeliveryQuoteActionProto} GetDeliveryQuoteActionProto
             */
            GetDeliveryQuoteActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.GetDeliveryQuoteActionProto)
                    return object;
                return new $root.waiternow.common.GetDeliveryQuoteActionProto();
            };

            /**
             * Creates a plain object from a GetDeliveryQuoteActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.GetDeliveryQuoteActionProto
             * @static
             * @param {waiternow.common.GetDeliveryQuoteActionProto} message GetDeliveryQuoteActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetDeliveryQuoteActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this GetDeliveryQuoteActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.GetDeliveryQuoteActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetDeliveryQuoteActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for GetDeliveryQuoteActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.GetDeliveryQuoteActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            GetDeliveryQuoteActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.GetDeliveryQuoteActionProto";
            };

            GetDeliveryQuoteActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.GetDeliveryQuoteActionProto
                 * @interface IRequest
                 * @property {string|null} [locationId] Request locationId
                 * @property {waiternow.common.IAddressProto|null} [deliveryAddress] Request deliveryAddress
                 * @property {waiternow.common.IPhoneNumberProto|null} [phoneNumber] Request phoneNumber
                 * @property {string|null} [email] Request email
                 * @property {waiternow.common.IDateTimeProto|null} [orderTime] Request orderTime
                 * @property {waiternow.common.IMenuOrderProto|null} [menuOrder] Request menuOrder
                 * @property {waiternow.common.IMoneyProto|null} [deliveryTip] Request deliveryTip
                 * @property {string|null} [consumerName] Request consumerName
                 * @property {string|null} [dropoffInstructions] Request dropoffInstructions
                 * @property {boolean|null} [contactlessDropoff] Request contactlessDropoff
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.GetDeliveryQuoteActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.GetDeliveryQuoteActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.GetDeliveryQuoteActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = "";

                /**
                 * Request deliveryAddress.
                 * @member {waiternow.common.IAddressProto|null|undefined} deliveryAddress
                 * @memberof waiternow.common.GetDeliveryQuoteActionProto.Request
                 * @instance
                 */
                Request.prototype.deliveryAddress = null;

                /**
                 * Request phoneNumber.
                 * @member {waiternow.common.IPhoneNumberProto|null|undefined} phoneNumber
                 * @memberof waiternow.common.GetDeliveryQuoteActionProto.Request
                 * @instance
                 */
                Request.prototype.phoneNumber = null;

                /**
                 * Request email.
                 * @member {string} email
                 * @memberof waiternow.common.GetDeliveryQuoteActionProto.Request
                 * @instance
                 */
                Request.prototype.email = "";

                /**
                 * Request orderTime.
                 * @member {waiternow.common.IDateTimeProto|null|undefined} orderTime
                 * @memberof waiternow.common.GetDeliveryQuoteActionProto.Request
                 * @instance
                 */
                Request.prototype.orderTime = null;

                /**
                 * Request menuOrder.
                 * @member {waiternow.common.IMenuOrderProto|null|undefined} menuOrder
                 * @memberof waiternow.common.GetDeliveryQuoteActionProto.Request
                 * @instance
                 */
                Request.prototype.menuOrder = null;

                /**
                 * Request deliveryTip.
                 * @member {waiternow.common.IMoneyProto|null|undefined} deliveryTip
                 * @memberof waiternow.common.GetDeliveryQuoteActionProto.Request
                 * @instance
                 */
                Request.prototype.deliveryTip = null;

                /**
                 * Request consumerName.
                 * @member {string} consumerName
                 * @memberof waiternow.common.GetDeliveryQuoteActionProto.Request
                 * @instance
                 */
                Request.prototype.consumerName = "";

                /**
                 * Request dropoffInstructions.
                 * @member {string} dropoffInstructions
                 * @memberof waiternow.common.GetDeliveryQuoteActionProto.Request
                 * @instance
                 */
                Request.prototype.dropoffInstructions = "";

                /**
                 * Request contactlessDropoff.
                 * @member {boolean} contactlessDropoff
                 * @memberof waiternow.common.GetDeliveryQuoteActionProto.Request
                 * @instance
                 */
                Request.prototype.contactlessDropoff = false;

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetDeliveryQuoteActionProto.Request
                 * @static
                 * @param {waiternow.common.GetDeliveryQuoteActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.GetDeliveryQuoteActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.GetDeliveryQuoteActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetDeliveryQuoteActionProto.Request
                 * @static
                 * @param {waiternow.common.GetDeliveryQuoteActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    if (message.deliveryAddress != null && Object.hasOwnProperty.call(message, "deliveryAddress"))
                        $root.waiternow.common.AddressProto.encode(message.deliveryAddress, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.phoneNumber != null && Object.hasOwnProperty.call(message, "phoneNumber"))
                        $root.waiternow.common.PhoneNumberProto.encode(message.phoneNumber, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.email);
                    if (message.orderTime != null && Object.hasOwnProperty.call(message, "orderTime"))
                        $root.waiternow.common.DateTimeProto.encode(message.orderTime, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.menuOrder != null && Object.hasOwnProperty.call(message, "menuOrder"))
                        $root.waiternow.common.MenuOrderProto.encode(message.menuOrder, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.deliveryTip != null && Object.hasOwnProperty.call(message, "deliveryTip"))
                        $root.waiternow.common.MoneyProto.encode(message.deliveryTip, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    if (message.consumerName != null && Object.hasOwnProperty.call(message, "consumerName"))
                        writer.uint32(/* id 8, wireType 2 =*/66).string(message.consumerName);
                    if (message.dropoffInstructions != null && Object.hasOwnProperty.call(message, "dropoffInstructions"))
                        writer.uint32(/* id 9, wireType 2 =*/74).string(message.dropoffInstructions);
                    if (message.contactlessDropoff != null && Object.hasOwnProperty.call(message, "contactlessDropoff"))
                        writer.uint32(/* id 10, wireType 0 =*/80).bool(message.contactlessDropoff);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.GetDeliveryQuoteActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetDeliveryQuoteActionProto.Request
                 * @static
                 * @param {waiternow.common.GetDeliveryQuoteActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetDeliveryQuoteActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetDeliveryQuoteActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetDeliveryQuoteActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 2: {
                                message.deliveryAddress = $root.waiternow.common.AddressProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.phoneNumber = $root.waiternow.common.PhoneNumberProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 4: {
                                message.email = reader.string();
                                break;
                            }
                        case 5: {
                                message.orderTime = $root.waiternow.common.DateTimeProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 6: {
                                message.menuOrder = $root.waiternow.common.MenuOrderProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 7: {
                                message.deliveryTip = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 8: {
                                message.consumerName = reader.string();
                                break;
                            }
                        case 9: {
                                message.dropoffInstructions = reader.string();
                                break;
                            }
                        case 10: {
                                message.contactlessDropoff = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetDeliveryQuoteActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetDeliveryQuoteActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.GetDeliveryQuoteActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    if (message.deliveryAddress != null && message.hasOwnProperty("deliveryAddress")) {
                        var error = $root.waiternow.common.AddressProto.verify(message.deliveryAddress);
                        if (error)
                            return "deliveryAddress." + error;
                    }
                    if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber")) {
                        var error = $root.waiternow.common.PhoneNumberProto.verify(message.phoneNumber);
                        if (error)
                            return "phoneNumber." + error;
                    }
                    if (message.email != null && message.hasOwnProperty("email"))
                        if (!$util.isString(message.email))
                            return "email: string expected";
                    if (message.orderTime != null && message.hasOwnProperty("orderTime")) {
                        var error = $root.waiternow.common.DateTimeProto.verify(message.orderTime);
                        if (error)
                            return "orderTime." + error;
                    }
                    if (message.menuOrder != null && message.hasOwnProperty("menuOrder")) {
                        var error = $root.waiternow.common.MenuOrderProto.verify(message.menuOrder);
                        if (error)
                            return "menuOrder." + error;
                    }
                    if (message.deliveryTip != null && message.hasOwnProperty("deliveryTip")) {
                        var error = $root.waiternow.common.MoneyProto.verify(message.deliveryTip);
                        if (error)
                            return "deliveryTip." + error;
                    }
                    if (message.consumerName != null && message.hasOwnProperty("consumerName"))
                        if (!$util.isString(message.consumerName))
                            return "consumerName: string expected";
                    if (message.dropoffInstructions != null && message.hasOwnProperty("dropoffInstructions"))
                        if (!$util.isString(message.dropoffInstructions))
                            return "dropoffInstructions: string expected";
                    if (message.contactlessDropoff != null && message.hasOwnProperty("contactlessDropoff"))
                        if (typeof message.contactlessDropoff !== "boolean")
                            return "contactlessDropoff: boolean expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetDeliveryQuoteActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetDeliveryQuoteActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetDeliveryQuoteActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.GetDeliveryQuoteActionProto.Request();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    if (object.deliveryAddress != null) {
                        if (typeof object.deliveryAddress !== "object")
                            throw TypeError(".waiternow.common.GetDeliveryQuoteActionProto.Request.deliveryAddress: object expected");
                        message.deliveryAddress = $root.waiternow.common.AddressProto.fromObject(object.deliveryAddress);
                    }
                    if (object.phoneNumber != null) {
                        if (typeof object.phoneNumber !== "object")
                            throw TypeError(".waiternow.common.GetDeliveryQuoteActionProto.Request.phoneNumber: object expected");
                        message.phoneNumber = $root.waiternow.common.PhoneNumberProto.fromObject(object.phoneNumber);
                    }
                    if (object.email != null)
                        message.email = String(object.email);
                    if (object.orderTime != null) {
                        if (typeof object.orderTime !== "object")
                            throw TypeError(".waiternow.common.GetDeliveryQuoteActionProto.Request.orderTime: object expected");
                        message.orderTime = $root.waiternow.common.DateTimeProto.fromObject(object.orderTime);
                    }
                    if (object.menuOrder != null) {
                        if (typeof object.menuOrder !== "object")
                            throw TypeError(".waiternow.common.GetDeliveryQuoteActionProto.Request.menuOrder: object expected");
                        message.menuOrder = $root.waiternow.common.MenuOrderProto.fromObject(object.menuOrder);
                    }
                    if (object.deliveryTip != null) {
                        if (typeof object.deliveryTip !== "object")
                            throw TypeError(".waiternow.common.GetDeliveryQuoteActionProto.Request.deliveryTip: object expected");
                        message.deliveryTip = $root.waiternow.common.MoneyProto.fromObject(object.deliveryTip);
                    }
                    if (object.consumerName != null)
                        message.consumerName = String(object.consumerName);
                    if (object.dropoffInstructions != null)
                        message.dropoffInstructions = String(object.dropoffInstructions);
                    if (object.contactlessDropoff != null)
                        message.contactlessDropoff = Boolean(object.contactlessDropoff);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetDeliveryQuoteActionProto.Request
                 * @static
                 * @param {waiternow.common.GetDeliveryQuoteActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.locationId = "";
                        object.deliveryAddress = null;
                        object.phoneNumber = null;
                        object.email = "";
                        object.orderTime = null;
                        object.menuOrder = null;
                        object.deliveryTip = null;
                        object.consumerName = "";
                        object.dropoffInstructions = "";
                        object.contactlessDropoff = false;
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    if (message.deliveryAddress != null && message.hasOwnProperty("deliveryAddress"))
                        object.deliveryAddress = $root.waiternow.common.AddressProto.toObject(message.deliveryAddress, options);
                    if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
                        object.phoneNumber = $root.waiternow.common.PhoneNumberProto.toObject(message.phoneNumber, options);
                    if (message.email != null && message.hasOwnProperty("email"))
                        object.email = message.email;
                    if (message.orderTime != null && message.hasOwnProperty("orderTime"))
                        object.orderTime = $root.waiternow.common.DateTimeProto.toObject(message.orderTime, options);
                    if (message.menuOrder != null && message.hasOwnProperty("menuOrder"))
                        object.menuOrder = $root.waiternow.common.MenuOrderProto.toObject(message.menuOrder, options);
                    if (message.deliveryTip != null && message.hasOwnProperty("deliveryTip"))
                        object.deliveryTip = $root.waiternow.common.MoneyProto.toObject(message.deliveryTip, options);
                    if (message.consumerName != null && message.hasOwnProperty("consumerName"))
                        object.consumerName = message.consumerName;
                    if (message.dropoffInstructions != null && message.hasOwnProperty("dropoffInstructions"))
                        object.dropoffInstructions = message.dropoffInstructions;
                    if (message.contactlessDropoff != null && message.hasOwnProperty("contactlessDropoff"))
                        object.contactlessDropoff = message.contactlessDropoff;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetDeliveryQuoteActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetDeliveryQuoteActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetDeliveryQuoteActionProto.Request";
                };

                return Request;
            })();

            GetDeliveryQuoteActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.GetDeliveryQuoteActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IDeliveryProto|null} [delivery] Response delivery
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.GetDeliveryQuoteActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.GetDeliveryQuoteActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.GetDeliveryQuoteActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response delivery.
                 * @member {waiternow.common.IDeliveryProto|null|undefined} delivery
                 * @memberof waiternow.common.GetDeliveryQuoteActionProto.Response
                 * @instance
                 */
                Response.prototype.delivery = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetDeliveryQuoteActionProto.Response
                 * @static
                 * @param {waiternow.common.GetDeliveryQuoteActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.GetDeliveryQuoteActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.GetDeliveryQuoteActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetDeliveryQuoteActionProto.Response
                 * @static
                 * @param {waiternow.common.GetDeliveryQuoteActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.delivery != null && Object.hasOwnProperty.call(message, "delivery"))
                        $root.waiternow.common.DeliveryProto.encode(message.delivery, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.GetDeliveryQuoteActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetDeliveryQuoteActionProto.Response
                 * @static
                 * @param {waiternow.common.GetDeliveryQuoteActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetDeliveryQuoteActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetDeliveryQuoteActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetDeliveryQuoteActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.delivery = $root.waiternow.common.DeliveryProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetDeliveryQuoteActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetDeliveryQuoteActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.GetDeliveryQuoteActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.delivery != null && message.hasOwnProperty("delivery")) {
                        var error = $root.waiternow.common.DeliveryProto.verify(message.delivery);
                        if (error)
                            return "delivery." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetDeliveryQuoteActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetDeliveryQuoteActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetDeliveryQuoteActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.GetDeliveryQuoteActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.GetDeliveryQuoteActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.delivery != null) {
                        if (typeof object.delivery !== "object")
                            throw TypeError(".waiternow.common.GetDeliveryQuoteActionProto.Response.delivery: object expected");
                        message.delivery = $root.waiternow.common.DeliveryProto.fromObject(object.delivery);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetDeliveryQuoteActionProto.Response
                 * @static
                 * @param {waiternow.common.GetDeliveryQuoteActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.delivery = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.delivery != null && message.hasOwnProperty("delivery"))
                        object.delivery = $root.waiternow.common.DeliveryProto.toObject(message.delivery, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetDeliveryQuoteActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetDeliveryQuoteActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetDeliveryQuoteActionProto.Response";
                };

                return Response;
            })();

            return GetDeliveryQuoteActionProto;
        })();

        common.PointOfServiceProto = (function() {

            /**
             * Properties of a PointOfServiceProto.
             * @memberof waiternow.common
             * @interface IPointOfServiceProto
             * @property {string|null} [id] PointOfServiceProto id
             * @property {google.protobuf.ITimestamp|null} [creationTime] PointOfServiceProto creationTime
             * @property {google.protobuf.ITimestamp|null} [lastUpdateTime] PointOfServiceProto lastUpdateTime
             * @property {string|null} [locationId] PointOfServiceProto locationId
             * @property {string|null} [friendlyName] PointOfServiceProto friendlyName
             * @property {waiternow.common.PointOfServiceProto.PointOfServiceType|null} [type] PointOfServiceProto type
             * @property {waiternow.common.PointOfServiceProto.IRedundantDataProto|null} [redundantData] PointOfServiceProto redundantData
             * @property {string|null} [vanityUrl] PointOfServiceProto vanityUrl
             */

            /**
             * Constructs a new PointOfServiceProto.
             * @memberof waiternow.common
             * @classdesc Represents a PointOfServiceProto.
             * @implements IPointOfServiceProto
             * @constructor
             * @param {waiternow.common.IPointOfServiceProto=} [properties] Properties to set
             */
            function PointOfServiceProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * PointOfServiceProto id.
             * @member {string} id
             * @memberof waiternow.common.PointOfServiceProto
             * @instance
             */
            PointOfServiceProto.prototype.id = "";

            /**
             * PointOfServiceProto creationTime.
             * @member {google.protobuf.ITimestamp|null|undefined} creationTime
             * @memberof waiternow.common.PointOfServiceProto
             * @instance
             */
            PointOfServiceProto.prototype.creationTime = null;

            /**
             * PointOfServiceProto lastUpdateTime.
             * @member {google.protobuf.ITimestamp|null|undefined} lastUpdateTime
             * @memberof waiternow.common.PointOfServiceProto
             * @instance
             */
            PointOfServiceProto.prototype.lastUpdateTime = null;

            /**
             * PointOfServiceProto locationId.
             * @member {string} locationId
             * @memberof waiternow.common.PointOfServiceProto
             * @instance
             */
            PointOfServiceProto.prototype.locationId = "";

            /**
             * PointOfServiceProto friendlyName.
             * @member {string} friendlyName
             * @memberof waiternow.common.PointOfServiceProto
             * @instance
             */
            PointOfServiceProto.prototype.friendlyName = "";

            /**
             * PointOfServiceProto type.
             * @member {waiternow.common.PointOfServiceProto.PointOfServiceType} type
             * @memberof waiternow.common.PointOfServiceProto
             * @instance
             */
            PointOfServiceProto.prototype.type = 0;

            /**
             * PointOfServiceProto redundantData.
             * @member {waiternow.common.PointOfServiceProto.IRedundantDataProto|null|undefined} redundantData
             * @memberof waiternow.common.PointOfServiceProto
             * @instance
             */
            PointOfServiceProto.prototype.redundantData = null;

            /**
             * PointOfServiceProto vanityUrl.
             * @member {string} vanityUrl
             * @memberof waiternow.common.PointOfServiceProto
             * @instance
             */
            PointOfServiceProto.prototype.vanityUrl = "";

            /**
             * Creates a new PointOfServiceProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.PointOfServiceProto
             * @static
             * @param {waiternow.common.IPointOfServiceProto=} [properties] Properties to set
             * @returns {waiternow.common.PointOfServiceProto} PointOfServiceProto instance
             */
            PointOfServiceProto.create = function create(properties) {
                return new PointOfServiceProto(properties);
            };

            /**
             * Encodes the specified PointOfServiceProto message. Does not implicitly {@link waiternow.common.PointOfServiceProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.PointOfServiceProto
             * @static
             * @param {waiternow.common.IPointOfServiceProto} message PointOfServiceProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PointOfServiceProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.locationId);
                if (message.friendlyName != null && Object.hasOwnProperty.call(message, "friendlyName"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.friendlyName);
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 4, wireType 0 =*/32).int32(message.type);
                if (message.creationTime != null && Object.hasOwnProperty.call(message, "creationTime"))
                    $root.google.protobuf.Timestamp.encode(message.creationTime, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                    $root.google.protobuf.Timestamp.encode(message.lastUpdateTime, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                if (message.redundantData != null && Object.hasOwnProperty.call(message, "redundantData"))
                    $root.waiternow.common.PointOfServiceProto.RedundantDataProto.encode(message.redundantData, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                if (message.vanityUrl != null && Object.hasOwnProperty.call(message, "vanityUrl"))
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.vanityUrl);
                return writer;
            };

            /**
             * Encodes the specified PointOfServiceProto message, length delimited. Does not implicitly {@link waiternow.common.PointOfServiceProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.PointOfServiceProto
             * @static
             * @param {waiternow.common.IPointOfServiceProto} message PointOfServiceProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PointOfServiceProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a PointOfServiceProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.PointOfServiceProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.PointOfServiceProto} PointOfServiceProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PointOfServiceProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PointOfServiceProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.id = reader.string();
                            break;
                        }
                    case 5: {
                            message.creationTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 6: {
                            message.lastUpdateTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 2: {
                            message.locationId = reader.string();
                            break;
                        }
                    case 3: {
                            message.friendlyName = reader.string();
                            break;
                        }
                    case 4: {
                            message.type = reader.int32();
                            break;
                        }
                    case 7: {
                            message.redundantData = $root.waiternow.common.PointOfServiceProto.RedundantDataProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 8: {
                            message.vanityUrl = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a PointOfServiceProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.PointOfServiceProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.PointOfServiceProto} PointOfServiceProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PointOfServiceProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a PointOfServiceProto message.
             * @function verify
             * @memberof waiternow.common.PointOfServiceProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            PointOfServiceProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.id != null && message.hasOwnProperty("id"))
                    if (!$util.isString(message.id))
                        return "id: string expected";
                if (message.creationTime != null && message.hasOwnProperty("creationTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.creationTime);
                    if (error)
                        return "creationTime." + error;
                }
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.lastUpdateTime);
                    if (error)
                        return "lastUpdateTime." + error;
                }
                if (message.locationId != null && message.hasOwnProperty("locationId"))
                    if (!$util.isString(message.locationId))
                        return "locationId: string expected";
                if (message.friendlyName != null && message.hasOwnProperty("friendlyName"))
                    if (!$util.isString(message.friendlyName))
                        return "friendlyName: string expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    switch (message.type) {
                    default:
                        return "type: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                        break;
                    }
                if (message.redundantData != null && message.hasOwnProperty("redundantData")) {
                    var error = $root.waiternow.common.PointOfServiceProto.RedundantDataProto.verify(message.redundantData);
                    if (error)
                        return "redundantData." + error;
                }
                if (message.vanityUrl != null && message.hasOwnProperty("vanityUrl"))
                    if (!$util.isString(message.vanityUrl))
                        return "vanityUrl: string expected";
                return null;
            };

            /**
             * Creates a PointOfServiceProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.PointOfServiceProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.PointOfServiceProto} PointOfServiceProto
             */
            PointOfServiceProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.PointOfServiceProto)
                    return object;
                var message = new $root.waiternow.common.PointOfServiceProto();
                if (object.id != null)
                    message.id = String(object.id);
                if (object.creationTime != null) {
                    if (typeof object.creationTime !== "object")
                        throw TypeError(".waiternow.common.PointOfServiceProto.creationTime: object expected");
                    message.creationTime = $root.google.protobuf.Timestamp.fromObject(object.creationTime);
                }
                if (object.lastUpdateTime != null) {
                    if (typeof object.lastUpdateTime !== "object")
                        throw TypeError(".waiternow.common.PointOfServiceProto.lastUpdateTime: object expected");
                    message.lastUpdateTime = $root.google.protobuf.Timestamp.fromObject(object.lastUpdateTime);
                }
                if (object.locationId != null)
                    message.locationId = String(object.locationId);
                if (object.friendlyName != null)
                    message.friendlyName = String(object.friendlyName);
                switch (object.type) {
                default:
                    if (typeof object.type === "number") {
                        message.type = object.type;
                        break;
                    }
                    break;
                case "POINT_OF_SERVICE_TYPE_UNSPECIFIED":
                case 0:
                    message.type = 0;
                    break;
                case "TABLE":
                case 1:
                    message.type = 1;
                    break;
                case "ROOM":
                case 2:
                    message.type = 2;
                    break;
                case "TERRACE":
                case 3:
                    message.type = 3;
                    break;
                case "POOL":
                case 4:
                    message.type = 4;
                    break;
                case "MENU":
                case 5:
                    message.type = 5;
                    break;
                case "ONLINE_PICKUP":
                case 6:
                    message.type = 6;
                    break;
                case "ONSITE_PICKUP":
                case 7:
                    message.type = 7;
                    break;
                case "ONLINE":
                case 8:
                    message.type = 8;
                    break;
                }
                if (object.redundantData != null) {
                    if (typeof object.redundantData !== "object")
                        throw TypeError(".waiternow.common.PointOfServiceProto.redundantData: object expected");
                    message.redundantData = $root.waiternow.common.PointOfServiceProto.RedundantDataProto.fromObject(object.redundantData);
                }
                if (object.vanityUrl != null)
                    message.vanityUrl = String(object.vanityUrl);
                return message;
            };

            /**
             * Creates a plain object from a PointOfServiceProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.PointOfServiceProto
             * @static
             * @param {waiternow.common.PointOfServiceProto} message PointOfServiceProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            PointOfServiceProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.id = "";
                    object.locationId = "";
                    object.friendlyName = "";
                    object.type = options.enums === String ? "POINT_OF_SERVICE_TYPE_UNSPECIFIED" : 0;
                    object.creationTime = null;
                    object.lastUpdateTime = null;
                    object.redundantData = null;
                    object.vanityUrl = "";
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                if (message.locationId != null && message.hasOwnProperty("locationId"))
                    object.locationId = message.locationId;
                if (message.friendlyName != null && message.hasOwnProperty("friendlyName"))
                    object.friendlyName = message.friendlyName;
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = options.enums === String ? $root.waiternow.common.PointOfServiceProto.PointOfServiceType[message.type] === undefined ? message.type : $root.waiternow.common.PointOfServiceProto.PointOfServiceType[message.type] : message.type;
                if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                    object.creationTime = $root.google.protobuf.Timestamp.toObject(message.creationTime, options);
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                    object.lastUpdateTime = $root.google.protobuf.Timestamp.toObject(message.lastUpdateTime, options);
                if (message.redundantData != null && message.hasOwnProperty("redundantData"))
                    object.redundantData = $root.waiternow.common.PointOfServiceProto.RedundantDataProto.toObject(message.redundantData, options);
                if (message.vanityUrl != null && message.hasOwnProperty("vanityUrl"))
                    object.vanityUrl = message.vanityUrl;
                return object;
            };

            /**
             * Converts this PointOfServiceProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.PointOfServiceProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            PointOfServiceProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for PointOfServiceProto
             * @function getTypeUrl
             * @memberof waiternow.common.PointOfServiceProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            PointOfServiceProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.PointOfServiceProto";
            };

            /**
             * PointOfServiceType enum.
             * @name waiternow.common.PointOfServiceProto.PointOfServiceType
             * @enum {number}
             * @property {number} POINT_OF_SERVICE_TYPE_UNSPECIFIED=0 POINT_OF_SERVICE_TYPE_UNSPECIFIED value
             * @property {number} TABLE=1 TABLE value
             * @property {number} ROOM=2 ROOM value
             * @property {number} TERRACE=3 TERRACE value
             * @property {number} POOL=4 POOL value
             * @property {number} MENU=5 MENU value
             * @property {number} ONLINE_PICKUP=6 ONLINE_PICKUP value
             * @property {number} ONSITE_PICKUP=7 ONSITE_PICKUP value
             * @property {number} ONLINE=8 ONLINE value
             */
            PointOfServiceProto.PointOfServiceType = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "POINT_OF_SERVICE_TYPE_UNSPECIFIED"] = 0;
                values[valuesById[1] = "TABLE"] = 1;
                values[valuesById[2] = "ROOM"] = 2;
                values[valuesById[3] = "TERRACE"] = 3;
                values[valuesById[4] = "POOL"] = 4;
                values[valuesById[5] = "MENU"] = 5;
                values[valuesById[6] = "ONLINE_PICKUP"] = 6;
                values[valuesById[7] = "ONSITE_PICKUP"] = 7;
                values[valuesById[8] = "ONLINE"] = 8;
                return values;
            })();

            PointOfServiceProto.RedundantDataProto = (function() {

                /**
                 * Properties of a RedundantDataProto.
                 * @memberof waiternow.common.PointOfServiceProto
                 * @interface IRedundantDataProto
                 * @property {string|null} [businessId] RedundantDataProto businessId
                 * @property {string|null} [businessName] RedundantDataProto businessName
                 * @property {waiternow.common.IImageProto|null} [businessLogo] RedundantDataProto businessLogo
                 * @property {boolean|null} [isBusinessSuspended] RedundantDataProto isBusinessSuspended
                 * @property {waiternow.common.LocationProto.ISettingsProto|null} [businessLocationSettings] RedundantDataProto businessLocationSettings
                 * @property {string|null} [locationName] RedundantDataProto locationName
                 * @property {waiternow.common.LocationProto.ISettingsProto|null} [locationSettings] RedundantDataProto locationSettings
                 * @property {waiternow.common.IAddressProto|null} [locationAddress] RedundantDataProto locationAddress
                 * @property {waiternow.common.IImageProto|null} [businessMenuHeaderForLandscapeScreen] RedundantDataProto businessMenuHeaderForLandscapeScreen
                 * @property {waiternow.common.IImageProto|null} [businessMenuHeaderForPortraitScreen] RedundantDataProto businessMenuHeaderForPortraitScreen
                 * @property {waiternow.common.IImageProto|null} [businessHomeHeaderForLandscapeScreen] RedundantDataProto businessHomeHeaderForLandscapeScreen
                 * @property {waiternow.common.IImageProto|null} [businessHomeHeaderForPortraitScreen] RedundantDataProto businessHomeHeaderForPortraitScreen
                 * @property {waiternow.common.IPhoneNumberProto|null} [locationPhoneNumber] RedundantDataProto locationPhoneNumber
                 * @property {string|null} [legacyBusinessDescription] RedundantDataProto legacyBusinessDescription
                 * @property {waiternow.common.ITextProto|null} [businessDescription] RedundantDataProto businessDescription
                 * @property {waiternow.common.ITextProto|null} [locationAnnouncement] RedundantDataProto locationAnnouncement
                 */

                /**
                 * Constructs a new RedundantDataProto.
                 * @memberof waiternow.common.PointOfServiceProto
                 * @classdesc Represents a RedundantDataProto.
                 * @implements IRedundantDataProto
                 * @constructor
                 * @param {waiternow.common.PointOfServiceProto.IRedundantDataProto=} [properties] Properties to set
                 */
                function RedundantDataProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * RedundantDataProto businessId.
                 * @member {string} businessId
                 * @memberof waiternow.common.PointOfServiceProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.businessId = "";

                /**
                 * RedundantDataProto businessName.
                 * @member {string} businessName
                 * @memberof waiternow.common.PointOfServiceProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.businessName = "";

                /**
                 * RedundantDataProto businessLogo.
                 * @member {waiternow.common.IImageProto|null|undefined} businessLogo
                 * @memberof waiternow.common.PointOfServiceProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.businessLogo = null;

                /**
                 * RedundantDataProto isBusinessSuspended.
                 * @member {boolean} isBusinessSuspended
                 * @memberof waiternow.common.PointOfServiceProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.isBusinessSuspended = false;

                /**
                 * RedundantDataProto businessLocationSettings.
                 * @member {waiternow.common.LocationProto.ISettingsProto|null|undefined} businessLocationSettings
                 * @memberof waiternow.common.PointOfServiceProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.businessLocationSettings = null;

                /**
                 * RedundantDataProto locationName.
                 * @member {string} locationName
                 * @memberof waiternow.common.PointOfServiceProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.locationName = "";

                /**
                 * RedundantDataProto locationSettings.
                 * @member {waiternow.common.LocationProto.ISettingsProto|null|undefined} locationSettings
                 * @memberof waiternow.common.PointOfServiceProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.locationSettings = null;

                /**
                 * RedundantDataProto locationAddress.
                 * @member {waiternow.common.IAddressProto|null|undefined} locationAddress
                 * @memberof waiternow.common.PointOfServiceProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.locationAddress = null;

                /**
                 * RedundantDataProto businessMenuHeaderForLandscapeScreen.
                 * @member {waiternow.common.IImageProto|null|undefined} businessMenuHeaderForLandscapeScreen
                 * @memberof waiternow.common.PointOfServiceProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.businessMenuHeaderForLandscapeScreen = null;

                /**
                 * RedundantDataProto businessMenuHeaderForPortraitScreen.
                 * @member {waiternow.common.IImageProto|null|undefined} businessMenuHeaderForPortraitScreen
                 * @memberof waiternow.common.PointOfServiceProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.businessMenuHeaderForPortraitScreen = null;

                /**
                 * RedundantDataProto businessHomeHeaderForLandscapeScreen.
                 * @member {waiternow.common.IImageProto|null|undefined} businessHomeHeaderForLandscapeScreen
                 * @memberof waiternow.common.PointOfServiceProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.businessHomeHeaderForLandscapeScreen = null;

                /**
                 * RedundantDataProto businessHomeHeaderForPortraitScreen.
                 * @member {waiternow.common.IImageProto|null|undefined} businessHomeHeaderForPortraitScreen
                 * @memberof waiternow.common.PointOfServiceProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.businessHomeHeaderForPortraitScreen = null;

                /**
                 * RedundantDataProto locationPhoneNumber.
                 * @member {waiternow.common.IPhoneNumberProto|null|undefined} locationPhoneNumber
                 * @memberof waiternow.common.PointOfServiceProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.locationPhoneNumber = null;

                /**
                 * RedundantDataProto legacyBusinessDescription.
                 * @member {string} legacyBusinessDescription
                 * @memberof waiternow.common.PointOfServiceProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.legacyBusinessDescription = "";

                /**
                 * RedundantDataProto businessDescription.
                 * @member {waiternow.common.ITextProto|null|undefined} businessDescription
                 * @memberof waiternow.common.PointOfServiceProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.businessDescription = null;

                /**
                 * RedundantDataProto locationAnnouncement.
                 * @member {waiternow.common.ITextProto|null|undefined} locationAnnouncement
                 * @memberof waiternow.common.PointOfServiceProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.locationAnnouncement = null;

                /**
                 * Creates a new RedundantDataProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.PointOfServiceProto.RedundantDataProto
                 * @static
                 * @param {waiternow.common.PointOfServiceProto.IRedundantDataProto=} [properties] Properties to set
                 * @returns {waiternow.common.PointOfServiceProto.RedundantDataProto} RedundantDataProto instance
                 */
                RedundantDataProto.create = function create(properties) {
                    return new RedundantDataProto(properties);
                };

                /**
                 * Encodes the specified RedundantDataProto message. Does not implicitly {@link waiternow.common.PointOfServiceProto.RedundantDataProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.PointOfServiceProto.RedundantDataProto
                 * @static
                 * @param {waiternow.common.PointOfServiceProto.IRedundantDataProto} message RedundantDataProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RedundantDataProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessId);
                    if (message.businessName != null && Object.hasOwnProperty.call(message, "businessName"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.businessName);
                    if (message.isBusinessSuspended != null && Object.hasOwnProperty.call(message, "isBusinessSuspended"))
                        writer.uint32(/* id 4, wireType 0 =*/32).bool(message.isBusinessSuspended);
                    if (message.businessLocationSettings != null && Object.hasOwnProperty.call(message, "businessLocationSettings"))
                        $root.waiternow.common.LocationProto.SettingsProto.encode(message.businessLocationSettings, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.locationName != null && Object.hasOwnProperty.call(message, "locationName"))
                        writer.uint32(/* id 6, wireType 2 =*/50).string(message.locationName);
                    if (message.locationSettings != null && Object.hasOwnProperty.call(message, "locationSettings"))
                        $root.waiternow.common.LocationProto.SettingsProto.encode(message.locationSettings, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    if (message.businessLogo != null && Object.hasOwnProperty.call(message, "businessLogo"))
                        $root.waiternow.common.ImageProto.encode(message.businessLogo, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                    if (message.locationAddress != null && Object.hasOwnProperty.call(message, "locationAddress"))
                        $root.waiternow.common.AddressProto.encode(message.locationAddress, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                    if (message.businessMenuHeaderForLandscapeScreen != null && Object.hasOwnProperty.call(message, "businessMenuHeaderForLandscapeScreen"))
                        $root.waiternow.common.ImageProto.encode(message.businessMenuHeaderForLandscapeScreen, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                    if (message.businessMenuHeaderForPortraitScreen != null && Object.hasOwnProperty.call(message, "businessMenuHeaderForPortraitScreen"))
                        $root.waiternow.common.ImageProto.encode(message.businessMenuHeaderForPortraitScreen, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                    if (message.locationPhoneNumber != null && Object.hasOwnProperty.call(message, "locationPhoneNumber"))
                        $root.waiternow.common.PhoneNumberProto.encode(message.locationPhoneNumber, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                    if (message.legacyBusinessDescription != null && Object.hasOwnProperty.call(message, "legacyBusinessDescription"))
                        writer.uint32(/* id 13, wireType 2 =*/106).string(message.legacyBusinessDescription);
                    if (message.businessDescription != null && Object.hasOwnProperty.call(message, "businessDescription"))
                        $root.waiternow.common.TextProto.encode(message.businessDescription, writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
                    if (message.locationAnnouncement != null && Object.hasOwnProperty.call(message, "locationAnnouncement"))
                        $root.waiternow.common.TextProto.encode(message.locationAnnouncement, writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
                    if (message.businessHomeHeaderForLandscapeScreen != null && Object.hasOwnProperty.call(message, "businessHomeHeaderForLandscapeScreen"))
                        $root.waiternow.common.ImageProto.encode(message.businessHomeHeaderForLandscapeScreen, writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
                    if (message.businessHomeHeaderForPortraitScreen != null && Object.hasOwnProperty.call(message, "businessHomeHeaderForPortraitScreen"))
                        $root.waiternow.common.ImageProto.encode(message.businessHomeHeaderForPortraitScreen, writer.uint32(/* id 17, wireType 2 =*/138).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified RedundantDataProto message, length delimited. Does not implicitly {@link waiternow.common.PointOfServiceProto.RedundantDataProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.PointOfServiceProto.RedundantDataProto
                 * @static
                 * @param {waiternow.common.PointOfServiceProto.IRedundantDataProto} message RedundantDataProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RedundantDataProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a RedundantDataProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.PointOfServiceProto.RedundantDataProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.PointOfServiceProto.RedundantDataProto} RedundantDataProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RedundantDataProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PointOfServiceProto.RedundantDataProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.businessId = reader.string();
                                break;
                            }
                        case 2: {
                                message.businessName = reader.string();
                                break;
                            }
                        case 8: {
                                message.businessLogo = $root.waiternow.common.ImageProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 4: {
                                message.isBusinessSuspended = reader.bool();
                                break;
                            }
                        case 5: {
                                message.businessLocationSettings = $root.waiternow.common.LocationProto.SettingsProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 6: {
                                message.locationName = reader.string();
                                break;
                            }
                        case 7: {
                                message.locationSettings = $root.waiternow.common.LocationProto.SettingsProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 9: {
                                message.locationAddress = $root.waiternow.common.AddressProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 10: {
                                message.businessMenuHeaderForLandscapeScreen = $root.waiternow.common.ImageProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 11: {
                                message.businessMenuHeaderForPortraitScreen = $root.waiternow.common.ImageProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 16: {
                                message.businessHomeHeaderForLandscapeScreen = $root.waiternow.common.ImageProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 17: {
                                message.businessHomeHeaderForPortraitScreen = $root.waiternow.common.ImageProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 12: {
                                message.locationPhoneNumber = $root.waiternow.common.PhoneNumberProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 13: {
                                message.legacyBusinessDescription = reader.string();
                                break;
                            }
                        case 14: {
                                message.businessDescription = $root.waiternow.common.TextProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 15: {
                                message.locationAnnouncement = $root.waiternow.common.TextProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a RedundantDataProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.PointOfServiceProto.RedundantDataProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.PointOfServiceProto.RedundantDataProto} RedundantDataProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RedundantDataProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a RedundantDataProto message.
                 * @function verify
                 * @memberof waiternow.common.PointOfServiceProto.RedundantDataProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                RedundantDataProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.businessId != null && message.hasOwnProperty("businessId"))
                        if (!$util.isString(message.businessId))
                            return "businessId: string expected";
                    if (message.businessName != null && message.hasOwnProperty("businessName"))
                        if (!$util.isString(message.businessName))
                            return "businessName: string expected";
                    if (message.businessLogo != null && message.hasOwnProperty("businessLogo")) {
                        var error = $root.waiternow.common.ImageProto.verify(message.businessLogo);
                        if (error)
                            return "businessLogo." + error;
                    }
                    if (message.isBusinessSuspended != null && message.hasOwnProperty("isBusinessSuspended"))
                        if (typeof message.isBusinessSuspended !== "boolean")
                            return "isBusinessSuspended: boolean expected";
                    if (message.businessLocationSettings != null && message.hasOwnProperty("businessLocationSettings")) {
                        var error = $root.waiternow.common.LocationProto.SettingsProto.verify(message.businessLocationSettings);
                        if (error)
                            return "businessLocationSettings." + error;
                    }
                    if (message.locationName != null && message.hasOwnProperty("locationName"))
                        if (!$util.isString(message.locationName))
                            return "locationName: string expected";
                    if (message.locationSettings != null && message.hasOwnProperty("locationSettings")) {
                        var error = $root.waiternow.common.LocationProto.SettingsProto.verify(message.locationSettings);
                        if (error)
                            return "locationSettings." + error;
                    }
                    if (message.locationAddress != null && message.hasOwnProperty("locationAddress")) {
                        var error = $root.waiternow.common.AddressProto.verify(message.locationAddress);
                        if (error)
                            return "locationAddress." + error;
                    }
                    if (message.businessMenuHeaderForLandscapeScreen != null && message.hasOwnProperty("businessMenuHeaderForLandscapeScreen")) {
                        var error = $root.waiternow.common.ImageProto.verify(message.businessMenuHeaderForLandscapeScreen);
                        if (error)
                            return "businessMenuHeaderForLandscapeScreen." + error;
                    }
                    if (message.businessMenuHeaderForPortraitScreen != null && message.hasOwnProperty("businessMenuHeaderForPortraitScreen")) {
                        var error = $root.waiternow.common.ImageProto.verify(message.businessMenuHeaderForPortraitScreen);
                        if (error)
                            return "businessMenuHeaderForPortraitScreen." + error;
                    }
                    if (message.businessHomeHeaderForLandscapeScreen != null && message.hasOwnProperty("businessHomeHeaderForLandscapeScreen")) {
                        var error = $root.waiternow.common.ImageProto.verify(message.businessHomeHeaderForLandscapeScreen);
                        if (error)
                            return "businessHomeHeaderForLandscapeScreen." + error;
                    }
                    if (message.businessHomeHeaderForPortraitScreen != null && message.hasOwnProperty("businessHomeHeaderForPortraitScreen")) {
                        var error = $root.waiternow.common.ImageProto.verify(message.businessHomeHeaderForPortraitScreen);
                        if (error)
                            return "businessHomeHeaderForPortraitScreen." + error;
                    }
                    if (message.locationPhoneNumber != null && message.hasOwnProperty("locationPhoneNumber")) {
                        var error = $root.waiternow.common.PhoneNumberProto.verify(message.locationPhoneNumber);
                        if (error)
                            return "locationPhoneNumber." + error;
                    }
                    if (message.legacyBusinessDescription != null && message.hasOwnProperty("legacyBusinessDescription"))
                        if (!$util.isString(message.legacyBusinessDescription))
                            return "legacyBusinessDescription: string expected";
                    if (message.businessDescription != null && message.hasOwnProperty("businessDescription")) {
                        var error = $root.waiternow.common.TextProto.verify(message.businessDescription);
                        if (error)
                            return "businessDescription." + error;
                    }
                    if (message.locationAnnouncement != null && message.hasOwnProperty("locationAnnouncement")) {
                        var error = $root.waiternow.common.TextProto.verify(message.locationAnnouncement);
                        if (error)
                            return "locationAnnouncement." + error;
                    }
                    return null;
                };

                /**
                 * Creates a RedundantDataProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.PointOfServiceProto.RedundantDataProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.PointOfServiceProto.RedundantDataProto} RedundantDataProto
                 */
                RedundantDataProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.PointOfServiceProto.RedundantDataProto)
                        return object;
                    var message = new $root.waiternow.common.PointOfServiceProto.RedundantDataProto();
                    if (object.businessId != null)
                        message.businessId = String(object.businessId);
                    if (object.businessName != null)
                        message.businessName = String(object.businessName);
                    if (object.businessLogo != null) {
                        if (typeof object.businessLogo !== "object")
                            throw TypeError(".waiternow.common.PointOfServiceProto.RedundantDataProto.businessLogo: object expected");
                        message.businessLogo = $root.waiternow.common.ImageProto.fromObject(object.businessLogo);
                    }
                    if (object.isBusinessSuspended != null)
                        message.isBusinessSuspended = Boolean(object.isBusinessSuspended);
                    if (object.businessLocationSettings != null) {
                        if (typeof object.businessLocationSettings !== "object")
                            throw TypeError(".waiternow.common.PointOfServiceProto.RedundantDataProto.businessLocationSettings: object expected");
                        message.businessLocationSettings = $root.waiternow.common.LocationProto.SettingsProto.fromObject(object.businessLocationSettings);
                    }
                    if (object.locationName != null)
                        message.locationName = String(object.locationName);
                    if (object.locationSettings != null) {
                        if (typeof object.locationSettings !== "object")
                            throw TypeError(".waiternow.common.PointOfServiceProto.RedundantDataProto.locationSettings: object expected");
                        message.locationSettings = $root.waiternow.common.LocationProto.SettingsProto.fromObject(object.locationSettings);
                    }
                    if (object.locationAddress != null) {
                        if (typeof object.locationAddress !== "object")
                            throw TypeError(".waiternow.common.PointOfServiceProto.RedundantDataProto.locationAddress: object expected");
                        message.locationAddress = $root.waiternow.common.AddressProto.fromObject(object.locationAddress);
                    }
                    if (object.businessMenuHeaderForLandscapeScreen != null) {
                        if (typeof object.businessMenuHeaderForLandscapeScreen !== "object")
                            throw TypeError(".waiternow.common.PointOfServiceProto.RedundantDataProto.businessMenuHeaderForLandscapeScreen: object expected");
                        message.businessMenuHeaderForLandscapeScreen = $root.waiternow.common.ImageProto.fromObject(object.businessMenuHeaderForLandscapeScreen);
                    }
                    if (object.businessMenuHeaderForPortraitScreen != null) {
                        if (typeof object.businessMenuHeaderForPortraitScreen !== "object")
                            throw TypeError(".waiternow.common.PointOfServiceProto.RedundantDataProto.businessMenuHeaderForPortraitScreen: object expected");
                        message.businessMenuHeaderForPortraitScreen = $root.waiternow.common.ImageProto.fromObject(object.businessMenuHeaderForPortraitScreen);
                    }
                    if (object.businessHomeHeaderForLandscapeScreen != null) {
                        if (typeof object.businessHomeHeaderForLandscapeScreen !== "object")
                            throw TypeError(".waiternow.common.PointOfServiceProto.RedundantDataProto.businessHomeHeaderForLandscapeScreen: object expected");
                        message.businessHomeHeaderForLandscapeScreen = $root.waiternow.common.ImageProto.fromObject(object.businessHomeHeaderForLandscapeScreen);
                    }
                    if (object.businessHomeHeaderForPortraitScreen != null) {
                        if (typeof object.businessHomeHeaderForPortraitScreen !== "object")
                            throw TypeError(".waiternow.common.PointOfServiceProto.RedundantDataProto.businessHomeHeaderForPortraitScreen: object expected");
                        message.businessHomeHeaderForPortraitScreen = $root.waiternow.common.ImageProto.fromObject(object.businessHomeHeaderForPortraitScreen);
                    }
                    if (object.locationPhoneNumber != null) {
                        if (typeof object.locationPhoneNumber !== "object")
                            throw TypeError(".waiternow.common.PointOfServiceProto.RedundantDataProto.locationPhoneNumber: object expected");
                        message.locationPhoneNumber = $root.waiternow.common.PhoneNumberProto.fromObject(object.locationPhoneNumber);
                    }
                    if (object.legacyBusinessDescription != null)
                        message.legacyBusinessDescription = String(object.legacyBusinessDescription);
                    if (object.businessDescription != null) {
                        if (typeof object.businessDescription !== "object")
                            throw TypeError(".waiternow.common.PointOfServiceProto.RedundantDataProto.businessDescription: object expected");
                        message.businessDescription = $root.waiternow.common.TextProto.fromObject(object.businessDescription);
                    }
                    if (object.locationAnnouncement != null) {
                        if (typeof object.locationAnnouncement !== "object")
                            throw TypeError(".waiternow.common.PointOfServiceProto.RedundantDataProto.locationAnnouncement: object expected");
                        message.locationAnnouncement = $root.waiternow.common.TextProto.fromObject(object.locationAnnouncement);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a RedundantDataProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.PointOfServiceProto.RedundantDataProto
                 * @static
                 * @param {waiternow.common.PointOfServiceProto.RedundantDataProto} message RedundantDataProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                RedundantDataProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.businessId = "";
                        object.businessName = "";
                        object.isBusinessSuspended = false;
                        object.businessLocationSettings = null;
                        object.locationName = "";
                        object.locationSettings = null;
                        object.businessLogo = null;
                        object.locationAddress = null;
                        object.businessMenuHeaderForLandscapeScreen = null;
                        object.businessMenuHeaderForPortraitScreen = null;
                        object.locationPhoneNumber = null;
                        object.legacyBusinessDescription = "";
                        object.businessDescription = null;
                        object.locationAnnouncement = null;
                        object.businessHomeHeaderForLandscapeScreen = null;
                        object.businessHomeHeaderForPortraitScreen = null;
                    }
                    if (message.businessId != null && message.hasOwnProperty("businessId"))
                        object.businessId = message.businessId;
                    if (message.businessName != null && message.hasOwnProperty("businessName"))
                        object.businessName = message.businessName;
                    if (message.isBusinessSuspended != null && message.hasOwnProperty("isBusinessSuspended"))
                        object.isBusinessSuspended = message.isBusinessSuspended;
                    if (message.businessLocationSettings != null && message.hasOwnProperty("businessLocationSettings"))
                        object.businessLocationSettings = $root.waiternow.common.LocationProto.SettingsProto.toObject(message.businessLocationSettings, options);
                    if (message.locationName != null && message.hasOwnProperty("locationName"))
                        object.locationName = message.locationName;
                    if (message.locationSettings != null && message.hasOwnProperty("locationSettings"))
                        object.locationSettings = $root.waiternow.common.LocationProto.SettingsProto.toObject(message.locationSettings, options);
                    if (message.businessLogo != null && message.hasOwnProperty("businessLogo"))
                        object.businessLogo = $root.waiternow.common.ImageProto.toObject(message.businessLogo, options);
                    if (message.locationAddress != null && message.hasOwnProperty("locationAddress"))
                        object.locationAddress = $root.waiternow.common.AddressProto.toObject(message.locationAddress, options);
                    if (message.businessMenuHeaderForLandscapeScreen != null && message.hasOwnProperty("businessMenuHeaderForLandscapeScreen"))
                        object.businessMenuHeaderForLandscapeScreen = $root.waiternow.common.ImageProto.toObject(message.businessMenuHeaderForLandscapeScreen, options);
                    if (message.businessMenuHeaderForPortraitScreen != null && message.hasOwnProperty("businessMenuHeaderForPortraitScreen"))
                        object.businessMenuHeaderForPortraitScreen = $root.waiternow.common.ImageProto.toObject(message.businessMenuHeaderForPortraitScreen, options);
                    if (message.locationPhoneNumber != null && message.hasOwnProperty("locationPhoneNumber"))
                        object.locationPhoneNumber = $root.waiternow.common.PhoneNumberProto.toObject(message.locationPhoneNumber, options);
                    if (message.legacyBusinessDescription != null && message.hasOwnProperty("legacyBusinessDescription"))
                        object.legacyBusinessDescription = message.legacyBusinessDescription;
                    if (message.businessDescription != null && message.hasOwnProperty("businessDescription"))
                        object.businessDescription = $root.waiternow.common.TextProto.toObject(message.businessDescription, options);
                    if (message.locationAnnouncement != null && message.hasOwnProperty("locationAnnouncement"))
                        object.locationAnnouncement = $root.waiternow.common.TextProto.toObject(message.locationAnnouncement, options);
                    if (message.businessHomeHeaderForLandscapeScreen != null && message.hasOwnProperty("businessHomeHeaderForLandscapeScreen"))
                        object.businessHomeHeaderForLandscapeScreen = $root.waiternow.common.ImageProto.toObject(message.businessHomeHeaderForLandscapeScreen, options);
                    if (message.businessHomeHeaderForPortraitScreen != null && message.hasOwnProperty("businessHomeHeaderForPortraitScreen"))
                        object.businessHomeHeaderForPortraitScreen = $root.waiternow.common.ImageProto.toObject(message.businessHomeHeaderForPortraitScreen, options);
                    return object;
                };

                /**
                 * Converts this RedundantDataProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.PointOfServiceProto.RedundantDataProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                RedundantDataProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for RedundantDataProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.PointOfServiceProto.RedundantDataProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                RedundantDataProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.PointOfServiceProto.RedundantDataProto";
                };

                return RedundantDataProto;
            })();

            return PointOfServiceProto;
        })();

        common.LocationPointsOfServiceProto = (function() {

            /**
             * Properties of a LocationPointsOfServiceProto.
             * @memberof waiternow.common
             * @interface ILocationPointsOfServiceProto
             * @property {string|null} [locationId] LocationPointsOfServiceProto locationId
             * @property {Array.<waiternow.common.IPointOfServiceProto>|null} [pointsOfService] LocationPointsOfServiceProto pointsOfService
             */

            /**
             * Constructs a new LocationPointsOfServiceProto.
             * @memberof waiternow.common
             * @classdesc Represents a LocationPointsOfServiceProto.
             * @implements ILocationPointsOfServiceProto
             * @constructor
             * @param {waiternow.common.ILocationPointsOfServiceProto=} [properties] Properties to set
             */
            function LocationPointsOfServiceProto(properties) {
                this.pointsOfService = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * LocationPointsOfServiceProto locationId.
             * @member {string} locationId
             * @memberof waiternow.common.LocationPointsOfServiceProto
             * @instance
             */
            LocationPointsOfServiceProto.prototype.locationId = "";

            /**
             * LocationPointsOfServiceProto pointsOfService.
             * @member {Array.<waiternow.common.IPointOfServiceProto>} pointsOfService
             * @memberof waiternow.common.LocationPointsOfServiceProto
             * @instance
             */
            LocationPointsOfServiceProto.prototype.pointsOfService = $util.emptyArray;

            /**
             * Creates a new LocationPointsOfServiceProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.LocationPointsOfServiceProto
             * @static
             * @param {waiternow.common.ILocationPointsOfServiceProto=} [properties] Properties to set
             * @returns {waiternow.common.LocationPointsOfServiceProto} LocationPointsOfServiceProto instance
             */
            LocationPointsOfServiceProto.create = function create(properties) {
                return new LocationPointsOfServiceProto(properties);
            };

            /**
             * Encodes the specified LocationPointsOfServiceProto message. Does not implicitly {@link waiternow.common.LocationPointsOfServiceProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.LocationPointsOfServiceProto
             * @static
             * @param {waiternow.common.ILocationPointsOfServiceProto} message LocationPointsOfServiceProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            LocationPointsOfServiceProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                if (message.pointsOfService != null && message.pointsOfService.length)
                    for (var i = 0; i < message.pointsOfService.length; ++i)
                        $root.waiternow.common.PointOfServiceProto.encode(message.pointsOfService[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified LocationPointsOfServiceProto message, length delimited. Does not implicitly {@link waiternow.common.LocationPointsOfServiceProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.LocationPointsOfServiceProto
             * @static
             * @param {waiternow.common.ILocationPointsOfServiceProto} message LocationPointsOfServiceProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            LocationPointsOfServiceProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a LocationPointsOfServiceProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.LocationPointsOfServiceProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.LocationPointsOfServiceProto} LocationPointsOfServiceProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            LocationPointsOfServiceProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.LocationPointsOfServiceProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.locationId = reader.string();
                            break;
                        }
                    case 2: {
                            if (!(message.pointsOfService && message.pointsOfService.length))
                                message.pointsOfService = [];
                            message.pointsOfService.push($root.waiternow.common.PointOfServiceProto.decode(reader, reader.uint32()));
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a LocationPointsOfServiceProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.LocationPointsOfServiceProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.LocationPointsOfServiceProto} LocationPointsOfServiceProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            LocationPointsOfServiceProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a LocationPointsOfServiceProto message.
             * @function verify
             * @memberof waiternow.common.LocationPointsOfServiceProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            LocationPointsOfServiceProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.locationId != null && message.hasOwnProperty("locationId"))
                    if (!$util.isString(message.locationId))
                        return "locationId: string expected";
                if (message.pointsOfService != null && message.hasOwnProperty("pointsOfService")) {
                    if (!Array.isArray(message.pointsOfService))
                        return "pointsOfService: array expected";
                    for (var i = 0; i < message.pointsOfService.length; ++i) {
                        var error = $root.waiternow.common.PointOfServiceProto.verify(message.pointsOfService[i]);
                        if (error)
                            return "pointsOfService." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a LocationPointsOfServiceProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.LocationPointsOfServiceProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.LocationPointsOfServiceProto} LocationPointsOfServiceProto
             */
            LocationPointsOfServiceProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.LocationPointsOfServiceProto)
                    return object;
                var message = new $root.waiternow.common.LocationPointsOfServiceProto();
                if (object.locationId != null)
                    message.locationId = String(object.locationId);
                if (object.pointsOfService) {
                    if (!Array.isArray(object.pointsOfService))
                        throw TypeError(".waiternow.common.LocationPointsOfServiceProto.pointsOfService: array expected");
                    message.pointsOfService = [];
                    for (var i = 0; i < object.pointsOfService.length; ++i) {
                        if (typeof object.pointsOfService[i] !== "object")
                            throw TypeError(".waiternow.common.LocationPointsOfServiceProto.pointsOfService: object expected");
                        message.pointsOfService[i] = $root.waiternow.common.PointOfServiceProto.fromObject(object.pointsOfService[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a LocationPointsOfServiceProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.LocationPointsOfServiceProto
             * @static
             * @param {waiternow.common.LocationPointsOfServiceProto} message LocationPointsOfServiceProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            LocationPointsOfServiceProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.pointsOfService = [];
                if (options.defaults)
                    object.locationId = "";
                if (message.locationId != null && message.hasOwnProperty("locationId"))
                    object.locationId = message.locationId;
                if (message.pointsOfService && message.pointsOfService.length) {
                    object.pointsOfService = [];
                    for (var j = 0; j < message.pointsOfService.length; ++j)
                        object.pointsOfService[j] = $root.waiternow.common.PointOfServiceProto.toObject(message.pointsOfService[j], options);
                }
                return object;
            };

            /**
             * Converts this LocationPointsOfServiceProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.LocationPointsOfServiceProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            LocationPointsOfServiceProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for LocationPointsOfServiceProto
             * @function getTypeUrl
             * @memberof waiternow.common.LocationPointsOfServiceProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            LocationPointsOfServiceProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.LocationPointsOfServiceProto";
            };

            return LocationPointsOfServiceProto;
        })();

        common.ReviewProto = (function() {

            /**
             * Properties of a ReviewProto.
             * @memberof waiternow.common
             * @interface IReviewProto
             * @property {string|null} [id] ReviewProto id
             * @property {google.protobuf.ITimestamp|null} [creationTime] ReviewProto creationTime
             * @property {google.protobuf.ITimestamp|null} [lastUpdateTime] ReviewProto lastUpdateTime
             * @property {string|null} [locationId] ReviewProto locationId
             * @property {string|null} [pointOfServiceId] ReviewProto pointOfServiceId
             * @property {string|null} [consumerId] ReviewProto consumerId
             * @property {string|null} [deviceId] ReviewProto deviceId
             * @property {string|null} [summary] ReviewProto summary
             * @property {string|null} [comments] ReviewProto comments
             * @property {waiternow.common.Rating|null} [rating] ReviewProto rating
             * @property {waiternow.common.ThumbSignal|null} [thumbSignal] ReviewProto thumbSignal
             * @property {waiternow.common.ReviewProto.IRedundantDataProto|null} [redundantData] ReviewProto redundantData
             */

            /**
             * Constructs a new ReviewProto.
             * @memberof waiternow.common
             * @classdesc Represents a ReviewProto.
             * @implements IReviewProto
             * @constructor
             * @param {waiternow.common.IReviewProto=} [properties] Properties to set
             */
            function ReviewProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ReviewProto id.
             * @member {string} id
             * @memberof waiternow.common.ReviewProto
             * @instance
             */
            ReviewProto.prototype.id = "";

            /**
             * ReviewProto creationTime.
             * @member {google.protobuf.ITimestamp|null|undefined} creationTime
             * @memberof waiternow.common.ReviewProto
             * @instance
             */
            ReviewProto.prototype.creationTime = null;

            /**
             * ReviewProto lastUpdateTime.
             * @member {google.protobuf.ITimestamp|null|undefined} lastUpdateTime
             * @memberof waiternow.common.ReviewProto
             * @instance
             */
            ReviewProto.prototype.lastUpdateTime = null;

            /**
             * ReviewProto locationId.
             * @member {string} locationId
             * @memberof waiternow.common.ReviewProto
             * @instance
             */
            ReviewProto.prototype.locationId = "";

            /**
             * ReviewProto pointOfServiceId.
             * @member {string} pointOfServiceId
             * @memberof waiternow.common.ReviewProto
             * @instance
             */
            ReviewProto.prototype.pointOfServiceId = "";

            /**
             * ReviewProto consumerId.
             * @member {string} consumerId
             * @memberof waiternow.common.ReviewProto
             * @instance
             */
            ReviewProto.prototype.consumerId = "";

            /**
             * ReviewProto deviceId.
             * @member {string} deviceId
             * @memberof waiternow.common.ReviewProto
             * @instance
             */
            ReviewProto.prototype.deviceId = "";

            /**
             * ReviewProto summary.
             * @member {string} summary
             * @memberof waiternow.common.ReviewProto
             * @instance
             */
            ReviewProto.prototype.summary = "";

            /**
             * ReviewProto comments.
             * @member {string} comments
             * @memberof waiternow.common.ReviewProto
             * @instance
             */
            ReviewProto.prototype.comments = "";

            /**
             * ReviewProto rating.
             * @member {waiternow.common.Rating|null|undefined} rating
             * @memberof waiternow.common.ReviewProto
             * @instance
             */
            ReviewProto.prototype.rating = null;

            /**
             * ReviewProto thumbSignal.
             * @member {waiternow.common.ThumbSignal|null|undefined} thumbSignal
             * @memberof waiternow.common.ReviewProto
             * @instance
             */
            ReviewProto.prototype.thumbSignal = null;

            /**
             * ReviewProto redundantData.
             * @member {waiternow.common.ReviewProto.IRedundantDataProto|null|undefined} redundantData
             * @memberof waiternow.common.ReviewProto
             * @instance
             */
            ReviewProto.prototype.redundantData = null;

            // OneOf field names bound to virtual getters and setters
            var $oneOfFields;

            /**
             * ReviewProto ratingType.
             * @member {"rating"|"thumbSignal"|undefined} ratingType
             * @memberof waiternow.common.ReviewProto
             * @instance
             */
            Object.defineProperty(ReviewProto.prototype, "ratingType", {
                get: $util.oneOfGetter($oneOfFields = ["rating", "thumbSignal"]),
                set: $util.oneOfSetter($oneOfFields)
            });

            /**
             * Creates a new ReviewProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.ReviewProto
             * @static
             * @param {waiternow.common.IReviewProto=} [properties] Properties to set
             * @returns {waiternow.common.ReviewProto} ReviewProto instance
             */
            ReviewProto.create = function create(properties) {
                return new ReviewProto(properties);
            };

            /**
             * Encodes the specified ReviewProto message. Does not implicitly {@link waiternow.common.ReviewProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.ReviewProto
             * @static
             * @param {waiternow.common.IReviewProto} message ReviewProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReviewProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.locationId);
                if (message.pointOfServiceId != null && Object.hasOwnProperty.call(message, "pointOfServiceId"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.pointOfServiceId);
                if (message.consumerId != null && Object.hasOwnProperty.call(message, "consumerId"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.consumerId);
                if (message.summary != null && Object.hasOwnProperty.call(message, "summary"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.summary);
                if (message.comments != null && Object.hasOwnProperty.call(message, "comments"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.comments);
                if (message.creationTime != null && Object.hasOwnProperty.call(message, "creationTime"))
                    $root.google.protobuf.Timestamp.encode(message.creationTime, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                if (message.rating != null && Object.hasOwnProperty.call(message, "rating"))
                    writer.uint32(/* id 8, wireType 0 =*/64).int32(message.rating);
                if (message.thumbSignal != null && Object.hasOwnProperty.call(message, "thumbSignal"))
                    writer.uint32(/* id 9, wireType 0 =*/72).int32(message.thumbSignal);
                if (message.redundantData != null && Object.hasOwnProperty.call(message, "redundantData"))
                    $root.waiternow.common.ReviewProto.RedundantDataProto.encode(message.redundantData, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                    $root.google.protobuf.Timestamp.encode(message.lastUpdateTime, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                if (message.deviceId != null && Object.hasOwnProperty.call(message, "deviceId"))
                    writer.uint32(/* id 12, wireType 2 =*/98).string(message.deviceId);
                return writer;
            };

            /**
             * Encodes the specified ReviewProto message, length delimited. Does not implicitly {@link waiternow.common.ReviewProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.ReviewProto
             * @static
             * @param {waiternow.common.IReviewProto} message ReviewProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReviewProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ReviewProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.ReviewProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.ReviewProto} ReviewProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReviewProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.ReviewProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.id = reader.string();
                            break;
                        }
                    case 7: {
                            message.creationTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 11: {
                            message.lastUpdateTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 2: {
                            message.locationId = reader.string();
                            break;
                        }
                    case 3: {
                            message.pointOfServiceId = reader.string();
                            break;
                        }
                    case 4: {
                            message.consumerId = reader.string();
                            break;
                        }
                    case 12: {
                            message.deviceId = reader.string();
                            break;
                        }
                    case 5: {
                            message.summary = reader.string();
                            break;
                        }
                    case 6: {
                            message.comments = reader.string();
                            break;
                        }
                    case 8: {
                            message.rating = reader.int32();
                            break;
                        }
                    case 9: {
                            message.thumbSignal = reader.int32();
                            break;
                        }
                    case 10: {
                            message.redundantData = $root.waiternow.common.ReviewProto.RedundantDataProto.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ReviewProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.ReviewProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.ReviewProto} ReviewProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReviewProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ReviewProto message.
             * @function verify
             * @memberof waiternow.common.ReviewProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ReviewProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                var properties = {};
                if (message.id != null && message.hasOwnProperty("id"))
                    if (!$util.isString(message.id))
                        return "id: string expected";
                if (message.creationTime != null && message.hasOwnProperty("creationTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.creationTime);
                    if (error)
                        return "creationTime." + error;
                }
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.lastUpdateTime);
                    if (error)
                        return "lastUpdateTime." + error;
                }
                if (message.locationId != null && message.hasOwnProperty("locationId"))
                    if (!$util.isString(message.locationId))
                        return "locationId: string expected";
                if (message.pointOfServiceId != null && message.hasOwnProperty("pointOfServiceId"))
                    if (!$util.isString(message.pointOfServiceId))
                        return "pointOfServiceId: string expected";
                if (message.consumerId != null && message.hasOwnProperty("consumerId"))
                    if (!$util.isString(message.consumerId))
                        return "consumerId: string expected";
                if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                    if (!$util.isString(message.deviceId))
                        return "deviceId: string expected";
                if (message.summary != null && message.hasOwnProperty("summary"))
                    if (!$util.isString(message.summary))
                        return "summary: string expected";
                if (message.comments != null && message.hasOwnProperty("comments"))
                    if (!$util.isString(message.comments))
                        return "comments: string expected";
                if (message.rating != null && message.hasOwnProperty("rating")) {
                    properties.ratingType = 1;
                    switch (message.rating) {
                    default:
                        return "rating: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                        break;
                    }
                }
                if (message.thumbSignal != null && message.hasOwnProperty("thumbSignal")) {
                    if (properties.ratingType === 1)
                        return "ratingType: multiple values";
                    properties.ratingType = 1;
                    switch (message.thumbSignal) {
                    default:
                        return "thumbSignal: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                        break;
                    }
                }
                if (message.redundantData != null && message.hasOwnProperty("redundantData")) {
                    var error = $root.waiternow.common.ReviewProto.RedundantDataProto.verify(message.redundantData);
                    if (error)
                        return "redundantData." + error;
                }
                return null;
            };

            /**
             * Creates a ReviewProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.ReviewProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.ReviewProto} ReviewProto
             */
            ReviewProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.ReviewProto)
                    return object;
                var message = new $root.waiternow.common.ReviewProto();
                if (object.id != null)
                    message.id = String(object.id);
                if (object.creationTime != null) {
                    if (typeof object.creationTime !== "object")
                        throw TypeError(".waiternow.common.ReviewProto.creationTime: object expected");
                    message.creationTime = $root.google.protobuf.Timestamp.fromObject(object.creationTime);
                }
                if (object.lastUpdateTime != null) {
                    if (typeof object.lastUpdateTime !== "object")
                        throw TypeError(".waiternow.common.ReviewProto.lastUpdateTime: object expected");
                    message.lastUpdateTime = $root.google.protobuf.Timestamp.fromObject(object.lastUpdateTime);
                }
                if (object.locationId != null)
                    message.locationId = String(object.locationId);
                if (object.pointOfServiceId != null)
                    message.pointOfServiceId = String(object.pointOfServiceId);
                if (object.consumerId != null)
                    message.consumerId = String(object.consumerId);
                if (object.deviceId != null)
                    message.deviceId = String(object.deviceId);
                if (object.summary != null)
                    message.summary = String(object.summary);
                if (object.comments != null)
                    message.comments = String(object.comments);
                switch (object.rating) {
                default:
                    if (typeof object.rating === "number") {
                        message.rating = object.rating;
                        break;
                    }
                    break;
                case "RATING_UNSPECIFIED":
                case 0:
                    message.rating = 0;
                    break;
                case "ONE_STAR":
                case 1:
                    message.rating = 1;
                    break;
                case "TWO_STARS":
                case 2:
                    message.rating = 2;
                    break;
                case "THREE_STARS":
                case 3:
                    message.rating = 3;
                    break;
                case "FOUR_STARS":
                case 4:
                    message.rating = 4;
                    break;
                case "FIVE_STARS":
                case 5:
                    message.rating = 5;
                    break;
                }
                switch (object.thumbSignal) {
                default:
                    if (typeof object.thumbSignal === "number") {
                        message.thumbSignal = object.thumbSignal;
                        break;
                    }
                    break;
                case "THUMB_SIGNAL_UNSPECIFIED":
                case 0:
                    message.thumbSignal = 0;
                    break;
                case "THUMB_UP":
                case 1:
                    message.thumbSignal = 1;
                    break;
                case "THUMB_DOWN":
                case 2:
                    message.thumbSignal = 2;
                    break;
                }
                if (object.redundantData != null) {
                    if (typeof object.redundantData !== "object")
                        throw TypeError(".waiternow.common.ReviewProto.redundantData: object expected");
                    message.redundantData = $root.waiternow.common.ReviewProto.RedundantDataProto.fromObject(object.redundantData);
                }
                return message;
            };

            /**
             * Creates a plain object from a ReviewProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.ReviewProto
             * @static
             * @param {waiternow.common.ReviewProto} message ReviewProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ReviewProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.id = "";
                    object.locationId = "";
                    object.pointOfServiceId = "";
                    object.consumerId = "";
                    object.summary = "";
                    object.comments = "";
                    object.creationTime = null;
                    object.redundantData = null;
                    object.lastUpdateTime = null;
                    object.deviceId = "";
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                if (message.locationId != null && message.hasOwnProperty("locationId"))
                    object.locationId = message.locationId;
                if (message.pointOfServiceId != null && message.hasOwnProperty("pointOfServiceId"))
                    object.pointOfServiceId = message.pointOfServiceId;
                if (message.consumerId != null && message.hasOwnProperty("consumerId"))
                    object.consumerId = message.consumerId;
                if (message.summary != null && message.hasOwnProperty("summary"))
                    object.summary = message.summary;
                if (message.comments != null && message.hasOwnProperty("comments"))
                    object.comments = message.comments;
                if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                    object.creationTime = $root.google.protobuf.Timestamp.toObject(message.creationTime, options);
                if (message.rating != null && message.hasOwnProperty("rating")) {
                    object.rating = options.enums === String ? $root.waiternow.common.Rating[message.rating] === undefined ? message.rating : $root.waiternow.common.Rating[message.rating] : message.rating;
                    if (options.oneofs)
                        object.ratingType = "rating";
                }
                if (message.thumbSignal != null && message.hasOwnProperty("thumbSignal")) {
                    object.thumbSignal = options.enums === String ? $root.waiternow.common.ThumbSignal[message.thumbSignal] === undefined ? message.thumbSignal : $root.waiternow.common.ThumbSignal[message.thumbSignal] : message.thumbSignal;
                    if (options.oneofs)
                        object.ratingType = "thumbSignal";
                }
                if (message.redundantData != null && message.hasOwnProperty("redundantData"))
                    object.redundantData = $root.waiternow.common.ReviewProto.RedundantDataProto.toObject(message.redundantData, options);
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                    object.lastUpdateTime = $root.google.protobuf.Timestamp.toObject(message.lastUpdateTime, options);
                if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                    object.deviceId = message.deviceId;
                return object;
            };

            /**
             * Converts this ReviewProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.ReviewProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ReviewProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for ReviewProto
             * @function getTypeUrl
             * @memberof waiternow.common.ReviewProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            ReviewProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.ReviewProto";
            };

            ReviewProto.RedundantDataProto = (function() {

                /**
                 * Properties of a RedundantDataProto.
                 * @memberof waiternow.common.ReviewProto
                 * @interface IRedundantDataProto
                 * @property {string|null} [pointOfServiceFriendlyName] RedundantDataProto pointOfServiceFriendlyName
                 * @property {string|null} [consumerName] RedundantDataProto consumerName
                 * @property {waiternow.common.Country|null} [locationCountry] RedundantDataProto locationCountry
                 */

                /**
                 * Constructs a new RedundantDataProto.
                 * @memberof waiternow.common.ReviewProto
                 * @classdesc Represents a RedundantDataProto.
                 * @implements IRedundantDataProto
                 * @constructor
                 * @param {waiternow.common.ReviewProto.IRedundantDataProto=} [properties] Properties to set
                 */
                function RedundantDataProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * RedundantDataProto pointOfServiceFriendlyName.
                 * @member {string} pointOfServiceFriendlyName
                 * @memberof waiternow.common.ReviewProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.pointOfServiceFriendlyName = "";

                /**
                 * RedundantDataProto consumerName.
                 * @member {string} consumerName
                 * @memberof waiternow.common.ReviewProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.consumerName = "";

                /**
                 * RedundantDataProto locationCountry.
                 * @member {waiternow.common.Country} locationCountry
                 * @memberof waiternow.common.ReviewProto.RedundantDataProto
                 * @instance
                 */
                RedundantDataProto.prototype.locationCountry = 0;

                /**
                 * Creates a new RedundantDataProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.ReviewProto.RedundantDataProto
                 * @static
                 * @param {waiternow.common.ReviewProto.IRedundantDataProto=} [properties] Properties to set
                 * @returns {waiternow.common.ReviewProto.RedundantDataProto} RedundantDataProto instance
                 */
                RedundantDataProto.create = function create(properties) {
                    return new RedundantDataProto(properties);
                };

                /**
                 * Encodes the specified RedundantDataProto message. Does not implicitly {@link waiternow.common.ReviewProto.RedundantDataProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.ReviewProto.RedundantDataProto
                 * @static
                 * @param {waiternow.common.ReviewProto.IRedundantDataProto} message RedundantDataProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RedundantDataProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.pointOfServiceFriendlyName != null && Object.hasOwnProperty.call(message, "pointOfServiceFriendlyName"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.pointOfServiceFriendlyName);
                    if (message.consumerName != null && Object.hasOwnProperty.call(message, "consumerName"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.consumerName);
                    if (message.locationCountry != null && Object.hasOwnProperty.call(message, "locationCountry"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.locationCountry);
                    return writer;
                };

                /**
                 * Encodes the specified RedundantDataProto message, length delimited. Does not implicitly {@link waiternow.common.ReviewProto.RedundantDataProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.ReviewProto.RedundantDataProto
                 * @static
                 * @param {waiternow.common.ReviewProto.IRedundantDataProto} message RedundantDataProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RedundantDataProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a RedundantDataProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.ReviewProto.RedundantDataProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.ReviewProto.RedundantDataProto} RedundantDataProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RedundantDataProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.ReviewProto.RedundantDataProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.pointOfServiceFriendlyName = reader.string();
                                break;
                            }
                        case 2: {
                                message.consumerName = reader.string();
                                break;
                            }
                        case 3: {
                                message.locationCountry = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a RedundantDataProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.ReviewProto.RedundantDataProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.ReviewProto.RedundantDataProto} RedundantDataProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RedundantDataProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a RedundantDataProto message.
                 * @function verify
                 * @memberof waiternow.common.ReviewProto.RedundantDataProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                RedundantDataProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.pointOfServiceFriendlyName != null && message.hasOwnProperty("pointOfServiceFriendlyName"))
                        if (!$util.isString(message.pointOfServiceFriendlyName))
                            return "pointOfServiceFriendlyName: string expected";
                    if (message.consumerName != null && message.hasOwnProperty("consumerName"))
                        if (!$util.isString(message.consumerName))
                            return "consumerName: string expected";
                    if (message.locationCountry != null && message.hasOwnProperty("locationCountry"))
                        switch (message.locationCountry) {
                        default:
                            return "locationCountry: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    return null;
                };

                /**
                 * Creates a RedundantDataProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.ReviewProto.RedundantDataProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.ReviewProto.RedundantDataProto} RedundantDataProto
                 */
                RedundantDataProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.ReviewProto.RedundantDataProto)
                        return object;
                    var message = new $root.waiternow.common.ReviewProto.RedundantDataProto();
                    if (object.pointOfServiceFriendlyName != null)
                        message.pointOfServiceFriendlyName = String(object.pointOfServiceFriendlyName);
                    if (object.consumerName != null)
                        message.consumerName = String(object.consumerName);
                    switch (object.locationCountry) {
                    default:
                        if (typeof object.locationCountry === "number") {
                            message.locationCountry = object.locationCountry;
                            break;
                        }
                        break;
                    case "COUNTRY_UNSPECIFIED":
                    case 0:
                        message.locationCountry = 0;
                        break;
                    case "UNITED_STATES":
                    case 1:
                        message.locationCountry = 1;
                        break;
                    case "MEXICO":
                    case 2:
                        message.locationCountry = 2;
                        break;
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a RedundantDataProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.ReviewProto.RedundantDataProto
                 * @static
                 * @param {waiternow.common.ReviewProto.RedundantDataProto} message RedundantDataProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                RedundantDataProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.pointOfServiceFriendlyName = "";
                        object.consumerName = "";
                        object.locationCountry = options.enums === String ? "COUNTRY_UNSPECIFIED" : 0;
                    }
                    if (message.pointOfServiceFriendlyName != null && message.hasOwnProperty("pointOfServiceFriendlyName"))
                        object.pointOfServiceFriendlyName = message.pointOfServiceFriendlyName;
                    if (message.consumerName != null && message.hasOwnProperty("consumerName"))
                        object.consumerName = message.consumerName;
                    if (message.locationCountry != null && message.hasOwnProperty("locationCountry"))
                        object.locationCountry = options.enums === String ? $root.waiternow.common.Country[message.locationCountry] === undefined ? message.locationCountry : $root.waiternow.common.Country[message.locationCountry] : message.locationCountry;
                    return object;
                };

                /**
                 * Converts this RedundantDataProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.ReviewProto.RedundantDataProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                RedundantDataProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for RedundantDataProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.ReviewProto.RedundantDataProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                RedundantDataProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.ReviewProto.RedundantDataProto";
                };

                return RedundantDataProto;
            })();

            return ReviewProto;
        })();

        common.ReviewsProto = (function() {

            /**
             * Properties of a ReviewsProto.
             * @memberof waiternow.common
             * @interface IReviewsProto
             * @property {Array.<waiternow.common.IReviewProto>|null} [reviews] ReviewsProto reviews
             * @property {string|null} [continuationToken] ReviewsProto continuationToken
             */

            /**
             * Constructs a new ReviewsProto.
             * @memberof waiternow.common
             * @classdesc Represents a ReviewsProto.
             * @implements IReviewsProto
             * @constructor
             * @param {waiternow.common.IReviewsProto=} [properties] Properties to set
             */
            function ReviewsProto(properties) {
                this.reviews = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ReviewsProto reviews.
             * @member {Array.<waiternow.common.IReviewProto>} reviews
             * @memberof waiternow.common.ReviewsProto
             * @instance
             */
            ReviewsProto.prototype.reviews = $util.emptyArray;

            /**
             * ReviewsProto continuationToken.
             * @member {string} continuationToken
             * @memberof waiternow.common.ReviewsProto
             * @instance
             */
            ReviewsProto.prototype.continuationToken = "";

            /**
             * Creates a new ReviewsProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.ReviewsProto
             * @static
             * @param {waiternow.common.IReviewsProto=} [properties] Properties to set
             * @returns {waiternow.common.ReviewsProto} ReviewsProto instance
             */
            ReviewsProto.create = function create(properties) {
                return new ReviewsProto(properties);
            };

            /**
             * Encodes the specified ReviewsProto message. Does not implicitly {@link waiternow.common.ReviewsProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.ReviewsProto
             * @static
             * @param {waiternow.common.IReviewsProto} message ReviewsProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReviewsProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.reviews != null && message.reviews.length)
                    for (var i = 0; i < message.reviews.length; ++i)
                        $root.waiternow.common.ReviewProto.encode(message.reviews[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.continuationToken);
                return writer;
            };

            /**
             * Encodes the specified ReviewsProto message, length delimited. Does not implicitly {@link waiternow.common.ReviewsProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.ReviewsProto
             * @static
             * @param {waiternow.common.IReviewsProto} message ReviewsProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReviewsProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ReviewsProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.ReviewsProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.ReviewsProto} ReviewsProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReviewsProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.ReviewsProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            if (!(message.reviews && message.reviews.length))
                                message.reviews = [];
                            message.reviews.push($root.waiternow.common.ReviewProto.decode(reader, reader.uint32()));
                            break;
                        }
                    case 2: {
                            message.continuationToken = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ReviewsProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.ReviewsProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.ReviewsProto} ReviewsProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReviewsProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ReviewsProto message.
             * @function verify
             * @memberof waiternow.common.ReviewsProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ReviewsProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.reviews != null && message.hasOwnProperty("reviews")) {
                    if (!Array.isArray(message.reviews))
                        return "reviews: array expected";
                    for (var i = 0; i < message.reviews.length; ++i) {
                        var error = $root.waiternow.common.ReviewProto.verify(message.reviews[i]);
                        if (error)
                            return "reviews." + error;
                    }
                }
                if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                    if (!$util.isString(message.continuationToken))
                        return "continuationToken: string expected";
                return null;
            };

            /**
             * Creates a ReviewsProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.ReviewsProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.ReviewsProto} ReviewsProto
             */
            ReviewsProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.ReviewsProto)
                    return object;
                var message = new $root.waiternow.common.ReviewsProto();
                if (object.reviews) {
                    if (!Array.isArray(object.reviews))
                        throw TypeError(".waiternow.common.ReviewsProto.reviews: array expected");
                    message.reviews = [];
                    for (var i = 0; i < object.reviews.length; ++i) {
                        if (typeof object.reviews[i] !== "object")
                            throw TypeError(".waiternow.common.ReviewsProto.reviews: object expected");
                        message.reviews[i] = $root.waiternow.common.ReviewProto.fromObject(object.reviews[i]);
                    }
                }
                if (object.continuationToken != null)
                    message.continuationToken = String(object.continuationToken);
                return message;
            };

            /**
             * Creates a plain object from a ReviewsProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.ReviewsProto
             * @static
             * @param {waiternow.common.ReviewsProto} message ReviewsProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ReviewsProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.reviews = [];
                if (options.defaults)
                    object.continuationToken = "";
                if (message.reviews && message.reviews.length) {
                    object.reviews = [];
                    for (var j = 0; j < message.reviews.length; ++j)
                        object.reviews[j] = $root.waiternow.common.ReviewProto.toObject(message.reviews[j], options);
                }
                if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                    object.continuationToken = message.continuationToken;
                return object;
            };

            /**
             * Converts this ReviewsProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.ReviewsProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ReviewsProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for ReviewsProto
             * @function getTypeUrl
             * @memberof waiternow.common.ReviewsProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            ReviewsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.ReviewsProto";
            };

            return ReviewsProto;
        })();

        common.LocationReviewsProto = (function() {

            /**
             * Properties of a LocationReviewsProto.
             * @memberof waiternow.common
             * @interface ILocationReviewsProto
             * @property {string|null} [locationId] LocationReviewsProto locationId
             * @property {Array.<waiternow.common.IReviewProto>|null} [reviews] LocationReviewsProto reviews
             * @property {string|null} [continuationToken] LocationReviewsProto continuationToken
             */

            /**
             * Constructs a new LocationReviewsProto.
             * @memberof waiternow.common
             * @classdesc Represents a LocationReviewsProto.
             * @implements ILocationReviewsProto
             * @constructor
             * @param {waiternow.common.ILocationReviewsProto=} [properties] Properties to set
             */
            function LocationReviewsProto(properties) {
                this.reviews = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * LocationReviewsProto locationId.
             * @member {string} locationId
             * @memberof waiternow.common.LocationReviewsProto
             * @instance
             */
            LocationReviewsProto.prototype.locationId = "";

            /**
             * LocationReviewsProto reviews.
             * @member {Array.<waiternow.common.IReviewProto>} reviews
             * @memberof waiternow.common.LocationReviewsProto
             * @instance
             */
            LocationReviewsProto.prototype.reviews = $util.emptyArray;

            /**
             * LocationReviewsProto continuationToken.
             * @member {string} continuationToken
             * @memberof waiternow.common.LocationReviewsProto
             * @instance
             */
            LocationReviewsProto.prototype.continuationToken = "";

            /**
             * Creates a new LocationReviewsProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.LocationReviewsProto
             * @static
             * @param {waiternow.common.ILocationReviewsProto=} [properties] Properties to set
             * @returns {waiternow.common.LocationReviewsProto} LocationReviewsProto instance
             */
            LocationReviewsProto.create = function create(properties) {
                return new LocationReviewsProto(properties);
            };

            /**
             * Encodes the specified LocationReviewsProto message. Does not implicitly {@link waiternow.common.LocationReviewsProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.LocationReviewsProto
             * @static
             * @param {waiternow.common.ILocationReviewsProto} message LocationReviewsProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            LocationReviewsProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                if (message.reviews != null && message.reviews.length)
                    for (var i = 0; i < message.reviews.length; ++i)
                        $root.waiternow.common.ReviewProto.encode(message.reviews[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.continuationToken);
                return writer;
            };

            /**
             * Encodes the specified LocationReviewsProto message, length delimited. Does not implicitly {@link waiternow.common.LocationReviewsProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.LocationReviewsProto
             * @static
             * @param {waiternow.common.ILocationReviewsProto} message LocationReviewsProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            LocationReviewsProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a LocationReviewsProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.LocationReviewsProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.LocationReviewsProto} LocationReviewsProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            LocationReviewsProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.LocationReviewsProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.locationId = reader.string();
                            break;
                        }
                    case 2: {
                            if (!(message.reviews && message.reviews.length))
                                message.reviews = [];
                            message.reviews.push($root.waiternow.common.ReviewProto.decode(reader, reader.uint32()));
                            break;
                        }
                    case 3: {
                            message.continuationToken = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a LocationReviewsProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.LocationReviewsProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.LocationReviewsProto} LocationReviewsProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            LocationReviewsProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a LocationReviewsProto message.
             * @function verify
             * @memberof waiternow.common.LocationReviewsProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            LocationReviewsProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.locationId != null && message.hasOwnProperty("locationId"))
                    if (!$util.isString(message.locationId))
                        return "locationId: string expected";
                if (message.reviews != null && message.hasOwnProperty("reviews")) {
                    if (!Array.isArray(message.reviews))
                        return "reviews: array expected";
                    for (var i = 0; i < message.reviews.length; ++i) {
                        var error = $root.waiternow.common.ReviewProto.verify(message.reviews[i]);
                        if (error)
                            return "reviews." + error;
                    }
                }
                if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                    if (!$util.isString(message.continuationToken))
                        return "continuationToken: string expected";
                return null;
            };

            /**
             * Creates a LocationReviewsProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.LocationReviewsProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.LocationReviewsProto} LocationReviewsProto
             */
            LocationReviewsProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.LocationReviewsProto)
                    return object;
                var message = new $root.waiternow.common.LocationReviewsProto();
                if (object.locationId != null)
                    message.locationId = String(object.locationId);
                if (object.reviews) {
                    if (!Array.isArray(object.reviews))
                        throw TypeError(".waiternow.common.LocationReviewsProto.reviews: array expected");
                    message.reviews = [];
                    for (var i = 0; i < object.reviews.length; ++i) {
                        if (typeof object.reviews[i] !== "object")
                            throw TypeError(".waiternow.common.LocationReviewsProto.reviews: object expected");
                        message.reviews[i] = $root.waiternow.common.ReviewProto.fromObject(object.reviews[i]);
                    }
                }
                if (object.continuationToken != null)
                    message.continuationToken = String(object.continuationToken);
                return message;
            };

            /**
             * Creates a plain object from a LocationReviewsProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.LocationReviewsProto
             * @static
             * @param {waiternow.common.LocationReviewsProto} message LocationReviewsProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            LocationReviewsProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.reviews = [];
                if (options.defaults) {
                    object.locationId = "";
                    object.continuationToken = "";
                }
                if (message.locationId != null && message.hasOwnProperty("locationId"))
                    object.locationId = message.locationId;
                if (message.reviews && message.reviews.length) {
                    object.reviews = [];
                    for (var j = 0; j < message.reviews.length; ++j)
                        object.reviews[j] = $root.waiternow.common.ReviewProto.toObject(message.reviews[j], options);
                }
                if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                    object.continuationToken = message.continuationToken;
                return object;
            };

            /**
             * Converts this LocationReviewsProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.LocationReviewsProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            LocationReviewsProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for LocationReviewsProto
             * @function getTypeUrl
             * @memberof waiternow.common.LocationReviewsProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            LocationReviewsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.LocationReviewsProto";
            };

            return LocationReviewsProto;
        })();

        common.ClientNotificationProto = (function() {

            /**
             * Properties of a ClientNotificationProto.
             * @memberof waiternow.common
             * @interface IClientNotificationProto
             * @property {waiternow.common.ClientNotificationProto.INotificationAlertProto|null} [notificationAlert] ClientNotificationProto notificationAlert
             * @property {waiternow.common.ClientNotificationProto.INewOrderProto|null} [newOrder] ClientNotificationProto newOrder
             * @property {waiternow.common.ClientNotificationProto.IOrderStatusUpdatedProto|null} [orderStatusUpdated] ClientNotificationProto orderStatusUpdated
             * @property {waiternow.common.ClientNotificationProto.ILocationOnlineStatusUpdatedProto|null} [locationOnlineStatusUpdated] ClientNotificationProto locationOnlineStatusUpdated
             * @property {waiternow.common.ClientNotificationProto.IMenuUpdatedProto|null} [menuUpdated] ClientNotificationProto menuUpdated
             * @property {waiternow.common.ClientNotificationProto.ITerminateDeviceSessionRequestProto|null} [terminateDeviceSessionRequest] ClientNotificationProto terminateDeviceSessionRequest
             * @property {waiternow.common.ClientNotificationProto.IStartRemoteLogsSessionProto|null} [startRemoteLogsSession] ClientNotificationProto startRemoteLogsSession
             */

            /**
             * Constructs a new ClientNotificationProto.
             * @memberof waiternow.common
             * @classdesc Represents a ClientNotificationProto.
             * @implements IClientNotificationProto
             * @constructor
             * @param {waiternow.common.IClientNotificationProto=} [properties] Properties to set
             */
            function ClientNotificationProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ClientNotificationProto notificationAlert.
             * @member {waiternow.common.ClientNotificationProto.INotificationAlertProto|null|undefined} notificationAlert
             * @memberof waiternow.common.ClientNotificationProto
             * @instance
             */
            ClientNotificationProto.prototype.notificationAlert = null;

            /**
             * ClientNotificationProto newOrder.
             * @member {waiternow.common.ClientNotificationProto.INewOrderProto|null|undefined} newOrder
             * @memberof waiternow.common.ClientNotificationProto
             * @instance
             */
            ClientNotificationProto.prototype.newOrder = null;

            /**
             * ClientNotificationProto orderStatusUpdated.
             * @member {waiternow.common.ClientNotificationProto.IOrderStatusUpdatedProto|null|undefined} orderStatusUpdated
             * @memberof waiternow.common.ClientNotificationProto
             * @instance
             */
            ClientNotificationProto.prototype.orderStatusUpdated = null;

            /**
             * ClientNotificationProto locationOnlineStatusUpdated.
             * @member {waiternow.common.ClientNotificationProto.ILocationOnlineStatusUpdatedProto|null|undefined} locationOnlineStatusUpdated
             * @memberof waiternow.common.ClientNotificationProto
             * @instance
             */
            ClientNotificationProto.prototype.locationOnlineStatusUpdated = null;

            /**
             * ClientNotificationProto menuUpdated.
             * @member {waiternow.common.ClientNotificationProto.IMenuUpdatedProto|null|undefined} menuUpdated
             * @memberof waiternow.common.ClientNotificationProto
             * @instance
             */
            ClientNotificationProto.prototype.menuUpdated = null;

            /**
             * ClientNotificationProto terminateDeviceSessionRequest.
             * @member {waiternow.common.ClientNotificationProto.ITerminateDeviceSessionRequestProto|null|undefined} terminateDeviceSessionRequest
             * @memberof waiternow.common.ClientNotificationProto
             * @instance
             */
            ClientNotificationProto.prototype.terminateDeviceSessionRequest = null;

            /**
             * ClientNotificationProto startRemoteLogsSession.
             * @member {waiternow.common.ClientNotificationProto.IStartRemoteLogsSessionProto|null|undefined} startRemoteLogsSession
             * @memberof waiternow.common.ClientNotificationProto
             * @instance
             */
            ClientNotificationProto.prototype.startRemoteLogsSession = null;

            // OneOf field names bound to virtual getters and setters
            var $oneOfFields;

            /**
             * ClientNotificationProto notificationType.
             * @member {"newOrder"|"orderStatusUpdated"|"locationOnlineStatusUpdated"|"menuUpdated"|"terminateDeviceSessionRequest"|"startRemoteLogsSession"|undefined} notificationType
             * @memberof waiternow.common.ClientNotificationProto
             * @instance
             */
            Object.defineProperty(ClientNotificationProto.prototype, "notificationType", {
                get: $util.oneOfGetter($oneOfFields = ["newOrder", "orderStatusUpdated", "locationOnlineStatusUpdated", "menuUpdated", "terminateDeviceSessionRequest", "startRemoteLogsSession"]),
                set: $util.oneOfSetter($oneOfFields)
            });

            /**
             * Creates a new ClientNotificationProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.ClientNotificationProto
             * @static
             * @param {waiternow.common.IClientNotificationProto=} [properties] Properties to set
             * @returns {waiternow.common.ClientNotificationProto} ClientNotificationProto instance
             */
            ClientNotificationProto.create = function create(properties) {
                return new ClientNotificationProto(properties);
            };

            /**
             * Encodes the specified ClientNotificationProto message. Does not implicitly {@link waiternow.common.ClientNotificationProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.ClientNotificationProto
             * @static
             * @param {waiternow.common.IClientNotificationProto} message ClientNotificationProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ClientNotificationProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.notificationAlert != null && Object.hasOwnProperty.call(message, "notificationAlert"))
                    $root.waiternow.common.ClientNotificationProto.NotificationAlertProto.encode(message.notificationAlert, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.newOrder != null && Object.hasOwnProperty.call(message, "newOrder"))
                    $root.waiternow.common.ClientNotificationProto.NewOrderProto.encode(message.newOrder, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.orderStatusUpdated != null && Object.hasOwnProperty.call(message, "orderStatusUpdated"))
                    $root.waiternow.common.ClientNotificationProto.OrderStatusUpdatedProto.encode(message.orderStatusUpdated, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.locationOnlineStatusUpdated != null && Object.hasOwnProperty.call(message, "locationOnlineStatusUpdated"))
                    $root.waiternow.common.ClientNotificationProto.LocationOnlineStatusUpdatedProto.encode(message.locationOnlineStatusUpdated, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                if (message.menuUpdated != null && Object.hasOwnProperty.call(message, "menuUpdated"))
                    $root.waiternow.common.ClientNotificationProto.MenuUpdatedProto.encode(message.menuUpdated, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                if (message.terminateDeviceSessionRequest != null && Object.hasOwnProperty.call(message, "terminateDeviceSessionRequest"))
                    $root.waiternow.common.ClientNotificationProto.TerminateDeviceSessionRequestProto.encode(message.terminateDeviceSessionRequest, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                if (message.startRemoteLogsSession != null && Object.hasOwnProperty.call(message, "startRemoteLogsSession"))
                    $root.waiternow.common.ClientNotificationProto.StartRemoteLogsSessionProto.encode(message.startRemoteLogsSession, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified ClientNotificationProto message, length delimited. Does not implicitly {@link waiternow.common.ClientNotificationProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.ClientNotificationProto
             * @static
             * @param {waiternow.common.IClientNotificationProto} message ClientNotificationProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ClientNotificationProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ClientNotificationProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.ClientNotificationProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.ClientNotificationProto} ClientNotificationProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ClientNotificationProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.ClientNotificationProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.notificationAlert = $root.waiternow.common.ClientNotificationProto.NotificationAlertProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 2: {
                            message.newOrder = $root.waiternow.common.ClientNotificationProto.NewOrderProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 3: {
                            message.orderStatusUpdated = $root.waiternow.common.ClientNotificationProto.OrderStatusUpdatedProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 4: {
                            message.locationOnlineStatusUpdated = $root.waiternow.common.ClientNotificationProto.LocationOnlineStatusUpdatedProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 5: {
                            message.menuUpdated = $root.waiternow.common.ClientNotificationProto.MenuUpdatedProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 6: {
                            message.terminateDeviceSessionRequest = $root.waiternow.common.ClientNotificationProto.TerminateDeviceSessionRequestProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 7: {
                            message.startRemoteLogsSession = $root.waiternow.common.ClientNotificationProto.StartRemoteLogsSessionProto.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ClientNotificationProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.ClientNotificationProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.ClientNotificationProto} ClientNotificationProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ClientNotificationProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ClientNotificationProto message.
             * @function verify
             * @memberof waiternow.common.ClientNotificationProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ClientNotificationProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                var properties = {};
                if (message.notificationAlert != null && message.hasOwnProperty("notificationAlert")) {
                    var error = $root.waiternow.common.ClientNotificationProto.NotificationAlertProto.verify(message.notificationAlert);
                    if (error)
                        return "notificationAlert." + error;
                }
                if (message.newOrder != null && message.hasOwnProperty("newOrder")) {
                    properties.notificationType = 1;
                    {
                        var error = $root.waiternow.common.ClientNotificationProto.NewOrderProto.verify(message.newOrder);
                        if (error)
                            return "newOrder." + error;
                    }
                }
                if (message.orderStatusUpdated != null && message.hasOwnProperty("orderStatusUpdated")) {
                    if (properties.notificationType === 1)
                        return "notificationType: multiple values";
                    properties.notificationType = 1;
                    {
                        var error = $root.waiternow.common.ClientNotificationProto.OrderStatusUpdatedProto.verify(message.orderStatusUpdated);
                        if (error)
                            return "orderStatusUpdated." + error;
                    }
                }
                if (message.locationOnlineStatusUpdated != null && message.hasOwnProperty("locationOnlineStatusUpdated")) {
                    if (properties.notificationType === 1)
                        return "notificationType: multiple values";
                    properties.notificationType = 1;
                    {
                        var error = $root.waiternow.common.ClientNotificationProto.LocationOnlineStatusUpdatedProto.verify(message.locationOnlineStatusUpdated);
                        if (error)
                            return "locationOnlineStatusUpdated." + error;
                    }
                }
                if (message.menuUpdated != null && message.hasOwnProperty("menuUpdated")) {
                    if (properties.notificationType === 1)
                        return "notificationType: multiple values";
                    properties.notificationType = 1;
                    {
                        var error = $root.waiternow.common.ClientNotificationProto.MenuUpdatedProto.verify(message.menuUpdated);
                        if (error)
                            return "menuUpdated." + error;
                    }
                }
                if (message.terminateDeviceSessionRequest != null && message.hasOwnProperty("terminateDeviceSessionRequest")) {
                    if (properties.notificationType === 1)
                        return "notificationType: multiple values";
                    properties.notificationType = 1;
                    {
                        var error = $root.waiternow.common.ClientNotificationProto.TerminateDeviceSessionRequestProto.verify(message.terminateDeviceSessionRequest);
                        if (error)
                            return "terminateDeviceSessionRequest." + error;
                    }
                }
                if (message.startRemoteLogsSession != null && message.hasOwnProperty("startRemoteLogsSession")) {
                    if (properties.notificationType === 1)
                        return "notificationType: multiple values";
                    properties.notificationType = 1;
                    {
                        var error = $root.waiternow.common.ClientNotificationProto.StartRemoteLogsSessionProto.verify(message.startRemoteLogsSession);
                        if (error)
                            return "startRemoteLogsSession." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a ClientNotificationProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.ClientNotificationProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.ClientNotificationProto} ClientNotificationProto
             */
            ClientNotificationProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.ClientNotificationProto)
                    return object;
                var message = new $root.waiternow.common.ClientNotificationProto();
                if (object.notificationAlert != null) {
                    if (typeof object.notificationAlert !== "object")
                        throw TypeError(".waiternow.common.ClientNotificationProto.notificationAlert: object expected");
                    message.notificationAlert = $root.waiternow.common.ClientNotificationProto.NotificationAlertProto.fromObject(object.notificationAlert);
                }
                if (object.newOrder != null) {
                    if (typeof object.newOrder !== "object")
                        throw TypeError(".waiternow.common.ClientNotificationProto.newOrder: object expected");
                    message.newOrder = $root.waiternow.common.ClientNotificationProto.NewOrderProto.fromObject(object.newOrder);
                }
                if (object.orderStatusUpdated != null) {
                    if (typeof object.orderStatusUpdated !== "object")
                        throw TypeError(".waiternow.common.ClientNotificationProto.orderStatusUpdated: object expected");
                    message.orderStatusUpdated = $root.waiternow.common.ClientNotificationProto.OrderStatusUpdatedProto.fromObject(object.orderStatusUpdated);
                }
                if (object.locationOnlineStatusUpdated != null) {
                    if (typeof object.locationOnlineStatusUpdated !== "object")
                        throw TypeError(".waiternow.common.ClientNotificationProto.locationOnlineStatusUpdated: object expected");
                    message.locationOnlineStatusUpdated = $root.waiternow.common.ClientNotificationProto.LocationOnlineStatusUpdatedProto.fromObject(object.locationOnlineStatusUpdated);
                }
                if (object.menuUpdated != null) {
                    if (typeof object.menuUpdated !== "object")
                        throw TypeError(".waiternow.common.ClientNotificationProto.menuUpdated: object expected");
                    message.menuUpdated = $root.waiternow.common.ClientNotificationProto.MenuUpdatedProto.fromObject(object.menuUpdated);
                }
                if (object.terminateDeviceSessionRequest != null) {
                    if (typeof object.terminateDeviceSessionRequest !== "object")
                        throw TypeError(".waiternow.common.ClientNotificationProto.terminateDeviceSessionRequest: object expected");
                    message.terminateDeviceSessionRequest = $root.waiternow.common.ClientNotificationProto.TerminateDeviceSessionRequestProto.fromObject(object.terminateDeviceSessionRequest);
                }
                if (object.startRemoteLogsSession != null) {
                    if (typeof object.startRemoteLogsSession !== "object")
                        throw TypeError(".waiternow.common.ClientNotificationProto.startRemoteLogsSession: object expected");
                    message.startRemoteLogsSession = $root.waiternow.common.ClientNotificationProto.StartRemoteLogsSessionProto.fromObject(object.startRemoteLogsSession);
                }
                return message;
            };

            /**
             * Creates a plain object from a ClientNotificationProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.ClientNotificationProto
             * @static
             * @param {waiternow.common.ClientNotificationProto} message ClientNotificationProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ClientNotificationProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.notificationAlert = null;
                if (message.notificationAlert != null && message.hasOwnProperty("notificationAlert"))
                    object.notificationAlert = $root.waiternow.common.ClientNotificationProto.NotificationAlertProto.toObject(message.notificationAlert, options);
                if (message.newOrder != null && message.hasOwnProperty("newOrder")) {
                    object.newOrder = $root.waiternow.common.ClientNotificationProto.NewOrderProto.toObject(message.newOrder, options);
                    if (options.oneofs)
                        object.notificationType = "newOrder";
                }
                if (message.orderStatusUpdated != null && message.hasOwnProperty("orderStatusUpdated")) {
                    object.orderStatusUpdated = $root.waiternow.common.ClientNotificationProto.OrderStatusUpdatedProto.toObject(message.orderStatusUpdated, options);
                    if (options.oneofs)
                        object.notificationType = "orderStatusUpdated";
                }
                if (message.locationOnlineStatusUpdated != null && message.hasOwnProperty("locationOnlineStatusUpdated")) {
                    object.locationOnlineStatusUpdated = $root.waiternow.common.ClientNotificationProto.LocationOnlineStatusUpdatedProto.toObject(message.locationOnlineStatusUpdated, options);
                    if (options.oneofs)
                        object.notificationType = "locationOnlineStatusUpdated";
                }
                if (message.menuUpdated != null && message.hasOwnProperty("menuUpdated")) {
                    object.menuUpdated = $root.waiternow.common.ClientNotificationProto.MenuUpdatedProto.toObject(message.menuUpdated, options);
                    if (options.oneofs)
                        object.notificationType = "menuUpdated";
                }
                if (message.terminateDeviceSessionRequest != null && message.hasOwnProperty("terminateDeviceSessionRequest")) {
                    object.terminateDeviceSessionRequest = $root.waiternow.common.ClientNotificationProto.TerminateDeviceSessionRequestProto.toObject(message.terminateDeviceSessionRequest, options);
                    if (options.oneofs)
                        object.notificationType = "terminateDeviceSessionRequest";
                }
                if (message.startRemoteLogsSession != null && message.hasOwnProperty("startRemoteLogsSession")) {
                    object.startRemoteLogsSession = $root.waiternow.common.ClientNotificationProto.StartRemoteLogsSessionProto.toObject(message.startRemoteLogsSession, options);
                    if (options.oneofs)
                        object.notificationType = "startRemoteLogsSession";
                }
                return object;
            };

            /**
             * Converts this ClientNotificationProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.ClientNotificationProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ClientNotificationProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for ClientNotificationProto
             * @function getTypeUrl
             * @memberof waiternow.common.ClientNotificationProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            ClientNotificationProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.ClientNotificationProto";
            };

            ClientNotificationProto.NotificationAlertProto = (function() {

                /**
                 * Properties of a NotificationAlertProto.
                 * @memberof waiternow.common.ClientNotificationProto
                 * @interface INotificationAlertProto
                 * @property {string|null} [title] NotificationAlertProto title
                 * @property {string|null} [body] NotificationAlertProto body
                 * @property {string|null} [imageUrl] NotificationAlertProto imageUrl
                 * @property {string|null} [redirectLink] NotificationAlertProto redirectLink
                 */

                /**
                 * Constructs a new NotificationAlertProto.
                 * @memberof waiternow.common.ClientNotificationProto
                 * @classdesc Represents a NotificationAlertProto.
                 * @implements INotificationAlertProto
                 * @constructor
                 * @param {waiternow.common.ClientNotificationProto.INotificationAlertProto=} [properties] Properties to set
                 */
                function NotificationAlertProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * NotificationAlertProto title.
                 * @member {string} title
                 * @memberof waiternow.common.ClientNotificationProto.NotificationAlertProto
                 * @instance
                 */
                NotificationAlertProto.prototype.title = "";

                /**
                 * NotificationAlertProto body.
                 * @member {string} body
                 * @memberof waiternow.common.ClientNotificationProto.NotificationAlertProto
                 * @instance
                 */
                NotificationAlertProto.prototype.body = "";

                /**
                 * NotificationAlertProto imageUrl.
                 * @member {string} imageUrl
                 * @memberof waiternow.common.ClientNotificationProto.NotificationAlertProto
                 * @instance
                 */
                NotificationAlertProto.prototype.imageUrl = "";

                /**
                 * NotificationAlertProto redirectLink.
                 * @member {string} redirectLink
                 * @memberof waiternow.common.ClientNotificationProto.NotificationAlertProto
                 * @instance
                 */
                NotificationAlertProto.prototype.redirectLink = "";

                /**
                 * Creates a new NotificationAlertProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.ClientNotificationProto.NotificationAlertProto
                 * @static
                 * @param {waiternow.common.ClientNotificationProto.INotificationAlertProto=} [properties] Properties to set
                 * @returns {waiternow.common.ClientNotificationProto.NotificationAlertProto} NotificationAlertProto instance
                 */
                NotificationAlertProto.create = function create(properties) {
                    return new NotificationAlertProto(properties);
                };

                /**
                 * Encodes the specified NotificationAlertProto message. Does not implicitly {@link waiternow.common.ClientNotificationProto.NotificationAlertProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.ClientNotificationProto.NotificationAlertProto
                 * @static
                 * @param {waiternow.common.ClientNotificationProto.INotificationAlertProto} message NotificationAlertProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                NotificationAlertProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.title);
                    if (message.body != null && Object.hasOwnProperty.call(message, "body"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.body);
                    if (message.imageUrl != null && Object.hasOwnProperty.call(message, "imageUrl"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.imageUrl);
                    if (message.redirectLink != null && Object.hasOwnProperty.call(message, "redirectLink"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.redirectLink);
                    return writer;
                };

                /**
                 * Encodes the specified NotificationAlertProto message, length delimited. Does not implicitly {@link waiternow.common.ClientNotificationProto.NotificationAlertProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.ClientNotificationProto.NotificationAlertProto
                 * @static
                 * @param {waiternow.common.ClientNotificationProto.INotificationAlertProto} message NotificationAlertProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                NotificationAlertProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a NotificationAlertProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.ClientNotificationProto.NotificationAlertProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.ClientNotificationProto.NotificationAlertProto} NotificationAlertProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                NotificationAlertProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.ClientNotificationProto.NotificationAlertProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.title = reader.string();
                                break;
                            }
                        case 2: {
                                message.body = reader.string();
                                break;
                            }
                        case 3: {
                                message.imageUrl = reader.string();
                                break;
                            }
                        case 4: {
                                message.redirectLink = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a NotificationAlertProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.ClientNotificationProto.NotificationAlertProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.ClientNotificationProto.NotificationAlertProto} NotificationAlertProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                NotificationAlertProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a NotificationAlertProto message.
                 * @function verify
                 * @memberof waiternow.common.ClientNotificationProto.NotificationAlertProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                NotificationAlertProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.title != null && message.hasOwnProperty("title"))
                        if (!$util.isString(message.title))
                            return "title: string expected";
                    if (message.body != null && message.hasOwnProperty("body"))
                        if (!$util.isString(message.body))
                            return "body: string expected";
                    if (message.imageUrl != null && message.hasOwnProperty("imageUrl"))
                        if (!$util.isString(message.imageUrl))
                            return "imageUrl: string expected";
                    if (message.redirectLink != null && message.hasOwnProperty("redirectLink"))
                        if (!$util.isString(message.redirectLink))
                            return "redirectLink: string expected";
                    return null;
                };

                /**
                 * Creates a NotificationAlertProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.ClientNotificationProto.NotificationAlertProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.ClientNotificationProto.NotificationAlertProto} NotificationAlertProto
                 */
                NotificationAlertProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.ClientNotificationProto.NotificationAlertProto)
                        return object;
                    var message = new $root.waiternow.common.ClientNotificationProto.NotificationAlertProto();
                    if (object.title != null)
                        message.title = String(object.title);
                    if (object.body != null)
                        message.body = String(object.body);
                    if (object.imageUrl != null)
                        message.imageUrl = String(object.imageUrl);
                    if (object.redirectLink != null)
                        message.redirectLink = String(object.redirectLink);
                    return message;
                };

                /**
                 * Creates a plain object from a NotificationAlertProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.ClientNotificationProto.NotificationAlertProto
                 * @static
                 * @param {waiternow.common.ClientNotificationProto.NotificationAlertProto} message NotificationAlertProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                NotificationAlertProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.title = "";
                        object.body = "";
                        object.imageUrl = "";
                        object.redirectLink = "";
                    }
                    if (message.title != null && message.hasOwnProperty("title"))
                        object.title = message.title;
                    if (message.body != null && message.hasOwnProperty("body"))
                        object.body = message.body;
                    if (message.imageUrl != null && message.hasOwnProperty("imageUrl"))
                        object.imageUrl = message.imageUrl;
                    if (message.redirectLink != null && message.hasOwnProperty("redirectLink"))
                        object.redirectLink = message.redirectLink;
                    return object;
                };

                /**
                 * Converts this NotificationAlertProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.ClientNotificationProto.NotificationAlertProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                NotificationAlertProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for NotificationAlertProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.ClientNotificationProto.NotificationAlertProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                NotificationAlertProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.ClientNotificationProto.NotificationAlertProto";
                };

                return NotificationAlertProto;
            })();

            ClientNotificationProto.NewOrderProto = (function() {

                /**
                 * Properties of a NewOrderProto.
                 * @memberof waiternow.common.ClientNotificationProto
                 * @interface INewOrderProto
                 * @property {string|null} [locationId] NewOrderProto locationId
                 * @property {string|null} [pointOfServiceId] NewOrderProto pointOfServiceId
                 * @property {string|null} [orderId] NewOrderProto orderId
                 * @property {waiternow.common.IOrderProto|null} [order] NewOrderProto order
                 */

                /**
                 * Constructs a new NewOrderProto.
                 * @memberof waiternow.common.ClientNotificationProto
                 * @classdesc Represents a NewOrderProto.
                 * @implements INewOrderProto
                 * @constructor
                 * @param {waiternow.common.ClientNotificationProto.INewOrderProto=} [properties] Properties to set
                 */
                function NewOrderProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * NewOrderProto locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.ClientNotificationProto.NewOrderProto
                 * @instance
                 */
                NewOrderProto.prototype.locationId = "";

                /**
                 * NewOrderProto pointOfServiceId.
                 * @member {string} pointOfServiceId
                 * @memberof waiternow.common.ClientNotificationProto.NewOrderProto
                 * @instance
                 */
                NewOrderProto.prototype.pointOfServiceId = "";

                /**
                 * NewOrderProto orderId.
                 * @member {string} orderId
                 * @memberof waiternow.common.ClientNotificationProto.NewOrderProto
                 * @instance
                 */
                NewOrderProto.prototype.orderId = "";

                /**
                 * NewOrderProto order.
                 * @member {waiternow.common.IOrderProto|null|undefined} order
                 * @memberof waiternow.common.ClientNotificationProto.NewOrderProto
                 * @instance
                 */
                NewOrderProto.prototype.order = null;

                /**
                 * Creates a new NewOrderProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.ClientNotificationProto.NewOrderProto
                 * @static
                 * @param {waiternow.common.ClientNotificationProto.INewOrderProto=} [properties] Properties to set
                 * @returns {waiternow.common.ClientNotificationProto.NewOrderProto} NewOrderProto instance
                 */
                NewOrderProto.create = function create(properties) {
                    return new NewOrderProto(properties);
                };

                /**
                 * Encodes the specified NewOrderProto message. Does not implicitly {@link waiternow.common.ClientNotificationProto.NewOrderProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.ClientNotificationProto.NewOrderProto
                 * @static
                 * @param {waiternow.common.ClientNotificationProto.INewOrderProto} message NewOrderProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                NewOrderProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    if (message.pointOfServiceId != null && Object.hasOwnProperty.call(message, "pointOfServiceId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.pointOfServiceId);
                    if (message.orderId != null && Object.hasOwnProperty.call(message, "orderId"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.orderId);
                    if (message.order != null && Object.hasOwnProperty.call(message, "order"))
                        $root.waiternow.common.OrderProto.encode(message.order, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified NewOrderProto message, length delimited. Does not implicitly {@link waiternow.common.ClientNotificationProto.NewOrderProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.ClientNotificationProto.NewOrderProto
                 * @static
                 * @param {waiternow.common.ClientNotificationProto.INewOrderProto} message NewOrderProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                NewOrderProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a NewOrderProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.ClientNotificationProto.NewOrderProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.ClientNotificationProto.NewOrderProto} NewOrderProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                NewOrderProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.ClientNotificationProto.NewOrderProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 2: {
                                message.pointOfServiceId = reader.string();
                                break;
                            }
                        case 3: {
                                message.orderId = reader.string();
                                break;
                            }
                        case 4: {
                                message.order = $root.waiternow.common.OrderProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a NewOrderProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.ClientNotificationProto.NewOrderProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.ClientNotificationProto.NewOrderProto} NewOrderProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                NewOrderProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a NewOrderProto message.
                 * @function verify
                 * @memberof waiternow.common.ClientNotificationProto.NewOrderProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                NewOrderProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    if (message.pointOfServiceId != null && message.hasOwnProperty("pointOfServiceId"))
                        if (!$util.isString(message.pointOfServiceId))
                            return "pointOfServiceId: string expected";
                    if (message.orderId != null && message.hasOwnProperty("orderId"))
                        if (!$util.isString(message.orderId))
                            return "orderId: string expected";
                    if (message.order != null && message.hasOwnProperty("order")) {
                        var error = $root.waiternow.common.OrderProto.verify(message.order);
                        if (error)
                            return "order." + error;
                    }
                    return null;
                };

                /**
                 * Creates a NewOrderProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.ClientNotificationProto.NewOrderProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.ClientNotificationProto.NewOrderProto} NewOrderProto
                 */
                NewOrderProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.ClientNotificationProto.NewOrderProto)
                        return object;
                    var message = new $root.waiternow.common.ClientNotificationProto.NewOrderProto();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    if (object.pointOfServiceId != null)
                        message.pointOfServiceId = String(object.pointOfServiceId);
                    if (object.orderId != null)
                        message.orderId = String(object.orderId);
                    if (object.order != null) {
                        if (typeof object.order !== "object")
                            throw TypeError(".waiternow.common.ClientNotificationProto.NewOrderProto.order: object expected");
                        message.order = $root.waiternow.common.OrderProto.fromObject(object.order);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a NewOrderProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.ClientNotificationProto.NewOrderProto
                 * @static
                 * @param {waiternow.common.ClientNotificationProto.NewOrderProto} message NewOrderProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                NewOrderProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.locationId = "";
                        object.pointOfServiceId = "";
                        object.orderId = "";
                        object.order = null;
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    if (message.pointOfServiceId != null && message.hasOwnProperty("pointOfServiceId"))
                        object.pointOfServiceId = message.pointOfServiceId;
                    if (message.orderId != null && message.hasOwnProperty("orderId"))
                        object.orderId = message.orderId;
                    if (message.order != null && message.hasOwnProperty("order"))
                        object.order = $root.waiternow.common.OrderProto.toObject(message.order, options);
                    return object;
                };

                /**
                 * Converts this NewOrderProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.ClientNotificationProto.NewOrderProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                NewOrderProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for NewOrderProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.ClientNotificationProto.NewOrderProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                NewOrderProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.ClientNotificationProto.NewOrderProto";
                };

                return NewOrderProto;
            })();

            ClientNotificationProto.OrderStatusUpdatedProto = (function() {

                /**
                 * Properties of an OrderStatusUpdatedProto.
                 * @memberof waiternow.common.ClientNotificationProto
                 * @interface IOrderStatusUpdatedProto
                 * @property {waiternow.common.IOrderProto|null} [order] OrderStatusUpdatedProto order
                 */

                /**
                 * Constructs a new OrderStatusUpdatedProto.
                 * @memberof waiternow.common.ClientNotificationProto
                 * @classdesc Represents an OrderStatusUpdatedProto.
                 * @implements IOrderStatusUpdatedProto
                 * @constructor
                 * @param {waiternow.common.ClientNotificationProto.IOrderStatusUpdatedProto=} [properties] Properties to set
                 */
                function OrderStatusUpdatedProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * OrderStatusUpdatedProto order.
                 * @member {waiternow.common.IOrderProto|null|undefined} order
                 * @memberof waiternow.common.ClientNotificationProto.OrderStatusUpdatedProto
                 * @instance
                 */
                OrderStatusUpdatedProto.prototype.order = null;

                /**
                 * Creates a new OrderStatusUpdatedProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.ClientNotificationProto.OrderStatusUpdatedProto
                 * @static
                 * @param {waiternow.common.ClientNotificationProto.IOrderStatusUpdatedProto=} [properties] Properties to set
                 * @returns {waiternow.common.ClientNotificationProto.OrderStatusUpdatedProto} OrderStatusUpdatedProto instance
                 */
                OrderStatusUpdatedProto.create = function create(properties) {
                    return new OrderStatusUpdatedProto(properties);
                };

                /**
                 * Encodes the specified OrderStatusUpdatedProto message. Does not implicitly {@link waiternow.common.ClientNotificationProto.OrderStatusUpdatedProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.ClientNotificationProto.OrderStatusUpdatedProto
                 * @static
                 * @param {waiternow.common.ClientNotificationProto.IOrderStatusUpdatedProto} message OrderStatusUpdatedProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                OrderStatusUpdatedProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.order != null && Object.hasOwnProperty.call(message, "order"))
                        $root.waiternow.common.OrderProto.encode(message.order, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified OrderStatusUpdatedProto message, length delimited. Does not implicitly {@link waiternow.common.ClientNotificationProto.OrderStatusUpdatedProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.ClientNotificationProto.OrderStatusUpdatedProto
                 * @static
                 * @param {waiternow.common.ClientNotificationProto.IOrderStatusUpdatedProto} message OrderStatusUpdatedProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                OrderStatusUpdatedProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an OrderStatusUpdatedProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.ClientNotificationProto.OrderStatusUpdatedProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.ClientNotificationProto.OrderStatusUpdatedProto} OrderStatusUpdatedProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                OrderStatusUpdatedProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.ClientNotificationProto.OrderStatusUpdatedProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.order = $root.waiternow.common.OrderProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an OrderStatusUpdatedProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.ClientNotificationProto.OrderStatusUpdatedProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.ClientNotificationProto.OrderStatusUpdatedProto} OrderStatusUpdatedProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                OrderStatusUpdatedProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an OrderStatusUpdatedProto message.
                 * @function verify
                 * @memberof waiternow.common.ClientNotificationProto.OrderStatusUpdatedProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                OrderStatusUpdatedProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.order != null && message.hasOwnProperty("order")) {
                        var error = $root.waiternow.common.OrderProto.verify(message.order);
                        if (error)
                            return "order." + error;
                    }
                    return null;
                };

                /**
                 * Creates an OrderStatusUpdatedProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.ClientNotificationProto.OrderStatusUpdatedProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.ClientNotificationProto.OrderStatusUpdatedProto} OrderStatusUpdatedProto
                 */
                OrderStatusUpdatedProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.ClientNotificationProto.OrderStatusUpdatedProto)
                        return object;
                    var message = new $root.waiternow.common.ClientNotificationProto.OrderStatusUpdatedProto();
                    if (object.order != null) {
                        if (typeof object.order !== "object")
                            throw TypeError(".waiternow.common.ClientNotificationProto.OrderStatusUpdatedProto.order: object expected");
                        message.order = $root.waiternow.common.OrderProto.fromObject(object.order);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an OrderStatusUpdatedProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.ClientNotificationProto.OrderStatusUpdatedProto
                 * @static
                 * @param {waiternow.common.ClientNotificationProto.OrderStatusUpdatedProto} message OrderStatusUpdatedProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                OrderStatusUpdatedProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.order = null;
                    if (message.order != null && message.hasOwnProperty("order"))
                        object.order = $root.waiternow.common.OrderProto.toObject(message.order, options);
                    return object;
                };

                /**
                 * Converts this OrderStatusUpdatedProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.ClientNotificationProto.OrderStatusUpdatedProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                OrderStatusUpdatedProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for OrderStatusUpdatedProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.ClientNotificationProto.OrderStatusUpdatedProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                OrderStatusUpdatedProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.ClientNotificationProto.OrderStatusUpdatedProto";
                };

                return OrderStatusUpdatedProto;
            })();

            ClientNotificationProto.LocationOnlineStatusUpdatedProto = (function() {

                /**
                 * Properties of a LocationOnlineStatusUpdatedProto.
                 * @memberof waiternow.common.ClientNotificationProto
                 * @interface ILocationOnlineStatusUpdatedProto
                 * @property {string|null} [locationId] LocationOnlineStatusUpdatedProto locationId
                 * @property {boolean|null} [isLocationOnline] LocationOnlineStatusUpdatedProto isLocationOnline
                 */

                /**
                 * Constructs a new LocationOnlineStatusUpdatedProto.
                 * @memberof waiternow.common.ClientNotificationProto
                 * @classdesc Represents a LocationOnlineStatusUpdatedProto.
                 * @implements ILocationOnlineStatusUpdatedProto
                 * @constructor
                 * @param {waiternow.common.ClientNotificationProto.ILocationOnlineStatusUpdatedProto=} [properties] Properties to set
                 */
                function LocationOnlineStatusUpdatedProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * LocationOnlineStatusUpdatedProto locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.ClientNotificationProto.LocationOnlineStatusUpdatedProto
                 * @instance
                 */
                LocationOnlineStatusUpdatedProto.prototype.locationId = "";

                /**
                 * LocationOnlineStatusUpdatedProto isLocationOnline.
                 * @member {boolean} isLocationOnline
                 * @memberof waiternow.common.ClientNotificationProto.LocationOnlineStatusUpdatedProto
                 * @instance
                 */
                LocationOnlineStatusUpdatedProto.prototype.isLocationOnline = false;

                /**
                 * Creates a new LocationOnlineStatusUpdatedProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.ClientNotificationProto.LocationOnlineStatusUpdatedProto
                 * @static
                 * @param {waiternow.common.ClientNotificationProto.ILocationOnlineStatusUpdatedProto=} [properties] Properties to set
                 * @returns {waiternow.common.ClientNotificationProto.LocationOnlineStatusUpdatedProto} LocationOnlineStatusUpdatedProto instance
                 */
                LocationOnlineStatusUpdatedProto.create = function create(properties) {
                    return new LocationOnlineStatusUpdatedProto(properties);
                };

                /**
                 * Encodes the specified LocationOnlineStatusUpdatedProto message. Does not implicitly {@link waiternow.common.ClientNotificationProto.LocationOnlineStatusUpdatedProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.ClientNotificationProto.LocationOnlineStatusUpdatedProto
                 * @static
                 * @param {waiternow.common.ClientNotificationProto.ILocationOnlineStatusUpdatedProto} message LocationOnlineStatusUpdatedProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LocationOnlineStatusUpdatedProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    if (message.isLocationOnline != null && Object.hasOwnProperty.call(message, "isLocationOnline"))
                        writer.uint32(/* id 2, wireType 0 =*/16).bool(message.isLocationOnline);
                    return writer;
                };

                /**
                 * Encodes the specified LocationOnlineStatusUpdatedProto message, length delimited. Does not implicitly {@link waiternow.common.ClientNotificationProto.LocationOnlineStatusUpdatedProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.ClientNotificationProto.LocationOnlineStatusUpdatedProto
                 * @static
                 * @param {waiternow.common.ClientNotificationProto.ILocationOnlineStatusUpdatedProto} message LocationOnlineStatusUpdatedProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LocationOnlineStatusUpdatedProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a LocationOnlineStatusUpdatedProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.ClientNotificationProto.LocationOnlineStatusUpdatedProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.ClientNotificationProto.LocationOnlineStatusUpdatedProto} LocationOnlineStatusUpdatedProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LocationOnlineStatusUpdatedProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.ClientNotificationProto.LocationOnlineStatusUpdatedProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 2: {
                                message.isLocationOnline = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a LocationOnlineStatusUpdatedProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.ClientNotificationProto.LocationOnlineStatusUpdatedProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.ClientNotificationProto.LocationOnlineStatusUpdatedProto} LocationOnlineStatusUpdatedProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LocationOnlineStatusUpdatedProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a LocationOnlineStatusUpdatedProto message.
                 * @function verify
                 * @memberof waiternow.common.ClientNotificationProto.LocationOnlineStatusUpdatedProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                LocationOnlineStatusUpdatedProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    if (message.isLocationOnline != null && message.hasOwnProperty("isLocationOnline"))
                        if (typeof message.isLocationOnline !== "boolean")
                            return "isLocationOnline: boolean expected";
                    return null;
                };

                /**
                 * Creates a LocationOnlineStatusUpdatedProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.ClientNotificationProto.LocationOnlineStatusUpdatedProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.ClientNotificationProto.LocationOnlineStatusUpdatedProto} LocationOnlineStatusUpdatedProto
                 */
                LocationOnlineStatusUpdatedProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.ClientNotificationProto.LocationOnlineStatusUpdatedProto)
                        return object;
                    var message = new $root.waiternow.common.ClientNotificationProto.LocationOnlineStatusUpdatedProto();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    if (object.isLocationOnline != null)
                        message.isLocationOnline = Boolean(object.isLocationOnline);
                    return message;
                };

                /**
                 * Creates a plain object from a LocationOnlineStatusUpdatedProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.ClientNotificationProto.LocationOnlineStatusUpdatedProto
                 * @static
                 * @param {waiternow.common.ClientNotificationProto.LocationOnlineStatusUpdatedProto} message LocationOnlineStatusUpdatedProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                LocationOnlineStatusUpdatedProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.locationId = "";
                        object.isLocationOnline = false;
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    if (message.isLocationOnline != null && message.hasOwnProperty("isLocationOnline"))
                        object.isLocationOnline = message.isLocationOnline;
                    return object;
                };

                /**
                 * Converts this LocationOnlineStatusUpdatedProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.ClientNotificationProto.LocationOnlineStatusUpdatedProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                LocationOnlineStatusUpdatedProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for LocationOnlineStatusUpdatedProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.ClientNotificationProto.LocationOnlineStatusUpdatedProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                LocationOnlineStatusUpdatedProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.ClientNotificationProto.LocationOnlineStatusUpdatedProto";
                };

                return LocationOnlineStatusUpdatedProto;
            })();

            ClientNotificationProto.MenuUpdatedProto = (function() {

                /**
                 * Properties of a MenuUpdatedProto.
                 * @memberof waiternow.common.ClientNotificationProto
                 * @interface IMenuUpdatedProto
                 * @property {string|null} [locationId] MenuUpdatedProto locationId
                 */

                /**
                 * Constructs a new MenuUpdatedProto.
                 * @memberof waiternow.common.ClientNotificationProto
                 * @classdesc Represents a MenuUpdatedProto.
                 * @implements IMenuUpdatedProto
                 * @constructor
                 * @param {waiternow.common.ClientNotificationProto.IMenuUpdatedProto=} [properties] Properties to set
                 */
                function MenuUpdatedProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * MenuUpdatedProto locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.ClientNotificationProto.MenuUpdatedProto
                 * @instance
                 */
                MenuUpdatedProto.prototype.locationId = "";

                /**
                 * Creates a new MenuUpdatedProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.ClientNotificationProto.MenuUpdatedProto
                 * @static
                 * @param {waiternow.common.ClientNotificationProto.IMenuUpdatedProto=} [properties] Properties to set
                 * @returns {waiternow.common.ClientNotificationProto.MenuUpdatedProto} MenuUpdatedProto instance
                 */
                MenuUpdatedProto.create = function create(properties) {
                    return new MenuUpdatedProto(properties);
                };

                /**
                 * Encodes the specified MenuUpdatedProto message. Does not implicitly {@link waiternow.common.ClientNotificationProto.MenuUpdatedProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.ClientNotificationProto.MenuUpdatedProto
                 * @static
                 * @param {waiternow.common.ClientNotificationProto.IMenuUpdatedProto} message MenuUpdatedProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MenuUpdatedProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    return writer;
                };

                /**
                 * Encodes the specified MenuUpdatedProto message, length delimited. Does not implicitly {@link waiternow.common.ClientNotificationProto.MenuUpdatedProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.ClientNotificationProto.MenuUpdatedProto
                 * @static
                 * @param {waiternow.common.ClientNotificationProto.IMenuUpdatedProto} message MenuUpdatedProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MenuUpdatedProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a MenuUpdatedProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.ClientNotificationProto.MenuUpdatedProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.ClientNotificationProto.MenuUpdatedProto} MenuUpdatedProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MenuUpdatedProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.ClientNotificationProto.MenuUpdatedProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a MenuUpdatedProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.ClientNotificationProto.MenuUpdatedProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.ClientNotificationProto.MenuUpdatedProto} MenuUpdatedProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MenuUpdatedProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a MenuUpdatedProto message.
                 * @function verify
                 * @memberof waiternow.common.ClientNotificationProto.MenuUpdatedProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                MenuUpdatedProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    return null;
                };

                /**
                 * Creates a MenuUpdatedProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.ClientNotificationProto.MenuUpdatedProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.ClientNotificationProto.MenuUpdatedProto} MenuUpdatedProto
                 */
                MenuUpdatedProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.ClientNotificationProto.MenuUpdatedProto)
                        return object;
                    var message = new $root.waiternow.common.ClientNotificationProto.MenuUpdatedProto();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    return message;
                };

                /**
                 * Creates a plain object from a MenuUpdatedProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.ClientNotificationProto.MenuUpdatedProto
                 * @static
                 * @param {waiternow.common.ClientNotificationProto.MenuUpdatedProto} message MenuUpdatedProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                MenuUpdatedProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.locationId = "";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    return object;
                };

                /**
                 * Converts this MenuUpdatedProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.ClientNotificationProto.MenuUpdatedProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                MenuUpdatedProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for MenuUpdatedProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.ClientNotificationProto.MenuUpdatedProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                MenuUpdatedProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.ClientNotificationProto.MenuUpdatedProto";
                };

                return MenuUpdatedProto;
            })();

            ClientNotificationProto.TerminateDeviceSessionRequestProto = (function() {

                /**
                 * Properties of a TerminateDeviceSessionRequestProto.
                 * @memberof waiternow.common.ClientNotificationProto
                 * @interface ITerminateDeviceSessionRequestProto
                 * @property {string|null} [deviceId] TerminateDeviceSessionRequestProto deviceId
                 */

                /**
                 * Constructs a new TerminateDeviceSessionRequestProto.
                 * @memberof waiternow.common.ClientNotificationProto
                 * @classdesc Represents a TerminateDeviceSessionRequestProto.
                 * @implements ITerminateDeviceSessionRequestProto
                 * @constructor
                 * @param {waiternow.common.ClientNotificationProto.ITerminateDeviceSessionRequestProto=} [properties] Properties to set
                 */
                function TerminateDeviceSessionRequestProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * TerminateDeviceSessionRequestProto deviceId.
                 * @member {string} deviceId
                 * @memberof waiternow.common.ClientNotificationProto.TerminateDeviceSessionRequestProto
                 * @instance
                 */
                TerminateDeviceSessionRequestProto.prototype.deviceId = "";

                /**
                 * Creates a new TerminateDeviceSessionRequestProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.ClientNotificationProto.TerminateDeviceSessionRequestProto
                 * @static
                 * @param {waiternow.common.ClientNotificationProto.ITerminateDeviceSessionRequestProto=} [properties] Properties to set
                 * @returns {waiternow.common.ClientNotificationProto.TerminateDeviceSessionRequestProto} TerminateDeviceSessionRequestProto instance
                 */
                TerminateDeviceSessionRequestProto.create = function create(properties) {
                    return new TerminateDeviceSessionRequestProto(properties);
                };

                /**
                 * Encodes the specified TerminateDeviceSessionRequestProto message. Does not implicitly {@link waiternow.common.ClientNotificationProto.TerminateDeviceSessionRequestProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.ClientNotificationProto.TerminateDeviceSessionRequestProto
                 * @static
                 * @param {waiternow.common.ClientNotificationProto.ITerminateDeviceSessionRequestProto} message TerminateDeviceSessionRequestProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                TerminateDeviceSessionRequestProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceId != null && Object.hasOwnProperty.call(message, "deviceId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.deviceId);
                    return writer;
                };

                /**
                 * Encodes the specified TerminateDeviceSessionRequestProto message, length delimited. Does not implicitly {@link waiternow.common.ClientNotificationProto.TerminateDeviceSessionRequestProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.ClientNotificationProto.TerminateDeviceSessionRequestProto
                 * @static
                 * @param {waiternow.common.ClientNotificationProto.ITerminateDeviceSessionRequestProto} message TerminateDeviceSessionRequestProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                TerminateDeviceSessionRequestProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a TerminateDeviceSessionRequestProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.ClientNotificationProto.TerminateDeviceSessionRequestProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.ClientNotificationProto.TerminateDeviceSessionRequestProto} TerminateDeviceSessionRequestProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                TerminateDeviceSessionRequestProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.ClientNotificationProto.TerminateDeviceSessionRequestProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a TerminateDeviceSessionRequestProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.ClientNotificationProto.TerminateDeviceSessionRequestProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.ClientNotificationProto.TerminateDeviceSessionRequestProto} TerminateDeviceSessionRequestProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                TerminateDeviceSessionRequestProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a TerminateDeviceSessionRequestProto message.
                 * @function verify
                 * @memberof waiternow.common.ClientNotificationProto.TerminateDeviceSessionRequestProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                TerminateDeviceSessionRequestProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                        if (!$util.isString(message.deviceId))
                            return "deviceId: string expected";
                    return null;
                };

                /**
                 * Creates a TerminateDeviceSessionRequestProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.ClientNotificationProto.TerminateDeviceSessionRequestProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.ClientNotificationProto.TerminateDeviceSessionRequestProto} TerminateDeviceSessionRequestProto
                 */
                TerminateDeviceSessionRequestProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.ClientNotificationProto.TerminateDeviceSessionRequestProto)
                        return object;
                    var message = new $root.waiternow.common.ClientNotificationProto.TerminateDeviceSessionRequestProto();
                    if (object.deviceId != null)
                        message.deviceId = String(object.deviceId);
                    return message;
                };

                /**
                 * Creates a plain object from a TerminateDeviceSessionRequestProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.ClientNotificationProto.TerminateDeviceSessionRequestProto
                 * @static
                 * @param {waiternow.common.ClientNotificationProto.TerminateDeviceSessionRequestProto} message TerminateDeviceSessionRequestProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                TerminateDeviceSessionRequestProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.deviceId = "";
                    if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                        object.deviceId = message.deviceId;
                    return object;
                };

                /**
                 * Converts this TerminateDeviceSessionRequestProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.ClientNotificationProto.TerminateDeviceSessionRequestProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                TerminateDeviceSessionRequestProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for TerminateDeviceSessionRequestProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.ClientNotificationProto.TerminateDeviceSessionRequestProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                TerminateDeviceSessionRequestProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.ClientNotificationProto.TerminateDeviceSessionRequestProto";
                };

                return TerminateDeviceSessionRequestProto;
            })();

            ClientNotificationProto.StartRemoteLogsSessionProto = (function() {

                /**
                 * Properties of a StartRemoteLogsSessionProto.
                 * @memberof waiternow.common.ClientNotificationProto
                 * @interface IStartRemoteLogsSessionProto
                 * @property {string|null} [deviceId] StartRemoteLogsSessionProto deviceId
                 * @property {google.protobuf.ITimestamp|null} [startTime] StartRemoteLogsSessionProto startTime
                 * @property {google.protobuf.IDuration|null} [duration] StartRemoteLogsSessionProto duration
                 */

                /**
                 * Constructs a new StartRemoteLogsSessionProto.
                 * @memberof waiternow.common.ClientNotificationProto
                 * @classdesc Represents a StartRemoteLogsSessionProto.
                 * @implements IStartRemoteLogsSessionProto
                 * @constructor
                 * @param {waiternow.common.ClientNotificationProto.IStartRemoteLogsSessionProto=} [properties] Properties to set
                 */
                function StartRemoteLogsSessionProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StartRemoteLogsSessionProto deviceId.
                 * @member {string} deviceId
                 * @memberof waiternow.common.ClientNotificationProto.StartRemoteLogsSessionProto
                 * @instance
                 */
                StartRemoteLogsSessionProto.prototype.deviceId = "";

                /**
                 * StartRemoteLogsSessionProto startTime.
                 * @member {google.protobuf.ITimestamp|null|undefined} startTime
                 * @memberof waiternow.common.ClientNotificationProto.StartRemoteLogsSessionProto
                 * @instance
                 */
                StartRemoteLogsSessionProto.prototype.startTime = null;

                /**
                 * StartRemoteLogsSessionProto duration.
                 * @member {google.protobuf.IDuration|null|undefined} duration
                 * @memberof waiternow.common.ClientNotificationProto.StartRemoteLogsSessionProto
                 * @instance
                 */
                StartRemoteLogsSessionProto.prototype.duration = null;

                /**
                 * Creates a new StartRemoteLogsSessionProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.ClientNotificationProto.StartRemoteLogsSessionProto
                 * @static
                 * @param {waiternow.common.ClientNotificationProto.IStartRemoteLogsSessionProto=} [properties] Properties to set
                 * @returns {waiternow.common.ClientNotificationProto.StartRemoteLogsSessionProto} StartRemoteLogsSessionProto instance
                 */
                StartRemoteLogsSessionProto.create = function create(properties) {
                    return new StartRemoteLogsSessionProto(properties);
                };

                /**
                 * Encodes the specified StartRemoteLogsSessionProto message. Does not implicitly {@link waiternow.common.ClientNotificationProto.StartRemoteLogsSessionProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.ClientNotificationProto.StartRemoteLogsSessionProto
                 * @static
                 * @param {waiternow.common.ClientNotificationProto.IStartRemoteLogsSessionProto} message StartRemoteLogsSessionProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StartRemoteLogsSessionProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceId != null && Object.hasOwnProperty.call(message, "deviceId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.deviceId);
                    if (message.startTime != null && Object.hasOwnProperty.call(message, "startTime"))
                        $root.google.protobuf.Timestamp.encode(message.startTime, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.duration != null && Object.hasOwnProperty.call(message, "duration"))
                        $root.google.protobuf.Duration.encode(message.duration, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified StartRemoteLogsSessionProto message, length delimited. Does not implicitly {@link waiternow.common.ClientNotificationProto.StartRemoteLogsSessionProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.ClientNotificationProto.StartRemoteLogsSessionProto
                 * @static
                 * @param {waiternow.common.ClientNotificationProto.IStartRemoteLogsSessionProto} message StartRemoteLogsSessionProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StartRemoteLogsSessionProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a StartRemoteLogsSessionProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.ClientNotificationProto.StartRemoteLogsSessionProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.ClientNotificationProto.StartRemoteLogsSessionProto} StartRemoteLogsSessionProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StartRemoteLogsSessionProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.ClientNotificationProto.StartRemoteLogsSessionProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceId = reader.string();
                                break;
                            }
                        case 2: {
                                message.startTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.duration = $root.google.protobuf.Duration.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a StartRemoteLogsSessionProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.ClientNotificationProto.StartRemoteLogsSessionProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.ClientNotificationProto.StartRemoteLogsSessionProto} StartRemoteLogsSessionProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StartRemoteLogsSessionProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StartRemoteLogsSessionProto message.
                 * @function verify
                 * @memberof waiternow.common.ClientNotificationProto.StartRemoteLogsSessionProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StartRemoteLogsSessionProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                        if (!$util.isString(message.deviceId))
                            return "deviceId: string expected";
                    if (message.startTime != null && message.hasOwnProperty("startTime")) {
                        var error = $root.google.protobuf.Timestamp.verify(message.startTime);
                        if (error)
                            return "startTime." + error;
                    }
                    if (message.duration != null && message.hasOwnProperty("duration")) {
                        var error = $root.google.protobuf.Duration.verify(message.duration);
                        if (error)
                            return "duration." + error;
                    }
                    return null;
                };

                /**
                 * Creates a StartRemoteLogsSessionProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.ClientNotificationProto.StartRemoteLogsSessionProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.ClientNotificationProto.StartRemoteLogsSessionProto} StartRemoteLogsSessionProto
                 */
                StartRemoteLogsSessionProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.ClientNotificationProto.StartRemoteLogsSessionProto)
                        return object;
                    var message = new $root.waiternow.common.ClientNotificationProto.StartRemoteLogsSessionProto();
                    if (object.deviceId != null)
                        message.deviceId = String(object.deviceId);
                    if (object.startTime != null) {
                        if (typeof object.startTime !== "object")
                            throw TypeError(".waiternow.common.ClientNotificationProto.StartRemoteLogsSessionProto.startTime: object expected");
                        message.startTime = $root.google.protobuf.Timestamp.fromObject(object.startTime);
                    }
                    if (object.duration != null) {
                        if (typeof object.duration !== "object")
                            throw TypeError(".waiternow.common.ClientNotificationProto.StartRemoteLogsSessionProto.duration: object expected");
                        message.duration = $root.google.protobuf.Duration.fromObject(object.duration);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a StartRemoteLogsSessionProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.ClientNotificationProto.StartRemoteLogsSessionProto
                 * @static
                 * @param {waiternow.common.ClientNotificationProto.StartRemoteLogsSessionProto} message StartRemoteLogsSessionProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StartRemoteLogsSessionProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.deviceId = "";
                        object.startTime = null;
                        object.duration = null;
                    }
                    if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                        object.deviceId = message.deviceId;
                    if (message.startTime != null && message.hasOwnProperty("startTime"))
                        object.startTime = $root.google.protobuf.Timestamp.toObject(message.startTime, options);
                    if (message.duration != null && message.hasOwnProperty("duration"))
                        object.duration = $root.google.protobuf.Duration.toObject(message.duration, options);
                    return object;
                };

                /**
                 * Converts this StartRemoteLogsSessionProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.ClientNotificationProto.StartRemoteLogsSessionProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StartRemoteLogsSessionProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for StartRemoteLogsSessionProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.ClientNotificationProto.StartRemoteLogsSessionProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                StartRemoteLogsSessionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.ClientNotificationProto.StartRemoteLogsSessionProto";
                };

                return StartRemoteLogsSessionProto;
            })();

            return ClientNotificationProto;
        })();

        common.SalesPartnerProto = (function() {

            /**
             * Properties of a SalesPartnerProto.
             * @memberof waiternow.common
             * @interface ISalesPartnerProto
             * @property {string|null} [id] SalesPartnerProto id
             * @property {google.protobuf.ITimestamp|null} [creationTime] SalesPartnerProto creationTime
             * @property {google.protobuf.ITimestamp|null} [lastUpdateTime] SalesPartnerProto lastUpdateTime
             * @property {string|null} [name] SalesPartnerProto name
             * @property {string|null} [email] SalesPartnerProto email
             * @property {waiternow.common.IPhoneNumberProto|null} [phoneNumber] SalesPartnerProto phoneNumber
             * @property {waiternow.common.IAddressProto|null} [address] SalesPartnerProto address
             * @property {waiternow.common.SalesPartnerProto.IStatusProto|null} [status] SalesPartnerProto status
             * @property {waiternow.common.SalesPartnerProto.ISettingsProto|null} [settings] SalesPartnerProto settings
             */

            /**
             * Constructs a new SalesPartnerProto.
             * @memberof waiternow.common
             * @classdesc Represents a SalesPartnerProto.
             * @implements ISalesPartnerProto
             * @constructor
             * @param {waiternow.common.ISalesPartnerProto=} [properties] Properties to set
             */
            function SalesPartnerProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * SalesPartnerProto id.
             * @member {string} id
             * @memberof waiternow.common.SalesPartnerProto
             * @instance
             */
            SalesPartnerProto.prototype.id = "";

            /**
             * SalesPartnerProto creationTime.
             * @member {google.protobuf.ITimestamp|null|undefined} creationTime
             * @memberof waiternow.common.SalesPartnerProto
             * @instance
             */
            SalesPartnerProto.prototype.creationTime = null;

            /**
             * SalesPartnerProto lastUpdateTime.
             * @member {google.protobuf.ITimestamp|null|undefined} lastUpdateTime
             * @memberof waiternow.common.SalesPartnerProto
             * @instance
             */
            SalesPartnerProto.prototype.lastUpdateTime = null;

            /**
             * SalesPartnerProto name.
             * @member {string} name
             * @memberof waiternow.common.SalesPartnerProto
             * @instance
             */
            SalesPartnerProto.prototype.name = "";

            /**
             * SalesPartnerProto email.
             * @member {string} email
             * @memberof waiternow.common.SalesPartnerProto
             * @instance
             */
            SalesPartnerProto.prototype.email = "";

            /**
             * SalesPartnerProto phoneNumber.
             * @member {waiternow.common.IPhoneNumberProto|null|undefined} phoneNumber
             * @memberof waiternow.common.SalesPartnerProto
             * @instance
             */
            SalesPartnerProto.prototype.phoneNumber = null;

            /**
             * SalesPartnerProto address.
             * @member {waiternow.common.IAddressProto|null|undefined} address
             * @memberof waiternow.common.SalesPartnerProto
             * @instance
             */
            SalesPartnerProto.prototype.address = null;

            /**
             * SalesPartnerProto status.
             * @member {waiternow.common.SalesPartnerProto.IStatusProto|null|undefined} status
             * @memberof waiternow.common.SalesPartnerProto
             * @instance
             */
            SalesPartnerProto.prototype.status = null;

            /**
             * SalesPartnerProto settings.
             * @member {waiternow.common.SalesPartnerProto.ISettingsProto|null|undefined} settings
             * @memberof waiternow.common.SalesPartnerProto
             * @instance
             */
            SalesPartnerProto.prototype.settings = null;

            /**
             * Creates a new SalesPartnerProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.SalesPartnerProto
             * @static
             * @param {waiternow.common.ISalesPartnerProto=} [properties] Properties to set
             * @returns {waiternow.common.SalesPartnerProto} SalesPartnerProto instance
             */
            SalesPartnerProto.create = function create(properties) {
                return new SalesPartnerProto(properties);
            };

            /**
             * Encodes the specified SalesPartnerProto message. Does not implicitly {@link waiternow.common.SalesPartnerProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.SalesPartnerProto
             * @static
             * @param {waiternow.common.ISalesPartnerProto} message SalesPartnerProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SalesPartnerProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                if (message.creationTime != null && Object.hasOwnProperty.call(message, "creationTime"))
                    $root.google.protobuf.Timestamp.encode(message.creationTime, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                    $root.google.protobuf.Timestamp.encode(message.lastUpdateTime, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.name);
                if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.email);
                if (message.phoneNumber != null && Object.hasOwnProperty.call(message, "phoneNumber"))
                    $root.waiternow.common.PhoneNumberProto.encode(message.phoneNumber, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                if (message.address != null && Object.hasOwnProperty.call(message, "address"))
                    $root.waiternow.common.AddressProto.encode(message.address, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                    $root.waiternow.common.SalesPartnerProto.StatusProto.encode(message.status, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                if (message.settings != null && Object.hasOwnProperty.call(message, "settings"))
                    $root.waiternow.common.SalesPartnerProto.SettingsProto.encode(message.settings, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified SalesPartnerProto message, length delimited. Does not implicitly {@link waiternow.common.SalesPartnerProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.SalesPartnerProto
             * @static
             * @param {waiternow.common.ISalesPartnerProto} message SalesPartnerProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SalesPartnerProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SalesPartnerProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.SalesPartnerProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.SalesPartnerProto} SalesPartnerProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SalesPartnerProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.SalesPartnerProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.id = reader.string();
                            break;
                        }
                    case 2: {
                            message.creationTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 3: {
                            message.lastUpdateTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 4: {
                            message.name = reader.string();
                            break;
                        }
                    case 5: {
                            message.email = reader.string();
                            break;
                        }
                    case 6: {
                            message.phoneNumber = $root.waiternow.common.PhoneNumberProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 7: {
                            message.address = $root.waiternow.common.AddressProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 8: {
                            message.status = $root.waiternow.common.SalesPartnerProto.StatusProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 9: {
                            message.settings = $root.waiternow.common.SalesPartnerProto.SettingsProto.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SalesPartnerProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.SalesPartnerProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.SalesPartnerProto} SalesPartnerProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SalesPartnerProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SalesPartnerProto message.
             * @function verify
             * @memberof waiternow.common.SalesPartnerProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SalesPartnerProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.id != null && message.hasOwnProperty("id"))
                    if (!$util.isString(message.id))
                        return "id: string expected";
                if (message.creationTime != null && message.hasOwnProperty("creationTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.creationTime);
                    if (error)
                        return "creationTime." + error;
                }
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.lastUpdateTime);
                    if (error)
                        return "lastUpdateTime." + error;
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.email != null && message.hasOwnProperty("email"))
                    if (!$util.isString(message.email))
                        return "email: string expected";
                if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber")) {
                    var error = $root.waiternow.common.PhoneNumberProto.verify(message.phoneNumber);
                    if (error)
                        return "phoneNumber." + error;
                }
                if (message.address != null && message.hasOwnProperty("address")) {
                    var error = $root.waiternow.common.AddressProto.verify(message.address);
                    if (error)
                        return "address." + error;
                }
                if (message.status != null && message.hasOwnProperty("status")) {
                    var error = $root.waiternow.common.SalesPartnerProto.StatusProto.verify(message.status);
                    if (error)
                        return "status." + error;
                }
                if (message.settings != null && message.hasOwnProperty("settings")) {
                    var error = $root.waiternow.common.SalesPartnerProto.SettingsProto.verify(message.settings);
                    if (error)
                        return "settings." + error;
                }
                return null;
            };

            /**
             * Creates a SalesPartnerProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.SalesPartnerProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.SalesPartnerProto} SalesPartnerProto
             */
            SalesPartnerProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.SalesPartnerProto)
                    return object;
                var message = new $root.waiternow.common.SalesPartnerProto();
                if (object.id != null)
                    message.id = String(object.id);
                if (object.creationTime != null) {
                    if (typeof object.creationTime !== "object")
                        throw TypeError(".waiternow.common.SalesPartnerProto.creationTime: object expected");
                    message.creationTime = $root.google.protobuf.Timestamp.fromObject(object.creationTime);
                }
                if (object.lastUpdateTime != null) {
                    if (typeof object.lastUpdateTime !== "object")
                        throw TypeError(".waiternow.common.SalesPartnerProto.lastUpdateTime: object expected");
                    message.lastUpdateTime = $root.google.protobuf.Timestamp.fromObject(object.lastUpdateTime);
                }
                if (object.name != null)
                    message.name = String(object.name);
                if (object.email != null)
                    message.email = String(object.email);
                if (object.phoneNumber != null) {
                    if (typeof object.phoneNumber !== "object")
                        throw TypeError(".waiternow.common.SalesPartnerProto.phoneNumber: object expected");
                    message.phoneNumber = $root.waiternow.common.PhoneNumberProto.fromObject(object.phoneNumber);
                }
                if (object.address != null) {
                    if (typeof object.address !== "object")
                        throw TypeError(".waiternow.common.SalesPartnerProto.address: object expected");
                    message.address = $root.waiternow.common.AddressProto.fromObject(object.address);
                }
                if (object.status != null) {
                    if (typeof object.status !== "object")
                        throw TypeError(".waiternow.common.SalesPartnerProto.status: object expected");
                    message.status = $root.waiternow.common.SalesPartnerProto.StatusProto.fromObject(object.status);
                }
                if (object.settings != null) {
                    if (typeof object.settings !== "object")
                        throw TypeError(".waiternow.common.SalesPartnerProto.settings: object expected");
                    message.settings = $root.waiternow.common.SalesPartnerProto.SettingsProto.fromObject(object.settings);
                }
                return message;
            };

            /**
             * Creates a plain object from a SalesPartnerProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.SalesPartnerProto
             * @static
             * @param {waiternow.common.SalesPartnerProto} message SalesPartnerProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SalesPartnerProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.id = "";
                    object.creationTime = null;
                    object.lastUpdateTime = null;
                    object.name = "";
                    object.email = "";
                    object.phoneNumber = null;
                    object.address = null;
                    object.status = null;
                    object.settings = null;
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                    object.creationTime = $root.google.protobuf.Timestamp.toObject(message.creationTime, options);
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                    object.lastUpdateTime = $root.google.protobuf.Timestamp.toObject(message.lastUpdateTime, options);
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.email != null && message.hasOwnProperty("email"))
                    object.email = message.email;
                if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
                    object.phoneNumber = $root.waiternow.common.PhoneNumberProto.toObject(message.phoneNumber, options);
                if (message.address != null && message.hasOwnProperty("address"))
                    object.address = $root.waiternow.common.AddressProto.toObject(message.address, options);
                if (message.status != null && message.hasOwnProperty("status"))
                    object.status = $root.waiternow.common.SalesPartnerProto.StatusProto.toObject(message.status, options);
                if (message.settings != null && message.hasOwnProperty("settings"))
                    object.settings = $root.waiternow.common.SalesPartnerProto.SettingsProto.toObject(message.settings, options);
                return object;
            };

            /**
             * Converts this SalesPartnerProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.SalesPartnerProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SalesPartnerProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for SalesPartnerProto
             * @function getTypeUrl
             * @memberof waiternow.common.SalesPartnerProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            SalesPartnerProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.SalesPartnerProto";
            };

            SalesPartnerProto.StatusProto = (function() {

                /**
                 * Properties of a StatusProto.
                 * @memberof waiternow.common.SalesPartnerProto
                 * @interface IStatusProto
                 * @property {waiternow.common.SalesPartnerProto.StatusProto.State|null} [state] StatusProto state
                 * @property {google.protobuf.ITimestamp|null} [stateUpdatedOn] StatusProto stateUpdatedOn
                 */

                /**
                 * Constructs a new StatusProto.
                 * @memberof waiternow.common.SalesPartnerProto
                 * @classdesc Represents a StatusProto.
                 * @implements IStatusProto
                 * @constructor
                 * @param {waiternow.common.SalesPartnerProto.IStatusProto=} [properties] Properties to set
                 */
                function StatusProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StatusProto state.
                 * @member {waiternow.common.SalesPartnerProto.StatusProto.State} state
                 * @memberof waiternow.common.SalesPartnerProto.StatusProto
                 * @instance
                 */
                StatusProto.prototype.state = 0;

                /**
                 * StatusProto stateUpdatedOn.
                 * @member {google.protobuf.ITimestamp|null|undefined} stateUpdatedOn
                 * @memberof waiternow.common.SalesPartnerProto.StatusProto
                 * @instance
                 */
                StatusProto.prototype.stateUpdatedOn = null;

                /**
                 * Creates a new StatusProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.SalesPartnerProto.StatusProto
                 * @static
                 * @param {waiternow.common.SalesPartnerProto.IStatusProto=} [properties] Properties to set
                 * @returns {waiternow.common.SalesPartnerProto.StatusProto} StatusProto instance
                 */
                StatusProto.create = function create(properties) {
                    return new StatusProto(properties);
                };

                /**
                 * Encodes the specified StatusProto message. Does not implicitly {@link waiternow.common.SalesPartnerProto.StatusProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.SalesPartnerProto.StatusProto
                 * @static
                 * @param {waiternow.common.SalesPartnerProto.IStatusProto} message StatusProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StatusProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.state);
                    if (message.stateUpdatedOn != null && Object.hasOwnProperty.call(message, "stateUpdatedOn"))
                        $root.google.protobuf.Timestamp.encode(message.stateUpdatedOn, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified StatusProto message, length delimited. Does not implicitly {@link waiternow.common.SalesPartnerProto.StatusProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.SalesPartnerProto.StatusProto
                 * @static
                 * @param {waiternow.common.SalesPartnerProto.IStatusProto} message StatusProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StatusProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a StatusProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.SalesPartnerProto.StatusProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.SalesPartnerProto.StatusProto} StatusProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StatusProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.SalesPartnerProto.StatusProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.state = reader.int32();
                                break;
                            }
                        case 2: {
                                message.stateUpdatedOn = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a StatusProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.SalesPartnerProto.StatusProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.SalesPartnerProto.StatusProto} StatusProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StatusProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StatusProto message.
                 * @function verify
                 * @memberof waiternow.common.SalesPartnerProto.StatusProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StatusProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.state != null && message.hasOwnProperty("state"))
                        switch (message.state) {
                        default:
                            return "state: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.stateUpdatedOn != null && message.hasOwnProperty("stateUpdatedOn")) {
                        var error = $root.google.protobuf.Timestamp.verify(message.stateUpdatedOn);
                        if (error)
                            return "stateUpdatedOn." + error;
                    }
                    return null;
                };

                /**
                 * Creates a StatusProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.SalesPartnerProto.StatusProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.SalesPartnerProto.StatusProto} StatusProto
                 */
                StatusProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.SalesPartnerProto.StatusProto)
                        return object;
                    var message = new $root.waiternow.common.SalesPartnerProto.StatusProto();
                    switch (object.state) {
                    default:
                        if (typeof object.state === "number") {
                            message.state = object.state;
                            break;
                        }
                        break;
                    case "STATE_UNSPECIFIED":
                    case 0:
                        message.state = 0;
                        break;
                    case "ACTIVE":
                    case 1:
                        message.state = 1;
                        break;
                    case "INACTIVE":
                    case 2:
                        message.state = 2;
                        break;
                    }
                    if (object.stateUpdatedOn != null) {
                        if (typeof object.stateUpdatedOn !== "object")
                            throw TypeError(".waiternow.common.SalesPartnerProto.StatusProto.stateUpdatedOn: object expected");
                        message.stateUpdatedOn = $root.google.protobuf.Timestamp.fromObject(object.stateUpdatedOn);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a StatusProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.SalesPartnerProto.StatusProto
                 * @static
                 * @param {waiternow.common.SalesPartnerProto.StatusProto} message StatusProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StatusProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.state = options.enums === String ? "STATE_UNSPECIFIED" : 0;
                        object.stateUpdatedOn = null;
                    }
                    if (message.state != null && message.hasOwnProperty("state"))
                        object.state = options.enums === String ? $root.waiternow.common.SalesPartnerProto.StatusProto.State[message.state] === undefined ? message.state : $root.waiternow.common.SalesPartnerProto.StatusProto.State[message.state] : message.state;
                    if (message.stateUpdatedOn != null && message.hasOwnProperty("stateUpdatedOn"))
                        object.stateUpdatedOn = $root.google.protobuf.Timestamp.toObject(message.stateUpdatedOn, options);
                    return object;
                };

                /**
                 * Converts this StatusProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.SalesPartnerProto.StatusProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StatusProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for StatusProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.SalesPartnerProto.StatusProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                StatusProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.SalesPartnerProto.StatusProto";
                };

                /**
                 * State enum.
                 * @name waiternow.common.SalesPartnerProto.StatusProto.State
                 * @enum {number}
                 * @property {number} STATE_UNSPECIFIED=0 STATE_UNSPECIFIED value
                 * @property {number} ACTIVE=1 ACTIVE value
                 * @property {number} INACTIVE=2 INACTIVE value
                 */
                StatusProto.State = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "STATE_UNSPECIFIED"] = 0;
                    values[valuesById[1] = "ACTIVE"] = 1;
                    values[valuesById[2] = "INACTIVE"] = 2;
                    return values;
                })();

                return StatusProto;
            })();

            SalesPartnerProto.SettingsProto = (function() {

                /**
                 * Properties of a SettingsProto.
                 * @memberof waiternow.common.SalesPartnerProto
                 * @interface ISettingsProto
                 * @property {string|null} [code] SettingsProto code
                 */

                /**
                 * Constructs a new SettingsProto.
                 * @memberof waiternow.common.SalesPartnerProto
                 * @classdesc Represents a SettingsProto.
                 * @implements ISettingsProto
                 * @constructor
                 * @param {waiternow.common.SalesPartnerProto.ISettingsProto=} [properties] Properties to set
                 */
                function SettingsProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SettingsProto code.
                 * @member {string} code
                 * @memberof waiternow.common.SalesPartnerProto.SettingsProto
                 * @instance
                 */
                SettingsProto.prototype.code = "";

                /**
                 * Creates a new SettingsProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.SalesPartnerProto.SettingsProto
                 * @static
                 * @param {waiternow.common.SalesPartnerProto.ISettingsProto=} [properties] Properties to set
                 * @returns {waiternow.common.SalesPartnerProto.SettingsProto} SettingsProto instance
                 */
                SettingsProto.create = function create(properties) {
                    return new SettingsProto(properties);
                };

                /**
                 * Encodes the specified SettingsProto message. Does not implicitly {@link waiternow.common.SalesPartnerProto.SettingsProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.SalesPartnerProto.SettingsProto
                 * @static
                 * @param {waiternow.common.SalesPartnerProto.ISettingsProto} message SettingsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SettingsProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.code);
                    return writer;
                };

                /**
                 * Encodes the specified SettingsProto message, length delimited. Does not implicitly {@link waiternow.common.SalesPartnerProto.SettingsProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.SalesPartnerProto.SettingsProto
                 * @static
                 * @param {waiternow.common.SalesPartnerProto.ISettingsProto} message SettingsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SettingsProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SettingsProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.SalesPartnerProto.SettingsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.SalesPartnerProto.SettingsProto} SettingsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SettingsProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.SalesPartnerProto.SettingsProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.code = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SettingsProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.SalesPartnerProto.SettingsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.SalesPartnerProto.SettingsProto} SettingsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SettingsProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SettingsProto message.
                 * @function verify
                 * @memberof waiternow.common.SalesPartnerProto.SettingsProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SettingsProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.code != null && message.hasOwnProperty("code"))
                        if (!$util.isString(message.code))
                            return "code: string expected";
                    return null;
                };

                /**
                 * Creates a SettingsProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.SalesPartnerProto.SettingsProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.SalesPartnerProto.SettingsProto} SettingsProto
                 */
                SettingsProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.SalesPartnerProto.SettingsProto)
                        return object;
                    var message = new $root.waiternow.common.SalesPartnerProto.SettingsProto();
                    if (object.code != null)
                        message.code = String(object.code);
                    return message;
                };

                /**
                 * Creates a plain object from a SettingsProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.SalesPartnerProto.SettingsProto
                 * @static
                 * @param {waiternow.common.SalesPartnerProto.SettingsProto} message SettingsProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SettingsProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.code = "";
                    if (message.code != null && message.hasOwnProperty("code"))
                        object.code = message.code;
                    return object;
                };

                /**
                 * Converts this SettingsProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.SalesPartnerProto.SettingsProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SettingsProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for SettingsProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.SalesPartnerProto.SettingsProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                SettingsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.SalesPartnerProto.SettingsProto";
                };

                return SettingsProto;
            })();

            return SalesPartnerProto;
        })();

        common.SalesPartnersProto = (function() {

            /**
             * Properties of a SalesPartnersProto.
             * @memberof waiternow.common
             * @interface ISalesPartnersProto
             * @property {Array.<waiternow.common.ISalesPartnerProto>|null} [salesPartners] SalesPartnersProto salesPartners
             * @property {string|null} [continuationToken] SalesPartnersProto continuationToken
             */

            /**
             * Constructs a new SalesPartnersProto.
             * @memberof waiternow.common
             * @classdesc Represents a SalesPartnersProto.
             * @implements ISalesPartnersProto
             * @constructor
             * @param {waiternow.common.ISalesPartnersProto=} [properties] Properties to set
             */
            function SalesPartnersProto(properties) {
                this.salesPartners = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * SalesPartnersProto salesPartners.
             * @member {Array.<waiternow.common.ISalesPartnerProto>} salesPartners
             * @memberof waiternow.common.SalesPartnersProto
             * @instance
             */
            SalesPartnersProto.prototype.salesPartners = $util.emptyArray;

            /**
             * SalesPartnersProto continuationToken.
             * @member {string} continuationToken
             * @memberof waiternow.common.SalesPartnersProto
             * @instance
             */
            SalesPartnersProto.prototype.continuationToken = "";

            /**
             * Creates a new SalesPartnersProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.SalesPartnersProto
             * @static
             * @param {waiternow.common.ISalesPartnersProto=} [properties] Properties to set
             * @returns {waiternow.common.SalesPartnersProto} SalesPartnersProto instance
             */
            SalesPartnersProto.create = function create(properties) {
                return new SalesPartnersProto(properties);
            };

            /**
             * Encodes the specified SalesPartnersProto message. Does not implicitly {@link waiternow.common.SalesPartnersProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.SalesPartnersProto
             * @static
             * @param {waiternow.common.ISalesPartnersProto} message SalesPartnersProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SalesPartnersProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.salesPartners != null && message.salesPartners.length)
                    for (var i = 0; i < message.salesPartners.length; ++i)
                        $root.waiternow.common.SalesPartnerProto.encode(message.salesPartners[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.continuationToken);
                return writer;
            };

            /**
             * Encodes the specified SalesPartnersProto message, length delimited. Does not implicitly {@link waiternow.common.SalesPartnersProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.SalesPartnersProto
             * @static
             * @param {waiternow.common.ISalesPartnersProto} message SalesPartnersProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SalesPartnersProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SalesPartnersProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.SalesPartnersProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.SalesPartnersProto} SalesPartnersProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SalesPartnersProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.SalesPartnersProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            if (!(message.salesPartners && message.salesPartners.length))
                                message.salesPartners = [];
                            message.salesPartners.push($root.waiternow.common.SalesPartnerProto.decode(reader, reader.uint32()));
                            break;
                        }
                    case 2: {
                            message.continuationToken = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SalesPartnersProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.SalesPartnersProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.SalesPartnersProto} SalesPartnersProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SalesPartnersProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SalesPartnersProto message.
             * @function verify
             * @memberof waiternow.common.SalesPartnersProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SalesPartnersProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.salesPartners != null && message.hasOwnProperty("salesPartners")) {
                    if (!Array.isArray(message.salesPartners))
                        return "salesPartners: array expected";
                    for (var i = 0; i < message.salesPartners.length; ++i) {
                        var error = $root.waiternow.common.SalesPartnerProto.verify(message.salesPartners[i]);
                        if (error)
                            return "salesPartners." + error;
                    }
                }
                if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                    if (!$util.isString(message.continuationToken))
                        return "continuationToken: string expected";
                return null;
            };

            /**
             * Creates a SalesPartnersProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.SalesPartnersProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.SalesPartnersProto} SalesPartnersProto
             */
            SalesPartnersProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.SalesPartnersProto)
                    return object;
                var message = new $root.waiternow.common.SalesPartnersProto();
                if (object.salesPartners) {
                    if (!Array.isArray(object.salesPartners))
                        throw TypeError(".waiternow.common.SalesPartnersProto.salesPartners: array expected");
                    message.salesPartners = [];
                    for (var i = 0; i < object.salesPartners.length; ++i) {
                        if (typeof object.salesPartners[i] !== "object")
                            throw TypeError(".waiternow.common.SalesPartnersProto.salesPartners: object expected");
                        message.salesPartners[i] = $root.waiternow.common.SalesPartnerProto.fromObject(object.salesPartners[i]);
                    }
                }
                if (object.continuationToken != null)
                    message.continuationToken = String(object.continuationToken);
                return message;
            };

            /**
             * Creates a plain object from a SalesPartnersProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.SalesPartnersProto
             * @static
             * @param {waiternow.common.SalesPartnersProto} message SalesPartnersProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SalesPartnersProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.salesPartners = [];
                if (options.defaults)
                    object.continuationToken = "";
                if (message.salesPartners && message.salesPartners.length) {
                    object.salesPartners = [];
                    for (var j = 0; j < message.salesPartners.length; ++j)
                        object.salesPartners[j] = $root.waiternow.common.SalesPartnerProto.toObject(message.salesPartners[j], options);
                }
                if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                    object.continuationToken = message.continuationToken;
                return object;
            };

            /**
             * Converts this SalesPartnersProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.SalesPartnersProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SalesPartnersProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for SalesPartnersProto
             * @function getTypeUrl
             * @memberof waiternow.common.SalesPartnersProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            SalesPartnersProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.SalesPartnersProto";
            };

            return SalesPartnersProto;
        })();

        common.PaycheckProto = (function() {

            /**
             * Properties of a PaycheckProto.
             * @memberof waiternow.common
             * @interface IPaycheckProto
             * @property {string|null} [id] PaycheckProto id
             * @property {google.protobuf.ITimestamp|null} [creationTime] PaycheckProto creationTime
             * @property {google.protobuf.ITimestamp|null} [lastUpdateTime] PaycheckProto lastUpdateTime
             * @property {string|null} [salesPartnerId] PaycheckProto salesPartnerId
             * @property {string|null} [salesPartnerName] PaycheckProto salesPartnerName
             * @property {waiternow.common.IDateRangeProto|null} [period] PaycheckProto period
             * @property {waiternow.common.IMoneyProto|null} [commissionPerPaidOrder] PaycheckProto commissionPerPaidOrder
             * @property {Array.<waiternow.common.PaycheckProto.ILocationCommissionProto>|null} [eligibleLocations] PaycheckProto eligibleLocations
             * @property {waiternow.common.IMoneyProto|null} [totalCommission] PaycheckProto totalCommission
             * @property {waiternow.common.PaycheckProto.IStatusProto|null} [status] PaycheckProto status
             */

            /**
             * Constructs a new PaycheckProto.
             * @memberof waiternow.common
             * @classdesc Represents a PaycheckProto.
             * @implements IPaycheckProto
             * @constructor
             * @param {waiternow.common.IPaycheckProto=} [properties] Properties to set
             */
            function PaycheckProto(properties) {
                this.eligibleLocations = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * PaycheckProto id.
             * @member {string} id
             * @memberof waiternow.common.PaycheckProto
             * @instance
             */
            PaycheckProto.prototype.id = "";

            /**
             * PaycheckProto creationTime.
             * @member {google.protobuf.ITimestamp|null|undefined} creationTime
             * @memberof waiternow.common.PaycheckProto
             * @instance
             */
            PaycheckProto.prototype.creationTime = null;

            /**
             * PaycheckProto lastUpdateTime.
             * @member {google.protobuf.ITimestamp|null|undefined} lastUpdateTime
             * @memberof waiternow.common.PaycheckProto
             * @instance
             */
            PaycheckProto.prototype.lastUpdateTime = null;

            /**
             * PaycheckProto salesPartnerId.
             * @member {string} salesPartnerId
             * @memberof waiternow.common.PaycheckProto
             * @instance
             */
            PaycheckProto.prototype.salesPartnerId = "";

            /**
             * PaycheckProto salesPartnerName.
             * @member {string} salesPartnerName
             * @memberof waiternow.common.PaycheckProto
             * @instance
             */
            PaycheckProto.prototype.salesPartnerName = "";

            /**
             * PaycheckProto period.
             * @member {waiternow.common.IDateRangeProto|null|undefined} period
             * @memberof waiternow.common.PaycheckProto
             * @instance
             */
            PaycheckProto.prototype.period = null;

            /**
             * PaycheckProto commissionPerPaidOrder.
             * @member {waiternow.common.IMoneyProto|null|undefined} commissionPerPaidOrder
             * @memberof waiternow.common.PaycheckProto
             * @instance
             */
            PaycheckProto.prototype.commissionPerPaidOrder = null;

            /**
             * PaycheckProto eligibleLocations.
             * @member {Array.<waiternow.common.PaycheckProto.ILocationCommissionProto>} eligibleLocations
             * @memberof waiternow.common.PaycheckProto
             * @instance
             */
            PaycheckProto.prototype.eligibleLocations = $util.emptyArray;

            /**
             * PaycheckProto totalCommission.
             * @member {waiternow.common.IMoneyProto|null|undefined} totalCommission
             * @memberof waiternow.common.PaycheckProto
             * @instance
             */
            PaycheckProto.prototype.totalCommission = null;

            /**
             * PaycheckProto status.
             * @member {waiternow.common.PaycheckProto.IStatusProto|null|undefined} status
             * @memberof waiternow.common.PaycheckProto
             * @instance
             */
            PaycheckProto.prototype.status = null;

            /**
             * Creates a new PaycheckProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.PaycheckProto
             * @static
             * @param {waiternow.common.IPaycheckProto=} [properties] Properties to set
             * @returns {waiternow.common.PaycheckProto} PaycheckProto instance
             */
            PaycheckProto.create = function create(properties) {
                return new PaycheckProto(properties);
            };

            /**
             * Encodes the specified PaycheckProto message. Does not implicitly {@link waiternow.common.PaycheckProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.PaycheckProto
             * @static
             * @param {waiternow.common.IPaycheckProto} message PaycheckProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PaycheckProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                if (message.creationTime != null && Object.hasOwnProperty.call(message, "creationTime"))
                    $root.google.protobuf.Timestamp.encode(message.creationTime, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                    $root.google.protobuf.Timestamp.encode(message.lastUpdateTime, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.salesPartnerId != null && Object.hasOwnProperty.call(message, "salesPartnerId"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.salesPartnerId);
                if (message.salesPartnerName != null && Object.hasOwnProperty.call(message, "salesPartnerName"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.salesPartnerName);
                if (message.period != null && Object.hasOwnProperty.call(message, "period"))
                    $root.waiternow.common.DateRangeProto.encode(message.period, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                if (message.commissionPerPaidOrder != null && Object.hasOwnProperty.call(message, "commissionPerPaidOrder"))
                    $root.waiternow.common.MoneyProto.encode(message.commissionPerPaidOrder, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                if (message.eligibleLocations != null && message.eligibleLocations.length)
                    for (var i = 0; i < message.eligibleLocations.length; ++i)
                        $root.waiternow.common.PaycheckProto.LocationCommissionProto.encode(message.eligibleLocations[i], writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                if (message.totalCommission != null && Object.hasOwnProperty.call(message, "totalCommission"))
                    $root.waiternow.common.MoneyProto.encode(message.totalCommission, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                    $root.waiternow.common.PaycheckProto.StatusProto.encode(message.status, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified PaycheckProto message, length delimited. Does not implicitly {@link waiternow.common.PaycheckProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.PaycheckProto
             * @static
             * @param {waiternow.common.IPaycheckProto} message PaycheckProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PaycheckProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a PaycheckProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.PaycheckProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.PaycheckProto} PaycheckProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PaycheckProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PaycheckProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.id = reader.string();
                            break;
                        }
                    case 2: {
                            message.creationTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 3: {
                            message.lastUpdateTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        }
                    case 4: {
                            message.salesPartnerId = reader.string();
                            break;
                        }
                    case 5: {
                            message.salesPartnerName = reader.string();
                            break;
                        }
                    case 6: {
                            message.period = $root.waiternow.common.DateRangeProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 7: {
                            message.commissionPerPaidOrder = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 8: {
                            if (!(message.eligibleLocations && message.eligibleLocations.length))
                                message.eligibleLocations = [];
                            message.eligibleLocations.push($root.waiternow.common.PaycheckProto.LocationCommissionProto.decode(reader, reader.uint32()));
                            break;
                        }
                    case 9: {
                            message.totalCommission = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                            break;
                        }
                    case 10: {
                            message.status = $root.waiternow.common.PaycheckProto.StatusProto.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a PaycheckProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.PaycheckProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.PaycheckProto} PaycheckProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PaycheckProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a PaycheckProto message.
             * @function verify
             * @memberof waiternow.common.PaycheckProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            PaycheckProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.id != null && message.hasOwnProperty("id"))
                    if (!$util.isString(message.id))
                        return "id: string expected";
                if (message.creationTime != null && message.hasOwnProperty("creationTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.creationTime);
                    if (error)
                        return "creationTime." + error;
                }
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.lastUpdateTime);
                    if (error)
                        return "lastUpdateTime." + error;
                }
                if (message.salesPartnerId != null && message.hasOwnProperty("salesPartnerId"))
                    if (!$util.isString(message.salesPartnerId))
                        return "salesPartnerId: string expected";
                if (message.salesPartnerName != null && message.hasOwnProperty("salesPartnerName"))
                    if (!$util.isString(message.salesPartnerName))
                        return "salesPartnerName: string expected";
                if (message.period != null && message.hasOwnProperty("period")) {
                    var error = $root.waiternow.common.DateRangeProto.verify(message.period);
                    if (error)
                        return "period." + error;
                }
                if (message.commissionPerPaidOrder != null && message.hasOwnProperty("commissionPerPaidOrder")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.commissionPerPaidOrder);
                    if (error)
                        return "commissionPerPaidOrder." + error;
                }
                if (message.eligibleLocations != null && message.hasOwnProperty("eligibleLocations")) {
                    if (!Array.isArray(message.eligibleLocations))
                        return "eligibleLocations: array expected";
                    for (var i = 0; i < message.eligibleLocations.length; ++i) {
                        var error = $root.waiternow.common.PaycheckProto.LocationCommissionProto.verify(message.eligibleLocations[i]);
                        if (error)
                            return "eligibleLocations." + error;
                    }
                }
                if (message.totalCommission != null && message.hasOwnProperty("totalCommission")) {
                    var error = $root.waiternow.common.MoneyProto.verify(message.totalCommission);
                    if (error)
                        return "totalCommission." + error;
                }
                if (message.status != null && message.hasOwnProperty("status")) {
                    var error = $root.waiternow.common.PaycheckProto.StatusProto.verify(message.status);
                    if (error)
                        return "status." + error;
                }
                return null;
            };

            /**
             * Creates a PaycheckProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.PaycheckProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.PaycheckProto} PaycheckProto
             */
            PaycheckProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.PaycheckProto)
                    return object;
                var message = new $root.waiternow.common.PaycheckProto();
                if (object.id != null)
                    message.id = String(object.id);
                if (object.creationTime != null) {
                    if (typeof object.creationTime !== "object")
                        throw TypeError(".waiternow.common.PaycheckProto.creationTime: object expected");
                    message.creationTime = $root.google.protobuf.Timestamp.fromObject(object.creationTime);
                }
                if (object.lastUpdateTime != null) {
                    if (typeof object.lastUpdateTime !== "object")
                        throw TypeError(".waiternow.common.PaycheckProto.lastUpdateTime: object expected");
                    message.lastUpdateTime = $root.google.protobuf.Timestamp.fromObject(object.lastUpdateTime);
                }
                if (object.salesPartnerId != null)
                    message.salesPartnerId = String(object.salesPartnerId);
                if (object.salesPartnerName != null)
                    message.salesPartnerName = String(object.salesPartnerName);
                if (object.period != null) {
                    if (typeof object.period !== "object")
                        throw TypeError(".waiternow.common.PaycheckProto.period: object expected");
                    message.period = $root.waiternow.common.DateRangeProto.fromObject(object.period);
                }
                if (object.commissionPerPaidOrder != null) {
                    if (typeof object.commissionPerPaidOrder !== "object")
                        throw TypeError(".waiternow.common.PaycheckProto.commissionPerPaidOrder: object expected");
                    message.commissionPerPaidOrder = $root.waiternow.common.MoneyProto.fromObject(object.commissionPerPaidOrder);
                }
                if (object.eligibleLocations) {
                    if (!Array.isArray(object.eligibleLocations))
                        throw TypeError(".waiternow.common.PaycheckProto.eligibleLocations: array expected");
                    message.eligibleLocations = [];
                    for (var i = 0; i < object.eligibleLocations.length; ++i) {
                        if (typeof object.eligibleLocations[i] !== "object")
                            throw TypeError(".waiternow.common.PaycheckProto.eligibleLocations: object expected");
                        message.eligibleLocations[i] = $root.waiternow.common.PaycheckProto.LocationCommissionProto.fromObject(object.eligibleLocations[i]);
                    }
                }
                if (object.totalCommission != null) {
                    if (typeof object.totalCommission !== "object")
                        throw TypeError(".waiternow.common.PaycheckProto.totalCommission: object expected");
                    message.totalCommission = $root.waiternow.common.MoneyProto.fromObject(object.totalCommission);
                }
                if (object.status != null) {
                    if (typeof object.status !== "object")
                        throw TypeError(".waiternow.common.PaycheckProto.status: object expected");
                    message.status = $root.waiternow.common.PaycheckProto.StatusProto.fromObject(object.status);
                }
                return message;
            };

            /**
             * Creates a plain object from a PaycheckProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.PaycheckProto
             * @static
             * @param {waiternow.common.PaycheckProto} message PaycheckProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            PaycheckProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.eligibleLocations = [];
                if (options.defaults) {
                    object.id = "";
                    object.creationTime = null;
                    object.lastUpdateTime = null;
                    object.salesPartnerId = "";
                    object.salesPartnerName = "";
                    object.period = null;
                    object.commissionPerPaidOrder = null;
                    object.totalCommission = null;
                    object.status = null;
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                    object.creationTime = $root.google.protobuf.Timestamp.toObject(message.creationTime, options);
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                    object.lastUpdateTime = $root.google.protobuf.Timestamp.toObject(message.lastUpdateTime, options);
                if (message.salesPartnerId != null && message.hasOwnProperty("salesPartnerId"))
                    object.salesPartnerId = message.salesPartnerId;
                if (message.salesPartnerName != null && message.hasOwnProperty("salesPartnerName"))
                    object.salesPartnerName = message.salesPartnerName;
                if (message.period != null && message.hasOwnProperty("period"))
                    object.period = $root.waiternow.common.DateRangeProto.toObject(message.period, options);
                if (message.commissionPerPaidOrder != null && message.hasOwnProperty("commissionPerPaidOrder"))
                    object.commissionPerPaidOrder = $root.waiternow.common.MoneyProto.toObject(message.commissionPerPaidOrder, options);
                if (message.eligibleLocations && message.eligibleLocations.length) {
                    object.eligibleLocations = [];
                    for (var j = 0; j < message.eligibleLocations.length; ++j)
                        object.eligibleLocations[j] = $root.waiternow.common.PaycheckProto.LocationCommissionProto.toObject(message.eligibleLocations[j], options);
                }
                if (message.totalCommission != null && message.hasOwnProperty("totalCommission"))
                    object.totalCommission = $root.waiternow.common.MoneyProto.toObject(message.totalCommission, options);
                if (message.status != null && message.hasOwnProperty("status"))
                    object.status = $root.waiternow.common.PaycheckProto.StatusProto.toObject(message.status, options);
                return object;
            };

            /**
             * Converts this PaycheckProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.PaycheckProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            PaycheckProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for PaycheckProto
             * @function getTypeUrl
             * @memberof waiternow.common.PaycheckProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            PaycheckProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.PaycheckProto";
            };

            PaycheckProto.LocationCommissionProto = (function() {

                /**
                 * Properties of a LocationCommissionProto.
                 * @memberof waiternow.common.PaycheckProto
                 * @interface ILocationCommissionProto
                 * @property {string|null} [locationId] LocationCommissionProto locationId
                 * @property {string|null} [locationName] LocationCommissionProto locationName
                 * @property {string|null} [businessName] LocationCommissionProto businessName
                 * @property {number|null} [eligibleOrders] LocationCommissionProto eligibleOrders
                 */

                /**
                 * Constructs a new LocationCommissionProto.
                 * @memberof waiternow.common.PaycheckProto
                 * @classdesc Represents a LocationCommissionProto.
                 * @implements ILocationCommissionProto
                 * @constructor
                 * @param {waiternow.common.PaycheckProto.ILocationCommissionProto=} [properties] Properties to set
                 */
                function LocationCommissionProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * LocationCommissionProto locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.PaycheckProto.LocationCommissionProto
                 * @instance
                 */
                LocationCommissionProto.prototype.locationId = "";

                /**
                 * LocationCommissionProto locationName.
                 * @member {string} locationName
                 * @memberof waiternow.common.PaycheckProto.LocationCommissionProto
                 * @instance
                 */
                LocationCommissionProto.prototype.locationName = "";

                /**
                 * LocationCommissionProto businessName.
                 * @member {string} businessName
                 * @memberof waiternow.common.PaycheckProto.LocationCommissionProto
                 * @instance
                 */
                LocationCommissionProto.prototype.businessName = "";

                /**
                 * LocationCommissionProto eligibleOrders.
                 * @member {number} eligibleOrders
                 * @memberof waiternow.common.PaycheckProto.LocationCommissionProto
                 * @instance
                 */
                LocationCommissionProto.prototype.eligibleOrders = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Creates a new LocationCommissionProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.PaycheckProto.LocationCommissionProto
                 * @static
                 * @param {waiternow.common.PaycheckProto.ILocationCommissionProto=} [properties] Properties to set
                 * @returns {waiternow.common.PaycheckProto.LocationCommissionProto} LocationCommissionProto instance
                 */
                LocationCommissionProto.create = function create(properties) {
                    return new LocationCommissionProto(properties);
                };

                /**
                 * Encodes the specified LocationCommissionProto message. Does not implicitly {@link waiternow.common.PaycheckProto.LocationCommissionProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.PaycheckProto.LocationCommissionProto
                 * @static
                 * @param {waiternow.common.PaycheckProto.ILocationCommissionProto} message LocationCommissionProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LocationCommissionProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    if (message.locationName != null && Object.hasOwnProperty.call(message, "locationName"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.locationName);
                    if (message.businessName != null && Object.hasOwnProperty.call(message, "businessName"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.businessName);
                    if (message.eligibleOrders != null && Object.hasOwnProperty.call(message, "eligibleOrders"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int64(message.eligibleOrders);
                    return writer;
                };

                /**
                 * Encodes the specified LocationCommissionProto message, length delimited. Does not implicitly {@link waiternow.common.PaycheckProto.LocationCommissionProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.PaycheckProto.LocationCommissionProto
                 * @static
                 * @param {waiternow.common.PaycheckProto.ILocationCommissionProto} message LocationCommissionProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LocationCommissionProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a LocationCommissionProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.PaycheckProto.LocationCommissionProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.PaycheckProto.LocationCommissionProto} LocationCommissionProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LocationCommissionProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PaycheckProto.LocationCommissionProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 2: {
                                message.locationName = reader.string();
                                break;
                            }
                        case 3: {
                                message.businessName = reader.string();
                                break;
                            }
                        case 4: {
                                message.eligibleOrders = reader.int64();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a LocationCommissionProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.PaycheckProto.LocationCommissionProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.PaycheckProto.LocationCommissionProto} LocationCommissionProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LocationCommissionProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a LocationCommissionProto message.
                 * @function verify
                 * @memberof waiternow.common.PaycheckProto.LocationCommissionProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                LocationCommissionProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    if (message.locationName != null && message.hasOwnProperty("locationName"))
                        if (!$util.isString(message.locationName))
                            return "locationName: string expected";
                    if (message.businessName != null && message.hasOwnProperty("businessName"))
                        if (!$util.isString(message.businessName))
                            return "businessName: string expected";
                    if (message.eligibleOrders != null && message.hasOwnProperty("eligibleOrders"))
                        if (!$util.isInteger(message.eligibleOrders) && !(message.eligibleOrders && $util.isInteger(message.eligibleOrders.low) && $util.isInteger(message.eligibleOrders.high)))
                            return "eligibleOrders: integer|Long expected";
                    return null;
                };

                /**
                 * Creates a LocationCommissionProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.PaycheckProto.LocationCommissionProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.PaycheckProto.LocationCommissionProto} LocationCommissionProto
                 */
                LocationCommissionProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.PaycheckProto.LocationCommissionProto)
                        return object;
                    var message = new $root.waiternow.common.PaycheckProto.LocationCommissionProto();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    if (object.locationName != null)
                        message.locationName = String(object.locationName);
                    if (object.businessName != null)
                        message.businessName = String(object.businessName);
                    if (object.eligibleOrders != null)
                        if ($util.Long)
                            (message.eligibleOrders = $util.Long.fromValue(object.eligibleOrders)).unsigned = false;
                        else if (typeof object.eligibleOrders === "string")
                            message.eligibleOrders = parseInt(object.eligibleOrders, 10);
                        else if (typeof object.eligibleOrders === "number")
                            message.eligibleOrders = object.eligibleOrders;
                        else if (typeof object.eligibleOrders === "object")
                            message.eligibleOrders = new $util.LongBits(object.eligibleOrders.low >>> 0, object.eligibleOrders.high >>> 0).toNumber();
                    return message;
                };

                /**
                 * Creates a plain object from a LocationCommissionProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.PaycheckProto.LocationCommissionProto
                 * @static
                 * @param {waiternow.common.PaycheckProto.LocationCommissionProto} message LocationCommissionProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                LocationCommissionProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.locationId = "";
                        object.locationName = "";
                        object.businessName = "";
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.eligibleOrders = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.eligibleOrders = options.longs === String ? "0" : 0;
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    if (message.locationName != null && message.hasOwnProperty("locationName"))
                        object.locationName = message.locationName;
                    if (message.businessName != null && message.hasOwnProperty("businessName"))
                        object.businessName = message.businessName;
                    if (message.eligibleOrders != null && message.hasOwnProperty("eligibleOrders"))
                        if (typeof message.eligibleOrders === "number")
                            object.eligibleOrders = options.longs === String ? String(message.eligibleOrders) : message.eligibleOrders;
                        else
                            object.eligibleOrders = options.longs === String ? $util.Long.prototype.toString.call(message.eligibleOrders) : options.longs === Number ? new $util.LongBits(message.eligibleOrders.low >>> 0, message.eligibleOrders.high >>> 0).toNumber() : message.eligibleOrders;
                    return object;
                };

                /**
                 * Converts this LocationCommissionProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.PaycheckProto.LocationCommissionProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                LocationCommissionProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for LocationCommissionProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.PaycheckProto.LocationCommissionProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                LocationCommissionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.PaycheckProto.LocationCommissionProto";
                };

                return LocationCommissionProto;
            })();

            PaycheckProto.StatusProto = (function() {

                /**
                 * Properties of a StatusProto.
                 * @memberof waiternow.common.PaycheckProto
                 * @interface IStatusProto
                 * @property {waiternow.common.PaycheckProto.StatusProto.State|null} [state] StatusProto state
                 * @property {google.protobuf.ITimestamp|null} [paidOn] StatusProto paidOn
                 */

                /**
                 * Constructs a new StatusProto.
                 * @memberof waiternow.common.PaycheckProto
                 * @classdesc Represents a StatusProto.
                 * @implements IStatusProto
                 * @constructor
                 * @param {waiternow.common.PaycheckProto.IStatusProto=} [properties] Properties to set
                 */
                function StatusProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StatusProto state.
                 * @member {waiternow.common.PaycheckProto.StatusProto.State} state
                 * @memberof waiternow.common.PaycheckProto.StatusProto
                 * @instance
                 */
                StatusProto.prototype.state = 0;

                /**
                 * StatusProto paidOn.
                 * @member {google.protobuf.ITimestamp|null|undefined} paidOn
                 * @memberof waiternow.common.PaycheckProto.StatusProto
                 * @instance
                 */
                StatusProto.prototype.paidOn = null;

                /**
                 * Creates a new StatusProto instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.PaycheckProto.StatusProto
                 * @static
                 * @param {waiternow.common.PaycheckProto.IStatusProto=} [properties] Properties to set
                 * @returns {waiternow.common.PaycheckProto.StatusProto} StatusProto instance
                 */
                StatusProto.create = function create(properties) {
                    return new StatusProto(properties);
                };

                /**
                 * Encodes the specified StatusProto message. Does not implicitly {@link waiternow.common.PaycheckProto.StatusProto.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.PaycheckProto.StatusProto
                 * @static
                 * @param {waiternow.common.PaycheckProto.IStatusProto} message StatusProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StatusProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.state);
                    if (message.paidOn != null && Object.hasOwnProperty.call(message, "paidOn"))
                        $root.google.protobuf.Timestamp.encode(message.paidOn, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified StatusProto message, length delimited. Does not implicitly {@link waiternow.common.PaycheckProto.StatusProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.PaycheckProto.StatusProto
                 * @static
                 * @param {waiternow.common.PaycheckProto.IStatusProto} message StatusProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StatusProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a StatusProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.PaycheckProto.StatusProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.PaycheckProto.StatusProto} StatusProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StatusProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PaycheckProto.StatusProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.state = reader.int32();
                                break;
                            }
                        case 3: {
                                message.paidOn = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a StatusProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.PaycheckProto.StatusProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.PaycheckProto.StatusProto} StatusProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StatusProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StatusProto message.
                 * @function verify
                 * @memberof waiternow.common.PaycheckProto.StatusProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StatusProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.state != null && message.hasOwnProperty("state"))
                        switch (message.state) {
                        default:
                            return "state: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                            break;
                        }
                    if (message.paidOn != null && message.hasOwnProperty("paidOn")) {
                        var error = $root.google.protobuf.Timestamp.verify(message.paidOn);
                        if (error)
                            return "paidOn." + error;
                    }
                    return null;
                };

                /**
                 * Creates a StatusProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.PaycheckProto.StatusProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.PaycheckProto.StatusProto} StatusProto
                 */
                StatusProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.PaycheckProto.StatusProto)
                        return object;
                    var message = new $root.waiternow.common.PaycheckProto.StatusProto();
                    switch (object.state) {
                    default:
                        if (typeof object.state === "number") {
                            message.state = object.state;
                            break;
                        }
                        break;
                    case "STATE_UNSPECIFIED":
                    case 0:
                        message.state = 0;
                        break;
                    case "NO_PAYMENT_REQUIRED":
                    case 1:
                        message.state = 1;
                        break;
                    case "PAYMENT_PENDING":
                    case 2:
                        message.state = 2;
                        break;
                    case "PAID":
                    case 3:
                        message.state = 3;
                        break;
                    }
                    if (object.paidOn != null) {
                        if (typeof object.paidOn !== "object")
                            throw TypeError(".waiternow.common.PaycheckProto.StatusProto.paidOn: object expected");
                        message.paidOn = $root.google.protobuf.Timestamp.fromObject(object.paidOn);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a StatusProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.PaycheckProto.StatusProto
                 * @static
                 * @param {waiternow.common.PaycheckProto.StatusProto} message StatusProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StatusProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.state = options.enums === String ? "STATE_UNSPECIFIED" : 0;
                        object.paidOn = null;
                    }
                    if (message.state != null && message.hasOwnProperty("state"))
                        object.state = options.enums === String ? $root.waiternow.common.PaycheckProto.StatusProto.State[message.state] === undefined ? message.state : $root.waiternow.common.PaycheckProto.StatusProto.State[message.state] : message.state;
                    if (message.paidOn != null && message.hasOwnProperty("paidOn"))
                        object.paidOn = $root.google.protobuf.Timestamp.toObject(message.paidOn, options);
                    return object;
                };

                /**
                 * Converts this StatusProto to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.PaycheckProto.StatusProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StatusProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for StatusProto
                 * @function getTypeUrl
                 * @memberof waiternow.common.PaycheckProto.StatusProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                StatusProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.PaycheckProto.StatusProto";
                };

                /**
                 * State enum.
                 * @name waiternow.common.PaycheckProto.StatusProto.State
                 * @enum {number}
                 * @property {number} STATE_UNSPECIFIED=0 STATE_UNSPECIFIED value
                 * @property {number} NO_PAYMENT_REQUIRED=1 NO_PAYMENT_REQUIRED value
                 * @property {number} PAYMENT_PENDING=2 PAYMENT_PENDING value
                 * @property {number} PAID=3 PAID value
                 */
                StatusProto.State = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "STATE_UNSPECIFIED"] = 0;
                    values[valuesById[1] = "NO_PAYMENT_REQUIRED"] = 1;
                    values[valuesById[2] = "PAYMENT_PENDING"] = 2;
                    values[valuesById[3] = "PAID"] = 3;
                    return values;
                })();

                return StatusProto;
            })();

            return PaycheckProto;
        })();

        common.PaychecksProto = (function() {

            /**
             * Properties of a PaychecksProto.
             * @memberof waiternow.common
             * @interface IPaychecksProto
             * @property {Array.<waiternow.common.IPaycheckProto>|null} [paychecks] PaychecksProto paychecks
             */

            /**
             * Constructs a new PaychecksProto.
             * @memberof waiternow.common
             * @classdesc Represents a PaychecksProto.
             * @implements IPaychecksProto
             * @constructor
             * @param {waiternow.common.IPaychecksProto=} [properties] Properties to set
             */
            function PaychecksProto(properties) {
                this.paychecks = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * PaychecksProto paychecks.
             * @member {Array.<waiternow.common.IPaycheckProto>} paychecks
             * @memberof waiternow.common.PaychecksProto
             * @instance
             */
            PaychecksProto.prototype.paychecks = $util.emptyArray;

            /**
             * Creates a new PaychecksProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.PaychecksProto
             * @static
             * @param {waiternow.common.IPaychecksProto=} [properties] Properties to set
             * @returns {waiternow.common.PaychecksProto} PaychecksProto instance
             */
            PaychecksProto.create = function create(properties) {
                return new PaychecksProto(properties);
            };

            /**
             * Encodes the specified PaychecksProto message. Does not implicitly {@link waiternow.common.PaychecksProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.PaychecksProto
             * @static
             * @param {waiternow.common.IPaychecksProto} message PaychecksProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PaychecksProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.paychecks != null && message.paychecks.length)
                    for (var i = 0; i < message.paychecks.length; ++i)
                        $root.waiternow.common.PaycheckProto.encode(message.paychecks[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified PaychecksProto message, length delimited. Does not implicitly {@link waiternow.common.PaychecksProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.PaychecksProto
             * @static
             * @param {waiternow.common.IPaychecksProto} message PaychecksProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PaychecksProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a PaychecksProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.PaychecksProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.PaychecksProto} PaychecksProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PaychecksProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PaychecksProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 2: {
                            if (!(message.paychecks && message.paychecks.length))
                                message.paychecks = [];
                            message.paychecks.push($root.waiternow.common.PaycheckProto.decode(reader, reader.uint32()));
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a PaychecksProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.PaychecksProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.PaychecksProto} PaychecksProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PaychecksProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a PaychecksProto message.
             * @function verify
             * @memberof waiternow.common.PaychecksProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            PaychecksProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.paychecks != null && message.hasOwnProperty("paychecks")) {
                    if (!Array.isArray(message.paychecks))
                        return "paychecks: array expected";
                    for (var i = 0; i < message.paychecks.length; ++i) {
                        var error = $root.waiternow.common.PaycheckProto.verify(message.paychecks[i]);
                        if (error)
                            return "paychecks." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a PaychecksProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.PaychecksProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.PaychecksProto} PaychecksProto
             */
            PaychecksProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.PaychecksProto)
                    return object;
                var message = new $root.waiternow.common.PaychecksProto();
                if (object.paychecks) {
                    if (!Array.isArray(object.paychecks))
                        throw TypeError(".waiternow.common.PaychecksProto.paychecks: array expected");
                    message.paychecks = [];
                    for (var i = 0; i < object.paychecks.length; ++i) {
                        if (typeof object.paychecks[i] !== "object")
                            throw TypeError(".waiternow.common.PaychecksProto.paychecks: object expected");
                        message.paychecks[i] = $root.waiternow.common.PaycheckProto.fromObject(object.paychecks[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a PaychecksProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.PaychecksProto
             * @static
             * @param {waiternow.common.PaychecksProto} message PaychecksProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            PaychecksProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.paychecks = [];
                if (message.paychecks && message.paychecks.length) {
                    object.paychecks = [];
                    for (var j = 0; j < message.paychecks.length; ++j)
                        object.paychecks[j] = $root.waiternow.common.PaycheckProto.toObject(message.paychecks[j], options);
                }
                return object;
            };

            /**
             * Converts this PaychecksProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.PaychecksProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            PaychecksProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for PaychecksProto
             * @function getTypeUrl
             * @memberof waiternow.common.PaychecksProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            PaychecksProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.PaychecksProto";
            };

            return PaychecksProto;
        })();

        common.SendEmailVerificationCodeActionProto = (function() {

            /**
             * Properties of a SendEmailVerificationCodeActionProto.
             * @memberof waiternow.common
             * @interface ISendEmailVerificationCodeActionProto
             */

            /**
             * Constructs a new SendEmailVerificationCodeActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a SendEmailVerificationCodeActionProto.
             * @implements ISendEmailVerificationCodeActionProto
             * @constructor
             * @param {waiternow.common.ISendEmailVerificationCodeActionProto=} [properties] Properties to set
             */
            function SendEmailVerificationCodeActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new SendEmailVerificationCodeActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.SendEmailVerificationCodeActionProto
             * @static
             * @param {waiternow.common.ISendEmailVerificationCodeActionProto=} [properties] Properties to set
             * @returns {waiternow.common.SendEmailVerificationCodeActionProto} SendEmailVerificationCodeActionProto instance
             */
            SendEmailVerificationCodeActionProto.create = function create(properties) {
                return new SendEmailVerificationCodeActionProto(properties);
            };

            /**
             * Encodes the specified SendEmailVerificationCodeActionProto message. Does not implicitly {@link waiternow.common.SendEmailVerificationCodeActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.SendEmailVerificationCodeActionProto
             * @static
             * @param {waiternow.common.ISendEmailVerificationCodeActionProto} message SendEmailVerificationCodeActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SendEmailVerificationCodeActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified SendEmailVerificationCodeActionProto message, length delimited. Does not implicitly {@link waiternow.common.SendEmailVerificationCodeActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.SendEmailVerificationCodeActionProto
             * @static
             * @param {waiternow.common.ISendEmailVerificationCodeActionProto} message SendEmailVerificationCodeActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SendEmailVerificationCodeActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SendEmailVerificationCodeActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.SendEmailVerificationCodeActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.SendEmailVerificationCodeActionProto} SendEmailVerificationCodeActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SendEmailVerificationCodeActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.SendEmailVerificationCodeActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SendEmailVerificationCodeActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.SendEmailVerificationCodeActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.SendEmailVerificationCodeActionProto} SendEmailVerificationCodeActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SendEmailVerificationCodeActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SendEmailVerificationCodeActionProto message.
             * @function verify
             * @memberof waiternow.common.SendEmailVerificationCodeActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SendEmailVerificationCodeActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a SendEmailVerificationCodeActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.SendEmailVerificationCodeActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.SendEmailVerificationCodeActionProto} SendEmailVerificationCodeActionProto
             */
            SendEmailVerificationCodeActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.SendEmailVerificationCodeActionProto)
                    return object;
                return new $root.waiternow.common.SendEmailVerificationCodeActionProto();
            };

            /**
             * Creates a plain object from a SendEmailVerificationCodeActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.SendEmailVerificationCodeActionProto
             * @static
             * @param {waiternow.common.SendEmailVerificationCodeActionProto} message SendEmailVerificationCodeActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SendEmailVerificationCodeActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this SendEmailVerificationCodeActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.SendEmailVerificationCodeActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SendEmailVerificationCodeActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for SendEmailVerificationCodeActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.SendEmailVerificationCodeActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            SendEmailVerificationCodeActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.SendEmailVerificationCodeActionProto";
            };

            SendEmailVerificationCodeActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.SendEmailVerificationCodeActionProto
                 * @interface IRequest
                 * @property {string|null} [email] Request email
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.SendEmailVerificationCodeActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.SendEmailVerificationCodeActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request email.
                 * @member {string} email
                 * @memberof waiternow.common.SendEmailVerificationCodeActionProto.Request
                 * @instance
                 */
                Request.prototype.email = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.SendEmailVerificationCodeActionProto.Request
                 * @static
                 * @param {waiternow.common.SendEmailVerificationCodeActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.SendEmailVerificationCodeActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.SendEmailVerificationCodeActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.SendEmailVerificationCodeActionProto.Request
                 * @static
                 * @param {waiternow.common.SendEmailVerificationCodeActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.SendEmailVerificationCodeActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.SendEmailVerificationCodeActionProto.Request
                 * @static
                 * @param {waiternow.common.SendEmailVerificationCodeActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.SendEmailVerificationCodeActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.SendEmailVerificationCodeActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.SendEmailVerificationCodeActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.email = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.SendEmailVerificationCodeActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.SendEmailVerificationCodeActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.SendEmailVerificationCodeActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.email != null && message.hasOwnProperty("email"))
                        if (!$util.isString(message.email))
                            return "email: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.SendEmailVerificationCodeActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.SendEmailVerificationCodeActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.SendEmailVerificationCodeActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.SendEmailVerificationCodeActionProto.Request();
                    if (object.email != null)
                        message.email = String(object.email);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.SendEmailVerificationCodeActionProto.Request
                 * @static
                 * @param {waiternow.common.SendEmailVerificationCodeActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.email = "";
                    if (message.email != null && message.hasOwnProperty("email"))
                        object.email = message.email;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.SendEmailVerificationCodeActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.SendEmailVerificationCodeActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.SendEmailVerificationCodeActionProto.Request";
                };

                return Request;
            })();

            SendEmailVerificationCodeActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.SendEmailVerificationCodeActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.SendEmailVerificationCodeActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.SendEmailVerificationCodeActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.SendEmailVerificationCodeActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.SendEmailVerificationCodeActionProto.Response
                 * @static
                 * @param {waiternow.common.SendEmailVerificationCodeActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.SendEmailVerificationCodeActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.SendEmailVerificationCodeActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.SendEmailVerificationCodeActionProto.Response
                 * @static
                 * @param {waiternow.common.SendEmailVerificationCodeActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.SendEmailVerificationCodeActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.SendEmailVerificationCodeActionProto.Response
                 * @static
                 * @param {waiternow.common.SendEmailVerificationCodeActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.SendEmailVerificationCodeActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.SendEmailVerificationCodeActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.SendEmailVerificationCodeActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.SendEmailVerificationCodeActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.SendEmailVerificationCodeActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.SendEmailVerificationCodeActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.SendEmailVerificationCodeActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.SendEmailVerificationCodeActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.SendEmailVerificationCodeActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.SendEmailVerificationCodeActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.SendEmailVerificationCodeActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.SendEmailVerificationCodeActionProto.Response
                 * @static
                 * @param {waiternow.common.SendEmailVerificationCodeActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.SendEmailVerificationCodeActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.SendEmailVerificationCodeActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.SendEmailVerificationCodeActionProto.Response";
                };

                return Response;
            })();

            return SendEmailVerificationCodeActionProto;
        })();

        common.ValidateEmailVerificationCodeActionProto = (function() {

            /**
             * Properties of a ValidateEmailVerificationCodeActionProto.
             * @memberof waiternow.common
             * @interface IValidateEmailVerificationCodeActionProto
             */

            /**
             * Constructs a new ValidateEmailVerificationCodeActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a ValidateEmailVerificationCodeActionProto.
             * @implements IValidateEmailVerificationCodeActionProto
             * @constructor
             * @param {waiternow.common.IValidateEmailVerificationCodeActionProto=} [properties] Properties to set
             */
            function ValidateEmailVerificationCodeActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new ValidateEmailVerificationCodeActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.ValidateEmailVerificationCodeActionProto
             * @static
             * @param {waiternow.common.IValidateEmailVerificationCodeActionProto=} [properties] Properties to set
             * @returns {waiternow.common.ValidateEmailVerificationCodeActionProto} ValidateEmailVerificationCodeActionProto instance
             */
            ValidateEmailVerificationCodeActionProto.create = function create(properties) {
                return new ValidateEmailVerificationCodeActionProto(properties);
            };

            /**
             * Encodes the specified ValidateEmailVerificationCodeActionProto message. Does not implicitly {@link waiternow.common.ValidateEmailVerificationCodeActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.ValidateEmailVerificationCodeActionProto
             * @static
             * @param {waiternow.common.IValidateEmailVerificationCodeActionProto} message ValidateEmailVerificationCodeActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ValidateEmailVerificationCodeActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified ValidateEmailVerificationCodeActionProto message, length delimited. Does not implicitly {@link waiternow.common.ValidateEmailVerificationCodeActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.ValidateEmailVerificationCodeActionProto
             * @static
             * @param {waiternow.common.IValidateEmailVerificationCodeActionProto} message ValidateEmailVerificationCodeActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ValidateEmailVerificationCodeActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ValidateEmailVerificationCodeActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.ValidateEmailVerificationCodeActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.ValidateEmailVerificationCodeActionProto} ValidateEmailVerificationCodeActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ValidateEmailVerificationCodeActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.ValidateEmailVerificationCodeActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ValidateEmailVerificationCodeActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.ValidateEmailVerificationCodeActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.ValidateEmailVerificationCodeActionProto} ValidateEmailVerificationCodeActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ValidateEmailVerificationCodeActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ValidateEmailVerificationCodeActionProto message.
             * @function verify
             * @memberof waiternow.common.ValidateEmailVerificationCodeActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ValidateEmailVerificationCodeActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a ValidateEmailVerificationCodeActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.ValidateEmailVerificationCodeActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.ValidateEmailVerificationCodeActionProto} ValidateEmailVerificationCodeActionProto
             */
            ValidateEmailVerificationCodeActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.ValidateEmailVerificationCodeActionProto)
                    return object;
                return new $root.waiternow.common.ValidateEmailVerificationCodeActionProto();
            };

            /**
             * Creates a plain object from a ValidateEmailVerificationCodeActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.ValidateEmailVerificationCodeActionProto
             * @static
             * @param {waiternow.common.ValidateEmailVerificationCodeActionProto} message ValidateEmailVerificationCodeActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ValidateEmailVerificationCodeActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this ValidateEmailVerificationCodeActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.ValidateEmailVerificationCodeActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ValidateEmailVerificationCodeActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for ValidateEmailVerificationCodeActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.ValidateEmailVerificationCodeActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            ValidateEmailVerificationCodeActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.ValidateEmailVerificationCodeActionProto";
            };

            ValidateEmailVerificationCodeActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.ValidateEmailVerificationCodeActionProto
                 * @interface IRequest
                 * @property {string|null} [email] Request email
                 * @property {string|null} [verificationCode] Request verificationCode
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.ValidateEmailVerificationCodeActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.ValidateEmailVerificationCodeActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request email.
                 * @member {string} email
                 * @memberof waiternow.common.ValidateEmailVerificationCodeActionProto.Request
                 * @instance
                 */
                Request.prototype.email = "";

                /**
                 * Request verificationCode.
                 * @member {string} verificationCode
                 * @memberof waiternow.common.ValidateEmailVerificationCodeActionProto.Request
                 * @instance
                 */
                Request.prototype.verificationCode = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.ValidateEmailVerificationCodeActionProto.Request
                 * @static
                 * @param {waiternow.common.ValidateEmailVerificationCodeActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.ValidateEmailVerificationCodeActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.ValidateEmailVerificationCodeActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.ValidateEmailVerificationCodeActionProto.Request
                 * @static
                 * @param {waiternow.common.ValidateEmailVerificationCodeActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
                    if (message.verificationCode != null && Object.hasOwnProperty.call(message, "verificationCode"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.verificationCode);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.ValidateEmailVerificationCodeActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.ValidateEmailVerificationCodeActionProto.Request
                 * @static
                 * @param {waiternow.common.ValidateEmailVerificationCodeActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.ValidateEmailVerificationCodeActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.ValidateEmailVerificationCodeActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.ValidateEmailVerificationCodeActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.email = reader.string();
                                break;
                            }
                        case 2: {
                                message.verificationCode = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.ValidateEmailVerificationCodeActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.ValidateEmailVerificationCodeActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.ValidateEmailVerificationCodeActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.email != null && message.hasOwnProperty("email"))
                        if (!$util.isString(message.email))
                            return "email: string expected";
                    if (message.verificationCode != null && message.hasOwnProperty("verificationCode"))
                        if (!$util.isString(message.verificationCode))
                            return "verificationCode: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.ValidateEmailVerificationCodeActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.ValidateEmailVerificationCodeActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.ValidateEmailVerificationCodeActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.ValidateEmailVerificationCodeActionProto.Request();
                    if (object.email != null)
                        message.email = String(object.email);
                    if (object.verificationCode != null)
                        message.verificationCode = String(object.verificationCode);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.ValidateEmailVerificationCodeActionProto.Request
                 * @static
                 * @param {waiternow.common.ValidateEmailVerificationCodeActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.email = "";
                        object.verificationCode = "";
                    }
                    if (message.email != null && message.hasOwnProperty("email"))
                        object.email = message.email;
                    if (message.verificationCode != null && message.hasOwnProperty("verificationCode"))
                        object.verificationCode = message.verificationCode;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.ValidateEmailVerificationCodeActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.ValidateEmailVerificationCodeActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.ValidateEmailVerificationCodeActionProto.Request";
                };

                return Request;
            })();

            ValidateEmailVerificationCodeActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.ValidateEmailVerificationCodeActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {boolean|null} [isVerificationCodeValid] Response isVerificationCodeValid
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.ValidateEmailVerificationCodeActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.ValidateEmailVerificationCodeActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.ValidateEmailVerificationCodeActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response isVerificationCodeValid.
                 * @member {boolean} isVerificationCodeValid
                 * @memberof waiternow.common.ValidateEmailVerificationCodeActionProto.Response
                 * @instance
                 */
                Response.prototype.isVerificationCodeValid = false;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.ValidateEmailVerificationCodeActionProto.Response
                 * @static
                 * @param {waiternow.common.ValidateEmailVerificationCodeActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.ValidateEmailVerificationCodeActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.ValidateEmailVerificationCodeActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.ValidateEmailVerificationCodeActionProto.Response
                 * @static
                 * @param {waiternow.common.ValidateEmailVerificationCodeActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.isVerificationCodeValid != null && Object.hasOwnProperty.call(message, "isVerificationCodeValid"))
                        writer.uint32(/* id 2, wireType 0 =*/16).bool(message.isVerificationCodeValid);
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.ValidateEmailVerificationCodeActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.ValidateEmailVerificationCodeActionProto.Response
                 * @static
                 * @param {waiternow.common.ValidateEmailVerificationCodeActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.ValidateEmailVerificationCodeActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.ValidateEmailVerificationCodeActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.ValidateEmailVerificationCodeActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.isVerificationCodeValid = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.ValidateEmailVerificationCodeActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.ValidateEmailVerificationCodeActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.ValidateEmailVerificationCodeActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.isVerificationCodeValid != null && message.hasOwnProperty("isVerificationCodeValid"))
                        if (typeof message.isVerificationCodeValid !== "boolean")
                            return "isVerificationCodeValid: boolean expected";
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.ValidateEmailVerificationCodeActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.ValidateEmailVerificationCodeActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.ValidateEmailVerificationCodeActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.ValidateEmailVerificationCodeActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.ValidateEmailVerificationCodeActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.isVerificationCodeValid != null)
                        message.isVerificationCodeValid = Boolean(object.isVerificationCodeValid);
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.ValidateEmailVerificationCodeActionProto.Response
                 * @static
                 * @param {waiternow.common.ValidateEmailVerificationCodeActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.isVerificationCodeValid = false;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.isVerificationCodeValid != null && message.hasOwnProperty("isVerificationCodeValid"))
                        object.isVerificationCodeValid = message.isVerificationCodeValid;
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.ValidateEmailVerificationCodeActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.ValidateEmailVerificationCodeActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.ValidateEmailVerificationCodeActionProto.Response";
                };

                return Response;
            })();

            return ValidateEmailVerificationCodeActionProto;
        })();

        common.SendPhoneNumberVerificationCodeActionProto = (function() {

            /**
             * Properties of a SendPhoneNumberVerificationCodeActionProto.
             * @memberof waiternow.common
             * @interface ISendPhoneNumberVerificationCodeActionProto
             */

            /**
             * Constructs a new SendPhoneNumberVerificationCodeActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a SendPhoneNumberVerificationCodeActionProto.
             * @implements ISendPhoneNumberVerificationCodeActionProto
             * @constructor
             * @param {waiternow.common.ISendPhoneNumberVerificationCodeActionProto=} [properties] Properties to set
             */
            function SendPhoneNumberVerificationCodeActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new SendPhoneNumberVerificationCodeActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.SendPhoneNumberVerificationCodeActionProto
             * @static
             * @param {waiternow.common.ISendPhoneNumberVerificationCodeActionProto=} [properties] Properties to set
             * @returns {waiternow.common.SendPhoneNumberVerificationCodeActionProto} SendPhoneNumberVerificationCodeActionProto instance
             */
            SendPhoneNumberVerificationCodeActionProto.create = function create(properties) {
                return new SendPhoneNumberVerificationCodeActionProto(properties);
            };

            /**
             * Encodes the specified SendPhoneNumberVerificationCodeActionProto message. Does not implicitly {@link waiternow.common.SendPhoneNumberVerificationCodeActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.SendPhoneNumberVerificationCodeActionProto
             * @static
             * @param {waiternow.common.ISendPhoneNumberVerificationCodeActionProto} message SendPhoneNumberVerificationCodeActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SendPhoneNumberVerificationCodeActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified SendPhoneNumberVerificationCodeActionProto message, length delimited. Does not implicitly {@link waiternow.common.SendPhoneNumberVerificationCodeActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.SendPhoneNumberVerificationCodeActionProto
             * @static
             * @param {waiternow.common.ISendPhoneNumberVerificationCodeActionProto} message SendPhoneNumberVerificationCodeActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SendPhoneNumberVerificationCodeActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SendPhoneNumberVerificationCodeActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.SendPhoneNumberVerificationCodeActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.SendPhoneNumberVerificationCodeActionProto} SendPhoneNumberVerificationCodeActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SendPhoneNumberVerificationCodeActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.SendPhoneNumberVerificationCodeActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SendPhoneNumberVerificationCodeActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.SendPhoneNumberVerificationCodeActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.SendPhoneNumberVerificationCodeActionProto} SendPhoneNumberVerificationCodeActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SendPhoneNumberVerificationCodeActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SendPhoneNumberVerificationCodeActionProto message.
             * @function verify
             * @memberof waiternow.common.SendPhoneNumberVerificationCodeActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SendPhoneNumberVerificationCodeActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a SendPhoneNumberVerificationCodeActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.SendPhoneNumberVerificationCodeActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.SendPhoneNumberVerificationCodeActionProto} SendPhoneNumberVerificationCodeActionProto
             */
            SendPhoneNumberVerificationCodeActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.SendPhoneNumberVerificationCodeActionProto)
                    return object;
                return new $root.waiternow.common.SendPhoneNumberVerificationCodeActionProto();
            };

            /**
             * Creates a plain object from a SendPhoneNumberVerificationCodeActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.SendPhoneNumberVerificationCodeActionProto
             * @static
             * @param {waiternow.common.SendPhoneNumberVerificationCodeActionProto} message SendPhoneNumberVerificationCodeActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SendPhoneNumberVerificationCodeActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this SendPhoneNumberVerificationCodeActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.SendPhoneNumberVerificationCodeActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SendPhoneNumberVerificationCodeActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for SendPhoneNumberVerificationCodeActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.SendPhoneNumberVerificationCodeActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            SendPhoneNumberVerificationCodeActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.SendPhoneNumberVerificationCodeActionProto";
            };

            SendPhoneNumberVerificationCodeActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.SendPhoneNumberVerificationCodeActionProto
                 * @interface IRequest
                 * @property {waiternow.common.IPhoneNumberProto|null} [phoneNumber] Request phoneNumber
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.SendPhoneNumberVerificationCodeActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.SendPhoneNumberVerificationCodeActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request phoneNumber.
                 * @member {waiternow.common.IPhoneNumberProto|null|undefined} phoneNumber
                 * @memberof waiternow.common.SendPhoneNumberVerificationCodeActionProto.Request
                 * @instance
                 */
                Request.prototype.phoneNumber = null;

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.SendPhoneNumberVerificationCodeActionProto.Request
                 * @static
                 * @param {waiternow.common.SendPhoneNumberVerificationCodeActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.SendPhoneNumberVerificationCodeActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.SendPhoneNumberVerificationCodeActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.SendPhoneNumberVerificationCodeActionProto.Request
                 * @static
                 * @param {waiternow.common.SendPhoneNumberVerificationCodeActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.phoneNumber != null && Object.hasOwnProperty.call(message, "phoneNumber"))
                        $root.waiternow.common.PhoneNumberProto.encode(message.phoneNumber, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.SendPhoneNumberVerificationCodeActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.SendPhoneNumberVerificationCodeActionProto.Request
                 * @static
                 * @param {waiternow.common.SendPhoneNumberVerificationCodeActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.SendPhoneNumberVerificationCodeActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.SendPhoneNumberVerificationCodeActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.SendPhoneNumberVerificationCodeActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.phoneNumber = $root.waiternow.common.PhoneNumberProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.SendPhoneNumberVerificationCodeActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.SendPhoneNumberVerificationCodeActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.SendPhoneNumberVerificationCodeActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber")) {
                        var error = $root.waiternow.common.PhoneNumberProto.verify(message.phoneNumber);
                        if (error)
                            return "phoneNumber." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.SendPhoneNumberVerificationCodeActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.SendPhoneNumberVerificationCodeActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.SendPhoneNumberVerificationCodeActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.SendPhoneNumberVerificationCodeActionProto.Request();
                    if (object.phoneNumber != null) {
                        if (typeof object.phoneNumber !== "object")
                            throw TypeError(".waiternow.common.SendPhoneNumberVerificationCodeActionProto.Request.phoneNumber: object expected");
                        message.phoneNumber = $root.waiternow.common.PhoneNumberProto.fromObject(object.phoneNumber);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.SendPhoneNumberVerificationCodeActionProto.Request
                 * @static
                 * @param {waiternow.common.SendPhoneNumberVerificationCodeActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.phoneNumber = null;
                    if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
                        object.phoneNumber = $root.waiternow.common.PhoneNumberProto.toObject(message.phoneNumber, options);
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.SendPhoneNumberVerificationCodeActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.SendPhoneNumberVerificationCodeActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.SendPhoneNumberVerificationCodeActionProto.Request";
                };

                return Request;
            })();

            SendPhoneNumberVerificationCodeActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.SendPhoneNumberVerificationCodeActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.SendPhoneNumberVerificationCodeActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.SendPhoneNumberVerificationCodeActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.SendPhoneNumberVerificationCodeActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.SendPhoneNumberVerificationCodeActionProto.Response
                 * @static
                 * @param {waiternow.common.SendPhoneNumberVerificationCodeActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.SendPhoneNumberVerificationCodeActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.SendPhoneNumberVerificationCodeActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.SendPhoneNumberVerificationCodeActionProto.Response
                 * @static
                 * @param {waiternow.common.SendPhoneNumberVerificationCodeActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.SendPhoneNumberVerificationCodeActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.SendPhoneNumberVerificationCodeActionProto.Response
                 * @static
                 * @param {waiternow.common.SendPhoneNumberVerificationCodeActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.SendPhoneNumberVerificationCodeActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.SendPhoneNumberVerificationCodeActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.SendPhoneNumberVerificationCodeActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.SendPhoneNumberVerificationCodeActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.SendPhoneNumberVerificationCodeActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.SendPhoneNumberVerificationCodeActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.SendPhoneNumberVerificationCodeActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.SendPhoneNumberVerificationCodeActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.SendPhoneNumberVerificationCodeActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.SendPhoneNumberVerificationCodeActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.SendPhoneNumberVerificationCodeActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.SendPhoneNumberVerificationCodeActionProto.Response
                 * @static
                 * @param {waiternow.common.SendPhoneNumberVerificationCodeActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.SendPhoneNumberVerificationCodeActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.SendPhoneNumberVerificationCodeActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.SendPhoneNumberVerificationCodeActionProto.Response";
                };

                return Response;
            })();

            return SendPhoneNumberVerificationCodeActionProto;
        })();

        common.ValidatePhoneNumberVerificationCodeActionProto = (function() {

            /**
             * Properties of a ValidatePhoneNumberVerificationCodeActionProto.
             * @memberof waiternow.common
             * @interface IValidatePhoneNumberVerificationCodeActionProto
             */

            /**
             * Constructs a new ValidatePhoneNumberVerificationCodeActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a ValidatePhoneNumberVerificationCodeActionProto.
             * @implements IValidatePhoneNumberVerificationCodeActionProto
             * @constructor
             * @param {waiternow.common.IValidatePhoneNumberVerificationCodeActionProto=} [properties] Properties to set
             */
            function ValidatePhoneNumberVerificationCodeActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new ValidatePhoneNumberVerificationCodeActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.ValidatePhoneNumberVerificationCodeActionProto
             * @static
             * @param {waiternow.common.IValidatePhoneNumberVerificationCodeActionProto=} [properties] Properties to set
             * @returns {waiternow.common.ValidatePhoneNumberVerificationCodeActionProto} ValidatePhoneNumberVerificationCodeActionProto instance
             */
            ValidatePhoneNumberVerificationCodeActionProto.create = function create(properties) {
                return new ValidatePhoneNumberVerificationCodeActionProto(properties);
            };

            /**
             * Encodes the specified ValidatePhoneNumberVerificationCodeActionProto message. Does not implicitly {@link waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.ValidatePhoneNumberVerificationCodeActionProto
             * @static
             * @param {waiternow.common.IValidatePhoneNumberVerificationCodeActionProto} message ValidatePhoneNumberVerificationCodeActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ValidatePhoneNumberVerificationCodeActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified ValidatePhoneNumberVerificationCodeActionProto message, length delimited. Does not implicitly {@link waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.ValidatePhoneNumberVerificationCodeActionProto
             * @static
             * @param {waiternow.common.IValidatePhoneNumberVerificationCodeActionProto} message ValidatePhoneNumberVerificationCodeActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ValidatePhoneNumberVerificationCodeActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ValidatePhoneNumberVerificationCodeActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.ValidatePhoneNumberVerificationCodeActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.ValidatePhoneNumberVerificationCodeActionProto} ValidatePhoneNumberVerificationCodeActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ValidatePhoneNumberVerificationCodeActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.ValidatePhoneNumberVerificationCodeActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ValidatePhoneNumberVerificationCodeActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.ValidatePhoneNumberVerificationCodeActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.ValidatePhoneNumberVerificationCodeActionProto} ValidatePhoneNumberVerificationCodeActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ValidatePhoneNumberVerificationCodeActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ValidatePhoneNumberVerificationCodeActionProto message.
             * @function verify
             * @memberof waiternow.common.ValidatePhoneNumberVerificationCodeActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ValidatePhoneNumberVerificationCodeActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a ValidatePhoneNumberVerificationCodeActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.ValidatePhoneNumberVerificationCodeActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.ValidatePhoneNumberVerificationCodeActionProto} ValidatePhoneNumberVerificationCodeActionProto
             */
            ValidatePhoneNumberVerificationCodeActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.ValidatePhoneNumberVerificationCodeActionProto)
                    return object;
                return new $root.waiternow.common.ValidatePhoneNumberVerificationCodeActionProto();
            };

            /**
             * Creates a plain object from a ValidatePhoneNumberVerificationCodeActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.ValidatePhoneNumberVerificationCodeActionProto
             * @static
             * @param {waiternow.common.ValidatePhoneNumberVerificationCodeActionProto} message ValidatePhoneNumberVerificationCodeActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ValidatePhoneNumberVerificationCodeActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this ValidatePhoneNumberVerificationCodeActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.ValidatePhoneNumberVerificationCodeActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ValidatePhoneNumberVerificationCodeActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for ValidatePhoneNumberVerificationCodeActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.ValidatePhoneNumberVerificationCodeActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            ValidatePhoneNumberVerificationCodeActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.ValidatePhoneNumberVerificationCodeActionProto";
            };

            ValidatePhoneNumberVerificationCodeActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.ValidatePhoneNumberVerificationCodeActionProto
                 * @interface IRequest
                 * @property {waiternow.common.IPhoneNumberProto|null} [phoneNumber] Request phoneNumber
                 * @property {string|null} [verificationCode] Request verificationCode
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.ValidatePhoneNumberVerificationCodeActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request phoneNumber.
                 * @member {waiternow.common.IPhoneNumberProto|null|undefined} phoneNumber
                 * @memberof waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.Request
                 * @instance
                 */
                Request.prototype.phoneNumber = null;

                /**
                 * Request verificationCode.
                 * @member {string} verificationCode
                 * @memberof waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.Request
                 * @instance
                 */
                Request.prototype.verificationCode = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.Request
                 * @static
                 * @param {waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.Request
                 * @static
                 * @param {waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.phoneNumber != null && Object.hasOwnProperty.call(message, "phoneNumber"))
                        $root.waiternow.common.PhoneNumberProto.encode(message.phoneNumber, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.verificationCode != null && Object.hasOwnProperty.call(message, "verificationCode"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.verificationCode);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.Request
                 * @static
                 * @param {waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.phoneNumber = $root.waiternow.common.PhoneNumberProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.verificationCode = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber")) {
                        var error = $root.waiternow.common.PhoneNumberProto.verify(message.phoneNumber);
                        if (error)
                            return "phoneNumber." + error;
                    }
                    if (message.verificationCode != null && message.hasOwnProperty("verificationCode"))
                        if (!$util.isString(message.verificationCode))
                            return "verificationCode: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.Request();
                    if (object.phoneNumber != null) {
                        if (typeof object.phoneNumber !== "object")
                            throw TypeError(".waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.Request.phoneNumber: object expected");
                        message.phoneNumber = $root.waiternow.common.PhoneNumberProto.fromObject(object.phoneNumber);
                    }
                    if (object.verificationCode != null)
                        message.verificationCode = String(object.verificationCode);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.Request
                 * @static
                 * @param {waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.phoneNumber = null;
                        object.verificationCode = "";
                    }
                    if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
                        object.phoneNumber = $root.waiternow.common.PhoneNumberProto.toObject(message.phoneNumber, options);
                    if (message.verificationCode != null && message.hasOwnProperty("verificationCode"))
                        object.verificationCode = message.verificationCode;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.Request";
                };

                return Request;
            })();

            ValidatePhoneNumberVerificationCodeActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.ValidatePhoneNumberVerificationCodeActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {boolean|null} [isVerificationCodeValid] Response isVerificationCodeValid
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.ValidatePhoneNumberVerificationCodeActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response isVerificationCodeValid.
                 * @member {boolean} isVerificationCodeValid
                 * @memberof waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.Response
                 * @instance
                 */
                Response.prototype.isVerificationCodeValid = false;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.Response
                 * @static
                 * @param {waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.Response
                 * @static
                 * @param {waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.isVerificationCodeValid != null && Object.hasOwnProperty.call(message, "isVerificationCodeValid"))
                        writer.uint32(/* id 2, wireType 0 =*/16).bool(message.isVerificationCodeValid);
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.Response
                 * @static
                 * @param {waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.isVerificationCodeValid = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.isVerificationCodeValid != null && message.hasOwnProperty("isVerificationCodeValid"))
                        if (typeof message.isVerificationCodeValid !== "boolean")
                            return "isVerificationCodeValid: boolean expected";
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.isVerificationCodeValid != null)
                        message.isVerificationCodeValid = Boolean(object.isVerificationCodeValid);
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.Response
                 * @static
                 * @param {waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.isVerificationCodeValid = false;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.isVerificationCodeValid != null && message.hasOwnProperty("isVerificationCodeValid"))
                        object.isVerificationCodeValid = message.isVerificationCodeValid;
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.ValidatePhoneNumberVerificationCodeActionProto.Response";
                };

                return Response;
            })();

            return ValidatePhoneNumberVerificationCodeActionProto;
        })();

        common.SignUpActionProto = (function() {

            /**
             * Properties of a SignUpActionProto.
             * @memberof waiternow.common
             * @interface ISignUpActionProto
             */

            /**
             * Constructs a new SignUpActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a SignUpActionProto.
             * @implements ISignUpActionProto
             * @constructor
             * @param {waiternow.common.ISignUpActionProto=} [properties] Properties to set
             */
            function SignUpActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new SignUpActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.SignUpActionProto
             * @static
             * @param {waiternow.common.ISignUpActionProto=} [properties] Properties to set
             * @returns {waiternow.common.SignUpActionProto} SignUpActionProto instance
             */
            SignUpActionProto.create = function create(properties) {
                return new SignUpActionProto(properties);
            };

            /**
             * Encodes the specified SignUpActionProto message. Does not implicitly {@link waiternow.common.SignUpActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.SignUpActionProto
             * @static
             * @param {waiternow.common.ISignUpActionProto} message SignUpActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SignUpActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified SignUpActionProto message, length delimited. Does not implicitly {@link waiternow.common.SignUpActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.SignUpActionProto
             * @static
             * @param {waiternow.common.ISignUpActionProto} message SignUpActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SignUpActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SignUpActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.SignUpActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.SignUpActionProto} SignUpActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SignUpActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.SignUpActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SignUpActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.SignUpActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.SignUpActionProto} SignUpActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SignUpActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SignUpActionProto message.
             * @function verify
             * @memberof waiternow.common.SignUpActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SignUpActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a SignUpActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.SignUpActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.SignUpActionProto} SignUpActionProto
             */
            SignUpActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.SignUpActionProto)
                    return object;
                return new $root.waiternow.common.SignUpActionProto();
            };

            /**
             * Creates a plain object from a SignUpActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.SignUpActionProto
             * @static
             * @param {waiternow.common.SignUpActionProto} message SignUpActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SignUpActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this SignUpActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.SignUpActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SignUpActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for SignUpActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.SignUpActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            SignUpActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.SignUpActionProto";
            };

            SignUpActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.SignUpActionProto
                 * @interface IRequest
                 * @property {waiternow.common.IUserProto|null} [user] Request user
                 * @property {string|null} [password] Request password
                 * @property {string|null} [emailVerificationCode] Request emailVerificationCode
                 * @property {string|null} [phoneNumberVerificationCode] Request phoneNumberVerificationCode
                 * @property {string|null} [devAuthorizationCode] Request devAuthorizationCode
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.SignUpActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.SignUpActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request user.
                 * @member {waiternow.common.IUserProto|null|undefined} user
                 * @memberof waiternow.common.SignUpActionProto.Request
                 * @instance
                 */
                Request.prototype.user = null;

                /**
                 * Request password.
                 * @member {string} password
                 * @memberof waiternow.common.SignUpActionProto.Request
                 * @instance
                 */
                Request.prototype.password = "";

                /**
                 * Request emailVerificationCode.
                 * @member {string} emailVerificationCode
                 * @memberof waiternow.common.SignUpActionProto.Request
                 * @instance
                 */
                Request.prototype.emailVerificationCode = "";

                /**
                 * Request phoneNumberVerificationCode.
                 * @member {string} phoneNumberVerificationCode
                 * @memberof waiternow.common.SignUpActionProto.Request
                 * @instance
                 */
                Request.prototype.phoneNumberVerificationCode = "";

                /**
                 * Request devAuthorizationCode.
                 * @member {string} devAuthorizationCode
                 * @memberof waiternow.common.SignUpActionProto.Request
                 * @instance
                 */
                Request.prototype.devAuthorizationCode = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.SignUpActionProto.Request
                 * @static
                 * @param {waiternow.common.SignUpActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.SignUpActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.SignUpActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.SignUpActionProto.Request
                 * @static
                 * @param {waiternow.common.SignUpActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.user != null && Object.hasOwnProperty.call(message, "user"))
                        $root.waiternow.common.UserProto.encode(message.user, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.devAuthorizationCode != null && Object.hasOwnProperty.call(message, "devAuthorizationCode"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.devAuthorizationCode);
                    if (message.password != null && Object.hasOwnProperty.call(message, "password"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.password);
                    if (message.emailVerificationCode != null && Object.hasOwnProperty.call(message, "emailVerificationCode"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.emailVerificationCode);
                    if (message.phoneNumberVerificationCode != null && Object.hasOwnProperty.call(message, "phoneNumberVerificationCode"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.phoneNumberVerificationCode);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.SignUpActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.SignUpActionProto.Request
                 * @static
                 * @param {waiternow.common.SignUpActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.SignUpActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.SignUpActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.SignUpActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.user = $root.waiternow.common.UserProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.password = reader.string();
                                break;
                            }
                        case 4: {
                                message.emailVerificationCode = reader.string();
                                break;
                            }
                        case 5: {
                                message.phoneNumberVerificationCode = reader.string();
                                break;
                            }
                        case 2: {
                                message.devAuthorizationCode = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.SignUpActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.SignUpActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.SignUpActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.user != null && message.hasOwnProperty("user")) {
                        var error = $root.waiternow.common.UserProto.verify(message.user);
                        if (error)
                            return "user." + error;
                    }
                    if (message.password != null && message.hasOwnProperty("password"))
                        if (!$util.isString(message.password))
                            return "password: string expected";
                    if (message.emailVerificationCode != null && message.hasOwnProperty("emailVerificationCode"))
                        if (!$util.isString(message.emailVerificationCode))
                            return "emailVerificationCode: string expected";
                    if (message.phoneNumberVerificationCode != null && message.hasOwnProperty("phoneNumberVerificationCode"))
                        if (!$util.isString(message.phoneNumberVerificationCode))
                            return "phoneNumberVerificationCode: string expected";
                    if (message.devAuthorizationCode != null && message.hasOwnProperty("devAuthorizationCode"))
                        if (!$util.isString(message.devAuthorizationCode))
                            return "devAuthorizationCode: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.SignUpActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.SignUpActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.SignUpActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.SignUpActionProto.Request();
                    if (object.user != null) {
                        if (typeof object.user !== "object")
                            throw TypeError(".waiternow.common.SignUpActionProto.Request.user: object expected");
                        message.user = $root.waiternow.common.UserProto.fromObject(object.user);
                    }
                    if (object.password != null)
                        message.password = String(object.password);
                    if (object.emailVerificationCode != null)
                        message.emailVerificationCode = String(object.emailVerificationCode);
                    if (object.phoneNumberVerificationCode != null)
                        message.phoneNumberVerificationCode = String(object.phoneNumberVerificationCode);
                    if (object.devAuthorizationCode != null)
                        message.devAuthorizationCode = String(object.devAuthorizationCode);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.SignUpActionProto.Request
                 * @static
                 * @param {waiternow.common.SignUpActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.user = null;
                        object.devAuthorizationCode = "";
                        object.password = "";
                        object.emailVerificationCode = "";
                        object.phoneNumberVerificationCode = "";
                    }
                    if (message.user != null && message.hasOwnProperty("user"))
                        object.user = $root.waiternow.common.UserProto.toObject(message.user, options);
                    if (message.devAuthorizationCode != null && message.hasOwnProperty("devAuthorizationCode"))
                        object.devAuthorizationCode = message.devAuthorizationCode;
                    if (message.password != null && message.hasOwnProperty("password"))
                        object.password = message.password;
                    if (message.emailVerificationCode != null && message.hasOwnProperty("emailVerificationCode"))
                        object.emailVerificationCode = message.emailVerificationCode;
                    if (message.phoneNumberVerificationCode != null && message.hasOwnProperty("phoneNumberVerificationCode"))
                        object.phoneNumberVerificationCode = message.phoneNumberVerificationCode;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.SignUpActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.SignUpActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.SignUpActionProto.Request";
                };

                return Request;
            })();

            SignUpActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.SignUpActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {string|null} [authToken] Response authToken
                 * @property {google.protobuf.IDuration|null} [authTokenExpiration] Response authTokenExpiration
                 * @property {string|null} [userId] Response userId
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.SignUpActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.SignUpActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.SignUpActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response authToken.
                 * @member {string} authToken
                 * @memberof waiternow.common.SignUpActionProto.Response
                 * @instance
                 */
                Response.prototype.authToken = "";

                /**
                 * Response authTokenExpiration.
                 * @member {google.protobuf.IDuration|null|undefined} authTokenExpiration
                 * @memberof waiternow.common.SignUpActionProto.Response
                 * @instance
                 */
                Response.prototype.authTokenExpiration = null;

                /**
                 * Response userId.
                 * @member {string} userId
                 * @memberof waiternow.common.SignUpActionProto.Response
                 * @instance
                 */
                Response.prototype.userId = "";

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.SignUpActionProto.Response
                 * @static
                 * @param {waiternow.common.SignUpActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.SignUpActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.SignUpActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.SignUpActionProto.Response
                 * @static
                 * @param {waiternow.common.SignUpActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.authToken != null && Object.hasOwnProperty.call(message, "authToken"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.authToken);
                    if (message.authTokenExpiration != null && Object.hasOwnProperty.call(message, "authTokenExpiration"))
                        $root.google.protobuf.Duration.encode(message.authTokenExpiration, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.userId);
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.SignUpActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.SignUpActionProto.Response
                 * @static
                 * @param {waiternow.common.SignUpActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.SignUpActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.SignUpActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.SignUpActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.authToken = reader.string();
                                break;
                            }
                        case 3: {
                                message.authTokenExpiration = $root.google.protobuf.Duration.decode(reader, reader.uint32());
                                break;
                            }
                        case 4: {
                                message.userId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.SignUpActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.SignUpActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.SignUpActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.authToken != null && message.hasOwnProperty("authToken"))
                        if (!$util.isString(message.authToken))
                            return "authToken: string expected";
                    if (message.authTokenExpiration != null && message.hasOwnProperty("authTokenExpiration")) {
                        var error = $root.google.protobuf.Duration.verify(message.authTokenExpiration);
                        if (error)
                            return "authTokenExpiration." + error;
                    }
                    if (message.userId != null && message.hasOwnProperty("userId"))
                        if (!$util.isString(message.userId))
                            return "userId: string expected";
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.SignUpActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.SignUpActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.SignUpActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.SignUpActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.SignUpActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.authToken != null)
                        message.authToken = String(object.authToken);
                    if (object.authTokenExpiration != null) {
                        if (typeof object.authTokenExpiration !== "object")
                            throw TypeError(".waiternow.common.SignUpActionProto.Response.authTokenExpiration: object expected");
                        message.authTokenExpiration = $root.google.protobuf.Duration.fromObject(object.authTokenExpiration);
                    }
                    if (object.userId != null)
                        message.userId = String(object.userId);
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.SignUpActionProto.Response
                 * @static
                 * @param {waiternow.common.SignUpActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.authToken = "";
                        object.authTokenExpiration = null;
                        object.userId = "";
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.authToken != null && message.hasOwnProperty("authToken"))
                        object.authToken = message.authToken;
                    if (message.authTokenExpiration != null && message.hasOwnProperty("authTokenExpiration"))
                        object.authTokenExpiration = $root.google.protobuf.Duration.toObject(message.authTokenExpiration, options);
                    if (message.userId != null && message.hasOwnProperty("userId"))
                        object.userId = message.userId;
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.SignUpActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.SignUpActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.SignUpActionProto.Response";
                };

                return Response;
            })();

            return SignUpActionProto;
        })();

        common.FullSignUpActionProto = (function() {

            /**
             * Properties of a FullSignUpActionProto.
             * @memberof waiternow.common
             * @interface IFullSignUpActionProto
             */

            /**
             * Constructs a new FullSignUpActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a FullSignUpActionProto.
             * @implements IFullSignUpActionProto
             * @constructor
             * @param {waiternow.common.IFullSignUpActionProto=} [properties] Properties to set
             */
            function FullSignUpActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new FullSignUpActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FullSignUpActionProto
             * @static
             * @param {waiternow.common.IFullSignUpActionProto=} [properties] Properties to set
             * @returns {waiternow.common.FullSignUpActionProto} FullSignUpActionProto instance
             */
            FullSignUpActionProto.create = function create(properties) {
                return new FullSignUpActionProto(properties);
            };

            /**
             * Encodes the specified FullSignUpActionProto message. Does not implicitly {@link waiternow.common.FullSignUpActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FullSignUpActionProto
             * @static
             * @param {waiternow.common.IFullSignUpActionProto} message FullSignUpActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FullSignUpActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified FullSignUpActionProto message, length delimited. Does not implicitly {@link waiternow.common.FullSignUpActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FullSignUpActionProto
             * @static
             * @param {waiternow.common.IFullSignUpActionProto} message FullSignUpActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FullSignUpActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FullSignUpActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FullSignUpActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FullSignUpActionProto} FullSignUpActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FullSignUpActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FullSignUpActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FullSignUpActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FullSignUpActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FullSignUpActionProto} FullSignUpActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FullSignUpActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FullSignUpActionProto message.
             * @function verify
             * @memberof waiternow.common.FullSignUpActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FullSignUpActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a FullSignUpActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FullSignUpActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FullSignUpActionProto} FullSignUpActionProto
             */
            FullSignUpActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FullSignUpActionProto)
                    return object;
                return new $root.waiternow.common.FullSignUpActionProto();
            };

            /**
             * Creates a plain object from a FullSignUpActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FullSignUpActionProto
             * @static
             * @param {waiternow.common.FullSignUpActionProto} message FullSignUpActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FullSignUpActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this FullSignUpActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FullSignUpActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FullSignUpActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FullSignUpActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.FullSignUpActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FullSignUpActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FullSignUpActionProto";
            };

            FullSignUpActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.FullSignUpActionProto
                 * @interface IRequest
                 * @property {string|null} [email] Request email
                 * @property {string|null} [password] Request password
                 * @property {string|null} [name] Request name
                 * @property {string|null} [lastName] Request lastName
                 * @property {waiternow.common.IPhoneNumberProto|null} [phoneNumber] Request phoneNumber
                 * @property {waiternow.common.ContactMedium|null} [preferredContactMedium] Request preferredContactMedium
                 * @property {waiternow.common.ReachMedium|null} [reachMedium] Request reachMedium
                 * @property {waiternow.common.Language|null} [language] Request language
                 * @property {string|null} [businessName] Request businessName
                 * @property {waiternow.common.IAddressProto|null} [businessAddress] Request businessAddress
                 * @property {number|null} [numberOfPointsOfService] Request numberOfPointsOfService
                 * @property {waiternow.common.RecordType|null} [recordType] Request recordType
                 * @property {string|null} [devAuthorizationCode] Request devAuthorizationCode
                 * @property {string|null} [emailVerificationCode] Request emailVerificationCode
                 * @property {string|null} [phoneNumberVerificationCode] Request phoneNumberVerificationCode
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.FullSignUpActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.FullSignUpActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request email.
                 * @member {string} email
                 * @memberof waiternow.common.FullSignUpActionProto.Request
                 * @instance
                 */
                Request.prototype.email = "";

                /**
                 * Request password.
                 * @member {string} password
                 * @memberof waiternow.common.FullSignUpActionProto.Request
                 * @instance
                 */
                Request.prototype.password = "";

                /**
                 * Request name.
                 * @member {string} name
                 * @memberof waiternow.common.FullSignUpActionProto.Request
                 * @instance
                 */
                Request.prototype.name = "";

                /**
                 * Request lastName.
                 * @member {string} lastName
                 * @memberof waiternow.common.FullSignUpActionProto.Request
                 * @instance
                 */
                Request.prototype.lastName = "";

                /**
                 * Request phoneNumber.
                 * @member {waiternow.common.IPhoneNumberProto|null|undefined} phoneNumber
                 * @memberof waiternow.common.FullSignUpActionProto.Request
                 * @instance
                 */
                Request.prototype.phoneNumber = null;

                /**
                 * Request preferredContactMedium.
                 * @member {waiternow.common.ContactMedium} preferredContactMedium
                 * @memberof waiternow.common.FullSignUpActionProto.Request
                 * @instance
                 */
                Request.prototype.preferredContactMedium = 0;

                /**
                 * Request reachMedium.
                 * @member {waiternow.common.ReachMedium} reachMedium
                 * @memberof waiternow.common.FullSignUpActionProto.Request
                 * @instance
                 */
                Request.prototype.reachMedium = 0;

                /**
                 * Request language.
                 * @member {waiternow.common.Language} language
                 * @memberof waiternow.common.FullSignUpActionProto.Request
                 * @instance
                 */
                Request.prototype.language = 0;

                /**
                 * Request businessName.
                 * @member {string} businessName
                 * @memberof waiternow.common.FullSignUpActionProto.Request
                 * @instance
                 */
                Request.prototype.businessName = "";

                /**
                 * Request businessAddress.
                 * @member {waiternow.common.IAddressProto|null|undefined} businessAddress
                 * @memberof waiternow.common.FullSignUpActionProto.Request
                 * @instance
                 */
                Request.prototype.businessAddress = null;

                /**
                 * Request numberOfPointsOfService.
                 * @member {number} numberOfPointsOfService
                 * @memberof waiternow.common.FullSignUpActionProto.Request
                 * @instance
                 */
                Request.prototype.numberOfPointsOfService = 0;

                /**
                 * Request recordType.
                 * @member {waiternow.common.RecordType} recordType
                 * @memberof waiternow.common.FullSignUpActionProto.Request
                 * @instance
                 */
                Request.prototype.recordType = 0;

                /**
                 * Request devAuthorizationCode.
                 * @member {string} devAuthorizationCode
                 * @memberof waiternow.common.FullSignUpActionProto.Request
                 * @instance
                 */
                Request.prototype.devAuthorizationCode = "";

                /**
                 * Request emailVerificationCode.
                 * @member {string} emailVerificationCode
                 * @memberof waiternow.common.FullSignUpActionProto.Request
                 * @instance
                 */
                Request.prototype.emailVerificationCode = "";

                /**
                 * Request phoneNumberVerificationCode.
                 * @member {string} phoneNumberVerificationCode
                 * @memberof waiternow.common.FullSignUpActionProto.Request
                 * @instance
                 */
                Request.prototype.phoneNumberVerificationCode = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FullSignUpActionProto.Request
                 * @static
                 * @param {waiternow.common.FullSignUpActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.FullSignUpActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.FullSignUpActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FullSignUpActionProto.Request
                 * @static
                 * @param {waiternow.common.FullSignUpActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
                    if (message.password != null && Object.hasOwnProperty.call(message, "password"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.password);
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.name);
                    if (message.lastName != null && Object.hasOwnProperty.call(message, "lastName"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.lastName);
                    if (message.phoneNumber != null && Object.hasOwnProperty.call(message, "phoneNumber"))
                        $root.waiternow.common.PhoneNumberProto.encode(message.phoneNumber, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.preferredContactMedium != null && Object.hasOwnProperty.call(message, "preferredContactMedium"))
                        writer.uint32(/* id 6, wireType 0 =*/48).int32(message.preferredContactMedium);
                    if (message.reachMedium != null && Object.hasOwnProperty.call(message, "reachMedium"))
                        writer.uint32(/* id 7, wireType 0 =*/56).int32(message.reachMedium);
                    if (message.language != null && Object.hasOwnProperty.call(message, "language"))
                        writer.uint32(/* id 8, wireType 0 =*/64).int32(message.language);
                    if (message.businessName != null && Object.hasOwnProperty.call(message, "businessName"))
                        writer.uint32(/* id 9, wireType 2 =*/74).string(message.businessName);
                    if (message.businessAddress != null && Object.hasOwnProperty.call(message, "businessAddress"))
                        $root.waiternow.common.AddressProto.encode(message.businessAddress, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                    if (message.numberOfPointsOfService != null && Object.hasOwnProperty.call(message, "numberOfPointsOfService"))
                        writer.uint32(/* id 11, wireType 0 =*/88).int32(message.numberOfPointsOfService);
                    if (message.recordType != null && Object.hasOwnProperty.call(message, "recordType"))
                        writer.uint32(/* id 12, wireType 0 =*/96).int32(message.recordType);
                    if (message.devAuthorizationCode != null && Object.hasOwnProperty.call(message, "devAuthorizationCode"))
                        writer.uint32(/* id 13, wireType 2 =*/106).string(message.devAuthorizationCode);
                    if (message.emailVerificationCode != null && Object.hasOwnProperty.call(message, "emailVerificationCode"))
                        writer.uint32(/* id 14, wireType 2 =*/114).string(message.emailVerificationCode);
                    if (message.phoneNumberVerificationCode != null && Object.hasOwnProperty.call(message, "phoneNumberVerificationCode"))
                        writer.uint32(/* id 15, wireType 2 =*/122).string(message.phoneNumberVerificationCode);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.FullSignUpActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FullSignUpActionProto.Request
                 * @static
                 * @param {waiternow.common.FullSignUpActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FullSignUpActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FullSignUpActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FullSignUpActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.email = reader.string();
                                break;
                            }
                        case 2: {
                                message.password = reader.string();
                                break;
                            }
                        case 3: {
                                message.name = reader.string();
                                break;
                            }
                        case 4: {
                                message.lastName = reader.string();
                                break;
                            }
                        case 5: {
                                message.phoneNumber = $root.waiternow.common.PhoneNumberProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 6: {
                                message.preferredContactMedium = reader.int32();
                                break;
                            }
                        case 7: {
                                message.reachMedium = reader.int32();
                                break;
                            }
                        case 8: {
                                message.language = reader.int32();
                                break;
                            }
                        case 9: {
                                message.businessName = reader.string();
                                break;
                            }
                        case 10: {
                                message.businessAddress = $root.waiternow.common.AddressProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 11: {
                                message.numberOfPointsOfService = reader.int32();
                                break;
                            }
                        case 12: {
                                message.recordType = reader.int32();
                                break;
                            }
                        case 13: {
                                message.devAuthorizationCode = reader.string();
                                break;
                            }
                        case 14: {
                                message.emailVerificationCode = reader.string();
                                break;
                            }
                        case 15: {
                                message.phoneNumberVerificationCode = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FullSignUpActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FullSignUpActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.FullSignUpActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.email != null && message.hasOwnProperty("email"))
                        if (!$util.isString(message.email))
                            return "email: string expected";
                    if (message.password != null && message.hasOwnProperty("password"))
                        if (!$util.isString(message.password))
                            return "password: string expected";
                    if (message.name != null && message.hasOwnProperty("name"))
                        if (!$util.isString(message.name))
                            return "name: string expected";
                    if (message.lastName != null && message.hasOwnProperty("lastName"))
                        if (!$util.isString(message.lastName))
                            return "lastName: string expected";
                    if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber")) {
                        var error = $root.waiternow.common.PhoneNumberProto.verify(message.phoneNumber);
                        if (error)
                            return "phoneNumber." + error;
                    }
                    if (message.preferredContactMedium != null && message.hasOwnProperty("preferredContactMedium"))
                        switch (message.preferredContactMedium) {
                        default:
                            return "preferredContactMedium: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                            break;
                        }
                    if (message.reachMedium != null && message.hasOwnProperty("reachMedium"))
                        switch (message.reachMedium) {
                        default:
                            return "reachMedium: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                        case 6:
                        case 7:
                            break;
                        }
                    if (message.language != null && message.hasOwnProperty("language"))
                        switch (message.language) {
                        default:
                            return "language: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.businessName != null && message.hasOwnProperty("businessName"))
                        if (!$util.isString(message.businessName))
                            return "businessName: string expected";
                    if (message.businessAddress != null && message.hasOwnProperty("businessAddress")) {
                        var error = $root.waiternow.common.AddressProto.verify(message.businessAddress);
                        if (error)
                            return "businessAddress." + error;
                    }
                    if (message.numberOfPointsOfService != null && message.hasOwnProperty("numberOfPointsOfService"))
                        if (!$util.isInteger(message.numberOfPointsOfService))
                            return "numberOfPointsOfService: integer expected";
                    if (message.recordType != null && message.hasOwnProperty("recordType"))
                        switch (message.recordType) {
                        default:
                            return "recordType: enum value expected";
                        case 0:
                        case 1:
                        case 3:
                        case 4:
                        case 5:
                            break;
                        }
                    if (message.devAuthorizationCode != null && message.hasOwnProperty("devAuthorizationCode"))
                        if (!$util.isString(message.devAuthorizationCode))
                            return "devAuthorizationCode: string expected";
                    if (message.emailVerificationCode != null && message.hasOwnProperty("emailVerificationCode"))
                        if (!$util.isString(message.emailVerificationCode))
                            return "emailVerificationCode: string expected";
                    if (message.phoneNumberVerificationCode != null && message.hasOwnProperty("phoneNumberVerificationCode"))
                        if (!$util.isString(message.phoneNumberVerificationCode))
                            return "phoneNumberVerificationCode: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FullSignUpActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FullSignUpActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FullSignUpActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.FullSignUpActionProto.Request();
                    if (object.email != null)
                        message.email = String(object.email);
                    if (object.password != null)
                        message.password = String(object.password);
                    if (object.name != null)
                        message.name = String(object.name);
                    if (object.lastName != null)
                        message.lastName = String(object.lastName);
                    if (object.phoneNumber != null) {
                        if (typeof object.phoneNumber !== "object")
                            throw TypeError(".waiternow.common.FullSignUpActionProto.Request.phoneNumber: object expected");
                        message.phoneNumber = $root.waiternow.common.PhoneNumberProto.fromObject(object.phoneNumber);
                    }
                    switch (object.preferredContactMedium) {
                    default:
                        if (typeof object.preferredContactMedium === "number") {
                            message.preferredContactMedium = object.preferredContactMedium;
                            break;
                        }
                        break;
                    case "CONTACT_MEDIUM_UNSPECIFIED":
                    case 0:
                        message.preferredContactMedium = 0;
                        break;
                    case "EMAIL":
                    case 1:
                        message.preferredContactMedium = 1;
                        break;
                    case "PHONE_CALL":
                    case 2:
                        message.preferredContactMedium = 2;
                        break;
                    case "TEXT_MESSAGE":
                    case 3:
                        message.preferredContactMedium = 3;
                        break;
                    case "WHATS_APP":
                    case 4:
                        message.preferredContactMedium = 4;
                        break;
                    }
                    switch (object.reachMedium) {
                    default:
                        if (typeof object.reachMedium === "number") {
                            message.reachMedium = object.reachMedium;
                            break;
                        }
                        break;
                    case "REACH_MEDIUM_UNDEFINED":
                    case 0:
                        message.reachMedium = 0;
                        break;
                    case "GOOGLE":
                    case 1:
                        message.reachMedium = 1;
                        break;
                    case "FACEBOOK":
                    case 2:
                        message.reachMedium = 2;
                        break;
                    case "INSTRAGRAM":
                    case 3:
                        message.reachMedium = 3;
                        break;
                    case "LINKED_IN":
                    case 4:
                        message.reachMedium = 4;
                        break;
                    case "RECOMMENDATION":
                    case 5:
                        message.reachMedium = 5;
                        break;
                    case "SALESPERSON":
                    case 6:
                        message.reachMedium = 6;
                        break;
                    case "OTHER":
                    case 7:
                        message.reachMedium = 7;
                        break;
                    }
                    switch (object.language) {
                    default:
                        if (typeof object.language === "number") {
                            message.language = object.language;
                            break;
                        }
                        break;
                    case "LANGUAGE_UNSPECIFIED":
                    case 0:
                        message.language = 0;
                        break;
                    case "ENGLISH":
                    case 1:
                        message.language = 1;
                        break;
                    case "SPANISH":
                    case 2:
                        message.language = 2;
                        break;
                    }
                    if (object.businessName != null)
                        message.businessName = String(object.businessName);
                    if (object.businessAddress != null) {
                        if (typeof object.businessAddress !== "object")
                            throw TypeError(".waiternow.common.FullSignUpActionProto.Request.businessAddress: object expected");
                        message.businessAddress = $root.waiternow.common.AddressProto.fromObject(object.businessAddress);
                    }
                    if (object.numberOfPointsOfService != null)
                        message.numberOfPointsOfService = object.numberOfPointsOfService | 0;
                    switch (object.recordType) {
                    default:
                        if (typeof object.recordType === "number") {
                            message.recordType = object.recordType;
                            break;
                        }
                        break;
                    case "RECORD_TYPE_UNSPECIFIED":
                    case 0:
                        message.recordType = 0;
                        break;
                    case "REGULAR":
                    case 1:
                        message.recordType = 1;
                        break;
                    case "PRE_CREATED":
                    case 3:
                        message.recordType = 3;
                        break;
                    case "TEST":
                    case 4:
                        message.recordType = 4;
                        break;
                    case "DEMO":
                    case 5:
                        message.recordType = 5;
                        break;
                    }
                    if (object.devAuthorizationCode != null)
                        message.devAuthorizationCode = String(object.devAuthorizationCode);
                    if (object.emailVerificationCode != null)
                        message.emailVerificationCode = String(object.emailVerificationCode);
                    if (object.phoneNumberVerificationCode != null)
                        message.phoneNumberVerificationCode = String(object.phoneNumberVerificationCode);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FullSignUpActionProto.Request
                 * @static
                 * @param {waiternow.common.FullSignUpActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.email = "";
                        object.password = "";
                        object.name = "";
                        object.lastName = "";
                        object.phoneNumber = null;
                        object.preferredContactMedium = options.enums === String ? "CONTACT_MEDIUM_UNSPECIFIED" : 0;
                        object.reachMedium = options.enums === String ? "REACH_MEDIUM_UNDEFINED" : 0;
                        object.language = options.enums === String ? "LANGUAGE_UNSPECIFIED" : 0;
                        object.businessName = "";
                        object.businessAddress = null;
                        object.numberOfPointsOfService = 0;
                        object.recordType = options.enums === String ? "RECORD_TYPE_UNSPECIFIED" : 0;
                        object.devAuthorizationCode = "";
                        object.emailVerificationCode = "";
                        object.phoneNumberVerificationCode = "";
                    }
                    if (message.email != null && message.hasOwnProperty("email"))
                        object.email = message.email;
                    if (message.password != null && message.hasOwnProperty("password"))
                        object.password = message.password;
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = message.name;
                    if (message.lastName != null && message.hasOwnProperty("lastName"))
                        object.lastName = message.lastName;
                    if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
                        object.phoneNumber = $root.waiternow.common.PhoneNumberProto.toObject(message.phoneNumber, options);
                    if (message.preferredContactMedium != null && message.hasOwnProperty("preferredContactMedium"))
                        object.preferredContactMedium = options.enums === String ? $root.waiternow.common.ContactMedium[message.preferredContactMedium] === undefined ? message.preferredContactMedium : $root.waiternow.common.ContactMedium[message.preferredContactMedium] : message.preferredContactMedium;
                    if (message.reachMedium != null && message.hasOwnProperty("reachMedium"))
                        object.reachMedium = options.enums === String ? $root.waiternow.common.ReachMedium[message.reachMedium] === undefined ? message.reachMedium : $root.waiternow.common.ReachMedium[message.reachMedium] : message.reachMedium;
                    if (message.language != null && message.hasOwnProperty("language"))
                        object.language = options.enums === String ? $root.waiternow.common.Language[message.language] === undefined ? message.language : $root.waiternow.common.Language[message.language] : message.language;
                    if (message.businessName != null && message.hasOwnProperty("businessName"))
                        object.businessName = message.businessName;
                    if (message.businessAddress != null && message.hasOwnProperty("businessAddress"))
                        object.businessAddress = $root.waiternow.common.AddressProto.toObject(message.businessAddress, options);
                    if (message.numberOfPointsOfService != null && message.hasOwnProperty("numberOfPointsOfService"))
                        object.numberOfPointsOfService = message.numberOfPointsOfService;
                    if (message.recordType != null && message.hasOwnProperty("recordType"))
                        object.recordType = options.enums === String ? $root.waiternow.common.RecordType[message.recordType] === undefined ? message.recordType : $root.waiternow.common.RecordType[message.recordType] : message.recordType;
                    if (message.devAuthorizationCode != null && message.hasOwnProperty("devAuthorizationCode"))
                        object.devAuthorizationCode = message.devAuthorizationCode;
                    if (message.emailVerificationCode != null && message.hasOwnProperty("emailVerificationCode"))
                        object.emailVerificationCode = message.emailVerificationCode;
                    if (message.phoneNumberVerificationCode != null && message.hasOwnProperty("phoneNumberVerificationCode"))
                        object.phoneNumberVerificationCode = message.phoneNumberVerificationCode;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FullSignUpActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.FullSignUpActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FullSignUpActionProto.Request";
                };

                return Request;
            })();

            FullSignUpActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.FullSignUpActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {string|null} [authToken] Response authToken
                 * @property {google.protobuf.IDuration|null} [authTokenExpiration] Response authTokenExpiration
                 * @property {string|null} [userId] Response userId
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.FullSignUpActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.FullSignUpActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.FullSignUpActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response authToken.
                 * @member {string} authToken
                 * @memberof waiternow.common.FullSignUpActionProto.Response
                 * @instance
                 */
                Response.prototype.authToken = "";

                /**
                 * Response authTokenExpiration.
                 * @member {google.protobuf.IDuration|null|undefined} authTokenExpiration
                 * @memberof waiternow.common.FullSignUpActionProto.Response
                 * @instance
                 */
                Response.prototype.authTokenExpiration = null;

                /**
                 * Response userId.
                 * @member {string} userId
                 * @memberof waiternow.common.FullSignUpActionProto.Response
                 * @instance
                 */
                Response.prototype.userId = "";

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FullSignUpActionProto.Response
                 * @static
                 * @param {waiternow.common.FullSignUpActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.FullSignUpActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.FullSignUpActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FullSignUpActionProto.Response
                 * @static
                 * @param {waiternow.common.FullSignUpActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.authToken != null && Object.hasOwnProperty.call(message, "authToken"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.authToken);
                    if (message.authTokenExpiration != null && Object.hasOwnProperty.call(message, "authTokenExpiration"))
                        $root.google.protobuf.Duration.encode(message.authTokenExpiration, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.userId);
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.FullSignUpActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FullSignUpActionProto.Response
                 * @static
                 * @param {waiternow.common.FullSignUpActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FullSignUpActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FullSignUpActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FullSignUpActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.authToken = reader.string();
                                break;
                            }
                        case 3: {
                                message.authTokenExpiration = $root.google.protobuf.Duration.decode(reader, reader.uint32());
                                break;
                            }
                        case 4: {
                                message.userId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FullSignUpActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FullSignUpActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.FullSignUpActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.authToken != null && message.hasOwnProperty("authToken"))
                        if (!$util.isString(message.authToken))
                            return "authToken: string expected";
                    if (message.authTokenExpiration != null && message.hasOwnProperty("authTokenExpiration")) {
                        var error = $root.google.protobuf.Duration.verify(message.authTokenExpiration);
                        if (error)
                            return "authTokenExpiration." + error;
                    }
                    if (message.userId != null && message.hasOwnProperty("userId"))
                        if (!$util.isString(message.userId))
                            return "userId: string expected";
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FullSignUpActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FullSignUpActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FullSignUpActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.FullSignUpActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.FullSignUpActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.authToken != null)
                        message.authToken = String(object.authToken);
                    if (object.authTokenExpiration != null) {
                        if (typeof object.authTokenExpiration !== "object")
                            throw TypeError(".waiternow.common.FullSignUpActionProto.Response.authTokenExpiration: object expected");
                        message.authTokenExpiration = $root.google.protobuf.Duration.fromObject(object.authTokenExpiration);
                    }
                    if (object.userId != null)
                        message.userId = String(object.userId);
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FullSignUpActionProto.Response
                 * @static
                 * @param {waiternow.common.FullSignUpActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.authToken = "";
                        object.authTokenExpiration = null;
                        object.userId = "";
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.authToken != null && message.hasOwnProperty("authToken"))
                        object.authToken = message.authToken;
                    if (message.authTokenExpiration != null && message.hasOwnProperty("authTokenExpiration"))
                        object.authTokenExpiration = $root.google.protobuf.Duration.toObject(message.authTokenExpiration, options);
                    if (message.userId != null && message.hasOwnProperty("userId"))
                        object.userId = message.userId;
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FullSignUpActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.FullSignUpActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FullSignUpActionProto.Response";
                };

                return Response;
            })();

            return FullSignUpActionProto;
        })();

        common.SignInActionProto = (function() {

            /**
             * Properties of a SignInActionProto.
             * @memberof waiternow.common
             * @interface ISignInActionProto
             */

            /**
             * Constructs a new SignInActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a SignInActionProto.
             * @implements ISignInActionProto
             * @constructor
             * @param {waiternow.common.ISignInActionProto=} [properties] Properties to set
             */
            function SignInActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new SignInActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.SignInActionProto
             * @static
             * @param {waiternow.common.ISignInActionProto=} [properties] Properties to set
             * @returns {waiternow.common.SignInActionProto} SignInActionProto instance
             */
            SignInActionProto.create = function create(properties) {
                return new SignInActionProto(properties);
            };

            /**
             * Encodes the specified SignInActionProto message. Does not implicitly {@link waiternow.common.SignInActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.SignInActionProto
             * @static
             * @param {waiternow.common.ISignInActionProto} message SignInActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SignInActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified SignInActionProto message, length delimited. Does not implicitly {@link waiternow.common.SignInActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.SignInActionProto
             * @static
             * @param {waiternow.common.ISignInActionProto} message SignInActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SignInActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SignInActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.SignInActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.SignInActionProto} SignInActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SignInActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.SignInActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SignInActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.SignInActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.SignInActionProto} SignInActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SignInActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SignInActionProto message.
             * @function verify
             * @memberof waiternow.common.SignInActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SignInActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a SignInActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.SignInActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.SignInActionProto} SignInActionProto
             */
            SignInActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.SignInActionProto)
                    return object;
                return new $root.waiternow.common.SignInActionProto();
            };

            /**
             * Creates a plain object from a SignInActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.SignInActionProto
             * @static
             * @param {waiternow.common.SignInActionProto} message SignInActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SignInActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this SignInActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.SignInActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SignInActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for SignInActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.SignInActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            SignInActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.SignInActionProto";
            };

            SignInActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.SignInActionProto
                 * @interface IRequest
                 * @property {string|null} [email] Request email
                 * @property {string|null} [password] Request password
                 * @property {string|null} [encodedCredentials] Request encodedCredentials
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.SignInActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.SignInActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request email.
                 * @member {string} email
                 * @memberof waiternow.common.SignInActionProto.Request
                 * @instance
                 */
                Request.prototype.email = "";

                /**
                 * Request password.
                 * @member {string} password
                 * @memberof waiternow.common.SignInActionProto.Request
                 * @instance
                 */
                Request.prototype.password = "";

                /**
                 * Request encodedCredentials.
                 * @member {string} encodedCredentials
                 * @memberof waiternow.common.SignInActionProto.Request
                 * @instance
                 */
                Request.prototype.encodedCredentials = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.SignInActionProto.Request
                 * @static
                 * @param {waiternow.common.SignInActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.SignInActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.SignInActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.SignInActionProto.Request
                 * @static
                 * @param {waiternow.common.SignInActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
                    if (message.password != null && Object.hasOwnProperty.call(message, "password"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.password);
                    if (message.encodedCredentials != null && Object.hasOwnProperty.call(message, "encodedCredentials"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.encodedCredentials);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.SignInActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.SignInActionProto.Request
                 * @static
                 * @param {waiternow.common.SignInActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.SignInActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.SignInActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.SignInActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.email = reader.string();
                                break;
                            }
                        case 2: {
                                message.password = reader.string();
                                break;
                            }
                        case 3: {
                                message.encodedCredentials = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.SignInActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.SignInActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.SignInActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.email != null && message.hasOwnProperty("email"))
                        if (!$util.isString(message.email))
                            return "email: string expected";
                    if (message.password != null && message.hasOwnProperty("password"))
                        if (!$util.isString(message.password))
                            return "password: string expected";
                    if (message.encodedCredentials != null && message.hasOwnProperty("encodedCredentials"))
                        if (!$util.isString(message.encodedCredentials))
                            return "encodedCredentials: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.SignInActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.SignInActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.SignInActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.SignInActionProto.Request();
                    if (object.email != null)
                        message.email = String(object.email);
                    if (object.password != null)
                        message.password = String(object.password);
                    if (object.encodedCredentials != null)
                        message.encodedCredentials = String(object.encodedCredentials);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.SignInActionProto.Request
                 * @static
                 * @param {waiternow.common.SignInActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.email = "";
                        object.password = "";
                        object.encodedCredentials = "";
                    }
                    if (message.email != null && message.hasOwnProperty("email"))
                        object.email = message.email;
                    if (message.password != null && message.hasOwnProperty("password"))
                        object.password = message.password;
                    if (message.encodedCredentials != null && message.hasOwnProperty("encodedCredentials"))
                        object.encodedCredentials = message.encodedCredentials;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.SignInActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.SignInActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.SignInActionProto.Request";
                };

                return Request;
            })();

            SignInActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.SignInActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {string|null} [authToken] Response authToken
                 * @property {google.protobuf.IDuration|null} [authTokenExpiration] Response authTokenExpiration
                 * @property {string|null} [userId] Response userId
                 * @property {google.protobuf.IDuration|null} [businessSafetyCheckOrdersPollRate] Response businessSafetyCheckOrdersPollRate
                 * @property {google.protobuf.IDuration|null} [businessCheckOrdersPollRate] Response businessCheckOrdersPollRate
                 * @property {google.protobuf.ITimestamp|null} [since] Response since
                 * @property {google.protobuf.IDuration|null} [businessDeviceHeartbeatRate] Response businessDeviceHeartbeatRate
                 * @property {boolean|null} [isImpersonationAllowed] Response isImpersonationAllowed
                 * @property {boolean|null} [isAdminUser] Response isAdminUser
                 * @property {boolean|null} [isPrivilegedUser] Response isPrivilegedUser
                 * @property {boolean|null} [isSuperuser] Response isSuperuser
                 * @property {string|null} [pingUrl] Response pingUrl
                 * @property {google.protobuf.IDuration|null} [businessIntenetConnectionPingRate] Response businessIntenetConnectionPingRate
                 * @property {string|null} [googleAiServicesApiKey] Response googleAiServicesApiKey
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.SignInActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.SignInActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.SignInActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response authToken.
                 * @member {string} authToken
                 * @memberof waiternow.common.SignInActionProto.Response
                 * @instance
                 */
                Response.prototype.authToken = "";

                /**
                 * Response authTokenExpiration.
                 * @member {google.protobuf.IDuration|null|undefined} authTokenExpiration
                 * @memberof waiternow.common.SignInActionProto.Response
                 * @instance
                 */
                Response.prototype.authTokenExpiration = null;

                /**
                 * Response userId.
                 * @member {string} userId
                 * @memberof waiternow.common.SignInActionProto.Response
                 * @instance
                 */
                Response.prototype.userId = "";

                /**
                 * Response businessSafetyCheckOrdersPollRate.
                 * @member {google.protobuf.IDuration|null|undefined} businessSafetyCheckOrdersPollRate
                 * @memberof waiternow.common.SignInActionProto.Response
                 * @instance
                 */
                Response.prototype.businessSafetyCheckOrdersPollRate = null;

                /**
                 * Response businessCheckOrdersPollRate.
                 * @member {google.protobuf.IDuration|null|undefined} businessCheckOrdersPollRate
                 * @memberof waiternow.common.SignInActionProto.Response
                 * @instance
                 */
                Response.prototype.businessCheckOrdersPollRate = null;

                /**
                 * Response since.
                 * @member {google.protobuf.ITimestamp|null|undefined} since
                 * @memberof waiternow.common.SignInActionProto.Response
                 * @instance
                 */
                Response.prototype.since = null;

                /**
                 * Response businessDeviceHeartbeatRate.
                 * @member {google.protobuf.IDuration|null|undefined} businessDeviceHeartbeatRate
                 * @memberof waiternow.common.SignInActionProto.Response
                 * @instance
                 */
                Response.prototype.businessDeviceHeartbeatRate = null;

                /**
                 * Response isImpersonationAllowed.
                 * @member {boolean} isImpersonationAllowed
                 * @memberof waiternow.common.SignInActionProto.Response
                 * @instance
                 */
                Response.prototype.isImpersonationAllowed = false;

                /**
                 * Response isAdminUser.
                 * @member {boolean} isAdminUser
                 * @memberof waiternow.common.SignInActionProto.Response
                 * @instance
                 */
                Response.prototype.isAdminUser = false;

                /**
                 * Response isPrivilegedUser.
                 * @member {boolean} isPrivilegedUser
                 * @memberof waiternow.common.SignInActionProto.Response
                 * @instance
                 */
                Response.prototype.isPrivilegedUser = false;

                /**
                 * Response isSuperuser.
                 * @member {boolean} isSuperuser
                 * @memberof waiternow.common.SignInActionProto.Response
                 * @instance
                 */
                Response.prototype.isSuperuser = false;

                /**
                 * Response pingUrl.
                 * @member {string} pingUrl
                 * @memberof waiternow.common.SignInActionProto.Response
                 * @instance
                 */
                Response.prototype.pingUrl = "";

                /**
                 * Response businessIntenetConnectionPingRate.
                 * @member {google.protobuf.IDuration|null|undefined} businessIntenetConnectionPingRate
                 * @memberof waiternow.common.SignInActionProto.Response
                 * @instance
                 */
                Response.prototype.businessIntenetConnectionPingRate = null;

                /**
                 * Response googleAiServicesApiKey.
                 * @member {string} googleAiServicesApiKey
                 * @memberof waiternow.common.SignInActionProto.Response
                 * @instance
                 */
                Response.prototype.googleAiServicesApiKey = "";

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.SignInActionProto.Response
                 * @static
                 * @param {waiternow.common.SignInActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.SignInActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.SignInActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.SignInActionProto.Response
                 * @static
                 * @param {waiternow.common.SignInActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.authToken != null && Object.hasOwnProperty.call(message, "authToken"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.authToken);
                    if (message.authTokenExpiration != null && Object.hasOwnProperty.call(message, "authTokenExpiration"))
                        $root.google.protobuf.Duration.encode(message.authTokenExpiration, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.userId);
                    if (message.businessSafetyCheckOrdersPollRate != null && Object.hasOwnProperty.call(message, "businessSafetyCheckOrdersPollRate"))
                        $root.google.protobuf.Duration.encode(message.businessSafetyCheckOrdersPollRate, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.since != null && Object.hasOwnProperty.call(message, "since"))
                        $root.google.protobuf.Timestamp.encode(message.since, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.isImpersonationAllowed != null && Object.hasOwnProperty.call(message, "isImpersonationAllowed"))
                        writer.uint32(/* id 7, wireType 0 =*/56).bool(message.isImpersonationAllowed);
                    if (message.businessDeviceHeartbeatRate != null && Object.hasOwnProperty.call(message, "businessDeviceHeartbeatRate"))
                        $root.google.protobuf.Duration.encode(message.businessDeviceHeartbeatRate, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                    if (message.isAdminUser != null && Object.hasOwnProperty.call(message, "isAdminUser"))
                        writer.uint32(/* id 9, wireType 0 =*/72).bool(message.isAdminUser);
                    if (message.businessCheckOrdersPollRate != null && Object.hasOwnProperty.call(message, "businessCheckOrdersPollRate"))
                        $root.google.protobuf.Duration.encode(message.businessCheckOrdersPollRate, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                    if (message.isSuperuser != null && Object.hasOwnProperty.call(message, "isSuperuser"))
                        writer.uint32(/* id 11, wireType 0 =*/88).bool(message.isSuperuser);
                    if (message.pingUrl != null && Object.hasOwnProperty.call(message, "pingUrl"))
                        writer.uint32(/* id 12, wireType 2 =*/98).string(message.pingUrl);
                    if (message.businessIntenetConnectionPingRate != null && Object.hasOwnProperty.call(message, "businessIntenetConnectionPingRate"))
                        $root.google.protobuf.Duration.encode(message.businessIntenetConnectionPingRate, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
                    if (message.googleAiServicesApiKey != null && Object.hasOwnProperty.call(message, "googleAiServicesApiKey"))
                        writer.uint32(/* id 14, wireType 2 =*/114).string(message.googleAiServicesApiKey);
                    if (message.isPrivilegedUser != null && Object.hasOwnProperty.call(message, "isPrivilegedUser"))
                        writer.uint32(/* id 15, wireType 0 =*/120).bool(message.isPrivilegedUser);
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.SignInActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.SignInActionProto.Response
                 * @static
                 * @param {waiternow.common.SignInActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.SignInActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.SignInActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.SignInActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.authToken = reader.string();
                                break;
                            }
                        case 3: {
                                message.authTokenExpiration = $root.google.protobuf.Duration.decode(reader, reader.uint32());
                                break;
                            }
                        case 4: {
                                message.userId = reader.string();
                                break;
                            }
                        case 5: {
                                message.businessSafetyCheckOrdersPollRate = $root.google.protobuf.Duration.decode(reader, reader.uint32());
                                break;
                            }
                        case 10: {
                                message.businessCheckOrdersPollRate = $root.google.protobuf.Duration.decode(reader, reader.uint32());
                                break;
                            }
                        case 6: {
                                message.since = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            }
                        case 8: {
                                message.businessDeviceHeartbeatRate = $root.google.protobuf.Duration.decode(reader, reader.uint32());
                                break;
                            }
                        case 7: {
                                message.isImpersonationAllowed = reader.bool();
                                break;
                            }
                        case 9: {
                                message.isAdminUser = reader.bool();
                                break;
                            }
                        case 15: {
                                message.isPrivilegedUser = reader.bool();
                                break;
                            }
                        case 11: {
                                message.isSuperuser = reader.bool();
                                break;
                            }
                        case 12: {
                                message.pingUrl = reader.string();
                                break;
                            }
                        case 13: {
                                message.businessIntenetConnectionPingRate = $root.google.protobuf.Duration.decode(reader, reader.uint32());
                                break;
                            }
                        case 14: {
                                message.googleAiServicesApiKey = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.SignInActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.SignInActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.SignInActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.authToken != null && message.hasOwnProperty("authToken"))
                        if (!$util.isString(message.authToken))
                            return "authToken: string expected";
                    if (message.authTokenExpiration != null && message.hasOwnProperty("authTokenExpiration")) {
                        var error = $root.google.protobuf.Duration.verify(message.authTokenExpiration);
                        if (error)
                            return "authTokenExpiration." + error;
                    }
                    if (message.userId != null && message.hasOwnProperty("userId"))
                        if (!$util.isString(message.userId))
                            return "userId: string expected";
                    if (message.businessSafetyCheckOrdersPollRate != null && message.hasOwnProperty("businessSafetyCheckOrdersPollRate")) {
                        var error = $root.google.protobuf.Duration.verify(message.businessSafetyCheckOrdersPollRate);
                        if (error)
                            return "businessSafetyCheckOrdersPollRate." + error;
                    }
                    if (message.businessCheckOrdersPollRate != null && message.hasOwnProperty("businessCheckOrdersPollRate")) {
                        var error = $root.google.protobuf.Duration.verify(message.businessCheckOrdersPollRate);
                        if (error)
                            return "businessCheckOrdersPollRate." + error;
                    }
                    if (message.since != null && message.hasOwnProperty("since")) {
                        var error = $root.google.protobuf.Timestamp.verify(message.since);
                        if (error)
                            return "since." + error;
                    }
                    if (message.businessDeviceHeartbeatRate != null && message.hasOwnProperty("businessDeviceHeartbeatRate")) {
                        var error = $root.google.protobuf.Duration.verify(message.businessDeviceHeartbeatRate);
                        if (error)
                            return "businessDeviceHeartbeatRate." + error;
                    }
                    if (message.isImpersonationAllowed != null && message.hasOwnProperty("isImpersonationAllowed"))
                        if (typeof message.isImpersonationAllowed !== "boolean")
                            return "isImpersonationAllowed: boolean expected";
                    if (message.isAdminUser != null && message.hasOwnProperty("isAdminUser"))
                        if (typeof message.isAdminUser !== "boolean")
                            return "isAdminUser: boolean expected";
                    if (message.isPrivilegedUser != null && message.hasOwnProperty("isPrivilegedUser"))
                        if (typeof message.isPrivilegedUser !== "boolean")
                            return "isPrivilegedUser: boolean expected";
                    if (message.isSuperuser != null && message.hasOwnProperty("isSuperuser"))
                        if (typeof message.isSuperuser !== "boolean")
                            return "isSuperuser: boolean expected";
                    if (message.pingUrl != null && message.hasOwnProperty("pingUrl"))
                        if (!$util.isString(message.pingUrl))
                            return "pingUrl: string expected";
                    if (message.businessIntenetConnectionPingRate != null && message.hasOwnProperty("businessIntenetConnectionPingRate")) {
                        var error = $root.google.protobuf.Duration.verify(message.businessIntenetConnectionPingRate);
                        if (error)
                            return "businessIntenetConnectionPingRate." + error;
                    }
                    if (message.googleAiServicesApiKey != null && message.hasOwnProperty("googleAiServicesApiKey"))
                        if (!$util.isString(message.googleAiServicesApiKey))
                            return "googleAiServicesApiKey: string expected";
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.SignInActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.SignInActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.SignInActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.SignInActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.SignInActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.authToken != null)
                        message.authToken = String(object.authToken);
                    if (object.authTokenExpiration != null) {
                        if (typeof object.authTokenExpiration !== "object")
                            throw TypeError(".waiternow.common.SignInActionProto.Response.authTokenExpiration: object expected");
                        message.authTokenExpiration = $root.google.protobuf.Duration.fromObject(object.authTokenExpiration);
                    }
                    if (object.userId != null)
                        message.userId = String(object.userId);
                    if (object.businessSafetyCheckOrdersPollRate != null) {
                        if (typeof object.businessSafetyCheckOrdersPollRate !== "object")
                            throw TypeError(".waiternow.common.SignInActionProto.Response.businessSafetyCheckOrdersPollRate: object expected");
                        message.businessSafetyCheckOrdersPollRate = $root.google.protobuf.Duration.fromObject(object.businessSafetyCheckOrdersPollRate);
                    }
                    if (object.businessCheckOrdersPollRate != null) {
                        if (typeof object.businessCheckOrdersPollRate !== "object")
                            throw TypeError(".waiternow.common.SignInActionProto.Response.businessCheckOrdersPollRate: object expected");
                        message.businessCheckOrdersPollRate = $root.google.protobuf.Duration.fromObject(object.businessCheckOrdersPollRate);
                    }
                    if (object.since != null) {
                        if (typeof object.since !== "object")
                            throw TypeError(".waiternow.common.SignInActionProto.Response.since: object expected");
                        message.since = $root.google.protobuf.Timestamp.fromObject(object.since);
                    }
                    if (object.businessDeviceHeartbeatRate != null) {
                        if (typeof object.businessDeviceHeartbeatRate !== "object")
                            throw TypeError(".waiternow.common.SignInActionProto.Response.businessDeviceHeartbeatRate: object expected");
                        message.businessDeviceHeartbeatRate = $root.google.protobuf.Duration.fromObject(object.businessDeviceHeartbeatRate);
                    }
                    if (object.isImpersonationAllowed != null)
                        message.isImpersonationAllowed = Boolean(object.isImpersonationAllowed);
                    if (object.isAdminUser != null)
                        message.isAdminUser = Boolean(object.isAdminUser);
                    if (object.isPrivilegedUser != null)
                        message.isPrivilegedUser = Boolean(object.isPrivilegedUser);
                    if (object.isSuperuser != null)
                        message.isSuperuser = Boolean(object.isSuperuser);
                    if (object.pingUrl != null)
                        message.pingUrl = String(object.pingUrl);
                    if (object.businessIntenetConnectionPingRate != null) {
                        if (typeof object.businessIntenetConnectionPingRate !== "object")
                            throw TypeError(".waiternow.common.SignInActionProto.Response.businessIntenetConnectionPingRate: object expected");
                        message.businessIntenetConnectionPingRate = $root.google.protobuf.Duration.fromObject(object.businessIntenetConnectionPingRate);
                    }
                    if (object.googleAiServicesApiKey != null)
                        message.googleAiServicesApiKey = String(object.googleAiServicesApiKey);
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.SignInActionProto.Response
                 * @static
                 * @param {waiternow.common.SignInActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.authToken = "";
                        object.authTokenExpiration = null;
                        object.userId = "";
                        object.businessSafetyCheckOrdersPollRate = null;
                        object.since = null;
                        object.isImpersonationAllowed = false;
                        object.businessDeviceHeartbeatRate = null;
                        object.isAdminUser = false;
                        object.businessCheckOrdersPollRate = null;
                        object.isSuperuser = false;
                        object.pingUrl = "";
                        object.businessIntenetConnectionPingRate = null;
                        object.googleAiServicesApiKey = "";
                        object.isPrivilegedUser = false;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.authToken != null && message.hasOwnProperty("authToken"))
                        object.authToken = message.authToken;
                    if (message.authTokenExpiration != null && message.hasOwnProperty("authTokenExpiration"))
                        object.authTokenExpiration = $root.google.protobuf.Duration.toObject(message.authTokenExpiration, options);
                    if (message.userId != null && message.hasOwnProperty("userId"))
                        object.userId = message.userId;
                    if (message.businessSafetyCheckOrdersPollRate != null && message.hasOwnProperty("businessSafetyCheckOrdersPollRate"))
                        object.businessSafetyCheckOrdersPollRate = $root.google.protobuf.Duration.toObject(message.businessSafetyCheckOrdersPollRate, options);
                    if (message.since != null && message.hasOwnProperty("since"))
                        object.since = $root.google.protobuf.Timestamp.toObject(message.since, options);
                    if (message.isImpersonationAllowed != null && message.hasOwnProperty("isImpersonationAllowed"))
                        object.isImpersonationAllowed = message.isImpersonationAllowed;
                    if (message.businessDeviceHeartbeatRate != null && message.hasOwnProperty("businessDeviceHeartbeatRate"))
                        object.businessDeviceHeartbeatRate = $root.google.protobuf.Duration.toObject(message.businessDeviceHeartbeatRate, options);
                    if (message.isAdminUser != null && message.hasOwnProperty("isAdminUser"))
                        object.isAdminUser = message.isAdminUser;
                    if (message.businessCheckOrdersPollRate != null && message.hasOwnProperty("businessCheckOrdersPollRate"))
                        object.businessCheckOrdersPollRate = $root.google.protobuf.Duration.toObject(message.businessCheckOrdersPollRate, options);
                    if (message.isSuperuser != null && message.hasOwnProperty("isSuperuser"))
                        object.isSuperuser = message.isSuperuser;
                    if (message.pingUrl != null && message.hasOwnProperty("pingUrl"))
                        object.pingUrl = message.pingUrl;
                    if (message.businessIntenetConnectionPingRate != null && message.hasOwnProperty("businessIntenetConnectionPingRate"))
                        object.businessIntenetConnectionPingRate = $root.google.protobuf.Duration.toObject(message.businessIntenetConnectionPingRate, options);
                    if (message.googleAiServicesApiKey != null && message.hasOwnProperty("googleAiServicesApiKey"))
                        object.googleAiServicesApiKey = message.googleAiServicesApiKey;
                    if (message.isPrivilegedUser != null && message.hasOwnProperty("isPrivilegedUser"))
                        object.isPrivilegedUser = message.isPrivilegedUser;
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.SignInActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.SignInActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.SignInActionProto.Response";
                };

                return Response;
            })();

            return SignInActionProto;
        })();

        common.SignOutActionProto = (function() {

            /**
             * Properties of a SignOutActionProto.
             * @memberof waiternow.common
             * @interface ISignOutActionProto
             */

            /**
             * Constructs a new SignOutActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a SignOutActionProto.
             * @implements ISignOutActionProto
             * @constructor
             * @param {waiternow.common.ISignOutActionProto=} [properties] Properties to set
             */
            function SignOutActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new SignOutActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.SignOutActionProto
             * @static
             * @param {waiternow.common.ISignOutActionProto=} [properties] Properties to set
             * @returns {waiternow.common.SignOutActionProto} SignOutActionProto instance
             */
            SignOutActionProto.create = function create(properties) {
                return new SignOutActionProto(properties);
            };

            /**
             * Encodes the specified SignOutActionProto message. Does not implicitly {@link waiternow.common.SignOutActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.SignOutActionProto
             * @static
             * @param {waiternow.common.ISignOutActionProto} message SignOutActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SignOutActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified SignOutActionProto message, length delimited. Does not implicitly {@link waiternow.common.SignOutActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.SignOutActionProto
             * @static
             * @param {waiternow.common.ISignOutActionProto} message SignOutActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SignOutActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SignOutActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.SignOutActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.SignOutActionProto} SignOutActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SignOutActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.SignOutActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SignOutActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.SignOutActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.SignOutActionProto} SignOutActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SignOutActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SignOutActionProto message.
             * @function verify
             * @memberof waiternow.common.SignOutActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SignOutActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a SignOutActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.SignOutActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.SignOutActionProto} SignOutActionProto
             */
            SignOutActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.SignOutActionProto)
                    return object;
                return new $root.waiternow.common.SignOutActionProto();
            };

            /**
             * Creates a plain object from a SignOutActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.SignOutActionProto
             * @static
             * @param {waiternow.common.SignOutActionProto} message SignOutActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SignOutActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this SignOutActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.SignOutActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SignOutActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for SignOutActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.SignOutActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            SignOutActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.SignOutActionProto";
            };

            SignOutActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.SignOutActionProto
                 * @interface IRequest
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.SignOutActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.SignOutActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.SignOutActionProto.Request
                 * @static
                 * @param {waiternow.common.SignOutActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.SignOutActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.SignOutActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.SignOutActionProto.Request
                 * @static
                 * @param {waiternow.common.SignOutActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.SignOutActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.SignOutActionProto.Request
                 * @static
                 * @param {waiternow.common.SignOutActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.SignOutActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.SignOutActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.SignOutActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.SignOutActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.SignOutActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.SignOutActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.SignOutActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.SignOutActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.SignOutActionProto.Request)
                        return object;
                    return new $root.waiternow.common.SignOutActionProto.Request();
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.SignOutActionProto.Request
                 * @static
                 * @param {waiternow.common.SignOutActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject() {
                    return {};
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.SignOutActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.SignOutActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.SignOutActionProto.Request";
                };

                return Request;
            })();

            SignOutActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.SignOutActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.SignOutActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.SignOutActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.SignOutActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.SignOutActionProto.Response
                 * @static
                 * @param {waiternow.common.SignOutActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.SignOutActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.SignOutActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.SignOutActionProto.Response
                 * @static
                 * @param {waiternow.common.SignOutActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.SignOutActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.SignOutActionProto.Response
                 * @static
                 * @param {waiternow.common.SignOutActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.SignOutActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.SignOutActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.SignOutActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.SignOutActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.SignOutActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.SignOutActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.SignOutActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.SignOutActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.SignOutActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.SignOutActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.SignOutActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.SignOutActionProto.Response
                 * @static
                 * @param {waiternow.common.SignOutActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.SignOutActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.SignOutActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.SignOutActionProto.Response";
                };

                return Response;
            })();

            return SignOutActionProto;
        })();

        common.GetAuthenticatedUserActionProto = (function() {

            /**
             * Properties of a GetAuthenticatedUserActionProto.
             * @memberof waiternow.common
             * @interface IGetAuthenticatedUserActionProto
             */

            /**
             * Constructs a new GetAuthenticatedUserActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a GetAuthenticatedUserActionProto.
             * @implements IGetAuthenticatedUserActionProto
             * @constructor
             * @param {waiternow.common.IGetAuthenticatedUserActionProto=} [properties] Properties to set
             */
            function GetAuthenticatedUserActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new GetAuthenticatedUserActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.GetAuthenticatedUserActionProto
             * @static
             * @param {waiternow.common.IGetAuthenticatedUserActionProto=} [properties] Properties to set
             * @returns {waiternow.common.GetAuthenticatedUserActionProto} GetAuthenticatedUserActionProto instance
             */
            GetAuthenticatedUserActionProto.create = function create(properties) {
                return new GetAuthenticatedUserActionProto(properties);
            };

            /**
             * Encodes the specified GetAuthenticatedUserActionProto message. Does not implicitly {@link waiternow.common.GetAuthenticatedUserActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.GetAuthenticatedUserActionProto
             * @static
             * @param {waiternow.common.IGetAuthenticatedUserActionProto} message GetAuthenticatedUserActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetAuthenticatedUserActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified GetAuthenticatedUserActionProto message, length delimited. Does not implicitly {@link waiternow.common.GetAuthenticatedUserActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.GetAuthenticatedUserActionProto
             * @static
             * @param {waiternow.common.IGetAuthenticatedUserActionProto} message GetAuthenticatedUserActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetAuthenticatedUserActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetAuthenticatedUserActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.GetAuthenticatedUserActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.GetAuthenticatedUserActionProto} GetAuthenticatedUserActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetAuthenticatedUserActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetAuthenticatedUserActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetAuthenticatedUserActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.GetAuthenticatedUserActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.GetAuthenticatedUserActionProto} GetAuthenticatedUserActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetAuthenticatedUserActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetAuthenticatedUserActionProto message.
             * @function verify
             * @memberof waiternow.common.GetAuthenticatedUserActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetAuthenticatedUserActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a GetAuthenticatedUserActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.GetAuthenticatedUserActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.GetAuthenticatedUserActionProto} GetAuthenticatedUserActionProto
             */
            GetAuthenticatedUserActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.GetAuthenticatedUserActionProto)
                    return object;
                return new $root.waiternow.common.GetAuthenticatedUserActionProto();
            };

            /**
             * Creates a plain object from a GetAuthenticatedUserActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.GetAuthenticatedUserActionProto
             * @static
             * @param {waiternow.common.GetAuthenticatedUserActionProto} message GetAuthenticatedUserActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetAuthenticatedUserActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this GetAuthenticatedUserActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.GetAuthenticatedUserActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetAuthenticatedUserActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for GetAuthenticatedUserActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.GetAuthenticatedUserActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            GetAuthenticatedUserActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.GetAuthenticatedUserActionProto";
            };

            GetAuthenticatedUserActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.GetAuthenticatedUserActionProto
                 * @interface IRequest
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.GetAuthenticatedUserActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.GetAuthenticatedUserActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetAuthenticatedUserActionProto.Request
                 * @static
                 * @param {waiternow.common.GetAuthenticatedUserActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.GetAuthenticatedUserActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.GetAuthenticatedUserActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetAuthenticatedUserActionProto.Request
                 * @static
                 * @param {waiternow.common.GetAuthenticatedUserActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.GetAuthenticatedUserActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetAuthenticatedUserActionProto.Request
                 * @static
                 * @param {waiternow.common.GetAuthenticatedUserActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetAuthenticatedUserActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetAuthenticatedUserActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetAuthenticatedUserActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetAuthenticatedUserActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetAuthenticatedUserActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.GetAuthenticatedUserActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetAuthenticatedUserActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetAuthenticatedUserActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetAuthenticatedUserActionProto.Request)
                        return object;
                    return new $root.waiternow.common.GetAuthenticatedUserActionProto.Request();
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetAuthenticatedUserActionProto.Request
                 * @static
                 * @param {waiternow.common.GetAuthenticatedUserActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject() {
                    return {};
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetAuthenticatedUserActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetAuthenticatedUserActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetAuthenticatedUserActionProto.Request";
                };

                return Request;
            })();

            GetAuthenticatedUserActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.GetAuthenticatedUserActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IUserProto|null} [user] Response user
                 * @property {boolean|null} [isImpersonationAllowed] Response isImpersonationAllowed
                 * @property {boolean|null} [isAdminUser] Response isAdminUser
                 * @property {boolean|null} [isSuperuser] Response isSuperuser
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.GetAuthenticatedUserActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.GetAuthenticatedUserActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.GetAuthenticatedUserActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response user.
                 * @member {waiternow.common.IUserProto|null|undefined} user
                 * @memberof waiternow.common.GetAuthenticatedUserActionProto.Response
                 * @instance
                 */
                Response.prototype.user = null;

                /**
                 * Response isImpersonationAllowed.
                 * @member {boolean} isImpersonationAllowed
                 * @memberof waiternow.common.GetAuthenticatedUserActionProto.Response
                 * @instance
                 */
                Response.prototype.isImpersonationAllowed = false;

                /**
                 * Response isAdminUser.
                 * @member {boolean} isAdminUser
                 * @memberof waiternow.common.GetAuthenticatedUserActionProto.Response
                 * @instance
                 */
                Response.prototype.isAdminUser = false;

                /**
                 * Response isSuperuser.
                 * @member {boolean} isSuperuser
                 * @memberof waiternow.common.GetAuthenticatedUserActionProto.Response
                 * @instance
                 */
                Response.prototype.isSuperuser = false;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetAuthenticatedUserActionProto.Response
                 * @static
                 * @param {waiternow.common.GetAuthenticatedUserActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.GetAuthenticatedUserActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.GetAuthenticatedUserActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetAuthenticatedUserActionProto.Response
                 * @static
                 * @param {waiternow.common.GetAuthenticatedUserActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.user != null && Object.hasOwnProperty.call(message, "user"))
                        $root.waiternow.common.UserProto.encode(message.user, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.isImpersonationAllowed != null && Object.hasOwnProperty.call(message, "isImpersonationAllowed"))
                        writer.uint32(/* id 3, wireType 0 =*/24).bool(message.isImpersonationAllowed);
                    if (message.isAdminUser != null && Object.hasOwnProperty.call(message, "isAdminUser"))
                        writer.uint32(/* id 4, wireType 0 =*/32).bool(message.isAdminUser);
                    if (message.isSuperuser != null && Object.hasOwnProperty.call(message, "isSuperuser"))
                        writer.uint32(/* id 5, wireType 0 =*/40).bool(message.isSuperuser);
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.GetAuthenticatedUserActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetAuthenticatedUserActionProto.Response
                 * @static
                 * @param {waiternow.common.GetAuthenticatedUserActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetAuthenticatedUserActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetAuthenticatedUserActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetAuthenticatedUserActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.user = $root.waiternow.common.UserProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.isImpersonationAllowed = reader.bool();
                                break;
                            }
                        case 4: {
                                message.isAdminUser = reader.bool();
                                break;
                            }
                        case 5: {
                                message.isSuperuser = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetAuthenticatedUserActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetAuthenticatedUserActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.GetAuthenticatedUserActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.user != null && message.hasOwnProperty("user")) {
                        var error = $root.waiternow.common.UserProto.verify(message.user);
                        if (error)
                            return "user." + error;
                    }
                    if (message.isImpersonationAllowed != null && message.hasOwnProperty("isImpersonationAllowed"))
                        if (typeof message.isImpersonationAllowed !== "boolean")
                            return "isImpersonationAllowed: boolean expected";
                    if (message.isAdminUser != null && message.hasOwnProperty("isAdminUser"))
                        if (typeof message.isAdminUser !== "boolean")
                            return "isAdminUser: boolean expected";
                    if (message.isSuperuser != null && message.hasOwnProperty("isSuperuser"))
                        if (typeof message.isSuperuser !== "boolean")
                            return "isSuperuser: boolean expected";
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetAuthenticatedUserActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetAuthenticatedUserActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetAuthenticatedUserActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.GetAuthenticatedUserActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.GetAuthenticatedUserActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.user != null) {
                        if (typeof object.user !== "object")
                            throw TypeError(".waiternow.common.GetAuthenticatedUserActionProto.Response.user: object expected");
                        message.user = $root.waiternow.common.UserProto.fromObject(object.user);
                    }
                    if (object.isImpersonationAllowed != null)
                        message.isImpersonationAllowed = Boolean(object.isImpersonationAllowed);
                    if (object.isAdminUser != null)
                        message.isAdminUser = Boolean(object.isAdminUser);
                    if (object.isSuperuser != null)
                        message.isSuperuser = Boolean(object.isSuperuser);
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetAuthenticatedUserActionProto.Response
                 * @static
                 * @param {waiternow.common.GetAuthenticatedUserActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.user = null;
                        object.isImpersonationAllowed = false;
                        object.isAdminUser = false;
                        object.isSuperuser = false;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.user != null && message.hasOwnProperty("user"))
                        object.user = $root.waiternow.common.UserProto.toObject(message.user, options);
                    if (message.isImpersonationAllowed != null && message.hasOwnProperty("isImpersonationAllowed"))
                        object.isImpersonationAllowed = message.isImpersonationAllowed;
                    if (message.isAdminUser != null && message.hasOwnProperty("isAdminUser"))
                        object.isAdminUser = message.isAdminUser;
                    if (message.isSuperuser != null && message.hasOwnProperty("isSuperuser"))
                        object.isSuperuser = message.isSuperuser;
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetAuthenticatedUserActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetAuthenticatedUserActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetAuthenticatedUserActionProto.Response";
                };

                return Response;
            })();

            return GetAuthenticatedUserActionProto;
        })();

        common.GetUserActionProto = (function() {

            /**
             * Properties of a GetUserActionProto.
             * @memberof waiternow.common
             * @interface IGetUserActionProto
             */

            /**
             * Constructs a new GetUserActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a GetUserActionProto.
             * @implements IGetUserActionProto
             * @constructor
             * @param {waiternow.common.IGetUserActionProto=} [properties] Properties to set
             */
            function GetUserActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new GetUserActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.GetUserActionProto
             * @static
             * @param {waiternow.common.IGetUserActionProto=} [properties] Properties to set
             * @returns {waiternow.common.GetUserActionProto} GetUserActionProto instance
             */
            GetUserActionProto.create = function create(properties) {
                return new GetUserActionProto(properties);
            };

            /**
             * Encodes the specified GetUserActionProto message. Does not implicitly {@link waiternow.common.GetUserActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.GetUserActionProto
             * @static
             * @param {waiternow.common.IGetUserActionProto} message GetUserActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetUserActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified GetUserActionProto message, length delimited. Does not implicitly {@link waiternow.common.GetUserActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.GetUserActionProto
             * @static
             * @param {waiternow.common.IGetUserActionProto} message GetUserActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetUserActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetUserActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.GetUserActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.GetUserActionProto} GetUserActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetUserActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetUserActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetUserActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.GetUserActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.GetUserActionProto} GetUserActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetUserActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetUserActionProto message.
             * @function verify
             * @memberof waiternow.common.GetUserActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetUserActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a GetUserActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.GetUserActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.GetUserActionProto} GetUserActionProto
             */
            GetUserActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.GetUserActionProto)
                    return object;
                return new $root.waiternow.common.GetUserActionProto();
            };

            /**
             * Creates a plain object from a GetUserActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.GetUserActionProto
             * @static
             * @param {waiternow.common.GetUserActionProto} message GetUserActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetUserActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this GetUserActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.GetUserActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetUserActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for GetUserActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.GetUserActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            GetUserActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.GetUserActionProto";
            };

            GetUserActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.GetUserActionProto
                 * @interface IRequest
                 * @property {string|null} [userId] Request userId
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.GetUserActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.GetUserActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request userId.
                 * @member {string} userId
                 * @memberof waiternow.common.GetUserActionProto.Request
                 * @instance
                 */
                Request.prototype.userId = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetUserActionProto.Request
                 * @static
                 * @param {waiternow.common.GetUserActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.GetUserActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.GetUserActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetUserActionProto.Request
                 * @static
                 * @param {waiternow.common.GetUserActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.userId);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.GetUserActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetUserActionProto.Request
                 * @static
                 * @param {waiternow.common.GetUserActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetUserActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetUserActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetUserActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.userId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetUserActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetUserActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.GetUserActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.userId != null && message.hasOwnProperty("userId"))
                        if (!$util.isString(message.userId))
                            return "userId: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetUserActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetUserActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetUserActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.GetUserActionProto.Request();
                    if (object.userId != null)
                        message.userId = String(object.userId);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetUserActionProto.Request
                 * @static
                 * @param {waiternow.common.GetUserActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.userId = "";
                    if (message.userId != null && message.hasOwnProperty("userId"))
                        object.userId = message.userId;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetUserActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetUserActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetUserActionProto.Request";
                };

                return Request;
            })();

            GetUserActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.GetUserActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IUserProto|null} [user] Response user
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.GetUserActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.GetUserActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.GetUserActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response user.
                 * @member {waiternow.common.IUserProto|null|undefined} user
                 * @memberof waiternow.common.GetUserActionProto.Response
                 * @instance
                 */
                Response.prototype.user = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetUserActionProto.Response
                 * @static
                 * @param {waiternow.common.GetUserActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.GetUserActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.GetUserActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetUserActionProto.Response
                 * @static
                 * @param {waiternow.common.GetUserActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.user != null && Object.hasOwnProperty.call(message, "user"))
                        $root.waiternow.common.UserProto.encode(message.user, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.GetUserActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetUserActionProto.Response
                 * @static
                 * @param {waiternow.common.GetUserActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetUserActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetUserActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetUserActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.user = $root.waiternow.common.UserProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetUserActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetUserActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.GetUserActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.user != null && message.hasOwnProperty("user")) {
                        var error = $root.waiternow.common.UserProto.verify(message.user);
                        if (error)
                            return "user." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetUserActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetUserActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetUserActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.GetUserActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.GetUserActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.user != null) {
                        if (typeof object.user !== "object")
                            throw TypeError(".waiternow.common.GetUserActionProto.Response.user: object expected");
                        message.user = $root.waiternow.common.UserProto.fromObject(object.user);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetUserActionProto.Response
                 * @static
                 * @param {waiternow.common.GetUserActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.user = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.user != null && message.hasOwnProperty("user"))
                        object.user = $root.waiternow.common.UserProto.toObject(message.user, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetUserActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetUserActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetUserActionProto.Response";
                };

                return Response;
            })();

            return GetUserActionProto;
        })();

        common.FindUserActionProto = (function() {

            /**
             * Properties of a FindUserActionProto.
             * @memberof waiternow.common
             * @interface IFindUserActionProto
             */

            /**
             * Constructs a new FindUserActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a FindUserActionProto.
             * @implements IFindUserActionProto
             * @constructor
             * @param {waiternow.common.IFindUserActionProto=} [properties] Properties to set
             */
            function FindUserActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new FindUserActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FindUserActionProto
             * @static
             * @param {waiternow.common.IFindUserActionProto=} [properties] Properties to set
             * @returns {waiternow.common.FindUserActionProto} FindUserActionProto instance
             */
            FindUserActionProto.create = function create(properties) {
                return new FindUserActionProto(properties);
            };

            /**
             * Encodes the specified FindUserActionProto message. Does not implicitly {@link waiternow.common.FindUserActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FindUserActionProto
             * @static
             * @param {waiternow.common.IFindUserActionProto} message FindUserActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindUserActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified FindUserActionProto message, length delimited. Does not implicitly {@link waiternow.common.FindUserActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FindUserActionProto
             * @static
             * @param {waiternow.common.IFindUserActionProto} message FindUserActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindUserActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FindUserActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FindUserActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FindUserActionProto} FindUserActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindUserActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindUserActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FindUserActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FindUserActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FindUserActionProto} FindUserActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindUserActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FindUserActionProto message.
             * @function verify
             * @memberof waiternow.common.FindUserActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FindUserActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a FindUserActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FindUserActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FindUserActionProto} FindUserActionProto
             */
            FindUserActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FindUserActionProto)
                    return object;
                return new $root.waiternow.common.FindUserActionProto();
            };

            /**
             * Creates a plain object from a FindUserActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FindUserActionProto
             * @static
             * @param {waiternow.common.FindUserActionProto} message FindUserActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FindUserActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this FindUserActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FindUserActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FindUserActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FindUserActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.FindUserActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FindUserActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FindUserActionProto";
            };

            FindUserActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.FindUserActionProto
                 * @interface IRequest
                 * @property {string|null} [userEmail] Request userEmail
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.FindUserActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.FindUserActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request userEmail.
                 * @member {string} userEmail
                 * @memberof waiternow.common.FindUserActionProto.Request
                 * @instance
                 */
                Request.prototype.userEmail = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindUserActionProto.Request
                 * @static
                 * @param {waiternow.common.FindUserActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.FindUserActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.FindUserActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindUserActionProto.Request
                 * @static
                 * @param {waiternow.common.FindUserActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.userEmail != null && Object.hasOwnProperty.call(message, "userEmail"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.userEmail);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.FindUserActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindUserActionProto.Request
                 * @static
                 * @param {waiternow.common.FindUserActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindUserActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindUserActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindUserActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.userEmail = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindUserActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindUserActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.FindUserActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.userEmail != null && message.hasOwnProperty("userEmail"))
                        if (!$util.isString(message.userEmail))
                            return "userEmail: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindUserActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindUserActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindUserActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.FindUserActionProto.Request();
                    if (object.userEmail != null)
                        message.userEmail = String(object.userEmail);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindUserActionProto.Request
                 * @static
                 * @param {waiternow.common.FindUserActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.userEmail = "";
                    if (message.userEmail != null && message.hasOwnProperty("userEmail"))
                        object.userEmail = message.userEmail;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindUserActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindUserActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindUserActionProto.Request";
                };

                return Request;
            })();

            FindUserActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.FindUserActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IUserProto|null} [user] Response user
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.FindUserActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.FindUserActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.FindUserActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response user.
                 * @member {waiternow.common.IUserProto|null|undefined} user
                 * @memberof waiternow.common.FindUserActionProto.Response
                 * @instance
                 */
                Response.prototype.user = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindUserActionProto.Response
                 * @static
                 * @param {waiternow.common.FindUserActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.FindUserActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.FindUserActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindUserActionProto.Response
                 * @static
                 * @param {waiternow.common.FindUserActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.user != null && Object.hasOwnProperty.call(message, "user"))
                        $root.waiternow.common.UserProto.encode(message.user, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.FindUserActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindUserActionProto.Response
                 * @static
                 * @param {waiternow.common.FindUserActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindUserActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindUserActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindUserActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.user = $root.waiternow.common.UserProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindUserActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindUserActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.FindUserActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.user != null && message.hasOwnProperty("user")) {
                        var error = $root.waiternow.common.UserProto.verify(message.user);
                        if (error)
                            return "user." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindUserActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindUserActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindUserActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.FindUserActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.FindUserActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.user != null) {
                        if (typeof object.user !== "object")
                            throw TypeError(".waiternow.common.FindUserActionProto.Response.user: object expected");
                        message.user = $root.waiternow.common.UserProto.fromObject(object.user);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindUserActionProto.Response
                 * @static
                 * @param {waiternow.common.FindUserActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.user = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.user != null && message.hasOwnProperty("user"))
                        object.user = $root.waiternow.common.UserProto.toObject(message.user, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindUserActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindUserActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindUserActionProto.Response";
                };

                return Response;
            })();

            return FindUserActionProto;
        })();

        common.DeleteUserActionProto = (function() {

            /**
             * Properties of a DeleteUserActionProto.
             * @memberof waiternow.common
             * @interface IDeleteUserActionProto
             */

            /**
             * Constructs a new DeleteUserActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a DeleteUserActionProto.
             * @implements IDeleteUserActionProto
             * @constructor
             * @param {waiternow.common.IDeleteUserActionProto=} [properties] Properties to set
             */
            function DeleteUserActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new DeleteUserActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.DeleteUserActionProto
             * @static
             * @param {waiternow.common.IDeleteUserActionProto=} [properties] Properties to set
             * @returns {waiternow.common.DeleteUserActionProto} DeleteUserActionProto instance
             */
            DeleteUserActionProto.create = function create(properties) {
                return new DeleteUserActionProto(properties);
            };

            /**
             * Encodes the specified DeleteUserActionProto message. Does not implicitly {@link waiternow.common.DeleteUserActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.DeleteUserActionProto
             * @static
             * @param {waiternow.common.IDeleteUserActionProto} message DeleteUserActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DeleteUserActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified DeleteUserActionProto message, length delimited. Does not implicitly {@link waiternow.common.DeleteUserActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.DeleteUserActionProto
             * @static
             * @param {waiternow.common.IDeleteUserActionProto} message DeleteUserActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DeleteUserActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a DeleteUserActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.DeleteUserActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.DeleteUserActionProto} DeleteUserActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DeleteUserActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.DeleteUserActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a DeleteUserActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.DeleteUserActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.DeleteUserActionProto} DeleteUserActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DeleteUserActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a DeleteUserActionProto message.
             * @function verify
             * @memberof waiternow.common.DeleteUserActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            DeleteUserActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a DeleteUserActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.DeleteUserActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.DeleteUserActionProto} DeleteUserActionProto
             */
            DeleteUserActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.DeleteUserActionProto)
                    return object;
                return new $root.waiternow.common.DeleteUserActionProto();
            };

            /**
             * Creates a plain object from a DeleteUserActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.DeleteUserActionProto
             * @static
             * @param {waiternow.common.DeleteUserActionProto} message DeleteUserActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            DeleteUserActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this DeleteUserActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.DeleteUserActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            DeleteUserActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for DeleteUserActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.DeleteUserActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            DeleteUserActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.DeleteUserActionProto";
            };

            DeleteUserActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.DeleteUserActionProto
                 * @interface IRequest
                 * @property {string|null} [userId] Request userId
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.DeleteUserActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.DeleteUserActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request userId.
                 * @member {string} userId
                 * @memberof waiternow.common.DeleteUserActionProto.Request
                 * @instance
                 */
                Request.prototype.userId = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.DeleteUserActionProto.Request
                 * @static
                 * @param {waiternow.common.DeleteUserActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.DeleteUserActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.DeleteUserActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.DeleteUserActionProto.Request
                 * @static
                 * @param {waiternow.common.DeleteUserActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.userId);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.DeleteUserActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.DeleteUserActionProto.Request
                 * @static
                 * @param {waiternow.common.DeleteUserActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.DeleteUserActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.DeleteUserActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.DeleteUserActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.userId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.DeleteUserActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.DeleteUserActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.DeleteUserActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.userId != null && message.hasOwnProperty("userId"))
                        if (!$util.isString(message.userId))
                            return "userId: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.DeleteUserActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.DeleteUserActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.DeleteUserActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.DeleteUserActionProto.Request();
                    if (object.userId != null)
                        message.userId = String(object.userId);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.DeleteUserActionProto.Request
                 * @static
                 * @param {waiternow.common.DeleteUserActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.userId = "";
                    if (message.userId != null && message.hasOwnProperty("userId"))
                        object.userId = message.userId;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.DeleteUserActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.DeleteUserActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.DeleteUserActionProto.Request";
                };

                return Request;
            })();

            DeleteUserActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.DeleteUserActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.DeleteUserActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.DeleteUserActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.DeleteUserActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.DeleteUserActionProto.Response
                 * @static
                 * @param {waiternow.common.DeleteUserActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.DeleteUserActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.DeleteUserActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.DeleteUserActionProto.Response
                 * @static
                 * @param {waiternow.common.DeleteUserActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.DeleteUserActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.DeleteUserActionProto.Response
                 * @static
                 * @param {waiternow.common.DeleteUserActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.DeleteUserActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.DeleteUserActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.DeleteUserActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.DeleteUserActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.DeleteUserActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.DeleteUserActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.DeleteUserActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.DeleteUserActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.DeleteUserActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.DeleteUserActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.DeleteUserActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.DeleteUserActionProto.Response
                 * @static
                 * @param {waiternow.common.DeleteUserActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.DeleteUserActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.DeleteUserActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.DeleteUserActionProto.Response";
                };

                return Response;
            })();

            return DeleteUserActionProto;
        })();

        common.UpdateUserActionProto = (function() {

            /**
             * Properties of an UpdateUserActionProto.
             * @memberof waiternow.common
             * @interface IUpdateUserActionProto
             */

            /**
             * Constructs a new UpdateUserActionProto.
             * @memberof waiternow.common
             * @classdesc Represents an UpdateUserActionProto.
             * @implements IUpdateUserActionProto
             * @constructor
             * @param {waiternow.common.IUpdateUserActionProto=} [properties] Properties to set
             */
            function UpdateUserActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new UpdateUserActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.UpdateUserActionProto
             * @static
             * @param {waiternow.common.IUpdateUserActionProto=} [properties] Properties to set
             * @returns {waiternow.common.UpdateUserActionProto} UpdateUserActionProto instance
             */
            UpdateUserActionProto.create = function create(properties) {
                return new UpdateUserActionProto(properties);
            };

            /**
             * Encodes the specified UpdateUserActionProto message. Does not implicitly {@link waiternow.common.UpdateUserActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.UpdateUserActionProto
             * @static
             * @param {waiternow.common.IUpdateUserActionProto} message UpdateUserActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UpdateUserActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified UpdateUserActionProto message, length delimited. Does not implicitly {@link waiternow.common.UpdateUserActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.UpdateUserActionProto
             * @static
             * @param {waiternow.common.IUpdateUserActionProto} message UpdateUserActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UpdateUserActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an UpdateUserActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.UpdateUserActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.UpdateUserActionProto} UpdateUserActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UpdateUserActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.UpdateUserActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an UpdateUserActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.UpdateUserActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.UpdateUserActionProto} UpdateUserActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UpdateUserActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an UpdateUserActionProto message.
             * @function verify
             * @memberof waiternow.common.UpdateUserActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            UpdateUserActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates an UpdateUserActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.UpdateUserActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.UpdateUserActionProto} UpdateUserActionProto
             */
            UpdateUserActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.UpdateUserActionProto)
                    return object;
                return new $root.waiternow.common.UpdateUserActionProto();
            };

            /**
             * Creates a plain object from an UpdateUserActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.UpdateUserActionProto
             * @static
             * @param {waiternow.common.UpdateUserActionProto} message UpdateUserActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            UpdateUserActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this UpdateUserActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.UpdateUserActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            UpdateUserActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for UpdateUserActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.UpdateUserActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            UpdateUserActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.UpdateUserActionProto";
            };

            UpdateUserActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.UpdateUserActionProto
                 * @interface IRequest
                 * @property {waiternow.common.IUserProto|null} [user] Request user
                 * @property {Array.<waiternow.common.UpdateUserActionProto.Request.RemovableField>|null} [fieldsToRemove] Request fieldsToRemove
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.UpdateUserActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.UpdateUserActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    this.fieldsToRemove = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request user.
                 * @member {waiternow.common.IUserProto|null|undefined} user
                 * @memberof waiternow.common.UpdateUserActionProto.Request
                 * @instance
                 */
                Request.prototype.user = null;

                /**
                 * Request fieldsToRemove.
                 * @member {Array.<waiternow.common.UpdateUserActionProto.Request.RemovableField>} fieldsToRemove
                 * @memberof waiternow.common.UpdateUserActionProto.Request
                 * @instance
                 */
                Request.prototype.fieldsToRemove = $util.emptyArray;

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.UpdateUserActionProto.Request
                 * @static
                 * @param {waiternow.common.UpdateUserActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.UpdateUserActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.UpdateUserActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.UpdateUserActionProto.Request
                 * @static
                 * @param {waiternow.common.UpdateUserActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.user != null && Object.hasOwnProperty.call(message, "user"))
                        $root.waiternow.common.UserProto.encode(message.user, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.fieldsToRemove != null && message.fieldsToRemove.length) {
                        writer.uint32(/* id 2, wireType 2 =*/18).fork();
                        for (var i = 0; i < message.fieldsToRemove.length; ++i)
                            writer.int32(message.fieldsToRemove[i]);
                        writer.ldelim();
                    }
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.UpdateUserActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.UpdateUserActionProto.Request
                 * @static
                 * @param {waiternow.common.UpdateUserActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.UpdateUserActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.UpdateUserActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.UpdateUserActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.user = $root.waiternow.common.UserProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                if (!(message.fieldsToRemove && message.fieldsToRemove.length))
                                    message.fieldsToRemove = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.fieldsToRemove.push(reader.int32());
                                } else
                                    message.fieldsToRemove.push(reader.int32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.UpdateUserActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.UpdateUserActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.UpdateUserActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.user != null && message.hasOwnProperty("user")) {
                        var error = $root.waiternow.common.UserProto.verify(message.user);
                        if (error)
                            return "user." + error;
                    }
                    if (message.fieldsToRemove != null && message.hasOwnProperty("fieldsToRemove")) {
                        if (!Array.isArray(message.fieldsToRemove))
                            return "fieldsToRemove: array expected";
                        for (var i = 0; i < message.fieldsToRemove.length; ++i)
                            switch (message.fieldsToRemove[i]) {
                            default:
                                return "fieldsToRemove: enum value[] expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                    }
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.UpdateUserActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.UpdateUserActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.UpdateUserActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.UpdateUserActionProto.Request();
                    if (object.user != null) {
                        if (typeof object.user !== "object")
                            throw TypeError(".waiternow.common.UpdateUserActionProto.Request.user: object expected");
                        message.user = $root.waiternow.common.UserProto.fromObject(object.user);
                    }
                    if (object.fieldsToRemove) {
                        if (!Array.isArray(object.fieldsToRemove))
                            throw TypeError(".waiternow.common.UpdateUserActionProto.Request.fieldsToRemove: array expected");
                        message.fieldsToRemove = [];
                        for (var i = 0; i < object.fieldsToRemove.length; ++i)
                            switch (object.fieldsToRemove[i]) {
                            default:
                                if (typeof object.fieldsToRemove[i] === "number") {
                                    message.fieldsToRemove[i] = object.fieldsToRemove[i];
                                    break;
                                }
                            case "REMOVABLE_FIELD_UNSPECIFIED":
                            case 0:
                                message.fieldsToRemove[i] = 0;
                                break;
                            case "PHONE_NUMBER":
                            case 1:
                                message.fieldsToRemove[i] = 1;
                                break;
                            case "SETTINGS_PREFERRED_CONTACT_MEDIUM":
                            case 2:
                                message.fieldsToRemove[i] = 2;
                                break;
                            }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.UpdateUserActionProto.Request
                 * @static
                 * @param {waiternow.common.UpdateUserActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.fieldsToRemove = [];
                    if (options.defaults)
                        object.user = null;
                    if (message.user != null && message.hasOwnProperty("user"))
                        object.user = $root.waiternow.common.UserProto.toObject(message.user, options);
                    if (message.fieldsToRemove && message.fieldsToRemove.length) {
                        object.fieldsToRemove = [];
                        for (var j = 0; j < message.fieldsToRemove.length; ++j)
                            object.fieldsToRemove[j] = options.enums === String ? $root.waiternow.common.UpdateUserActionProto.Request.RemovableField[message.fieldsToRemove[j]] === undefined ? message.fieldsToRemove[j] : $root.waiternow.common.UpdateUserActionProto.Request.RemovableField[message.fieldsToRemove[j]] : message.fieldsToRemove[j];
                    }
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.UpdateUserActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.UpdateUserActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.UpdateUserActionProto.Request";
                };

                /**
                 * RemovableField enum.
                 * @name waiternow.common.UpdateUserActionProto.Request.RemovableField
                 * @enum {number}
                 * @property {number} REMOVABLE_FIELD_UNSPECIFIED=0 REMOVABLE_FIELD_UNSPECIFIED value
                 * @property {number} PHONE_NUMBER=1 PHONE_NUMBER value
                 * @property {number} SETTINGS_PREFERRED_CONTACT_MEDIUM=2 SETTINGS_PREFERRED_CONTACT_MEDIUM value
                 */
                Request.RemovableField = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "REMOVABLE_FIELD_UNSPECIFIED"] = 0;
                    values[valuesById[1] = "PHONE_NUMBER"] = 1;
                    values[valuesById[2] = "SETTINGS_PREFERRED_CONTACT_MEDIUM"] = 2;
                    return values;
                })();

                return Request;
            })();

            UpdateUserActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.UpdateUserActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.UpdateUserActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.UpdateUserActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.UpdateUserActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.UpdateUserActionProto.Response
                 * @static
                 * @param {waiternow.common.UpdateUserActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.UpdateUserActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.UpdateUserActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.UpdateUserActionProto.Response
                 * @static
                 * @param {waiternow.common.UpdateUserActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.UpdateUserActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.UpdateUserActionProto.Response
                 * @static
                 * @param {waiternow.common.UpdateUserActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.UpdateUserActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.UpdateUserActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.UpdateUserActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.UpdateUserActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.UpdateUserActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.UpdateUserActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.UpdateUserActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.UpdateUserActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.UpdateUserActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.UpdateUserActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.UpdateUserActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.UpdateUserActionProto.Response
                 * @static
                 * @param {waiternow.common.UpdateUserActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.UpdateUserActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.UpdateUserActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.UpdateUserActionProto.Response";
                };

                return Response;
            })();

            return UpdateUserActionProto;
        })();

        common.ChangePasswordActionProto = (function() {

            /**
             * Properties of a ChangePasswordActionProto.
             * @memberof waiternow.common
             * @interface IChangePasswordActionProto
             */

            /**
             * Constructs a new ChangePasswordActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a ChangePasswordActionProto.
             * @implements IChangePasswordActionProto
             * @constructor
             * @param {waiternow.common.IChangePasswordActionProto=} [properties] Properties to set
             */
            function ChangePasswordActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new ChangePasswordActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.ChangePasswordActionProto
             * @static
             * @param {waiternow.common.IChangePasswordActionProto=} [properties] Properties to set
             * @returns {waiternow.common.ChangePasswordActionProto} ChangePasswordActionProto instance
             */
            ChangePasswordActionProto.create = function create(properties) {
                return new ChangePasswordActionProto(properties);
            };

            /**
             * Encodes the specified ChangePasswordActionProto message. Does not implicitly {@link waiternow.common.ChangePasswordActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.ChangePasswordActionProto
             * @static
             * @param {waiternow.common.IChangePasswordActionProto} message ChangePasswordActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ChangePasswordActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified ChangePasswordActionProto message, length delimited. Does not implicitly {@link waiternow.common.ChangePasswordActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.ChangePasswordActionProto
             * @static
             * @param {waiternow.common.IChangePasswordActionProto} message ChangePasswordActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ChangePasswordActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ChangePasswordActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.ChangePasswordActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.ChangePasswordActionProto} ChangePasswordActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ChangePasswordActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.ChangePasswordActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ChangePasswordActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.ChangePasswordActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.ChangePasswordActionProto} ChangePasswordActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ChangePasswordActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ChangePasswordActionProto message.
             * @function verify
             * @memberof waiternow.common.ChangePasswordActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ChangePasswordActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a ChangePasswordActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.ChangePasswordActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.ChangePasswordActionProto} ChangePasswordActionProto
             */
            ChangePasswordActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.ChangePasswordActionProto)
                    return object;
                return new $root.waiternow.common.ChangePasswordActionProto();
            };

            /**
             * Creates a plain object from a ChangePasswordActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.ChangePasswordActionProto
             * @static
             * @param {waiternow.common.ChangePasswordActionProto} message ChangePasswordActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ChangePasswordActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this ChangePasswordActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.ChangePasswordActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ChangePasswordActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for ChangePasswordActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.ChangePasswordActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            ChangePasswordActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.ChangePasswordActionProto";
            };

            ChangePasswordActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.ChangePasswordActionProto
                 * @interface IRequest
                 * @property {string|null} [currentPassword] Request currentPassword
                 * @property {string|null} [newPassword] Request newPassword
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.ChangePasswordActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.ChangePasswordActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request currentPassword.
                 * @member {string} currentPassword
                 * @memberof waiternow.common.ChangePasswordActionProto.Request
                 * @instance
                 */
                Request.prototype.currentPassword = "";

                /**
                 * Request newPassword.
                 * @member {string} newPassword
                 * @memberof waiternow.common.ChangePasswordActionProto.Request
                 * @instance
                 */
                Request.prototype.newPassword = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.ChangePasswordActionProto.Request
                 * @static
                 * @param {waiternow.common.ChangePasswordActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.ChangePasswordActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.ChangePasswordActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.ChangePasswordActionProto.Request
                 * @static
                 * @param {waiternow.common.ChangePasswordActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.currentPassword != null && Object.hasOwnProperty.call(message, "currentPassword"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.currentPassword);
                    if (message.newPassword != null && Object.hasOwnProperty.call(message, "newPassword"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.newPassword);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.ChangePasswordActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.ChangePasswordActionProto.Request
                 * @static
                 * @param {waiternow.common.ChangePasswordActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.ChangePasswordActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.ChangePasswordActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.ChangePasswordActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.currentPassword = reader.string();
                                break;
                            }
                        case 2: {
                                message.newPassword = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.ChangePasswordActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.ChangePasswordActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.ChangePasswordActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.currentPassword != null && message.hasOwnProperty("currentPassword"))
                        if (!$util.isString(message.currentPassword))
                            return "currentPassword: string expected";
                    if (message.newPassword != null && message.hasOwnProperty("newPassword"))
                        if (!$util.isString(message.newPassword))
                            return "newPassword: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.ChangePasswordActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.ChangePasswordActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.ChangePasswordActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.ChangePasswordActionProto.Request();
                    if (object.currentPassword != null)
                        message.currentPassword = String(object.currentPassword);
                    if (object.newPassword != null)
                        message.newPassword = String(object.newPassword);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.ChangePasswordActionProto.Request
                 * @static
                 * @param {waiternow.common.ChangePasswordActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.currentPassword = "";
                        object.newPassword = "";
                    }
                    if (message.currentPassword != null && message.hasOwnProperty("currentPassword"))
                        object.currentPassword = message.currentPassword;
                    if (message.newPassword != null && message.hasOwnProperty("newPassword"))
                        object.newPassword = message.newPassword;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.ChangePasswordActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.ChangePasswordActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.ChangePasswordActionProto.Request";
                };

                return Request;
            })();

            ChangePasswordActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.ChangePasswordActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.ChangePasswordActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.ChangePasswordActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.ChangePasswordActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.ChangePasswordActionProto.Response
                 * @static
                 * @param {waiternow.common.ChangePasswordActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.ChangePasswordActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.ChangePasswordActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.ChangePasswordActionProto.Response
                 * @static
                 * @param {waiternow.common.ChangePasswordActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.ChangePasswordActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.ChangePasswordActionProto.Response
                 * @static
                 * @param {waiternow.common.ChangePasswordActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.ChangePasswordActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.ChangePasswordActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.ChangePasswordActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.ChangePasswordActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.ChangePasswordActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.ChangePasswordActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.ChangePasswordActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.ChangePasswordActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.ChangePasswordActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.ChangePasswordActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.ChangePasswordActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.ChangePasswordActionProto.Response
                 * @static
                 * @param {waiternow.common.ChangePasswordActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.ChangePasswordActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.ChangePasswordActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.ChangePasswordActionProto.Response";
                };

                return Response;
            })();

            return ChangePasswordActionProto;
        })();

        common.ResetPasswordActionProto = (function() {

            /**
             * Properties of a ResetPasswordActionProto.
             * @memberof waiternow.common
             * @interface IResetPasswordActionProto
             */

            /**
             * Constructs a new ResetPasswordActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a ResetPasswordActionProto.
             * @implements IResetPasswordActionProto
             * @constructor
             * @param {waiternow.common.IResetPasswordActionProto=} [properties] Properties to set
             */
            function ResetPasswordActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new ResetPasswordActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.ResetPasswordActionProto
             * @static
             * @param {waiternow.common.IResetPasswordActionProto=} [properties] Properties to set
             * @returns {waiternow.common.ResetPasswordActionProto} ResetPasswordActionProto instance
             */
            ResetPasswordActionProto.create = function create(properties) {
                return new ResetPasswordActionProto(properties);
            };

            /**
             * Encodes the specified ResetPasswordActionProto message. Does not implicitly {@link waiternow.common.ResetPasswordActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.ResetPasswordActionProto
             * @static
             * @param {waiternow.common.IResetPasswordActionProto} message ResetPasswordActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ResetPasswordActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified ResetPasswordActionProto message, length delimited. Does not implicitly {@link waiternow.common.ResetPasswordActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.ResetPasswordActionProto
             * @static
             * @param {waiternow.common.IResetPasswordActionProto} message ResetPasswordActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ResetPasswordActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ResetPasswordActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.ResetPasswordActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.ResetPasswordActionProto} ResetPasswordActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ResetPasswordActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.ResetPasswordActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ResetPasswordActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.ResetPasswordActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.ResetPasswordActionProto} ResetPasswordActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ResetPasswordActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ResetPasswordActionProto message.
             * @function verify
             * @memberof waiternow.common.ResetPasswordActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ResetPasswordActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a ResetPasswordActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.ResetPasswordActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.ResetPasswordActionProto} ResetPasswordActionProto
             */
            ResetPasswordActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.ResetPasswordActionProto)
                    return object;
                return new $root.waiternow.common.ResetPasswordActionProto();
            };

            /**
             * Creates a plain object from a ResetPasswordActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.ResetPasswordActionProto
             * @static
             * @param {waiternow.common.ResetPasswordActionProto} message ResetPasswordActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ResetPasswordActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this ResetPasswordActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.ResetPasswordActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ResetPasswordActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for ResetPasswordActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.ResetPasswordActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            ResetPasswordActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.ResetPasswordActionProto";
            };

            ResetPasswordActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.ResetPasswordActionProto
                 * @interface IRequest
                 * @property {string|null} [email] Request email
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.ResetPasswordActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.ResetPasswordActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request email.
                 * @member {string} email
                 * @memberof waiternow.common.ResetPasswordActionProto.Request
                 * @instance
                 */
                Request.prototype.email = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.ResetPasswordActionProto.Request
                 * @static
                 * @param {waiternow.common.ResetPasswordActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.ResetPasswordActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.ResetPasswordActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.ResetPasswordActionProto.Request
                 * @static
                 * @param {waiternow.common.ResetPasswordActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.ResetPasswordActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.ResetPasswordActionProto.Request
                 * @static
                 * @param {waiternow.common.ResetPasswordActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.ResetPasswordActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.ResetPasswordActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.ResetPasswordActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.email = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.ResetPasswordActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.ResetPasswordActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.ResetPasswordActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.email != null && message.hasOwnProperty("email"))
                        if (!$util.isString(message.email))
                            return "email: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.ResetPasswordActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.ResetPasswordActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.ResetPasswordActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.ResetPasswordActionProto.Request();
                    if (object.email != null)
                        message.email = String(object.email);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.ResetPasswordActionProto.Request
                 * @static
                 * @param {waiternow.common.ResetPasswordActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.email = "";
                    if (message.email != null && message.hasOwnProperty("email"))
                        object.email = message.email;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.ResetPasswordActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.ResetPasswordActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.ResetPasswordActionProto.Request";
                };

                return Request;
            })();

            ResetPasswordActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.ResetPasswordActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.ResetPasswordActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.ResetPasswordActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.ResetPasswordActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.ResetPasswordActionProto.Response
                 * @static
                 * @param {waiternow.common.ResetPasswordActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.ResetPasswordActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.ResetPasswordActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.ResetPasswordActionProto.Response
                 * @static
                 * @param {waiternow.common.ResetPasswordActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.ResetPasswordActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.ResetPasswordActionProto.Response
                 * @static
                 * @param {waiternow.common.ResetPasswordActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.ResetPasswordActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.ResetPasswordActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.ResetPasswordActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.ResetPasswordActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.ResetPasswordActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.ResetPasswordActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.ResetPasswordActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.ResetPasswordActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.ResetPasswordActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.ResetPasswordActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.ResetPasswordActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.ResetPasswordActionProto.Response
                 * @static
                 * @param {waiternow.common.ResetPasswordActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.ResetPasswordActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.ResetPasswordActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.ResetPasswordActionProto.Response";
                };

                return Response;
            })();

            return ResetPasswordActionProto;
        })();

        common.VerifyResetPasswordActionProto = (function() {

            /**
             * Properties of a VerifyResetPasswordActionProto.
             * @memberof waiternow.common
             * @interface IVerifyResetPasswordActionProto
             */

            /**
             * Constructs a new VerifyResetPasswordActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a VerifyResetPasswordActionProto.
             * @implements IVerifyResetPasswordActionProto
             * @constructor
             * @param {waiternow.common.IVerifyResetPasswordActionProto=} [properties] Properties to set
             */
            function VerifyResetPasswordActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new VerifyResetPasswordActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.VerifyResetPasswordActionProto
             * @static
             * @param {waiternow.common.IVerifyResetPasswordActionProto=} [properties] Properties to set
             * @returns {waiternow.common.VerifyResetPasswordActionProto} VerifyResetPasswordActionProto instance
             */
            VerifyResetPasswordActionProto.create = function create(properties) {
                return new VerifyResetPasswordActionProto(properties);
            };

            /**
             * Encodes the specified VerifyResetPasswordActionProto message. Does not implicitly {@link waiternow.common.VerifyResetPasswordActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.VerifyResetPasswordActionProto
             * @static
             * @param {waiternow.common.IVerifyResetPasswordActionProto} message VerifyResetPasswordActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            VerifyResetPasswordActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified VerifyResetPasswordActionProto message, length delimited. Does not implicitly {@link waiternow.common.VerifyResetPasswordActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.VerifyResetPasswordActionProto
             * @static
             * @param {waiternow.common.IVerifyResetPasswordActionProto} message VerifyResetPasswordActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            VerifyResetPasswordActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a VerifyResetPasswordActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.VerifyResetPasswordActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.VerifyResetPasswordActionProto} VerifyResetPasswordActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            VerifyResetPasswordActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.VerifyResetPasswordActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a VerifyResetPasswordActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.VerifyResetPasswordActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.VerifyResetPasswordActionProto} VerifyResetPasswordActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            VerifyResetPasswordActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a VerifyResetPasswordActionProto message.
             * @function verify
             * @memberof waiternow.common.VerifyResetPasswordActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            VerifyResetPasswordActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a VerifyResetPasswordActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.VerifyResetPasswordActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.VerifyResetPasswordActionProto} VerifyResetPasswordActionProto
             */
            VerifyResetPasswordActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.VerifyResetPasswordActionProto)
                    return object;
                return new $root.waiternow.common.VerifyResetPasswordActionProto();
            };

            /**
             * Creates a plain object from a VerifyResetPasswordActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.VerifyResetPasswordActionProto
             * @static
             * @param {waiternow.common.VerifyResetPasswordActionProto} message VerifyResetPasswordActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            VerifyResetPasswordActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this VerifyResetPasswordActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.VerifyResetPasswordActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            VerifyResetPasswordActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for VerifyResetPasswordActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.VerifyResetPasswordActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            VerifyResetPasswordActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.VerifyResetPasswordActionProto";
            };

            VerifyResetPasswordActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.VerifyResetPasswordActionProto
                 * @interface IRequest
                 * @property {string|null} [authenticityToken] Request authenticityToken
                 * @property {string|null} [newPassword] Request newPassword
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.VerifyResetPasswordActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.VerifyResetPasswordActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request authenticityToken.
                 * @member {string} authenticityToken
                 * @memberof waiternow.common.VerifyResetPasswordActionProto.Request
                 * @instance
                 */
                Request.prototype.authenticityToken = "";

                /**
                 * Request newPassword.
                 * @member {string} newPassword
                 * @memberof waiternow.common.VerifyResetPasswordActionProto.Request
                 * @instance
                 */
                Request.prototype.newPassword = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.VerifyResetPasswordActionProto.Request
                 * @static
                 * @param {waiternow.common.VerifyResetPasswordActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.VerifyResetPasswordActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.VerifyResetPasswordActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.VerifyResetPasswordActionProto.Request
                 * @static
                 * @param {waiternow.common.VerifyResetPasswordActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.authenticityToken != null && Object.hasOwnProperty.call(message, "authenticityToken"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.authenticityToken);
                    if (message.newPassword != null && Object.hasOwnProperty.call(message, "newPassword"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.newPassword);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.VerifyResetPasswordActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.VerifyResetPasswordActionProto.Request
                 * @static
                 * @param {waiternow.common.VerifyResetPasswordActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.VerifyResetPasswordActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.VerifyResetPasswordActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.VerifyResetPasswordActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.authenticityToken = reader.string();
                                break;
                            }
                        case 2: {
                                message.newPassword = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.VerifyResetPasswordActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.VerifyResetPasswordActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.VerifyResetPasswordActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.authenticityToken != null && message.hasOwnProperty("authenticityToken"))
                        if (!$util.isString(message.authenticityToken))
                            return "authenticityToken: string expected";
                    if (message.newPassword != null && message.hasOwnProperty("newPassword"))
                        if (!$util.isString(message.newPassword))
                            return "newPassword: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.VerifyResetPasswordActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.VerifyResetPasswordActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.VerifyResetPasswordActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.VerifyResetPasswordActionProto.Request();
                    if (object.authenticityToken != null)
                        message.authenticityToken = String(object.authenticityToken);
                    if (object.newPassword != null)
                        message.newPassword = String(object.newPassword);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.VerifyResetPasswordActionProto.Request
                 * @static
                 * @param {waiternow.common.VerifyResetPasswordActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.authenticityToken = "";
                        object.newPassword = "";
                    }
                    if (message.authenticityToken != null && message.hasOwnProperty("authenticityToken"))
                        object.authenticityToken = message.authenticityToken;
                    if (message.newPassword != null && message.hasOwnProperty("newPassword"))
                        object.newPassword = message.newPassword;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.VerifyResetPasswordActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.VerifyResetPasswordActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.VerifyResetPasswordActionProto.Request";
                };

                return Request;
            })();

            VerifyResetPasswordActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.VerifyResetPasswordActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.VerifyResetPasswordActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.VerifyResetPasswordActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.VerifyResetPasswordActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.VerifyResetPasswordActionProto.Response
                 * @static
                 * @param {waiternow.common.VerifyResetPasswordActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.VerifyResetPasswordActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.VerifyResetPasswordActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.VerifyResetPasswordActionProto.Response
                 * @static
                 * @param {waiternow.common.VerifyResetPasswordActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.VerifyResetPasswordActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.VerifyResetPasswordActionProto.Response
                 * @static
                 * @param {waiternow.common.VerifyResetPasswordActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.VerifyResetPasswordActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.VerifyResetPasswordActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.VerifyResetPasswordActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.VerifyResetPasswordActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.VerifyResetPasswordActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.VerifyResetPasswordActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.VerifyResetPasswordActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.VerifyResetPasswordActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.VerifyResetPasswordActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.VerifyResetPasswordActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.VerifyResetPasswordActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.VerifyResetPasswordActionProto.Response
                 * @static
                 * @param {waiternow.common.VerifyResetPasswordActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.VerifyResetPasswordActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.VerifyResetPasswordActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.VerifyResetPasswordActionProto.Response";
                };

                return Response;
            })();

            return VerifyResetPasswordActionProto;
        })();

        common.GetGoogleApiKeysActionProto = (function() {

            /**
             * Properties of a GetGoogleApiKeysActionProto.
             * @memberof waiternow.common
             * @interface IGetGoogleApiKeysActionProto
             */

            /**
             * Constructs a new GetGoogleApiKeysActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a GetGoogleApiKeysActionProto.
             * @implements IGetGoogleApiKeysActionProto
             * @constructor
             * @param {waiternow.common.IGetGoogleApiKeysActionProto=} [properties] Properties to set
             */
            function GetGoogleApiKeysActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new GetGoogleApiKeysActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.GetGoogleApiKeysActionProto
             * @static
             * @param {waiternow.common.IGetGoogleApiKeysActionProto=} [properties] Properties to set
             * @returns {waiternow.common.GetGoogleApiKeysActionProto} GetGoogleApiKeysActionProto instance
             */
            GetGoogleApiKeysActionProto.create = function create(properties) {
                return new GetGoogleApiKeysActionProto(properties);
            };

            /**
             * Encodes the specified GetGoogleApiKeysActionProto message. Does not implicitly {@link waiternow.common.GetGoogleApiKeysActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.GetGoogleApiKeysActionProto
             * @static
             * @param {waiternow.common.IGetGoogleApiKeysActionProto} message GetGoogleApiKeysActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetGoogleApiKeysActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified GetGoogleApiKeysActionProto message, length delimited. Does not implicitly {@link waiternow.common.GetGoogleApiKeysActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.GetGoogleApiKeysActionProto
             * @static
             * @param {waiternow.common.IGetGoogleApiKeysActionProto} message GetGoogleApiKeysActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetGoogleApiKeysActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetGoogleApiKeysActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.GetGoogleApiKeysActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.GetGoogleApiKeysActionProto} GetGoogleApiKeysActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetGoogleApiKeysActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetGoogleApiKeysActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetGoogleApiKeysActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.GetGoogleApiKeysActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.GetGoogleApiKeysActionProto} GetGoogleApiKeysActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetGoogleApiKeysActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetGoogleApiKeysActionProto message.
             * @function verify
             * @memberof waiternow.common.GetGoogleApiKeysActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetGoogleApiKeysActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a GetGoogleApiKeysActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.GetGoogleApiKeysActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.GetGoogleApiKeysActionProto} GetGoogleApiKeysActionProto
             */
            GetGoogleApiKeysActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.GetGoogleApiKeysActionProto)
                    return object;
                return new $root.waiternow.common.GetGoogleApiKeysActionProto();
            };

            /**
             * Creates a plain object from a GetGoogleApiKeysActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.GetGoogleApiKeysActionProto
             * @static
             * @param {waiternow.common.GetGoogleApiKeysActionProto} message GetGoogleApiKeysActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetGoogleApiKeysActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this GetGoogleApiKeysActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.GetGoogleApiKeysActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetGoogleApiKeysActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for GetGoogleApiKeysActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.GetGoogleApiKeysActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            GetGoogleApiKeysActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.GetGoogleApiKeysActionProto";
            };

            GetGoogleApiKeysActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.GetGoogleApiKeysActionProto
                 * @interface IRequest
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.GetGoogleApiKeysActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.GetGoogleApiKeysActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetGoogleApiKeysActionProto.Request
                 * @static
                 * @param {waiternow.common.GetGoogleApiKeysActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.GetGoogleApiKeysActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.GetGoogleApiKeysActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetGoogleApiKeysActionProto.Request
                 * @static
                 * @param {waiternow.common.GetGoogleApiKeysActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.GetGoogleApiKeysActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetGoogleApiKeysActionProto.Request
                 * @static
                 * @param {waiternow.common.GetGoogleApiKeysActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetGoogleApiKeysActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetGoogleApiKeysActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetGoogleApiKeysActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetGoogleApiKeysActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetGoogleApiKeysActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.GetGoogleApiKeysActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetGoogleApiKeysActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetGoogleApiKeysActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetGoogleApiKeysActionProto.Request)
                        return object;
                    return new $root.waiternow.common.GetGoogleApiKeysActionProto.Request();
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetGoogleApiKeysActionProto.Request
                 * @static
                 * @param {waiternow.common.GetGoogleApiKeysActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject() {
                    return {};
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetGoogleApiKeysActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetGoogleApiKeysActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetGoogleApiKeysActionProto.Request";
                };

                return Request;
            })();

            GetGoogleApiKeysActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.GetGoogleApiKeysActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {string|null} [googleAiServicesApiKey] Response googleAiServicesApiKey
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.GetGoogleApiKeysActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.GetGoogleApiKeysActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.GetGoogleApiKeysActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response googleAiServicesApiKey.
                 * @member {string} googleAiServicesApiKey
                 * @memberof waiternow.common.GetGoogleApiKeysActionProto.Response
                 * @instance
                 */
                Response.prototype.googleAiServicesApiKey = "";

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetGoogleApiKeysActionProto.Response
                 * @static
                 * @param {waiternow.common.GetGoogleApiKeysActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.GetGoogleApiKeysActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.GetGoogleApiKeysActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetGoogleApiKeysActionProto.Response
                 * @static
                 * @param {waiternow.common.GetGoogleApiKeysActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.googleAiServicesApiKey != null && Object.hasOwnProperty.call(message, "googleAiServicesApiKey"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.googleAiServicesApiKey);
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.GetGoogleApiKeysActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetGoogleApiKeysActionProto.Response
                 * @static
                 * @param {waiternow.common.GetGoogleApiKeysActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetGoogleApiKeysActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetGoogleApiKeysActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetGoogleApiKeysActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.googleAiServicesApiKey = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetGoogleApiKeysActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetGoogleApiKeysActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.GetGoogleApiKeysActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.googleAiServicesApiKey != null && message.hasOwnProperty("googleAiServicesApiKey"))
                        if (!$util.isString(message.googleAiServicesApiKey))
                            return "googleAiServicesApiKey: string expected";
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetGoogleApiKeysActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetGoogleApiKeysActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetGoogleApiKeysActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.GetGoogleApiKeysActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.GetGoogleApiKeysActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.googleAiServicesApiKey != null)
                        message.googleAiServicesApiKey = String(object.googleAiServicesApiKey);
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetGoogleApiKeysActionProto.Response
                 * @static
                 * @param {waiternow.common.GetGoogleApiKeysActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.googleAiServicesApiKey = "";
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.googleAiServicesApiKey != null && message.hasOwnProperty("googleAiServicesApiKey"))
                        object.googleAiServicesApiKey = message.googleAiServicesApiKey;
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetGoogleApiKeysActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetGoogleApiKeysActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetGoogleApiKeysActionProto.Response";
                };

                return Response;
            })();

            return GetGoogleApiKeysActionProto;
        })();

        common.CreateBusinessActionProto = (function() {

            /**
             * Properties of a CreateBusinessActionProto.
             * @memberof waiternow.common
             * @interface ICreateBusinessActionProto
             */

            /**
             * Constructs a new CreateBusinessActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a CreateBusinessActionProto.
             * @implements ICreateBusinessActionProto
             * @constructor
             * @param {waiternow.common.ICreateBusinessActionProto=} [properties] Properties to set
             */
            function CreateBusinessActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new CreateBusinessActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.CreateBusinessActionProto
             * @static
             * @param {waiternow.common.ICreateBusinessActionProto=} [properties] Properties to set
             * @returns {waiternow.common.CreateBusinessActionProto} CreateBusinessActionProto instance
             */
            CreateBusinessActionProto.create = function create(properties) {
                return new CreateBusinessActionProto(properties);
            };

            /**
             * Encodes the specified CreateBusinessActionProto message. Does not implicitly {@link waiternow.common.CreateBusinessActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.CreateBusinessActionProto
             * @static
             * @param {waiternow.common.ICreateBusinessActionProto} message CreateBusinessActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CreateBusinessActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified CreateBusinessActionProto message, length delimited. Does not implicitly {@link waiternow.common.CreateBusinessActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.CreateBusinessActionProto
             * @static
             * @param {waiternow.common.ICreateBusinessActionProto} message CreateBusinessActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CreateBusinessActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CreateBusinessActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.CreateBusinessActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.CreateBusinessActionProto} CreateBusinessActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CreateBusinessActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CreateBusinessActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CreateBusinessActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.CreateBusinessActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.CreateBusinessActionProto} CreateBusinessActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CreateBusinessActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CreateBusinessActionProto message.
             * @function verify
             * @memberof waiternow.common.CreateBusinessActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CreateBusinessActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a CreateBusinessActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.CreateBusinessActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.CreateBusinessActionProto} CreateBusinessActionProto
             */
            CreateBusinessActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.CreateBusinessActionProto)
                    return object;
                return new $root.waiternow.common.CreateBusinessActionProto();
            };

            /**
             * Creates a plain object from a CreateBusinessActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.CreateBusinessActionProto
             * @static
             * @param {waiternow.common.CreateBusinessActionProto} message CreateBusinessActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CreateBusinessActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this CreateBusinessActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.CreateBusinessActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CreateBusinessActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for CreateBusinessActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.CreateBusinessActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            CreateBusinessActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.CreateBusinessActionProto";
            };

            CreateBusinessActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.CreateBusinessActionProto
                 * @interface IRequest
                 * @property {waiternow.common.IBusinessProto|null} [business] Request business
                 * @property {string|null} [ownerUserId] Request ownerUserId
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.CreateBusinessActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.CreateBusinessActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request business.
                 * @member {waiternow.common.IBusinessProto|null|undefined} business
                 * @memberof waiternow.common.CreateBusinessActionProto.Request
                 * @instance
                 */
                Request.prototype.business = null;

                /**
                 * Request ownerUserId.
                 * @member {string} ownerUserId
                 * @memberof waiternow.common.CreateBusinessActionProto.Request
                 * @instance
                 */
                Request.prototype.ownerUserId = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.CreateBusinessActionProto.Request
                 * @static
                 * @param {waiternow.common.CreateBusinessActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.CreateBusinessActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.CreateBusinessActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.CreateBusinessActionProto.Request
                 * @static
                 * @param {waiternow.common.CreateBusinessActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.business != null && Object.hasOwnProperty.call(message, "business"))
                        $root.waiternow.common.BusinessProto.encode(message.business, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.ownerUserId != null && Object.hasOwnProperty.call(message, "ownerUserId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.ownerUserId);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.CreateBusinessActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.CreateBusinessActionProto.Request
                 * @static
                 * @param {waiternow.common.CreateBusinessActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.CreateBusinessActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.CreateBusinessActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CreateBusinessActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.business = $root.waiternow.common.BusinessProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.ownerUserId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.CreateBusinessActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.CreateBusinessActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.CreateBusinessActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.business != null && message.hasOwnProperty("business")) {
                        var error = $root.waiternow.common.BusinessProto.verify(message.business);
                        if (error)
                            return "business." + error;
                    }
                    if (message.ownerUserId != null && message.hasOwnProperty("ownerUserId"))
                        if (!$util.isString(message.ownerUserId))
                            return "ownerUserId: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.CreateBusinessActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.CreateBusinessActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.CreateBusinessActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.CreateBusinessActionProto.Request();
                    if (object.business != null) {
                        if (typeof object.business !== "object")
                            throw TypeError(".waiternow.common.CreateBusinessActionProto.Request.business: object expected");
                        message.business = $root.waiternow.common.BusinessProto.fromObject(object.business);
                    }
                    if (object.ownerUserId != null)
                        message.ownerUserId = String(object.ownerUserId);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.CreateBusinessActionProto.Request
                 * @static
                 * @param {waiternow.common.CreateBusinessActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.business = null;
                        object.ownerUserId = "";
                    }
                    if (message.business != null && message.hasOwnProperty("business"))
                        object.business = $root.waiternow.common.BusinessProto.toObject(message.business, options);
                    if (message.ownerUserId != null && message.hasOwnProperty("ownerUserId"))
                        object.ownerUserId = message.ownerUserId;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.CreateBusinessActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.CreateBusinessActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.CreateBusinessActionProto.Request";
                };

                return Request;
            })();

            CreateBusinessActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.CreateBusinessActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IBusinessProto|null} [business] Response business
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.CreateBusinessActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.CreateBusinessActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.CreateBusinessActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response business.
                 * @member {waiternow.common.IBusinessProto|null|undefined} business
                 * @memberof waiternow.common.CreateBusinessActionProto.Response
                 * @instance
                 */
                Response.prototype.business = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.CreateBusinessActionProto.Response
                 * @static
                 * @param {waiternow.common.CreateBusinessActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.CreateBusinessActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.CreateBusinessActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.CreateBusinessActionProto.Response
                 * @static
                 * @param {waiternow.common.CreateBusinessActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.business != null && Object.hasOwnProperty.call(message, "business"))
                        $root.waiternow.common.BusinessProto.encode(message.business, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.CreateBusinessActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.CreateBusinessActionProto.Response
                 * @static
                 * @param {waiternow.common.CreateBusinessActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.CreateBusinessActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.CreateBusinessActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CreateBusinessActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.business = $root.waiternow.common.BusinessProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.CreateBusinessActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.CreateBusinessActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.CreateBusinessActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.business != null && message.hasOwnProperty("business")) {
                        var error = $root.waiternow.common.BusinessProto.verify(message.business);
                        if (error)
                            return "business." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.CreateBusinessActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.CreateBusinessActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.CreateBusinessActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.CreateBusinessActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.CreateBusinessActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.business != null) {
                        if (typeof object.business !== "object")
                            throw TypeError(".waiternow.common.CreateBusinessActionProto.Response.business: object expected");
                        message.business = $root.waiternow.common.BusinessProto.fromObject(object.business);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.CreateBusinessActionProto.Response
                 * @static
                 * @param {waiternow.common.CreateBusinessActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.business = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.business != null && message.hasOwnProperty("business"))
                        object.business = $root.waiternow.common.BusinessProto.toObject(message.business, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.CreateBusinessActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.CreateBusinessActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.CreateBusinessActionProto.Response";
                };

                return Response;
            })();

            return CreateBusinessActionProto;
        })();

        common.UpdateBusinessActionProto = (function() {

            /**
             * Properties of an UpdateBusinessActionProto.
             * @memberof waiternow.common
             * @interface IUpdateBusinessActionProto
             */

            /**
             * Constructs a new UpdateBusinessActionProto.
             * @memberof waiternow.common
             * @classdesc Represents an UpdateBusinessActionProto.
             * @implements IUpdateBusinessActionProto
             * @constructor
             * @param {waiternow.common.IUpdateBusinessActionProto=} [properties] Properties to set
             */
            function UpdateBusinessActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new UpdateBusinessActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.UpdateBusinessActionProto
             * @static
             * @param {waiternow.common.IUpdateBusinessActionProto=} [properties] Properties to set
             * @returns {waiternow.common.UpdateBusinessActionProto} UpdateBusinessActionProto instance
             */
            UpdateBusinessActionProto.create = function create(properties) {
                return new UpdateBusinessActionProto(properties);
            };

            /**
             * Encodes the specified UpdateBusinessActionProto message. Does not implicitly {@link waiternow.common.UpdateBusinessActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.UpdateBusinessActionProto
             * @static
             * @param {waiternow.common.IUpdateBusinessActionProto} message UpdateBusinessActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UpdateBusinessActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified UpdateBusinessActionProto message, length delimited. Does not implicitly {@link waiternow.common.UpdateBusinessActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.UpdateBusinessActionProto
             * @static
             * @param {waiternow.common.IUpdateBusinessActionProto} message UpdateBusinessActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UpdateBusinessActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an UpdateBusinessActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.UpdateBusinessActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.UpdateBusinessActionProto} UpdateBusinessActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UpdateBusinessActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.UpdateBusinessActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an UpdateBusinessActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.UpdateBusinessActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.UpdateBusinessActionProto} UpdateBusinessActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UpdateBusinessActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an UpdateBusinessActionProto message.
             * @function verify
             * @memberof waiternow.common.UpdateBusinessActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            UpdateBusinessActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates an UpdateBusinessActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.UpdateBusinessActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.UpdateBusinessActionProto} UpdateBusinessActionProto
             */
            UpdateBusinessActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.UpdateBusinessActionProto)
                    return object;
                return new $root.waiternow.common.UpdateBusinessActionProto();
            };

            /**
             * Creates a plain object from an UpdateBusinessActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.UpdateBusinessActionProto
             * @static
             * @param {waiternow.common.UpdateBusinessActionProto} message UpdateBusinessActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            UpdateBusinessActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this UpdateBusinessActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.UpdateBusinessActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            UpdateBusinessActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for UpdateBusinessActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.UpdateBusinessActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            UpdateBusinessActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.UpdateBusinessActionProto";
            };

            UpdateBusinessActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.UpdateBusinessActionProto
                 * @interface IRequest
                 * @property {waiternow.common.IBusinessProto|null} [business] Request business
                 * @property {Array.<waiternow.common.UpdateBusinessActionProto.Request.RemovableField>|null} [fieldsToRemove] Request fieldsToRemove
                 * @property {Array.<waiternow.common.UpdateLocationActionProto.Request.SettingsRemovableField>|null} [locationSettingsFieldsToRemove] Request locationSettingsFieldsToRemove
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.UpdateBusinessActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.UpdateBusinessActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    this.fieldsToRemove = [];
                    this.locationSettingsFieldsToRemove = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request business.
                 * @member {waiternow.common.IBusinessProto|null|undefined} business
                 * @memberof waiternow.common.UpdateBusinessActionProto.Request
                 * @instance
                 */
                Request.prototype.business = null;

                /**
                 * Request fieldsToRemove.
                 * @member {Array.<waiternow.common.UpdateBusinessActionProto.Request.RemovableField>} fieldsToRemove
                 * @memberof waiternow.common.UpdateBusinessActionProto.Request
                 * @instance
                 */
                Request.prototype.fieldsToRemove = $util.emptyArray;

                /**
                 * Request locationSettingsFieldsToRemove.
                 * @member {Array.<waiternow.common.UpdateLocationActionProto.Request.SettingsRemovableField>} locationSettingsFieldsToRemove
                 * @memberof waiternow.common.UpdateBusinessActionProto.Request
                 * @instance
                 */
                Request.prototype.locationSettingsFieldsToRemove = $util.emptyArray;

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.UpdateBusinessActionProto.Request
                 * @static
                 * @param {waiternow.common.UpdateBusinessActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.UpdateBusinessActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.UpdateBusinessActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.UpdateBusinessActionProto.Request
                 * @static
                 * @param {waiternow.common.UpdateBusinessActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.business != null && Object.hasOwnProperty.call(message, "business"))
                        $root.waiternow.common.BusinessProto.encode(message.business, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.fieldsToRemove != null && message.fieldsToRemove.length) {
                        writer.uint32(/* id 2, wireType 2 =*/18).fork();
                        for (var i = 0; i < message.fieldsToRemove.length; ++i)
                            writer.int32(message.fieldsToRemove[i]);
                        writer.ldelim();
                    }
                    if (message.locationSettingsFieldsToRemove != null && message.locationSettingsFieldsToRemove.length) {
                        writer.uint32(/* id 3, wireType 2 =*/26).fork();
                        for (var i = 0; i < message.locationSettingsFieldsToRemove.length; ++i)
                            writer.int32(message.locationSettingsFieldsToRemove[i]);
                        writer.ldelim();
                    }
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.UpdateBusinessActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.UpdateBusinessActionProto.Request
                 * @static
                 * @param {waiternow.common.UpdateBusinessActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.UpdateBusinessActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.UpdateBusinessActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.UpdateBusinessActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.business = $root.waiternow.common.BusinessProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                if (!(message.fieldsToRemove && message.fieldsToRemove.length))
                                    message.fieldsToRemove = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.fieldsToRemove.push(reader.int32());
                                } else
                                    message.fieldsToRemove.push(reader.int32());
                                break;
                            }
                        case 3: {
                                if (!(message.locationSettingsFieldsToRemove && message.locationSettingsFieldsToRemove.length))
                                    message.locationSettingsFieldsToRemove = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.locationSettingsFieldsToRemove.push(reader.int32());
                                } else
                                    message.locationSettingsFieldsToRemove.push(reader.int32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.UpdateBusinessActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.UpdateBusinessActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.UpdateBusinessActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.business != null && message.hasOwnProperty("business")) {
                        var error = $root.waiternow.common.BusinessProto.verify(message.business);
                        if (error)
                            return "business." + error;
                    }
                    if (message.fieldsToRemove != null && message.hasOwnProperty("fieldsToRemove")) {
                        if (!Array.isArray(message.fieldsToRemove))
                            return "fieldsToRemove: array expected";
                        for (var i = 0; i < message.fieldsToRemove.length; ++i)
                            switch (message.fieldsToRemove[i]) {
                            default:
                                return "fieldsToRemove: enum value[] expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                                break;
                            }
                    }
                    if (message.locationSettingsFieldsToRemove != null && message.hasOwnProperty("locationSettingsFieldsToRemove")) {
                        if (!Array.isArray(message.locationSettingsFieldsToRemove))
                            return "locationSettingsFieldsToRemove: array expected";
                        for (var i = 0; i < message.locationSettingsFieldsToRemove.length; ++i)
                            switch (message.locationSettingsFieldsToRemove[i]) {
                            default:
                                return "locationSettingsFieldsToRemove: enum value[] expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                            case 8:
                            case 9:
                            case 10:
                            case 11:
                            case 12:
                            case 13:
                            case 14:
                            case 15:
                            case 16:
                            case 17:
                            case 18:
                            case 19:
                            case 22:
                            case 23:
                            case 28:
                            case 29:
                            case 31:
                            case 32:
                            case 33:
                            case 34:
                            case 35:
                            case 36:
                            case 37:
                            case 38:
                            case 39:
                            case 40:
                            case 20:
                            case 21:
                            case 24:
                            case 25:
                            case 26:
                            case 27:
                            case 30:
                                break;
                            }
                    }
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.UpdateBusinessActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.UpdateBusinessActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.UpdateBusinessActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.UpdateBusinessActionProto.Request();
                    if (object.business != null) {
                        if (typeof object.business !== "object")
                            throw TypeError(".waiternow.common.UpdateBusinessActionProto.Request.business: object expected");
                        message.business = $root.waiternow.common.BusinessProto.fromObject(object.business);
                    }
                    if (object.fieldsToRemove) {
                        if (!Array.isArray(object.fieldsToRemove))
                            throw TypeError(".waiternow.common.UpdateBusinessActionProto.Request.fieldsToRemove: array expected");
                        message.fieldsToRemove = [];
                        for (var i = 0; i < object.fieldsToRemove.length; ++i)
                            switch (object.fieldsToRemove[i]) {
                            default:
                                if (typeof object.fieldsToRemove[i] === "number") {
                                    message.fieldsToRemove[i] = object.fieldsToRemove[i];
                                    break;
                                }
                            case "REMOVABLE_FIELD_UNSPECIFIED":
                            case 0:
                                message.fieldsToRemove[i] = 0;
                                break;
                            case "SETTINGS_BILLING_INFO_BUSINESS_OFFICIAL_ID":
                            case 1:
                                message.fieldsToRemove[i] = 1;
                                break;
                            case "SETTINGS_BILLING_INFO_BUSINESS_OFFICIAL_NAME":
                            case 2:
                                message.fieldsToRemove[i] = 2;
                                break;
                            case "SETTINGS_BILLING_INFO_BILLING_ADDRESS":
                            case 3:
                                message.fieldsToRemove[i] = 3;
                                break;
                            case "DESCRIPTION":
                            case 4:
                                message.fieldsToRemove[i] = 4;
                                break;
                            case "VANITY_URL":
                            case 5:
                                message.fieldsToRemove[i] = 5;
                                break;
                            }
                    }
                    if (object.locationSettingsFieldsToRemove) {
                        if (!Array.isArray(object.locationSettingsFieldsToRemove))
                            throw TypeError(".waiternow.common.UpdateBusinessActionProto.Request.locationSettingsFieldsToRemove: array expected");
                        message.locationSettingsFieldsToRemove = [];
                        for (var i = 0; i < object.locationSettingsFieldsToRemove.length; ++i)
                            switch (object.locationSettingsFieldsToRemove[i]) {
                            default:
                                if (typeof object.locationSettingsFieldsToRemove[i] === "number") {
                                    message.locationSettingsFieldsToRemove[i] = object.locationSettingsFieldsToRemove[i];
                                    break;
                                }
                            case "SETTINGS_REMOVABLE_FIELD_UNSPECIFIED":
                            case 0:
                                message.locationSettingsFieldsToRemove[i] = 0;
                                break;
                            case "LOCALE_LANGUAGE":
                            case 1:
                                message.locationSettingsFieldsToRemove[i] = 1;
                                break;
                            case "LOCALE_CURRENCY_CODE":
                            case 2:
                                message.locationSettingsFieldsToRemove[i] = 2;
                                break;
                            case "LOCALE_TIMEZONE":
                            case 3:
                                message.locationSettingsFieldsToRemove[i] = 3;
                                break;
                            case "VIEW_THEME":
                            case 4:
                                message.locationSettingsFieldsToRemove[i] = 4;
                                break;
                            case "VIEW_APP_MODE":
                            case 5:
                                message.locationSettingsFieldsToRemove[i] = 5;
                                break;
                            case "EXTERNAL_LINKS_WEBSITE":
                            case 6:
                                message.locationSettingsFieldsToRemove[i] = 6;
                                break;
                            case "EXTERNAL_LINKS_YOUTUBE":
                            case 7:
                                message.locationSettingsFieldsToRemove[i] = 7;
                                break;
                            case "EXTERNAL_LINKS_FACEBOOK":
                            case 8:
                                message.locationSettingsFieldsToRemove[i] = 8;
                                break;
                            case "EXTERNAL_LINKS_INSTAGRAM":
                            case 9:
                                message.locationSettingsFieldsToRemove[i] = 9;
                                break;
                            case "EXTERNAL_LINKS_TWITTER":
                            case 10:
                                message.locationSettingsFieldsToRemove[i] = 10;
                                break;
                            case "EXTERNAL_LINKS_LINKED_IN":
                            case 11:
                                message.locationSettingsFieldsToRemove[i] = 11;
                                break;
                            case "EXTERNAL_LINKS_TIKTOK":
                            case 12:
                                message.locationSettingsFieldsToRemove[i] = 12;
                                break;
                            case "COLOR_PALETTE":
                            case 13:
                                message.locationSettingsFieldsToRemove[i] = 13;
                                break;
                            case "ENABLED_FEATURES_PAYMENT_REQUIRED_FOR_ORDERS":
                            case 14:
                                message.locationSettingsFieldsToRemove[i] = 14;
                                break;
                            case "ENABLED_FEATURES_POKE_WAITER_DISABLED":
                            case 15:
                                message.locationSettingsFieldsToRemove[i] = 15;
                                break;
                            case "ENABLED_FEATURES_MENU_DISABLED":
                            case 16:
                                message.locationSettingsFieldsToRemove[i] = 16;
                                break;
                            case "ENABLED_FEATURES_IMAGE_MENU_DISABLED":
                            case 17:
                                message.locationSettingsFieldsToRemove[i] = 17;
                                break;
                            case "ENABLED_FEATURES_MESSAGE_WAITER_DISABLED":
                            case 18:
                                message.locationSettingsFieldsToRemove[i] = 18;
                                break;
                            case "ENABLED_FEATURES_ASK_FOR_CHECK_DISABLED":
                            case 19:
                                message.locationSettingsFieldsToRemove[i] = 19;
                                break;
                            case "ENABLED_FEATURES_SPECIAL_INSTRUCTIONS_DISABLED":
                            case 22:
                                message.locationSettingsFieldsToRemove[i] = 22;
                                break;
                            case "ENABLED_FEATURES_COMPLETED_STATUS_SUPPORTED_FOR_PAID_ORDERS":
                            case 23:
                                message.locationSettingsFieldsToRemove[i] = 23;
                                break;
                            case "ENABLED_FEATURES_IS_ONSITE_TIPS_DISABLED":
                            case 28:
                                message.locationSettingsFieldsToRemove[i] = 28;
                                break;
                            case "ENABLED_FEATURES_IS_ONLINE_PICKUP_TIPS_ENABLED":
                            case 29:
                                message.locationSettingsFieldsToRemove[i] = 29;
                                break;
                            case "ENABLED_FEATURES_IS_DELIVERY_DISABLED":
                            case 31:
                                message.locationSettingsFieldsToRemove[i] = 31;
                                break;
                            case "ENABLED_FEATURES_CHARGE_CREDIT_CARD_FEE_TO_CONSUMER":
                            case 32:
                                message.locationSettingsFieldsToRemove[i] = 32;
                                break;
                            case "ENABLED_FEATURES_IS_ALCOHOL_FOR_PICKUP_ALLOWED":
                            case 33:
                                message.locationSettingsFieldsToRemove[i] = 33;
                                break;
                            case "ENABLED_FEATURES_IS_ALCOHOL_FOR_DELIVERY_ALLOWED":
                            case 34:
                                message.locationSettingsFieldsToRemove[i] = 34;
                                break;
                            case "ENABLED_FEATURES_PRINT_ORDER_AND_RECEIPT":
                            case 35:
                                message.locationSettingsFieldsToRemove[i] = 35;
                                break;
                            case "ENABLED_FEATURES_IS_ORDER_FOR_LATER_DISABLED":
                            case 36:
                                message.locationSettingsFieldsToRemove[i] = 36;
                                break;
                            case "ENABLED_FEATURES_IS_ORDER_FOR_LATER_DAY_DISABLED":
                            case 37:
                                message.locationSettingsFieldsToRemove[i] = 37;
                                break;
                            case "ENABLED_FEATURES_IS_SMS_ON_NEW_ORDERS_FOR_BUSINESS_WEB_ENABLED":
                            case 38:
                                message.locationSettingsFieldsToRemove[i] = 38;
                                break;
                            case "ENABLED_FEATURES_EXPAND_QUANTITY_FOR_PRINTED_ORDERS":
                            case 39:
                                message.locationSettingsFieldsToRemove[i] = 39;
                                break;
                            case "ENABLED_FEATURES_IS_BUSINESS_AUTO_START_SESSION_ENABLED":
                            case 40:
                                message.locationSettingsFieldsToRemove[i] = 40;
                                break;
                            case "TAXES":
                            case 20:
                                message.locationSettingsFieldsToRemove[i] = 20;
                                break;
                            case "PRINTERS":
                            case 21:
                                message.locationSettingsFieldsToRemove[i] = 21;
                                break;
                            case "ORDER_PAYMENT_WAITERNOW_FEE":
                            case 24:
                                message.locationSettingsFieldsToRemove[i] = 24;
                                break;
                            case "BUSINESS_HOURS":
                            case 25:
                                message.locationSettingsFieldsToRemove[i] = 25;
                                break;
                            case "ALERT_CONFIG":
                            case 26:
                                message.locationSettingsFieldsToRemove[i] = 26;
                                break;
                            case "ORDER_PREPARATION_DURATION":
                            case 27:
                                message.locationSettingsFieldsToRemove[i] = 27;
                                break;
                            case "DELIVERY_CONFIG":
                            case 30:
                                message.locationSettingsFieldsToRemove[i] = 30;
                                break;
                            }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.UpdateBusinessActionProto.Request
                 * @static
                 * @param {waiternow.common.UpdateBusinessActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.fieldsToRemove = [];
                        object.locationSettingsFieldsToRemove = [];
                    }
                    if (options.defaults)
                        object.business = null;
                    if (message.business != null && message.hasOwnProperty("business"))
                        object.business = $root.waiternow.common.BusinessProto.toObject(message.business, options);
                    if (message.fieldsToRemove && message.fieldsToRemove.length) {
                        object.fieldsToRemove = [];
                        for (var j = 0; j < message.fieldsToRemove.length; ++j)
                            object.fieldsToRemove[j] = options.enums === String ? $root.waiternow.common.UpdateBusinessActionProto.Request.RemovableField[message.fieldsToRemove[j]] === undefined ? message.fieldsToRemove[j] : $root.waiternow.common.UpdateBusinessActionProto.Request.RemovableField[message.fieldsToRemove[j]] : message.fieldsToRemove[j];
                    }
                    if (message.locationSettingsFieldsToRemove && message.locationSettingsFieldsToRemove.length) {
                        object.locationSettingsFieldsToRemove = [];
                        for (var j = 0; j < message.locationSettingsFieldsToRemove.length; ++j)
                            object.locationSettingsFieldsToRemove[j] = options.enums === String ? $root.waiternow.common.UpdateLocationActionProto.Request.SettingsRemovableField[message.locationSettingsFieldsToRemove[j]] === undefined ? message.locationSettingsFieldsToRemove[j] : $root.waiternow.common.UpdateLocationActionProto.Request.SettingsRemovableField[message.locationSettingsFieldsToRemove[j]] : message.locationSettingsFieldsToRemove[j];
                    }
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.UpdateBusinessActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.UpdateBusinessActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.UpdateBusinessActionProto.Request";
                };

                /**
                 * RemovableField enum.
                 * @name waiternow.common.UpdateBusinessActionProto.Request.RemovableField
                 * @enum {number}
                 * @property {number} REMOVABLE_FIELD_UNSPECIFIED=0 REMOVABLE_FIELD_UNSPECIFIED value
                 * @property {number} SETTINGS_BILLING_INFO_BUSINESS_OFFICIAL_ID=1 SETTINGS_BILLING_INFO_BUSINESS_OFFICIAL_ID value
                 * @property {number} SETTINGS_BILLING_INFO_BUSINESS_OFFICIAL_NAME=2 SETTINGS_BILLING_INFO_BUSINESS_OFFICIAL_NAME value
                 * @property {number} SETTINGS_BILLING_INFO_BILLING_ADDRESS=3 SETTINGS_BILLING_INFO_BILLING_ADDRESS value
                 * @property {number} DESCRIPTION=4 DESCRIPTION value
                 * @property {number} VANITY_URL=5 VANITY_URL value
                 */
                Request.RemovableField = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "REMOVABLE_FIELD_UNSPECIFIED"] = 0;
                    values[valuesById[1] = "SETTINGS_BILLING_INFO_BUSINESS_OFFICIAL_ID"] = 1;
                    values[valuesById[2] = "SETTINGS_BILLING_INFO_BUSINESS_OFFICIAL_NAME"] = 2;
                    values[valuesById[3] = "SETTINGS_BILLING_INFO_BILLING_ADDRESS"] = 3;
                    values[valuesById[4] = "DESCRIPTION"] = 4;
                    values[valuesById[5] = "VANITY_URL"] = 5;
                    return values;
                })();

                return Request;
            })();

            UpdateBusinessActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.UpdateBusinessActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.UpdateBusinessActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.UpdateBusinessActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.UpdateBusinessActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.UpdateBusinessActionProto.Response
                 * @static
                 * @param {waiternow.common.UpdateBusinessActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.UpdateBusinessActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.UpdateBusinessActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.UpdateBusinessActionProto.Response
                 * @static
                 * @param {waiternow.common.UpdateBusinessActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.UpdateBusinessActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.UpdateBusinessActionProto.Response
                 * @static
                 * @param {waiternow.common.UpdateBusinessActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.UpdateBusinessActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.UpdateBusinessActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.UpdateBusinessActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.UpdateBusinessActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.UpdateBusinessActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.UpdateBusinessActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.UpdateBusinessActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.UpdateBusinessActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.UpdateBusinessActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.UpdateBusinessActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.UpdateBusinessActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.UpdateBusinessActionProto.Response
                 * @static
                 * @param {waiternow.common.UpdateBusinessActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.UpdateBusinessActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.UpdateBusinessActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.UpdateBusinessActionProto.Response";
                };

                return Response;
            })();

            return UpdateBusinessActionProto;
        })();

        common.UpdateBusinessImageActionProto = (function() {

            /**
             * Properties of an UpdateBusinessImageActionProto.
             * @memberof waiternow.common
             * @interface IUpdateBusinessImageActionProto
             */

            /**
             * Constructs a new UpdateBusinessImageActionProto.
             * @memberof waiternow.common
             * @classdesc Represents an UpdateBusinessImageActionProto.
             * @implements IUpdateBusinessImageActionProto
             * @constructor
             * @param {waiternow.common.IUpdateBusinessImageActionProto=} [properties] Properties to set
             */
            function UpdateBusinessImageActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new UpdateBusinessImageActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.UpdateBusinessImageActionProto
             * @static
             * @param {waiternow.common.IUpdateBusinessImageActionProto=} [properties] Properties to set
             * @returns {waiternow.common.UpdateBusinessImageActionProto} UpdateBusinessImageActionProto instance
             */
            UpdateBusinessImageActionProto.create = function create(properties) {
                return new UpdateBusinessImageActionProto(properties);
            };

            /**
             * Encodes the specified UpdateBusinessImageActionProto message. Does not implicitly {@link waiternow.common.UpdateBusinessImageActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.UpdateBusinessImageActionProto
             * @static
             * @param {waiternow.common.IUpdateBusinessImageActionProto} message UpdateBusinessImageActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UpdateBusinessImageActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified UpdateBusinessImageActionProto message, length delimited. Does not implicitly {@link waiternow.common.UpdateBusinessImageActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.UpdateBusinessImageActionProto
             * @static
             * @param {waiternow.common.IUpdateBusinessImageActionProto} message UpdateBusinessImageActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UpdateBusinessImageActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an UpdateBusinessImageActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.UpdateBusinessImageActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.UpdateBusinessImageActionProto} UpdateBusinessImageActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UpdateBusinessImageActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.UpdateBusinessImageActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an UpdateBusinessImageActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.UpdateBusinessImageActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.UpdateBusinessImageActionProto} UpdateBusinessImageActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UpdateBusinessImageActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an UpdateBusinessImageActionProto message.
             * @function verify
             * @memberof waiternow.common.UpdateBusinessImageActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            UpdateBusinessImageActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates an UpdateBusinessImageActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.UpdateBusinessImageActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.UpdateBusinessImageActionProto} UpdateBusinessImageActionProto
             */
            UpdateBusinessImageActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.UpdateBusinessImageActionProto)
                    return object;
                return new $root.waiternow.common.UpdateBusinessImageActionProto();
            };

            /**
             * Creates a plain object from an UpdateBusinessImageActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.UpdateBusinessImageActionProto
             * @static
             * @param {waiternow.common.UpdateBusinessImageActionProto} message UpdateBusinessImageActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            UpdateBusinessImageActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this UpdateBusinessImageActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.UpdateBusinessImageActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            UpdateBusinessImageActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for UpdateBusinessImageActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.UpdateBusinessImageActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            UpdateBusinessImageActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.UpdateBusinessImageActionProto";
            };

            UpdateBusinessImageActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.UpdateBusinessImageActionProto
                 * @interface IRequest
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.UpdateBusinessImageActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.UpdateBusinessImageActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.UpdateBusinessImageActionProto.Request
                 * @static
                 * @param {waiternow.common.UpdateBusinessImageActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.UpdateBusinessImageActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.UpdateBusinessImageActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.UpdateBusinessImageActionProto.Request
                 * @static
                 * @param {waiternow.common.UpdateBusinessImageActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.UpdateBusinessImageActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.UpdateBusinessImageActionProto.Request
                 * @static
                 * @param {waiternow.common.UpdateBusinessImageActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.UpdateBusinessImageActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.UpdateBusinessImageActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.UpdateBusinessImageActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.UpdateBusinessImageActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.UpdateBusinessImageActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.UpdateBusinessImageActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.UpdateBusinessImageActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.UpdateBusinessImageActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.UpdateBusinessImageActionProto.Request)
                        return object;
                    return new $root.waiternow.common.UpdateBusinessImageActionProto.Request();
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.UpdateBusinessImageActionProto.Request
                 * @static
                 * @param {waiternow.common.UpdateBusinessImageActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject() {
                    return {};
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.UpdateBusinessImageActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.UpdateBusinessImageActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.UpdateBusinessImageActionProto.Request";
                };

                return Request;
            })();

            UpdateBusinessImageActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.UpdateBusinessImageActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.UpdateBusinessImageActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.UpdateBusinessImageActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.UpdateBusinessImageActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.UpdateBusinessImageActionProto.Response
                 * @static
                 * @param {waiternow.common.UpdateBusinessImageActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.UpdateBusinessImageActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.UpdateBusinessImageActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.UpdateBusinessImageActionProto.Response
                 * @static
                 * @param {waiternow.common.UpdateBusinessImageActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.UpdateBusinessImageActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.UpdateBusinessImageActionProto.Response
                 * @static
                 * @param {waiternow.common.UpdateBusinessImageActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.UpdateBusinessImageActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.UpdateBusinessImageActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.UpdateBusinessImageActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.UpdateBusinessImageActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.UpdateBusinessImageActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.UpdateBusinessImageActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.UpdateBusinessImageActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.UpdateBusinessImageActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.UpdateBusinessImageActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.UpdateBusinessImageActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.UpdateBusinessImageActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.UpdateBusinessImageActionProto.Response
                 * @static
                 * @param {waiternow.common.UpdateBusinessImageActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.UpdateBusinessImageActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.UpdateBusinessImageActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.UpdateBusinessImageActionProto.Response";
                };

                return Response;
            })();

            return UpdateBusinessImageActionProto;
        })();

        common.DeleteBusinessImageActionProto = (function() {

            /**
             * Properties of a DeleteBusinessImageActionProto.
             * @memberof waiternow.common
             * @interface IDeleteBusinessImageActionProto
             */

            /**
             * Constructs a new DeleteBusinessImageActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a DeleteBusinessImageActionProto.
             * @implements IDeleteBusinessImageActionProto
             * @constructor
             * @param {waiternow.common.IDeleteBusinessImageActionProto=} [properties] Properties to set
             */
            function DeleteBusinessImageActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new DeleteBusinessImageActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.DeleteBusinessImageActionProto
             * @static
             * @param {waiternow.common.IDeleteBusinessImageActionProto=} [properties] Properties to set
             * @returns {waiternow.common.DeleteBusinessImageActionProto} DeleteBusinessImageActionProto instance
             */
            DeleteBusinessImageActionProto.create = function create(properties) {
                return new DeleteBusinessImageActionProto(properties);
            };

            /**
             * Encodes the specified DeleteBusinessImageActionProto message. Does not implicitly {@link waiternow.common.DeleteBusinessImageActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.DeleteBusinessImageActionProto
             * @static
             * @param {waiternow.common.IDeleteBusinessImageActionProto} message DeleteBusinessImageActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DeleteBusinessImageActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified DeleteBusinessImageActionProto message, length delimited. Does not implicitly {@link waiternow.common.DeleteBusinessImageActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.DeleteBusinessImageActionProto
             * @static
             * @param {waiternow.common.IDeleteBusinessImageActionProto} message DeleteBusinessImageActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DeleteBusinessImageActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a DeleteBusinessImageActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.DeleteBusinessImageActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.DeleteBusinessImageActionProto} DeleteBusinessImageActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DeleteBusinessImageActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.DeleteBusinessImageActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a DeleteBusinessImageActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.DeleteBusinessImageActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.DeleteBusinessImageActionProto} DeleteBusinessImageActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DeleteBusinessImageActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a DeleteBusinessImageActionProto message.
             * @function verify
             * @memberof waiternow.common.DeleteBusinessImageActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            DeleteBusinessImageActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a DeleteBusinessImageActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.DeleteBusinessImageActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.DeleteBusinessImageActionProto} DeleteBusinessImageActionProto
             */
            DeleteBusinessImageActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.DeleteBusinessImageActionProto)
                    return object;
                return new $root.waiternow.common.DeleteBusinessImageActionProto();
            };

            /**
             * Creates a plain object from a DeleteBusinessImageActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.DeleteBusinessImageActionProto
             * @static
             * @param {waiternow.common.DeleteBusinessImageActionProto} message DeleteBusinessImageActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            DeleteBusinessImageActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this DeleteBusinessImageActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.DeleteBusinessImageActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            DeleteBusinessImageActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for DeleteBusinessImageActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.DeleteBusinessImageActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            DeleteBusinessImageActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.DeleteBusinessImageActionProto";
            };

            DeleteBusinessImageActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.DeleteBusinessImageActionProto
                 * @interface IRequest
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.DeleteBusinessImageActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.DeleteBusinessImageActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.DeleteBusinessImageActionProto.Request
                 * @static
                 * @param {waiternow.common.DeleteBusinessImageActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.DeleteBusinessImageActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.DeleteBusinessImageActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.DeleteBusinessImageActionProto.Request
                 * @static
                 * @param {waiternow.common.DeleteBusinessImageActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.DeleteBusinessImageActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.DeleteBusinessImageActionProto.Request
                 * @static
                 * @param {waiternow.common.DeleteBusinessImageActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.DeleteBusinessImageActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.DeleteBusinessImageActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.DeleteBusinessImageActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.DeleteBusinessImageActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.DeleteBusinessImageActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.DeleteBusinessImageActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.DeleteBusinessImageActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.DeleteBusinessImageActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.DeleteBusinessImageActionProto.Request)
                        return object;
                    return new $root.waiternow.common.DeleteBusinessImageActionProto.Request();
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.DeleteBusinessImageActionProto.Request
                 * @static
                 * @param {waiternow.common.DeleteBusinessImageActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject() {
                    return {};
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.DeleteBusinessImageActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.DeleteBusinessImageActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.DeleteBusinessImageActionProto.Request";
                };

                return Request;
            })();

            DeleteBusinessImageActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.DeleteBusinessImageActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.DeleteBusinessImageActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.DeleteBusinessImageActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.DeleteBusinessImageActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.DeleteBusinessImageActionProto.Response
                 * @static
                 * @param {waiternow.common.DeleteBusinessImageActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.DeleteBusinessImageActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.DeleteBusinessImageActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.DeleteBusinessImageActionProto.Response
                 * @static
                 * @param {waiternow.common.DeleteBusinessImageActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.DeleteBusinessImageActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.DeleteBusinessImageActionProto.Response
                 * @static
                 * @param {waiternow.common.DeleteBusinessImageActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.DeleteBusinessImageActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.DeleteBusinessImageActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.DeleteBusinessImageActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.DeleteBusinessImageActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.DeleteBusinessImageActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.DeleteBusinessImageActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.DeleteBusinessImageActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.DeleteBusinessImageActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.DeleteBusinessImageActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.DeleteBusinessImageActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.DeleteBusinessImageActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.DeleteBusinessImageActionProto.Response
                 * @static
                 * @param {waiternow.common.DeleteBusinessImageActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.DeleteBusinessImageActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.DeleteBusinessImageActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.DeleteBusinessImageActionProto.Response";
                };

                return Response;
            })();

            return DeleteBusinessImageActionProto;
        })();

        common.DeleteBusinessActionProto = (function() {

            /**
             * Properties of a DeleteBusinessActionProto.
             * @memberof waiternow.common
             * @interface IDeleteBusinessActionProto
             */

            /**
             * Constructs a new DeleteBusinessActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a DeleteBusinessActionProto.
             * @implements IDeleteBusinessActionProto
             * @constructor
             * @param {waiternow.common.IDeleteBusinessActionProto=} [properties] Properties to set
             */
            function DeleteBusinessActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new DeleteBusinessActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.DeleteBusinessActionProto
             * @static
             * @param {waiternow.common.IDeleteBusinessActionProto=} [properties] Properties to set
             * @returns {waiternow.common.DeleteBusinessActionProto} DeleteBusinessActionProto instance
             */
            DeleteBusinessActionProto.create = function create(properties) {
                return new DeleteBusinessActionProto(properties);
            };

            /**
             * Encodes the specified DeleteBusinessActionProto message. Does not implicitly {@link waiternow.common.DeleteBusinessActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.DeleteBusinessActionProto
             * @static
             * @param {waiternow.common.IDeleteBusinessActionProto} message DeleteBusinessActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DeleteBusinessActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified DeleteBusinessActionProto message, length delimited. Does not implicitly {@link waiternow.common.DeleteBusinessActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.DeleteBusinessActionProto
             * @static
             * @param {waiternow.common.IDeleteBusinessActionProto} message DeleteBusinessActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DeleteBusinessActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a DeleteBusinessActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.DeleteBusinessActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.DeleteBusinessActionProto} DeleteBusinessActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DeleteBusinessActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.DeleteBusinessActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a DeleteBusinessActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.DeleteBusinessActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.DeleteBusinessActionProto} DeleteBusinessActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DeleteBusinessActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a DeleteBusinessActionProto message.
             * @function verify
             * @memberof waiternow.common.DeleteBusinessActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            DeleteBusinessActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a DeleteBusinessActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.DeleteBusinessActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.DeleteBusinessActionProto} DeleteBusinessActionProto
             */
            DeleteBusinessActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.DeleteBusinessActionProto)
                    return object;
                return new $root.waiternow.common.DeleteBusinessActionProto();
            };

            /**
             * Creates a plain object from a DeleteBusinessActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.DeleteBusinessActionProto
             * @static
             * @param {waiternow.common.DeleteBusinessActionProto} message DeleteBusinessActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            DeleteBusinessActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this DeleteBusinessActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.DeleteBusinessActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            DeleteBusinessActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for DeleteBusinessActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.DeleteBusinessActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            DeleteBusinessActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.DeleteBusinessActionProto";
            };

            DeleteBusinessActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.DeleteBusinessActionProto
                 * @interface IRequest
                 * @property {string|null} [businessId] Request businessId
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.DeleteBusinessActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.DeleteBusinessActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request businessId.
                 * @member {string} businessId
                 * @memberof waiternow.common.DeleteBusinessActionProto.Request
                 * @instance
                 */
                Request.prototype.businessId = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.DeleteBusinessActionProto.Request
                 * @static
                 * @param {waiternow.common.DeleteBusinessActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.DeleteBusinessActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.DeleteBusinessActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.DeleteBusinessActionProto.Request
                 * @static
                 * @param {waiternow.common.DeleteBusinessActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessId);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.DeleteBusinessActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.DeleteBusinessActionProto.Request
                 * @static
                 * @param {waiternow.common.DeleteBusinessActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.DeleteBusinessActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.DeleteBusinessActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.DeleteBusinessActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.businessId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.DeleteBusinessActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.DeleteBusinessActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.DeleteBusinessActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.businessId != null && message.hasOwnProperty("businessId"))
                        if (!$util.isString(message.businessId))
                            return "businessId: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.DeleteBusinessActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.DeleteBusinessActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.DeleteBusinessActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.DeleteBusinessActionProto.Request();
                    if (object.businessId != null)
                        message.businessId = String(object.businessId);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.DeleteBusinessActionProto.Request
                 * @static
                 * @param {waiternow.common.DeleteBusinessActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.businessId = "";
                    if (message.businessId != null && message.hasOwnProperty("businessId"))
                        object.businessId = message.businessId;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.DeleteBusinessActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.DeleteBusinessActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.DeleteBusinessActionProto.Request";
                };

                return Request;
            })();

            DeleteBusinessActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.DeleteBusinessActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.DeleteBusinessActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.DeleteBusinessActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.DeleteBusinessActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.DeleteBusinessActionProto.Response
                 * @static
                 * @param {waiternow.common.DeleteBusinessActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.DeleteBusinessActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.DeleteBusinessActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.DeleteBusinessActionProto.Response
                 * @static
                 * @param {waiternow.common.DeleteBusinessActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.DeleteBusinessActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.DeleteBusinessActionProto.Response
                 * @static
                 * @param {waiternow.common.DeleteBusinessActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.DeleteBusinessActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.DeleteBusinessActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.DeleteBusinessActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.DeleteBusinessActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.DeleteBusinessActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.DeleteBusinessActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.DeleteBusinessActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.DeleteBusinessActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.DeleteBusinessActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.DeleteBusinessActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.DeleteBusinessActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.DeleteBusinessActionProto.Response
                 * @static
                 * @param {waiternow.common.DeleteBusinessActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.DeleteBusinessActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.DeleteBusinessActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.DeleteBusinessActionProto.Response";
                };

                return Response;
            })();

            return DeleteBusinessActionProto;
        })();

        common.GetBusinessActionProto = (function() {

            /**
             * Properties of a GetBusinessActionProto.
             * @memberof waiternow.common
             * @interface IGetBusinessActionProto
             */

            /**
             * Constructs a new GetBusinessActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a GetBusinessActionProto.
             * @implements IGetBusinessActionProto
             * @constructor
             * @param {waiternow.common.IGetBusinessActionProto=} [properties] Properties to set
             */
            function GetBusinessActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new GetBusinessActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.GetBusinessActionProto
             * @static
             * @param {waiternow.common.IGetBusinessActionProto=} [properties] Properties to set
             * @returns {waiternow.common.GetBusinessActionProto} GetBusinessActionProto instance
             */
            GetBusinessActionProto.create = function create(properties) {
                return new GetBusinessActionProto(properties);
            };

            /**
             * Encodes the specified GetBusinessActionProto message. Does not implicitly {@link waiternow.common.GetBusinessActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.GetBusinessActionProto
             * @static
             * @param {waiternow.common.IGetBusinessActionProto} message GetBusinessActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetBusinessActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified GetBusinessActionProto message, length delimited. Does not implicitly {@link waiternow.common.GetBusinessActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.GetBusinessActionProto
             * @static
             * @param {waiternow.common.IGetBusinessActionProto} message GetBusinessActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetBusinessActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetBusinessActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.GetBusinessActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.GetBusinessActionProto} GetBusinessActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetBusinessActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetBusinessActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetBusinessActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.GetBusinessActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.GetBusinessActionProto} GetBusinessActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetBusinessActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetBusinessActionProto message.
             * @function verify
             * @memberof waiternow.common.GetBusinessActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetBusinessActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a GetBusinessActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.GetBusinessActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.GetBusinessActionProto} GetBusinessActionProto
             */
            GetBusinessActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.GetBusinessActionProto)
                    return object;
                return new $root.waiternow.common.GetBusinessActionProto();
            };

            /**
             * Creates a plain object from a GetBusinessActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.GetBusinessActionProto
             * @static
             * @param {waiternow.common.GetBusinessActionProto} message GetBusinessActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetBusinessActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this GetBusinessActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.GetBusinessActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetBusinessActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for GetBusinessActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.GetBusinessActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            GetBusinessActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.GetBusinessActionProto";
            };

            GetBusinessActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.GetBusinessActionProto
                 * @interface IRequest
                 * @property {string|null} [businessId] Request businessId
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.GetBusinessActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.GetBusinessActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request businessId.
                 * @member {string} businessId
                 * @memberof waiternow.common.GetBusinessActionProto.Request
                 * @instance
                 */
                Request.prototype.businessId = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetBusinessActionProto.Request
                 * @static
                 * @param {waiternow.common.GetBusinessActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.GetBusinessActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.GetBusinessActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetBusinessActionProto.Request
                 * @static
                 * @param {waiternow.common.GetBusinessActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessId);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.GetBusinessActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetBusinessActionProto.Request
                 * @static
                 * @param {waiternow.common.GetBusinessActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetBusinessActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetBusinessActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetBusinessActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.businessId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetBusinessActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetBusinessActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.GetBusinessActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.businessId != null && message.hasOwnProperty("businessId"))
                        if (!$util.isString(message.businessId))
                            return "businessId: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetBusinessActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetBusinessActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetBusinessActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.GetBusinessActionProto.Request();
                    if (object.businessId != null)
                        message.businessId = String(object.businessId);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetBusinessActionProto.Request
                 * @static
                 * @param {waiternow.common.GetBusinessActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.businessId = "";
                    if (message.businessId != null && message.hasOwnProperty("businessId"))
                        object.businessId = message.businessId;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetBusinessActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetBusinessActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetBusinessActionProto.Request";
                };

                return Request;
            })();

            GetBusinessActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.GetBusinessActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IBusinessProto|null} [business] Response business
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.GetBusinessActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.GetBusinessActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.GetBusinessActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response business.
                 * @member {waiternow.common.IBusinessProto|null|undefined} business
                 * @memberof waiternow.common.GetBusinessActionProto.Response
                 * @instance
                 */
                Response.prototype.business = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetBusinessActionProto.Response
                 * @static
                 * @param {waiternow.common.GetBusinessActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.GetBusinessActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.GetBusinessActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetBusinessActionProto.Response
                 * @static
                 * @param {waiternow.common.GetBusinessActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.business != null && Object.hasOwnProperty.call(message, "business"))
                        $root.waiternow.common.BusinessProto.encode(message.business, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.GetBusinessActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetBusinessActionProto.Response
                 * @static
                 * @param {waiternow.common.GetBusinessActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetBusinessActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetBusinessActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetBusinessActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.business = $root.waiternow.common.BusinessProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetBusinessActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetBusinessActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.GetBusinessActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.business != null && message.hasOwnProperty("business")) {
                        var error = $root.waiternow.common.BusinessProto.verify(message.business);
                        if (error)
                            return "business." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetBusinessActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetBusinessActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetBusinessActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.GetBusinessActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.GetBusinessActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.business != null) {
                        if (typeof object.business !== "object")
                            throw TypeError(".waiternow.common.GetBusinessActionProto.Response.business: object expected");
                        message.business = $root.waiternow.common.BusinessProto.fromObject(object.business);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetBusinessActionProto.Response
                 * @static
                 * @param {waiternow.common.GetBusinessActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.business = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.business != null && message.hasOwnProperty("business"))
                        object.business = $root.waiternow.common.BusinessProto.toObject(message.business, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetBusinessActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetBusinessActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetBusinessActionProto.Response";
                };

                return Response;
            })();

            return GetBusinessActionProto;
        })();

        common.FindBusinessesByNameActionProto = (function() {

            /**
             * Properties of a FindBusinessesByNameActionProto.
             * @memberof waiternow.common
             * @interface IFindBusinessesByNameActionProto
             */

            /**
             * Constructs a new FindBusinessesByNameActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a FindBusinessesByNameActionProto.
             * @implements IFindBusinessesByNameActionProto
             * @constructor
             * @param {waiternow.common.IFindBusinessesByNameActionProto=} [properties] Properties to set
             */
            function FindBusinessesByNameActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new FindBusinessesByNameActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FindBusinessesByNameActionProto
             * @static
             * @param {waiternow.common.IFindBusinessesByNameActionProto=} [properties] Properties to set
             * @returns {waiternow.common.FindBusinessesByNameActionProto} FindBusinessesByNameActionProto instance
             */
            FindBusinessesByNameActionProto.create = function create(properties) {
                return new FindBusinessesByNameActionProto(properties);
            };

            /**
             * Encodes the specified FindBusinessesByNameActionProto message. Does not implicitly {@link waiternow.common.FindBusinessesByNameActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FindBusinessesByNameActionProto
             * @static
             * @param {waiternow.common.IFindBusinessesByNameActionProto} message FindBusinessesByNameActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindBusinessesByNameActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified FindBusinessesByNameActionProto message, length delimited. Does not implicitly {@link waiternow.common.FindBusinessesByNameActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FindBusinessesByNameActionProto
             * @static
             * @param {waiternow.common.IFindBusinessesByNameActionProto} message FindBusinessesByNameActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindBusinessesByNameActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FindBusinessesByNameActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FindBusinessesByNameActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FindBusinessesByNameActionProto} FindBusinessesByNameActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindBusinessesByNameActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindBusinessesByNameActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FindBusinessesByNameActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FindBusinessesByNameActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FindBusinessesByNameActionProto} FindBusinessesByNameActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindBusinessesByNameActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FindBusinessesByNameActionProto message.
             * @function verify
             * @memberof waiternow.common.FindBusinessesByNameActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FindBusinessesByNameActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a FindBusinessesByNameActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FindBusinessesByNameActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FindBusinessesByNameActionProto} FindBusinessesByNameActionProto
             */
            FindBusinessesByNameActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FindBusinessesByNameActionProto)
                    return object;
                return new $root.waiternow.common.FindBusinessesByNameActionProto();
            };

            /**
             * Creates a plain object from a FindBusinessesByNameActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FindBusinessesByNameActionProto
             * @static
             * @param {waiternow.common.FindBusinessesByNameActionProto} message FindBusinessesByNameActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FindBusinessesByNameActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this FindBusinessesByNameActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FindBusinessesByNameActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FindBusinessesByNameActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FindBusinessesByNameActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.FindBusinessesByNameActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FindBusinessesByNameActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FindBusinessesByNameActionProto";
            };

            FindBusinessesByNameActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.FindBusinessesByNameActionProto
                 * @interface IRequest
                 * @property {string|null} [businessName] Request businessName
                 * @property {string|null} [continuationToken] Request continuationToken
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.FindBusinessesByNameActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.FindBusinessesByNameActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request businessName.
                 * @member {string} businessName
                 * @memberof waiternow.common.FindBusinessesByNameActionProto.Request
                 * @instance
                 */
                Request.prototype.businessName = "";

                /**
                 * Request continuationToken.
                 * @member {string} continuationToken
                 * @memberof waiternow.common.FindBusinessesByNameActionProto.Request
                 * @instance
                 */
                Request.prototype.continuationToken = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindBusinessesByNameActionProto.Request
                 * @static
                 * @param {waiternow.common.FindBusinessesByNameActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.FindBusinessesByNameActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.FindBusinessesByNameActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindBusinessesByNameActionProto.Request
                 * @static
                 * @param {waiternow.common.FindBusinessesByNameActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.businessName != null && Object.hasOwnProperty.call(message, "businessName"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessName);
                    if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.continuationToken);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.FindBusinessesByNameActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindBusinessesByNameActionProto.Request
                 * @static
                 * @param {waiternow.common.FindBusinessesByNameActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindBusinessesByNameActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindBusinessesByNameActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindBusinessesByNameActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.businessName = reader.string();
                                break;
                            }
                        case 2: {
                                message.continuationToken = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindBusinessesByNameActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindBusinessesByNameActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.FindBusinessesByNameActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.businessName != null && message.hasOwnProperty("businessName"))
                        if (!$util.isString(message.businessName))
                            return "businessName: string expected";
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        if (!$util.isString(message.continuationToken))
                            return "continuationToken: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindBusinessesByNameActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindBusinessesByNameActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindBusinessesByNameActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.FindBusinessesByNameActionProto.Request();
                    if (object.businessName != null)
                        message.businessName = String(object.businessName);
                    if (object.continuationToken != null)
                        message.continuationToken = String(object.continuationToken);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindBusinessesByNameActionProto.Request
                 * @static
                 * @param {waiternow.common.FindBusinessesByNameActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.businessName = "";
                        object.continuationToken = "";
                    }
                    if (message.businessName != null && message.hasOwnProperty("businessName"))
                        object.businessName = message.businessName;
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        object.continuationToken = message.continuationToken;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindBusinessesByNameActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindBusinessesByNameActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindBusinessesByNameActionProto.Request";
                };

                return Request;
            })();

            FindBusinessesByNameActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.FindBusinessesByNameActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IBusinessesProto|null} [businesses] Response businesses
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.FindBusinessesByNameActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.FindBusinessesByNameActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.FindBusinessesByNameActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response businesses.
                 * @member {waiternow.common.IBusinessesProto|null|undefined} businesses
                 * @memberof waiternow.common.FindBusinessesByNameActionProto.Response
                 * @instance
                 */
                Response.prototype.businesses = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindBusinessesByNameActionProto.Response
                 * @static
                 * @param {waiternow.common.FindBusinessesByNameActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.FindBusinessesByNameActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.FindBusinessesByNameActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindBusinessesByNameActionProto.Response
                 * @static
                 * @param {waiternow.common.FindBusinessesByNameActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.businesses != null && Object.hasOwnProperty.call(message, "businesses"))
                        $root.waiternow.common.BusinessesProto.encode(message.businesses, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.FindBusinessesByNameActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindBusinessesByNameActionProto.Response
                 * @static
                 * @param {waiternow.common.FindBusinessesByNameActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindBusinessesByNameActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindBusinessesByNameActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindBusinessesByNameActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.businesses = $root.waiternow.common.BusinessesProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindBusinessesByNameActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindBusinessesByNameActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.FindBusinessesByNameActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.businesses != null && message.hasOwnProperty("businesses")) {
                        var error = $root.waiternow.common.BusinessesProto.verify(message.businesses);
                        if (error)
                            return "businesses." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindBusinessesByNameActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindBusinessesByNameActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindBusinessesByNameActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.FindBusinessesByNameActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.FindBusinessesByNameActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.businesses != null) {
                        if (typeof object.businesses !== "object")
                            throw TypeError(".waiternow.common.FindBusinessesByNameActionProto.Response.businesses: object expected");
                        message.businesses = $root.waiternow.common.BusinessesProto.fromObject(object.businesses);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindBusinessesByNameActionProto.Response
                 * @static
                 * @param {waiternow.common.FindBusinessesByNameActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.businesses = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.businesses != null && message.hasOwnProperty("businesses"))
                        object.businesses = $root.waiternow.common.BusinessesProto.toObject(message.businesses, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindBusinessesByNameActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindBusinessesByNameActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindBusinessesByNameActionProto.Response";
                };

                return Response;
            })();

            return FindBusinessesByNameActionProto;
        })();

        common.FindBusinessesByUserActionProto = (function() {

            /**
             * Properties of a FindBusinessesByUserActionProto.
             * @memberof waiternow.common
             * @interface IFindBusinessesByUserActionProto
             */

            /**
             * Constructs a new FindBusinessesByUserActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a FindBusinessesByUserActionProto.
             * @implements IFindBusinessesByUserActionProto
             * @constructor
             * @param {waiternow.common.IFindBusinessesByUserActionProto=} [properties] Properties to set
             */
            function FindBusinessesByUserActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new FindBusinessesByUserActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FindBusinessesByUserActionProto
             * @static
             * @param {waiternow.common.IFindBusinessesByUserActionProto=} [properties] Properties to set
             * @returns {waiternow.common.FindBusinessesByUserActionProto} FindBusinessesByUserActionProto instance
             */
            FindBusinessesByUserActionProto.create = function create(properties) {
                return new FindBusinessesByUserActionProto(properties);
            };

            /**
             * Encodes the specified FindBusinessesByUserActionProto message. Does not implicitly {@link waiternow.common.FindBusinessesByUserActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FindBusinessesByUserActionProto
             * @static
             * @param {waiternow.common.IFindBusinessesByUserActionProto} message FindBusinessesByUserActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindBusinessesByUserActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified FindBusinessesByUserActionProto message, length delimited. Does not implicitly {@link waiternow.common.FindBusinessesByUserActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FindBusinessesByUserActionProto
             * @static
             * @param {waiternow.common.IFindBusinessesByUserActionProto} message FindBusinessesByUserActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindBusinessesByUserActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FindBusinessesByUserActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FindBusinessesByUserActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FindBusinessesByUserActionProto} FindBusinessesByUserActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindBusinessesByUserActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindBusinessesByUserActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FindBusinessesByUserActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FindBusinessesByUserActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FindBusinessesByUserActionProto} FindBusinessesByUserActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindBusinessesByUserActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FindBusinessesByUserActionProto message.
             * @function verify
             * @memberof waiternow.common.FindBusinessesByUserActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FindBusinessesByUserActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a FindBusinessesByUserActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FindBusinessesByUserActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FindBusinessesByUserActionProto} FindBusinessesByUserActionProto
             */
            FindBusinessesByUserActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FindBusinessesByUserActionProto)
                    return object;
                return new $root.waiternow.common.FindBusinessesByUserActionProto();
            };

            /**
             * Creates a plain object from a FindBusinessesByUserActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FindBusinessesByUserActionProto
             * @static
             * @param {waiternow.common.FindBusinessesByUserActionProto} message FindBusinessesByUserActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FindBusinessesByUserActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this FindBusinessesByUserActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FindBusinessesByUserActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FindBusinessesByUserActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FindBusinessesByUserActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.FindBusinessesByUserActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FindBusinessesByUserActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FindBusinessesByUserActionProto";
            };

            FindBusinessesByUserActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.FindBusinessesByUserActionProto
                 * @interface IRequest
                 * @property {string|null} [userId] Request userId
                 * @property {string|null} [userEmail] Request userEmail
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.FindBusinessesByUserActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.FindBusinessesByUserActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request userId.
                 * @member {string|null|undefined} userId
                 * @memberof waiternow.common.FindBusinessesByUserActionProto.Request
                 * @instance
                 */
                Request.prototype.userId = null;

                /**
                 * Request userEmail.
                 * @member {string|null|undefined} userEmail
                 * @memberof waiternow.common.FindBusinessesByUserActionProto.Request
                 * @instance
                 */
                Request.prototype.userEmail = null;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * Request user.
                 * @member {"userId"|"userEmail"|undefined} user
                 * @memberof waiternow.common.FindBusinessesByUserActionProto.Request
                 * @instance
                 */
                Object.defineProperty(Request.prototype, "user", {
                    get: $util.oneOfGetter($oneOfFields = ["userId", "userEmail"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindBusinessesByUserActionProto.Request
                 * @static
                 * @param {waiternow.common.FindBusinessesByUserActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.FindBusinessesByUserActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.FindBusinessesByUserActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindBusinessesByUserActionProto.Request
                 * @static
                 * @param {waiternow.common.FindBusinessesByUserActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.userId);
                    if (message.userEmail != null && Object.hasOwnProperty.call(message, "userEmail"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.userEmail);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.FindBusinessesByUserActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindBusinessesByUserActionProto.Request
                 * @static
                 * @param {waiternow.common.FindBusinessesByUserActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindBusinessesByUserActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindBusinessesByUserActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindBusinessesByUserActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.userId = reader.string();
                                break;
                            }
                        case 2: {
                                message.userEmail = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindBusinessesByUserActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindBusinessesByUserActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.FindBusinessesByUserActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.userId != null && message.hasOwnProperty("userId")) {
                        properties.user = 1;
                        if (!$util.isString(message.userId))
                            return "userId: string expected";
                    }
                    if (message.userEmail != null && message.hasOwnProperty("userEmail")) {
                        if (properties.user === 1)
                            return "user: multiple values";
                        properties.user = 1;
                        if (!$util.isString(message.userEmail))
                            return "userEmail: string expected";
                    }
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindBusinessesByUserActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindBusinessesByUserActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindBusinessesByUserActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.FindBusinessesByUserActionProto.Request();
                    if (object.userId != null)
                        message.userId = String(object.userId);
                    if (object.userEmail != null)
                        message.userEmail = String(object.userEmail);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindBusinessesByUserActionProto.Request
                 * @static
                 * @param {waiternow.common.FindBusinessesByUserActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (message.userId != null && message.hasOwnProperty("userId")) {
                        object.userId = message.userId;
                        if (options.oneofs)
                            object.user = "userId";
                    }
                    if (message.userEmail != null && message.hasOwnProperty("userEmail")) {
                        object.userEmail = message.userEmail;
                        if (options.oneofs)
                            object.user = "userEmail";
                    }
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindBusinessesByUserActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindBusinessesByUserActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindBusinessesByUserActionProto.Request";
                };

                return Request;
            })();

            FindBusinessesByUserActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.FindBusinessesByUserActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IUserBusinessesProto|null} [userBusinesses] Response userBusinesses
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.FindBusinessesByUserActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.FindBusinessesByUserActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.FindBusinessesByUserActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response userBusinesses.
                 * @member {waiternow.common.IUserBusinessesProto|null|undefined} userBusinesses
                 * @memberof waiternow.common.FindBusinessesByUserActionProto.Response
                 * @instance
                 */
                Response.prototype.userBusinesses = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindBusinessesByUserActionProto.Response
                 * @static
                 * @param {waiternow.common.FindBusinessesByUserActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.FindBusinessesByUserActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.FindBusinessesByUserActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindBusinessesByUserActionProto.Response
                 * @static
                 * @param {waiternow.common.FindBusinessesByUserActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.userBusinesses != null && Object.hasOwnProperty.call(message, "userBusinesses"))
                        $root.waiternow.common.UserBusinessesProto.encode(message.userBusinesses, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.FindBusinessesByUserActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindBusinessesByUserActionProto.Response
                 * @static
                 * @param {waiternow.common.FindBusinessesByUserActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindBusinessesByUserActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindBusinessesByUserActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindBusinessesByUserActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.userBusinesses = $root.waiternow.common.UserBusinessesProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindBusinessesByUserActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindBusinessesByUserActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.FindBusinessesByUserActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.userBusinesses != null && message.hasOwnProperty("userBusinesses")) {
                        var error = $root.waiternow.common.UserBusinessesProto.verify(message.userBusinesses);
                        if (error)
                            return "userBusinesses." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindBusinessesByUserActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindBusinessesByUserActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindBusinessesByUserActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.FindBusinessesByUserActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.FindBusinessesByUserActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.userBusinesses != null) {
                        if (typeof object.userBusinesses !== "object")
                            throw TypeError(".waiternow.common.FindBusinessesByUserActionProto.Response.userBusinesses: object expected");
                        message.userBusinesses = $root.waiternow.common.UserBusinessesProto.fromObject(object.userBusinesses);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindBusinessesByUserActionProto.Response
                 * @static
                 * @param {waiternow.common.FindBusinessesByUserActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.userBusinesses = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.userBusinesses != null && message.hasOwnProperty("userBusinesses"))
                        object.userBusinesses = $root.waiternow.common.UserBusinessesProto.toObject(message.userBusinesses, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindBusinessesByUserActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindBusinessesByUserActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindBusinessesByUserActionProto.Response";
                };

                return Response;
            })();

            return FindBusinessesByUserActionProto;
        })();

        common.FindUsersByBusinessActionProto = (function() {

            /**
             * Properties of a FindUsersByBusinessActionProto.
             * @memberof waiternow.common
             * @interface IFindUsersByBusinessActionProto
             */

            /**
             * Constructs a new FindUsersByBusinessActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a FindUsersByBusinessActionProto.
             * @implements IFindUsersByBusinessActionProto
             * @constructor
             * @param {waiternow.common.IFindUsersByBusinessActionProto=} [properties] Properties to set
             */
            function FindUsersByBusinessActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new FindUsersByBusinessActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FindUsersByBusinessActionProto
             * @static
             * @param {waiternow.common.IFindUsersByBusinessActionProto=} [properties] Properties to set
             * @returns {waiternow.common.FindUsersByBusinessActionProto} FindUsersByBusinessActionProto instance
             */
            FindUsersByBusinessActionProto.create = function create(properties) {
                return new FindUsersByBusinessActionProto(properties);
            };

            /**
             * Encodes the specified FindUsersByBusinessActionProto message. Does not implicitly {@link waiternow.common.FindUsersByBusinessActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FindUsersByBusinessActionProto
             * @static
             * @param {waiternow.common.IFindUsersByBusinessActionProto} message FindUsersByBusinessActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindUsersByBusinessActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified FindUsersByBusinessActionProto message, length delimited. Does not implicitly {@link waiternow.common.FindUsersByBusinessActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FindUsersByBusinessActionProto
             * @static
             * @param {waiternow.common.IFindUsersByBusinessActionProto} message FindUsersByBusinessActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindUsersByBusinessActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FindUsersByBusinessActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FindUsersByBusinessActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FindUsersByBusinessActionProto} FindUsersByBusinessActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindUsersByBusinessActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindUsersByBusinessActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FindUsersByBusinessActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FindUsersByBusinessActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FindUsersByBusinessActionProto} FindUsersByBusinessActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindUsersByBusinessActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FindUsersByBusinessActionProto message.
             * @function verify
             * @memberof waiternow.common.FindUsersByBusinessActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FindUsersByBusinessActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a FindUsersByBusinessActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FindUsersByBusinessActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FindUsersByBusinessActionProto} FindUsersByBusinessActionProto
             */
            FindUsersByBusinessActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FindUsersByBusinessActionProto)
                    return object;
                return new $root.waiternow.common.FindUsersByBusinessActionProto();
            };

            /**
             * Creates a plain object from a FindUsersByBusinessActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FindUsersByBusinessActionProto
             * @static
             * @param {waiternow.common.FindUsersByBusinessActionProto} message FindUsersByBusinessActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FindUsersByBusinessActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this FindUsersByBusinessActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FindUsersByBusinessActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FindUsersByBusinessActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FindUsersByBusinessActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.FindUsersByBusinessActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FindUsersByBusinessActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FindUsersByBusinessActionProto";
            };

            FindUsersByBusinessActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.FindUsersByBusinessActionProto
                 * @interface IRequest
                 * @property {string|null} [businessId] Request businessId
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.FindUsersByBusinessActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.FindUsersByBusinessActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request businessId.
                 * @member {string} businessId
                 * @memberof waiternow.common.FindUsersByBusinessActionProto.Request
                 * @instance
                 */
                Request.prototype.businessId = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindUsersByBusinessActionProto.Request
                 * @static
                 * @param {waiternow.common.FindUsersByBusinessActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.FindUsersByBusinessActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.FindUsersByBusinessActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindUsersByBusinessActionProto.Request
                 * @static
                 * @param {waiternow.common.FindUsersByBusinessActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessId);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.FindUsersByBusinessActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindUsersByBusinessActionProto.Request
                 * @static
                 * @param {waiternow.common.FindUsersByBusinessActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindUsersByBusinessActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindUsersByBusinessActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindUsersByBusinessActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.businessId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindUsersByBusinessActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindUsersByBusinessActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.FindUsersByBusinessActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.businessId != null && message.hasOwnProperty("businessId"))
                        if (!$util.isString(message.businessId))
                            return "businessId: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindUsersByBusinessActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindUsersByBusinessActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindUsersByBusinessActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.FindUsersByBusinessActionProto.Request();
                    if (object.businessId != null)
                        message.businessId = String(object.businessId);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindUsersByBusinessActionProto.Request
                 * @static
                 * @param {waiternow.common.FindUsersByBusinessActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.businessId = "";
                    if (message.businessId != null && message.hasOwnProperty("businessId"))
                        object.businessId = message.businessId;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindUsersByBusinessActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindUsersByBusinessActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindUsersByBusinessActionProto.Request";
                };

                return Request;
            })();

            FindUsersByBusinessActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.FindUsersByBusinessActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IBusinessUsersProto|null} [businessUsers] Response businessUsers
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.FindUsersByBusinessActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.FindUsersByBusinessActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.FindUsersByBusinessActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response businessUsers.
                 * @member {waiternow.common.IBusinessUsersProto|null|undefined} businessUsers
                 * @memberof waiternow.common.FindUsersByBusinessActionProto.Response
                 * @instance
                 */
                Response.prototype.businessUsers = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindUsersByBusinessActionProto.Response
                 * @static
                 * @param {waiternow.common.FindUsersByBusinessActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.FindUsersByBusinessActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.FindUsersByBusinessActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindUsersByBusinessActionProto.Response
                 * @static
                 * @param {waiternow.common.FindUsersByBusinessActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.businessUsers != null && Object.hasOwnProperty.call(message, "businessUsers"))
                        $root.waiternow.common.BusinessUsersProto.encode(message.businessUsers, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.FindUsersByBusinessActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindUsersByBusinessActionProto.Response
                 * @static
                 * @param {waiternow.common.FindUsersByBusinessActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindUsersByBusinessActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindUsersByBusinessActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindUsersByBusinessActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.businessUsers = $root.waiternow.common.BusinessUsersProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindUsersByBusinessActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindUsersByBusinessActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.FindUsersByBusinessActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.businessUsers != null && message.hasOwnProperty("businessUsers")) {
                        var error = $root.waiternow.common.BusinessUsersProto.verify(message.businessUsers);
                        if (error)
                            return "businessUsers." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindUsersByBusinessActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindUsersByBusinessActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindUsersByBusinessActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.FindUsersByBusinessActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.FindUsersByBusinessActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.businessUsers != null) {
                        if (typeof object.businessUsers !== "object")
                            throw TypeError(".waiternow.common.FindUsersByBusinessActionProto.Response.businessUsers: object expected");
                        message.businessUsers = $root.waiternow.common.BusinessUsersProto.fromObject(object.businessUsers);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindUsersByBusinessActionProto.Response
                 * @static
                 * @param {waiternow.common.FindUsersByBusinessActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.businessUsers = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.businessUsers != null && message.hasOwnProperty("businessUsers"))
                        object.businessUsers = $root.waiternow.common.BusinessUsersProto.toObject(message.businessUsers, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindUsersByBusinessActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindUsersByBusinessActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindUsersByBusinessActionProto.Response";
                };

                return Response;
            })();

            return FindUsersByBusinessActionProto;
        })();

        common.AddOwnerToBusinessActionProto = (function() {

            /**
             * Properties of an AddOwnerToBusinessActionProto.
             * @memberof waiternow.common
             * @interface IAddOwnerToBusinessActionProto
             */

            /**
             * Constructs a new AddOwnerToBusinessActionProto.
             * @memberof waiternow.common
             * @classdesc Represents an AddOwnerToBusinessActionProto.
             * @implements IAddOwnerToBusinessActionProto
             * @constructor
             * @param {waiternow.common.IAddOwnerToBusinessActionProto=} [properties] Properties to set
             */
            function AddOwnerToBusinessActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new AddOwnerToBusinessActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.AddOwnerToBusinessActionProto
             * @static
             * @param {waiternow.common.IAddOwnerToBusinessActionProto=} [properties] Properties to set
             * @returns {waiternow.common.AddOwnerToBusinessActionProto} AddOwnerToBusinessActionProto instance
             */
            AddOwnerToBusinessActionProto.create = function create(properties) {
                return new AddOwnerToBusinessActionProto(properties);
            };

            /**
             * Encodes the specified AddOwnerToBusinessActionProto message. Does not implicitly {@link waiternow.common.AddOwnerToBusinessActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.AddOwnerToBusinessActionProto
             * @static
             * @param {waiternow.common.IAddOwnerToBusinessActionProto} message AddOwnerToBusinessActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AddOwnerToBusinessActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified AddOwnerToBusinessActionProto message, length delimited. Does not implicitly {@link waiternow.common.AddOwnerToBusinessActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.AddOwnerToBusinessActionProto
             * @static
             * @param {waiternow.common.IAddOwnerToBusinessActionProto} message AddOwnerToBusinessActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AddOwnerToBusinessActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AddOwnerToBusinessActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.AddOwnerToBusinessActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.AddOwnerToBusinessActionProto} AddOwnerToBusinessActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AddOwnerToBusinessActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.AddOwnerToBusinessActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AddOwnerToBusinessActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.AddOwnerToBusinessActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.AddOwnerToBusinessActionProto} AddOwnerToBusinessActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AddOwnerToBusinessActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AddOwnerToBusinessActionProto message.
             * @function verify
             * @memberof waiternow.common.AddOwnerToBusinessActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AddOwnerToBusinessActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates an AddOwnerToBusinessActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.AddOwnerToBusinessActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.AddOwnerToBusinessActionProto} AddOwnerToBusinessActionProto
             */
            AddOwnerToBusinessActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.AddOwnerToBusinessActionProto)
                    return object;
                return new $root.waiternow.common.AddOwnerToBusinessActionProto();
            };

            /**
             * Creates a plain object from an AddOwnerToBusinessActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.AddOwnerToBusinessActionProto
             * @static
             * @param {waiternow.common.AddOwnerToBusinessActionProto} message AddOwnerToBusinessActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AddOwnerToBusinessActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this AddOwnerToBusinessActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.AddOwnerToBusinessActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AddOwnerToBusinessActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for AddOwnerToBusinessActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.AddOwnerToBusinessActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            AddOwnerToBusinessActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.AddOwnerToBusinessActionProto";
            };

            AddOwnerToBusinessActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.AddOwnerToBusinessActionProto
                 * @interface IRequest
                 * @property {string|null} [businessId] Request businessId
                 * @property {string|null} [affectedUserEmail] Request affectedUserEmail
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.AddOwnerToBusinessActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.AddOwnerToBusinessActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request businessId.
                 * @member {string} businessId
                 * @memberof waiternow.common.AddOwnerToBusinessActionProto.Request
                 * @instance
                 */
                Request.prototype.businessId = "";

                /**
                 * Request affectedUserEmail.
                 * @member {string} affectedUserEmail
                 * @memberof waiternow.common.AddOwnerToBusinessActionProto.Request
                 * @instance
                 */
                Request.prototype.affectedUserEmail = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.AddOwnerToBusinessActionProto.Request
                 * @static
                 * @param {waiternow.common.AddOwnerToBusinessActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.AddOwnerToBusinessActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.AddOwnerToBusinessActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.AddOwnerToBusinessActionProto.Request
                 * @static
                 * @param {waiternow.common.AddOwnerToBusinessActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessId);
                    if (message.affectedUserEmail != null && Object.hasOwnProperty.call(message, "affectedUserEmail"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.affectedUserEmail);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.AddOwnerToBusinessActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.AddOwnerToBusinessActionProto.Request
                 * @static
                 * @param {waiternow.common.AddOwnerToBusinessActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.AddOwnerToBusinessActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.AddOwnerToBusinessActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.AddOwnerToBusinessActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.businessId = reader.string();
                                break;
                            }
                        case 2: {
                                message.affectedUserEmail = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.AddOwnerToBusinessActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.AddOwnerToBusinessActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.AddOwnerToBusinessActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.businessId != null && message.hasOwnProperty("businessId"))
                        if (!$util.isString(message.businessId))
                            return "businessId: string expected";
                    if (message.affectedUserEmail != null && message.hasOwnProperty("affectedUserEmail"))
                        if (!$util.isString(message.affectedUserEmail))
                            return "affectedUserEmail: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.AddOwnerToBusinessActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.AddOwnerToBusinessActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.AddOwnerToBusinessActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.AddOwnerToBusinessActionProto.Request();
                    if (object.businessId != null)
                        message.businessId = String(object.businessId);
                    if (object.affectedUserEmail != null)
                        message.affectedUserEmail = String(object.affectedUserEmail);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.AddOwnerToBusinessActionProto.Request
                 * @static
                 * @param {waiternow.common.AddOwnerToBusinessActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.businessId = "";
                        object.affectedUserEmail = "";
                    }
                    if (message.businessId != null && message.hasOwnProperty("businessId"))
                        object.businessId = message.businessId;
                    if (message.affectedUserEmail != null && message.hasOwnProperty("affectedUserEmail"))
                        object.affectedUserEmail = message.affectedUserEmail;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.AddOwnerToBusinessActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.AddOwnerToBusinessActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.AddOwnerToBusinessActionProto.Request";
                };

                return Request;
            })();

            AddOwnerToBusinessActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.AddOwnerToBusinessActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.AddOwnerToBusinessActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.AddOwnerToBusinessActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.AddOwnerToBusinessActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.AddOwnerToBusinessActionProto.Response
                 * @static
                 * @param {waiternow.common.AddOwnerToBusinessActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.AddOwnerToBusinessActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.AddOwnerToBusinessActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.AddOwnerToBusinessActionProto.Response
                 * @static
                 * @param {waiternow.common.AddOwnerToBusinessActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.AddOwnerToBusinessActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.AddOwnerToBusinessActionProto.Response
                 * @static
                 * @param {waiternow.common.AddOwnerToBusinessActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.AddOwnerToBusinessActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.AddOwnerToBusinessActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.AddOwnerToBusinessActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.AddOwnerToBusinessActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.AddOwnerToBusinessActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.AddOwnerToBusinessActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.AddOwnerToBusinessActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.AddOwnerToBusinessActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.AddOwnerToBusinessActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.AddOwnerToBusinessActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.AddOwnerToBusinessActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.AddOwnerToBusinessActionProto.Response
                 * @static
                 * @param {waiternow.common.AddOwnerToBusinessActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.AddOwnerToBusinessActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.AddOwnerToBusinessActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.AddOwnerToBusinessActionProto.Response";
                };

                return Response;
            })();

            return AddOwnerToBusinessActionProto;
        })();

        common.RemoveUserFromBusinessActionProto = (function() {

            /**
             * Properties of a RemoveUserFromBusinessActionProto.
             * @memberof waiternow.common
             * @interface IRemoveUserFromBusinessActionProto
             */

            /**
             * Constructs a new RemoveUserFromBusinessActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a RemoveUserFromBusinessActionProto.
             * @implements IRemoveUserFromBusinessActionProto
             * @constructor
             * @param {waiternow.common.IRemoveUserFromBusinessActionProto=} [properties] Properties to set
             */
            function RemoveUserFromBusinessActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new RemoveUserFromBusinessActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.RemoveUserFromBusinessActionProto
             * @static
             * @param {waiternow.common.IRemoveUserFromBusinessActionProto=} [properties] Properties to set
             * @returns {waiternow.common.RemoveUserFromBusinessActionProto} RemoveUserFromBusinessActionProto instance
             */
            RemoveUserFromBusinessActionProto.create = function create(properties) {
                return new RemoveUserFromBusinessActionProto(properties);
            };

            /**
             * Encodes the specified RemoveUserFromBusinessActionProto message. Does not implicitly {@link waiternow.common.RemoveUserFromBusinessActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.RemoveUserFromBusinessActionProto
             * @static
             * @param {waiternow.common.IRemoveUserFromBusinessActionProto} message RemoveUserFromBusinessActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RemoveUserFromBusinessActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified RemoveUserFromBusinessActionProto message, length delimited. Does not implicitly {@link waiternow.common.RemoveUserFromBusinessActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.RemoveUserFromBusinessActionProto
             * @static
             * @param {waiternow.common.IRemoveUserFromBusinessActionProto} message RemoveUserFromBusinessActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RemoveUserFromBusinessActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a RemoveUserFromBusinessActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.RemoveUserFromBusinessActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.RemoveUserFromBusinessActionProto} RemoveUserFromBusinessActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RemoveUserFromBusinessActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.RemoveUserFromBusinessActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a RemoveUserFromBusinessActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.RemoveUserFromBusinessActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.RemoveUserFromBusinessActionProto} RemoveUserFromBusinessActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RemoveUserFromBusinessActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a RemoveUserFromBusinessActionProto message.
             * @function verify
             * @memberof waiternow.common.RemoveUserFromBusinessActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            RemoveUserFromBusinessActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a RemoveUserFromBusinessActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.RemoveUserFromBusinessActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.RemoveUserFromBusinessActionProto} RemoveUserFromBusinessActionProto
             */
            RemoveUserFromBusinessActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.RemoveUserFromBusinessActionProto)
                    return object;
                return new $root.waiternow.common.RemoveUserFromBusinessActionProto();
            };

            /**
             * Creates a plain object from a RemoveUserFromBusinessActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.RemoveUserFromBusinessActionProto
             * @static
             * @param {waiternow.common.RemoveUserFromBusinessActionProto} message RemoveUserFromBusinessActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            RemoveUserFromBusinessActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this RemoveUserFromBusinessActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.RemoveUserFromBusinessActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            RemoveUserFromBusinessActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for RemoveUserFromBusinessActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.RemoveUserFromBusinessActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            RemoveUserFromBusinessActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.RemoveUserFromBusinessActionProto";
            };

            RemoveUserFromBusinessActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.RemoveUserFromBusinessActionProto
                 * @interface IRequest
                 * @property {string|null} [businessId] Request businessId
                 * @property {string|null} [affectedUserEmail] Request affectedUserEmail
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.RemoveUserFromBusinessActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.RemoveUserFromBusinessActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request businessId.
                 * @member {string} businessId
                 * @memberof waiternow.common.RemoveUserFromBusinessActionProto.Request
                 * @instance
                 */
                Request.prototype.businessId = "";

                /**
                 * Request affectedUserEmail.
                 * @member {string} affectedUserEmail
                 * @memberof waiternow.common.RemoveUserFromBusinessActionProto.Request
                 * @instance
                 */
                Request.prototype.affectedUserEmail = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.RemoveUserFromBusinessActionProto.Request
                 * @static
                 * @param {waiternow.common.RemoveUserFromBusinessActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.RemoveUserFromBusinessActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.RemoveUserFromBusinessActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.RemoveUserFromBusinessActionProto.Request
                 * @static
                 * @param {waiternow.common.RemoveUserFromBusinessActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessId);
                    if (message.affectedUserEmail != null && Object.hasOwnProperty.call(message, "affectedUserEmail"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.affectedUserEmail);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.RemoveUserFromBusinessActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.RemoveUserFromBusinessActionProto.Request
                 * @static
                 * @param {waiternow.common.RemoveUserFromBusinessActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.RemoveUserFromBusinessActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.RemoveUserFromBusinessActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.RemoveUserFromBusinessActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.businessId = reader.string();
                                break;
                            }
                        case 2: {
                                message.affectedUserEmail = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.RemoveUserFromBusinessActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.RemoveUserFromBusinessActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.RemoveUserFromBusinessActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.businessId != null && message.hasOwnProperty("businessId"))
                        if (!$util.isString(message.businessId))
                            return "businessId: string expected";
                    if (message.affectedUserEmail != null && message.hasOwnProperty("affectedUserEmail"))
                        if (!$util.isString(message.affectedUserEmail))
                            return "affectedUserEmail: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.RemoveUserFromBusinessActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.RemoveUserFromBusinessActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.RemoveUserFromBusinessActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.RemoveUserFromBusinessActionProto.Request();
                    if (object.businessId != null)
                        message.businessId = String(object.businessId);
                    if (object.affectedUserEmail != null)
                        message.affectedUserEmail = String(object.affectedUserEmail);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.RemoveUserFromBusinessActionProto.Request
                 * @static
                 * @param {waiternow.common.RemoveUserFromBusinessActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.businessId = "";
                        object.affectedUserEmail = "";
                    }
                    if (message.businessId != null && message.hasOwnProperty("businessId"))
                        object.businessId = message.businessId;
                    if (message.affectedUserEmail != null && message.hasOwnProperty("affectedUserEmail"))
                        object.affectedUserEmail = message.affectedUserEmail;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.RemoveUserFromBusinessActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.RemoveUserFromBusinessActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.RemoveUserFromBusinessActionProto.Request";
                };

                return Request;
            })();

            RemoveUserFromBusinessActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.RemoveUserFromBusinessActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.RemoveUserFromBusinessActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.RemoveUserFromBusinessActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.RemoveUserFromBusinessActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.RemoveUserFromBusinessActionProto.Response
                 * @static
                 * @param {waiternow.common.RemoveUserFromBusinessActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.RemoveUserFromBusinessActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.RemoveUserFromBusinessActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.RemoveUserFromBusinessActionProto.Response
                 * @static
                 * @param {waiternow.common.RemoveUserFromBusinessActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.RemoveUserFromBusinessActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.RemoveUserFromBusinessActionProto.Response
                 * @static
                 * @param {waiternow.common.RemoveUserFromBusinessActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.RemoveUserFromBusinessActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.RemoveUserFromBusinessActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.RemoveUserFromBusinessActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.RemoveUserFromBusinessActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.RemoveUserFromBusinessActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.RemoveUserFromBusinessActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.RemoveUserFromBusinessActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.RemoveUserFromBusinessActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.RemoveUserFromBusinessActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.RemoveUserFromBusinessActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.RemoveUserFromBusinessActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.RemoveUserFromBusinessActionProto.Response
                 * @static
                 * @param {waiternow.common.RemoveUserFromBusinessActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.RemoveUserFromBusinessActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.RemoveUserFromBusinessActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.RemoveUserFromBusinessActionProto.Response";
                };

                return Response;
            })();

            return RemoveUserFromBusinessActionProto;
        })();

        common.CreateLocationActionProto = (function() {

            /**
             * Properties of a CreateLocationActionProto.
             * @memberof waiternow.common
             * @interface ICreateLocationActionProto
             */

            /**
             * Constructs a new CreateLocationActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a CreateLocationActionProto.
             * @implements ICreateLocationActionProto
             * @constructor
             * @param {waiternow.common.ICreateLocationActionProto=} [properties] Properties to set
             */
            function CreateLocationActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new CreateLocationActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.CreateLocationActionProto
             * @static
             * @param {waiternow.common.ICreateLocationActionProto=} [properties] Properties to set
             * @returns {waiternow.common.CreateLocationActionProto} CreateLocationActionProto instance
             */
            CreateLocationActionProto.create = function create(properties) {
                return new CreateLocationActionProto(properties);
            };

            /**
             * Encodes the specified CreateLocationActionProto message. Does not implicitly {@link waiternow.common.CreateLocationActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.CreateLocationActionProto
             * @static
             * @param {waiternow.common.ICreateLocationActionProto} message CreateLocationActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CreateLocationActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified CreateLocationActionProto message, length delimited. Does not implicitly {@link waiternow.common.CreateLocationActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.CreateLocationActionProto
             * @static
             * @param {waiternow.common.ICreateLocationActionProto} message CreateLocationActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CreateLocationActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CreateLocationActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.CreateLocationActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.CreateLocationActionProto} CreateLocationActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CreateLocationActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CreateLocationActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CreateLocationActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.CreateLocationActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.CreateLocationActionProto} CreateLocationActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CreateLocationActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CreateLocationActionProto message.
             * @function verify
             * @memberof waiternow.common.CreateLocationActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CreateLocationActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a CreateLocationActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.CreateLocationActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.CreateLocationActionProto} CreateLocationActionProto
             */
            CreateLocationActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.CreateLocationActionProto)
                    return object;
                return new $root.waiternow.common.CreateLocationActionProto();
            };

            /**
             * Creates a plain object from a CreateLocationActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.CreateLocationActionProto
             * @static
             * @param {waiternow.common.CreateLocationActionProto} message CreateLocationActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CreateLocationActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this CreateLocationActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.CreateLocationActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CreateLocationActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for CreateLocationActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.CreateLocationActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            CreateLocationActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.CreateLocationActionProto";
            };

            CreateLocationActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.CreateLocationActionProto
                 * @interface IRequest
                 * @property {waiternow.common.ILocationProto|null} [location] Request location
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.CreateLocationActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.CreateLocationActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request location.
                 * @member {waiternow.common.ILocationProto|null|undefined} location
                 * @memberof waiternow.common.CreateLocationActionProto.Request
                 * @instance
                 */
                Request.prototype.location = null;

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.CreateLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.CreateLocationActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.CreateLocationActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.CreateLocationActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.CreateLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.CreateLocationActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.location != null && Object.hasOwnProperty.call(message, "location"))
                        $root.waiternow.common.LocationProto.encode(message.location, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.CreateLocationActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.CreateLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.CreateLocationActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.CreateLocationActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.CreateLocationActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CreateLocationActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.location = $root.waiternow.common.LocationProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.CreateLocationActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.CreateLocationActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.CreateLocationActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.location != null && message.hasOwnProperty("location")) {
                        var error = $root.waiternow.common.LocationProto.verify(message.location);
                        if (error)
                            return "location." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.CreateLocationActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.CreateLocationActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.CreateLocationActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.CreateLocationActionProto.Request();
                    if (object.location != null) {
                        if (typeof object.location !== "object")
                            throw TypeError(".waiternow.common.CreateLocationActionProto.Request.location: object expected");
                        message.location = $root.waiternow.common.LocationProto.fromObject(object.location);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.CreateLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.CreateLocationActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.location = null;
                    if (message.location != null && message.hasOwnProperty("location"))
                        object.location = $root.waiternow.common.LocationProto.toObject(message.location, options);
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.CreateLocationActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.CreateLocationActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.CreateLocationActionProto.Request";
                };

                return Request;
            })();

            CreateLocationActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.CreateLocationActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.ILocationProto|null} [location] Response location
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.CreateLocationActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.CreateLocationActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.CreateLocationActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response location.
                 * @member {waiternow.common.ILocationProto|null|undefined} location
                 * @memberof waiternow.common.CreateLocationActionProto.Response
                 * @instance
                 */
                Response.prototype.location = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.CreateLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.CreateLocationActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.CreateLocationActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.CreateLocationActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.CreateLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.CreateLocationActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.location != null && Object.hasOwnProperty.call(message, "location"))
                        $root.waiternow.common.LocationProto.encode(message.location, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.CreateLocationActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.CreateLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.CreateLocationActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.CreateLocationActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.CreateLocationActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CreateLocationActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.location = $root.waiternow.common.LocationProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.CreateLocationActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.CreateLocationActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.CreateLocationActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.location != null && message.hasOwnProperty("location")) {
                        var error = $root.waiternow.common.LocationProto.verify(message.location);
                        if (error)
                            return "location." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.CreateLocationActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.CreateLocationActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.CreateLocationActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.CreateLocationActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.CreateLocationActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.location != null) {
                        if (typeof object.location !== "object")
                            throw TypeError(".waiternow.common.CreateLocationActionProto.Response.location: object expected");
                        message.location = $root.waiternow.common.LocationProto.fromObject(object.location);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.CreateLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.CreateLocationActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.location = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.location != null && message.hasOwnProperty("location"))
                        object.location = $root.waiternow.common.LocationProto.toObject(message.location, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.CreateLocationActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.CreateLocationActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.CreateLocationActionProto.Response";
                };

                return Response;
            })();

            return CreateLocationActionProto;
        })();

        common.UpdateLocationActionProto = (function() {

            /**
             * Properties of an UpdateLocationActionProto.
             * @memberof waiternow.common
             * @interface IUpdateLocationActionProto
             */

            /**
             * Constructs a new UpdateLocationActionProto.
             * @memberof waiternow.common
             * @classdesc Represents an UpdateLocationActionProto.
             * @implements IUpdateLocationActionProto
             * @constructor
             * @param {waiternow.common.IUpdateLocationActionProto=} [properties] Properties to set
             */
            function UpdateLocationActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new UpdateLocationActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.UpdateLocationActionProto
             * @static
             * @param {waiternow.common.IUpdateLocationActionProto=} [properties] Properties to set
             * @returns {waiternow.common.UpdateLocationActionProto} UpdateLocationActionProto instance
             */
            UpdateLocationActionProto.create = function create(properties) {
                return new UpdateLocationActionProto(properties);
            };

            /**
             * Encodes the specified UpdateLocationActionProto message. Does not implicitly {@link waiternow.common.UpdateLocationActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.UpdateLocationActionProto
             * @static
             * @param {waiternow.common.IUpdateLocationActionProto} message UpdateLocationActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UpdateLocationActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified UpdateLocationActionProto message, length delimited. Does not implicitly {@link waiternow.common.UpdateLocationActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.UpdateLocationActionProto
             * @static
             * @param {waiternow.common.IUpdateLocationActionProto} message UpdateLocationActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UpdateLocationActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an UpdateLocationActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.UpdateLocationActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.UpdateLocationActionProto} UpdateLocationActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UpdateLocationActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.UpdateLocationActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an UpdateLocationActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.UpdateLocationActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.UpdateLocationActionProto} UpdateLocationActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UpdateLocationActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an UpdateLocationActionProto message.
             * @function verify
             * @memberof waiternow.common.UpdateLocationActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            UpdateLocationActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates an UpdateLocationActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.UpdateLocationActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.UpdateLocationActionProto} UpdateLocationActionProto
             */
            UpdateLocationActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.UpdateLocationActionProto)
                    return object;
                return new $root.waiternow.common.UpdateLocationActionProto();
            };

            /**
             * Creates a plain object from an UpdateLocationActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.UpdateLocationActionProto
             * @static
             * @param {waiternow.common.UpdateLocationActionProto} message UpdateLocationActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            UpdateLocationActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this UpdateLocationActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.UpdateLocationActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            UpdateLocationActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for UpdateLocationActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.UpdateLocationActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            UpdateLocationActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.UpdateLocationActionProto";
            };

            UpdateLocationActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.UpdateLocationActionProto
                 * @interface IRequest
                 * @property {waiternow.common.ILocationProto|null} [location] Request location
                 * @property {Array.<waiternow.common.UpdateLocationActionProto.Request.RemovableField>|null} [fieldsToRemove] Request fieldsToRemove
                 * @property {Array.<waiternow.common.UpdateLocationActionProto.Request.SettingsRemovableField>|null} [settingsFieldsToRemove] Request settingsFieldsToRemove
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.UpdateLocationActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.UpdateLocationActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    this.fieldsToRemove = [];
                    this.settingsFieldsToRemove = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request location.
                 * @member {waiternow.common.ILocationProto|null|undefined} location
                 * @memberof waiternow.common.UpdateLocationActionProto.Request
                 * @instance
                 */
                Request.prototype.location = null;

                /**
                 * Request fieldsToRemove.
                 * @member {Array.<waiternow.common.UpdateLocationActionProto.Request.RemovableField>} fieldsToRemove
                 * @memberof waiternow.common.UpdateLocationActionProto.Request
                 * @instance
                 */
                Request.prototype.fieldsToRemove = $util.emptyArray;

                /**
                 * Request settingsFieldsToRemove.
                 * @member {Array.<waiternow.common.UpdateLocationActionProto.Request.SettingsRemovableField>} settingsFieldsToRemove
                 * @memberof waiternow.common.UpdateLocationActionProto.Request
                 * @instance
                 */
                Request.prototype.settingsFieldsToRemove = $util.emptyArray;

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.UpdateLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.UpdateLocationActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.UpdateLocationActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.UpdateLocationActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.UpdateLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.UpdateLocationActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.location != null && Object.hasOwnProperty.call(message, "location"))
                        $root.waiternow.common.LocationProto.encode(message.location, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.fieldsToRemove != null && message.fieldsToRemove.length) {
                        writer.uint32(/* id 2, wireType 2 =*/18).fork();
                        for (var i = 0; i < message.fieldsToRemove.length; ++i)
                            writer.int32(message.fieldsToRemove[i]);
                        writer.ldelim();
                    }
                    if (message.settingsFieldsToRemove != null && message.settingsFieldsToRemove.length) {
                        writer.uint32(/* id 3, wireType 2 =*/26).fork();
                        for (var i = 0; i < message.settingsFieldsToRemove.length; ++i)
                            writer.int32(message.settingsFieldsToRemove[i]);
                        writer.ldelim();
                    }
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.UpdateLocationActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.UpdateLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.UpdateLocationActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.UpdateLocationActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.UpdateLocationActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.UpdateLocationActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.location = $root.waiternow.common.LocationProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                if (!(message.fieldsToRemove && message.fieldsToRemove.length))
                                    message.fieldsToRemove = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.fieldsToRemove.push(reader.int32());
                                } else
                                    message.fieldsToRemove.push(reader.int32());
                                break;
                            }
                        case 3: {
                                if (!(message.settingsFieldsToRemove && message.settingsFieldsToRemove.length))
                                    message.settingsFieldsToRemove = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.settingsFieldsToRemove.push(reader.int32());
                                } else
                                    message.settingsFieldsToRemove.push(reader.int32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.UpdateLocationActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.UpdateLocationActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.UpdateLocationActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.location != null && message.hasOwnProperty("location")) {
                        var error = $root.waiternow.common.LocationProto.verify(message.location);
                        if (error)
                            return "location." + error;
                    }
                    if (message.fieldsToRemove != null && message.hasOwnProperty("fieldsToRemove")) {
                        if (!Array.isArray(message.fieldsToRemove))
                            return "fieldsToRemove: array expected";
                        for (var i = 0; i < message.fieldsToRemove.length; ++i)
                            switch (message.fieldsToRemove[i]) {
                            default:
                                return "fieldsToRemove: enum value[] expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                    }
                    if (message.settingsFieldsToRemove != null && message.hasOwnProperty("settingsFieldsToRemove")) {
                        if (!Array.isArray(message.settingsFieldsToRemove))
                            return "settingsFieldsToRemove: array expected";
                        for (var i = 0; i < message.settingsFieldsToRemove.length; ++i)
                            switch (message.settingsFieldsToRemove[i]) {
                            default:
                                return "settingsFieldsToRemove: enum value[] expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                            case 8:
                            case 9:
                            case 10:
                            case 11:
                            case 12:
                            case 13:
                            case 14:
                            case 15:
                            case 16:
                            case 17:
                            case 18:
                            case 19:
                            case 22:
                            case 23:
                            case 28:
                            case 29:
                            case 31:
                            case 32:
                            case 33:
                            case 34:
                            case 35:
                            case 36:
                            case 37:
                            case 38:
                            case 39:
                            case 40:
                            case 20:
                            case 21:
                            case 24:
                            case 25:
                            case 26:
                            case 27:
                            case 30:
                                break;
                            }
                    }
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.UpdateLocationActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.UpdateLocationActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.UpdateLocationActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.UpdateLocationActionProto.Request();
                    if (object.location != null) {
                        if (typeof object.location !== "object")
                            throw TypeError(".waiternow.common.UpdateLocationActionProto.Request.location: object expected");
                        message.location = $root.waiternow.common.LocationProto.fromObject(object.location);
                    }
                    if (object.fieldsToRemove) {
                        if (!Array.isArray(object.fieldsToRemove))
                            throw TypeError(".waiternow.common.UpdateLocationActionProto.Request.fieldsToRemove: array expected");
                        message.fieldsToRemove = [];
                        for (var i = 0; i < object.fieldsToRemove.length; ++i)
                            switch (object.fieldsToRemove[i]) {
                            default:
                                if (typeof object.fieldsToRemove[i] === "number") {
                                    message.fieldsToRemove[i] = object.fieldsToRemove[i];
                                    break;
                                }
                            case "REMOVABLE_FIELD_UNSPECIFIED":
                            case 0:
                                message.fieldsToRemove[i] = 0;
                                break;
                            case "METADATA":
                            case 1:
                                message.fieldsToRemove[i] = 1;
                                break;
                            case "ANNOUNCEMENT":
                            case 2:
                                message.fieldsToRemove[i] = 2;
                                break;
                            }
                    }
                    if (object.settingsFieldsToRemove) {
                        if (!Array.isArray(object.settingsFieldsToRemove))
                            throw TypeError(".waiternow.common.UpdateLocationActionProto.Request.settingsFieldsToRemove: array expected");
                        message.settingsFieldsToRemove = [];
                        for (var i = 0; i < object.settingsFieldsToRemove.length; ++i)
                            switch (object.settingsFieldsToRemove[i]) {
                            default:
                                if (typeof object.settingsFieldsToRemove[i] === "number") {
                                    message.settingsFieldsToRemove[i] = object.settingsFieldsToRemove[i];
                                    break;
                                }
                            case "SETTINGS_REMOVABLE_FIELD_UNSPECIFIED":
                            case 0:
                                message.settingsFieldsToRemove[i] = 0;
                                break;
                            case "LOCALE_LANGUAGE":
                            case 1:
                                message.settingsFieldsToRemove[i] = 1;
                                break;
                            case "LOCALE_CURRENCY_CODE":
                            case 2:
                                message.settingsFieldsToRemove[i] = 2;
                                break;
                            case "LOCALE_TIMEZONE":
                            case 3:
                                message.settingsFieldsToRemove[i] = 3;
                                break;
                            case "VIEW_THEME":
                            case 4:
                                message.settingsFieldsToRemove[i] = 4;
                                break;
                            case "VIEW_APP_MODE":
                            case 5:
                                message.settingsFieldsToRemove[i] = 5;
                                break;
                            case "EXTERNAL_LINKS_WEBSITE":
                            case 6:
                                message.settingsFieldsToRemove[i] = 6;
                                break;
                            case "EXTERNAL_LINKS_YOUTUBE":
                            case 7:
                                message.settingsFieldsToRemove[i] = 7;
                                break;
                            case "EXTERNAL_LINKS_FACEBOOK":
                            case 8:
                                message.settingsFieldsToRemove[i] = 8;
                                break;
                            case "EXTERNAL_LINKS_INSTAGRAM":
                            case 9:
                                message.settingsFieldsToRemove[i] = 9;
                                break;
                            case "EXTERNAL_LINKS_TWITTER":
                            case 10:
                                message.settingsFieldsToRemove[i] = 10;
                                break;
                            case "EXTERNAL_LINKS_LINKED_IN":
                            case 11:
                                message.settingsFieldsToRemove[i] = 11;
                                break;
                            case "EXTERNAL_LINKS_TIKTOK":
                            case 12:
                                message.settingsFieldsToRemove[i] = 12;
                                break;
                            case "COLOR_PALETTE":
                            case 13:
                                message.settingsFieldsToRemove[i] = 13;
                                break;
                            case "ENABLED_FEATURES_PAYMENT_REQUIRED_FOR_ORDERS":
                            case 14:
                                message.settingsFieldsToRemove[i] = 14;
                                break;
                            case "ENABLED_FEATURES_POKE_WAITER_DISABLED":
                            case 15:
                                message.settingsFieldsToRemove[i] = 15;
                                break;
                            case "ENABLED_FEATURES_MENU_DISABLED":
                            case 16:
                                message.settingsFieldsToRemove[i] = 16;
                                break;
                            case "ENABLED_FEATURES_IMAGE_MENU_DISABLED":
                            case 17:
                                message.settingsFieldsToRemove[i] = 17;
                                break;
                            case "ENABLED_FEATURES_MESSAGE_WAITER_DISABLED":
                            case 18:
                                message.settingsFieldsToRemove[i] = 18;
                                break;
                            case "ENABLED_FEATURES_ASK_FOR_CHECK_DISABLED":
                            case 19:
                                message.settingsFieldsToRemove[i] = 19;
                                break;
                            case "ENABLED_FEATURES_SPECIAL_INSTRUCTIONS_DISABLED":
                            case 22:
                                message.settingsFieldsToRemove[i] = 22;
                                break;
                            case "ENABLED_FEATURES_COMPLETED_STATUS_SUPPORTED_FOR_PAID_ORDERS":
                            case 23:
                                message.settingsFieldsToRemove[i] = 23;
                                break;
                            case "ENABLED_FEATURES_IS_ONSITE_TIPS_DISABLED":
                            case 28:
                                message.settingsFieldsToRemove[i] = 28;
                                break;
                            case "ENABLED_FEATURES_IS_ONLINE_PICKUP_TIPS_ENABLED":
                            case 29:
                                message.settingsFieldsToRemove[i] = 29;
                                break;
                            case "ENABLED_FEATURES_IS_DELIVERY_DISABLED":
                            case 31:
                                message.settingsFieldsToRemove[i] = 31;
                                break;
                            case "ENABLED_FEATURES_CHARGE_CREDIT_CARD_FEE_TO_CONSUMER":
                            case 32:
                                message.settingsFieldsToRemove[i] = 32;
                                break;
                            case "ENABLED_FEATURES_IS_ALCOHOL_FOR_PICKUP_ALLOWED":
                            case 33:
                                message.settingsFieldsToRemove[i] = 33;
                                break;
                            case "ENABLED_FEATURES_IS_ALCOHOL_FOR_DELIVERY_ALLOWED":
                            case 34:
                                message.settingsFieldsToRemove[i] = 34;
                                break;
                            case "ENABLED_FEATURES_PRINT_ORDER_AND_RECEIPT":
                            case 35:
                                message.settingsFieldsToRemove[i] = 35;
                                break;
                            case "ENABLED_FEATURES_IS_ORDER_FOR_LATER_DISABLED":
                            case 36:
                                message.settingsFieldsToRemove[i] = 36;
                                break;
                            case "ENABLED_FEATURES_IS_ORDER_FOR_LATER_DAY_DISABLED":
                            case 37:
                                message.settingsFieldsToRemove[i] = 37;
                                break;
                            case "ENABLED_FEATURES_IS_SMS_ON_NEW_ORDERS_FOR_BUSINESS_WEB_ENABLED":
                            case 38:
                                message.settingsFieldsToRemove[i] = 38;
                                break;
                            case "ENABLED_FEATURES_EXPAND_QUANTITY_FOR_PRINTED_ORDERS":
                            case 39:
                                message.settingsFieldsToRemove[i] = 39;
                                break;
                            case "ENABLED_FEATURES_IS_BUSINESS_AUTO_START_SESSION_ENABLED":
                            case 40:
                                message.settingsFieldsToRemove[i] = 40;
                                break;
                            case "TAXES":
                            case 20:
                                message.settingsFieldsToRemove[i] = 20;
                                break;
                            case "PRINTERS":
                            case 21:
                                message.settingsFieldsToRemove[i] = 21;
                                break;
                            case "ORDER_PAYMENT_WAITERNOW_FEE":
                            case 24:
                                message.settingsFieldsToRemove[i] = 24;
                                break;
                            case "BUSINESS_HOURS":
                            case 25:
                                message.settingsFieldsToRemove[i] = 25;
                                break;
                            case "ALERT_CONFIG":
                            case 26:
                                message.settingsFieldsToRemove[i] = 26;
                                break;
                            case "ORDER_PREPARATION_DURATION":
                            case 27:
                                message.settingsFieldsToRemove[i] = 27;
                                break;
                            case "DELIVERY_CONFIG":
                            case 30:
                                message.settingsFieldsToRemove[i] = 30;
                                break;
                            }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.UpdateLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.UpdateLocationActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.fieldsToRemove = [];
                        object.settingsFieldsToRemove = [];
                    }
                    if (options.defaults)
                        object.location = null;
                    if (message.location != null && message.hasOwnProperty("location"))
                        object.location = $root.waiternow.common.LocationProto.toObject(message.location, options);
                    if (message.fieldsToRemove && message.fieldsToRemove.length) {
                        object.fieldsToRemove = [];
                        for (var j = 0; j < message.fieldsToRemove.length; ++j)
                            object.fieldsToRemove[j] = options.enums === String ? $root.waiternow.common.UpdateLocationActionProto.Request.RemovableField[message.fieldsToRemove[j]] === undefined ? message.fieldsToRemove[j] : $root.waiternow.common.UpdateLocationActionProto.Request.RemovableField[message.fieldsToRemove[j]] : message.fieldsToRemove[j];
                    }
                    if (message.settingsFieldsToRemove && message.settingsFieldsToRemove.length) {
                        object.settingsFieldsToRemove = [];
                        for (var j = 0; j < message.settingsFieldsToRemove.length; ++j)
                            object.settingsFieldsToRemove[j] = options.enums === String ? $root.waiternow.common.UpdateLocationActionProto.Request.SettingsRemovableField[message.settingsFieldsToRemove[j]] === undefined ? message.settingsFieldsToRemove[j] : $root.waiternow.common.UpdateLocationActionProto.Request.SettingsRemovableField[message.settingsFieldsToRemove[j]] : message.settingsFieldsToRemove[j];
                    }
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.UpdateLocationActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.UpdateLocationActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.UpdateLocationActionProto.Request";
                };

                /**
                 * RemovableField enum.
                 * @name waiternow.common.UpdateLocationActionProto.Request.RemovableField
                 * @enum {number}
                 * @property {number} REMOVABLE_FIELD_UNSPECIFIED=0 REMOVABLE_FIELD_UNSPECIFIED value
                 * @property {number} METADATA=1 METADATA value
                 * @property {number} ANNOUNCEMENT=2 ANNOUNCEMENT value
                 */
                Request.RemovableField = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "REMOVABLE_FIELD_UNSPECIFIED"] = 0;
                    values[valuesById[1] = "METADATA"] = 1;
                    values[valuesById[2] = "ANNOUNCEMENT"] = 2;
                    return values;
                })();

                /**
                 * SettingsRemovableField enum.
                 * @name waiternow.common.UpdateLocationActionProto.Request.SettingsRemovableField
                 * @enum {number}
                 * @property {number} SETTINGS_REMOVABLE_FIELD_UNSPECIFIED=0 SETTINGS_REMOVABLE_FIELD_UNSPECIFIED value
                 * @property {number} LOCALE_LANGUAGE=1 LOCALE_LANGUAGE value
                 * @property {number} LOCALE_CURRENCY_CODE=2 LOCALE_CURRENCY_CODE value
                 * @property {number} LOCALE_TIMEZONE=3 LOCALE_TIMEZONE value
                 * @property {number} VIEW_THEME=4 VIEW_THEME value
                 * @property {number} VIEW_APP_MODE=5 VIEW_APP_MODE value
                 * @property {number} EXTERNAL_LINKS_WEBSITE=6 EXTERNAL_LINKS_WEBSITE value
                 * @property {number} EXTERNAL_LINKS_YOUTUBE=7 EXTERNAL_LINKS_YOUTUBE value
                 * @property {number} EXTERNAL_LINKS_FACEBOOK=8 EXTERNAL_LINKS_FACEBOOK value
                 * @property {number} EXTERNAL_LINKS_INSTAGRAM=9 EXTERNAL_LINKS_INSTAGRAM value
                 * @property {number} EXTERNAL_LINKS_TWITTER=10 EXTERNAL_LINKS_TWITTER value
                 * @property {number} EXTERNAL_LINKS_LINKED_IN=11 EXTERNAL_LINKS_LINKED_IN value
                 * @property {number} EXTERNAL_LINKS_TIKTOK=12 EXTERNAL_LINKS_TIKTOK value
                 * @property {number} COLOR_PALETTE=13 COLOR_PALETTE value
                 * @property {number} ENABLED_FEATURES_PAYMENT_REQUIRED_FOR_ORDERS=14 ENABLED_FEATURES_PAYMENT_REQUIRED_FOR_ORDERS value
                 * @property {number} ENABLED_FEATURES_POKE_WAITER_DISABLED=15 ENABLED_FEATURES_POKE_WAITER_DISABLED value
                 * @property {number} ENABLED_FEATURES_MENU_DISABLED=16 ENABLED_FEATURES_MENU_DISABLED value
                 * @property {number} ENABLED_FEATURES_IMAGE_MENU_DISABLED=17 ENABLED_FEATURES_IMAGE_MENU_DISABLED value
                 * @property {number} ENABLED_FEATURES_MESSAGE_WAITER_DISABLED=18 ENABLED_FEATURES_MESSAGE_WAITER_DISABLED value
                 * @property {number} ENABLED_FEATURES_ASK_FOR_CHECK_DISABLED=19 ENABLED_FEATURES_ASK_FOR_CHECK_DISABLED value
                 * @property {number} ENABLED_FEATURES_SPECIAL_INSTRUCTIONS_DISABLED=22 ENABLED_FEATURES_SPECIAL_INSTRUCTIONS_DISABLED value
                 * @property {number} ENABLED_FEATURES_COMPLETED_STATUS_SUPPORTED_FOR_PAID_ORDERS=23 ENABLED_FEATURES_COMPLETED_STATUS_SUPPORTED_FOR_PAID_ORDERS value
                 * @property {number} ENABLED_FEATURES_IS_ONSITE_TIPS_DISABLED=28 ENABLED_FEATURES_IS_ONSITE_TIPS_DISABLED value
                 * @property {number} ENABLED_FEATURES_IS_ONLINE_PICKUP_TIPS_ENABLED=29 ENABLED_FEATURES_IS_ONLINE_PICKUP_TIPS_ENABLED value
                 * @property {number} ENABLED_FEATURES_IS_DELIVERY_DISABLED=31 ENABLED_FEATURES_IS_DELIVERY_DISABLED value
                 * @property {number} ENABLED_FEATURES_CHARGE_CREDIT_CARD_FEE_TO_CONSUMER=32 ENABLED_FEATURES_CHARGE_CREDIT_CARD_FEE_TO_CONSUMER value
                 * @property {number} ENABLED_FEATURES_IS_ALCOHOL_FOR_PICKUP_ALLOWED=33 ENABLED_FEATURES_IS_ALCOHOL_FOR_PICKUP_ALLOWED value
                 * @property {number} ENABLED_FEATURES_IS_ALCOHOL_FOR_DELIVERY_ALLOWED=34 ENABLED_FEATURES_IS_ALCOHOL_FOR_DELIVERY_ALLOWED value
                 * @property {number} ENABLED_FEATURES_PRINT_ORDER_AND_RECEIPT=35 ENABLED_FEATURES_PRINT_ORDER_AND_RECEIPT value
                 * @property {number} ENABLED_FEATURES_IS_ORDER_FOR_LATER_DISABLED=36 ENABLED_FEATURES_IS_ORDER_FOR_LATER_DISABLED value
                 * @property {number} ENABLED_FEATURES_IS_ORDER_FOR_LATER_DAY_DISABLED=37 ENABLED_FEATURES_IS_ORDER_FOR_LATER_DAY_DISABLED value
                 * @property {number} ENABLED_FEATURES_IS_SMS_ON_NEW_ORDERS_FOR_BUSINESS_WEB_ENABLED=38 ENABLED_FEATURES_IS_SMS_ON_NEW_ORDERS_FOR_BUSINESS_WEB_ENABLED value
                 * @property {number} ENABLED_FEATURES_EXPAND_QUANTITY_FOR_PRINTED_ORDERS=39 ENABLED_FEATURES_EXPAND_QUANTITY_FOR_PRINTED_ORDERS value
                 * @property {number} ENABLED_FEATURES_IS_BUSINESS_AUTO_START_SESSION_ENABLED=40 ENABLED_FEATURES_IS_BUSINESS_AUTO_START_SESSION_ENABLED value
                 * @property {number} TAXES=20 TAXES value
                 * @property {number} PRINTERS=21 PRINTERS value
                 * @property {number} ORDER_PAYMENT_WAITERNOW_FEE=24 ORDER_PAYMENT_WAITERNOW_FEE value
                 * @property {number} BUSINESS_HOURS=25 BUSINESS_HOURS value
                 * @property {number} ALERT_CONFIG=26 ALERT_CONFIG value
                 * @property {number} ORDER_PREPARATION_DURATION=27 ORDER_PREPARATION_DURATION value
                 * @property {number} DELIVERY_CONFIG=30 DELIVERY_CONFIG value
                 */
                Request.SettingsRemovableField = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "SETTINGS_REMOVABLE_FIELD_UNSPECIFIED"] = 0;
                    values[valuesById[1] = "LOCALE_LANGUAGE"] = 1;
                    values[valuesById[2] = "LOCALE_CURRENCY_CODE"] = 2;
                    values[valuesById[3] = "LOCALE_TIMEZONE"] = 3;
                    values[valuesById[4] = "VIEW_THEME"] = 4;
                    values[valuesById[5] = "VIEW_APP_MODE"] = 5;
                    values[valuesById[6] = "EXTERNAL_LINKS_WEBSITE"] = 6;
                    values[valuesById[7] = "EXTERNAL_LINKS_YOUTUBE"] = 7;
                    values[valuesById[8] = "EXTERNAL_LINKS_FACEBOOK"] = 8;
                    values[valuesById[9] = "EXTERNAL_LINKS_INSTAGRAM"] = 9;
                    values[valuesById[10] = "EXTERNAL_LINKS_TWITTER"] = 10;
                    values[valuesById[11] = "EXTERNAL_LINKS_LINKED_IN"] = 11;
                    values[valuesById[12] = "EXTERNAL_LINKS_TIKTOK"] = 12;
                    values[valuesById[13] = "COLOR_PALETTE"] = 13;
                    values[valuesById[14] = "ENABLED_FEATURES_PAYMENT_REQUIRED_FOR_ORDERS"] = 14;
                    values[valuesById[15] = "ENABLED_FEATURES_POKE_WAITER_DISABLED"] = 15;
                    values[valuesById[16] = "ENABLED_FEATURES_MENU_DISABLED"] = 16;
                    values[valuesById[17] = "ENABLED_FEATURES_IMAGE_MENU_DISABLED"] = 17;
                    values[valuesById[18] = "ENABLED_FEATURES_MESSAGE_WAITER_DISABLED"] = 18;
                    values[valuesById[19] = "ENABLED_FEATURES_ASK_FOR_CHECK_DISABLED"] = 19;
                    values[valuesById[22] = "ENABLED_FEATURES_SPECIAL_INSTRUCTIONS_DISABLED"] = 22;
                    values[valuesById[23] = "ENABLED_FEATURES_COMPLETED_STATUS_SUPPORTED_FOR_PAID_ORDERS"] = 23;
                    values[valuesById[28] = "ENABLED_FEATURES_IS_ONSITE_TIPS_DISABLED"] = 28;
                    values[valuesById[29] = "ENABLED_FEATURES_IS_ONLINE_PICKUP_TIPS_ENABLED"] = 29;
                    values[valuesById[31] = "ENABLED_FEATURES_IS_DELIVERY_DISABLED"] = 31;
                    values[valuesById[32] = "ENABLED_FEATURES_CHARGE_CREDIT_CARD_FEE_TO_CONSUMER"] = 32;
                    values[valuesById[33] = "ENABLED_FEATURES_IS_ALCOHOL_FOR_PICKUP_ALLOWED"] = 33;
                    values[valuesById[34] = "ENABLED_FEATURES_IS_ALCOHOL_FOR_DELIVERY_ALLOWED"] = 34;
                    values[valuesById[35] = "ENABLED_FEATURES_PRINT_ORDER_AND_RECEIPT"] = 35;
                    values[valuesById[36] = "ENABLED_FEATURES_IS_ORDER_FOR_LATER_DISABLED"] = 36;
                    values[valuesById[37] = "ENABLED_FEATURES_IS_ORDER_FOR_LATER_DAY_DISABLED"] = 37;
                    values[valuesById[38] = "ENABLED_FEATURES_IS_SMS_ON_NEW_ORDERS_FOR_BUSINESS_WEB_ENABLED"] = 38;
                    values[valuesById[39] = "ENABLED_FEATURES_EXPAND_QUANTITY_FOR_PRINTED_ORDERS"] = 39;
                    values[valuesById[40] = "ENABLED_FEATURES_IS_BUSINESS_AUTO_START_SESSION_ENABLED"] = 40;
                    values[valuesById[20] = "TAXES"] = 20;
                    values[valuesById[21] = "PRINTERS"] = 21;
                    values[valuesById[24] = "ORDER_PAYMENT_WAITERNOW_FEE"] = 24;
                    values[valuesById[25] = "BUSINESS_HOURS"] = 25;
                    values[valuesById[26] = "ALERT_CONFIG"] = 26;
                    values[valuesById[27] = "ORDER_PREPARATION_DURATION"] = 27;
                    values[valuesById[30] = "DELIVERY_CONFIG"] = 30;
                    return values;
                })();

                return Request;
            })();

            UpdateLocationActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.UpdateLocationActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.UpdateLocationActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.UpdateLocationActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.UpdateLocationActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.UpdateLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.UpdateLocationActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.UpdateLocationActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.UpdateLocationActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.UpdateLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.UpdateLocationActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.UpdateLocationActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.UpdateLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.UpdateLocationActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.UpdateLocationActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.UpdateLocationActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.UpdateLocationActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.UpdateLocationActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.UpdateLocationActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.UpdateLocationActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.UpdateLocationActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.UpdateLocationActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.UpdateLocationActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.UpdateLocationActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.UpdateLocationActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.UpdateLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.UpdateLocationActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.UpdateLocationActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.UpdateLocationActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.UpdateLocationActionProto.Response";
                };

                return Response;
            })();

            return UpdateLocationActionProto;
        })();

        common.DeleteLocationActionProto = (function() {

            /**
             * Properties of a DeleteLocationActionProto.
             * @memberof waiternow.common
             * @interface IDeleteLocationActionProto
             */

            /**
             * Constructs a new DeleteLocationActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a DeleteLocationActionProto.
             * @implements IDeleteLocationActionProto
             * @constructor
             * @param {waiternow.common.IDeleteLocationActionProto=} [properties] Properties to set
             */
            function DeleteLocationActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new DeleteLocationActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.DeleteLocationActionProto
             * @static
             * @param {waiternow.common.IDeleteLocationActionProto=} [properties] Properties to set
             * @returns {waiternow.common.DeleteLocationActionProto} DeleteLocationActionProto instance
             */
            DeleteLocationActionProto.create = function create(properties) {
                return new DeleteLocationActionProto(properties);
            };

            /**
             * Encodes the specified DeleteLocationActionProto message. Does not implicitly {@link waiternow.common.DeleteLocationActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.DeleteLocationActionProto
             * @static
             * @param {waiternow.common.IDeleteLocationActionProto} message DeleteLocationActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DeleteLocationActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified DeleteLocationActionProto message, length delimited. Does not implicitly {@link waiternow.common.DeleteLocationActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.DeleteLocationActionProto
             * @static
             * @param {waiternow.common.IDeleteLocationActionProto} message DeleteLocationActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DeleteLocationActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a DeleteLocationActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.DeleteLocationActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.DeleteLocationActionProto} DeleteLocationActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DeleteLocationActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.DeleteLocationActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a DeleteLocationActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.DeleteLocationActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.DeleteLocationActionProto} DeleteLocationActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DeleteLocationActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a DeleteLocationActionProto message.
             * @function verify
             * @memberof waiternow.common.DeleteLocationActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            DeleteLocationActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a DeleteLocationActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.DeleteLocationActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.DeleteLocationActionProto} DeleteLocationActionProto
             */
            DeleteLocationActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.DeleteLocationActionProto)
                    return object;
                return new $root.waiternow.common.DeleteLocationActionProto();
            };

            /**
             * Creates a plain object from a DeleteLocationActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.DeleteLocationActionProto
             * @static
             * @param {waiternow.common.DeleteLocationActionProto} message DeleteLocationActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            DeleteLocationActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this DeleteLocationActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.DeleteLocationActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            DeleteLocationActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for DeleteLocationActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.DeleteLocationActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            DeleteLocationActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.DeleteLocationActionProto";
            };

            DeleteLocationActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.DeleteLocationActionProto
                 * @interface IRequest
                 * @property {string|null} [locationId] Request locationId
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.DeleteLocationActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.DeleteLocationActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.DeleteLocationActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.DeleteLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.DeleteLocationActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.DeleteLocationActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.DeleteLocationActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.DeleteLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.DeleteLocationActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.DeleteLocationActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.DeleteLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.DeleteLocationActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.DeleteLocationActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.DeleteLocationActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.DeleteLocationActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.DeleteLocationActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.DeleteLocationActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.DeleteLocationActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.DeleteLocationActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.DeleteLocationActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.DeleteLocationActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.DeleteLocationActionProto.Request();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.DeleteLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.DeleteLocationActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.locationId = "";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.DeleteLocationActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.DeleteLocationActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.DeleteLocationActionProto.Request";
                };

                return Request;
            })();

            DeleteLocationActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.DeleteLocationActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.DeleteLocationActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.DeleteLocationActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.DeleteLocationActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.DeleteLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.DeleteLocationActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.DeleteLocationActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.DeleteLocationActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.DeleteLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.DeleteLocationActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.DeleteLocationActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.DeleteLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.DeleteLocationActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.DeleteLocationActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.DeleteLocationActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.DeleteLocationActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.DeleteLocationActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.DeleteLocationActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.DeleteLocationActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.DeleteLocationActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.DeleteLocationActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.DeleteLocationActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.DeleteLocationActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.DeleteLocationActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.DeleteLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.DeleteLocationActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.DeleteLocationActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.DeleteLocationActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.DeleteLocationActionProto.Response";
                };

                return Response;
            })();

            return DeleteLocationActionProto;
        })();

        common.GetLocationActionProto = (function() {

            /**
             * Properties of a GetLocationActionProto.
             * @memberof waiternow.common
             * @interface IGetLocationActionProto
             */

            /**
             * Constructs a new GetLocationActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a GetLocationActionProto.
             * @implements IGetLocationActionProto
             * @constructor
             * @param {waiternow.common.IGetLocationActionProto=} [properties] Properties to set
             */
            function GetLocationActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new GetLocationActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.GetLocationActionProto
             * @static
             * @param {waiternow.common.IGetLocationActionProto=} [properties] Properties to set
             * @returns {waiternow.common.GetLocationActionProto} GetLocationActionProto instance
             */
            GetLocationActionProto.create = function create(properties) {
                return new GetLocationActionProto(properties);
            };

            /**
             * Encodes the specified GetLocationActionProto message. Does not implicitly {@link waiternow.common.GetLocationActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.GetLocationActionProto
             * @static
             * @param {waiternow.common.IGetLocationActionProto} message GetLocationActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetLocationActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified GetLocationActionProto message, length delimited. Does not implicitly {@link waiternow.common.GetLocationActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.GetLocationActionProto
             * @static
             * @param {waiternow.common.IGetLocationActionProto} message GetLocationActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetLocationActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetLocationActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.GetLocationActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.GetLocationActionProto} GetLocationActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetLocationActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetLocationActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetLocationActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.GetLocationActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.GetLocationActionProto} GetLocationActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetLocationActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetLocationActionProto message.
             * @function verify
             * @memberof waiternow.common.GetLocationActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetLocationActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a GetLocationActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.GetLocationActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.GetLocationActionProto} GetLocationActionProto
             */
            GetLocationActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.GetLocationActionProto)
                    return object;
                return new $root.waiternow.common.GetLocationActionProto();
            };

            /**
             * Creates a plain object from a GetLocationActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.GetLocationActionProto
             * @static
             * @param {waiternow.common.GetLocationActionProto} message GetLocationActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetLocationActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this GetLocationActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.GetLocationActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetLocationActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for GetLocationActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.GetLocationActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            GetLocationActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.GetLocationActionProto";
            };

            GetLocationActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.GetLocationActionProto
                 * @interface IRequest
                 * @property {string|null} [locationId] Request locationId
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.GetLocationActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.GetLocationActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.GetLocationActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.GetLocationActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.GetLocationActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.GetLocationActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.GetLocationActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.GetLocationActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.GetLocationActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetLocationActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetLocationActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetLocationActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetLocationActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetLocationActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.GetLocationActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetLocationActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetLocationActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetLocationActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.GetLocationActionProto.Request();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.GetLocationActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.locationId = "";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetLocationActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetLocationActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetLocationActionProto.Request";
                };

                return Request;
            })();

            GetLocationActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.GetLocationActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.ILocationProto|null} [location] Response location
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.GetLocationActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.GetLocationActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.GetLocationActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response location.
                 * @member {waiternow.common.ILocationProto|null|undefined} location
                 * @memberof waiternow.common.GetLocationActionProto.Response
                 * @instance
                 */
                Response.prototype.location = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.GetLocationActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.GetLocationActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.GetLocationActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.GetLocationActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.location != null && Object.hasOwnProperty.call(message, "location"))
                        $root.waiternow.common.LocationProto.encode(message.location, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.GetLocationActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.GetLocationActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetLocationActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetLocationActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetLocationActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.location = $root.waiternow.common.LocationProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetLocationActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetLocationActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.GetLocationActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.location != null && message.hasOwnProperty("location")) {
                        var error = $root.waiternow.common.LocationProto.verify(message.location);
                        if (error)
                            return "location." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetLocationActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetLocationActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetLocationActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.GetLocationActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.GetLocationActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.location != null) {
                        if (typeof object.location !== "object")
                            throw TypeError(".waiternow.common.GetLocationActionProto.Response.location: object expected");
                        message.location = $root.waiternow.common.LocationProto.fromObject(object.location);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.GetLocationActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.location = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.location != null && message.hasOwnProperty("location"))
                        object.location = $root.waiternow.common.LocationProto.toObject(message.location, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetLocationActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetLocationActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetLocationActionProto.Response";
                };

                return Response;
            })();

            return GetLocationActionProto;
        })();

        common.GetLocationAnalyticsActionProto = (function() {

            /**
             * Properties of a GetLocationAnalyticsActionProto.
             * @memberof waiternow.common
             * @interface IGetLocationAnalyticsActionProto
             */

            /**
             * Constructs a new GetLocationAnalyticsActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a GetLocationAnalyticsActionProto.
             * @implements IGetLocationAnalyticsActionProto
             * @constructor
             * @param {waiternow.common.IGetLocationAnalyticsActionProto=} [properties] Properties to set
             */
            function GetLocationAnalyticsActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new GetLocationAnalyticsActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.GetLocationAnalyticsActionProto
             * @static
             * @param {waiternow.common.IGetLocationAnalyticsActionProto=} [properties] Properties to set
             * @returns {waiternow.common.GetLocationAnalyticsActionProto} GetLocationAnalyticsActionProto instance
             */
            GetLocationAnalyticsActionProto.create = function create(properties) {
                return new GetLocationAnalyticsActionProto(properties);
            };

            /**
             * Encodes the specified GetLocationAnalyticsActionProto message. Does not implicitly {@link waiternow.common.GetLocationAnalyticsActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.GetLocationAnalyticsActionProto
             * @static
             * @param {waiternow.common.IGetLocationAnalyticsActionProto} message GetLocationAnalyticsActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetLocationAnalyticsActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified GetLocationAnalyticsActionProto message, length delimited. Does not implicitly {@link waiternow.common.GetLocationAnalyticsActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.GetLocationAnalyticsActionProto
             * @static
             * @param {waiternow.common.IGetLocationAnalyticsActionProto} message GetLocationAnalyticsActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetLocationAnalyticsActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetLocationAnalyticsActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.GetLocationAnalyticsActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.GetLocationAnalyticsActionProto} GetLocationAnalyticsActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetLocationAnalyticsActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetLocationAnalyticsActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetLocationAnalyticsActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.GetLocationAnalyticsActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.GetLocationAnalyticsActionProto} GetLocationAnalyticsActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetLocationAnalyticsActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetLocationAnalyticsActionProto message.
             * @function verify
             * @memberof waiternow.common.GetLocationAnalyticsActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetLocationAnalyticsActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a GetLocationAnalyticsActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.GetLocationAnalyticsActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.GetLocationAnalyticsActionProto} GetLocationAnalyticsActionProto
             */
            GetLocationAnalyticsActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.GetLocationAnalyticsActionProto)
                    return object;
                return new $root.waiternow.common.GetLocationAnalyticsActionProto();
            };

            /**
             * Creates a plain object from a GetLocationAnalyticsActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.GetLocationAnalyticsActionProto
             * @static
             * @param {waiternow.common.GetLocationAnalyticsActionProto} message GetLocationAnalyticsActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetLocationAnalyticsActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this GetLocationAnalyticsActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.GetLocationAnalyticsActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetLocationAnalyticsActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for GetLocationAnalyticsActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.GetLocationAnalyticsActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            GetLocationAnalyticsActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.GetLocationAnalyticsActionProto";
            };

            GetLocationAnalyticsActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.GetLocationAnalyticsActionProto
                 * @interface IRequest
                 * @property {string|null} [locationId] Request locationId
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.GetLocationAnalyticsActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.GetLocationAnalyticsActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.GetLocationAnalyticsActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetLocationAnalyticsActionProto.Request
                 * @static
                 * @param {waiternow.common.GetLocationAnalyticsActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.GetLocationAnalyticsActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.GetLocationAnalyticsActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetLocationAnalyticsActionProto.Request
                 * @static
                 * @param {waiternow.common.GetLocationAnalyticsActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.GetLocationAnalyticsActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetLocationAnalyticsActionProto.Request
                 * @static
                 * @param {waiternow.common.GetLocationAnalyticsActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetLocationAnalyticsActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetLocationAnalyticsActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetLocationAnalyticsActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetLocationAnalyticsActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetLocationAnalyticsActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.GetLocationAnalyticsActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetLocationAnalyticsActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetLocationAnalyticsActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetLocationAnalyticsActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.GetLocationAnalyticsActionProto.Request();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetLocationAnalyticsActionProto.Request
                 * @static
                 * @param {waiternow.common.GetLocationAnalyticsActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.locationId = "";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetLocationAnalyticsActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetLocationAnalyticsActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetLocationAnalyticsActionProto.Request";
                };

                return Request;
            })();

            GetLocationAnalyticsActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.GetLocationAnalyticsActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IAnalyticsProto|null} [analytics] Response analytics
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.GetLocationAnalyticsActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.GetLocationAnalyticsActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.GetLocationAnalyticsActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response analytics.
                 * @member {waiternow.common.IAnalyticsProto|null|undefined} analytics
                 * @memberof waiternow.common.GetLocationAnalyticsActionProto.Response
                 * @instance
                 */
                Response.prototype.analytics = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetLocationAnalyticsActionProto.Response
                 * @static
                 * @param {waiternow.common.GetLocationAnalyticsActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.GetLocationAnalyticsActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.GetLocationAnalyticsActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetLocationAnalyticsActionProto.Response
                 * @static
                 * @param {waiternow.common.GetLocationAnalyticsActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.analytics != null && Object.hasOwnProperty.call(message, "analytics"))
                        $root.waiternow.common.AnalyticsProto.encode(message.analytics, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.GetLocationAnalyticsActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetLocationAnalyticsActionProto.Response
                 * @static
                 * @param {waiternow.common.GetLocationAnalyticsActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetLocationAnalyticsActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetLocationAnalyticsActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetLocationAnalyticsActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.analytics = $root.waiternow.common.AnalyticsProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetLocationAnalyticsActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetLocationAnalyticsActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.GetLocationAnalyticsActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.analytics != null && message.hasOwnProperty("analytics")) {
                        var error = $root.waiternow.common.AnalyticsProto.verify(message.analytics);
                        if (error)
                            return "analytics." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetLocationAnalyticsActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetLocationAnalyticsActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetLocationAnalyticsActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.GetLocationAnalyticsActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.GetLocationAnalyticsActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.analytics != null) {
                        if (typeof object.analytics !== "object")
                            throw TypeError(".waiternow.common.GetLocationAnalyticsActionProto.Response.analytics: object expected");
                        message.analytics = $root.waiternow.common.AnalyticsProto.fromObject(object.analytics);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetLocationAnalyticsActionProto.Response
                 * @static
                 * @param {waiternow.common.GetLocationAnalyticsActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.analytics = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.analytics != null && message.hasOwnProperty("analytics"))
                        object.analytics = $root.waiternow.common.AnalyticsProto.toObject(message.analytics, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetLocationAnalyticsActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetLocationAnalyticsActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetLocationAnalyticsActionProto.Response";
                };

                return Response;
            })();

            return GetLocationAnalyticsActionProto;
        })();

        common.GetBusinessLocationsActionProto = (function() {

            /**
             * Properties of a GetBusinessLocationsActionProto.
             * @memberof waiternow.common
             * @interface IGetBusinessLocationsActionProto
             */

            /**
             * Constructs a new GetBusinessLocationsActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a GetBusinessLocationsActionProto.
             * @implements IGetBusinessLocationsActionProto
             * @constructor
             * @param {waiternow.common.IGetBusinessLocationsActionProto=} [properties] Properties to set
             */
            function GetBusinessLocationsActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new GetBusinessLocationsActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.GetBusinessLocationsActionProto
             * @static
             * @param {waiternow.common.IGetBusinessLocationsActionProto=} [properties] Properties to set
             * @returns {waiternow.common.GetBusinessLocationsActionProto} GetBusinessLocationsActionProto instance
             */
            GetBusinessLocationsActionProto.create = function create(properties) {
                return new GetBusinessLocationsActionProto(properties);
            };

            /**
             * Encodes the specified GetBusinessLocationsActionProto message. Does not implicitly {@link waiternow.common.GetBusinessLocationsActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.GetBusinessLocationsActionProto
             * @static
             * @param {waiternow.common.IGetBusinessLocationsActionProto} message GetBusinessLocationsActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetBusinessLocationsActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified GetBusinessLocationsActionProto message, length delimited. Does not implicitly {@link waiternow.common.GetBusinessLocationsActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.GetBusinessLocationsActionProto
             * @static
             * @param {waiternow.common.IGetBusinessLocationsActionProto} message GetBusinessLocationsActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetBusinessLocationsActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetBusinessLocationsActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.GetBusinessLocationsActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.GetBusinessLocationsActionProto} GetBusinessLocationsActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetBusinessLocationsActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetBusinessLocationsActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetBusinessLocationsActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.GetBusinessLocationsActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.GetBusinessLocationsActionProto} GetBusinessLocationsActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetBusinessLocationsActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetBusinessLocationsActionProto message.
             * @function verify
             * @memberof waiternow.common.GetBusinessLocationsActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetBusinessLocationsActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a GetBusinessLocationsActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.GetBusinessLocationsActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.GetBusinessLocationsActionProto} GetBusinessLocationsActionProto
             */
            GetBusinessLocationsActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.GetBusinessLocationsActionProto)
                    return object;
                return new $root.waiternow.common.GetBusinessLocationsActionProto();
            };

            /**
             * Creates a plain object from a GetBusinessLocationsActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.GetBusinessLocationsActionProto
             * @static
             * @param {waiternow.common.GetBusinessLocationsActionProto} message GetBusinessLocationsActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetBusinessLocationsActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this GetBusinessLocationsActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.GetBusinessLocationsActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetBusinessLocationsActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for GetBusinessLocationsActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.GetBusinessLocationsActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            GetBusinessLocationsActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.GetBusinessLocationsActionProto";
            };

            GetBusinessLocationsActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.GetBusinessLocationsActionProto
                 * @interface IRequest
                 * @property {string|null} [businessId] Request businessId
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.GetBusinessLocationsActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.GetBusinessLocationsActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request businessId.
                 * @member {string} businessId
                 * @memberof waiternow.common.GetBusinessLocationsActionProto.Request
                 * @instance
                 */
                Request.prototype.businessId = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetBusinessLocationsActionProto.Request
                 * @static
                 * @param {waiternow.common.GetBusinessLocationsActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.GetBusinessLocationsActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.GetBusinessLocationsActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetBusinessLocationsActionProto.Request
                 * @static
                 * @param {waiternow.common.GetBusinessLocationsActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessId);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.GetBusinessLocationsActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetBusinessLocationsActionProto.Request
                 * @static
                 * @param {waiternow.common.GetBusinessLocationsActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetBusinessLocationsActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetBusinessLocationsActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetBusinessLocationsActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.businessId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetBusinessLocationsActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetBusinessLocationsActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.GetBusinessLocationsActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.businessId != null && message.hasOwnProperty("businessId"))
                        if (!$util.isString(message.businessId))
                            return "businessId: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetBusinessLocationsActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetBusinessLocationsActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetBusinessLocationsActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.GetBusinessLocationsActionProto.Request();
                    if (object.businessId != null)
                        message.businessId = String(object.businessId);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetBusinessLocationsActionProto.Request
                 * @static
                 * @param {waiternow.common.GetBusinessLocationsActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.businessId = "";
                    if (message.businessId != null && message.hasOwnProperty("businessId"))
                        object.businessId = message.businessId;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetBusinessLocationsActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetBusinessLocationsActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetBusinessLocationsActionProto.Request";
                };

                return Request;
            })();

            GetBusinessLocationsActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.GetBusinessLocationsActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IBusinessLocationsProto|null} [businessLocations] Response businessLocations
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.GetBusinessLocationsActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.GetBusinessLocationsActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.GetBusinessLocationsActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response businessLocations.
                 * @member {waiternow.common.IBusinessLocationsProto|null|undefined} businessLocations
                 * @memberof waiternow.common.GetBusinessLocationsActionProto.Response
                 * @instance
                 */
                Response.prototype.businessLocations = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetBusinessLocationsActionProto.Response
                 * @static
                 * @param {waiternow.common.GetBusinessLocationsActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.GetBusinessLocationsActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.GetBusinessLocationsActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetBusinessLocationsActionProto.Response
                 * @static
                 * @param {waiternow.common.GetBusinessLocationsActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.businessLocations != null && Object.hasOwnProperty.call(message, "businessLocations"))
                        $root.waiternow.common.BusinessLocationsProto.encode(message.businessLocations, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.GetBusinessLocationsActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetBusinessLocationsActionProto.Response
                 * @static
                 * @param {waiternow.common.GetBusinessLocationsActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetBusinessLocationsActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetBusinessLocationsActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetBusinessLocationsActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.businessLocations = $root.waiternow.common.BusinessLocationsProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetBusinessLocationsActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetBusinessLocationsActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.GetBusinessLocationsActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.businessLocations != null && message.hasOwnProperty("businessLocations")) {
                        var error = $root.waiternow.common.BusinessLocationsProto.verify(message.businessLocations);
                        if (error)
                            return "businessLocations." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetBusinessLocationsActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetBusinessLocationsActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetBusinessLocationsActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.GetBusinessLocationsActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.GetBusinessLocationsActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.businessLocations != null) {
                        if (typeof object.businessLocations !== "object")
                            throw TypeError(".waiternow.common.GetBusinessLocationsActionProto.Response.businessLocations: object expected");
                        message.businessLocations = $root.waiternow.common.BusinessLocationsProto.fromObject(object.businessLocations);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetBusinessLocationsActionProto.Response
                 * @static
                 * @param {waiternow.common.GetBusinessLocationsActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.businessLocations = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.businessLocations != null && message.hasOwnProperty("businessLocations"))
                        object.businessLocations = $root.waiternow.common.BusinessLocationsProto.toObject(message.businessLocations, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetBusinessLocationsActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetBusinessLocationsActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetBusinessLocationsActionProto.Response";
                };

                return Response;
            })();

            return GetBusinessLocationsActionProto;
        })();

        common.FindLocationsByUserActionProto = (function() {

            /**
             * Properties of a FindLocationsByUserActionProto.
             * @memberof waiternow.common
             * @interface IFindLocationsByUserActionProto
             */

            /**
             * Constructs a new FindLocationsByUserActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a FindLocationsByUserActionProto.
             * @implements IFindLocationsByUserActionProto
             * @constructor
             * @param {waiternow.common.IFindLocationsByUserActionProto=} [properties] Properties to set
             */
            function FindLocationsByUserActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new FindLocationsByUserActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FindLocationsByUserActionProto
             * @static
             * @param {waiternow.common.IFindLocationsByUserActionProto=} [properties] Properties to set
             * @returns {waiternow.common.FindLocationsByUserActionProto} FindLocationsByUserActionProto instance
             */
            FindLocationsByUserActionProto.create = function create(properties) {
                return new FindLocationsByUserActionProto(properties);
            };

            /**
             * Encodes the specified FindLocationsByUserActionProto message. Does not implicitly {@link waiternow.common.FindLocationsByUserActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FindLocationsByUserActionProto
             * @static
             * @param {waiternow.common.IFindLocationsByUserActionProto} message FindLocationsByUserActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindLocationsByUserActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified FindLocationsByUserActionProto message, length delimited. Does not implicitly {@link waiternow.common.FindLocationsByUserActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FindLocationsByUserActionProto
             * @static
             * @param {waiternow.common.IFindLocationsByUserActionProto} message FindLocationsByUserActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindLocationsByUserActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FindLocationsByUserActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FindLocationsByUserActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FindLocationsByUserActionProto} FindLocationsByUserActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindLocationsByUserActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindLocationsByUserActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FindLocationsByUserActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FindLocationsByUserActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FindLocationsByUserActionProto} FindLocationsByUserActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindLocationsByUserActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FindLocationsByUserActionProto message.
             * @function verify
             * @memberof waiternow.common.FindLocationsByUserActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FindLocationsByUserActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a FindLocationsByUserActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FindLocationsByUserActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FindLocationsByUserActionProto} FindLocationsByUserActionProto
             */
            FindLocationsByUserActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FindLocationsByUserActionProto)
                    return object;
                return new $root.waiternow.common.FindLocationsByUserActionProto();
            };

            /**
             * Creates a plain object from a FindLocationsByUserActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FindLocationsByUserActionProto
             * @static
             * @param {waiternow.common.FindLocationsByUserActionProto} message FindLocationsByUserActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FindLocationsByUserActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this FindLocationsByUserActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FindLocationsByUserActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FindLocationsByUserActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FindLocationsByUserActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.FindLocationsByUserActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FindLocationsByUserActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FindLocationsByUserActionProto";
            };

            FindLocationsByUserActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.FindLocationsByUserActionProto
                 * @interface IRequest
                 * @property {string|null} [userId] Request userId
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.FindLocationsByUserActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.FindLocationsByUserActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request userId.
                 * @member {string} userId
                 * @memberof waiternow.common.FindLocationsByUserActionProto.Request
                 * @instance
                 */
                Request.prototype.userId = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindLocationsByUserActionProto.Request
                 * @static
                 * @param {waiternow.common.FindLocationsByUserActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.FindLocationsByUserActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.FindLocationsByUserActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindLocationsByUserActionProto.Request
                 * @static
                 * @param {waiternow.common.FindLocationsByUserActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.userId);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.FindLocationsByUserActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindLocationsByUserActionProto.Request
                 * @static
                 * @param {waiternow.common.FindLocationsByUserActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindLocationsByUserActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindLocationsByUserActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindLocationsByUserActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.userId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindLocationsByUserActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindLocationsByUserActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.FindLocationsByUserActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.userId != null && message.hasOwnProperty("userId"))
                        if (!$util.isString(message.userId))
                            return "userId: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindLocationsByUserActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindLocationsByUserActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindLocationsByUserActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.FindLocationsByUserActionProto.Request();
                    if (object.userId != null)
                        message.userId = String(object.userId);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindLocationsByUserActionProto.Request
                 * @static
                 * @param {waiternow.common.FindLocationsByUserActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.userId = "";
                    if (message.userId != null && message.hasOwnProperty("userId"))
                        object.userId = message.userId;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindLocationsByUserActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindLocationsByUserActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindLocationsByUserActionProto.Request";
                };

                return Request;
            })();

            FindLocationsByUserActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.FindLocationsByUserActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IUserLocationsProto|null} [userLocations] Response userLocations
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.FindLocationsByUserActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.FindLocationsByUserActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.FindLocationsByUserActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response userLocations.
                 * @member {waiternow.common.IUserLocationsProto|null|undefined} userLocations
                 * @memberof waiternow.common.FindLocationsByUserActionProto.Response
                 * @instance
                 */
                Response.prototype.userLocations = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindLocationsByUserActionProto.Response
                 * @static
                 * @param {waiternow.common.FindLocationsByUserActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.FindLocationsByUserActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.FindLocationsByUserActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindLocationsByUserActionProto.Response
                 * @static
                 * @param {waiternow.common.FindLocationsByUserActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.userLocations != null && Object.hasOwnProperty.call(message, "userLocations"))
                        $root.waiternow.common.UserLocationsProto.encode(message.userLocations, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.FindLocationsByUserActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindLocationsByUserActionProto.Response
                 * @static
                 * @param {waiternow.common.FindLocationsByUserActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindLocationsByUserActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindLocationsByUserActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindLocationsByUserActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.userLocations = $root.waiternow.common.UserLocationsProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindLocationsByUserActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindLocationsByUserActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.FindLocationsByUserActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.userLocations != null && message.hasOwnProperty("userLocations")) {
                        var error = $root.waiternow.common.UserLocationsProto.verify(message.userLocations);
                        if (error)
                            return "userLocations." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindLocationsByUserActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindLocationsByUserActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindLocationsByUserActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.FindLocationsByUserActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.FindLocationsByUserActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.userLocations != null) {
                        if (typeof object.userLocations !== "object")
                            throw TypeError(".waiternow.common.FindLocationsByUserActionProto.Response.userLocations: object expected");
                        message.userLocations = $root.waiternow.common.UserLocationsProto.fromObject(object.userLocations);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindLocationsByUserActionProto.Response
                 * @static
                 * @param {waiternow.common.FindLocationsByUserActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.userLocations = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.userLocations != null && message.hasOwnProperty("userLocations"))
                        object.userLocations = $root.waiternow.common.UserLocationsProto.toObject(message.userLocations, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindLocationsByUserActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindLocationsByUserActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindLocationsByUserActionProto.Response";
                };

                return Response;
            })();

            return FindLocationsByUserActionProto;
        })();

        common.FindLocationsByUserAndBusinessActionProto = (function() {

            /**
             * Properties of a FindLocationsByUserAndBusinessActionProto.
             * @memberof waiternow.common
             * @interface IFindLocationsByUserAndBusinessActionProto
             */

            /**
             * Constructs a new FindLocationsByUserAndBusinessActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a FindLocationsByUserAndBusinessActionProto.
             * @implements IFindLocationsByUserAndBusinessActionProto
             * @constructor
             * @param {waiternow.common.IFindLocationsByUserAndBusinessActionProto=} [properties] Properties to set
             */
            function FindLocationsByUserAndBusinessActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new FindLocationsByUserAndBusinessActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FindLocationsByUserAndBusinessActionProto
             * @static
             * @param {waiternow.common.IFindLocationsByUserAndBusinessActionProto=} [properties] Properties to set
             * @returns {waiternow.common.FindLocationsByUserAndBusinessActionProto} FindLocationsByUserAndBusinessActionProto instance
             */
            FindLocationsByUserAndBusinessActionProto.create = function create(properties) {
                return new FindLocationsByUserAndBusinessActionProto(properties);
            };

            /**
             * Encodes the specified FindLocationsByUserAndBusinessActionProto message. Does not implicitly {@link waiternow.common.FindLocationsByUserAndBusinessActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FindLocationsByUserAndBusinessActionProto
             * @static
             * @param {waiternow.common.IFindLocationsByUserAndBusinessActionProto} message FindLocationsByUserAndBusinessActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindLocationsByUserAndBusinessActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified FindLocationsByUserAndBusinessActionProto message, length delimited. Does not implicitly {@link waiternow.common.FindLocationsByUserAndBusinessActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FindLocationsByUserAndBusinessActionProto
             * @static
             * @param {waiternow.common.IFindLocationsByUserAndBusinessActionProto} message FindLocationsByUserAndBusinessActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindLocationsByUserAndBusinessActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FindLocationsByUserAndBusinessActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FindLocationsByUserAndBusinessActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FindLocationsByUserAndBusinessActionProto} FindLocationsByUserAndBusinessActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindLocationsByUserAndBusinessActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindLocationsByUserAndBusinessActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FindLocationsByUserAndBusinessActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FindLocationsByUserAndBusinessActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FindLocationsByUserAndBusinessActionProto} FindLocationsByUserAndBusinessActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindLocationsByUserAndBusinessActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FindLocationsByUserAndBusinessActionProto message.
             * @function verify
             * @memberof waiternow.common.FindLocationsByUserAndBusinessActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FindLocationsByUserAndBusinessActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a FindLocationsByUserAndBusinessActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FindLocationsByUserAndBusinessActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FindLocationsByUserAndBusinessActionProto} FindLocationsByUserAndBusinessActionProto
             */
            FindLocationsByUserAndBusinessActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FindLocationsByUserAndBusinessActionProto)
                    return object;
                return new $root.waiternow.common.FindLocationsByUserAndBusinessActionProto();
            };

            /**
             * Creates a plain object from a FindLocationsByUserAndBusinessActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FindLocationsByUserAndBusinessActionProto
             * @static
             * @param {waiternow.common.FindLocationsByUserAndBusinessActionProto} message FindLocationsByUserAndBusinessActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FindLocationsByUserAndBusinessActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this FindLocationsByUserAndBusinessActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FindLocationsByUserAndBusinessActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FindLocationsByUserAndBusinessActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FindLocationsByUserAndBusinessActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.FindLocationsByUserAndBusinessActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FindLocationsByUserAndBusinessActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FindLocationsByUserAndBusinessActionProto";
            };

            FindLocationsByUserAndBusinessActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.FindLocationsByUserAndBusinessActionProto
                 * @interface IRequest
                 * @property {string|null} [userId] Request userId
                 * @property {string|null} [businessId] Request businessId
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.FindLocationsByUserAndBusinessActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.FindLocationsByUserAndBusinessActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request userId.
                 * @member {string} userId
                 * @memberof waiternow.common.FindLocationsByUserAndBusinessActionProto.Request
                 * @instance
                 */
                Request.prototype.userId = "";

                /**
                 * Request businessId.
                 * @member {string} businessId
                 * @memberof waiternow.common.FindLocationsByUserAndBusinessActionProto.Request
                 * @instance
                 */
                Request.prototype.businessId = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindLocationsByUserAndBusinessActionProto.Request
                 * @static
                 * @param {waiternow.common.FindLocationsByUserAndBusinessActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.FindLocationsByUserAndBusinessActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.FindLocationsByUserAndBusinessActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindLocationsByUserAndBusinessActionProto.Request
                 * @static
                 * @param {waiternow.common.FindLocationsByUserAndBusinessActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.userId);
                    if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.businessId);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.FindLocationsByUserAndBusinessActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindLocationsByUserAndBusinessActionProto.Request
                 * @static
                 * @param {waiternow.common.FindLocationsByUserAndBusinessActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindLocationsByUserAndBusinessActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindLocationsByUserAndBusinessActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindLocationsByUserAndBusinessActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.userId = reader.string();
                                break;
                            }
                        case 2: {
                                message.businessId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindLocationsByUserAndBusinessActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindLocationsByUserAndBusinessActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.FindLocationsByUserAndBusinessActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.userId != null && message.hasOwnProperty("userId"))
                        if (!$util.isString(message.userId))
                            return "userId: string expected";
                    if (message.businessId != null && message.hasOwnProperty("businessId"))
                        if (!$util.isString(message.businessId))
                            return "businessId: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindLocationsByUserAndBusinessActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindLocationsByUserAndBusinessActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindLocationsByUserAndBusinessActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.FindLocationsByUserAndBusinessActionProto.Request();
                    if (object.userId != null)
                        message.userId = String(object.userId);
                    if (object.businessId != null)
                        message.businessId = String(object.businessId);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindLocationsByUserAndBusinessActionProto.Request
                 * @static
                 * @param {waiternow.common.FindLocationsByUserAndBusinessActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.userId = "";
                        object.businessId = "";
                    }
                    if (message.userId != null && message.hasOwnProperty("userId"))
                        object.userId = message.userId;
                    if (message.businessId != null && message.hasOwnProperty("businessId"))
                        object.businessId = message.businessId;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindLocationsByUserAndBusinessActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindLocationsByUserAndBusinessActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindLocationsByUserAndBusinessActionProto.Request";
                };

                return Request;
            })();

            FindLocationsByUserAndBusinessActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.FindLocationsByUserAndBusinessActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IUserLocationsProto|null} [userLocations] Response userLocations
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.FindLocationsByUserAndBusinessActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.FindLocationsByUserAndBusinessActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.FindLocationsByUserAndBusinessActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response userLocations.
                 * @member {waiternow.common.IUserLocationsProto|null|undefined} userLocations
                 * @memberof waiternow.common.FindLocationsByUserAndBusinessActionProto.Response
                 * @instance
                 */
                Response.prototype.userLocations = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindLocationsByUserAndBusinessActionProto.Response
                 * @static
                 * @param {waiternow.common.FindLocationsByUserAndBusinessActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.FindLocationsByUserAndBusinessActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.FindLocationsByUserAndBusinessActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindLocationsByUserAndBusinessActionProto.Response
                 * @static
                 * @param {waiternow.common.FindLocationsByUserAndBusinessActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.userLocations != null && Object.hasOwnProperty.call(message, "userLocations"))
                        $root.waiternow.common.UserLocationsProto.encode(message.userLocations, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.FindLocationsByUserAndBusinessActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindLocationsByUserAndBusinessActionProto.Response
                 * @static
                 * @param {waiternow.common.FindLocationsByUserAndBusinessActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindLocationsByUserAndBusinessActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindLocationsByUserAndBusinessActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindLocationsByUserAndBusinessActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.userLocations = $root.waiternow.common.UserLocationsProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindLocationsByUserAndBusinessActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindLocationsByUserAndBusinessActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.FindLocationsByUserAndBusinessActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.userLocations != null && message.hasOwnProperty("userLocations")) {
                        var error = $root.waiternow.common.UserLocationsProto.verify(message.userLocations);
                        if (error)
                            return "userLocations." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindLocationsByUserAndBusinessActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindLocationsByUserAndBusinessActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindLocationsByUserAndBusinessActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.FindLocationsByUserAndBusinessActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.FindLocationsByUserAndBusinessActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.userLocations != null) {
                        if (typeof object.userLocations !== "object")
                            throw TypeError(".waiternow.common.FindLocationsByUserAndBusinessActionProto.Response.userLocations: object expected");
                        message.userLocations = $root.waiternow.common.UserLocationsProto.fromObject(object.userLocations);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindLocationsByUserAndBusinessActionProto.Response
                 * @static
                 * @param {waiternow.common.FindLocationsByUserAndBusinessActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.userLocations = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.userLocations != null && message.hasOwnProperty("userLocations"))
                        object.userLocations = $root.waiternow.common.UserLocationsProto.toObject(message.userLocations, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindLocationsByUserAndBusinessActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindLocationsByUserAndBusinessActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindLocationsByUserAndBusinessActionProto.Response";
                };

                return Response;
            })();

            return FindLocationsByUserAndBusinessActionProto;
        })();

        common.FindLocationsByBusinessActionProto = (function() {

            /**
             * Properties of a FindLocationsByBusinessActionProto.
             * @memberof waiternow.common
             * @interface IFindLocationsByBusinessActionProto
             */

            /**
             * Constructs a new FindLocationsByBusinessActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a FindLocationsByBusinessActionProto.
             * @implements IFindLocationsByBusinessActionProto
             * @constructor
             * @param {waiternow.common.IFindLocationsByBusinessActionProto=} [properties] Properties to set
             */
            function FindLocationsByBusinessActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new FindLocationsByBusinessActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FindLocationsByBusinessActionProto
             * @static
             * @param {waiternow.common.IFindLocationsByBusinessActionProto=} [properties] Properties to set
             * @returns {waiternow.common.FindLocationsByBusinessActionProto} FindLocationsByBusinessActionProto instance
             */
            FindLocationsByBusinessActionProto.create = function create(properties) {
                return new FindLocationsByBusinessActionProto(properties);
            };

            /**
             * Encodes the specified FindLocationsByBusinessActionProto message. Does not implicitly {@link waiternow.common.FindLocationsByBusinessActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FindLocationsByBusinessActionProto
             * @static
             * @param {waiternow.common.IFindLocationsByBusinessActionProto} message FindLocationsByBusinessActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindLocationsByBusinessActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified FindLocationsByBusinessActionProto message, length delimited. Does not implicitly {@link waiternow.common.FindLocationsByBusinessActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FindLocationsByBusinessActionProto
             * @static
             * @param {waiternow.common.IFindLocationsByBusinessActionProto} message FindLocationsByBusinessActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindLocationsByBusinessActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FindLocationsByBusinessActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FindLocationsByBusinessActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FindLocationsByBusinessActionProto} FindLocationsByBusinessActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindLocationsByBusinessActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindLocationsByBusinessActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FindLocationsByBusinessActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FindLocationsByBusinessActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FindLocationsByBusinessActionProto} FindLocationsByBusinessActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindLocationsByBusinessActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FindLocationsByBusinessActionProto message.
             * @function verify
             * @memberof waiternow.common.FindLocationsByBusinessActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FindLocationsByBusinessActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a FindLocationsByBusinessActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FindLocationsByBusinessActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FindLocationsByBusinessActionProto} FindLocationsByBusinessActionProto
             */
            FindLocationsByBusinessActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FindLocationsByBusinessActionProto)
                    return object;
                return new $root.waiternow.common.FindLocationsByBusinessActionProto();
            };

            /**
             * Creates a plain object from a FindLocationsByBusinessActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FindLocationsByBusinessActionProto
             * @static
             * @param {waiternow.common.FindLocationsByBusinessActionProto} message FindLocationsByBusinessActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FindLocationsByBusinessActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this FindLocationsByBusinessActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FindLocationsByBusinessActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FindLocationsByBusinessActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FindLocationsByBusinessActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.FindLocationsByBusinessActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FindLocationsByBusinessActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FindLocationsByBusinessActionProto";
            };

            FindLocationsByBusinessActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.FindLocationsByBusinessActionProto
                 * @interface IRequest
                 * @property {string|null} [businessId] Request businessId
                 * @property {string|null} [continuationToken] Request continuationToken
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.FindLocationsByBusinessActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.FindLocationsByBusinessActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request businessId.
                 * @member {string} businessId
                 * @memberof waiternow.common.FindLocationsByBusinessActionProto.Request
                 * @instance
                 */
                Request.prototype.businessId = "";

                /**
                 * Request continuationToken.
                 * @member {string} continuationToken
                 * @memberof waiternow.common.FindLocationsByBusinessActionProto.Request
                 * @instance
                 */
                Request.prototype.continuationToken = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindLocationsByBusinessActionProto.Request
                 * @static
                 * @param {waiternow.common.FindLocationsByBusinessActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.FindLocationsByBusinessActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.FindLocationsByBusinessActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindLocationsByBusinessActionProto.Request
                 * @static
                 * @param {waiternow.common.FindLocationsByBusinessActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessId);
                    if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.continuationToken);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.FindLocationsByBusinessActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindLocationsByBusinessActionProto.Request
                 * @static
                 * @param {waiternow.common.FindLocationsByBusinessActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindLocationsByBusinessActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindLocationsByBusinessActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindLocationsByBusinessActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.businessId = reader.string();
                                break;
                            }
                        case 2: {
                                message.continuationToken = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindLocationsByBusinessActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindLocationsByBusinessActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.FindLocationsByBusinessActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.businessId != null && message.hasOwnProperty("businessId"))
                        if (!$util.isString(message.businessId))
                            return "businessId: string expected";
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        if (!$util.isString(message.continuationToken))
                            return "continuationToken: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindLocationsByBusinessActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindLocationsByBusinessActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindLocationsByBusinessActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.FindLocationsByBusinessActionProto.Request();
                    if (object.businessId != null)
                        message.businessId = String(object.businessId);
                    if (object.continuationToken != null)
                        message.continuationToken = String(object.continuationToken);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindLocationsByBusinessActionProto.Request
                 * @static
                 * @param {waiternow.common.FindLocationsByBusinessActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.businessId = "";
                        object.continuationToken = "";
                    }
                    if (message.businessId != null && message.hasOwnProperty("businessId"))
                        object.businessId = message.businessId;
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        object.continuationToken = message.continuationToken;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindLocationsByBusinessActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindLocationsByBusinessActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindLocationsByBusinessActionProto.Request";
                };

                return Request;
            })();

            FindLocationsByBusinessActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.FindLocationsByBusinessActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.ILocationsProto|null} [locations] Response locations
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.FindLocationsByBusinessActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.FindLocationsByBusinessActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.FindLocationsByBusinessActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response locations.
                 * @member {waiternow.common.ILocationsProto|null|undefined} locations
                 * @memberof waiternow.common.FindLocationsByBusinessActionProto.Response
                 * @instance
                 */
                Response.prototype.locations = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindLocationsByBusinessActionProto.Response
                 * @static
                 * @param {waiternow.common.FindLocationsByBusinessActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.FindLocationsByBusinessActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.FindLocationsByBusinessActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindLocationsByBusinessActionProto.Response
                 * @static
                 * @param {waiternow.common.FindLocationsByBusinessActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.locations != null && Object.hasOwnProperty.call(message, "locations"))
                        $root.waiternow.common.LocationsProto.encode(message.locations, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.FindLocationsByBusinessActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindLocationsByBusinessActionProto.Response
                 * @static
                 * @param {waiternow.common.FindLocationsByBusinessActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindLocationsByBusinessActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindLocationsByBusinessActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindLocationsByBusinessActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.locations = $root.waiternow.common.LocationsProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindLocationsByBusinessActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindLocationsByBusinessActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.FindLocationsByBusinessActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.locations != null && message.hasOwnProperty("locations")) {
                        var error = $root.waiternow.common.LocationsProto.verify(message.locations);
                        if (error)
                            return "locations." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindLocationsByBusinessActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindLocationsByBusinessActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindLocationsByBusinessActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.FindLocationsByBusinessActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.FindLocationsByBusinessActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.locations != null) {
                        if (typeof object.locations !== "object")
                            throw TypeError(".waiternow.common.FindLocationsByBusinessActionProto.Response.locations: object expected");
                        message.locations = $root.waiternow.common.LocationsProto.fromObject(object.locations);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindLocationsByBusinessActionProto.Response
                 * @static
                 * @param {waiternow.common.FindLocationsByBusinessActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.locations = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.locations != null && message.hasOwnProperty("locations"))
                        object.locations = $root.waiternow.common.LocationsProto.toObject(message.locations, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindLocationsByBusinessActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindLocationsByBusinessActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindLocationsByBusinessActionProto.Response";
                };

                return Response;
            })();

            return FindLocationsByBusinessActionProto;
        })();

        common.FindUsersByLocationActionProto = (function() {

            /**
             * Properties of a FindUsersByLocationActionProto.
             * @memberof waiternow.common
             * @interface IFindUsersByLocationActionProto
             */

            /**
             * Constructs a new FindUsersByLocationActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a FindUsersByLocationActionProto.
             * @implements IFindUsersByLocationActionProto
             * @constructor
             * @param {waiternow.common.IFindUsersByLocationActionProto=} [properties] Properties to set
             */
            function FindUsersByLocationActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new FindUsersByLocationActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FindUsersByLocationActionProto
             * @static
             * @param {waiternow.common.IFindUsersByLocationActionProto=} [properties] Properties to set
             * @returns {waiternow.common.FindUsersByLocationActionProto} FindUsersByLocationActionProto instance
             */
            FindUsersByLocationActionProto.create = function create(properties) {
                return new FindUsersByLocationActionProto(properties);
            };

            /**
             * Encodes the specified FindUsersByLocationActionProto message. Does not implicitly {@link waiternow.common.FindUsersByLocationActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FindUsersByLocationActionProto
             * @static
             * @param {waiternow.common.IFindUsersByLocationActionProto} message FindUsersByLocationActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindUsersByLocationActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified FindUsersByLocationActionProto message, length delimited. Does not implicitly {@link waiternow.common.FindUsersByLocationActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FindUsersByLocationActionProto
             * @static
             * @param {waiternow.common.IFindUsersByLocationActionProto} message FindUsersByLocationActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindUsersByLocationActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FindUsersByLocationActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FindUsersByLocationActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FindUsersByLocationActionProto} FindUsersByLocationActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindUsersByLocationActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindUsersByLocationActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FindUsersByLocationActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FindUsersByLocationActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FindUsersByLocationActionProto} FindUsersByLocationActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindUsersByLocationActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FindUsersByLocationActionProto message.
             * @function verify
             * @memberof waiternow.common.FindUsersByLocationActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FindUsersByLocationActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a FindUsersByLocationActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FindUsersByLocationActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FindUsersByLocationActionProto} FindUsersByLocationActionProto
             */
            FindUsersByLocationActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FindUsersByLocationActionProto)
                    return object;
                return new $root.waiternow.common.FindUsersByLocationActionProto();
            };

            /**
             * Creates a plain object from a FindUsersByLocationActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FindUsersByLocationActionProto
             * @static
             * @param {waiternow.common.FindUsersByLocationActionProto} message FindUsersByLocationActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FindUsersByLocationActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this FindUsersByLocationActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FindUsersByLocationActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FindUsersByLocationActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FindUsersByLocationActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.FindUsersByLocationActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FindUsersByLocationActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FindUsersByLocationActionProto";
            };

            FindUsersByLocationActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.FindUsersByLocationActionProto
                 * @interface IRequest
                 * @property {string|null} [locationId] Request locationId
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.FindUsersByLocationActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.FindUsersByLocationActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.FindUsersByLocationActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindUsersByLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.FindUsersByLocationActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.FindUsersByLocationActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.FindUsersByLocationActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindUsersByLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.FindUsersByLocationActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.FindUsersByLocationActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindUsersByLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.FindUsersByLocationActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindUsersByLocationActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindUsersByLocationActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindUsersByLocationActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindUsersByLocationActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindUsersByLocationActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.FindUsersByLocationActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindUsersByLocationActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindUsersByLocationActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindUsersByLocationActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.FindUsersByLocationActionProto.Request();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindUsersByLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.FindUsersByLocationActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.locationId = "";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindUsersByLocationActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindUsersByLocationActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindUsersByLocationActionProto.Request";
                };

                return Request;
            })();

            FindUsersByLocationActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.FindUsersByLocationActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.ILocationUsersProto|null} [locationUsers] Response locationUsers
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.FindUsersByLocationActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.FindUsersByLocationActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.FindUsersByLocationActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response locationUsers.
                 * @member {waiternow.common.ILocationUsersProto|null|undefined} locationUsers
                 * @memberof waiternow.common.FindUsersByLocationActionProto.Response
                 * @instance
                 */
                Response.prototype.locationUsers = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindUsersByLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.FindUsersByLocationActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.FindUsersByLocationActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.FindUsersByLocationActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindUsersByLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.FindUsersByLocationActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.locationUsers != null && Object.hasOwnProperty.call(message, "locationUsers"))
                        $root.waiternow.common.LocationUsersProto.encode(message.locationUsers, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.FindUsersByLocationActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindUsersByLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.FindUsersByLocationActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindUsersByLocationActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindUsersByLocationActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindUsersByLocationActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.locationUsers = $root.waiternow.common.LocationUsersProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindUsersByLocationActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindUsersByLocationActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.FindUsersByLocationActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.locationUsers != null && message.hasOwnProperty("locationUsers")) {
                        var error = $root.waiternow.common.LocationUsersProto.verify(message.locationUsers);
                        if (error)
                            return "locationUsers." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindUsersByLocationActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindUsersByLocationActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindUsersByLocationActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.FindUsersByLocationActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.FindUsersByLocationActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.locationUsers != null) {
                        if (typeof object.locationUsers !== "object")
                            throw TypeError(".waiternow.common.FindUsersByLocationActionProto.Response.locationUsers: object expected");
                        message.locationUsers = $root.waiternow.common.LocationUsersProto.fromObject(object.locationUsers);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindUsersByLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.FindUsersByLocationActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.locationUsers = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.locationUsers != null && message.hasOwnProperty("locationUsers"))
                        object.locationUsers = $root.waiternow.common.LocationUsersProto.toObject(message.locationUsers, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindUsersByLocationActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindUsersByLocationActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindUsersByLocationActionProto.Response";
                };

                return Response;
            })();

            return FindUsersByLocationActionProto;
        })();

        common.AddAdminToLocationActionProto = (function() {

            /**
             * Properties of an AddAdminToLocationActionProto.
             * @memberof waiternow.common
             * @interface IAddAdminToLocationActionProto
             */

            /**
             * Constructs a new AddAdminToLocationActionProto.
             * @memberof waiternow.common
             * @classdesc Represents an AddAdminToLocationActionProto.
             * @implements IAddAdminToLocationActionProto
             * @constructor
             * @param {waiternow.common.IAddAdminToLocationActionProto=} [properties] Properties to set
             */
            function AddAdminToLocationActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new AddAdminToLocationActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.AddAdminToLocationActionProto
             * @static
             * @param {waiternow.common.IAddAdminToLocationActionProto=} [properties] Properties to set
             * @returns {waiternow.common.AddAdminToLocationActionProto} AddAdminToLocationActionProto instance
             */
            AddAdminToLocationActionProto.create = function create(properties) {
                return new AddAdminToLocationActionProto(properties);
            };

            /**
             * Encodes the specified AddAdminToLocationActionProto message. Does not implicitly {@link waiternow.common.AddAdminToLocationActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.AddAdminToLocationActionProto
             * @static
             * @param {waiternow.common.IAddAdminToLocationActionProto} message AddAdminToLocationActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AddAdminToLocationActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified AddAdminToLocationActionProto message, length delimited. Does not implicitly {@link waiternow.common.AddAdminToLocationActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.AddAdminToLocationActionProto
             * @static
             * @param {waiternow.common.IAddAdminToLocationActionProto} message AddAdminToLocationActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AddAdminToLocationActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AddAdminToLocationActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.AddAdminToLocationActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.AddAdminToLocationActionProto} AddAdminToLocationActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AddAdminToLocationActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.AddAdminToLocationActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AddAdminToLocationActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.AddAdminToLocationActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.AddAdminToLocationActionProto} AddAdminToLocationActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AddAdminToLocationActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AddAdminToLocationActionProto message.
             * @function verify
             * @memberof waiternow.common.AddAdminToLocationActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AddAdminToLocationActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates an AddAdminToLocationActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.AddAdminToLocationActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.AddAdminToLocationActionProto} AddAdminToLocationActionProto
             */
            AddAdminToLocationActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.AddAdminToLocationActionProto)
                    return object;
                return new $root.waiternow.common.AddAdminToLocationActionProto();
            };

            /**
             * Creates a plain object from an AddAdminToLocationActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.AddAdminToLocationActionProto
             * @static
             * @param {waiternow.common.AddAdminToLocationActionProto} message AddAdminToLocationActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AddAdminToLocationActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this AddAdminToLocationActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.AddAdminToLocationActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AddAdminToLocationActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for AddAdminToLocationActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.AddAdminToLocationActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            AddAdminToLocationActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.AddAdminToLocationActionProto";
            };

            AddAdminToLocationActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.AddAdminToLocationActionProto
                 * @interface IRequest
                 * @property {string|null} [locationId] Request locationId
                 * @property {string|null} [affectedUserEmail] Request affectedUserEmail
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.AddAdminToLocationActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.AddAdminToLocationActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.AddAdminToLocationActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = "";

                /**
                 * Request affectedUserEmail.
                 * @member {string} affectedUserEmail
                 * @memberof waiternow.common.AddAdminToLocationActionProto.Request
                 * @instance
                 */
                Request.prototype.affectedUserEmail = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.AddAdminToLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.AddAdminToLocationActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.AddAdminToLocationActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.AddAdminToLocationActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.AddAdminToLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.AddAdminToLocationActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    if (message.affectedUserEmail != null && Object.hasOwnProperty.call(message, "affectedUserEmail"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.affectedUserEmail);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.AddAdminToLocationActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.AddAdminToLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.AddAdminToLocationActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.AddAdminToLocationActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.AddAdminToLocationActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.AddAdminToLocationActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 2: {
                                message.affectedUserEmail = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.AddAdminToLocationActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.AddAdminToLocationActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.AddAdminToLocationActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    if (message.affectedUserEmail != null && message.hasOwnProperty("affectedUserEmail"))
                        if (!$util.isString(message.affectedUserEmail))
                            return "affectedUserEmail: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.AddAdminToLocationActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.AddAdminToLocationActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.AddAdminToLocationActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.AddAdminToLocationActionProto.Request();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    if (object.affectedUserEmail != null)
                        message.affectedUserEmail = String(object.affectedUserEmail);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.AddAdminToLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.AddAdminToLocationActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.locationId = "";
                        object.affectedUserEmail = "";
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    if (message.affectedUserEmail != null && message.hasOwnProperty("affectedUserEmail"))
                        object.affectedUserEmail = message.affectedUserEmail;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.AddAdminToLocationActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.AddAdminToLocationActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.AddAdminToLocationActionProto.Request";
                };

                return Request;
            })();

            AddAdminToLocationActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.AddAdminToLocationActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.AddAdminToLocationActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.AddAdminToLocationActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.AddAdminToLocationActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.AddAdminToLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.AddAdminToLocationActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.AddAdminToLocationActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.AddAdminToLocationActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.AddAdminToLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.AddAdminToLocationActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.AddAdminToLocationActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.AddAdminToLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.AddAdminToLocationActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.AddAdminToLocationActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.AddAdminToLocationActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.AddAdminToLocationActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.AddAdminToLocationActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.AddAdminToLocationActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.AddAdminToLocationActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.AddAdminToLocationActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.AddAdminToLocationActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.AddAdminToLocationActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.AddAdminToLocationActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.AddAdminToLocationActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.AddAdminToLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.AddAdminToLocationActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.AddAdminToLocationActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.AddAdminToLocationActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.AddAdminToLocationActionProto.Response";
                };

                return Response;
            })();

            return AddAdminToLocationActionProto;
        })();

        common.AddViewerToLocationActionProto = (function() {

            /**
             * Properties of an AddViewerToLocationActionProto.
             * @memberof waiternow.common
             * @interface IAddViewerToLocationActionProto
             */

            /**
             * Constructs a new AddViewerToLocationActionProto.
             * @memberof waiternow.common
             * @classdesc Represents an AddViewerToLocationActionProto.
             * @implements IAddViewerToLocationActionProto
             * @constructor
             * @param {waiternow.common.IAddViewerToLocationActionProto=} [properties] Properties to set
             */
            function AddViewerToLocationActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new AddViewerToLocationActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.AddViewerToLocationActionProto
             * @static
             * @param {waiternow.common.IAddViewerToLocationActionProto=} [properties] Properties to set
             * @returns {waiternow.common.AddViewerToLocationActionProto} AddViewerToLocationActionProto instance
             */
            AddViewerToLocationActionProto.create = function create(properties) {
                return new AddViewerToLocationActionProto(properties);
            };

            /**
             * Encodes the specified AddViewerToLocationActionProto message. Does not implicitly {@link waiternow.common.AddViewerToLocationActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.AddViewerToLocationActionProto
             * @static
             * @param {waiternow.common.IAddViewerToLocationActionProto} message AddViewerToLocationActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AddViewerToLocationActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified AddViewerToLocationActionProto message, length delimited. Does not implicitly {@link waiternow.common.AddViewerToLocationActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.AddViewerToLocationActionProto
             * @static
             * @param {waiternow.common.IAddViewerToLocationActionProto} message AddViewerToLocationActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AddViewerToLocationActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AddViewerToLocationActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.AddViewerToLocationActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.AddViewerToLocationActionProto} AddViewerToLocationActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AddViewerToLocationActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.AddViewerToLocationActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AddViewerToLocationActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.AddViewerToLocationActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.AddViewerToLocationActionProto} AddViewerToLocationActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AddViewerToLocationActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AddViewerToLocationActionProto message.
             * @function verify
             * @memberof waiternow.common.AddViewerToLocationActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AddViewerToLocationActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates an AddViewerToLocationActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.AddViewerToLocationActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.AddViewerToLocationActionProto} AddViewerToLocationActionProto
             */
            AddViewerToLocationActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.AddViewerToLocationActionProto)
                    return object;
                return new $root.waiternow.common.AddViewerToLocationActionProto();
            };

            /**
             * Creates a plain object from an AddViewerToLocationActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.AddViewerToLocationActionProto
             * @static
             * @param {waiternow.common.AddViewerToLocationActionProto} message AddViewerToLocationActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AddViewerToLocationActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this AddViewerToLocationActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.AddViewerToLocationActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AddViewerToLocationActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for AddViewerToLocationActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.AddViewerToLocationActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            AddViewerToLocationActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.AddViewerToLocationActionProto";
            };

            AddViewerToLocationActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.AddViewerToLocationActionProto
                 * @interface IRequest
                 * @property {string|null} [locationId] Request locationId
                 * @property {string|null} [affectedUserEmail] Request affectedUserEmail
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.AddViewerToLocationActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.AddViewerToLocationActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.AddViewerToLocationActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = "";

                /**
                 * Request affectedUserEmail.
                 * @member {string} affectedUserEmail
                 * @memberof waiternow.common.AddViewerToLocationActionProto.Request
                 * @instance
                 */
                Request.prototype.affectedUserEmail = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.AddViewerToLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.AddViewerToLocationActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.AddViewerToLocationActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.AddViewerToLocationActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.AddViewerToLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.AddViewerToLocationActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    if (message.affectedUserEmail != null && Object.hasOwnProperty.call(message, "affectedUserEmail"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.affectedUserEmail);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.AddViewerToLocationActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.AddViewerToLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.AddViewerToLocationActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.AddViewerToLocationActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.AddViewerToLocationActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.AddViewerToLocationActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 2: {
                                message.affectedUserEmail = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.AddViewerToLocationActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.AddViewerToLocationActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.AddViewerToLocationActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    if (message.affectedUserEmail != null && message.hasOwnProperty("affectedUserEmail"))
                        if (!$util.isString(message.affectedUserEmail))
                            return "affectedUserEmail: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.AddViewerToLocationActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.AddViewerToLocationActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.AddViewerToLocationActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.AddViewerToLocationActionProto.Request();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    if (object.affectedUserEmail != null)
                        message.affectedUserEmail = String(object.affectedUserEmail);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.AddViewerToLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.AddViewerToLocationActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.locationId = "";
                        object.affectedUserEmail = "";
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    if (message.affectedUserEmail != null && message.hasOwnProperty("affectedUserEmail"))
                        object.affectedUserEmail = message.affectedUserEmail;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.AddViewerToLocationActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.AddViewerToLocationActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.AddViewerToLocationActionProto.Request";
                };

                return Request;
            })();

            AddViewerToLocationActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.AddViewerToLocationActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.AddViewerToLocationActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.AddViewerToLocationActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.AddViewerToLocationActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.AddViewerToLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.AddViewerToLocationActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.AddViewerToLocationActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.AddViewerToLocationActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.AddViewerToLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.AddViewerToLocationActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.AddViewerToLocationActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.AddViewerToLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.AddViewerToLocationActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.AddViewerToLocationActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.AddViewerToLocationActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.AddViewerToLocationActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.AddViewerToLocationActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.AddViewerToLocationActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.AddViewerToLocationActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.AddViewerToLocationActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.AddViewerToLocationActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.AddViewerToLocationActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.AddViewerToLocationActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.AddViewerToLocationActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.AddViewerToLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.AddViewerToLocationActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.AddViewerToLocationActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.AddViewerToLocationActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.AddViewerToLocationActionProto.Response";
                };

                return Response;
            })();

            return AddViewerToLocationActionProto;
        })();

        common.RemoveUserFromLocationActionProto = (function() {

            /**
             * Properties of a RemoveUserFromLocationActionProto.
             * @memberof waiternow.common
             * @interface IRemoveUserFromLocationActionProto
             */

            /**
             * Constructs a new RemoveUserFromLocationActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a RemoveUserFromLocationActionProto.
             * @implements IRemoveUserFromLocationActionProto
             * @constructor
             * @param {waiternow.common.IRemoveUserFromLocationActionProto=} [properties] Properties to set
             */
            function RemoveUserFromLocationActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new RemoveUserFromLocationActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.RemoveUserFromLocationActionProto
             * @static
             * @param {waiternow.common.IRemoveUserFromLocationActionProto=} [properties] Properties to set
             * @returns {waiternow.common.RemoveUserFromLocationActionProto} RemoveUserFromLocationActionProto instance
             */
            RemoveUserFromLocationActionProto.create = function create(properties) {
                return new RemoveUserFromLocationActionProto(properties);
            };

            /**
             * Encodes the specified RemoveUserFromLocationActionProto message. Does not implicitly {@link waiternow.common.RemoveUserFromLocationActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.RemoveUserFromLocationActionProto
             * @static
             * @param {waiternow.common.IRemoveUserFromLocationActionProto} message RemoveUserFromLocationActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RemoveUserFromLocationActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified RemoveUserFromLocationActionProto message, length delimited. Does not implicitly {@link waiternow.common.RemoveUserFromLocationActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.RemoveUserFromLocationActionProto
             * @static
             * @param {waiternow.common.IRemoveUserFromLocationActionProto} message RemoveUserFromLocationActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RemoveUserFromLocationActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a RemoveUserFromLocationActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.RemoveUserFromLocationActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.RemoveUserFromLocationActionProto} RemoveUserFromLocationActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RemoveUserFromLocationActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.RemoveUserFromLocationActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a RemoveUserFromLocationActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.RemoveUserFromLocationActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.RemoveUserFromLocationActionProto} RemoveUserFromLocationActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RemoveUserFromLocationActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a RemoveUserFromLocationActionProto message.
             * @function verify
             * @memberof waiternow.common.RemoveUserFromLocationActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            RemoveUserFromLocationActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a RemoveUserFromLocationActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.RemoveUserFromLocationActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.RemoveUserFromLocationActionProto} RemoveUserFromLocationActionProto
             */
            RemoveUserFromLocationActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.RemoveUserFromLocationActionProto)
                    return object;
                return new $root.waiternow.common.RemoveUserFromLocationActionProto();
            };

            /**
             * Creates a plain object from a RemoveUserFromLocationActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.RemoveUserFromLocationActionProto
             * @static
             * @param {waiternow.common.RemoveUserFromLocationActionProto} message RemoveUserFromLocationActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            RemoveUserFromLocationActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this RemoveUserFromLocationActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.RemoveUserFromLocationActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            RemoveUserFromLocationActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for RemoveUserFromLocationActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.RemoveUserFromLocationActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            RemoveUserFromLocationActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.RemoveUserFromLocationActionProto";
            };

            RemoveUserFromLocationActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.RemoveUserFromLocationActionProto
                 * @interface IRequest
                 * @property {string|null} [locationId] Request locationId
                 * @property {string|null} [affectedUserEmail] Request affectedUserEmail
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.RemoveUserFromLocationActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.RemoveUserFromLocationActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.RemoveUserFromLocationActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = "";

                /**
                 * Request affectedUserEmail.
                 * @member {string} affectedUserEmail
                 * @memberof waiternow.common.RemoveUserFromLocationActionProto.Request
                 * @instance
                 */
                Request.prototype.affectedUserEmail = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.RemoveUserFromLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.RemoveUserFromLocationActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.RemoveUserFromLocationActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.RemoveUserFromLocationActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.RemoveUserFromLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.RemoveUserFromLocationActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    if (message.affectedUserEmail != null && Object.hasOwnProperty.call(message, "affectedUserEmail"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.affectedUserEmail);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.RemoveUserFromLocationActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.RemoveUserFromLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.RemoveUserFromLocationActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.RemoveUserFromLocationActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.RemoveUserFromLocationActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.RemoveUserFromLocationActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 2: {
                                message.affectedUserEmail = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.RemoveUserFromLocationActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.RemoveUserFromLocationActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.RemoveUserFromLocationActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    if (message.affectedUserEmail != null && message.hasOwnProperty("affectedUserEmail"))
                        if (!$util.isString(message.affectedUserEmail))
                            return "affectedUserEmail: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.RemoveUserFromLocationActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.RemoveUserFromLocationActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.RemoveUserFromLocationActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.RemoveUserFromLocationActionProto.Request();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    if (object.affectedUserEmail != null)
                        message.affectedUserEmail = String(object.affectedUserEmail);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.RemoveUserFromLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.RemoveUserFromLocationActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.locationId = "";
                        object.affectedUserEmail = "";
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    if (message.affectedUserEmail != null && message.hasOwnProperty("affectedUserEmail"))
                        object.affectedUserEmail = message.affectedUserEmail;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.RemoveUserFromLocationActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.RemoveUserFromLocationActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.RemoveUserFromLocationActionProto.Request";
                };

                return Request;
            })();

            RemoveUserFromLocationActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.RemoveUserFromLocationActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.RemoveUserFromLocationActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.RemoveUserFromLocationActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.RemoveUserFromLocationActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.RemoveUserFromLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.RemoveUserFromLocationActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.RemoveUserFromLocationActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.RemoveUserFromLocationActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.RemoveUserFromLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.RemoveUserFromLocationActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.RemoveUserFromLocationActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.RemoveUserFromLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.RemoveUserFromLocationActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.RemoveUserFromLocationActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.RemoveUserFromLocationActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.RemoveUserFromLocationActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.RemoveUserFromLocationActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.RemoveUserFromLocationActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.RemoveUserFromLocationActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.RemoveUserFromLocationActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.RemoveUserFromLocationActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.RemoveUserFromLocationActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.RemoveUserFromLocationActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.RemoveUserFromLocationActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.RemoveUserFromLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.RemoveUserFromLocationActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.RemoveUserFromLocationActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.RemoveUserFromLocationActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.RemoveUserFromLocationActionProto.Response";
                };

                return Response;
            })();

            return RemoveUserFromLocationActionProto;
        })();

        common.RemoveViewerFromLocationActionProto = (function() {

            /**
             * Properties of a RemoveViewerFromLocationActionProto.
             * @memberof waiternow.common
             * @interface IRemoveViewerFromLocationActionProto
             */

            /**
             * Constructs a new RemoveViewerFromLocationActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a RemoveViewerFromLocationActionProto.
             * @implements IRemoveViewerFromLocationActionProto
             * @constructor
             * @param {waiternow.common.IRemoveViewerFromLocationActionProto=} [properties] Properties to set
             */
            function RemoveViewerFromLocationActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new RemoveViewerFromLocationActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.RemoveViewerFromLocationActionProto
             * @static
             * @param {waiternow.common.IRemoveViewerFromLocationActionProto=} [properties] Properties to set
             * @returns {waiternow.common.RemoveViewerFromLocationActionProto} RemoveViewerFromLocationActionProto instance
             */
            RemoveViewerFromLocationActionProto.create = function create(properties) {
                return new RemoveViewerFromLocationActionProto(properties);
            };

            /**
             * Encodes the specified RemoveViewerFromLocationActionProto message. Does not implicitly {@link waiternow.common.RemoveViewerFromLocationActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.RemoveViewerFromLocationActionProto
             * @static
             * @param {waiternow.common.IRemoveViewerFromLocationActionProto} message RemoveViewerFromLocationActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RemoveViewerFromLocationActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified RemoveViewerFromLocationActionProto message, length delimited. Does not implicitly {@link waiternow.common.RemoveViewerFromLocationActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.RemoveViewerFromLocationActionProto
             * @static
             * @param {waiternow.common.IRemoveViewerFromLocationActionProto} message RemoveViewerFromLocationActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RemoveViewerFromLocationActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a RemoveViewerFromLocationActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.RemoveViewerFromLocationActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.RemoveViewerFromLocationActionProto} RemoveViewerFromLocationActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RemoveViewerFromLocationActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.RemoveViewerFromLocationActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a RemoveViewerFromLocationActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.RemoveViewerFromLocationActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.RemoveViewerFromLocationActionProto} RemoveViewerFromLocationActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RemoveViewerFromLocationActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a RemoveViewerFromLocationActionProto message.
             * @function verify
             * @memberof waiternow.common.RemoveViewerFromLocationActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            RemoveViewerFromLocationActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a RemoveViewerFromLocationActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.RemoveViewerFromLocationActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.RemoveViewerFromLocationActionProto} RemoveViewerFromLocationActionProto
             */
            RemoveViewerFromLocationActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.RemoveViewerFromLocationActionProto)
                    return object;
                return new $root.waiternow.common.RemoveViewerFromLocationActionProto();
            };

            /**
             * Creates a plain object from a RemoveViewerFromLocationActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.RemoveViewerFromLocationActionProto
             * @static
             * @param {waiternow.common.RemoveViewerFromLocationActionProto} message RemoveViewerFromLocationActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            RemoveViewerFromLocationActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this RemoveViewerFromLocationActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.RemoveViewerFromLocationActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            RemoveViewerFromLocationActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for RemoveViewerFromLocationActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.RemoveViewerFromLocationActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            RemoveViewerFromLocationActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.RemoveViewerFromLocationActionProto";
            };

            RemoveViewerFromLocationActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.RemoveViewerFromLocationActionProto
                 * @interface IRequest
                 * @property {string|null} [locationId] Request locationId
                 * @property {string|null} [affectedUserEmail] Request affectedUserEmail
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.RemoveViewerFromLocationActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.RemoveViewerFromLocationActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.RemoveViewerFromLocationActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = "";

                /**
                 * Request affectedUserEmail.
                 * @member {string} affectedUserEmail
                 * @memberof waiternow.common.RemoveViewerFromLocationActionProto.Request
                 * @instance
                 */
                Request.prototype.affectedUserEmail = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.RemoveViewerFromLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.RemoveViewerFromLocationActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.RemoveViewerFromLocationActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.RemoveViewerFromLocationActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.RemoveViewerFromLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.RemoveViewerFromLocationActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    if (message.affectedUserEmail != null && Object.hasOwnProperty.call(message, "affectedUserEmail"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.affectedUserEmail);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.RemoveViewerFromLocationActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.RemoveViewerFromLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.RemoveViewerFromLocationActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.RemoveViewerFromLocationActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.RemoveViewerFromLocationActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.RemoveViewerFromLocationActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 2: {
                                message.affectedUserEmail = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.RemoveViewerFromLocationActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.RemoveViewerFromLocationActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.RemoveViewerFromLocationActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    if (message.affectedUserEmail != null && message.hasOwnProperty("affectedUserEmail"))
                        if (!$util.isString(message.affectedUserEmail))
                            return "affectedUserEmail: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.RemoveViewerFromLocationActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.RemoveViewerFromLocationActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.RemoveViewerFromLocationActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.RemoveViewerFromLocationActionProto.Request();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    if (object.affectedUserEmail != null)
                        message.affectedUserEmail = String(object.affectedUserEmail);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.RemoveViewerFromLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.RemoveViewerFromLocationActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.locationId = "";
                        object.affectedUserEmail = "";
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    if (message.affectedUserEmail != null && message.hasOwnProperty("affectedUserEmail"))
                        object.affectedUserEmail = message.affectedUserEmail;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.RemoveViewerFromLocationActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.RemoveViewerFromLocationActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.RemoveViewerFromLocationActionProto.Request";
                };

                return Request;
            })();

            RemoveViewerFromLocationActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.RemoveViewerFromLocationActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.RemoveViewerFromLocationActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.RemoveViewerFromLocationActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.RemoveViewerFromLocationActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.RemoveViewerFromLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.RemoveViewerFromLocationActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.RemoveViewerFromLocationActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.RemoveViewerFromLocationActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.RemoveViewerFromLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.RemoveViewerFromLocationActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.RemoveViewerFromLocationActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.RemoveViewerFromLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.RemoveViewerFromLocationActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.RemoveViewerFromLocationActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.RemoveViewerFromLocationActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.RemoveViewerFromLocationActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.RemoveViewerFromLocationActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.RemoveViewerFromLocationActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.RemoveViewerFromLocationActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.RemoveViewerFromLocationActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.RemoveViewerFromLocationActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.RemoveViewerFromLocationActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.RemoveViewerFromLocationActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.RemoveViewerFromLocationActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.RemoveViewerFromLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.RemoveViewerFromLocationActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.RemoveViewerFromLocationActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.RemoveViewerFromLocationActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.RemoveViewerFromLocationActionProto.Response";
                };

                return Response;
            })();

            return RemoveViewerFromLocationActionProto;
        })();

        common.EnrollLocationInMarketplacePaymentsActionProto = (function() {

            /**
             * Properties of an EnrollLocationInMarketplacePaymentsActionProto.
             * @memberof waiternow.common
             * @interface IEnrollLocationInMarketplacePaymentsActionProto
             */

            /**
             * Constructs a new EnrollLocationInMarketplacePaymentsActionProto.
             * @memberof waiternow.common
             * @classdesc Represents an EnrollLocationInMarketplacePaymentsActionProto.
             * @implements IEnrollLocationInMarketplacePaymentsActionProto
             * @constructor
             * @param {waiternow.common.IEnrollLocationInMarketplacePaymentsActionProto=} [properties] Properties to set
             */
            function EnrollLocationInMarketplacePaymentsActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new EnrollLocationInMarketplacePaymentsActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.EnrollLocationInMarketplacePaymentsActionProto
             * @static
             * @param {waiternow.common.IEnrollLocationInMarketplacePaymentsActionProto=} [properties] Properties to set
             * @returns {waiternow.common.EnrollLocationInMarketplacePaymentsActionProto} EnrollLocationInMarketplacePaymentsActionProto instance
             */
            EnrollLocationInMarketplacePaymentsActionProto.create = function create(properties) {
                return new EnrollLocationInMarketplacePaymentsActionProto(properties);
            };

            /**
             * Encodes the specified EnrollLocationInMarketplacePaymentsActionProto message. Does not implicitly {@link waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.EnrollLocationInMarketplacePaymentsActionProto
             * @static
             * @param {waiternow.common.IEnrollLocationInMarketplacePaymentsActionProto} message EnrollLocationInMarketplacePaymentsActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EnrollLocationInMarketplacePaymentsActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified EnrollLocationInMarketplacePaymentsActionProto message, length delimited. Does not implicitly {@link waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.EnrollLocationInMarketplacePaymentsActionProto
             * @static
             * @param {waiternow.common.IEnrollLocationInMarketplacePaymentsActionProto} message EnrollLocationInMarketplacePaymentsActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EnrollLocationInMarketplacePaymentsActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an EnrollLocationInMarketplacePaymentsActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.EnrollLocationInMarketplacePaymentsActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.EnrollLocationInMarketplacePaymentsActionProto} EnrollLocationInMarketplacePaymentsActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EnrollLocationInMarketplacePaymentsActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.EnrollLocationInMarketplacePaymentsActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an EnrollLocationInMarketplacePaymentsActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.EnrollLocationInMarketplacePaymentsActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.EnrollLocationInMarketplacePaymentsActionProto} EnrollLocationInMarketplacePaymentsActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EnrollLocationInMarketplacePaymentsActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an EnrollLocationInMarketplacePaymentsActionProto message.
             * @function verify
             * @memberof waiternow.common.EnrollLocationInMarketplacePaymentsActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            EnrollLocationInMarketplacePaymentsActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates an EnrollLocationInMarketplacePaymentsActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.EnrollLocationInMarketplacePaymentsActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.EnrollLocationInMarketplacePaymentsActionProto} EnrollLocationInMarketplacePaymentsActionProto
             */
            EnrollLocationInMarketplacePaymentsActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.EnrollLocationInMarketplacePaymentsActionProto)
                    return object;
                return new $root.waiternow.common.EnrollLocationInMarketplacePaymentsActionProto();
            };

            /**
             * Creates a plain object from an EnrollLocationInMarketplacePaymentsActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.EnrollLocationInMarketplacePaymentsActionProto
             * @static
             * @param {waiternow.common.EnrollLocationInMarketplacePaymentsActionProto} message EnrollLocationInMarketplacePaymentsActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            EnrollLocationInMarketplacePaymentsActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this EnrollLocationInMarketplacePaymentsActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.EnrollLocationInMarketplacePaymentsActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            EnrollLocationInMarketplacePaymentsActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for EnrollLocationInMarketplacePaymentsActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.EnrollLocationInMarketplacePaymentsActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            EnrollLocationInMarketplacePaymentsActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.EnrollLocationInMarketplacePaymentsActionProto";
            };

            EnrollLocationInMarketplacePaymentsActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.EnrollLocationInMarketplacePaymentsActionProto
                 * @interface IRequest
                 * @property {string|null} [locationId] Request locationId
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.EnrollLocationInMarketplacePaymentsActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.Request
                 * @static
                 * @param {waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.Request
                 * @static
                 * @param {waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.Request
                 * @static
                 * @param {waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.Request();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.Request
                 * @static
                 * @param {waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.locationId = "";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.Request";
                };

                return Request;
            })();

            EnrollLocationInMarketplacePaymentsActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.EnrollLocationInMarketplacePaymentsActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IMarketplacePaymentsLocationEnrollmentProto|null} [enrollment] Response enrollment
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.EnrollLocationInMarketplacePaymentsActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response enrollment.
                 * @member {waiternow.common.IMarketplacePaymentsLocationEnrollmentProto|null|undefined} enrollment
                 * @memberof waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.Response
                 * @instance
                 */
                Response.prototype.enrollment = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.Response
                 * @static
                 * @param {waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.Response
                 * @static
                 * @param {waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.enrollment != null && Object.hasOwnProperty.call(message, "enrollment"))
                        $root.waiternow.common.MarketplacePaymentsLocationEnrollmentProto.encode(message.enrollment, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.Response
                 * @static
                 * @param {waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.enrollment = $root.waiternow.common.MarketplacePaymentsLocationEnrollmentProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.enrollment != null && message.hasOwnProperty("enrollment")) {
                        var error = $root.waiternow.common.MarketplacePaymentsLocationEnrollmentProto.verify(message.enrollment);
                        if (error)
                            return "enrollment." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.enrollment != null) {
                        if (typeof object.enrollment !== "object")
                            throw TypeError(".waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.Response.enrollment: object expected");
                        message.enrollment = $root.waiternow.common.MarketplacePaymentsLocationEnrollmentProto.fromObject(object.enrollment);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.Response
                 * @static
                 * @param {waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.enrollment = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.enrollment != null && message.hasOwnProperty("enrollment"))
                        object.enrollment = $root.waiternow.common.MarketplacePaymentsLocationEnrollmentProto.toObject(message.enrollment, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.EnrollLocationInMarketplacePaymentsActionProto.Response";
                };

                return Response;
            })();

            return EnrollLocationInMarketplacePaymentsActionProto;
        })();

        common.VerifyMarketplacePaymentsEnrollmentActionProto = (function() {

            /**
             * Properties of a VerifyMarketplacePaymentsEnrollmentActionProto.
             * @memberof waiternow.common
             * @interface IVerifyMarketplacePaymentsEnrollmentActionProto
             */

            /**
             * Constructs a new VerifyMarketplacePaymentsEnrollmentActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a VerifyMarketplacePaymentsEnrollmentActionProto.
             * @implements IVerifyMarketplacePaymentsEnrollmentActionProto
             * @constructor
             * @param {waiternow.common.IVerifyMarketplacePaymentsEnrollmentActionProto=} [properties] Properties to set
             */
            function VerifyMarketplacePaymentsEnrollmentActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new VerifyMarketplacePaymentsEnrollmentActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto
             * @static
             * @param {waiternow.common.IVerifyMarketplacePaymentsEnrollmentActionProto=} [properties] Properties to set
             * @returns {waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto} VerifyMarketplacePaymentsEnrollmentActionProto instance
             */
            VerifyMarketplacePaymentsEnrollmentActionProto.create = function create(properties) {
                return new VerifyMarketplacePaymentsEnrollmentActionProto(properties);
            };

            /**
             * Encodes the specified VerifyMarketplacePaymentsEnrollmentActionProto message. Does not implicitly {@link waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto
             * @static
             * @param {waiternow.common.IVerifyMarketplacePaymentsEnrollmentActionProto} message VerifyMarketplacePaymentsEnrollmentActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            VerifyMarketplacePaymentsEnrollmentActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified VerifyMarketplacePaymentsEnrollmentActionProto message, length delimited. Does not implicitly {@link waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto
             * @static
             * @param {waiternow.common.IVerifyMarketplacePaymentsEnrollmentActionProto} message VerifyMarketplacePaymentsEnrollmentActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            VerifyMarketplacePaymentsEnrollmentActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a VerifyMarketplacePaymentsEnrollmentActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto} VerifyMarketplacePaymentsEnrollmentActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            VerifyMarketplacePaymentsEnrollmentActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a VerifyMarketplacePaymentsEnrollmentActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto} VerifyMarketplacePaymentsEnrollmentActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            VerifyMarketplacePaymentsEnrollmentActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a VerifyMarketplacePaymentsEnrollmentActionProto message.
             * @function verify
             * @memberof waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            VerifyMarketplacePaymentsEnrollmentActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a VerifyMarketplacePaymentsEnrollmentActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto} VerifyMarketplacePaymentsEnrollmentActionProto
             */
            VerifyMarketplacePaymentsEnrollmentActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto)
                    return object;
                return new $root.waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto();
            };

            /**
             * Creates a plain object from a VerifyMarketplacePaymentsEnrollmentActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto
             * @static
             * @param {waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto} message VerifyMarketplacePaymentsEnrollmentActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            VerifyMarketplacePaymentsEnrollmentActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this VerifyMarketplacePaymentsEnrollmentActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            VerifyMarketplacePaymentsEnrollmentActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for VerifyMarketplacePaymentsEnrollmentActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            VerifyMarketplacePaymentsEnrollmentActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto";
            };

            VerifyMarketplacePaymentsEnrollmentActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto
                 * @interface IRequest
                 * @property {string|null} [locationId] Request locationId
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.Request
                 * @static
                 * @param {waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.Request
                 * @static
                 * @param {waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.Request
                 * @static
                 * @param {waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.Request();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.Request
                 * @static
                 * @param {waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.locationId = "";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.Request";
                };

                return Request;
            })();

            VerifyMarketplacePaymentsEnrollmentActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {boolean|null} [isEnrolled] Response isEnrolled
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response isEnrolled.
                 * @member {boolean} isEnrolled
                 * @memberof waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.Response
                 * @instance
                 */
                Response.prototype.isEnrolled = false;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.Response
                 * @static
                 * @param {waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.Response
                 * @static
                 * @param {waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.isEnrolled != null && Object.hasOwnProperty.call(message, "isEnrolled"))
                        writer.uint32(/* id 2, wireType 0 =*/16).bool(message.isEnrolled);
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.Response
                 * @static
                 * @param {waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.isEnrolled = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.isEnrolled != null && message.hasOwnProperty("isEnrolled"))
                        if (typeof message.isEnrolled !== "boolean")
                            return "isEnrolled: boolean expected";
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.isEnrolled != null)
                        message.isEnrolled = Boolean(object.isEnrolled);
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.Response
                 * @static
                 * @param {waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.isEnrolled = false;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.isEnrolled != null && message.hasOwnProperty("isEnrolled"))
                        object.isEnrolled = message.isEnrolled;
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.VerifyMarketplacePaymentsEnrollmentActionProto.Response";
                };

                return Response;
            })();

            return VerifyMarketplacePaymentsEnrollmentActionProto;
        })();

        common.UnenrollLocationFromMarketplacePaymentsActionProto = (function() {

            /**
             * Properties of an UnenrollLocationFromMarketplacePaymentsActionProto.
             * @memberof waiternow.common
             * @interface IUnenrollLocationFromMarketplacePaymentsActionProto
             */

            /**
             * Constructs a new UnenrollLocationFromMarketplacePaymentsActionProto.
             * @memberof waiternow.common
             * @classdesc Represents an UnenrollLocationFromMarketplacePaymentsActionProto.
             * @implements IUnenrollLocationFromMarketplacePaymentsActionProto
             * @constructor
             * @param {waiternow.common.IUnenrollLocationFromMarketplacePaymentsActionProto=} [properties] Properties to set
             */
            function UnenrollLocationFromMarketplacePaymentsActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new UnenrollLocationFromMarketplacePaymentsActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto
             * @static
             * @param {waiternow.common.IUnenrollLocationFromMarketplacePaymentsActionProto=} [properties] Properties to set
             * @returns {waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto} UnenrollLocationFromMarketplacePaymentsActionProto instance
             */
            UnenrollLocationFromMarketplacePaymentsActionProto.create = function create(properties) {
                return new UnenrollLocationFromMarketplacePaymentsActionProto(properties);
            };

            /**
             * Encodes the specified UnenrollLocationFromMarketplacePaymentsActionProto message. Does not implicitly {@link waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto
             * @static
             * @param {waiternow.common.IUnenrollLocationFromMarketplacePaymentsActionProto} message UnenrollLocationFromMarketplacePaymentsActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UnenrollLocationFromMarketplacePaymentsActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified UnenrollLocationFromMarketplacePaymentsActionProto message, length delimited. Does not implicitly {@link waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto
             * @static
             * @param {waiternow.common.IUnenrollLocationFromMarketplacePaymentsActionProto} message UnenrollLocationFromMarketplacePaymentsActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UnenrollLocationFromMarketplacePaymentsActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an UnenrollLocationFromMarketplacePaymentsActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto} UnenrollLocationFromMarketplacePaymentsActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UnenrollLocationFromMarketplacePaymentsActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an UnenrollLocationFromMarketplacePaymentsActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto} UnenrollLocationFromMarketplacePaymentsActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UnenrollLocationFromMarketplacePaymentsActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an UnenrollLocationFromMarketplacePaymentsActionProto message.
             * @function verify
             * @memberof waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            UnenrollLocationFromMarketplacePaymentsActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates an UnenrollLocationFromMarketplacePaymentsActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto} UnenrollLocationFromMarketplacePaymentsActionProto
             */
            UnenrollLocationFromMarketplacePaymentsActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto)
                    return object;
                return new $root.waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto();
            };

            /**
             * Creates a plain object from an UnenrollLocationFromMarketplacePaymentsActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto
             * @static
             * @param {waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto} message UnenrollLocationFromMarketplacePaymentsActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            UnenrollLocationFromMarketplacePaymentsActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this UnenrollLocationFromMarketplacePaymentsActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            UnenrollLocationFromMarketplacePaymentsActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for UnenrollLocationFromMarketplacePaymentsActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            UnenrollLocationFromMarketplacePaymentsActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto";
            };

            UnenrollLocationFromMarketplacePaymentsActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto
                 * @interface IRequest
                 * @property {string|null} [locationId] Request locationId
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.Request
                 * @static
                 * @param {waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.Request
                 * @static
                 * @param {waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.Request
                 * @static
                 * @param {waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.Request();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.Request
                 * @static
                 * @param {waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.locationId = "";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.Request";
                };

                return Request;
            })();

            UnenrollLocationFromMarketplacePaymentsActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.Response
                 * @static
                 * @param {waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.Response
                 * @static
                 * @param {waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.Response
                 * @static
                 * @param {waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.Response
                 * @static
                 * @param {waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.UnenrollLocationFromMarketplacePaymentsActionProto.Response";
                };

                return Response;
            })();

            return UnenrollLocationFromMarketplacePaymentsActionProto;
        })();

        common.EnrollLocationInDeliveryActionProto = (function() {

            /**
             * Properties of an EnrollLocationInDeliveryActionProto.
             * @memberof waiternow.common
             * @interface IEnrollLocationInDeliveryActionProto
             */

            /**
             * Constructs a new EnrollLocationInDeliveryActionProto.
             * @memberof waiternow.common
             * @classdesc Represents an EnrollLocationInDeliveryActionProto.
             * @implements IEnrollLocationInDeliveryActionProto
             * @constructor
             * @param {waiternow.common.IEnrollLocationInDeliveryActionProto=} [properties] Properties to set
             */
            function EnrollLocationInDeliveryActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new EnrollLocationInDeliveryActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.EnrollLocationInDeliveryActionProto
             * @static
             * @param {waiternow.common.IEnrollLocationInDeliveryActionProto=} [properties] Properties to set
             * @returns {waiternow.common.EnrollLocationInDeliveryActionProto} EnrollLocationInDeliveryActionProto instance
             */
            EnrollLocationInDeliveryActionProto.create = function create(properties) {
                return new EnrollLocationInDeliveryActionProto(properties);
            };

            /**
             * Encodes the specified EnrollLocationInDeliveryActionProto message. Does not implicitly {@link waiternow.common.EnrollLocationInDeliveryActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.EnrollLocationInDeliveryActionProto
             * @static
             * @param {waiternow.common.IEnrollLocationInDeliveryActionProto} message EnrollLocationInDeliveryActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EnrollLocationInDeliveryActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified EnrollLocationInDeliveryActionProto message, length delimited. Does not implicitly {@link waiternow.common.EnrollLocationInDeliveryActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.EnrollLocationInDeliveryActionProto
             * @static
             * @param {waiternow.common.IEnrollLocationInDeliveryActionProto} message EnrollLocationInDeliveryActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EnrollLocationInDeliveryActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an EnrollLocationInDeliveryActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.EnrollLocationInDeliveryActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.EnrollLocationInDeliveryActionProto} EnrollLocationInDeliveryActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EnrollLocationInDeliveryActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.EnrollLocationInDeliveryActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an EnrollLocationInDeliveryActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.EnrollLocationInDeliveryActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.EnrollLocationInDeliveryActionProto} EnrollLocationInDeliveryActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EnrollLocationInDeliveryActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an EnrollLocationInDeliveryActionProto message.
             * @function verify
             * @memberof waiternow.common.EnrollLocationInDeliveryActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            EnrollLocationInDeliveryActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates an EnrollLocationInDeliveryActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.EnrollLocationInDeliveryActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.EnrollLocationInDeliveryActionProto} EnrollLocationInDeliveryActionProto
             */
            EnrollLocationInDeliveryActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.EnrollLocationInDeliveryActionProto)
                    return object;
                return new $root.waiternow.common.EnrollLocationInDeliveryActionProto();
            };

            /**
             * Creates a plain object from an EnrollLocationInDeliveryActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.EnrollLocationInDeliveryActionProto
             * @static
             * @param {waiternow.common.EnrollLocationInDeliveryActionProto} message EnrollLocationInDeliveryActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            EnrollLocationInDeliveryActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this EnrollLocationInDeliveryActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.EnrollLocationInDeliveryActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            EnrollLocationInDeliveryActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for EnrollLocationInDeliveryActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.EnrollLocationInDeliveryActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            EnrollLocationInDeliveryActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.EnrollLocationInDeliveryActionProto";
            };

            EnrollLocationInDeliveryActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.EnrollLocationInDeliveryActionProto
                 * @interface IRequest
                 * @property {string|null} [locationId] Request locationId
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.EnrollLocationInDeliveryActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.EnrollLocationInDeliveryActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.EnrollLocationInDeliveryActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.EnrollLocationInDeliveryActionProto.Request
                 * @static
                 * @param {waiternow.common.EnrollLocationInDeliveryActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.EnrollLocationInDeliveryActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.EnrollLocationInDeliveryActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.EnrollLocationInDeliveryActionProto.Request
                 * @static
                 * @param {waiternow.common.EnrollLocationInDeliveryActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.EnrollLocationInDeliveryActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.EnrollLocationInDeliveryActionProto.Request
                 * @static
                 * @param {waiternow.common.EnrollLocationInDeliveryActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.EnrollLocationInDeliveryActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.EnrollLocationInDeliveryActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.EnrollLocationInDeliveryActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.EnrollLocationInDeliveryActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.EnrollLocationInDeliveryActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.EnrollLocationInDeliveryActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.EnrollLocationInDeliveryActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.EnrollLocationInDeliveryActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.EnrollLocationInDeliveryActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.EnrollLocationInDeliveryActionProto.Request();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.EnrollLocationInDeliveryActionProto.Request
                 * @static
                 * @param {waiternow.common.EnrollLocationInDeliveryActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.locationId = "";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.EnrollLocationInDeliveryActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.EnrollLocationInDeliveryActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.EnrollLocationInDeliveryActionProto.Request";
                };

                return Request;
            })();

            EnrollLocationInDeliveryActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.EnrollLocationInDeliveryActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.EnrollLocationInDeliveryActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.EnrollLocationInDeliveryActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.EnrollLocationInDeliveryActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.EnrollLocationInDeliveryActionProto.Response
                 * @static
                 * @param {waiternow.common.EnrollLocationInDeliveryActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.EnrollLocationInDeliveryActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.EnrollLocationInDeliveryActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.EnrollLocationInDeliveryActionProto.Response
                 * @static
                 * @param {waiternow.common.EnrollLocationInDeliveryActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.EnrollLocationInDeliveryActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.EnrollLocationInDeliveryActionProto.Response
                 * @static
                 * @param {waiternow.common.EnrollLocationInDeliveryActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.EnrollLocationInDeliveryActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.EnrollLocationInDeliveryActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.EnrollLocationInDeliveryActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.EnrollLocationInDeliveryActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.EnrollLocationInDeliveryActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.EnrollLocationInDeliveryActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.EnrollLocationInDeliveryActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.EnrollLocationInDeliveryActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.EnrollLocationInDeliveryActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.EnrollLocationInDeliveryActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.EnrollLocationInDeliveryActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.EnrollLocationInDeliveryActionProto.Response
                 * @static
                 * @param {waiternow.common.EnrollLocationInDeliveryActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.EnrollLocationInDeliveryActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.EnrollLocationInDeliveryActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.EnrollLocationInDeliveryActionProto.Response";
                };

                return Response;
            })();

            return EnrollLocationInDeliveryActionProto;
        })();

        common.FindLocationsBySalesPartnerActionProto = (function() {

            /**
             * Properties of a FindLocationsBySalesPartnerActionProto.
             * @memberof waiternow.common
             * @interface IFindLocationsBySalesPartnerActionProto
             */

            /**
             * Constructs a new FindLocationsBySalesPartnerActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a FindLocationsBySalesPartnerActionProto.
             * @implements IFindLocationsBySalesPartnerActionProto
             * @constructor
             * @param {waiternow.common.IFindLocationsBySalesPartnerActionProto=} [properties] Properties to set
             */
            function FindLocationsBySalesPartnerActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new FindLocationsBySalesPartnerActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FindLocationsBySalesPartnerActionProto
             * @static
             * @param {waiternow.common.IFindLocationsBySalesPartnerActionProto=} [properties] Properties to set
             * @returns {waiternow.common.FindLocationsBySalesPartnerActionProto} FindLocationsBySalesPartnerActionProto instance
             */
            FindLocationsBySalesPartnerActionProto.create = function create(properties) {
                return new FindLocationsBySalesPartnerActionProto(properties);
            };

            /**
             * Encodes the specified FindLocationsBySalesPartnerActionProto message. Does not implicitly {@link waiternow.common.FindLocationsBySalesPartnerActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FindLocationsBySalesPartnerActionProto
             * @static
             * @param {waiternow.common.IFindLocationsBySalesPartnerActionProto} message FindLocationsBySalesPartnerActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindLocationsBySalesPartnerActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified FindLocationsBySalesPartnerActionProto message, length delimited. Does not implicitly {@link waiternow.common.FindLocationsBySalesPartnerActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FindLocationsBySalesPartnerActionProto
             * @static
             * @param {waiternow.common.IFindLocationsBySalesPartnerActionProto} message FindLocationsBySalesPartnerActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindLocationsBySalesPartnerActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FindLocationsBySalesPartnerActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FindLocationsBySalesPartnerActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FindLocationsBySalesPartnerActionProto} FindLocationsBySalesPartnerActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindLocationsBySalesPartnerActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindLocationsBySalesPartnerActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FindLocationsBySalesPartnerActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FindLocationsBySalesPartnerActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FindLocationsBySalesPartnerActionProto} FindLocationsBySalesPartnerActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindLocationsBySalesPartnerActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FindLocationsBySalesPartnerActionProto message.
             * @function verify
             * @memberof waiternow.common.FindLocationsBySalesPartnerActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FindLocationsBySalesPartnerActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a FindLocationsBySalesPartnerActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FindLocationsBySalesPartnerActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FindLocationsBySalesPartnerActionProto} FindLocationsBySalesPartnerActionProto
             */
            FindLocationsBySalesPartnerActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FindLocationsBySalesPartnerActionProto)
                    return object;
                return new $root.waiternow.common.FindLocationsBySalesPartnerActionProto();
            };

            /**
             * Creates a plain object from a FindLocationsBySalesPartnerActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FindLocationsBySalesPartnerActionProto
             * @static
             * @param {waiternow.common.FindLocationsBySalesPartnerActionProto} message FindLocationsBySalesPartnerActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FindLocationsBySalesPartnerActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this FindLocationsBySalesPartnerActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FindLocationsBySalesPartnerActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FindLocationsBySalesPartnerActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FindLocationsBySalesPartnerActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.FindLocationsBySalesPartnerActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FindLocationsBySalesPartnerActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FindLocationsBySalesPartnerActionProto";
            };

            FindLocationsBySalesPartnerActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.FindLocationsBySalesPartnerActionProto
                 * @interface IRequest
                 * @property {string|null} [salesPartnerId] Request salesPartnerId
                 * @property {string|null} [continuationToken] Request continuationToken
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.FindLocationsBySalesPartnerActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.FindLocationsBySalesPartnerActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request salesPartnerId.
                 * @member {string} salesPartnerId
                 * @memberof waiternow.common.FindLocationsBySalesPartnerActionProto.Request
                 * @instance
                 */
                Request.prototype.salesPartnerId = "";

                /**
                 * Request continuationToken.
                 * @member {string} continuationToken
                 * @memberof waiternow.common.FindLocationsBySalesPartnerActionProto.Request
                 * @instance
                 */
                Request.prototype.continuationToken = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindLocationsBySalesPartnerActionProto.Request
                 * @static
                 * @param {waiternow.common.FindLocationsBySalesPartnerActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.FindLocationsBySalesPartnerActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.FindLocationsBySalesPartnerActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindLocationsBySalesPartnerActionProto.Request
                 * @static
                 * @param {waiternow.common.FindLocationsBySalesPartnerActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.salesPartnerId != null && Object.hasOwnProperty.call(message, "salesPartnerId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.salesPartnerId);
                    if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.continuationToken);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.FindLocationsBySalesPartnerActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindLocationsBySalesPartnerActionProto.Request
                 * @static
                 * @param {waiternow.common.FindLocationsBySalesPartnerActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindLocationsBySalesPartnerActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindLocationsBySalesPartnerActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindLocationsBySalesPartnerActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.salesPartnerId = reader.string();
                                break;
                            }
                        case 2: {
                                message.continuationToken = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindLocationsBySalesPartnerActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindLocationsBySalesPartnerActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.FindLocationsBySalesPartnerActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.salesPartnerId != null && message.hasOwnProperty("salesPartnerId"))
                        if (!$util.isString(message.salesPartnerId))
                            return "salesPartnerId: string expected";
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        if (!$util.isString(message.continuationToken))
                            return "continuationToken: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindLocationsBySalesPartnerActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindLocationsBySalesPartnerActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindLocationsBySalesPartnerActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.FindLocationsBySalesPartnerActionProto.Request();
                    if (object.salesPartnerId != null)
                        message.salesPartnerId = String(object.salesPartnerId);
                    if (object.continuationToken != null)
                        message.continuationToken = String(object.continuationToken);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindLocationsBySalesPartnerActionProto.Request
                 * @static
                 * @param {waiternow.common.FindLocationsBySalesPartnerActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.salesPartnerId = "";
                        object.continuationToken = "";
                    }
                    if (message.salesPartnerId != null && message.hasOwnProperty("salesPartnerId"))
                        object.salesPartnerId = message.salesPartnerId;
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        object.continuationToken = message.continuationToken;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindLocationsBySalesPartnerActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindLocationsBySalesPartnerActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindLocationsBySalesPartnerActionProto.Request";
                };

                return Request;
            })();

            FindLocationsBySalesPartnerActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.FindLocationsBySalesPartnerActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.ILocationsProto|null} [locations] Response locations
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.FindLocationsBySalesPartnerActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.FindLocationsBySalesPartnerActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.FindLocationsBySalesPartnerActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response locations.
                 * @member {waiternow.common.ILocationsProto|null|undefined} locations
                 * @memberof waiternow.common.FindLocationsBySalesPartnerActionProto.Response
                 * @instance
                 */
                Response.prototype.locations = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindLocationsBySalesPartnerActionProto.Response
                 * @static
                 * @param {waiternow.common.FindLocationsBySalesPartnerActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.FindLocationsBySalesPartnerActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.FindLocationsBySalesPartnerActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindLocationsBySalesPartnerActionProto.Response
                 * @static
                 * @param {waiternow.common.FindLocationsBySalesPartnerActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.locations != null && Object.hasOwnProperty.call(message, "locations"))
                        $root.waiternow.common.LocationsProto.encode(message.locations, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.FindLocationsBySalesPartnerActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindLocationsBySalesPartnerActionProto.Response
                 * @static
                 * @param {waiternow.common.FindLocationsBySalesPartnerActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindLocationsBySalesPartnerActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindLocationsBySalesPartnerActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindLocationsBySalesPartnerActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.locations = $root.waiternow.common.LocationsProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindLocationsBySalesPartnerActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindLocationsBySalesPartnerActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.FindLocationsBySalesPartnerActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.locations != null && message.hasOwnProperty("locations")) {
                        var error = $root.waiternow.common.LocationsProto.verify(message.locations);
                        if (error)
                            return "locations." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindLocationsBySalesPartnerActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindLocationsBySalesPartnerActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindLocationsBySalesPartnerActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.FindLocationsBySalesPartnerActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.FindLocationsBySalesPartnerActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.locations != null) {
                        if (typeof object.locations !== "object")
                            throw TypeError(".waiternow.common.FindLocationsBySalesPartnerActionProto.Response.locations: object expected");
                        message.locations = $root.waiternow.common.LocationsProto.fromObject(object.locations);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindLocationsBySalesPartnerActionProto.Response
                 * @static
                 * @param {waiternow.common.FindLocationsBySalesPartnerActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.locations = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.locations != null && message.hasOwnProperty("locations"))
                        object.locations = $root.waiternow.common.LocationsProto.toObject(message.locations, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindLocationsBySalesPartnerActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindLocationsBySalesPartnerActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindLocationsBySalesPartnerActionProto.Response";
                };

                return Response;
            })();

            return FindLocationsBySalesPartnerActionProto;
        })();

        common.GetPrintingStationsActionProto = (function() {

            /**
             * Properties of a GetPrintingStationsActionProto.
             * @memberof waiternow.common
             * @interface IGetPrintingStationsActionProto
             */

            /**
             * Constructs a new GetPrintingStationsActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a GetPrintingStationsActionProto.
             * @implements IGetPrintingStationsActionProto
             * @constructor
             * @param {waiternow.common.IGetPrintingStationsActionProto=} [properties] Properties to set
             */
            function GetPrintingStationsActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new GetPrintingStationsActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.GetPrintingStationsActionProto
             * @static
             * @param {waiternow.common.IGetPrintingStationsActionProto=} [properties] Properties to set
             * @returns {waiternow.common.GetPrintingStationsActionProto} GetPrintingStationsActionProto instance
             */
            GetPrintingStationsActionProto.create = function create(properties) {
                return new GetPrintingStationsActionProto(properties);
            };

            /**
             * Encodes the specified GetPrintingStationsActionProto message. Does not implicitly {@link waiternow.common.GetPrintingStationsActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.GetPrintingStationsActionProto
             * @static
             * @param {waiternow.common.IGetPrintingStationsActionProto} message GetPrintingStationsActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetPrintingStationsActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified GetPrintingStationsActionProto message, length delimited. Does not implicitly {@link waiternow.common.GetPrintingStationsActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.GetPrintingStationsActionProto
             * @static
             * @param {waiternow.common.IGetPrintingStationsActionProto} message GetPrintingStationsActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetPrintingStationsActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetPrintingStationsActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.GetPrintingStationsActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.GetPrintingStationsActionProto} GetPrintingStationsActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetPrintingStationsActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetPrintingStationsActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetPrintingStationsActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.GetPrintingStationsActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.GetPrintingStationsActionProto} GetPrintingStationsActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetPrintingStationsActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetPrintingStationsActionProto message.
             * @function verify
             * @memberof waiternow.common.GetPrintingStationsActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetPrintingStationsActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a GetPrintingStationsActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.GetPrintingStationsActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.GetPrintingStationsActionProto} GetPrintingStationsActionProto
             */
            GetPrintingStationsActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.GetPrintingStationsActionProto)
                    return object;
                return new $root.waiternow.common.GetPrintingStationsActionProto();
            };

            /**
             * Creates a plain object from a GetPrintingStationsActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.GetPrintingStationsActionProto
             * @static
             * @param {waiternow.common.GetPrintingStationsActionProto} message GetPrintingStationsActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetPrintingStationsActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this GetPrintingStationsActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.GetPrintingStationsActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetPrintingStationsActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for GetPrintingStationsActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.GetPrintingStationsActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            GetPrintingStationsActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.GetPrintingStationsActionProto";
            };

            GetPrintingStationsActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.GetPrintingStationsActionProto
                 * @interface IRequest
                 * @property {string|null} [locationId] Request locationId
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.GetPrintingStationsActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.GetPrintingStationsActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.GetPrintingStationsActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetPrintingStationsActionProto.Request
                 * @static
                 * @param {waiternow.common.GetPrintingStationsActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.GetPrintingStationsActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.GetPrintingStationsActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetPrintingStationsActionProto.Request
                 * @static
                 * @param {waiternow.common.GetPrintingStationsActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.GetPrintingStationsActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetPrintingStationsActionProto.Request
                 * @static
                 * @param {waiternow.common.GetPrintingStationsActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetPrintingStationsActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetPrintingStationsActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetPrintingStationsActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetPrintingStationsActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetPrintingStationsActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.GetPrintingStationsActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetPrintingStationsActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetPrintingStationsActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetPrintingStationsActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.GetPrintingStationsActionProto.Request();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetPrintingStationsActionProto.Request
                 * @static
                 * @param {waiternow.common.GetPrintingStationsActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.locationId = "";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetPrintingStationsActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetPrintingStationsActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetPrintingStationsActionProto.Request";
                };

                return Request;
            })();

            GetPrintingStationsActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.GetPrintingStationsActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {Array.<string>|null} [stations] Response stations
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.GetPrintingStationsActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.GetPrintingStationsActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    this.stations = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.GetPrintingStationsActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response stations.
                 * @member {Array.<string>} stations
                 * @memberof waiternow.common.GetPrintingStationsActionProto.Response
                 * @instance
                 */
                Response.prototype.stations = $util.emptyArray;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetPrintingStationsActionProto.Response
                 * @static
                 * @param {waiternow.common.GetPrintingStationsActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.GetPrintingStationsActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.GetPrintingStationsActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetPrintingStationsActionProto.Response
                 * @static
                 * @param {waiternow.common.GetPrintingStationsActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.stations != null && message.stations.length)
                        for (var i = 0; i < message.stations.length; ++i)
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.stations[i]);
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.GetPrintingStationsActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetPrintingStationsActionProto.Response
                 * @static
                 * @param {waiternow.common.GetPrintingStationsActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetPrintingStationsActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetPrintingStationsActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetPrintingStationsActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                if (!(message.stations && message.stations.length))
                                    message.stations = [];
                                message.stations.push(reader.string());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetPrintingStationsActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetPrintingStationsActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.GetPrintingStationsActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.stations != null && message.hasOwnProperty("stations")) {
                        if (!Array.isArray(message.stations))
                            return "stations: array expected";
                        for (var i = 0; i < message.stations.length; ++i)
                            if (!$util.isString(message.stations[i]))
                                return "stations: string[] expected";
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetPrintingStationsActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetPrintingStationsActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetPrintingStationsActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.GetPrintingStationsActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.GetPrintingStationsActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.stations) {
                        if (!Array.isArray(object.stations))
                            throw TypeError(".waiternow.common.GetPrintingStationsActionProto.Response.stations: array expected");
                        message.stations = [];
                        for (var i = 0; i < object.stations.length; ++i)
                            message.stations[i] = String(object.stations[i]);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetPrintingStationsActionProto.Response
                 * @static
                 * @param {waiternow.common.GetPrintingStationsActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.stations = [];
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.stations && message.stations.length) {
                        object.stations = [];
                        for (var j = 0; j < message.stations.length; ++j)
                            object.stations[j] = message.stations[j];
                    }
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetPrintingStationsActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetPrintingStationsActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetPrintingStationsActionProto.Response";
                };

                return Response;
            })();

            return GetPrintingStationsActionProto;
        })();

        common.AddImageToImageMenuActionProto = (function() {

            /**
             * Properties of an AddImageToImageMenuActionProto.
             * @memberof waiternow.common
             * @interface IAddImageToImageMenuActionProto
             */

            /**
             * Constructs a new AddImageToImageMenuActionProto.
             * @memberof waiternow.common
             * @classdesc Represents an AddImageToImageMenuActionProto.
             * @implements IAddImageToImageMenuActionProto
             * @constructor
             * @param {waiternow.common.IAddImageToImageMenuActionProto=} [properties] Properties to set
             */
            function AddImageToImageMenuActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new AddImageToImageMenuActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.AddImageToImageMenuActionProto
             * @static
             * @param {waiternow.common.IAddImageToImageMenuActionProto=} [properties] Properties to set
             * @returns {waiternow.common.AddImageToImageMenuActionProto} AddImageToImageMenuActionProto instance
             */
            AddImageToImageMenuActionProto.create = function create(properties) {
                return new AddImageToImageMenuActionProto(properties);
            };

            /**
             * Encodes the specified AddImageToImageMenuActionProto message. Does not implicitly {@link waiternow.common.AddImageToImageMenuActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.AddImageToImageMenuActionProto
             * @static
             * @param {waiternow.common.IAddImageToImageMenuActionProto} message AddImageToImageMenuActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AddImageToImageMenuActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified AddImageToImageMenuActionProto message, length delimited. Does not implicitly {@link waiternow.common.AddImageToImageMenuActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.AddImageToImageMenuActionProto
             * @static
             * @param {waiternow.common.IAddImageToImageMenuActionProto} message AddImageToImageMenuActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AddImageToImageMenuActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AddImageToImageMenuActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.AddImageToImageMenuActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.AddImageToImageMenuActionProto} AddImageToImageMenuActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AddImageToImageMenuActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.AddImageToImageMenuActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AddImageToImageMenuActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.AddImageToImageMenuActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.AddImageToImageMenuActionProto} AddImageToImageMenuActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AddImageToImageMenuActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AddImageToImageMenuActionProto message.
             * @function verify
             * @memberof waiternow.common.AddImageToImageMenuActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AddImageToImageMenuActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates an AddImageToImageMenuActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.AddImageToImageMenuActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.AddImageToImageMenuActionProto} AddImageToImageMenuActionProto
             */
            AddImageToImageMenuActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.AddImageToImageMenuActionProto)
                    return object;
                return new $root.waiternow.common.AddImageToImageMenuActionProto();
            };

            /**
             * Creates a plain object from an AddImageToImageMenuActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.AddImageToImageMenuActionProto
             * @static
             * @param {waiternow.common.AddImageToImageMenuActionProto} message AddImageToImageMenuActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AddImageToImageMenuActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this AddImageToImageMenuActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.AddImageToImageMenuActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AddImageToImageMenuActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for AddImageToImageMenuActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.AddImageToImageMenuActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            AddImageToImageMenuActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.AddImageToImageMenuActionProto";
            };

            AddImageToImageMenuActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.AddImageToImageMenuActionProto
                 * @interface IRequest
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.AddImageToImageMenuActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.AddImageToImageMenuActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.AddImageToImageMenuActionProto.Request
                 * @static
                 * @param {waiternow.common.AddImageToImageMenuActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.AddImageToImageMenuActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.AddImageToImageMenuActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.AddImageToImageMenuActionProto.Request
                 * @static
                 * @param {waiternow.common.AddImageToImageMenuActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.AddImageToImageMenuActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.AddImageToImageMenuActionProto.Request
                 * @static
                 * @param {waiternow.common.AddImageToImageMenuActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.AddImageToImageMenuActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.AddImageToImageMenuActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.AddImageToImageMenuActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.AddImageToImageMenuActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.AddImageToImageMenuActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.AddImageToImageMenuActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.AddImageToImageMenuActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.AddImageToImageMenuActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.AddImageToImageMenuActionProto.Request)
                        return object;
                    return new $root.waiternow.common.AddImageToImageMenuActionProto.Request();
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.AddImageToImageMenuActionProto.Request
                 * @static
                 * @param {waiternow.common.AddImageToImageMenuActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject() {
                    return {};
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.AddImageToImageMenuActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.AddImageToImageMenuActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.AddImageToImageMenuActionProto.Request";
                };

                return Request;
            })();

            AddImageToImageMenuActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.AddImageToImageMenuActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IImageProto|null} [image] Response image
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.AddImageToImageMenuActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.AddImageToImageMenuActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.AddImageToImageMenuActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response image.
                 * @member {waiternow.common.IImageProto|null|undefined} image
                 * @memberof waiternow.common.AddImageToImageMenuActionProto.Response
                 * @instance
                 */
                Response.prototype.image = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.AddImageToImageMenuActionProto.Response
                 * @static
                 * @param {waiternow.common.AddImageToImageMenuActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.AddImageToImageMenuActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.AddImageToImageMenuActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.AddImageToImageMenuActionProto.Response
                 * @static
                 * @param {waiternow.common.AddImageToImageMenuActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.image != null && Object.hasOwnProperty.call(message, "image"))
                        $root.waiternow.common.ImageProto.encode(message.image, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.AddImageToImageMenuActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.AddImageToImageMenuActionProto.Response
                 * @static
                 * @param {waiternow.common.AddImageToImageMenuActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.AddImageToImageMenuActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.AddImageToImageMenuActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.AddImageToImageMenuActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.image = $root.waiternow.common.ImageProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.AddImageToImageMenuActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.AddImageToImageMenuActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.AddImageToImageMenuActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.image != null && message.hasOwnProperty("image")) {
                        var error = $root.waiternow.common.ImageProto.verify(message.image);
                        if (error)
                            return "image." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.AddImageToImageMenuActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.AddImageToImageMenuActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.AddImageToImageMenuActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.AddImageToImageMenuActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.AddImageToImageMenuActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.image != null) {
                        if (typeof object.image !== "object")
                            throw TypeError(".waiternow.common.AddImageToImageMenuActionProto.Response.image: object expected");
                        message.image = $root.waiternow.common.ImageProto.fromObject(object.image);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.AddImageToImageMenuActionProto.Response
                 * @static
                 * @param {waiternow.common.AddImageToImageMenuActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.image = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.image != null && message.hasOwnProperty("image"))
                        object.image = $root.waiternow.common.ImageProto.toObject(message.image, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.AddImageToImageMenuActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.AddImageToImageMenuActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.AddImageToImageMenuActionProto.Response";
                };

                return Response;
            })();

            return AddImageToImageMenuActionProto;
        })();

        common.RemoveImageMenuCategoryActionProto = (function() {

            /**
             * Properties of a RemoveImageMenuCategoryActionProto.
             * @memberof waiternow.common
             * @interface IRemoveImageMenuCategoryActionProto
             */

            /**
             * Constructs a new RemoveImageMenuCategoryActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a RemoveImageMenuCategoryActionProto.
             * @implements IRemoveImageMenuCategoryActionProto
             * @constructor
             * @param {waiternow.common.IRemoveImageMenuCategoryActionProto=} [properties] Properties to set
             */
            function RemoveImageMenuCategoryActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new RemoveImageMenuCategoryActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.RemoveImageMenuCategoryActionProto
             * @static
             * @param {waiternow.common.IRemoveImageMenuCategoryActionProto=} [properties] Properties to set
             * @returns {waiternow.common.RemoveImageMenuCategoryActionProto} RemoveImageMenuCategoryActionProto instance
             */
            RemoveImageMenuCategoryActionProto.create = function create(properties) {
                return new RemoveImageMenuCategoryActionProto(properties);
            };

            /**
             * Encodes the specified RemoveImageMenuCategoryActionProto message. Does not implicitly {@link waiternow.common.RemoveImageMenuCategoryActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.RemoveImageMenuCategoryActionProto
             * @static
             * @param {waiternow.common.IRemoveImageMenuCategoryActionProto} message RemoveImageMenuCategoryActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RemoveImageMenuCategoryActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified RemoveImageMenuCategoryActionProto message, length delimited. Does not implicitly {@link waiternow.common.RemoveImageMenuCategoryActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.RemoveImageMenuCategoryActionProto
             * @static
             * @param {waiternow.common.IRemoveImageMenuCategoryActionProto} message RemoveImageMenuCategoryActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RemoveImageMenuCategoryActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a RemoveImageMenuCategoryActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.RemoveImageMenuCategoryActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.RemoveImageMenuCategoryActionProto} RemoveImageMenuCategoryActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RemoveImageMenuCategoryActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.RemoveImageMenuCategoryActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a RemoveImageMenuCategoryActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.RemoveImageMenuCategoryActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.RemoveImageMenuCategoryActionProto} RemoveImageMenuCategoryActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RemoveImageMenuCategoryActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a RemoveImageMenuCategoryActionProto message.
             * @function verify
             * @memberof waiternow.common.RemoveImageMenuCategoryActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            RemoveImageMenuCategoryActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a RemoveImageMenuCategoryActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.RemoveImageMenuCategoryActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.RemoveImageMenuCategoryActionProto} RemoveImageMenuCategoryActionProto
             */
            RemoveImageMenuCategoryActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.RemoveImageMenuCategoryActionProto)
                    return object;
                return new $root.waiternow.common.RemoveImageMenuCategoryActionProto();
            };

            /**
             * Creates a plain object from a RemoveImageMenuCategoryActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.RemoveImageMenuCategoryActionProto
             * @static
             * @param {waiternow.common.RemoveImageMenuCategoryActionProto} message RemoveImageMenuCategoryActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            RemoveImageMenuCategoryActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this RemoveImageMenuCategoryActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.RemoveImageMenuCategoryActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            RemoveImageMenuCategoryActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for RemoveImageMenuCategoryActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.RemoveImageMenuCategoryActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            RemoveImageMenuCategoryActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.RemoveImageMenuCategoryActionProto";
            };

            RemoveImageMenuCategoryActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.RemoveImageMenuCategoryActionProto
                 * @interface IRequest
                 * @property {string|null} [categoryName] Request categoryName
                 * @property {string|null} [businessId] Request businessId
                 * @property {string|null} [locationId] Request locationId
                 * @property {string|null} [imageId] Request imageId
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.RemoveImageMenuCategoryActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.RemoveImageMenuCategoryActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request categoryName.
                 * @member {string} categoryName
                 * @memberof waiternow.common.RemoveImageMenuCategoryActionProto.Request
                 * @instance
                 */
                Request.prototype.categoryName = "";

                /**
                 * Request businessId.
                 * @member {string|null|undefined} businessId
                 * @memberof waiternow.common.RemoveImageMenuCategoryActionProto.Request
                 * @instance
                 */
                Request.prototype.businessId = null;

                /**
                 * Request locationId.
                 * @member {string|null|undefined} locationId
                 * @memberof waiternow.common.RemoveImageMenuCategoryActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = null;

                /**
                 * Request imageId.
                 * @member {string} imageId
                 * @memberof waiternow.common.RemoveImageMenuCategoryActionProto.Request
                 * @instance
                 */
                Request.prototype.imageId = "";

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * Request subject.
                 * @member {"businessId"|"locationId"|undefined} subject
                 * @memberof waiternow.common.RemoveImageMenuCategoryActionProto.Request
                 * @instance
                 */
                Object.defineProperty(Request.prototype, "subject", {
                    get: $util.oneOfGetter($oneOfFields = ["businessId", "locationId"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.RemoveImageMenuCategoryActionProto.Request
                 * @static
                 * @param {waiternow.common.RemoveImageMenuCategoryActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.RemoveImageMenuCategoryActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.RemoveImageMenuCategoryActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.RemoveImageMenuCategoryActionProto.Request
                 * @static
                 * @param {waiternow.common.RemoveImageMenuCategoryActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.categoryName != null && Object.hasOwnProperty.call(message, "categoryName"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.categoryName);
                    if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.businessId);
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.locationId);
                    if (message.imageId != null && Object.hasOwnProperty.call(message, "imageId"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.imageId);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.RemoveImageMenuCategoryActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.RemoveImageMenuCategoryActionProto.Request
                 * @static
                 * @param {waiternow.common.RemoveImageMenuCategoryActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.RemoveImageMenuCategoryActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.RemoveImageMenuCategoryActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.RemoveImageMenuCategoryActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.categoryName = reader.string();
                                break;
                            }
                        case 2: {
                                message.businessId = reader.string();
                                break;
                            }
                        case 3: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 4: {
                                message.imageId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.RemoveImageMenuCategoryActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.RemoveImageMenuCategoryActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.RemoveImageMenuCategoryActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.categoryName != null && message.hasOwnProperty("categoryName"))
                        if (!$util.isString(message.categoryName))
                            return "categoryName: string expected";
                    if (message.businessId != null && message.hasOwnProperty("businessId")) {
                        properties.subject = 1;
                        if (!$util.isString(message.businessId))
                            return "businessId: string expected";
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId")) {
                        if (properties.subject === 1)
                            return "subject: multiple values";
                        properties.subject = 1;
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    }
                    if (message.imageId != null && message.hasOwnProperty("imageId"))
                        if (!$util.isString(message.imageId))
                            return "imageId: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.RemoveImageMenuCategoryActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.RemoveImageMenuCategoryActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.RemoveImageMenuCategoryActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.RemoveImageMenuCategoryActionProto.Request();
                    if (object.categoryName != null)
                        message.categoryName = String(object.categoryName);
                    if (object.businessId != null)
                        message.businessId = String(object.businessId);
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    if (object.imageId != null)
                        message.imageId = String(object.imageId);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.RemoveImageMenuCategoryActionProto.Request
                 * @static
                 * @param {waiternow.common.RemoveImageMenuCategoryActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.categoryName = "";
                        object.imageId = "";
                    }
                    if (message.categoryName != null && message.hasOwnProperty("categoryName"))
                        object.categoryName = message.categoryName;
                    if (message.businessId != null && message.hasOwnProperty("businessId")) {
                        object.businessId = message.businessId;
                        if (options.oneofs)
                            object.subject = "businessId";
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId")) {
                        object.locationId = message.locationId;
                        if (options.oneofs)
                            object.subject = "locationId";
                    }
                    if (message.imageId != null && message.hasOwnProperty("imageId"))
                        object.imageId = message.imageId;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.RemoveImageMenuCategoryActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.RemoveImageMenuCategoryActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.RemoveImageMenuCategoryActionProto.Request";
                };

                return Request;
            })();

            RemoveImageMenuCategoryActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.RemoveImageMenuCategoryActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.RemoveImageMenuCategoryActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.RemoveImageMenuCategoryActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.RemoveImageMenuCategoryActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.RemoveImageMenuCategoryActionProto.Response
                 * @static
                 * @param {waiternow.common.RemoveImageMenuCategoryActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.RemoveImageMenuCategoryActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.RemoveImageMenuCategoryActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.RemoveImageMenuCategoryActionProto.Response
                 * @static
                 * @param {waiternow.common.RemoveImageMenuCategoryActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.RemoveImageMenuCategoryActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.RemoveImageMenuCategoryActionProto.Response
                 * @static
                 * @param {waiternow.common.RemoveImageMenuCategoryActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.RemoveImageMenuCategoryActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.RemoveImageMenuCategoryActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.RemoveImageMenuCategoryActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.RemoveImageMenuCategoryActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.RemoveImageMenuCategoryActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.RemoveImageMenuCategoryActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.RemoveImageMenuCategoryActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.RemoveImageMenuCategoryActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.RemoveImageMenuCategoryActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.RemoveImageMenuCategoryActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.RemoveImageMenuCategoryActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.RemoveImageMenuCategoryActionProto.Response
                 * @static
                 * @param {waiternow.common.RemoveImageMenuCategoryActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.RemoveImageMenuCategoryActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.RemoveImageMenuCategoryActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.RemoveImageMenuCategoryActionProto.Response";
                };

                return Response;
            })();

            return RemoveImageMenuCategoryActionProto;
        })();

        common.SortImageMenuCategoryActionProto = (function() {

            /**
             * Properties of a SortImageMenuCategoryActionProto.
             * @memberof waiternow.common
             * @interface ISortImageMenuCategoryActionProto
             */

            /**
             * Constructs a new SortImageMenuCategoryActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a SortImageMenuCategoryActionProto.
             * @implements ISortImageMenuCategoryActionProto
             * @constructor
             * @param {waiternow.common.ISortImageMenuCategoryActionProto=} [properties] Properties to set
             */
            function SortImageMenuCategoryActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new SortImageMenuCategoryActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.SortImageMenuCategoryActionProto
             * @static
             * @param {waiternow.common.ISortImageMenuCategoryActionProto=} [properties] Properties to set
             * @returns {waiternow.common.SortImageMenuCategoryActionProto} SortImageMenuCategoryActionProto instance
             */
            SortImageMenuCategoryActionProto.create = function create(properties) {
                return new SortImageMenuCategoryActionProto(properties);
            };

            /**
             * Encodes the specified SortImageMenuCategoryActionProto message. Does not implicitly {@link waiternow.common.SortImageMenuCategoryActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.SortImageMenuCategoryActionProto
             * @static
             * @param {waiternow.common.ISortImageMenuCategoryActionProto} message SortImageMenuCategoryActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SortImageMenuCategoryActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified SortImageMenuCategoryActionProto message, length delimited. Does not implicitly {@link waiternow.common.SortImageMenuCategoryActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.SortImageMenuCategoryActionProto
             * @static
             * @param {waiternow.common.ISortImageMenuCategoryActionProto} message SortImageMenuCategoryActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SortImageMenuCategoryActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SortImageMenuCategoryActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.SortImageMenuCategoryActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.SortImageMenuCategoryActionProto} SortImageMenuCategoryActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SortImageMenuCategoryActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.SortImageMenuCategoryActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SortImageMenuCategoryActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.SortImageMenuCategoryActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.SortImageMenuCategoryActionProto} SortImageMenuCategoryActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SortImageMenuCategoryActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SortImageMenuCategoryActionProto message.
             * @function verify
             * @memberof waiternow.common.SortImageMenuCategoryActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SortImageMenuCategoryActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a SortImageMenuCategoryActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.SortImageMenuCategoryActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.SortImageMenuCategoryActionProto} SortImageMenuCategoryActionProto
             */
            SortImageMenuCategoryActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.SortImageMenuCategoryActionProto)
                    return object;
                return new $root.waiternow.common.SortImageMenuCategoryActionProto();
            };

            /**
             * Creates a plain object from a SortImageMenuCategoryActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.SortImageMenuCategoryActionProto
             * @static
             * @param {waiternow.common.SortImageMenuCategoryActionProto} message SortImageMenuCategoryActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SortImageMenuCategoryActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this SortImageMenuCategoryActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.SortImageMenuCategoryActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SortImageMenuCategoryActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for SortImageMenuCategoryActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.SortImageMenuCategoryActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            SortImageMenuCategoryActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.SortImageMenuCategoryActionProto";
            };

            SortImageMenuCategoryActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.SortImageMenuCategoryActionProto
                 * @interface IRequest
                 * @property {string|null} [businessId] Request businessId
                 * @property {string|null} [locationId] Request locationId
                 * @property {waiternow.common.ImageMenuProto.ICategoryProto|null} [sortedCategory] Request sortedCategory
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.SortImageMenuCategoryActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.SortImageMenuCategoryActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request businessId.
                 * @member {string|null|undefined} businessId
                 * @memberof waiternow.common.SortImageMenuCategoryActionProto.Request
                 * @instance
                 */
                Request.prototype.businessId = null;

                /**
                 * Request locationId.
                 * @member {string|null|undefined} locationId
                 * @memberof waiternow.common.SortImageMenuCategoryActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = null;

                /**
                 * Request sortedCategory.
                 * @member {waiternow.common.ImageMenuProto.ICategoryProto|null|undefined} sortedCategory
                 * @memberof waiternow.common.SortImageMenuCategoryActionProto.Request
                 * @instance
                 */
                Request.prototype.sortedCategory = null;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * Request subject.
                 * @member {"businessId"|"locationId"|undefined} subject
                 * @memberof waiternow.common.SortImageMenuCategoryActionProto.Request
                 * @instance
                 */
                Object.defineProperty(Request.prototype, "subject", {
                    get: $util.oneOfGetter($oneOfFields = ["businessId", "locationId"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.SortImageMenuCategoryActionProto.Request
                 * @static
                 * @param {waiternow.common.SortImageMenuCategoryActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.SortImageMenuCategoryActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.SortImageMenuCategoryActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.SortImageMenuCategoryActionProto.Request
                 * @static
                 * @param {waiternow.common.SortImageMenuCategoryActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessId);
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.locationId);
                    if (message.sortedCategory != null && Object.hasOwnProperty.call(message, "sortedCategory"))
                        $root.waiternow.common.ImageMenuProto.CategoryProto.encode(message.sortedCategory, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.SortImageMenuCategoryActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.SortImageMenuCategoryActionProto.Request
                 * @static
                 * @param {waiternow.common.SortImageMenuCategoryActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.SortImageMenuCategoryActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.SortImageMenuCategoryActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.SortImageMenuCategoryActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.businessId = reader.string();
                                break;
                            }
                        case 2: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 3: {
                                message.sortedCategory = $root.waiternow.common.ImageMenuProto.CategoryProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.SortImageMenuCategoryActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.SortImageMenuCategoryActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.SortImageMenuCategoryActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.businessId != null && message.hasOwnProperty("businessId")) {
                        properties.subject = 1;
                        if (!$util.isString(message.businessId))
                            return "businessId: string expected";
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId")) {
                        if (properties.subject === 1)
                            return "subject: multiple values";
                        properties.subject = 1;
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    }
                    if (message.sortedCategory != null && message.hasOwnProperty("sortedCategory")) {
                        var error = $root.waiternow.common.ImageMenuProto.CategoryProto.verify(message.sortedCategory);
                        if (error)
                            return "sortedCategory." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.SortImageMenuCategoryActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.SortImageMenuCategoryActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.SortImageMenuCategoryActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.SortImageMenuCategoryActionProto.Request();
                    if (object.businessId != null)
                        message.businessId = String(object.businessId);
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    if (object.sortedCategory != null) {
                        if (typeof object.sortedCategory !== "object")
                            throw TypeError(".waiternow.common.SortImageMenuCategoryActionProto.Request.sortedCategory: object expected");
                        message.sortedCategory = $root.waiternow.common.ImageMenuProto.CategoryProto.fromObject(object.sortedCategory);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.SortImageMenuCategoryActionProto.Request
                 * @static
                 * @param {waiternow.common.SortImageMenuCategoryActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.sortedCategory = null;
                    if (message.businessId != null && message.hasOwnProperty("businessId")) {
                        object.businessId = message.businessId;
                        if (options.oneofs)
                            object.subject = "businessId";
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId")) {
                        object.locationId = message.locationId;
                        if (options.oneofs)
                            object.subject = "locationId";
                    }
                    if (message.sortedCategory != null && message.hasOwnProperty("sortedCategory"))
                        object.sortedCategory = $root.waiternow.common.ImageMenuProto.CategoryProto.toObject(message.sortedCategory, options);
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.SortImageMenuCategoryActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.SortImageMenuCategoryActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.SortImageMenuCategoryActionProto.Request";
                };

                return Request;
            })();

            SortImageMenuCategoryActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.SortImageMenuCategoryActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.SortImageMenuCategoryActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.SortImageMenuCategoryActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.SortImageMenuCategoryActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.SortImageMenuCategoryActionProto.Response
                 * @static
                 * @param {waiternow.common.SortImageMenuCategoryActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.SortImageMenuCategoryActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.SortImageMenuCategoryActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.SortImageMenuCategoryActionProto.Response
                 * @static
                 * @param {waiternow.common.SortImageMenuCategoryActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.SortImageMenuCategoryActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.SortImageMenuCategoryActionProto.Response
                 * @static
                 * @param {waiternow.common.SortImageMenuCategoryActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.SortImageMenuCategoryActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.SortImageMenuCategoryActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.SortImageMenuCategoryActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.SortImageMenuCategoryActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.SortImageMenuCategoryActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.SortImageMenuCategoryActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.SortImageMenuCategoryActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.SortImageMenuCategoryActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.SortImageMenuCategoryActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.SortImageMenuCategoryActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.SortImageMenuCategoryActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.SortImageMenuCategoryActionProto.Response
                 * @static
                 * @param {waiternow.common.SortImageMenuCategoryActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.SortImageMenuCategoryActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.SortImageMenuCategoryActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.SortImageMenuCategoryActionProto.Response";
                };

                return Response;
            })();

            return SortImageMenuCategoryActionProto;
        })();

        common.AddImageToMenuActionProto = (function() {

            /**
             * Properties of an AddImageToMenuActionProto.
             * @memberof waiternow.common
             * @interface IAddImageToMenuActionProto
             */

            /**
             * Constructs a new AddImageToMenuActionProto.
             * @memberof waiternow.common
             * @classdesc Represents an AddImageToMenuActionProto.
             * @implements IAddImageToMenuActionProto
             * @constructor
             * @param {waiternow.common.IAddImageToMenuActionProto=} [properties] Properties to set
             */
            function AddImageToMenuActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new AddImageToMenuActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.AddImageToMenuActionProto
             * @static
             * @param {waiternow.common.IAddImageToMenuActionProto=} [properties] Properties to set
             * @returns {waiternow.common.AddImageToMenuActionProto} AddImageToMenuActionProto instance
             */
            AddImageToMenuActionProto.create = function create(properties) {
                return new AddImageToMenuActionProto(properties);
            };

            /**
             * Encodes the specified AddImageToMenuActionProto message. Does not implicitly {@link waiternow.common.AddImageToMenuActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.AddImageToMenuActionProto
             * @static
             * @param {waiternow.common.IAddImageToMenuActionProto} message AddImageToMenuActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AddImageToMenuActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified AddImageToMenuActionProto message, length delimited. Does not implicitly {@link waiternow.common.AddImageToMenuActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.AddImageToMenuActionProto
             * @static
             * @param {waiternow.common.IAddImageToMenuActionProto} message AddImageToMenuActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AddImageToMenuActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AddImageToMenuActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.AddImageToMenuActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.AddImageToMenuActionProto} AddImageToMenuActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AddImageToMenuActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.AddImageToMenuActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AddImageToMenuActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.AddImageToMenuActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.AddImageToMenuActionProto} AddImageToMenuActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AddImageToMenuActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AddImageToMenuActionProto message.
             * @function verify
             * @memberof waiternow.common.AddImageToMenuActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AddImageToMenuActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates an AddImageToMenuActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.AddImageToMenuActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.AddImageToMenuActionProto} AddImageToMenuActionProto
             */
            AddImageToMenuActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.AddImageToMenuActionProto)
                    return object;
                return new $root.waiternow.common.AddImageToMenuActionProto();
            };

            /**
             * Creates a plain object from an AddImageToMenuActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.AddImageToMenuActionProto
             * @static
             * @param {waiternow.common.AddImageToMenuActionProto} message AddImageToMenuActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AddImageToMenuActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this AddImageToMenuActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.AddImageToMenuActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AddImageToMenuActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for AddImageToMenuActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.AddImageToMenuActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            AddImageToMenuActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.AddImageToMenuActionProto";
            };

            AddImageToMenuActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.AddImageToMenuActionProto
                 * @interface IRequest
                 * @property {string|null} [businessId] Request businessId
                 * @property {string|null} [locationId] Request locationId
                 * @property {Uint8Array|null} [image] Request image
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.AddImageToMenuActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.AddImageToMenuActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request businessId.
                 * @member {string|null|undefined} businessId
                 * @memberof waiternow.common.AddImageToMenuActionProto.Request
                 * @instance
                 */
                Request.prototype.businessId = null;

                /**
                 * Request locationId.
                 * @member {string|null|undefined} locationId
                 * @memberof waiternow.common.AddImageToMenuActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = null;

                /**
                 * Request image.
                 * @member {Uint8Array} image
                 * @memberof waiternow.common.AddImageToMenuActionProto.Request
                 * @instance
                 */
                Request.prototype.image = $util.newBuffer([]);

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * Request subject.
                 * @member {"businessId"|"locationId"|undefined} subject
                 * @memberof waiternow.common.AddImageToMenuActionProto.Request
                 * @instance
                 */
                Object.defineProperty(Request.prototype, "subject", {
                    get: $util.oneOfGetter($oneOfFields = ["businessId", "locationId"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.AddImageToMenuActionProto.Request
                 * @static
                 * @param {waiternow.common.AddImageToMenuActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.AddImageToMenuActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.AddImageToMenuActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.AddImageToMenuActionProto.Request
                 * @static
                 * @param {waiternow.common.AddImageToMenuActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessId);
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.locationId);
                    if (message.image != null && Object.hasOwnProperty.call(message, "image"))
                        writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.image);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.AddImageToMenuActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.AddImageToMenuActionProto.Request
                 * @static
                 * @param {waiternow.common.AddImageToMenuActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.AddImageToMenuActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.AddImageToMenuActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.AddImageToMenuActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.businessId = reader.string();
                                break;
                            }
                        case 2: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 3: {
                                message.image = reader.bytes();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.AddImageToMenuActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.AddImageToMenuActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.AddImageToMenuActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.businessId != null && message.hasOwnProperty("businessId")) {
                        properties.subject = 1;
                        if (!$util.isString(message.businessId))
                            return "businessId: string expected";
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId")) {
                        if (properties.subject === 1)
                            return "subject: multiple values";
                        properties.subject = 1;
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    }
                    if (message.image != null && message.hasOwnProperty("image"))
                        if (!(message.image && typeof message.image.length === "number" || $util.isString(message.image)))
                            return "image: buffer expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.AddImageToMenuActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.AddImageToMenuActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.AddImageToMenuActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.AddImageToMenuActionProto.Request();
                    if (object.businessId != null)
                        message.businessId = String(object.businessId);
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    if (object.image != null)
                        if (typeof object.image === "string")
                            $util.base64.decode(object.image, message.image = $util.newBuffer($util.base64.length(object.image)), 0);
                        else if (object.image.length >= 0)
                            message.image = object.image;
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.AddImageToMenuActionProto.Request
                 * @static
                 * @param {waiternow.common.AddImageToMenuActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        if (options.bytes === String)
                            object.image = "";
                        else {
                            object.image = [];
                            if (options.bytes !== Array)
                                object.image = $util.newBuffer(object.image);
                        }
                    if (message.businessId != null && message.hasOwnProperty("businessId")) {
                        object.businessId = message.businessId;
                        if (options.oneofs)
                            object.subject = "businessId";
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId")) {
                        object.locationId = message.locationId;
                        if (options.oneofs)
                            object.subject = "locationId";
                    }
                    if (message.image != null && message.hasOwnProperty("image"))
                        object.image = options.bytes === String ? $util.base64.encode(message.image, 0, message.image.length) : options.bytes === Array ? Array.prototype.slice.call(message.image) : message.image;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.AddImageToMenuActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.AddImageToMenuActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.AddImageToMenuActionProto.Request";
                };

                return Request;
            })();

            AddImageToMenuActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.AddImageToMenuActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IImageProto|null} [image] Response image
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.AddImageToMenuActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.AddImageToMenuActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.AddImageToMenuActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response image.
                 * @member {waiternow.common.IImageProto|null|undefined} image
                 * @memberof waiternow.common.AddImageToMenuActionProto.Response
                 * @instance
                 */
                Response.prototype.image = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.AddImageToMenuActionProto.Response
                 * @static
                 * @param {waiternow.common.AddImageToMenuActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.AddImageToMenuActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.AddImageToMenuActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.AddImageToMenuActionProto.Response
                 * @static
                 * @param {waiternow.common.AddImageToMenuActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.image != null && Object.hasOwnProperty.call(message, "image"))
                        $root.waiternow.common.ImageProto.encode(message.image, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.AddImageToMenuActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.AddImageToMenuActionProto.Response
                 * @static
                 * @param {waiternow.common.AddImageToMenuActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.AddImageToMenuActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.AddImageToMenuActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.AddImageToMenuActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.image = $root.waiternow.common.ImageProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.AddImageToMenuActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.AddImageToMenuActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.AddImageToMenuActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.image != null && message.hasOwnProperty("image")) {
                        var error = $root.waiternow.common.ImageProto.verify(message.image);
                        if (error)
                            return "image." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.AddImageToMenuActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.AddImageToMenuActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.AddImageToMenuActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.AddImageToMenuActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.AddImageToMenuActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.image != null) {
                        if (typeof object.image !== "object")
                            throw TypeError(".waiternow.common.AddImageToMenuActionProto.Response.image: object expected");
                        message.image = $root.waiternow.common.ImageProto.fromObject(object.image);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.AddImageToMenuActionProto.Response
                 * @static
                 * @param {waiternow.common.AddImageToMenuActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.image = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.image != null && message.hasOwnProperty("image"))
                        object.image = $root.waiternow.common.ImageProto.toObject(message.image, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.AddImageToMenuActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.AddImageToMenuActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.AddImageToMenuActionProto.Response";
                };

                return Response;
            })();

            return AddImageToMenuActionProto;
        })();

        common.AddImageToMenuMultiPartFormRequestActionProto = (function() {

            /**
             * Properties of an AddImageToMenuMultiPartFormRequestActionProto.
             * @memberof waiternow.common
             * @interface IAddImageToMenuMultiPartFormRequestActionProto
             */

            /**
             * Constructs a new AddImageToMenuMultiPartFormRequestActionProto.
             * @memberof waiternow.common
             * @classdesc Represents an AddImageToMenuMultiPartFormRequestActionProto.
             * @implements IAddImageToMenuMultiPartFormRequestActionProto
             * @constructor
             * @param {waiternow.common.IAddImageToMenuMultiPartFormRequestActionProto=} [properties] Properties to set
             */
            function AddImageToMenuMultiPartFormRequestActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new AddImageToMenuMultiPartFormRequestActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.AddImageToMenuMultiPartFormRequestActionProto
             * @static
             * @param {waiternow.common.IAddImageToMenuMultiPartFormRequestActionProto=} [properties] Properties to set
             * @returns {waiternow.common.AddImageToMenuMultiPartFormRequestActionProto} AddImageToMenuMultiPartFormRequestActionProto instance
             */
            AddImageToMenuMultiPartFormRequestActionProto.create = function create(properties) {
                return new AddImageToMenuMultiPartFormRequestActionProto(properties);
            };

            /**
             * Encodes the specified AddImageToMenuMultiPartFormRequestActionProto message. Does not implicitly {@link waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.AddImageToMenuMultiPartFormRequestActionProto
             * @static
             * @param {waiternow.common.IAddImageToMenuMultiPartFormRequestActionProto} message AddImageToMenuMultiPartFormRequestActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AddImageToMenuMultiPartFormRequestActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified AddImageToMenuMultiPartFormRequestActionProto message, length delimited. Does not implicitly {@link waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.AddImageToMenuMultiPartFormRequestActionProto
             * @static
             * @param {waiternow.common.IAddImageToMenuMultiPartFormRequestActionProto} message AddImageToMenuMultiPartFormRequestActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AddImageToMenuMultiPartFormRequestActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AddImageToMenuMultiPartFormRequestActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.AddImageToMenuMultiPartFormRequestActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.AddImageToMenuMultiPartFormRequestActionProto} AddImageToMenuMultiPartFormRequestActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AddImageToMenuMultiPartFormRequestActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.AddImageToMenuMultiPartFormRequestActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AddImageToMenuMultiPartFormRequestActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.AddImageToMenuMultiPartFormRequestActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.AddImageToMenuMultiPartFormRequestActionProto} AddImageToMenuMultiPartFormRequestActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AddImageToMenuMultiPartFormRequestActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AddImageToMenuMultiPartFormRequestActionProto message.
             * @function verify
             * @memberof waiternow.common.AddImageToMenuMultiPartFormRequestActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AddImageToMenuMultiPartFormRequestActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates an AddImageToMenuMultiPartFormRequestActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.AddImageToMenuMultiPartFormRequestActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.AddImageToMenuMultiPartFormRequestActionProto} AddImageToMenuMultiPartFormRequestActionProto
             */
            AddImageToMenuMultiPartFormRequestActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.AddImageToMenuMultiPartFormRequestActionProto)
                    return object;
                return new $root.waiternow.common.AddImageToMenuMultiPartFormRequestActionProto();
            };

            /**
             * Creates a plain object from an AddImageToMenuMultiPartFormRequestActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.AddImageToMenuMultiPartFormRequestActionProto
             * @static
             * @param {waiternow.common.AddImageToMenuMultiPartFormRequestActionProto} message AddImageToMenuMultiPartFormRequestActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AddImageToMenuMultiPartFormRequestActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this AddImageToMenuMultiPartFormRequestActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.AddImageToMenuMultiPartFormRequestActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AddImageToMenuMultiPartFormRequestActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for AddImageToMenuMultiPartFormRequestActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.AddImageToMenuMultiPartFormRequestActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            AddImageToMenuMultiPartFormRequestActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.AddImageToMenuMultiPartFormRequestActionProto";
            };

            AddImageToMenuMultiPartFormRequestActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.AddImageToMenuMultiPartFormRequestActionProto
                 * @interface IRequest
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.AddImageToMenuMultiPartFormRequestActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.Request
                 * @static
                 * @param {waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.Request
                 * @static
                 * @param {waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.Request
                 * @static
                 * @param {waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.Request)
                        return object;
                    return new $root.waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.Request();
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.Request
                 * @static
                 * @param {waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject() {
                    return {};
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.Request";
                };

                return Request;
            })();

            AddImageToMenuMultiPartFormRequestActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.AddImageToMenuMultiPartFormRequestActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IImageProto|null} [image] Response image
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.AddImageToMenuMultiPartFormRequestActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response image.
                 * @member {waiternow.common.IImageProto|null|undefined} image
                 * @memberof waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.Response
                 * @instance
                 */
                Response.prototype.image = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.Response
                 * @static
                 * @param {waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.Response
                 * @static
                 * @param {waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.image != null && Object.hasOwnProperty.call(message, "image"))
                        $root.waiternow.common.ImageProto.encode(message.image, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.Response
                 * @static
                 * @param {waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.image = $root.waiternow.common.ImageProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.image != null && message.hasOwnProperty("image")) {
                        var error = $root.waiternow.common.ImageProto.verify(message.image);
                        if (error)
                            return "image." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.image != null) {
                        if (typeof object.image !== "object")
                            throw TypeError(".waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.Response.image: object expected");
                        message.image = $root.waiternow.common.ImageProto.fromObject(object.image);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.Response
                 * @static
                 * @param {waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.image = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.image != null && message.hasOwnProperty("image"))
                        object.image = $root.waiternow.common.ImageProto.toObject(message.image, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.AddImageToMenuMultiPartFormRequestActionProto.Response";
                };

                return Response;
            })();

            return AddImageToMenuMultiPartFormRequestActionProto;
        })();

        common.SaveDraftOfMenuActionProto = (function() {

            /**
             * Properties of a SaveDraftOfMenuActionProto.
             * @memberof waiternow.common
             * @interface ISaveDraftOfMenuActionProto
             */

            /**
             * Constructs a new SaveDraftOfMenuActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a SaveDraftOfMenuActionProto.
             * @implements ISaveDraftOfMenuActionProto
             * @constructor
             * @param {waiternow.common.ISaveDraftOfMenuActionProto=} [properties] Properties to set
             */
            function SaveDraftOfMenuActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new SaveDraftOfMenuActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.SaveDraftOfMenuActionProto
             * @static
             * @param {waiternow.common.ISaveDraftOfMenuActionProto=} [properties] Properties to set
             * @returns {waiternow.common.SaveDraftOfMenuActionProto} SaveDraftOfMenuActionProto instance
             */
            SaveDraftOfMenuActionProto.create = function create(properties) {
                return new SaveDraftOfMenuActionProto(properties);
            };

            /**
             * Encodes the specified SaveDraftOfMenuActionProto message. Does not implicitly {@link waiternow.common.SaveDraftOfMenuActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.SaveDraftOfMenuActionProto
             * @static
             * @param {waiternow.common.ISaveDraftOfMenuActionProto} message SaveDraftOfMenuActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SaveDraftOfMenuActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified SaveDraftOfMenuActionProto message, length delimited. Does not implicitly {@link waiternow.common.SaveDraftOfMenuActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.SaveDraftOfMenuActionProto
             * @static
             * @param {waiternow.common.ISaveDraftOfMenuActionProto} message SaveDraftOfMenuActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SaveDraftOfMenuActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SaveDraftOfMenuActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.SaveDraftOfMenuActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.SaveDraftOfMenuActionProto} SaveDraftOfMenuActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SaveDraftOfMenuActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.SaveDraftOfMenuActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SaveDraftOfMenuActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.SaveDraftOfMenuActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.SaveDraftOfMenuActionProto} SaveDraftOfMenuActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SaveDraftOfMenuActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SaveDraftOfMenuActionProto message.
             * @function verify
             * @memberof waiternow.common.SaveDraftOfMenuActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SaveDraftOfMenuActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a SaveDraftOfMenuActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.SaveDraftOfMenuActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.SaveDraftOfMenuActionProto} SaveDraftOfMenuActionProto
             */
            SaveDraftOfMenuActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.SaveDraftOfMenuActionProto)
                    return object;
                return new $root.waiternow.common.SaveDraftOfMenuActionProto();
            };

            /**
             * Creates a plain object from a SaveDraftOfMenuActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.SaveDraftOfMenuActionProto
             * @static
             * @param {waiternow.common.SaveDraftOfMenuActionProto} message SaveDraftOfMenuActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SaveDraftOfMenuActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this SaveDraftOfMenuActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.SaveDraftOfMenuActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SaveDraftOfMenuActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for SaveDraftOfMenuActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.SaveDraftOfMenuActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            SaveDraftOfMenuActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.SaveDraftOfMenuActionProto";
            };

            SaveDraftOfMenuActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.SaveDraftOfMenuActionProto
                 * @interface IRequest
                 * @property {string|null} [businessId] Request businessId
                 * @property {string|null} [locationId] Request locationId
                 * @property {waiternow.common.IMenuSpecProto|null} [menu] Request menu
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.SaveDraftOfMenuActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.SaveDraftOfMenuActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request businessId.
                 * @member {string|null|undefined} businessId
                 * @memberof waiternow.common.SaveDraftOfMenuActionProto.Request
                 * @instance
                 */
                Request.prototype.businessId = null;

                /**
                 * Request locationId.
                 * @member {string|null|undefined} locationId
                 * @memberof waiternow.common.SaveDraftOfMenuActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = null;

                /**
                 * Request menu.
                 * @member {waiternow.common.IMenuSpecProto|null|undefined} menu
                 * @memberof waiternow.common.SaveDraftOfMenuActionProto.Request
                 * @instance
                 */
                Request.prototype.menu = null;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * Request subject.
                 * @member {"businessId"|"locationId"|undefined} subject
                 * @memberof waiternow.common.SaveDraftOfMenuActionProto.Request
                 * @instance
                 */
                Object.defineProperty(Request.prototype, "subject", {
                    get: $util.oneOfGetter($oneOfFields = ["businessId", "locationId"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.SaveDraftOfMenuActionProto.Request
                 * @static
                 * @param {waiternow.common.SaveDraftOfMenuActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.SaveDraftOfMenuActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.SaveDraftOfMenuActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.SaveDraftOfMenuActionProto.Request
                 * @static
                 * @param {waiternow.common.SaveDraftOfMenuActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessId);
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.locationId);
                    if (message.menu != null && Object.hasOwnProperty.call(message, "menu"))
                        $root.waiternow.common.MenuSpecProto.encode(message.menu, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.SaveDraftOfMenuActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.SaveDraftOfMenuActionProto.Request
                 * @static
                 * @param {waiternow.common.SaveDraftOfMenuActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.SaveDraftOfMenuActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.SaveDraftOfMenuActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.SaveDraftOfMenuActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.businessId = reader.string();
                                break;
                            }
                        case 2: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 3: {
                                message.menu = $root.waiternow.common.MenuSpecProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.SaveDraftOfMenuActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.SaveDraftOfMenuActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.SaveDraftOfMenuActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.businessId != null && message.hasOwnProperty("businessId")) {
                        properties.subject = 1;
                        if (!$util.isString(message.businessId))
                            return "businessId: string expected";
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId")) {
                        if (properties.subject === 1)
                            return "subject: multiple values";
                        properties.subject = 1;
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    }
                    if (message.menu != null && message.hasOwnProperty("menu")) {
                        var error = $root.waiternow.common.MenuSpecProto.verify(message.menu);
                        if (error)
                            return "menu." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.SaveDraftOfMenuActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.SaveDraftOfMenuActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.SaveDraftOfMenuActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.SaveDraftOfMenuActionProto.Request();
                    if (object.businessId != null)
                        message.businessId = String(object.businessId);
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    if (object.menu != null) {
                        if (typeof object.menu !== "object")
                            throw TypeError(".waiternow.common.SaveDraftOfMenuActionProto.Request.menu: object expected");
                        message.menu = $root.waiternow.common.MenuSpecProto.fromObject(object.menu);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.SaveDraftOfMenuActionProto.Request
                 * @static
                 * @param {waiternow.common.SaveDraftOfMenuActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.menu = null;
                    if (message.businessId != null && message.hasOwnProperty("businessId")) {
                        object.businessId = message.businessId;
                        if (options.oneofs)
                            object.subject = "businessId";
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId")) {
                        object.locationId = message.locationId;
                        if (options.oneofs)
                            object.subject = "locationId";
                    }
                    if (message.menu != null && message.hasOwnProperty("menu"))
                        object.menu = $root.waiternow.common.MenuSpecProto.toObject(message.menu, options);
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.SaveDraftOfMenuActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.SaveDraftOfMenuActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.SaveDraftOfMenuActionProto.Request";
                };

                return Request;
            })();

            SaveDraftOfMenuActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.SaveDraftOfMenuActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.SaveDraftOfMenuActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.SaveDraftOfMenuActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.SaveDraftOfMenuActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.SaveDraftOfMenuActionProto.Response
                 * @static
                 * @param {waiternow.common.SaveDraftOfMenuActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.SaveDraftOfMenuActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.SaveDraftOfMenuActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.SaveDraftOfMenuActionProto.Response
                 * @static
                 * @param {waiternow.common.SaveDraftOfMenuActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.SaveDraftOfMenuActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.SaveDraftOfMenuActionProto.Response
                 * @static
                 * @param {waiternow.common.SaveDraftOfMenuActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.SaveDraftOfMenuActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.SaveDraftOfMenuActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.SaveDraftOfMenuActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.SaveDraftOfMenuActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.SaveDraftOfMenuActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.SaveDraftOfMenuActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.SaveDraftOfMenuActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.SaveDraftOfMenuActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.SaveDraftOfMenuActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.SaveDraftOfMenuActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.SaveDraftOfMenuActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.SaveDraftOfMenuActionProto.Response
                 * @static
                 * @param {waiternow.common.SaveDraftOfMenuActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.SaveDraftOfMenuActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.SaveDraftOfMenuActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.SaveDraftOfMenuActionProto.Response";
                };

                return Response;
            })();

            return SaveDraftOfMenuActionProto;
        })();

        common.PublishMenuActionProto = (function() {

            /**
             * Properties of a PublishMenuActionProto.
             * @memberof waiternow.common
             * @interface IPublishMenuActionProto
             */

            /**
             * Constructs a new PublishMenuActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a PublishMenuActionProto.
             * @implements IPublishMenuActionProto
             * @constructor
             * @param {waiternow.common.IPublishMenuActionProto=} [properties] Properties to set
             */
            function PublishMenuActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new PublishMenuActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.PublishMenuActionProto
             * @static
             * @param {waiternow.common.IPublishMenuActionProto=} [properties] Properties to set
             * @returns {waiternow.common.PublishMenuActionProto} PublishMenuActionProto instance
             */
            PublishMenuActionProto.create = function create(properties) {
                return new PublishMenuActionProto(properties);
            };

            /**
             * Encodes the specified PublishMenuActionProto message. Does not implicitly {@link waiternow.common.PublishMenuActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.PublishMenuActionProto
             * @static
             * @param {waiternow.common.IPublishMenuActionProto} message PublishMenuActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PublishMenuActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified PublishMenuActionProto message, length delimited. Does not implicitly {@link waiternow.common.PublishMenuActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.PublishMenuActionProto
             * @static
             * @param {waiternow.common.IPublishMenuActionProto} message PublishMenuActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PublishMenuActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a PublishMenuActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.PublishMenuActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.PublishMenuActionProto} PublishMenuActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PublishMenuActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PublishMenuActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a PublishMenuActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.PublishMenuActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.PublishMenuActionProto} PublishMenuActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PublishMenuActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a PublishMenuActionProto message.
             * @function verify
             * @memberof waiternow.common.PublishMenuActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            PublishMenuActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a PublishMenuActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.PublishMenuActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.PublishMenuActionProto} PublishMenuActionProto
             */
            PublishMenuActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.PublishMenuActionProto)
                    return object;
                return new $root.waiternow.common.PublishMenuActionProto();
            };

            /**
             * Creates a plain object from a PublishMenuActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.PublishMenuActionProto
             * @static
             * @param {waiternow.common.PublishMenuActionProto} message PublishMenuActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            PublishMenuActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this PublishMenuActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.PublishMenuActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            PublishMenuActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for PublishMenuActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.PublishMenuActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            PublishMenuActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.PublishMenuActionProto";
            };

            PublishMenuActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.PublishMenuActionProto
                 * @interface IRequest
                 * @property {string|null} [businessId] Request businessId
                 * @property {string|null} [locationId] Request locationId
                 * @property {waiternow.common.IMenuSpecProto|null} [menu] Request menu
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.PublishMenuActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.PublishMenuActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request businessId.
                 * @member {string|null|undefined} businessId
                 * @memberof waiternow.common.PublishMenuActionProto.Request
                 * @instance
                 */
                Request.prototype.businessId = null;

                /**
                 * Request locationId.
                 * @member {string|null|undefined} locationId
                 * @memberof waiternow.common.PublishMenuActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = null;

                /**
                 * Request menu.
                 * @member {waiternow.common.IMenuSpecProto|null|undefined} menu
                 * @memberof waiternow.common.PublishMenuActionProto.Request
                 * @instance
                 */
                Request.prototype.menu = null;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * Request subject.
                 * @member {"businessId"|"locationId"|undefined} subject
                 * @memberof waiternow.common.PublishMenuActionProto.Request
                 * @instance
                 */
                Object.defineProperty(Request.prototype, "subject", {
                    get: $util.oneOfGetter($oneOfFields = ["businessId", "locationId"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.PublishMenuActionProto.Request
                 * @static
                 * @param {waiternow.common.PublishMenuActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.PublishMenuActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.PublishMenuActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.PublishMenuActionProto.Request
                 * @static
                 * @param {waiternow.common.PublishMenuActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessId);
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.locationId);
                    if (message.menu != null && Object.hasOwnProperty.call(message, "menu"))
                        $root.waiternow.common.MenuSpecProto.encode(message.menu, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.PublishMenuActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.PublishMenuActionProto.Request
                 * @static
                 * @param {waiternow.common.PublishMenuActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.PublishMenuActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.PublishMenuActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PublishMenuActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.businessId = reader.string();
                                break;
                            }
                        case 2: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 3: {
                                message.menu = $root.waiternow.common.MenuSpecProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.PublishMenuActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.PublishMenuActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.PublishMenuActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.businessId != null && message.hasOwnProperty("businessId")) {
                        properties.subject = 1;
                        if (!$util.isString(message.businessId))
                            return "businessId: string expected";
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId")) {
                        if (properties.subject === 1)
                            return "subject: multiple values";
                        properties.subject = 1;
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    }
                    if (message.menu != null && message.hasOwnProperty("menu")) {
                        var error = $root.waiternow.common.MenuSpecProto.verify(message.menu);
                        if (error)
                            return "menu." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.PublishMenuActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.PublishMenuActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.PublishMenuActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.PublishMenuActionProto.Request();
                    if (object.businessId != null)
                        message.businessId = String(object.businessId);
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    if (object.menu != null) {
                        if (typeof object.menu !== "object")
                            throw TypeError(".waiternow.common.PublishMenuActionProto.Request.menu: object expected");
                        message.menu = $root.waiternow.common.MenuSpecProto.fromObject(object.menu);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.PublishMenuActionProto.Request
                 * @static
                 * @param {waiternow.common.PublishMenuActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.menu = null;
                    if (message.businessId != null && message.hasOwnProperty("businessId")) {
                        object.businessId = message.businessId;
                        if (options.oneofs)
                            object.subject = "businessId";
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId")) {
                        object.locationId = message.locationId;
                        if (options.oneofs)
                            object.subject = "locationId";
                    }
                    if (message.menu != null && message.hasOwnProperty("menu"))
                        object.menu = $root.waiternow.common.MenuSpecProto.toObject(message.menu, options);
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.PublishMenuActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.PublishMenuActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.PublishMenuActionProto.Request";
                };

                return Request;
            })();

            PublishMenuActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.PublishMenuActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.PublishMenuActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.PublishMenuActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.PublishMenuActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.PublishMenuActionProto.Response
                 * @static
                 * @param {waiternow.common.PublishMenuActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.PublishMenuActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.PublishMenuActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.PublishMenuActionProto.Response
                 * @static
                 * @param {waiternow.common.PublishMenuActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.PublishMenuActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.PublishMenuActionProto.Response
                 * @static
                 * @param {waiternow.common.PublishMenuActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.PublishMenuActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.PublishMenuActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.PublishMenuActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.PublishMenuActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.PublishMenuActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.PublishMenuActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.PublishMenuActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.PublishMenuActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.PublishMenuActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.PublishMenuActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.PublishMenuActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.PublishMenuActionProto.Response
                 * @static
                 * @param {waiternow.common.PublishMenuActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.PublishMenuActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.PublishMenuActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.PublishMenuActionProto.Response";
                };

                return Response;
            })();

            return PublishMenuActionProto;
        })();

        common.GetDraftOfMenuActionProto = (function() {

            /**
             * Properties of a GetDraftOfMenuActionProto.
             * @memberof waiternow.common
             * @interface IGetDraftOfMenuActionProto
             */

            /**
             * Constructs a new GetDraftOfMenuActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a GetDraftOfMenuActionProto.
             * @implements IGetDraftOfMenuActionProto
             * @constructor
             * @param {waiternow.common.IGetDraftOfMenuActionProto=} [properties] Properties to set
             */
            function GetDraftOfMenuActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new GetDraftOfMenuActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.GetDraftOfMenuActionProto
             * @static
             * @param {waiternow.common.IGetDraftOfMenuActionProto=} [properties] Properties to set
             * @returns {waiternow.common.GetDraftOfMenuActionProto} GetDraftOfMenuActionProto instance
             */
            GetDraftOfMenuActionProto.create = function create(properties) {
                return new GetDraftOfMenuActionProto(properties);
            };

            /**
             * Encodes the specified GetDraftOfMenuActionProto message. Does not implicitly {@link waiternow.common.GetDraftOfMenuActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.GetDraftOfMenuActionProto
             * @static
             * @param {waiternow.common.IGetDraftOfMenuActionProto} message GetDraftOfMenuActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetDraftOfMenuActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified GetDraftOfMenuActionProto message, length delimited. Does not implicitly {@link waiternow.common.GetDraftOfMenuActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.GetDraftOfMenuActionProto
             * @static
             * @param {waiternow.common.IGetDraftOfMenuActionProto} message GetDraftOfMenuActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetDraftOfMenuActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetDraftOfMenuActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.GetDraftOfMenuActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.GetDraftOfMenuActionProto} GetDraftOfMenuActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetDraftOfMenuActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetDraftOfMenuActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetDraftOfMenuActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.GetDraftOfMenuActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.GetDraftOfMenuActionProto} GetDraftOfMenuActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetDraftOfMenuActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetDraftOfMenuActionProto message.
             * @function verify
             * @memberof waiternow.common.GetDraftOfMenuActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetDraftOfMenuActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a GetDraftOfMenuActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.GetDraftOfMenuActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.GetDraftOfMenuActionProto} GetDraftOfMenuActionProto
             */
            GetDraftOfMenuActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.GetDraftOfMenuActionProto)
                    return object;
                return new $root.waiternow.common.GetDraftOfMenuActionProto();
            };

            /**
             * Creates a plain object from a GetDraftOfMenuActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.GetDraftOfMenuActionProto
             * @static
             * @param {waiternow.common.GetDraftOfMenuActionProto} message GetDraftOfMenuActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetDraftOfMenuActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this GetDraftOfMenuActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.GetDraftOfMenuActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetDraftOfMenuActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for GetDraftOfMenuActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.GetDraftOfMenuActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            GetDraftOfMenuActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.GetDraftOfMenuActionProto";
            };

            GetDraftOfMenuActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.GetDraftOfMenuActionProto
                 * @interface IRequest
                 * @property {string|null} [businessId] Request businessId
                 * @property {string|null} [locationId] Request locationId
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.GetDraftOfMenuActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.GetDraftOfMenuActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request businessId.
                 * @member {string|null|undefined} businessId
                 * @memberof waiternow.common.GetDraftOfMenuActionProto.Request
                 * @instance
                 */
                Request.prototype.businessId = null;

                /**
                 * Request locationId.
                 * @member {string|null|undefined} locationId
                 * @memberof waiternow.common.GetDraftOfMenuActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = null;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * Request subject.
                 * @member {"businessId"|"locationId"|undefined} subject
                 * @memberof waiternow.common.GetDraftOfMenuActionProto.Request
                 * @instance
                 */
                Object.defineProperty(Request.prototype, "subject", {
                    get: $util.oneOfGetter($oneOfFields = ["businessId", "locationId"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetDraftOfMenuActionProto.Request
                 * @static
                 * @param {waiternow.common.GetDraftOfMenuActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.GetDraftOfMenuActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.GetDraftOfMenuActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetDraftOfMenuActionProto.Request
                 * @static
                 * @param {waiternow.common.GetDraftOfMenuActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessId);
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.locationId);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.GetDraftOfMenuActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetDraftOfMenuActionProto.Request
                 * @static
                 * @param {waiternow.common.GetDraftOfMenuActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetDraftOfMenuActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetDraftOfMenuActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetDraftOfMenuActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.businessId = reader.string();
                                break;
                            }
                        case 2: {
                                message.locationId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetDraftOfMenuActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetDraftOfMenuActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.GetDraftOfMenuActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.businessId != null && message.hasOwnProperty("businessId")) {
                        properties.subject = 1;
                        if (!$util.isString(message.businessId))
                            return "businessId: string expected";
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId")) {
                        if (properties.subject === 1)
                            return "subject: multiple values";
                        properties.subject = 1;
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    }
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetDraftOfMenuActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetDraftOfMenuActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetDraftOfMenuActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.GetDraftOfMenuActionProto.Request();
                    if (object.businessId != null)
                        message.businessId = String(object.businessId);
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetDraftOfMenuActionProto.Request
                 * @static
                 * @param {waiternow.common.GetDraftOfMenuActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (message.businessId != null && message.hasOwnProperty("businessId")) {
                        object.businessId = message.businessId;
                        if (options.oneofs)
                            object.subject = "businessId";
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId")) {
                        object.locationId = message.locationId;
                        if (options.oneofs)
                            object.subject = "locationId";
                    }
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetDraftOfMenuActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetDraftOfMenuActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetDraftOfMenuActionProto.Request";
                };

                return Request;
            })();

            GetDraftOfMenuActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.GetDraftOfMenuActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IMenuSpecProto|null} [menu] Response menu
                 * @property {boolean|null} [draftGeneratedFromParentBusiness] Response draftGeneratedFromParentBusiness
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.GetDraftOfMenuActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.GetDraftOfMenuActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.GetDraftOfMenuActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response menu.
                 * @member {waiternow.common.IMenuSpecProto|null|undefined} menu
                 * @memberof waiternow.common.GetDraftOfMenuActionProto.Response
                 * @instance
                 */
                Response.prototype.menu = null;

                /**
                 * Response draftGeneratedFromParentBusiness.
                 * @member {boolean} draftGeneratedFromParentBusiness
                 * @memberof waiternow.common.GetDraftOfMenuActionProto.Response
                 * @instance
                 */
                Response.prototype.draftGeneratedFromParentBusiness = false;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetDraftOfMenuActionProto.Response
                 * @static
                 * @param {waiternow.common.GetDraftOfMenuActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.GetDraftOfMenuActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.GetDraftOfMenuActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetDraftOfMenuActionProto.Response
                 * @static
                 * @param {waiternow.common.GetDraftOfMenuActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.menu != null && Object.hasOwnProperty.call(message, "menu"))
                        $root.waiternow.common.MenuSpecProto.encode(message.menu, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.draftGeneratedFromParentBusiness != null && Object.hasOwnProperty.call(message, "draftGeneratedFromParentBusiness"))
                        writer.uint32(/* id 3, wireType 0 =*/24).bool(message.draftGeneratedFromParentBusiness);
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.GetDraftOfMenuActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetDraftOfMenuActionProto.Response
                 * @static
                 * @param {waiternow.common.GetDraftOfMenuActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetDraftOfMenuActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetDraftOfMenuActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetDraftOfMenuActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.menu = $root.waiternow.common.MenuSpecProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.draftGeneratedFromParentBusiness = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetDraftOfMenuActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetDraftOfMenuActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.GetDraftOfMenuActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.menu != null && message.hasOwnProperty("menu")) {
                        var error = $root.waiternow.common.MenuSpecProto.verify(message.menu);
                        if (error)
                            return "menu." + error;
                    }
                    if (message.draftGeneratedFromParentBusiness != null && message.hasOwnProperty("draftGeneratedFromParentBusiness"))
                        if (typeof message.draftGeneratedFromParentBusiness !== "boolean")
                            return "draftGeneratedFromParentBusiness: boolean expected";
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetDraftOfMenuActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetDraftOfMenuActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetDraftOfMenuActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.GetDraftOfMenuActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.GetDraftOfMenuActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.menu != null) {
                        if (typeof object.menu !== "object")
                            throw TypeError(".waiternow.common.GetDraftOfMenuActionProto.Response.menu: object expected");
                        message.menu = $root.waiternow.common.MenuSpecProto.fromObject(object.menu);
                    }
                    if (object.draftGeneratedFromParentBusiness != null)
                        message.draftGeneratedFromParentBusiness = Boolean(object.draftGeneratedFromParentBusiness);
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetDraftOfMenuActionProto.Response
                 * @static
                 * @param {waiternow.common.GetDraftOfMenuActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.menu = null;
                        object.draftGeneratedFromParentBusiness = false;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.menu != null && message.hasOwnProperty("menu"))
                        object.menu = $root.waiternow.common.MenuSpecProto.toObject(message.menu, options);
                    if (message.draftGeneratedFromParentBusiness != null && message.hasOwnProperty("draftGeneratedFromParentBusiness"))
                        object.draftGeneratedFromParentBusiness = message.draftGeneratedFromParentBusiness;
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetDraftOfMenuActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetDraftOfMenuActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetDraftOfMenuActionProto.Response";
                };

                return Response;
            })();

            return GetDraftOfMenuActionProto;
        })();

        common.GetMenuActionProto = (function() {

            /**
             * Properties of a GetMenuActionProto.
             * @memberof waiternow.common
             * @interface IGetMenuActionProto
             */

            /**
             * Constructs a new GetMenuActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a GetMenuActionProto.
             * @implements IGetMenuActionProto
             * @constructor
             * @param {waiternow.common.IGetMenuActionProto=} [properties] Properties to set
             */
            function GetMenuActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new GetMenuActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.GetMenuActionProto
             * @static
             * @param {waiternow.common.IGetMenuActionProto=} [properties] Properties to set
             * @returns {waiternow.common.GetMenuActionProto} GetMenuActionProto instance
             */
            GetMenuActionProto.create = function create(properties) {
                return new GetMenuActionProto(properties);
            };

            /**
             * Encodes the specified GetMenuActionProto message. Does not implicitly {@link waiternow.common.GetMenuActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.GetMenuActionProto
             * @static
             * @param {waiternow.common.IGetMenuActionProto} message GetMenuActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetMenuActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified GetMenuActionProto message, length delimited. Does not implicitly {@link waiternow.common.GetMenuActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.GetMenuActionProto
             * @static
             * @param {waiternow.common.IGetMenuActionProto} message GetMenuActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetMenuActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetMenuActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.GetMenuActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.GetMenuActionProto} GetMenuActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetMenuActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetMenuActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetMenuActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.GetMenuActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.GetMenuActionProto} GetMenuActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetMenuActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetMenuActionProto message.
             * @function verify
             * @memberof waiternow.common.GetMenuActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetMenuActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a GetMenuActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.GetMenuActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.GetMenuActionProto} GetMenuActionProto
             */
            GetMenuActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.GetMenuActionProto)
                    return object;
                return new $root.waiternow.common.GetMenuActionProto();
            };

            /**
             * Creates a plain object from a GetMenuActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.GetMenuActionProto
             * @static
             * @param {waiternow.common.GetMenuActionProto} message GetMenuActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetMenuActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this GetMenuActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.GetMenuActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetMenuActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for GetMenuActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.GetMenuActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            GetMenuActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.GetMenuActionProto";
            };

            GetMenuActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.GetMenuActionProto
                 * @interface IRequest
                 * @property {string|null} [businessId] Request businessId
                 * @property {string|null} [locationId] Request locationId
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.GetMenuActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.GetMenuActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request businessId.
                 * @member {string|null|undefined} businessId
                 * @memberof waiternow.common.GetMenuActionProto.Request
                 * @instance
                 */
                Request.prototype.businessId = null;

                /**
                 * Request locationId.
                 * @member {string|null|undefined} locationId
                 * @memberof waiternow.common.GetMenuActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = null;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * Request subject.
                 * @member {"businessId"|"locationId"|undefined} subject
                 * @memberof waiternow.common.GetMenuActionProto.Request
                 * @instance
                 */
                Object.defineProperty(Request.prototype, "subject", {
                    get: $util.oneOfGetter($oneOfFields = ["businessId", "locationId"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetMenuActionProto.Request
                 * @static
                 * @param {waiternow.common.GetMenuActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.GetMenuActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.GetMenuActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetMenuActionProto.Request
                 * @static
                 * @param {waiternow.common.GetMenuActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessId);
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.locationId);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.GetMenuActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetMenuActionProto.Request
                 * @static
                 * @param {waiternow.common.GetMenuActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetMenuActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetMenuActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetMenuActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.businessId = reader.string();
                                break;
                            }
                        case 2: {
                                message.locationId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetMenuActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetMenuActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.GetMenuActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.businessId != null && message.hasOwnProperty("businessId")) {
                        properties.subject = 1;
                        if (!$util.isString(message.businessId))
                            return "businessId: string expected";
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId")) {
                        if (properties.subject === 1)
                            return "subject: multiple values";
                        properties.subject = 1;
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    }
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetMenuActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetMenuActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetMenuActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.GetMenuActionProto.Request();
                    if (object.businessId != null)
                        message.businessId = String(object.businessId);
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetMenuActionProto.Request
                 * @static
                 * @param {waiternow.common.GetMenuActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (message.businessId != null && message.hasOwnProperty("businessId")) {
                        object.businessId = message.businessId;
                        if (options.oneofs)
                            object.subject = "businessId";
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId")) {
                        object.locationId = message.locationId;
                        if (options.oneofs)
                            object.subject = "locationId";
                    }
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetMenuActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetMenuActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetMenuActionProto.Request";
                };

                return Request;
            })();

            GetMenuActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.GetMenuActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IMenuSpecProto|null} [menu] Response menu
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.GetMenuActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.GetMenuActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.GetMenuActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response menu.
                 * @member {waiternow.common.IMenuSpecProto|null|undefined} menu
                 * @memberof waiternow.common.GetMenuActionProto.Response
                 * @instance
                 */
                Response.prototype.menu = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetMenuActionProto.Response
                 * @static
                 * @param {waiternow.common.GetMenuActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.GetMenuActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.GetMenuActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetMenuActionProto.Response
                 * @static
                 * @param {waiternow.common.GetMenuActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.menu != null && Object.hasOwnProperty.call(message, "menu"))
                        $root.waiternow.common.MenuSpecProto.encode(message.menu, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.GetMenuActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetMenuActionProto.Response
                 * @static
                 * @param {waiternow.common.GetMenuActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetMenuActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetMenuActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetMenuActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.menu = $root.waiternow.common.MenuSpecProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetMenuActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetMenuActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.GetMenuActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.menu != null && message.hasOwnProperty("menu")) {
                        var error = $root.waiternow.common.MenuSpecProto.verify(message.menu);
                        if (error)
                            return "menu." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetMenuActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetMenuActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetMenuActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.GetMenuActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.GetMenuActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.menu != null) {
                        if (typeof object.menu !== "object")
                            throw TypeError(".waiternow.common.GetMenuActionProto.Response.menu: object expected");
                        message.menu = $root.waiternow.common.MenuSpecProto.fromObject(object.menu);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetMenuActionProto.Response
                 * @static
                 * @param {waiternow.common.GetMenuActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.menu = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.menu != null && message.hasOwnProperty("menu"))
                        object.menu = $root.waiternow.common.MenuSpecProto.toObject(message.menu, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetMenuActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetMenuActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetMenuActionProto.Response";
                };

                return Response;
            })();

            return GetMenuActionProto;
        })();

        common.GetMenuDenormalizedActionProto = (function() {

            /**
             * Properties of a GetMenuDenormalizedActionProto.
             * @memberof waiternow.common
             * @interface IGetMenuDenormalizedActionProto
             */

            /**
             * Constructs a new GetMenuDenormalizedActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a GetMenuDenormalizedActionProto.
             * @implements IGetMenuDenormalizedActionProto
             * @constructor
             * @param {waiternow.common.IGetMenuDenormalizedActionProto=} [properties] Properties to set
             */
            function GetMenuDenormalizedActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new GetMenuDenormalizedActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.GetMenuDenormalizedActionProto
             * @static
             * @param {waiternow.common.IGetMenuDenormalizedActionProto=} [properties] Properties to set
             * @returns {waiternow.common.GetMenuDenormalizedActionProto} GetMenuDenormalizedActionProto instance
             */
            GetMenuDenormalizedActionProto.create = function create(properties) {
                return new GetMenuDenormalizedActionProto(properties);
            };

            /**
             * Encodes the specified GetMenuDenormalizedActionProto message. Does not implicitly {@link waiternow.common.GetMenuDenormalizedActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.GetMenuDenormalizedActionProto
             * @static
             * @param {waiternow.common.IGetMenuDenormalizedActionProto} message GetMenuDenormalizedActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetMenuDenormalizedActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified GetMenuDenormalizedActionProto message, length delimited. Does not implicitly {@link waiternow.common.GetMenuDenormalizedActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.GetMenuDenormalizedActionProto
             * @static
             * @param {waiternow.common.IGetMenuDenormalizedActionProto} message GetMenuDenormalizedActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetMenuDenormalizedActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetMenuDenormalizedActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.GetMenuDenormalizedActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.GetMenuDenormalizedActionProto} GetMenuDenormalizedActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetMenuDenormalizedActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetMenuDenormalizedActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetMenuDenormalizedActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.GetMenuDenormalizedActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.GetMenuDenormalizedActionProto} GetMenuDenormalizedActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetMenuDenormalizedActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetMenuDenormalizedActionProto message.
             * @function verify
             * @memberof waiternow.common.GetMenuDenormalizedActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetMenuDenormalizedActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a GetMenuDenormalizedActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.GetMenuDenormalizedActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.GetMenuDenormalizedActionProto} GetMenuDenormalizedActionProto
             */
            GetMenuDenormalizedActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.GetMenuDenormalizedActionProto)
                    return object;
                return new $root.waiternow.common.GetMenuDenormalizedActionProto();
            };

            /**
             * Creates a plain object from a GetMenuDenormalizedActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.GetMenuDenormalizedActionProto
             * @static
             * @param {waiternow.common.GetMenuDenormalizedActionProto} message GetMenuDenormalizedActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetMenuDenormalizedActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this GetMenuDenormalizedActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.GetMenuDenormalizedActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetMenuDenormalizedActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for GetMenuDenormalizedActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.GetMenuDenormalizedActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            GetMenuDenormalizedActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.GetMenuDenormalizedActionProto";
            };

            GetMenuDenormalizedActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.GetMenuDenormalizedActionProto
                 * @interface IRequest
                 * @property {string|null} [businessId] Request businessId
                 * @property {string|null} [locationId] Request locationId
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.GetMenuDenormalizedActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.GetMenuDenormalizedActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request businessId.
                 * @member {string|null|undefined} businessId
                 * @memberof waiternow.common.GetMenuDenormalizedActionProto.Request
                 * @instance
                 */
                Request.prototype.businessId = null;

                /**
                 * Request locationId.
                 * @member {string|null|undefined} locationId
                 * @memberof waiternow.common.GetMenuDenormalizedActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = null;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * Request subject.
                 * @member {"businessId"|"locationId"|undefined} subject
                 * @memberof waiternow.common.GetMenuDenormalizedActionProto.Request
                 * @instance
                 */
                Object.defineProperty(Request.prototype, "subject", {
                    get: $util.oneOfGetter($oneOfFields = ["businessId", "locationId"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetMenuDenormalizedActionProto.Request
                 * @static
                 * @param {waiternow.common.GetMenuDenormalizedActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.GetMenuDenormalizedActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.GetMenuDenormalizedActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetMenuDenormalizedActionProto.Request
                 * @static
                 * @param {waiternow.common.GetMenuDenormalizedActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessId);
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.locationId);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.GetMenuDenormalizedActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetMenuDenormalizedActionProto.Request
                 * @static
                 * @param {waiternow.common.GetMenuDenormalizedActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetMenuDenormalizedActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetMenuDenormalizedActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetMenuDenormalizedActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.businessId = reader.string();
                                break;
                            }
                        case 2: {
                                message.locationId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetMenuDenormalizedActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetMenuDenormalizedActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.GetMenuDenormalizedActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.businessId != null && message.hasOwnProperty("businessId")) {
                        properties.subject = 1;
                        if (!$util.isString(message.businessId))
                            return "businessId: string expected";
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId")) {
                        if (properties.subject === 1)
                            return "subject: multiple values";
                        properties.subject = 1;
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    }
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetMenuDenormalizedActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetMenuDenormalizedActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetMenuDenormalizedActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.GetMenuDenormalizedActionProto.Request();
                    if (object.businessId != null)
                        message.businessId = String(object.businessId);
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetMenuDenormalizedActionProto.Request
                 * @static
                 * @param {waiternow.common.GetMenuDenormalizedActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (message.businessId != null && message.hasOwnProperty("businessId")) {
                        object.businessId = message.businessId;
                        if (options.oneofs)
                            object.subject = "businessId";
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId")) {
                        object.locationId = message.locationId;
                        if (options.oneofs)
                            object.subject = "locationId";
                    }
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetMenuDenormalizedActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetMenuDenormalizedActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetMenuDenormalizedActionProto.Request";
                };

                return Request;
            })();

            GetMenuDenormalizedActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.GetMenuDenormalizedActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IMenuProto|null} [menu] Response menu
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.GetMenuDenormalizedActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.GetMenuDenormalizedActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.GetMenuDenormalizedActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response menu.
                 * @member {waiternow.common.IMenuProto|null|undefined} menu
                 * @memberof waiternow.common.GetMenuDenormalizedActionProto.Response
                 * @instance
                 */
                Response.prototype.menu = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetMenuDenormalizedActionProto.Response
                 * @static
                 * @param {waiternow.common.GetMenuDenormalizedActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.GetMenuDenormalizedActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.GetMenuDenormalizedActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetMenuDenormalizedActionProto.Response
                 * @static
                 * @param {waiternow.common.GetMenuDenormalizedActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.menu != null && Object.hasOwnProperty.call(message, "menu"))
                        $root.waiternow.common.MenuProto.encode(message.menu, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.GetMenuDenormalizedActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetMenuDenormalizedActionProto.Response
                 * @static
                 * @param {waiternow.common.GetMenuDenormalizedActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetMenuDenormalizedActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetMenuDenormalizedActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetMenuDenormalizedActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.menu = $root.waiternow.common.MenuProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetMenuDenormalizedActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetMenuDenormalizedActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.GetMenuDenormalizedActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.menu != null && message.hasOwnProperty("menu")) {
                        var error = $root.waiternow.common.MenuProto.verify(message.menu);
                        if (error)
                            return "menu." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetMenuDenormalizedActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetMenuDenormalizedActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetMenuDenormalizedActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.GetMenuDenormalizedActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.GetMenuDenormalizedActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.menu != null) {
                        if (typeof object.menu !== "object")
                            throw TypeError(".waiternow.common.GetMenuDenormalizedActionProto.Response.menu: object expected");
                        message.menu = $root.waiternow.common.MenuProto.fromObject(object.menu);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetMenuDenormalizedActionProto.Response
                 * @static
                 * @param {waiternow.common.GetMenuDenormalizedActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.menu = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.menu != null && message.hasOwnProperty("menu"))
                        object.menu = $root.waiternow.common.MenuProto.toObject(message.menu, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetMenuDenormalizedActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetMenuDenormalizedActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetMenuDenormalizedActionProto.Response";
                };

                return Response;
            })();

            return GetMenuDenormalizedActionProto;
        })();

        common.RemoveDraftOfMenuActionProto = (function() {

            /**
             * Properties of a RemoveDraftOfMenuActionProto.
             * @memberof waiternow.common
             * @interface IRemoveDraftOfMenuActionProto
             */

            /**
             * Constructs a new RemoveDraftOfMenuActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a RemoveDraftOfMenuActionProto.
             * @implements IRemoveDraftOfMenuActionProto
             * @constructor
             * @param {waiternow.common.IRemoveDraftOfMenuActionProto=} [properties] Properties to set
             */
            function RemoveDraftOfMenuActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new RemoveDraftOfMenuActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.RemoveDraftOfMenuActionProto
             * @static
             * @param {waiternow.common.IRemoveDraftOfMenuActionProto=} [properties] Properties to set
             * @returns {waiternow.common.RemoveDraftOfMenuActionProto} RemoveDraftOfMenuActionProto instance
             */
            RemoveDraftOfMenuActionProto.create = function create(properties) {
                return new RemoveDraftOfMenuActionProto(properties);
            };

            /**
             * Encodes the specified RemoveDraftOfMenuActionProto message. Does not implicitly {@link waiternow.common.RemoveDraftOfMenuActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.RemoveDraftOfMenuActionProto
             * @static
             * @param {waiternow.common.IRemoveDraftOfMenuActionProto} message RemoveDraftOfMenuActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RemoveDraftOfMenuActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified RemoveDraftOfMenuActionProto message, length delimited. Does not implicitly {@link waiternow.common.RemoveDraftOfMenuActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.RemoveDraftOfMenuActionProto
             * @static
             * @param {waiternow.common.IRemoveDraftOfMenuActionProto} message RemoveDraftOfMenuActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RemoveDraftOfMenuActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a RemoveDraftOfMenuActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.RemoveDraftOfMenuActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.RemoveDraftOfMenuActionProto} RemoveDraftOfMenuActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RemoveDraftOfMenuActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.RemoveDraftOfMenuActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a RemoveDraftOfMenuActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.RemoveDraftOfMenuActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.RemoveDraftOfMenuActionProto} RemoveDraftOfMenuActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RemoveDraftOfMenuActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a RemoveDraftOfMenuActionProto message.
             * @function verify
             * @memberof waiternow.common.RemoveDraftOfMenuActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            RemoveDraftOfMenuActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a RemoveDraftOfMenuActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.RemoveDraftOfMenuActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.RemoveDraftOfMenuActionProto} RemoveDraftOfMenuActionProto
             */
            RemoveDraftOfMenuActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.RemoveDraftOfMenuActionProto)
                    return object;
                return new $root.waiternow.common.RemoveDraftOfMenuActionProto();
            };

            /**
             * Creates a plain object from a RemoveDraftOfMenuActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.RemoveDraftOfMenuActionProto
             * @static
             * @param {waiternow.common.RemoveDraftOfMenuActionProto} message RemoveDraftOfMenuActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            RemoveDraftOfMenuActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this RemoveDraftOfMenuActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.RemoveDraftOfMenuActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            RemoveDraftOfMenuActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for RemoveDraftOfMenuActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.RemoveDraftOfMenuActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            RemoveDraftOfMenuActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.RemoveDraftOfMenuActionProto";
            };

            RemoveDraftOfMenuActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.RemoveDraftOfMenuActionProto
                 * @interface IRequest
                 * @property {string|null} [businessId] Request businessId
                 * @property {string|null} [locationId] Request locationId
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.RemoveDraftOfMenuActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.RemoveDraftOfMenuActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request businessId.
                 * @member {string|null|undefined} businessId
                 * @memberof waiternow.common.RemoveDraftOfMenuActionProto.Request
                 * @instance
                 */
                Request.prototype.businessId = null;

                /**
                 * Request locationId.
                 * @member {string|null|undefined} locationId
                 * @memberof waiternow.common.RemoveDraftOfMenuActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = null;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * Request subject.
                 * @member {"businessId"|"locationId"|undefined} subject
                 * @memberof waiternow.common.RemoveDraftOfMenuActionProto.Request
                 * @instance
                 */
                Object.defineProperty(Request.prototype, "subject", {
                    get: $util.oneOfGetter($oneOfFields = ["businessId", "locationId"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.RemoveDraftOfMenuActionProto.Request
                 * @static
                 * @param {waiternow.common.RemoveDraftOfMenuActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.RemoveDraftOfMenuActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.RemoveDraftOfMenuActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.RemoveDraftOfMenuActionProto.Request
                 * @static
                 * @param {waiternow.common.RemoveDraftOfMenuActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessId);
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.locationId);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.RemoveDraftOfMenuActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.RemoveDraftOfMenuActionProto.Request
                 * @static
                 * @param {waiternow.common.RemoveDraftOfMenuActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.RemoveDraftOfMenuActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.RemoveDraftOfMenuActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.RemoveDraftOfMenuActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.businessId = reader.string();
                                break;
                            }
                        case 2: {
                                message.locationId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.RemoveDraftOfMenuActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.RemoveDraftOfMenuActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.RemoveDraftOfMenuActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.businessId != null && message.hasOwnProperty("businessId")) {
                        properties.subject = 1;
                        if (!$util.isString(message.businessId))
                            return "businessId: string expected";
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId")) {
                        if (properties.subject === 1)
                            return "subject: multiple values";
                        properties.subject = 1;
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    }
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.RemoveDraftOfMenuActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.RemoveDraftOfMenuActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.RemoveDraftOfMenuActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.RemoveDraftOfMenuActionProto.Request();
                    if (object.businessId != null)
                        message.businessId = String(object.businessId);
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.RemoveDraftOfMenuActionProto.Request
                 * @static
                 * @param {waiternow.common.RemoveDraftOfMenuActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (message.businessId != null && message.hasOwnProperty("businessId")) {
                        object.businessId = message.businessId;
                        if (options.oneofs)
                            object.subject = "businessId";
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId")) {
                        object.locationId = message.locationId;
                        if (options.oneofs)
                            object.subject = "locationId";
                    }
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.RemoveDraftOfMenuActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.RemoveDraftOfMenuActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.RemoveDraftOfMenuActionProto.Request";
                };

                return Request;
            })();

            RemoveDraftOfMenuActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.RemoveDraftOfMenuActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.RemoveDraftOfMenuActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.RemoveDraftOfMenuActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.RemoveDraftOfMenuActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.RemoveDraftOfMenuActionProto.Response
                 * @static
                 * @param {waiternow.common.RemoveDraftOfMenuActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.RemoveDraftOfMenuActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.RemoveDraftOfMenuActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.RemoveDraftOfMenuActionProto.Response
                 * @static
                 * @param {waiternow.common.RemoveDraftOfMenuActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.RemoveDraftOfMenuActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.RemoveDraftOfMenuActionProto.Response
                 * @static
                 * @param {waiternow.common.RemoveDraftOfMenuActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.RemoveDraftOfMenuActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.RemoveDraftOfMenuActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.RemoveDraftOfMenuActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.RemoveDraftOfMenuActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.RemoveDraftOfMenuActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.RemoveDraftOfMenuActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.RemoveDraftOfMenuActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.RemoveDraftOfMenuActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.RemoveDraftOfMenuActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.RemoveDraftOfMenuActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.RemoveDraftOfMenuActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.RemoveDraftOfMenuActionProto.Response
                 * @static
                 * @param {waiternow.common.RemoveDraftOfMenuActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.RemoveDraftOfMenuActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.RemoveDraftOfMenuActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.RemoveDraftOfMenuActionProto.Response";
                };

                return Response;
            })();

            return RemoveDraftOfMenuActionProto;
        })();

        common.RemoveMenuActionProto = (function() {

            /**
             * Properties of a RemoveMenuActionProto.
             * @memberof waiternow.common
             * @interface IRemoveMenuActionProto
             */

            /**
             * Constructs a new RemoveMenuActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a RemoveMenuActionProto.
             * @implements IRemoveMenuActionProto
             * @constructor
             * @param {waiternow.common.IRemoveMenuActionProto=} [properties] Properties to set
             */
            function RemoveMenuActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new RemoveMenuActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.RemoveMenuActionProto
             * @static
             * @param {waiternow.common.IRemoveMenuActionProto=} [properties] Properties to set
             * @returns {waiternow.common.RemoveMenuActionProto} RemoveMenuActionProto instance
             */
            RemoveMenuActionProto.create = function create(properties) {
                return new RemoveMenuActionProto(properties);
            };

            /**
             * Encodes the specified RemoveMenuActionProto message. Does not implicitly {@link waiternow.common.RemoveMenuActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.RemoveMenuActionProto
             * @static
             * @param {waiternow.common.IRemoveMenuActionProto} message RemoveMenuActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RemoveMenuActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified RemoveMenuActionProto message, length delimited. Does not implicitly {@link waiternow.common.RemoveMenuActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.RemoveMenuActionProto
             * @static
             * @param {waiternow.common.IRemoveMenuActionProto} message RemoveMenuActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RemoveMenuActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a RemoveMenuActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.RemoveMenuActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.RemoveMenuActionProto} RemoveMenuActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RemoveMenuActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.RemoveMenuActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a RemoveMenuActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.RemoveMenuActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.RemoveMenuActionProto} RemoveMenuActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RemoveMenuActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a RemoveMenuActionProto message.
             * @function verify
             * @memberof waiternow.common.RemoveMenuActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            RemoveMenuActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a RemoveMenuActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.RemoveMenuActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.RemoveMenuActionProto} RemoveMenuActionProto
             */
            RemoveMenuActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.RemoveMenuActionProto)
                    return object;
                return new $root.waiternow.common.RemoveMenuActionProto();
            };

            /**
             * Creates a plain object from a RemoveMenuActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.RemoveMenuActionProto
             * @static
             * @param {waiternow.common.RemoveMenuActionProto} message RemoveMenuActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            RemoveMenuActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this RemoveMenuActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.RemoveMenuActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            RemoveMenuActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for RemoveMenuActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.RemoveMenuActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            RemoveMenuActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.RemoveMenuActionProto";
            };

            RemoveMenuActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.RemoveMenuActionProto
                 * @interface IRequest
                 * @property {string|null} [businessId] Request businessId
                 * @property {string|null} [locationId] Request locationId
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.RemoveMenuActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.RemoveMenuActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request businessId.
                 * @member {string|null|undefined} businessId
                 * @memberof waiternow.common.RemoveMenuActionProto.Request
                 * @instance
                 */
                Request.prototype.businessId = null;

                /**
                 * Request locationId.
                 * @member {string|null|undefined} locationId
                 * @memberof waiternow.common.RemoveMenuActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = null;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * Request subject.
                 * @member {"businessId"|"locationId"|undefined} subject
                 * @memberof waiternow.common.RemoveMenuActionProto.Request
                 * @instance
                 */
                Object.defineProperty(Request.prototype, "subject", {
                    get: $util.oneOfGetter($oneOfFields = ["businessId", "locationId"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.RemoveMenuActionProto.Request
                 * @static
                 * @param {waiternow.common.RemoveMenuActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.RemoveMenuActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.RemoveMenuActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.RemoveMenuActionProto.Request
                 * @static
                 * @param {waiternow.common.RemoveMenuActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessId);
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.locationId);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.RemoveMenuActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.RemoveMenuActionProto.Request
                 * @static
                 * @param {waiternow.common.RemoveMenuActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.RemoveMenuActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.RemoveMenuActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.RemoveMenuActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.businessId = reader.string();
                                break;
                            }
                        case 2: {
                                message.locationId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.RemoveMenuActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.RemoveMenuActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.RemoveMenuActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.businessId != null && message.hasOwnProperty("businessId")) {
                        properties.subject = 1;
                        if (!$util.isString(message.businessId))
                            return "businessId: string expected";
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId")) {
                        if (properties.subject === 1)
                            return "subject: multiple values";
                        properties.subject = 1;
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    }
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.RemoveMenuActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.RemoveMenuActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.RemoveMenuActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.RemoveMenuActionProto.Request();
                    if (object.businessId != null)
                        message.businessId = String(object.businessId);
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.RemoveMenuActionProto.Request
                 * @static
                 * @param {waiternow.common.RemoveMenuActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (message.businessId != null && message.hasOwnProperty("businessId")) {
                        object.businessId = message.businessId;
                        if (options.oneofs)
                            object.subject = "businessId";
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId")) {
                        object.locationId = message.locationId;
                        if (options.oneofs)
                            object.subject = "locationId";
                    }
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.RemoveMenuActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.RemoveMenuActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.RemoveMenuActionProto.Request";
                };

                return Request;
            })();

            RemoveMenuActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.RemoveMenuActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.RemoveMenuActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.RemoveMenuActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.RemoveMenuActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.RemoveMenuActionProto.Response
                 * @static
                 * @param {waiternow.common.RemoveMenuActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.RemoveMenuActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.RemoveMenuActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.RemoveMenuActionProto.Response
                 * @static
                 * @param {waiternow.common.RemoveMenuActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.RemoveMenuActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.RemoveMenuActionProto.Response
                 * @static
                 * @param {waiternow.common.RemoveMenuActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.RemoveMenuActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.RemoveMenuActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.RemoveMenuActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.RemoveMenuActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.RemoveMenuActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.RemoveMenuActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.RemoveMenuActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.RemoveMenuActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.RemoveMenuActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.RemoveMenuActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.RemoveMenuActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.RemoveMenuActionProto.Response
                 * @static
                 * @param {waiternow.common.RemoveMenuActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.RemoveMenuActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.RemoveMenuActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.RemoveMenuActionProto.Response";
                };

                return Response;
            })();

            return RemoveMenuActionProto;
        })();

        common.GetMenuAvailabilityActionProto = (function() {

            /**
             * Properties of a GetMenuAvailabilityActionProto.
             * @memberof waiternow.common
             * @interface IGetMenuAvailabilityActionProto
             */

            /**
             * Constructs a new GetMenuAvailabilityActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a GetMenuAvailabilityActionProto.
             * @implements IGetMenuAvailabilityActionProto
             * @constructor
             * @param {waiternow.common.IGetMenuAvailabilityActionProto=} [properties] Properties to set
             */
            function GetMenuAvailabilityActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new GetMenuAvailabilityActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.GetMenuAvailabilityActionProto
             * @static
             * @param {waiternow.common.IGetMenuAvailabilityActionProto=} [properties] Properties to set
             * @returns {waiternow.common.GetMenuAvailabilityActionProto} GetMenuAvailabilityActionProto instance
             */
            GetMenuAvailabilityActionProto.create = function create(properties) {
                return new GetMenuAvailabilityActionProto(properties);
            };

            /**
             * Encodes the specified GetMenuAvailabilityActionProto message. Does not implicitly {@link waiternow.common.GetMenuAvailabilityActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.GetMenuAvailabilityActionProto
             * @static
             * @param {waiternow.common.IGetMenuAvailabilityActionProto} message GetMenuAvailabilityActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetMenuAvailabilityActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified GetMenuAvailabilityActionProto message, length delimited. Does not implicitly {@link waiternow.common.GetMenuAvailabilityActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.GetMenuAvailabilityActionProto
             * @static
             * @param {waiternow.common.IGetMenuAvailabilityActionProto} message GetMenuAvailabilityActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetMenuAvailabilityActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetMenuAvailabilityActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.GetMenuAvailabilityActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.GetMenuAvailabilityActionProto} GetMenuAvailabilityActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetMenuAvailabilityActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetMenuAvailabilityActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetMenuAvailabilityActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.GetMenuAvailabilityActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.GetMenuAvailabilityActionProto} GetMenuAvailabilityActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetMenuAvailabilityActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetMenuAvailabilityActionProto message.
             * @function verify
             * @memberof waiternow.common.GetMenuAvailabilityActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetMenuAvailabilityActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a GetMenuAvailabilityActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.GetMenuAvailabilityActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.GetMenuAvailabilityActionProto} GetMenuAvailabilityActionProto
             */
            GetMenuAvailabilityActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.GetMenuAvailabilityActionProto)
                    return object;
                return new $root.waiternow.common.GetMenuAvailabilityActionProto();
            };

            /**
             * Creates a plain object from a GetMenuAvailabilityActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.GetMenuAvailabilityActionProto
             * @static
             * @param {waiternow.common.GetMenuAvailabilityActionProto} message GetMenuAvailabilityActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetMenuAvailabilityActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this GetMenuAvailabilityActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.GetMenuAvailabilityActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetMenuAvailabilityActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for GetMenuAvailabilityActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.GetMenuAvailabilityActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            GetMenuAvailabilityActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.GetMenuAvailabilityActionProto";
            };

            GetMenuAvailabilityActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.GetMenuAvailabilityActionProto
                 * @interface IRequest
                 * @property {string|null} [locationId] Request locationId
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.GetMenuAvailabilityActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.GetMenuAvailabilityActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.GetMenuAvailabilityActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetMenuAvailabilityActionProto.Request
                 * @static
                 * @param {waiternow.common.GetMenuAvailabilityActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.GetMenuAvailabilityActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.GetMenuAvailabilityActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetMenuAvailabilityActionProto.Request
                 * @static
                 * @param {waiternow.common.GetMenuAvailabilityActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.GetMenuAvailabilityActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetMenuAvailabilityActionProto.Request
                 * @static
                 * @param {waiternow.common.GetMenuAvailabilityActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetMenuAvailabilityActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetMenuAvailabilityActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetMenuAvailabilityActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetMenuAvailabilityActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetMenuAvailabilityActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.GetMenuAvailabilityActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetMenuAvailabilityActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetMenuAvailabilityActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetMenuAvailabilityActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.GetMenuAvailabilityActionProto.Request();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetMenuAvailabilityActionProto.Request
                 * @static
                 * @param {waiternow.common.GetMenuAvailabilityActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.locationId = "";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetMenuAvailabilityActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetMenuAvailabilityActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetMenuAvailabilityActionProto.Request";
                };

                return Request;
            })();

            GetMenuAvailabilityActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.GetMenuAvailabilityActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {Array.<waiternow.common.IMenuEntryAvailabilityProto>|null} [menuEntriesAvailability] Response menuEntriesAvailability
                 * @property {Array.<waiternow.common.IItemAvailabilityProto>|null} [itemsAvailability] Response itemsAvailability
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.GetMenuAvailabilityActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.GetMenuAvailabilityActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    this.menuEntriesAvailability = [];
                    this.itemsAvailability = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.GetMenuAvailabilityActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response menuEntriesAvailability.
                 * @member {Array.<waiternow.common.IMenuEntryAvailabilityProto>} menuEntriesAvailability
                 * @memberof waiternow.common.GetMenuAvailabilityActionProto.Response
                 * @instance
                 */
                Response.prototype.menuEntriesAvailability = $util.emptyArray;

                /**
                 * Response itemsAvailability.
                 * @member {Array.<waiternow.common.IItemAvailabilityProto>} itemsAvailability
                 * @memberof waiternow.common.GetMenuAvailabilityActionProto.Response
                 * @instance
                 */
                Response.prototype.itemsAvailability = $util.emptyArray;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetMenuAvailabilityActionProto.Response
                 * @static
                 * @param {waiternow.common.GetMenuAvailabilityActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.GetMenuAvailabilityActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.GetMenuAvailabilityActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetMenuAvailabilityActionProto.Response
                 * @static
                 * @param {waiternow.common.GetMenuAvailabilityActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.menuEntriesAvailability != null && message.menuEntriesAvailability.length)
                        for (var i = 0; i < message.menuEntriesAvailability.length; ++i)
                            $root.waiternow.common.MenuEntryAvailabilityProto.encode(message.menuEntriesAvailability[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.itemsAvailability != null && message.itemsAvailability.length)
                        for (var i = 0; i < message.itemsAvailability.length; ++i)
                            $root.waiternow.common.ItemAvailabilityProto.encode(message.itemsAvailability[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.GetMenuAvailabilityActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetMenuAvailabilityActionProto.Response
                 * @static
                 * @param {waiternow.common.GetMenuAvailabilityActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetMenuAvailabilityActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetMenuAvailabilityActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetMenuAvailabilityActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                if (!(message.menuEntriesAvailability && message.menuEntriesAvailability.length))
                                    message.menuEntriesAvailability = [];
                                message.menuEntriesAvailability.push($root.waiternow.common.MenuEntryAvailabilityProto.decode(reader, reader.uint32()));
                                break;
                            }
                        case 3: {
                                if (!(message.itemsAvailability && message.itemsAvailability.length))
                                    message.itemsAvailability = [];
                                message.itemsAvailability.push($root.waiternow.common.ItemAvailabilityProto.decode(reader, reader.uint32()));
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetMenuAvailabilityActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetMenuAvailabilityActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.GetMenuAvailabilityActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.menuEntriesAvailability != null && message.hasOwnProperty("menuEntriesAvailability")) {
                        if (!Array.isArray(message.menuEntriesAvailability))
                            return "menuEntriesAvailability: array expected";
                        for (var i = 0; i < message.menuEntriesAvailability.length; ++i) {
                            var error = $root.waiternow.common.MenuEntryAvailabilityProto.verify(message.menuEntriesAvailability[i]);
                            if (error)
                                return "menuEntriesAvailability." + error;
                        }
                    }
                    if (message.itemsAvailability != null && message.hasOwnProperty("itemsAvailability")) {
                        if (!Array.isArray(message.itemsAvailability))
                            return "itemsAvailability: array expected";
                        for (var i = 0; i < message.itemsAvailability.length; ++i) {
                            var error = $root.waiternow.common.ItemAvailabilityProto.verify(message.itemsAvailability[i]);
                            if (error)
                                return "itemsAvailability." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetMenuAvailabilityActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetMenuAvailabilityActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetMenuAvailabilityActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.GetMenuAvailabilityActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.GetMenuAvailabilityActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.menuEntriesAvailability) {
                        if (!Array.isArray(object.menuEntriesAvailability))
                            throw TypeError(".waiternow.common.GetMenuAvailabilityActionProto.Response.menuEntriesAvailability: array expected");
                        message.menuEntriesAvailability = [];
                        for (var i = 0; i < object.menuEntriesAvailability.length; ++i) {
                            if (typeof object.menuEntriesAvailability[i] !== "object")
                                throw TypeError(".waiternow.common.GetMenuAvailabilityActionProto.Response.menuEntriesAvailability: object expected");
                            message.menuEntriesAvailability[i] = $root.waiternow.common.MenuEntryAvailabilityProto.fromObject(object.menuEntriesAvailability[i]);
                        }
                    }
                    if (object.itemsAvailability) {
                        if (!Array.isArray(object.itemsAvailability))
                            throw TypeError(".waiternow.common.GetMenuAvailabilityActionProto.Response.itemsAvailability: array expected");
                        message.itemsAvailability = [];
                        for (var i = 0; i < object.itemsAvailability.length; ++i) {
                            if (typeof object.itemsAvailability[i] !== "object")
                                throw TypeError(".waiternow.common.GetMenuAvailabilityActionProto.Response.itemsAvailability: object expected");
                            message.itemsAvailability[i] = $root.waiternow.common.ItemAvailabilityProto.fromObject(object.itemsAvailability[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetMenuAvailabilityActionProto.Response
                 * @static
                 * @param {waiternow.common.GetMenuAvailabilityActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.menuEntriesAvailability = [];
                        object.itemsAvailability = [];
                    }
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.menuEntriesAvailability && message.menuEntriesAvailability.length) {
                        object.menuEntriesAvailability = [];
                        for (var j = 0; j < message.menuEntriesAvailability.length; ++j)
                            object.menuEntriesAvailability[j] = $root.waiternow.common.MenuEntryAvailabilityProto.toObject(message.menuEntriesAvailability[j], options);
                    }
                    if (message.itemsAvailability && message.itemsAvailability.length) {
                        object.itemsAvailability = [];
                        for (var j = 0; j < message.itemsAvailability.length; ++j)
                            object.itemsAvailability[j] = $root.waiternow.common.ItemAvailabilityProto.toObject(message.itemsAvailability[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetMenuAvailabilityActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetMenuAvailabilityActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetMenuAvailabilityActionProto.Response";
                };

                return Response;
            })();

            return GetMenuAvailabilityActionProto;
        })();

        common.UpdateMenuAvailabilityActionProto = (function() {

            /**
             * Properties of an UpdateMenuAvailabilityActionProto.
             * @memberof waiternow.common
             * @interface IUpdateMenuAvailabilityActionProto
             */

            /**
             * Constructs a new UpdateMenuAvailabilityActionProto.
             * @memberof waiternow.common
             * @classdesc Represents an UpdateMenuAvailabilityActionProto.
             * @implements IUpdateMenuAvailabilityActionProto
             * @constructor
             * @param {waiternow.common.IUpdateMenuAvailabilityActionProto=} [properties] Properties to set
             */
            function UpdateMenuAvailabilityActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new UpdateMenuAvailabilityActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.UpdateMenuAvailabilityActionProto
             * @static
             * @param {waiternow.common.IUpdateMenuAvailabilityActionProto=} [properties] Properties to set
             * @returns {waiternow.common.UpdateMenuAvailabilityActionProto} UpdateMenuAvailabilityActionProto instance
             */
            UpdateMenuAvailabilityActionProto.create = function create(properties) {
                return new UpdateMenuAvailabilityActionProto(properties);
            };

            /**
             * Encodes the specified UpdateMenuAvailabilityActionProto message. Does not implicitly {@link waiternow.common.UpdateMenuAvailabilityActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.UpdateMenuAvailabilityActionProto
             * @static
             * @param {waiternow.common.IUpdateMenuAvailabilityActionProto} message UpdateMenuAvailabilityActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UpdateMenuAvailabilityActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified UpdateMenuAvailabilityActionProto message, length delimited. Does not implicitly {@link waiternow.common.UpdateMenuAvailabilityActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.UpdateMenuAvailabilityActionProto
             * @static
             * @param {waiternow.common.IUpdateMenuAvailabilityActionProto} message UpdateMenuAvailabilityActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UpdateMenuAvailabilityActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an UpdateMenuAvailabilityActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.UpdateMenuAvailabilityActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.UpdateMenuAvailabilityActionProto} UpdateMenuAvailabilityActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UpdateMenuAvailabilityActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.UpdateMenuAvailabilityActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an UpdateMenuAvailabilityActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.UpdateMenuAvailabilityActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.UpdateMenuAvailabilityActionProto} UpdateMenuAvailabilityActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UpdateMenuAvailabilityActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an UpdateMenuAvailabilityActionProto message.
             * @function verify
             * @memberof waiternow.common.UpdateMenuAvailabilityActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            UpdateMenuAvailabilityActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates an UpdateMenuAvailabilityActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.UpdateMenuAvailabilityActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.UpdateMenuAvailabilityActionProto} UpdateMenuAvailabilityActionProto
             */
            UpdateMenuAvailabilityActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.UpdateMenuAvailabilityActionProto)
                    return object;
                return new $root.waiternow.common.UpdateMenuAvailabilityActionProto();
            };

            /**
             * Creates a plain object from an UpdateMenuAvailabilityActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.UpdateMenuAvailabilityActionProto
             * @static
             * @param {waiternow.common.UpdateMenuAvailabilityActionProto} message UpdateMenuAvailabilityActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            UpdateMenuAvailabilityActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this UpdateMenuAvailabilityActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.UpdateMenuAvailabilityActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            UpdateMenuAvailabilityActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for UpdateMenuAvailabilityActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.UpdateMenuAvailabilityActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            UpdateMenuAvailabilityActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.UpdateMenuAvailabilityActionProto";
            };

            UpdateMenuAvailabilityActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.UpdateMenuAvailabilityActionProto
                 * @interface IRequest
                 * @property {string|null} [locationId] Request locationId
                 * @property {Array.<waiternow.common.IMenuEntryAvailabilityProto>|null} [menuEntriesAvailability] Request menuEntriesAvailability
                 * @property {Array.<waiternow.common.IItemAvailabilityProto>|null} [itemsAvailability] Request itemsAvailability
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.UpdateMenuAvailabilityActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.UpdateMenuAvailabilityActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    this.menuEntriesAvailability = [];
                    this.itemsAvailability = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.UpdateMenuAvailabilityActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = "";

                /**
                 * Request menuEntriesAvailability.
                 * @member {Array.<waiternow.common.IMenuEntryAvailabilityProto>} menuEntriesAvailability
                 * @memberof waiternow.common.UpdateMenuAvailabilityActionProto.Request
                 * @instance
                 */
                Request.prototype.menuEntriesAvailability = $util.emptyArray;

                /**
                 * Request itemsAvailability.
                 * @member {Array.<waiternow.common.IItemAvailabilityProto>} itemsAvailability
                 * @memberof waiternow.common.UpdateMenuAvailabilityActionProto.Request
                 * @instance
                 */
                Request.prototype.itemsAvailability = $util.emptyArray;

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.UpdateMenuAvailabilityActionProto.Request
                 * @static
                 * @param {waiternow.common.UpdateMenuAvailabilityActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.UpdateMenuAvailabilityActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.UpdateMenuAvailabilityActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.UpdateMenuAvailabilityActionProto.Request
                 * @static
                 * @param {waiternow.common.UpdateMenuAvailabilityActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    if (message.menuEntriesAvailability != null && message.menuEntriesAvailability.length)
                        for (var i = 0; i < message.menuEntriesAvailability.length; ++i)
                            $root.waiternow.common.MenuEntryAvailabilityProto.encode(message.menuEntriesAvailability[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.itemsAvailability != null && message.itemsAvailability.length)
                        for (var i = 0; i < message.itemsAvailability.length; ++i)
                            $root.waiternow.common.ItemAvailabilityProto.encode(message.itemsAvailability[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.UpdateMenuAvailabilityActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.UpdateMenuAvailabilityActionProto.Request
                 * @static
                 * @param {waiternow.common.UpdateMenuAvailabilityActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.UpdateMenuAvailabilityActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.UpdateMenuAvailabilityActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.UpdateMenuAvailabilityActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 2: {
                                if (!(message.menuEntriesAvailability && message.menuEntriesAvailability.length))
                                    message.menuEntriesAvailability = [];
                                message.menuEntriesAvailability.push($root.waiternow.common.MenuEntryAvailabilityProto.decode(reader, reader.uint32()));
                                break;
                            }
                        case 3: {
                                if (!(message.itemsAvailability && message.itemsAvailability.length))
                                    message.itemsAvailability = [];
                                message.itemsAvailability.push($root.waiternow.common.ItemAvailabilityProto.decode(reader, reader.uint32()));
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.UpdateMenuAvailabilityActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.UpdateMenuAvailabilityActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.UpdateMenuAvailabilityActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    if (message.menuEntriesAvailability != null && message.hasOwnProperty("menuEntriesAvailability")) {
                        if (!Array.isArray(message.menuEntriesAvailability))
                            return "menuEntriesAvailability: array expected";
                        for (var i = 0; i < message.menuEntriesAvailability.length; ++i) {
                            var error = $root.waiternow.common.MenuEntryAvailabilityProto.verify(message.menuEntriesAvailability[i]);
                            if (error)
                                return "menuEntriesAvailability." + error;
                        }
                    }
                    if (message.itemsAvailability != null && message.hasOwnProperty("itemsAvailability")) {
                        if (!Array.isArray(message.itemsAvailability))
                            return "itemsAvailability: array expected";
                        for (var i = 0; i < message.itemsAvailability.length; ++i) {
                            var error = $root.waiternow.common.ItemAvailabilityProto.verify(message.itemsAvailability[i]);
                            if (error)
                                return "itemsAvailability." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.UpdateMenuAvailabilityActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.UpdateMenuAvailabilityActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.UpdateMenuAvailabilityActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.UpdateMenuAvailabilityActionProto.Request();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    if (object.menuEntriesAvailability) {
                        if (!Array.isArray(object.menuEntriesAvailability))
                            throw TypeError(".waiternow.common.UpdateMenuAvailabilityActionProto.Request.menuEntriesAvailability: array expected");
                        message.menuEntriesAvailability = [];
                        for (var i = 0; i < object.menuEntriesAvailability.length; ++i) {
                            if (typeof object.menuEntriesAvailability[i] !== "object")
                                throw TypeError(".waiternow.common.UpdateMenuAvailabilityActionProto.Request.menuEntriesAvailability: object expected");
                            message.menuEntriesAvailability[i] = $root.waiternow.common.MenuEntryAvailabilityProto.fromObject(object.menuEntriesAvailability[i]);
                        }
                    }
                    if (object.itemsAvailability) {
                        if (!Array.isArray(object.itemsAvailability))
                            throw TypeError(".waiternow.common.UpdateMenuAvailabilityActionProto.Request.itemsAvailability: array expected");
                        message.itemsAvailability = [];
                        for (var i = 0; i < object.itemsAvailability.length; ++i) {
                            if (typeof object.itemsAvailability[i] !== "object")
                                throw TypeError(".waiternow.common.UpdateMenuAvailabilityActionProto.Request.itemsAvailability: object expected");
                            message.itemsAvailability[i] = $root.waiternow.common.ItemAvailabilityProto.fromObject(object.itemsAvailability[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.UpdateMenuAvailabilityActionProto.Request
                 * @static
                 * @param {waiternow.common.UpdateMenuAvailabilityActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.menuEntriesAvailability = [];
                        object.itemsAvailability = [];
                    }
                    if (options.defaults)
                        object.locationId = "";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    if (message.menuEntriesAvailability && message.menuEntriesAvailability.length) {
                        object.menuEntriesAvailability = [];
                        for (var j = 0; j < message.menuEntriesAvailability.length; ++j)
                            object.menuEntriesAvailability[j] = $root.waiternow.common.MenuEntryAvailabilityProto.toObject(message.menuEntriesAvailability[j], options);
                    }
                    if (message.itemsAvailability && message.itemsAvailability.length) {
                        object.itemsAvailability = [];
                        for (var j = 0; j < message.itemsAvailability.length; ++j)
                            object.itemsAvailability[j] = $root.waiternow.common.ItemAvailabilityProto.toObject(message.itemsAvailability[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.UpdateMenuAvailabilityActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.UpdateMenuAvailabilityActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.UpdateMenuAvailabilityActionProto.Request";
                };

                return Request;
            })();

            UpdateMenuAvailabilityActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.UpdateMenuAvailabilityActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.UpdateMenuAvailabilityActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.UpdateMenuAvailabilityActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.UpdateMenuAvailabilityActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.UpdateMenuAvailabilityActionProto.Response
                 * @static
                 * @param {waiternow.common.UpdateMenuAvailabilityActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.UpdateMenuAvailabilityActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.UpdateMenuAvailabilityActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.UpdateMenuAvailabilityActionProto.Response
                 * @static
                 * @param {waiternow.common.UpdateMenuAvailabilityActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.UpdateMenuAvailabilityActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.UpdateMenuAvailabilityActionProto.Response
                 * @static
                 * @param {waiternow.common.UpdateMenuAvailabilityActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.UpdateMenuAvailabilityActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.UpdateMenuAvailabilityActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.UpdateMenuAvailabilityActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.UpdateMenuAvailabilityActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.UpdateMenuAvailabilityActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.UpdateMenuAvailabilityActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.UpdateMenuAvailabilityActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.UpdateMenuAvailabilityActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.UpdateMenuAvailabilityActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.UpdateMenuAvailabilityActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.UpdateMenuAvailabilityActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.UpdateMenuAvailabilityActionProto.Response
                 * @static
                 * @param {waiternow.common.UpdateMenuAvailabilityActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.UpdateMenuAvailabilityActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.UpdateMenuAvailabilityActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.UpdateMenuAvailabilityActionProto.Response";
                };

                return Response;
            })();

            return UpdateMenuAvailabilityActionProto;
        })();

        common.DenormalizeMenuActionProto = (function() {

            /**
             * Properties of a DenormalizeMenuActionProto.
             * @memberof waiternow.common
             * @interface IDenormalizeMenuActionProto
             */

            /**
             * Constructs a new DenormalizeMenuActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a DenormalizeMenuActionProto.
             * @implements IDenormalizeMenuActionProto
             * @constructor
             * @param {waiternow.common.IDenormalizeMenuActionProto=} [properties] Properties to set
             */
            function DenormalizeMenuActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new DenormalizeMenuActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.DenormalizeMenuActionProto
             * @static
             * @param {waiternow.common.IDenormalizeMenuActionProto=} [properties] Properties to set
             * @returns {waiternow.common.DenormalizeMenuActionProto} DenormalizeMenuActionProto instance
             */
            DenormalizeMenuActionProto.create = function create(properties) {
                return new DenormalizeMenuActionProto(properties);
            };

            /**
             * Encodes the specified DenormalizeMenuActionProto message. Does not implicitly {@link waiternow.common.DenormalizeMenuActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.DenormalizeMenuActionProto
             * @static
             * @param {waiternow.common.IDenormalizeMenuActionProto} message DenormalizeMenuActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DenormalizeMenuActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified DenormalizeMenuActionProto message, length delimited. Does not implicitly {@link waiternow.common.DenormalizeMenuActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.DenormalizeMenuActionProto
             * @static
             * @param {waiternow.common.IDenormalizeMenuActionProto} message DenormalizeMenuActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DenormalizeMenuActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a DenormalizeMenuActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.DenormalizeMenuActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.DenormalizeMenuActionProto} DenormalizeMenuActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DenormalizeMenuActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.DenormalizeMenuActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a DenormalizeMenuActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.DenormalizeMenuActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.DenormalizeMenuActionProto} DenormalizeMenuActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DenormalizeMenuActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a DenormalizeMenuActionProto message.
             * @function verify
             * @memberof waiternow.common.DenormalizeMenuActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            DenormalizeMenuActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a DenormalizeMenuActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.DenormalizeMenuActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.DenormalizeMenuActionProto} DenormalizeMenuActionProto
             */
            DenormalizeMenuActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.DenormalizeMenuActionProto)
                    return object;
                return new $root.waiternow.common.DenormalizeMenuActionProto();
            };

            /**
             * Creates a plain object from a DenormalizeMenuActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.DenormalizeMenuActionProto
             * @static
             * @param {waiternow.common.DenormalizeMenuActionProto} message DenormalizeMenuActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            DenormalizeMenuActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this DenormalizeMenuActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.DenormalizeMenuActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            DenormalizeMenuActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for DenormalizeMenuActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.DenormalizeMenuActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            DenormalizeMenuActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.DenormalizeMenuActionProto";
            };

            DenormalizeMenuActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.DenormalizeMenuActionProto
                 * @interface IRequest
                 * @property {waiternow.common.IMenuSpecProto|null} [menu] Request menu
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.DenormalizeMenuActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.DenormalizeMenuActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request menu.
                 * @member {waiternow.common.IMenuSpecProto|null|undefined} menu
                 * @memberof waiternow.common.DenormalizeMenuActionProto.Request
                 * @instance
                 */
                Request.prototype.menu = null;

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.DenormalizeMenuActionProto.Request
                 * @static
                 * @param {waiternow.common.DenormalizeMenuActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.DenormalizeMenuActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.DenormalizeMenuActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.DenormalizeMenuActionProto.Request
                 * @static
                 * @param {waiternow.common.DenormalizeMenuActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.menu != null && Object.hasOwnProperty.call(message, "menu"))
                        $root.waiternow.common.MenuSpecProto.encode(message.menu, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.DenormalizeMenuActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.DenormalizeMenuActionProto.Request
                 * @static
                 * @param {waiternow.common.DenormalizeMenuActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.DenormalizeMenuActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.DenormalizeMenuActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.DenormalizeMenuActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.menu = $root.waiternow.common.MenuSpecProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.DenormalizeMenuActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.DenormalizeMenuActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.DenormalizeMenuActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.menu != null && message.hasOwnProperty("menu")) {
                        var error = $root.waiternow.common.MenuSpecProto.verify(message.menu);
                        if (error)
                            return "menu." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.DenormalizeMenuActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.DenormalizeMenuActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.DenormalizeMenuActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.DenormalizeMenuActionProto.Request();
                    if (object.menu != null) {
                        if (typeof object.menu !== "object")
                            throw TypeError(".waiternow.common.DenormalizeMenuActionProto.Request.menu: object expected");
                        message.menu = $root.waiternow.common.MenuSpecProto.fromObject(object.menu);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.DenormalizeMenuActionProto.Request
                 * @static
                 * @param {waiternow.common.DenormalizeMenuActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.menu = null;
                    if (message.menu != null && message.hasOwnProperty("menu"))
                        object.menu = $root.waiternow.common.MenuSpecProto.toObject(message.menu, options);
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.DenormalizeMenuActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.DenormalizeMenuActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.DenormalizeMenuActionProto.Request";
                };

                return Request;
            })();

            DenormalizeMenuActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.DenormalizeMenuActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IMenuProto|null} [menu] Response menu
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.DenormalizeMenuActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.DenormalizeMenuActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.DenormalizeMenuActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response menu.
                 * @member {waiternow.common.IMenuProto|null|undefined} menu
                 * @memberof waiternow.common.DenormalizeMenuActionProto.Response
                 * @instance
                 */
                Response.prototype.menu = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.DenormalizeMenuActionProto.Response
                 * @static
                 * @param {waiternow.common.DenormalizeMenuActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.DenormalizeMenuActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.DenormalizeMenuActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.DenormalizeMenuActionProto.Response
                 * @static
                 * @param {waiternow.common.DenormalizeMenuActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.menu != null && Object.hasOwnProperty.call(message, "menu"))
                        $root.waiternow.common.MenuProto.encode(message.menu, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.DenormalizeMenuActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.DenormalizeMenuActionProto.Response
                 * @static
                 * @param {waiternow.common.DenormalizeMenuActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.DenormalizeMenuActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.DenormalizeMenuActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.DenormalizeMenuActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.menu = $root.waiternow.common.MenuProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.DenormalizeMenuActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.DenormalizeMenuActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.DenormalizeMenuActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.menu != null && message.hasOwnProperty("menu")) {
                        var error = $root.waiternow.common.MenuProto.verify(message.menu);
                        if (error)
                            return "menu." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.DenormalizeMenuActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.DenormalizeMenuActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.DenormalizeMenuActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.DenormalizeMenuActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.DenormalizeMenuActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.menu != null) {
                        if (typeof object.menu !== "object")
                            throw TypeError(".waiternow.common.DenormalizeMenuActionProto.Response.menu: object expected");
                        message.menu = $root.waiternow.common.MenuProto.fromObject(object.menu);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.DenormalizeMenuActionProto.Response
                 * @static
                 * @param {waiternow.common.DenormalizeMenuActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.menu = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.menu != null && message.hasOwnProperty("menu"))
                        object.menu = $root.waiternow.common.MenuProto.toObject(message.menu, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.DenormalizeMenuActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.DenormalizeMenuActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.DenormalizeMenuActionProto.Response";
                };

                return Response;
            })();

            return DenormalizeMenuActionProto;
        })();

        common.CheckMenuAvailabilityActionProto = (function() {

            /**
             * Properties of a CheckMenuAvailabilityActionProto.
             * @memberof waiternow.common
             * @interface ICheckMenuAvailabilityActionProto
             */

            /**
             * Constructs a new CheckMenuAvailabilityActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a CheckMenuAvailabilityActionProto.
             * @implements ICheckMenuAvailabilityActionProto
             * @constructor
             * @param {waiternow.common.ICheckMenuAvailabilityActionProto=} [properties] Properties to set
             */
            function CheckMenuAvailabilityActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new CheckMenuAvailabilityActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.CheckMenuAvailabilityActionProto
             * @static
             * @param {waiternow.common.ICheckMenuAvailabilityActionProto=} [properties] Properties to set
             * @returns {waiternow.common.CheckMenuAvailabilityActionProto} CheckMenuAvailabilityActionProto instance
             */
            CheckMenuAvailabilityActionProto.create = function create(properties) {
                return new CheckMenuAvailabilityActionProto(properties);
            };

            /**
             * Encodes the specified CheckMenuAvailabilityActionProto message. Does not implicitly {@link waiternow.common.CheckMenuAvailabilityActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.CheckMenuAvailabilityActionProto
             * @static
             * @param {waiternow.common.ICheckMenuAvailabilityActionProto} message CheckMenuAvailabilityActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CheckMenuAvailabilityActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified CheckMenuAvailabilityActionProto message, length delimited. Does not implicitly {@link waiternow.common.CheckMenuAvailabilityActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.CheckMenuAvailabilityActionProto
             * @static
             * @param {waiternow.common.ICheckMenuAvailabilityActionProto} message CheckMenuAvailabilityActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CheckMenuAvailabilityActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CheckMenuAvailabilityActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.CheckMenuAvailabilityActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.CheckMenuAvailabilityActionProto} CheckMenuAvailabilityActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CheckMenuAvailabilityActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CheckMenuAvailabilityActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CheckMenuAvailabilityActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.CheckMenuAvailabilityActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.CheckMenuAvailabilityActionProto} CheckMenuAvailabilityActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CheckMenuAvailabilityActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CheckMenuAvailabilityActionProto message.
             * @function verify
             * @memberof waiternow.common.CheckMenuAvailabilityActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CheckMenuAvailabilityActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a CheckMenuAvailabilityActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.CheckMenuAvailabilityActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.CheckMenuAvailabilityActionProto} CheckMenuAvailabilityActionProto
             */
            CheckMenuAvailabilityActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.CheckMenuAvailabilityActionProto)
                    return object;
                return new $root.waiternow.common.CheckMenuAvailabilityActionProto();
            };

            /**
             * Creates a plain object from a CheckMenuAvailabilityActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.CheckMenuAvailabilityActionProto
             * @static
             * @param {waiternow.common.CheckMenuAvailabilityActionProto} message CheckMenuAvailabilityActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CheckMenuAvailabilityActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this CheckMenuAvailabilityActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.CheckMenuAvailabilityActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CheckMenuAvailabilityActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for CheckMenuAvailabilityActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.CheckMenuAvailabilityActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            CheckMenuAvailabilityActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.CheckMenuAvailabilityActionProto";
            };

            CheckMenuAvailabilityActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.CheckMenuAvailabilityActionProto
                 * @interface IRequest
                 * @property {string|null} [locationId] Request locationId
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.CheckMenuAvailabilityActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.CheckMenuAvailabilityActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.CheckMenuAvailabilityActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.CheckMenuAvailabilityActionProto.Request
                 * @static
                 * @param {waiternow.common.CheckMenuAvailabilityActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.CheckMenuAvailabilityActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.CheckMenuAvailabilityActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.CheckMenuAvailabilityActionProto.Request
                 * @static
                 * @param {waiternow.common.CheckMenuAvailabilityActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.CheckMenuAvailabilityActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.CheckMenuAvailabilityActionProto.Request
                 * @static
                 * @param {waiternow.common.CheckMenuAvailabilityActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.CheckMenuAvailabilityActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.CheckMenuAvailabilityActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CheckMenuAvailabilityActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.CheckMenuAvailabilityActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.CheckMenuAvailabilityActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.CheckMenuAvailabilityActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.CheckMenuAvailabilityActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.CheckMenuAvailabilityActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.CheckMenuAvailabilityActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.CheckMenuAvailabilityActionProto.Request();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.CheckMenuAvailabilityActionProto.Request
                 * @static
                 * @param {waiternow.common.CheckMenuAvailabilityActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.locationId = "";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.CheckMenuAvailabilityActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.CheckMenuAvailabilityActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.CheckMenuAvailabilityActionProto.Request";
                };

                return Request;
            })();

            CheckMenuAvailabilityActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.CheckMenuAvailabilityActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {boolean|null} [hasUnavailableElements] Response hasUnavailableElements
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.CheckMenuAvailabilityActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.CheckMenuAvailabilityActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.CheckMenuAvailabilityActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response hasUnavailableElements.
                 * @member {boolean} hasUnavailableElements
                 * @memberof waiternow.common.CheckMenuAvailabilityActionProto.Response
                 * @instance
                 */
                Response.prototype.hasUnavailableElements = false;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.CheckMenuAvailabilityActionProto.Response
                 * @static
                 * @param {waiternow.common.CheckMenuAvailabilityActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.CheckMenuAvailabilityActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.CheckMenuAvailabilityActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.CheckMenuAvailabilityActionProto.Response
                 * @static
                 * @param {waiternow.common.CheckMenuAvailabilityActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.hasUnavailableElements != null && Object.hasOwnProperty.call(message, "hasUnavailableElements"))
                        writer.uint32(/* id 2, wireType 0 =*/16).bool(message.hasUnavailableElements);
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.CheckMenuAvailabilityActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.CheckMenuAvailabilityActionProto.Response
                 * @static
                 * @param {waiternow.common.CheckMenuAvailabilityActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.CheckMenuAvailabilityActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.CheckMenuAvailabilityActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CheckMenuAvailabilityActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.hasUnavailableElements = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.CheckMenuAvailabilityActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.CheckMenuAvailabilityActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.CheckMenuAvailabilityActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.hasUnavailableElements != null && message.hasOwnProperty("hasUnavailableElements"))
                        if (typeof message.hasUnavailableElements !== "boolean")
                            return "hasUnavailableElements: boolean expected";
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.CheckMenuAvailabilityActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.CheckMenuAvailabilityActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.CheckMenuAvailabilityActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.CheckMenuAvailabilityActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.CheckMenuAvailabilityActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.hasUnavailableElements != null)
                        message.hasUnavailableElements = Boolean(object.hasUnavailableElements);
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.CheckMenuAvailabilityActionProto.Response
                 * @static
                 * @param {waiternow.common.CheckMenuAvailabilityActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.hasUnavailableElements = false;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.hasUnavailableElements != null && message.hasOwnProperty("hasUnavailableElements"))
                        object.hasUnavailableElements = message.hasUnavailableElements;
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.CheckMenuAvailabilityActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.CheckMenuAvailabilityActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.CheckMenuAvailabilityActionProto.Response";
                };

                return Response;
            })();

            return CheckMenuAvailabilityActionProto;
        })();

        common.CreatePointOfServiceActionProto = (function() {

            /**
             * Properties of a CreatePointOfServiceActionProto.
             * @memberof waiternow.common
             * @interface ICreatePointOfServiceActionProto
             */

            /**
             * Constructs a new CreatePointOfServiceActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a CreatePointOfServiceActionProto.
             * @implements ICreatePointOfServiceActionProto
             * @constructor
             * @param {waiternow.common.ICreatePointOfServiceActionProto=} [properties] Properties to set
             */
            function CreatePointOfServiceActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new CreatePointOfServiceActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.CreatePointOfServiceActionProto
             * @static
             * @param {waiternow.common.ICreatePointOfServiceActionProto=} [properties] Properties to set
             * @returns {waiternow.common.CreatePointOfServiceActionProto} CreatePointOfServiceActionProto instance
             */
            CreatePointOfServiceActionProto.create = function create(properties) {
                return new CreatePointOfServiceActionProto(properties);
            };

            /**
             * Encodes the specified CreatePointOfServiceActionProto message. Does not implicitly {@link waiternow.common.CreatePointOfServiceActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.CreatePointOfServiceActionProto
             * @static
             * @param {waiternow.common.ICreatePointOfServiceActionProto} message CreatePointOfServiceActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CreatePointOfServiceActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified CreatePointOfServiceActionProto message, length delimited. Does not implicitly {@link waiternow.common.CreatePointOfServiceActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.CreatePointOfServiceActionProto
             * @static
             * @param {waiternow.common.ICreatePointOfServiceActionProto} message CreatePointOfServiceActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CreatePointOfServiceActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CreatePointOfServiceActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.CreatePointOfServiceActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.CreatePointOfServiceActionProto} CreatePointOfServiceActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CreatePointOfServiceActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CreatePointOfServiceActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CreatePointOfServiceActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.CreatePointOfServiceActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.CreatePointOfServiceActionProto} CreatePointOfServiceActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CreatePointOfServiceActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CreatePointOfServiceActionProto message.
             * @function verify
             * @memberof waiternow.common.CreatePointOfServiceActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CreatePointOfServiceActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a CreatePointOfServiceActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.CreatePointOfServiceActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.CreatePointOfServiceActionProto} CreatePointOfServiceActionProto
             */
            CreatePointOfServiceActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.CreatePointOfServiceActionProto)
                    return object;
                return new $root.waiternow.common.CreatePointOfServiceActionProto();
            };

            /**
             * Creates a plain object from a CreatePointOfServiceActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.CreatePointOfServiceActionProto
             * @static
             * @param {waiternow.common.CreatePointOfServiceActionProto} message CreatePointOfServiceActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CreatePointOfServiceActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this CreatePointOfServiceActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.CreatePointOfServiceActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CreatePointOfServiceActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for CreatePointOfServiceActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.CreatePointOfServiceActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            CreatePointOfServiceActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.CreatePointOfServiceActionProto";
            };

            CreatePointOfServiceActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.CreatePointOfServiceActionProto
                 * @interface IRequest
                 * @property {waiternow.common.IPointOfServiceProto|null} [pointOfService] Request pointOfService
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.CreatePointOfServiceActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.CreatePointOfServiceActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request pointOfService.
                 * @member {waiternow.common.IPointOfServiceProto|null|undefined} pointOfService
                 * @memberof waiternow.common.CreatePointOfServiceActionProto.Request
                 * @instance
                 */
                Request.prototype.pointOfService = null;

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.CreatePointOfServiceActionProto.Request
                 * @static
                 * @param {waiternow.common.CreatePointOfServiceActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.CreatePointOfServiceActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.CreatePointOfServiceActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.CreatePointOfServiceActionProto.Request
                 * @static
                 * @param {waiternow.common.CreatePointOfServiceActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.pointOfService != null && Object.hasOwnProperty.call(message, "pointOfService"))
                        $root.waiternow.common.PointOfServiceProto.encode(message.pointOfService, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.CreatePointOfServiceActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.CreatePointOfServiceActionProto.Request
                 * @static
                 * @param {waiternow.common.CreatePointOfServiceActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.CreatePointOfServiceActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.CreatePointOfServiceActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CreatePointOfServiceActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.pointOfService = $root.waiternow.common.PointOfServiceProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.CreatePointOfServiceActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.CreatePointOfServiceActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.CreatePointOfServiceActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.pointOfService != null && message.hasOwnProperty("pointOfService")) {
                        var error = $root.waiternow.common.PointOfServiceProto.verify(message.pointOfService);
                        if (error)
                            return "pointOfService." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.CreatePointOfServiceActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.CreatePointOfServiceActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.CreatePointOfServiceActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.CreatePointOfServiceActionProto.Request();
                    if (object.pointOfService != null) {
                        if (typeof object.pointOfService !== "object")
                            throw TypeError(".waiternow.common.CreatePointOfServiceActionProto.Request.pointOfService: object expected");
                        message.pointOfService = $root.waiternow.common.PointOfServiceProto.fromObject(object.pointOfService);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.CreatePointOfServiceActionProto.Request
                 * @static
                 * @param {waiternow.common.CreatePointOfServiceActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.pointOfService = null;
                    if (message.pointOfService != null && message.hasOwnProperty("pointOfService"))
                        object.pointOfService = $root.waiternow.common.PointOfServiceProto.toObject(message.pointOfService, options);
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.CreatePointOfServiceActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.CreatePointOfServiceActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.CreatePointOfServiceActionProto.Request";
                };

                return Request;
            })();

            CreatePointOfServiceActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.CreatePointOfServiceActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IPointOfServiceProto|null} [pointOfService] Response pointOfService
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.CreatePointOfServiceActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.CreatePointOfServiceActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.CreatePointOfServiceActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response pointOfService.
                 * @member {waiternow.common.IPointOfServiceProto|null|undefined} pointOfService
                 * @memberof waiternow.common.CreatePointOfServiceActionProto.Response
                 * @instance
                 */
                Response.prototype.pointOfService = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.CreatePointOfServiceActionProto.Response
                 * @static
                 * @param {waiternow.common.CreatePointOfServiceActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.CreatePointOfServiceActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.CreatePointOfServiceActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.CreatePointOfServiceActionProto.Response
                 * @static
                 * @param {waiternow.common.CreatePointOfServiceActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.pointOfService != null && Object.hasOwnProperty.call(message, "pointOfService"))
                        $root.waiternow.common.PointOfServiceProto.encode(message.pointOfService, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.CreatePointOfServiceActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.CreatePointOfServiceActionProto.Response
                 * @static
                 * @param {waiternow.common.CreatePointOfServiceActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.CreatePointOfServiceActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.CreatePointOfServiceActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CreatePointOfServiceActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.pointOfService = $root.waiternow.common.PointOfServiceProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.CreatePointOfServiceActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.CreatePointOfServiceActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.CreatePointOfServiceActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.pointOfService != null && message.hasOwnProperty("pointOfService")) {
                        var error = $root.waiternow.common.PointOfServiceProto.verify(message.pointOfService);
                        if (error)
                            return "pointOfService." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.CreatePointOfServiceActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.CreatePointOfServiceActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.CreatePointOfServiceActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.CreatePointOfServiceActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.CreatePointOfServiceActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.pointOfService != null) {
                        if (typeof object.pointOfService !== "object")
                            throw TypeError(".waiternow.common.CreatePointOfServiceActionProto.Response.pointOfService: object expected");
                        message.pointOfService = $root.waiternow.common.PointOfServiceProto.fromObject(object.pointOfService);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.CreatePointOfServiceActionProto.Response
                 * @static
                 * @param {waiternow.common.CreatePointOfServiceActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.pointOfService = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.pointOfService != null && message.hasOwnProperty("pointOfService"))
                        object.pointOfService = $root.waiternow.common.PointOfServiceProto.toObject(message.pointOfService, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.CreatePointOfServiceActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.CreatePointOfServiceActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.CreatePointOfServiceActionProto.Response";
                };

                return Response;
            })();

            return CreatePointOfServiceActionProto;
        })();

        common.CreatePointsOfServiceActionProto = (function() {

            /**
             * Properties of a CreatePointsOfServiceActionProto.
             * @memberof waiternow.common
             * @interface ICreatePointsOfServiceActionProto
             */

            /**
             * Constructs a new CreatePointsOfServiceActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a CreatePointsOfServiceActionProto.
             * @implements ICreatePointsOfServiceActionProto
             * @constructor
             * @param {waiternow.common.ICreatePointsOfServiceActionProto=} [properties] Properties to set
             */
            function CreatePointsOfServiceActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new CreatePointsOfServiceActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.CreatePointsOfServiceActionProto
             * @static
             * @param {waiternow.common.ICreatePointsOfServiceActionProto=} [properties] Properties to set
             * @returns {waiternow.common.CreatePointsOfServiceActionProto} CreatePointsOfServiceActionProto instance
             */
            CreatePointsOfServiceActionProto.create = function create(properties) {
                return new CreatePointsOfServiceActionProto(properties);
            };

            /**
             * Encodes the specified CreatePointsOfServiceActionProto message. Does not implicitly {@link waiternow.common.CreatePointsOfServiceActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.CreatePointsOfServiceActionProto
             * @static
             * @param {waiternow.common.ICreatePointsOfServiceActionProto} message CreatePointsOfServiceActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CreatePointsOfServiceActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified CreatePointsOfServiceActionProto message, length delimited. Does not implicitly {@link waiternow.common.CreatePointsOfServiceActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.CreatePointsOfServiceActionProto
             * @static
             * @param {waiternow.common.ICreatePointsOfServiceActionProto} message CreatePointsOfServiceActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CreatePointsOfServiceActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CreatePointsOfServiceActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.CreatePointsOfServiceActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.CreatePointsOfServiceActionProto} CreatePointsOfServiceActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CreatePointsOfServiceActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CreatePointsOfServiceActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CreatePointsOfServiceActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.CreatePointsOfServiceActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.CreatePointsOfServiceActionProto} CreatePointsOfServiceActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CreatePointsOfServiceActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CreatePointsOfServiceActionProto message.
             * @function verify
             * @memberof waiternow.common.CreatePointsOfServiceActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CreatePointsOfServiceActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a CreatePointsOfServiceActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.CreatePointsOfServiceActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.CreatePointsOfServiceActionProto} CreatePointsOfServiceActionProto
             */
            CreatePointsOfServiceActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.CreatePointsOfServiceActionProto)
                    return object;
                return new $root.waiternow.common.CreatePointsOfServiceActionProto();
            };

            /**
             * Creates a plain object from a CreatePointsOfServiceActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.CreatePointsOfServiceActionProto
             * @static
             * @param {waiternow.common.CreatePointsOfServiceActionProto} message CreatePointsOfServiceActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CreatePointsOfServiceActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this CreatePointsOfServiceActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.CreatePointsOfServiceActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CreatePointsOfServiceActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for CreatePointsOfServiceActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.CreatePointsOfServiceActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            CreatePointsOfServiceActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.CreatePointsOfServiceActionProto";
            };

            CreatePointsOfServiceActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.CreatePointsOfServiceActionProto
                 * @interface IRequest
                 * @property {string|null} [locationId] Request locationId
                 * @property {string|null} [friendlyNamePrefix] Request friendlyNamePrefix
                 * @property {waiternow.common.IIntRangeProto|null} [friendlyNameSuffix] Request friendlyNameSuffix
                 * @property {waiternow.common.PointOfServiceProto.PointOfServiceType|null} [type] Request type
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.CreatePointsOfServiceActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.CreatePointsOfServiceActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.CreatePointsOfServiceActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = "";

                /**
                 * Request friendlyNamePrefix.
                 * @member {string} friendlyNamePrefix
                 * @memberof waiternow.common.CreatePointsOfServiceActionProto.Request
                 * @instance
                 */
                Request.prototype.friendlyNamePrefix = "";

                /**
                 * Request friendlyNameSuffix.
                 * @member {waiternow.common.IIntRangeProto|null|undefined} friendlyNameSuffix
                 * @memberof waiternow.common.CreatePointsOfServiceActionProto.Request
                 * @instance
                 */
                Request.prototype.friendlyNameSuffix = null;

                /**
                 * Request type.
                 * @member {waiternow.common.PointOfServiceProto.PointOfServiceType} type
                 * @memberof waiternow.common.CreatePointsOfServiceActionProto.Request
                 * @instance
                 */
                Request.prototype.type = 0;

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.CreatePointsOfServiceActionProto.Request
                 * @static
                 * @param {waiternow.common.CreatePointsOfServiceActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.CreatePointsOfServiceActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.CreatePointsOfServiceActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.CreatePointsOfServiceActionProto.Request
                 * @static
                 * @param {waiternow.common.CreatePointsOfServiceActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    if (message.friendlyNamePrefix != null && Object.hasOwnProperty.call(message, "friendlyNamePrefix"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.friendlyNamePrefix);
                    if (message.friendlyNameSuffix != null && Object.hasOwnProperty.call(message, "friendlyNameSuffix"))
                        $root.waiternow.common.IntRangeProto.encode(message.friendlyNameSuffix, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.type);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.CreatePointsOfServiceActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.CreatePointsOfServiceActionProto.Request
                 * @static
                 * @param {waiternow.common.CreatePointsOfServiceActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.CreatePointsOfServiceActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.CreatePointsOfServiceActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CreatePointsOfServiceActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 2: {
                                message.friendlyNamePrefix = reader.string();
                                break;
                            }
                        case 3: {
                                message.friendlyNameSuffix = $root.waiternow.common.IntRangeProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 4: {
                                message.type = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.CreatePointsOfServiceActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.CreatePointsOfServiceActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.CreatePointsOfServiceActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    if (message.friendlyNamePrefix != null && message.hasOwnProperty("friendlyNamePrefix"))
                        if (!$util.isString(message.friendlyNamePrefix))
                            return "friendlyNamePrefix: string expected";
                    if (message.friendlyNameSuffix != null && message.hasOwnProperty("friendlyNameSuffix")) {
                        var error = $root.waiternow.common.IntRangeProto.verify(message.friendlyNameSuffix);
                        if (error)
                            return "friendlyNameSuffix." + error;
                    }
                    if (message.type != null && message.hasOwnProperty("type"))
                        switch (message.type) {
                        default:
                            return "type: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                        case 6:
                        case 7:
                        case 8:
                            break;
                        }
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.CreatePointsOfServiceActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.CreatePointsOfServiceActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.CreatePointsOfServiceActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.CreatePointsOfServiceActionProto.Request();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    if (object.friendlyNamePrefix != null)
                        message.friendlyNamePrefix = String(object.friendlyNamePrefix);
                    if (object.friendlyNameSuffix != null) {
                        if (typeof object.friendlyNameSuffix !== "object")
                            throw TypeError(".waiternow.common.CreatePointsOfServiceActionProto.Request.friendlyNameSuffix: object expected");
                        message.friendlyNameSuffix = $root.waiternow.common.IntRangeProto.fromObject(object.friendlyNameSuffix);
                    }
                    switch (object.type) {
                    default:
                        if (typeof object.type === "number") {
                            message.type = object.type;
                            break;
                        }
                        break;
                    case "POINT_OF_SERVICE_TYPE_UNSPECIFIED":
                    case 0:
                        message.type = 0;
                        break;
                    case "TABLE":
                    case 1:
                        message.type = 1;
                        break;
                    case "ROOM":
                    case 2:
                        message.type = 2;
                        break;
                    case "TERRACE":
                    case 3:
                        message.type = 3;
                        break;
                    case "POOL":
                    case 4:
                        message.type = 4;
                        break;
                    case "MENU":
                    case 5:
                        message.type = 5;
                        break;
                    case "ONLINE_PICKUP":
                    case 6:
                        message.type = 6;
                        break;
                    case "ONSITE_PICKUP":
                    case 7:
                        message.type = 7;
                        break;
                    case "ONLINE":
                    case 8:
                        message.type = 8;
                        break;
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.CreatePointsOfServiceActionProto.Request
                 * @static
                 * @param {waiternow.common.CreatePointsOfServiceActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.locationId = "";
                        object.friendlyNamePrefix = "";
                        object.friendlyNameSuffix = null;
                        object.type = options.enums === String ? "POINT_OF_SERVICE_TYPE_UNSPECIFIED" : 0;
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    if (message.friendlyNamePrefix != null && message.hasOwnProperty("friendlyNamePrefix"))
                        object.friendlyNamePrefix = message.friendlyNamePrefix;
                    if (message.friendlyNameSuffix != null && message.hasOwnProperty("friendlyNameSuffix"))
                        object.friendlyNameSuffix = $root.waiternow.common.IntRangeProto.toObject(message.friendlyNameSuffix, options);
                    if (message.type != null && message.hasOwnProperty("type"))
                        object.type = options.enums === String ? $root.waiternow.common.PointOfServiceProto.PointOfServiceType[message.type] === undefined ? message.type : $root.waiternow.common.PointOfServiceProto.PointOfServiceType[message.type] : message.type;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.CreatePointsOfServiceActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.CreatePointsOfServiceActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.CreatePointsOfServiceActionProto.Request";
                };

                return Request;
            })();

            CreatePointsOfServiceActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.CreatePointsOfServiceActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {Array.<waiternow.common.IPointOfServiceProto>|null} [pointsOfService] Response pointsOfService
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.CreatePointsOfServiceActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.CreatePointsOfServiceActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    this.pointsOfService = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.CreatePointsOfServiceActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response pointsOfService.
                 * @member {Array.<waiternow.common.IPointOfServiceProto>} pointsOfService
                 * @memberof waiternow.common.CreatePointsOfServiceActionProto.Response
                 * @instance
                 */
                Response.prototype.pointsOfService = $util.emptyArray;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.CreatePointsOfServiceActionProto.Response
                 * @static
                 * @param {waiternow.common.CreatePointsOfServiceActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.CreatePointsOfServiceActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.CreatePointsOfServiceActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.CreatePointsOfServiceActionProto.Response
                 * @static
                 * @param {waiternow.common.CreatePointsOfServiceActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.pointsOfService != null && message.pointsOfService.length)
                        for (var i = 0; i < message.pointsOfService.length; ++i)
                            $root.waiternow.common.PointOfServiceProto.encode(message.pointsOfService[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.CreatePointsOfServiceActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.CreatePointsOfServiceActionProto.Response
                 * @static
                 * @param {waiternow.common.CreatePointsOfServiceActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.CreatePointsOfServiceActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.CreatePointsOfServiceActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CreatePointsOfServiceActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                if (!(message.pointsOfService && message.pointsOfService.length))
                                    message.pointsOfService = [];
                                message.pointsOfService.push($root.waiternow.common.PointOfServiceProto.decode(reader, reader.uint32()));
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.CreatePointsOfServiceActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.CreatePointsOfServiceActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.CreatePointsOfServiceActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.pointsOfService != null && message.hasOwnProperty("pointsOfService")) {
                        if (!Array.isArray(message.pointsOfService))
                            return "pointsOfService: array expected";
                        for (var i = 0; i < message.pointsOfService.length; ++i) {
                            var error = $root.waiternow.common.PointOfServiceProto.verify(message.pointsOfService[i]);
                            if (error)
                                return "pointsOfService." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.CreatePointsOfServiceActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.CreatePointsOfServiceActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.CreatePointsOfServiceActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.CreatePointsOfServiceActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.CreatePointsOfServiceActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.pointsOfService) {
                        if (!Array.isArray(object.pointsOfService))
                            throw TypeError(".waiternow.common.CreatePointsOfServiceActionProto.Response.pointsOfService: array expected");
                        message.pointsOfService = [];
                        for (var i = 0; i < object.pointsOfService.length; ++i) {
                            if (typeof object.pointsOfService[i] !== "object")
                                throw TypeError(".waiternow.common.CreatePointsOfServiceActionProto.Response.pointsOfService: object expected");
                            message.pointsOfService[i] = $root.waiternow.common.PointOfServiceProto.fromObject(object.pointsOfService[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.CreatePointsOfServiceActionProto.Response
                 * @static
                 * @param {waiternow.common.CreatePointsOfServiceActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.pointsOfService = [];
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.pointsOfService && message.pointsOfService.length) {
                        object.pointsOfService = [];
                        for (var j = 0; j < message.pointsOfService.length; ++j)
                            object.pointsOfService[j] = $root.waiternow.common.PointOfServiceProto.toObject(message.pointsOfService[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.CreatePointsOfServiceActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.CreatePointsOfServiceActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.CreatePointsOfServiceActionProto.Response";
                };

                return Response;
            })();

            return CreatePointsOfServiceActionProto;
        })();

        common.UpdatePointOfServiceActionProto = (function() {

            /**
             * Properties of an UpdatePointOfServiceActionProto.
             * @memberof waiternow.common
             * @interface IUpdatePointOfServiceActionProto
             */

            /**
             * Constructs a new UpdatePointOfServiceActionProto.
             * @memberof waiternow.common
             * @classdesc Represents an UpdatePointOfServiceActionProto.
             * @implements IUpdatePointOfServiceActionProto
             * @constructor
             * @param {waiternow.common.IUpdatePointOfServiceActionProto=} [properties] Properties to set
             */
            function UpdatePointOfServiceActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new UpdatePointOfServiceActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.UpdatePointOfServiceActionProto
             * @static
             * @param {waiternow.common.IUpdatePointOfServiceActionProto=} [properties] Properties to set
             * @returns {waiternow.common.UpdatePointOfServiceActionProto} UpdatePointOfServiceActionProto instance
             */
            UpdatePointOfServiceActionProto.create = function create(properties) {
                return new UpdatePointOfServiceActionProto(properties);
            };

            /**
             * Encodes the specified UpdatePointOfServiceActionProto message. Does not implicitly {@link waiternow.common.UpdatePointOfServiceActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.UpdatePointOfServiceActionProto
             * @static
             * @param {waiternow.common.IUpdatePointOfServiceActionProto} message UpdatePointOfServiceActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UpdatePointOfServiceActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified UpdatePointOfServiceActionProto message, length delimited. Does not implicitly {@link waiternow.common.UpdatePointOfServiceActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.UpdatePointOfServiceActionProto
             * @static
             * @param {waiternow.common.IUpdatePointOfServiceActionProto} message UpdatePointOfServiceActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UpdatePointOfServiceActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an UpdatePointOfServiceActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.UpdatePointOfServiceActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.UpdatePointOfServiceActionProto} UpdatePointOfServiceActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UpdatePointOfServiceActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.UpdatePointOfServiceActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an UpdatePointOfServiceActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.UpdatePointOfServiceActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.UpdatePointOfServiceActionProto} UpdatePointOfServiceActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UpdatePointOfServiceActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an UpdatePointOfServiceActionProto message.
             * @function verify
             * @memberof waiternow.common.UpdatePointOfServiceActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            UpdatePointOfServiceActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates an UpdatePointOfServiceActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.UpdatePointOfServiceActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.UpdatePointOfServiceActionProto} UpdatePointOfServiceActionProto
             */
            UpdatePointOfServiceActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.UpdatePointOfServiceActionProto)
                    return object;
                return new $root.waiternow.common.UpdatePointOfServiceActionProto();
            };

            /**
             * Creates a plain object from an UpdatePointOfServiceActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.UpdatePointOfServiceActionProto
             * @static
             * @param {waiternow.common.UpdatePointOfServiceActionProto} message UpdatePointOfServiceActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            UpdatePointOfServiceActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this UpdatePointOfServiceActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.UpdatePointOfServiceActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            UpdatePointOfServiceActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for UpdatePointOfServiceActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.UpdatePointOfServiceActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            UpdatePointOfServiceActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.UpdatePointOfServiceActionProto";
            };

            UpdatePointOfServiceActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.UpdatePointOfServiceActionProto
                 * @interface IRequest
                 * @property {waiternow.common.IPointOfServiceProto|null} [pointOfService] Request pointOfService
                 * @property {Array.<waiternow.common.UpdatePointOfServiceActionProto.Request.RemovableField>|null} [fieldsToRemove] Request fieldsToRemove
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.UpdatePointOfServiceActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.UpdatePointOfServiceActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    this.fieldsToRemove = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request pointOfService.
                 * @member {waiternow.common.IPointOfServiceProto|null|undefined} pointOfService
                 * @memberof waiternow.common.UpdatePointOfServiceActionProto.Request
                 * @instance
                 */
                Request.prototype.pointOfService = null;

                /**
                 * Request fieldsToRemove.
                 * @member {Array.<waiternow.common.UpdatePointOfServiceActionProto.Request.RemovableField>} fieldsToRemove
                 * @memberof waiternow.common.UpdatePointOfServiceActionProto.Request
                 * @instance
                 */
                Request.prototype.fieldsToRemove = $util.emptyArray;

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.UpdatePointOfServiceActionProto.Request
                 * @static
                 * @param {waiternow.common.UpdatePointOfServiceActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.UpdatePointOfServiceActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.UpdatePointOfServiceActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.UpdatePointOfServiceActionProto.Request
                 * @static
                 * @param {waiternow.common.UpdatePointOfServiceActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.pointOfService != null && Object.hasOwnProperty.call(message, "pointOfService"))
                        $root.waiternow.common.PointOfServiceProto.encode(message.pointOfService, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.fieldsToRemove != null && message.fieldsToRemove.length) {
                        writer.uint32(/* id 2, wireType 2 =*/18).fork();
                        for (var i = 0; i < message.fieldsToRemove.length; ++i)
                            writer.int32(message.fieldsToRemove[i]);
                        writer.ldelim();
                    }
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.UpdatePointOfServiceActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.UpdatePointOfServiceActionProto.Request
                 * @static
                 * @param {waiternow.common.UpdatePointOfServiceActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.UpdatePointOfServiceActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.UpdatePointOfServiceActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.UpdatePointOfServiceActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.pointOfService = $root.waiternow.common.PointOfServiceProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                if (!(message.fieldsToRemove && message.fieldsToRemove.length))
                                    message.fieldsToRemove = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.fieldsToRemove.push(reader.int32());
                                } else
                                    message.fieldsToRemove.push(reader.int32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.UpdatePointOfServiceActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.UpdatePointOfServiceActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.UpdatePointOfServiceActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.pointOfService != null && message.hasOwnProperty("pointOfService")) {
                        var error = $root.waiternow.common.PointOfServiceProto.verify(message.pointOfService);
                        if (error)
                            return "pointOfService." + error;
                    }
                    if (message.fieldsToRemove != null && message.hasOwnProperty("fieldsToRemove")) {
                        if (!Array.isArray(message.fieldsToRemove))
                            return "fieldsToRemove: array expected";
                        for (var i = 0; i < message.fieldsToRemove.length; ++i)
                            switch (message.fieldsToRemove[i]) {
                            default:
                                return "fieldsToRemove: enum value[] expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                    }
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.UpdatePointOfServiceActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.UpdatePointOfServiceActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.UpdatePointOfServiceActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.UpdatePointOfServiceActionProto.Request();
                    if (object.pointOfService != null) {
                        if (typeof object.pointOfService !== "object")
                            throw TypeError(".waiternow.common.UpdatePointOfServiceActionProto.Request.pointOfService: object expected");
                        message.pointOfService = $root.waiternow.common.PointOfServiceProto.fromObject(object.pointOfService);
                    }
                    if (object.fieldsToRemove) {
                        if (!Array.isArray(object.fieldsToRemove))
                            throw TypeError(".waiternow.common.UpdatePointOfServiceActionProto.Request.fieldsToRemove: array expected");
                        message.fieldsToRemove = [];
                        for (var i = 0; i < object.fieldsToRemove.length; ++i)
                            switch (object.fieldsToRemove[i]) {
                            default:
                                if (typeof object.fieldsToRemove[i] === "number") {
                                    message.fieldsToRemove[i] = object.fieldsToRemove[i];
                                    break;
                                }
                            case "REMOVABLE_FIELD_UNSPECIFIED":
                            case 0:
                                message.fieldsToRemove[i] = 0;
                                break;
                            case "TYPE":
                            case 1:
                                message.fieldsToRemove[i] = 1;
                                break;
                            case "VANITY_URL":
                            case 2:
                                message.fieldsToRemove[i] = 2;
                                break;
                            }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.UpdatePointOfServiceActionProto.Request
                 * @static
                 * @param {waiternow.common.UpdatePointOfServiceActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.fieldsToRemove = [];
                    if (options.defaults)
                        object.pointOfService = null;
                    if (message.pointOfService != null && message.hasOwnProperty("pointOfService"))
                        object.pointOfService = $root.waiternow.common.PointOfServiceProto.toObject(message.pointOfService, options);
                    if (message.fieldsToRemove && message.fieldsToRemove.length) {
                        object.fieldsToRemove = [];
                        for (var j = 0; j < message.fieldsToRemove.length; ++j)
                            object.fieldsToRemove[j] = options.enums === String ? $root.waiternow.common.UpdatePointOfServiceActionProto.Request.RemovableField[message.fieldsToRemove[j]] === undefined ? message.fieldsToRemove[j] : $root.waiternow.common.UpdatePointOfServiceActionProto.Request.RemovableField[message.fieldsToRemove[j]] : message.fieldsToRemove[j];
                    }
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.UpdatePointOfServiceActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.UpdatePointOfServiceActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.UpdatePointOfServiceActionProto.Request";
                };

                /**
                 * RemovableField enum.
                 * @name waiternow.common.UpdatePointOfServiceActionProto.Request.RemovableField
                 * @enum {number}
                 * @property {number} REMOVABLE_FIELD_UNSPECIFIED=0 REMOVABLE_FIELD_UNSPECIFIED value
                 * @property {number} TYPE=1 TYPE value
                 * @property {number} VANITY_URL=2 VANITY_URL value
                 */
                Request.RemovableField = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "REMOVABLE_FIELD_UNSPECIFIED"] = 0;
                    values[valuesById[1] = "TYPE"] = 1;
                    values[valuesById[2] = "VANITY_URL"] = 2;
                    return values;
                })();

                return Request;
            })();

            UpdatePointOfServiceActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.UpdatePointOfServiceActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.UpdatePointOfServiceActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.UpdatePointOfServiceActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.UpdatePointOfServiceActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.UpdatePointOfServiceActionProto.Response
                 * @static
                 * @param {waiternow.common.UpdatePointOfServiceActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.UpdatePointOfServiceActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.UpdatePointOfServiceActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.UpdatePointOfServiceActionProto.Response
                 * @static
                 * @param {waiternow.common.UpdatePointOfServiceActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.UpdatePointOfServiceActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.UpdatePointOfServiceActionProto.Response
                 * @static
                 * @param {waiternow.common.UpdatePointOfServiceActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.UpdatePointOfServiceActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.UpdatePointOfServiceActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.UpdatePointOfServiceActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.UpdatePointOfServiceActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.UpdatePointOfServiceActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.UpdatePointOfServiceActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.UpdatePointOfServiceActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.UpdatePointOfServiceActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.UpdatePointOfServiceActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.UpdatePointOfServiceActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.UpdatePointOfServiceActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.UpdatePointOfServiceActionProto.Response
                 * @static
                 * @param {waiternow.common.UpdatePointOfServiceActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.UpdatePointOfServiceActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.UpdatePointOfServiceActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.UpdatePointOfServiceActionProto.Response";
                };

                return Response;
            })();

            return UpdatePointOfServiceActionProto;
        })();

        common.DeletePointOfServiceActionProto = (function() {

            /**
             * Properties of a DeletePointOfServiceActionProto.
             * @memberof waiternow.common
             * @interface IDeletePointOfServiceActionProto
             */

            /**
             * Constructs a new DeletePointOfServiceActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a DeletePointOfServiceActionProto.
             * @implements IDeletePointOfServiceActionProto
             * @constructor
             * @param {waiternow.common.IDeletePointOfServiceActionProto=} [properties] Properties to set
             */
            function DeletePointOfServiceActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new DeletePointOfServiceActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.DeletePointOfServiceActionProto
             * @static
             * @param {waiternow.common.IDeletePointOfServiceActionProto=} [properties] Properties to set
             * @returns {waiternow.common.DeletePointOfServiceActionProto} DeletePointOfServiceActionProto instance
             */
            DeletePointOfServiceActionProto.create = function create(properties) {
                return new DeletePointOfServiceActionProto(properties);
            };

            /**
             * Encodes the specified DeletePointOfServiceActionProto message. Does not implicitly {@link waiternow.common.DeletePointOfServiceActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.DeletePointOfServiceActionProto
             * @static
             * @param {waiternow.common.IDeletePointOfServiceActionProto} message DeletePointOfServiceActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DeletePointOfServiceActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified DeletePointOfServiceActionProto message, length delimited. Does not implicitly {@link waiternow.common.DeletePointOfServiceActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.DeletePointOfServiceActionProto
             * @static
             * @param {waiternow.common.IDeletePointOfServiceActionProto} message DeletePointOfServiceActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DeletePointOfServiceActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a DeletePointOfServiceActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.DeletePointOfServiceActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.DeletePointOfServiceActionProto} DeletePointOfServiceActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DeletePointOfServiceActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.DeletePointOfServiceActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a DeletePointOfServiceActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.DeletePointOfServiceActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.DeletePointOfServiceActionProto} DeletePointOfServiceActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DeletePointOfServiceActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a DeletePointOfServiceActionProto message.
             * @function verify
             * @memberof waiternow.common.DeletePointOfServiceActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            DeletePointOfServiceActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a DeletePointOfServiceActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.DeletePointOfServiceActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.DeletePointOfServiceActionProto} DeletePointOfServiceActionProto
             */
            DeletePointOfServiceActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.DeletePointOfServiceActionProto)
                    return object;
                return new $root.waiternow.common.DeletePointOfServiceActionProto();
            };

            /**
             * Creates a plain object from a DeletePointOfServiceActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.DeletePointOfServiceActionProto
             * @static
             * @param {waiternow.common.DeletePointOfServiceActionProto} message DeletePointOfServiceActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            DeletePointOfServiceActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this DeletePointOfServiceActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.DeletePointOfServiceActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            DeletePointOfServiceActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for DeletePointOfServiceActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.DeletePointOfServiceActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            DeletePointOfServiceActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.DeletePointOfServiceActionProto";
            };

            DeletePointOfServiceActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.DeletePointOfServiceActionProto
                 * @interface IRequest
                 * @property {string|null} [pointOfServiceId] Request pointOfServiceId
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.DeletePointOfServiceActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.DeletePointOfServiceActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request pointOfServiceId.
                 * @member {string} pointOfServiceId
                 * @memberof waiternow.common.DeletePointOfServiceActionProto.Request
                 * @instance
                 */
                Request.prototype.pointOfServiceId = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.DeletePointOfServiceActionProto.Request
                 * @static
                 * @param {waiternow.common.DeletePointOfServiceActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.DeletePointOfServiceActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.DeletePointOfServiceActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.DeletePointOfServiceActionProto.Request
                 * @static
                 * @param {waiternow.common.DeletePointOfServiceActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.pointOfServiceId != null && Object.hasOwnProperty.call(message, "pointOfServiceId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.pointOfServiceId);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.DeletePointOfServiceActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.DeletePointOfServiceActionProto.Request
                 * @static
                 * @param {waiternow.common.DeletePointOfServiceActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.DeletePointOfServiceActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.DeletePointOfServiceActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.DeletePointOfServiceActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.pointOfServiceId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.DeletePointOfServiceActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.DeletePointOfServiceActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.DeletePointOfServiceActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.pointOfServiceId != null && message.hasOwnProperty("pointOfServiceId"))
                        if (!$util.isString(message.pointOfServiceId))
                            return "pointOfServiceId: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.DeletePointOfServiceActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.DeletePointOfServiceActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.DeletePointOfServiceActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.DeletePointOfServiceActionProto.Request();
                    if (object.pointOfServiceId != null)
                        message.pointOfServiceId = String(object.pointOfServiceId);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.DeletePointOfServiceActionProto.Request
                 * @static
                 * @param {waiternow.common.DeletePointOfServiceActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.pointOfServiceId = "";
                    if (message.pointOfServiceId != null && message.hasOwnProperty("pointOfServiceId"))
                        object.pointOfServiceId = message.pointOfServiceId;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.DeletePointOfServiceActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.DeletePointOfServiceActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.DeletePointOfServiceActionProto.Request";
                };

                return Request;
            })();

            DeletePointOfServiceActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.DeletePointOfServiceActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.DeletePointOfServiceActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.DeletePointOfServiceActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.DeletePointOfServiceActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.DeletePointOfServiceActionProto.Response
                 * @static
                 * @param {waiternow.common.DeletePointOfServiceActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.DeletePointOfServiceActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.DeletePointOfServiceActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.DeletePointOfServiceActionProto.Response
                 * @static
                 * @param {waiternow.common.DeletePointOfServiceActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.DeletePointOfServiceActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.DeletePointOfServiceActionProto.Response
                 * @static
                 * @param {waiternow.common.DeletePointOfServiceActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.DeletePointOfServiceActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.DeletePointOfServiceActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.DeletePointOfServiceActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.DeletePointOfServiceActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.DeletePointOfServiceActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.DeletePointOfServiceActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.DeletePointOfServiceActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.DeletePointOfServiceActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.DeletePointOfServiceActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.DeletePointOfServiceActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.DeletePointOfServiceActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.DeletePointOfServiceActionProto.Response
                 * @static
                 * @param {waiternow.common.DeletePointOfServiceActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.DeletePointOfServiceActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.DeletePointOfServiceActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.DeletePointOfServiceActionProto.Response";
                };

                return Response;
            })();

            return DeletePointOfServiceActionProto;
        })();

        common.GetPointOfServiceActionProto = (function() {

            /**
             * Properties of a GetPointOfServiceActionProto.
             * @memberof waiternow.common
             * @interface IGetPointOfServiceActionProto
             */

            /**
             * Constructs a new GetPointOfServiceActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a GetPointOfServiceActionProto.
             * @implements IGetPointOfServiceActionProto
             * @constructor
             * @param {waiternow.common.IGetPointOfServiceActionProto=} [properties] Properties to set
             */
            function GetPointOfServiceActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new GetPointOfServiceActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.GetPointOfServiceActionProto
             * @static
             * @param {waiternow.common.IGetPointOfServiceActionProto=} [properties] Properties to set
             * @returns {waiternow.common.GetPointOfServiceActionProto} GetPointOfServiceActionProto instance
             */
            GetPointOfServiceActionProto.create = function create(properties) {
                return new GetPointOfServiceActionProto(properties);
            };

            /**
             * Encodes the specified GetPointOfServiceActionProto message. Does not implicitly {@link waiternow.common.GetPointOfServiceActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.GetPointOfServiceActionProto
             * @static
             * @param {waiternow.common.IGetPointOfServiceActionProto} message GetPointOfServiceActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetPointOfServiceActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified GetPointOfServiceActionProto message, length delimited. Does not implicitly {@link waiternow.common.GetPointOfServiceActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.GetPointOfServiceActionProto
             * @static
             * @param {waiternow.common.IGetPointOfServiceActionProto} message GetPointOfServiceActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetPointOfServiceActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetPointOfServiceActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.GetPointOfServiceActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.GetPointOfServiceActionProto} GetPointOfServiceActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetPointOfServiceActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetPointOfServiceActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetPointOfServiceActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.GetPointOfServiceActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.GetPointOfServiceActionProto} GetPointOfServiceActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetPointOfServiceActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetPointOfServiceActionProto message.
             * @function verify
             * @memberof waiternow.common.GetPointOfServiceActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetPointOfServiceActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a GetPointOfServiceActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.GetPointOfServiceActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.GetPointOfServiceActionProto} GetPointOfServiceActionProto
             */
            GetPointOfServiceActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.GetPointOfServiceActionProto)
                    return object;
                return new $root.waiternow.common.GetPointOfServiceActionProto();
            };

            /**
             * Creates a plain object from a GetPointOfServiceActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.GetPointOfServiceActionProto
             * @static
             * @param {waiternow.common.GetPointOfServiceActionProto} message GetPointOfServiceActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetPointOfServiceActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this GetPointOfServiceActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.GetPointOfServiceActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetPointOfServiceActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for GetPointOfServiceActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.GetPointOfServiceActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            GetPointOfServiceActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.GetPointOfServiceActionProto";
            };

            GetPointOfServiceActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.GetPointOfServiceActionProto
                 * @interface IRequest
                 * @property {string|null} [pointOfServiceId] Request pointOfServiceId
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.GetPointOfServiceActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.GetPointOfServiceActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request pointOfServiceId.
                 * @member {string} pointOfServiceId
                 * @memberof waiternow.common.GetPointOfServiceActionProto.Request
                 * @instance
                 */
                Request.prototype.pointOfServiceId = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetPointOfServiceActionProto.Request
                 * @static
                 * @param {waiternow.common.GetPointOfServiceActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.GetPointOfServiceActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.GetPointOfServiceActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetPointOfServiceActionProto.Request
                 * @static
                 * @param {waiternow.common.GetPointOfServiceActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.pointOfServiceId != null && Object.hasOwnProperty.call(message, "pointOfServiceId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.pointOfServiceId);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.GetPointOfServiceActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetPointOfServiceActionProto.Request
                 * @static
                 * @param {waiternow.common.GetPointOfServiceActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetPointOfServiceActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetPointOfServiceActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetPointOfServiceActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.pointOfServiceId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetPointOfServiceActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetPointOfServiceActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.GetPointOfServiceActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.pointOfServiceId != null && message.hasOwnProperty("pointOfServiceId"))
                        if (!$util.isString(message.pointOfServiceId))
                            return "pointOfServiceId: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetPointOfServiceActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetPointOfServiceActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetPointOfServiceActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.GetPointOfServiceActionProto.Request();
                    if (object.pointOfServiceId != null)
                        message.pointOfServiceId = String(object.pointOfServiceId);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetPointOfServiceActionProto.Request
                 * @static
                 * @param {waiternow.common.GetPointOfServiceActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.pointOfServiceId = "";
                    if (message.pointOfServiceId != null && message.hasOwnProperty("pointOfServiceId"))
                        object.pointOfServiceId = message.pointOfServiceId;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetPointOfServiceActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetPointOfServiceActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetPointOfServiceActionProto.Request";
                };

                return Request;
            })();

            GetPointOfServiceActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.GetPointOfServiceActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IPointOfServiceProto|null} [pointOfService] Response pointOfService
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.GetPointOfServiceActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.GetPointOfServiceActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.GetPointOfServiceActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response pointOfService.
                 * @member {waiternow.common.IPointOfServiceProto|null|undefined} pointOfService
                 * @memberof waiternow.common.GetPointOfServiceActionProto.Response
                 * @instance
                 */
                Response.prototype.pointOfService = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetPointOfServiceActionProto.Response
                 * @static
                 * @param {waiternow.common.GetPointOfServiceActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.GetPointOfServiceActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.GetPointOfServiceActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetPointOfServiceActionProto.Response
                 * @static
                 * @param {waiternow.common.GetPointOfServiceActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.pointOfService != null && Object.hasOwnProperty.call(message, "pointOfService"))
                        $root.waiternow.common.PointOfServiceProto.encode(message.pointOfService, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.GetPointOfServiceActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetPointOfServiceActionProto.Response
                 * @static
                 * @param {waiternow.common.GetPointOfServiceActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetPointOfServiceActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetPointOfServiceActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetPointOfServiceActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.pointOfService = $root.waiternow.common.PointOfServiceProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetPointOfServiceActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetPointOfServiceActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.GetPointOfServiceActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.pointOfService != null && message.hasOwnProperty("pointOfService")) {
                        var error = $root.waiternow.common.PointOfServiceProto.verify(message.pointOfService);
                        if (error)
                            return "pointOfService." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetPointOfServiceActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetPointOfServiceActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetPointOfServiceActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.GetPointOfServiceActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.GetPointOfServiceActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.pointOfService != null) {
                        if (typeof object.pointOfService !== "object")
                            throw TypeError(".waiternow.common.GetPointOfServiceActionProto.Response.pointOfService: object expected");
                        message.pointOfService = $root.waiternow.common.PointOfServiceProto.fromObject(object.pointOfService);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetPointOfServiceActionProto.Response
                 * @static
                 * @param {waiternow.common.GetPointOfServiceActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.pointOfService = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.pointOfService != null && message.hasOwnProperty("pointOfService"))
                        object.pointOfService = $root.waiternow.common.PointOfServiceProto.toObject(message.pointOfService, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetPointOfServiceActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetPointOfServiceActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetPointOfServiceActionProto.Response";
                };

                return Response;
            })();

            return GetPointOfServiceActionProto;
        })();

        common.FindPointsOfServiceByLocationActionProto = (function() {

            /**
             * Properties of a FindPointsOfServiceByLocationActionProto.
             * @memberof waiternow.common
             * @interface IFindPointsOfServiceByLocationActionProto
             */

            /**
             * Constructs a new FindPointsOfServiceByLocationActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a FindPointsOfServiceByLocationActionProto.
             * @implements IFindPointsOfServiceByLocationActionProto
             * @constructor
             * @param {waiternow.common.IFindPointsOfServiceByLocationActionProto=} [properties] Properties to set
             */
            function FindPointsOfServiceByLocationActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new FindPointsOfServiceByLocationActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FindPointsOfServiceByLocationActionProto
             * @static
             * @param {waiternow.common.IFindPointsOfServiceByLocationActionProto=} [properties] Properties to set
             * @returns {waiternow.common.FindPointsOfServiceByLocationActionProto} FindPointsOfServiceByLocationActionProto instance
             */
            FindPointsOfServiceByLocationActionProto.create = function create(properties) {
                return new FindPointsOfServiceByLocationActionProto(properties);
            };

            /**
             * Encodes the specified FindPointsOfServiceByLocationActionProto message. Does not implicitly {@link waiternow.common.FindPointsOfServiceByLocationActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FindPointsOfServiceByLocationActionProto
             * @static
             * @param {waiternow.common.IFindPointsOfServiceByLocationActionProto} message FindPointsOfServiceByLocationActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindPointsOfServiceByLocationActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified FindPointsOfServiceByLocationActionProto message, length delimited. Does not implicitly {@link waiternow.common.FindPointsOfServiceByLocationActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FindPointsOfServiceByLocationActionProto
             * @static
             * @param {waiternow.common.IFindPointsOfServiceByLocationActionProto} message FindPointsOfServiceByLocationActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindPointsOfServiceByLocationActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FindPointsOfServiceByLocationActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FindPointsOfServiceByLocationActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FindPointsOfServiceByLocationActionProto} FindPointsOfServiceByLocationActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindPointsOfServiceByLocationActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindPointsOfServiceByLocationActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FindPointsOfServiceByLocationActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FindPointsOfServiceByLocationActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FindPointsOfServiceByLocationActionProto} FindPointsOfServiceByLocationActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindPointsOfServiceByLocationActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FindPointsOfServiceByLocationActionProto message.
             * @function verify
             * @memberof waiternow.common.FindPointsOfServiceByLocationActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FindPointsOfServiceByLocationActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a FindPointsOfServiceByLocationActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FindPointsOfServiceByLocationActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FindPointsOfServiceByLocationActionProto} FindPointsOfServiceByLocationActionProto
             */
            FindPointsOfServiceByLocationActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FindPointsOfServiceByLocationActionProto)
                    return object;
                return new $root.waiternow.common.FindPointsOfServiceByLocationActionProto();
            };

            /**
             * Creates a plain object from a FindPointsOfServiceByLocationActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FindPointsOfServiceByLocationActionProto
             * @static
             * @param {waiternow.common.FindPointsOfServiceByLocationActionProto} message FindPointsOfServiceByLocationActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FindPointsOfServiceByLocationActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this FindPointsOfServiceByLocationActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FindPointsOfServiceByLocationActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FindPointsOfServiceByLocationActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FindPointsOfServiceByLocationActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.FindPointsOfServiceByLocationActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FindPointsOfServiceByLocationActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FindPointsOfServiceByLocationActionProto";
            };

            FindPointsOfServiceByLocationActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.FindPointsOfServiceByLocationActionProto
                 * @interface IRequest
                 * @property {string|null} [locationId] Request locationId
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.FindPointsOfServiceByLocationActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.FindPointsOfServiceByLocationActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.FindPointsOfServiceByLocationActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindPointsOfServiceByLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.FindPointsOfServiceByLocationActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.FindPointsOfServiceByLocationActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.FindPointsOfServiceByLocationActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindPointsOfServiceByLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.FindPointsOfServiceByLocationActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.FindPointsOfServiceByLocationActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindPointsOfServiceByLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.FindPointsOfServiceByLocationActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindPointsOfServiceByLocationActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindPointsOfServiceByLocationActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindPointsOfServiceByLocationActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindPointsOfServiceByLocationActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindPointsOfServiceByLocationActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.FindPointsOfServiceByLocationActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindPointsOfServiceByLocationActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindPointsOfServiceByLocationActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindPointsOfServiceByLocationActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.FindPointsOfServiceByLocationActionProto.Request();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindPointsOfServiceByLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.FindPointsOfServiceByLocationActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.locationId = "";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindPointsOfServiceByLocationActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindPointsOfServiceByLocationActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindPointsOfServiceByLocationActionProto.Request";
                };

                return Request;
            })();

            FindPointsOfServiceByLocationActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.FindPointsOfServiceByLocationActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.ILocationPointsOfServiceProto|null} [locationPointsOfService] Response locationPointsOfService
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.FindPointsOfServiceByLocationActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.FindPointsOfServiceByLocationActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.FindPointsOfServiceByLocationActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response locationPointsOfService.
                 * @member {waiternow.common.ILocationPointsOfServiceProto|null|undefined} locationPointsOfService
                 * @memberof waiternow.common.FindPointsOfServiceByLocationActionProto.Response
                 * @instance
                 */
                Response.prototype.locationPointsOfService = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindPointsOfServiceByLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.FindPointsOfServiceByLocationActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.FindPointsOfServiceByLocationActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.FindPointsOfServiceByLocationActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindPointsOfServiceByLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.FindPointsOfServiceByLocationActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.locationPointsOfService != null && Object.hasOwnProperty.call(message, "locationPointsOfService"))
                        $root.waiternow.common.LocationPointsOfServiceProto.encode(message.locationPointsOfService, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.FindPointsOfServiceByLocationActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindPointsOfServiceByLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.FindPointsOfServiceByLocationActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindPointsOfServiceByLocationActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindPointsOfServiceByLocationActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindPointsOfServiceByLocationActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.locationPointsOfService = $root.waiternow.common.LocationPointsOfServiceProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindPointsOfServiceByLocationActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindPointsOfServiceByLocationActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.FindPointsOfServiceByLocationActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.locationPointsOfService != null && message.hasOwnProperty("locationPointsOfService")) {
                        var error = $root.waiternow.common.LocationPointsOfServiceProto.verify(message.locationPointsOfService);
                        if (error)
                            return "locationPointsOfService." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindPointsOfServiceByLocationActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindPointsOfServiceByLocationActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindPointsOfServiceByLocationActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.FindPointsOfServiceByLocationActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.FindPointsOfServiceByLocationActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.locationPointsOfService != null) {
                        if (typeof object.locationPointsOfService !== "object")
                            throw TypeError(".waiternow.common.FindPointsOfServiceByLocationActionProto.Response.locationPointsOfService: object expected");
                        message.locationPointsOfService = $root.waiternow.common.LocationPointsOfServiceProto.fromObject(object.locationPointsOfService);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindPointsOfServiceByLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.FindPointsOfServiceByLocationActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.locationPointsOfService = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.locationPointsOfService != null && message.hasOwnProperty("locationPointsOfService"))
                        object.locationPointsOfService = $root.waiternow.common.LocationPointsOfServiceProto.toObject(message.locationPointsOfService, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindPointsOfServiceByLocationActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindPointsOfServiceByLocationActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindPointsOfServiceByLocationActionProto.Response";
                };

                return Response;
            })();

            return FindPointsOfServiceByLocationActionProto;
        })();

        common.GetQrCodesActionProto = (function() {

            /**
             * Properties of a GetQrCodesActionProto.
             * @memberof waiternow.common
             * @interface IGetQrCodesActionProto
             */

            /**
             * Constructs a new GetQrCodesActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a GetQrCodesActionProto.
             * @implements IGetQrCodesActionProto
             * @constructor
             * @param {waiternow.common.IGetQrCodesActionProto=} [properties] Properties to set
             */
            function GetQrCodesActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new GetQrCodesActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.GetQrCodesActionProto
             * @static
             * @param {waiternow.common.IGetQrCodesActionProto=} [properties] Properties to set
             * @returns {waiternow.common.GetQrCodesActionProto} GetQrCodesActionProto instance
             */
            GetQrCodesActionProto.create = function create(properties) {
                return new GetQrCodesActionProto(properties);
            };

            /**
             * Encodes the specified GetQrCodesActionProto message. Does not implicitly {@link waiternow.common.GetQrCodesActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.GetQrCodesActionProto
             * @static
             * @param {waiternow.common.IGetQrCodesActionProto} message GetQrCodesActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetQrCodesActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified GetQrCodesActionProto message, length delimited. Does not implicitly {@link waiternow.common.GetQrCodesActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.GetQrCodesActionProto
             * @static
             * @param {waiternow.common.IGetQrCodesActionProto} message GetQrCodesActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetQrCodesActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetQrCodesActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.GetQrCodesActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.GetQrCodesActionProto} GetQrCodesActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetQrCodesActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetQrCodesActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetQrCodesActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.GetQrCodesActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.GetQrCodesActionProto} GetQrCodesActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetQrCodesActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetQrCodesActionProto message.
             * @function verify
             * @memberof waiternow.common.GetQrCodesActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetQrCodesActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a GetQrCodesActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.GetQrCodesActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.GetQrCodesActionProto} GetQrCodesActionProto
             */
            GetQrCodesActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.GetQrCodesActionProto)
                    return object;
                return new $root.waiternow.common.GetQrCodesActionProto();
            };

            /**
             * Creates a plain object from a GetQrCodesActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.GetQrCodesActionProto
             * @static
             * @param {waiternow.common.GetQrCodesActionProto} message GetQrCodesActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetQrCodesActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this GetQrCodesActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.GetQrCodesActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetQrCodesActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for GetQrCodesActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.GetQrCodesActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            GetQrCodesActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.GetQrCodesActionProto";
            };

            GetQrCodesActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.GetQrCodesActionProto
                 * @interface IRequest
                 * @property {string|null} [locationId] Request locationId
                 * @property {string|null} [pointOfServiceId] Request pointOfServiceId
                 * @property {string|null} [businessId] Request businessId
                 * @property {waiternow.common.QrCodeSize|null} [qrCodeSize] Request qrCodeSize
                 * @property {waiternow.common.Language|null} [language] Request language
                 * @property {waiternow.common.Theme|null} [theme] Request theme
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.GetQrCodesActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.GetQrCodesActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request locationId.
                 * @member {string|null|undefined} locationId
                 * @memberof waiternow.common.GetQrCodesActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = null;

                /**
                 * Request pointOfServiceId.
                 * @member {string|null|undefined} pointOfServiceId
                 * @memberof waiternow.common.GetQrCodesActionProto.Request
                 * @instance
                 */
                Request.prototype.pointOfServiceId = null;

                /**
                 * Request businessId.
                 * @member {string|null|undefined} businessId
                 * @memberof waiternow.common.GetQrCodesActionProto.Request
                 * @instance
                 */
                Request.prototype.businessId = null;

                /**
                 * Request qrCodeSize.
                 * @member {waiternow.common.QrCodeSize} qrCodeSize
                 * @memberof waiternow.common.GetQrCodesActionProto.Request
                 * @instance
                 */
                Request.prototype.qrCodeSize = 0;

                /**
                 * Request language.
                 * @member {waiternow.common.Language} language
                 * @memberof waiternow.common.GetQrCodesActionProto.Request
                 * @instance
                 */
                Request.prototype.language = 0;

                /**
                 * Request theme.
                 * @member {waiternow.common.Theme} theme
                 * @memberof waiternow.common.GetQrCodesActionProto.Request
                 * @instance
                 */
                Request.prototype.theme = 0;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * Request subject.
                 * @member {"locationId"|"pointOfServiceId"|"businessId"|undefined} subject
                 * @memberof waiternow.common.GetQrCodesActionProto.Request
                 * @instance
                 */
                Object.defineProperty(Request.prototype, "subject", {
                    get: $util.oneOfGetter($oneOfFields = ["locationId", "pointOfServiceId", "businessId"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetQrCodesActionProto.Request
                 * @static
                 * @param {waiternow.common.GetQrCodesActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.GetQrCodesActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.GetQrCodesActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetQrCodesActionProto.Request
                 * @static
                 * @param {waiternow.common.GetQrCodesActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    if (message.pointOfServiceId != null && Object.hasOwnProperty.call(message, "pointOfServiceId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.pointOfServiceId);
                    if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.businessId);
                    if (message.qrCodeSize != null && Object.hasOwnProperty.call(message, "qrCodeSize"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.qrCodeSize);
                    if (message.language != null && Object.hasOwnProperty.call(message, "language"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int32(message.language);
                    if (message.theme != null && Object.hasOwnProperty.call(message, "theme"))
                        writer.uint32(/* id 6, wireType 0 =*/48).int32(message.theme);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.GetQrCodesActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetQrCodesActionProto.Request
                 * @static
                 * @param {waiternow.common.GetQrCodesActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetQrCodesActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetQrCodesActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetQrCodesActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 2: {
                                message.pointOfServiceId = reader.string();
                                break;
                            }
                        case 3: {
                                message.businessId = reader.string();
                                break;
                            }
                        case 4: {
                                message.qrCodeSize = reader.int32();
                                break;
                            }
                        case 5: {
                                message.language = reader.int32();
                                break;
                            }
                        case 6: {
                                message.theme = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetQrCodesActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetQrCodesActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.GetQrCodesActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.locationId != null && message.hasOwnProperty("locationId")) {
                        properties.subject = 1;
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    }
                    if (message.pointOfServiceId != null && message.hasOwnProperty("pointOfServiceId")) {
                        if (properties.subject === 1)
                            return "subject: multiple values";
                        properties.subject = 1;
                        if (!$util.isString(message.pointOfServiceId))
                            return "pointOfServiceId: string expected";
                    }
                    if (message.businessId != null && message.hasOwnProperty("businessId")) {
                        if (properties.subject === 1)
                            return "subject: multiple values";
                        properties.subject = 1;
                        if (!$util.isString(message.businessId))
                            return "businessId: string expected";
                    }
                    if (message.qrCodeSize != null && message.hasOwnProperty("qrCodeSize"))
                        switch (message.qrCodeSize) {
                        default:
                            return "qrCodeSize: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                            break;
                        }
                    if (message.language != null && message.hasOwnProperty("language"))
                        switch (message.language) {
                        default:
                            return "language: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.theme != null && message.hasOwnProperty("theme"))
                        switch (message.theme) {
                        default:
                            return "theme: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetQrCodesActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetQrCodesActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetQrCodesActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.GetQrCodesActionProto.Request();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    if (object.pointOfServiceId != null)
                        message.pointOfServiceId = String(object.pointOfServiceId);
                    if (object.businessId != null)
                        message.businessId = String(object.businessId);
                    switch (object.qrCodeSize) {
                    default:
                        if (typeof object.qrCodeSize === "number") {
                            message.qrCodeSize = object.qrCodeSize;
                            break;
                        }
                        break;
                    case "QR_CODE_SIZE_UNSPECIFIED":
                    case 0:
                        message.qrCodeSize = 0;
                        break;
                    case "SMALL":
                    case 1:
                        message.qrCodeSize = 1;
                        break;
                    case "SMALL_RAW":
                    case 2:
                        message.qrCodeSize = 2;
                        break;
                    case "SIZE_4_BY_3_INCH":
                    case 3:
                        message.qrCodeSize = 3;
                        break;
                    case "SIZE_4_BY_4_INCH":
                    case 4:
                        message.qrCodeSize = 4;
                        break;
                    case "SIZE_4_BY_6_INCH":
                    case 5:
                        message.qrCodeSize = 5;
                        break;
                    }
                    switch (object.language) {
                    default:
                        if (typeof object.language === "number") {
                            message.language = object.language;
                            break;
                        }
                        break;
                    case "LANGUAGE_UNSPECIFIED":
                    case 0:
                        message.language = 0;
                        break;
                    case "ENGLISH":
                    case 1:
                        message.language = 1;
                        break;
                    case "SPANISH":
                    case 2:
                        message.language = 2;
                        break;
                    }
                    switch (object.theme) {
                    default:
                        if (typeof object.theme === "number") {
                            message.theme = object.theme;
                            break;
                        }
                        break;
                    case "THEME_UNSPECIFIED":
                    case 0:
                        message.theme = 0;
                        break;
                    case "DARK":
                    case 1:
                        message.theme = 1;
                        break;
                    case "LIGHT":
                    case 2:
                        message.theme = 2;
                        break;
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetQrCodesActionProto.Request
                 * @static
                 * @param {waiternow.common.GetQrCodesActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.qrCodeSize = options.enums === String ? "QR_CODE_SIZE_UNSPECIFIED" : 0;
                        object.language = options.enums === String ? "LANGUAGE_UNSPECIFIED" : 0;
                        object.theme = options.enums === String ? "THEME_UNSPECIFIED" : 0;
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId")) {
                        object.locationId = message.locationId;
                        if (options.oneofs)
                            object.subject = "locationId";
                    }
                    if (message.pointOfServiceId != null && message.hasOwnProperty("pointOfServiceId")) {
                        object.pointOfServiceId = message.pointOfServiceId;
                        if (options.oneofs)
                            object.subject = "pointOfServiceId";
                    }
                    if (message.businessId != null && message.hasOwnProperty("businessId")) {
                        object.businessId = message.businessId;
                        if (options.oneofs)
                            object.subject = "businessId";
                    }
                    if (message.qrCodeSize != null && message.hasOwnProperty("qrCodeSize"))
                        object.qrCodeSize = options.enums === String ? $root.waiternow.common.QrCodeSize[message.qrCodeSize] === undefined ? message.qrCodeSize : $root.waiternow.common.QrCodeSize[message.qrCodeSize] : message.qrCodeSize;
                    if (message.language != null && message.hasOwnProperty("language"))
                        object.language = options.enums === String ? $root.waiternow.common.Language[message.language] === undefined ? message.language : $root.waiternow.common.Language[message.language] : message.language;
                    if (message.theme != null && message.hasOwnProperty("theme"))
                        object.theme = options.enums === String ? $root.waiternow.common.Theme[message.theme] === undefined ? message.theme : $root.waiternow.common.Theme[message.theme] : message.theme;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetQrCodesActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetQrCodesActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetQrCodesActionProto.Request";
                };

                return Request;
            })();

            GetQrCodesActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.GetQrCodesActionProto
                 * @interface IResponse
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.GetQrCodesActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.GetQrCodesActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetQrCodesActionProto.Response
                 * @static
                 * @param {waiternow.common.GetQrCodesActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.GetQrCodesActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.GetQrCodesActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetQrCodesActionProto.Response
                 * @static
                 * @param {waiternow.common.GetQrCodesActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.GetQrCodesActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetQrCodesActionProto.Response
                 * @static
                 * @param {waiternow.common.GetQrCodesActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetQrCodesActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetQrCodesActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetQrCodesActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetQrCodesActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetQrCodesActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.GetQrCodesActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetQrCodesActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetQrCodesActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetQrCodesActionProto.Response)
                        return object;
                    return new $root.waiternow.common.GetQrCodesActionProto.Response();
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetQrCodesActionProto.Response
                 * @static
                 * @param {waiternow.common.GetQrCodesActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject() {
                    return {};
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetQrCodesActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetQrCodesActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetQrCodesActionProto.Response";
                };

                return Response;
            })();

            return GetQrCodesActionProto;
        })();

        common.GetOrderActionProto = (function() {

            /**
             * Properties of a GetOrderActionProto.
             * @memberof waiternow.common
             * @interface IGetOrderActionProto
             */

            /**
             * Constructs a new GetOrderActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a GetOrderActionProto.
             * @implements IGetOrderActionProto
             * @constructor
             * @param {waiternow.common.IGetOrderActionProto=} [properties] Properties to set
             */
            function GetOrderActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new GetOrderActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.GetOrderActionProto
             * @static
             * @param {waiternow.common.IGetOrderActionProto=} [properties] Properties to set
             * @returns {waiternow.common.GetOrderActionProto} GetOrderActionProto instance
             */
            GetOrderActionProto.create = function create(properties) {
                return new GetOrderActionProto(properties);
            };

            /**
             * Encodes the specified GetOrderActionProto message. Does not implicitly {@link waiternow.common.GetOrderActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.GetOrderActionProto
             * @static
             * @param {waiternow.common.IGetOrderActionProto} message GetOrderActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetOrderActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified GetOrderActionProto message, length delimited. Does not implicitly {@link waiternow.common.GetOrderActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.GetOrderActionProto
             * @static
             * @param {waiternow.common.IGetOrderActionProto} message GetOrderActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetOrderActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetOrderActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.GetOrderActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.GetOrderActionProto} GetOrderActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetOrderActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetOrderActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetOrderActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.GetOrderActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.GetOrderActionProto} GetOrderActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetOrderActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetOrderActionProto message.
             * @function verify
             * @memberof waiternow.common.GetOrderActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetOrderActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a GetOrderActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.GetOrderActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.GetOrderActionProto} GetOrderActionProto
             */
            GetOrderActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.GetOrderActionProto)
                    return object;
                return new $root.waiternow.common.GetOrderActionProto();
            };

            /**
             * Creates a plain object from a GetOrderActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.GetOrderActionProto
             * @static
             * @param {waiternow.common.GetOrderActionProto} message GetOrderActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetOrderActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this GetOrderActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.GetOrderActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetOrderActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for GetOrderActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.GetOrderActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            GetOrderActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.GetOrderActionProto";
            };

            GetOrderActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.GetOrderActionProto
                 * @interface IRequest
                 * @property {string|null} [orderId] Request orderId
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.GetOrderActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.GetOrderActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request orderId.
                 * @member {string} orderId
                 * @memberof waiternow.common.GetOrderActionProto.Request
                 * @instance
                 */
                Request.prototype.orderId = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetOrderActionProto.Request
                 * @static
                 * @param {waiternow.common.GetOrderActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.GetOrderActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.GetOrderActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetOrderActionProto.Request
                 * @static
                 * @param {waiternow.common.GetOrderActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.orderId != null && Object.hasOwnProperty.call(message, "orderId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.orderId);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.GetOrderActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetOrderActionProto.Request
                 * @static
                 * @param {waiternow.common.GetOrderActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetOrderActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetOrderActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetOrderActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.orderId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetOrderActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetOrderActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.GetOrderActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.orderId != null && message.hasOwnProperty("orderId"))
                        if (!$util.isString(message.orderId))
                            return "orderId: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetOrderActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetOrderActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetOrderActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.GetOrderActionProto.Request();
                    if (object.orderId != null)
                        message.orderId = String(object.orderId);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetOrderActionProto.Request
                 * @static
                 * @param {waiternow.common.GetOrderActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.orderId = "";
                    if (message.orderId != null && message.hasOwnProperty("orderId"))
                        object.orderId = message.orderId;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetOrderActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetOrderActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetOrderActionProto.Request";
                };

                return Request;
            })();

            GetOrderActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.GetOrderActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IOrderProto|null} [order] Response order
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.GetOrderActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.GetOrderActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.GetOrderActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response order.
                 * @member {waiternow.common.IOrderProto|null|undefined} order
                 * @memberof waiternow.common.GetOrderActionProto.Response
                 * @instance
                 */
                Response.prototype.order = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetOrderActionProto.Response
                 * @static
                 * @param {waiternow.common.GetOrderActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.GetOrderActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.GetOrderActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetOrderActionProto.Response
                 * @static
                 * @param {waiternow.common.GetOrderActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.order != null && Object.hasOwnProperty.call(message, "order"))
                        $root.waiternow.common.OrderProto.encode(message.order, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.GetOrderActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetOrderActionProto.Response
                 * @static
                 * @param {waiternow.common.GetOrderActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetOrderActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetOrderActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetOrderActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.order = $root.waiternow.common.OrderProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetOrderActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetOrderActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.GetOrderActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.order != null && message.hasOwnProperty("order")) {
                        var error = $root.waiternow.common.OrderProto.verify(message.order);
                        if (error)
                            return "order." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetOrderActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetOrderActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetOrderActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.GetOrderActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.GetOrderActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.order != null) {
                        if (typeof object.order !== "object")
                            throw TypeError(".waiternow.common.GetOrderActionProto.Response.order: object expected");
                        message.order = $root.waiternow.common.OrderProto.fromObject(object.order);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetOrderActionProto.Response
                 * @static
                 * @param {waiternow.common.GetOrderActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.order = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.order != null && message.hasOwnProperty("order"))
                        object.order = $root.waiternow.common.OrderProto.toObject(message.order, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetOrderActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetOrderActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetOrderActionProto.Response";
                };

                return Response;
            })();

            return GetOrderActionProto;
        })();

        common.AckOrderActionProto = (function() {

            /**
             * Properties of an AckOrderActionProto.
             * @memberof waiternow.common
             * @interface IAckOrderActionProto
             */

            /**
             * Constructs a new AckOrderActionProto.
             * @memberof waiternow.common
             * @classdesc Represents an AckOrderActionProto.
             * @implements IAckOrderActionProto
             * @constructor
             * @param {waiternow.common.IAckOrderActionProto=} [properties] Properties to set
             */
            function AckOrderActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new AckOrderActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.AckOrderActionProto
             * @static
             * @param {waiternow.common.IAckOrderActionProto=} [properties] Properties to set
             * @returns {waiternow.common.AckOrderActionProto} AckOrderActionProto instance
             */
            AckOrderActionProto.create = function create(properties) {
                return new AckOrderActionProto(properties);
            };

            /**
             * Encodes the specified AckOrderActionProto message. Does not implicitly {@link waiternow.common.AckOrderActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.AckOrderActionProto
             * @static
             * @param {waiternow.common.IAckOrderActionProto} message AckOrderActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AckOrderActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified AckOrderActionProto message, length delimited. Does not implicitly {@link waiternow.common.AckOrderActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.AckOrderActionProto
             * @static
             * @param {waiternow.common.IAckOrderActionProto} message AckOrderActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AckOrderActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AckOrderActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.AckOrderActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.AckOrderActionProto} AckOrderActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AckOrderActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.AckOrderActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AckOrderActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.AckOrderActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.AckOrderActionProto} AckOrderActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AckOrderActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AckOrderActionProto message.
             * @function verify
             * @memberof waiternow.common.AckOrderActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AckOrderActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates an AckOrderActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.AckOrderActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.AckOrderActionProto} AckOrderActionProto
             */
            AckOrderActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.AckOrderActionProto)
                    return object;
                return new $root.waiternow.common.AckOrderActionProto();
            };

            /**
             * Creates a plain object from an AckOrderActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.AckOrderActionProto
             * @static
             * @param {waiternow.common.AckOrderActionProto} message AckOrderActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AckOrderActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this AckOrderActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.AckOrderActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AckOrderActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for AckOrderActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.AckOrderActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            AckOrderActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.AckOrderActionProto";
            };

            AckOrderActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.AckOrderActionProto
                 * @interface IRequest
                 * @property {string|null} [orderId] Request orderId
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.AckOrderActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.AckOrderActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request orderId.
                 * @member {string} orderId
                 * @memberof waiternow.common.AckOrderActionProto.Request
                 * @instance
                 */
                Request.prototype.orderId = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.AckOrderActionProto.Request
                 * @static
                 * @param {waiternow.common.AckOrderActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.AckOrderActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.AckOrderActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.AckOrderActionProto.Request
                 * @static
                 * @param {waiternow.common.AckOrderActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.orderId != null && Object.hasOwnProperty.call(message, "orderId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.orderId);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.AckOrderActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.AckOrderActionProto.Request
                 * @static
                 * @param {waiternow.common.AckOrderActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.AckOrderActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.AckOrderActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.AckOrderActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.orderId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.AckOrderActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.AckOrderActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.AckOrderActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.orderId != null && message.hasOwnProperty("orderId"))
                        if (!$util.isString(message.orderId))
                            return "orderId: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.AckOrderActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.AckOrderActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.AckOrderActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.AckOrderActionProto.Request();
                    if (object.orderId != null)
                        message.orderId = String(object.orderId);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.AckOrderActionProto.Request
                 * @static
                 * @param {waiternow.common.AckOrderActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.orderId = "";
                    if (message.orderId != null && message.hasOwnProperty("orderId"))
                        object.orderId = message.orderId;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.AckOrderActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.AckOrderActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.AckOrderActionProto.Request";
                };

                return Request;
            })();

            AckOrderActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.AckOrderActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.AckOrderActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.AckOrderActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.AckOrderActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.AckOrderActionProto.Response
                 * @static
                 * @param {waiternow.common.AckOrderActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.AckOrderActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.AckOrderActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.AckOrderActionProto.Response
                 * @static
                 * @param {waiternow.common.AckOrderActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.AckOrderActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.AckOrderActionProto.Response
                 * @static
                 * @param {waiternow.common.AckOrderActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.AckOrderActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.AckOrderActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.AckOrderActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.AckOrderActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.AckOrderActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.AckOrderActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.AckOrderActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.AckOrderActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.AckOrderActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.AckOrderActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.AckOrderActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.AckOrderActionProto.Response
                 * @static
                 * @param {waiternow.common.AckOrderActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.AckOrderActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.AckOrderActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.AckOrderActionProto.Response";
                };

                return Response;
            })();

            return AckOrderActionProto;
        })();

        common.MarkOrderAsPrintedActionProto = (function() {

            /**
             * Properties of a MarkOrderAsPrintedActionProto.
             * @memberof waiternow.common
             * @interface IMarkOrderAsPrintedActionProto
             */

            /**
             * Constructs a new MarkOrderAsPrintedActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a MarkOrderAsPrintedActionProto.
             * @implements IMarkOrderAsPrintedActionProto
             * @constructor
             * @param {waiternow.common.IMarkOrderAsPrintedActionProto=} [properties] Properties to set
             */
            function MarkOrderAsPrintedActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new MarkOrderAsPrintedActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.MarkOrderAsPrintedActionProto
             * @static
             * @param {waiternow.common.IMarkOrderAsPrintedActionProto=} [properties] Properties to set
             * @returns {waiternow.common.MarkOrderAsPrintedActionProto} MarkOrderAsPrintedActionProto instance
             */
            MarkOrderAsPrintedActionProto.create = function create(properties) {
                return new MarkOrderAsPrintedActionProto(properties);
            };

            /**
             * Encodes the specified MarkOrderAsPrintedActionProto message. Does not implicitly {@link waiternow.common.MarkOrderAsPrintedActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.MarkOrderAsPrintedActionProto
             * @static
             * @param {waiternow.common.IMarkOrderAsPrintedActionProto} message MarkOrderAsPrintedActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MarkOrderAsPrintedActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified MarkOrderAsPrintedActionProto message, length delimited. Does not implicitly {@link waiternow.common.MarkOrderAsPrintedActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.MarkOrderAsPrintedActionProto
             * @static
             * @param {waiternow.common.IMarkOrderAsPrintedActionProto} message MarkOrderAsPrintedActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MarkOrderAsPrintedActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a MarkOrderAsPrintedActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.MarkOrderAsPrintedActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.MarkOrderAsPrintedActionProto} MarkOrderAsPrintedActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MarkOrderAsPrintedActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.MarkOrderAsPrintedActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a MarkOrderAsPrintedActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.MarkOrderAsPrintedActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.MarkOrderAsPrintedActionProto} MarkOrderAsPrintedActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MarkOrderAsPrintedActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a MarkOrderAsPrintedActionProto message.
             * @function verify
             * @memberof waiternow.common.MarkOrderAsPrintedActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            MarkOrderAsPrintedActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a MarkOrderAsPrintedActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.MarkOrderAsPrintedActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.MarkOrderAsPrintedActionProto} MarkOrderAsPrintedActionProto
             */
            MarkOrderAsPrintedActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.MarkOrderAsPrintedActionProto)
                    return object;
                return new $root.waiternow.common.MarkOrderAsPrintedActionProto();
            };

            /**
             * Creates a plain object from a MarkOrderAsPrintedActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.MarkOrderAsPrintedActionProto
             * @static
             * @param {waiternow.common.MarkOrderAsPrintedActionProto} message MarkOrderAsPrintedActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            MarkOrderAsPrintedActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this MarkOrderAsPrintedActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.MarkOrderAsPrintedActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            MarkOrderAsPrintedActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for MarkOrderAsPrintedActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.MarkOrderAsPrintedActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            MarkOrderAsPrintedActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.MarkOrderAsPrintedActionProto";
            };

            MarkOrderAsPrintedActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.MarkOrderAsPrintedActionProto
                 * @interface IRequest
                 * @property {string|null} [orderId] Request orderId
                 * @property {google.protobuf.ITimestamp|null} [printedAt] Request printedAt
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.MarkOrderAsPrintedActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.MarkOrderAsPrintedActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request orderId.
                 * @member {string} orderId
                 * @memberof waiternow.common.MarkOrderAsPrintedActionProto.Request
                 * @instance
                 */
                Request.prototype.orderId = "";

                /**
                 * Request printedAt.
                 * @member {google.protobuf.ITimestamp|null|undefined} printedAt
                 * @memberof waiternow.common.MarkOrderAsPrintedActionProto.Request
                 * @instance
                 */
                Request.prototype.printedAt = null;

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.MarkOrderAsPrintedActionProto.Request
                 * @static
                 * @param {waiternow.common.MarkOrderAsPrintedActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.MarkOrderAsPrintedActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.MarkOrderAsPrintedActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.MarkOrderAsPrintedActionProto.Request
                 * @static
                 * @param {waiternow.common.MarkOrderAsPrintedActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.orderId != null && Object.hasOwnProperty.call(message, "orderId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.orderId);
                    if (message.printedAt != null && Object.hasOwnProperty.call(message, "printedAt"))
                        $root.google.protobuf.Timestamp.encode(message.printedAt, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.MarkOrderAsPrintedActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.MarkOrderAsPrintedActionProto.Request
                 * @static
                 * @param {waiternow.common.MarkOrderAsPrintedActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.MarkOrderAsPrintedActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.MarkOrderAsPrintedActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.MarkOrderAsPrintedActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.orderId = reader.string();
                                break;
                            }
                        case 2: {
                                message.printedAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.MarkOrderAsPrintedActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.MarkOrderAsPrintedActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.MarkOrderAsPrintedActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.orderId != null && message.hasOwnProperty("orderId"))
                        if (!$util.isString(message.orderId))
                            return "orderId: string expected";
                    if (message.printedAt != null && message.hasOwnProperty("printedAt")) {
                        var error = $root.google.protobuf.Timestamp.verify(message.printedAt);
                        if (error)
                            return "printedAt." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.MarkOrderAsPrintedActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.MarkOrderAsPrintedActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.MarkOrderAsPrintedActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.MarkOrderAsPrintedActionProto.Request();
                    if (object.orderId != null)
                        message.orderId = String(object.orderId);
                    if (object.printedAt != null) {
                        if (typeof object.printedAt !== "object")
                            throw TypeError(".waiternow.common.MarkOrderAsPrintedActionProto.Request.printedAt: object expected");
                        message.printedAt = $root.google.protobuf.Timestamp.fromObject(object.printedAt);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.MarkOrderAsPrintedActionProto.Request
                 * @static
                 * @param {waiternow.common.MarkOrderAsPrintedActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.orderId = "";
                        object.printedAt = null;
                    }
                    if (message.orderId != null && message.hasOwnProperty("orderId"))
                        object.orderId = message.orderId;
                    if (message.printedAt != null && message.hasOwnProperty("printedAt"))
                        object.printedAt = $root.google.protobuf.Timestamp.toObject(message.printedAt, options);
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.MarkOrderAsPrintedActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.MarkOrderAsPrintedActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.MarkOrderAsPrintedActionProto.Request";
                };

                return Request;
            })();

            MarkOrderAsPrintedActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.MarkOrderAsPrintedActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.MarkOrderAsPrintedActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.MarkOrderAsPrintedActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.MarkOrderAsPrintedActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.MarkOrderAsPrintedActionProto.Response
                 * @static
                 * @param {waiternow.common.MarkOrderAsPrintedActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.MarkOrderAsPrintedActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.MarkOrderAsPrintedActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.MarkOrderAsPrintedActionProto.Response
                 * @static
                 * @param {waiternow.common.MarkOrderAsPrintedActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.MarkOrderAsPrintedActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.MarkOrderAsPrintedActionProto.Response
                 * @static
                 * @param {waiternow.common.MarkOrderAsPrintedActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.MarkOrderAsPrintedActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.MarkOrderAsPrintedActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.MarkOrderAsPrintedActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.MarkOrderAsPrintedActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.MarkOrderAsPrintedActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.MarkOrderAsPrintedActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.MarkOrderAsPrintedActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.MarkOrderAsPrintedActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.MarkOrderAsPrintedActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.MarkOrderAsPrintedActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.MarkOrderAsPrintedActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.MarkOrderAsPrintedActionProto.Response
                 * @static
                 * @param {waiternow.common.MarkOrderAsPrintedActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.MarkOrderAsPrintedActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.MarkOrderAsPrintedActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.MarkOrderAsPrintedActionProto.Response";
                };

                return Response;
            })();

            return MarkOrderAsPrintedActionProto;
        })();

        common.MarkOrderAsCompletedActionProto = (function() {

            /**
             * Properties of a MarkOrderAsCompletedActionProto.
             * @memberof waiternow.common
             * @interface IMarkOrderAsCompletedActionProto
             */

            /**
             * Constructs a new MarkOrderAsCompletedActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a MarkOrderAsCompletedActionProto.
             * @implements IMarkOrderAsCompletedActionProto
             * @constructor
             * @param {waiternow.common.IMarkOrderAsCompletedActionProto=} [properties] Properties to set
             */
            function MarkOrderAsCompletedActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new MarkOrderAsCompletedActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.MarkOrderAsCompletedActionProto
             * @static
             * @param {waiternow.common.IMarkOrderAsCompletedActionProto=} [properties] Properties to set
             * @returns {waiternow.common.MarkOrderAsCompletedActionProto} MarkOrderAsCompletedActionProto instance
             */
            MarkOrderAsCompletedActionProto.create = function create(properties) {
                return new MarkOrderAsCompletedActionProto(properties);
            };

            /**
             * Encodes the specified MarkOrderAsCompletedActionProto message. Does not implicitly {@link waiternow.common.MarkOrderAsCompletedActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.MarkOrderAsCompletedActionProto
             * @static
             * @param {waiternow.common.IMarkOrderAsCompletedActionProto} message MarkOrderAsCompletedActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MarkOrderAsCompletedActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified MarkOrderAsCompletedActionProto message, length delimited. Does not implicitly {@link waiternow.common.MarkOrderAsCompletedActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.MarkOrderAsCompletedActionProto
             * @static
             * @param {waiternow.common.IMarkOrderAsCompletedActionProto} message MarkOrderAsCompletedActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MarkOrderAsCompletedActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a MarkOrderAsCompletedActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.MarkOrderAsCompletedActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.MarkOrderAsCompletedActionProto} MarkOrderAsCompletedActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MarkOrderAsCompletedActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.MarkOrderAsCompletedActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a MarkOrderAsCompletedActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.MarkOrderAsCompletedActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.MarkOrderAsCompletedActionProto} MarkOrderAsCompletedActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MarkOrderAsCompletedActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a MarkOrderAsCompletedActionProto message.
             * @function verify
             * @memberof waiternow.common.MarkOrderAsCompletedActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            MarkOrderAsCompletedActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a MarkOrderAsCompletedActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.MarkOrderAsCompletedActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.MarkOrderAsCompletedActionProto} MarkOrderAsCompletedActionProto
             */
            MarkOrderAsCompletedActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.MarkOrderAsCompletedActionProto)
                    return object;
                return new $root.waiternow.common.MarkOrderAsCompletedActionProto();
            };

            /**
             * Creates a plain object from a MarkOrderAsCompletedActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.MarkOrderAsCompletedActionProto
             * @static
             * @param {waiternow.common.MarkOrderAsCompletedActionProto} message MarkOrderAsCompletedActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            MarkOrderAsCompletedActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this MarkOrderAsCompletedActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.MarkOrderAsCompletedActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            MarkOrderAsCompletedActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for MarkOrderAsCompletedActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.MarkOrderAsCompletedActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            MarkOrderAsCompletedActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.MarkOrderAsCompletedActionProto";
            };

            MarkOrderAsCompletedActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.MarkOrderAsCompletedActionProto
                 * @interface IRequest
                 * @property {string|null} [orderId] Request orderId
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.MarkOrderAsCompletedActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.MarkOrderAsCompletedActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request orderId.
                 * @member {string} orderId
                 * @memberof waiternow.common.MarkOrderAsCompletedActionProto.Request
                 * @instance
                 */
                Request.prototype.orderId = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.MarkOrderAsCompletedActionProto.Request
                 * @static
                 * @param {waiternow.common.MarkOrderAsCompletedActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.MarkOrderAsCompletedActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.MarkOrderAsCompletedActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.MarkOrderAsCompletedActionProto.Request
                 * @static
                 * @param {waiternow.common.MarkOrderAsCompletedActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.orderId != null && Object.hasOwnProperty.call(message, "orderId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.orderId);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.MarkOrderAsCompletedActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.MarkOrderAsCompletedActionProto.Request
                 * @static
                 * @param {waiternow.common.MarkOrderAsCompletedActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.MarkOrderAsCompletedActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.MarkOrderAsCompletedActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.MarkOrderAsCompletedActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.orderId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.MarkOrderAsCompletedActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.MarkOrderAsCompletedActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.MarkOrderAsCompletedActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.orderId != null && message.hasOwnProperty("orderId"))
                        if (!$util.isString(message.orderId))
                            return "orderId: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.MarkOrderAsCompletedActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.MarkOrderAsCompletedActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.MarkOrderAsCompletedActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.MarkOrderAsCompletedActionProto.Request();
                    if (object.orderId != null)
                        message.orderId = String(object.orderId);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.MarkOrderAsCompletedActionProto.Request
                 * @static
                 * @param {waiternow.common.MarkOrderAsCompletedActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.orderId = "";
                    if (message.orderId != null && message.hasOwnProperty("orderId"))
                        object.orderId = message.orderId;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.MarkOrderAsCompletedActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.MarkOrderAsCompletedActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.MarkOrderAsCompletedActionProto.Request";
                };

                return Request;
            })();

            MarkOrderAsCompletedActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.MarkOrderAsCompletedActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.MarkOrderAsCompletedActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.MarkOrderAsCompletedActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.MarkOrderAsCompletedActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.MarkOrderAsCompletedActionProto.Response
                 * @static
                 * @param {waiternow.common.MarkOrderAsCompletedActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.MarkOrderAsCompletedActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.MarkOrderAsCompletedActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.MarkOrderAsCompletedActionProto.Response
                 * @static
                 * @param {waiternow.common.MarkOrderAsCompletedActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.MarkOrderAsCompletedActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.MarkOrderAsCompletedActionProto.Response
                 * @static
                 * @param {waiternow.common.MarkOrderAsCompletedActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.MarkOrderAsCompletedActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.MarkOrderAsCompletedActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.MarkOrderAsCompletedActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.MarkOrderAsCompletedActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.MarkOrderAsCompletedActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.MarkOrderAsCompletedActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.MarkOrderAsCompletedActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.MarkOrderAsCompletedActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.MarkOrderAsCompletedActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.MarkOrderAsCompletedActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.MarkOrderAsCompletedActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.MarkOrderAsCompletedActionProto.Response
                 * @static
                 * @param {waiternow.common.MarkOrderAsCompletedActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.MarkOrderAsCompletedActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.MarkOrderAsCompletedActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.MarkOrderAsCompletedActionProto.Response";
                };

                return Response;
            })();

            return MarkOrderAsCompletedActionProto;
        })();

        common.MarkOrderAsDisputedActionProto = (function() {

            /**
             * Properties of a MarkOrderAsDisputedActionProto.
             * @memberof waiternow.common
             * @interface IMarkOrderAsDisputedActionProto
             */

            /**
             * Constructs a new MarkOrderAsDisputedActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a MarkOrderAsDisputedActionProto.
             * @implements IMarkOrderAsDisputedActionProto
             * @constructor
             * @param {waiternow.common.IMarkOrderAsDisputedActionProto=} [properties] Properties to set
             */
            function MarkOrderAsDisputedActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new MarkOrderAsDisputedActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.MarkOrderAsDisputedActionProto
             * @static
             * @param {waiternow.common.IMarkOrderAsDisputedActionProto=} [properties] Properties to set
             * @returns {waiternow.common.MarkOrderAsDisputedActionProto} MarkOrderAsDisputedActionProto instance
             */
            MarkOrderAsDisputedActionProto.create = function create(properties) {
                return new MarkOrderAsDisputedActionProto(properties);
            };

            /**
             * Encodes the specified MarkOrderAsDisputedActionProto message. Does not implicitly {@link waiternow.common.MarkOrderAsDisputedActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.MarkOrderAsDisputedActionProto
             * @static
             * @param {waiternow.common.IMarkOrderAsDisputedActionProto} message MarkOrderAsDisputedActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MarkOrderAsDisputedActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified MarkOrderAsDisputedActionProto message, length delimited. Does not implicitly {@link waiternow.common.MarkOrderAsDisputedActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.MarkOrderAsDisputedActionProto
             * @static
             * @param {waiternow.common.IMarkOrderAsDisputedActionProto} message MarkOrderAsDisputedActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MarkOrderAsDisputedActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a MarkOrderAsDisputedActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.MarkOrderAsDisputedActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.MarkOrderAsDisputedActionProto} MarkOrderAsDisputedActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MarkOrderAsDisputedActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.MarkOrderAsDisputedActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a MarkOrderAsDisputedActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.MarkOrderAsDisputedActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.MarkOrderAsDisputedActionProto} MarkOrderAsDisputedActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MarkOrderAsDisputedActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a MarkOrderAsDisputedActionProto message.
             * @function verify
             * @memberof waiternow.common.MarkOrderAsDisputedActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            MarkOrderAsDisputedActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a MarkOrderAsDisputedActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.MarkOrderAsDisputedActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.MarkOrderAsDisputedActionProto} MarkOrderAsDisputedActionProto
             */
            MarkOrderAsDisputedActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.MarkOrderAsDisputedActionProto)
                    return object;
                return new $root.waiternow.common.MarkOrderAsDisputedActionProto();
            };

            /**
             * Creates a plain object from a MarkOrderAsDisputedActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.MarkOrderAsDisputedActionProto
             * @static
             * @param {waiternow.common.MarkOrderAsDisputedActionProto} message MarkOrderAsDisputedActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            MarkOrderAsDisputedActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this MarkOrderAsDisputedActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.MarkOrderAsDisputedActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            MarkOrderAsDisputedActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for MarkOrderAsDisputedActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.MarkOrderAsDisputedActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            MarkOrderAsDisputedActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.MarkOrderAsDisputedActionProto";
            };

            MarkOrderAsDisputedActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.MarkOrderAsDisputedActionProto
                 * @interface IRequest
                 * @property {string|null} [orderId] Request orderId
                 * @property {waiternow.common.IDateProto|null} [disputeDate] Request disputeDate
                 * @property {string|null} [reason] Request reason
                 * @property {boolean|null} [notifyBusiness] Request notifyBusiness
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.MarkOrderAsDisputedActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.MarkOrderAsDisputedActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request orderId.
                 * @member {string} orderId
                 * @memberof waiternow.common.MarkOrderAsDisputedActionProto.Request
                 * @instance
                 */
                Request.prototype.orderId = "";

                /**
                 * Request disputeDate.
                 * @member {waiternow.common.IDateProto|null|undefined} disputeDate
                 * @memberof waiternow.common.MarkOrderAsDisputedActionProto.Request
                 * @instance
                 */
                Request.prototype.disputeDate = null;

                /**
                 * Request reason.
                 * @member {string} reason
                 * @memberof waiternow.common.MarkOrderAsDisputedActionProto.Request
                 * @instance
                 */
                Request.prototype.reason = "";

                /**
                 * Request notifyBusiness.
                 * @member {boolean} notifyBusiness
                 * @memberof waiternow.common.MarkOrderAsDisputedActionProto.Request
                 * @instance
                 */
                Request.prototype.notifyBusiness = false;

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.MarkOrderAsDisputedActionProto.Request
                 * @static
                 * @param {waiternow.common.MarkOrderAsDisputedActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.MarkOrderAsDisputedActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.MarkOrderAsDisputedActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.MarkOrderAsDisputedActionProto.Request
                 * @static
                 * @param {waiternow.common.MarkOrderAsDisputedActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.orderId != null && Object.hasOwnProperty.call(message, "orderId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.orderId);
                    if (message.disputeDate != null && Object.hasOwnProperty.call(message, "disputeDate"))
                        $root.waiternow.common.DateProto.encode(message.disputeDate, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.reason != null && Object.hasOwnProperty.call(message, "reason"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.reason);
                    if (message.notifyBusiness != null && Object.hasOwnProperty.call(message, "notifyBusiness"))
                        writer.uint32(/* id 4, wireType 0 =*/32).bool(message.notifyBusiness);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.MarkOrderAsDisputedActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.MarkOrderAsDisputedActionProto.Request
                 * @static
                 * @param {waiternow.common.MarkOrderAsDisputedActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.MarkOrderAsDisputedActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.MarkOrderAsDisputedActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.MarkOrderAsDisputedActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.orderId = reader.string();
                                break;
                            }
                        case 2: {
                                message.disputeDate = $root.waiternow.common.DateProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.reason = reader.string();
                                break;
                            }
                        case 4: {
                                message.notifyBusiness = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.MarkOrderAsDisputedActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.MarkOrderAsDisputedActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.MarkOrderAsDisputedActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.orderId != null && message.hasOwnProperty("orderId"))
                        if (!$util.isString(message.orderId))
                            return "orderId: string expected";
                    if (message.disputeDate != null && message.hasOwnProperty("disputeDate")) {
                        var error = $root.waiternow.common.DateProto.verify(message.disputeDate);
                        if (error)
                            return "disputeDate." + error;
                    }
                    if (message.reason != null && message.hasOwnProperty("reason"))
                        if (!$util.isString(message.reason))
                            return "reason: string expected";
                    if (message.notifyBusiness != null && message.hasOwnProperty("notifyBusiness"))
                        if (typeof message.notifyBusiness !== "boolean")
                            return "notifyBusiness: boolean expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.MarkOrderAsDisputedActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.MarkOrderAsDisputedActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.MarkOrderAsDisputedActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.MarkOrderAsDisputedActionProto.Request();
                    if (object.orderId != null)
                        message.orderId = String(object.orderId);
                    if (object.disputeDate != null) {
                        if (typeof object.disputeDate !== "object")
                            throw TypeError(".waiternow.common.MarkOrderAsDisputedActionProto.Request.disputeDate: object expected");
                        message.disputeDate = $root.waiternow.common.DateProto.fromObject(object.disputeDate);
                    }
                    if (object.reason != null)
                        message.reason = String(object.reason);
                    if (object.notifyBusiness != null)
                        message.notifyBusiness = Boolean(object.notifyBusiness);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.MarkOrderAsDisputedActionProto.Request
                 * @static
                 * @param {waiternow.common.MarkOrderAsDisputedActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.orderId = "";
                        object.disputeDate = null;
                        object.reason = "";
                        object.notifyBusiness = false;
                    }
                    if (message.orderId != null && message.hasOwnProperty("orderId"))
                        object.orderId = message.orderId;
                    if (message.disputeDate != null && message.hasOwnProperty("disputeDate"))
                        object.disputeDate = $root.waiternow.common.DateProto.toObject(message.disputeDate, options);
                    if (message.reason != null && message.hasOwnProperty("reason"))
                        object.reason = message.reason;
                    if (message.notifyBusiness != null && message.hasOwnProperty("notifyBusiness"))
                        object.notifyBusiness = message.notifyBusiness;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.MarkOrderAsDisputedActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.MarkOrderAsDisputedActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.MarkOrderAsDisputedActionProto.Request";
                };

                return Request;
            })();

            MarkOrderAsDisputedActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.MarkOrderAsDisputedActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.MarkOrderAsDisputedActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.MarkOrderAsDisputedActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.MarkOrderAsDisputedActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.MarkOrderAsDisputedActionProto.Response
                 * @static
                 * @param {waiternow.common.MarkOrderAsDisputedActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.MarkOrderAsDisputedActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.MarkOrderAsDisputedActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.MarkOrderAsDisputedActionProto.Response
                 * @static
                 * @param {waiternow.common.MarkOrderAsDisputedActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.MarkOrderAsDisputedActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.MarkOrderAsDisputedActionProto.Response
                 * @static
                 * @param {waiternow.common.MarkOrderAsDisputedActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.MarkOrderAsDisputedActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.MarkOrderAsDisputedActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.MarkOrderAsDisputedActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.MarkOrderAsDisputedActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.MarkOrderAsDisputedActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.MarkOrderAsDisputedActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.MarkOrderAsDisputedActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.MarkOrderAsDisputedActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.MarkOrderAsDisputedActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.MarkOrderAsDisputedActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.MarkOrderAsDisputedActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.MarkOrderAsDisputedActionProto.Response
                 * @static
                 * @param {waiternow.common.MarkOrderAsDisputedActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.MarkOrderAsDisputedActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.MarkOrderAsDisputedActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.MarkOrderAsDisputedActionProto.Response";
                };

                return Response;
            })();

            return MarkOrderAsDisputedActionProto;
        })();

        common.FindUnackedOrdersActionProto = (function() {

            /**
             * Properties of a FindUnackedOrdersActionProto.
             * @memberof waiternow.common
             * @interface IFindUnackedOrdersActionProto
             */

            /**
             * Constructs a new FindUnackedOrdersActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a FindUnackedOrdersActionProto.
             * @implements IFindUnackedOrdersActionProto
             * @constructor
             * @param {waiternow.common.IFindUnackedOrdersActionProto=} [properties] Properties to set
             */
            function FindUnackedOrdersActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new FindUnackedOrdersActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FindUnackedOrdersActionProto
             * @static
             * @param {waiternow.common.IFindUnackedOrdersActionProto=} [properties] Properties to set
             * @returns {waiternow.common.FindUnackedOrdersActionProto} FindUnackedOrdersActionProto instance
             */
            FindUnackedOrdersActionProto.create = function create(properties) {
                return new FindUnackedOrdersActionProto(properties);
            };

            /**
             * Encodes the specified FindUnackedOrdersActionProto message. Does not implicitly {@link waiternow.common.FindUnackedOrdersActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FindUnackedOrdersActionProto
             * @static
             * @param {waiternow.common.IFindUnackedOrdersActionProto} message FindUnackedOrdersActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindUnackedOrdersActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified FindUnackedOrdersActionProto message, length delimited. Does not implicitly {@link waiternow.common.FindUnackedOrdersActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FindUnackedOrdersActionProto
             * @static
             * @param {waiternow.common.IFindUnackedOrdersActionProto} message FindUnackedOrdersActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindUnackedOrdersActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FindUnackedOrdersActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FindUnackedOrdersActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FindUnackedOrdersActionProto} FindUnackedOrdersActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindUnackedOrdersActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindUnackedOrdersActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FindUnackedOrdersActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FindUnackedOrdersActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FindUnackedOrdersActionProto} FindUnackedOrdersActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindUnackedOrdersActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FindUnackedOrdersActionProto message.
             * @function verify
             * @memberof waiternow.common.FindUnackedOrdersActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FindUnackedOrdersActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a FindUnackedOrdersActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FindUnackedOrdersActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FindUnackedOrdersActionProto} FindUnackedOrdersActionProto
             */
            FindUnackedOrdersActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FindUnackedOrdersActionProto)
                    return object;
                return new $root.waiternow.common.FindUnackedOrdersActionProto();
            };

            /**
             * Creates a plain object from a FindUnackedOrdersActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FindUnackedOrdersActionProto
             * @static
             * @param {waiternow.common.FindUnackedOrdersActionProto} message FindUnackedOrdersActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FindUnackedOrdersActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this FindUnackedOrdersActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FindUnackedOrdersActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FindUnackedOrdersActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FindUnackedOrdersActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.FindUnackedOrdersActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FindUnackedOrdersActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FindUnackedOrdersActionProto";
            };

            FindUnackedOrdersActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.FindUnackedOrdersActionProto
                 * @interface IRequest
                 * @property {string|null} [locationId] Request locationId
                 * @property {string|null} [continuationToken] Request continuationToken
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.FindUnackedOrdersActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.FindUnackedOrdersActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.FindUnackedOrdersActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = "";

                /**
                 * Request continuationToken.
                 * @member {string} continuationToken
                 * @memberof waiternow.common.FindUnackedOrdersActionProto.Request
                 * @instance
                 */
                Request.prototype.continuationToken = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindUnackedOrdersActionProto.Request
                 * @static
                 * @param {waiternow.common.FindUnackedOrdersActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.FindUnackedOrdersActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.FindUnackedOrdersActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindUnackedOrdersActionProto.Request
                 * @static
                 * @param {waiternow.common.FindUnackedOrdersActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.continuationToken);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.FindUnackedOrdersActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindUnackedOrdersActionProto.Request
                 * @static
                 * @param {waiternow.common.FindUnackedOrdersActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindUnackedOrdersActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindUnackedOrdersActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindUnackedOrdersActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 2: {
                                message.continuationToken = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindUnackedOrdersActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindUnackedOrdersActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.FindUnackedOrdersActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        if (!$util.isString(message.continuationToken))
                            return "continuationToken: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindUnackedOrdersActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindUnackedOrdersActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindUnackedOrdersActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.FindUnackedOrdersActionProto.Request();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    if (object.continuationToken != null)
                        message.continuationToken = String(object.continuationToken);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindUnackedOrdersActionProto.Request
                 * @static
                 * @param {waiternow.common.FindUnackedOrdersActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.locationId = "";
                        object.continuationToken = "";
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        object.continuationToken = message.continuationToken;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindUnackedOrdersActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindUnackedOrdersActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindUnackedOrdersActionProto.Request";
                };

                return Request;
            })();

            FindUnackedOrdersActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.FindUnackedOrdersActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.ILocationOrdersProto|null} [locationOrders] Response locationOrders
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.FindUnackedOrdersActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.FindUnackedOrdersActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.FindUnackedOrdersActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response locationOrders.
                 * @member {waiternow.common.ILocationOrdersProto|null|undefined} locationOrders
                 * @memberof waiternow.common.FindUnackedOrdersActionProto.Response
                 * @instance
                 */
                Response.prototype.locationOrders = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindUnackedOrdersActionProto.Response
                 * @static
                 * @param {waiternow.common.FindUnackedOrdersActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.FindUnackedOrdersActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.FindUnackedOrdersActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindUnackedOrdersActionProto.Response
                 * @static
                 * @param {waiternow.common.FindUnackedOrdersActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.locationOrders != null && Object.hasOwnProperty.call(message, "locationOrders"))
                        $root.waiternow.common.LocationOrdersProto.encode(message.locationOrders, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.FindUnackedOrdersActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindUnackedOrdersActionProto.Response
                 * @static
                 * @param {waiternow.common.FindUnackedOrdersActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindUnackedOrdersActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindUnackedOrdersActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindUnackedOrdersActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.locationOrders = $root.waiternow.common.LocationOrdersProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindUnackedOrdersActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindUnackedOrdersActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.FindUnackedOrdersActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.locationOrders != null && message.hasOwnProperty("locationOrders")) {
                        var error = $root.waiternow.common.LocationOrdersProto.verify(message.locationOrders);
                        if (error)
                            return "locationOrders." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindUnackedOrdersActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindUnackedOrdersActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindUnackedOrdersActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.FindUnackedOrdersActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.FindUnackedOrdersActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.locationOrders != null) {
                        if (typeof object.locationOrders !== "object")
                            throw TypeError(".waiternow.common.FindUnackedOrdersActionProto.Response.locationOrders: object expected");
                        message.locationOrders = $root.waiternow.common.LocationOrdersProto.fromObject(object.locationOrders);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindUnackedOrdersActionProto.Response
                 * @static
                 * @param {waiternow.common.FindUnackedOrdersActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.locationOrders = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.locationOrders != null && message.hasOwnProperty("locationOrders"))
                        object.locationOrders = $root.waiternow.common.LocationOrdersProto.toObject(message.locationOrders, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindUnackedOrdersActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindUnackedOrdersActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindUnackedOrdersActionProto.Response";
                };

                return Response;
            })();

            return FindUnackedOrdersActionProto;
        })();

        common.FindUnackedAndPaidOrdersActionProto = (function() {

            /**
             * Properties of a FindUnackedAndPaidOrdersActionProto.
             * @memberof waiternow.common
             * @interface IFindUnackedAndPaidOrdersActionProto
             */

            /**
             * Constructs a new FindUnackedAndPaidOrdersActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a FindUnackedAndPaidOrdersActionProto.
             * @implements IFindUnackedAndPaidOrdersActionProto
             * @constructor
             * @param {waiternow.common.IFindUnackedAndPaidOrdersActionProto=} [properties] Properties to set
             */
            function FindUnackedAndPaidOrdersActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new FindUnackedAndPaidOrdersActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FindUnackedAndPaidOrdersActionProto
             * @static
             * @param {waiternow.common.IFindUnackedAndPaidOrdersActionProto=} [properties] Properties to set
             * @returns {waiternow.common.FindUnackedAndPaidOrdersActionProto} FindUnackedAndPaidOrdersActionProto instance
             */
            FindUnackedAndPaidOrdersActionProto.create = function create(properties) {
                return new FindUnackedAndPaidOrdersActionProto(properties);
            };

            /**
             * Encodes the specified FindUnackedAndPaidOrdersActionProto message. Does not implicitly {@link waiternow.common.FindUnackedAndPaidOrdersActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FindUnackedAndPaidOrdersActionProto
             * @static
             * @param {waiternow.common.IFindUnackedAndPaidOrdersActionProto} message FindUnackedAndPaidOrdersActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindUnackedAndPaidOrdersActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified FindUnackedAndPaidOrdersActionProto message, length delimited. Does not implicitly {@link waiternow.common.FindUnackedAndPaidOrdersActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FindUnackedAndPaidOrdersActionProto
             * @static
             * @param {waiternow.common.IFindUnackedAndPaidOrdersActionProto} message FindUnackedAndPaidOrdersActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindUnackedAndPaidOrdersActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FindUnackedAndPaidOrdersActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FindUnackedAndPaidOrdersActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FindUnackedAndPaidOrdersActionProto} FindUnackedAndPaidOrdersActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindUnackedAndPaidOrdersActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindUnackedAndPaidOrdersActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FindUnackedAndPaidOrdersActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FindUnackedAndPaidOrdersActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FindUnackedAndPaidOrdersActionProto} FindUnackedAndPaidOrdersActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindUnackedAndPaidOrdersActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FindUnackedAndPaidOrdersActionProto message.
             * @function verify
             * @memberof waiternow.common.FindUnackedAndPaidOrdersActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FindUnackedAndPaidOrdersActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a FindUnackedAndPaidOrdersActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FindUnackedAndPaidOrdersActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FindUnackedAndPaidOrdersActionProto} FindUnackedAndPaidOrdersActionProto
             */
            FindUnackedAndPaidOrdersActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FindUnackedAndPaidOrdersActionProto)
                    return object;
                return new $root.waiternow.common.FindUnackedAndPaidOrdersActionProto();
            };

            /**
             * Creates a plain object from a FindUnackedAndPaidOrdersActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FindUnackedAndPaidOrdersActionProto
             * @static
             * @param {waiternow.common.FindUnackedAndPaidOrdersActionProto} message FindUnackedAndPaidOrdersActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FindUnackedAndPaidOrdersActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this FindUnackedAndPaidOrdersActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FindUnackedAndPaidOrdersActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FindUnackedAndPaidOrdersActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FindUnackedAndPaidOrdersActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.FindUnackedAndPaidOrdersActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FindUnackedAndPaidOrdersActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FindUnackedAndPaidOrdersActionProto";
            };

            FindUnackedAndPaidOrdersActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersActionProto
                 * @interface IRequest
                 * @property {string|null} [locationId] Request locationId
                 * @property {string|null} [continuationToken] Request continuationToken
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.FindUnackedAndPaidOrdersActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = "";

                /**
                 * Request continuationToken.
                 * @member {string} continuationToken
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersActionProto.Request
                 * @instance
                 */
                Request.prototype.continuationToken = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersActionProto.Request
                 * @static
                 * @param {waiternow.common.FindUnackedAndPaidOrdersActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.FindUnackedAndPaidOrdersActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.FindUnackedAndPaidOrdersActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersActionProto.Request
                 * @static
                 * @param {waiternow.common.FindUnackedAndPaidOrdersActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.continuationToken);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.FindUnackedAndPaidOrdersActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersActionProto.Request
                 * @static
                 * @param {waiternow.common.FindUnackedAndPaidOrdersActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindUnackedAndPaidOrdersActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindUnackedAndPaidOrdersActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 2: {
                                message.continuationToken = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindUnackedAndPaidOrdersActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        if (!$util.isString(message.continuationToken))
                            return "continuationToken: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindUnackedAndPaidOrdersActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindUnackedAndPaidOrdersActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.FindUnackedAndPaidOrdersActionProto.Request();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    if (object.continuationToken != null)
                        message.continuationToken = String(object.continuationToken);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersActionProto.Request
                 * @static
                 * @param {waiternow.common.FindUnackedAndPaidOrdersActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.locationId = "";
                        object.continuationToken = "";
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        object.continuationToken = message.continuationToken;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindUnackedAndPaidOrdersActionProto.Request";
                };

                return Request;
            })();

            FindUnackedAndPaidOrdersActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.ILocationOrdersProto|null} [locationOrders] Response locationOrders
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.FindUnackedAndPaidOrdersActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response locationOrders.
                 * @member {waiternow.common.ILocationOrdersProto|null|undefined} locationOrders
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersActionProto.Response
                 * @instance
                 */
                Response.prototype.locationOrders = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersActionProto.Response
                 * @static
                 * @param {waiternow.common.FindUnackedAndPaidOrdersActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.FindUnackedAndPaidOrdersActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.FindUnackedAndPaidOrdersActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersActionProto.Response
                 * @static
                 * @param {waiternow.common.FindUnackedAndPaidOrdersActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.locationOrders != null && Object.hasOwnProperty.call(message, "locationOrders"))
                        $root.waiternow.common.LocationOrdersProto.encode(message.locationOrders, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.FindUnackedAndPaidOrdersActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersActionProto.Response
                 * @static
                 * @param {waiternow.common.FindUnackedAndPaidOrdersActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindUnackedAndPaidOrdersActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindUnackedAndPaidOrdersActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.locationOrders = $root.waiternow.common.LocationOrdersProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindUnackedAndPaidOrdersActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.locationOrders != null && message.hasOwnProperty("locationOrders")) {
                        var error = $root.waiternow.common.LocationOrdersProto.verify(message.locationOrders);
                        if (error)
                            return "locationOrders." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindUnackedAndPaidOrdersActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindUnackedAndPaidOrdersActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.FindUnackedAndPaidOrdersActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.FindUnackedAndPaidOrdersActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.locationOrders != null) {
                        if (typeof object.locationOrders !== "object")
                            throw TypeError(".waiternow.common.FindUnackedAndPaidOrdersActionProto.Response.locationOrders: object expected");
                        message.locationOrders = $root.waiternow.common.LocationOrdersProto.fromObject(object.locationOrders);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersActionProto.Response
                 * @static
                 * @param {waiternow.common.FindUnackedAndPaidOrdersActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.locationOrders = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.locationOrders != null && message.hasOwnProperty("locationOrders"))
                        object.locationOrders = $root.waiternow.common.LocationOrdersProto.toObject(message.locationOrders, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindUnackedAndPaidOrdersActionProto.Response";
                };

                return Response;
            })();

            return FindUnackedAndPaidOrdersActionProto;
        })();

        common.FindUnackedExcludingWithPaymentIntentOrdersActionProto = (function() {

            /**
             * Properties of a FindUnackedExcludingWithPaymentIntentOrdersActionProto.
             * @memberof waiternow.common
             * @interface IFindUnackedExcludingWithPaymentIntentOrdersActionProto
             */

            /**
             * Constructs a new FindUnackedExcludingWithPaymentIntentOrdersActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a FindUnackedExcludingWithPaymentIntentOrdersActionProto.
             * @implements IFindUnackedExcludingWithPaymentIntentOrdersActionProto
             * @constructor
             * @param {waiternow.common.IFindUnackedExcludingWithPaymentIntentOrdersActionProto=} [properties] Properties to set
             */
            function FindUnackedExcludingWithPaymentIntentOrdersActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new FindUnackedExcludingWithPaymentIntentOrdersActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto
             * @static
             * @param {waiternow.common.IFindUnackedExcludingWithPaymentIntentOrdersActionProto=} [properties] Properties to set
             * @returns {waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto} FindUnackedExcludingWithPaymentIntentOrdersActionProto instance
             */
            FindUnackedExcludingWithPaymentIntentOrdersActionProto.create = function create(properties) {
                return new FindUnackedExcludingWithPaymentIntentOrdersActionProto(properties);
            };

            /**
             * Encodes the specified FindUnackedExcludingWithPaymentIntentOrdersActionProto message. Does not implicitly {@link waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto
             * @static
             * @param {waiternow.common.IFindUnackedExcludingWithPaymentIntentOrdersActionProto} message FindUnackedExcludingWithPaymentIntentOrdersActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindUnackedExcludingWithPaymentIntentOrdersActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified FindUnackedExcludingWithPaymentIntentOrdersActionProto message, length delimited. Does not implicitly {@link waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto
             * @static
             * @param {waiternow.common.IFindUnackedExcludingWithPaymentIntentOrdersActionProto} message FindUnackedExcludingWithPaymentIntentOrdersActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindUnackedExcludingWithPaymentIntentOrdersActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FindUnackedExcludingWithPaymentIntentOrdersActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto} FindUnackedExcludingWithPaymentIntentOrdersActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindUnackedExcludingWithPaymentIntentOrdersActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FindUnackedExcludingWithPaymentIntentOrdersActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto} FindUnackedExcludingWithPaymentIntentOrdersActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindUnackedExcludingWithPaymentIntentOrdersActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FindUnackedExcludingWithPaymentIntentOrdersActionProto message.
             * @function verify
             * @memberof waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FindUnackedExcludingWithPaymentIntentOrdersActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a FindUnackedExcludingWithPaymentIntentOrdersActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto} FindUnackedExcludingWithPaymentIntentOrdersActionProto
             */
            FindUnackedExcludingWithPaymentIntentOrdersActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto)
                    return object;
                return new $root.waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto();
            };

            /**
             * Creates a plain object from a FindUnackedExcludingWithPaymentIntentOrdersActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto
             * @static
             * @param {waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto} message FindUnackedExcludingWithPaymentIntentOrdersActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FindUnackedExcludingWithPaymentIntentOrdersActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this FindUnackedExcludingWithPaymentIntentOrdersActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FindUnackedExcludingWithPaymentIntentOrdersActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FindUnackedExcludingWithPaymentIntentOrdersActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FindUnackedExcludingWithPaymentIntentOrdersActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto";
            };

            FindUnackedExcludingWithPaymentIntentOrdersActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto
                 * @interface IRequest
                 * @property {string|null} [locationId] Request locationId
                 * @property {string|null} [continuationToken] Request continuationToken
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = "";

                /**
                 * Request continuationToken.
                 * @member {string} continuationToken
                 * @memberof waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.Request
                 * @instance
                 */
                Request.prototype.continuationToken = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.Request
                 * @static
                 * @param {waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.Request
                 * @static
                 * @param {waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.continuationToken);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.Request
                 * @static
                 * @param {waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 2: {
                                message.continuationToken = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        if (!$util.isString(message.continuationToken))
                            return "continuationToken: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.Request();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    if (object.continuationToken != null)
                        message.continuationToken = String(object.continuationToken);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.Request
                 * @static
                 * @param {waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.locationId = "";
                        object.continuationToken = "";
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        object.continuationToken = message.continuationToken;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.Request";
                };

                return Request;
            })();

            FindUnackedExcludingWithPaymentIntentOrdersActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.ILocationOrdersProto|null} [locationOrders] Response locationOrders
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response locationOrders.
                 * @member {waiternow.common.ILocationOrdersProto|null|undefined} locationOrders
                 * @memberof waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.Response
                 * @instance
                 */
                Response.prototype.locationOrders = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.Response
                 * @static
                 * @param {waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.Response
                 * @static
                 * @param {waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.locationOrders != null && Object.hasOwnProperty.call(message, "locationOrders"))
                        $root.waiternow.common.LocationOrdersProto.encode(message.locationOrders, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.Response
                 * @static
                 * @param {waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.locationOrders = $root.waiternow.common.LocationOrdersProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.locationOrders != null && message.hasOwnProperty("locationOrders")) {
                        var error = $root.waiternow.common.LocationOrdersProto.verify(message.locationOrders);
                        if (error)
                            return "locationOrders." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.locationOrders != null) {
                        if (typeof object.locationOrders !== "object")
                            throw TypeError(".waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.Response.locationOrders: object expected");
                        message.locationOrders = $root.waiternow.common.LocationOrdersProto.fromObject(object.locationOrders);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.Response
                 * @static
                 * @param {waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.locationOrders = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.locationOrders != null && message.hasOwnProperty("locationOrders"))
                        object.locationOrders = $root.waiternow.common.LocationOrdersProto.toObject(message.locationOrders, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindUnackedExcludingWithPaymentIntentOrdersActionProto.Response";
                };

                return Response;
            })();

            return FindUnackedExcludingWithPaymentIntentOrdersActionProto;
        })();

        common.FindAckedOrdersActionProto = (function() {

            /**
             * Properties of a FindAckedOrdersActionProto.
             * @memberof waiternow.common
             * @interface IFindAckedOrdersActionProto
             */

            /**
             * Constructs a new FindAckedOrdersActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a FindAckedOrdersActionProto.
             * @implements IFindAckedOrdersActionProto
             * @constructor
             * @param {waiternow.common.IFindAckedOrdersActionProto=} [properties] Properties to set
             */
            function FindAckedOrdersActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new FindAckedOrdersActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FindAckedOrdersActionProto
             * @static
             * @param {waiternow.common.IFindAckedOrdersActionProto=} [properties] Properties to set
             * @returns {waiternow.common.FindAckedOrdersActionProto} FindAckedOrdersActionProto instance
             */
            FindAckedOrdersActionProto.create = function create(properties) {
                return new FindAckedOrdersActionProto(properties);
            };

            /**
             * Encodes the specified FindAckedOrdersActionProto message. Does not implicitly {@link waiternow.common.FindAckedOrdersActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FindAckedOrdersActionProto
             * @static
             * @param {waiternow.common.IFindAckedOrdersActionProto} message FindAckedOrdersActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindAckedOrdersActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified FindAckedOrdersActionProto message, length delimited. Does not implicitly {@link waiternow.common.FindAckedOrdersActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FindAckedOrdersActionProto
             * @static
             * @param {waiternow.common.IFindAckedOrdersActionProto} message FindAckedOrdersActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindAckedOrdersActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FindAckedOrdersActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FindAckedOrdersActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FindAckedOrdersActionProto} FindAckedOrdersActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindAckedOrdersActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindAckedOrdersActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FindAckedOrdersActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FindAckedOrdersActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FindAckedOrdersActionProto} FindAckedOrdersActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindAckedOrdersActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FindAckedOrdersActionProto message.
             * @function verify
             * @memberof waiternow.common.FindAckedOrdersActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FindAckedOrdersActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a FindAckedOrdersActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FindAckedOrdersActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FindAckedOrdersActionProto} FindAckedOrdersActionProto
             */
            FindAckedOrdersActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FindAckedOrdersActionProto)
                    return object;
                return new $root.waiternow.common.FindAckedOrdersActionProto();
            };

            /**
             * Creates a plain object from a FindAckedOrdersActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FindAckedOrdersActionProto
             * @static
             * @param {waiternow.common.FindAckedOrdersActionProto} message FindAckedOrdersActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FindAckedOrdersActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this FindAckedOrdersActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FindAckedOrdersActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FindAckedOrdersActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FindAckedOrdersActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.FindAckedOrdersActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FindAckedOrdersActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FindAckedOrdersActionProto";
            };

            FindAckedOrdersActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.FindAckedOrdersActionProto
                 * @interface IRequest
                 * @property {string|null} [locationId] Request locationId
                 * @property {string|null} [continuationToken] Request continuationToken
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.FindAckedOrdersActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.FindAckedOrdersActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.FindAckedOrdersActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = "";

                /**
                 * Request continuationToken.
                 * @member {string} continuationToken
                 * @memberof waiternow.common.FindAckedOrdersActionProto.Request
                 * @instance
                 */
                Request.prototype.continuationToken = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindAckedOrdersActionProto.Request
                 * @static
                 * @param {waiternow.common.FindAckedOrdersActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.FindAckedOrdersActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.FindAckedOrdersActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindAckedOrdersActionProto.Request
                 * @static
                 * @param {waiternow.common.FindAckedOrdersActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.continuationToken);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.FindAckedOrdersActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindAckedOrdersActionProto.Request
                 * @static
                 * @param {waiternow.common.FindAckedOrdersActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindAckedOrdersActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindAckedOrdersActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindAckedOrdersActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 2: {
                                message.continuationToken = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindAckedOrdersActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindAckedOrdersActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.FindAckedOrdersActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        if (!$util.isString(message.continuationToken))
                            return "continuationToken: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindAckedOrdersActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindAckedOrdersActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindAckedOrdersActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.FindAckedOrdersActionProto.Request();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    if (object.continuationToken != null)
                        message.continuationToken = String(object.continuationToken);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindAckedOrdersActionProto.Request
                 * @static
                 * @param {waiternow.common.FindAckedOrdersActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.locationId = "";
                        object.continuationToken = "";
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        object.continuationToken = message.continuationToken;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindAckedOrdersActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindAckedOrdersActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindAckedOrdersActionProto.Request";
                };

                return Request;
            })();

            FindAckedOrdersActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.FindAckedOrdersActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.ILocationOrdersProto|null} [locationOrders] Response locationOrders
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.FindAckedOrdersActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.FindAckedOrdersActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.FindAckedOrdersActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response locationOrders.
                 * @member {waiternow.common.ILocationOrdersProto|null|undefined} locationOrders
                 * @memberof waiternow.common.FindAckedOrdersActionProto.Response
                 * @instance
                 */
                Response.prototype.locationOrders = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindAckedOrdersActionProto.Response
                 * @static
                 * @param {waiternow.common.FindAckedOrdersActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.FindAckedOrdersActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.FindAckedOrdersActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindAckedOrdersActionProto.Response
                 * @static
                 * @param {waiternow.common.FindAckedOrdersActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.locationOrders != null && Object.hasOwnProperty.call(message, "locationOrders"))
                        $root.waiternow.common.LocationOrdersProto.encode(message.locationOrders, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.FindAckedOrdersActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindAckedOrdersActionProto.Response
                 * @static
                 * @param {waiternow.common.FindAckedOrdersActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindAckedOrdersActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindAckedOrdersActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindAckedOrdersActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.locationOrders = $root.waiternow.common.LocationOrdersProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindAckedOrdersActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindAckedOrdersActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.FindAckedOrdersActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.locationOrders != null && message.hasOwnProperty("locationOrders")) {
                        var error = $root.waiternow.common.LocationOrdersProto.verify(message.locationOrders);
                        if (error)
                            return "locationOrders." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindAckedOrdersActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindAckedOrdersActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindAckedOrdersActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.FindAckedOrdersActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.FindAckedOrdersActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.locationOrders != null) {
                        if (typeof object.locationOrders !== "object")
                            throw TypeError(".waiternow.common.FindAckedOrdersActionProto.Response.locationOrders: object expected");
                        message.locationOrders = $root.waiternow.common.LocationOrdersProto.fromObject(object.locationOrders);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindAckedOrdersActionProto.Response
                 * @static
                 * @param {waiternow.common.FindAckedOrdersActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.locationOrders = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.locationOrders != null && message.hasOwnProperty("locationOrders"))
                        object.locationOrders = $root.waiternow.common.LocationOrdersProto.toObject(message.locationOrders, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindAckedOrdersActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindAckedOrdersActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindAckedOrdersActionProto.Response";
                };

                return Response;
            })();

            return FindAckedOrdersActionProto;
        })();

        common.FindAckedExcludingWithPaymentIntentOrdersActionProto = (function() {

            /**
             * Properties of a FindAckedExcludingWithPaymentIntentOrdersActionProto.
             * @memberof waiternow.common
             * @interface IFindAckedExcludingWithPaymentIntentOrdersActionProto
             */

            /**
             * Constructs a new FindAckedExcludingWithPaymentIntentOrdersActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a FindAckedExcludingWithPaymentIntentOrdersActionProto.
             * @implements IFindAckedExcludingWithPaymentIntentOrdersActionProto
             * @constructor
             * @param {waiternow.common.IFindAckedExcludingWithPaymentIntentOrdersActionProto=} [properties] Properties to set
             */
            function FindAckedExcludingWithPaymentIntentOrdersActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new FindAckedExcludingWithPaymentIntentOrdersActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto
             * @static
             * @param {waiternow.common.IFindAckedExcludingWithPaymentIntentOrdersActionProto=} [properties] Properties to set
             * @returns {waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto} FindAckedExcludingWithPaymentIntentOrdersActionProto instance
             */
            FindAckedExcludingWithPaymentIntentOrdersActionProto.create = function create(properties) {
                return new FindAckedExcludingWithPaymentIntentOrdersActionProto(properties);
            };

            /**
             * Encodes the specified FindAckedExcludingWithPaymentIntentOrdersActionProto message. Does not implicitly {@link waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto
             * @static
             * @param {waiternow.common.IFindAckedExcludingWithPaymentIntentOrdersActionProto} message FindAckedExcludingWithPaymentIntentOrdersActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindAckedExcludingWithPaymentIntentOrdersActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified FindAckedExcludingWithPaymentIntentOrdersActionProto message, length delimited. Does not implicitly {@link waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto
             * @static
             * @param {waiternow.common.IFindAckedExcludingWithPaymentIntentOrdersActionProto} message FindAckedExcludingWithPaymentIntentOrdersActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindAckedExcludingWithPaymentIntentOrdersActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FindAckedExcludingWithPaymentIntentOrdersActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto} FindAckedExcludingWithPaymentIntentOrdersActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindAckedExcludingWithPaymentIntentOrdersActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FindAckedExcludingWithPaymentIntentOrdersActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto} FindAckedExcludingWithPaymentIntentOrdersActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindAckedExcludingWithPaymentIntentOrdersActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FindAckedExcludingWithPaymentIntentOrdersActionProto message.
             * @function verify
             * @memberof waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FindAckedExcludingWithPaymentIntentOrdersActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a FindAckedExcludingWithPaymentIntentOrdersActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto} FindAckedExcludingWithPaymentIntentOrdersActionProto
             */
            FindAckedExcludingWithPaymentIntentOrdersActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto)
                    return object;
                return new $root.waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto();
            };

            /**
             * Creates a plain object from a FindAckedExcludingWithPaymentIntentOrdersActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto
             * @static
             * @param {waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto} message FindAckedExcludingWithPaymentIntentOrdersActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FindAckedExcludingWithPaymentIntentOrdersActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this FindAckedExcludingWithPaymentIntentOrdersActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FindAckedExcludingWithPaymentIntentOrdersActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FindAckedExcludingWithPaymentIntentOrdersActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FindAckedExcludingWithPaymentIntentOrdersActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto";
            };

            FindAckedExcludingWithPaymentIntentOrdersActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto
                 * @interface IRequest
                 * @property {string|null} [locationId] Request locationId
                 * @property {string|null} [continuationToken] Request continuationToken
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = "";

                /**
                 * Request continuationToken.
                 * @member {string} continuationToken
                 * @memberof waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.Request
                 * @instance
                 */
                Request.prototype.continuationToken = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.Request
                 * @static
                 * @param {waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.Request
                 * @static
                 * @param {waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.continuationToken);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.Request
                 * @static
                 * @param {waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 2: {
                                message.continuationToken = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        if (!$util.isString(message.continuationToken))
                            return "continuationToken: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.Request();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    if (object.continuationToken != null)
                        message.continuationToken = String(object.continuationToken);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.Request
                 * @static
                 * @param {waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.locationId = "";
                        object.continuationToken = "";
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        object.continuationToken = message.continuationToken;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.Request";
                };

                return Request;
            })();

            FindAckedExcludingWithPaymentIntentOrdersActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.ILocationOrdersProto|null} [locationOrders] Response locationOrders
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response locationOrders.
                 * @member {waiternow.common.ILocationOrdersProto|null|undefined} locationOrders
                 * @memberof waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.Response
                 * @instance
                 */
                Response.prototype.locationOrders = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.Response
                 * @static
                 * @param {waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.Response
                 * @static
                 * @param {waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.locationOrders != null && Object.hasOwnProperty.call(message, "locationOrders"))
                        $root.waiternow.common.LocationOrdersProto.encode(message.locationOrders, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.Response
                 * @static
                 * @param {waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.locationOrders = $root.waiternow.common.LocationOrdersProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.locationOrders != null && message.hasOwnProperty("locationOrders")) {
                        var error = $root.waiternow.common.LocationOrdersProto.verify(message.locationOrders);
                        if (error)
                            return "locationOrders." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.locationOrders != null) {
                        if (typeof object.locationOrders !== "object")
                            throw TypeError(".waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.Response.locationOrders: object expected");
                        message.locationOrders = $root.waiternow.common.LocationOrdersProto.fromObject(object.locationOrders);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.Response
                 * @static
                 * @param {waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.locationOrders = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.locationOrders != null && message.hasOwnProperty("locationOrders"))
                        object.locationOrders = $root.waiternow.common.LocationOrdersProto.toObject(message.locationOrders, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindAckedExcludingWithPaymentIntentOrdersActionProto.Response";
                };

                return Response;
            })();

            return FindAckedExcludingWithPaymentIntentOrdersActionProto;
        })();

        common.FindPaidOrdersActionProto = (function() {

            /**
             * Properties of a FindPaidOrdersActionProto.
             * @memberof waiternow.common
             * @interface IFindPaidOrdersActionProto
             */

            /**
             * Constructs a new FindPaidOrdersActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a FindPaidOrdersActionProto.
             * @implements IFindPaidOrdersActionProto
             * @constructor
             * @param {waiternow.common.IFindPaidOrdersActionProto=} [properties] Properties to set
             */
            function FindPaidOrdersActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new FindPaidOrdersActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FindPaidOrdersActionProto
             * @static
             * @param {waiternow.common.IFindPaidOrdersActionProto=} [properties] Properties to set
             * @returns {waiternow.common.FindPaidOrdersActionProto} FindPaidOrdersActionProto instance
             */
            FindPaidOrdersActionProto.create = function create(properties) {
                return new FindPaidOrdersActionProto(properties);
            };

            /**
             * Encodes the specified FindPaidOrdersActionProto message. Does not implicitly {@link waiternow.common.FindPaidOrdersActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FindPaidOrdersActionProto
             * @static
             * @param {waiternow.common.IFindPaidOrdersActionProto} message FindPaidOrdersActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindPaidOrdersActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified FindPaidOrdersActionProto message, length delimited. Does not implicitly {@link waiternow.common.FindPaidOrdersActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FindPaidOrdersActionProto
             * @static
             * @param {waiternow.common.IFindPaidOrdersActionProto} message FindPaidOrdersActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindPaidOrdersActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FindPaidOrdersActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FindPaidOrdersActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FindPaidOrdersActionProto} FindPaidOrdersActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindPaidOrdersActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindPaidOrdersActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FindPaidOrdersActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FindPaidOrdersActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FindPaidOrdersActionProto} FindPaidOrdersActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindPaidOrdersActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FindPaidOrdersActionProto message.
             * @function verify
             * @memberof waiternow.common.FindPaidOrdersActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FindPaidOrdersActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a FindPaidOrdersActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FindPaidOrdersActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FindPaidOrdersActionProto} FindPaidOrdersActionProto
             */
            FindPaidOrdersActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FindPaidOrdersActionProto)
                    return object;
                return new $root.waiternow.common.FindPaidOrdersActionProto();
            };

            /**
             * Creates a plain object from a FindPaidOrdersActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FindPaidOrdersActionProto
             * @static
             * @param {waiternow.common.FindPaidOrdersActionProto} message FindPaidOrdersActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FindPaidOrdersActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this FindPaidOrdersActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FindPaidOrdersActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FindPaidOrdersActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FindPaidOrdersActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.FindPaidOrdersActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FindPaidOrdersActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FindPaidOrdersActionProto";
            };

            FindPaidOrdersActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.FindPaidOrdersActionProto
                 * @interface IRequest
                 * @property {string|null} [locationId] Request locationId
                 * @property {google.protobuf.ITimestamp|null} [afterTime] Request afterTime
                 * @property {google.protobuf.ITimestamp|null} [beforeTime] Request beforeTime
                 * @property {waiternow.common.SortOrder|null} [sortOrder] Request sortOrder
                 * @property {string|null} [continuationToken] Request continuationToken
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.FindPaidOrdersActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.FindPaidOrdersActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.FindPaidOrdersActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = "";

                /**
                 * Request afterTime.
                 * @member {google.protobuf.ITimestamp|null|undefined} afterTime
                 * @memberof waiternow.common.FindPaidOrdersActionProto.Request
                 * @instance
                 */
                Request.prototype.afterTime = null;

                /**
                 * Request beforeTime.
                 * @member {google.protobuf.ITimestamp|null|undefined} beforeTime
                 * @memberof waiternow.common.FindPaidOrdersActionProto.Request
                 * @instance
                 */
                Request.prototype.beforeTime = null;

                /**
                 * Request sortOrder.
                 * @member {waiternow.common.SortOrder} sortOrder
                 * @memberof waiternow.common.FindPaidOrdersActionProto.Request
                 * @instance
                 */
                Request.prototype.sortOrder = 0;

                /**
                 * Request continuationToken.
                 * @member {string} continuationToken
                 * @memberof waiternow.common.FindPaidOrdersActionProto.Request
                 * @instance
                 */
                Request.prototype.continuationToken = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindPaidOrdersActionProto.Request
                 * @static
                 * @param {waiternow.common.FindPaidOrdersActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.FindPaidOrdersActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.FindPaidOrdersActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindPaidOrdersActionProto.Request
                 * @static
                 * @param {waiternow.common.FindPaidOrdersActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    if (message.afterTime != null && Object.hasOwnProperty.call(message, "afterTime"))
                        $root.google.protobuf.Timestamp.encode(message.afterTime, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.beforeTime != null && Object.hasOwnProperty.call(message, "beforeTime"))
                        $root.google.protobuf.Timestamp.encode(message.beforeTime, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.sortOrder != null && Object.hasOwnProperty.call(message, "sortOrder"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.sortOrder);
                    if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.continuationToken);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.FindPaidOrdersActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindPaidOrdersActionProto.Request
                 * @static
                 * @param {waiternow.common.FindPaidOrdersActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindPaidOrdersActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindPaidOrdersActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindPaidOrdersActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 2: {
                                message.afterTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.beforeTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            }
                        case 4: {
                                message.sortOrder = reader.int32();
                                break;
                            }
                        case 5: {
                                message.continuationToken = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindPaidOrdersActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindPaidOrdersActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.FindPaidOrdersActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    if (message.afterTime != null && message.hasOwnProperty("afterTime")) {
                        var error = $root.google.protobuf.Timestamp.verify(message.afterTime);
                        if (error)
                            return "afterTime." + error;
                    }
                    if (message.beforeTime != null && message.hasOwnProperty("beforeTime")) {
                        var error = $root.google.protobuf.Timestamp.verify(message.beforeTime);
                        if (error)
                            return "beforeTime." + error;
                    }
                    if (message.sortOrder != null && message.hasOwnProperty("sortOrder"))
                        switch (message.sortOrder) {
                        default:
                            return "sortOrder: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        if (!$util.isString(message.continuationToken))
                            return "continuationToken: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindPaidOrdersActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindPaidOrdersActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindPaidOrdersActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.FindPaidOrdersActionProto.Request();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    if (object.afterTime != null) {
                        if (typeof object.afterTime !== "object")
                            throw TypeError(".waiternow.common.FindPaidOrdersActionProto.Request.afterTime: object expected");
                        message.afterTime = $root.google.protobuf.Timestamp.fromObject(object.afterTime);
                    }
                    if (object.beforeTime != null) {
                        if (typeof object.beforeTime !== "object")
                            throw TypeError(".waiternow.common.FindPaidOrdersActionProto.Request.beforeTime: object expected");
                        message.beforeTime = $root.google.protobuf.Timestamp.fromObject(object.beforeTime);
                    }
                    switch (object.sortOrder) {
                    default:
                        if (typeof object.sortOrder === "number") {
                            message.sortOrder = object.sortOrder;
                            break;
                        }
                        break;
                    case "SORT_ORDER_UNSPECIFIED":
                    case 0:
                        message.sortOrder = 0;
                        break;
                    case "ASCENDING":
                    case 1:
                        message.sortOrder = 1;
                        break;
                    case "DESCENDING":
                    case 2:
                        message.sortOrder = 2;
                        break;
                    }
                    if (object.continuationToken != null)
                        message.continuationToken = String(object.continuationToken);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindPaidOrdersActionProto.Request
                 * @static
                 * @param {waiternow.common.FindPaidOrdersActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.locationId = "";
                        object.afterTime = null;
                        object.beforeTime = null;
                        object.sortOrder = options.enums === String ? "SORT_ORDER_UNSPECIFIED" : 0;
                        object.continuationToken = "";
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    if (message.afterTime != null && message.hasOwnProperty("afterTime"))
                        object.afterTime = $root.google.protobuf.Timestamp.toObject(message.afterTime, options);
                    if (message.beforeTime != null && message.hasOwnProperty("beforeTime"))
                        object.beforeTime = $root.google.protobuf.Timestamp.toObject(message.beforeTime, options);
                    if (message.sortOrder != null && message.hasOwnProperty("sortOrder"))
                        object.sortOrder = options.enums === String ? $root.waiternow.common.SortOrder[message.sortOrder] === undefined ? message.sortOrder : $root.waiternow.common.SortOrder[message.sortOrder] : message.sortOrder;
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        object.continuationToken = message.continuationToken;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindPaidOrdersActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindPaidOrdersActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindPaidOrdersActionProto.Request";
                };

                return Request;
            })();

            FindPaidOrdersActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.FindPaidOrdersActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.ILocationOrdersProto|null} [locationOrders] Response locationOrders
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.FindPaidOrdersActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.FindPaidOrdersActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.FindPaidOrdersActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response locationOrders.
                 * @member {waiternow.common.ILocationOrdersProto|null|undefined} locationOrders
                 * @memberof waiternow.common.FindPaidOrdersActionProto.Response
                 * @instance
                 */
                Response.prototype.locationOrders = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindPaidOrdersActionProto.Response
                 * @static
                 * @param {waiternow.common.FindPaidOrdersActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.FindPaidOrdersActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.FindPaidOrdersActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindPaidOrdersActionProto.Response
                 * @static
                 * @param {waiternow.common.FindPaidOrdersActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.locationOrders != null && Object.hasOwnProperty.call(message, "locationOrders"))
                        $root.waiternow.common.LocationOrdersProto.encode(message.locationOrders, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.FindPaidOrdersActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindPaidOrdersActionProto.Response
                 * @static
                 * @param {waiternow.common.FindPaidOrdersActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindPaidOrdersActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindPaidOrdersActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindPaidOrdersActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.locationOrders = $root.waiternow.common.LocationOrdersProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindPaidOrdersActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindPaidOrdersActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.FindPaidOrdersActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.locationOrders != null && message.hasOwnProperty("locationOrders")) {
                        var error = $root.waiternow.common.LocationOrdersProto.verify(message.locationOrders);
                        if (error)
                            return "locationOrders." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindPaidOrdersActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindPaidOrdersActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindPaidOrdersActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.FindPaidOrdersActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.FindPaidOrdersActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.locationOrders != null) {
                        if (typeof object.locationOrders !== "object")
                            throw TypeError(".waiternow.common.FindPaidOrdersActionProto.Response.locationOrders: object expected");
                        message.locationOrders = $root.waiternow.common.LocationOrdersProto.fromObject(object.locationOrders);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindPaidOrdersActionProto.Response
                 * @static
                 * @param {waiternow.common.FindPaidOrdersActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.locationOrders = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.locationOrders != null && message.hasOwnProperty("locationOrders"))
                        object.locationOrders = $root.waiternow.common.LocationOrdersProto.toObject(message.locationOrders, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindPaidOrdersActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindPaidOrdersActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindPaidOrdersActionProto.Response";
                };

                return Response;
            })();

            return FindPaidOrdersActionProto;
        })();

        common.FindUnpaidOrdersActionProto = (function() {

            /**
             * Properties of a FindUnpaidOrdersActionProto.
             * @memberof waiternow.common
             * @interface IFindUnpaidOrdersActionProto
             */

            /**
             * Constructs a new FindUnpaidOrdersActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a FindUnpaidOrdersActionProto.
             * @implements IFindUnpaidOrdersActionProto
             * @constructor
             * @param {waiternow.common.IFindUnpaidOrdersActionProto=} [properties] Properties to set
             */
            function FindUnpaidOrdersActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new FindUnpaidOrdersActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FindUnpaidOrdersActionProto
             * @static
             * @param {waiternow.common.IFindUnpaidOrdersActionProto=} [properties] Properties to set
             * @returns {waiternow.common.FindUnpaidOrdersActionProto} FindUnpaidOrdersActionProto instance
             */
            FindUnpaidOrdersActionProto.create = function create(properties) {
                return new FindUnpaidOrdersActionProto(properties);
            };

            /**
             * Encodes the specified FindUnpaidOrdersActionProto message. Does not implicitly {@link waiternow.common.FindUnpaidOrdersActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FindUnpaidOrdersActionProto
             * @static
             * @param {waiternow.common.IFindUnpaidOrdersActionProto} message FindUnpaidOrdersActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindUnpaidOrdersActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified FindUnpaidOrdersActionProto message, length delimited. Does not implicitly {@link waiternow.common.FindUnpaidOrdersActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FindUnpaidOrdersActionProto
             * @static
             * @param {waiternow.common.IFindUnpaidOrdersActionProto} message FindUnpaidOrdersActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindUnpaidOrdersActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FindUnpaidOrdersActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FindUnpaidOrdersActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FindUnpaidOrdersActionProto} FindUnpaidOrdersActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindUnpaidOrdersActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindUnpaidOrdersActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FindUnpaidOrdersActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FindUnpaidOrdersActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FindUnpaidOrdersActionProto} FindUnpaidOrdersActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindUnpaidOrdersActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FindUnpaidOrdersActionProto message.
             * @function verify
             * @memberof waiternow.common.FindUnpaidOrdersActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FindUnpaidOrdersActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a FindUnpaidOrdersActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FindUnpaidOrdersActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FindUnpaidOrdersActionProto} FindUnpaidOrdersActionProto
             */
            FindUnpaidOrdersActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FindUnpaidOrdersActionProto)
                    return object;
                return new $root.waiternow.common.FindUnpaidOrdersActionProto();
            };

            /**
             * Creates a plain object from a FindUnpaidOrdersActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FindUnpaidOrdersActionProto
             * @static
             * @param {waiternow.common.FindUnpaidOrdersActionProto} message FindUnpaidOrdersActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FindUnpaidOrdersActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this FindUnpaidOrdersActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FindUnpaidOrdersActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FindUnpaidOrdersActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FindUnpaidOrdersActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.FindUnpaidOrdersActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FindUnpaidOrdersActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FindUnpaidOrdersActionProto";
            };

            FindUnpaidOrdersActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.FindUnpaidOrdersActionProto
                 * @interface IRequest
                 * @property {string|null} [locationId] Request locationId
                 * @property {google.protobuf.ITimestamp|null} [afterTime] Request afterTime
                 * @property {google.protobuf.ITimestamp|null} [beforeTime] Request beforeTime
                 * @property {waiternow.common.SortOrder|null} [sortOrder] Request sortOrder
                 * @property {string|null} [continuationToken] Request continuationToken
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.FindUnpaidOrdersActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.FindUnpaidOrdersActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.FindUnpaidOrdersActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = "";

                /**
                 * Request afterTime.
                 * @member {google.protobuf.ITimestamp|null|undefined} afterTime
                 * @memberof waiternow.common.FindUnpaidOrdersActionProto.Request
                 * @instance
                 */
                Request.prototype.afterTime = null;

                /**
                 * Request beforeTime.
                 * @member {google.protobuf.ITimestamp|null|undefined} beforeTime
                 * @memberof waiternow.common.FindUnpaidOrdersActionProto.Request
                 * @instance
                 */
                Request.prototype.beforeTime = null;

                /**
                 * Request sortOrder.
                 * @member {waiternow.common.SortOrder} sortOrder
                 * @memberof waiternow.common.FindUnpaidOrdersActionProto.Request
                 * @instance
                 */
                Request.prototype.sortOrder = 0;

                /**
                 * Request continuationToken.
                 * @member {string} continuationToken
                 * @memberof waiternow.common.FindUnpaidOrdersActionProto.Request
                 * @instance
                 */
                Request.prototype.continuationToken = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindUnpaidOrdersActionProto.Request
                 * @static
                 * @param {waiternow.common.FindUnpaidOrdersActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.FindUnpaidOrdersActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.FindUnpaidOrdersActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindUnpaidOrdersActionProto.Request
                 * @static
                 * @param {waiternow.common.FindUnpaidOrdersActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    if (message.afterTime != null && Object.hasOwnProperty.call(message, "afterTime"))
                        $root.google.protobuf.Timestamp.encode(message.afterTime, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.beforeTime != null && Object.hasOwnProperty.call(message, "beforeTime"))
                        $root.google.protobuf.Timestamp.encode(message.beforeTime, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.sortOrder != null && Object.hasOwnProperty.call(message, "sortOrder"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.sortOrder);
                    if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.continuationToken);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.FindUnpaidOrdersActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindUnpaidOrdersActionProto.Request
                 * @static
                 * @param {waiternow.common.FindUnpaidOrdersActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindUnpaidOrdersActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindUnpaidOrdersActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindUnpaidOrdersActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 2: {
                                message.afterTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.beforeTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            }
                        case 4: {
                                message.sortOrder = reader.int32();
                                break;
                            }
                        case 5: {
                                message.continuationToken = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindUnpaidOrdersActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindUnpaidOrdersActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.FindUnpaidOrdersActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    if (message.afterTime != null && message.hasOwnProperty("afterTime")) {
                        var error = $root.google.protobuf.Timestamp.verify(message.afterTime);
                        if (error)
                            return "afterTime." + error;
                    }
                    if (message.beforeTime != null && message.hasOwnProperty("beforeTime")) {
                        var error = $root.google.protobuf.Timestamp.verify(message.beforeTime);
                        if (error)
                            return "beforeTime." + error;
                    }
                    if (message.sortOrder != null && message.hasOwnProperty("sortOrder"))
                        switch (message.sortOrder) {
                        default:
                            return "sortOrder: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        if (!$util.isString(message.continuationToken))
                            return "continuationToken: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindUnpaidOrdersActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindUnpaidOrdersActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindUnpaidOrdersActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.FindUnpaidOrdersActionProto.Request();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    if (object.afterTime != null) {
                        if (typeof object.afterTime !== "object")
                            throw TypeError(".waiternow.common.FindUnpaidOrdersActionProto.Request.afterTime: object expected");
                        message.afterTime = $root.google.protobuf.Timestamp.fromObject(object.afterTime);
                    }
                    if (object.beforeTime != null) {
                        if (typeof object.beforeTime !== "object")
                            throw TypeError(".waiternow.common.FindUnpaidOrdersActionProto.Request.beforeTime: object expected");
                        message.beforeTime = $root.google.protobuf.Timestamp.fromObject(object.beforeTime);
                    }
                    switch (object.sortOrder) {
                    default:
                        if (typeof object.sortOrder === "number") {
                            message.sortOrder = object.sortOrder;
                            break;
                        }
                        break;
                    case "SORT_ORDER_UNSPECIFIED":
                    case 0:
                        message.sortOrder = 0;
                        break;
                    case "ASCENDING":
                    case 1:
                        message.sortOrder = 1;
                        break;
                    case "DESCENDING":
                    case 2:
                        message.sortOrder = 2;
                        break;
                    }
                    if (object.continuationToken != null)
                        message.continuationToken = String(object.continuationToken);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindUnpaidOrdersActionProto.Request
                 * @static
                 * @param {waiternow.common.FindUnpaidOrdersActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.locationId = "";
                        object.afterTime = null;
                        object.beforeTime = null;
                        object.sortOrder = options.enums === String ? "SORT_ORDER_UNSPECIFIED" : 0;
                        object.continuationToken = "";
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    if (message.afterTime != null && message.hasOwnProperty("afterTime"))
                        object.afterTime = $root.google.protobuf.Timestamp.toObject(message.afterTime, options);
                    if (message.beforeTime != null && message.hasOwnProperty("beforeTime"))
                        object.beforeTime = $root.google.protobuf.Timestamp.toObject(message.beforeTime, options);
                    if (message.sortOrder != null && message.hasOwnProperty("sortOrder"))
                        object.sortOrder = options.enums === String ? $root.waiternow.common.SortOrder[message.sortOrder] === undefined ? message.sortOrder : $root.waiternow.common.SortOrder[message.sortOrder] : message.sortOrder;
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        object.continuationToken = message.continuationToken;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindUnpaidOrdersActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindUnpaidOrdersActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindUnpaidOrdersActionProto.Request";
                };

                return Request;
            })();

            FindUnpaidOrdersActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.FindUnpaidOrdersActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.ILocationOrdersProto|null} [locationOrders] Response locationOrders
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.FindUnpaidOrdersActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.FindUnpaidOrdersActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.FindUnpaidOrdersActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response locationOrders.
                 * @member {waiternow.common.ILocationOrdersProto|null|undefined} locationOrders
                 * @memberof waiternow.common.FindUnpaidOrdersActionProto.Response
                 * @instance
                 */
                Response.prototype.locationOrders = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindUnpaidOrdersActionProto.Response
                 * @static
                 * @param {waiternow.common.FindUnpaidOrdersActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.FindUnpaidOrdersActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.FindUnpaidOrdersActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindUnpaidOrdersActionProto.Response
                 * @static
                 * @param {waiternow.common.FindUnpaidOrdersActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.locationOrders != null && Object.hasOwnProperty.call(message, "locationOrders"))
                        $root.waiternow.common.LocationOrdersProto.encode(message.locationOrders, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.FindUnpaidOrdersActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindUnpaidOrdersActionProto.Response
                 * @static
                 * @param {waiternow.common.FindUnpaidOrdersActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindUnpaidOrdersActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindUnpaidOrdersActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindUnpaidOrdersActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.locationOrders = $root.waiternow.common.LocationOrdersProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindUnpaidOrdersActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindUnpaidOrdersActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.FindUnpaidOrdersActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.locationOrders != null && message.hasOwnProperty("locationOrders")) {
                        var error = $root.waiternow.common.LocationOrdersProto.verify(message.locationOrders);
                        if (error)
                            return "locationOrders." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindUnpaidOrdersActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindUnpaidOrdersActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindUnpaidOrdersActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.FindUnpaidOrdersActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.FindUnpaidOrdersActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.locationOrders != null) {
                        if (typeof object.locationOrders !== "object")
                            throw TypeError(".waiternow.common.FindUnpaidOrdersActionProto.Response.locationOrders: object expected");
                        message.locationOrders = $root.waiternow.common.LocationOrdersProto.fromObject(object.locationOrders);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindUnpaidOrdersActionProto.Response
                 * @static
                 * @param {waiternow.common.FindUnpaidOrdersActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.locationOrders = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.locationOrders != null && message.hasOwnProperty("locationOrders"))
                        object.locationOrders = $root.waiternow.common.LocationOrdersProto.toObject(message.locationOrders, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindUnpaidOrdersActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindUnpaidOrdersActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindUnpaidOrdersActionProto.Response";
                };

                return Response;
            })();

            return FindUnpaidOrdersActionProto;
        })();

        common.RefundPaidOrderActionProto = (function() {

            /**
             * Properties of a RefundPaidOrderActionProto.
             * @memberof waiternow.common
             * @interface IRefundPaidOrderActionProto
             */

            /**
             * Constructs a new RefundPaidOrderActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a RefundPaidOrderActionProto.
             * @implements IRefundPaidOrderActionProto
             * @constructor
             * @param {waiternow.common.IRefundPaidOrderActionProto=} [properties] Properties to set
             */
            function RefundPaidOrderActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new RefundPaidOrderActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.RefundPaidOrderActionProto
             * @static
             * @param {waiternow.common.IRefundPaidOrderActionProto=} [properties] Properties to set
             * @returns {waiternow.common.RefundPaidOrderActionProto} RefundPaidOrderActionProto instance
             */
            RefundPaidOrderActionProto.create = function create(properties) {
                return new RefundPaidOrderActionProto(properties);
            };

            /**
             * Encodes the specified RefundPaidOrderActionProto message. Does not implicitly {@link waiternow.common.RefundPaidOrderActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.RefundPaidOrderActionProto
             * @static
             * @param {waiternow.common.IRefundPaidOrderActionProto} message RefundPaidOrderActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RefundPaidOrderActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified RefundPaidOrderActionProto message, length delimited. Does not implicitly {@link waiternow.common.RefundPaidOrderActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.RefundPaidOrderActionProto
             * @static
             * @param {waiternow.common.IRefundPaidOrderActionProto} message RefundPaidOrderActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RefundPaidOrderActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a RefundPaidOrderActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.RefundPaidOrderActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.RefundPaidOrderActionProto} RefundPaidOrderActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RefundPaidOrderActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.RefundPaidOrderActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a RefundPaidOrderActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.RefundPaidOrderActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.RefundPaidOrderActionProto} RefundPaidOrderActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RefundPaidOrderActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a RefundPaidOrderActionProto message.
             * @function verify
             * @memberof waiternow.common.RefundPaidOrderActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            RefundPaidOrderActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a RefundPaidOrderActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.RefundPaidOrderActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.RefundPaidOrderActionProto} RefundPaidOrderActionProto
             */
            RefundPaidOrderActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.RefundPaidOrderActionProto)
                    return object;
                return new $root.waiternow.common.RefundPaidOrderActionProto();
            };

            /**
             * Creates a plain object from a RefundPaidOrderActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.RefundPaidOrderActionProto
             * @static
             * @param {waiternow.common.RefundPaidOrderActionProto} message RefundPaidOrderActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            RefundPaidOrderActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this RefundPaidOrderActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.RefundPaidOrderActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            RefundPaidOrderActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for RefundPaidOrderActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.RefundPaidOrderActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            RefundPaidOrderActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.RefundPaidOrderActionProto";
            };

            RefundPaidOrderActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.RefundPaidOrderActionProto
                 * @interface IRequest
                 * @property {string|null} [orderId] Request orderId
                 * @property {waiternow.common.IMoneyProto|null} [amount] Request amount
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.RefundPaidOrderActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.RefundPaidOrderActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request orderId.
                 * @member {string} orderId
                 * @memberof waiternow.common.RefundPaidOrderActionProto.Request
                 * @instance
                 */
                Request.prototype.orderId = "";

                /**
                 * Request amount.
                 * @member {waiternow.common.IMoneyProto|null|undefined} amount
                 * @memberof waiternow.common.RefundPaidOrderActionProto.Request
                 * @instance
                 */
                Request.prototype.amount = null;

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.RefundPaidOrderActionProto.Request
                 * @static
                 * @param {waiternow.common.RefundPaidOrderActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.RefundPaidOrderActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.RefundPaidOrderActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.RefundPaidOrderActionProto.Request
                 * @static
                 * @param {waiternow.common.RefundPaidOrderActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.orderId != null && Object.hasOwnProperty.call(message, "orderId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.orderId);
                    if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                        $root.waiternow.common.MoneyProto.encode(message.amount, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.RefundPaidOrderActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.RefundPaidOrderActionProto.Request
                 * @static
                 * @param {waiternow.common.RefundPaidOrderActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.RefundPaidOrderActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.RefundPaidOrderActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.RefundPaidOrderActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.orderId = reader.string();
                                break;
                            }
                        case 7: {
                                message.amount = $root.waiternow.common.MoneyProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.RefundPaidOrderActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.RefundPaidOrderActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.RefundPaidOrderActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.orderId != null && message.hasOwnProperty("orderId"))
                        if (!$util.isString(message.orderId))
                            return "orderId: string expected";
                    if (message.amount != null && message.hasOwnProperty("amount")) {
                        var error = $root.waiternow.common.MoneyProto.verify(message.amount);
                        if (error)
                            return "amount." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.RefundPaidOrderActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.RefundPaidOrderActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.RefundPaidOrderActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.RefundPaidOrderActionProto.Request();
                    if (object.orderId != null)
                        message.orderId = String(object.orderId);
                    if (object.amount != null) {
                        if (typeof object.amount !== "object")
                            throw TypeError(".waiternow.common.RefundPaidOrderActionProto.Request.amount: object expected");
                        message.amount = $root.waiternow.common.MoneyProto.fromObject(object.amount);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.RefundPaidOrderActionProto.Request
                 * @static
                 * @param {waiternow.common.RefundPaidOrderActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.orderId = "";
                        object.amount = null;
                    }
                    if (message.orderId != null && message.hasOwnProperty("orderId"))
                        object.orderId = message.orderId;
                    if (message.amount != null && message.hasOwnProperty("amount"))
                        object.amount = $root.waiternow.common.MoneyProto.toObject(message.amount, options);
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.RefundPaidOrderActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.RefundPaidOrderActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.RefundPaidOrderActionProto.Request";
                };

                return Request;
            })();

            RefundPaidOrderActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.RefundPaidOrderActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IPaymentProto|null} [payment] Response payment
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.RefundPaidOrderActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.RefundPaidOrderActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.RefundPaidOrderActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response payment.
                 * @member {waiternow.common.IPaymentProto|null|undefined} payment
                 * @memberof waiternow.common.RefundPaidOrderActionProto.Response
                 * @instance
                 */
                Response.prototype.payment = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.RefundPaidOrderActionProto.Response
                 * @static
                 * @param {waiternow.common.RefundPaidOrderActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.RefundPaidOrderActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.RefundPaidOrderActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.RefundPaidOrderActionProto.Response
                 * @static
                 * @param {waiternow.common.RefundPaidOrderActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.payment != null && Object.hasOwnProperty.call(message, "payment"))
                        $root.waiternow.common.PaymentProto.encode(message.payment, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.RefundPaidOrderActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.RefundPaidOrderActionProto.Response
                 * @static
                 * @param {waiternow.common.RefundPaidOrderActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.RefundPaidOrderActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.RefundPaidOrderActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.RefundPaidOrderActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.payment = $root.waiternow.common.PaymentProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.RefundPaidOrderActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.RefundPaidOrderActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.RefundPaidOrderActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.payment != null && message.hasOwnProperty("payment")) {
                        var error = $root.waiternow.common.PaymentProto.verify(message.payment);
                        if (error)
                            return "payment." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.RefundPaidOrderActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.RefundPaidOrderActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.RefundPaidOrderActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.RefundPaidOrderActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.RefundPaidOrderActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.payment != null) {
                        if (typeof object.payment !== "object")
                            throw TypeError(".waiternow.common.RefundPaidOrderActionProto.Response.payment: object expected");
                        message.payment = $root.waiternow.common.PaymentProto.fromObject(object.payment);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.RefundPaidOrderActionProto.Response
                 * @static
                 * @param {waiternow.common.RefundPaidOrderActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.payment = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.payment != null && message.hasOwnProperty("payment"))
                        object.payment = $root.waiternow.common.PaymentProto.toObject(message.payment, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.RefundPaidOrderActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.RefundPaidOrderActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.RefundPaidOrderActionProto.Response";
                };

                return Response;
            })();

            return RefundPaidOrderActionProto;
        })();

        common.FindRefundedOrdersActionProto = (function() {

            /**
             * Properties of a FindRefundedOrdersActionProto.
             * @memberof waiternow.common
             * @interface IFindRefundedOrdersActionProto
             */

            /**
             * Constructs a new FindRefundedOrdersActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a FindRefundedOrdersActionProto.
             * @implements IFindRefundedOrdersActionProto
             * @constructor
             * @param {waiternow.common.IFindRefundedOrdersActionProto=} [properties] Properties to set
             */
            function FindRefundedOrdersActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new FindRefundedOrdersActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FindRefundedOrdersActionProto
             * @static
             * @param {waiternow.common.IFindRefundedOrdersActionProto=} [properties] Properties to set
             * @returns {waiternow.common.FindRefundedOrdersActionProto} FindRefundedOrdersActionProto instance
             */
            FindRefundedOrdersActionProto.create = function create(properties) {
                return new FindRefundedOrdersActionProto(properties);
            };

            /**
             * Encodes the specified FindRefundedOrdersActionProto message. Does not implicitly {@link waiternow.common.FindRefundedOrdersActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FindRefundedOrdersActionProto
             * @static
             * @param {waiternow.common.IFindRefundedOrdersActionProto} message FindRefundedOrdersActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindRefundedOrdersActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified FindRefundedOrdersActionProto message, length delimited. Does not implicitly {@link waiternow.common.FindRefundedOrdersActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FindRefundedOrdersActionProto
             * @static
             * @param {waiternow.common.IFindRefundedOrdersActionProto} message FindRefundedOrdersActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindRefundedOrdersActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FindRefundedOrdersActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FindRefundedOrdersActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FindRefundedOrdersActionProto} FindRefundedOrdersActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindRefundedOrdersActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindRefundedOrdersActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FindRefundedOrdersActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FindRefundedOrdersActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FindRefundedOrdersActionProto} FindRefundedOrdersActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindRefundedOrdersActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FindRefundedOrdersActionProto message.
             * @function verify
             * @memberof waiternow.common.FindRefundedOrdersActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FindRefundedOrdersActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a FindRefundedOrdersActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FindRefundedOrdersActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FindRefundedOrdersActionProto} FindRefundedOrdersActionProto
             */
            FindRefundedOrdersActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FindRefundedOrdersActionProto)
                    return object;
                return new $root.waiternow.common.FindRefundedOrdersActionProto();
            };

            /**
             * Creates a plain object from a FindRefundedOrdersActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FindRefundedOrdersActionProto
             * @static
             * @param {waiternow.common.FindRefundedOrdersActionProto} message FindRefundedOrdersActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FindRefundedOrdersActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this FindRefundedOrdersActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FindRefundedOrdersActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FindRefundedOrdersActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FindRefundedOrdersActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.FindRefundedOrdersActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FindRefundedOrdersActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FindRefundedOrdersActionProto";
            };

            FindRefundedOrdersActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.FindRefundedOrdersActionProto
                 * @interface IRequest
                 * @property {string|null} [locationId] Request locationId
                 * @property {google.protobuf.ITimestamp|null} [afterTime] Request afterTime
                 * @property {google.protobuf.ITimestamp|null} [beforeTime] Request beforeTime
                 * @property {waiternow.common.SortOrder|null} [sortOrder] Request sortOrder
                 * @property {string|null} [continuationToken] Request continuationToken
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.FindRefundedOrdersActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.FindRefundedOrdersActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.FindRefundedOrdersActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = "";

                /**
                 * Request afterTime.
                 * @member {google.protobuf.ITimestamp|null|undefined} afterTime
                 * @memberof waiternow.common.FindRefundedOrdersActionProto.Request
                 * @instance
                 */
                Request.prototype.afterTime = null;

                /**
                 * Request beforeTime.
                 * @member {google.protobuf.ITimestamp|null|undefined} beforeTime
                 * @memberof waiternow.common.FindRefundedOrdersActionProto.Request
                 * @instance
                 */
                Request.prototype.beforeTime = null;

                /**
                 * Request sortOrder.
                 * @member {waiternow.common.SortOrder} sortOrder
                 * @memberof waiternow.common.FindRefundedOrdersActionProto.Request
                 * @instance
                 */
                Request.prototype.sortOrder = 0;

                /**
                 * Request continuationToken.
                 * @member {string} continuationToken
                 * @memberof waiternow.common.FindRefundedOrdersActionProto.Request
                 * @instance
                 */
                Request.prototype.continuationToken = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindRefundedOrdersActionProto.Request
                 * @static
                 * @param {waiternow.common.FindRefundedOrdersActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.FindRefundedOrdersActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.FindRefundedOrdersActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindRefundedOrdersActionProto.Request
                 * @static
                 * @param {waiternow.common.FindRefundedOrdersActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    if (message.afterTime != null && Object.hasOwnProperty.call(message, "afterTime"))
                        $root.google.protobuf.Timestamp.encode(message.afterTime, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.beforeTime != null && Object.hasOwnProperty.call(message, "beforeTime"))
                        $root.google.protobuf.Timestamp.encode(message.beforeTime, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.sortOrder != null && Object.hasOwnProperty.call(message, "sortOrder"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.sortOrder);
                    if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.continuationToken);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.FindRefundedOrdersActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindRefundedOrdersActionProto.Request
                 * @static
                 * @param {waiternow.common.FindRefundedOrdersActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindRefundedOrdersActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindRefundedOrdersActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindRefundedOrdersActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 2: {
                                message.afterTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.beforeTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            }
                        case 4: {
                                message.sortOrder = reader.int32();
                                break;
                            }
                        case 5: {
                                message.continuationToken = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindRefundedOrdersActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindRefundedOrdersActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.FindRefundedOrdersActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    if (message.afterTime != null && message.hasOwnProperty("afterTime")) {
                        var error = $root.google.protobuf.Timestamp.verify(message.afterTime);
                        if (error)
                            return "afterTime." + error;
                    }
                    if (message.beforeTime != null && message.hasOwnProperty("beforeTime")) {
                        var error = $root.google.protobuf.Timestamp.verify(message.beforeTime);
                        if (error)
                            return "beforeTime." + error;
                    }
                    if (message.sortOrder != null && message.hasOwnProperty("sortOrder"))
                        switch (message.sortOrder) {
                        default:
                            return "sortOrder: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        if (!$util.isString(message.continuationToken))
                            return "continuationToken: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindRefundedOrdersActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindRefundedOrdersActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindRefundedOrdersActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.FindRefundedOrdersActionProto.Request();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    if (object.afterTime != null) {
                        if (typeof object.afterTime !== "object")
                            throw TypeError(".waiternow.common.FindRefundedOrdersActionProto.Request.afterTime: object expected");
                        message.afterTime = $root.google.protobuf.Timestamp.fromObject(object.afterTime);
                    }
                    if (object.beforeTime != null) {
                        if (typeof object.beforeTime !== "object")
                            throw TypeError(".waiternow.common.FindRefundedOrdersActionProto.Request.beforeTime: object expected");
                        message.beforeTime = $root.google.protobuf.Timestamp.fromObject(object.beforeTime);
                    }
                    switch (object.sortOrder) {
                    default:
                        if (typeof object.sortOrder === "number") {
                            message.sortOrder = object.sortOrder;
                            break;
                        }
                        break;
                    case "SORT_ORDER_UNSPECIFIED":
                    case 0:
                        message.sortOrder = 0;
                        break;
                    case "ASCENDING":
                    case 1:
                        message.sortOrder = 1;
                        break;
                    case "DESCENDING":
                    case 2:
                        message.sortOrder = 2;
                        break;
                    }
                    if (object.continuationToken != null)
                        message.continuationToken = String(object.continuationToken);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindRefundedOrdersActionProto.Request
                 * @static
                 * @param {waiternow.common.FindRefundedOrdersActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.locationId = "";
                        object.afterTime = null;
                        object.beforeTime = null;
                        object.sortOrder = options.enums === String ? "SORT_ORDER_UNSPECIFIED" : 0;
                        object.continuationToken = "";
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    if (message.afterTime != null && message.hasOwnProperty("afterTime"))
                        object.afterTime = $root.google.protobuf.Timestamp.toObject(message.afterTime, options);
                    if (message.beforeTime != null && message.hasOwnProperty("beforeTime"))
                        object.beforeTime = $root.google.protobuf.Timestamp.toObject(message.beforeTime, options);
                    if (message.sortOrder != null && message.hasOwnProperty("sortOrder"))
                        object.sortOrder = options.enums === String ? $root.waiternow.common.SortOrder[message.sortOrder] === undefined ? message.sortOrder : $root.waiternow.common.SortOrder[message.sortOrder] : message.sortOrder;
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        object.continuationToken = message.continuationToken;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindRefundedOrdersActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindRefundedOrdersActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindRefundedOrdersActionProto.Request";
                };

                return Request;
            })();

            FindRefundedOrdersActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.FindRefundedOrdersActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.ILocationOrdersProto|null} [locationOrders] Response locationOrders
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.FindRefundedOrdersActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.FindRefundedOrdersActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.FindRefundedOrdersActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response locationOrders.
                 * @member {waiternow.common.ILocationOrdersProto|null|undefined} locationOrders
                 * @memberof waiternow.common.FindRefundedOrdersActionProto.Response
                 * @instance
                 */
                Response.prototype.locationOrders = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindRefundedOrdersActionProto.Response
                 * @static
                 * @param {waiternow.common.FindRefundedOrdersActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.FindRefundedOrdersActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.FindRefundedOrdersActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindRefundedOrdersActionProto.Response
                 * @static
                 * @param {waiternow.common.FindRefundedOrdersActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.locationOrders != null && Object.hasOwnProperty.call(message, "locationOrders"))
                        $root.waiternow.common.LocationOrdersProto.encode(message.locationOrders, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.FindRefundedOrdersActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindRefundedOrdersActionProto.Response
                 * @static
                 * @param {waiternow.common.FindRefundedOrdersActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindRefundedOrdersActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindRefundedOrdersActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindRefundedOrdersActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.locationOrders = $root.waiternow.common.LocationOrdersProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindRefundedOrdersActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindRefundedOrdersActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.FindRefundedOrdersActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.locationOrders != null && message.hasOwnProperty("locationOrders")) {
                        var error = $root.waiternow.common.LocationOrdersProto.verify(message.locationOrders);
                        if (error)
                            return "locationOrders." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindRefundedOrdersActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindRefundedOrdersActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindRefundedOrdersActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.FindRefundedOrdersActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.FindRefundedOrdersActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.locationOrders != null) {
                        if (typeof object.locationOrders !== "object")
                            throw TypeError(".waiternow.common.FindRefundedOrdersActionProto.Response.locationOrders: object expected");
                        message.locationOrders = $root.waiternow.common.LocationOrdersProto.fromObject(object.locationOrders);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindRefundedOrdersActionProto.Response
                 * @static
                 * @param {waiternow.common.FindRefundedOrdersActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.locationOrders = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.locationOrders != null && message.hasOwnProperty("locationOrders"))
                        object.locationOrders = $root.waiternow.common.LocationOrdersProto.toObject(message.locationOrders, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindRefundedOrdersActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindRefundedOrdersActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindRefundedOrdersActionProto.Response";
                };

                return Response;
            })();

            return FindRefundedOrdersActionProto;
        })();

        common.FindDisputedOrdersActionProto = (function() {

            /**
             * Properties of a FindDisputedOrdersActionProto.
             * @memberof waiternow.common
             * @interface IFindDisputedOrdersActionProto
             */

            /**
             * Constructs a new FindDisputedOrdersActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a FindDisputedOrdersActionProto.
             * @implements IFindDisputedOrdersActionProto
             * @constructor
             * @param {waiternow.common.IFindDisputedOrdersActionProto=} [properties] Properties to set
             */
            function FindDisputedOrdersActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new FindDisputedOrdersActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FindDisputedOrdersActionProto
             * @static
             * @param {waiternow.common.IFindDisputedOrdersActionProto=} [properties] Properties to set
             * @returns {waiternow.common.FindDisputedOrdersActionProto} FindDisputedOrdersActionProto instance
             */
            FindDisputedOrdersActionProto.create = function create(properties) {
                return new FindDisputedOrdersActionProto(properties);
            };

            /**
             * Encodes the specified FindDisputedOrdersActionProto message. Does not implicitly {@link waiternow.common.FindDisputedOrdersActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FindDisputedOrdersActionProto
             * @static
             * @param {waiternow.common.IFindDisputedOrdersActionProto} message FindDisputedOrdersActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindDisputedOrdersActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified FindDisputedOrdersActionProto message, length delimited. Does not implicitly {@link waiternow.common.FindDisputedOrdersActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FindDisputedOrdersActionProto
             * @static
             * @param {waiternow.common.IFindDisputedOrdersActionProto} message FindDisputedOrdersActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindDisputedOrdersActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FindDisputedOrdersActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FindDisputedOrdersActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FindDisputedOrdersActionProto} FindDisputedOrdersActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindDisputedOrdersActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindDisputedOrdersActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FindDisputedOrdersActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FindDisputedOrdersActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FindDisputedOrdersActionProto} FindDisputedOrdersActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindDisputedOrdersActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FindDisputedOrdersActionProto message.
             * @function verify
             * @memberof waiternow.common.FindDisputedOrdersActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FindDisputedOrdersActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a FindDisputedOrdersActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FindDisputedOrdersActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FindDisputedOrdersActionProto} FindDisputedOrdersActionProto
             */
            FindDisputedOrdersActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FindDisputedOrdersActionProto)
                    return object;
                return new $root.waiternow.common.FindDisputedOrdersActionProto();
            };

            /**
             * Creates a plain object from a FindDisputedOrdersActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FindDisputedOrdersActionProto
             * @static
             * @param {waiternow.common.FindDisputedOrdersActionProto} message FindDisputedOrdersActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FindDisputedOrdersActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this FindDisputedOrdersActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FindDisputedOrdersActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FindDisputedOrdersActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FindDisputedOrdersActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.FindDisputedOrdersActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FindDisputedOrdersActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FindDisputedOrdersActionProto";
            };

            FindDisputedOrdersActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.FindDisputedOrdersActionProto
                 * @interface IRequest
                 * @property {string|null} [locationId] Request locationId
                 * @property {google.protobuf.ITimestamp|null} [afterTime] Request afterTime
                 * @property {google.protobuf.ITimestamp|null} [beforeTime] Request beforeTime
                 * @property {waiternow.common.SortOrder|null} [sortOrder] Request sortOrder
                 * @property {string|null} [continuationToken] Request continuationToken
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.FindDisputedOrdersActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.FindDisputedOrdersActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.FindDisputedOrdersActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = "";

                /**
                 * Request afterTime.
                 * @member {google.protobuf.ITimestamp|null|undefined} afterTime
                 * @memberof waiternow.common.FindDisputedOrdersActionProto.Request
                 * @instance
                 */
                Request.prototype.afterTime = null;

                /**
                 * Request beforeTime.
                 * @member {google.protobuf.ITimestamp|null|undefined} beforeTime
                 * @memberof waiternow.common.FindDisputedOrdersActionProto.Request
                 * @instance
                 */
                Request.prototype.beforeTime = null;

                /**
                 * Request sortOrder.
                 * @member {waiternow.common.SortOrder} sortOrder
                 * @memberof waiternow.common.FindDisputedOrdersActionProto.Request
                 * @instance
                 */
                Request.prototype.sortOrder = 0;

                /**
                 * Request continuationToken.
                 * @member {string} continuationToken
                 * @memberof waiternow.common.FindDisputedOrdersActionProto.Request
                 * @instance
                 */
                Request.prototype.continuationToken = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindDisputedOrdersActionProto.Request
                 * @static
                 * @param {waiternow.common.FindDisputedOrdersActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.FindDisputedOrdersActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.FindDisputedOrdersActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindDisputedOrdersActionProto.Request
                 * @static
                 * @param {waiternow.common.FindDisputedOrdersActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    if (message.afterTime != null && Object.hasOwnProperty.call(message, "afterTime"))
                        $root.google.protobuf.Timestamp.encode(message.afterTime, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.beforeTime != null && Object.hasOwnProperty.call(message, "beforeTime"))
                        $root.google.protobuf.Timestamp.encode(message.beforeTime, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.sortOrder != null && Object.hasOwnProperty.call(message, "sortOrder"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.sortOrder);
                    if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.continuationToken);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.FindDisputedOrdersActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindDisputedOrdersActionProto.Request
                 * @static
                 * @param {waiternow.common.FindDisputedOrdersActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindDisputedOrdersActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindDisputedOrdersActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindDisputedOrdersActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 2: {
                                message.afterTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.beforeTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            }
                        case 4: {
                                message.sortOrder = reader.int32();
                                break;
                            }
                        case 5: {
                                message.continuationToken = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindDisputedOrdersActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindDisputedOrdersActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.FindDisputedOrdersActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    if (message.afterTime != null && message.hasOwnProperty("afterTime")) {
                        var error = $root.google.protobuf.Timestamp.verify(message.afterTime);
                        if (error)
                            return "afterTime." + error;
                    }
                    if (message.beforeTime != null && message.hasOwnProperty("beforeTime")) {
                        var error = $root.google.protobuf.Timestamp.verify(message.beforeTime);
                        if (error)
                            return "beforeTime." + error;
                    }
                    if (message.sortOrder != null && message.hasOwnProperty("sortOrder"))
                        switch (message.sortOrder) {
                        default:
                            return "sortOrder: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        if (!$util.isString(message.continuationToken))
                            return "continuationToken: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindDisputedOrdersActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindDisputedOrdersActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindDisputedOrdersActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.FindDisputedOrdersActionProto.Request();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    if (object.afterTime != null) {
                        if (typeof object.afterTime !== "object")
                            throw TypeError(".waiternow.common.FindDisputedOrdersActionProto.Request.afterTime: object expected");
                        message.afterTime = $root.google.protobuf.Timestamp.fromObject(object.afterTime);
                    }
                    if (object.beforeTime != null) {
                        if (typeof object.beforeTime !== "object")
                            throw TypeError(".waiternow.common.FindDisputedOrdersActionProto.Request.beforeTime: object expected");
                        message.beforeTime = $root.google.protobuf.Timestamp.fromObject(object.beforeTime);
                    }
                    switch (object.sortOrder) {
                    default:
                        if (typeof object.sortOrder === "number") {
                            message.sortOrder = object.sortOrder;
                            break;
                        }
                        break;
                    case "SORT_ORDER_UNSPECIFIED":
                    case 0:
                        message.sortOrder = 0;
                        break;
                    case "ASCENDING":
                    case 1:
                        message.sortOrder = 1;
                        break;
                    case "DESCENDING":
                    case 2:
                        message.sortOrder = 2;
                        break;
                    }
                    if (object.continuationToken != null)
                        message.continuationToken = String(object.continuationToken);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindDisputedOrdersActionProto.Request
                 * @static
                 * @param {waiternow.common.FindDisputedOrdersActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.locationId = "";
                        object.afterTime = null;
                        object.beforeTime = null;
                        object.sortOrder = options.enums === String ? "SORT_ORDER_UNSPECIFIED" : 0;
                        object.continuationToken = "";
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    if (message.afterTime != null && message.hasOwnProperty("afterTime"))
                        object.afterTime = $root.google.protobuf.Timestamp.toObject(message.afterTime, options);
                    if (message.beforeTime != null && message.hasOwnProperty("beforeTime"))
                        object.beforeTime = $root.google.protobuf.Timestamp.toObject(message.beforeTime, options);
                    if (message.sortOrder != null && message.hasOwnProperty("sortOrder"))
                        object.sortOrder = options.enums === String ? $root.waiternow.common.SortOrder[message.sortOrder] === undefined ? message.sortOrder : $root.waiternow.common.SortOrder[message.sortOrder] : message.sortOrder;
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        object.continuationToken = message.continuationToken;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindDisputedOrdersActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindDisputedOrdersActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindDisputedOrdersActionProto.Request";
                };

                return Request;
            })();

            FindDisputedOrdersActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.FindDisputedOrdersActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.ILocationOrdersProto|null} [locationOrders] Response locationOrders
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.FindDisputedOrdersActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.FindDisputedOrdersActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.FindDisputedOrdersActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response locationOrders.
                 * @member {waiternow.common.ILocationOrdersProto|null|undefined} locationOrders
                 * @memberof waiternow.common.FindDisputedOrdersActionProto.Response
                 * @instance
                 */
                Response.prototype.locationOrders = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindDisputedOrdersActionProto.Response
                 * @static
                 * @param {waiternow.common.FindDisputedOrdersActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.FindDisputedOrdersActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.FindDisputedOrdersActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindDisputedOrdersActionProto.Response
                 * @static
                 * @param {waiternow.common.FindDisputedOrdersActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.locationOrders != null && Object.hasOwnProperty.call(message, "locationOrders"))
                        $root.waiternow.common.LocationOrdersProto.encode(message.locationOrders, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.FindDisputedOrdersActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindDisputedOrdersActionProto.Response
                 * @static
                 * @param {waiternow.common.FindDisputedOrdersActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindDisputedOrdersActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindDisputedOrdersActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindDisputedOrdersActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.locationOrders = $root.waiternow.common.LocationOrdersProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindDisputedOrdersActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindDisputedOrdersActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.FindDisputedOrdersActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.locationOrders != null && message.hasOwnProperty("locationOrders")) {
                        var error = $root.waiternow.common.LocationOrdersProto.verify(message.locationOrders);
                        if (error)
                            return "locationOrders." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindDisputedOrdersActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindDisputedOrdersActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindDisputedOrdersActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.FindDisputedOrdersActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.FindDisputedOrdersActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.locationOrders != null) {
                        if (typeof object.locationOrders !== "object")
                            throw TypeError(".waiternow.common.FindDisputedOrdersActionProto.Response.locationOrders: object expected");
                        message.locationOrders = $root.waiternow.common.LocationOrdersProto.fromObject(object.locationOrders);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindDisputedOrdersActionProto.Response
                 * @static
                 * @param {waiternow.common.FindDisputedOrdersActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.locationOrders = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.locationOrders != null && message.hasOwnProperty("locationOrders"))
                        object.locationOrders = $root.waiternow.common.LocationOrdersProto.toObject(message.locationOrders, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindDisputedOrdersActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindDisputedOrdersActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindDisputedOrdersActionProto.Response";
                };

                return Response;
            })();

            return FindDisputedOrdersActionProto;
        })();

        common.FindPaidRefundedOrDisputedOrdersActionProto = (function() {

            /**
             * Properties of a FindPaidRefundedOrDisputedOrdersActionProto.
             * @memberof waiternow.common
             * @interface IFindPaidRefundedOrDisputedOrdersActionProto
             */

            /**
             * Constructs a new FindPaidRefundedOrDisputedOrdersActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a FindPaidRefundedOrDisputedOrdersActionProto.
             * @implements IFindPaidRefundedOrDisputedOrdersActionProto
             * @constructor
             * @param {waiternow.common.IFindPaidRefundedOrDisputedOrdersActionProto=} [properties] Properties to set
             */
            function FindPaidRefundedOrDisputedOrdersActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new FindPaidRefundedOrDisputedOrdersActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto
             * @static
             * @param {waiternow.common.IFindPaidRefundedOrDisputedOrdersActionProto=} [properties] Properties to set
             * @returns {waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto} FindPaidRefundedOrDisputedOrdersActionProto instance
             */
            FindPaidRefundedOrDisputedOrdersActionProto.create = function create(properties) {
                return new FindPaidRefundedOrDisputedOrdersActionProto(properties);
            };

            /**
             * Encodes the specified FindPaidRefundedOrDisputedOrdersActionProto message. Does not implicitly {@link waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto
             * @static
             * @param {waiternow.common.IFindPaidRefundedOrDisputedOrdersActionProto} message FindPaidRefundedOrDisputedOrdersActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindPaidRefundedOrDisputedOrdersActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified FindPaidRefundedOrDisputedOrdersActionProto message, length delimited. Does not implicitly {@link waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto
             * @static
             * @param {waiternow.common.IFindPaidRefundedOrDisputedOrdersActionProto} message FindPaidRefundedOrDisputedOrdersActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindPaidRefundedOrDisputedOrdersActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FindPaidRefundedOrDisputedOrdersActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto} FindPaidRefundedOrDisputedOrdersActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindPaidRefundedOrDisputedOrdersActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FindPaidRefundedOrDisputedOrdersActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto} FindPaidRefundedOrDisputedOrdersActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindPaidRefundedOrDisputedOrdersActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FindPaidRefundedOrDisputedOrdersActionProto message.
             * @function verify
             * @memberof waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FindPaidRefundedOrDisputedOrdersActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a FindPaidRefundedOrDisputedOrdersActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto} FindPaidRefundedOrDisputedOrdersActionProto
             */
            FindPaidRefundedOrDisputedOrdersActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto)
                    return object;
                return new $root.waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto();
            };

            /**
             * Creates a plain object from a FindPaidRefundedOrDisputedOrdersActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto
             * @static
             * @param {waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto} message FindPaidRefundedOrDisputedOrdersActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FindPaidRefundedOrDisputedOrdersActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this FindPaidRefundedOrDisputedOrdersActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FindPaidRefundedOrDisputedOrdersActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FindPaidRefundedOrDisputedOrdersActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FindPaidRefundedOrDisputedOrdersActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto";
            };

            FindPaidRefundedOrDisputedOrdersActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto
                 * @interface IRequest
                 * @property {string|null} [locationId] Request locationId
                 * @property {google.protobuf.ITimestamp|null} [afterTime] Request afterTime
                 * @property {google.protobuf.ITimestamp|null} [beforeTime] Request beforeTime
                 * @property {waiternow.common.SortOrder|null} [sortOrder] Request sortOrder
                 * @property {string|null} [continuationToken] Request continuationToken
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = "";

                /**
                 * Request afterTime.
                 * @member {google.protobuf.ITimestamp|null|undefined} afterTime
                 * @memberof waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Request
                 * @instance
                 */
                Request.prototype.afterTime = null;

                /**
                 * Request beforeTime.
                 * @member {google.protobuf.ITimestamp|null|undefined} beforeTime
                 * @memberof waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Request
                 * @instance
                 */
                Request.prototype.beforeTime = null;

                /**
                 * Request sortOrder.
                 * @member {waiternow.common.SortOrder} sortOrder
                 * @memberof waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Request
                 * @instance
                 */
                Request.prototype.sortOrder = 0;

                /**
                 * Request continuationToken.
                 * @member {string} continuationToken
                 * @memberof waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Request
                 * @instance
                 */
                Request.prototype.continuationToken = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Request
                 * @static
                 * @param {waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Request
                 * @static
                 * @param {waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    if (message.afterTime != null && Object.hasOwnProperty.call(message, "afterTime"))
                        $root.google.protobuf.Timestamp.encode(message.afterTime, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.beforeTime != null && Object.hasOwnProperty.call(message, "beforeTime"))
                        $root.google.protobuf.Timestamp.encode(message.beforeTime, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.sortOrder != null && Object.hasOwnProperty.call(message, "sortOrder"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.sortOrder);
                    if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.continuationToken);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Request
                 * @static
                 * @param {waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 2: {
                                message.afterTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.beforeTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            }
                        case 4: {
                                message.sortOrder = reader.int32();
                                break;
                            }
                        case 5: {
                                message.continuationToken = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    if (message.afterTime != null && message.hasOwnProperty("afterTime")) {
                        var error = $root.google.protobuf.Timestamp.verify(message.afterTime);
                        if (error)
                            return "afterTime." + error;
                    }
                    if (message.beforeTime != null && message.hasOwnProperty("beforeTime")) {
                        var error = $root.google.protobuf.Timestamp.verify(message.beforeTime);
                        if (error)
                            return "beforeTime." + error;
                    }
                    if (message.sortOrder != null && message.hasOwnProperty("sortOrder"))
                        switch (message.sortOrder) {
                        default:
                            return "sortOrder: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        if (!$util.isString(message.continuationToken))
                            return "continuationToken: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Request();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    if (object.afterTime != null) {
                        if (typeof object.afterTime !== "object")
                            throw TypeError(".waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Request.afterTime: object expected");
                        message.afterTime = $root.google.protobuf.Timestamp.fromObject(object.afterTime);
                    }
                    if (object.beforeTime != null) {
                        if (typeof object.beforeTime !== "object")
                            throw TypeError(".waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Request.beforeTime: object expected");
                        message.beforeTime = $root.google.protobuf.Timestamp.fromObject(object.beforeTime);
                    }
                    switch (object.sortOrder) {
                    default:
                        if (typeof object.sortOrder === "number") {
                            message.sortOrder = object.sortOrder;
                            break;
                        }
                        break;
                    case "SORT_ORDER_UNSPECIFIED":
                    case 0:
                        message.sortOrder = 0;
                        break;
                    case "ASCENDING":
                    case 1:
                        message.sortOrder = 1;
                        break;
                    case "DESCENDING":
                    case 2:
                        message.sortOrder = 2;
                        break;
                    }
                    if (object.continuationToken != null)
                        message.continuationToken = String(object.continuationToken);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Request
                 * @static
                 * @param {waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.locationId = "";
                        object.afterTime = null;
                        object.beforeTime = null;
                        object.sortOrder = options.enums === String ? "SORT_ORDER_UNSPECIFIED" : 0;
                        object.continuationToken = "";
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    if (message.afterTime != null && message.hasOwnProperty("afterTime"))
                        object.afterTime = $root.google.protobuf.Timestamp.toObject(message.afterTime, options);
                    if (message.beforeTime != null && message.hasOwnProperty("beforeTime"))
                        object.beforeTime = $root.google.protobuf.Timestamp.toObject(message.beforeTime, options);
                    if (message.sortOrder != null && message.hasOwnProperty("sortOrder"))
                        object.sortOrder = options.enums === String ? $root.waiternow.common.SortOrder[message.sortOrder] === undefined ? message.sortOrder : $root.waiternow.common.SortOrder[message.sortOrder] : message.sortOrder;
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        object.continuationToken = message.continuationToken;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Request";
                };

                return Request;
            })();

            FindPaidRefundedOrDisputedOrdersActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.ILocationOrdersProto|null} [locationOrders] Response locationOrders
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response locationOrders.
                 * @member {waiternow.common.ILocationOrdersProto|null|undefined} locationOrders
                 * @memberof waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Response
                 * @instance
                 */
                Response.prototype.locationOrders = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Response
                 * @static
                 * @param {waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Response
                 * @static
                 * @param {waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.locationOrders != null && Object.hasOwnProperty.call(message, "locationOrders"))
                        $root.waiternow.common.LocationOrdersProto.encode(message.locationOrders, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Response
                 * @static
                 * @param {waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.locationOrders = $root.waiternow.common.LocationOrdersProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.locationOrders != null && message.hasOwnProperty("locationOrders")) {
                        var error = $root.waiternow.common.LocationOrdersProto.verify(message.locationOrders);
                        if (error)
                            return "locationOrders." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.locationOrders != null) {
                        if (typeof object.locationOrders !== "object")
                            throw TypeError(".waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Response.locationOrders: object expected");
                        message.locationOrders = $root.waiternow.common.LocationOrdersProto.fromObject(object.locationOrders);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Response
                 * @static
                 * @param {waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.locationOrders = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.locationOrders != null && message.hasOwnProperty("locationOrders"))
                        object.locationOrders = $root.waiternow.common.LocationOrdersProto.toObject(message.locationOrders, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindPaidRefundedOrDisputedOrdersActionProto.Response";
                };

                return Response;
            })();

            return FindPaidRefundedOrDisputedOrdersActionProto;
        })();

        common.FindDisputedOrdersForAllLocationsActionProto = (function() {

            /**
             * Properties of a FindDisputedOrdersForAllLocationsActionProto.
             * @memberof waiternow.common
             * @interface IFindDisputedOrdersForAllLocationsActionProto
             */

            /**
             * Constructs a new FindDisputedOrdersForAllLocationsActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a FindDisputedOrdersForAllLocationsActionProto.
             * @implements IFindDisputedOrdersForAllLocationsActionProto
             * @constructor
             * @param {waiternow.common.IFindDisputedOrdersForAllLocationsActionProto=} [properties] Properties to set
             */
            function FindDisputedOrdersForAllLocationsActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new FindDisputedOrdersForAllLocationsActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FindDisputedOrdersForAllLocationsActionProto
             * @static
             * @param {waiternow.common.IFindDisputedOrdersForAllLocationsActionProto=} [properties] Properties to set
             * @returns {waiternow.common.FindDisputedOrdersForAllLocationsActionProto} FindDisputedOrdersForAllLocationsActionProto instance
             */
            FindDisputedOrdersForAllLocationsActionProto.create = function create(properties) {
                return new FindDisputedOrdersForAllLocationsActionProto(properties);
            };

            /**
             * Encodes the specified FindDisputedOrdersForAllLocationsActionProto message. Does not implicitly {@link waiternow.common.FindDisputedOrdersForAllLocationsActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FindDisputedOrdersForAllLocationsActionProto
             * @static
             * @param {waiternow.common.IFindDisputedOrdersForAllLocationsActionProto} message FindDisputedOrdersForAllLocationsActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindDisputedOrdersForAllLocationsActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified FindDisputedOrdersForAllLocationsActionProto message, length delimited. Does not implicitly {@link waiternow.common.FindDisputedOrdersForAllLocationsActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FindDisputedOrdersForAllLocationsActionProto
             * @static
             * @param {waiternow.common.IFindDisputedOrdersForAllLocationsActionProto} message FindDisputedOrdersForAllLocationsActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindDisputedOrdersForAllLocationsActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FindDisputedOrdersForAllLocationsActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FindDisputedOrdersForAllLocationsActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FindDisputedOrdersForAllLocationsActionProto} FindDisputedOrdersForAllLocationsActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindDisputedOrdersForAllLocationsActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindDisputedOrdersForAllLocationsActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FindDisputedOrdersForAllLocationsActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FindDisputedOrdersForAllLocationsActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FindDisputedOrdersForAllLocationsActionProto} FindDisputedOrdersForAllLocationsActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindDisputedOrdersForAllLocationsActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FindDisputedOrdersForAllLocationsActionProto message.
             * @function verify
             * @memberof waiternow.common.FindDisputedOrdersForAllLocationsActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FindDisputedOrdersForAllLocationsActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a FindDisputedOrdersForAllLocationsActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FindDisputedOrdersForAllLocationsActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FindDisputedOrdersForAllLocationsActionProto} FindDisputedOrdersForAllLocationsActionProto
             */
            FindDisputedOrdersForAllLocationsActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FindDisputedOrdersForAllLocationsActionProto)
                    return object;
                return new $root.waiternow.common.FindDisputedOrdersForAllLocationsActionProto();
            };

            /**
             * Creates a plain object from a FindDisputedOrdersForAllLocationsActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FindDisputedOrdersForAllLocationsActionProto
             * @static
             * @param {waiternow.common.FindDisputedOrdersForAllLocationsActionProto} message FindDisputedOrdersForAllLocationsActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FindDisputedOrdersForAllLocationsActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this FindDisputedOrdersForAllLocationsActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FindDisputedOrdersForAllLocationsActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FindDisputedOrdersForAllLocationsActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FindDisputedOrdersForAllLocationsActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.FindDisputedOrdersForAllLocationsActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FindDisputedOrdersForAllLocationsActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FindDisputedOrdersForAllLocationsActionProto";
            };

            FindDisputedOrdersForAllLocationsActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.FindDisputedOrdersForAllLocationsActionProto
                 * @interface IRequest
                 * @property {google.protobuf.ITimestamp|null} [afterTime] Request afterTime
                 * @property {google.protobuf.ITimestamp|null} [beforeTime] Request beforeTime
                 * @property {string|null} [continuationToken] Request continuationToken
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.FindDisputedOrdersForAllLocationsActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.FindDisputedOrdersForAllLocationsActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request afterTime.
                 * @member {google.protobuf.ITimestamp|null|undefined} afterTime
                 * @memberof waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Request
                 * @instance
                 */
                Request.prototype.afterTime = null;

                /**
                 * Request beforeTime.
                 * @member {google.protobuf.ITimestamp|null|undefined} beforeTime
                 * @memberof waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Request
                 * @instance
                 */
                Request.prototype.beforeTime = null;

                /**
                 * Request continuationToken.
                 * @member {string} continuationToken
                 * @memberof waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Request
                 * @instance
                 */
                Request.prototype.continuationToken = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Request
                 * @static
                 * @param {waiternow.common.FindDisputedOrdersForAllLocationsActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Request
                 * @static
                 * @param {waiternow.common.FindDisputedOrdersForAllLocationsActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.afterTime != null && Object.hasOwnProperty.call(message, "afterTime"))
                        $root.google.protobuf.Timestamp.encode(message.afterTime, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.beforeTime != null && Object.hasOwnProperty.call(message, "beforeTime"))
                        $root.google.protobuf.Timestamp.encode(message.beforeTime, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.continuationToken);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Request
                 * @static
                 * @param {waiternow.common.FindDisputedOrdersForAllLocationsActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.afterTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.beforeTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            }
                        case 4: {
                                message.continuationToken = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.afterTime != null && message.hasOwnProperty("afterTime")) {
                        var error = $root.google.protobuf.Timestamp.verify(message.afterTime);
                        if (error)
                            return "afterTime." + error;
                    }
                    if (message.beforeTime != null && message.hasOwnProperty("beforeTime")) {
                        var error = $root.google.protobuf.Timestamp.verify(message.beforeTime);
                        if (error)
                            return "beforeTime." + error;
                    }
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        if (!$util.isString(message.continuationToken))
                            return "continuationToken: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Request();
                    if (object.afterTime != null) {
                        if (typeof object.afterTime !== "object")
                            throw TypeError(".waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Request.afterTime: object expected");
                        message.afterTime = $root.google.protobuf.Timestamp.fromObject(object.afterTime);
                    }
                    if (object.beforeTime != null) {
                        if (typeof object.beforeTime !== "object")
                            throw TypeError(".waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Request.beforeTime: object expected");
                        message.beforeTime = $root.google.protobuf.Timestamp.fromObject(object.beforeTime);
                    }
                    if (object.continuationToken != null)
                        message.continuationToken = String(object.continuationToken);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Request
                 * @static
                 * @param {waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.afterTime = null;
                        object.beforeTime = null;
                        object.continuationToken = "";
                    }
                    if (message.afterTime != null && message.hasOwnProperty("afterTime"))
                        object.afterTime = $root.google.protobuf.Timestamp.toObject(message.afterTime, options);
                    if (message.beforeTime != null && message.hasOwnProperty("beforeTime"))
                        object.beforeTime = $root.google.protobuf.Timestamp.toObject(message.beforeTime, options);
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        object.continuationToken = message.continuationToken;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Request";
                };

                return Request;
            })();

            FindDisputedOrdersForAllLocationsActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.FindDisputedOrdersForAllLocationsActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IOrdersProto|null} [orders] Response orders
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.FindDisputedOrdersForAllLocationsActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.FindDisputedOrdersForAllLocationsActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response orders.
                 * @member {waiternow.common.IOrdersProto|null|undefined} orders
                 * @memberof waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Response
                 * @instance
                 */
                Response.prototype.orders = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Response
                 * @static
                 * @param {waiternow.common.FindDisputedOrdersForAllLocationsActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Response
                 * @static
                 * @param {waiternow.common.FindDisputedOrdersForAllLocationsActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.orders != null && Object.hasOwnProperty.call(message, "orders"))
                        $root.waiternow.common.OrdersProto.encode(message.orders, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Response
                 * @static
                 * @param {waiternow.common.FindDisputedOrdersForAllLocationsActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.orders = $root.waiternow.common.OrdersProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.orders != null && message.hasOwnProperty("orders")) {
                        var error = $root.waiternow.common.OrdersProto.verify(message.orders);
                        if (error)
                            return "orders." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.orders != null) {
                        if (typeof object.orders !== "object")
                            throw TypeError(".waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Response.orders: object expected");
                        message.orders = $root.waiternow.common.OrdersProto.fromObject(object.orders);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Response
                 * @static
                 * @param {waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.orders = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.orders != null && message.hasOwnProperty("orders"))
                        object.orders = $root.waiternow.common.OrdersProto.toObject(message.orders, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindDisputedOrdersForAllLocationsActionProto.Response";
                };

                return Response;
            })();

            return FindDisputedOrdersForAllLocationsActionProto;
        })();

        common.FindUnackedAndPaidOrdersForAllLocationsActionProto = (function() {

            /**
             * Properties of a FindUnackedAndPaidOrdersForAllLocationsActionProto.
             * @memberof waiternow.common
             * @interface IFindUnackedAndPaidOrdersForAllLocationsActionProto
             */

            /**
             * Constructs a new FindUnackedAndPaidOrdersForAllLocationsActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a FindUnackedAndPaidOrdersForAllLocationsActionProto.
             * @implements IFindUnackedAndPaidOrdersForAllLocationsActionProto
             * @constructor
             * @param {waiternow.common.IFindUnackedAndPaidOrdersForAllLocationsActionProto=} [properties] Properties to set
             */
            function FindUnackedAndPaidOrdersForAllLocationsActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new FindUnackedAndPaidOrdersForAllLocationsActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto
             * @static
             * @param {waiternow.common.IFindUnackedAndPaidOrdersForAllLocationsActionProto=} [properties] Properties to set
             * @returns {waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto} FindUnackedAndPaidOrdersForAllLocationsActionProto instance
             */
            FindUnackedAndPaidOrdersForAllLocationsActionProto.create = function create(properties) {
                return new FindUnackedAndPaidOrdersForAllLocationsActionProto(properties);
            };

            /**
             * Encodes the specified FindUnackedAndPaidOrdersForAllLocationsActionProto message. Does not implicitly {@link waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto
             * @static
             * @param {waiternow.common.IFindUnackedAndPaidOrdersForAllLocationsActionProto} message FindUnackedAndPaidOrdersForAllLocationsActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindUnackedAndPaidOrdersForAllLocationsActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified FindUnackedAndPaidOrdersForAllLocationsActionProto message, length delimited. Does not implicitly {@link waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto
             * @static
             * @param {waiternow.common.IFindUnackedAndPaidOrdersForAllLocationsActionProto} message FindUnackedAndPaidOrdersForAllLocationsActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindUnackedAndPaidOrdersForAllLocationsActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FindUnackedAndPaidOrdersForAllLocationsActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto} FindUnackedAndPaidOrdersForAllLocationsActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindUnackedAndPaidOrdersForAllLocationsActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FindUnackedAndPaidOrdersForAllLocationsActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto} FindUnackedAndPaidOrdersForAllLocationsActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindUnackedAndPaidOrdersForAllLocationsActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FindUnackedAndPaidOrdersForAllLocationsActionProto message.
             * @function verify
             * @memberof waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FindUnackedAndPaidOrdersForAllLocationsActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a FindUnackedAndPaidOrdersForAllLocationsActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto} FindUnackedAndPaidOrdersForAllLocationsActionProto
             */
            FindUnackedAndPaidOrdersForAllLocationsActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto)
                    return object;
                return new $root.waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto();
            };

            /**
             * Creates a plain object from a FindUnackedAndPaidOrdersForAllLocationsActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto
             * @static
             * @param {waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto} message FindUnackedAndPaidOrdersForAllLocationsActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FindUnackedAndPaidOrdersForAllLocationsActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this FindUnackedAndPaidOrdersForAllLocationsActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FindUnackedAndPaidOrdersForAllLocationsActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FindUnackedAndPaidOrdersForAllLocationsActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FindUnackedAndPaidOrdersForAllLocationsActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto";
            };

            FindUnackedAndPaidOrdersForAllLocationsActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto
                 * @interface IRequest
                 * @property {google.protobuf.ITimestamp|null} [afterTime] Request afterTime
                 * @property {google.protobuf.ITimestamp|null} [beforeTime] Request beforeTime
                 * @property {waiternow.common.SortOrder|null} [sortOrder] Request sortOrder
                 * @property {string|null} [continuationToken] Request continuationToken
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request afterTime.
                 * @member {google.protobuf.ITimestamp|null|undefined} afterTime
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Request
                 * @instance
                 */
                Request.prototype.afterTime = null;

                /**
                 * Request beforeTime.
                 * @member {google.protobuf.ITimestamp|null|undefined} beforeTime
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Request
                 * @instance
                 */
                Request.prototype.beforeTime = null;

                /**
                 * Request sortOrder.
                 * @member {waiternow.common.SortOrder} sortOrder
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Request
                 * @instance
                 */
                Request.prototype.sortOrder = 0;

                /**
                 * Request continuationToken.
                 * @member {string} continuationToken
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Request
                 * @instance
                 */
                Request.prototype.continuationToken = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Request
                 * @static
                 * @param {waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Request
                 * @static
                 * @param {waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.afterTime != null && Object.hasOwnProperty.call(message, "afterTime"))
                        $root.google.protobuf.Timestamp.encode(message.afterTime, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.beforeTime != null && Object.hasOwnProperty.call(message, "beforeTime"))
                        $root.google.protobuf.Timestamp.encode(message.beforeTime, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.sortOrder != null && Object.hasOwnProperty.call(message, "sortOrder"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.sortOrder);
                    if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.continuationToken);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Request
                 * @static
                 * @param {waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.afterTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.beforeTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.sortOrder = reader.int32();
                                break;
                            }
                        case 4: {
                                message.continuationToken = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.afterTime != null && message.hasOwnProperty("afterTime")) {
                        var error = $root.google.protobuf.Timestamp.verify(message.afterTime);
                        if (error)
                            return "afterTime." + error;
                    }
                    if (message.beforeTime != null && message.hasOwnProperty("beforeTime")) {
                        var error = $root.google.protobuf.Timestamp.verify(message.beforeTime);
                        if (error)
                            return "beforeTime." + error;
                    }
                    if (message.sortOrder != null && message.hasOwnProperty("sortOrder"))
                        switch (message.sortOrder) {
                        default:
                            return "sortOrder: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        if (!$util.isString(message.continuationToken))
                            return "continuationToken: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Request();
                    if (object.afterTime != null) {
                        if (typeof object.afterTime !== "object")
                            throw TypeError(".waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Request.afterTime: object expected");
                        message.afterTime = $root.google.protobuf.Timestamp.fromObject(object.afterTime);
                    }
                    if (object.beforeTime != null) {
                        if (typeof object.beforeTime !== "object")
                            throw TypeError(".waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Request.beforeTime: object expected");
                        message.beforeTime = $root.google.protobuf.Timestamp.fromObject(object.beforeTime);
                    }
                    switch (object.sortOrder) {
                    default:
                        if (typeof object.sortOrder === "number") {
                            message.sortOrder = object.sortOrder;
                            break;
                        }
                        break;
                    case "SORT_ORDER_UNSPECIFIED":
                    case 0:
                        message.sortOrder = 0;
                        break;
                    case "ASCENDING":
                    case 1:
                        message.sortOrder = 1;
                        break;
                    case "DESCENDING":
                    case 2:
                        message.sortOrder = 2;
                        break;
                    }
                    if (object.continuationToken != null)
                        message.continuationToken = String(object.continuationToken);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Request
                 * @static
                 * @param {waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.afterTime = null;
                        object.beforeTime = null;
                        object.sortOrder = options.enums === String ? "SORT_ORDER_UNSPECIFIED" : 0;
                        object.continuationToken = "";
                    }
                    if (message.afterTime != null && message.hasOwnProperty("afterTime"))
                        object.afterTime = $root.google.protobuf.Timestamp.toObject(message.afterTime, options);
                    if (message.beforeTime != null && message.hasOwnProperty("beforeTime"))
                        object.beforeTime = $root.google.protobuf.Timestamp.toObject(message.beforeTime, options);
                    if (message.sortOrder != null && message.hasOwnProperty("sortOrder"))
                        object.sortOrder = options.enums === String ? $root.waiternow.common.SortOrder[message.sortOrder] === undefined ? message.sortOrder : $root.waiternow.common.SortOrder[message.sortOrder] : message.sortOrder;
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        object.continuationToken = message.continuationToken;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Request";
                };

                return Request;
            })();

            FindUnackedAndPaidOrdersForAllLocationsActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IOrdersProto|null} [orders] Response orders
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response orders.
                 * @member {waiternow.common.IOrdersProto|null|undefined} orders
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Response
                 * @instance
                 */
                Response.prototype.orders = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Response
                 * @static
                 * @param {waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Response
                 * @static
                 * @param {waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.orders != null && Object.hasOwnProperty.call(message, "orders"))
                        $root.waiternow.common.OrdersProto.encode(message.orders, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Response
                 * @static
                 * @param {waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.orders = $root.waiternow.common.OrdersProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.orders != null && message.hasOwnProperty("orders")) {
                        var error = $root.waiternow.common.OrdersProto.verify(message.orders);
                        if (error)
                            return "orders." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.orders != null) {
                        if (typeof object.orders !== "object")
                            throw TypeError(".waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Response.orders: object expected");
                        message.orders = $root.waiternow.common.OrdersProto.fromObject(object.orders);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Response
                 * @static
                 * @param {waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.orders = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.orders != null && message.hasOwnProperty("orders"))
                        object.orders = $root.waiternow.common.OrdersProto.toObject(message.orders, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindUnackedAndPaidOrdersForAllLocationsActionProto.Response";
                };

                return Response;
            })();

            return FindUnackedAndPaidOrdersForAllLocationsActionProto;
        })();

        common.FindPaidOrdersInProgressActionProto = (function() {

            /**
             * Properties of a FindPaidOrdersInProgressActionProto.
             * @memberof waiternow.common
             * @interface IFindPaidOrdersInProgressActionProto
             */

            /**
             * Constructs a new FindPaidOrdersInProgressActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a FindPaidOrdersInProgressActionProto.
             * @implements IFindPaidOrdersInProgressActionProto
             * @constructor
             * @param {waiternow.common.IFindPaidOrdersInProgressActionProto=} [properties] Properties to set
             */
            function FindPaidOrdersInProgressActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new FindPaidOrdersInProgressActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FindPaidOrdersInProgressActionProto
             * @static
             * @param {waiternow.common.IFindPaidOrdersInProgressActionProto=} [properties] Properties to set
             * @returns {waiternow.common.FindPaidOrdersInProgressActionProto} FindPaidOrdersInProgressActionProto instance
             */
            FindPaidOrdersInProgressActionProto.create = function create(properties) {
                return new FindPaidOrdersInProgressActionProto(properties);
            };

            /**
             * Encodes the specified FindPaidOrdersInProgressActionProto message. Does not implicitly {@link waiternow.common.FindPaidOrdersInProgressActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FindPaidOrdersInProgressActionProto
             * @static
             * @param {waiternow.common.IFindPaidOrdersInProgressActionProto} message FindPaidOrdersInProgressActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindPaidOrdersInProgressActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified FindPaidOrdersInProgressActionProto message, length delimited. Does not implicitly {@link waiternow.common.FindPaidOrdersInProgressActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FindPaidOrdersInProgressActionProto
             * @static
             * @param {waiternow.common.IFindPaidOrdersInProgressActionProto} message FindPaidOrdersInProgressActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindPaidOrdersInProgressActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FindPaidOrdersInProgressActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FindPaidOrdersInProgressActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FindPaidOrdersInProgressActionProto} FindPaidOrdersInProgressActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindPaidOrdersInProgressActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindPaidOrdersInProgressActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FindPaidOrdersInProgressActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FindPaidOrdersInProgressActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FindPaidOrdersInProgressActionProto} FindPaidOrdersInProgressActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindPaidOrdersInProgressActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FindPaidOrdersInProgressActionProto message.
             * @function verify
             * @memberof waiternow.common.FindPaidOrdersInProgressActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FindPaidOrdersInProgressActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a FindPaidOrdersInProgressActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FindPaidOrdersInProgressActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FindPaidOrdersInProgressActionProto} FindPaidOrdersInProgressActionProto
             */
            FindPaidOrdersInProgressActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FindPaidOrdersInProgressActionProto)
                    return object;
                return new $root.waiternow.common.FindPaidOrdersInProgressActionProto();
            };

            /**
             * Creates a plain object from a FindPaidOrdersInProgressActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FindPaidOrdersInProgressActionProto
             * @static
             * @param {waiternow.common.FindPaidOrdersInProgressActionProto} message FindPaidOrdersInProgressActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FindPaidOrdersInProgressActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this FindPaidOrdersInProgressActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FindPaidOrdersInProgressActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FindPaidOrdersInProgressActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FindPaidOrdersInProgressActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.FindPaidOrdersInProgressActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FindPaidOrdersInProgressActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FindPaidOrdersInProgressActionProto";
            };

            FindPaidOrdersInProgressActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.FindPaidOrdersInProgressActionProto
                 * @interface IRequest
                 * @property {string|null} [locationId] Request locationId
                 * @property {google.protobuf.ITimestamp|null} [afterTime] Request afterTime
                 * @property {google.protobuf.ITimestamp|null} [beforeTime] Request beforeTime
                 * @property {waiternow.common.SortOrder|null} [sortOrder] Request sortOrder
                 * @property {string|null} [continuationToken] Request continuationToken
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.FindPaidOrdersInProgressActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.FindPaidOrdersInProgressActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.FindPaidOrdersInProgressActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = "";

                /**
                 * Request afterTime.
                 * @member {google.protobuf.ITimestamp|null|undefined} afterTime
                 * @memberof waiternow.common.FindPaidOrdersInProgressActionProto.Request
                 * @instance
                 */
                Request.prototype.afterTime = null;

                /**
                 * Request beforeTime.
                 * @member {google.protobuf.ITimestamp|null|undefined} beforeTime
                 * @memberof waiternow.common.FindPaidOrdersInProgressActionProto.Request
                 * @instance
                 */
                Request.prototype.beforeTime = null;

                /**
                 * Request sortOrder.
                 * @member {waiternow.common.SortOrder} sortOrder
                 * @memberof waiternow.common.FindPaidOrdersInProgressActionProto.Request
                 * @instance
                 */
                Request.prototype.sortOrder = 0;

                /**
                 * Request continuationToken.
                 * @member {string} continuationToken
                 * @memberof waiternow.common.FindPaidOrdersInProgressActionProto.Request
                 * @instance
                 */
                Request.prototype.continuationToken = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindPaidOrdersInProgressActionProto.Request
                 * @static
                 * @param {waiternow.common.FindPaidOrdersInProgressActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.FindPaidOrdersInProgressActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.FindPaidOrdersInProgressActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindPaidOrdersInProgressActionProto.Request
                 * @static
                 * @param {waiternow.common.FindPaidOrdersInProgressActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    if (message.afterTime != null && Object.hasOwnProperty.call(message, "afterTime"))
                        $root.google.protobuf.Timestamp.encode(message.afterTime, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.beforeTime != null && Object.hasOwnProperty.call(message, "beforeTime"))
                        $root.google.protobuf.Timestamp.encode(message.beforeTime, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.sortOrder != null && Object.hasOwnProperty.call(message, "sortOrder"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.sortOrder);
                    if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.continuationToken);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.FindPaidOrdersInProgressActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindPaidOrdersInProgressActionProto.Request
                 * @static
                 * @param {waiternow.common.FindPaidOrdersInProgressActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindPaidOrdersInProgressActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindPaidOrdersInProgressActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindPaidOrdersInProgressActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 2: {
                                message.afterTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.beforeTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            }
                        case 4: {
                                message.sortOrder = reader.int32();
                                break;
                            }
                        case 5: {
                                message.continuationToken = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindPaidOrdersInProgressActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindPaidOrdersInProgressActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.FindPaidOrdersInProgressActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    if (message.afterTime != null && message.hasOwnProperty("afterTime")) {
                        var error = $root.google.protobuf.Timestamp.verify(message.afterTime);
                        if (error)
                            return "afterTime." + error;
                    }
                    if (message.beforeTime != null && message.hasOwnProperty("beforeTime")) {
                        var error = $root.google.protobuf.Timestamp.verify(message.beforeTime);
                        if (error)
                            return "beforeTime." + error;
                    }
                    if (message.sortOrder != null && message.hasOwnProperty("sortOrder"))
                        switch (message.sortOrder) {
                        default:
                            return "sortOrder: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        if (!$util.isString(message.continuationToken))
                            return "continuationToken: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindPaidOrdersInProgressActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindPaidOrdersInProgressActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindPaidOrdersInProgressActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.FindPaidOrdersInProgressActionProto.Request();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    if (object.afterTime != null) {
                        if (typeof object.afterTime !== "object")
                            throw TypeError(".waiternow.common.FindPaidOrdersInProgressActionProto.Request.afterTime: object expected");
                        message.afterTime = $root.google.protobuf.Timestamp.fromObject(object.afterTime);
                    }
                    if (object.beforeTime != null) {
                        if (typeof object.beforeTime !== "object")
                            throw TypeError(".waiternow.common.FindPaidOrdersInProgressActionProto.Request.beforeTime: object expected");
                        message.beforeTime = $root.google.protobuf.Timestamp.fromObject(object.beforeTime);
                    }
                    switch (object.sortOrder) {
                    default:
                        if (typeof object.sortOrder === "number") {
                            message.sortOrder = object.sortOrder;
                            break;
                        }
                        break;
                    case "SORT_ORDER_UNSPECIFIED":
                    case 0:
                        message.sortOrder = 0;
                        break;
                    case "ASCENDING":
                    case 1:
                        message.sortOrder = 1;
                        break;
                    case "DESCENDING":
                    case 2:
                        message.sortOrder = 2;
                        break;
                    }
                    if (object.continuationToken != null)
                        message.continuationToken = String(object.continuationToken);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindPaidOrdersInProgressActionProto.Request
                 * @static
                 * @param {waiternow.common.FindPaidOrdersInProgressActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.locationId = "";
                        object.afterTime = null;
                        object.beforeTime = null;
                        object.sortOrder = options.enums === String ? "SORT_ORDER_UNSPECIFIED" : 0;
                        object.continuationToken = "";
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    if (message.afterTime != null && message.hasOwnProperty("afterTime"))
                        object.afterTime = $root.google.protobuf.Timestamp.toObject(message.afterTime, options);
                    if (message.beforeTime != null && message.hasOwnProperty("beforeTime"))
                        object.beforeTime = $root.google.protobuf.Timestamp.toObject(message.beforeTime, options);
                    if (message.sortOrder != null && message.hasOwnProperty("sortOrder"))
                        object.sortOrder = options.enums === String ? $root.waiternow.common.SortOrder[message.sortOrder] === undefined ? message.sortOrder : $root.waiternow.common.SortOrder[message.sortOrder] : message.sortOrder;
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        object.continuationToken = message.continuationToken;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindPaidOrdersInProgressActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindPaidOrdersInProgressActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindPaidOrdersInProgressActionProto.Request";
                };

                return Request;
            })();

            FindPaidOrdersInProgressActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.FindPaidOrdersInProgressActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.ILocationOrdersProto|null} [locationOrders] Response locationOrders
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.FindPaidOrdersInProgressActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.FindPaidOrdersInProgressActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.FindPaidOrdersInProgressActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response locationOrders.
                 * @member {waiternow.common.ILocationOrdersProto|null|undefined} locationOrders
                 * @memberof waiternow.common.FindPaidOrdersInProgressActionProto.Response
                 * @instance
                 */
                Response.prototype.locationOrders = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindPaidOrdersInProgressActionProto.Response
                 * @static
                 * @param {waiternow.common.FindPaidOrdersInProgressActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.FindPaidOrdersInProgressActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.FindPaidOrdersInProgressActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindPaidOrdersInProgressActionProto.Response
                 * @static
                 * @param {waiternow.common.FindPaidOrdersInProgressActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.locationOrders != null && Object.hasOwnProperty.call(message, "locationOrders"))
                        $root.waiternow.common.LocationOrdersProto.encode(message.locationOrders, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.FindPaidOrdersInProgressActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindPaidOrdersInProgressActionProto.Response
                 * @static
                 * @param {waiternow.common.FindPaidOrdersInProgressActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindPaidOrdersInProgressActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindPaidOrdersInProgressActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindPaidOrdersInProgressActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.locationOrders = $root.waiternow.common.LocationOrdersProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindPaidOrdersInProgressActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindPaidOrdersInProgressActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.FindPaidOrdersInProgressActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.locationOrders != null && message.hasOwnProperty("locationOrders")) {
                        var error = $root.waiternow.common.LocationOrdersProto.verify(message.locationOrders);
                        if (error)
                            return "locationOrders." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindPaidOrdersInProgressActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindPaidOrdersInProgressActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindPaidOrdersInProgressActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.FindPaidOrdersInProgressActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.FindPaidOrdersInProgressActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.locationOrders != null) {
                        if (typeof object.locationOrders !== "object")
                            throw TypeError(".waiternow.common.FindPaidOrdersInProgressActionProto.Response.locationOrders: object expected");
                        message.locationOrders = $root.waiternow.common.LocationOrdersProto.fromObject(object.locationOrders);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindPaidOrdersInProgressActionProto.Response
                 * @static
                 * @param {waiternow.common.FindPaidOrdersInProgressActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.locationOrders = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.locationOrders != null && message.hasOwnProperty("locationOrders"))
                        object.locationOrders = $root.waiternow.common.LocationOrdersProto.toObject(message.locationOrders, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindPaidOrdersInProgressActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindPaidOrdersInProgressActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindPaidOrdersInProgressActionProto.Response";
                };

                return Response;
            })();

            return FindPaidOrdersInProgressActionProto;
        })();

        common.FindPendingOrdersActionProto = (function() {

            /**
             * Properties of a FindPendingOrdersActionProto.
             * @memberof waiternow.common
             * @interface IFindPendingOrdersActionProto
             */

            /**
             * Constructs a new FindPendingOrdersActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a FindPendingOrdersActionProto.
             * @implements IFindPendingOrdersActionProto
             * @constructor
             * @param {waiternow.common.IFindPendingOrdersActionProto=} [properties] Properties to set
             */
            function FindPendingOrdersActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new FindPendingOrdersActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FindPendingOrdersActionProto
             * @static
             * @param {waiternow.common.IFindPendingOrdersActionProto=} [properties] Properties to set
             * @returns {waiternow.common.FindPendingOrdersActionProto} FindPendingOrdersActionProto instance
             */
            FindPendingOrdersActionProto.create = function create(properties) {
                return new FindPendingOrdersActionProto(properties);
            };

            /**
             * Encodes the specified FindPendingOrdersActionProto message. Does not implicitly {@link waiternow.common.FindPendingOrdersActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FindPendingOrdersActionProto
             * @static
             * @param {waiternow.common.IFindPendingOrdersActionProto} message FindPendingOrdersActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindPendingOrdersActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified FindPendingOrdersActionProto message, length delimited. Does not implicitly {@link waiternow.common.FindPendingOrdersActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FindPendingOrdersActionProto
             * @static
             * @param {waiternow.common.IFindPendingOrdersActionProto} message FindPendingOrdersActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindPendingOrdersActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FindPendingOrdersActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FindPendingOrdersActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FindPendingOrdersActionProto} FindPendingOrdersActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindPendingOrdersActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindPendingOrdersActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FindPendingOrdersActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FindPendingOrdersActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FindPendingOrdersActionProto} FindPendingOrdersActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindPendingOrdersActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FindPendingOrdersActionProto message.
             * @function verify
             * @memberof waiternow.common.FindPendingOrdersActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FindPendingOrdersActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a FindPendingOrdersActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FindPendingOrdersActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FindPendingOrdersActionProto} FindPendingOrdersActionProto
             */
            FindPendingOrdersActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FindPendingOrdersActionProto)
                    return object;
                return new $root.waiternow.common.FindPendingOrdersActionProto();
            };

            /**
             * Creates a plain object from a FindPendingOrdersActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FindPendingOrdersActionProto
             * @static
             * @param {waiternow.common.FindPendingOrdersActionProto} message FindPendingOrdersActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FindPendingOrdersActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this FindPendingOrdersActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FindPendingOrdersActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FindPendingOrdersActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FindPendingOrdersActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.FindPendingOrdersActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FindPendingOrdersActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FindPendingOrdersActionProto";
            };

            FindPendingOrdersActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.FindPendingOrdersActionProto
                 * @interface IRequest
                 * @property {string|null} [locationId] Request locationId
                 * @property {string|null} [continuationToken] Request continuationToken
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.FindPendingOrdersActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.FindPendingOrdersActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.FindPendingOrdersActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = "";

                /**
                 * Request continuationToken.
                 * @member {string} continuationToken
                 * @memberof waiternow.common.FindPendingOrdersActionProto.Request
                 * @instance
                 */
                Request.prototype.continuationToken = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindPendingOrdersActionProto.Request
                 * @static
                 * @param {waiternow.common.FindPendingOrdersActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.FindPendingOrdersActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.FindPendingOrdersActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindPendingOrdersActionProto.Request
                 * @static
                 * @param {waiternow.common.FindPendingOrdersActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.continuationToken);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.FindPendingOrdersActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindPendingOrdersActionProto.Request
                 * @static
                 * @param {waiternow.common.FindPendingOrdersActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindPendingOrdersActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindPendingOrdersActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindPendingOrdersActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 2: {
                                message.continuationToken = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindPendingOrdersActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindPendingOrdersActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.FindPendingOrdersActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        if (!$util.isString(message.continuationToken))
                            return "continuationToken: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindPendingOrdersActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindPendingOrdersActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindPendingOrdersActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.FindPendingOrdersActionProto.Request();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    if (object.continuationToken != null)
                        message.continuationToken = String(object.continuationToken);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindPendingOrdersActionProto.Request
                 * @static
                 * @param {waiternow.common.FindPendingOrdersActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.locationId = "";
                        object.continuationToken = "";
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        object.continuationToken = message.continuationToken;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindPendingOrdersActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindPendingOrdersActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindPendingOrdersActionProto.Request";
                };

                return Request;
            })();

            FindPendingOrdersActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.FindPendingOrdersActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IOrdersProto|null} [orders] Response orders
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.FindPendingOrdersActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.FindPendingOrdersActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.FindPendingOrdersActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response orders.
                 * @member {waiternow.common.IOrdersProto|null|undefined} orders
                 * @memberof waiternow.common.FindPendingOrdersActionProto.Response
                 * @instance
                 */
                Response.prototype.orders = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindPendingOrdersActionProto.Response
                 * @static
                 * @param {waiternow.common.FindPendingOrdersActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.FindPendingOrdersActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.FindPendingOrdersActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindPendingOrdersActionProto.Response
                 * @static
                 * @param {waiternow.common.FindPendingOrdersActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.orders != null && Object.hasOwnProperty.call(message, "orders"))
                        $root.waiternow.common.OrdersProto.encode(message.orders, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.FindPendingOrdersActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindPendingOrdersActionProto.Response
                 * @static
                 * @param {waiternow.common.FindPendingOrdersActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindPendingOrdersActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindPendingOrdersActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindPendingOrdersActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.orders = $root.waiternow.common.OrdersProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindPendingOrdersActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindPendingOrdersActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.FindPendingOrdersActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.orders != null && message.hasOwnProperty("orders")) {
                        var error = $root.waiternow.common.OrdersProto.verify(message.orders);
                        if (error)
                            return "orders." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindPendingOrdersActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindPendingOrdersActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindPendingOrdersActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.FindPendingOrdersActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.FindPendingOrdersActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.orders != null) {
                        if (typeof object.orders !== "object")
                            throw TypeError(".waiternow.common.FindPendingOrdersActionProto.Response.orders: object expected");
                        message.orders = $root.waiternow.common.OrdersProto.fromObject(object.orders);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindPendingOrdersActionProto.Response
                 * @static
                 * @param {waiternow.common.FindPendingOrdersActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.orders = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.orders != null && message.hasOwnProperty("orders"))
                        object.orders = $root.waiternow.common.OrdersProto.toObject(message.orders, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindPendingOrdersActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindPendingOrdersActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindPendingOrdersActionProto.Response";
                };

                return Response;
            })();

            return FindPendingOrdersActionProto;
        })();

        common.FindPendingOrdersMaybeSplitByStationActionProto = (function() {

            /**
             * Properties of a FindPendingOrdersMaybeSplitByStationActionProto.
             * @memberof waiternow.common
             * @interface IFindPendingOrdersMaybeSplitByStationActionProto
             */

            /**
             * Constructs a new FindPendingOrdersMaybeSplitByStationActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a FindPendingOrdersMaybeSplitByStationActionProto.
             * @implements IFindPendingOrdersMaybeSplitByStationActionProto
             * @constructor
             * @param {waiternow.common.IFindPendingOrdersMaybeSplitByStationActionProto=} [properties] Properties to set
             */
            function FindPendingOrdersMaybeSplitByStationActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new FindPendingOrdersMaybeSplitByStationActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto
             * @static
             * @param {waiternow.common.IFindPendingOrdersMaybeSplitByStationActionProto=} [properties] Properties to set
             * @returns {waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto} FindPendingOrdersMaybeSplitByStationActionProto instance
             */
            FindPendingOrdersMaybeSplitByStationActionProto.create = function create(properties) {
                return new FindPendingOrdersMaybeSplitByStationActionProto(properties);
            };

            /**
             * Encodes the specified FindPendingOrdersMaybeSplitByStationActionProto message. Does not implicitly {@link waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto
             * @static
             * @param {waiternow.common.IFindPendingOrdersMaybeSplitByStationActionProto} message FindPendingOrdersMaybeSplitByStationActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindPendingOrdersMaybeSplitByStationActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified FindPendingOrdersMaybeSplitByStationActionProto message, length delimited. Does not implicitly {@link waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto
             * @static
             * @param {waiternow.common.IFindPendingOrdersMaybeSplitByStationActionProto} message FindPendingOrdersMaybeSplitByStationActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindPendingOrdersMaybeSplitByStationActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FindPendingOrdersMaybeSplitByStationActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto} FindPendingOrdersMaybeSplitByStationActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindPendingOrdersMaybeSplitByStationActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FindPendingOrdersMaybeSplitByStationActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto} FindPendingOrdersMaybeSplitByStationActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindPendingOrdersMaybeSplitByStationActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FindPendingOrdersMaybeSplitByStationActionProto message.
             * @function verify
             * @memberof waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FindPendingOrdersMaybeSplitByStationActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a FindPendingOrdersMaybeSplitByStationActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto} FindPendingOrdersMaybeSplitByStationActionProto
             */
            FindPendingOrdersMaybeSplitByStationActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto)
                    return object;
                return new $root.waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto();
            };

            /**
             * Creates a plain object from a FindPendingOrdersMaybeSplitByStationActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto
             * @static
             * @param {waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto} message FindPendingOrdersMaybeSplitByStationActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FindPendingOrdersMaybeSplitByStationActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this FindPendingOrdersMaybeSplitByStationActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FindPendingOrdersMaybeSplitByStationActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FindPendingOrdersMaybeSplitByStationActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FindPendingOrdersMaybeSplitByStationActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto";
            };

            FindPendingOrdersMaybeSplitByStationActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto
                 * @interface IRequest
                 * @property {string|null} [locationId] Request locationId
                 * @property {string|null} [continuationToken] Request continuationToken
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = "";

                /**
                 * Request continuationToken.
                 * @member {string} continuationToken
                 * @memberof waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.Request
                 * @instance
                 */
                Request.prototype.continuationToken = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.Request
                 * @static
                 * @param {waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.Request
                 * @static
                 * @param {waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.continuationToken);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.Request
                 * @static
                 * @param {waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 2: {
                                message.continuationToken = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        if (!$util.isString(message.continuationToken))
                            return "continuationToken: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.Request();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    if (object.continuationToken != null)
                        message.continuationToken = String(object.continuationToken);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.Request
                 * @static
                 * @param {waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.locationId = "";
                        object.continuationToken = "";
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        object.continuationToken = message.continuationToken;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.Request";
                };

                return Request;
            })();

            FindPendingOrdersMaybeSplitByStationActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IOrdersMaybeSplitByStationProto|null} [orders] Response orders
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response orders.
                 * @member {waiternow.common.IOrdersMaybeSplitByStationProto|null|undefined} orders
                 * @memberof waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.Response
                 * @instance
                 */
                Response.prototype.orders = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.Response
                 * @static
                 * @param {waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.Response
                 * @static
                 * @param {waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.orders != null && Object.hasOwnProperty.call(message, "orders"))
                        $root.waiternow.common.OrdersMaybeSplitByStationProto.encode(message.orders, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.Response
                 * @static
                 * @param {waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.orders = $root.waiternow.common.OrdersMaybeSplitByStationProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.orders != null && message.hasOwnProperty("orders")) {
                        var error = $root.waiternow.common.OrdersMaybeSplitByStationProto.verify(message.orders);
                        if (error)
                            return "orders." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.orders != null) {
                        if (typeof object.orders !== "object")
                            throw TypeError(".waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.Response.orders: object expected");
                        message.orders = $root.waiternow.common.OrdersMaybeSplitByStationProto.fromObject(object.orders);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.Response
                 * @static
                 * @param {waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.orders = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.orders != null && message.hasOwnProperty("orders"))
                        object.orders = $root.waiternow.common.OrdersMaybeSplitByStationProto.toObject(message.orders, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindPendingOrdersMaybeSplitByStationActionProto.Response";
                };

                return Response;
            })();

            return FindPendingOrdersMaybeSplitByStationActionProto;
        })();

        common.FindUnackedAndPaidOrdersForLaterActionProto = (function() {

            /**
             * Properties of a FindUnackedAndPaidOrdersForLaterActionProto.
             * @memberof waiternow.common
             * @interface IFindUnackedAndPaidOrdersForLaterActionProto
             */

            /**
             * Constructs a new FindUnackedAndPaidOrdersForLaterActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a FindUnackedAndPaidOrdersForLaterActionProto.
             * @implements IFindUnackedAndPaidOrdersForLaterActionProto
             * @constructor
             * @param {waiternow.common.IFindUnackedAndPaidOrdersForLaterActionProto=} [properties] Properties to set
             */
            function FindUnackedAndPaidOrdersForLaterActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new FindUnackedAndPaidOrdersForLaterActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto
             * @static
             * @param {waiternow.common.IFindUnackedAndPaidOrdersForLaterActionProto=} [properties] Properties to set
             * @returns {waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto} FindUnackedAndPaidOrdersForLaterActionProto instance
             */
            FindUnackedAndPaidOrdersForLaterActionProto.create = function create(properties) {
                return new FindUnackedAndPaidOrdersForLaterActionProto(properties);
            };

            /**
             * Encodes the specified FindUnackedAndPaidOrdersForLaterActionProto message. Does not implicitly {@link waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto
             * @static
             * @param {waiternow.common.IFindUnackedAndPaidOrdersForLaterActionProto} message FindUnackedAndPaidOrdersForLaterActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindUnackedAndPaidOrdersForLaterActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified FindUnackedAndPaidOrdersForLaterActionProto message, length delimited. Does not implicitly {@link waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto
             * @static
             * @param {waiternow.common.IFindUnackedAndPaidOrdersForLaterActionProto} message FindUnackedAndPaidOrdersForLaterActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindUnackedAndPaidOrdersForLaterActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FindUnackedAndPaidOrdersForLaterActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto} FindUnackedAndPaidOrdersForLaterActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindUnackedAndPaidOrdersForLaterActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FindUnackedAndPaidOrdersForLaterActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto} FindUnackedAndPaidOrdersForLaterActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindUnackedAndPaidOrdersForLaterActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FindUnackedAndPaidOrdersForLaterActionProto message.
             * @function verify
             * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FindUnackedAndPaidOrdersForLaterActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a FindUnackedAndPaidOrdersForLaterActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto} FindUnackedAndPaidOrdersForLaterActionProto
             */
            FindUnackedAndPaidOrdersForLaterActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto)
                    return object;
                return new $root.waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto();
            };

            /**
             * Creates a plain object from a FindUnackedAndPaidOrdersForLaterActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto
             * @static
             * @param {waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto} message FindUnackedAndPaidOrdersForLaterActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FindUnackedAndPaidOrdersForLaterActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this FindUnackedAndPaidOrdersForLaterActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FindUnackedAndPaidOrdersForLaterActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FindUnackedAndPaidOrdersForLaterActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FindUnackedAndPaidOrdersForLaterActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto";
            };

            FindUnackedAndPaidOrdersForLaterActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto
                 * @interface IRequest
                 * @property {string|null} [locationId] Request locationId
                 * @property {google.protobuf.ITimestamp|null} [afterTime] Request afterTime
                 * @property {string|null} [continuationToken] Request continuationToken
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = "";

                /**
                 * Request afterTime.
                 * @member {google.protobuf.ITimestamp|null|undefined} afterTime
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.Request
                 * @instance
                 */
                Request.prototype.afterTime = null;

                /**
                 * Request continuationToken.
                 * @member {string} continuationToken
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.Request
                 * @instance
                 */
                Request.prototype.continuationToken = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.Request
                 * @static
                 * @param {waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.Request
                 * @static
                 * @param {waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    if (message.afterTime != null && Object.hasOwnProperty.call(message, "afterTime"))
                        $root.google.protobuf.Timestamp.encode(message.afterTime, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.continuationToken);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.Request
                 * @static
                 * @param {waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 2: {
                                message.afterTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.continuationToken = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    if (message.afterTime != null && message.hasOwnProperty("afterTime")) {
                        var error = $root.google.protobuf.Timestamp.verify(message.afterTime);
                        if (error)
                            return "afterTime." + error;
                    }
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        if (!$util.isString(message.continuationToken))
                            return "continuationToken: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.Request();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    if (object.afterTime != null) {
                        if (typeof object.afterTime !== "object")
                            throw TypeError(".waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.Request.afterTime: object expected");
                        message.afterTime = $root.google.protobuf.Timestamp.fromObject(object.afterTime);
                    }
                    if (object.continuationToken != null)
                        message.continuationToken = String(object.continuationToken);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.Request
                 * @static
                 * @param {waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.locationId = "";
                        object.afterTime = null;
                        object.continuationToken = "";
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    if (message.afterTime != null && message.hasOwnProperty("afterTime"))
                        object.afterTime = $root.google.protobuf.Timestamp.toObject(message.afterTime, options);
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        object.continuationToken = message.continuationToken;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.Request";
                };

                return Request;
            })();

            FindUnackedAndPaidOrdersForLaterActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IOrdersProto|null} [orders] Response orders
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response orders.
                 * @member {waiternow.common.IOrdersProto|null|undefined} orders
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.Response
                 * @instance
                 */
                Response.prototype.orders = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.Response
                 * @static
                 * @param {waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.Response
                 * @static
                 * @param {waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.orders != null && Object.hasOwnProperty.call(message, "orders"))
                        $root.waiternow.common.OrdersProto.encode(message.orders, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.Response
                 * @static
                 * @param {waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.orders = $root.waiternow.common.OrdersProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.orders != null && message.hasOwnProperty("orders")) {
                        var error = $root.waiternow.common.OrdersProto.verify(message.orders);
                        if (error)
                            return "orders." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.orders != null) {
                        if (typeof object.orders !== "object")
                            throw TypeError(".waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.Response.orders: object expected");
                        message.orders = $root.waiternow.common.OrdersProto.fromObject(object.orders);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.Response
                 * @static
                 * @param {waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.orders = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.orders != null && message.hasOwnProperty("orders"))
                        object.orders = $root.waiternow.common.OrdersProto.toObject(message.orders, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindUnackedAndPaidOrdersForLaterActionProto.Response";
                };

                return Response;
            })();

            return FindUnackedAndPaidOrdersForLaterActionProto;
        })();

        common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto = (function() {

            /**
             * Properties of a FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.
             * @memberof waiternow.common
             * @interface IFindUnackedAndPaidOrdersForLaterForAllLocationsActionProto
             */

            /**
             * Constructs a new FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.
             * @implements IFindUnackedAndPaidOrdersForLaterForAllLocationsActionProto
             * @constructor
             * @param {waiternow.common.IFindUnackedAndPaidOrdersForLaterForAllLocationsActionProto=} [properties] Properties to set
             */
            function FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto
             * @static
             * @param {waiternow.common.IFindUnackedAndPaidOrdersForLaterForAllLocationsActionProto=} [properties] Properties to set
             * @returns {waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto} FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto instance
             */
            FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.create = function create(properties) {
                return new FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto(properties);
            };

            /**
             * Encodes the specified FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto message. Does not implicitly {@link waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto
             * @static
             * @param {waiternow.common.IFindUnackedAndPaidOrdersForLaterForAllLocationsActionProto} message FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto message, length delimited. Does not implicitly {@link waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto
             * @static
             * @param {waiternow.common.IFindUnackedAndPaidOrdersForLaterForAllLocationsActionProto} message FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto} FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto} FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto message.
             * @function verify
             * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto} FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto
             */
            FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto)
                    return object;
                return new $root.waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto();
            };

            /**
             * Creates a plain object from a FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto
             * @static
             * @param {waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto} message FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto";
            };

            FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto
                 * @interface IRequest
                 * @property {google.protobuf.ITimestamp|null} [afterTime] Request afterTime
                 * @property {google.protobuf.ITimestamp|null} [beforeTime] Request beforeTime
                 * @property {waiternow.common.SortOrder|null} [sortOrder] Request sortOrder
                 * @property {string|null} [continuationToken] Request continuationToken
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request afterTime.
                 * @member {google.protobuf.ITimestamp|null|undefined} afterTime
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Request
                 * @instance
                 */
                Request.prototype.afterTime = null;

                /**
                 * Request beforeTime.
                 * @member {google.protobuf.ITimestamp|null|undefined} beforeTime
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Request
                 * @instance
                 */
                Request.prototype.beforeTime = null;

                /**
                 * Request sortOrder.
                 * @member {waiternow.common.SortOrder} sortOrder
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Request
                 * @instance
                 */
                Request.prototype.sortOrder = 0;

                /**
                 * Request continuationToken.
                 * @member {string} continuationToken
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Request
                 * @instance
                 */
                Request.prototype.continuationToken = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Request
                 * @static
                 * @param {waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Request
                 * @static
                 * @param {waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.afterTime != null && Object.hasOwnProperty.call(message, "afterTime"))
                        $root.google.protobuf.Timestamp.encode(message.afterTime, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.beforeTime != null && Object.hasOwnProperty.call(message, "beforeTime"))
                        $root.google.protobuf.Timestamp.encode(message.beforeTime, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.sortOrder != null && Object.hasOwnProperty.call(message, "sortOrder"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.sortOrder);
                    if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.continuationToken);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Request
                 * @static
                 * @param {waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.afterTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.beforeTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.sortOrder = reader.int32();
                                break;
                            }
                        case 4: {
                                message.continuationToken = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.afterTime != null && message.hasOwnProperty("afterTime")) {
                        var error = $root.google.protobuf.Timestamp.verify(message.afterTime);
                        if (error)
                            return "afterTime." + error;
                    }
                    if (message.beforeTime != null && message.hasOwnProperty("beforeTime")) {
                        var error = $root.google.protobuf.Timestamp.verify(message.beforeTime);
                        if (error)
                            return "beforeTime." + error;
                    }
                    if (message.sortOrder != null && message.hasOwnProperty("sortOrder"))
                        switch (message.sortOrder) {
                        default:
                            return "sortOrder: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        if (!$util.isString(message.continuationToken))
                            return "continuationToken: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Request();
                    if (object.afterTime != null) {
                        if (typeof object.afterTime !== "object")
                            throw TypeError(".waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Request.afterTime: object expected");
                        message.afterTime = $root.google.protobuf.Timestamp.fromObject(object.afterTime);
                    }
                    if (object.beforeTime != null) {
                        if (typeof object.beforeTime !== "object")
                            throw TypeError(".waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Request.beforeTime: object expected");
                        message.beforeTime = $root.google.protobuf.Timestamp.fromObject(object.beforeTime);
                    }
                    switch (object.sortOrder) {
                    default:
                        if (typeof object.sortOrder === "number") {
                            message.sortOrder = object.sortOrder;
                            break;
                        }
                        break;
                    case "SORT_ORDER_UNSPECIFIED":
                    case 0:
                        message.sortOrder = 0;
                        break;
                    case "ASCENDING":
                    case 1:
                        message.sortOrder = 1;
                        break;
                    case "DESCENDING":
                    case 2:
                        message.sortOrder = 2;
                        break;
                    }
                    if (object.continuationToken != null)
                        message.continuationToken = String(object.continuationToken);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Request
                 * @static
                 * @param {waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.afterTime = null;
                        object.beforeTime = null;
                        object.sortOrder = options.enums === String ? "SORT_ORDER_UNSPECIFIED" : 0;
                        object.continuationToken = "";
                    }
                    if (message.afterTime != null && message.hasOwnProperty("afterTime"))
                        object.afterTime = $root.google.protobuf.Timestamp.toObject(message.afterTime, options);
                    if (message.beforeTime != null && message.hasOwnProperty("beforeTime"))
                        object.beforeTime = $root.google.protobuf.Timestamp.toObject(message.beforeTime, options);
                    if (message.sortOrder != null && message.hasOwnProperty("sortOrder"))
                        object.sortOrder = options.enums === String ? $root.waiternow.common.SortOrder[message.sortOrder] === undefined ? message.sortOrder : $root.waiternow.common.SortOrder[message.sortOrder] : message.sortOrder;
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        object.continuationToken = message.continuationToken;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Request";
                };

                return Request;
            })();

            FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IOrdersProto|null} [orders] Response orders
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response orders.
                 * @member {waiternow.common.IOrdersProto|null|undefined} orders
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Response
                 * @instance
                 */
                Response.prototype.orders = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Response
                 * @static
                 * @param {waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Response
                 * @static
                 * @param {waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.orders != null && Object.hasOwnProperty.call(message, "orders"))
                        $root.waiternow.common.OrdersProto.encode(message.orders, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Response
                 * @static
                 * @param {waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.orders = $root.waiternow.common.OrdersProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.orders != null && message.hasOwnProperty("orders")) {
                        var error = $root.waiternow.common.OrdersProto.verify(message.orders);
                        if (error)
                            return "orders." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.orders != null) {
                        if (typeof object.orders !== "object")
                            throw TypeError(".waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Response.orders: object expected");
                        message.orders = $root.waiternow.common.OrdersProto.fromObject(object.orders);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Response
                 * @static
                 * @param {waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.orders = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.orders != null && message.hasOwnProperty("orders"))
                        object.orders = $root.waiternow.common.OrdersProto.toObject(message.orders, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto.Response";
                };

                return Response;
            })();

            return FindUnackedAndPaidOrdersForLaterForAllLocationsActionProto;
        })();

        common.FindReviewsByLocationActionProto = (function() {

            /**
             * Properties of a FindReviewsByLocationActionProto.
             * @memberof waiternow.common
             * @interface IFindReviewsByLocationActionProto
             */

            /**
             * Constructs a new FindReviewsByLocationActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a FindReviewsByLocationActionProto.
             * @implements IFindReviewsByLocationActionProto
             * @constructor
             * @param {waiternow.common.IFindReviewsByLocationActionProto=} [properties] Properties to set
             */
            function FindReviewsByLocationActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new FindReviewsByLocationActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FindReviewsByLocationActionProto
             * @static
             * @param {waiternow.common.IFindReviewsByLocationActionProto=} [properties] Properties to set
             * @returns {waiternow.common.FindReviewsByLocationActionProto} FindReviewsByLocationActionProto instance
             */
            FindReviewsByLocationActionProto.create = function create(properties) {
                return new FindReviewsByLocationActionProto(properties);
            };

            /**
             * Encodes the specified FindReviewsByLocationActionProto message. Does not implicitly {@link waiternow.common.FindReviewsByLocationActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FindReviewsByLocationActionProto
             * @static
             * @param {waiternow.common.IFindReviewsByLocationActionProto} message FindReviewsByLocationActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindReviewsByLocationActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified FindReviewsByLocationActionProto message, length delimited. Does not implicitly {@link waiternow.common.FindReviewsByLocationActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FindReviewsByLocationActionProto
             * @static
             * @param {waiternow.common.IFindReviewsByLocationActionProto} message FindReviewsByLocationActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindReviewsByLocationActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FindReviewsByLocationActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FindReviewsByLocationActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FindReviewsByLocationActionProto} FindReviewsByLocationActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindReviewsByLocationActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindReviewsByLocationActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FindReviewsByLocationActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FindReviewsByLocationActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FindReviewsByLocationActionProto} FindReviewsByLocationActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindReviewsByLocationActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FindReviewsByLocationActionProto message.
             * @function verify
             * @memberof waiternow.common.FindReviewsByLocationActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FindReviewsByLocationActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a FindReviewsByLocationActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FindReviewsByLocationActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FindReviewsByLocationActionProto} FindReviewsByLocationActionProto
             */
            FindReviewsByLocationActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FindReviewsByLocationActionProto)
                    return object;
                return new $root.waiternow.common.FindReviewsByLocationActionProto();
            };

            /**
             * Creates a plain object from a FindReviewsByLocationActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FindReviewsByLocationActionProto
             * @static
             * @param {waiternow.common.FindReviewsByLocationActionProto} message FindReviewsByLocationActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FindReviewsByLocationActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this FindReviewsByLocationActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FindReviewsByLocationActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FindReviewsByLocationActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FindReviewsByLocationActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.FindReviewsByLocationActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FindReviewsByLocationActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FindReviewsByLocationActionProto";
            };

            FindReviewsByLocationActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.FindReviewsByLocationActionProto
                 * @interface IRequest
                 * @property {string|null} [locationId] Request locationId
                 * @property {waiternow.common.ThumbSignal|null} [thumbSignal] Request thumbSignal
                 * @property {string|null} [continuationToken] Request continuationToken
                 * @property {waiternow.common.Rating|null} [rating] Request rating
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.FindReviewsByLocationActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.FindReviewsByLocationActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.FindReviewsByLocationActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = "";

                /**
                 * Request thumbSignal.
                 * @member {waiternow.common.ThumbSignal} thumbSignal
                 * @memberof waiternow.common.FindReviewsByLocationActionProto.Request
                 * @instance
                 */
                Request.prototype.thumbSignal = 0;

                /**
                 * Request continuationToken.
                 * @member {string} continuationToken
                 * @memberof waiternow.common.FindReviewsByLocationActionProto.Request
                 * @instance
                 */
                Request.prototype.continuationToken = "";

                /**
                 * Request rating.
                 * @member {waiternow.common.Rating} rating
                 * @memberof waiternow.common.FindReviewsByLocationActionProto.Request
                 * @instance
                 */
                Request.prototype.rating = 0;

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindReviewsByLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.FindReviewsByLocationActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.FindReviewsByLocationActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.FindReviewsByLocationActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindReviewsByLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.FindReviewsByLocationActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    if (message.thumbSignal != null && Object.hasOwnProperty.call(message, "thumbSignal"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.thumbSignal);
                    if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.continuationToken);
                    if (message.rating != null && Object.hasOwnProperty.call(message, "rating"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.rating);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.FindReviewsByLocationActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindReviewsByLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.FindReviewsByLocationActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindReviewsByLocationActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindReviewsByLocationActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindReviewsByLocationActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 2: {
                                message.thumbSignal = reader.int32();
                                break;
                            }
                        case 3: {
                                message.continuationToken = reader.string();
                                break;
                            }
                        case 4: {
                                message.rating = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindReviewsByLocationActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindReviewsByLocationActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.FindReviewsByLocationActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    if (message.thumbSignal != null && message.hasOwnProperty("thumbSignal"))
                        switch (message.thumbSignal) {
                        default:
                            return "thumbSignal: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        if (!$util.isString(message.continuationToken))
                            return "continuationToken: string expected";
                    if (message.rating != null && message.hasOwnProperty("rating"))
                        switch (message.rating) {
                        default:
                            return "rating: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                            break;
                        }
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindReviewsByLocationActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindReviewsByLocationActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindReviewsByLocationActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.FindReviewsByLocationActionProto.Request();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    switch (object.thumbSignal) {
                    default:
                        if (typeof object.thumbSignal === "number") {
                            message.thumbSignal = object.thumbSignal;
                            break;
                        }
                        break;
                    case "THUMB_SIGNAL_UNSPECIFIED":
                    case 0:
                        message.thumbSignal = 0;
                        break;
                    case "THUMB_UP":
                    case 1:
                        message.thumbSignal = 1;
                        break;
                    case "THUMB_DOWN":
                    case 2:
                        message.thumbSignal = 2;
                        break;
                    }
                    if (object.continuationToken != null)
                        message.continuationToken = String(object.continuationToken);
                    switch (object.rating) {
                    default:
                        if (typeof object.rating === "number") {
                            message.rating = object.rating;
                            break;
                        }
                        break;
                    case "RATING_UNSPECIFIED":
                    case 0:
                        message.rating = 0;
                        break;
                    case "ONE_STAR":
                    case 1:
                        message.rating = 1;
                        break;
                    case "TWO_STARS":
                    case 2:
                        message.rating = 2;
                        break;
                    case "THREE_STARS":
                    case 3:
                        message.rating = 3;
                        break;
                    case "FOUR_STARS":
                    case 4:
                        message.rating = 4;
                        break;
                    case "FIVE_STARS":
                    case 5:
                        message.rating = 5;
                        break;
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindReviewsByLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.FindReviewsByLocationActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.locationId = "";
                        object.thumbSignal = options.enums === String ? "THUMB_SIGNAL_UNSPECIFIED" : 0;
                        object.continuationToken = "";
                        object.rating = options.enums === String ? "RATING_UNSPECIFIED" : 0;
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    if (message.thumbSignal != null && message.hasOwnProperty("thumbSignal"))
                        object.thumbSignal = options.enums === String ? $root.waiternow.common.ThumbSignal[message.thumbSignal] === undefined ? message.thumbSignal : $root.waiternow.common.ThumbSignal[message.thumbSignal] : message.thumbSignal;
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        object.continuationToken = message.continuationToken;
                    if (message.rating != null && message.hasOwnProperty("rating"))
                        object.rating = options.enums === String ? $root.waiternow.common.Rating[message.rating] === undefined ? message.rating : $root.waiternow.common.Rating[message.rating] : message.rating;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindReviewsByLocationActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindReviewsByLocationActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindReviewsByLocationActionProto.Request";
                };

                return Request;
            })();

            FindReviewsByLocationActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.FindReviewsByLocationActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.ILocationReviewsProto|null} [locationReviews] Response locationReviews
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.FindReviewsByLocationActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.FindReviewsByLocationActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.FindReviewsByLocationActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response locationReviews.
                 * @member {waiternow.common.ILocationReviewsProto|null|undefined} locationReviews
                 * @memberof waiternow.common.FindReviewsByLocationActionProto.Response
                 * @instance
                 */
                Response.prototype.locationReviews = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindReviewsByLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.FindReviewsByLocationActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.FindReviewsByLocationActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.FindReviewsByLocationActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindReviewsByLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.FindReviewsByLocationActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.locationReviews != null && Object.hasOwnProperty.call(message, "locationReviews"))
                        $root.waiternow.common.LocationReviewsProto.encode(message.locationReviews, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.FindReviewsByLocationActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindReviewsByLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.FindReviewsByLocationActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindReviewsByLocationActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindReviewsByLocationActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindReviewsByLocationActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.locationReviews = $root.waiternow.common.LocationReviewsProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindReviewsByLocationActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindReviewsByLocationActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.FindReviewsByLocationActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.locationReviews != null && message.hasOwnProperty("locationReviews")) {
                        var error = $root.waiternow.common.LocationReviewsProto.verify(message.locationReviews);
                        if (error)
                            return "locationReviews." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindReviewsByLocationActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindReviewsByLocationActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindReviewsByLocationActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.FindReviewsByLocationActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.FindReviewsByLocationActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.locationReviews != null) {
                        if (typeof object.locationReviews !== "object")
                            throw TypeError(".waiternow.common.FindReviewsByLocationActionProto.Response.locationReviews: object expected");
                        message.locationReviews = $root.waiternow.common.LocationReviewsProto.fromObject(object.locationReviews);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindReviewsByLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.FindReviewsByLocationActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.locationReviews = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.locationReviews != null && message.hasOwnProperty("locationReviews"))
                        object.locationReviews = $root.waiternow.common.LocationReviewsProto.toObject(message.locationReviews, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindReviewsByLocationActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindReviewsByLocationActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindReviewsByLocationActionProto.Response";
                };

                return Response;
            })();

            return FindReviewsByLocationActionProto;
        })();

        common.FindDevicesByLocationActionProto = (function() {

            /**
             * Properties of a FindDevicesByLocationActionProto.
             * @memberof waiternow.common
             * @interface IFindDevicesByLocationActionProto
             */

            /**
             * Constructs a new FindDevicesByLocationActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a FindDevicesByLocationActionProto.
             * @implements IFindDevicesByLocationActionProto
             * @constructor
             * @param {waiternow.common.IFindDevicesByLocationActionProto=} [properties] Properties to set
             */
            function FindDevicesByLocationActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new FindDevicesByLocationActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FindDevicesByLocationActionProto
             * @static
             * @param {waiternow.common.IFindDevicesByLocationActionProto=} [properties] Properties to set
             * @returns {waiternow.common.FindDevicesByLocationActionProto} FindDevicesByLocationActionProto instance
             */
            FindDevicesByLocationActionProto.create = function create(properties) {
                return new FindDevicesByLocationActionProto(properties);
            };

            /**
             * Encodes the specified FindDevicesByLocationActionProto message. Does not implicitly {@link waiternow.common.FindDevicesByLocationActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FindDevicesByLocationActionProto
             * @static
             * @param {waiternow.common.IFindDevicesByLocationActionProto} message FindDevicesByLocationActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindDevicesByLocationActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified FindDevicesByLocationActionProto message, length delimited. Does not implicitly {@link waiternow.common.FindDevicesByLocationActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FindDevicesByLocationActionProto
             * @static
             * @param {waiternow.common.IFindDevicesByLocationActionProto} message FindDevicesByLocationActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindDevicesByLocationActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FindDevicesByLocationActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FindDevicesByLocationActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FindDevicesByLocationActionProto} FindDevicesByLocationActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindDevicesByLocationActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindDevicesByLocationActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FindDevicesByLocationActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FindDevicesByLocationActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FindDevicesByLocationActionProto} FindDevicesByLocationActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindDevicesByLocationActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FindDevicesByLocationActionProto message.
             * @function verify
             * @memberof waiternow.common.FindDevicesByLocationActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FindDevicesByLocationActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a FindDevicesByLocationActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FindDevicesByLocationActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FindDevicesByLocationActionProto} FindDevicesByLocationActionProto
             */
            FindDevicesByLocationActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FindDevicesByLocationActionProto)
                    return object;
                return new $root.waiternow.common.FindDevicesByLocationActionProto();
            };

            /**
             * Creates a plain object from a FindDevicesByLocationActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FindDevicesByLocationActionProto
             * @static
             * @param {waiternow.common.FindDevicesByLocationActionProto} message FindDevicesByLocationActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FindDevicesByLocationActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this FindDevicesByLocationActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FindDevicesByLocationActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FindDevicesByLocationActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FindDevicesByLocationActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.FindDevicesByLocationActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FindDevicesByLocationActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FindDevicesByLocationActionProto";
            };

            FindDevicesByLocationActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.FindDevicesByLocationActionProto
                 * @interface IRequest
                 * @property {string|null} [locationId] Request locationId
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.FindDevicesByLocationActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.FindDevicesByLocationActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.FindDevicesByLocationActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindDevicesByLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.FindDevicesByLocationActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.FindDevicesByLocationActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.FindDevicesByLocationActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindDevicesByLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.FindDevicesByLocationActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.FindDevicesByLocationActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindDevicesByLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.FindDevicesByLocationActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindDevicesByLocationActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindDevicesByLocationActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindDevicesByLocationActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindDevicesByLocationActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindDevicesByLocationActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.FindDevicesByLocationActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindDevicesByLocationActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindDevicesByLocationActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindDevicesByLocationActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.FindDevicesByLocationActionProto.Request();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindDevicesByLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.FindDevicesByLocationActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.locationId = "";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindDevicesByLocationActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindDevicesByLocationActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindDevicesByLocationActionProto.Request";
                };

                return Request;
            })();

            FindDevicesByLocationActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.FindDevicesByLocationActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.ILocationDevicesProto|null} [locationDevices] Response locationDevices
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.FindDevicesByLocationActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.FindDevicesByLocationActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.FindDevicesByLocationActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response locationDevices.
                 * @member {waiternow.common.ILocationDevicesProto|null|undefined} locationDevices
                 * @memberof waiternow.common.FindDevicesByLocationActionProto.Response
                 * @instance
                 */
                Response.prototype.locationDevices = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindDevicesByLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.FindDevicesByLocationActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.FindDevicesByLocationActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.FindDevicesByLocationActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindDevicesByLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.FindDevicesByLocationActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.locationDevices != null && Object.hasOwnProperty.call(message, "locationDevices"))
                        $root.waiternow.common.LocationDevicesProto.encode(message.locationDevices, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.FindDevicesByLocationActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindDevicesByLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.FindDevicesByLocationActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindDevicesByLocationActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindDevicesByLocationActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindDevicesByLocationActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.locationDevices = $root.waiternow.common.LocationDevicesProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindDevicesByLocationActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindDevicesByLocationActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.FindDevicesByLocationActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.locationDevices != null && message.hasOwnProperty("locationDevices")) {
                        var error = $root.waiternow.common.LocationDevicesProto.verify(message.locationDevices);
                        if (error)
                            return "locationDevices." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindDevicesByLocationActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindDevicesByLocationActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindDevicesByLocationActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.FindDevicesByLocationActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.FindDevicesByLocationActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.locationDevices != null) {
                        if (typeof object.locationDevices !== "object")
                            throw TypeError(".waiternow.common.FindDevicesByLocationActionProto.Response.locationDevices: object expected");
                        message.locationDevices = $root.waiternow.common.LocationDevicesProto.fromObject(object.locationDevices);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindDevicesByLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.FindDevicesByLocationActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.locationDevices = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.locationDevices != null && message.hasOwnProperty("locationDevices"))
                        object.locationDevices = $root.waiternow.common.LocationDevicesProto.toObject(message.locationDevices, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindDevicesByLocationActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindDevicesByLocationActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindDevicesByLocationActionProto.Response";
                };

                return Response;
            })();

            return FindDevicesByLocationActionProto;
        })();

        common.FindDevicesByPointOfServiceActionProto = (function() {

            /**
             * Properties of a FindDevicesByPointOfServiceActionProto.
             * @memberof waiternow.common
             * @interface IFindDevicesByPointOfServiceActionProto
             */

            /**
             * Constructs a new FindDevicesByPointOfServiceActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a FindDevicesByPointOfServiceActionProto.
             * @implements IFindDevicesByPointOfServiceActionProto
             * @constructor
             * @param {waiternow.common.IFindDevicesByPointOfServiceActionProto=} [properties] Properties to set
             */
            function FindDevicesByPointOfServiceActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new FindDevicesByPointOfServiceActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FindDevicesByPointOfServiceActionProto
             * @static
             * @param {waiternow.common.IFindDevicesByPointOfServiceActionProto=} [properties] Properties to set
             * @returns {waiternow.common.FindDevicesByPointOfServiceActionProto} FindDevicesByPointOfServiceActionProto instance
             */
            FindDevicesByPointOfServiceActionProto.create = function create(properties) {
                return new FindDevicesByPointOfServiceActionProto(properties);
            };

            /**
             * Encodes the specified FindDevicesByPointOfServiceActionProto message. Does not implicitly {@link waiternow.common.FindDevicesByPointOfServiceActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FindDevicesByPointOfServiceActionProto
             * @static
             * @param {waiternow.common.IFindDevicesByPointOfServiceActionProto} message FindDevicesByPointOfServiceActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindDevicesByPointOfServiceActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified FindDevicesByPointOfServiceActionProto message, length delimited. Does not implicitly {@link waiternow.common.FindDevicesByPointOfServiceActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FindDevicesByPointOfServiceActionProto
             * @static
             * @param {waiternow.common.IFindDevicesByPointOfServiceActionProto} message FindDevicesByPointOfServiceActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindDevicesByPointOfServiceActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FindDevicesByPointOfServiceActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FindDevicesByPointOfServiceActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FindDevicesByPointOfServiceActionProto} FindDevicesByPointOfServiceActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindDevicesByPointOfServiceActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindDevicesByPointOfServiceActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FindDevicesByPointOfServiceActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FindDevicesByPointOfServiceActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FindDevicesByPointOfServiceActionProto} FindDevicesByPointOfServiceActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindDevicesByPointOfServiceActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FindDevicesByPointOfServiceActionProto message.
             * @function verify
             * @memberof waiternow.common.FindDevicesByPointOfServiceActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FindDevicesByPointOfServiceActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a FindDevicesByPointOfServiceActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FindDevicesByPointOfServiceActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FindDevicesByPointOfServiceActionProto} FindDevicesByPointOfServiceActionProto
             */
            FindDevicesByPointOfServiceActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FindDevicesByPointOfServiceActionProto)
                    return object;
                return new $root.waiternow.common.FindDevicesByPointOfServiceActionProto();
            };

            /**
             * Creates a plain object from a FindDevicesByPointOfServiceActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FindDevicesByPointOfServiceActionProto
             * @static
             * @param {waiternow.common.FindDevicesByPointOfServiceActionProto} message FindDevicesByPointOfServiceActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FindDevicesByPointOfServiceActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this FindDevicesByPointOfServiceActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FindDevicesByPointOfServiceActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FindDevicesByPointOfServiceActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FindDevicesByPointOfServiceActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.FindDevicesByPointOfServiceActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FindDevicesByPointOfServiceActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FindDevicesByPointOfServiceActionProto";
            };

            FindDevicesByPointOfServiceActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.FindDevicesByPointOfServiceActionProto
                 * @interface IRequest
                 * @property {string|null} [pointOfServiceId] Request pointOfServiceId
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.FindDevicesByPointOfServiceActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.FindDevicesByPointOfServiceActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request pointOfServiceId.
                 * @member {string} pointOfServiceId
                 * @memberof waiternow.common.FindDevicesByPointOfServiceActionProto.Request
                 * @instance
                 */
                Request.prototype.pointOfServiceId = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindDevicesByPointOfServiceActionProto.Request
                 * @static
                 * @param {waiternow.common.FindDevicesByPointOfServiceActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.FindDevicesByPointOfServiceActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.FindDevicesByPointOfServiceActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindDevicesByPointOfServiceActionProto.Request
                 * @static
                 * @param {waiternow.common.FindDevicesByPointOfServiceActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.pointOfServiceId != null && Object.hasOwnProperty.call(message, "pointOfServiceId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.pointOfServiceId);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.FindDevicesByPointOfServiceActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindDevicesByPointOfServiceActionProto.Request
                 * @static
                 * @param {waiternow.common.FindDevicesByPointOfServiceActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindDevicesByPointOfServiceActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindDevicesByPointOfServiceActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindDevicesByPointOfServiceActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.pointOfServiceId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindDevicesByPointOfServiceActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindDevicesByPointOfServiceActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.FindDevicesByPointOfServiceActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.pointOfServiceId != null && message.hasOwnProperty("pointOfServiceId"))
                        if (!$util.isString(message.pointOfServiceId))
                            return "pointOfServiceId: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindDevicesByPointOfServiceActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindDevicesByPointOfServiceActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindDevicesByPointOfServiceActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.FindDevicesByPointOfServiceActionProto.Request();
                    if (object.pointOfServiceId != null)
                        message.pointOfServiceId = String(object.pointOfServiceId);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindDevicesByPointOfServiceActionProto.Request
                 * @static
                 * @param {waiternow.common.FindDevicesByPointOfServiceActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.pointOfServiceId = "";
                    if (message.pointOfServiceId != null && message.hasOwnProperty("pointOfServiceId"))
                        object.pointOfServiceId = message.pointOfServiceId;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindDevicesByPointOfServiceActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindDevicesByPointOfServiceActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindDevicesByPointOfServiceActionProto.Request";
                };

                return Request;
            })();

            FindDevicesByPointOfServiceActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.FindDevicesByPointOfServiceActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IPointOfServiceDevicesProto|null} [pointOfServiceDevices] Response pointOfServiceDevices
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.FindDevicesByPointOfServiceActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.FindDevicesByPointOfServiceActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.FindDevicesByPointOfServiceActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response pointOfServiceDevices.
                 * @member {waiternow.common.IPointOfServiceDevicesProto|null|undefined} pointOfServiceDevices
                 * @memberof waiternow.common.FindDevicesByPointOfServiceActionProto.Response
                 * @instance
                 */
                Response.prototype.pointOfServiceDevices = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindDevicesByPointOfServiceActionProto.Response
                 * @static
                 * @param {waiternow.common.FindDevicesByPointOfServiceActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.FindDevicesByPointOfServiceActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.FindDevicesByPointOfServiceActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindDevicesByPointOfServiceActionProto.Response
                 * @static
                 * @param {waiternow.common.FindDevicesByPointOfServiceActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.pointOfServiceDevices != null && Object.hasOwnProperty.call(message, "pointOfServiceDevices"))
                        $root.waiternow.common.PointOfServiceDevicesProto.encode(message.pointOfServiceDevices, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.FindDevicesByPointOfServiceActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindDevicesByPointOfServiceActionProto.Response
                 * @static
                 * @param {waiternow.common.FindDevicesByPointOfServiceActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindDevicesByPointOfServiceActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindDevicesByPointOfServiceActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindDevicesByPointOfServiceActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.pointOfServiceDevices = $root.waiternow.common.PointOfServiceDevicesProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindDevicesByPointOfServiceActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindDevicesByPointOfServiceActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.FindDevicesByPointOfServiceActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.pointOfServiceDevices != null && message.hasOwnProperty("pointOfServiceDevices")) {
                        var error = $root.waiternow.common.PointOfServiceDevicesProto.verify(message.pointOfServiceDevices);
                        if (error)
                            return "pointOfServiceDevices." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindDevicesByPointOfServiceActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindDevicesByPointOfServiceActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindDevicesByPointOfServiceActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.FindDevicesByPointOfServiceActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.FindDevicesByPointOfServiceActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.pointOfServiceDevices != null) {
                        if (typeof object.pointOfServiceDevices !== "object")
                            throw TypeError(".waiternow.common.FindDevicesByPointOfServiceActionProto.Response.pointOfServiceDevices: object expected");
                        message.pointOfServiceDevices = $root.waiternow.common.PointOfServiceDevicesProto.fromObject(object.pointOfServiceDevices);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindDevicesByPointOfServiceActionProto.Response
                 * @static
                 * @param {waiternow.common.FindDevicesByPointOfServiceActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.pointOfServiceDevices = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.pointOfServiceDevices != null && message.hasOwnProperty("pointOfServiceDevices"))
                        object.pointOfServiceDevices = $root.waiternow.common.PointOfServiceDevicesProto.toObject(message.pointOfServiceDevices, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindDevicesByPointOfServiceActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindDevicesByPointOfServiceActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindDevicesByPointOfServiceActionProto.Response";
                };

                return Response;
            })();

            return FindDevicesByPointOfServiceActionProto;
        })();

        common.CreateSalesPartnerActionProto = (function() {

            /**
             * Properties of a CreateSalesPartnerActionProto.
             * @memberof waiternow.common
             * @interface ICreateSalesPartnerActionProto
             */

            /**
             * Constructs a new CreateSalesPartnerActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a CreateSalesPartnerActionProto.
             * @implements ICreateSalesPartnerActionProto
             * @constructor
             * @param {waiternow.common.ICreateSalesPartnerActionProto=} [properties] Properties to set
             */
            function CreateSalesPartnerActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new CreateSalesPartnerActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.CreateSalesPartnerActionProto
             * @static
             * @param {waiternow.common.ICreateSalesPartnerActionProto=} [properties] Properties to set
             * @returns {waiternow.common.CreateSalesPartnerActionProto} CreateSalesPartnerActionProto instance
             */
            CreateSalesPartnerActionProto.create = function create(properties) {
                return new CreateSalesPartnerActionProto(properties);
            };

            /**
             * Encodes the specified CreateSalesPartnerActionProto message. Does not implicitly {@link waiternow.common.CreateSalesPartnerActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.CreateSalesPartnerActionProto
             * @static
             * @param {waiternow.common.ICreateSalesPartnerActionProto} message CreateSalesPartnerActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CreateSalesPartnerActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified CreateSalesPartnerActionProto message, length delimited. Does not implicitly {@link waiternow.common.CreateSalesPartnerActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.CreateSalesPartnerActionProto
             * @static
             * @param {waiternow.common.ICreateSalesPartnerActionProto} message CreateSalesPartnerActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CreateSalesPartnerActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CreateSalesPartnerActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.CreateSalesPartnerActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.CreateSalesPartnerActionProto} CreateSalesPartnerActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CreateSalesPartnerActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CreateSalesPartnerActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CreateSalesPartnerActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.CreateSalesPartnerActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.CreateSalesPartnerActionProto} CreateSalesPartnerActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CreateSalesPartnerActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CreateSalesPartnerActionProto message.
             * @function verify
             * @memberof waiternow.common.CreateSalesPartnerActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CreateSalesPartnerActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a CreateSalesPartnerActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.CreateSalesPartnerActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.CreateSalesPartnerActionProto} CreateSalesPartnerActionProto
             */
            CreateSalesPartnerActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.CreateSalesPartnerActionProto)
                    return object;
                return new $root.waiternow.common.CreateSalesPartnerActionProto();
            };

            /**
             * Creates a plain object from a CreateSalesPartnerActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.CreateSalesPartnerActionProto
             * @static
             * @param {waiternow.common.CreateSalesPartnerActionProto} message CreateSalesPartnerActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CreateSalesPartnerActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this CreateSalesPartnerActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.CreateSalesPartnerActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CreateSalesPartnerActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for CreateSalesPartnerActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.CreateSalesPartnerActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            CreateSalesPartnerActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.CreateSalesPartnerActionProto";
            };

            CreateSalesPartnerActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.CreateSalesPartnerActionProto
                 * @interface IRequest
                 * @property {waiternow.common.ISalesPartnerProto|null} [salesPartner] Request salesPartner
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.CreateSalesPartnerActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.CreateSalesPartnerActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request salesPartner.
                 * @member {waiternow.common.ISalesPartnerProto|null|undefined} salesPartner
                 * @memberof waiternow.common.CreateSalesPartnerActionProto.Request
                 * @instance
                 */
                Request.prototype.salesPartner = null;

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.CreateSalesPartnerActionProto.Request
                 * @static
                 * @param {waiternow.common.CreateSalesPartnerActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.CreateSalesPartnerActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.CreateSalesPartnerActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.CreateSalesPartnerActionProto.Request
                 * @static
                 * @param {waiternow.common.CreateSalesPartnerActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.salesPartner != null && Object.hasOwnProperty.call(message, "salesPartner"))
                        $root.waiternow.common.SalesPartnerProto.encode(message.salesPartner, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.CreateSalesPartnerActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.CreateSalesPartnerActionProto.Request
                 * @static
                 * @param {waiternow.common.CreateSalesPartnerActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.CreateSalesPartnerActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.CreateSalesPartnerActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CreateSalesPartnerActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.salesPartner = $root.waiternow.common.SalesPartnerProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.CreateSalesPartnerActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.CreateSalesPartnerActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.CreateSalesPartnerActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.salesPartner != null && message.hasOwnProperty("salesPartner")) {
                        var error = $root.waiternow.common.SalesPartnerProto.verify(message.salesPartner);
                        if (error)
                            return "salesPartner." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.CreateSalesPartnerActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.CreateSalesPartnerActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.CreateSalesPartnerActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.CreateSalesPartnerActionProto.Request();
                    if (object.salesPartner != null) {
                        if (typeof object.salesPartner !== "object")
                            throw TypeError(".waiternow.common.CreateSalesPartnerActionProto.Request.salesPartner: object expected");
                        message.salesPartner = $root.waiternow.common.SalesPartnerProto.fromObject(object.salesPartner);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.CreateSalesPartnerActionProto.Request
                 * @static
                 * @param {waiternow.common.CreateSalesPartnerActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.salesPartner = null;
                    if (message.salesPartner != null && message.hasOwnProperty("salesPartner"))
                        object.salesPartner = $root.waiternow.common.SalesPartnerProto.toObject(message.salesPartner, options);
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.CreateSalesPartnerActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.CreateSalesPartnerActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.CreateSalesPartnerActionProto.Request";
                };

                return Request;
            })();

            CreateSalesPartnerActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.CreateSalesPartnerActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.ISalesPartnerProto|null} [salesPartner] Response salesPartner
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.CreateSalesPartnerActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.CreateSalesPartnerActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.CreateSalesPartnerActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response salesPartner.
                 * @member {waiternow.common.ISalesPartnerProto|null|undefined} salesPartner
                 * @memberof waiternow.common.CreateSalesPartnerActionProto.Response
                 * @instance
                 */
                Response.prototype.salesPartner = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.CreateSalesPartnerActionProto.Response
                 * @static
                 * @param {waiternow.common.CreateSalesPartnerActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.CreateSalesPartnerActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.CreateSalesPartnerActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.CreateSalesPartnerActionProto.Response
                 * @static
                 * @param {waiternow.common.CreateSalesPartnerActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.salesPartner != null && Object.hasOwnProperty.call(message, "salesPartner"))
                        $root.waiternow.common.SalesPartnerProto.encode(message.salesPartner, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.CreateSalesPartnerActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.CreateSalesPartnerActionProto.Response
                 * @static
                 * @param {waiternow.common.CreateSalesPartnerActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.CreateSalesPartnerActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.CreateSalesPartnerActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CreateSalesPartnerActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.salesPartner = $root.waiternow.common.SalesPartnerProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.CreateSalesPartnerActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.CreateSalesPartnerActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.CreateSalesPartnerActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.salesPartner != null && message.hasOwnProperty("salesPartner")) {
                        var error = $root.waiternow.common.SalesPartnerProto.verify(message.salesPartner);
                        if (error)
                            return "salesPartner." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.CreateSalesPartnerActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.CreateSalesPartnerActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.CreateSalesPartnerActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.CreateSalesPartnerActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.CreateSalesPartnerActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.salesPartner != null) {
                        if (typeof object.salesPartner !== "object")
                            throw TypeError(".waiternow.common.CreateSalesPartnerActionProto.Response.salesPartner: object expected");
                        message.salesPartner = $root.waiternow.common.SalesPartnerProto.fromObject(object.salesPartner);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.CreateSalesPartnerActionProto.Response
                 * @static
                 * @param {waiternow.common.CreateSalesPartnerActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.salesPartner = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.salesPartner != null && message.hasOwnProperty("salesPartner"))
                        object.salesPartner = $root.waiternow.common.SalesPartnerProto.toObject(message.salesPartner, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.CreateSalesPartnerActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.CreateSalesPartnerActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.CreateSalesPartnerActionProto.Response";
                };

                return Response;
            })();

            return CreateSalesPartnerActionProto;
        })();

        common.UpdateSalesPartnerActionProto = (function() {

            /**
             * Properties of an UpdateSalesPartnerActionProto.
             * @memberof waiternow.common
             * @interface IUpdateSalesPartnerActionProto
             */

            /**
             * Constructs a new UpdateSalesPartnerActionProto.
             * @memberof waiternow.common
             * @classdesc Represents an UpdateSalesPartnerActionProto.
             * @implements IUpdateSalesPartnerActionProto
             * @constructor
             * @param {waiternow.common.IUpdateSalesPartnerActionProto=} [properties] Properties to set
             */
            function UpdateSalesPartnerActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new UpdateSalesPartnerActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.UpdateSalesPartnerActionProto
             * @static
             * @param {waiternow.common.IUpdateSalesPartnerActionProto=} [properties] Properties to set
             * @returns {waiternow.common.UpdateSalesPartnerActionProto} UpdateSalesPartnerActionProto instance
             */
            UpdateSalesPartnerActionProto.create = function create(properties) {
                return new UpdateSalesPartnerActionProto(properties);
            };

            /**
             * Encodes the specified UpdateSalesPartnerActionProto message. Does not implicitly {@link waiternow.common.UpdateSalesPartnerActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.UpdateSalesPartnerActionProto
             * @static
             * @param {waiternow.common.IUpdateSalesPartnerActionProto} message UpdateSalesPartnerActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UpdateSalesPartnerActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified UpdateSalesPartnerActionProto message, length delimited. Does not implicitly {@link waiternow.common.UpdateSalesPartnerActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.UpdateSalesPartnerActionProto
             * @static
             * @param {waiternow.common.IUpdateSalesPartnerActionProto} message UpdateSalesPartnerActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UpdateSalesPartnerActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an UpdateSalesPartnerActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.UpdateSalesPartnerActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.UpdateSalesPartnerActionProto} UpdateSalesPartnerActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UpdateSalesPartnerActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.UpdateSalesPartnerActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an UpdateSalesPartnerActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.UpdateSalesPartnerActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.UpdateSalesPartnerActionProto} UpdateSalesPartnerActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UpdateSalesPartnerActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an UpdateSalesPartnerActionProto message.
             * @function verify
             * @memberof waiternow.common.UpdateSalesPartnerActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            UpdateSalesPartnerActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates an UpdateSalesPartnerActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.UpdateSalesPartnerActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.UpdateSalesPartnerActionProto} UpdateSalesPartnerActionProto
             */
            UpdateSalesPartnerActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.UpdateSalesPartnerActionProto)
                    return object;
                return new $root.waiternow.common.UpdateSalesPartnerActionProto();
            };

            /**
             * Creates a plain object from an UpdateSalesPartnerActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.UpdateSalesPartnerActionProto
             * @static
             * @param {waiternow.common.UpdateSalesPartnerActionProto} message UpdateSalesPartnerActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            UpdateSalesPartnerActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this UpdateSalesPartnerActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.UpdateSalesPartnerActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            UpdateSalesPartnerActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for UpdateSalesPartnerActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.UpdateSalesPartnerActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            UpdateSalesPartnerActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.UpdateSalesPartnerActionProto";
            };

            UpdateSalesPartnerActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.UpdateSalesPartnerActionProto
                 * @interface IRequest
                 * @property {waiternow.common.ISalesPartnerProto|null} [salesPartner] Request salesPartner
                 * @property {Array.<waiternow.common.UpdateSalesPartnerActionProto.Request.RemovableField>|null} [fieldsToRemove] Request fieldsToRemove
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.UpdateSalesPartnerActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.UpdateSalesPartnerActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    this.fieldsToRemove = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request salesPartner.
                 * @member {waiternow.common.ISalesPartnerProto|null|undefined} salesPartner
                 * @memberof waiternow.common.UpdateSalesPartnerActionProto.Request
                 * @instance
                 */
                Request.prototype.salesPartner = null;

                /**
                 * Request fieldsToRemove.
                 * @member {Array.<waiternow.common.UpdateSalesPartnerActionProto.Request.RemovableField>} fieldsToRemove
                 * @memberof waiternow.common.UpdateSalesPartnerActionProto.Request
                 * @instance
                 */
                Request.prototype.fieldsToRemove = $util.emptyArray;

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.UpdateSalesPartnerActionProto.Request
                 * @static
                 * @param {waiternow.common.UpdateSalesPartnerActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.UpdateSalesPartnerActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.UpdateSalesPartnerActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.UpdateSalesPartnerActionProto.Request
                 * @static
                 * @param {waiternow.common.UpdateSalesPartnerActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.salesPartner != null && Object.hasOwnProperty.call(message, "salesPartner"))
                        $root.waiternow.common.SalesPartnerProto.encode(message.salesPartner, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.fieldsToRemove != null && message.fieldsToRemove.length) {
                        writer.uint32(/* id 2, wireType 2 =*/18).fork();
                        for (var i = 0; i < message.fieldsToRemove.length; ++i)
                            writer.int32(message.fieldsToRemove[i]);
                        writer.ldelim();
                    }
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.UpdateSalesPartnerActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.UpdateSalesPartnerActionProto.Request
                 * @static
                 * @param {waiternow.common.UpdateSalesPartnerActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.UpdateSalesPartnerActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.UpdateSalesPartnerActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.UpdateSalesPartnerActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.salesPartner = $root.waiternow.common.SalesPartnerProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                if (!(message.fieldsToRemove && message.fieldsToRemove.length))
                                    message.fieldsToRemove = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.fieldsToRemove.push(reader.int32());
                                } else
                                    message.fieldsToRemove.push(reader.int32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.UpdateSalesPartnerActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.UpdateSalesPartnerActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.UpdateSalesPartnerActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.salesPartner != null && message.hasOwnProperty("salesPartner")) {
                        var error = $root.waiternow.common.SalesPartnerProto.verify(message.salesPartner);
                        if (error)
                            return "salesPartner." + error;
                    }
                    if (message.fieldsToRemove != null && message.hasOwnProperty("fieldsToRemove")) {
                        if (!Array.isArray(message.fieldsToRemove))
                            return "fieldsToRemove: array expected";
                        for (var i = 0; i < message.fieldsToRemove.length; ++i)
                            switch (message.fieldsToRemove[i]) {
                            default:
                                return "fieldsToRemove: enum value[] expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                    }
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.UpdateSalesPartnerActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.UpdateSalesPartnerActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.UpdateSalesPartnerActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.UpdateSalesPartnerActionProto.Request();
                    if (object.salesPartner != null) {
                        if (typeof object.salesPartner !== "object")
                            throw TypeError(".waiternow.common.UpdateSalesPartnerActionProto.Request.salesPartner: object expected");
                        message.salesPartner = $root.waiternow.common.SalesPartnerProto.fromObject(object.salesPartner);
                    }
                    if (object.fieldsToRemove) {
                        if (!Array.isArray(object.fieldsToRemove))
                            throw TypeError(".waiternow.common.UpdateSalesPartnerActionProto.Request.fieldsToRemove: array expected");
                        message.fieldsToRemove = [];
                        for (var i = 0; i < object.fieldsToRemove.length; ++i)
                            switch (object.fieldsToRemove[i]) {
                            default:
                                if (typeof object.fieldsToRemove[i] === "number") {
                                    message.fieldsToRemove[i] = object.fieldsToRemove[i];
                                    break;
                                }
                            case "REMOVABLE_FIELD_UNSPECIFIED":
                            case 0:
                                message.fieldsToRemove[i] = 0;
                                break;
                            case "PHONE_NUMBER":
                            case 1:
                                message.fieldsToRemove[i] = 1;
                                break;
                            case "STATUS_STATE":
                            case 2:
                                message.fieldsToRemove[i] = 2;
                                break;
                            case "SETTINGS_CODE":
                            case 3:
                                message.fieldsToRemove[i] = 3;
                                break;
                            }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.UpdateSalesPartnerActionProto.Request
                 * @static
                 * @param {waiternow.common.UpdateSalesPartnerActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.fieldsToRemove = [];
                    if (options.defaults)
                        object.salesPartner = null;
                    if (message.salesPartner != null && message.hasOwnProperty("salesPartner"))
                        object.salesPartner = $root.waiternow.common.SalesPartnerProto.toObject(message.salesPartner, options);
                    if (message.fieldsToRemove && message.fieldsToRemove.length) {
                        object.fieldsToRemove = [];
                        for (var j = 0; j < message.fieldsToRemove.length; ++j)
                            object.fieldsToRemove[j] = options.enums === String ? $root.waiternow.common.UpdateSalesPartnerActionProto.Request.RemovableField[message.fieldsToRemove[j]] === undefined ? message.fieldsToRemove[j] : $root.waiternow.common.UpdateSalesPartnerActionProto.Request.RemovableField[message.fieldsToRemove[j]] : message.fieldsToRemove[j];
                    }
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.UpdateSalesPartnerActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.UpdateSalesPartnerActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.UpdateSalesPartnerActionProto.Request";
                };

                /**
                 * RemovableField enum.
                 * @name waiternow.common.UpdateSalesPartnerActionProto.Request.RemovableField
                 * @enum {number}
                 * @property {number} REMOVABLE_FIELD_UNSPECIFIED=0 REMOVABLE_FIELD_UNSPECIFIED value
                 * @property {number} PHONE_NUMBER=1 PHONE_NUMBER value
                 * @property {number} STATUS_STATE=2 STATUS_STATE value
                 * @property {number} SETTINGS_CODE=3 SETTINGS_CODE value
                 */
                Request.RemovableField = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "REMOVABLE_FIELD_UNSPECIFIED"] = 0;
                    values[valuesById[1] = "PHONE_NUMBER"] = 1;
                    values[valuesById[2] = "STATUS_STATE"] = 2;
                    values[valuesById[3] = "SETTINGS_CODE"] = 3;
                    return values;
                })();

                return Request;
            })();

            UpdateSalesPartnerActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.UpdateSalesPartnerActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.UpdateSalesPartnerActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.UpdateSalesPartnerActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.UpdateSalesPartnerActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.UpdateSalesPartnerActionProto.Response
                 * @static
                 * @param {waiternow.common.UpdateSalesPartnerActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.UpdateSalesPartnerActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.UpdateSalesPartnerActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.UpdateSalesPartnerActionProto.Response
                 * @static
                 * @param {waiternow.common.UpdateSalesPartnerActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.UpdateSalesPartnerActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.UpdateSalesPartnerActionProto.Response
                 * @static
                 * @param {waiternow.common.UpdateSalesPartnerActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.UpdateSalesPartnerActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.UpdateSalesPartnerActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.UpdateSalesPartnerActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.UpdateSalesPartnerActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.UpdateSalesPartnerActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.UpdateSalesPartnerActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.UpdateSalesPartnerActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.UpdateSalesPartnerActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.UpdateSalesPartnerActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.UpdateSalesPartnerActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.UpdateSalesPartnerActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.UpdateSalesPartnerActionProto.Response
                 * @static
                 * @param {waiternow.common.UpdateSalesPartnerActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.UpdateSalesPartnerActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.UpdateSalesPartnerActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.UpdateSalesPartnerActionProto.Response";
                };

                return Response;
            })();

            return UpdateSalesPartnerActionProto;
        })();

        common.FindSalesPartnersByNameActionProto = (function() {

            /**
             * Properties of a FindSalesPartnersByNameActionProto.
             * @memberof waiternow.common
             * @interface IFindSalesPartnersByNameActionProto
             */

            /**
             * Constructs a new FindSalesPartnersByNameActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a FindSalesPartnersByNameActionProto.
             * @implements IFindSalesPartnersByNameActionProto
             * @constructor
             * @param {waiternow.common.IFindSalesPartnersByNameActionProto=} [properties] Properties to set
             */
            function FindSalesPartnersByNameActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new FindSalesPartnersByNameActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FindSalesPartnersByNameActionProto
             * @static
             * @param {waiternow.common.IFindSalesPartnersByNameActionProto=} [properties] Properties to set
             * @returns {waiternow.common.FindSalesPartnersByNameActionProto} FindSalesPartnersByNameActionProto instance
             */
            FindSalesPartnersByNameActionProto.create = function create(properties) {
                return new FindSalesPartnersByNameActionProto(properties);
            };

            /**
             * Encodes the specified FindSalesPartnersByNameActionProto message. Does not implicitly {@link waiternow.common.FindSalesPartnersByNameActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FindSalesPartnersByNameActionProto
             * @static
             * @param {waiternow.common.IFindSalesPartnersByNameActionProto} message FindSalesPartnersByNameActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindSalesPartnersByNameActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified FindSalesPartnersByNameActionProto message, length delimited. Does not implicitly {@link waiternow.common.FindSalesPartnersByNameActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FindSalesPartnersByNameActionProto
             * @static
             * @param {waiternow.common.IFindSalesPartnersByNameActionProto} message FindSalesPartnersByNameActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindSalesPartnersByNameActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FindSalesPartnersByNameActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FindSalesPartnersByNameActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FindSalesPartnersByNameActionProto} FindSalesPartnersByNameActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindSalesPartnersByNameActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindSalesPartnersByNameActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FindSalesPartnersByNameActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FindSalesPartnersByNameActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FindSalesPartnersByNameActionProto} FindSalesPartnersByNameActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindSalesPartnersByNameActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FindSalesPartnersByNameActionProto message.
             * @function verify
             * @memberof waiternow.common.FindSalesPartnersByNameActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FindSalesPartnersByNameActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a FindSalesPartnersByNameActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FindSalesPartnersByNameActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FindSalesPartnersByNameActionProto} FindSalesPartnersByNameActionProto
             */
            FindSalesPartnersByNameActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FindSalesPartnersByNameActionProto)
                    return object;
                return new $root.waiternow.common.FindSalesPartnersByNameActionProto();
            };

            /**
             * Creates a plain object from a FindSalesPartnersByNameActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FindSalesPartnersByNameActionProto
             * @static
             * @param {waiternow.common.FindSalesPartnersByNameActionProto} message FindSalesPartnersByNameActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FindSalesPartnersByNameActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this FindSalesPartnersByNameActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FindSalesPartnersByNameActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FindSalesPartnersByNameActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FindSalesPartnersByNameActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.FindSalesPartnersByNameActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FindSalesPartnersByNameActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FindSalesPartnersByNameActionProto";
            };

            FindSalesPartnersByNameActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.FindSalesPartnersByNameActionProto
                 * @interface IRequest
                 * @property {string|null} [namePrefix] Request namePrefix
                 * @property {string|null} [continuationToken] Request continuationToken
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.FindSalesPartnersByNameActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.FindSalesPartnersByNameActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request namePrefix.
                 * @member {string} namePrefix
                 * @memberof waiternow.common.FindSalesPartnersByNameActionProto.Request
                 * @instance
                 */
                Request.prototype.namePrefix = "";

                /**
                 * Request continuationToken.
                 * @member {string} continuationToken
                 * @memberof waiternow.common.FindSalesPartnersByNameActionProto.Request
                 * @instance
                 */
                Request.prototype.continuationToken = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindSalesPartnersByNameActionProto.Request
                 * @static
                 * @param {waiternow.common.FindSalesPartnersByNameActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.FindSalesPartnersByNameActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.FindSalesPartnersByNameActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindSalesPartnersByNameActionProto.Request
                 * @static
                 * @param {waiternow.common.FindSalesPartnersByNameActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.namePrefix != null && Object.hasOwnProperty.call(message, "namePrefix"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.namePrefix);
                    if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.continuationToken);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.FindSalesPartnersByNameActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindSalesPartnersByNameActionProto.Request
                 * @static
                 * @param {waiternow.common.FindSalesPartnersByNameActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindSalesPartnersByNameActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindSalesPartnersByNameActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindSalesPartnersByNameActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.namePrefix = reader.string();
                                break;
                            }
                        case 2: {
                                message.continuationToken = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindSalesPartnersByNameActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindSalesPartnersByNameActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.FindSalesPartnersByNameActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.namePrefix != null && message.hasOwnProperty("namePrefix"))
                        if (!$util.isString(message.namePrefix))
                            return "namePrefix: string expected";
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        if (!$util.isString(message.continuationToken))
                            return "continuationToken: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindSalesPartnersByNameActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindSalesPartnersByNameActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindSalesPartnersByNameActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.FindSalesPartnersByNameActionProto.Request();
                    if (object.namePrefix != null)
                        message.namePrefix = String(object.namePrefix);
                    if (object.continuationToken != null)
                        message.continuationToken = String(object.continuationToken);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindSalesPartnersByNameActionProto.Request
                 * @static
                 * @param {waiternow.common.FindSalesPartnersByNameActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.namePrefix = "";
                        object.continuationToken = "";
                    }
                    if (message.namePrefix != null && message.hasOwnProperty("namePrefix"))
                        object.namePrefix = message.namePrefix;
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        object.continuationToken = message.continuationToken;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindSalesPartnersByNameActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindSalesPartnersByNameActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindSalesPartnersByNameActionProto.Request";
                };

                return Request;
            })();

            FindSalesPartnersByNameActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.FindSalesPartnersByNameActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.ISalesPartnersProto|null} [salesPartners] Response salesPartners
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.FindSalesPartnersByNameActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.FindSalesPartnersByNameActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.FindSalesPartnersByNameActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response salesPartners.
                 * @member {waiternow.common.ISalesPartnersProto|null|undefined} salesPartners
                 * @memberof waiternow.common.FindSalesPartnersByNameActionProto.Response
                 * @instance
                 */
                Response.prototype.salesPartners = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindSalesPartnersByNameActionProto.Response
                 * @static
                 * @param {waiternow.common.FindSalesPartnersByNameActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.FindSalesPartnersByNameActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.FindSalesPartnersByNameActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindSalesPartnersByNameActionProto.Response
                 * @static
                 * @param {waiternow.common.FindSalesPartnersByNameActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.salesPartners != null && Object.hasOwnProperty.call(message, "salesPartners"))
                        $root.waiternow.common.SalesPartnersProto.encode(message.salesPartners, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.FindSalesPartnersByNameActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindSalesPartnersByNameActionProto.Response
                 * @static
                 * @param {waiternow.common.FindSalesPartnersByNameActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindSalesPartnersByNameActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindSalesPartnersByNameActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindSalesPartnersByNameActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.salesPartners = $root.waiternow.common.SalesPartnersProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindSalesPartnersByNameActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindSalesPartnersByNameActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.FindSalesPartnersByNameActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.salesPartners != null && message.hasOwnProperty("salesPartners")) {
                        var error = $root.waiternow.common.SalesPartnersProto.verify(message.salesPartners);
                        if (error)
                            return "salesPartners." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindSalesPartnersByNameActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindSalesPartnersByNameActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindSalesPartnersByNameActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.FindSalesPartnersByNameActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.FindSalesPartnersByNameActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.salesPartners != null) {
                        if (typeof object.salesPartners !== "object")
                            throw TypeError(".waiternow.common.FindSalesPartnersByNameActionProto.Response.salesPartners: object expected");
                        message.salesPartners = $root.waiternow.common.SalesPartnersProto.fromObject(object.salesPartners);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindSalesPartnersByNameActionProto.Response
                 * @static
                 * @param {waiternow.common.FindSalesPartnersByNameActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.salesPartners = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.salesPartners != null && message.hasOwnProperty("salesPartners"))
                        object.salesPartners = $root.waiternow.common.SalesPartnersProto.toObject(message.salesPartners, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindSalesPartnersByNameActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindSalesPartnersByNameActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindSalesPartnersByNameActionProto.Response";
                };

                return Response;
            })();

            return FindSalesPartnersByNameActionProto;
        })();

        common.AssociateSalesPartnerToLocationActionProto = (function() {

            /**
             * Properties of an AssociateSalesPartnerToLocationActionProto.
             * @memberof waiternow.common
             * @interface IAssociateSalesPartnerToLocationActionProto
             */

            /**
             * Constructs a new AssociateSalesPartnerToLocationActionProto.
             * @memberof waiternow.common
             * @classdesc Represents an AssociateSalesPartnerToLocationActionProto.
             * @implements IAssociateSalesPartnerToLocationActionProto
             * @constructor
             * @param {waiternow.common.IAssociateSalesPartnerToLocationActionProto=} [properties] Properties to set
             */
            function AssociateSalesPartnerToLocationActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new AssociateSalesPartnerToLocationActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.AssociateSalesPartnerToLocationActionProto
             * @static
             * @param {waiternow.common.IAssociateSalesPartnerToLocationActionProto=} [properties] Properties to set
             * @returns {waiternow.common.AssociateSalesPartnerToLocationActionProto} AssociateSalesPartnerToLocationActionProto instance
             */
            AssociateSalesPartnerToLocationActionProto.create = function create(properties) {
                return new AssociateSalesPartnerToLocationActionProto(properties);
            };

            /**
             * Encodes the specified AssociateSalesPartnerToLocationActionProto message. Does not implicitly {@link waiternow.common.AssociateSalesPartnerToLocationActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.AssociateSalesPartnerToLocationActionProto
             * @static
             * @param {waiternow.common.IAssociateSalesPartnerToLocationActionProto} message AssociateSalesPartnerToLocationActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AssociateSalesPartnerToLocationActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified AssociateSalesPartnerToLocationActionProto message, length delimited. Does not implicitly {@link waiternow.common.AssociateSalesPartnerToLocationActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.AssociateSalesPartnerToLocationActionProto
             * @static
             * @param {waiternow.common.IAssociateSalesPartnerToLocationActionProto} message AssociateSalesPartnerToLocationActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AssociateSalesPartnerToLocationActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AssociateSalesPartnerToLocationActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.AssociateSalesPartnerToLocationActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.AssociateSalesPartnerToLocationActionProto} AssociateSalesPartnerToLocationActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AssociateSalesPartnerToLocationActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.AssociateSalesPartnerToLocationActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AssociateSalesPartnerToLocationActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.AssociateSalesPartnerToLocationActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.AssociateSalesPartnerToLocationActionProto} AssociateSalesPartnerToLocationActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AssociateSalesPartnerToLocationActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AssociateSalesPartnerToLocationActionProto message.
             * @function verify
             * @memberof waiternow.common.AssociateSalesPartnerToLocationActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AssociateSalesPartnerToLocationActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates an AssociateSalesPartnerToLocationActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.AssociateSalesPartnerToLocationActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.AssociateSalesPartnerToLocationActionProto} AssociateSalesPartnerToLocationActionProto
             */
            AssociateSalesPartnerToLocationActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.AssociateSalesPartnerToLocationActionProto)
                    return object;
                return new $root.waiternow.common.AssociateSalesPartnerToLocationActionProto();
            };

            /**
             * Creates a plain object from an AssociateSalesPartnerToLocationActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.AssociateSalesPartnerToLocationActionProto
             * @static
             * @param {waiternow.common.AssociateSalesPartnerToLocationActionProto} message AssociateSalesPartnerToLocationActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AssociateSalesPartnerToLocationActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this AssociateSalesPartnerToLocationActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.AssociateSalesPartnerToLocationActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AssociateSalesPartnerToLocationActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for AssociateSalesPartnerToLocationActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.AssociateSalesPartnerToLocationActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            AssociateSalesPartnerToLocationActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.AssociateSalesPartnerToLocationActionProto";
            };

            AssociateSalesPartnerToLocationActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.AssociateSalesPartnerToLocationActionProto
                 * @interface IRequest
                 * @property {string|null} [salesPartnerId] Request salesPartnerId
                 * @property {string|null} [locationId] Request locationId
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.AssociateSalesPartnerToLocationActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.AssociateSalesPartnerToLocationActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request salesPartnerId.
                 * @member {string} salesPartnerId
                 * @memberof waiternow.common.AssociateSalesPartnerToLocationActionProto.Request
                 * @instance
                 */
                Request.prototype.salesPartnerId = "";

                /**
                 * Request locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.AssociateSalesPartnerToLocationActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.AssociateSalesPartnerToLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.AssociateSalesPartnerToLocationActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.AssociateSalesPartnerToLocationActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.AssociateSalesPartnerToLocationActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.AssociateSalesPartnerToLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.AssociateSalesPartnerToLocationActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.salesPartnerId != null && Object.hasOwnProperty.call(message, "salesPartnerId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.salesPartnerId);
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.locationId);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.AssociateSalesPartnerToLocationActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.AssociateSalesPartnerToLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.AssociateSalesPartnerToLocationActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.AssociateSalesPartnerToLocationActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.AssociateSalesPartnerToLocationActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.AssociateSalesPartnerToLocationActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.salesPartnerId = reader.string();
                                break;
                            }
                        case 2: {
                                message.locationId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.AssociateSalesPartnerToLocationActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.AssociateSalesPartnerToLocationActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.AssociateSalesPartnerToLocationActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.salesPartnerId != null && message.hasOwnProperty("salesPartnerId"))
                        if (!$util.isString(message.salesPartnerId))
                            return "salesPartnerId: string expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.AssociateSalesPartnerToLocationActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.AssociateSalesPartnerToLocationActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.AssociateSalesPartnerToLocationActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.AssociateSalesPartnerToLocationActionProto.Request();
                    if (object.salesPartnerId != null)
                        message.salesPartnerId = String(object.salesPartnerId);
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.AssociateSalesPartnerToLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.AssociateSalesPartnerToLocationActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.salesPartnerId = "";
                        object.locationId = "";
                    }
                    if (message.salesPartnerId != null && message.hasOwnProperty("salesPartnerId"))
                        object.salesPartnerId = message.salesPartnerId;
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.AssociateSalesPartnerToLocationActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.AssociateSalesPartnerToLocationActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.AssociateSalesPartnerToLocationActionProto.Request";
                };

                return Request;
            })();

            AssociateSalesPartnerToLocationActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.AssociateSalesPartnerToLocationActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.AssociateSalesPartnerToLocationActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.AssociateSalesPartnerToLocationActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.AssociateSalesPartnerToLocationActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.AssociateSalesPartnerToLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.AssociateSalesPartnerToLocationActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.AssociateSalesPartnerToLocationActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.AssociateSalesPartnerToLocationActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.AssociateSalesPartnerToLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.AssociateSalesPartnerToLocationActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.AssociateSalesPartnerToLocationActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.AssociateSalesPartnerToLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.AssociateSalesPartnerToLocationActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.AssociateSalesPartnerToLocationActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.AssociateSalesPartnerToLocationActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.AssociateSalesPartnerToLocationActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.AssociateSalesPartnerToLocationActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.AssociateSalesPartnerToLocationActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.AssociateSalesPartnerToLocationActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.AssociateSalesPartnerToLocationActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.AssociateSalesPartnerToLocationActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.AssociateSalesPartnerToLocationActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.AssociateSalesPartnerToLocationActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.AssociateSalesPartnerToLocationActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.AssociateSalesPartnerToLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.AssociateSalesPartnerToLocationActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.AssociateSalesPartnerToLocationActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.AssociateSalesPartnerToLocationActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.AssociateSalesPartnerToLocationActionProto.Response";
                };

                return Response;
            })();

            return AssociateSalesPartnerToLocationActionProto;
        })();

        common.UpdateBillActionProto = (function() {

            /**
             * Properties of an UpdateBillActionProto.
             * @memberof waiternow.common
             * @interface IUpdateBillActionProto
             */

            /**
             * Constructs a new UpdateBillActionProto.
             * @memberof waiternow.common
             * @classdesc Represents an UpdateBillActionProto.
             * @implements IUpdateBillActionProto
             * @constructor
             * @param {waiternow.common.IUpdateBillActionProto=} [properties] Properties to set
             */
            function UpdateBillActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new UpdateBillActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.UpdateBillActionProto
             * @static
             * @param {waiternow.common.IUpdateBillActionProto=} [properties] Properties to set
             * @returns {waiternow.common.UpdateBillActionProto} UpdateBillActionProto instance
             */
            UpdateBillActionProto.create = function create(properties) {
                return new UpdateBillActionProto(properties);
            };

            /**
             * Encodes the specified UpdateBillActionProto message. Does not implicitly {@link waiternow.common.UpdateBillActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.UpdateBillActionProto
             * @static
             * @param {waiternow.common.IUpdateBillActionProto} message UpdateBillActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UpdateBillActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified UpdateBillActionProto message, length delimited. Does not implicitly {@link waiternow.common.UpdateBillActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.UpdateBillActionProto
             * @static
             * @param {waiternow.common.IUpdateBillActionProto} message UpdateBillActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UpdateBillActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an UpdateBillActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.UpdateBillActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.UpdateBillActionProto} UpdateBillActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UpdateBillActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.UpdateBillActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an UpdateBillActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.UpdateBillActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.UpdateBillActionProto} UpdateBillActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UpdateBillActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an UpdateBillActionProto message.
             * @function verify
             * @memberof waiternow.common.UpdateBillActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            UpdateBillActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates an UpdateBillActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.UpdateBillActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.UpdateBillActionProto} UpdateBillActionProto
             */
            UpdateBillActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.UpdateBillActionProto)
                    return object;
                return new $root.waiternow.common.UpdateBillActionProto();
            };

            /**
             * Creates a plain object from an UpdateBillActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.UpdateBillActionProto
             * @static
             * @param {waiternow.common.UpdateBillActionProto} message UpdateBillActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            UpdateBillActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this UpdateBillActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.UpdateBillActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            UpdateBillActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for UpdateBillActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.UpdateBillActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            UpdateBillActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.UpdateBillActionProto";
            };

            UpdateBillActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.UpdateBillActionProto
                 * @interface IRequest
                 * @property {waiternow.common.IBillProto|null} [bill] Request bill
                 * @property {Array.<waiternow.common.UpdateBillActionProto.Request.RemovableField>|null} [fieldsToRemove] Request fieldsToRemove
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.UpdateBillActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.UpdateBillActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    this.fieldsToRemove = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request bill.
                 * @member {waiternow.common.IBillProto|null|undefined} bill
                 * @memberof waiternow.common.UpdateBillActionProto.Request
                 * @instance
                 */
                Request.prototype.bill = null;

                /**
                 * Request fieldsToRemove.
                 * @member {Array.<waiternow.common.UpdateBillActionProto.Request.RemovableField>} fieldsToRemove
                 * @memberof waiternow.common.UpdateBillActionProto.Request
                 * @instance
                 */
                Request.prototype.fieldsToRemove = $util.emptyArray;

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.UpdateBillActionProto.Request
                 * @static
                 * @param {waiternow.common.UpdateBillActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.UpdateBillActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.UpdateBillActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.UpdateBillActionProto.Request
                 * @static
                 * @param {waiternow.common.UpdateBillActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.bill != null && Object.hasOwnProperty.call(message, "bill"))
                        $root.waiternow.common.BillProto.encode(message.bill, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.fieldsToRemove != null && message.fieldsToRemove.length) {
                        writer.uint32(/* id 2, wireType 2 =*/18).fork();
                        for (var i = 0; i < message.fieldsToRemove.length; ++i)
                            writer.int32(message.fieldsToRemove[i]);
                        writer.ldelim();
                    }
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.UpdateBillActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.UpdateBillActionProto.Request
                 * @static
                 * @param {waiternow.common.UpdateBillActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.UpdateBillActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.UpdateBillActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.UpdateBillActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.bill = $root.waiternow.common.BillProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                if (!(message.fieldsToRemove && message.fieldsToRemove.length))
                                    message.fieldsToRemove = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.fieldsToRemove.push(reader.int32());
                                } else
                                    message.fieldsToRemove.push(reader.int32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.UpdateBillActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.UpdateBillActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.UpdateBillActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.bill != null && message.hasOwnProperty("bill")) {
                        var error = $root.waiternow.common.BillProto.verify(message.bill);
                        if (error)
                            return "bill." + error;
                    }
                    if (message.fieldsToRemove != null && message.hasOwnProperty("fieldsToRemove")) {
                        if (!Array.isArray(message.fieldsToRemove))
                            return "fieldsToRemove: array expected";
                        for (var i = 0; i < message.fieldsToRemove.length; ++i)
                            switch (message.fieldsToRemove[i]) {
                            default:
                                return "fieldsToRemove: enum value[] expected";
                            case 0:
                                break;
                            }
                    }
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.UpdateBillActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.UpdateBillActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.UpdateBillActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.UpdateBillActionProto.Request();
                    if (object.bill != null) {
                        if (typeof object.bill !== "object")
                            throw TypeError(".waiternow.common.UpdateBillActionProto.Request.bill: object expected");
                        message.bill = $root.waiternow.common.BillProto.fromObject(object.bill);
                    }
                    if (object.fieldsToRemove) {
                        if (!Array.isArray(object.fieldsToRemove))
                            throw TypeError(".waiternow.common.UpdateBillActionProto.Request.fieldsToRemove: array expected");
                        message.fieldsToRemove = [];
                        for (var i = 0; i < object.fieldsToRemove.length; ++i)
                            switch (object.fieldsToRemove[i]) {
                            default:
                                if (typeof object.fieldsToRemove[i] === "number") {
                                    message.fieldsToRemove[i] = object.fieldsToRemove[i];
                                    break;
                                }
                            case "REMOVABLE_FIELD_UNSPECIFIED":
                            case 0:
                                message.fieldsToRemove[i] = 0;
                                break;
                            }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.UpdateBillActionProto.Request
                 * @static
                 * @param {waiternow.common.UpdateBillActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.fieldsToRemove = [];
                    if (options.defaults)
                        object.bill = null;
                    if (message.bill != null && message.hasOwnProperty("bill"))
                        object.bill = $root.waiternow.common.BillProto.toObject(message.bill, options);
                    if (message.fieldsToRemove && message.fieldsToRemove.length) {
                        object.fieldsToRemove = [];
                        for (var j = 0; j < message.fieldsToRemove.length; ++j)
                            object.fieldsToRemove[j] = options.enums === String ? $root.waiternow.common.UpdateBillActionProto.Request.RemovableField[message.fieldsToRemove[j]] === undefined ? message.fieldsToRemove[j] : $root.waiternow.common.UpdateBillActionProto.Request.RemovableField[message.fieldsToRemove[j]] : message.fieldsToRemove[j];
                    }
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.UpdateBillActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.UpdateBillActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.UpdateBillActionProto.Request";
                };

                /**
                 * RemovableField enum.
                 * @name waiternow.common.UpdateBillActionProto.Request.RemovableField
                 * @enum {number}
                 * @property {number} REMOVABLE_FIELD_UNSPECIFIED=0 REMOVABLE_FIELD_UNSPECIFIED value
                 */
                Request.RemovableField = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "REMOVABLE_FIELD_UNSPECIFIED"] = 0;
                    return values;
                })();

                return Request;
            })();

            UpdateBillActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.UpdateBillActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.UpdateBillActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.UpdateBillActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.UpdateBillActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.UpdateBillActionProto.Response
                 * @static
                 * @param {waiternow.common.UpdateBillActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.UpdateBillActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.UpdateBillActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.UpdateBillActionProto.Response
                 * @static
                 * @param {waiternow.common.UpdateBillActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.UpdateBillActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.UpdateBillActionProto.Response
                 * @static
                 * @param {waiternow.common.UpdateBillActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.UpdateBillActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.UpdateBillActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.UpdateBillActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.UpdateBillActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.UpdateBillActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.UpdateBillActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.UpdateBillActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.UpdateBillActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.UpdateBillActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.UpdateBillActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.UpdateBillActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.UpdateBillActionProto.Response
                 * @static
                 * @param {waiternow.common.UpdateBillActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.UpdateBillActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.UpdateBillActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.UpdateBillActionProto.Response";
                };

                return Response;
            })();

            return UpdateBillActionProto;
        })();

        common.FindBillsByBusinessActionProto = (function() {

            /**
             * Properties of a FindBillsByBusinessActionProto.
             * @memberof waiternow.common
             * @interface IFindBillsByBusinessActionProto
             */

            /**
             * Constructs a new FindBillsByBusinessActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a FindBillsByBusinessActionProto.
             * @implements IFindBillsByBusinessActionProto
             * @constructor
             * @param {waiternow.common.IFindBillsByBusinessActionProto=} [properties] Properties to set
             */
            function FindBillsByBusinessActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new FindBillsByBusinessActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FindBillsByBusinessActionProto
             * @static
             * @param {waiternow.common.IFindBillsByBusinessActionProto=} [properties] Properties to set
             * @returns {waiternow.common.FindBillsByBusinessActionProto} FindBillsByBusinessActionProto instance
             */
            FindBillsByBusinessActionProto.create = function create(properties) {
                return new FindBillsByBusinessActionProto(properties);
            };

            /**
             * Encodes the specified FindBillsByBusinessActionProto message. Does not implicitly {@link waiternow.common.FindBillsByBusinessActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FindBillsByBusinessActionProto
             * @static
             * @param {waiternow.common.IFindBillsByBusinessActionProto} message FindBillsByBusinessActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindBillsByBusinessActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified FindBillsByBusinessActionProto message, length delimited. Does not implicitly {@link waiternow.common.FindBillsByBusinessActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FindBillsByBusinessActionProto
             * @static
             * @param {waiternow.common.IFindBillsByBusinessActionProto} message FindBillsByBusinessActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindBillsByBusinessActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FindBillsByBusinessActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FindBillsByBusinessActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FindBillsByBusinessActionProto} FindBillsByBusinessActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindBillsByBusinessActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindBillsByBusinessActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FindBillsByBusinessActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FindBillsByBusinessActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FindBillsByBusinessActionProto} FindBillsByBusinessActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindBillsByBusinessActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FindBillsByBusinessActionProto message.
             * @function verify
             * @memberof waiternow.common.FindBillsByBusinessActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FindBillsByBusinessActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a FindBillsByBusinessActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FindBillsByBusinessActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FindBillsByBusinessActionProto} FindBillsByBusinessActionProto
             */
            FindBillsByBusinessActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FindBillsByBusinessActionProto)
                    return object;
                return new $root.waiternow.common.FindBillsByBusinessActionProto();
            };

            /**
             * Creates a plain object from a FindBillsByBusinessActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FindBillsByBusinessActionProto
             * @static
             * @param {waiternow.common.FindBillsByBusinessActionProto} message FindBillsByBusinessActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FindBillsByBusinessActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this FindBillsByBusinessActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FindBillsByBusinessActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FindBillsByBusinessActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FindBillsByBusinessActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.FindBillsByBusinessActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FindBillsByBusinessActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FindBillsByBusinessActionProto";
            };

            FindBillsByBusinessActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.FindBillsByBusinessActionProto
                 * @interface IRequest
                 * @property {string|null} [businessId] Request businessId
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.FindBillsByBusinessActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.FindBillsByBusinessActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request businessId.
                 * @member {string} businessId
                 * @memberof waiternow.common.FindBillsByBusinessActionProto.Request
                 * @instance
                 */
                Request.prototype.businessId = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindBillsByBusinessActionProto.Request
                 * @static
                 * @param {waiternow.common.FindBillsByBusinessActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.FindBillsByBusinessActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.FindBillsByBusinessActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindBillsByBusinessActionProto.Request
                 * @static
                 * @param {waiternow.common.FindBillsByBusinessActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessId);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.FindBillsByBusinessActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindBillsByBusinessActionProto.Request
                 * @static
                 * @param {waiternow.common.FindBillsByBusinessActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindBillsByBusinessActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindBillsByBusinessActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindBillsByBusinessActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.businessId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindBillsByBusinessActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindBillsByBusinessActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.FindBillsByBusinessActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.businessId != null && message.hasOwnProperty("businessId"))
                        if (!$util.isString(message.businessId))
                            return "businessId: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindBillsByBusinessActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindBillsByBusinessActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindBillsByBusinessActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.FindBillsByBusinessActionProto.Request();
                    if (object.businessId != null)
                        message.businessId = String(object.businessId);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindBillsByBusinessActionProto.Request
                 * @static
                 * @param {waiternow.common.FindBillsByBusinessActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.businessId = "";
                    if (message.businessId != null && message.hasOwnProperty("businessId"))
                        object.businessId = message.businessId;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindBillsByBusinessActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindBillsByBusinessActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindBillsByBusinessActionProto.Request";
                };

                return Request;
            })();

            FindBillsByBusinessActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.FindBillsByBusinessActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IBusinessBillsProto|null} [businessBills] Response businessBills
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.FindBillsByBusinessActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.FindBillsByBusinessActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.FindBillsByBusinessActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response businessBills.
                 * @member {waiternow.common.IBusinessBillsProto|null|undefined} businessBills
                 * @memberof waiternow.common.FindBillsByBusinessActionProto.Response
                 * @instance
                 */
                Response.prototype.businessBills = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindBillsByBusinessActionProto.Response
                 * @static
                 * @param {waiternow.common.FindBillsByBusinessActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.FindBillsByBusinessActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.FindBillsByBusinessActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindBillsByBusinessActionProto.Response
                 * @static
                 * @param {waiternow.common.FindBillsByBusinessActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.businessBills != null && Object.hasOwnProperty.call(message, "businessBills"))
                        $root.waiternow.common.BusinessBillsProto.encode(message.businessBills, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.FindBillsByBusinessActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindBillsByBusinessActionProto.Response
                 * @static
                 * @param {waiternow.common.FindBillsByBusinessActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindBillsByBusinessActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindBillsByBusinessActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindBillsByBusinessActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.businessBills = $root.waiternow.common.BusinessBillsProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindBillsByBusinessActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindBillsByBusinessActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.FindBillsByBusinessActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.businessBills != null && message.hasOwnProperty("businessBills")) {
                        var error = $root.waiternow.common.BusinessBillsProto.verify(message.businessBills);
                        if (error)
                            return "businessBills." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindBillsByBusinessActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindBillsByBusinessActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindBillsByBusinessActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.FindBillsByBusinessActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.FindBillsByBusinessActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.businessBills != null) {
                        if (typeof object.businessBills !== "object")
                            throw TypeError(".waiternow.common.FindBillsByBusinessActionProto.Response.businessBills: object expected");
                        message.businessBills = $root.waiternow.common.BusinessBillsProto.fromObject(object.businessBills);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindBillsByBusinessActionProto.Response
                 * @static
                 * @param {waiternow.common.FindBillsByBusinessActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.businessBills = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.businessBills != null && message.hasOwnProperty("businessBills"))
                        object.businessBills = $root.waiternow.common.BusinessBillsProto.toObject(message.businessBills, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindBillsByBusinessActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindBillsByBusinessActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindBillsByBusinessActionProto.Response";
                };

                return Response;
            })();

            return FindBillsByBusinessActionProto;
        })();

        common.FindPendingBillsByBusinessActionProto = (function() {

            /**
             * Properties of a FindPendingBillsByBusinessActionProto.
             * @memberof waiternow.common
             * @interface IFindPendingBillsByBusinessActionProto
             */

            /**
             * Constructs a new FindPendingBillsByBusinessActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a FindPendingBillsByBusinessActionProto.
             * @implements IFindPendingBillsByBusinessActionProto
             * @constructor
             * @param {waiternow.common.IFindPendingBillsByBusinessActionProto=} [properties] Properties to set
             */
            function FindPendingBillsByBusinessActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new FindPendingBillsByBusinessActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FindPendingBillsByBusinessActionProto
             * @static
             * @param {waiternow.common.IFindPendingBillsByBusinessActionProto=} [properties] Properties to set
             * @returns {waiternow.common.FindPendingBillsByBusinessActionProto} FindPendingBillsByBusinessActionProto instance
             */
            FindPendingBillsByBusinessActionProto.create = function create(properties) {
                return new FindPendingBillsByBusinessActionProto(properties);
            };

            /**
             * Encodes the specified FindPendingBillsByBusinessActionProto message. Does not implicitly {@link waiternow.common.FindPendingBillsByBusinessActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FindPendingBillsByBusinessActionProto
             * @static
             * @param {waiternow.common.IFindPendingBillsByBusinessActionProto} message FindPendingBillsByBusinessActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindPendingBillsByBusinessActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified FindPendingBillsByBusinessActionProto message, length delimited. Does not implicitly {@link waiternow.common.FindPendingBillsByBusinessActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FindPendingBillsByBusinessActionProto
             * @static
             * @param {waiternow.common.IFindPendingBillsByBusinessActionProto} message FindPendingBillsByBusinessActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindPendingBillsByBusinessActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FindPendingBillsByBusinessActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FindPendingBillsByBusinessActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FindPendingBillsByBusinessActionProto} FindPendingBillsByBusinessActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindPendingBillsByBusinessActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindPendingBillsByBusinessActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FindPendingBillsByBusinessActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FindPendingBillsByBusinessActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FindPendingBillsByBusinessActionProto} FindPendingBillsByBusinessActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindPendingBillsByBusinessActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FindPendingBillsByBusinessActionProto message.
             * @function verify
             * @memberof waiternow.common.FindPendingBillsByBusinessActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FindPendingBillsByBusinessActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a FindPendingBillsByBusinessActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FindPendingBillsByBusinessActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FindPendingBillsByBusinessActionProto} FindPendingBillsByBusinessActionProto
             */
            FindPendingBillsByBusinessActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FindPendingBillsByBusinessActionProto)
                    return object;
                return new $root.waiternow.common.FindPendingBillsByBusinessActionProto();
            };

            /**
             * Creates a plain object from a FindPendingBillsByBusinessActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FindPendingBillsByBusinessActionProto
             * @static
             * @param {waiternow.common.FindPendingBillsByBusinessActionProto} message FindPendingBillsByBusinessActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FindPendingBillsByBusinessActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this FindPendingBillsByBusinessActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FindPendingBillsByBusinessActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FindPendingBillsByBusinessActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FindPendingBillsByBusinessActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.FindPendingBillsByBusinessActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FindPendingBillsByBusinessActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FindPendingBillsByBusinessActionProto";
            };

            FindPendingBillsByBusinessActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.FindPendingBillsByBusinessActionProto
                 * @interface IRequest
                 * @property {string|null} [businessId] Request businessId
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.FindPendingBillsByBusinessActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.FindPendingBillsByBusinessActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request businessId.
                 * @member {string} businessId
                 * @memberof waiternow.common.FindPendingBillsByBusinessActionProto.Request
                 * @instance
                 */
                Request.prototype.businessId = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindPendingBillsByBusinessActionProto.Request
                 * @static
                 * @param {waiternow.common.FindPendingBillsByBusinessActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.FindPendingBillsByBusinessActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.FindPendingBillsByBusinessActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindPendingBillsByBusinessActionProto.Request
                 * @static
                 * @param {waiternow.common.FindPendingBillsByBusinessActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessId);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.FindPendingBillsByBusinessActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindPendingBillsByBusinessActionProto.Request
                 * @static
                 * @param {waiternow.common.FindPendingBillsByBusinessActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindPendingBillsByBusinessActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindPendingBillsByBusinessActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindPendingBillsByBusinessActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.businessId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindPendingBillsByBusinessActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindPendingBillsByBusinessActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.FindPendingBillsByBusinessActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.businessId != null && message.hasOwnProperty("businessId"))
                        if (!$util.isString(message.businessId))
                            return "businessId: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindPendingBillsByBusinessActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindPendingBillsByBusinessActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindPendingBillsByBusinessActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.FindPendingBillsByBusinessActionProto.Request();
                    if (object.businessId != null)
                        message.businessId = String(object.businessId);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindPendingBillsByBusinessActionProto.Request
                 * @static
                 * @param {waiternow.common.FindPendingBillsByBusinessActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.businessId = "";
                    if (message.businessId != null && message.hasOwnProperty("businessId"))
                        object.businessId = message.businessId;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindPendingBillsByBusinessActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindPendingBillsByBusinessActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindPendingBillsByBusinessActionProto.Request";
                };

                return Request;
            })();

            FindPendingBillsByBusinessActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.FindPendingBillsByBusinessActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IBusinessPendingBillsProto|null} [businessBills] Response businessBills
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.FindPendingBillsByBusinessActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.FindPendingBillsByBusinessActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.FindPendingBillsByBusinessActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response businessBills.
                 * @member {waiternow.common.IBusinessPendingBillsProto|null|undefined} businessBills
                 * @memberof waiternow.common.FindPendingBillsByBusinessActionProto.Response
                 * @instance
                 */
                Response.prototype.businessBills = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindPendingBillsByBusinessActionProto.Response
                 * @static
                 * @param {waiternow.common.FindPendingBillsByBusinessActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.FindPendingBillsByBusinessActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.FindPendingBillsByBusinessActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindPendingBillsByBusinessActionProto.Response
                 * @static
                 * @param {waiternow.common.FindPendingBillsByBusinessActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.businessBills != null && Object.hasOwnProperty.call(message, "businessBills"))
                        $root.waiternow.common.BusinessPendingBillsProto.encode(message.businessBills, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.FindPendingBillsByBusinessActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindPendingBillsByBusinessActionProto.Response
                 * @static
                 * @param {waiternow.common.FindPendingBillsByBusinessActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindPendingBillsByBusinessActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindPendingBillsByBusinessActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindPendingBillsByBusinessActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.businessBills = $root.waiternow.common.BusinessPendingBillsProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindPendingBillsByBusinessActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindPendingBillsByBusinessActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.FindPendingBillsByBusinessActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.businessBills != null && message.hasOwnProperty("businessBills")) {
                        var error = $root.waiternow.common.BusinessPendingBillsProto.verify(message.businessBills);
                        if (error)
                            return "businessBills." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindPendingBillsByBusinessActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindPendingBillsByBusinessActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindPendingBillsByBusinessActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.FindPendingBillsByBusinessActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.FindPendingBillsByBusinessActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.businessBills != null) {
                        if (typeof object.businessBills !== "object")
                            throw TypeError(".waiternow.common.FindPendingBillsByBusinessActionProto.Response.businessBills: object expected");
                        message.businessBills = $root.waiternow.common.BusinessPendingBillsProto.fromObject(object.businessBills);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindPendingBillsByBusinessActionProto.Response
                 * @static
                 * @param {waiternow.common.FindPendingBillsByBusinessActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.businessBills = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.businessBills != null && message.hasOwnProperty("businessBills"))
                        object.businessBills = $root.waiternow.common.BusinessPendingBillsProto.toObject(message.businessBills, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindPendingBillsByBusinessActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindPendingBillsByBusinessActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindPendingBillsByBusinessActionProto.Response";
                };

                return Response;
            })();

            return FindPendingBillsByBusinessActionProto;
        })();

        common.MarkBillAsPaidActionProto = (function() {

            /**
             * Properties of a MarkBillAsPaidActionProto.
             * @memberof waiternow.common
             * @interface IMarkBillAsPaidActionProto
             */

            /**
             * Constructs a new MarkBillAsPaidActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a MarkBillAsPaidActionProto.
             * @implements IMarkBillAsPaidActionProto
             * @constructor
             * @param {waiternow.common.IMarkBillAsPaidActionProto=} [properties] Properties to set
             */
            function MarkBillAsPaidActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new MarkBillAsPaidActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.MarkBillAsPaidActionProto
             * @static
             * @param {waiternow.common.IMarkBillAsPaidActionProto=} [properties] Properties to set
             * @returns {waiternow.common.MarkBillAsPaidActionProto} MarkBillAsPaidActionProto instance
             */
            MarkBillAsPaidActionProto.create = function create(properties) {
                return new MarkBillAsPaidActionProto(properties);
            };

            /**
             * Encodes the specified MarkBillAsPaidActionProto message. Does not implicitly {@link waiternow.common.MarkBillAsPaidActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.MarkBillAsPaidActionProto
             * @static
             * @param {waiternow.common.IMarkBillAsPaidActionProto} message MarkBillAsPaidActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MarkBillAsPaidActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified MarkBillAsPaidActionProto message, length delimited. Does not implicitly {@link waiternow.common.MarkBillAsPaidActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.MarkBillAsPaidActionProto
             * @static
             * @param {waiternow.common.IMarkBillAsPaidActionProto} message MarkBillAsPaidActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MarkBillAsPaidActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a MarkBillAsPaidActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.MarkBillAsPaidActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.MarkBillAsPaidActionProto} MarkBillAsPaidActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MarkBillAsPaidActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.MarkBillAsPaidActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a MarkBillAsPaidActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.MarkBillAsPaidActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.MarkBillAsPaidActionProto} MarkBillAsPaidActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MarkBillAsPaidActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a MarkBillAsPaidActionProto message.
             * @function verify
             * @memberof waiternow.common.MarkBillAsPaidActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            MarkBillAsPaidActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a MarkBillAsPaidActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.MarkBillAsPaidActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.MarkBillAsPaidActionProto} MarkBillAsPaidActionProto
             */
            MarkBillAsPaidActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.MarkBillAsPaidActionProto)
                    return object;
                return new $root.waiternow.common.MarkBillAsPaidActionProto();
            };

            /**
             * Creates a plain object from a MarkBillAsPaidActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.MarkBillAsPaidActionProto
             * @static
             * @param {waiternow.common.MarkBillAsPaidActionProto} message MarkBillAsPaidActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            MarkBillAsPaidActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this MarkBillAsPaidActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.MarkBillAsPaidActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            MarkBillAsPaidActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for MarkBillAsPaidActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.MarkBillAsPaidActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            MarkBillAsPaidActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.MarkBillAsPaidActionProto";
            };

            MarkBillAsPaidActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.MarkBillAsPaidActionProto
                 * @interface IRequest
                 * @property {string|null} [billId] Request billId
                 * @property {string|null} [paymentId] Request paymentId
                 * @property {string|null} [businessId] Request businessId
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.MarkBillAsPaidActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.MarkBillAsPaidActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request billId.
                 * @member {string} billId
                 * @memberof waiternow.common.MarkBillAsPaidActionProto.Request
                 * @instance
                 */
                Request.prototype.billId = "";

                /**
                 * Request paymentId.
                 * @member {string} paymentId
                 * @memberof waiternow.common.MarkBillAsPaidActionProto.Request
                 * @instance
                 */
                Request.prototype.paymentId = "";

                /**
                 * Request businessId.
                 * @member {string} businessId
                 * @memberof waiternow.common.MarkBillAsPaidActionProto.Request
                 * @instance
                 */
                Request.prototype.businessId = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.MarkBillAsPaidActionProto.Request
                 * @static
                 * @param {waiternow.common.MarkBillAsPaidActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.MarkBillAsPaidActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.MarkBillAsPaidActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.MarkBillAsPaidActionProto.Request
                 * @static
                 * @param {waiternow.common.MarkBillAsPaidActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.billId != null && Object.hasOwnProperty.call(message, "billId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.billId);
                    if (message.paymentId != null && Object.hasOwnProperty.call(message, "paymentId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.paymentId);
                    if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.businessId);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.MarkBillAsPaidActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.MarkBillAsPaidActionProto.Request
                 * @static
                 * @param {waiternow.common.MarkBillAsPaidActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.MarkBillAsPaidActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.MarkBillAsPaidActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.MarkBillAsPaidActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.billId = reader.string();
                                break;
                            }
                        case 2: {
                                message.paymentId = reader.string();
                                break;
                            }
                        case 3: {
                                message.businessId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.MarkBillAsPaidActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.MarkBillAsPaidActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.MarkBillAsPaidActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.billId != null && message.hasOwnProperty("billId"))
                        if (!$util.isString(message.billId))
                            return "billId: string expected";
                    if (message.paymentId != null && message.hasOwnProperty("paymentId"))
                        if (!$util.isString(message.paymentId))
                            return "paymentId: string expected";
                    if (message.businessId != null && message.hasOwnProperty("businessId"))
                        if (!$util.isString(message.businessId))
                            return "businessId: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.MarkBillAsPaidActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.MarkBillAsPaidActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.MarkBillAsPaidActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.MarkBillAsPaidActionProto.Request();
                    if (object.billId != null)
                        message.billId = String(object.billId);
                    if (object.paymentId != null)
                        message.paymentId = String(object.paymentId);
                    if (object.businessId != null)
                        message.businessId = String(object.businessId);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.MarkBillAsPaidActionProto.Request
                 * @static
                 * @param {waiternow.common.MarkBillAsPaidActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.billId = "";
                        object.paymentId = "";
                        object.businessId = "";
                    }
                    if (message.billId != null && message.hasOwnProperty("billId"))
                        object.billId = message.billId;
                    if (message.paymentId != null && message.hasOwnProperty("paymentId"))
                        object.paymentId = message.paymentId;
                    if (message.businessId != null && message.hasOwnProperty("businessId"))
                        object.businessId = message.businessId;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.MarkBillAsPaidActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.MarkBillAsPaidActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.MarkBillAsPaidActionProto.Request";
                };

                return Request;
            })();

            MarkBillAsPaidActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.MarkBillAsPaidActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.MarkBillAsPaidActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.MarkBillAsPaidActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.MarkBillAsPaidActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.MarkBillAsPaidActionProto.Response
                 * @static
                 * @param {waiternow.common.MarkBillAsPaidActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.MarkBillAsPaidActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.MarkBillAsPaidActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.MarkBillAsPaidActionProto.Response
                 * @static
                 * @param {waiternow.common.MarkBillAsPaidActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.MarkBillAsPaidActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.MarkBillAsPaidActionProto.Response
                 * @static
                 * @param {waiternow.common.MarkBillAsPaidActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.MarkBillAsPaidActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.MarkBillAsPaidActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.MarkBillAsPaidActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.MarkBillAsPaidActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.MarkBillAsPaidActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.MarkBillAsPaidActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.MarkBillAsPaidActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.MarkBillAsPaidActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.MarkBillAsPaidActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.MarkBillAsPaidActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.MarkBillAsPaidActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.MarkBillAsPaidActionProto.Response
                 * @static
                 * @param {waiternow.common.MarkBillAsPaidActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.MarkBillAsPaidActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.MarkBillAsPaidActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.MarkBillAsPaidActionProto.Response";
                };

                return Response;
            })();

            return MarkBillAsPaidActionProto;
        })();

        common.UpdatePaycheckActionProto = (function() {

            /**
             * Properties of an UpdatePaycheckActionProto.
             * @memberof waiternow.common
             * @interface IUpdatePaycheckActionProto
             */

            /**
             * Constructs a new UpdatePaycheckActionProto.
             * @memberof waiternow.common
             * @classdesc Represents an UpdatePaycheckActionProto.
             * @implements IUpdatePaycheckActionProto
             * @constructor
             * @param {waiternow.common.IUpdatePaycheckActionProto=} [properties] Properties to set
             */
            function UpdatePaycheckActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new UpdatePaycheckActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.UpdatePaycheckActionProto
             * @static
             * @param {waiternow.common.IUpdatePaycheckActionProto=} [properties] Properties to set
             * @returns {waiternow.common.UpdatePaycheckActionProto} UpdatePaycheckActionProto instance
             */
            UpdatePaycheckActionProto.create = function create(properties) {
                return new UpdatePaycheckActionProto(properties);
            };

            /**
             * Encodes the specified UpdatePaycheckActionProto message. Does not implicitly {@link waiternow.common.UpdatePaycheckActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.UpdatePaycheckActionProto
             * @static
             * @param {waiternow.common.IUpdatePaycheckActionProto} message UpdatePaycheckActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UpdatePaycheckActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified UpdatePaycheckActionProto message, length delimited. Does not implicitly {@link waiternow.common.UpdatePaycheckActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.UpdatePaycheckActionProto
             * @static
             * @param {waiternow.common.IUpdatePaycheckActionProto} message UpdatePaycheckActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UpdatePaycheckActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an UpdatePaycheckActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.UpdatePaycheckActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.UpdatePaycheckActionProto} UpdatePaycheckActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UpdatePaycheckActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.UpdatePaycheckActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an UpdatePaycheckActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.UpdatePaycheckActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.UpdatePaycheckActionProto} UpdatePaycheckActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UpdatePaycheckActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an UpdatePaycheckActionProto message.
             * @function verify
             * @memberof waiternow.common.UpdatePaycheckActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            UpdatePaycheckActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates an UpdatePaycheckActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.UpdatePaycheckActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.UpdatePaycheckActionProto} UpdatePaycheckActionProto
             */
            UpdatePaycheckActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.UpdatePaycheckActionProto)
                    return object;
                return new $root.waiternow.common.UpdatePaycheckActionProto();
            };

            /**
             * Creates a plain object from an UpdatePaycheckActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.UpdatePaycheckActionProto
             * @static
             * @param {waiternow.common.UpdatePaycheckActionProto} message UpdatePaycheckActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            UpdatePaycheckActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this UpdatePaycheckActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.UpdatePaycheckActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            UpdatePaycheckActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for UpdatePaycheckActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.UpdatePaycheckActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            UpdatePaycheckActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.UpdatePaycheckActionProto";
            };

            UpdatePaycheckActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.UpdatePaycheckActionProto
                 * @interface IRequest
                 * @property {waiternow.common.IPaycheckProto|null} [paycheck] Request paycheck
                 * @property {Array.<waiternow.common.UpdatePaycheckActionProto.Request.RemovableField>|null} [fieldsToRemove] Request fieldsToRemove
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.UpdatePaycheckActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.UpdatePaycheckActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    this.fieldsToRemove = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request paycheck.
                 * @member {waiternow.common.IPaycheckProto|null|undefined} paycheck
                 * @memberof waiternow.common.UpdatePaycheckActionProto.Request
                 * @instance
                 */
                Request.prototype.paycheck = null;

                /**
                 * Request fieldsToRemove.
                 * @member {Array.<waiternow.common.UpdatePaycheckActionProto.Request.RemovableField>} fieldsToRemove
                 * @memberof waiternow.common.UpdatePaycheckActionProto.Request
                 * @instance
                 */
                Request.prototype.fieldsToRemove = $util.emptyArray;

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.UpdatePaycheckActionProto.Request
                 * @static
                 * @param {waiternow.common.UpdatePaycheckActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.UpdatePaycheckActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.UpdatePaycheckActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.UpdatePaycheckActionProto.Request
                 * @static
                 * @param {waiternow.common.UpdatePaycheckActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.paycheck != null && Object.hasOwnProperty.call(message, "paycheck"))
                        $root.waiternow.common.PaycheckProto.encode(message.paycheck, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.fieldsToRemove != null && message.fieldsToRemove.length) {
                        writer.uint32(/* id 2, wireType 2 =*/18).fork();
                        for (var i = 0; i < message.fieldsToRemove.length; ++i)
                            writer.int32(message.fieldsToRemove[i]);
                        writer.ldelim();
                    }
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.UpdatePaycheckActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.UpdatePaycheckActionProto.Request
                 * @static
                 * @param {waiternow.common.UpdatePaycheckActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.UpdatePaycheckActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.UpdatePaycheckActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.UpdatePaycheckActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.paycheck = $root.waiternow.common.PaycheckProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                if (!(message.fieldsToRemove && message.fieldsToRemove.length))
                                    message.fieldsToRemove = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.fieldsToRemove.push(reader.int32());
                                } else
                                    message.fieldsToRemove.push(reader.int32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.UpdatePaycheckActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.UpdatePaycheckActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.UpdatePaycheckActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.paycheck != null && message.hasOwnProperty("paycheck")) {
                        var error = $root.waiternow.common.PaycheckProto.verify(message.paycheck);
                        if (error)
                            return "paycheck." + error;
                    }
                    if (message.fieldsToRemove != null && message.hasOwnProperty("fieldsToRemove")) {
                        if (!Array.isArray(message.fieldsToRemove))
                            return "fieldsToRemove: array expected";
                        for (var i = 0; i < message.fieldsToRemove.length; ++i)
                            switch (message.fieldsToRemove[i]) {
                            default:
                                return "fieldsToRemove: enum value[] expected";
                            case 0:
                                break;
                            }
                    }
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.UpdatePaycheckActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.UpdatePaycheckActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.UpdatePaycheckActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.UpdatePaycheckActionProto.Request();
                    if (object.paycheck != null) {
                        if (typeof object.paycheck !== "object")
                            throw TypeError(".waiternow.common.UpdatePaycheckActionProto.Request.paycheck: object expected");
                        message.paycheck = $root.waiternow.common.PaycheckProto.fromObject(object.paycheck);
                    }
                    if (object.fieldsToRemove) {
                        if (!Array.isArray(object.fieldsToRemove))
                            throw TypeError(".waiternow.common.UpdatePaycheckActionProto.Request.fieldsToRemove: array expected");
                        message.fieldsToRemove = [];
                        for (var i = 0; i < object.fieldsToRemove.length; ++i)
                            switch (object.fieldsToRemove[i]) {
                            default:
                                if (typeof object.fieldsToRemove[i] === "number") {
                                    message.fieldsToRemove[i] = object.fieldsToRemove[i];
                                    break;
                                }
                            case "REMOVABLE_FIELD_UNSPECIFIED":
                            case 0:
                                message.fieldsToRemove[i] = 0;
                                break;
                            }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.UpdatePaycheckActionProto.Request
                 * @static
                 * @param {waiternow.common.UpdatePaycheckActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.fieldsToRemove = [];
                    if (options.defaults)
                        object.paycheck = null;
                    if (message.paycheck != null && message.hasOwnProperty("paycheck"))
                        object.paycheck = $root.waiternow.common.PaycheckProto.toObject(message.paycheck, options);
                    if (message.fieldsToRemove && message.fieldsToRemove.length) {
                        object.fieldsToRemove = [];
                        for (var j = 0; j < message.fieldsToRemove.length; ++j)
                            object.fieldsToRemove[j] = options.enums === String ? $root.waiternow.common.UpdatePaycheckActionProto.Request.RemovableField[message.fieldsToRemove[j]] === undefined ? message.fieldsToRemove[j] : $root.waiternow.common.UpdatePaycheckActionProto.Request.RemovableField[message.fieldsToRemove[j]] : message.fieldsToRemove[j];
                    }
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.UpdatePaycheckActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.UpdatePaycheckActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.UpdatePaycheckActionProto.Request";
                };

                /**
                 * RemovableField enum.
                 * @name waiternow.common.UpdatePaycheckActionProto.Request.RemovableField
                 * @enum {number}
                 * @property {number} REMOVABLE_FIELD_UNSPECIFIED=0 REMOVABLE_FIELD_UNSPECIFIED value
                 */
                Request.RemovableField = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "REMOVABLE_FIELD_UNSPECIFIED"] = 0;
                    return values;
                })();

                return Request;
            })();

            UpdatePaycheckActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.UpdatePaycheckActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.UpdatePaycheckActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.UpdatePaycheckActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.UpdatePaycheckActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.UpdatePaycheckActionProto.Response
                 * @static
                 * @param {waiternow.common.UpdatePaycheckActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.UpdatePaycheckActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.UpdatePaycheckActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.UpdatePaycheckActionProto.Response
                 * @static
                 * @param {waiternow.common.UpdatePaycheckActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.UpdatePaycheckActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.UpdatePaycheckActionProto.Response
                 * @static
                 * @param {waiternow.common.UpdatePaycheckActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.UpdatePaycheckActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.UpdatePaycheckActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.UpdatePaycheckActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.UpdatePaycheckActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.UpdatePaycheckActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.UpdatePaycheckActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.UpdatePaycheckActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.UpdatePaycheckActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.UpdatePaycheckActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.UpdatePaycheckActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.UpdatePaycheckActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.UpdatePaycheckActionProto.Response
                 * @static
                 * @param {waiternow.common.UpdatePaycheckActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.UpdatePaycheckActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.UpdatePaycheckActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.UpdatePaycheckActionProto.Response";
                };

                return Response;
            })();

            return UpdatePaycheckActionProto;
        })();

        common.FindPaychecksBySalespersonActionProto = (function() {

            /**
             * Properties of a FindPaychecksBySalespersonActionProto.
             * @memberof waiternow.common
             * @interface IFindPaychecksBySalespersonActionProto
             */

            /**
             * Constructs a new FindPaychecksBySalespersonActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a FindPaychecksBySalespersonActionProto.
             * @implements IFindPaychecksBySalespersonActionProto
             * @constructor
             * @param {waiternow.common.IFindPaychecksBySalespersonActionProto=} [properties] Properties to set
             */
            function FindPaychecksBySalespersonActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new FindPaychecksBySalespersonActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FindPaychecksBySalespersonActionProto
             * @static
             * @param {waiternow.common.IFindPaychecksBySalespersonActionProto=} [properties] Properties to set
             * @returns {waiternow.common.FindPaychecksBySalespersonActionProto} FindPaychecksBySalespersonActionProto instance
             */
            FindPaychecksBySalespersonActionProto.create = function create(properties) {
                return new FindPaychecksBySalespersonActionProto(properties);
            };

            /**
             * Encodes the specified FindPaychecksBySalespersonActionProto message. Does not implicitly {@link waiternow.common.FindPaychecksBySalespersonActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FindPaychecksBySalespersonActionProto
             * @static
             * @param {waiternow.common.IFindPaychecksBySalespersonActionProto} message FindPaychecksBySalespersonActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindPaychecksBySalespersonActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified FindPaychecksBySalespersonActionProto message, length delimited. Does not implicitly {@link waiternow.common.FindPaychecksBySalespersonActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FindPaychecksBySalespersonActionProto
             * @static
             * @param {waiternow.common.IFindPaychecksBySalespersonActionProto} message FindPaychecksBySalespersonActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindPaychecksBySalespersonActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FindPaychecksBySalespersonActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FindPaychecksBySalespersonActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FindPaychecksBySalespersonActionProto} FindPaychecksBySalespersonActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindPaychecksBySalespersonActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindPaychecksBySalespersonActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FindPaychecksBySalespersonActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FindPaychecksBySalespersonActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FindPaychecksBySalespersonActionProto} FindPaychecksBySalespersonActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindPaychecksBySalespersonActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FindPaychecksBySalespersonActionProto message.
             * @function verify
             * @memberof waiternow.common.FindPaychecksBySalespersonActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FindPaychecksBySalespersonActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a FindPaychecksBySalespersonActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FindPaychecksBySalespersonActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FindPaychecksBySalespersonActionProto} FindPaychecksBySalespersonActionProto
             */
            FindPaychecksBySalespersonActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FindPaychecksBySalespersonActionProto)
                    return object;
                return new $root.waiternow.common.FindPaychecksBySalespersonActionProto();
            };

            /**
             * Creates a plain object from a FindPaychecksBySalespersonActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FindPaychecksBySalespersonActionProto
             * @static
             * @param {waiternow.common.FindPaychecksBySalespersonActionProto} message FindPaychecksBySalespersonActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FindPaychecksBySalespersonActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this FindPaychecksBySalespersonActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FindPaychecksBySalespersonActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FindPaychecksBySalespersonActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FindPaychecksBySalespersonActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.FindPaychecksBySalespersonActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FindPaychecksBySalespersonActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FindPaychecksBySalespersonActionProto";
            };

            FindPaychecksBySalespersonActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.FindPaychecksBySalespersonActionProto
                 * @interface IRequest
                 * @property {string|null} [salesPartnerId] Request salesPartnerId
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.FindPaychecksBySalespersonActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.FindPaychecksBySalespersonActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request salesPartnerId.
                 * @member {string} salesPartnerId
                 * @memberof waiternow.common.FindPaychecksBySalespersonActionProto.Request
                 * @instance
                 */
                Request.prototype.salesPartnerId = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindPaychecksBySalespersonActionProto.Request
                 * @static
                 * @param {waiternow.common.FindPaychecksBySalespersonActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.FindPaychecksBySalespersonActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.FindPaychecksBySalespersonActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindPaychecksBySalespersonActionProto.Request
                 * @static
                 * @param {waiternow.common.FindPaychecksBySalespersonActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.salesPartnerId != null && Object.hasOwnProperty.call(message, "salesPartnerId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.salesPartnerId);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.FindPaychecksBySalespersonActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindPaychecksBySalespersonActionProto.Request
                 * @static
                 * @param {waiternow.common.FindPaychecksBySalespersonActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindPaychecksBySalespersonActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindPaychecksBySalespersonActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindPaychecksBySalespersonActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.salesPartnerId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindPaychecksBySalespersonActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindPaychecksBySalespersonActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.FindPaychecksBySalespersonActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.salesPartnerId != null && message.hasOwnProperty("salesPartnerId"))
                        if (!$util.isString(message.salesPartnerId))
                            return "salesPartnerId: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindPaychecksBySalespersonActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindPaychecksBySalespersonActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindPaychecksBySalespersonActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.FindPaychecksBySalespersonActionProto.Request();
                    if (object.salesPartnerId != null)
                        message.salesPartnerId = String(object.salesPartnerId);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindPaychecksBySalespersonActionProto.Request
                 * @static
                 * @param {waiternow.common.FindPaychecksBySalespersonActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.salesPartnerId = "";
                    if (message.salesPartnerId != null && message.hasOwnProperty("salesPartnerId"))
                        object.salesPartnerId = message.salesPartnerId;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindPaychecksBySalespersonActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindPaychecksBySalespersonActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindPaychecksBySalespersonActionProto.Request";
                };

                return Request;
            })();

            FindPaychecksBySalespersonActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.FindPaychecksBySalespersonActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IPaychecksProto|null} [paychecks] Response paychecks
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.FindPaychecksBySalespersonActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.FindPaychecksBySalespersonActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.FindPaychecksBySalespersonActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response paychecks.
                 * @member {waiternow.common.IPaychecksProto|null|undefined} paychecks
                 * @memberof waiternow.common.FindPaychecksBySalespersonActionProto.Response
                 * @instance
                 */
                Response.prototype.paychecks = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindPaychecksBySalespersonActionProto.Response
                 * @static
                 * @param {waiternow.common.FindPaychecksBySalespersonActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.FindPaychecksBySalespersonActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.FindPaychecksBySalespersonActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindPaychecksBySalespersonActionProto.Response
                 * @static
                 * @param {waiternow.common.FindPaychecksBySalespersonActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.paychecks != null && Object.hasOwnProperty.call(message, "paychecks"))
                        $root.waiternow.common.PaychecksProto.encode(message.paychecks, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.FindPaychecksBySalespersonActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindPaychecksBySalespersonActionProto.Response
                 * @static
                 * @param {waiternow.common.FindPaychecksBySalespersonActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindPaychecksBySalespersonActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindPaychecksBySalespersonActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindPaychecksBySalespersonActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.paychecks = $root.waiternow.common.PaychecksProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindPaychecksBySalespersonActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindPaychecksBySalespersonActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.FindPaychecksBySalespersonActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.paychecks != null && message.hasOwnProperty("paychecks")) {
                        var error = $root.waiternow.common.PaychecksProto.verify(message.paychecks);
                        if (error)
                            return "paychecks." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindPaychecksBySalespersonActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindPaychecksBySalespersonActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindPaychecksBySalespersonActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.FindPaychecksBySalespersonActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.FindPaychecksBySalespersonActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.paychecks != null) {
                        if (typeof object.paychecks !== "object")
                            throw TypeError(".waiternow.common.FindPaychecksBySalespersonActionProto.Response.paychecks: object expected");
                        message.paychecks = $root.waiternow.common.PaychecksProto.fromObject(object.paychecks);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindPaychecksBySalespersonActionProto.Response
                 * @static
                 * @param {waiternow.common.FindPaychecksBySalespersonActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.paychecks = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.paychecks != null && message.hasOwnProperty("paychecks"))
                        object.paychecks = $root.waiternow.common.PaychecksProto.toObject(message.paychecks, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindPaychecksBySalespersonActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindPaychecksBySalespersonActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindPaychecksBySalespersonActionProto.Response";
                };

                return Response;
            })();

            return FindPaychecksBySalespersonActionProto;
        })();

        common.FindLocationMetricsActionProto = (function() {

            /**
             * Properties of a FindLocationMetricsActionProto.
             * @memberof waiternow.common
             * @interface IFindLocationMetricsActionProto
             */

            /**
             * Constructs a new FindLocationMetricsActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a FindLocationMetricsActionProto.
             * @implements IFindLocationMetricsActionProto
             * @constructor
             * @param {waiternow.common.IFindLocationMetricsActionProto=} [properties] Properties to set
             */
            function FindLocationMetricsActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new FindLocationMetricsActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FindLocationMetricsActionProto
             * @static
             * @param {waiternow.common.IFindLocationMetricsActionProto=} [properties] Properties to set
             * @returns {waiternow.common.FindLocationMetricsActionProto} FindLocationMetricsActionProto instance
             */
            FindLocationMetricsActionProto.create = function create(properties) {
                return new FindLocationMetricsActionProto(properties);
            };

            /**
             * Encodes the specified FindLocationMetricsActionProto message. Does not implicitly {@link waiternow.common.FindLocationMetricsActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FindLocationMetricsActionProto
             * @static
             * @param {waiternow.common.IFindLocationMetricsActionProto} message FindLocationMetricsActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindLocationMetricsActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified FindLocationMetricsActionProto message, length delimited. Does not implicitly {@link waiternow.common.FindLocationMetricsActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FindLocationMetricsActionProto
             * @static
             * @param {waiternow.common.IFindLocationMetricsActionProto} message FindLocationMetricsActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindLocationMetricsActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FindLocationMetricsActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FindLocationMetricsActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FindLocationMetricsActionProto} FindLocationMetricsActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindLocationMetricsActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindLocationMetricsActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FindLocationMetricsActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FindLocationMetricsActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FindLocationMetricsActionProto} FindLocationMetricsActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindLocationMetricsActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FindLocationMetricsActionProto message.
             * @function verify
             * @memberof waiternow.common.FindLocationMetricsActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FindLocationMetricsActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a FindLocationMetricsActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FindLocationMetricsActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FindLocationMetricsActionProto} FindLocationMetricsActionProto
             */
            FindLocationMetricsActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FindLocationMetricsActionProto)
                    return object;
                return new $root.waiternow.common.FindLocationMetricsActionProto();
            };

            /**
             * Creates a plain object from a FindLocationMetricsActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FindLocationMetricsActionProto
             * @static
             * @param {waiternow.common.FindLocationMetricsActionProto} message FindLocationMetricsActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FindLocationMetricsActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this FindLocationMetricsActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FindLocationMetricsActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FindLocationMetricsActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FindLocationMetricsActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.FindLocationMetricsActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FindLocationMetricsActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FindLocationMetricsActionProto";
            };

            FindLocationMetricsActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.FindLocationMetricsActionProto
                 * @interface IRequest
                 * @property {string|null} [locationId] Request locationId
                 * @property {waiternow.common.PeriodType|null} [periodType] Request periodType
                 * @property {waiternow.common.IDateProto|null} [afterDate] Request afterDate
                 * @property {waiternow.common.IDateProto|null} [beforeDate] Request beforeDate
                 * @property {waiternow.common.SortOrder|null} [sortOrder] Request sortOrder
                 * @property {string|null} [continuationToken] Request continuationToken
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.FindLocationMetricsActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.FindLocationMetricsActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.FindLocationMetricsActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = "";

                /**
                 * Request periodType.
                 * @member {waiternow.common.PeriodType} periodType
                 * @memberof waiternow.common.FindLocationMetricsActionProto.Request
                 * @instance
                 */
                Request.prototype.periodType = 0;

                /**
                 * Request afterDate.
                 * @member {waiternow.common.IDateProto|null|undefined} afterDate
                 * @memberof waiternow.common.FindLocationMetricsActionProto.Request
                 * @instance
                 */
                Request.prototype.afterDate = null;

                /**
                 * Request beforeDate.
                 * @member {waiternow.common.IDateProto|null|undefined} beforeDate
                 * @memberof waiternow.common.FindLocationMetricsActionProto.Request
                 * @instance
                 */
                Request.prototype.beforeDate = null;

                /**
                 * Request sortOrder.
                 * @member {waiternow.common.SortOrder} sortOrder
                 * @memberof waiternow.common.FindLocationMetricsActionProto.Request
                 * @instance
                 */
                Request.prototype.sortOrder = 0;

                /**
                 * Request continuationToken.
                 * @member {string} continuationToken
                 * @memberof waiternow.common.FindLocationMetricsActionProto.Request
                 * @instance
                 */
                Request.prototype.continuationToken = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindLocationMetricsActionProto.Request
                 * @static
                 * @param {waiternow.common.FindLocationMetricsActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.FindLocationMetricsActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.FindLocationMetricsActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindLocationMetricsActionProto.Request
                 * @static
                 * @param {waiternow.common.FindLocationMetricsActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    if (message.periodType != null && Object.hasOwnProperty.call(message, "periodType"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.periodType);
                    if (message.afterDate != null && Object.hasOwnProperty.call(message, "afterDate"))
                        $root.waiternow.common.DateProto.encode(message.afterDate, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.beforeDate != null && Object.hasOwnProperty.call(message, "beforeDate"))
                        $root.waiternow.common.DateProto.encode(message.beforeDate, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.sortOrder != null && Object.hasOwnProperty.call(message, "sortOrder"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int32(message.sortOrder);
                    if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                        writer.uint32(/* id 6, wireType 2 =*/50).string(message.continuationToken);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.FindLocationMetricsActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindLocationMetricsActionProto.Request
                 * @static
                 * @param {waiternow.common.FindLocationMetricsActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindLocationMetricsActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindLocationMetricsActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindLocationMetricsActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 2: {
                                message.periodType = reader.int32();
                                break;
                            }
                        case 3: {
                                message.afterDate = $root.waiternow.common.DateProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 4: {
                                message.beforeDate = $root.waiternow.common.DateProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 5: {
                                message.sortOrder = reader.int32();
                                break;
                            }
                        case 6: {
                                message.continuationToken = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindLocationMetricsActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindLocationMetricsActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.FindLocationMetricsActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    if (message.periodType != null && message.hasOwnProperty("periodType"))
                        switch (message.periodType) {
                        default:
                            return "periodType: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                            break;
                        }
                    if (message.afterDate != null && message.hasOwnProperty("afterDate")) {
                        var error = $root.waiternow.common.DateProto.verify(message.afterDate);
                        if (error)
                            return "afterDate." + error;
                    }
                    if (message.beforeDate != null && message.hasOwnProperty("beforeDate")) {
                        var error = $root.waiternow.common.DateProto.verify(message.beforeDate);
                        if (error)
                            return "beforeDate." + error;
                    }
                    if (message.sortOrder != null && message.hasOwnProperty("sortOrder"))
                        switch (message.sortOrder) {
                        default:
                            return "sortOrder: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        if (!$util.isString(message.continuationToken))
                            return "continuationToken: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindLocationMetricsActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindLocationMetricsActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindLocationMetricsActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.FindLocationMetricsActionProto.Request();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    switch (object.periodType) {
                    default:
                        if (typeof object.periodType === "number") {
                            message.periodType = object.periodType;
                            break;
                        }
                        break;
                    case "PERIOD_TYPE_UNSPECIFIED":
                    case 0:
                        message.periodType = 0;
                        break;
                    case "DAILY":
                    case 1:
                        message.periodType = 1;
                        break;
                    case "MONTHLY":
                    case 2:
                        message.periodType = 2;
                        break;
                    case "YEARLY":
                    case 3:
                        message.periodType = 3;
                        break;
                    }
                    if (object.afterDate != null) {
                        if (typeof object.afterDate !== "object")
                            throw TypeError(".waiternow.common.FindLocationMetricsActionProto.Request.afterDate: object expected");
                        message.afterDate = $root.waiternow.common.DateProto.fromObject(object.afterDate);
                    }
                    if (object.beforeDate != null) {
                        if (typeof object.beforeDate !== "object")
                            throw TypeError(".waiternow.common.FindLocationMetricsActionProto.Request.beforeDate: object expected");
                        message.beforeDate = $root.waiternow.common.DateProto.fromObject(object.beforeDate);
                    }
                    switch (object.sortOrder) {
                    default:
                        if (typeof object.sortOrder === "number") {
                            message.sortOrder = object.sortOrder;
                            break;
                        }
                        break;
                    case "SORT_ORDER_UNSPECIFIED":
                    case 0:
                        message.sortOrder = 0;
                        break;
                    case "ASCENDING":
                    case 1:
                        message.sortOrder = 1;
                        break;
                    case "DESCENDING":
                    case 2:
                        message.sortOrder = 2;
                        break;
                    }
                    if (object.continuationToken != null)
                        message.continuationToken = String(object.continuationToken);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindLocationMetricsActionProto.Request
                 * @static
                 * @param {waiternow.common.FindLocationMetricsActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.locationId = "";
                        object.periodType = options.enums === String ? "PERIOD_TYPE_UNSPECIFIED" : 0;
                        object.afterDate = null;
                        object.beforeDate = null;
                        object.sortOrder = options.enums === String ? "SORT_ORDER_UNSPECIFIED" : 0;
                        object.continuationToken = "";
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    if (message.periodType != null && message.hasOwnProperty("periodType"))
                        object.periodType = options.enums === String ? $root.waiternow.common.PeriodType[message.periodType] === undefined ? message.periodType : $root.waiternow.common.PeriodType[message.periodType] : message.periodType;
                    if (message.afterDate != null && message.hasOwnProperty("afterDate"))
                        object.afterDate = $root.waiternow.common.DateProto.toObject(message.afterDate, options);
                    if (message.beforeDate != null && message.hasOwnProperty("beforeDate"))
                        object.beforeDate = $root.waiternow.common.DateProto.toObject(message.beforeDate, options);
                    if (message.sortOrder != null && message.hasOwnProperty("sortOrder"))
                        object.sortOrder = options.enums === String ? $root.waiternow.common.SortOrder[message.sortOrder] === undefined ? message.sortOrder : $root.waiternow.common.SortOrder[message.sortOrder] : message.sortOrder;
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        object.continuationToken = message.continuationToken;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindLocationMetricsActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindLocationMetricsActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindLocationMetricsActionProto.Request";
                };

                return Request;
            })();

            FindLocationMetricsActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.FindLocationMetricsActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.ILocationMetricsProto|null} [metrics] Response metrics
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.FindLocationMetricsActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.FindLocationMetricsActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.FindLocationMetricsActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response metrics.
                 * @member {waiternow.common.ILocationMetricsProto|null|undefined} metrics
                 * @memberof waiternow.common.FindLocationMetricsActionProto.Response
                 * @instance
                 */
                Response.prototype.metrics = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindLocationMetricsActionProto.Response
                 * @static
                 * @param {waiternow.common.FindLocationMetricsActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.FindLocationMetricsActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.FindLocationMetricsActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindLocationMetricsActionProto.Response
                 * @static
                 * @param {waiternow.common.FindLocationMetricsActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.metrics != null && Object.hasOwnProperty.call(message, "metrics"))
                        $root.waiternow.common.LocationMetricsProto.encode(message.metrics, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.FindLocationMetricsActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindLocationMetricsActionProto.Response
                 * @static
                 * @param {waiternow.common.FindLocationMetricsActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindLocationMetricsActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindLocationMetricsActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindLocationMetricsActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.metrics = $root.waiternow.common.LocationMetricsProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindLocationMetricsActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindLocationMetricsActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.FindLocationMetricsActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.metrics != null && message.hasOwnProperty("metrics")) {
                        var error = $root.waiternow.common.LocationMetricsProto.verify(message.metrics);
                        if (error)
                            return "metrics." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindLocationMetricsActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindLocationMetricsActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindLocationMetricsActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.FindLocationMetricsActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.FindLocationMetricsActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.metrics != null) {
                        if (typeof object.metrics !== "object")
                            throw TypeError(".waiternow.common.FindLocationMetricsActionProto.Response.metrics: object expected");
                        message.metrics = $root.waiternow.common.LocationMetricsProto.fromObject(object.metrics);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindLocationMetricsActionProto.Response
                 * @static
                 * @param {waiternow.common.FindLocationMetricsActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.metrics = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.metrics != null && message.hasOwnProperty("metrics"))
                        object.metrics = $root.waiternow.common.LocationMetricsProto.toObject(message.metrics, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindLocationMetricsActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindLocationMetricsActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindLocationMetricsActionProto.Response";
                };

                return Response;
            })();

            return FindLocationMetricsActionProto;
        })();

        common.FindBusinessMetricsActionProto = (function() {

            /**
             * Properties of a FindBusinessMetricsActionProto.
             * @memberof waiternow.common
             * @interface IFindBusinessMetricsActionProto
             */

            /**
             * Constructs a new FindBusinessMetricsActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a FindBusinessMetricsActionProto.
             * @implements IFindBusinessMetricsActionProto
             * @constructor
             * @param {waiternow.common.IFindBusinessMetricsActionProto=} [properties] Properties to set
             */
            function FindBusinessMetricsActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new FindBusinessMetricsActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FindBusinessMetricsActionProto
             * @static
             * @param {waiternow.common.IFindBusinessMetricsActionProto=} [properties] Properties to set
             * @returns {waiternow.common.FindBusinessMetricsActionProto} FindBusinessMetricsActionProto instance
             */
            FindBusinessMetricsActionProto.create = function create(properties) {
                return new FindBusinessMetricsActionProto(properties);
            };

            /**
             * Encodes the specified FindBusinessMetricsActionProto message. Does not implicitly {@link waiternow.common.FindBusinessMetricsActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FindBusinessMetricsActionProto
             * @static
             * @param {waiternow.common.IFindBusinessMetricsActionProto} message FindBusinessMetricsActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindBusinessMetricsActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified FindBusinessMetricsActionProto message, length delimited. Does not implicitly {@link waiternow.common.FindBusinessMetricsActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FindBusinessMetricsActionProto
             * @static
             * @param {waiternow.common.IFindBusinessMetricsActionProto} message FindBusinessMetricsActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindBusinessMetricsActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FindBusinessMetricsActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FindBusinessMetricsActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FindBusinessMetricsActionProto} FindBusinessMetricsActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindBusinessMetricsActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindBusinessMetricsActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FindBusinessMetricsActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FindBusinessMetricsActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FindBusinessMetricsActionProto} FindBusinessMetricsActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindBusinessMetricsActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FindBusinessMetricsActionProto message.
             * @function verify
             * @memberof waiternow.common.FindBusinessMetricsActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FindBusinessMetricsActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a FindBusinessMetricsActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FindBusinessMetricsActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FindBusinessMetricsActionProto} FindBusinessMetricsActionProto
             */
            FindBusinessMetricsActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FindBusinessMetricsActionProto)
                    return object;
                return new $root.waiternow.common.FindBusinessMetricsActionProto();
            };

            /**
             * Creates a plain object from a FindBusinessMetricsActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FindBusinessMetricsActionProto
             * @static
             * @param {waiternow.common.FindBusinessMetricsActionProto} message FindBusinessMetricsActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FindBusinessMetricsActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this FindBusinessMetricsActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FindBusinessMetricsActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FindBusinessMetricsActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FindBusinessMetricsActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.FindBusinessMetricsActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FindBusinessMetricsActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FindBusinessMetricsActionProto";
            };

            FindBusinessMetricsActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.FindBusinessMetricsActionProto
                 * @interface IRequest
                 * @property {string|null} [businessId] Request businessId
                 * @property {waiternow.common.PeriodType|null} [periodType] Request periodType
                 * @property {waiternow.common.IDateProto|null} [afterDate] Request afterDate
                 * @property {waiternow.common.IDateProto|null} [beforeDate] Request beforeDate
                 * @property {waiternow.common.SortOrder|null} [sortOrder] Request sortOrder
                 * @property {string|null} [continuationToken] Request continuationToken
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.FindBusinessMetricsActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.FindBusinessMetricsActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request businessId.
                 * @member {string} businessId
                 * @memberof waiternow.common.FindBusinessMetricsActionProto.Request
                 * @instance
                 */
                Request.prototype.businessId = "";

                /**
                 * Request periodType.
                 * @member {waiternow.common.PeriodType} periodType
                 * @memberof waiternow.common.FindBusinessMetricsActionProto.Request
                 * @instance
                 */
                Request.prototype.periodType = 0;

                /**
                 * Request afterDate.
                 * @member {waiternow.common.IDateProto|null|undefined} afterDate
                 * @memberof waiternow.common.FindBusinessMetricsActionProto.Request
                 * @instance
                 */
                Request.prototype.afterDate = null;

                /**
                 * Request beforeDate.
                 * @member {waiternow.common.IDateProto|null|undefined} beforeDate
                 * @memberof waiternow.common.FindBusinessMetricsActionProto.Request
                 * @instance
                 */
                Request.prototype.beforeDate = null;

                /**
                 * Request sortOrder.
                 * @member {waiternow.common.SortOrder} sortOrder
                 * @memberof waiternow.common.FindBusinessMetricsActionProto.Request
                 * @instance
                 */
                Request.prototype.sortOrder = 0;

                /**
                 * Request continuationToken.
                 * @member {string} continuationToken
                 * @memberof waiternow.common.FindBusinessMetricsActionProto.Request
                 * @instance
                 */
                Request.prototype.continuationToken = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindBusinessMetricsActionProto.Request
                 * @static
                 * @param {waiternow.common.FindBusinessMetricsActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.FindBusinessMetricsActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.FindBusinessMetricsActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindBusinessMetricsActionProto.Request
                 * @static
                 * @param {waiternow.common.FindBusinessMetricsActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessId);
                    if (message.periodType != null && Object.hasOwnProperty.call(message, "periodType"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.periodType);
                    if (message.afterDate != null && Object.hasOwnProperty.call(message, "afterDate"))
                        $root.waiternow.common.DateProto.encode(message.afterDate, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.beforeDate != null && Object.hasOwnProperty.call(message, "beforeDate"))
                        $root.waiternow.common.DateProto.encode(message.beforeDate, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.sortOrder != null && Object.hasOwnProperty.call(message, "sortOrder"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int32(message.sortOrder);
                    if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                        writer.uint32(/* id 6, wireType 2 =*/50).string(message.continuationToken);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.FindBusinessMetricsActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindBusinessMetricsActionProto.Request
                 * @static
                 * @param {waiternow.common.FindBusinessMetricsActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindBusinessMetricsActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindBusinessMetricsActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindBusinessMetricsActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.businessId = reader.string();
                                break;
                            }
                        case 2: {
                                message.periodType = reader.int32();
                                break;
                            }
                        case 3: {
                                message.afterDate = $root.waiternow.common.DateProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 4: {
                                message.beforeDate = $root.waiternow.common.DateProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 5: {
                                message.sortOrder = reader.int32();
                                break;
                            }
                        case 6: {
                                message.continuationToken = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindBusinessMetricsActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindBusinessMetricsActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.FindBusinessMetricsActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.businessId != null && message.hasOwnProperty("businessId"))
                        if (!$util.isString(message.businessId))
                            return "businessId: string expected";
                    if (message.periodType != null && message.hasOwnProperty("periodType"))
                        switch (message.periodType) {
                        default:
                            return "periodType: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                            break;
                        }
                    if (message.afterDate != null && message.hasOwnProperty("afterDate")) {
                        var error = $root.waiternow.common.DateProto.verify(message.afterDate);
                        if (error)
                            return "afterDate." + error;
                    }
                    if (message.beforeDate != null && message.hasOwnProperty("beforeDate")) {
                        var error = $root.waiternow.common.DateProto.verify(message.beforeDate);
                        if (error)
                            return "beforeDate." + error;
                    }
                    if (message.sortOrder != null && message.hasOwnProperty("sortOrder"))
                        switch (message.sortOrder) {
                        default:
                            return "sortOrder: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        if (!$util.isString(message.continuationToken))
                            return "continuationToken: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindBusinessMetricsActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindBusinessMetricsActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindBusinessMetricsActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.FindBusinessMetricsActionProto.Request();
                    if (object.businessId != null)
                        message.businessId = String(object.businessId);
                    switch (object.periodType) {
                    default:
                        if (typeof object.periodType === "number") {
                            message.periodType = object.periodType;
                            break;
                        }
                        break;
                    case "PERIOD_TYPE_UNSPECIFIED":
                    case 0:
                        message.periodType = 0;
                        break;
                    case "DAILY":
                    case 1:
                        message.periodType = 1;
                        break;
                    case "MONTHLY":
                    case 2:
                        message.periodType = 2;
                        break;
                    case "YEARLY":
                    case 3:
                        message.periodType = 3;
                        break;
                    }
                    if (object.afterDate != null) {
                        if (typeof object.afterDate !== "object")
                            throw TypeError(".waiternow.common.FindBusinessMetricsActionProto.Request.afterDate: object expected");
                        message.afterDate = $root.waiternow.common.DateProto.fromObject(object.afterDate);
                    }
                    if (object.beforeDate != null) {
                        if (typeof object.beforeDate !== "object")
                            throw TypeError(".waiternow.common.FindBusinessMetricsActionProto.Request.beforeDate: object expected");
                        message.beforeDate = $root.waiternow.common.DateProto.fromObject(object.beforeDate);
                    }
                    switch (object.sortOrder) {
                    default:
                        if (typeof object.sortOrder === "number") {
                            message.sortOrder = object.sortOrder;
                            break;
                        }
                        break;
                    case "SORT_ORDER_UNSPECIFIED":
                    case 0:
                        message.sortOrder = 0;
                        break;
                    case "ASCENDING":
                    case 1:
                        message.sortOrder = 1;
                        break;
                    case "DESCENDING":
                    case 2:
                        message.sortOrder = 2;
                        break;
                    }
                    if (object.continuationToken != null)
                        message.continuationToken = String(object.continuationToken);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindBusinessMetricsActionProto.Request
                 * @static
                 * @param {waiternow.common.FindBusinessMetricsActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.businessId = "";
                        object.periodType = options.enums === String ? "PERIOD_TYPE_UNSPECIFIED" : 0;
                        object.afterDate = null;
                        object.beforeDate = null;
                        object.sortOrder = options.enums === String ? "SORT_ORDER_UNSPECIFIED" : 0;
                        object.continuationToken = "";
                    }
                    if (message.businessId != null && message.hasOwnProperty("businessId"))
                        object.businessId = message.businessId;
                    if (message.periodType != null && message.hasOwnProperty("periodType"))
                        object.periodType = options.enums === String ? $root.waiternow.common.PeriodType[message.periodType] === undefined ? message.periodType : $root.waiternow.common.PeriodType[message.periodType] : message.periodType;
                    if (message.afterDate != null && message.hasOwnProperty("afterDate"))
                        object.afterDate = $root.waiternow.common.DateProto.toObject(message.afterDate, options);
                    if (message.beforeDate != null && message.hasOwnProperty("beforeDate"))
                        object.beforeDate = $root.waiternow.common.DateProto.toObject(message.beforeDate, options);
                    if (message.sortOrder != null && message.hasOwnProperty("sortOrder"))
                        object.sortOrder = options.enums === String ? $root.waiternow.common.SortOrder[message.sortOrder] === undefined ? message.sortOrder : $root.waiternow.common.SortOrder[message.sortOrder] : message.sortOrder;
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        object.continuationToken = message.continuationToken;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindBusinessMetricsActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindBusinessMetricsActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindBusinessMetricsActionProto.Request";
                };

                return Request;
            })();

            FindBusinessMetricsActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.FindBusinessMetricsActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IBusinessMetricsProto|null} [metrics] Response metrics
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.FindBusinessMetricsActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.FindBusinessMetricsActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.FindBusinessMetricsActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response metrics.
                 * @member {waiternow.common.IBusinessMetricsProto|null|undefined} metrics
                 * @memberof waiternow.common.FindBusinessMetricsActionProto.Response
                 * @instance
                 */
                Response.prototype.metrics = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindBusinessMetricsActionProto.Response
                 * @static
                 * @param {waiternow.common.FindBusinessMetricsActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.FindBusinessMetricsActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.FindBusinessMetricsActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindBusinessMetricsActionProto.Response
                 * @static
                 * @param {waiternow.common.FindBusinessMetricsActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.metrics != null && Object.hasOwnProperty.call(message, "metrics"))
                        $root.waiternow.common.BusinessMetricsProto.encode(message.metrics, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.FindBusinessMetricsActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindBusinessMetricsActionProto.Response
                 * @static
                 * @param {waiternow.common.FindBusinessMetricsActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindBusinessMetricsActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindBusinessMetricsActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindBusinessMetricsActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.metrics = $root.waiternow.common.BusinessMetricsProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindBusinessMetricsActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindBusinessMetricsActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.FindBusinessMetricsActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.metrics != null && message.hasOwnProperty("metrics")) {
                        var error = $root.waiternow.common.BusinessMetricsProto.verify(message.metrics);
                        if (error)
                            return "metrics." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindBusinessMetricsActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindBusinessMetricsActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindBusinessMetricsActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.FindBusinessMetricsActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.FindBusinessMetricsActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.metrics != null) {
                        if (typeof object.metrics !== "object")
                            throw TypeError(".waiternow.common.FindBusinessMetricsActionProto.Response.metrics: object expected");
                        message.metrics = $root.waiternow.common.BusinessMetricsProto.fromObject(object.metrics);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindBusinessMetricsActionProto.Response
                 * @static
                 * @param {waiternow.common.FindBusinessMetricsActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.metrics = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.metrics != null && message.hasOwnProperty("metrics"))
                        object.metrics = $root.waiternow.common.BusinessMetricsProto.toObject(message.metrics, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindBusinessMetricsActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindBusinessMetricsActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindBusinessMetricsActionProto.Response";
                };

                return Response;
            })();

            return FindBusinessMetricsActionProto;
        })();

        common.CreateCampaignActionProto = (function() {

            /**
             * Properties of a CreateCampaignActionProto.
             * @memberof waiternow.common
             * @interface ICreateCampaignActionProto
             */

            /**
             * Constructs a new CreateCampaignActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a CreateCampaignActionProto.
             * @implements ICreateCampaignActionProto
             * @constructor
             * @param {waiternow.common.ICreateCampaignActionProto=} [properties] Properties to set
             */
            function CreateCampaignActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new CreateCampaignActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.CreateCampaignActionProto
             * @static
             * @param {waiternow.common.ICreateCampaignActionProto=} [properties] Properties to set
             * @returns {waiternow.common.CreateCampaignActionProto} CreateCampaignActionProto instance
             */
            CreateCampaignActionProto.create = function create(properties) {
                return new CreateCampaignActionProto(properties);
            };

            /**
             * Encodes the specified CreateCampaignActionProto message. Does not implicitly {@link waiternow.common.CreateCampaignActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.CreateCampaignActionProto
             * @static
             * @param {waiternow.common.ICreateCampaignActionProto} message CreateCampaignActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CreateCampaignActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified CreateCampaignActionProto message, length delimited. Does not implicitly {@link waiternow.common.CreateCampaignActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.CreateCampaignActionProto
             * @static
             * @param {waiternow.common.ICreateCampaignActionProto} message CreateCampaignActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CreateCampaignActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CreateCampaignActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.CreateCampaignActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.CreateCampaignActionProto} CreateCampaignActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CreateCampaignActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CreateCampaignActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CreateCampaignActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.CreateCampaignActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.CreateCampaignActionProto} CreateCampaignActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CreateCampaignActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CreateCampaignActionProto message.
             * @function verify
             * @memberof waiternow.common.CreateCampaignActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CreateCampaignActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a CreateCampaignActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.CreateCampaignActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.CreateCampaignActionProto} CreateCampaignActionProto
             */
            CreateCampaignActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.CreateCampaignActionProto)
                    return object;
                return new $root.waiternow.common.CreateCampaignActionProto();
            };

            /**
             * Creates a plain object from a CreateCampaignActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.CreateCampaignActionProto
             * @static
             * @param {waiternow.common.CreateCampaignActionProto} message CreateCampaignActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CreateCampaignActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this CreateCampaignActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.CreateCampaignActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CreateCampaignActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for CreateCampaignActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.CreateCampaignActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            CreateCampaignActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.CreateCampaignActionProto";
            };

            CreateCampaignActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.CreateCampaignActionProto
                 * @interface IRequest
                 * @property {waiternow.common.ICampaignProto|null} [campaign] Request campaign
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.CreateCampaignActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.CreateCampaignActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request campaign.
                 * @member {waiternow.common.ICampaignProto|null|undefined} campaign
                 * @memberof waiternow.common.CreateCampaignActionProto.Request
                 * @instance
                 */
                Request.prototype.campaign = null;

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.CreateCampaignActionProto.Request
                 * @static
                 * @param {waiternow.common.CreateCampaignActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.CreateCampaignActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.CreateCampaignActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.CreateCampaignActionProto.Request
                 * @static
                 * @param {waiternow.common.CreateCampaignActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.campaign != null && Object.hasOwnProperty.call(message, "campaign"))
                        $root.waiternow.common.CampaignProto.encode(message.campaign, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.CreateCampaignActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.CreateCampaignActionProto.Request
                 * @static
                 * @param {waiternow.common.CreateCampaignActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.CreateCampaignActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.CreateCampaignActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CreateCampaignActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.campaign = $root.waiternow.common.CampaignProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.CreateCampaignActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.CreateCampaignActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.CreateCampaignActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.campaign != null && message.hasOwnProperty("campaign")) {
                        var error = $root.waiternow.common.CampaignProto.verify(message.campaign);
                        if (error)
                            return "campaign." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.CreateCampaignActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.CreateCampaignActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.CreateCampaignActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.CreateCampaignActionProto.Request();
                    if (object.campaign != null) {
                        if (typeof object.campaign !== "object")
                            throw TypeError(".waiternow.common.CreateCampaignActionProto.Request.campaign: object expected");
                        message.campaign = $root.waiternow.common.CampaignProto.fromObject(object.campaign);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.CreateCampaignActionProto.Request
                 * @static
                 * @param {waiternow.common.CreateCampaignActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.campaign = null;
                    if (message.campaign != null && message.hasOwnProperty("campaign"))
                        object.campaign = $root.waiternow.common.CampaignProto.toObject(message.campaign, options);
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.CreateCampaignActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.CreateCampaignActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.CreateCampaignActionProto.Request";
                };

                return Request;
            })();

            CreateCampaignActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.CreateCampaignActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.ICampaignProto|null} [campaign] Response campaign
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.CreateCampaignActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.CreateCampaignActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.CreateCampaignActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response campaign.
                 * @member {waiternow.common.ICampaignProto|null|undefined} campaign
                 * @memberof waiternow.common.CreateCampaignActionProto.Response
                 * @instance
                 */
                Response.prototype.campaign = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.CreateCampaignActionProto.Response
                 * @static
                 * @param {waiternow.common.CreateCampaignActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.CreateCampaignActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.CreateCampaignActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.CreateCampaignActionProto.Response
                 * @static
                 * @param {waiternow.common.CreateCampaignActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.campaign != null && Object.hasOwnProperty.call(message, "campaign"))
                        $root.waiternow.common.CampaignProto.encode(message.campaign, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.CreateCampaignActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.CreateCampaignActionProto.Response
                 * @static
                 * @param {waiternow.common.CreateCampaignActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.CreateCampaignActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.CreateCampaignActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.CreateCampaignActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.campaign = $root.waiternow.common.CampaignProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.CreateCampaignActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.CreateCampaignActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.CreateCampaignActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.campaign != null && message.hasOwnProperty("campaign")) {
                        var error = $root.waiternow.common.CampaignProto.verify(message.campaign);
                        if (error)
                            return "campaign." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.CreateCampaignActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.CreateCampaignActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.CreateCampaignActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.CreateCampaignActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.CreateCampaignActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.campaign != null) {
                        if (typeof object.campaign !== "object")
                            throw TypeError(".waiternow.common.CreateCampaignActionProto.Response.campaign: object expected");
                        message.campaign = $root.waiternow.common.CampaignProto.fromObject(object.campaign);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.CreateCampaignActionProto.Response
                 * @static
                 * @param {waiternow.common.CreateCampaignActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.campaign = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.campaign != null && message.hasOwnProperty("campaign"))
                        object.campaign = $root.waiternow.common.CampaignProto.toObject(message.campaign, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.CreateCampaignActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.CreateCampaignActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.CreateCampaignActionProto.Response";
                };

                return Response;
            })();

            return CreateCampaignActionProto;
        })();

        common.UpdateCampaignActionProto = (function() {

            /**
             * Properties of an UpdateCampaignActionProto.
             * @memberof waiternow.common
             * @interface IUpdateCampaignActionProto
             */

            /**
             * Constructs a new UpdateCampaignActionProto.
             * @memberof waiternow.common
             * @classdesc Represents an UpdateCampaignActionProto.
             * @implements IUpdateCampaignActionProto
             * @constructor
             * @param {waiternow.common.IUpdateCampaignActionProto=} [properties] Properties to set
             */
            function UpdateCampaignActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new UpdateCampaignActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.UpdateCampaignActionProto
             * @static
             * @param {waiternow.common.IUpdateCampaignActionProto=} [properties] Properties to set
             * @returns {waiternow.common.UpdateCampaignActionProto} UpdateCampaignActionProto instance
             */
            UpdateCampaignActionProto.create = function create(properties) {
                return new UpdateCampaignActionProto(properties);
            };

            /**
             * Encodes the specified UpdateCampaignActionProto message. Does not implicitly {@link waiternow.common.UpdateCampaignActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.UpdateCampaignActionProto
             * @static
             * @param {waiternow.common.IUpdateCampaignActionProto} message UpdateCampaignActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UpdateCampaignActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified UpdateCampaignActionProto message, length delimited. Does not implicitly {@link waiternow.common.UpdateCampaignActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.UpdateCampaignActionProto
             * @static
             * @param {waiternow.common.IUpdateCampaignActionProto} message UpdateCampaignActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UpdateCampaignActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an UpdateCampaignActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.UpdateCampaignActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.UpdateCampaignActionProto} UpdateCampaignActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UpdateCampaignActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.UpdateCampaignActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an UpdateCampaignActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.UpdateCampaignActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.UpdateCampaignActionProto} UpdateCampaignActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UpdateCampaignActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an UpdateCampaignActionProto message.
             * @function verify
             * @memberof waiternow.common.UpdateCampaignActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            UpdateCampaignActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates an UpdateCampaignActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.UpdateCampaignActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.UpdateCampaignActionProto} UpdateCampaignActionProto
             */
            UpdateCampaignActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.UpdateCampaignActionProto)
                    return object;
                return new $root.waiternow.common.UpdateCampaignActionProto();
            };

            /**
             * Creates a plain object from an UpdateCampaignActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.UpdateCampaignActionProto
             * @static
             * @param {waiternow.common.UpdateCampaignActionProto} message UpdateCampaignActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            UpdateCampaignActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this UpdateCampaignActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.UpdateCampaignActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            UpdateCampaignActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for UpdateCampaignActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.UpdateCampaignActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            UpdateCampaignActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.UpdateCampaignActionProto";
            };

            UpdateCampaignActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.UpdateCampaignActionProto
                 * @interface IRequest
                 * @property {waiternow.common.ICampaignProto|null} [campaign] Request campaign
                 * @property {Array.<waiternow.common.UpdateCampaignActionProto.Request.RemovableField>|null} [fieldsToRemove] Request fieldsToRemove
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.UpdateCampaignActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.UpdateCampaignActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    this.fieldsToRemove = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request campaign.
                 * @member {waiternow.common.ICampaignProto|null|undefined} campaign
                 * @memberof waiternow.common.UpdateCampaignActionProto.Request
                 * @instance
                 */
                Request.prototype.campaign = null;

                /**
                 * Request fieldsToRemove.
                 * @member {Array.<waiternow.common.UpdateCampaignActionProto.Request.RemovableField>} fieldsToRemove
                 * @memberof waiternow.common.UpdateCampaignActionProto.Request
                 * @instance
                 */
                Request.prototype.fieldsToRemove = $util.emptyArray;

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.UpdateCampaignActionProto.Request
                 * @static
                 * @param {waiternow.common.UpdateCampaignActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.UpdateCampaignActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.UpdateCampaignActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.UpdateCampaignActionProto.Request
                 * @static
                 * @param {waiternow.common.UpdateCampaignActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.campaign != null && Object.hasOwnProperty.call(message, "campaign"))
                        $root.waiternow.common.CampaignProto.encode(message.campaign, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.fieldsToRemove != null && message.fieldsToRemove.length) {
                        writer.uint32(/* id 2, wireType 2 =*/18).fork();
                        for (var i = 0; i < message.fieldsToRemove.length; ++i)
                            writer.int32(message.fieldsToRemove[i]);
                        writer.ldelim();
                    }
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.UpdateCampaignActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.UpdateCampaignActionProto.Request
                 * @static
                 * @param {waiternow.common.UpdateCampaignActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.UpdateCampaignActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.UpdateCampaignActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.UpdateCampaignActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.campaign = $root.waiternow.common.CampaignProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                if (!(message.fieldsToRemove && message.fieldsToRemove.length))
                                    message.fieldsToRemove = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.fieldsToRemove.push(reader.int32());
                                } else
                                    message.fieldsToRemove.push(reader.int32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.UpdateCampaignActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.UpdateCampaignActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.UpdateCampaignActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.campaign != null && message.hasOwnProperty("campaign")) {
                        var error = $root.waiternow.common.CampaignProto.verify(message.campaign);
                        if (error)
                            return "campaign." + error;
                    }
                    if (message.fieldsToRemove != null && message.hasOwnProperty("fieldsToRemove")) {
                        if (!Array.isArray(message.fieldsToRemove))
                            return "fieldsToRemove: array expected";
                        for (var i = 0; i < message.fieldsToRemove.length; ++i)
                            switch (message.fieldsToRemove[i]) {
                            default:
                                return "fieldsToRemove: enum value[] expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                                break;
                            }
                    }
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.UpdateCampaignActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.UpdateCampaignActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.UpdateCampaignActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.UpdateCampaignActionProto.Request();
                    if (object.campaign != null) {
                        if (typeof object.campaign !== "object")
                            throw TypeError(".waiternow.common.UpdateCampaignActionProto.Request.campaign: object expected");
                        message.campaign = $root.waiternow.common.CampaignProto.fromObject(object.campaign);
                    }
                    if (object.fieldsToRemove) {
                        if (!Array.isArray(object.fieldsToRemove))
                            throw TypeError(".waiternow.common.UpdateCampaignActionProto.Request.fieldsToRemove: array expected");
                        message.fieldsToRemove = [];
                        for (var i = 0; i < object.fieldsToRemove.length; ++i)
                            switch (object.fieldsToRemove[i]) {
                            default:
                                if (typeof object.fieldsToRemove[i] === "number") {
                                    message.fieldsToRemove[i] = object.fieldsToRemove[i];
                                    break;
                                }
                            case "REMOVABLE_FIELD_UNSPECIFIED":
                            case 0:
                                message.fieldsToRemove[i] = 0;
                                break;
                            case "CODE":
                            case 1:
                                message.fieldsToRemove[i] = 1;
                                break;
                            case "DESCRIPTION":
                            case 2:
                                message.fieldsToRemove[i] = 2;
                                break;
                            case "DISCOUNT":
                            case 3:
                                message.fieldsToRemove[i] = 3;
                                break;
                            case "CONDITIONS":
                            case 4:
                                message.fieldsToRemove[i] = 4;
                                break;
                            case "IS_ACTIVE":
                            case 5:
                                message.fieldsToRemove[i] = 5;
                                break;
                            }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.UpdateCampaignActionProto.Request
                 * @static
                 * @param {waiternow.common.UpdateCampaignActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.fieldsToRemove = [];
                    if (options.defaults)
                        object.campaign = null;
                    if (message.campaign != null && message.hasOwnProperty("campaign"))
                        object.campaign = $root.waiternow.common.CampaignProto.toObject(message.campaign, options);
                    if (message.fieldsToRemove && message.fieldsToRemove.length) {
                        object.fieldsToRemove = [];
                        for (var j = 0; j < message.fieldsToRemove.length; ++j)
                            object.fieldsToRemove[j] = options.enums === String ? $root.waiternow.common.UpdateCampaignActionProto.Request.RemovableField[message.fieldsToRemove[j]] === undefined ? message.fieldsToRemove[j] : $root.waiternow.common.UpdateCampaignActionProto.Request.RemovableField[message.fieldsToRemove[j]] : message.fieldsToRemove[j];
                    }
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.UpdateCampaignActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.UpdateCampaignActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.UpdateCampaignActionProto.Request";
                };

                /**
                 * RemovableField enum.
                 * @name waiternow.common.UpdateCampaignActionProto.Request.RemovableField
                 * @enum {number}
                 * @property {number} REMOVABLE_FIELD_UNSPECIFIED=0 REMOVABLE_FIELD_UNSPECIFIED value
                 * @property {number} CODE=1 CODE value
                 * @property {number} DESCRIPTION=2 DESCRIPTION value
                 * @property {number} DISCOUNT=3 DISCOUNT value
                 * @property {number} CONDITIONS=4 CONDITIONS value
                 * @property {number} IS_ACTIVE=5 IS_ACTIVE value
                 */
                Request.RemovableField = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "REMOVABLE_FIELD_UNSPECIFIED"] = 0;
                    values[valuesById[1] = "CODE"] = 1;
                    values[valuesById[2] = "DESCRIPTION"] = 2;
                    values[valuesById[3] = "DISCOUNT"] = 3;
                    values[valuesById[4] = "CONDITIONS"] = 4;
                    values[valuesById[5] = "IS_ACTIVE"] = 5;
                    return values;
                })();

                return Request;
            })();

            UpdateCampaignActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.UpdateCampaignActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.UpdateCampaignActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.UpdateCampaignActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.UpdateCampaignActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.UpdateCampaignActionProto.Response
                 * @static
                 * @param {waiternow.common.UpdateCampaignActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.UpdateCampaignActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.UpdateCampaignActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.UpdateCampaignActionProto.Response
                 * @static
                 * @param {waiternow.common.UpdateCampaignActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.UpdateCampaignActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.UpdateCampaignActionProto.Response
                 * @static
                 * @param {waiternow.common.UpdateCampaignActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.UpdateCampaignActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.UpdateCampaignActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.UpdateCampaignActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.UpdateCampaignActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.UpdateCampaignActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.UpdateCampaignActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.UpdateCampaignActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.UpdateCampaignActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.UpdateCampaignActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.UpdateCampaignActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.UpdateCampaignActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.UpdateCampaignActionProto.Response
                 * @static
                 * @param {waiternow.common.UpdateCampaignActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.UpdateCampaignActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.UpdateCampaignActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.UpdateCampaignActionProto.Response";
                };

                return Response;
            })();

            return UpdateCampaignActionProto;
        })();

        common.DeleteCampaignActionProto = (function() {

            /**
             * Properties of a DeleteCampaignActionProto.
             * @memberof waiternow.common
             * @interface IDeleteCampaignActionProto
             */

            /**
             * Constructs a new DeleteCampaignActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a DeleteCampaignActionProto.
             * @implements IDeleteCampaignActionProto
             * @constructor
             * @param {waiternow.common.IDeleteCampaignActionProto=} [properties] Properties to set
             */
            function DeleteCampaignActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new DeleteCampaignActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.DeleteCampaignActionProto
             * @static
             * @param {waiternow.common.IDeleteCampaignActionProto=} [properties] Properties to set
             * @returns {waiternow.common.DeleteCampaignActionProto} DeleteCampaignActionProto instance
             */
            DeleteCampaignActionProto.create = function create(properties) {
                return new DeleteCampaignActionProto(properties);
            };

            /**
             * Encodes the specified DeleteCampaignActionProto message. Does not implicitly {@link waiternow.common.DeleteCampaignActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.DeleteCampaignActionProto
             * @static
             * @param {waiternow.common.IDeleteCampaignActionProto} message DeleteCampaignActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DeleteCampaignActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified DeleteCampaignActionProto message, length delimited. Does not implicitly {@link waiternow.common.DeleteCampaignActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.DeleteCampaignActionProto
             * @static
             * @param {waiternow.common.IDeleteCampaignActionProto} message DeleteCampaignActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DeleteCampaignActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a DeleteCampaignActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.DeleteCampaignActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.DeleteCampaignActionProto} DeleteCampaignActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DeleteCampaignActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.DeleteCampaignActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a DeleteCampaignActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.DeleteCampaignActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.DeleteCampaignActionProto} DeleteCampaignActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DeleteCampaignActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a DeleteCampaignActionProto message.
             * @function verify
             * @memberof waiternow.common.DeleteCampaignActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            DeleteCampaignActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a DeleteCampaignActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.DeleteCampaignActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.DeleteCampaignActionProto} DeleteCampaignActionProto
             */
            DeleteCampaignActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.DeleteCampaignActionProto)
                    return object;
                return new $root.waiternow.common.DeleteCampaignActionProto();
            };

            /**
             * Creates a plain object from a DeleteCampaignActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.DeleteCampaignActionProto
             * @static
             * @param {waiternow.common.DeleteCampaignActionProto} message DeleteCampaignActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            DeleteCampaignActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this DeleteCampaignActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.DeleteCampaignActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            DeleteCampaignActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for DeleteCampaignActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.DeleteCampaignActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            DeleteCampaignActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.DeleteCampaignActionProto";
            };

            DeleteCampaignActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.DeleteCampaignActionProto
                 * @interface IRequest
                 * @property {string|null} [campaignId] Request campaignId
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.DeleteCampaignActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.DeleteCampaignActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request campaignId.
                 * @member {string} campaignId
                 * @memberof waiternow.common.DeleteCampaignActionProto.Request
                 * @instance
                 */
                Request.prototype.campaignId = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.DeleteCampaignActionProto.Request
                 * @static
                 * @param {waiternow.common.DeleteCampaignActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.DeleteCampaignActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.DeleteCampaignActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.DeleteCampaignActionProto.Request
                 * @static
                 * @param {waiternow.common.DeleteCampaignActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.campaignId != null && Object.hasOwnProperty.call(message, "campaignId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.campaignId);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.DeleteCampaignActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.DeleteCampaignActionProto.Request
                 * @static
                 * @param {waiternow.common.DeleteCampaignActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.DeleteCampaignActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.DeleteCampaignActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.DeleteCampaignActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.campaignId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.DeleteCampaignActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.DeleteCampaignActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.DeleteCampaignActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.campaignId != null && message.hasOwnProperty("campaignId"))
                        if (!$util.isString(message.campaignId))
                            return "campaignId: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.DeleteCampaignActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.DeleteCampaignActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.DeleteCampaignActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.DeleteCampaignActionProto.Request();
                    if (object.campaignId != null)
                        message.campaignId = String(object.campaignId);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.DeleteCampaignActionProto.Request
                 * @static
                 * @param {waiternow.common.DeleteCampaignActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.campaignId = "";
                    if (message.campaignId != null && message.hasOwnProperty("campaignId"))
                        object.campaignId = message.campaignId;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.DeleteCampaignActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.DeleteCampaignActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.DeleteCampaignActionProto.Request";
                };

                return Request;
            })();

            DeleteCampaignActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.DeleteCampaignActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.DeleteCampaignActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.DeleteCampaignActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.DeleteCampaignActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.DeleteCampaignActionProto.Response
                 * @static
                 * @param {waiternow.common.DeleteCampaignActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.DeleteCampaignActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.DeleteCampaignActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.DeleteCampaignActionProto.Response
                 * @static
                 * @param {waiternow.common.DeleteCampaignActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.DeleteCampaignActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.DeleteCampaignActionProto.Response
                 * @static
                 * @param {waiternow.common.DeleteCampaignActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.DeleteCampaignActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.DeleteCampaignActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.DeleteCampaignActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.DeleteCampaignActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.DeleteCampaignActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.DeleteCampaignActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.DeleteCampaignActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.DeleteCampaignActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.DeleteCampaignActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.DeleteCampaignActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.DeleteCampaignActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.DeleteCampaignActionProto.Response
                 * @static
                 * @param {waiternow.common.DeleteCampaignActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.operationStatus = null;
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.DeleteCampaignActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.DeleteCampaignActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.DeleteCampaignActionProto.Response";
                };

                return Response;
            })();

            return DeleteCampaignActionProto;
        })();

        common.GetCampaignActionProto = (function() {

            /**
             * Properties of a GetCampaignActionProto.
             * @memberof waiternow.common
             * @interface IGetCampaignActionProto
             */

            /**
             * Constructs a new GetCampaignActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a GetCampaignActionProto.
             * @implements IGetCampaignActionProto
             * @constructor
             * @param {waiternow.common.IGetCampaignActionProto=} [properties] Properties to set
             */
            function GetCampaignActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new GetCampaignActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.GetCampaignActionProto
             * @static
             * @param {waiternow.common.IGetCampaignActionProto=} [properties] Properties to set
             * @returns {waiternow.common.GetCampaignActionProto} GetCampaignActionProto instance
             */
            GetCampaignActionProto.create = function create(properties) {
                return new GetCampaignActionProto(properties);
            };

            /**
             * Encodes the specified GetCampaignActionProto message. Does not implicitly {@link waiternow.common.GetCampaignActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.GetCampaignActionProto
             * @static
             * @param {waiternow.common.IGetCampaignActionProto} message GetCampaignActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetCampaignActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified GetCampaignActionProto message, length delimited. Does not implicitly {@link waiternow.common.GetCampaignActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.GetCampaignActionProto
             * @static
             * @param {waiternow.common.IGetCampaignActionProto} message GetCampaignActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetCampaignActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetCampaignActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.GetCampaignActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.GetCampaignActionProto} GetCampaignActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetCampaignActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetCampaignActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetCampaignActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.GetCampaignActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.GetCampaignActionProto} GetCampaignActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetCampaignActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetCampaignActionProto message.
             * @function verify
             * @memberof waiternow.common.GetCampaignActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetCampaignActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a GetCampaignActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.GetCampaignActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.GetCampaignActionProto} GetCampaignActionProto
             */
            GetCampaignActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.GetCampaignActionProto)
                    return object;
                return new $root.waiternow.common.GetCampaignActionProto();
            };

            /**
             * Creates a plain object from a GetCampaignActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.GetCampaignActionProto
             * @static
             * @param {waiternow.common.GetCampaignActionProto} message GetCampaignActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetCampaignActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this GetCampaignActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.GetCampaignActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetCampaignActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for GetCampaignActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.GetCampaignActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            GetCampaignActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.GetCampaignActionProto";
            };

            GetCampaignActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.GetCampaignActionProto
                 * @interface IRequest
                 * @property {string|null} [campaignId] Request campaignId
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.GetCampaignActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.GetCampaignActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request campaignId.
                 * @member {string} campaignId
                 * @memberof waiternow.common.GetCampaignActionProto.Request
                 * @instance
                 */
                Request.prototype.campaignId = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetCampaignActionProto.Request
                 * @static
                 * @param {waiternow.common.GetCampaignActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.GetCampaignActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.GetCampaignActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetCampaignActionProto.Request
                 * @static
                 * @param {waiternow.common.GetCampaignActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.campaignId != null && Object.hasOwnProperty.call(message, "campaignId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.campaignId);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.GetCampaignActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetCampaignActionProto.Request
                 * @static
                 * @param {waiternow.common.GetCampaignActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetCampaignActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetCampaignActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetCampaignActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.campaignId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetCampaignActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetCampaignActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.GetCampaignActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.campaignId != null && message.hasOwnProperty("campaignId"))
                        if (!$util.isString(message.campaignId))
                            return "campaignId: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetCampaignActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetCampaignActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetCampaignActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.GetCampaignActionProto.Request();
                    if (object.campaignId != null)
                        message.campaignId = String(object.campaignId);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetCampaignActionProto.Request
                 * @static
                 * @param {waiternow.common.GetCampaignActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.campaignId = "";
                    if (message.campaignId != null && message.hasOwnProperty("campaignId"))
                        object.campaignId = message.campaignId;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetCampaignActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetCampaignActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetCampaignActionProto.Request";
                };

                return Request;
            })();

            GetCampaignActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.GetCampaignActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.ICampaignProto|null} [campaign] Response campaign
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.GetCampaignActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.GetCampaignActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.GetCampaignActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response campaign.
                 * @member {waiternow.common.ICampaignProto|null|undefined} campaign
                 * @memberof waiternow.common.GetCampaignActionProto.Response
                 * @instance
                 */
                Response.prototype.campaign = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetCampaignActionProto.Response
                 * @static
                 * @param {waiternow.common.GetCampaignActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.GetCampaignActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.GetCampaignActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetCampaignActionProto.Response
                 * @static
                 * @param {waiternow.common.GetCampaignActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.campaign != null && Object.hasOwnProperty.call(message, "campaign"))
                        $root.waiternow.common.CampaignProto.encode(message.campaign, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.GetCampaignActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetCampaignActionProto.Response
                 * @static
                 * @param {waiternow.common.GetCampaignActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetCampaignActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetCampaignActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetCampaignActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.campaign = $root.waiternow.common.CampaignProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetCampaignActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetCampaignActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.GetCampaignActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.campaign != null && message.hasOwnProperty("campaign")) {
                        var error = $root.waiternow.common.CampaignProto.verify(message.campaign);
                        if (error)
                            return "campaign." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetCampaignActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetCampaignActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetCampaignActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.GetCampaignActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.GetCampaignActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.campaign != null) {
                        if (typeof object.campaign !== "object")
                            throw TypeError(".waiternow.common.GetCampaignActionProto.Response.campaign: object expected");
                        message.campaign = $root.waiternow.common.CampaignProto.fromObject(object.campaign);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetCampaignActionProto.Response
                 * @static
                 * @param {waiternow.common.GetCampaignActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.campaign = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.campaign != null && message.hasOwnProperty("campaign"))
                        object.campaign = $root.waiternow.common.CampaignProto.toObject(message.campaign, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetCampaignActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetCampaignActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetCampaignActionProto.Response";
                };

                return Response;
            })();

            return GetCampaignActionProto;
        })();

        common.FindCampaignsByScopeActionProto = (function() {

            /**
             * Properties of a FindCampaignsByScopeActionProto.
             * @memberof waiternow.common
             * @interface IFindCampaignsByScopeActionProto
             */

            /**
             * Constructs a new FindCampaignsByScopeActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a FindCampaignsByScopeActionProto.
             * @implements IFindCampaignsByScopeActionProto
             * @constructor
             * @param {waiternow.common.IFindCampaignsByScopeActionProto=} [properties] Properties to set
             */
            function FindCampaignsByScopeActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new FindCampaignsByScopeActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FindCampaignsByScopeActionProto
             * @static
             * @param {waiternow.common.IFindCampaignsByScopeActionProto=} [properties] Properties to set
             * @returns {waiternow.common.FindCampaignsByScopeActionProto} FindCampaignsByScopeActionProto instance
             */
            FindCampaignsByScopeActionProto.create = function create(properties) {
                return new FindCampaignsByScopeActionProto(properties);
            };

            /**
             * Encodes the specified FindCampaignsByScopeActionProto message. Does not implicitly {@link waiternow.common.FindCampaignsByScopeActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FindCampaignsByScopeActionProto
             * @static
             * @param {waiternow.common.IFindCampaignsByScopeActionProto} message FindCampaignsByScopeActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindCampaignsByScopeActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified FindCampaignsByScopeActionProto message, length delimited. Does not implicitly {@link waiternow.common.FindCampaignsByScopeActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FindCampaignsByScopeActionProto
             * @static
             * @param {waiternow.common.IFindCampaignsByScopeActionProto} message FindCampaignsByScopeActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindCampaignsByScopeActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FindCampaignsByScopeActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FindCampaignsByScopeActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FindCampaignsByScopeActionProto} FindCampaignsByScopeActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindCampaignsByScopeActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindCampaignsByScopeActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FindCampaignsByScopeActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FindCampaignsByScopeActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FindCampaignsByScopeActionProto} FindCampaignsByScopeActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindCampaignsByScopeActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FindCampaignsByScopeActionProto message.
             * @function verify
             * @memberof waiternow.common.FindCampaignsByScopeActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FindCampaignsByScopeActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a FindCampaignsByScopeActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FindCampaignsByScopeActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FindCampaignsByScopeActionProto} FindCampaignsByScopeActionProto
             */
            FindCampaignsByScopeActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FindCampaignsByScopeActionProto)
                    return object;
                return new $root.waiternow.common.FindCampaignsByScopeActionProto();
            };

            /**
             * Creates a plain object from a FindCampaignsByScopeActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FindCampaignsByScopeActionProto
             * @static
             * @param {waiternow.common.FindCampaignsByScopeActionProto} message FindCampaignsByScopeActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FindCampaignsByScopeActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this FindCampaignsByScopeActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FindCampaignsByScopeActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FindCampaignsByScopeActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FindCampaignsByScopeActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.FindCampaignsByScopeActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FindCampaignsByScopeActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FindCampaignsByScopeActionProto";
            };

            FindCampaignsByScopeActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.FindCampaignsByScopeActionProto
                 * @interface IRequest
                 * @property {string|null} [businessId] Request businessId
                 * @property {string|null} [locationId] Request locationId
                 * @property {waiternow.common.SortOrder|null} [sortOrder] Request sortOrder
                 * @property {string|null} [continuationToken] Request continuationToken
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.FindCampaignsByScopeActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.FindCampaignsByScopeActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request businessId.
                 * @member {string|null|undefined} businessId
                 * @memberof waiternow.common.FindCampaignsByScopeActionProto.Request
                 * @instance
                 */
                Request.prototype.businessId = null;

                /**
                 * Request locationId.
                 * @member {string|null|undefined} locationId
                 * @memberof waiternow.common.FindCampaignsByScopeActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = null;

                /**
                 * Request sortOrder.
                 * @member {waiternow.common.SortOrder} sortOrder
                 * @memberof waiternow.common.FindCampaignsByScopeActionProto.Request
                 * @instance
                 */
                Request.prototype.sortOrder = 0;

                /**
                 * Request continuationToken.
                 * @member {string} continuationToken
                 * @memberof waiternow.common.FindCampaignsByScopeActionProto.Request
                 * @instance
                 */
                Request.prototype.continuationToken = "";

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * Request campaignScope.
                 * @member {"businessId"|"locationId"|undefined} campaignScope
                 * @memberof waiternow.common.FindCampaignsByScopeActionProto.Request
                 * @instance
                 */
                Object.defineProperty(Request.prototype, "campaignScope", {
                    get: $util.oneOfGetter($oneOfFields = ["businessId", "locationId"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindCampaignsByScopeActionProto.Request
                 * @static
                 * @param {waiternow.common.FindCampaignsByScopeActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.FindCampaignsByScopeActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.FindCampaignsByScopeActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindCampaignsByScopeActionProto.Request
                 * @static
                 * @param {waiternow.common.FindCampaignsByScopeActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessId);
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.locationId);
                    if (message.sortOrder != null && Object.hasOwnProperty.call(message, "sortOrder"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.sortOrder);
                    if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.continuationToken);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.FindCampaignsByScopeActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindCampaignsByScopeActionProto.Request
                 * @static
                 * @param {waiternow.common.FindCampaignsByScopeActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindCampaignsByScopeActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindCampaignsByScopeActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindCampaignsByScopeActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.businessId = reader.string();
                                break;
                            }
                        case 2: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 3: {
                                message.sortOrder = reader.int32();
                                break;
                            }
                        case 4: {
                                message.continuationToken = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindCampaignsByScopeActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindCampaignsByScopeActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.FindCampaignsByScopeActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.businessId != null && message.hasOwnProperty("businessId")) {
                        properties.campaignScope = 1;
                        if (!$util.isString(message.businessId))
                            return "businessId: string expected";
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId")) {
                        if (properties.campaignScope === 1)
                            return "campaignScope: multiple values";
                        properties.campaignScope = 1;
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    }
                    if (message.sortOrder != null && message.hasOwnProperty("sortOrder"))
                        switch (message.sortOrder) {
                        default:
                            return "sortOrder: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        if (!$util.isString(message.continuationToken))
                            return "continuationToken: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindCampaignsByScopeActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindCampaignsByScopeActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindCampaignsByScopeActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.FindCampaignsByScopeActionProto.Request();
                    if (object.businessId != null)
                        message.businessId = String(object.businessId);
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    switch (object.sortOrder) {
                    default:
                        if (typeof object.sortOrder === "number") {
                            message.sortOrder = object.sortOrder;
                            break;
                        }
                        break;
                    case "SORT_ORDER_UNSPECIFIED":
                    case 0:
                        message.sortOrder = 0;
                        break;
                    case "ASCENDING":
                    case 1:
                        message.sortOrder = 1;
                        break;
                    case "DESCENDING":
                    case 2:
                        message.sortOrder = 2;
                        break;
                    }
                    if (object.continuationToken != null)
                        message.continuationToken = String(object.continuationToken);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindCampaignsByScopeActionProto.Request
                 * @static
                 * @param {waiternow.common.FindCampaignsByScopeActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.sortOrder = options.enums === String ? "SORT_ORDER_UNSPECIFIED" : 0;
                        object.continuationToken = "";
                    }
                    if (message.businessId != null && message.hasOwnProperty("businessId")) {
                        object.businessId = message.businessId;
                        if (options.oneofs)
                            object.campaignScope = "businessId";
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId")) {
                        object.locationId = message.locationId;
                        if (options.oneofs)
                            object.campaignScope = "locationId";
                    }
                    if (message.sortOrder != null && message.hasOwnProperty("sortOrder"))
                        object.sortOrder = options.enums === String ? $root.waiternow.common.SortOrder[message.sortOrder] === undefined ? message.sortOrder : $root.waiternow.common.SortOrder[message.sortOrder] : message.sortOrder;
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        object.continuationToken = message.continuationToken;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindCampaignsByScopeActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindCampaignsByScopeActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindCampaignsByScopeActionProto.Request";
                };

                return Request;
            })();

            FindCampaignsByScopeActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.FindCampaignsByScopeActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.ICampaignsProto|null} [campaigns] Response campaigns
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.FindCampaignsByScopeActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.FindCampaignsByScopeActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.FindCampaignsByScopeActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response campaigns.
                 * @member {waiternow.common.ICampaignsProto|null|undefined} campaigns
                 * @memberof waiternow.common.FindCampaignsByScopeActionProto.Response
                 * @instance
                 */
                Response.prototype.campaigns = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindCampaignsByScopeActionProto.Response
                 * @static
                 * @param {waiternow.common.FindCampaignsByScopeActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.FindCampaignsByScopeActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.FindCampaignsByScopeActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindCampaignsByScopeActionProto.Response
                 * @static
                 * @param {waiternow.common.FindCampaignsByScopeActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.campaigns != null && Object.hasOwnProperty.call(message, "campaigns"))
                        $root.waiternow.common.CampaignsProto.encode(message.campaigns, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.FindCampaignsByScopeActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindCampaignsByScopeActionProto.Response
                 * @static
                 * @param {waiternow.common.FindCampaignsByScopeActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindCampaignsByScopeActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindCampaignsByScopeActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindCampaignsByScopeActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.campaigns = $root.waiternow.common.CampaignsProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindCampaignsByScopeActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindCampaignsByScopeActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.FindCampaignsByScopeActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.campaigns != null && message.hasOwnProperty("campaigns")) {
                        var error = $root.waiternow.common.CampaignsProto.verify(message.campaigns);
                        if (error)
                            return "campaigns." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindCampaignsByScopeActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindCampaignsByScopeActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindCampaignsByScopeActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.FindCampaignsByScopeActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.FindCampaignsByScopeActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.campaigns != null) {
                        if (typeof object.campaigns !== "object")
                            throw TypeError(".waiternow.common.FindCampaignsByScopeActionProto.Response.campaigns: object expected");
                        message.campaigns = $root.waiternow.common.CampaignsProto.fromObject(object.campaigns);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindCampaignsByScopeActionProto.Response
                 * @static
                 * @param {waiternow.common.FindCampaignsByScopeActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.campaigns = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.campaigns != null && message.hasOwnProperty("campaigns"))
                        object.campaigns = $root.waiternow.common.CampaignsProto.toObject(message.campaigns, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindCampaignsByScopeActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindCampaignsByScopeActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindCampaignsByScopeActionProto.Response";
                };

                return Response;
            })();

            return FindCampaignsByScopeActionProto;
        })();

        common.GetSalesSummaryReportActionProto = (function() {

            /**
             * Properties of a GetSalesSummaryReportActionProto.
             * @memberof waiternow.common
             * @interface IGetSalesSummaryReportActionProto
             */

            /**
             * Constructs a new GetSalesSummaryReportActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a GetSalesSummaryReportActionProto.
             * @implements IGetSalesSummaryReportActionProto
             * @constructor
             * @param {waiternow.common.IGetSalesSummaryReportActionProto=} [properties] Properties to set
             */
            function GetSalesSummaryReportActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new GetSalesSummaryReportActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.GetSalesSummaryReportActionProto
             * @static
             * @param {waiternow.common.IGetSalesSummaryReportActionProto=} [properties] Properties to set
             * @returns {waiternow.common.GetSalesSummaryReportActionProto} GetSalesSummaryReportActionProto instance
             */
            GetSalesSummaryReportActionProto.create = function create(properties) {
                return new GetSalesSummaryReportActionProto(properties);
            };

            /**
             * Encodes the specified GetSalesSummaryReportActionProto message. Does not implicitly {@link waiternow.common.GetSalesSummaryReportActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.GetSalesSummaryReportActionProto
             * @static
             * @param {waiternow.common.IGetSalesSummaryReportActionProto} message GetSalesSummaryReportActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetSalesSummaryReportActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified GetSalesSummaryReportActionProto message, length delimited. Does not implicitly {@link waiternow.common.GetSalesSummaryReportActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.GetSalesSummaryReportActionProto
             * @static
             * @param {waiternow.common.IGetSalesSummaryReportActionProto} message GetSalesSummaryReportActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetSalesSummaryReportActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetSalesSummaryReportActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.GetSalesSummaryReportActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.GetSalesSummaryReportActionProto} GetSalesSummaryReportActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetSalesSummaryReportActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetSalesSummaryReportActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetSalesSummaryReportActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.GetSalesSummaryReportActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.GetSalesSummaryReportActionProto} GetSalesSummaryReportActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetSalesSummaryReportActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetSalesSummaryReportActionProto message.
             * @function verify
             * @memberof waiternow.common.GetSalesSummaryReportActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetSalesSummaryReportActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a GetSalesSummaryReportActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.GetSalesSummaryReportActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.GetSalesSummaryReportActionProto} GetSalesSummaryReportActionProto
             */
            GetSalesSummaryReportActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.GetSalesSummaryReportActionProto)
                    return object;
                return new $root.waiternow.common.GetSalesSummaryReportActionProto();
            };

            /**
             * Creates a plain object from a GetSalesSummaryReportActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.GetSalesSummaryReportActionProto
             * @static
             * @param {waiternow.common.GetSalesSummaryReportActionProto} message GetSalesSummaryReportActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetSalesSummaryReportActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this GetSalesSummaryReportActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.GetSalesSummaryReportActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetSalesSummaryReportActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for GetSalesSummaryReportActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.GetSalesSummaryReportActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            GetSalesSummaryReportActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.GetSalesSummaryReportActionProto";
            };

            GetSalesSummaryReportActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.GetSalesSummaryReportActionProto
                 * @interface IRequest
                 * @property {string|null} [locationId] Request locationId
                 * @property {waiternow.common.IDateRangeProto|null} [period] Request period
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.GetSalesSummaryReportActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.GetSalesSummaryReportActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.GetSalesSummaryReportActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = "";

                /**
                 * Request period.
                 * @member {waiternow.common.IDateRangeProto|null|undefined} period
                 * @memberof waiternow.common.GetSalesSummaryReportActionProto.Request
                 * @instance
                 */
                Request.prototype.period = null;

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetSalesSummaryReportActionProto.Request
                 * @static
                 * @param {waiternow.common.GetSalesSummaryReportActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.GetSalesSummaryReportActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.GetSalesSummaryReportActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetSalesSummaryReportActionProto.Request
                 * @static
                 * @param {waiternow.common.GetSalesSummaryReportActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    if (message.period != null && Object.hasOwnProperty.call(message, "period"))
                        $root.waiternow.common.DateRangeProto.encode(message.period, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.GetSalesSummaryReportActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetSalesSummaryReportActionProto.Request
                 * @static
                 * @param {waiternow.common.GetSalesSummaryReportActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetSalesSummaryReportActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetSalesSummaryReportActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetSalesSummaryReportActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 2: {
                                message.period = $root.waiternow.common.DateRangeProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetSalesSummaryReportActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetSalesSummaryReportActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.GetSalesSummaryReportActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    if (message.period != null && message.hasOwnProperty("period")) {
                        var error = $root.waiternow.common.DateRangeProto.verify(message.period);
                        if (error)
                            return "period." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetSalesSummaryReportActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetSalesSummaryReportActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetSalesSummaryReportActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.GetSalesSummaryReportActionProto.Request();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    if (object.period != null) {
                        if (typeof object.period !== "object")
                            throw TypeError(".waiternow.common.GetSalesSummaryReportActionProto.Request.period: object expected");
                        message.period = $root.waiternow.common.DateRangeProto.fromObject(object.period);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetSalesSummaryReportActionProto.Request
                 * @static
                 * @param {waiternow.common.GetSalesSummaryReportActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.locationId = "";
                        object.period = null;
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    if (message.period != null && message.hasOwnProperty("period"))
                        object.period = $root.waiternow.common.DateRangeProto.toObject(message.period, options);
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetSalesSummaryReportActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetSalesSummaryReportActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetSalesSummaryReportActionProto.Request";
                };

                return Request;
            })();

            GetSalesSummaryReportActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.GetSalesSummaryReportActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.ISalesSummaryReportProto|null} [report] Response report
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.GetSalesSummaryReportActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.GetSalesSummaryReportActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.GetSalesSummaryReportActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response report.
                 * @member {waiternow.common.ISalesSummaryReportProto|null|undefined} report
                 * @memberof waiternow.common.GetSalesSummaryReportActionProto.Response
                 * @instance
                 */
                Response.prototype.report = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.GetSalesSummaryReportActionProto.Response
                 * @static
                 * @param {waiternow.common.GetSalesSummaryReportActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.GetSalesSummaryReportActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.GetSalesSummaryReportActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.GetSalesSummaryReportActionProto.Response
                 * @static
                 * @param {waiternow.common.GetSalesSummaryReportActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.report != null && Object.hasOwnProperty.call(message, "report"))
                        $root.waiternow.common.SalesSummaryReportProto.encode(message.report, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.GetSalesSummaryReportActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.GetSalesSummaryReportActionProto.Response
                 * @static
                 * @param {waiternow.common.GetSalesSummaryReportActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.GetSalesSummaryReportActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.GetSalesSummaryReportActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.GetSalesSummaryReportActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.report = $root.waiternow.common.SalesSummaryReportProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.GetSalesSummaryReportActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.GetSalesSummaryReportActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.GetSalesSummaryReportActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.report != null && message.hasOwnProperty("report")) {
                        var error = $root.waiternow.common.SalesSummaryReportProto.verify(message.report);
                        if (error)
                            return "report." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.GetSalesSummaryReportActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.GetSalesSummaryReportActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.GetSalesSummaryReportActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.GetSalesSummaryReportActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.GetSalesSummaryReportActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.report != null) {
                        if (typeof object.report !== "object")
                            throw TypeError(".waiternow.common.GetSalesSummaryReportActionProto.Response.report: object expected");
                        message.report = $root.waiternow.common.SalesSummaryReportProto.fromObject(object.report);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.GetSalesSummaryReportActionProto.Response
                 * @static
                 * @param {waiternow.common.GetSalesSummaryReportActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.report = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.report != null && message.hasOwnProperty("report"))
                        object.report = $root.waiternow.common.SalesSummaryReportProto.toObject(message.report, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.GetSalesSummaryReportActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.GetSalesSummaryReportActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.GetSalesSummaryReportActionProto.Response";
                };

                return Response;
            })();

            return GetSalesSummaryReportActionProto;
        })();

        common.FindEventsByLocationActionProto = (function() {

            /**
             * Properties of a FindEventsByLocationActionProto.
             * @memberof waiternow.common
             * @interface IFindEventsByLocationActionProto
             */

            /**
             * Constructs a new FindEventsByLocationActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a FindEventsByLocationActionProto.
             * @implements IFindEventsByLocationActionProto
             * @constructor
             * @param {waiternow.common.IFindEventsByLocationActionProto=} [properties] Properties to set
             */
            function FindEventsByLocationActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new FindEventsByLocationActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FindEventsByLocationActionProto
             * @static
             * @param {waiternow.common.IFindEventsByLocationActionProto=} [properties] Properties to set
             * @returns {waiternow.common.FindEventsByLocationActionProto} FindEventsByLocationActionProto instance
             */
            FindEventsByLocationActionProto.create = function create(properties) {
                return new FindEventsByLocationActionProto(properties);
            };

            /**
             * Encodes the specified FindEventsByLocationActionProto message. Does not implicitly {@link waiternow.common.FindEventsByLocationActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FindEventsByLocationActionProto
             * @static
             * @param {waiternow.common.IFindEventsByLocationActionProto} message FindEventsByLocationActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindEventsByLocationActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified FindEventsByLocationActionProto message, length delimited. Does not implicitly {@link waiternow.common.FindEventsByLocationActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FindEventsByLocationActionProto
             * @static
             * @param {waiternow.common.IFindEventsByLocationActionProto} message FindEventsByLocationActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindEventsByLocationActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FindEventsByLocationActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FindEventsByLocationActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FindEventsByLocationActionProto} FindEventsByLocationActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindEventsByLocationActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindEventsByLocationActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FindEventsByLocationActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FindEventsByLocationActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FindEventsByLocationActionProto} FindEventsByLocationActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindEventsByLocationActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FindEventsByLocationActionProto message.
             * @function verify
             * @memberof waiternow.common.FindEventsByLocationActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FindEventsByLocationActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a FindEventsByLocationActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FindEventsByLocationActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FindEventsByLocationActionProto} FindEventsByLocationActionProto
             */
            FindEventsByLocationActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FindEventsByLocationActionProto)
                    return object;
                return new $root.waiternow.common.FindEventsByLocationActionProto();
            };

            /**
             * Creates a plain object from a FindEventsByLocationActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FindEventsByLocationActionProto
             * @static
             * @param {waiternow.common.FindEventsByLocationActionProto} message FindEventsByLocationActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FindEventsByLocationActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this FindEventsByLocationActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FindEventsByLocationActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FindEventsByLocationActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FindEventsByLocationActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.FindEventsByLocationActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FindEventsByLocationActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FindEventsByLocationActionProto";
            };

            FindEventsByLocationActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.FindEventsByLocationActionProto
                 * @interface IRequest
                 * @property {string|null} [locationId] Request locationId
                 * @property {google.protobuf.ITimestamp|null} [afterTime] Request afterTime
                 * @property {google.protobuf.ITimestamp|null} [beforeTime] Request beforeTime
                 * @property {waiternow.common.SortOrder|null} [sortOrder] Request sortOrder
                 * @property {string|null} [continuationToken] Request continuationToken
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.FindEventsByLocationActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.FindEventsByLocationActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request locationId.
                 * @member {string} locationId
                 * @memberof waiternow.common.FindEventsByLocationActionProto.Request
                 * @instance
                 */
                Request.prototype.locationId = "";

                /**
                 * Request afterTime.
                 * @member {google.protobuf.ITimestamp|null|undefined} afterTime
                 * @memberof waiternow.common.FindEventsByLocationActionProto.Request
                 * @instance
                 */
                Request.prototype.afterTime = null;

                /**
                 * Request beforeTime.
                 * @member {google.protobuf.ITimestamp|null|undefined} beforeTime
                 * @memberof waiternow.common.FindEventsByLocationActionProto.Request
                 * @instance
                 */
                Request.prototype.beforeTime = null;

                /**
                 * Request sortOrder.
                 * @member {waiternow.common.SortOrder} sortOrder
                 * @memberof waiternow.common.FindEventsByLocationActionProto.Request
                 * @instance
                 */
                Request.prototype.sortOrder = 0;

                /**
                 * Request continuationToken.
                 * @member {string} continuationToken
                 * @memberof waiternow.common.FindEventsByLocationActionProto.Request
                 * @instance
                 */
                Request.prototype.continuationToken = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindEventsByLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.FindEventsByLocationActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.FindEventsByLocationActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.FindEventsByLocationActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindEventsByLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.FindEventsByLocationActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    if (message.afterTime != null && Object.hasOwnProperty.call(message, "afterTime"))
                        $root.google.protobuf.Timestamp.encode(message.afterTime, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.beforeTime != null && Object.hasOwnProperty.call(message, "beforeTime"))
                        $root.google.protobuf.Timestamp.encode(message.beforeTime, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.sortOrder != null && Object.hasOwnProperty.call(message, "sortOrder"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.sortOrder);
                    if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.continuationToken);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.FindEventsByLocationActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindEventsByLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.FindEventsByLocationActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindEventsByLocationActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindEventsByLocationActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindEventsByLocationActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 2: {
                                message.afterTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.beforeTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            }
                        case 4: {
                                message.sortOrder = reader.int32();
                                break;
                            }
                        case 5: {
                                message.continuationToken = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindEventsByLocationActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindEventsByLocationActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.FindEventsByLocationActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    if (message.afterTime != null && message.hasOwnProperty("afterTime")) {
                        var error = $root.google.protobuf.Timestamp.verify(message.afterTime);
                        if (error)
                            return "afterTime." + error;
                    }
                    if (message.beforeTime != null && message.hasOwnProperty("beforeTime")) {
                        var error = $root.google.protobuf.Timestamp.verify(message.beforeTime);
                        if (error)
                            return "beforeTime." + error;
                    }
                    if (message.sortOrder != null && message.hasOwnProperty("sortOrder"))
                        switch (message.sortOrder) {
                        default:
                            return "sortOrder: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        if (!$util.isString(message.continuationToken))
                            return "continuationToken: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindEventsByLocationActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindEventsByLocationActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindEventsByLocationActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.FindEventsByLocationActionProto.Request();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    if (object.afterTime != null) {
                        if (typeof object.afterTime !== "object")
                            throw TypeError(".waiternow.common.FindEventsByLocationActionProto.Request.afterTime: object expected");
                        message.afterTime = $root.google.protobuf.Timestamp.fromObject(object.afterTime);
                    }
                    if (object.beforeTime != null) {
                        if (typeof object.beforeTime !== "object")
                            throw TypeError(".waiternow.common.FindEventsByLocationActionProto.Request.beforeTime: object expected");
                        message.beforeTime = $root.google.protobuf.Timestamp.fromObject(object.beforeTime);
                    }
                    switch (object.sortOrder) {
                    default:
                        if (typeof object.sortOrder === "number") {
                            message.sortOrder = object.sortOrder;
                            break;
                        }
                        break;
                    case "SORT_ORDER_UNSPECIFIED":
                    case 0:
                        message.sortOrder = 0;
                        break;
                    case "ASCENDING":
                    case 1:
                        message.sortOrder = 1;
                        break;
                    case "DESCENDING":
                    case 2:
                        message.sortOrder = 2;
                        break;
                    }
                    if (object.continuationToken != null)
                        message.continuationToken = String(object.continuationToken);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindEventsByLocationActionProto.Request
                 * @static
                 * @param {waiternow.common.FindEventsByLocationActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.locationId = "";
                        object.afterTime = null;
                        object.beforeTime = null;
                        object.sortOrder = options.enums === String ? "SORT_ORDER_UNSPECIFIED" : 0;
                        object.continuationToken = "";
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    if (message.afterTime != null && message.hasOwnProperty("afterTime"))
                        object.afterTime = $root.google.protobuf.Timestamp.toObject(message.afterTime, options);
                    if (message.beforeTime != null && message.hasOwnProperty("beforeTime"))
                        object.beforeTime = $root.google.protobuf.Timestamp.toObject(message.beforeTime, options);
                    if (message.sortOrder != null && message.hasOwnProperty("sortOrder"))
                        object.sortOrder = options.enums === String ? $root.waiternow.common.SortOrder[message.sortOrder] === undefined ? message.sortOrder : $root.waiternow.common.SortOrder[message.sortOrder] : message.sortOrder;
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        object.continuationToken = message.continuationToken;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindEventsByLocationActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindEventsByLocationActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindEventsByLocationActionProto.Request";
                };

                return Request;
            })();

            FindEventsByLocationActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.FindEventsByLocationActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IEventsProto|null} [events] Response events
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.FindEventsByLocationActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.FindEventsByLocationActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.FindEventsByLocationActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response events.
                 * @member {waiternow.common.IEventsProto|null|undefined} events
                 * @memberof waiternow.common.FindEventsByLocationActionProto.Response
                 * @instance
                 */
                Response.prototype.events = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindEventsByLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.FindEventsByLocationActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.FindEventsByLocationActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.FindEventsByLocationActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindEventsByLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.FindEventsByLocationActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.events != null && Object.hasOwnProperty.call(message, "events"))
                        $root.waiternow.common.EventsProto.encode(message.events, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.FindEventsByLocationActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindEventsByLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.FindEventsByLocationActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindEventsByLocationActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindEventsByLocationActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindEventsByLocationActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.events = $root.waiternow.common.EventsProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindEventsByLocationActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindEventsByLocationActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.FindEventsByLocationActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.events != null && message.hasOwnProperty("events")) {
                        var error = $root.waiternow.common.EventsProto.verify(message.events);
                        if (error)
                            return "events." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindEventsByLocationActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindEventsByLocationActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindEventsByLocationActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.FindEventsByLocationActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.FindEventsByLocationActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.events != null) {
                        if (typeof object.events !== "object")
                            throw TypeError(".waiternow.common.FindEventsByLocationActionProto.Response.events: object expected");
                        message.events = $root.waiternow.common.EventsProto.fromObject(object.events);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindEventsByLocationActionProto.Response
                 * @static
                 * @param {waiternow.common.FindEventsByLocationActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.events = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.events != null && message.hasOwnProperty("events"))
                        object.events = $root.waiternow.common.EventsProto.toObject(message.events, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindEventsByLocationActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindEventsByLocationActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindEventsByLocationActionProto.Response";
                };

                return Response;
            })();

            return FindEventsByLocationActionProto;
        })();

        common.FindEventsByDeviceActionProto = (function() {

            /**
             * Properties of a FindEventsByDeviceActionProto.
             * @memberof waiternow.common
             * @interface IFindEventsByDeviceActionProto
             */

            /**
             * Constructs a new FindEventsByDeviceActionProto.
             * @memberof waiternow.common
             * @classdesc Represents a FindEventsByDeviceActionProto.
             * @implements IFindEventsByDeviceActionProto
             * @constructor
             * @param {waiternow.common.IFindEventsByDeviceActionProto=} [properties] Properties to set
             */
            function FindEventsByDeviceActionProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new FindEventsByDeviceActionProto instance using the specified properties.
             * @function create
             * @memberof waiternow.common.FindEventsByDeviceActionProto
             * @static
             * @param {waiternow.common.IFindEventsByDeviceActionProto=} [properties] Properties to set
             * @returns {waiternow.common.FindEventsByDeviceActionProto} FindEventsByDeviceActionProto instance
             */
            FindEventsByDeviceActionProto.create = function create(properties) {
                return new FindEventsByDeviceActionProto(properties);
            };

            /**
             * Encodes the specified FindEventsByDeviceActionProto message. Does not implicitly {@link waiternow.common.FindEventsByDeviceActionProto.verify|verify} messages.
             * @function encode
             * @memberof waiternow.common.FindEventsByDeviceActionProto
             * @static
             * @param {waiternow.common.IFindEventsByDeviceActionProto} message FindEventsByDeviceActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindEventsByDeviceActionProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified FindEventsByDeviceActionProto message, length delimited. Does not implicitly {@link waiternow.common.FindEventsByDeviceActionProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof waiternow.common.FindEventsByDeviceActionProto
             * @static
             * @param {waiternow.common.IFindEventsByDeviceActionProto} message FindEventsByDeviceActionProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FindEventsByDeviceActionProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FindEventsByDeviceActionProto message from the specified reader or buffer.
             * @function decode
             * @memberof waiternow.common.FindEventsByDeviceActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {waiternow.common.FindEventsByDeviceActionProto} FindEventsByDeviceActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindEventsByDeviceActionProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindEventsByDeviceActionProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FindEventsByDeviceActionProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof waiternow.common.FindEventsByDeviceActionProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {waiternow.common.FindEventsByDeviceActionProto} FindEventsByDeviceActionProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FindEventsByDeviceActionProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FindEventsByDeviceActionProto message.
             * @function verify
             * @memberof waiternow.common.FindEventsByDeviceActionProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FindEventsByDeviceActionProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a FindEventsByDeviceActionProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof waiternow.common.FindEventsByDeviceActionProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {waiternow.common.FindEventsByDeviceActionProto} FindEventsByDeviceActionProto
             */
            FindEventsByDeviceActionProto.fromObject = function fromObject(object) {
                if (object instanceof $root.waiternow.common.FindEventsByDeviceActionProto)
                    return object;
                return new $root.waiternow.common.FindEventsByDeviceActionProto();
            };

            /**
             * Creates a plain object from a FindEventsByDeviceActionProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof waiternow.common.FindEventsByDeviceActionProto
             * @static
             * @param {waiternow.common.FindEventsByDeviceActionProto} message FindEventsByDeviceActionProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FindEventsByDeviceActionProto.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this FindEventsByDeviceActionProto to JSON.
             * @function toJSON
             * @memberof waiternow.common.FindEventsByDeviceActionProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FindEventsByDeviceActionProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FindEventsByDeviceActionProto
             * @function getTypeUrl
             * @memberof waiternow.common.FindEventsByDeviceActionProto
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FindEventsByDeviceActionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/waiternow.common.FindEventsByDeviceActionProto";
            };

            FindEventsByDeviceActionProto.Request = (function() {

                /**
                 * Properties of a Request.
                 * @memberof waiternow.common.FindEventsByDeviceActionProto
                 * @interface IRequest
                 * @property {string|null} [deviceId] Request deviceId
                 * @property {google.protobuf.ITimestamp|null} [afterTime] Request afterTime
                 * @property {google.protobuf.ITimestamp|null} [beforeTime] Request beforeTime
                 * @property {waiternow.common.SortOrder|null} [sortOrder] Request sortOrder
                 * @property {string|null} [continuationToken] Request continuationToken
                 */

                /**
                 * Constructs a new Request.
                 * @memberof waiternow.common.FindEventsByDeviceActionProto
                 * @classdesc Represents a Request.
                 * @implements IRequest
                 * @constructor
                 * @param {waiternow.common.FindEventsByDeviceActionProto.IRequest=} [properties] Properties to set
                 */
                function Request(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Request deviceId.
                 * @member {string} deviceId
                 * @memberof waiternow.common.FindEventsByDeviceActionProto.Request
                 * @instance
                 */
                Request.prototype.deviceId = "";

                /**
                 * Request afterTime.
                 * @member {google.protobuf.ITimestamp|null|undefined} afterTime
                 * @memberof waiternow.common.FindEventsByDeviceActionProto.Request
                 * @instance
                 */
                Request.prototype.afterTime = null;

                /**
                 * Request beforeTime.
                 * @member {google.protobuf.ITimestamp|null|undefined} beforeTime
                 * @memberof waiternow.common.FindEventsByDeviceActionProto.Request
                 * @instance
                 */
                Request.prototype.beforeTime = null;

                /**
                 * Request sortOrder.
                 * @member {waiternow.common.SortOrder} sortOrder
                 * @memberof waiternow.common.FindEventsByDeviceActionProto.Request
                 * @instance
                 */
                Request.prototype.sortOrder = 0;

                /**
                 * Request continuationToken.
                 * @member {string} continuationToken
                 * @memberof waiternow.common.FindEventsByDeviceActionProto.Request
                 * @instance
                 */
                Request.prototype.continuationToken = "";

                /**
                 * Creates a new Request instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindEventsByDeviceActionProto.Request
                 * @static
                 * @param {waiternow.common.FindEventsByDeviceActionProto.IRequest=} [properties] Properties to set
                 * @returns {waiternow.common.FindEventsByDeviceActionProto.Request} Request instance
                 */
                Request.create = function create(properties) {
                    return new Request(properties);
                };

                /**
                 * Encodes the specified Request message. Does not implicitly {@link waiternow.common.FindEventsByDeviceActionProto.Request.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindEventsByDeviceActionProto.Request
                 * @static
                 * @param {waiternow.common.FindEventsByDeviceActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceId != null && Object.hasOwnProperty.call(message, "deviceId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.deviceId);
                    if (message.afterTime != null && Object.hasOwnProperty.call(message, "afterTime"))
                        $root.google.protobuf.Timestamp.encode(message.afterTime, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.beforeTime != null && Object.hasOwnProperty.call(message, "beforeTime"))
                        $root.google.protobuf.Timestamp.encode(message.beforeTime, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.sortOrder != null && Object.hasOwnProperty.call(message, "sortOrder"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.sortOrder);
                    if (message.continuationToken != null && Object.hasOwnProperty.call(message, "continuationToken"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.continuationToken);
                    return writer;
                };

                /**
                 * Encodes the specified Request message, length delimited. Does not implicitly {@link waiternow.common.FindEventsByDeviceActionProto.Request.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindEventsByDeviceActionProto.Request
                 * @static
                 * @param {waiternow.common.FindEventsByDeviceActionProto.IRequest} message Request message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Request.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Request message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindEventsByDeviceActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindEventsByDeviceActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindEventsByDeviceActionProto.Request();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceId = reader.string();
                                break;
                            }
                        case 2: {
                                message.afterTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.beforeTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            }
                        case 4: {
                                message.sortOrder = reader.int32();
                                break;
                            }
                        case 5: {
                                message.continuationToken = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Request message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindEventsByDeviceActionProto.Request
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindEventsByDeviceActionProto.Request} Request
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Request.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Request message.
                 * @function verify
                 * @memberof waiternow.common.FindEventsByDeviceActionProto.Request
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Request.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                        if (!$util.isString(message.deviceId))
                            return "deviceId: string expected";
                    if (message.afterTime != null && message.hasOwnProperty("afterTime")) {
                        var error = $root.google.protobuf.Timestamp.verify(message.afterTime);
                        if (error)
                            return "afterTime." + error;
                    }
                    if (message.beforeTime != null && message.hasOwnProperty("beforeTime")) {
                        var error = $root.google.protobuf.Timestamp.verify(message.beforeTime);
                        if (error)
                            return "beforeTime." + error;
                    }
                    if (message.sortOrder != null && message.hasOwnProperty("sortOrder"))
                        switch (message.sortOrder) {
                        default:
                            return "sortOrder: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        if (!$util.isString(message.continuationToken))
                            return "continuationToken: string expected";
                    return null;
                };

                /**
                 * Creates a Request message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindEventsByDeviceActionProto.Request
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindEventsByDeviceActionProto.Request} Request
                 */
                Request.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindEventsByDeviceActionProto.Request)
                        return object;
                    var message = new $root.waiternow.common.FindEventsByDeviceActionProto.Request();
                    if (object.deviceId != null)
                        message.deviceId = String(object.deviceId);
                    if (object.afterTime != null) {
                        if (typeof object.afterTime !== "object")
                            throw TypeError(".waiternow.common.FindEventsByDeviceActionProto.Request.afterTime: object expected");
                        message.afterTime = $root.google.protobuf.Timestamp.fromObject(object.afterTime);
                    }
                    if (object.beforeTime != null) {
                        if (typeof object.beforeTime !== "object")
                            throw TypeError(".waiternow.common.FindEventsByDeviceActionProto.Request.beforeTime: object expected");
                        message.beforeTime = $root.google.protobuf.Timestamp.fromObject(object.beforeTime);
                    }
                    switch (object.sortOrder) {
                    default:
                        if (typeof object.sortOrder === "number") {
                            message.sortOrder = object.sortOrder;
                            break;
                        }
                        break;
                    case "SORT_ORDER_UNSPECIFIED":
                    case 0:
                        message.sortOrder = 0;
                        break;
                    case "ASCENDING":
                    case 1:
                        message.sortOrder = 1;
                        break;
                    case "DESCENDING":
                    case 2:
                        message.sortOrder = 2;
                        break;
                    }
                    if (object.continuationToken != null)
                        message.continuationToken = String(object.continuationToken);
                    return message;
                };

                /**
                 * Creates a plain object from a Request message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindEventsByDeviceActionProto.Request
                 * @static
                 * @param {waiternow.common.FindEventsByDeviceActionProto.Request} message Request
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Request.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.deviceId = "";
                        object.afterTime = null;
                        object.beforeTime = null;
                        object.sortOrder = options.enums === String ? "SORT_ORDER_UNSPECIFIED" : 0;
                        object.continuationToken = "";
                    }
                    if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                        object.deviceId = message.deviceId;
                    if (message.afterTime != null && message.hasOwnProperty("afterTime"))
                        object.afterTime = $root.google.protobuf.Timestamp.toObject(message.afterTime, options);
                    if (message.beforeTime != null && message.hasOwnProperty("beforeTime"))
                        object.beforeTime = $root.google.protobuf.Timestamp.toObject(message.beforeTime, options);
                    if (message.sortOrder != null && message.hasOwnProperty("sortOrder"))
                        object.sortOrder = options.enums === String ? $root.waiternow.common.SortOrder[message.sortOrder] === undefined ? message.sortOrder : $root.waiternow.common.SortOrder[message.sortOrder] : message.sortOrder;
                    if (message.continuationToken != null && message.hasOwnProperty("continuationToken"))
                        object.continuationToken = message.continuationToken;
                    return object;
                };

                /**
                 * Converts this Request to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindEventsByDeviceActionProto.Request
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Request.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Request
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindEventsByDeviceActionProto.Request
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindEventsByDeviceActionProto.Request";
                };

                return Request;
            })();

            FindEventsByDeviceActionProto.Response = (function() {

                /**
                 * Properties of a Response.
                 * @memberof waiternow.common.FindEventsByDeviceActionProto
                 * @interface IResponse
                 * @property {waiternow.common.IOperationStatusProto|null} [operationStatus] Response operationStatus
                 * @property {waiternow.common.IEventsProto|null} [events] Response events
                 */

                /**
                 * Constructs a new Response.
                 * @memberof waiternow.common.FindEventsByDeviceActionProto
                 * @classdesc Represents a Response.
                 * @implements IResponse
                 * @constructor
                 * @param {waiternow.common.FindEventsByDeviceActionProto.IResponse=} [properties] Properties to set
                 */
                function Response(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Response operationStatus.
                 * @member {waiternow.common.IOperationStatusProto|null|undefined} operationStatus
                 * @memberof waiternow.common.FindEventsByDeviceActionProto.Response
                 * @instance
                 */
                Response.prototype.operationStatus = null;

                /**
                 * Response events.
                 * @member {waiternow.common.IEventsProto|null|undefined} events
                 * @memberof waiternow.common.FindEventsByDeviceActionProto.Response
                 * @instance
                 */
                Response.prototype.events = null;

                /**
                 * Creates a new Response instance using the specified properties.
                 * @function create
                 * @memberof waiternow.common.FindEventsByDeviceActionProto.Response
                 * @static
                 * @param {waiternow.common.FindEventsByDeviceActionProto.IResponse=} [properties] Properties to set
                 * @returns {waiternow.common.FindEventsByDeviceActionProto.Response} Response instance
                 */
                Response.create = function create(properties) {
                    return new Response(properties);
                };

                /**
                 * Encodes the specified Response message. Does not implicitly {@link waiternow.common.FindEventsByDeviceActionProto.Response.verify|verify} messages.
                 * @function encode
                 * @memberof waiternow.common.FindEventsByDeviceActionProto.Response
                 * @static
                 * @param {waiternow.common.FindEventsByDeviceActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationStatus != null && Object.hasOwnProperty.call(message, "operationStatus"))
                        $root.waiternow.common.OperationStatusProto.encode(message.operationStatus, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.events != null && Object.hasOwnProperty.call(message, "events"))
                        $root.waiternow.common.EventsProto.encode(message.events, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Response message, length delimited. Does not implicitly {@link waiternow.common.FindEventsByDeviceActionProto.Response.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof waiternow.common.FindEventsByDeviceActionProto.Response
                 * @static
                 * @param {waiternow.common.FindEventsByDeviceActionProto.IResponse} message Response message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Response.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Response message from the specified reader or buffer.
                 * @function decode
                 * @memberof waiternow.common.FindEventsByDeviceActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {waiternow.common.FindEventsByDeviceActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.waiternow.common.FindEventsByDeviceActionProto.Response();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.operationStatus = $root.waiternow.common.OperationStatusProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.events = $root.waiternow.common.EventsProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Response message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof waiternow.common.FindEventsByDeviceActionProto.Response
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {waiternow.common.FindEventsByDeviceActionProto.Response} Response
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Response.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Response message.
                 * @function verify
                 * @memberof waiternow.common.FindEventsByDeviceActionProto.Response
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Response.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus")) {
                        var error = $root.waiternow.common.OperationStatusProto.verify(message.operationStatus);
                        if (error)
                            return "operationStatus." + error;
                    }
                    if (message.events != null && message.hasOwnProperty("events")) {
                        var error = $root.waiternow.common.EventsProto.verify(message.events);
                        if (error)
                            return "events." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Response message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof waiternow.common.FindEventsByDeviceActionProto.Response
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {waiternow.common.FindEventsByDeviceActionProto.Response} Response
                 */
                Response.fromObject = function fromObject(object) {
                    if (object instanceof $root.waiternow.common.FindEventsByDeviceActionProto.Response)
                        return object;
                    var message = new $root.waiternow.common.FindEventsByDeviceActionProto.Response();
                    if (object.operationStatus != null) {
                        if (typeof object.operationStatus !== "object")
                            throw TypeError(".waiternow.common.FindEventsByDeviceActionProto.Response.operationStatus: object expected");
                        message.operationStatus = $root.waiternow.common.OperationStatusProto.fromObject(object.operationStatus);
                    }
                    if (object.events != null) {
                        if (typeof object.events !== "object")
                            throw TypeError(".waiternow.common.FindEventsByDeviceActionProto.Response.events: object expected");
                        message.events = $root.waiternow.common.EventsProto.fromObject(object.events);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Response message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof waiternow.common.FindEventsByDeviceActionProto.Response
                 * @static
                 * @param {waiternow.common.FindEventsByDeviceActionProto.Response} message Response
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Response.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.operationStatus = null;
                        object.events = null;
                    }
                    if (message.operationStatus != null && message.hasOwnProperty("operationStatus"))
                        object.operationStatus = $root.waiternow.common.OperationStatusProto.toObject(message.operationStatus, options);
                    if (message.events != null && message.hasOwnProperty("events"))
                        object.events = $root.waiternow.common.EventsProto.toObject(message.events, options);
                    return object;
                };

                /**
                 * Converts this Response to JSON.
                 * @function toJSON
                 * @memberof waiternow.common.FindEventsByDeviceActionProto.Response
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Response.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for Response
                 * @function getTypeUrl
                 * @memberof waiternow.common.FindEventsByDeviceActionProto.Response
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/waiternow.common.FindEventsByDeviceActionProto.Response";
                };

                return Response;
            })();

            return FindEventsByDeviceActionProto;
        })();

        return common;
    })();

    return waiternow;
})();

$root.google = (function() {

    /**
     * Namespace google.
     * @exports google
     * @namespace
     */
    var google = {};

    google.protobuf = (function() {

        /**
         * Namespace protobuf.
         * @memberof google
         * @namespace
         */
        var protobuf = {};

        protobuf.Duration = (function() {

            /**
             * Properties of a Duration.
             * @memberof google.protobuf
             * @interface IDuration
             * @property {number|null} [seconds] Duration seconds
             * @property {number|null} [nanos] Duration nanos
             */

            /**
             * Constructs a new Duration.
             * @memberof google.protobuf
             * @classdesc Represents a Duration.
             * @implements IDuration
             * @constructor
             * @param {google.protobuf.IDuration=} [properties] Properties to set
             */
            function Duration(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Duration seconds.
             * @member {number} seconds
             * @memberof google.protobuf.Duration
             * @instance
             */
            Duration.prototype.seconds = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Duration nanos.
             * @member {number} nanos
             * @memberof google.protobuf.Duration
             * @instance
             */
            Duration.prototype.nanos = 0;

            /**
             * Creates a new Duration instance using the specified properties.
             * @function create
             * @memberof google.protobuf.Duration
             * @static
             * @param {google.protobuf.IDuration=} [properties] Properties to set
             * @returns {google.protobuf.Duration} Duration instance
             */
            Duration.create = function create(properties) {
                return new Duration(properties);
            };

            /**
             * Encodes the specified Duration message. Does not implicitly {@link google.protobuf.Duration.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.Duration
             * @static
             * @param {google.protobuf.IDuration} message Duration message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Duration.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.seconds != null && Object.hasOwnProperty.call(message, "seconds"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int64(message.seconds);
                if (message.nanos != null && Object.hasOwnProperty.call(message, "nanos"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.nanos);
                return writer;
            };

            /**
             * Encodes the specified Duration message, length delimited. Does not implicitly {@link google.protobuf.Duration.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.Duration
             * @static
             * @param {google.protobuf.IDuration} message Duration message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Duration.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Duration message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.Duration
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.Duration} Duration
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Duration.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.Duration();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.seconds = reader.int64();
                            break;
                        }
                    case 2: {
                            message.nanos = reader.int32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Duration message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.Duration
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.Duration} Duration
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Duration.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Duration message.
             * @function verify
             * @memberof google.protobuf.Duration
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Duration.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.seconds != null && message.hasOwnProperty("seconds"))
                    if (!$util.isInteger(message.seconds) && !(message.seconds && $util.isInteger(message.seconds.low) && $util.isInteger(message.seconds.high)))
                        return "seconds: integer|Long expected";
                if (message.nanos != null && message.hasOwnProperty("nanos"))
                    if (!$util.isInteger(message.nanos))
                        return "nanos: integer expected";
                return null;
            };

            /**
             * Creates a Duration message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.Duration
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.Duration} Duration
             */
            Duration.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.Duration)
                    return object;
                var message = new $root.google.protobuf.Duration();
                if (object.seconds != null)
                    if ($util.Long)
                        (message.seconds = $util.Long.fromValue(object.seconds)).unsigned = false;
                    else if (typeof object.seconds === "string")
                        message.seconds = parseInt(object.seconds, 10);
                    else if (typeof object.seconds === "number")
                        message.seconds = object.seconds;
                    else if (typeof object.seconds === "object")
                        message.seconds = new $util.LongBits(object.seconds.low >>> 0, object.seconds.high >>> 0).toNumber();
                if (object.nanos != null)
                    message.nanos = object.nanos | 0;
                return message;
            };

            /**
             * Creates a plain object from a Duration message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.Duration
             * @static
             * @param {google.protobuf.Duration} message Duration
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Duration.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.seconds = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.seconds = options.longs === String ? "0" : 0;
                    object.nanos = 0;
                }
                if (message.seconds != null && message.hasOwnProperty("seconds"))
                    if (typeof message.seconds === "number")
                        object.seconds = options.longs === String ? String(message.seconds) : message.seconds;
                    else
                        object.seconds = options.longs === String ? $util.Long.prototype.toString.call(message.seconds) : options.longs === Number ? new $util.LongBits(message.seconds.low >>> 0, message.seconds.high >>> 0).toNumber() : message.seconds;
                if (message.nanos != null && message.hasOwnProperty("nanos"))
                    object.nanos = message.nanos;
                return object;
            };

            /**
             * Converts this Duration to JSON.
             * @function toJSON
             * @memberof google.protobuf.Duration
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Duration.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for Duration
             * @function getTypeUrl
             * @memberof google.protobuf.Duration
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            Duration.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/google.protobuf.Duration";
            };

            return Duration;
        })();

        protobuf.Timestamp = (function() {

            /**
             * Properties of a Timestamp.
             * @memberof google.protobuf
             * @interface ITimestamp
             * @property {number|null} [seconds] Timestamp seconds
             * @property {number|null} [nanos] Timestamp nanos
             */

            /**
             * Constructs a new Timestamp.
             * @memberof google.protobuf
             * @classdesc Represents a Timestamp.
             * @implements ITimestamp
             * @constructor
             * @param {google.protobuf.ITimestamp=} [properties] Properties to set
             */
            function Timestamp(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Timestamp seconds.
             * @member {number} seconds
             * @memberof google.protobuf.Timestamp
             * @instance
             */
            Timestamp.prototype.seconds = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Timestamp nanos.
             * @member {number} nanos
             * @memberof google.protobuf.Timestamp
             * @instance
             */
            Timestamp.prototype.nanos = 0;

            /**
             * Creates a new Timestamp instance using the specified properties.
             * @function create
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {google.protobuf.ITimestamp=} [properties] Properties to set
             * @returns {google.protobuf.Timestamp} Timestamp instance
             */
            Timestamp.create = function create(properties) {
                return new Timestamp(properties);
            };

            /**
             * Encodes the specified Timestamp message. Does not implicitly {@link google.protobuf.Timestamp.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {google.protobuf.ITimestamp} message Timestamp message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Timestamp.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.seconds != null && Object.hasOwnProperty.call(message, "seconds"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int64(message.seconds);
                if (message.nanos != null && Object.hasOwnProperty.call(message, "nanos"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.nanos);
                return writer;
            };

            /**
             * Encodes the specified Timestamp message, length delimited. Does not implicitly {@link google.protobuf.Timestamp.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {google.protobuf.ITimestamp} message Timestamp message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Timestamp.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Timestamp message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.Timestamp} Timestamp
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Timestamp.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.Timestamp();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.seconds = reader.int64();
                            break;
                        }
                    case 2: {
                            message.nanos = reader.int32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Timestamp message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.Timestamp} Timestamp
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Timestamp.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Timestamp message.
             * @function verify
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Timestamp.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.seconds != null && message.hasOwnProperty("seconds"))
                    if (!$util.isInteger(message.seconds) && !(message.seconds && $util.isInteger(message.seconds.low) && $util.isInteger(message.seconds.high)))
                        return "seconds: integer|Long expected";
                if (message.nanos != null && message.hasOwnProperty("nanos"))
                    if (!$util.isInteger(message.nanos))
                        return "nanos: integer expected";
                return null;
            };

            /**
             * Creates a Timestamp message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.Timestamp} Timestamp
             */
            Timestamp.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.Timestamp)
                    return object;
                var message = new $root.google.protobuf.Timestamp();
                if (object.seconds != null)
                    if ($util.Long)
                        (message.seconds = $util.Long.fromValue(object.seconds)).unsigned = false;
                    else if (typeof object.seconds === "string")
                        message.seconds = parseInt(object.seconds, 10);
                    else if (typeof object.seconds === "number")
                        message.seconds = object.seconds;
                    else if (typeof object.seconds === "object")
                        message.seconds = new $util.LongBits(object.seconds.low >>> 0, object.seconds.high >>> 0).toNumber();
                if (object.nanos != null)
                    message.nanos = object.nanos | 0;
                return message;
            };

            /**
             * Creates a plain object from a Timestamp message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {google.protobuf.Timestamp} message Timestamp
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Timestamp.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.seconds = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.seconds = options.longs === String ? "0" : 0;
                    object.nanos = 0;
                }
                if (message.seconds != null && message.hasOwnProperty("seconds"))
                    if (typeof message.seconds === "number")
                        object.seconds = options.longs === String ? String(message.seconds) : message.seconds;
                    else
                        object.seconds = options.longs === String ? $util.Long.prototype.toString.call(message.seconds) : options.longs === Number ? new $util.LongBits(message.seconds.low >>> 0, message.seconds.high >>> 0).toNumber() : message.seconds;
                if (message.nanos != null && message.hasOwnProperty("nanos"))
                    object.nanos = message.nanos;
                return object;
            };

            /**
             * Converts this Timestamp to JSON.
             * @function toJSON
             * @memberof google.protobuf.Timestamp
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Timestamp.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for Timestamp
             * @function getTypeUrl
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            Timestamp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/google.protobuf.Timestamp";
            };

            return Timestamp;
        })();

        protobuf.Any = (function() {

            /**
             * Properties of an Any.
             * @memberof google.protobuf
             * @interface IAny
             * @property {string|null} [type_url] Any type_url
             * @property {Uint8Array|null} [value] Any value
             */

            /**
             * Constructs a new Any.
             * @memberof google.protobuf
             * @classdesc Represents an Any.
             * @implements IAny
             * @constructor
             * @param {google.protobuf.IAny=} [properties] Properties to set
             */
            function Any(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Any type_url.
             * @member {string} type_url
             * @memberof google.protobuf.Any
             * @instance
             */
            Any.prototype.type_url = "";

            /**
             * Any value.
             * @member {Uint8Array} value
             * @memberof google.protobuf.Any
             * @instance
             */
            Any.prototype.value = $util.newBuffer([]);

            /**
             * Creates a new Any instance using the specified properties.
             * @function create
             * @memberof google.protobuf.Any
             * @static
             * @param {google.protobuf.IAny=} [properties] Properties to set
             * @returns {google.protobuf.Any} Any instance
             */
            Any.create = function create(properties) {
                return new Any(properties);
            };

            /**
             * Encodes the specified Any message. Does not implicitly {@link google.protobuf.Any.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.Any
             * @static
             * @param {google.protobuf.IAny} message Any message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Any.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.type_url != null && Object.hasOwnProperty.call(message, "type_url"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.type_url);
                if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                    writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.value);
                return writer;
            };

            /**
             * Encodes the specified Any message, length delimited. Does not implicitly {@link google.protobuf.Any.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.Any
             * @static
             * @param {google.protobuf.IAny} message Any message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Any.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an Any message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.Any
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.Any} Any
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Any.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.Any();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.type_url = reader.string();
                            break;
                        }
                    case 2: {
                            message.value = reader.bytes();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an Any message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.Any
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.Any} Any
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Any.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an Any message.
             * @function verify
             * @memberof google.protobuf.Any
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Any.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.type_url != null && message.hasOwnProperty("type_url"))
                    if (!$util.isString(message.type_url))
                        return "type_url: string expected";
                if (message.value != null && message.hasOwnProperty("value"))
                    if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
                        return "value: buffer expected";
                return null;
            };

            /**
             * Creates an Any message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.Any
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.Any} Any
             */
            Any.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.Any)
                    return object;
                var message = new $root.google.protobuf.Any();
                if (object.type_url != null)
                    message.type_url = String(object.type_url);
                if (object.value != null)
                    if (typeof object.value === "string")
                        $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
                    else if (object.value.length >= 0)
                        message.value = object.value;
                return message;
            };

            /**
             * Creates a plain object from an Any message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.Any
             * @static
             * @param {google.protobuf.Any} message Any
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Any.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.type_url = "";
                    if (options.bytes === String)
                        object.value = "";
                    else {
                        object.value = [];
                        if (options.bytes !== Array)
                            object.value = $util.newBuffer(object.value);
                    }
                }
                if (message.type_url != null && message.hasOwnProperty("type_url"))
                    object.type_url = message.type_url;
                if (message.value != null && message.hasOwnProperty("value"))
                    object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
                return object;
            };

            /**
             * Converts this Any to JSON.
             * @function toJSON
             * @memberof google.protobuf.Any
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Any.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for Any
             * @function getTypeUrl
             * @memberof google.protobuf.Any
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            Any.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/google.protobuf.Any";
            };

            return Any;
        })();

        return protobuf;
    })();

    return google;
})();

module.exports = $root;
